(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 5042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports E, _, a, b, c, h, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8916);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8137);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7278);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
})));

if (false) {}




/***/ }),

/***/ 917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, jsx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8916);
/* harmony import */ var _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2443);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(444);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8137);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7278);












var pkg = {
	name: "@emotion/react",
	version: "11.10.5",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.5",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.5",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.5",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)([styles], undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 8916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
var emotion_sheet_browser_esm = __webpack_require__(1526);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new emotion_sheet_browser_esm/* StyleSheet */.m({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 8137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(5042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 1526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ StyleSheet; }
/* harmony export */ });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();




/***/ }),

/***/ 7278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 5687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 5957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ strategies; },
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 9137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, _Parser, createLiteralElement, createNumberElement

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_es6_extendStatics = function(d, b) {
    tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
    return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
    tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (tslib_es6_assign(tslib_es6_assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (tslib_es6_assign(tslib_es6_assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = tslib_es6_assign(tslib_es6_assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = tslib_es6_assign(tslib_es6_assign({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = tslib_es6_assign(tslib_es6_assign({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = tslib_es6_assign(tslib_es6_assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = tslib_es6_assign(tslib_es6_assign({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var parser_Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new parser_Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

// only for testing
var _Parser = (/* unused pure expression or super */ null && (Parser));


/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "Rw": function() { return /* binding */ IntlError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "bc": function() { return /* binding */ IntlErrorCode; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4874);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage
            ? "default message (".concat(typeof descriptor.defaultMessage === 'string'
                ? descriptor.defaultMessage
                : descriptor.defaultMessage
                    .map(function (e) { var _a; return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e); })
                    .join(), ")")
            : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 2644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4874);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6284);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5957);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8222);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 4874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 8442:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/* harmony default export */ __webpack_exports__["Z"] = (isHostComponent);

/***/ }),

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
exports.Z = _default;

/***/ }),

/***/ 4938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
}));
var _utils = __webpack_require__(5532);

/***/ }),

/***/ 120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1354);
/* harmony import */ var _className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7078);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9762);




const defaultTheme = (0,_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
const Box = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: _className__WEBPACK_IMPORTED_MODULE_2__/* ["default"].generate */ .Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Box);

/***/ }),

/***/ 5084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/resolveProps/resolveProps.js
var resolveProps = __webpack_require__(5971);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 7 modules
var ButtonBase = __webpack_require__(9828);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Button/buttonClasses.js


function getButtonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiButton', slot);
}
const buttonClasses = (0,generateUtilityClasses/* default */.Z)('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'textSuccess', 'textError', 'textInfo', 'textWarning', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'outlinedSuccess', 'outlinedError', 'outlinedInfo', 'outlinedWarning', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'containedSuccess', 'containedError', 'containedInfo', 'containedWarning', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
/* harmony default export */ var Button_buttonClasses = (buttonClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonGroup/ButtonGroupContext.js


/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/react.createContext({});

if (false) {}

/* harmony default export */ var ButtonGroup_ButtonGroupContext = (ButtonGroupContext);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Button/Button.js


const _excluded = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];















const useUtilityClasses = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${(0,capitalize/* default */.Z)(color)}`, `size${(0,capitalize/* default */.Z)(size)}`, `${variant}Size${(0,capitalize/* default */.Z)(size)}`, color === 'inherit' && 'colorInherit', disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['startIcon', `iconSize${(0,capitalize/* default */.Z)(size)}`],
    endIcon: ['endIcon', `iconSize${(0,capitalize/* default */.Z)(size)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getButtonUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};

const commonIconStyles = ownerState => (0,esm_extends/* default */.Z)({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});

const ButtonRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], styles[`${ownerState.variant}Size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;

  return (0,esm_extends/* default */.Z)({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': (0,esm_extends/* default */.Z)({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: (theme.vars || theme).palette.grey.A100,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': (0,esm_extends/* default */.Z)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${Button_buttonClasses.focusVisible}`]: (0,esm_extends/* default */.Z)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${Button_buttonClasses.disabled}`]: (0,esm_extends/* default */.Z)({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'outlined' && ownerState.color === 'secondary' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ? // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: (theme.vars || theme).palette.grey[300],
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${Button_buttonClasses.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${Button_buttonClasses.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = (0,styled/* default */.ZP)('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = (0,styled/* default */.ZP)('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/react.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = react.useContext(ButtonGroup_ButtonGroupContext);
  const resolvedProps = (0,resolveProps/* default */.Z)(contextProps, inProps);
  const props = (0,useThemeProps/* default */.Z)({
    props: resolvedProps,
    name: 'MuiButton'
  });

  const {
    children,
    color = 'primary',
    component = 'button',
    className,
    disabled = false,
    disableElevation = false,
    disableFocusRipple = false,
    endIcon: endIconProp,
    focusVisibleClassName,
    fullWidth = false,
    size = 'medium',
    startIcon: startIconProp,
    type,
    variant = 'text'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });

  const classes = useUtilityClasses(ownerState);

  const startIcon = startIconProp && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });

  const endIcon = endIconProp && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonRoot, (0,esm_extends/* default */.Z)({
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(contextProps.className, classes.root, className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Button_Button = (Button);

/***/ }),

/***/ 9828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonBase_ButtonBase; }
});

// UNUSED EXPORTS: ButtonBaseRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(4771);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(6432);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useIsFocusVisible.js + 2 modules
var useIsFocusVisible = __webpack_require__(5811);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(5068);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonBase/Ripple.js



/**
 * @ignore - internal component.
 */



function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = react.useState(false);
  const rippleClassName = (0,clsx_m/* default */.Z)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = (0,clsx_m/* default */.Z)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);

  if (!inProp && !leaving) {
    setLeaving(true);
  }

  react.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: childClassName
    })
  });
}

 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_Ripple = (Ripple);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonBase/touchRippleClasses.js


function getTouchRippleUtilityClass(slot) {
  return generateUtilityClass('MuiTouchRipple', slot);
}
const touchRippleClasses = (0,generateUtilityClasses/* default */.Z)('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
/* harmony default export */ var ButtonBase_touchRippleClasses = (touchRippleClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonBase/TouchRipple.js


const _excluded = ["center", "classes", "className"];

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;











const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.

const TouchRippleRipple = (0,styled/* default */.ZP)(ButtonBase_Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ButtonBase_touchRippleClasses.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, ButtonBase_touchRippleClasses.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, ButtonBase_touchRippleClasses.child, ButtonBase_touchRippleClasses.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, ButtonBase_touchRippleClasses.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

const TouchRipple = /*#__PURE__*/react.forwardRef(function TouchRipple(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTouchRipple'
  });

  const {
    center: centerProp = false,
    classes = {},
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const [ripples, setRipples] = react.useState([]);
  const nextKey = react.useRef(0);
  const rippleCallback = react.useRef(null);
  react.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  const ignoringMouseDown = react.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  const startTimer = react.useRef(null); // This is the hook called once the previous timeout is ready.

  const startTimerCommit = react.useRef(null);
  const container = react.useRef(null);
  react.useEffect(() => {
    return () => {
      clearTimeout(startTimer.current);
    };
  }, []);
  const startCommit = react.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/(0,jsx_runtime.jsx)(TouchRippleRipple, {
      classes: {
        ripple: (0,clsx_m/* default */.Z)(classes.ripple, ButtonBase_touchRippleClasses.ripple),
        rippleVisible: (0,clsx_m/* default */.Z)(classes.rippleVisible, ButtonBase_touchRippleClasses.rippleVisible),
        ripplePulsate: (0,clsx_m/* default */.Z)(classes.ripplePulsate, ButtonBase_touchRippleClasses.ripplePulsate),
        child: (0,clsx_m/* default */.Z)(classes.child, ButtonBase_touchRippleClasses.child),
        childLeaving: (0,clsx_m/* default */.Z)(classes.childLeaving, ButtonBase_touchRippleClasses.childLeaving),
        childPulsate: (0,clsx_m/* default */.Z)(classes.childPulsate, ButtonBase_touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = react.useCallback((event = {}, options = {}, cb) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes

    } = options;

    if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if ((event == null ? void 0 : event.type) === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    let rippleX;
    let rippleY;
    let rippleSize;

    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    } // Touche devices


    if (event != null && event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(() => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit]);
  const pulsate = react.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = react.useCallback((event, cb) => {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(() => {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  react.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TouchRippleRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(ButtonBase_touchRippleClasses.root, classes.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TransitionGroup, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_TouchRipple = (TouchRipple);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass_generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonBase/buttonBaseClasses.js


function getButtonBaseUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0,generateUtilityClasses/* default */.Z)('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
/* harmony default export */ var ButtonBase_buttonBaseClasses = (buttonBaseClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js


const ButtonBase_excluded = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];















const useUtilityClasses = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getButtonBaseUtilityClass, classes);

  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }

  return composedClasses;
};

const ButtonBaseRoot = (0,styled/* default */.ZP)('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.

  },
  [`&.${ButtonBase_buttonBaseClasses.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

const ButtonBase = /*#__PURE__*/react.forwardRef(function ButtonBase(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiButtonBase'
  });

  const {
    action,
    centerRipple = false,
    children,
    className,
    component = 'button',
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    LinkComponent = 'a',
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ButtonBase_excluded);

  const buttonRef = react.useRef(null);
  const rippleRef = react.useRef(null);
  const handleRippleRef = (0,useForkRef/* default */.Z)(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  react.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = react.useState(false);
  react.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  react.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);

  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return (0,useEventCallback/* default */.Z)(event => {
      if (eventCallback) {
        eventCallback(event);
      }

      const ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = (0,useEventCallback/* default */.Z)(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  const keydownRef = react.useRef(false);
  const handleKeyDown = (0,useEventCallback/* default */.Z)(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = (0,useEventCallback/* default */.Z)(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;

  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }

  const buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }

    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }

  const handleRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef, buttonRef);

  if (false) {}

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonBaseRoot, (0,esm_extends/* default */.Z)({
    as: ComponentProp,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/

    /* TouchRipple is only needed client-side, x2 boost on the server. */
    (0,jsx_runtime.jsx)(ButtonBase_TouchRipple, (0,esm_extends/* default */.Z)({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_ButtonBase = (ButtonBase);

/***/ }),

/***/ 8016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(518);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6622);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1719);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8884);
/* eslint-disable material-ui/mui-name-matches-component-name */





const Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  createStyledComponent: (0,_styles_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`maxWidth${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: inProps => (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiContainer'
  })
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconButton_IconButton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 7 modules
var ButtonBase = __webpack_require__(9828);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/IconButton/iconButtonClasses.js


function getIconButtonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiIconButton', slot);
}
const iconButtonClasses = (0,generateUtilityClasses/* default */.Z)('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
/* harmony default export */ var IconButton_iconButtonClasses = (iconButtonClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js


const _excluded = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];













const useUtilityClasses = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${(0,capitalize/* default */.Z)(color)}`, edge && `edge${(0,capitalize/* default */.Z)(edge)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getIconButtonUtilityClass, classes);
};

const IconButtonRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.edge && styles[`edge${(0,capitalize/* default */.Z)(ownerState.edge)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette[ownerState.color].main
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}), ownerState.size === 'small' && {
  padding: 5,
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  padding: 12,
  fontSize: theme.typography.pxToRem(28)
}, {
  [`&.${IconButton_iconButtonClasses.disabled}`]: {
    backgroundColor: 'transparent',
    color: (theme.vars || theme).palette.action.disabled
  }
}));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */

const IconButton = /*#__PURE__*/react.forwardRef(function IconButton(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiIconButton'
  });

  const {
    edge = false,
    children,
    className,
    color = 'default',
    disabled = false,
    disableFocusRipple = false,
    size = 'medium'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButtonRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var IconButton_IconButton = (IconButton);

/***/ }),

/***/ 8346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useIsFocusVisible.js + 2 modules
var useIsFocusVisible = __webpack_require__(5811);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(4771);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/linkClasses.js


function getLinkUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiLink', slot);
}
const linkClasses = (0,generateUtilityClasses/* default */.Z)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
/* harmony default export */ var Link_linkClasses = (linkClasses);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(4844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/getTextDecoration.js

const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}Channel`);

  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }

  return (0,colorManipulator/* alpha */.Fq)(color, 0.4);
};

/* harmony default export */ var Link_getTextDecoration = (getTextDecoration);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/Link.js


const _excluded = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0,capitalize/* default */.Z)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};

const LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0,capitalize/* default */.Z)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0,esm_extends/* default */.Z)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: Link_getTextDecoration({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    [`&.${Link_linkClasses.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/react.forwardRef(function Link(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLink'
  });

  const {
    className,
    color = 'primary',
    component = 'a',
    onBlur,
    onFocus,
    TypographyClasses,
    underline = 'always',
    variant = 'inherit',
    sx
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  const handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  const handleFocus = event => {
    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
    color: color,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

/***/ }),

/***/ 5214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ List_List; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/ListContext.js
var ListContext = __webpack_require__(7742);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/List/listClasses.js


function getListUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiList', slot);
}
const listClasses = (0,generateUtilityClasses/* default */.Z)('MuiList', ['root', 'padding', 'dense', 'subheader']);
/* harmony default export */ var List_listClasses = ((/* unused pure expression or super */ null && (listClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/List/List.js


const _excluded = ["children", "className", "component", "dense", "disablePadding", "subheader"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return (0,composeClasses/* default */.Z)(slots, getListUtilityClass, classes);
};

const ListRoot = (0,styled/* default */.ZP)('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List = /*#__PURE__*/react.forwardRef(function List(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiList'
  });

  const {
    children,
    className,
    component = 'ul',
    dense = false,
    disablePadding = false,
    subheader
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const context = react.useMemo(() => ({
    dense
  }), [dense]);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    dense,
    disablePadding
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: context,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var List_List = (List);

/***/ }),

/***/ 7742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

/**
 * @ignore - internal component.
 */

const ListContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ListContext);

/***/ }),

/***/ 3265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ListItem_ListItem; }
});

// UNUSED EXPORTS: ListItemRoot, overridesResolver

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(8442);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 7 modules
var ButtonBase = __webpack_require__(9828);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(3814);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(3289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(4771);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/ListContext.js
var ListContext = __webpack_require__(7742);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass_generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ListItem/listItemClasses.js


function getListItemUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiListItem', slot);
}
const listItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
/* harmony default export */ var ListItem_listItemClasses = (listItemClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ListItemButton/listItemButtonClasses.js


function getListItemButtonUtilityClass(slot) {
  return generateUtilityClass('MuiListItemButton', slot);
}
const listItemButtonClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
/* harmony default export */ var ListItemButton_listItemButtonClasses = (listItemButtonClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ListItemSecondaryAction/listItemSecondaryActionClasses.js


function getListItemSecondaryActionClassesUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItemSecondaryAction', ['root', 'disableGutters']);
/* harmony default export */ var ListItemSecondaryAction_listItemSecondaryActionClasses = ((/* unused pure expression or super */ null && (listItemSecondaryActionClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ListItemSecondaryAction/ListItemSecondaryAction.js


const _excluded = ["className"];










const useUtilityClasses = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};

const ListItemSecondaryActionRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));
/**
 * Must be used as the last child of ListItem to function properly.
 */

const ListItemSecondaryAction = /*#__PURE__*/react.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });

  const {
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const context = react.useContext(ListContext/* default */.Z);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableGutters: context.disableGutters
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemSecondaryActionRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* harmony default export */ var ListItemSecondaryAction_ListItemSecondaryAction = (ListItemSecondaryAction);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js


const ListItem_excluded = ["className"],
      _excluded2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected"];


















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};

const ListItem_useUtilityClasses = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return (0,composeClasses/* default */.Z)(slots, getListItemUtilityClass, classes);
};

const ListItemRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && (0,esm_extends/* default */.Z)({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${ListItemButton_listItemButtonClasses.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${ListItem_listItemClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${ListItem_listItemClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${ListItem_listItemClasses.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${ListItem_listItemClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${ListItem_listItemClasses.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = (0,styled/* default */.ZP)('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

const ListItem = /*#__PURE__*/react.forwardRef(function ListItem(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListItem'
  });

  const {
    alignItems = 'center',
    autoFocus = false,
    button = false,
    children: childrenProp,
    className,
    component: componentProp,
    components = {},
    componentsProps = {},
    ContainerComponent = 'li',
    ContainerProps: {
      className: ContainerClassName
    } = {},
    dense = false,
    disabled = false,
    disableGutters = false,
    disablePadding = false,
    divider = false,
    focusVisibleClassName,
    secondaryAction,
    selected = false
  } = props,
        ContainerProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ContainerProps, ListItem_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  const context = react.useContext(ListContext/* default */.Z);
  const childContext = {
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  };
  const listItemRef = react.useRef(null);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  const children = react.Children.toArray(childrenProp); // v4 implementation, deprecated in v5, will be removed in v6

  const hasSecondaryAction = children.length && (0,isMuiElement/* default */.Z)(children[children.length - 1], ['ListItemSecondaryAction']);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });

  const classes = ListItem_useUtilityClasses(ownerState);
  const handleRef = (0,useForkRef/* default */.Z)(listItemRef, ref);
  const Root = components.Root || ListItemRoot;
  const rootProps = componentsProps.root || {};

  const componentProps = (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, rootProps.className, className),
    disabled
  }, other);

  let Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx_m/* default */.Z)(ListItem_listItemClasses.focusVisible, focusVisibleClassName);
    Component = ButtonBase/* default */.Z;
  } // v4 implementation, deprecated in v5, will be removed in v6


  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
      value: childContext,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListItemContainer, (0,esm_extends/* default */.Z)({
        as: ContainerComponent,
        className: (0,clsx_m/* default */.Z)(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Root, (0,esm_extends/* default */.Z)({}, rootProps, !(0,isHostComponent/* default */.Z)(Root) && {
          as: Component,
          ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
      as: Component,
      ref: handleRef,
      ownerState: ownerState
    }, !(0,isHostComponent/* default */.Z)(Root) && {
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemSecondaryAction_ListItemSecondaryAction, {
        children: secondaryAction
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var ListItem_ListItem = (ListItem);

/***/ }),

/***/ 918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// UNUSED EXPORTS: getOverlayAlpha

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js


const _excluded = ["className", "component", "elevation", "square", "variant"];









 // Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61


const getOverlayAlpha = elevation => {
  let alphaValue;

  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }

  return (alphaValue / 100).toFixed(2);
};

const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};

const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;

  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPaper'
  });

  const {
    className,
    component = 'div',
    elevation = 1,
    square = false,
    variant = 'elevation'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });

  const classes = useUtilityClasses(ownerState);

  if (false) {}

  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 9144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export style */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5408);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8700);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9707);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4953);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1719);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8884);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


const _excluded = ["component", "direction", "spacing", "divider", "children"];






/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */



function joinChildren(children, separator) {
  const childrenArray = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);

    if (index < childrenArray.length - 1) {
      output.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }

    return output;
  }, []);
}

const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};

const style = ({
  ownerState,
  theme
}) => {
  let styles = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    display: 'flex',
    flexDirection: 'column'
  }, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .handleBreakpoints */ .k9)({
    theme
  }, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), propValue => ({
    flexDirection: propValue
  })));

  if (ownerState.spacing) {
    const transformer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* .createUnarySpacing */ .hB)(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }

      return acc;
    }, {});
    const directionValues = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
      values: ownerState.direction,
      base
    });
    const spacingValues = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
      values: ownerState.spacing,
      base
    });

    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];

        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }

    const styleFromPropValue = (propValue, breakpoint) => {
      return {
        '& > :not(style) + :not(style)': {
          margin: 0,
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* .getValue */ .NA)(transformer, propValue)
        }
      };
    };

    styles = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .handleBreakpoints */ .k9)({
      theme
    }, spacingValues, styleFromPropValue));
  }

  styles = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .mergeBreakpointsInOrder */ .dt)(theme.breakpoints, styles);
  return styles;
};
const StackRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [styles.root];
  }
})(style);
const Stack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Stack(inProps, ref) {
  const themeProps = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiStack'
  });
  const props = (0,_mui_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(themeProps);

  const {
    component = 'div',
    direction = 'column',
    spacing = 0,
    divider,
    children
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, _excluded);

  const ownerState = {
    direction,
    spacing
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StackRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    as: component,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: divider ? joinChildren(children, divider) : children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Stack);

/***/ }),

/***/ 1645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SvgIcon_SvgIcon; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SvgIcon/svgIconClasses.js


function getSvgIconUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiSvgIcon', slot);
}
const svgIconClasses = (0,generateUtilityClasses/* default */.Z)('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);
/* harmony default export */ var SvgIcon_svgIconClasses = ((/* unused pure expression or super */ null && (svgIconClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js


const _excluded = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];











const useUtilityClasses = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${(0,capitalize/* default */.Z)(color)}`, `fontSize${(0,capitalize/* default */.Z)(fontSize)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getSvgIconUtilityClass, classes);
};

const SvgIconRoot = (0,styled/* default */.ZP)('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[`fontSize${(0,capitalize/* default */.Z)(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;

  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon = /*#__PURE__*/react.forwardRef(function SvgIcon(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSvgIcon'
  });

  const {
    children,
    className,
    color = 'inherit',
    component = 'svg',
    fontSize = 'medium',
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = '0 0 24 24'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox
  });

  const more = {};

  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SvgIconRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, {
    ownerState: ownerState,
    children: [children, titleAccess ? /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: titleAccess
    }) : null]
  }));
});
 false ? 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ var SvgIcon_SvgIcon = (SvgIcon);

/***/ }),

/***/ 784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Toolbar_Toolbar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Toolbar/toolbarClasses.js


function getToolbarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiToolbar', slot);
}
const toolbarClasses = (0,generateUtilityClasses/* default */.Z)('MuiToolbar', ['root', 'gutters', 'regular', 'dense']);
/* harmony default export */ var Toolbar_toolbarClasses = ((/* unused pure expression or super */ null && (toolbarClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js


const _excluded = ["className", "component", "disableGutters", "variant"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    disableGutters,
    variant
  } = ownerState;
  const slots = {
    root: ['root', !disableGutters && 'gutters', variant]
  };
  return (0,composeClasses/* default */.Z)(slots, getToolbarUtilityClass, classes);
};

const ToolbarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiToolbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableGutters && styles.gutters, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center'
}, !ownerState.disableGutters && {
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
}, ownerState.variant === 'dense' && {
  minHeight: 48
}), ({
  theme,
  ownerState
}) => ownerState.variant === 'regular' && theme.mixins.toolbar);
const Toolbar = /*#__PURE__*/react.forwardRef(function Toolbar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiToolbar'
  });

  const {
    className,
    component = 'div',
    disableGutters = false,
    variant = 'regular'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    disableGutters,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ToolbarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Toolbar_Toolbar = (Toolbar);

/***/ }),

/***/ 9630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Typography; }
});

// UNUSED EXPORTS: TypographyRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(9707);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Typography/typographyClasses.js


function getTypographyUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiTypography', slot);
}
const typographyClasses = (0,generateUtilityClasses/* default */.Z)('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
/* harmony default export */ var Typography_typographyClasses = ((/* unused pure expression or super */ null && (typographyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js


const _excluded = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];











const useUtilityClasses = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${(0,capitalize/* default */.Z)(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return (0,composeClasses/* default */.Z)(slots, getTypographyUtilityClass, classes);
};

const TypographyRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${(0,capitalize/* default */.Z)(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 0
}, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6

const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const Typography = /*#__PURE__*/react.forwardRef(function Typography(inProps, ref) {
  const themeProps = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors(themeProps.color);
  const props = (0,extendSxProp/* default */.Z)((0,esm_extends/* default */.Z)({}, themeProps, {
    color
  }));

  const {
    align = 'inherit',
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = 'body1',
    variantMapping = defaultVariantMapping
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });

  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TypographyRoot, (0,esm_extends/* default */.Z)({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Typography_Typography = (Typography);

/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createTheme; }
});

// UNUSED EXPORTS: createMuiTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(6535);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 4 modules
var createTheme = __webpack_require__(7506);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/createMixins.js

function createMixins(breakpoints, mixins) {
  return (0,esm_extends/* default */.Z)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/common.js
const common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/grey.js
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/purple.js
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ var colors_purple = (purple);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/red.js
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/orange.js
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/blue.js
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/lightBlue.js
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ var colors_lightBlue = (lightBlue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/colors/green.js
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/createPalette.js



const _excluded = ["mode", "contrastThreshold", "tonalOffset"];










const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_blue[200],
      light: colors_blue[50],
      dark: colors_blue[400]
    };
  }

  return {
    main: colors_blue[700],
    light: colors_blue[400],
    dark: colors_blue[800]
  };
}

function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_purple[200],
      light: colors_purple[50],
      dark: colors_purple[400]
    };
  }

  return {
    main: colors_purple[500],
    light: colors_purple[300],
    dark: colors_purple[700]
  };
}

function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_red[500],
      light: colors_red[300],
      dark: colors_red[700]
    };
  }

  return {
    main: colors_red[700],
    light: colors_red[400],
    dark: colors_red[800]
  };
}

function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_lightBlue[400],
      light: colors_lightBlue[300],
      dark: colors_lightBlue[700]
    };
  }

  return {
    main: colors_lightBlue[700],
    light: colors_lightBlue[500],
    dark: colors_lightBlue[900]
  };
}

function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_green[400],
      light: colors_green[300],
      dark: colors_green[700]
    };
  }

  return {
    main: colors_green[800],
    light: colors_green[500],
    dark: colors_green[900]
  };
}

function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_orange[400],
      light: colors_orange[300],
      dark: colors_orange[700]
    };
  }

  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: colors_orange[500],
    dark: colors_orange[900]
  };
}

function createPalette(palette) {
  const {
    mode = 'light',
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(palette, _excluded);

  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

  function getContrastText(background) {
    const contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {}

    return contrastText;
  }

  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.hasOwnProperty('main')) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(11, name ? ` (${name})` : '', mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  const modes = {
    dark,
    light
  };

  if (false) {}

  const paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: (0,esm_extends/* default */.Z)({}, colors_common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/createTypography.js


const createTypography_excluded = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];


function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
        {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, createTypography_excluded);

  if (false) {}

  const coef = fontSize / 14;

  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);

  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0,esm_extends/* default */.Z)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);

  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/shadows.js
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;

function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/createTransitions.js


const createTransitions_excluded = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}

function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }

  const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}

function createTransitions(inputTransitions) {
  const mergedEasing = (0,esm_extends/* default */.Z)({}, easing, inputTransitions.easing);

  const mergedDuration = (0,esm_extends/* default */.Z)({}, duration, inputTransitions.duration);

  const create = (props = ['all'], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options,
          other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTransitions_excluded);

    if (false) {}

    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };

  return (0,esm_extends/* default */.Z)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/zIndex.js
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ var styles_zIndex = (zIndex);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/createTheme.js



const createTheme_excluded = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];










function createTheme_createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);

  if (options.vars) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(18));
  }

  const palette = createPalette(paletteInput);
  const systemTheme = (0,createTheme/* default */.Z)(options);
  let muiTheme = (0,deepmerge/* default */.Z)(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: styles_shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: (0,esm_extends/* default */.Z)({}, styles_zIndex)
  });
  muiTheme = (0,deepmerge/* default */.Z)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);

  if (false) {}

  return muiTheme;
}

let warnedOnce = false;
function createMuiTheme(...args) {
  if (false) {}

  return createTheme_createTheme(...args);
}
/* harmony default export */ var styles_createTheme = (createTheme_createTheme);

/***/ }),

/***/ 5165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9762);

const defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 1719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FO": function() { return /* binding */ rootShouldForwardProp; }
/* harmony export */ });
/* unused harmony export slotShouldForwardProp */
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6154);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5165);


const rootShouldForwardProp = prop => (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* .shouldForwardProp */ .x9)(prop) && prop !== 'classes';
const slotShouldForwardProp = (/* unused pure expression or super */ null && (shouldForwardProp));
const styled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
  defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  rootShouldForwardProp
});
/* harmony default export */ __webpack_exports__["ZP"] = (styled);

/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6682);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5165);



function useTheme() {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);

  if (false) {}

  return theme;
}

/***/ }),

/***/ 8884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9628);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5165);


function useThemeProps({
  props,
  name
}) {
  return (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    props,
    name,
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
  });
}

/***/ }),

/***/ 6622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4142);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 5532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ utils_createChainedFunction; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon; },
  "debounce": function() { return /* reexport */ utils_debounce; },
  "deprecatedPropType": function() { return /* reexport */ utils_deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ utils_ownerDocument; },
  "ownerWindow": function() { return /* reexport */ utils_ownerWindow; },
  "requirePropFactory": function() { return /* reexport */ utils_requirePropFactory; },
  "setRef": function() { return /* reexport */ utils_setRef; },
  "unstable_ClassNameGenerator": function() { return /* binding */ unstable_ClassNameGenerator; },
  "unstable_useEnhancedEffect": function() { return /* reexport */ useEnhancedEffect/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ utils_useId; },
  "unsupportedProp": function() { return /* reexport */ utils_unsupportedProp; },
  "useControlled": function() { return /* reexport */ utils_useControlled; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(7078);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/createChainedFunction/createChainedFunction.js
var createChainedFunction = __webpack_require__(1476);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/createChainedFunction.js

/* harmony default export */ var utils_createChainedFunction = (createChainedFunction/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(1645);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/createSvgIcon.js



/**
 * Private module reserved for @mui packages.
 */


function createSvgIcon(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,esm_extends/* default */.Z)({
      "data-testid": `${displayName}Icon`,
      ref: ref
    }, props, {
      children: path
    }));
  }

  if (false) {}

  Component.muiName = SvgIcon/* default.muiName */.Z.muiName;
  return /*#__PURE__*/react.memo( /*#__PURE__*/react.forwardRef(Component));
}
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/debounce/debounce.js
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/debounce.js

/* harmony default export */ var utils_debounce = (debounce);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/deprecatedPropType/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/deprecatedPropType.js

/* harmony default export */ var utils_deprecatedPropType = (deprecatedPropType);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(3814);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(2690);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/ownerDocument.js

/* harmony default export */ var utils_ownerDocument = (ownerDocument/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerWindow/ownerWindow.js
var ownerWindow = __webpack_require__(4161);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/ownerWindow.js

/* harmony default export */ var utils_ownerWindow = (ownerWindow/* default */.Z);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/requirePropFactory/requirePropFactory.js

function requirePropFactory(componentNameInError, Component) {
  if (true) {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? (0,esm_extends/* default */.Z)({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/requirePropFactory.js

/* harmony default export */ var utils_requirePropFactory = (requirePropFactory);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/setRef/setRef.js
var setRef = __webpack_require__(7364);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/setRef.js

/* harmony default export */ var utils_setRef = (setRef/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(3289);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(2996);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/useId.js

/* harmony default export */ var utils_useId = (useId/* default */.Z);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/unsupportedProp/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/unsupportedProp.js

/* harmony default export */ var utils_unsupportedProp = (unsupportedProp);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/useControlled/useControlled.js
'use client';

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = react.useRef(controlled !== undefined);
  const [valueState, setValue] = react.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (false) {}
  const setValueIfUncontrolled = react.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/useControlled.js

/* harmony default export */ var utils_useControlled = (useControlled);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(6432);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(4771);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useIsFocusVisible.js + 2 modules
var useIsFocusVisible = __webpack_require__(5811);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/index.js

















 // TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention

const unstable_ClassNameGenerator = {
  configure: generator => {
    console.warn(['MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.', '', "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", '', 'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401', '', 'The updated documentation: https://mui.com/guides/classname-generator/'].join('\n'));
    ClassNameGenerator/* default.configure */.Z.configure(generator);
  }
};

/***/ }),

/***/ 3814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_isMuiElement; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/isMuiElement/isMuiElement.js

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/react.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/isMuiElement.js

/* harmony default export */ var utils_isMuiElement = (isMuiElement);

/***/ }),

/***/ 3289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3546);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 6432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9948);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 4771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3703);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 5811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_useIsFocusVisible; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/useTimeout/useTimeout.js
'use client';



class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}
function useTimeout() {
  const timeout = useLazyRef(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js
'use client';

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = react.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = react.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/useIsFocusVisible.js

/* harmony default export */ var utils_useIsFocusVisible = (useIsFocusVisible);

/***/ }),

/***/ 9731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styled; },
  "Co": function() { return /* binding */ internal_processStyles; }
});

// UNUSED EXPORTS: GlobalStyles, StyledEngineProvider, ThemeContext, css, keyframes

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(5042);
;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var emotion_element_6a883da9_browser_esm = __webpack_require__(2443);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(8137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(7278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  var rules = (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_6a883da9_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_6a883da9_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/(0,react.createElement)(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);

;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/index.js
/**
 * @mui/styled-engine v5.16.4
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use client';

/* eslint-disable no-underscore-dangle */

function styled(tag, options) {
  const stylesFactory = emotion_styled_browser_esm(tag, options);
  if (false) {}
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};




/***/ }),

/***/ 518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createContainer; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize/capitalize.js
var capitalize = __webpack_require__(4142);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
var useThemeProps = __webpack_require__(9628);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createStyled.js
var createStyled = __webpack_require__(6154);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styled.js

const styled = (0,createStyled/* default */.ZP)();
/* harmony default export */ var esm_styled = (styled);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 4 modules
var createTheme = __webpack_require__(7506);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Container/createContainer.js


const _excluded = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"];










const defaultTheme = (0,createTheme/* default */.Z)();
const defaultCreateStyledComponent = esm_styled('div', {
  name: 'MuiContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`maxWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
  }
});
const useThemePropsDefault = inProps => (0,useThemeProps/* default */.Z)({
  props: inProps,
  name: 'MuiContainer',
  defaultTheme
});
const useUtilityClasses = (ownerState, componentName) => {
  const getContainerUtilityClass = slot => {
    return (0,generateUtilityClass/* default */.ZP)(componentName, slot);
  };
  const {
    classes,
    fixed,
    disableGutters,
    maxWidth
  } = ownerState;
  const slots = {
    root: ['root', maxWidth && `maxWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fixed && 'fixed', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiContainer'
  } = options;
  const ContainerRoot = createStyledComponent(({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({
    width: '100%',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    marginRight: 'auto',
    display: 'block'
  }, !ownerState.disableGutters && {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }), ({
    theme,
    ownerState
  }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
    const breakpoint = breakpointValueKey;
    const value = theme.breakpoints.values[breakpoint];
    if (value !== 0) {
      // @ts-ignore
      acc[theme.breakpoints.up(breakpoint)] = {
        maxWidth: `${value}${theme.breakpoints.unit}`
      };
    }
    return acc;
  }, {}), ({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({}, ownerState.maxWidth === 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('xs')]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }
  }, ownerState.maxWidth &&
  // @ts-ignore module augmentation fails if custom breakpoints are used
  ownerState.maxWidth !== 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up(ownerState.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
    }
  }));
  const Container = /*#__PURE__*/react.forwardRef(function Container(inProps, ref) {
    const props = useThemeProps(inProps);
    const {
        className,
        component = 'div',
        disableGutters = false,
        fixed = false,
        maxWidth = 'lg'
      } = props,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    const ownerState = (0,esm_extends/* default */.Z)({}, props, {
      component,
      disableGutters,
      fixed,
      maxWidth
    });

    // @ts-ignore module augmentation fails if custom breakpoints are used
    const classes = useUtilityClasses(ownerState, componentName);
    return (
      /*#__PURE__*/
      // @ts-ignore theme is injected by the styled util
      (0,jsx_runtime.jsx)(ContainerRoot, (0,esm_extends/* default */.Z)({
        as: component
        // @ts-ignore module augmentation fails if custom breakpoints are used
        ,
        ownerState: ownerState,
        className: (0,clsx/* default */.Z)(classes.root, className),
        ref: ref
      }, other))
    );
  });
   false ? 0 : void 0;
  return Container;
}

/***/ }),

/***/ 5408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ removeUnusedBreakpoints; },
/* harmony export */   "P$": function() { return /* binding */ resolveBreakpointValues; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "W8": function() { return /* binding */ createEmptyBreakpointObject; },
/* harmony export */   "dt": function() { return /* binding */ mergeBreakpointsInOrder; },
/* harmony export */   "k9": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony export computeBreakpointsBase */
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4953);





// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  // false positive
  // eslint-disable-next-line react/function-component-definition
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme
        }, props[key]));
      }
      return acc;
    }, null);
    return merge(base, extended);
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 8423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fq": function() { return /* binding */ alpha; },
  "_j": function() { return /* binding */ darken; },
  "mi": function() { return /* binding */ getContrastRatio; },
  "$n": function() { return /* binding */ lighten; }
});

// UNUSED EXPORTS: blend, colorChannel, decomposeColor, emphasize, getLuminance, hexToRgb, hslToRgb, private_safeAlpha, private_safeColorChannel, private_safeDarken, private_safeEmphasize, private_safeLighten, recomposeColor, rgbToHex

// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(6535);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/clamp/clamp.js
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
/* harmony default export */ var clamp_clamp = (clamp);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/colorManipulator.js

/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (false) {}
  return clamp_clamp(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

/***/ }),

/***/ 1354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createBox; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9731);
/* harmony import */ var _styleFunctionSx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6523);
/* harmony import */ var _styleFunctionSx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9707);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,_mui_styled_engine__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(_styleFunctionSx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const Box = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Box(inProps, ref) {
    const theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(defaultTheme);
    const _extendSxProp = (0,_styleFunctionSx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
      as: component,
      ref: ref,
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}

/***/ }),

/***/ 6154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ createStyled; },
/* harmony export */   "x9": function() { return /* binding */ shouldForwardProp; }
/* harmony export */ });
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3366);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9731);
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4953);
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7506);
/* harmony import */ var _styleFunctionSx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6523);


const _excluded = ["ownerState"],
  _excluded2 = ["variants"],
  _excluded3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */






function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
const lowercaseFirstLetter = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
      ownerState
    } = _ref,
    props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg(resolvedStyle, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(resolvedStylesArg, _excluded2);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0,_styleFunctionSx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
      theme: resolveTheme((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0,_mui_styled_engine__WEBPACK_IMPORTED_MODULE_4__/* .internal_processStyles */ .Co)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions,
      options = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(inputOptions, _excluded3);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (false) {}
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0,_mui_styled_engine__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_5__/* .isPlainObject */ .P)(stylesArg)) {
        return props => processStyleArg(stylesArg, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (false) {}
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

/***/ }),

/***/ 7506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createTheme_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createBreakpoints.js


const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0,esm_extends/* default */.Z)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0,esm_extends/* default */.Z)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/shape.js
const shape = {
  borderRadius: 4
};
/* harmony default export */ var createTheme_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(8700);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createSpacing.js


// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = (0,esm_spacing/* createUnarySpacing */.hB)({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (false) {}
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(6523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(4920);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/applyStyles.js
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js


const createTheme_excluded = ["breakpoints", "palette", "spacing", "shape"];







function createTheme(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0,esm_extends/* default */.Z)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0,esm_extends/* default */.Z)({}, createTheme_shape, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
/* harmony default export */ var createTheme_createTheme = (createTheme);

/***/ }),

/***/ 7730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4953);

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}
/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 8700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ createUnarySpacing; },
  "eI": function() { return /* binding */ createUnaryUnit; },
  "NA": function() { return /* binding */ getValue; },
  "e6": function() { return /* binding */ margin; },
  "o3": function() { return /* binding */ padding; }
});

// UNUSED EXPORTS: default, getStyleFromPropValue, marginKeys, paddingKeys

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(5408);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(4844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(7730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/spacing.js





const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = (0,style/* getPath */.DW)(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (false) {}
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0,breakpoints/* handleBreakpoints */.k9)(props, propValue, styleFromPropValue);
}
function spacing_style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge/* default */.Z, {});
}
function margin(props) {
  return spacing_style(props, marginKeys);
}
margin.propTypes =  false ? 0 : {};
margin.filterProps = marginKeys;
function padding(props) {
  return spacing_style(props, paddingKeys);
}
padding.propTypes =  false ? 0 : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return spacing_style(props, spacingKeys);
}
spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = ((/* unused pure expression or super */ null && (spacing)));

/***/ }),

/***/ 4844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ getPath; },
/* harmony export */   "Jq": function() { return /* binding */ getStyleValue; }
/* harmony export */ });
/* harmony import */ var _mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4142);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5408);



function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .handleBreakpoints */ .k9)(props, propValue, styleFromPropValue);
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}
/* harmony default export */ __webpack_exports__["ZP"] = (style);

/***/ }),

/***/ 4920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styleFunctionSx_defaultSxConfig; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(8700);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(4844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(7730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/compose.js

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0,merge/* default */.Z)(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}
/* harmony default export */ var esm_compose = (compose);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(5408);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/borders.js





function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return (0,style/* default */.ZP)({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes =  false ? 0 : {};
borderRadius.filterProps = ['borderRadius'];
const borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
/* harmony default export */ var esm_borders = ((/* unused pure expression or super */ null && (borders)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/cssGrid.js






// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes =  false ? 0 : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes =  false ? 0 : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes =  false ? 0 : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = (0,style/* default */.ZP)({
  prop: 'gridColumn'
});
const gridRow = (0,style/* default */.ZP)({
  prop: 'gridRow'
});
const gridAutoFlow = (0,style/* default */.ZP)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = (0,style/* default */.ZP)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = (0,style/* default */.ZP)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = (0,style/* default */.ZP)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0,style/* default */.ZP)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0,style/* default */.ZP)({
  prop: 'gridTemplateAreas'
});
const gridArea = (0,style/* default */.ZP)({
  prop: 'gridArea'
});
const grid = esm_compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var cssGrid = ((/* unused pure expression or super */ null && (grid)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/palette.js


function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = (0,style/* default */.ZP)({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = (0,style/* default */.ZP)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = (0,style/* default */.ZP)({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const palette = esm_compose(color, bgcolor, backgroundColor);
/* harmony default export */ var esm_palette = ((/* unused pure expression or super */ null && (palette)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/sizing.js



function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0,style/* default */.ZP)({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || breakpoints/* values */.VO[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = (0,style/* default */.ZP)({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = (0,style/* default */.ZP)({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = (0,style/* default */.ZP)({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = (0,style/* default */.ZP)({
  prop: 'minHeight',
  transform: sizingTransform
});
const sizeWidth = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
const sizeHeight = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = (0,style/* default */.ZP)({
  prop: 'boxSizing'
});
const sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = ((/* unused pure expression or super */ null && (sizing)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js





const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: spacing/* padding */.o3
  },
  pt: {
    style: spacing/* padding */.o3
  },
  pr: {
    style: spacing/* padding */.o3
  },
  pb: {
    style: spacing/* padding */.o3
  },
  pl: {
    style: spacing/* padding */.o3
  },
  px: {
    style: spacing/* padding */.o3
  },
  py: {
    style: spacing/* padding */.o3
  },
  padding: {
    style: spacing/* padding */.o3
  },
  paddingTop: {
    style: spacing/* padding */.o3
  },
  paddingRight: {
    style: spacing/* padding */.o3
  },
  paddingBottom: {
    style: spacing/* padding */.o3
  },
  paddingLeft: {
    style: spacing/* padding */.o3
  },
  paddingX: {
    style: spacing/* padding */.o3
  },
  paddingY: {
    style: spacing/* padding */.o3
  },
  paddingInline: {
    style: spacing/* padding */.o3
  },
  paddingInlineStart: {
    style: spacing/* padding */.o3
  },
  paddingInlineEnd: {
    style: spacing/* padding */.o3
  },
  paddingBlock: {
    style: spacing/* padding */.o3
  },
  paddingBlockStart: {
    style: spacing/* padding */.o3
  },
  paddingBlockEnd: {
    style: spacing/* padding */.o3
  },
  m: {
    style: spacing/* margin */.e6
  },
  mt: {
    style: spacing/* margin */.e6
  },
  mr: {
    style: spacing/* margin */.e6
  },
  mb: {
    style: spacing/* margin */.e6
  },
  ml: {
    style: spacing/* margin */.e6
  },
  mx: {
    style: spacing/* margin */.e6
  },
  my: {
    style: spacing/* margin */.e6
  },
  margin: {
    style: spacing/* margin */.e6
  },
  marginTop: {
    style: spacing/* margin */.e6
  },
  marginRight: {
    style: spacing/* margin */.e6
  },
  marginBottom: {
    style: spacing/* margin */.e6
  },
  marginLeft: {
    style: spacing/* margin */.e6
  },
  marginX: {
    style: spacing/* margin */.e6
  },
  marginY: {
    style: spacing/* margin */.e6
  },
  marginInline: {
    style: spacing/* margin */.e6
  },
  marginInlineStart: {
    style: spacing/* margin */.e6
  },
  marginInlineEnd: {
    style: spacing/* margin */.e6
  },
  marginBlock: {
    style: spacing/* margin */.e6
  },
  marginBlockStart: {
    style: spacing/* margin */.e6
  },
  marginBlockEnd: {
    style: spacing/* margin */.e6
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
/* harmony default export */ var styleFunctionSx_defaultSxConfig = (defaultSxConfig);

/***/ }),

/***/ 9707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ extendSxProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3366);
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4953);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4920);


const _excluded = ["sx"];


const splitProps = props => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!(0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .P)(result)) {
        return systemProps;
      }
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, result);
    };
  } else {
    finalSx = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, inSx);
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, otherProps, {
    sx: finalSx
  });
}

/***/ }),

/***/ 6523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unstable_createStyleFunctionSx */
/* harmony import */ var _mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4142);
/* harmony import */ var _merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7730);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4844);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5408);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4920);





function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getPath */ .DW)(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .createEmptyBreakpointObject */ .W8)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, breakpointsValues);
              }
            }
          } else {
            css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .removeUnusedBreakpoints */ .L7)(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
/* harmony default export */ __webpack_exports__["Z"] = (styleFunctionSx);

/***/ }),

/***/ 6682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7506);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4168);
'use client';



const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5971);

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 9628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(539);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6682);
'use client';



function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    theme,
    name,
    props
  });
  return mergedProps;
}

/***/ }),

/***/ 4168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2443);
'use client';



function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 7078:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
/* harmony default export */ __webpack_exports__["Z"] = (ClassNameGenerator);

/***/ }),

/***/ 4142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6535);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 4780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ composeClasses; }
/* harmony export */ });
function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

/***/ }),

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

/***/ }),

/***/ 4953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; },
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7462);

// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      if (isPlainObject(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

/***/ }),

/***/ 6535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 4867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ generateUtilityClass; }
/* harmony export */ });
/* unused harmony exports globalStateClasses, isGlobalState */
/* harmony import */ var _ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7078);

const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"].generate */ .Z.generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
  return globalStateClasses[slot] !== undefined;
}

/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClasses; }
/* harmony export */ });
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4867);

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(componentName, slot, globalStatePrefix);
  });
  return result;
}

/***/ }),

/***/ 2690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 4161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2690);

function ownerWindow(node) {
  const doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 5971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ resolveProps; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7462);

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

/***/ }),

/***/ 7364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 3546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
'use client';



/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 9948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3546);
'use client';




/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  (0,_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useRef((...args) =>
  // @ts-expect-error hide `this`
  (0, ref.current)(...args)).current;
}
/* harmony default export */ __webpack_exports__["Z"] = (useEventCallback);

/***/ }),

/***/ 3703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7364);
'use client';



function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/***/ }),

/***/ 2996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
'use client';


let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

/***/ }),

/***/ 9477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __webpack_require__(7294);
function ThirdPartyScriptEmbed({ html, height = null, width = null, children, dataNtpc = '', }) {
    (0, react_1.useEffect)(() => {
        if (dataNtpc) {
            // performance.mark is being used as a feature use signal. While it is traditionally used for performance
            // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
            // existing API.
            performance.mark('mark_feature_usage', {
                detail: {
                    feature: `next-third-parties-${dataNtpc}`,
                },
            });
        }
    }, [dataNtpc]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, html ? ((0, jsx_runtime_1.jsx)("div", { style: {
                    height: height != null ? `${height}px` : 'auto',
                    width: width != null ? `${width}px` : 'auto',
                }, "data-ntpc": dataNtpc, dangerouslySetInnerHTML: { __html: html } })) : null] }));
}
exports["default"] = ThirdPartyScriptEmbed;


/***/ }),

/***/ 7834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(7294);
const script_1 = __importDefault(__webpack_require__(4298));
let currDataLayerName = undefined;
function GoogleAnalytics(props) {
    const { gaId, dataLayerName = 'dataLayer' } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-ga',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga-init", dangerouslySetInnerHTML: {
                    __html: `
          window['${dataLayerName}'] = window['${dataLayerName}'] || [];
          function gtag(){window['${dataLayerName}'].push(arguments);}
          gtag('js', new Date());

          gtag('config', '${gaId}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga", src: `https://www.googletagmanager.com/gtag/js?id=${gaId}` })] }));
}
exports.GoogleAnalytics = GoogleAnalytics;
function sendGAEvent(..._args) {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GA has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(arguments);
    }
    else {
        console.warn(`@next/third-parties: GA dataLayer ${currDataLayerName} does not exist`);
    }
}
exports.sendGAEvent = sendGAEvent;


/***/ }),

/***/ 3632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const third_party_capital_1 = __webpack_require__(6257);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(9477));
function GoogleMapsEmbed(props) {
    const { apiKey, ...restProps } = props;
    const formattedProps = { ...restProps, key: apiKey };
    const { html } = (0, third_party_capital_1.GoogleMapsEmbed)(formattedProps);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: formattedProps.height || null, width: formattedProps.width || null, html: html, dataNtpc: "GoogleMapsEmbed" }));
}
exports["default"] = GoogleMapsEmbed;


/***/ }),

/***/ 674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGTMEvent = exports.GoogleTagManager = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(7294);
const script_1 = __importDefault(__webpack_require__(4298));
let currDataLayerName = undefined;
function GoogleTagManager(props) {
    const { gtmId, dataLayerName = 'dataLayer', auth, preview, dataLayer } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    const gtmLayer = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
    const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-gtm',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm-init", dangerouslySetInnerHTML: {
                    __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
      })(window,'${dataLayerName}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm", "data-ntpc": "GTM", src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}` })] }));
}
exports.GoogleTagManager = GoogleTagManager;
const sendGTMEvent = (data) => {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GTM has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(data);
    }
    else {
        console.warn(`@next/third-parties: GTM dataLayer ${currDataLayerName} does not exist`);
    }
};
exports.sendGTMEvent = sendGTMEvent;


/***/ }),

/***/ 9692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = exports.sendGTMEvent = exports.GoogleTagManager = exports.YouTubeEmbed = exports.GoogleMapsEmbed = void 0;
var google_maps_embed_1 = __webpack_require__(3632);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return __importDefault(google_maps_embed_1).default; } }));
var youtube_embed_1 = __webpack_require__(1494);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return __importDefault(youtube_embed_1).default; } }));
var gtm_1 = __webpack_require__(674);
Object.defineProperty(exports, "GoogleTagManager", ({ enumerable: true, get: function () { return gtm_1.GoogleTagManager; } }));
Object.defineProperty(exports, "sendGTMEvent", ({ enumerable: true, get: function () { return gtm_1.sendGTMEvent; } }));
var ga_1 = __webpack_require__(7834);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return ga_1.GoogleAnalytics; } }));
Object.defineProperty(exports, "sendGAEvent", ({ enumerable: true, get: function () { return ga_1.sendGAEvent; } }));


/***/ }),

/***/ 1494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const script_1 = __importDefault(__webpack_require__(4298));
const third_party_capital_1 = __webpack_require__(6257);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(9477));
const scriptStrategy = {
    server: 'beforeInteractive',
    client: 'afterInteractive',
    idle: 'lazyOnload',
    worker: 'worker',
};
function YouTubeEmbed(props) {
    const { html, scripts, stylesheets } = (0, third_party_capital_1.YouTubeEmbed)(props);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: props.height || null, width: props.width || null, html: html, dataNtpc: "YouTubeEmbed", children: scripts === null || scripts === void 0 ? void 0 : scripts.map((script) => ((0, jsx_runtime_1.jsx)(script_1.default, { src: script.url, strategy: scriptStrategy[script.strategy], stylesheets: stylesheets }, script.url))) }));
}
exports["default"] = YouTubeEmbed;


/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ addExtensionMethods; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5659);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7850);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1422);
/* module decorator */ module = __webpack_require__.hmd(module);



/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getMainCarrier */ .cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, './node/integrations/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, './node/integrations/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, './node/integrations/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, './node/integrations/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .loadModule */ .$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .addTracingExtensions */ .T)();

  // Detect and automatically load specified integrations.
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)()) {
    _autoloadDatabaseIntegrations();
  }
}


//# sourceMappingURL=extensions.js.map


/***/ }),

/***/ 1131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 5659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1422);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1131);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(350);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9015);





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1235);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9015);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 7850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ addTracingExtensions; },
  "l": function() { return /* binding */ startIdleTransaction; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(2343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(7597);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(5659);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(7522);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(9791);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(5544);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js
var tracing_transaction = __webpack_require__(8069);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new tracing_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 5544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ TRACING_DEFAULTS; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8903);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8069);




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

  // Idle timeout was canceled and we should finish the transaction with the last span end.
   __init4() {this._idleTimeoutCanceledPermanently = false;}

    __init5() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   __init6() {this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];}

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);IdleTransaction.prototype.__init5.call(this);IdleTransaction.prototype.__init6.call(this);
    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampWithMs is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 8903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(535);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 8069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(535);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1131);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5659);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8903);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      environment: environment || _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_ENVIRONMENT */ .J,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 9791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; }
/* harmony export */ });
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5659);



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 7522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5659);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 5722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ud": function() { return /* reexport */ captureUnderscoreErrorException; },
  "S1": function() { return /* reexport */ client_init; }
});

// UNUSED EXPORTS: Breadcrumbs, BrowserClient, BrowserProfilingIntegration, BrowserTracing, Dedupe, ErrorBoundary, FunctionToString, GlobalHandlers, HttpContext, Hub, InboundFilters, Integrations, LinkedErrors, Profiler, Replay, SDK_VERSION, Scope, TryCatch, WINDOW, addBreadcrumb, addGlobalEventProcessor, addTracingExtensions, captureEvent, captureException, captureMessage, chromeStackLineParser, close, configureScope, createReduxEnhancer, createTransport, defaultIntegrations, defaultStackLineParsers, defaultStackParser, eventFromException, eventFromMessage, flush, forceLoad, geckoStackLineParser, getCurrentHub, getHubFromCarrier, lastEventId, makeBrowserOfflineTransport, makeFetchTransport, makeMain, makeXHRTransport, nextRouterInstrumentation, onLoad, onProfilingStartRouteTransaction, opera10StackLineParser, opera11StackLineParser, reactRouterV3Instrumentation, reactRouterV4Instrumentation, reactRouterV5Instrumentation, reactRouterV6Instrumentation, setContext, setExtra, setExtras, setTag, setTags, setUser, showReportDialog, startTransaction, useProfiler, winjsStackLineParser, withErrorBoundary, withProfiler, withScope, withSentryGetServerSideProps, withSentryGetStaticProps, withSentryReactRouterV6Routing, withSentryRouting, withSentryServerSideAppGetInitialProps, withSentryServerSideDocumentGetInitialProps, withSentryServerSideErrorGetInitialProps, withSentryServerSideGetInitialProps, wrap, wrapAppGetInitialPropsWithSentry, wrapCreateBrowserRouter, wrapDocumentGetInitialPropsWithSentry, wrapErrorGetInitialPropsWithSentry, wrapGetInitialPropsWithSentry, wrapGetServerSidePropsWithSentry, wrapGetStaticPropsWithSentry, wrapUseRoutes

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(7522);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
    const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename);
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.44.2';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(2343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(7321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(5659);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(350);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
  }
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(7597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(6893);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize_normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize_normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  let overriddenDepth = depth;

  if (typeof (value )['__sentry_override_normalization_depth__'] === 'number') {
    overriddenDepth = (value )['__sentry_override_normalization_depth__'] ;
  }

  // We're also done if we've reached the max depth
  if (overriddenDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, overriddenDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, overriddenDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${getConstructorName(value)}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize_normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(1170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(1235);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(1131);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js




/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
    timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  applyDebugMetadata(prepared, options.stackParser);

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : constants/* DEFAULT_ENVIRONMENT */.J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
  }
}

/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */
function applyDebugMetadata(event, stackParser) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  // Build a map of abs_path -> debug_id
  const absPathDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    const parsedStack = stackParser(debugIdStackTrace);
    for (const stackFrame of parsedStack) {
      if (stackFrame.abs_path) {
        acc[stackFrame.abs_path] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  // Get a Set of abs_paths in the stack trace
  const errorAbsPaths = new Set();
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.abs_path) {
          errorAbsPaths.add(frame.abs_path);
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  errorAbsPaths.forEach(absPath => {
    if (absPathDebugIdMap[absPath]) {
      images.push({
        type: 'sourcemap',
        code_file: absPath,
        debug_id: absPathDebugIdMap[absPath],
      });
    }
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize_normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize_normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize_normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize_normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize_normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize_normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  // eslint-disable-next-line @typescript-eslint/ban-types
   __init5() {this._hooks = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);BaseClient.prototype.__init5.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      const promise = this._sendEnvelope(env);
      if (promise) {
        promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
      }
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      void this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-ignore We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      // @ts-ignore we cannot enforce the callback to match the hook
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    return prepareEvent(options, event, hint, scope);
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this.emit('beforeEnvelope', envelope);

      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(8518);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/exports.js


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,esm_hub/* getCurrentHub */.Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,esm_hub/* getCurrentHub */.Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,esm_hub/* getCurrentHub */.Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        captureException(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(8464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? (0,browser/* htmlTreeAsString */.Rt)(event.target, { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !handlerData.xhr.__sentry_xhr__) {
    return;
  }

  const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        void this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    abs_path: filename, // As opposed to filename, abs_path is immutable (I can't control your actions but don't touch it!)
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?(?:async )?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/requestdata.js




const DEFAULT_INCLUDES = {
  ip: false,
  request: true,
  transaction: true,
  user: true,
};
const DEFAULT_REQUEST_INCLUDES = (/* unused pure expression or super */ null && (['cookies', 'data', 'headers', 'method', 'query_string', 'url']));
const DEFAULT_USER_INCLUDES = (/* unused pure expression or super */ null && (['id', 'username', 'email']));

/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */
function addRequestDataToTransaction(
  transaction,
  req,
  deps,
) {
  if (!transaction) return;
  if (!transaction.metadata.source || transaction.metadata.source === 'url') {
    // Attempt to grab a parameterized route off of the request
    transaction.setName(...extractPathForTransaction(req, { path: true, method: true }));
  }
  transaction.setData('url', req.originalUrl || req.url);
  if (req.baseUrl) {
    transaction.setData('baseUrl', req.baseUrl);
  }
  transaction.setData('query', extractQueryParams(req, deps));
}

/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */
function extractPathForTransaction(
  req,
  options = {},
) {
  const method = req.method && req.method.toUpperCase();

  let path = '';
  let source = 'url';

  // Check to see if there's a parameterized route we can use (as there is in Express)
  if (options.customRoute || req.route) {
    path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
    source = 'route';
  }

  // Otherwise, just take the original URL
  else if (req.originalUrl || req.url) {
    path = stripUrlQueryAndFragment(req.originalUrl || req.url || '');
  }

  let name = '';
  if (options.method && method) {
    name += method;
  }
  if (options.method && options.path) {
    name += ' ';
  }
  if (options.path && path) {
    name += path;
  }

  return [name, source];
}

/** JSDoc */
function extractTransaction(req, type) {
  switch (type) {
    case 'path': {
      return extractPathForTransaction(req, { path: true })[0];
    }
    case 'handler': {
      return (req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name) || '<anonymous>';
    }
    case 'methodPath':
    default: {
      return extractPathForTransaction(req, { path: true, method: true })[0];
    }
  }
}

/** JSDoc */
function extractUserData(
  user

,
  keys,
) {
  const extractedUser = {};
  const attributes = Array.isArray(keys) ? keys : DEFAULT_USER_INCLUDES;

  attributes.forEach(key => {
    if (user && key in user) {
      extractedUser[key] = user[key];
    }
  });

  return extractedUser;
}

/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */
function extractRequestData(
  req,
  options

,
) {
  const { include = DEFAULT_REQUEST_INCLUDES, deps } = options || {};
  const requestData = {};

  // headers:
  //   node, express, koa, nextjs: req.headers
  const headers = (req.headers || {})

;
  // method:
  //   node, express, koa, nextjs: req.method
  const method = req.method;
  // host:
  //   express: req.hostname in > 4 and req.host in < 4
  //   koa: req.host
  //   node, nextjs: req.headers.host
  const host = req.hostname || req.host || headers.host || '<no host>';
  // protocol:
  //   node, nextjs: <n/a>
  //   express, koa: req.protocol
  const protocol = req.protocol === 'https' || (req.socket && req.socket.encrypted) ? 'https' : 'http';
  // url (including path and query string):
  //   node, express: req.originalUrl
  //   koa, nextjs: req.url
  const originalUrl = req.originalUrl || req.url || '';
  // absolute url
  const absoluteUrl = `${protocol}://${host}${originalUrl}`;
  include.forEach(key => {
    switch (key) {
      case 'headers': {
        requestData.headers = headers;
        break;
      }
      case 'method': {
        requestData.method = method;
        break;
      }
      case 'url': {
        requestData.url = absoluteUrl;
        break;
      }
      case 'cookies': {
        // cookies:
        //   node, express, koa: req.headers.cookie
        //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        requestData.cookies =
          // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
          // come off in v8
          req.cookies || (headers.cookie && deps && deps.cookie && deps.cookie.parse(headers.cookie)) || {};
        break;
      }
      case 'query_string': {
        // query string:
        //   node: req.url (raw)
        //   express, koa, nextjs: req.query
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        requestData.query_string = extractQueryParams(req, deps);
        break;
      }
      case 'data': {
        if (method === 'GET' || method === 'HEAD') {
          break;
        }
        // body data:
        //   express, koa, nextjs: req.body
        //
        //   when using node by itself, you have to read the incoming stream(see
        //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
        //   where they're going to store the final result, so they'll have to capture this data themselves
        if (req.body !== undefined) {
          requestData.data = isString(req.body) ? req.body : JSON.stringify(normalize(req.body));
        }
        break;
      }
      default: {
        if ({}.hasOwnProperty.call(req, key)) {
          requestData[key] = (req )[key];
        }
      }
    }
  });

  return requestData;
}

/**
 * Options deciding what parts of the request to use when enhancing an event
 */

/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @hidden
 */
function addRequestDataToEvent(
  event,
  req,
  options,
) {
  const include = {
    ...DEFAULT_INCLUDES,
    ...(options && options.include),
  };

  if (include.request) {
    const extractedRequestData = Array.isArray(include.request)
      ? extractRequestData(req, { include: include.request, deps: options && options.deps })
      : extractRequestData(req, { deps: options && options.deps });

    event.request = {
      ...event.request,
      ...extractedRequestData,
    };
  }

  if (include.user) {
    const extractedUser = req.user && isPlainObject(req.user) ? extractUserData(req.user, include.user) : {};

    if (Object.keys(extractedUser).length) {
      event.user = {
        ...event.user,
        ...extractedUser,
      };
    }
  }

  // client ip:
  //   node, nextjs: req.socket.remoteAddress
  //   express, koa: req.ip
  if (include.ip) {
    const ip = req.ip || (req.socket && req.socket.remoteAddress);
    if (ip) {
      event.user = {
        ...event.user,
        ip_address: ip,
      };
    }
  }

  if (include.transaction && !event.transaction) {
    // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = extractTransaction(req, include.transaction);
  }

  return event;
}

function extractQueryParams(
  req,
  deps,
) {
  // url (including path and query string):
  //   node, express: req.originalUrl
  //   koa, nextjs: req.url
  let originalUrl = req.originalUrl || req.url || '';

  if (!originalUrl) {
    return;
  }

  // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
  // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
  if (originalUrl.startsWith('/')) {
    originalUrl = `http://dogs.are.great${originalUrl}`;
  }

  return (
    req.query ||
    (typeof URL !== undefined && new URL(originalUrl).search.replace('?', '')) ||
    // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
    (deps && deps.url && deps.url.parse(originalUrl).query) ||
    undefined
  );
}


//# sourceMappingURL=requestdata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/utils/node-utils.js


/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */
function shouldDisableAutoInstrumentation(getCurrentHub) {
  const clientOptions = _optionalChain([getCurrentHub, 'call', _ => _(), 'access', _2 => _2.getClient, 'call', _3 => _3(), 'optionalAccess', _4 => _4.getOptions, 'call', _5 => _5()]);
  const instrumenter = _optionalChain([clientOptions, 'optionalAccess', _6 => _6.instrumenter]) || 'sentry';

  return instrumenter !== 'sentry';
}


//# sourceMappingURL=node-utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/express.js




/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */
class Express  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Express';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Express.id;}

  /**
   * Express App instance
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {Express.prototype.__init.call(this);
    this._router = options.router || options.app;
    this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (!this._router) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('ExpressIntegration is missing an Express instance');
      return;
    }

    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Express Integration is skipped because of instrumenter configuration.');
      return;
    }

    instrumentMiddlewares(this._router, this._methods);
    instrumentRouter(this._router );
  }
}Express.__initStatic();

/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */
// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function express_wrap(fn, method) {
  const arity = fn.length;

  switch (arity) {
    case 2: {
      return function ( req, res) {
        const transaction = res.__sentry_transaction;
        if (transaction) {
          const span = transaction.startChild({
            description: fn.name,
            op: `middleware.express.${method}`,
          });
          res.once('finish', () => {
            span.finish();
          });
        }
        return fn.call(this, req, res);
      };
    }
    case 3: {
      return function (

        req,
        res,
        next,
      ) {
        const transaction = res.__sentry_transaction;
        const span = _optionalChain([transaction, 'optionalAccess', _2 => _2.startChild, 'call', _3 => _3({
          description: fn.name,
          op: `middleware.express.${method}`,
        })]);
        fn.call(this, req, res, function ( ...args) {
          _optionalChain([span, 'optionalAccess', _4 => _4.finish, 'call', _5 => _5()]);
          next.call(this, ...args);
        });
      };
    }
    case 4: {
      return function (

        err,
        req,
        res,
        next,
      ) {
        const transaction = res.__sentry_transaction;
        const span = _optionalChain([transaction, 'optionalAccess', _6 => _6.startChild, 'call', _7 => _7({
          description: fn.name,
          op: `middleware.express.${method}`,
        })]);
        fn.call(this, err, req, res, function ( ...args) {
          _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
          next.call(this, ...args);
        });
      };
    }
    default: {
      throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
  }
}

/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */
function wrapMiddlewareArgs(args, method) {
  return args.map((arg) => {
    if (typeof arg === 'function') {
      return express_wrap(arg, method);
    }

    if (Array.isArray(arg)) {
      return arg.map((a) => {
        if (typeof a === 'function') {
          return express_wrap(a, method);
        }
        return a;
      });
    }

    return arg;
  });
}

/**
 * Patches original router to utilize our tracing functionality
 */
function patchMiddleware(router, method) {
  const originalCallback = router[method];

  router[method] = function (...args) {
    return originalCallback.call(this, ...wrapMiddlewareArgs(args, method));
  };

  return router;
}

/**
 * Patches original router methods
 */
function instrumentMiddlewares(router, methods = []) {
  methods.forEach((method) => patchMiddleware(router, method));
}

/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */
function instrumentRouter(appOrRouter) {
  // This is how we can distinguish between app and routers
  const isApp = 'settings' in appOrRouter;

  // In case the app's top-level router hasn't been initialized yet, we have to do it now
  if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) {
    appOrRouter.lazyrouter();
  }

  const router = isApp ? appOrRouter._router : appOrRouter;

  if (!router) {
    /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.debug */.kg.debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.debug */.kg.debug('Routing instrumentation is currently only supported in Express 4.');
    return;
  }

  const routerProto = Object.getPrototypeOf(router) ;

  const originalProcessParams = routerProto.process_params;
  routerProto.process_params = function process_params(
    layer,
    called,
    req,
    res,
    done,
  ) {
    // Base case: We're in the first part of the URL (thus we start with the root '/')
    if (!req._reconstructedRoute) {
      req._reconstructedRoute = '';
    }

    // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
    const { layerRoutePath, isRegex, isArray, numExtraSegments } = getLayerRoutePathInfo(layer);

    if (layerRoutePath || isRegex || isArray) {
      req._hasParameters = true;
    }

    // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
    const partialRoute = layerRoutePath || layer.path || '';

    // Normalize the partial route so that it doesn't contain leading or trailing slashes
    // and exclude empty or '*' wildcard routes.
    // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
    // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
    // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
    const finalPartialRoute = partialRoute
      .split('/')
      .filter(segment => segment.length > 0 && (isRegex || isArray || !segment.includes('*')))
      .join('/');

    // If we found a valid partial URL, we append it to the reconstructed route
    if (finalPartialRoute && finalPartialRoute.length > 0) {
      // If the partial route is from a regex route, we append a '/' to close the regex
      req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
    }

    // Now we check if we are in the "last" part of the route. We determine this by comparing the
    // number of URL segments from the original URL to that of our reconstructed parameterized URL.
    // If we've reached our final destination, we update the transaction name.
    const urlLength = getNumberOfUrlSegments(req.originalUrl || '') + numExtraSegments;
    const routeLength = getNumberOfUrlSegments(req._reconstructedRoute);

    if (urlLength === routeLength) {
      if (!req._hasParameters) {
        if (req._reconstructedRoute !== req.originalUrl) {
          req._reconstructedRoute = req.originalUrl;
        }
      }

      const transaction = res.__sentry_transaction;
      if (transaction && transaction.metadata.source !== 'custom') {
        // If the request URL is '/' or empty, the reconstructed route will be empty.
        // Therefore, we fall back to setting the final route to '/' in this case.
        const finalRoute = req._reconstructedRoute || '/';

        transaction.setName(...extractPathForTransaction(req, { path: true, method: true, customRoute: finalRoute }));
      }
    }

    return originalProcessParams.call(this, layer, called, req, res, done);
  };
}

/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */
function getLayerRoutePathInfo(layer) {
  const lrp = _optionalChain([layer, 'access', _10 => _10.route, 'optionalAccess', _11 => _11.path]);

  const isRegex = (0,is/* isRegExp */.Kj)(lrp);
  const isArray = Array.isArray(lrp);

  if (!lrp) {
    return { isRegex, isArray, numExtraSegments: 0 };
  }

  const numExtraSegments = isArray
    ? Math.max(getNumberOfArrayUrlSegments(lrp ) - getNumberOfUrlSegments(layer.path || ''), 0)
    : 0;

  const layerRoutePath = getLayerRoutePathString(isArray, lrp);

  return { layerRoutePath, isRegex, isArray, numExtraSegments };
}

/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */
function getNumberOfArrayUrlSegments(routesArray) {
  return routesArray.reduce((accNumSegments, currentRoute) => {
    // array members can be a RegEx -> convert them toString
    return accNumSegments + getNumberOfUrlSegments(currentRoute.toString());
  }, 0);
}

/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */
function getLayerRoutePathString(isArray, lrp) {
  if (isArray) {
    return (lrp ).map(r => r.toString()).join(',');
  }
  return lrp && lrp.toString();
}


//# sourceMappingURL=express.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(1422);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/postgres.js




/** Tracing integration for node-postgres package */
class Postgres  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Postgres';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Postgres.id;}

   constructor(options = {}) {Postgres.prototype.__init.call(this);
    this._usePgNative = !!options.usePgNative;
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Postgres Integration is skipped because of instrumenter configuration.');
      return;
    }

    const pkg = (0,node/* loadModule */.$y)('pg');

    if (!pkg) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Postgres Integration was unable to require `pg` package.');
      return;
    }

    if (this._usePgNative && !_optionalChain([pkg, 'access', _2 => _2.native, 'optionalAccess', _3 => _3.Client])) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error("Postgres Integration was unable to access 'pg-native' bindings.");
      return;
    }

    const { Client } = this._usePgNative ? pkg.native : pkg;

    /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */
    (0,object/* fill */.hl)(Client.prototype, 'query', function (orig) {
      return function ( config, values, callback) {
        const scope = getCurrentHub().getScope();
        const parentSpan = _optionalChain([scope, 'optionalAccess', _4 => _4.getSpan, 'call', _5 => _5()]);
        const span = _optionalChain([parentSpan, 'optionalAccess', _6 => _6.startChild, 'call', _7 => _7({
          description: typeof config === 'string' ? config : (config ).text,
          op: 'db',
        })]);

        if (typeof callback === 'function') {
          return orig.call(this, config, values, function (err, result) {
            _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
            callback(err, result);
          });
        }

        if (typeof values === 'function') {
          return orig.call(this, config, function (err, result) {
            _optionalChain([span, 'optionalAccess', _10 => _10.finish, 'call', _11 => _11()]);
            values(err, result);
          });
        }

        const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);

        if ((0,is/* isThenable */.J8)(rv)) {
          return rv.then((res) => {
            _optionalChain([span, 'optionalAccess', _12 => _12.finish, 'call', _13 => _13()]);
            return res;
          });
        }

        _optionalChain([span, 'optionalAccess', _14 => _14.finish, 'call', _15 => _15()]);
        return rv;
      };
    });
  }
}Postgres.__initStatic();


//# sourceMappingURL=postgres.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/mysql.js




/** Tracing integration for node-mysql package */
class Mysql  {constructor() { Mysql.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Mysql';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Mysql.id;}

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Mysql Integration is skipped because of instrumenter configuration.');
      return;
    }

    const pkg = (0,node/* loadModule */.$y)('mysql/lib/Connection.js');

    if (!pkg) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Mysql Integration was unable to require `mysql` package.');
      return;
    }

    // The original function will have one of these signatures:
    //    function (callback) => void
    //    function (options, callback) => void
    //    function (options, values, callback) => void
    (0,object/* fill */.hl)(pkg, 'createQuery', function (orig) {
      return function ( options, values, callback) {
        const scope = getCurrentHub().getScope();
        const parentSpan = _optionalChain([scope, 'optionalAccess', _2 => _2.getSpan, 'call', _3 => _3()]);
        const span = _optionalChain([parentSpan, 'optionalAccess', _4 => _4.startChild, 'call', _5 => _5({
          description: typeof options === 'string' ? options : (options ).sql,
          op: 'db',
        })]);

        if (typeof callback === 'function') {
          return orig.call(this, options, values, function (err, result, fields) {
            _optionalChain([span, 'optionalAccess', _6 => _6.finish, 'call', _7 => _7()]);
            callback(err, result, fields);
          });
        }

        if (typeof values === 'function') {
          return orig.call(this, options, function (err, result, fields) {
            _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
            values(err, result, fields);
          });
        }

        return orig.call(this, options, values, callback);
      };
    });
  }
}Mysql.__initStatic();


//# sourceMappingURL=mysql.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/mongo.js




// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])

const OPERATIONS = [
  'aggregate', // aggregate(pipeline, options, callback)
  'bulkWrite', // bulkWrite(operations, options, callback)
  'countDocuments', // countDocuments(query, options, callback)
  'createIndex', // createIndex(fieldOrSpec, options, callback)
  'createIndexes', // createIndexes(indexSpecs, options, callback)
  'deleteMany', // deleteMany(filter, options, callback)
  'deleteOne', // deleteOne(filter, options, callback)
  'distinct', // distinct(key, query, options, callback)
  'drop', // drop(options, callback)
  'dropIndex', // dropIndex(indexName, options, callback)
  'dropIndexes', // dropIndexes(options, callback)
  'estimatedDocumentCount', // estimatedDocumentCount(options, callback)
  'find', // find(query, options, callback)
  'findOne', // findOne(query, options, callback)
  'findOneAndDelete', // findOneAndDelete(filter, options, callback)
  'findOneAndReplace', // findOneAndReplace(filter, replacement, options, callback)
  'findOneAndUpdate', // findOneAndUpdate(filter, update, options, callback)
  'indexes', // indexes(options, callback)
  'indexExists', // indexExists(indexes, options, callback)
  'indexInformation', // indexInformation(options, callback)
  'initializeOrderedBulkOp', // initializeOrderedBulkOp(options, callback)
  'insertMany', // insertMany(docs, options, callback)
  'insertOne', // insertOne(doc, options, callback)
  'isCapped', // isCapped(options, callback)
  'mapReduce', // mapReduce(map, reduce, options, callback)
  'options', // options(options, callback)
  'parallelCollectionScan', // parallelCollectionScan(options, callback)
  'rename', // rename(newName, options, callback)
  'replaceOne', // replaceOne(filter, doc, options, callback)
  'stats', // stats(options, callback)
  'updateMany', // updateMany(filter, update, options, callback)
  'updateOne', // updateOne(filter, update, options, callback)
] ;

// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const OPERATION_SIGNATURES

 = {
  // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
  // see https://github.com/getsentry/sentry-javascript/pull/3102
  bulkWrite: ['operations'],
  countDocuments: ['query'],
  createIndex: ['fieldOrSpec'],
  createIndexes: ['indexSpecs'],
  deleteMany: ['filter'],
  deleteOne: ['filter'],
  distinct: ['key', 'query'],
  dropIndex: ['indexName'],
  find: ['query'],
  findOne: ['query'],
  findOneAndDelete: ['filter'],
  findOneAndReplace: ['filter', 'replacement'],
  findOneAndUpdate: ['filter', 'update'],
  indexExists: ['indexes'],
  insertMany: ['docs'],
  insertOne: ['doc'],
  mapReduce: ['map', 'reduce'],
  rename: ['newName'],
  replaceOne: ['filter', 'doc'],
  updateMany: ['filter', 'update'],
  updateOne: ['filter', 'update'],
};

function isCursor(maybeCursor) {
  return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}

/** Tracing integration for mongo package */
class Mongo  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Mongo';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Mongo.id;}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {Mongo.prototype.__init.call(this);
    this._operations = Array.isArray(options.operations) ? options.operations : (OPERATIONS );
    this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
    this._useMongoose = !!options.useMongoose;
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Mongo Integration is skipped because of instrumenter configuration.');
      return;
    }

    const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
    const pkg = (0,node/* loadModule */.$y)(moduleName);

    if (!pkg) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
      return;
    }

    this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
  }

  /**
   * Patches original collection methods
   */
   _instrumentOperations(collection, operations, getCurrentHub) {
    operations.forEach((operation) => this._patchOperation(collection, operation, getCurrentHub));
  }

  /**
   * Patches original collection to utilize our tracing functionality
   */
   _patchOperation(collection, operation, getCurrentHub) {
    if (!(operation in collection.prototype)) return;

    const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);

    (0,object/* fill */.hl)(collection.prototype, operation, function (orig) {
      return function ( ...args) {
        const lastArg = args[args.length - 1];
        const scope = getCurrentHub().getScope();
        const parentSpan = _optionalChain([scope, 'optionalAccess', _2 => _2.getSpan, 'call', _3 => _3()]);

        // Check if the operation was passed a callback. (mapReduce requires a different check, as
        // its (non-callback) arguments can also be functions.)
        if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
          const span = _optionalChain([parentSpan, 'optionalAccess', _4 => _4.startChild, 'call', _5 => _5(getSpanContext(this, operation, args))]);
          const maybePromiseOrCursor = orig.call(this, ...args);

          if ((0,is/* isThenable */.J8)(maybePromiseOrCursor)) {
            return maybePromiseOrCursor.then((res) => {
              _optionalChain([span, 'optionalAccess', _6 => _6.finish, 'call', _7 => _7()]);
              return res;
            });
          }
          // If the operation returns a Cursor
          // we need to attach a listener to it to finish the span when the cursor is closed.
          else if (isCursor(maybePromiseOrCursor)) {
            const cursor = maybePromiseOrCursor ;

            try {
              cursor.once('close', () => {
                _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
              });
            } catch (e) {
              // If the cursor is already closed, `once` will throw an error. In that case, we can
              // finish the span immediately.
              _optionalChain([span, 'optionalAccess', _10 => _10.finish, 'call', _11 => _11()]);
            }

            return cursor;
          } else {
            _optionalChain([span, 'optionalAccess', _12 => _12.finish, 'call', _13 => _13()]);
            return maybePromiseOrCursor;
          }
        }

        const span = _optionalChain([parentSpan, 'optionalAccess', _14 => _14.startChild, 'call', _15 => _15(getSpanContext(this, operation, args.slice(0, -1)))]);

        return orig.call(this, ...args.slice(0, -1), function (err, result) {
          _optionalChain([span, 'optionalAccess', _16 => _16.finish, 'call', _17 => _17()]);
          lastArg(err, result);
        });
      };
    });
  }

  /**
   * Form a SpanContext based on the user input to a given operation.
   */
   _getSpanContextFromOperationArguments(
    collection,
    operation,
    args,
  ) {
    const data = {
      collectionName: collection.collectionName,
      dbName: collection.dbName,
      namespace: collection.namespace,
    };
    const spanContext = {
      op: 'db',
      description: operation,
      data,
    };

    // If the operation takes no arguments besides `options` and `callback`, or if argument
    // collection is disabled for this operation, just return early.
    const signature = OPERATION_SIGNATURES[operation];
    const shouldDescribe = Array.isArray(this._describeOperations)
      ? this._describeOperations.includes(operation)
      : this._describeOperations;

    if (!signature || !shouldDescribe) {
      return spanContext;
    }

    try {
      // Special case for `mapReduce`, as the only one accepting functions as arguments.
      if (operation === 'mapReduce') {
        const [map, reduce] = args ;
        data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
        data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
      } else {
        for (let i = 0; i < signature.length; i++) {
          data[signature[i]] = JSON.stringify(args[i]);
        }
      }
    } catch (_oO) {
      // no-empty
    }

    return spanContext;
  }
}Mongo.__initStatic();


//# sourceMappingURL=mongo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/prisma.js




function isValidPrismaClient(possibleClient) {
  return possibleClient && !!(possibleClient )['$use'];
}

/** Tracing integration for @prisma/client package */
class Prisma  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Prisma';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Prisma.id;}

  /**
   * Prisma ORM Client Instance
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {Prisma.prototype.__init.call(this);
    if (isValidPrismaClient(options.client)) {
      this._client = options.client;
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Unsupported Prisma client provided to PrismaIntegration. Provided client: ${JSON.stringify(options.client)}`,
        );
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (!this._client) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('PrismaIntegration is missing a Prisma Client Instance');
      return;
    }

    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Prisma Integration is skipped because of instrumenter configuration.');
      return;
    }

    this._client.$use((params, next) => {
      const scope = getCurrentHub().getScope();
      const parentSpan = _optionalChain([scope, 'optionalAccess', _2 => _2.getSpan, 'call', _3 => _3()]);

      const action = params.action;
      const model = params.model;

      const span = _optionalChain([parentSpan, 'optionalAccess', _4 => _4.startChild, 'call', _5 => _5({
        description: model ? `${model} ${action}` : action,
        op: 'db.sql.prisma',
      })]);

      const rv = next(params);

      if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then((res) => {
          _optionalChain([span, 'optionalAccess', _6 => _6.finish, 'call', _7 => _7()]);
          return res;
        });
      }

      _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
      return rv;
    });
  }
}Prisma.__initStatic();


//# sourceMappingURL=prisma.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/graphql.js




/** Tracing integration for graphql package */
class GraphQL  {constructor() { GraphQL.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GraphQL';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GraphQL.id;}

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('GraphQL Integration is skipped because of instrumenter configuration.');
      return;
    }

    const pkg = (0,node/* loadModule */.$y)

('graphql/execution/execute.js');

    if (!pkg) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('GraphQL Integration was unable to require graphql/execution package.');
      return;
    }

    (0,object/* fill */.hl)(pkg, 'execute', function (orig) {
      return function ( ...args) {
        const scope = getCurrentHub().getScope();
        const parentSpan = _optionalChain([scope, 'optionalAccess', _2 => _2.getSpan, 'call', _3 => _3()]);

        const span = _optionalChain([parentSpan, 'optionalAccess', _4 => _4.startChild, 'call', _5 => _5({
          description: 'execute',
          op: 'graphql.execute',
        })]);

        _optionalChain([scope, 'optionalAccess', _6 => _6.setSpan, 'call', _7 => _7(span)]);

        const rv = orig.call(this, ...args);

        if ((0,is/* isThenable */.J8)(rv)) {
          return rv.then((res) => {
            _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);
            _optionalChain([scope, 'optionalAccess', _10 => _10.setSpan, 'call', _11 => _11(parentSpan)]);

            return res;
          });
        }

        _optionalChain([span, 'optionalAccess', _12 => _12.finish, 'call', _13 => _13()]);
        _optionalChain([scope, 'optionalAccess', _14 => _14.setSpan, 'call', _15 => _15(parentSpan)]);
        return rv;
      };
    });
  }
}GraphQL.__initStatic();


//# sourceMappingURL=graphql.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/node/integrations/apollo.js




/** Tracing integration for Apollo */
class Apollo  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Apollo';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Apollo.id;}

  /**
   * @inheritDoc
   */
   constructor(
    options = {
      useNestjs: false,
    },
  ) {Apollo.prototype.__init.call(this);
    this._useNest = !!options.useNestjs;
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (shouldDisableAutoInstrumentation(getCurrentHub)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Apollo Integration is skipped because of instrumenter configuration.');
      return;
    }

    if (this._useNest) {
      const pkg = (0,node/* loadModule */.$y)

('@nestjs/graphql');

      if (!pkg) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
        return;
      }

      /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */
      (0,object/* fill */.hl)(
        pkg.GraphQLFactory.prototype,
        'mergeWithSchema',
        function (orig) {
          return function (

            ...args
          ) {
            (0,object/* fill */.hl)(this.resolversExplorerService, 'explore', function (orig) {
              return function () {
                const resolvers = (0,misc/* arrayify */.lE)(orig.call(this));

                const instrumentedResolvers = instrumentResolvers(resolvers, getCurrentHub);

                return instrumentedResolvers;
              };
            });

            return orig.call(this, ...args);
          };
        },
      );
    } else {
      const pkg = (0,node/* loadModule */.$y)

('apollo-server-core');

      if (!pkg) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Apollo Integration was unable to require apollo-server-core package.');
        return;
      }

      /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */
      (0,object/* fill */.hl)(pkg.ApolloServerBase.prototype, 'constructSchema', function (orig) {
        return function (

) {
          if (!this.config.resolvers) {
            if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
              if (this.config.schema) {
                esm_logger/* logger.warn */.kg.warn(
                  'Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.' +
                    'If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.',
                );
                esm_logger/* logger.warn */.kg.warn();
              } else if (this.config.modules) {
                esm_logger/* logger.warn */.kg.warn(
                  'Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.',
                );
              }

              esm_logger/* logger.error */.kg.error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
            }

            return orig.call(this);
          }

          const resolvers = (0,misc/* arrayify */.lE)(this.config.resolvers);

          this.config.resolvers = instrumentResolvers(resolvers, getCurrentHub);

          return orig.call(this);
        };
      });
    }
  }
}Apollo.__initStatic();

function instrumentResolvers(resolvers, getCurrentHub) {
  return resolvers.map(model => {
    Object.keys(model).forEach(resolverGroupName => {
      Object.keys(model[resolverGroupName]).forEach(resolverName => {
        if (typeof model[resolverGroupName][resolverName] !== 'function') {
          return;
        }

        wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
      });
    });

    return model;
  });
}

/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */
function wrapResolver(
  model,
  resolverGroupName,
  resolverName,
  getCurrentHub,
) {
  (0,object/* fill */.hl)(model[resolverGroupName], resolverName, function (orig) {
    return function ( ...args) {
      const scope = getCurrentHub().getScope();
      const parentSpan = _optionalChain([scope, 'optionalAccess', _2 => _2.getSpan, 'call', _3 => _3()]);
      const span = _optionalChain([parentSpan, 'optionalAccess', _4 => _4.startChild, 'call', _5 => _5({
        description: `${resolverGroupName}.${resolverName}`,
        op: 'graphql.resolve',
      })]);

      const rv = orig.call(this, ...args);

      if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then((res) => {
          _optionalChain([span, 'optionalAccess', _6 => _6.finish, 'call', _7 => _7()]);
          return res;
        });
      }

      _optionalChain([span, 'optionalAccess', _8 => _8.finish, 'call', _9 => _9()]);

      return rv;
    };
  });
}


//# sourceMappingURL=apollo.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(5544);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(7850);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(9791);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js










/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      if (clsCallback) {
        clsCallback();
      }
      if (lcpCallback) {
        lcpCallback();
      }
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  };

  observe('event', entryHandler, { durationThreshold: 0 });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  return onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js



/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,hasTracingEnabled/* hasTracingEnabled */.z)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...idletransaction/* TRACING_DEFAULTS */.AT,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);
    (0,hubextensions/* addTracingExtensions */.T)();

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.l)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;

      const op = 'ui.action.click';
      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.l)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/extensions.js
var extensions = __webpack_require__(758);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/index.js











//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js



const Integrations = {
  BrowserTracing: BrowserTracing,
  Apollo: Apollo,
  Express: Express,
  GraphQL: GraphQL,
  Mongo: Mongo,
  Mysql: Mysql,
  Postgres: Postgres,
  Prisma: Prisma,
};

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,extensions/* addExtensionMethods */.r)();
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(3454);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/_error.js



/** Platform-agnostic version of `flush` */
function _error_flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  return client ? client.flush(timeout) : Promise.resolve(false);
}

/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  withScope(scope => {
    scope.addEventProcessor(event => {
      (0,misc/* addExceptionMechanism */.EG)(event, {
        type: 'instrument',
        handled: true,
        data: {
          function: '_error.getInitialProps',
        },
      });
      return event;
    });

    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    captureException(err || `_error.js called with falsy error (${err})`);
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await _error_flush(2000);
}


//# sourceMappingURL=_error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js























// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);

  options.environment = options.environment || getVercelEnv(true) || "production";

  addClientIntegrations(options);

  sdk_init(options);

  configureScope(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
        // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js


/***/ }),

/***/ 8464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7597);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 8518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2343);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(535);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(360);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8823);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);







// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in WINDOW)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in WINDOW.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const url = args[1];
      const xhrInfo = (this.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this.__sentry_xhr__;

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(this, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  const oldOnPopState = WINDOW.onpopstate;
  WINDOW.onpopstate = function ( ...args) {
    const to = WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = WINDOW.onerror;

  WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW.onunhandledrejection;

  WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 7597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 2343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 2844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 1422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ loadModule; },
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8518);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(3454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */
const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = stack.slice(0, STACKTRACE_FRAME_LIMIT);

  const lastFrameFunction = localStack[localStack.length - 1].function;
  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  const firstFrameFunction = localStack[localStack.length - 1].function;
  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) {
    localStack.pop();
  }

  return localStack.map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    const lineMatch = line.match(FULL_MATCH);

    if (lineMatch) {
      let object;
      let method;
      let functionName;
      let typeName;
      let methodName;

      if (lineMatch[1]) {
        functionName = lineMatch[1];

        let methodStart = functionName.lastIndexOf('.');
        if (functionName[methodStart - 1] === '.') {
          methodStart--;
        }

        if (methodStart > 0) {
          object = functionName.slice(0, methodStart);
          method = functionName.slice(methodStart + 1);
          const objectEnd = object.indexOf('.Module');
          if (objectEnd > 0) {
            functionName = functionName.slice(objectEnd + 1);
            object = object.slice(0, objectEnd);
          }
        }
        typeName = undefined;
      }

      if (method) {
        typeName = object;
        methodName = method;
      }

      if (method === '<anonymous>') {
        methodName = undefined;
        functionName = undefined;
      }

      if (functionName === undefined) {
        methodName = methodName || '<anonymous>';
        functionName = typeName ? `${typeName}.${methodName}` : methodName;
      }

      let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
      const isNative = lineMatch[5] === 'native';

      if (!filename && lineMatch[5] && !isNative) {
        filename = lineMatch[5];
      }

      const isInternal =
        isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && !filename.includes(':\\'));

      // in_app is all that's not an internal Node function or a module within node_modules
      // note that isNative appears to return true even for node core libraries
      // see https://github.com/getsentry/raven-node/issues/176

      const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

      return {
        filename,
        module: getModule ? getModule(filename) : undefined,
        function: functionName,
        lineno: parseInt(lineMatch[3], 10) || undefined,
        colno: parseInt(lineMatch[4], 10) || undefined,
        in_app,
      };
    }

    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    return undefined;
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 7321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2343);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 6893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7597);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1422);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1235);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 1235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 6010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 3832:
/***/ (function(module, exports) {

/*!
 * CSSJanus. https://github.com/cssjanus/cssjanus
 *
 * Copyright 2014 Trevor Parscal
 * Copyright 2010 Roan Kattouw
 * Copyright 2008 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cssjanus;

/**
 * Create a tokenizer object.
 *
 * This utility class is used by CSSJanus to protect strings by replacing them temporarily with
 * tokens and later transforming them back.
 *
 * @class
 * @constructor
 * @param {RegExp} regex Regular expression whose matches to replace by a token
 * @param {string} token Placeholder text
 */
function Tokenizer( regex, token ) {

	var matches = [],
		index = 0;

	/**
	 * Add a match.
	 *
	 * @private
	 * @param {string} match Matched string
	 * @return {string} Token to leave in the matched string's place
	 */
	function tokenizeCallback( match ) {
		matches.push( match );
		return token;
	}

	/**
	 * Get a match.
	 *
	 * @private
	 * @return {string} Original matched string to restore
	 */
	function detokenizeCallback() {
		return matches[ index++ ];
	}

	return {
		/**
		 * Replace matching strings with tokens.
		 *
		 * @param {string} str String to tokenize
		 * @return {string} Tokenized string
		 */
		tokenize: function ( str ) {
			return str.replace( regex, tokenizeCallback );
		},

		/**
		 * Restores tokens to their original values.
		 *
		 * @param {string} str String previously run through tokenize()
		 * @return {string} Original string
		 */
		detokenize: function ( str ) {
			return str.replace( new RegExp( '(' + token + ')', 'g' ), detokenizeCallback );
		}
	};
}

/**
 * Create a CSSJanus object.
 *
 * CSSJanus transforms CSS rules with horizontal relevance so that a left-to-right stylesheet can
 * become a right-to-left stylesheet automatically. Processing can be bypassed for an entire rule
 * or a single property by adding a / * @noflip * / comment above the rule or property.
 *
 * @class
 * @constructor
 */
function CSSJanus() {

	var
		// Tokens
		temporaryToken = '`TMP`',
		noFlipSingleToken = '`NOFLIP_SINGLE`',
		noFlipClassToken = '`NOFLIP_CLASS`',
		commentToken = '`COMMENT`',
		// Patterns
		nonAsciiPattern = '[^\\u0020-\\u007e]',
		unicodePattern = '(?:(?:\\\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)',
		numPattern = '(?:[0-9]*\\.[0-9]+|[0-9]+)',
		unitPattern = '(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)',
		directionPattern = 'direction\\s*:\\s*',
		urlSpecialCharsPattern = '[!#$%&*-~]',
		validAfterUriCharsPattern = '[\'"]?\\s*',
		nonLetterPattern = '(^|[^a-zA-Z])',
		charsWithinSelectorPattern = '[^\\}]*?',
		noFlipPattern = '\\/\\*\\!?\\s*@noflip\\s*\\*\\/',
		commentPattern = '\\/\\*[^*]*\\*+([^\\/*][^*]*\\*+)*\\/',
		escapePattern = '(?:' + unicodePattern + '|\\\\[^\\r\\n\\f0-9a-f])',
		nmstartPattern = '(?:[_a-z]|' + nonAsciiPattern + '|' + escapePattern + ')',
		nmcharPattern = '(?:[_a-z0-9-]|' + nonAsciiPattern + '|' + escapePattern + ')',
		identPattern = '-?' + nmstartPattern + nmcharPattern + '*',
		quantPattern = numPattern + '(?:\\s*' + unitPattern + '|' + identPattern + ')?',
		signedQuantPattern = '((?:-?' + quantPattern + ')|(?:inherit|auto))',
		fourNotationQuantPropsPattern = '((?:margin|padding|border-width)\\s*:\\s*)',
		fourNotationColorPropsPattern = '((?:-color|border-style)\\s*:\\s*)',
		colorPattern = '(#?' + nmcharPattern + '+|(?:rgba?|hsla?)\\([ \\d.,%-]+\\))',
		// The use of a lazy match ("*?") may cause a backtrack limit to be exceeded before finding
		// the intended match. This affects 'urlCharsPattern' and 'lookAheadNotOpenBracePattern'.
		// We have not yet found this problem on Node.js, but we have on PHP 7, where it was
		// mitigated by using a possessive quantifier ("*+"), which are not supported in JS.
		// See <https://github.com/cssjanus/php-cssjanus/issues/14> and <https://phabricator.wikimedia.org/T215746#4944830>.
		urlCharsPattern = '(?:' + urlSpecialCharsPattern + '|' + nonAsciiPattern + '|' + escapePattern + ')*?',
		lookAheadNotLetterPattern = '(?![a-zA-Z])',
		lookAheadNotOpenBracePattern = '(?!(' + nmcharPattern + '|\\r?\\n|\\s|#|\\:|\\.|\\,|\\+|>|~|\\(|\\)|\\[|\\]|=|\\*=|~=|\\^=|\'[^\']*\'|"[^"]*"|' + commentToken + ')*?{)',
		lookAheadNotClosingParenPattern = '(?!' + urlCharsPattern + validAfterUriCharsPattern + '\\))',
		lookAheadForClosingParenPattern = '(?=' + urlCharsPattern + validAfterUriCharsPattern + '\\))',
		suffixPattern = '(\\s*(?:!important\\s*)?[;}])',
		// Regular expressions
		temporaryTokenRegExp = /`TMP`/g,
		commentRegExp = new RegExp( commentPattern, 'gi' ),
		noFlipSingleRegExp = new RegExp( '(' + noFlipPattern + lookAheadNotOpenBracePattern + '[^;}]+;?)', 'gi' ),
		noFlipClassRegExp = new RegExp( '(' + noFlipPattern + charsWithinSelectorPattern + '})', 'gi' ),
		directionLtrRegExp = new RegExp( '(' + directionPattern + ')ltr', 'gi' ),
		directionRtlRegExp = new RegExp( '(' + directionPattern + ')rtl', 'gi' ),
		leftRegExp = new RegExp( nonLetterPattern + '(left)' + lookAheadNotLetterPattern + lookAheadNotClosingParenPattern + lookAheadNotOpenBracePattern, 'gi' ),
		rightRegExp = new RegExp( nonLetterPattern + '(right)' + lookAheadNotLetterPattern + lookAheadNotClosingParenPattern + lookAheadNotOpenBracePattern, 'gi' ),
		leftInUrlRegExp = new RegExp( nonLetterPattern + '(left)' + lookAheadForClosingParenPattern, 'gi' ),
		rightInUrlRegExp = new RegExp( nonLetterPattern + '(right)' + lookAheadForClosingParenPattern, 'gi' ),
		ltrInUrlRegExp = new RegExp( nonLetterPattern + '(ltr)' + lookAheadForClosingParenPattern, 'gi' ),
		rtlInUrlRegExp = new RegExp( nonLetterPattern + '(rtl)' + lookAheadForClosingParenPattern, 'gi' ),
		cursorEastRegExp = new RegExp( nonLetterPattern + '([ns]?)e-resize', 'gi' ),
		cursorWestRegExp = new RegExp( nonLetterPattern + '([ns]?)w-resize', 'gi' ),
		fourNotationQuantRegExp = new RegExp( fourNotationQuantPropsPattern + signedQuantPattern + '(\\s+)' + signedQuantPattern + '(\\s+)' + signedQuantPattern + '(\\s+)' + signedQuantPattern + suffixPattern, 'gi' ),
		fourNotationColorRegExp = new RegExp( fourNotationColorPropsPattern + colorPattern + '(\\s+)' + colorPattern + '(\\s+)' + colorPattern + '(\\s+)' + colorPattern + suffixPattern, 'gi' ),
		bgHorizontalPercentageRegExp = new RegExp( '(background(?:-position)?\\s*:\\s*(?:[^:;}\\s]+\\s+)*?)(' + quantPattern + ')', 'gi' ),
		bgHorizontalPercentageXRegExp = new RegExp( '(background-position-x\\s*:\\s*)(-?' + numPattern + '%)', 'gi' ),
		// border-radius: <length or percentage>{1,4} [optional: / <length or percentage>{1,4} ]
		borderRadiusRegExp = new RegExp( '(border-radius\\s*:\\s*)' + signedQuantPattern + '(?:(?:\\s+' + signedQuantPattern + ')(?:\\s+' + signedQuantPattern + ')?(?:\\s+' + signedQuantPattern + ')?)?' +
			'(?:(?:(?:\\s*\\/\\s*)' + signedQuantPattern + ')(?:\\s+' + signedQuantPattern + ')?(?:\\s+' + signedQuantPattern + ')?(?:\\s+' + signedQuantPattern + ')?)?' + suffixPattern, 'gi' ),
		boxShadowRegExp = new RegExp( '(box-shadow\\s*:\\s*(?:inset\\s*)?)' + signedQuantPattern, 'gi' ),
		textShadow1RegExp = new RegExp( '(text-shadow\\s*:\\s*)' + signedQuantPattern + '(\\s*)' + colorPattern, 'gi' ),
		textShadow2RegExp = new RegExp( '(text-shadow\\s*:\\s*)' + colorPattern + '(\\s*)' + signedQuantPattern, 'gi' ),
		textShadow3RegExp = new RegExp( '(text-shadow\\s*:\\s*)' + signedQuantPattern, 'gi' ),
		translateXRegExp = new RegExp( '(transform\\s*:[^;}]*)(translateX\\s*\\(\\s*)' + signedQuantPattern + '(\\s*\\))', 'gi' ),
		translateRegExp = new RegExp( '(transform\\s*:[^;}]*)(translate\\s*\\(\\s*)' + signedQuantPattern + '((?:\\s*,\\s*' + signedQuantPattern + '){0,2}\\s*\\))', 'gi' );

	/**
	 * Invert the horizontal value of a background position property.
	 *
	 * @private
	 * @param {string} match Matched property
	 * @param {string} pre Text before value
	 * @param {string} value Horizontal value
	 * @return {string} Inverted property
	 */
	function calculateNewBackgroundPosition( match, pre, value ) {
		var idx, len;
		if ( value.slice( -1 ) === '%' ) {
			idx = value.indexOf( '.' );
			if ( idx !== -1 ) {
				// Two off, one for the "%" at the end, one for the dot itself
				len = value.length - idx - 2;
				value = 100 - parseFloat( value );
				value = value.toFixed( len ) + '%';
			} else {
				value = 100 - parseFloat( value ) + '%';
			}
		}
		return pre + value;
	}

	/**
	 * Invert a set of border radius values.
	 *
	 * @private
	 * @param {Array} values Matched values
	 * @return {string} Inverted values
	 */
	function flipBorderRadiusValues( values ) {
		switch ( values.length ) {
			case 4:
				values = [ values[ 1 ], values[ 0 ], values[ 3 ], values[ 2 ] ];
				break;
			case 3:
				values = [ values[ 1 ], values[ 0 ], values[ 1 ], values[ 2 ] ];
				break;
			case 2:
				values = [ values[ 1 ], values[ 0 ] ];
				break;
			case 1:
				values = [ values[ 0 ] ];
				break;
		}

		return values.join( ' ' );
	}

	/**
	 * Invert a set of border radius values.
	 *
	 * @private
	 * @param {string} match Matched property
	 * @param {string} pre Text before value
	 * @param {string} [firstGroup1]
	 * @param {string} [firstGroup2]
	 * @param {string} [firstGroup3]
	 * @param {string} [firstGroup4]
	 * @param {string} [secondGroup1]
	 * @param {string} [secondGroup2]
	 * @param {string} [secondGroup3]
	 * @param {string} [secondGroup4]
	 * @param {string} [post] Text after value
	 * @return {string} Inverted property
	 */
	function calculateNewBorderRadius( match, pre ) {
		var values,
			args = [].slice.call( arguments ),
			firstGroup = args.slice( 2, 6 ).filter( function ( val ) { return val; } ),
			secondGroup = args.slice( 6, 10 ).filter( function ( val ) { return val; } ),
			post = args[ 10 ] || '';

		if ( secondGroup.length ) {
			values = flipBorderRadiusValues( firstGroup ) + ' / ' + flipBorderRadiusValues( secondGroup );
		} else {
			values = flipBorderRadiusValues( firstGroup );
		}

		return pre + values + post;
	}

	/**
	 * Flip the sign of a CSS value, possibly with a unit.
	 *
	 * We can't just negate the value with unary minus due to the units.
	 *
	 * @private
	 * @param {string} value
	 * @return {string}
	 */
	function flipSign( value ) {
		if ( parseFloat( value ) === 0 ) {
			// Don't mangle zeroes
			return value;
		}

		if ( value[ 0 ] === '-' ) {
			return value.slice( 1 );
		}

		return '-' + value;
	}

	/**
	 * @private
	 * @param {string} match
	 * @param {string} property
	 * @param {string} offset
	 * @return {string}
	 */
	function calculateNewShadow( match, property, offset ) {
		return property + flipSign( offset );
	}

	/**
	 * @private
	 * @param {string} match
	 * @param {string} property
	 * @param {string} prefix
	 * @param {string} offset
	 * @param {string} suffix
	 * @return {string}
	 */
	function calculateNewTranslate( match, property, prefix, offset, suffix ) {
		return property + prefix + flipSign( offset ) + suffix;
	}

	/**
	 * @private
	 * @param {string} match
	 * @param {string} property
	 * @param {string} color
	 * @param {string} space
	 * @param {string} offset
	 * @return {string}
	 */
	function calculateNewFourTextShadow( match, property, color, space, offset ) {
		return property + color + space + flipSign( offset );
	}

	return {
		/**
		 * Transform a left-to-right stylesheet to right-to-left.
		 *
		 * @param {string} css Stylesheet to transform
		 * @param {Object} options Options
		 * @param {boolean} [options.transformDirInUrl=false] Transform directions in URLs
		 * (e.g. 'ltr', 'rtl')
		 * @param {boolean} [options.transformEdgeInUrl=false] Transform edges in URLs
		 * (e.g. 'left', 'right')
		 * @return {string} Transformed stylesheet
		 */
		'transform': function ( css, options ) { // eslint-disable-line quote-props
			// Use single quotes in this object literal key for closure compiler.
			// Tokenizers
			var noFlipSingleTokenizer = new Tokenizer( noFlipSingleRegExp, noFlipSingleToken ),
				noFlipClassTokenizer = new Tokenizer( noFlipClassRegExp, noFlipClassToken ),
				commentTokenizer = new Tokenizer( commentRegExp, commentToken );

			// Tokenize
			css = commentTokenizer.tokenize(
				noFlipClassTokenizer.tokenize(
					noFlipSingleTokenizer.tokenize(
						// We wrap tokens in ` , not ~ like the original implementation does.
						// This was done because ` is not a legal character in CSS and can only
						// occur in URLs, where we escape it to %60 before inserting our tokens.
						css.replace( '`', '%60' )
					)
				)
			);

			// Transform URLs
			if ( options.transformDirInUrl ) {
				// Replace 'ltr' with 'rtl' and vice versa in background URLs
				css = css
					.replace( ltrInUrlRegExp, '$1' + temporaryToken )
					.replace( rtlInUrlRegExp, '$1ltr' )
					.replace( temporaryTokenRegExp, 'rtl' );
			}
			if ( options.transformEdgeInUrl ) {
				// Replace 'left' with 'right' and vice versa in background URLs
				css = css
					.replace( leftInUrlRegExp, '$1' + temporaryToken )
					.replace( rightInUrlRegExp, '$1left' )
					.replace( temporaryTokenRegExp, 'right' );
			}

			// Transform rules
			css = css
				// Replace direction: ltr; with direction: rtl; and vice versa.
				.replace( directionLtrRegExp, '$1' + temporaryToken )
				.replace( directionRtlRegExp, '$1ltr' )
				.replace( temporaryTokenRegExp, 'rtl' )
				// Flip rules like left: , padding-right: , etc.
				.replace( leftRegExp, '$1' + temporaryToken )
				.replace( rightRegExp, '$1left' )
				.replace( temporaryTokenRegExp, 'right' )
				// Flip East and West in rules like cursor: nw-resize;
				.replace( cursorEastRegExp, '$1$2' + temporaryToken )
				.replace( cursorWestRegExp, '$1$2e-resize' )
				.replace( temporaryTokenRegExp, 'w-resize' )
				// Border radius
				.replace( borderRadiusRegExp, calculateNewBorderRadius )
				// Shadows
				.replace( boxShadowRegExp, calculateNewShadow )
				.replace( textShadow1RegExp, calculateNewFourTextShadow )
				.replace( textShadow2RegExp, calculateNewFourTextShadow )
				.replace( textShadow3RegExp, calculateNewShadow )
				// Translate
				.replace( translateXRegExp, calculateNewTranslate )
				.replace( translateRegExp, calculateNewTranslate )
				// Swap the second and fourth parts in four-part notation rules
				// like padding: 1px 2px 3px 4px;
				.replace( fourNotationQuantRegExp, '$1$2$3$8$5$6$7$4$9' )
				.replace( fourNotationColorRegExp, '$1$2$3$8$5$6$7$4$9' )
				// Flip horizontal background percentages
				.replace( bgHorizontalPercentageRegExp, calculateNewBackgroundPosition )
				.replace( bgHorizontalPercentageXRegExp, calculateNewBackgroundPosition );

			// Detokenize
			css = noFlipSingleTokenizer.detokenize(
				noFlipClassTokenizer.detokenize(
					commentTokenizer.detokenize( css )
				)
			);

			return css;
		}
	};
}

/* Initialization */

cssjanus = new CSSJanus();

/* Exports */

if (  true && module.exports ) {
	/**
	 * Transform a left-to-right stylesheet to right-to-left.
	 *
	 * This function is a static wrapper around the transform method of an instance of CSSJanus.
	 *
	 * @param {string} css Stylesheet to transform
	 * @param {Object|boolean} [options] Options object, or transformDirInUrl option (back-compat)
	 * @param {boolean} [options.transformDirInUrl=false] Transform directions in URLs
	 * (e.g. 'ltr', 'rtl')
	 * @param {boolean} [options.transformEdgeInUrl=false] Transform edges in URLs
	 * (e.g. 'left', 'right')
	 * @param {boolean} [transformEdgeInUrl] Back-compat parameter
	 * @return {string} Transformed stylesheet
	 */
	exports.transform = function ( css, options, transformEdgeInUrl ) {
		var norm;
		if ( typeof options === 'object' ) {
			norm = options;
		} else {
			norm = {};
			if ( typeof options === 'boolean' ) {
				norm.transformDirInUrl = options;
			}
			if ( typeof transformEdgeInUrl === 'boolean' ) {
				norm.transformEdgeInUrl = transformEdgeInUrl;
			}
		}
		return cssjanus.transform( css, norm );
	};
} else if ( typeof window !== 'undefined' ) {
	/* global window */
	// Allow cssjanus to be used in a browser.
	// eslint-disable-next-line dot-notation
	window[ 'cssjanus' ] = cssjanus;
}


/***/ }),

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(_,t){ true?module.exports=t(__webpack_require__(7484)):0}(this,(function(_){"use strict";function t(_){return _&&"object"==typeof _&&"default"in _?_:{default:_}}var e=t(_),n="января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),s="январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),r="янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),o="янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_"),i=/D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;function d(_,t,e){var n,s;return"m"===e?t?"минута":"минуту":_+" "+(n=+_,s={mm:t?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"}[e].split("_"),n%10==1&&n%100!=11?s[0]:n%10>=2&&n%10<=4&&(n%100<10||n%100>=20)?s[1]:s[2])}var u=function(_,t){return i.test(t)?n[_.month()]:s[_.month()]};u.s=s,u.f=n;var a=function(_,t){return i.test(t)?r[_.month()]:o[_.month()]};a.s=o,a.f=r;var m={name:"ru",weekdays:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),weekdaysShort:"вск_пнд_втр_срд_чтв_птн_сбт".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),months:u,monthsShort:a,weekStart:1,yearStart:4,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., H:mm",LLLL:"dddd, D MMMM YYYY г., H:mm"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",m:d,mm:d,h:"час",hh:d,d:"день",dd:d,M:"месяц",MM:d,y:"год",yy:d},ordinal:function(_){return _},meridiem:function(_){return _<4?"ночи":_<12?"утра":_<17?"дня":"вечера"}};return e.default.locale(m,null,!0),m}));

/***/ }),

/***/ 285:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return(e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1)}],a:[i,function(e){this.afternoon=u(e,!0)}],S:[/\d/,function(e){this.milliseconds=100*+e}],SS:[n,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else{var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={}}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""))}else i.call(this,e)}}}));

/***/ }),

/***/ 6607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 6176:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)}}}));

/***/ }),

/***/ 6852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(7294),n=__webpack_require__(6199);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 6199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(6852);
} else {}


/***/ }),

/***/ 3233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(984);
} else {}


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 6284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5145);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9137);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5957);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1092);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),

/***/ 1050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5145);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 1092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ formatToParts; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9137);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1050);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 5145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 9915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MetricaPixel = void 0;
const react_1 = __importDefault(__webpack_require__(7294));
const MetricaPixel = ({ tagID }) => (react_1.default.createElement("img", { height: "1", width: "1", style: { display: 'none' }, src: `https://mc.yandex.ru/watch/${tagID}`, alt: "" }));
exports.MetricaPixel = MetricaPixel;
//# sourceMappingURL=MetricaPixel.js.map

/***/ }),

/***/ 4134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YandexMetricaProvider = exports.MetricaTagIDContext = void 0;
const script_1 = __importDefault(__webpack_require__(4298));
const react_1 = __importStar(__webpack_require__(7294));
const useTrackRouteChange_1 = __webpack_require__(7854);
const MetricaPixel_1 = __webpack_require__(9915);
exports.MetricaTagIDContext = (0, react_1.createContext)(null);
const YandexMetricaProvider = ({ children, tagID, strategy = 'afterInteractive', initParameters, }) => {
    const YANDEX_METRICA_ID = process.env.NEXT_PUBLIC_YANDEX_METRICA_ID;
    const id = (0, react_1.useMemo)(() => {
        return tagID || (YANDEX_METRICA_ID ? Number(YANDEX_METRICA_ID) : null);
    }, [YANDEX_METRICA_ID, tagID]);
    (0, useTrackRouteChange_1.useTrackRouteChange)({ tagID: id });
    if (!id) {
        console.warn('[next-yandex-metrica] Yandex.Metrica tag ID is not defined');
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(script_1.default, { id: "yandex-metrica", strategy: strategy }, `
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
          ym(${id}, "init", ${JSON.stringify(initParameters || {})});
        `),
        react_1.default.createElement("noscript", { id: "yandex-metrica-pixel" },
            react_1.default.createElement(MetricaPixel_1.MetricaPixel, { tagID: id })),
        react_1.default.createElement(exports.MetricaTagIDContext.Provider, { value: id }, children)));
};
exports.YandexMetricaProvider = YandexMetricaProvider;
//# sourceMappingURL=YandexMetricaProvider.js.map

/***/ }),

/***/ 8200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMetrica = void 0;
const react_1 = __webpack_require__(7294);
const YandexMetricaProvider_1 = __webpack_require__(4134);
const ym_1 = __webpack_require__(4645);
const useMetrica = () => {
    const tagID = (0, react_1.useContext)(YandexMetricaProvider_1.MetricaTagIDContext);
    const notBounce = (0, react_1.useCallback)((options) => {
        (0, ym_1.ym)(tagID, 'notBounce', options);
    }, [tagID]);
    const reachGoal = (0, react_1.useCallback)((target, params, callback) => {
        (0, ym_1.ym)(tagID, 'reachGoal', target, params, callback);
    }, [tagID]);
    const setUserID = (0, react_1.useCallback)((userID) => {
        (0, ym_1.ym)(tagID, 'setUserID', userID);
    }, [tagID]);
    const userParams = (0, react_1.useCallback)((parameters) => {
        (0, ym_1.ym)(tagID, 'userParams', parameters);
    }, [tagID]);
    const ymEvent = (0, react_1.useCallback)((...parameters) => {
        (0, ym_1.ym)(tagID, ...parameters);
    }, [tagID]);
    return { notBounce, reachGoal, setUserID, userParams, ymEvent };
};
exports.useMetrica = useMetrica;
//# sourceMappingURL=useMetrica.js.map

/***/ }),

/***/ 7854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTrackRouteChange = void 0;
const router_1 = __webpack_require__(1163);
const react_1 = __webpack_require__(7294);
const ym_1 = __webpack_require__(4645);
const useTrackRouteChange = ({ tagID }) => {
    (0, react_1.useEffect)(() => {
        const handleRouteChange = (url) => {
            (0, ym_1.ym)(tagID, 'hit', url.toString());
        };
        router_1.Router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router_1.Router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [tagID]);
};
exports.useTrackRouteChange = useTrackRouteChange;
//# sourceMappingURL=useTrackRouteChange.js.map

/***/ }),

/***/ 9024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.BJ = void 0;
var YandexMetricaProvider_1 = __webpack_require__(4134);
Object.defineProperty(exports, "BJ", ({ enumerable: true, get: function () { return YandexMetricaProvider_1.YandexMetricaProvider; } }));
var useMetrica_1 = __webpack_require__(8200);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useMetrica_1.useMetrica; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4645:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ym = void 0;
const ym = (tagID, ...parameters) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ym is defined by the Yandex.Metrica script
    // @ts-ignore
    const ym = window.ym;
    if (!ym || !tagID) {
        return;
    }
    ym(tagID, ...parameters);
};
exports.ym = ym;
//# sourceMappingURL=ym.js.map

/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(9746);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1246:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5722);
/* provided dependency */ var process = __webpack_require__(3454);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "uRKKIQzIa2V-wQ-PLklIO"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .init */ .S1({
    dsn: SENTRY_DSN || "https://860def41d71045b6ab58f722d4a5e819@o4504876434063360.ingest.sentry.io/4504876494422016",
    tracesSampleRate: 1.0
});


/***/ }),

/***/ 227:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) {} else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _router = __webpack_require__(1003);
var _addLocale = __webpack_require__(4465);
var _routerContext = __webpack_require__(2692);
var _appRouterContext = __webpack_require__(8245);
var _useIntersection = __webpack_require__(9246);
var _getDomainLocale = __webpack_require__(227);
var _addBasePath = __webpack_require__(3468);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 9246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(4686);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 8245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 4737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J6": function() { return /* binding */ SettingsContext; },
/* harmony export */   "ix": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "mu": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9734);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mode */ .Z.mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].skin */ .Z.skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].footer */ .Z.footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].layout */ .Z.layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].layout */ .Z.layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].direction */ .Z.direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].navHidden */ .Z.navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].appBarBlur */ .Z.appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].navCollapsed */ .Z.navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].contentWidth */ .Z.contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].toastPosition */ .Z.toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verticalNavToggleType */ .Z.verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].layout */ .Z.layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].appBar */ .Z.appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__/* ["default"].appBar */ .Z.appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        console.error(err);
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 1268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4737);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__/* .SettingsContext */ .J6);


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    appUrl: "https://".concat("app.gosilk.ru")
});


/***/ }),

/***/ 9734:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ // ** MUI Imports
const themeConfig = {
    // ** Layout Configs
    templateName: "Silk" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "dark",
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: true,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle-outline" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 260 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: true,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["Z"] = (themeConfig);


/***/ }),

/***/ 9930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ HistoryContext; },
/* harmony export */   "f": function() { return /* binding */ HistoryProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
// ** React Imports


// ** Next Import

// ** Defaults
const defaultProvider = [];
const HistoryContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultProvider);
const HistoryProvider = (param)=>{
    let { children  } = param;
    // ** States
    const [history, setHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    // ** Hooks
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setHistory((state)=>[
                ...state,
                router.pathname
            ]);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HistoryContext.Provider, {
        value: history,
        children: children
    });
};



/***/ }),

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ default_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@unleash/proxy-client-react/dist/unleash-react.js + 1 modules
var unleash_react = __webpack_require__(8676);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(120);
// EXTERNAL MODULE: ./node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(4190);
// EXTERNAL MODULE: ./src/state-manager/global/index.ts + 3 modules
var global = __webpack_require__(5789);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(6622);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass_generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/AppBar/appBarClasses.js


function getAppBarUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiAppBar', slot);
}
const appBarClasses = (0,generateUtilityClasses/* default */.Z)('MuiAppBar', ['root', 'positionFixed', 'positionAbsolute', 'positionSticky', 'positionStatic', 'positionRelative', 'colorDefault', 'colorPrimary', 'colorSecondary', 'colorInherit', 'colorTransparent']);
/* harmony default export */ var AppBar_appBarClasses = ((/* unused pure expression or super */ null && (appBarClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js


const _excluded = ["className", "color", "enableColorOnDark", "position"];











const useUtilityClasses = ownerState => {
  const {
    color,
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`, `position${(0,capitalize/* default */.Z)(position)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getAppBarUtilityClass, classes);
}; // var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'


const joinVars = (var1, var2) => `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})`;

const AppBarRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiAppBar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${(0,capitalize/* default */.Z)(ownerState.position)}`], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return (0,esm_extends/* default */.Z)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, ownerState.position === 'fixed' && {
    position: 'fixed',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0,
    '@media print': {
      // Prevent the app bar to be visible on each printed page.
      position: 'absolute'
    }
  }, ownerState.position === 'absolute' && {
    position: 'absolute',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'sticky' && {
    // ⚠️ sticky is not supported by IE11.
    position: 'sticky',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'static' && {
    position: 'static'
  }, ownerState.position === 'relative' && {
    position: 'relative'
  }, !theme.vars && (0,esm_extends/* default */.Z)({}, ownerState.color === 'default' && {
    backgroundColor: backgroundColorDefault,
    color: theme.palette.getContrastText(backgroundColorDefault)
  }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText
  }, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, ownerState.color === 'transparent' && (0,esm_extends/* default */.Z)({
    backgroundColor: 'transparent',
    color: 'inherit'
  }, theme.palette.mode === 'dark' && {
    backgroundImage: 'none'
  })), theme.vars && (0,esm_extends/* default */.Z)({}, ownerState.color === 'default' && {
    '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
    '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
  }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
    '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
    '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
  }, {
    backgroundColor: 'var(--AppBar-background)',
    color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
  }, ownerState.color === 'transparent' && {
    backgroundImage: 'none',
    backgroundColor: 'transparent',
    color: 'inherit'
  }));
});
const AppBar = /*#__PURE__*/react.forwardRef(function AppBar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAppBar'
  });

  const {
    className,
    color = 'primary',
    enableColorOnDark = false,
    position = 'fixed'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    position,
    enableColorOnDark
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AppBarRoot, (0,esm_extends/* default */.Z)({
    square: true,
    component: "header",
    ownerState: ownerState,
    elevation: 4,
    className: (0,clsx_m/* default */.Z)(classes.root, className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AppBar_AppBar = (AppBar);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(8016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(562);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(2996);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(3703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(2690);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(9948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/createChainedFunction/createChainedFunction.js
var createChainedFunction = __webpack_require__(1476);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(3546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/setRef/setRef.js
var setRef = __webpack_require__(7364);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Portal/Portal.js






function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


const Portal = /*#__PURE__*/react.forwardRef(function Portal(props, ref) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = react.useState(null);
  const handleRef = (0,useForkRef/* default */.Z)( /*#__PURE__*/react.isValidElement(children) ? children.ref : null, ref);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (mountNode && !disablePortal) {
      (0,setRef/* default */.Z)(ref, mountNode);
      return () => {
        (0,setRef/* default */.Z)(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react.isValidElement(children)) {
      return /*#__PURE__*/react.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: mountNode ? /*#__PURE__*/react_dom.createPortal(children, mountNode) : mountNode
  });
});
 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var Portal_Portal = (Portal);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerWindow/ownerWindow.js
var ownerWindow = __webpack_require__(4161);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/getScrollbarSize/getScrollbarSize.js
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/ModalUnstyled/ModalManager.js


// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = (0,ownerDocument/* default */.Z)(container);

  if (doc.body === container) {
    return (0,ownerWindow/* default */.Z)(container).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(element) {
  return parseInt((0,ownerWindow/* default */.Z)(element).getComputedStyle(element).paddingRight, 10) || 0;
}

function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}

function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);

    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}

function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = getScrollbarSize((0,ownerDocument/* default */.Z)(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.

      const fixedElements = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }

    let scrollContainer;

    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = (0,ownerDocument/* default */.Z)(container).body;
    } else {
      // Improve Gatsby support
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = (0,ownerWindow/* default */.Z)(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    } // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.


    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}

/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }

  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);

    if (modalIndex !== -1) {
      return modalIndex;
    }

    modalIndex = this.modals.length;
    this.modals.push(modal); // If the modal we are adding is already in the DOM.

    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }

    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);

    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }

    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }

  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];

    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }

  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);

    if (modalIndex === -1) {
      return modalIndex;
    }

    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }

      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }

      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null

      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }

    return modalIndex;
  }

  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }

}
;// CONCATENATED MODULE: ./node_modules/@mui/base/FocusTrap/FocusTrap.js
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */


 // Inspired by https://github.com/focus-trap/tabbable



const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');

function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
}

function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }

  if (!node.name) {
    return false;
  }

  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);

  let roving = getRadio(`[name="${node.name}"]:checked`);

  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }

  return roving !== node;
}

function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }

  return true;
}

function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);

    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }

    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}

function defaultIsEnabled() {
  return true;
}
/**
 * Utility component that locks focus inside the component.
 */


function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = react.useRef();
  const sentinelStart = react.useRef(null);
  const sentinelEnd = react.useRef(null);
  const nodeToRestore = react.useRef(null);
  const reactFocusEventTarget = react.useRef(null); // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.

  const activated = react.useRef(false);
  const rootRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, rootRef);
  const lastKeydown = react.useRef(null);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);

    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}

        rootRef.current.setAttribute('tabIndex', -1);
      }

      if (activated.current) {
        rootRef.current.focus();
      }
    }

    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);

    const contain = nativeEvent => {
      const {
        current: rootElement
      } = rootRef; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (!rootElement.contains(doc.activeElement)) {
        // if the focus event is not coming from inside the children's react tree, reset the refs
        if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
          reactFocusEventTarget.current = null;
        } else if (reactFocusEventTarget.current !== null) {
          return;
        }

        if (!activated.current) {
          return;
        }

        let tabbable = [];

        if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
          tabbable = getTabbable(rootRef.current);
        }

        if (tabbable.length > 0) {
          var _lastKeydown$current, _lastKeydown$current2;

          const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
          const focusNext = tabbable[0];
          const focusPrevious = tabbable[tabbable.length - 1];

          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        } else {
          rootElement.focus();
        }
      }
    };

    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;

      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      } // Make sure the next tab starts from the right place.
      // doc.activeElement referes to the origin.


      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        sentinelEnd.current.focus();
      }
    };

    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    const interval = setInterval(() => {
      if (doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);

  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/react.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var FocusTrap_FocusTrap = (FocusTrap);
;// CONCATENATED MODULE: ./node_modules/@mui/base/ModalUnstyled/modalUnstyledClasses.js


function getModalUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiModal', slot);
}
const modalUnstyledClasses_modalUnstyledClasses = (0,generateUtilityClasses/* default */.Z)('MuiModal', ['root', 'hidden']);
/* harmony default export */ var ModalUnstyled_modalUnstyledClasses = ((/* unused pure expression or super */ null && (modalUnstyledClasses_modalUnstyledClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(8442);
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/appendOwnerState.js


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps = {}, ownerState) {
  if ((0,isHostComponent/* default */.Z)(elementType)) {
    return otherProps;
  }

  return (0,esm_extends/* default */.Z)({}, otherProps, {
    ownerState: (0,esm_extends/* default */.Z)({}, otherProps.ownerState, ownerState)
  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/extractEventHandlers.js
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }

  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/omitEventHandlers.js
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }

  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/mergeSlotProps.js





/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on an unstyled component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;

  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = (0,clsx_m/* default */.Z)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);

    const mergedStyle = (0,esm_extends/* default */.Z)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);

    const props = (0,esm_extends/* default */.Z)({}, additionalProps, externalForwardedProps, externalSlotProps);

    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }

    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }

    return {
      props,
      internalRef: undefined
    };
  } // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.


  const eventHandlers = extractEventHandlers((0,esm_extends/* default */.Z)({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers); // The order of classes is important here.
  // Emotion (that we use in libraries consuming MUI Base) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.

  const joinedClasses = (0,clsx_m/* default */.Z)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);

  const mergedStyle = (0,esm_extends/* default */.Z)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);

  const props = (0,esm_extends/* default */.Z)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);

  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }

  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }

  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/resolveComponentProps.js
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState);
  }

  return componentProps;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/useSlotProps.js


const useSlotProps_excluded = ["elementType", "externalSlotProps", "ownerState"];





/**
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;

  const {
    elementType,
    externalSlotProps,
    ownerState
  } = parameters,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(parameters, useSlotProps_excluded);

  const resolvedComponentsProps = resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps((0,esm_extends/* default */.Z)({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = (0,useForkRef/* default */.Z)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, (0,esm_extends/* default */.Z)({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/ModalUnstyled/ModalUnstyled.js


const ModalUnstyled_excluded = ["children", "classes", "closeAfterTransition", "component", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited", "slotProps", "slots"];












const ModalUnstyled_useUtilityClasses = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden']
  };
  return (0,composeClasses/* default */.Z)(slots, getModalUtilityClass, classes);
};

function ModalUnstyled_getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


const defaultManager = new ModalManager();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const ModalUnstyled = /*#__PURE__*/react.forwardRef(function ModalUnstyled(props, ref) {
  var _props$ariaHidden, _ref;

  const {
    children,
    classes: classesProp,
    closeAfterTransition = false,
    component,
    container,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    // private
    // eslint-disable-next-line react/prop-types
    manager = defaultManager,
    onBackdropClick,
    onClose,
    onKeyDown,
    open,

    /* eslint-disable react/prop-types */
    onTransitionEnter,
    onTransitionExited,
    slotProps = {},
    slots = {}
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ModalUnstyled_excluded);

  const [exited, setExited] = react.useState(true);
  const modal = react.useRef({});
  const mountNodeRef = react.useRef(null);
  const modalRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(modalRef, ref);
  const hasTransition = getHasTransition(props);
  const ariaHiddenProp = (_props$ariaHidden = props['aria-hidden']) != null ? _props$ariaHidden : true;

  const getDoc = () => (0,ownerDocument/* default */.Z)(mountNodeRef.current);

  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  const handleOpen = (0,useEventCallback/* default */.Z)(() => {
    const resolvedContainer = ModalUnstyled_getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = react.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = (0,useEventCallback/* default */.Z)(node => {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = react.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [manager, ariaHiddenProp]);
  react.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    classes: classesProp,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    exited,
    hideBackdrop,
    keepMounted
  });

  const classes = ModalUnstyled_useUtilityClasses(ownerState);

  const handleEnter = () => {
    setExited(false);

    if (onTransitionEnter) {
      onTransitionEnter();
    }
  };

  const handleExited = () => {
    setExited(true);

    if (onTransitionExited) {
      onTransitionExited();
    }

    if (closeAfterTransition) {
      handleClose();
    }
  };

  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    } // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.


    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  const childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = (0,createChainedFunction/* default */.Z)(handleEnter, children.props.onEnter);
    childProps.onExited = (0,createChainedFunction/* default */.Z)(handleExited, children.props.onExited);
  }

  const Root = (_ref = component != null ? component : slots.root) != null ? _ref : 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: handleRef,
      role: 'presentation',
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState
  });
  const BackdropComponent = slots.backdrop;
  const backdropProps = useSlotProps({
    elementType: BackdropComponent,
    externalSlotProps: slotProps.backdrop,
    additionalProps: {
      'aria-hidden': true,
      onClick: handleBackdropClick,
      open
    },
    className: classes.backdrop,
    ownerState
  });

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal_Portal, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropComponent, (0,esm_extends/* default */.Z)({}, backdropProps)) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(FocusTrap_FocusTrap, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/react.cloneElement(children, childProps)
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var ModalUnstyled_ModalUnstyled = (ModalUnstyled);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(5068);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/transitions/utils.js
const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;

  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var utils_useForkRef = __webpack_require__(4771);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Fade/Fade.js


const Fade_excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Fade = /*#__PURE__*/react.forwardRef(function Fade(props, ref) {
  const theme = (0,useTheme/* default */.Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = esm_Transition
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Fade_excluded);

  const enableStrictModeCompat = true;
  const nodeRef = react.useRef(null);
  const handleRef = (0,utils_useForkRef/* default */.Z)(nodeRef, children.ref, ref);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: appear,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
        style: (0,esm_extends/* default */.Z)({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Fade_Fade = (Fade);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Backdrop/backdropClasses.js


function getBackdropUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiBackdrop', slot);
}
const backdropClasses = (0,generateUtilityClasses/* default */.Z)('MuiBackdrop', ['root', 'invisible']);
/* harmony default export */ var Backdrop_backdropClasses = ((/* unused pure expression or super */ null && (backdropClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Backdrop/Backdrop.js


const Backdrop_excluded = ["children", "component", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"];










const Backdrop_useUtilityClasses = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getBackdropUtilityClass, classes);
};

const BackdropRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/react.forwardRef(function Backdrop(inProps, ref) {
  var _components$Root, _componentsProps$root;

  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBackdrop'
  });

  const {
    children,
    component = 'div',
    components = {},
    componentsProps = {},
    className,
    invisible = false,
    open,
    transitionDuration,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Fade_Fade
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Backdrop_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    invisible
  });

  const classes = Backdrop_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropRoot, {
      "aria-hidden": true,
      as: (_components$Root = components.Root) != null ? _components$Root : component,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState),
      classes: classes,
      ref: ref,
      children: children
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Backdrop_Backdrop = (Backdrop);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js


const Modal_excluded = ["BackdropComponent", "BackdropProps", "closeAfterTransition", "children", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "slotProps", "slots", "theme"];









const modalClasses = (/* unused pure expression or super */ null && (modalUnstyledClasses));

const extendUtilityClasses = ownerState => {
  return ownerState.classes;
};

const ModalRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = (0,styled/* default */.ZP)(Backdrop_Backdrop, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;

  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiModal',
    props: inProps
  });

  const {
    BackdropComponent = ModalBackdrop,
    BackdropProps,
    closeAfterTransition = false,
    children,
    component,
    components = {},
    componentsProps = {},
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    slotProps,
    slots,
    // eslint-disable-next-line react/prop-types
    theme
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Modal_excluded);

  const [exited, setExited] = react.useState(true);
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };

  const ownerState = (0,esm_extends/* default */.Z)({}, props, commonProps, {
    exited
  });

  const classes = extendUtilityClasses(ownerState);
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalUnstyled_ModalUnstyled, (0,esm_extends/* default */.Z)({
    slots: {
      root: RootSlot,
      backdrop: BackdropSlot
    },
    slotProps: {
      root: () => (0,esm_extends/* default */.Z)({}, resolveComponentProps(rootSlotProps, ownerState), !(0,isHostComponent/* default */.Z)(RootSlot) && {
        as: component,
        theme
      }),
      backdrop: () => (0,esm_extends/* default */.Z)({}, BackdropProps, resolveComponentProps(backdropSlotProps, ownerState))
    },
    onTransitionEnter: () => setExited(false),
    onTransitionExited: () => setExited(true),
    ref: ref
  }, other, {
    classes: classes
  }, commonProps, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Dialog/dialogClasses.js


function getDialogUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiDialog', slot);
}
const dialogClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
/* harmony default export */ var Dialog_dialogClasses = (dialogClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Dialog/DialogContext.js

const DialogContext = /*#__PURE__*/(0,react.createContext)({});

if (false) {}

/* harmony default export */ var Dialog_DialogContext = (DialogContext);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js


const Dialog_excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
















const DialogBackdrop = (0,styled/* default */.ZP)(Backdrop_Backdrop, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});

const Dialog_useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,capitalize/* default */.Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,capitalize/* default */.Z)(scroll)}`, `paperWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogUtilityClass, classes);
};

const DialogRoot = (0,styled/* default */.ZP)(Modal_Modal, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,capitalize/* default */.Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,capitalize/* default */.Z)(ownerState.scroll)}`], styles[`paperWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11

}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

const Dialog = /*#__PURE__*/react.forwardRef(function Dialog(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    'aria-describedby': ariaDescribedby,
    'aria-labelledby': ariaLabelledbyProp,
    BackdropComponent,
    BackdropProps,
    children,
    className,
    disableEscapeKeyDown = false,
    fullScreen = false,
    fullWidth = false,
    maxWidth = 'sm',
    onBackdropClick,
    onClose,
    open,
    PaperComponent = Paper/* default */.Z,
    PaperProps = {},
    scroll = 'paper',
    TransitionComponent = Fade_Fade,
    transitionDuration = defaultTransitionDuration,
    TransitionProps
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Dialog_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });

  const classes = Dialog_useUtilityClasses(ownerState);
  const backdropClick = react.useRef();

  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }

    backdropClick.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const ariaLabelledby = (0,useId/* default */.Z)(ariaLabelledbyProp);
  const dialogContextValue = react.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0,esm_extends/* default */.Z)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContainer, {
        className: (0,clsx_m/* default */.Z)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogPaper, (0,esm_extends/* default */.Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog_DialogContext.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Dialog_Dialog = (Dialog);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/DialogContent/dialogContentClasses.js


function getDialogContentUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.ZP)('MuiDialogContent', slot);
}
const dialogContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogContent', ['root', 'dividers']);
/* harmony default export */ var DialogContent_dialogContentClasses = ((/* unused pure expression or super */ null && (dialogContentClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/DialogTitle/dialogTitleClasses.js


function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogTitle', ['root']);
/* harmony default export */ var DialogTitle_dialogTitleClasses = (dialogTitleClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js


const DialogContent_excluded = ["className", "dividers"];










const DialogContent_useUtilityClasses = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogContentUtilityClass, classes);
};

const DialogContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${DialogTitle_dialogTitleClasses.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/react.forwardRef(function DialogContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialogContent'
  });

  const {
    className,
    dividers = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, DialogContent_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    dividers
  });

  const classes = DialogContent_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContent_DialogContent = (DialogContent);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(5084);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./src/configs/app.ts
var app = __webpack_require__(9419);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/layouts/components/menu-list/MenuList.tsx
//** Effect Imports


// ** MUI Imports

// ** Next Imports


// ** Hooks Imports

// ** Source code Imports

const MenuList = (param)=>{
    let { pages  } = param;
    // ** Hooks
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const hash = router.asPath.split("#")[1];
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const filterePages = language === "ru" ? pages.filter((item)=>item.title !== "partners") : pages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filterePages === null || filterePages === void 0 ? void 0 : filterePages.map((page)=>{
            const isActiveItem = !hash ? router.pathname === page.link : "#".concat(hash) === page.link;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    "&.MuiBox-root a": {
                        color: "#fff",
                        textDecoration: "initial",
                        borderBottom: isActiveItem ? "1px solid #fff" : "initial"
                    },
                    "&.MuiBox-root a:hover": {
                        color: "#9000FF",
                        borderBottom: isActiveItem ? "1px solid #9000FF" : "initial"
                    },
                    "@media (max-width:1024px)": {
                        display: "none"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: page.link,
                    children: formatMessage({
                        id: page.title
                    }).toUpperCase()
                })
            }, page.id);
        })
    });
};
/* harmony default export */ var menu_list_MenuList = (MenuList);

;// CONCATENATED MODULE: ./src/layouts/components/menu-list/MobileMenuList.tsx
//** Effect Imports


// ** MUI Imports

// ** Next Imports


// ** Hooks Imports

// ** Source code Imports

const MobileMenuList = (param)=>{
    let { pages , handleClose  } = param;
    // ** Hooks
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const hash = router.asPath.split("#")[1];
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const filterePages = language === "ru" ? pages.filter((item)=>item.title !== "partners") : pages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filterePages === null || filterePages === void 0 ? void 0 : filterePages.map((page)=>{
            const isActiveItem = !hash ? router.pathname === page.link : "#".concat(hash) === page.link;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                onClick: handleClose,
                sx: {
                    width: "fit-content",
                    borderBottom: isActiveItem ? "1px solid #fff" : "initial",
                    "&.MuiBox-root a": {
                        color: "#fff",
                        textDecoration: "none"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: page.link,
                    children: formatMessage({
                        id: page.title
                    }).toUpperCase()
                })
            }, page.id);
        })
    });
};
/* harmony default export */ var menu_list_MobileMenuList = (MobileMenuList);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./src/@core/components/icon/index.tsx
// ** MUI Imports


// ** Icon Imports

const IconifyIcon = (param)=>{
    let { icon , sx , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: sx,
        component: iconify/* Icon */.JO,
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ var icon = (IconifyIcon);

;// CONCATENATED MODULE: ./src/layouts/components/registration-closed/index.tsx
// ** React Imports


// ** Mui Imports

// ** Icon Imports

// ** Effector Imports

// ** Modules Imports


// ** Source code Imports

const RegistrationClosed = (param)=>{
    let { sx  } = param;
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const registration_closed = (0,unleash_react/* useFlag */.P5)("registration_closed");
    const { open  } = (0,effector_react/* useStore */.oR)(global/* default.modalRegistrationClosed */.ZP.modalRegistrationClosed);
    (0,react.useEffect)(()=>{
        (0,global/* changeModalRegistrationStatus */.HI)(registration_closed);
    }, [
        registration_closed
    ]);
    const onClose = ()=>{
        (0,global/* closeModalRegistrationClosed */.aA)();
    };
    if (!open) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: (theme)=>theme.palette.warning.dark,
            width: "100%",
            padding: "15px 0",
            ...sx
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&.MuiContainer-root": {
                    maxWidth: "1200px",
                    padding: "0 0.75rem"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        maxWidth: "850px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#fff",
                        "@media (max-width:1024px)": {
                            maxWidth: "720px"
                        },
                        "@media (max-width:768px)": {
                            fontSize: "12px",
                            mb: "16px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: (theme)=>theme.palette.common.white
                        },
                        children: formatMessage({
                            id: "registration-clossed-warning"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    sx: {
                        color: (theme)=>theme.palette.common.white
                    },
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon, {
                        icon: "mdi:close"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var registration_closed = (RegistrationClosed);

;// CONCATENATED MODULE: ./src/layouts/default-layout/Header.tsx
// ** Next Imports


// ** React Imports

// ** MUI Imports


// ** Hooks Imports


//** Effect Imports

// ** Source code Imports





const { appUrl  } = app/* default */.Z;
const Header = (param)=>{
    let { pages  } = param;
    // ** Hooks
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const [open, setOpen] = (0,react.useState)(false);
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar_AppBar, {
        position: "fixed",
        sx: {
            backgroundColor: "black",
            height: "80px",
            zIndex: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                sx: {
                    "&.MuiContainer-root": {
                        maxWidth: "1222px"
                    },
                    height: "100%",
                    "@media (max-width:1024px)": {
                        "&.MuiContainer-root": {
                            pl: 4,
                            pr: 4
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                    disableGutters: true,
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        height: "100%",
                        "@media (max-width:1024px)": {
                            "&.MuiToolbar-root": {
                                justifyContent: "unset"
                            }
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            size: "large",
                            edge: "start",
                            color: "inherit",
                            "aria-label": "menu",
                            onClick: handleClickOpen,
                            sx: {
                                mr: 2,
                                display: "none",
                                "@media (max-width:1024px)": {
                                    display: "flex"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog, {
                            open: open,
                            onClose: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent_DialogContent, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    background: "black",
                                    p: "19px 16px 40px",
                                    position: "fixed",
                                    top: 0,
                                    right: 0,
                                    width: 1,
                                    height: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        onClick: handleClose,
                                        sx: {
                                            width: "32px",
                                            height: "32px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            position: "absolute",
                                            top: "19px",
                                            right: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    width: "24px",
                                                    height: "3px",
                                                    background: "#909090",
                                                    transform: "rotate(-45deg)",
                                                    position: "absolute"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    width: "24px",
                                                    height: "3px",
                                                    background: "#909090",
                                                    transform: "rotate(45deg)",
                                                    position: "absolute"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            sx: {
                                                p: 0,
                                                mb: "100px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/logo.svg",
                                                alt: "logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "20px",
                                            fontSize: "17px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_list_MobileMenuList, {
                                            pages: pages,
                                            handleClose: handleClose
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "column-reverse",
                                        spacing: 6,
                                        sx: {
                                            mt: "auto"
                                        },
                                        children: [
                                            language === "ru" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                component: (link_default()),
                                                href: "".concat(appUrl, "/register"),
                                                variant: "outlined",
                                                sx: {
                                                    color: "white",
                                                    borderRadius: "0",
                                                    border: "0.5px solid #FFFFFF",
                                                    padding: "11px 12px",
                                                    fontSize: "16px",
                                                    lineHeight: "19px"
                                                },
                                                children: formatMessage({
                                                    id: "sign-up"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                component: (link_default()),
                                                href: "".concat(appUrl, "/login"),
                                                variant: "contained",
                                                sx: {
                                                    background: "#9000FF",
                                                    borderRadius: "0",
                                                    padding: "11px 17px",
                                                    fontSize: "16px",
                                                    lineHeight: "19px"
                                                },
                                                children: formatMessage({
                                                    id: "login"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            width: 1,
                                            zIndex: -1,
                                            "&.MuiBox-root img": {
                                                width: 1
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/mobille-menu/mobile-menu-bg.svg",
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                mr: "auto",
                                "@media (min-width:1025px)": {
                                    "&.MuiBox-root": {
                                        mr: "unset"
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                component: (link_default()),
                                href: "/",
                                sx: {
                                    p: 0,
                                    "&.MuiButtonBase-root": {
                                        borderRadius: "unset"
                                    },
                                    "&.MuiButtonBase-root:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/logo.svg",
                                    alt: "logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                fontSize: "14px",
                                "& .MuiBox-root": {
                                    marginRight: "30px"
                                },
                                "& .MuiBox-root:last-child": {
                                    marginRight: "0px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_list_MenuList, {
                                pages: pages
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 6,
                            children: [
                                language === "ru" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    component: (link_default()),
                                    href: "".concat(appUrl, "/register"),
                                    variant: "outlined",
                                    sx: {
                                        color: "white",
                                        borderRadius: "0",
                                        border: "0.5px solid #FFFFFF",
                                        padding: "11px 12px",
                                        fontSize: "16px",
                                        lineHeight: "19px",
                                        "&.MuiButtonBase-root:hover": {
                                            background: "#9000FF",
                                            color: "#fff"
                                        },
                                        "@media (max-width: 768px)": {
                                            display: "none"
                                        }
                                    },
                                    children: formatMessage({
                                        id: "sign-up"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    component: (link_default()),
                                    href: "".concat(appUrl, "/login"),
                                    variant: "contained",
                                    sx: {
                                        background: "#9000FF",
                                        borderRadius: "0",
                                        padding: "11px 17px",
                                        fontSize: "16px",
                                        lineHeight: "19px",
                                        "&.MuiButtonBase-root:hover": {
                                            background: "#fff",
                                            color: "#9000FF"
                                        }
                                    },
                                    children: formatMessage({
                                        id: "login"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(registration_closed, {
                sx: {
                    position: "absolute",
                    top: "100%"
                }
            })
        ]
    });
};
/* harmony default export */ var default_layout_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(5214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(3265);
;// CONCATENATED MODULE: ./src/layouts/components/footer-bottom-list/FooterBottomList.tsx
//** Effect Imports


// ** Next Imports

// ** MUI Imports

// ** Source code Imports


const FooterBottomList = (param)=>{
    let { menuList  } = param;
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    if (language === "en") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuList.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                sx: {
                    p: 0,
                    width: "unset",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: (link_default()),
                        href: item.link,
                        target: item.target,
                        sx: {
                            "&:hover": {
                                color: "#fff"
                            },
                            width: "max-content",
                            fontSize: 15,
                            color: "inherit",
                            textDecoration: "none",
                            "@media (max-width:768px)": {
                                fontSize: 13
                            }
                        },
                        children: formatMessage({
                            id: item.text
                        })
                    }),
                    index !== menuList.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            right: "-25px",
                            width: "1px",
                            height: "12px",
                            background: "#5c5c5c",
                            "@media (max-width:1024px)": {
                                right: "-33%"
                            },
                            "@media (max-width:700px)": {
                                display: "none"
                            }
                        }
                    })
                ]
            }, item.id))
    });
};
/* harmony default export */ var footer_bottom_list_FooterBottomList = (FooterBottomList);

;// CONCATENATED MODULE: ./src/layouts/default-layout/Footer.tsx
// ** React Imports


//** Effect Imports

// ** Next Imports


// ** MUI Imports

// ** Hooks Imports

// ** Source code Imports


const Footer = (param)=>{
    let { socials , pages , menuList  } = param;
    // ** Hooks
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const hash = router.asPath.split("#")[1];
    const currentYear = (0,react.useMemo)(()=>new Date().getFullYear(), []);
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const filterePages = language === "ru" ? pages.filter((item)=>item.title !== "partners") : pages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            pb: "55px",
            color: "#5c5c5c",
            "@media (max-width:768px)": {
                pb: "70px"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                sx: {
                    "&.MuiContainer-root": {
                        maxWidth: "1222px"
                    },
                    "@media (max-width:1024px)": {
                        pl: 4,
                        pr: 4
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #5c5c5c",
                        pb: "32px",
                        "@media (max-width:900px)": {
                            flexDirection: "column-reverse",
                            alignItems: "flex-start"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                gap: "4px",
                                "& .MuiButtonBase-root:hover": {
                                    backgroundColor: "transparent"
                                },
                                "@media (max-width:900px)": {
                                    "&.MuiBox-root": {
                                        mt: "36px"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        display: "contents"
                                    },
                                    component: (link_default()),
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/logo.svg",
                                        alt: "logo"
                                    })
                                }),
                                socials.map((social)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        sx: {
                                            "&.MuiButtonBase-root:hover svg path": {
                                                fill: "#9000FF"
                                            }
                                        },
                                        LinkComponent: (link_default()),
                                        href: social.link,
                                        target: "_blank",
                                        children: social.svg
                                    }, social.id))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                fontSize: "14px",
                                zIndex: "3",
                                "@media (max-width:768px)": {
                                    flexDirection: "column",
                                    maxHeight: "150px",
                                    flexWrap: "wrap"
                                }
                            },
                            children: filterePages === null || filterePages === void 0 ? void 0 : filterePages.map((page)=>{
                                const isActiveItem = !hash ? router.pathname === page.link : "#".concat(hash) === page.link;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        marginRight: "30px",
                                        "&.MuiBox-root:last-child": {
                                            marginRight: "0"
                                        },
                                        "&.MuiBox-root a": {
                                            color: "inherit",
                                            textDecoration: "initial",
                                            borderBottom: isActiveItem ? "1px solid #5c5c5c" : "initial"
                                        },
                                        "&.MuiBox-root a:hover": {
                                            color: "#fff",
                                            borderBottom: isActiveItem ? "1px solid #fff" : "initial"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: page.link,
                                        children: formatMessage({
                                            id: page.title
                                        }).toUpperCase()
                                    })
                                }, page.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    pt: "5px",
                    "&.MuiContainer-root": {
                        pl: 0,
                        pr: 0
                    },
                    "@media (max-width:1224px)": {
                        "&.MuiContainer-root": {
                            flexDirection: "column-reverse",
                            pl: 4,
                            pr: 4
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            fontSize: "15px",
                            "&.MuiTypography-root": {
                                color: "inherit"
                            }
                        },
                        children: [
                            formatMessage({
                                id: "copyright"
                            }, {
                                year: "2023-".concat(currentYear)
                            }),
                            ". ",
                            formatMessage({
                                id: "all-right-reserved"
                            }),
                            ".",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                style: {
                                    marginLeft: 8,
                                    opacity: 0.5
                                },
                                children: [
                                    "v.",
                                    "0.1.31"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        sx: {
                            display: "flex",
                            gap: "50px",
                            "& .MuiListItem-root:nth-of-type(2) .MuiBox-root": {
                                display: "none"
                            },
                            "& .MuiListItem-root:nth-of-type(2) .MuiTypography-root": {
                                mr: 0
                            },
                            "@media (max-width:1024px)": {
                                gap: "0px",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                overflow: "hidden",
                                "& .MuiListItem-root:nth-of-type(3)": {
                                    width: "unset"
                                }
                            },
                            "@media (max-width: 768px)": {
                                flexDirection: "column"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_list_FooterBottomList, {
                            menuList: menuList
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var default_layout_Footer = (Footer);

;// CONCATENATED MODULE: ./src/layouts/default-layout/opts.tsx

const socials = [
    // {
    //   id: 'YouTube',
    //   svg: (
    //     <svg width='41' height='29' viewBox='0 0 41 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
    //       <path
    //         fillRule='evenodd'
    //         clipRule='evenodd'
    //         d='M36.5179 0.866181C38.283 1.3436 39.6703 2.74518 40.1427 4.5287C40.9966 7.75811 41 14.5 41 14.5C41 14.5 41 21.2419 40.1427 24.4714C39.6703 26.2549 38.283 27.6564 36.5179 28.1338C33.3218 29 20.4999 29 20.4999 29C20.4999 29 7.67821 29 4.48204 28.1338C2.71691 27.6564 1.32977 26.2549 0.85726 24.4714C0 21.2419 0 14.5 0 14.5C0 14.5 0 7.75811 0.85726 4.5287C1.32977 2.74518 2.71691 1.3436 4.48204 0.866181C7.67821 0 20.4999 0 20.4999 0C20.4999 0 33.3218 0 36.5179 0.866181ZM27.0478 14.5007L16.3961 20.714V8.28735L27.0478 14.5007Z'
    //         fill='#909090'
    //       />
    //       <path
    //         fillRule='evenodd'
    //         clipRule='evenodd'
    //         d='M36.5179 0.866181C38.283 1.3436 39.6703 2.74518 40.1427 4.5287C40.9966 7.75811 41 14.5 41 14.5C41 14.5 41 21.2419 40.1427 24.4714C39.6703 26.2549 38.283 27.6564 36.5179 28.1338C33.3218 29 20.4999 29 20.4999 29C20.4999 29 7.67821 29 4.48204 28.1338C2.71691 27.6564 1.32977 26.2549 0.85726 24.4714C0 21.2419 0 14.5 0 14.5C0 14.5 0 7.75811 0.85726 4.5287C1.32977 2.74518 2.71691 1.3436 4.48204 0.866181C7.67821 0 20.4999 0 20.4999 0C20.4999 0 33.3218 0 36.5179 0.866181ZM27.0478 14.5007L16.3961 20.714V8.28735L27.0478 14.5007Z'
    //         fill='black'
    //         fillOpacity='0.2'
    //       />
    //     </svg>
    //   ),
    //   link: 'https://www.youtube.com/@SILKmuz'
    // },
    {
        id: "VK",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "28",
            height: "29",
            viewBox: "0 0 28 29",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.96824 2.03853C0 4.07706 0 7.35797 0 13.92V15.08C0 21.642 0 24.9229 1.96824 26.9615C3.93647 29 7.10429 29 13.44 29H14.56C20.8957 29 24.0635 29 26.0318 26.9615C28 24.9229 28 21.642 28 15.08V13.92C28 7.35797 28 4.07706 26.0318 2.03853C24.0635 0 20.8957 0 14.56 0H13.44C7.10429 0 3.93647 0 1.96824 2.03853ZM4.66668 8.63097C4.81827 16.3941 8.45593 21.0595 14.8336 21.0595H15.1952V16.6182C17.5387 16.8669 19.3108 18.6958 20.0219 21.0595H23.3334C22.4239 17.5264 20.0336 15.573 18.5412 14.8266C20.0336 13.906 22.1323 11.6666 22.6337 8.63097H19.6255C18.9725 11.0943 17.0373 13.3337 15.1952 13.5453V8.63097H12.1869V17.2402C10.3214 16.7424 7.9663 14.329 7.86137 8.63097H4.66668Z",
                    fill: "#909090"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.96824 2.03853C0 4.07706 0 7.35797 0 13.92V15.08C0 21.642 0 24.9229 1.96824 26.9615C3.93647 29 7.10429 29 13.44 29H14.56C20.8957 29 24.0635 29 26.0318 26.9615C28 24.9229 28 21.642 28 15.08V13.92C28 7.35797 28 4.07706 26.0318 2.03853C24.0635 0 20.8957 0 14.56 0H13.44C7.10429 0 3.93647 0 1.96824 2.03853ZM4.66668 8.63097C4.81827 16.3941 8.45593 21.0595 14.8336 21.0595H15.1952V16.6182C17.5387 16.8669 19.3108 18.6958 20.0219 21.0595H23.3334C22.4239 17.5264 20.0336 15.573 18.5412 14.8266C20.0336 13.906 22.1323 11.6666 22.6337 8.63097H19.6255C18.9725 11.0943 17.0373 13.3337 15.1952 13.5453V8.63097H12.1869V17.2402C10.3214 16.7424 7.9663 14.329 7.86137 8.63097H4.66668Z",
                    fill: "black",
                    fillOpacity: "0.2"
                })
            ]
        }),
        link: "https://vk.com/gosilk_ru"
    },
    {
        id: "Telegram",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "29",
            height: "29",
            viewBox: "0 0 29 29",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29 14.5C29 22.5081 22.5081 29 14.5 29C6.49187 29 0 22.5081 0 14.5C0 6.49187 6.49187 0 14.5 0C22.5081 0 29 6.49187 29 14.5ZM9.41507 13.0865C7.9556 13.7187 6.45601 14.3683 5.08477 15.1177C4.36875 15.6378 5.3204 16.0058 6.21318 16.3508C6.3551 16.4057 6.49555 16.46 6.62757 16.5142C6.73743 16.5477 6.84915 16.5831 6.96235 16.6187C7.9553 16.9327 9.0625 17.2827 10.0265 16.7562C11.61 15.8537 13.1044 14.8103 14.5977 13.7678C15.087 13.4261 15.576 13.0847 16.0682 12.7483C16.0912 12.7336 16.1172 12.7168 16.1456 12.6985C16.5649 12.429 17.5076 11.8226 17.1589 12.6581C16.3343 13.5529 15.4509 14.3448 14.5629 15.1412C13.9644 15.6778 13.3636 16.2165 12.7773 16.7898C12.2664 17.2016 11.7362 18.0296 12.308 18.6061C13.6252 19.5209 14.9631 20.4137 16.3002 21.3059C16.7352 21.5962 17.1702 21.8864 17.6045 22.1775C18.3403 22.7604 19.4903 22.2888 19.6521 21.3779C19.7241 20.959 19.7964 20.54 19.8686 20.1209C20.2678 17.8054 20.6671 15.489 21.0199 13.166C21.0678 12.8016 21.1221 12.4372 21.1765 12.0727C21.3083 11.1891 21.4403 10.3044 21.4815 9.41607C21.3752 8.52957 20.2919 8.72449 19.6888 8.92382C16.5897 10.0938 13.5215 11.3505 10.4655 12.6294C10.1193 12.7815 9.76834 12.9336 9.41507 13.0865Z",
                    fill: "#909090"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29 14.5C29 22.5081 22.5081 29 14.5 29C6.49187 29 0 22.5081 0 14.5C0 6.49187 6.49187 0 14.5 0C22.5081 0 29 6.49187 29 14.5ZM9.41507 13.0865C7.9556 13.7187 6.45601 14.3683 5.08477 15.1177C4.36875 15.6378 5.3204 16.0058 6.21318 16.3508C6.3551 16.4057 6.49555 16.46 6.62757 16.5142C6.73743 16.5477 6.84915 16.5831 6.96235 16.6187C7.9553 16.9327 9.0625 17.2827 10.0265 16.7562C11.61 15.8537 13.1044 14.8103 14.5977 13.7678C15.087 13.4261 15.576 13.0847 16.0682 12.7483C16.0912 12.7336 16.1172 12.7168 16.1456 12.6985C16.5649 12.429 17.5076 11.8226 17.1589 12.6581C16.3343 13.5529 15.4509 14.3448 14.5629 15.1412C13.9644 15.6778 13.3636 16.2165 12.7773 16.7898C12.2664 17.2016 11.7362 18.0296 12.308 18.6061C13.6252 19.5209 14.9631 20.4137 16.3002 21.3059C16.7352 21.5962 17.1702 21.8864 17.6045 22.1775C18.3403 22.7604 19.4903 22.2888 19.6521 21.3779C19.7241 20.959 19.7964 20.54 19.8686 20.1209C20.2678 17.8054 20.6671 15.489 21.0199 13.166C21.0678 12.8016 21.1221 12.4372 21.1765 12.0727C21.3083 11.1891 21.4403 10.3044 21.4815 9.41607C21.3752 8.52957 20.2919 8.72449 19.6888 8.92382C16.5897 10.0938 13.5215 11.3505 10.4655 12.6294C10.1193 12.7815 9.76834 12.9336 9.41507 13.0865Z",
                    fill: "black",
                    fillOpacity: "0.2"
                })
            ]
        }),
        link: "https://t.me/gosilkru"
    }
];
const pages = [
    {
        id: 1,
        title: "main",
        link: "/"
    },
    {
        id: 2,
        title: "how-work",
        link: "/#services"
    },
    {
        id: 3,
        title: "artists",
        link: "/#artists"
    },
    // {
    //   id: 4,
    //   title: 'sites',
    //   link: '/platforms'
    // },
    {
        id: 4,
        title: "news",
        link: "/news"
    },
    //
    // {
    //   id: 6,
    //   title: 'reviews',
    //   link: '#reviews'
    // },
    {
        id: 5,
        title: "partners",
        link: "#partners"
    }
];
const menuList = [
    {
        id: 1,
        text: "cookie-policy",
        link: "/cookie-policy",
        target: "_blank"
    },
    {
        id: 2,
        text: "privacy-policy",
        link: "/privacy-policy",
        target: "_blank"
    }
];

;// CONCATENATED MODULE: ./src/layouts/default-layout/index.tsx
// ** React Imports



// ** Mui Imports

//** Effect Imports

// ** Source code Imports




const DefaultLayout = (param)=>{
    let { sx , children  } = param;
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const isLandingNewsAvailableFlag = (0,unleash_react/* useFlag */.P5)("is_landing_news_available");
    const isLandingNewsAvailable = isLandingNewsAvailableFlag && language !== "en";
    const visiblePages = (0,react.useMemo)(()=>{
        return isLandingNewsAvailable ? pages : pages.filter((page)=>page.title !== "news");
    }, [
        isLandingNewsAvailable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            background: "black",
            overflowX: "hidden",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(default_layout_Header, {
                pages: visiblePages
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(default_layout_Footer, {
                socials: socials,
                pages: visiblePages,
                menuList: menuList
            })
        ]
    });
};
/* harmony default export */ var default_layout = (DefaultLayout);


/***/ }),

/***/ 9746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@next/third-parties/dist/google/index.js
var google = __webpack_require__(9692);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(4865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var emotion_element_6a883da9_browser_esm = __webpack_require__(2443);
// EXTERNAL MODULE: ./src/configs/themeConfig.ts
var themeConfig = __webpack_require__(9734);
;// CONCATENATED MODULE: ./src/configs/feature-flag.ts
const config = {
    url: "".concat("https://features.emd.one/silk-landing", "/").concat("production"),
    clientKey: "W5VKcazJZa" || 0,
    environment: "production",
    refreshInterval: 15,
    appName: "silk-landing" || 0
};
/* harmony default export */ var feature_flag = (config);

// EXTERNAL MODULE: ./node_modules/next-yandex-metrica/dist/index.js
var dist = __webpack_require__(9024);
;// CONCATENATED MODULE: ./node_modules/goober/dist/goober.modern.js
let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,r=e=>{let r=t(e),l=r.data;return r.data="",l},l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";")}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return"go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d)}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e)})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e}return e+l+(null==n?"":n)},"");function u(e){let r=this||{},l=e.call?e(r.p):e;return i(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let d,f,g,b=u.bind({g:1}),h=u.bind({k:1});function m(e,t,r,l){o.p=t,d=e,f=r,g=l}function j(e,t){let r=this||{};return function(){let l=arguments;function a(n,o){let c=Object.assign({},n),s=c.className||a.className;r.p=Object.assign({theme:f&&f()},c),r.o=/ *go\d+/.test(s),c.className=u.apply(r,l)+(s?" "+s:""),t&&(c.ref=o);let i=e;return e[0]&&(i=c.as||e,delete c.as),g&&i[0]&&g(c),d(i,c)}return t?t(a):a}}

;// CONCATENATED MODULE: ./node_modules/react-hot-toast/dist/index.mjs
var W=e=>typeof e=="function",T=(e,t)=>W(e)?e(t):e;var U=(()=>{let e=0;return()=>(++e).toString()})(),dist_b=(()=>{let e;return()=>{if(e===void 0&&typeof window<"u"){let t=matchMedia("(prefers-reduced-motion: reduce)");e=!t||t.matches}return e}})();var Q=20;var S=new Map,X=1e3,$=e=>{if(S.has(e))return;let t=setTimeout(()=>{S.delete(e),dist_u({type:4,toastId:e})},X);S.set(e,t)},J=e=>{let t=S.get(e);t&&clearTimeout(t)},v=(e,t)=>{switch(t.type){case 0:return{...e,toasts:[t.toast,...e.toasts].slice(0,Q)};case 1:return t.toast.id&&J(t.toast.id),{...e,toasts:e.toasts.map(r=>r.id===t.toast.id?{...r,...t.toast}:r)};case 2:let{toast:o}=t;return e.toasts.find(r=>r.id===o.id)?v(e,{type:1,toast:o}):v(e,{type:0,toast:o});case 3:let{toastId:s}=t;return s?$(s):e.toasts.forEach(r=>{$(r.id)}),{...e,toasts:e.toasts.map(r=>r.id===s||s===void 0?{...r,visible:!1}:r)};case 4:return t.toastId===void 0?{...e,toasts:[]}:{...e,toasts:e.toasts.filter(r=>r.id!==t.toastId)};case 5:return{...e,pausedAt:t.time};case 6:let a=t.time-(e.pausedAt||0);return{...e,pausedAt:void 0,toasts:e.toasts.map(r=>({...r,pauseDuration:r.pauseDuration+a}))}}},A=[],P={toasts:[],pausedAt:void 0},dist_u=e=>{P=v(P,e),A.forEach(t=>{t(P)})},Y={blank:4e3,error:4e3,success:2e3,loading:1/0,custom:4e3},I=(e={})=>{let[t,o]=(0,react.useState)(P);(0,react.useEffect)(()=>(A.push(o),()=>{let a=A.indexOf(o);a>-1&&A.splice(a,1)}),[t]);let s=t.toasts.map(a=>{var r,c;return{...e,...e[a.type],...a,duration:a.duration||((r=e[a.type])==null?void 0:r.duration)||(e==null?void 0:e.duration)||Y[a.type],style:{...e.style,...(c=e[a.type])==null?void 0:c.style,...a.style}}});return{...t,toasts:s}};var G=(e,t="blank",o)=>({createdAt:Date.now(),visible:!0,type:t,ariaProps:{role:"status","aria-live":"polite"},message:e,pauseDuration:0,...o,id:(o==null?void 0:o.id)||U()}),dist_h=e=>(t,o)=>{let s=G(t,e,o);return dist_u({type:2,toast:s}),s.id},dist_n=(e,t)=>dist_h("blank")(e,t);dist_n.error=dist_h("error");dist_n.success=dist_h("success");dist_n.loading=dist_h("loading");dist_n.custom=dist_h("custom");dist_n.dismiss=e=>{dist_u({type:3,toastId:e})};dist_n.remove=e=>dist_u({type:4,toastId:e});dist_n.promise=(e,t,o)=>{let s=dist_n.loading(t.loading,{...o,...o==null?void 0:o.loading});return e.then(a=>(dist_n.success(T(t.success,a),{id:s,...o,...o==null?void 0:o.success}),a)).catch(a=>{dist_n.error(T(t.error,a),{id:s,...o,...o==null?void 0:o.error})}),e};var Z=(e,t)=>{dist_u({type:1,toast:{id:e,height:t}})},ee=()=>{dist_u({type:5,time:Date.now()})},D=e=>{let{toasts:t,pausedAt:o}=I(e);(0,react.useEffect)(()=>{if(o)return;let r=Date.now(),c=t.map(i=>{if(i.duration===1/0)return;let d=(i.duration||0)+i.pauseDuration-(r-i.createdAt);if(d<0){i.visible&&dist_n.dismiss(i.id);return}return setTimeout(()=>dist_n.dismiss(i.id),d)});return()=>{c.forEach(i=>i&&clearTimeout(i))}},[t,o]);let s=(0,react.useCallback)(()=>{o&&dist_u({type:6,time:Date.now()})},[o]),a=(0,react.useCallback)((r,c)=>{let{reverseOrder:i=!1,gutter:d=8,defaultPosition:p}=c||{},g=t.filter(m=>(m.position||p)===(r.position||p)&&m.height),E=g.findIndex(m=>m.id===r.id),x=g.filter((m,R)=>R<E&&m.visible).length;return g.filter(m=>m.visible).slice(...i?[x+1]:[0,x]).reduce((m,R)=>m+(R.height||0)+d,0)},[t]);return{toasts:t,handlers:{updateHeight:Z,startPause:ee,endPause:s,calculateOffset:a}}};var oe=h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,re=h`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,se=h`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,_=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e=>e.secondary||"#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;var ne=h`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,V=j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e=>e.secondary||"#e0e0e0"};
  border-right-color: ${e=>e.primary||"#616161"};
  animation: ${ne} 1s linear infinite;
`;var pe=h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,de=h`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,w=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${de} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e=>e.secondary||"#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;var ue=j("div")`
  position: absolute;
`,le=j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,Te=h`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,fe=j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Te} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,M=({toast:e})=>{let{icon:t,type:o,iconTheme:s}=e;return t!==void 0?typeof t=="string"?react.createElement(fe,null,t):t:o==="blank"?null:react.createElement(le,null,react.createElement(V,{...s}),o!=="loading"&&react.createElement(ue,null,o==="error"?react.createElement(_,{...s}):react.createElement(w,{...s})))};var ye=e=>`
0% {transform: translate3d(0,${e*-200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`,ge=e=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e*-150}%,-1px) scale(.6); opacity:0;}
`,he="0%{opacity:0;} 100%{opacity:1;}",xe="0%{opacity:1;} 100%{opacity:0;}",be=j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,Se=j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,Ae=(e,t)=>{let s=e.includes("top")?1:-1,[a,r]=dist_b()?[he,xe]:[ye(s),ge(s)];return{animation:t?`${h(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards`:`${h(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`}},F=react.memo(({toast:e,position:t,style:o,children:s})=>{let a=e.height?Ae(e.position||t||"top-center",e.visible):{opacity:0},r=react.createElement(M,{toast:e}),c=react.createElement(Se,{...e.ariaProps},T(e.message,e));return react.createElement(be,{className:e.className,style:{...a,...o,...e.style}},typeof s=="function"?s({icon:r,message:c}):react.createElement(react.Fragment,null,r,c))});m(react.createElement);var Ee=({id:e,className:t,style:o,onHeightUpdate:s,children:a})=>{let r=react.useCallback(c=>{if(c){let i=()=>{let d=c.getBoundingClientRect().height;s(e,d)};i(),new MutationObserver(i).observe(c,{subtree:!0,childList:!0,characterData:!0})}},[e,s]);return react.createElement("div",{ref:r,className:t,style:o},a)},Re=(e,t)=>{let o=e.includes("top"),s=o?{top:0}:{bottom:0},a=e.includes("center")?{justifyContent:"center"}:e.includes("right")?{justifyContent:"flex-end"}:{};return{left:0,right:0,display:"flex",position:"absolute",transition:dist_b()?void 0:"all 230ms cubic-bezier(.21,1.02,.73,1)",transform:`translateY(${t*(o?1:-1)}px)`,...s,...a}},ve=u`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,O=16,Ie=({reverseOrder:e,position:t="top-center",toastOptions:o,gutter:s,children:a,containerStyle:r,containerClassName:c})=>{let{toasts:i,handlers:d}=D(o);return react.createElement("div",{style:{position:"fixed",zIndex:9999,top:O,left:O,right:O,bottom:O,pointerEvents:"none",...r},className:c,onMouseEnter:d.startPause,onMouseLeave:d.endPause},i.map(p=>{let g=p.position||t,E=d.calculateOffset(p,{reverseOrder:e,gutter:s,defaultPosition:t}),x=Re(g,E);return react.createElement(Ee,{id:p.id,key:p.id,onHeightUpdate:d.updateHeight,className:p.visible?ve:"",style:x},p.type==="custom"?T(p.message,p):a?a(p):react.createElement(F,{toast:p,position:g}))}))};var _t=(/* unused pure expression or super */ null && (dist_n));
//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(8884);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/GlobalStyles/GlobalStyles.js
'use client';





function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_react_browser_esm/* Global */.xB, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(6682);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js
'use client';






function GlobalStyles_GlobalStyles({
  styles,
  themeId,
  defaultTheme = {}
}) {
  const upperTheme = (0,useTheme/* default */.Z)(defaultTheme);
  const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalStyles, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;
/* harmony default export */ var esm_GlobalStyles_GlobalStyles = (GlobalStyles_GlobalStyles);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(5165);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/GlobalStyles/GlobalStyles.js







function GlobalStyles_GlobalStyles_GlobalStyles(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_GlobalStyles_GlobalStyles, (0,esm_extends/* default */.Z)({}, props, {
    defaultTheme: defaultTheme/* default */.Z
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var material_esm_GlobalStyles_GlobalStyles = (GlobalStyles_GlobalStyles_GlobalStyles);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/CssBaseline/CssBaseline.js







const html = (theme, enableColorScheme) => (0,esm_extends/* default */.Z)({
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box',
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: '100%'
}, enableColorScheme && !theme.vars && {
  colorScheme: theme.palette.mode
});
const body = theme => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.primary
}, theme.typography.body1, {
  backgroundColor: (theme.vars || theme).palette.background.default,
  '@media print': {
    // Save printer ink.
    backgroundColor: (theme.vars || theme).palette.common.white
  }
});
const styles = (theme, enableColorScheme = false) => {
  var _theme$components, _theme$components$Mui;

  const colorSchemeStyles = {};

  if (enableColorScheme && theme.colorSchemes) {
    Object.entries(theme.colorSchemes).forEach(([key, scheme]) => {
      var _scheme$palette;

      colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
        colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
      };
    });
  }

  let defaultStyles = (0,esm_extends/* default */.Z)({
    html: html(theme, enableColorScheme),
    '*, *::before, *::after': {
      boxSizing: 'inherit'
    },
    'strong, b': {
      fontWeight: theme.typography.fontWeightBold
    },
    body: (0,esm_extends/* default */.Z)({
      margin: 0
    }, body(theme), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      '&::backdrop': {
        backgroundColor: (theme.vars || theme).palette.background.default
      }
    })
  }, colorSchemeStyles);

  const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;

  if (themeOverrides) {
    defaultStyles = [defaultStyles, themeOverrides];
  }

  return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCssBaseline'
  });
  const {
    children,
    enableColorScheme = false
  } = props;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(material_esm_GlobalStyles_GlobalStyles, {
      styles: theme => styles(theme, enableColorScheme)
    }), children]
  });
}

 false ? 0 : void 0;
/* harmony default export */ var CssBaseline_CssBaseline = (CssBaseline);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/createTheme.js + 14 modules
var createTheme = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(6535);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/cssUtils.js
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    let pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    } // Convert length in pixels to the output unit


    let outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid
}) {
  const sizeBelow = size - size % grid;
  const sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid({
  lineHeight,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 900, 1200],
  transform = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(breakpoint => {
    let value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
    };
  });
  return output;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/styles/responsiveFontSizes.js



function responsiveFontSizes(themeInput, options = {}) {
  const {
    breakpoints = ['sm', 'md', 'lg'],
    disableAlign = false,
    factor = 2,
    variants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']
  } = options;

  const theme = (0,esm_extends/* default */.Z)({}, themeInput);

  theme.typography = (0,esm_extends/* default */.Z)({}, theme.typography);
  const typography = theme.typography; // Convert between CSS lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  const convert = convertLength(typography.htmlFontSize);
  const breakpointValues = breakpoints.map(x => theme.breakpoints.values[x]);
  variants.forEach(variant => {
    const style = typography[variant];
    const remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    const maxFontSize = remFontSize;
    const minFontSize = 1 + (maxFontSize - 1) / factor;
    let {
      lineHeight
    } = style;

    if (!isUnitless(lineHeight) && !disableAlign) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(6));
    }

    if (!isUnitless(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    let transform = null;

    if (!disableAlign) {
      transform = value => alignProperty({
        size: value,
        grid: fontGrid({
          pixels: 4,
          lineHeight,
          htmlFontSize: typography.htmlFontSize
        })
      });
    }

    typography[variant] = (0,esm_extends/* default */.Z)({}, style, responsiveProperty({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform
    }));
  });
  return theme;
}
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/useTheme/ThemeContext.js

const ThemeContext = /*#__PURE__*/react.createContext(null);
if (false) {}
/* harmony default export */ var useTheme_ThemeContext = (ThemeContext);
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/useTheme/useTheme.js


function useTheme_useTheme() {
  const theme = react.useContext(useTheme_ThemeContext);
  if (false) {}
  return theme;
}
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/ThemeProvider/nested.js
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ var nested = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/ThemeProvider/ThemeProvider.js








// To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (false) {}
    return mergedTheme;
  }
  return (0,esm_extends/* default */.Z)({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme_useTheme();
  if (false) {}
  const theme = react.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(useTheme_ThemeContext.Provider, {
    value: theme,
    children: children
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(4168);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/RtlProvider/index.js


const _excluded = ["value"];



const RtlContext = /*#__PURE__*/react.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RtlContext.Provider, (0,esm_extends/* default */.Z)({
    value: value != null ? value : true
  }, props));
}
 false ? 0 : void 0;
const useRtl = () => {
  const value = React.useContext(RtlContext);
  return value != null ? value : false;
};
/* harmony default export */ var esm_RtlProvider = (RtlProvider);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/DefaultPropsProvider/DefaultPropsProvider.js
'use client';





const PropsContext = /*#__PURE__*/react.createContext(undefined);
function DefaultPropsProvider({
  value,
  children
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PropsContext.Provider, {
    value: value,
    children: children
  });
}
 false ? 0 : void 0;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config = theme.components[name];
  if (config.defaultProps) {
    // compatible with v5 signature
    return resolveProps(config.defaultProps, props);
  }
  if (!config.styleOverrides && !config.variants) {
    // v6 signature, no property 'defaultProps'
    return resolveProps(config, props);
  }
  return props;
}
function useDefaultProps({
  props,
  name
}) {
  const ctx = React.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
/* harmony default export */ var DefaultPropsProvider_DefaultPropsProvider = (DefaultPropsProvider);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js
'use client';











const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return react.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
      [themeId]: localTheme
    }) : (0,esm_extends/* default */.Z)({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider_ThemeProvider_ThemeProvider(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = (0,useThemeWithoutDefault/* default */.Z)(EMPTY_THEME);
  const upperPrivateTheme = useTheme_useTheme() || EMPTY_THEME;
  if (false) {}
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider_ThemeProvider, {
    theme: privateTheme,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_element_6a883da9_browser_esm.T.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_RtlProvider, {
        value: rtlValue,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DefaultPropsProvider_DefaultPropsProvider, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children: children
        })
      })
    })
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var esm_ThemeProvider_ThemeProvider = (ThemeProvider_ThemeProvider_ThemeProvider);
// EXTERNAL MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
var emotion_sheet_browser_esm = __webpack_require__(1526);
;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new emotion_sheet_browser_esm/* StyleSheet */.m({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);

// EXTERNAL MODULE: ./node_modules/cssjanus/src/cssjanus.js
var cssjanus = __webpack_require__(3832);
var cssjanus_default = /*#__PURE__*/__webpack_require__.n(cssjanus);
;// CONCATENATED MODULE: ./node_modules/stylis-plugin-rtl/dist/stylis-rtl.js


function stringifyPreserveComments(element, index, children) {
    switch (element.type) {
        case IMPORT:
        case Enum_DECLARATION:
        case COMMENT:
            return (element.return = element.return || element.value);
        case Enum_RULESET: {
            element.value = Array.isArray(element.props) ? element.props.join(',') : element.props;
            if (Array.isArray(element.children)) {
                element.children.forEach(function (x) {
                    if (x.type === COMMENT)
                        x.children = x.value;
                });
            }
        }
    }
    var serializedChildren = Serializer_serialize(Array.prototype.concat(element.children), stringifyPreserveComments);
    return Utility_strlen(serializedChildren) ? (element.return = element.value + '{' + serializedChildren + '}') : '';
}
function stylisRTLPlugin(element, index, children, callback) {
    if (element.type === Enum_KEYFRAMES ||
        element.type === SUPPORTS ||
        (element.type === Enum_RULESET && (!element.parent || element.parent.type === MEDIA || element.parent.type === Enum_RULESET))) {
        var stringified = cssjanus_default().transform(stringifyPreserveComments(element, index, children));
        element.children = stringified ? compile(stringified)[0].children : [];
        element.return = '';
    }
}
// stable identifier that will not be dropped by minification unless the whole module
// is unused
Object.defineProperty(stylisRTLPlugin, 'name', { value: 'stylisRTLPlugin' });
/* harmony default export */ var stylis_rtl = (stylisRTLPlugin);
//# sourceMappingURL=stylis-rtl.js.map
;// CONCATENATED MODULE: ./src/layouts/components/Direction.tsx
// ** React Imports


// ** Emotion Imports


// ** RTL Plugin

const styleCache = ()=>emotion_cache_browser_esm({
        key: "rtl",
        prepend: true,
        stylisPlugins: [
            stylis_rtl
        ]
    });
const Direction = (props)=>{
    const { children , direction  } = props;
    (0,react.useEffect)(()=>{
        document.dir = direction;
    }, [
        direction
    ]);
    if (direction === "rtl") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_element_6a883da9_browser_esm.C, {
            value: styleCache(),
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var components_Direction = (Direction);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/card.ts
// ** MUI Imports
const Card = (theme, skin)=>{
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: theme.shadows[0],
                    ...skin === "bordered" && {
                        border: "1px solid ".concat(theme.palette.divider)
                    },
                    "& .card-more-options": {
                        marginTop: theme.spacing(-1),
                        marginRight: theme.spacing(-3)
                    },
                    "& .MuiTableContainer-root, & .MuiDataGrid-root, & .MuiDataGrid-columnHeaders": {
                        borderRadius: 0
                    }
                }
            },
            defaultProps: {
                elevation: skin === "bordered" ? 0 : 6
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "& + .MuiCardContent-root, & + .MuiCardActions-root, & + .MuiCollapse-root .MuiCardContent-root": {
                        paddingTop: 0
                    },
                    "& .MuiCardHeader-subheader": {
                        fontSize: "0.875rem",
                        color: theme.palette.text.secondary
                    }
                },
                title: {
                    lineHeight: 1.6,
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    letterSpacing: "0.15px",
                    "@media (min-width:600px)": {
                        fontSize: "1.25rem"
                    }
                },
                action: {
                    marginTop: 0,
                    marginRight: 0
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "& + .MuiCardHeader-root, & + .MuiCardContent-root, & + .MuiCardActions-root": {
                        paddingTop: 0
                    },
                    "&:last-of-type": {
                        paddingBottom: theme.spacing(5)
                    }
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "& .MuiButton-text": {
                        paddingLeft: theme.spacing(2.5),
                        paddingRight: theme.spacing(2.5)
                    },
                    "&.card-action-dense": {
                        padding: theme.spacing(0, 2.5, 2.5),
                        ".MuiCard-root .MuiCardMedia-root + &": {
                            paddingTop: theme.spacing(2.5)
                        }
                    },
                    ".MuiCard-root &:first-of-type": {
                        paddingTop: theme.spacing(2.5),
                        "& + .MuiCardHeader-root, & + .MuiCardContent-root, & + .MuiCardActions-root": {
                            paddingTop: 0
                        }
                    }
                }
            }
        }
    };
};
/* harmony default export */ var card = (Card);

;// CONCATENATED MODULE: ./src/@core/utils/hex-to-rgba.ts
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};

;// CONCATENATED MODULE: ./src/@core/theme/overrides/chip.ts
// ** MUI Imports
// ** Util Imports

const Chip = (theme)=>{
    return {
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: theme.spacing(0.5),
                    "&.MuiChip-rounded": {
                        borderRadius: theme.spacing(0.5)
                    }
                },
                outlined: {
                    "&.MuiChip-colorDefault": {
                        borderColor: "rgba(".concat(theme.palette.customColors.main, ", 0.22)")
                    }
                },
                deleteIcon: {
                    width: 18,
                    height: 18
                },
                avatar: {
                    color: theme.palette.text.primary
                },
                iconColorDefault: {
                    color: theme.palette.text.primary
                },
                deletableColorPrimary: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.primary.main, 0.7),
                        "&:hover": {
                            color: theme.palette.primary.main
                        }
                    }
                },
                deletableColorSecondary: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.secondary.main, 0.7),
                        "&:hover": {
                            color: theme.palette.secondary.main
                        }
                    }
                },
                deletableColorSuccess: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.success.main, 0.7),
                        "&:hover": {
                            color: theme.palette.success.main
                        }
                    }
                },
                deletableColorError: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.error.main, 0.7),
                        "&:hover": {
                            color: theme.palette.error.main
                        }
                    }
                },
                deletableColorWarning: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.warning.main, 0.7),
                        "&:hover": {
                            color: theme.palette.warning.main
                        }
                    }
                },
                deletableColorInfo: {
                    "&.MuiChip-light .MuiChip-deleteIcon": {
                        color: hexToRGBA(theme.palette.info.main, 0.7),
                        "&:hover": {
                            color: theme.palette.info.main
                        }
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_chip = (Chip);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/link.ts
/* harmony default export */ var overrides_link = ({
    MuiLink: {
        styleOverrides: {
            root: {
                textDecoration: "none"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/@core/theme/overrides/list.ts
// ** MUI Imports
const List = (theme)=>{
    return {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                    marginRight: theme.spacing(2.25),
                    color: theme.palette.text.secondary
                }
            }
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                    marginRight: theme.spacing(4)
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                dense: {
                    "& .MuiListItemText-primary": {
                        color: theme.palette.text.primary
                    }
                }
            }
        },
        MuiListSubheader: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: theme.palette.text.primary
                }
            }
        }
    };
};
/* harmony default export */ var overrides_list = (List);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/menu.ts
// ** MUI Imports
const Menu = (theme, skin)=>{
    const boxShadow = ()=>{
        if (skin === "bordered") {
            return theme.shadows[0];
        } else if (theme.palette.mode === "light") {
            return theme.shadows[8];
        } else return theme.shadows[9];
    };
    return {
        MuiMenu: {
            styleOverrides: {
                root: {
                    "& .MuiMenu-paper": {
                        borderRadius: 5,
                        boxShadow: boxShadow(),
                        ...skin === "bordered" && {
                            border: "1px solid ".concat(theme.palette.divider)
                        }
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_menu = (Menu);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/tabs.ts
// ** MUI Imports
const Tabs = (theme)=>{
    return {
        MuiTabs: {
            styleOverrides: {
                vertical: {
                    minWidth: 130,
                    marginRight: theme.spacing(4),
                    borderRight: "1px solid ".concat(theme.palette.divider),
                    "& .MuiTab-root": {
                        minWidth: 130
                    }
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                textColorSecondary: {
                    "&.Mui-selected": {
                        color: theme.palette.text.secondary
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_tabs = (Tabs);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/input.ts
// ** MUI Imports
const input = (theme)=>{
    return {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.secondary
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    "&:before": {
                        borderBottom: "1px solid rgba(".concat(theme.palette.customColors.main, ", 0.22)")
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "1px solid rgba(".concat(theme.palette.customColors.main, ", 0.32)")
                    },
                    "&.Mui-disabled:before": {
                        borderBottomStyle: "solid"
                    }
                }
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(".concat(theme.palette.customColors.main, ", 0.04)"),
                    "&:hover:not(.Mui-disabled)": {
                        backgroundColor: "rgba(".concat(theme.palette.customColors.main, ", 0.08)")
                    },
                    "&:before": {
                        borderBottom: "1px solid rgba(".concat(theme.palette.customColors.main, ", 0.22)")
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: "1px solid rgba(".concat(theme.palette.customColors.main, ", 0.32)")
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&:hover:not(.Mui-focused):not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(".concat(theme.palette.customColors.main, ", 0.32)")
                    },
                    "&:hover.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.error.main
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(".concat(theme.palette.customColors.main, ", 0.22)")
                    },
                    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.text.disabled
                    }
                },
                input: {
                    "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px ".concat(theme.palette.background.paper, " inset"),
                        WebkitTextFillColor: theme.palette.text.primary,
                        color: theme.palette.text.primary,
                        transition: "background-color, 99999999s ease-in-out 0s"
                    }
                },
                notchedOutline: {
                    top: theme.spacing(-1.25)
                }
            }
        }
    };
};
/* harmony default export */ var overrides_input = (input);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/form.ts
// ** MUI Imports
const form_form = (theme)=>{
    return {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.secondary
                }
            }
        }
    };
};
/* harmony default export */ var overrides_form = (form_form);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/paper.ts
/* harmony default export */ var paper = ({
    MuiPaper: {
        styleOverrides: {
            root: {
                backgroundImage: "none"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/@core/theme/overrides/table.ts
// ** MUI Imports
const Table = (theme)=>{
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    boxShadow: theme.shadows[0],
                    borderTopColor: theme.palette.divider
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    textTransform: "uppercase",
                    "& .MuiTableCell-head": {
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        letterSpacing: "0.13px"
                    }
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    "& .MuiTableCell-body": {
                        letterSpacing: "0.25px",
                        color: theme.palette.text.secondary,
                        "&:not(.MuiTableCell-sizeSmall):not(.MuiTableCell-paddingCheckbox):not(.MuiTableCell-paddingNone)": {
                            paddingTop: theme.spacing(3.5),
                            paddingBottom: theme.spacing(3.5)
                        }
                    }
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "& .MuiTableCell-head:not(.MuiTableCell-paddingCheckbox):first-of-type, & .MuiTableCell-root:not(.MuiTableCell-paddingCheckbox):first-of-type ": {
                        paddingLeft: theme.spacing(5)
                    },
                    "& .MuiTableCell-head:last-child, & .MuiTableCell-root:last-child": {
                        paddingRight: theme.spacing(5)
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "1px solid ".concat(theme.palette.divider)
                },
                paddingCheckbox: {
                    paddingLeft: theme.spacing(2)
                },
                stickyHeader: {
                    backgroundColor: theme.palette.customColors.tableHeaderBg
                }
            }
        }
    };
};
/* harmony default export */ var table = (Table);

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
;// CONCATENATED MODULE: ./src/@core/theme/overrides/alerts.ts
// ** MUI Imports

const Alert = (theme)=>{
    const getColor = theme.palette.mode === "light" ? colorManipulator/* darken */._j : colorManipulator/* lighten */.$n;
    return {
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: 5,
                    "& .MuiAlertTitle-root": {
                        marginBottom: theme.spacing(1.6)
                    },
                    "& a": {
                        fontWeight: 500,
                        color: "inherit"
                    }
                },
                standardSuccess: {
                    color: theme.palette.success.contrastText,
                    backgroundColor: theme.palette.success.light,
                    "& .MuiAlertTitle-root": {
                        color: theme.palette.success.contrastText
                    },
                    "& .MuiAlert-icon": {
                        color: theme.palette.success.contrastText
                    }
                },
                standardInfo: {
                    color: theme.palette.info.contrastText,
                    backgroundColor: theme.palette.info.main,
                    "& .MuiAlertTitle-root": {
                        color: theme.palette.info.contrastText
                    },
                    "& .MuiAlert-icon": {
                        color: theme.palette.info.contrastText
                    }
                },
                standardWarning: {
                    color: theme.palette.warning.contrastText,
                    backgroundColor: theme.palette.warning.main,
                    "& .MuiAlertTitle-root": {
                        color: theme.palette.warning.contrastText
                    },
                    "& .MuiAlert-icon": {
                        color: theme.palette.warning.contrastText
                    }
                },
                standardError: {
                    color: theme.palette.error.contrastText,
                    backgroundColor: theme.palette.error.main,
                    "& .MuiAlertTitle-root": {
                        color: theme.palette.error.contrastText
                    },
                    "& .MuiAlert-icon": {
                        color: theme.palette.error.contrastText
                    }
                },
                outlinedSuccess: {
                    borderColor: theme.palette.success.main,
                    color: getColor(theme.palette.success.main, 0.12),
                    "& .MuiAlertTitle-root": {
                        color: getColor(theme.palette.success.main, 0.12)
                    },
                    "& .MuiAlert-icon": {
                        color: getColor(theme.palette.success.main, 0.12)
                    }
                },
                outlinedInfo: {
                    borderColor: theme.palette.info.main,
                    color: getColor(theme.palette.info.main, 0.12),
                    "& .MuiAlertTitle-root": {
                        color: getColor(theme.palette.info.main, 0.12)
                    },
                    "& .MuiAlert-icon": {
                        color: getColor(theme.palette.info.main, 0.12)
                    }
                },
                outlinedWarning: {
                    borderColor: theme.palette.warning.main,
                    color: getColor(theme.palette.warning.main, 0.12),
                    "& .MuiAlertTitle-root": {
                        color: getColor(theme.palette.warning.main, 0.12)
                    },
                    "& .MuiAlert-icon": {
                        color: getColor(theme.palette.warning.main, 0.12)
                    }
                },
                outlinedError: {
                    borderColor: theme.palette.error.main,
                    color: getColor(theme.palette.error.main, 0.12),
                    "& .MuiAlertTitle-root": {
                        color: getColor(theme.palette.error.main, 0.12)
                    },
                    "& .MuiAlert-icon": {
                        color: getColor(theme.palette.error.main, 0.12)
                    }
                },
                filled: {
                    fontWeight: 400,
                    color: theme.palette.common.white
                }
            }
        }
    };
};
/* harmony default export */ var overrides_alerts = (Alert);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/button.ts
// ** MUI Imports
// ** Theme Config Imports

const Button = (theme)=>{
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: 15,
                    fontWeight: 500,
                    borderRadius: 2,
                    lineHeight: 1.7,
                    letterSpacing: "0.46px",
                    padding: "".concat(theme.spacing(2, 3)),
                    textTransform: "none"
                },
                specified: {
                    backgroundColor: theme.palette.specified.main,
                    color: theme.palette.specified.contrastText,
                    "&:hover": {
                        backgroundColor: theme.palette.specified.hover.main,
                        color: theme.palette.specified.hover.contrastText
                    }
                },
                contained: {
                    boxShadow: theme.shadows[3],
                    padding: "".concat(theme.spacing(2.25, 6.5))
                },
                outlined: {
                    padding: "".concat(theme.spacing(2, 6.5))
                },
                sizeSmall: {
                    padding: "".concat(theme.spacing(1, 2.25)),
                    "&.MuiButton-contained": {
                        padding: "".concat(theme.spacing(1, 3.5))
                    },
                    "&.MuiButton-outlined": {
                        padding: "".concat(theme.spacing(0.75, 3.25))
                    }
                },
                sizeLarge: {
                    padding: "".concat(theme.spacing(2.125, 5.5)),
                    "&.MuiButton-contained": {
                        padding: "".concat(theme.spacing(2.125, 6.5))
                    },
                    "&.MuiButton-outlined": {
                        padding: "".concat(theme.spacing(1.875, 6.25))
                    }
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: themeConfig/* default.disableRipple */.Z.disableRipple
            }
        }
    };
};
/* harmony default export */ var overrides_button = (Button);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/dialog.ts
// ** MUI Imports
const Dialog = (theme, skin)=>{
    return {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    boxShadow: theme.shadows[skin === "bordered" ? 0 : 6],
                    ...skin === "bordered" && {
                        border: "1px solid ".concat(theme.palette.divider)
                    },
                    "&:not(.MuiDialog-paperFullScreen)": {
                        "@media (max-width:599px)": {
                            margin: theme.spacing(4),
                            width: "calc(100% - ".concat(theme.spacing(8), ")"),
                            maxWidth: "calc(100% - ".concat(theme.spacing(8), ") !important")
                        }
                    },
                    "& > .MuiList-root": {
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1)
                    }
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5)
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "& + .MuiDialogContent-root": {
                        paddingTop: 0
                    },
                    "& + .MuiDialogActions-root": {
                        paddingTop: 0
                    }
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "&.dialog-actions-dense": {
                        padding: theme.spacing(2.5),
                        paddingTop: 0
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_dialog = (Dialog);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/rating.ts
// ** MUI Imports
const Rating = (theme)=>{
    return {
        MuiRating: {
            styleOverrides: {
                root: {
                    color: theme.palette.warning.main,
                    "& svg": {
                        flexShrink: 0
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_rating = (Rating);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/select.ts
const select_select = ()=>{
    return {
        MuiSelect: {
            styleOverrides: {
                select: {
                    minWidth: "6rem !important",
                    "&.MuiTablePagination-select": {
                        minWidth: "1.5rem !important"
                    },
                    textOverflow: "initial",
                    whiteSpace: "initial",
                    overflow: "initial"
                }
            }
        }
    };
};
/* harmony default export */ var overrides_select = (select_select);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/avatars.ts
// ** MUI Imports
const Avatar = (theme)=>{
    return {
        MuiAvatar: {
            styleOverrides: {
                colorDefault: {
                    color: theme.palette.text.secondary,
                    backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[200] : theme.palette.grey[700]
                },
                rounded: {
                    borderRadius: 5
                }
            }
        },
        MuiAvatarGroup: {
            styleOverrides: {
                root: {
                    "&.pull-up": {
                        "& .MuiAvatar-root": {
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                zIndex: 2,
                                boxShadow: theme.shadows[3],
                                transform: "translateY(-4px)"
                            }
                        }
                    },
                    justifyContent: "flex-end",
                    ".MuiCard-root & .MuiAvatar-root": {
                        borderColor: theme.palette.background.paper
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_avatars = (Avatar);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/divider.ts
// ** MUI Imports
const Divider = (theme)=>{
    return {
        MuiDivider: {
            styleOverrides: {
                root: {
                    "&:not(.MuiDivider-vertical)": {
                        marginTop: theme.spacing(2),
                        marginBottom: theme.spacing(2)
                    }
                },
                middle: {
                    "&:not(.MuiDivider-vertical)": {
                        marginLeft: theme.spacing(5),
                        marginRight: theme.spacing(5)
                    },
                    "&.MuiDivider-vertical": {
                        marginTop: theme.spacing(2),
                        marginBottom: theme.spacing(2)
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_divider = (Divider);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/popover.ts
// ** MUI Imports
const Popover = (theme, skin)=>{
    return {
        MuiPopover: {
            styleOverrides: {
                root: {
                    "& .MuiPopover-paper": {
                        boxShadow: theme.shadows[skin === "bordered" ? 0 : 6],
                        ...skin === "bordered" && {
                            border: "1px solid ".concat(theme.palette.divider)
                        }
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_popover = (Popover);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/tooltip.ts
// ** MUI Imports
const Tooltip = (theme)=>{
    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    paddingLeft: theme.spacing(4),
                    paddingRight: theme.spacing(4),
                    paddingTop: theme.spacing(4),
                    paddingBottom: theme.spacing(6),
                    backgroundColor: "#3A3E5B",
                    borderRadius: theme.spacing(2),
                    fontSize: 14,
                    color: theme.palette.common.white,
                    marginLeft: theme.spacing(-2)
                },
                arrow: {
                    marginLeft: theme.spacing(1),
                    color: "#3A3E5B"
                }
            }
        }
    };
};
/* harmony default export */ var overrides_tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/backdrop.ts
// ** MUI Imports
// ** Util Import

const Backdrop = (theme)=>{
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.mode === "light" ? "rgba(".concat(theme.palette.customColors.main, ", 0.7)") : hexToRGBA(theme.palette.background.default, 0.7)
                },
                invisible: {
                    backgroundColor: "transparent"
                }
            }
        }
    };
};
/* harmony default export */ var overrides_backdrop = (Backdrop);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/dataGrid.ts
// ** MUI Imports
const DataGrid = (theme)=>{
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: 0,
                    color: theme.palette.text.primary,
                    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                        outline: "none"
                    }
                },
                toolbarContainer: {
                    paddingRight: "".concat(theme.spacing(5), " !important"),
                    paddingLeft: "".concat(theme.spacing(3.25), " !important")
                },
                columnHeaders: {
                    lineHeight: "24px !important",
                    backgroundColor: theme.palette.customColors.tableHeaderBg
                },
                columnHeader: {
                    "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
                        padding: theme.spacing(4),
                        "&:first-of-type": {
                            paddingLeft: theme.spacing(5)
                        }
                    },
                    "&:last-of-type": {
                        paddingRight: theme.spacing(5)
                    }
                },
                columnHeaderCheckbox: {
                    maxWidth: "58px !important",
                    minWidth: "58px !important"
                },
                columnHeaderTitleContainer: {
                    padding: 0
                },
                columnHeaderTitle: {
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    letterSpacing: "0.17px",
                    textTransform: "uppercase"
                },
                columnSeparator: {
                    color: theme.palette.divider
                },
                row: {
                    "&:last-child": {
                        "& .MuiDataGrid-cell": {
                            borderBottom: 0
                        }
                    }
                },
                cell: {
                    lineHeight: "20px !important",
                    borderColor: theme.palette.divider,
                    "&:not(.MuiDataGrid-cellCheckbox)": {
                        padding: theme.spacing(4),
                        "&:first-of-type": {
                            paddingLeft: theme.spacing(5)
                        }
                    },
                    "&:last-of-type": {
                        paddingRight: theme.spacing(5)
                    },
                    "&:focus, &:focus-within": {
                        outline: "none"
                    }
                },
                cellCheckbox: {
                    maxWidth: "58px !important",
                    minWidth: "58px !important"
                },
                editInputCell: {
                    padding: 0,
                    color: theme.palette.text.primary,
                    "& .MuiInputBase-input": {
                        padding: 0
                    }
                },
                footerContainer: {
                    minHeight: "50px !important",
                    borderTop: "1px solid ".concat(theme.palette.divider),
                    "& .MuiTablePagination-toolbar": {
                        minHeight: "50px !important",
                        paddingLeft: "".concat(theme.spacing(4), " !important"),
                        paddingRight: "".concat(theme.spacing(4), " !important")
                    },
                    "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel": {
                        color: theme.palette.text.primary
                    }
                },
                selectedRowCount: {
                    margin: 0,
                    paddingLeft: theme.spacing(4),
                    paddingRight: theme.spacing(4)
                }
            },
            defaultProps: {
                rowHeight: 50,
                headerHeight: 54
            }
        }
    };
};
/* harmony default export */ var overrides_dataGrid = (DataGrid);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/snackbar.ts
// ** MUI Imports
const Snackbar = (theme, skin)=>{
    return {
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    ...skin === "bordered" && {
                        boxShadow: "none"
                    },
                    backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[900] : theme.palette.grey[100]
                }
            }
        }
    };
};
/* harmony default export */ var overrides_snackbar = (Snackbar);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/switches.ts
// ** MUI Imports
const Switch = (theme)=>{
    return {
        MuiSwitch: {
            styleOverrides: {
                root: {
                    "& .MuiSwitch-track": {
                        backgroundColor: "rgb(".concat(theme.palette.customColors.main, ")")
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_switches = (Switch);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/timeline.ts
// ** MUI Imports
// ** Util Import

const Timeline = (theme)=>{
    return {
        MuiTimelineItem: {
            styleOverrides: {
                root: {
                    "&:not(:last-of-type)": {
                        "& .MuiTimelineContent-root": {
                            marginBottom: theme.spacing(4)
                        }
                    }
                }
            }
        },
        MuiTimelineConnector: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.divider
                }
            }
        },
        MuiTimelineContent: {
            styleOverrides: {
                root: {
                    marginTop: theme.spacing(0.5)
                }
            }
        },
        MuiTimelineDot: {
            styleOverrides: {
                filledPrimary: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.primary.main, 0.12))
                },
                filledSecondary: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.secondary.main, 0.12))
                },
                filledSuccess: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.success.main, 0.12))
                },
                filledError: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.error.main, 0.12))
                },
                filledWarning: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.warning.main, 0.12))
                },
                filledInfo: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.info.main, 0.12))
                },
                filledGrey: {
                    boxShadow: "0 0 0 3px ".concat(hexToRGBA(theme.palette.grey[400], 0.12))
                },
                outlinedPrimary: {
                    "& svg": {
                        color: theme.palette.primary.main
                    }
                },
                outlinedSecondary: {
                    "& svg": {
                        color: theme.palette.secondary.main
                    }
                },
                outlinedSuccess: {
                    "& svg": {
                        color: theme.palette.success.main
                    }
                },
                outlinedError: {
                    "& svg": {
                        color: theme.palette.error.main
                    }
                },
                outlinedWarning: {
                    "& svg": {
                        color: theme.palette.warning.main
                    }
                },
                outlinedInfo: {
                    "& svg": {
                        color: theme.palette.info.main
                    }
                },
                outlinedGrey: {
                    "& svg": {
                        color: theme.palette.grey[400]
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_timeline = (Timeline);

// EXTERNAL MODULE: ./src/@core/hooks/useSettings.ts
var useSettings = __webpack_require__(1268);
;// CONCATENATED MODULE: ./src/@core/theme/overrides/accordion.ts
// ** MUI Imports
// ** Hook Import

const Accordion = (theme)=>{
    // Hook & Var
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const { skin  } = settings;
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: theme.shadows[skin === "bordered" ? 0 : 1],
                    ...skin === "bordered" && {
                        "&:before": {
                            display: "none"
                        },
                        borderLeft: "1px solid ".concat(theme.palette.divider),
                        borderRight: "1px solid ".concat(theme.palette.divider),
                        borderBottom: "1px solid ".concat(theme.palette.divider),
                        "&:first-of-type": {
                            borderTop: "1px solid ".concat(theme.palette.divider)
                        }
                    },
                    "&.Mui-disabled": {
                        backgroundColor: "rgba(".concat(theme.palette.customColors.main, ", 0.12)")
                    },
                    "&.Mui-expanded": {
                        boxShadow: theme.shadows[skin === "bordered" ? 0 : 3],
                        "&:not(:first-of-type)": {
                            borderTop: "1px solid ".concat(theme.palette.divider)
                        },
                        ...skin === "bordered" && {
                            "& + .MuiAccordion-root": {
                                borderTop: "1px solid ".concat(theme.palette.divider)
                            }
                        }
                    }
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    borderRadius: "inherit",
                    padding: "0 ".concat(theme.spacing(5)),
                    "&.Mui-expanded": {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    "& + .MuiCollapse-root": {
                        "& .MuiAccordionDetails-root:first-of-type": {
                            paddingTop: 0
                        }
                    }
                },
                content: {
                    margin: "".concat(theme.spacing(2.5), " 0")
                },
                expandIconWrapper: {
                    color: theme.palette.text.secondary
                }
            }
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(5),
                    "& + .MuiAccordionDetails-root": {
                        paddingTop: 0
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_accordion = (Accordion);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/pagination.ts
// ** MUI Imports
// ** Util Import

const Pagination = (theme)=>{
    return {
        MuiPaginationItem: {
            styleOverrides: {
                outlined: {
                    borderColor: "rgba(".concat(theme.palette.customColors.main, ", 0.22)")
                },
                outlinedPrimary: {
                    "&.Mui-selected": {
                        backgroundColor: hexToRGBA(theme.palette.primary.main, 0.12),
                        "&:hover": {
                            backgroundColor: "".concat(hexToRGBA(theme.palette.primary.main, 0.2), " !important")
                        }
                    }
                },
                outlinedSecondary: {
                    "&.Mui-selected": {
                        backgroundColor: hexToRGBA(theme.palette.secondary.main, 0.12),
                        "&:hover": {
                            backgroundColor: "".concat(hexToRGBA(theme.palette.secondary.main, 0.2), " !important")
                        }
                    }
                }
            }
        }
    };
};
/* harmony default export */ var overrides_pagination = (Pagination);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/typography.ts
// ** MUI Imports
const Typography = (theme)=>{
    return {
        MuiTypography: {
            styleOverrides: {
                gutterBottom: {
                    marginBottom: theme.spacing(2)
                }
            }
        }
    };
};
/* harmony default export */ var typography = (Typography);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/autocomplete.ts
// ** MUI Imports
const Autocomplete = (theme, skin)=>{
    return {
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    ...skin === "bordered" && {
                        boxShadow: "none",
                        border: "1px solid ".concat(theme.palette.divider)
                    }
                },
                endAdornment: {
                    top: "50%",
                    transform: "translateY(-50%)"
                }
            }
        }
    };
};
/* harmony default export */ var overrides_autocomplete = (Autocomplete);

;// CONCATENATED MODULE: ./src/@core/theme/overrides/toggleButton.ts
/* harmony default export */ var toggleButton = ({
    MuiToggleButtonGroup: {
        styleOverrides: {
            root: {
                borderRadius: 4
            }
        }
    },
    MuiToggleButton: {
        styleOverrides: {
            root: {
                borderRadius: 4
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/@core/theme/overrides/index.ts
// ** MUI Imports
// ** Overrides Imports





























const Overrides = (theme, settings)=>{
    const { skin  } = settings;
    const button = overrides_button(theme);
    const chip = overrides_chip(theme);
    const list = overrides_list(theme);
    const tabs = overrides_tabs(theme);
    const input = overrides_input(theme);
    const form = overrides_form(theme);
    const tables = table(theme);
    const alerts = overrides_alerts(theme);
    const rating = overrides_rating(theme);
    const select = overrides_select();
    const avatars = overrides_avatars(theme);
    const divider = overrides_divider(theme);
    const menu = overrides_menu(theme, skin);
    const tooltip = overrides_tooltip(theme);
    const cards = card(theme, skin);
    const backdrop = overrides_backdrop(theme);
    const dataGrid = overrides_dataGrid(theme);
    const switches = overrides_switches(theme);
    const timeline = overrides_timeline(theme);
    const accordion = overrides_accordion(theme);
    const dialog = overrides_dialog(theme, skin);
    const pagination = overrides_pagination(theme);
    const popover = overrides_popover(theme, skin);
    const snackbar = overrides_snackbar(theme, skin);
    const autocomplete = overrides_autocomplete(theme, skin);
    return Object.assign(chip, list, menu, tabs, cards, input, form, alerts, button, dialog, rating, tables, avatars, divider, overrides_link, popover, tooltip, backdrop, dataGrid, paper, snackbar, switches, timeline, accordion, select, pagination, autocomplete, typography, toggleButton);
};
/* harmony default export */ var overrides = (Overrides);

;// CONCATENATED MODULE: ./src/@core/theme/typography/index.ts
// ** Theme Type Import
const typography_Typography = (theme)=>{
    return {
        h1: {
            fontWeight: 500,
            letterSpacing: "-1.5px",
            color: theme.palette.text.primary
        },
        h2: {
            fontWeight: 500,
            letterSpacing: "-0.5px",
            color: theme.palette.text.primary
        },
        h3: {
            fontWeight: 500,
            letterSpacing: 0,
            color: theme.palette.text.primary
        },
        h4: {
            fontWeight: 500,
            letterSpacing: "0.25px",
            color: theme.palette.text.primary
        },
        h5: {
            fontWeight: 500,
            letterSpacing: 0,
            color: theme.palette.text.primary
        },
        h6: {
            letterSpacing: "0.15px",
            color: theme.palette.text.primary
        },
        subtitle1: {
            letterSpacing: "0.15px",
            color: theme.palette.text.primary
        },
        subtitle2: {
            letterSpacing: "0.1px",
            color: theme.palette.text.primary
        },
        body1: {
            letterSpacing: "0.15px",
            color: theme.palette.text.primary
        },
        body2: {
            lineHeight: 1.42,
            letterSpacing: "0.15px",
            color: theme.palette.text.secondary
        },
        body3: {
            lineHeight: "15px",
            fontSize: theme.spacing(3),
            letterSpacing: "0.4px",
            color: theme.palette.customColors.marker
        },
        button: {
            letterSpacing: "0.3px",
            color: theme.palette.text.primary
        },
        caption: {
            letterSpacing: "0.4px",
            color: theme.palette.text.secondary
        },
        overline: {
            letterSpacing: "1px",
            color: theme.palette.text.secondary
        }
    };
};
/* harmony default export */ var theme_typography = (typography_Typography);

;// CONCATENATED MODULE: ./src/layouts/UserThemeOptions.ts
// ** MUI Imports
// ** To use core palette, uncomment the below import
// import corePalette from 'src/@core/theme/palette'
// ** To use mode (light/dark/semi-dark), skin(default/bordered), direction(ltr/rtl), etc. for conditional styles, uncomment below line
// import { useSettings } from 'src/@core/hooks/useSettings'
const UserThemeOptions = ()=>{
    // ** To use mode (light/dark/semi-dark), skin(default/bordered), direction(ltr/rtl), etc. for conditional styles, uncomment below line
    // const { settings } = useSettings()
    // ** To use mode (light/dark/semi-dark), skin(default/bordered), direction(ltr/rtl), etc. for conditional styles, uncomment below line
    // const { mode, skin, themeColor } = settings
    // ** To use core palette, uncomment the below line
    // const palette = corePalette(mode, skin, themeColor)
    return {
    };
};
/* harmony default export */ var layouts_UserThemeOptions = (UserThemeOptions);

;// CONCATENATED MODULE: ./src/@core/theme/palette/index.ts
// ** Type Imports
const DefaultPalette = (mode, skin, themeColor)=>{
    // ** Vars
    const whiteColor = "#FFF";
    const blackColor = "#000";
    const lightColor = "54, 56, 71";
    const lightColor2 = "76, 78, 100";
    const darkColor = "234, 234, 255";
    const darkColor2 = "231, 227, 252";
    const mainColor = mode === "light" ? lightColor : darkColor;
    const mainColor2 = mode === "light" ? lightColor2 : darkColor2;
    const primaryGradient = ()=>{
        if (themeColor === "primary") {
            return "#C6A7FE";
        } else if (themeColor === "secondary") {
            return "#9C9FA4";
        } else if (themeColor === "success") {
            return "#93DD5C";
        } else if (themeColor === "error") {
            return "#FF8C90";
        } else if (themeColor === "warning") {
            return "#FFCF5C";
        } else {
            return "#6ACDFF";
        }
    };
    const defaultBgColor = ()=>{
        if (skin === "bordered" && mode === "light") {
            return whiteColor;
        } else if (skin === "bordered" && mode === "dark") {
            return "#312D4B";
        } else if (mode === "light") {
            return "#F4F5FA";
        } else return "#000000";
    };
    return {
        customColors: {
            default: defaultBgColor(),
            dark: darkColor,
            main: mainColor,
            light: lightColor,
            primaryGradient: primaryGradient(),
            bodyBg: mode === "light" ? whiteColor : "#141414",
            trackBg: mode === "light" ? "#F0F2F8" : "#474360",
            darkBg: skin === "bordered" ? "#0F0F0F" : "#141414",
            lightBg: skin === "bordered" ? "#F4F5FA" : whiteColor,
            tableHeaderBg: mode === "light" ? "#F9FAFC" : "#3D3759",
            tableHeaderBg2: "#3A3E5B",
            primaryMainActive: mode === "light" ? whiteColor : blackColor,
            primaryContrastTextActive: mode === "light" ? "rgba(".concat(lightColor2, ", 0.87)") : whiteColor,
            chartTooltipBg: mode === "light" ? "#F2F2F2" : "#141414",
            chartTooltipBorder: "#434548",
            chartLegendColor: "#9D9AAB",
            chartGridStroke: "rgba(".concat(lightColor2, ", 0.12)"),
            greyPrimary: mode === "light" ? "#50515F" : "#DCDCED",
            button: mode === "light" ? whiteColor : "rgba(".concat(lightColor2, ", 0.95)"),
            cardBg: mode === "light" ? "#F4F5FA" : blackColor,
            cardBg2: mode === "light" ? "#F4F5FA" : "#1C1C1C",
            cardBg3: mode === "light" ? "#E0E0E0" : "#303030",
            marker: "rgba(".concat(mainColor2, ", 0.68)"),
            border: mode === "light" ? "rgba(".concat(lightColor, ", 0.12)") : "rgba(234, 242, 255, 0.22)",
            playerTextColor: mode === "light" ? "rgba(".concat(lightColor, ", 0.87)") : whiteColor,
            playerColor: mode === "light" ? "rgba(".concat(lightColor2, ", 0.54)") : whiteColor,
            lightGreen: "#5DB921",
            activeMenu: mode === "light" ? "rgba(".concat(darkColor2, ", 0.52)") : "rgba(".concat(lightColor2, ", 0.52)"),
            viewFieldBg: mode === "light" ? "#F2F2F2" : "#000000",
            viewFieldBorder: mode === "light" ? "rgba(".concat(lightColor2, ", 0.22)") : "#434548",
            chartСandles: mode === "light" ? "#F2F2F2" : "rgba(".concat(lightColor2, ", 0.26)")
        },
        specified: {
            main: mode === "light" ? blackColor : whiteColor,
            contrastText: mode === "light" ? whiteColor : "rgba(".concat(lightColor, ", 0.87)"),
            hover: {
                main: mode === "light" ? whiteColor : blackColor,
                contrastText: mode === "light" ? "rgba(".concat(lightColor, ", 0.87)") : whiteColor
            }
        },
        mode: mode,
        common: {
            black: blackColor,
            dark: "#0F0F0F",
            white: whiteColor
        },
        primary: {
            light: "#A543FF",
            main: "#9000FF",
            dark: "#7700F0",
            contrastText: whiteColor
        },
        secondary: {
            light: "#EEEEEE",
            main: mode === "light" ? "#7D7D7D" : "#CBCBCB",
            dark: "#7D7D7D",
            contrastText: whiteColor
        },
        error: {
            light: "#FF625F",
            main: "#FF4D49",
            dark: "#E04440",
            contrastText: whiteColor
        },
        warning: {
            light: "#FDBE42",
            main: "#FDB528",
            dark: "#DF9F23",
            contrastText: whiteColor
        },
        info: {
            light: "#40CDFA",
            main: "#26C6F9",
            dark: "#21AEDB",
            contrastText: whiteColor
        },
        success: {
            light: "#72E128",
            main: "#83E542",
            dark: "#64C623",
            contrastText: whiteColor
        },
        grey: {
            50: "#FAFAFA",
            100: "#F5F5F5",
            200: "#EEEEEE",
            300: "#E0E0E0",
            400: "#BDBDBD",
            500: "#9E9E9E",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            A100: "#F5F5F5",
            A200: "#EEEEEE",
            A400: "#BDBDBD",
            A700: "#616161"
        },
        text: {
            primary: "rgba(".concat(mainColor, ", 0.87)"),
            secondary: "rgba(".concat(mainColor2, ", 0.68)"),
            disabled: "rgba(".concat(mainColor2, ", 0.38)")
        },
        divider: "rgba(".concat(mainColor, ", 0.12)"),
        background: {
            paper: mode === "light" ? whiteColor : "#141414",
            default: defaultBgColor()
        },
        action: {
            active: "rgba(".concat(mainColor2, ", 0.54)"),
            hover: mode === "light" ? "rgba(91, 76, 100, 0.07)" : "rgba(234, 234, 255, 0.05)",
            selected: "rgba(".concat(mainColor2, ", 0.08)"),
            disabled: "rgba(".concat(mainColor, ", 0.26)"),
            disabledBackground: "rgba(".concat(mainColor, ", 0.12)"),
            focus: "rgba(".concat(mainColor, ", 0.12)")
        }
    };
};
/* harmony default export */ var palette = (DefaultPalette);

;// CONCATENATED MODULE: ./src/@core/theme/spacing/index.ts
/* harmony default export */ var spacing = ({
    spacing: (factor)=>"".concat(0.25 * factor, "rem")
});

;// CONCATENATED MODULE: ./src/@core/theme/shadows/index.ts
// ** Type Imports
const Shadows = (mode)=>{
    if (mode === "light") {
        return [
            "none",
            "0px 2px 1px -1px rgba(58, 53, 65, 0.2), 0px 1px 1px 0px rgba(58, 53, 65, 0.14), 0px 1px 3px 0px rgba(58, 53, 65, 0.12)",
            "0px 3px 1px -2px rgba(58, 53, 65, 0.2), 0px 2px 2px 0px rgba(58, 53, 65, 0.14), 0px 1px 5px 0px rgba(58, 53, 65, 0.12)",
            "0px 4px 8px -4px rgba(58, 53, 65, 0.42)",
            "0px 6px 18px -8px rgba(58, 53, 65, 0.56)",
            "0px 3px 5px -1px rgba(58, 53, 65, 0.2), 0px 5px 8px 0px rgba(58, 53, 65, 0.14), 0px 1px 14px 0px rgba(58, 53, 65, 0.12)",
            "0px 2px 10px 0px rgba(58, 53, 65, 0.1)",
            "0px 4px 5px -2px rgba(58, 53, 65, 0.2), 0px 7px 10px 1px rgba(58, 53, 65, 0.14), 0px 2px 16px 1px rgba(58, 53, 65, 0.12)",
            "0px 5px 5px -3px rgba(58, 53, 65, 0.2), 0px 8px 10px 1px rgba(58, 53, 65, 0.14), 0px 3px 14px 2px rgba(58, 53, 65, 0.12)",
            "0px 5px 6px -3px rgba(58, 53, 65, 0.2), 0px 9px 12px 1px rgba(58, 53, 65, 0.14), 0px 3px 16px 2px rgba(58, 53, 65, 0.12)",
            "0px 6px 6px -3px rgba(58, 53, 65, 0.2), 0px 10px 14px 1px rgba(58, 53, 65, 0.14), 0px 4px 18px 3px rgba(58, 53, 65, 0.12)",
            "0px 6px 7px -4px rgba(58, 53, 65, 0.2), 0px 11px 15px 1px rgba(58, 53, 65, 0.14), 0px 4px 20px 3px rgba(58, 53, 65, 0.12)",
            "0px 7px 8px -4px rgba(58, 53, 65, 0.2), 0px 12px 17px 2px rgba(58, 53, 65, 0.14), 0px 5px 22px 4px rgba(58, 53, 65, 0.12)",
            "0px 7px 8px -4px rgba(58, 53, 65, 0.2), 0px 13px 19px 2px rgba(58, 53, 65, 0.14), 0px 5px 24px 4px rgba(58, 53, 65, 0.12)",
            "0px 7px 9px -4px rgba(58, 53, 65, 0.2), 0px 14px 21px 2px rgba(58, 53, 65, 0.14), 0px 5px 26px 4px rgba(58, 53, 65, 0.12)",
            "0px 8px 9px -5px rgba(58, 53, 65, 0.2), 0px 15px 22px 2px rgba(58, 53, 65, 0.14), 0px 6px 28px 5px rgba(58, 53, 65, 0.12)",
            "0px 8px 10px -5px rgba(58, 53, 65, 0.2), 0px 16px 24px 2px rgba(58, 53, 65, 0.14), 0px 6px 30px 5px rgba(58, 53, 65, 0.12)",
            "0px 8px 11px -5px rgba(58, 53, 65, 0.2), 0px 17px 26px 2px rgba(58, 53, 65, 0.14), 0px 6px 32px 5px rgba(58, 53, 65, 0.12)",
            "0px 9px 11px -5px rgba(58, 53, 65, 0.2), 0px 18px 28px 2px rgba(58, 53, 65, 0.14), 0px 7px 34px 6px rgba(58, 53, 65, 0.12)",
            "0px 9px 12px -6px rgba(58, 53, 65, 0.2), 0px 19px 29px 2px rgba(58, 53, 65, 0.14), 0px 7px 36px 6px rgba(58, 53, 65, 0.12)",
            "0px 10px 13px -6px rgba(58, 53, 65, 0.2), 0px 20px 31px 3px rgba(58, 53, 65, 0.14), 0px 8px 38px 7px rgba(58, 53, 65, 0.12)",
            "0px 10px 13px -6px rgba(58, 53, 65, 0.2), 0px 21px 33px 3px rgba(58, 53, 65, 0.14), 0px 8px 40px 7px rgba(58, 53, 65, 0.12)",
            "0px 10px 14px -6px rgba(58, 53, 65, 0.2), 0px 22px 35px 3px rgba(58, 53, 65, 0.14), 0px 8px 42px 7px rgba(58, 53, 65, 0.12)",
            "0px 11px 14px -7px rgba(58, 53, 65, 0.2), 0px 23px 36px 3px rgba(58, 53, 65, 0.14), 0px 9px 44px 8px rgba(58, 53, 65, 0.12)",
            "0px 11px 15px -7px rgba(58, 53, 65, 0.2), 0px 24px 38px 3px rgba(58, 53, 65, 0.14), 0px 9px 46px 8px rgba(58, 53, 65, 0.12)"
        ];
    } else {
        return [
            "none",
            "0px 2px 1px -1px rgba(19, 17, 32, 0.2), 0px 1px 1px 0px rgba(19, 17, 32, 0.14), 0px 1px 3px 0px rgba(19, 17, 32, 0.12)",
            "0px 3px 1px -2px rgba(19, 17, 32, 0.2), 0px 2px 2px 0px rgba(19, 17, 32, 0.14), 0px 1px 5px 0px rgba(19, 17, 32, 0.12)",
            "0px 4px 8px -4px rgba(19, 17, 32, 0.42)",
            "0px 6px 18px -8px rgba(19, 17, 32, 0.56)",
            "0px 3px 5px -1px rgba(19, 17, 32, 0.2), 0px 5px 8px rgba(19, 17, 32, 0.14), 0px 1px 14px rgba(19, 17, 32, 0.12)",
            "0px 2px 10px 0px rgba(19, 17, 32, 0.1)",
            "0px 4px 5px -2px rgba(19, 17, 32, 0.2), 0px 7px 10px 1px rgba(19, 17, 32, 0.14), 0px 2px 16px 1px rgba(19, 17, 32, 0.12)",
            "0px 5px 5px -3px rgba(19, 17, 32, 0.2), 0px 8px 10px 1px rgba(19, 17, 32, 0.14), 0px 3px 14px 2px rgba(19, 17, 32, 0.12)",
            "0px 5px 6px -3px rgba(19, 17, 32, 0.2), 0px 9px 12px 1px rgba(19, 17, 32, 0.14), 0px 3px 16px 2px rgba(19, 17, 32, 0.12)",
            "0px 6px 6px -3px rgba(19, 17, 32, 0.2), 0px 10px 14px 1px rgba(19, 17, 32, 0.14), 0px 4px 18px 3px rgba(19, 17, 32, 0.12)",
            "0px 6px 7px -4px rgba(19, 17, 32, 0.2), 0px 11px 15px 1px rgba(19, 17, 32, 0.14), 0px 4px 20px 3px rgba(19, 17, 32, 0.12)",
            "0px 7px 8px -4px rgba(19, 17, 32, 0.2), 0px 12px 17px 2px rgba(19, 17, 32, 0.14), 0px 5px 22px 4px rgba(19, 17, 32, 0.12)",
            "0px 7px 8px -4px rgba(19, 17, 32, 0.2), 0px 13px 19px 2px rgba(19, 17, 32, 0.14), 0px 5px 24px 4px rgba(19, 17, 32, 0.12)",
            "0px 7px 9px -4px rgba(19, 17, 32, 0.2), 0px 14px 21px 2px rgba(19, 17, 32, 0.14), 0px 5px 26px 4px rgba(19, 17, 32, 0.12)",
            "0px 8px 9px -5px rgba(19, 17, 32, 0.2), 0px 15px 22px 2px rgba(19, 17, 32, 0.14), 0px 6px 28px 5px rgba(19, 17, 32, 0.12)",
            "0px 8px 10px -5px rgba(19, 17, 32, 0.2), 0px 16px 24px 2px rgba(19, 17, 32, 0.14), 0px 6px 30px 5px rgba(19, 17, 32, 0.12)",
            "0px 8px 11px -5px rgba(19, 17, 32, 0.2), 0px 17px 26px 2px rgba(19, 17, 32, 0.14), 0px 6px 32px 5px rgba(19, 17, 32, 0.12)",
            "0px 9px 11px -5px rgba(19, 17, 32, 0.2), 0px 18px 28px 2px rgba(19, 17, 32, 0.14), 0px 7px 34px 6px rgba(19, 17, 32, 0.12)",
            "0px 9px 12px -6px rgba(19, 17, 32, 0.2), 0px 19px 29px 2px rgba(19, 17, 32, 0.14), 0px 7px 36px 6px rgba(19, 17, 32, 0.12)",
            "0px 10px 13px -6px rgba(19, 17, 32, 0.2), 0px 20px 31px 3px rgba(19, 17, 32, 0.14), 0px 8px 38px 7px rgba(19, 17, 32, 0.12)",
            "0px 10px 13px -6px rgba(19, 17, 32, 0.2), 0px 21px 33px 3px rgba(19, 17, 32, 0.14), 0px 8px 40px 7px rgba(19, 17, 32, 0.12)",
            "0px 10px 14px -6px rgba(19, 17, 32, 0.2), 0px 22px 35px 3px rgba(19, 17, 32, 0.14), 0px 8px 42px 7px rgba(19, 17, 32, 0.12)",
            "0px 11px 14px -7px rgba(19, 17, 32, 0.2), 0px 23px 36px 3px rgba(19, 17, 32, 0.14), 0px 9px 44px 8px rgba(19, 17, 32, 0.12)",
            "0px 11px 15px -7px rgba(19, 17, 32, 0.2), 0px 24px 38px 3px rgba(19, 17, 32, 0.14), 0px 9px 46px 8px rgba(19, 17, 32, 0.12)"
        ];
    }
};
/* harmony default export */ var shadows = (Shadows);

;// CONCATENATED MODULE: ./src/@core/theme/breakpoints/index.ts
const breakpoints = ()=>({
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536
        }
    });
/* harmony default export */ var theme_breakpoints = (breakpoints);

;// CONCATENATED MODULE: ./src/@core/theme/ThemeOptions.ts
// ** MUI Theme Provider

// ** User Theme Options

// ** Theme Override Imports




const themeOptions = (settings)=>{
    var ref;
    // ** Vars
    const { skin , mode , direction , themeColor  } = settings;
    // ** Create New object before removing user component overrides and typography objects from userThemeOptions
    const userThemeConfig = Object.assign({}, layouts_UserThemeOptions());
    const userFontFamily = (ref = userThemeConfig.typography) === null || ref === void 0 ? void 0 : ref.fontFamily;
    // ** Remove component overrides and typography objects from userThemeOptions
    delete userThemeConfig.components;
    delete userThemeConfig.typography;
    const mergedThemeConfig = (0,deepmerge/* default */.Z)({
        direction,
        palette: palette(mode === "semi-dark" ? "light" : mode, skin, themeColor),
        typography: {
            fontFamily: userFontFamily || [
                "FiraSans",
                "Inter",
                "sans-serif",
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"'
            ].join(",")
        },
        shadows: shadows(mode),
        ...spacing,
        breakpoints: theme_breakpoints(),
        shape: {
            borderRadius: 2
        },
        mixins: {
            toolbar: {
                minHeight: 64
            }
        }
    }, userThemeConfig);
    return (0,deepmerge/* default */.Z)(mergedThemeConfig, {
        palette: {
            primary: {
                ...mergedThemeConfig.palette[themeColor]
            }
        }
    });
};
/* harmony default export */ var ThemeOptions = (themeOptions);

;// CONCATENATED MODULE: ./src/@core/theme/globalStyles.ts
// ** MUI Imports
// ** Hook Import

// ** Util Import

const globalStyles_GlobalStyles = (theme)=>{
    // ** Hook & Var
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const { mode  } = settings;
    const perfectScrollbarThumbBgColor = ()=>{
        if (mode === "light") {
            return "#C2C4D1 !important";
        } else {
            return "#504B6D !important";
        }
    };
    return {
        html: {
            scrollBehavior: "smooth",
            [theme.breakpoints.down("xl")]: {
                fontSize: "calc(0.8vw + 0.45vh)"
            },
            [theme.breakpoints.down("lg")]: {
                fontSize: 16
            }
        },
        "body *::-webkit-scrollbar": {
            width: 3,
            height: 3
        },
        "body *::-webkit-scrollbar-track": {
            backgroundColor: theme.palette.text.disabled,
            opacity: 0.6
        },
        "body *::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            marginLeft: 16
        },
        'body[style^="padding-right"] .layout-navbar-and-nav-container::after': {
            content: '""',
            position: "absolute",
            left: "100%",
            top: 0,
            height: "100%",
            backgroundColor: hexToRGBA(theme.palette.background.paper, 0.85),
            width: "30px"
        },
        ".demo-space-x > *": {
            marginTop: "1rem !important",
            marginRight: "1rem !important",
            'body[dir="rtl"] &': {
                marginRight: "0 !important",
                marginLeft: "1rem !important"
            }
        },
        ".demo-space-y > *:not(:last-of-type)": {
            marginBottom: "1rem"
        },
        ".MuiGrid-container.match-height .MuiCard-root": {
            height: "100%"
        },
        ".ps__rail-y": {
            zIndex: 1,
            right: "0 !important",
            left: "auto !important",
            "&:hover, &:focus, &.ps--clicking": {
                backgroundColor: theme.palette.mode === "light" ? "#E4E5EB !important" : "#423D5D !important"
            },
            "& .ps__thumb-y": {
                right: "3px !important",
                left: "auto !important",
                backgroundColor: theme.palette.mode === "light" ? "#C2C4D1 !important" : "#504B6D !important"
            },
            ".layout-vertical-nav &": {
                "& .ps__thumb-y": {
                    width: 4,
                    backgroundColor: perfectScrollbarThumbBgColor()
                },
                "&:hover, &:focus, &.ps--clicking": {
                    backgroundColor: "transparent !important",
                    "& .ps__thumb-y": {
                        width: 6
                    }
                }
            }
        },
        ".MuiFormLabel-root": {
            color: theme.palette.text.secondary
        },
        ["\n      .MuiClock-amButton .MuiTypography-root,\n      .MuiClock-pmButton .MuiTypography-root\n    "]: {
            color: "inherit"
        },
        "#nprogress": {
            pointerEvents: "none",
            "& .bar": {
                left: 0,
                top: 0,
                height: 3,
                width: "100%",
                zIndex: 2000,
                position: "fixed",
                backgroundColor: theme.palette.primary.main
            }
        }
    };
};
/* harmony default export */ var globalStyles = (globalStyles_GlobalStyles);

;// CONCATENATED MODULE: ./src/@core/theme/ThemeComponent.tsx
// ** React Imports

// ** MUI Imports




// ** Theme Config

// ** Direction component for LTR or RTL

// ** Theme Override Imports


// ** Theme


// ** Global Styles

const ThemeComponent = (props)=>{
    // ** Props
    const { settings , children  } = props;
    // ** Merged ThemeOptions of Core and User
    const coreThemeConfig = ThemeOptions(settings);
    // ** Pass ThemeOptions to CreateTheme Function to create partial theme without component overrides
    let theme = (0,createTheme/* default */.Z)(coreThemeConfig);
    // ** Deep Merge Component overrides of core and user
    const mergeComponentOverrides = (theme, settings)=>{
        var ref;
        return (0,deepmerge/* default */.Z)({
            ...overrides(theme, settings)
        }, (ref = layouts_UserThemeOptions()) === null || ref === void 0 ? void 0 : ref.components);
    };
    // ** Deep Merge Typography of core and user
    const mergeTypography = (theme)=>{
        var ref;
        return (0,deepmerge/* default */.Z)(theme_typography(theme), (ref = layouts_UserThemeOptions()) === null || ref === void 0 ? void 0 : ref.typography);
    };
    // ** Continue theme creation and pass merged component overrides to CreateTheme function
    theme = (0,createTheme/* default */.Z)(theme, {
        components: {
            ...mergeComponentOverrides(theme, settings)
        },
        typography: {
            ...mergeTypography(theme)
        }
    });
    // ** Set responsive font sizes to true
    if (themeConfig/* default.responsiveFontSizes */.Z.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ThemeProvider_ThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Direction, {
            direction: settings.direction,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline_CssBaseline, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(material_esm_GlobalStyles_GlobalStyles, {
                    styles: ()=>globalStyles(theme)
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var theme_ThemeComponent = (ThemeComponent);

;// CONCATENATED MODULE: ./src/@core/components/window-wrapper/index.tsx
// ** React Imports


// ** Next Import

const WindowWrapper = (param)=>{
    let { children  } = param;
    // ** State
    const [windowReadyFlag, setWindowReadyFlag] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (true) {
            setWindowReadyFlag(true);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.route
    ]);
    if (windowReadyFlag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    } else {
        return null;
    }
};
/* harmony default export */ var window_wrapper = (WindowWrapper);

// EXTERNAL MODULE: ./node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(4190);
// EXTERNAL MODULE: ./src/state-manager/global/index.ts + 3 modules
var global = __webpack_require__(5789);
// EXTERNAL MODULE: ./src/views/pages/error-page/index.tsx
var error_page = __webpack_require__(3209);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(6176);
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(6607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
;// CONCATENATED MODULE: ./node_modules/@date-io/dayjs/build/index.esm.js





dayjs_min_default().extend((customParseFormat_default()));
dayjs_min_default().extend((localizedFormat_default()));
dayjs_min_default().extend((isBetween_default()));
const withLocale = (dayjs, locale) => (!locale ? dayjs : (...args) => dayjs(...args).locale(locale));
const defaultFormats = {
    normalDateWithWeekday: "ddd, MMM D",
    normalDate: "D MMMM",
    shortDate: "MMM D",
    monthAndDate: "MMMM D",
    dayOfMonth: "D",
    year: "YYYY",
    month: "MMMM",
    monthShort: "MMM",
    monthAndYear: "MMMM YYYY",
    weekday: "dddd",
    weekdayShort: "ddd",
    minutes: "mm",
    hours12h: "hh",
    hours24h: "HH",
    seconds: "ss",
    fullTime: "LT",
    fullTime12h: "hh:mm A",
    fullTime24h: "HH:mm",
    fullDate: "ll",
    fullDateWithWeekday: "dddd, LL",
    fullDateTime: "lll",
    fullDateTime12h: "ll hh:mm A",
    fullDateTime24h: "ll HH:mm",
    keyboardDate: "L",
    keyboardDateTime: "L LT",
    keyboardDateTime12h: "L hh:mm A",
    keyboardDateTime24h: "L HH:mm",
};
class DayjsUtils {
    constructor({ locale, formats, instance } = {}) {
        this.lib = "dayjs";
        this.is12HourCycleInCurrentLocale = () => {
            var _a, _b, _c;
            /* istanbul ignore next */
            return /A|a/.test((_c = (_b = (_a = this.rawDayJsInstance.Ls[this.locale || "en"]) === null || _a === void 0 ? void 0 : _a.formats) === null || _b === void 0 ? void 0 : _b.LT) !== null && _c !== void 0 ? _c : "");
        };
        this.getCurrentLocaleCode = () => {
            return this.locale || "en";
        };
        this.getFormatHelperText = (format) => {
            var _a, _b;
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?)|./g;
            return ((_b = (_a = format
                .match(localFormattingTokens)) === null || _a === void 0 ? void 0 : _a.map((token) => {
                var _a, _b;
                var firstCharacter = token[0];
                if (firstCharacter === "L") {
                    /* istanbul ignore next */
                    return ((_b = (_a = this.rawDayJsInstance.Ls[this.locale || "en"]) === null || _a === void 0 ? void 0 : _a.formats[token]) !== null && _b !== void 0 ? _b : token);
                }
                return token;
            }).join("").replace(/a/gi, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format);
        };
        this.parseISO = (isoString) => {
            return this.dayjs(isoString);
        };
        this.toISO = (value) => {
            return value.toISOString();
        };
        this.parse = (value, format) => {
            if (value === "") {
                return null;
            }
            return this.dayjs(value, format, this.locale, true);
        };
        this.date = (value) => {
            if (value === null) {
                return null;
            }
            return this.dayjs(value);
        };
        this.toJsDate = (value) => {
            return value.toDate();
        };
        this.isValid = (value) => {
            return this.dayjs(value).isValid();
        };
        this.isNull = (date) => {
            return date === null;
        };
        this.getDiff = (date, comparing, units) => {
            if (typeof comparing === "string") {
                comparing = this.dayjs(comparing);
            }
            if (!comparing.isValid()) {
                return 0;
            }
            return date.diff(comparing, units);
        };
        this.isAfter = (date, value) => {
            return date.isAfter(value);
        };
        this.isBefore = (date, value) => {
            return date.isBefore(value);
        };
        this.isAfterDay = (date, value) => {
            return date.isAfter(value, "day");
        };
        this.isBeforeDay = (date, value) => {
            return date.isBefore(value, "day");
        };
        this.isAfterMonth = (date, value) => {
            return date.isAfter(value, "month");
        };
        this.isBeforeMonth = (date, value) => {
            return date.isBefore(value, "month");
        };
        this.isBeforeYear = (date, value) => {
            return date.isBefore(value, "year");
        };
        this.isAfterYear = (date, value) => {
            return date.isAfter(value, "year");
        };
        this.startOfDay = (date) => {
            return date.startOf("day");
        };
        this.endOfDay = (date) => {
            return date.endOf("day");
        };
        this.format = (date, formatKey) => {
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString) => {
            return this.dayjs(date).format(formatString);
        };
        this.formatNumber = (numberToFormat) => {
            return numberToFormat;
        };
        this.getHours = (date) => {
            return date.hour();
        };
        this.addSeconds = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "second")
                : date.add(count, "second");
        };
        this.addMinutes = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "minute")
                : date.add(count, "minute");
        };
        this.addHours = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "hour")
                : date.add(count, "hour");
        };
        this.addDays = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "day")
                : date.add(count, "day");
        };
        this.addWeeks = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "week")
                : date.add(count, "week");
        };
        this.addMonths = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "month")
                : date.add(count, "month");
        };
        this.addYears = (date, count) => {
            return count < 0
                ? date.subtract(Math.abs(count), "year")
                : date.add(count, "year");
        };
        this.setMonth = (date, count) => {
            return date.set("month", count);
        };
        this.setHours = (date, count) => {
            return date.set("hour", count);
        };
        this.getMinutes = (date) => {
            return date.minute();
        };
        this.setMinutes = (date, count) => {
            return date.set("minute", count);
        };
        this.getSeconds = (date) => {
            return date.second();
        };
        this.setSeconds = (date, count) => {
            return date.set("second", count);
        };
        this.getMonth = (date) => {
            return date.month();
        };
        this.getDate = (date) => {
            return date.date();
        };
        this.setDate = (date, count) => {
            return date.set("date", count);
        };
        this.getDaysInMonth = (date) => {
            return date.daysInMonth();
        };
        this.isSameDay = (date, comparing) => {
            return date.isSame(comparing, "day");
        };
        this.isSameMonth = (date, comparing) => {
            return date.isSame(comparing, "month");
        };
        this.isSameYear = (date, comparing) => {
            return date.isSame(comparing, "year");
        };
        this.isSameHour = (date, comparing) => {
            return date.isSame(comparing, "hour");
        };
        this.getMeridiemText = (ampm) => {
            return ampm === "am" ? "AM" : "PM";
        };
        this.startOfYear = (date) => {
            return date.startOf("year");
        };
        this.endOfYear = (date) => {
            return date.endOf("year");
        };
        this.startOfMonth = (date) => {
            return date.startOf("month");
        };
        this.endOfMonth = (date) => {
            return date.endOf("month");
        };
        this.startOfWeek = (date) => {
            return date.startOf("week");
        };
        this.endOfWeek = (date) => {
            return date.endOf("week");
        };
        this.getNextMonth = (date) => {
            return date.add(1, "month");
        };
        this.getPreviousMonth = (date) => {
            return date.subtract(1, "month");
        };
        this.getMonthArray = (date) => {
            const firstMonth = date.startOf("year");
            const monthArray = [firstMonth];
            while (monthArray.length < 12) {
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.getYear = (date) => {
            return date.year();
        };
        this.setYear = (date, year) => {
            return date.set("year", year);
        };
        this.mergeDateAndTime = (date, time) => {
            return date.hour(time.hour()).minute(time.minute()).second(time.second());
        };
        this.getWeekdays = () => {
            const start = this.dayjs().startOf("week");
            return [0, 1, 2, 3, 4, 5, 6].map((diff) => this.formatByString(start.add(diff, "day"), "dd"));
        };
        this.isEqual = (value, comparing) => {
            if (value === null && comparing === null) {
                return true;
            }
            return this.dayjs(value).isSame(comparing);
        };
        this.getWeekArray = (date) => {
            const start = this.dayjs(date).startOf("month").startOf("week");
            const end = this.dayjs(date).endOf("month").endOf("week");
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while (current.isBefore(end)) {
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = current.add(1, "day");
                count += 1;
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end) => {
            const startDate = this.dayjs(start).startOf("year");
            const endDate = this.dayjs(end).endOf("year");
            const years = [];
            let current = startDate;
            while (current.isBefore(endDate)) {
                years.push(current);
                current = current.add(1, "year");
            }
            return years;
        };
        this.isWithinRange = (date, [start, end]) => {
            return date.isBetween(start, end, null, "[]");
        };
        this.rawDayJsInstance = instance || (dayjs_min_default());
        this.dayjs = withLocale(this.rawDayJsInstance, locale);
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
}



;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/index.js

const formatTokenMap = {
  YY: 'year',
  YYYY: 'year',
  M: 'month',
  MM: 'month',
  MMM: 'month',
  MMMM: 'month',
  D: 'day',
  DD: 'day',
  H: 'hour',
  HH: 'hour',
  h: 'hour',
  hh: 'hour',
  m: 'minute',
  mm: 'minute',
  s: 'second',
  ss: 'second',
  A: 'am-pm',
  a: 'am-pm'
};
class AdapterDayjs extends DayjsUtils {
  constructor(...args) {
    super(...args);
    this.formatTokenMap = formatTokenMap;

    this.expandFormat = format => {
      var _this$rawDayJsInstanc;

      const localeFormats = (_this$rawDayJsInstanc = this.rawDayJsInstance.Ls[this.locale || 'en']) == null ? void 0 : _this$rawDayJsInstanc.formats; // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js

      const t = formatBis => formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b) => a || b.slice(1));

      return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b) => {
        const B = b && b.toUpperCase();
        return a || localeFormats[b] || t(localeFormats[B]);
      });
    };

    this.getFormatHelperText = format => {
      return this.expandFormat(format).replace(/a/gi, '(a|p)m').toLocaleLowerCase();
    };
  }

}
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/utils/getPickersLocalization.js

const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: (0,esm_extends/* default */.Z)({}, pickersTranslations)
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/enUS.js

// This object is not Partial<PickersLocaleText> because it is the default values
const enUSPickers = {
  // Calendar navigation
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  // View navigation
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: view => view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
  inputModeToggleButtonAriaLabel: (isKeyboardInputOpen, viewType) => isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`,
  // DateRange placeholders
  start: 'Start',
  end: 'End',
  // Action bar
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  // Toolbar titles
  datePickerDefaultToolbarTitle: 'Select date',
  dateTimePickerDefaultToolbarTitle: 'Select date & time',
  timePickerDefaultToolbarTitle: 'Select time',
  dateRangePickerDefaultToolbarTitle: 'Select date range',
  // Clock labels
  clockLabelText: (view, time, adapter) => `Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
  hoursClockNumberText: hours => `${hours} hours`,
  minutesClockNumberText: minutes => `${minutes} minutes`,
  secondsClockNumberText: seconds => `${seconds} seconds`,
  // Open picker labels
  openDatePickerDialogue: (rawValue, utils) => rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), 'fullDate')}` : 'Choose date',
  openTimePickerDialogue: (rawValue, utils) => rawValue && utils.isValid(utils.date(rawValue)) ? `Choose time, selected time is ${utils.format(utils.date(rawValue), 'fullTime')}` : 'Choose time',
  // Table labels
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date'
};
const DEFAULT_LOCALE = enUSPickers;
const enUS = getPickersLocalization(enUSPickers);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js






const MuiPickersAdapterContext = /*#__PURE__*/react.createContext(null);

if (false) {}

let warnedOnce = false;
/**
 * @ignore - do not document.
 */

function LocalizationProvider(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLocalizationProvider'
  });
  const {
    children,
    dateAdapter: Utils,
    dateFormats,
    dateLibInstance,
    locale,
    adapterLocale,
    localeText
  } = props;

  if (false) {}

  const utils = react.useMemo(() => new Utils({
    locale: adapterLocale != null ? adapterLocale : locale,
    formats: dateFormats,
    instance: dateLibInstance
  }), [Utils, locale, adapterLocale, dateFormats, dateLibInstance]);
  const defaultDates = react.useMemo(() => {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = react.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText: (0,esm_extends/* default */.Z)({}, DEFAULT_LOCALE, localeText != null ? localeText : {})
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/react-intl/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5719);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(4806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/node_modules/tslib/tslib.es6.js
var tslib_tslib_es6 = __webpack_require__(4874);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(5687);
// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(6284);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 11 modules
var lib = __webpack_require__(9137);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_tslib_es6/* __assign */.pi)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
var formatMessage = function (_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_tslib_es6/* __assign */.pi)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
};

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(2644);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(1050);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = ['type'];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_tslib_es6/* __assign */.pi)((0,tslib_tslib_es6/* __assign */.pi)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), 
        // @ts-expect-error TODO: will get to this later
        formatMessage: formatMessage.bind(null, resolvedConfig, formatters), 
        // @ts-expect-error TODO: will get to this later
        $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(1092);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6/* __rest */._T)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements,
    };
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, coreIntl), { 
        // @ts-expect-error fix this
        formatMessage: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters), 
        // @ts-expect-error fix this
        $t: provider_formatMessage.bind(null, resolvedConfig, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

;// CONCATENATED MODULE: ./src/locale/ru.json
var ru_namespaceObject = JSON.parse('{"65+":"65+ лет","accept":"принять","cookie-text-1":"Мы используем файлы ","cookie-link":"cookie","cookie-text-2":", чтобы сайтом было удобнее пользоваться","begin":"Начать","platforms-promo":"Благодаря совместной работе имена наших партнёров регулярно появляются на первых строчках международных чартов и в списках обладателей Grammy.","code-verify":"Код из письма","get-income":"Получайте доход от вашего творчества","follow-analytics":"Следите за аналитикой","choose-the-essentials":"Выберите самое необходимое","download-your-tracks":"Загрузите ваши треки","terms-and-conditions":"Условия и положения","faq":"F.A.Q.","how-work":"Kак работает","copyright":"© Silk {year}","main":"Главная","show-all":"Показать все","register":"Зарегистрируйтесь","technology-for-artists":"Технологии для артистов, позволяющие достигнуть своей аудитории","send":"Отправить","agree-personal-data":"Даю согласие на обработку Персональных данных","agree":"Даю согласие на обработку","personal-data":"Персональных данных","email":"E-mail","firstname":"Имя","try-now":"Попробуйте прямо сейчас","try-now-button":"Попробуйте сейчас","have-any-questions":"Остались вопросы?","reviews":"Отзывы","upload-new-sounds-benefits":"Загружайте новые композиции, вносите правки, планируйте выход релизов, следите за статусом модерации","catalog-management":"Управление каталогом","platform":"Платформа","over-150-services-creativity":"Более 150 сервисов для вашего творчества","partners":"партнёры","how-work-platform":"Как работает платформа","legal-information":"Правовая информация","legal-data":"Юридические данные","legal-information-desc":"Чтобы каждый артист мог использовать максимум возможностей платформы Silk и получать вознаграждение за монетизацию творчества, мы заключаем с вами официальный договор. \\n\\nЭто формальность, но именно она помогает сделать наше партнерство прозрачным и надежным, а также защищает интеллектуальную собственность от мошенничества. \\n\\nЗагрузить необходимые документы вы можете в соответствующем поле ниже. После оформления они всегда будут доступны в личном кабинете пользователя.","usage-agreement":"Соглашение об использовании","privacy-policy":"Политика обработки персональных данных","cookie-policy":"Политика cookie","search":"Поиск","control":"Управление","moderation":"Модерация","correction":"Исправление","rejected":"Отклонено","distribution":"Дистрибуция","release":"Релиз","all-releases":"Все релизы","analytics":"Аналитика","auditions":"Прослушивания","paid-auditions":"Платные прослушивания","all-auditions":"Все прослушивания","plural-audition":"{count, plural, =0 {Прослушиваний} one {Прослушивание} few {Прослушивания} other {Прослушиваний}}","country":"Страна","artist":"Артист","artists":"Артисты","demography":"Демография","table-details":"Детальная статистика","platforms":"Площадки","playlists":"Плейлисты","plays-month":"прослушиваний/мес.","promotion":"Продвижение","news":"Новости","knowledge-base":"База знаний","profile":"Профиль","settings":"Личный кабинет","logout":"Выйти","finance":"Финансы","operations":"Операции","payments":"Выплаты","balance":"Баланс","all-right-reserved":"Все права защищены","listening-dynamics":"Общая динамика прослушиваний","listening-platforms":"Прослушивания на площадках","download-report":"Скачать отчёт","total":"Всего","quantity":"Количество","share":"Поделиться","analytics-summary":"Сводка аналитики","total-Listens":"Общее количество прослушиваний","general-indicators":"Общие показатели","downloaded-tracks":"Загружено треков","connected-platforms":"Подключено платформ","drafts":"Черновики","in-moderations":"На модерации","need-fixes":"Требуются исправление","ringtone":"Рингтон","ringtones":"Рингтоны","video-clip":"Видеоклип","video-clips":"Видеоклипы","upcoming-releases":"Предстоящие релизы","promo-links":"Промо-ссылки","public-use":"Публичное использование","add-draft":"Добавить черновик","all-drafts":"Все черновики","all-news":"Все новости","all-posts":"Все статьи","more":"Подробнее","more-than":"более","general-info":"Общая информация","general-info-description":"Заполните общую информацию по вашему релизу","upload":"Загрузить","uploading":"Загрузка","persons-roles":"Персоны и роли","genres":"Жанры","booklet":"Буклет","booklets":"Буклеты","identifiers":"Идентификаторы","label":"Лейбл","label-name":"Название лейбла","artist-name-or-label":"Имя артиста или название лейбла","enter-artist-nickname":"Укажите псевдоним артиста","label-desc":"Укажите наименование лейбла, данная информация будет отображена на площадках","dates":"Даты","date-release":"Дата релиза","date-releases":"Даты релиза","additional-materials-short":"Доп. материалы","subtitle":"Подзаголовок","metadata-language":"Язык метаданных","metadata-language-info":"Выберите язык, на котором будет написана информация о релизе","release-name":"Имя релиза","release-description":"Описание релиза","release-info":"Для релизов, которые будут отгружаться на Apple Music: если название трека содержит кириллицу, не нужно переводить его, оставьте оригинальное название","release-type":"Тип релиза","release-kind":"Вид релиза","audio-book":"Аудиокнига","upload-file-title-all":"Загрузите один или несколько файлов","upload-file-description":"Выберите файл или перетащите его сюда","upload-file-title-audio":"Загрузите один или несколько треков","upload-file-title-image":"Загрузите один или несколько изобажений","upload-file-title-video":"Загрузите одно или несколько видео","upload-file-title-all-one":"Загрузите файл","upload-file-title-all-many":"Загрузите файлы","upload-file-description-one":"Выберите файл или перетащите его сюда","upload-file-title-audio-one":"Загрузите трек","upload-file-title-image-one":"Загрузите изображение","upload-file-title-video-one":"Загрузите видео","tracks":"Треки","upload-video":"Загрузить видео","uploading-video":"Загрузка видео","uploading-video-for-track":"Загрузка видео для трека","upload-cover":"Загрузить обложку","persons-and-roles-desc":"Здесь необходимо указать титульные персоны для релиза целиком — это наименование артиста или проекта в том виде, в котором вы хотите видеть его площадках. Таких персон может быть несколько, и у каждой нужно определить роль — исполнитель, соисполнитель (feat.) или remixer","add-role":"Добавить роль","no-roles":"Нет ролей","no-cover":"Нет обложки","choose-name":"Выберите имя","choose-role":"Выберите роль","choose-status":"Выберите статус","choose-legal-status-of-non-resident-rf":"Выберите юридический статус нерезидента РФ","performer":"Исполнитель","producer":"Producer","genre":"Жанр","genre-info":"Основной жанр релиза","subgenre":"Поджанр","subgenre-info":"Дополнительный жанр, элементы которого есть в вашем релизе. Если их нет, оставьте поле пустым","genre-subgenre":"Жанр / поджанр","genre-subgenre-desc":"Укажите основной жанр и поджанр для релиза","identification":"Идентификация","enter-code":"Введите код","partner-code":"Код партнёра","signin-title":"Авторизируйтесь в системе","remember-me":"Запомнить меня","forgot-password-question":"Забыли пароль?","new-on-platform-question":"Впервые на платформе?","create-account":"Создать аккаунт","password":"Пароль","new-password":"Новый пароль","confirm-password":"Подтвердите пароль","verify-code":"Подтвердить код","change-password":"Изменить пароль","changing-password":"Смена пароля","forgot-password":"Восстановление пароля","checking-code-from-email":"Проверьте ваш e-mail","checking-code-label":"Мы отправили код на вашу электронную почту для подтверждения смены пароля","send-reset":"Отправить код","forgot-label":"Введите адрес электронной почты, и мы вышлем вам инструкции по сбросу пароля","login":"Войти","or":"или","signup-title":"Регистрация в системе","signup-description":"Введите свои персональные данные","go-dashboard":"Перейти в панель","i-agree-to":"Я согласен с","with-privacy-policy":"Политикой конфиденциальности","with-terms-use":"Условиями использования","already-have-account":"Уже есть аккаунт?","remember-your-password":"Вспомнили пароль?","sign-in-instead":"Авторизуйтесь","sign-up":"Зарегистрироваться","upload-loading":"Идет загрузка","no-tracks":"Нет треков","no-support-functional-mobile":"Данный функционал не поддерживается на мобильных устройствах","select-from-list":"Выберите название из списка","enter-label-name":"Укажите название лейбла","release-dates":"Даты релиза","release-dates-description":"Укажите основные даты для релиза. Пожалуйста, учитывайте разницу часовых поясов: старт на площадках и открытие предзаказа происходят в указанные даты ровно в 00:00:00 по московскому времени","select-date":"Выберите дату","select-year":"Выберите год","first-publication":"Первая публикация","start-sites":"Старт на площадках","preorder-opening":"Открытие предзаказа","obtaining-copyright":"Получение авторских прав","additional-materials":"Дополнительные материалы","download-booklet":"Загрузить буклет","continue":"Далее","track-name":"Название трека","name":"Название","rights":"Права","author-rights":"Авторские права","related-rights":"Смежные права","home-page":"Главная страница","new-release":"Новый релиз","your-music":"Ваша музыка","changes-required":"Требуются изменения","usage":"Использование","lyrics":"Текст песни","file-for-karaoke":"Файл для караоке","track-version":"Версия трека","video":"Видео","cover":"Обложка","site":"Площадка","sites":"Площадки","sites_many":"Площадок","sites-and-territories":"Площадки и территории","select-sites":"Выбор площадок","some-sites-only":"Только несколько площадок","select-all":"Выбрать все","reset-all":"Сбросить все","territories":"Территории","countries":"Страны","countries_many":"Стран","select-territories":"Выберите территории","some-countries":"В некоторых странах","back":"Назад","single":"Сингл","ep":"EP","album":"Альбом","single-maxi":"Макси-сингл","mixtape":"Микстейп","asia":"Азия","europe":"Европа","africa":"Африка","australia":"Австралия","north-america":"Северная Америка","south-america":"Южная Америка","afghanistan":"Афганистан","albania":"Албания","algeria":"Алжир","american-samoa":"Американское Самоа","andorra":"Андорра","angola":"Ангола","anguilla":"Ангилья","antarctica":"Антарктида","antigua-and-barbuda":"Антигуа и Барбуда","argentina":"Аргентина","armenia":"Армения","aruba":"Аруба","austria":"Австрия","azerbaijan":"Азербайджан","bahamas":"Багамы","bahrain":"Бахрейн","bangladesh":"Бангладеш","barbados":"Барбадос","belarus":"Беларусь","belgium":"Бельгия","belize":"Белиз","benin":"Бенин","bermuda":"Бермуды","bhutan":"Бутан","bolivia":"Боливия","bosnia-and-herzegovina":"Босния и Герцеговина","botswana":"Ботсвана","bouvet-island":"Остров Буве","brazil":"Бразилия","british-indian-ocean-territory":"Британская территория Индийского океана","brunei":"Бруней","bulgaria":"Болгария","burkina-faso":"Буркина-Фасо","burundi":"Бурунди","cambodia":"Камбоджа","cameroon":"Камерун","canada":"Канада","cape-verde":"Кабо-Верде","cayman-islands":"Каймановы острова","central-african-republic":"Центрально-Африканская Республика","chad":"Чад","chile":"Чили","china":"Китай","christmas-island":"Остров Рождества","cocos-keeling-islands":"Кокосовые (Килинг) острова","colombia":"Колумбия","comoros":"Коморы","congo":"Конго","cook-islands":"Острова Кука","costa-rica":"Коста-Рика","croatia":"Хорватия","cuba":"Куба","cyprus":"Кипр","czech-republic":"Чехия","denmark":"Дания","djibouti":"Джибути","dominica":"Доминика","dominican-republic":"Доминиканская Респблика","timor-leste":"Восточный Тимор","ecuador":"Эквадор","egypt":"Египет","el-salvador":"Сальвадор","england":"Англия","equatorial-guinea":"Экваториальная Гвинея","eritrea":"Эритрея","estonia":"Эстония","ethiopia":"Эфиопия","falkland-islands":"Фолклендские острова","faroe-islands":"Фарерские острова","fiji":"Острова Фиджи","finland":"Финляндия","france":"Франция","french-guiana":"Французская Гвиана","french-polynesia":"Французская Полинезия","french-southern-territories":"Южные Французские Территории","gabon":"Габон","gambia":"Гамбия","georgia":"Грузия","germany":"Германия","ghana":"Гана","gibraltar":"Гибралтар","greece":"Греция","greenland":"Гренландия","grenada":"Гренада","guadeloupe":"Гваделупа","guam":"Гуам","guatemala":"Гватемала","guinea":"Гвинея","guinea-bissau":"Гвинея-Бисау","guyana":"Гайана","guernsey":"Гернси","haiti":"Гаити","heard-island-and-mcdonald-islands":"Остров Херд и остров Макдональд","holy-see-vatican-city-state":"Ватикан","honduras":"Гондурас","hong-kong":"Гонконг","hungary":"Венгрия","iceland":"Исландия","india":"Индия","indonesia":"Индонезия","iran":"Иран","iraq":"Ирак","ireland":"Ирландия","israel":"Израиль","italy":"Италия","ivory-coast":"Кот-д\'Ивуар","jamaica":"Ямайка","japan":"Япония","jordan":"Иордания","kazakhstan":"Казахстан","kenya":"Кения","kiribati":"Кирибати","kuwait":"Кувейт","kyrgyzstan":"Киргизия","laos":"Лаос","latvia":"Латвия","lebanon":"Ливан","lesotho":"Лесото","liberia":"Либерия","libyan-arab-jamahiriya":"Ливийская арабская джамахирия","liechtenstein":"Лихтенштейн","lithuania":"Литва","luxembourg":"Люксембург","macao":"Макао","macedonia":"Северная Македония","madagascar":"Мадагаскар","malawi":"Малави","malaysia":"Малайзия","maldives":"Мальдивы","mali":"Мали","malta":"Мальта","marshall-islands":"Маршалловы острова","martinique":"Мартиника","mauritania":"Мавритания","mauritius":"Маврикий","mayotte":"Майотта","mexico":"Мексика","micronesia-federated-states-of":"Микронезия, Федеративные Штаты","moldova":"Молдова","monaco":"Монако","mongolia":"Монголия","montenegro":"Черногория","montserrat":"Монтсеррат","morocco":"Марокко","mozambique":"Мозамбик","myanmar":"Мьянма","namibia":"Намибия","nauru":"Науру","nepal":"Непал","netherlands":"Нидерланды","netherlands-antilles":"Нидерландские Антильские острова","new-caledonia":"Новая Каледония","new-zealand":"Новая Зеландия","nicaragua":"Никарагуа","niger":"Нигер","nigeria":"Нигерия","niue":"Ниуэ","norfolk-island":"Остров Норфолк","north-korea":"Северная Корея","northern-ireland":"Северная Ирландия","northern-mariana-islands":"Северные Марианские острова","norway":"Норвегия","oman":"Оман","pakistan":"Пакистан","palau":"Палау","palestine":"Палестина","panama":"Панама","papua-new-guinea":"Папуа - Новая Гвинея","paraguay":"Парагвай","peru":"Перу","philippines":"Филиппины","pitcairn":"Питкэрн","poland":"Польша","portugal":"Португалия","puerto-rico":"Пуэрто-Рико","qatar":"Катар","reunion":"Реюньон","romania":"Румыния","russian-federation":"Россия","rwanda":"Руанда","saint-helena":"Святая Елена","saint-kitts-and-nevis":"Сент-Китс и Невис","saint-lucia":"Сент-Люсия","saint-pierre-and-miquelon":"Сен-Пьер и Микелон","saint-vincent-and-grenadines":"Святой Винсент и Гренадины","samoa":"Самоа","san-marino":"Сан-Марино","sao-tome-and-principe":"Сан-Томе и Принсипи","saudi-arabia":"Саудовская Аравия","scotland":"Шотландия","senegal":"Сенегал","serbia":"Сербия","seychelles":"Сейшелы","sierra-leone":"Сьерра-Леоне","singapore":"Сингапур","slovakia":"Словакия","slovenia":"Словения","solomon-islands":"Соломоновы острова","somalia":"Сомали","south-africa":"Южная Африка","south-georgia-and-the-south-sandwich-islands":"Южная Георгия и Южные Сандвичевы острова","south-korea":"Южная Корея","south-sudan":"Южный Судан","spain":"Испания","sri-lanka":"Шри-Ланка","sudan":"Судан","suriname":"Суринам","svalbard-and-jan-mayen":"Шпицберген и Ян-Майен","swaziland":"Свазиленд","sweden":"Швеция","switzerland":"Швейцария","syria":"Сирия","tajikistan":"Таджикистан","tanzania":"Танзания","thailand":"Таиланд","congo-democratic-republic":"Демократическая Республика Конго","togo":"Идти","tokelau":"Токелау","tonga":"Тонга","trinidad-and-tobago":"Тринидад и Тобаго","tunisia":"Тунис","turkey":"Турция","turkmenistan":"Туркменистан","turks-and-caicos-islands":"острова Теркс и Кайкос","tuvalu":"Тувалу","uganda":"Уганда","ukraine":"Украина","united-arab-emirates":"Арабские Эмираты","united-kingdom":"Великобритания","united-states":"США","united-states-minor-outlying-islands":"Малые отдаленные острова США","uruguay":"Уругвай","uzbekistan":"Узбекистан","vanuatu":"Вануату","venezuela":"Венесуэла","vietnam":"Вьетнам","virgin-islands-british":"Виргинские острова, Британские","virgin-islands-us":"Виргинские острова, США","wales":"Уэльс","wallis-and-futuna":"Уоллис и Футуна","western-sahara":"Западная Сахара","yemen":"Йемен","zambia":"Замбия","zimbabwe":"Зимбабве","regions":"Регионы","launch-options":"Параметры запуска","special-launch-options":"Специальные параметры запуска","release-date":"Дата релиза","no-selected-sites":"Нет выбраных площадок","feat.":"feat.","feat":"feat","check":"Проверка","enter-release-name":"Укажите название релиза","enter-release-subtitle":"Укажите подзаголовок релиза","choose-metadata-language":"Выберите язык метаданных","choose-release-type":"Выберите тип релиза","choose-release-kind":"Выберите вид релиза","enter-track-name":"Введите название трека","enter-track-subtitle":"Укажите подзаголовок трека","enter-author-rights":"Укажите авторские права","enter-related-rights":"Укажите смежные права","enter-identification-code":"Укажите идентификационный код","enter-partner-code":"Укажите код партнёра","errors-in-release":"Ошибки в релизе","errors-in-tracks":"Ошибки в треках","errors-in-regions-section":"Ошибки в разделе \\"Регионы","to-correct":"Исправить","required-validation":"Обязательное поле","required-validation-one-of":"Одно из полей обязательно к заполнению","required-validation-upload-or-link":"Введите ссылку или загрузите свои треки","data-validation":"Проверка данных","data-validation-desc":"Внимательно проверьте корректность заполненных данных релиза","download-cover":"Загрузите обложку","person-name":"Имя персоны","enter-person-name":"Укажите имя персоны","enter-person-alias":"Укажите псевдоним персоны","enter-person":"Укажите персону","choose-person-role":"Укажите роль персоны","enter-genre":"Укажите жанр","enter-subgenre":"Укажите поджанр","enter-label":"Укажите лейбл","enter-first-publication":"Укажите день начала публикации","enter-start-sites":"Укажите дату старта на площадках","enter-regions":"Укажите регионы","releases":"Релизы","releases-search":"UPC, ISRC, трек, альбом, исполнитель","date-start":"Дата старта","date-created":"Дата создания","submit-for-moderation":"Отправка на модерацию","no-text":"Без текста","no-words":"Без слов","role":"Роль","roles":"Роли","selected":"Выбрано","all-countries":"Все страны","in-all-countries":"Во всех странах","in-all-sites":"На всех площадках","additional-params":"Дополнительные параметры","preliminary-audition-start":"Начало фрагмента","preliminary-audition-start-error":"Начало фрагмента должно быть меньше или равно {time}","tracks-versions":"Версии трека","remove":"Удалить","digital-booklet-description":"PDF-аналог бумажного буклета, который слушатели получат при покупке полного релиза. Опция доступна для некоторых площадок","sites-and-regions":"Площадки и регионы","remove-everything":"Убрать все","isrs":"ISRS","upc":"UPC","total-releases":"Всего релизов","by-name":"По имени","by-date-start":"По дате старта","by-date-release":"По дате релиза","sort-by":"Сортировать по","download-catalog":"Скачать каталог","duration":"Длительность","share-of-rights":"Доля прав","services":"Сервисы","ringtone-unavailable":"Рингтон недоступен","ringtone-available":"Рингтон доступен","lyrics-not-available":"Тексты недоступны","lyrics-available":"Тексты доступны","synchronized-lyrics":"Синхронизированный текст","synchronized-track-lyrics":"Синхронизированный текст трека","synchronized-lyrics-not-available":"Синхронизированный текст трека недоступен","synchronized-lyrics-available":"Синхронизированный текст трека доступен","video-unavailable":"Видео недоступно","video-available":"Видео доступно","tracklist":"Трек-лист","tracklist-desc":"Заполните все данные для каждого трека","untitled":"Без названия","no-description":"Без описания","contact-data":"Контактные данные","contact-data-caption":"Введите ваши данные","social-media":"Социальные сети","social-media-caption":"Добавьте соц.сети","social-link-twitch":"Twitch","social-link-odnoklassniki":"Одноклассники","social-link-facebook":"Facebook","social-link-youtube":"YouTube","social-link-soundcloud":"Soundcloud","social-link-tik-tok":"Tik Tok","social-link-vk":"ВКонтакте","social-link-telegram":"Telegram","add-tracks-caption":"Добавьте треки","city":"Город","next":"Далее","social-link-other":"Другие социальные сети","add-link":"Добавьте ссылку","add-link-to-tracks":"Добавьте ссылку на ваши треки","error-password":"Пароль должен быть не менее 5 символов","repeat-error-password":"Пароли не совпадают","user-alredy-exist":"Пользователь уже зарегистрирован","user-rejected":"Ваш аккаунт заблокирован","user-email-alredy-exist":"Пользователь с такой почтой уже зарегистрирован","incorrect-login-or-password":"Неверный логин или пароль","and":"и","privacy-policy-label-thunk-one":"Я ознакомился с","privacy-policy-label-thunk-two":"политикой конфиденциальности","privacy-policy-label-thunk-three":"и даю согласие на обработку своих данных","email-error":"E-mail должен быть корректным","first-name":"Ваше имя","last-name":"Ваша фамилия","save-changes":"Сохранить изменения","reset":"Сбросить","upload-new-photo":"Загрузить новое фото","allowed-avatar":"Формат PNG, JPEG.","old-password":"Старый пароль","reset-password":"Сбросить пароль","author-right-info":"Укажите доли авторских и смежных прав","additional-params-track-info":"С выбранной секунды начнется воспроизведение фрагмента:\\n\\n- который будет использован на сервисе VK Клипы\\n\\n- который будет использован как сниппет на VK Музыка\\n\\n- который будет проигрываться до покупки на iTunes\\n\\n- который будет использован как сниппет на Apple Music\\n\\n- который будет использован как официальный звук на TikTok, Likee","instant-gratification":"Instant Gratification","instant-gratification-info":"Дата, когда открывается возможность прослушать часть треков с альбома (до 50%). Указанная дата должна быть позже даты предзаказа, но ранее даты старта на площадках. Поддерживают площадки: iTunes, Apple Music, Яндекс Музыка и YouTube Music","identification-track-desc":"Международный стандартный код для точного определения уникальности аудио- или видеозаписи: каждый трек релиза должен обладать собственным ISRC. Если у ваших записей еще нет такого кода, пропустите этот пункт — и мы присвоим его самостоятельно. В случае, если вы переносите уже публиковавшийся контент, поле обязательно к заполнению","explicit-content":"Explicit content","explicit-content-info":"Версия трека, содержащая ненормативную или потенциально оскорбительную лексику","live":"Live","live-info":"Запись живого выступления, если в названии трека вы уже указали Live, не выбирайте параметр","track-cover":"Cover","track-cover-info":"Версия трека, исполненная другим артистом","remix":"Remix","remix-info":"Альтернативная версия выпущенного ранее трека","instrumental":"Instrumental","instrumental-info":"Версия трека без вокальной партии","track-language":"Язык трека","enter-track-language":"Укажите язык трека","track-language-info":"Язык, на котором исполняется трек","instant-gratification-warning":"Только 50% треков с релиза доступны в период предварительного заказа, проверьте настройки ещё раз в других треках","preliminary-audition-date":"Дата предпрослушивания","start-preliminary-audition-date":"Дата начала предпрослушивания","copy-antire-track-list":"Скопировать на весь трек-лист","executor":"Испонитель","music-author":"Автор музыки","lyricist":"Автор текста","remixer":"Remixer","of-feat.s":"Соисполнителей (feat.)","of-performers":"Исполнителей","of-music-authors":"Авторов музыки","of-lyricists":"Авторов текста","of-remixers":"Ремиксеров","of-producers":"Продюсеров","copy-other-tracks":"Скопировать в другие треки","persons-and-roles-track-desc":"Персона «Исполнитель» должна совпадать с указанной в данных релиза. Кроме того, для каждого трека могут обозначаться дополнительные персоны: соисполнитель, автор музыки, автор текста, ремиксер и продюсер. \\n\\nУ авторов музыки и текста необходимо указывать фактические имена и фамилии, а у продюсеров и ремиксеров — псевдоним или сценическое имя","persons-and-roles-track-info":"У авторов музыки и текста необходимо указывать фактические имена и фамилии, а у продюсеров и ремиксеров — псевдоним или сценическое имя","demographics":"Демографические показатели","os":"Операционные системы","country-stream":"География слушателей","add-performer-track":"Добавьте исполнителя трека","add-performer-release":"Добавьте исполнителя релиза","artist-of-release-track-not-match":"«Исполнитель» отличается в данных релиза и трека — проверьте, чтобы персона в этой роли была одинаковой в обоих разделах","do-add-music-author":"Добавьте автора музыки","do-add-lyricist":"Добавьте автора текста","no-words-track-cannot-have-lyricist":"Вы выбрали \\"без слов\\" в языке трека, поэтому автора текста указывать не нужно","instrumental-track-cannot-have-lyricist":"У инструментальной версии трека не должно быть автора текста","congratulations":"Поздравляем","you-release-sent-moderation":"Ваш релиз отправлен на модерацию","release-sent-moderation-with-apply-promo":"Внимание! Вы активировали возможность подачи релиза на промо. О дальнейших шагах мы оповестим вас в течение {days} дней, когда ему будет присвоен UPC","to-list-releases":"К списку релизов","russian":"Русский","english":"Английский","ukrainian":"Украинский","kazakh":"Казахский","romanian":"Румынский","belarusian":"Белорусский","estonian":"Эстонский","latvian":"Латышский","lithuanian":"Литовский","azeri":"Азербайджанский","armenian":"Армянский","georgian":"Грузинский","kyrgyz":"Киргизский","tajik":"Таджикский","turkmen":"Туркменский","uzbek":"Узбекский","polish":"Польский","arabic":"Арабский","turkish":"Турецкий","vietnamese":"Вьетнамский","french":"Французский","german":"Немецкий","spanish":"Испанский","italian":"Итальянский","finnish":"Финский","norwegian":"Норвежский","catalan":"Каталанский","portuguese":"Португальский","afrikaans":"Африкаанс","bengali":"Бенгальский","bulgarian":"Болгарский","czech":"Чешский","danish":"Датский","dutch":"Нидерландский,Голландский","greek":"Греческий,Новогреческий","hebrew":"Иврит","hindi":"Хинди","hungarian":"Венгерский","icelandic":"Исландский","indonesian":"Индонезийский","irish":"Ирландский","japanese":"Японский","korean":"Корейский","lao":"Лаосский","latin":"Латинский","malay":"Малайский","persian":"Персидский","punjabi":"Пенджабский","sanskrit":"Санскрит","slovak":"Словацкий","slovenian":"Словенский","swedish":"Шведский","tagalog":"Тагальский","tamil":"Тамильский","telugu":"Телугу","thai":"Тайский","urdu":"Урду","zulu":"Зулу","tatar":"Татарский","chinese":"Китайский","croatian":"Хорватский","haitian":"Гаитянский","avestan":"Авестийский","single-info":"1-3 трека, длительность каждого менее 10 минут","ep-info":"От 2 до 6 треков общей продолжительностью не более 30 минут","album-info":"От 7 треков и более, общая продолжительность более 30 минут","single-maxi-info":"Содержит от 2 до 3 треков","mixtape-info":"Сборник/компиляция треков, которые не объединены общей идеей","audio-book-info":"Озвученное литературное произведение общей продолжительностью не более 120 минут","data-sent":"Готово","data-sent-desc":"Данные отправлены. Как только мы их проверим, вы получите обратную связь.","go-to-use":"Перейти к использованию","account-verified-desc":"Ваш аккаунт успешно подтверждён, вы можете полноценно использовать нашу платформу","open":"Открыть","close":"Закрыть","message-moderator":"Сообщение модератору","message-moderator-desc":"Добавьте информацию, которая поможет модераторам проверить релиз, например, ссылку на профиль артиста на площадках, особенности отгрузки видео, корректное написание метаданных и т.д.","write-message-moderator":"Напишите сообщение модератору","male":"Мужчины","female":"Женщины","unknown":"Неизвестно","mobile":"Мобильные","desktop":"ПК","other":"Остальное","confirm-delete":"Вы уверены, что хотите удалить","confirm-delete-avatar":"Вы уверены, что хотите удалить аватар","confirm-delete-track":"Вы уверены, что хотите удалить трек","confirm-delete-release":"Вы уверены, что хотите удалить релиз","confirm-delete-file":"Вы уверены, что хотите удалить файл","confirm":"Подтвердить","cancel":"Отмена","sites-list":"Список площадок","sites-list-empty":"Список площадок пока отсутствует","viewing-release-sites":"Просмотр релиза на площадках","viewing-release-info":"Просмотр информации о релизе","copy-release":"Копировать релиз","edit-release":"Редактировать релиз","remove-release":"Удалить релиз","viewing-status-shipment-sites":"Просмотр статуса отгрузки на площадки","shipping-date":"Дата отгрузки","message-absent":"Сообщение отсуствует","release-information":"Информация о релизе","sec":"сек","empty":"Пусто","ringtone-creation":"Создание рингтона","ringtone-creation-description":"Длина от 5 до 29.99 сек.","upload-more":"Загрузить еще","all":"Все","sound":"Звук","yandex":"Яндекс Музыка","umavk":"VK Музыка","umaok":"Одноклассники","spotify":"Spotify","deezer":"Deezer","applemusic":"Apple Music","period-week":"Последняя неделя","period-month":"Последний месяц","period-six-months":"Последние полгода","period-year":"Год","period-custom":"Произвольный","period-start":"Начало периода","period-end":"Конец периода","paid":"Платные","all_streams":"Все прослушивания","all_paystreams":"Платные прослушивания","android":"Android","windows":"Windows","macintosh":"Mac","ios":"iOS","browser":"Браузер","linux":"Linux","type-device":"Типы устройств","tablet":"Планшеты","total-in-device":"Всего на устройствах","filters":"Фильтры","no-data-title":"В настоящий момент данные не доступны","no-data-description":"Сейчас отсутствует информация по статистике для вашего аккаунта","devices-type":"Тип устройств","gender":"Пол","age-group":"Возрастная группа","apply":"Применить","countries-chip":"Страны: {value}","device-types-chip":"Тип устройства: {value}","os-chip":"Операционные системы: {value}","genders-chip":"Пол: {value}","ages-chip":"Возраст: {value}","other-news":"Другие новости","help-center-title":"Добро пожаловать в базу знаний!","help-center-description":"Здесь вы найдёте описание всех функций платформы","press-question":"Задайте вопрос","no-results-found":"Ничего не найдено","notifications":"Уведомления","notifications-new":"{count} новых","read-all-notifications":"Пометить все как прочитанные","error-by-upload-files":"Произошла ошибка при загрузке файлов","files-uploaded-success":"Файлы успешно загружены","error-by-remove-file":"Произошла ошибка при удалении файла","file-removed-success":"Файл успешно удален","error-by-remove-data":"Произошла ошибка при удалении данных","data-removed-success":"Данные успешно удалены","error-by-remove-release":"Произошла ошибка при удалении релиза","error-by-remove-track":"Произошла ошибка при удалении трек","release-removed-success":"Релиз успешно удален","track-removed-success":"Трек успешно удален","error-copy-release":"Произошла ошибка при копировании релиза","release-cody-success":"Копия релиза успешно создана","failed-load-list":"Не удалось загрузить список","failed-save-release":"Не удалось сохранить релиз","release-saved":"Релиз сохранен","failed-create-release":"Не удалось создать релиз","release-created":"Релиз создан","failed-apply-for-promo":"Не удалось подать на промо","promo-created":"Промо создано","promo-saved":"Промо сохранено","promo-accepted":"Промо одобрено","error-submitting-promo-moderation":"Ошибка при попытке отправить промо на модерцию","promo-sent-moderatio":"Промо отправлен на модерацию","error-submitting-release-moderation":"Ошибка при отправке рилиза на модерцию","release-sent-moderation":"Релиз отправлен на модерацию","authorization-error":"Ошибка при авторизации","registration-error":"Ошибка при регистрации","allowed-apple-music":"Доступен в Apple Music","hour-start":"Час старта","commercial-library":"Коммерческая библиотека TikTok","commercial-library-info":"Библиотека TikTok предоставляет коммерческому бизнесу доступ к контенту для размещения рекламы","allowed-full-version-track":"Доступность полной версии трека","allowed-full-version-track-info":"TikTok предоставляет возможность пользователям получать доступ к полной версии композиции","allowed-itunes":"Доступен на iTunes","disable-listening":"Запретить прослушивание","disable-listening-info":"Запрет на возможность бесплатного прослушивания фрагмента релиза в iTunes в период предзаказа","price-category-release":"Ценовая категория релиза","price-category-track":"Ценовая категория трека","minimal-price-category-track":"Минимальная ценовая категория трека","minimal-price-category-track-info":"Отметьте этот пункт, если хотите сделать релиз доступнее в тех странах СНГ, где у iTunes указаны цены в долларах","minimal-price-category-track-countries":"Страны для минимальной ценовой категории трека","support-chat":"Чат поддержки","write-message":"Написать сообщение…","edit-release-info":"Будет создана новая редакция релиза \\"{name}\\". Очень внимательно проверьте даты предзаказа и старта продаж перед тем, как отправите релиз на модерацию. Вы действительно хотите отредактировать релиз?","edit":"Редактировать","unknown-error":"Произошла неизвестная ошибка","incorrect-email-or-password":"Некорректный e-mail или пароль","tracks-count":"Количество треков","back-opt":"Back","budget-one":"Budget One","mid-or-front":"Mid/Front","front-plus":"Front/Plus","digital-45":"Digital 45","mini-ep":"Mini EP","mini-album-one":"Mini Album One","budget-two":"Budget Two","mid":"Mid","front-one":"Front One","front-two":"Front Two","mini-album-two":"Mini Album Two","deluxe-one":"Deluxe One","deluxe-two":"Deluxe Two","deluxe-three":"Deluxe Three","deluxe-four":"Deluxe Four","front":"Front","low":"Low","lowest":"Lowest","next-sites":"Следующие площадки","data-saved-successfully":"Даные успешно сохранены","failed-save-data":"Не удалось сохранить данные","password-updated-successfully":"Пароль успешно обновлен","failed-update-password":"Не удалось обновить пароль","page-not-found":"Страница не найдена","page-not-found-description":"Пожалуйста, проверьте написание в адресной строке или вернитесь на главную страницу","back-to-home":"Вернуться на главную","unauthorized-title":"Вы неавториованы","unauthorized-description":"Авторизуйтесь что бы просматривать эту страницу","by-content":"По контенту","by-countries":"По странам","all-paystreams":"Платные прослушивания","return-to-draft":"Вернуть в черновики","return":"Вернуть","require-change":"Требуют изменения","data-copied-success":"Данные успешно скопированы","data-copied-to-track-list-success":"Данные успешно скопированы в треклист","internal-server-error":"Внутренняя ошибка сервера 👨🏻‍💻","something-went-wrong":"Ой, что-то пошло не так!","all-streams":"Все прослушивания","total-streams":"Общее количество прослушиваний","best-track":"Лучший трек","best-album":"Лучший альбом","best-platform":"Лучшая площадка","best-paid-track":"Прослушивания","zvooq":"Звук","<18":"<18 лет","18-24":"18-24 года","25-34":"25-34 года","35-44":"35-44 года","45-54":"45-54 года","55-64":"55-64 года","press-search":"Начните вводить текст для поиска","search-releases":"Ваша музыка","search-news":"Новости","search-faqs":"База знаний","cant-upload-files-demo-one":"В демо-режиме нельзя загружать медиа-файлы.","cant-upload-files-demo-two":"Чтобы пользоваться всеми возможностями платформы подпишите договор в","cant-upload-files-demo-three":"личном кабинете","popular-searches":"Популярные запросы","compositions":"Композиции","social-media-caption-links":"Добавьте ссылки на соц.сети","error-too-many-files":"Слишком много файлов","error-maximum-attach-files":"Вы можете загрузить не более {count, plural, =0 {файлов} one {# файла} other {# файлов}}","itunes":"iTunes","nodata":"Нет данных","the-best":"Лучшее","upc-code-info":"Уникальный код присваивается каждому альбому, EP или синглу. Если релиз новый, и у вас еще нет UPC, оставьте поле пустым, мы присвоим код самостоятельно. В случае переноса на платформу существующего релиза — поле обязательно к заполнению","partner-code-info":"Ваш собственный код релиза","date-release-platforms-info":"Дата, когда ваш релиз впервые был отгружен на музыкальные площадки. Если релиз новый — не заполняйте это поле, дата будет присвоена автоматически","date-start-platforms-info":"Дата, когда релиз будет опубликован на площадках. Если вы переносите уже существующий релиз, выберите ближайшую дату. Учитывайте, что между загрузкой и публикацией пройдет не менее {days} дней — это ограничение нужно, чтобы избежать ошибок модерации со стороны площадок","date-preorder-info":"Если опция предзаказа релизу не требуется, продублируйте дату старта","date-copyright-info":"Год, когда вы получили авторские права на релиз, будет отображаться на площадках рядом с названием лейбла","license-agreement-with-individual":"Физическое лицо","license-agreement-with-underage-guardianship":"Физическое лицо не достигшее 14 лет, действующее с согласием законного представителя","license-agreement-with-underage":"Физическое лицо не достигшее совершеннолетия (от 14 до 18 лет), действующее с согласием законного представителя","license-agreement-with-self-employed":"Самозанятый","license-agreement-with-individual-entrepreneur":"Индивидуальный предприниматель","license-agreement-with-legal-entity":"Юридическое лицо","license-agreement-with-non-resident-rf":"Нерезидент РФ","data-sent-successfully":"Данные успешно отправлены","data-save-successfully":"Данные успешно сохранены","failed-send-data":"Не удалось сохранить данные","upload-your-files":"Загрузите ваши документы","upload-your-files-desc":"И мы подготовим для вас необходимый контракт, который появиться тут + мы уведомим вас по электронной почте","passport-file":"Паспорт (разворот с фотографией и страница с регистрацией)","payment-details-file":"Реквизиты счёта карты из онлайн-банка","ruble-payment-details-file":"Реквизиты рублёвого счёта карты из онлайн-банка","parents-payment-details":"Платежные реквизиты законного представителя","payment-details-legal-representative":"Реквизиты счёта карты из онлайн-банка законного представителя","birth-certificate-file":"Свидетельство о рождении","passport-representative-file":"Паспорт законного представителя (разворот с фотографией и страница с регистрацией)","self-employed-file":"Справка о статусе самозанятного","certificate-registration-individual-ntrepreneur":"Выписка из ЕГРЮЛ","сertificate-registration-legal-entity":"Справка о регистрации юридического лица","identification-document":"Документ, удостоверяющий личность","certificate-tax-residency":"Справка о налоговом резиденстве","documents-sent":"Данные отправлены, сформированный договор будет выслан вам в течение 15 дней","signed-contract-sent":"Договор отправлен. На его проверку потребуется 3 дня","promo-moderation-is-sent":"Промо отправленно на модерацию, ожидайте подтверждения от менеджеров","reports":"Отчёты","reports-desc":"Здесь находятся ваши финансовые отчёты, вы можете скачать их в любое время","reports-soon":"На этой странице будут отображены ваши финансовые отчёты","request-report":"Запросить отчёт","available":"Доступен","unavailable":"Недоступен","track":"Трэк","album-id":"ID альбома","isrc":"ISRC","date":"Дата","age":"Возраст","show-by":"Показывать по","content-id":"ID контента","error-by-remove-record":"Произошла ошибка при удалении записи","record-removed-success":"Запись успешно удалена","no-results":"Нет результатов","no-results-for":"Нет результатов для \\"{text}","your-contract-ready":"Ваш контракт готов","your-contract-ready-desc":"Пожалуйста скачайте его, распечатайте, подпишите, отсканируйте и отправьте нам","your-contract":"Ваш контракт","attach-scanned-contract-form-below":"Отсканированный контракт прикрепите в форму ниже","download":"Скачать","your-browser-needs-update":"Ваш браузер {name} {version} устарел и не обеспечивает полноценную и безопасную работу с сайтом","revert-uploading":"Отменить загрузку","message-from-moderator":"Сообщение от модератора","upload-songs-here":"Загрузите сюда композиции","go":"Перейти","by-all-users":"По всем пользователям","with-top-performers":"С топовыми исполнителями","captcha-verification-error":"Ошибка валидации капчи","permission-error":"Ошибка прав доступа","access-denied":"Доступ запрещен","additional-information":"Дополнительная информация","additional-information-desc":"Укажите дополнительную информацию для трека","alias":"Псевдоним","set-alias":"Укажите псевдоним","add-alias":"Добавить псевдоним","invalid-password":"Неверный пароль","go-home":"На главную","get-additional-income-promo":"Выберите эту опцию, если у вас есть текст трека и вы хотите создать караоке-файл. Наш сервис сгенерирует его автоматически","format":"Формат","save":"Сохранить","your-contract-signed":"Ваш контракт подписан","your-contract-signed-desc":"Теперь вы можете свободно пользоваться всеми возможностями платформы","logged-impersonation":"Вы авторизованы через дашборд EMD Cloud","instructions-adding-lyrics-item-1":"Укажите текст в точности, как произносит исполнитель","instructions-adding-lyrics-item-2":"Следите за орфографией и пунктуацией","instructions-adding-lyrics-item-3":"Имена собственные, аббревиатуры, географические названия, торговые марки должны быть написаны с заглавной буквы","instructions-adding-lyrics-item-4":"Записывайте слова, даже если секция повторяется, разбивая текст на строчки","instructions-adding-lyrics-item-5":"Если слова повторяются, их все равно нужно прописать","instructions-adding-lyrics-item-6":"Не вводите слишком длинные строки. Одно предложение = одна строка","instructions-adding-lyrics-item-7":"Все строки текста должны быть разделены одинарным интервалом, а каждая строфа (четыре или две строчки с законченной мыслью) – двойным интервалом. Каждый текстовый блок может содержать не более 10 строк","instructions-adding-lyrics-item-8":"Не заканчивайте строки текста точкой или запятой","instructions-adding-lyrics-item-9":"Восклицательные (!), вопросительные знаки (?) и кавычки (« ») — единственные допустимые знаки препинания в конце строки","instructions-adding-lyrics-item-10":"Не используйте пометки «Вступление», «Хор», «Проигрыш»","instructions-adding-lyrics-item-11":"Не пишите «Припев», «Припев 2 раза»","instructions-adding-lyrics-item-12":"Бэк-вокал должен быть заключен в круглые скобки в конце строки, первая буква должна быть заглавной","instructions-adding-lyrics-item-13":"Междометия и звукоподражания стоит также прописывать текстом","instructions-adding-lyrics-item-14":"Войс-тег можно указать на усмотрение автора","instructions-adding-lyrics-item-15":"Не прописывайте компьютерные звуковые эффекты","instructions-adding-lyrics-item-16":"Нецензурная лексика в версии Explicit, должна быть прописана текстом так, как произносится","instructions-adding-lyrics-item-17":"Нецензурная лексика в версии Clean (без галочки на Explicit) прописывается так, как слышится (то есть, если в самом звуке вместо “иди нахуй” слышится “иди на”, то пишем “иди на”)","instructions-adding-lyrics-item-18":"Не используйте в тексте, названии или исполнителях символ «&»","instructions-adding-lyrics-item-19":"Если «&» является неотъемлемым названием коллектива, то его нужно указать через «&amp;» (c amp и точкой с запятой после символа &)","lyrics-desc-one":"Текст песни,","lyrics-desc-two":"подробная инструкция","go-to":"Перейти","inn":"ИНН","snils":"СНИЛС","inn-underage":"ИНН несовершеннолетнего","snils-underage":"СНИЛС несовершеннолетнего","inn-with-underage":"ИНН законного представителя","snils-with-underage":"СНИЛС законного представителя","number":"Номер","error-upc-code":"UPC должен быть длинной от 8 до 15 цифр","error-isrc-code":"Некорректный формат ISRC","error-link":"Некорректная ссылка","error-empty-field":"Это поле не может быть пустым","video-sites-desc":"Укажите площадки, на которых будет распространяться ваше видео","audio-sites-desc":"Укажите площадки, на которых будет распространяться ваш релиз","fullname":"ФИО","current-week-date-preorder-error":"На модерацию релиза нам потребуется {days} дней, поэтому дата предзаказа должна быть на {days} дней больше текущей даты","current-week-date-firs-publication-error":"На модерацию релиза нам потребуется {days} дней, поэтому дата старта должна быть на {days} дней больше текущей даты","create-karaoke-file":"Создать караоке-файл","error":"Ошибка","error-loading-release":"Не удалось загрузить релиз","error-loading-promo":"Не удалось загрузить промо","error-loading-new":"Не удалось загрузить новость","error-loading-finance-report":"Не удалось загрузить финансовый отчёт","select-audio-platforms":"Укажите площадки, на которых будет распространяться ваш релиз","select-release-countries":"Выберите регионы, в которых будет распространяться ваш релиз","need-specify-lyrics-error":"Добавьте текст песни, чтобы мы могли создать караоке файл","error-tracks-by-single-type":"В типе релиза «Сингл» можно загрузить только одну композицию","error-tracks-by-maxi-single-type":"В типе релиза «Макси-сингл» можно добавить только до 3-х композиций, и название одного из треков должно совпадать с названием релиза","error-track-name-by-single-type":"Проверьте названия релиза и трека. Оно должно совпадать","error-track-name-by-maxi-single-type":"Название одного из треков должно совпадать с названием релиза","is-present":"Есть","absent":"Нет","yes":"да","no":"нет","send-moderation-confirm-title-notice":"Отправить релиз на модерацию?","send-moderation-confirm-description-notice":"Во время модерации релиз нельзя будет отредактировать. Пожалуйста, убедитесь, что все данные заполнены правильно","error-edit-release-for-moderation-status":"Релиз находится на стадии модерации, поэтому вы не можете его редактировать","error-edit-release-for-changes-required-status":"Для того, чтобы отредактировать релиз, перейдите в раздел «Требуются изменения» и нажмите «вернуть в черновики»","error-edit-release-for-released-status":"Релиз прошел модерацию, поэтому вы не можете его редактировать","error-edit-promo-for-moderation-status":"Промо находится на стадии модерации, поэтому вы не можете его редактировать","error-edit-promo-for-changes-required-status":"Для того, чтобы отредактировать промо, перейдите в раздел «Требуются изменения» и нажмите «вернуть в черновики»","error-edit-promo-for-accepted-status":"Промо прошел модерацию, поэтому вы не можете его редактировать","account-regected-title":"Ваш аккаунт временно заблокирован","account-rejected-description":"Не переживайте, такое иногда случается. Чтобы обсудить подробности ситуации, пожалуйста, свяжитесь с нами: report@gosilk.ru","technical-break-title":"Мы закрыты на техническое обслуживание","technical-break-description":"Пожалуйста, зайдите позже","refresh-page":"Обновить страницу","release-cover":"Обложка релиза","promo-form-title":"Продвижение релиза","promo-form-description":"Чтобы ваш релиз получил возможность попасть в плейлисты стриминг-сервисов, необходимо заполнить поля ниже. Часть данных автоматически дублируется из раздела «Релиз», а остальные — требуется ввести вручную","enter-release-description":"Укажите описание релиза","marketing-info":"Маркетинговая информация","enter-marketing-info":"Укажите маркетинговую информацию","enter-link":"Укажите ссылку","enter-contry":"Укажите страну","regional-affiliation":"Региональная принадлежность","regional-affiliation-release":"Региональная принадлежность релиза","add-video-for-yandex-music":"Добавить видеошот для Яндекс Mузыки","upload-artist-photo":"Загрузить фото артиста","more-about-promotion":"Подробнее о продвижении","marketing":"Маркетинг","edit-iformation-promo":"Редактировать информацию для промо","year-short":"г.","various-artists":"Various Artists","varus-artists-info":"Используйте функцию «Various Artists», если загружаете сборник из треков разных исполнителей","tech-break-notice":"Сегодня с {startAt} до {endAt} по московскому времени будут проводиться технические работы и обновления. Сервисы платформы будут недоступны. Пожалуйста, завершите или запланируйте вашу работу на другое время","apply-for-promo":"Подать на промо","apply-for-promo-info":"Используйте этот инструмент, чтобы ваш релиз получил возможность попадания в плейлисты сервисов. Обратите внимание — в случае подачи на промо выбор ближайшей даты релиза увеличивается с {days} до {daysApplyPromo} дней после заявки","page":"страница","confirm-delete-demo-release-description":"Данный релиз является образцом по заполнению ваших будущих релизов. \\nВы уверены, что хотите удалить его?","demo-release-info":"Демо-релиз создан специально, чтобы помочь вам избежать ошибок при заполнении собственного релиза. Если он мешает в работе с черновиками, нажмите на иконку корзины, чтобы удалить его","relese-description-field-info":"Кратко расскажите в свободной форме о своем релизе: его особенностях, ключевых сторонах, интересных фактах. Цель этого описания — мотивировать редакторов стримингового сервиса разместить треки в своих плейлистах","marketing-information-field-info":"Если треки вашего релиза уже звучали, анонсировались, или на основе них сделано множество пользовательских публикаций в TikTok, YouTube, или ВКонтакте, укажите данную информацию, приложите ссылки и имеющиеся показатели из соцсетей. В ином случае оставьте поле пустым","regional-affilation-info":"Если ваша музыка имеет этнические или территориальные особенности, вы можете обозначить, к какому региону относится релиз. Это поможет привлечь внимание целевой аудитории и повлиять на то, в какие плейлисты попадут треки. Например, если в песне звучит армянский язык и в качестве региона указана Армения — релиз может попасть в плейлисты, связанные с этой страной","upload-wideo-for-yandex-music-info-1":"Дополните релиз зацикленным роликом продолжительностью до 15 секунд. Для создания видеошота можно использовать специально снятое видео, нарезки из видеоклипов, кадры с бекстейджа или моушндизайн. Придерживайтесь технических требований — обрабатываются только ролики, соответствующие следующим параметрам:","upload-wideo-for-yandex-music-info-2":"Из сервисов, с которыми работает Silk, функция загрузки видеошота вручную необходима только для «Яндекс Музыки»","upload-wideo-for-yandex-music-info-item-1":"видео без звука в формате mp4, H.264","upload-wideo-for-yandex-music-info-item-2":"разрешение 720p (404х720)","upload-wideo-for-yandex-music-info-item-3":"продолжительность 15 секунд","upload-wideo-for-yandex-music-info-item-4":"формат — вертикальный (при загрузке горизонтального видео будет кадрирован центр)","instructions-adding-promo-title":"Ваш релиз может попасть в тематические плейлисты стриминговых сервисов, если он заинтересует редакторов. Чтобы предложить свою музыку к размещению, вам необходимо корректно заполнить все поля раздела, кроме тех, которые заполняются автоматически. Помните, что заполнение формы не гарантирует попадание в плейлист","instructions-adding-promo-item-1":"Пункты «Имя артиста», «Название релиза», «Тип релиза», «Жанр релиза», «UPC релиза» и «Ссылка на прослушивание» автоматически дублируют данные, которые вы указывали ранее","instructions-adding-promo-item-2":"«Описание релиза». Это основной способ рассказать редакторам о своей музыке. В свободной форме опишите особенности релиза, идею, тему или интересные факты, связанные с ним. Ваша задача — заинтересовать редактора разместить контент в плейлисте, который может составляться по определенным критериям. Помните, что лучше всего воспринимается краткая и ёмкая информация","instructions-adding-promo-item-3":"«Маркетинговая информация». Если треки вашего релиза уже звучали, анонсировались, или на основе них сделано множество пользовательских публикаций в YouTube, TikTok или VK, укажите данную информацию, приложите ссылки и имеющиеся показатели из соцсетей. В ином случае оставьте поле пустым","instructions-adding-promo-item-4":"«Ссылки на социальные сети артиста». Разместите ссылки на соцсети, чтобы редактор мог оперативно найти больше информации о вашем творчестве в случае заинтересованности","instructions-adding-promo-item-5":"«Региональная принадлежность». Если ваша музыка имеет этнические или территориальные особенности, вы можете обозначить, к какому региону относится релиз. Это поможет привлечь внимание целевой аудитории и повлиять на то, в какие плейлисты попадут треки. Например, если в песне звучит армянский язык и в качестве региона указана Армения — релиз может попасть в плейлисты, связанные с этой страной","instructions-adding-promo-item-6":"«Фотография артиста». Загрузите фотографию, которую считаете актуальной в настоящее время — она может понадобиться при оформлении редакционных материалов стриминговых сервисов. Обратите внимание: главное — лицо артиста, в кадре не должно быть отвлекающих элементов и посторонних людей. Минимально допустимое разрешение — 1080х1080 точек","instructions-adding-promo-item-7":"Пункт «Загрузка видеошота для «Яндекс Музыки»","instructions-adding-promo-item-8":"Если вы хотите продолжить заполнение формы позже, нажмите кнопку «Сохранить». Когда процесс заполнения закончен — нажимайте «Отправить»","post-links-on-social-networks":"Разместите ссылки на соцсети","error-max-symbols":"Максимальное число символов не должно превышать {length}","avatar-artist":"Обратите внимание: главное — лицо артиста, в кадре не должно быть отвлекающих элементов и посторонних людей. Минимально допустимое разрешение — 1080х1080 точек","cant-send-moderation-promo":"Для подачи релиза на промо нам требуется 7 дней. Если вы хотите отправить данный релиз на промо, перенесите дату старта на площадках обратившись в техническую поддержку","cover-does-not-fit-parameters":"Обложка не подходит по параметрам","minimum-size-for":"Минимальный размер: {width}x{height}px","maximum-size-for":"Максимальный размер: {width}x{height}px","minimum-dpi-size":"Разрешение: не менее {size}dpi","go-to-news-list":"К списку новостей","new-not-found":"Новость не найдена","release-not-found":"Релиз не найден","promo-not-found":"Промо не найдено","finance-report-not-found":"Финансовый отчёт не найден","focus-track":"Фокус трэк","focus-track-info":"Отметьте трек, к которому хотите привлечь внимание слушателя.","focus-track-info-1":"В релизах с количеством треков от 3 до 4 можно отметить 1 фокус-трек","focus-track-info-2":"В релизах с количеством треков от 5 до 10 можно отметить 2 фокус-трека","focus-track-info-3":"В релизах с количеством треков от 11 и более можно отметить 3 фокус-трека","focus-track-info-ps":"Обратите внимание, параметр нельзя использовать для синглов, макси-синглов и аудиокниг.\\n\\nПоддерживает только VK Музыка.","focus-track-warning":"Ознакомьтесь с правилами использования этого параметра, после чего проверьте настройки в других треках","report-unavailable":"Отчёт недоступен","report-available":"Отчёт доступен","signed-report-sent":"Подписанный отчёт отправлен","signed-report-rejected":"Подписанный отчёт отклонен","signed-report-approved":"Подписанный отчёт одобрен и подписан менеджерами","finance-report-desc-1":"В данном разделе пользователи могут скачивать отчёты для ознакомления, а также подписывать их и загружать обратно. Процедура необходима, чтобы выплачивать вознаграждения. Юридически, это возможно только после выполнения всех перечисленных шагов:","finance-report-desc-2":"Иногда у пользователей возникают вопросы — ниже мы собрали наиболее популярные из них.","finance-report-instruction-item-1":"Скачайте отчёт, ознакомьтесь с ним.","finance-report-instruction-item-2":"Распечатайте документ, проверьте его.","finance-report-instruction-item-3":"Если вас всё устраивает, поставьте свою подпись.","finance-report-instruction-item-4":"Отсканируйте или сфотографируйте подписанный отчёт так, чтобы все детали документа хорошо читались.","finance-report-instruction-item-5":"Загрузите обратно скан подписанного экземпляра в соответствующем поле — далее его должны будут подписать менеджеры финансового отдела Silk.","finance-report-instruction-item-6":"Ожидайте, когда специалисты технической поддержки свяжутся с вами для обмена оригиналами документов.","finance-report-faq-title-1":"Когда будет готов мой отчёт?","finance-report-faq-text-1":"Вся информация по предоставлению отчёта указана в Приложении № 2 к лицензионному договору","finance-report-faq-title-2":"Почему, спустя квартал после релиза, я получил информацию не со всеми месяцами продаж?","finance-report-faq-text-2":"Содержание отчёта Silk напрямую зависит от того, с какой периодичностью стриминговые площадки присылают информацию. Иногда магазины отчитываются с задержкой: если какой-либо месяц не попал в текущий отчёт — вероятнее всего, он будет отображён в следующем отчётном периоде.","finance-report-faq-title-3":"Как я могу получить выплату?","finance-report-faq-text-3":"Следуйте инструкции, приведённой выше. Когда документы согласованы и подписаны с обеих сторон, производится выплата авторских отчислений за прошедший период.","finance-report-faq-title-4":"Почему в отчёте представлена информация не по всем ранее вышедшим релизам?","finance-report-faq-text-4":"В отчёте отражаются только те объекты, по которым есть данные от стриминговых площадок. Чаще всего это связано с особенностями периодичности отчётов этих сервисов.","finance-report-faq-title-5":"Как часто мне будет приходить отчёт?","finance-report-faq-text-5":"Отчёт составляется ежеквартально.","registration-clossed-warning":"Внимание! Регистрация временно приостановлена. Наша музыкальная платформа готовится к запуску бета-версии, и мы работаем над улучшением сервисных процессов. Следите за новостями — скоро мы откроем двери для новых талантов!","billions-short":"млрд.","millions-short":"млн.","on-the-platform-since":"на платформе с","since-year":"года","metadata-title-default":"{name} — международная дистрибуция для избранных артистов","metadata-description-default":"Дистрибьюция и продвижение вашей музыки на 70+ стриминг-сервисах. Загружай свои треки через агрегатор музыки Silk, специально для артистов, музыкальных лейблов и продюсеров."}');
;// CONCATENATED MODULE: ./src/locale/en.json
var en_namespaceObject = JSON.parse('{"65+":"65+ years old","accept":"accept","cookie-text-1":"We use ","cookie-link":"Cookies","cookie-text-2":" to make our website more comfortable to use","begin":"Begin","platforms-promo":"As a result of cooperation, the names of our partners regularly appear at the top of international charts and in the lists of Grammy winners.","code-verify":"Code from the message","get-income":"Earn income from your art","follow-analytics":"Follow the analytics","choose-the-essentials":"Choose the most necessary","download-your-tracks":"Upload your tracks","terms-and-conditions":"Terms and conditions","faq":"F.A.Q.","how-work":"How it works","copyright":"© Silk {year}","main":"Main","show-all":"Show all","register":"Sign up","technology-for-artists":"Technologies for artists that allows to reach their audience","send":"Send","agree-personal-data":"I agree to the processing of Personal data","agree":"I agree to the processing","personal-data":"Personal data","email":"E-mail","firstname":"First name","try-now":"Try now","try-now-button":"Try now","have-any-questions":"Got Questions?","reviews":"Reviews","upload-new-sounds-benefits":"Upload new compositions, make edits, plan releases, monitor moderation status","catalog-management":"Catalog management","platform":"Platform","over-150-services-creativity":"Over 150 services for your creativity","partners":"Partners","how-work-platform":"How the platform works","legal-information":"Legal information","legal-data":"Legal data","legal-information-desc":"To ensure that each artist can use the maximum capabilities of the Silk platform and receive remuneration for monetizing their creativity, we conclude an official agreement with you.\\n\\nThis is a formality, but it is what helps make our partnership transparent and reliable, and also protects intellectual property from fraud.\\n\\nYou can upload the necessary documents in the appropriate field below. Once completed, they will always be available in the user\'s personal account.","usage-agreement":"User Agreement","privacy-policy":"Privacy Policy","cookie-policy":"Cookie Policy","search":"Search","control":"Control","moderation":"Moderation","correction":"Correction","rejected":"Rejected","distribution":"Distribution","release":"Release","all-releases":"All releases","analytics":"Analytics","auditions":"Streams","paid-auditions":"Paid Streams","all-auditions":"All streams","plural-audition":"","country":"Country","artist":"Artist","artists":"Artists","demography":"Demography","table-details":"Detailed statistics","platforms":"Platforms","playlists":"Playlists","plays-month":"streams/month","promotion":"Promotion","news":"News","knowledge-base":"Knowledge Base","profile":"Profile","settings":"Personal account","logout":"Log out","finance":"Finance","operations":"Operations","payments":"Payments","balance":"Balance","all-right-reserved":"All rights reserved","listening-dynamics":"General dynamics of streams","listening-platforms":"Streams on the platforms","download-report":"Download report","total":"Total","quantity":"Quantity","share":"Share","analytics-summary":"Analytics report","total-Listens":"Total number of streams","general-indicators":"General numbers","downloaded-tracks":"Tracks uploaded","connected-platforms":"Connected platforms","drafts":"Drafts","in-moderations":"Under moderation","need-fixes":"Changes required","ringtone":"Ringtone","ringtones":"Ringtones","video-clip":"Video clip","video-clips":"Video clips","upcoming-releases":"Upcoming releases","promo-links":"Promo links","public-use":"Public use","add-draft":"Add draft","all-drafts":"All drafts","all-news":"All news","all-posts":"All articles","more":"Read more","more-than":"more than","general-info":"General information","general-info-description":"Fill in general information about your release","upload":"Upload","uploading":"Uploading","persons-roles":"Persons and roles","genres":"Genres","booklet":"Booklet","booklets":"Booklets","identifiers":"Identifiers","label":"Label","label-name":"Label name","artist-name-or-label":"Artist name or label name","enter-artist-nickname":"Please enter artist\'s nickname","label-desc":"Please enter the label name, this information will be displayed on the platforms","dates":"Dates","date-release":"Release date","date-releases":"Release dates","additional-materials-short":"Additional materials","subtitle":"Subtitle","metadata-language":"Metadata language","metadata-language-info":"Select the language in which the release information will be written","release-name":"Release title","release-description":"Release Description","release-info":"For releases that will be uploaded to Apple Music: if the track title contains Cyrillic characters, you do not need to translate it, leave the original title","release-type":"Release type","release-kind":"Release type","audio-book":"Audiobook","upload-file-title-all":"Upload one or more files","upload-file-description":"Select a file or drag it here","upload-file-title-audio":"Upload one or more tracks","upload-file-title-image":"Upload one or more images","upload-file-title-video":"Upload one or more videos","upload-file-title-all-one":"Upload file","upload-file-title-all-many":"Upload files","upload-file-description-one":"Select a file or drag it here","upload-file-title-audio-one":"Upload track","upload-file-title-image-one":"Upload image","upload-file-title-video-one":"Upload video","tracks":"Tracks","upload-video":"Upload video","uploading-video":"Uploading video","uploading-video-for-track":"Uploading video for track","upload-cover":"Upload release cover","persons-and-roles-desc":"Here you need to specify the title persons for the release in full - this is the name of the artist or project in the form in which you want to see it on the platforms. There can be several such persons, and each one needs to have a role - performer, co-performer (feat.) or remixer","add-role":"Add role","no-roles":"No roles","no-cover":"No cover","choose-name":"Select a name","choose-role":"Select a role","choose-status":"Select status","choose-legal-status-of-non-resident-rf":"Select the legal status of a non-resident of the Russian Federation","performer":"Artist","producer":"Producer","genre":"Genre","genre-info":"Main genre of the release","subgenre":"Subgenre","subgenre-info":"An additional genre that your release contains elements of. If none, leave the field blank.","genre-subgenre":"Genre / subgenre","genre-subgenre-desc":"Please indicate the main genre and subgenre for the release.","identification":"Identification","enter-code":"Enter the code","partner-code":"Partner code","signin-title":"Log in to the system","remember-me":"Remember me","forgot-password-question":"Forgot your password?","new-on-platform-question":"New to the platform?","create-account":"Create an account","password":"Password","new-password":"New Password","confirm-password":"Confirm password","verify-code":"Confirm code","change-password":"Change password","changing-password":"Changing the password","forgot-password":"Password recovery","checking-code-from-email":"Check your email","checking-code-label":"We have sent a code to your email to confirm your password change.","send-reset":"Send code","forgot-label":"Enter your email address and we will send you instructions on how to reset your password","login":"Login","or":"or","signup-title":"Registration in the system","signup-description":"Enter your personal data","go-dashboard":"go to dashboard","i-agree-to":"I agree to","with-privacy-policy":"Privacy Policy","with-terms-use":"Terms of Use","already-have-account":"Already have an account?","remember-your-password":"Remembered your password?","sign-in-instead":"Sign in","sign-up":"Sign up","upload-loading":"Loading in progress","no-tracks":"No tracks","no-support-functional-mobile":"This functionality is not supported on mobile devices.","select-from-list":"Select a name from the list","enter-label-name":"Please enter the label name","release-dates":"Release dates","release-dates-description":"Please indicate the main release dates. Please take into account the time zone difference: the launch on the platforms and the opening of pre-orders occur on the specified dates at exactly 12 AM Moscow time","select-date":"Select date","select-year":"Select year","first-publication":"First publication","start-sites":"Start at platforms","preorder-opening":"Pre-order opening","obtaining-copyright":"Obtaining copyright","additional-materials":"Additional materials","download-booklet":"Download the brochure","continue":"Continue","track-name":"Track title","name":"Name","rights":"Rights","author-rights":"Copyright","related-rights":"Related rights","home-page":"Home page","new-release":"New release","your-music":"Your music","changes-required":"Changes are required","usage":"Usage","lyrics":"Song lyrics","file-for-karaoke":"File for karaoke","track-version":"Track version","video":"Video","cover":"Cover","site":"Platform","sites":"Platforms","sites_many":"Platforms","sites-and-territories":"Platforms and territories","select-sites":"Select platforms","some-sites-only":"Only a few platforms","select-all":"Select all","reset-all":"Reset all","territories":"Territories","countries":"Countries","countries_many":"Countries","select-territories":"Select territories","some-countries":"In some countries","back":"Back","single":"Single","ep":"EP","album":"Album","single-maxi":"Maxi single","mixtape":"Mixtape","asia":"Asia","europe":"Europe","africa":"Africa","australia":"Australia","north-america":"North America","south-america":"South America","afghanistan":"Afghanistan","albania":"Albania","algeria":"Algeria","american-samoa":"American Samoa","andorra":"Andorra","angola":"Angola","anguilla":"Anguilla","antarctica":"Antarctica","antigua-and-barbuda":"Antigua and Barbuda","argentina":"Argentina","armenia":"Armenia","aruba":"Aruba","austria":"Austria","azerbaijan":"Azerbaijan","bahamas":"Bahamas","bahrain":"Bahrain","bangladesh":"Bangladesh","barbados":"Barbados","belarus":"Belarus","belgium":"Belgium","belize":"Belize","benin":"Benin","bermuda":"Bermuda","bhutan":"Bhutan","bolivia":"Bolivia","bosnia-and-herzegovina":"Bosnia and Herzegovina","botswana":"Botswana","bouvet-island":"Bouvet Island","brazil":"Brazil","british-indian-ocean-territory":"British Indian Ocean Territory","brunei":"Brunei","bulgaria":"Bulgaria","burkina-faso":"Burkina Faso","burundi":"Burundi","cambodia":"Cambodia","cameroon":"Cameroon","canada":"Canada","cape-verde":"Cape Verde","cayman-islands":"Cayman Islands","central-african-republic":"Central African Republic","chad":"Chad","chile":"Chile","china":"China","christmas-island":"Christmas Island","cocos-keeling-islands":"Cocos (Keeling) Islands","colombia":"Colombia","comoros":"Comoros","congo":"Congo","cook-islands":"Cook Islands","costa-rica":"Costa Rica","croatia":"Croatia","cuba":"Cuba","cyprus":"Cyprus","czech-republic":"Czech Republic","denmark":"Denmark","djibouti":"Djibouti","dominica":"Dominica","dominican-republic":"Dominican Republic","timor-leste":"East Timor","ecuador":"Ecuador","egypt":"Egypt","el-salvador":"El Salvador","england":"England","equatorial-guinea":"Equatorial Guinea","eritrea":"Eritrea","estonia":"Estonia","ethiopia":"Ethiopia","falkland-islands":"Falkland Islands","faroe-islands":"Faroe Islands","fiji":"Fiji Islands","finland":"Finland","france":"France","french-guiana":"French Guiana","french-polynesia":"French Polynesia","french-southern-territories":"French Southern Territories","gabon":"Gabon","gambia":"Gambia","georgia":"Georgia","germany":"Germany","ghana":"Ghana","gibraltar":"Gibraltar","greece":"Greece","greenland":"Greenland","grenada":"Grenada","guadeloupe":"Guadeloupe","guam":"Guam","guatemala":"Guatemala","guinea":"Guinea","guinea-bissau":"Guinea-Bissau","guyana":"Guyana","guernsey":"Guernsey","haiti":"Haiti","heard-island-and-mcdonald-islands":"Heard Island and McDonald Islands","holy-see-vatican-city-state":"Vatican City","honduras":"Honduras","hong-kong":"Hong Kong","hungary":"Hungary","iceland":"Iceland","india":"India","indonesia":"Indonesia","iran":"Iran","iraq":"Iraq","ireland":"Ireland","israel":"Israel","italy":"Italy","ivory-coast":"Ivory Coast (Côte d\'Ivoire)","jamaica":"Jamaica","japan":"Japan","jordan":"Jordan","kazakhstan":"Kazakhstan","kenya":"Kenya","kiribati":"Kiribati","kuwait":"Kuwait","kyrgyzstan":"Kyrgyzstan","laos":"Laos","latvia":"Latvia","lebanon":"Lebanon","lesotho":"Lesotho","liberia":"Liberia","libyan-arab-jamahiriya":"Libya","liechtenstein":"Liechtenstein","lithuania":"Lithuania","luxembourg":"Luxembourg","macao":"Macau (Macau SAR)","macedonia":"North Macedonia","madagascar":"Madagascar","malawi":"Malawi","malaysia":"Malaysia","maldives":"Maldives","mali":"Mali","malta":"Malta","marshall-islands":"Marshall Islands","martinique":"Martinique","mauritania":"Mauritania","mauritius":"Mauritius","mayotte":"Mayotte","mexico":"Mexico","micronesia-federated-states-of":"Micronesia, Federated States of","moldova":"Moldova","monaco":"Monaco","mongolia":"Mongolia","montenegro":"Montenegro","montserrat":"Montserrat","morocco":"Morocco","mozambique":"Mozambique","myanmar":"Myanmar (Burma)","namibia":"Namibia","nauru":"Nauru","nepal":"Nepal","netherlands":"Netherlands","netherlands-antilles":"Netherlands Antilles (dissolved)","new-caledonia":"New Caledonia","new-zealand":"New Zealand","nicaragua":"Nicaragua","niger":"Niger","nigeria":"Nigeria","niue":"Niue","norfolk-island":"Norfolk Island","north-korea":"North Korea","northern-ireland":"Northern Ireland","northern-mariana-islands":"Northern Mariana Islands","norway":"Norway","oman":"Oman","pakistan":"Pakistan","palau":"Palau","palestine":"Palestine","panama":"Panama","papua-new-guinea":"Papua New Guinea","paraguay":"Paraguay","peru":"Peru","philippines":"Philippines","pitcairn":"Pitcairn Islands","poland":"Poland","portugal":"Portugal","puerto-rico":"Puerto Rico","qatar":"Qatar","reunion":"Réunion","romania":"Romania","russian-federation":"Russia","rwanda":"Rwanda","saint-helena":"Saint Helena","saint-kitts-and-nevis":"Saint Kitts and Nevis","saint-lucia":"Saint Lucia","saint-pierre-and-miquelon":"Saint Pierre and Miquelon","saint-vincent-and-grenadines":"Saint Vincent and the Grenadines","samoa":"Samoa","san-marino":"San Marino","sao-tome-and-principe":"Sao Tome and Principe","saudi-arabia":"Saudi Arabia","scotland":"Scotland","senegal":"Senegal","serbia":"Serbia","seychelles":"Seychelles","sierra-leone":"Sierra Leone","singapore":"Singapore","slovakia":"Slovakia","slovenia":"Slovenia","solomon-islands":"Solomon Islands","somalia":"Somalia","south-africa":"South Africa","south-georgia-and-the-south-sandwich-islands":"South Georgia and the South Sandwich Islands","south-korea":"South Korea","south-sudan":"South Sudan","spain":"Spain","sri-lanka":"Sri Lanka","sudan":"Sudan","suriname":"Suriname","svalbard-and-jan-mayen":"Svalbard and Jan Mayen","swaziland":"Swaziland (Eswatini)","sweden":"Sweden","switzerland":"Switzerland","syria":"Syria","tajikistan":"Tajikistan","tanzania":"Tanzania","thailand":"Thailand","congo-democratic-republic":"Democratic Republic of the Congo","togo":"Togo","tokelau":"Tokelau","tonga":"Tonga","trinidad-and-tobago":"Trinidad and Tobago","tunisia":"Tunisia","turkey":"Turkey","turkmenistan":"Turkmenistan","turks-and-caicos-islands":"Turks and Caicos Islands","tuvalu":"Tuvalu","uganda":"Uganda","ukraine":"Ukraine","united-arab-emirates":"United Arab Emirates","united-kingdom":"United Kingdom","united-states":"United States","united-states-minor-outlying-islands":"U.S. Minor Outlying Islands","uruguay":"Uruguay","uzbekistan":"Uzbekistan","vanuatu":"Vanuatu","venezuela":"Venezuela","vietnam":"Vietnam","virgin-islands-british":"British Virgin Islands","virgin-islands-us":"U.S. Virgin Islands","wales":"Wales","wallis-and-futuna":"Wallis and Futuna","western-sahara":"Western Sahara","yemen":"Yemen","zambia":"Zambia","zimbabwe":"Zimbabwe","regions":"Regions","launch-options":"Launch parameters","special-launch-options":"Special launch parameters","release-date":"Release date","no-selected-sites":"No selected platforms","feat.":"feat.","feat":"feat","check":"Check","enter-release-name":"Please specify the release title","enter-release-subtitle":"Please specify the release subtitle","choose-metadata-language":"Select metadata language","choose-release-type":"Choose release type","choose-release-kind":"Select release type","enter-track-name":"Enter track title","enter-track-subtitle":"Enter track subtitle","enter-author-rights":"Enter copyright","enter-related-rights":"Enter neighboring rights","enter-identification-code":"Enter identification code","enter-partner-code":"Enter partner code","errors-in-release":"Errors in release","errors-in-tracks":"Errors in tracks","errors-in-regions-section":"Errors in the \\"Regions\\" section","to-correct":"Correct","required-validation":"Mandatory field","required-validation-one-of":"One of the fields is required","required-validation-upload-or-link":"Enter a link or upload your tracks","data-validation":"Data verification","data-validation-desc":"Carefully check the accuracy of the entered release data","download-cover":"Upload cover art","person-name":"Person\'s name","enter-person-name":"Specify the person\'s name","enter-person-alias":"Specify the person\'s alias","enter-person":"Specify the person","choose-person-role":"Specify the person\'s role","enter-genre":"Specify genre","enter-subgenre":"Specify subgenre","enter-label":"Specify label","enter-first-publication":"Specify start date of publication","enter-start-sites":"Specify start date on platforms","enter-regions":"Specify regions","releases":"Releases","releases-search":"UPC, ISRC, track, album, artist","date-start":"Start date","date-created":"Creation date","submit-for-moderation":"Submission for moderation","no-text":"No text","no-words":"No words","role":"Role","roles":"Roles","selected":"Selected","all-countries":"All countries","in-all-countries":"In all countries","in-all-sites":"On all platforms","additional-params":"Additional parameters","preliminary-audition-start":"Start of fragment","preliminary-audition-start-error":"The start of the fragment must be less than or equal to {time}","tracks-versions":"Track versions","remove":"Delete","digital-booklet-description":"PDF equivalent of a paper booklet that listeners will receive upon purchasing the full release. This option is available for some platforms","sites-and-regions":"Platforms and regions","remove-everything":"Remove all","isrs":"ISRS","upc":"UPC","total-releases":"Total releases","by-name":"By name","by-date-start":"By start date","by-date-release":"By release date","sort-by":"Sort by","download-catalog":"Download catalog","duration":"Duration","share-of-rights":"Rights share","services":"Services","ringtone-unavailable":"Ringtone unavailable","ringtone-available":"Ringtone available","lyrics-not-available":"Lyrics unavailable","lyrics-available":"Lyrics available","synchronized-lyrics":"Synchronized lyrics","synchronized-track-lyrics":"Synchronized track lyrics","synchronized-lyrics-not-available":"Synchronized track lyrics unavailable","synchronized-lyrics-available":"Synchronized track lyrics available","video-unavailable":"Video unavailable","video-available":"Video available","tracklist":"Tracklist","tracklist-desc":"Fill in all data for each track","untitled":"Untitled","no-description":"No description","contact-data":"Contact information","contact-data-caption":"Enter your details","social-media":"Social networks","social-media-caption":"Add social networks","social-link-twitch":"Twitch","social-link-odnoklassniki":"Odnoklassniki","social-link-facebook":"Facebook","social-link-youtube":"YouTube","social-link-soundcloud":"SoundCloud","social-link-tik-tok":"TikTok","social-link-vk":"VKontakte","social-link-telegram":"Telegram","add-tracks-caption":"Add tracks","city":"City","next":"Next","social-link-other":"Other social networks","add-link":"Add link","add-link-to-tracks":"Add a link to your tracks","error-password":"Password must be at least 5 characters long","repeat-error-password":"Passwords do not match","user-alredy-exist":"User already registered","user-rejected":"Your account is blocked","user-email-alredy-exist":"User with this email is already registered","incorrect-login-or-password":"Invalid login or password","and":"and","privacy-policy-label-thunk-one":"I have read the","privacy-policy-label-thunk-two":"privacy policy","privacy-policy-label-thunk-three":"and I consent to the processing of my data","email-error":"E-mail must be valid","first-name":"Your first name","last-name":"Your last name","save-changes":"Save changes","reset":"Reset","upload-new-photo":"Upload a new photo","allowed-avatar":"Format PNG, JPEG.","old-password":"Old password","reset-password":"Reset password","author-right-info":"Specify shares of copyright and related rights","additional-params-track-info":"The playback of the fragment will start from the selected second:\\n\\n- which will be used on the VK Clips service\\n\\n- which will be used as a snippet on VK Music\\n\\n- which will be played before purchase on iTunes\\n\\n- which will be used as a snippet on Apple Music\\n\\n- which will be used as official sound on TikTok, Likee","instant-gratification":"Instant Gratification","instant-gratification-info":"Date for Listening to Album Tracks (up to 50%). The date when the opportunity to listen to part of the tracks from the album opens (up to 50%). The specified date must be later than the pre-order date but earlier than the start date on platforms. Supported platforms: iTunes, Apple Music, Yandex Music, and YouTube Music.","identification-track-desc":"International Standard Code for Unique Identification: Each track of the release must have its own ISRC. If your recordings do not have such a code yet, you can skip this point — we will assign it ourselves. If you are transferring already published content, this field is mandatory.","explicit-content":"Explicit Content","explicit-content-info":"Track version containing inappropriate or potentially offensive language.","live":"Live","live-info":"Recording of a live performance; if you have already indicated \\"Live\\" in the track title, do not select this parameter.","track-cover":"Cover","track-cover-info":"Version of the track performed by another artist.","remix":"Remix","remix-info":"Alternative version of a previously released track.","instrumental":"Instrumental","instrumental-info":"Version of the track without vocal parts.","track-language":"Track Language","enter-track-language":"Specify the language of the track","track-language-info":"the language in which the track is performed","instant-gratification-warning":"Only 50% of tracks from the release are available during the pre-order period; please check the settings again for other tracks.","preliminary-audition-date":"Pre-listening Date","start-preliminary-audition-date":"Date for the start of pre-listening.","copy-antire-track-list":"Copy to Entire Track List","executor":"Artist","music-author":"Author of the music.","lyricist":"Author of the lyrics.","remixer":"Remixer","of-feat.s":"Featured Artists (feat.)","of-performers":"Performers","of-music-authors":"Music Authors","of-lyricists":"Lyric Authors","of-remixers":"Remixers","of-producers":"Producers","copy-other-tracks":"Copy to Other Tracks","persons-and-roles-track-desc":"The \\"Artist\\" persona must match the one specified in the release data. Additionally, for each track, other personas can be designated: featured artist, music author, lyric author, remixer, and producer. It is necessary to provide the actual names and surnames for music and lyric authors, while producers and remixers should provide their stage name or pseudonym.","persons-and-roles-track-info":"It is necessary to provide the actual names and surnames for music and lyric authors, while producers and remixers should provide their stage name or pseudonym.","demographics":"Demographic Indicators","os":"Operating Systems","country-stream":"Listener Geography","add-performer-track":"Add track artist","add-performer-release":"Add release artist","artist-of-release-track-not-match":"The \\"Artist\\" differs in the release and track data — please ensure that the persona in this role is the same in both sections.","do-add-music-author":"Add music author","do-add-lyricist":"Add lyric author","no-words-track-cannot-have-lyricist":"You selected \\"instrumental\\" for the track language, so there is no need to specify a lyric author.","instrumental-track-cannot-have-lyricist":"An instrumental version of a track cannot not have a lyric author.","congratulations":"Congratulations!","you-release-sent-moderation":"Your release has been submitted for moderation.","release-sent-moderation-with-apply-promo":"Attention! You have activated the option to submit a release for promotion. We will notify you of further steps within {days} days when it is assigned a UPC.","to-list-releases":"Back to release list","russian":"Russian","english":"English","ukrainian":"Ukrainian","kazakh":"Kazakh","romanian":"Romanian","belarusian":"Belarusian","estonian":"Estonian","latvian":"Latvian","lithuanian":"Lithuanian","azeri":"Azerbaijani","armenian":"Armenian","georgian":"Georgian","kyrgyz":"Kyrgyz","tajik":"Tajik","turkmen":"Turkmen","uzbek":"Uzbek","polish":"Polish","arabic":"Arabic","turkish":"Turkish","vietnamese":"Vietnamese","french":"French","german":"German","spanish":"Spanish","italian":"Italian","finnish":"Finnish","norwegian":"Norwegian","catalan":"Catalan","portuguese":"Portuguese","afrikaans":"African","bengali":"Bengali","bulgarian":"Bulgarian","czech":"Czech","danish":"Danish","dutch":"Dutch, Hollandic","greek":"Greek, Modern Greek","hebrew":"Hebrew","hindi":"Hindi","hungarian":"Hungarian","icelandic":"Icelandic","indonesian":"Indonesian","irish":"Irish","japanese":"Japanese","korean":"Korean","lao":"Lao","latin":"Latin","malay":"Malay","persian":"Persian","punjabi":"Punjabi","sanskrit":"Sanskrit","slovak":"Slovak","slovenian":"Slovenian","swedish":"Swedish","tagalog":"Tagalog","tamil":"Tamil","telugu":"Telugu","thai":"Thai","urdu":"Urdu","zulu":"Zulu","tatar":"Tatar","chinese":"Chinese","croatian":"Croatian","haitian":"Haitian","avestan":"Avestan","single-info":"1-3 tracks, each lasting less than 10 minutes","ep-info":"From 2 to 6 tracks with a total duration of no more than 30 minutes","album-info":"7 or more tracks, total duration over 30 minutes","single-maxi-info":"Contains 2 to 3 tracks","mixtape-info":"Compilation/collection of tracks that are not united by a common idea","audio-book-info":"An audio literary work with a total duration of no more than 120 minutes","data-sent":"Ready","data-sent-desc":"Data submitted. Once we review it, you will receive feedback.","go-to-use":"Proceed to use the platform","account-verified-desc":"Your account has been successfully verified, you can fully use our platform.","open":"Open","close":"Close","message-moderator":"Message to the moderator","message-moderator-desc":"Add information that will help moderators verify the release, such as a link to the artist\'s profile on platforms, features of video delivery, correct writing of metadata, etc.","write-message-moderator":"Write a message to the moderator","male":"Men","female":"Women","unknown":"Unknown","mobile":"Mobile devices","desktop":"PCs","other":"Others","confirm-delete":"Are you sure you want to delete?","confirm-delete-avatar":"Are you sure you want to delete the avatar?","confirm-delete-track":"Are you sure you want to delete the track?","confirm-delete-release":"Are you sure you want to delete the release?","confirm-delete-file":"Are you sure you want to delete the file?","confirm":"Confirm","cancel":"Cancel","sites-list":"List of platforms","sites-list-empty":"The list of platforms is currently unavailable","viewing-release-sites":"View the release on platforms","viewing-release-info":"View information about the release","copy-release":"Copy release","edit-release":"Edit release","remove-release":"Delete release","viewing-status-shipment-sites":"View shipping status to platforms","shipping-date":"Shipping date","message-absent":"Message is missing","release-information":"Release information","sec":"sec","empty":"Empty","ringtone-creation":"Creating a ringtone","ringtone-creation-description":"Length from 5 to 29.99 seconds.","upload-more":"Upload more","all":"All","sound":"Sound","yandex":"Yandex Music","umavk":"VK Music","umaok":"Odnoklassniki","spotify":"Spotify","deezer":"Deezer","applemusic":"Apple Music","period-week":"Last week","period-month":"Last month","period-six-months":"Last six months","period-year":"Year","period-custom":"Custom","period-start":"Start date","period-end":"End date","paid":"Paid","all_streams":"All listens","all_paystreams":"Paid listens","android":"Android","windows":"Windows","macintosh":"Mac","ios":"iOS","browser":"Browser","linux":"Linux","type-device":"Device types","tablet":"Tablets","total-in-device":"Total on devices","filters":"Filters","no-data-title":"Currently, data is not available","no-data-description":"There is currently no information on statistics for your account","devices-type":"Device types","gender":"Gender","age-group":"Age group","apply":"Apply","countries-chip":"Countries: {value}","device-types-chip":"Device type: {value}","os-chip":"Operating systems: {value}","genders-chip":"Gender: {value}","ages-chip":"Age: {value}","other-news":"Other news","help-center-title":"Welcome to the knowledge base!","help-center-description":"Here you will find descriptions of all platform features","press-question":"Ask a question","no-results-found":"Nothing found","notifications":"Notifications","notifications-new":"{count} new","read-all-notifications":"Mark all as read","error-by-upload-files":"An error occurred while uploading files","files-uploaded-success":"Files uploaded successfully","error-by-remove-file":"An error occurred while deleting the file","file-removed-success":"File deleted successfully","error-by-remove-data":"An error occurred while deleting data","data-removed-success":"Data deleted successfully","error-by-remove-release":"An error occurred while deleting the release","error-by-remove-track":"An error occurred while deleting tracks","release-removed-success":"Release deleted successfully","track-removed-success":"Track deleted successfully","error-copy-release":"An error occurred while copying the release","release-cody-success":"Copy of the release created successfully","failed-load-list":"Failed to load the list","failed-save-release":"Failed to save the release","release-saved":"Release saved successfully","failed-create-release":"Failed to create the release","release-created":"Release created successfully","failed-apply-for-promo":"Failed to submit for promo","promo-created":"Promo created successfully","promo-saved":"Promo saved successfully","promo-accepted":"Promo approved successfully","error-submitting-promo-moderation":"Error sending promo for moderation","promo-sent-moderatio":"Promo sent for moderation successfully","error-submitting-release-moderation":"Error sending the release for moderation","release-sent-moderation":"Release sent for moderation successfully","authorization-error":"Authorization error","registration-error":"Registration error","allowed-apple-music":"Available on Apple Music","hour-start":"Start hour","commercial-library":"Commercial TikTok library","commercial-library-info":"The TikTok library provides commercial businesses access to content for advertising placement","allowed-full-version-track":"Availability of the full version of the track","allowed-full-version-track-info":"TikTok allows users to access the full version of the composition","allowed-itunes":"Available on iTunes","disable-listening":"Prohibit listening","disable-listening-info":"Prohibition on the ability to listen to a free sample of the release on iTunes during the pre-order period","price-category-release":"Release price category","price-category-track":"Track price category","minimal-price-category-track":"Minimum track price category","minimal-price-category-track-info":"Check this box if you want to make the release more accessible in those CIS countries where iTunes prices are listed in dollars","minimal-price-category-track-countries":"Countries for minimum track price category","support-chat":"Support chat","write-message":"Write a message…","edit-release-info":"A new edition of the release \\"{name}\\" will be created. Please check the pre-order and sales start dates very carefully before submitting the release for moderation. Do you really want to edit the release?","edit":"Edit","unknown-error":"An unknown error occurred","incorrect-email-or-password":"Incorrect email or password","tracks-count":"Number of tracks","back-opt":"Back","budget-one":"Budget One","mid-or-front":"Mid/Front","front-plus":"Front/Plus","digital-45":"Digital 45","mini-ep":"Mini EP","mini-album-one":"Mini Album One","budget-two":"Budget Two","mid":"Mid","front-one":"Front One","front-two":"Front Two","mini-album-two":"Mini Album Two","deluxe-one":"Deluxe One","deluxe-two":"Deluxe Two","deluxe-three":"Deluxe Three","deluxe-four":"Deluxe Four","front":"Front","low":"Low","lowest":"Lowest","next-sites":"Next platforms","data-saved-successfully":"Data successfully saved","failed-save-data":"Failed to save data","password-updated-successfully":"Password successfully updated","failed-update-password":"Failed to update password","page-not-found":"Page not found","page-not-found-description":"Please check the spelling in the address bar or return to the homepage","back-to-home":"Return to homepage","unauthorized-title":"You are not authorized","unauthorized-description":"Log in to view this page","by-content":"By content","by-countries":"By countries","all-paystreams":"Paid listens","return-to-draft":"Return to drafts","return":"Return","require-change":"Require changes","data-copied-success":"Data successfully copied","data-copied-to-track-list-success":"Data successfully copied to tracklist","internal-server-error":"Internal server error 👨🏻‍💻","something-went-wrong":"Oops, something went wrong!","all-streams":"All listens","total-streams":"Total number of listens","best-track":"Best track","best-album":"Best album","best-platform":"Best platform","best-paid-track":"Listens","zvooq":"Sound","<18":"<18 years old","18-24":"18-24 years old","25-34":"25-34 years old","35-44":"35-44 years old","45-54":"45-54 years old","55-64":"55-64 years old","press-search":"Start typing text to search","search-releases":"Your music","search-news":"News","search-faqs":"Knowledge base","cant-upload-files-demo-one":"Media files cannot be uploaded in demo mode. To use all platform features, sign a contract in your personal account.","cant-upload-files-demo-two":"To use all platform features, sign a contract in your personal account.  Popular requests","cant-upload-files-demo-three":"personal account.","popular-searches":"Popular requests","compositions":"Compositions","social-media-caption-links":"Add links to social networks  You can upload no more than {count, plural, =0 {files} one {# file} other {# files}}.","error-too-many-files":"Too many files","error-maximum-attach-files":"You can upload no more than {count, plural, =0 {files} one {# file} other {# files}}.","itunes":"iTunes","nodata":"No data","the-best":"Best","upc-code-info":"A unique code is assigned to each album, EP, or single. If the release is new and you do not yet have a UPC, leave the field blank, and we will assign the code ourselves. In case of transferring an existing release to the platform, the field must be filled.","partner-code-info":"Your own release code","date-release-platforms-info":"The date when your release was first shipped to music platforms. If the release is new, do not fill in this field; the date will be assigned automatically.","date-start-platforms-info":"The date when the release will be published on platforms. If you are transferring an existing release, choose the nearest date. Keep in mind that there will be at least {days} days between uploading and publishing — this limitation is necessary to avoid moderation errors from the platforms.","date-preorder-info":"If the pre-order option is not required for the release, duplicate the start date.","date-copyright-info":"The year when you obtained copyright for the release will be displayed on platforms next to the label name.","license-agreement-with-individual":"Individual","license-agreement-with-underage-guardianship":"An individual under 14 years old acting with the consent of a legal representative","license-agreement-with-underage":"An individual who is not of legal age (from 14 to 18 years old) acting with the consent of a legal representative","license-agreement-with-self-employed":"Self-employed","license-agreement-with-individual-entrepreneur":"Individual entrepreneur","license-agreement-with-legal-entity":"Legal entity","license-agreement-with-non-resident-rf":"Non-resident of the Russian Federation","data-sent-successfully":"Data successfully submitted","data-save-successfully":"Data successfully saved","failed-send-data":"Failed to save data","upload-your-files":"Upload your documents","upload-your-files-desc":"And we will prepare the necessary contract for you, which will appear here + we will notify you by email.","passport-file":"Passport (spread with photo and registration page)","payment-details-file":"Account details for the card from the online bank","ruble-payment-details-file":"Ruble account details for the card from the online bank","parents-payment-details":"Payment details of the legal representative","payment-details-legal-representative":"Account details for the card from the online bank of the legal representative","birth-certificate-file":"Birth certificate","passport-representative-file":"Passport of the legal representative (page with photo and registration page)","self-employed-file":"Certificate of self-employment status","certificate-registration-individual-ntrepreneur":"Extract from the Unified State Register of Legal Entities (EGRUL)","сertificate-registration-legal-entity":"Certificate of legal entity registration","identification-document":"Identity document","certificate-tax-residency":"Certificate of tax residency","documents-sent":"Data submitted; the generated contract will be sent to you within 15 days","signed-contract-sent":"Contract sent. It will take 3 days for review","promo-moderation-is-sent":"Promo sent for moderation; please wait for confirmation from managers","reports":"Reports","reports-desc":"Your financial reports are here; you can download them anytime","reports-soon":"Your financial reports will be displayed on this page","request-report":"Request a report","available":"Available","unavailable":"Unavailable","track":"Track","album-id":"Album ID","isrc":"ISRC","date":"Date","age":"Age","show-by":"Show by","content-id":"Content ID","error-by-remove-record":"Error occurred while deleting the record","record-removed-success":"Record successfully deleted","no-results":"No results found","no-results-for":"No results for \\"{text}","your-contract-ready":"Your contract is ready","your-contract-ready-desc":"Please download it, print it, sign it, scan it, and send it to us","your-contract":"Your contract","attach-scanned-contract-form-below":"Attach the scanned contract in the form below","download":"Download","your-browser-needs-update":"Your browser {name} {version} is outdated and does not provide full and secure functionality on the site","revert-uploading":"Cancel download","message-from-moderator":"Message from the moderator","upload-songs-here":"Upload compositions here","go":"Go to","by-all-users":"All users","with-top-performers":"With top performers","captcha-verification-error":"Captcha validation error","permission-error":"Access rights error","access-denied":"Access denied","additional-information":"Additional information","additional-information-desc":"Please provide additional information for the track","alias":"Pseudonym","set-alias":"Please specify a pseudonym","add-alias":"Add pseudonym","invalid-password":"Incorrect password","go-home":"Home page","get-additional-income-promo":"Select this option if you have the track text and want to create a karaoke file. Our service will generate it automatically.","format":"Format","save":"Save","your-contract-signed":"Your contract is signed. Now you can freely use all the platform\'s features.","your-contract-signed-desc":"Now you can freely use all the platform\'s features.","logged-impersonation":"You are authorized through the EMD Cloud dashboard.","instructions-adding-lyrics-item-1":"Please enter the text exactly as pronounced by the performer.","instructions-adding-lyrics-item-2":"Follow spelling and punctuation carefully.","instructions-adding-lyrics-item-3":"Proper nouns, abbreviations, geographical names, and trademarks should be capitalized.","instructions-adding-lyrics-item-4":"Record words even if the section repeats, breaking the text into lines.","instructions-adding-lyrics-item-5":"If words repeat, they still need to be written out.","instructions-adding-lyrics-item-6":"Do not enter overly long lines. One sentence = one line.","instructions-adding-lyrics-item-7":"All lines of text should be separated by a single space, and each stanza (four or two lines with a complete thought) should be double-spaced. Each text block can contain no more than 10 lines.","instructions-adding-lyrics-item-8":"Do not end lines of text with a period or comma.","instructions-adding-lyrics-item-9":"Exclamation marks (!), question marks (?), and quotation marks (« ») are the only acceptable punctuation marks at the end of a line.","instructions-adding-lyrics-item-10":"Do not use notes like \\"Introduction,\\" \\"Chorus,\\" \\"Interlude.","instructions-adding-lyrics-item-11":"Do not write \\"Chorus,\\" \\"Chorus 2 times.","instructions-adding-lyrics-item-12":"Backing vocals should be enclosed in parentheses at the end of the line, and the first letter should be capitalized.","instructions-adding-lyrics-item-13":"interjections and onomatopoeia should also be written out as text.","instructions-adding-lyrics-item-14":"Voice tags can be indicated at the author\'s discretion.","instructions-adding-lyrics-item-15":"Do not write computer sound effects.","instructions-adding-lyrics-item-16":"Profanity in Explicit versions must be written out as pronounced.","instructions-adding-lyrics-item-17":"Profanity in Clean versions (without checking Explicit) is written as heard (i.e., if instead of “go fuck yourself” it sounds like “go on,” then write “go on”).","instructions-adding-lyrics-item-18":"Do not use the symbol \\"&\\" in text, titles, or performers.","instructions-adding-lyrics-item-19":"If \\"&\\" is an integral part of a group\'s name, it should be indicated as \\"amp;\\" (with \\"amp\\" and a semicolon after the  symbol &).","lyrics-desc-one":"Text of the song,","lyrics-desc-two":"detailed instructions","go-to":"Go to","inn":"INN (Tax Identification Number)","snils":"SNILS (Insurance Number)","inn-underage":"Minor\'s INN","snils-underage":"Minor\'s SNILS","inn-with-underage":"Legal representative\'s INN","snils-with-underage":"SNILS of the legal representative","number":"Number","error-upc-code":"UPC must be between 8 to 15 digits long","error-isrc-code":"Incorrect ISRC format","error-link":"Incorrect link","error-empty-field":"This field cannot be empty","video-sites-desc":"Please specify the platforms where your video will be distributed","audio-sites-desc":"Please specify the platforms where your release will be distributed","fullname":"Full name","current-week-date-preorder-error":"We will need {days} days for release moderation, so the pre-order date must be {days} days later than the current date","current-week-date-firs-publication-error":"We will need {days} days for release moderation, so the start date must be {days} days later than the current date","create-karaoke-file":"Create a karaoke file","error":"Error","error-loading-release":"Failed to upload the release","error-loading-promo":"Failed to upload promo","error-loading-new":"Failed to upload news","error-loading-finance-report":"Failed to upload financial report","select-audio-platforms":"Please specify the platforms where your release will be distributed","select-release-countries":"Select the regions where your release will be distributed","need-specify-lyrics-error":"Add the song lyrics so we can create a karaoke file","error-tracks-by-single-type":"In the \\"Single\\" release type, only one composition can be uploaded","error-tracks-by-maxi-single-type":"In the \\"Maxi Single\\" release type, you can add up to 3 compositions, and one of the track titles must match the release title","error-track-name-by-single-type":"Check the titles of the release and track. They must match","error-track-name-by-maxi-single-type":"One of the track titles must match the release title","is-present":"Yes","absent":"No","yes":"Yes","no":"No","send-moderation-confirm-title-notice":"Send the release for moderation?","send-moderation-confirm-description-notice":"During moderation, the release cannot be edited. Please ensure that all data is filled out correctly","error-edit-release-for-moderation-status":"The release is under moderation, so you cannot edit it","error-edit-release-for-changes-required-status":"To edit the release, go to the \\"Changes Required\\" section and click \\"Return to Drafts","error-edit-release-for-released-status":"The release has passed moderation, so you cannot edit it","error-edit-promo-for-moderation-status":"The promo is under moderation, so you cannot edit it","error-edit-promo-for-changes-required-status":"To edit the promo, go to the \\"Changes Required\\" section and click \\"Return to Drafts","error-edit-promo-for-accepted-status":"The promo has passed moderation, so you cannot edit it","account-regected-title":"Your account is temporarily blocked","account-rejected-description":"Don\'t worry, this happens sometimes. To discuss the details of the situation, please contact us: report@gosilk.ru","technical-break-title":"We are closed for maintenance","technical-break-description":"Please check back later","refresh-page":"Refresh the page","release-cover":"Release cover","promo-form-title":"Release promotion","promo-form-description":"To give your release a chance to be included in streaming service playlists, please fill in the fields below. Some data is automatically duplicated from the \\"Release\\" section, while others need to be entered manually","enter-release-description":"Please provide a description of the release","marketing-info":"Marketing information","enter-marketing-info":"Please provide marketing information","enter-link":"Please provide a link","enter-contry":"Please specify the country","regional-affiliation":"Regional affiliation","regional-affiliation-release":"Regional affiliation of the release","add-video-for-yandex-music":"Add a video shot for Yandex Music","upload-artist-photo":"Upload artist photo","more-about-promotion":"More about promotion","marketing":"Marketing","edit-iformation-promo":"Edit information for promo","year-short":"","various-artists":"Various Artists","varus-artists-info":"Use the \\"Various Artists\\" function if you are uploading a compilation of tracks from different artists","tech-break-notice":"Today from {startAt} to {endAt} Moscow time, technical work and updates will be conducted. The platform services will be unavailable. Please complete or schedule your work for another time","apply-for-promo":"Submit for promo","apply-for-promo-info":"Use this tool to give your release a chance to be included in service playlists. Note that when applying for promo, the selection of the nearest release date increases from {days} to {daysApplyPromo} days after submission","page":"Page","confirm-delete-demo-release-description":"This release serves as a sample for filling out your future releases. Are you sure you want to delete it?","demo-release-info":"The demo release is created specifically to help you avoid mistakes when filling out your own release. If it interferes with working on drafts, click on the trash can icon to delete it.","relese-description-field-info":"Briefly describe your release in free form: its features, key aspects, and interesting facts. The purpose of this description is to motivate the editors of the streaming service to include the tracks in their playlists.","marketing-information-field-info":"If the tracks from your release have already been played, announced, or have generated numerous user publications on TikTok, YouTube, or VKontakte, please provide this information, along with links and any available metrics from social media. Otherwise, leave the field blank.","regional-affilation-info":"If your music has ethnic or territorial characteristics, you can indicate which region the release belongs to. This will help attract the attention of the target audience and influence which playlists the tracks will be included in. For example, if the song features the Armenian language and Armenia is indicated as the region, the release may be included in playlists related to that country.","upload-wideo-for-yandex-music-info-1":"Supplement your release with a looping video clip of up to 15 seconds. You can use specially shot video, clips from music videos, behind-the-scenes footage, or motion design for the video shot. Please adhere to the technical requirements—only videos that meet the following parameters will be processed:","upload-wideo-for-yandex-music-info-2":"From the services that Silk works with, manual upload of the video shot is only required for \\"Yandex Music.","upload-wideo-for-yandex-music-info-item-1":"Video without sound in mp4 format, H.264","upload-wideo-for-yandex-music-info-item-2":"Resolution 720p (404x720)","upload-wideo-for-yandex-music-info-item-3":"Duration 15 seconds","upload-wideo-for-yandex-music-info-item-4":"Format - vertical (if horizontal video is uploaded, it will be cropped to center)","instructions-adding-promo-title":"Your release may be included in thematic playlists of streaming services if it interests the editors. To propose your music for placement, you need to fill out all fields in the section correctly, except for those that are filled out automatically. Remember that filling out the form does not guarantee placement in a playlist.","instructions-adding-promo-item-1":"The fields \\"Artist Name,\\" \\"Release Title,\\" \\"Release Type,\\" \\"Release Genre,\\" \\"Release UPC,\\" and \\"Listening Link\\" automatically duplicate the data you provided earlier.","instructions-adding-promo-item-2":"Release Description.\\" This is the main way to tell editors about your music. Describe the features of the release, the idea, theme, or interesting facts related to it in free form. Your task is to interest the editor in placing content in a playlist that may be compiled based on certain criteria. Remember that concise and clear information is best received.","instructions-adding-promo-item-3":"Marketing Information.\\" If the tracks from your release have already been played, announced, or have generated numerous user publications on YouTube, TikTok, or VK, please provide this information, along with links and any available metrics from social media. Otherwise, leave the field blank.","instructions-adding-promo-item-4":"Artist\'s Social Media Links.\\" Provide links to social media so that the editor can quickly find more information about your work if interested.","instructions-adding-promo-item-5":"Regional Affiliation.\\" If your music has ethnic or territorial characteristics, you can indicate which region the release belongs to. This will help attract the attention of the target audience and influence which playlists the tracks will be included in. For example, if the song features the Armenian language and Armenia is indicated as the region, the release may be included in playlists related to that country.","instructions-adding-promo-item-6":"Artist Photo.\\" Upload a photo that you consider relevant at this time—it may be needed when preparing editorial materials for streaming services. Please note: the focus should be on the artist\'s face; there should be no distracting elements or other people in the frame. The minimum acceptable resolution is 1080x1080 pixels.","instructions-adding-promo-item-7":"The \\"Upload Video Shot for Yandex Music\\" section.","instructions-adding-promo-item-8":"If you want to continue filling out the form later, click the \\"Save\\" button. When you have finished filling out the form—click \\"Submit.","post-links-on-social-networks":"Provide links to social media","error-max-symbols":"The maximum number of characters must not exceed {length}.","avatar-artist":"Please note: the focus should be on the artist\'s face; there should be no distracting elements or other people in the frame. The minimum acceptable resolution is 1080x1080 pixels.","cant-send-moderation-promo":"To submit a release for promotion, we require 7 days. If you want to send this release for promotion, please move the start date on the platforms by contacting technical support.","cover-does-not-fit-parameters":"The cover does not meet the parameters.","minimum-size-for":"Minimum size: {width}x{height}px.","maximum-size-for":"Maximum size: {width}x{height}px.","minimum-dpi-size":"Resolution: at least {size}dpi.","go-to-news-list":"To the news list.","new-not-found":"News not found.","release-not-found":"Release not found.","promo-not-found":"Promo not found.","finance-report-not-found":"Financial report not found.","focus-track":"Focus track.","focus-track-info":"Select the track you want to draw the listener\'s attention to.","focus-track-info-1":"In releases with 3 to 4 tracks, you can select 1 focus track.","focus-track-info-2":"In releases with 5 to 10 tracks, you can select 2 focus tracks.","focus-track-info-3":"In releases with 11 or more tracks, you can select 3 focus tracks.","focus-track-info-ps":"Please note that this parameter cannot be used for singles, maxi-singles, and audiobooks.  Supports only VK Music.","focus-track-warning":"Familiarize yourself with the rules for using this parameter, and then check the settings in other tracks.","report-unavailable":"Report unavailable.","report-available":"Report available.","signed-report-sent":"Signed report sent.","signed-report-rejected":"Signed report rejected.","signed-report-approved":"Signed report approved and signed by managers.","finance-report-desc-1":"In this section, users can download reports for review, as well as sign them and upload them back. This procedure is necessary to process payments. Legally, this is only possible after completing all the listed steps:","finance-report-desc-2":"Sometimes users have questions—below we have gathered the most popular ones.","finance-report-instruction-item-1":"Download the report and review it.","finance-report-instruction-item-2":"Print the document and check it.","finance-report-instruction-item-3":"If everything is satisfactory, sign it.","finance-report-instruction-item-4":"Scan or photograph the signed report so that all details of the document are clearly readable.","finance-report-instruction-item-5":"Upload the scan of the signed copy back in the appropriate field—then it will need to be signed by the managers of Silk\'s finance department.","finance-report-instruction-item-6":"Wait for technical support specialists to contact you to exchange original documents.","finance-report-faq-title-1":"When will my report be ready?","finance-report-faq-text-1":"All information regarding the provision of reports is specified in Appendix No. 2 to the licensing agreement.","finance-report-faq-title-2":"Why, a quarter after the release, did I receive information not covering all months of sales?","finance-report-faq-text-2":"The content of the Silk report directly depends on how frequently streaming platforms send information. Sometimes stores report with a delay: if any month is missing from the current report—it is likely to appear in the next reporting period.","finance-report-faq-title-3":"How can I receive payment?","finance-report-faq-text-3":"Follow the instructions provided above. When the documents are agreed upon and signed by both parties, payment of royalties for the past period will be made.","finance-report-faq-title-4":"Why does the report contain information not covering all previously released releases?","finance-report-faq-text-4":"The report only reflects those items for which there is data from streaming platforms. Most often, this is related to the reporting frequency of these services.","finance-report-faq-title-5":"How often will I receive a report?","finance-report-faq-text-5":"Reports are generated quarterly.","registration-clossed-warning":"Attention! Registration is temporarily suspended. Our music platform is preparing to launch a beta version, and we are working on improving service processes. Stay tuned - soon we will open the doors to new talents!","billions-short":"bn","millions-short":"mn","on-the-platform-since":"on the platform since","since-year":"year","metadata-title-default":"{name} — International distribution for artists","metadata-description-default":"Distribute and promote your music on 70+ streaming services. Upload your tracks through the Silk music aggregator, specifically for artists, music labels, and producers."}');
;// CONCATENATED MODULE: ./src/configs/platform-localizations.ts
// ** Locales


const platformLanguages = [
    {
        label: "Русский",
        value: "ru",
        country: "RUS",
        options: ru_namespaceObject
    },
    {
        label: "English",
        value: "en",
        country: "GBR",
        options: en_namespaceObject
    }
];
/* harmony default export */ var platform_localizations = (platformLanguages);

;// CONCATENATED MODULE: ./src/context/LocalizationContext.tsx
// ** React Imports


// ** MUI Imports


// ** Intl Imports

// ** Effector Imports

// ** Config Imports

// ** Source code Imports

const LocalizationContext_LocalizationProvider = (param)=>{
    let { children  } = param;
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const languageMessages = (0,react.useMemo)(()=>{
        var ref, ref1;
        const currentLanguage = (ref = platform_localizations.find((param)=>{
            let { value  } = param;
            return value === language;
        })) === null || ref === void 0 ? void 0 : ref.options;
        return currentLanguage || ((ref1 = platform_localizations[0]) === null || ref1 === void 0 ? void 0 : ref1.options);
    }, [
        language
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider, {
        adapterLocale: language,
        dateAdapter: AdapterDayjs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(provider, {
            messages: languageMessages,
            locale: language,
            defaultLocale: language,
            children: children
        })
    });
};


// EXTERNAL MODULE: ./src/context/HistoryContext.tsx
var HistoryContext = __webpack_require__(9930);
// EXTERNAL MODULE: ./src/@core/context/settingsContext.tsx
var settingsContext = __webpack_require__(4737);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/ru.js
var ru = __webpack_require__(600);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
;// CONCATENATED MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ var ResizeObserver_es = (index);

// EXTERNAL MODULE: ./node_modules/@unleash/proxy-client-react/dist/unleash-react.js + 1 modules
var unleash_react = __webpack_require__(8676);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(1719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(120);
;// CONCATENATED MODULE: ./src/@core/styles/libs/react-hot-toast/index.ts
// ** MUI Imports


// ** Hook Import

const ReactHotToast = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    // ** Hook & Var
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const { layout , navHidden  } = settings;
    return {
        "& > div": {
            left: "".concat(theme.spacing(6), " !important"),
            right: "".concat(theme.spacing(6), " !important"),
            bottom: "".concat(theme.spacing(6), " !important"),
            zIndex: "".concat(theme.zIndex.drawer - 1, " !important"),
            top: layout === "horizontal" && !navHidden ? "139px !important" : "75px !important"
        },
        "& .react-hot-toast": {
            fontWeight: 400,
            fontSize: "1rem",
            borderRadius: "5px",
            letterSpacing: "0.14px",
            color: theme.palette.text.primary,
            background: theme.palette.background.paper,
            boxShadow: theme.palette.mode === "light" ? "0px 4px 10px -4px rgba(58, 53, 65, 0.6)" : "0px 8px 16px -4px rgba(19, 17, 32, 0.65)",
            "&>:first-of-type:not([role])>:first-of-type": {
                width: 14,
                height: 14
            }
        }
    };
});
/* harmony default export */ var react_hot_toast = (ReactHotToast);

;// CONCATENATED MODULE: ./src/@core/utils/create-emotion-cache.ts

const createEmotionCache = ()=>{
    return emotion_cache_browser_esm({
        key: "css"
    });
};

// EXTERNAL MODULE: ./node_modules/prismjs/prism.js
var prism = __webpack_require__(5660);
// EXTERNAL MODULE: ./node_modules/prismjs/themes/prism-tomorrow.css
var prism_tomorrow = __webpack_require__(8386);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-jsx.js
var prism_jsx = __webpack_require__(2356);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-tsx.js
var prism_tsx = __webpack_require__(1029);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/dist/css/styles.css
var css_styles = __webpack_require__(7187);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./src/iconify-bundle/icons-bundle-react.js

(0,iconify/* addCollection */.Hc)({
    prefix: "mdi",
    lastModified: 1658119761,
    icons: {
        "ab-testing": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v8h2V8h2v4h2V4a2 2 0 0 0-2-2H4m0 2h2v2H4m18 9.5V14a2 2 0 0 0-2-2h-4v10h4a2 2 0 0 0 2-2v-1.5a1.54 1.54 0 0 0-1.5-1.5a1.54 1.54 0 0 0 1.5-1.5M20 20h-2v-2h2v2m0-4h-2v-2h2M5.79 21.61l-1.58-1.22l14-18l1.58 1.22Z"/>'
        },
        abacus: {
            body: '<path fill="currentColor" d="M5 5h2v6H5V5m5 0H8v6h2V5M5 19h2v-6H5v6m5-6H8v6h2v-2h5v-2h-5v-2m-8 8h2V3H2v18M20 3v4h-7V5h-2v6h2V9h7v6h-2v-2h-2v6h2v-2h2v4h2V3h-2Z"/>'
        },
        "abjad-arabic": {
            body: '<path fill="currentColor" d="M12 4c-1.92 0-3.5 1.58-3.5 3.5c0 .93.38 1.78 1 2.41c-1.53 1-2.5 2.71-2.5 4.59c0 3.03 2.47 5.5 5.5 5.5c1.76 0 3.5-.46 5-1.34l-1-1.73c-1.22.7-2.6 1.07-4 1.07c-1.94 0-3.5-1.55-3.5-3.5a3.49 3.49 0 0 1 2.59-3.38l5.21-1.4l-.52-1.93L11.83 9c-.75-.1-1.33-.72-1.33-1.5c0-.84.66-1.5 1.5-1.5c.26 0 .5.07.75.2l1-1.73C13.22 4.16 12.61 4 12 4Z"/>'
        },
        "abjad-hebrew": {
            body: '<path fill="currentColor" d="M3.9 4L9 10.03a3.444 3.444 0 0 0-3 2.56L4 20h2.07l1.85-6.89c.17-.65.77-1.11 1.44-1.11h1.33l6.78 8h2.63L15 13.97a3.444 3.444 0 0 0 3-2.56L20 4h-2.07l-1.85 6.89c-.17.65-.77 1.11-1.44 1.11h-1.33L6.53 4Z"/>'
        },
        "abugida-devanagari": {
            body: '<path fill="currentColor" d="M8 3v2h3c1.32 0 2.41.83 2.82 2H6v2h8v1h-2c-2.75 0-5 2.25-5 5s2.25 5 5 5c.77 0 1.45-.27 2-.7V21h2v-4h-2c-.45.62-1.17 1-2 1c-1.67 0-3-1.33-3-3s1.33-3 3-3h4V9h2V7h-2.1c-.47-2.28-2.49-4-4.9-4H8Z"/>'
        },
        "abugida-thai": {
            body: '<path fill="currentColor" d="M9 20c0-2.56 1.87-7.58 4.86-12.75C14.29 6.5 15.08 6 16 6c1.12 0 2 .88 2 2v12h2V8c0-2.2-1.8-4-4-4c-1.66 0-3.1.92-3.87 2.25c-1.57 2.71-2.52 4.9-3.13 6.78V6.5C9 5.13 7.87 4 6.5 4S4 5.13 4 6.5S5.13 9 6.5 9c.17 0 .34 0 .5-.05V20M6.5 6c.29 0 .5.21.5.5c0 .29-.21.5-.5.5c-.29 0-.5-.21-.5-.5c0-.29.21-.5.5-.5Z"/>'
        },
        "access-point": {
            body: '<path fill="currentColor" d="M4.93 4.93A9.969 9.969 0 0 0 2 12c0 2.76 1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 12c0-2.21.89-4.22 2.34-5.66L4.93 4.93m14.14 0l-1.41 1.41A7.955 7.955 0 0 1 20 12c0 2.22-.89 4.22-2.34 5.66l1.41 1.41A9.969 9.969 0 0 0 22 12c0-2.76-1.12-5.26-2.93-7.07M7.76 7.76A5.98 5.98 0 0 0 6 12c0 1.65.67 3.15 1.76 4.24l1.41-1.41A3.99 3.99 0 0 1 8 12c0-1.11.45-2.11 1.17-2.83L7.76 7.76m8.48 0l-1.41 1.41A3.99 3.99 0 0 1 16 12c0 1.11-.45 2.11-1.17 2.83l1.41 1.41A5.98 5.98 0 0 0 18 12c0-1.65-.67-3.15-1.76-4.24M12 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "access-point-check": {
            body: '<path fill="currentColor" d="m20.59 14.84l1.16 1.41L17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59m-1.52-9.91l-1.41 1.41A7.955 7.955 0 0 1 20 12v.34c.68.25 1.33.62 1.88 1.09c.07-.47.12-.93.12-1.43c0-2.76-1.12-5.26-2.93-7.07m-3.11 7.43c.64-.23 1.32-.36 2.04-.36c0-1.65-.67-3.15-1.76-4.24l-1.41 1.41A3.99 3.99 0 0 1 16 12c0 .12-.03.24-.04.36M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 12c0-2.21.89-4.22 2.34-5.66m1.42 1.42C6.67 8.85 6 10.35 6 12s.67 3.15 1.76 4.24l1.41-1.41C8.45 14.11 8 13.11 8 12s.45-2.11 1.17-2.83L7.76 7.76Z"/>'
        },
        "access-point-minus": {
            body: '<path fill="currentColor" d="M16 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41A5.98 5.98 0 0 1 18 12c-.72 0-1.4.13-2.04.36c.01-.12.04-.24.04-.36m4 .34c.68.25 1.33.62 1.88 1.09c.07-.47.12-.93.12-1.43c0-2.76-1.12-5.26-2.93-7.07l-1.41 1.41A7.955 7.955 0 0 1 20 12v.34M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M7.76 7.76C6.67 8.85 6 10.35 6 12s.67 3.15 1.76 4.24l1.41-1.41C8.45 14.11 8 13.11 8 12s.45-2.11 1.17-2.83L7.76 7.76M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 12c0-2.21.89-4.22 2.34-5.66M14 19h8v-2h-8v2Z"/>'
        },
        "access-point-network": {
            body: '<path fill="currentColor" d="M4.93 3.93A9.969 9.969 0 0 0 2 11c0 2.76 1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 11c0-2.21.89-4.22 2.34-5.66L4.93 3.93m14.14 0l-1.41 1.41A7.955 7.955 0 0 1 20 11c0 2.22-.89 4.22-2.34 5.66l1.41 1.41A9.969 9.969 0 0 0 22 11c0-2.76-1.12-5.26-2.93-7.07M7.76 6.76A5.98 5.98 0 0 0 6 11c0 1.65.67 3.15 1.76 4.24l1.41-1.41A3.99 3.99 0 0 1 8 11c0-1.11.45-2.11 1.17-2.83L7.76 6.76m8.48 0l-1.41 1.41A3.99 3.99 0 0 1 16 11c0 1.11-.45 2.11-1.17 2.83l1.41 1.41A5.98 5.98 0 0 0 18 11c0-1.65-.67-3.15-1.76-4.24M12 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-1 6v4h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7a1 1 0 0 0-1-1h-1v-4h-2Z"/>'
        },
        "access-point-network-off": {
            body: '<path fill="currentColor" d="M14.83 13.83A3.99 3.99 0 0 0 16 11c0-1.11-.45-2.11-1.17-2.83l1.41-1.41A5.98 5.98 0 0 1 18 11c0 1.65-.67 3.15-1.76 4.24l-1.41-1.41M14 11a2 2 0 0 0-2-2c-.6 0-1.13.27-1.5.68l2.82 2.82c.41-.37.68-.9.68-1.5m3.66 5.66l1.41 1.41A9.969 9.969 0 0 0 22 11c0-2.76-1.12-5.26-2.93-7.07l-1.41 1.41A7.955 7.955 0 0 1 20 11c0 2.22-.89 4.22-2.34 5.66M22 21.18V20h-1.18L22 21.18m-1.73.82l.73.73L19.73 24l-2-2H15a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-3.73l-2.66-2.66c.2.46.48.89.83 1.22l-1.41 1.41A5.98 5.98 0 0 1 6 11c0-.23 0-.46.04-.69L4.37 8.64C4.14 9.39 4 10.18 4 11c0 2.22.89 4.22 2.34 5.66l-1.41 1.41A9.969 9.969 0 0 1 2.81 7.08L1 5.27L2.28 4L3.7 5.42l1.45 1.45l1.48 1.48L8.17 9.9l2.11 2.1l.72.71L18.27 20h.01l2 2h-.01m-4.54-2L13 17.27V19h1a1 1 0 0 1 1 1h.73Z"/>'
        },
        "access-point-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L12.1 14H12a2 2 0 0 1-2-2v-.1l-1.6-1.61c-.25.52-.4 1.09-.4 1.71c0 1.11.45 2.11 1.17 2.83l-1.41 1.41A5.98 5.98 0 0 1 6 12c0-1.17.34-2.26.93-3.18L5.5 7.37C4.55 8.67 4 10.27 4 12c0 2.22.89 4.22 2.34 5.66l-1.41 1.41A9.969 9.969 0 0 1 2 12c0-2.28.77-4.37 2.06-6.05L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27m-4.91-10l1.6 1.6c.3-.72.47-1.5.47-2.33c0-1.65-.67-3.15-1.76-4.24l-1.41 1.41a3.99 3.99 0 0 1 1.1 3.56m3.1 3.1l1.47 1.45c.94-1.53 1.5-3.34 1.5-5.28c0-2.76-1.12-5.26-2.93-7.07l-1.41 1.41A7.955 7.955 0 0 1 20 12c0 1.39-.35 2.7-.97 3.83Z"/>'
        },
        "access-point-plus": {
            body: '<path fill="currentColor" d="M16 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41A5.98 5.98 0 0 1 18 12c-.72 0-1.4.13-2.04.36c.01-.12.04-.24.04-.36m4 .34c.68.25 1.33.62 1.88 1.09c.07-.47.12-.93.12-1.43c0-2.76-1.12-5.26-2.93-7.07l-1.41 1.41A7.955 7.955 0 0 1 20 12v.34M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 12c0-2.21.89-4.22 2.34-5.66m1.42 1.42C6.67 8.85 6 10.35 6 12s.67 3.15 1.76 4.24l1.41-1.41C8.45 14.11 8 13.11 8 12s.45-2.11 1.17-2.83L7.76 7.76M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3Z"/>'
        },
        "access-point-remove": {
            body: '<path fill="currentColor" d="M16 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41A5.98 5.98 0 0 1 18 12c-.72 0-1.4.13-2.04.36c.01-.12.04-.24.04-.36M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 12c0-2.21.89-4.22 2.34-5.66m12.73-1.41l-1.41 1.41A7.955 7.955 0 0 1 20 12v.34c.68.25 1.33.62 1.88 1.09c.07-.47.12-.93.12-1.43c0-2.76-1.12-5.26-2.93-7.07M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M7.76 7.76C6.67 8.85 6 10.35 6 12s.67 3.15 1.76 4.24l1.41-1.41C8.45 14.11 8 13.11 8 12s.45-2.11 1.17-2.83L7.76 7.76m12.36 6.7L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.41L18 19.41l2.12 2.12l1.41-1.41L19.41 18l2.12-2.12l-1.41-1.42Z"/>'
        },
        account: {
            body: '<path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z"/>'
        },
        "account-alert": {
            body: '<path fill="currentColor" d="M10 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H2v-2c0-2.21 3.58-4 8-4m10-2V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "account-alert-outline": {
            body: '<path fill="currentColor" d="M20 12V7h2v6h-2m0 4h2v-2h-2m-10-2c2.67 0 8 1.34 8 4v3H2v-3c0-2.66 5.33-4 8-4m0-9a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1m0-9A2.1 2.1 0 0 0 7.9 8a2.1 2.1 0 0 0 2.1 2.1A2.1 2.1 0 0 0 12.1 8A2.1 2.1 0 0 0 10 5.9Z"/>'
        },
        "account-arrow-down": {
            body: '<path fill="currentColor" d="M19 18v-4h-2v4h-2l3 3l3-3h-2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5c0-1.2.3-2.3.9-3.4c-.6 0-1.2-.1-1.9-.1"/>'
        },
        "account-arrow-down-outline": {
            body: '<path fill="currentColor" d="M19 18v-4h-2v4h-2l3 3l3-3h-2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1c.5 0 1 .1 1.5.1c.3-.6.6-1.2 1.1-1.7c-1-.2-1.9-.3-2.6-.3"/>'
        },
        "account-arrow-left": {
            body: '<path fill="currentColor" d="M17 18h4v-2h-4v-2l-3 3l3 3v-2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5c0-1.2.3-2.3.9-3.4c-.6 0-1.2-.1-1.9-.1"/>'
        },
        "account-arrow-left-outline": {
            body: '<path fill="currentColor" d="M17 18h4v-2h-4v-2l-3 3l3 3v-2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1c.5 0 1 .1 1.5.1c.3-.6.6-1.2 1.1-1.7c-1-.2-1.9-.3-2.6-.3"/>'
        },
        "account-arrow-right": {
            body: '<path fill="currentColor" d="M18 16h-4v2h4v2l3-3l-3-3v2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5c0-1.2.3-2.3.9-3.4c-.6 0-1.2-.1-1.9-.1"/>'
        },
        "account-arrow-right-outline": {
            body: '<path fill="currentColor" d="M18 16h-4v2h4v2l3-3l-3-3v2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1c.5 0 1 .1 1.5.1c.3-.6.6-1.2 1.1-1.7c-1-.2-1.9-.3-2.6-.3"/>'
        },
        "account-arrow-up": {
            body: '<path fill="currentColor" d="M17 17v4h2v-4h2l-3-3l-3 3h2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5c0-1.2.3-2.3.9-3.4c-.6 0-1.2-.1-1.9-.1"/>'
        },
        "account-arrow-up-outline": {
            body: '<path fill="currentColor" d="M17 17v4h2v-4h2l-3-3l-3 3h2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1c.5 0 1 .1 1.5.1c.3-.6.6-1.2 1.1-1.7c-1-.2-1.9-.3-2.6-.3"/>'
        },
        "account-badge": {
            body: '<path fill="currentColor" d="M14 19.5c0-2 1.1-3.8 2.7-4.7c-1.3-.5-2.9-.8-4.7-.8c-4.4 0-8 1.8-8 4v2h10v-.5m5.5-3.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5M16 8c0 2.2-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4s4 1.8 4 4Z"/>'
        },
        "account-badge-outline": {
            body: '<path fill="currentColor" d="M14 20H4v-3c0-2.7 5.3-4 8-4c1.5 0 3.9.4 5.7 1.3c-.8.3-1.4.7-2 1.2c-1.1-.4-2.4-.6-3.7-.6c-3 0-6.1 1.5-6.1 2.1v1.1h8.3c-.1.4-.2.9-.2 1.4v.5m9-.5c0 1.9-1.6 3.5-3.5 3.5S16 21.4 16 19.5s1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5M12 6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-2C9.8 4 8 5.8 8 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4Z"/>'
        },
        "account-box": {
            body: '<path fill="currentColor" d="M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6m9-9a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z"/>'
        },
        "account-box-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m16-4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12m-3 5a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3m-9 8v1h12v-1c0-2-4-3.1-6-3.1S8 13 8 15Z"/>'
        },
        "account-box-multiple-outline": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m14.5 8.25c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V15h9M14 10.25c1.24 0 2.25-1.01 2.25-2.25S15.24 5.75 14 5.75S11.75 6.76 11.75 8s1.01 2.25 2.25 2.25M20 2H8c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14H8V4h12v12Z"/>'
        },
        "account-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-2.5 13.25c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9M12 12.25A2.25 2.25 0 0 0 14.25 10A2.25 2.25 0 0 0 12 7.75A2.25 2.25 0 0 0 9.75 10A2.25 2.25 0 0 0 12 12.25Z"/>'
        },
        "account-cancel": {
            body: '<path fill="currentColor" d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m7.5 9C15 13 13 15 13 17.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5M10 14c-4.42 0-8 1.79-8 4v2h9.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 .95-3.36c-.63-.08-1.27-.14-1.95-.14m7.5.5c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5L16 14.92c.42-.27.94-.42 1.5-.42M14.92 16L19 20.08c-.42.27-.94.42-1.5.42c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5Z"/>'
        },
        "account-cancel-outline": {
            body: '<path fill="currentColor" d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0 7c-2.67 0-8 1.33-8 4v3h9.5a6.5 6.5 0 0 1-.47-1.9H3.9V17c0-.64 3.13-2.1 6.1-2.1c.5 0 1 .05 1.5.13a6.5 6.5 0 0 1 1.05-1.74C11.61 13.1 10.71 13 10 13m7.5 0C15 13 13 15 13 17.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m0 1.5c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5L16 14.92c.42-.27.94-.42 1.5-.42M14.92 16L19 20.08c-.42.27-.94.42-1.5.42c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5Z"/>'
        },
        "account-card": {
            body: '<path fill="currentColor" d="M7 12c2.2 0 4-1.8 4-4S9.2 4 7 4S3 5.8 3 8s1.8 4 4 4m4 8v-5.3c-1.1-.4-2.5-.7-4-.7c-3.9 0-7 1.8-7 4v2h11m4-16c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-7Z"/>'
        },
        "account-card-outline": {
            body: '<path fill="currentColor" d="M7 4C4.8 4 3 5.8 3 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m-7 8c0-2.2 3.1-4 7-4c1.5 0 2.9.3 4 .7V17c-.8-.5-2.2-1-4-1c-3.2 0-5 1.4-5 2h9v2H0v-2M22 4h-7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14h-7V6h7v12Z"/>'
        },
        "account-cash": {
            body: '<path fill="currentColor" d="M11 8c0 2.21-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4m0 6.72V20H0v-2c0-2.21 3.13-4 7-4c1.5 0 2.87.27 4 .72M24 20H13V3h11v17m-8-8.5a2.5 2.5 0 0 1 5 0a2.5 2.5 0 0 1-5 0M22 7a2 2 0 0 1-2-2h-3c0 1.11-.89 2-2 2v9a2 2 0 0 1 2 2h3c0-1.1.9-2 2-2V7Z"/>'
        },
        "account-cash-outline": {
            body: '<path fill="currentColor" d="M16 11.5a2.5 2.5 0 0 1 5 0a2.5 2.5 0 0 1-5 0M13 3v17h11V3H13m9 13c-1.1 0-2 .9-2 2h-3a2 2 0 0 0-2-2V7c1.11 0 2-.89 2-2h3a2 2 0 0 0 2 2v9M7 6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-2C4.79 4 3 5.79 3 8s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 10c-3.87 0-7 1.79-7 4v2h11v-2H2c0-.58 1.75-2 5-2c1.83 0 3.17.45 4 .95v-2.23C9.87 14.27 8.5 14 7 14Z"/>'
        },
        "account-check": {
            body: '<path fill="currentColor" d="m21.1 12.5l1.4 1.41l-6.53 6.59L12.5 17l1.4-1.41l2.07 2.08l5.13-5.17M10 17l3 3H3v-2c0-2.21 3.58-4 8-4l1.89.11L10 17m1-13a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        "account-check-outline": {
            body: '<path fill="currentColor" d="m21.1 12.5l1.4 1.41l-6.53 6.59L12.5 17l1.4-1.41l2.07 2.08l5.13-5.17M11 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c.68 0 1.5.09 2.41.26l-1.67 1.67l-.74-.03c-2.97 0-6.1 1.46-6.1 2.1v1.1h6.2L13 20H3v-3c0-2.66 5.33-4 8-4Z"/>'
        },
        "account-child": {
            body: '<path fill="currentColor" d="M12 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 7c1.63 0 3.12.35 4.5 1.05c1.34.71 2 1.56 2 2.56v5.77c0 1.12-.86 2.06-2.61 2.81V19c0-.95-.86-1.62-2.58-2.03c-.56-.13-1-.19-1.31-.19c-.87 0-1.7.17-2.46.52c-.77.34-1.23.78-1.38 1.31c1.34.53 2.62.8 3.84.8l1-.1v2.63L12 22a9.68 9.68 0 0 1-3.89-.81c-1.75-.75-2.61-1.69-2.61-2.81v-5.77c0-1 .66-1.85 2-2.56C8.88 9.35 10.38 9 12 9m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "account-child-circle": {
            body: '<path fill="currentColor" d="M12 12a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 15a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 12m0-10a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 14c.72 0 1.4.15 2.04.5c.64.3.96.7.96 1.17v1.74c1.34-.6 2-1.33 2-2.21v-4.4c0-.8-.5-1.45-1.55-2c-1.05-.54-2.2-.8-3.45-.8s-2.4.26-3.45.8C7.5 11.35 7 12 7 12.8v4.4c0 .8.53 1.49 1.63 2.02c1.09.53 2.21.78 3.37.78l1-.08v-2.01L12 18c-1 0-2-.2-2.95-.61c.12-.39.48-.7 1.08-.98c.59-.28 1.21-.41 1.87-.41m0-12a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 12 9a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 4Z"/>'
        },
        "account-child-outline": {
            body: '<path fill="currentColor" d="M12 17c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0-7c2.34 0 7 1.16 7 3.5v5.13c0 .87-.69 1.61-1.66 2.16v-7.41c0-.56-2.74-1.84-5.34-1.84c-2.6 0-5.34 1.28-5.34 1.84v5.37c0 .25.65.71 1.62 1.1C9 19 10.93 18.56 12 18.56c1.33 0 4 .66 4 2v.83c-1.37.49-2.93.74-4 .74c-1.07 0-2.62-.25-4-.74c-1.63-.58-3-1.5-3-2.76V13.5c0-2.34 4.66-3.5 7-3.5m0-6.25c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75s1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75M12 9c-1.93 0-3.5-1.57-3.5-3.5S10.07 2 12 2s3.5 1.57 3.5 3.5S13.93 9 12 9Z"/>'
        },
        "account-circle": {
            body: '<path fill="currentColor" d="M12 19.2c-2.5 0-4.71-1.28-6-3.2c.03-2 4-3.1 6-3.1s5.97 1.1 6 3.1a7.232 7.232 0 0 1-6 3.2M12 5a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-3A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10Z"/>'
        },
        "account-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.5.88 4.93 1.78A7.893 7.893 0 0 1 12 20c-1.86 0-3.57-.64-4.93-1.72m11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33A7.928 7.928 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.5-1.64 4.83M12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6m0 5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 8a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 11Z"/>'
        },
        "account-clock": {
            body: '<path fill="currentColor" d="M10.63 14.1a6.998 6.998 0 0 1 9.27-3.47a6.998 6.998 0 0 1 3.47 9.27A6.98 6.98 0 0 1 17 24c-2.7 0-5.17-1.56-6.33-4H1v-2c.06-1.14.84-2.07 2.34-2.82S6.72 14.04 9 14c.57 0 1.11.05 1.63.1M9 4c1.12.03 2.06.42 2.81 1.17S12.93 6.86 12.93 8c0 1.14-.37 2.08-1.12 2.83c-.75.75-1.69 1.12-2.81 1.12s-2.06-.37-2.81-1.12C5.44 10.08 5.07 9.14 5.07 8c0-1.14.37-2.08 1.12-2.83C6.94 4.42 7.88 4.03 9 4m8 18a5 5 0 0 0 5-5a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5m-1-8h1.5v2.82l2.44 1.41l-.75 1.3L16 17.69V14Z"/>'
        },
        "account-clock-outline": {
            body: '<path fill="currentColor" d="M16 14h1.5v2.82l2.44 1.41l-.75 1.3L16 17.69V14m1-2a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0-2a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-2.79 0-5.2-1.64-6.33-4H1v-3c0-2.66 5.33-4 8-4c.6 0 1.34.07 2.12.2A6.992 6.992 0 0 1 17 10m-7 7c0-.7.1-1.38.29-2c-.42-.07-.86-.1-1.29-.1c-2.97 0-6.1 1.46-6.1 2.1v1.1h7.19A6.71 6.71 0 0 1 10 17M9 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 1.9A2.1 2.1 0 0 0 6.9 8A2.1 2.1 0 0 0 9 10.1A2.1 2.1 0 0 0 11.1 8A2.1 2.1 0 0 0 9 5.9Z"/>'
        },
        "account-cog": {
            body: '<path fill="currentColor" d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m7 8a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 19 12h-2m-7 2c-4.42 0-8 1.79-8 4v2h9.68a7 7 0 0 1-.68-3a7 7 0 0 1 .64-2.91c-.53-.06-1.08-.09-1.64-.09m8 1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "account-cog-outline": {
            body: '<path fill="currentColor" d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m7 6c-.16 0-.24.08-.24.24l-.26 1.26c-.22.18-.54.34-.78.5l-1.28-.5c-.08 0-.24 0-.32.1l-.96 1.76c-.08.08-.08.24.08.32l1.04.82v1l-1.04.82c-.08.08-.16.24-.08.32l.96 1.76c.08.1.24.1.32.1l1.28-.5c.24.16.56.32.78.5l.26 1.26c0 .16.08.24.24.24h2c.08 0 .24-.08.24-.24l.16-1.26c.32-.18.64-.34.88-.5l1.22.5c.14 0 .3 0 .3-.1l1.04-1.76c.08-.08 0-.24-.08-.32l-1.04-.82v-1l1.04-.82c.08-.08.16-.24.08-.32L21.8 13.6c0-.1-.16-.1-.3-.1l-1.22.5c-.24-.16-.56-.32-.88-.5l-.16-1.26c0-.16-.16-.24-.24-.24h-2m-7 1c-2.67 0-8 1.33-8 4v3h9.67c-.28-.59-.48-1.23-.58-1.9H3.9V17c0-.64 3.13-2.1 6.1-2.1c.43 0 .87.04 1.3.1c.2-.64.47-1.24.82-1.79c-.78-.13-1.52-.21-2.12-.21m8.04 2.5c.8 0 1.46.66 1.46 1.54c0 .8-.66 1.46-1.46 1.46c-.88 0-1.54-.66-1.54-1.46c0-.88.66-1.54 1.54-1.54Z"/>'
        },
        "account-convert": {
            body: '<path fill="currentColor" d="m12 0l-.66.03l3.81 3.81L16.5 2.5c3.25 1.57 5.59 4.74 5.95 8.5h1.5C23.44 4.84 18.29 0 12 0m0 4c-1.93 0-3.5 1.57-3.5 3.5S10.07 11 12 11s3.5-1.57 3.5-3.5S13.93 4 12 4M.05 13C.56 19.16 5.71 24 12 24l.66-.03l-3.81-3.81L7.5 21.5c-3.25-1.56-5.59-4.74-5.95-8.5H.05M12 13c-3.87 0-7 1.57-7 3.5V18h14v-1.5c0-1.93-3.13-3.5-7-3.5Z"/>'
        },
        "account-convert-outline": {
            body: '<path fill="currentColor" d="m12 0l-.66.03l3.81 3.81L16.5 2.5c3.25 1.57 5.59 4.74 5.95 8.5h1.5C23.44 4.84 18.29 0 12 0m0 4c-1.93 0-3.5 1.57-3.5 3.5S10.07 11 12 11s3.5-1.57 3.5-3.5S13.93 4 12 4m0 2c.83 0 1.5.67 1.5 1.5S12.83 9 12 9s-1.5-.67-1.5-1.5S11.17 6 12 6M.05 13C.56 19.16 5.71 24 12 24l.66-.03l-3.81-3.81L7.5 21.5c-3.25-1.56-5.59-4.74-5.95-8.5H.05M12 13c-3.87 0-7 1.57-7 3.5V18h14v-1.5c0-1.93-3.13-3.5-7-3.5m0 2c2.11 0 3.61.53 4.39 1H7.61c.78-.47 2.28-1 4.39-1Z"/>'
        },
        "account-cowboy-hat": {
            body: '<path fill="currentColor" d="M20 22H4v-2c0-2.2 3.6-4 8-4s8 1.8 8 4M8 9h8v1c0 2.2-1.8 4-4 4s-4-1.8-4-4m11-6c-.6 0-1 .4-1 1v1h-1.5l-1.4-3c-.1-.2-.2-.4-.4-.5c-.5-.5-1.3-.6-2-.3l-.7.2l-.7-.3c-.7-.3-1.5-.2-2 .3c-.2.2-.3.4-.4.6L7.5 6H6V5c0-.6-.4-1-1-1s-1 .4-1 1v1c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-.5-.4-1-1-1Z"/>'
        },
        "account-cowboy-hat-outline": {
            body: '<path fill="currentColor" d="M19 4c-.6 0-1 .4-1 1v1h-1.5l-1.4-3c-.1-.2-.2-.4-.4-.5c-.5-.5-1.3-.6-2-.3l-.7.2l-.7-.3c-.7-.3-1.5-.2-2 .3c-.2.2-.3.4-.4.6L7.5 6H6V5c0-.6-.4-1-1-1s-1 .4-1 1v1c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-.5-.4-1-1-1M4 22v-3c0-2.67 5.33-4 8-4s8 1.33 8 4v3H4m14.1-1.9V19c0-.64-3.13-2.1-6.1-2.1S5.9 18.36 5.9 19v1.1h12.2M16 9v1c0 2.21-1.79 4-4 4s-4-1.79-4-4V9h2v1a2 2 0 1 0 4 0V9h2Z"/>'
        },
        "account-credit-card": {
            body: '<path fill="currentColor" d="M7 12c2.2 0 4-1.8 4-4S9.2 4 7 4S3 5.8 3 8s1.8 4 4 4m4 8v-5.3c-1.1-.4-2.5-.7-4-.7c-3.9 0-7 1.8-7 4v2h11M22 4h-7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-4 14h-2V6h2v12Z"/>'
        },
        "account-credit-card-outline": {
            body: '<path fill="currentColor" d="M7 4C4.8 4 3 5.8 3 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0 4c-3.9 0-7 1.8-7 4v2h11v-2H2c0-.6 1.8-2 5-2c1.8 0 3.2.5 4 1v-2.2c-1.1-.5-2.5-.8-4-.8M22 4h-7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-6 14h-1V6h1v12m6 0h-4V6h4v12Z"/>'
        },
        "account-details": {
            body: '<path fill="currentColor" d="M11 9c0 1.66-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3m3 11H2v-2c0-2.21 2.69-4 6-4s6 1.79 6 4m8-6v2h-9v-2m9-4v2h-9V8m9-4v2h-9V4Z"/>'
        },
        "account-details-outline": {
            body: '<path fill="currentColor" d="M11 9c0 1.66-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3m3 11H2v-2c0-2.21 2.69-4 6-4s6 1.79 6 4M7 9c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m-3 9h8c0-1.1-1.79-2-4-2s-4 .9-4 2m18-6v2h-9v-2m9-4v2h-9V8m9-4v2h-9V4Z"/>'
        },
        "account-edit": {
            body: '<path fill="currentColor" d="m21.7 13.35l-1 1l-2.05-2.05l1-1a.55.55 0 0 1 .77 0l1.28 1.28c.21.21.21.56 0 .77M12 18.94l6.06-6.06l2.05 2.05L14.06 21H12v-2.06M12 14c-4.42 0-8 1.79-8 4v2h6v-1.89l4-4c-.66-.08-1.33-.11-2-.11m0-10a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "account-edit-outline": {
            body: '<path fill="currentColor" d="M2 17v3h8v-1.89H3.9V17c0-.64 3.13-2.1 6.1-2.1c.96.01 1.91.14 2.83.38l1.52-1.52c-1.4-.47-2.85-.73-4.35-.76c-2.67 0-8 1.33-8 4m8-13C7.79 4 6 5.79 6 8s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 6c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m11.7 3.35l-1 1l-2.05-2l1-1a.55.55 0 0 1 .77 0l1.28 1.28c.21.21.21.56 0 .77M12 18.94l6.06-6.06l2.05 2l-6 6.07H12v-2.01"/>'
        },
        "account-eye": {
            body: '<path fill="currentColor" d="M6 8c0-2.21 1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4m3.14 11.75L8.85 19l.29-.75c.7-1.75 1.94-3.11 3.47-4.03c-.82-.14-1.69-.22-2.61-.22c-4.42 0-8 1.79-8 4v2h7.27c-.04-.09-.09-.17-.13-.25M17 18c-.56 0-1 .44-1 1s.44 1 1 1s1-.44 1-1s-.44-1-1-1m6 1c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4s5.06 1.66 6 4m-3.5 0a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "account-eye-outline": {
            body: '<path fill="currentColor" d="M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m0-6a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m-.73 14H2v-3c0-2.67 5.33-4 8-4c1.04 0 2.5.21 3.86.61c-.86.34-1.66.81-2.36 1.39c-.5-.06-1-.1-1.5-.1c-2.97 0-6.1 1.46-6.1 2.1v1.1h5.32c-.02.05-.05.1-.08.15l-.29.75l.29.75c.04.08.09.16.13.25M17 18c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c-2.73 0-5.06 1.66-6 4c.94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 6.5a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "account-filter": {
            body: '<path fill="currentColor" d="M10 4c2.2 0 4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4m7 17l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3m-2-2.3l-2.3-2.8c-.4-.5-.6-1.1-.6-1.7c-.7-.2-1.4-.2-2.1-.2c-4.4 0-8 1.8-8 4v2h13v-1.3Z"/>'
        },
        "account-filter-outline": {
            body: '<path fill="currentColor" d="m17 21l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3m-2-1H2v-3c0-2.7 5.3-4 8-4c.6 0 1.3.1 2.1.2c-.2.6-.1 1.3.1 1.9c-.7-.1-1.5-.2-2.2-.2c-3 0-6.1 1.5-6.1 2.1v1.1h10.6l.5.6V20M10 4C7.8 4 6 5.8 6 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "account-group": {
            body: '<path fill="currentColor" d="M12 5.5A3.5 3.5 0 0 1 15.5 9a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8.5 9A3.5 3.5 0 0 1 12 5.5M5 8c.56 0 1.08.15 1.53.42c-.15 1.43.27 2.85 1.13 3.96C7.16 13.34 6.16 14 5 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3m14 0a3 3 0 0 1 3 3a3 3 0 0 1-3 3c-1.16 0-2.16-.66-2.66-1.62a5.536 5.536 0 0 0 1.13-3.96c.45-.27.97-.42 1.53-.42M5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13v-1.75M0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9c-.59.68-.95 1.62-.95 2.65V20H0m24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65c2.56.34 4.45 1.51 4.45 2.9V20Z"/>'
        },
        "account-group-outline": {
            body: '<path fill="currentColor" d="M12 5a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 12 12a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12 5m0 2a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 10a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 7M5.5 8A2.5 2.5 0 0 0 3 10.5c0 .94.53 1.75 1.29 2.18c.36.2.77.32 1.21.32c.44 0 .85-.12 1.21-.32c.37-.21.68-.51.91-.87A5.42 5.42 0 0 1 6.5 8.5v-.28c-.3-.14-.64-.22-1-.22m13 0c-.36 0-.7.08-1 .22v.28c0 1.2-.39 2.36-1.12 3.31c.12.19.25.34.4.49a2.482 2.482 0 0 0 1.72.7c.44 0 .85-.12 1.21-.32c.76-.43 1.29-1.24 1.29-2.18A2.5 2.5 0 0 0 18.5 8M12 14c-2.34 0-7 1.17-7 3.5V19h14v-1.5c0-2.33-4.66-3.5-7-3.5m-7.29.55C2.78 14.78 0 15.76 0 17.5V19h3v-1.93c0-1.01.69-1.85 1.71-2.52m14.58 0c1.02.67 1.71 1.51 1.71 2.52V19h3v-1.5c0-1.74-2.78-2.72-4.71-2.95M12 16c1.53 0 3.24.5 4.23 1H7.77c.99-.5 2.7-1 4.23-1Z"/>'
        },
        "account-hard-hat": {
            body: '<path fill="currentColor" d="M12 15c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4M8 9a4 4 0 0 0 4 4a4 4 0 0 0 4-4m-4.5-7c-.3 0-.5.21-.5.5v3h-1V3s-2.25.86-2.25 3.75c0 0-.75.14-.75 1.25h10c-.05-1.11-.75-1.25-.75-1.25C16.25 3.86 14 3 14 3v2.5h-1v-3c0-.29-.19-.5-.5-.5h-1Z"/>'
        },
        "account-hard-hat-outline": {
            body: '<path fill="currentColor" d="M16 9c0 5.33-8 5.33-8 0h2c0 2.67 4 2.67 4 0m6 9v3H4v-3c0-2.67 5.33-4 8-4s8 1.33 8 4m-1.9 0c0-.64-3.13-2.1-6.1-2.1c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2M12.5 2c.28 0 .5.22.5.5v3h1V3a3.89 3.89 0 0 1 2.25 3.75s.7.14.75 1.25H7c0-1.11.75-1.25.75-1.25A3.89 3.89 0 0 1 10 3v2.5h1v-3c0-.28.22-.5.5-.5"/>'
        },
        "account-heart": {
            body: '<path fill="currentColor" d="M15 14c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4m0-2a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4M5 15l-.6-.5C2.4 12.6 1 11.4 1 9.9c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8C8 7.7 9 8.6 9 9.9c0 1.5-1.4 2.7-3.4 4.6L5 15Z"/>'
        },
        "account-heart-outline": {
            body: '<path fill="currentColor" d="m5 15l-.6-.5C2.4 12.6 1 11.4 1 9.9c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8C8 7.7 9 8.6 9 9.9c0 1.5-1.4 2.7-3.4 4.6L5 15M15 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 6.1A2.1 2.1 0 0 1 12.9 8A2.1 2.1 0 0 1 15 5.9a2.1 2.1 0 1 1 0 4.2m0 2.9c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4m6.1 5.1H8.9V17c0-.64 3.1-2.1 6.1-2.1c2.97 0 6.1 1.46 6.1 2.1v1.1Z"/>'
        },
        "account-injury": {
            body: '<path fill="currentColor" d="M8 6c0-2.21 1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4m9 16h1c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66c-.43-.22-.89-.43-1.39-.62V22m-4.66-5L15 11.33c-.93-.21-1.93-.33-3-.33c-2.53 0-4.71.7-6.39 1.56A2.97 2.97 0 0 0 4 15.22V22h2.34c-.22-.45-.34-.96-.34-1.5C6 18.57 7.57 17 9.5 17h2.84M10 22l1.41-3H9.5c-.83 0-1.5.67-1.5 1.5S8.67 22 9.5 22h.5Z"/>'
        },
        "account-injury-outline": {
            body: '<path fill="currentColor" d="M12 10c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m6.39 8.56C16.71 11.7 14.53 11 12 11s-4.71.7-6.39 1.56A2.97 2.97 0 0 0 4 15.22V22h2v-6.78c0-.38.2-.72.5-.88C7.71 13.73 9.63 13 12 13c.76 0 1.47.07 2.13.2l-1.55 3.3H9.75C8.23 16.5 7 17.73 7 19.25S8.23 22 9.75 22H18c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66M10.94 20H9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.89l-.7 1.5M18 20h-4.85l2.94-6.27c.54.2 1.01.41 1.41.61c.3.16.5.5.5.88V20Z"/>'
        },
        "account-key": {
            body: '<path fill="currentColor" d="M11 10v2H9v2H7v-2H5.8c-.4 1.2-1.5 2-2.8 2c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.3 0 2.4.8 2.8 2H11m-8 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m13 4c2.7 0 8 1.3 8 4v2H8v-2c0-2.7 5.3-4 8-4m0-2c-2.2 0-4-1.8-4-4s1.8-4 4-4s4 1.8 4 4s-1.8 4-4 4Z"/>'
        },
        "account-key-outline": {
            body: '<path fill="currentColor" d="M5.8 10C5.4 8.8 4.3 8 3 8c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H7v2h2v-2h2v-2H5.8M3 12c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m13-8c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 6.1c-1.2 0-2.1-.9-2.1-2.1c0-1.2.9-2.1 2.1-2.1c1.2 0 2.1.9 2.1 2.1s-.9 2.1-2.1 2.1m0 2.9c-2.7 0-8 1.3-8 4v3h16v-3c0-2.7-5.3-4-8-4m6.1 5.1H9.9V17c0-.6 3.1-2.1 6.1-2.1c3 0 6.1 1.5 6.1 2.1v1.1Z"/>'
        },
        "account-lock": {
            body: '<path fill="currentColor" d="M6 8c0-2.21 1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4m6 10.2c0-.96.5-1.86 1.2-2.46v-.24c0-.39.07-.76.18-1.12c-1.03-.24-2.17-.38-3.38-.38c-4.42 0-8 1.79-8 4v2h10v-1.8m10 .1v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V17c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h3v-1.5Z"/>'
        },
        "account-lock-open": {
            body: '<path fill="currentColor" d="M6 8c0-2.21 1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4m6 10.2c0-.96.5-1.86 1.2-2.46V14.5c0-.05.02-.11.02-.16c-.99-.22-2.07-.34-3.22-.34c-4.42 0-8 1.79-8 4v2h10v-1.8m10 .1v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h4.3c.6 0 1.2.6 1.2 1.3Z"/>'
        },
        "account-lock-open-outline": {
            body: '<path fill="currentColor" d="M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m0-6a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m2 14H2v-3c0-2.67 5.33-4 8-4c.91 0 2.13.16 3.35.47c-.09.33-.15.68-.15 1.03v.89c-.98-.29-2.1-.49-3.2-.49c-2.97 0-6.1 1.46-6.1 2.1v1.1H12V20m8.8-3h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "account-lock-outline": {
            body: '<path fill="currentColor" d="M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m0-6a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m2 14H2v-3c0-2.67 5.33-4 8-4c1 0 2.38.19 3.71.56c-.3.56-.48 1.18-.5 1.83c-.98-.29-2.1-.49-3.21-.49c-2.97 0-6.1 1.46-6.1 2.1v1.1H12V20m8.8-3v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17Z"/>'
        },
        "account-minus": {
            body: '<path fill="currentColor" d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4M1 10v2h8v-2m6 2a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4Z"/>'
        },
        "account-minus-outline": {
            body: '<path fill="currentColor" d="M15 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 1.9a2.1 2.1 0 1 1 0 4.2A2.1 2.1 0 0 1 12.9 8A2.1 2.1 0 0 1 15 5.9M1 10v2h8v-2H1m14 3c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4m0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H8.9V17c0-.64 3.1-2.1 6.1-2.1Z"/>'
        },
        "account-multiple": {
            body: '<path fill="currentColor" d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.39 3.39 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.39 3.39 0 0 0 15 11a3.5 3.5 0 0 0 0-7Z"/>'
        },
        "account-multiple-check": {
            body: '<path fill="currentColor" d="M19 17v2H7v-2s0-4 6-4s6 4 6 4m-3-9a3 3 0 1 0-3 3a3 3 0 0 0 3-3m3.2 5.06A5.6 5.6 0 0 1 21 17v2h3v-2s0-3.45-4.8-3.94M18 5a2.91 2.91 0 0 0-.89.14a5 5 0 0 1 0 5.72A2.91 2.91 0 0 0 18 11a3 3 0 0 0 0-6M7.34 8.92l1.16 1.41l-4.75 4.75l-2.75-3l1.16-1.16l1.59 1.58l3.59-3.58"/>'
        },
        "account-multiple-check-outline": {
            body: '<path fill="currentColor" d="M13 11a3 3 0 1 0-3-3a3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1a1 1 0 0 1 1-1m4.11 3.86a5 5 0 0 0 0-5.72A2.91 2.91 0 0 1 18 5a3 3 0 0 1 0 6a2.91 2.91 0 0 1-.89-.14M13 13c-6 0-6 4-6 4v2h12v-2s0-4-6-4m-4 4c0-.29.32-2 4-2c3.5 0 3.94 1.56 4 2m7 0v2h-3v-2a5.6 5.6 0 0 0-1.8-3.94C24 13.55 24 17 24 17M7.34 8.92l1.16 1.41l-4.75 4.75l-2.75-3l1.16-1.16l1.59 1.58l3.59-3.58"/>'
        },
        "account-multiple-minus": {
            body: '<path fill="currentColor" d="M19 17v2H7v-2s0-4 6-4s6 4 6 4m-3-9a3 3 0 1 0-3 3a3 3 0 0 0 3-3m3.2 5.06A5.6 5.6 0 0 1 21 17v2h3v-2s0-3.45-4.8-3.94M18 5a2.91 2.91 0 0 0-.89.14a5 5 0 0 1 0 5.72A2.91 2.91 0 0 0 18 11a3 3 0 0 0 0-6M8 10H0v2h8Z"/>'
        },
        "account-multiple-minus-outline": {
            body: '<path fill="currentColor" d="M13 11a3 3 0 1 0-3-3a3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1a1 1 0 0 1 1-1m4.11 3.86a5 5 0 0 0 0-5.72A2.91 2.91 0 0 1 18 5a3 3 0 0 1 0 6a2.91 2.91 0 0 1-.89-.14M13 13c-6 0-6 4-6 4v2h12v-2s0-4-6-4m-4 4c0-.29.32-2 4-2c3.5 0 3.94 1.56 4 2m7 0v2h-3v-2a5.6 5.6 0 0 0-1.8-3.94C24 13.55 24 17 24 17M8 12H0v-2h8Z"/>'
        },
        "account-multiple-outline": {
            body: '<path fill="currentColor" d="M13.07 10.41a5 5 0 0 0 0-5.82A3.39 3.39 0 0 1 15 4a3.5 3.5 0 0 1 0 7a3.39 3.39 0 0 1-1.93-.59M5.5 7.5A3.5 3.5 0 1 1 9 11a3.5 3.5 0 0 1-3.5-3.5m2 0A1.5 1.5 0 1 0 9 6a1.5 1.5 0 0 0-1.5 1.5M16 17v2H2v-2s0-4 7-4s7 4 7 4m-2 0c-.14-.78-1.33-2-5-2s-4.93 1.31-5 2m11.95-4A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4Z"/>'
        },
        "account-multiple-plus": {
            body: '<path fill="currentColor" d="M19 17v2H7v-2s0-4 6-4s6 4 6 4m-3-9a3 3 0 1 0-3 3a3 3 0 0 0 3-3m3.2 5.06A5.6 5.6 0 0 1 21 17v2h3v-2s0-3.45-4.8-3.94M18 5a2.91 2.91 0 0 0-.89.14a5 5 0 0 1 0 5.72A2.91 2.91 0 0 0 18 11a3 3 0 0 0 0-6M8 10H5V7H3v3H0v2h3v3h2v-3h3Z"/>'
        },
        "account-multiple-plus-outline": {
            body: '<path fill="currentColor" d="M13 11a3 3 0 1 0-3-3a3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1a1 1 0 0 1 1-1m4.11 3.86a5 5 0 0 0 0-5.72A2.91 2.91 0 0 1 18 5a3 3 0 0 1 0 6a2.91 2.91 0 0 1-.89-.14M13 13c-6 0-6 4-6 4v2h12v-2s0-4-6-4m-4 4c0-.29.32-2 4-2c3.5 0 3.94 1.56 4 2m7 0v2h-3v-2a5.6 5.6 0 0 0-1.8-3.94C24 13.55 24 17 24 17M8 12H5v3H3v-3H0v-2h3V7h2v3h3Z"/>'
        },
        "account-multiple-remove": {
            body: '<path fill="currentColor" d="M24 17v2h-3v-2c0-1.55-.7-2.94-1.82-3.94C24 13.55 24 17 24 17M18 5c1.66 0 3 1.34 3 3a2.996 2.996 0 0 1-3.9 2.86c.57-.81.9-1.79.9-2.86c0-1.06-.33-2.05-.9-2.86c.28-.09.59-.14.9-.14m-5 0c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m6 12v2H7v-2c0-2.21 2.69-4 6-4s6 1.79 6 4M.464 13.12L2.59 11L.464 8.88L1.88 7.46L4 9.59l2.12-2.13l1.42 1.42L5.41 11l2.13 2.12l-1.42 1.42L4 12.41l-2.12 2.13Z"/>'
        },
        "account-multiple-remove-outline": {
            body: '<path fill="currentColor" d="M24 17v2h-3v-2c0-1.55-.7-2.94-1.82-3.94C24 13.55 24 17 24 17M18 5c1.66 0 3 1.34 3 3a2.996 2.996 0 0 1-3.9 2.86c.57-.81.9-1.79.9-2.86c0-1.06-.33-2.05-.9-2.86c.28-.09.59-.14.9-.14m-5 0c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m6 12v2H7v-2c0-2.21 2.69-4 6-4s6 1.79 6 4M13 7c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m0 8c-2.21 0-4 .9-4 2h8c0-1.1-1.79-2-4-2M.464 13.12L2.59 11L.464 8.88L1.88 7.46L4 9.59l2.12-2.13l1.42 1.42L5.41 11l2.13 2.12l-1.42 1.42L4 12.41l-2.12 2.13Z"/>'
        },
        "account-music": {
            body: '<path fill="currentColor" d="M11 14c1 0 2.05.16 3.2.44c-.81.87-1.2 1.89-1.2 3.06c0 .89.25 1.73.78 2.5H3v-2c0-1.19.91-2.15 2.74-2.88C7.57 14.38 9.33 14 11 14m0-2c-1.08 0-2-.39-2.82-1.17C7.38 10.05 7 9.11 7 8c0-1.08.38-2 1.18-2.82C9 4.38 9.92 4 11 4c1.11 0 2.05.38 2.83 1.18C14.61 6 15 6.92 15 8c0 1.11-.39 2.05-1.17 2.83c-.78.78-1.72 1.17-2.83 1.17m7.5-2H22v2h-2v5.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5c.36 0 .69.07 1 .21V10Z"/>'
        },
        "account-music-outline": {
            body: '<path fill="currentColor" d="M11 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c1.1 0 2.66.23 4.11.69c-.61.38-1.11.91-1.5 1.54c-.82-.2-1.72-.33-2.61-.33c-2.97 0-6.1 1.46-6.1 2.1v1.1h8.14c.09.7.34 1.34.72 1.9H3v-3c0-2.66 5.33-4 8-4m7.5-3H22v2h-2v5.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5c.36 0 .69.07 1 .21V10Z"/>'
        },
        "account-network": {
            body: '<path fill="currentColor" d="M13 17v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H5v-1.5c0-1.93 3.13-3.5 7-3.5s7 1.57 7 3.5V17h-6M12 3a3.5 3.5 0 0 1 3.5 3.5A3.5 3.5 0 0 1 12 10a3.5 3.5 0 0 1-3.5-3.5A3.5 3.5 0 0 1 12 3Z"/>'
        },
        "account-network-off": {
            body: '<path fill="currentColor" d="M13.03 9.83L8.67 5.47A3.487 3.487 0 0 1 12 3c1.93 0 3.5 1.57 3.5 3.5c0 1.57-1.04 2.89-2.47 3.33M19 15.5c0-1.24-1.3-2.33-3.25-2.95L19 15.8v-.3m3 6.5h-.43l-.73.73l-.73-.73H15c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1H2v-2h7c0-.55.45-1 1-1h1v-2H5v-1.5c0-1.62 2.22-3 5.23-3.38L1.11 3l1.28-1.27L22 21.34v.01l.11.11l-.11.11V22m-3.89-2l-3-3H13v2h1c.55 0 1 .45 1 1h3.11Z"/>'
        },
        "account-network-off-outline": {
            body: '<path fill="currentColor" d="m19 15.8l-3.25-3.25c1.95.62 3.25 1.71 3.25 2.95v.3m-5.97-5.97L8.67 5.47A3.487 3.487 0 0 1 12 3c1.93 0 3.5 1.57 3.5 3.5c0 1.57-1.04 2.89-2.47 3.33M12 8c.83 0 1.5-.67 1.5-1.5S12.83 5 12 5s-1.5.67-1.5 1.5S11.17 8 12 8m10 14h-.43l-.73.73l-.73-.73H15c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1H2v-2h7c0-.55.45-1 1-1h1v-2H5v-1.5c0-1.62 2.22-3 5.23-3.38L1.11 3l1.28-1.27L22 21.34v.01l.11.11l-.11.11V22m-8.89-7l-1-1H12c-2.11 0-3.61.53-4.39 1h5.5m5 5l-3-3H13v2h1c.55 0 1 .45 1 1h3.11Z"/>'
        },
        "account-network-outline": {
            body: '<path fill="currentColor" d="M12 10a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12 3a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 12 10m0-5a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 8a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 5m3 15a1 1 0 0 0-1-1h-1v-2h6v-1.5c0-1.93-3.13-3.5-7-3.5s-7 1.57-7 3.5V17h6v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-7.39-5c.78-.47 2.28-1 4.39-1s3.61.53 4.39 1H7.61Z"/>'
        },
        "account-off": {
            body: '<path fill="currentColor" d="M12 4a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L8.07 7.25A4.004 4.004 0 0 1 12 4m.28 10l6 6L20 21.72L18.73 23l-3-3H4v-2c0-1.84 2.5-3.39 5.87-3.86L2.78 7.05l1.27-1.27L12.28 14M20 18v1.18l-4.86-4.86C18 14.93 20 16.35 20 18Z"/>'
        },
        "account-off-outline": {
            body: '<path fill="currentColor" d="m2.75 7l1.28-1.25L13.26 15L20 21.72L18.73 23l-3-3H4v-3c0-1.86 2.61-3.08 5.09-3.64L2.75 7M20 17v2.18l-1.9-1.9V17c0-.26-.5-.65-1.3-1L14 13.18c2.71.45 6 1.73 6 3.82M5.9 17v1.1h7.93L10.72 15c-2.53.3-4.82 1.45-4.82 2M12 4a4 4 0 0 1 4 4c0 1.95-1.4 3.58-3.25 3.93L8.07 7.25A4.004 4.004 0 0 1 12 4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "account-outline": {
            body: '<path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z"/>'
        },
        "account-plus": {
            body: '<path fill="currentColor" d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m-9-4V7H4v3H1v2h3v3h2v-3h3v-2m6 2a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4Z"/>'
        },
        "account-plus-outline": {
            body: '<path fill="currentColor" d="M15 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 1.9a2.1 2.1 0 1 1 0 4.2A2.1 2.1 0 0 1 12.9 8A2.1 2.1 0 0 1 15 5.9M4 7v3H1v2h3v3h2v-3h3v-2H6V7H4m11 6c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4m0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H8.9V17c0-.64 3.1-2.1 6.1-2.1Z"/>'
        },
        "account-question": {
            body: '<path fill="currentColor" d="M13 8a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4m4 10v2H1v-2c0-2.21 3.58-4 8-4s8 1.79 8 4m3.5-3.5V16H19v-1.5h1.5m-2-5H17V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.01-.91 1.7v.2H19v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16A1.5 1.5 0 0 0 20 7.5A1.5 1.5 0 0 0 18.5 9v.5Z"/>'
        },
        "account-question-outline": {
            body: '<path fill="currentColor" d="M20.5 14.5V16H19v-1.5h1.5m-2-5H17V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.01-.91 1.7v.2H19v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16A1.5 1.5 0 0 0 20 7.5A1.5 1.5 0 0 0 18.5 9v.5M9 13c2.67 0 8 1.34 8 4v3H1v-3c0-2.66 5.33-4 8-4m0-9a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1m0-9A2.1 2.1 0 0 0 6.9 8A2.1 2.1 0 0 0 9 10.1A2.1 2.1 0 0 0 11.1 8A2.1 2.1 0 0 0 9 5.9Z"/>'
        },
        "account-reactivate": {
            body: '<path fill="currentColor" d="M21.5 9h-5l1.86-1.86A7.991 7.991 0 0 0 12 4c-4.42 0-8 3.58-8 8c0 1.83.61 3.5 1.64 4.85c1.22-1.4 3.51-2.35 6.36-2.35c2.85 0 5.15.95 6.36 2.35A7.945 7.945 0 0 0 20 12h2c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2c3.14 0 5.95 1.45 7.78 3.72L21.5 4v5M12 7c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3Z"/>'
        },
        "account-reactivate-outline": {
            body: '<path fill="currentColor" d="M21.5 9h-5l1.86-1.86A7.991 7.991 0 0 0 12 4c-4.42 0-8 3.58-8 8c0 1.83.61 3.5 1.64 4.85c1.22-1.4 3.51-2.35 6.36-2.35c2.85 0 5.15.95 6.36 2.35A7.945 7.945 0 0 0 20 12h2c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2c3.14 0 5.95 1.45 7.78 3.72L21.5 4v5M12 20c1.9 0 3.64-.66 5-1.76c-.64-1.01-2.55-1.74-5-1.74s-4.36.73-5 1.74c1.36 1.1 3.1 1.76 5 1.76m0-14c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 2c-.83 0-1.5.67-1.5 1.5S11.17 11 12 11s1.5-.67 1.5-1.5S12.83 8 12 8Z"/>'
        },
        "account-remove": {
            body: '<path fill="currentColor" d="M15 14c2.67 0 8 1.33 8 4v2H7v-2c0-2.67 5.33-4 8-4m0-2a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4M5 9.59l2.12-2.13l1.42 1.42L6.41 11l2.13 2.12l-1.42 1.42L5 12.41l-2.12 2.13l-1.42-1.42L3.59 11L1.46 8.88l1.42-1.42L5 9.59Z"/>'
        },
        "account-remove-outline": {
            body: '<path fill="currentColor" d="m1.46 8.88l1.42-1.42L5 9.59l2.12-2.13l1.42 1.42L6.41 11l2.13 2.12l-1.42 1.42L5 12.41l-2.12 2.13l-1.42-1.42L3.59 11L1.46 8.88M15 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 1.9A2.1 2.1 0 0 0 12.9 8a2.1 2.1 0 0 0 2.1 2.1a2.1 2.1 0 1 0 0-4.2m0 7.1c2.67 0 8 1.33 8 4v3H7v-3c0-2.67 5.33-4 8-4m0 1.9c-3 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z"/>'
        },
        "account-school": {
            body: '<path fill="currentColor" d="M16 8c0 2.21-1.79 4-4 4s-4-1.79-4-4l.11-.94L5 5.5L12 2l7 3.5v5h-1V6l-2.11 1.06L16 8m-4 6c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z"/>'
        },
        "account-school-outline": {
            body: '<path fill="currentColor" d="M18 10.5V6l-2.11 1.06A3.999 3.999 0 0 1 12 12a3.999 3.999 0 0 1-3.89-4.94L5 5.5L12 2l7 3.5v5h-1M12 9l-2-1c0 1.1.9 2 2 2s2-.9 2-2l-2 1m2.75-3.58L12.16 4.1L9.47 5.47l2.6 1.32l2.68-1.37M12 13c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-3 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1Z"/>'
        },
        "account-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M10 4a4 4 0 0 1 4 4c0 .91-.31 1.75-.82 2.43c-.86.32-1.63.83-2.27 1.47L10 12a4 4 0 0 1-4-4a4 4 0 0 1 4-4M2 20v-2c0-2.12 3.31-3.86 7.5-4c-.32.78-.5 1.62-.5 2.5c0 1.29.38 2.5 1 3.5H2Z"/>'
        },
        "account-search-outline": {
            body: '<path fill="currentColor" d="M10 13c-.35.59-.64 1.24-.81 1.93C6.5 15.16 3.9 16.42 3.9 17v1.1h5.3c.17.68.45 1.32.8 1.9H2v-3c0-2.66 5.33-4 8-4m0-9a4 4 0 0 1 4 4c0 .91-.31 1.75-.82 2.43c-.86.32-1.63.83-2.27 1.47L10 12a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 1.9A2.1 2.1 0 0 0 7.9 8a2.1 2.1 0 0 0 2.1 2.1A2.1 2.1 0 0 0 12.1 8A2.1 2.1 0 0 0 10 5.9m5.5 6.1c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "account-settings": {
            body: '<path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4m-5 8h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "account-settings-outline": {
            body: '<path fill="currentColor" d="M12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4m0 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1m1 7.1h-2v2h2v-2m4 0h-2v2h2v-2m-8 0H7v2h2v-2Z"/>'
        },
        "account-settings-variant": {
            body: '<path d="M8.999 3.999a4.002 4.002 0 0 0 0 8.003a3.999 3.999 0 0 0 3.998-4.005A3.998 3.998 0 0 0 9 4zm0 10C6.329 13.999 1 15.332 1 17.997V20H12.08a6.233 6.233 0 0 1-.078-1.001c0-1.514.493-2.988 1.407-4.199c-1.529-.523-3.228-.801-4.41-.801zm8.99 0a.261.261 0 0 0-.25.21l-.19 1.319a4.091 4.091 0 0 0-.85.492l-1.24-.502a.265.265 0 0 0-.308.112l-1.001 1.729a.255.255 0 0 0 .059.322l1.06.83a3.95 3.95 0 0 0 0 .981l-1.06.83a.26.26 0 0 0-.059.318l1.001 1.729c.059.111.19.151.308.111l1.24-.497c.258.2.542.366.85.488l.19 1.318c.02.122.122.21.25.21h2.001c.122 0 .23-.088.25-.21l.19-1.318c.297-.132.59-.288.84-.488l1.25.497c.111.04.239 0 .313-.111l.996-1.729a.256.256 0 0 0-.059-.317l-1.07-.83c.02-.162.04-.323.04-.494c0-.171-.01-.328-.04-.488l1.06-.83c.087-.084.121-.21.059-.322l-.996-1.729a.263.263 0 0 0-.313-.113l-1.24.503c-.26-.2-.543-.37-.85-.492l-.19-1.32a.238.238 0 0 0-.24-.21M18.989 17.5c.83 0 1.5.669 1.5 1.499c0 .83-.67 1.498-1.5 1.498S17.49 19.83 17.49 19s.669-1.499 1.499-1.499z" fill="currentColor"/>',
            hidden: true
        },
        "account-star": {
            body: '<path fill="currentColor" d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m0-2a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4M5 13.28l2.45 1.49l-.65-2.81L9 10.08l-2.89-.25L5 7.19L3.87 9.83L1 10.08l2.18 1.88l-.68 2.81L5 13.28Z"/>'
        },
        "account-star-outline": {
            body: '<path fill="currentColor" d="M15 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 1.9A2.1 2.1 0 0 0 12.9 8a2.1 2.1 0 0 0 2.1 2.1a2.1 2.1 0 1 0 0-4.2m0 7.1c2.67 0 8 1.33 8 4v3H7v-3c0-2.67 5.33-4 8-4m0 1.9c-3 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1M5 13.28l-2.5 1.49l.68-2.81L1 10.08l2.87-.25L5 7.19l1.11 2.64l2.89.25l-2.2 1.88l.65 2.81L5 13.28Z"/>'
        },
        "account-supervisor": {
            body: '<path fill="currentColor" d="M16.5 12A2.5 2.5 0 0 0 19 9.5A2.5 2.5 0 0 0 16.5 7A2.5 2.5 0 0 0 14 9.5a2.5 2.5 0 0 0 2.5 2.5M9 11a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75M9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13Z"/>'
        },
        "account-supervisor-circle": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m3.6 6.34c1.07 0 1.93.86 1.93 1.93c0 1.07-.86 1.93-1.93 1.93a1.93 1.93 0 0 1-1.93-1.93c-.01-1.07.86-1.93 1.93-1.93m-6-1.58c1.3 0 2.36 1.06 2.36 2.36c0 1.3-1.06 2.38-2.36 2.38c-1.3 0-2.36-1.08-2.36-2.38c0-1.31 1.05-2.36 2.36-2.36m0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96C5.5 13.56 8.13 13 9.6 13c.53 0 1.2.07 1.9.21c-1.64.87-1.9 2.02-1.9 2.68M12 20c-.28 0-.54 0-.8-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13c1.07 0 2.9.39 3.84 1.15C18.27 17.88 15.38 20 12 20Z"/>'
        },
        "account-supervisor-circle-outline": {
            body: '<path fill="currentColor" d="M12.5 10c0-1.66-1.34-3-3-3c-1.64 0-3 1.34-3 3c0 1.64 1.36 3 3 3c1.66 0 3-1.36 3-3m-3 1c-.54 0-1-.46-1-1c0-.56.46-1 1-1c.56 0 1 .44 1 1c0 .54-.44 1-1 1m6.5 2c1.12 0 2-.9 2-2c0-1.12-.88-2-2-2c-1.1 0-2 .88-2 2c0 1.1.9 2 2 2M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M5.85 17.11C6.53 16.57 8.12 16 9.5 16h.24c.26-.63.67-1.28 1.3-1.85c-.54-.1-1.09-.15-1.54-.15c-1.29 0-3.38.44-4.72 1.42C4.28 14.38 4 13.22 4 12c0-4.42 3.59-8 8-8s8 3.58 8 8c0 1.19-.27 2.33-.75 3.36c-1-.59-2.36-.86-3.25-.86c-1.5 0-4.5.8-4.5 2.69v2.78a7.932 7.932 0 0 1-5.65-2.86Z"/>'
        },
        "account-supervisor-outline": {
            body: '<path fill="currentColor" d="M16.5 15.5c1.72 0 3.75.8 4 1.28v.72h-8v-.72c.25-.48 2.28-1.28 4-1.28m0-1.5c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75M9 13c-2.33 0-7 1.17-7 3.5V19h7v-1.5H3.5v-1c0-.63 2.79-2.16 6.32-2a5.12 5.12 0 0 1 1.55-1.25A12.28 12.28 0 0 0 9 13m0-6.5A1.5 1.5 0 1 1 7.5 8A1.5 1.5 0 0 1 9 6.5M9 5a3 3 0 1 0 3 3a3 3 0 0 0-3-3m7.5 3.5a1 1 0 1 1-1 1a1 1 0 0 1 1-1m0-1.5A2.5 2.5 0 1 0 19 9.5A2.5 2.5 0 0 0 16.5 7Z"/>'
        },
        "account-switch": {
            body: '<path fill="currentColor" d="M16 9c6 0 6 4 6 4v2h-6v-2s0-1.69-1.15-3.2c-.17-.23-.38-.45-.6-.66C14.77 9.06 15.34 9 16 9M2 13s0-4 6-4s6 4 6 4v2H2v-2m7 4v2h6v-2l3 3l-3 3v-2H9v2l-3-3l3-3M8 1C6.34 1 5 2.34 5 4s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m8 0c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3Z"/>'
        },
        "account-switch-outline": {
            body: '<path fill="currentColor" d="M16 9c6 0 6 4 6 4v2h-6v-2s0-1.69-1.15-3.2c-.17-.23-.38-.45-.6-.66C14.77 9.06 15.34 9 16 9m-8 2c3.5 0 3.94 1.56 4 2H4c.06-.44.5-2 4-2m0-2c-6 0-6 4-6 4v2h12v-2s0-4-6-4m1 8v2h6v-2l3 3l-3 3v-2H9v2l-3-3l3-3M8 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m0-2C6.34 1 5 2.34 5 4s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m8 0c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3Z"/>'
        },
        "account-sync": {
            body: '<path fill="currentColor" d="M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 10c-4.4 0-8 1.8-8 4v2h9.5c-.3-.8-.5-1.6-.5-2.5c0-1.2.3-2.3.9-3.4c-.6 0-1.2-.1-1.9-.1m7 6c-1.4 0-2.5-1.1-2.5-2.5c0-.4.1-.8.3-1.1l-1.1-1.1c-.4.6-.7 1.4-.7 2.2c0 2.2 1.8 4 4 4V23l2.2-2.2l-2.2-2.3V20m0-6.5V12l-2.2 2.2l2.2 2.2V15c1.4 0 2.5 1.1 2.5 2.5c0 .4-.1.8-.3 1.1l1.1 1.1c.4-.6.7-1.4.7-2.2c0-2.2-1.8-4-4-4Z"/>'
        },
        "account-sync-outline": {
            body: '<path fill="currentColor" d="M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1c.5 0 1 .1 1.5.1c.3-.6.6-1.2 1.1-1.7c-1-.2-1.9-.3-2.6-.3m7 7c-1.4 0-2.5-1.1-2.5-2.5c0-.4.1-.8.3-1.1l-1.1-1.1c-.4.6-.7 1.4-.7 2.2c0 2.2 1.8 4 4 4V23l2.2-2.2l-2.2-2.3V20m0-6.5V12l-2.2 2.2l2.2 2.2V15c1.4 0 2.5 1.1 2.5 2.5c0 .4-.1.8-.3 1.1l1.1 1.1c.4-.6.7-1.4.7-2.2c0-2.2-1.8-4-4-4Z"/>'
        },
        "account-tie": {
            body: '<path fill="currentColor" d="M12 3c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4m4 10.54c0 1.06-.28 3.53-2.19 6.29L13 15l.94-1.88c-.62-.07-1.27-.12-1.94-.12s-1.32.05-1.94.12L11 15l-.81 4.83C8.28 17.07 8 14.6 8 13.54c-2.39.7-4 1.96-4 3.46v4h16v-4c0-1.5-1.6-2.76-4-3.46Z"/>'
        },
        "account-tie-hat": {
            body: '<path fill="currentColor" d="M16 14.5c0 1.1-.3 3.5-2.2 6.3L13 16l.9-1.9c-.6 0-1.2-.1-1.9-.1s-1.3.1-1.9.1L11 16l-.8 4.8C8.3 18.1 8 15.6 8 14.5c-2.4.7-4 2-4 3.5v4h16v-4c0-1.5-1.6-2.8-4-3.5M6 4.5C6 3.1 8.7 2 12 2s6 1.1 6 2.5c0 .4-.2.7-.5 1c-.9-.9-3-1.5-5.5-1.5s-4.6.6-5.5 1.5c-.3-.3-.5-.6-.5-1m9.9 2.9c.1.2.1.4.1.6c0 2.2-1.8 4-4 4s-4-1.8-4-4c0-.2 0-.4.1-.6c1 .4 2.4.6 3.9.6s2.9-.2 3.9-.6m.7-1.3c-1.1.5-2.7.9-4.6.9s-3.5-.4-4.6-.9C8.1 5.5 9.8 5 12 5s3.9.5 4.6 1.1Z"/>'
        },
        "account-tie-hat-outline": {
            body: '<path fill="currentColor" d="M6 4.5C6 3.1 8.7 2 12 2s6 1.1 6 2.5c0 .4-.2.7-.5 1c-.9-.9-3-1.5-5.5-1.5s-4.6.6-5.5 1.5c-.3-.3-.5-.6-.5-1m6 .5c-2.2 0-3.9.5-4.6 1.1c1.1.5 2.7.9 4.6.9s3.5-.4 4.6-.9C15.9 5.5 14.2 5 12 5m2 3c0 1.1-.9 2-2 2s-2-.9-2-2v-.1c-.7-.1-1.4-.2-2-.4V8c0 2.2 1.8 4 4 4s4-1.8 4-4c0-.2 0-.4-.1-.6c-.6.2-1.3.3-2 .4c.1.1.1.1.1.2m2.4 5.8l-.7 1.2l-.2.5c1.5.5 2.6 1.1 2.6 1.5v3.1h-4.2L13 15l.9-1.9c-.6 0-1.2-.1-1.9-.1s-1.3 0-1.9.1L11 15l-.9 5.1H5.9V17c0-.4 1.1-1 2.6-1.5l-.2-.5l-.6-1.2C5.7 14.4 4 15.5 4 17v5h16v-5c0-1.5-1.7-2.6-3.6-3.2Z"/>'
        },
        "account-tie-outline": {
            body: '<path fill="currentColor" d="M16.36 12.76C18.31 13.42 20 14.5 20 16v5H4v-5c0-1.5 1.69-2.58 3.65-3.24L8.27 14l.23.5c-1.5.46-2.6 1.12-2.6 1.5v3.1h4.22l.88-5.07l-.94-1.88c.62-.07 1.27-.12 1.94-.12c.67 0 1.32.05 1.94.12L13 14.03l.88 5.07h4.22V16c0-.38-1.1-1.04-2.6-1.5l.23-.5l.63-1.24M12 5c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0 6c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4Z"/>'
        },
        "account-tie-voice": {
            body: '<path fill="currentColor" d="M16.75 4.36c2.02 2.2 2.02 5.25 0 7.27l-1.68-1.69c.84-1.18.84-2.71 0-3.89l1.68-1.69M20.06 1c3.94 4.05 3.9 10.11 0 14l-1.63-1.63c2.77-3.18 2.77-7.72 0-10.74L20.06 1M9 4c2.2 0 4 1.79 4 4s-1.8 4-4 4s-4-1.79-4-4s1.79-4 4-4m4 10.54c0 1.06-.29 3.53-2.2 6.29L10 16l.93-1.88C10.31 14.05 9.66 14 9 14s-1.33.05-1.95.12L8 16l-.82 4.83C5.27 18.07 5 15.6 5 14.54C2.6 15.24.994 16.5.994 18v4H17v-4c0-1.5-1.61-2.76-4-3.46Z"/>'
        },
        "account-tie-voice-off": {
            body: '<path fill="currentColor" d="M12.7 9.5L7.5 4.3c.46-.19.96-.3 1.5-.3c2.2 0 4 1.79 4 4c0 .53-.11 1.04-.3 1.5m4.05 2.13c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69M20.06 15c3.9-3.89 3.94-9.95 0-14l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.06 15M2.39 1.73L1.11 3l4.02 4c-.08.34-.13.66-.13 1c0 2.21 1.79 4 4 4c.33 0 .66-.06.97-.14L13 14.87c-.07 1.19-.46 3.45-2.2 5.96L10 16l.93-1.88C10.31 14.05 9.66 14 9 14c-.68 0-1.33.05-1.95.12L8 16l-.82 4.83C5.27 18.07 5 15.6 5 14.54C2.6 15.24.994 16.5.994 18v4H17v-3.12l3.84 3.85l1.27-1.27L2.39 1.73Z"/>'
        },
        "account-tie-voice-off-outline": {
            body: '<path fill="currentColor" d="M9.22 6L7.5 4.3c.46-.19.97-.3 1.5-.3c2.21 0 4 1.79 4 4c0 .53-.11 1.04-.3 1.5L11 7.78A2.1 2.1 0 0 0 9.22 6m10.84 9c3.9-3.89 3.94-9.95 0-14l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.06 15m-3.31-3.37c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69M2.39 1.73L1.11 3l4.03 4.03C5.06 7.34 5 7.66 5 8c0 2.21 1.79 4 4 4c.34 0 .66-.06.97-.14l2.89 2.89l-.13.25l-.23.5c.8.24 1.47.55 1.94.83l.66.67v3.1h-4.22L10 15.03l.94-1.88c-.62-.07-1.27-.12-1.94-.12s-1.32.05-1.94.12L8 15.03l-.88 5.07H2.9V17c0-.38 1.1-1.04 2.6-1.5l-.23-.5l-.62-1.24C2.69 14.42 1 15.5 1 17v5h16v-3.11l3.84 3.84l1.27-1.27L2.39 1.73Z"/>'
        },
        "account-tie-voice-outline": {
            body: '<path fill="currentColor" d="M16.75 4.36c2.02 2.2 2.02 5.25 0 7.27l-1.68-1.69c.84-1.18.84-2.71 0-3.89l1.68-1.69M20.06 1c3.94 4.05 3.9 10.11 0 14l-1.63-1.63c2.77-3.18 2.77-7.72 0-10.74L20.06 1m-6.7 12.76C15.31 14.42 17 15.5 17 17v5H1v-5c0-1.5 1.69-2.58 3.65-3.24L5.27 15l.23.5c-1.5.46-2.6 1.12-2.6 1.5v3.1h4.22L8 15.03l-.94-1.88c.62-.07 1.27-.12 1.94-.12s1.32.05 1.94.12L10 15.03l.88 5.07h4.22V17c0-.38-1.1-1.04-2.6-1.5l.23-.5l.63-1.24M9 6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0 6c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4Z"/>'
        },
        "account-tie-woman": {
            body: '<path fill="currentColor" d="M11.94 3A3.993 3.993 0 0 0 8 7c-.06 1.64-.19 3.47-.97 4.59C9.71 13.22 12 13 12 13s2.29.22 4.97-1.41C16.12 10.22 15.94 8.54 16 7c0-2.21-1.79-4-4-4h-.06M8.86 13.32C6 13.93 4 15.35 4 17v4h8l-3-4H6.5m5.5 4l1.78-7.19S13 14 12 14s-1.78-.19-1.78-.19M12 21h8v-4c0-1.65-2-3.07-4.86-3.68L17.5 17H15Z"/>'
        },
        "account-voice": {
            body: '<path fill="currentColor" d="M9 5a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c2.67 0 8 1.34 8 4v2H1v-2c0-2.66 5.33-4 8-4m7.76-9.64c2.02 2.2 2.02 5.25 0 7.27l-1.68-1.69c.84-1.18.84-2.71 0-3.89l1.68-1.69M20.07 2c3.93 4.05 3.9 10.11 0 14l-1.63-1.63c2.77-3.18 2.77-7.72 0-10.74L20.07 2Z"/>'
        },
        "account-voice-off": {
            body: '<path fill="currentColor" d="M2 3.27L3.28 2L22 20.72L20.73 22l-4-4c.17.31.27.64.27 1v2H1v-2c0-2.66 5.33-4 8-4c1.77 0 4.72.59 6.5 1.77l-4.38-4.38c-.62.39-1.34.61-2.12.61a4 4 0 0 1-4-4c0-.78.22-1.5.61-2.12L2 3.27M9 5a4 4 0 0 1 4 4v.17L8.83 5H9m7.76.36c2.02 2.2 2.02 5.25 0 7.27l-1.68-1.69c.84-1.18.84-2.71 0-3.89l1.68-1.69M20.07 2c3.93 4.05 3.9 10.11 0 14l-1.63-1.63c2.77-3.18 2.77-7.72 0-10.74L20.07 2Z"/>'
        },
        "account-wrench": {
            body: '<path fill="currentColor" d="m22.9 21.2l-4.1-4.1c.4-1 .2-2.3-.7-3.1c-.9-.9-2.2-1.1-3.3-.6l1.9 1.9l-1.4 1.4l-2-2c-.5 1.1-.3 2.4.6 3.4c.9.9 2.1 1.1 3.1.7l4.1 4.1c.2.2.5.2.6 0l1-1c.3-.3.3-.6.2-.7M13 20H2v-2c0-2.2 3.6-4 8-4c.5 0 1 0 1.4.1c-.3.6-.4 1.2-.4 1.9c0 1.6.8 3.1 2 4M10 4C7.8 4 6 5.8 6 8s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4"/>'
        },
        "account-wrench-outline": {
            body: '<path fill="currentColor" d="m22.9 21.2l-4.1-4.1c.4-1 .2-2.3-.7-3.1c-.9-.9-2.2-1.1-3.3-.6l1.9 1.9l-1.4 1.4l-2-2c-.5 1.1-.3 2.4.6 3.4c.9.9 2.1 1.1 3.1.7l4.1 4.1c.2.2.5.2.6 0l1-1c.3-.3.3-.6.2-.7M10 12c2.2 0 4-1.8 4-4s-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3 14H2v-3c0-2.7 5.3-4 8-4c.5 0 1.2.1 1.9.2c-.4.5-.6 1.1-.8 1.8c-.4 0-.7-.1-1.1-.1c-3 0-6.1 1.5-6.1 2.1v1.1h7.6c.3.8.9 1.4 1.5 1.9Z"/>'
        },
        accusoft: {
            body: '<path d="M17.5 15.61c-.17-.24-7.97-10.21-8.23-10.53c-.27-.33-.19-.43-.14-.49c.09-.09.23-.09.8-.09c.33 0 3.66 0 4.01-.03c.72 0 .84.06.91.09c.08.02.28.19.41.36c.07.08 7.06 8.44 7.13 8.53c.07.09.2.24.28.39c.09.16.1.34-.03.41c-.08.05-3.94 1.64-4.05 1.68c-.09.07-.32.13-.48.11c-.11-.04-.34-.12-.61-.43m3.97-.19l.28.05s.93.18 1.02.2c.1.02.19.09.18.12c-.01.08-.05.12-.12.16c-.06.05-4.25 2.63-4.33 2.67c-.07.04-.17.1-.39.13c-.41.08-1.2-.14-1.45-.19c-.25-.06-10.51-2.33-10.6-2.36c-.09-.03-.15-.04-.16-.12c-.01-.14.21-.2.38-.27c.18-.06 5-1.81 5.17-1.88c.17-.07.39-.09.5-.1c.11-.01.78.1 1.08.14c.31.03 1.17.18 1.17.18l1.96 2.55c.34.39.56.55.84.58c.15.01.31-.03.42-.08c.08-.04 4.05-1.78 4.05-1.78M10.25 9.18l1.71 2.19l.04.08v.05c-.04.04-3.07 2.82-3.09 2.85L5.72 15.5s-.09.05-.14.08c-.05.03-.11.09-.08.24v.97l-3.94 1.25c-.19.06-.56.19-.61.15c-.07-.05.02-.16.05-.22c.06-.06 8.08-7.97 8.39-8.27c.45-.46.86-.52.86-.52" fill="currentColor"/>',
            hidden: true
        },
        "ad-choices": {
            body: '<path d="M9 9a1 1 0 1 1 0 2a1 1 0 0 1 0-2zM5 2c2 1 15 8.25 15 8.25s1.458.813 1.25 2c-.163.926-1.75 1.75-1.75 1.75l-9 5S8 20 8 18v-5s0-1 1-1s1 1 1 1v3.5l6.5-3.5s.813-.354.813-.854S16 11 16 11L6 5S4.5 4 4.5 6v12s.03 1.416.958.938c1.334-.688 1.647-.512 1.98.166c.52 1.063-.48 1.604-.48 1.604L4 22.25S2 23 2 21V4c0-3 3-2 3-2z" fill="currentColor"/>',
            hidden: true
        },
        adchoices: {
            body: '<path d="M9 9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M5 2c2 1 15 8.25 15 8.25s1.46.81 1.25 2c-.16.93-1.75 1.75-1.75 1.75l-9 5S8 20 8 18v-5s0-1 1-1s1 1 1 1v3.5l6.5-3.5s.81-.35.81-.85S16 11 16 11L6 5S4.5 4 4.5 6v12s.03 1.42.96.94c1.33-.69 1.65-.51 1.98.16c.52 1.07-.48 1.61-.48 1.61L4 22.25S2 23 2 21V4c0-3 3-2 3-2z" fill="currentColor"/>',
            hidden: true
        },
        adjust: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m3-8a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3Z"/>'
        },
        adobe: {
            body: '<path d="M14.58 3H22v16.67L14.58 3M9.42 3H2v16.67L9.42 3M12 9.17l4.67 10.5H13.5l-1.33-3.34H8.75L12 9.17z" fill="currentColor"/>',
            hidden: true
        },
        advertisements: {
            body: '<path fill="currentColor" d="M19 7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2v2h-4v2h4c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2h-2V9h4V7h-4M9 7v10h4c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H9m2 2h2v6h-2V9M3 7c-1.1 0-2 .9-2 2v8h2v-4h2v4h2V9c0-1.1-.9-2-2-2H3m0 2h2v2H3V9Z"/>'
        },
        "advertisements-off": {
            body: '<path fill="currentColor" d="m12.2 9l-2-2H13c1.1 0 2 .9 2 2v2.8l-2-2V9h-.8M23 9V7h-4c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2v2h-2.8l2 2h.8c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2h-2V9h4m-.9 12.5l-1.3 1.3l-6.4-6.4c-.3.3-.8.6-1.4.6H9v-6.1l-2-2V17H5v-4H3v4H1V9c0-1.1.9-2 2-2h2.1l-4-4l1.3-1.3l19.7 19.8M5 9H3v2h2V9m8 5.9l-2-2V15h2v-.1Z"/>'
        },
        "air-conditioner": {
            body: '<path fill="currentColor" d="M6.59.66c2.34-1.81 4.88.4 5.45 3.84c.43 0 .85.12 1.23.34c.52-.6.98-1.42.8-2.34c-.42-2.15 1.99-3.89 4.28-.92c1.81 2.34-.4 4.88-3.85 5.45c0 .43-.11.86-.34 1.24c.6.51 1.42.97 2.34.79c2.13-.42 3.88 1.98.91 4.28c-2.34 1.81-4.88-.4-5.45-3.84c-.43 0-.85-.13-1.22-.35c-.52.6-.99 1.43-.81 2.35c.42 2.14-1.99 3.89-4.28.92c-1.82-2.35.4-4.89 3.85-5.45c0-.43.13-.85.35-1.23c-.6-.51-1.42-.98-2.35-.8c-2.13.42-3.88-1.98-.91-4.28M5 16h2a2 2 0 0 1 2 2v6H7v-2H5v2H3v-6a2 2 0 0 1 2-2m0 2v2h2v-2H5m7.93-2H15l-2.93 8H10l2.93-8M18 16h3v2h-3v4h3v2h-3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Z"/>'
        },
        "air-filter": {
            body: '<path fill="currentColor" d="M19 18.31V20a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3.7c-.46-.18-1.05-.3-2-.3a1 1 0 0 1-1-1a1 1 0 0 1 1-1c.82 0 1.47.08 2 .21V12.3c-.46-.18-1.05-.3-2-.3a1 1 0 0 1-1-1a1 1 0 0 1 1-1c.82 0 1.47.08 2 .21V8.3C4.54 8.12 3.95 8 3 8a1 1 0 0 1-1-1a1 1 0 0 1 1-1c.82 0 1.47.08 2 .21V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2.16c1.78.31 2.54.97 2.71 1.13c.39.39.39 1.03 0 1.42c-.39.39-.91.38-1.42 0c0 0-1.04-.71-3.29-.71c-1.26 0-2.09.41-3.05.9c-1.04.51-2.21 1.1-3.95 1.1c-.36 0-.69 0-1-.04V7.95c.3.05.63.05 1 .05c1.26 0 2.09-.41 3.05-.89C14.09 6.59 15.27 6 17 6V4H7v16h10v-2c1.5 0 1.97.29 2 .31M17 10c-1.73 0-2.91.59-3.95 1.11c-.96.48-1.79.89-3.05.89c-.37 0-.7 0-1-.05v2.01c.31.04.64.04 1 .04c1.74 0 2.91-.59 3.95-1.1c.96-.48 1.79-.9 3.05-.9c2.25 0 3.29.71 3.29.71c.51.39 1.03.39 1.42 0c.39-.39.39-1.02 0-1.42C21.5 11.08 20.25 10 17 10m0 4c-1.73 0-2.91.59-3.95 1.11c-.96.48-1.79.89-3.05.89c-.37 0-.7 0-1-.05v2.01c.31.04.64.04 1 .04c1.74 0 2.91-.59 3.95-1.1c.96-.48 1.79-.9 3.05-.9c2.25 0 3.29.71 3.29.71c.51.39 1.03.39 1.42 0c.39-.39.39-1.02 0-1.42C21.5 15.08 20.25 14 17 14Z"/>'
        },
        "air-horn": {
            body: '<path fill="currentColor" d="M19 2.8v6.4c0 .3-.3.6-.6.5c0 0-3.9-2.6-8.4-2.6v2.4h.2c.5 0 1 .2 1.2.6l1.3 1.8c.2.2.3.5.3.7v8c0 .7-.7 1.4-1.5 1.4h-5c-.8 0-1.5-.6-1.5-1.4v-8c0-.3.1-.5.3-.7l1.3-1.8c.3-.4.7-.6 1.2-.6H8V8c-.4.5-1 .8-1.6.8C5.1 8.8 4 7.5 4 6c0-1.5 1.1-2.8 2.4-2.8c.6.1 1.2.4 1.6.8V2.6h2V5c4.5 0 8.4-2.6 8.4-2.6c.3-.1.6.1.6.4Z"/>'
        },
        "air-humidifier": {
            body: '<path fill="currentColor" d="M11 9c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 6c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2M7 4h7c2.21 0 4 1.79 4 4v1h-2V8a2 2 0 0 0-2-2H7c-1.1 0-2 .9-2 2v12h11v-2h2v4H3V8c0-2.21 1.79-4 4-4m12 6.5s2 2.17 2 3.5c0 1.1-.9 2-2 2s-2-.9-2-2c0-1.33 2-3.5 2-3.5"/>'
        },
        "air-humidifier-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l2.7 2.7C3.3 6.3 3 7.1 3 8v14h15v-2.1l2.8 2.8l1.3-1.2m-12.5-10l2.8 2.8c-.3.4-.8.7-1.4.7c-1.1 0-2-.9-2-2c0-.6.3-1.1.6-1.5m6.4 6.4V20H5V8c0-.3.1-.6.2-.9l3 3C7.5 10.8 7 11.9 7 13c0 2.2 1.8 4 4 4c1.1 0 2.2-.5 2.9-1.2l2.1 2.1m1-4.1c.1-1.3 2-3.3 2-3.3s2 2.2 2 3.5c0 1-.8 1.9-1.8 2L17 13.8M9.2 6l-2-2H14c2.2 0 4 1.8 4 4v1h-2V8c0-1.1-.9-2-2-2H9.2Z"/>'
        },
        "air-purifier": {
            body: '<path fill="currentColor" d="M11 9a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M7 4h7a4 4 0 0 1 4 4v1h-2V8a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v12h11v-2h2v4H3V8a4 4 0 0 1 4-4m9 7c2.5 0 2.5-2 5-2v2c-2.5 0-2.5 2-5 2v-2m0 4c2.5 0 2.5-2 5-2v2c-2.5 0-2.5 2-5 2v-2Z"/>'
        },
        "air-purifier-off": {
            body: '<path fill="currentColor" d="M21 11c-2.4 0-2.5 1.9-4.8 2l-.2-.2V11c2.5 0 2.5-2 5-2v2m1.1 10.5l-1.3 1.3l-2.8-2.9V22H3V8c0-.9.3-1.7.8-2.3L1.1 3l1.3-1.3l19.7 19.8M9 13c0 1.1.9 2 2 2c.6 0 1.1-.3 1.5-.6l-2.8-2.8c-.4.3-.7.8-.7 1.4m7 4.9l-2.1-2.1c-.7.7-1.8 1.2-2.9 1.2c-2.2 0-4-1.8-4-4c0-1.1.5-2.2 1.2-2.9l-3-3c-.1.3-.2.6-.2.9v12h11v-2.1m5-2.9v-2c-1.7 0-2.3 1-3.3 1.5l1.1 1.1c.6-.3 1.2-.6 2.2-.6m-7-9c1.1 0 2 .9 2 2v1h2V8c0-2.2-1.8-4-4-4H7.2l2 2H14Z"/>'
        },
        airbag: {
            body: '<path fill="currentColor" d="M14 8a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5m-3.54 7.55L13 18.03l-2 .02l-3.5 3.53L6 20.09l4.46-4.54M17 2c1.08 0 2 .88 2 2c0 1.08-.88 2-2 2c-1.08 0-2-.88-2-2c0-1.08.89-2 2-2m-2.59 13h-2.82l5.7 5.71l1.42-1.42l-4.3-4.29m.71-.71l4.29 4.3l.22.21c.23-.38.37-.8.37-1.3v-8A2.5 2.5 0 0 0 17.5 7A2.5 2.5 0 0 0 15 9.5v4.67l.12.12Z"/>'
        },
        airballoon: {
            body: '<path fill="currentColor" d="M11 23a2 2 0 0 1-2-2v-2h6v2a2 2 0 0 1-2 2h-2m1-22c.71 0 1.39.09 2.05.26C15.22 2.83 16 5.71 16 9c0 2.28-.38 4.37-1 7a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2c-.62-2.63-1-4.72-1-7c0-3.29.78-6.17 1.95-7.74C10.61 1.09 11.29 1 12 1m8 7c0 3.18-1.85 7.92-4.54 9.21C16.41 15.39 17 11.83 17 9c0-2.83-.59-5.39-1.54-7.21C18.15 3.08 20 4.82 20 8M4 8c0-3.18 1.85-4.92 4.54-6.21C7.59 3.61 7 6.17 7 9s.59 6.39 1.54 8.21C5.85 15.92 4 11.18 4 8Z"/>'
        },
        "airballoon-outline": {
            body: '<path fill="currentColor" d="M11 23c-1.1 0-2-.9-2-2v-2h6v2c0 1.1-.9 2-2 2h-2m1-20c.28 0 .55 0 .81.05C13.42 4.22 14 6.26 14 9c0 2.1-1 7-1 7h-2s-1-4.9-1-7c0-2.74.58-4.78 1.19-5.95c.26-.05.53-.05.81-.05m0-2c-.71 0-1.39.09-2.05.26C8.78 2.83 8 5.71 8 9c0 2.28.38 4.37 1 7c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2c.62-2.63 1-4.72 1-7c0-3.29-.78-6.17-1.95-7.74C13.39 1.09 12.71 1 12 1M4 8c0 3.18 1.85 7.92 4.54 9.21c-.54-1-.93-2.54-1.2-4.21C6.55 11.53 6 9.62 6 8c0-1.34.44-2.33 1.47-3.2c.26-1.13.62-2.15 1.07-3.01C5.85 3.08 4 4.82 4 8m11.46-6.21c.45.86.81 1.88 1.07 3.01C17.56 5.67 18 6.66 18 8c0 1.62-.55 3.53-1.34 5c-.27 1.67-.66 3.21-1.2 4.21C18.15 15.92 20 11.18 20 8s-1.85-4.92-4.54-6.21Z"/>'
        },
        airplane: {
            body: '<path fill="currentColor" d="M20.56 3.91c.59.59.59 1.54 0 2.12l-3.89 3.89l2.12 9.19l-1.41 1.42l-3.88-7.43L9.6 17l.36 2.47l-1.07 1.06l-1.76-3.18l-3.19-1.77L5 14.5l2.5.37L11.37 11L3.94 7.09l1.42-1.41l9.19 2.12l3.89-3.89c.56-.58 1.56-.58 2.12 0Z"/>'
        },
        "airplane-alert": {
            body: '<path fill="currentColor" d="M17.56 3.91c.59.59.59 1.54 0 2.12l-3.89 3.89l2.12 9.19l-1.41 1.42l-3.88-7.43L6.6 17l.36 2.47l-1.07 1.06l-1.76-3.18l-3.186-1.77L2 14.5l2.5.37L8.37 11L.944 7.09L2.36 5.68l9.19 2.12l3.89-3.89c.56-.58 1.56-.58 2.12 0M20 7v6h2V7h-2m0 10h2v-2h-2v2Z"/>'
        },
        "airplane-check": {
            body: '<path fill="currentColor" d="M15.97 13.83A5.89 5.89 0 0 0 13.82 16l-2.27-4.37l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1.24 5.38m5.37 2.01l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "airplane-clock": {
            body: '<path fill="currentColor" d="M16 9c-.91 0-1.77.18-2.57.5l-.7-3.05l3.89-3.89c.58-.56.58-1.53 0-2.12s-1.54-.586-2.12 0l-3.89 3.89l-9.2-2.12L0 3.62L7.43 7.5l-3.89 3.9l-2.48-.35L0 12.11l3.18 1.76l1.77 3.19L6 16l-.34-2.5l3.89-3.87l1.02 1.96A6.995 6.995 0 0 0 16 23c3.87 0 7-3.13 7-7s-3.13-7-7-7m0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75V12H15v5l3.61 2.16l.75-1.22l-2.86-1.69Z"/>'
        },
        "airplane-cog": {
            body: '<path fill="currentColor" d="M15.73 12.81c-.97.52-1.81 1.26-2.44 2.15l-1.74-3.33l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1 4.36m8.07 7.59c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "airplane-edit": {
            body: '<path fill="currentColor" d="M11.55 11.63L7.66 15.5L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1.3 5.65l-2.09 2.09l-2.39-4.56M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "airplane-landing": {
            body: '<path fill="currentColor" d="M2.5 19h19v2h-19v-2m7.18-5.73l4.35 1.16l5.31 1.42c.8.21 1.62-.26 1.84-1.06c.21-.79-.26-1.62-1.06-1.84l-5.31-1.42l-2.76-9.03l-1.93-.5v8.28L5.15 8.95l-.93-2.32l-1.45-.39v5.17l1.6.43l5.31 1.43Z"/>'
        },
        "airplane-marker": {
            body: '<path fill="currentColor" d="M15.33 11.05a5.525 5.525 0 0 0-2.24 3.53l-1.54-2.95l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l.6 2.6M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2"/>'
        },
        "airplane-minus": {
            body: '<path fill="currentColor" d="M15.97 13.83A5.89 5.89 0 0 0 13.82 16l-2.27-4.37l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1.24 5.38M15 18v2h8v-2h-8Z"/>'
        },
        "airplane-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18 19.9l-.62.63L16 17.89l-3.65-3.65L9.6 17l.36 2.47l-1.07 1.06l-1.76-3.18l-3.19-1.77L5 14.5l2.5.37l2.73-2.75L6.59 8.5L3.94 7.09l.63-.63L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M16.67 9.92l3.89-3.89c.59-.58.59-1.53 0-2.12s-1.56-.58-2.12 0L14.55 7.8L9.94 6.74l7.8 7.8l-1.07-4.62Z"/>'
        },
        "airplane-plus": {
            body: '<path fill="currentColor" d="M15.97 13.83A5.89 5.89 0 0 0 13.82 16l-2.27-4.37l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1.24 5.38M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "airplane-remove": {
            body: '<path fill="currentColor" d="M15.97 13.83A5.89 5.89 0 0 0 13.82 16l-2.27-4.37l-3.89 3.87L8 18l-1.05 1.06l-1.77-3.19L2 14.11l1.06-1.06l2.48.35l3.89-3.9L2 5.62l1.41-1.41l9.2 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.58.59.58 1.56 0 2.12l-3.89 3.89l1.24 5.38m6.57 3.05l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "airplane-search": {
            body: '<path fill="currentColor" d="m9.55 9.63l1.35 2.59c.6-1.05 1.51-1.91 2.6-2.48l-.77-3.29l3.89-3.89c.58-.59.58-1.56 0-2.122s-1.54-.586-2.12 0L10.61 4.33l-9.2-2.12L0 3.62L7.43 7.5l-3.89 3.9l-2.48-.35L0 12.11l3.18 1.76l1.77 3.19L6 16l-.34-2.5l3.89-3.87M16.5 11c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5"/>'
        },
        "airplane-settings": {
            body: '<path fill="currentColor" d="M20.09 4.56L16.2 8.45l2.12 9.19l-1.41 1.42L13 11.63L9.13 15.5L9.5 18l-1.08 1.06l-1.77-3.19l-3.18-1.76l1.06-1.07L7 13.4l3.9-3.9l-7.43-3.88l1.42-1.41l9.19 2.12l3.89-3.89a1.49 1.49 0 0 1 2.12 0c.59.56.59 1.53 0 2.12M7 24h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        "airplane-takeoff": {
            body: '<path fill="currentColor" d="M2.5 19h19v2h-19v-2m19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10L8 3.57l-1.91.51l4.14 7.17l-4.97 1.33l-1.97-1.54l-1.45.39l1.82 3.16l.77 1.33l1.6-.42l5.31-1.43l4.35-1.16L21 11.5c.81-.24 1.28-1.06 1.07-1.86Z"/>'
        },
        airport: {
            body: '<path fill="currentColor" d="M14.97 5.92a.967.967 0 0 0-1.18-.68l-3.4.91l-4.44-4.12l-1.23.33l2.66 4.59l-3.19.85l-1.26-.98l-.93.25l1.66 2.88l10.62-2.84c.52-.15.82-.68.69-1.19M21 10l-1 2h-5l-1-2l1-1h2V7h1v2h2l1 1m1 10v2H2v-2h13v-7h5v7h2Z"/>'
        },
        alarm: {
            body: '<path fill="currentColor" d="M12 20a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m0-16a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m.5 4H11v6l4.75 2.85l.75-1.23l-4-2.37V8M7.88 3.39L6.6 1.86L2 5.71l1.29 1.53l4.59-3.85M22 5.72l-4.6-3.86l-1.29 1.53l4.6 3.86L22 5.72Z"/>'
        },
        "alarm-bell": {
            body: '<path fill="currentColor" d="M15 18.66V22H5v-3.34a9.982 9.982 0 0 0 10 0M22 4a2 2 0 0 0-2-2c-.31 0-.61.07-.88.21c-.3.15-.56.37-.76.64A1.997 1.997 0 0 0 20 6h.24c1.73 4.43.42 9.46-3.24 12.5c-.32.25-.65.5-1 .72V21h1v-1.26c3.14-2.24 5-5.88 5-9.74c0-1.5-.28-3-.83-4.38c.52-.38.83-.98.83-1.62m-4 6a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8Z"/>'
        },
        "alarm-check": {
            body: '<path fill="currentColor" d="M10.54 14.53L8.41 12.4l-1.06 1.06l3.18 3.18l6-6l-1.06-1.06l-4.93 4.95M12 20a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m0-16a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m-4.12-.61L6.6 1.86L2 5.71l1.29 1.53l4.59-3.85M22 5.72l-4.6-3.86l-1.29 1.53l4.6 3.86L22 5.72Z"/>'
        },
        "alarm-light": {
            body: '<path fill="currentColor" d="M6 6.9L3.87 4.78l1.41-1.41L7.4 5.5L6 6.9M13 1v3h-2V1h2m7.13 3.78L18 6.9l-1.4-1.4l2.12-2.13l1.41 1.41M4.5 10.5v2h-3v-2h3m15 0h3v2h-3v-2M6 20h12a2 2 0 0 1 2 2H4a2 2 0 0 1 2-2m6-15a6 6 0 0 1 6 6v8H6v-8a6 6 0 0 1 6-6Z"/>'
        },
        "alarm-light-off": {
            body: '<path fill="currentColor" d="m18 14.8l-9-9c.9-.5 1.9-.8 3-.8c3.3 0 6 2.7 6 6v3.8m2.1-10l-1.4-1.4l-2.1 2.1L18 6.9l2.1-2.1m-.6 5.7v2h3v-2h-3m-15 0h-3v2h3v-2M1.1 3l5.5 5.5c-.4.7-.6 1.6-.6 2.5v8h11.1l1 1H6c-1.1 0-2 .9-2 2h16.1l.7.7l1.3-1.3L2.4 1.7L1.1 3M13 1h-2v3h2V1Z"/>'
        },
        "alarm-light-off-outline": {
            body: '<path fill="currentColor" d="M10.5 7.3L9 5.8c.9-.5 1.9-.8 3-.8c3.3 0 6 2.7 6 6v3.8l-2-2V11c0-2.2-1.8-4-4-4c-.5 0-1 .1-1.5.3m9.6-2.5l-1.4-1.4l-2.1 2.1L18 6.9l2.1-2.1m-.6 5.7v2h3v-2h-3m-15 0h-3v2h3v-2M2.4 1.7l19.7 19.7l-1.3 1.3l-.7-.7H4c0-1.1.9-2 2-2h12.1l-1-1H6v-8c0-.9.2-1.8.6-2.5L1.1 3l1.3-1.3M8 17h7.1l-7-7c0 .3-.1.7-.1 1v6m5-16h-2v3h2V1Z"/>'
        },
        "alarm-light-outline": {
            body: '<path fill="currentColor" d="M6 6.9L3.87 4.78l1.41-1.41L7.4 5.5L6 6.9M13 1v3h-2V1h2m7.13 3.78L18 6.9l-1.4-1.4l2.12-2.13l1.41 1.41M4.5 10.5v2h-3v-2h3m15 0h3v2h-3v-2M6 20h12a2 2 0 0 1 2 2H4a2 2 0 0 1 2-2m6-15a6 6 0 0 1 6 6v8H6v-8a6 6 0 0 1 6-6m0 2a4 4 0 0 0-4 4v6h8v-6a4 4 0 0 0-4-4Z"/>'
        },
        "alarm-multiple": {
            body: '<path fill="currentColor" d="M9.29 3.25L5.16 6.72L4 5.34l4.14-3.47l1.15 1.38M22 5.35l-1.16 1.38l-4.14-3.48l1.16-1.38L22 5.35M13 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m-1 1.5h1.5v4.53l3.22 1.47l-.62 1.36L12 13V7.5M1 14c0-2.5 1.13-4.7 2.91-6.17A9.975 9.975 0 0 0 3 12l.06 1.13L3 14c0 2.28 1.27 4.26 3.14 5.28c1.3 1.22 2.93 2.11 4.75 2.5c-.61.14-1.24.22-1.89.22a8 8 0 0 1-8-8Z"/>'
        },
        "alarm-note": {
            body: '<path fill="currentColor" d="m17.4 1.86l-1.29 1.53l4.6 3.86L22 5.72l-4.6-3.86m-10.8 0L2 5.71l1.29 1.53l4.59-3.85L6.6 1.86M12 4a9 9 0 0 0-9 9a9 9 0 0 0 9 9c.33 0 .67 0 1-.06v-2c-.33.06-.67.06-1 .06a7 7 0 0 1-7-7a7 7 0 0 1 7-7c3.1 0 5.83 2.03 6.71 5h2.07C19.85 6.9 16.2 4 12 4m11 11h-3v5.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5c.54 0 1.07.18 1.5.5V13h4v2M11.5 8v5.25l-4 2.37l.75 1.23L13 14V8h-1.5Z"/>'
        },
        "alarm-note-off": {
            body: '<path fill="currentColor" d="M19 13v2.8l1 1V15h3v-2h-4M2.38 1.73L1.11 3L3 4.88l-1 .83l1.29 1.53l1.12-.94l.8.8c-3.26 3.75-2.86 9.44.9 12.7A8.959 8.959 0 0 0 12 22c.33 0 .67 0 1-.06v-2c-.33.06-.67.06-1 .06a7 7 0 0 1-7-7c0-1.64.57-3.23 1.63-4.5l4.78 4.8l-3.91 2.32l.75 1.23l4.19-2.52l3.94 3.94a2.498 2.498 0 0 0-1.13 3.35a2.498 2.498 0 0 0 3.35 1.13c.49-.25.9-.64 1.13-1.13l1.11 1.11l1.27-1.27L2.38 1.73M12 6c3.1 0 5.83 2.03 6.71 5h2.07C19.85 6.9 16.2 4 12 4c-1.35 0-2.69.3-3.9.9l1.52 1.52C10.38 6.14 11.19 6 12 6m-.5 2.3L13 9.8V8h-1.5v.3M7.88 3.39L6.6 1.86l-.84.7L7.18 4l.7-.61m9.52-1.53l-1.29 1.53l4.6 3.86L22 5.72l-4.6-3.86Z"/>'
        },
        "alarm-off": {
            body: '<path fill="currentColor" d="M8 3.28L6.6 1.86l-.86.71L7.16 4m9.31 14.39C15.26 19.39 13.7 20 12 20a7 7 0 0 1-7-7c0-1.7.61-3.26 1.61-4.47M2.92 2.29L1.65 3.57L3 4.9l-1.13.93l1.42 1.42l1.11-.94l.8.8A8.964 8.964 0 0 0 3 13a9 9 0 0 0 9 9c2.25 0 4.31-.83 5.89-2.2l2.2 2.2l1.27-1.27L3.89 3.27l-.97-.98M22 5.72l-4.6-3.86l-1.29 1.53l4.6 3.86L22 5.72M12 6a7 7 0 0 1 7 7c0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 0 0-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6Z"/>'
        },
        "alarm-panel": {
            body: '<path fill="currentColor" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M8 19H5v-2h3v2m0-3H5v-2h3v2m0-3H5v-2h3v2m5.5 6h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3v-2h3v2m5.5 6h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3v-2h3v2m0-4H5V5h14v4Z"/>'
        },
        "alarm-panel-outline": {
            body: '<path fill="currentColor" d="M9 12H6v-2h3v2m4.5-2h-3v2h3v-2m4.5 0h-3v2h3v-2m0-4H6v3h12V6m2-1H4v14h16V5m0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h16M9 13H6v2h3v-2m4.5 0h-3v2h3v-2m4.5 0h-3v2h3v-2m-9 3H6v2h3v-2m4.5 0h-3v2h3v-2m4.5 0h-3v2h3v-2Z"/>'
        },
        "alarm-plus": {
            body: '<path fill="currentColor" d="M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3m-1 8a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m0-16a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m10 1.72l-4.6-3.86l-1.29 1.53l4.6 3.86M7.88 3.39L6.6 1.86L2 5.71l1.29 1.53l4.59-3.85Z"/>'
        },
        "alarm-snooze": {
            body: '<path fill="currentColor" d="M7.88 3.39L6.6 1.86L2 5.71l1.29 1.53l4.59-3.85M22 5.72l-4.6-3.86l-1.29 1.53l4.6 3.86L22 5.72M12 4a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m0 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2Z"/>'
        },
        album: {
            body: '<path fill="currentColor" d="M12 11a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 5.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5s-2 4.5-4.5 4.5M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        alert: {
            body: '<path fill="currentColor" d="M13 14h-2V9h2m0 9h-2v-2h2M1 21h22L12 2L1 21Z"/>'
        },
        "alert-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m8 10V7h-2v6h2m0 4v-2h-2v2h2Z"/>'
        },
        "alert-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8 12h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        "alert-circle": {
            body: '<path fill="currentColor" d="M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "alert-circle-check": {
            body: '<path fill="currentColor" d="m18.75 22.16l-2.75-3L17.16 18l1.59 1.59L22.34 16l1.16 1.41l-4.75 4.75M13 13V7h-2v6h2m0 4v-2h-2v2h2M12 2c5.5 0 10 4.5 10 10l-.09 1.31A6.005 6.005 0 0 0 14 19c0 .95.22 1.85.62 2.65c-.84.23-1.71.35-2.62.35c-5.5 0-10-4.5-10-10S6.5 2 12 2Z"/>'
        },
        "alert-circle-check-outline": {
            body: '<path fill="currentColor" d="m18.75 22.16l-2.75-3L17.16 18l1.59 1.59L22.34 16l1.16 1.41l-4.75 4.75M11 15h2v2h-2v-2m0-8h2v6h-2V7m1-5c5.5 0 10 4.5 10 10l-.08 1.31c-.61-.2-1.25-.31-1.98-.31l.06-1c0-4.42-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8c.71 0 1.39-.09 2.05-.26c.08.68.28 1.32.57 1.91c-.84.23-1.72.35-2.62.35c-5.53 0-10-4.5-10-10S6.47 2 12 2Z"/>'
        },
        "alert-circle-outline": {
            body: '<path fill="currentColor" d="M11 15h2v2h-2v-2m0-8h2v6h-2V7m1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8Z"/>'
        },
        "alert-decagram": {
            body: '<path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68L23 12m-10 5h-2v-2h2v2m0-4h-2V7h2v6Z"/>'
        },
        "alert-decagram-outline": {
            body: '<path fill="currentColor" d="m23 12l-2.44 2.78l.34 3.68l-3.61.82l-1.89 3.18L12 21l-3.4 1.47l-1.89-3.18l-3.61-.82l.34-3.69L1 12l2.44-2.79l-.34-3.68l3.61-.81L8.6 1.54L12 3l3.4-1.46l1.89 3.18l3.61.82l-.34 3.68L23 12m-2.67 0L18.5 9.89l.24-2.79L16 6.5l-1.42-2.43L12 5.18L9.42 4.07L8 6.5l-2.74.59l.24 2.79L3.67 12l1.83 2.1l-.24 2.8l2.74.6l1.42 2.43L12 18.81l2.58 1.11L16 17.5l2.74-.61l-.24-2.79l1.83-2.1M11 15h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        "alert-minus": {
            body: '<path fill="currentColor" d="M14 19c0-2.79 1.91-5.13 4.5-5.8L12 2L1 21h13.35c-.22-.63-.35-1.3-.35-2m-1-1h-2v-2h2v2m0-4h-2v-4h2v4m11 4v2h-8v-2h8Z"/>'
        },
        "alert-minus-outline": {
            body: '<path fill="currentColor" d="M11 15.5h2v2h-2v-2m3 3.5v-.4H5.4L12 7.3l4.11 7.14c.51-.44 1.09-.79 1.73-1.03L12 3.3L2 20.6h12.22c-.14-.51-.22-1.04-.22-1.6m-1-8.5h-2v4h2v-4m3 7.5v2h8v-2h-8Z"/>'
        },
        "alert-octagon": {
            body: '<path fill="currentColor" d="M13 13h-2V7h2m-2 8h2v2h-2m4.73-14H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3Z"/>'
        },
        "alert-octagon-outline": {
            body: '<path fill="currentColor" d="M8.27 3L3 8.27v7.46L8.27 21h7.46C17.5 19.24 21 15.73 21 15.73V8.27L15.73 3M9.1 5h5.8L19 9.1v5.8L14.9 19H9.1L5 14.9V9.1m6 5.9h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        "alert-octagram": {
            body: '<path fill="currentColor" d="M2.2 16.06L3.88 12L2.2 7.94l4.06-1.68L7.94 2.2L12 3.88l4.06-1.68l1.68 4.06l4.06 1.68L20.12 12l1.68 4.06l-4.06 1.68l-1.68 4.06L12 20.12L7.94 21.8l-1.68-4.06l-4.06-1.68M13 17v-2h-2v2h2m0-4V7h-2v6h2Z"/>'
        },
        "alert-octagram-outline": {
            body: '<path fill="currentColor" d="M2.2 16.06L3.88 12L2.2 7.94l4.06-1.68L7.94 2.2L12 3.88l4.06-1.68l1.68 4.06l4.06 1.68L20.12 12l1.68 4.06l-4.06 1.68l-1.68 4.06L12 20.12L7.94 21.8l-1.68-4.06l-4.06-1.68M4.81 9l1.24 3l-1.24 3l2.98 1.21L9 19.19l3-1.24l3 1.24l1.21-2.98L19.19 15l-1.24-3l1.24-3l-2.98-1.21L15 4.81l-3 1.24l-3-1.24l-1.21 2.98L4.81 9M11 15h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        "alert-outline": {
            body: '<path fill="currentColor" d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2"/>'
        },
        "alert-plus": {
            body: '<path fill="currentColor" d="M14 19c0-2.79 1.91-5.13 4.5-5.8L12 2L1 21h13.35c-.22-.63-.35-1.3-.35-2m-1-1h-2v-2h2v2m0-4h-2v-4h2v4m8 1v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "alert-plus-outline": {
            body: '<path fill="currentColor" d="M11 15.5h2v2h-2v-2m3 3.5v-.4H5.4L12 7.3l4.11 7.14c.51-.44 1.09-.79 1.73-1.03L12 3.3L2 20.6h12.22c-.14-.51-.22-1.04-.22-1.6m-1-8.5h-2v4h2v-4m6 4.5v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "alert-remove": {
            body: '<path fill="currentColor" d="M14 19c0-2.79 1.91-5.13 4.5-5.8L12 2L1 21h13.35c-.22-.63-.35-1.3-.35-2m-1-1h-2v-2h2v2m0-4h-2v-4h2v4m10.54 2.88L21.41 19l2.13 2.12l-1.42 1.42L20 20.41l-2.12 2.13l-1.41-1.42L18.59 19l-2.12-2.12l1.41-1.41L20 17.59l2.12-2.13l1.42 1.42Z"/>'
        },
        "alert-remove-outline": {
            body: '<path fill="currentColor" d="M11 15.5h2v2h-2v-2m3 3.5v-.4H5.4L12 7.3l4.11 7.14c.51-.44 1.09-.79 1.73-1.03L12 3.3L2 20.6h12.22c-.14-.51-.22-1.04-.22-1.6m-1-8.5h-2v4h2v-4m9.12 4.96L20 17.59l-2.12-2.13l-1.41 1.42L18.59 19l-2.12 2.12l1.41 1.42L20 20.41l2.12 2.13l1.42-1.42L21.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "alert-rhombus": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m-1 5h2v6h-2V7m0 8h2v2h-2v-2Z"/>'
        },
        "alert-rhombus-outline": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l8 8l-8 8l-8-8m7-5v6h2V7m-2 8v2h2v-2Z"/>'
        },
        alien: {
            body: '<path fill="currentColor" d="M12 3c4.97 0 9 3.58 9 8s-6 10-9 10s-9-5.58-9-10s4.03-8 9-8m-1.69 7.93C9.29 9.29 7.47 8.58 6.25 9.34c-1.22.76-1.38 2.71-.36 4.35c1.03 1.64 2.85 2.35 4.07 1.59c1.22-.78 1.37-2.71.35-4.35m3.38 0c-1.02 1.64-.87 3.57.35 4.35c1.22.76 3.04.05 4.07-1.59c1.02-1.64.86-3.59-.36-4.35c-1.22-.76-3.04-.05-4.06 1.59M12 17.75c-2 0-2.5-.75-2.5-.75c0 .03.5 2 2.5 2s2.5-2 2.5-2s-.5.75-2.5.75Z"/>'
        },
        "alien-outline": {
            body: '<path fill="currentColor" d="M10.31 10.93c1.02 1.64.87 3.57-.35 4.35c-1.22.76-3.04.05-4.07-1.59c-1.02-1.64-.86-3.59.36-4.35c1.22-.76 3.04-.05 4.06 1.59M12 17.75c2 0 2.5-.75 2.5-.75s-.5 2-2.5 2s-2.5-1.97-2.5-2c0 0 .5.75 2.5.75m5.75-8.41c1.22.76 1.38 2.71.36 4.35c-1.03 1.64-2.85 2.35-4.07 1.59c-1.22-.78-1.37-2.71-.35-4.35c1.02-1.64 2.84-2.35 4.06-1.59M12 20c2.5 0 8-5.14 8-9c0-3.86-3.59-7-8-7s-8 3.14-8 7s5.5 9 8 9m0-18c5.5 0 10 4.04 10 9c0 4.08-5.68 11-10 11S2 15.08 2 11c0-4.96 4.5-9 10-9Z"/>'
        },
        "align-horizontal-center": {
            body: '<path fill="currentColor" d="M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8V2Z"/>'
        },
        "align-horizontal-distribute": {
            body: '<path fill="currentColor" d="M4 22H2V2h2v20M22 2h-2v20h2V2m-8.5 5h-3v10h3V7Z"/>'
        },
        "align-horizontal-left": {
            body: '<path fill="currentColor" d="M4 22H2V2h2v20M22 7H6v3h16V7m-6 7H6v3h10v-3Z"/>'
        },
        "align-horizontal-right": {
            body: '<path fill="currentColor" d="M20 2h2v20h-2V2M2 10h16V7H2v3m6 7h10v-3H8v3Z"/>'
        },
        "align-vertical-bottom": {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2M10 2H7v16h3V2m7 6h-3v10h3V8Z"/>'
        },
        "align-vertical-center": {
            body: '<path fill="currentColor" d="M22 11h-5V6h-3v5h-4V3H7v8H1.8v2H7v8h3v-8h4v5h3v-5h5v-2Z"/>'
        },
        "align-vertical-distribute": {
            body: '<path fill="currentColor" d="M22 2v2H2V2h20M7 10.5v3h10v-3H7M2 20v2h20v-2H2Z"/>'
        },
        "align-vertical-top": {
            body: '<path fill="currentColor" d="M22 2v2H2V2h20M7 22h3V6H7v16m7-6h3V6h-3v10Z"/>'
        },
        "all-inclusive": {
            body: '<path fill="currentColor" d="M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99C3.53 15.38 2 13.87 2 12c0-1.87 1.53-3.38 3.4-3.38c.91 0 1.76.35 2.44 1.03l1.13 1l1.53-1.34L9.22 8.2A5.37 5.37 0 0 0 5.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l7.03-6.24c.64-.64 1.49-.99 2.4-.99c1.87 0 3.4 1.51 3.4 3.38c0 1.87-1.53 3.38-3.4 3.38c-.9 0-1.76-.35-2.44-1.03L15 13.34l-1.5 1.34l1.28 1.12a5.386 5.386 0 0 0 3.82 1.57c2.98 0 5.4-2.41 5.4-5.37c0-3-2.42-5.38-5.4-5.38Z"/>'
        },
        "all-inclusive-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-2.9 12.9c-1.03 0-2.01-.4-2.75-1.14l-.64-.64l1.42-1.41l.63.63A1.897 1.897 0 0 0 18 12a1.9 1.9 0 0 0-1.9-1.9c-.5 0-.98.2-1.34.56l-4.11 4.1A3.85 3.85 0 0 1 7.9 15.9C5.75 15.9 4 14.15 4 12s1.75-3.9 3.9-3.9c1.04 0 2.01.4 2.75 1.14l.64.64l-1.42 1.42l-.63-.64c-.36-.36-.84-.56-1.34-.56a1.9 1.9 0 1 0 0 3.8c.5 0 .98-.2 1.34-.56l4.11-4.1A3.85 3.85 0 0 1 16.1 8.1c2.15 0 3.9 1.75 3.9 3.9s-1.75 3.9-3.9 3.9Z"/>'
        },
        "all-inclusive-box-outline": {
            body: '<path fill="currentColor" d="M19 12c0 1.84-1.5 3.34-3.34 3.34c-.89 0-1.72-.34-2.35-.98l-.6-.6l1.06-1.05c.27.29.6.59.6.59c.34.35.81.54 1.3.54c1.01 0 1.83-.84 1.83-1.84s-.82-1.84-1.83-1.84c-.49 0-.96.2-1.3.54l-3.67 3.66c-.63.64-1.47.98-2.36.98C6.5 15.34 5 13.84 5 12s1.5-3.34 3.34-3.34c.89 0 1.73.34 2.36.98l.59.6l-1.06 1.06l-.59-.6c-.35-.34-.81-.54-1.3-.54c-1.02 0-1.84.84-1.84 1.84s.82 1.84 1.84 1.84c.49 0 .95-.19 1.3-.54l3.67-3.66c.63-.64 1.46-.98 2.35-.98C17.5 8.66 19 10.16 19 12m2-7v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2m-2 0H5v14h14V5Z"/>'
        },
        allergy: {
            body: '<path fill="currentColor" d="M19.75 5.33a1.25 1.25 0 0 0-1.25 1.25v4.59h-.83V4.08a1.25 1.25 0 0 0-2.5 0v7.09h-.84V3.25a1.25 1.25 0 1 0-2.5 0v7.92H11V5.33a1.25 1.25 0 0 0-2.5 0v9.93l-3.59-2a1 1 0 0 0-.5-.14a1 1 0 0 0-.66.25l-1.08 1L9.21 21a3.29 3.29 0 0 0 2.37 1h6.09A3.33 3.33 0 0 0 21 18.67V6.58a1.25 1.25 0 0 0-1.25-1.25M11 15a1 1 0 1 1 1-1a1 1 0 0 1-1 1m2 3a1 1 0 1 1 1-1a1 1 0 0 1-1 1m5-2a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-2-4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        allo: {
            body: '<path d="M21.984 12v9c0 .5-.226.82-.68.96c-.452.142-.82.009-1.1-.398l-1.548-2.109c-1.875 1.688-4.093 2.531-6.656 2.531c-2.75 0-5.102-.976-7.055-2.93c-1.953-1.952-2.93-4.304-2.93-7.054s.977-5.102 2.93-7.055C6.898 2.992 9.25 2.015 12 2.015s5.102.977 7.055 2.93c1.953 1.953 2.93 4.305 2.93 7.055z" fill="currentColor"/>',
            hidden: true
        },
        alpha: {
            body: '<path fill="currentColor" d="M18.08 17.8c-.46.13-.87.2-1.23.2c-1.2 0-2.01-.88-2.42-2.65h-.05c-.99 1.91-2.38 2.86-4.13 2.86c-1.31 0-2.36-.49-3.15-1.48S5.92 14.5 5.92 13c0-1.75.45-3.15 1.34-4.24c.89-1.09 2.1-1.64 3.63-1.64c.82 0 1.56.23 2.2.68c.64.46 1.13 1.1 1.47 1.93h.04l.71-2.4h2.56l-2.14 5.32c.24 1.24.49 2.09.77 2.54c.24.45.58.68 1 .68c.24 0 .43-.04.6-.11l-.02 2.04m-4.26-5.24c-.21-1.13-.55-2.01-1.01-2.61c-.45-.61-1-.91-1.63-.91c-.82 0-1.48.37-1.97 1.1c-.49.74-.71 1.65-.71 2.72c0 .98.19 1.79.62 2.45c.42.66.99.98 1.7.98c.6 0 1.15-.29 1.64-.84c.5-.57.91-1.4 1.24-2.49l.12-.4Z"/>'
        },
        "alpha-a": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2h-2m0 2h2v2h-2V9Z"/>'
        },
        "alpha-a-box": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m8 2a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2h-2m0 2h2v2h-2V9Z"/>'
        },
        "alpha-a-box-outline": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5m6 2h2a2 2 0 0 1 2 2v8h-2v-4h-2v4H9V9a2 2 0 0 1 2-2m0 2v2h2V9h-2Z"/>'
        },
        "alpha-a-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-1 5a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2h-2m0 2h2v2h-2V9Z"/>'
        },
        "alpha-a-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h2a2 2 0 0 1 2 2v8h-2v-4h-2v4H9V9a2 2 0 0 1 2-2m0 2v2h2V9h-2m1 11a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-b": {
            body: '<path fill="currentColor" d="M15 10.5V9a2 2 0 0 0-2-2H9v10h4a2 2 0 0 0 2-2v-1.5c0-.8-.7-1.5-1.5-1.5c.8 0 1.5-.7 1.5-1.5M13 15h-2v-2h2v2m0-4h-2V9h2v2Z"/>'
        },
        "alpha-b-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m10 7.5V9a2 2 0 0 0-2-2H9v10h4a2 2 0 0 0 2-2v-1.5c0-.8-.7-1.5-1.5-1.5c.8 0 1.5-.7 1.5-1.5M13 15h-2v-2h2v2m0-4h-2V9h2v2Z"/>'
        },
        "alpha-b-box-outline": {
            body: '<path fill="currentColor" d="M15 10.5c0 .8-.7 1.5-1.5 1.5c.8 0 1.5.7 1.5 1.5V15a2 2 0 0 1-2 2H9V7h4a2 2 0 0 1 2 2v1.5M13 15v-2h-2v2h2m0-4V9h-2v2h2M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-b-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m3 8.5V9a2 2 0 0 0-2-2H9v10h4a2 2 0 0 0 2-2v-1.5c0-.8-.7-1.5-1.5-1.5c.8 0 1.5-.7 1.5-1.5M13 15h-2v-2h2v2m0-4h-2V9h2v2Z"/>'
        },
        "alpha-b-circle-outline": {
            body: '<path fill="currentColor" d="M15 10.5c0 .8-.7 1.5-1.5 1.5c.8 0 1.5.7 1.5 1.5V15a2 2 0 0 1-2 2H9V7h4a2 2 0 0 1 2 2v1.5M13 15v-2h-2v2h2m0-4V9h-2v2h2m-1-9a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-c": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h-2v1h-2V9h2v1h2V9a2 2 0 0 0-2-2h-2Z"/>'
        },
        "alpha-c-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m6 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h-2v1h-2V9h2v1h2V9a2 2 0 0 0-2-2h-2Z"/>'
        },
        "alpha-c-box-outline": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5m6 2h2a2 2 0 0 1 2 2v1h-2V9h-2v6h2v-1h2v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-c-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-1 5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h-2v1h-2V9h2v1h2V9a2 2 0 0 0-2-2h-2Z"/>'
        },
        "alpha-c-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h2a2 2 0 0 1 2 2v1h-2V9h-2v6h2v-1h2v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-d": {
            body: '<path fill="currentColor" d="M9 7v10h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v6h-2V9Z"/>'
        },
        "alpha-d-box": {
            body: '<path fill="currentColor" d="M9 7v10h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v6h-2V9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-d-box-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9V7m2 2v6h2V9h-2M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-d-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M9 7v10h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v6h-2V9Z"/>'
        },
        "alpha-d-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9V7m2 2v6h2V9h-2m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-e": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4v-2h4v-2h-4V9h4V7H9Z"/>'
        },
        "alpha-e-box": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4v-2h4v-2h-4V9h4V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-e-box-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-4v2h4v2h-4v2h4v2H9V7M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-e-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M9 7v10h6v-2h-4v-2h4v-2h-4V9h4V7H9Z"/>'
        },
        "alpha-e-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-4v2h4v2h-4v2h4v2H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-f": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h3v-2h-3V9h4V7H9Z"/>'
        },
        "alpha-f-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h3v-2h-3V9h4V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-f-box-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-4v2h3v2h-3v4H9V7M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-f-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M9 7v10h2v-4h3v-2h-3V9h4V7H9Z"/>'
        },
        "alpha-f-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-4v2h3v2h-3v4H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-g": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4h-2v4h-2V9h4V7h-4Z"/>'
        },
        "alpha-g-box": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4h-2v4h-2V9h4V7h-4M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-g-box-outline": {
            body: '<path fill="currentColor" d="M11 7h4v2h-4v6h2v-4h2v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-g-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-1 5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4h-2v4h-2V9h4V7h-4Z"/>'
        },
        "alpha-g-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h4v2h-4v6h2v-4h2v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-h": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h2v4h2V7h-2v4h-2V7H9Z"/>'
        },
        "alpha-h-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h2v4h2V7h-2v4h-2V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-h-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2v4h2V7h2v10h-2v-4h-2v4H9V7M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m2 0v14h14V5H5Z"/>'
        },
        "alpha-h-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M9 7v10h2v-4h2v4h2V7h-2v4h-2V7H9Z"/>'
        },
        "alpha-h-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2v4h2V7h2v10h-2v-4h-2v4H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-i": {
            body: '<path fill="currentColor" d="M14 7v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "alpha-i-box": {
            body: '<path fill="currentColor" d="M14 7h-4v2h1v6h-1v2h4v-2h-1V9h1V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-i-box-outline": {
            body: '<path fill="currentColor" d="M14 7v2h-1v6h1v2h-4v-2h1V9h-1V7h4M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-i-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m2 5h-4v2h1v6h-1v2h4v-2h-1V9h1V7Z"/>'
        },
        "alpha-i-circle-outline": {
            body: '<path fill="currentColor" d="M14 7v2h-1v6h1v2h-4v-2h1V9h-1V7h4m-2-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-j": {
            body: '<path fill="currentColor" d="M13 7v8h-2v-1H9v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2Z"/>'
        },
        "alpha-j-box": {
            body: '<path fill="currentColor" d="M13 7v8h-2v-1H9v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-j-box-outline": {
            body: '<path fill="currentColor" d="M13 7h2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1h2v1h2V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-j-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m1 5v8h-2v-1H9v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2Z"/>'
        },
        "alpha-j-circle-outline": {
            body: '<path fill="currentColor" d="M13 7h2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1h2v1h2V7m-1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-k": {
            body: '<path fill="currentColor" d="M9 7v10h2v-3.33L13 17h2l-3-5l3-5h-2l-2 3.33V7H9Z"/>'
        },
        "alpha-k-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-3.33L13 17h2l-3-5l3-5h-2l-2 3.33V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-k-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2v3.33L13 7h2l-3 5l3 5h-2l-2-3.33V17H9V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-k-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M9 7v10h2v-3.33L13 17h2l-3-5l3-5h-2l-2 3.33V7H9Z"/>'
        },
        "alpha-k-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2v3.33L13 7h2l-3 5l3 5h-2l-2-3.33V17H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-l": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4V7H9Z"/>'
        },
        "alpha-l-box": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-l-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2v8h4v2H9V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-l-circle": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-l-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2v8h4v2H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-m": {
            body: '<path fill="currentColor" d="M9 7a2 2 0 0 0-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2H9Z"/>'
        },
        "alpha-m-box": {
            body: '<path fill="currentColor" d="M9 7a2 2 0 0 0-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-m-box-outline": {
            body: '<path fill="currentColor" d="M9 7h6a2 2 0 0 1 2 2v8h-2V9h-2v7h-2V9H9v8H7V9a2 2 0 0 1 2-2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-m-circle": {
            body: '<path fill="currentColor" d="M9 7a2 2 0 0 0-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-m-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6a2 2 0 0 1 2 2v8h-2V9h-2v7h-2V9H9v8H7V9a2 2 0 0 1 2-2m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-n": {
            body: '<path fill="currentColor" d="M9 7v10h2v-5l2 5h2V7h-2v5l-2-5H9Z"/>'
        },
        "alpha-n-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-5l2 5h2V7h-2v5l-2-5H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-n-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2l2 5V7h2v10h-2l-2-5v5H9V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-n-circle": {
            body: '<path fill="currentColor" d="M9 7v10h2v-5l2 5h2V7h-2v5l-2-5H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-n-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2l2 5V7h2v10h-2l-2-5v5H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-o": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "alpha-o-box": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-o-box-outline": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5m6 2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2Z"/>'
        },
        "alpha-o-circle": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-o-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-p": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9Z"/>'
        },
        "alpha-p-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-p-box-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v4H9V7m2 2v2h2V9h-2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-p-circle": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-p-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v4H9V7m2 2v2h2V9h-2m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-q": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2v2h2v-2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "alpha-q-box": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2v2h2v-2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-q-box-outline": {
            body: '<path fill="currentColor" d="M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v14h14V6H5m6 1h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2v2h-2v-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2Z"/>'
        },
        "alpha-q-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-1 5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2v2h2v-2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "alpha-q-circle-outline": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m-1 3h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2v2h-2v-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2Z"/>'
        },
        "alpha-r": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h.8l1.2 4h2l-1.24-4.15C14.5 12.55 15 11.84 15 11V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9Z"/>'
        },
        "alpha-r-box": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h.8l1.2 4h2l-1.24-4.15C14.5 12.55 15 11.84 15 11V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-r-box-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v2c0 .84-.5 1.55-1.24 1.85L15 17h-2l-1.2-4H11v4H9V7m2 2v2h2V9h-2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-r-circle": {
            body: '<path fill="currentColor" d="M9 7v10h2v-4h.8l1.2 4h2l-1.24-4.15C14.5 12.55 15 11.84 15 11V9a2 2 0 0 0-2-2H9m2 2h2v2h-2V9m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-r-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v2c0 .84-.5 1.55-1.24 1.85L15 17h-2l-1.2-4H11v4H9V7m2 2v2h2V9h-2m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 4.41 3.58 8 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-s": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4Z"/>'
        },
        "alpha-s-box": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-s-box-outline": {
            body: '<path fill="currentColor" d="M11 7h4v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H9v-2h4v-2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-s-circle": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4m1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-s-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h4v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H9v-2h4v-2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-t": {
            body: '<path fill="currentColor" d="M9 7v2h2v8h2V9h2V7H9Z"/>'
        },
        "alpha-t-box": {
            body: '<path fill="currentColor" d="M9 7v2h2v8h2V9h2V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-t-box-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-2v8h-2V9H9V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-t-circle": {
            body: '<path fill="currentColor" d="M9 7v2h2v8h2V9h2V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-t-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-2v8h-2V9H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-u": {
            body: '<path fill="currentColor" d="M9 7v8a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2v8h-2V7H9Z"/>'
        },
        "alpha-u-box": {
            body: '<path fill="currentColor" d="M9 7v8a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2v8h-2V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-u-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2v8h2V7h2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-u-circle": {
            body: '<path fill="currentColor" d="M9 7v8a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7h-2v8h-2V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-u-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2v8h2V7h2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-v": {
            body: '<path fill="currentColor" d="m9 7l2 10h2l2-10h-2l-1 5l-1-5H9Z"/>'
        },
        "alpha-v-box": {
            body: '<path fill="currentColor" d="m9 7l2 10h2l2-10h-2l-1 5l-1-5H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-v-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 5l1-5h2l-2 10h-2L9 7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-v-circle": {
            body: '<path fill="currentColor" d="m9 7l2 10h2l2-10h-2l-1 5l-1-5H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-v-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 5l1-5h2l-2 10h-2L9 7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-w": {
            body: '<path fill="currentColor" d="M9 17a2 2 0 0 1-2-2V7h2v8h2V8h2v7h2V7h2v8a2 2 0 0 1-2 2H9Z"/>'
        },
        "alpha-w-box": {
            body: '<path fill="currentColor" d="M9 17h6a2 2 0 0 0 2-2V7h-2v8h-2V8h-2v7H9V7H7v8a2 2 0 0 0 2 2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-w-box-outline": {
            body: '<path fill="currentColor" d="M9 17a2 2 0 0 1-2-2V7h2v8h2V8h2v7h2V7h2v8a2 2 0 0 1-2 2H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-w-circle": {
            body: '<path fill="currentColor" d="M9 17h6a2 2 0 0 0 2-2V7h-2v8h-2V8h-2v7H9V7H7v8a2 2 0 0 0 2 2m3-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-w-circle-outline": {
            body: '<path fill="currentColor" d="M9 17a2 2 0 0 1-2-2V7h2v8h2V8h2v7h2V7h2v8a2 2 0 0 1-2 2H9m3-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-x": {
            body: '<path fill="currentColor" d="m9 7l2 5l-2 5h2l1-2.5l1 2.5h2l-2-5l2-5h-2l-1 2.5L11 7H9Z"/>'
        },
        "alpha-x-box": {
            body: '<path fill="currentColor" d="m9 7l2 5l-2 5h2l1-2.5l1 2.5h2l-2-5l2-5h-2l-1 2.5L11 7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-x-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 2.5L13 7h2l-2 5l2 5h-2l-1-2.5l-1 2.5H9l2-5l-2-5M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-x-circle": {
            body: '<path fill="currentColor" d="m9 7l2 5l-2 5h2l1-2.5l1 2.5h2l-2-5l2-5h-2l-1 2.5L11 7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-x-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 2.5L13 7h2l-2 5l2 5h-2l-1-2.5l-1 2.5H9l2-5l-2-5m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-y": {
            body: '<path fill="currentColor" d="m9 7l2 6v4h2v-4l2-6h-2l-1 3l-1-3H9Z"/>'
        },
        "alpha-y-box": {
            body: '<path fill="currentColor" d="m9 7l2 6v4h2v-4l2-6h-2l-1 3l-1-3H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-y-box-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 3l1-3h2l-2 6v4h-2v-4L9 7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-y-circle": {
            body: '<path fill="currentColor" d="m9 7l2 6v4h2v-4l2-6h-2l-1 3l-1-3H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-y-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2l1 3l1-3h2l-2 6v4h-2v-4L9 7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alpha-z": {
            body: '<path fill="currentColor" d="M9 7v2h4l-4 6v2h6v-2h-4l4-6V7H9Z"/>'
        },
        "alpha-z-box": {
            body: '<path fill="currentColor" d="M9 7v2h4l-4 6v2h6v-2h-4l4-6V7H9M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "alpha-z-box-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2l-4 6h4v2H9v-2l4-6H9V7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "alpha-z-circle": {
            body: '<path fill="currentColor" d="M9 7v2h4l-4 6v2h6v-2h-4l4-6V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "alpha-z-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2l-4 6h4v2H9v-2l4-6H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "alphabet-aurebesh": {
            body: '<path fill="currentColor" d="M3 4v7h11.23L22 4h-3l-5.54 5H5V4H3m0 9v7h2v-5h8.46L19 20h3l-7.77-7H3Z"/>'
        },
        "alphabet-cyrillic": {
            body: '<path fill="currentColor" d="M16 6c-1.64 0-3 1.36-3 3v6c0 1.65 1.36 3 3 3h1c1.65 0 3-1.35 3-3v-3c0-1.64-1.35-3-3-3h-2c0-.56.44-1 1-1h2c1.09 0 2-.91 2-2M5 9v2h3c.57 0 1 .43 1 1H7c-1.64 0-3 1.36-3 3c0 1.65 1.36 3 3 3h4v-6c0-1.64-1.35-3-3-3m7 2h2c.57 0 1 .43 1 1v3c0 .57-.43 1-1 1h-1c-.57 0-1-.43-1-1m-8-1h2v2H7c-.57 0-1-.43-1-1c0-.57.43-1 1-1Z"/>'
        },
        "alphabet-greek": {
            body: '<path fill="currentColor" d="M16 6c-1.64 0-3 1.36-3 3v12h2V9c0-.57.43-1 1-1h1c.57 0 1 .43 1 1v1c0 .57-.43 1-1 1h-1v2h1c.57 0 1 .43 1 1v1c0 .57-.43 1-1 1h-1v2h1c1.65 0 3-1.35 3-3v-1c0-.82-.41-1.54-1-2c.59-.46 1-1.18 1-2V9c0-1.64-1.35-3-3-3M7 9c-1.64 0-3 1.36-3 3v3c0 1.65 1.36 3 3 3h.7c.5 0 .95-.19 1.3-.5v.5h2V9H9v.5c-.35-.31-.8-.5-1.3-.5M7 11h1c.57 0 1 .43 1 1v3c0 .57-.43 1-1 1H7c-.57 0-1-.43-1-1v-3c0-.57.43-1 1-1Z"/>'
        },
        "alphabet-latin": {
            body: '<path fill="currentColor" d="M13 6v12h2v-.69c.37.42.9.69 1.5.69h.5c1.65 0 3-1.35 3-3v-3c0-1.64-1.35-3-3-3h-.5c-.6 0-1.13.27-1.5.7V6M5 9v2h3c.57 0 1 .43 1 1H7c-1.64 0-3 1.36-3 3c0 1.65 1.36 3 3 3h4v-6c0-1.64-1.35-3-3-3m8 2h1c.57 0 1 .43 1 1v3c0 .57-.43 1-1 1h-1c-.57 0-1-.43-1-1v-3c0-.57.43-1 1-1m-9 3h2v2H7c-.57 0-1-.43-1-1c0-.57.43-1 1-1Z"/>'
        },
        "alphabet-piqad": {
            body: '<path fill="currentColor" d="m13.04 4l-6.5 13.85C6.21 18.55 5.5 19 4.73 19H4v1h12c1.2 0 2.27.54 3 1.39h1c-.95-2.07-3-3.39-5.3-3.39H12c-.71 0-1.38-.37-1.76-.97c-.39-.6-.44-1.35-.14-2l.48-1.03H19v-1h-1.5c-2.21 0-4-1.79-4-4s1.79-4 4-4H20V4Z"/>'
        },
        "alphabet-tengwar": {
            body: '<path fill="currentColor" d="m10 7l2.5-4H15l-4 4h-1m2.5 2c-.54 0-1.04.13-1.5.35V9H8v2h1v10h2v-8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H12v2h.5c1.93 0 3.5-1.57 3.5-3.5v-2c0-1.93-1.57-3.5-3.5-3.5Z"/>'
        },
        alphabetical: {
            body: '<path fill="currentColor" d="M6 11a2 2 0 0 1 2 2v4H4a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2m-2 2v2h2v-2H4m16 0v2h2v2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2v2h-2m-8-6v4h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V7h2m0 8h2v-2h-2v2Z"/>'
        },
        "alphabetical-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L16 15.31l-2-2l-.35-.31L10 9.34L2.39 1.73L1.11 3L10 11.89V15a2 2 0 0 0 2 2h2a1.92 1.92 0 0 0 .89-.22l5.95 5.95M12 15v-1.11L13.11 15M16 12.78L14.22 11A2 2 0 0 1 16 12.78M20.2 17L18 14.8V13a2 2 0 0 1 2-2h2v2h-2v2h2v2M6 11H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4v-4a2 2 0 0 0-2-2m0 4H4v-2h2m6-4.2L10.2 7H12Z"/>'
        },
        "alphabetical-variant": {
            body: '<path fill="currentColor" d="M3 7a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2H3m0 2h2v2H3m12-.5V9a2 2 0 0 0-2-2H9v10h4a2 2 0 0 0 2-2v-1.5a1.54 1.54 0 0 0-1.5-1.5a1.54 1.54 0 0 0 1.5-1.5M13 15h-2v-2h2v2m0-4h-2V9h2m6-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h-2v1h-2V9h2v1h2V9a2 2 0 0 0-2-2Z"/>'
        },
        "alphabetical-variant-off": {
            body: '<path fill="currentColor" d="m12.2 9l-2-2H13a2 2 0 0 1 2 2v1.5a1.47 1.47 0 0 1-.36.94L13 9.8V9m10 1V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4.8l3.2 3.2h.8a2 2 0 0 0 2-2v-1h-2v1h-2V9h2v1m-6 4.35l7.11 7.11l-1.27 1.27l-6.38-6.38A2 2 0 0 1 13 17H9v-6.11l-2-2V17H5v-4H3v4H1V9a2 2 0 0 1 2-2h2.12l-4-4l1.27-1.27L9 8.34l2 2l.66.66L15 14.34M5 9H3v2h2m8 3.89L11.11 13H11v2h2Z"/>'
        },
        altimeter: {
            body: '<path fill="currentColor" d="M7 3v2h10V3H7m2 4v2h6V7H9m-7 .96v8.08L6.03 12L2 7.96m20.03 0L18 12l4.03 4.04V7.96M7 11v2h10v-2H7m2 4v2h6v-2H9m-2 4v2h10v-2H7Z"/>'
        },
        amazon: {
            body: '<path d="M15.93 17.09c-.18.16-.43.17-.63.06c-.89-.74-1.05-1.08-1.54-1.79c-1.47 1.5-2.51 1.95-4.42 1.95c-2.25 0-4.01-1.39-4.01-4.17c0-2.18 1.17-3.64 2.86-4.38c1.46-.64 3.49-.76 5.04-.93V7.5c0-.66.05-1.41-.33-1.96c-.32-.49-.95-.7-1.5-.7c-1.02 0-1.93.53-2.15 1.61c-.05.24-.25.48-.47.49l-2.6-.28c-.22-.05-.46-.22-.4-.56c.6-3.15 3.45-4.1 6-4.1c1.3 0 3 .35 4.03 1.33C17.11 4.55 17 6.18 17 7.95v4.17c0 1.25.5 1.81 1 2.48c.17.25.21.54 0 .71l-2.06 1.78h-.01m-2.7-6.53V10c-1.94 0-3.99.39-3.99 2.67c0 1.16.61 1.95 1.63 1.95c.76 0 1.43-.47 1.86-1.22c.52-.93.5-1.8.5-2.84m6.93 8.98C18 21.14 14.82 22 12.1 22c-3.81 0-7.25-1.41-9.85-3.76c-.2-.18-.02-.43.25-.29c2.78 1.63 6.25 2.61 9.83 2.61c2.41 0 5.07-.5 7.51-1.53c.37-.16.66.24.32.51m.91-1.04c-.28-.36-1.85-.17-2.57-.08c-.19.02-.22-.16-.03-.3c1.24-.88 3.29-.62 3.53-.33c.24.3-.07 2.35-1.24 3.32c-.18.16-.35.07-.26-.11c.26-.67.85-2.14.57-2.5z" fill="currentColor"/>',
            hidden: true
        },
        "amazon-alexa": {
            body: '<path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1.57 19.87v-1.96c0-.69-.43-1.34-1.08-1.61c-2.44-1.04-4.18-3.47-4.18-6.3c0-3.74 3.05-6.83 6.83-6.83c3.78 0 6.83 3.09 6.83 6.83c0 4.43-3.44 8.61-8.4 9.87z" fill="currentColor"/>',
            hidden: true
        },
        "amazon-drive": {
            body: '<path d="M4.94 11.12c.29 0 .56.04.82.11a3.892 3.892 0 0 1 3.89-3.88c1.62 0 3.02 1 3.59 2.42a3.15 3.15 0 0 1 2.52-1.24a3.188 3.188 0 0 1 3.1 3.9c.24-.09.51-.14.79-.14a2.356 2.356 0 0 1 0 4.71H4.94C3.32 17 2 15.68 2 14.06c0-1.63 1.32-2.94 2.94-2.94z" fill="currentColor"/>',
            hidden: true
        },
        ambulance: {
            body: '<path fill="currentColor" d="M18 18.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M6 18.5A1.5 1.5 0 0 0 7.5 17A1.5 1.5 0 0 0 6 15.5A1.5 1.5 0 0 0 4.5 17A1.5 1.5 0 0 0 6 18.5M20 8l3 4v5h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3H9a3 3 0 0 1-3 3a3 3 0 0 1-3-3H1V6c0-1.11.89-2 2-2h14v4h3M8 6v3H5v2h3v3h2v-3h3V9h-3V6H8Z"/>'
        },
        ammunition: {
            body: '<path fill="currentColor" d="M14 22h-4v-1h4v1m-1-12V7h-2v3l-1 1.5V20h4v-8.5L13 10m-1-8s-1 1-1 3v1h2V5s0-2-1-3M8 22H4v-1h4v1M7 10V7H5v3l-1 1.5V20h4v-8.5L7 10M6 2S5 3 5 5v1h2V5s0-2-1-3m14 20h-4v-1h4v1m-1-12V7h-2v3l-1 1.5V20h4v-8.5L19 10m-1-8s-1 1-1 3v1h2V5s0-2-1-3Z"/>'
        },
        ampersand: {
            body: '<path fill="currentColor" d="M4.4 16.5c0-.9.3-1.8.8-2.6s1.5-1.7 3-2.7c-.9-1.1-1.4-1.9-1.7-2.5c-.4-.7-.5-1.3-.5-2c0-1.5.4-2.6 1.3-3.5c.9-.9 2.1-1.2 3.6-1.2c1.3 0 2.4.4 3.3 1.2c.9.8 1.3 1.8 1.3 2.9c0 .8-.2 1.5-.6 2.2c-.4.7-1.1 1.4-2.1 2.1l-1.4 1.1l4.3 5.2c.6-1.2.9-2.4.9-3.9h2.2c0 2.3-.5 4.2-1.6 5.7l2.8 3.3h-3l-1.3-1.5c-.7.6-1.4 1-2.3 1.3c-.9.3-1.8.5-2.7.5c-1.9 0-3.4-.5-4.6-1.5c-1.1-1.1-1.7-2.4-1.7-4.1m6.3 3.5c1.3 0 2.5-.5 3.6-1.5l-4.7-5.7l-.4.3C7.7 14.2 7 15.3 7 16.5c0 1.1.3 1.9 1 2.5c.7.6 1.5 1 2.7 1M8.5 6.7c0 .9.5 1.9 1.6 3.2l1.6-1.1c.6-.4 1-.8 1.2-1.2c.2-.4.3-.9.3-1.4c0-.6-.2-1.1-.7-1.5c-.4-.4-1-.6-1.7-.6s-1.3.2-1.7.7c-.4.5-.6 1.1-.6 1.9Z"/>'
        },
        amplifier: {
            body: '<path fill="currentColor" d="M10 2h4a1 1 0 0 1 1 1h6v18h-2a1 1 0 0 1-1 1a1 1 0 0 1-1-1H7a1 1 0 0 1-1 1a1 1 0 0 1-1-1H3V3h6a1 1 0 0 1 1-1M5 5v4h14V5H5m2 1a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m5 0h2v1h-2V6m3 0h1v2h-1V6m2 0h1v2h-1V6m-5 5a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m-2-5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "amplifier-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3L3 4.9V21h2c0 .6.4 1 1 1s1-.4 1-1h10c0 .6.4 1 1 1s1-.4 1-1h.1l1.7 1.7l1.3-1.2M5 9V6.9L7.1 9H5m7 10c-2.2 0-4-1.8-4-4c0-1.4.7-2.6 1.8-3.3l5.5 5.5c-.7 1.1-1.9 1.8-3.3 1.8m2-13v1h-2V6h2m-4 0c.6 0 1 .4 1 1c0 .2-.1.4-.2.6L9.4 6.2c.2-.1.4-.2.6-.2M8.2 5l-2-2H9c0-.6.4-1 1-1h4c.6 0 1 .4 1 1h6v14.8L12.2 9H19V5H8.2M16 6v2h-1V6h1m2 0v2h-1V6h1Z"/>'
        },
        anchor: {
            body: '<path fill="currentColor" d="M12 2a3 3 0 0 0-3 3a3 3 0 0 0 2 2.83V9H8v2h3v8.92c-.74-.13-1.5-.34-2.21-.65c-.74-.32-1.39-.71-1.97-1.18c-.58-.47-1.04-.98-1.38-1.54L7 15l-4-3v3c0 .97.27 1.88.82 2.72A8.23 8.23 0 0 0 6 19.95c.87.64 1.84 1.14 2.88 1.5c1.05.36 2.09.55 3.12.55c1.03 0 2.07-.2 3.12-.56c1.04-.36 2.01-.86 2.88-1.49c.92-.64 1.63-1.38 2.18-2.23c.55-.84.82-1.75.82-2.72v-3l-4 3l1.56 1.55c-.34.56-.8 1.07-1.38 1.54c-.58.47-1.23.86-1.97 1.18c-.71.31-1.47.52-2.21.65V11h3V9h-3V7.82A3 3 0 0 0 15 5a3 3 0 0 0-3-3m0 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        android: {
            body: '<path fill="currentColor" d="M16.61 15.15c-.46 0-.84-.37-.84-.83s.38-.82.84-.82c.46 0 .84.36.84.82c0 .46-.38.83-.84.83m-9.2 0c-.46 0-.84-.37-.84-.83c0-.46.38-.82.84-.82c.46 0 .83.36.83.82c0 .46-.37.83-.83.83m9.5-5.01l1.67-2.88c.09-.17.03-.38-.13-.47c-.17-.1-.38-.04-.45.13l-1.71 2.91A10.15 10.15 0 0 0 12 8.91c-1.53 0-3 .33-4.27.91L6.04 6.91a.334.334 0 0 0-.47-.13c-.17.09-.22.3-.13.47l1.66 2.88C4.25 11.69 2.29 14.58 2 18h20c-.28-3.41-2.23-6.3-5.09-7.86Z"/>'
        },
        "android-auto": {
            body: '<path d="M22.78 17.91c.16.25.22.51.22.79c0 .38-.13.69-.43.94s-.63.36-1.01.36h-2.48L12.42 8h-.84L4.92 20H2.39c-.47 0-.86-.2-1.17-.62c-.31-.42-.33-.88-.05-1.38l9.61-16.31C11.09 1.22 11.5 1 12 1c.53 0 .92.22 1.17.69l9.61 16.22m-18 4.4L12 9.38l7.22 12.93l-.72.69l-6.5-2.66L5.44 23l-.66-.69z" fill="currentColor"/>',
            hidden: true
        },
        "android-debug-bridge": {
            body: '<path d="M15 9a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1M9 9a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m7.12-4.63l2.1-2.1l-.82-.83l-2.31 2.31C14.16 3.28 13.11 3 12 3c-1.12 0-2.16.28-3.09.75L6.6 1.44l-.82.83l2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63M5 16c0 3.86 3.13 7 7 7a7 7 0 0 0 7-7v-4H5v4z" fill="currentColor"/>',
            hidden: true
        },
        "android-head": {
            body: '<path d="M8 11.5a1.25 1.25 0 0 0-1.25 1.25A1.25 1.25 0 0 0 8 14a1.25 1.25 0 0 0 1.25-1.25A1.25 1.25 0 0 0 8 11.5m8 0a1.25 1.25 0 0 0-1.25 1.25A1.25 1.25 0 0 0 16 14a1.25 1.25 0 0 0 1.25-1.25A1.25 1.25 0 0 0 16 11.5M12 7c1.5 0 2.9.33 4.18.91l2.16-2.16a.996.996 0 1 1 1.41 1.41l-1.8 1.8A9.999 9.999 0 0 1 22 17H2c0-3.29 1.59-6.21 4.05-8.04l-1.8-1.8a.996.996 0 1 1 1.41-1.41l2.16 2.16C9.1 7.33 10.5 7 12 7z" fill="currentColor"/>',
            hidden: true
        },
        "android-messages": {
            body: '<path fill="currentColor" d="M20 20H7a2 2 0 0 1-2-2V8.94l-2.77-3.3C2.09 5.47 2 5.24 2 5a1 1 0 0 1 1-1h17a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M8.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-10m0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-10m0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5Z"/>',
            hidden: true
        },
        "android-studio": {
            body: '<path fill="currentColor" d="M11 2h2v2h.5A1.5 1.5 0 0 1 15 5.5V9l-.44.44l1.64 2.84C17.31 11.19 18 9.68 18 8h2c0 2.42-1.07 4.59-2.77 6.06l3.14 5.44l.13 2.22l-1.87-1.22l-3.07-5.33c-1.06.53-2.28.83-3.56.83c-1.28 0-2.5-.3-3.56-.83L5.37 20.5L3.5 21.72l.13-2.22L9.44 9.44L9 9V5.5A1.5 1.5 0 0 1 10.5 4h.5V2M9.44 13.43c.78.37 1.65.57 2.56.57c.91 0 1.78-.2 2.56-.57L13.1 10.9h-.01c-.62.6-1.56.6-2.18 0h-.01l-1.46 2.53M12 6a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "angle-acute": {
            body: '<path fill="currentColor" d="M20 19H4.09L14.18 4.43l1.64 1.14l-4.54 6.56c1.61.83 2.72 2.49 2.72 4.41c0 .16 0 .31-.03.46H20v2M7.91 17h4.05c.04-.15.04-.3.04-.46c0-1.26-.76-2.32-1.86-2.76L7.91 17Z"/>'
        },
        "angle-obtuse": {
            body: '<path fill="currentColor" d="M21 19H9.31L4.07 5.36l1.86-.72l3.03 7.86a4.82 4.82 0 0 1 1.75-.33A4.88 4.88 0 0 1 15.58 17H21v2m-10.31-2h2.89a2.849 2.849 0 0 0-2.87-2.83c-.37 0-.71.07-1.04.19L10.69 17Z"/>'
        },
        "angle-right": {
            body: '<path fill="currentColor" d="M5 4h2v7h6v6h7v2H5V4m2 13h4v-4H7v4Z"/>'
        },
        angular: {
            body: '<path fill="currentColor" d="m12 2.5l8.84 3.15l-1.34 11.7L12 21.5l-7.5-4.15l-1.34-11.7L12 2.5m0 2.1L6.47 17h2.06l1.11-2.78h4.7L15.45 17h2.05L12 4.6m1.62 7.9h-3.23L12 8.63l1.62 3.87Z"/>'
        },
        angularjs: {
            body: '<path fill="currentColor" d="m12 2.5l8.84 3.15l-1.34 11.7L12 21.5l-7.5-4.15l-1.34-11.7L12 2.5m0 2L5 7l1.08 9.22L12 19.5l5.92-3.28L19 7l-7-2.5m0 1.22L16.58 16h-1.71l-.93-2.28h-3.9L9.12 16H7.41L12 5.72m1.34 6.58L12 9.07l-1.34 3.23h2.68Z"/>'
        },
        animation: {
            body: '<path fill="currentColor" d="M4 2c-1.11 0-2 .89-2 2v10h2V4h10V2H4m4 4c-1.11 0-2 .89-2 2v10h2V8h10V6H8m4 4c-1.11 0-2 .89-2 2v8c0 1.11.89 2 2 2h8c1.11 0 2-.89 2-2v-8c0-1.11-.89-2-2-2h-8Z"/>'
        },
        "animation-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Z"/>'
        },
        "animation-play": {
            body: '<path fill="currentColor" d="M4 2h10v2H4v10H2V4c0-1.11.89-2 2-2m4 4h10v2H8v10H6V8c0-1.11.89-2 2-2m4 4h8c1.11 0 2 .89 2 2v8c0 1.11-.89 2-2 2h-8c-1.11 0-2-.89-2-2v-8c0-1.11.89-2 2-2m2 2v8l6-4l-6-4Z"/>'
        },
        "animation-play-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-6 3v6l4-3l-4-3Z"/>'
        },
        ansible: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4.1 15c-.19 0-.34-.1-.55-.27l-5.16-4.17l-1.73 4.34H7.17l4.37-10.51c.11-.28.35-.42.63-.42s.5.14.62.42l3.98 9.58c.04.11.07.22.07.29c-.01.42-.34.74-.74.74m-3.93-8.89l2.59 6.39l-3.91-3.08l1.32-3.31Z"/>'
        },
        antenna: {
            body: '<path fill="currentColor" d="M12 7.5c.69 0 1.27.23 1.76.7s.74 1.07.74 1.8c0 1.05-.5 1.81-1.5 2.28V21h-2v-8.72c-1-.47-1.5-1.23-1.5-2.28c0-.73.26-1.33.74-1.8s1.07-.7 1.76-.7m4.69-2.2c1.25 1.25 1.92 2.81 2.01 4.7c0 1.8-.67 3.38-2.01 4.72L15.5 13.5c1-.91 1.5-2.08 1.5-3.5c0-1.33-.5-2.5-1.5-3.5l1.19-1.2M6.09 4.08C4.5 5.67 3.7 7.64 3.7 10s.8 4.3 2.39 5.89l-1.17 1.22C3 15.08 2 12.7 2 10s1-5.06 2.92-7.09l1.17 1.17m12.99-1.17C21 4.94 22 7.3 22 10c0 2.8-1 5.17-2.92 7.11l-1.17-1.22C19.5 14.3 20.3 12.33 20.3 10s-.8-4.33-2.39-5.92l1.17-1.17M7.31 5.3L8.5 6.5C7.5 7.42 7 8.58 7 10c0 1.33.5 2.5 1.5 3.5l-1.19 1.22C5.97 13.38 5.3 11.8 5.3 10c0-1.8.67-3.36 2.01-4.7Z"/>'
        },
        anvil: {
            body: '<path fill="currentColor" d="M9 5v5c4.03 2.47-.56 4.97-3 6v3h15v-3c-6.41-2.73-3.53-7 1-8V5H9M2 6c.81 2.13 2.42 3.5 5 4V6H2Z"/>'
        },
        "apache-kafka": {
            body: '<path fill="currentColor" d="M15.54 12.97c-.68 0-1.3.25-1.78.67l-1.29-.75c.09-.29.13-.6.13-.92c0-.32-.04-.63-.1-.92l1.23-.73c.48.44 1.12.68 1.81.68c1.49 0 2.7-1.19 2.7-2.68s-1.21-2.69-2.7-2.69s-2.7 1.21-2.7 2.7c0 .17.02.37.05.55l-1.25.72c-.43-.45-1-.78-1.64-.95V7.26a2.705 2.705 0 0 0 1.88-2.57C11.88 3.2 10.67 2 9.18 2C7.69 2 6.5 3.2 6.5 4.69c0 1.2.76 2.21 1.84 2.57v1.4a3.421 3.421 0 0 0-2.58 3.31c0 1.6 1.1 2.94 2.58 3.31v1.45A2.692 2.692 0 0 0 6.5 19.3c0 1.49 1.19 2.7 2.68 2.7c1.49 0 2.7-1.21 2.7-2.7c0-1.2-.79-2.22-1.88-2.57v-1.44c.64-.16 1.2-.49 1.64-.94l1.26.73c-.04.19-.06.38-.06.58c0 1.49 1.21 2.7 2.7 2.7s2.7-1.21 2.7-2.7s-1.21-2.69-2.7-2.69m0-5.97c.74 0 1.33.59 1.33 1.32s-.59 1.34-1.33 1.34s-1.33-.6-1.33-1.34S14.8 7 15.54 7M7.85 4.69c0-.74.59-1.34 1.33-1.34c.74 0 1.32.6 1.32 1.34s-.58 1.34-1.32 1.34c-.74 0-1.33-.6-1.33-1.34M10.5 19.3c0 .74-.58 1.34-1.32 1.34c-.74 0-1.33-.6-1.33-1.34c0-.74.59-1.34 1.33-1.34c.74 0 1.32.6 1.32 1.34m-1.32-5.41a1.92 1.92 0 1 1 .001-3.841a1.92 1.92 0 0 1-.001 3.841M15.54 17c-.74 0-1.33-.6-1.33-1.34s.59-1.33 1.33-1.33s1.33.6 1.33 1.33S16.28 17 15.54 17Z"/>'
        },
        api: {
            body: '<path fill="currentColor" d="M7 7H5a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2m0 4H5V9h2m7-2h-4v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m0 4h-2V9h2m6 0v6h1v2h-4v-2h1V9h-1V7h4v2Z"/>'
        },
        "api-off": {
            body: '<path fill="currentColor" d="M7 11H5V9h2m7-2h-2.62l1.91 2H14v.75l1.87 1.96c.08-.21.13-.46.13-.71V9a2 2 0 0 0-2-2M4.45 2.62L3 4l2.86 3H5c-1.1 0-2 .9-2 2v8h2v-4h2v4h2v-6.7l1 1.04V17h2v-3.55l7.55 7.93L21 20m-.1-3h.1v-2h-1V9h1V7h-4v2h1v4.95Z"/>'
        },
        apple: {
            body: '<path fill="currentColor" d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47c-1.34.03-1.77-.79-3.29-.79c-1.53 0-2 .77-3.27.82c-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51c1.28-.02 2.5.87 3.29.87c.78 0 2.26-1.07 3.81-.91c.65.03 2.47.26 3.64 1.98c-.09.06-2.17 1.28-2.15 3.81c.03 3.02 2.65 4.03 2.68 4.04c-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5c.13 1.17-.34 2.35-1.04 3.19c-.69.85-1.83 1.51-2.95 1.42c-.15-1.15.41-2.35 1.05-3.11Z"/>'
        },
        "apple-finder": {
            body: '<path fill="currentColor" d="M8 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m9-1V8c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1m5-5v15c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2M4 20h9.06c-.1-.65-.17-1.36-.23-2.06c-.27.02-.53.06-.83.06c-3.76 0-5.69-2.27-5.77-2.37a1.01 1.01 0 0 1 .13-1.41a1.01 1.01 0 0 1 1.41.13C7.83 14.43 9.23 16 12 16c.27 0 .5-.03.74-.05c-.03-1.2-.01-2.21 0-2.69h-1.81c-.65 0-1.18-.56-1.18-1.26c.02-.25.32-4.18 1.25-7H4v15m16 0V5h-7.4c-.86 2.19-1.23 5.73-1.33 6.76h1.81c.64 0 1.17.56 1.17 1.24c0 .04-.04 1.15-.01 2.6c1.3-.49 1.98-1.25 1.99-1.26a.998.998 0 1 1 1.54 1.27c-.06.07-1.22 1.44-3.45 2.07c.06.82.14 1.61.26 2.32H20Z"/>'
        },
        "apple-icloud": {
            body: '<path fill="currentColor" d="M22 15.04c0 2.19-1.76 3.96-3.93 3.96H5.93C3.76 19 2 17.23 2 15.04c0-1.97 1.43-3.6 3.31-3.9c-.03-.14-.04-.28-.04-.43c0-1.38 1.11-2.51 2.49-2.51c.61 0 1.18.23 1.61.6c.77-1.75 1.76-3.36 4.54-3.36c3.37 0 4.96 2.62 4.96 5.39c0 .11 0 .23-.01.34A3.95 3.95 0 0 1 22 15.04Z"/>'
        },
        "apple-ios": {
            body: '<path fill="currentColor" d="M2.09 16.8h1.66V9.76H2.09m.83-.92a.9.9 0 0 0 .92-.9c0-.5-.4-.9-.92-.9a.9.9 0 0 0-.92.9c0 .5.4.9.92.9m6.33-1.78C6.46 7.06 4.7 8.96 4.7 12c0 3.06 1.76 4.96 4.55 4.96s4.55-1.9 4.55-4.96c0-3.04-1.76-4.94-4.55-4.94m0 1.44c1.71 0 2.8 1.37 2.8 3.5c0 2.15-1.09 3.5-2.8 3.5c-1.71 0-2.79-1.35-2.79-3.5c0-2.13 1.08-3.5 2.79-3.5m5.25 5.61c.07 1.76 1.5 2.85 3.72 2.85c2.32 0 3.78-1.14 3.78-2.96c0-1.43-.82-2.23-2.77-2.68l-1.1-.25c-1.18-.28-1.66-.65-1.66-1.29c0-.78.73-1.33 1.81-1.33c1.1 0 1.85.55 1.93 1.44h1.63c-.04-1.69-1.43-2.83-3.55-2.83c-2.08 0-3.56 1.15-3.56 2.85c0 1.37.83 2.22 2.6 2.62l1.24.29c1.21.29 1.7.68 1.7 1.38c0 .8-.8 1.37-1.96 1.37s-2.05-.57-2.15-1.46H14.5Z"/>'
        },
        "apple-keyboard-caps": {
            body: '<path fill="currentColor" d="M15 14V8h2.17L12 2.83L6.83 8H9v6h6M12 0l10 10h-5v6H7v-6H2L12 0M7 18h10v6H7v-6m8 2H9v2h6v-2Z"/>'
        },
        "apple-keyboard-command": {
            body: '<path fill="currentColor" d="M6 2a4 4 0 0 1 4 4v2h4V6a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-2v4h2a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4v-2h-4v2a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4h2v-4H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4m10 16a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2v2m-2-8h-4v4h4v-4m-8 6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2v-2H6M8 6a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2h2V6m10 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2h2Z"/>'
        },
        "apple-keyboard-control": {
            body: '<path fill="currentColor" d="m19.78 11.78l-1.42 1.41L12 6.83l-6.36 6.36l-1.42-1.41L12 4l7.78 7.78Z"/>'
        },
        "apple-keyboard-option": {
            body: '<path fill="currentColor" d="M3 4h6.11l7.04 14H21v2h-6.12L7.84 6H3V4m11 0h7v2h-7V4Z"/>'
        },
        "apple-keyboard-shift": {
            body: '<path fill="currentColor" d="M15 18v-6h2.17L12 6.83L6.83 12H9v6h6M12 4l10 10h-5v6H7v-6H2L12 4Z"/>'
        },
        "apple-safari": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 2.09.8 4 2.11 5.41l3.77-7.53l7.53-3.77A7.931 7.931 0 0 0 12 4m0 16a8 8 0 0 0 8-8c0-2.09-.8-4-2.11-5.41l-3.77 7.53l-7.53 3.77A7.931 7.931 0 0 0 12 20m0-8l-.77-.77L9.7 14.3l3.07-1.53L12 12m0 5.5h1V19h-1v-1.5m3.88-1.61l.71-.71l1.06 1.06l-.71.71l-1.06-1.06M17.5 12v-1H19v1h-1.5M12 6.5h-1V5h1v1.5M8.12 8.11l-.71.71l-1.06-1.06l.71-.71l1.06 1.06M6.5 12v1H5v-1h1.5Z"/>'
        },
        application: {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 5H3V4h18v3Z"/>'
        },
        "application-array": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-11 9H8v7h2v2H6V9h4v2m8 9h-4v-2h2v-7h-2V9h4v11m3-13H3V4h18v3Z"/>'
        },
        "application-array-outline": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H3V6h18v14M6 8v10h4v-2H8v-6h2V8H6m10 8h-2v2h4V8h-4v2h2v6"/>'
        },
        "application-braces": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-10 9H9v1.5c0 1.1-.9 2-2 2c1.1 0 2 .9 2 2V18h2v2H9c-1.1 0-2-.9-2-2v-.5c0-1.1-.9-2-2-2v-2c1.1 0 2-.9 2-2V11c0-1.1.9-2 2-2h2v2m8 4.5c-1.1 0-2 .9-2 2v.5c0 1.1-.9 2-2 2h-2v-2h2v-1.5c0-1.1.9-2 2-2c-1.1 0-2-.9-2-2V11h-2V9h2c1.1 0 2 .9 2 2v.5c0 1.1.9 2 2 2v2M21 7H3V4h18v3Z"/>'
        },
        "application-braces-outline": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H3V6h18v14M9 8c-1.1 0-2 .9-2 2s-.9 2-2 2v2c1.1 0 2 .9 2 2s.9 2 2 2h2v-2H9v-1c0-1.1-.9-2-2-2c1.1 0 2-.9 2-2v-1h2V8m4 0c1.1 0 2 .9 2 2s.9 2 2 2v2c-1.1 0-2 .9-2 2s-.9 2-2 2h-2v-2h2v-1c0-1.1.9-2 2-2c-1.1 0-2-.9-2-2v-1h-2V8h2Z"/>'
        },
        "application-brackets": {
            body: '<path fill="currentColor" d="M21 2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M11 17.5L9.5 19L5 14.5L9.5 10l1.5 1.5l-3 3l3 3m3.5 1.5L13 17.5l3-3l-3-3l1.5-1.5l4.5 4.5l-4.5 4.5M21 7H3V4h18v3Z"/>'
        },
        "application-brackets-outline": {
            body: '<path fill="currentColor" d="M9.5 8.5L11 10l-3 3l3 3l-1.5 1.5L5 13l4.5-4.5m5 9L13 16l3-3l-3-3l1.5-1.5L19 13l-4.5 4.5M21 2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 18H3V6h18v14Z"/>'
        },
        "application-cog": {
            body: '<path fill="currentColor" d="M21.7 18.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M11 18c0-3.9 3.1-7 7-7c2 0 3.7.8 5 2.1V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h9.3c-.8-1.1-1.3-2.5-1.3-4M3 4h18v3H3V4Z"/>'
        },
        "application-cog-outline": {
            body: '<path fill="currentColor" d="M21.7 18.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M12.3 22H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v9.1c-.6-.6-1.3-1.1-2-1.4V6H3v14h8.3c.2.7.5 1.4 1 2Z"/>'
        },
        "application-edit": {
            body: '<path fill="currentColor" d="m11 20.1l8.2-8.2c.5-.5 1.1-.8 1.8-.8s1.3.3 1.8.8l.2.2V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8v-1.9M3 4h18v3H3V4m18 9.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V23h2.1l6.1-6.1l-2.1-2Z"/>'
        },
        "application-edit-outline": {
            body: '<path fill="currentColor" d="M11 20v2H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v8.1l-.2-.2c-.5-.5-1.1-.8-1.8-.8V6H3v14h8m10.4-6.7l1.3 1.3c.2.2.2.6 0 .8l-1 1l-2.1-2.1l1-1c.1-.1.2-.2.4-.2s.3.1.4.2m-.3 3.6l-6 6.1H13v-2.1l6.1-6.1l2 2.1Z"/>'
        },
        "application-export": {
            body: '<path fill="currentColor" d="M9 12h9.8l-2.5-2.5l1.4-1.4l4.9 4.9l-4.9 4.9l-1.4-1.4l2.5-2.5H9v-2m12 5.4V20H3V6h18v2.6l2 2V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-4.6l-2 2Z"/>'
        },
        "application-import": {
            body: '<path fill="currentColor" d="M1 12h9.8L8.3 9.5l1.4-1.4l4.9 4.9l-4.9 4.9l-1.4-1.4l2.5-2.5H1v-2M21 2H3c-1.1 0-2 .9-2 2v6.1h2V6h18v14H3v-4H1v4c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2"/>'
        },
        "application-outline": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H3V6h18v14Z"/>'
        },
        "application-parentheses": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M10 19.4l-1.6.6C6.9 18.6 6 16.6 6 14.5s.9-4.1 2.4-5.5l1.6.6c-1.3 1.1-2 3-2 4.9s.7 3.7 2 4.9m5.6.6l-1.6-.6c1.3-1.2 2-3 2-4.9s-.7-3.7-2-4.9l1.6-.6c1.5 1.4 2.4 3.4 2.4 5.5s-.9 4.1-2.4 5.5M21 7H3V4h18v3Z"/>'
        },
        "application-parentheses-outline": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H3V6h18v14M15.6 8c1.5 1.3 2.4 3.1 2.4 5s-.9 3.7-2.4 5l-1.6-.6c1.3-1 2-2.7 2-4.4s-.7-3.4-2-4.4l1.6-.6M8.4 8l1.6.6c-1.3 1-2 2.7-2 4.4s.7 3.4 2 4.4l-1.6.6C6.9 16.7 6 14.9 6 13s.9-3.7 2.4-5Z"/>'
        },
        "application-settings": {
            body: '<path fill="currentColor" d="M21 0H3C1.9 0 1 .9 1 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 5H3V2h18v3M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2"/>'
        },
        "application-settings-outline": {
            body: '<path fill="currentColor" d="M21 0H3C1.9 0 1 .9 1 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 18H3V4h18v14M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2"/>'
        },
        "application-variable": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7.4 20C5.9 18.6 5 16.6 5 14.5s.9-4.1 2.4-5.5l1.6.6c-1.3 1.1-2 3-2 4.9s.7 3.7 2 4.9l-1.6.6m5.3-2l-.8-2l-1.4 2H9l2.3-3.1L10 12h1.3l.8 2l1.4-2H15l-2.2 3l1.3 3h-1.4m3.9 2l-1.6-.6c1.3-1.2 2-3 2-4.9s-.7-3.7-2-4.9l1.6-.6c1.5 1.4 2.4 3.4 2.4 5.5s-.9 4.1-2.4 5.5M21 7H3V4h18v3Z"/>'
        },
        "application-variable-outline": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H3V6h18v14M16.6 8c1.5 1.3 2.4 3.1 2.4 5s-.9 3.7-2.4 5l-1.6-.6c1.3-1 2-2.7 2-4.4s-.7-3.4-2-4.4l1.6-.6M7.4 8l1.6.6c-1.3 1-2 2.7-2 4.4s.7 3.4 2 4.4l-1.6.6C5.9 16.7 5 14.9 5 13s.9-3.7 2.4-5m4.7 4l1.4-2H15l-2.2 3l1.3 3h-1.3l-.8-2l-1.4 2H9l2.3-3.1L10 10h1.3l.8 2Z"/>'
        },
        appnet: {
            body: '<path d="M14.474 9.142c.597-1.45 1.706-4.862 1.877-5.46c.17-.597.597-.682.853-.682h2.047c.341 0 .533.256.448.682c-2.154 7.593-3.604 9.81-3.604 10.323c0 1.28 1.365 3.668 2.644 3.668c.768 0 .598-1.109 1.45-1.109h1.621c.256 0 .512.256.512.682c0 .427-.474 3.754-3.716 3.754s-4.452-3.919-4.452-3.919C13.727 17.934 11.232 21 8.161 21c-5.46 0-6.483-5.8-6.483-9.213C1.678 8.374 3.298 3 7.905 3s6.569 6.142 6.569 6.142zm-9.981 2.389c0 1.962-.085 6.057 3.508 6.142c2.037.085 3.914-2.474 4.804-4.521c-1.232-4.266-2.085-6.825-4.814-6.825c-3.669.085-3.498 5.204-3.498 5.204z" fill="currentColor"/>',
            hidden: true
        },
        "approximately-equal": {
            body: '<path fill="currentColor" d="M18.9 9.2c-.8.9-2.3 1.8-3.9 1.8c-1.5 0-2.4-.5-3.2-.9c-.8-.3-1.6-.8-2.9-.8c-1.2 0-2.3.7-2.9 1.3L5 9.1c.9-.9 2.3-1.9 3.9-1.9c1.5 0 2.4.6 3.2.9c.8.3 1.6.9 2.9.9c1.2 0 2.3-.8 2.9-1.4l1 1.6m.1 4.9c-.9.9-2.3 1.9-3.9 1.9c-1.5 0-2.4-.5-3.2-.9c-.8-.3-1.6-.9-2.9-.9c-1.2 0-2.3.8-2.9 1.4l-1-1.6c.9-.9 2.3-1.9 3.9-1.9c1.5 0 2.4.5 3.2.9c.8.3 1.6.8 2.9.8c1.2 0 2.3-.8 2.9-1.4l1 1.7Z"/>'
        },
        "approximately-equal-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9.3 8.2c1.3 0 2.1.5 2.8.8c.6.3 1.3.7 2.4.7c1 0 2-.7 2.5-1.2l.8 1.3c-.7.8-2 1.6-3.4 1.6c-1.3 0-2.1-.5-2.7-.8c-.6-.3-1.4-.7-2.5-.7c-1 0-2 .7-2.5 1.2L6 9.8c.7-.8 2-1.6 3.3-1.6m5.3 7.6c-1.3 0-2.1-.5-2.8-.8c-.6-.3-1.4-.7-2.5-.7c-1 0-2 .7-2.5 1.2L6 14.1c.7-.8 2-1.6 3.3-1.6c1.3 0 2.1.5 2.8.8c.6.3 1.3.7 2.5.7c1 0 2-.7 2.5-1.2l.8 1.3c-.6.9-1.9 1.7-3.3 1.7Z"/>'
        },
        apps: {
            body: '<path fill="currentColor" d="M16 20h4v-4h-4m0-2h4v-4h-4m-6-2h4V4h-4m6 4h4V4h-4m-6 10h4v-4h-4m-6 4h4v-4H4m0 10h4v-4H4m6 4h4v-4h-4M4 8h4V4H4v4Z"/>'
        },
        "apps-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2 4v2h2V7H7m4 0v2h2V7h-2m4 0v2h2V7h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2Z"/>'
        },
        arch: {
            body: '<path fill="currentColor" d="M12 2c-.89 2.18-1.43 3.61-2.42 5.73c.61.64 1.35 1.39 2.56 2.24c-1.3-.54-2.19-1.07-2.85-1.63C8 11 6.03 14.75 2 22c3.17-1.83 5.63-2.96 7.92-3.39c-.1-.42-.16-.88-.15-1.36v-.1c.05-2.03 1.11-3.59 2.36-3.48c1.25.1 2.22 1.83 2.17 3.87c-.01.38-.05.75-.12 1.09c2.26.44 4.69 1.56 7.82 3.37c-.62-1.14-1.17-2.16-1.69-3.13c-.81-.64-1.7-1.48-3.46-2.37c1.21.3 2.08.66 2.76 1.07C14.26 7.62 13.83 6.3 12 2Z"/>'
        },
        archive: {
            body: '<path fill="currentColor" d="M3 3h18v4H3V3m1 5h16v13H4V8m5.5 3a.5.5 0 0 0-.5.5V13h6v-1.5a.5.5 0 0 0-.5-.5h-5Z"/>'
        },
        "archive-alert": {
            body: '<path fill="currentColor" d="M2 4h16v3H2V4m1 4h14v12H3V8m4.5 3c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M20 13V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "archive-alert-outline": {
            body: '<path fill="currentColor" d="M2 4h16v3H2V4m5.5 7h5c.28 0 .5.22.5.5V13H7v-1.5c0-.28.22-.5.5-.5M20 13V7h2v6h-2m0 4v-2h2v2h-2M3 8h2v10h10V8h2v12H3V8Z"/>'
        },
        "archive-arrow-down": {
            body: '<path fill="currentColor" d="M3 3h18v4H3V3m1 18V8h16v13H4m10-7v-3h-4v3H7l5 5l5-5h-3Z"/>'
        },
        "archive-arrow-down-outline": {
            body: '<path fill="currentColor" d="M20 21H4V10h2v9h12v-9h2v11M3 3h18v6H3V3m2 2v2h14V5m-8.5 6v3H8l4 4l4-4h-2.5v-3"/>'
        },
        "archive-arrow-up": {
            body: '<path fill="currentColor" d="M4 21h16V8H4m10 7v3h-4v-3H7l5-5l5 5M3 3h18v4H3"/>'
        },
        "archive-arrow-up-outline": {
            body: '<path fill="currentColor" d="M20 21H4V10h2v9h12v-9h2v11M3 3h18v6H3V3m2 2v2h14V5m-8.5 12v-3H8l4-4l4 4h-2.5v3"/>'
        },
        "archive-cancel": {
            body: '<path fill="currentColor" d="M18.5 12c.5 0 1 .07 1.5.18V8H4v13h8.5a6.5 6.5 0 0 1 6-9M9 13v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13H9m12-6H3V3h18v4m-2.5 7C16 14 14 16 14 18.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m0 7.5c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5L20 21.08c-.42.27-.94.42-1.5.42m2.58-1.5L17 15.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5Z"/>'
        },
        "archive-cancel-outline": {
            body: '<path fill="currentColor" d="M14.5 11c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5h5m4 1c.5 0 1 .07 1.5.18V10h-2v2.03c.17-.03.33-.03.5-.03M6 19v-9H4v11h8.5c-.26-.62-.41-1.3-.47-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m4 13.5c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "archive-check": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V8H4v13h9.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6M9 13v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13H9m12-6H3V3h18v4m1.5 10.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "archive-check-outline": {
            body: '<path fill="currentColor" d="M21 3H3v6h18V3m-2 4H5V5h14v2m-4.5 4c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5h5m3.5 2.09V10h2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09M13 19c0 .7.13 1.37.35 2H4V10h2v9h7m9.5-1.75L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "archive-clock": {
            body: '<path fill="currentColor" d="M20 6H2V2h18v4m-3.5 6H15v5l3.61 2.16l.75-1.22l-2.86-1.69V12m6.5 4c0 3.87-3.13 7-7 7c-2.38 0-4.47-1.19-5.74-3H3V7h16v2.68c2.36 1.13 4 3.53 4 6.32M8 12h2.26c.57-.81 1.3-1.5 2.15-2H8.5c-.28 0-.5.22-.5.5V12m13 4c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "archive-clock-outline": {
            body: '<path fill="currentColor" d="M20 2H2v6h18V2m-2 4H4V4h14v2m-2 3c-1.31 0-2.54.37-3.59 1H8.5c-.28 0-.5.22-.5.5V12h2.26A6.94 6.94 0 0 0 9 16c0 .7.11 1.37.29 2H5V9H3v11h7.26c1.27 1.81 3.36 3 5.74 3c3.87 0 7-3.13 7-7s-3.13-7-7-7m0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "archive-cog": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-9 12c0 .7.11 1.37.3 2H4V8h16v4.08c-.33-.05-.66-.08-1-.08c-3.87 0-7 3.13-7 7m3-6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13h6m8.8 7.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "archive-cog-outline": {
            body: '<path fill="currentColor" d="M18 12.08V10h2v2.08c-.33-.05-.66-.08-1-.08c-.34 0-.67.03-1 .08M9.5 11c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M6 19v-9H4v11h8.3c-.19-.63-.3-1.3-.3-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m4.8 15.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "archive-edit": {
            body: '<path fill="currentColor" d="M20 10.3V8H4v13h7v-1.87l8.39-8.39c.18-.18.39-.32.61-.44M15 13H9v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13m6-6H3V3h18v4m1.85 7.19l-.98.98l-2.04-2.04l.98-.98c.19-.2.52-.2.72 0l1.32 1.32c.2.2.2.53 0 .72m-3.72-.36l2.04 2.04L15.04 22H13v-2.04l6.13-6.13Z"/>'
        },
        "archive-edit-outline": {
            body: '<path fill="currentColor" d="M18 12.13V10h2v.3c-.22.12-.43.26-.61.44L18 12.13M9.5 11c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M6 10H4v11h7v-1.87l.13-.13H6v-9m15-1H3V3h18v6m-2-4H5v2h14V5m-6 14.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "archive-eye": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4M9.14 19.75c.18.44.4.86.64 1.25H4V8h16v5.55c-.94-.36-1.95-.55-3-.55c-3.5 0-6.57 2.06-7.86 5.25l-.29.75l.29.75M9 13h6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13m8 5c-.56 0-1 .44-1 1s.44 1 1 1s1-.44 1-1s-.44-1-1-1m6 1c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4s5.06 1.66 6 4m-3.5 0a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "archive-eye-outline": {
            body: '<path fill="currentColor" d="M14.5 11c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5h5m5.5 2.55V10h-2v3.06c.69.08 1.36.25 2 .49M21 9H3V3h18v6m-2-4H5v2h14V5M8.85 19H6v-9H4v11h5.78c-.24-.39-.46-.81-.64-1.25L8.85 19M17 18c-.56 0-1 .44-1 1s.44 1 1 1s1-.44 1-1s-.44-1-1-1m6 1c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4s5.06 1.66 6 4m-3.5 0a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "archive-lock": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4M9.5 11h5c.28 0 .5.22.5.5v.56A4.922 4.922 0 0 1 19 10c.34 0 .68.04 1 .11V8H4v13h9.03c-.03-.1-.03-.2-.03-.3v-3.5c0-.96.5-1.86 1.2-2.46v-.24c0-.5.12-1.03.3-1.5H9v-1.5c0-.28.22-.5.5-.5M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "archive-lock-open": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-2 2c.34 0 .68.04 1 .11V8H4v13h9.03c-.03-.1-.03-.2-.03-.3v-3.5c0-.96.5-1.86 1.2-2.46V13.5c0-.17.04-.33.06-.5H9v-1.5c0-.28.22-.5.5-.5h5c.17 0 .32.09.41.22A4.887 4.887 0 0 1 19 9m2.8 7h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "archive-lock-open-outline": {
            body: '<path fill="currentColor" d="M14.5 11c.17 0 .32.09.41.22c-.35.54-.57 1.14-.65 1.78H9v-1.5c0-.28.22-.5.5-.5h5M13 19H6v-9H4v11h9.03c-.03-.1-.03-.2-.03-.3V19m8-10H3V3h18v6m-2-4H5v2h14V5m2.8 11h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "archive-lock-outline": {
            body: '<path fill="currentColor" d="M15 12.06c-.21.29-.36.61-.5.94H9v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v.56M21 9H3V3h18v6m-2-4H5v2h14V5m-6 14H6v-9H4v11h9.03c-.03-.1-.03-.2-.03-.3V19m10-1.7v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "archive-marker": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-7.37 6H9v-1.5c0-.28.22-.5.5-.5h5c.22 0 .4.14.47.33c.96-.83 2.2-1.33 3.53-1.33c.5 0 1 .08 1.5.22V8H4v13h11.19C14.12 19.43 13 17.35 13 15.5c0-.89.23-1.74.63-2.5M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "archive-marker-outline": {
            body: '<path fill="currentColor" d="M14.5 11c.22 0 .4.14.47.33A5.43 5.43 0 0 0 13.63 13H9v-1.5c0-.28.22-.5.5-.5h5M21 9H3V3h18v6m-2-4H5v2h14V5M6 19v-9H4v11h11.19c-.41-.6-.83-1.28-1.19-2H6m16-3.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "archive-minus": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V8H4v13h9.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6M9 13v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13H9m12-6H3V3h18v4m2 11v2h-8v-2h8Z"/>'
        },
        "archive-minus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .7.13 1.37.35 2H4V10h2v9h7m6-6c.34 0 .67.04 1 .09V10h-2v3.09c.33-.05.66-.09 1-.09m-9.5-2c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M21 9H3V3h18v6m-2-4H5v2h14V5m-4 13v2h8v-2h-8Z"/>'
        },
        "archive-music": {
            body: '<path fill="currentColor" d="M16.5 16.11V11H20V8H4v13h9.03c-.03-.16-.03-.33-.03-.5c0-2.14 1.5-3.93 3.5-4.39M9 13v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13H9m12-6H3V3h18v4m1 6v2h-2v5.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3.5-2.29V13H22Z"/>'
        },
        "archive-music-outline": {
            body: '<path fill="currentColor" d="M21 3H3v6h18V3m-2 4H5V5h14v2m-1 4v-1h2v1h-2m-3.5 0c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5h5m-1.24 8c-.17.47-.26.97-.26 1.5c0 .17 0 .34.03.5H4V10h2v9h7.26M22 13v2h-2v5.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3.5-2.29V13H22Z"/>'
        },
        "archive-off": {
            body: '<path fill="currentColor" d="m10.2 7l-4-4H21v4H10.2M20 8h-8.8l8.8 8.8V8m0 11.35v-.01L8.66 8l-1-1l-5.27-5.27L1.11 3L3 4.89V7h2.11l1 1H4v13h15.11l1.73 1.73l1.27-1.27L20 19.35Z"/>'
        },
        "archive-off-outline": {
            body: '<path fill="currentColor" d="m8.2 5l-2-2H21v6h-8.8l-2-2H19V5H8.2M20 16.8V10h-2v4.8l2 2m0 2.55v-.01l-2-2v.01L9.66 9l-2-2l-1.53-1.53l-3.74-3.74L1.11 3L3 4.89V9h4.11l10 10H6v-9H4v11h15.11l1.73 1.73l1.27-1.27L20 19.35Z"/>'
        },
        "archive-outline": {
            body: '<path fill="currentColor" d="M20 21H4V10h2v9h12v-9h2v11M3 3h18v6H3V3m6.5 8h5c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5M5 5v2h14V5H5Z"/>'
        },
        "archive-plus": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-8 12c0 .7.13 1.37.35 2H4V8h16v5.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m2-6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13h6m5 5v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "archive-plus-outline": {
            body: '<path fill="currentColor" d="M18 13.09V10h2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09M9.5 11c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M21 9H3V3h18v6m-2-4H5v2h14V5M6 19v-9H4v11h9.35c-.22-.63-.35-1.3-.35-2H6m14-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "archive-refresh": {
            body: '<path fill="currentColor" d="M18.5 12c.5 0 1 .07 1.5.18V8H4v13h8.5a6.5 6.5 0 0 1 6-9M9 13v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V13H9m12-6H3V3h18v4m-3 11.5l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4Z"/>'
        },
        "archive-refresh-outline": {
            body: '<path fill="currentColor" d="M18 12.03V10h2v2.18c-.5-.11-1-.18-1.5-.18c-.17 0-.33 0-.5.03M9.5 11c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M6 19v-9H4v11h8.5c-.26-.62-.41-1.3-.47-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m3 13.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "archive-remove": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-8 12c0 .7.13 1.37.35 2H4V8h16v5.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m2-6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13h6m7.54 3.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "archive-remove-outline": {
            body: '<path fill="currentColor" d="M18 13.09V10h2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09M14.5 11h-5c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5M6 19v-9H4v11h9.35c-.22-.63-.35-1.3-.35-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m3.54 11.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "archive-search": {
            body: '<path fill="currentColor" d="M20 6H2V2h18v4m-8.97 6H8v-1.5c0-.28.22-.5.5-.5h4.54c1.8-1.13 4.03-1.3 5.96-.5V7H3v13h8.82c-2.12-2.2-2.38-5.5-.79-8m12.36 9L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "archive-search-outline": {
            body: '<path fill="currentColor" d="M13.04 10c-.4.25-.78.55-1.14.9c-.33.34-.63.71-.87 1.1H8v-1.5c0-.28.22-.5.5-.5h4.54M20 8H2V2h18v6m-2-4H4v2h14V4M5 18V9H3v11h8.82a6.44 6.44 0 0 1-1.32-2H5m18.39 3L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "archive-settings": {
            body: '<path fill="currentColor" d="M21 2v4H3V2h18M4 7h16v13H4V7m5 5h6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V12M7 24h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        "archive-settings-outline": {
            body: '<path fill="currentColor" d="M3 2v6h18V2H3m16 4H5V4h14v2m-1 3h2v11H4V9h2v9h12V9m-3 1.5V12H9v-1.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "archive-star": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4m-8 12c0 .7.13 1.37.35 2H4V8h16v5.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m2-6v-1.5c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13h6m8 4.89l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "archive-star-outline": {
            body: '<path fill="currentColor" d="M18 13.09V10h2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09M9.5 11c-.28 0-.5.22-.5.5V13h6v-1.5c0-.28-.22-.5-.5-.5h-5M6 19v-9H4v11h9.35c-.22-.63-.35-1.3-.35-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m4 12.89l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "archive-sync": {
            body: '<path fill="currentColor" d="M21 7H3V3h18v4M9.5 11h5c.28 0 .5.22.5.5v1.32A6.444 6.444 0 0 1 19.5 11c.17 0 .34 0 .5.03V8H4v13h10.03A6.42 6.42 0 0 1 13 17.5c0-1.75.69-3.33 1.82-4.5H9v-1.5c0-.28.22-.5.5-.5m9.5 2.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20Z"/>'
        },
        "archive-sync-outline": {
            body: '<path fill="currentColor" d="M18 11.18V10h2v1.03c-.16-.03-.33-.03-.5-.03c-.5 0-1 .07-1.5.18m-3 .32c0-.28-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5V13h5.82l.18-.18V11.5M6 19v-9H4v11h10.03c-.39-.61-.68-1.28-.85-2H6M21 9H3V3h18v6m-2-4H5v2h14V5m0 8.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20Z"/>'
        },
        "arm-flex": {
            body: '<path fill="currentColor" d="M3 18.34S4 7.09 7 3l5 1l-1 3.09H9v7.16h1c2-3.07 6.14-4.19 8.64-3.07c3.3 1.53 3 6.14 0 8.18C16.24 21 9 22.43 3 18.34Z"/>'
        },
        "arm-flex-outline": {
            body: '<path fill="currentColor" d="M7 7.76v8.49h4.08l.6-.91c1.16-1.79 3.25-2.59 4.79-2.59c.53 0 .98.09 1.32.25c.91.41 1.16 1.18 1.21 1.74c.08 1.13-.5 2.29-1.5 2.97c-.9.62-3.06 1.29-5.63 1.29c-1.75 0-4.26-.31-6.75-1.7c.29-2.45.88-6.42 1.88-9.54M7 3C4 7.09 3 18.34 3 18.34C5.9 20.31 9.08 21 11.87 21c2.99 0 5.52-.79 6.77-1.64c3-2.04 3.3-6.65 0-8.18c-.64-.29-1.38-.43-2.17-.43c-2.3 0-4.97 1.21-6.47 3.5H9V7.09h2L12 4L7 3Z"/>'
        },
        "arrange-bring-forward": {
            body: '<path fill="currentColor" d="M2 2h14v14H2V2m20 6v14H8v-4h2v2h10V10h-2V8h4Z"/>'
        },
        "arrange-bring-to-front": {
            body: '<path fill="currentColor" d="M2 2h9v4H9V4H4v5h2v2H2V2m20 11v9h-9v-4h2v2h5v-5h-2v-2h4M8 8h8v8H8V8Z"/>'
        },
        "arrange-send-backward": {
            body: '<path fill="currentColor" d="M2 2h14v14H2V2m20 6v14H8v-4h10V8h4M4 4v10h10V4H4Z"/>'
        },
        "arrange-send-to-back": {
            body: '<path fill="currentColor" d="M2 2h9v9H2V2m7 2H4v5h5V4m13 9v9h-9v-9h9m-7 7h5v-5h-5v5m1-12v3h-3V8h3m-5 8H8v-3h3v3Z"/>'
        },
        "arrow-all": {
            body: '<path fill="currentColor" d="M13 11h5l-1.5-1.5l1.42-1.42L21.84 12l-3.92 3.92l-1.42-1.42L18 13h-5v5l1.5-1.5l1.42 1.42L12 21.84l-3.92-3.92L9.5 16.5L11 18v-5H6l1.5 1.5l-1.42 1.42L2.16 12l3.92-3.92L7.5 9.5L6 11h5V6L9.5 7.5L8.08 6.08L12 2.16l3.92 3.92L14.5 7.5L13 6v5Z"/>'
        },
        "arrow-bottom-left": {
            body: '<path fill="currentColor" d="M19 6.41L17.59 5L7 15.59V9H5v10h10v-2H8.41L19 6.41Z"/>'
        },
        "arrow-bottom-left-bold-box": {
            body: '<path fill="currentColor" d="M5 21c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5m10.3-5l-2.1-2.1L17 10l-2.8-2.8l-3.8 3.9l-2.2-2.2V16h7.1Z"/>'
        },
        "arrow-bottom-left-bold-box-outline": {
            body: '<path fill="currentColor" d="M8 16V8.9l2.1 2.1l4.1-3.9L17 10l-4.1 3.9L15 16H8m13 3V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2m-2 0H5V5h14v14Z"/>'
        },
        "arrow-bottom-left-bold-outline": {
            body: '<path fill="currentColor" d="M18.36 19.78H4.22V5.64l4.25 4.24l5.65-5.66l5.66 5.66l-5.66 5.66l4.24 4.24M6.34 17.66h7.07l-2.12-2.12l5.66-5.66l-2.83-2.83l-5.66 5.66l-2.12-2.12v7.07Z"/>'
        },
        "arrow-bottom-left-thick": {
            body: '<path fill="currentColor" d="m15.5 5.69l2.81 2.81l-6.37 6.39h4.95v3.42H5.69V7.11h3.43v4.95l6.38-6.37Z"/>'
        },
        "arrow-bottom-left-thin": {
            body: '<path fill="currentColor" d="m12.07 19l-2.83-2.82L19 6.42L17.58 5l-9.76 9.76L5 11.94V19Z"/>'
        },
        "arrow-bottom-left-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 20.03c4.41 0 8.03-3.62 8.03-8.03c0-4.41-3.62-8.03-8.03-8.03c-4.41 0-8.03 3.62-8.03 8.03c0 4.41 3.62 8.03 8.03 8.03M12 22C6.46 22 2 17.54 2 12S6.46 2 12 2s10 4.46 10 10s-4.46 10-10 10m-1.88-9.53L8 10.36V16h5.64l-2.11-2.12L16.5 8.9l-1.4-1.4"/>'
        },
        "arrow-bottom-right": {
            body: '<path fill="currentColor" d="M5 6.41L6.41 5L17 15.59V9h2v10H9v-2h6.59L5 6.41Z"/>'
        },
        "arrow-bottom-right-bold-box": {
            body: '<path fill="currentColor" d="M19 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2m-3.2-5V8.9L13.7 11L9.8 7.2L7 10l3.8 3.9L8.7 16h7.1Z"/>'
        },
        "arrow-bottom-right-bold-box-outline": {
            body: '<path fill="currentColor" d="M16 16H8.9l2.1-2.1L7 10l2.8-2.8l4.1 3.9L16 8.9V16M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2M5 5h14v14H5V5Z"/>'
        },
        "arrow-bottom-right-bold-outline": {
            body: '<path fill="currentColor" d="M9.88 15.54L4.22 9.88l5.66-5.66l5.66 5.66l4.24-4.24v14.14H5.64l4.24-4.24m7.78-4.95l-2.12 2.12l-5.66-5.66l-2.83 2.83l5.66 5.66l-2.12 2.12h7.07v-7.07Z"/>'
        },
        "arrow-bottom-right-thick": {
            body: '<path fill="currentColor" d="M14.89 12.06V7.11h3.42v11.2H7.11v-3.42h4.95L5.69 8.5L8.5 5.69l6.39 6.37Z"/>'
        },
        "arrow-bottom-right-thin": {
            body: '<path fill="currentColor" d="m11.93 19l2.83-2.82L5 6.42L6.42 5l9.76 9.76L19 11.94V19Z"/>'
        },
        "arrow-bottom-right-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 20.03c-4.41 0-8.03-3.62-8.03-8.03c0-4.41 3.62-8.03 8.03-8.03c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03M12 22c5.54 0 10-4.46 10-10S17.54 2 12 2S2 6.46 2 12s4.46 10 10 10m1.88-9.53L16 10.36V16h-5.64l2.11-2.12L7.5 8.9l1.4-1.4"/>'
        },
        "arrow-collapse": {
            body: '<path fill="currentColor" d="M19.5 3.09L15 7.59V4h-2v7h7V9h-3.59l4.5-4.5l-1.41-1.41M4 13v2h3.59l-4.5 4.5l1.41 1.41l4.5-4.5V20h2v-7H4Z"/>'
        },
        "arrow-collapse-all": {
            body: '<path fill="currentColor" d="m19.5 3.09l1.41 1.41l-4.5 4.5H20v2h-7V4h2v3.59l4.5-4.5m1.41 16.41l-1.41 1.41l-4.5-4.5V20h-2v-7h7v2h-3.59l4.5 4.5M4.5 3.09L9 7.59V4h2v7H4V9h3.59l-4.5-4.5L4.5 3.09M3.09 19.5l4.5-4.5H4v-2h7v7H9v-3.59l-4.5 4.5l-1.41-1.41Z"/>'
        },
        "arrow-collapse-down": {
            body: '<path fill="currentColor" d="M19.92 12.08L12 20l-7.92-7.92l1.42-1.41l5.5 5.5V2h2v14.17l5.5-5.51l1.42 1.42M12 20H2v2h20v-2H12Z"/>'
        },
        "arrow-collapse-horizontal": {
            body: '<path fill="currentColor" d="M13 20V4h2.03v16H13m-3 0V4h2.03v16H10M5 8l4.03 4L5 16v-3H2v-2h3V8m15 8l-4-4l4-4v3h3v2h-3v3Z"/>'
        },
        "arrow-collapse-left": {
            body: '<path fill="currentColor" d="M11.92 19.92L4 12l7.92-7.92l1.41 1.42l-5.5 5.5H22v2H7.83l5.51 5.5l-1.42 1.42M4 12V2H2v20h2V12Z"/>'
        },
        "arrow-collapse-right": {
            body: '<path fill="currentColor" d="M12.08 4.08L20 12l-7.92 7.92l-1.41-1.42l5.5-5.5H2v-2h14.17l-5.5-5.5l1.41-1.42M20 12v10h2V2h-2v10Z"/>'
        },
        "arrow-collapse-up": {
            body: '<path fill="currentColor" d="M4.08 11.92L12 4l7.92 7.92l-1.42 1.41l-5.5-5.5V22h-2V7.83l-5.5 5.5l-1.42-1.41M12 4h10V2H2v2h10Z"/>'
        },
        "arrow-collapse-vertical": {
            body: '<path fill="currentColor" d="M4 12h16v2H4v-2m0-3h16v2H4V9m12-5l-4 4l-4-4h3V1h2v3h3M8 19l4-4l4 4h-3v3h-2v-3H8Z"/>'
        },
        "arrow-decision": {
            body: '<path fill="currentColor" d="M11 5H8l4-4l4 4h-3v4.43c-.75.46-1.42 1.03-2 1.69V5m11 6l-4-4v3a6.747 6.747 0 0 0-7 6.17A3.006 3.006 0 0 0 9.17 20A3.006 3.006 0 0 0 13 21.83A3.01 3.01 0 0 0 14.83 18c-.3-.86-.98-1.53-1.83-1.83c.47-4 4.47-4.2 4.95-4.2v3L22 11m-11.37.59A7.632 7.632 0 0 0 6 10V7l-4 4l4 4v-3c1.34.03 2.63.5 3.64 1.4c.25-.64.58-1.25.99-1.81Z"/>'
        },
        "arrow-decision-auto": {
            body: '<path fill="currentColor" d="M12 5H9l4-4l4 4h-3v4.43c-.75.46-1.42 1.03-2 1.69V5m-1.6 10H8.5l-.7-2H4.6l-.7 2H2l3.2-9h2l3.2 9m-3.05-3.35L6.2 8l-1.15 3.65h2.3M23 11l-4-4v3a6.747 6.747 0 0 0-7 6.17A3.006 3.006 0 0 0 10.17 20A3.006 3.006 0 0 0 14 21.83A3.01 3.01 0 0 0 15.83 18c-.3-.86-.98-1.53-1.83-1.83c.47-4 4.47-4.2 4.95-4.2v3L23 11Z"/>'
        },
        "arrow-decision-auto-outline": {
            body: '<path fill="currentColor" d="M19 15v-3c-.5 0-4.5.16-4.95 4.2c1.56.55 2.38 2.27 1.83 3.83a3.006 3.006 0 0 1-3.83 1.83c-1.55-.56-2.38-2.27-1.83-3.83c.28-.86.98-1.53 1.83-1.83A6.748 6.748 0 0 1 19 10V7l4 4l-4 4m-5 4a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1m-2-7.88c.58-.66 1.25-1.23 2-1.69V5h3l-4-4l-4 4h3v6.12M7.2 6h-2L2 15h1.9l.7-2h3.2l.7 2h1.9L7.2 6m-2.15 5.65L6.2 8l1.15 3.65h-2.3Z"/>'
        },
        "arrow-decision-outline": {
            body: '<path fill="currentColor" d="M9.64 13.4C8.63 12.5 7.34 12.03 6 12v3l-4-4l4-4v3c1.67 0 3.3.57 4.63 1.59a7.97 7.97 0 0 0-.99 1.81M18 15v-3c-.5 0-4.5.16-4.95 4.2c1.56.55 2.38 2.27 1.83 3.83a3.006 3.006 0 0 1-3.83 1.83c-1.55-.56-2.38-2.27-1.83-3.83c.28-.86.98-1.53 1.83-1.83A6.748 6.748 0 0 1 18 10V7l4 4l-4 4m-5 4a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1m-2-7.88c.58-.66 1.25-1.23 2-1.69V5h3l-4-4l-4 4h3v6.12Z"/>'
        },
        "arrow-down": {
            body: '<path fill="currentColor" d="M11 4h2v12l5.5-5.5l1.42 1.42L12 19.84l-7.92-7.92L5.5 10.5L11 16V4Z"/>'
        },
        "arrow-down-bold": {
            body: '<path fill="currentColor" d="M9 4h6v8h4.84L12 19.84L4.16 12H9V4Z"/>'
        },
        "arrow-down-bold-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m7 14l5-5h-3V8h-4v4H7l5 5Z"/>'
        },
        "arrow-down-bold-box-outline": {
            body: '<path fill="currentColor" d="m12 17l-5-5h3V8h4v4h3l-5 5M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "arrow-down-bold-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 15l5-5h-3V8h-4v4H7l5 5Z"/>'
        },
        "arrow-down-bold-circle-outline": {
            body: '<path fill="currentColor" d="m12 17l-5-5h3V8h4v4h3l-5 5m0-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "arrow-down-bold-hexagon-outline": {
            body: '<path fill="currentColor" d="m12 17l-5-5h3V8h4v4h3l-5 5m9-.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "arrow-down-bold-outline": {
            body: '<path fill="currentColor" d="M22 11L12 21L2 11h6V3h8v8h6m-10 7l5-5h-3V5h-4v8H7l5 5Z"/>'
        },
        "arrow-down-box": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m8 1v8.5L7.5 11l-1.42 1.42L12 18.34l5.92-5.92L16.5 11L13 14.5V6h-2Z"/>'
        },
        "arrow-down-circle": {
            body: '<path fill="currentColor" d="M11 6v8l-3.5-3.5l-1.42 1.42L12 17.84l5.92-5.92l-1.42-1.42L13 14V6h-2m1 16A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10Z"/>'
        },
        "arrow-down-circle-outline": {
            body: '<path fill="currentColor" d="M11 6h2v8l3.5-3.5l1.42 1.42L12 17.84l-5.92-5.92L7.5 10.5L11 14V6m1 16A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10m0-2a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8Z"/>'
        },
        "arrow-down-drop-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-5 8l5 5l5-5H7Z"/>'
        },
        "arrow-down-drop-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m-5 6l5 5l5-5H7Z"/>'
        },
        "arrow-down-left": {
            body: '<path fill="currentColor" d="M20 4v2h-6.5C11 6 9 8 9 10.5v5.67l3.09-3.08l1.41 1.41L8 20l-5.5-5.5l1.41-1.42L7 16.17V10.5A6.5 6.5 0 0 1 13.5 4H20Z"/>'
        },
        "arrow-down-left-bold": {
            body: '<path fill="currentColor" d="M21 3v4h-7.5C11.57 7 10 8.57 10 10.5V13h4l-6 7l-6-7h4v-2.5C6 6.36 9.36 3 13.5 3H21Z"/>'
        },
        "arrow-down-right": {
            body: '<path fill="currentColor" d="M21.5 14.5L16 20l-5.5-5.5l1.41-1.41L15 16.17V10.5C15 8 13 6 10.5 6H4V4h6.5a6.5 6.5 0 0 1 6.5 6.5v5.67l3.09-3.09l1.41 1.42Z"/>'
        },
        "arrow-down-right-bold": {
            body: '<path fill="currentColor" d="M10.5 3c4.14 0 7.5 3.36 7.5 7.5V13h4l-6 7l-6-7h4v-2.5C14 8.57 12.43 7 10.5 7H3V3h7.5Z"/>'
        },
        "arrow-down-thick": {
            body: '<path fill="currentColor" d="M10 4h4v9l3.5-3.5l2.42 2.42L12 19.84l-7.92-7.92L6.5 9.5L10 13V4Z"/>'
        },
        "arrow-down-thin": {
            body: '<path fill="currentColor" d="M7.03 13.92h4V5l2.01-.03v8.95h3.99l-5 5Z"/>'
        },
        "arrow-down-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 20.03c4.41 0 8.03-3.62 8.03-8.03c0-4.41-3.62-8.03-8.03-8.03c-4.41 0-8.03 3.62-8.03 8.03c0 4.41 3.62 8.03 8.03 8.03M12 22C6.46 22 2 17.54 2 12S6.46 2 12 2s10 4.46 10 10s-4.46 10-10 10m-1-8.46H8l4 3.96l4-3.96h-3V6.5h-2"/>'
        },
        "arrow-expand": {
            body: '<path fill="currentColor" d="M10 21v-2H6.41l4.5-4.5l-1.41-1.41l-4.5 4.5V14H3v7h7m4.5-10.09l4.5-4.5V10h2V3h-7v2h3.59l-4.5 4.5l1.41 1.41Z"/>'
        },
        "arrow-expand-all": {
            body: '<path fill="currentColor" d="m9.5 13.09l1.41 1.41l-4.5 4.5H10v2H3v-7h2v3.59l4.5-4.5m1.41-3.59L9.5 10.91L5 6.41V10H3V3h7v2H6.41l4.5 4.5m3.59 3.59l4.5 4.5V14h2v7h-7v-2h3.59l-4.5-4.5l1.41-1.41M13.09 9.5l4.5-4.5H14V3h7v7h-2V6.41l-4.5 4.5l-1.41-1.41Z"/>'
        },
        "arrow-expand-down": {
            body: '<path fill="currentColor" d="M22 4V2H2v2h9v14.17l-5.5-5.5l-1.42 1.41L12 22l7.92-7.92l-1.42-1.41l-5.5 5.5V4h9Z"/>'
        },
        "arrow-expand-horizontal": {
            body: '<path fill="currentColor" d="M9 11h6V8l4 4l-4 4v-3H9v3l-4-4l4-4v3m-7 9V4h2v16H2m18 0V4h2v16h-2Z"/>'
        },
        "arrow-expand-left": {
            body: '<path fill="currentColor" d="M20 22h2V2h-2v9H5.83l5.5-5.5l-1.41-1.42L2 12l7.92 7.92l1.41-1.42l-5.5-5.5H20v9Z"/>'
        },
        "arrow-expand-right": {
            body: '<path fill="currentColor" d="M4 2H2v20h2v-9h14.17l-5.5 5.5l1.41 1.42L22 12l-7.92-7.92l-1.41 1.42l5.5 5.5H4V2Z"/>'
        },
        "arrow-expand-up": {
            body: '<path fill="currentColor" d="M2 20v2h20v-2h-9V5.83l5.5 5.5l1.42-1.41L12 2L4.08 9.92l1.42 1.41l5.5-5.5V20H2Z"/>'
        },
        "arrow-expand-vertical": {
            body: '<path fill="currentColor" d="M13 9v6h3l-4 4l-4-4h3V9H8l4-4l4 4h-3M4 2h16v2H4V2m0 18h16v2H4v-2Z"/>'
        },
        "arrow-horizontal-lock": {
            body: '<path fill="currentColor" d="M14.8 7V5.5C14.8 4.1 13.4 3 12 3S9.2 4.1 9.2 5.5V7C8.6 7 8 7.6 8 8.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2V8.3c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3V5.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V7M6 17v3l-4-4l4-4v3h12v-3l4 4l-4 4v-3H6Z"/>'
        },
        "arrow-left": {
            body: '<path fill="currentColor" d="M20 11v2H8l5.5 5.5l-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5L8 11h12Z"/>'
        },
        "arrow-left-bold": {
            body: '<path fill="currentColor" d="M20 9v6h-8v4.84L4.16 12L12 4.16V9h8Z"/>'
        },
        "arrow-left-bold-box": {
            body: '<path fill="currentColor" d="M21 5v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2M7 12l5 5v-3h4v-4h-4V7l-5 5Z"/>'
        },
        "arrow-left-bold-box-outline": {
            body: '<path fill="currentColor" d="m7 12l5-5v3h4v4h-4v3l-5-5m14-7v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-2 0H5v14h14V5Z"/>'
        },
        "arrow-left-bold-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M7 12l5 5v-3h4v-4h-4V7l-5 5Z"/>'
        },
        "arrow-left-bold-circle-outline": {
            body: '<path fill="currentColor" d="m7 12l5-5v3h4v4h-4v3l-5-5m15 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8Z"/>'
        },
        "arrow-left-bold-hexagon-outline": {
            body: '<path fill="currentColor" d="m7 12l5-5v3h4v4h-4v3l-5-5m14 4.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "arrow-left-bold-outline": {
            body: '<path fill="currentColor" d="M13 22L3 12L13 2v6h8v8h-8v6M6 12l5 5v-3h8v-4h-8V7l-5 5Z"/>'
        },
        "arrow-left-bottom": {
            body: '<path fill="currentColor" d="M20 4v6.5a6.5 6.5 0 0 1-6.5 6.5H7.83l3.09 3.09L9.5 21.5L4 16l5.5-5.5l1.41 1.41L7.83 15h5.67c2.5 0 4.5-2 4.5-4.5V4h2Z"/>'
        },
        "arrow-left-bottom-bold": {
            body: '<path fill="currentColor" d="M21 10.5c0 4.14-3.36 7.5-7.5 7.5H11v4l-7-6l7-6v4h2.5c1.93 0 3.5-1.57 3.5-3.5V3h4v7.5Z"/>'
        },
        "arrow-left-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-1 8H9.5L13 7.5l-1.42-1.42L5.66 12l5.92 5.92L13 16.5L9.5 13H18v-2Z"/>'
        },
        "arrow-left-circle": {
            body: '<path fill="currentColor" d="M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m16-1h-8l3.5-3.5l-1.42-1.42L6.16 12l5.92 5.92l1.42-1.42L10 13h8v-2Z"/>'
        },
        "arrow-left-circle-outline": {
            body: '<path fill="currentColor" d="M18 11v2h-8l3.5 3.5l-1.42 1.42L6.16 12l5.92-5.92L13.5 7.5L10 11h8M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m2 0a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8Z"/>'
        },
        "arrow-left-drop-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-8-5l-5 5l5 5V7Z"/>'
        },
        "arrow-left-drop-circle-outline": {
            body: '<path fill="currentColor" d="M22 12A10 10 0 0 0 12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10m-2 0a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8m-6-5l-5 5l5 5V7Z"/>'
        },
        "arrow-left-right": {
            body: '<path fill="currentColor" d="M6.45 17.45L1 12l5.45-5.45l1.41 1.41L4.83 11h14.34l-3.03-3.04l1.41-1.41L23 12l-5.45 5.45l-1.41-1.41L19.17 13H4.83l3.03 3.04l-1.41 1.41Z"/>'
        },
        "arrow-left-right-bold": {
            body: '<path fill="currentColor" d="M8 14v4l-6-6l6-6v4h8V6l6 6l-6 6v-4H8Z"/>'
        },
        "arrow-left-right-bold-outline": {
            body: '<path fill="currentColor" d="M14 16v6l10-10L14 2v6h-4V2L0 12l10 10v-6h4m-6-2v3l-5-5l5-5v3h8V7l5 5l-5 5v-3H8Z"/>'
        },
        "arrow-left-thick": {
            body: '<path fill="currentColor" d="M20 10v4h-9l3.5 3.5l-2.42 2.42L4.16 12l7.92-7.92L14.5 6.5L11 10h9Z"/>'
        },
        "arrow-left-thin": {
            body: '<path fill="currentColor" d="M10.05 16.94v-4h8.92l.03-2.01h-8.95V6.94l-5 5Z"/>'
        },
        "arrow-left-thin-circle-outline": {
            body: '<path fill="currentColor" d="M3.97 12c0 4.41 3.62 8.03 8.03 8.03c4.41 0 8.03-3.62 8.03-8.03c0-4.41-3.62-8.03-8.03-8.03c-4.41 0-8.03 3.62-8.03 8.03M2 12C2 6.46 6.46 2 12 2s10 4.46 10 10s-4.46 10-10 10S2 17.54 2 12m8.46-1V8L6.5 12l3.96 4v-3h7.04v-2"/>'
        },
        "arrow-left-top": {
            body: '<path fill="currentColor" d="M20 13.5V20h-2v-6.5C18 11 16 9 13.5 9H7.83l3.08 3.09L9.5 13.5L4 8l5.5-5.5l1.42 1.41L7.83 7h5.67a6.5 6.5 0 0 1 6.5 6.5Z"/>'
        },
        "arrow-left-top-bold": {
            body: '<path fill="currentColor" d="M21 21h-4v-7.5c0-1.93-1.57-3.5-3.5-3.5H11v4L4 8l7-6v4h2.5c4.14 0 7.5 3.36 7.5 7.5V21Z"/>'
        },
        "arrow-projectile": {
            body: '<path fill="currentColor" d="m22 2l-2 5l-.97-.97L8 17.06V19l-3 3l-1-2l-2-1l3-3h1.94L17.97 4.97L17 4l5-2Z"/>'
        },
        "arrow-projectile-multiple": {
            body: '<path fill="currentColor" d="m19 16l3 3l-2 1l-1 2l-3-3v-1.94l-4-4l-4 4V19l-3 3l-1-2l-2-1l3-3h1.94l4-4l-5.97-5.97L4 7L2 2l5 2l-.97.97L12 10.94l5.97-5.97L17 4l5-2l-2 5l-.97-.97L13.06 12l4 4H19Z"/>'
        },
        "arrow-right": {
            body: '<path fill="currentColor" d="M4 11v2h12l-5.5 5.5l1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5L16 11H4Z"/>'
        },
        "arrow-right-bold": {
            body: '<path fill="currentColor" d="M4 15V9h8V4.16L19.84 12L12 19.84V15H4Z"/>'
        },
        "arrow-right-bold-box": {
            body: '<path fill="currentColor" d="M3 19V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2m14-7l-5-5v3H8v4h4v3l5-5Z"/>'
        },
        "arrow-right-bold-box-outline": {
            body: '<path fill="currentColor" d="m17 12l-5 5v-3H8v-4h4V7l5 5M3 19V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2m2 0h14V5H5v14Z"/>'
        },
        "arrow-right-bold-circle": {
            body: '<path fill="currentColor" d="M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m15 0l-5-5v3H8v4h4v3l5-5Z"/>'
        },
        "arrow-right-bold-circle-outline": {
            body: '<path fill="currentColor" d="m17 12l-5 5v-3H8v-4h4V7l5 5M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m2 0a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8Z"/>'
        },
        "arrow-right-bold-hexagon-outline": {
            body: '<path fill="currentColor" d="m17 12l-5 5v-3H8v-4h4V7l5 5m4 4.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "arrow-right-bold-outline": {
            body: '<path fill="currentColor" d="M11 16H3V8h8V2l10 10l-10 10v-6m2-9v3H5v4h8v3l5-5l-5-5Z"/>'
        },
        "arrow-right-bottom": {
            body: '<path fill="currentColor" d="m20 16l-5.5 5.5l-1.42-1.41L16.17 17H10.5A6.5 6.5 0 0 1 4 10.5V4h2v6.5C6 13 8 15 10.5 15h5.67l-3.08-3.09l1.41-1.41L20 16Z"/>'
        },
        "arrow-right-bottom-bold": {
            body: '<path fill="currentColor" d="M3 3h4v7.5c0 1.93 1.57 3.5 3.5 3.5H13v-4l7 6l-7 6v-4h-2.5C6.36 18 3 14.64 3 10.5V3Z"/>'
        },
        "arrow-right-box": {
            body: '<path fill="currentColor" d="M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5m1-8h8.5L11 16.5l1.42 1.42L18.34 12l-5.92-5.92L11 7.5l3.5 3.5H6v2Z"/>'
        },
        "arrow-right-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M6 13h8l-3.5 3.5l1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5L14 11H6v2Z"/>'
        },
        "arrow-right-circle-outline": {
            body: '<path fill="currentColor" d="M6 13v-2h8l-3.5-3.5l1.42-1.42L17.84 12l-5.92 5.92l-1.42-1.42L14 13H6m16-1a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8Z"/>'
        },
        "arrow-right-drop-circle": {
            body: '<path fill="currentColor" d="M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m8 5l5-5l-5-5v10Z"/>'
        },
        "arrow-right-drop-circle-outline": {
            body: '<path fill="currentColor" d="M2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2A10 10 0 0 0 2 12m2 0a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8m6 5l5-5l-5-5v10Z"/>'
        },
        "arrow-right-thick": {
            body: '<path fill="currentColor" d="M4 10v4h9l-3.5 3.5l2.42 2.42L19.84 12l-7.92-7.92L9.5 6.5L13 10H4Z"/>'
        },
        "arrow-right-thin": {
            body: '<path fill="currentColor" d="M14 16.94v-4H5.08l-.03-2.01H14V6.94l5 5Z"/>'
        },
        "arrow-right-thin-circle-outline": {
            body: '<path fill="currentColor" d="M20.03 12c0-4.41-3.62-8.03-8.03-8.03c-4.41 0-8.03 3.62-8.03 8.03c0 4.41 3.62 8.03 8.03 8.03c4.41 0 8.03-3.62 8.03-8.03M22 12c0 5.54-4.46 10-10 10S2 17.54 2 12S6.46 2 12 2s10 4.46 10 10m-8.46 1v3l3.96-4l-3.96-4v3H6.5v2"/>'
        },
        "arrow-right-top": {
            body: '<path fill="currentColor" d="m20 8l-5.5 5.5l-1.41-1.41L16.17 9H10.5C8 9 6 11 6 13.5V20H4v-6.5A6.5 6.5 0 0 1 10.5 7h5.67l-3.09-3.09L14.5 2.5L20 8Z"/>'
        },
        "arrow-right-top-bold": {
            body: '<path fill="currentColor" d="M3 13.5C3 9.36 6.36 6 10.5 6H13V2l7 6l-7 6v-4h-2.5C8.57 10 7 11.57 7 13.5V21H3v-7.5Z"/>'
        },
        "arrow-split-horizontal": {
            body: '<path fill="currentColor" d="M8 18h3v-3H2v-2h20v2h-9v3h3l-4 4l-4-4m4-16L8 6h3v3H2v2h20V9h-9V6h3l-4-4Z"/>'
        },
        "arrow-split-vertical": {
            body: '<path fill="currentColor" d="M18 16v-3h-3v9h-2V2h2v9h3V8l4 4l-4 4M2 12l4 4v-3h3v9h2V2H9v9H6V8l-4 4Z"/>'
        },
        "arrow-top-left": {
            body: '<path fill="currentColor" d="M19 17.59L17.59 19L7 8.41V15H5V5h10v2H8.41L19 17.59Z"/>'
        },
        "arrow-top-left-bold-box": {
            body: '<path fill="currentColor" d="M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2m3.2 5v7.1l2.1-2.1l3.8 3.9L17 14l-3.8-3.9L15.3 8H8.2Z"/>'
        },
        "arrow-top-left-bold-box-outline": {
            body: '<path fill="currentColor" d="M8 8h7.1L13 10.1l4 3.9l-2.8 2.8l-4.1-3.9L8 15.1V8m11-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14v14Z"/>'
        },
        "arrow-top-left-bold-outline": {
            body: '<path fill="currentColor" d="m14.12 8.46l5.66 5.66l-5.66 5.66l-5.66-5.66l-4.24 4.24V4.22h14.14l-4.24 4.24m-7.78 4.95l2.12-2.12l5.66 5.66l2.83-2.83l-5.66-5.65l2.12-2.13H6.34v7.07Z"/>'
        },
        "arrow-top-left-bottom-right": {
            body: '<path fill="currentColor" d="M13 21h8v-8h-2v4.59L6.41 5H11V3H3v8h2V6.41L17.59 19H13v2Z"/>'
        },
        "arrow-top-left-bottom-right-bold": {
            body: '<path fill="currentColor" d="M5.83 8.66L3 11.5V3h8.5L8.66 5.83l9.51 9.51L21 12.5V21h-8.5l2.84-2.83l-9.51-9.51Z"/>'
        },
        "arrow-top-left-thick": {
            body: '<path fill="currentColor" d="M9.12 11.94v4.95H5.69V5.69h11.2v3.43h-4.95l6.37 6.38l-2.81 2.81l-6.38-6.37Z"/>'
        },
        "arrow-top-left-thin": {
            body: '<path fill="currentColor" d="M12.07 5L9.24 7.83L19 17.59L17.58 19L7.82 9.25L5 12.07V5Z"/>'
        },
        "arrow-top-left-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 3.97c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03c-4.41 0-8.03-3.62-8.03-8.03c0-4.41 3.62-8.03 8.03-8.03M12 2C6.46 2 2 6.46 2 12s4.46 10 10 10s10-4.46 10-10S17.54 2 12 2m-1.88 9.53L8 13.64V8h5.64l-2.11 2.12l4.97 4.98l-1.4 1.4"/>'
        },
        "arrow-top-right": {
            body: '<path fill="currentColor" d="M5 17.59L15.59 7H9V5h10v10h-2V8.41L6.41 19L5 17.59Z"/>'
        },
        "arrow-top-right-bold-box": {
            body: '<path fill="currentColor" d="M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14M8.7 8l2.1 2.1L7 14l2.8 2.8l3.8-3.9l2.1 2.1V8h-7Z"/>'
        },
        "arrow-top-right-bold-box-outline": {
            body: '<path fill="currentColor" d="M16 8v7.1L13.9 13l-4.1 3.9L7 14l4.1-3.9L8.9 8H16M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2m2 0h14v14H5V5Z"/>'
        },
        "arrow-top-right-bold-outline": {
            body: '<path fill="currentColor" d="M5.64 4.22h14.14v14.14l-4.24-4.24l-5.66 5.66l-5.66-5.66l5.66-5.66l-4.24-4.24m12.02 2.12h-7.07l2.12 2.12l-5.66 5.66l2.83 2.83l5.66-5.66l2.12 2.12V6.34Z"/>'
        },
        "arrow-top-right-bottom-left": {
            body: '<path fill="currentColor" d="M11 21H3v-8h2v4.59L17.59 5H13V3h8v8h-2V6.41L6.41 19H11v2Z"/>'
        },
        "arrow-top-right-bottom-left-bold": {
            body: '<path fill="currentColor" d="M18.17 8.66L21 11.5V3h-8.5l2.84 2.83l-9.51 9.51L3 12.5V21h8.5l-2.84-2.83l9.51-9.51Z"/>'
        },
        "arrow-top-right-thick": {
            body: '<path fill="currentColor" d="M8.5 18.31L5.69 15.5l6.37-6.38H7.11V5.69h11.2v11.2h-3.42v-4.95L8.5 18.31Z"/>'
        },
        "arrow-top-right-thin": {
            body: '<path fill="currentColor" d="m11.93 5l2.83 2.83L5 17.59L6.42 19l9.76-9.75L19 12.07V5h-7.07Z"/>'
        },
        "arrow-top-right-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 3.97c-4.41 0-8.03 3.62-8.03 8.03c0 4.41 3.62 8.03 8.03 8.03c4.41 0 8.03-3.62 8.03-8.03c0-4.41-3.62-8.03-8.03-8.03M12 2c5.54 0 10 4.46 10 10s-4.46 10-10 10S2 17.54 2 12S6.46 2 12 2m1.88 9.53L16 13.64V8h-5.64l2.11 2.12L7.5 15.1l1.4 1.4"/>'
        },
        "arrow-u-down-left": {
            body: '<path fill="currentColor" d="M20 10.5V18h-2v-7.5C18 8 16 6 13.5 6S9 8 9 10.5v5.67l3.09-3.08l1.41 1.41L8 20l-5.5-5.5l1.41-1.42L7 16.17V10.5a6.5 6.5 0 1 1 13 0Z"/>'
        },
        "arrow-u-down-left-bold": {
            body: '<path fill="currentColor" d="M21 10.5V18h-4v-7.5C17 8.57 15.43 7 13.5 7S10 8.57 10 10.5V13h4l-6 7l-6-7h4v-2.5C6 6.36 9.36 3 13.5 3S21 6.36 21 10.5Z"/>'
        },
        "arrow-u-down-right": {
            body: '<path fill="currentColor" d="M21.5 14.5L16 20l-5.5-5.5l1.41-1.41L15 16.17V10.5C15 8 13 6 10.5 6S6 8 6 10.5V18H4v-7.5a6.5 6.5 0 1 1 13 0v5.67l3.09-3.09l1.41 1.42Z"/>'
        },
        "arrow-u-down-right-bold": {
            body: '<path fill="currentColor" d="M10.5 3c4.14 0 7.5 3.36 7.5 7.5V13h4l-6 7l-6-7h4v-2.5C14 8.57 12.43 7 10.5 7S7 8.57 7 10.5V18H3v-7.5C3 6.36 6.36 3 10.5 3Z"/>'
        },
        "arrow-u-left-bottom": {
            body: '<path fill="currentColor" d="M20 10.5a6.5 6.5 0 0 1-6.5 6.5H7.83l3.09 3.09L9.5 21.5L4 16l5.5-5.5l1.41 1.41L7.83 15h5.67c2.5 0 4.5-2 4.5-4.5S16 6 13.5 6H6V4h7.5a6.5 6.5 0 0 1 6.5 6.5Z"/>'
        },
        "arrow-u-left-bottom-bold": {
            body: '<path fill="currentColor" d="M21 10.5c0 4.14-3.36 7.5-7.5 7.5H11v4l-7-6l7-6v4h2.5c1.93 0 3.5-1.57 3.5-3.5S15.43 7 13.5 7H6V3h7.5c4.14 0 7.5 3.36 7.5 7.5Z"/>'
        },
        "arrow-u-left-top": {
            body: '<path fill="currentColor" d="M20 13.5a6.5 6.5 0 0 1-6.5 6.5H6v-2h7.5c2.5 0 4.5-2 4.5-4.5S16 9 13.5 9H7.83l3.08 3.09L9.5 13.5L4 8l5.5-5.5l1.42 1.41L7.83 7h5.67a6.5 6.5 0 0 1 6.5 6.5Z"/>'
        },
        "arrow-u-left-top-bold": {
            body: '<path fill="currentColor" d="M13.5 21H6v-4h7.5c1.93 0 3.5-1.57 3.5-3.5S15.43 10 13.5 10H11v4L4 8l7-6v4h2.5c4.14 0 7.5 3.36 7.5 7.5S17.64 21 13.5 21Z"/>'
        },
        "arrow-u-right-bottom": {
            body: '<path fill="currentColor" d="m20 16l-5.5 5.5l-1.42-1.41L16.17 17H10.5a6.5 6.5 0 1 1 0-13H18v2h-7.5C8 6 6 8 6 10.5S8 15 10.5 15h5.67l-3.08-3.09l1.41-1.41L20 16Z"/>'
        },
        "arrow-u-right-bottom-bold": {
            body: '<path fill="currentColor" d="M10.5 3H18v4h-7.5C8.57 7 7 8.57 7 10.5S8.57 14 10.5 14H13v-4l7 6l-7 6v-4h-2.5C6.36 18 3 14.64 3 10.5S6.36 3 10.5 3Z"/>'
        },
        "arrow-u-right-top": {
            body: '<path fill="currentColor" d="M10.5 18H18v2h-7.5a6.5 6.5 0 1 1 0-13h5.67l-3.09-3.09L14.5 2.5L20 8l-5.5 5.5l-1.41-1.41L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z"/>'
        },
        "arrow-u-right-top-bold": {
            body: '<path fill="currentColor" d="M3 13.5C3 9.36 6.36 6 10.5 6H13V2l7 6l-7 6v-4h-2.5C8.57 10 7 11.57 7 13.5S8.57 17 10.5 17H18v4h-7.5C6.36 21 3 17.64 3 13.5Z"/>'
        },
        "arrow-u-up-left": {
            body: '<path fill="currentColor" d="M20 6v7.5a6.5 6.5 0 1 1-13 0V7.83l-3.09 3.09L2.5 9.5L8 4l5.5 5.5l-1.41 1.41L9 7.83v5.67C9 16 11 18 13.5 18s4.5-2 4.5-4.5V6h2Z"/>'
        },
        "arrow-u-up-left-bold": {
            body: '<path fill="currentColor" d="M13.5 21C9.36 21 6 17.64 6 13.5V11H2l6-7l6 7h-4v2.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V6h4v7.5c0 4.14-3.36 7.5-7.5 7.5Z"/>'
        },
        "arrow-u-up-right": {
            body: '<path fill="currentColor" d="m21.5 9.5l-1.41 1.42L17 7.83v5.67a6.5 6.5 0 1 1-13 0V6h2v7.5C6 16 8 18 10.5 18s4.5-2 4.5-4.5V7.83l-3.09 3.08L10.5 9.5L16 4l5.5 5.5Z"/>'
        },
        "arrow-u-up-right-bold": {
            body: '<path fill="currentColor" d="M3 13.5V6h4v7.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V11h-4l6-7l6 7h-4v2.5c0 4.14-3.36 7.5-7.5 7.5S3 17.64 3 13.5Z"/>'
        },
        "arrow-up": {
            body: '<path fill="currentColor" d="M13 20h-2V8l-5.5 5.5l-1.42-1.42L12 4.16l7.92 7.92l-1.42 1.42L13 8v12Z"/>'
        },
        "arrow-up-bold": {
            body: '<path fill="currentColor" d="M15 20H9v-8H4.16L12 4.16L19.84 12H15v8Z"/>'
        },
        "arrow-up-bold-box": {
            body: '<path fill="currentColor" d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M12 7l-5 5h3v4h4v-4h3l-5-5Z"/>'
        },
        "arrow-up-bold-box-outline": {
            body: '<path fill="currentColor" d="m12 7l5 5h-3v4h-4v-4H7l5-5m7 14H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2m0-2V5H5v14h14Z"/>'
        },
        "arrow-up-bold-circle": {
            body: '<path fill="currentColor" d="M12 22A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10m0-15l-5 5h3v4h4v-4h3l-5-5Z"/>'
        },
        "arrow-up-bold-circle-outline": {
            body: '<path fill="currentColor" d="m12 7l5 5h-3v4h-4v-4H7l5-5m0 15A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10m0-2a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8Z"/>'
        },
        "arrow-up-bold-hexagon-outline": {
            body: '<path fill="currentColor" d="m12 7l5 5h-3v4h-4v-4H7l5-5m9 9.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "arrow-up-bold-outline": {
            body: '<path fill="currentColor" d="M16 13v8H8v-8H2L12 3l10 10h-6m-9-2h3v8h4v-8h3l-5-5l-5 5Z"/>'
        },
        "arrow-up-box": {
            body: '<path fill="currentColor" d="M21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14m-8-1V9.5l3.5 3.5l1.42-1.42L12 5.66l-5.92 5.92L7.5 13L11 9.5V18h2Z"/>'
        },
        "arrow-up-circle": {
            body: '<path fill="currentColor" d="M13 18v-8l3.5 3.5l1.42-1.42L12 6.16l-5.92 5.92L7.5 13.5L11 10v8h2M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "arrow-up-circle-outline": {
            body: '<path fill="currentColor" d="M13 18h-2v-8l-3.5 3.5l-1.42-1.42L12 6.16l5.92 5.92l-1.42 1.42L13 10v8M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "arrow-up-down": {
            body: '<path fill="currentColor" d="M17.45 17.55L12 23l-5.45-5.45l1.41-1.41L11 19.17V4.83L7.96 7.86L6.55 6.45L12 1l5.45 5.45l-1.41 1.41L13 4.83v14.34l3.04-3.03l1.41 1.41Z"/>'
        },
        "arrow-up-down-bold": {
            body: '<path fill="currentColor" d="M10 8H6l6-6l6 6h-4v8h4l-6 6l-6-6h4V8Z"/>'
        },
        "arrow-up-down-bold-outline": {
            body: '<path fill="currentColor" d="M16 10h6L12 0L2 10h6v4H2l10 10l10-10h-6v-4m-2 6h3l-5 5l-5-5h3V8H7l5-5l5 5h-3v8Z"/>'
        },
        "arrow-up-drop-circle": {
            body: '<path fill="currentColor" d="M12 22A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10m5-8l-5-5l-5 5h10Z"/>'
        },
        "arrow-up-drop-circle-outline": {
            body: '<path fill="currentColor" d="M12 22a10 10 0 0 0 10-10A10 10 0 0 0 12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10m0-2a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m5-6l-5-5l-5 5h10Z"/>'
        },
        "arrow-up-left": {
            body: '<path fill="currentColor" d="M20 18v2h-6.5A6.5 6.5 0 0 1 7 13.5V7.83l-3.09 3.09L2.5 9.5L8 4l5.5 5.5l-1.41 1.41L9 7.83v5.67C9 16 11 18 13.5 18H20Z"/>'
        },
        "arrow-up-left-bold": {
            body: '<path fill="currentColor" d="M13.5 21C9.36 21 6 17.64 6 13.5V11H2l6-7l6 7h-4v2.5c0 1.93 1.57 3.5 3.5 3.5H21v4h-7.5Z"/>'
        },
        "arrow-up-right": {
            body: '<path fill="currentColor" d="m21.5 9.5l-1.41 1.42L17 7.83v5.67a6.5 6.5 0 0 1-6.5 6.5H4v-2h6.5c2.5 0 4.5-2 4.5-4.5V7.83l-3.09 3.08L10.5 9.5L16 4l5.5 5.5Z"/>'
        },
        "arrow-up-right-bold": {
            body: '<path fill="currentColor" d="M3 21v-4h7.5c1.93 0 3.5-1.57 3.5-3.5V11h-4l6-7l6 7h-4v2.5c0 4.14-3.36 7.5-7.5 7.5H3Z"/>'
        },
        "arrow-up-thick": {
            body: '<path fill="currentColor" d="M14 20h-4v-9l-3.5 3.5l-2.42-2.42L12 4.16l7.92 7.92l-2.42 2.42L14 11v9Z"/>'
        },
        "arrow-up-thin": {
            body: '<path fill="currentColor" d="M7.03 9.97h4v8.92l2.01.03V9.97h3.99l-5-5Z"/>'
        },
        "arrow-up-thin-circle-outline": {
            body: '<path fill="currentColor" d="M12 3.97c-4.41 0-8.03 3.62-8.03 8.03c0 4.41 3.62 8.03 8.03 8.03c4.41 0 8.03-3.62 8.03-8.03c0-4.41-3.62-8.03-8.03-8.03M12 2c5.54 0 10 4.46 10 10s-4.46 10-10 10S2 17.54 2 12S6.46 2 12 2m1 8.46h3L12 6.5l-4 3.96h3v7.04h2"/>'
        },
        "arrow-vertical-lock": {
            body: '<path fill="currentColor" d="M18.8 11V9.5C18.8 8.1 17.4 7 16 7s-2.8 1.1-2.8 2.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11M9 6h3L8 2L4 6h3v12H4l4 4l4-4H9V6Z"/>'
        },
        artboard: {
            body: '<path fill="currentColor" d="M17 9v6H7V9h10m2-6h-2v3h2V3M7 3H5v3h2V3m16 4h-3v2h3V7m-4 0H5v10h14V7M4 7H1v2h3V7m19 8h-3v2h3v-2M4 15H1v2h3v-2m15 3h-2v3h2v-3M7 18H5v3h2v-3Z"/>'
        },
        artstation: {
            body: '<path fill="currentColor" d="m1.77 16.88l1.73 2.98c.34.68 1.04 1.14 1.83 1.14h11.46l-2.36-4.12H1.77m20.46.02c0-.4-.12-.79-.33-1.12L15.17 4.1A2.04 2.04 0 0 0 13.35 3H9.8l10.38 18l1.64-2.86c.31-.54.41-.78.41-1.24m-9.5-2.96L8.1 5.92l-4.65 8.02h9.28Z"/>'
        },
        "aspect-ratio": {
            body: '<path fill="currentColor" d="M19 12h-2v3h-3v2h5v-5M7 9h3V7H5v5h2V9m14-6H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H3V5h18v14Z"/>'
        },
        assistant: {
            body: '<path fill="currentColor" d="M19 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4l3 3l3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11"/>'
        },
        asterisk: {
            body: '<path fill="currentColor" d="M21 13h-6.6l4.7 4.7l-1.4 1.4l-4.7-4.7V21h-2v-6.7L6.3 19l-1.4-1.4L9.4 13H3v-2h6.6L4.9 6.3l1.4-1.4L11 9.6V3h2v6.4l4.6-4.6L19 6.3L14.3 11H21v2Z"/>'
        },
        "asterisk-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.39 0-8-3.61-8-8c0-4.39 3.61-8 8-8c4.39 0 8 3.61 8 8c0 4.39-3.61 8-8 8m1-9.73l2.83-1.64l1 1.74L14 12l2.83 1.63l-1 1.74L13 13.73V17h-2v-3.27l-2.83 1.64l-1-1.74L10 12l-2.83-1.63l1-1.74L11 10.27V7h2v3.27Z"/>'
        },
        at: {
            body: '<path fill="currentColor" d="M12 15c.81 0 1.5-.3 2.11-.89c.59-.61.89-1.3.89-2.11c0-.81-.3-1.5-.89-2.11C13.5 9.3 12.81 9 12 9c-.81 0-1.5.3-2.11.89C9.3 10.5 9 11.19 9 12c0 .81.3 1.5.89 2.11c.61.59 1.3.89 2.11.89m0-13c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12v1.45c0 1-.35 1.85-1 2.55c-.7.67-1.5 1-2.5 1c-1.2 0-2.19-.5-2.94-1.5c-1 1-2.18 1.5-3.56 1.5c-1.37 0-2.55-.5-3.54-1.46C7.5 14.55 7 13.38 7 12c0-1.37.5-2.55 1.46-3.54C9.45 7.5 10.63 7 12 7c1.38 0 2.55.5 3.54 1.46C16.5 9.45 17 10.63 17 12v1.45c0 .41.16.77.46 1.08c.3.31.65.47 1.04.47c.42 0 .77-.16 1.07-.47c.3-.31.43-.67.43-1.08V12c0-2.19-.77-4.07-2.35-5.65S14.19 4 12 4c-2.19 0-4.07.77-5.65 2.35S4 9.81 4 12c0 2.19.77 4.07 2.35 5.65S9.81 20 12 20h5v2h-5c-2.75 0-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2Z"/>'
        },
        atlassian: {
            body: '<path fill="currentColor" d="M7.93 11.24a.582.582 0 0 0-.8-.11c-.07.06-.13.13-.17.21l-4.9 9.81c-.15.29-.03.64.26.79c.08.06.18.06.27.06h6.82c.22 0 .43-.12.53-.32c1.47-3.05.56-7.68-2.01-10.44m3.6-8.93a12.991 12.991 0 0 0-.76 12.78l3.29 6.59c.11.2.31.32.53.32h6.82a.59.59 0 0 0 .59-.59c0-.09 0-.18-.06-.26c0 0-9.18-18.38-9.44-18.84a.52.52 0 0 0-.72-.25c-.11.05-.2.14-.25.25Z"/>'
        },
        atm: {
            body: '<path fill="currentColor" d="M8 9v1.5h2.25V15h1.5v-4.5H14V9H8M6 9H3a1 1 0 0 0-1 1v5h1.5v-1.5h2V15H7v-5a1 1 0 0 0-1-1m-.5 3h-2v-1.5h2V12M21 9h-4.5a1 1 0 0 0-1 1v5H17v-4.5h1V14h1.5v-3.5h1V15H22v-5a1 1 0 0 0-1-1Z"/>'
        },
        atom: {
            body: '<path fill="currentColor" d="M12 11a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M4.22 4.22C5.65 2.79 8.75 3.43 12 5.56c3.25-2.13 6.35-2.77 7.78-1.34c1.43 1.43.79 4.53-1.34 7.78c2.13 3.25 2.77 6.35 1.34 7.78c-1.43 1.43-4.53.79-7.78-1.34c-3.25 2.13-6.35 2.77-7.78 1.34c-1.43-1.43-.79-4.53 1.34-7.78c-2.13-3.25-2.77-6.35-1.34-7.78m11.32 4.24c.61.62 1.17 1.25 1.69 1.88c1.38-2.13 1.88-3.96 1.13-4.7c-.74-.75-2.57-.25-4.7 1.13c.63.52 1.26 1.08 1.88 1.69m-7.08 7.08c-.61-.62-1.17-1.25-1.69-1.88c-1.38 2.13-1.88 3.96-1.13 4.7c.74.75 2.57.25 4.7-1.13c-.63-.52-1.26-1.08-1.88-1.69m-2.82-9.9c-.75.74-.25 2.57 1.13 4.7c.52-.63 1.08-1.26 1.69-1.88c.62-.61 1.25-1.17 1.88-1.69c-2.13-1.38-3.96-1.88-4.7-1.13m4.24 8.48c.7.7 1.42 1.34 2.12 1.91c.7-.57 1.42-1.21 2.12-1.91c.7-.7 1.34-1.42 1.91-2.12c-.57-.7-1.21-1.42-1.91-2.12c-.7-.7-1.42-1.34-2.12-1.91c-.7.57-1.42 1.21-2.12 1.91c-.7.7-1.34 1.42-1.91 2.12c.57.7 1.21 1.42 1.91 2.12m8.48 4.24c.75-.74.25-2.57-1.13-4.7c-.52.63-1.08 1.26-1.69 1.88c-.62.61-1.25 1.17-1.88 1.69c2.13 1.38 3.96 1.88 4.7 1.13Z"/>'
        },
        "atom-variant": {
            body: '<path fill="currentColor" d="M18.36 2.64c1.64 0 3 1.36 3 3c0 1.65-1.36 3-3 3c-1.65 0-3-1.35-3-3c0-.3.05-.58.14-.84c-1.07-.51-2.25-.8-3.5-.8a8 8 0 0 0-8 8l.04.84l-1.99.21L2 12A10 10 0 0 1 12 2c1.69 0 3.28.42 4.67 1.16c.49-.33 1.07-.52 1.69-.52m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1c.56 0 1-.45 1-1c0-.56-.44-1-1-1M5.64 15.36c1.65 0 3 1.35 3 3c0 .3-.05.58-.14.84c1.07.51 2.25.8 3.5.8a8 8 0 0 0 8-8l-.04-.84l1.99-.21L22 12a10 10 0 0 1-10 10c-1.69 0-3.28-.42-4.67-1.16c-.49.33-1.07.52-1.69.52c-1.64 0-3-1.36-3-3c0-1.65 1.36-3 3-3m0 2c-.56 0-1 .45-1 1c0 .56.44 1 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        attachment: {
            body: '<path fill="currentColor" d="M7.5 18A5.5 5.5 0 0 1 2 12.5A5.5 5.5 0 0 1 7.5 7H18a4 4 0 0 1 4 4a4 4 0 0 1-4 4H9.5A2.5 2.5 0 0 1 7 12.5A2.5 2.5 0 0 1 9.5 10H17v1.5H9.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1H18a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 18 8.5H7.5a4 4 0 0 0-4 4a4 4 0 0 0 4 4H17V18H7.5Z"/>'
        },
        "attachment-check": {
            body: '<path fill="currentColor" d="M16.61 13.5c-.8.35-1.5.86-2.07 1.5H9.5a2.5 2.5 0 0 1 0-5H17v1.5H9.5c-.55 0-1 .45-1 1s.45 1 1 1h7.11m-13.11-1c0-2.21 1.79-4 4-4H18a2.495 2.495 0 0 1 1.45 4.53c.6.04 1.18.17 1.72.38c.52-.67.83-1.5.83-2.41c0-2.21-1.79-4-4-4H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18h5.59c.09-.53.25-1.03.46-1.5H7.5c-2.21 0-4-1.79-4-4m17.84 3.34l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "attachment-lock": {
            body: '<path fill="currentColor" d="M18 13c-1.4 0-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3v-1.5c0-1.4-1.4-2.5-2.8-2.5m0 1.2c.8 0 1.5.5 1.5 1.3V17h-3v-1.5c0-.8.7-1.3 1.5-1.3M7.5 5C4.5 5 2 7.5 2 10.5S4.5 16 7.5 16h5.7v-.5c0-.3 0-.7.1-1H7.5c-2.2 0-4-1.8-4-4s1.8-4 4-4H18c1.4 0 2.5 1.1 2.5 2.5c0 .9-.5 1.7-1.3 2.2c.6.1 1.1.4 1.6.7c.8-.8 1.2-1.8 1.2-2.9c0-2.2-1.8-4-4-4H7.5m2 3C8.1 8 7 9.1 7 10.5S8.1 13 9.5 13H14c.5-.7 1.1-1.2 1.8-1.5H9.5c-.6 0-1-.4-1-1s.4-1 1-1H17V8H9.5Z"/>'
        },
        "attachment-minus": {
            body: '<path fill="currentColor" d="M16.61 13.5c-.8.35-1.5.86-2.07 1.5H9.5a2.5 2.5 0 0 1 0-5H17v1.5H9.5c-.55 0-1 .45-1 1s.45 1 1 1h7.11m-13.11-1c0-2.21 1.79-4 4-4H18a2.495 2.495 0 0 1 1.45 4.53c.6.04 1.18.17 1.72.38c.52-.67.83-1.5.83-2.41c0-2.21-1.79-4-4-4H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18h5.59c.09-.53.25-1.03.46-1.5H7.5c-2.21 0-4-1.79-4-4M15 18v2h8v-2h-8Z"/>'
        },
        "attachment-off": {
            body: '<path fill="currentColor" d="M17 10v1.5h-2.3L13.2 10H17m1-1.5a2.5 2.5 0 0 1 0 5h-1.3l1.48 1.5c2.13-.11 3.82-1.85 3.82-4c0-2.21-1.79-4-4-4h-7.8l1.5 1.5H18m4.11 12.96l-1.27 1.27L16.11 18H7.5C4.46 18 2 15.54 2 12.5c0-2.33 1.45-4.31 3.5-5.12L1.11 3l1.28-1.27l19.72 19.73M8.5 12.5c0 .55.45 1 1 1h2.11l-2-2H9.5c-.55 0-1 .45-1 1m6.11 4l-1.5-1.5H9.5A2.5 2.5 0 0 1 7 12.5c0-1 .57-1.81 1.38-2.23L6.69 8.58A4.01 4.01 0 0 0 3.5 12.5c0 2.21 1.79 4 4 4h7.11Z"/>'
        },
        "attachment-plus": {
            body: '<path fill="currentColor" d="M7.5 16.5h6.05c-.21.47-.37.97-.46 1.5H7.5C4.46 18 2 15.54 2 12.5S4.46 7 7.5 7H18c2.21 0 4 1.79 4 4c0 .91-.31 1.74-.83 2.41c-.54-.21-1.12-.34-1.72-.38A2.495 2.495 0 0 0 18 8.5H7.5c-2.21 0-4 1.79-4 4s1.79 4 4 4m2-3c-.55 0-1-.45-1-1s.45-1 1-1H17V10H9.5a2.5 2.5 0 0 0 0 5h5.04a5.96 5.96 0 0 1 2.07-1.5H9.5M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "attachment-remove": {
            body: '<path fill="currentColor" d="M16.61 13.5c-.8.35-1.5.86-2.07 1.5H9.5a2.5 2.5 0 0 1 0-5H17v1.5H9.5c-.55 0-1 .45-1 1s.45 1 1 1h7.11m-13.11-1c0-2.21 1.79-4 4-4H18a2.495 2.495 0 0 1 1.45 4.53c.6.04 1.18.17 1.72.38c.52-.67.83-1.5.83-2.41c0-2.21-1.79-4-4-4H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18h5.59c.09-.53.25-1.03.46-1.5H7.5c-2.21 0-4-1.79-4-4m19.04 4.38l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        atv: {
            body: '<path fill="currentColor" d="M20 11c-.2 0-.4 0-.5.1L17.4 9H20V6l-3.7 1.9L13.4 5H9v2h3.6l2 2H11l-4 2l-2-2H0v2h4c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4l2 2h3l3.5-6.1l1 1c-.9.7-1.5 1.9-1.5 3.1c0 2.2 1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4M4 17c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "audio-input-rca": {
            body: '<path fill="currentColor" d="M11 6v6H5V6h2V2c0-.55.45-1 1-1s1 .45 1 1v4h2m-6 8v2c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82v-2H5m12-8V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2m-4 8v2c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82v-2h-6Z"/>'
        },
        "audio-input-stereo-minijack": {
            body: '<path fill="currentColor" d="M11 4V3c0-.55.45-1 1-1s1 .45 1 1v1h-2m2 5V5h-2v4H9v6c0 1.3.84 2.4 2 2.82V22h2v-4.18c1.16-.42 2-1.52 2-2.82V9h-2Z"/>'
        },
        "audio-input-xlr": {
            body: '<path fill="currentColor" d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m1.5 14.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5M9 12c0-.83-.67-1.5-1.5-1.5S6 11.17 6 12s.67 1.5 1.5 1.5S9 12.83 9 12m9 0c0-.83-.67-1.5-1.5-1.5S15 11.17 15 12s.67 1.5 1.5 1.5S18 12.83 18 12Z"/>'
        },
        "audio-video": {
            body: '<path fill="currentColor" d="M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h6v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m-6 5H4v-2h10v2m4 1a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2M6 15H4v-1h2v1m4 0H8v-1h2v1m4 0h-2v-1h2v1Z"/>'
        },
        "audio-video-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4 4H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h6v1c0 .6.4 1 1 1h1.1l3.7 3.7l1.3-1.2M6 15H4v-1h2v1m-2-3v-2h4.1l2 2H4m6 3H8v-1h2v1m2 0v-1h.1l1 1H12m2-5v.8l6.2 6.2c1-.1 1.8-.9 1.8-2V9c0-1.1-.9-2-2-2h-9.8l3 3h.8m4-1c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "augmented-reality": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m2 6h3c.6 0 1 .5 1 1v5H9.5v-1.5h-2V15H6v-5c0-.5.4-1 1-1m6 0h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4L18 15h-1.5l-.85-2H14.5v2H13V9m-5.5 1.5V12h2v-1.5h-2m7 0v1h2v-1h-2"/>'
        },
        aurora: {
            body: '<path fill="currentColor" d="M2 3c.55 0 1 .45 1 1v9h2V5c0-.55.45-1 1-1s1 .45 1 1v8h2V6c0-.55.45-1 1-1s1 .45 1 1v7h1.5c.17 0 .34 0 .5.05V7c0-.55.45-1 1-1s1 .45 1 1v8.5a2.5 2.5 0 0 1-2.5 2.5h-1c-.28 0-.5.22-.5.5s.22.5.5.5H17V8c0-.55.45-1 1-1s1 .45 1 1v11h2V9c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1H11.5a2.5 2.5 0 0 1 0-5h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H2c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1Z"/>'
        },
        "auto-download": {
            body: '<path fill="currentColor" d="M22 17v2H11v-2h11M19 4.5v5h3L16.5 15L11 9.5h3v-5h5M10.7 15H8.8l-.7-2H4.9l-.7 2H2.3l3.2-9h2l3.2 9m-3.05-3.35L6.5 8l-1.15 3.65h2.3Z"/>'
        },
        "auto-fix": {
            body: '<path fill="currentColor" d="M7.5 5.6L5 7l1.4-2.5L5 2l2.5 1.4L10 2L8.6 4.5L10 7L7.5 5.6m12 9.8L22 14l-1.4 2.5L22 19l-2.5-1.4L17 19l1.4-2.5L17 14l2.5 1.4M22 2l-1.4 2.5L22 7l-2.5-1.4L17 7l1.4-2.5L17 2l2.5 1.4L22 2m-8.66 10.78l2.44-2.44l-2.12-2.12l-2.44 2.44l2.12 2.12m1.03-5.49l2.34 2.34c.39.37.39 1.02 0 1.41L5.04 22.71c-.39.39-1.04.39-1.41 0l-2.34-2.34c-.39-.37-.39-1.02 0-1.41L12.96 7.29c.39-.39 1.04-.39 1.41 0Z"/>'
        },
        "auto-upload": {
            body: '<path fill="currentColor" d="M5.35 12.65L6.5 9l1.15 3.65M5.5 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L7.5 7M11 20h11v-2H11m3-2h5v-5h3l-5.5-5.5L11 11h3v5Z"/>'
        },
        autorenew: {
            body: '<path fill="currentColor" d="M12 6v3l4-4l-4-4v3a8 8 0 0 0-8 8c0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.9 5.9 0 0 1 6 12a6 6 0 0 1 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.8.7 2.8a6 6 0 0 1-6 6v-3l-4 4l4 4v-3a8 8 0 0 0 8-8c0-1.57-.46-3.03-1.24-4.26Z"/>'
        },
        "autorenew-off": {
            body: '<path fill="currentColor" d="M18 12c0-1-.26-1.96-.7-2.8l1.46-1.46A7.93 7.93 0 0 1 20 12c0 1.39-.36 2.68-1 3.82l-1.5-1.5c.32-.72.5-1.49.5-2.32M2.39 1.73L1.11 3L5.5 7.37C4.55 8.68 4 10.27 4 12c0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.9 5.9 0 0 1 6 12c0-1.17.34-2.26.92-3.19l8.27 8.27c-.93.58-2.02.92-3.19.92v-3l-4 4l4 4v-3c1.73 0 3.32-.55 4.63-1.5l4.21 4.23l1.27-1.27L2.39 1.73M12 6v2.8l.1.1L16 5l-4-4v3c-1.38 0-2.68.36-3.82 1l1.5 1.5c.72-.32 1.5-.5 2.32-.5Z"/>'
        },
        "av-timer": {
            body: '<path fill="currentColor" d="M11 17a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1m0-14v4h2V5.08c3.39.49 6 3.39 6 6.92a7 7 0 0 1-7 7a7 7 0 0 1-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41l-6.8-6.8v.02C4.42 6.45 3 9.05 3 12a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m6 9a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1M6 12a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1Z"/>'
        },
        awning: {
            body: '<path fill="currentColor" d="M5.06 7c-.43 0-.84.14-1.22.42c-.38.28-.6.64-.7 1.08l-1.03 4.41c-.25 1.09-.05 2.01.58 2.82c.12.12.24.24.35.34c.59.57 1.24.93 2.18.93c.94 0 1.69-.41 2.25-.95c.63.62 1.39.95 2.33.95c.84 0 1.64-.37 2.2-.93c.68.63 1.45.93 2.3.93c.87 0 1.61-.33 2.24-.95c.57.57 1.32.95 2.27.95s1.62-.35 2.19-.94c.09-.09.18-.19.28-.29c.66-.82.86-1.77.61-2.86L20.86 8.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 7H5.06Z"/>'
        },
        "awning-outline": {
            body: '<path fill="currentColor" d="M5.06 7c-.43 0-.84.14-1.22.42c-.38.28-.6.64-.7 1.08l-1.03 4.41c-.25 1.09-.05 2.01.58 2.82c.12.12.24.24.35.34c.59.57 1.24.93 2.18.93c.94 0 1.69-.41 2.25-.95c.63.62 1.39.95 2.33.95c.84 0 1.64-.37 2.2-.93c.68.63 1.45.93 2.3.93c.87 0 1.61-.33 2.24-.95c.57.57 1.32.95 2.27.95s1.62-.35 2.19-.94c.09-.09.18-.19.28-.29c.66-.82.86-1.77.61-2.86L20.86 8.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 7H5.06m13.83 1.97l1.08 4.41c.09.43 0 .82-.28 1.17c-.25.31-.56.45-.94.45c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 9l1.92-.03M5.06 9h1.97l-.61 4.84C6.3 14.63 5.91 15 5.25 15c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17L5.06 9m3.99 0H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41c-.23-.29-.34-.59-.34-.93v-.16L9.05 9M13 9h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38a1.29 1.29 0 0 1-.36-.92V9Z"/>'
        },
        aws: {
            body: '<path fill="currentColor" d="M7.64 10.38c0 .25.02.45.07.62c.05.12.12.28.21.46c.04.04.05.1.05.15c0 .07-.04.13-.13.2l-.42.28c-.06.04-.12.06-.17.06c-.07 0-.13-.04-.2-.1c-.09-.1-.17-.2-.24-.31c-.06-.11-.13-.24-.2-.39c-.52.61-1.17.92-1.96.92c-.56 0-1-.16-1.33-.48c-.32-.32-.49-.75-.49-1.29c0-.55.2-1 .6-1.36c.41-.34.95-.52 1.63-.52c.23 0 .44.02.71.06c.23.03.5.08.76.14v-.48c0-.51-.1-.84-.31-1.07c-.22-.21-.57-.3-1.08-.3c-.24 0-.48.03-.72.08c-.25.06-.49.13-.72.23c-.11.04-.2.07-.23.08c-.05.02-.08.02-.11.02c-.09 0-.14-.06-.14-.2v-.33c0-.1.01-.18.05-.23c.03-.05.09-.09.18-.12c.24-.14.51-.24.84-.32a3.9 3.9 0 0 1 1.04-.13c.79 0 1.37.18 1.74.54c.37.36.55.91.55 1.64v2.15h.02m-2.7 1.02c.22 0 .44-.04.68-.12c.24-.08.45-.23.63-.43c.11-.13.19-.27.25-.43c0-.16.05-.35.05-.58v-.27c-.2-.07-.4-.07-.62-.12a6.89 6.89 0 0 0-.62-.04c-.45 0-.77.09-.99.27c-.22.18-.32.43-.32.76c0 .32.07.56.24.71c.16.17.39.25.7.25m5.34.71a.58.58 0 0 1-.28-.06c-.03-.05-.08-.14-.12-.26L8.32 6.65c-.04-.15-.06-.22-.06-.27c0-.11.05-.17.16-.17h.65c.13 0 .22.02.26.07c.06.04.1.13.14.26l1.11 4.4l1.04-4.4c.03-.13.07-.22.13-.26c.05-.04.14-.07.25-.07h.55c.12 0 .21.02.26.07c.05.04.1.13.13.26L14 11l1.14-4.46c.04-.13.09-.22.13-.26c.06-.04.14-.07.26-.07h.62c.11 0 .17.06.17.17c0 .03-.01.07-.02.12c0 0-.02.08-.04.15l-1.61 5.14c-.04.14-.08.21-.15.26c-.04.04-.13.07-.24.07h-.57c-.13 0-.19-.02-.27-.07a.45.45 0 0 1-.12-.26L12.27 7.5l-1.03 4.28c-.03.13-.07.22-.12.27a.49.49 0 0 1-.27.06h-.57m8.55.18c-.33 0-.7-.04-1.03-.12c-.33-.08-.59-.17-.76-.26a.496.496 0 0 1-.21-.19a.392.392 0 0 1-.04-.18v-.34c0-.14.05-.2.15-.2h.12c.04 0 .1.05.17.08c.22.1.47.18.73.23c.27.05.54.08.79.08c.42 0 .75-.07.97-.22c.23-.17.35-.36.35-.63c0-.19-.07-.34-.18-.47c-.12-.12-.35-.24-.67-.34l-.97-.3c-.48-.16-.84-.38-1.06-.68a1.58 1.58 0 0 1-.33-.97c0-.28.06-.52.18-.73c.12-.22.28-.4.46-.55c.22-.15.44-.26.71-.34c.26-.08.54-.12.84-.12c.14 0 .29.01.45.03c.14.02.28.05.42.07c.14.04.26.07.38.11c.12.04.2.08.28.12c.09.05.16.1.2.16c.04.06.06.13.06.22v.32c0 .14-.05.21-.15.21c-.05 0-.14-.03-.26-.08c-.37-.17-.8-.26-1.27-.26c-.38 0-.66.06-.89.19c-.2.12-.31.32-.31.59c0 .19.07.35.2.47c.13.13.38.25.73.37l.95.3c.48.14.82.36 1.03.64c.2.27.3.58.3.93c0 .28-.06.54-.17.77c-.12.22-.28.42-.5.58c-.19.17-.44.29-.72.38c-.28.09-.62.13-.95.13m1.25 3.24C17.89 17.14 14.71 18 12 18c-3.85 0-7.3-1.42-9.91-3.77c-.21-.19-.02-.44.23-.29c2.82 1.63 6.29 2.62 9.89 2.62c2.43 0 5.1-.5 7.55-1.56c.37-.15.68.26.32.53M21 14.5c-.29-.37-1.86-.18-2.57-.1c-.21.03-.24-.16-.05-.3c1.25-.87 3.31-.6 3.54-.33c.24.3-.06 2.36-1.23 3.34c-.19.15-.36.07-.28-.11c.27-.68.86-2.16.59-2.5Z"/>'
        },
        axe: {
            body: '<path fill="currentColor" d="m12 2l10 6c0 4-2 6-6 7l-3-5l-4-4l3-4M4.11 19.84l-1.99-1.51L9.19 9L11 10.81l-6.89 9.03Z"/>'
        },
        "axe-battle": {
            body: '<path fill="currentColor" d="M21.47 12.43c-2.12 2.12-5.65 1.41-5.65 1.41V9.6L3.41 22L2 20.59L14.4 8.18h-4.24s-.71-3.53 1.41-5.65c2.12-2.124 5.66-1.42 5.66-1.42v4.25l.71-.71l1.41 1.41l-.71.71h4.25s.7 3.54-1.42 5.66Z"/>'
        },
        axis: {
            body: '<path fill="currentColor" d="m2.61 21l-1-1.73L11 13.85V3h2v10.85l9.39 5.42l-1 1.73L12 15.58L2.61 21Z"/>'
        },
        "axis-arrow": {
            body: '<path fill="currentColor" d="m12 2l4 4h-3v7.85l6.53 3.76L21 15.03l1.5 5.47l-5.5 1.46l1.53-2.61L12 15.58l-6.53 3.77L7 21.96L1.5 20.5L3 15.03l1.47 2.58L11 13.85V6H8l4-4Z"/>'
        },
        "axis-arrow-info": {
            body: '<path fill="currentColor" d="m12 2l4 4h-3v7.85l6.53 3.76L21 15.03l1.5 5.47l-5.5 1.46l1.53-2.61L12 15.58l-6.53 3.77L7 21.96L1.5 20.5L3 15.03l1.47 2.58L11 13.85V6H8l4-4m9 3h-2V3h2v2m1 5v2h-4v-2h1V8h-1V6h3v4h1Z"/>'
        },
        "axis-arrow-lock": {
            body: '<path fill="currentColor" d="M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V5h3M1.74 19.25l1.47-5.46l1.47 2.55L9 13.85V6H6l4-4l4 4h-3v7.85l7.03 4.01l1.47-2.58l1.5 5.46l-5.5 1.47l1.53-2.61L10 15.58l-4.32 2.49l1.53 2.64l-5.47-1.46Z"/>'
        },
        "axis-lock": {
            body: '<path fill="currentColor" d="M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V5h3M11 13.82l9.39 5.43l-1 1.75L10 15.56L3.17 19.5l-1-1.73L9 13.82V3h2v10.82Z"/>'
        },
        "axis-x-arrow": {
            body: '<path fill="currentColor" d="M1.5 20.5L3 15.03l1.46 2.57L11 13.82V3h2v10.82l9.39 5.43l-1 1.75L12 15.56l-6.54 3.77L7 21.96L1.5 20.5Z"/>'
        },
        "axis-x-arrow-lock": {
            body: '<path fill="currentColor" d="M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3c-.69 0-1.31.38-1.46 1c-.04.09-.04.19-.04.3V5h3M1.74 19.25l1.47-5.46l1.46 2.53L9 13.82V3h2v10.82l9.39 5.43l-1 1.75L10 15.56l-4.33 2.5l1.54 2.65l-5.47-1.46Z"/>'
        },
        "axis-x-rotate-clockwise": {
            body: '<path fill="currentColor" d="M12 10h2.91C14.57 6.55 13.4 4 12 4c-1.58 0-2.88 3.27-3 7.42l-2 1.15V12C7 6.5 9.24 2 12 2c2.42 0 4.44 3.44 4.9 8H20l-4 4l-4-4m0 12c-1.88 0-3.53-2.08-4.38-5.16l1.75-1.01C9.87 18.31 10.86 20 12 20c1.27 0 2.36-2.11 2.79-5.08l1.21 1.2l.7-.7C16 19.26 14.16 22 12 22m-9.89-3.13l-1-1.74l-.05-.07l10.06-5.81l1.6 1.59l-10.57 6.1l-.04-.07M21.89 5.13l1 1.74L19.2 9h-1.43l-.27-1.34l4.39-2.53Z"/>'
        },
        "axis-x-rotate-counterclockwise": {
            body: '<path fill="currentColor" d="m12 14l4-4l4 4h-3.1c-.46 4.56-2.48 8-4.9 8c-1.88 0-3.53-2.08-4.38-5.16l1.75-1.01C9.87 18.31 10.86 20 12 20c1.4 0 2.57-2.55 2.91-6H12M1.11 17.13l12.78-7.38l.07.79L10.5 14h.04l-8.43 4.87l-1-1.74m20.78-12l1 1.74l-5.01 2.89c-.09-.73-.21-1.43-.38-2.1l4.39-2.53M12 2c2.3 0 4.23 3.1 4.82 7.32L16 8.5l-1.13 1.13C14.5 6.37 13.35 4 12 4c-1.58 0-2.88 3.27-3 7.42l-2 1.15V12C7 6.5 9.24 2 12 2Z"/>'
        },
        "axis-x-y-arrow-lock": {
            body: '<path fill="currentColor" d="M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V5h3M1.74 19.25l1.47-5.46l1.47 2.55L9 13.85V3h2v10.85l6.53 3.76L19 15.03l1.5 5.47l-5.5 1.46l1.53-2.61L10 15.58l-4.32 2.49l1.53 2.64l-5.47-1.46Z"/>'
        },
        "axis-y-arrow": {
            body: '<path fill="currentColor" d="M22.5 20.5L17 21.96l1.53-2.61L12 15.58L2.61 21l-1-1.73L11 13.85V3h2v10.85l6.53 3.76L21 15.03l1.5 5.47Z"/>'
        },
        "axis-y-arrow-lock": {
            body: '<path fill="currentColor" d="m11 13.82l7 4.06l1.5-2.6l1.5 5.46l-5.5 1.47l1.5-2.6l-7-4.05l-6.83 3.94l-1-1.73L9 13.82V3h2v10.82M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V5h3Z"/>'
        },
        "axis-y-rotate-clockwise": {
            body: '<path fill="currentColor" d="m12 10l4 4l4-4h-3.1c-.46-4.56-2.48-8-4.9-8c-1.88 0-3.53 2.08-4.38 5.16l1.75 1.01C9.87 5.69 10.86 4 12 4c1.4 0 2.57 2.55 2.91 6H12M1.11 6.87l12.78 7.38l.07-.79L10.5 10h.04L2.11 5.13l-1 1.74m20.78 12l1-1.74l-5.01-2.89c-.09.73-.21 1.43-.38 2.1l4.39 2.53M12 22c2.3 0 4.23-3.1 4.82-7.32l-.82.82l-1.13-1.13C14.5 17.63 13.35 20 12 20c-1.58 0-2.88-3.27-3-7.42l-2-1.15V12c0 5.5 2.24 10 5 10Z"/>'
        },
        "axis-y-rotate-counterclockwise": {
            body: '<path fill="currentColor" d="M12 14h2.91c-.34 3.45-1.51 6-2.91 6c-1.58 0-2.88-3.27-3-7.42l-2-1.15V12c0 5.5 2.24 10 5 10c2.42 0 4.44-3.44 4.9-8H20l-4-4l-4 4m0-12c-1.88 0-3.53 2.08-4.38 5.16l1.75 1.01C9.87 5.69 10.86 4 12 4c1.27 0 2.36 2.11 2.79 5.08L16 7.88l.7.7C16 4.74 14.16 2 12 2M2.11 5.13l-1 1.74l-.05.07l10.06 5.81l1.6-1.59l-10.57-6.1l-.04.07m19.78 13.74l1-1.74L19.2 15h-1.43l-.27 1.34l4.39 2.53Z"/>'
        },
        "axis-z-arrow": {
            body: '<path fill="currentColor" d="m12 2l4 4h-3v7.82l9.39 5.43l-1 1.75L12 15.56L2.61 21l-1-1.75L11 13.82V6H8l4-4Z"/>'
        },
        "axis-z-arrow-lock": {
            body: '<path fill="currentColor" d="M21.8 5c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3V6.2c0-.6.6-1.2 1.2-1.2V3.5C16.2 2.1 17.6 1 19 1s2.8 1.1 2.8 2.5V5m-1.3 0V3.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V5h3M10 2l4 4h-3v7.82l9.39 5.43l-1 1.75L10 15.56L3.17 19.5l-1-1.73L9 13.82V6H6l4-4Z"/>'
        },
        "axis-z-rotate-clockwise": {
            body: '<path fill="currentColor" d="m14 12l-4 4l4 4v-3.1c4.56-.46 8-2.48 8-4.9c0-2.42-3.44-4.44-8-4.9v1.99c3.45.34 6 1.51 6 2.91c0 1.4-2.55 2.57-6 2.91V12M4 12c0-1.4 2.55-2.57 6-2.91V7.1c-4.56.46-8 2.48-8 4.9c0 2.16 2.74 4 6.58 4.7l-.7-.7l1.2-1.21C6.11 14.36 4 13.27 4 12m9-10h-2v11l2-2V2m0 20v-1l-2-2v3h2Z"/>'
        },
        "axis-z-rotate-counterclockwise": {
            body: '<path fill="currentColor" d="m10 12l4 4l-4 4v-3.1c-4.56-.46-8-2.48-8-4.9c0-2.42 3.44-4.44 8-4.9v1.99C6.55 9.43 4 10.6 4 12c0 1.4 2.55 2.57 6 2.91V12m10 0c0-1.4-2.55-2.57-6-2.91V7.1c4.56.46 8 2.48 8 4.9c0 2.16-2.74 4-6.58 4.7l.7-.7l-1.2-1.21C17.89 14.36 20 13.27 20 12M11 2h2v11l-2-2V2m0 20v-1l2-2v3h-2Z"/>'
        },
        babel: {
            body: '<path fill="currentColor" d="M15.14 2c-1.34.12-3.1.59-5.27 1.43c-.59.44-1.27.87-2.03 1.29v.13c.06 0 .12-.04.2-.08c.09-.01.15.02.15.11l.13-.08l.07-.01l.01.07c.01.06-.47.43-1.4 1.1l.06.13H7l-.16-.05c0 .05-.06.07-.2.08l.01.07l.16.18c-.06 0-.13-.01-.21-.05c-.31.03-.6.26-.91.68l.08.12c.26-.24.41-.36.45-.36l.02.19c-.04 0-.12.05-.2.08l.16.24c.3-.34.66-.63 1.04-.86c.19.05.29.09.29.17l.14-.01c1.02-.76 2.04-1.3 3.04-1.64l.01.13c-.19.28-.32.44-.39.44c.01.09.05.17.1.24c.02.18-.43 1.32-1.36 3.45c-2.12 4.94-3.88 8.59-5.3 10.97c0 .04.03.11.08.19c.35-.09.57-.17.65-.25l.1-.01l.01.13l.13-.01l.14-.08c0 .05.05.06.12.05l.03.13c0 .14-.07.34-.23.61c-.15.16-.3.5-.46 1.02V22h.13c.57-.65 1.03-1.28 1.31-1.89c1.66-.49 2.93-.96 3.81-1.44c.88-.07 1.56-.3 2.02-.67l-.01-.09l-.33.09h-.08l-.01-.05c.65-.1 1.1-.25 1.32-.45c1.29-.96 2.24-1.65 2.89-2.06c2-1.47 2.94-2.89 2.83-4.23c-.01-.14-.46-.71-1.32-1.65c-.02-.18.29-.44.9-.79l1.73-1.53c.39-.5.62-1.3.7-2.41l-.03-.26c-.06-.78-.62-1.41-1.7-1.89c-.62-.43-1.74-.65-3.36-.68m2.1.87c1.29.05 1.95.27 1.99.68l-.05.13l-1.94-.81M16 3.96c.89-.01 1.35.22 1.4.72l.1-.01v-.33l.14-.01c.36.17.52.41.54.67c.02.2-.08.42-.29.69c-.09.01-.14-.05-.15-.19h-.14l-.04.41c-.56.87-1 1.32-1.26 1.35c-.24.32-.39.49-.45.49c-.18.22-.68.6-1.5 1.12c-.27.03-1.28.41-3.01 1.17c-.09-.04-.18-.04-.28-.04l-.01-.12c-.02-.26.09-.57.34-.96c.11-.71.28-1.12.44-1.22l1.45-3.26c-.01-.2.29-.35.93-.44l.21-.04l.02.19c.62-.1 1.01-.15 1.16-.15c.14-.03.28-.04.4-.04m3 .33h.04c.12.01.24.21.37.62l.01.12c-.07.01-.2-.2-.39-.62L19 4.29m-8.18 2.07h.06l.02.19c-.06.01-.15.1-.25.28l-.01-.13c.12-.15.18-.27.18-.34m-4.15.1l.01.04c-.05 0-.12.06-.18.1l-.09.01l-.02-.11l.28-.04m3.57 1.26l.02.28h-.07l-.03-.27l.08-.01m-.17.47c-.02.22-.07.31-.18.34l-.07.01c.08-.15.12-.25.11-.33l.14-.02m-.29.68l.01.06l-.12.21l-.13.01l-.01-.06c.13-.01.19-.09.18-.21l.07-.01m-.28.63l-.05.31h-.07l-.02-.31h.14m7.07.22l.28.17c.01.11-.03.14-.12.15a.585.585 0 0 0-.29-.11l-.01-.2l.14-.01m-5.57.74l.03.12l-.27.03l-.01-.11l.25-.04m4.5.45c.18.09.28.18.29.25l.01.06c-.19.02-.35-.08-.51-.29l.21-.02m2.16.21c.15.06.22.13.23.19l.04.51c-.06.14-.12.21-.19.21l-.08-.91m-3.5.06c.7-.01 1.24.15 1.6.5l.03.26c-.29.91-.66 1.44-1.04 1.6L13 14.93c-1.3.86-2 1.28-2.1 1.29c-2.07 1.14-3.36 1.73-3.86 1.78h-.08c.07-.24.99-2.13 2.77-5.67c.77-.07 2.03-.44 3.71-1.1l.41-.04c.11 0 .21-.01.31-.01m-2.54.41l.01.06l-.28.02l-.01-.06l.28-.02m-4.36 4.22c-.09.45-.18.69-.26.69l-.03-.07c-.02-.23.08-.43.29-.62m5.92.28l.01.12c.01.06-.19.22-.59.51c-1.16.57-1.84.96-2.04 1.16c-1.26.44-1.88.71-1.87.81c-1.12.45-1.85.77-2.19.97c-.09.01-.21-.03-.37-.1c-.01-.22.08-.41.31-.56c.19 0 .38 0 .56.09c.21-.09.57-.22 1.08-.35l-.01-.13l-.41.04c.05-.07.45-.25 1.2-.56l.21-.02l.01.06c-.35.03-.55.14-.58.33c0 .07.03.12.12.11c.25-.18.38-.27.38-.3c.5-.09 1.9-.83 4.18-2.18m-6.32.6l.01.06c.01.09-.04.14-.13.15v-.06c-.01-.08.03-.13.12-.15m3.14.81c.07-.03.12 0 .12.08c-.16.02-.47.15-.93.42h-.07l-.01-.13c.33-.03.62-.16.86-.37H10m-3.05 1l.01.08c-.06 0-.12.03-.21.08l-.13.01c-.01-.06.03-.12.12-.14l.21-.03m-1.6.8l.15.06c-.06.4-.17.6-.37.64a.745.745 0 0 0-.43-.11l-.02-.19c-.01-.08.04-.13.14-.15c.08-.01.13.05.14.18c.24-.29.37-.43.39-.43Z"/>'
        },
        baby: {
            body: '<path fill="currentColor" d="M18.5 4A2.5 2.5 0 0 1 21 6.5A2.5 2.5 0 0 1 18.5 9A2.5 2.5 0 0 1 16 6.5A2.5 2.5 0 0 1 18.5 4m-14 16A1.5 1.5 0 0 1 3 18.5A1.5 1.5 0 0 1 4.5 17h7a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5h-7m11.59-1l-1.4-4H11l-4.25-4.25S9 8.25 12.5 8.25c3 0 3.35 1 3.56 1.62L18.92 18c.28.78-.14 1.64-.92 1.92c-.78.27-1.64-.14-1.91-.92Z"/>'
        },
        "baby-bottle": {
            body: '<path fill="currentColor" d="m11.28 2.8l-.5.5a5.5 5.5 0 0 0-4.37-.43l-.08-.07A2.5 2.5 0 0 0 2.8 6.33l.07.08a5.5 5.5 0 0 0 .43 4.37l-.5.5a1.5 1.5 0 0 0 0 2.12l1.41 1.42a1.5 1.5 0 0 0 2.12 0l.35-.36l7.08 7.07a1.5 1.5 0 0 0 2.12 0l5.65-5.65a1.5 1.5 0 0 0 0-2.12l-7.07-7.08l.36-.35a1.5 1.5 0 0 0 0-2.12L13.4 2.8a1.5 1.5 0 0 0-2.12 0m2.48 2.47l-8.49 8.49l-1.41-1.42l8.48-8.48m2.48 7.77l-3.19 3.19l-1.06-1.06l3.19-3.19m3.18 3.19l-3.18 3.18l-1.07-1.06l3.19-3.19Z"/>'
        },
        "baby-bottle-outline": {
            body: '<path fill="currentColor" d="m11.28 2.8l-.5.5c-1.34-.75-2.94-.9-4.37-.43l-.08-.07c-.97-.98-2.56-.98-3.53 0s-.98 2.56 0 3.53l.07.08c-.47 1.43-.32 3.03.43 4.37l-.5.5a1.49 1.49 0 0 0 0 2.12l1.41 1.42c.59.58 1.53.58 2.12 0l.35-.36l7.08 7.07c.58.59 1.53.59 2.12 0l5.65-5.65c.59-.59.59-1.54 0-2.13l-7.07-7.07l.36-.35c.58-.59.58-1.53 0-2.12L13.4 2.79a1.5 1.5 0 0 0-2.12.01M4.25 7.05c.08-.34.22-.67.41-.98l-.8-.8a.854.854 0 0 1-.23-.37c-.13-.34-.06-.76.23-1.04s.7-.36 1.04-.23c.14.04.26.12.37.23l.8.8c.31-.19.64-.33.98-.41c.86-.25 1.78-.19 2.6.17L4.42 9.65c-.36-.82-.42-1.74-.17-2.6m16.22 7.77l-5.65 5.65l-7.07-7.07l5.65-5.65l7.07 7.07m-6.71-9.55l-8.49 8.49l-1.41-1.42l8.48-8.48l1.42 1.41m1.06 6.36l-3.19 3.19l-1.06-1.06l3.19-3.19l1.06 1.06m2.12 2.13l-3.18 3.18l-1.07-1.06l3.19-3.19l1.06 1.07Z"/>'
        },
        "baby-buggy": {
            body: '<path fill="currentColor" d="M17 20a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2M7 20a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2M17.61 3c-.66 0-1.17.2-1.61.5c-.68.41-1.12 1.09-1.53 1.57L5.71 15.35C5.16 16 5.62 17 6.47 17H14a2 2 0 0 0 2-2V6.38c.58-.68.93-1.38 1.61-1.38c.77 0 1.39.66 1.39 1.5V7h2v-.5C21 4.56 19.5 3 17.61 3m-8.75.09c-1.82.07-3.63.67-5.18 1.81l4.76 4.76l3.88-4.56c.27-.32.59-.72.98-1.1a9.58 9.58 0 0 0-3.65-.91c-.26-.01-.53-.01-.79 0Z"/>'
        },
        "baby-buggy-off": {
            body: '<path fill="currentColor" d="M17 20c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2M5 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2m17.11 3.46L2.39 1.73L1.11 3l8.17 8.17l-3.57 4.18C5.16 16 5.62 17 6.47 17H14c.32 0 .62-.08.89-.22l5.95 5.95l1.27-1.27M16 12.8V6.38c.58-.68.93-1.38 1.61-1.38c.77 0 1.39.66 1.39 1.5V7h2v-.5C21 4.56 19.5 3 17.61 3c-.66 0-1.17.2-1.61.5c-.68.41-1.12 1.09-1.53 1.57l-2.85 3.35L16 12.8m-3.68-7.7c.27-.32.59-.72.98-1.1a9.58 9.58 0 0 0-3.65-.91c-.26-.01-.53-.01-.79 0c-.74.03-1.48.17-2.2.37l3.81 3.81l1.85-2.17Z"/>'
        },
        "baby-carriage": {
            body: '<path fill="currentColor" d="M13 2v8h8a8 8 0 0 0-8-8m6.32 13.89A7.948 7.948 0 0 0 21 11H6.44L5.5 9H2v2h2.22s1.89 4.07 2.12 4.42C5.24 16 4.5 17.17 4.5 18.5A3.5 3.5 0 0 0 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3a3.5 3.5 0 0 0 3.5-3.5c0-1.04-.46-1.97-1.18-2.61M8 20a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 8 17a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 8 20m9 0a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 17 17a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 17 20Z"/>'
        },
        "baby-carriage-off": {
            body: '<path fill="currentColor" d="M22 10c0-4.4-3.6-8-8-8v8h8m-7.8 1H22c0 1.8-.6 3.5-1.7 4.9c.7.6 1.1 1.5 1.2 2.4L14.2 11m6.6 11.7l1.3-1.3L2.4 1.7L1.1 3l8 8H7.4l-.9-2H3v2h2.2s1.9 4.1 2.1 4.4c-1 .5-1.7 1.5-1.8 2.6c-.3 1.9 1.1 3.7 3 4c1.9.3 3.7-1.1 4-3h2.1c.1.4.2.8.4 1.2c.9 1.7 3.1 2.3 4.7 1.4l1.1 1.1m-10.3-4.2c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5S8.2 17 9 17s1.5.7 1.5 1.5m7.6 1.5c-.9 0-1.6-.7-1.6-1.5v-.1l1.6 1.6Z"/>'
        },
        "baby-face": {
            body: '<path fill="currentColor" d="M1 12c0-1.81 1.2-3.34 2.86-3.83A8.974 8.974 0 0 1 12 3a9 9 0 0 1 8.15 5.17C21.8 8.66 23 10.19 23 12s-1.2 3.34-2.85 3.83A9 9 0 0 1 12 21c-3.6 0-6.71-2.11-8.14-5.17A3.99 3.99 0 0 1 1 12m13.5-2.75a1.25 1.25 0 0 0-1.25 1.25a1.25 1.25 0 0 0 1.25 1.25a1.25 1.25 0 0 0 1.25-1.25a1.25 1.25 0 0 0-1.25-1.25m-5 0a1.25 1.25 0 0 0-1.25 1.25a1.25 1.25 0 0 0 1.25 1.25a1.25 1.25 0 0 0 1.25-1.25A1.25 1.25 0 0 0 9.5 9.25M7.5 14c.76 1.77 2.5 3 4.5 3s3.74-1.23 4.5-3h-9M3 12c0 .82.5 1.53 1.21 1.84C4.07 13.25 4 12.63 4 12c0-.63.07-1.25.21-1.84C3.5 10.47 3 11.18 3 12m18 0c0-.82-.5-1.53-1.21-1.84c.14.59.21 1.21.21 1.84c0 .63-.07 1.25-.21 1.84C20.5 13.53 21 12.82 21 12Z"/>'
        },
        "baby-face-outline": {
            body: '<path fill="currentColor" d="M14.5 9.25a1.25 1.25 0 0 1 1.25 1.25a1.25 1.25 0 0 1-1.25 1.25a1.25 1.25 0 0 1-1.25-1.25a1.25 1.25 0 0 1 1.25-1.25m-5 0a1.25 1.25 0 0 1 1.25 1.25a1.25 1.25 0 0 1-1.25 1.25a1.25 1.25 0 0 1-1.25-1.25A1.25 1.25 0 0 1 9.5 9.25M7.5 14h9c-.76 1.77-2.5 3-4.5 3s-3.74-1.23-4.5-3M1 12c0-1.81 1.2-3.34 2.86-3.83A8.974 8.974 0 0 1 12 3a9 9 0 0 1 8.15 5.17C21.8 8.66 23 10.19 23 12s-1.2 3.34-2.85 3.83A9 9 0 0 1 12 21c-3.6 0-6.71-2.11-8.14-5.17A3.99 3.99 0 0 1 1 12m11-7a7.02 7.02 0 0 0-6.72 5H5a2 2 0 0 0-2 2a2 2 0 0 0 2 2h.28c.86 2.88 3.54 5 6.72 5a7.02 7.02 0 0 0 6.72-5H19a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-.28A7.02 7.02 0 0 0 12 5Z"/>'
        },
        backburger: {
            body: '<path fill="currentColor" d="m5 13l4 4l-1.4 1.42L1.18 12L7.6 5.58L9 7l-4 4h16v2H5m16-7v2H11V6h10m0 10v2H11v-2h10Z"/>'
        },
        backspace: {
            body: '<path fill="currentColor" d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-3 12.59L17.59 17L14 13.41L10.41 17L9 15.59L12.59 12L9 8.41L10.41 7L14 10.59L17.59 7L19 8.41L15.41 12"/>'
        },
        "backspace-outline": {
            body: '<path fill="currentColor" d="M19 15.59L17.59 17L14 13.41L10.41 17L9 15.59L12.59 12L9 8.41L10.41 7L14 10.59L17.59 7L19 8.41L15.41 12L19 15.59M22 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7c-.69 0-1.23-.36-1.59-.89L0 12l5.41-8.12C5.77 3.35 6.31 3 7 3h15m0 2H7l-4.72 7L7 19h15V5Z"/>'
        },
        "backspace-reverse": {
            body: '<path fill="currentColor" d="M2 21h15c.7 0 1.2-.4 1.6-.9L24 12l-5.4-8.1c-.4-.5-.9-.9-1.6-.9H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2M5 8.4L6.4 7l3.6 3.6L13.6 7L15 8.4L11.4 12l3.6 3.6l-1.4 1.4l-3.6-3.6L6.4 17L5 15.6L8.6 12"/>'
        },
        "backspace-reverse-outline": {
            body: '<path fill="currentColor" d="M5 15.59L6.41 17L10 13.41L13.59 17L15 15.59L11.41 12L15 8.41L13.59 7L10 10.59L6.41 7L5 8.41L8.59 12L5 15.59M2 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h15c.69 0 1.23-.36 1.59-.89L24 12l-5.41-8.12C18.23 3.35 17.69 3 17 3H2m0 2h15l4.72 7L17 19H2V5Z"/>'
        },
        "backup-restore": {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0-9 9H0l4 4l4-4H5a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.5 0-2.91-.5-4.06-1.3L6.5 19.14A9.115 9.115 0 0 0 12 21a9 9 0 0 0 9-9a9 9 0 0 0-9-9m2 9a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2Z"/>'
        },
        bacteria: {
            body: '<path fill="currentColor" d="M21 16c0-.5-.05-.92-.12-1.32l1.57-.78l-.9-1.8l-1.37.69c-.55-.83-1.27-1.29-1.89-1.51l.66-1.96l-1.9-.64l-.76 2.28c-1.33-.13-2.12-.64-2.59-1.19l1.75-.87l-.9-1.8l-1.55.79a4.39 4.39 0 0 0-.72-2.02l1.55-2.32l-1.66-1.11l-1.41 2.12c-.48-.23-1.06-.41-1.76-.5V2H7v2.1c-.71.15-1.27.44-1.68.81L2.7 2.29L1.29 3.71l2.95 2.94C4 7.39 4 8 4 8H2v2h2.04c.06.63.17 1.36.36 2.15l-2.72.9l.63 1.9l2.69-.9c.24.51.5 1.03.82 1.53l-2.38 1.59l1.11 1.66l2.52-1.68c.56.56 1.22 1.06 1.99 1.49l-.96 1.91l1.79.9l1-2l-.16-.09c.95.32 2.03.54 3.27.61V22h2v-2.07c.76-.09 1.81-.29 2.77-.74l1.52 1.52l1.41-1.42l-1.33-1.34c.38-.51.63-1.15.63-1.95M8.5 11A1.5 1.5 0 0 1 7 9.5A1.5 1.5 0 0 1 8.5 8A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 8.5 11m2.5 3a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m4.5 3a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "bacteria-outline": {
            body: '<path fill="currentColor" d="M9 2H7v2.1c-.71.15-1.27.44-1.68.81L2.7 2.29L1.29 3.71l2.95 2.94C4 7.39 4 8 4 8H2v2h2.04c.06.63.17 1.36.36 2.15l-2.72.9l.63 1.9l2.69-.9c.24.51.5 1.03.82 1.53l-2.38 1.59l1.11 1.66l2.52-1.68c.56.56 1.22 1.06 1.99 1.49l-.96 1.91l1.79.9l1-2l-.16-.09c.95.32 2.03.54 3.27.61V22h2v-2.07c.76-.09 1.81-.29 2.77-.74l1.52 1.52l1.41-1.42l-1.33-1.34c.38-.51.63-1.15.63-1.95c0-.5-.05-.92-.12-1.32l1.57-.78l-.9-1.8l-1.37.69c-.55-.83-1.27-1.29-1.89-1.51l.66-1.96l-1.9-.64l-.76 2.28c-1.33-.13-2.12-.64-2.59-1.19l1.75-.87l-.9-1.8l-1.55.79a4.39 4.39 0 0 0-.72-2.02l1.55-2.32l-1.66-1.11l-1.41 2.12c-.48-.23-1.06-.41-1.76-.5M15 18c-2.94 0-5.19-.82-6.69-2.44C5.68 12.72 6 8.2 6 8.17v-.14C6 7.1 6.39 6 8 6c2.63 0 2.97 1.43 3 2c0 2 1.6 5 6 5c.33 0 2 .15 2 3c0 1.89-3.97 2-4 2M8.5 8A1.5 1.5 0 0 0 7 9.5A1.5 1.5 0 0 0 8.5 11A1.5 1.5 0 0 0 10 9.5A1.5 1.5 0 0 0 8.5 8m2.5 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m4.5 2a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "badge-account": {
            body: '<path fill="currentColor" d="M17 3h-3v3h-4V3H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5 5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1M13 5h-2V1h2v4m3 14H8v-1h8v1m-4 2H8v-1h4v1Z"/>'
        },
        "badge-account-alert": {
            body: '<path fill="currentColor" d="M15 3h-3v3H8V3H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5 5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H6v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1M11 5H9V1h2v4m3 14H6v-1h8v1m-4 2H6v-1h4v1m9-8V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "badge-account-alert-outline": {
            body: '<path fill="currentColor" d="M15 3h-3v2h3v16H5V5h3V3H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H6v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m0 3H6v-1h8v1m-4 2H6v-1h4v1m1-15H9V1h2v4m8 8V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "badge-account-horizontal": {
            body: '<path fill="currentColor" d="M22 4h-8v3h-4V4H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M8 9a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H4v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m8 1h-6v-2h6v2m0-4h-6v-2h6v2m0-4h-6V8h6v2m-7-4h-2V2h2v4Z"/>'
        },
        "badge-account-horizontal-outline": {
            body: '<path fill="currentColor" d="M8 9a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H4v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m8-9h-6v2h6V8m0 4h-6v2h6v-2m0 4h-6v2h6v-2m2-12h-8v2h8v14H2V6h8V4H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-9 2h-2V2h2v4Z"/>'
        },
        "badge-account-outline": {
            body: '<path fill="currentColor" d="M17 3h-3v2h3v16H7V5h3V3H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4 8H8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m0 3H8v-1h8v1m-4 2H8v-1h4v1m1-15h-2V1h2v4Z"/>'
        },
        badminton: {
            body: '<path fill="currentColor" d="M12.3 2c-.97.03-1.72.84-1.69 1.8c.01.24.06.47.16.7l.29.64c.04.13-.03.27-.17.31c-.09.05-.19 0-.26-.08l-.42-.55c-.33-.42-.83-.68-1.36-.69c-.97-.02-1.77.75-1.79 1.71c-.01.42.13.82.39 1.16l.42.5h.01c.08.13.05.29-.06.37c-.09.07-.21.07-.29 0L7 7.45c-.34-.26-.75-.4-1.16-.39c-.96.02-1.73.82-1.71 1.79c.01.53.27 1.03.69 1.36l.57.44c.11.1.11.26-.01.35a.23.23 0 0 1-.26.05h-.01l-.61-.28c-.23-.09-.46-.15-.7-.16c-.96-.03-1.77.73-1.8 1.7c0 .72.4 1.38 1.06 1.66l11.39 5.07l4.59-4.59l-5.07-11.39C13.69 2.39 13 1.97 12.3 2m.83 4.1c.42-.01.8.23.96.61l3.05 6.84l-3.95-3.94l-.93-2.11c-.3-.63.16-1.38.87-1.4M9.85 8.85c.27 0 .52.1.71.3l4.81 4.81c.4.38.41 1.01.03 1.41c-.4.4-1.02.41-1.44 0l-4.81-4.81a.987.987 0 0 1-.02-1.41c.19-.2.45-.3.72-.3m-2.72 3.32c.13 0 .27.04.37.09l2.13.94l3.94 3.94l-6.86-3.05c-1.02-.44-.68-1.95.42-1.92m13.15 3.87l-4.24 4.24l.85.85c.76.75 1.86 1.04 2.89.77a3.024 3.024 0 0 0 2.12-2.12c.27-1.03-.02-2.13-.77-2.89l-.85-.85Z"/>'
        },
        "bag-carry-on": {
            body: '<path fill="currentColor" d="M14.6 21.4c.4.4.8.6 1.4.6s1-.2 1.4-.6s.6-.8.6-1.4s-.2-1-.6-1.4s-.9-.6-1.4-.6s-1 .2-1.4.6s-.6.8-.6 1.4s.2 1 .6 1.4M6 19c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6V7c-.5 0-1 .2-1.4.6C6.2 8 6 8.5 6 9v10M16 2h-4c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6v3H9v14h4.2c-.2-.5-.2-.8-.2-1c0-.8.3-1.5.9-2.1c.6-.6 1.3-.9 2.1-.9V2Z"/>'
        },
        "bag-carry-on-check": {
            body: '<path fill="currentColor" d="m15.28 16.69l2.86-2.81l.7.7l-3.56 3.56L13.17 16l.71-.72l1.4 1.41M8 21a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2v14M9 7h5V4a2 2 0 0 1-2-2h4v8a6 6 0 0 1 6 6a6 6 0 0 1-6 6c-1.23 0-2.37-.37-3.32-1H9V7m7 5a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "bag-carry-on-off": {
            body: '<path fill="currentColor" d="m2.1 4.9l3.9 4V19c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6V10.8l1 1V21h4.2c-.1-.4-.2-.8-.2-1c0-1.2.5-2 1.6-2.6l.8.8c-.9.3-1.3 1-1.3 1.9c0 .5.2 1 .6 1.4c.3.3.8.5 1.3.5c.9 0 1.6-.4 1.9-1.3l1.2 1.2l1.4-1.4l-17-17l-1.4 1.4M12 2c0 .5.2 1 .6 1.4s.9.6 1.4.6v3H9.8l6.2 6.2V2h-4Z"/>'
        },
        "bag-checked": {
            body: '<path fill="currentColor" d="M22 19H2v2h20v-2M4 15c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6V6c-.5 0-1 .2-1.4.6C4.2 7 4 7.5 4 8v7m9.5-9h-3c0-.4.1-.8.4-1.1c.3-.3.6-.4 1.1-.4c.4 0 .8.1 1.1.4c.2.3.4.7.4 1.1M7 6v11h10V6h-2c0-.8-.3-1.5-.9-2.1S12.8 3 12 3s-1.5.3-2.1.9C9.3 4.5 9 5.2 9 6H7m11 11c.5 0 1-.2 1.4-.6c.4-.4.6-.9.6-1.4V8c0-.5-.2-1-.6-1.4c-.4-.4-.9-.6-1.4-.6v11Z"/>'
        },
        "bag-personal": {
            body: '<path fill="currentColor" d="M16 5V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1a4 4 0 0 0-4 4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a4 4 0 0 0-4-4m-6-1h4v1h-4V4m2 5l2 2l-2 2l-2-2l2-2m6 7H9v2H8v-2H6v-1h12v1Z"/>'
        },
        "bag-personal-off": {
            body: '<path fill="currentColor" d="M20 19.35L2.38 1.73L1.11 3l3.66 3.66C4.27 7.34 4 8.16 4 9v11a2 2 0 0 0 2 2h12c.56 0 1.08-.24 1.46-.65l1.38 1.38l1.27-1.27L20 19.35M9 16v2H8v-2H6v-1h7.11l1 1H9m11-7a4 4 0 0 0-4-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.8l12 12V9m-6-4h-4V4h4v1Z"/>'
        },
        "bag-personal-off-outline": {
            body: '<path fill="currentColor" d="M20 19.35L2.38 1.73L1.11 3l3.66 3.66C4.27 7.34 4 8.16 4 9v11a2 2 0 0 0 2 2h12c.56 0 1.08-.24 1.46-.65l1.38 1.38l1.27-1.27L20 19.35M6 9c0-.31.08-.62.22-.89L13.11 15H6V9m12 11H6v-4h2v2h1v-2h5.11L18 19.89V20M16 7a2 2 0 0 1 2 2v5.8l2 2V9a4 4 0 0 0-4-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.8L10.2 7H16m-6-3h4v1h-4V4Z"/>'
        },
        "bag-personal-outline": {
            body: '<path fill="currentColor" d="M16 5V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1a4 4 0 0 0-4 4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a4 4 0 0 0-4-4m-6-1h4v1h-4V4m2 5l2 2l-2 2l-2-2l2-2m6 11H6v-4h2v2h1v-2h9v4m0-5H6V9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6Z"/>'
        },
        "bag-personal-tag": {
            body: '<path fill="currentColor" d="M14 5V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v1C3.8 5 2 6.8 2 9v11c0 1.1.9 2 2 2h11.2l-2.4-2.4c-.6-.5-.9-1.3-.9-2V16H7v2H6v-2H4v-1h8v-.2c0-1.5 1.2-2.8 2.8-2.8H18V9c0-2.2-1.8-4-4-4m-4 8l-2-2l2-2l2 2l-2 2m2-8H8V4h4v1m9.8 12.8l-3.6-3.6c-.2-.1-.4-.2-.6-.2h-2.8c-.4 0-.8.4-.8.8v2.8c0 .2.1.4.2.6l3.6 3.6c.1.1.3.2.6.2s.4-.1.6-.2l2.8-2.8c.1-.1.2-.3.2-.6c0-.2-.1-.4-.2-.6m-6-1.3c-.4 0-.7-.3-.8-.7c0-.4.3-.7.7-.7c.4 0 .7.3.8.7c0 .4-.3.7-.7.7Z"/>'
        },
        "bag-personal-tag-outline": {
            body: '<path fill="currentColor" d="M14 5V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v1C3.8 5 2 6.8 2 9v11c0 1.1.9 2 2 2h11.2l-2-2H4v-4h2v2h1v-2h5v-1H4V9c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v3h2V9c0-2.2-1.8-4-4-4m-2 0H8V4h4v1m-2 4l-2 2l2 2l2-2l-2-2m11.8 8.8l-3.6-3.6c-.2-.1-.4-.2-.6-.2h-2.8c-.4 0-.8.4-.8.8v2.8c0 .2.1.4.2.6l3.6 3.6c.1.1.3.2.6.2s.4-.1.6-.2l2.8-2.8c.1-.1.2-.3.2-.6c0-.2-.1-.4-.2-.6m-6-1.3c-.4 0-.7-.3-.8-.7c0-.4.3-.7.7-.7c.4 0 .7.3.8.7c0 .4-.3.7-.7.7Z"/>'
        },
        "bag-suitcase": {
            body: '<path fill="currentColor" d="M17.03 6C18.11 6 19 6.88 19 8v11c0 1.13-.89 2-1.97 2c0 .58-.47 1-1.03 1c-.5 0-1-.42-1-1H9c0 .58-.5 1-1 1c-.56 0-1.03-.42-1.03-1C5.89 21 5 20.13 5 19V8c0-1.12.89-2 1.97-2H9V3c0-.58.46-1 1-1h4c.54 0 1 .42 1 1v3h2.03M13.5 6V3.5h-3V6h3M8 9v9h1.5V9H8m6.5 0v9H16V9h-1.5m-3.25 0v9h1.5V9h-1.5Z"/>'
        },
        "bag-suitcase-off": {
            body: '<path fill="currentColor" d="M2 4.77L3.28 3.5L21 21.22l-1.27 1.28L18 20.76c-.29.17-.62.24-.97.24c0 .58-.47 1-1.03 1c-.5 0-1-.42-1-1H9c0 .58-.5 1-1 1c-.56 0-1.03-.42-1.03-1C5.89 21 5 20.13 5 19V7.77l-3-3M17.03 6C18.11 6 19 6.88 19 8v8.68l-3-3V9h-1.5v3.18l-1.75-1.75V9h-1.43L8.31 6H9V3c0-.58.46-1 1-1h4c.54 0 1 .42 1 1v3h2.03M8 18h1.5v-5.73L8 10.77V18m3.25 0h1.5v-2.5l-1.5-1.5v4m3.25 0h.73l-.73-.73V18m-1-12V3.5h-3V6h3Z"/>'
        },
        "bag-suitcase-off-outline": {
            body: '<path fill="currentColor" d="M2 4.77L3.28 3.5L21 21.22l-1.27 1.28L18 20.76c-.29.17-.62.24-.97.24c0 .58-.47 1-1.03 1c-.5 0-1-.42-1-1H9c0 .58-.5 1-1 1c-.56 0-1.03-.42-1.03-1C5.89 21 5 20.13 5 19V7.78L2 4.77M9.5 18H8v-7.22L6.97 9.74V19h9.26l-.98-1h-.75v-.74l-1.75-1.76V18h-1.5v-4L9.5 12.28V18m3.25-9v1.43L11.32 9h1.43m1.75 0H16v4.67l-1.5-1.5V9m2.53-3C18.11 6 19 6.88 19 8v8.68l-1.97-1.98V8h-6.7L8.31 6H9V3c0-.58.46-1 1-1h4c.54 0 1 .42 1 1v3h2.03M10.5 3.5V6h3V3.5h-3Z"/>'
        },
        "bag-suitcase-outline": {
            body: '<path fill="currentColor" d="M9.5 18V9H8v9m4.75 0V9h-1.5v9M16 18V9h-1.5v9m2.53-12C18.11 6 19 6.88 19 8v11c0 1.13-.89 2-1.97 2c0 .58-.47 1-1.03 1c-.5 0-1-.42-1-1H9c0 .58-.5 1-1 1c-.56 0-1.03-.42-1.03-1C5.89 21 5 20.13 5 19V8c0-1.12.89-2 1.97-2H9V3c0-.58.46-1 1-1h4c.54 0 1 .42 1 1v3m-4.5-2.5V6h3V3.5M17.03 19V8H6.97v11"/>'
        },
        baguette: {
            body: '<path fill="currentColor" d="M5 22c-1.32 0-1.85-2.36-1.96-3.3a5.56 5.56 0 0 1 .32-2.7a2.5 2.5 0 0 1 1.87-1.62c1.17-.2 2 .5 3.06.74a1.21 1.21 0 0 0 1.56-1.37C9.41 12.03 6.28 12 5 12c0-1.86 2.04-2.1 3.5-1.96a10.8 10.8 0 0 1 2.54.56c.5.17 1.08.6 1.63.56c.83-.07 1-.93.64-1.56C12.44 8.12 9.97 8 8.5 8c0-2 1.73-2.38 3.39-2.08a11.58 11.58 0 0 1 2.49.79c.51.22 1.12.64 1.68.45c1.44-.44-.06-1.98-.7-2.35a6.6 6.6 0 0 0-1.42-.58c-.54-.16-1.2-.1-.71-.73a5.13 5.13 0 0 1 2.73-1.24c1.89-.44 4.5-.52 4.96 1.86a5.3 5.3 0 0 1-.85 3.58a38.96 38.96 0 0 1-6.85 8.63a36.6 36.6 0 0 1-4.6 3.99C7.62 21.04 6.3 22 5 22Z"/>'
        },
        balcony: {
            body: '<path fill="currentColor" d="M10 10v2H8v-2h2m6 2v-2h-2v2h2m5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1M7 16H5v4h2v-4m4 0H9v4h2v-4m0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08M13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14m2 2h-2v4h2v-4m4 0h-2v4h2v-4Z"/>'
        },
        balloon: {
            body: '<path fill="currentColor" d="M13.16 12.74L14 14h-1.5c-.15 2.71-.5 5.41-1 8.08l-1-.16c.5-2.62.84-5.26 1-7.92H10l.84-1.26C8.64 11.79 7 8.36 7 6a5 5 0 0 1 5-5a5 5 0 0 1 5 5c0 2.36-1.64 5.79-3.84 6.74Z"/>'
        },
        ballot: {
            body: '<path fill="currentColor" d="M13 9.5h5v-2h-5v2m0 7h5v-2h-5v2m6 4.5H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M6 11h5V6H6v5m1-4h3v3H7V7M6 18h5v-5H6v5m1-4h3v3H7v-3Z"/>'
        },
        "ballot-outline": {
            body: '<path fill="currentColor" d="M13 7.5h5v2h-5v-2m0 7h5v2h-5v-2M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m0 16V5H5v14h14M11 6v5H6V6h5m-1 4V7H7v3h3m1 3v5H6v-5h5m-1 4v-3H7v3h3Z"/>'
        },
        "ballot-recount": {
            body: '<path fill="currentColor" d="M19 12v1.5a4 4 0 0 1 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12m0 11v-1.5a4 4 0 0 1-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23m-9-6H7v-3h3v3m0-10v3H7V7h3M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.17c-.5-.11-1-.17-1.5-.17a6.5 6.5 0 0 0-6.5 6.5c0 1.29.38 2.5 1 3.5H5m8-11.5h5v-2h-5v2M11 13H6v5h5v-5m0-7H6v5h5V6Z"/>'
        },
        "ballot-recount-outline": {
            body: '<path fill="currentColor" d="M6 18v-5h5v5H6m1-4v3h3v-3H7m6-6.5h5v2h-5v-2M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.17c-.5-.11-1-.17-1.5-.17H19V5H5v14h8.17c.17.72.46 1.39.83 2H5m6-15v5H6V6h5m-1 4V7H7v3h3m9 2v1.5a4 4 0 0 1 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12m0 11v-1.5a4 4 0 0 1-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23Z"/>'
        },
        bandage: {
            body: '<path fill="currentColor" d="m17.73 12l3.98-3.96c.39-.39.39-1.04 0-1.41l-4.34-4.34c-.37-.39-1.02-.39-1.41 0L12 6.27L8 2.29a1.001 1.001 0 0 0-1.41 0L2.25 6.63c-.39.37-.39 1.02 0 1.41L6.23 12l-3.98 4c-.39.39-.39 1 0 1.41l4.34 4.34c.41.39 1.02.39 1.41 0l4-3.98l3.96 3.98c.2.2.45.29.71.29c.26 0 .51-.1.71-.29l4.34-4.34c.39-.41.39-1.02 0-1.41l-3.99-4M12 9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4.71 1.96L3.66 7.34l3.63-3.63l3.62 3.62l-3.62 3.63M10 13a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m2 2a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m2-4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m2.66 9.34l-3.63-3.62l3.63-3.63l3.62 3.62l-3.62 3.63Z"/>'
        },
        bandcamp: {
            body: '<path d="M22 6l-6.5 12H2L8.5 6H22z" fill="currentColor"/>',
            hidden: true
        },
        bank: {
            body: '<path fill="currentColor" d="M11.5 1L2 6v2h19V6m-5 4v7h3v-7M2 22h19v-3H2m8-9v7h3v-7m-9 0v7h3v-7H4Z"/>'
        },
        "bank-check": {
            body: '<path fill="currentColor" d="m17.8 21.2l-2.8-3l1.2-1.2l1.6 1.6l3.6-3.6l1.2 1.4l-4.8 4.8M13 10h-3v7h2.1c.1-.8.5-1.6.9-2.3V10m3 0v2.3c.6-.2 1.3-.3 2-.3c.3 0 .7 0 1 .1V10h-3m-3.9 9H2v3h11.5c-.7-.8-1.2-1.9-1.4-3M21 6l-9.5-5L2 6v2h19V6M7 17v-7H4v7h3Z"/>'
        },
        "bank-minus": {
            body: '<path fill="currentColor" d="M14 17h8v2h-8v-2M11.5 1L21 6v2H2V6l9.5-5m4.5 9h3v2.08L18 12c-.7 0-1.37.12-2 .34V10M2 22v-3h10.08c.19 1.14.71 2.17 1.45 3H2m8-12h3v4.68c-.46.69-.78 1.47-.92 2.32H10v-7m-6 0h3v7H4v-7Z"/>'
        },
        "bank-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-.7-.7H2v-3h15.1L13 14.9V17h-3v-5.1L6.1 8H2V6l1.4-.7L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M4 10v7h3v-7H4m17-2V6l-9.5-5l-4.8 2.5L11.2 8H21m-2 7.8V10h-3v2.8l3 3Z"/>'
        },
        "bank-off-outline": {
            body: '<path fill="currentColor" d="M20.8 22.7L19.1 21H2v-2h15.1l-4.6-4.6V17h-2v-4.6L6.1 8H2V6l1.4-.7L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M4.5 10v7h2v-7h-2m7-6.7L16.7 6H9.2l2 2H21V6l-9.5-5l-4.8 2.5L8.2 5l3.3-1.7m7 12V10h-2v3.3l2 2Z"/>'
        },
        "bank-outline": {
            body: '<path fill="currentColor" d="M6.5 10h-2v7h2v-7m6 0h-2v7h2v-7m8.5 9H2v2h19v-2m-2.5-9h-2v7h2v-7m-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5Z"/>'
        },
        "bank-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M11.5 1L21 6v2H2V6l9.5-5m4.5 9h3v2.08L18 12c-.7 0-1.37.12-2 .34V10M2 22v-3h10.08c.19 1.14.71 2.17 1.45 3H2m8-12h3v4.68c-.46.69-.78 1.47-.92 2.32H10v-7m-6 0h3v7H4v-7Z"/>'
        },
        "bank-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M11.5 1L21 6v2H2V6l9.5-5m4.5 9h3v2.08L18 12c-.7 0-1.37.12-2 .34V10M2 22v-3h10.08c.19 1.14.71 2.17 1.45 3H2m8-12h3v4.68c-.46.69-.78 1.47-.92 2.32H10v-7m-6 0h3v7H4v-7Z"/>'
        },
        "bank-transfer": {
            body: '<path fill="currentColor" d="M15 14v-3h3V9l4 3.5l-4 3.5v-2h-3m-1-6.3V9H2V7.7L8 4l6 3.7M7 10h2v5H7v-5m-4 0h2v5H3v-5m10 0v2.5l-2 1.8V10h2m-3.9 6l-.6.5l1.7 1.5H2v-2h7.1m7.9-1v3h-3v2l-4-3.5l4-3.5v2h3Z"/>'
        },
        "bank-transfer-in": {
            body: '<path fill="currentColor" d="M2 15v-3h3v-2l4 3.5L5 17v-2H2m20-6.3V10H10V8.7L16 5l6 3.7M10 17h12v2H10v-2m5-6h2v5h-2v-5m-4 0h2v5h-2v-5m8 0h2v5h-2v-5Z"/>'
        },
        "bank-transfer-out": {
            body: '<path fill="currentColor" d="M15 15v-3h3v-2l4 3.5l-4 3.5v-2h-3m-1-6.3V10H2V8.7L8 5l6 3.7M2 17h12v2H2v-2m5-6h2v5H7v-5m-4 0h2v5H3v-5m8 0h2v5h-2v-5Z"/>'
        },
        barcode: {
            body: '<path fill="currentColor" d="M2 6h2v12H2V6m3 0h1v12H5V6m2 0h3v12H7V6m4 0h1v12h-1V6m3 0h2v12h-2V6m3 0h3v12h-3V6m4 0h1v12h-1V6Z"/>'
        },
        "barcode-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L16 17.89V18h-2v-2.11l-2-2V18h-1v-5.11l-1-1V18H7V8.89l-1-1V18H5V6.89L1.11 3l1.28-1.27L7 6.34l3 3l1 1l1 1l2 2.01v-.01l2 2v.01l1 1v-.01L18.66 18h-.01l3.46 3.46l-1.27 1.27M16 6h-2v4.8l2 2V6m-4 0h-1v1.8l1 1V6m8 0h-3v7.8l3 3V6m2 12V6h-1v11.8l.2.2h.8M10 6h-.8l.8.8V6M2 18h2V6H2v12Z"/>'
        },
        "barcode-scan": {
            body: '<path fill="currentColor" d="M4 6h2v12H4V6m3 0h1v12H7V6m2 0h3v12H9V6m4 0h1v12h-1V6m3 0h2v12h-2V6m3 0h1v12h-1V6M2 4v4H0V4a2 2 0 0 1 2-2h4v2H2m20-2a2 2 0 0 1 2 2v4h-2V4h-4V2h4M2 16v4h4v2H2a2 2 0 0 1-2-2v-4h2m20 4v-4h2v4a2 2 0 0 1-2 2h-4v-2h4Z"/>'
        },
        barley: {
            body: '<path fill="currentColor" d="M7.33 18.33c-.83-1.16-.83-2.5-.83-3.83c1.67 1 3.33 2 4.17 3.17l.33.56v-2.28c-1.5-.9-2.92-1.82-3.67-2.87c-.83-1.16-.83-2.5-.83-3.83c1.67 1 3.33 2 4.17 3.17L11 13v-2.3c-1.5-.9-2.92-1.82-3.67-2.87C6.5 6.67 6.5 5.33 6.5 4c1.67 1 3.33 2 4.17 3.17c.1.14.19.29.27.45c-.17-.62-.28-1.2-.29-1.8c-.01-1.51.65-3.06 1.31-4.61c.69 1.48 1.38 2.97 1.39 4.48c.01.63-.1 1.27-.28 1.9c.08-.14.16-.28.26-.42C14.17 6 15.83 5 17.5 4c0 1.33 0 2.67-.83 3.83C15.92 8.88 14.5 9.8 13 10.7V13l.33-.58c.84-1.17 2.5-2.17 4.17-3.17c0 1.33 0 2.67-.83 3.83c-.75 1.05-2.17 1.97-3.67 2.87v2.28l.33-.56c.84-1.17 2.5-2.17 4.17-3.17c0 1.33 0 2.67-.83 3.83c-.75 1.05-2.17 1.97-3.67 2.87V23h-2v-1.8c-1.5-.9-2.92-1.82-3.67-2.87Z"/>'
        },
        "barley-off": {
            body: '<path fill="currentColor" d="M11.96 1.21c-.66 1.55-1.32 3.1-1.31 4.61c.01.6.12 1.18.29 1.8a3.35 3.35 0 0 0-.27-.45C9.83 6 8.17 5 6.5 4c0 .8 0 1.59.18 2.36L13 12.68V10.7c1.5-.9 2.92-1.82 3.67-2.87c.83-1.16.83-2.5.83-3.83c-1.67 1-3.33 2-4.17 3.17c-.1.14-.18.28-.26.42c.18-.63.29-1.27.28-1.9c-.01-1.51-.7-3-1.39-4.48M3.28 5.5L2 6.77l4.64 4.64c.11.59.31 1.14.69 1.67c.75 1.05 2.17 1.97 3.67 2.87v2.28l-.33-.56c-.84-1.17-2.5-2.17-4.17-3.17c0 1.33 0 2.67.83 3.83c.75 1.05 2.17 1.97 3.67 2.87V23h2v-1.8c.74-.44 1.45-.89 2.07-1.36l3.66 3.66L20 22.22C14 16.23 9.1 11.32 3.28 5.5M17.5 9.25c-1.67 1-3.33 2-4.17 3.17l-.21.37L15 14.66c.67-.5 1.27-1.02 1.67-1.58c.83-1.16.83-2.5.83-3.83m0 5.25c-.57.34-1.12.68-1.65 1.03l1.44 1.44c.21-.8.21-1.64.21-2.47Z"/>'
        },
        barn: {
            body: '<path fill="currentColor" d="M12 3L3 8.2V21h6l2.9-3l3.1 3h6V8.2L12 3M7.9 20v-6l3 3l-3 3m1-7h6l-3 3l-3-3m7 7l-3-3l3-3v6m-.9-9H8.8V9H15v2Z"/>'
        },
        barrel: {
            body: '<path fill="currentColor" d="M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1m-8 3c-1.66 0-3-1.32-3-2.95c0-1.3.5-1.67 3-4.55c2.47 2.86 3 3.24 3 4.55c0 1.63-1.34 2.95-3 2.95Z"/>'
        },
        "barrel-outline": {
            body: '<path fill="currentColor" d="M9 13.05C9 14.68 10.34 16 12 16s3-1.32 3-2.95c0-1.31-.53-1.69-3-4.55c-2.5 2.88-3 3.25-3 4.55M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1m-3 6H7v-6c.55 0 1-.45 1-1s-.45-1-1-1V5h10v6c-.55 0-1 .45-1 1s.45 1 1 1v6Z"/>'
        },
        baseball: {
            body: '<path fill="currentColor" d="M12 2c-2.5 0-4.75.9-6.5 2.4c.5.41.91.87 1.3 1.36l1.09-.63l1 1.74l-1 .57c.56 1.09.93 2.29 1.06 3.56H10v2H8.95c-.13 1.27-.5 2.47-1.06 3.56l1 .57l-1 1.74l-1.09-.63c-.39.49-.8.95-1.3 1.36c1.75 1.5 4 2.4 6.5 2.4s4.75-.9 6.5-2.4c-.5-.41-.91-.87-1.31-1.36l-1.08.63l-1-1.74l1-.58A9.896 9.896 0 0 1 15.05 13H14v-2h1.05c.13-1.27.5-2.47 1.06-3.55l-1-.58l1-1.74l1.08.63c.4-.49.81-.95 1.31-1.36C16.75 2.9 14.5 2 12 2M4.12 5.85A9.936 9.936 0 0 0 2 12c0 2.32.79 4.45 2.12 6.15c.34-.28.64-.6.93-.93l-.62-.35l1-1.74l.73.43c.39-.79.66-1.65.77-2.56H6v-2h.93c-.11-.91-.38-1.77-.77-2.56l-.73.43l-1-1.74l.62-.35c-.29-.33-.59-.65-.93-.93m15.76 0c-.34.28-.64.6-.93.93l.62.35l-1 1.74l-.73-.43c-.39.79-.66 1.65-.77 2.56H18v2h-.93c.11.91.38 1.77.77 2.56l.73-.43l1 1.74l-.62.35c.29.33.59.65.93.93A9.936 9.936 0 0 0 22 12c0-2.32-.79-4.45-2.12-6.15Z"/>'
        },
        "baseball-bat": {
            body: '<path fill="currentColor" d="M20 2c-.28 0-.5.11-.71.29l-9.5 9.5c-.04.04-.07.08-2.56 3.56L4 18.59l-.29-.3C3.5 18.1 3.26 18 3 18c-.56 0-1 .44-1 1c0 .26.1.5.29.71l2 2c.39.4 1.02.41 1.42.03c.4-.39.41-1.02 0-1.45l-.3-.29l3.23-3.23l3.57-2.56l9.5-9.5c.39-.39.39-1.03 0-1.42l-1-1C20.5 2.1 20.26 2 20 2m-1.5 11a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "baseball-diamond": {
            body: '<path fill="currentColor" d="M5.79 12.79L2 9s4-6 10-6s10 6 10 6l-3.79 3.79L12 6.59l-6.21 6.2M13.5 18h-3v2l1.5 1l1.5-1v-2m3.29-3.79L14.2 16.8c-.6-.49-1.36-.8-2.2-.8s-1.6.31-2.2.8l-2.59-2.59L12 9.41l4.79 4.8M13 14c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1Z"/>'
        },
        "baseball-diamond-outline": {
            body: '<path fill="currentColor" d="M12 2C5 2 1 9 1 9l8.3 8.3c.44-.53 1.02-.93 1.7-1.13L7.83 13L12 8.83L16.17 13L13 16.17c.68.2 1.27.6 1.7 1.13L23 9s-4-7-11-7m5.59 9.59L12 6l-5.59 5.59l-2.82-2.83C4.95 7 7.89 4 12 4c4.08 0 7.03 3 8.4 4.77l-2.81 2.82M13 13c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1m.5 7L12 21l-1.5-1v-2h3v2Z"/>'
        },
        basecamp: {
            body: '<path d="M2 16.25s2-12.5 10-12.5s10 12.5 10 12.5s-2 4-10 4s-10-4-10-4m1.35-.6S4.3 19 12 19c5 0 8-1.2 8.65-3.15c.65-1.95-5-8.25-6-8.25S11.2 12 10.45 12c-2 0-1.55-2-3.3-2c-1.75 0-3.8 5.65-3.8 5.65z" fill="currentColor"/>',
            hidden: true
        },
        bash: {
            body: '<path fill="currentColor" d="M5 9h2.31l.32-3h2l-.32 3h2l.32-3h2l-.32 3H15v2h-1.9l-.2 2H15v2h-2.31l-.32 3h-2l.32-3h-2l-.32 3h-2l.32-3H5v-2h1.9l.2-2H5V9m4.1 2l-.2 2h2l.2-2M19 6h-2v8h2m0 2h-2v2h2Z"/>'
        },
        basket: {
            body: '<path fill="currentColor" d="M5.5 21c-.78 0-1.46-.45-1.79-1.1L1.1 10.44L1 10a1 1 0 0 1 1-1h4.58l4.6-6.57a.997.997 0 0 1 1.65.01L17.42 9H22a1 1 0 0 1 1 1l-.04.29l-2.67 9.61c-.33.65-1.01 1.1-1.79 1.1h-13M12 4.74L9 9h6l-3-4.26M12 13a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "basket-check": {
            body: '<path fill="currentColor" d="m21.63 16.27l-3.87 3.9l-1.35-1.37L15 20.22L17.75 23l5.28-5.32l-1.4-1.41M13 20c0-3.31 2.69-6 6-6c1 0 1.92.24 2.74.67l1.22-4.38L23 10c0-.55-.45-1-1-1h-4.58l-4.59-6.56a.997.997 0 0 0-1.65-.01L6.58 9H2c-.55 0-1 .45-1 1l.1.44l2.61 9.46c.33.65 1.01 1.1 1.79 1.1h7.59c-.05-.33-.09-.66-.09-1M12 4.74L15 9H9l3-4.26M10 15c0-1.1.9-2 2-2s2 .9 2 2s-.89 2-2 2s-2-.89-2-2Z"/>'
        },
        "basket-check-outline": {
            body: '<path fill="currentColor" d="m21.63 16.27l-3.87 3.9l-1.35-1.37L15 20.22L17.75 23l5.28-5.32l-1.4-1.41M14 15c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m-1 5c0-.34.04-.67.09-1H5.5l-2.19-8H20.7l-.84 3.07c.68.1 1.32.3 1.9.61l1.21-4.41L23 10c0-.55-.45-1-1-1h-4.79l-4.38-6.56a.997.997 0 0 0-1.66.01L6.79 9H2c-.55 0-1 .45-1 1c0 .09 0 .18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h7.59c-.05-.33-.09-.66-.09-1M12 4.8L14.8 9H9.2L12 4.8Z"/>'
        },
        "basket-fill": {
            body: '<path fill="currentColor" d="M3 2h3v3H3V2m3 5h3v3H6V7m2-5h3v3H8V2m9 9l-5-5h3V2h4v4h3l-5 5M7.5 22c-.78 0-1.46-.45-1.79-1.1L3.1 13.44L3 13a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1l-.04.29l-2.67 7.61c-.33.65-1.01 1.1-1.79 1.1h-9m.11-2h8.78l2.18-6H5.42l2.19 6Z"/>'
        },
        "basket-minus": {
            body: '<path fill="currentColor" d="M23 18v2h-8v-2h8m0-8l-.04.29L22 13.8a6.005 6.005 0 0 0-9 5.2c0 .7.13 1.37.35 2H5.5c-.78 0-1.46-.45-1.79-1.1L1.1 10.44L1 10c0-.55.45-1 1-1h4.58l4.6-6.57a.997.997 0 0 1 1.65.01L17.42 9H22c.55 0 1 .45 1 1m-9 5c0-1.1-.89-2-2-2s-2 .9-2 2s.9 2 2 2s2-.89 2-2m1-6l-3-4.26L9 9h6Z"/>'
        },
        "basket-minus-outline": {
            body: '<path fill="currentColor" d="M23 18v2h-8v-2h8m-11-5c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m1.35 8H5.5c-.92 0-1.69-.62-1.92-1.46l-2.54-9.27C1 10.18 1 10.09 1 10c0-.55.45-1 1-1h4.79l4.38-6.55a.997.997 0 0 1 1.66-.01L17.21 9H22c.55 0 1 .45 1 1l-.03.27l-.97 3.54c-.57-.31-1.21-.57-1.88-.7L20.7 11H3.31l2.19 8H13c0 .7.13 1.37.35 2M9.2 9h5.6L12 4.8L9.2 9Z"/>'
        },
        "basket-off": {
            body: '<path fill="currentColor" d="m23 10l-.04.29l-2.06 7.41L12.2 9H15l-3-4.26l-1.68 2.38l-1.43-1.43l2.29-3.26a.997.997 0 0 1 1.65.01L17.42 9H22c.55 0 1 .45 1 1m-.89 11.46l-1.27 1.27l-1.81-1.81c-.17.05-.35.08-.53.08h-13c-.78 0-1.46-.45-1.79-1.1L1.1 10.44L1 10c0-.55.45-1 1-1h4.58l.22-.31L1.11 3l1.28-1.27l19.72 19.73m-8.26-5.72l-2.59-2.59C10.5 13.44 10 14.16 10 15a2 2 0 0 0 2 2c.84 0 1.56-.5 1.85-1.26Z"/>'
        },
        "basket-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l5.81 5.81l-.13.19H2c-.55 0-1 .45-1 1c0 .09 0 .18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.18 0 .36-.04.53-.08l1.81 1.81l1.27-1.27L2.39 1.73M5.5 19l-2.19-8h5.8l2.15 2.15C10.5 13.44 10 14.16 10 15c0 1.1.9 2 2 2c.84 0 1.56-.5 1.85-1.26L17.11 19H5.5M23 10l-.03.27l-2.04 7.46l-1.63-1.63l1.4-5.1h-6.5l-2-2h2.6L12 4.8l-1.6 2.4l-1.44-1.44l2.21-3.31a.997.997 0 0 1 1.66-.01L17.21 9H22c.55 0 1 .45 1 1Z"/>'
        },
        "basket-outline": {
            body: '<path fill="currentColor" d="M22 9h-4.79l-4.38-6.56a.997.997 0 0 0-1.66.01L6.79 9H2c-.55 0-1 .45-1 1c0 .09 0 .18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1M12 4.8L14.8 9H9.2L12 4.8M18.5 19h-13l-2.19-8H20.7l-2.2 8M12 13c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2Z"/>'
        },
        "basket-plus": {
            body: '<path fill="currentColor" d="M20 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2m3-5l-.04.29L22 13.8a6.005 6.005 0 0 0-9 5.2c0 .7.13 1.37.35 2H5.5c-.78 0-1.46-.45-1.79-1.1L1.1 10.44L1 10c0-.55.45-1 1-1h4.58l4.6-6.57a.997.997 0 0 1 1.65.01L17.42 9H22c.55 0 1 .45 1 1m-9 5c0-1.1-.89-2-2-2s-2 .9-2 2s.9 2 2 2s2-.89 2-2m1-6l-3-4.26L9 9h6Z"/>'
        },
        "basket-plus-outline": {
            body: '<path fill="currentColor" d="M20 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2m-8-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m1.35 8H5.5c-.92 0-1.69-.62-1.92-1.46l-2.54-9.27C1 10.18 1 10.09 1 10c0-.55.45-1 1-1h4.79l4.38-6.55a.997.997 0 0 1 1.66-.01L17.21 9H22c.55 0 1 .45 1 1l-.03.27l-.97 3.54c-.57-.31-1.21-.57-1.88-.7L20.7 11H3.31l2.19 8H13c0 .7.13 1.37.35 2M9.2 9h5.6L12 4.8L9.2 9Z"/>'
        },
        "basket-remove": {
            body: '<path fill="currentColor" d="M22.54 16.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.13l1.42 1.42M23 10l-.04.29L22 13.8a6.005 6.005 0 0 0-9 5.2c0 .7.13 1.37.35 2H5.5c-.78 0-1.46-.45-1.79-1.1L1.1 10.44L1 10c0-.55.45-1 1-1h4.58l4.6-6.57a.997.997 0 0 1 1.65.01L17.42 9H22c.55 0 1 .45 1 1m-9 5c0-1.1-.89-2-2-2s-2 .9-2 2s.9 2 2 2s2-.89 2-2m1-6l-3-4.26L9 9h6Z"/>'
        },
        "basket-remove-outline": {
            body: '<path fill="currentColor" d="M22.54 16.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.13l1.42 1.42M12 13c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m1.35 8H5.5c-.92 0-1.69-.62-1.92-1.46l-2.54-9.27C1 10.18 1 10.09 1 10c0-.55.45-1 1-1h4.79l4.38-6.55a.997.997 0 0 1 1.66-.01L17.21 9H22c.55 0 1 .45 1 1l-.03.27l-.97 3.54c-.57-.31-1.21-.57-1.88-.7L20.7 11H3.31l2.19 8H13c0 .7.13 1.37.35 2M9.2 9h5.6L12 4.8L9.2 9Z"/>'
        },
        "basket-unfill": {
            body: '<path fill="currentColor" d="M3 10h3V7H3v3m2-5h3V2H5v3m3 5h3V7H8v3m9-9l-5 5h3v4h4V6h3l-5-5M7.5 22c-.78 0-1.46-.45-1.79-1.1L3.1 13.44L3 13a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1l-.04.29l-2.67 7.61c-.33.65-1.01 1.1-1.79 1.1h-9m.11-2h8.78l2.18-6H5.42l2.19 6Z"/>'
        },
        basketball: {
            body: '<path fill="currentColor" d="M2.34 14.63c.6-.22 1.22-.33 1.88-.33c1.34 0 2.51.42 3.51 1.26L4.59 18.7a10.61 10.61 0 0 1-2.25-4.07M15.56 9.8c1.97 1.47 4.1 1.83 6.38 1.08c.03.21.06.59.06 1.12c0 1.03-.25 2.18-.72 3.45c-.47 1.26-1.05 2.28-1.73 3.05l-6.33-6.31l2.34-2.39m-6.79 6.84c1.06 1.53 1.28 3.2.65 5.02c-1.42-.41-2.69-1.05-3.75-1.93l3.1-3.09m3.42-3.42l6.31 6.33c-2.17 1.9-4.72 2.7-7.62 2.39c.21-.66.32-1.38.32-2.16c0-.62-.14-1.35-.42-2.18c-.28-.83-.61-1.51-.98-2.04l2.39-2.34M8.81 14.5a6.695 6.695 0 0 0-3.23-1.59c-1.22-.23-2.39-.16-3.52.22c-.03-.22-.06-.6-.06-1.13c0-1.03.25-2.18.72-3.45c.47-1.26 1.05-2.28 1.73-3.05l6.66 6.69l-2.3 2.31m6.75-6.77c-1.34-1.65-1.65-3.45-.93-5.39c.62.16 1.33.46 2.13.92c.79.45 1.44.9 1.94 1.33l-3.14 3.14m6.1 1.65c-.6.21-1.22.32-1.88.32c-1.09 0-2.14-.32-3.14-.98l3.09-3.05c.88 1.1 1.52 2.33 1.93 3.71m-9.47 1.73L5.5 4.45c2.17-1.9 4.72-2.7 7.63-2.39c-.22.66-.33 1.38-.33 2.16c0 .72.16 1.53.49 2.44c.33.9.71 1.62 1.21 2.15l-2.31 2.3Z"/>'
        },
        "basketball-hoop": {
            body: '<path fill="currentColor" d="M21 2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2v-4h14v4h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-4 10h-2V9H9v3H7V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3M7 16v3.5L8 23l2-2l2 2l2-2l2 2l1-3.5V16H7Z"/>'
        },
        "basketball-hoop-outline": {
            body: '<path fill="currentColor" d="M21 2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3.57L8 23l2-2l2 2l2-2l2 2l1.43-5H21a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 14h-3v-2h-1V9a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H6v2H3V4h18v12M9 14V9h6v5H9Z"/>'
        },
        bat: {
            body: '<path fill="currentColor" d="M.75 8S5 7 8 9c0 0 .5 3.75 2.5 3.75V11s.5 1 1.5 1s1.5-1 1.5-1v1.75C15.5 12.75 16 9 16 9c3-2 7.25-1 7.25-1c-2 1-2.25 4.5-2.25 4.5c-4 0-4 3.25-4 3.25c-5-1-5 2.75-5 2.75s0-3.75-5-2.75c0 0 0-3.25-4-3.25C3 12.5 2.75 9 .75 8Z"/>'
        },
        bathtub: {
            body: '<path fill="currentColor" d="M7 5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m13 8V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08c-.41 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08c0-.18-.03-.34-.07-.5l1.25-1.26a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.23-.43-.38-.69-.5c-.31-.15-.65-.23-1-.23C6 10 5 11 5 12.25V13H2v6c0 1.1.9 2 2 2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1c1.1 0 2-.9 2-2v-6h-2Z"/>'
        },
        "bathtub-outline": {
            body: '<path fill="currentColor" d="M7 5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m13 8V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08c-.41 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08c0-.18-.03-.34-.07-.5l1.25-1.26a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.23-.43-.38-.69-.5c-.31-.15-.65-.23-1-.23C6 10 5 11 5 12.25V13H2v6c0 1.1.9 2 2 2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1c1.1 0 2-.9 2-2v-6h-2m0 6H4v-4h16v4Z"/>'
        },
        battery: {
            body: '<path fill="currentColor" d="M16.67 4H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-10": {
            body: '<path fill="currentColor" d="M16 18H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-10-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v12H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-20": {
            body: '<path fill="currentColor" d="M16 17H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-20-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v11H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-30": {
            body: '<path fill="currentColor" d="M16 15H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-30-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v9H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-40": {
            body: '<path fill="currentColor" d="M16 14H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-40-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v8H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-50": {
            body: '<path fill="currentColor" d="M16 13H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-50-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v7H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-60": {
            body: '<path fill="currentColor" d="M16 12H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-60-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v6H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-70": {
            body: '<path fill="currentColor" d="M16 10H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-70-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v4H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-80": {
            body: '<path fill="currentColor" d="M16 9H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-80-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v3H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-90": {
            body: '<path fill="currentColor" d="M16 8H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-90-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5M4 6h8v2H4V6m15 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-alert": {
            body: '<path fill="currentColor" d="M13 14h-2V8h2m0 10h-2v-2h2m3.7-12H15V2H9v2H7.3C6.6 4 6 4.6 6 5.3v15.3c0 .8.6 1.4 1.3 1.4h9.3c.7 0 1.3-.6 1.3-1.3V5.3c.1-.7-.5-1.3-1.2-1.3Z"/>'
        },
        "battery-alert-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.3C2.6 4 2 4.6 2 5.3v15.3c0 .8.6 1.4 1.3 1.4h9.3c.7 0 1.3-.6 1.3-1.3V5.3c.1-.7-.5-1.3-1.2-1.3H11V2H5m14 6v3.8l-2.3-2.3l-.7.7l2.8 2.8l-2.8 2.8l.7.7l2.3-2.3V18h.5l2.9-2.9l-2.2-2.1l2.1-2.1L19.5 8H19M7 8h2v6H7m13-4.1l.9.9l-.9 1V9.9m0 4.3l.9.9l-.9 1v-1.9M7 16h2v2H7v-2Z"/>'
        },
        "battery-alert-variant": {
            body: '<path fill="currentColor" d="M14.67 4H13V2H7v2H5.33C4.6 4 4 4.6 4 5.33v15.34C4 21.4 4.6 22 5.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33C16 4.6 15.4 4 14.67 4M21 13h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "battery-alert-variant-outline": {
            body: '<path fill="currentColor" d="M14 20H6V6h8m.67-2H13V2H7v2H5.33C4.6 4 4 4.6 4 5.33v15.34C4 21.4 4.6 22 5.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33C16 4.6 15.4 4 14.67 4M21 7h-2v6h2V8m0 7h-2v2h2v-2Z"/>'
        },
        "battery-arrow-down": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4m1.4-3.5l3 3l3-3h-2v-4h-2v4h-2"/>'
        },
        "battery-arrow-down-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2m1.4-3.5l3 3l3-3h-2v-4h-2v4h-2"/>'
        },
        "battery-arrow-up": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4m7.4-4.5l-3-3l-3 3h2v4h2v-4h2"/>'
        },
        "battery-arrow-up-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2m7.4-4.5l-3-3l-3 3h2v4h2v-4h2"/>'
        },
        "battery-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4H11V2H5m14 6v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "battery-bluetooth-variant": {
            body: '<path fill="currentColor" d="M9 2v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4H15V2H9m2.83 6h.5l2.85 2.85L13.04 13l2.13 2.14L12.33 18h-.5v-3.79L9.54 16.5l-.71-.71L11.62 13l-2.79-2.79l.71-.71l2.29 2.29V8m1 1.91v1.88l.94-.94l-.94-.94m0 4.3v1.87l.94-.94l-.94-.93Z"/>'
        },
        "battery-charging": {
            body: '<path fill="currentColor" d="M16.67 4H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.33C6 21.4 6.6 22 7.33 22h9.33c.74 0 1.34-.6 1.34-1.33V5.33C18 4.6 17.4 4 16.67 4M11 20v-5.5H9L13 7v5.5h2"/>'
        },
        "battery-charging-10": {
            body: '<path fill="currentColor" d="M23.05 11h-3V4l-5 10h3v8M12 18H4l.05-12h8m.67-2h-1.67V2h-6v2H3.38a1.33 1.33 0 0 0-1.33 1.33v15.34c0 .73.6 1.33 1.33 1.33h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.72 4Z"/>'
        },
        "battery-charging-100": {
            body: '<path fill="currentColor" d="M23 11h-3V4l-5 10h3v8M12.67 4H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4Z"/>'
        },
        "battery-charging-20": {
            body: '<path fill="currentColor" d="M23.05 11h-3V4l-5 10h3v8m-6-5h-8V6h8m.67-2h-1.67V2h-6v2H3.38a1.33 1.33 0 0 0-1.33 1.33v15.34c0 .73.6 1.33 1.33 1.33h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.72 4Z"/>'
        },
        "battery-charging-30": {
            body: '<path fill="currentColor" d="M12 15H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4M23 11h-3V4l-5 10h3v8l5-11Z"/>'
        },
        "battery-charging-40": {
            body: '<path fill="currentColor" d="M13 4h-2V2H5v2H3c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1m-1 10.5H4V6h8v8.5M23 11h-3V4l-5 10h3v8"/>'
        },
        "battery-charging-50": {
            body: '<path fill="currentColor" d="M23 11h-3V4l-5 10h3v8m-6-9H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4Z"/>'
        },
        "battery-charging-60": {
            body: '<path fill="currentColor" d="M12 11H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4M23 11h-3V4l-5 10h3v8l5-11Z"/>'
        },
        "battery-charging-70": {
            body: '<path fill="currentColor" d="M12 10H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4M23 11h-3V4l-5 10h3v8l5-11Z"/>'
        },
        "battery-charging-80": {
            body: '<path fill="currentColor" d="M23 11h-3V4l-5 10h3v8M12 9H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4Z"/>'
        },
        "battery-charging-90": {
            body: '<path fill="currentColor" d="M23 11h-3V4l-5 10h3v8M12 8H4V6h8m.67-2H11V2H5v2H3.33A1.33 1.33 0 0 0 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.67 4Z"/>'
        },
        "battery-charging-high": {
            body: '<path fill="currentColor" d="M12 20H4V6h8m.67-2H11V2H5v2H3.33C2.6 4 2 4.6 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C14 4.6 13.4 4 12.67 4M11 16H5v3h6v-3m0-9H5v3h6V7m0 4.5H5v3h6v-3M23 10h-3V3l-5 10h3v8"/>'
        },
        "battery-charging-low": {
            body: '<path fill="currentColor" d="M12 20H4V6h8m.67-2H11V2H5v2H3.33C2.6 4 2 4.6 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C14 4.6 13.4 4 12.67 4M11 16H5v3h6v-3m12-6h-3V3l-5 10h3v8"/>'
        },
        "battery-charging-medium": {
            body: '<path fill="currentColor" d="M12 20H4V6h8m.67-2H11V2H5v2H3.33C2.6 4 2 4.6 2 5.33v15.34C2 21.4 2.6 22 3.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C14 4.6 13.4 4 12.67 4M11 16H5v3h6v-3m0-4.5H5v3h6v-3M23 10h-3V3l-5 10h3v8"/>'
        },
        "battery-charging-outline": {
            body: '<path fill="currentColor" d="M23.05 11h-3V4l-5 10h3v8M12 20H4l.05-14h8m.67-2h-1.67V2h-6v2H3.38a1.33 1.33 0 0 0-1.33 1.33v15.34c0 .73.6 1.33 1.33 1.33h9.34c.73 0 1.33-.6 1.33-1.33V5.33A1.33 1.33 0 0 0 12.72 4Z"/>'
        },
        "battery-charging-wireless": {
            body: '<path fill="currentColor" d="M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m7.07.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48Z"/>'
        },
        "battery-charging-wireless-10": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 14.5H4V6h8v12.5Z"/>'
        },
        "battery-charging-wireless-20": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 13H4V6h8v11Z"/>'
        },
        "battery-charging-wireless-30": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 12H4V6h8v10Z"/>'
        },
        "battery-charging-wireless-40": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 10.5H4V6h8v8.5Z"/>'
        },
        "battery-charging-wireless-50": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 9H4V6h8v7Z"/>'
        },
        "battery-charging-wireless-60": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 7.6H4V6h8v5.6Z"/>'
        },
        "battery-charging-wireless-70": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 6H4V6h8v4Z"/>'
        },
        "battery-charging-wireless-80": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 5H4V6h8v3Z"/>'
        },
        "battery-charging-wireless-90": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 3.5H4V6h8v1.5Z"/>'
        },
        "battery-charging-wireless-alert": {
            body: '<path fill="currentColor" d="M13 4h-2V2H5v2H3c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1M9 18H7v-2h2v2m0-4H7V8h2v6m11.1-9.1l-1.4 1.4c3.1 3.1 3.1 8.2 0 11.3l1.4 1.4c3.9-3.8 3.9-10.2 0-14.1m-2.9 2.9l-1.4 1.4c1.6 1.6 1.6 4.1 0 5.7l1.4 1.4c2.4-2.4 2.4-6.2 0-8.5Z"/>'
        },
        "battery-charging-wireless-outline": {
            body: '<path fill="currentColor" d="m20.07 4.93l-1.41 1.41c3.13 3.12 3.13 8.19 0 11.32l1.41 1.41c3.9-3.9 3.9-10.23 0-14.14m-2.83 2.83l-1.41 1.41a4.008 4.008 0 0 1 0 5.66l1.41 1.41a6 6 0 0 0 0-8.48M13 4h-2V2H5v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 16H4V6h8v14Z"/>'
        },
        "battery-check": {
            body: '<path fill="currentColor" d="m16.75 21.16l-2.75-3L15.16 17l1.59 1.59L20.34 15l1.16 1.41l-4.75 4.75M12 18c0-3.31 2.69-6 6-6V5.33C18 4.6 17.4 4 16.67 4H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h6.21A5.93 5.93 0 0 1 12 18Z"/>'
        },
        "battery-check-outline": {
            body: '<path fill="currentColor" d="m16.75 21.16l-2.75-3L15.16 17l1.59 1.59L20.34 15l1.16 1.41l-4.75 4.75M12.35 20H8V6h8v6.35c.63-.22 1.3-.35 2-.35V5.33C18 4.6 17.4 4 16.67 4H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h6.21c-.54-.58-.93-1.25-1.19-2Z"/>'
        },
        "battery-clock": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7c-1.31 0-2.54-.37-3.59-1H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33v3.96c2.89.86 5 3.54 5 6.71m-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "battery-clock-outline": {
            body: '<path fill="currentColor" d="M18 9.29V5.33C18 4.6 17.4 4 16.67 4H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h5.08c1.05.63 2.28 1 3.59 1c3.87 0 7-3.13 7-7c0-3.17-2.11-5.85-5-6.71M8 6h8v3c-3.87 0-7 3.13-7 7c0 1.5.47 2.87 1.26 4H8V6m8 15c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "battery-heart": {
            body: '<path fill="currentColor" d="M12.67 4H11V2H5v2H3.33A1.34 1.34 0 0 0 2 5.33v15.34A1.34 1.34 0 0 0 3.33 22h9.34A1.34 1.34 0 0 0 14 20.67V5.33A1.34 1.34 0 0 0 12.67 4M19 16.17l-.58-.53C16.36 13.77 15 12.54 15 11a2.18 2.18 0 0 1 2.2-2.2a2.4 2.4 0 0 1 1.8.83a2.4 2.4 0 0 1 1.8-.83A2.18 2.18 0 0 1 23 11c0 1.5-1.36 2.74-3.42 4.61Z"/>'
        },
        "battery-heart-outline": {
            body: '<path fill="currentColor" d="m19 16.2l-.6-.5c-2-1.9-3.4-3.2-3.4-4.7c0-1.2 1-2.2 2.2-2.2c.7 0 1.3.3 1.8.8c.5-.5 1.1-.8 1.8-.8c1.2 0 2.2 1 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.6M12.7 4H11V2H5v2H3.3C2.6 4 2 4.6 2 5.3v15.3c0 .8.6 1.4 1.3 1.4h9.3c.7 0 1.3-.6 1.3-1.3V5.3c.1-.7-.5-1.3-1.2-1.3M12 20H4V6h8v14Z"/>'
        },
        "battery-heart-variant": {
            body: '<path fill="currentColor" d="M16.67 4H15V2H9v2H7.33A1.34 1.34 0 0 0 6 5.33v15.34A1.34 1.34 0 0 0 7.33 22h9.34A1.34 1.34 0 0 0 18 20.67V5.33A1.34 1.34 0 0 0 16.67 4m-4.09 11.64l-.58.53l-.58-.53C9.36 13.77 8 12.54 8 11a2.18 2.18 0 0 1 2.2-2.2a2.4 2.4 0 0 1 1.8.83a2.4 2.4 0 0 1 1.8-.83A2.18 2.18 0 0 1 16 11c0 1.54-1.36 2.77-3.42 4.64Z"/>'
        },
        "battery-high": {
            body: '<path fill="currentColor" d="M16 20H8V6h8m.67-2H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C18 4.6 17.4 4 16.67 4M15 16H9v3h6v-3m0-9H9v3h6V7m0 4.5H9v3h6v-3Z"/>'
        },
        "battery-lock": {
            body: '<path fill="currentColor" d="M19.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16m-7.23 6H5.33C4.6 22 4 21.4 4 20.67V5.33C4 4.6 4.6 4 5.33 4H7V2h6v2h1.67C15.4 4 16 4.6 16 5.33v4.78c-2.14.44-3.8 2.27-3.8 4.39v.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .46.1.9.27 1.3Z"/>'
        },
        "battery-lock-open": {
            body: '<path fill="currentColor" d="M19.8 16h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-8.53 6H5.33C4.6 22 4 21.4 4 20.67V5.33C4 4.6 4.6 4 5.33 4H7V2h6v2h1.67C15.4 4 16 4.6 16 5.33v3.78c-2.14.44-3.8 2.27-3.8 4.39v1.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .23.03.45.07.67l.01.02c.04.21.11.41.19.61Z"/>'
        },
        "battery-low": {
            body: '<path fill="currentColor" d="M16 20H8V6h8m.67-2H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C18 4.6 17.4 4 16.67 4M15 16H9v3h6v-3"/>'
        },
        "battery-medium": {
            body: '<path fill="currentColor" d="M16 20H8V6h8m.67-2H15V2H9v2H7.33C6.6 4 6 4.6 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34c.74 0 1.33-.59 1.33-1.33V5.33C18 4.6 17.4 4 16.67 4M15 16H9v3h6v-3m0-4.5H9v3h6v-3Z"/>'
        },
        "battery-minus": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4M22 17v2h-8v-2h8Z"/>'
        },
        "battery-minus-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2M22 17v2h-8v-2h8Z"/>'
        },
        "battery-minus-variant": {
            body: '<path fill="currentColor" d="M16.67 4C17.4 4 18 4.6 18 5.33v15.34A1.33 1.33 0 0 1 16.67 22H7.33C6.6 22 6 21.4 6 20.67V5.33A1.33 1.33 0 0 1 7.33 4H9V2h6v2h1.67M8 12v2h8v-2"/>'
        },
        "battery-negative": {
            body: '<path fill="currentColor" d="M11.67 4A1.33 1.33 0 0 1 13 5.33v15.34c0 .73-.6 1.33-1.33 1.33H2.33C1.6 22 1 21.4 1 20.67V5.33A1.33 1.33 0 0 1 2.33 4H4V2h6v2h1.67M15 12h8v2h-8v-2M3 13h8V6H3v7Z"/>'
        },
        "battery-off": {
            body: '<path fill="currentColor" d="M18 14.8L7.21 4H9V2h6v2h1.67A1.34 1.34 0 0 1 18 5.33m0 12.02L3.38 2.73L2.11 4L6 7.89v12.78A1.34 1.34 0 0 0 7.33 22h9.34A1.34 1.34 0 0 0 18 20.67v-.78l2.84 2.84l1.27-1.27Z"/>'
        },
        "battery-off-outline": {
            body: '<path fill="currentColor" d="M18 17.35L3.38 2.73L2.11 4L6 7.89v12.78A1.34 1.34 0 0 0 7.33 22h9.34A1.34 1.34 0 0 0 18 20.67v-.78l2.84 2.84l1.27-1.27M16 20H8V9.89l8 8M16 6v6.8l2 2V5.33A1.34 1.34 0 0 0 16.67 4H15V2H9v2H7.21l2 2Z"/>'
        },
        "battery-outline": {
            body: '<path fill="currentColor" d="M16 20H8V6h8m.67-2H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.34C6 21.4 6.6 22 7.33 22h9.34A1.33 1.33 0 0 0 18 20.67V5.33C18 4.6 17.4 4 16.67 4Z"/>'
        },
        "battery-plus": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4M22 17v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "battery-plus-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2M22 17v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "battery-plus-variant": {
            body: '<path fill="currentColor" d="M16.67 4C17.4 4 18 4.6 18 5.33v15.34A1.33 1.33 0 0 1 16.67 22H7.33C6.6 22 6 21.4 6 20.67V5.33A1.33 1.33 0 0 1 7.33 4H9V2h6v2h1.67M16 14v-2h-3V9h-2v3H8v2h3v3h2v-3h3Z"/>'
        },
        "battery-positive": {
            body: '<path fill="currentColor" d="M11.67 4A1.33 1.33 0 0 1 13 5.33v15.34c0 .73-.6 1.33-1.33 1.33H2.33C1.6 22 1 21.4 1 20.67V5.33A1.33 1.33 0 0 1 2.33 4H4V2h6v2h1.67M23 14h-3v3h-2v-3h-3v-2h3V9h2v3h3v2M3 13h8V6H3v7Z"/>'
        },
        "battery-remove": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4m8-1.88l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12Z"/>'
        },
        "battery-remove-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2m8-1.88l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12Z"/>'
        },
        "battery-standard": {
            body: '<path d="M16 11.998H8v-6h8m.666-2H15v-2H9v2H7.332C6.596 3.998 6 4.595 6 5.331v15.334c0 .736.597 1.333 1.333 1.333h9.334c.737 0 1.333-.597 1.333-1.333V5.331c0-.736-.596-1.333-1.333-1.333z" fill="currentColor"/>',
            hidden: true
        },
        "battery-sync": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-3.31 0-6 2.69-6 6c0 1.54.58 2.94 1.54 4M18 13l2.25 2.25L18 17.5V16c-1.85 0-3.06 1.96-2.24 3.62l-1.09 1.09c-1.76-2.66.14-6.21 3.33-6.21V13m0 11l-2.25-2.25L18 19.5V21c1.85 0 3.06-1.96 2.24-3.62l1.09-1.09c1.76 2.66-.14 6.21-3.33 6.21V24"/>'
        },
        "battery-sync-outline": {
            body: '<path fill="currentColor" d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2h6v2h1.67C17.4 4 18 4.6 18 5.33V12c-.7 0-1.37.13-2 .35V6H8v14h4.35c.26.75.65 1.42 1.19 2M18 13l2.25 2.25L18 17.5V16c-1.85 0-3.06 1.96-2.24 3.62l-1.09 1.09c-1.76-2.66.14-6.21 3.33-6.21V13m0 11l-2.25-2.25L18 19.5V21c1.85 0 3.06-1.96 2.24-3.62l1.09-1.09c1.76 2.66-.14 6.21-3.33 6.21V24"/>'
        },
        "battery-unknown": {
            body: '<path fill="currentColor" d="m15.07 12.25l-.9.92c-.54.54-.92 1.01-1.08 1.83h-2.04c.11-.9.51-1.72 1.12-2.33l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 0 0-2-2a2 2 0 0 0-2 2H8a4 4 0 0 1 4-4a4 4 0 0 1 4 4c0 .88-.36 1.68-.93 2.25M13 19h-2v-2h2m3.67-13H15V2H9v2H7.33A1.33 1.33 0 0 0 6 5.33v15.33C6 21.4 6.6 22 7.33 22h9.34c.73 0 1.33-.6 1.33-1.34V5.33C18 4.59 17.4 4 16.67 4Z"/>'
        },
        "battery-unknown-bluetooth": {
            body: '<path fill="currentColor" d="M5 2v2H3.33A1.33 1.33 0 0 0 2 5.33v15.33C2 21.4 2.6 22 3.33 22h9.34c.73 0 1.33-.6 1.33-1.34V5.33C14 4.59 13.4 4 12.67 4H11V2H5m3 4a4 4 0 0 1 4 4c0 .88-.36 1.68-.93 2.25l-.9.92c-.54.54-.92 1.01-1.08 1.83H7.05c.11-.9.51-1.72 1.12-2.33l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 0 0-2-2a2 2 0 0 0-2 2H4a4 4 0 0 1 4-4m11 2v3.79L16.71 9.5l-.71.71L18.79 13L16 15.79l.71.71L19 14.21V18h.5l2.85-2.86L20.21 13l2.14-2.15L19.5 8H19m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87M7 17h2v2H7v-2Z"/>'
        },
        battlenet: {
            body: '<path d="M19.92 10.76s2.58 1.48 2.58 3.13c0 1.61-3 2.17-6.32 2.01c0 0-1.41 1.97-2.76 2.8c1.46 2.74 2.58 3.8 2.55 3.8c0 0-.74.19-2.97-3.46c-1.34.85-2.83 1.19-3.44.66c-.62-.53-.14-1.42.12-1.85c-.27.15-1.68.98-2.93.98c-1.49 0-1.7-1.11-1.7-1.68C5.05 15 7.12 12 7.12 12s-.96-2.12-1.07-3.78c-1.88-.16-4.05.17-4.52.32c-.13 0 .31-.32.47-.36c.15-.05 1.91-.51 4-.51c0-1.74.35-3.34 1.41-3.34c.72 0 1.3 1.12 1.3 1.12S8.7 1.5 10.74 1.5C12.8 1.5 15 6.11 15 6.11s2.22.21 3.85.98c.65-1.36 1.24-1.98 1.96-4.09c.19.7-.61 2.5-1.46 4.3c0 0 2.3 1.2 2.3 2.53c0 1.01-1.73.93-1.73.93m-9.24 7.82c.68.11 1.73-.48 1.72-.48l-.82-1.53l-1.18.83c-.01.01-.76.98.28 1.18m9.47-8.82c0-.66-1.2-1.41-1.34-1.49l-.92 1.48l1.28.62c.42-.03.98-.02.98-.61M8 5.63c-.3 0-.91.44-.91 2.01l1.74.06l-.11-1.4C8.6 6 8.3 5.63 8 5.63m2.18 10.15c-1.26-.65-2.02-1.72-2.64-2.88c0 0-1.58 2.65-.57 3.32c1.03.67 2.67-.06 3.21-.44m2.79 1.98c1.14-.87 4.22-3.03 4.48-6.68c-2.88-1.64-6.83-2.37-6.83-2.37s-.01-.5.08-.85c.94.11 3.89.61 6.33 1.57c-.68-1.15-1.19-1.58-1.66-1.93c1.16.26 1.99 1.76 1.99 1.76l.92-1.3s-4.37-2.35-8.09-.54c-.08 2.88 1.4 7.14 1.4 7.14l-.77.33c-.52-1.05-1.19-2.8-1.82-6.22c-.3.41-.83.88-.84 2.42c-.46-1.29.5-2.66.51-2.67l-1.6-.16c.1 1.66.98 5.94 3.61 7.27c2.32-1.32 4.82-3.99 5.45-4.76l.69.51l-4.47 4.69c1.24.03 1.97-.25 2.47-.47c-.72.75-1.96.82-2.55.82c.01.02.3.75.7 1.44m1.06-11.71c-.03-.08-1.37-2.36-2.56-2.19c-.78.25-1.23 1.57-1.24 3.01c.53-.31 1.77-.87 3.8-.82m2.68 9.02S20 15 19.9 13.76c0-1.2-1.98-2.43-1.98-2.41c.01 2.12-1.21 3.72-1.21 3.72z" fill="currentColor"/>',
            hidden: true
        },
        beach: {
            body: '<path fill="currentColor" d="M15 18.54c2.13-.33 4.5-.54 7-.54v4H5c0-.65 3.2-2.14 8-3.1v-6.5c-.84.25-1.55.81-2 1.55a3.495 3.495 0 0 0-6 0c.03-3.58 3.5-6.52 8-6.91V7a1 1 0 0 1 1-1a1 1 0 0 1 1 1v.04c4.5.39 7.96 3.33 8 6.91a3.495 3.495 0 0 0-6 0c-.45-.74-1.16-1.3-2-1.56v6.15M7 2a5 5 0 0 1-5 5V2h5Z"/>'
        },
        beaker: {
            body: '<path fill="currentColor" d="M3 3v2a2 2 0 0 1 2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 1 2-2V3H3m4 6h3v1H7V9m0 2h3v1H7v-1m3 5H7v-1h3v1m2-2H7v-1h5v1m0-6H7V7h5v1Z"/>'
        },
        "beaker-alert": {
            body: '<path fill="currentColor" d="M3 3h18v2c-1.1 0-2 .9-2 2v12c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H7m0 2v1h3v-1H7m3 5v-1H7v1h3m2-2v-1H7v1h5m0-6V7H7v1h5m9 5V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "beaker-alert-outline": {
            body: '<path fill="currentColor" d="M3 3h18v2c-1.1 0-2 .9-2 2v12c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3m4 2v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h10V5H7m14 8V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "beaker-check": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M3 3h18v2c-1.1 0-2 .9-2 2v5a6.005 6.005 0 0 0-5.2 9H7c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H7m0 2v1h3v-1H7m3 5v-1H7v1h3m2-2v-1H7v1h5m0-6V7H7v1h5Z"/>'
        },
        "beaker-check-outline": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M3 3h18v2c-1.1 0-2 .9-2 2v5c-.7 0-1.37.12-2 .34V5H7v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h6.08c.12.72.37 1.39.72 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3Z"/>'
        },
        "beaker-minus": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M3 3h18v2c-1.1 0-2 .9-2 2v5a6.005 6.005 0 0 0-5.2 9H7c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H7m0 2v1h3v-1H7m3 5v-1H7v1h3m2-2v-1H7v1h5m0-6V7H7v1h5Z"/>'
        },
        "beaker-minus-outline": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2M3 3h18v2c-1.1 0-2 .9-2 2v5c-.7 0-1.37.12-2 .34V5H7v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h6.08c.12.72.37 1.39.72 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3Z"/>'
        },
        "beaker-outline": {
            body: '<path fill="currentColor" d="M3 3h18v2a2 2 0 0 0-2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3m4 2v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h10V5H7Z"/>'
        },
        "beaker-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M3 3h18v2c-1.1 0-2 .9-2 2v5a6.005 6.005 0 0 0-5.2 9H7c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H7m0 2v1h3v-1H7m3 5v-1H7v1h3m2-2v-1H7v1h5m0-6V7H7v1h5Z"/>'
        },
        "beaker-plus-outline": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M3 3h18v2c-1.1 0-2 .9-2 2v5c-.7 0-1.37.12-2 .34V5H7v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h6.08c.12.72.37 1.39.72 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3Z"/>'
        },
        "beaker-question": {
            body: '<path fill="currentColor" d="M0 3h18v2c-1.1 0-2 .9-2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H4m0 2v1h3v-1H4m3 5v-1H4v1h3m2-2v-1H4v1h5m0-6V7H4v1h5m12.5 7.5V17H20v-1.5h1.5m-2-5H18V10c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.02-.91 1.7v.2H20v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.82-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5Z"/>'
        },
        "beaker-question-outline": {
            body: '<path fill="currentColor" d="M0 3h18v2c-1.1 0-2 .9-2 2v12c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3m4 2v2h5v1H4v1h3v1H4v1h3v1H4v1h5v1H4v1h3v1H4v3h10V5H4m17.5 10.5V17H20v-1.5h1.5m-2-5H18V10c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.02-.91 1.7v.2H20v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.82-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5Z"/>'
        },
        "beaker-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M3 3h18v2c-1.1 0-2 .9-2 2v5a6.005 6.005 0 0 0-5.2 9H7c-1.1 0-2-.9-2-2V7c0-1.1-.9-2-2-2V3m4 6v1h3V9H7m0 2v1h3v-1H7m3 5v-1H7v1h3m2-2v-1H7v1h5m0-6V7H7v1h5Z"/>'
        },
        "beaker-remove-outline": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M3 3h18v2c-1.1 0-2 .9-2 2v5c-.7 0-1.37.12-2 .34V5H7v2h5v1H7v1h3v1H7v1h3v1H7v1h5v1H7v1h3v1H7v3h6.08c.12.72.37 1.39.72 2H7a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2V3Z"/>'
        },
        beam: {
            body: '<path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2zm9.365 10.817A16.655 16.655 0 0 1 11.183 2.635c5.823-.501 10.684 4.355 10.182 10.182zM9.172 9.172a4 4 0 1 1 5.656 5.656a4 4 0 0 1-5.656-5.656zm-6.537 2.01a16.655 16.655 0 0 1 10.182 10.183c-5.83.502-10.683-4.362-10.182-10.182z" fill="currentColor"/>',
            hidden: true
        },
        beats: {
            body: '<path d="M7 12a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5c-1.13 0-2.16.37-3 1V2.46c.95-.3 1.95-.46 3-.46a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12c0-3.7 2-6.93 5-8.66V12m5-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3z" fill="currentColor"/>',
            hidden: true
        },
        bed: {
            body: '<path fill="currentColor" d="M19 7h-8v7H3V5H1v15h2v-3h18v3h2v-9a4 4 0 0 0-4-4M7 13a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3Z"/>'
        },
        "bed-clock": {
            body: '<path fill="currentColor" d="M19.2 9.5L16 7.7V4h1.5v2.8l2.4 1.4l-.7 1.3m3 2.2c.5.7.8 1.5.8 2.3v9h-2v-3H3v3H1V8h2v9h8v-6.4c-.6-1.1-1-2.3-1-3.6c0-3.9 3.1-7 7-7s7 3.1 7 7c0 1.8-.7 3.4-1.8 4.7M12 7c0 2.8 2.2 5 5 5s5-2.2 5-5s-2.2-5-5-5s-5 2.2-5 5m-5 9c1.7 0 3-1.3 3-3s-1.3-3-3-3s-3 1.3-3 3s1.3 3 3 3Z"/>'
        },
        "bed-double": {
            body: '<path fill="currentColor" d="M18 10V7a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v3a2 2 0 0 0-2 2v5h1.33L6 19h1l.67-2h8.66l.67 2h1l.67-2H20v-5a2 2 0 0 0-2-2m-7 0H8V7h3m5 3h-3V7h3Z"/>'
        },
        "bed-double-outline": {
            body: '<path fill="currentColor" d="M8 5c-.5 0-1 .21-1.39.6S6 6.45 6 7v3c-.53 0-1 .19-1.41.59S4 11.47 4 12v5h1.34L6 19h1l.69-2h8.67l.64 2h1l.66-2H20v-5c0-.53-.19-1-.59-1.41S18.53 10 18 10V7c0-.55-.2-1-.61-1.4S16.5 5 16 5M8 7h3v3H8m5-3h3v3h-3m-7 2h12v3H6Z"/>'
        },
        "bed-empty": {
            body: '<path fill="currentColor" d="M19 7H5v7H3V5H1v15h2v-3h18v3h2v-9a4 4 0 0 0-4-4"/>'
        },
        "bed-king": {
            body: '<path fill="currentColor" d="M6 5c-.53 0-1 .21-1.41.6S4 6.45 4 7v3c-.55 0-1 .19-1.4.59S2 11.47 2 12v5h1.33L4 19h1l.67-2h12.66l.67 2h1l.67-2H22v-5c0-.53-.21-1-.6-1.41c-.4-.4-.85-.59-1.4-.59V7c0-.55-.19-1-.59-1.4S18.53 5 18 5M6 7h5v3H6m7-3h5v3h-5Z"/>'
        },
        "bed-king-outline": {
            body: '<path fill="currentColor" d="M20 10V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3a2 2 0 0 0-2 2v5h1.33L4 19h1l.67-2h12.66l.67 2h1l.67-2H22v-5a2 2 0 0 0-2-2m-7-3h5v3h-5M6 7h5v3H6m14 5H4v-3h16Z"/>'
        },
        "bed-outline": {
            body: '<path fill="currentColor" d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3s1.34 3 3 3m0-4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4m2 8h-8V9h6c1.1 0 2 .9 2 2Z"/>'
        },
        "bed-queen": {
            body: '<path fill="currentColor" d="M19 10V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3a2 2 0 0 0-2 2v5h1.33L5 19h1l.67-2h10.66l.67 2h1l.67-2H21v-5a2 2 0 0 0-2-2m-2 0H7V7h10Z"/>'
        },
        "bed-queen-outline": {
            body: '<path fill="currentColor" d="M19 10V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3a2 2 0 0 0-2 2v5h1.33L5 19h1l.67-2h10.66l.67 2h1l.67-2H21v-5a2 2 0 0 0-2-2M7 7h10v3H7m12 5H5v-3h14Z"/>'
        },
        "bed-single": {
            body: '<path fill="currentColor" d="M17 10V7a2 2 0 0 0-2-2H9c-1.1 0-2 .9-2 2v3c-1.1 0-2.11.9-2 2v5h1.33L7 19h1l.67-2h6.66l.67 2h1l.67-2H19v-5a2 2 0 0 0-2-2m-2 0H9V7h6Z"/>'
        },
        "bed-single-outline": {
            body: '<path fill="currentColor" d="M17 10V7a2 2 0 0 0-2-2H9c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L7 19h1l.67-2h6.66l.67 2h1l.67-2H19v-5a2 2 0 0 0-2-2M9 7h6v3H9m8 5H7v-3h10Z"/>'
        },
        bee: {
            body: '<path fill="currentColor" d="M17.4 9C17 7.8 16.2 7 15 6.5V5h-1v1.4h-.4c-1.1 0-2 .4-2.8 1.2l-.4.4L9 7.5c-.3-.1-.6-.2-1-.2c-.6 0-1.2.2-1.7.6c-.6.4-.9.9-1.1 1.4c-.2.7-.2 1.3 0 2c.3.7.6 1.2 1.1 1.5c-.4 1.5-.1 2.8 1 3.9c.8.8 1.7 1.2 2.8 1.2c.5 0 .8 0 1.1-.1c.6.8 1.4 1.3 2.4 1.3c.3 0 .7 0 1-.1c.6-.2 1-.6 1.4-1.1c.4-.6.6-1.1.6-1.7c0-.4 0-.7-.1-1l-.5-1.6l.6-.4c.8-.8 1.2-1.9 1.1-3.1H19V9h-1.6m-9.7 2.3c-.6-.3-.8-.7-.6-1.3c.2-.6.6-.8 1.2-.6l3.2 1.2c-1.6.8-2.8 1-3.8.7m6.3 5.6c-.6.2-1 0-1.3-.6c-.3-1-.1-2.2.7-3.8l1.2 3.1c.2.7 0 1.1-.6 1.3m1.2-5.3l-.6-1.6v-.1l-.3-.3h-.1L12.6 9c.4-.3.8-.5 1.3-.5s1 .2 1.4.6c.4.4.6.8.6 1.3c-.2.3-.4.8-.7 1.2Z"/>'
        },
        "bee-flower": {
            body: '<path fill="currentColor" d="M11.6 13v-.1l-.3-.3h-.1L9.6 12c.4-.3.8-.5 1.3-.5s1 .2 1.4.6c.4.4.6.8.6 1.3s-.1.9-.5 1.3l-.8-1.7m-1.9 6.3c-.3-1-.1-2.2.7-3.8l1.2 3.1c.2.6 0 1-.6 1.3c-.6.3-1 .1-1.3-.6m-5.6-6.2c.2-.6.6-.8 1.2-.6l3.2 1.2c-1.6.8-2.8 1-3.8.7c-.6-.3-.8-.7-.6-1.3m7.9-5h-1v1.4h-.4c-1.1 0-2 .4-2.8 1.2l-.4.6l-1.4-.8c-.3-.1-.6-.1-1-.1c-.6 0-1.2.2-1.7.6s-.9.8-1.1 1.4c-.2.7-.2 1.3 0 2c.3.7.6 1.2 1.1 1.5c-.4 1.5-.1 2.8 1 3.9c.8.8 1.7 1.2 2.8 1.2c.5 0 .8 0 1.1-.1c.6.8 1.4 1.3 2.4 1.3c.3 0 .7 0 1-.1c.6-.2 1-.6 1.4-1.1c.4-.6.6-1.1.6-1.7c0-.4 0-.7-.1-1l-.6-1.4l.6-.4c.8-.8 1.2-1.9 1.1-3.1H16v-1h-1.6c-.4-1.2-1.2-2-2.4-2.4V8.1m5.3-1.3c-.2-.2-.3-.5-.3-.7c0-.3.1-.5.3-.7c.2-.2.4-.3.7-.3s.5.1.7.3c.2.1.3.4.3.7c0 .3-.1.5-.3.7c-.2.2-.4.2-.7.2s-.5 0-.7-.2m3.4-2.7h-1.1l-.3-.9c-.2-.7-.6-1-1.3-1c-.7 0-1.2.3-1.3 1l-.3.9h-1.1c-.6 0-1 .3-1.3.9c-.2.6 0 1.1.6 1.5l.9.5l-.4 1.2c-.2.4-.1.8.1 1.2c.3.4.6.6 1.1.6c.4 0 .7-.1.9-.3l.8-.6l.8.7c.2.1.5.2.9.2c.5 0 .8-.2 1.1-.6c.2-.4.3-.8.1-1.2L20.5 7l.8-.5c.6-.4.8-.9.6-1.5c-.2-.7-.6-.9-1.2-.9Z"/>'
        },
        "beehive-off-outline": {
            body: '<path fill="currentColor" d="m1.1 3l3.6 3.5c-1 .7-1.7 1.7-1.7 3c0 .6.2 1.2.5 1.7C2 11.6 1 12.9 1 14.5c0 1.3.7 2.3 1.7 3c-.5.5-.7 1.2-.7 2C2 21.4 3.6 23 5.5 23h13c.8 0 1.5-.3 2.1-.7l.7.7l1.3-1.3l-20.2-20L1.1 3m8.1 8H6.5C5.7 11 5 10.3 5 9.5c0-.7.5-1.3 1.2-1.5l3 3M9 21H5.5c-.8 0-1.5-.7-1.5-1.5S4.7 18 5.5 18H9v3m.2-5H4.5c-.8 0-1.5-.7-1.5-1.5S3.7 13 4.5 13h6.7l1 1H12c-1.3 0-2.4.8-2.8 2m9.3 5H15v-3h1.2l2.9 2.9c-.2.1-.4.1-.6.1M7.1 3.9L5.7 2.5C6.3 1.6 7.3 1 8.5 1h7C17.4 1 19 2.6 19 4.5c0 .6-.2 1.2-.5 1.7C20 6.6 21 7.9 21 9.5c0 .6-.2 1.2-.5 1.7c1.4.5 2.5 1.8 2.5 3.3c0 1.3-.7 2.3-1.7 3c.3.4.5.8.6 1.2L19.2 16h.3c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-3.3l-2-2h3.3c.8 0 1.5-.7 1.5-1.5S18.3 8 17.5 8h-6.3l-2-2h6.3c.8 0 1.5-.7 1.5-1.5S16.3 3 15.5 3h-7c-.6 0-1.2.4-1.4.9Z"/>'
        },
        "beehive-outline": {
            body: '<path fill="currentColor" d="M23 14.5c0-1.56-1.03-2.87-2.45-3.32c.28-.5.45-1.07.45-1.68c0-1.56-1.03-2.87-2.45-3.32c.28-.5.45-1.07.45-1.68C19 2.57 17.43 1 15.5 1h-7C6.57 1 5 2.57 5 4.5c0 .61.17 1.18.45 1.68C4.04 6.63 3 7.94 3 9.5c0 .61.17 1.18.45 1.68C2.04 11.63 1 12.94 1 14.5c0 1.26.67 2.34 1.67 2.96c-.42.57-.67 1.28-.67 2.04C2 21.43 3.57 23 5.5 23h13c1.93 0 3.5-1.57 3.5-3.5c0-.76-.25-1.47-.67-2.04c1-.62 1.67-1.7 1.67-2.96M8.5 3h7c.83 0 1.5.67 1.5 1.5S16.33 6 15.5 6h-7C7.67 6 7 5.33 7 4.5S7.67 3 8.5 3m-2 5h11c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-11C5.67 11 5 10.33 5 9.5S5.67 8 6.5 8M4 19.5c0-.83.67-1.5 1.5-1.5H9v3H5.5c-.83 0-1.5-.67-1.5-1.5M18.5 21H15v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m1-5h-4.68c-.42-1.16-1.52-2-2.82-2s-2.4.84-2.82 2H4.5c-.83 0-1.5-.67-1.5-1.5S3.67 13 4.5 13h15c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"/>'
        },
        beekeeper: {
            body: '<path fill="currentColor" d="M19 5h-3c0-1.66-1.79-3-4-3S8 3.34 8 5H5c-.55 0-1 .45-1 1s.45 1 1 1v7a2 2 0 0 0 2 2h10c1.11 0 2-.89 2-2V7c.55 0 1-.45 1-1s-.45-1-1-1m-2 9H7V7h10v7m-1.14-6c.08.32.14.65.14 1c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-.35.06-.68.14-1h2.14c-.17.3-.28.63-.28 1c0 1.1.9 2 2 2s2-.9 2-2c0-.37-.11-.7-.28-1h2.14M20 19v3H4v-3c0-.78.47-1.45 1.18-2H12c-2.72 0-5.81 1.29-6 2v1h12v-1c-.19-.71-3.28-2-6-2h6.82c.71.55 1.18 1.22 1.18 2Z"/>'
        },
        beer: {
            body: '<path fill="currentColor" d="M4 2h15l-2 20H6L4 2m2.2 2l1.6 16h1L7.43 6.34C8.5 6 9.89 5.89 11 7c1.56 1.56 4.33.69 5.5.23L16.8 4H6.2Z"/>'
        },
        "beer-outline": {
            body: '<path fill="currentColor" d="m4 2l2 20h11l2-20H4m2.2 2h10.6l-.3 3.23c-3.32 1.27-4.65.44-5.12.08c-.25-.19-.61-.62-1.27-.92c-.66-.31-1.56-.39-2.61-.07c-.41.11-.73.29-1 .47L6.2 4m2.66 4.11c.19 0 .3.04.41.09c.23.1.44.35.9.7c.86.66 2.86 1.46 6.09.51L15.2 20H7.8L6.71 9.06c.05-.06.2-.17.46-.35c.33-.21.74-.43.83-.46h.03c.38-.11.64-.15.83-.14Z"/>'
        },
        behance: {
            body: '<path d="M19.58 12.27c-.04-.62-.25-1.09-.62-1.41c-.37-.32-.83-.48-1.38-.48c-.58 0-1.08.17-1.39.51c-.33.34-.54.8-.62 1.38m6.35-.23c.08.41.08 1 .08 1.77h-6.5c.05.9.35 1.52.94 1.88c.35.23.78.34 1.29.34c.53 0 .96-.14 1.27-.41c.2-.15.36-.35.5-.62h2.38c-.06.54-.35 1.07-.88 1.62c-.78.88-1.9 1.3-3.34 1.3c-1.19 0-2.23-.37-3.16-1.1c-.88-.73-1.34-1.92-1.34-3.57c0-1.55.41-2.75 1.23-3.55c.82-.83 1.88-1.24 3.19-1.24c.77 0 1.47.14 2.09.42c.62.28 1.14.71 1.54 1.32c.37.53.6 1.14.71 1.84M9.58 14.07c0-.65-.27-1.1-.79-1.34c-.29-.13-.71-.2-1.25-.23H4.87v3.34H7.5c.54 0 .96-.07 1.26-.22c.55-.27.82-.79.82-1.55m-4.71-3.61H7.5c.54 0 1-.1 1.32-.31c.34-.2.5-.57.5-1.09c0-.56-.22-.96-.66-1.15c-.39-.13-.88-.19-1.47-.19H4.87m6.85 4.7c.32.5.48 1.11.48 1.82c0 .76-.2 1.4-.55 1.99a3.6 3.6 0 0 1-.88.98c-.4.29-.87.51-1.41.62c-.54.11-1.12.17-1.75.17H2V5.55h6c1.53.03 2.6.45 3.23 1.33c.38.53.57 1.16.57 1.9c0 .76-.19 1.37-.57 1.83c-.23.26-.53.5-.95.71c.63.23 1.11.6 1.44 1.1m8.34-5.1h-5.01V6.07h5.01v1.25z" fill="currentColor"/>',
            hidden: true
        },
        bell: {
            body: '<path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"/>'
        },
        "bell-alert": {
            body: '<path fill="currentColor" d="M23 7v6h-2V7m0 8h2v2h-2M12 2a2 2 0 0 0-2 2a2 2 0 0 0 0 .29C7.12 5.14 5 7.82 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.18-2.12-5.86-5-6.71A2 2 0 0 0 14 4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 2 2a2 2 0 0 0 2-2Z"/>'
        },
        "bell-alert-outline": {
            body: '<path fill="currentColor" d="M12 2a2 2 0 0 0-2 2a2 2 0 0 0 0 .29C7.12 5.14 5 7.82 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.18-2.12-5.86-5-6.71A2 2 0 0 0 14 4a2 2 0 0 0-2-2m0 4a5 5 0 0 1 5 5v7H7v-7a5 5 0 0 1 5-5m9 1v6h2V7h-2m0 8v2h2v-2h-2m-11 6a2 2 0 0 0 2 2a2 2 0 0 0 2-2h-4Z"/>'
        },
        "bell-badge": {
            body: '<path fill="currentColor" d="M21 6.5c0 1.93-1.57 3.5-3.5 3.5S14 8.43 14 6.5S15.57 3 17.5 3S21 4.57 21 6.5m-2 5.29c-.5.13-1 .21-1.5.21A5.51 5.51 0 0 1 12 6.5c0-1.47.58-2.8 1.5-3.79A1.93 1.93 0 0 0 12 2c-1.1 0-2 .9-2 2v.29C7.03 5.17 5 7.9 5 11v6l-2 2v1h18v-1l-2-2v-5.21M12 23c1.11 0 2-.89 2-2h-4a2 2 0 0 0 2 2Z"/>'
        },
        "bell-badge-outline": {
            body: '<path fill="currentColor" d="M19 17v-5.2c-.5.1-1 .2-1.5.2H17v6H7v-7c0-2.8 2.2-5 5-5c.1-1.3.7-2.4 1.5-3.3c-.3-.4-.9-.7-1.5-.7c-1.1 0-2 .9-2 2v.3C7 5.2 5 7.9 5 11v6l-2 2v1h18v-1l-2-2m-9 4c0 1.1.9 2 2 2s2-.9 2-2h-4M21 6.5c0 1.9-1.6 3.5-3.5 3.5S14 8.4 14 6.5S15.6 3 17.5 3S21 4.6 21 6.5"/>'
        },
        "bell-cancel": {
            body: '<path fill="currentColor" d="M17.5 13a4.5 4.5 0 0 0-4.5 4.5a4.5 4.5 0 0 0 4.5 4.5a4.5 4.5 0 0 0 4.5-4.5a4.5 4.5 0 0 0-4.5-4.5m0 1.5a3 3 0 0 1 3 3a3 3 0 0 1-.42 1.5L16 14.92a3 3 0 0 1 1.5-.42M14.92 16L19 20.08a3 3 0 0 1-1.5.42a3 3 0 0 1-3-3a3 3 0 0 1 .42-1.5M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h8.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 6.5-6.5a6.5 6.5 0 0 1 1.5.18V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 2 2c.5 0 .97-.19 1.33-.5a6.5 6.5 0 0 1-1.3-1.5Z"/>'
        },
        "bell-cancel-outline": {
            body: '<path fill="currentColor" d="M17.5 13a4.5 4.5 0 0 0-4.5 4.5a4.5 4.5 0 0 0 4.5 4.5a4.5 4.5 0 0 0 4.5-4.5a4.5 4.5 0 0 0-4.5-4.5m0 1.5a3 3 0 0 1 3 3a3 3 0 0 1-.42 1.5L16 14.92a3 3 0 0 1 1.5-.42M14.92 16L19 20.08a3 3 0 0 1-1.5.42a3 3 0 0 1-3-3a3 3 0 0 1 .42-1.5M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h8.5a6.5 6.5 0 0 1-.47-2H7v-7a5 5 0 0 1 5-5a5 5 0 0 1 5 5a6.5 6.5 0 0 1 .5 0a6.5 6.5 0 0 1 1.5.18V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 2 2c.5 0 .97-.19 1.33-.5a6.5 6.5 0 0 1-1.3-1.5Z"/>'
        },
        "bell-check": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M3 20v-1l2-2v-6a7 7 0 0 1 5-6.71V4a2 2 0 1 1 4 0v.29A7 7 0 0 1 19 11v1.08L18 12a6.005 6.005 0 0 0-5.66 8H3m9 3a2 2 0 0 1-2-2h2.8c.24.41.53.79.85 1.13c-.36.53-.96.87-1.65.87Z"/>'
        },
        "bell-check-outline": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M10 21h2.8c.24.41.53.79.85 1.13c-.36.53-.96.87-1.65.87a2 2 0 0 1-2-2m-7-1v-1l2-2v-6a7 7 0 0 1 5-6.71V4a2 2 0 1 1 4 0v.29A7 7 0 0 1 19 11v1.08L18 12l-1 .08V11c0-2.76-2.24-5-5-5s-5 2.24-5 5v7h5c0 .7.12 1.37.34 2H3Z"/>'
        },
        "bell-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m5 14v-1l-1-1v-2.61c0-1.09-.27-2.05-.79-2.86C14.7 7.72 13.96 7.21 13 7v-.5a1 1 0 0 0-1-1a1 1 0 0 0-1 1V7c-.96.21-1.7.72-2.21 1.53c-.52.81-.79 1.77-.79 2.86V14l-1 1v1h10m-3.5 1h-3a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5Z"/>'
        },
        "bell-circle-outline": {
            body: '<path fill="currentColor" d="M17 16H7v-1l1-1v-2.61c0-1.09.27-2.05.79-2.86C9.3 7.72 10.04 7.21 11 7v-.5a1 1 0 0 1 1-1a1 1 0 0 1 1 1V7c.96.21 1.7.72 2.21 1.53c.52.81.79 1.77.79 2.86V14l1 1v1m-3.5 1a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5h3M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "bell-cog": {
            body: '<path fill="currentColor" d="M19 12c-3.87 0-7 3.13-7 7c0 .34.03.67.08 1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4c0-1.1.9-2 2-2s2 .9 2 2v.29c2.97.88 5 3.61 5 6.71v1m-9 9a2 2 0 0 0 2 2c.39 0 .75-.12 1.06-.31c-.32-.52-.56-1.09-.76-1.69H10m13.77-.68c.1.07.12.21.06.32l-1 1.73c-.06.13-.19.13-.3.13l-1.25-.53c-.28.2-.53.37-.84.5l-.19 1.32c-.02.12-.12.21-.25.21h-2c-.12 0-.23-.09-.25-.21l-.18-1.32c-.32-.13-.57-.3-.85-.5l-1.22.53c-.13 0-.27 0-.33-.13l-1-1.73a.257.257 0 0 1 .06-.32l1.06-.82c-.02-.17-.04-.33-.04-.5s.02-.33.04-.5l-1.06-.82c-.09-.07-.12-.18-.06-.32l1-1.72c.06-.11.2-.14.33-.11l1.22.47c.28-.17.53-.34.85-.46l.18-1.33c.02-.12.13-.21.25-.21h2c.13 0 .23.09.25.21l.19 1.33c.31.12.56.29.84.46l1.25-.47c.11-.03.24 0 .3.11l1 1.72c.06.14.04.25-.06.32l-1.05.82a4.321 4.321 0 0 1 0 1l1.05.82M20.75 19c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75s.79 1.75 1.75 1.75s1.75-.78 1.75-1.75Z"/>'
        },
        "bell-cog-outline": {
            body: '<path fill="currentColor" d="M22.72 19.5a4.193 4.193 0 0 0 0-1l1.05-.82c.1-.07.12-.18.06-.32l-1-1.72c-.06-.11-.19-.14-.3-.11l-1.25.47c-.28-.17-.53-.34-.84-.46l-.19-1.33A.249.249 0 0 0 20 14h-2c-.12 0-.23.09-.25.21l-.18 1.33c-.32.12-.57.29-.85.46l-1.22-.47c-.13-.03-.27 0-.33.11l-1 1.72c-.06.14-.03.25.06.32l1.06.82c-.02.17-.04.34-.04.5s.02.33.04.5l-1.06.82c-.09.07-.12.21-.06.32l1 1.73c.06.13.2.13.33.13l1.22-.53c.28.2.53.37.85.5l.18 1.32c.02.12.13.21.25.21h2c.13 0 .23-.09.25-.21l.19-1.32c.31-.13.56-.3.84-.5l1.25.53c.11 0 .24 0 .3-.13l1-1.73c.06-.11.04-.25-.06-.32l-1.05-.82M19 20.75c-.96 0-1.75-.78-1.75-1.75s.79-1.75 1.75-1.75s1.75.78 1.75 1.75s-.78 1.75-1.75 1.75M12.08 20H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v1c-.69 0-1.37.11-2 .29V11c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h5.08c-.05.33-.08.66-.08 1c0 .34.03.67.08 1m.22 1c.2.6.44 1.17.76 1.69c-.31.19-.67.31-1.06.31c-1.1 0-2-.9-2-2h2.3Z"/>'
        },
        "bell-minus": {
            body: '<path fill="currentColor" d="M22 19v-2h-8v2h8M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a5.93 5.93 0 0 1-.35-2c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .09V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 3.65 1.13c-.32-.34-.6-.72-.84-1.13H10Z"/>'
        },
        "bell-minus-outline": {
            body: '<path fill="currentColor" d="M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a5.93 5.93 0 0 1-.35-2H7v-7c0-2.76 2.24-5 5-5s5 2.24 5 5v1.09a5.634 5.634 0 0 1 2 0V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m2 15v2h8v-2m-12 4a2 2 0 0 0 3.65 1.13c-.32-.34-.6-.72-.84-1.13H10Z"/>'
        },
        "bell-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.11 20H3v-1l2-2v-6c0-1.14.29-2.27.83-3.28L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M19 15.8V11c0-3.1-2.03-5.83-5-6.71V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v.29c-.61.18-1.2.45-1.74.8L19 15.8M12 23a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2Z"/>'
        },
        "bell-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l4.72 4.72A6.975 6.975 0 0 0 5 11v6l-2 2v1h15.11l2.73 2.73l1.27-1.27M7 18v-7c0-.61.11-1.21.34-1.77L16.11 18H7m3 3h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2M8.29 5.09c.53-.34 1.11-.59 1.71-.8V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v4.8l-2-2V11a5 5 0 0 0-5-5c-.78 0-1.55.2-2.24.56L8.29 5.09Z"/>'
        },
        "bell-outline": {
            body: '<path fill="currentColor" d="M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2-5.8 5-6.7V4c0-1.1.9-2 2-2s2 .9 2 2v.3c3 .9 5 3.6 5 6.7v6l2 2m-4-8c0-2.8-2.2-5-5-5s-5 2.2-5 5v7h10v-7Z"/>'
        },
        "bell-plus": {
            body: '<path fill="currentColor" d="M17 14v3h-3v2h3v3h2v-3h3v-2h-3v-3M12 2a2 2 0 0 0-2 2a2 2 0 0 0 0 .29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a6 6 0 0 1-.35-2a6 6 0 0 1 6-6a6 6 0 0 1 1 .09V11c0-3.18-2.12-5.86-5-6.71A2 2 0 0 0 14 4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 2 2a2 2 0 0 0 1.65-.87a6 6 0 0 1-.84-1.13Z"/>'
        },
        "bell-plus-outline": {
            body: '<path fill="currentColor" d="M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a5.93 5.93 0 0 1-.35-2H7v-7c0-2.76 2.24-5 5-5s5 2.24 5 5v1.09a5.634 5.634 0 0 1 2 0V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m5 12v3h-3v2h3v3h2v-3h3v-2h-3v-3m-9 7a2 2 0 0 0 3.65 1.13c-.32-.34-.6-.72-.84-1.13Z"/>'
        },
        "bell-remove": {
            body: '<path fill="currentColor" d="M20.12 14.46L18 16.59l-2.12-2.13l-1.42 1.42L16.59 18l-2.13 2.12l1.42 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a5.93 5.93 0 0 1-.35-2c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .09V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 3.65 1.13c-.32-.34-.6-.72-.84-1.13Z"/>'
        },
        "bell-remove-outline": {
            body: '<path fill="currentColor" d="M20.12 14.46L18 16.59l-2.12-2.13l-1.42 1.42L16.59 18l-2.13 2.12l1.42 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12M12 2c-1.1 0-2 .9-2 2v.29C7.12 5.14 5 7.82 5 11v6l-2 2v1h9.35a5.93 5.93 0 0 1-.35-2H7v-7a5 5 0 0 1 5-5a5 5 0 0 1 5 5v1.09c.33-.05.66-.09 1-.09c.34 0 .67.03 1 .09V11c0-3.18-2.12-5.86-5-6.71V4a2 2 0 0 0-2-2m-2 19a2 2 0 0 0 3.65 1.13c-.32-.34-.6-.72-.84-1.13Z"/>'
        },
        "bell-ring": {
            body: '<path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m9.75-17.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11Z"/>'
        },
        "bell-ring-outline": {
            body: '<path fill="currentColor" d="M10 21h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-4-8a5 5 0 0 0-5-5a5 5 0 0 0-5 5v7h10v-7m2.75-7.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11Z"/>'
        },
        "bell-sleep": {
            body: '<path fill="currentColor" d="M10 21h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2M15 9H9v2h3.24L9 13.7V16h6v-2h-3.24L15 11.3V9Z"/>'
        },
        "bell-sleep-outline": {
            body: '<path fill="currentColor" d="M10 21h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-4-8a5 5 0 0 0-5-5a5 5 0 0 0-5 5v7h10v-7M9 9v2h3.24L9 13.7V16h6v-2h-3.24L15 11.3V9H9Z"/>'
        },
        beta: {
            body: '<path fill="currentColor" d="M9.23 17.59v5.53H6.88V6.72c0-1.45.43-2.59 1.28-3.44C9 2.43 10.17 2 11.61 2c1.39 0 2.46.34 3.26 1c.79.68 1.18 1.62 1.18 2.81c0 .82-.26 1.59-.78 2.3c-.52.71-1.19 1.2-2.02 1.47v.04c1.25.2 2.22.65 2.88 1.38c.66.71.99 1.62.99 2.74c0 1.32-.46 2.4-1.37 3.23c-.92.83-2.12 1.24-3.62 1.24c-1.06 0-2.03-.21-2.9-.62m1.49-6.84V8.83c.87-.11 1.58-.43 2.15-.97c.56-.55.84-1.16.84-1.86c0-1.38-.71-2.08-2.11-2.08c-.76 0-1.35.24-1.76.73c-.41.49-.61 1.17-.61 2.06v8.79c.91.53 1.8.79 2.66.79c.84 0 1.5-.22 1.97-.65c.47-.44.7-1.06.7-1.85c0-1.79-1.28-2.79-3.84-3.04Z"/>'
        },
        betamax: {
            body: '<path fill="currentColor" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m4 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m5 0h7v8h-7V9m-5 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        biathlon: {
            body: '<path fill="currentColor" d="M12.88 3.64c.77 0 1.4.63 1.4 1.4c0 .77-.63 1.4-1.4 1.4c-.77 0-1.38-.63-1.38-1.4c0-.77.61-1.4 1.38-1.4M15 13h1.5v6H15v-6m0-4.5h1.5V10H15V8.5m-4.96-5.9L8 2.04L6.06 8.58L3.9 11.42l3.27.95l2.87-9.77m9.63 15.95c-.36.38-.79.95-1.27 1.15c-.49.22-.86.3-1.4.3h-3.5l-.07-3c-.01-.17-.06-.33-.15-.5l-2.4-4.26l.88-2.74a245.5 245.5 0 0 0 1.3 2.33c.15.17.39.3.63.3h2.21a.81.81 0 0 0 .81-.81c0-.42-.33-.76-.75-.79l-1.67-.13L12.4 7s-.4-.58-1.26-.58c-.87 0-1.14.42-1.31 1L6 20H3v2h14c1.37 0 2.53-.66 3.5-1.63l-.83-1.82m-9.92-4.16l1.87 3l.13 2.61h-4l2-5.61Z"/>'
        },
        bicycle: {
            body: '<path fill="currentColor" d="M19 10c-.56 0-1.09.11-1.59.28L14.46 4.5H11V6h2.54l.88 1.72L12 13.13l-1.77-4.18c.27-.1.51-.37.51-.7c0-.41-.33-.75-.74-.75H8c-.42 0-.76.34-.76.75S7.58 9 8 9h.61l2.25 5.25h-.94C9.56 11.85 7.5 10 5 10c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.5 0 4.56-1.85 4.92-4.25h2.58l2.79-6.32l.79 1.53A4.976 4.976 0 0 0 14 15c0 2.76 2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5M5 18.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5c1.67 0 3.07 1.18 3.41 2.75H4v1.5h4.41A3.495 3.495 0 0 1 5 18.5m14 0c-1.93 0-3.5-1.57-3.5-3.5c0-1.08.5-2.03 1.27-2.67l1.8 3.52l1.32-.72l-1.79-3.5c.29-.07.59-.13.9-.13c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5Z"/>'
        },
        "bicycle-basket": {
            body: '<path fill="currentColor" d="m11.74 13.36l2.4-5.65l-1.08-2.21H10.5V4H14l.73 1.5h7.02l-1 3.5h-4.31l.67 1.37A5.002 5.002 0 0 1 24 15c0 2.76-2.24 5-5 5s-5-2.24-5-5c0-1.55.71-2.94 1.82-3.85L15 9.5L12.25 16H9.9A5 5 0 1 1 5 10c2.59 0 4.72 1.97 5 4.5h.58L8.3 9h-.8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.75c.41 0 .75.34.75.75s-.34.75-.75.75h-.28l1.77 4.36M5 11.5c-1.93 0-3.5 1.57-3.5 3.5a3.504 3.504 0 0 0 6.86 1H4v-1.5h4.47c-.25-1.7-1.71-3-3.47-3m14 0c-.43 0-.85.08-1.23.22l1.93 3.96l-1.35.66l-1.85-3.79c-.62.63-1 1.5-1 2.45c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5Z"/>'
        },
        "bicycle-cargo": {
            body: '<path fill="currentColor" d="M21 11.5V10l-7.5-1V5H9v1.5h3v7.8h-1L9 10c.3-.1.5-.4.5-.7c0-.4-.3-.8-.7-.8h-2c-.5 0-.8.3-.8.7s.3.8.8.8h.6l2 4.2H7.9C7.6 12.4 6 11 4 11c-2.2 0-4 1.8-4 4s1.8 4 4 4c2 0 3.6-1.4 3.9-3.2h8.6c.2-2.4 2.1-4.3 4.5-4.3M6.4 15.8c-.3 1-1.3 1.8-2.4 1.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5c1.1 0 2.1.7 2.4 1.8H4v1.5h2.4M21 13c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3m0 4.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "bicycle-electric": {
            body: '<path fill="currentColor" d="M19 7c-.56 0-1.09.11-1.59.28L14.46 1.5H11V3h2.54l.88 1.72L12 10.13l-1.77-4.18c.27-.1.51-.37.51-.7c0-.41-.33-.75-.74-.75H8c-.42 0-.76.34-.76.75S7.58 6 8 6h.61l2.25 5.25h-.94C9.56 8.85 7.5 7 5 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.5 0 4.56-1.85 4.92-4.25h2.58l2.79-6.32l.79 1.53A4.976 4.976 0 0 0 14 12c0 2.76 2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5M5 15.5c-1.93 0-3.5-1.57-3.5-3.5S3.07 8.5 5 8.5c1.67 0 3.07 1.18 3.41 2.75H4v1.5h4.41A3.495 3.495 0 0 1 5 15.5m14 0c-1.93 0-3.5-1.57-3.5-3.5c0-1.08.5-2.03 1.27-2.67l1.8 3.52l1.32-.72l-1.79-3.5c.29-.07.59-.13.9-.13c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5M11 20H7l6 3v-2h4l-6-3v2Z"/>'
        },
        "bicycle-penny-farthing": {
            body: '<path fill="currentColor" d="M15.5 5.06V2H12v2h1.5v1.04c-.79.07-1.56.23-2.3.46c-.17-.3-.48-.5-.84-.5H7c-.55 0-1 .45-1 1s.45 1 1 1h1.05A11.5 11.5 0 0 0 3 16.18c-1.15.41-2 1.51-2 2.82c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.83-2.39-2-2.81c.07-1.52.46-2.94 1.14-4.19c-.09.5-.14 1-.14 1.5c0 4.69 3.81 8.5 8.5 8.5c4.69 0 8.5-3.81 8.5-8.5c0-4.36-3.28-7.94-7.5-8.44M4 20c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m10.5 0C10.92 20 8 17.08 8 13.5c0-3.24 2.39-5.93 5.5-6.41V15h2V7.09c3.11.48 5.5 3.17 5.5 6.41c0 3.58-2.92 6.5-6.5 6.5Z"/>'
        },
        bike: {
            body: '<path fill="currentColor" d="M5 20.5A3.5 3.5 0 0 1 1.5 17A3.5 3.5 0 0 1 5 13.5A3.5 3.5 0 0 1 8.5 17A3.5 3.5 0 0 1 5 20.5M5 12a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m9.8-2H19V8.2h-3.2l-1.94-3.27c-.29-.5-.86-.83-1.46-.83c-.47 0-.9.19-1.2.5L7.5 8.29C7.19 8.6 7 9 7 9.5c0 .63.33 1.16.85 1.47L11.2 13v5H13v-6.5l-2.25-1.65l2.32-2.35m5.93 13a3.5 3.5 0 0 1-3.5-3.5a3.5 3.5 0 0 1 3.5-3.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m0-8.5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m-3-7.2c1 0 1.8-.8 1.8-1.8S17 1.2 16 1.2S14.2 2 14.2 3S15 4.8 16 4.8Z"/>'
        },
        "bike-fast": {
            body: '<path fill="currentColor" d="M16 1.2c-1 0-1.8.8-1.8 1.8S15 4.8 16 4.8S17.8 4 17.8 3S17 1.2 16 1.2m-3.6 2.9c-.47 0-.9.19-1.2.5L7.5 8.29C7.19 8.6 7 9 7 9.5c0 .63.33 1.16.85 1.47L11.2 13v5H13v-6.5l-2.25-1.65l2.32-2.35L14.8 10H19V8.2h-3.2l-1.94-3.27c-.29-.5-.86-.83-1.46-.83M10 3H3c-.55 0-1-.45-1-1s.45-1 1-1h9.79c-.21.34-.38.71-.47 1.11c-.86.02-1.67.34-2.32.89m-5 9c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5M19 12c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5M5.32 11H1c-.552 0-1-.45-1-1s.448-1 1-1h4.05c-.02.16-.05.33-.05.5c0 .53.12 1.04.32 1.5M6 7H2c-.55 0-1-.45-1-1s.45-1 1-1h5.97L6.09 6.87C6.05 6.91 6 6.96 6 7Z"/>'
        },
        billboard: {
            body: '<path fill="currentColor" d="M20 22h-2v-5h2M6 22H4v-5h2M23 4v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2m-2 0H3v9h18m-1-7h-5v2h5m-2 1h-3v2h3m-4 0H4l2.73-3.64l2 2.73l.73-.54L8.2 7.82l1.71-2.27Z"/>'
        },
        billiards: {
            body: '<path fill="currentColor" d="M11 13h2v2h-2m0-6h2v2h-2m0 6h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 9 13.5V15a2 2 0 0 0 2 2m1-16C5.92 1 1 5.92 1 12s4.92 11 11 11s11-4.92 11-11S18.08 1 12 1m0 18a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7Z"/>'
        },
        "billiards-rack": {
            body: '<path fill="currentColor" d="m20.31 16.44l-5.77-9.97a2.978 2.978 0 0 0-4.08-1.09c-.46.26-.83.62-1.1 1.09L3.6 16.44a2.953 2.953 0 0 0 1.09 4.06c.45.28.96.42 1.49.42h11.55a2.992 2.992 0 0 0 2.98-3c0-.52-.14-1.03-.4-1.48m-14.94.99l5.74-9.96c.27-.47.89-.65 1.35-.37c.16.08.29.21.38.37l5.74 9.96c.27.48.11 1.07-.37 1.36c-.15.09-.32.14-.49.14H6.21c-.55-.01-1-.46-.99-1.01c0-.17.04-.34.13-.49h.02m6.6-3.98c-1.1 0-1.97-.89-1.97-1.99c0-1.11.87-2 1.97-2a2 2 0 0 1 2 2c0 1.1-.9 1.99-2.02 1.99h.02m-2.51 4.48c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99s2 .89 2 1.99s-.9 1.99-2 1.99m4.98 0a2 2 0 0 1-1.99-1.99a2 2 0 0 1 1.99-1.99c1.1 0 2 .89 2 1.99s-.9 1.99-2 1.99Z"/>'
        },
        binoculars: {
            body: '<path fill="currentColor" d="M11 6h2v7h-2V6M9 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5l2-9h4v7a1 1 0 0 1-1 1v6m1-15H7V3h3v2m5 15v-6a1 1 0 0 1-1-1V6h4l2 9v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1M14 5V3h3v2h-3Z"/>'
        },
        bio: {
            body: '<path fill="currentColor" d="M17 12h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 2v3h3v-3h-3M2 7h5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2V7m2 2v3h3V9H4m0 8h3v-3H4v3m7-4h2v6h-2v-6m0-4h2v2h-2V9Z"/>'
        },
        biohazard: {
            body: '<path fill="currentColor" d="M23 16.06c0 .23 0 .44-.04.64c-.18-2.56-2.32-4.59-4.96-4.59c-.37 0-.73.05-1.08.12c.04.27.08.5.08.77c0 2.35-1.69 4.32-3.93 4.81c.35 2.24 2.24 3.98 4.58 4.15c-.22.04-.43.04-.65.04c-2.08 0-3.93-1.06-5-2.66A6.005 6.005 0 0 1 7 22c-.22 0-.43 0-.65-.04c2.34-.17 4.22-1.9 4.58-4.15C8.68 17.32 7 15.35 7 13c0-.27.04-.5.07-.77c-.34-.07-.7-.12-1.07-.12a4.97 4.97 0 0 0-4.97 4.59C1 16.5 1 16.29 1 16.06c0-3.21 2.59-5.82 5.81-5.92A5.877 5.877 0 0 1 9.06 2C7.81 2.9 7 4.34 7 6c0 1.35.56 2.59 1.47 3.5c.91-.91 2.15-1.46 3.53-1.46c1.37 0 2.62.55 3.5 1.46c.93-.91 1.5-2.15 1.5-3.5c0-1.66-.82-3.1-2.06-4a5.877 5.877 0 0 1 2.25 8.14c3.23.1 5.81 2.71 5.81 5.92M9.27 10.11a5.003 5.003 0 0 0 5.46 0C14 9.45 13.06 9.03 12 9.03s-2 .42-2.73 1.08M12 14.47c.82 0 1.5-.67 1.5-1.47a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5c0 .8.67 1.47 1.5 1.47m-1.03 2.32c-.1-1.89-1.26-3.5-2.92-4.24c-.02.15-.05.29-.05.45c0 1.82 1.27 3.34 2.97 3.79m4.99-4.24A4.982 4.982 0 0 0 13 16.79c1.73-.45 3-1.97 3-3.79c0-.16-.03-.3-.04-.45Z"/>'
        },
        bird: {
            body: '<path fill="currentColor" d="m23 11.5l-3.05-1.13c-.26-1.15-.91-1.81-.91-1.81a4.189 4.189 0 0 0-5.93 0l-1.48 1.48L5 3c-1 4 0 8 2.45 11.22L2 19.5s8.89 2 14.07-2.05c2.76-2.16 3.38-3.42 3.77-4.75L23 11.5m-5.29.22c-.39.39-1.03.39-1.42 0a.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0c.39.39.39 1.02 0 1.41Z"/>'
        },
        bitbucket: {
            body: '<path fill="currentColor" d="M2.65 3C2.3 3 2 3.3 2 3.65v.12l2.73 16.5c.07.42.43.73.85.73h13.05c.31 0 .59-.22.64-.54L22 3.77a.643.643 0 0 0-.54-.73c-.03-.01-.07-.01-.11-.01L2.65 3M14.1 14.95H9.94L8.81 9.07h6.3l-1.01 5.88Z"/>'
        },
        bitcoin: {
            body: '<path fill="currentColor" d="M14.24 10.56c-.31 1.24-2.24.61-2.84.44l.55-2.18c.62.18 2.61.44 2.29 1.74m-3.11 1.56l-.6 2.41c.74.19 3.03.92 3.37-.44c.36-1.42-2.03-1.79-2.77-1.97m10.57 2.3c-1.34 5.36-6.76 8.62-12.12 7.28C4.22 20.36.963 14.94 2.3 9.58A9.996 9.996 0 0 1 14.42 2.3c5.35 1.34 8.61 6.76 7.28 12.12m-7.49-6.37l.45-1.8l-1.1-.25l-.44 1.73c-.29-.07-.58-.14-.88-.2l.44-1.77l-1.09-.26l-.45 1.79c-.24-.06-.48-.11-.7-.17l-1.51-.38l-.3 1.17s.82.19.8.2c.45.11.53.39.51.64l-1.23 4.93c-.05.14-.21.32-.5.27c.01.01-.8-.2-.8-.2L6.87 15l1.42.36c.27.07.53.14.79.2l-.46 1.82l1.1.28l.45-1.81c.3.08.59.15.87.23l-.45 1.79l1.1.28l.46-1.82c1.85.35 3.27.21 3.85-1.48c.5-1.35 0-2.15-1-2.66c.72-.19 1.26-.64 1.41-1.62c.2-1.33-.82-2.04-2.2-2.52Z"/>'
        },
        "black-mesa": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a7.99 7.99 0 0 0 2.71 6H9v-6h8l2.15 3.59c.54-1.09.85-2.3.85-3.59a8 8 0 0 0-8-8Z"/>'
        },
        blackberry: {
            body: '<path d="M5.45 10.28c.95 0 2.05.77 2.05 1.72s-1.1 1.72-2.05 1.72H2l.69-3.44h2.76m.69-5.52c.95 0 2.07.77 2.07 1.74c0 .93-1.12 1.71-2.07 1.71H2.69l.69-3.45h2.76m6.89 0c.97 0 2.07.77 2.07 1.74c0 .93-1.1 1.71-2.07 1.71H9.41l.69-3.45h2.93m-.69 5.52c.96 0 2.07.77 2.07 1.72s-1.11 1.72-2.07 1.72H8.72l.69-3.44h2.93m-1.37 5.51c.95 0 2.06.78 2.06 1.71c0 .97-1.11 1.74-2.06 1.74H7.5l.71-3.45h2.76m7.58-2.07c.95 0 2.07.78 2.07 1.73s-1.12 1.72-2.07 1.72H15.1l.69-3.45h2.76m1.38-5.51c.95 0 2.07.79 2.07 1.72c0 .95-1.12 1.73-2.07 1.73H16.5l.67-3.45h2.76z" fill="currentColor"/>',
            hidden: true
        },
        blender: {
            body: '<path fill="currentColor" d="M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87M5 9V5h1.31l.62 4H5m7 10c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m2.29-5H9.72L8.33 5h7.34l-1.38 9Z"/>'
        },
        "blender-outline": {
            body: '<path fill="currentColor" d="M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87M5 9V5h1.31l.62 4H5m10.67-4l-1.38 9H9.72L8.33 5h7.34M16 20H8v-1c0-1.65 1.35-3 3-3h2c1.65 0 3 1.35 3 3v1m-4-3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "blender-software": {
            body: '<path fill="currentColor" d="M12.58 3.12v.01c-.31 0-.62.09-.87.26c-.5.35-.56.93-.11 1.3L14.46 7l-8.73.03h-.01C5 7.03 4.3 7.5 4.16 8.1c-.16.61.34 1.12 1.1 1.12l4.43-.01l-7.93 6.09c-.76.57-.99 1.52-.52 2.12c.48.61 1.49.61 2.26 0l4.3-3.53s-.07.48-.06.76c0 .29.1.85.23 1.28c.29.93.78 1.78 1.46 2.53c.7.77 1.57 1.39 2.57 1.83c1.03.47 2.17.71 3.34.71c1.16 0 2.31-.25 3.35-.72c1-.44 1.86-1.07 2.56-1.84c.68-.75 1.17-1.61 1.46-2.53c.14-.47.23-.94.29-1.41c0-.47 0-.94-.06-1.41c-.13-.91-.44-1.77-.94-2.55c-.44-.71-1-1.34-1.69-1.87l-6.89-5.29a1.42 1.42 0 0 0-.84-.26m2.76 6.09c1.16 0 2.25.38 3.12 1.08c.44.36.79.78 1.04 1.25c.27.46.44 1.01.5 1.57c.04.56-.04 1.12-.23 1.66c-.2.54-.52 1.04-.95 1.49c-.89.9-2.13 1.42-3.48 1.42c-1.34 0-2.59-.51-3.48-1.41c-.43-.44-.75-.95-.95-1.49a3.89 3.89 0 0 1-.22-1.66c.05-.56.22-1.09.48-1.57c.26-.47.62-.89 1.06-1.25c.86-.71 1.96-1.09 3.11-1.09m.1 1.4c-.78 0-1.5.28-2.03.73c-.54.46-.91 1.1-.94 1.84c-.04.75.26 1.45.79 1.97c.54.53 1.32.85 2.18.85c.86 0 1.63-.32 2.18-.85c.53-.52.83-1.22.79-1.97c-.04-.74-.41-1.38-.94-1.84c-.53-.45-1.25-.73-2.03-.73Z"/>'
        },
        blinds: {
            body: '<path fill="currentColor" d="M3 2h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1v7a1 1 0 0 1-1 1h-6v2.17c1.17.41 2 1.52 2 2.83a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V14H5a1 1 0 0 1-1-1V6H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m9 16a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "blinds-horizontal": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h20v-2h-2M16 9h2v2h-2V9m-2 2H6V9h8v2m4-4h-2V5h2v2m-4-2v2H6V5h8M6 19v-6h8v1.82A1.746 1.746 0 0 0 15 18a1.746 1.746 0 0 0 1-3.18V13h2v6H6Z"/>'
        },
        "blinds-horizontal-closed": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h11.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2m-2-8h-2V9h2v2m-4 0H6V9h8v2m0 2v2H6v-2h8m2 0h2v2h-2v-2m2-6h-2V5h2v2m-4-2v2H6V5h8M6 19v-2h8v2H6m10 0v-2h2v2h-2Z"/>'
        },
        "blinds-open": {
            body: '<path fill="currentColor" d="M3 2h18c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-1v1c0 .55-.45 1-1 1h-6v2.17A3 3 0 0 1 15 13c0 1.66-1.34 3-3 3s-3-1.34-3-3c0-1.31.84-2.42 2-2.83V8H5c-.55 0-1-.45-1-1V6H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m9 10c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "blinds-vertical": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h20v-2h-2m-10 0V5h4v14h-4Z"/>'
        },
        "blinds-vertical-closed": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h20v-2h-2M13 5h1.5v14H13V5m-2 14H9.5V5H11v14M6 5h1.5v14H6V5m10.5 14V5H18v14h-1.5Z"/>'
        },
        "block-helper": {
            body: '<path fill="currentColor" d="M12 0a12 12 0 0 1 12 12a12 12 0 0 1-12 12A12 12 0 0 1 0 12A12 12 0 0 1 12 0m0 2A10 10 0 0 0 2 12c0 2.4.85 4.6 2.26 6.33L18.33 4.26A9.984 9.984 0 0 0 12 2m0 20a10 10 0 0 0 10-10c0-2.4-.85-4.6-2.26-6.33L5.67 19.74A9.984 9.984 0 0 0 12 22Z"/>'
        },
        blogger: {
            body: '<path d="M12.5 10H10c-.55 0-1-.45-1-1s.45-1 1-1h2.5c.55 0 1 .45 1 1s-.45 1-1 1m2.5 4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1m7-10v16c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2V4c0-1.11.89-2 2-2h16c1.11 0 2 .89 2 2m-4 8s0-1-1-1c-.95.03-1-1-1-1V8c0-1.66-1.34-3-3-3H9C7.34 5 6 6.34 6 8v7c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3v-3z" fill="currentColor"/>',
            hidden: true
        },
        "blood-bag": {
            body: '<path fill="currentColor" d="M21 7c-1 0-1-1-1-1V5h-2v2h-2V6c0-1.73-1.25-5-6-5S4 4.27 4 6v13c0 .33-.1 2-2 2v2c2.93 0 4-2.39 4-4V6c0-.12.05-3 4-3c3.83 0 4 2.7 4 3v1h-2V5h-2v1s0 1-1 1s-1 1-1 1v12s0 2 5 2h4c5 0 5-2 5-2V8s0-1-1-1m-6 12.4a3 3 0 0 1-3-3c0-2 3-5.4 3-5.4s3 3.4 3 5.4a3 3 0 0 1-3 3Z"/>'
        },
        bluetooth: {
            body: '<path fill="currentColor" d="M14.88 16.29L13 18.17v-3.76m0-8.58l1.88 1.88L13 9.58m4.71-1.87L12 2h-1v7.58L6.41 5L5 6.41L10.59 12L5 17.58L6.41 19L11 14.41V22h1l5.71-5.71l-4.3-4.29l4.3-4.29Z"/>'
        },
        "bluetooth-audio": {
            body: '<path fill="currentColor" d="M12.88 16.29L11 18.17v-3.76m0-8.58l1.88 1.88L11 9.58m4.71-1.87L10 2H9v7.58L4.41 5L3 6.41L8.59 12L3 17.58L4.41 19L9 14.41V22h1l5.71-5.71l-4.3-4.29m8.12-5.29L18.26 8c.63 1.18.99 2.55.99 4c0 1.45-.36 2.82-.99 4l1.2 1.22A9.91 9.91 0 0 0 21 11.91c0-1.91-.54-3.68-1.47-5.2M14.24 12l2.32 2.33c.28-.73.44-1.51.44-2.33c0-.82-.16-1.6-.43-2.32L14.24 12Z"/>'
        },
        "bluetooth-connect": {
            body: '<path fill="currentColor" d="m19 10l-2 2l2 2l2-2m-6.12 4.29L13 18.17v-3.76m0-8.58l1.88 1.88L13 9.58m4.71-1.87L12 2h-1v7.58L6.41 5L5 6.41L10.59 12L5 17.58L6.41 19L11 14.41V22h1l5.71-5.71l-4.3-4.29M7 12l-2-2l-2 2l2 2l2-2Z"/>'
        },
        "bluetooth-off": {
            body: '<path fill="currentColor" d="m13 5.83l1.88 1.88l-1.6 1.6l1.41 1.41l3.02-3.02L12 2h-1v5.03l2 2M5.41 4L4 5.41L10.59 12L5 17.59L6.41 19L11 14.41V22h1l4.29-4.29l2.3 2.29L20 18.59m-7-.42v-3.76l1.88 1.88"/>'
        },
        "bluetooth-settings": {
            body: '<path fill="currentColor" d="M14.88 14.29L13 16.17v-3.76l1.88 1.88M13 3.83l1.88 1.88L13 7.59m4.71-1.88L12 0h-1v7.59L6.41 3L5 4.41L10.59 10L5 15.59L6.41 17L11 12.41V20h1l5.71-5.71l-4.3-4.29l4.3-4.29M15 24h2v-2h-2m-8 2h2v-2H7m4 2h2v-2h-2v2Z"/>'
        },
        "bluetooth-transfer": {
            body: '<path fill="currentColor" d="M14.71 7.71L10.41 12l4.3 4.29L9 22H8v-7.59L3.41 19L2 17.59L7.59 12L2 6.41L3.41 5L8 9.59V2h1l5.71 5.71M10 5.83v3.76l1.88-1.88L10 5.83m1.88 10.46L10 14.41v3.76l1.88-1.88M22 8h-2v3h-2V8h-2l3-4l3 4m0 8l-3 4l-3-4h2v-3h2v3h2Z"/>'
        },
        blur: {
            body: '<path fill="currentColor" d="M14 8.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 14 8.5m0 4a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-8.5A1.5 1.5 0 0 0 8.5 10a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 10 8.5m4 12a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m0-3.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m7-3.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M18 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-8-.5A1.5 1.5 0 0 0 8.5 14a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m0 17a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-7-7a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m11-10a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M14 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m7 3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M6 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M3 9.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M6 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "blur-linear": {
            body: '<path fill="currentColor" d="M13 17a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-4a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-4a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m4 3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m0-4a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M3 3v2h18V3m-4 13.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M9 17a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m-4-3.5A1.5 1.5 0 0 0 6.5 12A1.5 1.5 0 0 0 5 10.5A1.5 1.5 0 0 0 3.5 12A1.5 1.5 0 0 0 5 13.5m0-4A1.5 1.5 0 0 0 6.5 8A1.5 1.5 0 0 0 5 6.5A1.5 1.5 0 0 0 3.5 8A1.5 1.5 0 0 0 5 9.5M3 21h18v-2H3M9 9a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0 4a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m-4 4.5A1.5 1.5 0 0 0 6.5 16A1.5 1.5 0 0 0 5 14.5A1.5 1.5 0 0 0 3.5 16A1.5 1.5 0 0 0 5 17.5Z"/>'
        },
        "blur-off": {
            body: '<path fill="currentColor" d="M3 13.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M6 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m4 3.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-7-11a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M6 13a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m15 .5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M10 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M2.5 5.27l3.78 3.78L6 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47a1.5 1.5 0 0 0 1.5 1.5c.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0 0 14 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23L3.77 4L2.5 5.27M14 20.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M18 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0 4a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0 4a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m-8-8a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m11 3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m-11-7a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m4 0a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m-.2 8h.2a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 14 8.5a1.5 1.5 0 0 0-1.5 1.5v.2c.11.67.63 1.19 1.3 1.3M14 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1Z"/>'
        },
        "blur-radial": {
            body: '<path fill="currentColor" d="M14 13a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 3.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m5 7.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m0 4a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-3-6a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M14 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-4-1.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m-3 6a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m3 3a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-3-7a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m3 3.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        bolt: {
            body: '<path fill="currentColor" d="M14 17.7V21h-4v-.7l4-2.6M17 3H7v3h10V3m-2 4l-1 .7V7h-4v3.3L9 11v1l6-3.9V7m0 4l-1 .7v-2l-4 2.7v2L9 15v1l6-3.9V11m0 4l-1 .7v-2l-4 2.7v2L9 19v1l6-3.9V15Z"/>'
        },
        bomb: {
            body: '<path fill="currentColor" d="M11.25 6a3.25 3.25 0 0 1 3.25-3.25A3.25 3.25 0 0 1 17.75 6c0 .42.33.75.75.75s.75-.33.75-.75v-.75h1.5V6a2.25 2.25 0 0 1-2.25 2.25A2.25 2.25 0 0 1 16.25 6a1.75 1.75 0 0 0-1.75-1.75A1.75 1.75 0 0 0 12.75 6H14v1.29c2.89.86 5 3.54 5 6.71a7 7 0 0 1-7 7a7 7 0 0 1-7-7c0-3.17 2.11-5.85 5-6.71V6h1.25M22 6h2v1h-2V6m-3-2V2h1v2h-1m1.91.38l1.42-1.42l.71.71l-1.42 1.42l-.71-.71Z"/>'
        },
        "bomb-off": {
            body: '<path fill="currentColor" d="M14.5 2.75c-1.8 0-3.25 1.45-3.25 3.25H10v1.29c-.69.21-1.33.52-1.92.91l9.71 9.71A6.918 6.918 0 0 0 19 14c0-3.17-2.11-5.85-5-6.71V6h-1.25a1.75 1.75 0 0 1 1.75-1.75A1.75 1.75 0 0 1 16.25 6a2.25 2.25 0 0 0 2.25 2.25c1.24 0 2.24-1.01 2.24-2.25v-.75h-1.49V6c0 .42-.34.75-.75.75c-.42 0-.75-.33-.75-.75c0-1.8-1.46-3.25-3.25-3.25M3.41 6.36L2 7.77l3.55 3.55C5.2 12.14 5 13.04 5 14c0 3.86 3.13 7 7 7c.92 0 1.83-.19 2.68-.55L18.23 24l1.41-1.41L3.41 6.36Z"/>'
        },
        bone: {
            body: '<path fill="currentColor" d="M8 14a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-.77.29-1.47.76-2c-.47-.53-.76-1.23-.76-2a3 3 0 0 1 3-3a3 3 0 0 1 3 3c1.33.08 2.67.17 4 .17s2.67-.09 4-.17a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 .77-.29 1.47-.76 2c.47.53.76 1.23.76 2a3 3 0 0 1-3 3a3 3 0 0 1-3-3c-1.33-.08-2.67-.17-4-.17s-2.67.09-4 .17Z"/>'
        },
        "bone-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4 4H5c-1.7 0-3 1.3-3 3c0 .8.3 1.5.8 2c-.5.5-.8 1.2-.8 2c0 1.7 1.3 3 3 3s3-1.3 3-3c1.3-.1 2.6-.2 3.9-.2l8.9 8.9l1.3-1.2M20 16.8l-6.7-6.7c.9 0 1.8-.1 2.7-.1c0-1.7 1.3-3 3-3s3 1.3 3 3c0 .8-.3 1.5-.8 2c.5.5.8 1.2.8 2c0 1.3-.8 2.4-2 2.8Z"/>'
        },
        book: {
            body: '<path fill="currentColor" d="M18 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-6v7L9.5 7.5L7 9V2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12Z"/>'
        },
        "book-account": {
            body: '<path fill="currentColor" d="M18 2h-6v7L9.5 7.5L7 9V2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-4 10a2 2 0 1 1-2 2a2 2 0 0 1 2-2m4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2Z"/>'
        },
        "book-account-outline": {
            body: '<path fill="currentColor" d="M18 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12m0 2h-5v5l-2.5-2.3L8 9V4H6v16h12m-5-9a2 2 0 1 1-2 2a2 2 0 0 1 2-2m4 8H9v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1"/>'
        },
        "book-alert": {
            body: '<path fill="currentColor" d="M18 4v16c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h1v7l2.5-1.5L10 9V2h6a2 2 0 0 1 2 2m2 13h2v-2h-2v2m0-10v6h2V7h-2Z"/>'
        },
        "book-alert-outline": {
            body: '<path fill="currentColor" d="M16 2H4c-1.1 0-2 .9-2 2v16a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 18H4V4h2v8l2.5-2.25L11 12V4h5v16m4-5h2v2h-2v-2m2-8v6h-2V7h2Z"/>'
        },
        "book-alphabet": {
            body: '<path fill="currentColor" d="M5.81 2C4.83 2.09 4 3 4 4v16c0 1.05.95 2 2 2h12c1.05 0 2-.95 2-2V4a2 2 0 0 0-2-2h-6v7L9.5 7.5L7 9V2H5.81M12 13h1a1 1 0 0 1 1 1v4h-1v-2h-1v2h-1v-4a1 1 0 0 1 1-1m0 1v1h1v-1h-1m3 1h3v1l-2 3h2v1h-3v-1l2-3h-2v-1Z"/>'
        },
        "book-arrow-down": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m7 1v-4h-2v4h-2l3 3l3-3h-2Z"/>'
        },
        "book-arrow-down-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M20 20v-4h-2v4h-2l3 3l3-3h-2Z"/>'
        },
        "book-arrow-left": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m5-1v-2l-3 3l3 3v-2h4v-2h-4Z"/>'
        },
        "book-arrow-left-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M18 18v-2l-3 3l3 3v-2h4v-2h-4Z"/>'
        },
        "book-arrow-right": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m10 0l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "book-arrow-right-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M23 19l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "book-arrow-up": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m6-4l-3 3h2v4h2v-4h2l-3-3Z"/>'
        },
        "book-arrow-up-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M19 15l-3 3h2v4h2v-4h2l-3-3Z"/>'
        },
        "book-cancel": {
            body: '<path fill="currentColor" d="M12 18.5c0 1.29.39 2.5 1.04 3.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v8.18c-.5-.11-1-.18-1.5-.18a6.5 6.5 0 0 0-6.5 6.5m11 0c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "book-cancel-outline": {
            body: '<path fill="currentColor" d="M12.18 20c.18.72.47 1.39.86 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8.18c-.5-.11-1-.18-1.5-.18c-.17 0-.33 0-.5.03V4h-5v8l-2.5-2.25L8 12V4H6v16h6.18M23 18.5c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "book-check": {
            body: '<path fill="currentColor" d="m16.75 22.16l-2.75-3L15.16 18l1.59 1.59L20.34 16l1.16 1.41l-4.75 4.75M6 22a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.34A6.005 6.005 0 0 0 12.8 22H6Z"/>'
        },
        "book-check-outline": {
            body: '<path fill="currentColor" d="m16.75 22.16l-2.75-3L15.16 18l1.59 1.59L20.34 16l1.16 1.41l-4.75 4.75M18 2c1.1 0 2 .9 2 2v9.34c-.63-.22-1.3-.34-2-.34V4h-5v8l-2.5-2.25L8 12V4H6v16h6.08c.12.72.37 1.39.72 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12Z"/>'
        },
        "book-clock": {
            body: '<path fill="currentColor" d="m16.5 17.25l2.86 1.69l-.75 1.22L15 18v-5h1.5v4.25M23 17c0 3.87-3.13 7-7 7c-1.91 0-3.63-.76-4.89-2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v7.26c1.81 1.27 3 3.36 3 5.74m-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "book-clock-outline": {
            body: '<path fill="currentColor" d="M20 11.26V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h5.11c1.26 1.24 2.98 2 4.89 2c3.87 0 7-3.13 7-7c0-2.38-1.19-4.47-3-5.74M18 4v6.29c-.63-.18-1.3-.29-2-.29c-1.07 0-2.09.25-3 .68V4h5M6 4h2v8l2.5-2.25l1.6 1.44A6.993 6.993 0 0 0 9 17c0 1.08.25 2.09.68 3H6V4m10 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 18v-5h1.5v4.25Z"/>'
        },
        "book-cog": {
            body: '<path fill="currentColor" d="M12 19c0 1.08.25 2.09.68 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v8.08c-.33-.05-.66-.08-1-.08c-3.87 0-7 3.13-7 7m11.8 1.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "book-cog-outline": {
            body: '<path fill="currentColor" d="M18 4h-5v8l-2.5-2.25L8 12V4H6v16h6.08c.1.71.31 1.38.61 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8.08c-.33-.05-.66-.08-1-.08c-.34 0-.67.03-1 .08V4m5.8 16.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "book-cross": {
            body: '<path fill="currentColor" d="M5.81 2H7v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v16c0 1.05-.95 2-2 2H6c-1.05 0-2-.95-2-2V4c0-1 .83-1.91 1.81-2M13 10v3h-3v2h3v5h2v-5h3v-2h-3v-3h-2Z"/>'
        },
        "book-edit": {
            body: '<path fill="currentColor" d="M19.39 10.74L11 19.13V22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v6.3c-.22.12-.43.26-.61.44M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "book-edit-outline": {
            body: '<path fill="currentColor" d="M6 20h5v2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6.3c-.22.12-.43.26-.61.44L18 12.13V4h-5v8l-2.5-2.25L8 12V4H6v16m16.85-6.53l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96Z"/>'
        },
        "book-education": {
            body: '<path fill="currentColor" d="M8.82 17L13 19.28V22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v8.54l-1.5-.82L8.82 17M24 17l-5.5-3l-5.5 3l5.5 3l5.5-3m-9 2.09v2L18.5 23l3.5-1.91v-2L18.5 21L15 19.09Z"/>'
        },
        "book-education-outline": {
            body: '<path fill="currentColor" d="M6 20h7v2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8.54l-1.5-.82l-.5.28V4h-5v8l-2.5-2.25L8 12V4H6v16m18-3l-5.5-3l-5.5 3l5.5 3l5.5-3m-9 2.09v2L18.5 23l3.5-1.91v-2L18.5 21L15 19.09Z"/>'
        },
        "book-heart": {
            body: '<path fill="currentColor" d="m19 23.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M6 22a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.08L19 13a6.005 6.005 0 0 0-5.2 9H6Z"/>'
        },
        "book-heart-outline": {
            body: '<path fill="currentColor" d="m19 23.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M18 2c1.1 0 2 .9 2 2v9.08L19 13l-1 .08V4h-5v8l-2.5-2.25L8 12V4H6v16h7.08c.12.72.37 1.39.72 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12Z"/>'
        },
        "book-information-variant": {
            body: '<path fill="currentColor" d="M18 2h-6v7L9.5 7.5L7 9V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4a2 2 0 0 0-2-2m-.32 16.41c-.11.09-1.21.84-1.63 1.09c-.42.29-2.05 1.22-1.79-.58c.63-3.64 1.85-5.8.39-4.86c-.38.23-.6.37-.74.44c-.13.11-.12.1-.23-.09s-.15-.18-.01-.28c0 0 2.23-1.79 3.05-1.85c.78-.07.59.89.52 1.33c-.46 1.85-1.3 4.54-1.17 4.93c.11.39.93-.23 1.37-.54c0 0 .06-.07.17.05c.11.17.22.25.07.36m-.71-7.35c-.57 0-1.03-.46-1.03-1.03c0-.57.46-1.03 1.03-1.03c.57 0 1.03.46 1.03 1.03c0 .57-.46 1.03-1.03 1.03Z"/>'
        },
        "book-lock": {
            body: '<path fill="currentColor" d="M14.2 14.5v.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .46.1.9.27 1.3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v6.11c-.32-.07-.66-.11-1-.11c-2.6 0-4.8 2.06-4.8 4.5m8.8 2.8v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "book-lock-open": {
            body: '<path fill="currentColor" d="M14.2 13.5v1.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .46.1.9.27 1.3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v5.11c-.32-.07-.66-.11-1-.11c-2.6 0-4.8 2.06-4.8 4.5m7.6 2.5h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "book-lock-open-outline": {
            body: '<path fill="currentColor" d="M13 20.7c0 .46.1.9.27 1.3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5.11c-.32-.07-.66-.11-1-.11s-.68.04-1 .11V4h-5v8l-2.5-2.25L8 12V4H6v16h7v.7m8.8-4.7h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "book-lock-outline": {
            body: '<path fill="currentColor" d="M13 20.7c0 .46.1.9.27 1.3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6.11c-.32-.07-.66-.11-1-.11s-.68.04-1 .11V4h-5v8l-2.5-2.25L8 12V4H6v16h7v.7m10-3.4v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "book-marker": {
            body: '<path fill="currentColor" d="M13 15.5c0 2.28 1.7 4.91 2.91 6.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v6.22c-.5-.14-1-.22-1.5-.22c-3 0-5.5 2.5-5.5 5.5m9 0c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "book-marker-outline": {
            body: '<path fill="currentColor" d="M14.55 20c.45.76.95 1.44 1.36 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6.22c-.5-.14-1-.22-1.5-.22c-.17 0-.33 0-.5.03V4h-5v8l-2.5-2.25L8 12V4H6v16h8.55M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "book-minus": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m2-1v2h8v-2h-8Z"/>'
        },
        "book-minus-multiple": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.46 5.46 0 0 1-.72-2M19 2h-5v5l-2-1.5L10 7V2H9c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4.09A6 6 0 0 1 20 13.08c.34.06.68.15 1 .26V4a2 2 0 0 0-2-2m4 16v2h-8v-2h8Z"/>'
        },
        "book-minus-multiple-outline": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.46 5.46 0 0 1-.72-2M19 2H9c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4.09c.11-.71.35-1.39.72-2H9V4h2v6l2.5-2.25L16 10V4h3v9c.68 0 1.36.11 2 .34V4a2 2 0 0 0-2-2m4 16v2h-8v-2h8Z"/>'
        },
        "book-minus-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M15 18v2h8v-2h-8Z"/>'
        },
        "book-multiple": {
            body: '<path fill="currentColor" d="M19 18H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v5l2-1.5L14 7V2h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2m-2 2v2H5a2 2 0 0 1-2-2V6h2v14h12Z"/>'
        },
        "book-multiple-minus": {
            body: '<path d="M9 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-5v5l-2-1.5L10 7V2H9zM3 6v14a2 2 0 0 0 2 2h12v-2H5V6H3zm16 6v2h-6v-2h6z" fill="currentColor"/>',
            hidden: true
        },
        "book-multiple-outline": {
            body: '<path fill="currentColor" d="M19 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10m0 2h-3v6l-2.5-2.25L11 10V4H9v12h10M3 20a2 2 0 0 0 2 2h12v-2H5V6H3Z"/>'
        },
        "book-multiple-plus": {
            body: '<path d="M9 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-5v5l-2-1.5L10 7V2H9zM3 6v14a2 2 0 0 0 2 2h12v-2H5V6H3zm12 4h2v2h2v2h-2v2h-2v-2h-2v-2h2v-2z" fill="currentColor"/>',
            hidden: true
        },
        "book-multiple-remove": {
            body: '<path d="M9 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-5v5l-2-1.5L10 7V2H9zM3 6v14a2 2 0 0 0 2 2h12v-2H5V6H3zm11.586 4.172L16 11.586l1.414-1.414l1.414 1.414L17.414 13l1.414 1.414l-1.414 1.414L16 14.414l-1.414 1.414l-1.414-1.414L14.586 13l-1.414-1.414l1.414-1.414z" fill="currentColor"/>',
            hidden: true
        },
        "book-multiple-variant": {
            body: '<path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z" fill="currentColor"/>',
            hidden: true
        },
        "book-music": {
            body: '<path fill="currentColor" d="M13 20.5c0 .53.09 1.03.26 1.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v7h-3.5v5.11c-2 .46-3.5 2.25-3.5 4.39m7-7.5h-1.5v5.21a2.5 2.5 0 1 0-1 4.79a2.5 2.5 0 0 0 2.5-2.5V15h2v-2h-2Z"/>'
        },
        "book-music-outline": {
            body: '<path fill="currentColor" d="M13 20.5c0 .53.09 1.03.26 1.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7h-2V4h-5v8l-2.5-2.25L8 12V4H6v16h7.04c-.01.17-.04.33-.04.5m7-7.5h-1.5v5.21a2.5 2.5 0 1 0-1 4.79a2.5 2.5 0 0 0 2.5-2.5V15h2v-2h-2Z"/>'
        },
        "book-off": {
            body: '<path fill="currentColor" d="M18.68 2.12L12 8.8V2h6c.24 0 .46.05.68.12M9.5 7.5L7 9V2H6a2 2 0 0 0-2 2v12.8l7.88-7.87L9.5 7.5m12.11-5.77L1.89 21.46l1.27 1.27l1.38-1.38c.36.4.88.65 1.46.65h12c1.11 0 2-.89 2-2V5.89L22.89 3l-1.28-1.27Z"/>'
        },
        "book-off-outline": {
            body: '<path fill="currentColor" d="m6 14.8l-2 2V4a2 2 0 0 1 2-2h12c.24 0 .47.04.68.12L16.8 4H13v3.8L10.79 10l-.29-.25L8 12V4H6v10.8M22.89 3L20 5.89V20c0 1.11-.89 2-2 2H6c-.58 0-1.1-.25-1.46-.65l-1.38 1.38l-1.27-1.27L21.61 1.73L22.89 3M18 7.89l-12 12V20h12V7.89Z"/>'
        },
        "book-open": {
            body: '<path fill="currentColor" d="M13 12h7v1.5h-7m0-4h7V11h-7m0 3.5h7V16h-7m8-12H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 15h-9V6h9"/>'
        },
        "book-open-blank-variant": {
            body: '<path fill="currentColor" d="M21 5c-1.11-.35-2.33-.5-3.5-.5c-1.95 0-4.05.4-5.5 1.5c-1.45-1.1-3.55-1.5-5.5-1.5c-1.95 0-4.05.4-5.5 1.5v14.65c0 .25.25.5.5.5c.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5c1.35-.85 3.8-1.5 5.5-1.5c1.65 0 3.35.3 4.75 1.05c.1.05.15.05.25.05c.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1m0 13.5c-1.1-.35-2.3-.5-3.5-.5c-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5c1.2 0 2.4.15 3.5.5v11.5Z"/>'
        },
        "book-open-outline": {
            body: '<path fill="currentColor" d="M21 4H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M3 19V6h8v13H3m18 0h-8V6h8v13m-7-9.5h6V11h-6V9.5m0 2.5h6v1.5h-6V12m0 2.5h6V16h-6v-1.5Z"/>'
        },
        "book-open-page-variant": {
            body: '<path fill="currentColor" d="m19 2l-5 4.5v11l5-4.5V2M6.5 5C4.55 5 2.45 5.4 1 6.5v14.66c0 .25.25.5.5.5c.1 0 .15-.07.25-.07c1.35-.65 3.3-1.09 4.75-1.09c1.95 0 4.05.4 5.5 1.5c1.35-.85 3.8-1.5 5.5-1.5c1.65 0 3.35.31 4.75 1.06c.1.05.15.03.25.03c.25 0 .5-.25.5-.5V6.5c-.6-.45-1.25-.75-2-1V19c-1.1-.35-2.3-.5-3.5-.5c-1.7 0-4.15.65-5.5 1.5V6.5C10.55 5.4 8.45 5 6.5 5Z"/>'
        },
        "book-open-page-variant-outline": {
            body: '<path fill="currentColor" d="m19 1l-5 5v11l5-4.5V1m2 4v13.5c-1.1-.35-2.3-.5-3.5-.5c-1.7 0-4.15.65-5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5c-1.95 0-4.05.4-5.5 1.5v14.65c0 .25.25.5.5.5c.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5c1.35-.85 3.8-1.5 5.5-1.5c1.65 0 3.35.3 4.75 1.05c.1.05.15.05.25.05c.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1M10 18.41C8.75 18.09 7.5 18 6.5 18c-1.06 0-2.32.19-3.5.5V7.13c.91-.4 2.14-.63 3.5-.63c1.36 0 2.59.23 3.5.63v11.28Z"/>'
        },
        "book-open-variant": {
            body: '<path fill="currentColor" d="M17.5 14.33c.79 0 1.63.08 2.5.24v1.5c-.62-.16-1.46-.24-2.5-.24c-1.9 0-3.39.33-4.5.99v-1.69c1.17-.53 2.67-.8 4.5-.8M13 12.46c1.29-.53 2.79-.79 4.5-.79c.79 0 1.63.07 2.5.23v1.5c-.62-.16-1.46-.24-2.5-.24c-1.9 0-3.39.34-4.5.99m4.5-3.65c-1.9 0-3.39.32-4.5 1V9.84c1.23-.56 2.73-.84 4.5-.84c.79 0 1.63.08 2.5.23v1.55c-.74-.19-1.59-.28-2.5-.28m3.5 8V7c-1.04-.33-2.21-.5-3.5-.5c-2.05 0-3.88.5-5.5 1.5v11.5c1.62-1 3.45-1.5 5.5-1.5c1.19 0 2.36.16 3.5.5m-3.5-14c2.35 0 4.19.5 5.5 1.5v14.56c0 .12-.05.24-.16.35c-.11.09-.23.17-.34.17c-.11 0-.19-.02-.25-.05c-1.28-.69-2.87-1.03-4.75-1.03c-2.05 0-3.88.5-5.5 1.5c-1.34-1-3.17-1.5-5.5-1.5c-1.66 0-3.25.36-4.75 1.07c-.03.01-.07.01-.12.03c-.04.01-.08.02-.13.02c-.11 0-.23-.04-.34-.12a.475.475 0 0 1-.16-.35V6c1.34-1 3.18-1.5 5.5-1.5c2.33 0 4.16.5 5.5 1.5c1.34-1 3.17-1.5 5.5-1.5Z"/>'
        },
        "book-outline": {
            body: '<path fill="currentColor" d="M18 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12m0 2h-5v8l-2.5-2.25L8 12V4H6v16h12V4Z"/>'
        },
        "book-play": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m4-3v6l5-3l-5-3Z"/>'
        },
        "book-play-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M17 16v6l5-3l-5-3Z"/>'
        },
        "book-plus": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "book-plus-multiple": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.5 5.5 0 0 1-.72-2M19 2h-5v5l-2-1.5L10 7V2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.09A6 6 0 0 1 21 13.34V4a2 2 0 0 0-2-2m1 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "book-plus-multiple-outline": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.5 5.5 0 0 1-.72-2M19 2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.09a5.5 5.5 0 0 1 .72-2H9V4h2v6l2.5-2.25L16 10V4h3v9a6 6 0 0 1 2 .34V4a2 2 0 0 0-2-2m1 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "book-plus-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "book-refresh": {
            body: '<path fill="currentColor" d="M12 18.5c0 1.29.39 2.5 1.04 3.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v8.18c-.5-.11-1-.18-1.5-.18a6.5 6.5 0 0 0-6.5 6.5m10 0v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "book-refresh-outline": {
            body: '<path fill="currentColor" d="M12.18 20c.18.72.47 1.39.86 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8.18c-.5-.11-1-.18-1.5-.18c-.17 0-.33 0-.5.03V4h-5v8l-2.5-2.25L8 12V4H6v16h6.18M22 18.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "book-remove": {
            body: '<path fill="currentColor" d="M13 19c0 1.1.3 2.12.81 3H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-3.31 0-6 2.69-6 6m9.54-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "book-remove-multiple": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.5 5.5 0 0 1-.72-2M19 2h-5v5l-2-1.5L10 7V2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.09A6 6 0 0 1 21 13.34V4a2 2 0 0 0-2-2m3.54 14.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.13-2.12l1.42-1.42L19 17.59l2.12-2.13Z"/>'
        },
        "book-remove-multiple-outline": {
            body: '<path fill="currentColor" d="M13.09 20H5V6H3v14a2 2 0 0 0 2 2h8.81a5.5 5.5 0 0 1-.72-2M19 2H9a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.09a5.5 5.5 0 0 1 .72-2H9V4h2v6l2.5-2.25L16 10V4h3v9a6 6 0 0 1 2 .34V4a2 2 0 0 0-2-2m3.54 14.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.13-2.12l1.42-1.42L19 17.59l2.12-2.13Z"/>'
        },
        "book-remove-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V4h-5v8l-2.5-2.25L8 12V4H6v16h7.09m9.45-3.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "book-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v7.81A6.48 6.48 0 0 0 15.5 10A6.5 6.5 0 0 0 9 16.5c0 2.31 1.21 4.35 3.03 5.5H6Z"/>'
        },
        "book-search-outline": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M13 4v8l-2.5-2.25L8 12V4H6v16h4c.54.81 1.23 1.5 2.03 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7.81c-.58-.55-1.25-1-2-1.31V4h-5Z"/>'
        },
        "book-settings": {
            body: '<path fill="currentColor" d="M20 2v16c0 1.11-.89 2-2 2H6c-1.11 0-2-.89-2-2V2c0-1.105.89-2 2-2h1v7l2.5-1.5L12 7V0h6a2 2 0 0 1 2 2M7 24h2v-2H7v2m8 0h2v-2h-2v2m-4 0h2v-2h-2v2Z"/>'
        },
        "book-settings-outline": {
            body: '<path fill="currentColor" d="M18 0H6C4.89 0 4 .895 4 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V2c0-1.105-.89-2-2-2m0 18H6V2h2v8l2.5-2.25L13 10V2h5v16M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "book-sync": {
            body: '<path fill="currentColor" d="M13 17.5c0 1.75.69 3.33 1.82 4.5H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h1v7l2.5-1.5L12 9V2h6a2 2 0 0 1 2 2v7.03c-.16-.03-.33-.03-.5-.03a6.5 6.5 0 0 0-6.5 6.5m6 2.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20m0-6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4Z"/>'
        },
        "book-sync-outline": {
            body: '<path fill="currentColor" d="M13.5 20c.31.75.76 1.42 1.32 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7.03c-.16-.03-.33-.03-.5-.03c-.5 0-1 .07-1.5.18V4h-5v8l-2.5-2.25L8 12V4H6v16h7.5m5.5 0a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20m0-6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4Z"/>'
        },
        "book-variant": {
            body: '<path fill="currentColor" d="M6 4h5v8l-2.5-1.5L6 12M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "book-variant-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m16-4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 10l-2.5-1.5L15 12V4h5v8Z"/>',
            hidden: true
        },
        bookmark: {
            body: '<path fill="currentColor" d="M17 3H7a2 2 0 0 0-2 2v16l7-3l7 3V5a2 2 0 0 0-2-2Z"/>'
        },
        "bookmark-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1 11l-2.5-1.5L13 14V6h5v8Z"/>'
        },
        "bookmark-box-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6m16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 10l-2.5-1.5L15 12V4h5v8Z"/>'
        },
        "bookmark-box-multiple-outline": {
            body: '<path fill="currentColor" d="M4 20h14v2H4c-1.1 0-2-.9-2-2V6h2v14M22 4v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2m-2 0H8v12h12V4m-2 2h-5v7l2.5-1.5L18 13V6Z"/>'
        },
        "bookmark-box-outline": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14c0 .53-.21 1.04-.59 1.41c-.37.38-.88.59-1.41.59H5c-.53 0-1.04-.21-1.41-.59C3.21 20.04 3 19.53 3 19V5c0-1.11.89-2 2-2m14 16V5H5v14h14M17 7h-5v8l2.5-1.5L17 15V7Z"/>'
        },
        "bookmark-check": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10m-6 11l6.25-6.24l-1.41-1.42L11 11.18L8.41 8.59L7 10l4 4Z"/>'
        },
        "bookmark-check-outline": {
            body: '<path fill="currentColor" d="m9.47 9.65l-1.41 1.42L11 14l5.19-5.18l-1.41-1.42L11 11.18M17 3H7c-1.1 0-2 .9-2 2v16l7-3l7 3V5c0-1.1-.9-2-2-2m0 15l-5-2.18L7 18V5h10Z"/>'
        },
        "bookmark-minus": {
            body: '<path fill="currentColor" d="M17 3H7a2 2 0 0 0-2 2v16l7-3l7 3V5a2 2 0 0 0-2-2m-2 8H9V9h6v2Z"/>'
        },
        "bookmark-minus-outline": {
            body: '<path fill="currentColor" d="M9 11V9h6v2H9m10-6v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2m-2 0H7v13l5-2.18L17 18V5Z"/>'
        },
        "bookmark-multiple": {
            body: '<path fill="currentColor" d="M15 5a2 2 0 0 1 2 2v16l-7-3l-7 3V7a2 2 0 0 1 2-2h10M9 1h10a2 2 0 0 1 2 2v16l-2-.87V3H7a2 2 0 0 1 2-2Z"/>'
        },
        "bookmark-multiple-outline": {
            body: '<path fill="currentColor" d="M9 1h10a2 2 0 0 1 2 2v16l-2-.87V3H7a2 2 0 0 1 2-2m6 19V7H5v13l5-2.18L15 20m0-15a2 2 0 0 1 2 2v16l-7-3l-7 3V7a2 2 0 0 1 2-2h10Z"/>'
        },
        "bookmark-music": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10m-6 8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V8h3V6h-4v5.27c-.29-.17-.64-.27-1-.27Z"/>'
        },
        "bookmark-music-outline": {
            body: '<path fill="currentColor" d="M7 3c-1.1 0-2 .9-2 2v16l7-3l7 3V5a2 2 0 0 0-2-2H7m0 2h10v13l-5-2.18L7 18V5m5 1v5.3c-.3-.2-.6-.3-1-.3a2 2 0 1 0 0 4c1.11 0 2-.89 2-2V8h2V6h-3Z"/>'
        },
        "bookmark-off": {
            body: '<path fill="currentColor" d="M20 20.72L18.73 22l-1.95-1.95L12 18l-7 3V8.27l-3-3L3.28 4L20 20.72m-1-3.56V5a2 2 0 0 0-2-2H7c-.59 0-1.11.27-1.5.68L19 17.16Z"/>'
        },
        "bookmark-off-outline": {
            body: '<path fill="currentColor" d="M3.28 4L2 5.27l3 3V21l7-3l4.78 2.05L18.73 22L20 20.72L3.28 4M7 18v-7.73l6 5.98l-1-.43L7 18M7 5.16L5.5 3.67C5.88 3.26 6.41 3 7 3h10a2 2 0 0 1 2 2v12.16l-2-2V5H7v.16Z"/>'
        },
        "bookmark-outline": {
            body: '<path fill="currentColor" d="m17 18l-5-2.18L7 18V5h10m0-2H7a2 2 0 0 0-2 2v16l7-3l7 3V5a2 2 0 0 0-2-2Z"/>'
        },
        "bookmark-plus": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10m-6 4v2H9v2h2v2h2v-2h2V9h-2V7h-2Z"/>'
        },
        "bookmark-plus-outline": {
            body: '<path fill="currentColor" d="M17 18V5H7v13l5-2.18L17 18m0-15a2 2 0 0 1 2 2v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10m-6 4h2v2h2v2h-2v2h-2v-2H9V9h2V7Z"/>'
        },
        "bookmark-remove": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v16l-7-3l-7 3V5a2 2 0 0 1 2-2h10M8.17 8.58L10.59 11l-2.42 2.41l1.42 1.42L12 12.41l2.41 2.42l1.42-1.42L13.41 11l2.42-2.42l-1.42-1.41L12 9.58L9.59 7.17L8.17 8.58Z"/>'
        },
        "bookmark-remove-outline": {
            body: '<path fill="currentColor" d="M7 3c-1.1 0-2 .9-2 2v16l7-3l7 3V5a2 2 0 0 0-2-2H7m0 2h10v13l-5-2.18L7 18V5m2.88 2.47L8.47 8.88L10.59 11l-2.12 2.12l1.41 1.42L12 12.42l2.12 2.11l1.42-1.41L13.42 11l2.11-2.12l-1.41-1.41L12 9.59L9.88 7.47Z"/>'
        },
        bookshelf: {
            body: '<path fill="currentColor" d="M9 3v15h3V3H9m3 2l4 13l3-1l-4-13l-3 1M5 5v13h3V5H5M3 19v2h18v-2H3Z"/>'
        },
        "boom-gate": {
            body: '<path fill="currentColor" d="M20 9H8.22A2.97 2.97 0 0 0 4 8.8c-.64.56-1 1.36-1 2.2v9a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1v-7h11a2 2 0 0 0 2-2a2 2 0 0 0-2-2M6 12.5A1.5 1.5 0 0 1 4.5 11A1.5 1.5 0 0 1 6 9.5A1.5 1.5 0 0 1 7.5 11A1.5 1.5 0 0 1 6 12.5m4.5-.5L9 10h1.5l1.5 2h-1.5m4 0L13 10h1.5l1.5 2h-1.5m4 0L17 10h1.5l1.5 2h-1.5Z"/>'
        },
        "boom-gate-alert": {
            body: '<path fill="currentColor" d="M19.9 3c-.6-1-1.8-1.3-2.7-.7L6.9 8.2C6.6 8.1 6.3 8 6 8c-1.7 0-3 1.3-3 3v9c-.6 0-1 .4-1 1v1h8v-1c0-.6-.4-1-1-1v-8.4l10.1-5.8c1-.6 1.3-1.8.8-2.8M6 12.5c-.8 0-1.5-.7-1.5-1.5S5.2 9.5 6 9.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m4.4-2.9l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.5-2l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.4-2l-2.3-1l1.3-.8l2.3 1l-1.3.8M20 18h-2v2h2v-2m0-8h-2v6h2v-6Z"/>'
        },
        "boom-gate-alert-outline": {
            body: '<path fill="currentColor" d="M19.9 3c-.6-1-1.8-1.3-2.7-.7L6.9 8.2C6.6 8.1 6.3 8 6 8c-1.7 0-3 1.3-3 3v9c-.6 0-1 .4-1 1v1h8v-1c0-.6-.4-1-1-1v-8.4l10.1-5.8c1-.6 1.3-1.8.8-2.8M7.5 20h-3v-6.4c.9.5 2.1.5 3 0V20M6 12.5c-.8 0-1.5-.7-1.5-1.5S5.2 9.5 6 9.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m4.4-2.9l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.5-2l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.4-2l-2.3-1l1.3-.8l2.3 1l-1.3.8M20 16h-2v-6h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "boom-gate-arrow-down": {
            body: '<path fill="currentColor" d="M19.86 3a1.995 1.995 0 0 0-2.74-.73L6.92 8.16C6.62 8.06 6.31 8 6 8a3 3 0 0 0-3 3v9a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1v-8.42l10.12-5.85c.96-.55 1.29-1.77.74-2.73M6 12.5A1.5 1.5 0 0 1 4.5 11A1.5 1.5 0 0 1 6 9.5A1.5 1.5 0 0 1 7.5 11A1.5 1.5 0 0 1 6 12.5m4.4-2.88l-2.3-1l1.3-.75l2.3 1l-1.3.75m3.46-2l-2.3-1l1.3-.75l2.3 1l-1.3.75m3.47-2l-2.3-1l1.3-.75l2.29 1l-1.29.75M17 20l-5-5h3v-4h4v4h3l-5 5"/>'
        },
        "boom-gate-arrow-down-outline": {
            body: '<path fill="currentColor" d="M19.86 3c.55.96.22 2.18-.74 2.73L9 11.58V20a1 1 0 0 1 1 1v1H2v-1a1 1 0 0 1 1-1v-9a3 3 0 0 1 3-3c.31 0 .62.06.92.16l10.2-5.89c.97-.56 2.19-.23 2.74.73M7.5 20v-6.4c-.93.54-2.07.54-3 0V20h3M6 12.5A1.5 1.5 0 0 0 7.5 11A1.5 1.5 0 0 0 6 9.5A1.5 1.5 0 0 0 4.5 11A1.5 1.5 0 0 0 6 12.5m4.4-2.88l1.3-.75l-2.3-1l-1.3.75l2.3 1m3.46-2l1.3-.75l-2.3-1l-1.3.75l2.3 1m3.47-2l1.29-.75l-2.29-1l-1.3.75l2.3 1M16 11.16h2v5.01l3-.01L17 20l-4-3.84l3 .01v-5.01Z"/>'
        },
        "boom-gate-arrow-up": {
            body: '<path fill="currentColor" d="M19.86 3a1.995 1.995 0 0 0-2.74-.73L6.92 8.16C6.62 8.06 6.31 8 6 8a3 3 0 0 0-3 3v9a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1v-8.42l10.12-5.85c.96-.55 1.29-1.77.74-2.73M6 12.5A1.5 1.5 0 0 1 4.5 11A1.5 1.5 0 0 1 6 9.5A1.5 1.5 0 0 1 7.5 11A1.5 1.5 0 0 1 6 12.5m4.4-2.88l-2.3-1l1.3-.75l2.3 1l-1.3.75m3.46-2l-2.3-1l1.3-.75l2.3 1l-1.3.75m3.47-2l-2.3-1l1.3-.75l2.29 1l-1.29.75M17 11l5 5h-3v4h-4v-4h-3l5-5"/>'
        },
        "boom-gate-arrow-up-outline": {
            body: '<path fill="currentColor" d="M19.86 3c.55.96.22 2.18-.74 2.73L9 11.58V20a1 1 0 0 1 1 1v1H2v-1a1 1 0 0 1 1-1v-9a3 3 0 0 1 3-3c.31 0 .62.06.92.16l10.2-5.89c.97-.56 2.19-.23 2.74.73M7.5 20v-6.4c-.93.54-2.07.54-3 0V20h3M6 12.5A1.5 1.5 0 0 0 7.5 11A1.5 1.5 0 0 0 6 9.5A1.5 1.5 0 0 0 4.5 11A1.5 1.5 0 0 0 6 12.5m4.4-2.88l1.3-.75l-2.3-1l-1.3.75l2.3 1m3.46-2l1.3-.75l-2.3-1l-1.3.75l2.3 1m3.47-2l1.29-.75l-2.29-1l-1.3.75l2.3 1M16 20v-5h-3l4-3.84L21 15h-3v5h-2Z"/>'
        },
        "boom-gate-outline": {
            body: '<path fill="currentColor" d="M20 9H8.22A2.97 2.97 0 0 0 4 8.8c-.64.56-1 1.36-1 2.2v9a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1v-7h11a2 2 0 0 0 2-2a2 2 0 0 0-2-2M7.5 20h-3v-6.4c.93.54 2.07.54 3 0V20M6 12.5A1.5 1.5 0 0 1 4.5 11A1.5 1.5 0 0 1 6 9.5A1.5 1.5 0 0 1 7.5 11A1.5 1.5 0 0 1 6 12.5m4.5-.5L9 10h1.5l1.5 2h-1.5m4 0L13 10h1.5l1.5 2h-1.5m4 0L17 10h1.5l1.5 2h-1.5Z"/>'
        },
        "boom-gate-up": {
            body: '<path fill="currentColor" d="M19.9 3c-.6-1-1.8-1.3-2.7-.7L6.9 8.2C6.6 8.1 6.3 8 6 8c-1.7 0-3 1.3-3 3v9c-.6 0-1 .4-1 1v1h8v-1c0-.6-.4-1-1-1v-8.4l10.1-5.8c1-.6 1.3-1.8.8-2.8M6 12.5c-.8 0-1.5-.7-1.5-1.5S5.2 9.5 6 9.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m4.4-2.9l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.5-2l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.4-2l-2.3-1l1.3-.8l2.3 1l-1.3.8"/>'
        },
        "boom-gate-up-outline": {
            body: '<path fill="currentColor" d="M19.9 3c-.6-1-1.8-1.3-2.7-.7L6.9 8.2C6.6 8.1 6.3 8 6 8c-1.7 0-3 1.3-3 3v9c-.6 0-1 .4-1 1v1h8v-1c0-.6-.4-1-1-1v-8.4l10.1-5.8c1-.6 1.3-1.8.8-2.8M7.5 20h-3v-6.4c.9.5 2.1.5 3 0V20M6 12.5c-.8 0-1.5-.7-1.5-1.5S5.2 9.5 6 9.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m4.4-2.9l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.5-2l-2.3-1l1.3-.8l2.3 1l-1.3.8m3.4-2l-2.3-1l1.3-.8l2.3 1l-1.3.8"/>'
        },
        boombox: {
            body: '<path fill="currentColor" d="M7 5L5 7v1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2V7l-2-2H7m0 2h10v1H7V7m4 2h2a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5m-3.5 1.5a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m9 0a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m-9 1.5A1.5 1.5 0 0 0 6 13.5A1.5 1.5 0 0 0 7.5 15A1.5 1.5 0 0 0 9 13.5A1.5 1.5 0 0 0 7.5 12m9 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        boomerang: {
            body: '<path fill="currentColor" d="M10 2H4c-1.1 0-2 .9-2 2s.9 2 2 2h4l2-4m8 0c2.2 0 4 1.8 4 4v6l-4 2c0-4.4-3.6-8-8-8l2-4h6m0 18v-4l4-2v6c0 1.1-.9 2-2 2s-2-.9-2-2Z"/>'
        },
        bootstrap: {
            body: '<path fill="currentColor" d="M11.79 11.5H9.72V8.19h2.47c1.26 0 1.96.56 1.96 1.59c0 1.12-.83 1.72-2.36 1.72m.37 1.13H9.72v3.64h2.56c1.56 0 2.38-.63 2.38-1.83s-.85-1.81-2.5-1.81M22 5.31v13.38C22 20.5 20.5 22 18.69 22H5.31C3.5 22 2 20.5 2 18.69V5.31C2 3.5 3.5 2 5.31 2h13.38C20.5 2 22 3.5 22 5.31m-6 9.19c0-1.38-.92-2.37-2.33-2.55v-.06c1-.18 1.79-1.18 1.79-2.26c0-1.55-1.2-2.58-2.96-2.58H8.43v10.36h4.04c2.21 0 3.53-1.09 3.53-2.91Z"/>'
        },
        "border-all": {
            body: '<path fill="currentColor" d="M19 11h-6V5h6m0 14h-6v-6h6m-8-2H5V5h6m0 14H5v-6h6m-8 8h18V3H3v18Z"/>'
        },
        "border-all-variant": {
            body: '<path fill="currentColor" d="M3 21V3h18v18H3M5 5v14h14V5H5Z"/>'
        },
        "border-bottom": {
            body: '<path fill="currentColor" d="M5 15H3v2h2m-2 4h18v-2H3m2-8H3v2h2m14-4h2V7h-2m0-2h2V3h-2M5 7H3v2h2m14 8h2v-2h-2m0-2h2v-2h-2m-2-8h-2v2h2m-4-2h-2v2h2m4 6h-2v2h2m-4-6h-2v2h2M5 3H3v2h2m8 6h-2v2h2M9 3H7v2h2m4 10h-2v2h2m-4-6H7v2h2v-2Z"/>'
        },
        "border-bottom-variant": {
            body: '<path fill="currentColor" d="M5 15H3v2h2m-2 4h18v-2H3m2-8H3v2h2m14-4h2V7h-2m0-2h2V3h-2M5 7H3v2h2m14 8h2v-2h-2m0-2h2v-2h-2m-2-8h-2v2h2m-4-2h-2v2h2M5 3H3v2h2m4-2H7v2h2"/>'
        },
        "border-color": {
            body: '<path fill="currentColor" d="M20.71 4.04c.39-.39.39-1.04 0-1.41L18.37.29C18-.1 17.35-.1 16.96.29L15 2.25L18.75 6m-1 1L14 3.25l-10 10V17h3.75l10-10Z"/>'
        },
        "border-horizontal": {
            body: '<path fill="currentColor" d="M19 21h2v-2h-2m-4 2h2v-2h-2m-4-2h2v-2h-2m8-6h2V7h-2m0-2h2V3h-2M3 13h18v-2H3m8 10h2v-2h-2m8-2h2v-2h-2M13 3h-2v2h2m0 2h-2v2h2m4-6h-2v2h2M9 3H7v2h2M5 3H3v2h2m2 16h2v-2H7m-4-2h2v-2H3m2-8H3v2h2M3 21h2v-2H3v2Z"/>'
        },
        "border-inside": {
            body: '<path fill="currentColor" d="M19 17h2v-2h-2m0 6h2v-2h-2M13 3h-2v8H3v2h8v8h2v-8h8v-2h-8m2 10h2v-2h-2m4-14h2V3h-2m0 6h2V7h-2m-2-4h-2v2h2M5 3H3v2h2m4-2H7v2h2M3 17h2v-2H3m2-8H3v2h2m2 12h2v-2H7m-4 2h2v-2H3v2Z"/>'
        },
        "border-left": {
            body: '<path fill="currentColor" d="M15 5h2V3h-2m0 10h2v-2h-2m4 10h2v-2h-2m0-6h2v-2h-2m0-6h2V3h-2m0 14h2v-2h-2m-4 6h2v-2h-2m4-10h2V7h-2M3 21h2V3H3m4 10h2v-2H7m0-6h2V3H7m0 18h2v-2H7m4-6h2v-2h-2m0-2h2V7h-2m0-2h2V3h-2m0 14h2v-2h-2m0 6h2v-2h-2v2Z"/>'
        },
        "border-left-variant": {
            body: '<path fill="currentColor" d="M15 5h2V3h-2m4 18h2v-2h-2m0-6h2v-2h-2m0-6h2V3h-2m0 14h2v-2h-2m-4 6h2v-2h-2m4-10h2V7h-2M3 21h2V3H3m4 2h2V3H7m0 18h2v-2H7m4-14h2V3h-2m0 18h2v-2h-2v2Z"/>'
        },
        "border-none": {
            body: '<path fill="currentColor" d="M15 5h2V3h-2m0 10h2v-2h-2m0 10h2v-2h-2M11 5h2V3h-2m8 2h2V3h-2m-8 6h2V7h-2m8 2h2V7h-2m0 14h2v-2h-2m0-6h2v-2h-2m0 6h2v-2h-2m-8-2h2v-2h-2M3 5h2V3H3m0 6h2V7H3m0 6h2v-2H3m0 6h2v-2H3m0 6h2v-2H3m8 2h2v-2h-2m0-2h2v-2h-2m-4 6h2v-2H7m0-6h2v-2H7m0-6h2V3H7v2Z"/>'
        },
        "border-none-variant": {
            body: '<path fill="currentColor" d="M15 5h2V3h-2m0 18h2v-2h-2M11 5h2V3h-2m8 2h2V3h-2m0 6h2V7h-2m0 14h2v-2h-2m0-6h2v-2h-2m0 6h2v-2h-2M3 5h2V3H3m0 6h2V7H3m0 6h2v-2H3m0 6h2v-2H3m0 6h2v-2H3m8 2h2v-2h-2m-4 2h2v-2H7M7 5h2V3H7v2Z"/>'
        },
        "border-outside": {
            body: '<path fill="currentColor" d="M9 11H7v2h2m4 2h-2v2h2m6 2H5V5h14M3 21h18V3H3m14 8h-2v2h2m-4-2h-2v2h2m0-6h-2v2h2V7Z"/>'
        },
        "border-radius": {
            body: '<path fill="currentColor" d="M3 16c0 2.8 2.2 5 5 5h2v-2H8c-1.7 0-3-1.3-3-3v-2H3v2m18-8c0-2.8-2.2-5-5-5h-2v2h2c1.7 0 3 1.3 3 3v2h2V8m-5 13c2.8 0 5-2.2 5-5v-2h-2v2c0 1.7-1.3 3-3 3h-2v2h2M8 3C5.2 3 3 5.2 3 8v2h2V8c0-1.7 1.3-3 3-3h2V3H8Z"/>'
        },
        "border-right": {
            body: '<path fill="currentColor" d="M11 9h2V7h-2m0-2h2V3h-2m0 10h2v-2h-2m4-6h2V3h-2m0 18h2v-2h-2m4 2h2V3h-2m-4 10h2v-2h-2m-4 6h2v-2h-2M3 9h2V7H3m0 10h2v-2H3m0-2h2v-2H3m8 10h2v-2h-2m-8 2h2v-2H3m4-6h2v-2H7m0-6h2V3H7M3 5h2V3H3m4 18h2v-2H7v2Z"/>'
        },
        "border-right-variant": {
            body: '<path fill="currentColor" d="M11 5h2V3h-2m4 2h2V3h-2m0 18h2v-2h-2m4 2h2V3h-2M3 9h2V7H3m0 10h2v-2H3m0-2h2v-2H3m8 10h2v-2h-2m-8 2h2v-2H3M7 5h2V3H7M3 5h2V3H3m4 18h2v-2H7v2Z"/>'
        },
        "border-style": {
            body: '<path fill="currentColor" d="M15 21h2v-2h-2m4 2h2v-2h-2M7 21h2v-2H7m4 2h2v-2h-2m8-2h2v-2h-2m0-2h2v-2h-2M3 3v18h2V5h16V3m-2 6h2V7h-2"/>'
        },
        "border-top": {
            body: '<path fill="currentColor" d="M15 13h2v-2h-2m4 10h2v-2h-2M11 9h2V7h-2m4 14h2v-2h-2m4-2h2v-2h-2M3 5h18V3H3m16 10h2v-2h-2m0-2h2V7h-2m-8 10h2v-2h-2M3 9h2V7H3m0 6h2v-2H3m0 10h2v-2H3m0-2h2v-2H3m8 6h2v-2h-2m0-6h2v-2h-2m-4 2h2v-2H7m0 10h2v-2H7v2Z"/>'
        },
        "border-top-variant": {
            body: '<path fill="currentColor" d="M19 21h2v-2h-2m-4 2h2v-2h-2m4-2h2v-2h-2M3 5h18V3H3m16 10h2v-2h-2m0-2h2V7h-2M3 9h2V7H3m0 6h2v-2H3m0 10h2v-2H3m0-2h2v-2H3m8 6h2v-2h-2m-4 2h2v-2H7v2Z"/>'
        },
        "border-vertical": {
            body: '<path fill="currentColor" d="M15 13h2v-2h-2m0 10h2v-2h-2m0-14h2V3h-2m4 6h2V7h-2m0-2h2V3h-2m0 10h2v-2h-2m0 10h2v-2h-2m-8 2h2V3h-2m8 14h2v-2h-2M7 5h2V3H7M3 17h2v-2H3m0 6h2v-2H3m0-6h2v-2H3m4 2h2v-2H7m0 10h2v-2H7M3 5h2V3H3m0 6h2V7H3v2Z"/>'
        },
        "bottle-soda": {
            body: '<path fill="currentColor" d="M15 11v9a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-9a2 2 0 0 1 .6-1.42C11.1 7.89 11 4 11 4h-1V2h4v2h-1s-.1 3.89 1.4 5.58A2 2 0 0 1 15 11Z"/>'
        },
        "bottle-soda-classic": {
            body: '<path fill="currentColor" d="M15 13.77a3 3 0 0 0 0 4.46V20a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1.77a3 3 0 0 0 0-4.46V9a12.28 12.28 0 0 0 1.91-5H10V2h4v2h-.91A12.28 12.28 0 0 0 15 9Z"/>'
        },
        "bottle-soda-classic-outline": {
            body: '<path fill="currentColor" d="M10 2v2h.91C10.65 5.79 9 7.5 8 9v4.77a3.007 3.007 0 0 1 0 4.46V20a2 2 0 0 0 2 2h4c1.11 0 2-.89 2-2v-1.77a3.007 3.007 0 0 1 0-4.46V9c-1-1.5-2.65-3.21-2.91-5H14V2m-2 4.5c.24.5 1.54 2 1.9 2.41L14 9v4c-.65.87-1 1.92-1 3s.35 2.13 1 3v1h-4v-1c.65-.87 1-1.92 1-3s-.35-2.13-1-3V9l.1-.09C10.46 8.5 11.76 7 12 6.5Z"/>'
        },
        "bottle-soda-outline": {
            body: '<path fill="currentColor" d="M14.4 9.58C12.9 7.89 13 4 13 4h1V2h-4v2h1s.1 3.89-1.4 5.58A2 2 0 0 0 9 11v9a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-9a2 2 0 0 0-.6-1.42M13 20h-2v-9l.1-.09A6.26 6.26 0 0 0 12 9.5a6.26 6.26 0 0 0 .9 1.41l.1.09Z"/>'
        },
        "bottle-tonic": {
            body: '<path fill="currentColor" d="M13 4h-2l-1-2h4l-1 2m6 9v9H5v-9c0-2.76 2.24-5 5-5V6H9V5h6v1h-1v2c2.76 0 5 2.24 5 5Z"/>'
        },
        "bottle-tonic-outline": {
            body: '<path fill="currentColor" d="M13 4h-2l-1-2h4l-1 2m6 9v9H5v-9c0-2.76 2.24-5 5-5V6H9V5h6v1h-1v2c2.76 0 5 2.24 5 5m-2 0c0-1.65-1.35-3-3-3h-4c-1.65 0-3 1.35-3 3v7h10v-7Z"/>'
        },
        "bottle-tonic-plus": {
            body: '<path fill="currentColor" d="M13 4h-2l-1-2h4l-1 2m1 4V6h1V5H9v1h1v2c-2.76 0-5 2.24-5 5v9h14v-9c0-2.76-2.24-5-5-5m2 9h-3v3h-2v-3H8v-2h3v-3h2v3h3v2Z"/>'
        },
        "bottle-tonic-plus-outline": {
            body: '<path fill="currentColor" d="M13 4h-2l-1-2h4l-1 2m6 9v9H5v-9c0-2.76 2.24-5 5-5V6H9V5h6v1h-1v2c2.76 0 5 2.24 5 5m-2 0c0-1.65-1.35-3-3-3h-4c-1.65 0-3 1.35-3 3v7h10v-7m-2 3h-2v2h-2v-2H9v-2h2v-2h2v2h2v2Z"/>'
        },
        "bottle-tonic-skull": {
            body: '<path fill="currentColor" d="M19 13v9H5v-9c0-2.76 2.24-5 5-5V6H9V5h6v1h-1v2c2.76 0 5 2.24 5 5m-6-9l1-2h-4l1 2h2m-1 7c-2.21 0-4 1.79-4 4c0 1 .39 1.9 1 2.59V19h1.25v-1.5h1.13V19h1.25v-1.5h1.12V19H15v-1.41A3.9 3.9 0 0 0 16 15c0-2.21-1.79-4-4-4m-1.5 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m.75 1.25L12 15l.75 1.25h-1.5M13.5 15c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "bottle-tonic-skull-outline": {
            body: '<path fill="currentColor" d="M13 4h-2l-1-2h4l-1 2m1 4V6h1V5H9v1h1v2c-2.76 0-5 2.24-5 5v9h14v-9c0-2.76-2.24-5-5-5m3 12H7v-7c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v7m-5-9c-2.21 0-4 1.79-4 4c0 1 .39 1.9 1 2.59V19h1.25v-1.5h1.13V19h1.25v-1.5h1.12V19H15v-1.41A3.9 3.9 0 0 0 16 15c0-2.21-1.79-4-4-4m-1.5 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m.75 1.25L12 15l.75 1.25h-1.5M13.5 15c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "bottle-wine": {
            body: '<path fill="currentColor" d="M10 22a1 1 0 0 1-1-1V11c0-2 1-3.75 2-4V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V7c1 .25 2 2 2 4v10a1 1 0 0 1-1 1h-4Z"/>'
        },
        "bottle-wine-outline": {
            body: '<path fill="currentColor" d="M11.5 2c-.28 0-.5.22-.5.5V7c-.07 0-.15 0-.22.03c-.96.24-1.57.97-2.02 1.86C8.3 9.76 8 10.84 8 12c.05 3 0 6.03 0 9c0 .55.45 1 1 1h6c.55 0 1-.45 1-1c.04-3 0-6 0-9c0-1.16-.26-2.24-.72-3.12c-.45-.88-1.06-1.61-2.02-1.84C13.18 7 13.05 7 13 7V2.5c0-.28-.22-.5-.5-.5M12 8.85c.32 0 .63.05.78.15c.07.03.42.26.72.81c.28.56.5 1.36.5 2.19v8h-4v-8c0-.83.22-1.63.5-2.19c.3-.55.65-.78.72-.81c.14-.1.46-.15.78-.15Z"/>'
        },
        "bow-arrow": {
            body: '<path fill="currentColor" d="M19.03 6.03L20 7l2-5l-5 2l.97.97l-1.82 1.82C10.87 2.16 3.3 3.94 2.97 4L2 4.26l.5 1.94l.79-.2l6.83 6.82L6.94 16H5l-3 3l2 1l1 2l3-3v-1.94l3.18-3.18L18 20.71l-.19.79l1.93.5l.26-.97c.06-.33 1.84-7.9-2.79-13.18l1.82-1.82M4.5 5.78c2.05-.28 6.78-.5 10.23 2.43l-3.91 3.91L4.5 5.78M18.22 19.5l-6.34-6.32l3.91-3.91c2.93 3.45 2.71 8.18 2.43 10.23Z"/>'
        },
        "bow-tie": {
            body: '<path fill="currentColor" d="m15 14l6 3V7l-6 3v4m-6 0l-6 3V7l6 3v4m1-4h4v4h-4v-4Z"/>'
        },
        bowl: {
            body: '<path fill="currentColor" d="M22 15c0 3.9-3.1 7-7 7H9c-3.9 0-7-3.1-7-7v-3h20v3Z"/>'
        },
        "bowl-mix": {
            body: '<path fill="currentColor" d="m16.2 11l4.1-6.5l1.7 1l-3.4 5.5h-2.4m-.6 1H2v3c0 3.9 3.1 7 7 7h6c3.9 0 7-3.1 7-7v-3h-6.4Z"/>'
        },
        "bowl-mix-outline": {
            body: '<path fill="currentColor" d="M15.6 12H2v3c0 3.9 3.1 7 7 7h6c3.9 0 7-3.1 7-7v-3h-6.4m4.4 3c0 2.8-2.2 5-5 5H9c-2.8 0-5-2.2-5-5v-1h16v1m-3.8-4l4.1-6.6L22 5.5L18.6 11h-2.4Z"/>'
        },
        "bowl-outline": {
            body: '<path fill="currentColor" d="M2 12v3c0 3.9 3.1 7 7 7h6c3.9 0 7-3.1 7-7v-3H2m2 2h16v1c0 2.8-2.2 5-5 5H9c-2.8 0-5-2.2-5-5v-1Z"/>'
        },
        bowling: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m.5 9a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M12 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M5.93 8.5c-.55.95-.22 2.17.73 2.72c.96.56 2.18.23 2.74-.72c.55-.97.22-2.19-.74-2.74c-.95-.55-2.16-.23-2.73.74Z"/>'
        },
        box: {
            body: '<path fill="currentColor" d="M15.39 14.04a2.57 2.57 0 0 0-2.57-2.57a2.565 2.565 0 1 0 2.57 2.57m1.71 0a4.274 4.274 0 0 1-8.05 2A4.274 4.274 0 0 1 1 14.11V7c0-.44.39-.82.86-.82s.84.38.85.82v3.62c.72-.54 1.61-.86 2.57-.86c1.63 0 3.05.92 3.77 2.27a4.274 4.274 0 0 1 3.77-2.27c2.36 0 4.28 1.92 4.28 4.28m-9.26 0c0-1.42-1.15-2.57-2.56-2.57a2.57 2.57 0 0 0-2.57 2.57a2.565 2.565 0 0 0 5.13 0m15 2.92c.11.16.16.34.16.51c0 .26-.12.53-.34.68a.89.89 0 0 1-.51.17c-.25 0-.5-.11-.65-.32l-1.91-2.53L17.7 18c-.17.21-.42.32-.67.32c-.18 0-.36-.06-.53-.17c-.21-.15-.33-.43-.33-.69c0-.17.06-.35.16-.5l2.17-2.92l-2.17-2.93a.828.828 0 0 1-.16-.5c0-.26.12-.51.33-.68c.39-.28.91-.21 1.2.16l1.89 2.52l1.91-2.52c.26-.37.79-.44 1.16-.16c.23.17.34.43.34.7c0 .17-.05.34-.16.48l-2.18 2.93l2.18 2.92Z"/>'
        },
        "box-cutter": {
            body: '<path fill="currentColor" d="M7.22 11.91c-.33.33-.51.74-.56 1.17l5.51 2.36l8.49-8.48c.78-.79.78-2.05 0-2.83l-1.42-1.42c-.78-.78-2.04-.78-2.83 0l-9.19 9.2M5 16v5.75l5.81-5.22l-5-2L5 16M17.12 4.83c.38-.39 1.03-.39 1.42 0c.39.4.39 1.03 0 1.42c-.39.39-1.04.39-1.42 0c-.39-.39-.39-1.02 0-1.42Z"/>'
        },
        "box-cutter-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-7.98-7.98l-.69.69l-5.51-2.36c.05-.43.23-.84.56-1.17l1.4-1.41L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27m-5.43-10.52l-4.25-4.25l5.25-5.25c.79-.78 2.05-.78 2.83 0l1.42 1.42c.78.78.78 2.04 0 2.83l-5.25 5.25m1.71-5.96c.38.39 1.03.39 1.42 0c.39-.39.39-1.02 0-1.42c-.39-.39-1.04-.39-1.42 0c-.39.4-.39 1.03 0 1.42M5 16v5.75l5.81-5.22l-5-2L5 16Z"/>'
        },
        "box-download": {
            body: '<path d="M4.996 3h14.012l1.728 2.993l-.006.004c.172.294.27.637.27 1.003v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7c0-.362.096-.702.264-.994l-.003-.002L4.996 3zm.577 1l-.577 1H19.008l-.578-1H5.573zM7 12l5 5l5-5h-3v-2h-4v2H7z" fill="currentColor"/>',
            hidden: true
        },
        "box-shadow": {
            body: '<path fill="currentColor" d="M3 3h15v15H3V3m16 16h2v2h-2v-2m0-3h2v2h-2v-2m0-3h2v2h-2v-2m0-3h2v2h-2v-2m0-3h2v2h-2V7m-3 12h2v2h-2v-2m-3 0h2v2h-2v-2m-3 0h2v2h-2v-2m-3 0h2v2H7v-2Z"/>'
        },
        "box-upload": {
            body: '<path d="M4.996 3h14.012l1.728 2.993l-.006.004c.172.294.27.637.27 1.003v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7c0-.362.096-.702.264-.994l-.003-.002L4.996 3zm.577 1l-.577 1H19.008l-.578-1H5.573zM7 15h3v2h4v-2h3l-5-5l-5 5z" fill="currentColor"/>',
            hidden: true
        },
        "boxing-glove": {
            body: '<path fill="currentColor" d="M19 16V6h3v10h-3M12 4H7S2 4 2 8v6c0 1.77 1 2.76 2.07 3.31A3.996 3.996 0 0 1 8 14h3v2H8a2 2 0 0 0-2 2a2 2 0 0 0 2 2h5c4 0 4-4 4-4V6s-1-2-5-2Z"/>'
        },
        "boxing-gloves": {
            body: '<path d="M19 16V6h3v10h-3zM12 4H7S2 4 2 8v6c0 1.772.979 2.757 2.07 3.306A4 4 0 0 1 8 14h3v2H8a2 2 0 1 0 0 4h5c4 0 4-4 4-4V6s-1-2-5-2z" fill="currentColor"/>',
            hidden: true
        },
        braille: {
            body: '<path fill="currentColor" d="M7 8a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.52.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H8c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L7 18V8m12.5-6A1.5 1.5 0 0 0 18 3.5A1.5 1.5 0 0 0 19.5 5A1.5 1.5 0 0 0 21 3.5A1.5 1.5 0 0 0 19.5 2m0 5A1.5 1.5 0 0 0 18 8.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 21 8.5A1.5 1.5 0 0 0 19.5 7m-5 0A1.5 1.5 0 0 0 13 8.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 16 8.5A1.5 1.5 0 0 0 14.5 7m5 5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        brain: {
            body: '<path fill="currentColor" d="M21.33 12.91c.09 1.55-.62 3.04-1.89 3.95l.77 1.49c.23.45.26.98.06 1.45c-.19.47-.58.84-1.06 1l-.79.25a1.687 1.687 0 0 1-1.86-.55L14.44 18c-.89-.15-1.73-.53-2.44-1.1c-.5.15-1 .23-1.5.23c-.88 0-1.76-.27-2.5-.79c-.53.16-1.07.23-1.62.22c-.79.01-1.57-.15-2.3-.45a4.105 4.105 0 0 1-2.43-3.61c-.08-.72.04-1.45.35-2.11c-.29-.75-.32-1.57-.07-2.33C2.3 7.11 3 6.32 3.87 5.82c.58-1.69 2.21-2.82 4-2.7c1.6-1.5 4.05-1.66 5.83-.37c.42-.11.86-.17 1.3-.17c1.36-.03 2.65.57 3.5 1.64c2.04.53 3.5 2.35 3.58 4.47c.05 1.11-.25 2.2-.86 3.13c.07.36.11.72.11 1.09m-5-1.41c.57.07 1.02.5 1.02 1.07a1 1 0 0 1-1 1h-.63c-.32.9-.88 1.69-1.62 2.29c.25.09.51.14.77.21c5.13-.07 4.53-3.2 4.53-3.25a2.592 2.592 0 0 0-2.69-2.49a1 1 0 0 1-1-1a1 1 0 0 1 1-1c1.23.03 2.41.49 3.33 1.3c.05-.29.08-.59.08-.89c-.06-1.24-.62-2.32-2.87-2.53c-1.25-2.96-4.4-1.32-4.4-.4c-.03.23.21.72.25.75a1 1 0 0 1 1 1c0 .55-.45 1-1 1c-.53-.02-1.03-.22-1.43-.56c-.48.31-1.03.5-1.6.56c-.57.05-1.04-.35-1.07-.9a.968.968 0 0 1 .88-1.1c.16-.02.94-.14.94-.77c0-.66.25-1.29.68-1.79c-.92-.25-1.91.08-2.91 1.29C6.75 5 6 5.25 5.45 7.2C4.5 7.67 4 8 3.78 9c1.08-.22 2.19-.13 3.22.25c.5.19.78.75.59 1.29c-.19.52-.77.78-1.29.59c-.73-.32-1.55-.34-2.3-.06c-.32.27-.32.83-.32 1.27c0 .74.37 1.43 1 1.83c.53.27 1.12.41 1.71.4c-.15-.26-.28-.53-.39-.81a1.038 1.038 0 0 1 1.96-.68c.4 1.14 1.42 1.92 2.62 2.05c1.37-.07 2.59-.88 3.19-2.13c.23-1.38 1.34-1.5 2.56-1.5m2 7.47l-.62-1.3l-.71.16l1 1.25l.33-.11m-4.65-8.61a1 1 0 0 0-.91-1.03c-.71-.04-1.4.2-1.93.67c-.57.58-.87 1.38-.84 2.19a1 1 0 0 0 1 1c.57 0 1-.45 1-1c0-.27.07-.54.23-.76c.12-.1.27-.15.43-.15c.55.03 1.02-.38 1.02-.92Z"/>'
        },
        "bread-slice": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 3.36 10 7.5c0 1.69-.74 3.25-2 4.5v8H4v-8c-1.26-1.25-2-2.81-2-4.5C2 5.36 6.5 2 12 2M8 18h4v-4H8v4Z"/>'
        },
        "bread-slice-outline": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 3.36 10 7.5c0 1.69-.74 3.25-2 4.5v8H4v-8c-1.26-1.25-2-2.81-2-4.5C2 5.36 6.5 2 12 2m6 11.14c1.24-.97 2-2.25 2-3.64C20 6.46 16.42 4 12 4S4 6.46 4 9.5c0 1.39.76 2.67 2 3.64V20h12v-6.86M8 18v-4h4v4H8Z"/>'
        },
        bridge: {
            body: '<path fill="currentColor" d="M7 14v-3.09c-.72-.33-1.39-.73-2-1.2V14h2m-2 4H3v-2H1v-2h2V7h2v1.43C6.8 10 9.27 11 12 11c2.73 0 5.2-1 7-2.57V7h2v7h2v2h-2v2h-2v-2H5v2m12-7.09V14h2V9.71c-.61.47-1.28.87-2 1.2M16 14v-2.68c-.64.23-1.31.4-2 .52V14h2m-3 0v-2.04L12 12l-1-.04V14h2m-3 0v-2.16c-.69-.12-1.36-.29-2-.52V14h2Z"/>'
        },
        briefcase: {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-account": {
            body: '<path fill="currentColor" d="M20 6h-4V4a2 2 0 0 0-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M10 4h4v2h-4V4m2 5a2.5 2.5 0 0 1 2.5 2.5A2.5 2.5 0 0 1 12 14a2.5 2.5 0 0 1-2.5-2.5A2.5 2.5 0 0 1 12 9m5 10H7v-1.25c0-1.38 2.24-2.5 5-2.5s5 1.12 5 2.5V19Z"/>'
        },
        "briefcase-account-outline": {
            body: '<path fill="currentColor" d="M20 6c.58 0 1.05.2 1.42.59c.38.41.58.86.58 1.41v11c0 .55-.2 1-.58 1.41c-.37.39-.84.59-1.42.59H4c-.58 0-1.05-.2-1.42-.59C2.2 20 2 19.55 2 19V8c0-.55.2-1 .58-1.41C2.95 6.2 3.42 6 4 6h4V4c0-.58.2-1.05.58-1.42C8.95 2.2 9.42 2 10 2h4c.58 0 1.05.2 1.42.58c.38.37.58.84.58 1.42v2h4M4 8v11h16V8H4m10-2V4h-4v2h4m-2 3a2.25 2.25 0 0 1 2.25 2.25c0 1.25-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25C9.75 10 10.76 9 12 9m4.5 9h-9v-1.12c0-1.25 2-2.25 4.5-2.25s4.5 1 4.5 2.25V18Z"/>'
        },
        "briefcase-arrow-left-right": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53A5.97 5.97 0 0 0 18 12a6.005 6.005 0 0 0-5.2 9H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m5 12.5V17h-4v-2h4v-1.5l3 2.5l-3 2.5m-2 .5h4v2h-4v1.5L14 20l3-2.5V19Z"/>'
        },
        "briefcase-arrow-left-right-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53a5.72 5.72 0 0 0-2-1.19V8H4v11h8.08c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2m4 4V4h-4v2h4m5 12.5V17h-4v-2h4v-1.5l3 2.5l-3 2.5m-2 .5h4v2h-4v1.5L14 20l3-2.5V19Z"/>'
        },
        "briefcase-arrow-up-down": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53A5.97 5.97 0 0 0 18 12a6.005 6.005 0 0 0-5.2 9H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m3.5 13H19v-4h2v4h1.5L20 22l-2.5-3m-.5-2v4h-2v-4h-1.5l2.5-3l2.5 3H17Z"/>'
        },
        "briefcase-arrow-up-down-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53a5.72 5.72 0 0 0-2-1.19V8H4v11h8.08c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2m4 4V4h-4v2h4m3.5 13H19v-4h2v4h1.5L20 22l-2.5-3m-.5-2v4h-2v-4h-1.5l2.5-3l2.5 3H17Z"/>'
        },
        "briefcase-check": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4V4a2 2 0 0 1 2-2m4 4V4h-4v2h4m-3.5 11.5l6.59-6.59l-1.41-1.41l-5.18 5.17l-2.09-2.08L7 14l3.5 3.5Z"/>'
        },
        "briefcase-check-outline": {
            body: '<path fill="currentColor" d="M20 6c.58 0 1.05.2 1.42.59c.38.41.58.86.58 1.41v11c0 .55-.2 1-.58 1.41c-.37.39-.84.59-1.42.59H4c-.58 0-1.05-.2-1.42-.59C2.2 20 2 19.55 2 19V8c0-.55.2-1 .58-1.41C2.95 6.2 3.42 6 4 6h4V4c0-.58.2-1.05.58-1.42C8.95 2.2 9.42 2 10 2h4c.58 0 1.05.2 1.42.58c.38.37.58.84.58 1.42v2h4M4 8v11h16V8H4m10-2V4h-4v2h4m-3.54 11.5l6.59-6.59l-1.41-1.41l-5.18 5.17l-2.09-2.08L6.96 14l3.5 3.5Z"/>'
        },
        "briefcase-clock": {
            body: '<path fill="currentColor" d="M21 11.11V7a2 2 0 0 0-2-2h-4V3a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7.26A7 7 0 1 0 21 11.11M9 3h4v2H9m10 15a5 5 0 0 1-6 0a5 5 0 1 1 6 0m-4-7h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13"/>'
        },
        "briefcase-clock-outline": {
            body: '<path fill="currentColor" d="M21 11.11V7a2 2 0 0 0-.58-1.41A1.87 1.87 0 0 0 19 5h-4V3a1.9 1.9 0 0 0-.58-1.42A1.9 1.9 0 0 0 13 1H9a1.9 1.9 0 0 0-1.42.58A1.9 1.9 0 0 0 7 3v2H3a1.87 1.87 0 0 0-1.42.59A2 2 0 0 0 1 7v11a2 2 0 0 0 .58 1.41A1.87 1.87 0 0 0 3 20h7.26A7 7 0 1 0 21 11.11M9 3h4v2H9M3 18V7h16v2.68A6.84 6.84 0 0 0 16 9a7 7 0 0 0-7 7a6.91 6.91 0 0 0 .29 2M19 20a5 5 0 0 1-6 0a4.94 4.94 0 0 1-2-4a5 5 0 0 1 5-5a4.94 4.94 0 0 1 3 1a5 5 0 0 1 0 8m-4-7h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13"/>'
        },
        "briefcase-download": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m-2 13l5-5h-3v-4h-4v4H7l5 5Z"/>'
        },
        "briefcase-download-outline": {
            body: '<path fill="currentColor" d="m12 18l-5-5h3V9h4v4h3l-5 5M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4M4 8v11h16V8H4Z"/>'
        },
        "briefcase-edit": {
            body: '<path fill="currentColor" d="M14 2a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2L10.85 19v2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2h4m0 4V4h-4v2h4m7.04 6.13c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 0 0-.38-.17m-1.97 1.75L13 19.94V22h2.06l6.06-6.07l-2.05-2.05Z"/>'
        },
        "briefcase-edit-outline": {
            body: '<path fill="currentColor" d="M21.04 12.13c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17m-1.97 1.75l2.05 2.05L15.06 22H13v-2.06l6.07-6.06M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2l-2 2V8H4v11h7v2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4V4a2 2 0 0 1 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-eye": {
            body: '<path fill="currentColor" d="M17 18c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m-7.9 1.7l-.3-.7l.3-.7c1.3-3.2 4.4-5.3 7.9-5.3c1.9 0 3.6.6 5 1.6V8c0-1.1-.9-2-2-2h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h5.8c-.3-.4-.5-.8-.7-1.3M10 4h4v2h-4V4m7 11c-2.7 0-5.1 1.7-6 4c.9 2.3 3.3 4 6 4s5.1-1.7 6-4c-.9-2.3-3.3-4-6-4m0 6.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5Z"/>'
        },
        "briefcase-eye-outline": {
            body: '<path fill="currentColor" d="M17 18c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m0-3c-2.7 0-5.1 1.7-6 4c.9 2.3 3.3 4 6 4s5.1-1.7 6-4c-.9-2.3-3.3-4-6-4m0 6.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5m-7.9-1.8l-.3-.7H4V8h16v5.6c.7.3 1.4.6 2 1.1V8c0-.5-.2-1-.6-1.4c-.4-.4-.8-.6-1.4-.6h-4V4c0-.6-.2-1-.6-1.4c-.4-.4-.8-.6-1.4-.6h-4c-.6 0-1 .2-1.4.6C8.2 3 8 3.4 8 4v2H4c-.6 0-1 .2-1.4.6C2.2 7 2 7.5 2 8v11c0 .5.2 1 .6 1.4c.4.4.8.6 1.4.6h5.8c-.3-.4-.5-.8-.7-1.3M10 4h4v2h-4V4Z"/>'
        },
        "briefcase-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53A5.97 5.97 0 0 0 18 12a6 6 0 0 0-6 6c0 1.09.29 2.12.8 3H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-minus-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53a5.72 5.72 0 0 0-2-1.19V8H4v11h8.08c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4V4a2 2 0 0 1 2-2m4 4V4h-4v2h4m0 11h8v2h-8v-2Z"/>'
        },
        "briefcase-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L19.11 21H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h.11l-3-3l1.28-1.27l19.72 19.73M22 18.8L8 4.8V4c0-1.11.89-2 2-2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v10.8M14 4h-4v2h4V4Z"/>'
        },
        "briefcase-off-outline": {
            body: '<path fill="currentColor" d="M20 8v8.8l2 2V8c0-.55-.2-1-.58-1.41C21.05 6.2 20.58 6 20 6h-4V4c0-.58-.2-1.05-.58-1.42C15.05 2.2 14.58 2 14 2h-4c-.58 0-1.05.2-1.42.58C8.2 2.95 8 3.42 8 4v.8L11.2 8H20M10 4h4v2h-4V4M2.39 1.73L1.11 3l3 3H4c-.58 0-1.05.2-1.42.59C2.2 7 2 7.45 2 8v11c0 .55.2 1 .58 1.41c.37.39.84.59 1.42.59h15.11l1.73 1.73l1.27-1.27L2.39 1.73M4 19V8h2.11l11 11H4Z"/>'
        },
        "briefcase-outline": {
            body: '<path fill="currentColor" d="M20 6c.58 0 1.05.2 1.42.59c.38.41.58.86.58 1.41v11c0 .55-.2 1-.58 1.41c-.37.39-.84.59-1.42.59H4c-.58 0-1.05-.2-1.42-.59C2.2 20 2 19.55 2 19V8c0-.55.2-1 .58-1.41C2.95 6.2 3.42 6 4 6h4V4c0-.58.2-1.05.58-1.42C8.95 2.2 9.42 2 10 2h4c.58 0 1.05.2 1.42.58c.38.37.58.84.58 1.42v2h4M4 8v11h16V8H4m10-2V4h-4v2h4Z"/>'
        },
        "briefcase-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53A5.97 5.97 0 0 0 18 12a6 6 0 0 0-6 6c0 1.09.29 2.12.8 3H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-plus-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53a5.72 5.72 0 0 0-2-1.19V8H4v11h8.08c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4V4a2 2 0 0 1 2-2m4 4V4h-4v2h4m0 11h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "briefcase-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53A5.97 5.97 0 0 0 18 12a6 6 0 0 0-6 6c0 1.09.29 2.12.8 3H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-remove-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.53a5.72 5.72 0 0 0-2-1.19V8H4v11h8.08c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4V4a2 2 0 0 1 2-2m4 4V4h-4v2h4m.46 9.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12Z"/>'
        },
        "briefcase-search": {
            body: '<path fill="currentColor" d="M16.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.03A6.492 6.492 0 0 0 16.5 10a6.5 6.5 0 0 0-6.5 6.5c0 1.75.69 3.33 1.81 4.5H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4Z"/>'
        },
        "briefcase-search-outline": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v5.03c-.5-.8-1.2-1.49-2-2.03V8H4v11h6.5c.31.75.76 1.42 1.31 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m6.31 12.9l3.08 3.1L22 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4m-3.81.1a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5Z"/>'
        },
        "briefcase-upload": {
            body: '<path fill="currentColor" d="M10 2h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4m-2 3l-5 5h3v4h4v-4h3l-5-5Z"/>'
        },
        "briefcase-upload-outline": {
            body: '<path fill="currentColor" d="m12 9l5 5h-3v4h-4v-4H7l5-5m-2-7h4a2 2 0 0 1 2 2v2h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h4V4c0-1.11.89-2 2-2m4 4V4h-4v2h4M4 8v11h16V8H4Z"/>'
        },
        "briefcase-variant": {
            body: '<path fill="currentColor" d="M10 16v-1H3v4c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4m10-9h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2m-6 0h-4V5h4v2Z"/>'
        },
        "briefcase-variant-off": {
            body: '<path fill="currentColor" d="M10 6.8L8.1 4.9L10 3h4l2 2v2h4c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-2.8l-7-7H14V5h-4v1.8M2.39 1.73L1.11 3l4 4H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h.11L14 15.89V16h-4v-1H3v4c0 1.11.89 2 2 2h14.1l1.74 1.73l1.27-1.27L2.39 1.73M21 17.8V15h-2.8l2.8 2.8Z"/>'
        },
        "briefcase-variant-off-outline": {
            body: '<path fill="currentColor" d="M10 6.8L8.1 4.9L10 3h4l2 2v2h4c1.1 0 2 .9 2 2v5c0 .73-.41 1.37-1 1.72v2.08L17.2 14H20V9h-7.8l-2-2H14V5h-4v1.8m12.11 14.66l-1.27 1.27L19.1 21H5c-1.11 0-2-.89-2-2v-3.27c-.6-.35-1-.98-1-1.73V9c0-1.1.9-2 2-2h1.11l-4-4l1.28-1.27l19.72 19.73M11 15h2v-.11L11.11 13H11v2m-2-1v-3h.11l-2-2H4v5h5m8.11 5L15 16.89V17H9v-1H5v3h12.11Z"/>'
        },
        "briefcase-variant-outline": {
            body: '<path fill="currentColor" d="M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2M10 5h4v2h-4V5M4 9h16v5h-5v-3H9v3H4V9m9 6h-2v-2h2v2m6 4H5v-3h4v1h6v-1h4v3Z"/>'
        },
        brightness: {
            body: '<path d="M4 4h4.686L12 .686L15.314 4H20v4.686L23.314 12L20 15.314V20h-4.686L12 23.314L8.686 20H4v-4.686L.686 12L4 8.686V4zm8 2v12a6 6 0 0 0 0-12z" fill="currentColor"/>',
            hidden: true
        },
        "brightness-1": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "brightness-2": {
            body: '<path fill="currentColor" d="M10 2c-1.82 0-3.53.5-5 1.35C8 5.08 10 8.3 10 12s-2 6.92-5 8.65C6.47 21.5 8.18 22 10 22a10 10 0 0 0 10-10A10 10 0 0 0 10 2Z"/>'
        },
        "brightness-3": {
            body: '<path fill="currentColor" d="M9 2c-1.05 0-2.05.16-3 .46c4.06 1.27 7 5.04 7 9.54c0 4.5-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46a10 10 0 0 0 10-10A10 10 0 0 0 9 2Z"/>'
        },
        "brightness-4": {
            body: '<path fill="currentColor" d="M12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12c0-2.42-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6a6 6 0 0 1 6 6a6 6 0 0 1-6 6m8-9.31V4h-4.69L12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31L15.31 20H20v-4.69L23.31 12L20 8.69Z"/>'
        },
        "brightness-5": {
            body: '<path fill="currentColor" d="M12 18a6 6 0 0 1-6-6a6 6 0 0 1 6-6a6 6 0 0 1 6 6a6 6 0 0 1-6 6m8-2.69L23.31 12L20 8.69V4h-4.69L12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31L15.31 20H20v-4.69Z"/>'
        },
        "brightness-6": {
            body: '<path fill="currentColor" d="M12 18V6a6 6 0 0 1 6 6a6 6 0 0 1-6 6m8-2.69L23.31 12L20 8.69V4h-4.69L12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31L15.31 20H20v-4.69Z"/>'
        },
        "brightness-7": {
            body: '<path fill="currentColor" d="M12 8a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 10a6 6 0 0 1-6-6a6 6 0 0 1 6-6a6 6 0 0 1 6 6a6 6 0 0 1-6 6m8-9.31V4h-4.69L12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31L15.31 20H20v-4.69L23.31 12L20 8.69Z"/>'
        },
        "brightness-auto": {
            body: '<path fill="currentColor" d="m14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9M20 8.69V4h-4.69L12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31L15.31 20H20v-4.69L23.31 12L20 8.69m-9.15 3.96h2.3L12 9l-1.15 3.65Z"/>'
        },
        "brightness-percent": {
            body: '<path fill="currentColor" d="M20.04 8.71V4h-4.7L12 .69L8.71 4H4v4.71L.69 12L4 15.34v4.7h4.71L12 23.35l3.34-3.31h4.7v-4.7L23.35 12l-3.31-3.29M8.83 7.05c.98 0 1.77.79 1.77 1.78a1.77 1.77 0 0 1-1.77 1.77c-.99 0-1.78-.79-1.78-1.77c0-.99.79-1.78 1.78-1.78M15.22 17c-.98 0-1.77-.8-1.77-1.78a1.77 1.77 0 0 1 1.77-1.77c.98 0 1.78.79 1.78 1.77A1.78 1.78 0 0 1 15.22 17m-6.72.03L7 15.53L15.53 7l1.5 1.5l-8.53 8.53Z"/>'
        },
        broadcast: {
            body: '<path fill="currentColor" d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m6 2c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 2.2 1.2 4.1 3 5.2l1-1.7c-1.2-.7-2-2-2-3.4c0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.5-.8 2.8-2 3.4l1 1.7c1.8-1 3-3 3-5.2M12 2C6.5 2 2 6.5 2 12c0 3.7 2 6.9 5 8.6l1-1.7c-2.4-1.4-4-4-4-6.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3-1.6 5.5-4 6.9l1 1.7c3-1.7 5-4.9 5-8.6c0-5.5-4.5-10-10-10Z"/>'
        },
        "broadcast-off": {
            body: '<path fill="currentColor" d="M17.6 14.2c.3-.7.4-1.4.4-2.2c0-3.3-2.7-6-6-6c-.8 0-1.6.2-2.2.4L11.4 8h.6c2.2 0 4 1.8 4 4c0 .2 0 .4-.1.6l1.7 1.6M12 4c4.4 0 8 3.6 8 8c0 1.4-.4 2.6-1 3.7l1.5 1.5c.9-1.5 1.5-3.3 1.5-5.2c0-5.5-4.5-10-10-10c-1.9 0-3.7.5-5.2 1.5L8.3 5c1.1-.7 2.3-1 3.7-1M3.3 2.5L2 3.8l2.1 2.1C2.8 7.6 2 9.7 2 12c0 3.7 2 6.9 5 8.6l1-1.7c-2.4-1.4-4-4-4-6.9c0-1.8.6-3.4 1.5-4.7L7 8.8c-.6.9-1 2-1 3.2c0 2.2 1.2 4.1 3 5.2l1-1.7c-1.2-.7-2-2-2-3.4c0-.6.2-1.2.4-1.8l1.6 1.6v.2c0 1.1.9 2 2 2h.2l7.5 7.5l1.3-1.3L4.3 3.5l-1-1Z"/>'
        },
        broom: {
            body: '<path fill="currentColor" d="m19.36 2.72l1.42 1.42l-5.72 5.71c1.07 1.54 1.22 3.39.32 4.59L9.06 8.12c1.2-.9 3.05-.75 4.59.32l5.71-5.72M5.93 17.57c-2.01-2.01-3.24-4.41-3.58-6.65l4.88-2.09l7.44 7.44l-2.09 4.88c-2.24-.34-4.64-1.57-6.65-3.58Z"/>'
        },
        brush: {
            body: '<path fill="currentColor" d="m20.71 4.63l-1.34-1.34c-.37-.39-1.02-.39-1.41 0L9 12.25L11.75 15l8.96-8.96c.39-.39.39-1.04 0-1.41M7 14a3 3 0 0 0-3 3c0 1.31-1.16 2-2 2c.92 1.22 2.5 2 4 2a4 4 0 0 0 4-4a3 3 0 0 0-3-3Z"/>'
        },
        "brush-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-8.4-8.4l-.6.7L9 12.2l.7-.7L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M7 14c-1.7 0-3 1.3-3 3c0 1.3-1.2 2-2 2c.9 1.2 2.5 2 4 2c2.2 0 4-1.8 4-4c0-1.7-1.3-3-3-3m13.7-8c.4-.4.4-1 0-1.4l-1.3-1.3c-.4-.4-1-.4-1.4 0L12.2 9l2.8 2.8L20.7 6Z"/>'
        },
        "brush-outline": {
            body: '<path fill="currentColor" d="M7 16c.55 0 1 .45 1 1c0 1.1-.9 2-2 2c-.17 0-.33 0-.5-.05c.31-.55.5-1.21.5-1.95c0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25L11.75 15l8.96-8.96c.39-.39.39-1.04 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29M7 14c-1.66 0-3 1.34-3 3c0 1.31-1.16 2-2 2c.92 1.22 2.5 2 4 2c2.21 0 4-1.79 4-4c0-1.66-1.34-3-3-3Z"/>'
        },
        "brush-variant": {
            body: '<path fill="currentColor" d="M8 3C5.79 3 4 4.79 4 7v7c0 1.1.9 2 2 2h3v4c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-4h3c1.1 0 2-.9 2-2V3H8m0 2h4v2h2V5h1v4h2V5h1v5H6V7c0-1.1.9-2 2-2m-2 9v-2h12v2H6Z"/>'
        },
        bucket: {
            body: '<path fill="currentColor" d="M3 4h18v3h-1l-2.5 14h-11L4 7H3V4Z"/>'
        },
        "bucket-outline": {
            body: '<path fill="currentColor" d="M3 4h18v3h-1l-2.5 14h-11L4 7H3V4m14.97 3H6.03l2.12 12h7.7l2.12-12Z"/>'
        },
        buffer: {
            body: '<path d="M12.6 2.86c2.67 1.24 5.4 2.53 8.06 3.77c.15.07.34.12.34.32s-.19.24-.34.31C18 8.5 15.3 9.77 12.62 11a1.3 1.3 0 0 1-1.24 0C8.69 9.76 6 8.5 3.32 7.25C3.18 7.19 3 7.14 3 6.94c0-.18.18-.23.31-.29C6 5.39 8.74 4.1 11.44 2.85c.29-.13.86-.12 1.16.01M12 21.15c-.2 0-.34-.08-.62-.18c-2.69-1.24-5.38-2.5-8.05-3.75c-.14-.07-.33-.11-.33-.32c0-.2.19-.24.34-.31c.44-.21.89-.42 1.33-.63c.45-.2.89-.2 1.33.01c1.79.83 3.57 1.66 5.35 2.49c.44.21.88.2 1.32 0c1.78-.84 3.56-1.67 5.33-2.5c.44-.2.87-.21 1.29-.01c.48.21.95.44 1.42.66c.07.03.14.07.2.12c.13.1.13.27 0 .35c-.08.06-.17.11-.26.15c-2.65 1.27-5.32 2.49-7.99 3.72c-.2.1-.47.2-.66.2m0-4.98c-.1 0-.45-.1-.64-.17c-2.68-1.26-5.36-2.5-8.02-3.76c-.14-.06-.34-.11-.34-.31c0-.21.2-.25.35-.32c.45-.22.9-.43 1.35-.64c.43-.19.86-.19 1.3.03c1.78.82 3.58 1.66 5.38 2.5c.41.19.83.19 1.25 0c1.8-.85 3.6-1.69 5.41-2.53c.41-.19.83-.19 1.25 0c.47.22.95.44 1.42.66c.06.03.13.06.19.11c.14.11.14.26-.01.38c-.05.04-.12.07-.18.1c-2.71 1.28-5.4 2.53-8.1 3.78c-.19.09-.53.17-.61.17z" fill="currentColor"/>',
            hidden: true
        },
        buffet: {
            body: '<path fill="currentColor" d="M9 14c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m6 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M3 22l1-3H3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1h-1l1 3h-2l-1-3H6l-1 3H3m10-9v4h7v-4h-7m-9 0v4h7v-4H4Z"/>'
        },
        bug: {
            body: '<path fill="currentColor" d="M14 12h-4v-2h4m0 6h-4v-2h4m6-6h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41L15.59 3l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L8.41 3L7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8Z"/>'
        },
        "bug-check": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 8H9v-2h4v2m0-4H9V9h4v2m4.75 11.16l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41l-4.75 4.75Z"/>'
        },
        "bug-check-outline": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-.57.09-1.14.25-1.69c-.66.45-1.45.69-2.25.69c-2.21 0-4-1.79-4-4v-4c0-2.21 1.79-4 4-4s4 1.79 4 4v4c0 .19 0 .39-.05.58c.59-.54 1.29-.96 2.05-1.23V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m2.34 9l-3.59 3.59L16.16 18L15 19.16l2.75 3l4.75-4.75L21.34 16M13 9v2H9V9h4m0 4v2H9v-2h4Z"/>'
        },
        "bug-outline": {
            body: '<path fill="currentColor" d="M20 8h-2.81c-.45-.8-1.07-1.5-1.82-2L17 4.41L15.59 3l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L8.41 3L7 4.41L8.62 6c-.75.5-1.36 1.21-1.81 2H4v2h2.09c-.06.33-.09.66-.09 1v1H4v2h2v1c0 .34.03.67.09 1H4v2h2.81A5.988 5.988 0 0 0 15 20.18c.91-.52 1.67-1.28 2.19-2.18H20v-2h-2.09c.06-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.03-.67-.09-1H20V8m-4 7a4 4 0 0 1-4 4a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4v4m-2-5v2h-4v-2h4m-4 4h4v2h-4v-2Z"/>'
        },
        "bug-pause": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 8H9v-2h4v2m0-4H9V9h4v2m7 5h2v6h-2m-4-6h2v6h-2v-6Z"/>'
        },
        "bug-pause-outline": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-.57.09-1.14.25-1.69c-.66.45-1.45.69-2.25.69c-2.21 0-4-1.79-4-4v-4c0-2.21 1.79-4 4-4s4 1.79 4 4v4c0 .19 0 .39-.05.58c.59-.54 1.29-.96 2.05-1.23V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 2v2H9V9h4m0 4v2H9v-2h4m7 3h2v6h-2m-4-6h2v6h-2v-6Z"/>'
        },
        "bug-play": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 8H9v-2h4v2m0-4H9V9h4v2m4 5v6l5-3l-5-3Z"/>'
        },
        "bug-play-outline": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-.57.09-1.14.25-1.69c-.66.45-1.45.69-2.25.69c-2.21 0-4-1.79-4-4v-4c0-2.21 1.79-4 4-4s4 1.79 4 4v4c0 .19 0 .39-.05.58c.59-.54 1.29-.96 2.05-1.23V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 2v2H9V9h4m0 4v2H9v-2h4m4 3v6l5-3l-5-3Z"/>'
        },
        "bug-stop": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 8H9v-2h4v2m0-4H9V9h4v2m3 5h6v6h-6v-6Z"/>'
        },
        "bug-stop-outline": {
            body: '<path fill="currentColor" d="M19 7h-2.81c-.45-.8-1.07-1.5-1.82-2L16 3.41L14.59 2l-2.17 2.17a6.002 6.002 0 0 0-2.83 0L7.41 2L6 3.41L7.62 5c-.75.5-1.36 1.21-1.81 2H3v2h2.09c-.06.33-.09.66-.09 1v1H3v2h2v1c0 .34.03.67.09 1H3v2h2.81A6.002 6.002 0 0 0 13 19.65V19c0-.57.09-1.14.25-1.69c-.66.45-1.45.69-2.25.69c-2.21 0-4-1.79-4-4v-4c0-2.21 1.79-4 4-4s4 1.79 4 4v4c0 .19 0 .39-.05.58c.59-.54 1.29-.96 2.05-1.23V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H19V7m-6 2v2H9V9h4m0 4v2H9v-2h4m3 3h6v6h-6v-6Z"/>'
        },
        bugle: {
            body: '<path fill="currentColor" d="M21 6c0 5-9 5-9 5H5c-1 0-2-1-2-1H2v4h1s1-1 2-1h1.3c-.8.5-1.3 1.2-1.3 2c0 1.8 2.3 3 5.5 3s5.5-1.2 5.5-3c0-.6-.3-1.2-.8-1.7c2.6.5 5.8 1.7 5.8 4.7h1V6h-1M10.5 16.7c-2.3 0-4.1-.8-4.1-1.7c0-.9 1.8-1.7 4.1-1.7s4.1.8 4.1 1.7c0 .9-1.8 1.7-4.1 1.7Z"/>'
        },
        "bulkhead-light": {
            body: '<path fill="currentColor" d="M13 2.09V2c0-.55-.45-1-1-1s-1 .45-1 1v.09a5.96 5.96 0 0 0-4.97 5.88V16c0 3 2.16 5.44 4.97 5.91V22c0 .55.45 1 1 1s1-.45 1-1v-.09A5.968 5.968 0 0 0 17.97 16V7.97C18 5 15.81 2.56 13 2.09M16 8h-1V5.4c.6.69 1 1.6 1 2.6m-2 11.44c-.59.35-1.27.56-2 .56s-1.41-.21-2-.56V16h4v3.44M10 15V9h4v6h-4m-1 0h-.97V9H9v6m1-10.44c.59-.35 1.27-.56 2-.56s1.41.21 2 .56V8h-4V4.56M15 9h1v6h-1V9M9 5.4V8h-.97v-.03c0-.97.37-1.88.97-2.57M8.03 16H9v2.6c-.6-.69-.97-1.6-.97-2.57V16M15 18.6V16h1c0 1-.4 1.91-1 2.6Z"/>'
        },
        bulldozer: {
            body: '<path fill="currentColor" d="M4 4a1 1 0 0 0-1 1v5c-.46 0-.86.31-.97.76v3.21h.26C2.65 13.37 3.3 13 4 13h9c.7 0 1.35.37 1.71.97h1.32L16 11a1 1 0 0 0-1-1h-2V8a1 1 0 0 0-1-1a1 1 0 0 0-1 1v2H9V5a1 1 0 0 0-1-1H4m1 2h2v5H5V6m12 5v8h5v-1l-3-1l-1-6h-1M4 15a2 2 0 0 0-2 2a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2a2 2 0 0 0-2-2H4Z"/>'
        },
        bullet: {
            body: '<path fill="currentColor" d="M14 22h-4v-1h4v1m-1-12V7h-2v3l-1 1.5V20h4v-8.5L13 10m-1-8s-1 1-1 3v1h2V5s0-2-1-3Z"/>'
        },
        "bulletin-board": {
            body: '<path fill="currentColor" d="M12.04 2.5L9.53 5h5l-2.49-2.5M4 7v13h16V7H4m8-7l5 5h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3l5-5M7 18v-4h5v4H7m7-1v-7h4v7h-4m-8-5V9h5v3H6Z"/>'
        },
        bullhorn: {
            body: '<path fill="currentColor" d="M12 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h3l5 4V4l-5 4m9.5 4c0 1.71-.96 3.26-2.5 4V8c1.53.75 2.5 2.3 2.5 4Z"/>'
        },
        "bullhorn-outline": {
            body: '<path fill="currentColor" d="M12 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h3l5 4V4l-5 4m3 7.6L13 14H4v-4h9l2-1.6v7.2m6.5-3.6c0 1.71-.96 3.26-2.5 4V8c1.53.75 2.5 2.3 2.5 4Z"/>'
        },
        "bullhorn-variant": {
            body: '<path fill="currentColor" d="M20 2v2L4 8V6H2v12h2v-2l2 .5v2C6 20.4 7.6 22 9.5 22s3.5-1.6 3.5-3.5v-.2l7 1.7v2h2V2h-2m-9 16.5c0 .8-.7 1.5-1.5 1.5S8 19.3 8 18.5V17l3 .8v.7Z"/>'
        },
        "bullhorn-variant-outline": {
            body: '<path fill="currentColor" d="M20 2v2L4 8V6H2v12h2v-2l2 .5v2C6 20.4 7.6 22 9.5 22s3.5-1.6 3.5-3.5v-.2l7 1.7v2h2V2h-2m-9 16.5c0 .8-.7 1.5-1.5 1.5S8 19.3 8 18.5V17l3 .8v.7m9-.5L4 14v-4l16-4v12Z"/>'
        },
        bullseye: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m0 2a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "bullseye-arrow": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-1.16-.21-2.31-.61-3.39l-1.6 1.6c.14.59.21 1.19.21 1.79a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8c.6 0 1.2.07 1.79.21L15.4 2.6C14.31 2.21 13.16 2 12 2m7 0l-4 4v1.5l-2.55 2.55C12.3 10 12.15 10 12 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.15 0-.3-.05-.45L16.5 9H18l4-4h-3V2m-7 4a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6h-2a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4V6Z"/>'
        },
        bulma: {
            body: '<path fill="currentColor" d="m11.38 2l-5 5l-1.25 8.75L11.38 22l7.5-5l-5-5l3.75-3.75L11.38 2Z"/>'
        },
        "bunk-bed": {
            body: '<path fill="currentColor" d="M1 2v21h2v-2h18v2h2V7c0-2.21-1.79-4-4-4h-9v5H3V2m3.5 0A2.5 2.5 0 0 0 4 4.5A2.5 2.5 0 0 0 6.5 7A2.5 2.5 0 0 0 9 4.5A2.5 2.5 0 0 0 6.5 2M3 11h18v2.56c-.59-.35-1.27-.56-2-.56h-9v5H3m3.5-6A2.5 2.5 0 0 0 4 14.5A2.5 2.5 0 0 0 6.5 17A2.5 2.5 0 0 0 9 14.5A2.5 2.5 0 0 0 6.5 12Z"/>'
        },
        "bunk-bed-outline": {
            body: '<path fill="currentColor" d="M1 2h2v7h7V3h9c2.2 0 4 1.8 4 4v16h-2v-2H3v2H1V2m11 3v4h9V7c0-1.1-.9-2-2-2h-7m-9 6v8h7v-6h9c.7 0 1.4.2 2 .6V11H3m3.5 2C7.9 13 9 14.1 9 15.5S7.9 18 6.5 18S4 16.9 4 15.5S5.1 13 6.5 13m0 1.6c-.5 0-.9.4-.9.9s.4.9.9.9s.9-.4.9-.9s-.4-.9-.9-.9m5.5.4v4h9v-2c0-1.1-.9-2-2-2h-7M6.5 3C7.9 3 9 4.1 9 5.5S7.9 8 6.5 8S4 6.9 4 5.5S5.1 3 6.5 3m0 1.6c-.5 0-.9.4-.9.9s.4.9.9.9s.9-.4.9-.9s-.4-.9-.9-.9Z"/>'
        },
        bus: {
            body: '<path fill="currentColor" d="M18 11H6V6h12m-1.5 11a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-9 0A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 14A1.5 1.5 0 0 1 9 15.5A1.5 1.5 0 0 1 7.5 17M4 16c0 .88.39 1.67 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10Z"/>'
        },
        "bus-alert": {
            body: '<path fill="currentColor" d="M16 1a7 7 0 0 1 7 7c0 3.53-2.61 6.45-6 6.93V18c0 .84-.35 1.58-1.04 2.2V22c0 .27-.09.5-.28.71c-.18.2-.42.29-.68.29h-1a.98.98 0 0 1-.73-.29a.964.964 0 0 1-.31-.71v-1H5.04v1c0 .27-.1.5-.31.71c-.2.2-.44.29-.73.29H3c-.26 0-.5-.09-.68-.29c-.19-.21-.28-.44-.28-.71v-1.8C1.35 19.58 1 18.84 1 18V8c0-1.58.7-2.65 2.07-3.2C4.44 4.26 6.42 4 9 4l1.23.03A7.013 7.013 0 0 1 16 1m0 2a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m-1 7h2v2h-2v-2m0-6h2v5h-2V4M3 13h8.09A7.01 7.01 0 0 1 9 8H3v5m1.5 3c-.81 0-1.5.67-1.5 1.5A1.5 1.5 0 0 0 4.5 19c.85 0 1.5-.67 1.5-1.5A1.5 1.5 0 0 0 4.5 16m9 0c-.85 0-1.5.67-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5c.81 0 1.5-.67 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "bus-articulated-end": {
            body: '<path fill="currentColor" d="M21.5 6L20 7.5L21.5 9L20 10.5l1.5 1.5l-1.5 1.5l1.5 1.5h-9a3 3 0 0 1-3 3a3 3 0 0 1-3-3h-4V8c0-1.11.89-2 2-2h17m-3 1.5H15V10h3.5V7.5m-5 0h-4V10h4V7.5M8 7.5H4V10h4V7.5m1.5 6A1.5 1.5 0 0 0 8 15a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 11 15a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "bus-articulated-front": {
            body: '<path fill="currentColor" d="m1 6l1.5 1.5L1 9l1.5 1.5L1 12l1.5 1.5L1 15h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2V8c0-1.11-.89-2-2-2H1m3 1.5h2.5V10H4V7.5m4 0h4V10H8V7.5m5.5 0h4V10h-4V7.5m5.5 0h2.5V13L19 11V7.5m-13 6A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "bus-clock": {
            body: '<path fill="currentColor" d="M16.5 4v4.25l2.86 1.69l-.75 1.22L15 9V4h1.5m-.5 9c1.36 0 2.54-.5 3.5-1.47c1-.97 1.5-2.14 1.5-3.53c0-1.36-.5-2.54-1.5-3.5c-.96-1-2.14-1.5-3.5-1.5c-1.39 0-2.56.5-3.53 1.5C11.5 5.46 11 6.64 11 8c0 1.39.5 2.56 1.47 3.53c.97.97 2.14 1.47 3.53 1.47m-2.5 6c.44 0 .8-.16 1.08-.46c.28-.3.42-.65.42-1.04c0-.42-.14-.77-.42-1.07c-.28-.3-.64-.43-1.08-.43c-.44 0-.8.13-1.08.43s-.42.65-.42 1.07c0 .39.14.74.42 1.04c.28.3.64.46 1.08.46M3 13h8.11C9.7 11.64 9 10 9 8H3v5m1.5 6c.44 0 .8-.16 1.08-.46c.28-.3.42-.65.42-1.04c0-.42-.14-.77-.42-1.07c-.28-.3-.64-.43-1.08-.43c-.44 0-.8.13-1.08.43S3 17.08 3 17.5c0 .39.14.74.42 1.04c.28.3.64.46 1.08.46M16 1c1.92 0 3.58.67 4.95 2.05C22.33 4.42 23 6.08 23 8c0 1.77-.56 3.29-1.72 4.59c-1.15 1.29-2.58 2.07-4.28 2.32V18c0 .84-.33 1.58-1 2.2V22c0 .27-.11.5-.3.71c-.2.2-.42.29-.7.29h-1c-.27 0-.5-.09-.71-.29A.982.982 0 0 1 13 22v-1H5v1c0 .27-.09.5-.29.71c-.21.2-.44.29-.71.29H3c-.28 0-.5-.09-.7-.29c-.19-.21-.3-.44-.3-.71v-1.8c-.67-.62-1-1.36-1-2.2V8c0-1.58.67-2.65 2.05-3.2C4.42 4.26 6.41 4 9 4h.61c.28 0 .48.03.61.03C11.63 2 13.55 1 16 1Z"/>'
        },
        "bus-double-decker": {
            body: '<path fill="currentColor" d="M3 4c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2V9.5h4V6c0-1.11-.89-2-2-2H3m-.5 1.5h4V8h-4V5.5m5.5 0h4V8H8V5.5m5.5 0h4V8h-4V5.5m5.5 0h2.5V8H19V5.5m-5.5 4h4V12h-4V9.5m-11 0h4V12h-4V9.5m5.5 0h4V12H8V9.5m-2 6A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "bus-electric": {
            body: '<path fill="currentColor" d="M18 8H6V4h12m-1.5 10c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m-9 0c-.8 0-1.5-.7-1.5-1.5S6.7 11 7.5 11s1.5.7 1.5 1.5S8.3 14 7.5 14M4 13c0 .9.4 1.7 1 2.2V17c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h8v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1.8c.6-.5 1-1.3 1-2.2V4c0-3.5-3.6-4-8-4S4 .5 4 4v9m3 8h4v-2l6 3h-4v2l-6-3Z"/>'
        },
        "bus-marker": {
            body: '<path fill="currentColor" d="M12 2c-4.42 0-8 .5-8 4v10a3 3 0 0 0 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h6a8 8 0 0 1-1-3.5a5.55 5.55 0 0 1 2.38-4.5H6V6h12v4a4.07 4.07 0 0 1 .5 0a5.34 5.34 0 0 1 1.5.22V6c0-3.5-3.58-4-8-4M7.5 14A1.5 1.5 0 1 1 6 15.5A1.5 1.5 0 0 1 7.5 14m11-2a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2Z"/>'
        },
        "bus-multiple": {
            body: '<path fill="currentColor" d="M10 5c-4.42 0-8 .5-8 4v10c0 .85.37 1.66 1 2.22V23c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.63-.56 1-1.37 1-2.22V9c0-3.5-3.58-4-8-4M5.5 20c-.83 0-1.5-.67-1.5-1.5S4.67 17 5.5 17s1.5.67 1.5 1.5S6.33 20 5.5 20m9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m1.5-6H4V9h12v5m6-9v10c0 .85-.37 1.66-1 2.22V19c0 .55-.45 1-1 1h-.12c.07-.32.12-.65.12-1V9c0-6-7-6-10-6c-.91 0-2.2 0-3.54.17C7.55 1.32 10.5 1 14 1c4.42 0 8 .5 8 4Z"/>'
        },
        "bus-school": {
            body: '<path fill="currentColor" d="M3 6c-1.11 0-2 .89-2 2v7h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2V8c0-1.11-.89-2-2-2H3m10.5 1.5h4V10h-4V7.5m-11 0h4V10h-4V7.5m5.5 0h4V10H8V7.5m-2 6A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "bus-side": {
            body: '<path fill="currentColor" d="M3 6c-1.11 0-2 .89-2 2v7h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2V8c0-1.11-.89-2-2-2H3m-.5 1.5h4V10h-4V7.5m5.5 0h4V10H8V7.5m5.5 0h4V10h-4V7.5m5.5 0h2.5V13L19 11V7.5m-13 6A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "bus-stop": {
            body: '<path fill="currentColor" d="M22 7v9c0 .71-.38 1.36-1 1.72v1.53c0 .41-.34.75-.75.75h-.5c-.41 0-.75-.34-.75-.75V18h-7v1.25c0 .41-.34.75-.75.75h-.5c-.41 0-.75-.34-.75-.75v-1.53c-.61-.36-1-1.01-1-1.72V7c0-3 3-3 6.5-3S22 4 22 7m-9 8c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m7 0c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m0-8h-9v4h9V7M7 9.5C6.97 8.12 5.83 7 4.45 7.05A2.501 2.501 0 0 0 2 9.6A2.51 2.51 0 0 0 4 12v8h1v-8c1.18-.24 2-1.29 2-2.5Z"/>'
        },
        "bus-stop-covered": {
            body: '<path fill="currentColor" d="M20 3H7V2H6a1.78 1.78 0 0 0-1.41 1H2v2h1.73C2 10.58 2 22 2 22h5V5h13m2 3.5a2.5 2.5 0 1 0-3 2.5v11h1V11a2.5 2.5 0 0 0 2-2.5m-7 3V16h-1v6h-1.5v-5h-1v5H10v-6H9v-4.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5m-3-5A1.5 1.5 0 1 0 13.5 8A1.5 1.5 0 0 0 12 6.5Z"/>'
        },
        "bus-stop-uncovered": {
            body: '<path fill="currentColor" d="M6 22v-3H4v3H2v-8a1 1 0 0 1 1-1a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v4m12-11v11h-1V11a2.5 2.5 0 1 1 1 0m-5 .55V16h-1v6h-1.5v-5h-1v5H10v-6H9v-4.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5m-3-4.95A1.5 1.5 0 1 0 13.5 8A1.5 1.5 0 0 0 12 6.5Z"/>'
        },
        butterfly: {
            body: '<path fill="currentColor" d="M13 21h-2V6L9.03 3.97L10 3l2 2l2-2l1 1l-2 2v15M7 6a5.002 5.002 0 0 0-3 9v2c0 2.21 1.79 4 4 4c.72 0 1.39-.19 1.97-.5l.03-.04V7c-.84-.63-1.87-1-3-1m-.5 6.5L5 11l1.5-1.5L8 11l-1.5 1.5M22 11c0-2.76-2.24-5-5-5c-1.12 0-2.15.37-3 1v13.46c.59.35 1.27.54 2 .54c2.21 0 4-1.79 4-4v-2c1.21-.91 2-2.36 2-4m-4.5 1.5L16 11l1.5-1.5L19 11l-1.5 1.5Z"/>'
        },
        "butterfly-outline": {
            body: '<path fill="currentColor" d="M13 21h-2V6L9.03 3.97L10 3l2 2l2-2l1 1l-2 2v15m1-12V7a5.002 5.002 0 0 1 6 8v2c0 2.21-1.79 4-4 4c-.73 0-1.41-.19-2-.54v-2c.59.35 1.27.54 2 .54c1.1 0 2-.9 2-2v-3.17c1.17-.41 2-1.52 2-2.83c0-1.65-1.33-3-3-3c-1.12 0-2.16.37-3 1m-4 0c-.84-.63-1.87-1-3-1c-1.67 0-3 1.35-3 3c0 1.31.84 2.42 2 2.83V17c0 1.1.9 2 2 2c.73 0 1.41-.19 2-.54v2c-.59.35-1.27.54-2 .54c-2.21 0-4-1.79-4-4v-2a5.002 5.002 0 0 1 6-8v2m-1 2L7.5 9.5L6 11l1.5 1.5L9 11m9 0l-1.5-1.5L15 11l1.5 1.5L18 11Z"/>'
        },
        "button-cursor": {
            body: '<path fill="currentColor" d="M18.1 15.3c-.1.1-.3.2-.4.3l-2.4.4l1.7 3.6c.2.4 0 .8-.4 1l-2.8 1.3c-.1.1-.2.1-.3.1c-.3 0-.6-.2-.7-.4L11.2 18l-1.9 1.5c-.1.1-.3.2-.5.2c-.4 0-.8-.3-.8-.8V7.5c0-.5.3-.8.8-.8c.2 0 .4.1.5.2l8.7 7.4c.3.2.4.7.1 1M6 12H4V4h16v8h-1.6l2.2 1.9c.8-.3 1.3-1 1.3-1.9V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h2v-2Z"/>'
        },
        "button-pointer": {
            body: '<path fill="currentColor" d="M20 20.5c0 .8-.7 1.5-1.5 1.5H13c-.4 0-.7-.1-1-.4l-4-4.2l.7-.8c.2-.2.5-.3.8-.3h.2L12 18V9c0-.6.4-1 1-1s1 .4 1 1v4.5l1.2.1l3.9 2.2c.5.2.9.8.9 1.3v3.4M20 2H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h4v-2H4V4h16v8h-2v2h2c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"/>'
        },
        "cabin-a-frame": {
            body: '<path fill="currentColor" d="M12 3L4 21h16L12 3M9 19H7.08L9 14.67V19m4 0h-2v-5h2v5m-2.81-7L12 7.92L13.81 12h-3.62M15 14.67L16.92 19H15v-4.33Z"/>'
        },
        "cable-data": {
            body: '<path fill="currentColor" d="M7.05 3.5a3.519 3.519 0 0 0 0 4.97l8.49 8.48c.58.59.58 1.55 0 2.12c-.59.59-1.54.59-2.13 0l-4.24-4.24l1.06-1.06l-3.53-3.54l-.36.36l-1.41-1.42a1.02 1.02 0 0 0-1.43 0l-1.4 1.42c-.39.41-.39 1.02 0 1.41l1.4 1.41l-.34.36L6.7 17.3l1.06-1.06L12 20.5a3.531 3.531 0 0 0 4.95 0c1.37-1.38 1.37-3.6 0-4.96L8.46 7.05c-.58-.59-.58-1.55 0-2.12c.59-.59 1.54-.59 2.13 0l4.24 4.24l-1.06 1.06l3.53 3.54l.36-.36l1.41 1.42c.39.39 1.03.39 1.43 0l1.4-1.42c.39-.41.39-1.02 0-1.41l-1.4-1.41l.34-.36L17.3 6.7l-1.06 1.06L12 3.5a3.531 3.531 0 0 0-4.95 0m-4.24 7.79l1.41-1.41l1.42 1.41l-1.42 1.42m14.14 0l1.42-1.42l1.41 1.42l-1.41 1.41Z"/>'
        },
        cached: {
            body: '<path fill="currentColor" d="m19 8l-4 4h3a6 6 0 0 1-6 6c-1 0-1.97-.25-2.8-.7l-1.46 1.46A7.93 7.93 0 0 0 12 20a8 8 0 0 0 8-8h3M6 12a6 6 0 0 1 6-6c1 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0 0 12 4a8 8 0 0 0-8 8H1l4 4l4-4"/>'
        },
        cactus: {
            body: '<path fill="currentColor" d="M14 16v5h-4v-3H9a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1a1 1 0 0 1 1 1v3c0 .56.45 1 1 1h1V6a2 2 0 0 1 2-2a2 2 0 0 1 2 2v8h1a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2a3 3 0 0 1-3 3h-1Z"/>'
        },
        cake: {
            body: '<path fill="currentColor" d="M11.5.5c.5.25 1.5 1.9 1.5 3S12.33 5 11.5 5S10 4.85 10 3.75S11 2 11.5.5m7 8.5C21 9 23 11 23 13.5c0 1.56-.79 2.93-2 3.74V23H3v-5.76c-1.21-.81-2-2.18-2-3.74C1 11 3 9 5.5 9H10V6h3v3h5.5M12 16a2.5 2.5 0 0 0 2.5-2.5H16a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5h-13A2.5 2.5 0 0 0 3 13.5A2.5 2.5 0 0 0 5.5 16A2.5 2.5 0 0 0 8 13.5h1.5A2.5 2.5 0 0 0 12 16Z"/>'
        },
        "cake-layered": {
            body: '<path fill="currentColor" d="M21 21v-4a2 2 0 0 0-2-2h-1v-3a2 2 0 0 0-2-2h-3V8h-2v2H8c-1.11 0-2 .89-2 2v3H5c-1.11 0-2 .89-2 2v4H1v2h22v-2M12 7a2 2 0 0 0 2-2c0-.38-.1-.73-.29-1.03L12 1l-1.72 2.97c-.18.3-.28.65-.28 1.03a2 2 0 0 0 2 2Z"/>'
        },
        "cake-variant": {
            body: '<path fill="currentColor" d="M12 6a2 2 0 0 0 2-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03a2 2 0 0 0 2 2m4.6 10l-1.07-1.08L14.45 16c-1.3 1.29-3.58 1.3-4.89 0L8.5 14.92L7.4 16a3.467 3.467 0 0 1-4.4.39V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4.61a3.467 3.467 0 0 1-4.4-.39M18 9h-5V7h-2v2H6a3 3 0 0 0-3 3v1.54c0 1.08.88 1.96 1.96 1.96c.54 0 1.04-.2 1.38-.57L8.5 12.8l2.11 2.13c.74.74 2.03.74 2.77 0l2.12-2.13l2.15 2.13c.35.37.85.57 1.38.57c1.08 0 1.97-.88 1.97-1.96V12a3 3 0 0 0-3-3Z"/>'
        },
        "cake-variant-outline": {
            body: '<path fill="currentColor" d="M12 6a2 2 0 0 0 2-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03c0 1.1.9 2 2 2m6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3m1 11H5v-3c.9 0 1.76-.37 2.4-1l1.1-1.08L9.56 16c1.31 1.3 3.59 1.29 4.89 0l1.08-1.08L16.6 16c.64.63 1.5 1 2.4 1v3m0-4.5c-.5 0-1-.2-1.35-.57L15.5 12.8l-2.12 2.13c-.74.74-2.03.74-2.77 0L8.5 12.8l-2.16 2.13c-.34.36-.84.57-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5Z"/>'
        },
        calculator: {
            body: '<path fill="currentColor" d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v4h10V4H7m0 6v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2m-8 4v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2Z"/>'
        },
        "calculator-off": {
            body: '<path d="M1.5 4.768L2.777 3.5L21 21.723L19.732 23l-1.458-1.458c-.346.286-.79.458-1.274.458H7a2 2 0 0 1-2-2V8.268l-3.5-3.5zM7 2h10a2 2 0 0 1 2 2v13.177l-2-2V14h-1.177L13 11.177V10h-1.177l-2-2H17V4H7v1.177L5.125 3.302A2 2 0 0 1 7 2zm0 10h1.732L7 10.268V12zm8-2v2h2v-2h-2zm-8 4v2h2v-2H7zm4 2h1.732L11 14.268V16zm-4 2v2h2v-2H7zm4 0v2h2v-2h-2zm4 2h1.732L15 18.268V20z" fill="currentColor"/>',
            hidden: true
        },
        "calculator-variant": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6 4.1L14.1 6l1.4 1.4L16.9 6L18 7.1l-1.4 1.4L18 9.9L16.9 11l-1.4-1.4l-1.4 1.4L13 9.9l1.4-1.4L13 7.1m-6.8.6h5v1.5h-5V7.7m5.3 8.3h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16m6.5 1.2h-5v-1.5h5v1.5m0-2.4h-5v-1.5h5v1.5Z"/>'
        },
        "calculator-variant-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14v14M6.2 7.7h5v1.5h-5V7.7m6.8 8.1h5v1.5h-5v-1.5m0-2.6h5v1.5h-5v-1.5M8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2v2m6.1-7.1l1.4-1.4l1.4 1.4l1.1-1l-1.4-1.4L18 7.1L16.9 6l-1.4 1.4L14.1 6L13 7.1l1.4 1.4L13 9.9l1.1 1Z"/>'
        },
        calendar: {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1m-1 11h-5v5h5v-5Z"/>'
        },
        "calendar-account": {
            body: '<path fill="currentColor" d="M12 9c2 0 3 2.42 1.59 3.84c-1.42 1.42-3.84.41-3.84-1.59C9.75 10 10.75 9 12 9m4.5 9h-9v-1.12c0-1.25 2-2.25 4.5-2.25s4.5 1 4.5 2.25M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2h-1V1h-2Z"/>'
        },
        "calendar-account-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10m0-12H5V5h14m-7 5c2 0 3 2.42 1.59 3.84c-1.42 1.42-3.84.41-3.84-1.59C9.75 11 10.75 10 12 10m4.5 7.88V18h-9v-.12c0-1.25 2-2.25 4.5-2.25s4.5 1 4.5 2.25Z"/>'
        },
        "calendar-alert": {
            body: '<path fill="currentColor" d="M6 1v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2h-1V1h-2v2H8V1H6M5 8h14v11H5V8m6 1v5h2V9h-2m0 7v2h2v-2h-2Z"/>'
        },
        "calendar-alert-outline": {
            body: '<path fill="currentColor" d="M11 16h2v2h-2v-2m0-6h2v4h-2v-4m8-7h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5h14M5 19V9h14v10H5Z"/>'
        },
        "calendar-arrow-left": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 16H5V8h14v11m-7-9v2h4v3h-4v2l-4-3.5l4-3.5Z"/>'
        },
        "calendar-arrow-right": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 16H5V8h14v11m-7-2v-2H8v-3h4v-2l4 3.5l-4 3.5Z"/>'
        },
        "calendar-badge": {
            body: '<path fill="currentColor" d="M19.5 16c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5m-5.29 5H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v9.21c-.5-.13-1-.21-1.5-.21c-.17 0-.33 0-.5.03V8H5v11h9.03c-.03.17-.03.33-.03.5c0 .5.08 1 .21 1.5Z"/>'
        },
        "calendar-badge-outline": {
            body: '<path fill="currentColor" d="M19.5 16c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5M14 19.5c0-.17 0-.33.03-.5H5V9h14v5.03c.17-.03.33-.03.5-.03c.5 0 1 .08 1.5.21V5a2 2 0 0 0-2-2h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9.21c-.13-.5-.21-1-.21-1.5M5 5h14v2H5V5Z"/>'
        },
        "calendar-blank": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1"/>'
        },
        "calendar-blank-multiple": {
            body: '<path fill="currentColor" d="M21 17V8H7v9h14m0-14c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H7a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1M3 21h14v2H3a2 2 0 0 1-2-2V9h2v12Z"/>'
        },
        "calendar-blank-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10m0-12H5V5h14v2Z"/>'
        },
        "calendar-check": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-2.47 8.06L15.47 10l-4.88 4.88l-2.12-2.12l-1.06 1.06L10.59 17l5.94-5.94Z"/>'
        },
        "calendar-check-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10M5 7V5h14v2H5m5.56 10.46l5.94-5.93l-1.07-1.06l-4.87 4.87l-2.11-2.11l-1.06 1.06l3.17 3.17Z"/>'
        },
        "calendar-clock": {
            body: '<path fill="currentColor" d="M15 13h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13m4-5H5v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67V8M5 21a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2H5m11-9.85A4.85 4.85 0 0 0 11.15 16c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0 0 20.85 16c0-2.68-2.17-4.85-4.85-4.85Z"/>'
        },
        "calendar-clock-outline": {
            body: '<path fill="currentColor" d="M6 1v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h6.1c1.26 1.24 2.99 2 4.9 2c3.87 0 7-3.13 7-7c0-1.91-.76-3.64-2-4.9V5a2 2 0 0 0-2-2h-1V1h-2v2H8V1M5 5h14v2H5m0 2h14v.67c-.91-.43-1.93-.67-3-.67c-3.87 0-7 3.13-7 7c0 1.07.24 2.09.67 3H5m11-7.85c2.68 0 4.85 2.17 4.85 4.85c0 2.68-2.17 4.85-4.85 4.85c-2.68 0-4.85-2.17-4.85-4.85c0-2.68 2.17-4.85 4.85-4.85M15 13v3.69l3.19 1.84l.75-1.3l-2.44-1.41V13Z"/>'
        },
        "calendar-collapse-horizontal": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1m-7 13l-3-3v2H6v2h2v2l3-3m7-1h-2v-2l-3 3l3 3v-2h2v-2Z"/>'
        },
        "calendar-collapse-horizontal-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5h14M5 19V9h14v10H5m11-8l-3 3l3 3v-2h2v-2h-2v-2m-8 2H6v2h2v2l3-3l-3-3v2Z"/>'
        },
        "calendar-cursor": {
            body: '<path fill="currentColor" d="M22.86 17.74c-.09.11-.21.17-.33.2l-1.87.36l1.29 2.84c.16.29.02.65-.28.79l-2.14 1.01c-.09.06-.17.06-.26.06c-.22 0-.43-.12-.53-.34l-1.29-2.83l-1.49 1.21a.593.593 0 0 1-.96-.47V11.6c0-.33.26-.6.59-.6c.15 0 .29.05.41.13l6.77 5.76c.27.23.3.61.09.85M12 15v-5H7v5h5m7-12h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v-2H5V8h14v3.06l2 1.7V5c0-1.1-.9-2-2-2Z"/>'
        },
        "calendar-cursor-outline": {
            body: '<path fill="currentColor" d="M5 9h14v2.1l2 1.7V5c0-1.1-.9-2-2-2h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H5V9m14-4v2H5V5h14M7 16v-5h5v5H7m15.9 1.7c-.1.1-.2.2-.3.2l-1.9.4l1.3 2.8c.2.3 0 .6-.3.8l-2.1 1c-.2.1-.2.1-.3.1c-.2 0-.4-.1-.5-.3l-1.3-2.8L16 21c-.1.1-.2.1-.4.1c-.3 0-.6-.3-.6-.6v-9c0-.3.3-.6.6-.6c.1 0 .3.1.4.1l6.8 5.8c.2.3.3.7.1.9Z"/>'
        },
        "calendar-edit": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5v-2H5V8h14v1h2V5a2 2 0 0 0-2-2m2.7 10.35l-1 1l-2.05-2l1-1c.2-.21.54-.22.77 0l1.28 1.28c.19.2.19.52 0 .72M12 18.94l6.07-6.06l2.05 2L14.06 21H12v-2.06Z"/>'
        },
        "calendar-edit-outline": {
            body: '<path fill="currentColor" d="m21.7 13.35l-1 1l-2.05-2l1-1c.2-.21.54-.22.77 0l1.28 1.28c.19.2.19.52 0 .72M12 18.94V21h2.06l6.06-6.12l-2.05-2L12 18.94M5 19h5v2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v4H5v10M5 5v2h14V5H5Z"/>'
        },
        "calendar-end": {
            body: '<path fill="currentColor" d="M22 14v8h-2v-4l-4 4v-3h-5v-2h5v-3l4 4v-4h2M5 19h4v2H5c-1.1 0-2-.9-2-2V5a2 2 0 0 1 2-2h1V.998h2V3h8V.998h2V3h1c1.11 0 2 .89 2 2v7h-2V8H5v11Z"/>'
        },
        "calendar-end-outline": {
            body: '<path fill="currentColor" d="M5 9h14v3h2V5c0-1.1-.9-2-2-2h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4v-2H5V9m14-4v2H5V5h14m-3 12h-5v2h5v3l4-4l-4-4v3m4-3v8h2v-8h-2Z"/>'
        },
        "calendar-expand-horizontal": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1m0 13l-3-3v2H9v-2l-3 3l3 3v-2h6v2l3-3Z"/>'
        },
        "calendar-expand-horizontal-outline": {
            body: '<path fill="currentColor" d="M15 13H9v-2l-3 3l3 3v-2h6v2l3-3l-3-3v2m4-10h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5h14M5 19V9h14v10H5Z"/>'
        },
        "calendar-export": {
            body: '<path fill="currentColor" d="m12 22l4-4h-3v-6h-2v6H8l4 4m7-19h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h3l-2-2H5V8h14v11h-1l-2 2h3c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "calendar-export-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3l-2-2H5V9h14v10h-1l-2 2h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M5 7V5h14v2H5m8 11v-6h-2v6H8l4 4l4-4h-3Z"/>'
        },
        "calendar-filter": {
            body: '<path fill="currentColor" d="M6 1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6h-2V8H5v11h10v2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1m11 20l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3"/>'
        },
        "calendar-filter-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H4.75c-.44.07-.85.27-1.17.58c-.31.32-.51.73-.58 1.17v14.5c.07.44.27.85.58 1.17c.32.31.73.51 1.17.58H15v-2H5V9h14v2h2V5c0-1.11-.89-2-2-2m0 4H5V5h14v2m-2 14l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3"/>'
        },
        "calendar-heart": {
            body: '<path fill="currentColor" d="M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1m-4 16.17l-.58-.53C9.36 14.77 8 13.54 8 12.03c0-1.23.97-2.2 2.2-2.2c.7 0 1.36.32 1.8.83c.44-.51 1.1-.83 1.8-.83c1.23 0 2.2.97 2.2 2.2c0 1.51-1.36 2.74-3.42 4.61l-.58.53Z"/>'
        },
        "calendar-heart-outline": {
            body: '<path fill="currentColor" d="M16 12.2c0 1.51-1.36 2.74-3.42 4.61l-.58.53l-.58-.53C9.36 14.94 8 13.71 8 12.2c0-1.23.97-2.2 2.2-2.2c.7 0 1.36.32 1.8.83c.44-.51 1.1-.83 1.8-.83c1.23 0 2.2.97 2.2 2.2M21 5v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2M5 5v2h14V5H5m14 14V9H5v10h14Z"/>'
        },
        "calendar-import": {
            body: '<path fill="currentColor" d="m12 12l-4 4h3v6h2v-6h3m3-13h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h4v-2H5V8h14v11h-4v2h4c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "calendar-import-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4v-2H5V9h14v10h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M5 7V5h14v2H5m7 5l-4 4h3v6h2v-6h3l-4-4Z"/>'
        },
        "calendar-lock": {
            body: '<path fill="currentColor" d="M12 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1c1.1 0 2 .9 2 2v7c-.6-.4-1.3-.8-2-.9V8H5v11h7v2m10-2.7v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V17c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h3v-1.5Z"/>'
        },
        "calendar-lock-open": {
            body: '<path fill="currentColor" d="M12 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1c1.1 0 2 .9 2 2v6c-.6-.4-1.3-.8-2-.9V8H5v11h7v2m10-2.7c0-.7-.6-1.3-1.2-1.3h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5Z"/>'
        },
        "calendar-lock-open-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V9h14v1.1c.7.2 1.4.5 2 .9V5c0-1.1-.9-2-2-2m0 4H5V5h14v2m3 14.8c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h4.3c.6 0 1.2.6 1.2 1.3v3.5Z"/>'
        },
        "calendar-lock-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V9h14v2c.7.2 1.4.5 2 .9V5c0-1.1-.9-2-2-2m0 4H5V5h14v2m1.8 10v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17Z"/>'
        },
        "calendar-minus": {
            body: '<path fill="currentColor" d="M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1m0 11.5v2H8v-2h8Z"/>'
        },
        "calendar-minus-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 2v2H5V5h14M5 19V9h14v10H5m3-6h8v2H8v-2Z"/>'
        },
        "calendar-month": {
            body: '<path fill="currentColor" d="M9 10v2H7v-2h2m4 0v2h-2v-2h2m4 0v2h-2v-2h2m2-7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V1h2v2h8V1h2v2h1m0 16V8H5v11h14M9 14v2H7v-2h2m4 0v2h-2v-2h2m4 0v2h-2v-2h2Z"/>'
        },
        "calendar-month-outline": {
            body: '<path fill="currentColor" d="M7 11h2v2H7v-2m14-6v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2M5 7h14V5H5v2m14 12V9H5v10h14m-4-6v-2h2v2h-2m-4 0v-2h2v2h-2m-4 2h2v2H7v-2m8 2v-2h2v2h-2m-4 0v-2h2v2h-2Z"/>'
        },
        "calendar-multiple": {
            body: '<path fill="currentColor" d="M21 17V8H7v9h14m0-14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V1h2v2h8V1h2v2h1M3 21h14v2H3a2 2 0 0 1-2-2V9h2v12m16-6h-4v-4h4v4Z"/>'
        },
        "calendar-multiple-check": {
            body: '<path fill="currentColor" d="M21 17V8H7v9h14m0-14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V1h2v2h8V1h2v2h1m-3.47 8.06l-4.44 4.44l-2.68-2.68l1.06-1.06l1.62 1.62L16.47 10l1.06 1.06M3 21h14v2H3a2 2 0 0 1-2-2V9h2v12Z"/>'
        },
        "calendar-multiselect": {
            body: '<path fill="currentColor" d="M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1m-9 9h2v2H7v-2m8 0h2v2h-2v-2m-4 4h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "calendar-multiselect-outline": {
            body: '<path fill="currentColor" d="M7 11h2v2H7v-2m12-8h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5h14M5 19V9h14v10H5m6-4h2v2h-2v-2m4 0h2v2h-2v-2m0-4h2v2h-2v-2Z"/>'
        },
        "calendar-outline": {
            body: '<path fill="currentColor" d="M12 12h5v5h-5v-5m7-9h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5h14M5 19V9h14v10H5Z"/>'
        },
        "calendar-plus": {
            body: '<path fill="currentColor" d="M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1m-5 8.5h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z"/>'
        },
        "calendar-plus-outline": {
            body: '<path fill="currentColor" d="M13 13h3v2h-3v3h-2v-3H8v-2h3v-3h2v3m8-8v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2M5 5v2h14V5H5m14 14V9H5v10h14Z"/>'
        },
        "calendar-question": {
            body: '<path fill="currentColor" d="M6 1v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1h-2v2H8V1H6M5 8h14v11H5V8m7.19 1c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91c-.2.26-.31.68-.31 1.18h2c0-.31.04-.56.13-.74c.09-.18.26-.36.51-.52c.45-.24.82-.53 1.11-.93c.29-.4.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82c-.53-.45-1.26-.68-2.19-.68M11 16v2h2v-2h-2Z"/>'
        },
        "calendar-question-outline": {
            body: '<path fill="currentColor" d="M11.95 10c-.74 0-1.34.18-1.8.5c-.44.39-.65.9-.65 1.6v.02h1.65c.01-.26.09-.47.24-.62a.88.88 0 0 1 .56-.19c.26 0 .48.09.64.25c.15.17.22.4.22.66c0 .28-.06.53-.2.73c-.11.21-.3.38-.52.55c-.43.28-.73.55-.89.79c-.17.21-.26.6-.26 1.04h1.7c0-.27.03-.49.11-.65c.08-.18.22-.32.43-.47c.39-.21.7-.47.95-.82c.24-.36.37-.72.37-1.17c0-.67-.23-1.22-.69-1.61c-.45-.41-1.07-.61-1.86-.61m-1.01 6.22V18h1.7v-1.78h-1.7M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 2v2H5V5h14M5 19V9h14v10H5Z"/>'
        },
        "calendar-range": {
            body: '<path fill="currentColor" d="M9 10H7v2h2v-2m4 0h-2v2h2v-2m4 0h-2v2h2v-2m2-7h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V8h14v11Z"/>'
        },
        "calendar-range-outline": {
            body: '<path fill="currentColor" d="M7 11h2v2H7v-2m14-6v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2M5 7h14V5H5v2m14 12V9H5v10h14m-4-6h2v-2h-2v2m-4 0h2v-2h-2v2Z"/>'
        },
        "calendar-refresh": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h9c-.6-.5-1.1-1.2-1.5-2H5V8h14v2.6c.7.1 1.4.3 2 .7V5c0-1.1-.9-2-2-2m-1 9.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 19 18 19c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4Z"/>'
        },
        "calendar-refresh-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h9c-.6-.5-1.1-1.2-1.5-2H5V9h14v1.6c.7.1 1.4.3 2 .7V5c0-1.1-.9-2-2-2m0 4H5V5h14m-1 7.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 19 18 19c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4Z"/>'
        },
        "calendar-remove": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M9.31 17l2.44-2.44L14.19 17l1.06-1.06l-2.44-2.44l2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06l2.44 2.44l-2.44 2.44L9.31 17Z"/>'
        },
        "calendar-remove-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10M5 7V5h14v2H5m3.23 9.41l1.06 1.06l2.44-2.44l2.44 2.44l1.06-1.06l-2.44-2.44l2.44-2.44l-1.06-1.06l-2.44 2.44l-2.44-2.44l-1.06 1.06l2.44 2.44l-2.44 2.44Z"/>'
        },
        "calendar-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M19 8H5v11h4.5c.31.75.76 1.42 1.31 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v8.03c-.5-.81-1.2-1.49-2-2.03V8Z"/>'
        },
        "calendar-search-outline": {
            body: '<path fill="currentColor" d="M19.3 18.9c.4-.7.7-1.5.7-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.9 0 1.7-.2 2.4-.7l3.1 3.1l1.4-1.4l-3.1-3.1m-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5M5 19V9h14v2c.8.5 1.5 1.2 2 2V5c0-1.1-.9-2-2-2h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5.8c-.6-.6-1-1.2-1.3-2H5M19 5v2H5V5h14Z"/>'
        },
        "calendar-select": {
            body: '<path d="M11 12h6v6h-6v-6zM5 4h1V2h2v2h8V2h2v2h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 5v11h14V9H5zm8 5v2h2v-2h-2z" fill="currentColor"/>',
            hidden: true
        },
        "calendar-star": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2h-1V1m-7.12 11H7.27l2.92 2.11l-1.11 3.45L12 15.43l2.92 2.13l-1.12-3.44L16.72 12h-3.6L12 8.56L10.88 12Z"/>'
        },
        "calendar-star-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V9h14v10m0-12H5V5h14v2m-8 6H7.8l2.6 2l-1 3l2.6-1.8l2.6 1.8l-1-3l2.6-2H13l-1-3l-1 3Z"/>'
        },
        "calendar-start": {
            body: '<path fill="currentColor" d="M2 14h2v3h5v-3l4 4l-4 4v-3H4v3H2v-8m17 5V8H5v4H3V5c0-1.11.89-2 2-2h1V.998h2V3h8V.998h2V3h1a2 2 0 0 1 2 2v14c0 1.1-.9 2-2 2h-6.17l2-2H19Z"/>'
        },
        "calendar-start-outline": {
            body: '<path fill="currentColor" d="m13 18l-4-4v3H4v-3H2v8h2v-3h5v3l4-4m6-15h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v7h2V9h14v10h-4.2l-2 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M5 7V5h14v2H5Z"/>'
        },
        "calendar-sync": {
            body: '<path fill="currentColor" d="M18 11v1.5c3.19 0 5.09 3.55 3.33 6.21l-1.09-1.09C21.06 15.96 19.85 14 18 14v1.5l-2.25-2.25L18 11m0 11v-1.5c-3.19 0-5.09-3.55-3.33-6.21l1.09 1.09C14.94 17.04 16.15 19 18 19v-1.5l2.25 2.25L18 22m1-19h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a5.919 5.919 0 0 1-1.5-2H5V8h14v2.59c.71.11 1.39.35 2 .72V5a2 2 0 0 0-2-2Z"/>'
        },
        "calendar-sync-outline": {
            body: '<path fill="currentColor" d="M18 11v1.5c3.19 0 5.09 3.55 3.33 6.21l-1.09-1.09C21.06 15.96 19.85 14 18 14v1.5l-2.25-2.25L18 11m0 11v-1.5c-3.19 0-5.09-3.55-3.33-6.21l1.09 1.09C14.94 17.04 16.15 19 18 19v-1.5l2.25 2.25L18 22m1-19h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a5.919 5.919 0 0 1-1.5-2H5V9h14v1.59c.71.11 1.39.35 2 .72V5a2 2 0 0 0-2-2m0 4H5V5h14"/>'
        },
        "calendar-text": {
            body: '<path fill="currentColor" d="M14 14H7v2h7m5 3H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-2 7H7v2h10v-2Z"/>'
        },
        "calendar-text-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14v10M5 7V5h14v2H5m2 4h10v2H7v-2m0 4h7v2H7v-2Z"/>'
        },
        "calendar-today": {
            body: '<path fill="currentColor" d="M7 10h5v5H7m12 4H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "calendar-today-outline": {
            body: '<path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m0 16H5V9h14v10m0-12H5V5h14M7 11h5v5H7"/>'
        },
        "calendar-week": {
            body: '<path fill="currentColor" d="M6 1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1M5 8v11h14V8H5m2 2h10v2H7v-2Z"/>'
        },
        "calendar-week-begin": {
            body: '<path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1m-9 9H7v7h2v-7Z"/>'
        },
        "calendar-week-begin-outline": {
            body: '<path fill="currentColor" d="M19 3c1.11 0 2 .89 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V1h2v2h8V1h2v2h1m0 16V9H5v10h14m0-12V5H5v2h14M7 11h2v6H7v-6"/>'
        },
        "calendar-week-end": {
            body: '<path fill="currentColor" d="M5 8h14v11H5M6 1v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2h-1V1h-2v2H8V1m7 16h2v-7h-2v7Z"/>',
            hidden: true
        },
        "calendar-week-end-outline": {
            body: '<path fill="currentColor" d="M5 4h1V2h2v2h8V2h2v2h1c1.11 0 2 .89 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 16h14V10H5v10M5 8h14V6H5v2m12 4v6h-2v-6h2"/>',
            hidden: true
        },
        "calendar-week-outline": {
            body: '<path fill="currentColor" d="M5 3h1V1h2v2h8V1h2v2h1c1.11 0 2 .89 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 16h14V9H5v10M5 7h14V5H5v2m12 4v2H7v-2h10"/>'
        },
        "calendar-weekend": {
            body: '<path fill="currentColor" d="M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1M7 17v-7h2v7H7m8-7h2v7h-2v-7Z"/>'
        },
        "calendar-weekend-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1V1h2v2h8V1h2v2h1m0 16V9H5v10h14m0-12V5H5v2h14M7 11h2v6H7v-6m8 0h2v6h-2v-6Z"/>'
        },
        "call-made": {
            body: '<path fill="currentColor" d="M9 5v2h6.59L4 18.59L5.41 20L17 8.41V15h2V5"/>'
        },
        "call-merge": {
            body: '<path fill="currentColor" d="M17 20.41L18.41 19L15 15.59L13.59 17M7.5 8H11v5.59L5.59 19L7 20.41l6-6V8h3.5L12 3.5"/>'
        },
        "call-missed": {
            body: '<path fill="currentColor" d="M19.59 7L12 14.59L6.41 9H11V7H3v8h2v-4.59l7 7l9-9"/>'
        },
        "call-received": {
            body: '<path fill="currentColor" d="M20 5.41L18.59 4L7 15.59V9H5v10h10v-2H8.41"/>'
        },
        "call-split": {
            body: '<path fill="currentColor" d="m14 4l2.29 2.29l-2.88 2.88l1.42 1.42l2.88-2.88L20 10V4M10 4H4v6l2.29-2.29l4.71 4.7V20h2v-8.41l-5.29-5.3"/>'
        },
        camcorder: {
            body: '<path fill="currentColor" d="M7 2C4.24 2 2 4.24 2 7v13c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V7c0-2.76-2.24-5-5-5M5 20c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m2-10c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3m15-1v5c0 1.1-.9 2-2 2h-7v-2h7V9h-7V7h7c1.1 0 2 .9 2 2Z"/>'
        },
        "camcorder-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L9.4 8.8l-7-7L1.1 3l1.6 1.6C2.2 5.3 2 6.1 2 7v13c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-6.1l1 1V16h1.1l6.7 6.7l1.3-1.2M5 20c-.5 0-1-.5-1-1s.5-1 1-1s1 .5 1 1s-.5 1-1 1m2-10c-1.7 0-3-1.3-3-3c0-.3.1-.6.2-.9L8 9.9c-.4 0-.7.1-1 .1m.2-6L5.5 2.3C6 2.1 6.5 2 7 2c2.8 0 5 2.2 5 5v1.8l-2-2C9.9 5.3 8.7 4.1 7.2 4M20 9h-7V7h7c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2h-.8l-2-2H20V9Z"/>'
        },
        camera: {
            body: '<path fill="currentColor" d="M4 4h3l2-2h6l2 2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m8 3a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "camera-account": {
            body: '<path fill="currentColor" d="M4 5h3l2-2h6l2 2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m12 12v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "camera-burst": {
            body: '<path fill="currentColor" d="M1 5h2v14H1V5m4 0h2v14H5V5m17 0H10a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11Z"/>'
        },
        "camera-control": {
            body: '<path fill="currentColor" d="M9 12c0-.81.3-1.5.89-2.11C10.5 9.3 11.19 9 12 9c.81 0 1.5.3 2.11.89c.59.61.89 1.3.89 2.11c0 .81-.3 1.5-.89 2.11c-.61.59-1.3.89-2.11.89c-.81 0-1.5-.3-2.11-.89C9.3 13.5 9 12.81 9 12M5.53 8.44l1.78 1.78L5.53 12l1.78 1.78l-1.78 1.78L2 12l3.53-3.56m2.91 10.03l1.78-1.78L12 18.47l1.78-1.78l1.78 1.78L12 22l-3.56-3.53m10.03-2.91l-1.78-1.78L18.47 12l-1.78-1.78l1.78-1.78L22 12l-3.53 3.56M15.56 5.53l-1.78 1.78L12 5.53l-1.78 1.78l-1.78-1.78L12 2l3.56 3.53Z"/>'
        },
        "camera-document": {
            body: '<path fill="currentColor" d="M21 7v15H3v-2h16V7h-4.28c-.34.6-.98 1-1.72 1a2 2 0 0 1-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2c.74 0 1.38.41 1.72 1H19c1.11 0 2 .89 2 2M6 15h7l-2-4H8l-2 4Z"/>'
        },
        "camera-document-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-.73-.73H3v-2h15.11l-5.22-5.22l.11.22H6l2-4h1.11l-1-1H8c-1.1 0-2-.9-2-2v-.11L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M13 8c.74 0 1.38-.4 1.72-1H19v8.8l2 2V7c0-1.11-.89-2-2-2h-4.28c-.34-.59-.98-1-1.72-1c0-1.1-.9-2-2-2H8c-.76 0-1.41.43-1.75 1.05L12.5 9.3c.31-.35.5-.8.5-1.3Z"/>'
        },
        "camera-enhance": {
            body: '<path fill="currentColor" d="M9 3L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.17L15 3m-3 15a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25"/>'
        },
        "camera-enhance-outline": {
            body: '<path fill="currentColor" d="m12 10l-.94 2.06L9 13l2.06.94L12 16l.94-2.06L15 13l-2.06-.94L12 10m8-5h-3.17L15 3H9L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35l.59.65H20v12M12 8a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 8a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3Z"/>'
        },
        "camera-flip": {
            body: '<path fill="currentColor" d="M20 5h-3l-2-2H9L7 5H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V7a2 2 0 0 0-2-2M5 12h2.1A4.997 4.997 0 0 1 13 8.1c.76.15 1.43.49 2 .9l-1.44 1.45c-.45-.28-.98-.45-1.56-.45c-1.26 0-2.4.8-2.82 2H11l-3 3l-3-3m11.91 2c-.55 2.71-3.19 4.45-5.91 3.9a5.44 5.44 0 0 1-2-.9l1.44-1.45c.46.28.99.45 1.56.45c1.27 0 2.41-.8 2.83-2H13l3-3l3 3h-2.09Z"/>'
        },
        "camera-flip-outline": {
            body: '<path fill="currentColor" d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V7a2 2 0 0 0-2-2m0 14H4V7h4.05l1.83-2h4.24L16 7h4v12M5 12h2.1A4.997 4.997 0 0 1 13 8.1c.76.15 1.43.49 2 .9l-1.44 1.45c-.45-.28-.98-.45-1.56-.45c-1.26 0-2.4.8-2.82 2H11l-3 3l-3-3m11.91 2c-.55 2.71-3.19 4.45-5.91 3.9a5.44 5.44 0 0 1-2-.9l1.44-1.45c.46.28.99.45 1.56.45c1.27 0 2.41-.8 2.83-2H13l3-3l3 3h-2.09Z"/>'
        },
        "camera-focus": {
            body: '<path d="M0 2a2 2 0 0 1 2-2h4v2H2v4H0V2zm24 20a2 2 0 0 1-2 2h-4v-2h4v-4h2v4zM2 24a2 2 0 0 1-2-2v-4h2v4h4v2H2zM22 0a2 2 0 0 1 2 2v4h-2V2h-4V0h4zm-5 9h6v6h-6V9zm1.5 1.5v3h3v-3h-3zM9 1h6v6H9V1zm1.5 1.5v3h3v-3h-3zM9 9h6v6H9V9zm1.5 1.5v3h3v-3h-3zM1 9h6v6H1V9zm1.5 1.5v3h3v-3h-3zM9 17h6v6H9v-6zm1.5 1.5v3h3v-3h-3z" fill="currentColor"/>',
            hidden: true
        },
        "camera-front": {
            body: '<path fill="currentColor" d="M7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5M17 0H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-5 8a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m2 12v2h5v-2m-9 0H5v2h5v2l3-3l-3-3v2Z"/>'
        },
        "camera-front-variant": {
            body: '<path fill="currentColor" d="M6 0h12a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 6a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m-1-5v2h2V1h-2M6 4v12.5c0-1.38 2.69-2.5 6-2.5s6 1.12 6 2.5V4H6m7 14H9v2h4v2l3-3l-3-3v2Z"/>'
        },
        "camera-gopro": {
            body: '<path fill="currentColor" d="M20 5h-5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-2.5 7.5a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m0-1.5A1.5 1.5 0 0 1 16 9.5A1.5 1.5 0 0 1 17.5 8A1.5 1.5 0 0 1 19 9.5a1.5 1.5 0 0 1-1.5 1.5M12 15V5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2H12m-2-3H4V7h6v5Z"/>'
        },
        "camera-image": {
            body: '<path fill="currentColor" d="M4 5h3l2-2h6l2 2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m9.09 4.45l-2.04 2.73l1.55 2.07l-.87.66l-2.46-3.27L6 16h12l-4.91-6.55Z"/>'
        },
        "camera-iris": {
            body: '<path fill="currentColor" d="m13.73 15l-3.9 6.76a9.984 9.984 0 0 0 8.49-2.01l-3.66-6.35M2.46 15c.92 2.92 3.15 5.26 5.99 6.34L12.12 15m-3.58-3l-3.9-6.75A9.855 9.855 0 0 0 2 12c0 .68.07 1.35.2 2h7.49m12.11-4h-7.49l.29.5l4.76 8.25A9.93 9.93 0 0 0 22 12c0-.69-.07-1.36-.2-2m-.26-1c-.92-2.93-3.15-5.26-5.99-6.34L11.88 9M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.84-6.32 2.25l3.66 6.35l.06-.1Z"/>'
        },
        "camera-lock": {
            body: '<path fill="currentColor" d="M4 4h3l2-2h6l2 2h3c1.11 0 2 .89 2 2v6c-.84-.63-1.87-1-3-1c-.79 0-1.54.18-2.21.5C16.18 9.22 14.27 7 12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c.42 0 .84-.05 1.23-.15c-.15.35-.23.74-.23 1.15v2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m8 5c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m11 9.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V17c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h3v-1.5Z"/>'
        },
        "camera-lock-outline": {
            body: '<path fill="currentColor" d="M23 18.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V17c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h3v-1.5M20 4c1.1 0 2 .9 2 2v6c-.58-.44-1.26-.75-2-.9V6h-4.05l-1.83-2H9.88L8.05 6H4v12h9v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3.17L9 2h6l1.83 2H20m-8 3a5.01 5.01 0 0 1 4.97 4.43c-1.68.75-2.87 2.4-2.97 4.33c-.33.3-.6.67-.77 1.09c-.39.1-.81.15-1.23.15c-2.76 0-5-2.24-5-5s2.24-5 5-5m0 8c1.65 0 3-1.35 3-3s-1.35-3-3-3s-3 1.35-3 3s1.35 3 3 3Z"/>'
        },
        "camera-marker": {
            body: '<path fill="currentColor" d="M18.5 16.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2m0-4.8c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5M9 2L7 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10.5c-.6-.9-1.1-1.9-1.4-3.1c-.3.1-.7.1-1.1.1c-2.8 0-5-2.2-5-5s2.2-5 5-5c2.1 0 4 1.3 4.7 3.3c.6-.2 1.2-.3 1.8-.3c1.3 0 2.5.5 3.5 1.3V6c0-1.1-.9-2-2-2h-3l-2-2H9m2.9 7C10.3 9 9 10.4 9 12c0 1.7 1.3 3 3 3c.4 0 .7-.1 1-.2c.2-1.4.9-2.6 1.9-3.5c-.3-1.3-1.5-2.3-3-2.3c.1 0 .1 0 0 0Z"/>'
        },
        "camera-marker-outline": {
            body: '<path fill="currentColor" d="M18.5 16.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2m0-4.8c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5M9 2L7.2 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10.5c-.4-.6-.8-1.3-1-2H4V6h4.1l1.8-2h4.2l1.8 2H20v4.2c.7.2 1.4.6 2 1.1V6c0-1.1-.9-2-2-2h-3.2L15 2H9m3 5c-2.8 0-5 2.2-5 5s2.2 5 5 5c.4 0 .8 0 1.2-.1c-.1-.5-.2-.9-.2-1.4v-.7c-.3.1-.7.2-1 .2c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.4 0 2.6 1 2.9 2.3c.5-.4 1.1-.8 1.8-1C16 8.3 14.1 7 12 7Z"/>'
        },
        "camera-metering-center": {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h16V6H4m8 4.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m0-3c2.14 0 3.93 1.5 4.39 3.5h-1.56A2.99 2.99 0 0 0 12 9c-1.31 0-2.42.83-2.83 2H7.61C8.07 9 9.86 7.5 12 7.5m0 9c-2.14 0-3.93-1.5-4.39-3.5h1.56c.41 1.17 1.52 2 2.83 2s2.42-.83 2.83-2h1.56c-.46 2-2.25 3.5-4.39 3.5Z"/>'
        },
        "camera-metering-matrix": {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h16V6H4m1.5 1.5H11v1.67c-.85.3-1.53.98-1.83 1.83H5.5V7.5m13 0V11h-3.67c-.3-.85-.98-1.53-1.83-1.83V7.5h5.5m0 9H13v-1.67c.85-.3 1.53-.98 1.83-1.83h3.67v3.5m-13 0V13h3.67c.3.85.98 1.53 1.83 1.83v1.67H5.5m6.5-6a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "camera-metering-partial": {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h16V6H4m8 1.5c2.14 0 3.93 1.5 4.39 3.5h-1.56A2.99 2.99 0 0 0 12 9c-1.31 0-2.42.83-2.83 2H7.61C8.07 9 9.86 7.5 12 7.5m0 9c-2.14 0-3.93-1.5-4.39-3.5h1.56c.41 1.17 1.52 2 2.83 2s2.42-.83 2.83-2h1.56c-.46 2-2.25 3.5-4.39 3.5Z"/>'
        },
        "camera-metering-spot": {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h16V6H4m8 4.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "camera-off": {
            body: '<path fill="currentColor" d="M1.2 4.47L2.5 3.2L20 20.72L18.73 22l-2-2H4a2 2 0 0 1-2-2V6c0-.22.04-.43.1-.63l-.9-.9M7 4l2-2h6l2 2h3a2 2 0 0 1 2 2v12c0 .6-.26 1.13-.68 1.5l-4.99-5c.43-.73.67-1.59.67-2.5a5 5 0 0 0-5-5c-.91 0-1.77.24-2.5.67L5.82 4H7m0 8a5 5 0 0 0 5 5c.5 0 1.03-.08 1.5-.23L11.72 15A3.064 3.064 0 0 1 9 12.28L7.23 10.5c-.15.47-.23 1-.23 1.5m5-3a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9Z"/>'
        },
        "camera-off-outline": {
            body: '<path fill="currentColor" d="M17 12c0 .54-.1 1.05-.26 1.54L15 11.78A3.057 3.057 0 0 0 12.22 9l-1.76-1.74c.49-.16 1-.26 1.54-.26c2.76 0 5 2.24 5 5M9.88 4h4.24l1.83 2H20v10.8l1.88 1.88c.08-.21.12-.44.12-.68V6c0-1.11-.89-2-2-2h-3.17L15 2H9L7.18 4L8.6 5.4L9.88 4m12.23 17.46l-1.27 1.27L18.11 20H4a2 2 0 0 1-2-2V6c0-.58.25-1.1.65-1.46L1.11 3l1.28-1.27l19.72 19.73M9 12c0 1.66 1.34 3 3 3c.33 0 .65-.07.94-.17l-3.77-3.77c-.1.3-.17.61-.17.94m7.11 6l-1.66-1.66c-.73.41-1.56.66-2.45.66c-2.76 0-5-2.24-5-5c0-.89.25-1.72.66-2.45L4.11 6H4v12h12.11Z"/>'
        },
        "camera-outline": {
            body: '<path fill="currentColor" d="M20 4h-3.17L15 2H9L7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12M12 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 8a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3Z"/>'
        },
        "camera-party-mode": {
            body: '<path fill="currentColor" d="M12 17c-1.63 0-3.06-.79-4-2h4a3 3 0 0 0 3-3c0-.35-.07-.69-.18-1h2.08c.06.32.1.66.1 1a5 5 0 0 1-5 5m0-10c1.63 0 3.06.79 4 2h-4a3 3 0 0 0-3 3c0 .35.07.68.18 1H7.1c-.07-.32-.1-.66-.1-1a5 5 0 0 1 5-5m8-3h-3.17L15 2H9L7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "camera-plus": {
            body: '<path fill="currentColor" d="M3 4V1h2v3h3v2H5v3H3V6H0V4m6 6V7h3V4h7l1.8 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10m10 9c4.45 0 6.69-5.38 3.54-8.54C13.39 7.31 8 9.55 8 14c0 2.76 2.24 5 5 5m-3.2-5c0 2.85 3.45 4.28 5.46 2.26c2.02-2.01.59-5.46-2.26-5.46A3.21 3.21 0 0 0 9.8 14Z"/>'
        },
        "camera-plus-outline": {
            body: '<path fill="currentColor" d="M21 6h-3.2L16 4h-6v2h5.1L17 8h4v12H5v-9H3v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2M8 14c0 4.45 5.39 6.69 8.54 3.54C19.69 14.39 17.45 9 13 9c-2.76 0-5 2.24-5 5m5-3a3.09 3.09 0 0 1 3 3a3.09 3.09 0 0 1-3 3a3.09 3.09 0 0 1-3-3a3.09 3.09 0 0 1 3-3M5 6h3V4H5V1H3v3H0v2h3v3h2"/>'
        },
        "camera-rear": {
            body: '<path fill="currentColor" d="M12 6a2 2 0 0 1-2-2a2 2 0 0 1 2-2c1.09 0 2 .9 2 2a2 2 0 0 1-2 2m5-6H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-3 20v2h5v-2m-9 0H5v2h5v2l3-3l-3-3v2Z"/>'
        },
        "camera-rear-variant": {
            body: '<path fill="currentColor" d="M6 0h12a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m1 16H9v2h4v2l3-3l-3-3v2Z"/>'
        },
        "camera-retake": {
            body: '<path fill="currentColor" d="M20 5h-3l-2-2H9L7 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-8 13c-1.08 0-2.14-.35-3-1l1.44-1.44c.47.29 1.01.44 1.56.44a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-1.26 0-2.4.8-2.82 2H11l-3 3l-3-3h2.1A4.997 4.997 0 0 1 13 8.1a5 5 0 0 1-1 9.9Z"/>'
        },
        "camera-retake-outline": {
            body: '<path fill="currentColor" d="M20 5h-3.17L15 3H9L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 14H4V7h4.05l1.83-2h4.24L16 7h4v12m-8-1c-1.08 0-2.14-.35-3-1l1.44-1.44c.47.29 1.01.44 1.56.44a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-1.26 0-2.4.8-2.82 2H11l-3 3l-3-3h2.1A4.997 4.997 0 0 1 13 8.1a5 5 0 0 1-1 9.9Z"/>'
        },
        "camera-switch": {
            body: '<path fill="currentColor" d="M15 15.5V13H9v2.5L5.5 12L9 8.5V11h6V8.5l3.5 3.5M20 4h-3.17L15 2H9L7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "camera-switch-outline": {
            body: '<path fill="currentColor" d="M20 4h-3.2L15 2H9L7.2 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M9.9 4h4.2l1.8 2H20v12H4V6h4.1m6.9 5H9V8.5L5.5 12L9 15.5V13h6v2.5l3.5-3.5L15 8.5V11Z"/>'
        },
        "camera-timer": {
            body: '<path fill="currentColor" d="M4.94 6.35c-.39-.39-.39-1.03 0-1.42a.996.996 0 0 1 1.41 0l6.72 5.38l.35.28c.78.78.78 2.05 0 2.83c-.78.78-2.05.78-2.83 0l-.28-.35l-5.37-6.72M12 20a8 8 0 0 0 8-8c0-2.21-.9-4.21-2.34-5.66l1.41-1.41A9.969 9.969 0 0 1 22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12h2a8 8 0 0 0 8 8m0-19a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "camera-wireless": {
            body: '<path fill="currentColor" d="M12 10.8a3.2 3.2 0 0 1 3.2 3.2a3.2 3.2 0 0 1-3.2 3.2A3.2 3.2 0 0 1 8.8 14a3.2 3.2 0 0 1 3.2-3.2m4-7.47V2a6 6 0 0 1 6 6h-1.33c0-2.58-2.09-4.67-4.67-4.67M16 6V4.67c1.84 0 3.33 1.49 3.33 3.33H18c0-1.11-.89-2-2-2m1 3h5v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.17L9 4h6v3c1.11 0 2 .89 2 2m-5 10a5 5 0 0 0 5-5a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5Z"/>'
        },
        "camera-wireless-outline": {
            body: '<path fill="currentColor" d="M20 9v11H4V8h4.05l1.83-2H15V4H9L7.17 6H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9h-2m.67-1H22c0-3.32-2.69-6-6-6v1.33c2.58 0 4.66 2.08 4.67 4.67M18 8h1.33A3.329 3.329 0 0 0 16 4.67V6c1.11 0 2 .89 2 2M7 14a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5a5 5 0 0 0-5 5m8 0a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3Z"/>'
        },
        campfire: {
            body: '<path fill="currentColor" d="m15.9 18.5l6 1.6l-.4 1.9l-9.4-2.5L2.7 22l-.5-1.9l6-1.6l-6.1-1.6l.5-1.9l9.4 2.5l9.4-2.5l.5 1.9l-6 1.6m.17-10.58c-.16-.22-.36-.42-.57-.59c-.45-.43-1-.74-1.44-1.2C13 5.08 12.79 3.34 13.44 2c-.65.17-1.26.54-1.77.95C9.84 4.46 9.11 7.1 10 9.38c0 .07.04.15.04.24c0 .16-.11.3-.25.38a.512.512 0 0 1-.57-.23c-.8-1.03-.93-2.51-.38-3.7c-1.19.99-1.84 2.65-1.73 4.22c.02.36.07.71.19 1.07c.11.44.29.87.52 1.25c.75 1.25 2.08 2.15 3.5 2.33c1.52.2 3.14-.09 4.31-1.15c1.3-1.2 1.77-3.12 1.08-4.79l-.1-.17c-.14-.33-.33-.63-.57-.9l.03-.01m-2.24 4.55c-.2.18-.52.36-.78.44c-.79.28-1.59-.12-2.05-.6c.84-.2 1.34-.84 1.5-1.48c.11-.58-.11-1.05-.21-1.61c-.08-.53-.07-.99.13-1.49c.13.27.27.55.44.77c.55.72 1.41 1.04 1.59 2c.02.13.05.22.05.33c0 .6-.24 1.24-.68 1.64"/>'
        },
        cancel: {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-1.9 0-3.6.6-4.9 1.7l11.2 11.2c1-1.4 1.7-3.1 1.7-4.9c0-4.4-3.6-8-8-8m4.9 14.3L5.7 7.1C4.6 8.4 4 10.1 4 12c0 4.4 3.6 8 8 8c1.9 0 3.6-.6 4.9-1.7Z"/>'
        },
        candelabra: {
            body: '<path fill="currentColor" d="M20.5 11c0 .55-.45 1-1 1H19v2c0 1.11-.89 2-2 2h-4v4h1a2 2 0 0 1 2 2H8c0-1.1.9-2 2-2h1v-4H7a2 2 0 0 1-2-2v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1H5V4l2 1v5h.5c.55 0 1 .45 1 1s-.45 1-1 1H7v2h4v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1h.5V2l2 1v7h.5c.55 0 1 .45 1 1s-.45 1-1 1H13v2h4v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1h.5V4l2 1v5h.5c.55 0 1 .45 1 1Z"/>'
        },
        "candelabra-fire": {
            body: '<path fill="currentColor" d="M18 7c.83 0 1.5-.67 1.5-1.5S18.83 3 18 3s-1.5 1.67-1.5 2.5c0 .83.67 1.5 1.5 1.5m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M12 6c.83 0 1.5-.67 1.5-1.5S12.83 2 12 2s-1.5 1.67-1.5 2.5c0 .83.67 1.5 1.5 1.5m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M6 7c.83 0 1.5-.67 1.5-1.5S6.83 3 6 3S4.5 4.67 4.5 5.5C4.5 6.33 5.17 7 6 7m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M20.5 11c0 .55-.45 1-1 1H19v2c0 1.11-.89 2-2 2h-4v4h1a2 2 0 0 1 2 2H8c0-1.1.9-2 2-2h1v-4H7a2 2 0 0 1-2-2v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1V9c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c.55 0 1 .45 1 1s-.45 1-1 1H7v2h4v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1V8c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v2c.55 0 1 .45 1 1s-.45 1-1 1H13v2h4v-2h-.5c-.55 0-1-.45-1-1s.45-1 1-1V9c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c.55 0 1 .45 1 1Z"/>'
        },
        candle: {
            body: '<path fill="currentColor" d="M12.5 2c-1.66 0-3 3.34-3 5a3 3 0 0 0 3 3a3 3 0 0 0 3-3c0-1.66-1.34-5-3-5m0 4.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M10 11a1 1 0 0 0-1 1v8H7a1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1v1a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-3v-8a1 1 0 0 0-1-1h-5Z"/>'
        },
        candy: {
            body: '<path fill="currentColor" d="M15.54 8.46c1.96 1.96 1.96 5.12 0 7.08s-5.12 1.96-7.07 0s-1.97-5.12 0-7.08s5.11-1.96 7.07 0m3.93-3.91s-.97.12-2.04.81a5.243 5.243 0 0 0-1.5-2.94a4.027 4.027 0 0 0-1.1 3.92c1.39.36 2.47 1.44 2.83 2.83c1.12.3 2.68.15 3.92-1.1a5.247 5.247 0 0 0-2.9-1.49c.39-.58.7-1.25.79-2.03M4.53 19.45s.97-.12 2.04-.81c.15 1.04.65 2.09 1.5 2.94c1.25-1.24 1.4-2.8 1.1-3.92a3.939 3.939 0 0 1-2.83-2.83c-1.12-.3-2.68-.15-3.92 1.1c.84.84 1.87 1.34 2.9 1.49c-.39.58-.7 1.26-.79 2.03Z"/>'
        },
        "candy-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-6.4-6.4c-1.9 1.1-4.4.8-6-.8c-1.6-1.6-1.9-4.1-.8-6L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M15.5 8.5c-1.4-1.4-3.3-1.8-5.1-1.2l6.3 6.3c.6-1.8.2-3.8-1.2-5.1m2.2.7c1.1.3 2.7.1 3.9-1.1c-.8-.8-1.9-1.3-2.9-1.5c.4-.6.7-1.3.8-2c0 0-1 .1-2 .8c-.1-1-.6-2.1-1.5-2.9c-1.2 1.2-1.4 2.8-1.1 3.9c1.3.3 2.4 1.4 2.8 2.8M6.3 14.8c-1.1-.3-2.7-.1-3.9 1.1c.8.8 1.9 1.3 2.9 1.5c-.4.6-.7 1.3-.8 2c0 0 1-.1 2-.8c.1 1 .6 2.1 1.5 2.9c1.2-1.2 1.4-2.8 1.1-3.9c-1.3-.3-2.4-1.4-2.8-2.8Z"/>'
        },
        "candy-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l6.6 6.6c-1.1 1.9-.8 4.4.8 6s4.1 1.9 6 .8l6.4 6.4l1.2-1.3M9.9 14.1c-.8-.8-1.1-2-.7-3.1l3.8 3.8c-1.1.4-2.3.2-3.1-.7m4.9-7.8c-.3-1.1-.2-2.7 1.1-3.9c.9.9 1.4 1.9 1.5 2.9c1.1-.7 2-.8 2-.8c-.1.8-.4 1.5-.8 2c1 .2 2.1.7 2.9 1.5c-1.2 1.2-2.8 1.4-3.9 1.1c-.3-1.3-1.4-2.4-2.8-2.8M12.2 9l-1.8-1.8c1.7-.6 3.7-.2 5.1 1.2c1.4 1.4 1.8 3.3 1.2 5.1L15 11.8c-.1-.7-.3-1.4-.9-1.9s-1.2-.8-1.9-.9m-3 8.7c.3 1.1.2 2.7-1.1 3.9c-.9-.9-1.4-1.9-1.5-2.9c-1.1.7-2 .8-2 .8c.1-.8.4-1.5.8-2c-1-.2-2.1-.7-2.9-1.5c1.2-1.2 2.8-1.4 3.9-1.1c.3 1.3 1.4 2.4 2.8 2.8Z"/>'
        },
        "candy-outline": {
            body: '<path fill="currentColor" d="M9.88 9.88c1.17-1.17 3.07-1.17 4.24 0s1.17 3.07 0 4.24a3 3 0 0 1-4.24 0a3 3 0 0 1 0-4.24M8.46 8.46c-1.96 1.96-1.96 5.12 0 7.08s5.12 1.96 7.08 0s1.96-5.12 0-7.08s-5.12-1.96-7.08 0m11.01-3.91s-.97.12-2.04.82c-.15-1.05-.65-2.1-1.5-2.95c-1.25 1.25-1.4 2.8-1.1 3.92c1.39.36 2.47 1.44 2.83 2.83c1.12.3 2.68.15 3.92-1.1a5.247 5.247 0 0 0-2.9-1.49c.39-.58.7-1.25.79-2.03M4.53 19.45s.97-.12 2.04-.81c.15 1.04.65 2.09 1.5 2.94c1.25-1.24 1.4-2.8 1.1-3.92a3.955 3.955 0 0 1-2.83-2.83c-1.12-.3-2.67-.15-3.92 1.1c.84.84 1.87 1.34 2.9 1.49c-.39.58-.7 1.26-.79 2.03Z"/>'
        },
        candycane: {
            body: '<path fill="currentColor" d="M10 10a2 2 0 0 1-2 2a2 2 0 0 1-2-2V8c0-.63.1-1.23.27-1.8L10 9.93V10m2-8c.74 0 1.44.13 2.09.38L11.97 6c-.83 0-1.53.5-1.82 1.25L7.24 4.34A6.008 6.008 0 0 1 12 2m5.76 4.31L14 10.07V8c0-.38-.1-.73-.28-1.03l2.11-3.59a5.98 5.98 0 0 1 1.93 2.93m.24 6.78l-4 4V12.9l4-4v4.19M18 20a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-.09l4-4V20Z"/>'
        },
        cannabis: {
            body: '<path fill="currentColor" d="M11.5 22v-4.65c-.5.78-1.5 1.74-3.47 2.46c0 0 .5-1.71 1.91-2.86c-1.3.28-3.26.24-5.94-.95c0 0 2.47-1.41 5.28-1.03C7.69 14 5.7 12.08 4.17 8.11c0 0 4.5 1.23 6.74 5.03C8.88 8.24 12 2 12 2c2.43 5.47 1.91 9.1 1.12 11.1c2.25-3.77 6.71-4.99 6.71-4.99c-1.53 3.97-3.52 5.89-5.11 6.86C17.53 14.59 20 16 20 16c-2.68 1.19-4.64 1.23-5.94.95c1.41 1.15 1.91 2.86 1.91 2.86c-1.97-.72-2.97-1.68-3.47-2.46V22h-1Z"/>'
        },
        "cannabis-off": {
            body: '<path fill="currentColor" d="m16.62 13.42l-2.12-2.1c2.34-2.38 5.33-3.21 5.33-3.21c-.96 2.49-2.1 4.16-3.21 5.31M12 2s-1.14 2.3-1.59 5.21l3.31 3.29c.2-2.05-.11-4.87-1.72-8.5m8.84 20.73l1.27-1.27L2.39 1.73L1.11 3l7.51 7.5C6.5 8.75 4.17 8.11 4.17 8.11C5.7 12.08 7.69 14 9.28 14.97C6.47 14.59 4 16 4 16c2.68 1.19 4.64 1.23 5.94.95c-1.41 1.15-1.91 2.86-1.91 2.86c1.97-.72 2.97-1.68 3.47-2.46V22h1v-4.65c.5.78 1.5 1.74 3.47 2.46c0 0-.5-1.71-1.91-2.86c.33.05.71.12 1.14.14l5.64 5.64Z"/>'
        },
        "caps-lock": {
            body: '<path fill="currentColor" d="M9.96 13.71L12 8.29l2.03 5.43M11.14 6L6.43 18h1.93l.96-2.57h5.36l.96 2.57h1.93L12.86 6h-1.72M20 2H4c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 18H4V4h16v16Z"/>'
        },
        car: {
            body: '<path fill="currentColor" d="m5 11l1.5-4.5h11L19 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6Z"/>'
        },
        "car-2-plus": {
            body: '<path fill="currentColor" d="M8 16c0-2.4 1.1-4.5 2.7-6H3l1.5-4.5h11l.8 2.5c.6 0 1.2.1 1.7.3L16.9 5c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L1 11v8c0 .5.5 1 1 1h1c.5 0 1-.5 1-1v-1h4.3c-.2-.6-.3-1.3-.3-2m-3.5-1c-.8 0-1.5-.7-1.5-1.5S3.7 12 4.5 12s1.5.7 1.5 1.5S5.3 15 4.5 15M16 20v-2h-3v-1h1c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2h-3v2h3v1h-1c-1.1 0-2 .9-2 2v3m12-3h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2Z"/>'
        },
        "car-3-plus": {
            body: '<path fill="currentColor" d="M16.9 5c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L1 11v8c0 .5.5 1 1 1h1c.5 0 1-.5 1-1v-1h4.3c-.2-.6-.3-1.3-.3-2c0-2.4 1.1-4.5 2.7-6H3l1.5-4.5h11l.8 2.5c.6 0 1.2.1 1.7.3L16.9 5M4.5 12c.8 0 1.5.7 1.5 1.5S5.3 15 4.5 15S3 14.3 3 13.5S3.7 12 4.5 12M23 17h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2m-8.5-1c.8 0 1.5-1.2 1.5-2c0-1.1-.9-2-2-2h-3v2h3v1h-2v2h2v1h-3v2h3c1.1 0 2-.9 2-2c0-.8-.7-2-1.5-2Z"/>'
        },
        "car-arrow-left": {
            body: '<path fill="currentColor" d="M12 18c0-3.31 2.69-6 6-6c1.09 0 2.12.3 3 .81V12l-2.08-6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h6.09c-.05-.33-.09-.66-.09-1M6.5 6.5h11L19 11H5l1.5-4.5m0 9.5c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16M18 15v2h4v2h-4v2l-3-3l3-3"/>'
        },
        "car-arrow-right": {
            body: '<path fill="currentColor" d="M12 18c0-3.31 2.69-6 6-6c1.09 0 2.12.3 3 .81V12l-2.08-6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h6.09c-.05-.33-.09-.66-.09-1M6.5 6.5h11L19 11H5l1.5-4.5m0 9.5c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16M19 21v-2h-4v-2h4v-2l3 3l-3 3"/>'
        },
        "car-back": {
            body: '<path fill="currentColor" d="m6 11l1-4h10l1 4m.92-5c-.21-.6-.78-1-1.42-1h-11c-.64 0-1.21.4-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6M7 16H5v-2h2v2m12 0h-2v-2h2v2m-5 0h-4v-2h4v2Z"/>'
        },
        "car-battery": {
            body: '<path fill="currentColor" d="M4 3v3H1v14h22V6h-3V3h-6v3h-4V3H4M3 8h18v10H3V8m12 2v2h-2v2h2v2h2v-2h2v-2h-2v-2h-2M5 12v2h6v-2H5Z"/>'
        },
        "car-brake-abs": {
            body: '<path fill="currentColor" d="M24 12c0 3.31-1.34 6.31-3.5 8.5l-1.08-1.08c1.9-1.92 3.08-4.52 3.08-7.42c0-2.89-1.18-5.5-3.08-7.42L20.5 3.5C22.66 5.69 24 8.69 24 12m-4-2.4V8h-3.2c-.88 0-1.6.72-1.6 1.6v1.6a1.6 1.6 0 0 0 1.6 1.6h1.6v1.6h-3.2V16h3.2c.88 0 1.6-.72 1.6-1.6v-1.6a1.6 1.6 0 0 0-1.6-1.6h-1.6V9.6H20M8.42 6c1.05-.63 2.27-1 3.58-1s2.53.37 3.58 1h3.11C17.05 4.16 14.66 3 12 3S6.95 4.16 5.31 6h3.11m4.78 6c.64 0 1.2.56 1.2 1.2v1.2a1.6 1.6 0 0 1-1.6 1.6H9.6V8h3.2a1.6 1.6 0 0 1 1.6 1.6v1.2c0 .64-.56 1.2-1.2 1.2m-.4.8h-1.6v1.6h1.6v-1.6m0-3.2h-1.6v1.6h1.6V9.6M4.58 4.58L3.5 3.5C1.34 5.69 0 8.69 0 12c0 3.31 1.34 6.31 3.5 8.5l1.08-1.08C2.68 17.5 1.5 14.9 1.5 12c0-2.89 1.18-5.5 3.08-7.42M7.2 16v-3.2H5.6V16H4V9.6A1.6 1.6 0 0 1 5.6 8h1.6c.88 0 1.6.72 1.6 1.6V16H7.2m0-4.8V9.6H5.6v1.6h1.6m8.38 6.8c-1.05.63-2.27 1-3.58 1a6.93 6.93 0 0 1-3.58-1H5.31c1.64 1.84 4.03 3 6.69 3s5.05-1.16 6.69-3h-3.11Z"/>'
        },
        "car-brake-alert": {
            body: '<path fill="currentColor" d="M11 15h2v2h-2v-2m0-8h2v6h-2V7m1-4a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7m8.5 1.5c2.16-2.19 3.5-5.19 3.5-8.5c0-3.31-1.34-6.31-3.5-8.5l-1.08 1.08C21.32 6.5 22.5 9.11 22.5 12c0 2.9-1.18 5.5-3.08 7.42l1.08 1.08M4.58 19.42C2.68 17.5 1.5 14.9 1.5 12c0-2.89 1.18-5.5 3.08-7.42L3.5 3.5C1.34 5.69 0 8.69 0 12c0 3.31 1.34 6.31 3.5 8.5l1.08-1.08Z"/>'
        },
        "car-brake-fluid-level": {
            body: '<path fill="currentColor" d="M1.5 12c0 2.9 1.18 5.5 3.08 7.42L3.5 20.5C1.34 18.31 0 15.31 0 12s1.34-6.31 3.5-8.5l1.08 1.08C2.68 6.5 1.5 9.11 1.5 12M21 12a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12M5 12c0 .44.05.86.12 1.28c.18-.19.34-.28.66-.28c.52 0 .61.21 1 .71S7.85 15 8.89 15c1.03 0 1.72-.79 2.11-1.29c.26-.34.39-.53.61-.63c.1-.05.22-.08.39-.08c.5 0 .61.21 1 .71S14.08 15 15.11 15c1.04 0 1.72-.79 2.11-1.29c.39-.5.48-.71 1-.71c.32 0 .48.09.66.28c.07-.42.12-.84.12-1.28c0-3.86-3.14-7-7-7s-7 3.14-7 7m15.5-8.5l-1.08 1.08C21.32 6.5 22.5 9.11 22.5 12c0 2.9-1.18 5.5-3.08 7.42l1.08 1.08c2.16-2.19 3.5-5.19 3.5-8.5s-1.34-6.31-3.5-8.5Z"/>'
        },
        "car-brake-hold": {
            body: '<path fill="currentColor" d="M12 3c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7m8.5 1.5c2.2-2.2 3.5-5.2 3.5-8.5s-1.3-6.3-3.5-8.5l-1.1 1.1c1.9 1.9 3.1 4.5 3.1 7.4c0 2.9-1.2 5.5-3.1 7.4l1.1 1.1M4.6 19.4c-1.9-1.9-3.1-4.5-3.1-7.4c0-2.9 1.2-5.5 3.1-7.4L3.5 3.5C1.3 5.7 0 8.7 0 12s1.3 6.3 3.5 8.5l1.1-1.1M9 7v10h2v-4h2v4h2V7h-2v4h-2V7H9Z"/>'
        },
        "car-brake-low-pressure": {
            body: '<path fill="currentColor" d="M13 12c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1m-3 0L7 9v2H3v2h4v2l3-3m4 0l3 3v-2h4v-2h-4V9l-3 3m6.5-8.5l-1.08 1.08C21.32 6.5 22.5 9.11 22.5 12c0 2.9-1.18 5.5-3.08 7.42l1.08 1.08c2.16-2.19 3.5-5.19 3.5-8.5s-1.34-6.31-3.5-8.5M5.69 9C6.81 6.64 9.22 5 12 5s5.19 1.64 6.32 4h2.18c-1.26-3.5-4.58-6-8.5-6S4.76 5.5 3.5 9h2.19M4.58 4.58L3.5 3.5C1.34 5.69 0 8.69 0 12s1.34 6.31 3.5 8.5l1.08-1.08C2.68 17.5 1.5 14.9 1.5 12c0-2.89 1.18-5.5 3.08-7.42M18.32 15c-1.13 2.36-3.53 4-6.32 4s-5.19-1.64-6.31-4H3.5c1.26 3.5 4.58 6 8.5 6s7.24-2.5 8.5-6h-2.18Z"/>'
        },
        "car-brake-parking": {
            body: '<path fill="currentColor" d="M12 3c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7m8.5 1.5c2.2-2.2 3.5-5.2 3.5-8.5s-1.3-6.3-3.5-8.5l-1.1 1.1c1.9 1.9 3.1 4.5 3.1 7.4c0 2.9-1.2 5.5-3.1 7.4l1.1 1.1M4.6 19.4c-1.9-1.9-3.1-4.5-3.1-7.4c0-2.9 1.2-5.5 3.1-7.4L3.5 3.5C1.3 5.7 0 8.7 0 12s1.3 6.3 3.5 8.5l1.1-1.1M9.5 7v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4m2 2h2v2h-2V9Z"/>'
        },
        "car-brake-retarder": {
            body: '<path fill="currentColor" d="M12 3c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7m8.5 1.5c2.2-2.2 3.5-5.2 3.5-8.5s-1.3-6.3-3.5-8.5l-1.1 1.1c1.9 1.9 3.1 4.5 3.1 7.4s-1.2 5.5-3.1 7.4l1.1 1.1M4.6 19.4c-1.9-1.9-3.1-4.5-3.1-7.4s1.2-5.5 3.1-7.4L3.5 3.5C1.3 5.7 0 8.7 0 12s1.3 6.3 3.5 8.5l1.1-1.1m10.7-8.9c.66 0 1.2.67 1.2 1.5c0 .81-.55 1.5-1.2 1.5c-.37 0-.64-.21-.8-.39l-.03-.03l-.03-.03L13.38 12l1.09-1.08l.03-.03l.03-.03c.21-.23.47-.36.77-.36m-6.6 0c.37 0 .64.21.8.38v.04l.06.03L10.62 12l-1.09 1.08l-.03.03l-.03.04c-.21.22-.47.35-.77.35c-.65 0-1.2-.69-1.2-1.5s.55-1.5 1.2-1.5M15.3 9c-.72 0-1.4.31-1.88.85L12 11.25l-1.39-1.37C10.1 9.31 9.42 9 8.7 9C7.21 9 6 10.35 6 12s1.21 3 2.7 3c.72 0 1.4-.31 1.89-.85l1.41-1.4l1.39 1.37c.51.56 1.19.88 1.91.88c1.49 0 2.7-1.35 2.7-3c0-1.67-1.21-3-2.7-3Z"/>'
        },
        "car-brake-temperature": {
            body: '<path fill="currentColor" d="M12 10h3V8h-3V7c0-.6-.4-1-1-1s-1 .4-1 1v10.3c-.6.3-1 1-1 1.7c0 1.1.9 2 2 2s2-.9 2-2c0-.7-.4-1.4-1-1.7V14h3v-2h-3v-2m12 2c0 3.31-1.34 6.31-3.5 8.5l-1.08-1.08c1.9-1.92 3.08-4.52 3.08-7.42c0-2.89-1.18-5.5-3.08-7.42L20.5 3.5C22.66 5.69 24 8.69 24 12M1.5 12c0 2.9 1.18 5.5 3.08 7.42L3.5 20.5C1.34 18.31 0 15.31 0 12s1.34-6.31 3.5-8.5l1.08 1.08C2.68 6.5 1.5 9.11 1.5 12M21 12c0 3.53-2.04 6.58-5 8.05v-2.31A7.01 7.01 0 0 0 19 12c0-3.86-3.14-7-7-7s-7 3.14-7 7a7.01 7.01 0 0 0 3 5.74v2.31C5.04 18.58 3 15.53 3 12a9 9 0 0 1 18 0Z"/>'
        },
        "car-brake-worn-linings": {
            body: '<path fill="currentColor" d="M12 5c3.86 0 7 3.14 7 7s-3.14 7-7 7s-7-3.14-7-7s3.14-7 7-7m0-2a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3M4.58 4.58L3.5 3.5A12.318 12.318 0 0 0 .861 7.55L2.3 8a10.73 10.73 0 0 1 2.28-3.42M1.71 14.1c-.14-.68-.21-1.38-.21-2.1c0-.72.07-1.42.21-2.1L.275 9.46C.098 10.28 0 11.13 0 12s.098 1.72.275 2.54l1.435-.44m21.43-6.55c-.61-1.52-1.51-2.9-2.64-4.05l-1.08 1.08c.97.98 1.74 2.13 2.28 3.42l1.44-.45M.861 16.45C1.47 18 2.37 19.35 3.5 20.5l1.08-1.08A10.73 10.73 0 0 1 2.3 16l-1.439.45m18.559 2.97l1.08 1.08c1.13-1.15 2.03-2.5 2.64-4.05L21.7 16a10.73 10.73 0 0 1-2.28 3.42m2.87-9.52c.14.68.21 1.38.21 2.1c0 .72-.07 1.42-.21 2.1l1.44.44c.17-.82.27-1.67.27-2.54s-.1-1.72-.27-2.54l-1.44.44Z"/>'
        },
        "car-child-seat": {
            body: '<path fill="currentColor" d="M17 4.5C17 5.9 15.9 7 14.5 7S12 5.9 12 4.5S13.1 2 14.5 2S17 3.1 17 4.5M15 8h-.8c-2.1 0-4.1-1.2-5.1-3.1c-.1-.1-.2-.2-.2-.3l-1.8.8c.5 1.4 2.1 3.2 4.4 4.1l-1.8 5l-3.9-1.1L3 18.9l2 .5l1.8-3.6l4.5 1.2c1 .2 2-.3 2.4-1.2L16 9.4c.2-.7-.3-1.4-1-1.4m3.9-1l-3.4 9.4c-.6 1.6-2.1 2.6-3.7 2.6c-.3 0-.7 0-1-.1l-2.9-.8l-.9 1.8l2 .5l1.4.4c.5.1 1 .2 1.5.2c2.5 0 4.7-1.5 5.6-3.9L21 7h-2.1Z"/>'
        },
        "car-clock": {
            body: '<path fill="currentColor" d="M23 8c0-3.87-3.13-7-7-7c-3.53 0-6.43 2.61-6.92 6H4.5c-.66 0-1.22.42-1.42 1L1 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-7.68c2.36-1.13 4-3.53 4-6.32m-18.5.5h4.53c.12 1.76.89 3.34 2.08 4.5H3l1.5-4.5m0 9.5c-.83 0-1.5-.67-1.5-1.5S3.67 15 4.5 15s1.5.67 1.5 1.5S5.33 18 4.5 18m11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m.5-5c-1.39 0-2.56-.5-3.53-1.47C11.5 10.56 11 9.39 11 8c0-1.36.5-2.54 1.47-3.5c.97-1 2.14-1.5 3.53-1.5c1.36 0 2.54.5 3.5 1.5c1 .96 1.5 2.14 1.5 3.5c0 1.39-.5 2.56-1.5 3.53c-.96.97-2.14 1.47-3.5 1.47m.5-4.75l2.86 1.69l-.75 1.22L15 9V4h1.5v4.25Z"/>'
        },
        "car-clutch": {
            body: '<path fill="currentColor" d="m10 18.84l4 1.86V23l-6-3v-6H5v-4h3V4l6-3v2.3l-4 1.86v13.68M19 10h-4V5.41L12 6.8v10.4l3 1.4V14h4v-4Z"/>'
        },
        "car-cog": {
            body: '<path fill="currentColor" d="M6.5 5c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h5.3a7 7 0 0 1-.3-2a7 7 0 0 1 3.41-6H5l1.5-4.5h11l1.18 3.53a7 7 0 0 1 1.79.43L18.92 6c-.2-.58-.76-1-1.42-1h-11M17 12a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 19 12h-2M6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13M18 15.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "car-connected": {
            body: '<path fill="currentColor" d="M5 14h14l-1.5-4.5h-11L5 14m12.5 5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5m-11 0A1.5 1.5 0 0 0 8 17.5A1.5 1.5 0 0 0 6.5 16A1.5 1.5 0 0 0 5 17.5A1.5 1.5 0 0 0 6.5 19M18.92 9L21 15v8a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8l2.08-6c.2-.58.77-1 1.42-1h11c.65 0 1.22.42 1.42 1M12 0c2.12 0 4.15.86 5.65 2.35l-1.42 1.42A6.016 6.016 0 0 0 12 2c-1.58 0-3.11.65-4.23 1.77L6.36 2.35A7.996 7.996 0 0 1 12 0m0 4c1.06 0 2.07.44 2.82 1.18L13.4 6.6c-.37-.37-.87-.6-1.4-.6c-.5 0-1.03.23-1.4.6L9.18 5.18C9.93 4.44 10.94 4 12 4Z"/>'
        },
        "car-convertable": {
            body: '<path d="M16 6l-1 .75L17.5 10h-4V8.5H12V10H3c-1.11 0-2 .89-2 2v3h2a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h2v-3c0-1.11-.89-2-2-2h-2l-3-4zM6 13.5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3zm12 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3z" fill="currentColor"/>',
            hidden: true
        },
        "car-convertible": {
            body: '<path fill="currentColor" d="m16 6l-1 .75L17.5 10h-4V8.5H12V10H3c-1.11 0-2 .89-2 2v3h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2l-3-4M6 13.5A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-coolant-level": {
            body: '<path fill="currentColor" d="M19 7V5h2V3h-8v2h2v2H1v14h22V7h-4m2 7.42c-.29-.29-.5-.42-1-.42c-.67 0-.79.21-1.29.71S17.33 16 16 16s-2.21-.79-2.71-1.29S12.67 14 12 14c-.22 0-.37.03-.5.08c-.28.1-.45.29-.79.63c-.5.5-1.38 1.29-2.71 1.29s-2.21-.79-2.71-1.29S4.67 14 4 14c-.5 0-.71.13-1 .42V9h18v5.42Z"/>'
        },
        "car-cruise-control": {
            body: '<path fill="currentColor" d="M22 15c0 2.6-1.2 4.9-3.1 6.3l-.5-.5l-2.1-2.1l1.4-1.4l1.2 1.2c.5-.7.9-1.6 1-2.5H18v-2h1.9c-.2-.9-.5-1.7-1-2.5l-1.2 1.2l-1.4-1.4l1.2-1.2c-.7-.5-1.6-.9-2.5-1V11h-2V9.1c-.9.2-1.7.5-2.5 1l3 3c.2 0 .3-.1.5-.1a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-.2 0-.3.1-.5l-3-3c-.5.7-.9 1.6-1 2.5H10v2H8.1c.2.9.5 1.7 1 2.5l1.2-1.2l1.4 1.4l-2.6 2.6C7.2 19.9 6 17.6 6 15a8 8 0 0 1 8-8a8 8 0 0 1 8 8M6.7 5.3L3.4 2L2 3.4l3.3 3.3L4 8h4V4L6.7 5.3Z"/>'
        },
        "car-defrost-front": {
            body: '<path fill="currentColor" d="M15 23c-.3 0-.5-.1-.7-.3c-.4-.4-.3-1 .1-1.4c.5-.4 1.7-1.8 1.7-2.9c0-.6-.4-1.2-.8-1.9c-.5-.8-1.2-1.8-1.2-3c0-2.3 1.3-3.2 1.5-3.3c.5-.3 1.1-.1 1.4.3c.3.5.1 1.1-.3 1.4c0 0-.5.4-.5 1.6c0 .6.4 1.2.8 1.9c.5.8 1.2 1.8 1.2 3c0 2.2-2.1 4.2-2.3 4.4c-.4.1-.7.2-.9.2m-3.3-.3c.2-.2 2.3-2.2 2.3-4.4c0-1.2-.6-2.2-1.2-3c-.4-.7-.8-1.3-.8-1.9c0-1.2.5-1.6.5-1.6c.5-.3.6-.9.3-1.4c-.3-.5-.9-.6-1.4-.3c-.2.1-1.5 1-1.5 3.3c0 1.2.6 2.2 1.2 3c.4.7.8 1.3.8 1.9c0 1.1-1.2 2.5-1.7 2.9c-.4.4-.4 1-.1 1.4c.2.2.5.3.7.3c.4.1.7 0 .9-.2m-4 0c.2-.2 2.3-2.2 2.3-4.4c0-1.2-.6-2.2-1.2-3c-.4-.6-.8-1.2-.8-1.9c0-1.2.5-1.6.5-1.6c.5-.3.6-.9.3-1.4c-.2-.4-.9-.5-1.3-.3c-.2.1-1.5 1-1.5 3.3c0 1.2.6 2.2 1.2 3c.4.7.8 1.3.8 1.9c0 1.1-1.2 2.5-1.7 2.9c-.4.4-.4 1-.1 1.4c.3.3.5.4.8.4c.2 0 .5-.1.7-.3M12 3C9.4 3 1 3.3 1 7c0 2.4 1.2 8.4 1.8 11H5v-2h-.6C3.8 13.1 3 8.8 3 7c0-1 4.4-2 9-2s9 1 9 2c0 1.8-.8 6.1-1.4 9H19v2h2.2c.6-2.6 1.8-8.6 1.8-11c0-3.7-8.4-4-11-4Z"/>'
        },
        "car-defrost-rear": {
            body: '<path fill="currentColor" d="M10 18.3c0 2.2-2.1 4.2-2.3 4.4c-.2.2-.5.3-.7.3c-.3 0-.5-.1-.8-.4c-.3-.4-.3-1 .1-1.4c.5-.4 1.7-1.8 1.7-2.9c0-.6-.4-1.2-.8-1.9c-.6-.8-1.2-1.8-1.2-3c0-2.3 1.3-3.2 1.5-3.3c.4-.2 1.1-.1 1.3.3c.3.5.2 1.1-.3 1.4c0 0-.5.4-.5 1.6c0 .7.4 1.3.8 1.9c.6.8 1.2 1.8 1.2 3m2-4.9c0-1.2.5-1.6.5-1.6c.5-.3.6-.9.3-1.4c-.3-.5-.9-.6-1.4-.3c-.2.1-1.5 1-1.5 3.3c0 1.2.6 2.2 1.2 3c.4.7.8 1.3.8 1.9c0 1.1-1.2 2.5-1.7 2.9c-.4.4-.4 1-.1 1.4c.2.2.5.3.7.3c.4.1.7 0 .9-.2c.2-.2 2.3-2.2 2.3-4.4c0-1.2-.6-2.2-1.2-3c-.4-.7-.8-1.3-.8-1.9M20 3H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h1v-2H4V5h16v11h-1v2h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-3.8 10.5c0-1.2.5-1.6.5-1.6c.4-.3.6-.9.3-1.4c-.3-.4-.9-.6-1.4-.3c-.2.1-1.5 1-1.5 3.3c0 1.2.7 2.2 1.2 3c.4.7.8 1.3.8 1.9c0 1.1-1.2 2.5-1.7 2.9c-.4.4-.5 1-.1 1.4c.2.2.4.3.7.3c.2 0 .5-.1.9-.2c.2-.2 2.3-2.2 2.3-4.4c0-1.2-.7-2.2-1.2-3c-.4-.7-.8-1.3-.8-1.9Z"/>'
        },
        "car-door": {
            body: '<path fill="currentColor" d="M19 14h-3v2h3v-2m3 7H3V11l8-8h10a1 1 0 0 1 1 1v17M11.83 5l-6 6H20V5h-8.17Z"/>'
        },
        "car-door-lock": {
            body: '<path fill="currentColor" d="M7.8 17v-1.5C7.8 14.1 6.4 13 5 13s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17M21 3H11l-8 8v.44c.61-.27 1.29-.44 2-.44c2.6 0 4.8 2.06 4.8 4.5v.25c.73.61 1.2 1.53 1.2 2.55V21h11V4c0-.55-.45-1-1-1m-2 13h-3v-2h3v2m1-5H5.83l6-6H20v6Z"/>'
        },
        "car-electric": {
            body: '<path fill="currentColor" d="M18.92 2c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.21.42-1.42 1L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-6M6.5 12c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9S8 9.67 8 10.5S7.33 12 6.5 12m11 0c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M5 7l1.5-4.5h11L19 7H5m2 13h4v-2l6 3h-4v2l-6-3Z"/>'
        },
        "car-electric-outline": {
            body: '<path fill="currentColor" d="M18.92 2c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.21.42-1.42 1L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-6M6.85 3h10.29l1.08 3.11H5.77L6.85 3M19 13H5V8h14v5M7.5 9c.83 0 1.5.67 1.5 1.5S8.33 12 7.5 12S6 11.33 6 10.5S6.67 9 7.5 9m9 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5M7 20h4v-2l6 3h-4v2l-6-3Z"/>'
        },
        "car-emergency": {
            body: '<path fill="currentColor" d="M11 0v3h2V0h-2M7.88 1.46L6.46 2.87L8.59 5L10 3.58L7.88 1.46m8.24 0L14 3.58L15.41 5l2.13-2.12l-1.42-1.42M12 5a2 2 0 0 0-2 2v1H6.5c-.66 0-1.22.42-1.42 1L3 15v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6c-.2-.58-.76-1-1.42-1H14V7a2 2 0 0 0-2-2M6.5 9.5h11L19 14H5l1.5-4.5m0 6.5A1.5 1.5 0 0 1 8 17.5A1.5 1.5 0 0 1 6.5 19A1.5 1.5 0 0 1 5 17.5A1.5 1.5 0 0 1 6.5 16m11 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-esp": {
            body: '<path fill="currentColor" d="M5.31 6C6.95 4.16 9.34 3 12 3s5.05 1.16 6.69 3h-3.11A6.93 6.93 0 0 0 12 5c-1.31 0-2.53.37-3.58 1H5.31m9.09 3.6V8h-3.2a1.6 1.6 0 0 0-1.6 1.6v1.6c0 .88.72 1.6 1.6 1.6h1.6v1.6H9.6V16h3.2a1.6 1.6 0 0 0 1.6-1.6v-1.6c0-.88-.72-1.6-1.6-1.6h-1.6V9.6h3.2m4-1.6h-3.2v8h1.6v-3.2h1.6a1.6 1.6 0 0 0 1.6-1.6V9.6c0-.88-.72-1.6-1.6-1.6m0 3.2h-1.6V9.6h1.6v1.6M8.8 9.6V8H4v8h4.8v-1.6H5.6v-1.6h3.2v-1.6H5.6V9.6h3.2m6.78 8.4c-1.05.63-2.27 1-3.58 1a6.93 6.93 0 0 1-3.58-1H5.31c1.64 1.84 4.03 3 6.69 3s5.05-1.16 6.69-3h-3.11M20.5 3.5l-1.08 1.08C21.32 6.5 22.5 9.11 22.5 12c0 2.9-1.18 5.5-3.08 7.42l1.08 1.08c2.16-2.19 3.5-5.19 3.5-8.5c0-3.31-1.34-6.31-3.5-8.5M4.58 4.58L3.5 3.5C1.34 5.69 0 8.69 0 12c0 3.31 1.34 6.31 3.5 8.5l1.08-1.08C2.68 17.5 1.5 14.9 1.5 12c0-2.89 1.18-5.5 3.08-7.42Z"/>'
        },
        "car-estate": {
            body: '<path fill="currentColor" d="M3 6h13l3 4h2c1.11 0 2 .89 2 2v3h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3H9a3 3 0 0 1-3 3a3 3 0 0 1-3-3H1V8c0-1.11.89-2 2-2m-.5 1.5V10h8V7.5h-8m9.5 0V10h5.14l-1.89-2.5H12m-6 6A1.5 1.5 0 0 0 4.5 15A1.5 1.5 0 0 0 6 16.5A1.5 1.5 0 0 0 7.5 15A1.5 1.5 0 0 0 6 13.5m12 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "car-hatchback": {
            body: '<path fill="currentColor" d="M16 6H6l-5 6v3h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2l-3-4M6.5 7.5h4V10h-6l2-2.5m5.5 0h3.5l1.96 2.5H12V7.5m-6 6A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-info": {
            body: '<path fill="currentColor" d="M19 15h-2v-2h2m1 7v2h-4v-2h1v-2h-1v-2h3v4m-.08-15a1.5 1.5 0 0 0-1.42-1h-11a1.5 1.5 0 0 0-1.42 1L3 11v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h5a7 7 0 0 1 7-7a6.84 6.84 0 0 1 3 .68V11M6.5 15A1.5 1.5 0 1 1 8 13.5A1.5 1.5 0 0 1 6.5 15M5 10l1.5-4.5h11L19 10Z"/>'
        },
        "car-key": {
            body: '<path fill="currentColor" d="M9 0C7.3 0 6 1.3 6 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H14v2h2V4h2V2h-6.2C11.4.8 10.3 0 9 0m0 2c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1M6.5 8c-.7 0-1.2.4-1.4 1L3 15v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8l-2.1-6c-.2-.6-.8-1-1.4-1h-11m0 1.5h11L19 14H5l1.5-4.5m0 6.5c.8 0 1.5.7 1.5 1.5S7.3 19 6.5 19S5 18.3 5 17.5S5.7 16 6.5 16m11 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        "car-lifted-pickup": {
            body: '<path fill="currentColor" d="m18 14l.79.1l-.02.23l.47.17l.15-.16c.5.26.93.66 1.21 1.16l-.17.17l.2.45l.23-.02c.09.29.14.59.14.9l-.1.78l-.24-.01l-.19.47l.19.15c-.27.51-.66.93-1.16 1.21l-.17-.18l-.46.2l.02.24c-.28.09-.58.14-.89.14l-.79-.1l.01-.25l-.46-.18l-.16.19c-.5-.27-.93-.66-1.21-1.16l.18-.18l-.2-.46l-.24.02c-.08-.28-.13-.57-.13-.88l.11-.8l.23.01l.19-.46l-.18-.15c.27-.51.65-.92 1.15-1.21l.17.17l.46-.2l-.02-.22c.28-.09.58-.14.89-.14m0 1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M6 14l.79.1l-.02.23l.47.17l.15-.16c.5.26.93.66 1.21 1.16l-.17.17l.2.45l.23-.02c.09.29.14.59.14.9l-.1.78l-.25-.01l-.18.47l.19.15c-.27.51-.66.93-1.16 1.21l-.17-.18l-.46.2l.02.24c-.28.09-.58.14-.89.14l-.79-.1l.01-.25l-.46-.18l-.16.19c-.5-.27-.93-.66-1.21-1.16l.18-.18l-.2-.46l-.24.02C3.05 17.6 3 17.31 3 17l.11-.8l.23.01l.19-.46l-.18-.15c.27-.51.65-.92 1.15-1.21l.17.17l.46-.2l-.02-.22c.28-.09.58-.14.89-.14m0 1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M16 6l3 4h2c1.11 0 2 .89 2 2v3h-2c0-1.66-1.34-3-3-3s-3 1.34-3 3H9c0-1.66-1.34-3-3-3s-3 1.34-3 3H1v-5h9.5V6H16m-4 1.5V10h5.46L15.5 7.5H12Z"/>'
        },
        "car-light-alert": {
            body: '<path fill="currentColor" d="M23 7v6h-2V7h2m-2 10h2v-2h-2v2M1 9v2h4c.1-.7.1-1.4.2-2H1m4 4H1v2h4.2c-.1-.6-.1-1.3-.2-2m.9-6.6c.1-.6.4-1 .6-1.4H1v2h4.7c.1-.2.1-.4.2-.6M1 17v2h5.6c-.4-.6-.7-1.2-.9-2H1m9-12.2c-4 0-4 14.4 0 14.4s9-2.7 9-7.2s-5-7.2-9-7.2m.1 12.4C9.7 16.8 9 15 9 12s.7-4.8 1.1-5.2C13 6.9 17 8.7 17 12s-4 5.1-6.9 5.2"/>'
        },
        "car-light-dimmed": {
            body: '<path fill="currentColor" d="M13 4.8c-4 0-4 14.4 0 14.4s9-2.7 9-7.2s-5-7.2-9-7.2m.1 12.4C12.7 16.8 12 15 12 12s.7-4.8 1.1-5.2C16 6.9 20 8.7 20 12c0 3.3-4.1 5.1-6.9 5.2M8 10.5c0 .5-.1 1-.1 1.5v.6L2.4 14l-.5-1.9L8 10.5M2 7l7.4-1.9c-.2.3-.4.7-.5 1.2c-.1.3-.2.7-.3 1.1L2.5 8.9L2 7m6.2 8.5c.1.7.3 1.4.5 1.9L2.4 19l-.5-1.9l6.3-1.6Z"/>'
        },
        "car-light-fog": {
            body: '<path fill="currentColor" d="M13 4.8c-4 0-4 14.4 0 14.4s9-2.7 9-7.2s-5-7.2-9-7.2m.1 12.4C12.7 16.8 12 15 12 12s.7-4.8 1.1-5.2C16 6.9 20 8.7 20 12c0 3.3-4 5.1-6.9 5.2M6 8v3h2v2H6v3h2.4c.2.7.4 1.4.6 2H6v3H4v-3H2v-2h2v-3H2v-2h2V8H2V6h2V3h2v3h3c0 .1-.1.2-.1.4c-.2.5-.4 1-.5 1.6H6Z"/>'
        },
        "car-light-high": {
            body: '<path fill="currentColor" d="M13 4.8c-4 0-4 14.4 0 14.4s9-2.7 9-7.2s-5-7.2-9-7.2m.1 12.4C12.7 16.8 12 15 12 12s.7-4.8 1.1-5.2C16 6.9 20 8.7 20 12c0 3.3-4 5.1-6.9 5.2M2 5h7.5c-.2.4-.5.8-.6 1.4c-.1.2-.1.4-.2.6H2V5m6 6H2V9h6.2c-.1.6-.1 1.3-.2 2m.7 6c.2.8.5 1.4.9 2H2.1v-2h6.6m-.5-2H2v-2h6c.1.7.1 1.4.2 2Z"/>'
        },
        "car-limousine": {
            body: '<path fill="currentColor" d="m1 6l1.5 1.5L1 9l1.5 1.5L1 12l1.5 1.5L1 15h14a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2l-3-4H1m3.62 1.5h5.88V10H4.12l-1-1l1.5-1.5m7.38 0h3.5l1.96 2.5H12V7.5m6 6a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-multiple": {
            body: '<path fill="currentColor" d="m8 11l1.5-4.5h9L20 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-9 0A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 9.5 13a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 9.5 16M19.92 6c-.21-.6-.78-1-1.42-1h-9c-.64 0-1.21.4-1.42 1L6 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6m-5-3c-.21-.6-.78-1-1.42-1h-9c-.64 0-1.21.4-1.42 1L1 9v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4.09A1.492 1.492 0 0 1 3.1 11c.22-.6.77-1 1.4-1h.07l.7-2H3l1.5-4.5h10.59l-.17-.5Z"/>'
        },
        "car-off": {
            body: '<path fill="currentColor" d="M20.5 19.85L6.41 5.76l-4-4L1.11 3l3.46 3.46L3 11v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10.11l4.73 4.73l1.27-1.27l-1.61-1.61M6.5 15A1.5 1.5 0 0 1 5 13.5A1.5 1.5 0 0 1 6.5 12A1.5 1.5 0 0 1 8 13.5A1.5 1.5 0 0 1 6.5 15M5 10l.78-2.33L8.11 10H5m12.5-4.5L19 10h-5.8l2.92 2.92c.38-.75 1.25-1.06 2-.71c.75.36 1.06 1.26.71 2c-.15.29-.4.56-.71.71L21 17.8V11l-2.08-6c-.21-.6-.78-1-1.42-1H7.2l1.5 1.5h8.8Z"/>'
        },
        "car-outline": {
            body: '<path fill="currentColor" d="M18.9 6c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L3 12v8c0 .5.5 1 1 1h1c.6 0 1-.5 1-1v-1h12v1c0 .5.5 1 1 1h1c.5 0 1-.5 1-1v-8l-2.1-6M6.8 7h10.3l1.1 3H5.8l1-3M19 17H5v-5h14v5M7.5 13c.8 0 1.5.7 1.5 1.5S8.3 16 7.5 16S6 15.3 6 14.5S6.7 13 7.5 13m9 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        "car-parking-lights": {
            body: '<path fill="currentColor" d="M7.3 9.2C8.1 9.6 9 10.5 9 12c0 1.5-.9 2.4-1.7 2.8c-.4-1.4-.4-4.2 0-5.6M6.5 7c-2 0-2 10 0 10s4.5-1.9 4.5-5s-2.5-5-4.5-5m10.2 2.2c.3 1.4.3 4.2 0 5.6c-.8-.4-1.7-1.3-1.7-2.8c0-1.5.9-2.4 1.7-2.8m.8-2.2c-2 0-4.5 1.9-4.5 5s2.5 5 4.5 5s2-10 0-10M4.9 6.2L2.5 4.6L1.4 6.3L4 8c.2-.7.5-1.4.9-1.8M20 8l2.6-1.7l-1.1-1.7l-2.4 1.6c.3.4.7 1 .9 1.8M4 16l-2.6 1.7l1.1 1.7l2.4-1.6c-.3-.4-.7-1-.9-1.8m16.5-5v2H24v-2h-3.5m-1.4 6.8l2.4 1.6l1.1-1.7L20 16c-.2.7-.5 1.4-.9 1.8M3.5 12v-1H0v2h3.5v-1Z"/>'
        },
        "car-pickup": {
            body: '<path fill="currentColor" d="M16 6h-5.5v4H1v5h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-3c0-1.11-.89-2-2-2h-2l-3-4m-4 1.5h3.5l1.96 2.5H12V7.5m-6 6A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-search": {
            body: '<path fill="currentColor" d="M9.61 16.11c0-2.08.98-3.92 2.49-5.11H5l1.5-4.5h11l1.22 3.66c.84.37 1.58.91 2.19 1.58L18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h4.29c-.43-.87-.68-1.85-.68-2.89M6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16m14.21 4.7l-.01.01l.01-.01m-4.6-9.09c2.5 0 4.5 2 4.5 4.5c0 .89-.25 1.71-.69 2.39L23 21.61L21.61 23l-3.11-3.07c-.7.43-1.5.68-2.39.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 1 0 2.5 2.5c0-1.39-1.11-2.5-2.5-2.5"/>'
        },
        "car-search-outline": {
            body: '<path fill="currentColor" d="M10.29 19H6v1c0 .5-.4 1-1 1H4c-.5 0-1-.5-1-1v-8l2.1-6c.2-.6.7-1 1.4-1h11c.6 0 1.2.4 1.4 1l2.01 5.74a6.541 6.541 0 0 0-2.73-1.79L17.1 7H6.8l-1 3h8.11c-1.12.4-2.1 1.1-2.83 2H5v5h4.68c.1.71.32 1.38.61 2M6 14.5c0 .8.7 1.5 1.5 1.5S9 15.3 9 14.5S8.3 13 7.5 13S6 13.7 6 14.5m10.11-2.89c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.89 0 1.69-.25 2.39-.68L21.61 23L23 21.61l-3.08-3.11c.44-.68.69-1.5.69-2.39c0-2.5-2-4.5-4.5-4.5m0 2c1.39 0 2.5 1.12 2.5 2.5s-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5s1.12-2.5 2.5-2.5"/>'
        },
        "car-seat": {
            body: '<path fill="currentColor" d="M7 18S4 10 4 6s2-4 2-4h1s1 0 1 1s-1 1-1 3s3 4 3 7s-3 5-3 5m5-1c-1 0-4 2.5-4 2.5c-.3.2-.2.5 0 .8c0 0 1 1.8 3 1.8h6c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2h-5Z"/>'
        },
        "car-seat-cooler": {
            body: '<path fill="currentColor" d="m20.8 10.2l-1.4.4l-1.2-.7V8.2l1.2-.7l1.4.4l.3-1.1l-1.1-.3l.3-1.1l-1.1-.3l-.4 1.4l-1.2.7l-1.5-.9V5l1-1l-.8-.8l-.8.8l-.8-.8l-.8.8l1 1v1.3l-1.5.9l-1.2-.7l-.3-1.4l-1.1.3l.3 1.1l-1.1.2l.3 1.1l1.4-.4l1.2.7v1.7l-1.2.7l-1.4-.4l-.3 1.3l1.1.3l-.3 1l1.1.3l.4-1.4l1.2-.7l1.5.9v1.3l-1 1l.8.8l.8-.8l.8.8l.8-.8l-1-1v-1.3l1.5-.9l1.2.7l.4 1.4l1.1-.3l-.4-1.1l1.1-.3l-.3-1.1m-6.8-2l1.5-.9l1.5.9v1.7l-1.5.9l-1.5-.9V8.2M5 18S2 10 2 6s2-4 2-4h1s1 0 1 1s-1 1-1 3s3 4 3 7s-3 5-3 5m10-1c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2H9c-2 0-3-1.8-3-1.8c-.2-.2-.3-.6 0-.8c0 0 3-2.5 4-2.5h5Z"/>'
        },
        "car-seat-heater": {
            body: '<path fill="currentColor" d="M5 18S2 10 2 6s2-4 2-4h1s1 0 1 1s-1 1-1 3s3 4 3 7s-3 5-3 5m10-1c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2H9c-2 0-3-1.8-3-1.8c-.2-.2-.3-.6 0-.8c0 0 3-2.5 4-2.5h5M13.7 3.4l-1.4 3.4l1.4 3.4l-2 4.8l-1.7-1.4l1.4-3.4L10 6.8L12 2l1.7 1.4m4.2 0l-1.4 3.4l1.4 3.4l-2 4.8l-1.7-1.4l1.4-3.4l-1.4-3.4l2-4.8l1.7 1.4m4.1 0l-1.4 3.4l1.4 3.4l-2 4.8l-1.7-1.4l1.4-3.4l-1.4-3.4l2-4.8L22 3.4"/>'
        },
        "car-select": {
            body: '<path fill="currentColor" d="m5 13l1.5-4.5h11L19 13m-1.5 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m-11 0c-.8 0-1.5-.7-1.5-1.5S5.7 15 6.5 15s1.5.7 1.5 1.5S7.3 18 6.5 18M18.9 8c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L3 14v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8M8 1l4 4.5L16 1Z"/>'
        },
        "car-settings": {
            body: '<path fill="currentColor" d="M15 22h2v2h-2m-4-2h2v2h-2m-4-2h2v2H7M5 11l1.5-4.5h11L19 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8Z"/>'
        },
        "car-shift-pattern": {
            body: '<path fill="currentColor" d="M8 5H4V2h4v3M4 22h4v-3H4v3M14 2h-4v3h4V2m-4 20h4v-3h-4v3m6-20v3h4V2h-4m1 9h-4V7h-2v4H7V7H5v10h2v-4h4v4h2v-4h6V7h-2v4Z"/>'
        },
        "car-side": {
            body: '<path fill="currentColor" d="m16 6l3 4h2c1.11 0 2 .89 2 2v3h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3H9a3 3 0 0 1-3 3a3 3 0 0 1-3-3H1v-3c0-1.11.89-2 2-2l3-4h10m-5.5 1.5H6.75L4.86 10h5.64V7.5m1.5 0V10h5.14l-1.89-2.5H12m-6 6A1.5 1.5 0 0 0 4.5 15A1.5 1.5 0 0 0 6 16.5A1.5 1.5 0 0 0 7.5 15A1.5 1.5 0 0 0 6 13.5m12 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "car-speed-limiter": {
            body: '<path fill="currentColor" d="M18 15c0 2.6-1.2 4.9-3.1 6.3l-.5-.5l-2.1-2.1l1.4-1.4l1.2 1.2c.5-.7.9-1.6 1-2.5H14v-2h1.9c-.2-.9-.5-1.7-1-2.5l-1.2 1.2l-1.4-1.4l1.2-1.2c-.7-.5-1.6-.9-2.5-1V11H9V9.1c-.9.2-1.7.5-2.5 1l3 3c.2 0 .3-.1.5-.1a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2c0-.2 0-.3.1-.5l-3-3c-.5.7-.9 1.6-1 2.5H6v2H4.1c.2.9.5 1.7 1 2.5l1.2-1.2l1.4 1.4l-2.6 2.6C3.2 19.9 2 17.6 2 15c0-4.42 3.58-8 8-8s8 3.58 8 8m5-10c0-1.66-1.34-3-3-3s-3 1.34-3 3c0 1.3.84 2.4 2 2.82V11h2V7.82C22.16 7.4 23 6.3 23 5m-3 1c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "car-sports": {
            body: '<path fill="currentColor" d="M12 8.5H7L4 11H3c-1.11 0-2 .89-2 2v3h2.17c.43 1.2 1.56 2 2.83 2s2.4-.8 2.82-2h6.35c.43 1.2 1.56 2 2.83 2s2.4-.8 2.82-2H23v-1c0-1.11-1.03-1.47-2-2l-9-4.5M5.25 12l2.25-2h4l4 2H5.25M6 13.5A1.5 1.5 0 0 1 7.5 15A1.5 1.5 0 0 1 6 16.5A1.5 1.5 0 0 1 4.5 15A1.5 1.5 0 0 1 6 13.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "car-tire-alert": {
            body: '<path fill="currentColor" d="M11 13h2v2h-2v-2m0-8h2v6h-2V5m6-.24c1.86 1.43 3 3.85 3 6.24a8 8 0 0 1-4.14 7H8.14A8 8 0 0 1 4 11c0-2.39 1.09-4.83 3-6.24V2H5v1.86C3.15 5.68 2 8.2 2 11s1.15 5.32 3 7.14V22h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-3.86c1.85-1.82 3-4.34 3-7.14s-1.15-5.32-3-7.14V2h-2v2.76Z"/>'
        },
        "car-traction-control": {
            body: '<path fill="currentColor" d="M9.5 11h1c.3 0 .5-.2.5-.5V9h8v1.5c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5V6l-1.4-4.3c-.1-.4-.5-.7-.9-.7h-7.3c-.4 0-.8.3-.9.7L9 6v4.5c0 .3.2.5.5.5m1.8-9h7.3l.9 3h-9.1l.9-3m.7 21h-2c0-.8-1.9-1.5-3.4-2.1C4.5 20.1 2 19.2 2 17c0-2.3 2.3-2.9 4.2-3.5C7.9 13.1 9 12.7 9 12h2c0 2.3-2.3 2.9-4.2 3.5c-1.7.4-2.8.8-2.8 1.5c0 .8 1.9 1.5 3.4 2.1c2.1.8 4.6 1.7 4.6 3.9m10 0h-2c0-.8-1.9-1.5-3.4-2.1c-2.1-.8-4.6-1.7-4.6-3.9c0-2.3 2.3-2.9 4.2-3.5c1.6-.5 2.8-.8 2.8-1.5h2c0 2.3-2.3 2.9-4.2 3.5c-1.6.4-2.8.8-2.8 1.5c0 .8 1.9 1.5 3.4 2.1c2.1.8 4.6 1.7 4.6 3.9Z"/>'
        },
        "car-turbocharger": {
            body: '<path fill="currentColor" d="M22 13v2h-3.68c.43-.91.68-1.92.68-3c0-3.86-3.14-7-7-7H2V3h10a9 9 0 0 1 9 9c0 .34-.03.67-.06 1H22m-10 6c-3.86 0-7-3.14-7-7c0-1.07.25-2.09.69-3H2v2h1.06c-.03.33-.06.66-.06 1a9 9 0 0 0 9 9h10v-2H12m4.86-6.8c-.93.74-2.14.27-2.86-.15V12c2.79-1.69 1.39-4.11 1.39-4.11s-1.06-1.85-.78 0c.17 1.18-.85 1.99-1.57 2.41l-.04-.02C12.93 7 10.13 7 10.13 7S8 7 9.74 7.69c1.11.44 1.3 1.73 1.31 2.56l-.05.03c-2.86-1.58-4.26.84-4.26.84s-1.07 1.85.4.68c.93-.73 2.14-.26 2.86.15V12c-2.79 1.7-1.39 4.12-1.39 4.12s1.06 1.85.79-.01c-.18-1.17.85-1.98 1.57-2.41l.03.03C11.07 17 13.87 17 13.87 17s2.13 0 .39-.69c-1.11-.44-1.3-1.73-1.31-2.56l.05-.02c2.86 1.58 4.26-.85 4.26-.85s1.07-1.84-.4-.68Z"/>'
        },
        "car-wash": {
            body: '<path fill="currentColor" d="m5 13l1.5-4.5h11L19 13m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 16.5A1.5 1.5 0 0 1 6.5 15A1.5 1.5 0 0 1 8 16.5A1.5 1.5 0 0 1 6.5 18M18.92 8c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 14v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8M7 5a1.5 1.5 0 0 0 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5A1.5 1.5 0 0 0 7 5m5 0a1.5 1.5 0 0 0 1.5-1.5c0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7A1.5 1.5 0 0 0 12 5m5 0a1.5 1.5 0 0 0 1.5-1.5c0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7A1.5 1.5 0 0 0 17 5Z"/>'
        },
        "car-windshield": {
            body: '<path fill="currentColor" d="m22.63 15.5l-2.42-9.65a1 1 0 0 0-1.07-.75c-1.34.14-5 .4-7.14.4s-5.8-.26-7.14-.4a1 1 0 0 0-1.07.75L1.37 15.5a1.5 1.5 0 0 0 1.18 1.86A61.5 61.5 0 0 0 12 18a61.5 61.5 0 0 0 9.45-.64a1.5 1.5 0 0 0 1.18-1.86Z"/>'
        },
        "car-windshield-outline": {
            body: '<path fill="currentColor" d="m22.63 15.5l-2.42-9.65a1 1 0 0 0-1.07-.75c-1.34.14-5 .4-7.14.4s-5.8-.26-7.14-.4a1 1 0 0 0-1.07.75L1.37 15.5a1.5 1.5 0 0 0 1.18 1.86A61.5 61.5 0 0 0 12 18a61.5 61.5 0 0 0 9.45-.64a1.5 1.5 0 0 0 1.18-1.86M12 16a63.33 63.33 0 0 1-8.56-.5L5.5 7.18c1.5.14 4.66.32 6.5.32s5-.18 6.5-.32l2.06 8.32A63.33 63.33 0 0 1 12 16Z"/>'
        },
        "car-wireless": {
            body: '<path fill="currentColor" d="M12 5c-1.1 0-2 .9-2 2v1H6.5c-.66 0-1.22.42-1.42 1L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-6c-.2-.58-.76-1-1.42-1H14V7a2 2 0 0 0-2-2M6.5 9.5h11L19 14H5l1.5-4.5m0 6.5c.83 0 1.5.67 1.5 1.5S7.33 19 6.5 19S5 18.33 5 17.5S5.67 16 6.5 16m11 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5M16.2 3.4C15 2.3 13.5 1.7 12 1.7s-3 .6-4.2 1.7L7 2.6C8.4 1.2 10.2.5 12 .5s3.6.7 5 2.1l-.8.8m-.9.8l-.8.8c-.7-.7-1.6-1-2.5-1s-1.8.3-2.5 1l-.8-.8c.9-.9 2.1-1.4 3.3-1.4s2.4.5 3.3 1.4"/>'
        },
        "car-wrench": {
            body: '<path fill="currentColor" d="M20.96 16.45c.01-.15.04-.3.04-.45v.5l-.04-.05M11 16c0 .71.15 1.39.42 2H6v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8l2.08-6c.2-.58.76-1 1.42-1h11c.66 0 1.22.42 1.42 1L21 11v5c0-2.76-2.24-5-5-5s-5 2.24-5 5m-3-2.5c0-.83-.67-1.5-1.5-1.5S5 12.67 5 13.5S5.67 15 6.5 15S8 14.33 8 13.5M19 10l-1.5-4.5h-11L5 10h14m3.87 11.19l-4.11-4.11c.41-1.04.18-2.26-.68-3.11c-.9-.91-2.25-1.09-3.34-.59l1.94 1.94l-1.35 1.36l-1.99-1.95c-.54 1.09-.29 2.44.59 3.35a2.91 2.91 0 0 0 3.12.68l4.11 4.1c.18.19.45.19.63 0l1.04-1.03c.22-.18.22-.5.04-.64Z"/>'
        },
        carabiner: {
            body: '<path fill="currentColor" d="M8 17.5c0 .83-.67 1.5-1.5 1.5S5 18.33 5 17.5S5.67 16 6.5 16s1.5.67 1.5 1.5M18 5.59C17.79 3.54 16.18 2 14.24 2H8.88C6.95 2 5.36 3.5 5.15 5.53L5 6.59C4.92 7.34 5.5 8 6.24 8c.63 0 1.15-.47 1.23-1.09l.14-1.09c.07-.75.62-1.32 1.27-1.32h5.36c.65 0 1.2.57 1.26 1.32l1 11.06c.09.86-.5 1.62-1.25 1.62l-5.21-.68a3.46 3.46 0 0 1-1.24 2.36l6.13.82h.32c1.02 0 2.01-.44 2.71-1.22A4.22 4.22 0 0 0 19 16.65L18 5.59m-6.34 2.35c-.58-.37-1.35-.19-1.72.4L6.39 14h.11c.88 0 1.68.34 2.3.88l3.26-5.22c.37-.58.19-1.35-.4-1.72Z"/>'
        },
        caravan: {
            body: '<path fill="currentColor" d="M5 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h8v-2h-2V9a2 2 0 0 0-2-2H5m0 2h5v3H5V9m8 0h4v3h-4V9m-3 7a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        card: {
            body: '<path fill="currentColor" d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Z"/>'
        },
        "card-account-details": {
            body: '<path fill="currentColor" d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6h-8m0 2v1h8V8h-8m0 2v1h7v-1h-7m-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "card-account-details-outline": {
            body: '<path fill="currentColor" d="M22 3H2c-1.09.04-1.96.91-2 2v14c.04 1.09.91 1.96 2 2h20c1.09-.04 1.96-.91 2-2V5a2.074 2.074 0 0 0-2-2m0 16H2V5h20v14m-8-2v-1.25c0-1.66-3.34-2.5-5-2.5c-1.66 0-5 .84-5 2.5V17h10M9 7a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 9 12a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 9 7m5 0v1h6V7h-6m0 2v1h6V9h-6m0 2v1h4v-1h-4"/>'
        },
        "card-account-details-star": {
            body: '<path fill="currentColor" d="m20 22.09l2.45 1.49l-.65-2.81l2.2-1.88l-2.89-.25L20 16l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49M14.08 21H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2h20c1.05 0 2 .95 2 2v10.53A5.97 5.97 0 0 0 20 14c-3.31 0-6 2.69-6 6c0 .34.03.68.08 1M8 13.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6C6.35 6 5 7.35 5 9s1.35 3 3 3s3-1.35 3-3s-1.35-3-3-3m13 4h-7v1h7v-1m1-2h-8v1h8V8m0-2h-8v1h8V6Z"/>'
        },
        "card-account-details-star-outline": {
            body: '<path fill="currentColor" d="m20 22.09l2.45 1.49l-.65-2.81l2.2-1.88l-2.89-.25L20 16l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49M14.08 21H2a2.074 2.074 0 0 1-2-2V5c.04-1.09.91-1.96 2-2h20c1.09.04 1.96.91 2 2v10.53c-.58-.53-1.25-.92-2-1.19V5H2v14h12.08c-.05.33-.08.66-.08 1c0 .34.03.68.08 1M14 17H4v-1.25c0-1.66 3.34-2.5 5-2.5c1.66 0 5 .84 5 2.5V17m0-6h4v1h-4v-1M9 7C7.63 7 6.5 8.13 6.5 9.5S7.63 12 9 12s2.5-1.13 2.5-2.5S10.37 7 9 7m5 2h6v1h-6V9m0-2h6v1h-6V7Z"/>'
        },
        "card-account-mail": {
            body: '<path fill="currentColor" d="M21 8V7l-3 2l-3-2v1l3 2m4-7H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M8 6a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1m8-5h-8V6h8"/>'
        },
        "card-account-mail-outline": {
            body: '<path fill="currentColor" d="M22 3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H2V5h20v14M21 6h-7v5h7V6m-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1M9 12a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0-4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 8.59c0-2.5-3.97-3.59-6-3.59s-6 1.09-6 3.59V18h12v-1.41M5.5 16c.72-.5 2.2-1 3.5-1c1.3 0 2.77.5 3.5 1h-7Z"/>'
        },
        "card-account-phone": {
            body: '<path fill="currentColor" d="M22 3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M8 6a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1m3.85-4h1.65l1.5 2l-2 2c-1.3-1-2.27-2.39-2.72-4c-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3 2.72-4l2 2l-1.5 2h-1.65c-.22.63-.35 1.3-.35 2s.13 1.37.35 2Z"/>'
        },
        "card-account-phone-outline": {
            body: '<path fill="currentColor" d="M22 3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H2V5h20v14m-3-1l2-2l-1.5-2h-1.65c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.65L21 8l-2-2c-1.3 1-2.27 2.38-2.72 4c-.18.64-.28 1.31-.28 2s.1 1.36.28 2c.45 1.61 1.42 3 2.72 4M9 12a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0-4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 8.59c0-2.5-3.97-3.59-6-3.59s-6 1.09-6 3.59V18h12v-1.41M5.5 16c.72-.5 2.2-1 3.5-1c1.3 0 2.77.5 3.5 1h-7Z"/>'
        },
        "card-bulleted": {
            body: '<path fill="currentColor" d="M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16m-9 9H9v2h2v-2m8 0h-6v2h6v-2M7 9H5v2h2V9m12 0H9v2h10V9Z"/>'
        },
        "card-bulleted-off": {
            body: '<path fill="currentColor" d="m3.35 3.58l17.3 17.29l-1.42 1.42L16.94 20H4a2 2 0 0 1-2-2V6c0-.28.06-.54.16-.78l-.93-.93l1.42-1.42l.7.71M6.6 4H20a2 2 0 0 1 2 2v12c0 .4-.12.77-.32 1.08L17.6 15H20v-2h-4.4l-2-2H20V9h-8.4l-5-5m3.34 9H9v2h2v-.94L9.94 13m-4-4H5v2h2v-.94L5.94 9Z"/>'
        },
        "card-bulleted-off-outline": {
            body: '<path fill="currentColor" d="m20.59 20.87l-1.42 1.42L16.88 20H4a2 2 0 0 1-2-2V6c0-.26.05-.5.14-.74l-.97-.97l1.42-1.42L3.73 4l16.86 16.87M6.54 4H20a2 2 0 0 1 2 2v12c0 .41-.13.8-.34 1.12L20 17.46V6H8.54l-2-2M4 18h10.88l-3-3H10v-1.88L7.88 11H6V9.12l-2-2V18m14-3h-.46l-2-2H18v2m0-4h-4.46l-2-2H18v2Z"/>'
        },
        "card-bulleted-outline": {
            body: '<path fill="currentColor" d="M12 15h-2v-2h2v2m6 0h-4v-2h4v2M8 11H6V9h2v2m10 0h-8V9h8v2m2 9H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M4 6v12h16V6H4Z"/>'
        },
        "card-bulleted-settings": {
            body: '<path fill="currentColor" d="M9 22v2H7v-2h2m4 0v2h-2v-2h2m4 0v2h-2v-2h2m3-2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2m-9-7H9v2h2v-2m8 0h-6v2h6v-2M7 9H5v2h2V9m12 0H9v2h10V9Z"/>'
        },
        "card-bulleted-settings-outline": {
            body: '<path fill="currentColor" d="M9 22v2H7v-2h2m4 0v2h-2v-2h2m4 0v2h-2v-2h2m-5-7h-2v-2h2v2m6 0h-4v-2h4v2M8 11H6V9h2v2m10 0h-8V9h8v2m2 9H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M4 6v12h16V6H4Z"/>'
        },
        "card-minus": {
            body: '<path fill="currentColor" d="M23 18v2h-8v-2h8m-4-5c1.09 0 2.12.3 3 .81V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6Z"/>'
        },
        "card-minus-outline": {
            body: '<path fill="currentColor" d="M23 18v2h-8v-2h8m-9.91 0H4V6h16v7.09c.72.12 1.39.37 2 .72V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1c0-.34.04-.67.09-1Z"/>'
        },
        "card-multiple": {
            body: '<path fill="currentColor" d="M21 3c.53 0 1.04.21 1.41.59c.38.37.59.88.59 1.41v10c0 .53-.21 1.04-.59 1.41c-.37.38-.88.59-1.41.59H7c-.53 0-1.04-.21-1.41-.59C5.21 16.04 5 15.53 5 15V5c0-.53.21-1.04.59-1.41C5.96 3.21 6.47 3 7 3h14M3 19h15v2H3c-.53 0-1.04-.21-1.41-.59C1.21 20.04 1 19.53 1 19V8h2v11Z"/>'
        },
        "card-multiple-outline": {
            body: '<path fill="currentColor" d="M21 16V6H7v10h14m0-12c.53 0 1.04.21 1.41.59c.38.37.59.88.59 1.41v10c0 .53-.21 1.04-.59 1.41c-.37.38-.88.59-1.41.59H7a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h14M3 20h15v2H3c-.53 0-1.04-.21-1.41-.59C1.21 21.04 1 20.53 1 20V9h2v11Z"/>'
        },
        "card-off": {
            body: '<path fill="currentColor" d="M21.88 18.68L7.2 4H20c1.11 0 2 .89 2 2v12c0 .24-.04.47-.12.68m-1.32 1.23h.01L2.39 1.73L1.11 3l1.54 1.54C2.25 4.9 2 5.42 2 6v12a2 2 0 0 0 2 2h14.11l2.73 2.73l1.27-1.27l-1.55-1.55Z"/>'
        },
        "card-off-outline": {
            body: '<path fill="currentColor" d="m9.2 6l-2-2H20c1.11 0 2 .89 2 2v12c0 .24-.04.47-.12.68L20 16.8V6H9.2m12.91 15.46l-1.27 1.27L18.11 20H4a2 2 0 0 1-2-2V6c0-.58.25-1.1.65-1.46L1.11 3l1.28-1.27L6.66 6l11.99 12h.01l1.91 1.91h-.01l1.55 1.55m-6-3.46l-12-12H4v12h12.11Z"/>'
        },
        "card-outline": {
            body: '<path fill="currentColor" d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M4 6v12h16V6H4Z"/>'
        },
        "card-plus": {
            body: '<path fill="currentColor" d="M13.09 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v7.81c-.88-.51-1.91-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "card-plus-outline": {
            body: '<path fill="currentColor" d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2m-7 3H3V6h16v7h2V6c0-1.11-.89-2-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11v-2Z"/>'
        },
        "card-remove": {
            body: '<path fill="currentColor" d="m20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19M19 13c1.09 0 2.12.3 3 .81V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6Z"/>'
        },
        "card-remove-outline": {
            body: '<path fill="currentColor" d="m20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19m-7.32-1H4V6h16v7.09c.72.12 1.39.37 2 .72V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1c0-.34.04-.67.09-1Z"/>'
        },
        "card-search": {
            body: '<path fill="currentColor" d="M11.5 9a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.38.7C9 16 7 14 7 11.5S9 7 11.5 7a4.481 4.481 0 0 1 3.8 6.89l2.91 2.9l-1.42 1.42Z"/>'
        },
        "card-search-outline": {
            body: '<path fill="currentColor" d="M11.5 16c.87 0 1.69-.26 2.38-.7l2.44 2.44l1.42-1.42l-2.44-2.43A4.481 4.481 0 0 0 11.5 7C9 7 7 9 7 11.5S9 16 11.5 16m0-7a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V6h16v12Z"/>'
        },
        "card-text": {
            body: '<path fill="currentColor" d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M5 13v2h11v-2H5m0-4v2h14V9H5Z"/>'
        },
        "card-text-outline": {
            body: '<path fill="currentColor" d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M4 6v12h16V6H4m2 3h12v2H6V9m0 4h10v2H6v-2Z"/>'
        },
        cards: {
            body: '<path fill="currentColor" d="m21.47 4.35l-1.34-.56v9.03l2.43-5.86c.41-1.02-.06-2.19-1.09-2.61m-19.5 3.7L6.93 20a2.01 2.01 0 0 0 1.81 1.26c.26 0 .53-.05.79-.16l7.37-3.05c.75-.31 1.21-1.05 1.23-1.79c.01-.26-.04-.55-.13-.81L13 3.5a1.954 1.954 0 0 0-1.81-1.25c-.26 0-.52.06-.77.15L3.06 5.45a1.994 1.994 0 0 0-1.09 2.6m16.15-3.8a2 2 0 0 0-2-2h-1.45l3.45 8.34"/>'
        },
        "cards-club": {
            body: '<path fill="currentColor" d="M12 2c2.3 0 4.3 2 4.3 4.2a4.445 4.445 0 0 1-2.26 3.8c1-.5 2.46-.5 2.46-.5c2.5 0 4.5 1.8 4.5 4.3S19 18 16.5 18c0 0-1.5 0-3.5-1c0 0-.3 2 2 5H9c2.3-3 2-5 2-5c-2 1-3.5 1-3.5 1C5 18 3 16.3 3 13.8s2-4.3 4.5-4.3c0 0 1.46 0 2.46.5c-.3-.17-2.17-1.23-2.26-3.8C7.7 4 9.7 2 12 2Z"/>'
        },
        "cards-club-outline": {
            body: '<path fill="currentColor" d="M16.6 9.5c.2-.6.4-1.3.4-2c0-3-2.2-5.5-5-5.5S7 4.5 7 7.5c0 .7.1 1.4.4 2c-2.5.1-4.4 1.9-4.4 4.3C3 16.3 5 18 7.5 18c0 0 2.5 0 3.5-1c0 0 .3 2-2 5h6c-2.3-3-2-5-2-5c1 1 3.5 1 3.5 1c2.5 0 4.5-1.7 4.5-4.2c0-2.4-1.9-4.2-4.4-4.3m-.1 6.5S14 16 13 15h-2c-1 1-3.5 1-3.5 1c-1.2 0-2.5-.7-2.5-2.2c0-1.3 1.1-2.3 2.5-2.3c.3 0 .8.1 1.3.2c.1 0 .2.1.3.1l.9-1.7c-.2-.2-.3-.4-.4-.6c-.4-.6-.6-1.2-.6-2C9 5.6 10.3 4 12 4s3 1.6 3 3.5c0 .8-.2 1.5-.6 2.1c-.1.2-.2.3-.3.5l.9 1.7c.1 0 .2-.1.3-.1c.4-.1.9-.2 1.3-.2c1.4 0 2.5 1 2.5 2.3c-.1 1.5-1.4 2.2-2.6 2.2Z"/>'
        },
        "cards-diamond": {
            body: '<path fill="currentColor" d="m19 12l-7 10l-7-10l7-10"/>'
        },
        "cards-diamond-outline": {
            body: '<path fill="currentColor" d="M12 2L5 12l7 10l7-10M7.44 12L12 5.5l4.56 6.5L12 18.5"/>'
        },
        "cards-heart": {
            body: '<path fill="currentColor" d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35Z"/>'
        },
        "cards-heart-outline": {
            body: '<path fill="currentColor" d="m12.1 18.55l-.1.1l-.11-.1C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5c1.54 0 3.04 1 3.57 2.36h1.86C13.46 6 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5c0 2.89-3.14 5.74-7.9 10.05M16.5 3c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z"/>'
        },
        "cards-outline": {
            body: '<path fill="currentColor" d="M11.19 2.25c-.26 0-.52.06-.77.15L3.06 5.45a1.994 1.994 0 0 0-1.09 2.6L6.93 20a2 2 0 0 0 1.81 1.25c.26 0 .53-.03.79-.15l7.37-3.05a2.02 2.02 0 0 0 1.23-1.8c.01-.25-.04-.54-.13-.8L13 3.5a1.954 1.954 0 0 0-1.81-1.25m3.48 0l3.45 8.35V4.25a2 2 0 0 0-2-2m4.01 1.54v9.03l2.43-5.86a1.99 1.99 0 0 0-1.09-2.6m-10.28-.14l4.98 12.02l-7.39 3.06L3.8 7.29"/>'
        },
        "cards-playing": {
            body: '<path fill="currentColor" d="M14.7 2.2h1.5c1.1 0 2 .9 2 2v6.4l-3.5-8.4m5.4 1.6l1.3.6c1 .4 1.5 1.6 1.1 2.6l-2.4 5.9V3.8M18 15.5l-5-12c-.3-.8-1-1.2-1.8-1.2c-.3 0-.5.1-.8.2L3 5.5C2 5.9 1.5 7 2 8l5 12c.3.8 1 1.2 1.8 1.2c.3 0 .5 0 .8-.2l7.4-3c.8-.3 1.2-1 1.2-1.8c-.1-.2-.1-.5-.2-.7m-6.6-.5l-3.2-2.4l.4-4l3.2 2.4l-.4 4"/>'
        },
        "cards-playing-club": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-3 13c-.6 0-1.1-.3-1.5-.7l1 2.7h-3l1-2.7c-.4.4-.9.7-1.5.7c-1.1 0-2-.9-2-2s.9-2 2-2h.3c-.2-.3-.3-.7-.3-1c0-1.1.9-2 2-2s2 .9 2 2c0 .4-.1.7-.3 1h.3c1.1 0 2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "cards-playing-club-multiple": {
            body: '<path fill="currentColor" d="M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m16-4H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m-3 13c-.6 0-1.1-.3-1.5-.7l1 2.7h-3l1-2.7c-.4.4-.9.7-1.5.7c-1.1 0-2-.9-2-2s.9-2 2-2h.3c-.2-.3-.3-.6-.3-1c0-1.1.9-2 2-2s2 .9 2 2c0 .4-.1.7-.3 1h.3c1.1 0 2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "cards-playing-club-multiple-outline": {
            body: '<path fill="currentColor" d="M19 0H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 18H9V2h10v16M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m11 2c-1.1 0-2 .9-2 2c0 .4.1.7.3 1H12c-1.1 0-2 .9-2 2s.9 2 2 2c.6 0 1.1-.3 1.5-.7l-1 2.7h3l-1-2.7c.4.4.9.7 1.5.7c1.1 0 2-.9 2-2s-.9-2-2-2h-.3c.2-.3.3-.6.3-1c0-1.1-.9-2-2-2Z"/>'
        },
        "cards-playing-club-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H7V4h10v16M12 8c-1.1 0-2 .9-2 2c0 .4.1.7.3 1H10c-1.1 0-2 .9-2 2s.9 2 2 2c.6 0 1.1-.3 1.5-.7l-1 2.7h3l-1-2.7c.4.4.9.7 1.5.7c1.1 0 2-.9 2-2s-.9-2-2-2h-.3c.2-.3.3-.7.3-1c0-1.1-.9-2-2-2Z"/>'
        },
        "cards-playing-diamond": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-5 15l-3-5l3-5l3 5l-3 5Z"/>'
        },
        "cards-playing-diamond-multiple": {
            body: '<path fill="currentColor" d="M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m16-4H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m-5 15l-3-5l3-5l3 5l-3 5Z"/>'
        },
        "cards-playing-diamond-multiple-outline": {
            body: '<path fill="currentColor" d="M19 0H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 18H9V2h10v16M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m11 1l-3 5l3 5l3-5l-3-5Z"/>'
        },
        "cards-playing-diamond-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H7V4h10v16M12 7l-3 5l3 5l3-5l-3-5Z"/>'
        },
        "cards-playing-heart": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-4.4 13.8l-.6.5l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6C8 10 9 9 10.2 9c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6Z"/>'
        },
        "cards-playing-heart-multiple": {
            body: '<path fill="currentColor" d="M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m16-4H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m-4.4 13.8l-.6.5l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6C10 8 11 7 12.2 7c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8C17 7 18 7.9 18 9.2c0 1.5-1.4 2.7-3.4 4.6Z"/>'
        },
        "cards-playing-heart-multiple-outline": {
            body: '<path fill="currentColor" d="M19 0H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 18H9V2h10v16M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m9.2 3C11 7 10 8 10 9.2c0 1.5 1.4 2.7 3.4 4.6l.6.5l.6-.5c2-1.9 3.4-3.1 3.4-4.6C18 7.9 17 7 15.8 7c-.7 0-1.4.3-1.8.8c-.4-.5-1.1-.8-1.8-.8Z"/>'
        },
        "cards-playing-heart-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H7V4h10v16M10.2 9C9 9 8 10 8 11.2c0 1.5 1.4 2.7 3.4 4.6l.6.5l.6-.5c2-1.9 3.4-3.1 3.4-4.6C16 9.9 15 9 13.8 9c-.7 0-1.4.3-1.8.8c-.4-.5-1.1-.8-1.8-.8Z"/>'
        },
        "cards-playing-outline": {
            body: '<path fill="currentColor" d="M11.19 2.25c.78.01 1.52.48 1.81 1.25l5 11.95c.09.26.14.55.13.8a2.02 2.02 0 0 1-1.23 1.8L9.53 21.1c-.26.12-.53.15-.79.15A2 2 0 0 1 6.93 20L1.97 8.05c-.42-1.01.07-2.18 1.09-2.6l7.36-3.05c.25-.09.51-.15.77-.15m3.48 0h1.45a2 2 0 0 1 2 2v6.35l-3.45-8.35m5.46 1.54l1.34.57a1.99 1.99 0 0 1 1.09 2.6l-2.43 5.86V3.79m-8.94.43L3.8 7.29L8.77 19.3l7.4-3.06l-4.98-12.02M8.65 8.54l3.23 2.41l-.44 4.01l-3.23-2.42l.44-4Z"/>'
        },
        "cards-playing-spade": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-3.2 13c-.4 0-.8-.1-1.2-.3l.9 2.3h-3l.9-2.3c-.4.2-.8.3-1.2.3C9 15 8 14 8 12.8c0-1.5 1.4-2.7 3.4-4.6l.6-.5l.6.5c2 1.9 3.4 3.1 3.4 4.6c0 1.3-1 2.2-2.2 2.2Z"/>'
        },
        "cards-playing-spade-multiple": {
            body: '<path fill="currentColor" d="M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m16-4H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m-3.2 13c-.4 0-.8-.1-1.2-.3l.9 2.3h-3l.9-2.3c-.4.2-.8.3-1.2.3c-1.2 0-2.2-1-2.2-2.2c0-1.5 1.4-2.7 3.4-4.6l.6-.5l.6.5c2 1.9 3.4 3.1 3.4 4.6c0 1.3-1 2.2-2.2 2.2Z"/>'
        },
        "cards-playing-spade-multiple-outline": {
            body: '<path fill="currentColor" d="M19 0H9C7.9 0 7 .9 7 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 18H9V2h10v16M3 4v18c0 1.1.9 2 2 2h12v-2H5V4H3m11 1.7l-.6.5c-2 1.9-3.4 3.1-3.4 4.6c0 1.2 1 2.2 2.2 2.2c.4 0 .8-.1 1.2-.3l-.9 2.3h3l-.9-2.3c.3.2.8.3 1.2.3c1.2 0 2.2-.9 2.2-2.2c0-1.5-1.4-2.7-3.4-4.6l-.6-.5Z"/>'
        },
        "cards-playing-spade-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H7V4h10v16M12 7.7l-.6.5c-2 1.9-3.4 3.1-3.4 4.6C8 14 9 15 10.2 15c.4 0 .8-.1 1.2-.3l-.9 2.3h3l-.9-2.3c.3.2.8.3 1.2.3c1.2 0 2.2-.9 2.2-2.2c0-1.5-1.4-2.7-3.4-4.6l-.6-.5Z"/>'
        },
        "cards-spade": {
            body: '<path fill="currentColor" d="M12 2C9 7 4 9 4 14c0 2 2 4 4 4c1 0 2 0 3-1c0 0 .32 2-2 5h6c-2-3-2-5-2-5c1 1 2 1 3 1c2 0 4-2 4-4c0-5-5-7-8-12Z"/>'
        },
        "cards-spade-outline": {
            body: '<path fill="currentColor" d="M11 17s.3 2-2 5h6c-2.3-3-2-5-2-5s1 1 3 1s4-2 4-4c0-5-5-7-8-12c-3 5-8 7-8 12c0 2 2 4 4 4s3-1 3-1m2-3h-2s-1 2-3 2c-.9 0-2-1.1-2-2c-.2-3 3.9-5.8 6-8.6c2.1 2.7 6.2 5.5 6 8.6c0 .9-1.1 2-2 2c-2 0-3-2-3-2Z"/>'
        },
        "cards-variant": {
            body: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m1 2v8h12V4H6m14 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16v1m0 4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16v1Z"/>'
        },
        carrot: {
            body: '<path fill="currentColor" d="m16 10l-.2 1h-2.3a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5h2.1l-1 5h-2.1a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5h1.9l-.4 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2l-1-5h1.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5H8.8L8 10c0-1.2.93-2.23 2.29-2.71L8.9 5.28a.997.997 0 0 1 .26-1.39a.998.998 0 0 1 1.39.25l.45.66V3a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2.28l1.5-1.74c.33-.42.97-.47 1.39-.11c.42.35.47.98.11 1.41l-2.13 2.51C15.14 7.85 16 8.85 16 10Z"/>'
        },
        cart: {
            body: '<path fill="currentColor" d="M17 18c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M1 2v2h2l3.6 7.59l-1.36 2.45c-.15.28-.24.61-.24.96a2 2 0 0 0 2 2h12v-2H7.42a.25.25 0 0 1-.25-.25c0-.05.01-.09.03-.12L8.1 13h7.45c.75 0 1.41-.42 1.75-1.03l3.58-6.47c.07-.16.12-.33.12-.5a1 1 0 0 0-1-1H5.21l-.94-2M7 18c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "cart-arrow-down": {
            body: '<path fill="currentColor" d="M10 0v4H8l4 4l4-4h-2V0M1 2v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2M7 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2Z"/>'
        },
        "cart-arrow-right": {
            body: '<path fill="currentColor" d="M9 20a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2m8-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-9.8-3.37c-.01.04-.01.08 0 .12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.07-.69.24-1l1.36-2.41L3 4H1V2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5L17.3 12c-.36.62-1.03 1-1.75 1H8.1l-.9 1.63M9 9.5h4v2l3-3l-3-3v2H9v2Z"/>'
        },
        "cart-arrow-up": {
            body: '<path fill="currentColor" d="M12 0L8 4h2v4h4V4h2M1 2v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2M7 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2Z"/>'
        },
        "cart-check": {
            body: '<path fill="currentColor" d="M9 20c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m8-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-9.8-3.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2H1v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2M18 2.8l-1.4-1.4l-4.8 4.8l-2.6-2.6L7.8 5l4 4L18 2.8Z"/>'
        },
        "cart-heart": {
            body: '<path fill="currentColor" d="M9 20c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m8-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-9.8-3.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2H1v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2M12 9.3l-.6-.5C9.4 6.9 8 5.7 8 4.2C8 3 9 2 10.2 2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8C15 2 16 2.9 16 4.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5Z"/>'
        },
        "cart-minus": {
            body: '<path fill="currentColor" d="M16 6V4H8v2M7 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-9.8-3.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2H1v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2Z"/>'
        },
        "cart-off": {
            body: '<path fill="currentColor" d="M22.73 22.73L1.27 1.27L0 2.54l4.39 4.39l2.21 4.66l-1.35 2.45c-.16.28-.25.61-.25.96a2 2 0 0 0 2 2h7.46l1.38 1.38c-.5.36-.84.95-.84 1.62a2 2 0 0 0 2 2c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27M7.42 15a.25.25 0 0 1-.25-.25l.03-.12l.9-1.63h2.36l2 2H7.42m8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.47c.08-.16.12-.33.12-.5a1 1 0 0 0-1-1H6.54l9.01 9M7 18a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "cart-outline": {
            body: '<path fill="currentColor" d="M17 18a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63l-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7l2.78-5H6.14l2.36 5H16Z"/>'
        },
        "cart-percent": {
            body: '<path fill="currentColor" d="M7 18c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m10 0c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m-9.8-3.2c0 .1.1.2.2.2H19v2H7c-1.1 0-2-.9-2-2c0-.4.1-.7.2-1l1.3-2.4L3 4H1V2h3.3l4.3 9h7l3.9-7l1.7 1l-3.9 7c-.3.6-1 1-1.7 1H8.1l-.9 1.6v.2M9.4 1c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4S8 3.2 8 2.4S8.7 1 9.4 1m5.2 8c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4s1.4.6 1.4 1.4S15.3 9 14.6 9M9.2 9L8 7.8L14.8 1L16 2.2L9.2 9"/>'
        },
        "cart-plus": {
            body: '<path fill="currentColor" d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3M7 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-9.8-3.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2H1v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2Z"/>'
        },
        "cart-remove": {
            body: '<path fill="currentColor" d="M14.1 8.5L12 6.4L9.9 8.5L8.5 7.1L10.6 5L8.5 2.9l1.4-1.4L12 3.6l2.1-2.1l1.4 1.4L13.4 5l2.1 2.1l-1.4 1.4M7 18c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m10 0c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m-9.8-3.2c0 .1.1.2.2.2H19v2H7c-1.1 0-2-.9-2-2c0-.4.1-.7.2-1l1.3-2.4L3 4H1V2h3.3l4.3 9h7l3.9-7l1.7 1l-3.9 7c-.3.6-1 1-1.7 1H8.1l-.9 1.6v.2Z"/>'
        },
        "cart-variant": {
            body: '<path fill="currentColor" d="M19 20c0 1.11-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2M7 18c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2c1.11 0 2-.89 2-2s-.89-2-2-2m.2-3.37l-.03.12c0 .14.11.25.25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2h3.27l.94 2H20c.55 0 1 .45 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63M8.5 11H10V9H7.56l.94 2M11 9v2h3V9h-3m3-1V6h-3v2h3m3.11 1H15v2h1l1.11-2m1.67-3H15v2h2.67l1.11-2M6.14 6l.94 2H10V6H6.14Z"/>'
        },
        "case-sensitive-alt": {
            body: '<path fill="currentColor" d="M20 14c0-1.5-.5-2-2-2h-2v-1c0-1 0-1-2-1v9h4c1.5 0 2-.53 2-2v-3m-8-2c0-1.5-.53-2-2-2H6c-1.5 0-2 .5-2 2v7h2v-3h4v3h2v-7m-2-5h4V5h-4v2m12 2v11c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V9c0-1.11.89-2 2-2h4V5l2-2h4l2 2v2h4a2 2 0 0 1 2 2m-6 8h2v-3h-2v3M6 12h4v2H6v-2Z"/>'
        },
        cash: {
            body: '<path fill="currentColor" d="M3 6h18v12H3V6m9 3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3M7 8a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2v-4a2 2 0 0 1-2-2H7Z"/>'
        },
        "cash-100": {
            body: '<path fill="currentColor" d="M2 5h20v15H2V5m18 13V7H4v11h16M17 8a2 2 0 0 0 2 2v5a2 2 0 0 0-2 2H7a2 2 0 0 0-2-2v-5a2 2 0 0 0 2-2h10m0 5v-1c0-1.1-.67-2-1.5-2s-1.5.9-1.5 2v1c0 1.1.67 2 1.5 2s1.5-.9 1.5-2m-1.5-2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5M13 13v-1c0-1.1-.67-2-1.5-2s-1.5.9-1.5 2v1c0 1.1.67 2 1.5 2s1.5-.9 1.5-2m-1.5-2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5M8 15h1v-5H8l-1 .5v1l1-.5v4Z"/>'
        },
        "cash-100-custom": {
            body: '<path fill="currentColor" d="M5 8H7V16H5V8ZM12 8H9C8.45 8 8 8.45 8 9V15C8 15.55 8.45 16 9 16H12C12.55 16 13 15.55 13 15V9C13 8.45 12.55 8 12 8ZM11 14H10V10H11V14ZM18 8H15C14.45 8 14 8.45 14 9V15C14 15.55 14.45 16 15 16H18C18.55 16 19 15.55 19 15V9C19 8.45 18.55 8 18 8ZM17 14H16V10H17V14Z"/><path fill="currentColor" d="M2 4V20H22V4H2ZM4 18V6H20V18H4Z"/>'
        },
        "cash-check": {
            body: '<path fill="currentColor" d="M3 6v12h10.32a6.38 6.38 0 0 1-.32-2H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3m9 3c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16C14.85 10.28 13.59 8.97 12 9m9.63 3.27l-3.87 3.9l-1.35-1.37L15 16.22L17.75 19l5.28-5.32l-1.4-1.41Z"/>'
        },
        "cash-clock": {
            body: '<path fill="currentColor" d="m17.5 16.82l2.44 1.41l-.75 1.3L16 17.69V14h1.5v2.82M24 17c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-.34.03-.67.08-1H2V4h18v6.68c2.36 1.13 4 3.53 4 6.32m-13.32-3c.18-.36.37-.7.6-1.03c-.09.03-.18.03-.28.03c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3c0 .25-.04.5-.1.73c.94-.46 1.99-.73 3.1-.73c.34 0 .67.03 1 .08V8a2 2 0 0 1-2-2H6c0 1.11-.89 2-2 2v4a2 2 0 0 1 2 2h4.68M22 17c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "cash-fast": {
            body: '<path fill="currentColor" d="M17.12 9.88a2.997 2.997 0 1 0-4.24 4.24a2.997 2.997 0 1 0 4.24-4.24M7 6v12h16V6H7m14 8c-.53 0-1.04.21-1.41.59c-.38.37-.59.88-.59 1.41h-8c0-.53-.21-1.04-.59-1.41c-.37-.38-.88-.59-1.41-.59v-4c.53 0 1.04-.21 1.41-.59c.38-.37.59-.88.59-1.41h8c0 .53.21 1.04.59 1.41c.37.38.88.59 1.41.59v4M5 8H3c-.55 0-1-.45-1-1s.45-1 1-1h2v2m0 5H2c-.55 0-1-.45-1-1s.45-1 1-1h3v2m0 5H1c-.552 0-1-.45-1-1s.448-1 1-1h4v2Z"/>'
        },
        "cash-lock": {
            body: '<path fill="currentColor" d="M21.8 15c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V15m-1.3 0v-1.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V15h3M2 6h18v3.1L19 9c-.82 0-1.59.2-2.27.54C16.28 9.18 16 8.62 16 8H6c0 1.11-.89 2-2 2v4a2 2 0 0 1 2 2h7.04l-.04.5V18H2V6m9 3c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3Z"/>'
        },
        "cash-lock-open": {
            body: '<path fill="currentColor" d="M21.8 16c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h4.3M2 6h18v3.1L19 9c-.82 0-1.59.2-2.27.54C16.28 9.18 16 8.62 16 8H6c0 1.11-.89 2-2 2v4a2 2 0 0 1 2 2h7.04l-.04.5V18H2V6m9 3c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3Z"/>'
        },
        "cash-marker": {
            body: '<path fill="currentColor" d="M18.5 16.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2m0-4.8c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m-3.6-.7C14.6 10 13.4 9 12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c.4 0 .7-.1 1-.2c.2-1.4.9-2.6 1.9-3.5M13 16H7a2 2 0 0 0-2-2v-4a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2s1 0 2 .6V6H3v12h10.5c-.2-.7-.4-1.3-.5-2Z"/>'
        },
        "cash-minus": {
            body: '<path fill="currentColor" d="M15 15v2h8v-2m-8.03-3.39C14.85 10.28 13.59 8.97 12 9c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16M13 16H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3v12h10.32a6.38 6.38 0 0 1-.32-2Z"/>'
        },
        "cash-multiple": {
            body: '<path fill="currentColor" d="M5 6h18v12H5V6m9 3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3M9 8a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2v-4a2 2 0 0 1-2-2H9m-8 2h2v10h16v2H1V10Z"/>'
        },
        "cash-plus": {
            body: '<path fill="currentColor" d="M15 15v2h3v3h2v-3h3v-2h-3v-3h-2v3m-3.03-3.39C14.85 10.28 13.59 8.97 12 9c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16M13 16H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3v12h10.32a6.38 6.38 0 0 1-.32-2Z"/>'
        },
        "cash-refund": {
            body: '<path fill="currentColor" d="M12.3 8.93L9.88 6.5h5.62V10H17V5H9.88l2.42-2.43l-1.06-1.07L7 5.75L11.24 10l1.06-1.07M12 14a3 3 0 1 0 3 3a3 3 0 0 0-3-3m-9-3v12h18V11m-2 8a2 2 0 0 0-2 2H7a2 2 0 0 0-2-2v-4a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2Z"/>'
        },
        "cash-register": {
            body: '<path fill="currentColor" d="M2 17h20v4H2v-4M6.25 7H9V6H6V3h8v3h-3v1h6.8c1 0 2 1 2.2 2l.5 7h-17l.55-7c0-1 1-2 2.2-2M13 9v2h5V9h-5M6 9v1h2V9H6m3 0v1h2V9H9m-3 2v1h2v-1H6m3 0v1h2v-1H9m-3 2v1h2v-1H6m3 0v1h2v-1H9M7 4v1h6V4H7Z"/>'
        },
        "cash-remove": {
            body: '<path fill="currentColor" d="m15.46 18.12l1.42 1.42L19 17.41l2.12 2.13l1.42-1.42L20.41 16l2.13-2.12l-1.42-1.42L19 14.59l-2.12-2.13l-1.42 1.42L17.59 16m-2.62-4.38C14.86 10.28 13.58 8.97 12 9c-1.7.04-3 1.3-3 3s1.3 2.94 3 3c.39 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.15M13 16H7c0-1.1-.9-2-2-2v-4c1.1 0 2-.9 2-2h10c0 1.1.9 2 2 2v.05c.67.01 1.34.13 2 .35V6H3v12h10.32a6.38 6.38 0 0 1-.32-2Z"/>'
        },
        "cash-sync": {
            body: '<path fill="currentColor" d="M3 6v12h10.32a6.38 6.38 0 0 1-.32-2H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3m9 3c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16C14.85 10.28 13.59 8.97 12 9m7 2l2.25 2.25L19 15.5V14c-1.85 0-3.06 1.96-2.24 3.62l-1.09 1.09c-1.76-2.66.14-6.21 3.33-6.21V11m0 11l-2.25-2.25L19 17.5V19c1.85 0 3.06-1.96 2.24-3.62l1.09-1.09c1.76 2.66-.14 6.21-3.33 6.21V22"/>'
        },
        "cash-usd": {
            body: '<path d="M20 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V6a2 2 0 0 0-2-2m-5 6h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1V7h2v1h2v2z" fill="currentColor"/>',
            hidden: true
        },
        "cash-usd-outline": {
            body: '<path d="M20 18H4V6h16m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-9 13h2v-1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3v-1h4V8h-2V7h-2v1h-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3v1H9v2h2v1z" fill="currentColor"/>',
            hidden: true
        },
        cassette: {
            body: '<path fill="currentColor" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2l1-2h10l1 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m2.5 5A1.5 1.5 0 0 1 8 11.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 5 11.5A1.5 1.5 0 0 1 6.5 10M9 10h6v3H9v-3m8.5 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        cast: {
            body: '<path fill="currentColor" d="M1 10v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11m0 4v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0 4v3h3a3 3 0 0 0-3-3M21 3H3c-1.11 0-2 .89-2 2v3h2V5h18v14h-7v2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "cast-audio": {
            body: '<path fill="currentColor" d="M2 11v2c5 0 9 4 9 9h2c0-6.1-4.9-11-11-11m18-9H10c-1.1 0-2 .9-2 2v6.5c1 .5 1.9 1.2 2.7 1.9c.9-1.4 2.5-2.4 4.3-2.4c2.8 0 5 2.2 5 5s-2.2 5-5 5h-.2c.1.7.2 1.3.2 2h5c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-5 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0 10c-.2 0-.5 0-.7-.1c-.5-1.5-1.2-2.8-2.1-4c.4-1.1 1.5-2 2.8-2c1.7 0 3 1.3 3 3S16.7 18 15 18M2 15v2c2.8 0 5 2.2 5 5h2c0-3.9-3.1-7-7-7m0 4v3h3c0-1.7-1.3-3-3-3"/>'
        },
        "cast-audio-variant": {
            body: '<path fill="currentColor" d="M14.5 12a2.5 2.5 0 0 0-5 0c0 1 .59 1.84 1.43 2.25l-1.11 1.1A3.999 3.999 0 0 1 12 8a3.999 3.999 0 0 1 2.18 7.35l-1.1-1.1c.84-.41 1.42-1.25 1.42-2.25M12 2C6.5 2 2 6.5 2 12c0 3.06 1.38 5.8 3.54 7.63l1.07-1.06C4.71 17 3.5 14.64 3.5 12c0-4.69 3.81-8.5 8.5-8.5c4.69 0 8.5 3.81 8.5 8.5c0 2.64-1.21 5-3.11 6.57l1.07 1.06C20.62 17.79 22 15.06 22 12c0-5.5-4.5-10-10-10m7 10c0-3.87-3.13-7-7-7a6.995 6.995 0 0 0-4.32 12.5l1.07-1.07C7.39 15.42 6.5 13.82 6.5 12c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5c0 1.82-.89 3.42-2.25 4.43l1.08 1.07A7.004 7.004 0 0 0 19 12M6 22h12l-6-6l-6 6Z"/>'
        },
        "cast-connected": {
            body: '<path fill="currentColor" d="M21 3H3c-1.11 0-2 .89-2 2v3h2V5h18v14h-7v2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M1 10v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11m18-3H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19M1 14v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0 4v3h3a3 3 0 0 0-3-3Z"/>'
        },
        "cast-education": {
            body: '<path fill="currentColor" d="M21 3H3a2 2 0 0 0-2 2v3h2V5h18v14h-7v2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M1 18v3h3a3 3 0 0 0-3-3m0-4v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0-4v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11m10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13L11 11.09M14.5 6L9 9l5.5 3L20 9l-5.5-3Z"/>'
        },
        "cast-off": {
            body: '<path fill="currentColor" d="M1.6 1.27L.25 2.75L1.41 3.8C1.16 4.13 1 4.55 1 5v3h2V5.23L18.2 19H14v2h6.41l1.9 1.72l1.34-1.48M6.5 3l2.2 2H21v11.14l2 1.81V5a2 2 0 0 0-2-2M1 10v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11m0 4v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0 4v3h3a3 3 0 0 0-3-3Z"/>'
        },
        "cast-variant": {
            body: '<path fill="currentColor" d="M6 22h12l-6-6m9-13H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-2H3V5h18v12h-4v2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        castle: {
            body: '<path fill="currentColor" d="M2 13h2v2h2v-2h2v2h2v-2h2v2h2v-5l3-3V1h2l4 2l-4 2v2l3 3v12H11v-3a2 2 0 0 0-2-2a2 2 0 0 0-2 2v3H2v-9m16-3c-.55 0-1 .54-1 1.2V13h2v-1.8c0-.66-.45-1.2-1-1.2Z"/>'
        },
        cat: {
            body: '<path fill="currentColor" d="m12 8l-1.33.09C9.81 7.07 7.4 4.5 5 4.5c0 0-1.97 2.96-.04 6.91c-.55.83-.89 1.26-.96 2.25l-1.93.29l.21.98l1.76-.26l.14.71l-1.57.94l.47.89l1.45-.89C5.68 18.76 8.59 20 12 20s6.32-1.24 7.47-3.68l1.45.89l.47-.89l-1.57-.94l.14-.71l1.76.26l.21-.98l-1.93-.29c-.07-.99-.41-1.42-.96-2.25C20.97 7.46 19 4.5 19 4.5c-2.4 0-4.81 2.57-5.67 3.59L12 8m-3 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 3h2l-.7 1.39c.2.64.76 1.11 1.45 1.11a1.5 1.5 0 0 0 1.5-1.5h.5a2 2 0 0 1-2 2c-.75 0-1.4-.41-1.75-1c-.35.59-1 1-1.75 1a2 2 0 0 1-2-2h.5a1.5 1.5 0 0 0 1.5 1.5c.69 0 1.25-.47 1.45-1.11L11 14Z"/>'
        },
        cctv: {
            body: '<path fill="currentColor" d="m6.03 12.03l2 3.47l-2.53 3.18L2 12.62l4.03-.59M17 18v-2.71c.88-.39 1.5-1.26 1.5-2.29c0-.57-.2-1.1-.53-1.5l1.97-1.15c1.01-.59 1.36-1.88.77-2.89l-1.38-2.4a2.125 2.125 0 0 0-2.89-.78L8.31 9c-.95.53-1.28 1.75-.73 2.71l1.5 2.6c.55.95 1.78 1.28 2.73.73l1.88-1.08c.25.59.72 1.07 1.31 1.33V18c0 1.1.9 2 2 2h5v-2h-5Z"/>'
        },
        "cctv-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.11 20H17c-1.1 0-2-.9-2-2v-1.11l-2.34-2.34l-.85.49c-.95.55-2.18.22-2.73-.73l-1.5-2.6c-.4-.71-.33-1.53.1-2.14L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M18.5 13c0-.57-.2-1.1-.53-1.5l1.97-1.15c1.01-.59 1.36-1.88.77-2.89l-1.38-2.4a2.125 2.125 0 0 0-2.89-.78l-5.67 3.29l7.09 7.09c.4-.44.64-1.02.64-1.66M2 12.62l3.5 6.06l2.53-3.18l-2-3.47l-4.03.59Z"/>'
        },
        "ceiling-fan": {
            body: '<path fill="currentColor" d="M8 3v2h3v5.27c-.62.36-1 1.02-1 1.73v1h4v-1c0-.71-.38-1.37-1-1.73V5h3V3H8m-2 9c-2.21 0-4 .67-4 1.5S3.79 15 6 15s4-.67 4-1.5S8.21 12 6 12m12 0c-2.21 0-4 .67-4 1.5s1.79 1.5 4 1.5s4-.67 4-1.5s-1.79-1.5-4-1.5m-8 2v1c0 .72.38 1.38 1 1.73c.62.36 1.38.36 2 0c.62-.35 1-1.02 1-1.73v-1h-4Z"/>'
        },
        "ceiling-fan-light": {
            body: '<path fill="currentColor" d="M8 3v2h3v5.27c-.62.36-1 1.02-1 1.73v1h4v-1c0-.71-.38-1.37-1-1.73V5h3V3H8m-2 9c-2.21 0-4 .67-4 1.5S3.79 15 6 15s4-.67 4-1.5S8.21 12 6 12m12 0c-2.21 0-4 .67-4 1.5s1.79 1.5 4 1.5s4-.67 4-1.5s-1.79-1.5-4-1.5m-8 2v1c0 .72.38 1.38 1 1.73c.62.36 1.38.36 2 0c.62-.35 1-1.02 1-1.73v-1h-4m3 5v3h-2v-3h2m2.88-2.54L18 18.59L16.59 20l-2.12-2.12l1.41-1.42m-6.34 1.42L7.41 20L6 18.59l2.12-2.12l1.42 1.41"/>'
        },
        "ceiling-light": {
            body: '<path fill="currentColor" d="M8 9h3V4h2v5h3l4 8H4l4-8m6 9a2 2 0 0 1-2 2a2 2 0 0 1-2-2h4Z"/>'
        },
        "ceiling-light-multiple": {
            body: '<path fill="currentColor" d="M10 11h3V6h2v5h3l4 8H6l4-8m6 9c0 1.11-.89 2-2 2s-2-.89-2-2h4m-7.79-9.89L8.76 9H11V2H9v5H6l-4 8h3.76l2.45-4.89Z"/>'
        },
        "ceiling-light-multiple-outline": {
            body: '<path fill="currentColor" d="m16.76 13l2 4H9.24l2-4h5.52M15 6h-2v5h-3l-4 8h16l-4-8h-3V6m1 14c0 1.11-.89 2-2 2s-2-.89-2-2h4m-7.79-9.89L8.76 9H11V2H9v5H6l-4 8h3.76l2.45-4.89Z"/>'
        },
        "ceiling-light-outline": {
            body: '<path fill="currentColor" d="m14.76 11l2 4H7.24l2-4h5.52M13 4h-2v5H8l-4 8h16l-4-8h-3V4m1 14h-4a2 2 0 1 0 4 0Z"/>'
        },
        cellphone: {
            body: '<path fill="currentColor" d="M17 19H7V5h10m0-4H7c-1.11 0-2 .89-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "cellphone-android": {
            body: '<path d="M17.25 18H6.75V4h10.5M14 21h-4v-1h4m2-19H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z" fill="currentColor"/>',
            hidden: true
        },
        "cellphone-arrow-down": {
            body: '<path fill="currentColor" d="M17 1H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 18H7V5h10v14m-1-6h-3V8h-2v5H8l4 4l4-4Z"/>'
        },
        "cellphone-arrow-down-variant": {
            body: '<path fill="currentColor" d="m18 14l5-5l-1.4-1.4l-2.6 2.6V3h-2v7.2l-2.6-2.6L13 9l5 5m1 2v5c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h7v4H7v14h10v-3h2Z"/>'
        },
        "cellphone-basic": {
            body: '<path fill="currentColor" d="M15 2a1 1 0 0 0-1 1v3h-4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h5c1.11 0 2-.89 2-2V8c0-.74-.4-1.38-1-1.72V3a1 1 0 0 0-1-1m-5 6h5v5h-5V8m0 7h1v1h-1v-1m2 0h1v1h-1v-1m2 0h1v1h-1v-1m-4 2h1v1h-1v-1m2 0h1v1h-1v-1m2 0h1v1h-1v-1m-4 2h1v1h-1v-1m2 0h1v1h-1v-1m2 0h1v1h-1v-1Z"/>'
        },
        "cellphone-charging": {
            body: '<path fill="currentColor" d="M11 18.5V13H9l4-7.5V11h2m2 8H7V5h10m0-4H7c-1.11 0-2 .89-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "cellphone-check": {
            body: '<path fill="currentColor" d="M14.54 23H7a2 2 0 0 1-2-2V3c0-1.11.89-2 2-2h10a2 2 0 0 1 2 2v10c-.7 0-1.37.13-2 .35V5H7v14h6c0 1.54.58 2.94 1.54 4m3.21-.84l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41l-4.75 4.75"/>'
        },
        "cellphone-cog": {
            body: '<path fill="currentColor" d="M9.82 12.5c.02-.17.04-.33.04-.5c0-.17-.02-.33-.04-.5l1.08-.81c.1-.07.1-.19.06-.32L9.93 8.64c-.06-.11-.2-.14-.31-.11l-1.28.5c-.27-.2-.56-.36-.87-.49l-.2-1.33c0-.12-.11-.21-.24-.21H5c-.15 0-.26.09-.28.21L4.5 8.53c-.29.12-.58.3-.85.47l-1.28-.5c-.12-.03-.25 0-.31.13l-1.03 1.73c-.06.14-.03.25.07.33l1.08.81c-.02.17-.03.34-.03.5c0 .17.02.33.04.5l-1.09.82c-.1.07-.1.21-.06.32l1.03 1.73c.06.13.2.13.31.13l1.28-.5c.27.18.56.34.87.47l.2 1.32c.01.12.12.21.27.21h2.04c.13 0 .24-.09.25-.21l.21-1.32c.3-.12.59-.3.86-.47l1.28.5c.12.03.25 0 .31-.13L11 13.64c.04-.11 0-.24-.08-.32l-1.1-.82M6 13.75c-1 0-1.8-.78-1.8-1.75S5 10.25 6 10.25s1.8.78 1.8 1.75S7 13.75 6 13.75M17 1H7a2 2 0 0 0-2 2v3h2V4h10v16H7v-2H5v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "cellphone-dock": {
            body: '<path fill="currentColor" d="M16 15H8V5h8m0-4H8c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M8 23h8v-2H8v2Z"/>'
        },
        "cellphone-information": {
            body: '<path fill="currentColor" d="M13 7h-2v2h2V7m0 4h-2v6h2v-6m4-10H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2m0 18H7V5h10v14Z"/>'
        },
        "cellphone-iphone": {
            body: '<path d="M16 18H7V4h9m-4.5 18a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m4-21h-8A2.5 2.5 0 0 0 5 3.5v17A2.5 2.5 0 0 0 7.5 23h8a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 15.5 1z" fill="currentColor"/>',
            hidden: true
        },
        "cellphone-key": {
            body: '<path fill="currentColor" d="M7 1c-1.1 0-2 .9-2 2v4h2V4h10v16H7v-3H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7M6 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H11v2h2v-2h2v-2H8.8C8.4 9.8 7.3 9 6 9m0 2c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1Z"/>'
        },
        "cellphone-link": {
            body: '<path fill="currentColor" d="M22 17h-4v-7h4m1-2h-6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1M4 6h18V4H4a2 2 0 0 0-2 2v11H0v3h14v-3H4V6Z"/>'
        },
        "cellphone-link-off": {
            body: '<path fill="currentColor" d="M23 8h-6a1 1 0 0 0-1 1v4.18l2 2V10h4v7h-2.18l3 3H23a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1M4 6.27L14.73 17H4V6.27M1.92 1.65L.65 2.92l1.82 1.82A1.9 1.9 0 0 0 2 6v11H0v3h17.73l2.35 2.35l1.27-1.27L3.89 3.62L1.92 1.65M22 6V4H6.82l2 2H22Z"/>'
        },
        "cellphone-lock": {
            body: '<path fill="currentColor" d="M17 1H7a2 2 0 0 0-2 2v3h2V4h10v16H7v-2H5v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M8.8 11V9.5C8.8 8.1 7.4 7 6 7S3.2 8.1 3.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11Z"/>'
        },
        "cellphone-marker": {
            body: '<path fill="currentColor" d="M18.5 13c-1.9 0-3.5 1.61-3.5 3.5c0 2.61 3.5 6.5 3.5 6.5s3.5-3.89 3.5-6.5c0-1.89-1.6-3.5-3.5-3.5m0 4.81c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.59 1.2 1.2c.1.6-.5 1.2-1.2 1.2M15.91 23H7a2 2 0 0 1-2-2V3c0-1.11.89-2 2-2h10a2 2 0 0 1 2 2v8.03c-.16-.03-.33-.03-.5-.03c-.5 0-1 .08-1.5.22V5H7v14h6.54c.6 1.5 1.58 2.97 2.37 4Z"/>'
        },
        "cellphone-message": {
            body: '<path fill="currentColor" d="M11 17V7H4v10h7m0-14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7m5.5 0h5A1.5 1.5 0 0 1 23 4.5v3A1.5 1.5 0 0 1 21.5 9H18l-3 3V4.5A1.5 1.5 0 0 1 16.5 3Z"/>'
        },
        "cellphone-message-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l1.11 1.11C2.08 4.38 2 4.68 2 5v14a2 2 0 0 0 2 2h7c1.1 0 2-.9 2-2v-4.11l7.84 7.84l1.27-1.27L2.39 1.73M11 17H4V7h1.11L11 12.89V17M23 4.5v3c0 .83-.67 1.5-1.5 1.5H18l-2.9 2.9l-.1-.1V4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5M10.2 7l-4-4H11c1.1 0 2 .9 2 2v4.8l-2-2V7h-.8"/>'
        },
        "cellphone-nfc": {
            body: '<path fill="currentColor" d="M2 16v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m0 4v3h3a3 3 0 0 0-3-3m0-8v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11M17 1H7a2 2 0 0 0-2 2v7.37c.69.16 1.36.37 2 .63V5h10v13h-3.03c.53 1.25.84 2.59.95 4H17a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "cellphone-nfc-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-1.99-1.99C18.56 21.5 17.84 22 17 22h-2.08c-.11-1.41-.42-2.75-.95-4h2.14L7 8.89V11c-.64-.26-1.31-.47-2-.63V6.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M17 5v8.8l2 2V3a2 2 0 0 0-2-2H7c-.76 0-1.41.43-1.75 1.05L8.2 5H17M2 20v3h3c0-1.66-1.34-3-3-3m0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7m0-4v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11Z"/>'
        },
        "cellphone-off": {
            body: '<path fill="currentColor" d="M2.38 1.73L1.11 3L5 6.89V21a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-.11l1.84 1.84l1.27-1.27M17 19H7V8.89l10 10V19m0-14v8.8l2 2V3a2 2 0 0 0-2-2H7c-.72 0-1.4.37-1.76 1l3 3H17Z"/>'
        },
        "cellphone-play": {
            body: '<path fill="currentColor" d="M17 19H7V5h10m0-4H7c-1.11 0-2 .89-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3a2 2 0 0 0-2-2m-7 8v6l4-3l-4-3Z"/>'
        },
        "cellphone-remove": {
            body: '<path fill="currentColor" d="m22.54 16.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12m-8 6.12H7a2 2 0 0 1-2-2V3c0-1.11.89-2 2-2h10a2 2 0 0 1 2 2v10c-.7 0-1.37.13-2 .35V5H7v14h6c0 1.54.58 2.94 1.54 4Z"/>'
        },
        "cellphone-screenshot": {
            body: '<path fill="currentColor" d="M7 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H7m0 3h10v16H7V4m2 2v4h1.5V7.5H13V6H9m4.5 8v2.5H11V18h4v-4h-1.5Z"/>'
        },
        "cellphone-settings": {
            body: '<path fill="currentColor" d="M16 16H8V4h8m0-4H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-1 24h2v-2h-2m-4 2h2v-2h-2m-4 2h2v-2H7v2Z"/>'
        },
        "cellphone-sound": {
            body: '<path fill="currentColor" d="M19.1 8.7c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5l-1 1M18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3M14 1H4a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 19H4V4h10v16Z"/>'
        },
        "cellphone-text": {
            body: '<path fill="currentColor" d="M17 19V5H7v14h10m0-18a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3c0-1.11.89-2 2-2h10M9 7h6v2H9V7m0 4h4v2H9v-2Z"/>'
        },
        "cellphone-wireless": {
            body: '<path fill="currentColor" d="M20.07 4.93A9.969 9.969 0 0 1 23 12c0 2.76-1.12 5.26-2.93 7.07l-1.41-1.41A7.938 7.938 0 0 0 21 12c0-2.21-.89-4.22-2.34-5.66l1.41-1.41m-2.83 2.83A5.98 5.98 0 0 1 19 12c0 1.65-.67 3.15-1.76 4.24l-1.41-1.41A3.99 3.99 0 0 0 17 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41M13 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-1.5-9A2.5 2.5 0 0 1 14 3.5V8h-2V4H3v15h9v-3h2v4.5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 1 20.5v-17A2.5 2.5 0 0 1 3.5 1h8Z"/>'
        },
        centos: {
            body: '<path fill="currentColor" d="M19.07 14.93L22 12l-2.93-2.93V4.93h-4.14L12 2L9.07 4.93H4.93v4.14L2 12l2.93 2.93v4.14h4.14L12 22l2.93-2.93h4.14v-4.14M21.41 12l-2.34 2.34v-1.88h-5.38l-.46-.46l.46-.46h5.38V9.66L21.41 12m-2.75 2.76l-1.34 1.33l-3.21-3.22h4.55v1.89m-6.2-1.66l-.46-.45l-.46.45v-.64h-.64l.46-.46l-.46-.46h.64v-.64l.46.46l.46-.46v.64h.64l-.45.46l.45.46h-.64v.64m1.65-1.97l3.21-3.22l1.34 1.33v1.89h-4.55m4.55-5.78v3.3l-1.34-1.33l-3.82 3.81h-.63v-.63l3.81-3.82l-1.33-1.33h3.31m-5.79 4.54V5.35h1.89l1.33 1.33l-3.22 3.21M12 2.59l2.34 2.34h-1.88v5.38l-.46.46l-.46-.46V4.93H9.66L12 2.59m-.87 7.3L7.91 6.68l1.33-1.33h1.89v4.54M5.35 5.35h3.3L7.32 6.68l3.81 3.82v.63h-.63L6.68 7.32L5.35 8.65v-3.3m0 3.89l1.33-1.33l3.21 3.22H5.35V9.24M2.59 12l2.34-2.34v1.88h5.38l.46.46l-.46.46H4.93v1.88L2.59 12m7.3.87l-3.21 3.22l-1.33-1.33v-1.89h4.54m-4.54 5.79v-3.31l1.33 1.33l3.82-3.81h.63v.63l-3.81 3.82l1.33 1.33h-3.3m5.78-4.54v4.55H9.24l-1.33-1.34l3.22-3.21m.87 7.3l-2.34-2.34h1.88v-5.38l.46-.46l.46.46v5.38h1.88L12 21.41m.87-7.3l3.22 3.21l-1.33 1.34h-1.89v-4.55m2.48 4.55l1.33-1.34l-3.81-3.82v-.63h.63l3.82 3.81l1.33-1.33v3.31h-3.3Z"/>'
        },
        certificate: {
            body: '<path fill="currentColor" d="M4 3c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2h8v5l3-3l3 3v-5h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4m8 2l3 2l3-2v3.5l3 1.5l-3 1.5V15l-3-2l-3 2v-3.5L9 10l3-1.5V5M4 5h5v2H4V5m0 4h3v2H4V9m0 4h5v2H4v-2Z"/>'
        },
        "certificate-outline": {
            body: '<path fill="currentColor" d="m13 21l2-1l2 1v-7h-4m4-5V7l-2 1l-2-1v2l-2 1l2 1v2l2-1l2 1v-2l2-1m1-7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7v-2H4V5h16v10h-1v2h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-9 5H5V6h6m-2 5H5V9h4m2 5H5v-2h6Z"/>'
        },
        "chair-rolling": {
            body: '<path fill="currentColor" d="M22 10v3h-3v-3h3M2 13h3v-3H2v3m15-8c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v8h10V5M7 15H6v2h5v1l-4 4h2.8l2.2-2.2l2.2 2.2H17l-4-4v-1h5v-2H7Z"/>'
        },
        "chair-school": {
            body: '<path fill="currentColor" d="M22 5v2h-5l-3.47 5H16v2h-1.54l3.71 8h-2.2l-.93-2H6.38l-1.03 2H3.1l4.13-8H7c-.45 0-.83-.3-.96-.7L2.87 3.84l.95-.34c.52-.16 1.09.13 1.26.65L7.72 12h4.38l3.47-5H12V5h10M9.5 14l-2.08 4h6.69l-1.85-4H9.5Z"/>'
        },
        chandelier: {
            body: '<path fill="currentColor" d="M15 13.1c0 1.66-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3M9 2v1a2 2 0 0 0 2 2v4.1c.32-.06.66-.1 1-.1s.68.04 1 .1V5c1.11 0 2-.89 2-2V2H9m-5 9.1c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m16 0c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 7c-.68 0-1.33-.14-1.92-.39c-.48.24-1.01.39-1.58.39c-1.11 0-2.09-.53-2.73-1.33c-.55.23-1.14.33-1.77.33s-1.22-.1-1.77-.33c-.64.8-1.62 1.33-2.73 1.33c-.57 0-1.1-.15-1.58-.39c-.59.25-1.24.39-1.92.39c-.27 0-.54-.04-.8-.1a5.436 5.436 0 0 0 4.3 2.1c1.33 0 2.55-.47 3.5-1.26v2.26c0 .55.45 1 1 1s1-.45 1-1v-2.26c.95.79 2.17 1.26 3.5 1.26c1.74 0 3.29-.81 4.3-2.1c-.26.06-.53.1-.8.1Z"/>'
        },
        charity: {
            body: '<path fill="currentColor" d="M12.75 3.94c1-.72 2.16-1.08 3.47-1.08c.72 0 1.51.19 2.37.59c.86.39 1.54.85 2.04 1.38c1.03 1.28 1.46 2.77 1.31 4.47c-.16 1.7-.72 3.03-1.69 3.97l-7.59 7.59c-.19.19-.43.28-.71.28c-.28 0-.51-.09-.7-.28a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.71l4.59-4.59c.25-.22.25-.45 0-.7c-.25-.25-.48-.25-.7 0l-4.59 4.59a.95.95 0 0 1-.71.28c-.28 0-.51-.09-.7-.28a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.71l4.59-4.59c.27-.25.27-.5 0-.75c-.23-.25-.45-.25-.7 0l-4.59 4.64a.98.98 0 0 1-.71.28c-.28 0-.52-.09-.73-.28c-.2-.19-.3-.42-.3-.7c0-.28.11-.53.33-.75l4.6-4.6c.25-.25.25-.48 0-.7c-.25-.22-.49-.22-.71 0L6.28 14.5c-.22.2-.45.31-.7.31c-.28 0-.52-.1-.7-.31c-.19-.2-.29-.44-.29-.72c0-.28.1-.51.29-.7C7.94 10 9.83 8.14 10.55 7.45l3.56 3.52c.39.37.84.56 1.39.56c.7 0 1.25-.28 1.66-.84c.28-.41.38-.86.3-1.36c-.08-.5-.29-.92-.63-1.27l-4.08-4.12m2.06 6.33L10.55 6l-7.08 7.08c-.84-.85-1.32-2.15-1.43-3.92c-.11-1.76.37-3.29 1.43-4.57c1.19-1.18 2.61-1.78 4.26-1.78c1.66 0 3.07.6 4.22 1.78l4.27 4.27c.19.19.28.42.28.7c0 .28-.09.52-.28.71c-.19.18-.42.28-.72.28c-.27 0-.5-.1-.69-.28Z"/>'
        },
        "chart-arc": {
            body: '<path fill="currentColor" d="m16.18 19.6l-2.01-3.48c.98-.72 1.66-1.84 1.8-3.12H20a8.55 8.55 0 0 1-3.82 6.6M13 7.03V3c4.3.26 7.74 3.7 8 8h-4.03A4.488 4.488 0 0 0 13 7.03M7 12.5c0 .64.13 1.25.38 1.8L3.9 16.31A8.42 8.42 0 0 1 3 12.5C3 7.97 6.54 4.27 11 4v4.03c-2.25.25-4 2.15-4 4.47m4.5 8.5c-2.97 0-5.58-1.5-7.1-3.82l3.48-2.01A4.47 4.47 0 0 0 11.5 17c.64 0 1.25-.13 1.8-.38l2.01 3.48c-1.15.58-2.44.9-3.81.9Z"/>'
        },
        "chart-areaspline": {
            body: '<path fill="currentColor" d="M17.45 15.18L22 7.31V21H2V3h2v12.54L9.5 6L16 9.78l4.24-7.33l1.73 1l-5.23 9.05l-6.51-3.75L4.31 19h2.26l4.39-7.56l6.49 3.74Z"/>'
        },
        "chart-areaspline-variant": {
            body: '<path fill="currentColor" d="M22 21H2V3h2v12.54L9.5 6L16 9.78l4.24-7.33l1.73 1L22 21Z"/>'
        },
        "chart-bar": {
            body: '<path fill="currentColor" d="M22 21H2V3h2v16h2v-9h4v9h2V6h4v13h2v-5h4v7Z"/>'
        },
        "chart-bar-stacked": {
            body: '<path fill="currentColor" d="M22 21H2V3h2v16h2v-2h4v2h2v-3h4v3h2v-2h4v4m-4-7h4v2h-4v-2m-6-8h4v3h-4V6m4 9h-4v-5h4v5M6 10h4v2H6v-2m4 6H6v-3h4v3Z"/>'
        },
        "chart-bell-curve": {
            body: '<path fill="currentColor" d="M9.96 11.31C10.82 8.1 11.5 6 13 6s2.18 2.1 3.04 5.31C17 14.92 18.1 19 22 19v-2c-2.2 0-3-2.46-4.03-6.2C17.08 7.46 16.15 4 13 4c-3.15 0-4.08 3.46-4.97 6.8C7.03 14.54 6.2 17 4 17V2H2v20h20v-2H4v-1c3.9 0 5-4.08 5.96-7.69Z"/>'
        },
        "chart-bell-curve-cumulative": {
            body: '<path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19Z"/>'
        },
        "chart-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 17H7v-7h2v7m4 0h-2V7h2v10m4 0h-2v-4h2v4Z"/>'
        },
        "chart-box-outline": {
            body: '<path fill="currentColor" d="M9 17H7v-7h2v7m4 0h-2V7h2v10m4 0h-2v-4h2v4m2 2H5V5h14v14.1M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z"/>'
        },
        "chart-box-plus-outline": {
            body: '<path fill="currentColor" d="M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3m-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6m-4-6v4h2v-4h-2m-4 4h2V9h-2v8m-2 0v-6H7v6h2Z"/>'
        },
        "chart-bubble": {
            body: '<path fill="currentColor" d="M7.2 11.2c1.77 0 3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2c-1.77 0-3.2-1.43-3.2-3.2c0-1.77 1.43-3.2 3.2-3.2m7.6 4.8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m.4-12A4.8 4.8 0 0 1 20 8.8c0 2.65-2.15 4.8-4.8 4.8a4.8 4.8 0 0 1-4.8-4.8c0-2.65 2.15-4.8 4.8-4.8Z"/>'
        },
        "chart-donut": {
            body: '<path fill="currentColor" d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92c0 .9-.18 1.75-.5 2.54l2.62 1.53c.56-1.24.88-2.62.88-4.07c0-5.18-3.95-9.45-9-9.95M12 19a7 7 0 0 1-7-7c0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95a10 10 0 0 0 10 10c3.3 0 6.23-1.61 8.05-4.09l-2.6-1.53A6.89 6.89 0 0 1 12 19Z"/>'
        },
        "chart-donut-variant": {
            body: '<path fill="currentColor" d="M13 2.05c5.05.5 9 4.77 9 9.95c0 1.45-.32 2.83-.88 4.07l-2.62-1.53c.32-.79.5-1.64.5-2.54c0-3.53-2.61-6.43-6-6.92V2.05M12 19c2.21 0 4.17-1 5.45-2.62l2.6 1.53A9.97 9.97 0 0 1 12 22C6.47 22 2 17.5 2 12a9.99 9.99 0 0 1 9-9.95v3.03C7.61 5.57 5 8.47 5 12a7 7 0 0 0 7 7m0-13a6 6 0 0 1 6 6c0 2.97-2.16 5.44-5 5.92v-3.09c1.17-.41 2-1.52 2-2.83a3 3 0 0 0-3-3l-.55.05l-1.54-2.67C10.56 6.13 11.26 6 12 6m-6 6c0-1.86.85-3.5 2.18-4.62l1.54 2.67C9.27 10.57 9 11.26 9 12c0 1.31.83 2.42 2 2.83v3.09c-2.84-.48-5-2.95-5-5.92Z"/>'
        },
        "chart-gantt": {
            body: '<path fill="currentColor" d="M2 5h8V2h2v20h-2v-4H6v-3h4v-2H4v-3h6V8H2V5m12 0h3v3h-3V5m0 5h5v3h-5v-3m0 5h8v3h-8v-3Z"/>'
        },
        "chart-histogram": {
            body: '<path fill="currentColor" d="M3 3h2v10h4V7h4v4h4v4h4v6H3V3Z"/>'
        },
        "chart-line": {
            body: '<path fill="currentColor" d="m16 11.78l4.24-7.33l1.73 1l-5.23 9.05l-6.51-3.75L5.46 19H22v2H2V3h2v14.54L9.5 8l6.5 3.78Z"/>'
        },
        "chart-line-stacked": {
            body: '<path fill="currentColor" d="M17.45 15.18L22 6.81V21H2V3h2v16h2.57l4.39-7.56l6.49 3.74M22 3l-.03.45L17 11l-7-5l-4 6V3h16Z"/>'
        },
        "chart-line-variant": {
            body: '<path fill="currentColor" d="m3.5 18.5l6-6l4 4L22 6.92L20.59 5.5l-7.09 8l-4-4L2 17l1.5 1.5Z"/>'
        },
        "chart-multiline": {
            body: '<path fill="currentColor" d="M22 6.92L20.59 5.5l-2.85 3.22C15.68 6.4 12.83 5 9.61 5C6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24L13.5 13.5l-4-4L2 17l1.5 1.5l6-6l4 4l4.05-4.57c.75 1.35 1.25 2.9 1.45 4.57h2c-.22-2.32-.95-4.41-2.04-6.16L22 6.92Z"/>'
        },
        "chart-multiple": {
            body: '<path fill="currentColor" d="M22 16v2H6V2h2v11.57l5.71-9l3.16 2.11l2.42-2.42l1.42 1.42l-3.58 3.61l-2.84-1.89L8.82 16M4 20V4H2v18h20v-2Z"/>'
        },
        "chart-pie": {
            body: '<path fill="currentColor" d="M11 2v20c-5.1-.5-9-4.8-9-10s3.9-9.5 9-10m2 0v9h9c-.5-4.8-4.2-8.5-9-9m0 11v9c4.7-.5 8.5-4.2 9-9h-9Z"/>'
        },
        "chart-pie-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM13 4.07C16.61 4.52 19.48 7.4 19.93 11H13V4.07ZM4 12C4 7.94 7.07 4.56 11 4.07V19.94C7.07 19.44 4 16.06 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z"/>'
        },
        "chart-ppf": {
            body: '<path fill="currentColor" d="M5 6v2c3.2 0 6.36 1.18 8.57 3.15C15.64 13 16.83 15.5 17 18h1.97A14 12.5 0 0 0 5 6m17 15H2V3h2v16h18Z"/>'
        },
        "chart-sankey": {
            body: '<path fill="currentColor" d="M22 5H4V2H2v20h20v-2H4V9c4.09 0 6.13 2 8.29 4.21S17.09 18 22 18v-2c-4.09 0-6.13-2-8.29-4.21S8.91 7 4 7h18Z"/>'
        },
        "chart-sankey-variant": {
            body: '<path fill="currentColor" d="M20 4v2H4V4H2v8h2v-2c4.16 0 5.92 2.11 7.77 4.34S15.65 19 20 19v2h2v-6h-2v2c-3.41 0-4.93-1.83-6.69-3.94C11.34 10.69 9.1 8 4 8h16v2h2V4Z"/>'
        },
        "chart-scatter-plot": {
            body: '<path fill="currentColor" d="M2 2h2v18h18v2H2V2m7 8a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m4-8a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m5 10a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "chart-scatter-plot-hexbin": {
            body: '<path fill="currentColor" d="M2 2h2v18h18v2H2V2m12 12.5L12 18H7.94l-2.02-3.5L7.94 11H12l2 3.5m.08-8L12.06 10H8L6 6.5L8 3h4.06l2.02 3.5m7.17 4L19.23 14h-4.04l-2.02-3.5L15.19 7h4.04l2.02 3.5Z"/>'
        },
        "chart-timeline": {
            body: '<path fill="currentColor" d="M2 2h2v18h18v2H2V2m5 8h10v3H7v-3m4 5h10v3H11v-3M6 4h16v4h-2V6H8v2H6V4Z"/>'
        },
        "chart-timeline-variant": {
            body: '<path fill="currentColor" d="m3 14l.5.07L8.07 9.5a1.95 1.95 0 0 1 .52-1.91c.78-.79 2.04-.79 2.82 0c.53.52.7 1.26.52 1.91l2.57 2.57l.5-.07c.18 0 .35 0 .5.07l3.57-3.57C19 8.35 19 8.18 19 8a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2c-.18 0-.35 0-.5-.07l-3.57 3.57c.07.15.07.32.07.5a2 2 0 0 1-2 2a2 2 0 0 1-2-2l.07-.5l-2.57-2.57c-.32.07-.68.07-1 0L4.93 15.5L5 16a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "chart-timeline-variant-shimmer": {
            body: '<path fill="currentColor" d="M21 8c-1.5 0-2.3 1.4-1.9 2.5l-3.6 3.6c-.3-.1-.7-.1-1 0l-2.6-2.6c.4-1.1-.4-2.5-1.9-2.5c-1.4 0-2.3 1.4-1.9 2.5L3.5 16c-1.1-.3-2.5.5-2.5 2c0 1.1.9 2 2 2c1.4 0 2.3-1.4 1.9-2.5l4.5-4.6c.3.1.7.1 1 0l2.6 2.6c-.3 1 .5 2.5 2 2.5s2.3-1.4 1.9-2.5l3.6-3.6c1.1.3 2.5-.5 2.5-1.9c0-1.1-.9-2-2-2m-6 1l.9-2.1L18 6l-2.1-.9L15 3l-.9 2.1L12 6l2.1.9L15 9M3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9l.5 2Z"/>'
        },
        "chart-tree": {
            body: '<path fill="currentColor" d="M14 6h8v16h-8V6M2 4h20V2H2v2m0 4h10V6H2v2m7 14h3V10H9v12m-7 0h5V10H2v12Z"/>'
        },
        "chart-waterfall": {
            body: '<path fill="currentColor" d="M2 2h2v18h18v2H2V2m15 0h3v16h-3V2M6 11h3v7H6v-7m7-8h3v4h-3V3m-3 5h3v4h-3V8Z"/>'
        },
        chat: {
            body: '<path fill="currentColor" d="M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8Z"/>'
        },
        "chat-alert": {
            body: '<path fill="currentColor" d="M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8m-1 11v2h2v-2h-2m0-2h2V6h-2v6Z"/>'
        },
        "chat-alert-outline": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 0 0 2.75 5.5c0 .6-.42 2.17-2.75 4.5c2.37-.11 4.64-1 6.47-2.5c1.14.33 2.34.5 3.53.5c5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6s8 2.69 8 6s-3.58 6-8 6m-1-4v2h2v-2h-2m0-2h2V7h-2v4Z"/>'
        },
        "chat-minus": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68A6.005 6.005 0 0 0 13 18l.08.95L12 19c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.14 2 11c0-4.42 4.5-8 10-8Z"/>'
        },
        "chat-minus-outline": {
            body: '<path fill="currentColor" d="M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68c-.59-.3-1.23-.52-1.9-.62c.08-.34.12-.7.12-1.06c0-3.31-3.58-6-8-6s-8 2.69-8 6s3.58 6 8 6l1.09-.05L13 18l.08.95L12 19c-1.19 0-2.38-.17-3.53-.5C6.64 20 4.37 20.89 2 21c2.33-2.33 2.75-3.9 2.75-4.5A7.218 7.218 0 0 1 2 11c0-4.42 4.5-8 10-8m11 14v2h-8v-2h8Z"/>'
        },
        "chat-outline": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 0 0 2.75 5.5c0 .6-.42 2.17-2.75 4.5c2.37-.11 4.64-1 6.47-2.5c1.14.33 2.34.5 3.53.5c5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6s8 2.69 8 6s-3.58 6-8 6Z"/>'
        },
        "chat-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68A6.005 6.005 0 0 0 13 18l.08.95L12 19c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.14 2 11c0-4.42 4.5-8 10-8Z"/>'
        },
        "chat-plus-outline": {
            body: '<path fill="currentColor" d="M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68c-.59-.3-1.23-.52-1.9-.62c.08-.34.12-.7.12-1.06c0-3.31-3.58-6-8-6s-8 2.69-8 6s3.58 6 8 6l1.09-.05L13 18l.08.95L12 19c-1.19 0-2.38-.17-3.53-.5C6.64 20 4.37 20.89 2 21c2.33-2.33 2.75-3.9 2.75-4.5A7.218 7.218 0 0 1 2 11c0-4.42 4.5-8 10-8m6 11h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "chat-processing": {
            body: '<path fill="currentColor" d="M12 3c5.5 0 10 3.58 10 8s-4.5 8-10 8c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.13 2 11c0-4.42 4.5-8 10-8m5 9v-2h-2v2h2m-4 0v-2h-2v2h2m-4 0v-2H7v2h2Z"/>'
        },
        "chat-processing-outline": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 0 0 2.75 5.5c0 .6-.42 2.17-2.75 4.5c2.37-.11 4.64-1 6.47-2.5c1.14.33 2.34.5 3.53.5c5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6s8 2.69 8 6s-3.58 6-8 6m5-5v-2h-2v2h2m-4 0v-2h-2v2h2m-4 0v-2H7v2h2Z"/>'
        },
        "chat-question": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.6 2 11c0 2.1 1 4.1 2.8 5.5c0 .6-.4 2.2-2.8 4.5c0 0 3.5 0 6.5-2.5c1.1.3 2.3.5 3.5.5c5.5 0 10-3.6 10-8s-4.5-8-10-8m1 12h-2v-2h2v2m1.8-5c-.3.4-.7.6-1.1.8c-.3.2-.4.3-.5.5c-.2.2-.2.4-.2.7h-2c0-.5.1-.8.3-1.1c.2-.2.6-.5 1.1-.8c.3-.1.5-.3.6-.5c.1-.2.2-.5.2-.7c0-.3-.1-.5-.3-.7c-.2-.2-.5-.3-.8-.3c-.3 0-.5.1-.7.2c-.2.1-.3.3-.3.6h-2c.1-.7.4-1.3.9-1.7c.5-.4 1.2-.5 2.1-.5c.9 0 1.7.2 2.2.6c.5.4.8 1 .8 1.7c.1.4 0 .8-.3 1.2Z"/>'
        },
        "chat-question-outline": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.6 2 11c0 2.2 1.1 4.2 2.8 5.5c0 .6-.4 2.2-2.8 4.5c2.4-.1 4.6-1 6.5-2.5c1.1.3 2.3.5 3.5.5c5.5 0 10-3.6 10-8s-4.5-8-10-8m0 14c-4.4 0-8-2.7-8-6s3.6-6 8-6s8 2.7 8 6s-3.6 6-8 6m.2-10.5c-.9 0-1.6.2-2.1.5c-.6.4-.9 1-.8 1.7h2c0-.3.1-.5.3-.6c.2-.1.4-.2.7-.2c.3 0 .6.1.8.3c.2.2.3.4.3.7c0 .3-.1.5-.2.7c-.2.2-.4.4-.6.5c-.5.3-.9.6-1.1.8c-.4.3-.5.6-.5 1.1h2c0-.3.1-.5.1-.7c.1-.2.3-.3.5-.5c.5-.2.8-.5 1.1-.9c.3-.4.4-.8.4-1.2c0-.7-.3-1.3-.8-1.7c-.4-.3-1.2-.5-2.1-.5M11 13v2h2v-2h-2Z"/>'
        },
        "chat-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.42 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.13l-1.42-1.42L17.59 18l-2.12-2.12M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68A6.005 6.005 0 0 0 13 18l.08.95L12 19c-1.24 0-2.43-.18-3.53-.5C5.55 21 2 21 2 21c2.33-2.33 2.7-3.9 2.75-4.5C3.05 15.07 2 13.14 2 11c0-4.42 4.5-8 10-8Z"/>'
        },
        "chat-remove-outline": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.42 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.13l-1.42-1.42L17.59 18l-2.12-2.12M12 3c5.5 0 10 3.58 10 8c0 .58-.08 1.14-.22 1.68c-.59-.3-1.23-.52-1.9-.62c.08-.34.12-.7.12-1.06c0-3.31-3.58-6-8-6s-8 2.69-8 6s3.58 6 8 6l1.09-.05L13 18l.08.95L12 19c-1.19 0-2.38-.17-3.53-.5C6.64 20 4.37 20.89 2 21c2.33-2.33 2.75-3.9 2.75-4.5A7.218 7.218 0 0 1 2 11c0-4.42 4.5-8 10-8Z"/>'
        },
        "chat-sleep": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.58 2 11c0 2.13 1.05 4.07 2.75 5.5c-.05.6-.42 2.17-2.75 4.5c0 0 3.55 0 6.47-2.5c1.1.32 2.29.5 3.53.5c5.5 0 10-3.58 10-8s-4.5-8-10-8m3 6.3L11.76 13H15v2H9v-2.3L12.24 9H9V7h6v2.3Z"/>'
        },
        "chat-sleep-outline": {
            body: '<path fill="currentColor" d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 0 0 2.75 5.5c0 .6-.42 2.17-2.75 4.5c2.37-.11 4.64-1 6.47-2.5c1.14.33 2.34.5 3.53.5c5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6s8 2.69 8 6s-3.58 6-8 6m3-10H9v2h3.24L9 12.7V15h6v-2h-3.24L15 9.3V7Z"/>'
        },
        check: {
            body: '<path fill="currentColor" d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7Z"/>'
        },
        "check-all": {
            body: '<path fill="currentColor" d="M.41 13.41L6 19l1.41-1.42L1.83 12m20.41-6.42L11.66 16.17L7.5 12l-1.43 1.41L11.66 19l12-12M18 7l-1.41-1.42l-6.35 6.35l1.42 1.41L18 7Z"/>'
        },
        "check-bold": {
            body: '<path fill="currentColor" d="m9 20.42l-6.21-6.21l2.83-2.83L9 14.77l9.88-9.89l2.83 2.83L9 20.42Z"/>'
        },
        "check-bookmark": {
            body: '<path d="M5 1h14a2 2 0 0 1 2 2v13c0 .71-.37 1.335-.93 1.69L12 23l-8.071-5.31A1.999 1.999 0 0 1 3 16V3a2 2 0 0 1 2-2zm5 15l9-9l-1.414-1.414L10 13.172L6.414 9.586L5 11l5 5z" fill="currentColor"/>',
            hidden: true
        },
        "check-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9Z"/>'
        },
        "check-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8l-1.41-1.42Z"/>'
        },
        "check-decagram": {
            body: '<path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68L23 12m-13 5l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8Z"/>'
        },
        "check-decagram-outline": {
            body: '<path fill="currentColor" d="m23 12l-2.4-2.8l.3-3.7l-3.6-.8l-1.9-3.2L12 3L8.6 1.5L6.7 4.7l-3.6.8l.3 3.7L1 12l2.4 2.8l-.3 3.7l3.6.8l1.9 3.2L12 21l3.4 1.5l1.9-3.2l3.6-.8l-.3-3.7L23 12m-4.3 4.9l-2.7.6l-1.4 2.4l-2.6-1.1l-2.6 1.1L8 17.5l-2.7-.6l.2-2.8L3.7 12l1.8-2.1l-.2-2.8L8 6.5l1.4-2.4L12 5.2l2.6-1.1L16 6.5l2.7.6l-.2 2.8l1.8 2.1l-1.8 2.1l.2 2.8m-2.1-9.3L18 9l-8 8l-4-4l1.4-1.4l2.6 2.6l6.6-6.6Z"/>'
        },
        "check-network": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-6.75-9.92l1.16-1.16L11 10.5l3.59-3.58l1.16 1.41L11 13.08l-2.75-3Z"/>'
        },
        "check-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m1-4.63l1.24-1.24l1.69 1.7L14.76 7L16 8.5l-5.07 5.07L8 10.37Z"/>'
        },
        "check-outline": {
            body: '<path fill="currentColor" d="M19.78 2.2L24 6.42L8.44 22L0 13.55l4.22-4.22l4.22 4.22L19.78 2.2m0 2.8L8.44 16.36l-4.22-4.17l-1.41 1.36l5.63 5.62L21.19 6.42L19.78 5Z"/>'
        },
        "check-underline": {
            body: '<path fill="currentColor" d="M21 5L9 17l-5.5-5.5l1.41-1.41L9 14.17L19.59 3.59L21 5M3 21v-2h18v2H3Z"/>'
        },
        "check-underline-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m5 16H7v-2h10v2m-6.7-4L7 10.7l1.4-1.4l1.9 1.9l5.3-5.3L17 7.3L10.3 14Z"/>'
        },
        "check-underline-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m-5-5h10v2H7v-2m3.3-3.8L8.4 9.3L7 10.7l3.3 3.3L17 7.3l-1.4-1.4l-5.3 5.3Z"/>'
        },
        checkbook: {
            body: '<path fill="currentColor" d="M5 14h14v1H5v-1m16 3V8H3v9h18M1 5h22v14H1V5m4 5h7v2H5v-2Z"/>'
        },
        "checkbox-blank": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "checkbox-blank-badge": {
            body: '<path fill="currentColor" d="M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5S17.57 1 19.5 1S23 2.57 23 4.5M19.5 10A5.51 5.51 0 0 1 14 4.5c0-.5.08-1 .21-1.5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V9.79c-.5.13-1 .21-1.5.21Z"/>'
        },
        "checkbox-blank-badge-outline": {
            body: '<path fill="currentColor" d="M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5S17.57 1 19.5 1S23 2.57 23 4.5M19.5 10H19v9H5V5h9.03C14 4.84 14 4.67 14 4.5c0-.5.08-1 .21-1.5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V9.79c-.5.13-1 .21-1.5.21Z"/>'
        },
        "checkbox-blank-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "checkbox-blank-circle-outline": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "checkbox-blank-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M21 5a2 2 0 0 0-2-2H6.2L21 17.8V5Z"/>'
        },
        "checkbox-blank-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L3 4.9V19a2 2 0 0 0 2 2h14.1l1.74 1.73l1.27-1.27M5 19V6.89L17.11 19H5M8.2 5l-2-2H19a2 2 0 0 1 2 2v12.8l-2-2V5H8.2Z"/>'
        },
        "checkbox-blank-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14Z"/>'
        },
        "checkbox-indeterminate": {
            body: '<path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 16H5V5h14v14zm-2-2H7V7h10v10z" fill="currentColor"/>',
            hidden: true
        },
        "checkbox-intermediate": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-2-2H7V7h10v10Z"/>'
        },
        "checkbox-intermediate-variant": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14v14M7 17V7h10"/>'
        },
        "checkbox-marked": {
            body: '<path fill="currentColor" d="m10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "checkbox-marked-circle": {
            body: '<path fill="currentColor" d="m10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m-7-6A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "checkbox-marked-circle-outline": {
            body: '<path fill="currentColor" d="M20 12a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8c.76 0 1.5.11 2.2.31l1.57-1.57A9.822 9.822 0 0 0 12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10M7.91 10.08L6.5 11.5L11 16L21 6l-1.41-1.42L11 13.17l-3.09-3.09Z"/>'
        },
        "checkbox-marked-circle-plus-outline": {
            body: '<path fill="currentColor" d="M14.3 21.7c-.7.2-1.5.3-2.3.3c-5.5 0-10-4.5-10-10S6.5 2 12 2c1.3 0 2.6.3 3.8.7l-1.6 1.6c-.7-.2-1.4-.3-2.2-.3c-4.4 0-8 3.6-8 8s3.6 8 8 8c.4 0 .9 0 1.3-.1c.2.7.6 1.3 1 1.8M7.9 10.1l-1.4 1.4L11 16L21 6l-1.4-1.4l-8.6 8.6l-3.1-3.1M18 14v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "checkbox-marked-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8h-2m-11.09-.92L6.5 11.5L11 16L21 6l-1.41-1.42L11 13.17l-3.09-3.09Z"/>'
        },
        "checkbox-multiple-blank": {
            body: '<path fill="currentColor" d="M22 16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h12a2 2 0 0 1 2 2v12m-6 4v2H4a2 2 0 0 1-2-2V7h2v13h12Z"/>'
        },
        "checkbox-multiple-blank-circle": {
            body: '<path fill="currentColor" d="M14 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8M4.93 5.82A8.01 8.01 0 0 0 2 12a8 8 0 0 0 8 8c.64 0 1.27-.08 1.88-.23c-1.76-.39-3.38-1.27-4.71-2.48A6.001 6.001 0 0 1 4 12c0-.3.03-.59.07-.89C4.03 10.74 4 10.37 4 10c0-1.44.32-2.87.93-4.18Z"/>'
        },
        "checkbox-multiple-blank-circle-outline": {
            body: '<path fill="currentColor" d="M14 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m0 2c3.32 0 6 2.69 6 6c0 3.32-2.68 6-6 6a6 6 0 0 1-6-6a6 6 0 0 1 6-6M4.93 5.82A8.01 8.01 0 0 0 2 12a8 8 0 0 0 8 8c.64 0 1.27-.08 1.88-.23c-1.76-.39-3.38-1.27-4.71-2.48A6.001 6.001 0 0 1 4 12c0-.3.03-.59.07-.89C4.03 10.74 4 10.37 4 10c0-1.44.32-2.87.93-4.18Z"/>'
        },
        "checkbox-multiple-blank-outline": {
            body: '<path fill="currentColor" d="M20 16V4H8v12h12m2 0a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h12a2 2 0 0 1 2 2v12m-6 4v2H4a2 2 0 0 1-2-2V7h2v13h12Z"/>'
        },
        "checkbox-multiple-marked": {
            body: '<path fill="currentColor" d="M22 16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h12a2 2 0 0 1 2 2v12m-6 4v2H4a2 2 0 0 1-2-2V7h2v13h12m-3-6l7-7l-1.41-1.41L13 11.17L9.91 8.09L8.5 9.5L13 14Z"/>'
        },
        "checkbox-multiple-marked-circle": {
            body: '<path fill="currentColor" d="M14 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8M4.93 5.82A8.01 8.01 0 0 0 2 12a8 8 0 0 0 8 8c.64 0 1.27-.08 1.88-.23c-1.76-.39-3.38-1.27-4.71-2.48A6.001 6.001 0 0 1 4 12c0-.3.03-.59.07-.89C4.03 10.74 4 10.37 4 10c0-1.44.32-2.87.93-4.18m13.16.26L19.5 7.5L13 14l-3.79-3.79l1.42-1.42L13 11.17"/>'
        },
        "checkbox-multiple-marked-circle-outline": {
            body: '<path fill="currentColor" d="M14 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8h-2c0 3.32-2.68 6-6 6a6 6 0 0 1-6-6a6 6 0 0 1 6-6c.43 0 .86.05 1.27.14l1.61-1.6C15.96 2.18 15 2 14 2m6.59 1.58L14 10.17l-2.38-2.38l-1.41 1.42L14 13l8-8m-17.07.82A8.01 8.01 0 0 0 2 12a8 8 0 0 0 8 8c.64 0 1.27-.08 1.88-.23c-1.76-.39-3.38-1.27-4.71-2.48A6.001 6.001 0 0 1 4 12c0-.3.03-.59.07-.89C4.03 10.74 4 10.37 4 10c0-1.44.32-2.87.93-4.18Z"/>'
        },
        "checkbox-multiple-marked-outline": {
            body: '<path fill="currentColor" d="M20 16v-6h2v6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h8v2H8v12h12m-9.09-8.92L14 10.17l6.59-6.59L22 5l-8 8l-4.5-4.5l1.41-1.42M16 20v2H4a2 2 0 0 1-2-2V7h2v13h12Z"/>'
        },
        "checkbox-multiple-outline": {
            body: '<path fill="currentColor" d="M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 14H8V4h12v12m-4 4v2H4a2 2 0 0 1-2-2V7h2v13h12m2.53-11.94L17.47 7l-4.88 4.88l-2.12-2.12l-1.06 1.06L12.59 14l5.94-5.94Z"/>'
        },
        "checkbox-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14m-9 12l-4-4l1.41-1.42L10 14.17l6.59-6.59L18 9"/>'
        },
        checkerboard: {
            body: '<path fill="currentColor" d="M2 2v20h20V2H2m18 10h-4v4h4v4h-4v-4h-4v4H8v-4H4v-4h4V8H4V4h4v4h4V4h4v4h4v4m-4-4v4h-4V8h4m-4 4v4H8v-4h4Z"/>'
        },
        "checkerboard-minus": {
            body: '<path fill="currentColor" d="M14 17v2h8v-2M8 16h4v-4H8v4m4-4h4V8h-4v4M2 2v20h11.5c-.5-.6-.9-1.3-1.2-2H8v-4H4v-4h4V8H4V4h4v4h4V4h4v4h4v4.4c.7.3 1.4.7 2 1.2V2H2Z"/>'
        },
        "checkerboard-plus": {
            body: '<path fill="currentColor" d="M19 17h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3M8 16h4v-4H8v4m4-4h4V8h-4v4M2 2v20h11.54c-.54-.58-.91-1.26-1.18-2H8v-4H4v-4h4V8H4V4h4v4h4V4h4v4h4v4.36c.74.27 1.42.64 2 1.18V2H2Z"/>'
        },
        "checkerboard-remove": {
            body: '<path fill="currentColor" d="M8 16h4v-4H8v4m4-4h4V8h-4v4M2 2v20h11.5c-.5-.6-.9-1.3-1.2-2H8v-4H4v-4h4V8H4V4h4v4h4V4h4v4h4v4.4c.7.3 1.4.7 2 1.2V2H2m18.1 12.5L18 16.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        cheese: {
            body: '<path fill="currentColor" d="M11 17.5c0-.83.67-1.5 1.5-1.5c.29 0 .56.09.79.23l7.46-4.3c-.4-.71-.85-1.38-1.34-2.03a.92.92 0 0 1-.41.1c-.55 0-1-.45-1-1c0-.2.08-.38.18-.54A17.742 17.742 0 0 0 12 4.25C11.85 5.24 11 6 10 6a2 2 0 0 1-2-2c0-.28.06-.55.16-.79C7.3 3.08 6.41 3 5.5 3c-.17 0-.33 0-.5.03v6.02a2.5 2.5 0 0 1 0 4.9V21l6-3.46v-.04M14 9a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m-5 7c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m0-6c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "cheese-off": {
            body: '<path fill="currentColor" d="M3.5 1.7L2.2 3l3.9 3.9V9c1.1.2 2 1.2 2 2.5s-.9 2.2-2 2.5v7l6-3.5c0-.8.7-1.5 1.5-1.5c.3 0 .6.1.8.2l.7-.4l5.2 5.2l1.3-1.3l-18.1-18M10.1 16c-.5 0-1-.5-1-1s.5-1 1-1s1 .5 1 1s-.5 1-1 1m3.7-6.5L9.9 5.6c.3.3.7.4 1.2.4c1 0 1.8-.8 2-1.8c2.3 1 4.5 2.4 6.2 4.2c-.1.2-.2.3-.2.5c0 .5.5 1 1 1c.2 0 .3 0 .4-.1c.5.6.9 1.3 1.3 2l-3.5 2l-1.7-1.7c.3-.3.5-.8.5-1.3c0-1.1-.9-2-2-2c-.5.2-1 .4-1.3.7M9.5 5.2L7.3 3c.7 0 1.3.1 1.9.2c-.1.3-.1.5-.1.8c0 .4.1.9.4 1.2Z"/>'
        },
        "chef-hat": {
            body: '<path fill="currentColor" d="M12.5 1.5c-1.77 0-3.33 1.17-3.83 2.87C8.14 4.13 7.58 4 7 4a4 4 0 0 0-4 4a4.01 4.01 0 0 0 3 3.87V19h13v-7.13c1.76-.46 3-2.05 3-3.87a4 4 0 0 0-4-4c-.58 0-1.14.13-1.67.37c-.5-1.7-2.06-2.87-3.83-2.87m-.5 9h1v7h-1v-7m-3 2h1v5H9v-5m6 0h1v5h-1v-5M6 20v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1H6Z"/>'
        },
        "chemical-weapon": {
            body: '<path fill="currentColor" d="M11 7.83A3 3 0 0 1 9 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.31-.84 2.42-2 2.83v2.81a3.66 3.66 0 0 0-2 0V7.83m7.3 13.27a2.989 2.989 0 0 1-1.46-3.14l-2.44-1.41c.48-.46.84-1.05 1-1.73l2.44 1.41c.94-.81 2.32-.97 3.45-.32c1.44.83 1.93 2.66 1.1 4.09a2.987 2.987 0 0 1-4.09 1.1M2.7 15.9c1.13-.65 2.51-.48 3.45.32l2.45-1.41c.16.69.51 1.27 1 1.73l-2.45 1.41c.23 1.22-.32 2.5-1.45 3.15c-1.44.83-3.27.34-4.1-1.1a2.999 2.999 0 0 1 1.1-4.1M14 14a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2m3 0l-.03.57l-1.47-.86c-.1-1.07-.67-2-1.5-2.59V9.41c1.77.78 3 2.54 3 4.59m-2.03 4.03c-.83.61-1.86.97-2.97.97s-2.14-.36-2.97-1l1.47-.83c.46.21.97.33 1.5.33s1.03-.12 1.5-.33l1.47.86m-7.94-3.47L7 14c0-2.05 1.23-3.81 3-4.58v1.71c-.83.58-1.4 1.51-1.5 2.57l-1.47.86Z"/>'
        },
        "chess-bishop": {
            body: '<path fill="currentColor" d="M19 22H5v-2h14v2M17.16 8.26A8.94 8.94 0 0 1 19 13c0 2.76-3.13 5-7 5s-7-2.24-7-5c0-2.38 2.33-6.61 5.46-7.73c-.3-.36-.46-.81-.46-1.27a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 .46-.16.91-.46 1.27c.86.33 1.64.83 2.3 1.47l-4.55 4.55l1.42 1.42l4.45-4.45Z"/>'
        },
        "chess-king": {
            body: '<path fill="currentColor" d="M19 22H5v-2h14v2m-2-12c-1.42 0-2.74.77-3.45 2H13V7h3V5h-3V2h-2v3H8v2h3v5h-.55C9.35 10.09 6.9 9.43 5 10.54A4.013 4.013 0 0 0 3.5 16c.74 1.24 2.07 2 3.5 2h10a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "chess-knight": {
            body: '<path fill="currentColor" d="M19 22H5v-2h14v2M13 2c-1.25 0-2.42.62-3.11 1.66L7 8l2 2l2.06-1.37c.44-.31 1.08-.19 1.39.27c.02.03.05.06.05.1c.3.59.19 1.3-.28 1.77l-4.8 4.8c-.55.56-.55 1.46.01 2.01c.26.26.62.42.99.42H17V6a4 4 0 0 0-4-4Z"/>'
        },
        "chess-pawn": {
            body: '<path fill="currentColor" d="M19 22H5v-2h14v2m-3-4H8l2.18-8H8V8h2.72l.07-.26A2.97 2.97 0 0 1 9.25 6.2c-.67-1.52.02-3.29 1.54-3.95c1.52-.67 3.29.02 3.95 1.54a2.99 2.99 0 0 1-1.54 3.95l.07.26H16v2h-2.18L16 18Z"/>'
        },
        "chess-queen": {
            body: '<path fill="currentColor" d="M18 3a2 2 0 0 1 2 2c0 .81-.5 1.5-1.17 1.82L17 13.15V18H7v-4.85L5.17 6.82C4.5 6.5 4 5.81 4 5a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 .5-.18.95-.5 1.3l2.8 3.05l.53-3.73C10.33 5.26 10 4.67 10 4a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 .67-.33 1.26-.83 1.62l.53 3.73l2.77-3.06A2 2 0 0 1 16 5a2 2 0 0 1 2-2M5 20h14v2H5v-2Z"/>'
        },
        "chess-rook": {
            body: '<path fill="currentColor" d="M5 20h14v2H5v-2M17 2v3h-2V2h-2v3h-2V2H9v3H7V2H5v6h2v10h10V8h2V2h-2Z"/>'
        },
        "chevron-double-down": {
            body: '<path fill="currentColor" d="M16.59 5.59L18 7l-6 6l-6-6l1.41-1.41L12 10.17l4.59-4.58m0 6L18 13l-6 6l-6-6l1.41-1.41L12 16.17l4.59-4.58Z"/>'
        },
        "chevron-double-left": {
            body: '<path fill="currentColor" d="M18.41 7.41L17 6l-6 6l6 6l1.41-1.41L13.83 12l4.58-4.59m-6 0L11 6l-6 6l6 6l1.41-1.41L7.83 12l4.58-4.59Z"/>'
        },
        "chevron-double-right": {
            body: '<path fill="currentColor" d="M5.59 7.41L7 6l6 6l-6 6l-1.41-1.41L10.17 12L5.59 7.41m6 0L13 6l6 6l-6 6l-1.41-1.41L16.17 12l-4.58-4.59Z"/>'
        },
        "chevron-double-up": {
            body: '<path fill="currentColor" d="M7.41 18.41L6 17l6-6l6 6l-1.41 1.41L12 13.83l-4.59 4.58m0-6L6 11l6-6l6 6l-1.41 1.41L12 7.83l-4.59 4.58Z"/>'
        },
        "chevron-down": {
            body: '<path fill="currentColor" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6l1.41-1.42Z"/>'
        },
        "chevron-double-left-custom": {
            body: '<path fill="currentColor" d="M12.529 5.33285C12.0084 4.81223 11.1643 4.81223 10.6437 5.33285L4.91982 11.0567C4.39912 11.5774 4.39912 12.4216 4.91982 12.9423L10.6437 18.6662C11.1643 19.1868 12.0084 19.1868 12.529 18.6662C13.0496 18.1456 13.0496 17.3015 12.529 16.7808L8.69049 12.9423C8.16979 12.4216 8.16979 11.5774 8.69049 11.0567L12.529 7.21818C13.0496 6.69756 13.0496 5.85347 12.529 5.33285Z" fill-opacity="0.54"/><path fill="currentColor" d="M17.3107 5.33285L11.5868 11.0567C11.0661 11.5774 11.0661 12.4216 11.5868 12.9423L17.3107 18.6662C17.8313 19.1868 18.6754 19.1868 19.196 18.6662C19.7166 18.1456 19.7166 17.3015 19.196 16.7808L15.3575 12.9423C14.8368 12.4216 14.8368 11.5774 15.3575 11.0567L19.196 7.21818C19.7166 6.69756 19.7166 5.85347 19.196 5.33285C18.6754 4.81223 17.8313 4.81223 17.3107 5.33285Z" fill-opacity="0.26"/>'
        },
        "chevron-double-right-custom": {
            body: '<path fill="currentColor" d="M11.471 18.6672C11.9916 19.1878 12.8357 19.1878 13.3563 18.6672L19.0802 12.9433C19.6009 12.4226 19.6009 11.5784 19.0802 11.0577L13.3563 5.33382C12.8357 4.8132 11.9916 4.8132 11.471 5.33382C10.9504 5.85444 10.9504 6.69853 11.471 7.21915L15.3095 11.0577C15.8302 11.5784 15.8302 12.4226 15.3095 12.9433L11.471 16.7818C10.9504 17.3024 10.9504 18.1465 11.471 18.6672Z" fill-opacity="0.54"/><path fill="currentColor" d="M6.68933 18.6672L12.4132 12.9433C12.9339 12.4226 12.9339 11.5784 12.4132 11.0577L6.68933 5.33382C6.16871 4.8132 5.32462 4.8132 4.80399 5.33382C4.28337 5.85444 4.28337 6.69853 4.80399 7.21915L8.64252 11.0577C9.16322 11.5784 9.16322 12.4226 8.64252 12.9433L4.80399 16.7818C4.28337 17.3024 4.28337 18.1465 4.80399 18.6672C5.32462 19.1878 6.16871 19.1878 6.68933 18.6672Z" fill-opacity="0.26"/>'
        },
        "chevron-down-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 12.71l-6-6l1.41-1.42L12 12.88l4.59-4.59L18 9.71l-6 6Z"/>'
        },
        "chevron-down-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14M7.41 8.29L12 12.88l4.59-4.59L18 9.71l-6 6l-6-6l1.41-1.42Z"/>'
        },
        "chevron-down-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M6 10l6 6l6-6l-1.4-1.4l-4.6 4.6l-4.6-4.6L6 10Z"/>'
        },
        "chevron-down-circle-outline": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8M6 10l6 6l6-6l-1.4-1.4l-4.6 4.6l-4.6-4.6L6 10Z"/>'
        },
        "chevron-left": {
            body: '<path fill="currentColor" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6l1.41-1.42Z"/>'
        },
        "chevron-left-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-3.29 13.59L14.29 18l-6-6l6-6l1.42 1.41L11.12 12l4.59 4.59Z"/>'
        },
        "chevron-left-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14M15.71 7.41L11.12 12l4.59 4.59L14.29 18l-6-6l6-6l1.42 1.41Z"/>'
        },
        "chevron-left-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-6.6 4.6L10.8 12l4.6-4.6L14 6l-6 6l6 6l1.4-1.4Z"/>'
        },
        "chevron-left-circle-outline": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m-4.6 4.6L10.8 12l4.6-4.6L14 6l-6 6l6 6l1.4-1.4Z"/>'
        },
        "chevron-right": {
            body: '<path fill="currentColor" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42Z"/>'
        },
        "chevron-right-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2M9.71 18l-1.42-1.41L12.88 12L8.29 7.41L9.71 6l6 6l-6 6Z"/>'
        },
        "chevron-right-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14M8.29 16.59L12.88 12L8.29 7.41L9.71 6l6 6l-6 6l-1.42-1.41Z"/>'
        },
        "chevron-right-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-12 6l6-6l-6-6l-1.4 1.4l4.6 4.6l-4.6 4.6L10 18Z"/>'
        },
        "chevron-right-circle-outline": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8M8.6 16.6l4.6-4.6l-4.6-4.6L10 6l6 6l-6 6l-1.4-1.4Z"/>'
        },
        "chevron-triple-down": {
            body: '<path fill="currentColor" d="M7.41 14.58L12 19.17l4.59-4.59L18 16l-6 6l-6-6l1.41-1.42m0-6L12 13.17l4.59-4.59L18 10l-6 6l-6-6l1.41-1.42m0-6L12 7.17l4.59-4.59L18 4l-6 6l-6-6l1.41-1.42Z"/>'
        },
        "chevron-triple-left": {
            body: '<path fill="currentColor" d="M9.42 7.41L4.83 12l4.59 4.59L8 18l-6-6l6-6l1.42 1.41m6 0L10.83 12l4.59 4.59L14 18l-6-6l6-6l1.42 1.41m6 0L16.83 12l4.59 4.59L20 18l-6-6l6-6l1.42 1.41Z"/>'
        },
        "chevron-triple-right": {
            body: '<path fill="currentColor" d="M14.58 16.59L19.17 12l-4.59-4.59L16 6l6 6l-6 6l-1.42-1.41m-6 0L13.17 12L8.58 7.41L10 6l6 6l-6 6l-1.42-1.41m-6 0L7.17 12L2.58 7.41L4 6l6 6l-6 6l-1.42-1.41Z"/>'
        },
        "chevron-triple-up": {
            body: '<path fill="currentColor" d="M16.59 9.42L12 4.83L7.41 9.42L6 8l6-6l6 6l-1.41 1.42m0 6L12 10.83l-4.59 4.59L6 14l6-6l6 6l-1.41 1.42m0 6L12 16.83l-4.59 4.59L6 20l6-6l6 6l-1.41 1.42Z"/>'
        },
        "chevron-up": {
            body: '<path fill="currentColor" d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6l-6 6l1.41 1.41Z"/>'
        },
        "chevron-up-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-2.41 12.71L12 11.12l-4.59 4.59L6 14.29l6-6l6 6l-1.41 1.42Z"/>'
        },
        "chevron-up-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-2.41-3.29L12 11.12l-4.59 4.59L6 14.29l6-6l6 6l-1.41 1.42Z"/>'
        },
        "chevron-up-circle": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M7.4 15.4l4.6-4.6l4.6 4.6L18 14l-6-6l-6 6l1.4 1.4Z"/>'
        },
        "chevron-up-circle-outline": {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-2 0a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8M7.4 15.4l4.6-4.6l4.6 4.6L18 14l-6-6l-6 6l1.4 1.4Z"/>'
        },
        "chili-alert": {
            body: '<path fill="currentColor" d="m9.25 7.5l-1.52-.87C8.26 5.7 9.03 5 9.94 4.69C9.8 4.29 9.44 4 9 4V2c1.54 0 2.79 1.16 2.97 2.65c.94.29 1.75 1.01 2.3 1.98l-1.52.87l-1.75-1l-1.75 1m4.75.78L12.75 9L11 8L9.25 9L8 8.28c-.6.35-1 .99-1 1.72v1c0 9 8 11 8 11V10c0-.73-.4-1.37-1-1.72M17 7v6h2V7h-2m0 10h2v-2h-2v2Z"/>'
        },
        "chili-alert-outline": {
            body: '<path fill="currentColor" d="M14 8.28L12.75 9L11 8L9.25 9L8 8.28c-.6.35-1 .99-1 1.72v1c0 9 8 11 8 11V10c0-.73-.4-1.37-1-1.72m-1 10.59c-1.77-1.18-3.83-3.43-4-7.44l2-1.13l2 1.15v7.42M9.25 7.5l-1.52-.87C8.26 5.7 9.03 5 9.94 4.69C9.8 4.29 9.44 4 9 4V2c1.54 0 2.79 1.16 2.97 2.65c.94.29 1.75 1.01 2.3 1.98l-1.52.87l-1.75-1l-1.75 1M19 7v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "chili-hot": {
            body: '<path fill="currentColor" d="m10.43 7.32l-1.57-.9C9.38 5.6 10.11 5 10.94 4.7A.99.99 0 0 0 10 4V2c.77 0 1.47.29 2 .77V4c.45 0 .81.3.94.7c-1.11.38-2.01 1.35-2.51 2.62M10 11c0-.77.23-1.5.6-2.09l-1.34-.76C8.5 8.44 8 9.16 8 10v1c0 7.05 4.9 9.8 7.03 10.66C12.41 19.62 10 16.2 10 11M6.43 7.32l-1.57-.9C5.38 5.6 6.11 5 6.94 4.7A.99.99 0 0 0 6 4V2c.77 0 1.47.29 2 .77V4c.45 0 .81.3.94.7c-1.11.38-2.01 1.35-2.51 2.62M6 11c0-.77.23-1.5.6-2.09l-1.34-.76C4.5 8.44 4 9.16 4 10v1c0 7.05 4.9 9.8 7.03 10.66C8.41 19.62 6 16.2 6 11m13-2.72L17.75 9L16 8l-1.75 1L13 8.28c-.6.35-1 .99-1 1.72v1c0 9 8 11 8 11V10c0-.73-.4-1.37-1-1.72m-6.27-1.65l1.52.87l1.75-1l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 14 2v2c.44 0 .8.29.94.69c-.91.31-1.68 1.01-2.21 1.94Z"/>'
        },
        "chili-hot-outline": {
            body: '<path fill="currentColor" d="M10.94 4.7A.99.99 0 0 0 10 4V2c.77 0 1.47.29 2 .77V4c.45 0 .81.3.94.7c-1.11.38-2.01 1.35-2.51 2.62l-1.57-.9C9.38 5.6 10.11 5 10.94 4.7M10 11c0-.77.23-1.5.6-2.09l-1.34-.76C8.5 8.44 8 9.16 8 10v1c0 7.05 4.9 9.8 7.03 10.66C12.41 19.62 10 16.2 10 11M8.94 4.7A.99.99 0 0 0 8 4V2.77C7.47 2.29 6.77 2 6 2v2c.45 0 .81.3.94.7c-.83.3-1.56.9-2.08 1.72l1.57.9c.5-1.27 1.4-2.24 2.51-2.62M6 11c0-.77.23-1.5.6-2.09l-1.34-.76C4.5 8.44 4 9.16 4 10v1c0 7.05 4.9 9.8 7.03 10.66C8.41 19.62 6 16.2 6 11m14-1v12s-8-2-8-11v-1c0-.73.4-1.37 1-1.72l1.25.72L16 8l1.75 1L19 8.28c.6.35 1 .99 1 1.72m-2 8.87v-7.42l-2-1.15l-2 1.13c.17 4.01 2.23 6.26 4 7.44M12.73 6.63l1.52.87l1.75-1l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 14 2v2c.44 0 .8.29.94.69c-.91.31-1.68 1.01-2.21 1.94Z"/>'
        },
        "chili-medium": {
            body: '<path fill="currentColor" d="m8.43 7.32l-1.57-.9C7.38 5.6 8.11 5 8.94 4.7A.99.99 0 0 0 8 4V2c.77 0 1.47.29 2 .77V4c.45 0 .81.3.94.7c-1.11.38-2.01 1.35-2.51 2.62M8 11c0-.77.23-1.5.6-2.09l-1.34-.76C6.5 8.44 6 9.16 6 10v1c0 7.05 4.9 9.8 7.03 10.66C10.41 19.62 8 16.2 8 11m9-2.72L15.75 9L14 8l-1.75 1L11 8.28c-.6.35-1 .99-1 1.72v1c0 9 8 11 8 11V10c0-.73-.4-1.37-1-1.72m-6.27-1.65l1.52.87l1.75-1l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 12 2v2c.44 0 .8.29.94.69c-.91.31-1.68 1.01-2.21 1.94Z"/>'
        },
        "chili-medium-outline": {
            body: '<path fill="currentColor" d="m8.43 7.32l-1.57-.9C7.38 5.6 8.11 5 8.94 4.7A.99.99 0 0 0 8 4V2c.77 0 1.47.29 2 .77V4c.45 0 .81.3.94.7c-1.11.38-2.01 1.35-2.51 2.62M8 11c0-.77.23-1.5.6-2.09l-1.34-.76C6.5 8.44 6 9.16 6 10v1c0 7.05 4.9 9.8 7.03 10.66C10.41 19.62 8 16.2 8 11m10-1v12s-8-2-8-11v-1c0-.73.4-1.37 1-1.72l1.25.72L14 8l1.75 1L17 8.28c.6.35 1 .99 1 1.72m-2 8.87v-7.42l-2-1.15l-2 1.13c.17 4.01 2.23 6.26 4 7.44M10.73 6.63l1.52.87l1.75-1l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 12 2v2c.44 0 .8.29.94.69c-.91.31-1.68 1.01-2.21 1.94Z"/>'
        },
        "chili-mild": {
            body: '<path fill="currentColor" d="M16 10v12s-8-2-8-11v-1c0-.73.4-1.37 1-1.72l1.25.72L12 8l1.75 1L15 8.28c.6.35 1 .99 1 1.72m-4-3.5l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 10 2v2c.44 0 .8.29.94.69c-.91.31-1.68 1.01-2.21 1.94l1.52.87l1.75-1Z"/>'
        },
        "chili-mild-outline": {
            body: '<path fill="currentColor" d="m10.25 7.5l-1.52-.87c.53-.93 1.3-1.63 2.21-1.94c-.14-.4-.5-.69-.94-.69V2c1.54 0 2.79 1.16 2.97 2.65c.94.29 1.75 1.01 2.3 1.98l-1.52.87l-1.75-1l-1.75 1M16 10v12s-8-2-8-11v-1c0-.73.4-1.37 1-1.72l1.25.72L12 8l1.75 1L15 8.28c.6.35 1 .99 1 1.72m-2 1.45l-2-1.15l-2 1.13c.17 4.01 2.23 6.26 4 7.44v-7.42Z"/>'
        },
        "chili-off": {
            body: '<path fill="currentColor" d="M15 8.28c.6.35 1 .99 1 1.72v2.8l-4.5-4.51L12 8l1.75 1L15 8.28M12 6.5l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 10 2v2c.44 0 .8.29.94.69c-.68.23-1.28.68-1.77 1.28l1.37 1.37L12 6.5M2.39 1.73L1.11 3L8 9.9V11c0 9 8 11 8 11v-4.11l4.84 4.84l1.27-1.27L2.39 1.73Z"/>'
        },
        "chili-off-outline": {
            body: '<path fill="currentColor" d="M15 8.28c.6.35 1 .99 1 1.72v2.8l-4.5-4.51L12 8l1.75 1L15 8.28M12 6.5l1.75 1l1.52-.87c-.55-.97-1.36-1.69-2.3-1.98A2.996 2.996 0 0 0 10 2v2c.44 0 .8.29.94.69c-.68.23-1.28.68-1.77 1.28l1.37 1.37L12 6.5m10.11 14.96l-1.27 1.27L16 17.89V22s-8-2-8-11V9.9L1.11 3l1.28-1.27l19.72 19.73M14 15.89l-3.93-3.93c.31 3.67 2.24 5.78 3.93 6.91v-2.98Z"/>'
        },
        chip: {
            body: '<path fill="currentColor" d="M6 4h12v1h3v2h-3v2h3v2h-3v2h3v2h-3v2h3v2h-3v1H6v-1H3v-2h3v-2H3v-2h3v-2H3V9h3V7H3V5h3V4m5 11v3h1v-3h-1m2 0v3h1v-3h-1m2 0v3h1v-3h-1Z"/>'
        },
        church: {
            body: '<path fill="currentColor" d="M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h8v-3c0-1.1.9-2 2-2s2 .9 2 2v3h8v-8l-4-1.78m-6 1.28c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"/>'
        },
        "church-outline": {
            body: '<path fill="currentColor" d="M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h9v-4c0-.55.45-1 1-1s1 .45 1 1v4h9v-8l-4-1.78M20 20h-5v-2.04c0-1.69-1.35-3.06-3-3.06s-3 1.37-3 3.06V20H4v-4.79l4-1.81v-3.35L12 8l4 2.04v3.35l4 1.81V20m-8-9.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        cigar: {
            body: '<path fill="currentColor" d="M16 10.2h-1.5a2 2 0 0 1-1.85-2a1.78 1.78 0 0 1 1.85-1.75V5a3.35 3.35 0 1 0 0 6.7H16a1.93 1.93 0 0 1 2 2V15h1.5v-1.64A3.31 3.31 0 0 0 16 10.2m2.82-2.47A3.34 3.34 0 0 0 16.5 2v1.5a1.85 1.85 0 1 1 0 3.7v1.5a4 4 0 0 1 4 4.07V15H22v-2.24a5.55 5.55 0 0 0-3.15-5.03M18 16v6h1.5v-6m1 0v6H22v-6m-10 0v1.27a2 2 0 0 1 0 3.46V22h5v-6m-14.12.88A3 3 0 0 0 5 22h5v-1.27a2 2 0 0 1 0-3.46V16H5a3 3 0 0 0-2.12.88M12 19a1 1 0 1 1-1-1a1 1 0 0 1 1 1Z"/>'
        },
        "cigar-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.11 20H18v-.11l-1-1V20h-5v-1.27a2 2 0 0 0 0-3.46V14h.11l-11-11l1.28-1.27l19.72 19.73l-1.27 1.27M14.5 9.7H16c1.07-.04 1.96.8 2 1.86V13h1.5v-1.64a3.302 3.302 0 0 0-3.45-3.16H14.5a1.999 1.999 0 0 1-1.85-2c.02-.98.85-1.77 1.81-1.75h.04V3a3.35 3.35 0 0 0 0 6.7m6 1V13H22v-2.24c0-2.14-1.22-4.1-3.15-5.03h-.03C19.58 5 19.9 4 19.8 3h-1.48a1.865 1.865 0 0 1-1.82 2.2v1.5c2.21 0 4 1.8 4 4M9.27 16c.18-.3.43-.55.73-.73V14H5a3 3 0 0 0-2.12 5.12c.57.56 1.33.88 2.12.88h5v-1.27A2.006 2.006 0 0 1 9.27 16M18 14.8l1.5 1.5V14H18v.8m2.5 2.5l1.5 1.5V14h-1.5v3.3M11 16c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        circle: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "circle-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 13c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4Z"/>'
        },
        "circle-box-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 5c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4Z"/>'
        },
        "circle-double": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m0 2a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        "circle-edit-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10h-2a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8V2m6.78 1a.69.69 0 0 0-.48.2l-1.22 1.21l2.5 2.5L20.8 5.7c.26-.26.26-.7 0-.95L19.25 3.2c-.13-.13-.3-.2-.47-.2m-2.41 2.12L9 12.5V15h2.5l7.37-7.38l-2.5-2.5Z"/>'
        },
        "circle-expand": {
            body: '<path fill="currentColor" d="m16 4l4 4V4m0 12l-4 4h4M8 20l-4-4v4M4 8l4-4H4m12.95 3.05a7.007 7.007 0 0 0-9.9 0a7.007 7.007 0 0 0 0 9.9a7.007 7.007 0 0 0 9.9 0c2.73-2.73 2.73-7.16 0-9.9m-1.1 8.8a5.402 5.402 0 0 1-7.7 0a5.402 5.402 0 0 1 0-7.7a5.402 5.402 0 0 1 7.7 0a5.402 5.402 0 0 1 0 7.7Z"/>'
        },
        "circle-half": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10V2Z"/>'
        },
        "circle-half-full": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8V4Z"/>'
        },
        "circle-medium": {
            body: '<path fill="currentColor" d="M12 8a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "circle-multiple": {
            body: '<path fill="currentColor" d="M15 4a8 8 0 1 1-8 8a8 8 0 0 1 8-8M3 12a6 6 0 0 0 4 5.65v2.09A8 8 0 0 1 7 4.26v2.09A6 6 0 0 0 3 12Z"/>'
        },
        "circle-multiple-outline": {
            body: '<path fill="currentColor" d="M15 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 14a6 6 0 0 0 6-6a6 6 0 0 0-6-6a6 6 0 0 0-6 6a6 6 0 0 0 6 6M3 12a5.99 5.99 0 0 0 4 5.65v2.09c-3.45-.89-6-4.01-6-7.74c0-3.73 2.55-6.85 6-7.74v2.09C4.67 7.17 3 9.39 3 12Z"/>'
        },
        "circle-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.95 2.95A9.95 9.95 0 0 0 2 12c0 5.5 4.5 10 10 10c2.28 0 4.37-.77 6.05-2.06l2.79 2.79l1.27-1.27M12 20c-4.42 0-8-3.58-8-8c0-1.73.56-3.32 1.5-4.62L16.62 18.5A7.78 7.78 0 0 1 12 20M8.17 4.97L6.72 3.5C8.25 2.56 10.06 2 12 2c5.5 0 10 4.5 10 10c0 1.94-.56 3.75-1.5 5.28l-1.47-1.45c.62-1.14.97-2.44.97-3.83c0-4.42-3.58-8-8-8c-1.39 0-2.69.35-3.83.97Z"/>'
        },
        "circle-opacity": {
            body: '<path fill="currentColor" d="M18 10V8h2v2h-2m0 2v-2h-2v2h2m0-4V6h-2v2h2m-2-5.16V4h2c-.63-.46-1.29-.85-2-1.16M18 4v2h2c-.58-.75-1.25-1.42-2-2m2 2v2h1.16c-.31-.71-.7-1.37-1.16-2m2 6c0-.68-.07-1.35-.2-2H20v2h2m-6-6V4h-2v2h2m0 10h2v-2h-2v2m2 2h2v-2h-2v2m-2 2h2v-2h-2v2m-2 1.8c.7-.14 1.36-.36 2-.64V20h-2v1.8m4-7.8h2v-2h-2v2m-2-6h-2v2h2V8m4 8h1.16c.28-.64.5-1.3.64-2H20v2m-4-4h-2v2h2v-2m-4 6v-2h2v-2h-2v-2h2v-2h-2V8h2V6h-2V4h2V2.2c-.65-.13-1.31-.2-2-.2C6.5 2 2 6.5 2 12s4.5 10 10 10v-2h2v-2h-2m2 0h2v-2h-2v2Z"/>'
        },
        "circle-outline": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "circle-slice-1": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c1.93 0 3.68.78 4.95 2.05L12 12V5Z"/>'
        },
        "circle-slice-2": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7h-7V5Z"/>'
        },
        "circle-slice-3": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7c0 1.93-.78 3.68-2.05 4.95L12 12V5Z"/>'
        },
        "circle-slice-4": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7s-3.13 7-7 7V5Z"/>'
        },
        "circle-slice-5": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.78-4.95-2.05L12 12V5Z"/>'
        },
        "circle-slice-6": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7s-3.13 7-7 7s-7-3.13-7-7h7V5Z"/>'
        },
        "circle-slice-7": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m0 1c3.87 0 7 3.13 7 7s-3.13 7-7 7s-7-3.13-7-7c0-1.93.78-3.68 2.05-4.95L12 12V5Z"/>'
        },
        "circle-slice-8": {
            body: '<path fill="currentColor" d="M12 5c3.87 0 7 3.13 7 7s-3.13 7-7 7s-7-3.13-7-7s3.13-7 7-7m0-3c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8Z"/>'
        },
        "circle-small": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2c1.11 0 2-.89 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "circular-saw": {
            body: '<path fill="currentColor" d="M13 11a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7.86 6.25A6.997 6.997 0 0 1 13 4c3.5 0 6.44 2.61 6.93 6H22v2h-6a3 3 0 0 0-3-3a3 3 0 0 0-3 3H2v-2h.05c.2-2.27 1.09-4.34 2.45-6l3.36 2.25M6.73 7.89L5.06 6.77c-.53.98-.88 2.07-1 3.23h2.01c.11-.75.33-1.46.66-2.11m.67 7.51L6 14h5.79c.24.42.71.7 1.21.7s.97-.28 1.21-.7H20v1.4c-1.61-.98-1.54.35-1.54.35v1.96l-1.96 1.96c-.5-1.75-1.4-.77-1.4-.77l-1.4 1.4h-2.8c.98-1.61-.35-1.54-.35-1.54H8.59L6.63 16.8c1.75-.49.77-1.4.77-1.4Z"/>'
        },
        "cisco-webex": {
            body: '<path d="M12 3a9 9 0 0 1 9 9a9 9 0 0 1-9 9a9 9 0 0 1-9-9a9 9 0 0 1 9-9M5.94 8.5a6.988 6.988 0 0 0 2.56 9.56c3.35 1.94 10.35-10.19 7-12.12A6.988 6.988 0 0 0 5.94 8.5z" fill="currentColor"/>',
            hidden: true
        },
        city: {
            body: '<path fill="currentColor" d="M19 15h-2v-2h2m0 6h-2v-2h2M13 7h-2V5h2m0 6h-2V9h2m0 6h-2v-2h2m0 6h-2v-2h2m-6-6H5V9h2m0 6H5v-2h2m0 6H5v-2h2m8-6V5l-3-3l-3 3v2H3v14h18V11h-6Z"/>'
        },
        "city-variant": {
            body: '<path fill="currentColor" d="M19 9V7a2 2 0 0 0-2-2h-1V2h-2v3h-1a2 2 0 0 0-2 2v2a2 2 0 0 0-2 2v1H5a2 2 0 0 0-2 2v8h3v-2h2v2h4v-2h2v2h2v-2h2v2h3V11a2 2 0 0 0-2-2M8 18H6v-2h2v2m6 0h-2v-2h2v2m0-4h-2v-2h2v2m-1-5V7h4v2h-4m5 9h-2v-2h2v2m0-4h-2v-2h2v2Z"/>'
        },
        "city-variant-outline": {
            body: '<path fill="currentColor" d="M15 23h-2v-2h2v2m4-2h-2v2h2v-2m-4-4h-2v2h2v-2m-8 4H5v2h2v-2m0-4H5v2h2v-2m12 0h-2v2h2v-2m-4-4h-2v2h2v-2m4 0h-2v2h2v-2m2-4a2 2 0 0 1 2 2v12h-2V11H11v12H9v-8H3v8H1v-8a2 2 0 0 1 2-2h6v-2a2 2 0 0 1 2-2V7a2 2 0 0 1 2-2h2V1h2v4h2a2 2 0 0 1 2 2v2m-2 0V7h-6v2h6Z"/>'
        },
        clipboard: {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1"/>'
        },
        "clipboard-account": {
            body: '<path fill="currentColor" d="M18 19H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1M12 7a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-account-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7m5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-4 8v-1c0-1.1 1.79-2 4-2s4 .9 4 2v1H8Z"/>'
        },
        "clipboard-alert": {
            body: '<path fill="currentColor" d="M12 5a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m1 9h-2V8h2m0 10h-2v-2h2m6-13h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-alert-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7m4 2h2v4.5h-2V9m0 6h2v2h-2v-2Z"/>'
        },
        "clipboard-arrow-down": {
            body: '<path fill="currentColor" d="m12 18l-5-5h3V9h4v4h3M12 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-arrow-down-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7m5 11l-5-5h3V9h4v4h3l-5 5Z"/>'
        },
        "clipboard-arrow-left": {
            body: '<path fill="currentColor" d="M16 15h-4v3l-5-5l5-5v3h4m-4-8a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-arrow-left-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7m0 6l5 5v-3h4v-4h-4V8l-5 5Z"/>'
        },
        "clipboard-arrow-right": {
            body: '<path fill="currentColor" d="m17 13l-5 5v-3H8v-4h4V8m0-5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-arrow-right-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7m9.91 6l-5 5v-3h-4v-4h4V8l5 5Z"/>'
        },
        "clipboard-arrow-up": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 5l-5 5h3v4h4v-4h3l-5-5m0-5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "clipboard-arrow-up-outline": {
            body: '<path fill="currentColor" d="m12 8l5 5h-3v4h-4v-4H7l5-5m7-5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 7V5H5v14h14V5h-2v2H7Z"/>'
        },
        "clipboard-check": {
            body: '<path fill="currentColor" d="m10 17l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9m-6-6a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-check-multiple": {
            body: '<path fill="currentColor" d="M4 7H2v14c0 1.1.9 2 2 2h14v-2H4M20 3h-3.2c-.4-1.2-1.5-2-2.8-2c-1.3 0-2.4.8-2.8 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6 0c.6 0 1 .5 1 1s-.5 1-1 1s-1-.5-1-1s.4-1 1-1m-1.7 12.1L9 11.8l1.4-1.4l1.9 1.9L17.6 7L19 8.4"/>'
        },
        "clipboard-check-multiple-outline": {
            body: '<path fill="currentColor" d="M4 7v14h14v2H4c-1.1 0-2-.9-2-2V7h2m8.8 8.35l-3.3-3.3l1.4-1.4l1.9 1.9l4.3-4.3l1.4 1.4l-5.7 5.7M20 3c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.18C11.6 1.84 12.7 1 14 1c1.3 0 2.4.84 2.82 2H20m-6 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-4 4V5H8v12h12V5h-2v2h-8Z"/>'
        },
        "clipboard-check-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2m.5 6.5L9 12l2 2l4.5-4.5L17 11l-6 6l-3.5-3.5Z"/>'
        },
        "clipboard-clock": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7c-1.91 0-3.63-.76-4.89-2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h4.18C9.6 1.84 10.7 1 12 1s2.4.84 2.82 2H19a2 2 0 0 1 2 2v6.11c1.24 1.26 2 2.98 2 4.89M11 4c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m10 12c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "clipboard-clock-outline": {
            body: '<path fill="currentColor" d="M21 11.11V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6.11c1.26 1.24 2.98 2 4.89 2c3.87 0 7-3.13 7-7c0-1.91-.76-3.63-2-4.89M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M5 19V5h2v2h10V5h2v4.68A6.995 6.995 0 0 0 9.68 19H5m11 2c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "clipboard-edit": {
            body: '<path fill="currentColor" d="M21.04 12.13c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17m-1.97 1.75l2.05 2.05L15.06 22H13v-2.06l6.07-6.06M19 3c1.1 0 2 .9 2 2v4L11 19v2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "clipboard-edit-outline": {
            body: '<path fill="currentColor" d="M21.04 12.13c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17m-1.97 1.75l2.05 2.05L15.06 22H13v-2.06l6.07-6.06M11 19l-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19c1.1 0 2 .9 2 2v4l-2 2V5h-2v2H7V5H5v14h6m1-16c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "clipboard-file": {
            body: '<path fill="currentColor" d="M19 3c1.1 0 2 .9 2 2v4.17L19.83 8H15c-2.21 0-4 1.79-4 4v9H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 20a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h4l4 4v7c0 1.11-.89 2-2 2h-6m6-8.17L18.17 12H18v3h3v-.17Z"/>'
        },
        "clipboard-file-outline": {
            body: '<path fill="currentColor" d="M15 23a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h4l4 4v7c0 1.11-.89 2-2 2h-6m0-2h6v-6.17L18.17 12H15v9m4-18c1.1 0 2 .9 2 2v4.17L19.83 8H19V5h-2v2H7V5H5v14h6v2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.18C9.6 1.84 10.7 1 12 1c1.3 0 2.4.84 2.82 2H19m-7 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "clipboard-flow": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m3 16l-4-4h3V8h2v7h3l-4 4m-5-3H8V9H5l4-4l4 4h-3v7"/>'
        },
        "clipboard-flow-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M7 7h10V5h2v14H5V5h2v2m3 9H8v-5H6l3-3l3 3h-2v5m4-6h2v5h2l-3 3l-3-3h2v-5Z"/>'
        },
        "clipboard-list": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M7 8h2v4H8V9H7V8m3 9v1H7v-.92L9 15H7v-1h2.25c.41 0 .75.34.75.75c0 .2-.08.39-.21.52L8.12 17H10m1-13c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m6 13h-5v-2h5v2m0-6h-5V9h5v2Z"/>'
        },
        "clipboard-list-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M7 7h10V5h2v14H5V5h2v2m5 10v-2h5v2h-5m0-6V9h5v2h-5m-4 1V9H7V8h2v4H8m1.25 2c.41 0 .75.34.75.75c0 .2-.08.39-.21.52L8.12 17H10v1H7v-.92L9 15H7v-1h2.25"/>'
        },
        "clipboard-minus": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m4 11H8v-2h8v2Z"/>'
        },
        "clipboard-minus-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m7 16H5V5h2v2h10V5h2v14M8 12h8v2H8v-2Z"/>'
        },
        "clipboard-multiple": {
            body: '<path fill="currentColor" d="M4 7H2v14c0 1.1.9 2 2 2h14v-2H4M20 3h-3.2c-.4-1.2-1.5-2-2.8-2c-1.3 0-2.4.8-2.8 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6 0c.6 0 1 .5 1 1s-.5 1-1 1s-1-.5-1-1s.4-1 1-1Z"/>'
        },
        "clipboard-multiple-outline": {
            body: '<path fill="currentColor" d="M4 7v14h14v2H4c-1.1 0-2-.9-2-2V7h2m16-4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.18C11.6 1.84 12.7 1 14 1c1.3 0 2.4.84 2.82 2H20m-6 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-4 4V5H8v12h12V5h-2v2h-8Z"/>'
        },
        "clipboard-off": {
            body: '<path fill="currentColor" d="M21 5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6.2L21 17.8V5m-9 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m10.11 16.46l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73Z"/>'
        },
        "clipboard-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3L3 4.9V19a2 2 0 0 0 2 2h14.1l1.74 1.73l1.27-1.27L2.39 1.73M5 19V6.89L17.11 19H5M17 7V5h2v10.8l2 2V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6.2l4 4H17m-5-4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "clipboard-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2Z"/>'
        },
        "clipboard-play": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.25 1.44 12.53.64 11 1.2c-.86.3-1.5.96-1.82 1.8H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-2 14V9l5 4l-5 4Z"/>'
        },
        "clipboard-play-multiple": {
            body: '<path fill="currentColor" d="M4 21h14v2H4c-1.1 0-2-.9-2-2V7h2m18-2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.2c.4-1.2 1.5-2 2.8-2c1.3 0 2.4.8 2.8 2H20c1.1 0 2 .9 2 2m-9-1c0 .5.5 1 1 1s1-.5 1-1s-.4-1-1-1s-1 .5-1 1m4 8l-5-4v8"/>'
        },
        "clipboard-play-multiple-outline": {
            body: '<path fill="currentColor" d="M4 7v14h14v2H4c-1.1 0-2-.9-2-2V7h2m16-4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.2c.4-1.2 1.5-2 2.8-2c1.3 0 2.4.8 2.8 2H20m-6 0c-.6 0-1 .5-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m-4 4V5H8v12h12V5h-2v2m-6 8V9l5 3"/>'
        },
        "clipboard-play-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.25 1.44 12.53.64 11 1.2c-.86.3-1.5.96-1.82 1.8H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2m3 10V9l5 4l-5 4Z"/>'
        },
        "clipboard-plus": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m1 9h3v2h-3v3h-2v-3H8v-2h3V9h2v3Z"/>'
        },
        "clipboard-plus-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M7 7h10V5h2v14H5V5h2v2m6 5h3v2h-3v3h-2v-3H8v-2h3V9h2v3Z"/>'
        },
        "clipboard-pulse": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M5 13.46h2.17l3.33-6.38l.94 6.97l2.49-3.19l2.6 2.6H19V15h-3.11l-1.82-1.79l-3.69 4.71l-.76-5.77L8.11 15H5v-1.54Z"/>'
        },
        "clipboard-pulse-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M5 15h3.11l1.51-2.85l.76 5.77l3.69-4.71L15.89 15H19v4H5v-4m14-1.54h-2.47l-2.6-2.6l-2.49 3.19l-.94-6.97l-3.33 6.38H5V5h2v1h10V5h2v8.46Z"/>'
        },
        "clipboard-remove": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m3.54 12.12l-1.42 1.42L12 14.41l-2.12 2.13l-1.41-1.42L10.59 13l-2.12-2.12l1.41-1.41L12 11.59l2.12-2.12l1.42 1.41L13.41 13l2.13 2.12Z"/>'
        },
        "clipboard-remove-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m7 16H5V5h2v2h10V5h2v14m-3.46-8.12L13.41 13l2.13 2.12l-1.42 1.42L12 14.41l-2.12 2.13l-1.41-1.42L10.59 13l-2.12-2.12l1.41-1.41L12 11.59l2.12-2.12l1.42 1.41Z"/>'
        },
        "clipboard-search": {
            body: '<path fill="currentColor" d="M11.9 10.9a6.505 6.505 0 0 1 9.1-.08V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.06c-.41-.26-.8-.55-1.16-.9a6.525 6.525 0 0 1 0-9.2M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8.31 14.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S12 13 12 15.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L22 22.39L23.39 21l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "clipboard-search-outline": {
            body: '<path fill="currentColor" d="M11.03 19H5V5h2v2h10V5h2v4.5c.72.3 1.4.74 2 1.32V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.06c-.41-.26-.8-.55-1.16-.9c-.33-.34-.63-.71-.87-1.1M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8.31 14.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S12 13 12 15.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L22 22.39L23.39 21l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "clipboard-text": {
            body: '<path fill="currentColor" d="M17 9H7V7h10m0 6H7v-2h10m-3 6H7v-2h7M12 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "clipboard-text-clock": {
            body: '<path fill="currentColor" d="M21 11.11V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6.11c1.26 1.24 2.98 2 4.89 2c3.87 0 7-3.13 7-7c0-1.91-.76-3.63-2-4.89M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M6 7h12v2H6V7m3.08 10H6v-2h3.08c-.05.33-.08.66-.08 1s.03.67.08 1M6 13v-2h5.11c-.61.57-1.07 1.25-1.43 2H6m10 8c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "clipboard-text-clock-outline": {
            body: '<path fill="currentColor" d="M21 11.11V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6.11c1.26 1.24 2.98 2 4.89 2c3.87 0 7-3.13 7-7c0-1.91-.76-3.63-2-4.89M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M5 19V5h2v2h10V5h2v4.68c-.91-.43-1.92-.68-3-.68H7v2h4.1c-.6.57-1.06 1.25-1.42 2H7v2h2.08c-.05.33-.08.66-.08 1c0 1.08.25 2.09.68 3H5m11 2c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "clipboard-text-multiple": {
            body: '<path fill="currentColor" d="M20 3h-3.2c-.4-1.2-1.5-2-2.8-2c-1.3 0-2.4.8-2.8 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6 0c.6 0 1 .5 1 1s-.5 1-1 1s-1-.5-1-1s.4-1 1-1m2 11H9v-2h7m3-2H9V8h10M4 21h14v2H4c-1.1 0-2-.9-2-2V7h2"/>'
        },
        "clipboard-text-multiple-outline": {
            body: '<path fill="currentColor" d="M4 7v14h14v2H4c-1.1 0-2-.9-2-2V7h2m16-4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.18C11.6 1.84 12.7 1 14 1c1.3 0 2.4.84 2.82 2H20m-6 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-4 4V5H8v12h12V5h-2v2m-3 8h-5v-2h5m3-2h-8V9h8v2Z"/>'
        },
        "clipboard-text-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3L3 4.9V19a2 2 0 0 0 2 2h14.1l1.74 1.73l1.27-1.27L2.39 1.73M7 11h2.11l2 2H7v-2m7 6H7v-2h6.11l.89.89V17m3-10v2h-4.8l2 2H17v2h-.8l4.8 4.8V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6.2l4 4H17m-5-4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "clipboard-text-off-outline": {
            body: '<path fill="currentColor" d="M17 7V5h2v10.8l2 2V5a2 2 0 0 0-2-2h-4.18C14.25 1.44 12.53.64 11 1.2c-.86.3-1.5.96-1.82 1.8H6.2l4 4H17m-5-4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m2.2 8l-2-2H17v2h-2.8M2.39 1.73L1.11 3L3 4.9V19a2 2 0 0 0 2 2h14.1l1.74 1.73l1.27-1.27L2.39 1.73M5 19V6.89L7.11 9H7v2h2.11l2 2H7v2h6.11l4 4H5Z"/>'
        },
        "clipboard-text-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.25 1.44 12.53.64 11 1.2c-.86.3-1.5.96-1.82 1.8H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2m10 4H7V9h10v2m-2 4H7v-2h8v2Z"/>'
        },
        "clipboard-text-play": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v8.34a5.92 5.92 0 0 0-2-.34c-3.32 0-6 2.69-6 6c0 .68.11 1.36.34 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.18c.32-.84.96-1.5 1.82-1.8c1.53-.56 3.25.24 3.82 1.8H19m-7 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-1 14v-2H7v2h4m2-4v-2H7v2h6m4-4V7H7v2h10m0 7l5 3l-5 3v-6Z"/>'
        },
        "clipboard-text-play-outline": {
            body: '<path fill="currentColor" d="M19 3h-4.18C14.25 1.44 12.53.64 11 1.2c-.86.3-1.5.96-1.82 1.8H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10v-2H5V5h2v2h10V5h2v9h2V5a2 2 0 0 0-2-2m-7 2a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m5 11v6l5-3l-5-3m0-5H7V9h10v2m-2 4H7v-2h8v2Z"/>'
        },
        "clipboard-text-search": {
            body: '<path fill="currentColor" d="M10.18 17H7v-2h3c.08-.68.23-1.36.5-2H7v-2h4.82c.03-.03.05-.06.08-.1A6.53 6.53 0 0 1 16.5 9H7V7h10v2h-.5c1.62 0 3.24.61 4.5 1.82V5a2 2 0 0 0-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.06c-.41-.26-.8-.55-1.16-.9c-.9-.89-1.45-1.97-1.72-3.1M12 3c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8.31 14.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S12 13 12 15.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L22 22.39L23.39 21l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "clipboard-text-search-outline": {
            body: '<path fill="currentColor" d="M17 9h-.5h.5M7 15h3c.08-.68.23-1.36.5-2H7v2m4.9-4.1A6.53 6.53 0 0 1 16.5 9H7v2h4.82c.03-.03.05-.06.08-.1m0 9.2c.36.35.75.64 1.16.9H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h4.18c.32-.84.96-1.5 1.82-1.8c1.53-.56 3.25.24 3.82 1.8H19a2 2 0 0 1 2 2v5.82a6.44 6.44 0 0 0-2-1.32V5h-2v2H7V5H5v14h6.03c.24.39.54.76.87 1.1M11 4c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m12.39 17L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        clippy: {
            body: '<path fill="currentColor" d="M15 15.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5v-1.75a.75.75 0 0 1 .75-.75a.75.75 0 0 1 .75.75v1.75a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-3.61c-.87-.28-1.5-1.02-1.5-1.89c0-1.1 1-2 2.25-2s2.25.9 2.25 2c0 .87-.63 1.61-1.5 1.89v3.61M8.25 8c1.25 0 2.25.9 2.25 2c0 .87-.63 1.61-1.5 1.89v5.36a3.25 3.25 0 0 0 3.25 3.25a3.25 3.25 0 0 0 3.25-3.25v-3.5a.75.75 0 0 1 .75-.75a.75.75 0 0 1 .75.75v3.5A4.75 4.75 0 0 1 12.25 22a4.75 4.75 0 0 1-4.75-4.75v-5.36C6.63 11.61 6 10.87 6 10c0-1.1 1-2 2.25-2m1.81-1.87l-.43 1.46c-.41-.22-.88-.34-1.38-.34c-.91 0-1.72.4-2.22 1.02l-1.2-.9C5.46 6.57 6.41 6 7.5 5.81v-.06A3.75 3.75 0 0 1 11.25 2A3.75 3.75 0 0 1 15 5.75v.06c1.09.19 2.04.76 2.67 1.56l-1.2.9c-.5-.62-1.31-1.02-2.22-1.02c-.5 0-.97.12-1.38.34l-.43-1.46c.33-.13.69-.26 1.06-.32v-.06c0-1.25-1-2.25-2.25-2.25S9 4.5 9 5.75v.06c.37.06.73.19 1.06.32m4.19 3.12c-.55 0-1 .34-1 .75s.45.75 1 .75s1-.34 1-.75s-.45-.75-1-.75m-6 0c-.55 0-1 .34-1 .75s.45.75 1 .75s1-.34 1-.75s-.45-.75-1-.75Z"/>'
        },
        clock: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7l-.8 1.3Z"/>'
        },
        "clock-alert": {
            body: '<path fill="currentColor" d="M20 12h2v6h-2v-6m0 8h2v2h-2v-2M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c2.3 0 4.3-.8 6-2V10h3.8c-.9-4.6-5-8-9.8-8m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7l-.8 1.3Z"/>'
        },
        "clock-alert-outline": {
            body: '<path fill="currentColor" d="M11 7v6l5.2 3.1l.8-1.2l-4.5-2.7V7H11m9 5v6h2v-6h-2m0 8v2h2v-2h-2m-2 0c-1.7 1.3-3.7 2-6 2c-5.5 0-10-4.5-10-10S6.5 2 12 2c4.8 0 8.9 3.4 9.8 8h-2.1c-.9-3.4-4-6-7.7-6c-4.4 0-8 3.6-8 8s3.6 8 8 8c2.4 0 4.5-1.1 6-2.7V20Z"/>'
        },
        "clock-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M13 19c0-1.5.5-2.8 1.4-3.9L11 13V7h1.5v5.2l3.1 1.9c1-.7 2.1-1.1 3.4-1.1c1 0 2 .3 2.8.7c.1-.6.2-1.1.2-1.7c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10c.6 0 1.2-.1 1.7-.2c-.4-.8-.7-1.8-.7-2.8Z"/>'
        },
        "clock-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5m-10.4 2.9c-.4.1-.7.1-1.1.1c-4.4 0-8-3.6-8-8s3.6-8 8-8s8 3.6 8 8c0 .4 0 .7-.1 1.1c.7.1 1.3.3 1.9.6c.1-.6.2-1.1.2-1.7c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10c.6 0 1.2-.1 1.7-.2c-.3-.5-.5-1.2-.6-1.9m2.5-5.8l-3.1-1.8V7H11v6l3.5 2.1c.3-.4.7-.7 1.1-1Z"/>'
        },
        "clock-digital": {
            body: '<path fill="currentColor" d="M2 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M2 8h20v8H2m1-7v1.5h3.25L3 15h1.75L8 10.5V9m1.25 0v1.5h1.5V9M12 9v1.5h1.5V15H15V9m2 0a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-2.5 1.5h2v3h-2m-8.25 0V15h1.5v-1.5"/>'
        },
        "clock-edit": {
            body: '<path fill="currentColor" d="M21 13.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V23h2.1l6.1-6.1l-2.1-2m-8.1 7c-5.1-.5-9-4.8-9-9.9C2 6.5 6.5 2 12 2c5.3 0 9.6 4.1 10 9.3c-.3-.1-.6-.2-1-.2c-.8 0-1.4.4-1.8.8l-2.7 2.7l-4-2.4V7H11v6l4.4 2.7l-4.4 4.4v1.8Z"/>'
        },
        "clock-edit-outline": {
            body: '<path fill="currentColor" d="M21 13.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V23h2.1l6.1-6.1l-2.1-2M12.5 7v5.2l4 2.4l-1 1L11 13V7h1.5M11 21.9c-5.1-.5-9-4.8-9-9.9C2 6.5 6.5 2 12 2c5.3 0 9.6 4.1 10 9.3c-.3-.1-.6-.2-1-.2s-.7.1-1 .2C19.6 7.2 16.2 4 12 4c-4.4 0-8 3.6-8 8c0 4.1 3.1 7.5 7.1 7.9l-.1.2v1.8Z"/>'
        },
        "clock-end": {
            body: '<path fill="currentColor" d="M12 1C8.14 1 5 4.14 5 8a7 7 0 0 0 7 7c3.86 0 7-3.13 7-7c0-3.86-3.14-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85c0 2.68-2.18 4.85-4.85 4.85A4.85 4.85 0 0 1 7.15 8A4.85 4.85 0 0 1 12 3.15M11 5v3.69l3.19 1.84l.75-1.3l-2.44-1.41V5M15 16v3H3v2h12v3l4-4m0 0v4h2v-8h-2"/>'
        },
        "clock-fast": {
            body: '<path fill="currentColor" d="M15 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m-1 2h1.5v3.78l2.33 2.33l-1.06 1.06L14 12.4V8M2 18a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3.83c.31.71.71 1.38 1.17 2H2m1-5a1 1 0 0 1-1-1a1 1 0 0 1 1-1h2.05L5 12l.05 1H3m1-5a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3c-.46.62-.86 1.29-1.17 2H4Z"/>'
        },
        "clock-in": {
            body: '<path fill="currentColor" d="M2.21.79L.79 2.21l4.01 4L3 8h5V3L6.21 4.8M12 8c-3.86 0-7 3.13-7 7a7 7 0 0 0 7 7c3.86 0 7-3.13 7-7a7 7 0 0 0-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85A4.85 4.85 0 0 1 12 19.85c-2.68 0-4.85-2.17-4.85-4.85A4.85 4.85 0 0 1 12 10.15M11 12v3.69l3.19 1.84l.75-1.3l-2.44-1.41V12"/>'
        },
        "clock-minus": {
            body: '<path fill="currentColor" d="M13.72 21.84c-.56.1-1.13.16-1.72.16c-5.5 0-10-4.5-10-10S6.5 2 12 2s10 4.5 10 10c0 .59-.06 1.16-.16 1.72A5.9 5.9 0 0 0 19 13c-1.26 0-2.43.39-3.4 1.06l-3.1-1.86V7H11v6l3.43 2.11A5.963 5.963 0 0 0 13 19c0 1.03.26 2 .72 2.84M15 18v2h8v-2h-8Z"/>'
        },
        "clock-minus-outline": {
            body: '<path fill="currentColor" d="M14.47 15.08L11 13V7h1.5v5.25l3.08 1.83c-.41.28-.79.62-1.11 1m-1.39 4.84c-.36.05-.71.08-1.08.08c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8c0 .37-.03.72-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10S2 6.5 2 12s4.47 10 10 10c.59 0 1.16-.06 1.72-.16c-.32-.59-.54-1.23-.64-1.92M15 18v2h8v-2h-8Z"/>'
        },
        "clock-out": {
            body: '<path fill="currentColor" d="m18 1l1.8 1.79l-4.01 4l1.42 1.42l4-4L23 6V1M12 8c-3.86 0-7 3.13-7 7a7 7 0 0 0 7 7c3.86 0 7-3.13 7-7a7 7 0 0 0-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85A4.85 4.85 0 0 1 12 19.85c-2.68 0-4.85-2.17-4.85-4.85A4.85 4.85 0 0 1 12 10.15M11 12v3.69l3.19 1.84l.75-1.3l-2.44-1.41V12"/>'
        },
        "clock-outline": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7h1.5Z"/>'
        },
        "clock-plus": {
            body: '<path fill="currentColor" d="M13.72 21.84c-.56.1-1.13.16-1.72.16c-5.5 0-10-4.5-10-10S6.5 2 12 2s10 4.5 10 10c0 .59-.06 1.16-.16 1.72A5.9 5.9 0 0 0 19 13c-1.26 0-2.43.39-3.4 1.06l-3.1-1.86V7H11v6l3.43 2.11A5.963 5.963 0 0 0 13 19c0 1.03.26 2 .72 2.84M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "clock-plus-outline": {
            body: '<path fill="currentColor" d="M14.47 15.08L11 13V7h1.5v5.25l3.08 1.83c-.41.28-.79.62-1.11 1m-1.39 4.84c-.36.05-.71.08-1.08.08c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8c0 .37-.03.72-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10S2 6.5 2 12s4.47 10 10 10c.59 0 1.16-.06 1.72-.16c-.32-.59-.54-1.23-.64-1.92M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "clock-remove": {
            body: '<path fill="currentColor" d="M13.72 21.84c-.56.1-1.13.16-1.72.16c-5.5 0-10-4.5-10-10S6.5 2 12 2s10 4.5 10 10c0 .59-.06 1.16-.16 1.72A5.9 5.9 0 0 0 19 13c-1.26 0-2.43.39-3.4 1.06l-3.1-1.86V7H11v6l3.43 2.11A5.963 5.963 0 0 0 13 19c0 1.03.26 2 .72 2.84m7.4-6.38L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "clock-remove-outline": {
            body: '<path fill="currentColor" d="M14.47 15.08L11 13V7h1.5v5.25l3.08 1.83c-.41.28-.79.62-1.11 1m-1.39 4.84c-.36.05-.71.08-1.08.08c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8c0 .37-.03.72-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10S2 6.5 2 12s4.47 10 10 10c.59 0 1.16-.06 1.72-.16c-.32-.59-.54-1.23-.64-1.92m8.04-4.46L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "clock-start": {
            body: '<path fill="currentColor" d="M12 1C8.14 1 5 4.14 5 8a7 7 0 0 0 7 7c3.86 0 7-3.13 7-7c0-3.86-3.14-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85c0 2.68-2.18 4.85-4.85 4.85A4.85 4.85 0 0 1 7.15 8A4.85 4.85 0 0 1 12 3.15M11 5v3.69l3.19 1.84l.75-1.3l-2.44-1.41V5M4 16v8h2v-3h12v3l4-4l-4-4v3H6v-3"/>'
        },
        "clock-time-eight": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M7.7 15.5L7 14.2l4-2.3V7h1.5v5.8l-4.8 2.7Z"/>'
        },
        "clock-time-eight-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 10.8l-4.8 2.8l-.7-1.4l4-2.3V7h1.5v5.8Z"/>'
        },
        "clock-time-eleven": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H11L8.5 8.6l1.3-.8L11 10V7h1.5v6Z"/>'
        },
        "clock-time-eleven-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 5v6H11L8.5 8.6l1.3-.8L11 10V7h1.5Z"/>'
        },
        "clock-time-five": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m2 15l-3-5.2V7h1.5v4.4l2.8 4.9l-1.3.7Z"/>'
        },
        "clock-time-five-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m3.3 14.2L14 17l-3-5.2V7h1.5v4.4l2.8 4.8Z"/>'
        },
        "clock-time-four": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4.3 13.2L11 12.3V7h1.5v4.4l4.5 2.5l-.7 1.3Z"/>'
        },
        "clock-time-four-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m5 11.9l-.7 1.3l-5.3-2.9V7h1.5v4.4l4.5 2.5Z"/>'
        },
        "clock-time-nine": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H7v-1.5h4V7h1.5v6Z"/>'
        },
        "clock-time-nine-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 5v6H7v-1.5h4V7h1.5Z"/>'
        },
        "clock-time-one": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.3 11H11V7h1.5v2.7L14 7.1l1.3.8l-3 5.1Z"/>'
        },
        "clock-time-one-outline": {
            body: '<path fill="currentColor" d="M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10C6.47 22 2 17.5 2 12S6.5 2 12 2m3.3 5.8l-3 5.2H11V7h1.5v2.65l1.5-2.6l1.3.75Z"/>'
        },
        "clock-time-seven": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 10.2L9.8 17l-1.3-.8l2.5-4.4V7h1.5v5.2Z"/>'
        },
        "clock-time-seven-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 5v5.2L9.8 17l-1.3-.8l2.5-4.4V7h1.5Z"/>'
        },
        "clock-time-six": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 15H11V7h1.5v10Z"/>'
        },
        "clock-time-six-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 5v10H11V7h1.5Z"/>'
        },
        "clock-time-ten": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H11l-4-2.3l.8-1.3l3.3 1.9V7h1.5v6Z"/>'
        },
        "clock-time-ten-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m.5 11H11l-4-2.3l.8-1.3l3.3 1.9V7h1.5v6Z"/>'
        },
        "clock-time-three": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m5 11h-6V7h1.5v4.5H17V13Z"/>'
        },
        "clock-time-three-outline": {
            body: '<path fill="currentColor" d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m5 9.5V13h-6V7h1.5v4.5H17Z"/>'
        },
        "clock-time-twelve": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H11V7h1.5v6Z"/>'
        },
        "clock-time-twelve-outline": {
            body: '<path fill="currentColor" d="M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10C6.47 22 2 17.5 2 12S6.5 2 12 2m.5 11.03H11V7h1.5v6.03Z"/>'
        },
        "clock-time-two": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m.5 11H11V7h1.5v4.3l3.7-2.1l.8 1.3l-4.5 2.5Z"/>'
        },
        "clock-time-two-outline": {
            body: '<path fill="currentColor" d="M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10C6.47 22 2 17.5 2 12S6.5 2 12 2m.5 11H11V7h1.5v4.26l3.7-2.13l.75 1.3L12.5 13Z"/>'
        },
        close: {
            body: '<path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/>'
        },
        "close-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-3.4 14L12 13.4L8.4 17L7 15.6l3.6-3.6L7 8.4L8.4 7l3.6 3.6L15.6 7L17 8.4L13.4 12l3.6 3.6l-1.4 1.4Z"/>'
        },
        "close-box-multiple": {
            body: '<path fill="currentColor" d="M4 20h14v2H4a2 2 0 0 1-2-2V6h2v14M20.22 2H7.78C6.8 2 6 2.8 6 3.78v12.44C6 17.2 6.8 18 7.78 18h12.44c.98 0 1.78-.8 1.78-1.78V3.78C22 2.8 21.2 2 20.22 2M19 13.6L17.6 15L14 11.4L10.4 15L9 13.6l3.6-3.6L9 6.4L10.4 5L14 8.6L17.6 5L19 6.4L15.4 10l3.6 3.6Z"/>'
        },
        "close-box-multiple-outline": {
            body: '<path fill="currentColor" d="M20 2H8c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14H8V4h12v12M4 6v14h14v2H4a2 2 0 0 1-2-2V6h2m5.77 6.84L12.6 10L9.77 7.15l1.4-1.4L14 8.6l2.84-2.83l1.4 1.4L15.4 10l2.83 2.84l-1.4 1.4L14 11.4l-2.83 2.84l-1.4-1.4Z"/>'
        },
        "close-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14M17 8.4L13.4 12l3.6 3.6l-1.4 1.4l-3.6-3.6L8.4 17L7 15.6l3.6-3.6L7 8.4L8.4 7l3.6 3.6L15.6 7L17 8.4Z"/>'
        },
        "close-circle": {
            body: '<path fill="currentColor" d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z"/>'
        },
        "close-circle-multiple": {
            body: '<path fill="currentColor" d="M2 12c0-2.79 1.64-5.2 4-6.32V3.5C2.5 4.76 0 8.09 0 12s2.5 7.24 6 8.5v-2.18C3.64 17.2 2 14.79 2 12m13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9s9-4.04 9-9s-4.04-9-9-9m5 12.59L18.59 17L15 13.41L11.41 17L10 15.59L13.59 12L10 8.41L11.41 7L15 10.59L18.59 7L20 8.41L16.41 12L20 15.59Z"/>'
        },
        "close-circle-multiple-outline": {
            body: '<path fill="currentColor" d="m18.54 9.88l-1.42-1.41L15 10.59l-2.12-2.12l-1.41 1.41L13.59 12l-2.12 2.12l1.41 1.42L15 13.41l2.12 2.13l1.42-1.42L16.41 12M2 12c0-2.79 1.64-5.2 4-6.32V3.5C2.5 4.76 0 8.09 0 12s2.5 7.24 6 8.5v-2.18C3.64 17.2 2 14.79 2 12m13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9s9-4.04 9-9s-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7Z"/>'
        },
        "close-circle-outline": {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m2.59 6L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8Z"/>'
        },
        "close-network": {
            body: '<path fill="currentColor" d="M14.59 6L12 8.59L9.41 6L8 7.41L10.59 10L8 12.59L9.41 14L12 11.41L14.59 14L16 12.59L13.41 10L16 7.41L14.59 6M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/>'
        },
        "close-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m8.54-2.88L13.41 10l2.12-2.13l-1.41-1.41L12 8.59L9.88 6.46L8.47 7.87L10.59 10l-2.12 2.13l1.41 1.41L12 11.41l2.12 2.13l1.42-1.42Z"/>'
        },
        "close-octagon": {
            body: '<path fill="currentColor" d="M8.27 3L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3M8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41"/>'
        },
        "close-octagon-outline": {
            body: '<path fill="currentColor" d="M8.27 3L3 8.27v7.46L8.27 21h7.46C17.5 19.24 21 15.73 21 15.73V8.27L15.73 3M9.1 5h5.8L19 9.1v5.8L14.9 19H9.1L5 14.9V9.1m4.12-1.39L7.71 9.12L10.59 12l-2.88 2.88l1.41 1.41L12 13.41l2.88 2.88l1.41-1.41L13.41 12l2.88-2.88l-1.41-1.41L12 10.59"/>'
        },
        "close-outline": {
            body: '<path fill="currentColor" d="M3 16.74L7.76 12L3 7.26L7.26 3L12 7.76L16.74 3L21 7.26L16.24 12L21 16.74L16.74 21L12 16.24L7.26 21L3 16.74m9-3.33l4.74 4.75l1.42-1.42L13.41 12l4.75-4.74l-1.42-1.42L12 10.59L7.26 5.84L5.84 7.26L10.59 12l-4.75 4.74l1.42 1.42L12 13.41Z"/>'
        },
        "close-thick": {
            body: '<path fill="currentColor" d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z"/>'
        },
        "closed-caption": {
            body: '<path fill="currentColor" d="M18 11h-1.5v-.5h-2v3h2V13H18v1a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1m-7 1H9.5v-.5h-2v3h2V13H11v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1m8-6H5c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "closed-caption-outline": {
            body: '<path fill="currentColor" d="M5 4c-.55 0-1 .18-1.41.57C3.2 4.96 3 5.44 3 6v12c0 .56.2 1.04.59 1.43c.41.39.86.57 1.41.57h14c.5 0 1-.19 1.39-.59c.41-.41.61-.88.61-1.41V6c0-.53-.2-1-.61-1.41C20 4.19 19.5 4 19 4H5m-.5 1.5h15v13h-15v-13M7 9c-.3 0-.53.09-.72.28c-.19.19-.28.42-.28.72v4c0 .3.09.53.28.72c.19.19.42.28.72.28h3c.27 0 .5-.09.71-.28c.2-.19.29-.42.29-.72v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.3-.09-.53-.29-.72C10.5 9.09 10.27 9 10 9H7m7 0c-.27 0-.5.09-.71.28c-.2.19-.29.42-.29.72v4c0 .3.09.53.29.72c.21.19.44.28.71.28h3c.3 0 .53-.09.72-.28c.19-.19.28-.42.28-.72v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.3-.09-.53-.28-.72C17.53 9.09 17.3 9 17 9h-3Z"/>'
        },
        cloud: {
            body: '<path fill="currentColor" d="M19.35 10.03A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-alert": {
            body: '<path fill="currentColor" d="M19 20H6c-3.3 0-6-2.7-6-6c0-3.1 2.3-5.6 5.3-6C6.6 5.6 9.1 4 12 4c3.6 0 6.7 2.6 7.4 6c2.6.2 4.6 2.3 4.6 5s-2.3 5-5 5m-8-5v2h2v-2h-2m0-2h2V7h-2v6Z"/>'
        },
        "cloud-braces": {
            body: '<path fill="currentColor" d="M6 20a6 6 0 0 1-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4a7.5 7.5 0 0 1 7.35 6A5.02 5.02 0 0 1 24 15a5 5 0 0 1-5 5H6m12.5-8H18a1 1 0 0 1-1-1v-1a2 2 0 0 0-2-2h-1.5v2H15v1a2 2 0 0 0 2 2a2 2 0 0 0-2 2v1h-1.5v2H15a2 2 0 0 0 2-2v-1a1 1 0 0 1 1-1h.5v-2m-13 0v2H6a1 1 0 0 1 1 1v1a2 2 0 0 0 2 2h1.5v-2H9v-1a2 2 0 0 0-2-2a2 2 0 0 0 2-2v-1h1.5V8H9a2 2 0 0 0-2 2v1a1 1 0 0 1-1 1h-.5Z"/>'
        },
        "cloud-check": {
            body: '<path fill="currentColor" d="m10 17l-3.5-3.5l1.41-1.42L10 14.17L15.18 9l1.41 1.41m2.76-.38A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-check-outline": {
            body: '<path fill="currentColor" d="M19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.5 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3m.35-7.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 6 20h13c2.76 0 5-2.24 5-5c0-2.64-2.05-4.78-4.65-4.97M10 17l-3.5-3.5l1.41-1.42L10 14.17l4.59-4.58L16 11"/>'
        },
        "cloud-circle": {
            body: '<path fill="currentColor" d="M16.5 16H8a3 3 0 0 1-3-3a3 3 0 0 1 3-3h.14c.44-1.72 1.99-3 3.86-3a4 4 0 0 1 4 4h.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "cloud-download": {
            body: '<path fill="currentColor" d="m17 13l-5 5l-5-5h3V9h4v4m5.35-2.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-download-outline": {
            body: '<path fill="currentColor" d="M8 13h2.55v-3h2.9v3H16l-4 4l-4-4m11.35-2.96c2.6.18 4.65 2.32 4.65 4.96a5 5 0 0 1-5 5H6a6 6 0 0 1-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4a7.49 7.49 0 0 1 7.35 6.04M19 18a3 3 0 0 0 3-3a2.98 2.98 0 0 0-2.78-2.96l-1.53-.11l-.3-1.5A5.503 5.503 0 0 0 12 6C9.94 6 8.08 7.14 7.13 8.97l-.5.95l-1.07.11A3.973 3.973 0 0 0 2 14a4 4 0 0 0 4 4h13Z"/>'
        },
        "cloud-lock": {
            body: '<path fill="currentColor" d="M22 17c.5 0 1 .5 1 1v4c0 .5-.5 1-1 1h-5c-.5 0-1-.5-1-1v-4c0-.5.5-1 1-1v-1.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5V17m-1 0v-1.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V17h3m-1.64-7.97C21.95 9.22 24 11.36 24 14l-.06.77A4.497 4.497 0 0 0 19.5 11C17 11 15 13 15 15.5v.26c-.61.55-1 1.35-1 2.24v1H6c-3.31 0-6-2.69-6-6c0-3.1 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 3c3.64 0 6.67 2.59 7.36 6.03Z"/>'
        },
        "cloud-lock-outline": {
            body: '<path fill="currentColor" d="M22 17c.5 0 1 .5 1 1v4c0 .5-.5 1-1 1h-5c-.5 0-1-.5-1-1v-4c0-.5.5-1 1-1v-1.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5V17m-1 0v-1.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V17h3m-3.5-6v-.5C17.5 7.46 15.04 5 12 5C9.5 5 7.37 6.69 6.71 9H6c-2.21 0-4 1.79-4 4s1.79 4 4 4h8.17a3 3 0 0 0-.17 1v1H6c-3.31 0-6-2.69-6-6c0-3.1 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 3c3.64 0 6.67 2.6 7.36 6.04C21.95 9.22 24 11.36 24 14l-.06.77A4.497 4.497 0 0 0 19.5 11h-2Z"/>'
        },
        "cloud-off-outline": {
            body: '<path fill="currentColor" d="m7.73 10l8 8H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4M3 5.27L5.75 8C2.56 8.15 0 10.77 0 14a6 6 0 0 0 6 6h11.73l2 2L21 20.73L4.27 4m15.08 6.03A7.49 7.49 0 0 0 12 4c-1.5 0-2.85.43-4 1.17l1.45 1.46C10.21 6.23 11.08 6 12 6a5.5 5.5 0 0 1 5.5 5.5v.5H19a3 3 0 0 1 3 3c0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-outline": {
            body: '<path fill="currentColor" d="M19 18H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4h.71C7.37 7.69 9.5 6 12 6a5.5 5.5 0 0 1 5.5 5.5v.5H19a3 3 0 0 1 3 3a3 3 0 0 1-3 3m.35-7.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-percent": {
            body: '<path fill="currentColor" d="M19.35 10.03A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 6 20h13c2.76 0 5-2.24 5-5c0-2.64-2.05-4.78-4.65-4.97m-9.9-1c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42m5.1 7.94c-.78 0-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42s1.42.64 1.42 1.42s-.64 1.42-1.42 1.42M9.2 17L8 15.8L14.8 9l1.2 1.2L9.2 17Z"/>'
        },
        "cloud-percent-outline": {
            body: '<path fill="currentColor" d="M9.45 9.03c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42m5.1 7.94c-.78 0-1.42-.64-1.42-1.42c0-.78.64-1.42 1.42-1.42s1.42.64 1.42 1.42c0 .78-.64 1.42-1.42 1.42M9.2 17L8 15.8L14.8 9l1.2 1.2L9.2 17m10.15-6.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 6 20h13c2.76 0 5-2.24 5-5c0-2.64-2.05-4.78-4.65-4.97M19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.5 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3Z"/>'
        },
        "cloud-print": {
            body: '<path fill="currentColor" d="M12 2C9.11 2 6.6 3.64 5.35 6.04A5.994 5.994 0 0 0 0 12a6 6 0 0 0 6 6v4h12v-4h1a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0 0 12 2M8 13h8v7H8v-7m1 1v1h6v-1H9m0 2v1h6v-1H9m0 2v1h6v-1H9Z"/>'
        },
        "cloud-print-outline": {
            body: '<path fill="currentColor" d="M19 16a3 3 0 0 0 3-3a3 3 0 0 0-3-3h-1.5v-.5A5.5 5.5 0 0 0 12 4C9.5 4 7.37 5.69 6.71 8H6a4 4 0 0 0-4 4a4 4 0 0 0 4 4v-5h12v5h1m.36-7.96C21.95 8.22 24 10.36 24 13a5 5 0 0 1-5 5h-1v4H6v-4a6 6 0 0 1-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 2c3.64 0 6.67 2.6 7.36 6.04M8 13v7h8v-7H8m1 5h6v1H9v-1m6-1H9v-1h6v1m-6-3h6v1H9v-1Z"/>'
        },
        "cloud-question": {
            body: '<path fill="currentColor" d="M19.35 10.03A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97M13 17h-2v-2h2v2m1.8-5.18c-.3.39-.67.68-1.13.93c-.26.16-.43.32-.52.51A1.7 1.7 0 0 0 13 14h-2c0-.55.11-.92.3-1.18c.2-.26.55-.57 1.07-.91c.26-.16.47-.35.63-.59c.15-.23.23-.51.23-.82c0-.32-.09-.56-.27-.74c-.18-.2-.46-.29-.76-.29c-.27 0-.49.08-.7.23c-.15.15-.25.38-.25.69H9.28c-.05-.75.22-1.39.78-1.8C10.6 8.2 11.31 8 12.2 8c.94 0 1.69.23 2.23.68c.54.45.81 1.07.81 1.82c0 .5-.15.91-.44 1.32Z"/>'
        },
        "cloud-refresh": {
            body: '<path fill="currentColor" d="M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96c0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4m5 9V9l-1 1a5.002 5.002 0 0 0-9 3c0 2.76 2.24 5 5 5c2.05 0 3.81-1.23 4.58-3h-2.34c-.55.61-1.35 1-2.24 1c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.09 0 2.04.58 2.56 1.44L13 13h4Z"/>'
        },
        "cloud-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5m3.85-5.97C21.95 8.22 24 10.36 24 13c0 1.64-.79 3.1-2 4v-.5a6.5 6.5 0 0 0-6.5-6.5A6.5 6.5 0 0 0 9 16.5c0 .5.06 1 .17 1.5H6a6 6 0 0 1-6-6c0-3.1 2.34-5.64 5.35-5.97A7.506 7.506 0 0 1 12 2a7.49 7.49 0 0 1 7.35 6.03Z"/>'
        },
        "cloud-search-outline": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5m6.5-1a3 3 0 0 0-3-3h-1.5v-.5A5.5 5.5 0 0 0 12 4C9.5 4 7.37 5.69 6.71 8H6a4 4 0 0 0-4 4a4 4 0 0 0 4 4h3v.5c0 .5.06 1 .17 1.5H6a6 6 0 0 1-6-6c0-3.1 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 2c3.64 0 6.67 2.59 7.36 6.04C21.95 8.22 24 10.36 24 13c0 1.65-.79 3.1-2 4v-.5c0-.73-.12-1.44-.35-2.1c.22-.4.35-.9.35-1.4Z"/>'
        },
        "cloud-sync": {
            body: '<path fill="currentColor" d="M19 12v1.5c2.21 0 4 1.79 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25l-.03-.03c.06-.05.13-.09 2.28-2.22m0 11v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25l.03.03c-.06.05-.13.09-2.28 2.22m-6-5.5a6.5 6.5 0 0 1 6.5-6.5c1.28 0 2.47.38 3.5 1c-.87-1.1-2.16-1.86-3.65-1.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 6 20h7.5c-.32-.77-.5-1.61-.5-2.5Z"/>'
        },
        "cloud-sync-outline": {
            body: '<path fill="currentColor" d="M19 12v1.5c2.21 0 4 1.79 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25l-.03-.03c.06-.05.13-.09 2.28-2.22m0 11v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25l.03.03c-.06.05-.13.09-2.28 2.22m-5.97-5H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.5 6 12 6c3 0 5.4 2.37 5.5 5.32c.62-.21 1.3-.32 2-.32c1.28 0 2.47.38 3.5 1c-.87-1.1-2.16-1.86-3.65-1.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 6 20h7.5c-.26-.62-.42-1.3-.47-2Z"/>'
        },
        "cloud-tags": {
            body: '<path fill="currentColor" d="M6 20a6 6 0 0 1-6-6c0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4a7.5 7.5 0 0 1 7.35 6A5.02 5.02 0 0 1 24 15a5 5 0 0 1-5 5H6M9.09 8.4L4.5 13l4.59 4.6l1.41-1.42L7.32 13l3.18-3.18L9.09 8.4m5.82 0L13.5 9.82L16.68 13l-3.18 3.18l1.41 1.42L19.5 13l-4.59-4.6Z"/>'
        },
        "cloud-upload": {
            body: '<path fill="currentColor" d="M14 13v4h-4v-4H7l5-5l5 5m2.35-2.97A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"/>'
        },
        "cloud-upload-outline": {
            body: '<path fill="currentColor" d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.96M19 18H6a4 4 0 0 1-4-4c0-2.05 1.53-3.76 3.56-3.97l1.07-.11l.5-.95A5.469 5.469 0 0 1 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5l1.53.11A2.98 2.98 0 0 1 22 15a3 3 0 0 1-3 3M8 13h2.55v3h2.9v-3H16l-4-4l-4 4Z"/>'
        },
        clouds: {
            body: '<path fill="currentColor" d="M19.19 12.07c.5-.53.81-1.25.81-2.07c0-1.7-1.3-3.16-3-3.16h-2.8C14.2 4.17 12.03 2 9.36 2c-2.05 0-3.8 1.28-4.51 3.08A3.967 3.967 0 0 0 1 9.04A3.97 3.97 0 0 0 4.96 13H8.1c-.06.33-.1.66-.1 1h-.5C5.57 14 4 15.57 4 17.5S5.57 21 7.5 21h11c2.5 0 4.5-2 4.5-4.5c0-2.24-1.66-4.09-3.81-4.43M18.5 19h-11c-.83 0-1.5-.67-1.5-1.5S6.67 16 7.5 16H10v-2c0-1.93 1.57-3.5 3.5-3.5S17 12.07 17 14h1.5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        clover: {
            body: '<path fill="currentColor" d="M12 11.18c3.3-3 5-4.54 5-6.49C17 3.19 15.75 2 14.25 2c-.86 0-1.68.36-2.25 1c-.57-.64-1.39-1-2.31-1C8.19 2 7 3.25 7 4.75c0 1.89 1.7 3.43 5 6.43m-.82.82c-3-3.3-4.54-5-6.49-5C3.19 7 2 8.25 2 9.75c0 .86.36 1.68 1 2.25c-.64.57-1 1.39-1 2.31C2 15.81 3.25 17 4.75 17c1.89 0 3.43-1.7 6.43-5m1.65 0c2.99 3.3 4.53 5 6.48 5c1.5 0 2.69-1.25 2.69-2.75c0-.86-.36-1.68-1-2.25c.64-.57 1-1.39 1-2.31C22 8.19 20.75 7 19.25 7c-1.89 0-3.43 1.7-6.42 5m-.83.82c-3.3 3-5 4.54-5 6.49C7 20.81 8.25 22 9.75 22c.86 0 1.68-.36 2.25-1c.57.64 1.39 1 2.31 1c1.5 0 2.69-1.25 2.69-2.75c0-1.89-1.7-3.43-5-6.43Z"/>'
        },
        "coach-lamp": {
            body: '<path fill="currentColor" d="m16 5l-1-3h-2l-1 3l-6 3h2l.6 3H4V7H2v10h2v-4h5l1 5l2 2l1 2h2l1-2l2-2l2-10h2m-5.84 9h-4.32L10 8h8Z"/>'
        },
        "coach-lamp-variant": {
            body: '<path fill="currentColor" d="M12.5 2L12 4l-2 2.31L5 9h2l2.5 9l2.5 2l.5 2h1l.5-2l2.5-2L19 9h2l-5-2.69L14 4l-.5-2M9 9h8l-2.22 8h-3.56M3 14v8h8.5l-.5-2H8l-3-3v-3Z"/>'
        },
        "coat-rack": {
            body: '<path fill="currentColor" d="M18.33 7.78a1 1 0 0 0-1.67 1.11A2 2 0 1 1 13 10V7.82a3 3 0 1 0-2 0V10a2 2 0 1 1-3.66-1.11a1 1 0 1 0-1.67-1.11A4 4 0 0 0 11 13.46V20a2 2 0 0 0-2 2h6a2 2 0 0 0-2-2v-6.54a4 4 0 0 0 5.33-5.68M12 4a1 1 0 1 1-1 1a1 1 0 0 1 1-1Z"/>'
        },
        "code-array": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m3 1v12h4v-2H8V8h2V6H6m10 10h-2v2h4V6h-4v2h2v8Z"/>'
        },
        "code-braces": {
            body: '<path fill="currentColor" d="M8 3a2 2 0 0 0-2 2v4a2 2 0 0 1-2 2H3v2h1a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h2v-2H8v-5a2 2 0 0 0-2-2a2 2 0 0 0 2-2V5h2V3m6 0a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h1v2h-1a2 2 0 0 0-2 2v4a2 2 0 0 1-2 2h-2v-2h2v-5a2 2 0 0 1 2-2a2 2 0 0 1-2-2V5h-2V3h2Z"/>'
        },
        "code-braces-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-8 5H9v2c0 1.1-.9 2-2 2c1.1 0 2 .9 2 2v2h2v2H9c-1.1 0-2-.9-2-2v-1c0-1.1-.9-2-2-2v-2c1.1 0 2-.9 2-2V8c0-1.1.9-2 2-2h2v2m8 5c-1.1 0-2 .9-2 2v1c0 1.1-.9 2-2 2h-2v-2h2v-2c0-1.1.9-2 2-2c-1.1 0-2-.9-2-2V8h-2V6h2c1.1 0 2 .9 2 2v1c0 1.1.9 2 2 2v2Z"/>'
        },
        "code-brackets": {
            body: '<path fill="currentColor" d="M15 4v2h3v12h-3v2h5V4M4 4v16h5v-2H6V6h3V4H4Z"/>'
        },
        "code-equal": {
            body: '<path fill="currentColor" d="M6 13h5v2H6m7-2h5v2h-5m0-6h5v2h-5M6 9h5v2H6M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-greater-than": {
            body: '<path fill="currentColor" d="M10.41 7.41L15 12l-4.59 4.6L9 15.18L12.18 12L9 8.82M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-greater-than-or-equal": {
            body: '<path fill="currentColor" d="M13 13h5v2h-5m0-6h5v2h-5M6.91 7.41L11.5 12l-4.59 4.6l-1.41-1.42L8.68 12L5.5 8.82M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-json": {
            body: '<path fill="currentColor" d="M5 3h2v2H5v5a2 2 0 0 1-2 2a2 2 0 0 1 2 2v5h2v2H5c-1.07-.27-2-.9-2-2v-4a2 2 0 0 0-2-2H0v-2h1a2 2 0 0 0 2-2V5a2 2 0 0 1 2-2m14 0a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h1v2h-1a2 2 0 0 0-2 2v4a2 2 0 0 1-2 2h-2v-2h2v-5a2 2 0 0 1 2-2a2 2 0 0 1-2-2V5h-2V3h2m-7 12a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "code-less-than": {
            body: '<path fill="currentColor" d="M13.59 7.41L9 12l4.59 4.6L15 15.18L11.82 12L15 8.82M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14Z"/>'
        },
        "code-less-than-or-equal": {
            body: '<path fill="currentColor" d="M13 13h5v2h-5m0-6h5v2h-5m-2.91-3.59l1.41 1.41L8.32 12l3.18 3.18l-1.41 1.42L5.5 12M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-not-equal": {
            body: '<path fill="currentColor" d="M6 15h2v2H6m5-4h7v2h-7m0-6h7v2h-7M6 7h2v6H6M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-not-equal-variant": {
            body: '<path fill="currentColor" d="M11 6.5v2.83L8.33 12L11 14.67v2.83L5.5 12M13 6.43L18.57 12L13 17.57v-2.83L15.74 12L13 9.26M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "code-parentheses": {
            body: '<path fill="currentColor" d="M17.62 3C19.13 5.27 20 8.55 20 12c0 3.44-.87 6.72-2.38 9L16 19.96c1.26-1.89 2-4.83 2-7.96s-.74-6.08-2-7.97L17.62 3M6.38 3L8 4.04C6.74 5.92 6 8.87 6 12s.74 6.08 2 7.96L6.38 21C4.87 18.73 4 15.45 4 12s.87-6.73 2.38-9Z"/>'
        },
        "code-parentheses-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 14.3l-1.6.7C6.9 16.5 6 14.3 6 12s.9-4.5 2.4-6l1.6.7C8.7 7.9 8 9.9 8 12s.7 4.1 2 5.3m5.6.7l-1.6-.7c1.3-1.3 2-3.2 2-5.3s-.7-4.1-2-5.3l1.6-.7c1.5 1.5 2.4 3.7 2.4 6s-.9 4.5-2.4 6Z"/>'
        },
        "code-string": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m9.5 6h-1A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 11.5 8h1A1.5 1.5 0 0 1 14 9.5h2A3.5 3.5 0 0 0 12.5 6h-1A3.5 3.5 0 0 0 8 9.5a3.5 3.5 0 0 0 3.5 3.5h1a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5H8a3.5 3.5 0 0 0 3.5 3.5h1a3.5 3.5 0 0 0 3.5-3.5a3.5 3.5 0 0 0-3.5-3.5Z"/>'
        },
        "code-tags": {
            body: '<path fill="currentColor" d="m14.6 16.6l4.6-4.6l-4.6-4.6L16 6l6 6l-6 6l-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6l6 6l1.4-1.4Z"/>'
        },
        "code-tags-check": {
            body: '<path fill="currentColor" d="M6.59 3.41L2 8l4.59 4.6L8 11.18L4.82 8L8 4.82L6.59 3.41m5.82 0L11 4.82L14.18 8L11 11.18l1.41 1.42L17 8l-4.59-4.59m9.18 8.18l-8.09 8.09L9.83 16l-1.41 1.41l5.08 5.09L23 13l-1.41-1.41Z"/>'
        },
        codepen: {
            body: '<path fill="currentColor" d="m8.21 12l-1.33.89v-1.78l1.33.89m3.26-2.18V7.34l-4.16 2.78l1.85 1.24l2.31-1.54m5.23.3l-4.17-2.78v2.48l2.31 1.54l1.86-1.24m-9.39 3.76l4.16 2.78v-2.48l-2.31-1.54l-1.85 1.24m5.22.3v2.48l4.17-2.78l-1.86-1.24l-2.31 1.54M12 10.74L10.12 12L12 13.26L13.88 12L12 10.74M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-3.82-1.88v-.07l-.01-.05l-.01-.05c-.01-.01-.01-.02-.02-.04l-.01-.02l-.02-.04l-.01-.02l-.02-.03l-.02-.03l-.03-.03l-.03-.02V9.7l-.04-.02l-.01-.01l-5.65-3.76a.528.528 0 0 0-.59 0L6.05 9.67v.01L6 9.7v.02l-.03.02l-.03.03l-.01.03l-.03.03l-.01.02l-.02.04l-.01.02l-.02.04V10h-.01l-.01.05v3.9l.01.05h.01v.05c.01.01.01.02.02.04l.01.02l.02.04l.01.02l.02.03l.02.03l.03.03l.03.02v.02l.04.02l.01.01l5.66 3.77c.08.06.19.08.29.08c.1 0 .21-.03.3-.08l5.65-3.77l.01-.01l.04-.02v-.02l.03-.02l.03-.03l.02-.03l.02-.03l.01-.02l.02-.04l.01-.02l.02-.04V14h.01l.01-.05v-3.83m-1.06 2.77v-1.78l-1.33.89l1.33.89Z"/>'
        },
        coffee: {
            body: '<path fill="currentColor" d="M2 21h18v-2H2M20 8h-2V5h2m0-2H4v10a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-3h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "coffee-maker": {
            body: '<path fill="currentColor" d="M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0 0 18 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1m-5 2c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "coffee-maker-check": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M13 18c0-2.22 1.21-4.15 3-5.19V11H6v5c0 1.64.81 3.09 2.03 4H4V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4h2V2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10.54A5.93 5.93 0 0 1 13 18m-3-9c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1Z"/>'
        },
        "coffee-maker-check-outline": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M13 18.21c-.5.49-1.22.79-2 .79c-1.65 0-3-1.35-3-3v-3h6v1.69c.5-.77 1.2-1.42 2-1.88V11H6v5c0 1.64.81 3.09 2.03 4H4V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4h2V2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10.54c-.91-1-1.48-2.33-1.54-3.79M10 9c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1Z"/>'
        },
        "coffee-maker-outline": {
            body: '<path fill="currentColor" d="M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0 0 18 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1m-8 10v-3h6v3c0 1.65-1.35 3-3 3s-3-1.35-3-3m3-8c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "coffee-off": {
            body: '<path fill="currentColor" d="M3.27 2L22 20.72L20.72 22l-.99-1H2v-2h15.73l-2.29-2.29c-.44.18-.94.29-1.44.29H8c-2.21 0-4-1.79-4-4V5.27l-2-2L3.27 2M22 5v3c0 1.1-.9 2-2 2h-2v3c0 .36-.06.7-.15 1.04L6.81 3H20a2 2 0 0 1 2 2m-2 0h-2v3h2V5Z"/>'
        },
        "coffee-off-outline": {
            body: '<path fill="currentColor" d="m2 3.27l2 2V13c0 2.21 1.79 4 4 4h6c.5 0 1-.11 1.44-.29L17.73 19H2v2h17.73l.99 1L22 20.72L3.27 2L2 3.27M8 15c-1.1 0-2-.9-2-2V7.27L13.73 15H8M20 3H6.81l2 2H16v7.19l1.85 1.85c.09-.34.15-.68.15-1.04v-3h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 5h-2V5h2v3Z"/>'
        },
        "coffee-outline": {
            body: '<path fill="currentColor" d="M2 21v-2h18v2H2M20 8V5h-2v3h2m0-5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V3h16m-4 2H6v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V5Z"/>'
        },
        "coffee-to-go": {
            body: '<path fill="currentColor" d="M3 19v-2h14l-1.74-1.76l1.41-1.41L20.84 18l-4.17 4.17l-1.41-1.41L17 19H3M17 8V5h-2v3h2m0-5a2 2 0 0 1 2 2v3c0 1.11-.89 2-2 2h-2v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V3h14Z"/>'
        },
        "coffee-to-go-outline": {
            body: '<path fill="currentColor" d="M3 3v8a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-1h2c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2H3m2 2h8v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5m10 0h2v3h-2V5m1.67 8.83l-1.41 1.41L17 17H3v2h14l-1.74 1.76l1.41 1.41L20.84 18l-4.17-4.17Z"/>'
        },
        coffin: {
            body: '<path fill="currentColor" d="M8 22L5 8l3-6h8l3 6l-3 14H8m3-16v2H9v2h2v5h2v-5h2V8h-2V6h-2Z"/>'
        },
        cog: {
            body: '<path fill="currentColor" d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"/>'
        },
        "cog-box": {
            body: '<path fill="currentColor" d="M17.25 12c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.29.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.19.69l-.25 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.3L10 16.85c-.44-.18-.83-.41-1.19-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.351.351 0 0 1 .08-.45l1.48-1.16c-.03-.22-.05-.45-.05-.68c0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 0 1-.08-.45l1.4-2.42c.09-.16.27-.22.43-.16l1.74.71c.36-.28.75-.52 1.19-.69l.25-1.86c.03-.16.18-.29.35-.29h2.8c.17 0 .32.13.35.29L14 7.15c.43.17.83.41 1.19.69l1.74-.71c.16-.06.34 0 .43.16l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.22.05.45.05.68M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 7c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "cog-clockwise": {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0 0 18c2 0 3.92-.66 5.5-1.86l-1.44-1.44A6.995 6.995 0 0 1 5 12c0-3.87 3.13-7 7-7s7 3.13 7 7h-3l4 4l4-4h-3a9 9 0 0 0-9-9M7.71 13.16c-.09.07-.12.19-.07.29l.9 1.55c.06.12.18.12.28.12l1.13-.45c.24.16.49.3.75.42l.18 1.19c.02.11.12.19.22.19h1.8c.1.03.21-.06.23-.17l.18-1.18c.27-.12.53-.27.76-.45l1.12.45c.11.04.23-.01.28-.12l.9-1.5c.05-.12.02-.24-.06-.31l-1-.74c.03-.3.03-.6 0-.9l1-.76c.09-.07.11-.18.06-.29l-.9-1.55a.226.226 0 0 0-.28-.1l-1.12.45c-.24-.17-.5-.3-.77-.42l-.17-1.19a.244.244 0 0 0-.23-.19h-1.76c-.1 0-.19.07-.21.17l-.17 1.18c-.26.12-.53.27-.76.45l-1.15-.42a.234.234 0 0 0-.29.12l-.91 1.5c-.05.12-.02.24.06.31l1 .74c-.02.15-.02.3 0 .45c-.01.15-.01.3 0 .45l-1 .74m4.29.31c-.84 0-1.5-.68-1.5-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5"/>'
        },
        "cog-counterclockwise": {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0-9 9H0l4 4l4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 0 1-11.06 5.7L6.5 19.14C8.08 20.34 10 21 12 21a9 9 0 0 0 0-18m4.29 10.19l-1-.74c.01-.15.01-.3 0-.45c.02-.15.02-.3 0-.45l1-.74c.08-.07.11-.19.06-.31L15.44 9a.234.234 0 0 0-.29-.12L14 9.3c-.23-.18-.5-.33-.76-.45l-.17-1.18a.214.214 0 0 0-.21-.17H11.1c-.1 0-.21.08-.23.19l-.17 1.19c-.27.12-.53.25-.77.42l-1.12-.45a.23.23 0 0 0-.28.1l-.9 1.55c-.05.11-.03.22.06.29l1 .76c-.03.3-.03.6 0 .9l-1 .74c-.08.07-.11.19-.06.31l.9 1.5c.05.11.17.16.28.12l1.12-.45c.23.18.49.33.76.45l.18 1.18c.02.11.13.2.23.17h1.8c.1 0 .21-.08.22-.19l.18-1.19c.26-.12.51-.26.75-.42l1.13.45c.1 0 .22 0 .28-.12l.9-1.55c.05-.1.02-.22-.07-.29M12 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .82-.66 1.5-1.5 1.5"/>'
        },
        "cog-off": {
            body: '<path fill="currentColor" d="M22.12 21.46L2.4 1.73L1.12 3L4 5.87L2.34 8.73c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1s.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.51-.21.96-.48 1.39-.79l4.59 4.59l1.27-1.27M12 15.5c-1.93 0-3.5-1.57-3.5-3.5c0-.5.12-.92.29-1.33l4.54 4.54c-.41.18-.83.29-1.33.29m-.26-6.97L8.56 5.35c.19-.1.37-.2.57-.28l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.12.22.07.49-.12.64L19.43 11c.04.34.07.67.07 1s-.03.65-.07.97l2.11 1.66c.19.15.24.42.12.64l-1.16 2.02l-5.03-5.03c.03-.08.03-.17.03-.26c0-1.93-1.57-3.5-3.5-3.5c-.09 0-.17 0-.26.03Z"/>'
        },
        "cog-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L4 5.88L2.34 8.73c-.13.22-.07.49.12.64L4.57 11l-.07 1l.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.51-.2.96-.48 1.39-.78l4.58 4.58l1.27-1.27M10 11.9l2.1 2.1H12a2 2 0 0 1-2-2v-.1m3.13 5.49L12.76 20h-1.52l-.37-2.62a5.444 5.444 0 0 1-3.01-1.76l-2.43 1.04l-.75-1.3L6.8 13.8a5.55 5.55 0 0 1 0-3.6L4.69 8.65l.75-1.3l.06.02l2.9 2.92C8.15 10.8 8 11.38 8 12c0 2.21 1.79 4 4 4c.62 0 1.2-.14 1.71-.4l1.12 1.12c-.52.31-1.09.54-1.7.67M10.06 6.86L8.55 5.35c.19-.09.38-.2.58-.28l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-1.16 2.02l-1.46-1.45l.28-.48l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4h-1.5l-.37 2.61c-.28.06-.56.14-.82.25M12 8c2.21 0 4 1.79 4 4c0 .25-.03.5-.07.73l-4.66-4.66c.23-.04.48-.07.73-.07Z"/>'
        },
        "cog-outline": {
            body: '<path fill="currentColor" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42h-4m1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04l.75-1.3l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4h-1.5Z"/>'
        },
        "cog-pause": {
            body: '<path fill="currentColor" d="M13.53 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66c-.04-.32-.07-.64-.07-.97s.03-.66.07-1L2.46 9.37a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.12.22.07.49-.12.64L19.43 11c.04.34.07.67.07 1v.19c-.5-.12-1-.19-1.5-.19c-.92 0-1.78.21-2.56.58c.03-.19.06-.38.06-.58c0-1.93-1.57-3.5-3.5-3.5S8.5 10.07 8.5 12s1.57 3.5 3.5 3.5c.2 0 .39-.03.58-.06a5.97 5.97 0 0 0 .95 6.56M19 15h2v6h-2m-4-6h2v6h-2v-6Z"/>'
        },
        "cog-pause-outline": {
            body: '<path fill="currentColor" d="M13.54 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1v.19c-.5-.12-1-.19-1.5-.19c-.17 0-.34 0-.5.03c0-.62-.1-1.24-.3-1.83l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4h-1.5l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.11c.26.75.65 1.42 1.19 2m-1.18-6.04c-.12.04-.24.04-.36.04c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4c0 .12 0 .24-.04.36a6.045 6.045 0 0 0-3.6 3.6M14 12c0-1.1-.89-2-2-2s-2 .9-2 2s.9 2 2 2s2-.89 2-2m5 3h2v6h-2m-4-6h2v6h-2v-6Z"/>'
        },
        "cog-play": {
            body: '<path fill="currentColor" d="M13.53 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66c-.04-.32-.07-.64-.07-.97s.03-.66.07-1L2.46 9.37a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.12.22.07.49-.12.64L19.43 11c.04.34.07.67.07 1v.19c-.5-.12-1-.19-1.5-.19c-.92 0-1.78.21-2.56.58c.03-.19.06-.38.06-.58c0-1.93-1.57-3.5-3.5-3.5S8.5 10.07 8.5 12s1.57 3.5 3.5 3.5c.2 0 .39-.03.58-.06a5.97 5.97 0 0 0 .95 6.56M16 15v6l5-3l-5-3Z"/>'
        },
        "cog-play-outline": {
            body: '<path fill="currentColor" d="M13.54 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1v.19c-.5-.12-1-.19-1.5-.19c-.17 0-.34 0-.5.03c0-.62-.1-1.24-.3-1.83l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4h-1.5l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.11c.26.75.65 1.42 1.19 2m2.42-9.64c.04-.12.04-.24.04-.36c0-2.21-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4c.12 0 .24 0 .36-.04a6.045 6.045 0 0 1 3.6-3.6M12 14c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m4 1v6l5-3l-5-3Z"/>'
        },
        "cog-refresh": {
            body: '<path fill="currentColor" d="M18 14.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4m-6.5 4c0-1.1.3-2.1.7-3H12c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5c0 .2 0 .4-.1.5c.8-.3 1.6-.5 2.6-.5c.5 0 1 .1 1.5.2V12c0-.3 0-.7-.1-1l2.1-1.6c.2-.2.2-.4.1-.6l-2-3.5c-.1-.3-.3-.3-.6-.3l-2.5 1c-.5-.4-1.1-.7-1.7-1l-.4-2.7c.1-.1-.2-.3-.4-.3h-4c-.2 0-.5.2-.5.4l-.4 2.7c-.6.2-1.1.6-1.7.9L5 5c-.3 0-.5 0-.7.3l-2 3.5c-.1.2 0 .4.2.6L4.6 11c0 .3-.1.7-.1 1s0 .7.1 1l-2.1 1.7c-.2.2-.2.4-.1.6l2 3.5c.1.2.3.2.6.2l2.5-1c.5.4 1.1.7 1.7 1l.4 2.7c0 .2.2.4.5.4h2.5c-.7-1.1-1.1-2.3-1.1-3.6Z"/>'
        },
        "cog-refresh-outline": {
            body: '<path fill="currentColor" d="M18 14.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4M11.7 20h-.4l-.4-2.6c-1.2-.2-2.2-.9-3-1.8l-2.4 1l-.8-1.3l2.1-1.6c-.4-1.2-.4-2.4 0-3.6L4.7 8.7l.8-1.3l2.4 1c.8-.9 1.8-1.5 3-1.8l.3-2.6h1.5l.4 2.6c1.2.2 2.3.9 3 1.8l2.4-1l.8 1.3l-2.1 1.5c.2.6.3 1.2.3 1.8h.5c.5 0 1 .1 1.5.2V12l-.1-1l2.1-1.6c.2-.2.2-.4.1-.6l-2-3.5c-.1-.3-.3-.3-.6-.3l-2.5 1c-.5-.4-1.1-.7-1.7-1l-.4-2.7c.1-.1-.2-.3-.4-.3h-4c-.2 0-.5.2-.5.4l-.4 2.7c-.6.2-1.1.6-1.7.9L5 5c-.3 0-.5 0-.7.3l-2 3.5c-.1.2 0 .4.2.6L4.6 11l-.1 1l.1 1l-2.1 1.7c-.2.2-.2.4-.1.6l2 3.5c.1.2.3.2.6.2l2.5-1c.5.4 1.1.7 1.7 1l.4 2.7c0 .2.2.4.5.4h2.5c-.5-.7-.7-1.4-.9-2.1m4.3-7.7V12c0-2.2-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4c.7-1.7 2.2-3.1 4-3.7m-6-.3c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2Z"/>'
        },
        "cog-stop": {
            body: '<path fill="currentColor" d="M13.53 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66c-.04-.32-.07-.64-.07-.97s.03-.66.07-1L2.46 9.37a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.12.22.07.49-.12.64L19.43 11c.04.34.07.67.07 1v.19c-.5-.12-1-.19-1.5-.19c-.92 0-1.78.21-2.56.58c.03-.19.06-.38.06-.58c0-1.93-1.57-3.5-3.5-3.5S8.5 10.07 8.5 12s1.57 3.5 3.5 3.5c.2 0 .39-.03.58-.06a5.97 5.97 0 0 0 .95 6.56M21 15h-6v6h6v-6Z"/>'
        },
        "cog-stop-outline": {
            body: '<path fill="currentColor" d="M13.54 22H10c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1v.19c-.5-.12-1-.19-1.5-.19c-.17 0-.34 0-.5.03c0-.62-.1-1.24-.3-1.83l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4h-1.5l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.11c.26.75.65 1.42 1.19 2m-1.18-6.04c-.12.04-.24.04-.36.04c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4c0 .12 0 .24-.04.36a6.045 6.045 0 0 0-3.6 3.6M14 12c0-1.1-.89-2-2-2s-2 .9-2 2s.9 2 2 2s2-.89 2-2m1 3h6v6h-6v-6Z"/>'
        },
        "cog-sync": {
            body: '<path fill="currentColor" d="M11.5 18.5c0-1.1.3-2.1.7-3H12c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5c0 .2 0 .4-.1.5c.8-.3 1.6-.5 2.6-.5c.5 0 1 .1 1.5.2V12c0-.3 0-.7-.1-1l2.1-1.6c.2-.2.2-.4.1-.6l-2-3.5c-.1-.3-.3-.3-.6-.3l-2.5 1c-.5-.4-1.1-.7-1.7-1l-.4-2.7c.1-.1-.2-.3-.4-.3h-4c-.2 0-.5.2-.5.4l-.4 2.7c-.6.2-1.1.6-1.7.9L5 5c-.3 0-.5 0-.7.3l-2 3.5c-.1.2 0 .4.2.6L4.6 11c0 .3-.1.7-.1 1s0 .7.1 1l-2.1 1.7c-.2.2-.2.4-.1.6l2 3.5c.1.2.3.2.6.2l2.5-1c.5.4 1.1.7 1.7 1l.4 2.7c0 .2.2.4.5.4h2.5c-.7-1.1-1.1-2.3-1.1-3.6m6.5-4V13l-2.2 2.2l2.2 2.2V16c1.4 0 2.5 1.1 2.5 2.5c0 .4-.1.8-.3 1.1l1.1 1.1c1.2-1.8.7-4.3-1.1-5.5c-.6-.5-1.4-.7-2.2-.7m0 6.5c-1.4 0-2.5-1.1-2.5-2.5c0-.4.1-.8.3-1.1l-1.1-1.1c-1.2 1.8-.7 4.3 1.1 5.5c.7.4 1.4.7 2.2.7V24l2.2-2.2l-2.2-2.3V21Z"/>'
        },
        "cog-sync-outline": {
            body: '<path fill="currentColor" d="M11.7 20h-.4l-.4-2.6c-1.2-.2-2.2-.9-3-1.8l-2.4 1l-.8-1.3l2.1-1.6c-.4-1.2-.4-2.4 0-3.6L4.7 8.7l.8-1.3l2.4 1c.8-.9 1.8-1.5 3-1.8l.3-2.6h1.5l.4 2.6c1.2.2 2.3.9 3 1.8l2.4-1l.8 1.3l-2.1 1.5c.2.6.3 1.2.3 1.8h.5c.5 0 1 .1 1.5.2V12l-.1-1l2.1-1.6c.2-.2.2-.4.1-.6l-2-3.5c-.1-.3-.3-.3-.6-.3l-2.5 1c-.5-.4-1.1-.7-1.7-1l-.4-2.7c.1-.1-.2-.3-.4-.3h-4c-.2 0-.5.2-.5.4l-.4 2.7c-.6.2-1.1.6-1.7.9L5 5c-.3 0-.5 0-.7.3l-2 3.5c-.1.2 0 .4.2.6L4.6 11l-.1 1l.1 1l-2.1 1.7c-.2.2-.2.4-.1.6l2 3.5c.1.2.3.2.6.2l2.5-1c.5.4 1.1.7 1.7 1l.4 2.7c0 .2.2.4.5.4h2.5c-.5-.7-.7-1.4-.9-2.1m4.3-7.7V12c0-2.2-1.8-4-4-4s-4 1.8-4 4s1.8 4 4 4c.7-1.7 2.2-3.1 4-3.7m-6-.3c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m8 2.5V13l-2.2 2.2l2.2 2.2V16c1.4 0 2.5 1.1 2.5 2.5c0 .4-.1.8-.3 1.1l1.1 1.1c1.2-1.8.7-4.3-1.1-5.5c-.6-.5-1.4-.7-2.2-.7m0 6.5c-1.4 0-2.5-1.1-2.5-2.5c0-.4.1-.8.3-1.1l-1.1-1.1c-1.2 1.8-.7 4.3 1.1 5.5c.7.4 1.4.7 2.2.7V24l2.2-2.2l-2.2-2.3V21Z"/>'
        },
        "cog-transfer": {
            body: '<path fill="currentColor" d="M14 18v-2l-4 3.5l4 3.5v-2h3v-3h-3m8-2.5L18 12v2h-3v3h3v2l4-3.5m-.34-6.77l-2-3.46c-.12-.22-.38-.31-.61-.22l-2.49 1c-.51-.41-1.06-.74-1.69-1l-.37-2.63A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.26-1.17.59-1.69 1L5 5.05c-.23-.09-.5 0-.61.22l-2 3.46c-.13.21-.08.49.11.64L4.57 11c-.04.33-.07.67-.07 1c0 .33.03.67.07 1l-2.11 1.63c-.2.15-.25.43-.12.64l2 3.46c.11.27.4.38.66.27l2.5-1c.24.19.5.37.76.53l3.51-3A3.518 3.518 0 0 1 8.5 11.8c.15-1.93 1.82-3.39 3.75-3.25c1.44.09 2.67 1.07 3.1 2.45h4.08l2.11-1.63c.19-.15.24-.43.12-.64Z"/>'
        },
        "cog-transfer-outline": {
            body: '<path fill="currentColor" d="M15 17v-3h3v-2l4 3.5l-4 3.5v-2h-3m2 1v3h-3v2l-4-3.5l4-3.5v2h3M12 8c-2.21 0-4 1.8-4 4c0 1.91 1.35 3.54 3.21 3.92L16 11.86A3.997 3.997 0 0 0 12 8m0 6c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m9.66-5.27l-2-3.46c-.12-.22-.38-.31-.61-.22l-2.49 1c-.51-.41-1.06-.74-1.69-1l-.37-2.63A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.26-1.17.59-1.69 1L5 5.05c-.23-.09-.5 0-.61.22l-2 3.46c-.13.21-.08.49.11.64L4.57 11l-.07 1l.07 1l-2.11 1.63c-.2.15-.25.43-.12.64l2 3.46c.11.27.4.38.66.27l2.5-1c.24.19.5.37.76.53l1.65-1.4c-.77-.33-1.45-.82-2-1.45l-2.41 1l-.77-1.3L6.8 13.8a5.55 5.55 0 0 1 0-3.6L4.69 8.65l.75-1.3l2.41 1c.78-.9 1.83-1.53 3-1.78l.4-2.57h1.5l.37 2.62c1.17.24 2.22.88 3 1.77l2.41-1l.75 1.3l-2.08 1.51c.09.26.16.53.2.8h2l2.1-1.63a.48.48 0 0 0 .16-.64M12 8c-2.21 0-4 1.8-4 4c0 1.91 1.35 3.54 3.21 3.92L16 11.86A3.997 3.997 0 0 0 12 8m0 6c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m0-6c-2.21 0-4 1.8-4 4c0 1.91 1.35 3.54 3.21 3.92L16 11.86A3.997 3.997 0 0 0 12 8m0 6c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2Z"/>'
        },
        cogs: {
            body: '<path fill="currentColor" d="M15.9 18.45c1.35 0 2.45-1.1 2.45-2.45s-1.1-2.45-2.45-2.45c-1.36 0-2.45 1.1-2.45 2.45s1.09 2.45 2.45 2.45m5.2-1.77l1.48 1.16c.13.11.17.29.08.45l-1.4 2.42a.35.35 0 0 1-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.27 1.85c-.02.17-.17.3-.34.3h-2.8c-.18 0-.32-.13-.35-.3l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.75.7c-.15.06-.34 0-.42-.15l-1.4-2.42a.351.351 0 0 1 .08-.45l1.48-1.16l-.05-.68l.05-.69l-1.48-1.15a.353.353 0 0 1-.08-.45l1.4-2.42c.08-.16.27-.22.42-.16l1.75.71c.36-.28.75-.52 1.18-.69l.26-1.86c.03-.16.17-.29.35-.29h2.8c.17 0 .32.13.34.29l.27 1.86c.42.17.82.41 1.18.69l1.74-.71c.17-.06.34 0 .43.16l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.15l.05.69l-.05.68M6.69 8.07c.87 0 1.57-.7 1.57-1.57c0-.87-.7-1.58-1.57-1.58A1.58 1.58 0 0 0 5.11 6.5c0 .87.71 1.57 1.58 1.57m3.34-1.13l.97.74c.07.07.09.19.03.29l-.9 1.56c-.05.1-.17.14-.27.1l-1.12-.45l-.74.44l-.19 1.19c-.02.11-.11.19-.22.19h-1.8c-.12 0-.21-.08-.23-.19L5.4 9.62l-.76-.44l-1.14.45c-.09.04-.2 0-.26-.1l-.9-1.56c-.06-.1-.03-.22.05-.29l.95-.74l-.03-.44l.03-.44l-.95-.74a.229.229 0 0 1-.05-.29l.9-1.56c.06-.1.17-.14.26-.1l1.13.45l.77-.44l.16-1.19c.02-.11.11-.19.23-.19h1.8c.11 0 .2.08.22.19L8 3.38l.74.44l1.12-.45c.1-.04.22 0 .27.1l.9 1.56c.06.1.04.22-.03.29l-.97.74l.03.44l-.03.44Z"/>'
        },
        collage: {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h6V3m2 0v8h8V5c0-1.11-.89-2-2-2m-6 10v8h6c1.11 0 2-.89 2-2v-6"/>'
        },
        "collapse-all": {
            body: '<path fill="currentColor" d="M14 4H4v10H2V4a2 2 0 0 1 2-2h10v2m4 2H8a2 2 0 0 0-2 2v10h2V8h10V6m4 6v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-2 3h-8v2h8v-2Z"/>'
        },
        "collapse-all-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-1 7h-6v-2h6v2Z"/>'
        },
        "color-helper": {
            body: '<path fill="currentColor" d="M0 24h24v-4H0v4Z"/>'
        },
        comma: {
            body: '<path fill="currentColor" d="M7 3h9.95v9.96l-3.99 7.98H8l3.97-7.98H7V3Z"/>'
        },
        "comma-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m10 10V7H9v6h3l-2 4h3l2-4Z"/>'
        },
        "comma-box-outline": {
            body: '<path fill="currentColor" d="m10 17l2-4H9V7h6v6l-2 4h-3M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "comma-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m3 11l-2 4h-3l2-4H9V7h6v6Z"/>'
        },
        "comma-circle-outline": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m-2 13h3l2-4V7H9v6h3l-2 4Z"/>'
        },
        comment: {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9Z"/>'
        },
        "comment-account": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m7-8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "comment-account-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m6-2H8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m-4-8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "comment-alert": {
            body: '<path fill="currentColor" d="M9 22c-.6 0-1-.4-1-1v-3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-6.1l-3.7 3.7c-.2.2-.4.3-.7.3H9m4-11V5h-2v6m2 4v-2h-2v2h2Z"/>'
        },
        "comment-alert-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m3-6h-2V6h2v4m0 4h-2v-2h2v2Z"/>'
        },
        "comment-arrow-left": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-4 9h-4.5l1.8 1.8L12 14l-4-4l4-4l1.2 1.2L11.5 9H16v2Z"/>'
        },
        "comment-arrow-left-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14h-6.9L10 19.1V16H4V4h16v12m-4-5V9h-4.5l1.8-1.8L12 6l-4 4l4 4l1.2-1.2l-1.7-1.8H16Z"/>'
        },
        "comment-arrow-right": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 12l-1.2-1.2l1.8-1.8H8V9h4.5l-1.8-1.8L12 6l4 4l-4 4Z"/>'
        },
        "comment-arrow-right-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14h-6.9L10 19.1V16H4V4h16v12M8 9v2h4.5l-1.8 1.8L12 14l4-4l-4-4l-1.2 1.2L12.5 9H8Z"/>'
        },
        "comment-bookmark": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-1 11l-2.5-1.5L14 13V5h5v8Z"/>'
        },
        "comment-bookmark-outline": {
            body: '<path fill="currentColor" d="M9 22c-.6 0-1-.4-1-1v-3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-6.1l-3.7 3.7c-.2.2-.4.3-.7.3H9m1-6v3.1l3.1-3.1H20V4H4v12h6m8-2V6h-5v8l2.5-1.5L18 14Z"/>'
        },
        "comment-check": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v3c0 .55.45 1 1 1h.5c.25 0 .5-.1.7-.29L13.9 18H20c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-9.53 12L7 10.5l1.4-1.41l2.07 2.08L15.6 6L17 7.41L10.47 14Z"/>'
        },
        "comment-check-outline": {
            body: '<path fill="currentColor" d="M9 22c-.55 0-1-.45-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m5.6-10L17 7.41L10.47 14L7 10.5l1.4-1.41l2.07 2.08L15.6 6"/>'
        },
        "comment-edit": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h4v3c0 .55.45 1 1 1h.5c.25 0 .5-.1.7-.29L13.9 18H20c1.1 0 2-.9 2-2V4a2 2 0 0 0-2-2M9.08 15H7v-2.09l6.17-6.19l2.07 2.08L9.08 15m7.76-7.8l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79Z"/>'
        },
        "comment-edit-outline": {
            body: '<path fill="currentColor" d="M9 22c-.55 0-1-.45-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m5.84-7.8l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79M8 11.91l4.17-4.19l2.07 2.08l-4.16 4.2H8v-2.09Z"/>'
        },
        "comment-eye": {
            body: '<path fill="currentColor" d="M20 12v4c0 1.11-.89 2-2 2h-4.1l-3.7 3.71c-.2.18-.44.29-.7.29H9a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.5c-.55.67-1 1.42-1.36 2.25L7.85 7l.29.75C9.43 10.94 12.5 13 16 13c1.44 0 2.8-.37 4-1m-4-6c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c2.73 0 5.06 1.66 6 4c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4m0 1.5A2.5 2.5 0 0 0 13.5 7A2.5 2.5 0 0 0 16 9.5A2.5 2.5 0 0 0 18.5 7A2.5 2.5 0 0 0 16 4.5"/>'
        },
        "comment-eye-outline": {
            body: '<path fill="currentColor" d="M16 6c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c2.73 0 5.06 1.66 6 4c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4m0 1.5A2.5 2.5 0 0 0 13.5 7A2.5 2.5 0 0 0 16 9.5A2.5 2.5 0 0 0 18.5 7A2.5 2.5 0 0 0 16 4.5m2 8.25V16h-4.92L10 19.08V16H4V6h4.27c.32-.73.73-1.4 1.23-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v3a1 1 0 0 0 1 1h.5c.25 0 .5-.1.7-.29L13.9 18H18c1.11 0 2-.89 2-2v-4c-.63.33-1.3.58-2 .75Z"/>'
        },
        "comment-flash": {
            body: '<path fill="currentColor" d="M22.5 16h-2.2l1.7-4h-5v6h2v5l3.5-7M15 18h-1.1l-3.7 3.7c-.2.2-.4.3-.7.3H9c-.6 0-1-.4-1-1v-3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-7v8Z"/>'
        },
        "comment-flash-outline": {
            body: '<path fill="currentColor" d="M22.5 16h-2.2l1.7-4h-5v6h2v5l3.5-7M15 18h-1.1l-3.7 3.7c-.2.2-.4.3-.7.3H9c-.6 0-1-.4-1-1v-3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2V4H4v12h6v3.1l3.1-3.1H15v2Z"/>'
        },
        "comment-minus": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v3c0 .55.45 1 1 1h.5c.25 0 .5-.1.7-.29L13.9 18H20c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-4 9H8V9h8v2Z"/>'
        },
        "comment-minus-outline": {
            body: '<path fill="currentColor" d="M16 11H8V9h8v2m6-7v12c0 1.11-.89 2-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9c-.55 0-1-.45-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2m-2 0H4v12h6v3.08L13.08 16H20V4"/>'
        },
        "comment-multiple": {
            body: '<path fill="currentColor" d="M12 23a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.18-.44.29-.7.29H12m-9-8H1V3a2 2 0 0 1 2-2h16v2H3v12Z"/>'
        },
        "comment-multiple-outline": {
            body: '<path fill="currentColor" d="M12 23a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.19-.45.29-.7.29H12m1-6v3.08L16.08 17H21V7H7v10h6M3 15H1V3a2 2 0 0 1 2-2h16v2H3v12Z"/>'
        },
        "comment-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L16.11 18H13.9l-3.7 3.71c-.2.19-.45.29-.7.29H9c-.55 0-1-.45-1-1v-3H4a2 2 0 0 1-2-2V3.9L1.11 3l1.28-1.27l19.72 19.73M22 16V4a2 2 0 0 0-2-2H5.2l15.75 15.75c.62-.34 1.05-.99 1.05-1.75Z"/>'
        },
        "comment-off-outline": {
            body: '<path fill="currentColor" d="m7.2 4l-2-2H20a2 2 0 0 1 2 2v12c0 .76-.43 1.41-1.05 1.75L19.2 16h.8V4H7.2m14.91 17.46l-1.27 1.27L16.11 18H13.9l-3.7 3.71c-.2.19-.45.29-.7.29H9c-.55 0-1-.45-1-1v-3H4a2 2 0 0 1-2-2V3.9L1.11 3l1.28-1.27l19.72 19.73m-8-5.46L4 5.89V16h6v3.08L13.08 16h1.03Z"/>'
        },
        "comment-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6Z"/>'
        },
        "comment-plus": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m2-16v3H8v2h3v3h2v-3h3V9h-3V6h-2Z"/>'
        },
        "comment-plus-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m1-10h2v3h3v2h-3v3h-2v-3H8V9h3V6Z"/>'
        },
        "comment-processing": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m8-11V9h-2v2h2m-4 0V9h-2v2h2m-4 0V9H7v2h2Z"/>'
        },
        "comment-processing-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6m7-5h-2V9h2v2m-4 0h-2V9h2v2m-4 0H7V9h2v2Z"/>'
        },
        "comment-question": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m8.19 3.5c-.89 0-1.6.18-2.14.54c-.55.36-.83.96-.78 1.65h1.97c0-.28.1-.49.26-.63c.2-.14.42-.21.69-.21c.31 0 .58.08.76.26c.18.17.27.39.27.69c0 .28-.08.53-.22.74c-.17.22-.38.4-.64.54c-.52.32-.86.6-1.07.84c-.19.24-.29.58-.29 1.08h2c0-.28.05-.5.14-.68c.09-.17.26-.32.52-.47c.46-.21.84-.49 1.13-.85c.29-.37.44-.76.44-1.2c0-.7-.27-1.26-.81-1.68c-.54-.41-1.29-.62-2.23-.62M11 12v2h2v-2h-2Z"/>'
        },
        "comment-question-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v3a1 1 0 0 0 1 1h.5c.25 0 .5-.1.7-.29L13.9 18H20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4m0 2h16v12h-6.92L10 19.08V16H4V4m8.19 1.5c-.89 0-1.6.18-2.14.54c-.55.36-.83.96-.78 1.65h1.97c0-.28.1-.49.26-.63c.2-.14.42-.21.69-.21c.31 0 .58.08.76.26c.18.17.27.39.27.69c0 .28-.08.53-.22.74c-.17.22-.38.4-.64.54c-.52.32-.86.6-1.07.84c-.19.24-.29.58-.29 1.08h2c0-.28.05-.5.14-.68c.09-.17.26-.32.52-.47c.46-.21.84-.49 1.13-.85c.29-.37.44-.76.44-1.2c0-.7-.27-1.26-.81-1.68c-.54-.41-1.29-.62-2.23-.62M11 12v2h2v-2h-2Z"/>'
        },
        "comment-quote": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-9 11H7V8.8L8.3 6h2L8.9 9H11v4m6 0h-4V8.8L14.3 6h2l-1.4 3H17v4Z"/>'
        },
        "comment-quote-outline": {
            body: '<path fill="currentColor" d="M9 22c-.6 0-1-.4-1-1v-3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-6.1l-3.7 3.7c-.2.2-.4.3-.7.3H9m1-6v3.1l3.1-3.1H20V4H4v12h6m6.3-10l-1.4 3H17v4h-4V8.8L14.3 6h2m-6 0L8.9 9H11v4H7V8.8L8.3 6h2Z"/>'
        },
        "comment-remove": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m.41-16L8 7.41L10.59 10L8 12.59L9.41 14L12 11.41L14.59 14L16 12.59L13.41 10L16 7.41L14.59 6L12 8.59L9.41 6Z"/>'
        },
        "comment-remove-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6M9.41 6L12 8.59L14.59 6L16 7.41L13.41 10L16 12.59L14.59 14L12 11.41L9.41 14L8 12.59L10.59 10L8 7.41L9.41 6Z"/>'
        },
        "comment-search": {
            body: '<path fill="currentColor" d="M15.5 2C18 2 20 4 20 6.5c0 .88-.25 1.7-.69 2.39l3.1 3.11L21 13.39l-3.11-3.08c-.69.44-1.51.69-2.39.69C13 11 11 9 11 6.5S13 2 15.5 2m0 2A2.5 2.5 0 0 0 13 6.5A2.5 2.5 0 0 0 15.5 9A2.5 2.5 0 0 0 18 6.5A2.5 2.5 0 0 0 15.5 4M4 4h5.5c-.31.79-.5 1.64-.5 2.5a6.5 6.5 0 0 0 6.5 6.5c.68 0 1.33-.11 1.96-.31L20 15.23V16a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.18-.44.29-.7.29H9a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/>'
        },
        "comment-search-outline": {
            body: '<path fill="currentColor" d="M4 4h5.5a6.85 6.85 0 0 0-.46 2H4v10h6v3.08L13.08 16H18v-2.77l2 2V16a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.19-.45.29-.7.29H9a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m11.5-2C18 2 20 4 20 6.5c0 .88-.25 1.7-.69 2.39l3.1 3.11L21 13.39l-3.11-3.08c-.69.44-1.51.69-2.39.69C13 11 11 9 11 6.5S13 2 15.5 2m0 2A2.5 2.5 0 0 0 13 6.5A2.5 2.5 0 0 0 15.5 9A2.5 2.5 0 0 0 18 6.5A2.5 2.5 0 0 0 15.5 4Z"/>'
        },
        "comment-text": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9M5 5v2h14V5H5m0 4v2h8V9H5m0 4v2h10v-2H5Z"/>'
        },
        "comment-text-multiple": {
            body: '<path fill="currentColor" d="M3 15H1V3a2 2 0 0 1 2-2h16v2H3v12m9 8a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.18-.44.29-.7.29H12M9 9v2h10V9H9m0 4v2h8v-2H9Z"/>'
        },
        "comment-text-multiple-outline": {
            body: '<path fill="currentColor" d="M12 23a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4.1l-3.7 3.71c-.2.18-.44.29-.7.29H12m1-6v3.08L16.08 17H21V7H7v10h6M3 15H1V3a2 2 0 0 1 2-2h16v2H3v12m6-6h10v2H9V9m0 4h8v2H9v-2Z"/>'
        },
        "comment-text-outline": {
            body: '<path fill="currentColor" d="M9 22a1 1 0 0 1-1-1v-3H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m1-6v3.08L13.08 16H20V4H4v12h6M6 7h12v2H6V7m0 4h9v2H6v-2Z"/>'
        },
        compare: {
            body: '<path fill="currentColor" d="M19 3h-5v2h5v13l-5-6v9h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-9 15H5l5-6m0-9H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h5v2h2V1h-2v2Z"/>'
        },
        "compare-horizontal": {
            body: '<path fill="currentColor" d="M9 14H2v2h7v3l4-4l-4-4v3m6-1v-3h7V8h-7V5l-4 4l4 4Z"/>'
        },
        "compare-remove": {
            body: '<path fill="currentColor" d="M19 5h-5V3h5c1.1 0 2 .9 2 2v8.4c-.6-.2-1.3-.4-2-.4V5m-9-4h2v22h-2v-2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h5V1m0 11l-5 6h5v-6m5.7 2L14 12v3.7c.4-.7 1-1.2 1.7-1.7m5.4 1.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "compare-vertical": {
            body: '<path fill="currentColor" d="M14 15v7h2v-7h3l-4-4l-4 4h3m-1-6h-3V2H8v7H5l4 4l4-4Z"/>'
        },
        compass: {
            body: '<path fill="currentColor" d="M14.19 14.19L6 18l3.81-8.19L18 6m-6-4A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 8.9a1.1 1.1 0 0 0-1.1 1.1a1.1 1.1 0 0 0 1.1 1.1a1.1 1.1 0 0 0 1.1-1.1a1.1 1.1 0 0 0-1.1-1.1Z"/>'
        },
        "compass-off": {
            body: '<path fill="currentColor" d="m1 3.5l1.28-1.25l19.47 19.47L20.5 23l-2.8-2.78A9.983 9.983 0 0 1 12 22A10 10 0 0 1 2 12c0-2.12.66-4.08 1.78-5.7L1 3.5M6 18l6.47-3L9 11.53L6 18M18 6l-6.44 3l-5.23-5.24A9.97 9.97 0 0 1 12 2a10 10 0 0 1 10 10c0 2.1-.65 4.06-1.76 5.67L15 12.44L18 6Z"/>'
        },
        "compass-off-outline": {
            body: '<path fill="currentColor" d="m1 3.5l1.28-1.25l19.47 19.47L20.5 23l-2.8-2.78A9.983 9.983 0 0 1 12 22A10 10 0 0 1 2 12c0-2.12.66-4.08 1.78-5.7L1 3.5M7 17l2.39-5.09l-4.16-4.17A8.026 8.026 0 0 0 4 12a8 8 0 0 0 8 8c1.56 0 3-.45 4.26-1.23l-4.17-4.16L7 17M17 7l-2.38 5.05l-2.67-2.67L17 7m-5-5a10 10 0 0 1 10 10c0 2.1-.65 4.06-1.76 5.67l-1.44-1.45C19.56 15 20 13.55 20 12a8 8 0 0 0-8-8c-1.55 0-3 .44-4.22 1.2L6.33 3.76A9.97 9.97 0 0 1 12 2Z"/>'
        },
        "compass-outline": {
            body: '<path fill="currentColor" d="m7 17l3.2-6.8L17 7l-3.2 6.8L7 17m5-5.9a.9.9 0 0 0-.9.9a.9.9 0 0 0 .9.9a.9.9 0 0 0 .9-.9a.9.9 0 0 0-.9-.9M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "compass-rose": {
            body: '<path fill="currentColor" d="m15 9l-3-9l-3 9l-9 3l9 3l3 9l3-9l9-3l-9-3M4 12l6-2l1 2H4m8 8l-2-6l2-1v7m0-16l2 6l-2 1V4m2 10l-1-2h7l-6 2m-5.3 3.3L5 19l1.7-3.7l1.6.5l.4 1.5m8.6-2L19 19l-3.7-1.7l.5-1.6l1.5-.4M6.7 8.7L5 5l3.7 1.7l-.5 1.5l-1.5.5m8.6-2L19 5l-1.7 3.7l-1.6-.5l-.4-1.5Z"/>'
        },
        compost: {
            body: '<path fill="currentColor" d="M18.92 14a6.983 6.983 0 0 1-2.96 4.76c-.2-.83-1.43-1.51-3.04-1.7c.17-1.19.52-2.3.76-2.94c.38.24.82.38 1.32.38c3.55 0 3-6 3-6s-.5 1-2 1h-1a2.5 2.5 0 0 0-2.13 3.81c.66-.69 1.37-1.31 2.13-1.81c-1.32 1.33-2.33 3-3 4.6c-.63-1.23-1.42-2.17-2-2.6c.47.2.91.5 1.33.8c.11-.24.17-.51.17-.8C11.45 10.77 7 11 7 11c.31.42.5.95.5 1.5v1c0 1.1.9 2 2 2c.5 0 .95-.18 1.3-.5c.23.63.4 1.35.49 2.04c-1.72.15-3.04.85-3.25 1.73C6.21 17.5 5 15.39 5 13c0-3.86 3.14-7 7-7v3l5-4l-5-4v3a9 9 0 0 0 0 18c4.63 0 8.44-3.5 8.94-8h-2.02Z"/>'
        },
        "concourse-ci": {
            body: '<path d="M10.94 12.09a1.06 1.06 0 1 0 .97-1.14a1.06 1.06 0 0 0-.97 1.14m2.6 1.12a2.62 2.62 0 0 1-.96.67l-.01.01a11.17 11.17 0 0 0 1.3 3.03a4.83 4.83 0 0 1-.95.38a4.9 4.9 0 0 1-.68.14l-.08.01l-.1.01l-.19.01c-.12 0-.23.03-.37 0a5 5 0 0 1-.71-.07a5.13 5.13 0 0 1-.7-.17a4.78 4.78 0 0 1-.63-.23a5 5 0 0 1-.53-.32a4.45 4.45 0 0 1-.43-.3c-.12-.09-.22-.19-.3-.26l-.25-.25s.05.1.21.28c.08.08.16.19.28.3a4.93 4.93 0 0 0 .38.37a5.21 5.21 0 0 0 .51.38a5.08 5.08 0 0 0 .63.36a5.43 5.43 0 0 0 .72.29a5.5 5.5 0 0 0 .78.18c.14.03.28.04.42.05l.19.02h.2a5.5 5.5 0 0 0 .8-.05a5.61 5.61 0 0 0 1.32-.35q.24.33.51.64l-.03.02l-.21.14h-.04c-.03.03.05 0 .04 0h-.02l-.06.04l-.14.07l-.07.03l-.04.02l-.01.01h-.01c-.01.01.05-.01.02 0h-.01l-.15.07q-.08.03-.17.07v.01l-.07.02l-.09.03a6.5 6.5 0 0 1-1.59.39a6.4 6.4 0 0 1-.94.04h-.12l-.12-.01l-.26-.02c-.16-.03-.31-.04-.48-.07a6.59 6.59 0 0 1-1.83-.63c-.15-.07-.29-.14-.42-.22c-.13-.08-.25-.16-.37-.24a6.64 6.64 0 0 1-.64-.51a6.35 6.35 0 0 1-.5-.49c-.14-.15-.25-.29-.35-.41c-.09-.12-.16-.2-.22-.28l-.06-.1l.06.11c.04.07.1.17.18.3c.08.13.18.27.32.45a6.5 6.5 0 0 0 .44.55a6.86 6.86 0 0 0 .61.58c.12.1.23.19.36.29c.13.1.26.19.4.28a7.12 7.12 0 0 0 .9.49a7.2 7.2 0 0 0 .99.37c.17.06.35.09.53.13l.27.05l.11.02l.14.02a7.27 7.27 0 0 0 1.04.07a7.38 7.38 0 0 0 1.85-.26l.09-.03l.05-.01l.06-.02c.06-.02.12-.03.16-.05l.18-.06l.17-.06l.15-.04l.06-.05h.02l.05-.02l.01-.01l.03-.01l.22-.11l.28-.14c.19.18.39.34.59.53c0 0 .97 1 1.5.59c.5-.39-.08-1.6-.08-1.6a11.2 11.2 0 0 0-4.14-5.47m-3.38-1.64l-.01-.01a11.18 11.18 0 0 0-3.24-.45a4.72 4.72 0 0 1 .43-1.72l.04-.08l.04-.08l.08-.17c.07-.1.12-.21.19-.31a4.97 4.97 0 0 1 .45-.58a5.05 5.05 0 0 1 .52-.5a4.77 4.77 0 0 1 .54-.4A5.06 5.06 0 0 1 9.74 7a4.88 4.88 0 0 1 .48-.22c.15-.06.28-.09.39-.12c.21-.06.34-.08.34-.08s-.13.01-.35.03c-.1.02-.25.03-.41.07a4.94 4.94 0 0 0-.52.14a5.34 5.34 0 0 0-.59.23a5.08 5.08 0 0 0-.63.34a5.47 5.47 0 0 0-.63.45a5.55 5.55 0 0 0-.57.57c-.09.09-.17.22-.25.33l-.12.15l-.06.08l-.06.09a5.5 5.5 0 0 0-.38.71a5.61 5.61 0 0 0-.41 1.37l-.01.02c-.26.02-.53.05-.8.1v-.14l.01-.25v-.05c0-.04-.01.06-.01.05v-.03l.01-.07l.01-.15l.01-.08v-.04h.01v-.03c0-.01-.01.03-.01.03l.03-.18l.02-.18l.01-.02v-.01l-.01.02l.01-.01v-.01l.01-.04l.01-.1a6.5 6.5 0 0 1 .99-2.38l.06-.09l.07-.1l.16-.21c.1-.12.19-.25.31-.37a6.61 6.61 0 0 1 1.51-1.23c.13-.09.27-.16.4-.22c.13-.08.27-.13.4-.19a6.76 6.76 0 0 1 .77-.28a6.5 6.5 0 0 1 .68-.16c.2-.05.38-.06.53-.08c.15-.02.27-.02.35-.03l.12-.01h-.12c-.08 0-.2-.01-.35-.01c-.15 0-.33 0-.54.02a6.41 6.41 0 0 0-.71.1a7.03 7.03 0 0 0-.82.2c-.14.07-.29.1-.43.16c-.15.05-.3.12-.45.19a7.26 7.26 0 0 0-.89.5a7.33 7.33 0 0 0-.84.64c-.14.12-.27.26-.4.38L5.9 7l-.08.09l-.1.1a7.25 7.25 0 0 0-.6.85a7.38 7.38 0 0 0-.76 1.71l-.03.09l-.01.05l-.02.06l-.05.18l-.04.16l-.03.21l-.03.13c-.01.02-.01.04-.01.07l-.01.02v.06l-.01.03l-.03.25l-.04.44c-.26.07-.52.15-.77.24c0 0-1.35.31-1.28.98c.08.63 1.41.78 1.41.78a11.21 11.21 0 0 0 6.83-.76a2.62 2.62 0 0 1-.08-1.17m9.54-.73a7.19 7.19 0 0 0-.17-1.05c-.03-.17-.1-.34-.15-.52l-.08-.24l-.04-.12l-.05-.14a7.23 7.23 0 0 0-.46-.94a7.35 7.35 0 0 0-1.13-1.48l-.07-.07l-.05-.03l-.03-.05l-.14-.12l-.12-.11l-.15-.12l-.12-.1l-.05-.05l-.01-.01h-.01l-.04-.03l-.03-.02l-.21-.14l-.27-.19q.1-.43.18-.86s.38-1.34-.25-1.6c-.58-.24-1.34.87-1.34.87a11.21 11.21 0 0 0-2.66 6.33a2.63 2.63 0 0 1 1.07.5A11.2 11.2 0 0 0 15.25 8a4.73 4.73 0 0 1 .83.66a4.81 4.81 0 0 1 .45.53l.05.06l.05.08l.11.17c.06.09.12.19.18.3a4.89 4.89 0 0 1 .48 1.36a4.78 4.78 0 0 1 .1.67a4.88 4.88 0 0 1 0 .61a4.76 4.76 0 0 1-.06.52c-.02.15-.05.29-.08.4c-.05.21-.09.34-.09.34l.14-.33c.04-.11.09-.23.13-.37a5.06 5.06 0 0 0 .13-.54a5.34 5.34 0 0 0 .08-.63a5.04 5.04 0 0 0 .01-.72a5.38 5.38 0 0 0-.33-1.54c-.05-.13-.11-.26-.16-.38L17.18 9l-.04-.07l-.05-.1a5.53 5.53 0 0 0-1.42-1.67c.12-.26.22-.51.33-.78l.03.03l.22.12l.03.01v.01h.01c.03.02-.05-.05-.04-.02h.01l.01.01l.06.04l.12.08l.05.05l.06.02l.01.01h.01l-.02-.01h.01l.14.11l.14.1l.02.02l-.01-.01l.01.01l.04.04l.09.05a6.46 6.46 0 0 1 1.6 2l.05.1l.06.12l.11.23c.05.15.12.29.18.45a6.69 6.69 0 0 1 .24.95a6.78 6.78 0 0 1 .11.96c.01.14.01.31 0 .46c0 .18-.01.3-.02.45a6.79 6.79 0 0 1-.13.81a6.4 6.4 0 0 1-.2.67c-.04.2-.11.37-.16.51c-.06.14-.11.24-.14.31l-.06.12l.07-.11c.04-.08.1-.17.17-.3c.07-.14.16-.28.24-.49a6.5 6.5 0 0 0 .25-.67a6.93 6.93 0 0 0 .22-.81c.02-.15.05-.31.07-.46c.02-.16.04-.32.04-.48a7.1 7.1 0 0 0-.01-1.03" fill="currentColor"/>',
            hidden: true
        },
        cone: {
            body: '<path fill="currentColor" d="M21.62 16.68L12.85 2.5A.958.958 0 0 0 12 2a.99.99 0 0 0-.85.47L2.38 16.65h.02c-.25.39-.4.85-.4 1.35c0 1.5 1.3 4 10 4c3.74 0 10-.5 10-4c0-.39-.09-.85-.38-1.32M12 4.9l6 9.68c-1.47-.35-3.4-.58-6-.58c-1.75 0-4.04.12-6 .6l6-9.7M12 20c-4.42 0-8-.89-8-2c0-1.1 3.58-2 8-2s8 .9 8 2c0 1.11-3.58 2-8 2Z"/>'
        },
        "cone-off": {
            body: '<path fill="currentColor" d="M10.5 7.31L9.06 5.86l2.09-3.39A.99.99 0 0 1 12 2c.33 0 .66.16.85.5l8.77 14.18a2.482 2.482 0 0 1 .28 2.02l-4.17-4.17c.08.02.17.03.27.05L12 4.9l-1.5 2.41m11.61 14.15l-1.27 1.27l-1.67-1.67c-2.14.77-5.06.94-7.17.94c-8.7 0-10-2.5-10-4c0-.5.15-.96.4-1.35h-.02L7.11 9l-6-6l1.28-1.27l19.72 19.73M6 14.6c1.96-.48 4.25-.6 6-.6h.11l-3.55-3.55L6 14.6m11.55 4.84l-3.36-3.36C13.5 16.03 12.76 16 12 16c-4.42 0-8 .9-8 2s3.58 2 8 2c2.16 0 4.11-.21 5.55-.56Z"/>'
        },
        connection: {
            body: '<path fill="currentColor" d="M21.4 7.5c.8.8.8 2.1 0 2.8l-2.8 2.8l-7.8-7.8l2.8-2.8c.8-.8 2.1-.8 2.8 0l1.8 1.8l3-3l1.4 1.4l-3 3l1.8 1.8m-5.8 5.8l-1.4-1.4l-2.8 2.8l-2.1-2.1l2.8-2.8l-1.4-1.4l-2.8 2.8l-1.5-1.4l-2.8 2.8c-.8.8-.8 2.1 0 2.8l1.8 1.8l-4 4l1.4 1.4l4-4l1.8 1.8c.8.8 2.1.8 2.8 0l2.8-2.8l-1.4-1.4l2.8-2.9Z"/>'
        },
        console: {
            body: '<path fill="currentColor" d="M20 19V7H4v12h16m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16m-7 14v-2h5v2h-5m-3.42-4L5.57 9H8.4l3.3 3.3c.39.39.39 1.03 0 1.42L8.42 17H5.59l3.99-4Z"/>'
        },
        "console-line": {
            body: '<path fill="currentColor" d="M13 19v-3h8v3h-8m-4.5-6L2.47 7h4.24l4.96 4.95c.58.59.58 1.55 0 2.12L6.74 19H2.5l6-6Z"/>'
        },
        "console-network": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10M7 7l4 4l-4 4h2.85l3.28-3.28c.37-.39.37-1.02 0-1.42L9.83 7H7m10 6h-3v2h3v-2Z"/>'
        },
        "console-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m1-8.11l3.56 3.56L8 14h2.53l2.92-2.92c.33-.34.33-.9 0-1.26L10.5 6.89H8m8 5.33h-2.67V14H16v-1.78Z"/>'
        },
        consolidate: {
            body: '<path fill="currentColor" d="M18 9h2V4h2v5a2 2 0 0 1-2 2h-2v2l-3-3l3-3m-4 3a2 2 0 1 0-2 2a2 2 0 0 0 2-2M2 11v5h2v-5h2v2l3-3l-3-3v2H4a2 2 0 0 0-2 2m13 5l-3-3l-3 3h2v2a2 2 0 0 0 2 2h5v-2h-5v-2"/>'
        },
        "contactless-payment": {
            body: '<path fill="currentColor" d="M16.79 23c-.42-.17-.72-.55-.79-1c-.05-.26 0-.44.4-1.16c1.5-2.7 2.27-5.75 2.23-8.84c.04-3-.69-5.93-2.13-8.56c-.21-.44-.4-.86-.56-1.31c.06-.38.25-.73.56-.94c.45-.24 1-.19 1.41.09c.28.36.52.72.72 1.14A21.4 21.4 0 0 1 20.8 9c.23 1.81.26 3.65.09 5.47c-.31 2.34-1 4.6-2.06 6.71c-.64 1.28-1 1.82-1.38 1.82h-.66m-4.36-2.21c-.57-.16-.93-.74-.81-1.32c0-.12.31-.67.59-1.23c1.18-2.27 1.69-4.83 1.46-7.38c-.14-1.83-.67-3.61-1.54-5.22c-.63-1.26-.67-1.46-.3-2c.44-.49 1.17-.56 1.71-.14c.72 1.06 1.29 2.22 1.71 3.44c1.28 3.79 1.08 7.92-.56 11.56c-.84 1.89-1.43 2.5-2.26 2.24v.05m-4.5-2.23a1.31 1.31 0 0 1-.73-.86c0-.2 0-.46.45-1.26a8.986 8.986 0 0 0 0-8.68C7 6.5 7 6.24 7.53 5.76c.19-.22.47-.33.77-.29c.64 0 1 .31 1.54 1.44A10.51 10.51 0 0 1 11.12 12c.04 1.81-.4 3.61-1.27 5.2c-.54 1.05-.81 1.3-1.35 1.39c-.19.02-.39 0-.57-.09v.06m-4.21-2.13c-.33-.16-.59-.43-.72-.78c-.1-.35 0-.65.4-1.29c.5-.68.74-1.52.69-2.36c.07-.85-.16-1.69-.65-2.39A6.11 6.11 0 0 1 3 8.82c-.11-.63.31-1.23 1-1.35c.54-.1.92.13 1.42.89a6.619 6.619 0 0 1 0 7.27c-.51.77-1.09 1-1.69.8h-.01Z"/>'
        },
        "contactless-payment-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M8.43 14.44l-1.36-.61c.28-.56.43-1.16.43-1.78c0-.66-.15-1.29-.43-1.88l1.36-.61c.38.81.57 1.64.57 2.49c0 .75-.19 1.55-.57 2.39m3.1 1.5l-1.31-.65c.53-1.13.78-2.29.78-3.43c0-1.13-.25-2.17-.78-3.15l1.31-.75c.66 1.16.97 2.46.97 3.9c0 1.47-.31 2.83-.97 4.08m3.15 1.41l-1.37-.7c.79-1.54 1.19-3.08 1.19-4.65s-.4-3.13-1.19-4.69l1.37-.66C15.55 8.43 16 10.22 16 12c0 1.82-.45 3.6-1.32 5.35Z"/>'
        },
        "contactless-payment-circle-outline": {
            body: '<path fill="currentColor" d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M8.43 14.44l-1.36-.61c.28-.56.43-1.16.43-1.78c0-.66-.15-1.29-.43-1.88l1.36-.61c.38.81.57 1.64.57 2.49c0 .75-.19 1.55-.57 2.39m3.1 1.5l-1.31-.65c.53-1.13.78-2.29.78-3.43c0-1.13-.25-2.17-.78-3.15l1.31-.75c.66 1.16.97 2.46.97 3.9c0 1.47-.31 2.83-.97 4.08m3.15 1.41l-1.37-.7c.79-1.54 1.19-3.08 1.19-4.65s-.4-3.13-1.19-4.69l1.37-.66C15.55 8.43 16 10.22 16 12c0 1.82-.45 3.6-1.32 5.35Z"/>'
        },
        contacts: {
            body: '<path fill="currentColor" d="M20 0H4v2h16V0M4 24h16v-2H4v2M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-8 2.75A2.25 2.25 0 0 1 14.25 9A2.25 2.25 0 0 1 12 11.25A2.25 2.25 0 0 1 9.75 9A2.25 2.25 0 0 1 12 6.75M17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17Z"/>'
        },
        "contacts-outline": {
            body: '<path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V6h16v12M4 0h16v2H4m0 20h16v2H4m8-12a2.5 2.5 0 0 0 0-5a2.5 2.5 0 0 0 0 5m0-3.5c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m5 7.5c0-2.1-3.31-3-5-3s-5 .9-5 3v1h10v-1m-8.19-.5c.61-.5 2.03-1 3.19-1c1.17 0 2.59.5 3.2 1H8.81Z"/>'
        },
        contain: {
            body: '<path fill="currentColor" d="M2 3h6v2H4v14h4v2H2V3m5 14v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m7-14v18h-6v-2h4V5h-4V3h6Z"/>'
        },
        "contain-end": {
            body: '<path fill="currentColor" d="M7 17v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m7-14v18h-6v-2h4V5h-4V3h6Z"/>'
        },
        "contain-start": {
            body: '<path fill="currentColor" d="M2 3h6v2H4v14h4v2H2V3m5 14v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2Z"/>'
        },
        "content-copy": {
            body: '<path fill="currentColor" d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z"/>'
        },
        "content-cut": {
            body: '<path fill="currentColor" d="m19 3l-6 6l2 2l7-7V3m-10 9.5a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5M6 20a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2M6 8a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m3.64-.36c.23-.5.36-1.05.36-1.64a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64Z"/>'
        },
        "content-duplicate": {
            body: '<path fill="currentColor" d="M11 17H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12v2H4v12h7v-2l4 3l-4 3v-2m8 4V7H8v6H6V7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11Z"/>'
        },
        "content-paste": {
            body: '<path fill="currentColor" d="M19 20H5V4h2v3h10V4h2m-7-2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 0h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "content-save": {
            body: '<path fill="currentColor" d="M15 9H5V5h10m-3 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4Z"/>'
        },
        "content-save-alert": {
            body: '<path fill="currentColor" d="M13 9H3V5h10m-3 14c-1.7 0-3-1.3-3-3s1.3-3 3-3s3 1.3 3 3s-1.3 3-3 3m5-16H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4m8 10h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "content-save-alert-outline": {
            body: '<path fill="currentColor" d="M15 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4m2 16H3V5h11.2L17 7.8V19m-7-7c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3M4 6h9v4H4V6m19 7h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "content-save-all": {
            body: '<path fill="currentColor" d="M17 7V3H7v4h10m-3 10a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m5-16l4 4v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12M1 7h2v14h14v2H3a2 2 0 0 1-2-2V7Z"/>'
        },
        "content-save-all-outline": {
            body: '<path fill="currentColor" d="M1 7h2v14h14v2H3a2 2 0 0 1-2-2V7m18-6H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5l-4-4m2 16H7V3h11.17L21 5.83V17m-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3M8 4h9v4H8V4Z"/>'
        },
        "content-save-check": {
            body: '<path fill="currentColor" d="M17 3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6.81c-.39-.66-.64-1.4-.74-2.16a2.994 2.994 0 0 1-1.87-3.81C9.61 13.83 10.73 13 12 13c.44 0 .88.1 1.28.29c2.29-1.79 5.55-1.7 7.72.25V7l-4-4m-2 6H5V5h10v4m.75 12L13 18l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L15.75 21"/>'
        },
        "content-save-check-outline": {
            body: '<path fill="currentColor" d="M14 12.8c-.5-.49-1.22-.8-2-.8a2.996 2.996 0 0 0-1 5.82a6.034 6.034 0 0 1 3-5.02M11.09 19H5V5h11.17L19 7.83v4.52c.75.26 1.42.65 2 1.19V7l-4-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6.81c-.35-.61-.6-1.28-.72-2M6 10h9V6H6v4m9.75 11L13 18l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L15.75 21"/>'
        },
        "content-save-cog": {
            body: '<path fill="currentColor" d="M21 11.7V7l-4-4H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6.7c-.3-.7-.5-1.4-.6-2.2C9.9 18.4 9 17.3 9 16c0-1.7 1.3-3 3-3c.3 0 .6.1.9.2C14.2 11.8 16 11 18 11c1.1 0 2.1.2 3 .7M15 9H5V5h10v4m6.7 9.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "content-save-cog-outline": {
            body: '<path fill="currentColor" d="M11.1 19c.1.7.3 1.4.6 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h12l4 4v4.7c-.6-.3-1.3-.5-2-.6V7.8L16.2 5H5v14h6.1m.9-7c-1.7 0-3 1.3-3 3c0 1.3.8 2.4 2 2.8c.1-2.2 1.1-4.1 2.7-5.3c-.5-.3-1.1-.5-1.7-.5m3-2V6H6v4h9m7.8 9.6l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8c.1 0 .1.1 0 .2M19.5 18c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "content-save-edit": {
            body: '<path fill="currentColor" d="m10 19l.14-.14A2.97 2.97 0 0 1 8 16a3 3 0 0 1 3-3c1.36 0 2.5.9 2.86 2.14L20 9V7l-4-4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6v-2M4 5h10v4H4V5m16.04 7.13c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 0 0-.38-.17m-1.97 1.75L12 19.94V22h2.06l6.06-6.07l-2.05-2.05Z"/>'
        },
        "content-save-edit-outline": {
            body: '<path fill="currentColor" d="M4 19h6v2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12l4 4v2.12l-2 2V7.83L15.17 5H4v14m10-9V6H5v4h9m6.42 2.3a.533.533 0 0 0-.38-.17c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28M12 19.94V22h2.06l6.06-6.07l-2.05-2.05L12 19.94M14 15c0-1.66-1.34-3-3-3s-3 1.34-3 3s1.34 3 3 3h.13L14 15.13V15"/>'
        },
        "content-save-minus": {
            body: '<path fill="currentColor" d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.81c-.36-.62-.61-1.3-.73-2H12c-1.66 0-3-1.34-3-3s1.34-3 3-3c.68 0 1.34.23 1.87.65A6.015 6.015 0 0 1 18 12c1.05 0 2.09.28 3 .81V7l-4-4m-2 6H5V5h10v4m-1 8v2h8v-2h-8Z"/>'
        },
        "content-save-minus-outline": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.81c-.36-.62-.61-1.3-.73-2H5V5h11.17L19 7.83v4.25c.7.12 1.38.37 2 .73V7l-4-4H5m1 3v4h9V6H6m6 6c-1.66 0-3 1.34-3 3s1.34 3 3 3c0-1.89.89-3.66 2.39-4.79C13.85 12.5 13 12 12 12m2 5v2h8v-2h-8Z"/>'
        },
        "content-save-move": {
            body: '<path fill="currentColor" d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6.81c-.39-.66-.64-1.4-.74-2.16a2.994 2.994 0 0 1-1.87-3.81C9.61 13.83 10.73 13 12 13c.44 0 .88.1 1.28.29c2.29-1.79 5.55-1.7 7.72.25V7l-4-4m-2 6H5V5h10v4m-2 8h4v-3l5 4.5l-5 4.5v-3h-4v-3"/>'
        },
        "content-save-move-outline": {
            body: '<path fill="currentColor" d="M13 17h4v-3l5 4.5l-5 4.5v-3h-4v-3m1-4.2c-.5-.49-1.22-.8-2-.8a2.996 2.996 0 0 0-1 5.82a6.034 6.034 0 0 1 3-5.02M11.09 19H5V5h11.17L19 7.83v4.52c.75.26 1.42.65 2 1.19V7l-4-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6.81c-.35-.61-.6-1.28-.72-2M6 10h9V6H6v4Z"/>'
        },
        "content-save-off": {
            body: '<path fill="currentColor" d="m8.2 5l-2-2H17l4 4v10.8L12.2 9H15V5H8.2m13.91 16.46l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73M7.11 9L5 6.89V9h2.11m7.78 7.78l-3.67-3.67C9.95 13.46 9 14.61 9 16c0 1.66 1.34 3 3 3c1.39 0 2.54-.95 2.89-2.22Z"/>'
        },
        "content-save-off-outline": {
            body: '<path fill="currentColor" d="m8.2 5l-2-2H17l4 4v10.8l-2-2V7.83L16.17 5H8.2m6.8 5V6H9.2l4 4H15m7.11 11.46l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73m-5-2.46l-2.52-2.5a2.996 2.996 0 1 1-4.09-4.09L8.11 10H6V7.89l-1-1V19h12.11Z"/>'
        },
        "content-save-outline": {
            body: '<path fill="currentColor" d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4m2 16H5V5h11.17L19 7.83V19m-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3M6 6h9v4H6V6Z"/>'
        },
        "content-save-plus": {
            body: '<path fill="currentColor" d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.81c-.36-.62-.61-1.3-.73-2H12c-1.66 0-3-1.34-3-3s1.34-3 3-3c.68 0 1.34.23 1.87.65A6.015 6.015 0 0 1 18 12c1.05 0 2.09.28 3 .81V7l-4-4m-2 6H5V5h10v4m2 5v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "content-save-plus-outline": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.81c-.36-.62-.61-1.3-.73-2H5V5h11.17L19 7.83v4.25c.7.12 1.38.37 2 .73V7l-4-4H5m1 3v4h9V6H6m6 6c-1.66 0-3 1.34-3 3s1.34 3 3 3c0-1.89.89-3.66 2.39-4.79C13.85 12.5 13 12 12 12m5 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "content-save-settings": {
            body: '<path fill="currentColor" d="M15 8V4H5v4h10m-3 10a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m5-16l4 4v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12m-6 20h2v2h-2v-2m-4 0h2v2H7v-2m8 0h2v2h-2v-2Z"/>'
        },
        "content-save-settings-outline": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2m2-20H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6l-4-4m2 16H5V4h11.17L19 6.83V18m-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3M6 5h9v4H6V5Z"/>'
        },
        contrast: {
            body: '<path fill="currentColor" d="M4.38 20.9a2 2 0 0 1-1.28-1.27L19.63 3.1a2 2 0 0 1 1.27 1.28L4.38 20.9M20 16v2h-7v-2h7M3 6h3V3h2v3h3v2H8v3H6V8H3V6Z"/>'
        },
        "contrast-box": {
            body: '<path fill="currentColor" d="M17 15.5h-5V17h5m2 2H5L19 5M5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "contrast-circle": {
            body: '<path fill="currentColor" d="M12 20c-2.21 0-4.21-.9-5.66-2.34L17.66 6.34A8.014 8.014 0 0 1 20 12a8 8 0 0 1-8 8M6 8h2V6h1.5v2h2v1.5h-2v2H8v-2H6M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 14h5v-1.5h-5V16Z"/>'
        },
        controller: {
            body: '<path fill="currentColor" d="M7.97 16L5 19c-.33.3-.77.5-1.25.5A1.75 1.75 0 0 1 2 17.75v-.25l1-7.38A4.524 4.524 0 0 1 7.5 6h9c2.36 0 4.29 1.81 4.5 4.12l1 7.38v.25a1.75 1.75 0 0 1-1.75 1.75c-.48 0-.92-.2-1.25-.5l-2.97-3H7.97M7 8v2H5v1h2v2h1v-2h2v-1H8V8H7m9.5 0a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75m-1.75 1.75a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75m3.5 0a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75M16.5 11.5a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75Z"/>'
        },
        "controller-classic": {
            body: '<path fill="currentColor" d="M6 7h12a5 5 0 0 1 5 5a5 5 0 0 1-5 5c-1.64 0-3.09-.79-4-2h-4c-.91 1.21-2.36 2-4 2a5 5 0 0 1-5-5a5 5 0 0 1 5-5m13.75 2.5a1.25 1.25 0 0 0-1.25 1.25A1.25 1.25 0 0 0 19.75 12A1.25 1.25 0 0 0 21 10.75a1.25 1.25 0 0 0-1.25-1.25m-2.5 2.5A1.25 1.25 0 0 0 16 13.25a1.25 1.25 0 0 0 1.25 1.25a1.25 1.25 0 0 0 1.25-1.25A1.25 1.25 0 0 0 17.25 12M5 9v2H3v2h2v2h2v-2h2v-2H7V9H5Z"/>'
        },
        "controller-classic-outline": {
            body: '<path fill="currentColor" d="M17.5 7a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5c-1.71 0-3.23-.78-4.24-2h-2.52c-1.01 1.22-2.53 2-4.24 2A5.5 5.5 0 0 1 1 12.5A5.5 5.5 0 0 1 6.5 7h11m-11 2A3.5 3.5 0 0 0 3 12.5A3.5 3.5 0 0 0 6.5 16c1.4 0 2.6-.82 3.16-2h4.68c.56 1.18 1.76 2 3.16 2a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 17.5 9h-11m-.75 1.25h1.5v1.5h1.5v1.5h-1.5v1.5h-1.5v-1.5h-1.5v-1.5h1.5v-1.5m11 2.25a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m2-2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "controller-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-6-6H7.97L5 19c-.33.3-.77.5-1.25.5A1.75 1.75 0 0 1 2 17.75v-.25l1-7.38c.1-1.03.53-1.95 1.19-2.66L2 5.27M5 10v1h2v2h1v-1.73L6.73 10H5m11.5-4c2.36 0 4.29 1.81 4.5 4.12l1 7.38v.25c0 .66-.36 1.25-.9 1.53L7.82 6h8.68m0 2a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75m-1.75 1.75a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75m3.5 0a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75M16.5 11.5a.75.75 0 0 0-.75.75a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75a.75.75 0 0 0-.75-.75Z"/>'
        },
        "controller-xbox": {
            body: '<path stroke-width=".2" stroke-linejoin="round" stroke="currentColor" d="M12 6.059c1.726 0 6.686-4.314 9.274.863C23.863 12.098 23.216 19 21.49 19c-4.313 0-1.725-4.314-9.49-4.314C4.235 14.686 6.824 19 2.51 19c-1.726 0-2.373-6.902.215-12.078c2.589-5.177 7.55-.863 9.275-.863zM12 7.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3z" fill="currentColor"/>',
            hidden: true
        },
        cookie: {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9c0-.5-.04-1-.13-1.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1M9.5 6A1.5 1.5 0 0 1 11 7.5A1.5 1.5 0 0 1 9.5 9A1.5 1.5 0 0 1 8 7.5A1.5 1.5 0 0 1 9.5 6m-3 4A1.5 1.5 0 0 1 8 11.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 5 11.5A1.5 1.5 0 0 1 6.5 10m5 1a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m5 2a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5M11 16a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 11 19a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 11 16Z"/>'
        },
        "cookie-alert": {
            body: '<path fill="currentColor" d="M18 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1c-5 0-9 4-9 9s4 9 9 9s9-4 9-9c0-.5 0-1-.1-1.5c-.3-.5-.9-.5-.9-.5M4.5 13c-.8 0-1.5-.7-1.5-1.5S3.7 10 4.5 10s1.5.7 1.5 1.5S5.3 13 4.5 13M6 7.5C6 6.7 6.7 6 7.5 6S9 6.7 9 7.5S8.3 9 7.5 9S6 8.3 6 7.5M9 19c-.8 0-1.5-.7-1.5-1.5S8.2 16 9 16s1.5.7 1.5 1.5S9.8 19 9 19m.5-5c-.8 0-1.5-.7-1.5-1.5S8.7 11 9.5 11s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m5 2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m6.5-1h2v2h-2v-2m2-8v6h-2V7h2Z"/>'
        },
        "cookie-alert-outline": {
            body: '<path fill="currentColor" d="M16 14.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5m2.9-4c.1.5.1 1 .1 1.5c0 5-4 9-9 9s-9-4-9-9s4-9 9-9c0 0 1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .9.5M17 12h-1.5c-.8 0-1.5-.7-1.5-1.5V10h-1.5c-.8 0-1.5-.7-1.5-1.5V8h-.5C9.7 8 9 7.3 9 6.5V5.1c-3.1.4-5.5 2.9-5.9 6c.1-.6.7-1.1 1.4-1.1c.8 0 1.5.7 1.5 1.5S5.3 13 4.5 13s-1.4-.6-1.5-1.4c0 .5 0 1 .1 1.5c.4 2.7 2.5 4.9 5.1 5.6c-.4-.3-.7-.7-.7-1.2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .7-.5 1.3-1.2 1.5c4.2.4 7.7-2.9 7.7-7m-7.5-1c-.8 0-1.5.7-1.5 1.5S8.7 14 9.5 14s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5M9 7.5C9 6.7 8.3 6 7.5 6S6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5M21 17h2v-2h-2v2m0-10v6h2V7h-2Z"/>'
        },
        "cookie-check": {
            body: '<path fill="currentColor" d="M15 14.53v-.03c0-.83.67-1.5 1.5-1.5c.3 0 .58.09.82.24A6.2 6.2 0 0 1 19 13c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89c0-1.78.78-3.37 2-4.47M6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5M11 19c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5S11.83 19 11 19m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m11 3.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "cookie-check-outline": {
            body: '<path fill="currentColor" d="M15 10h-.5c-.83 0-1.5-.67-1.5-1.5V8h-.5c-.83 0-1.5-.67-1.5-1.5V5.07C7.91 5.5 5.47 8 5.07 11.08A1.494 1.494 0 0 1 8 11.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62A1.498 1.498 0 0 1 11 16c.83 0 1.5.67 1.5 1.5c0 .72-.5 1.32-1.18 1.46c.58.04 1.14.04 1.68-.04V19c0 .66.12 1.3.32 1.89c-.43.07-.87.11-1.32.11a9 9 0 0 1 0-18s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5a8.444 8.444 0 0 1 .02 2.82c-.59-.2-1.23-.32-1.89-.32h-.08c.05-.32.08-.66.08-1h-1.5c-.83 0-1.5-.67-1.5-1.5V10h-1m0 4.5v.03c.66-.58 1.45-1.03 2.32-1.29c-.24-.15-.52-.24-.82-.24c-.83 0-1.5.67-1.5 1.5m-3.5-.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M11 7.5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5m10.34 8.34l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "cookie-clock": {
            body: '<path fill="currentColor" d="M19.97 10.24c-.02-.24-.06-.5-.1-.74C19.6 9 19 9 19 9h-2V8c0-1-1-1-1-1h-2V6c0-1-1-1-1-1h-1V3c0-1-1-1-1-1a9 9 0 0 0-9 9c0 4.71 3.62 8.57 8.23 8.96A6.996 6.996 0 0 0 16 23c3.87 0 7-3.13 7-7c0-2.39-1.2-4.5-3.03-5.76m-8.33.29c-.77.62-1.41 1.39-1.86 2.28c-.46-.26-.78-.75-.78-1.31c0-.83.67-1.5 1.5-1.5c.46 0 .86.21 1.14.53M5.5 12c-.83 0-1.5-.67-1.5-1.5S4.67 9 5.5 9S7 9.67 7 10.5S6.33 12 5.5 12M7 6.5C7 5.67 7.67 5 8.5 5s1.5.67 1.5 1.5S9.33 8 8.5 8S7 7.33 7 6.5m1.5 10c0-.46.21-.86.53-1.14c-.03.21-.03.43-.03.64c0 .62.09 1.22.24 1.79c-.44-.29-.74-.74-.74-1.29M16 21c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25Z"/>'
        },
        "cookie-clock-outline": {
            body: '<path fill="currentColor" d="M8.5 8C7.67 8 7 7.33 7 6.5S7.67 5 8.5 5s1.5.67 1.5 1.5S9.33 8 8.5 8m8 4H15v5l3.61 2.16l.75-1.22l-2.86-1.69V12m6.5 4c0 3.87-3.13 7-7 7c-2.39 0-4.5-1.2-5.77-3.04C5.62 19.57 2 15.71 2 11a9 9 0 0 1 9-9s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5c.04.24.08.5.1.74A6.981 6.981 0 0 1 23 16M9.16 17.74c-.4-.27-.66-.74-.66-1.24c0-.46.21-.86.53-1.14c.09-.91.35-1.77.75-2.55c-.46-.26-.78-.75-.78-1.31c0-.83.67-1.5 1.5-1.5c.46 0 .86.21 1.14.53c.95-.76 2.1-1.27 3.36-1.45V9h-1.5c-.83 0-1.5-.67-1.5-1.5V7h-.5c-.83 0-1.5-.67-1.5-1.5V4.07C6.91 4.5 4.47 7 4.07 10.08A1.494 1.494 0 0 1 7 10.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62M21 16c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "cookie-cog": {
            body: '<path fill="currentColor" d="M21 12.29V12c0-.5-.04-1-.13-1.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18h.29a7.38 7.38 0 0 1-.29-2v-.41c-.25.25-.6.41-1 .41c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16c.59 0 1.1.35 1.34.84A7.003 7.003 0 0 1 19 12c.69 0 1.36.11 2 .29M6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13m3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9m2 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m11.2 5.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "cookie-cog-outline": {
            body: '<path fill="currentColor" d="M14.5 10c-.83 0-1.5-.67-1.5-1.5V8h-.5c-.83 0-1.5-.67-1.5-1.5V5.07C7.91 5.5 5.47 8 5.07 11.08A1.494 1.494 0 0 1 8 11.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62A1.498 1.498 0 0 1 11 16c.59 0 1.1.35 1.34.84c-.18.55-.28 1.13-.34 1.73c-.17.19-.4.33-.68.39c.23.04.46.04.68.04c0 .69.11 1.36.29 2H12a9 9 0 0 1 0-18s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5c.09.5.13 1 .13 1.5v.29a7.38 7.38 0 0 0-2-.29h-1.5c-.83 0-1.5-.67-1.5-1.5V10h-1.5m-3 1c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M11 7.5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5m12.8 12.9c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "cookie-edit": {
            body: '<path fill="currentColor" d="M15.1 15.03c-.06-.17-.1-.34-.1-.53c0-.83.67-1.5 1.5-1.5c.19 0 .36.04.53.1l2.36-2.36c.3-.3.66-.5 1.05-.62C20.21 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0-9 9c0 4.63 3.5 8.44 8 8.94v-1.81l.14-.13H11c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5v.14l2.6-2.61M6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13m3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9m2 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m11.35.19l-.98.98l-2.04-2.04l.98-.98c.19-.2.52-.2.72 0l1.32 1.32c.2.2.2.53 0 .72m-3.72-.36l2.04 2.04L15.04 22H13v-2.04l6.13-6.13Z"/>'
        },
        "cookie-edit-outline": {
            body: '<path fill="currentColor" d="M9.5 6c.83 0 1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5S8.67 6 9.5 6m2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5m-.5 5a1.498 1.498 0 0 0-.84 2.74c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5H16v.5c0 .83.67 1.5 1.5 1.5h.63l1.26-1.26c.3-.3.66-.5 1.05-.62C20.21 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0-9 9c0 4.63 3.5 8.44 8 8.94v-1.81l1.47-1.47c.03-.06.03-.11.03-.16c0-.83-.67-1.5-1.5-1.5m4-1.5c0 .19.04.36.1.53l1.93-1.93c-.17-.06-.34-.1-.53-.1c-.83 0-1.5.67-1.5 1.5m7.85-1.03l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96Z"/>'
        },
        "cookie-lock": {
            body: '<path fill="currentColor" d="M18.5 11c.92 0 1.77.29 2.5.77c0-.42-.05-.85-.13-1.27C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.34 0 .67 0 1-.06V17c0-.92.42-1.74 1.07-2.29A4.509 4.509 0 0 1 18.5 11m-12 2c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5M11 19c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5S11.83 19 11 19m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m9.5 2v-.5a2.5 2.5 0 0 0-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5Z"/>'
        },
        "cookie-lock-outline": {
            body: '<path fill="currentColor" d="M10 12.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m6-2.5v.5c0 .4.16.76.41 1.03A4.5 4.5 0 0 1 18.5 11c.92 0 1.77.29 2.5.77c0-.42-.05-.85-.13-1.27C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.34 0 .67 0 1-.06v-2.02c-.54.08-1.1.08-1.68.04c.68-.14 1.18-.74 1.18-1.46c0-.83-.67-1.5-1.5-1.5a1.498 1.498 0 0 0-.84 2.74c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5H16m-5-2.5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5M22 17v4c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1v-.5a2.5 2.5 0 0 1 5 0v.5c.55 0 1 .45 1 1m-2-1.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5h3v-.5Z"/>'
        },
        "cookie-minus": {
            body: '<path fill="currentColor" d="M15 14.53v-.03c0-.83.67-1.5 1.5-1.5c.3 0 .58.09.82.24A6.2 6.2 0 0 1 19 13c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89c0-1.78.78-3.37 2-4.47M6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5M11 19c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5S11.83 19 11 19m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M23 18v2h-8v-2h8Z"/>'
        },
        "cookie-minus-outline": {
            body: '<path fill="currentColor" d="M15 10h-.5c-.83 0-1.5-.67-1.5-1.5V8h-.5c-.83 0-1.5-.67-1.5-1.5V5.07C7.91 5.5 5.47 8 5.07 11.08A1.494 1.494 0 0 1 8 11.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62A1.498 1.498 0 0 1 11 16c.83 0 1.5.67 1.5 1.5c0 .72-.5 1.32-1.18 1.46c.58.04 1.14.04 1.68-.04V19c0 .66.12 1.3.32 1.89c-.43.07-.87.11-1.32.11a9 9 0 0 1 0-18s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5a8.444 8.444 0 0 1 .02 2.82c-.59-.2-1.23-.32-1.89-.32h-.08c.05-.32.08-.66.08-1h-1.5c-.83 0-1.5-.67-1.5-1.5V10h-1m0 4.5v.03c.66-.58 1.45-1.03 2.32-1.29c-.24-.15-.52-.24-.82-.24c-.83 0-1.5.67-1.5 1.5m-4-7c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5m.5 6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m3.5 4v2h8v-2h-8Z"/>'
        },
        "cookie-off": {
            body: '<path fill="currentColor" d="m9.25 6.05l-1.8-1.8A8.924 8.924 0 0 1 12 3s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5a8.896 8.896 0 0 1-1.12 6.05l-1.8-1.8c.02-.08.05-.16.05-.25c0-.83-.67-1.5-1.5-1.5c-.09 0-.17.03-.25.05l-5.3-5.3c.02-.08.05-.16.05-.25c0-.83-.67-1.5-1.5-1.5c-.09 0-.17.03-.25.05m12.86 15.41l-1.27 1.27l-3.5-3.5A8.914 8.914 0 0 1 12 21a9 9 0 0 1-9-9c0-2 .66-3.85 1.77-5.34L1.11 3l1.28-1.27l19.72 19.73M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5S5.67 13 6.5 13S8 12.33 8 11.5m2 1c0 .83.67 1.5 1.5 1.5c.18 0 .35-.04.5-.1L10.1 12c-.06.15-.1.32-.1.5m2.5 5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5Z"/>'
        },
        "cookie-off-outline": {
            body: '<path fill="currentColor" d="M8.93 5.73L7.45 4.25A8.924 8.924 0 0 1 12 3s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5a8.896 8.896 0 0 1-1.12 6.05l-1.47-1.47c.46-.93.72-1.97.72-3.08h-1.5c-.83 0-1.5-.67-1.5-1.5V10h-1.5c-.83 0-1.5-.67-1.5-1.5V8h-.5c-.83 0-1.5-.67-1.5-1.5V5.07c-.74.11-1.43.34-2.07.66m.32.32l1.7 1.7c.02-.08.05-.16.05-.25c0-.83-.67-1.5-1.5-1.5c-.09 0-.17.03-.25.05m7 7l1.7 1.7c.02-.08.05-.16.05-.25c0-.83-.67-1.5-1.5-1.5c-.09 0-.17.03-.25.05m5.86 8.41l-1.27 1.27l-3.5-3.5A8.914 8.914 0 0 1 12 21a9 9 0 0 1-9-9c0-2 .66-3.85 1.77-5.34L1.11 3l1.28-1.27l19.72 19.73m-6.21-3.67L12 13.9c-.15.06-.32.1-.5.1c-.83 0-1.5-.67-1.5-1.5c0-.18.04-.35.1-.5L6.21 8.1c-.59.9-1 1.9-1.14 2.98A1.494 1.494 0 0 1 8 11.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62A1.498 1.498 0 0 1 11 16c.83 0 1.5.67 1.5 1.5c0 .72-.5 1.32-1.18 1.46c1.71.16 3.29-.3 4.58-1.17Z"/>'
        },
        "cookie-outline": {
            body: '<path fill="currentColor" d="M20.87 10.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 1 0 9 9c0-.5-.04-1-.13-1.5m-9.55 8.46c.68-.14 1.18-.74 1.18-1.46c0-.83-.67-1.5-1.5-1.5a1.498 1.498 0 0 0-.84 2.74c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5H16v.5c0 .83.67 1.5 1.5 1.5H19c0 4.08-3.5 7.36-7.68 6.96M9.5 9C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9m3.5 3.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m5 2c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5Z"/>'
        },
        "cookie-plus": {
            body: '<path fill="currentColor" d="M15 14.53v-.03c0-.83.67-1.5 1.5-1.5c.3 0 .58.09.82.24A6.2 6.2 0 0 1 19 13c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89c0-1.78.78-3.37 2-4.47M6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5M11 19c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5S11.83 19 11 19m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "cookie-plus-outline": {
            body: '<path fill="currentColor" d="M16.5 13c.3 0 .58.09.82.24c-.87.26-1.66.71-2.32 1.29v-.03c0-.83.67-1.5 1.5-1.5m-.5-3v.5c0 .83.67 1.5 1.5 1.5H19c0 .34-.03.68-.08 1H19c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89v-.08c-.54.08-1.1.08-1.68.04c.68-.14 1.18-.74 1.18-1.46c0-.83-.67-1.5-1.5-1.5a1.498 1.498 0 0 0-.84 2.74c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5H16m-4.5 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M11 7.5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "cookie-refresh": {
            body: '<path fill="currentColor" d="M11 16c.53 0 1 .28 1.26.69C13.04 14 15.54 12 18.5 12c.88 0 1.71.18 2.5.5V12c0-.5-.04-1-.13-1.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18h.5c-.31-.76-.5-1.56-.5-2.39c-.26.24-.61.39-1 .39c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16m2-3.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m-6.5.5c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5m10 11l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4Z"/>'
        },
        "cookie-refresh-outline": {
            body: '<path fill="currentColor" d="M13 12.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m-2-5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5m4 2.5h1v.5c0 .83.67 1.5 1.5 1.5H19v.03c.69.06 1.36.21 2 .47V12c0-.5-.04-1-.13-1.5C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18h.5c-.26-.64-.41-1.31-.47-2c-.23 0-.47 0-.71-.04c.27-.06.49-.2.68-.38v-.08c0-.63.1-1.23.26-1.81a1.497 1.497 0 0 0-2.76.81c0 .5.26.97.66 1.24c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5h.5m7 8.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "cookie-remove": {
            body: '<path fill="currentColor" d="M16.5 13c.3 0 .58.09.82.24A6.2 6.2 0 0 1 19 13c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89c0-1.78.78-3.37 2-4.47v-.03c0-.83.67-1.5 1.5-1.5m-10 0c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9S8 8.33 8 7.5M11 19c-.83 0-1.5-.67-1.5-1.5S10.17 16 11 16s1.5.67 1.5 1.5S11.83 19 11 19m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m8.91 5l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "cookie-remove-outline": {
            body: '<path fill="currentColor" d="M17.32 13.24c-.87.26-1.66.71-2.32 1.29v-.03c0-.83.67-1.5 1.5-1.5c.3 0 .58.09.82.24M16 10v.5c0 .83.67 1.5 1.5 1.5H19c0 .34-.03.68-.08 1H19c.66 0 1.3.12 1.89.32a8.444 8.444 0 0 0-.02-2.82C20.6 10 20 10 20 10h-2V9c0-1-1-1-1-1h-2V7c0-1-1-1-1-1h-1V4c0-1-1-1-1-1a9 9 0 0 0 0 18c.45 0 .89-.04 1.32-.11c-.2-.59-.32-1.23-.32-1.89v-.08c-.54.08-1.1.08-1.68.04c.68-.14 1.18-.74 1.18-1.46c0-.83-.67-1.5-1.5-1.5a1.498 1.498 0 0 0-.84 2.74c-2.62-.7-4.66-2.93-5.07-5.62C5 12.61 5 12.11 5 11.62c.07.77.71 1.38 1.5 1.38c.83 0 1.5-.67 1.5-1.5S7.33 10 6.5 10c-.68 0-1.25.46-1.43 1.08C5.47 8 7.91 5.5 11 5.07V6.5c0 .83.67 1.5 1.5 1.5h.5v.5c0 .83.67 1.5 1.5 1.5H16m-5-2.5c0-.83-.67-1.5-1.5-1.5S8 6.67 8 7.5S8.67 9 9.5 9S11 8.33 11 7.5m.5 6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m11.04 2.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "cookie-settings": {
            body: '<path fill="currentColor" d="M20.87 9.5C20.6 9 20 9 20 9h-2V8c0-1-1-1-1-1h-2V6c0-1-1-1-1-1h-1V3c0-1-1-1-1-1a9 9 0 1 0 9 9c0-.5-.04-1-.13-1.5M6.5 12c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9S8 9.67 8 10.5S7.33 12 6.5 12M8 6.5C8 5.67 8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8S8 7.33 8 6.5M11 18c-.83 0-1.5-.67-1.5-1.5S10.17 15 11 15s1.5.67 1.5 1.5S11.83 18 11 18m.5-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "cookie-settings-outline": {
            body: '<path fill="currentColor" d="M13 11.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m-2-5c0-.83-.67-1.5-1.5-1.5S8 5.67 8 6.5S8.67 8 9.5 8S11 7.33 11 6.5M21 11a9 9 0 1 1-9-9s1 0 1 1v2h1s1 0 1 1v1h2s1 0 1 1v1h2s.6 0 .87.5c.09.5.13 1 .13 1.5m-2 0h-1.5c-.83 0-1.5-.67-1.5-1.5V9h-1.5c-.83 0-1.5-.67-1.5-1.5V7h-.5c-.83 0-1.5-.67-1.5-1.5V4.07C7.91 4.5 5.47 7 5.07 10.08A1.494 1.494 0 0 1 8 10.5c0 .83-.67 1.5-1.5 1.5c-.79 0-1.43-.61-1.5-1.38c0 .49 0 .99.09 1.5c.41 2.69 2.45 4.92 5.07 5.62A1.498 1.498 0 0 1 11 15c.83 0 1.5.67 1.5 1.5c0 .72-.5 1.32-1.18 1.46C15.5 18.36 19 15.08 19 11m-2.5 1c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M7 24h2v-2H7v2m8 0h2v-2h-2v2m-4 0h2v-2h-2v2Z"/>'
        },
        "coolant-temperature": {
            body: '<path fill="currentColor" d="M11.5 1A1.5 1.5 0 0 0 10 2.5v12c-.63.47-1 1.21-1 2a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5c0-.79-.37-1.5-1-2V13h4v-2h-4V9h4V7h-4V5h4V3h-4v-.5A1.5 1.5 0 0 0 11.5 1M0 15v2c.67 0 .79.21 1.29.71S2.67 19 4 19s2.21-.79 2.71-1.29c.11-.12.2-.21.29-.3v-2.25c-.79.26-1.35.77-1.71 1.13c-.5.5-.62.71-1.29.71s-.79-.21-1.29-.71S1.33 15 0 15m16 0v2c.67 0 .79.21 1.29.71S18.67 19 20 19s2.21-.79 2.71-1.29S23.33 17 24 17v-2c-1.33 0-2.21.79-2.71 1.29S20.67 17 20 17s-.79-.21-1.29-.71S17.33 15 16 15m-8 5c-1.33 0-2.21.79-2.71 1.29S4.67 22 4 22s-.79-.21-1.29-.71c-.36-.36-.92-.87-1.71-1.13v2.25c.09.09.18.18.29.3c.5.5 1.38 1.29 2.71 1.29s2.21-.79 2.71-1.29S7.33 22 8 22s.79.21 1.29.71c.44.43 1.15 1.09 2.21 1.25c.16.04.33.04.5.04c1.33 0 2.21-.79 2.71-1.29S15.33 22 16 22s.79.21 1.29.71S18.67 24 20 24s2.21-.79 2.71-1.29c.11-.12.2-.21.29-.3v-2.25c-.79.26-1.35.77-1.71 1.13c-.5.5-.62.71-1.29.71s-.79-.21-1.29-.71S17.33 20 16 20s-2.21.79-2.71 1.29s-.62.71-1.29.71c-.22 0-.37-.03-.5-.08c-.28-.1-.45-.29-.79-.63C10.21 20.79 9.33 20 8 20Z"/>'
        },
        copyleft: {
            body: '<path fill="currentColor" d="M13.92 10.86c.12.99.2 2.24-.3 3.14c-.12.27-.34.5-.59.64c-.23.15-.53.22-.89.23c-.42 0-.81-.14-1.14-.4a1.67 1.67 0 0 1-.34-.47c-.09-.17-.16-.36-.16-.57H8.72c.01.41.12.79.28 1.15c.2.36.45.67.76.92c1.44 1.33 4.09 1.12 5.3-.37c1.31-1.67 1.28-4.59-.01-6.26c-1.22-1.52-3.92-1.71-5.37-.37c-.3.28-.53.62-.68 1c-.19.4-.28.83-.3 1.3h1.8c0-.43.19-.86.47-1.17c.29-.29.7-.49 1.15-.49c.69.01 1.21.3 1.5.86c.14.24.25.53.3.86M12 2C6.5 2 2 6.5 2 12c.53 13.26 19.47 13.27 20 0c0-5.5-4.5-10-10-10M4 12c.44-10.61 15.56-10.61 16 0c0 4.41-3.59 8-8 8s-8-3.59-8-8Z"/>'
        },
        copyright: {
            body: '<path fill="currentColor" d="M10.08 10.86c.05-.33.16-.62.3-.86c.3-.56.81-.85 1.5-.86c.45 0 .86.2 1.15.49c.28.31.47.74.47 1.17h1.8c-.02-.47-.11-.9-.3-1.3c-.15-.38-.38-.72-.68-1c-1.45-1.34-4.14-1.15-5.37.37c-1.29 1.67-1.32 4.59-.01 6.26c1.21 1.49 3.86 1.7 5.3.37c.31-.25.56-.56.76-.92c.16-.36.27-.74.28-1.15H13.5c0 .21-.07.4-.16.57c-.09.19-.21.34-.34.47c-.33.26-.72.4-1.14.4c-.36-.01-.66-.08-.89-.23a1.41 1.41 0 0 1-.59-.64c-.5-.9-.42-2.15-.3-3.14M12 2C6.5 2 2 6.5 2 12c.53 13.27 19.5 13.26 20 0c0-5.5-4.5-10-10-10m0 18c-4.41 0-8-3.59-8-8c.44-10.61 15.56-10.61 16 0c0 4.41-3.59 8-8 8Z"/>'
        },
        cordova: {
            body: '<path fill="currentColor" d="M20.18 21.55h-3.24l.23-2.73h-1.59l-.23 2.73h-6.7l-.23-2.73H6.83l.23 2.73H3.82L2 9.73l4.55-7.28h10.9L22 9.73l-1.82 11.82M16.55 6.09h-2.93l.2 1.36h-3.64l.2-1.36H7.45L5.64 9.73L6.55 17h10.9l.91-7.27l-1.81-3.64m-1.6 8.5c-.25 0-.45-.76-.45-1.69c0-.94.2-1.7.45-1.7c.26 0 .46.76.46 1.7c0 .93-.2 1.69-.46 1.69m-5.73.14c-.26 0-.46-.76-.46-1.69c0-.94.2-1.69.46-1.69c.25 0 .45.75.45 1.69c0 .93-.2 1.69-.45 1.69Z"/>'
        },
        corn: {
            body: '<path fill="currentColor" d="M11 12H8.82c.8.5 1.53 1.07 2.18 1.68V12m-4-1c.27-5.12 2.37-9 5-9c2.66 0 4.77 3.94 5 9.12c1.5-.69 3.17-1.12 5-1.12c-5.75 2.57-3.75 12-10 12c-6 0-4.07-9.43-10-12c1.82 0 3.5.4 5 1m4 0V9H8.24l-.21 2H11m0-3V6H9.05c-.25.6-.45 1.27-.62 2H11m0-3V3.3c-.55.33-1.05.92-1.5 1.7H11m1-2v2h1v1h-1v2h2v1h-2v2h3v1h-3v2h2v1h-1.77c1.19 1.45 1.92 3 2.09 4.23c.99-1.67 1.64-4.39 1.68-7.47C15.94 7 14.13 3 12 3Z"/>'
        },
        "corn-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l6.1 6.1c-.1.6-.2 1.2-.2 1.9c-1.5-.6-3.2-1-5-1c5.9 2.6 4 12 10 12c2.5 0 3.7-1.5 4.6-3.5l4.3 4.3l1.2-1.3M8.1 10l1 1H8l.1-1m.7 2h1.3l.9.9v.8c-.7-.6-1.4-1.2-2.2-1.7m5.5 7.2c-.2-1.2-.9-2.8-2.1-4.2h.9l2.1 2.1c-.2.8-.5 1.5-.9 2.1M11 6v1.8L12.2 9H14V8h-2V6h1V5h-1V3c2.1 0 3.9 4 4 8.8v1l2 2c.8-2 1.9-3.9 4-4.8c-1.8 0-3.5.4-5 1.1c-.2-5.2-2.3-9.1-5-9.1c-1.5 0-2.8 1.2-3.7 3.1l.9.9H11m0-2.7V5H9.5c.5-.8 1-1.4 1.5-1.7m4 8.5l-.8-.8h.8v.8Z"/>'
        },
        "cosine-wave": {
            body: '<path fill="currentColor" d="M22 2v2c-1.74 0-3 4.58-4.04 8.27c-1.39 5-2.7 9.73-5.96 9.73s-4.57-4.73-5.96-9.73C5 8.58 3.74 4 2 4V2c3.26 0 4.57 4.73 5.96 9.73C9 15.42 10.26 20 12 20c1.74 0 3-4.58 4.04-8.27C17.43 6.73 18.74 2 22 2Z"/>'
        },
        counter: {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h7V6H4m16 12V6h-1.24c.24.54.19 1.07.19 1.13c-.07.67-.54 1.37-.71 1.62l-2.33 2.55l3.32-.02l.01 1.22l-5.2-.03l-.04-1s3.05-3.23 3.2-3.52c.14-.28.71-1.95-.7-1.95c-1.23.05-1.09 1.3-1.09 1.3l-1.54.01s.01-.66.38-1.31H13v12h2.58l-.01-.86l.97-.01s.91-.16.92-1.05c.04-1-.81-1-.96-1c-.13 0-1.07.05-1.07.87h-1.52s.04-2.06 2.59-2.06c2.6 0 2.46 2.02 2.46 2.02s.04 1.25-1.11 1.72l.52.37H20M8.92 16h-1.5v-5.8l-1.8.56V9.53l3.14-1.12h.16V16Z"/>'
        },
        countertop: {
            body: '<path fill="currentColor" d="M18 10V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2h-4m-5 8h-2v-6h2v6Z"/>'
        },
        "countertop-outline": {
            body: '<path fill="currentColor" d="M22 10h-4V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2M6 6h2v2H6V6m0 12v-6h5v6H6m12 0h-5v-6h5v6Z"/>'
        },
        cow: {
            body: '<path fill="currentColor" d="M10.5 18a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5m3 0a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5M10 11a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 7c0 2.21-2.69 4-6 4s-6-1.79-6-4c0-.9.45-1.73 1.2-2.4c-.75-1-1.2-2.25-1.2-3.6l.12-1.22c-.54.15-1.19.15-1.72 0c-1.02-.28-2.56-1.43-2.33-2.23c.23-.8 2.14-.95 3.16-.65c.59.17 1.22.6 1.59 1.06l.57-.81C6.79 7.05 7 4 10 3l-.09.14c-.28.44-1 1.83-.24 3.33a6.02 6.02 0 0 1 4.66 0c.76-1.5.04-2.89-.24-3.33L14 3c3 1 3.21 4.05 2.61 5.15l.57.81c.37-.46 1-.89 1.59-1.06c1.02-.3 2.93-.15 3.16.65c.23.8-1.31 1.95-2.33 2.23c-.53.15-1.18.15-1.72 0L18 12c0 1.35-.45 2.6-1.2 3.6c.75.67 1.2 1.5 1.2 2.4m-6-2c-2.21 0-4 .9-4 2s1.79 2 4 2s4-.9 4-2s-1.79-2-4-2m0-2c1.12 0 2.17.21 3.07.56c.58-.69.93-1.56.93-2.56a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 1 .35 1.87.93 2.56c.9-.35 1.95-.56 3.07-.56m2.09-10.86Z"/>'
        },
        "cow-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l5.8 5.8l-.1.2c-.4-.5-1-.9-1.6-1.1c-1-.3-2.9-.2-3.2.6s1.3 2 2.3 2.2c.5.1 1.2.1 1.7 0V12c0 1.3.5 2.6 1.2 3.6c-.7.7-1.2 1.5-1.2 2.4c0 2.2 2.7 4 6 4c2.5 0 4.7-1 5.6-2.5l3.3 3.3l1.2-1.3M9.4 11.2c-.3.2-.4.5-.4.8c0 .6.4 1 1 1c.3 0 .6-.1.8-.4l1.4 1.4h-.1c-1.1 0-2.2.2-3.1.6c-.7-.7-1-1.6-1-2.6c0-.6.1-1.2.4-1.7l1 .9M16 18c0 1.1-1.8 2-4 2s-4-.9-4-2s1.8-2 4-2c1 0 1.9.2 2.6.5l1.4 1.4v.1M9.7 6.5L7.8 4.6C8.3 3.9 9 3.3 10 3l-.1.1c-.3.5-1 1.9-.2 3.4m1.6 1.6L9.7 6.5c.7-.3 1.5-.5 2.3-.5s1.6.2 2.3.5c.8-1.5 0-2.9-.2-3.3L14 3c3 1 3.2 4 2.6 5.2l.6.8c.4-.5 1-.9 1.6-1.1c1-.3 2.9-.2 3.2.6s-1.3 2-2.3 2.2c-.5.1-1.2.1-1.7 0V12c0 .8-.2 1.6-.5 2.3l-1.6-1.6c0-.2.1-.5.1-.7c0-2.2-1.8-4-4-4c-.2 0-.5 0-.7.1M14 18.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5s.2-.5.5-.5s.5.2.5.5m-3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5s.2-.5.5-.5s.5.2.5.5Z"/>'
        },
        "cpu-32-bit": {
            body: '<path fill="currentColor" d="M9 3v2H7a2 2 0 0 0-2 2v2H3v2h2v2H3v2h2v2a2 2 0 0 0 2 2h2v2h2v-2h2v2h2v-2h2a2 2 0 0 0 2-2v-2h2v-2h-2v-2h2V9h-2V7a2 2 0 0 0-2-2h-2V3h-2v2h-2V3M7 9h3.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7v-1.5h3v-.75H8.5v-1.5H10v-.75H7M12.5 9H16a1 1 0 0 1 1 1v1.75a1 1 0 0 1-1 1h-2v.75h3V15h-4.5v-2.75a1 1 0 0 1 1-1h2v-.75h-3"/>'
        },
        "cpu-64-bit": {
            body: '<path fill="currentColor" d="M9 3v2H7a2 2 0 0 0-2 2v2H3v2h2v2H3v2h2v2a2 2 0 0 0 2 2h2v2h2v-2h2v2h2v-2h2a2 2 0 0 0 2-2v-2h2v-2h-2v-2h2V9h-2V7a2 2 0 0 0-2-2h-2V3h-2v2h-2V3M8 9h3.5v1.5h-3v.75h2a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m4.5 0H14v2h1.5V9H17v6h-1.5v-2.5h-3m-4 .25v.75H10v-.75"/>'
        },
        cradle: {
            body: '<path fill="currentColor" d="M18 9h-6V4H8C5.8 4 4 5.8 4 8v6c0 1.1.9 2 2 2h2v2.9c-.6-.4-1.2-.8-1.7-1.3L4.9 19c1.8 1.9 4.3 3 7.1 3s5.3-1.1 7.1-2.9l-1.4-1.4c-.5.5-1 .9-1.6 1.3v-3h2c1.1 0 2-.9 2-2v-3c-.1-1.1-1-2-2.1-2m-4 10.8c-.6.2-1.3.2-2 .2s-1.4-.1-2-.2V16h4v3.8Z"/>'
        },
        "cradle-outline": {
            body: '<path fill="currentColor" d="M18 9h-6V4H8C5.8 4 4 5.8 4 8v6c0 1.1.9 2 2 2h2v2.9c-.6-.4-1.2-.8-1.7-1.3L4.9 19c1.8 1.9 4.3 3 7.1 3s5.3-1.1 7.1-2.9l-1.4-1.4c-.5.5-1 .9-1.6 1.3v-3h2c1.1 0 2-.9 2-2v-3c-.1-1.1-1-2-2.1-2m-4 10.8c-.6.2-1.3.2-2 .2s-1.4-.1-2-.2V16h4v3.8m4-5.8H6V8c0-1.1.9-2 2-2h2v5h8v3Z"/>'
        },
        crane: {
            body: '<path fill="currentColor" d="M20 6V5a1 1 0 0 0-1-1H9V3H6v1H5v2h1v9H5v-2H3v2H2v2h1v4h2v-4h5v4h2v-4h1v-2h-1v-2h-2v2H9V6h8v4.62c-.47.17-.81.61-.81 1.14c0 .44.24.84.61 1.06V14h.62c.34 0 .61.28.61.62c0 .34-.27.62-.61.62c-.22 0-.42-.12-.53-.31a.62.62 0 0 0-.84-.22c-.3.16-.4.54-.23.84c.33.56.94.92 1.6.92c1.01 0 1.84-.83 1.84-1.85c0-.78-.5-1.48-1.23-1.74v-.06c.38-.22.62-.62.62-1.06c0-.46-.27-.85-.65-1.06V6h2M8 13.66l-1 1v-1.42l1-1v1.42m0-2.95l-1 1v-1.42l1-1v1.42m-1-2V7.29l1-1v1.42l-1 1Z"/>'
        },
        creation: {
            body: '<path fill="currentColor" d="m19 1l-1.26 2.75L15 5l2.74 1.26L19 9l1.25-2.74L23 5l-2.75-1.25M9 4L6.5 9.5L1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5M19 15l-1.26 2.74L15 19l2.74 1.25L19 23l1.25-2.75L23 19l-2.75-1.26"/>'
        },
        "creative-commons": {
            body: '<path fill="currentColor" d="m11.89 10.34l-1.34.7c-.14-.3-.31-.51-.52-.63c-.21-.12-.41-.18-.58-.18c-.9 0-1.34.59-1.34 1.77c0 .54.11.97.34 1.29c.22.32.55.48 1 .48c.58 0 .99-.27 1.23-.86l1.23.63c-.26.49-.62.87-1.09 1.15c-.46.28-.97.42-1.53.42c-.9 0-1.62-.27-2.17-.82C6.58 13.74 6.3 13 6.3 12c0-.95.28-1.7.83-2.26c.56-.56 1.26-.84 2.1-.84c1.24-.01 2.13.48 2.66 1.44m5.77 0l-1.32.7c-.14-.3-.34-.51-.53-.63c-.21-.12-.41-.18-.6-.18c-.89 0-1.34.59-1.34 1.77c0 .54.13.97.34 1.29c.23.32.56.48 1 .48c.59 0 1-.27 1.24-.86l1.25.63c-.28.49-.65.87-1.11 1.15c-.47.28-.97.42-1.52.42c-.9 0-1.63-.27-2.17-.82c-.54-.55-.81-1.29-.81-2.29c0-.95.28-1.7.83-2.26c.55-.56 1.25-.84 2.08-.84c1.26-.01 2.14.48 2.66 1.44M12 3.5a8.5 8.5 0 0 1 8.5 8.5a8.5 8.5 0 0 1-8.5 8.5A8.5 8.5 0 0 1 3.5 12A8.5 8.5 0 0 1 12 3.5M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "credit-card": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 7H4V8h16Z"/>'
        },
        "credit-card-check": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.06-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.06 0 2.09.28 3 .81V6c0-1.11-.89-2-2-2m0 7H4V8h16m-2.25 14L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 22"/>'
        },
        "credit-card-check-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H3v-6h16v1c.7 0 1.37.13 2 .35V6c0-1.11-.89-2-2-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h10.09c-.05-.33-.09-.66-.09-1M3 6h16v2H3V6m14.75 16L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 22"/>'
        },
        "credit-card-chip": {
            body: '<path fill="currentColor" d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2M10 14H5v-4h5v4Z"/>'
        },
        "credit-card-chip-outline": {
            body: '<path fill="currentColor" d="M20 6v12H4V6h16m0-2H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m-9 6H6v4h5v-4Z"/>'
        },
        "credit-card-clock": {
            body: '<path fill="currentColor" d="M16 14h1.5v2.82l2.44 1.41l-.75 1.3L16 17.69V14m8 3a7 7 0 0 1-7 7c-2.79 0-5.2-1.64-6.33-4H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9m-7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m3-2V7H4v3h16Z"/>'
        },
        "credit-card-clock-outline": {
            body: '<path fill="currentColor" d="M16 14h1.5v2.82l2.44 1.41l-.75 1.3L16 17.69V14m8 3a7 7 0 0 1-7 7c-2.79 0-5.2-1.64-6.33-4H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9m-14 0c0-1.96.81-3.73 2.1-5H4v6h6.07c-.07-.33-.07-.66-.07-1m7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m3-4V6H4v2h16Z"/>'
        },
        "credit-card-edit": {
            body: '<path fill="currentColor" d="M20.6 11.3c.1-.1.2-.2.4-.2c.1 0 .3.1.4.2l1.2 1.2c.2.2.2.6 0 .8l-1 1l-2-2l1-1M13 18.9l6-6.1l2.1 2.1l-6 6.1H13v-2.1m-2 .2v-1l.6-.6l6.5-6.5H4V8h16v1.1l2-2V6c0-1.1-.9-2-2-2H4c-.5 0-1 .2-1.4.6C2.2 5 2 5.5 2 6v12c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6h7v-.9Z"/>'
        },
        "credit-card-edit-outline": {
            body: '<path fill="currentColor" d="m13 18.9l6.1-6.1l2.1 2.1l-6.1 6.1H13v-2.1m8.4-7.6l1.3 1.3c.2.2.2.5 0 .7l-1 1l-2.1-2l1-1c.1-.1.2-.2.4-.2s.3.1.4.2M11 18H4v-6h13.1L22 7.1V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2M4 6h16v2H4V6Z"/>'
        },
        "credit-card-fast": {
            body: '<path fill="currentColor" d="M3 8c-.55 0-1-.45-1-1s.45-1 1-1h2.54C5.19 6.6 5 7.29 5 8H3m2 5H2c-.55 0-1-.45-1-1s.45-1 1-1h3v2m-4 5c-.552 0-1-.45-1-1s.448-1 1-1h4c0 .71.19 1.4.54 2H1M21 6H9c-1.11 0-2 .89-2 2v8c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m0 6H9V9h12v3Z"/>'
        },
        "credit-card-fast-outline": {
            body: '<path fill="currentColor" d="M3 8c-.55 0-1-.45-1-1s.45-1 1-1h2.54C5.19 6.6 5 7.29 5 8H3m2 5H2c-.55 0-1-.45-1-1s.45-1 1-1h3v2m-4 5c-.552 0-1-.45-1-1s.448-1 1-1h4c0 .71.19 1.4.54 2H1M21 6H9c-1.11 0-2 .89-2 2v8c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m0 2v1H9V8h12M9 16v-4h12v4H9Z"/>'
        },
        "credit-card-lock": {
            body: '<path fill="currentColor" d="M21.8 15v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V15c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V15m-7.47 5H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v4.04c-.58-.44-1.25-.78-2-.93V8H4v3h11.04c-.54.72-.84 1.58-.84 2.5v.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .1 0 .2.03.3Z"/>'
        },
        "credit-card-lock-outline": {
            body: '<path fill="currentColor" d="M21.8 15v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V15c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V15M13 19.7V18H4v-6h10.5c.68-1.72 2.46-3 4.5-3c1.13 0 2.17.4 3 1.04V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.03c-.03-.1-.03-.2-.03-.3M4 6h16v2H4V6Z"/>'
        },
        "credit-card-marker": {
            body: '<path fill="currentColor" d="M18.5 12c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2M14.55 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v5.3a5.55 5.55 0 0 0-2-1.08V8H4v3h11.39C13.96 12 13 13.66 13 15.5c0 1.5.72 3.11 1.55 4.5Z"/>'
        },
        "credit-card-marker-outline": {
            body: '<path fill="currentColor" d="M13.5 18H4v-6h10.3c1-1.2 2.5-2 4.2-2c1.3 0 2.5.5 3.5 1.3V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10.6c-.4-.6-.8-1.3-1.1-2M4 6h16v2H4V6m14.5 6c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2Z"/>'
        },
        "credit-card-minus": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09c-.06-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.06 0 2.09.28 3 .81V6c0-1.11-.89-2-2-2m0 7H4V8h16m3 10v2h-8v-2h8Z"/>'
        },
        "credit-card-minus-outline": {
            body: '<path fill="currentColor" d="M24 18v2h-8v-2m3-10V6H3v2h16m0 4H3v6h11v2H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16c1.11 0 2 .89 2 2v7h-2v-1Z"/>'
        },
        "credit-card-multiple": {
            body: '<path fill="currentColor" d="M21 9V6H7v3h14m0-6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M3 19h15v2H3a2 2 0 0 1-2-2V8h2Z"/>'
        },
        "credit-card-multiple-outline": {
            body: '<path fill="currentColor" d="M21 8V6H7v2h14m0 8v-5H7v5h14m0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h14M3 20h15v2H3a2 2 0 0 1-2-2V9h2v11Z"/>'
        },
        "credit-card-off": {
            body: '<path fill="currentColor" d="m11.2 8l-4-4H20a2 2 0 0 1 2 2v12a1.91 1.91 0 0 1-.12.68L14.2 11H20V8m.84 14.73L18.11 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 .65-1.46L1.11 3l1.28-1.27l19.72 19.73M9.11 11l-3-3H4v3Z"/>'
        },
        "credit-card-off-outline": {
            body: '<path fill="currentColor" d="m.93 4.2l1.28-1.27L20 20.72L18.73 22l-2-2H4a2 2 0 0 1-2-2V6c0-.22.04-.43.11-.62L.93 4.2M20 8V6H7.82l-2-2H20a2 2 0 0 1 2 2v12c0 .6-.26 1.13-.68 1.5l-1.5-1.5H20v-6h-6.18l-4-4H20M4 8h.73L4 7.27V8m0 4v6h10.73l-6-6H4Z"/>'
        },
        "credit-card-outline": {
            body: '<path fill="currentColor" d="M20 8H4V6h16m0 12H4v-6h16m0-8H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "credit-card-plus": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09a5.47 5.47 0 0 1-.09-1a6 6 0 0 1 6-6a5.88 5.88 0 0 1 3 .81V6a2 2 0 0 0-2-2m0 7H4V8h16m0 7v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "credit-card-plus-outline": {
            body: '<path fill="currentColor" d="M21 18h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3M19 8V6H3v2h16m0 4H3v6h11v2H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16a2 2 0 0 1 2 2v7h-2v-1Z"/>'
        },
        "credit-card-refresh": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7.68c-.11-.5-.18-1-.18-1.5A6.5 6.5 0 0 1 18 12c1.5 0 2.9.53 4 1.4V6c0-1.11-.89-2-2-2m0 7H4V8h16v3m.83 4.67L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17Z"/>'
        },
        "credit-card-refresh-outline": {
            body: '<path fill="currentColor" d="M20 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7.68c-.11-.5-.18-1-.18-1.5c0-.17 0-.33.03-.5H4v-6h16v.32c.74.24 1.41.61 2 1.08V6a2 2 0 0 0-2-2m0 4H4V6h16v2m.83 7.67L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17Z"/>'
        },
        "credit-card-refund": {
            body: '<path fill="currentColor" d="M18 11H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m0 6H6v-3h12m-1-9v5h-1.5V6.5H9.88l2.42 2.43L11.24 10L7 5.75l4.24-4.25l1.06 1.07L9.88 5Z"/>'
        },
        "credit-card-refund-outline": {
            body: '<path fill="currentColor" d="M18 11H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m0 10H6v-4h12v4m0-6H6v-2h12v2M17 5v5h-1.5V6.5H9.88l2.42 2.43L11.24 10L7 5.75l4.24-4.25l1.06 1.07L9.88 5H17Z"/>'
        },
        "credit-card-remove": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.09a5.47 5.47 0 0 1-.09-1a6 6 0 0 1 6-6a5.88 5.88 0 0 1 3 .81V6a2 2 0 0 0-2-2m0 7H4V8h16m2.54 8.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.13-2.12l1.42-1.42L19 17.59l2.12-2.13Z"/>'
        },
        "credit-card-remove-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H3v-6h16v1c.7 0 1.37.13 2 .35V6c0-1.11-.89-2-2-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h10.09c-.05-.33-.09-.66-.09-1M3 6h16v2H3V6m19.54 10.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.13l1.42 1.42Z"/>'
        },
        "credit-card-scan": {
            body: '<path fill="currentColor" d="M18 6H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 6H6V9h12M2 4h4V2H2a2 2 0 0 0-2 2v4h2V4m20-2h-4v2h4v4h2V4a2 2 0 0 0-2-2M2 16H0v4a2 2 0 0 0 2 2h4v-2H2v-4m20 4h-4v2h4a2 2 0 0 0 2-2v-4h-2v4"/>'
        },
        "credit-card-scan-outline": {
            body: '<path fill="currentColor" d="M2 4h4V2H2a2 2 0 0 0-2 2v4h2V4m20-2h-4v2h4v4h2V4a2 2 0 0 0-2-2M2 16H0v4a2 2 0 0 0 2 2h4v-2H2v-4m20 4h-4v2h4a2 2 0 0 0 2-2v-4h-2v4M4 8v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2m2 8v-4h12v4H6m12-8v2H6V8h12Z"/>'
        },
        "credit-card-search": {
            body: '<path fill="currentColor" d="M11.82 11c-2.42 2.5-2.42 6.5 0 9H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v6.06c-.26-.41-.55-.8-.9-1.16c-.34-.33-.71-.63-1.1-.87V8H4v3h7.82m11.57 10L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "credit-card-search-outline": {
            body: '<path fill="currentColor" d="M11.03 12c.25-.39.54-.76.87-1.1a6.525 6.525 0 0 1 9.2 0c.35.36.64.75.9 1.16V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7.82a6.44 6.44 0 0 1-1.32-2H4v-6h7.03M4 6h16v2H4V6m16.31 11.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S12 13 12 15.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L22 22.39L23.39 21l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "credit-card-settings": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 7H4V8h16M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2Z"/>'
        },
        "credit-card-settings-outline": {
            body: '<path fill="currentColor" d="M20 8H4V6h16m0 12H4v-6h16m0-8H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "credit-card-sync": {
            body: '<path fill="currentColor" d="M13 17.5c0 .89.18 1.73.5 2.5H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v5.5c-.77-.32-1.61-.5-2.5-.5h.5V8H4v3h15.5a6.5 6.5 0 0 0-6.5 6.5m6 2.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20m0-6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4Z"/>'
        },
        "credit-card-sync-outline": {
            body: '<path fill="currentColor" d="M4 18v-6h12.05c1-.63 2.18-1 3.45-1c.89 0 1.73.18 2.5.5V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.5c-.26-.62-.42-1.3-.47-2H4M4 6h16v2H4V6m19 11.5c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12v1.5c2.21 0 4 1.79 4 4m-4 1l2.25 2.25L19 23v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5Z"/>'
        },
        "credit-card-wireless": {
            body: '<path fill="currentColor" d="m4.93 4.92l1.41 1.41c3.12-3.13 8.19-3.13 11.32 0l1.41-1.41C15.17 1 8.84 1 4.93 4.92m2.83 2.83l1.41 1.41a4.008 4.008 0 0 1 5.66 0l1.41-1.41a6 6 0 0 0-8.48 0M18 11H6a2 2 0 0 0-2 2v8c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2v-8a2 2 0 0 0-2-2m0 6H6v-3h12v3Z"/>'
        },
        "credit-card-wireless-off": {
            body: '<path fill="currentColor" d="M12 2c-2.15 0-4.3.69-6.1 2.08L7.32 5.5c3.13-2.26 7.52-2 10.34.83l1.41-1.41C17.12 2.96 14.56 2 12 2M3.28 4L2 5.27L7.73 11H6a2 2 0 0 0-2 2v8c0 1.11.89 2 2 2h12c.5 0 .92-.18 1.27-.46l.46.46L21 21.72M12 6c-1.13 0-2.25.31-3.23.94l1.47 1.47c1.49-.73 3.34-.49 4.59.75l1.41-1.41A5.964 5.964 0 0 0 12 6m.82 5l3 3H18v2.18l2 2V13a2 2 0 0 0-2-2M6 14h4.73l3 3H6Z"/>'
        },
        "credit-card-wireless-off-outline": {
            body: '<path fill="currentColor" d="M12 2c-2.15 0-4.3.69-6.1 2.08L7.32 5.5c3.13-2.26 7.52-2 10.34.83l1.41-1.41C17.12 2.96 14.56 2 12 2M3.28 4L2 5.27L7.73 11H6a2 2 0 0 0-2 2v8c0 1.11.89 2 2 2h12c.47 0 .92-.16 1.27-.46l.46.46L21 21.72M12 6c-1.13 0-2.25.31-3.23.94l1.47 1.47c1.49-.73 3.34-.49 4.59.75l1.41-1.41A5.964 5.964 0 0 0 12 6m.82 5l2 2H18v2h-1.18L20 18.18V13a2 2 0 0 0-2-2M6 13h3.73l2 2H6m0 2h7.73l4 4H6Z"/>'
        },
        "credit-card-wireless-outline": {
            body: '<path fill="currentColor" d="M18 11H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m0 10H6v-4h12v4m0-6H6v-2h12v2M4.93 4.92l1.41 1.41c3.12-3.13 8.19-3.13 11.32 0l1.41-1.41C15.17 1 8.84 1 4.93 4.92m2.83 2.83l1.41 1.41a4.008 4.008 0 0 1 5.66 0l1.41-1.41a6 6 0 0 0-8.48 0Z"/>'
        },
        cricket: {
            body: '<path fill="currentColor" d="m14.34 17.77l1.41-1.41L20 20.58L18.56 22l-4.22-4.23M18.5 2A3.5 3.5 0 0 1 22 5.5A3.5 3.5 0 0 1 18.5 9A3.5 3.5 0 0 1 15 5.5A3.5 3.5 0 0 1 18.5 2M2.24 7.11l2.83-2.83a1.02 1.02 0 0 1 1.43 0l8.47 8.49c.39.39.39 1.02 0 1.41L12.14 17a.99.99 0 0 1-1.42 0L2.24 8.53c-.39-.4-.39-1.03 0-1.42Z"/>'
        },
        crop: {
            body: '<path fill="currentColor" d="M7 17V1H5v4H1v2h4v10a2 2 0 0 0 2 2h10v4h2v-4h4v-2m-6-2h2V7a2 2 0 0 0-2-2H9v2h8v8Z"/>'
        },
        "crop-free": {
            body: '<path fill="currentColor" d="M19 3h-4v2h4v4h2V5a2 2 0 0 0-2-2m0 16h-4v2h4a2 2 0 0 0 2-2v-4h-2M5 15H3v4a2 2 0 0 0 2 2h4v-2H5M3 5v4h2V5h4V3H5a2 2 0 0 0-2 2Z"/>'
        },
        "crop-landscape": {
            body: '<path fill="currentColor" d="M19 17H5V7h14m0-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z"/>'
        },
        "crop-portrait": {
            body: '<path fill="currentColor" d="M17 19H7V5h10m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "crop-rotate": {
            body: '<path fill="currentColor" d="M7.47 21.5C4.2 19.93 1.86 16.76 1.5 13H0c.5 6.16 5.66 11 11.95 11c.23 0 .44 0 .66-.03L8.8 20.15L7.47 21.5M12.05 0c-.23 0-.44 0-.66.04l3.81 3.81l1.33-1.35c3.27 1.57 5.61 4.74 5.97 8.5H24c-.5-6.16-5.66-11-11.95-11M16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6m-8 2V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8Z"/>'
        },
        "crop-square": {
            body: '<path fill="currentColor" d="M18 18H6V6h12m0-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        cross: {
            body: '<path fill="currentColor" d="M10.5 2h3v6H19v3h-5.5v11h-3V11H5V8h5.5V2Z"/>'
        },
        "cross-bolnisi": {
            body: '<path fill="currentColor" d="m22 7l-.5-.5c-1.57 1.5-3.03 2.9-4.57 3.68c-1.43.73-2.49.73-3.93.82c.09-1.44.09-2.5.82-3.93c.78-1.54 2.18-3 3.68-4.57L17 2c-1.68 1.23-3.36 1.83-5 1.83c-1.64 0-3.32-.6-5-1.83l-.5.5C8 4.07 9.4 5.53 10.18 7.07c.73 1.43.73 2.49.82 3.93c-1.44-.09-2.5-.09-3.93-.82C5.53 9.4 4.06 8 2.5 6.5L2 7c1.23 1.68 1.83 3.36 1.83 5c0 1.64-.6 3.32-1.83 5l.5.5c1.57-1.5 3.03-2.9 4.57-3.68c1.43-.73 2.49-.73 3.93-.82c-.09 1.44-.09 2.5-.82 3.93c-.78 1.54-2.18 3-3.68 4.57l.5.5c1.68-1.23 3.36-1.83 5-1.83c1.64 0 3.32.6 5 1.83l.5-.5c-1.5-1.57-2.9-3.03-3.68-4.57c-.73-1.43-.73-2.49-.82-3.93c1.44.09 2.5.09 3.93.82c1.54.78 3 2.18 4.57 3.68l.5-.5c-1.23-1.68-1.83-3.36-1.83-5c0-1.64.6-3.32 1.83-5Z"/>'
        },
        "cross-celtic": {
            body: '<path fill="currentColor" d="M17.8 8a5.968 5.968 0 0 0-4.3-4.3V2h-3v1.7A5.968 5.968 0 0 0 6.2 8H4v3h2.2a5.968 5.968 0 0 0 4.3 4.3V22h3v-6.7a5.968 5.968 0 0 0 4.3-4.3h2.17V8H17.8m-5.76 1.53L14.5 11h1.26a4.078 4.078 0 0 1-2.26 2.26V12l-1.44-2.44L12 9.5l-.06.06L10.5 12v1.26A4.109 4.109 0 0 1 8.24 11H9.5l2.46-1.47l.04-.03h-.04L9.5 8H8.24a4.078 4.078 0 0 1 2.26-2.26V7l1.44 2.44l.06.06l.06-.06L13.5 7V5.74c1.03.42 1.85 1.23 2.26 2.26H14.5l-2.46 1.5H12l.04.03Z"/>'
        },
        "cross-outline": {
            body: '<path fill="currentColor" d="M15.5 6V1h-7v5H3v7h5.5v10h7V13H21V6h-5.5m3.5 5h-5.5v10h-3V11H5V8h5.5V3h3v5H19v3Z"/>'
        },
        crosshairs: {
            body: '<path fill="currentColor" d="M3.05 13H1v-2h2.05C3.5 6.83 6.83 3.5 11 3.05V1h2v2.05c4.17.45 7.5 3.78 7.95 7.95H23v2h-2.05c-.45 4.17-3.78 7.5-7.95 7.95V23h-2v-2.05C6.83 20.5 3.5 17.17 3.05 13M12 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7a7 7 0 0 0 7-7a7 7 0 0 0-7-7Z"/>'
        },
        "crosshairs-gps": {
            body: '<path fill="currentColor" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m-8.95 5H1v-2h2.05C3.5 6.83 6.83 3.5 11 3.05V1h2v2.05c4.17.45 7.5 3.78 7.95 7.95H23v2h-2.05c-.45 4.17-3.78 7.5-7.95 7.95V23h-2v-2.05C6.83 20.5 3.5 17.17 3.05 13M12 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7a7 7 0 0 0 7-7a7 7 0 0 0-7-7Z"/>'
        },
        "crosshairs-off": {
            body: '<path fill="currentColor" d="M20.94 11C20.5 6.83 17.17 3.5 13 3.06V1h-2v2.06a8.38 8.38 0 0 0-3.16.97l1.5 1.5A6.995 6.995 0 0 1 19 12c0 .94-.19 1.84-.5 2.65l1.5 1.5c.5-.96.82-2.02.95-3.15H23v-2h-2.06M3 4.27l2.04 2.04A8.914 8.914 0 0 0 3.06 11H1v2h2.06c.44 4.17 3.77 7.5 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21L21 19.73L4.27 3L3 4.27m13.27 13.27a6.995 6.995 0 0 1-9.81-9.81l9.81 9.81Z"/>'
        },
        "crosshairs-question": {
            body: '<path fill="currentColor" d="M3.05 13H1v-2h2.05C3.5 6.83 6.83 3.5 11 3.05V1h2v2.05c4.17.45 7.5 3.78 7.95 7.95H23v2h-2.05c-.45 4.17-3.78 7.5-7.95 7.95V23h-2v-2.05C6.83 20.5 3.5 17.17 3.05 13M12 5c-3.87 0-7 3.13-7 7s3.13 7 7 7s7-3.13 7-7s-3.13-7-7-7m-.87 12.25h1.75V15.5h-1.75v1.75M12 6.75c-1.93 0-3.5 1.57-3.5 3.5h1.75c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75c0 1.75-2.62 1.53-2.62 4.38h1.75c0-1.97 2.62-2.19 2.62-4.38c0-1.93-1.57-3.5-3.5-3.5Z"/>'
        },
        crowd: {
            body: '<path fill="currentColor" d="M3.69 9.12a.88.88 0 0 0-.65-.28c-.41 0-.72.19-.92.58s-.15.76.17 1.11c1.18 1.06 1.93 1.81 2.25 2.25c.41.56.61 1.38.61 2.44c0 1.31.5 2.28 1.5 2.95c.56.44 1.17.77 1.85.99v-3.89c0-.94-.33-1.72-.96-2.35m8.92.05c-.62.62-.96 1.39-.96 2.3v3.93c.96-.34 1.76-.87 2.42-1.57c.65-.7.98-1.47.98-2.41c0-1.13.19-1.94.57-2.44c.09-.16.26-.36.53-.61c.23-.25.47-.49.71-.71c.23-.21.46-.43.68-.65l.33-.28a.9.9 0 0 0 .28-.66c0-.28-.09-.53-.28-.73c-.19-.2-.42-.3-.72-.3s-.5.09-.69.28M12 20c.69 0 1.36-.09 2-.28v-3.57c0-.59-.18-1.05-.59-1.49C13 14.22 12.53 14 12 14c-.53 0-1 .2-1.38.61c-.4.39-.62.85-.62 1.45v3.66c.64.19 1.31.28 2 .28M9 8.5c0 .83-.67 1.5-1.5 1.5S6 9.33 6 8.5S6.67 7 7.5 7S9 7.67 9 8.5m9 0c0 .83-.67 1.5-1.5 1.5S15 9.33 15 8.5S15.67 7 16.5 7s1.5.67 1.5 1.5m-4.5-3c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S11.17 4 12 4s1.5.67 1.5 1.5m0 5.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5Z"/>'
        },
        crown: {
            body: '<path fill="currentColor" d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5m14 3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-1h14v1Z"/>'
        },
        "crown-circle": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4 13.44c0 .34-.22.56-.56.56H8.56c-.34 0-.56-.22-.56-.56V15h8v.44M16 14H8L7 8l3 2l2-3l2 3l3-2l-1 6Z"/>'
        },
        "crown-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8m-4-6L7 8l3 2l2-3l2 3l3-2l-1 6H8m.56 2c-.34 0-.56-.22-.56-.56V15h8v.44c0 .34-.22.56-.56.56H8.56Z"/>'
        },
        "crown-outline": {
            body: '<path fill="currentColor" d="m12 8l3 5.2l3-2.7l-.7 3.5H6.7L6 10.5l3 2.7L12 8m0-4l-3.5 6L3 5l2 11h14l2-11l-5.5 5L12 4m7 14H5v1c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-1Z"/>'
        },
        cryengine: {
            body: '<path fill="currentColor" d="M23.03 12.5c-.03.5-2.12 2.73-5.21 3.74c-3.77 1.26-9.85.79-9.85-3.94c0-2.22 1.81-4.03 4.03-4.03c2.25 0 4.05 1.82 4.05 4.04c0 1.08-.47 2.13-1.18 2.87c.67-.01 3.07-.18 5.34-2.06c.25-.24.41-.44.48-.57c.02-.05.05-.09.04-.15c0-.48-2.61-4.21-8.01-5.28c6.5.34 10.28 4.2 10.31 5.28v.1M12 10c-1.26 0-2.29 1.04-2.29 2.3A2.29 2.29 0 0 0 12 14.59c1.27 0 2.29-1.02 2.29-2.29c0-1.26-1.02-2.3-2.29-2.3m-8.69 2.34v.08c.1.52 1.51 2.99 6.97 4.46c-6.32-.51-9.16-3.6-9.24-4.46h-.01v-.07c0-.85 3.93-4.77 9.89-5.2c-4.78 1.11-7.61 4.72-7.61 5.19Z"/>'
        },
        "crystal-ball": {
            body: '<path fill="currentColor" d="m9.38 8.38l2.12.96l2.12-.96l-.96 2.12l.96 2.12l-2.12-.96l-2.12.96l.96-2.12l-.96-2.12M16.5 2.5l1.09 2.91L20.5 6.5l-2.91 1.09l-1.09 2.91l-1.09-2.91L12.5 6.5l2.91-1.09L16.5 2.5M6 19h1v-1a1 1 0 0 1 1-1h.26a7.473 7.473 0 0 1-3.76-6.5A7.5 7.5 0 0 1 12 3c1.05 0 2.05.22 2.96.61l-.37.98l-1.42.53C12.79 5.04 12.4 5 12 5a5.5 5.5 0 0 0-5.5 5.5A5.5 5.5 0 0 0 12 16c2.91 0 5.3-2.27 5.5-5.13l.91-2.46l.71-.27c.25.74.38 1.54.38 2.36c0 2.78-1.5 5.2-3.76 6.5H16a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v1H4v-1a2 2 0 0 1 2-2Z"/>'
        },
        cube: {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L6.04 7.5L12 10.85l5.96-3.35L12 4.15Z"/>'
        },
        "cube-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-3.56-3.56l-4.71 2.65c-.16.12-.36.18-.57.18s-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l.77-.43L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M12 4.15l5.96 3.35l-4.65 2.61l7.22 7.22c.29-.17.47-.48.47-.83v-9c0-.38-.21-.71-.53-.88l-7.9-4.44C12.41 2.06 12.21 2 12 2s-.41.06-.57.18L7.56 4.36L9 5.82l3-1.67Z"/>'
        },
        "cube-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L4.3 6.19l-.77.43c-.32.17-.53.5-.53.88v9c0 .38.21.71.53.88l7.9 4.44c.16.12.36.18.57.18s.41-.06.57-.18l4.71-2.65l3.56 3.56l1.27-1.27M5 15.91v-6.7l5.29 2.97l.71.71v6.4l-6-3.38m8 3.38v-4.4l2.82 2.81L13 19.29M9 5.82L7.56 4.36l3.87-2.18c.16-.12.36-.18.57-.18s.41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9c0 .35-.18.66-.47.83L19 15.8V9.21l-4.22 2.37l-1.47-1.47l4.65-2.61L12 4.15L9 5.82Z"/>'
        },
        "cube-outline": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L6.04 7.5L12 10.85l5.96-3.35L12 4.15M5 15.91l6 3.38v-6.71L5 9.21v6.7m14 0v-6.7l-6 3.37v6.71l6-3.38Z"/>'
        },
        "cube-scan": {
            body: '<path fill="currentColor" d="M17 22v-2h3v-3h2v3.5c0 .39-.16.74-.46 1.04c-.3.3-.65.46-1.04.46H17M7 22H3.5c-.39 0-.74-.16-1.04-.46c-.3-.3-.46-.65-.46-1.04V17h2v3h3v2M17 2h3.5c.39 0 .74.16 1.04.46c.3.3.46.65.46 1.04V7h-2V4h-3V2M7 2v2H4v3H2V3.5c0-.39.16-.74.46-1.04c.3-.3.65-.46 1.04-.46H7m6 15.25l4-2.3v-4.59l-4 2.3v4.59m-1-6.33l4-2.29l-4-2.35l-4 2.35l4 2.29m-5 4.03l4 2.3v-4.59l-4-2.3v4.59m11.23-7.36c.5.32.77.75.77 1.32v6.32c0 .57-.27 1-.77 1.32l-5.48 3.18c-.5.32-1 .32-1.5 0l-5.48-3.18c-.5-.32-.77-.75-.77-1.32V8.91c0-.57.27-1 .77-1.32l5.48-3.18c.25-.13.5-.19.75-.19s.5.06.75.19l5.48 3.18Z"/>'
        },
        "cube-send": {
            body: '<path fill="currentColor" d="M16 4L9 8.04v7.92L16 20l7-4.04V8.04m-7-1.73l3.8 2.19l-3.8 2.19l-3.79-2.19M0 7v2h7V7m4 3.11l4 2.31v4.69l-4-2.3m10-4.7v4.7l-4 2.3v-4.69M2 11v2h5v-2m-3 4v2h3v-2"/>'
        },
        "cube-unfolded": {
            body: '<path fill="currentColor" d="M6 9V4h7v5h10v7h-5v5h-7v-5H1V9h5m10 7h-3v3h3v-3M8 9h3V6H8v3m-2 5v-3H3v3h3m12-3v3h3v-3h-3m-5 0v3h3v-3h-3m-5 0v3h3v-3H8Z"/>'
        },
        cup: {
            body: '<path fill="currentColor" d="M18.32 8H5.67l-.44-4h13.54M3 2l2 18.23c.13 1 .97 1.77 2 1.77h10c1 0 1.87-.77 2-1.77L21 2H3Z"/>'
        },
        "cup-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L21 21.72L19.73 23l-1.46-1.46c-.34.29-.77.46-1.27.46H7a2.02 2.02 0 0 1-2-1.77L3.53 6.8L1 4.27M18.32 8l.45-4H5.82l-2-2H21l-1.71 15.47L9.82 8h8.5Z"/>'
        },
        "cup-off-outline": {
            body: '<path fill="currentColor" d="m3.83 2l2 2h12.95L17.5 15.66l1.8 1.84L21 2M2.27 3L1 4.27L3.53 6.8L5 20.23c.13 1 .97 1.77 2 1.77h10c.47 0 .91-.18 1.26-.46L19.73 23L21 21.73M5.78 9.06L16.73 20H7Z"/>'
        },
        "cup-outline": {
            body: '<path fill="currentColor" d="m3 2l2 18.23c.13 1 .97 1.77 2 1.77h10c1 0 1.87-.77 2-1.77L21 2H3m2.22 2h13.56L17 20H7L5.22 4Z"/>'
        },
        "cup-water": {
            body: '<path fill="currentColor" d="M18.32 8H5.67l-.44-4h13.54M12 19a3 3 0 0 1-3-3c0-2 3-5.4 3-5.4s3 3.4 3 5.4a3 3 0 0 1-3 3M3 2l2 18.23c.13 1 .97 1.77 2 1.77h10c1 0 1.87-.77 2-1.77L21 2H3Z"/>'
        },
        cupboard: {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-7 16H8v-3h2v3m6 0h-2v-3h2v3m1-6H7V9h10v3m0-5H7V4h10v3Z"/>'
        },
        "cupboard-outline": {
            body: '<path fill="currentColor" d="M7 2c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2H7m0 2h10v3H7V4m0 5h10v3H7V9m0 5h4v5H7v-5m6 0h4v5h-4v-5m-5 1v3h2v-3H8m6 0v3h2v-3h-2Z"/>'
        },
        cupcake: {
            body: '<path fill="currentColor" d="M12 1.5A2.5 2.5 0 0 1 14.5 4A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 9.5 4A2.5 2.5 0 0 1 12 1.5M15.87 5C18 5 20 7 20 9c2.7 0 2.7 4 0 4H4c-2.7 0-2.7-4 0-4c0-2 2-4 4.13-4c.44 1.73 2.01 3 3.87 3c1.86 0 3.43-1.27 3.87-3M5 15h3l1 7H7l-2-7m5 0h4l-1 7h-2l-1-7m6 0h3l-2 7h-2l1-7Z"/>'
        },
        curling: {
            body: '<path fill="currentColor" d="M10 3v2c2.5 0 3.9.05 4.72.41c.54.24 1.01.8 1.53 1.59H5v2h14.62l-.73-1.45c-1.03-2.05-1.93-3.33-3.36-3.96C14.1 2.95 12.5 3 10 3m-4 8c-2.22 0-4 1.78-4 4v3c0 2.22 1.78 4 4 4h12c2.22 0 4-1.78 4-4v-3c0-2.22-1.78-4-4-4H6Z"/>'
        },
        "currency-bdt": {
            body: '<path fill="currentColor" d="M18.09 10.5V9h-8.5V4.5A1.5 1.5 0 0 0 8.09 3a1.5 1.5 0 0 0-1.5 1.5A1.5 1.5 0 0 0 8.09 6v3h-3v1.5h3v6.2c0 2.36 1.91 4.27 4.25 4.3c2.34-.04 4.2-1.96 4.16-4.3c0-1.59-.75-3.09-2-4.08a4.08 4.08 0 0 0-.7-.47c-.22-.1-.46-.15-.7-.15c-.71 0-1.36.39-1.71 1c-.19.3-.29.65-.29 1c.01 1.1.9 2 2.01 2c.62 0 1.2-.31 1.58-.8c.21.47.31.98.31 1.5c.04 1.5-1.14 2.75-2.66 2.8c-1.53 0-2.76-1.27-2.75-2.8v-6.2h8.5Z"/>'
        },
        "currency-brl": {
            body: '<path fill="currentColor" d="M12 15h2c0 1.08 1.37 2 3 2s3-.92 3-2c0-1.1-1.04-1.5-3.24-2.03C14.64 12.44 12 11.78 12 9c0-1.79 1.47-3.31 3.5-3.82V3h3v2.18C20.53 5.69 22 7.21 22 9h-2c0-1.08-1.37-2-3-2s-3 .92-3 2c0 1.1 1.04 1.5 3.24 2.03C19.36 11.56 22 12.22 22 15c0 1.79-1.47 3.31-3.5 3.82V21h-3v-2.18C13.47 18.31 12 16.79 12 15M2 3h3.5A5.5 5.5 0 0 1 11 8.5c0 2.19-1.29 4.09-3.14 4.97L11.64 21H9.4l-3.52-7H4v7H2V3m3.5 9A3.5 3.5 0 0 0 9 8.5A3.5 3.5 0 0 0 5.5 5H4v7h1.5Z"/>'
        },
        "currency-btc": {
            body: '<path fill="currentColor" d="M17.06 11.57A3.9 3.9 0 0 0 18 9c0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4c0-1.45-.78-2.73-1.94-3.43M10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7m5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "currency-chf": {
            body: '<path d="M7 3h11v2H9v6h8v2H9v3h2v2H9v3H7v-3H5v-2h2V3z" fill="currentColor"/>',
            hidden: true
        },
        "currency-cny": {
            body: '<path fill="currentColor" d="M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29L16.63 3H19l-5.72 9Z"/>'
        },
        "currency-eth": {
            body: '<path fill="currentColor" d="M6 5h12v2H6m1 4h10v2H7m-1.5 4h13v2h-13"/>'
        },
        "currency-eur": {
            body: '<path fill="currentColor" d="M15 18.5c-2.5 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24A6.491 6.491 0 0 1 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0 0 15 3c-3.92 0-7.24 2.5-8.5 6H3l-1 2h4.06c-.06.33-.06.66-.06 1s0 .67.06 1H3l-1 2h4.5c1.26 3.5 4.58 6 8.5 6c2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57Z"/>'
        },
        "currency-eur-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L6.7 8.59c-.06.14-.13.27-.2.41H3l-1 2h4.06c-.06.33-.06.66-.06 1s0 .67.06 1H3l-1 2h4.5c1.26 3.5 4.58 6 8.5 6c1.21 0 2.36-.26 3.41-.7l2.43 2.43l1.27-1.27M8.58 13c-.05-.33-.08-.66-.08-1s.03-.67.08-1h.53l2 2H8.58M15 18.5c-2.5 0-4.68-1.42-5.76-3.5h3.87l3.33 3.33c-.47.1-.94.17-1.44.17M12.2 9H16l-1 2h-.8l-2-2m-1.7-1.68L8.74 5.54A8.956 8.956 0 0 1 15 3c2.3 0 4.41.87 6 2.3l-1.77 1.77A6.471 6.471 0 0 0 15 5.5c-1.74 0-3.31.7-4.5 1.82Z"/>'
        },
        "currency-fra": {
            body: '<path fill="currentColor" d="M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5h9Z"/>'
        },
        "currency-gbp": {
            body: '<path fill="currentColor" d="M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4c0-.35-.03-.69-.1-1H14v-2H9.82C9 10.42 8 9.6 8 8a3.5 3.5 0 0 1 6.78-1.22L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.5 4H6v2h2.47c.08.31.13.64.13 1c0 2.7-2.6 4-2.6 4v2h8Z"/>'
        },
        "currency-ils": {
            body: '<path fill="currentColor" d="M22 16a5 5 0 0 1-5 5H8V9h2v10h7a3 3 0 0 0 3-3V3h2v13m-6-8v7h-2V8a3 3 0 0 0-3-3H4v16H2V3h9a5 5 0 0 1 5 5Z"/>'
        },
        "currency-inr": {
            body: '<path fill="currentColor" d="M8 3h10l-1 2h-3.26c.48.58.84 1.26 1.05 2H18l-1 2h-2a5.558 5.558 0 0 1-4.8 4.96V14h-.7l6 7H13l-6-7v-2h2.5c1.76 0 3.22-1.3 3.46-3H7l1-2h4.66C12.1 5.82 10.9 5 9.5 5H7l1-2Z"/>'
        },
        "currency-jpy": {
            body: '<path fill="currentColor" d="M13.92 11H18v2h-5v2h5v2h-5v4h-2v-4H6v-2h5v-2H6v-2h4.08L5 3h2.37L12 10.29L16.63 3H19l-5.08 8Z"/>'
        },
        "currency-krw": {
            body: '<path fill="currentColor" d="M2 3h2l1.33 6h4l1.34-6h2.66l1.34 6h4L20 3h2l-1.33 6H22v2h-1.78l-.44 2H22v2h-2.67L18 21h-2.67L14 15h-4l-1.33 6H6l-1.33-6H2v-2h2.22l-.44-2H2V9h1.33L2 3m11.11 8h-2.22l-.45 2h3.12l-.45-2m-5.78 7L8 15H6.67l.66 3m1.56-7H5.78l.44 2h2.22l.45-2m7.78 7l.66-3H16l.67 3m1.55-7h-3.11l.45 2h2.22l.44-2M12 6l-.67 3h1.34L12 6Z"/>'
        },
        "currency-kzt": {
            body: '<path fill="currentColor" d="M5 3h14v2H5V3m0 3h14v2h-6v13h-2V8H5V6Z"/>'
        },
        "currency-mnt": {
            body: '<path fill="currentColor" d="M13 5v3.62l4-1.45v2.12l-4 1.45v1.76l4-1.43v2.13l-4 1.45V21h-2v-5.62l-4 1.46v-2.13l4-1.47v-1.77l-4 1.45V10.8l4-1.45V5H5V3h14v2h-6Z"/>'
        },
        "currency-ngn": {
            body: '<path fill="currentColor" d="M4 9h2V3h2l3.42 6H16V3h2v6h2v2h-2v2h2v2h-2v6h-2l-3.43-6H8v6H6v-6H4v-2h2v-2H4V9m4 0h1.13L8 7.03V9m0 2v2h3.42l-1.14-2H8m8 6v-2h-1.15L16 17m-3.44-6l1.15 2H16v-2h-3.44Z"/>'
        },
        "currency-php": {
            body: '<path fill="currentColor" d="M5 2v4H3v2h2v2H3v2h2v10h2v-6h6c2.7 0 5.16-1.56 6.32-4H22v-2h-2.08c.11-.66.11-1.34 0-2H22V6h-2.68C18.16 3.56 15.7 2 13 2M7 4h6c1.57 0 3.06.74 4 2H7V4m6 10H7v-2h10c-.94 1.26-2.43 2-4 2m5-5c0 .34-.04.67-.1 1H7V8h10.9c.06.33.1.66.1 1Z"/>'
        },
        "currency-rial": {
            body: '<path fill="currentColor" d="M11 17h2v2h-2v-2m3 0h2v2h-2v-2M9 4h2v11a4 4 0 0 1-4 4H5a3 3 0 0 1-3-3v-4h2v4a1 1 0 0 0 1 1h2c1.11 0 2-.89 2-2V4m3 0h2v9h3V8h2v5c0 1.11-.89 2-2 2h-3c-1.11 0-2-.89-2-2V4m8 6h2v7a3 3 0 0 1-3 3h-2v-2h2a1 1 0 0 0 1-1v-7Z"/>'
        },
        "currency-rub": {
            body: '<path fill="currentColor" d="M13.5 3H7v9H5v2h2v2H5v2h2v3h2v-3h4v-2H9v-2h4.5c3.04 0 5.5-2.46 5.5-5.5S16.54 3 13.5 3m0 9H9V5h4.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12Z"/>'
        },
        "currency-rupee": {
            body: '<path fill="currentColor" d="M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2c-.27 2.8-2.63 5-5.5 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66Z"/>'
        },
        "currency-sign": {
            body: '<path fill="currentColor" d="M4.41 3L3 4.41L5.69 7.1A7.924 7.924 0 0 0 4 12c0 1.85.63 3.55 1.69 4.9L3 19.59L4.41 21l2.69-2.69A7.924 7.924 0 0 0 12 20c1.85 0 3.55-.63 4.9-1.69L19.59 21L21 19.59l-2.69-2.69A7.924 7.924 0 0 0 20 12c0-1.85-.63-3.55-1.69-4.9L21 4.41L19.59 3L16.9 5.69A7.924 7.924 0 0 0 12 4c-1.85 0-3.55.63-4.9 1.69L4.41 3M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6s-6-2.69-6-6s2.69-6 6-6Z"/>'
        },
        "currency-try": {
            body: '<path fill="currentColor" d="M9 8.76V3h2v4.5L15 5v2.36l-4 2.51v2.35l4-2.5v2.36l-4 2.51V19c2.76 0 5-2.24 5-5h2c0 3.87-3.13 7-7 7H9v-5.16l-3 1.88v-2.36l3-1.86v-2.38L6 13v-2.36l3-1.88Z"/>'
        },
        "currency-twd": {
            body: '<path fill="currentColor" d="M3 11h18v2h-6v6h6v2h-6a2 2 0 0 1-2-2v-6h-2.65l-4.62 8L4 20l4.04-7H3v-2m2-8h14v2H5V3Z"/>'
        },
        "currency-uah": {
            body: '<path fill="currentColor" d="M14.59 11H18V9h-1.68c.42-.66.68-1.32.68-2c0-2.63-2.5-4-5-4c-2.35 0-4.47 2.06-4.71 2.29l1.42 1.42C9.19 6.23 10.71 5 12 5c1.04 0 3 .42 3 2c0 .5-.5 1.24-1.24 2H6v2h5.63c-.42.36-1.88 1.67-2.22 2H6v2h1.68c-.42.66-.68 1.32-.68 2c0 2.63 2.5 4 5 4c2.35 0 4.47-2.06 4.71-2.29l-1.42-1.42c-.47.48-2 1.71-3.29 1.71c-1.04 0-3-.42-3-2c0-.5.5-1.24 1.24-2H18v-2h-5.62l2.21-2Z"/>'
        },
        "currency-usd": {
            body: '<path fill="currentColor" d="M7 15h2c0 1.08 1.37 2 3 2s3-.92 3-2c0-1.1-1.04-1.5-3.24-2.03C9.64 12.44 7 11.78 7 9c0-1.79 1.47-3.31 3.5-3.82V3h3v2.18C15.53 5.69 17 7.21 17 9h-2c0-1.08-1.37-2-3-2s-3 .92-3 2c0 1.1 1.04 1.5 3.24 2.03C14.36 11.56 17 12.22 17 15c0 1.79-1.47 3.31-3.5 3.82V21h-3v-2.18C8.47 18.31 7 16.79 7 15Z"/>'
        },
        "currency-usd-circle": {
            body: '<path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m3 8h-4v1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1V7h2v1h2z" fill="currentColor"/>',
            hidden: true
        },
        "currency-usd-circle-outline": {
            body: '<path d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m-1 13v-1H9v-2h4v-1h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1V7h2v1h2v2h-4v1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1h-2z" fill="currentColor"/>',
            hidden: true
        },
        "currency-usd-off": {
            body: '<path fill="currentColor" d="M3 4.27L4.28 3L21 19.72L19.73 21l-3.67-3.67c-.62.67-1.52 1.22-2.56 1.49V21h-3v-2.18C8.47 18.31 7 16.79 7 15h2c0 1.08 1.37 2 3 2c1.13 0 2.14-.44 2.65-1.08l-2.97-2.97C9.58 12.42 7 11.75 7 9c0-.23 0-.45.07-.66L3 4.27m7.5.91V3h3v2.18C15.53 5.69 17 7.21 17 9h-2c0-1.08-1.37-2-3-2c-.37 0-.72.05-1.05.13L9.4 5.58l1.1-.4Z"/>'
        },
        "current-ac": {
            body: '<path fill="currentColor" d="M12.43 11C12.28 10.84 10 7 7 7s-4.68 3.18-5 4v2h9.57c.15.16 2.43 4 5.43 4s4.68-3.18 5-4v-2h-9.57M7 9c1.17 0 2.18.85 3 2H4.31c.47-.83 1.23-2 2.69-2m10 6c-1.17 0-2.18-.85-3-2h5.69c-.47.83-1.23 2-2.69 2Z"/>'
        },
        "current-dc": {
            body: '<path fill="currentColor" d="M2 9v2h20V9H2m0 4v2h5v-2H2m7 0v2h6v-2H9m8 0v2h5v-2h-5Z"/>'
        },
        "cursor-default": {
            body: '<path fill="currentColor" d="M13.64 21.97a.99.99 0 0 1-1.33-.47l-2.18-4.74l-2.51 2.02c-.17.14-.38.22-.62.22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1c.24 0 .47.09.64.23l.01-.01l11.49 9.64a1.001 1.001 0 0 1-.44 1.75l-3.16.62l2.2 4.73c.26.5.02 1.09-.48 1.32l-3.62 1.69Z"/>'
        },
        "cursor-default-click": {
            body: '<path fill="currentColor" d="M10.76 8.69a.76.76 0 0 0-.76.76V20.9c0 .42.34.76.76.76c.19 0 .35-.06.48-.16l1.91-1.55l1.66 3.62c.13.27.4.43.69.43c.11 0 .22 0 .33-.08l2.76-1.28c.38-.18.56-.64.36-1.01L17.28 18l2.41-.45a.88.88 0 0 0 .43-.26c.27-.32.23-.79-.12-1.08l-8.74-7.35l-.01.01a.756.756 0 0 0-.49-.18M15 10V8h5v2h-5m-1.17-5.24l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41M10 0h2v5h-2V0M3.93 14.66l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41m0-11.32l1.41-1.41l2.83 2.83l-1.41 1.41l-2.83-2.83M7 10H2V8h5v2"/>'
        },
        "cursor-default-click-outline": {
            body: '<path fill="currentColor" d="m11.5 11l6.38 5.37l-.88.18l-.64.12c-.63.13-.99.83-.71 1.4l.27.58l1.36 2.94l-1.42.66l-1.36-2.93l-.26-.58a.985.985 0 0 0-1.52-.36l-.51.4l-.71.57V11m-.74-2.31a.76.76 0 0 0-.76.76V20.9c0 .42.34.76.76.76c.19 0 .35-.06.48-.16l1.91-1.55l1.66 3.62c.13.27.4.43.69.43c.11 0 .22 0 .33-.08l2.76-1.28c.38-.18.56-.64.36-1.01L17.28 18l2.41-.45a.88.88 0 0 0 .43-.26c.27-.32.23-.79-.12-1.08l-8.74-7.35l-.01.01a.756.756 0 0 0-.49-.18M15 10V8h5v2h-5m-1.17-5.24l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41M10 0h2v5h-2V0M3.93 14.66l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41m0-11.32l1.41-1.41l2.83 2.83l-1.41 1.41l-2.83-2.83M7 10H2V8h5v2"/>'
        },
        "cursor-default-gesture": {
            body: '<path fill="currentColor" d="M15.59 8c-.33 0-.59.27-.59.6v8.97a.593.593 0 0 0 .96.47l1.49-1.21l1.29 2.83c.1.22.31.34.53.34c.09 0 .17 0 .26-.06l2.14-1.01c.3-.14.44-.5.28-.79l-1.29-2.84l1.87-.36c.12-.03.24-.09.33-.2c.21-.24.18-.62-.09-.85L16 8.13a.739.739 0 0 0-.41-.13M12.5 6.73c.22-.07.67.46 1.09 1.03L15 6.71c-.13-.21-.31-.46-.53-.75c-.16-.21-.88-1.03-1.81-1.16c-.62-.08-1.85.26-2.06 1.81c-.13.97.16 1.58.61 2.47c.25.52.83 1.88.97 2.7c.15.81-.12 1.38-.44 1.34c-.3-.04-.54-.47-.71-.71c-.14-.19-1.03-1.59-1.36-2.18c-.45-.73-1.63-2.27-3.23-2.49c-2.09-.28-3 1.46-3.26 2.62L1 10.06v1.82l1.93.27C2.75 15.6 4.5 16.82 5.67 17c1.25.15 2.41-.72 2.57-1.94c.17-1.22-.68-3.56-3.28-4.37c.14-.54.25-1.26 1.4-1.1c.9.12 1.85 1.67 2.57 2.85c.65 1.09 1.17 1.95 1.9 2.28c.62.28 1.33.25 1.9-.07c.69-.39 1.13-1.1 1.27-2.02c.22-1.73-1.3-4.46-1.43-4.79c-.17-.38-.45-1.02-.07-1.11m-6 8.05c-.07.33-.4.47-.62.44c-.5-.06-1.22-.72-1.17-2.69c1.46.6 1.82 1.82 1.79 2.25Z"/>'
        },
        "cursor-default-gesture-outline": {
            body: '<path fill="currentColor" d="m16.5 10.54l3.87 3.29l-1.87.35l.79 1.74l.93 2.04l-.5.23l-.91-1.99l-.81-1.77l-1.5 1.23v-5.12M15.59 8c-.33 0-.59.27-.59.6v8.97a.593.593 0 0 0 .96.47l1.49-1.21l1.29 2.83c.1.22.31.34.53.34c.09 0 .17 0 .26-.06l2.14-1.01c.3-.14.44-.5.28-.79l-1.29-2.84l1.87-.36c.12-.03.24-.09.33-.2c.21-.24.18-.62-.09-.85L16 8.13a.739.739 0 0 0-.41-.13M12.5 6.73c.22-.07.67.46 1.09 1.03L15 6.71c-.13-.21-.31-.46-.53-.75c-.16-.21-.88-1.03-1.81-1.16c-.62-.08-1.85.26-2.06 1.81c-.13.97.16 1.58.61 2.47c.25.52.83 1.88.97 2.7c.15.81-.12 1.38-.44 1.34c-.3-.04-.54-.47-.71-.71c-.14-.19-1.03-1.59-1.36-2.18c-.45-.73-1.63-2.27-3.23-2.49c-2.09-.28-3 1.46-3.26 2.62L1 10.06v1.82l1.93.27C2.75 15.6 4.5 16.82 5.67 17c1.25.15 2.41-.72 2.57-1.94c.17-1.22-.68-3.56-3.28-4.37c.14-.54.25-1.26 1.4-1.1c.9.12 1.85 1.67 2.57 2.85c.65 1.09 1.17 1.95 1.9 2.28c.62.28 1.33.25 1.9-.07c.69-.39 1.13-1.1 1.27-2.02c.22-1.73-1.3-4.46-1.43-4.79c-.17-.38-.45-1.02-.07-1.11m-6 8.05c-.07.33-.4.47-.62.44c-.5-.06-1.22-.72-1.17-2.69c1.46.6 1.82 1.82 1.79 2.25Z"/>'
        },
        "cursor-default-outline": {
            body: '<path fill="currentColor" d="M10.07 14.27a.997.997 0 0 1 1.33.48l2.3 4.99l1.8-.85l-2.31-4.98c-.24-.5-.02-1.1.48-1.33l.28-.08l2.3-.45L8 5.12V15.9l1.82-1.47l.25-.16m3.57 7.7a.99.99 0 0 1-1.33-.47l-2.18-4.74l-2.51 2.02c-.17.14-.38.22-.62.22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1c.24 0 .47.09.64.23l.01-.01l11.49 9.64a1.001 1.001 0 0 1-.44 1.75l-3.16.62l2.2 4.73c.26.5.02 1.09-.48 1.32l-3.62 1.69Z"/>'
        },
        "cursor-move": {
            body: '<path fill="currentColor" d="M13 6v5h5V7.75L22.25 12L18 16.25V13h-5v5h3.25L12 22.25L7.75 18H11v-5H6v3.25L1.75 12L6 7.75V11h5V6H7.75L12 1.75L16.25 6H13Z"/>'
        },
        "cursor-pointer": {
            body: '<path fill="currentColor" d="m13.75 10.19l.63.13l4.17 2.08c.7.23 1.16.92 1.1 1.66v.26l-.9 6.12c-.06.43-.25.83-.6 1.11c-.31.3-.72.45-1.15.45h-6.88c-.49 0-.94-.18-1.27-.53L2.86 15.5l.9-1c.24-.25.62-.39.98-.37h.29L9 15V4.5a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5.69h.75Z"/>'
        },
        "cursor-text": {
            body: '<path fill="currentColor" d="M13 19a1 1 0 0 0 1 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1c0 .55-.95 1-1.5 1H8v-2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8V2h2.5c.55 0 1.5.45 1.5 1c0-.55.95-1 1.5-1H16v2h-2a1 1 0 0 0-1 1v14Z"/>'
        },
        curtains: {
            body: '<path fill="currentColor" d="M23 3H1V1h22v2M2 22h4c0-3-2-5-2-5c6-4 7-13 7-13H2v18M22 4h-9s1 9 7 13c0 0-2 2-2 5h4V4Z"/>'
        },
        "curtains-closed": {
            body: '<path fill="currentColor" d="M23 3H1V1h22v2M2 22h9V4H2v18M22 4h-9v18h9V4Z"/>'
        },
        cylinder: {
            body: '<path fill="currentColor" d="M12 2c-2.11 0-9 .29-9 4v12c0 3.71 6.89 4 9 4c2.11 0 9-.29 9-4V6c0-3.71-6.89-4-9-4m0 8c1.38 0 4.8-.13 7-1.25v6.5C16.8 14.13 13.38 14 12 14s-4.8.13-7 1.25v-6.5C7.2 9.87 10.62 10 12 10m0-6c3.87 0 7 .89 7 2c0 1.11-3.13 2-7 2s-7-.89-7-2c0-1.11 3.13-2 7-2m0 16c-3.87 0-7-.89-7-2c0-1.1 3.13-2 7-2s7 .9 7 2c0 1.11-3.13 2-7 2Z"/>'
        },
        "cylinder-off": {
            body: '<path fill="currentColor" d="M7.64 4.44L6.03 2.83C8.15 2.1 10.82 2 12 2c2.11 0 9 .29 9 4v11.8l-2.94-2.94c.33.11.64.24.94.39v-6.5c-1.72.88-4.18 1.14-5.83 1.22L11.18 8H12c3.87 0 7-.89 7-2s-3.13-2-7-2c-1.65 0-3.16.17-4.36.44m14.47 17.02l-1.27 1.27l-1.93-1.93C16.7 21.87 13.36 22 12 22c-2.11 0-9-.29-9-4V6c0-.34.08-.64.18-.93L1.11 3l1.28-1.27l19.72 19.73M5 15.25C7.2 14.13 10.62 14 12 14h.11L7.73 9.62C6.76 9.43 5.8 9.15 5 8.75v6.5m12.39 4.03l-3.18-3.18c-.71-.06-1.43-.1-2.21-.1c-3.87 0-7 .9-7 2s3.13 2 7 2c2.17 0 4.1-.28 5.39-.72Z"/>'
        },
        "dance-ballroom": {
            body: '<path fill="currentColor" d="M14 3.5c0 .83-.67 1.5-1.5 1.5S11 4.33 11 3.5S11.67 2 12.5 2s1.5.67 1.5 1.5M8.5 5C7.67 5 7 5.67 7 6.5S7.67 8 8.5 8S10 7.33 10 6.5S9.33 5 8.5 5m5.5 7l-.78-2.25h2.96l2.16-1.08c.37-.17.52-.63.33-1a.737.737 0 0 0-1-.34l-.82.41l-.49-.84c-.29-.65-1-1.02-1.7-.86l-2.47.53c-.69.15-1.19.78-1.19 1.5v.7l-2.43 1.62h.01c-.08.07-.19.16-.25.28l-.89 1.77l-1.78.89c-.37.17-.52.64-.33 1.01a.753.753 0 0 0 1.01.33l2.22-1.11L9.6 11.5L11 13c-1 3-8 7-8 7s4 2 9 2s9-2 9-2s-5-4-7-8m2.85-.91l-.32.16h-1.2l.06.16c.52 1.03 1.28 2.09 2.11 3.03l-.53-3.41l-.12.06Z"/>'
        },
        "dance-pole": {
            body: '<path fill="currentColor" d="M12 1v1l-.77-.64L7.76 5.5l3.24 2V5.16L10.78 5L12 3.56V23h2v-9.76l1.93-1.93c2.57.4 5.2-.95 6.73-2.48l-1.42-1.42C20.1 8.56 17.7 9.61 16 9.26l-2-2.02V1m3 3a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-6 3.76l-3.9 3.9c-1.85 1.84-2.79 3.19-4.04 6.5l1.88.7c1-2.66 1.72-3.72 2.93-5.02l1.35 1.35l-4.95 4.95l1.42 1.42L11 16.24Z"/>'
        },
        data: {
            body: '<path d="M13 2V5.03c3.392.487 6 3.395 6 6.92c0 .896-.175 1.75-.482 2.537l2.6 1.534A9.925 9.925 0 0 0 22 11.95c0-5.184-3.946-9.446-9-9.95m-2 0a9.993 9.993 0 0 0-9 9.95c0 5.523 4.469 10 9.995 10c3.31 0 6.237-1.613 8.057-4.09l-2.596-1.53A6.98 6.98 0 0 1 12 18.95a7 7 0 0 1-7-7c0-3.526 2.608-6.434 6-6.921V2" fill="currentColor"/>',
            hidden: true
        },
        "data-matrix": {
            body: '<path fill="currentColor" d="M2 2v20h20v-2h-2v-2h2v-2h-2v-2h2v-2h-4v-2h-2v2h-2v-2h-2V8H8v4h4v4h-2v2h2v2h-2v-2H8v-2H6v-2H4v-2h2V6H4V2H2m4 4h2V2H6v4m2 10h2v-2H8v2m10-6h4V8h-4v2m0-2V4h-2v2h-2v2h4m-2-4V2h-2v2h2m2 0h2V2h-2v2m2 0v2h2V4h-2M10 2v4h2V2h-2m4 12h2v2h2v4h-4v-6M4 18h2v2H4v-2Z"/>'
        },
        "data-matrix-edit": {
            body: '<path fill="currentColor" d="M20 12.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V22h2.1l6.1-6.1l-2.1-2M8 6H6V2h2v4m2 10H8v-2h2v2m2-10h-2V2h2v4m4-4v2h-2V2h2m4 2h-2V2h2v2M10 20v-2H8v-2H6v-2H4v-2h2V6H4V2H2v20h8v-2m-4 0H4v-2h2v2m16-10h-4V8h4v2m-2-4V4h2v2h-2m-2-2v4h-4V6h2V4h2m-8 14v-2h2v-4H8V8h4v2h2v2h2v-2h2v1.1L15.1 14H14v1.1L11.1 18H10Z"/>'
        },
        "data-matrix-minus": {
            body: '<path fill="currentColor" d="M16 2v2h-2V2h2m-4 0h-2v4h2V2m-2 12H8v2h2v-2m6-10v2h-2v2h4V4h-2M8 2H6v4h2V2m12 0h-2v2h2V2m-6.2 20H2V2h2v4h2v6H4v2h2v2h2v2h2v2h2v-2h-2v-2h2v-4H8V8h4v2h2v2h2v-2h2v2h4v1.8c-.9-.5-1.9-.8-3-.8c-1.2 0-2.4.4-3.3 1H14v1.7c-.6.9-1 2.1-1 3.3c0 1.1.3 2.1.8 3M6 18H4v2h2v-2M22 8h-4v2h4V8m0-2V4h-2v2h2m-7 12v2h8v-2h-8Z"/>'
        },
        "data-matrix-plus": {
            body: '<path fill="currentColor" d="M16 2v2h-2V2h2m-4 0h-2v4h2V2m-2 12H8v2h2v-2m6-10v2h-2v2h4V4h-2M8 2H6v4h2V2m12 0h-2v2h2V2m-6.2 20H2V2h2v4h2v6H4v2h2v2h2v2h2v2h2v-2h-2v-2h2v-4H8V8h4v2h2v2h2v-2h2v2h4v1.8c-.9-.5-1.9-.8-3-.8c-1.2 0-2.4.4-3.3 1H14v1.7c-.6.9-1 2.1-1 3.3c0 1.1.3 2.1.8 3M6 18H4v2h2v-2M22 8h-4v2h4V8m0-2V4h-2v2h2m-4 9v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "data-matrix-remove": {
            body: '<path fill="currentColor" d="M16 2v2h-2V2h2m-4 0h-2v4h2V2m-2 12H8v2h2v-2m6-10v2h-2v2h4V4h-2M8 2H6v4h2V2m12 0h-2v2h2V2m-6.2 20H2V2h2v4h2v6H4v2h2v2h2v2h2v2h2v-2h-2v-2h2v-4H8V8h4v2h2v2h2v-2h2v2h4v1.8c-.9-.5-1.9-.8-3-.8c-1.2 0-2.4.4-3.3 1H14v1.7c-.6.9-1 2.1-1 3.3c0 1.1.3 2.1.8 3M6 18H4v2h2v-2M22 8h-4v2h4V8m0-2V4h-2v2h2m-.9 9.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "data-matrix-scan": {
            body: '<path fill="currentColor" d="M2 2h4V0H2C.9 0 0 .9 0 2v4h2V2m20-2h-4v2h4v4h2V2c0-1.1-.9-2-2-2M2 18H0v4c0 1.1.9 2 2 2h4v-2H2v-4m20 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4M8 6V4h2v2H8m2 8v-2h2v2h-2m6-10h2v2h-2V4m2 2h2v2h-2V6m0 8h2v2h-2v-2m2-2h-4v6h4v2H4V4h2v2h2v4H6v2h2v2h2v2h2v2h2v-2h-2v-2h2v-4h-4V6h2V4h2v4h2v2h4v2M8 18v-2H6v2h2Z"/>'
        },
        database: {
            body: '<path fill="currentColor" d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4s8-1.79 8-4s-3.58-4-8-4M4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4Z"/>'
        },
        "database-alert": {
            body: '<path fill="currentColor" d="M18 7c0 2.21-3.58 4-8 4S2 9.21 2 7s3.58-4 8-4s8 1.79 8 4m-8 11c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4m0-5c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4m10 4h2v-2h-2v2m0-10v6h2V7h-2Z"/>'
        },
        "database-alert-outline": {
            body: '<path fill="currentColor" d="M10 3C5.58 3 2 4.79 2 7v10c0 2.21 3.59 4 8 4s8-1.79 8-4V7c0-2.21-3.58-4-8-4m6 14c0 .5-2.13 2-6 2s-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23s4.39-.45 6-1.23V17m0-4.55c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M10 9C6.13 9 4 7.5 4 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m12-2v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "database-arrow-down": {
            body: '<path fill="currentColor" d="M19 13c-2.17 0-4.07 1.16-5.12 2.89c-.6.07-1.23.11-1.88.11c-4.42 0-8-1.79-8-4V9c0 2.21 3.58 4 8 4s8-1.79 8-4v3c0 .36-.1.71-.28 1.05C19.5 13 19.24 13 19 13m-7-2c4.42 0 8-1.79 8-4s-3.58-4-8-4s-8 1.79-8 4s3.58 4 8 4m1.1 6.96c-.36.04-.73.04-1.1.04c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19c0-.36.04-.7.1-1.04M20 20v-4h-2v4h-2l3 3l3-3h-2Z"/>'
        },
        "database-arrow-down-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m10 11l-3 3l-3-3h2v-4h2v4h2Z"/>'
        },
        "database-arrow-left": {
            body: '<path fill="currentColor" d="M4 7c0-2.21 3.58-4 8-4s8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4m15.72 6.05c.18-.34.28-.69.28-1.05V9c0 2.21-3.58 4-8 4s-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.65 0 1.28-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.24 0 .5 0 .72.05m-6.62 4.91c-.36.04-.73.04-1.1.04c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19c0-.36.04-.7.1-1.04M18 18v-2l-3 3l3 3v-2h4v-2h-4Z"/>'
        },
        "database-arrow-left-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m10 9v2h-4v2l-3-3l3-3v2h4Z"/>'
        },
        "database-arrow-right": {
            body: '<path fill="currentColor" d="M4 7c0-2.21 3.58-4 8-4s8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4m15.72 6.05c.18-.34.28-.69.28-1.05V9c0 2.21-3.58 4-8 4s-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.65 0 1.28-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.24 0 .5 0 .72.05m-6.62 4.91c-.36.04-.73.04-1.1.04c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19c0-.36.04-.7.1-1.04M23 19l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "database-arrow-right-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m8 13v-2h-4v-2h4v-2l3 3l-3 3Z"/>'
        },
        "database-arrow-up": {
            body: '<path fill="currentColor" d="M19 13c-2.17 0-4.07 1.16-5.12 2.89c-.6.07-1.23.11-1.88.11c-4.42 0-8-1.79-8-4V9c0 2.21 3.58 4 8 4s8-1.79 8-4v3c0 .36-.1.71-.28 1.05C19.5 13 19.24 13 19 13m-7-2c4.42 0 8-1.79 8-4s-3.58-4-8-4s-8 1.79-8 4s3.58 4 8 4m1.1 6.96c-.36.04-.73.04-1.1.04c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19c0-.36.04-.7.1-1.04M19 15l-3 3h2v4h2v-4h2l-3-3Z"/>'
        },
        "database-arrow-up-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m10 9h-2v4h-2v-4h-2l3-3l3 3Z"/>'
        },
        "database-check": {
            body: '<path fill="currentColor" d="M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3.08L19 12c-2.59 0-4.8 1.64-5.64 3.94L12 16c-4.42 0-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8 4h1c0 1.05.27 2.04.75 2.9L12 21c-4.42 0-8-1.79-8-4v-3m14 7.08l-2.75-3l1.16-1.16L18 18.5l3.59-3.58l1.16 1.41L18 21.08"/>'
        },
        "database-check-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m10.5 8.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "database-clock": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7a7 7 0 0 1-5.75-3C6.18 19.79 3 18.08 3 16v-3c0 1.88 2.58 3.44 6.06 3.88C9.03 16.59 9 16.3 9 16c0-.38.04-.75.1-1.12c-3.5-.43-6.1-2-6.1-3.88V8c0 2.09 3.2 3.8 7.27 4c.6-.86 1.37-1.56 2.26-2.07c-.49.04-1.03.07-1.53.07c-4.42 0-8-1.79-8-4s3.58-4 8-4s8 1.79 8 4c0 1.2-1.07 2.28-2.75 3c.75.04 1.5.19 2.19.45C18.79 9 19 8.5 19 8v1.68c2.36 1.13 4 3.53 4 6.32m-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "database-clock-outline": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7a7 7 0 0 1-5.75-3C6.19 19.79 3 18.08 3 16V6c0-2.21 3.58-4 8-4s8 1.79 8 4v3.68c2.36 1.13 4 3.53 4 6.32m-6-6.92v-.44c-.23.13-.5.26-.76.36c.26 0 .51.04.76.08M5 6c0 .5 2.13 2 6 2s6-1.5 6-2s-2.13-2-6-2s-6 1.5-6 2m0 5.45c1.07.78 2.8 1.31 4.72 1.48c.61-1.26 1.6-2.31 2.82-3.01c-.5.05-1.01.08-1.54.08c-2.39 0-4.53-.53-6-1.36v2.81m4.26 6.42C9.1 17.27 9 16.65 9 16c0-.39.04-.77.1-1.14c-1.54-.17-2.95-.53-4.1-1.09V16c0 .42 1.5 1.5 4.26 1.87M21 16c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "database-cog": {
            body: '<path fill="currentColor" d="M4 7c0-2.21 3.58-4 8-4s8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4m8.08 11H12c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4h.29a7.38 7.38 0 0 1-.29-2c0-.34.03-.67.08-1M20 12.08V9c0 2.21-3.58 4-8 4s-8-1.79-8-4v3c0 2.21 3.58 4 8 4h.69c1.13-2.37 3.53-4 6.31-4c.34 0 .67.03 1 .08m3.8 8.32c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "database-cog-outline": {
            body: '<path fill="currentColor" d="M12 14c-2.42 0-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.44c.33-.05.66-.08 1-.08c.34 0 .67.03 1 .08V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4h.29a7.38 7.38 0 0 1-.29-2c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.24 0 .47 0 .7-.03c.4-.83.95-1.56 1.62-2.16c-.74.12-1.52.19-2.32.19m0-9c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m10.7 14.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "database-edit": {
            body: '<path fill="currentColor" d="M4 14v3c0 2 3.05 3.72 7 4v-2.89l.13-.11C7.12 17.76 4 16.06 4 14m8-1c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4h1.16L17 12.12c-1.6.6-3.29.88-5 .88m0-10C7.58 3 4 4.79 4 7s3.58 4 8 4s8-1.79 8-4s-3.58-4-8-4m9 8.13c-.15 0-.29.06-.39.17l-1 1l2.05 2l1-1a.54.54 0 0 0 0-.77l-1.24-1.23a.517.517 0 0 0-.38-.17m-2 1.75L13 18.94V21h2.06l6.06-6.07l-2.08-2.05Z"/>'
        },
        "database-edit-outline": {
            body: '<path fill="currentColor" d="M12 16c.8 0 1.57-.07 2.31-.18l2.91-2.91C15.89 13.59 14 14 12 14c-2.42 0-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.49l1.39-1.39c.18-.18.39-.32.61-.44V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.04 3.06 3.72 7 3.97v-1.84l.17-.17C7.84 18.76 6 17.46 6 17v-2.23c1.61.78 3.72 1.23 6 1.23m0-11c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m7.13 8.83l2.04 2.04L15.04 22H13v-2.04l6.13-6.13m3.72.36l-.98.98l-2.04-2.04l.98-.98c.19-.2.52-.2.72 0l1.32 1.32c.2.2.2.53 0 .72Z"/>'
        },
        "database-export": {
            body: '<path fill="currentColor" d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4c.5 0 1-.03 1.5-.08V9.5h2.89l-1-1L18.9 5c-1.4-1.2-3.96-2-6.9-2m6.92 4.08L17.5 8.5L20 11h-5v2h5l-2.5 2.5l1.42 1.42L23.84 12M4 9v3c0 2.21 3.58 4 8 4c1.17 0 2.26-.15 3.25-.37l1.13-1.13H13.5v-1.58c-.5.05-1 .08-1.5.08c-4.42 0-8-1.79-8-4m0 5v3c0 2.21 3.58 4 8 4c2.94 0 5.5-.8 6.9-2L17 17.1c-1.39.56-3.1.9-5 .9c-4.42 0-8-1.79-8-4Z"/>'
        },
        "database-export-outline": {
            body: '<path fill="currentColor" d="m17.86 18l1.04 1c-1.4 1.2-3.96 2-6.9 2c-4.41 0-8-1.79-8-4V7c0-2.21 3.58-4 8-4c2.95 0 5.5.8 6.9 2l-1.04 1l-.36.4C16.65 5.77 14.78 5 12 5C8.13 5 6 6.5 6 7s2.13 2 6 2c1.37 0 2.5-.19 3.42-.46l.96.96H13.5v1.42c-.5.05-1 .08-1.5.08c-2.39 0-4.53-.53-6-1.36v2.81C7.3 13.4 9.58 14 12 14c.5 0 1-.03 1.5-.08v.58h2.88l-1 1l.12.11c-1.09.25-2.26.39-3.5.39c-2.28 0-4.39-.45-6-1.23V17c0 .5 2.13 2 6 2c2.78 0 4.65-.77 5.5-1.39l.36.39m1.06-10.92L17.5 8.5L20 11h-5v2h5l-2.5 2.5l1.42 1.42L23.84 12l-4.92-4.92Z"/>'
        },
        "database-eye": {
            body: '<path fill="currentColor" d="M4 12V9c0 2.2 3.6 4 8 4s8-1.8 8-4v3c0 .5-.2.9-.5 1.4c-.8-.3-1.6-.4-2.5-.4c-2.5 0-4.9 1.1-6.4 2.9C6.8 15.6 4 14 4 12m8-1c4.4 0 8-1.8 8-4s-3.6-4-8-4s-8 1.8-8 4s3.6 4 8 4m-2.9 8.7l-.3-.7l.3-.7c.1-.2.2-.3.2-.5c-3.1-.6-5.3-2-5.3-3.8v3c0 1.8 2.4 3.3 5.7 3.8c-.2-.3-.4-.7-.6-1.1M17 18c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m6 1c-.9 2.3-3.3 4-6 4s-5.1-1.7-6-4c.9-2.3 3.3-4 6-4s5.1 1.7 6 4m-3.5 0c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5Z"/>'
        },
        "database-eye-off": {
            body: '<path fill="currentColor" d="m14.1 10.9l-7-7c1.3-.6 3-.9 4.9-.9c4.4 0 8 1.8 8 4c0 1.9-2.5 3.4-5.9 3.9m2.1 2.1h.8c.9 0 1.7.1 2.5.4c.3-.4.5-.9.5-1.4V9c0 1.5-1.7 2.9-4.3 3.5l.5.5m2.2 2.2l4.4 4.4c.1-.2.2-.4.3-.5c-.9-2-2.6-3.5-4.7-3.9m3.7 6.3l-1.3 1.3l-.6-.6c-1 .5-2.1.9-3.2.9c-2.7 0-5.1-1.7-6-4c.6-1.4 1.6-2.5 2.9-3.2l-1.5-1.5c-.7.4-1.3 1-1.9 1.6c-3.7-.4-6.5-2-6.5-4V9c0 2.1 3.1 3.7 7.1 4l-2.3-2.3C6 10 4 8.6 4 7c0-.3.1-.6.2-.9L1.1 3l1.3-1.3l19.7 19.8m-3.3-.8l-1.1-1.1c-.1.3-.4.4-.7.4c-.6 0-1-.4-1-1c0-.3.1-.6.4-.8l-1.1-1.1c-.5.5-.8 1.1-.8 1.8c0 1.4 1.1 2.5 2.5 2.5c.7.1 1.4-.2 1.8-.7M8.8 19l.3-.7c.1-.2.2-.3.2-.5c-3.1-.6-5.3-2-5.3-3.8v3c0 1.8 2.4 3.3 5.7 3.8c-.2-.3-.4-.7-.5-1.1l-.4-.7Z"/>'
        },
        "database-eye-off-outline": {
            body: '<path fill="currentColor" d="M23 19c-.1.2-.2.4-.3.5l-4.4-4.4c2.2.5 3.9 2 4.7 3.9M12 5c3.9 0 6 1.5 6 2s-2.1 1.9-5.8 2l1.9 1.9c1.5-.2 2.9-.6 3.9-1.2v2.8c-.3.2-.6.4-1 .6c1 0 2 .2 3 .6V7c0-2.2-3.6-4-8-4c-1.9 0-3.6.3-4.9.9l1.6 1.6c.8-.3 2-.5 3.3-.5m10.1 16.5l-1.3 1.3l-.6-.6c-1 .5-2.1.9-3.2.9c-2.7 0-5.1-1.7-6-4c.6-1.4 1.6-2.5 2.9-3.2l-1.5-1.5c-.7.4-1.3 1-1.9 1.6c-1.7-.1-3.3-.5-4.6-1.2V17c0 .3 1.1 1.2 3 1.6l-.1.4l.3.7c.2.4.3.7.5 1.1c-3.2-.5-5.6-2-5.6-3.8V7c0-.3.1-.6.2-.9L1.1 3l1.3-1.3l19.7 19.8m-10-7.5l-3.4-3.4c-1.1-.2-2-.6-2.8-1v2.8c1.3 1 3.6 1.5 6 1.5c.1.1.2.1.2.1m6.7 6.7l-1.1-1.1c-.1.3-.4.4-.7.4c-.6 0-1-.4-1-1c0-.3.1-.6.4-.8l-1.1-1.1c-.5.5-.8 1.1-.8 1.8c0 1.4 1.1 2.5 2.5 2.5c.7.1 1.4-.2 1.8-.7Z"/>'
        },
        "database-eye-outline": {
            body: '<path fill="currentColor" d="m9.1 19.7l-.3-.7l.2-.4c-1.9-.5-3-1.3-3-1.6v-2.2c1.3.6 2.8 1 4.6 1.2c.7-.8 1.6-1.5 2.5-2H12c-2.4 0-4.7-.6-6-1.5V9.6c1.5.8 3.6 1.4 6 1.4s4.5-.5 6-1.4v2.8c-.3.2-.6.4-1 .6c1 0 2 .2 3 .6V7c0-2.2-3.6-4-8-4S4 4.8 4 7v10c0 1.8 2.4 3.3 5.7 3.8c-.2-.3-.4-.7-.6-1.1M12 5c3.9 0 6 1.5 6 2s-2.1 2-6 2s-6-1.5-6-2s2.1-2 6-2m5 13c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m0-3c-2.7 0-5.1 1.7-6 4c.9 2.3 3.3 4 6 4s5.1-1.7 6-4c-.9-2.3-3.3-4-6-4m0 6.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5Z"/>'
        },
        "database-import": {
            body: '<path fill="currentColor" d="M12 3C8.59 3 5.69 4.07 4.54 5.57l5.25 5.25c.71.11 1.43.18 2.21.18c4.42 0 8-1.79 8-4s-3.58-4-8-4M3.92 7.08L2.5 8.5L5 11H0v2h5l-2.5 2.5l1.42 1.42L8.84 12M20 9c0 2.21-3.58 4-8 4c-.66 0-1.3-.05-1.91-.13l-2.47 2.47c1.26.41 2.76.66 4.38.66c4.42 0 8-1.79 8-4m0 2c0 2.21-3.58 4-8 4c-2.28 0-4.33-.5-5.79-1.25l-1.68 1.68C5.68 19.93 8.59 21 12 21c4.42 0 8-1.79 8-4"/>'
        },
        "database-import-outline": {
            body: '<path fill="currentColor" d="m8.84 12l-4.92 4.92L2.5 15.5L5 13H0v-2h5L2.5 8.5l1.42-1.42L8.84 12M12 3C8.59 3 5.68 4.07 4.53 5.57L5 6l1.03 1.07C6 7.05 6 7 6 7c0-.5 2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2c-2.62 0-4.42-.69-5.32-1.28l3.12 3.12c.7.1 1.44.16 2.2.16c2.39 0 4.53-.53 6-1.36v2.81c-1.3.95-3.58 1.55-6 1.55c-.96 0-1.9-.1-2.76-.27l-1.65 1.64c1.32.4 2.82.63 4.41.63c2.28 0 4.39-.45 6-1.23V17c0 .5-2.13 2-6 2s-6-1.5-6-2v-.04L5 18l-.46.43C5.69 19.93 8.6 21 12 21c4.41 0 8-1.79 8-4V7c0-2.21-3.58-4-8-4Z"/>'
        },
        "database-lock": {
            body: '<path fill="currentColor" d="M11 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4m8 9.03a4.502 4.502 0 0 0-3.87 3.4c-1.21.36-2.63.57-4.13.57c-4.42 0-8-1.79-8-4V9c0 2.21 3.58 4 8 4s8-1.79 8-4v3.03m-5 5.68v3c-.93.19-1.94.29-3 .29c-4.42 0-8-1.79-8-4v-3c0 2.21 3.58 4 8 4c1.06 0 2.07-.1 3-.29M19.5 14a2.5 2.5 0 0 1 2.5 2.5v.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1v-.5a2.5 2.5 0 0 1 2.5-2.5m0 1a1.5 1.5 0 0 0-1.5 1.5v.5h3v-.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "database-lock-outline": {
            body: '<path fill="currentColor" d="M6 12.45V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v1.41c.17-.02.33-.05.5-.05c.53 0 1.03.1 1.5.26V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.34 0 .67 0 1-.03v-2.02c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.41 0 .81-.03 1.21-.06c.19-.48.47-.91.86-1.24c.06-.31.16-.61.27-.9c-.74.13-1.53.2-2.34.2c-2.42 0-4.7-.6-6-1.55M12 5c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m9 11v-.5a2.5 2.5 0 0 0-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5Z"/>'
        },
        "database-marker": {
            body: '<path fill="currentColor" d="M18.5 12c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2M4 12V9c0 2.21 3.58 4 8 4c.57 0 1.13-.03 1.67-.09c-.42.78-.67 1.66-.67 2.59c0 .15 0 .31.03.46c-.34.04-.68.04-1.03.04c-4.42 0-8-1.79-8-4m0-5c0-2.21 3.58-4 8-4s8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4m11 13.71c-.93.19-1.94.29-3 .29c-4.42 0-8-1.79-8-4v-3c0 2.21 3.58 4 8 4c.5 0 1.03-.03 1.5-.07c.4.98.94 1.94 1.5 2.78Z"/>'
        },
        "database-marker-outline": {
            body: '<path fill="currentColor" d="M12 19c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.35 0 .69-.03 1.03-.05c-.03-.15-.03-.3-.03-.45c0-.54.09-1.06.24-1.56c-.41.06-.82.06-1.24.06c-2.42 0-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v.39c.17-.03.33-.03.5-.03c.5 0 1 .08 1.5.22V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c1.06 0 2.07-.11 3-.29c-.38-.57-.75-1.21-1.07-1.86c-.59.09-1.22.15-1.93.15m0-14c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m6.5 7c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2Z"/>'
        },
        "database-minus": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3.08L19 12c-2.59 0-4.8 1.64-5.64 3.94L12 16c-4.42 0-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8 4h1c0 1.05.27 2.04.75 2.9L12 21c-4.42 0-8-1.79-8-4v-3Z"/>'
        },
        "database-minus-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m11 9v2h-8v-2h8Z"/>'
        },
        "database-off": {
            body: '<path fill="currentColor" d="M19.07 15.87c.59-.56.93-1.19.93-1.87v2.8l-.93-.93M20 9c0 1.54-1.73 2.86-4.27 3.53l2.16 2.16C19.19 14 20 13.04 20 12V9m0-2c0-2.21-3.58-4-8-4c-1.87 0-3.58.33-4.94.86l7 7C17.5 10.41 20 8.85 20 7M2.39 1.73L1.11 3l3.1 3.1c-.13.29-.21.59-.21.9c0 1.63 1.96 3.04 4.77 3.66l2.31 2.31C7.1 12.74 4 11.06 4 9v3c0 2.21 3.58 4 8 4c.69 0 1.35-.05 2-.13l1.66 1.68c-1.09.29-2.34.45-3.66.45c-4.42 0-8-1.79-8-4v3c0 2.21 3.58 4 8 4c2.31 0 4.38-.5 5.84-1.27l3 3l1.27-1.27L2.39 1.73Z"/>'
        },
        "database-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l3.1 3.1c-.13.29-.21.59-.21.9v10c0 2.21 3.59 4 8 4c2.3 0 4.38-.5 5.84-1.27l3 3l1.27-1.27L2.39 1.73M6 9.64c.76.43 1.7.78 2.76 1.01L12.11 14H12c-2.42 0-4.7-.6-6-1.55V9.64M12 19c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.68 0 1.34-.05 2-.13l2.34 2.36c-1.01.42-2.47.77-4.34.77M8.64 5.44L7.06 3.86C8.42 3.33 10.13 3 12 3c4.42 0 8 1.79 8 4v9.8l-2-2v-.03v.01l-1.55-1.53c.6-.22 1.13-.49 1.55-.8V9.64c-1.03.58-2.39 1.01-3.94 1.22L12.19 9C15.94 8.94 18 7.5 18 7s-2.13-2-6-2c-1.34 0-2.46.18-3.36.44Z"/>'
        },
        "database-outline": {
            body: '<path fill="currentColor" d="M12 3C7.58 3 4 4.79 4 7v10c0 2.21 3.59 4 8 4s8-1.79 8-4V7c0-2.21-3.58-4-8-4m6 14c0 .5-2.13 2-6 2s-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23s4.39-.45 6-1.23V17m0-4.55c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2Z"/>'
        },
        "database-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3.08L19 12c-2.59 0-4.8 1.64-5.64 3.94L12 16c-4.42 0-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8 4h1c0 1.05.27 2.04.75 2.9L12 21c-4.42 0-8-1.79-8-4v-3Z"/>'
        },
        "database-plus-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m11 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "database-refresh": {
            body: '<path fill="currentColor" d="M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4c1.11 0 2.18-.11 3.14-.32c-.95.86-1.64 1.99-1.96 3.28L12 16c-4.42 0-8-1.79-8-4V9m16 0v2h-.5l-.6.03c.7-.6 1.1-1.29 1.1-2.03M4 14c0 2.21 3.58 4 8 4l1-.03c.09 1.06.42 2.03.95 2.91L12 21c-4.42 0-8-1.79-8-4v-3m15-.5c1.11 0 2.11.45 2.83 1.17L23 13.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 21 19h1.71A3.991 3.991 0 0 1 19 21.5c-2.21 0-4-1.79-4-4s1.79-4 4-4Z"/>'
        },
        "database-refresh-outline": {
            body: '<path fill="currentColor" d="M6 12.45V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.39c.17-.03.33-.03.5-.03c.5 0 1 .07 1.5.18V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4h.5c-.26-.63-.41-1.3-.47-2H12c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23h.5c.35-.82.84-1.54 1.45-2.14c-.63.09-1.28.14-1.95.14c-2.42 0-4.7-.6-6-1.55M12 5c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m6 13.5l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4Z"/>'
        },
        "database-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3.08L19 12c-2.59 0-4.8 1.64-5.64 3.94L12 16c-4.42 0-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8 4h1c0 1.05.27 2.04.75 2.9L12 21c-4.42 0-8-1.79-8-4v-3Z"/>'
        },
        "database-remove-outline": {
            body: '<path fill="currentColor" d="M20 13.09V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.46 0 .9 0 1.33-.06A5.94 5.94 0 0 1 13 19v-.05c-.32.05-.65.05-1 .05c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23c.65 0 1.27-.04 1.88-.11A5.986 5.986 0 0 1 19 13c.34 0 .67.04 1 .09m-2-.64c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2m8.41 10l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19"/>'
        },
        "database-search": {
            body: '<path fill="currentColor" d="M18.68 12.32a4.49 4.49 0 0 0-6.36.01a4.49 4.49 0 0 0 0 6.36a4.508 4.508 0 0 0 5.57.63L21 22.39L22.39 21l-3.09-3.11c1.13-1.77.87-4.09-.62-5.57m-1.41 4.95c-.98.98-2.56.97-3.54 0c-.97-.98-.97-2.56.01-3.54c.97-.97 2.55-.97 3.53 0c.97.98.97 2.56 0 3.54M10.9 20.1a6.527 6.527 0 0 1-1.48-2.32C6.27 17.25 4 15.76 4 14v3c0 2.21 3.58 4 8 4c-.4-.26-.77-.56-1.1-.9M4 9v3c0 1.68 2.07 3.12 5 3.7v-.2c0-.93.2-1.85.58-2.69C6.34 12.3 4 10.79 4 9m8-6C7.58 3 4 4.79 4 7c0 2 3 3.68 6.85 4h.05c1.2-1.26 2.86-2 4.6-2c.91 0 1.81.19 2.64.56A3.215 3.215 0 0 0 20 7c0-2.21-3.58-4-8-4Z"/>'
        },
        "database-search-outline": {
            body: '<path fill="currentColor" d="M11 18.95c-3.23-.23-5-1.5-5-1.95v-2.23c1.13.55 2.5.92 4 1.1c0-.66.04-1.33.21-1.98c-1.71-.22-3.24-.73-4.21-1.44V9.64c1.43.81 3.5 1.33 5.82 1.36c.03-.03.05-.07.08-.1c2.2-2.19 5.6-2.49 8.1-.87V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.34 0 .68 0 1-.03c-.38-.25-.76-.53-1.1-.87c-.35-.36-.65-.74-.9-1.15M12 5c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m8.31 12.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S12 13 12 15.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L22 22.39L23.39 21l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "database-settings": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4s8-1.79 8-4v3c0 2.21-3.58 4-8 4s-8-1.79-8-4V9m0 5c0 2.21 3.58 4 8 4s8-1.79 8-4v3c0 1.19-1.05 2.27-2.71 3H6.71C5.05 19.27 4 18.19 4 17v-3Z"/>'
        },
        "database-settings-outline": {
            body: '<path fill="currentColor" d="M12 3C7.58 3 4 4.79 4 7v10c0 1.2 1.06 2.27 2.73 3h10.54c1.67-.73 2.73-1.8 2.73-3V7c0-2.21-3.58-4-8-4m6 14c0 .5-2.13 2-6 2s-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23s4.39-.45 6-1.23V17m0-4.55c-1.3.95-3.58 1.55-6 1.55s-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v2.81M12 9C8.13 9 6 7.5 6 7s2.13-2 6-2s6 1.5 6 2s-2.13 2-6 2M7 22h2v2H7v-2m8 0h2v2h-2v-2m-4 0h2v2h-2v-2Z"/>'
        },
        "database-sync": {
            body: '<path fill="currentColor" d="M19 12v1.5a4 4 0 0 1 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12m0 11v-1.5a4 4 0 0 1-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23M12 3c4.42 0 8 1.79 8 4s-3.58 4-8 4s-8-1.79-8-4s3.58-4 8-4M4 9c0 2.21 3.58 4 8 4c1.11 0 2.17-.11 3.14-.32c-.95.86-1.64 1.99-1.96 3.28L12 16c-4.42 0-8-1.79-8-4V9m16 0v2h-.5l-.6.03c.7-.6 1.1-1.29 1.1-2.03M4 14c0 2.21 3.58 4 8 4l1-.03c.09 1.06.42 2.03.95 2.91L12 21c-4.42 0-8-1.79-8-4v-3Z"/>'
        },
        "database-sync-outline": {
            body: '<path fill="currentColor" d="M12 16c.41 0 .81-.03 1.21-.06c.19-.76.51-1.48.95-2.11c-.69.11-1.42.17-2.16.17c-2.42 0-4.7-.6-6-1.55V9.64c1.47.83 3.61 1.36 6 1.36s4.53-.53 6-1.36v1.55c.5-.12 1-.19 1.55-.19c.15 0 .3 0 .45.03V7c0-2.21-3.58-4-8-4S4 4.79 4 7v10c0 2.21 3.59 4 8 4c.66 0 1.31-.04 1.92-.12c-.35-.59-.61-1.24-.76-1.94c-.37.06-.75.06-1.16.06c-3.87 0-6-1.5-6-2v-2.23c1.61.78 3.72 1.23 6 1.23m0-11c3.87 0 6 1.5 6 2s-2.13 2-6 2s-6-1.5-6-2s2.13-2 6-2m11 12.5c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12v1.5c2.21 0 4 1.79 4 4m-4 1l2.25 2.25L19 23v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5Z"/>'
        },
        "death-star": {
            body: '<path fill="currentColor" d="M2.05 13h19.9c-.5 5.05-4.76 9-9.95 9c-5.18 0-9.45-3.95-9.95-9m19.9-2H2.05c.5-5.05 4.77-9 9.95-9s9.45 3.95 9.95 9M12 6.75a2.5 2.5 0 0 0-2.5-2.5A2.5 2.5 0 0 0 7 6.75a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5Z"/>'
        },
        "death-star-variant": {
            body: '<path fill="currentColor" d="M2.05 13h19.89c-.06.69-.2 1.36-.4 2H14v2h3v2h-2v2h-2.5v1H12c-5.18 0-9.45-3.95-9.95-9m19.89-2H2.05c.5-5.05 4.77-9 9.95-9c1.62 0 3.15.39 4.5 1.08V5h2v2H20v2h1.54c.2.64.34 1.31.4 2M12 6.75a2.5 2.5 0 0 0-2.5-2.5A2.5 2.5 0 0 0 7 6.75a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5Z"/>'
        },
        "deathly-hallows": {
            body: '<path fill="currentColor" d="M12 2L1 21h22L12 2m.75 9.47c1.81.4 2.95 2.2 2.55 4.03c-.3 1.25-1.3 2.25-2.55 2.53v-6.56M11.25 18c-1.81-.4-2.95-2.2-2.55-4c.3-1.28 1.3-2.28 2.55-2.56V18m5.63-3.28A4.874 4.874 0 0 0 12.75 10V6.29L20.4 19.5h-7.33c2.22-.5 3.8-2.47 3.81-4.75v-.03m-5.63-8.43V10c-2.65.4-4.48 2.88-4.07 5.54c.32 1.96 1.79 3.58 3.75 4.01H3.6l7.65-13.26Z"/>'
        },
        debian: {
            body: '<path fill="currentColor" d="m18.5 10.57l-.2.37c.26-.78.11-1.63.15-2.37l-.07-.02c-.07-1.85-1.67-3.82-3.09-4.48c-1.23-.57-3.12-.67-3.99-.24c.12-.11.6-.15.45-.23c-1.37.13-1.06.47-2.11.74c-.29.28.86-.22.23.16c-.56.13-.82-.12-1.65.74c.07.12.53-.35.15.12c-.79-.09-2.48 1.8-2.84 2.42l.19.04c-.31.77-.72 1.26-.77 1.72c-.08 1.14-.45 3.21.08 3.85l-.06.53l.23.45l-.12.01c.58 1.83.62.04 1.39 1.94c-.11-.04-.23-.08-.39-.32c-.02.19.24.69.54 1.08l-.12.14c.16.31.32.38.43.49c-.63-.35.57 1.13.7 1.32l.1-.17c-.02.24.17.56.53 1.01l.3-.01c.13.24.58.68.85.7l-.18.24c.69.2.33.29 1.18.59l-.17-.3c.43.37.56.7 1.17.98c.85.3.96.18 1.82.43c-.73 0-1.59 0-2.17-.22c-3.96-1.07-7.56-5.72-7.32-10.5c-.06-.97.1-2.18-.06-2.42c.22-.74.48-1.64 1.01-2.71c-.04-.07.09.21.36-.24c.16-.36.29-.75.5-1.1l.1-.03c.11-.61 1.43-1.55 1.85-2.02v.18c.86-.81 2.4-1.35 3.26-1.73c-.23.25.51-.03 1.04-.06l-.49.28c.63-.16.6.07 1.25-.03c-.23.03-.5.1-.46.16c.72.08.84-.22 1.51 0l-.05-.2c.94.34 1.13.28 2.14.82c.36.01.4-.22.93 0c.1.16-.02.19.64.59c.07-.03-.13-.22-.27-.37c1.3.71 2.75 2.22 3.18 3.84c-.41-.74-.04.39-.18.33c.18.49.33 1 .43 1.53c-.12-.43-.39-1.48-.86-2.15c-.03.43-.6-.3-.29.66c.22.34.05-.35.34.25c0 .29.11.58.18.95c-.1-.02-.22-.41-.3-.31c.1.5.27.72.33.76c-.03.08-.12-.08-.12.24c.04.74.21.43.29.46c-.09.37-.41.79-.25 1.42l-.2-.56c-.05.53.11.63-.13 1.28c.18-.6.16-1.1-.01-.85c.09.82-.65 1.45-.58 1.98l-.21-.29c-.57.83-.01.45-.4 1.06c.14-.23-.07-.08.11-.36c-.12.01-.55.53-.94.83c-1.54 1.23-3.39 1.4-5.15.73h-.01c.01-.04 0-.09-.12-.17c-1.51-1.15-2.4-2.13-2.11-4.41c.25-.17.31-1.12.84-1.45c.32-.71 1.28-1.36 2.31-1.38c1.05-.06 1.94.56 2.39 1.14c-.82-.75-2.14-.98-3.28-.43c-1.15.53-1.84 1.8-1.76 3.07c.06-.07.1-.02.12-.18c-.03 2.47 2.66 4.28 4.6 3.37l.03.05c.78-.22.68-.39 1.19-.75c-.04.09-.34.3-.16.3c.25-.06 1.03-.79 1.42-1.13c.17-.38-.1-.23.15-.69l.3-.15c.17-.48.35-.75.35-1.32"/>'
        },
        "debug-step-into": {
            body: '<path fill="currentColor" d="M12 22a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m1-20v11l4.5-4.5l1.42 1.42L12 16.84L5.08 9.92L6.5 8.5L11 13V2h2Z"/>'
        },
        "debug-step-out": {
            body: '<path fill="currentColor" d="M12 22a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m1-6h-2V6l-4.5 4.5l-1.42-1.42L12 2.16l6.92 6.92l-1.42 1.42L13 6v10Z"/>'
        },
        "debug-step-over": {
            body: '<path fill="currentColor" d="M12 14a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m11.46-5.14l-1.59 6.89L15 14.16l3.8-2.38A7.972 7.972 0 0 0 12 8c-3.95 0-7.23 2.86-7.88 6.63l-1.97-.35C2.96 9.58 7.06 6 12 6c3.58 0 6.73 1.89 8.5 4.72l2.96-1.86Z"/>'
        },
        decagram: {
            body: '<path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68L23 12Z"/>'
        },
        "decagram-outline": {
            body: '<path fill="currentColor" d="m23 12l-2.44 2.78l.34 3.68l-3.61.82l-1.89 3.18L12 21l-3.4 1.47l-1.89-3.18l-3.61-.82l.34-3.69L1 12l2.44-2.79l-.34-3.68l3.61-.81L8.6 1.54L12 3l3.4-1.46l1.89 3.18l3.61.82l-.34 3.68L23 12m-2.67 0L18.5 9.89l.24-2.79L16 6.5l-1.42-2.43L12 5.18L9.42 4.07L8 6.5l-2.74.59l.24 2.79L3.67 12l1.83 2.1l-.24 2.8l2.74.6l1.42 2.43L12 18.81l2.58 1.11L16 17.5l2.74-.61l-.24-2.79l1.83-2.1Z"/>'
        },
        decimal: {
            body: '<path fill="currentColor" d="M10 7a3 3 0 0 0-3 3v3a3 3 0 0 0 6 0v-3a3 3 0 0 0-3-3m1 6a1 1 0 0 1-2 0v-3a1 1 0 0 1 2 0m6-3a3 3 0 0 0-3 3v3a3 3 0 0 0 6 0v-3a3 3 0 0 0-3-3m1 6a1 1 0 0 1-2 0v-3a1 1 0 0 1 2 0M6 15a1 1 0 1 1-1-1a1 1 0 0 1 1 1Z"/>'
        },
        "decimal-comma": {
            body: '<path fill="currentColor" d="M10 7a3 3 0 0 1 3 3v3a3 3 0 0 1-6 0v-3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m7-2a3 3 0 0 1 3 3v3a3 3 0 0 1-6 0v-3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1M5 14a1 1 0 0 0-1 1l1 3h1v-3a1 1 0 0 0-1-1Z"/>'
        },
        "decimal-comma-decrease": {
            body: '<path fill="currentColor" d="M5 13v3H4l-1-3a1 1 0 0 1 2 0m10 3v-2l-3 3l3 3v-2h6v-2m-9-5a3 3 0 0 1-6 0V8a3 3 0 0 1 6 0m-2 0a1 1 0 0 0-2 0v3a1 1 0 0 0 2 0Z"/>'
        },
        "decimal-comma-increase": {
            body: '<path fill="currentColor" d="M9 5a3 3 0 0 0-3 3v3a3 3 0 0 0 6 0V8a3 3 0 0 0-3-3m1 6a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0m6 6a3 3 0 0 0 3-3V8a3 3 0 0 0-6 0v3a3 3 0 0 0 3 3m-1-6a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0m4 9v-2h-6v-2h6v-2l3 3M5 13v3H4l-1-3a1 1 0 0 1 2 0Z"/>'
        },
        "decimal-decrease": {
            body: '<path fill="currentColor" d="m12 17l3 3v-2h6v-2h-6v-2l-3 3M9 5a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-5 5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "decimal-increase": {
            body: '<path fill="currentColor" d="m22 17l-3 3v-2h-6v-2h6v-2l3 3M9 5a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m7-2a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1M4 12a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        delete: {
            body: '<path fill="currentColor" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12Z"/>'
        },
        "delete-alert": {
            body: '<path fill="currentColor" d="M17 4v2H3V4h3.5l1-1h5l1 1H17M4 19V7h12v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2m15-4h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "delete-alert-outline": {
            body: '<path fill="currentColor" d="M4 19V7h12v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2M6 9v10h8V9H6m7.5-5H17v2H3V4h3.5l1-1h5l1 1M19 17v-2h2v2h-2m0-4V7h2v6h-2Z"/>'
        },
        "delete-circle": {
            body: '<path fill="currentColor" d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m5 5h-2.5l-1-1h-3l-1 1H7v2h10V7M9 18h6a1 1 0 0 0 1-1v-7H8v7a1 1 0 0 0 1 1Z"/>'
        },
        "delete-circle-outline": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m4 6v7a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-7h8m-2.5-4l1 1H17v2H7V7h2.5l1-1h3Z"/>'
        },
        "delete-clock": {
            body: '<path fill="currentColor" d="M15 13h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13m8 3c0 3.87-3.13 7-7 7c-1.91 0-3.64-.76-4.9-2H8c-1.1 0-2-.9-2-2V7h12v2.29c2.89.86 5 3.54 5 6.71m-7-5c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m3-7v2H5V4h3.5l1-1h5l1 1H19Z"/>'
        },
        "delete-clock-outline": {
            body: '<path fill="currentColor" d="M15 13h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13m8 3c0 3.87-3.13 7-7 7c-1.91 0-3.64-.76-4.9-2H8c-1.1 0-2-.9-2-2V7h12v2.29c2.89.86 5 3.54 5 6.71M9 16c0-3.87 3.13-7 7-7H8v10h1.67c-.43-.91-.67-1.93-.67-3m7-5c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m-.5-7H19v2H5V4h3.5l1-1h5l1 1Z"/>'
        },
        "delete-empty": {
            body: '<path fill="currentColor" d="m20.37 8.91l-1 1.73l-12.13-7l1-1.73l3.04 1.75l1.36-.37l4.33 2.5l.37 1.37l3.03 1.75M6 19V7h5.07L18 11v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2Z"/>'
        },
        "delete-empty-outline": {
            body: '<path fill="currentColor" d="m20.37 8.91l-1 1.73l-12.13-7l1-1.73l3.04 1.75l1.36-.37l4.33 2.5l.37 1.37l3.03 1.75M6 19V7h5.07L18 11v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2m2 0h8v-6.8L10.46 9H8v10Z"/>'
        },
        "delete-forever": {
            body: '<path fill="currentColor" d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12m2.46-7.12l1.41-1.41L12 12.59l2.12-2.12l1.41 1.41L13.41 14l2.12 2.12l-1.41 1.41L12 15.41l-2.12 2.12l-1.41-1.41L10.59 14l-2.13-2.12M15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5Z"/>'
        },
        "delete-forever-outline": {
            body: '<path fill="currentColor" d="M14.12 10.47L12 12.59l-2.13-2.12l-1.41 1.41L10.59 14l-2.12 2.12l1.41 1.41L12 15.41l2.12 2.12l1.41-1.41L13.41 14l2.12-2.12l-1.41-1.41M15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12M8 9h8v10H8V9Z"/>'
        },
        "delete-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L5 5.72l.28.28l1 1L18 18.72l2 2L18.73 22l-1.46-1.46c-.34.29-.77.46-1.27.46H8c-1.1 0-2-.9-2-2V9.27l-4-4M19 4v2H7.82l-2-2H8.5l1-1h5l1 1H19m-1 3v9.18L8.82 7H18Z"/>'
        },
        "delete-off-outline": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L5 5.72l.28.28l1 1l2 2L16 16.72l2 2l2 2L18.73 22l-1.46-1.46c-.34.29-.77.46-1.27.46H8c-1.1 0-2-.9-2-2V9.27l-4-4M8 19h7.73L8 11.27V19M18 7v9.18l-2-2V9h-5.18l-2-2H18m-2.5-3H19v2H7.82l-2-2H8.5l1-1h5l1 1Z"/>'
        },
        "delete-outline": {
            body: '<path fill="currentColor" d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12M8 9h8v10H8V9m7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5Z"/>'
        },
        "delete-restore": {
            body: '<path fill="currentColor" d="M14 14h2l-4-4l-4 4h2v4h4v-4M6 7h12v12c0 .5-.2 1-.61 1.39c-.39.41-.89.61-1.39.61H8c-.5 0-1-.2-1.39-.61C6.2 20 6 19.5 6 19V7m13-3v2H5V4h3.5l1-1h5l1 1H19Z"/>'
        },
        "delete-sweep": {
            body: '<path fill="currentColor" d="M15 16h4v2h-4v-2m0-8h7v2h-7V8m0 4h6v2h-6v-2M3 18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8H3v10M14 5h-3l-1-1H6L5 5H2v2h12V5Z"/>'
        },
        "delete-sweep-outline": {
            body: '<path fill="currentColor" d="M15 16h4v2h-4v-2m0-8h7v2h-7V8m0 4h6v2h-6v-2m-4-2v8H5v-8h6m2-2H3v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8m1-3h-3l-1-1H6L5 5H2v2h12V5Z"/>'
        },
        "delete-variant": {
            body: '<path fill="currentColor" d="M21.03 3L18 20.31c-.17.96-1 1.69-2 1.69H8c-1 0-1.83-.73-2-1.69L2.97 3h18.06M5.36 5L8 20h8l2.64-15H5.36M9 18v-4h4v4H9m4-4.82L9.82 10L13 6.82L16.18 10L13 13.18Z"/>'
        },
        delta: {
            body: '<path fill="currentColor" d="M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20"/>'
        },
        desk: {
            body: '<path fill="currentColor" d="M3 6h18c.55 0 1 .45 1 1s-.45 1-1 1v11h-2v-2h-4v2h-2V8H5v11H3V8c-.55 0-1-.45-1-1s.45-1 1-1m13 4.5v.5h2v-.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5m0 4v.5h2v-.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5Z"/>'
        },
        "desk-lamp": {
            body: '<path fill="currentColor" d="M10.85 2L9.18 4.5l1.14.75L7.14 10H7a2 2 0 0 0-2 2a2 2 0 0 0 1.58 1.95L10.62 20H7v2h10v-2h-4l-4.47-6.72A2 2 0 0 0 9 12c0-.3-.07-.6-.2-.87L12 6.37c-.22 1.68.75 3.52 2.45 4.63l4.44-6.63c-1.69-1.13-3.77-1.33-5.24-.5L10.85 2m7.48 5l-1.66 2.5c.68.45 1.62.27 2.08-.42c.46-.69.25-1.62-.42-2.08Z"/>'
        },
        "desk-lamp-off": {
            body: '<path fill="currentColor" d="m9 10.87l-.2.26c.13.27.2.57.2.87a2 2 0 0 1-.47 1.28L13 20h4v2H7v-2h3.62l-4.04-6.05A2 2 0 0 1 5 12c0-1.1.9-2 2-2h.14l.39-.58L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27L9 10.87M18.33 7l-1.66 2.5c.68.45 1.62.27 2.08-.42S19 7.46 18.33 7m-8.76-.63L11 7.82l1-1.45c-.22 1.68.75 3.52 2.45 4.63l4.44-6.63c-1.69-1.13-3.77-1.33-5.24-.5L10.85 2L9.18 4.5l1.14.75l-.75 1.12Z"/>'
        },
        "desk-lamp-on": {
            body: '<path fill="currentColor" d="M10.85 2L9.18 4.5l1.14.75L7.14 10H7c-1.1 0-2 .9-2 2a2 2 0 0 0 1.58 1.95L10.62 20H7v2h10v-2h-4l-4.47-6.72A2 2 0 0 0 9 12c0-.3-.07-.6-.2-.87L12 6.37c-.22 1.68.75 3.52 2.45 4.63l4.44-6.63c-1.69-1.13-3.77-1.33-5.24-.5L10.85 2m7.48 5l-1.66 2.5c.68.45 1.62.27 2.08-.42c.46-.69.25-1.62-.42-2.08m3.37 5.58l-2.12-2.13l.7-.7l2.12 2.12l-.7.71M23 7h-3V6h3v1m-7 7v-3h1v3h-1Z"/>'
        },
        deskphone: {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m10 2v14h4V5h-4M5 5v4h8V5H5m0 6v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m-6 3v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m0 3v2h2v-2h-2m-3 0v2h2v-2H8m-3 0v2h2v-2H5Z"/>'
        },
        "desktop-classic": {
            body: '<path fill="currentColor" d="M6 2c-1.11 0-2 .89-2 2v8c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2H6m0 2h12v8H6V4M4 15c-1.11 0-2 .89-2 2v3c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2v-3c0-1.11-.89-2-2-2H4m4 2h12v3H8v-3m1 .75v1.5h4v-1.5H9m6 0v1.5h4v-1.5h-4Z"/>'
        },
        "desktop-mac": {
            body: '<path fill="currentColor" d="M21 14H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7l-2 3v1h8v-1l-2-3h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>',
            hidden: true
        },
        "desktop-mac-dashboard": {
            body: '<path fill="currentColor" d="M21 14V4H3v10h18m0-12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7l2 3v1H8v-1l2-3H3a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h18M4 5h11v5H4V5m12 0h4v2h-4V5m4 3v5h-4V8h4M4 11h5v2H4v-2m6 0h5v2h-5v-2Z"/>',
            hidden: true
        },
        "desktop-tower": {
            body: '<path fill="currentColor" d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v2h8V4H8m8 4H8v2h8V8m0 10h-2v2h2v-2Z"/>'
        },
        "desktop-tower-monitor": {
            body: '<path fill="currentColor" d="M22 18h-5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1m0-10h-5v1h5V8m0 2h-5v1h5v-1M9 15v2h1v1H5v-1h1v-2H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H9m3-7H3v5h9V8Z"/>'
        },
        details: {
            body: '<path fill="currentColor" d="M6.38 6h11.25L12 16L6.38 6M3 4l9 16l9-16H3Z"/>'
        },
        "dev-to": {
            body: '<path fill="currentColor" d="M7.73 11.93c0 1.72-.02 1.83-.23 2.07c-.19.17-.38.23-.76.23l-.51.01l-.03-2.27l-.02-2.27h.52c.35 0 .6.07.77.21c.24.21.26.25.26 2.02M22 7.5v9c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2v-9c0-1.11.89-2 2-2h16c1.11 0 2 .89 2 2M8.93 11.73c-.03-1.84-.05-1.99-.29-2.39c-.4-.68-.85-.84-2.36-.84H5v7h1.21c1.33 0 1.89-.17 2.29-.71c.41-.53.5-.98.43-3.06m4.19-3.23h-1.48c-1.49 0-1.5 0-1.71.28S9.7 9.21 9.7 12v2.96l.27.27c.25.27.31.27 1.71.27h1.44v-1.19l-1.09-.04l-1.1-.03V12.6l.68-.03l.66-.04v-1.19h-1.39V9.7h2.24V8.5m5.88.06c0-.06-.3-.06-.66-.06l-.68.06l-.59 2.35c-.38 1.48-.62 2.27-.67 2.13c-.08-.27-1.14-4.44-1.14-4.49c0-.05-.31-.05-.68-.05h-.69l.41 1.55c.2.87.59 2.28.81 3.15c.34 1.35.46 1.65.75 1.94c.2.22.45.36.61.36c.33 0 .76-.34.9-.73C17.5 14.5 19 8.69 19 8.56Z"/>'
        },
        "developer-board": {
            body: '<path fill="currentColor" d="M22 9V7h-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2m-4 10H4V5h14v14M6 13h5v4H6v-4m6-6h4v3h-4V7M6 7h5v5H6V7m6 4h4v6h-4v-6Z"/>'
        },
        deviantart: {
            body: '<path fill="currentColor" d="M6 6h6l2-4h4v4l-3.5 7H18v5h-6l-2 4H6v-4l3.5-7H6V6Z"/>'
        },
        devices: {
            body: '<path fill="currentColor" d="M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6m10 6H9v1.78c-.61.55-1 1.33-1 2.22c0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12m-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1m-1 10h-4v-8h4v8Z"/>'
        },
        dharmachakra: {
            body: '<path fill="currentColor" d="M11 2v1c-1.73.2-3.31.9-4.6 1.94l-.76-.76L4.22 5.6l.78.75A9.043 9.043 0 0 0 3 11H2v2h1c.21 1.68.9 3.26 2 4.56l-.78.76l1.42 1.42l.75-.74A9.304 9.304 0 0 0 11 21v1h2v-1a9.27 9.27 0 0 0 4.6-2l.76.74l1.42-1.42l-.78-.75c1.1-1.3 1.79-2.89 2-4.57h1v-2h-1a9.01 9.01 0 0 0-2-4.64l.78-.76l-1.42-1.42l-.75.76A8.997 8.997 0 0 0 13 3V2h-2m0 3v3l-1 .5l-2.19-2.15c.91-.68 2-1.18 3.19-1.35m2 0c1.16.18 2.26.64 3.2 1.35L14 8.5L13 8V5M6.4 7.76L8.5 10L8 11H5c.16-1.16.7-2.3 1.39-3.25l.01.01m11.2 0c.73.95 1.21 2.06 1.4 3.24h-3l-.5-1l2.11-2.24h-.01M12 10c1.12 0 2 .88 2 2s-.88 2-2 2s-2-.88-2-2s.88-2 2-2m-7 3h3l.57 1l-2.18 2.15C5.67 15.24 5.19 14.16 5 13m11 0h3a6.984 6.984 0 0 1-1.39 3.16L15.5 14l.5-1m-6 2.5l1 .5v3a7.04 7.04 0 0 1-3.2-1.43L10 15.5m4 0l2.19 2.07c-.91.68-2 1.26-3.19 1.43v-3l1-.5Z"/>'
        },
        diabetes: {
            body: '<path fill="currentColor" d="M14.73 2.29a1 1 0 0 1 1.41 1.41L13 6.79l.76.95l1.94 5a1.46 1.46 0 0 1-.34 1.55l-3.09 3.09a1.55 1.55 0 0 1-2.12 0l-4.6-4.6a1.37 1.37 0 0 1-.4-1l-.5-6.44h1.07a1 1 0 0 1 .75.3l.14.17l1.05 3.48m0 12.71L2 16.36l2.12-2.12l5.66 5.66M19.5 4.5S17 7.26 17 9a2.5 2.5 0 1 0 5 0c0-1.74-2.5-4.5-2.5-4.5Z"/>'
        },
        dialpad: {
            body: '<path fill="currentColor" d="M12 19a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M6 1a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m12-8a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m-6 8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m6 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-6 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        diameter: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m5 13v-2H7v2l-3-3l3-3v2h10V9l3 3l-3 3Z"/>'
        },
        "diameter-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m4-5v-2H8v2l-3-3l3-3v2h8V9l3 3l-3 3Z"/>'
        },
        "diameter-variant": {
            body: '<path fill="currentColor" d="m4.15 21.46l1.32-1.88A10.012 10.012 0 0 1 2 12A10 10 0 0 1 12 2c1.78 0 3.44.46 4.89 1.27l1.32-1.88l1.64 1.15l-1.32 1.88C20.65 6.26 22 8.97 22 12a10 10 0 0 1-10 10c-1.78 0-3.44-.46-4.89-1.27l-1.32 1.88l-1.64-1.15M12 4a8 8 0 0 0-8 8c0 2.35 1 4.46 2.63 5.93l9.1-13.01A7.921 7.921 0 0 0 12 4m0 16a8 8 0 0 0 8-8c0-2.35-1-4.46-2.63-5.93l-9.1 13.01c1.11.59 2.38.92 3.73.92Z"/>'
        },
        diamond: {
            body: '<path fill="currentColor" d="M6 2L2 8l10 14L22 8l-4-6H6Z"/>'
        },
        "diamond-outline": {
            body: '<path fill="currentColor" d="M18 2H6L2 8l10 14L22 8l-4-6M4.43 8l2.64-4h9.86l2.64 4L12 18.56L4.43 8Z"/>'
        },
        "diamond-stone": {
            body: '<path fill="currentColor" d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6Z"/>'
        },
        dice: {
            body: '<path d="M21 16.5a1 1 0 0 1-.527.881l-7.907 4.443a.996.996 0 0 1-1.132 0l-7.907-4.443A1 1 0 0 1 3 16.5v-9a1 1 0 0 1 .527-.881l7.907-4.443a.995.995 0 0 1 1.132 0l7.907 4.443A1 1 0 0 1 21 7.5v9zM5.5 14.316c-.552-.313-1-.118-1 .434s.448 1.253 1 1.566c.552.313 1 .118 1-.434s-.448-1.253-1-1.566zm0-4c-.552-.313-1-.118-1 .434s.448 1.253 1 1.566c.552.313 1 .118 1-.434s-.448-1.253-1-1.566zm4 6.264c-.552-.313-1-.118-1 .434s.448 1.253 1 1.566c.552.312 1 .118 1-.434c0-.553-.448-1.254-1-1.566zm-2-3.132c-.552-.313-1-.118-1 .434s.448 1.253 1 1.566c.552.312 1 .118 1-.434c0-.553-.448-1.254-1-1.566zm2-.868c-.552-.313-1-.119-1 .434c0 .552.448 1.253 1 1.566c.552.312 1 .118 1-.434c0-.553-.448-1.254-1-1.566zm9 1.736c-.552.313-1 1.014-1 1.566s.448.746 1 .434c.552-.313 1-1.014 1-1.566s-.448-.747-1-.434zm0-4c-.552.313-1 1.014-1 1.566s.448.747 1 .434s1-1.014 1-1.566s-.448-.747-1-.434zm-4 6.264c-.552.312-1 1.014-1 1.566s.448.746 1 .434c.552-.313 1-1.014 1-1.566s-.448-.747-1-.434zm0-4c-.552.312-1 1.014-1 1.566s.448.746 1 .434c.552-.313 1-1.014 1-1.566s-.448-.747-1-.434zm1.992-4.81c.547-.321.602-.806.124-1.082s-1.31-.24-1.856.083c-.547.322-.602.807-.124 1.083c.478.276 1.31.239 1.856-.083zm-7.425.333c.547-.322.603-.807.124-1.083c-.478-.276-1.309-.239-1.856.083c-.547.322-.602.807-.124 1.083c.478.276 1.31.24 1.856-.083zm3.713-.166c.546-.322.602-.807.124-1.083c-.479-.276-1.31-.239-1.857.083c-.546.322-.602.807-.124 1.083c.479.276 1.31.239 1.857-.083z" fill="currentColor"/>',
            hidden: true
        },
        "dice-1": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-1-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 7.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"/>'
        },
        "dice-2": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-2-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9S9 8.33 9 7.5S8.33 6 7.5 6m9 9c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5Z"/>'
        },
        "dice-3": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M7 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-3-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 7.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6m9 9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5Z"/>'
        },
        "dice-4": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M7 15a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-4-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9S9 8.33 9 7.5S8.33 6 7.5 6m9 9c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5m0-9c-.83 0-1.5.67-1.5 1.5S15.67 9 16.5 9S18 8.33 18 7.5S17.33 6 16.5 6m-9 9c-.83 0-1.5.67-1.5 1.5S6.67 18 7.5 18S9 17.33 9 16.5S8.33 15 7.5 15Z"/>'
        },
        "dice-5": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-5 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-5 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-5-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6m9 9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5m0-9c-.8 0-1.5.7-1.5 1.5S15.7 9 16.5 9S18 8.3 18 7.5S17.3 6 16.5 6M12 10.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5M7.5 15c-.8 0-1.5.7-1.5 1.5S6.7 18 7.5 18S9 17.3 9 16.5S8.3 15 7.5 15Z"/>'
        },
        "dice-6": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M7 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "dice-6-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6m9 9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5m0-4.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S18 12.8 18 12s-.7-1.5-1.5-1.5m0-4.5c-.8 0-1.5.7-1.5 1.5S15.7 9 16.5 9S18 8.3 18 7.5S17.3 6 16.5 6m-9 4.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S9 12.8 9 12s-.7-1.5-1.5-1.5m0 4.5c-.8 0-1.5.7-1.5 1.5S6.7 18 7.5 18S9 17.3 9 16.5S8.3 15 7.5 15Z"/>'
        },
        "dice-d10": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m2.07 6.21c1.43 0 2.57 1.15 2.57 2.57v2.64c0 1.42-1.14 2.58-2.57 2.58s-2.57-1.16-2.57-2.58v-2.64a2.57 2.57 0 0 1 2.57-2.57m-3.71.2h.14V16H9v-5.79l-1.78.55V9.53l3.14-1.12m3.7 1.24c-.59 0-1.06.48-1.06 1.06v2.79c0 .57.47 1.04 1.06 1.04c.58 0 1.08-.48 1.08-1.04v-2.79c0-.59-.5-1.06-1.08-1.06Z"/>'
        },
        "dice-d10-outline": {
            body: '<path fill="currentColor" d="M10.5 16H9v-5.79l-1.78.55V9.53l3.14-1.12h.14V16m3.57-7.79c1.43 0 2.57 1.15 2.57 2.57v2.64c0 1.42-1.14 2.58-2.57 2.58s-2.57-1.16-2.57-2.58v-2.64a2.57 2.57 0 0 1 2.57-2.57m-.01 1.44c-.59 0-1.06.48-1.06 1.06v2.79c0 .57.47 1.04 1.06 1.04c.58 0 1.08-.48 1.08-1.04v-2.79c0-.59-.5-1.06-1.08-1.06M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l8 8l-8 8l-8-8Z"/>'
        },
        "dice-d12": {
            body: '<path fill="currentColor" d="M12 2L1.5 9.64L5.5 22h13l4-12.36L12 2m-1.5 15H8.89v-6.11L7 11.47v-1.28L10.31 9h.19v8m6.5 0h-5.34v-1.09s3.57-3.46 3.57-4.51c0-1.28-1.05-1.15-1.05-1.15c-.68.05-1.18.62-1.18 1.3h-1.56c.06-1.46 1.28-2.61 2.83-2.55c2.47 0 2.5 1.85 2.5 2.3c0 1.77-3.19 4.47-3.19 4.47l3.42-.02V17Z"/>'
        },
        "dice-d12-outline": {
            body: '<path fill="currentColor" d="M12 2L1.5 9.64L5.5 22h13l4-12.36L12 2m5 18H7l-3.15-9.6L12 4.47l8.15 5.93L17 20m0-4.25V17h-5.34v-1.09s3.57-3.46 3.57-4.51c0-1.28-1.05-1.15-1.05-1.15c-.68.05-1.18.62-1.18 1.3h-1.56c.06-1.46 1.28-2.61 2.83-2.55c2.47 0 2.5 1.85 2.5 2.3c0 1.77-3.19 4.47-3.19 4.47l3.42-.02M10.5 17H8.89v-6.11L7 11.47v-1.28L10.31 9h.19v8Z"/>'
        },
        "dice-d20": {
            body: '<path fill="currentColor" d="m20.47 6.62l-7.9-4.44C12.41 2.06 12.21 2 12 2s-.41.06-.57.18l-7.9 4.44c-.32.17-.53.5-.53.88v9c0 .38.21.71.53.88l7.9 4.44c.16.12.36.18.57.18s.41-.06.57-.18l7.9-4.44c.32-.17.53-.5.53-.88v-9c0-.38-.21-.71-.53-.88m-9.02 9.34l-5.14-.03v-1.02s3.43-3.33 3.44-4.34c0-1.24-1.02-1.11-1.02-1.11s-.98.04-1.09 1.25l-1.5.05s.04-2.5 2.69-2.5c2.37 0 2.4 1.78 2.4 2.24c0 1.68-3.08 4.27-3.08 4.27l3.3-.01v1.2m6.05-2.46c0 1.4-1.15 2.55-2.57 2.55c-1.43 0-2.57-1.15-2.57-2.55v-2.66c0-1.42 1.14-2.57 2.57-2.57s2.57 1.15 2.57 2.57v2.66M16 10.77v2.76c0 .59-.5 1.07-1.08 1.07c-.58 0-1.06-.48-1.06-1.07v-2.76c0-.59.48-1.06 1.06-1.06c.58 0 1.08.47 1.08 1.06Z"/>'
        },
        "dice-d20-outline": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94m2.93 4.12a2.57 2.57 0 0 1 2.57 2.57v2.66c0 1.4-1.15 2.55-2.57 2.55c-1.43 0-2.57-1.15-2.57-2.55v-2.66a2.57 2.57 0 0 1 2.57-2.57m-.01 1.44c-.58 0-1.06.47-1.06 1.06v2.76c0 .59.48 1.07 1.06 1.07c.58 0 1.08-.48 1.08-1.07v-2.76c0-.59-.5-1.06-1.08-1.06m-3.47 5.05v1.2l-5.14-.03v-1.02s3.43-3.33 3.44-4.34c0-1.24-1.02-1.11-1.02-1.11s-.98.04-1.09 1.25l-1.5.05s.04-2.5 2.69-2.5c2.37 0 2.4 1.78 2.4 2.24c0 1.68-3.08 4.27-3.08 4.27l3.3-.01Z"/>'
        },
        "dice-d4": {
            body: '<path fill="currentColor" d="m10.25 15.15l1.67-2.68v2.68h-1.67M21.92 21H2.08c-.84 0-1.36-.92-.92-1.64l9.92-16.23c.42-.69 1.42-.69 1.84 0l9.92 16.23c.44.72-.08 1.64-.92 1.64m-7.63-5.85h-.86v-4.73h-1.52l-3.16 4.99l.07.95h3.1V18h1.51v-1.64h.86v-1.21Z"/>'
        },
        "dice-d4-outline": {
            body: '<path fill="currentColor" d="M13.43 15.15h.86v1.21h-.86V18h-1.51v-1.64h-3.1l-.07-.95l3.16-4.99h1.52v4.73m-3.18 0h1.67v-2.68l-1.67 2.68M22 21H2c-.36 0-.69-.19-.87-.5a.97.97 0 0 1 .02-1l10-16.5c.35-.62 1.35-.62 1.71 0l10 16.5A.993.993 0 0 1 22 21M3.78 19h16.45L12 5.43L3.78 19Z"/>'
        },
        "dice-d6": {
            body: '<path fill="currentColor" d="M13.05 13.5c0 .77-.44 1.33-1.05 1.33s-1.15-.56-1.15-1.33l-.02-.72s.38-.78 1.12-.68c.61 0 1.1.63 1.1 1.4M21 5v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2m-6.45 8.41c-.05-1.96-1.36-2.54-2.02-2.54c-1.12 0-1.67.66-1.67.66s.03-2.03 2.53-2v-1.2s-4.06-.39-4.09 4.33c-.03 4.2 3.47 3.34 3.47 3.34s1.84-.53 1.78-2.59Z"/>'
        },
        "dice-d6-outline": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5m8.39 4.53c-2.5-.03-2.53 2-2.53 2s.55-.66 1.67-.66c.66 0 1.97.58 2.02 2.54c.06 2.06-1.78 2.59-1.78 2.59s-3.5.86-3.47-3.34c.03-4.72 4.09-4.33 4.09-4.33v1.2m-1.44 2.57c-.74-.1-1.12.68-1.12.68l.02.72c0 .77.54 1.33 1.15 1.33c.61 0 1.05-.56 1.05-1.33s-.49-1.4-1.1-1.4Z"/>'
        },
        "dice-d8": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 6.25c1.31 0 2.38.95 2.38 2.13c0 .69-.38 1.3-.94 1.69c.7.39 1.16 1.06 1.16 1.83c0 1.22-1.16 2.2-2.6 2.2c-1.44 0-2.6-.98-2.6-2.2c0-.77.46-1.44 1.16-1.83c-.56-.39-.93-1-.93-1.69c0-1.18 1.06-2.13 2.37-2.13m0 1.25c-.5 0-.9.45-.9 1s.4 1 .9 1s.9-.45.9-1s-.4-1-.9-1m0 3.15c-.61 0-1.1.49-1.1 1.1c0 .61.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1c0-.61-.49-1.1-1.1-1.1Z"/>'
        },
        "dice-d8-outline": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l8 8l-8 8l-8-8m8-3.75c1.31 0 2.38.95 2.38 2.13c0 .69-.38 1.3-.94 1.69c.7.39 1.16 1.06 1.16 1.83c0 1.22-1.16 2.2-2.6 2.2c-1.44 0-2.6-.98-2.6-2.2c0-.77.46-1.44 1.16-1.83c-.56-.39-.93-1-.93-1.69c0-1.18 1.06-2.13 2.37-2.13m0 4.4c-.61 0-1.1.49-1.1 1.1c0 .61.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1c0-.61-.49-1.1-1.1-1.1m0-3.15c-.5 0-.9.45-.9 1s.4 1 .9 1s.9-.45.9-1s-.4-1-.9-1"/>'
        },
        "dice-multiple": {
            body: '<path fill="currentColor" d="M19.78 3h-8.56C10.55 3 10 3.55 10 4.22V8h6v6h3.78c.67 0 1.22-.55 1.22-1.22V4.22C21 3.55 20.45 3 19.78 3m-7.34 3.67a1.23 1.23 0 1 1 0-2.46a1.23 1.23 0 0 1 1.23 1.23c0 .68-.55 1.23-1.23 1.23m6.12 6.11a1.23 1.23 0 1 1-.02-2.46c.68-.01 1.23.54 1.24 1.24c-.01.67-.55 1.21-1.22 1.22m0-6.11a1.23 1.23 0 1 1-.02-2.46a1.231 1.231 0 0 1 .02 2.46M4.22 10h8.56A1.22 1.22 0 0 1 14 11.22v8.56c0 .67-.55 1.22-1.22 1.22H4.22C3.55 21 3 20.45 3 19.78v-8.56c0-.67.55-1.22 1.22-1.22m4.28 4.28c-.67 0-1.22.55-1.22 1.22c0 .67.55 1.22 1.22 1.22c.67 0 1.22-.55 1.22-1.22a1.22 1.22 0 0 0-1.22-1.22m-3.06-3.06c-.67 0-1.22.55-1.22 1.22a1.22 1.22 0 0 0 1.22 1.22c.67 0 1.22-.55 1.22-1.22c0-.67-.55-1.22-1.22-1.22m6.11 6.11c-.67 0-1.22.55-1.22 1.22c0 .67.55 1.22 1.22 1.22a1.22 1.22 0 0 0 1.22-1.22c0-.67-.54-1.21-1.21-1.22h-.01Z"/>'
        },
        "dice-multiple-outline": {
            body: '<path fill="currentColor" d="M14 8c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m-2 4v7H5v-7h7m.78-2H4.22C3.55 10 3 10.55 3 11.22v8.56c0 .67.55 1.22 1.22 1.22h8.56c.67 0 1.22-.55 1.22-1.22v-8.56c0-.67-.55-1.22-1.22-1.22m7-7h-8.56C10.55 3 10 3.55 10 4.22V8h2V5h7v7h-3v2h3.78c.67 0 1.22-.55 1.22-1.22V4.22C21 3.55 20.45 3 19.78 3M17 8c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m0 3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M7 15c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3 3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1"/>'
        },
        "digital-ocean": {
            body: '<path fill="currentColor" d="M6 12H2C2 6.5 6.5 2 12 2s10 4.5 10 10s-4.5 10-10 10v-4H8v-4h4v4c3.32 0 6-2.69 6-6s-2.69-6-6-6s-6 2.69-6 6m2 6v3H5v-3h3m-5-2h2v2H3v-2Z"/>'
        },
        "dip-switch": {
            body: '<path fill="currentColor" d="M3 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m7 0h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m7 0h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1M4 18h2v-5H4v5m7-7h2V6h-2v5m7 7h2v-5h-2v5Z"/>'
        },
        directions: {
            body: '<path fill="currentColor" d="M14 14.5V12h-4v3H8v-4a1 1 0 0 1 1-1h5V7.5l3.5 3.5m4.21.29l-9-9h-.01a.996.996 0 0 0-1.41 0l-9 9c-.39.39-.39 1.03 0 1.42l9 9c.39.38 1.02.39 1.42 0l9-9c.39-.39.39-1.03 0-1.42Z"/>'
        },
        "directions-fork": {
            body: '<path fill="currentColor" d="M3 4v8.5l3-3L9 13c1 1 1 2 1 2v6h4v-7s0-1-.53-2S12 10 12 10L9 6.58L11.5 4M18 4l-4.46 4.47L14 9s.93 1 1.47 2c.21.4.33.79.4 1.13L21 7"/>'
        },
        disc: {
            body: '<path fill="currentColor" d="M12 14a2 2 0 0 1-2-2c0-1.11.89-2 2-2c1.11 0 2 .89 2 2a2 2 0 0 1-2 2m0-10a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "disc-alert": {
            body: '<path fill="currentColor" d="M10 14c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0-10c-4.4 0-8 3.6-8 8s3.6 8 8 8s8-3.6 8-8s-3.6-8-8-8m10 9h2V7h-2m0 10h2v-2h-2v2Z"/>'
        },
        "disc-player": {
            body: '<path fill="currentColor" d="M14.5 10.37a1.87 1.87 0 1 0 0-3.74c-1.04 0-1.87.83-1.87 1.87a1.87 1.87 0 0 0 1.87 1.87m0-9.37A7.5 7.5 0 0 1 22 8.5c0 2.17-.92 4.13-2.4 5.5H9.4A7.51 7.51 0 0 1 7 8.5C7 4.35 10.36 1 14.5 1M6 21v1H4v-1H2v-6h20v6h-2v1h-2v-1H6m-2-3v1h9v-1H4m11-1v2h2v-2h-2m4 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        discord: {
            body: '<path fill="currentColor" d="m22 24l-5.25-5l.63 2H4.5A2.5 2.5 0 0 1 2 18.5v-15A2.5 2.5 0 0 1 4.5 1h15A2.5 2.5 0 0 1 22 3.5V24M12 6.8c-2.68 0-4.56 1.15-4.56 1.15c1.03-.92 2.83-1.45 2.83-1.45l-.17-.17c-1.69.03-3.22 1.2-3.22 1.2c-1.72 3.59-1.61 6.69-1.61 6.69c1.4 1.81 3.48 1.68 3.48 1.68l.71-.9c-1.25-.27-2.04-1.38-2.04-1.38S9.3 14.9 12 14.9s4.58-1.28 4.58-1.28s-.79 1.11-2.04 1.38l.71.9s2.08.13 3.48-1.68c0 0 .11-3.1-1.61-6.69c0 0-1.53-1.17-3.22-1.2l-.17.17s1.8.53 2.83 1.45c0 0-1.88-1.15-4.56-1.15m-2.07 3.79c.65 0 1.18.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27m4.17 0c.65 0 1.17.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27Z"/>',
            hidden: true
        },
        dishwasher: {
            body: '<path fill="currentColor" d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-8 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m11 16H6V8h12v12m-3.33-4.67c.02.7-.26 1.38-.76 1.88a2.7 2.7 0 0 1-3.82 0c-.5-.5-.78-1.18-.76-1.88c.07-.71.3-1.39.67-2c.37-.83.81-1.6 1.33-2.33l.67-1c1.79 2.59 2.67 4.36 2.67 5.33"/>'
        },
        "dishwasher-alert": {
            body: '<path fill="currentColor" d="M16 2H4c-1.1 0-2 .9-2 2v16a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M8 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M5 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m11 16H4V8h12v12m-3.33-4.67c.02.7-.26 1.38-.76 1.88a2.7 2.7 0 0 1-3.82 0c-.5-.5-.78-1.18-.76-1.88c.07-.71.3-1.39.67-2c.37-.83.81-1.6 1.33-2.33l.67-1c1.79 2.59 2.67 4.36 2.67 5.33M20 15h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "dishwasher-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20c0 1.11.89 2 2 2h12c.58 0 1.1-.25 1.46-.65l1.38 1.38l1.27-1.27M18 20H6V8h.11l4.39 4.37c-.19.32-.35.63-.5.96c-.37.61-.6 1.29-.67 2c-.02.7.26 1.38.76 1.88a2.7 2.7 0 0 0 3.82 0c.25-.24.44-.53.59-.85l3.5 3.53V20M11.2 8H18v6.8l2 2V4a2 2 0 0 0-2-2H6c-.24 0-.46.05-.67.13L11.2 8M10 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        disk: {
            body: '<path d="M11.998 13.999A2 2 0 0 1 10 11.997c0-1.103.894-1.997 1.998-1.997c1.107 0 2 .894 2 1.998a2.001 2.001 0 0 1-2 2zm0-10a7.999 7.999 0 0 0-8 7.998c0 4.42 3.584 8.003 8 8.003A8.004 8.004 0 0 0 20 11.998a8 8 0 0 0-8.002-8z" fill="currentColor"/>',
            hidden: true
        },
        "disk-alert": {
            body: '<path d="M10 13.998a2 2 0 1 1 0-4a2 2 0 0 1 0 4zm0-10a8 8 0 1 0 0 16a8 8 0 0 0 0-16zm10 8h2v-5h-2m0 9h2v-2h-2v2z" fill="currentColor"/>',
            hidden: true
        },
        "disk-player": {
            body: '<path d="M14.499 10.374a1.876 1.876 0 0 0 1.876-1.876A1.873 1.873 0 0 0 14.5 6.626a1.872 1.872 0 0 0-1.873 1.872c0 1.034.838 1.876 1.873 1.876zm0-9.374a7.5 7.5 0 0 1 5.1 13H9.401A7.499 7.499 0 0 1 14.5 1zM6 21v1H4v-1H2v-6h20v6h-2v1h-2v-1H6zm-2-3v1h9v-1H4zm11-1v2h2v-2h-2zm4 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2z" fill="currentColor"/>',
            hidden: true
        },
        disqus: {
            body: '<path fill="currentColor" d="M12.08 22c-2.45 0-4.69-.89-6.42-2.37l-4.25.58l1.64-4.06c-.55-1.27-.89-2.65-.89-4.15c0-5.5 4.44-10 9.92-10C17.56 2 22 6.5 22 12s-4.44 10-9.92 10m5.42-10.03v-.03C17.5 9.06 15.46 7 11.95 7H8.16v10h3.74c3.53 0 5.6-2.14 5.6-5.03M12 14.54h-1.11V9.46H12c1.62 0 2.7.93 2.7 2.54c0 1.63-1.08 2.54-2.7 2.54Z"/>'
        },
        "disqus-outline": {
            body: '<path d="M11.9 14.5h-1.1v-5h1.1c1.6 0 2.7.9 2.7 2.5s-1.1 2.5-2.7 2.5m0-7.5H8.1v10h3.7c3.5 0 5.6-2.1 5.6-5s-2-5-5.5-5m.1 13c-1.9 0-3.7-.7-5.1-1.9l-.7-.6l-1.7.2l.7-1.6l-.3-.8c-.5-1.1-.7-2.2-.7-3.4c0-4.4 3.6-8 7.9-8c4.3 0 7.8 3.7 7.8 8.1c0 4.4-3.6 8-7.9 8m0-18C6.5 2 2.1 6.5 2.1 12c0 1.5.3 2.9.9 4.2l-1.6 4.1l4.3-.6c1.7 1.5 4 2.4 6.4 2.4c5.5 0 9.9-4.5 9.9-10S17.5 2 12 2z" fill="currentColor"/>',
            hidden: true
        },
        "distribute-horizontal-center": {
            body: '<path fill="currentColor" d="M8 2v3h2v14H8v3H6v-3H4V5h2V2h2m8 0v5h-2v10h2v5h2v-5h2V7h-2V2h-2Z"/>'
        },
        "distribute-horizontal-left": {
            body: '<path fill="currentColor" d="M21 7v10h-5v5h-2V2h2v5h5M5 2H3v20h2v-3h5V5H5V2Z"/>'
        },
        "distribute-horizontal-right": {
            body: '<path fill="currentColor" d="M3 17V7h5V2h2v20H8v-5H3m16 5h2V2h-2v3h-5v14h5v3Z"/>'
        },
        "distribute-vertical-bottom": {
            body: '<path fill="currentColor" d="M7 3h10v5h5v2H2V8h5V3M2 19v2h20v-2h-3v-5H5v5H2Z"/>'
        },
        "distribute-vertical-center": {
            body: '<path fill="currentColor" d="M2 16h3v-2h14v2h3v2h-3v2H5v-2H2v-2m0-8h5v2h10V8h5V6h-5V4H7v2H2v2Z"/>'
        },
        "distribute-vertical-top": {
            body: '<path fill="currentColor" d="M17 21H7v-5H2v-2h20v2h-5v5m5-16V3H2v2h3v5h14V5h3Z"/>'
        },
        diversify: {
            body: '<path fill="currentColor" d="M19 2v2h-7a2 2 0 0 0-2 2v3h2V6h7v2l3-3l-3-3m0 7v2h-5v2h5v2l3-3l-3-3m-7.95 1c-1.11 0-2.01.87-2.02 2s.87 2 1.97 2c1.11 0 2-.89 2-2c0-1.09-.87-1.97-1.95-2M2 11v2h6v-2H2m8 4v3a2 2 0 0 0 2 2h7v2l3-3l-3-3v2h-7v-3h-2Z"/>'
        },
        diving: {
            body: '<path fill="currentColor" d="m13.26 5.2l.04-.02a1 1 0 0 1 1.41.12L16.97 8H20c.55 0 1 .45 1 1s-.45 1-1 1h-3.5c-.35 0-.65-.18-.83-.44l-1.5-1.79l-2.53 2.36l2.93 2.05c.26.18.43.48.43.82v4c0 .55-.45 1-1 1s-1-.45-1-1v-3.5l-3.23-2.24a1.786 1.786 0 0 1-.17-2.8l3.66-3.26M16.5 5c.84 0 1.5-.67 1.5-1.5S17.34 2 16.5 2S15 2.67 15 3.5S15.68 5 16.5 5M6 19H5c-1.66 0-3 1.34-3 3h4v-1.5h9V19H6Z"/>'
        },
        "diving-flippers": {
            body: '<path fill="currentColor" d="M20.28 3.66c-1-.22-1.74-1.41-2.71-1.62c-.97-.21-2.17.55-3.15.33a3.66 3.66 0 0 0-3.14.34L11.21 17L11 18c-.36 1.62.67 3.22 2.29 3.58c1.61.35 3.21-.67 3.57-2.29l.21-1L23 5.28a3.63 3.63 0 0 0-2.72-1.62m-5.37 15.2c-.12.55-.66.9-1.21.79c-.56-.12-.91-.65-.79-1.22l.86-3.93a1 1 0 0 1 1.97.34c0 .04-.01.07-.02.11l-.81 3.91m-5.19 2.48c-.39-.61-.64-1.29-.72-2L8.24 16c-.14-.53.17-1.08.76-1.24a.81.81 0 0 1 .22 0V3.43c-.91 0-2-.57-2.84-.37c-.84.2-1.69 1.38-2.66 1.6c-1.11.1-2.11.69-2.72 1.62l5.93 13l.21 1a3.003 3.003 0 0 0 3.57 2.29h.1c-.43-.35-.81-.76-1.09-1.23Z"/>'
        },
        "diving-helmet": {
            body: '<path fill="currentColor" d="M16 12a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4m3.45-4.11l-1.38.69l.25.42H20v6h-1.67a7.062 7.062 0 0 1-2.12 2.6c1.64.51 2.89 1.31 3.46 2.26C18.69 21.1 15.62 22 12 22s-6.69-.9-7.67-2.14c.57-.95 1.82-1.75 3.46-2.26c-.9-.68-1.63-1.57-2.12-2.6H4V9h1.68A6.952 6.952 0 0 1 9 5.68V4h6v1.68c.68.32 1.29.78 1.82 1.32l1.73-.86C19.93 5.42 20 4.1 20 2h2c0 2.06 0 4.62-2.55 5.89M17 12a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5Z"/>'
        },
        "diving-scuba": {
            body: '<path fill="currentColor" d="M1 13c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m7.89-2.89l4.53-1.21l-.78-2.9l-4.53 1.21c-.8.21-1.28 1.04-1.06 1.84c.22.8 1.04 1.28 1.84 1.06M20.5 5.9L23 3l-1-1l-3 3l-2 4l-9.5 2.87c-.8.2-1.37.89-1.5 1.68L5.24 18L2.4 21.8L4 23l3-4l1.14-3.14L14 14l5-3.5l1.5-4.6Z"/>'
        },
        "diving-scuba-flag": {
            body: '<path fill="currentColor" d="m2 6l17 14H2V6m3-2l17 14V4H5Z"/>'
        },
        "diving-scuba-mask": {
            body: '<path fill="currentColor" d="M12 15c1.31 0 2.42.83 2.83 2H18a4 4 0 0 1 4 4v1h-2v-1a2 2 0 0 0-2-2h-3.17A2.99 2.99 0 0 1 12 21a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m6-14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-3.15c-.42 0-.8.24-.95.63c-.2.6-.67 1.08-1.28 1.28c-1.04.34-2.18-.23-2.52-1.28c-.15-.39-.53-.63-.95-.63H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12m0 7V5H6v5h4.65c.25-.54.76-.91 1.35-1c.59.09 1.1.46 1.35 1H18Z"/>'
        },
        "diving-scuba-tank": {
            body: '<path fill="currentColor" d="M19 18.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5c0-1.03.62-1.91 1.5-2.29V6H11v1.35c1.22.58 2 1.8 2 3.15V22H6V10.5c0-1.35.78-2.57 2-3.15V6H6V4h2v-.5A1.5 1.5 0 0 1 9.5 2A1.5 1.5 0 0 1 11 3.5V4h4.5a2 2 0 0 1 2 2v10.21c.88.38 1.5 1.26 1.5 2.29Z"/>'
        },
        "diving-scuba-tank-multiple": {
            body: '<path fill="currentColor" d="M22 18.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5c0-1.03.62-1.91 1.5-2.29V6H14v1.35c1.22.58 2 1.8 2 3.15V22H2V10.5c0-1.35.78-2.57 2-3.15V6H2V4h2v-.5A1.5 1.5 0 0 1 5.5 2A1.5 1.5 0 0 1 7 3.5V4h4v-.5A1.5 1.5 0 0 1 12.5 2A1.5 1.5 0 0 1 14 3.5V4h4.5a2 2 0 0 1 2 2v10.21c.88.38 1.5 1.26 1.5 2.29M11 7.35V6H7v1.35c1.22.58 2 1.8 2 3.15c0-1.35.78-2.57 2-3.15Z"/>'
        },
        "diving-snorkel": {
            body: '<path fill="currentColor" d="M16 3H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h3.15c.42 0 .8.24.95.63a2.003 2.003 0 0 0 2.52 1.28c.61-.2 1.08-.68 1.28-1.28c.15-.39.53-.63.95-.63H16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 7h-4.65c-.25-.54-.76-.91-1.35-1c-.59.09-1.1.46-1.35 1H4V5h12v5m6-8v13.5a6.5 6.5 0 0 1-6.5 6.5c-1.71 0-3.35-.68-4.57-1.88c-1.98.46-4.05-.33-5.22-2l1.91-.83c.88.93 2.22 1.21 3.38.71c.2-.09.39-.2.56-.33c.84-.62 1.31-1.63 1.22-2.67l1.91-.83c.41 1.87-.28 3.83-1.79 5c.76.54 1.67.83 2.6.83c2.5 0 4.5-2 4.5-4.5V2h2Z"/>'
        },
        division: {
            body: '<path fill="currentColor" d="M19 13H5v-2h14v2m-7-8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "division-box": {
            body: '<path fill="currentColor" d="M17 13v-2H7v2h10m2-10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14m-7 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        dlna: {
            body: '<path fill="currentColor" d="M21.38 12.56h-8.53c-.88 0-1.75.4-2.24 1.05v-.01c-.49.68-1.29 1.12-2.2 1.12c-1.49 0-2.7-1.22-2.7-2.72c0-1.5 1.21-2.69 2.7-2.69c.91 0 1.71.44 2.2 1.12v-.01c.49.65 1.36 1.08 2.24 1.08h8.44c.16 0 .71-.1.71-.83c-.74-4.24-4.9-7.49-9.94-7.49c-3.1 0-5.87 1.23-7.72 3.17c-.29.44.01.57.29.61h5.51c.86 0 1.75-.42 2.24-1.07v.02c.5-.68 1.29-1.13 2.2-1.13c1.49 0 2.7 1.22 2.7 2.72c0 1.5-1.21 2.7-2.7 2.7c-.91 0-1.7-.45-2.2-1.13v.01c-.49-.64-1.38-1.05-2.24-1.05H4.13h.02s-.89-.03-1.43.72C2.3 9.42 2 10.85 2 12c0 1.16.17 2.21.72 3.27c.47.76 1.43.73 1.43.73h-.04h6.03c.86 0 1.75-.42 2.24-1.07v.01c.5-.68 1.29-1.13 2.2-1.13c1.49 0 2.7 1.22 2.7 2.69c0 1.5-1.21 2.73-2.7 2.73c-.91 0-1.7-.45-2.2-1.13v.02c-.49-.65-1.38-1.07-2.24-1.07h-5.5c-.28.04-.58.17-.32.59c1.85 1.94 4.63 3.18 7.74 3.18c5.05 0 9.22-3.25 9.94-7.51c0-.59-.41-.73-.62-.75"/>'
        },
        dna: {
            body: '<path fill="currentColor" d="M4 2h2v2c0 1.44.68 2.61 1.88 3.78c.86.83 2.01 1.63 3.21 2.42l-1.83 1.19C8.27 10.72 7.31 10 6.5 9.21C5.07 7.82 4 6.1 4 4V2m14 0h2v2c0 2.1-1.07 3.82-2.5 5.21c-1.41 1.38-3.21 2.52-4.96 3.63c-1.75 1.12-3.45 2.21-4.66 3.38C6.68 17.39 6 18.56 6 20v2H4v-2c0-2.1 1.07-3.82 2.5-5.21c1.41-1.38 3.21-2.52 4.96-3.63c1.75-1.12 3.45-2.21 4.66-3.38C17.32 6.61 18 5.44 18 4V2m-3.26 10.61c.99.67 1.95 1.39 2.76 2.18C18.93 16.18 20 17.9 20 20v2h-2v-2c0-1.44-.68-2.61-1.88-3.78c-.86-.83-2.01-1.63-3.21-2.42l1.83-1.19M7 3h10v1l-.06.5H7.06L7 4V3m.68 3h8.64c-.24.34-.52.69-.9 1.06l-.51.44H9.07l-.49-.44c-.38-.37-.66-.72-.9-1.06m1.41 10.5h5.84l.49.44c.38.37.66.72.9 1.06H7.68c.24-.34.52-.69.9-1.06l.51-.44m-2.03 3h9.88l.06.5v1H7v-1l.06-.5Z"/>'
        },
        dns: {
            body: '<path fill="currentColor" d="M7 9a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m13-6H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M7 19a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m13-6H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Z"/>'
        },
        "dns-outline": {
            body: '<path fill="currentColor" d="M19 15v4H5v-4h14m1-2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M7 18.5A1.5 1.5 0 0 1 5.5 17A1.5 1.5 0 0 1 7 15.5A1.5 1.5 0 0 1 8.5 17A1.5 1.5 0 0 1 7 18.5M19 5v4H5V5h14m1-2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M7 8.5A1.5 1.5 0 0 1 5.5 7A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 8.5 7A1.5 1.5 0 0 1 7 8.5Z"/>'
        },
        "do-not-disturb": {
            body: '<path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m5 11H7v-2h10v2z" fill="currentColor"/>',
            hidden: true
        },
        "dock-bottom": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 9H4V6h16Z"/>'
        },
        "dock-left": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 14H9V6h11Z"/>'
        },
        "dock-right": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-5 14H4V6h11Z"/>'
        },
        "dock-top": {
            body: '<path fill="currentColor" d="M4 20h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2m0-9h16v7H4v-7Z"/>'
        },
        "dock-window": {
            body: '<path fill="currentColor" d="M18 18v2H4a2 2 0 0 1-2-2V8h2v10M22 6v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2m-2 0H8v8h12Z"/>'
        },
        docker: {
            body: '<path fill="currentColor" d="M21.81 10.25c-.06-.04-.56-.43-1.64-.43c-.28 0-.56.03-.84.08c-.21-1.4-1.38-2.11-1.43-2.14l-.29-.17l-.18.27c-.24.36-.43.77-.51 1.19c-.2.8-.08 1.56.33 2.21c-.49.28-1.29.35-1.46.35H2.62c-.34 0-.62.28-.62.63c0 1.15.18 2.3.58 3.38c.45 1.19 1.13 2.07 2 2.61c.98.6 2.59.94 4.42.94c.79 0 1.61-.07 2.42-.22c1.12-.2 2.2-.59 3.19-1.16A8.3 8.3 0 0 0 16.78 16c1.05-1.17 1.67-2.5 2.12-3.65h.19c1.14 0 1.85-.46 2.24-.85c.26-.24.45-.53.59-.87l.08-.24l-.19-.14m-17.96.99h1.76c.08 0 .16-.07.16-.16V9.5c0-.08-.07-.16-.16-.16H3.85c-.09 0-.16.07-.16.16v1.58c.01.09.07.16.16.16m2.43 0h1.76c.08 0 .16-.07.16-.16V9.5c0-.08-.07-.16-.16-.16H6.28c-.09 0-.16.07-.16.16v1.58c.01.09.07.16.16.16m2.47 0h1.75c.1 0 .17-.07.17-.16V9.5c0-.08-.06-.16-.17-.16H8.75c-.08 0-.15.07-.15.16v1.58c0 .09.06.16.15.16m2.44 0h1.77c.08 0 .15-.07.15-.16V9.5c0-.08-.06-.16-.15-.16h-1.77c-.08 0-.15.07-.15.16v1.58c0 .09.07.16.15.16M6.28 9h1.76c.08 0 .16-.09.16-.18V7.25c0-.09-.07-.16-.16-.16H6.28c-.09 0-.16.06-.16.16v1.57c.01.09.07.18.16.18m2.47 0h1.75c.1 0 .17-.09.17-.18V7.25c0-.09-.06-.16-.17-.16H8.75c-.08 0-.15.06-.15.16v1.57c0 .09.06.18.15.18m2.44 0h1.77c.08 0 .15-.09.15-.18V7.25c0-.09-.07-.16-.15-.16h-1.77c-.08 0-.15.06-.15.16v1.57c0 .09.07.18.15.18m0-2.28h1.77c.08 0 .15-.07.15-.16V5c0-.1-.07-.17-.15-.17h-1.77c-.08 0-.15.06-.15.17v1.56c0 .08.07.16.15.16m2.46 4.52h1.76c.09 0 .16-.07.16-.16V9.5c0-.08-.07-.16-.16-.16h-1.76c-.08 0-.15.07-.15.16v1.58c0 .09.07.16.15.16"/>'
        },
        doctor: {
            body: '<path fill="currentColor" d="M14.84 16.26C17.86 16.83 20 18.29 20 20v2H4v-2c0-1.71 2.14-3.17 5.16-3.74L12 21l2.84-4.74M8 8h8v2a4 4 0 0 1-4 4a4 4 0 0 1-4-4V8m0-1l.41-4.1a1 1 0 0 1 1-.9h5.19c.51 0 .94.39.99.9L16 7H8m4-4h-1v1h-1v1h1v1h1V5h1V4h-1V3Z"/>'
        },
        document: {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm2 4v2h10V7H7zm0 4v2h10v-2H7zm0 4v2h7v-2H7z" fill="currentColor"/>',
            hidden: true
        },
        dog: {
            body: '<path fill="currentColor" d="M18 4c-1.71 0-2.75.33-3.35.61C13.88 4.23 13 4 12 4s-1.88.23-2.65.61C8.75 4.33 7.71 4 6 4c-3 0-5 8-5 10c0 .83 1.32 1.59 3.14 1.9c.64 2.24 3.66 3.95 7.36 4.1v-4.28c-.59-.37-1.5-1.04-1.5-1.72c0-1 2-1 2-1s2 0 2 1c0 .68-.91 1.35-1.5 1.72V20c3.7-.15 6.72-1.86 7.36-4.1C21.68 15.59 23 14.83 23 14c0-2-2-10-5-10M4.15 13.87c-.5-.12-.89-.26-1.15-.37c.25-2.77 2.2-7.1 3.05-7.5c.54 0 .95.06 1.32.11c-2.1 2.31-2.93 5.93-3.22 7.76M9 12a1 1 0 0 1-1-1c0-.54.45-1 1-1a1 1 0 0 1 1 1c0 .56-.45 1-1 1m6 0a1 1 0 0 1-1-1c0-.54.45-1 1-1a1 1 0 0 1 1 1c0 .56-.45 1-1 1m4.85 1.87c-.29-1.83-1.12-5.45-3.22-7.76c.37-.05.78-.11 1.32-.11c.85.4 2.8 4.73 3.05 7.5c-.25.11-.64.25-1.15.37Z"/>'
        },
        "dog-service": {
            body: '<path fill="currentColor" d="m14 8l3 3v10h-2v-6H8l-2 3v3H4v-6l1-1v-3L2 8l1-1l2 2h2v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V9l1-1m5-3V3l-4 4l3 3l1-1l1 1l2-2l-3-3m-7.5 4.5l-7-7c-.27-.28-.71-.28-1 0c-.28.27-.28.71 0 1l7 7c.27.28.71.28 1 0c.28-.27.28-.71 0-1Z"/>'
        },
        "dog-side": {
            body: '<path fill="currentColor" d="m19 3l-4 4l3 3l1-1l1 1l2-2l-3-3V3M3 7L2 8l3 3v3l-1 1v6h2v-3l2-3h7v6h2V11l-3-3l-1 1H5L3 7Z"/>'
        },
        "dog-side-off": {
            body: '<path fill="currentColor" d="m18 10l-3-3l4-4v2l3 3l-2 2l-1-1l-1 1m-1 1l-3-3l-1 1h-.8l4.8 4.8V11M2.39 1.73L1.11 3l6 6H5L3 7L2 8l3 3v3l-1 1v6h2v-3l2-3h5.11L15 16.89V21h2v-2.11l3.84 3.84l1.27-1.27L2.39 1.73Z"/>'
        },
        dolby: {
            body: '<path fill="currentColor" d="M2 5v14h20V5H2m4 12H4V7h2c2.86.09 5.1 2.33 5 5c.1 2.67-2.14 4.91-5 5m14 0h-2c-2.86-.09-5.1-2.33-5-5c-.1-2.67 2.14-4.91 5-5h2v10Z"/>'
        },
        dolly: {
            body: '<path fill="currentColor" d="M11.97 19.88a2.01 2.01 0 0 1-2.57-1.19a1.97 1.97 0 0 1 1.19-2.56c1.04-.38 2.19.15 2.57 1.18a2.01 2.01 0 0 1-1.19 2.57M9.9 14.25c-2.07.75-3.14 3.05-2.4 5.13a4.043 4.043 0 0 0 5.16 2.37c2.07-.75 3.13-3.05 2.38-5.12c-.76-2.08-3.07-3.13-5.14-2.38m6.04-9.67L9.37 7l1.38 3.74l6.57-2.41m3 5.29l-4.78 1.75c.17.29.31.59.43.91c.12.32.2.65.25.97L21 15.5m-1.46-6.92l-8.45 3.1l.49 1.32c1.25.09 2.42.64 3.31 1.55l6.03-2.21M2 2v2h3.09l3.57 9.75a4.946 4.946 0 0 1 1.87-.69L6.5 2"/>'
        },
        dolphin: {
            body: '<path fill="currentColor" d="M20 7s0-4-5-4c-1.53 0-2.85.19-4 .5c-.5-.44-3.74-3.191-7 .07l2.56 2.56C2.5 10.53 4 18 4 18s-3 0-3 4l4-1l4 1c0-4-3-4-3-4s.85-5.76 7-6.82V14c2 0 2.68-1.81 2.89-3H18c4 0 5-1 5-2s-2-2-3-2m-2 1c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        domain: {
            body: '<path fill="currentColor" d="M18 15h-2v2h2m0-6h-2v2h2m2 6h-8v-2h2v-2h-2v-2h2v-2h-2V9h8M10 7H8V5h2m0 6H8V9h2m0 6H8v-2h2m0 6H8v-2h2M6 7H4V5h2m0 6H4V9h2m0 6H4v-2h2m0 6H4v-2h2m6-10V3H2v18h20V7H12Z"/>'
        },
        "domain-off": {
            body: '<path fill="currentColor" d="M12 19h4l-2-2h-2v2m-2-4v-2H8v2h2m0 4v-2H8v2h2m-4-8V9H4v2h2m0 4v-2H4v2h2m0 4v-2H4v2h2M1.31 1.78l21 20.91L21 24l-3-3H2V5L.09 3.09l1.22-1.31M16 11h2v2h-2v-2M8 5v.91L5.11 3H12v4h10v12.92l-2-2.01V9h-8v.89L9.09 7H10V5H8Z"/>'
        },
        "domain-plus": {
            body: '<path fill="currentColor" d="M12 7V3H2v18h11.35a5.8 5.8 0 0 1-.35-2h-1v-2h1.35a5 5 0 0 1 .65-1.31V15h-2v-2h2v-2h-2V9h8v4.09a5.58 5.58 0 0 1 2 .72V7M6 19H4v-2h2m0-2H4v-2h2m0-2H4V9h2m0-2H4V5h2m4 14H8v-2h2m0-2H8v-2h2m0-2H8V9h2m0-2H8V5h2m6 8h2v-2h-2m0 0v2h2v-2m-2 0v2h2v-2m2 4v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "domain-remove": {
            body: '<path fill="currentColor" d="M12 7V3H2v18h11.35a5.8 5.8 0 0 1-.35-2h-1v-2h1.35a5 5 0 0 1 .65-1.31V15h-2v-2h2v-2h-2V9h8v4.09a5.58 5.58 0 0 1 2 .72V7M6 19H4v-2h2m0-2H4v-2h2m0-2H4V9h2m0-2H4V5h2m4 14H8v-2h2m0-2H8v-2h2m0-2H8V9h2m0-2H8V5h2m6 8h2v-2h-2m0 0v2h2v-2m-2 0v2h2v-2m4.54 5.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.13-2.12l1.42-1.42L19 17.59l2.12-2.13Z"/>'
        },
        "dome-light": {
            body: '<path fill="currentColor" d="M21 10a9 9 0 0 1-18 0v-.97c0-.27.11-.53.3-.73c.2-.19.46-.3.73-.3H20c.25 0 .5.11.7.3c.19.2.3.45.3.7v1M5 10c0 3.86 3.14 7 7 7s7-3.14 7-7H5m15-4v1H4V6c0-.27.1-.5.29-.71C4.5 5.1 4.73 5 5 5h5V3h4v2h5c.25 0 .5.11.7.3c.19.2.3.45.3.7Z"/>'
        },
        "domino-mask": {
            body: '<path fill="currentColor" d="M15.83 9.81c-1.13-.11-2.14.57-2.37 1.69c0 .34 1.35.79 2.59.79c1.24 0 2.36-.79 2.36-1.01c0-.23-.78-1.35-2.58-1.47m-7.65 0c-1.8.12-2.59 1.13-2.59 1.46c0 .23 1.23 1.02 2.36 1.02s2.59-.45 2.59-.79c-.23-1.12-1.35-1.8-2.36-1.69M16.95 16c-1.91 0-3.15-2.25-4.95-2.25S8.85 16 7.05 16C4.69 16 3 13.86 3 10.04C3 7.68 3.68 7 6.71 7S10.54 8.24 12 8.24S14.36 7 17.29 7S21 7.79 21 10.04c0 3.82-1.69 5.96-4.05 5.96Z"/>'
        },
        donkey: {
            body: '<path fill="currentColor" d="m21.34 10.35l-.07-.07l-.09-.09L18 7V6a.5.5 0 0 0-.5-.5c-.14 0-.28.06-.37.16L13.46 9H7c-.68 0-1.31.35-1.68.92l-2.7 2.67c-.33.45-.23 1.07.22 1.41c.34.24.81.25 1.16 0l1-.93V19h3v-4h5v4h3v-5.17c0-.53.21-1.04.59-1.41L18 11l2 1c.15.08.32.13.5.13c.6-.02 1.09-.52 1.08-1.13c-.01-.24-.08-.47-.24-.65Z"/>'
        },
        door: {
            body: '<path fill="currentColor" d="M8 3c-1.11 0-2 .89-2 2v16h12V5c0-1.11-.89-2-2-2H8m0 2h8v14H8V5m5 6v2h2v-2h-2Z"/>'
        },
        "door-closed": {
            body: '<path fill="currentColor" d="M16 11h2v2h-2v-2m-4-8h7c1.11 0 2 .89 2 2v14h1v2H2v-2h8V5c0-1.11.89-2 2-2m0 2v14h7V5h-7Z"/>'
        },
        "door-closed-lock": {
            body: '<path fill="currentColor" d="M16 11h2v2h-2v-2m-4-8h7a2 2 0 0 1 2 2v14h1v2H2v-2h8V5a2 2 0 0 1 2-2m0 2v14h7V5M6.2 5H2.8v-.5a1.7 1.7 0 0 1 3.4 0M7 5v-.5a2.5 2.5 0 0 0-5 0V5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1"/>'
        },
        "door-open": {
            body: '<path fill="currentColor" d="M12 3c-1.11 0-2 .89-2 2H3v14H2v2h20v-2h-1V5c0-1.11-.89-2-2-2h-7m0 2h7v14h-7V5m-7 6h2v2H5v-2Z"/>'
        },
        "door-sliding": {
            body: '<path fill="currentColor" d="M10 13H8v-2h2v2m6-2h-2v2h2v-2m5 8v2H3v-2h1V5c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v14h1M11 5H6v14h5V5m7 0h-5v14h5V5Z"/>'
        },
        "door-sliding-lock": {
            body: '<path fill="currentColor" d="M21.8 17v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17M13 11h2v2h-2v-2m-4 2H7v-2h2v2m4 6h-1V5h5v6.44c.61-.27 1.29-.44 2-.44V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14H2v2h11v-2m-3 0H5V5h5v14Z"/>'
        },
        "door-sliding-open": {
            body: '<path fill="currentColor" d="M6 11v2H4v-2h2m16-6h-5v14h5V5M7 5H2v14h5V5m15-2c1.11 0 2 .89 2 2v16H0V5c0-1.11.894-2 2-2h7v16h6V3h7m-2 8h-2v2h2v-2Z"/>'
        },
        doorbell: {
            body: '<path fill="currentColor" d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m4-8H8c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H8V4h8v16Z"/>'
        },
        "doorbell-video": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m4-11v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2m-7.5 3c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5m5.5 3H8v10h8V10Z"/>'
        },
        "dot-net": {
            body: '<path fill="currentColor" d="M2 15a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m19 2h-2V9h-2V7h6v2h-2v8M16 7v2h-2v2h2v2h-2v2h2v2h-4V7h4m-5 0v10H9l-3-6v6H4V7h2l3 6V7h2Z"/>'
        },
        "dots-circle": {
            body: '<path fill="currentColor" d="M12 19c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-18c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2M6 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m-3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m12 12c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m-3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "dots-grid": {
            body: '<path fill="currentColor" d="M12 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2M6 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m12 12c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "dots-hexagon": {
            body: '<path fill="currentColor" d="M16 12c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m-6 0c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m-6 0c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m9 6c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m-6 0c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6-12c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2M7 6c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2"/>'
        },
        "dots-horizontal": {
            body: '<path fill="currentColor" d="M16 12a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2Z"/>'
        },
        "dots-horizontal-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 8.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m-5.5 0A1.5 1.5 0 0 0 5 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 8 12a1.5 1.5 0 0 0-1.5-1.5m11 0A1.5 1.5 0 0 0 16 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 19 12a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "dots-horizontal-circle-outline": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m0 6.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m-4.5 0A1.5 1.5 0 0 1 9 12a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 6 12a1.5 1.5 0 0 1 1.5-1.5m9 0A1.5 1.5 0 0 1 18 12a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 15 12a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "dots-square": {
            body: '<path fill="currentColor" d="M12 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-12c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2M6 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m12 12c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "dots-triangle": {
            body: '<path fill="currentColor" d="M12 16c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m-9 6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3-6c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m6 12c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2"/>'
        },
        "dots-vertical": {
            body: '<path fill="currentColor" d="M12 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "dots-vertical-circle": {
            body: '<path fill="currentColor" d="M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m8.5 0a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5m0 5.5A1.5 1.5 0 0 0 12 19a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 12 16a1.5 1.5 0 0 0-1.5 1.5m0-11A1.5 1.5 0 0 0 12 8a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 12 5a1.5 1.5 0 0 0-1.5 1.5Z"/>'
        },
        "dots-vertical-circle-outline": {
            body: '<path fill="currentColor" d="M10.5 12a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5m0 4.5A1.5 1.5 0 0 1 12 15a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 18a1.5 1.5 0 0 1-1.5-1.5m0-9A1.5 1.5 0 0 1 12 6a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 9a1.5 1.5 0 0 1-1.5-1.5M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        douban: {
            body: '<path d="M20 6H4V4h16v2m0 12v2H4v-2h3.33l-1.07-4H5V8h14v6h-1.26l-1.07 4H20M7 12h10v-2H7v2m2.4 6h5.2l1.07-4H8.33l1.07 4z" fill="currentColor"/>',
            hidden: true
        },
        download: {
            body: '<path fill="currentColor" d="M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7l7-7Z"/>'
        },
        "download-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m3 14h8v-2H8v2m8-7h-2.5V7h-3v3H8l4 4l4-4Z"/>'
        },
        "download-box-outline": {
            body: '<path fill="currentColor" d="M8 17v-2h8v2H8m8-7l-4 4l-4-4h2.5V7h3v3H16M5 3h14a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 2v14h14V5H5Z"/>'
        },
        "download-circle": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2M8 17h8v-2H8v2m8-7h-2.5V6h-3v4H8l4 4l4-4Z"/>'
        },
        "download-circle-outline": {
            body: '<path fill="currentColor" d="M8 17v-2h8v2H8m8-7l-4 4l-4-4h2.5V6h3v4H16m-4-8c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8Z"/>'
        },
        "download-lock": {
            body: '<path fill="currentColor" d="M5 20h9v-2H5m14-9h-4V3H9v6H5l7 7m10 0a1.08 1.08 0 0 1 1 1v4a1.08 1.08 0 0 1-1 1h-5a1.08 1.08 0 0 1-1-1v-4a1.08 1.08 0 0 1 1-1v-1.5a2.5 2.5 0 0 1 5 0V16m-1 0v-1.5a1.5 1.5 0 0 0-3 0V16h3"/>'
        },
        "download-lock-outline": {
            body: '<path fill="currentColor" d="M22 16a1.08 1.08 0 0 1 1 1v4a1.08 1.08 0 0 1-1 1h-5a1.08 1.08 0 0 1-1-1v-4a1.08 1.08 0 0 1 1-1v-1.5a2.5 2.5 0 0 1 5 0V16m-1 0v-1.5a1.5 1.5 0 0 0-3 0V16h3M13 5v6h1.17L12 13.17L9.83 11H11V5h2m2-2H9v6H5l7 7l7-7h-4V3m-1 15H5v2h9Z"/>'
        },
        "download-multiple": {
            body: '<path fill="currentColor" d="M9 1v6H5l7 7l7-7h-4V1H9M5 16v2h14v-2H5m0 4v2h14v-2H5Z"/>'
        },
        "download-network": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10m-5 11.5l4.5-4.5H13V6h-2v4H7.5l4.5 4.5Z"/>'
        },
        "download-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m5-1l4-4h-3V6h-2v4H8l4 4Z"/>'
        },
        "download-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.11 20H5v-2h11.11l-3.05-3.05L12 16L5 9h2.11l-6-6l1.28-1.27l19.72 19.73l-1.27 1.27M19 9h-4V3H9v2.8l6.6 6.6L19 9Z"/>'
        },
        "download-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l6 6H5l7 7l1.06-1.05L16.11 18H5v2h13.11l2.73 2.73l1.27-1.27M11 5h2v4.8l2.6 2.6L19 9h-4V3H9v2.8l2 2V5Z"/>'
        },
        "download-outline": {
            body: '<path fill="currentColor" d="M13 5v6h1.17L12 13.17L9.83 11H11V5h2m2-2H9v6H5l7 7l7-7h-4V3m4 15H5v2h14v-2Z"/>'
        },
        drag: {
            body: '<path fill="currentColor" d="M7 19v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m-8-4v-2h2v2H7m4 0v-2h2v2h-2m4 0v-2h2v2h-2m-8-4V9h2v2H7m4 0V9h2v2h-2m4 0V9h2v2h-2M7 7V5h2v2H7m4 0V5h2v2h-2m4 0V5h2v2h-2Z"/>'
        },
        "drag-horizontal": {
            body: '<path fill="currentColor" d="M3 15v-2h2v2H3m0-4V9h2v2H3m4 4v-2h2v2H7m0-4V9h2v2H7m4 4v-2h2v2h-2m0-4V9h2v2h-2m4 4v-2h2v2h-2m0-4V9h2v2h-2m4 4v-2h2v2h-2m0-4V9h2v2h-2Z"/>'
        },
        "drag-horizontal-variant": {
            body: '<path fill="currentColor" d="M21 11H3V9h18v2m0 2H3v2h18v-2Z"/>'
        },
        "drag-variant": {
            body: '<path fill="currentColor" d="m22.67 12l-4.49 4.5l-2.51-2.5l1.98-2l-1.98-1.96l2.51-2.51L22.67 12M12 1.33l4.47 4.49l-2.51 2.51L12 6.35l-2 1.98l-2.5-2.51L12 1.33m0 21.34l-4.47-4.49l2.51-2.51L12 17.65l2-1.98l2.5 2.51l-4.5 4.49M1.33 12l4.49-4.5L8.33 10l-1.98 2l1.98 1.96l-2.51 2.51L1.33 12M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "drag-vertical": {
            body: '<path fill="currentColor" d="M9 3h2v2H9V3m4 0h2v2h-2V3M9 7h2v2H9V7m4 0h2v2h-2V7m-4 4h2v2H9v-2m4 0h2v2h-2v-2m-4 4h2v2H9v-2m4 0h2v2h-2v-2m-4 4h2v2H9v-2m4 0h2v2h-2v-2Z"/>'
        },
        "drag-vertical-variant": {
            body: '<path fill="currentColor" d="M11 21H9V3h2v18m4-18h-2v18h2V3Z"/>'
        },
        "drama-masks": {
            body: '<path fill="currentColor" d="M8.11 19.45a6.948 6.948 0 0 1-4.4-5.1L2.05 6.54c-.24-1.08.45-2.14 1.53-2.37l9.77-2.07l.03-.01c1.07-.21 2.12.48 2.34 1.54l.35 1.67l4.35.93h.03c1.05.24 1.73 1.3 1.51 2.36l-1.66 7.82a6.993 6.993 0 0 1-8.3 5.38a6.888 6.888 0 0 1-3.89-2.34M20 8.18L10.23 6.1l-1.66 7.82v.03c-.57 2.68 1.16 5.32 3.85 5.89c2.69.57 5.35-1.15 5.92-3.84L20 8.18m-4 8.32a2.962 2.962 0 0 1-3.17 1.39a2.974 2.974 0 0 1-2.33-2.55L16 16.5M8.47 5.17L4 6.13l1.66 7.81l.01.03c.15.71.45 1.35.86 1.9c-.1-.77-.08-1.57.09-2.37l.43-2c-.45-.08-.84-.33-1.05-.69c.06-.61.56-1.15 1.25-1.31h.25l.78-3.81c.04-.19.1-.36.19-.52m6.56 7.06c.32-.53 1-.81 1.69-.66c.69.14 1.19.67 1.28 1.29c-.33.52-1 .8-1.7.64c-.69-.13-1.19-.66-1.27-1.27m-4.88-1.04c.32-.53.99-.81 1.68-.66c.67.14 1.2.68 1.28 1.29c-.33.52-1 .81-1.69.68c-.69-.17-1.19-.7-1.27-1.31m1.82-6.76l1.96.42l-.16-.8l-1.8.38Z"/>'
        },
        draw: {
            body: '<path fill="currentColor" d="M9.75 20.85c1.78-.7 1.39-2.63.49-3.85c-.89-1.25-2.12-2.11-3.36-2.94A9.817 9.817 0 0 1 4.54 12c-.28-.33-.85-.94-.27-1.06c.59-.12 1.61.46 2.13.68c.91.38 1.81.82 2.65 1.34l1.01-1.7C8.5 10.23 6.5 9.32 4.64 9.05c-1.06-.16-2.18.06-2.54 1.21c-.32.99.19 1.99.77 2.77c1.37 1.83 3.5 2.71 5.09 4.29c.34.33.75.72.95 1.18c.21.44.16.47-.31.47c-1.24 0-2.79-.97-3.8-1.61l-1.01 1.7c1.53.94 4.09 2.41 5.96 1.79m11.09-15.6c.22-.22.22-.58 0-.79l-1.3-1.3a.562.562 0 0 0-.78 0l-1.02 1.02l2.08 2.08M11 10.92V13h2.08l6.15-6.15l-2.08-2.08L11 10.92Z"/>'
        },
        "draw-pen": {
            body: '<path fill="currentColor" d="M9.75 20.85c1.78-.7 1.39-2.63.49-3.85c-.89-1.25-2.12-2.11-3.36-2.94A9.817 9.817 0 0 1 4.54 12c-.28-.33-.85-.94-.27-1.06c.59-.12 1.61.46 2.13.68c.91.38 1.81.82 2.65 1.34l1.01-1.7C8.5 10.23 6.5 9.32 4.64 9.05c-1.06-.16-2.18.06-2.54 1.21c-.32.99.19 1.99.77 2.77c1.37 1.83 3.5 2.71 5.09 4.29c.34.33.75.72.95 1.18c.21.44.16.47-.31.47c-1.24 0-2.79-.97-3.8-1.61l-1.01 1.7c1.53.94 4.09 2.41 5.96 1.79m9.21-13.52L13.29 13H11v-2.29l5.67-5.68l2.29 2.3m3.4-.78c-.01.3-.32.61-.64.92L19.2 10l-.87-.87l2.6-2.59l-.59-.59l-.67.67l-2.29-2.29l2.15-2.15c.24-.24.63-.24.86 0l1.43 1.43c.24.22.24.62 0 .86c-.21.21-.41.41-.41.61c-.02.2.18.42.38.59c.29.3.58.58.57.88Z"/>'
        },
        drawing: {
            body: '<path fill="currentColor" d="M8.5 3A5.5 5.5 0 0 1 14 8.5c0 1.33-.47 2.55-1.26 3.5H21v9h-9v-8.26c-.95.79-2.17 1.26-3.5 1.26A5.5 5.5 0 0 1 3 8.5A5.5 5.5 0 0 1 8.5 3Z"/>'
        },
        "drawing-box": {
            body: '<path fill="currentColor" d="M18 18h-6v-5.79c-.66.61-1.53.99-2.5.99c-2.04 0-3.7-1.66-3.7-3.7a3.7 3.7 0 0 1 3.7-3.7c2.04 0 3.7 1.66 3.7 3.7c0 .97-.38 1.84-.99 2.5H18m1-9H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        dresser: {
            body: '<path fill="currentColor" d="M4 3c-1.1 0-2 .9-2 2v3h20V5a2 2 0 0 0-2-2H4m6 2h4v1h-4V5M2 9v5h20V9H2m8 2h4v1h-4v-1m-8 4v3a2 2 0 0 0 2 2v1h2v-1h12v1h2v-1c1.11 0 2-.89 2-2v-3H2m8 2h4v1h-4v-1Z"/>'
        },
        "dresser-outline": {
            body: '<path fill="currentColor" d="M4 3c-1.1 0-2 .9-2 2v13a2 2 0 0 0 2 2v1h2v-1h12v1h2v-1c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2H4m0 2h16v3H4V5m6 1v1h4V6h-4m-6 4h16v3H4v-3m6 1v1h4v-1h-4m-6 4h16v3H4v-3m6 1v1h4v-1h-4Z"/>'
        },
        dribbble: {
            body: '<path d="M16.42 18.42A57.5 57.5 0 0 0 15 13.17c.5-.07 1-.11 1.58-.11h.02c.93 0 1.95.12 3.06.37a7.788 7.788 0 0 1-3.24 4.99M12 19.8c-1.74 0-3.34-.57-4.64-1.54c.28-.45.87-1.32 1.82-2.22c.96-.93 2.32-1.89 4.05-2.46c.59 1.67 1.13 3.57 1.54 5.71c-.86.33-1.77.51-2.77.51M4.2 12v-.11c.22.01.51.01.85.01h.01c1.56-.01 4.3-.14 7.08-1.01c.15.33.3.67.45 1.03c-1.86.62-3.32 1.61-4.4 2.58c-1.03.96-1.74 1.89-2.15 2.5a7.704 7.704 0 0 1-1.84-5m4.35-7c.55.65 1.63 2.06 2.79 4.25c-2.34.71-4.73.87-6.16.87h-.13c-.24 0-.45 0-.62-.01C5 7.87 6.5 6 8.55 5M12 4.2c1.84 0 3.53.64 4.86 1.71C15.84 7.14 14.5 8 13.03 8.65C12 6.67 11 5.25 10.34 4.38c.54-.11 1.09-.18 1.66-.18m6.13 2.98a7.823 7.823 0 0 1 1.66 4.45a15.32 15.32 0 0 0-3.19-.35h-.01c-.8 0-1.55.07-2.26.19c-.17-.42-.33-.82-.52-1.21c1.58-.69 3.09-1.68 4.32-3.08M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2z" fill="currentColor"/>',
            hidden: true
        },
        "dribbble-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m10.09 13.5c-.28-1.36-.62-2.59-1.01-3.68l1.12-.08h.02c.65 0 1.37.08 2.14.26a5.49 5.49 0 0 1-2.27 3.5m-3.09.96c-1.21 0-2.34-.4-3.24-1.07c.19-.32.6-.93 1.24-1.56c.7-.65 1.64-1.33 2.86-1.72c.42 1.16.79 2.49 1.08 3.99c-.61.23-1.26.36-1.94.36M6.54 12v-.08l.6.01c1.1 0 3.01-.1 4.96-.71l.31.72c-1.3.44-2.32 1.13-3.07 1.82c-.73.66-1.22 1.32-1.51 1.74c-.8-.94-1.29-2.16-1.29-3.5m3.05-4.89c.38.45 1.14 1.43 1.95 2.97c-1.65.49-3.31.6-4.32.6H6.7a5.47 5.47 0 0 1 2.89-3.57M12 6.54c1.29 0 2.47.46 3.41 1.2c-.72.86-1.67 1.48-2.69 1.92a19.89 19.89 0 0 0-1.88-2.99c.37-.08.76-.13 1.16-.13m4.29 2.09c.68.87 1.11 1.94 1.16 3.11c-.79-.16-1.53-.24-2.23-.24c-.56 0-1.09.04-1.59.13l-.36-.85c1.1-.48 2.16-1.17 3.02-2.15M12 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7a7 7 0 0 0 7-7a7 7 0 0 0-7-7z" fill="currentColor"/>',
            hidden: true
        },
        drone: {
            body: '<path fill="currentColor" d="M22 11h-1l-1-2h-6.25L16 12.5h-2L10.75 9H4c-.55 0-2-.45-2-1s1.5-2.5 3.5-2.5S7.67 6.5 9 7h12a1 1 0 0 1 1 1v3M10.75 6.5L14 3h2l-2.25 3.5h-3M18 11V9.5h1.75L19 11h-1M3 19a1 1 0 0 1-1-1a1 1 0 0 1 1-1a4 4 0 0 1 4 4a1 1 0 0 1-1 1a1 1 0 0 1-1-1a2 2 0 0 0-2-2m8 2a1 1 0 0 1-1 1a1 1 0 0 1-1-1a6 6 0 0 0-6-6a1 1 0 0 1-1-1a1 1 0 0 1 1-1a8 8 0 0 1 8 8Z"/>'
        },
        dropbox: {
            body: '<path fill="currentColor" d="m3 6.2l5 3.19l5-3.19L8 3L3 6.2m10 0l5 3.19l5-3.19L18 3l-5 3.2M3 12.55l5 3.19l5-3.19l-5-3.2l-5 3.2m15-3.2l-5 3.2l5 3.19l5-3.19l-5-3.2M8.03 16.8l5.01 3.2l5-3.2l-5-3.19l-5.01 3.19Z"/>'
        },
        drupal: {
            body: '<path fill="currentColor" d="M20.47 14.65c0 .64-.22 1.71-.64 2.45c-.43.75-.75.96-1.39.96c-.74-.11-2.13-2.24-3.08-2.34c-1.18 0-3.63 2.45-5.65 2.45c-1.17 0-1.6-.22-1.92-.43c-.64-.43-.85-1.07-.85-1.92c0-1.6 1.49-2.98 3.3-2.98c2.35 0 3.94 2.34 5.12 2.24c.95 0 2.87-1.92 3.83-1.92c.96-.21 1.28.84 1.28 1.49m-3.84-9.37c-1.06-.64-2.02-.96-3.09-1.6c-.63-.43-1.49-1.38-2.23-2.24c-.31 1.39-.53 1.92-1.07 2.35c-1.06.74-1.6 1.06-2.55 1.49C6.94 5.7 3 8.05 3 13.16C3 18.27 7.37 22 12.05 22c4.8 0 8.95-3.5 8.95-8.73c.21-5.22-3.73-7.57-4.37-7.99Z"/>'
        },
        duck: {
            body: '<path fill="currentColor" d="M8.5 5A1.5 1.5 0 0 0 7 6.5A1.5 1.5 0 0 0 8.5 8A1.5 1.5 0 0 0 10 6.5A1.5 1.5 0 0 0 8.5 5M10 2a5 5 0 0 1 5 5c0 1.7-.85 3.2-2.14 4.1c1.58.15 3.36.51 5.14 1.4c3 1.5 4-.5 4-.5s-1 9-7 9H9s-5 0-5-5c0-3 3-4 2-6c-4 0-4-3.5-4-3.5c1 .5 2.24.5 3 .15A5.02 5.02 0 0 1 10 2Z"/>'
        },
        dumbbell: {
            body: '<path fill="currentColor" d="M20.57 14.86L22 13.43L20.57 12L17 15.57L8.43 7L12 3.43L10.57 2L9.14 3.43L7.71 2L5.57 4.14L4.14 2.71L2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57L3.43 12L7 8.43L15.57 17L12 20.57L13.43 22l1.43-1.43L16.29 22l2.14-2.14l1.43 1.43l1.43-1.43l-1.43-1.43L22 16.29l-1.43-1.43Z"/>'
        },
        "dump-truck": {
            body: '<path fill="currentColor" d="M20 8h-5v6H2v3h1a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4M6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5m12 0a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5M17 12V9.5h2.5l1.96 2.5H17m1-5h-4v6H3L1.57 8H1V6h12l1-1h4v2Z"/>'
        },
        "ear-hearing": {
            body: '<path fill="currentColor" d="M17 20c-.29 0-.56-.06-.76-.15c-.71-.35-1.21-.88-1.71-2.38c-.53-1.56-1.47-2.29-2.39-3c-.79-.61-1.61-1.24-2.32-2.53C9.29 11 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9c.93 1.65 1.98 2.48 2.85 3.15c.81.62 1.39 1.07 1.71 2.05c.6 1.82 1.37 2.84 2.73 3.55c.51.23 1.07.35 1.64.35a4 4 0 0 0 4-4h-2a2 2 0 0 1-2 2M7.64 2.64L6.22 1.22A10.965 10.965 0 0 0 3 9c0 3.04 1.23 5.79 3.22 7.78l1.41-1.41A8.952 8.952 0 0 1 5 9c0-2.5 1-4.74 2.64-6.36M11.5 9a2.5 2.5 0 0 0 2.5 2.5A2.5 2.5 0 0 0 16.5 9A2.5 2.5 0 0 0 14 6.5A2.5 2.5 0 0 0 11.5 9Z"/>'
        },
        "ear-hearing-loop": {
            body: '<path fill="currentColor" d="M12 6.5a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5M16 17v2h2v4h2v-4h2v-2h-6m-4.31-3.53L3.67 22L2.4 20.73l7.35-7.86c.58.34 1.25.55 1.94.6M19 9c0 1.26-.38 2.65-1.07 3.9c-.93 1.65-1.98 2.48-2.85 3.15c-.81.62-1.39 1.07-1.71 2.05c-.6 1.82-1.37 2.84-2.73 3.55c-.51.23-1.07.35-1.64.35c-1.19 0-2.25-.53-3-1.35l1.43-1.43a1.98 1.98 0 0 0 2.33.63c.71-.35 1.21-.88 1.71-2.38c.53-1.56 1.47-2.29 2.39-3c.79-.61 1.61-1.24 2.32-2.53C16.71 11 17 9.93 17 9c0-2.8-2.2-5-5-5S7 6.2 7 9H5c0-3.93 3.07-7 7-7s7 3.07 7 7m-.63-4.88l2.35-2.39L22 3l-2.68 2.72c-.26-.57-.58-1.11-.95-1.6Z"/>'
        },
        "ear-hearing-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L20 20.72L18.73 22l-5.82-5.82c-.72.56-1.24 1.01-1.54 1.92c-.6 1.82-1.37 2.84-2.73 3.55c-.51.23-1.07.35-1.64.35a4 4 0 0 1-4-4h2a2 2 0 0 0 2 2c.29 0 .56-.06.76-.15c.71-.35 1.21-.88 1.71-2.38c.44-1.35 1.22-2.08 2.03-2.71L5.04 8.31C5 8.54 5 8.77 5 9H3c0-.83.14-1.61.39-2.34L1 4.27m13.18 7.67C14.71 11 15 9.93 15 9c0-2.8-2.2-5-5-5c-1.19 0-2.26.39-3.11 1.06L5.46 3.63C6.67 2.61 8.25 2 10 2c3.93 0 7 3.07 7 7c0 1.26-.38 2.65-1.07 3.9l-.46.75l-1.44-1.45l.15-.26m2.18-9.3l1.42-1.42C19.77 3.21 21 5.96 21 9c0 2.83-1.07 5.41-2.82 7.36l-1.41-1.42A9.01 9.01 0 0 0 19 9c0-2.5-1-4.74-2.64-6.36M12.5 9c0 .5-.14.93-.37 1.31L8.69 6.87c.38-.23.81-.37 1.31-.37A2.5 2.5 0 0 1 12.5 9Z"/>'
        },
        earbuds: {
            body: '<path fill="currentColor" d="M10 8v12c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-6.73c-.68.45-1.39.73-2 .73c-2 0-3-2-3-3V6c0-1 1-3 3-3s5 3 5 5m6.5-5C13.46 3 11 5.46 11 8.5s2.46 5.5 5.5 5.5S22 11.54 22 8.5S19.54 3 16.5 3m-2 11.68V20c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-5.32c-.63.21-1.3.32-2 .32s-1.37-.11-2-.32Z"/>'
        },
        "earbuds-off": {
            body: '<path fill="currentColor" d="m10 9.34l1.56 1.57v-.01l2.54 2.55l-.01-.01l1.49 1.49h.01l2.91 2.91v.01l3.61 3.61l-1.27 1.27l-2.41-2.4c-.13.39-.49.67-.93.67h-2c-.55 0-1-.45-1-1v-3.61l-4.5-4.5V20c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-6.73c-.68.45-1.39.73-2 .73c-2 0-3-2-3-3V6c0-.42.19-1 .55-1.57L1.11 3l1.28-1.27L6.1 5.44M22 8.5C22 5.46 19.54 3 16.5 3c-2.81 0-5.13 2.12-5.46 4.84l6.12 6.12A5.496 5.496 0 0 0 22 8.5Z"/>'
        },
        "earbuds-off-outline": {
            body: '<path fill="currentColor" d="m22.11 21.46l-3.61-3.61v-.01l-2.92-2.91l-1.49-1.49h.01l-2.54-2.54L10 9.34l-3-3L6.66 6h.01l-.57-.56l-3.71-3.71L1.11 3l1.44 1.43C2.19 5 2 5.58 2 6v5c0 1 1 3 3 3c.61 0 1.32-.28 2-.73V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8.11l4.5 4.5V20c0 .55.45 1 1 1h2c.44 0 .8-.28.93-.68l2.41 2.41l1.27-1.27M8 10.23L5.91 11.6c-.51.33-.83.4-.91.4c-.7 0-1-.92-1-1V6.03c0-.03 0-.06.03-.11L8 9.89v.34m5.53.1l-2.49-2.49C11.37 5.12 13.69 3 16.5 3C19.54 3 22 5.46 22 8.5c0 2.82-2.11 5.13-4.84 5.46l-2.49-2.49c.53.33 1.16.53 1.83.53c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5S13 6.57 13 8.5c0 .67.2 1.3.53 1.83Z"/>'
        },
        "earbuds-outline": {
            body: '<path fill="currentColor" d="M5 3C3 3 2 5 2 6v5c0 1 1 3 3 3c.61 0 1.32-.28 2-.73V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8c0-2-3-5-5-5m3 7.23L5.91 11.6c-.51.33-.83.4-.91.4c-.7 0-1-.92-1-1V6.03C4 5.92 4.3 5 5 5c.9 0 3 2.1 3 3v2.23M16.5 15c.7 0 1.37-.11 2-.32V20c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-5.32c.63.21 1.3.32 2 .32m0-12C13.46 3 11 5.46 11 8.5s2.46 5.5 5.5 5.5S22 11.54 22 8.5S19.54 3 16.5 3m0 9c-1.93 0-3.5-1.57-3.5-3.5S14.57 5 16.5 5S20 6.57 20 8.5S18.43 12 16.5 12Z"/>'
        },
        earth: {
            body: '<path fill="currentColor" d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M11 19.93c-3.95-.49-7-3.85-7-7.93c0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "earth-arrow-right": {
            body: '<path fill="currentColor" d="M19 21v-2h-4v-2h4v-2l3 3l-3 3m-7-3c0-2.2 1.2-4.1 3-5.2c-.1-.5-.5-.8-1-.8H8v-2h2c.6 0 1-.4 1-1V7h2c1.1 0 2-.9 2-2v-.4c2.9 1.2 5 4 5 7.4v.3c.7.2 1.3.6 1.9 1.1c.1-.4.1-.9.1-1.4c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10c.5 0 1 0 1.4-.1c-.9-1.1-1.4-2.4-1.4-3.9m-1 1.9c-4-.5-7-3.8-7-7.9c0-.6.1-1.2.2-1.8L9 15v1c0 1.1.9 2 2 2v1.9Z"/>'
        },
        "earth-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m10.78 2H19v12.18c-.26-.8-1.31-1.39-2.2-1.39h-1v-3a1 1 0 0 0-1-1h-6v-2h2a1 1 0 0 0 1-1v-2h2c1.03 0 1.87-.79 1.98-1.79M5 10.29l4.8 4.5v1a2 2 0 0 0 2 2V19H5v-8.71Z"/>'
        },
        "earth-box-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8M5 3h14a2 2 0 0 1 2 2v7.8c-.61-.35-1.28-.6-2-.72V5h-3.22c-.11 1-.95 1.79-1.98 1.79h-2v2c0 .56-.45 1-1 1h-2v2h6c.43 0 .8.27.94.65A6.013 6.013 0 0 0 12 17.83c-1.3-.04-2.2-.93-2.2-2.04v-1L5 10.29V19h7.08c.12.72.37 1.39.72 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2Z"/>'
        },
        "earth-box-off": {
            body: '<path fill="currentColor" d="m23 4.27l-2 2V19a2 2 0 0 1-2 2H6.27l-2 2L3 21.72L21.72 3L23 4.27M5 3h14.18l-2 2h-1.4c-.11 1-.95 1.79-1.98 1.79h-2v2c0 .56-.45 1-1 1h-2v2h1.58l-1.83 1.83L5 10.29v6.89l-2 2V5c0-1.11.89-2 2-2m6.8 16v-1.21c-.63 0-1.2-.29-1.57-.75L8.27 19h3.53m4-6.21v3h1c.89 0 1.94.59 2.2 1.39V8.27l-3.67 3.67c.28.18.47.49.47.85Z"/>'
        },
        "earth-box-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M5 3h14a2 2 0 0 1 2 2v7.8c-.61-.35-1.28-.6-2-.72V5h-3.22c-.11 1-.95 1.79-1.98 1.79h-2v2c0 .56-.45 1-1 1h-2v2h6c.43 0 .8.27.94.65A6.013 6.013 0 0 0 12 17.83c-1.3-.04-2.2-.93-2.2-2.04v-1L5 10.29V19h7.08c.12.72.37 1.39.72 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2Z"/>'
        },
        "earth-box-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.12-2.12M5 3h14a2 2 0 0 1 2 2v7.8c-.61-.35-1.28-.6-2-.72V5h-3.22c-.11 1-.95 1.79-1.98 1.79h-2v2c0 .56-.45 1-1 1h-2v2h6c.43 0 .8.27.94.65A6.013 6.013 0 0 0 12 17.83c-1.3-.04-2.2-.93-2.2-2.04v-1L5 10.29V19h7.08c.12.72.37 1.39.72 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2Z"/>'
        },
        "earth-minus": {
            body: '<path fill="currentColor" d="M14 17h8v2h-8v-2m6-5c0-3.36-2.07-6.23-5-7.41V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h6c.5 0 .9.35 1 .81c-1.8 1.04-3 2.98-3 5.19c0 1.5.54 2.85 1.44 3.9L12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10l-.1 1.44c-.56-.48-1.2-.85-1.9-1.1V12m-9 7.93V18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.78 4 11.38 4 12c0 4.08 3.06 7.44 7 7.93Z"/>'
        },
        "earth-off": {
            body: '<path fill="currentColor" d="m22 5.27l-1.5 1.48C21.46 8.28 22 10.07 22 12a10 10 0 0 1-10 10c-1.92 0-3.72-.54-5.25-1.5L5.27 22L4 20.72L20.72 4L22 5.27m-4.1 12.12C19.2 15.97 20 14.08 20 12c0-1.37-.34-2.66-.95-3.78l-4.22 4.22c.11.16.17.35.17.56v3h1c.89 0 1.64.59 1.9 1.39M11 19.93V18c-.5 0-.93-.17-1.27-.46l-1.51 1.51c.85.45 1.78.75 2.78.88m4-15.34V5a2 2 0 0 1-2 2h-2v2a1 1 0 0 1-1 1H8v2h2.18l-2.09 2.09l-3.88-3.88C4.08 10.78 4 11.38 4 12c0 1.74.56 3.36 1.5 4.67L4.08 18.1A9.903 9.903 0 0 1 2 12A10 10 0 0 1 12 2c2.3 0 4.41.77 6.1 2.08L16.67 5.5A8.15 8.15 0 0 0 15 4.59Z"/>'
        },
        "earth-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3m3-2c0-3.36-2.07-6.23-5-7.41V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h6c.5 0 .9.35 1 .81c-1.8 1.04-3 2.98-3 5.19c0 1.5.54 2.85 1.44 3.9L12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10l-.1 1.44c-.56-.48-1.2-.85-1.9-1.1V12m-9 7.93V18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.78 4 11.38 4 12c0 4.08 3.06 7.44 7 7.93Z"/>'
        },
        "earth-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.12-2.12M20 12c0-3.36-2.07-6.23-5-7.41V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h6c.5 0 .9.35 1 .81c-1.8 1.04-3 2.98-3 5.19c0 1.5.54 2.85 1.44 3.9L12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10l-.1 1.44c-.56-.48-1.2-.85-1.9-1.1V12m-9 7.93V18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.78 4 11.38 4 12c0 4.08 3.06 7.44 7 7.93Z"/>'
        },
        ebay: {
            body: '<path d="M3.805 10.507c-.816 0-1.643.517-1.643 1.422h3.205c0-.853-.633-1.422-1.562-1.422zm.04-.741c2.06 0 2.66 1.35 2.684 2.265V7.842H7.65v2.765s.476-.826 2.006-.826c1.634 0 2.602 1.154 2.602 2.59c0 .175-.013.344-.04.507c.264-.742 1.18-1.109 2.684-1.109h1.363v-.24c0-.676-.595-1.027-1.363-1.027c-1.18 0-1.241.746-1.241.746h-1.162c0-.204.15-1.482 2.484-1.482c.795 0 1.665.166 2.108.82l-.33-.62h1.307l1.876 3.759l1.872-3.759H23l-3.41 6.691H18.35l.983-1.865l-2.089-3.92c.092.224.144.492.144.81v2.416c0 .28.04.716.04.716h-1.033s-.028-.352-.028-.71c0 0-.524.9-2.15.9c-1.195 0-2.078-.576-2.078-1.632c0-.06.003-.117.009-.173c-.31 1.086-1.239 1.79-2.493 1.79c-1.473 0-2.015-.847-2.015-.847c0 .321-.04.672-.04.672H6.505s.025-.489.025-.837V12.67H2.137c0 .924.702 1.583 1.678 1.583c1.198 0 1.445-.841 1.445-.841h1.15s-.153 1.562-2.525 1.562C1.87 14.974 1 13.984 1 12.41c0-1.986 1.293-2.644 2.845-2.644zm5.528.774c-1.178 0-1.723.934-1.723 1.84c0 .973.607 1.85 1.73 1.85c.943 0 1.716-.735 1.716-1.86c0-1.049-.67-1.83-1.723-1.83zm6.892 1.95c-1.764 0-2.965.006-2.965.882c0 .481.356.896 1.188.896c1.519 0 1.777-1.04 1.777-1.457v-.32z" fill="currentColor"/>',
            hidden: true
        },
        egg: {
            body: '<path fill="currentColor" d="M19.5 14.5A7.5 7.5 0 0 1 12 22a7.5 7.5 0 0 1-7.5-7.5C4.5 10.36 7.86 2 12 2c4.14 0 7.5 8.36 7.5 12.5Z"/>'
        },
        "egg-easter": {
            body: '<path fill="currentColor" d="M6.89 6.36C8.23 3.91 10 2 12 2c2 0 3.77 1.91 5.11 4.36c-.85.21-1.61.71-2.11 1.41a3.712 3.712 0 0 0-5.2-.8c-.3.22-.58.49-.8.8c-.5-.7-1.26-1.2-2.11-1.41M15 18.06l-3-3l-3 3l-3-3l-1.27 1.27a7.504 7.504 0 0 0 9.11 5.43a7.529 7.529 0 0 0 5.43-5.43L18 15.06l-3 3m-6-2.12l3-3l3 3l3-3l1.5 1.5c-.13-2.31-.7-4.58-1.69-6.68c-1.16.1-2.06 1.07-2.06 2.24h-1.5A2.25 2.25 0 0 0 12 7.75A2.25 2.25 0 0 0 9.75 10h-1.5c0-1.17-.9-2.14-2.06-2.24c-.99 2.1-1.56 4.37-1.69 6.68l1.5-1.5l3 3Z"/>'
        },
        "egg-fried": {
            body: '<path fill="currentColor" d="M12 4.5c2.17 0 2.58.57 3.5 1.82c.38.53.82 1.12 1.44 1.74c.49.49.92.87 1.27 1.18c1.09.95 1.29 1.12 1.29 2.76c0 2.93 0 3.38-1.56 4.94C16 18.86 15.38 19.5 13 19.5c-1.12 0-1.5-.32-2.11-.81c-.62-.5-1.46-1.19-2.89-1.19c-3.04 0-3.5-3.45-3.5-5.5c0-1.35.5-3.09 1.97-3.58c1.78-.59 2.73-1.71 3.49-2.61c.79-.93 1.15-1.31 2.04-1.31M12 3C9 3 9 6 6 7c-2.12.71-3 3-3 5c0 3 1 7 5 7c2 0 2 2 5 2s4-1 6-3s2-3 2-6s-1-3-3-5s-2-4-6-4m0 5c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 2c-1.1 0-2 .9-2 2H9c0-1.65 1.35-3 3-3v1Z"/>'
        },
        "egg-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l5 5c-1 2.3-1.6 4.8-1.6 6.5c0 4.1 3.4 7.5 7.5 7.5c2.2 0 4.2-1 5.6-2.5l3.2 3.2l1.3-1.2m-2.6-7C19.5 10.4 16.1 2 12 2c-1.5 0-2.9 1.1-4.1 2.7l11.4 11.4c.1-.5.2-1 .2-1.6Z"/>'
        },
        "egg-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L6.1 8c-1 2.28-1.6 4.76-1.6 6.5c0 4.14 3.36 7.5 7.5 7.5c2.23 0 4.22-1 5.59-2.5l3.25 3.23l1.27-1.27M12 20a5.51 5.51 0 0 1-5.5-5.5c0-1.42.45-3.25 1.13-5l8.54 8.56C15.16 19.24 13.67 20 12 20M9.36 6.16L7.92 4.72C9.1 3.11 10.5 2 12 2c4.14 0 7.5 8.36 7.5 12.5c0 .56-.07 1.1-.18 1.62l-1.82-1.83C17.38 10.46 14.28 4 12 4c-.83 0-1.78.87-2.64 2.16Z"/>'
        },
        "egg-outline": {
            body: '<path fill="currentColor" d="M12 4c2.32 0 5.5 6.7 5.5 10.5c0 3.03-2.47 5.5-5.5 5.5s-5.5-2.47-5.5-5.5C6.5 10.7 9.68 4 12 4m0-2c-4.14 0-7.5 8.36-7.5 12.5c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5C19.5 10.36 16.14 2 12 2Z"/>'
        },
        "eiffel-tower": {
            body: '<path fill="currentColor" d="M8.21 17c.44-.85.85-1.84 1.23-3H9v-2h1c.61-2.6 1-5.87 1-10h2c0 4.13.4 7.4 1 10h1v2h-.44c.38 1.16.79 2.15 1.23 3H17v2l2 3h-2.42c-.77-1.76-2.53-3-4.58-3c-2.05 0-3.81 1.24-4.58 3H5l2-3l-.03-2h1.24m4.38-3h-1.18a21.77 21.77 0 0 1-1.13 3h3.44c-.4-.87-.79-1.87-1.13-3Z"/>'
        },
        "eight-track": {
            body: '<path fill="currentColor" d="M7 2L5 5v11l1 4c.27 1.07.9 2 2 2h8a2 2 0 0 0 2-2l1-4V5l-2-3h-2v1h-2V2H7m0 4h10v10H7V6Z"/>'
        },
        eject: {
            body: '<path fill="currentColor" d="M12 5L5.33 15h13.34M5 17h14v2H5v-2Z"/>'
        },
        "eject-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m4.5 14h-9v-2h9v2m-9-4L12 6l4.5 6h-9Z"/>'
        },
        "eject-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.5-8L12 6l-4.5 6h9m0 4h-9v-2h9v2Z"/>'
        },
        "eject-outline": {
            body: '<path fill="currentColor" d="M5 17h14v2H5v-2m7-12L5.33 15h13.34L12 5m0 3.6l2.93 4.4H9.07L12 8.6Z"/>'
        },
        "electric-switch": {
            body: '<path fill="currentColor" d="M1 11h2.17C3.58 9.83 4.69 9 6 9c.65 0 1.25.21 1.74.56l6.7-4.69l1.14 1.63l-6.69 4.7c.07.25.11.52.11.8a3 3 0 0 1-3 3a2.99 2.99 0 0 1-2.83-2H1v-2m22 0v2h-2.17A2.99 2.99 0 0 1 18 15a3 3 0 0 1-3-3a3 3 0 0 1 3-3c1.31 0 2.42.83 2.83 2H23M6 11a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m12 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "electric-switch-closed": {
            body: '<path fill="currentColor" d="M20.83 11a3 3 0 0 0-5.65 0H8.82a3 3 0 0 0-5.65 0H1v2h2.17a3 3 0 0 0 5.65 0h6.36a3 3 0 0 0 5.65 0H23v-2M6 13a1 1 0 1 1 1-1a1 1 0 0 1-1 1m12 0a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "electron-framework": {
            body: '<path fill="currentColor" d="M12 22c-1.67 0-3.16-1.5-4.1-4.07c-.07-.2.03-.43.24-.49c.2-.08.42.03.49.23c.81 2.23 2.07 3.56 3.37 3.56c.94 0 1.87-.68 2.62-1.92a.386.386 0 0 1 .66.4C14.38 21.19 13.22 22 12 22m3.91-4.28a.36.36 0 0 1-.11-.02c-.21-.07-.3-.28-.26-.49c.46-1.4.68-3.03.68-4.71c0-3.85-1.25-7.26-3.03-8.36c-.25.36-.69.64-1.19.64c-.76 0-1.39-.62-1.39-1.39c0-.77.63-1.39 1.39-1.39c.77 0 1.4.61 1.41 1.37C15.53 4.5 17 8.21 17 12.5c0 1.75-.25 3.46-.72 4.95c-.05.16-.2.27-.37.27M12 2.77c-.34 0-.62.28-.62.62c0 .34.29.61.62.61c.35 0 .64-.27.64-.61c0-.34-.29-.62-.64-.62M4.08 18.54c-.77 0-1.4-.63-1.4-1.39c0-.49.26-.93.65-1.18c-.14-2.41 2.35-5.56 6.17-7.75c1.59-.9 3.25-1.55 4.82-1.88c.18-.05.41.08.45.29c.05.21-.08.42-.27.46c-1.5.32-3.09.94-4.6 1.8c-3.44 1.97-5.8 4.79-5.8 6.87c.76.01 1.4.63 1.4 1.39c0 .77-.65 1.39-1.42 1.39m0-2.01c-.34 0-.62.28-.62.62c0 .35.28.62.62.62s.63-.27.63-.62c0-.34-.29-.62-.63-.62m14.42-3.09c-.07 0-.16-.03-.23-.09a.393.393 0 0 1-.04-.55c1.54-1.8 2.07-3.54 1.41-4.66c-.47-.81-1.54-1.26-3.01-1.28c-.22 0-.39-.18-.38-.39c0-.21.18-.37.39-.38c1.75.02 3.06.61 3.67 1.66c.84 1.44.29 3.46-1.49 5.55c-.08.09-.19.14-.32.14m-2 5.46c-2 0-4.56-.74-7-2.13c-1.55-.89-2.93-1.98-4-3.14a.402.402 0 0 1 0-.55c.18-.14.42-.13.57.03c1.01 1.1 2.33 2.14 3.82 2.99c3.31 1.9 6.88 2.53 8.76 1.62c-.08-.17-.15-.37-.15-.57c0-.77.65-1.39 1.42-1.39c.77 0 1.4.62 1.4 1.39a1.396 1.396 0 0 1-2.15 1.17c-.7.39-1.61.58-2.67.58m3-1.27c.13.08.27.14.42.14a.619.619 0 1 0 0-1.24c-.35 0-.62.28-.62.62c0 .14.05.27.13.38c.04.02.07.06.07.1M4.46 12c-.13 0-.26-.08-.33-.2c-.9-1.55-1.05-2.99-.43-4.06c.84-1.44 2.88-1.98 5.61-1.49c.19.04.35.25.31.45c-.03.21-.23.35-.44.3C6.82 6.59 5 7 4.37 8.13c-.48.82-.33 1.98.43 3.28c.1.19.04.42-.15.53c-.06.03-.12.06-.19.06m7.75 1.4a.92.92 0 0 1-.4-1.8c.5-.1 1 .21 1.1.71c.09.49-.21.98-.7 1.09Z"/>'
        },
        elephant: {
            body: '<path fill="currentColor" d="M19.5 15.5a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5v-7c0-1.93-2.07-3.5-4-3.5H6a4 4 0 0 0-4 4v10h4v-4h5v4h4v-4.5a.5.5 0 0 1 .5-.5a.5.5 0 0 1 .5.5V16a3 3 0 0 0 3 3a3 3 0 0 0 3-3v-2h-2.5v1.5Z"/>'
        },
        "elevation-decline": {
            body: '<path fill="currentColor" d="M21 21H3v-9.75L9.45 15l3.77-2.2L21 17.29V21M3 8.94V6.75l6.45 3.75l3.77-2.2L21 12.79V15l-7.78-4.5l-3.77 2.17L3 8.94Z"/>'
        },
        "elevation-rise": {
            body: '<path fill="currentColor" d="M3 21v-3.71l7.78-4.49l3.77 2.2L21 11.25V21H3M21 8.94l-6.45 3.73l-3.77-2.17L3 15v-2.21l7.78-4.49l3.77 2.2L21 6.75v2.19Z"/>'
        },
        elevator: {
            body: '<path fill="currentColor" d="m7 2l4 4H8v4H6V6H3l4-4m10 8l-4-4h3V2h2v4h3l-4 4M7 12h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m0 2v6h10v-6H7Z"/>'
        },
        "elevator-down": {
            body: '<path fill="currentColor" d="m7 10l4-4H8V2H6v4H3l4 4m10 0l-4-4h3V2h2v4h3l-4 4M7 12h10a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2v-6c0-1.1.9-2 2-2m0 2v6h10v-6H7Z"/>'
        },
        "elevator-passenger": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M8.5 6a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5m2.5 8h-1v4H7v-4H6v-2.5c0-1.1.9-2 2-2h1c1.1 0 2 .9 2 2V14m4.5 3L13 13h5l-2.5 4M13 11l2.5-4l2.5 4h-5Z"/>'
        },
        "elevator-passenger-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.41-1.41v-.01L2.39 1.73L1.11 3L3 4.9V19c0 1.1.9 2 2 2h14.1l1.74 1.73l1.27-1.27M11 14h-1v4H7v-4H6v-2.5c0-1 .71-1.79 1.65-1.96L11 12.89V14m2.46-3.74L6.2 3H19c1.1 0 2 .9 2 2v12.8l-3.69-3.69L18 13h-1.8l-2-2H18l-2.5-4l-2.04 3.26Z"/>'
        },
        "elevator-passenger-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L3 4.9V19c0 1.1.9 2 2 2h14.1l1.74 1.73l1.27-1.27M5 19V6.89l2.65 2.65C6.71 9.71 6 10.5 6 11.5V14h1v4h3v-4h1v-1.11L17.11 19H5M8.2 5l-2-2H19c1.1 0 2 .9 2 2v12.8l-2-2V5H8.2m9.8 6h-3.8l-.74-.74L15.5 7l2.5 4m-.69 3.11L16.2 13H18l-.69 1.11Z"/>'
        },
        "elevator-passenger-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 15v-4h1v-2.5c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2V14h1v4h3M8.5 8.5a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5M18 11l-2.5-4l-2.5 4h5m-5 2l2.5 4l2.5-4h-5Z"/>'
        },
        "elevator-up": {
            body: '<path fill="currentColor" d="m7 2l4 4H8v4H6V6H3l4-4m10 0l-4 4h3v4h2V6h3l-4-4M7 12h10a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2v-6c0-1.1.9-2 2-2m0 2v6h10v-6H7Z"/>'
        },
        ellipse: {
            body: '<path fill="currentColor" d="M12 4C6.5 4 2 7.58 2 12s4.5 8 10 8s10-3.58 10-8s-4.5-8-10-8Z"/>'
        },
        "ellipse-outline": {
            body: '<path fill="currentColor" d="M12 6c4.41 0 8 2.69 8 6s-3.59 6-8 6s-8-2.69-8-6s3.59-6 8-6m0-2C6.5 4 2 7.58 2 12s4.5 8 10 8s10-3.58 10-8s-4.5-8-10-8Z"/>'
        },
        email: {
            body: '<path fill="currentColor" d="m20 8l-8 5l-8-5V6l8 5l8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "email-alert": {
            body: '<path fill="currentColor" d="m18 8l-8 5l-8-5V6l8 5l8-5m0-2H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m6 3h-2v6h2V7m0 8h-2v2h2v-2Z"/>'
        },
        "email-alert-outline": {
            body: '<path fill="currentColor" d="M24 7h-2v6h2V7m0 8h-2v2h2v-2m-4-9c0-1.1-.9-2-2-2H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6m-2 0l-8 5l-8-5h16m0 12H2V8l8 5l8-5v10Z"/>'
        },
        "email-arrow-left": {
            body: '<path fill="currentColor" d="M13 19c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5l8-5v2l-8 5l-8-5m14 8v2h4v2h-4v2l-3-3l3-3Z"/>'
        },
        "email-arrow-left-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m-2 10v2h4v2h-4v2l-3-3l3-3Z"/>'
        },
        "email-arrow-right": {
            body: '<path fill="currentColor" d="M13 19c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5l8-5v2l-8 5l-8-5m16 14v-2h-4v-2h4v-2l3 3l-3 3Z"/>'
        },
        "email-arrow-right-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m0 16v-2h-4v-2h4v-2l3 3l-3 3Z"/>'
        },
        "email-box": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m1.4 3.5h11.2c.77 0 1.4.62 1.4 1.4v8.2a1.4 1.4 0 0 1-1.4 1.4H6.4c-.77 0-1.4-.63-1.4-1.4V7.9c0-.78.62-1.4 1.4-1.4M6 8v2l6 4l6-4V8l-6 4l-6-4Z"/>'
        },
        "email-check": {
            body: '<path fill="currentColor" d="M13 19c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5l8-5v2l-8 5l-8-5m13.75 14.16l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41l-4.75 4.75"/>'
        },
        "email-check-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m-2.25 16.16l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41l-4.75 4.75"/>'
        },
        "email-edit": {
            body: '<path fill="currentColor" d="M21 12.13c-.15.01-.29.06-.39.17l-1 1l2.05 2l1-1c.22-.21.22-.56 0-.77l-1.24-1.23a.557.557 0 0 0-.38-.17m-2 1.75L13 19.94V22h2.06l6.06-6.07M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v-.89l8.24-8.22c.47-.49 1.12-.76 1.8-.76c.34 0 .68.06 1 .19V6c0-1.12-.92-2-2.04-2m0 4l-8 5l-8-5V6l8 5l8-5"/>'
        },
        "email-edit-outline": {
            body: '<path fill="currentColor" d="M19.07 13.88L13 19.94V22h2.06l6.06-6.07m1.58-2.35l-1.28-1.28a.517.517 0 0 0-.38-.17c-.15.01-.29.06-.39.17l-1 1l2.05 2l1-1c.19-.2.19-.52 0-.72M11 18H4V8l8 5l8-5v2h2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2m9-12l-8 5l-8-5h16Z"/>'
        },
        "email-fast": {
            body: '<path fill="currentColor" d="M22 5.5H9c-1.1 0-2 .9-2 2v9a2 2 0 0 0 2 2h13c1.11 0 2-.89 2-2v-9a2 2 0 0 0-2-2m0 3.67l-6.5 3.33L9 9.17V7.5l6.5 3.31L22 7.5v1.67M5 16.5c0 .17.03.33.05.5H1c-.552 0-1-.45-1-1s.448-1 1-1h4v1.5M3 7h2.05c-.02.17-.05.33-.05.5V9H3c-.55 0-1-.45-1-1s.45-1 1-1m-2 5c0-.55.45-1 1-1h3v2H2c-.55 0-1-.45-1-1Z"/>'
        },
        "email-fast-outline": {
            body: '<path fill="currentColor" d="M22 5.5H9c-1.1 0-2 .9-2 2v9a2 2 0 0 0 2 2h13c1.11 0 2-.89 2-2v-9a2 2 0 0 0-2-2m0 11H9V9.17l6.5 3.33L22 9.17v7.33m-6.5-5.69L9 7.5h13l-6.5 3.31M5 16.5c0 .17.03.33.05.5H1c-.552 0-1-.45-1-1s.448-1 1-1h4v1.5M3 7h2.05c-.02.17-.05.33-.05.5V9H3c-.55 0-1-.45-1-1s.45-1 1-1m-2 5c0-.55.45-1 1-1h3v2H2c-.55 0-1-.45-1-1Z"/>'
        },
        "email-lock": {
            body: '<path fill="currentColor" d="M12 18.2c0-.96.5-1.86 1.2-2.46v-.24c0-2.44 2.2-4.5 4.8-4.5c1.65 0 3.13.83 4 2.06V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h8v-1.8M4 6l8 5l8-5v2l-8 5l-8-5V6m16.8 11v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17Z"/>'
        },
        "email-lock-outline": {
            body: '<path fill="currentColor" d="M12 18.2V18H4V8l8 5l8-5v3.44c.81.36 1.5.92 2 1.62V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8v-1.8M20 6l-8 5l-8-5h16m.8 11v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V17Z"/>'
        },
        "email-mark-as-unread": {
            body: '<path fill="currentColor" d="M18.84 7h-2.62L10.5 4L4 7.41V17a2 2 0 0 1-2-2V7.17c0-.67.28-1.11.81-1.36L10.5 2l7.55 3.81c.45.28.73.69.79 1.19M7 8h13a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2m13 3.67V10l-6.5 3.31L7 10v1.67L13.5 15l6.5-3.33Z"/>'
        },
        "email-minus": {
            body: '<path fill="currentColor" d="M13 19c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5l8-5v2l-8 5l-8-5m19 10v2h-8v-2h8Z"/>'
        },
        "email-minus-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m3 12v2h-8v-2h8Z"/>'
        },
        "email-multiple": {
            body: '<path fill="currentColor" d="M22 6V4l-8 5l-8-5v2l8 5l8-5m0-4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h16M2 6v14h18v2H2a2 2 0 0 1-2-2V6h2Z"/>'
        },
        "email-multiple-outline": {
            body: '<path fill="currentColor" d="M2 6v14h18v2H2c-1.105 0-2-.89-2-2V6h2m22-2c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4m-2 0l-8 5l-8-5h16m0 12H6V6l8 5l8-5v10Z"/>'
        },
        "email-newsletter": {
            body: '<path fill="currentColor" d="M12 .64L8.23 3H5v2L2.97 6.29C2.39 6.64 2 7.27 2 8v10a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V8c0-.73-.39-1.36-.97-1.71L19 5V3h-3.23M7 5h10v4.88L12 13L7 9.88M8 6v1.5h8V6M5 7.38v1.25L4 8m15-.62L20 8l-1 .63M8 8.5V10h8V8.5Z"/>'
        },
        "email-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l1.5 1.5c-.4.4-.6.9-.6 1.5v12c0 1.1.9 2 2 2h14.1l2.7 2.7l1.3-1.2M4 8V6l.3.2l5.3 5.3L4 8m9.4 2.2L7.2 4H20c1.1 0 2 .9 2 2v12c0 .2 0 .5-.1.7l-7.3-7.3L20 8V6l-6.6 4.2Z"/>'
        },
        "email-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l1.5 1.5c-.3.4-.6.9-.6 1.5v12c0 1.1.9 2 2 2h14.1l2.7 2.7l1.3-1.2M4 18V8l5.6 3.5l6.5 6.5H4M9.2 6l-2-2H20c1.1 0 2 .9 2 2v12c0 .2 0 .5-.1.7L20 16.8V8l-5.4 3.4l-1.2-1.2L20 6H9.2Z"/>'
        },
        "email-open": {
            body: '<path fill="currentColor" d="m4 8l8 5l8-5l-8-5l-8 5m18 0v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-.73.39-1.36.97-1.71L12 .64l9.03 5.65c.58.35.97.98.97 1.71Z"/>'
        },
        "email-open-multiple": {
            body: '<path fill="currentColor" d="m6 8l8 5l8-5l-8-5l-8 5m18 0v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8c0-.73.39-1.36.97-1.71L14 .64l9.03 5.65c.58.35.97.98.97 1.71M2 8v14h18v2H2a2 2 0 0 1-2-2V8h2Z"/>'
        },
        "email-open-multiple-outline": {
            body: '<path fill="currentColor" d="M2 8v14h18v2H2c-1.105 0-2-.89-2-2V8h2m21.03-1.71L14 .64L4.97 6.29C4.39 6.64 4 7.27 4 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-.73-.39-1.36-.97-1.71M22 18H6v-8l8 5l8-5v8m-8-5L6 8l8-5l8 5l-8 5Z"/>'
        },
        "email-open-outline": {
            body: '<path fill="currentColor" d="M21.03 6.29L12 .64L2.97 6.29C2.39 6.64 2 7.27 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-.73-.39-1.36-.97-1.71M20 18H4v-8l8 5l8-5v8m-8-5L4 8l8-5l8 5l-8 5Z"/>'
        },
        "email-outline": {
            body: '<path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6m-2 0l-8 5l-8-5h16m0 12H4V8l8 5l8-5v10Z"/>'
        },
        "email-plus": {
            body: '<path fill="currentColor" d="M13 19c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5l8-5v2l-8 5l-8-5m16 7v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "email-plus-outline": {
            body: '<path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m0 9v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "email-remove": {
            body: '<path fill="currentColor" d="m20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16a2 2 0 0 1 2 2v7.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m7-11V6l-8 5l-8-5v2l8 5l8-5Z"/>'
        },
        "email-remove-outline": {
            body: '<path fill="currentColor" d="M13.09 18H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1c0-.34.04-.67.09-1M20 6l-8 5l-8-5h16m.41 13l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "email-seal": {
            body: '<path fill="currentColor" d="M12.5 13.3c-.3-.9-.1-1.6 0-2c-.1-.4-.3-1-.1-1.9c.3-.8.8-1.2 1.1-1.5c.1-.4.3-1 1.1-1.6c.7-.5 1.4-.5 1.8-.5c.1-.1.3-.2.5-.3V2.6c.1-.9-.6-1.6-1.5-1.6H2.6C1.7 1 1 1.7 1 2.6v9.8c0 .9.7 1.6 1.6 1.6h10.3c-.2-.2-.3-.4-.4-.7M3 5V3l6 3l6-3v2L9 8L3 5m19.6 4.9c-.2-.6-.7-.7-1-1c-.2-.3-.2-.9-.7-1.2c-.5-.4-1-.2-1.4-.3c-.4-.1-.7-.6-1.3-.6s-.9.4-1.3.6c-.4.1-.9-.1-1.4.3c-.5.3-.4.8-.7 1.2c-.3.3-.8.5-1 1c-.2.6.2 1 .2 1.4c0 .4-.4.8-.2 1.4c.2.6.7.7 1 1c.2.3.2.9.7 1.2c.5.4 1 .2 1.4.3c.4.1.7.6 1.3.6s.9-.4 1.3-.6c.4-.1.9.1 1.4-.3c.5-.4.5-.9.7-1.2c.3-.3.8-.5 1-1c.2-.6-.2-1-.2-1.4c0-.4.4-.8.2-1.4m-4.4 4.5c-1.7 0-3-1.4-3-3s1.4-3 3-3s3 1.4 3 3s-1.3 3-3 3m1.5-3.1c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5m-.2 5.8l-.5 2.7l-.6 3.1l-2-1.9l-2.4 1.1l1-5.7c.4.2.9.3 1.4.3c.3.2.7.4 1 .5c.2.1.5.1.8.1c.5.1.9 0 1.3-.2m3.2 2.4l-2-.7l.4-2.2l.6-.3l.1-.1l.9 3.3Z"/>'
        },
        "email-seal-outline": {
            body: '<path fill="currentColor" d="M12.5 13.3c-.2-.5-.2-.9-.1-1.3H3V4.5l6 4l6-4v1.7c.6-.3 1.1-.3 1.4-.3c.1-.1.3-.2.5-.3v-3c.1-.9-.6-1.6-1.5-1.6H2.6C1.7 1 1 1.7 1 2.6v9.8c0 .9.7 1.6 1.6 1.6h10.3c-.2-.2-.3-.4-.4-.7M15 3L9 7L3 3h12m7.6 6.9c-.2-.6-.7-.7-1-1c-.2-.3-.2-.9-.7-1.2c-.5-.4-1-.2-1.4-.3c-.4-.1-.7-.6-1.3-.6s-.9.4-1.3.6c-.4.1-.9-.1-1.4.3c-.5.3-.4.8-.7 1.2c-.3.3-.8.5-1 1c-.2.6.2 1 .2 1.4c0 .4-.4.8-.2 1.4c.2.6.7.7 1 1c.2.3.2.9.7 1.2c.5.4 1 .2 1.4.3c.4.1.7.6 1.3.6s.9-.4 1.3-.6c.4-.1.9.1 1.4-.3c.5-.4.5-.9.7-1.2c.3-.3.8-.5 1-1c.2-.6-.2-1-.2-1.4c0-.4.4-.8.2-1.4m-4.4 4.5c-1.7 0-3-1.4-3-3s1.4-3 3-3s3 1.4 3 3s-1.3 3-3 3m1.5-3.1c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5m-.2 5.8l-.5 2.7l-.6 3.1l-2-1.9l-2.4 1.1l1-5.7c.4.2.9.3 1.4.3c.3.2.7.4 1 .5c.2.1.5.1.8.1c.5.1.9 0 1.3-.2m3.2 2.4l-2-.7l.4-2.2l.6-.3l.1-.1l.9 3.3Z"/>'
        },
        "email-search": {
            body: '<path fill="currentColor" d="M3 4h16a2 2 0 0 1 2 2v4.82c-1-.97-2.3-1.59-3.69-1.76L19 8V6l-8 5l-8-5v2l7.62 4.76c-.41.86-.62 1.79-.62 2.74a6.5 6.5 0 0 0 1.81 4.5H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2m13.5 7c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "email-search-outline": {
            body: '<path fill="currentColor" d="M16.5 11c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5m-6 5H3V8l7.62 4.76A6.486 6.486 0 0 1 16.5 9c.27 0 .54 0 .81.06L19 8v1.5c.75.31 1.42.77 2 1.32V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8.82c-.55-.58-1-1.25-1.32-2M19 6l-8 5l-8-5h16Z"/>'
        },
        "email-sync": {
            body: '<path fill="currentColor" d="M3 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h10.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 6.5-6.5a6.5 6.5 0 0 1 1.5.18V6a2 2 0 0 0-2-2H3m0 2l8 5l8-5v2l-8 5l-8-5V6m16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4V12m-3.33 3.29c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09Z"/>'
        },
        "email-sync-outline": {
            body: '<path fill="currentColor" d="M3 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10.5a6.5 6.5 0 0 1-.5-2H3V8l8 5l8-5v3a6.5 6.5 0 0 1 .5 0a6.5 6.5 0 0 1 1.5.18V6c0-1.1-.9-2-2-2H3m0 2h16l-8 5l-8-5m16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4V12m-3.33 3.29c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09Z"/>'
        },
        "email-variant": {
            body: '<path fill="currentColor" d="M12 13L2 6.76V6c0-1.11.89-2 2-2h16a2 2 0 0 1 2 2v.75L12 13m10 5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.11l2 1.25V18h16v-7.64l2-1.25V18Z"/>'
        },
        ember: {
            body: '<path fill="currentColor" d="M22 14.22s-4.39 3.13-7.28 3.17c-2.88.05-2.59-1.83-2.59-1.83s10.58-3.62 7.7-10.77c-1.3-1.84-2.83-2.42-4.94-2.37c-2.13.04-4.72 1.34-6.43 5.18c-.82 1.84-1.05 3.58-1.22 4.9c0 0-1.92.38-2.92-.46c-1-.84-1.55 0-1.55 0s-1.74 2.16-.02 2.83c1.71.67 4.37.95 4.37.95c.24 1.18.96 3.18 3.05 4.78c3.13 2.4 9.15-.2 9.15-.2m-7.69-8.07c.13-4.97 3.37-7.15 4.52-6.06c1.12 1.09.71 3.43-1.43 4.89c-2.13 1.47-3.09 1.17-3.09 1.17Z"/>'
        },
        emby: {
            body: '<path fill="currentColor" d="M11 2L6 7l1 1l-5 5l5 5l1-1l5 5l5-5l-1-1l5-5l-5-5l-1 1l-5-5m-1 6.5l6 3.5l-6 3.5v-7Z"/>'
        },
        emoticon: {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m3.5 6A1.5 1.5 0 0 1 17 9.5a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 14 9.5A1.5 1.5 0 0 1 15.5 8m-7 0A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 8.5 11A1.5 1.5 0 0 1 7 9.5A1.5 1.5 0 0 1 8.5 8m3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.81 2.04-2.78 3.5-5.11 3.5Z"/>'
        },
        "emoticon-angry": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5V8l3 1.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5m7.77 7.73C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14c1.75 0 3.29.72 4.19 1.81l-1.42 1.42M17 9.5c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5L17 8v1.5Z"/>'
        },
        "emoticon-angry-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-6c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14m-2-4.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5V8l3 1.5m7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5L17 8v1.5"/>'
        },
        "emoticon-confused": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2M8.5 8A1.5 1.5 0 1 1 7 9.5A1.54 1.54 0 0 1 8.5 8m8.5 8h-4a4 4 0 0 0-3.47 2L7.8 17a6 6 0 0 1 5.2-3h4m-1.5-3A1.5 1.5 0 1 1 17 9.5a1.54 1.54 0 0 1-1.5 1.5Z"/>'
        },
        "emoticon-confused-outline": {
            body: '<path fill="currentColor" d="M20 12a8 8 0 1 0-8 8a8 8 0 0 0 8-8m2 0A10 10 0 1 1 12 2a10 10 0 0 1 10 10m-6.5-4A1.5 1.5 0 1 1 14 9.5A1.54 1.54 0 0 1 15.5 8M10 9.5A1.5 1.5 0 1 1 8.5 8A1.54 1.54 0 0 1 10 9.5m7 5.5h-4a4 4 0 0 0-3.47 2L7.8 16a6 6 0 0 1 5.2-3h4Z"/>'
        },
        "emoticon-cool": {
            body: '<path fill="currentColor" d="M3.22 7.22A9.984 9.984 0 0 1 12 2c3.79 0 7.09 2.11 8.78 5.22L20 8H4l-.78-.78M21.4 8.6c.38 1.07.6 2.21.6 3.4a10 10 0 0 1-10 10A10 10 0 0 1 2 12c0-1.19.22-2.33.6-3.4L4 10h1c0 1.38 2.12 2.5 3.5 2.5s2.75-1.12 2.75-2.5h1.5c0 1.38 1.37 2.5 2.75 2.5S19 11.38 19 10h1l1.4-1.4m-5.21 6.82L14.77 14c-.45.72-1.52 1.23-2.77 1.23S9.68 14.72 9.23 14l-1.42 1.42c.9 1.08 2.44 1.81 4.19 1.81c1.75 0 3.29-.73 4.19-1.81Z"/>'
        },
        "emoticon-cool-outline": {
            body: '<path fill="currentColor" d="M19 10c0 1.38-2.12 2.5-3.5 2.5s-2.75-1.12-2.75-2.5h-1.5c0 1.38-1.37 2.5-2.75 2.5S5 11.38 5 10h-.75c-.16.64-.25 1.31-.25 2a8 8 0 0 0 8 8a8 8 0 0 0 8-8c0-.69-.09-1.36-.25-2H19m-7-6C9.04 4 6.45 5.61 5.07 8h13.86C17.55 5.61 14.96 4 12 4m10 8a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-10 5.23c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81Z"/>'
        },
        "emoticon-cry": {
            body: '<path fill="currentColor" d="M5.14 17.57c0-1.07 1.18-3.07 2.43-4.76C8.82 14.5 10 16.5 10 17.57A2.43 2.43 0 0 1 7.57 20c-1.34 0-2.43-1.09-2.43-2.43M22 12a10 10 0 0 1-10 10c-.92 0-1.82-.14-2.67-.37A4.424 4.424 0 0 0 12 17.57c0-.45-.11-.97-.31-1.57H12c1.25 0 2.32.5 2.77 1.23l1.42-1.42C15.29 14.72 13.75 14 12 14c-.41 0-.81.04-1.19.12c-.43-.76-.96-1.59-1.62-2.49L8.71 11c.71-.13 1.29-.77 1.29-1.5C10 8.7 9.3 8 8.5 8S7 8.7 7 9.5c0 .19.04.37.11.54l-1.15 1.59C4.4 13.75 3.5 15.5 3.23 16.81C2.45 15.38 2 13.74 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-5-2.5c0-.8-.7-1.5-1.5-1.5S14 8.7 14 9.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "emoticon-cry-outline": {
            body: '<path fill="currentColor" d="M7.57 20c-1.34 0-2.43-1.09-2.43-2.43c0-1.07 1.18-3.07 2.43-4.76C8.82 14.5 10 16.5 10 17.57A2.43 2.43 0 0 1 7.57 20M12 2A10 10 0 0 0 2 12c0 1.75.45 3.38 1.24 4.81c.16-.81.57-1.74 1.07-2.64A7.69 7.69 0 0 1 4 12a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8c-.24 0-.47 0-.71-.04c-.47.74-1.15 1.32-1.95 1.67c.85.24 1.74.37 2.66.37a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 12c-.41 0-.81.04-1.19.12c.35.63.66 1.28.88 1.88H12c1.25 0 2.32.5 2.77 1.23l1.42-1.42C15.29 14.72 13.75 14 12 14m3.5-6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S16.3 8 15.5 8M10 9.5C10 8.7 9.3 8 8.5 8S7 8.7 7 9.5S7.7 11 8.5 11s1.5-.7 1.5-1.5"/>'
        },
        "emoticon-dead": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10M6.76 8.82l1.06-1.06l1.06 1.06l1.06-1.06L11 8.82L9.94 9.88L11 10.94L9.94 12l-1.06-1.06L7.82 12l-1.06-1.06l1.06-1.06l-1.06-1.06m.13 8.68C7.69 15.46 9.67 14 12 14c2.33 0 4.31 1.46 5.11 3.5H6.89m10.35-6.56L16.18 12l-1.06-1.06L14.06 12L13 10.94l1.06-1.06L13 8.82l1.06-1.06l1.06 1.06l1.06-1.06l1.06 1.06l-1.06 1.06l1.06 1.06Z"/>'
        },
        "emoticon-dead-outline": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m4.18-12.24l-1.06 1.06l-1.06-1.06L13 8.82l1.06 1.06L13 10.94L14.06 12l1.06-1.06L16.18 12l1.06-1.06l-1.06-1.06l1.06-1.06l-1.06-1.06M7.82 12l1.06-1.06L9.94 12L11 10.94L9.94 9.88L11 8.82L9.94 7.76L8.88 8.82L7.82 7.76L6.76 8.82l1.06 1.06l-1.06 1.06L7.82 12M12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5Z"/>'
        },
        "emoticon-devil": {
            body: '<path fill="currentColor" d="M22.5 2.09c-.9.91-2.37 1.64-4.19 2.16A9.92 9.92 0 0 0 12 2c-2.39 0-4.59.84-6.31 2.25C3.87 3.73 2.4 3 1.5 2.09c.03 1.63.85 3.12 2.22 4.31A9.89 9.89 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-2.08-.63-4-1.72-5.6c1.37-1.19 2.19-2.68 2.22-4.31M7.5 8.5l3 1.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V8.5m4.5 8.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81M16.5 10c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5l3-1.5V10Z"/>'
        },
        "emoticon-devil-outline": {
            body: '<path fill="currentColor" d="M1.5 2.09c.9.91 2.37 1.64 4.19 2.16A9.92 9.92 0 0 1 12 2c2.39 0 4.59.84 6.31 2.25C20.13 3.73 21.6 3 22.5 2.09c-.03 1.63-.85 3.12-2.22 4.31A9.89 9.89 0 0 1 22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12c0-2.08.63-4 1.72-5.6C2.35 5.21 1.53 3.72 1.5 2.09M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m-9.5-2c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V8.5l3 1.5m6 0c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5l3-1.5V10M12 17.23c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81Z"/>'
        },
        "emoticon-excited": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10M8.88 7.82L11 9.94L9.94 11L8.88 9.94L7.82 11L6.76 9.94l2.12-2.12M12 17.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5m4.18-6.5l-1.06-1.06L14.06 11L13 9.94l2.12-2.12l2.12 2.12L16.18 11Z"/>'
        },
        "emoticon-excited-outline": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06l-2.12-2.12L13 9.94m-4.12 0L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11l1.06-1.06M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5Z"/>'
        },
        "emoticon-frown": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12s4.47 10 10 10c5.5 0 10-4.5 10-10S17.5 2 12 2m3.5 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11S7 10.33 7 9.5S7.67 8 8.5 8m-1.61 9c.8-2.04 2.78-3.5 5.11-3.5s4.31 1.46 5.11 3.5H6.89Z"/>'
        },
        "emoticon-frown-outline": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12s4.47 10 10 10c5.5 0 10-4.5 10-10S17.5 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8m3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8S14 8.67 14 9.5s.67 1.5 1.5 1.5m-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8S7 8.67 7 9.5S7.67 11 8.5 11m3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5Z"/>'
        },
        "emoticon-happy": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5C7 8.7 7.7 8 8.5 8s1.5.7 1.5 1.5S9.3 11 8.5 11S7 10.3 7 9.5m5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81M15.5 11c-.8 0-1.5-.7-1.5-1.5S14.7 8 15.5 8s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "emoticon-happy-outline": {
            body: '<path fill="currentColor" d="M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5S14.7 8 15.5 8s1.5.7 1.5 1.5m-5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81Z"/>'
        },
        "emoticon-kiss": {
            body: '<path fill="currentColor" d="M18.9 18.94L15.94 16c-.18-.21-.39-.5-.39-.95a1.3 1.3 0 0 1 1.3-1.3c.34 0 .68.14.92.4l1.14 1.11l1.12-1.13c.24-.24.58-.38.92-.38a1.3 1.3 0 0 1 1.3 1.3c0 .34-.14.68-.38.92l-2.97 2.97m-1.44.68A9.931 9.931 0 0 1 11 22A10 10 0 0 1 1 12A10 10 0 0 1 11 2a10 10 0 0 1 10 10c0 .09 0 .17-.05.25c-.74 0-1.45.3-1.98.82l-.07.07l-.06-.05a2.76 2.76 0 0 0-1.99-.84a2.8 2.8 0 0 0-2.8 2.8c0 .73.29 1.45.82 1.98l2.59 2.59M13 9.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S15.3 8 14.5 8S13 8.7 13 9.5m-4 0C9 8.7 8.3 8 7.5 8S6 8.7 6 9.5S6.7 11 7.5 11S9 10.3 9 9.5m3.94 5.68L14 14.12L11.88 12l-1.06 1.06l1.06 1.06l-1.06 1.06l1.06 1.06l-1.06 1.06l1.06 1.06L14 16.24l-1.06-1.06Z"/>'
        },
        "emoticon-kiss-outline": {
            body: '<path fill="currentColor" d="M9 9.5c0 .8-.7 1.5-1.5 1.5S6 10.3 6 9.5S6.7 8 7.5 8S9 8.7 9 9.5m7 0c0 .8-.7 1.5-1.5 1.5S13 10.3 13 9.5S13.7 8 14.5 8s1.5.7 1.5 1.5m-2 4.62L11.88 12l-1.06 1.06l1.06 1.06l-1.06 1.06l1.06 1.06l-1.06 1.06l1.06 1.06L14 16.24l-1.06-1.06L14 14.12M16.85 13a2.05 2.05 0 0 0-2.05 2.05c0 .57.23 1.07.6 1.45l3.5 3.5l3.5-3.5c.37-.37.6-.89.6-1.45A2.05 2.05 0 0 0 20.95 13c-.55 0-1.08.23-1.45.6l-.6.6l-.6-.59c-.37-.38-.9-.61-1.45-.61M15 18.92A7.979 7.979 0 0 1 11 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8c4.26 0 7.73 3.33 8 7.5c.58-.31 1.26-.5 1.95-.5c-.5-5.05-4.77-9-9.95-9A10 10 0 0 0 1 12a10 10 0 0 0 10 10c2 0 3.88-.6 5.45-1.62L15 18.92Z"/>'
        },
        "emoticon-lol": {
            body: '<path fill="currentColor" d="M15.07 8.93v-4a4.06 4.06 0 0 1 .66-2.21a10 10 0 0 0-13 13a4.06 4.06 0 0 1 2.21-.66h4v4a4.06 4.06 0 0 1-.66 2.21a10 10 0 0 0 13-13a4.06 4.06 0 0 1-2.21.66M11 6h1.5v1.5H14V9h-3m-3.5 5v-1.5H6V11h3v3m6.89 1.9A5.5 5.5 0 0 1 9.8 17L17 9.8a5.5 5.5 0 0 1-1.11 6.09m-11 5.19a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2v2a2 2 0 0 1-1.96 1.99M19.07 2.93a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2v-2a2 2 0 0 1 2-2Z"/>'
        },
        "emoticon-lol-outline": {
            body: '<path fill="currentColor" d="M6 11v1.5h1.5V14H9v-3m3.5-5H11v3h3V7.5h-1.5M9.8 17A5.5 5.5 0 0 0 17 9.8M6.34 6.34a8 8 0 0 1 8.74-1.72a4.11 4.11 0 0 1 .65-1.9a10 10 0 0 0-13 13a4.11 4.11 0 0 1 1.9-.65a8 8 0 0 1 1.71-8.73m11.32 11.32a8 8 0 0 1-8.74 1.72a4.11 4.11 0 0 1-.65 1.9a10 10 0 0 0 13-13a4.11 4.11 0 0 1-1.9.65a8 8 0 0 1-1.71 8.73M6 11v1.5h1.5V14H9v-3m.8 6A5.5 5.5 0 0 0 17 9.8M12.5 6H11v3h3V7.5h-1.5M6 11v1.5h1.5V14H9v-3m3.5-5H11v3h3V7.5h-1.5M9.8 17A5.5 5.5 0 0 0 17 9.8M4.93 21a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2v2a2 2 0 0 1-2 2.07M19.07 2.93a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2v-2a2 2 0 0 1 2-2Z"/>'
        },
        "emoticon-neutral": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5A1.5 1.5 0 0 1 8.5 8A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 8.5 11A1.5 1.5 0 0 1 7 9.5m9 6.5H8v-2h8v2m-.5-5A1.5 1.5 0 0 1 14 9.5A1.5 1.5 0 0 1 15.5 8A1.5 1.5 0 0 1 17 9.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "emoticon-neutral-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m-3.5-9A1.5 1.5 0 0 1 7 9.5A1.5 1.5 0 0 1 8.5 8A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 8.5 11M17 9.5a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 14 9.5A1.5 1.5 0 0 1 15.5 8A1.5 1.5 0 0 1 17 9.5M16 14v2H8v-2h8Z"/>'
        },
        "emoticon-outline": {
            body: '<path fill="currentColor" d="M12 17.5c2.33 0 4.3-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5M8.5 11A1.5 1.5 0 0 0 10 9.5A1.5 1.5 0 0 0 8.5 8A1.5 1.5 0 0 0 7 9.5A1.5 1.5 0 0 0 8.5 11m7 0A1.5 1.5 0 0 0 17 9.5A1.5 1.5 0 0 0 15.5 8A1.5 1.5 0 0 0 14 9.5a1.5 1.5 0 0 0 1.5 1.5M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "emoticon-poop": {
            body: '<path fill="currentColor" d="M11.36 2c-.21 0-.49.12-.79.32C10 2.7 8.85 3.9 8.4 5.1c-.34.9-.35 1.72-.21 2.33c-.56.1-.97.28-1.13.35c-.51.22-1.59 1.18-1.69 2.67c-.03.52.04 1.05.2 1.55c-.66.19-1.04.43-1.07.44c-.32.12-.85.49-1 .69c-.35.4-.58.87-.71 1.37c-.29 1.09-.19 2.33.34 3.33c.29.56.69 1.17 1.13 1.6c1.44 1.48 3.92 2.04 5.88 2.36c2.39.4 4.89.26 7.12-.66c3.35-1.39 4.24-3.63 4.38-4.24c.29-1.39-.07-2.7-.22-3.02c-.22-.46-.58-.93-1.17-1.23c-.4-.25-.75-.38-1.01-.44c.26-.95-.11-1.7-.62-2.26c-.77-.82-1.56-.94-1.56-.94c.26-.5.36-1.1.22-1.68c-.16-.71-.55-1.16-1.06-1.46c-.52-.31-1.16-.46-1.82-.58c-.32-.06-1.65-.25-2.2-1.01c-.45-.62-.46-1.74-.58-2.07c-.05-.13-.12-.2-.26-.2M16 9.61c.07 0 .13.01.19.01c1.43.16 2.45 1.54 2.28 3.07c-.17 1.53-1.47 2.65-2.9 2.49c-1.43-.18-2.45-1.53-2.28-3.07c.16-1.45 1.35-2.55 2.71-2.5m-7.38 0c1.33.04 2.44 1.17 2.54 2.6c.12 1.54-.95 2.87-2.38 2.98h-.01c-1.43.11-2.69-1.05-2.81-2.59c-.11-1.54.96-2.87 2.39-2.98c.09-.01.18-.01.27-.01m.02 1.7c-.04 0-.07 0-.11.01c-.56.07-.96.58-.89 1.13a1 1 0 0 0 1.13.87c.56-.07.96-.58.9-1.13a1.01 1.01 0 0 0-1.03-.88m7.3.02c-.52.02-.94.42-.98.95a1 1 0 0 0 .95 1.06a1.008 1.008 0 1 0 .14-2.01h-.11m-7.23 4.82c.29-.01.55.08.79.13c1.18.22 2.2.25 2.69.25c.49 0 1.5-.03 2.67-.25c.41-.08.88-.25 1.25 0c.48.32.13 1.47-.61 2.25a4.53 4.53 0 0 1-3.31 1.38c-1.78 0-2.86-.91-3.31-1.38c-.74-.78-1.09-1.93-.62-2.25c.14-.09.29-.13.45-.13Z"/>'
        },
        "emoticon-poop-outline": {
            body: '<path fill="currentColor" d="M21.42 13.87c-.22-.46-.58-.93-1.17-1.23c-.4-.25-.75-.38-1.01-.44c.26-.95-.11-1.7-.62-2.26c-.77-.82-1.56-.94-1.56-.94c.26-.5.36-1.1.22-1.68c-.16-.71-.55-1.16-1.06-1.46c-.52-.31-1.16-.46-1.82-.58c-.32-.06-1.65-.25-2.2-1.01c-.45-.62-.46-1.74-.58-2.07c-.05-.13-.12-.2-.26-.2c-.21 0-.49.12-.79.32C10 2.7 8.85 3.9 8.4 5.1c-.34.9-.35 1.72-.21 2.33c-.56.1-.97.28-1.13.35c-.51.22-1.59 1.18-1.69 2.67c-.03.44.04.89.13 1.33v.25c-.62.19-.97.4-1 .41c-.32.12-.85.49-1 .69c-.35.4-.58.87-.71 1.37c-.29 1.09-.19 2.33.34 3.33c.29.56.69 1.17 1.13 1.6c1.44 1.48 3.92 2.04 5.88 2.36c.82.14 1.66.21 2.49.21c1.59 0 3.17-.27 4.63-.87c3.35-1.39 4.24-3.63 4.38-4.24c.29-1.39-.07-2.7-.22-3.02m-5.37-2.54a1.008 1.008 0 1 1-.14 2.01a1 1 0 0 1-.95-1.06c.04-.53.46-.93.98-.95h.11m4.13 5.22c-.01.02-.48 1.95-3.49 3.19c-1.22.51-2.59.76-4.06.76c-.73 0-1.49-.06-2.25-.19c-1.62-.26-3.88-.75-5.07-1.95c-.27-.27-.59-.73-.85-1.23c-.34-.63-.42-1.48-.22-2.25c.08-.3.21-.56.39-.76l.02-.03c.09-.09.3-.21.38-.25l.11-.04l.12-.06c.06-.04.2-.11.41-.19c.46 1.26 1.61 2.15 2.92 2.15c.08 0 .15-.01.23-.01a2.97 2.97 0 0 0 2.12-1.14c.53-.66.79-1.51.72-2.38c-.12-1.67-1.44-3.01-3.02-3.06h-.02c-.12 0-.22 0-.31.01c-.31.03-.58.11-.85.22c.09-.1.17-.17.2-.19c.13-.05.41-.15.79-.24L10 8.63l-.35-1.54c-.04-.19-.12-.74.16-1.46c.15-.43.46-.87.77-1.25c.1.27.23.53.42.77c.77 1.08 2.12 1.43 3.06 1.59l.07.02c.47.08 1 .19 1.33.39c.21.13.3.26.36.52c.05.2.02.43-.09.64l-.52.89c-1.26.3-2.26 1.44-2.42 2.86c-.2 1.81.99 3.4 2.71 3.62c.12.01.24.02.35.02c.71 0 1.4-.26 1.97-.75c.41-.36.72-.82.92-1.33l.16.04c.1.02.27.08.55.25l.05.04l.07.05c.21.08.37.26.48.5c.08.17.33 1.1.13 2.05m-12.54-4.1c-.07-.55.33-1.06.89-1.13c.04-.01.07-.01.11-.01c.51-.01.97.36 1.03.88c.06.55-.34 1.06-.9 1.13a1 1 0 0 1-1.13-.87m1.07 3.7c.29-.01.55.08.79.13c1.18.22 2.2.25 2.69.25c.49 0 1.5-.03 2.67-.25c.41-.08.88-.25 1.25 0c.48.32.13 1.47-.61 2.25a4.53 4.53 0 0 1-3.31 1.38c-1.78 0-2.86-.91-3.31-1.38c-.74-.78-1.09-1.93-.62-2.25c.14-.09.29-.13.45-.13Z"/>'
        },
        "emoticon-sad": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5C7 8.7 7.7 8 8.5 8s1.5.7 1.5 1.5S9.3 11 8.5 11S7 10.3 7 9.5m7.77 7.73C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14c1.75 0 3.29.72 4.19 1.81l-1.42 1.42M15.5 11c-.8 0-1.5-.7-1.5-1.5S14.7 8 15.5 8s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "emoticon-sad-outline": {
            body: '<path fill="currentColor" d="M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-6.5-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m2 4.5c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14Z"/>'
        },
        "emoticon-sick": {
            body: '<path fill="currentColor" d="M21 9c-1.1 0-2-.9-2-2s2-4 2-4s2 2.9 2 4s-.9 2-2 2m-3.5-2c0-.73.41-1.71.92-2.66A9.958 9.958 0 0 0 12 2C6.47 2 2 6.5 2 12s4.47 10 10 10c5.5 0 10-4.5 10-10c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 0 1-.86.12c-1.93 0-3.5-1.57-3.5-3.5m-1.88.38l1.06 1.06l-1.06 1.06l1.06 1.06l-1.06 1.06L13.5 9.5l2.12-2.12m-8.3 1.06l1.06-1.06L10.5 9.5l-2.12 2.12l-1.06-1.06L8.38 9.5L7.32 8.44M15.44 17c-.69-1.19-1.97-2-3.44-2s-2.75.81-3.44 2H6.88c.3-.76.76-1.43 1.34-2l-2.98-1.7c-.45.26-1.01.28-1.49 0a1.501 1.501 0 0 1 1.5-2.6c.48.3.75.8.75 1.3l3.57 2.06c.73-.36 1.55-.56 2.43-.56c2.33 0 4.32 1.45 5.12 3.5h-1.68Z"/>'
        },
        "emoticon-sick-outline": {
            body: '<path fill="currentColor" d="M7.32 10.56L8.38 9.5L7.32 8.44l1.06-1.06L10.5 9.5l-2.12 2.12l-1.06-1.06M4.5 9h.08C5.77 6.07 8.64 4 12 4c2.19 0 4.16.88 5.61 2.3c.15-.6.45-1.3.81-1.96A9.958 9.958 0 0 0 12 2c-4.89 0-8.95 3.5-9.82 8.14C2.74 9.44 3.59 9 4.5 9M21 10.5c-.42 0-.82-.09-1.19-.22c.12.55.19 1.13.19 1.72c0 4.42-3.58 8-8 8c-3.36 0-6.23-2.07-7.42-5H4.5c-.5 0-1.04-.14-1.5-.4c-.32-.18-.59-.42-.82-.7C3.07 18.5 7.11 22 12 22c5.5 0 10-4.5 10-10c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 0 1-.86.12M21 3s-2 2.9-2 4s.9 2 2 2s2-.9 2-2s-2-4-2-4m-5.38 4.38L13.5 9.5l2.12 2.12l1.06-1.06l-1.06-1.06l1.06-1.06l-1.06-1.06M8.56 17c.69-1.19 1.97-2 3.44-2s2.75.81 3.44 2h1.68c-.8-2.05-2.79-3.5-5.12-3.5c-.87 0-1.7.2-2.43.57L6 12c0-.5-.27-1-.75-1.29c-.72-.41-1.63-.17-2.05.55c-.41.74-.17 1.63.55 2.05c.48.28 1.05.25 1.49 0l2.97 1.72c-.57.53-1.03 1.21-1.33 1.97h1.68Z"/>'
        },
        "emoticon-tongue": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-4.73 9c-.17-.29-.27-.64-.27-1c0-1.11.89-2 2-2a2 2 0 0 1 2 2c0 .36-.1.71-.27 1c-.34-.6-.99-1-1.73-1s-1.39.4-1.73 1M16 15h-1c0 2-.9 3-2 3s-2-1-2-3H8v-2h8v2m.73-4c-.34-.6-.99-1-1.73-1s-1.39.4-1.73 1c-.17-.29-.27-.64-.27-1c0-1.11.89-2 2-2a2 2 0 0 1 2 2c0 .36-.1.71-.27 1Z"/>'
        },
        "emoticon-tongue-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8M9 10c-.74 0-1.39.4-1.73 1c-.17-.29-.27-.64-.27-1a2 2 0 0 1 2-2a2 2 0 0 1 1.73 3c-.34-.6-.99-1-1.73-1m8 0c0 .36-.1.71-.27 1c-.34-.6-.99-1-1.73-1s-1.39.4-1.73 1c-.17-.29-.27-.64-.27-1a2 2 0 0 1 2-2a2 2 0 0 1 2 2m-1 3v2h-1c0 2-.9 3-2 3s-2-1-2-3H8v-2h8Z"/>'
        },
        "emoticon-wink": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5C7 8.7 7.7 8 8.5 8s1.5.7 1.5 1.5S9.3 11 8.5 11S7 10.3 7 9.5m5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81M17 10h-4V9h4v1Z"/>'
        },
        "emoticon-wink-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m2 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81M17 10h-4V9h4v1Z"/>'
        },
        engine: {
            body: '<path fill="currentColor" d="M7 4v2h3v2H7l-2 2v3H3v-3H1v8h2v-3h2v3h3l2 2h8v-4h2v3h3V9h-3v3h-2V8h-6V6h3V4H7Z"/>'
        },
        "engine-off": {
            body: '<path fill="currentColor" d="M3.78 2.5L21.5 20.22l-1.27 1.28L18 19.27V20h-8l-2-2H5v-3H3v3H1v-8h2v3h2v-3l1.87-1.86L2.5 3.77L3.78 2.5M20 9v3h-2V8h-6V6h3V4H7.82l15 15H23V9h-3Z"/>'
        },
        "engine-off-outline": {
            body: '<path fill="currentColor" d="m2.5 3.77l4.37 4.37L5 10v3H3v-3H1v8h2v-3h2v3h3l2 2h8v-.73l3.23 3.23l1.27-1.28L3.78 2.5L2.5 3.77M16 18h-5l-2-2H7v-5l1-1h.73L16 17.27V18m7-9v10h-.18L16 12.18V10h-2.18l-6-6H15v2h-3v2h6v4h2V9h3Z"/>'
        },
        "engine-outline": {
            body: '<path fill="currentColor" d="M8 10h8v8h-5l-2-2H7v-5m0-7v2h3v2H7l-2 2v3H3v-3H1v8h2v-3h2v3h3l2 2h8v-4h2v3h3V9h-3v3h-2V8h-6V6h3V4H7Z"/>'
        },
        epsilon: {
            body: '<path fill="currentColor" d="m15.05 7.78l1.1-1.6S14.91 5 12.77 5c-2.73 0-4.42 1.84-4.42 3.76c0 1.92 1.73 2.93 1.73 2.93S8 12.38 8 15c0 2.63 2.14 4 4.44 4c2.94 0 4.56-1.96 4.56-1.96l-1.4-1.54s-1.46 1.37-3.01 1.37c-1.93 0-2.38-1.18-2.38-1.95c0-1.05.33-2.27 3.62-2.27l-.01-1.88s-3.38.34-3.38-1.99c0-1.57 1.46-1.86 2.2-1.86c1.64 0 2.41.86 2.41.86"/>'
        },
        equal: {
            body: '<path fill="currentColor" d="M19 10H5V8h14v2m0 6H5v-2h14v2Z"/>'
        },
        "equal-box": {
            body: '<path fill="currentColor" d="M17 16v-2H7v2h10m2-13a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14m-2 7V8H7v2h10Z"/>'
        },
        equalizer: {
            body: '<path fill="currentColor" d="M10 20h4V4h-4v16m-6 0h4v-8H4v8M16 9v11h4V9h-4Z"/>'
        },
        "equalizer-outline": {
            body: '<path fill="currentColor" d="M15 21H9V3h6v18m-4-2h2V5h-2v14m-3 2H2V11h6v10m-4-2h2v-6H4v6m18 2h-6V8h6v13m-4-2h2v-9h-2v9Z"/>'
        },
        eraser: {
            body: '<path fill="currentColor" d="m16.24 3.56l4.95 4.94c.78.79.78 2.05 0 2.84L12 20.53a4.008 4.008 0 0 1-5.66 0L2.81 17c-.78-.79-.78-2.05 0-2.84l10.6-10.6c.79-.78 2.05-.78 2.83 0M4.22 15.58l3.54 3.53c.78.79 2.04.79 2.83 0l3.53-3.53l-4.95-4.95l-4.95 4.95Z"/>'
        },
        "eraser-variant": {
            body: '<path fill="currentColor" d="M15.14 3c-.51 0-1.02.2-1.41.59L2.59 14.73c-.78.77-.78 2.04 0 2.83L5.03 20h7.66l8.72-8.73c.79-.77.79-2.04 0-2.83l-4.85-4.85c-.39-.39-.91-.59-1.42-.59M17 18l-2 2h7v-2"/>'
        },
        escalator: {
            body: '<path fill="currentColor" d="M20 8h-1.05l-12 12H4a2 2 0 0 1-2-2a2 2 0 0 1 2-2h1.29L7 14.29V10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.29L17.29 4H20a2 2 0 0 1 2 2a2 2 0 0 1-2 2M8.5 5A1.5 1.5 0 0 1 10 6.5A1.5 1.5 0 0 1 8.5 8A1.5 1.5 0 0 1 7 6.5A1.5 1.5 0 0 1 8.5 5Z"/>'
        },
        "escalator-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m9.34 3h2.71a2 2 0 0 1 2 2c0 1.11-.89 2-2 2H16l-6 8H7.05a2 2 0 1 1 0-4h1.29l6-8Z"/>'
        },
        "escalator-down": {
            body: '<path fill="currentColor" d="M20 8h-1.05l-12 12H4a2 2 0 1 1 0-4h1.29L7 14.29V10c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1.29L17.29 4H20c1.11 0 2 .89 2 2c0 1.11-.89 2-2 2M8.5 5c.83 0 1.5.67 1.5 1.5S9.33 8 8.5 8S7 7.33 7 6.5S7.67 5 8.5 5m6.33 12.34l5.51-5.51l1.83 1.83l-5.51 5.51L18.5 21H13v-5.5l1.83 1.84Z"/>'
        },
        "escalator-up": {
            body: '<path fill="currentColor" d="M20 8h-1.05l-12 12H4a2 2 0 1 1 0-4h1.29L7 14.29V10c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1.29L17.29 4H20c1.11 0 2 .89 2 2c0 1.11-.89 2-2 2M8.5 5c.83 0 1.5.67 1.5 1.5S9.33 8 8.5 8S7 7.33 7 6.5S7.67 5 8.5 5m11.67 10.66l-5.51 5.51l-1.83-1.83l5.51-5.51L16.5 12H22v5.5l-1.83-1.84Z"/>'
        },
        eslint: {
            body: '<path fill="currentColor" d="m7.95 9.55l3.89-2.25c.1-.05.22-.05.32 0l3.89 2.25c.1.06.16.16.16.27v4.5c0 .11-.06.21-.16.27l-3.89 2.25a.36.36 0 0 1-.32 0l-3.89-2.25a.315.315 0 0 1-.16-.27v-4.5c0-.11.06-.21.16-.27m14.17 2.05c.17.29.17.63 0 .93l-4.65 8.03c-.17.3-.47.44-.82.44h-9.3c-.35 0-.65-.15-.82-.44l-4.65-8.03a.949.949 0 0 1 0-.95L6.53 3.5c.17-.28.47-.5.82-.5h9.3c.35 0 .65.22.82.5l4.65 8.1m-3.85 3.9V8.65c0-.12-.07-.23-.18-.29l-5.93-3.41a.325.325 0 0 0-.33 0L5.91 8.36c-.11.06-.18.17-.18.29v6.85c0 .11.07.22.18.28l5.93 3.41c.1.06.23.06.33 0l5.92-3.41a.33.33 0 0 0 .18-.28Z"/>'
        },
        et: {
            body: '<path fill="currentColor" d="m23 8.78l-1.29-1.56c-.26.2-1.18.78-1.94.78c-.51 0-1.47-.25-2.32-.47C16.39 7.26 15.39 7 14.6 7c-.6 0-1.17.15-1.67.35A3.973 3.973 0 0 0 9 4c-4.42 0-7 3.58-7 8s3.58 7 8 7c2.06 0 3.93-.57 5.34-1.61l-.34 3.9l2 .18l1-11.73c.66.15 1.27.26 1.77.26c1.61 0 3.07-1.09 3.23-1.22M9 6a2 2 0 0 1 2 2a2 2 0 0 1-2 2H4.23C4.8 7.67 6.39 6 9 6m1 11c-3.31 0-6-1.69-6-5h5c1.6 0 2.83-.83 3.5-2.09c.26-.2 1.35-.91 2.1-.91c.34 0 .9.11 1.45.25l-.4 4.64C14.82 15.95 12.6 17 10 17Z"/>'
        },
        ethereum: {
            body: '<path fill="currentColor" d="m12 1.75l-6.25 10.5L12 16l6.25-3.75L12 1.75M5.75 13.5L12 22.25l6.25-8.75L12 17.25L5.75 13.5Z"/>'
        },
        ethernet: {
            body: '<path fill="currentColor" d="M7 15h2v3h2v-3h2v3h2v-3h2v3h2V9h-4V6H9v3H5v9h2v-3M4.38 3h15.25A2.37 2.37 0 0 1 22 5.38v14.25A2.37 2.37 0 0 1 19.63 22H4.38A2.37 2.37 0 0 1 2 19.63V5.38C2 4.06 3.06 3 4.38 3Z"/>'
        },
        "ethernet-cable": {
            body: '<path fill="currentColor" d="M11 3v4h2V3h-2M8 4v7h8V4h-2v4h-4V4H8m2 8v10h4V12h-4Z"/>'
        },
        "ethernet-cable-off": {
            body: '<path fill="currentColor" d="M11 3h2v4h-2V3M8 4h2v4h4V4h2v7h-3.18L8 6.18V4m12 16.72L18.73 22L14 17.27V22h-4v-8.73l-8-8L3.28 4L20 20.72Z"/>'
        },
        etsy: {
            body: '<path d="M6.72 20.78c1.51-.07 3.35 0 5.15 0c1.85 0 3.75-.12 5.25 0c.6.05 1.16.41 1.65.09c.39-.49.1-1.16.19-1.82c.16-1.27 1.32-2.78-.37-3.1c-.72.66-.24 1.28-.64 2.1c-.5.98-2.27 1.32-3.95 1.45c-1.46.12-4 .26-4.5-.73c-.46-.83-.21-2.12-.21-3.19c0-1.2-.13-2.36.21-3.28c1.82.13 4.2-.61 5.5.2c.87.5.37 1.56 1.38 1.9c.69-.19.32-1.08.28-1.9c-.03-.56-.03-1.31 0-1.93c.03-.84.34-1.81-.56-1.83c-.71.56-.17 1.49-.92 2.01c-.23.17-.75.25-1.1.25c-1.38.17-3.54.05-4.7-.16c-.15-1.68-.14-3.97 0-5.65c.62-.62 2.07-.65 3.04-.64c1.71 0 4.37.15 4.88 1c.28.45.06 1.45.55 1.55c1 .23.51-1.55.56-2.37c.03-.62.3-1.01.18-1.46c-.32-.44-.8-.22-1.09-.18c-3.15.41-7.9.18-11.24.18c-.4 0-1.1-.2-1.38.27c-.2 1.06 1.24.62 1.74 1.19c.17.18.41 1 .46 1.55c.15 1.46 0 3.69 0 5.84c0 2.26.18 4.55 0 5.93c-.08.48-.35 1.25-.46 1.36c-.62.63-2.28-.06-2.12 1.28c.59.39 1.43.13 2.22.09z" fill="currentColor"/>',
            hidden: true
        },
        "ev-plug-ccs1": {
            body: '<path fill="currentColor" d="M7.5 20c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5M18 18.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5m4 1.5c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4s1.8-4 4-4h.3C4.3 14.4 3 11.8 3 9c0-5 4-9 9-9s9 4 9 9c0 2.8-1.3 5.4-3.3 7h.3c2.2 0 4 1.8 4 4m-10-4c3.9 0 7-3.1 7-7s-3.1-7-7-7s-7 3.1-7 7s3.1 7 7 7m8 4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2s.9 2 2 2h12c1.1 0 2-.9 2-2M12.9 6.3c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8s-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8m-5.4 0c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8s-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8m1.8 3.9c0 .6-.5 1.1-1.1 1.1c-.6 0-1.1-.5-1.1-1.1S7.5 9 8.1 9c.7 0 1.2.6 1.2 1.2m4.5 2.5c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8s1.8.8 1.8 1.8m3.2-2.5c0 .6-.5 1.1-1.1 1.1c-.6 0-1.1-.5-1.1-1.1S15.2 9 15.9 9c.6 0 1.1.6 1.1 1.2"/>'
        },
        "ev-plug-ccs2": {
            body: '<path fill="currentColor" d="M7.5 19c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5M18 17.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5m0-2.5h-.3c2-1.6 3.3-4.2 3.3-7s-1.3-5.4-3.3-7H6.3C4.3 2.6 3 5.2 3 8s1.3 5.4 3.3 7H6c-2.2 0-4 1.8-4 4s1.8 4 4 4h12c2.2 0 4-1.8 4-4s-1.8-4-4-4M5 8c0-1.9.8-3.7 2.1-5h9.8C18.2 4.3 19 6.1 19 8c0 3.9-3.1 7-7 7s-7-3.1-7-7m13 13H6c-1.1 0-2-.9-2-2s.9-2 2-2h12c1.1 0 2 .9 2 2s-.9 2-2 2M12.9 5.3c0 .7.6 1.3 1.3 1.3c.7 0 1.3-.6 1.3-1.3S14.9 4 14.1 4c-.7 0-1.2.6-1.2 1.3m-4.3 0c0 .7.6 1.3 1.3 1.3c.7 0 1.3-.6 1.3-1.3S10.6 4 9.9 4c-.8 0-1.3.6-1.3 1.3M7.7 10c1 0 1.7-.8 1.7-1.7c0-.9-.8-1.7-1.7-1.7S6 7.3 6 8.3c0 .9.8 1.7 1.7 1.7m3.9 1.7c0-.9-.8-1.7-1.7-1.7c-1 0-1.7.8-1.7 1.7c0 1 .8 1.7 1.7 1.7c.9 0 1.7-.7 1.7-1.7M12 10c1 0 1.7-.8 1.7-1.7c0-.9-.8-1.7-1.7-1.7s-1.7.8-1.7 1.7c0 .9.8 1.7 1.7 1.7m3.9 1.7c0-.9-.8-1.7-1.7-1.7c-1 0-1.7.8-1.7 1.7c0 1 .8 1.7 1.7 1.7c.9 0 1.7-.7 1.7-1.7M18 8.3c0-.9-.8-1.7-1.7-1.7c-1 0-1.7.8-1.7 1.7c0 1 .8 1.7 1.7 1.7c.9 0 1.7-.8 1.7-1.7"/>'
        },
        "ev-plug-chademo": {
            body: '<path fill="currentColor" d="M7.5 9.5C6.1 9.5 5 10.6 5 12s1.1 2.5 2.5 2.5S10 13.4 10 12S8.9 9.5 7.5 9.5m9 0c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5S19 13.4 19 12s-1.1-2.5-2.5-2.5M12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8s-8-3.6-8-8s3.6-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 3c-1.4 0-2.5 1.1-2.5 2.5S10.6 10 12 10s2.5-1.1 2.5-2.5S13.4 5 12 5m1.5 2.5c0 .2-.1.4-.2.6l-.6-.6l.6-.6c.1.2.2.4.2.6m-.9-1.3l-.6.6l-.6-.6c.2-.1.4-.2.6-.2s.4.1.6.2m-1.9 1.9c-.1-.2-.2-.4-.2-.6s.1-.4.2-.6l.6.6l-.6.6m.7.7l.6-.6l.6.6c-.2.1-.4.2-.6.2s-.4-.1-.6-.2M12 14c-1.4 0-2.5 1.1-2.5 2.5S10.6 19 12 19s2.5-1.1 2.5-2.5S13.4 14 12 14m1.5 2.5c0 .2-.1.4-.2.6l-.6-.6l.6-.6c.1.2.2.4.2.6m-.9-1.3l-.6.6l-.6-.6c.2-.1.4-.2.6-.2s.4.1.6.2m-1.9 1.9c-.1-.2-.2-.4-.2-.6s.1-.4.2-.6l.6.6l-.6.6m.7.7l.6-.6l.6.6c-.2.1-.4.2-.6.2s-.4-.1-.6-.2Z"/>'
        },
        "ev-plug-tesla": {
            body: '<path fill="currentColor" d="M6 9c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m11 1c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m5-.07V11a9 9 0 0 1-9 9h-2c-4.97 0-9-4-9-9V9.93C2 6.65 4.65 4 7.93 4h8.14C19.35 4 22 6.65 22 9.93M14.5 9a2.5 2.5 0 0 0 5 0a2.5 2.5 0 0 0-5 0m-10 0a2.5 2.5 0 0 0 5 0a2.5 2.5 0 0 0-5 0M9 17c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m4.5 0c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5m3.5 0c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m2.97-5.34C19.23 12.5 18.18 13 17 13c-2.21 0-4-1.79-4-4c0-1.2.54-2.27 1.38-3H9.62c.84.73 1.38 1.8 1.38 3c0 2.21-1.79 4-4 4a3.9 3.9 0 0 1-2.97-1.34c.16 1.66.9 3.16 2.01 4.28C7.71 14.73 9.76 14 12 14c2.24 0 4.29.73 5.96 1.94a7.044 7.044 0 0 0 2.01-4.28Z"/>'
        },
        "ev-plug-type1": {
            body: '<path fill="currentColor" d="M13 9c0 1.1.9 2 2 2s2-.9 2-2s-.9-2-2-2s-2 .9-2 2M7 9c0 1.1.9 2 2 2s2-.9 2-2s-.9-2-2-2s-2 .9-2 2m2 4.2c0-.6-.6-1.2-1.2-1.2s-1.2.6-1.2 1.2s.6 1.2 1.2 1.2S9 13.9 9 13.2m5 2.8c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2M12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8s-8-3.6-8-8s3.6-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m5.5 11.2c0-.7-.6-1.2-1.2-1.2c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2c.6.1 1.2-.5 1.2-1.2"/>'
        },
        "ev-plug-type2": {
            body: '<path fill="currentColor" d="M17.3 5C19 6.5 20 8.6 20 11c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-2.4 1.1-4.5 2.7-6h10.6m.7-2H6l-.6.5C3.2 5.4 2 8.1 2 11c0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.9-1.2-5.6-3.4-7.5L18 3m-5 4.5c0 .8.7 1.5 1.5 1.5S16 8.3 16 7.5S15.3 6 14.5 6S13 6.7 13 7.5m-5 0C8 8.3 8.7 9 9.5 9S11 8.3 11 7.5S10.3 6 9.5 6S8 6.7 8 7.5M7 13c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4.5 2c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2m.5-2c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4.5 2c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2m2.5-4c0-1.1-.9-2-2-2s-2 .9-2 2s.9 2 2 2s2-.9 2-2"/>'
        },
        "ev-station": {
            body: '<path fill="currentColor" d="m19.77 7.23l.01-.01l-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21a1 1 0 0 1-1 1a1 1 0 0 1-1-1V14a2 2 0 0 0-2-2h-1V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16h10v-7.5h1.5v5A2.5 2.5 0 0 0 18 21a2.5 2.5 0 0 0 2.5-2.5V9c0-.69-.28-1.32-.73-1.77M18 10a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1M8 18v-4.5H6L10 6v5h2l-4 7Z"/>'
        },
        eventbrite: {
            body: '<path d="M12 17.5c-1.85 0-3.58-.94-4.59-2.5l10-2.25l4.67-1a9.76 9.76 0 0 0-1-4.11C18.66 2.61 12.62.5 7.58 2.92C2.55 5.34.44 11.38 2.86 16.41c2.43 5.03 8.47 7.15 13.5 4.73c2.14-1.05 3.89-2.83 4.86-5.03L16.61 15A5.47 5.47 0 0 1 12 17.5m0-11c1.76 0 3.41.84 4.44 2.27l-9.87 2.42A5.49 5.49 0 0 1 12 6.5z" fill="currentColor"/>',
            hidden: true
        },
        evernote: {
            body: '<path fill="currentColor" d="M15.09 11.63s.19-1.28.91-1.28c.76 0 1.78 1.71 1.78 1.71s-2.32-.43-2.69-.43M19 4.69c-.36-.6-2.17-1.28-3.11-1.28H13.5S12.7 2 10.88 2c-1.83 0-1.71.81-1.71 1.5v2.82l-.83.87H4.5s-1.06.72-1.06 2.25c0 1.56.48 6.91 3.69 7.41c3.8.58 4.45-1.18 4.45-1.39c0-.9.02-2.25.02-2.25s1.11 2.12 2.79 2.12s2.65.97 2.65 1.96v1.84S17 20.28 16 20.28h-2.11s-.69-.54-.69-1.28c0-.75.33-.95.73-.95c.39 0 .72.04.72.04v-1.56s-3.18-.03-3.18 2.41c0 2.43 1.66 3.06 2.99 3.06h2.17s3.93-.5 3.93-8.25S19.33 5.28 19 4.69M7.5 6.31H4.26l4.06-4.09V5.5l-.82.81Z"/>'
        },
        excavator: {
            body: '<path fill="currentColor" d="M18.5 18.5c.54 0 1 .46 1 1s-.46 1-1 1h-12c-.54 0-1-.46-1-1s.46-1 1-1h12m0-1.5h-12C5.13 17 4 18.13 4 19.5S5.13 22 6.5 22h12a2.5 2.5 0 0 0 0-5m2.5-6h-3V7h-5l-3 4v5h12l-1-5m-9.46 0l1.96-2.5H16V11h-4.46M9.76 3.41L4.76 2L2 11.83c-.34 1.28.41 2.61 1.7 2.97l1.16.32l3.29-2.83l-3.88-1.08l1.88-6.75l2.79.78c.56.29 1.77 1.1 2.53 2.13L12.5 6h.44c-1.26-1.59-3.09-2.54-3.18-2.59Z"/>'
        },
        exclamation: {
            body: '<path fill="currentColor" d="M11 4h2v11h-2V4Zm2 14v2h-2v-2h2Z"/>'
        },
        "exclamation-thick": {
            body: '<path fill="currentColor" d="M10 3h4v11h-4V3m0 18v-4h4v4h-4Z"/>'
        },
        "exit-run": {
            body: '<path fill="currentColor" d="M13.34 8.17c-.93 0-1.69-.77-1.69-1.7a1.69 1.69 0 0 1 1.69-1.69c.94 0 1.7.76 1.7 1.69c0 .93-.76 1.7-1.7 1.7M10.3 19.93l-5.93-1.18l.34-1.7l4.15.85l1.35-6.86l-1.52.6v2.86H7v-3.96l4.4-1.87l.67-.08c.6 0 1.1.34 1.43.85l.86 1.35c.68 1.21 2.03 2.03 3.64 2.03v1.68c-1.86 0-3.56-.83-4.66-2.1l-.5 2.54l1.77 1.69V23h-1.69v-5.1l-1.78-1.69l-.84 3.72M21 23h-2V3H6v13.11l-2-.42V1h17v22M6 23H4v-3.22l2 .42V23Z"/>'
        },
        "exit-to-app": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8.92 12.58L11.5 17l5-5l-5-5l-1.42 1.41L12.67 11H3v2h9.67l-2.59 2.58Z"/>'
        },
        "expand-all": {
            body: '<path fill="currentColor" d="M18 8H8v10H6V8a2 2 0 0 1 2-2h10v2m-4-6H4a2 2 0 0 0-2 2v10h2V4h10V2m8 10v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-2 3h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z"/>'
        },
        "expand-all-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v10h2V4h10V2H4m4 4a2 2 0 0 0-2 2v10h2V8h10V6H8m12 6v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m-1 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2Z"/>'
        },
        "expansion-card": {
            body: '<path fill="currentColor" d="M2 7v1.5h1V17h1.5V7H2m4 0v9h1v1h7v-1h8V7H6m11.5 2a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5A2.5 2.5 0 0 1 17.5 9Z"/>'
        },
        "expansion-card-variant": {
            body: '<path fill="currentColor" d="M2 7h2.5v10H3V8.5H2M22 7v9h-8v1H7v-1H6V7m4 2H8v3h2m3-3h-2v3h2m7-3h-5v5h5V9Z"/>'
        },
        exponent: {
            body: '<path fill="currentColor" d="m15.38 3l2.39 5.75c-.22.93-.5 1.57-.77 1.95c-.33.48-.56.55-.81.55v1.5c.75 0 1.55-.4 2.05-1.19C19.87 8.94 22 3 22 3h-1.62l-1.69 4.05L17 3h-1.62M3.42 8.59L2 10l4.79 4.79L2 19.59L3.41 21l4.8-4.79L13 21l1.41-1.41l-4.79-4.8L14.41 10L13 8.59l-4.79 4.79l-4.8-4.79h.01Z"/>'
        },
        "exponent-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m8.76 3h1.63l1.11 2.6L17.59 6h1.65s-1.74 4.57-2.78 6.32c-.38.57-1.11.95-1.96.93v-1.5c.46.01.75-.25 1-.62c.11-.13.18-.33.24-.49L13.76 6M6.41 9.59l2.8 2.79L12 9.59L13.41 11l-2.79 2.79l2.79 2.8L12 18l-2.79-2.79L6.41 18L5 16.59l2.79-2.8L5 11l1.41-1.41Z"/>'
        },
        export: {
            body: '<path fill="currentColor" d="m23 12l-4-4v3h-9v2h9v3M1 18V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3h-2V6H3v12h12v-3h2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2Z"/>'
        },
        "export-variant": {
            body: '<path fill="currentColor" d="M12 1L8 5h3v9h2V5h3m2 18H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3v2H6v12h12V9h-3V7h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Z"/>'
        },
        eye: {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5Z"/>'
        },
        "eye-arrow-left": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.36 0 .72 0 1.08-.05a6.09 6.09 0 0 1-.08-.95c0-.56.08-1.12.24-1.66c-.41.1-.82.16-1.24.16c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5c0 .29-.03.59-.08.88c.66-.25 1.37-.38 2.08-.38c1.17 0 2.31.34 3.29 1c.27-.5.51-1 .71-1.5c-1.73-4.39-6-7.5-11-7.5M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m6 6v2h4v2h-4v2l-3-3l3-3"/>'
        },
        "eye-arrow-left-outline": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.36 0 .72 0 1.08-.05a6.09 6.09 0 0 1-.08-.95c0-.36.04-.72.1-1.08c-.36.04-.73.08-1.1.08c-3.76 0-7.17-2.14-8.82-5.5a9.821 9.821 0 0 1 17.64 0c-.12.24-.26.45-.39.68c.66.16 1.29.43 1.86.82c.27-.5.51-1 .71-1.5c-1.73-4.39-6-7.5-11-7.5M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m6 6v2h4v2h-4v2l-3-3l3-3"/>'
        },
        "eye-arrow-right": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.7 7.6 1 12c1.7 4.4 6 7.5 11 7.5h1.1c-.1-.3-.1-.6-.1-1c0-.6.1-1.1.2-1.7c-.4.1-.8.2-1.2.2c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5c0 .3 0 .6-.1.9c.7-.2 1.4-.4 2.1-.4c1.2 0 2.3.3 3.3 1c.3-.5.5-1 .7-1.5c-1.7-4.4-6-7.5-11-7.5M12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3m7 12v-2h-4v-2h4v-2l3 3l-3 3"/>'
        },
        "eye-arrow-right-outline": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.7 7.6 1 12c1.7 4.4 6 7.5 11 7.5h1.1c-.1-.3-.1-.6-.1-1s0-.7.1-1.1c-.4 0-.7.1-1.1.1c-3.8 0-7.2-2.1-8.8-5.5c1.6-3.4 5-5.5 8.8-5.5s7.2 2.1 8.8 5.5c-.1.2-.3.4-.4.7c.7.2 1.3.4 1.9.8c.3-.5.5-1 .7-1.5c-1.7-4.4-6-7.5-11-7.5M12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3m7 12v-2h-4v-2h4v-2l3 3l-3 3"/>'
        },
        "eye-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 8c.5 0 .97-.07 1.42-.21c-.27.71-.42 1.43-.42 2.21v.45l-1 .05c-5 0-9.27-3.11-11-7.5c1.73-4.39 6-7.5 11-7.5s9.27 3.11 11 7.5c-.25.64-.56 1.26-.92 1.85c-.9-.54-1.96-.85-3.08-.85c-.78 0-1.5.15-2.21.42c.14-.45.21-.92.21-1.42a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5Z"/>'
        },
        "eye-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4.5c5 0 9.27 3.11 11 7.5c-.25.65-.56 1.26-.92 1.85a5.77 5.77 0 0 0-1.9-.73l.64-1.12a9.821 9.821 0 0 0-17.64 0A9.821 9.821 0 0 0 12 17.5l1.21-.07c-.14.5-.21 1.03-.21 1.57v.46l-1 .04c-5 0-9.27-3.11-11-7.5c1.73-4.39 6-7.5 11-7.5Z"/>'
        },
        "eye-circle": {
            body: '<path fill="currentColor" d="M12 9.5A2.5 2.5 0 0 0 9.5 12a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 9.5m0 3.5a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m0-3.5A2.5 2.5 0 0 0 9.5 12a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 9.5m0 3.5a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m0-11A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 14c-2.63 0-5-1.57-6-4a6.505 6.505 0 0 1 8.5-3.5A6.52 6.52 0 0 1 18 12c-1 2.43-3.37 4-6 4m0-6.5A2.5 2.5 0 0 0 9.5 12a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 9.5m0 3.5a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        "eye-circle-outline": {
            body: '<path fill="currentColor" d="M12 22A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10m0-2a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m0-3c2.63 0 5 1.57 6 4a6.505 6.505 0 0 1-8.5 3.5A6.52 6.52 0 0 1 6 12c1-2.43 3.37-4 6-4m0 1.5A2.5 2.5 0 0 0 9.5 12a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 9.5"/>'
        },
        "eye-minus": {
            body: '<path fill="currentColor" d="M12 4.5A11.8 11.8 0 0 0 1 12a11.8 11.8 0 0 0 11 7.5h1.1a3.8 3.8 0 0 1-.1-1a9.9 9.9 0 0 1 .2-1.7L12 17a5 5 0 1 1 5-5a2.8 2.8 0 0 1-.1.9a5.2 5.2 0 0 1 2.1-.4a5.6 5.6 0 0 1 3.3 1A10.1 10.1 0 0 0 23 12a11.8 11.8 0 0 0-11-7.5M12 9a3 3 0 1 0 3 3a2.9 2.9 0 0 0-3-3m3 8.5v2h8v-2Z"/>'
        },
        "eye-minus-outline": {
            body: '<path fill="currentColor" d="M12 4.5A11.8 11.8 0 0 0 1 12a11.8 11.8 0 0 0 11 7.5h1.1a3.8 3.8 0 0 1-.1-1a4.1 4.1 0 0 1 .1-1.1H12A9.6 9.6 0 0 1 3.2 12A9.6 9.6 0 0 1 12 6.5a9.6 9.6 0 0 1 8.8 5.5l-.4.7a4.6 4.6 0 0 1 1.9.8A10.1 10.1 0 0 0 23 12a11.8 11.8 0 0 0-11-7.5M12 9a3 3 0 1 0 3 3a2.9 2.9 0 0 0-3-3m3 8.5v2h8v-2Z"/>'
        },
        "eye-off": {
            body: '<path fill="currentColor" d="M11.83 9L15 12.16V12a3 3 0 0 0-3-3h-.17m-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28l.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5c1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22L21 20.73L3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75c-1.73-4.39-6-7.5-11-7.5c-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7Z"/>'
        },
        "eye-off-outline": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58c-5 0-9.27-3.11-11-7.5c.69-1.76 1.79-3.31 3.19-4.54L2 5.27M12 9a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9m0-4.5c5 0 9.27 3.11 11 7.5a11.79 11.79 0 0 1-4 5.19l-1.42-1.43A9.862 9.862 0 0 0 20.82 12A9.821 9.821 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97M3.18 12A9.821 9.821 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13Z"/>'
        },
        "eye-outline": {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4.5c5 0 9.27 3.11 11 7.5c-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5M3.18 12a9.821 9.821 0 0 0 17.64 0a9.821 9.821 0 0 0-17.64 0Z"/>'
        },
        "eye-plus": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.36 0 .72 0 1.08-.05a6.09 6.09 0 0 1-.08-.95c0-.56.08-1.12.24-1.66c-.41.1-.82.16-1.24.16a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5c0 .29-.03.59-.08.88c.66-.25 1.37-.38 2.08-.38c1.17 0 2.31.34 3.29 1c.27-.5.51-1 .71-1.5c-1.73-4.39-6-7.5-11-7.5M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m6 5.5v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "eye-plus-outline": {
            body: '<path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.36 0 .72 0 1.08-.05a6.09 6.09 0 0 1-.08-.95c0-.36.04-.72.1-1.08c-.36.04-.73.08-1.1.08c-3.76 0-7.17-2.14-8.82-5.5a9.821 9.821 0 0 1 17.64 0c-.12.24-.26.45-.39.68c.66.16 1.29.43 1.86.82c.27-.5.51-1 .71-1.5c-1.73-4.39-6-7.5-11-7.5M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m6 5.5v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "eye-refresh": {
            body: '<path fill="currentColor" d="M12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3m6 9.5l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4m-5.9 1s-.1 0 0 0C7 19.5 2.7 16.4 1 12c1.7-4.4 6-7.5 11-7.5s9.3 3.1 11 7.5c-.2.4-.4.9-.6 1.3c-1.1-.8-2.4-1.3-3.9-1.3c-.5 0-1 .1-1.5.2V12c0-2.8-2.2-5-5-5s-5 2.2-5 5s2.2 5 5 5h.2c-.1.5-.2 1-.2 1.5c0 .3 0 .7.1 1Z"/>'
        },
        "eye-refresh-outline": {
            body: '<path fill="currentColor" d="M12 9c1.7 0 3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3s1.3-3 3-3m6 9.5l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4m-6 0c0-.3 0-.7.1-1H12c-3.8 0-7.2-2.1-8.8-5.5c1.6-3.4 5-5.5 8.8-5.5s7.2 2.1 8.8 5.5c-.1.1-.1.2-.2.4c.6.2 1.2.5 1.8.9c.2-.4.4-.9.6-1.3c-1.7-4.4-6-7.5-11-7.5S2.7 7.6 1 12c1.7 4.4 6 7.5 11 7.5h.1c-.1-.3-.1-.7-.1-1Z"/>'
        },
        "eye-remove": {
            body: '<path fill="currentColor" d="M22.54 16.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 8c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5c0 .5-.1 1-.23 1.43c.69-.27 1.44-.43 2.23-.43c1.12 0 2.17.32 3.07.85c.36-.58.67-1.2.93-1.85c-1.73-4.39-6-7.5-11-7.5S2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.35 0 .69 0 1.03-.05c-.03-.15-.03-.3-.03-.45c0-.79.16-1.54.43-2.23c-.43.13-.93.23-1.43.23Z"/>'
        },
        "eye-remove-outline": {
            body: '<path fill="currentColor" d="M22.54 16.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 8.5c-3.76 0-7.17-2.14-8.82-5.5a9.821 9.821 0 0 1 17.64 0c-.19.39-.41.77-.65 1.13c.68.13 1.33.37 1.9.72c.36-.58.67-1.2.93-1.85c-1.73-4.39-6-7.5-11-7.5S2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5c.35 0 .69 0 1.03-.05c-.03-.15-.03-.3-.03-.45c0-.55.08-1.08.22-1.59c-.4.05-.81.09-1.22.09Z"/>'
        },
        "eye-settings": {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-12.5c-4.86 0-9.22 3-11 7.5c2.39 6.08 9.25 9.06 15.33 6.67c3.05-1.2 5.47-3.61 6.67-6.67c-1.78-4.5-6.14-7.5-11-7.5M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "eye-settings-outline": {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4.5c4.86 0 9.22 3 11 7.5c-2.39 6.08-9.25 9.06-15.33 6.67C4.62 17.47 2.2 15.06 1 12c1.78-4.5 6.14-7.5 11-7.5M3.18 12c2.38 4.87 8.27 6.89 13.14 4.5a9.811 9.811 0 0 0 4.5-4.5c-2.38-4.87-8.27-6.89-13.14-4.5a9.811 9.811 0 0 0-4.5 4.5M9 22H7v2h2v-2m4 0h-2v2h2v-2m4 0h-2v2h2v-2Z"/>'
        },
        eyedropper: {
            body: '<path fill="currentColor" d="m19.35 11.72l-2.13 2.13l-1.41-1.42l-7.71 7.71L3.5 22L2 20.5l1.86-4.6l7.71-7.71l-1.42-1.41l2.13-2.13l7.07 7.07M16.76 3A3 3 0 0 1 21 3a3 3 0 0 1 0 4.24l-1.92 1.92l-4.24-4.24L16.76 3M5.56 17.03L4.5 19.5l2.47-1.06L14.4 11L13 9.6l-7.44 7.43Z"/>'
        },
        "eyedropper-minus": {
            body: '<path fill="currentColor" d="m19.35 11.72l-2.13 2.13l-1.41-1.42l-7.71 7.71L3.5 22L2 20.5l1.86-4.6l7.71-7.71l-1.42-1.41l2.13-2.13l7.07 7.07M16.76 3c1.17-1.17 3.07-1.17 4.24 0s1.17 3.07 0 4.24l-1.92 1.92l-4.24-4.24L16.76 3M5.56 17.03L4.5 19.5l2.47-1.06L14.4 11L13 9.6l-7.44 7.43M9 4v2H1V4h8Z"/>'
        },
        "eyedropper-off": {
            body: '<path fill="currentColor" d="m21 7.24l-1.92 1.92l-4.24-4.24L16.76 3c1.17-1.17 3.07-1.17 4.24 0s1.17 3.07 0 4.24M10.94 8.82l1.42 1.42l.64-.64l1.4 1.4l-.64.64l1.42 1.42l.63-.63l1.41 1.42l2.13-2.13l-7.07-7.07l-2.13 2.13l1.42 1.41l-.63.63m8.92 11.47l-1.28 1.28l-5.95-5.96l-4.53 4.53L3.5 22L2 20.5l1.86-4.6l4.53-4.53l-6.53-6.52l1.28-1.28l16.72 16.72m-8.65-6.09l-1.4-1.41l-4.25 4.24L4.5 19.5l2.47-1.06l4.24-4.24Z"/>'
        },
        "eyedropper-plus": {
            body: '<path fill="currentColor" d="m19.35 11.72l-2.13 2.13l-1.41-1.42l-7.71 7.71L3.5 22L2 20.5l1.86-4.6l7.71-7.71l-1.42-1.41l2.13-2.13l7.07 7.07M16.76 3c1.17-1.17 3.07-1.17 4.24 0s1.17 3.07 0 4.24l-1.92 1.92l-4.24-4.24L16.76 3M5.56 17.03L4.5 19.5l2.47-1.06L14.4 11L13 9.6l-7.44 7.43M6 1v3h3v2H6v3H4V6H1V4h3V1h2Z"/>'
        },
        "eyedropper-remove": {
            body: '<path fill="currentColor" d="m19.35 11.72l-2.13 2.13l-1.41-1.42l-7.71 7.71L3.5 22L2 20.5l1.86-4.6l7.71-7.71l-1.42-1.41l2.13-2.13l7.07 7.07M16.76 3c1.17-1.17 3.07-1.17 4.24 0s1.17 3.07 0 4.24l-1.92 1.92l-4.24-4.24L16.76 3M5.56 17.03L4.5 19.5l2.47-1.06L14.4 11L13 9.6l-7.44 7.43M8.54 2.88L6.41 5l2.13 2.12l-1.42 1.42L5 6.41L2.88 8.54L1.46 7.12L3.59 5L1.46 2.88l1.42-1.41L5 3.59l2.12-2.12l1.42 1.41Z"/>'
        },
        "eyedropper-variant": {
            body: '<path fill="currentColor" d="M6.92 19L5 17.08L13.06 9L15 10.94m5.71-5.31l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-3.12 3.12l-1.93-1.91l-1.41 1.41l1.42 1.42L3 16.25V21h4.75l8.92-8.92l1.42 1.42l1.41-1.41l-1.92-1.92l3.12-3.12c.4-.4.4-1.05.01-1.42Z"/>'
        },
        "face-agent": {
            body: '<path fill="currentColor" d="M18.72 14.76c.35-.85.54-1.76.54-2.76c0-.72-.11-1.41-.3-2.05c-.65.15-1.33.23-2.04.23A9.07 9.07 0 0 1 9.5 6.34a9.21 9.21 0 0 1-4.73 4.88c-.04.25-.04.52-.04.78A7.27 7.27 0 0 0 12 19.27c1.05 0 2.06-.23 2.97-.64c.57 1.09.83 1.63.81 1.63c-1.64.55-2.91.82-3.78.82c-2.42 0-4.73-.95-6.43-2.66a9.03 9.03 0 0 1-2.24-3.69H2v-4.55h1.09a9.09 9.09 0 0 1 15.33-4.6a8.991 8.991 0 0 1 2.47 4.6H22v4.55h-.06L18.38 18l-5.3-.6v-1.67h4.83l.81-.97m-9.45-2.99c.3 0 .59.12.8.34a1.136 1.136 0 0 1 0 1.6c-.21.21-.5.33-.8.33c-.63 0-1.14-.5-1.14-1.13c0-.63.51-1.14 1.14-1.14m5.45 0c.63 0 1.13.51 1.13 1.14c0 .63-.5 1.13-1.13 1.13c-.63 0-1.14-.5-1.14-1.13a1.14 1.14 0 0 1 1.14-1.14Z"/>'
        },
        "face-man": {
            body: '<path fill="currentColor" d="M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75m6 0A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8c0-.29 0-.58.05-.86c2.36-1.05 4.23-2.98 5.21-5.37a9.974 9.974 0 0 0 10.41 3.97c.21.71.33 1.47.33 2.26c0 4.41-3.59 8-8 8Z"/>'
        },
        "face-man-outline": {
            body: '<path fill="currentColor" d="M10.25 13A1.25 1.25 0 0 1 9 14.25A1.25 1.25 0 0 1 7.75 13A1.25 1.25 0 0 1 9 11.75A1.25 1.25 0 0 1 10.25 13M15 11.75A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75m7 .25a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12M4.42 9.47a8.046 8.046 0 0 0 3.66-4.44a8.046 8.046 0 0 0-3.66 4.44M20 12c0-.78-.12-1.53-.33-2.24c-.7.15-1.42.24-2.17.24a10 10 0 0 1-7.76-3.69A10.016 10.016 0 0 1 4 11.86V12c0 4.41 3.59 8 8 8s8-3.59 8-8Z"/>'
        },
        "face-man-profile": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 6.39A9.973 9.973 0 0 0 17.42 10c.78 0 1.53-.09 2.25-.26c.21.71.33 1.47.33 2.26c0 4.41-3.59 8-8 8c-3 0-5.61-1.66-7-4.11L6.75 14v-1A1.25 1.25 0 0 1 8 11.75A1.25 1.25 0 0 1 9.25 13v1H12m4-2.25A1.25 1.25 0 0 0 14.75 13A1.25 1.25 0 0 0 16 14.25A1.25 1.25 0 0 0 17.25 13A1.25 1.25 0 0 0 16 11.75Z"/>'
        },
        "face-man-shimmer": {
            body: '<path fill="currentColor" d="M18.41 3.41L16 4.5l2.41 1.09L19.5 8l1.1-2.41L23 4.5l-2.4-1.09L19.5 1M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10c0-1.47-.33-2.87-.9-4.13l-1.24 2.72c.08.46.14.91.14 1.41c0 4.43-3.57 8-8 8s-8-3.57-8-8v-.13a10 10 0 0 0 5.74-5.56A10 10 0 0 0 17.5 10a10 10 0 0 0 1.33-.09l-1.48-3.26L12.6 4.5l3.53-1.6C14.87 2.33 13.47 2 12 2m-3 9.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75m6 0A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z"/>'
        },
        "face-man-shimmer-outline": {
            body: '<path fill="currentColor" d="m19.5 1l-1.09 2.41L16 4.5l2.41 1.09L19.5 8l1.1-2.41L23 4.5l-2.4-1.09L19.5 1M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10c0-1.47-.33-2.87-.9-4.13l-1.24 2.7c.09.47.14.93.14 1.43c0 4.43-3.57 8-8 8s-8-3.57-8-8v-.14a10 10 0 0 0 5.74-5.55a9.994 9.994 0 0 0 9.09 3.6L17.96 8h-.46c-2.82 0-5.4-1.5-6.84-3.88c.44-.07.88-.12 1.34-.12c.5 0 .96.05 1.42.13l2.71-1.22A9.86 9.86 0 0 0 12 2M8.09 5a8 8 0 0 1-3.68 4.5C5.04 7.57 6.37 6 8.09 5M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75m6 0A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z"/>'
        },
        "face-mask": {
            body: '<path fill="currentColor" d="M20.25 6c-1.46 0-2.64 1.14-2.75 2.58l-4.95-1.42c-.36-.11-.74-.11-1.1 0L6.5 8.58C6.39 7.14 5.21 6 3.75 6C2.23 6 1 7.23 1 8.75v3.5C1 13.77 2.23 15 3.75 15h1.93c1.13 2.36 3.53 4 6.32 4s5.19-1.64 6.32-4h1.93c1.52 0 2.75-1.23 2.75-2.75v-3.5C23 7.23 21.77 6 20.25 6M5 13.5H3.75c-.69 0-1.25-.56-1.25-1.25v-3.5a1.25 1.25 0 0 1 2.5 0v4.75M15 12l-2.6-.7c-.3-.1-.6-.1-.8 0L9 12v-1l2.3-.7c.4-.1.9-.1 1.4 0l2.3.7v1m6.5.25c0 .69-.56 1.25-1.25 1.25H19V8.75a1.25 1.25 0 0 1 2.5 0v3.5Z"/>'
        },
        "face-mask-outline": {
            body: '<path fill="currentColor" d="m15 12l-2.6-.7c-.3-.1-.6-.1-.8 0L9 12v-1l2.3-.7c.4-.1.9-.1 1.4 0l2.3.7v1m5.25-6c-1.46 0-2.64 1.14-2.75 2.58l-4.95-1.42c-.18-.05-.36-.08-.55-.08c-.18 0-.37.03-.55.08L6.5 8.58C6.39 7.14 5.21 6 3.75 6C2.23 6 1 7.23 1 8.75v3.5C1 13.77 2.23 15 3.75 15h1.93c1.13 2.36 3.53 4 6.32 4s5.19-1.64 6.32-4h1.93c1.52 0 2.75-1.23 2.75-2.75v-3.5C23 7.23 21.77 6 20.25 6M5 13.5H3.75c-.69 0-1.25-.56-1.25-1.25v-3.5a1.25 1.25 0 0 1 2.5 0v4.75M17 12c0 2.76-2.24 5-5 5s-5-2.24-5-5v-1.5l5-1.42l5 1.42V12m4.5.25c0 .69-.56 1.25-1.25 1.25H19V8.75a1.25 1.25 0 0 1 2.5 0v3.5Z"/>'
        },
        "face-recognition": {
            body: '<path fill="currentColor" d="M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75m6 0A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a4.12 4.12 0 0 1 0-.86a10.05 10.05 0 0 0 5.26-5.37A9.985 9.985 0 0 0 17.42 10c.76 0 1.51-.09 2.25-.26c1.25 4.26-1.17 8.69-5.41 9.93c-.76.22-1.5.33-2.26.33M0 2a2 2 0 0 1 2-2h4v2H2v4H0V2m24 20a2 2 0 0 1-2 2h-4v-2h4v-4h2v4M2 24a2 2 0 0 1-2-2v-4h2v4h4v2H2M22 0a2 2 0 0 1 2 2v4h-2V2h-4V0h4Z"/>'
        },
        "face-woman": {
            body: '<path fill="currentColor" d="M13.75 13a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0M22 12v10H2V12C2 6.5 6.5 2 12 2s10 4.5 10 10M4 12c0 4.41 3.59 8 8 8s8-3.59 8-8c0-.79-.12-1.55-.33-2.26A9.974 9.974 0 0 1 9.26 5.77c-.98 2.39-2.85 4.32-5.21 5.37c-.05.28-.05.57-.05.86m5 2.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5Z"/>'
        },
        "face-woman-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12v10h20V12c0-5.5-4.5-10-10-10m0 2c2.9 0 5.44 1.56 6.84 3.88c-.43.07-.88.12-1.34.12c-2.9 0-5.44-1.56-6.84-3.88c.43-.07.88-.12 1.34-.12M8.08 5.03a8.046 8.046 0 0 1-3.66 4.44a8.046 8.046 0 0 1 3.66-4.44M4 11.86c2.6-.98 4.69-2.99 5.74-5.55A10 10 0 0 0 17.5 10c.75 0 1.47-.09 2.17-.24c.21.71.33 1.46.33 2.24c0 4.41-3.59 8-8 8s-8-3.59-8-8v-.14M4 20v-2c.57.75 1.25 1.43 2 2H4m16 0h-2c.75-.57 1.43-1.25 2-2v2m-6.25-7a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0m-6 0a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0Z"/>'
        },
        "face-woman-profile": {
            body: '<path fill="currentColor" d="M17.25 13a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0M22 12c0 5.5-4.5 10-10 10H2V12C2 6.5 6.5 2 12 2s10 4.5 10 10M7 18c1.41 1.23 3 2 5 2c4.41 0 8-3.59 8-8c0-.79-.12-1.55-.33-2.26c-.72.17-1.47.26-2.25.26c-2 0-3.85-.6-5.42-1.61c0 0-1.46 5.37-3.97 4.61c-.66-.2-1.03.31-1.03 1"/>'
        },
        "face-woman-shimmer": {
            body: '<path fill="currentColor" d="m19.5 1l-1.09 2.41L16 4.5l2.41 1.09L19.5 8l1.1-2.41L23 4.5l-2.4-1.09L19.5 1M12 2C6.5 2 2 6.5 2 12v10h20V12c0-1.47-.33-2.87-.9-4.13l-1.24 2.72c.08.46.14.91.14 1.41c0 4.43-3.57 8-8 8s-8-3.57-8-8v-.13a10 10 0 0 0 5.74-5.56A10 10 0 0 0 17.5 10a10 10 0 0 0 1.33-.09l-1.48-3.26L12.6 4.5l3.53-1.6C14.87 2.33 13.47 2 12 2m-3 9.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75m6 0A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z"/>'
        },
        "face-woman-shimmer-outline": {
            body: '<path fill="currentColor" d="m19.5 1l-1.09 2.41L16 4.5l2.41 1.09L19.5 8l1.1-2.41L23 4.5l-2.4-1.09M12 2C6.5 2 2 6.5 2 12v10h20V12c0-1.47-.33-2.87-.9-4.13l-1.24 2.7c.09.47.14.93.14 1.43c0 4.43-3.57 8-8 8s-8-3.57-8-8v-.14a9.928 9.928 0 0 0 5.74-5.55a9.994 9.994 0 0 0 9.09 3.6L17.96 8h-.46c-2.82 0-5.4-1.5-6.84-3.88c.44-.07.88-.12 1.34-.12c.5 0 .96.05 1.42.13l2.71-1.22A9.86 9.86 0 0 0 12 2M8.09 5a8.117 8.117 0 0 1-3.68 4.5C5.04 7.57 6.37 6 8.09 5M9 11.75a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5M4 17.97c.58.77 1.26 1.45 2.03 2.03H4m16-2.03V20h-2.03c.77-.58 1.45-1.26 2.03-2.03Z"/>'
        },
        facebook: {
            body: '<path fill="currentColor" d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02Z"/>'
        },
        "facebook-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" fill="currentColor"/>',
            hidden: true
        },
        "facebook-gaming": {
            body: '<path fill="currentColor" d="M9.5 14.5v-5H21V21h-5.5v-6.5h-6M3 3h18v5.5H8.5v7h6V21H3V3Z"/>'
        },
        "facebook-messenger": {
            body: '<path fill="currentColor" d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7C22 6.13 17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63Z"/>'
        },
        "facebook-workplace": {
            body: '<path fill="currentColor" d="M19.69 16.12c-.27.31-.74.8-1.5.8c-1.06 0-1.41-.77-1.73-1.58l-1.6-3.93l-1.6 3.93c-.26.66-.56 1.58-1.73 1.58s-1.46-.92-1.74-1.58L7.11 8.72h2.26l2.16 5.45l1.61-3.97c.25-.63.55-1.58 1.72-1.58c1.14 0 1.46.95 1.72 1.58l1.75 4.3c.89-1.36 1.27-3 1.05-4.61a6.712 6.712 0 0 0-2.24-4.16a6.729 6.729 0 0 0-4.42-1.67c-1.69-.01-3.33.52-4.72 1.5a8.064 8.064 0 0 0-2.88 3.98c-.52 1.6-.52 3.33 0 4.93c.52 1.6 1.54 2.99 2.91 3.97c1.37.99 3.01 1.51 4.69 1.5c.73 0 1.45-.1 2.15-.3v2.11c-.71.16-1.43.25-2.15.25c-2.11 0-4.18-.66-5.9-1.9c-1.72-1.24-3-2.99-3.65-5a9.883 9.883 0 0 1-.01-6.2c.66-2.01 1.94-3.76 3.66-5C8.53 2.66 10.6 2 12.72 2c4.84 0 8.78 3.94 8.78 8.79c0 1.92-.64 3.8-1.81 5.33Z"/>'
        },
        factory: {
            body: '<path fill="currentColor" d="M4 18v2h4v-2H4m0-4v2h10v-2H4m6 4v2h4v-2h-4m6-4v2h4v-2h-4m0 4v2h4v-2h-4M2 22V8l5 4V8l5 4V8l5 4l1-10h3l1 10v10H2Z"/>'
        },
        "family-tree": {
            body: '<path fill="currentColor" d="M12 1a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 11 5.79V7H7a2 2 0 0 0-2 2v.71A2.5 2.5 0 0 0 3.5 12A2.5 2.5 0 0 0 5 14.29V15H4a2 2 0 0 0-2 2v1.21A2.5 2.5 0 0 0 .5 20.5A2.5 2.5 0 0 0 3 23a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 4 18.21V17h4v1.21a2.5 2.5 0 0 0-1.5 2.29A2.5 2.5 0 0 0 9 23a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-1.5-2.29V17a2 2 0 0 0-2-2H7v-.71A2.5 2.5 0 0 0 8.5 12A2.5 2.5 0 0 0 7 9.71V9h10v.71A2.5 2.5 0 0 0 15.5 12a2.5 2.5 0 0 0 1.5 2.29V15h-1a2 2 0 0 0-2 2v1.21a2.5 2.5 0 0 0-1.5 2.29A2.5 2.5 0 0 0 15 23a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-1.5-2.29V17h4v1.21a2.5 2.5 0 0 0-1.5 2.29A2.5 2.5 0 0 0 21 23a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-1.5-2.29V17a2 2 0 0 0-2-2h-1v-.71A2.5 2.5 0 0 0 20.5 12A2.5 2.5 0 0 0 19 9.71V9a2 2 0 0 0-2-2h-4V5.79a2.5 2.5 0 0 0 1.5-2.29A2.5 2.5 0 0 0 12 1m0 1.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M6 11a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m12 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M3 19.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        fan: {
            body: '<path fill="currentColor" d="M12 11a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m.5-9c4.5 0 4.61 3.57 2.25 4.75c-.99.49-1.43 1.54-1.62 2.47c.48.2.9.51 1.22.91c3.7-2 7.68-1.21 7.68 2.37c0 4.5-3.57 4.6-4.75 2.23c-.5-.99-1.56-1.43-2.49-1.62c-.2.48-.51.89-.91 1.23c1.99 3.69 1.2 7.66-2.38 7.66c-4.5 0-4.59-3.58-2.23-4.76c.98-.49 1.42-1.53 1.62-2.45c-.49-.2-.92-.52-1.24-.92C5.96 15.85 2 15.07 2 11.5C2 7 5.56 6.89 6.74 9.26c.5.99 1.55 1.42 2.48 1.61c.19-.48.51-.9.92-1.22C8.15 5.96 8.94 2 12.5 2Z"/>'
        },
        "fan-alert": {
            body: '<path fill="currentColor" d="M10 11c-.57 0-1 .45-1 1s.43 1 1 1c.54 0 1-.45 1-1s-.46-1-1-1m.5-9c4.5 0 4.59 3.57 2.23 4.75c-.99.49-1.43 1.54-1.62 2.47c.48.2.89.51 1.22.91c3.7-2 7.67-1.21 7.67 2.37c0 4.5-3.57 4.6-4.74 2.23c-.5-.99-1.56-1.43-2.49-1.62c-.2.48-.51.89-.91 1.23C13.85 18.03 13.06 22 9.5 22c-4.5 0-4.6-3.58-2.24-4.76c.98-.49 1.42-1.53 1.62-2.45c-.49-.2-.92-.52-1.24-.92C3.95 15.85 0 15.07 0 11.5C0 7 3.56 6.89 4.73 9.26c.5.99 1.55 1.42 2.48 1.61c.19-.48.51-.9.92-1.22C6.14 5.96 6.93 2 10.5 2M22 13V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "fan-auto": {
            body: '<path fill="currentColor" d="M12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2m-.5 9c.54 0 1 .45 1 1s-.46 1-1 1c-.57 0-1-.45-1-1s.43-1 1-1m6 4a2 2 0 0 0-2 2v6h2v-2h2v2h2v-6c0-1.1-.9-2-2-2m-2 2h2v2h-2Z"/>'
        },
        "fan-chevron-down": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m7 6.17L22.17 16l1.42 1.41L19 22l-4.59-4.59L15.83 16L19 19.17"/>'
        },
        "fan-chevron-up": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m7 4.83L15.83 21l-1.42-1.41L19 15l4.59 4.59L22.17 21L19 17.83"/>'
        },
        "fan-clock": {
            body: '<path fill="currentColor" d="M16 14h1.5v2.8l2.4 1.4l-.8 1.3l-3.1-1.8V14m5-2.7c-.2-3.4-4-4.1-7.7-2.1c-.3-.4-.7-.7-1.2-.9c.2-.9.6-2 1.6-2.5C16.1 4.6 16 1 11.5 1C7.9 1 7.2 5 9.1 8.7c-.4.3-.7.7-.9 1.2c-.9-.2-2-.6-2.5-1.6C4.6 5.9 1 6 1 10.5c0 3.6 4 4.3 7.7 2.4c.3.4.8.7 1.2.9c-.2.9-.6 2-1.6 2.5C5.9 17.4 6 21 10.5 21c.3 0 .5 0 .7-.1c1.3 1.9 3.4 3.1 5.8 3.1c3.9 0 7-3.1 7-7c0-2.4-1.2-4.5-3-5.7M11 10c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m6 12c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5Z"/>'
        },
        "fan-minus": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m11 5v2h-8v-2h8Z"/>'
        },
        "fan-off": {
            body: '<path fill="currentColor" d="M12.5 2C9.64 2 8.57 4.55 9.29 7.47L15 13.16c.87.21 1.81.65 2.28 1.57c1.18 2.37 4.75 2.27 4.75-2.23c0-3.58-3.98-4.37-7.68-2.37c-.32-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.11 5.57 17 2 12.5 2M3.28 4L2 5.27l2.47 2.46C3.22 7.74 2 8.87 2 11.5c0 3.57 3.96 4.35 7.65 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.91 18.42 7 22 11.5 22c2.3 0 3.44-1.64 3.44-3.79L18.73 22L20 20.72L3.28 4Z"/>'
        },
        "fan-plus": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m8 2v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "fan-remove": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m10.54 3.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41Z"/>'
        },
        "fan-speed-1": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m5 2v2h1v6h2v-8h-3Z"/>'
        },
        "fan-speed-2": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m4 2v2h3v1h-1c-1.1 0-2 .9-2 2v3h5v-2h-3v-1h1c1.11 0 2-.89 2-2v-1a2 2 0 0 0-2-2h-3Z"/>'
        },
        "fan-speed-3": {
            body: '<path fill="currentColor" d="M13 19c0-1.41.5-2.7 1.3-3.72c-.13-.31-.27-.63-.44-.94c.4-.34.71-.75.91-1.23c.49.1 1.01.28 1.48.56a5.997 5.997 0 0 1 5.64.07c.06-.37.11-.78.11-1.24c0-3.58-3.97-4.37-7.67-2.37c-.33-.4-.74-.71-1.22-.91c.19-.93.63-1.98 1.62-2.47C17.09 5.57 17 2 12.5 2c-3.57 0-4.36 3.96-2.37 7.65c-.41.32-.73.74-.92 1.22c-.93-.19-1.98-.62-2.48-1.61C5.56 6.89 2 7 2 11.5c0 3.57 3.95 4.35 7.64 2.37c.32.4.75.72 1.24.92c-.2.92-.64 1.96-1.62 2.45C6.9 18.42 7 22 11.5 22c.81 0 1.5-.22 2-.59c-.31-.74-.5-1.55-.5-2.41m-1-6c-.57 0-1-.45-1-1s.43-1 1-1c.54 0 1 .45 1 1s-.46 1-1 1m9 8v-.5c0-.83-.67-1.5-1.5-1.5c.83 0 1.5-.67 1.5-1.5V17a2 2 0 0 0-2-2h-3v2h3v1h-2v2h2v1h-3v2h3c1.11 0 2-.89 2-2"/>'
        },
        "fast-forward": {
            body: '<path fill="currentColor" d="M13 6v12l8.5-6M4 18l8.5-6L4 6v12Z"/>'
        },
        "fast-forward-10": {
            body: '<path fill="currentColor" d="M10 12v10H8v-8H6v-2h4m8 2v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-4 0v6h2v-6h-2M11.5 3c2.65 0 5.05 1 6.9 2.6L21 3v7h-7l2.62-2.62C15.23 6.22 13.46 5.5 11.5 5.5c-3.54 0-6.55 2.31-7.6 5.5l-2.37-.78C2.92 6.03 6.85 3 11.5 3Z"/>'
        },
        "fast-forward-15": {
            body: '<path fill="currentColor" d="M11.5 3c2.65 0 5.05 1 6.9 2.6L21 3v7h-7l2.62-2.62C15.23 6.22 13.46 5.5 11.5 5.5c-3.54 0-6.55 2.31-7.6 5.5l-2.37-.78C2.92 6.03 6.85 3 11.5 3M10 12v10H8v-8H6v-2h4m2 0h6v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-4v-2h4v-2h-4v-6Z"/>'
        },
        "fast-forward-30": {
            body: '<path fill="currentColor" d="M11.5 3c-4.65 0-8.58 3.03-9.97 7.22L3.9 11c1.05-3.19 4.06-5.5 7.6-5.5c1.96 0 3.73.72 5.12 1.88L14 10h7V3l-2.6 2.6C16.55 4 14.15 3 11.5 3M19 14v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-4 0v6h2v-6h-2m-4 6a2 2 0 0 1-2 2H5v-2h4v-2H7v-2h2v-2H5v-2h4a2 2 0 0 1 2 2v1.5A1.5 1.5 0 0 1 9.5 17a1.5 1.5 0 0 1 1.5 1.5V20Z"/>'
        },
        "fast-forward-45": {
            body: '<path fill="currentColor" d="M11.5 3c2.6 0 5 1 6.9 2.6L21 3v7h-7l2.6-2.6c-1.4-1.2-3.2-1.9-5.1-1.9C8 5.5 4.9 7.8 3.9 11l-2.4-.8C2.9 6 6.8 3 11.5 3m1.5 9h6v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2h4v-2h-4v-6m-8 0v6h4v4h2V12H9v4H7v-4H5Z"/>'
        },
        "fast-forward-5": {
            body: '<path fill="currentColor" d="M11.5 3c2.65 0 5.05 1 6.9 2.6L21 3v7h-7l2.62-2.62C15.23 6.22 13.46 5.5 11.5 5.5c-3.54 0-6.55 2.31-7.6 5.5l-2.37-.78C2.92 6.03 6.85 3 11.5 3M9 12h6v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2H9v-2h4v-2H9v-6Z"/>'
        },
        "fast-forward-60": {
            body: '<path fill="currentColor" d="M11.5 3c-4.7 0-8.6 3-10 7.2l2.4.8c1-3.2 4.1-5.5 7.6-5.5c2 0 3.7.7 5.1 1.9L14 10h7V3l-2.6 2.6C16.5 4 14.1 3 11.5 3M19 14v6c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2m-4 0v6h2v-6h-2m-8-2c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H7v-2h4v-2H7m0 6h2v2H7v-2Z"/>'
        },
        "fast-forward-outline": {
            body: '<path fill="currentColor" d="m15 9.9l3 2.1l-3 2.1V9.9m-9 0L9 12l-3 2.1V9.9M13 6v12l8.5-6L13 6M4 6v12l8.5-6L4 6Z"/>'
        },
        faucet: {
            body: '<path fill="currentColor" d="M19 14v2h-3v-1.72l3-.28m0-1c0-1.1-1-2-2.2-2H10v-1H5v11h5v-7.09l9-.91M5 9h5V7l5.36-1.79a.932.932 0 1 0-.61-1.76L5 7v2Z"/>'
        },
        "faucet-variant": {
            body: '<path fill="currentColor" d="M21 21H3c0-1.1.9-2 2-2h14c1.11 0 2 .89 2 2M19 7c0-1.61-1.07-4-4-4s-4 2.39-4 4v11h2V7c0-.46.17-2 2-2s2 1.54 2 2h-.5v2h3V7H19M7 12c-.55 0-1 .45-1 1v1H3v1h3v3h2v-5c0-.55-.45-1-1-1m14 2h-3v-1c0-.55-.45-1-1-1s-1 .45-1 1v5h2v-3h3v-1Z"/>'
        },
        fax: {
            body: '<path fill="currentColor" d="M19 9h-1V4H8v16h14v-8c0-1.66-1.34-3-3-3m-9-3h6v3h-6V6m4 11h-4v-5h4v5m2 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3 3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m0-3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M4.5 8A2.5 2.5 0 0 0 2 10.5v8a2.5 2.5 0 0 0 5 0v-8A2.5 2.5 0 0 0 4.5 8Z"/>'
        },
        feather: {
            body: '<path fill="currentColor" d="M22 2s-7.64-.37-13.66 7.88C3.72 16.21 2 22 2 22l1.94-1c1.44-2.5 2.19-3.53 3.6-5c2.53.74 5.17.65 7.46-2c-2-.56-3.6-.43-5.96-.19C11.69 12 13.5 11.6 16 12l1-2c-1.8-.34-3-.37-4.78.04C14.19 8.65 15.56 7.87 18 8l1.21-1.93c-1.56-.11-2.5.06-4.29.5c1.61-1.46 3.08-2.12 5.22-2.25c0 0 1.05-1.89 1.86-2.32Z"/>'
        },
        "feature-search": {
            body: '<path fill="currentColor" d="M20 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.5c-.3.8-.5 1.6-.5 2.5c0 3.6 2.9 6.5 6.5 6.5c.8 0 1.5-.1 2.1-.4L20 15v5m-.7-11.1c.4-.7.7-1.5.7-2.4C20 4 18 2 15.5 2S11 4 11 6.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.1 3.1l1.4-1.4l-3.1-3.1m-3.8.1C14.1 9 13 7.9 13 6.5S14.1 4 15.5 4S18 5.1 18 6.5S16.9 9 15.5 9Z"/>'
        },
        "feature-search-outline": {
            body: '<path fill="currentColor" d="M15.5 2C13 2 11 4 11 6.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.1 3.1l1.4-1.4l-3.1-3.1c.4-.7.7-1.5.7-2.4C20 4 18 2 15.5 2M4 4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5l-2-2v7H4V6h5.03c.06-.7.23-1.35.47-2H4m11.5 0C16.9 4 18 5.1 18 6.5S16.9 9 15.5 9S13 7.9 13 6.5S14.1 4 15.5 4Z"/>'
        },
        fedora: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.47 2 12v7.73C2 21 3 22 4.27 22H12c5.53 0 10-4.5 10-10S17.5 2 12 2m2.03 4.12c1.68 0 3.26 1.28 3.26 3.06c0 .16 0 .32-.02.51c-.05.47-.48.81-.95.75a.836.836 0 0 1-.7-.98c0-.06.01-.14.01-.28c0-1.01-.82-1.4-1.6-1.4c-.78 0-1.48.66-1.48 1.4c.01.85 0 1.7 0 2.56l1.45-.02c1.12-.02 1.13 1.68 0 1.67l-1.45.01l-.01 2.39c-.18 1.88-1.77 3.37-3.69 3.37c-2.03 0-3.71-1.66-3.71-3.7A3.801 3.801 0 0 1 9 11.74l1.15-.01v1.67L9 13.41h-.03c-1.16.03-2.15.82-2.16 2.06c0 1.12.91 2.03 2.04 2.03c1.15 0 2.03-.83 2.03-2.03c.02-2.01-.01-4.22 0-6.3c0-.12.01-.21.02-.34c.19-1.54 1.57-2.71 3.13-2.71"/>'
        },
        fence: {
            body: '<path fill="currentColor" d="M9 9v2H7V9H5v2H3V9H1v12h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2V9h-2v2h-2V9h-2v2h-2V9h-2v2h-2V9H9m-6 4h2v4H3v-4m4 0h2v4H7v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4Z"/>'
        },
        "fence-electric": {
            body: '<path fill="currentColor" d="M9 9v2H7V9H5v2H3V9H1v12h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2V9h-2v2h-2V9h-2v2h-2V9h-2v2h-2V9H9m-6 4h2v4H3v-4m4 0h2v4H7v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4M7 4h4V2l6 3h-4v2L7 4Z"/>'
        },
        fencing: {
            body: '<path fill="currentColor" d="m4.5 17.42l1.08 1.08l-2.3 2.28c-.28.29-.78.29-1.06 0s-.29-.78 0-1.06l2.28-2.3m13.79-12V4L12 10.29L5.71 4v1.42L11.29 11L7.5 14.81c-1.18-.84-2.82-.74-3.87.31l4.25 4.25c1.05-1.05 1.15-2.69.32-3.87L18.29 5.42m3.49 14.3l-2.28-2.3l-1.08 1.08l2.3 2.28c.28.29.78.29 1.06 0s.29-.78 0-1.06m-5.28-4.91l-3.08-3.1l-.71.71l3.1 3.08c-.84 1.18-.74 2.82.31 3.87l4.25-4.25c-1.05-1.05-2.69-1.15-3.87-.31Z"/>'
        },
        "ferris-wheel": {
            body: '<path fill="currentColor" d="M12 19c.86 0 1.59.54 1.87 1.29c.55-.12 1.08-.29 1.59-.52l-1.76-4.15c-.52.25-1.09.38-1.7.38c-.61 0-1.18-.13-1.7-.38l-1.76 4.15c.51.23 1.04.4 1.59.52c.28-.75 1.01-1.29 1.87-1.29m6.25-1.24c-.25-.34-.44-.76-.44-1.26c0-1.09.9-2 2-2l.31.03c.25-.8.38-1.65.38-2.53c0-.88-.13-1.73-.38-2.5h-.31c-1.11 0-2-.89-2-2c0-.5.16-.91.44-1.26a8.474 8.474 0 0 0-4.38-2.53C13.59 4.46 12.86 5 12 5c-.86 0-1.59-.54-1.87-1.29a8.474 8.474 0 0 0-4.38 2.53c.28.35.45.79.45 1.26a2 2 0 0 1-2 2h-.32c-.25.78-.38 1.62-.38 2.5c0 .89.14 1.74.39 2.55l.31-.05c1.11 0 2 .92 2 2c0 .5-.16.93-.44 1.27c.32.35.68.67 1.05.96l1.9-4.46C8.26 13.62 8 12.84 8 12a4 4 0 0 1 4-4a4 4 0 0 1 4 4c0 .84-.26 1.62-.71 2.27l1.9 4.46c.38-.29.73-.62 1.06-.97M12 23c-1 0-1.84-.74-2-1.71a9.51 9.51 0 0 1-1.85-.6L7.17 23H5l1.41-3.32a8.59 8.59 0 0 1-1.45-1.31c-.24.1-.49.13-.76.13a2 2 0 0 1-2-2c0-.62.3-1.18.77-1.55a9.49 9.49 0 0 1-.01-5.87A2.006 2.006 0 0 1 4.2 5.5c.26 0 .51.06.73.15A9.397 9.397 0 0 1 10 2.71C10.16 1.74 11 1 12 1s1.84.74 2 1.71c2 .42 3.74 1.47 5.06 2.93c.23-.09.48-.14.75-.14a2 2 0 0 1 2 2a2 2 0 0 1-.77 1.57c.3.93.46 1.93.46 2.93c0 1-.16 2-.46 2.93c.46.37.77.94.77 1.57c0 1.12-.89 2-2 2c-.27 0-.52-.04-.76-.14c-.44.49-.93.93-1.46 1.32L19 23h-2.17l-.98-2.31c-.6.26-1.22.47-1.85.6c-.16.97-1 1.71-2 1.71Z"/>'
        },
        ferry: {
            body: '<path fill="currentColor" d="M6 6h12v3.96L12 8L6 9.96M3.94 19H4c1.6 0 3-.88 4-2c1 1.12 2.4 2 4 2s3-.88 4-2c1 1.12 2.4 2 4 2h.05l1.9-6.69c.08-.25.05-.53-.06-.77c-.13-.24-.34-.42-.6-.5L20 10.62V6a2 2 0 0 0-2-2h-3V1H9v3H6a2 2 0 0 0-2 2v4.62l-1.29.42c-.26.08-.47.26-.6.5c-.11.24-.14.52-.06.77M20 21c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2h-2Z"/>'
        },
        file: {
            body: '<path fill="currentColor" d="M13 9V3.5L18.5 9M6 2c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6Z"/>'
        },
        "file-account": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m8 18v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "file-account-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-5-7c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m2 5v1H7v-1c0-1.33 2.67-2 4-2s4 .67 4 2Z"/>'
        },
        "file-alert": {
            body: '<path fill="currentColor" d="M20 17h2v-2h-2v2m0-10v6h2V7M4 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m-1 1.5L16.5 9H11Z"/>'
        },
        "file-alert-outline": {
            body: '<path fill="currentColor" d="M20 17h2v-2h-2v2m0-10v6h2V7M4 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6M4 4h7v5h5v11H4Z"/>'
        },
        "file-arrow-left-right": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V8l-6-6H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-6-9.5L18.5 9H13V3.5m7 16V18h-4v-2h4v-1.5l3 2.5l-3 2.5m-2 .5h4v2h-4v1.5L15 21l3-2.5V20Z"/>'
        },
        "file-arrow-left-right-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V9h-5V4H6v16h7.09M23 17l-3-2.5V16h-4v2h4v1.5l3-2.5m-5 1.5L15 21l3 2.5V22h4v-2h-4v-1.5Z"/>'
        },
        "file-arrow-up-down": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V8l-6-6H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-6-9.5L18.5 9H13V3.5M23.5 20L21 23l-2.5-3H20v-4h2v4h1.5m-4-2H18v4h-2v-4h-1.5l2.5-3l2.5 3Z"/>'
        },
        "file-arrow-up-down-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V9h-5V4H6v16h7.09M17 15l-2.5 3H16v4h2v-4h1.5L17 15m5 5v-4h-2v4h-1.5l2.5 3l2.5-3H22Z"/>'
        },
        "file-cabinet": {
            body: '<path fill="currentColor" d="M14 8h-4V6h4v2m6-4v16c0 1.11-.89 2-2 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2m-2 9H6v7h12v-7m0-9H6v7h12V4m-4 11h-4v2h4v-2Z"/>'
        },
        "file-cad": {
            body: '<path fill="currentColor" d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m-1 1.5L18.5 9H13m-3.12.25h1.24v.94c.69-.01 1.26.56 1.26 1.25v2.06l-.12.13l.89 1.54c.32-.5.48-1.08.47-1.67h1.26c0 1.04-.38 2.05-1.05 2.85l1.67 2.9v1.25l-1.08-.62l-1.55-2.69c-.7.46-1.53.7-2.37.7c-.84 0-1.66-.24-2.37-.7l-1.55 2.69l-1.08.62v-1.25l3.24-5.62l-.12-.13v-2.06c0-.69.57-1.26 1.26-1.25m.62 1.25c-.69 0-1.04.84-.55 1.33c.49.49 1.33.15 1.33-.55c0-.43-.35-.78-.78-.78m-.84 3.1l-.9 1.57c1.05.71 2.43.71 3.48 0l-.9-1.57c-.47.46-1.21.46-1.68 0Z"/>'
        },
        "file-cad-box": {
            body: '<path fill="currentColor" d="M5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7.75 2.25h1.5v1.13c.83 0 1.5.67 1.5 1.5v2.49l-.14.13l1.07 1.86c.37-.6.57-1.29.57-2h1.5A5.2 5.2 0 0 1 16 13.77l2 3.48v1.5L16.7 18l-1.86-3.22a5.182 5.182 0 0 1-5.68 0L7.3 18l-1.3.75v-1.5l3.89-6.75l-.14-.13V7.88c0-.83.67-1.5 1.5-1.5m.75 1.5c-.84 0-1.26 1.02-.66 1.62A.943.943 0 1 0 12 7.88m-1 3.72l-1.09 1.9c1.26.86 2.92.86 4.18 0L13 11.6c-.57.51-1.43.51-2 0Z"/>'
        },
        "file-cancel": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m4.5 9C8 11 6 13 6 15.5S8 20 10.5 20s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m0 1.5a3 3 0 0 1 3 3c0 .56-.15 1.08-.42 1.5L9 12.92c.42-.27.94-.42 1.5-.42m-3 3c0-.56.15-1.08.42-1.5L12 18.08c-.42.27-.94.42-1.5.42a3 3 0 0 1-3-3Z"/>'
        },
        "file-cancel-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-6.5-10c2.5 0 4.5 2 4.5 4.5S14 19 11.5 19S7 17 7 14.5S9 10 11.5 10m0 1.5c-.56 0-1.08.15-1.5.42L14.08 16c.27-.42.42-.94.42-1.5a3 3 0 0 0-3-3m-3 3a3 3 0 0 0 3 3c.56 0 1.08-.15 1.5-.42L8.92 13c-.27.42-.42.94-.42 1.5Z"/>'
        },
        "file-certificate": {
            body: '<path fill="currentColor" d="M14 2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3v3l2-1l2 1v-3h3a2 2 0 0 0 2-2V7m-5 8v2l-2-1l-2 1v-2l-2-1l2-1v-2l2 1l2-1v2l2 1m-3-6V3.5L17.5 8Z"/>'
        },
        "file-certificate-outline": {
            body: '<path fill="currentColor" d="M14 13v-2l-2 1l-2-1v2l-2 1l2 1v2l2-1l2 1v-2l2-1M14 2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h1v-2H7V4h6v4h4v10h-1v2h1a2 2 0 0 0 2-2V7m-5 6v-2l-2 1l-2-1v2l-2 1l2 1v2l2-1l2 1v-2l2-1m-6 9l2-1l2 1v-5h-4m4-5v-2l-2 1l-2-1v2l-2 1l2 1v2l2-1l2 1v-2l2-1Z"/>'
        },
        "file-chart": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m1 18h2v-6H7v6m4 0h2v-8h-2v8m4 0h2v-4h-2v4Z"/>'
        },
        "file-chart-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.8c-.5-.9-.8-1.9-.8-3v1h-2v-8h2v7c0-3.3 2.7-6 6-6c.3 0 .7 0 1 .1V8l-6-6H6m7 1.5L18.5 9H13V3.5M7 14h2v6H7v-6Z"/>'
        },
        "file-chart-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.8c-.4-.6-.6-1.3-.7-2H6V4h7v5h5v4.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V8l-6-6H6m5 9v8h2v-8h-2m-4 2v6h2v-6H7Z"/>'
        },
        "file-chart-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7v5h5v11m-9-7v6H7v-6h2m6 2v4h2v-4h-2m-4-4v8h2v-8h-2Z"/>'
        },
        "file-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .08V8l-6-6m-1 1.5L18.5 9H13Z"/>'
        },
        "file-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5m-10.41 3H6V4h7v5h5v4.09c.33-.05.66-.09 1-.09s.67.04 1 .09V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.35-.61-.6-1.28-.72-2Z"/>'
        },
        "file-clock": {
            body: '<path fill="currentColor" d="M4 2c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h8.41A7 7 0 0 0 16 23a7 7 0 0 0 7-7a7 7 0 0 0-5-6.7V8l-6-6H4m7 1.5L16.5 9H11V3.5m5 7.5a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m-1 1v5l3.61 2.16l.75-1.22l-2.86-1.69V12H15Z"/>'
        },
        "file-clock-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8.41A7 7 0 0 0 16 23a7 7 0 0 0 7-7a7 7 0 0 0-5-6.7V8l-6-6H4m0 2h7v5h5a7 7 0 0 0-7 7a7 7 0 0 0 1.26 4H4V4m12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m-1 1v5l3.61 2.16l.75-1.22l-2.86-1.69V12H15Z"/>'
        },
        "file-cloud": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m9.68 13a3.758 3.758 0 0 0-7-1A3.028 3.028 0 0 0 6 17a3 3 0 0 0 3 3h6.5a2.5 2.5 0 0 0 2.5-2.5c0-1.32-1.03-2.39-2.32-2.5Z"/>'
        },
        "file-cloud-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-1-3.08c0 1.15-.93 2.08-2.08 2.08H9.5A2.5 2.5 0 0 1 7 16.5c0-1.29 1-2.35 2.23-2.5c.52-1 1.56-1.67 2.77-1.67c1.5 0 2.78 1.09 3.07 2.5c1.07.1 1.93.99 1.93 2.09Z"/>'
        },
        "file-code": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m.12 13.5l3.74 3.74l1.42-1.41l-2.33-2.33l2.33-2.33l-1.42-1.41l-3.74 3.74m11.16 0l-3.74-3.74l-1.42 1.41l2.33 2.33l-2.33 2.33l1.42 1.41l3.74-3.74Z"/>'
        },
        "file-code-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8.46-4.35l2.09 2.09L10.35 19L7 15.65l3.35-3.35l1.28 1.26l-2.09 2.09m7.46 0L13.65 19l-1.27-1.26l2.09-2.09l-2.09-2.09l1.27-1.26L17 15.65Z"/>'
        },
        "file-cog": {
            body: '<path fill="currentColor" d="M6 2c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h6.68a7 7 0 0 1-.68-3a7 7 0 0 1 7-7a7 7 0 0 1 1 .08V8l-6-6H6m7 1.5L18.5 9H13V3.5M18 14a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 20 14h-2m1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "file-cog-outline": {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h6v-2H6V4h7v5h5v3h2V8l-6-6m4 12a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 20 14m-1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "file-compare": {
            body: '<path fill="currentColor" d="M10 18H6v-2h4v2m0-4H6v-2h4v2m0-13v1H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h4v1h2V1h-2m10 7v12c0 1.11-.89 2-2 2h-4v-2h4v-9h-4V9h4.5L14 4.5V2l6 6m-4 6h-2v-2h2v2m0 4h-2v-2h2v2Z"/>'
        },
        "file-delimited": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m1 14l-2 4h-3l2-4H9v-5h6v5m-2-7V3.5L18.5 9H13Z"/>'
        },
        "file-delimited-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8-1l2-4H9v-5h6v5l-2 4h-3"/>'
        },
        "file-document": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m9 16v-2H6v2h9m3-4v-2H6v2h12Z"/>'
        },
        "file-document-alert": {
            body: '<path fill="currentColor" d="M20 17h2v-2h-2v2m0-10v6h2V7h-2m-9 2h5.5L11 3.5V9M4 2h8l6 6v12c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m9 16v-2H4v2h9m3-4v-2H4v2h12Z"/>'
        },
        "file-document-alert-outline": {
            body: '<path fill="currentColor" d="M20 17h2v-2h-2v2m0-10v6h2V7M6 16h5v2H6m0-6h8v2H6M4 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6M4 4h7v5h5v11H4Z"/>'
        },
        "file-document-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-.33.03-.67.08-1H6v-2h7.81c.46-.8 1.1-1.5 1.87-2H6v-2h12v1.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6m-1 1.5L18.5 9H13Z"/>'
        },
        "file-document-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M6 2a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.36-.62-.61-1.3-.73-2H6V4h7v5h5v4.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6M8 12v2h8v-2m-8 4v2h5v-2Z"/>'
        },
        "file-document-edit": {
            body: '<path fill="currentColor" d="M6 2c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h4v-1.91L12.09 18H6v-2h8.09l2-2H6v-2h12.09L20 10.09V8l-6-6H6m7 1.5L18.5 9H13V3.5m7.15 9.5a.55.55 0 0 0-.4.16l-1.02 1.02l2.09 2.08l1.02-1.01c.21-.22.21-.58 0-.79l-1.3-1.3a.544.544 0 0 0-.39-.16m-2.01 1.77L12 20.92V23h2.08l6.15-6.15l-2.09-2.08Z"/>'
        },
        "file-document-edit-outline": {
            body: '<path fill="currentColor" d="M8 12h8v2H8v-2m2 8H6V4h7v5h5v3.1l2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4v-2m-2-2h4.1l.9-.9V16H8v2m12.2-5c.1 0 .3.1.4.2l1.3 1.3c.2.2.2.6 0 .8l-1 1l-2.1-2.1l1-1c.1-.1.2-.2.4-.2m0 3.9L14.1 23H12v-2.1l6.1-6.1l2.1 2.1Z"/>'
        },
        "file-document-minus": {
            body: '<path fill="currentColor" d="M15 18h8v2h-8M6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-.33.03-.67.08-1H6v-2h7.81c.46-.8 1.1-1.5 1.87-2H6v-2h12v1.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6m-1 1.5L18.5 9H13Z"/>'
        },
        "file-document-minus-outline": {
            body: '<path fill="currentColor" d="M23 18h-8v2h8M6 2a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.36-.62-.61-1.3-.73-2H6V4h7v5h5v4.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6M8 12v2h8v-2m-8 4v2h5v-2Z"/>'
        },
        "file-document-multiple": {
            body: '<path fill="currentColor" d="M4 4v18h16v2H4c-1.1 0-2-.9-2-2V4h2m11 3h5.5L15 1.5V7M8 0h8l6 6v12c0 1.11-.89 2-2 2H8a2 2 0 0 1-2-2V2c0-1.11.89-2 2-2m9 16v-2H8v2h9m3-4v-2H8v2h12Z"/>'
        },
        "file-document-multiple-outline": {
            body: '<path fill="currentColor" d="M16 0H8C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6l-6-6m4 18H8V2h7v5h5v11M4 4v18h16v2H4c-1.1 0-2-.9-2-2V4h2m6 6v2h8v-2h-8m0 4v2h5v-2h-5Z"/>'
        },
        "file-document-outline": {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6m0 2h7v5h5v11H6V4m2 8v2h8v-2H8m0 4v2h5v-2H8Z"/>'
        },
        "file-document-plus": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-.33.03-.67.08-1H6v-2h7.81c.46-.8 1.1-1.5 1.87-2H6v-2h12v1.08c.33-.05.67-.08 1-.08s.67.03 1 .08V8l-6-6m-1 7V3.5L18.5 9H13m5 6v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "file-document-plus-outline": {
            body: '<path fill="currentColor" d="M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3M6 2a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.36-.62-.61-1.3-.73-2H6V4h7v5h5v4.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6M8 12v2h8v-2m-8 4v2h5v-2Z"/>'
        },
        "file-document-remove": {
            body: '<path fill="currentColor" d="M21.12 15.46L19 17.59l-2.12-2.13l-1.42 1.42L17.59 19l-2.13 2.12l1.42 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12M6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-.33.03-.67.08-1H6v-2h7.81c.46-.8 1.1-1.5 1.87-2H6v-2h12v1.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6m-1 1.5L18.5 9H13Z"/>'
        },
        "file-document-remove-outline": {
            body: '<path fill="currentColor" d="M22.54 21.12L20.41 19l2.13-2.12l-1.42-1.42L19 17.59l-2.12-2.13l-1.42 1.42L17.59 19l-2.13 2.12l1.42 1.42L19 20.41l2.12 2.13M6 2a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.36-.62-.61-1.3-.73-2H6V4h7v5h5v4.08c.33-.05.67-.08 1-.08c.34 0 .67.03 1 .08V8l-6-6M8 12v2h8v-2m-8 4v2h5v-2Z"/>'
        },
        "file-download": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m-2 17l-4-4h2.5v-3h3v3H16l-4 4m1-10V3.5L18.5 9H13Z"/>'
        },
        "file-download-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-6-1l-4-4h2.5v-3h3v3H16l-4 4Z"/>'
        },
        "file-edit": {
            body: '<path fill="currentColor" d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h4v-1.9l10-10V8l-6-6H6m7 1.5L18.5 9H13V3.5m7.1 9.5c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-2 1.8L12 20.9V23h2.1l6.1-6.1l-2.1-2.1Z"/>'
        },
        "file-edit-outline": {
            body: '<path fill="currentColor" d="M10 20H6V4h7v5h5v3.1l2-2V8l-6-6H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h4v-2m10.2-7c.1 0 .3.1.4.2l1.3 1.3c.2.2.2.6 0 .8l-1 1l-2.1-2.1l1-1c.1-.1.2-.2.4-.2m0 3.9L14.1 23H12v-2.1l6.1-6.1l2.1 2.1Z"/>'
        },
        "file-excel": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.8 18H14l-2-3.4l-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4l2-3.4h1.8l-2.9 4.5l2.9 4.5M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-excel-box": {
            body: '<path fill="currentColor" d="M16.2 17h-2L12 13.2L9.8 17h-2l3.2-5l-3.2-5h2l2.2 3.8L14.2 7h2L13 12m6-9H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "file-excel-box-outline": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m0 2h14v14H5V5m8 7l3.2 5h-2L12 13.2L9.8 17h-2l3.2-5l-3.2-5h2l2.2 3.8L14.2 7h2L13 12Z"/>'
        },
        "file-excel-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-5.1-5.5l2.9 4.5H14l-2-3.4l-2 3.4H8.2l2.9-4.5L8.2 10H10l2 3.4l2-3.4h1.8l-2.9 4.5Z"/>'
        },
        "file-export": {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-1 1.5L18.5 9H13m-4.07 3.22H16v7.07l-2.12-2.12L11.05 20l-2.83-2.83l2.83-2.82"/>'
        },
        "file-export-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7v5h5v11m-2-9v7.1L13.9 16l-2.8 2.8L8.3 16l2.8-2.8L8.9 11H16Z"/>'
        },
        "file-eye": {
            body: '<path fill="currentColor" d="M17 18c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c-2.73 0-5.06 1.66-6 4c.94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5m-7.86-1.75L8.85 19l.29-.74C10.43 15.06 13.5 13 17 13c1.05 0 2.06.21 3 .56V8l-6-6H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h4.5c-.55-.66-1-1.42-1.36-2.25M13 3.5L18.5 9H13V3.5Z"/>'
        },
        "file-eye-outline": {
            body: '<path fill="currentColor" d="M17 18c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c-2.73 0-5.06 1.66-6 4c.94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5M9.27 20H6V4h7v5h5v4.07c.7.08 1.36.25 2 .49V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.5a8.15 8.15 0 0 1-1.23-2Z"/>'
        },
        "file-find": {
            body: '<path fill="currentColor" d="M9 13a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3m11 6.59V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.76.83-2.76.83a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5c0 1-.31 1.96-.83 2.75L20 19.59Z"/>'
        },
        "file-find-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6M6 4h7l5 5v8.58l-1.84-1.84a4.97 4.97 0 0 0-.66-6.28A4.921 4.921 0 0 0 12 8c-1.28 0-2.55.5-3.53 1.46c-1.97 1.95-1.97 5.11 0 7.04c.97 1 2.25 1.47 3.53 1.47c.96 0 1.92-.28 2.75-.83L17.6 20H6V4m8.11 11.1c-.56.56-1.31.9-2.11.9c-.8 0-1.55-.33-2.11-.9C9.33 14.54 9 13.79 9 13c0-.81.32-1.56.89-2.12c.56-.57 1.31-.88 2.11-.88c.8 0 1.55.31 2.11.88c.56.56.89 1.31.89 2.12c0 .79-.32 1.54-.89 2.1Z"/>'
        },
        "file-gif-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 7.5H7.5v3h1V12H10v1.7c0 .7-.5 1.3-1.3 1.3H7.3c-.8 0-1.3-.7-1.3-1.3v-3.3C6 9.7 6.5 9 7.3 9h1.3c.9 0 1.4.7 1.4 1.3v.2m3 4.5h-1.5V9H13v6m4.5-4.5H16v1h1.5V13H16v2h-1.5V9h3v1.5Z"/>'
        },
        "file-hidden": {
            body: '<path fill="currentColor" d="M13 9h1v2h-3V7h2v2m5.5 0l-2.12-2.12l1.25-1.25L20 8v2h-2v1h-3V9h3.5M13 3.5V2h-1v2h1v2h-2V4H9V2H8v2H6v1H4V4c0-1.11.89-2 2-2h8l2.36 2.36l-1.25 1.25L13 3.5M20 20a2 2 0 0 1-2 2h-2v-2h2v-1h2v1m-2-5h2v3h-2v-3m-6 7v-2h3v2h-3m-4 0v-2h3v2H8m-2 0a2 2 0 0 1-2-2v-2h2v2h1v2H6m-2-8h2v3H4v-3m0-4h2v3H4v-3m14 1h2v3h-2v-3M4 6h2v3H4V6Z"/>'
        },
        "file-image": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m0 18h12v-8l-4 4l-2-2l-6 6M8 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "file-image-box": {
            body: '<path d="M8.5 13.498l2.5 3.006l3.5-4.506l4.5 6H5m16 1v-14a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z" fill="currentColor"/>',
            hidden: true
        },
        "file-image-marker": {
            body: '<path fill="currentColor" d="m6 20l6-6l1.03 1.03c.25-2.77 2.65-5.03 5.47-5.03c.5 0 1 .08 1.5.22V8l-6-6H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h9.91c-.41-.56-.91-1.24-1.36-2H6m7-16.5L18.5 9H13V3.5M8 9a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m10.5 3c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2Z"/>'
        },
        "file-image-marker-outline": {
            body: '<path fill="currentColor" d="M8.5 12c-.83 0-1.5-.67-1.5-1.5S7.67 9 8.5 9s1.5.67 1.5 1.5S9.33 12 8.5 12m5.5 7c-.57-1.14-1-2.36-1-3.5c0-.16 0-.32.03-.47L12 14l-5 5h7m-8 1V4h7v5h5v1.03c.17-.03.33-.03.5-.03c.5 0 1 .08 1.5.22V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h9.91c-.41-.56-.91-1.24-1.36-2H6m16-4.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "file-image-minus": {
            body: '<path fill="currentColor" d="M13.09 20H6l6-6l1.88 1.88c.62-.98 1.48-1.78 2.52-2.28L18 12v1.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h7.81c-.35-.61-.6-1.28-.72-2M13 3.5L18.5 9H13V3.5M8 9a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m15 9v2h-8v-2h8Z"/>'
        },
        "file-image-minus-outline": {
            body: '<path fill="currentColor" d="m7 19l5-5l1.88 1.88c-.55.91-.88 1.98-.88 3.12H7m3-8.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5S7.67 12 8.5 12s1.5-.67 1.5-1.5m3.09 9.5H6V4h7v5h5v4.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.35-.61-.6-1.28-.72-2M15 18v2h8v-2h-8Z"/>'
        },
        "file-image-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-1-7v6H7l5-5l2 2m-4-5.5A1.5 1.5 0 0 1 8.5 12A1.5 1.5 0 0 1 7 10.5A1.5 1.5 0 0 1 8.5 9a1.5 1.5 0 0 1 1.5 1.5Z"/>'
        },
        "file-image-plus": {
            body: '<path fill="currentColor" d="M13.09 20H6l6-6l1.88 1.88c.62-.98 1.48-1.78 2.52-2.28L18 12v1.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h7.81c-.35-.61-.6-1.28-.72-2M13 3.5L18.5 9H13V3.5M8 9a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m12 6v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "file-image-plus-outline": {
            body: '<path fill="currentColor" d="m7 19l5-5l1.88 1.88c-.55.91-.88 1.98-.88 3.12H7m3-8.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5S7.67 12 8.5 12s1.5-.67 1.5-1.5m3.09 9.5H6V4h7v5h5v4.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.35-.61-.6-1.28-.72-2M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "file-image-remove": {
            body: '<path fill="currentColor" d="M13.09 20H6l6-6l1.88 1.88c.62-.98 1.48-1.78 2.52-2.28L18 12v1.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h7.81c-.35-.61-.6-1.28-.72-2M13 3.5L18.5 9H13V3.5M8 9a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m14.54 7.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41Z"/>'
        },
        "file-image-remove-outline": {
            body: '<path fill="currentColor" d="m7 19l5-5l1.88 1.88c-.55.91-.88 1.98-.88 3.12H7m3-8.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5S7.67 12 8.5 12s1.5-.67 1.5-1.5m3.09 9.5H6V4h7v5h5v4.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h7.81c-.35-.61-.6-1.28-.72-2m8.03-4.54L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "file-import": {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-1 1.5L18.5 9H13m-2.95 2.22l2.83 2.83L15 11.93V19H7.93l2.12-2.12l-2.83-2.83"/>'
        },
        "file-import-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-3-8.07V19H7.93l2.12-2.12l-2.83-2.83l2.83-2.83l2.83 2.83L15 11.93Z"/>'
        },
        "file-jpg-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 13.5c0 1.1-.9 1.5-2 1.5s-2-.4-2-1.5V12h1.5v1.5h1V9H9v4.5m5-2c0 .8-.7 1.5-1.5 1.5h-1v2H10V9h2.5c.8 0 1.5.7 1.5 1.5v1m5-1h-2.5v3h1V12H19v1.7c0 .7-.5 1.3-1.3 1.3h-1.3c-.8 0-1.3-.7-1.3-1.3v-3.3c-.1-.7.4-1.4 1.2-1.4h1.3c.8 0 1.3.7 1.3 1.3v.2m-7.4 0h1v1h-1v-1Z"/>'
        },
        "file-key": {
            body: '<path fill="currentColor" d="M11 16c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m9-8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8m4 13h-5.2c-.6-1.6-2.3-2.4-3.8-1.8c-1.6.6-2.4 2.3-1.8 3.8s2.3 2.4 3.8 1.8c.9-.3 1.5-1 1.8-1.8H14v2h2v-2h2m.5-8L13 3.5V9h5.5Z"/>'
        },
        "file-key-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m4 18H6V4h7v5h5m-5.17 6a3 3 0 1 0 0 2H14v2h2v-2h1v-2m-7 2a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "file-link": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m-3 18h-1c-1.61 0-4-1.06-4-4c0-2.93 2.39-4 4-4h1v2h-1c-.46 0-2 .17-2 2c0 1.9 1.67 2 2 2h1v2m4-5v2H9v-2h6m-1 5h-1v-2h1c.46 0 2-.17 2-2c0-1.9-1.67-2-2-2h-1v-2h1c1.61 0 4 1.07 4 4c0 2.94-2.39 4-4 4M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-link-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-7-1h-.25C9.45 19 7 18.22 7 15.25s2.45-3.75 3.75-3.75H11V13h-.25c-.37 0-2.25.13-2.25 2.25c0 2.19 2 2.25 2.25 2.25H11V19m3-3h-4v-1.5h4V16m-1-4.5h.25c1.3 0 3.75.78 3.75 3.75S14.55 19 13.25 19H13v-1.5h.25c.37 0 2.25-.13 2.25-2.25c0-2.19-2-2.25-2.25-2.25H13v-1.5Z"/>'
        },
        "file-lock": {
            body: '<path fill="currentColor" d="M18 13c-1.4 0-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3v-1.5c0-1.4-1.4-2.5-2.8-2.5m0 1.2c.8 0 1.5.5 1.5 1.3V17h-3v-1.5c0-.8.7-1.3 1.5-1.3M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-3.8c0-1 .4-1.7 1-2.2c.1-.1.2-.1.2-.2v-.3c0-2.7 2.4-4.5 4.8-4.5c.7 0 1.4.2 2 .4V8l-6-6H6m7 1.5L18.5 9H13V3.5Z"/>'
        },
        "file-lock-open": {
            body: '<path fill="currentColor" d="M22 18.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h4.3c.6 0 1.2.6 1.2 1.3M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-3.8c0-1 .4-1.7 1-2.2c.1-.1.2-.1.2-.2v-1.3c0-2.7 2.4-4.5 4.8-4.5c.7 0 1.4.2 2 .4V8l-6-6H6m7 1.5L18.5 9H13V3.5Z"/>'
        },
        "file-lock-open-outline": {
            body: '<path fill="currentColor" d="M22 18.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h4.3c.6 0 1.2.6 1.2 1.3M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-2H6V4h7v5h5v1c.7 0 1.4.2 2 .4V8l-6-6H6Z"/>'
        },
        "file-lock-outline": {
            body: '<path fill="currentColor" d="M18 13c-1.4 0-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3v-1.5c0-1.4-1.4-2.5-2.8-2.5m0 1.2c.8 0 1.5.5 1.5 1.3V17h-3v-1.5c0-.8.7-1.3 1.5-1.3M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-2H6V4h7v5h5v2c.7 0 1.4.2 2 .4V8l-6-6H6Z"/>'
        },
        "file-marker": {
            body: '<path fill="currentColor" d="M18.5 10c.5 0 1 .08 1.5.22V8l-6-6H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h9.91C14.7 20.41 13 17.78 13 15.5c0-3 2.5-5.5 5.5-5.5M13 3.5L18.5 9H13V3.5m5.5 8.5c-1.9 0-3.5 1.6-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5c0-1.9-1.6-3.5-3.5-3.5m0 4.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2Z"/>'
        },
        "file-marker-outline": {
            body: '<path fill="currentColor" d="M14.55 20c.45.76.95 1.44 1.36 2H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v2.22c-.5-.14-1-.22-1.5-.22c-.17 0-.33 0-.5.03V9h-5V4H6v16h8.55M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "file-minus": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .08V8l-6-6m-1 7V3.5L18.5 9H13m10 11h-8v-2h8v2Z"/>'
        },
        "file-minus-outline": {
            body: '<path fill="currentColor" d="M13.81 22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09s-.67.04-1 .09V9h-5V4H6v16h7.09c.12.72.37 1.39.72 2M23 18h-8v2h8v-2Z"/>'
        },
        "file-move": {
            body: '<path fill="currentColor" d="M14 17h4v-3l5 4.5l-5 4.5v-3h-4v-3m-1-8h5.5L13 3.5V9M6 2h8l6 6v4.34c-.63-.22-1.3-.34-2-.34a6 6 0 0 0-6 6c0 1.54.58 2.94 1.53 4H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>'
        },
        "file-move-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 .41.12.8.34 1.12c.07.11.16.21.25.29c.36.37.86.59 1.41.59h7.53c-.53-.58-.92-1.25-1.18-2H6V4h7v5h5v3c.7 0 1.37.12 2 .34V8l-6-6m4 21l5-4.5l-3-2.7l-2-1.8v3h-4v3h4v3Z"/>'
        },
        "file-multiple": {
            body: '<path fill="currentColor" d="M15 7h5.5L15 1.5V7M8 0h8l6 6v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2M4 4v18h16v2H4a2 2 0 0 1-2-2V4h2Z"/>'
        },
        "file-multiple-outline": {
            body: '<path fill="currentColor" d="M16 0H8C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6l-6-6m4 18H8V2h7v5h5v11M4 4v18h16v2H4c-1.1 0-2-.9-2-2V4h2Z"/>'
        },
        "file-music": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-1 11h-2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.4 0 .7.1 1 .3V11h3v2m0-4V3.5L18.5 9H13Z"/>'
        },
        "file-music-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-5-10v2h-2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.4 0 .7.1 1 .3V10h3Z"/>'
        },
        "file-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m4 18H6V4h7v5h5v11Z"/>'
        },
        "file-pdf": {
            body: '<path d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m4.1 9.4c-.02.04-.29 1.76-2.1 4.69c0 0-3.5 1.82-2.67 3.18c.67 1.08 2.32-.04 3.74-2.68c0 0 1.82-.64 4.24-.82c0 0 3.86 1.73 4.39-.11c.52-1.86-3.06-1.44-3.7-1.25c0 0-2-1.35-2.5-3.21c0 0 1.14-3.95-.61-3.9c-1.75.05-1.09 3.13-.79 4.1m.81 1.04c.03.01.47 1.21 1.89 2.46c0 0-2.33.46-3.39.9c0 0 1-1.73 1.5-3.36m3.93 2.72c.58-.16 2.33.15 2.26.48c-.06.33-2.26-.48-2.26-.48M7.77 17c-.53 1.24-1.44 2-1.67 2c-.23 0 .7-1.6 1.67-2m3.14-6.93c0-.07-.36-2.2 0-2.15c.54.08 0 2.08 0 2.15z" fill="currentColor"/>',
            hidden: true
        },
        "file-pdf-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9.5 8.5c0 .8-.7 1.5-1.5 1.5H7v2H5.5V9H8c.8 0 1.5.7 1.5 1.5v1m5 2c0 .8-.7 1.5-1.5 1.5h-2.5V9H13c.8 0 1.5.7 1.5 1.5v3m4-3H17v1h1.5V13H17v2h-1.5V9h3v1.5m-6.5 0h1v3h-1v-3m-5 0h1v1H7v-1Z"/>'
        },
        "file-pdf-box-outline": {
            body: '<path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v14H5V5h14m-1.1 8.5c-.3-.5-1-.7-2.2-.7c-.4 0-.8 0-1.2.1c-.3-.2-.6-.4-.8-.6c-.6-.5-1.2-1.4-1.5-2.5v-.1c.3-1.3.6-2.8 0-3.5c-.3-.1-.5-.2-.7-.2h-.2c-.4 0-.7.4-.8.7c-.4 1.3-.1 2 .2 3.2c-.2.9-.6 1.8-1 2.8c-.4.7-.7 1.3-1 1.8c-.4.2-.7.3-.9.5c-1.1.7-1.7 1.5-1.8 2v.5l.5.3c.2.2.3.2.5.2c.8 0 1.7-.9 2.9-3h.1c1-.3 2.2-.5 3.9-.7c1 .5 2.2.7 2.9.7c.4 0 .7-.1.9-.3c.2-.2.3-.4.3-.6c0-.3 0-.5-.1-.6M6.8 17.3c0-.4.5-1 1.2-1.6c.1-.1.3-.2.5-.3c-.7 1.1-1.3 1.8-1.7 1.9m4.5-10.6s0-.1.1-.1h.1c.2.2.2.5.1 1.1v.2c-.1.2-.1.5-.2.8c-.3-.9-.3-1.6-.1-2m-1.2 7.6H10c.1-.3.3-.6.5-1c.4-.8.8-1.6 1-2.3c.4.9.9 1.6 1.5 2.1c.1.1.3.2.4.3c-.9.1-2.1.4-3.3.9m7.2-.1h-.2c-.4 0-1.1-.2-1.8-.5c.1-.1.2-.1.2-.1c1.4 0 1.7.2 1.8.3l.1.1c0 .2 0 .2-.1.2z" fill="currentColor"/>',
            hidden: true
        },
        "file-pdf-outline": {
            body: '<path d="M14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-7.08-7.69c-.24-.77-.77-3.23.63-3.27c1.4-.04.48 3.12.48 3.12c.39 1.49 2.02 2.56 2.02 2.56c.5-.15 3.35-.48 2.95 1c-.43 1.48-3.5.09-3.5.09c-1.95.14-3.41.66-3.41.66c-1.13 2.11-2.45 3.03-2.99 2.14c-.67-1.11 2.13-2.54 2.13-2.54c1.45-2.35 1.67-3.72 1.69-3.76m.65.84c-.4 1.3-1.2 2.69-1.2 2.69c.85-.34 2.71-.73 2.71-.73c-1.14-1-1.49-1.95-1.51-1.96m3.14 2.17s1.75.65 1.79.39c.07-.27-1.33-.51-1.79-.39m-5.66 1.49c-.77.3-1.51 1.58-1.33 1.58c.18.01.91-.6 1.33-1.58m2.52-5.55c0-.05.43-1.68 0-1.73c-.3-.03-.01 1.69 0 1.73z" fill="currentColor"/>',
            hidden: true
        },
        "file-percent": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8M7.37 20L15 12.35L13.65 11L6 18.65L7.37 20M13 9h5.5L13 3.5V9m-5.5 2A1.5 1.5 0 0 0 6 12.5A1.5 1.5 0 0 0 7.5 14A1.5 1.5 0 0 0 9 12.5A1.5 1.5 0 0 0 7.5 11m6 6a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "file-percent-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8-8.5c0 .83-.67 1.5-1.5 1.5S7 12.33 7 11.5S7.67 10 8.5 10s1.5.67 1.5 1.5m6 6c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5m0-6.15L8.37 19L7 17.65L14.65 10L16 11.35Z"/>'
        },
        "file-phone": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m3 17.44c0 .31-.25.56-.56.56C11.23 20 7 15.77 7 10.56c0-.31.25-.56.56-.56H9.5c.31 0 .56.25.56.56c0 .69.11 1.36.31 1.98c.06.19.02.41-.14.57L9 14.33c.81 1.57 2.1 2.86 3.67 3.67l1.23-1.23c.15-.16.37-.2.56-.14c.62.2 1.29.32 1.99.32c.3 0 .55.24.55.55v1.94M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-phone-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-9-6.67c.81 1.57 2.1 2.86 3.67 3.67l1.22-1.23c.16-.16.38-.2.57-.14c.62.2 1.29.32 1.98.32c.31 0 .56.24.56.55v1.95c0 .3-.25.55-.56.55C11.23 19 7 14.77 7 9.56c0-.31.25-.56.56-.56H9.5c.31 0 .56.25.56.56c0 .69.11 1.36.31 1.98c.06.19.02.41-.14.57L9 13.33Z"/>'
        },
        "file-plus": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .08V8l-6-6m-1 7V3.5L18.5 9H13m10 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2Z"/>'
        },
        "file-plus-outline": {
            body: '<path fill="currentColor" d="M13.81 22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09s-.67.04-1 .09V9h-5V4H6v16h7.09c.12.72.37 1.39.72 2M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z"/>'
        },
        "file-png-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 11.5c0 .8-.7 1.5-1.5 1.5h-1v2H5V9h2.5c.8 0 1.5.7 1.5 1.5v1m5 3.5h-1.5l-1-2.5V15H10V9h1.5l1 2.5V9H14v6m5-4.5h-2.5v3h1V12H19v1.7c0 .7-.5 1.3-1.3 1.3h-1.3c-.8 0-1.3-.7-1.3-1.3v-3.3c-.1-.7.4-1.4 1.2-1.4h1.3c.8 0 1.3.7 1.3 1.3v.2h.1m-12.5 0h1v1h-1v-1Z"/>'
        },
        "file-powerpoint": {
            body: '<path fill="currentColor" d="M12.6 12.3h-2v3.2h2.1c.6 0 .9-.2 1.2-.5c.3-.3.4-.6.4-1.1c0-.5-.1-.8-.4-1.1c-.3-.3-.7-.5-1.3-.5M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.2 14c-.6.5-1.1.7-2.4.7h-2.2V20H9v-9h3.8c1.3 0 1.9.3 2.4.8c.6.6.8 1.2.8 2.1c0 .9-.2 1.6-.8 2.1M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-powerpoint-box": {
            body: '<path fill="currentColor" d="M9.8 13.4h2.5c1.5 0 2.16-.28 2.8-.82c.64-.55.9-1.33.9-2.35c0-.97-.25-1.73-.9-2.35c-.65-.59-1.27-.88-2.8-.88H8v10h1.8v-3.6M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-9.2 9V8.4h2.3c.66 0 1.17.25 1.5.6c.33.35.5.72.5 1.24c0 .56-.18.95-.5 1.26c-.32.31-.7.5-1.38.5H9.8Z"/>'
        },
        "file-powerpoint-box-outline": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m0 2h14v14H5V5m10.1 2.88c-.65-.59-1.27-.88-2.8-.88H8v10h1.8v-3.6h2.5c1.5 0 2.16-.28 2.8-.82c.64-.55.9-1.33.9-2.35c0-.97-.25-1.73-.9-2.35m-1.5 3.62c-.32.31-.7.5-1.38.5H9.8V8.4h2.3c.66 0 1.17.25 1.5.6c.33.35.5.72.5 1.24c0 .56-.18.95-.5 1.26Z"/>'
        },
        "file-powerpoint-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-2.8-9.2c-.5-.5-1.1-.8-2.4-.8H9v9h1.6v-3.3h2.2c1.3 0 1.8-.2 2.4-.7c.6-.5.8-1.2.8-2.1c0-.9-.2-1.5-.8-2.1M13.9 14c-.3.3-.6.5-1.2.5h-2.1v-3.2h2c.6 0 1 .2 1.3.5c.3.3.4.6.4 1.1s-.1.8-.4 1.1Z"/>'
        },
        "file-presentation-box": {
            body: '<path fill="currentColor" d="M19 16H5V8h14m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "file-question": {
            body: '<path fill="currentColor" d="M6 2c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6m7 1.5L18.5 9H13V3.5M12 11a3 3 0 0 1 3 3c0 1.88-2.25 2.06-2.25 3.75h-1.5c0-2.44 2.25-2.25 2.25-3.75a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5H9a3 3 0 0 1 3-3m-.75 7.5h1.5V20h-1.5v-1.5Z"/>'
        },
        "file-question-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-3-7c0 1.89-2.25 2.07-2.25 3.76h-1.5c0-2.44 2.25-2.26 2.25-3.76c0-.82-.67-1.5-1.5-1.5s-1.5.68-1.5 1.5H9c0-1.65 1.34-3 3-3s3 1.35 3 3m-2.25 4.5V19h-1.5v-1.5h1.5Z"/>'
        },
        "file-refresh": {
            body: '<path fill="currentColor" d="M18 14.5c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4M13 9h5.5L13 3.5V9M6 2h8l6 6v4.17c-.5-.11-1-.17-1.5-.17a6.5 6.5 0 0 0-6.5 6.5c0 1.29.37 2.5 1 3.5H6c-1.12 0-2-.9-2-2V4c0-1.11.89-2 2-2Z"/>'
        },
        "file-refresh-outline": {
            body: '<path fill="currentColor" d="M18 14.5c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4M14 2l6 6v4.17c-.5-.11-1-.17-1.5-.17H18V9h-5V4H6v16h6.17c.17.72.46 1.39.83 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8Z"/>'
        },
        "file-remove": {
            body: '<path fill="currentColor" d="M21.12 22.54L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19l2.13 2.12l-1.42 1.42M14 2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.81c-.53-.91-.81-1.95-.81-3c0-3.31 2.69-6 6-6c.34 0 .67.03 1 .08V8l-6-6m-1 7V3.5L18.5 9H13Z"/>'
        },
        "file-remove-outline": {
            body: '<path fill="currentColor" d="M13.81 22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09s-.67.04-1 .09V9h-5V4H6v16h7.09c.12.72.37 1.39.72 2m8.73-.88L20.41 19l2.13-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42Z"/>'
        },
        "file-replace": {
            body: '<path fill="currentColor" d="M14 12h5.5L14 6.5V12M8 5h7l6 6v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3h5v2l4-3l-4-3v2H6V7a2 2 0 0 1 2-2m5.5-2H4v13h2v2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h7.5l2 2Z"/>'
        },
        "file-replace-outline": {
            body: '<path fill="currentColor" d="m14 3l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2l4-3l-4-3v2H4V3h10m7 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11v-9h-5V7H8v6H6V7a2 2 0 0 1 2-2h8l5 5Z"/>'
        },
        "file-restore": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12 9.5c-1.35 0-2.5.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8a5 5 0 0 1 5 5a5 5 0 0 1-5 5Z"/>'
        },
        "file-restore-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7l5 5v11m-1-6.76c0 2.62-2.13 4.76-4.76 4.76c-1.95 0-3.63-1.18-4.36-2.86H9.5c.61.86 1.61 1.43 2.74 1.43c1.84 0 3.33-1.5 3.33-3.33S14.08 9.9 12.24 9.9c-1.29 0-2.38.75-2.95 1.81l1.52 1.53H7V9.43l1.24 1.24a4.714 4.714 0 0 1 4-2.17c2.63-.03 4.76 2.11 4.76 4.74Z"/>'
        },
        "file-rotate-left": {
            body: '<path fill="currentColor" d="M17 7h-4c-1.1 0-2 .9-2 2v9a2 2 0 0 0 2 2h6c1.11 0 2-.89 2-2v-7l-4-4m2 5h-3V9h.17L19 11.83V12M4 11c0-4.42 3.58-8 8-8l1 .06v2.02L12 5c-3.31 0-6 2.69-6 6h3l-4 4l-4-4h3"/>'
        },
        "file-rotate-left-outline": {
            body: '<path fill="currentColor" d="M4 11c0-4.42 3.58-8 8-8l1 .06v2.02L12 5c-3.31 0-6 2.69-6 6h3l-4 4l-4-4h3m13-4h-4c-1.1 0-2 .9-2 2v9a2 2 0 0 0 2 2h6c1.11 0 2-.89 2-2v-7l-4-4m2 11h-6V9h3v3h3v6Z"/>'
        },
        "file-rotate-right": {
            body: '<path fill="currentColor" d="M5 20a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h4l4 4v7c0 1.11-.89 2-2 2H5m6-8.17L8.17 9H8v3h3v-.17m9-.83h3l-4 4l-4-4h3c0-3.31-2.69-6-6-6l-1 .08V3.06L12 3c4.42 0 8 3.58 8 8"/>'
        },
        "file-rotate-right-outline": {
            body: '<path fill="currentColor" d="M20 11h3l-4 4l-4-4h3c0-3.31-2.69-6-6-6l-1 .08V3.06L12 3c4.42 0 8 3.58 8 8M9 7H5c-1.1 0-2 .9-2 2v9a2 2 0 0 0 2 2h6c1.11 0 2-.89 2-2v-7L9 7m2 11H5V9h3v3h3v6Z"/>'
        },
        "file-search": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h7c-.41-.25-.8-.56-1.14-.9a6.478 6.478 0 0 1-.36-9.18C13.69 9.5 17.33 9.13 20 11V8l-6-6m-1 7V3.5L18.5 9H13m7.31 9.9c1.33-2.11.69-4.9-1.4-6.22c-2.11-1.33-4.91-.68-6.22 1.4c-1.34 2.11-.69 4.89 1.4 6.22c1.46.93 3.32.93 4.79.02L22 23.39L23.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "file-search-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h7c-.41-.25-.8-.56-1.14-.9c-.33-.33-.61-.7-.86-1.1H6V4h7v5h5v1.18c.71.16 1.39.43 2 .82V8l-6-6m6.31 16.9c1.33-2.11.69-4.9-1.4-6.22c-2.11-1.33-4.91-.68-6.22 1.4c-1.34 2.11-.69 4.89 1.4 6.22c1.46.93 3.32.93 4.79.02L22 23.39L23.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "file-send": {
            body: '<path fill="currentColor" d="M14 2H6c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-1.46 17.37v-2h-4v-1.99h4v-2l3 3l-3 2.99M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-send-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-5.46-1.5v-2h-4v-2h4v-2l3 3l-3 3Z"/>'
        },
        "file-settings": {
            body: '<path fill="currentColor" d="M6 0C4.89 0 4 .89 4 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6l-6-6H6m7 1.5L18.5 7H13V1.5M7 22v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2Z"/>'
        },
        "file-settings-outline": {
            body: '<path fill="currentColor" d="M6 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6l-6-6H6m0 2h7v5h5v11H6V2m1 20v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2Z"/>'
        },
        "file-sign": {
            body: '<path fill="currentColor" d="M19.7 12.9L14 18.6h-2.3v-2.3l5.7-5.7l2.3 2.3m3.4-.8c0 .3-.3.6-.6.9L20 15.5l-.9-.9l2.6-2.6l-.6-.6l-.7.7l-2.3-2.3l2.2-2.1c.2-.2.6-.2.9 0l1.4 1.4c.2.2.2.6 0 .9c-.2.2-.4.4-.4.6c0 .2.2.4.4.6c.3.3.6.6.5.9M3 20V4h7v5h5v1.5l2-2V8l-6-6H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2H3m8-2.9c-.2 0-.4.1-.5.1L10 15H8.5l-2.1 1.7L7 14H5.5l-1 5H6l2.9-2.6l.6 2.3h1l.5-.1v-1.5Z"/>'
        },
        "file-star": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m.5 16.9L12 17.5L9.5 19l.7-2.8L8 14.3l2.9-.2l1.1-2.7l1.1 2.6l2.9.2l-2.2 1.9l.7 2.8M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-star-outline": {
            body: '<path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8.5-2l.7-2.8L8 13.3l2.9-.2l1.1-2.7l1.1 2.6l2.9.2l-2.2 1.9l.7 2.8l-2.5-1.4L9.5 18Z"/>'
        },
        "file-swap": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8m-6 10v-2h-4v2l-3-3l3-3v2h4v-2l3 3m-4-6V3.5L18.5 9Z"/>'
        },
        "file-swap-outline": {
            body: '<path fill="currentColor" d="m17 15l-3-3v2h-4v-2l-3 3l3 3v-2h4v2m0-16H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m4 18H6V4h7v5h5Z"/>'
        },
        "file-sync": {
            body: '<path fill="currentColor" d="M11 17.5c0-3.6 2.9-6.5 6.5-6.5c.9 0 1.7.2 2.5.5V8l-6-6H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6.8c-1.1-1.2-1.8-2.8-1.8-4.5m2-14L18.5 9H13V3.5m4 8.5v1.5c2.2 0 4 1.8 4 4c0 .8-.2 1.6-.7 2.2l-1.1-1.1c.2-.3.3-.7.3-1.1c0-1.4-1.1-2.5-2.5-2.5v1.5l-2.2-2.2L17 12m0 11v-1.5c-2.2 0-4-1.8-4-4c0-.8.2-1.6.7-2.2l1.1 1.1c-.2.3-.3.7-.3 1.1c0 1.4 1.1 2.5 2.5 2.5v-1.5l2.2 2.2L17 23Z"/>'
        },
        "file-sync-outline": {
            body: '<path fill="currentColor" d="M12.8 22H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8l6 6v3.5c-.6-.3-1.3-.4-2-.5V9h-5V4H6v16h5.5c.3.7.8 1.4 1.3 2M17 12l-2.2 2.2l2.2 2.2V15c1.4 0 2.5 1.1 2.5 2.5c0 .4-.1.8-.3 1.1l1.1 1.1c.4-.6.7-1.4.7-2.2c0-2.2-1.8-4-4-4V12m2.2 8.8L17 18.5V20c-1.4 0-2.5-1.1-2.5-2.5c0-.4.1-.8.3-1.1l-1.1-1.1c-.4.6-.7 1.4-.7 2.2c0 2.2 1.8 4 4 4V23l2.2-2.2Z"/>'
        },
        "file-table": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-4 17H7v-2h3v2m0-3H7v-2h3v2m0-3H7v-2h3v2m4 6h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3v-2h3v2m-1-4V3.5L18.5 9H13Z"/>'
        },
        "file-table-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2M9 18H6v-2h3v2m0-3H6v-2h3v2m0-3H6v-2h3v2m4 6h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3v-2h3v2Z"/>'
        },
        "file-table-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3c-1.1 0-2-.9-2-2V5h2m18-4H7c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V3a2 2 0 0 0-2-2M11 16H8v-2h3v2m0-3H8v-2h3v2m0-3H8V8h3v2m4 6h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3V8h3v2Z"/>'
        },
        "file-table-box-multiple-outline": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3c-1.1 0-2-.9-2-2V5h2m18-4H7c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.11 0 2-.89 2-2V3c0-1.1-.9-2-2-2m0 16H7V3h14v14m-10-3H8v2h3v-2m4 0h-3v2h3v-2m-4-3H8v2h3v-2m4 0h-3v2h3v-2m-4-3H8v2h3V8m4 0h-3v2h3V8Z"/>'
        },
        "file-table-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m0 16H5V5h14v14M9 18H6v-2h3v2m4 0h-3v-2h3v2m-4-3H6v-2h3v2m4 0h-3v-2h3v2m-4-3H6v-2h3v2m4 0h-3v-2h3v2Z"/>'
        },
        "file-table-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m4 18H6V4h7v5h5v11m-8-7H7v-2h3v2m4 0h-3v-2h3v2m-4 3H7v-2h3v2m4 0h-3v-2h3v2m-4 3H7v-2h3v2m4 0h-3v-2h3v2Z"/>'
        },
        "file-tree": {
            body: '<path fill="currentColor" d="M3 3h6v4H3V3m12 7h6v4h-6v-4m0 7h6v4h-6v-4m-2-4H7v5h6v2H5V9h2v2h6v2Z"/>'
        },
        "file-tree-outline": {
            body: '<path fill="currentColor" d="M12 13H7v5h5v2H5V10h2v1h5v2M8 4v2H4V4h4m2-2H2v6h8V2m10 9v2h-4v-2h4m2-2h-8v6h8V9m-2 9v2h-4v-2h4m2-2h-8v6h8v-6Z"/>'
        },
        "file-undo": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m6.16 12.31c-1.56 0-2.97.58-4.05 1.52L6 13.72V19h5.28l-2.13-2.12c.82-.68 1.85-1.1 3.01-1.1c2.07 0 3.84 1.35 4.45 3.22l1.39-.46c-.81-2.45-3.12-4.23-5.84-4.23Z"/>'
        },
        "file-undo-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-1-2.39l-1.16.39a3.908 3.908 0 0 0-3.71-2.69c-.96 0-1.82.35-2.5.92L11.4 18H7v-4.4l1.76 1.76c.9-.79 2.07-1.27 3.37-1.27c2.27 0 4.2 1.48 4.87 3.52Z"/>'
        },
        "file-upload": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m-.5 14v3h-3v-3H8l4-4l4 4h-2.5M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-upload-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-6-8l4 4h-2.5v3h-3v-3H8l4-4Z"/>'
        },
        "file-video": {
            body: '<path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m11 17v-6l-3 2.2V13H7v6h7v-2.2l3 2.2Z"/>'
        },
        "file-video-outline": {
            body: '<path fill="currentColor" d="m14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-2-2l-2.5-1.7V18H8v-5h5.5v1.7L16 13v5Z"/>'
        },
        "file-word": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.2 18h-1.4L12 13.2L10.2 20H8.8l-2.2-9h1.5l1.4 6.8l1.8-6.8h1.3l1.8 6.8l1.4-6.8h1.5l-2.1 9M13 9V3.5L18.5 9H13Z"/>'
        },
        "file-word-box": {
            body: '<path fill="currentColor" d="M15.5 17H14l-2-7.5l-2 7.5H8.5L6.1 7h1.7l1.54 7.5L11.3 7h1.4l1.97 7.5L16.2 7h1.7M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "file-word-box-outline": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m0 2h14v14H5V5m12.9 2l-2.4 10H14l-2-7.5l-2 7.5H8.5L6.1 7h1.7l1.54 7.5L11.3 7h1.4l1.97 7.5L16.2 7h1.7Z"/>'
        },
        "file-word-outline": {
            body: '<path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8l-6-6m4 18H6V4h7v5h5v11m-.65-10l-2.1 9h-1.4l-1.8-6.79l-1.8 6.79h-1.4l-2.2-9h1.5l1.4 6.81l1.8-6.81h1.3l1.8 6.81l1.4-6.81h1.5Z"/>'
        },
        "file-xml": {
            body: '<path d="M13 8.998h5.5l-5.5-5.5v5.5zm-7-7h8l6 6v12a2 2 0 0 1-2 2H5.99a1.992 1.992 0 0 1-1.99-2l.01-16c0-1.104.884-2 1.99-2zM6.121 15.5l3.742 3.743l1.414-1.415L8.95 15.5l2.328-2.328l-1.414-1.415L6.122 15.5zm11.156 0l-3.742-3.743l-1.414 1.415L14.45 15.5l-2.328 2.328l1.414 1.415l3.742-3.743z" fill="currentColor"/>',
            hidden: true
        },
        "file-xml-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2M8 15H6.5L6 13l-.5 2H4l.75-3L4 9h1.5l.5 2l.5-2H8l-.75 3L8 15m7.5 0H14v-4.5h-1V14h-1.5v-3.5h-1V15H9v-4c0-1.1.9-2 2-2h2.5a2 2 0 0 1 2 2v4m4.5 0h-3V9h1.5v4.5H20V15Z"/>'
        },
        fill: {
            body: '<path d="M19 11.5s-2 2.167-2 3.5a2 2 0 0 0 4 0c0-1.333-2-3.5-2-3.5zm-4.281-1.52L5.207 10L10 5.208l4.719 4.771zm1.842-1.041L7.621 0L6.207 1.414l2.379 2.379l-5.147 5.146a1.502 1.502 0 0 0 0 2.122l5.5 5.5c.293.293.677.439 1.061.439c.384 0 .768-.146 1.061-.439l5.5-5.5a1.502 1.502 0 0 0 0-2.122z" fill="currentColor"/><path d="M0 20h24v4H0z" fill="currentColor"/>',
            hidden: true
        },
        film: {
            body: '<path fill="currentColor" d="M3.5 3H5V1.8c0-.44.36-.8.8-.8h4.4c.44 0 .8.36.8.8V3h1.5A1.5 1.5 0 0 1 14 4.5V5h8v15h-8v.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 20.5v-16A1.5 1.5 0 0 1 3.5 3M18 7v2h2V7h-2m-4 0v2h2V7h-2m-4 0v2h2V7h-2m4 9v2h2v-2h-2m4 0v2h2v-2h-2m-8 0v2h2v-2h-2Z"/>'
        },
        filmstrip: {
            body: '<path fill="currentColor" d="M18 9h-2V7h2m0 6h-2v-2h2m0 6h-2v-2h2M8 9H6V7h2m0 6H6v-2h2m0 6H6v-2h2M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2Z"/>'
        },
        "filmstrip-box": {
            body: '<path fill="currentColor" d="M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14M7 18v-2H5v2h2m0-5v-2H5v2h2m0-5V6H5v2h2m12 10v-2h-2v2h2m0-5v-2h-2v2h2m0-5V6h-2v2h2Z"/>'
        },
        "filmstrip-box-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m16-4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M10 15H8v-2h2v2m0-4H8V9h2v2m0-4H8V5h2v2m10 8h-2v-2h2v2m0-4h-2V9h2v2m0-4h-2V5h2v2Z"/>'
        },
        "filmstrip-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L21 21.72L19.73 23L16 19.27V21H8v-2H6v2H4V7.27l-3-3M18 9V7h-2v2h2m0 4v-2h-2v2h2m0 2h-1.18l-10-10H8V3h8v2h2V3h2v15.18l-2-2V15M8 13v-1.73L7.73 11H6v2h2m0 4v-2H6v2h2M6 3v1.18L4.82 3H6Z"/>'
        },
        filter: {
            body: '<path fill="currentColor" d="M14 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0l-2.01-2.01a.989.989 0 0 1-.29-.83V12h-.03L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L14.03 12H14Z"/>'
        },
        "filter-check": {
            body: '<path fill="currentColor" d="M12 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L8.29 18.7a.989.989 0 0 1-.29-.83V12h-.03L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L12.03 12H12m5.75 9L15 18l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 21"/>'
        },
        "filter-check-outline": {
            body: '<path fill="currentColor" d="M13 19.88c.04.3-.06.62-.28.83c-.4.39-1.03.39-1.42 0L7.29 16.7a.989.989 0 0 1-.29-.83v-5.12L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L13 10.75v9.13M5.04 5L9 10.07v5.51l2 2v-7.53L14.96 5H5.04m12.71 16L15 18l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 21"/>'
        },
        "filter-cog": {
            body: '<path fill="currentColor" d="m22.77 19.32l-1.07-.82c.02-.17.04-.33.04-.5s-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 19 13h-2a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32M18 19.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M3 3c-.22 0-.43.08-.62.22a1 1 0 0 0-.17 1.4L7.97 12H8v5.87c-.04.29.06.6.29.83l2.01 2.01c.35.35.89.37 1.28.09c-.38-.89-.58-1.84-.58-2.8c0-1.27.35-2.5 1-3.6V12h.03l5.76-7.38a1 1 0 0 0-.17-1.4c-.19-.14-.4-.22-.62-.22H3Z"/>'
        },
        "filter-cog-outline": {
            body: '<path fill="currentColor" d="m22.77 19.32l-1.07-.82c.02-.17.04-.33.04-.5s-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 19 13h-2a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32M18 19.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m-.38-16.28c-.19-.14-.4-.22-.62-.22H3c-.22 0-.43.08-.62.22a1 1 0 0 0-.17 1.4L7 10.75v5.12c-.04.29.06.6.29.83l4.01 4.01c.1.1.2.17.35.22C11.22 20 11 19 11 18c0-1.83.72-3.59 2-4.9v-2.35l4.79-6.13a1 1 0 0 0-.17-1.4M11 10.05v7.53l-2-2v-5.52L5.04 5h9.92L11 10.05Z"/>'
        },
        "filter-menu": {
            body: '<path fill="currentColor" d="m11 11l5.76-7.38a1 1 0 0 0-.17-1.4A1 1 0 0 0 16 2H2a1 1 0 0 0-.62.22a1 1 0 0 0-.17 1.4L7 11v5.87a1 1 0 0 0 .29.83l2 2a1 1 0 0 0 1.41 0a1 1 0 0 0 .3-.83V11m2 5l5 5l5-5Z"/>'
        },
        "filter-menu-outline": {
            body: '<path fill="currentColor" d="M12 18.88a1 1 0 0 1-.29.83a1 1 0 0 1-1.41 0l-4-4a1 1 0 0 1-.3-.84V9.75L1.21 3.62a1 1 0 0 1 .17-1.4A1 1 0 0 1 2 2h14a1 1 0 0 1 .62.22a1 1 0 0 1 .17 1.4L12 9.75v9.13M4 4l4 5.06v5.52l2 2V9.05L14 4m-1 12l5 5l5-5Z"/>'
        },
        "filter-minus": {
            body: '<path fill="currentColor" d="M12 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L8.29 18.7a.999.999 0 0 1-.29-.84V12h-.03L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L12.03 12H12m3 5h8v2h-8v-2Z"/>'
        },
        "filter-minus-outline": {
            body: '<path fill="currentColor" d="M15 17h8v2h-8v-2m-2 2.88c.04.3-.06.62-.28.83c-.4.39-1.03.39-1.42 0L7.29 16.7a.989.989 0 0 1-.29-.83v-5.12L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L13 10.75v9.13M5.04 5L9 10.07v5.51l2 2v-7.53L14.96 5H5.04Z"/>'
        },
        "filter-multiple": {
            body: '<path fill="currentColor" d="M3.46 5c-.21 0-.42.08-.59.21c-.44.34-.52.97-.18 1.4v.01L8 13.42v5.99l2.29 2.3c.39.39 1.03.39 1.42 0c.39-.39.39-1.03 0-1.42L10 18.59v-5.86L4.27 5.39A1.01 1.01 0 0 0 3.46 5M16 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0l-2.01-2.01a.989.989 0 0 1-.29-.83V12h-.03L6.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L16.03 12H16Z"/>'
        },
        "filter-multiple-outline": {
            body: '<path fill="currentColor" d="M3.47 5c-.22 0-.43.08-.6.21c-.44.34-.52.97-.18 1.4v.01L7 12.14v5.91l3.64 3.66c.36.39 1.02.39 1.41 0c.39-.39.39-1.02.01-1.41L9 17.22v-5.77L4.27 5.39c-.19-.25-.49-.39-.8-.39m18.15-1.78c-.19-.14-.4-.22-.62-.22H7c-.22 0-.43.08-.62.22a1 1 0 0 0-.17 1.4L11 10.75v5.12c-.04.29.06.6.29.83l4.01 4.01c.39.39 1.02.39 1.41 0c.23-.21.33-.53.29-.83v-9.13l4.79-6.13a1 1 0 0 0-.17-1.4M15 10.05v7.53l-2-2v-5.52L9.04 5h9.92L15 10.05Z"/>'
        },
        "filter-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l8.39 8.37l.47.63H10v5.87c-.04.29.06.6.29.83l2.01 2.01c.39.39 1.02.39 1.41 0c.23-.21.33-.53.29-.83v-3.99l6.84 6.84l1.27-1.27L14 13.35L9.41 8.76L4.15 3.5L2.39 1.73M6.21 3l8.33 8.34l5.25-6.72a1 1 0 0 0-.17-1.4c-.19-.14-.4-.22-.62-.22H6.21Z"/>'
        },
        "filter-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3L9 10.89v4.98c-.04.29.06.6.29.83l4.01 4.01c.39.39 1.02.39 1.41 0c.23-.21.33-.53.29-.83v-2.99l5.84 5.84l1.27-1.27L15 14.35v-.01l-2-1.99l-2-2.01L4.15 3.5L2.39 1.73M6.21 3L8.2 5h8.76l-3.85 4.91L15 11.8v-1.05l4.79-6.13a1 1 0 0 0-.17-1.4c-.19-.14-.4-.22-.62-.22H6.21M11 12.89l2 2v2.69l-2-2v-2.69Z"/>'
        },
        "filter-outline": {
            body: '<path fill="currentColor" d="M15 19.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L9.29 16.7a.989.989 0 0 1-.29-.83v-5.12L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L15 10.75v9.13M7.04 5L11 10.06v5.52l2 2v-7.53L16.96 5H7.04Z"/>'
        },
        "filter-plus": {
            body: '<path fill="currentColor" d="M12 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L8.29 18.7a.989.989 0 0 1-.29-.83V12h-.03L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L12.03 12H12m3 5h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "filter-plus-outline": {
            body: '<path fill="currentColor" d="M15 17h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2m-2 2.88c.04.3-.06.62-.28.83c-.4.39-1.03.39-1.42 0L7.29 16.7a.989.989 0 0 1-.29-.83v-5.12L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L13 10.75v9.13M5.04 5L9 10.07v5.51l2 2v-7.53L14.96 5H5.04Z"/>'
        },
        "filter-remove": {
            body: '<path fill="currentColor" d="M14.76 20.83L17.6 18l-2.84-2.83l1.41-1.41L19 16.57l2.83-2.81l1.41 1.41L20.43 18l2.81 2.83l-1.41 1.41L19 19.4l-2.83 2.84l-1.41-1.41M12 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L8.29 18.7a.989.989 0 0 1-.29-.83V12h-.03L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L12.03 12H12Z"/>'
        },
        "filter-remove-outline": {
            body: '<path fill="currentColor" d="M14.73 20.83L17.58 18l-2.85-2.83l1.42-1.41L19 16.57l2.8-2.81l1.42 1.41L20.41 18l2.81 2.83l-1.42 1.41L19 19.4l-2.85 2.84l-1.42-1.41M13 19.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L7.29 16.7a.989.989 0 0 1-.29-.83v-5.12L2.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L13 10.75v9.13M5.04 5L9 10.06v5.52l2 2v-7.53L14.96 5H5.04Z"/>'
        },
        "filter-settings": {
            body: '<path fill="currentColor" d="M15 22h2v2h-2m-4-2h2v2h-2m-4-2h2v2H7m7-12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0l-2.01-2.01a.989.989 0 0 1-.29-.83V12h-.03L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L14.03 12Z"/>'
        },
        "filter-settings-outline": {
            body: '<path fill="currentColor" d="M15 22h2v2h-2m-4-2h2v2h-2m-4-2h2v2H7m8-4.12c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L9.29 16.7a.989.989 0 0 1-.29-.83v-5.12L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L15 10.75v9.13M7.04 5L11 10.06v5.52l2 2v-7.53L16.96 5Z"/>'
        },
        "filter-variant": {
            body: '<path fill="currentColor" d="M6 13h12v-2H6M3 6v2h18V6M10 18h4v-2h-4v2Z"/>'
        },
        "filter-variant-minus": {
            body: '<path fill="currentColor" d="M21 8H3V6h18v2m-7.19 8H10v2h3.09c.12-.72.37-1.39.72-2M18 11H6v2h12v-2m5 7h-8v2h8v-2Z"/>'
        },
        "filter-variant-plus": {
            body: '<path fill="currentColor" d="M21 8H3V6h18v2m-7.19 8H10v2h3.09c.12-.72.37-1.39.72-2M18 11H6v2h12v-2m0 4v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "filter-variant-remove": {
            body: '<path fill="currentColor" d="M21 8H3V6h18v2m-7.19 8H10v2h3.09c.12-.72.37-1.39.72-2M18 11H6v2h12v-2m3.12 4.46L19 17.59l-2.12-2.13l-1.41 1.42L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        finance: {
            body: '<path fill="currentColor" d="m6 16.5l-3 2.94V11h3m5 3.66l-1.57-1.34L8 14.64V7h3m5 6l-3 3V3h3m2.81 9.81L17 11h5v5l-1.79-1.79L13 21.36l-3.47-3.02L5.75 22H3l6.47-6.34L13 18.64"/>'
        },
        "find-replace": {
            body: '<path fill="currentColor" d="M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0 0 11 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0 1 11 6m5.64 9.14A6.89 6.89 0 0 0 17.92 12H15.9a5 5 0 0 1-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0 0 11 18c1.55 0 3-.5 4.14-1.36L20 21.5l1.5-1.5l-4.86-4.86Z"/>'
        },
        fingerprint: {
            body: '<path fill="currentColor" d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12 3c-1.97 0-3.85.47-5.56 1.41c-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.5 9.86 2 12 2s4 .47 6.04 1.5c.25.15.34.45.21.69a.48.48 0 0 1-.44.28M3.5 9.72c-.1 0-.2-.03-.29-.09a.517.517 0 0 1-.12-.7c.99-1.4 2.25-2.5 3.75-3.27C10 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.85 3.75 3.25c.16.22.1.54-.12.7c-.23.16-.54.11-.7-.1a9.257 9.257 0 0 0-3.39-2.96c-2.87-1.47-6.54-1.47-9.4.01c-1.36.7-2.5 1.7-3.4 2.95c-.08.15-.23.22-.39.22m6.25 12.07c-.13 0-.25-.05-.35-.15c-.87-.87-1.34-1.43-2.01-2.64c-.69-1.23-1.05-2.73-1.05-4.34c0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5c0-2.42-2.09-4.39-4.66-4.39c-2.57 0-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.84c.64 1.16 1.08 1.65 1.85 2.43c.19.2.19.51 0 .71c-.12.1-.24.15-.37.15m7.17-1.85c-1.19 0-2.24-.3-3.1-.89c-1.49-1.01-2.38-2.65-2.38-4.39a.5.5 0 0 1 .5-.5a.5.5 0 0 1 .5.5c0 1.41.72 2.74 1.94 3.56c.71.48 1.54.71 2.54.71c.24 0 .64-.03 1.04-.1c.27-.05.54.13.58.41c.05.26-.13.53-.41.58c-.57.11-1.07.12-1.21.12M14.91 22h-.13c-1.59-.46-2.63-1.05-3.72-2.12a7.28 7.28 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94c1.7 0 3.08 1.32 3.08 2.94c0 1.07.95 1.94 2.08 1.94c1.15 0 2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83c-2.84 0-5.46 1.58-6.61 4.03c-.39.81-.59 1.76-.59 2.8c0 .78.07 2.01.67 3.61c.1.26-.03.55-.29.64a.504.504 0 0 1-.64-.29c-.5-1.31-.73-2.62-.73-3.96c0-1.2.23-2.29.68-3.24c1.33-2.79 4.28-4.6 7.51-4.6c4.54 0 8.25 3.51 8.25 7.83c0 1.62-1.38 2.94-3.08 2.94c-1.7 0-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51c.95.94 1.86 1.46 3.27 1.84c.27.08.42.36.35.62c-.05.23-.26.38-.47.38Z"/>'
        },
        "fingerprint-off": {
            body: '<path fill="currentColor" d="M1.5 4.77L2.78 3.5L20.5 21.22l-1.27 1.28l-2.56-2.56c-1.09-.04-2.05-.34-2.85-.89c-1.48-1-2.36-2.62-2.38-4.34l-1.17-1.18c-.24.32-.38.7-.38 1.12c0 1.71.66 3.31 1.87 4.51c.95.94 1.86 1.46 3.27 1.84c.27.08.42.36.35.62c-.05.23-.26.38-.47.38h-.13c-1.59-.46-2.63-1.05-3.72-2.12a7.28 7.28 0 0 1-2.17-5.22c0-.69.25-1.33.67-1.83L8.5 11.77c-.72.77-1.16 1.78-1.16 2.89c0 1.44.32 2.77.93 3.84c.64 1.16 1.08 1.65 1.85 2.43c.19.2.19.51 0 .71c-.12.1-.24.15-.37.15s-.25-.05-.35-.15c-.87-.87-1.34-1.43-2.01-2.64c-.69-1.23-1.05-2.73-1.05-4.34c0-1.38.55-2.66 1.45-3.6L6.7 9.97c-.55.53-1.01 1.18-1.35 1.89c-.39.81-.59 1.76-.59 2.8c0 .78.07 2.01.67 3.61c.1.26-.03.55-.29.64a.504.504 0 0 1-.64-.29c-.5-1.31-.73-2.62-.73-3.96c0-1.2.23-2.29.68-3.24c.39-.81.91-1.54 1.55-2.16L4.97 8.24c-.39.39-.75.81-1.08 1.26c-.08.15-.23.22-.39.22l-.29-.09a.517.517 0 0 1-.12-.7c.36-.5.75-.97 1.18-1.4L1.5 4.77m16.31-.3l-.23-.06C15.66 3.42 14 3 12 3c-1.97 0-3.85.47-5.56 1.41l-.15.05l-.58-.57c.02-.15.11-.28.25-.36C7.82 2.5 9.86 2 12 2s4 .47 6.04 1.5c.25.15.34.45.21.69a.48.48 0 0 1-.44.28m-.66 1.18c1.5.77 2.76 1.85 3.75 3.25c.16.22.1.54-.12.7c-.23.16-.54.11-.7-.1a9.257 9.257 0 0 0-3.39-2.96c-2.63-1.35-5.93-1.46-8.66-.33l-.76-.76c3.07-1.41 6.87-1.35 9.88.2M12 9.27c3.12 0 5.66 2.42 5.66 5.39a.5.5 0 0 1-.5.5l-.23-.05l-.21-.22l-.06-.23c0-2.39-2.04-4.34-4.57-4.39l-.94-.94l.85-.06m2.38 8.95c.33.23.69.4 1.09.51l-2.84-2.83c.29.92.9 1.75 1.75 2.32m4.83-3.56c0-3.77-3.25-6.83-7.25-6.83c-.7 0-1.38.1-2.03.28l-.81-.81c.88-.3 1.85-.48 2.84-.48c4.54 0 8.25 3.51 8.25 7.83c0 1-.52 1.88-1.32 2.41l-.72-.72c.62-.34 1.04-.96 1.04-1.68Z"/>'
        },
        fire: {
            body: '<path fill="currentColor" d="M17.66 11.2c-.23-.3-.51-.56-.77-.82c-.67-.6-1.43-1.03-2.07-1.66C13.33 7.26 13 4.85 13.95 3c-.95.23-1.78.75-2.49 1.32c-2.59 2.08-3.61 5.75-2.39 8.9c.04.1.08.2.08.33c0 .22-.15.42-.35.5c-.23.1-.47.04-.66-.12a.58.58 0 0 1-.14-.17c-1.13-1.43-1.31-3.48-.55-5.12C5.78 10 4.87 12.3 5 14.47c.06.5.12 1 .29 1.5c.14.6.41 1.2.71 1.73c1.08 1.73 2.95 2.97 4.96 3.22c2.14.27 4.43-.12 6.07-1.6c1.83-1.66 2.47-4.32 1.53-6.6l-.13-.26c-.21-.46-.77-1.26-.77-1.26m-3.16 6.3c-.28.24-.74.5-1.1.6c-1.12.4-2.24-.16-2.9-.82c1.19-.28 1.9-1.16 2.11-2.05c.17-.8-.15-1.46-.28-2.23c-.12-.74-.1-1.37.17-2.06c.19.38.39.76.63 1.06c.77 1 1.98 1.44 2.24 2.8c.04.14.06.28.06.43c.03.82-.33 1.72-.93 2.27Z"/>'
        },
        "fire-alert": {
            body: '<path fill="currentColor" d="M15.66 11.2c-.23-.3-.51-.56-.77-.82c-.67-.6-1.43-1.03-2.07-1.66C11.33 7.26 11 4.85 11.95 3c-.95.23-1.78.75-2.49 1.32c-2.59 2.08-3.61 5.75-2.39 8.9c.04.1.08.2.08.33c0 .22-.15.42-.35.5c-.23.1-.47.04-.66-.12a.58.58 0 0 1-.14-.17c-1.13-1.43-1.31-3.48-.55-5.12C3.78 10 2.87 12.3 3 14.47c.06.5.12 1 .29 1.5c.14.6.41 1.2.71 1.73c1.08 1.73 2.95 2.97 4.96 3.22c2.14.27 4.43-.12 6.07-1.6c1.83-1.66 2.47-4.32 1.53-6.6l-.13-.26c-.21-.46-.77-1.26-.77-1.26m-3.16 6.3c-.28.24-.74.5-1.1.6c-1.12.4-2.24-.16-2.9-.82c1.19-.28 1.9-1.16 2.11-2.05c.17-.8-.15-1.46-.28-2.23c-.12-.74-.1-1.37.17-2.06c.19.38.39.76.63 1.06c.77 1 1.98 1.44 2.24 2.8c.04.14.06.28.06.43c.03.82-.33 1.72-.93 2.27M21 13h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "fire-circle": {
            body: '<path fill="currentColor" d="M14.66 14.18c.03.11.04.22.04.32c.03.65-.26 1.35-.73 1.78c-.22.19-.58.39-.86.47c-.88.31-1.76-.13-2.28-.64c.94-.22 1.49-.9 1.67-1.61c.12-.61-.13-1.12-.23-1.72c-.1-.58-.08-1.07.13-1.6c.15.29.31.59.5.82c.6.78 1.55 1.12 1.76 2.18M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-4.84.56l-.1-.2c-.16-.36-.61-.98-.61-.98c-.18-.23-.4-.44-.6-.64c-.53-.47-1.12-.8-1.63-1.29c-1.17-1.14-1.43-3.01-.68-4.45c-.75.18-1.4.58-1.96 1.03c-2.03 1.62-2.83 4.47-1.87 6.92c.03.08.06.16.06.26c0 .17-.12.32-.27.39c-.19.07-.37.03-.5-.1a.323.323 0 0 1-.13-.13c-.87-1.11-1.03-2.71-.44-3.98c-1.31 1.06-2.02 2.85-1.93 4.53c.06.39.1.78.24 1.17c.11.47.32.91.56 1.35c.84 1.34 2.31 2.31 3.89 2.5c1.68.21 3.48-.09 4.77-1.24c1.44-1.3 1.94-3.37 1.2-5.14Z"/>'
        },
        "fire-custom": {
            body: '<path fill="currentColor" d="M13.5 0.669922C13.5 0.669922 14.24 3.31992 14.24 5.46992C14.24 7.52992 12.89 9.19992 10.83 9.19992C8.76 9.19992 7.2 7.52992 7.2 5.46992L7.23 5.10992C5.21 7.50992 4 10.6199 4 13.9999C4 18.4199 7.58 21.9999 12 21.9999C16.42 21.9999 20 18.4199 20 13.9999C20 8.60992 17.41 3.79992 13.5 0.669922ZM11.71 18.9999C9.93 18.9999 8.49 17.5999 8.49 15.8599C8.49 14.2399 9.54 13.0999 11.3 12.7399C13.07 12.3799 14.9 11.5299 15.92 10.1599C16.31 11.4499 16.51 12.8099 16.51 14.1999C16.51 16.8499 14.36 18.9999 11.71 18.9999Z"/>'
        },
        "fire-extinguisher": {
            body: '<path fill="currentColor" d="M10.5 7h1.25L12 5h-1.75L6 7.5V9H4V6.5L10 3h2V2h2v1h2l1-.5v3L16 5h-2l.25 2h1.25A1.5 1.5 0 0 1 17 8.5V22H9V8.5A1.5 1.5 0 0 1 10.5 7Z"/>'
        },
        "fire-hydrant": {
            body: '<path fill="currentColor" d="M5 15v-1H4v-2h1v-1h2v4H5m14-3v-1h-2v4h2v-1h1v-2h-1m-1-6h-2.14C15.5 4.6 14.4 3.5 13 3.14V2h-2v1.14C9.6 3.5 8.5 4.6 8.14 6H6v2h12V6m0 16H6c0-1.1.9-2 2-2V9h8v11a2 2 0 0 1 2 2m-8-9a2 2 0 1 0 4 0c0-1.11-.89-2-2-2s-2 .9-2 2Z"/>'
        },
        "fire-hydrant-alert": {
            body: '<path fill="currentColor" d="M22 7h-2v6h2V7m0 8h-2v2h2v-2M3 15v-1H2v-2h1v-1h2v4H3m14-3v-1h-2v4h2v-1h1v-2h-1m-1-6h-2.14C13.5 4.6 12.4 3.5 11 3.14V2H9v1.14C7.6 3.5 6.5 4.6 6.14 6H4v2h12V6m0 16H4a2 2 0 0 1 2-2V9h8v11a2 2 0 0 1 2 2m-8-9a2 2 0 1 0 4 0c0-1.11-.89-2-2-2s-2 .9-2 2Z"/>'
        },
        "fire-hydrant-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l1.27-1.27L2.39 1.73L1.11 3L8 9.89V20c-1.1 0-2 .9-2 2h12a2 2 0 0 0-2-2v-2.11l4.84 4.84M10.22 12.11l2.67 2.67c-.27.14-.57.22-.89.22a2 2 0 0 1-2-2c0-.32.08-.62.22-.89M11.2 8L8.44 5.24c.5-1.03 1.43-1.81 2.56-2.1V2h2v1.14c1.4.36 2.5 1.46 2.86 2.86H18v2h-6.8m7.8 3v1h1v2h-1v1h-.8L17 13.8V11h2M5 15v-1H4v-2h1v-1h2v4H5m11-2.2L12.2 9H16v3.8Z"/>'
        },
        "fire-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.98 6C5.66 10.36 4.88 12.47 5 14.47c.06.5.12 1 .29 1.5c.14.6.41 1.2.71 1.73c1.08 1.73 2.95 2.97 4.96 3.22c2.14.27 4.43-.12 6.07-1.6c.07-.06.12-.14.19-.21l3.62 3.62l1.27-1.27M8.8 14.05c-.23.1-.47.04-.66-.12a.58.58 0 0 1-.14-.17c-1-1.29-1.26-3.07-.74-4.61l1.32 1.32c0 .93.15 1.86.49 2.75c.04.1.08.2.08.33c0 .22-.15.42-.35.5m5.7 3.45c-.28.24-.74.5-1.1.6c-1.12.4-2.24-.16-2.9-.82c1.19-.28 1.9-1.16 2.11-2.05c.05-.23.05-.47.03-.7L15 16.88c-.15.23-.31.45-.5.62m4.42-1.78L9.65 6.46c.47-.81 1.07-1.54 1.81-2.14c.71-.57 1.54-1.09 2.49-1.32c-.95 1.85-.62 4.26.87 5.72c.64.63 1.4 1.06 2.07 1.66c.26.26.54.52.77.82c0 0 .56.8.77 1.26l.13.26c.4.97.5 2 .36 3Z"/>'
        },
        "fire-truck": {
            body: '<path fill="currentColor" d="M17.04 2c-.19 0-.38.04-.54.14L5.59 8.5h3.96l7.95-4.64c.5-.28.63-.89.35-1.36c-.17-.3-.47-.5-.81-.5M16 8v2H3a2 2 0 0 0-2 2h1v3H1v4h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-6.5L19.5 8H16m2 1.5h1l2.5 3v1H18v-4M4 12h3v3H4v-3m5 0h3v3H9v-3m5 0h2v3h-2v-3m-8 5.5A1.5 1.5 0 0 1 7.5 19A1.5 1.5 0 0 1 6 20.5A1.5 1.5 0 0 1 4.5 19A1.5 1.5 0 0 1 6 17.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        firebase: {
            body: '<path fill="currentColor" d="m20 18.69l-7.3 4.05c-.5.26-1 .26-1.5 0L4 18.69L17.05 5.54l.35-.1c.3 0 .47.13.5.4L20 18.69M9.35 5.74L4.8 13.29L6.7 1.34c.03-.27.2-.4.5-.4c.2 0 .33.06.4.25l2.15 3.95l-.4.6M13.85 7L4.3 16.59l7.25-12.3c.1-.2.25-.29.45-.29s.33.09.4.29L13.85 7Z"/>'
        },
        firefox: {
            body: '<path fill="currentColor" d="M6.85 6.74c.01 0 .01 0 0 0M21.28 8.6c-.43-1.05-1.32-2.18-2.01-2.54c.56 1.11.89 2.22 1.02 3.04v.02c-1.13-2.82-3.05-3.96-4.62-6.44c-.08-.12-.17-.25-.24-.38c-.04-.07-.07-.14-.11-.21c-.06-.13-.12-.26-.15-.4c0-.01-.01-.02-.02-.02h-.03c-2.22 1.3-3.15 3.59-3.38 5.04c-.69.04-1.37.21-1.99.51c-.12.05-.17.19-.13.31c.05.14.21.21.34.15c.54-.26 1.14-.41 1.74-.45h.05c.08-.01.17-.01.25-.01c.5-.01.97.06 1.44.2l.06.02c.1.02.17.06.25.06c.05.04.11.06.16.08l.14.06c.07.03.14.06.2.09c.03.02.06.03.09.05c.07.04.16.07.2.11c.04.02.08.05.12.07c.73.45 1.34 1.07 1.75 1.81c-.53-.37-1.49-.74-2.41-.58c3.6 1.81 2.63 8-2.36 7.76c-.44-.01-.88-.1-1.3-.25c-.1-.03-.2-.07-.29-.12c-.05-.02-.12-.05-.17-.08c-1.23-.63-2.24-1.82-2.38-3.27c0 0 .5-1.73 3.33-1.73c.31 0 1.17-.86 1.2-1.1c0-.09-1.74-.78-2.42-1.45c-.37-.36-.54-.53-.69-.66c-.08-.07-.17-.13-.26-.19a4.63 4.63 0 0 1-.03-2.45C7.6 6.12 6.8 6.86 6.22 7.5c-.4-.5-.37-2.15-.35-2.5c-.01 0-.3.16-.33.18c-.35.25-.68.53-.98.82c-.35.37-.66.74-.94 1.14c-.62.91-1.12 1.95-1.34 3.04c0 .01-.1.41-.17.92l-.03.23c-.02.17-.04.32-.08.58v.41c0 5.53 4.5 10.01 10 10.01c4.97 0 9.08-3.59 9.88-8.33c.02-.11.03-.24.05-.37c.2-1.72-.02-3.52-.65-5.03Z"/>'
        },
        fireplace: {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2m0-16H2V3h20v3m-2 1v12h-3v-8s-2.5-1-5-1s-5 1-5 1v8H4V7h16m-5.5 7.67h-.03l.34.55l.06.12c.42 1.01.13 2.16-.66 2.9c-.71.66-1.71.83-2.63.71c-.87-.11-1.68-.66-2.13-1.42c-.15-.23-.26-.5-.32-.76L9 16.11c-.04-.96.34-1.97 1.06-2.57c-.33.72-.25 1.62.24 2.25l.06.08c.08.07.19.1.28.05c.09-.03.16-.12.16-.22l-.04-.14c-.53-1.39-.08-3.01 1.03-3.93c.31-.25.71-.48 1.08-.58c-.41.82-.26 1.88.38 2.52l.89.73l.36.37m-1.39 2.77c.26-.24.42-.64.39-1v-.19c-.12-.6-.65-.79-1-1.25l-.24-.45c-.13.3-.14.58-.09.91c.06.34.2.63.12.98c-.09.39-.39.78-.92.91c.3.29.78.52 1.27.36l.47-.27Z"/>'
        },
        "fireplace-off": {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2m0-16H2V3h20v3m-2 1v12h-3v-8s-2.5-1-5-1s-5 1-5 1v8H4V7h16Z"/>'
        },
        firewire: {
            body: '<path fill="currentColor" d="M12 10c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m3 9H9v2h6v-2m0 3H9v2h6v-2m-8.7-9.4l4.2-4.2l-1.3-1.5l-4.3 4.3l1.4 1.4M4.2 8.5l4.2-4.2l-1.3-1.5l-4.3 4.3l1.4 1.4M15 17H9v2h6v-2M13.4 6.3l4.2 4.2L21.1 7l-4.2-4.2l-3.5 3.5Z"/>'
        },
        firework: {
            body: '<path fill="currentColor" d="m5.8 16.59l-1.3-1.31l7.76-7.78l4.24 4.24l-7.78 7.76l-1.43-1.41c-.25.07-.49.19-.66.41c-.06.07-.13.15-.13.24c-.08.14-.12.26-.18.41c-.11.27-.23.54-.39.78c-.12.17-.25.33-.4.46c-.11.11-.24.2-.37.27c-.08.05-.16.1-.26.13c-.6.25-1.27.21-1.9.21v-2h.9c.1 0 .18 0 .26-.06l.05-.05c.07-.08.13-.19.18-.29c.08-.18.14-.36.21-.54l.04-.1c.12-.27.26-.51.44-.73c.1-.13.22-.23.34-.36c.12-.1.24-.2.38-.28M21 3l-1.12 8.19l-7.07-7.07L21 3Z"/>'
        },
        "firework-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-7.67-7.67l-4.45 4.44l-1.43-1.41c-.25.07-.49.19-.66.41c-.06.07-.13.15-.13.24c-.08.14-.12.26-.18.41c-.11.27-.23.54-.39.78c-.12.17-.25.33-.4.46c-.11.11-.24.2-.37.27c-.08.05-.16.1-.26.13c-.6.25-1.27.21-1.9.21v-2h.9c.1 0 .18 0 .26-.06l.05-.05c.07-.08.13-.19.18-.29c.08-.18.14-.36.21-.54l.04-.1c.12-.27.26-.51.44-.73c.1-.13.22-.23.34-.36c.12-.1.24-.2.38-.28l-1.3-1.31l4.44-4.45L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M21 3l-8.19 1.12l7.07 7.07L21 3m-4.5 8.74L12.26 7.5l-.76.78l4.22 4.22l.78-.76Z"/>'
        },
        fish: {
            body: '<path fill="currentColor" d="m12 20l.76-3c-3.26-.21-6.17-1.6-7.01-3.42c-.09.48-.22.92-.42 1.25C4.67 16 3.33 16 2 16c1.1 0 1.5-1.57 1.5-3.5S3.1 9 2 9c1.33 0 2.67 0 3.33 1.17c.2.33.33.77.42 1.25c.65-1.42 2.57-2.57 4.91-3.1L9 5c2 0 4 0 5.33.67c1.13.56 1.78 1.6 2.36 2.71c2.92.7 5.31 2.28 5.31 4.12c0 1.88-2.5 3.5-5.5 4.16c-.83 1.1-1.64 2.12-2.33 2.67c-.84.67-1.5.67-2.17.67m5-9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "fish-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-5.1-5.1c-.6.7-1.1 1.3-1.6 1.7c-.8.7-1.4.7-2.1.7l.8-3c-3.3-.2-6.2-1.6-7-3.4c-.1.5-.2.9-.4 1.2C4.7 16 3.3 16 2 16c1.1 0 1.5-1.6 1.5-3.5S3.1 9 2 9c1.3 0 2.7 0 3.3 1.2c.2.3.3.8.4 1.2c.3-.7 1-1.4 1.9-1.9L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M9.8 6.6L9 5c2 0 4 0 5.3.7c1.1.6 1.8 1.6 2.4 2.7c2.9.7 5.3 2.3 5.3 4.1c0 1.3-1.2 2.5-3 3.3L9.8 6.6M16 12c0 .6.4 1 1 1s1-.4 1-1s-.4-1-1-1s-1 .4-1 1Z"/>'
        },
        fishbowl: {
            body: '<path fill="currentColor" d="M19.11 5H21V3H3v2h1.89A9.93 9.93 0 0 0 2 12c0 3.97 2.31 7.39 5.66 9h8.68A9.973 9.973 0 0 0 22 12c0-2.73-1.11-5.2-2.89-7m-5.86 12c-1.16 0-2.19-.36-2.92-.83c-.66.83-2 .83-3.33.83c1.1 0 1.5-1.12 1.5-2.5S8.1 12 7 12c1.33 0 2.67 0 3.37.91c.69-.55 1.72-.91 2.88-.91c2.07 0 3.75 1.12 3.75 2.5S15.32 17 13.25 17M16 7c-2.44 1.71-5.56 1.71-8 0c-.94.66-2 1.09-3.05 1.25c.36-.67.82-1.29 1.37-1.84L7.7 5h8.6l1.38 1.41a7.87 7.87 0 0 1 1.37 1.84A7.272 7.272 0 0 1 16 7Z"/>'
        },
        "fishbowl-outline": {
            body: '<path fill="currentColor" d="M19.11 5H21V3H3v2h1.89A9.93 9.93 0 0 0 2 12c0 3.97 2.31 7.39 5.66 9h8.68A9.973 9.973 0 0 0 22 12c0-2.73-1.11-5.2-2.89-7M6.32 6.41L7.7 5h8.6l1.38 1.41a7.87 7.87 0 0 1 1.37 1.84A7.272 7.272 0 0 1 16 7c-2.44 1.71-5.56 1.71-8 0c-.94.66-2 1.09-3.05 1.25c.36-.67.82-1.29 1.37-1.84M15.85 19h-7.7A7.93 7.93 0 0 1 4 12c0-.57.07-1.14.19-1.68A8.74 8.74 0 0 0 8 9.33c2.5 1.3 5.5 1.3 8 0c1.2.62 2.5.96 3.81.99c.12.54.19 1.11.19 1.68a7.93 7.93 0 0 1-4.15 7M17 14.5c0 1.38-1.68 2.5-3.75 2.5c-1.16 0-2.19-.36-2.92-.84c-.66.84-2 .84-3.33.84c1.1 0 1.5-1.12 1.5-2.5S8.1 12 7 12c1.33 0 2.67 0 3.37.91c.69-.55 1.72-.91 2.88-.91c2.07 0 3.75 1.12 3.75 2.5Z"/>'
        },
        "fit-to-page": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2m-8 2l3 3h-2v2h-2V7H9m-2 8l-3-3l3-3v2h2v2H7m5 7l-3-3h2v-2h2v2h2m2-2v-2h-2v-2h2V9l3 3"/>'
        },
        "fit-to-page-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2m0 18H4V4h16m-7 4v2h-2V8H9l3-3l3 3m1 7v-2h-2v-2h2V9l3 3m-9 1H8v2l-3-3l3-3v2h2m5 5l-3 3l-3-3h2v-2h2v2"/>'
        },
        "fit-to-screen": {
            body: '<path fill="currentColor" d="M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4M4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2m16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2M7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2M18 8H6v8h12V8Z"/>'
        },
        "fit-to-screen-outline": {
            body: '<path fill="currentColor" d="M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4M4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2m16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2M7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2m9-8v4H8v-4h8m2-2H6v8h12V8Z"/>'
        },
        flag: {
            body: '<path fill="currentColor" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Z"/>'
        },
        "flag-checkered": {
            body: '<path fill="currentColor" d="M14.4 6H20v10h-7l-.4-2H7v7H5V4h9l.4 2m-.4 8h2v-2h2v-2h-2V8h-2v2l-1-2V6h-2v2H9V6H7v2h2v2H7v2h2v-2h2v2h2v-2l1 2v2m-3-4V8h2v2h-2m3 0h2v2h-2v-2Z"/>'
        },
        "flag-checkered-variant": {
            body: '<path d="M6 3a1 1 0 0 1 1 1v.875C8.063 4.437 9.5 4 11 4c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4a1 1 0 0 1 1-1zm5 5.75c1.221 0 2.07.652 3 1.16v1.416c.594.37 1.221.674 2 .674c2 0 2-.5 2-.5v-1.25s-1 .25-2 .25c-.779 0-1.406-.265-2-.59V8.576c.594.37 1.221.674 2 .674c2 0 2-.25 2-.25V7.5S17 8 16 8c-.779 0-1.406-.303-2-.674v1.25c-.93-.58-1.779-1.326-3-1.326V6C9 6 7 7.25 7 7.25V8.5s2-1.25 4-1.25v1.5C9 8.75 7 10 7 10v1.5S9 10 11 10V8.75z" fill="currentColor"/>',
            hidden: true
        },
        "flag-minus": {
            body: '<path fill="currentColor" d="M12.4 5H18v10h-7l-.4-2H5v7H3V3h9l.4 2M14 17h8v2h-8v-2Z"/>'
        },
        "flag-minus-outline": {
            body: '<path fill="currentColor" d="m12.36 6l.4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6M23 18h-8v2h8v-2Z"/>'
        },
        "flag-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L14.11 16H13l-.28-1.39l-.61-.61H7v7H5V6.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M20 16V6h-5.6L14 4H7.2l12 12h.8"/>'
        },
        "flag-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L5 6.89V21h2v-7h5.11l.61.61L13 16h1.11l6.73 6.73l1.27-1.27M7 12V8.89L10.11 12H7m2.2-6l-2-2H14l.4 2H20v10h-.8l-2-2h.8V8h-5.24l-.4-2H9.2Z"/>'
        },
        "flag-outline": {
            body: '<path fill="currentColor" d="m12.36 6l.4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6"/>'
        },
        "flag-outline-variant": {
            body: '<path d="M6 3a1 1 0 0 1 1 1v.875C8.063 4.437 9.5 4 11 4c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4a1 1 0 0 1 1-1zm1 4.25v4.25S9 10 11 10s3 2 5 2s2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2S7 7.25 7 7.25z" fill="currentColor"/>',
            hidden: true
        },
        "flag-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3m-4.6-9H18v7c-2.22 0-4.16 1.21-5.2 3H11l-.4-2H5v7H3V3h9l.4 2Z"/>'
        },
        "flag-plus-outline": {
            body: '<path fill="currentColor" d="m13 16l-.4-2H7v7H5V4h9l.4 2H20v7.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V8h-5.24l-.4-2H7v6h7.24l.4 2h1.05c-.77.5-1.42 1.2-1.88 2H13m5-1v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "flag-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M12.4 5H18v7c-2.22 0-4.16 1.21-5.2 3H11l-.4-2H5v7H3V3h9l.4 2Z"/>'
        },
        "flag-remove-outline": {
            body: '<path fill="currentColor" d="m13 16l-.4-2H7v7H5V4h9l.4 2H20v7.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V8h-5.24l-.4-2H7v6h7.24l.4 2h1.05c-.77.5-1.42 1.2-1.88 2H13m8.12-.54L19 17.59l-2.12-2.13l-1.41 1.42L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "flag-triangle": {
            body: '<path fill="currentColor" d="M7 2h2v20H7V2m12 7l-8 5.6V3.4L19 9Z"/>'
        },
        "flag-variant": {
            body: '<path fill="currentColor" d="M6 3a1 1 0 0 1 1 1v.88C8.06 4.44 9.5 4 11 4c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4a1 1 0 0 1 1-1Z"/>'
        },
        "flag-variant-minus": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m9 15v2h8v-2h-8Z"/>'
        },
        "flag-variant-minus-outline": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m1 4.2v4.2s2-1.5 4-1.5s3 2 5 2s2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2S7 7.2 7 7.2M15 18v2h8v-2h-8Z"/>'
        },
        "flag-variant-off": {
            body: '<path fill="currentColor" d="M20.8 22.7L10.2 12.1C7.8 12.4 7 14 7 14v7H5V6.9L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M20 12V4s-1 2-4 2c-2 0-2-2-5-2c-1.2 0-2.3.3-3.2.6l9.3 9.3C19.2 13.5 20 12 20 12Z"/>'
        },
        "flag-variant-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3L5 6.9V21h2v-7s.8-1.6 3.2-1.9l10.7 10.7l1.2-1.3M7 11.5V8.9l1.7 1.7c-1 .4-1.7.9-1.7.9m2.4-5.3L7.8 4.6c.9-.3 2-.6 3.2-.6c3 0 3 2 5 2c3 0 4-2 4-2v8s-.8 1.5-2.9 1.9L15 11.8c.3.1.6.2 1 .2c2 0 2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2c-.5 0-1.1.1-1.6.2Z"/>'
        },
        "flag-variant-outline": {
            body: '<path fill="currentColor" d="M6 3a1 1 0 0 1 1 1v.88C8.06 4.44 9.5 4 11 4c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4a1 1 0 0 1 1-1m1 4.25v4.25S9 10 11 10s3 2 5 2s2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2S7 7.25 7 7.25Z"/>'
        },
        "flag-variant-plus": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m12 12v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "flag-variant-plus-outline": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m1 4.2v4.2s2-1.5 4-1.5s3 2 5 2s2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2S7 7.2 7 7.2M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "flag-variant-remove": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m15.1 12.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "flag-variant-remove-outline": {
            body: '<path fill="currentColor" d="M6 3c.6 0 1 .4 1 1v.9c1.1-.5 2.5-.9 4-.9c3 0 3 2 5 2c3 0 4-2 4-2v8s-1 2-4 2s-3-2-5-2c-3 0-4 2-4 2v7H5V4c0-.6.4-1 1-1m1 4.2v4.2s2-1.5 4-1.5s3 2 5 2s2-1 2-1V7.5S17 8 16 8c-2 0-3-2-5-2S7 7.2 7 7.2m14.1 8.3L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        flare: {
            body: '<path fill="currentColor" d="M7 11H1v2h6v-2m2.17-3.24L7.05 5.64L5.64 7.05l2.12 2.12l1.41-1.41M13 1h-2v6h2V1m5.36 6.05l-1.41-1.41l-2.12 2.12l1.41 1.41l2.12-2.12M17 11v2h6v-2h-6m-5-2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m2.83 7.24l2.12 2.12l1.41-1.41l-2.12-2.12l-1.41 1.41m-9.19.71l1.41 1.41l2.12-2.12l-1.41-1.41l-2.12 2.12M11 23h2v-6h-2v6Z"/>'
        },
        flash: {
            body: '<path fill="currentColor" d="M7 2v11h3v9l7-12h-4l4-8H7Z"/>'
        },
        "flash-alert": {
            body: '<path fill="currentColor" d="M5 2v11h3v9l7-12h-4l4-8m2 13h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "flash-alert-outline": {
            body: '<path fill="currentColor" d="M5 2h10l-3.5 7H15L8 22v-8H5V2m2 2v8h3v2.66L12 11H8.24l3.52-7M17 15h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "flash-auto": {
            body: '<path fill="currentColor" d="M16.85 7.65L18 4l1.15 3.65M19 2h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9M3 2v12h3v9l7-12H9l4-9H3Z"/>'
        },
        "flash-off": {
            body: '<path fill="currentColor" d="M17 10h-4l4-8H7v2.18l8.46 8.46M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20L19 18.73L3.27 3Z"/>'
        },
        "flash-off-outline": {
            body: '<path fill="currentColor" d="m9 6.19l-2-2V2h10l-3.5 7H17l-1.82 3.37l-3.75-3.75L13.76 4H9v2.19m10 12.54L17.73 20l-4.32-4.32L10 22v-8H7V9.27l-5-5L3.27 3L19 18.73Z"/>'
        },
        "flash-outline": {
            body: '<path fill="currentColor" d="M7 2h10l-3.5 7H17l-7 13v-8H7V2m2 2v8h3v2.66L14 11h-3.76l3.52-7H9Z"/>'
        },
        "flash-red-eye": {
            body: '<path fill="currentColor" d="M16 5c-.56 0-1 .44-1 1s.44 1 1 1s1-.44 1-1s-.44-1-1-1m0-3c-2.73 0-5.06 1.66-6 4c.94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 1.5A2.5 2.5 0 0 1 18.5 6A2.5 2.5 0 0 1 16 8.5A2.5 2.5 0 0 1 13.5 6A2.5 2.5 0 0 1 16 3.5M3 2v12h3v9l7-12H9l1.12-2.5C9.44 7.76 8.88 6.93 8.5 6c.69-1.71 2-3.12 3.61-4H3Z"/>'
        },
        "flash-triangle": {
            body: '<path fill="currentColor" d="M12 2L1 21h22L12 2m-2 13v-5h4l-1.5 3.5h2l-3 5.5v-4H10Z"/>'
        },
        "flash-triangle-outline": {
            body: '<path fill="currentColor" d="M12 2L1 21h22M12 6l7.5 13h-15m9.5-5h-1.5l1.5-3h-4v4h1v3l3-4Z"/>'
        },
        flashlight: {
            body: '<path fill="currentColor" d="M9 10L6 5h12l-3 5H9m9-6H6V2h12v2M9 22V11h6v11H9m3-9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "flashlight-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22L15 18.27V22H9v-9.73l-7-7M18 5l-3 5h-3.18l-5-5H18m0-1H6V2h12v2m-3 7v2.18L12.82 11H15Z"/>'
        },
        flask: {
            body: '<path fill="currentColor" d="M6 22a3 3 0 0 1-3-3c0-.6.18-1.16.5-1.63L9 7.81V6a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 0 1-3 3H6m-1-3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1c0-.21-.07-.41-.18-.57l-2.29-3.96L14 17l-5.07-5.07l-3.75 6.5c-.11.16-.18.36-.18.57m8-9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "flask-empty": {
            body: '<path fill="currentColor" d="M6 22a3 3 0 0 1-3-3c0-.6.18-1.16.5-1.63L9 7.81V6a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 0 1-3 3H6Z"/>'
        },
        "flask-empty-minus": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37C14.92 12.84 13 15.2 13 18c0 1.54.58 2.94 1.53 4H6Z"/>'
        },
        "flask-empty-minus-outline": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57Z"/>'
        },
        "flask-empty-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-1.2-1.2c-.5.3-1 .5-1.6.5H6c-1.7 0-3-1.3-3-3c0-.6.2-1.2.5-1.6l4.4-7.6L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M15 7.8V6c.6 0 1-.4 1-1V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v.8l12.4 12.4L15 7.8Z"/>'
        },
        "flask-empty-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l6.8 6.8l-4.4 7.6c-.3.4-.5 1-.5 1.6c0 1.7 1.3 3 3 3h12c.6 0 1.2-.2 1.6-.5l1.2 1.2l1.3-1.2M18 20H6c-.6 0-1-.4-1-1c0-.2.1-.4.2-.6l4.2-7.2L18 20c.1 0 0 0 0 0M11 7.8l-3-3V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1c0 .6-.4 1-1 1v1.8l5.4 9.4l-5.4-5.4l-2-3.4V4h-2v3.8Z"/>'
        },
        "flask-empty-outline": {
            body: '<path fill="currentColor" d="M5 19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1c0-.21-.07-.41-.18-.57L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57m1 3a3 3 0 0 1-3-3c0-.6.18-1.16.5-1.63L9 7.81V6a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 0 1-3 3H6Z"/>'
        },
        "flask-empty-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37C14.92 12.84 13 15.2 13 18c0 1.54.58 2.94 1.53 4H6Z"/>'
        },
        "flask-empty-plus-outline": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57Z"/>'
        },
        "flask-empty-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37C14.92 12.84 13 15.2 13 18c0 1.54.58 2.94 1.53 4H6Z"/>'
        },
        "flask-empty-remove-outline": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57Z"/>'
        },
        "flask-minus": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-2 .52-3.64 2.08-4.24 4.08l-4.33-4.33l-3.75 6.5c-.11.16-.18.36-.18.57c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6m7-12c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "flask-minus-outline": {
            body: '<path fill="currentColor" d="M23 17v2h-8v-2h8M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57m8-3l.58-.58c-.37.78-.58 1.66-.58 2.58H7.73l2.66-4.61L13 16m-.5-4c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5Z"/>'
        },
        "flask-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l6.8 6.8l-4.4 7.6c-.3.4-.5 1-.5 1.6c0 1.7 1.3 3 3 3h12c.6 0 1.2-.2 1.6-.5l1.2 1.2l1.3-1.2M18 20H6c-.6 0-1-.4-1-1c0-.2.1-.4.2-.6L9 11.9l5 5.1l.6-.6L18 20c.1 0 0 0 0 0M8 4.8V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1c0 .6-.4 1-1 1v1.8l5.4 9.4L8 4.8Z"/>'
        },
        "flask-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l6.8 6.8l-4.4 7.6c-.3.4-.5 1-.5 1.6c0 1.7 1.3 3 3 3h12c.6 0 1.2-.2 1.6-.5l1.2 1.2l1.3-1.2M18 20H6c-.6 0-1-.4-1-1c0-.2.1-.4.2-.6l4.2-7.2l4.2 4.2l-.6.6l-2.6-2.6L7.7 18h8.4l1.9 2c.1 0 0 0 0 0M11 7.8l-3-3V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1c0 .6-.4 1-1 1v1.8l5.4 9.4l-5.4-5.4l-2-3.4V4h-2v3.8Z"/>'
        },
        "flask-outline": {
            body: '<path fill="currentColor" d="M5 19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1c0-.21-.07-.41-.18-.57L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57m1 3a3 3 0 0 1-3-3c0-.6.18-1.16.5-1.63L9 7.81V6a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63a3 3 0 0 1-3 3H6m7-6l1.34-1.34L16.27 18H7.73l2.66-4.61L13 16m-.5-4a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5Z"/>'
        },
        "flask-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-2 .52-3.64 2.08-4.24 4.08l-4.33-4.33l-3.75 6.5c-.11.16-.18.36-.18.57c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6m7-12c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "flask-plus-outline": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57m8-3l.58-.58c-.37.78-.58 1.66-.58 2.58H7.73l2.66-4.61L13 16m-.5-4c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5Z"/>'
        },
        "flask-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M6 22c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-2 .52-3.64 2.08-4.24 4.08l-4.33-4.33l-3.75 6.5c-.11.16-.18.36-.18.57c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6m7-12c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "flask-remove-outline": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.12l1.41 1.41L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.12l-1.41-1.41L17.59 18l-2.13-2.12M5 19c0 .55.45 1 1 1h7.34c.27.75.66 1.42 1.19 2H6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.64L9 7.81V6c-.55 0-1-.45-1-1V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1c0 .55-.45 1-1 1v1.81l2.5 4.37c-.64.17-1.26.45-1.81.82L13 8.35V4h-2v4.35L5.18 18.43c-.11.16-.18.36-.18.57m8-3l.58-.58c-.37.78-.58 1.66-.58 2.58H7.73l2.66-4.61L13 16m-.5-4c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5Z"/>'
        },
        "flask-round-bottom": {
            body: '<path fill="currentColor" d="M19 15c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.2 4-6.33V5c0-.55.45-1 1-1h.5l-1-2h5l-1 2h.5c.55 0 1 .45 1 1v3.67c2.36 1.13 4 3.54 4 6.33m-8-9v4.1A5 5 0 0 0 7 15l.08.91L9 13.93L13.07 18l3.86-3.86A5.013 5.013 0 0 0 13 10.1V6h-2m2.07 6c.55 0 1 .45 1 1s-.45 1-1 1c-.57 0-1-.45-1-1s.43-1 1-1Z"/>'
        },
        "flask-round-bottom-empty": {
            body: '<path fill="currentColor" d="M19 15c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.2 4-6.33V5c0-.55.45-1 1-1h.5l-1-2h5l-1 2h.5c.55 0 1 .45 1 1v3.67c2.36 1.13 4 3.54 4 6.33Z"/>'
        },
        "flask-round-bottom-empty-outline": {
            body: '<path fill="currentColor" d="M19 15c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.2 4-6.33V5c0-.55.45-1 1-1h.5l-1-2h5l-1 2h.5c.55 0 1 .45 1 1v3.67c2.36 1.13 4 3.54 4 6.33m-8-9v4.1a5 5 0 1 0 2 0V6h-2Z"/>'
        },
        "flask-round-bottom-outline": {
            body: '<path fill="currentColor" d="M15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3v-1h2v1c0 .55.45 1 1 1s1-.45 1-1v-1h2v1m4 0c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.2 4-6.33V5c0-.55.45-1 1-1h.5l-1-2h5l-1 2h.5c.55 0 1 .45 1 1v3.67c2.36 1.13 4 3.54 4 6.33m-8-9v4.1a5 5 0 1 0 2 0V6h-2Z"/>'
        },
        flattr: {
            body: '<path d="M21 12a9 9 0 0 1-9 9H4.5l5.24-5.24l1.42 1.41L9.33 19H12a7 7 0 0 0 7-7V7l2-2v7M3 12a9 9 0 0 1 9-9h7.5l-5.24 5.24l-1.42-1.41L14.67 5H12a7 7 0 0 0-7 7v5l-2 2v-7z" fill="currentColor"/>',
            hidden: true
        },
        "fleur-de-lis": {
            body: '<path fill="currentColor" d="M12 2S9 4 9 7s2 5 2 9h-1s0-2-1-4c-2-4-6-2-6 1s2 3 2 3c0-3 3.5-3 3.5 0H7v2h3.5L9 20s1 1 2 0l1 2l1-2c1 1 2 0 2 0l-1.5-2H17v-2h-1.5c0-3 3.5-3 3.5 0c0 0 2 0 2-3s-4-5-6-1c-1 2-1 4-1 4h-1c0-4 2-6 2-9s-3-5-3-5Z"/>'
        },
        flickr: {
            body: '<path d="M11 12c0 2.5-2 4.5-4.5 4.5S2 14.5 2 12s2-4.5 4.5-4.5S11 9.5 11 12m6.5-4.5C15 7.5 13 9.5 13 12s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5z" fill="currentColor"/>',
            hidden: true
        },
        "flickr-after": {
            body: '<circle cx="17" cy="12" r="4" fill="currentColor"/>',
            hidden: true
        },
        "flickr-before": {
            body: '<circle cx="7" cy="12" r="4" fill="currentColor"/>',
            hidden: true
        },
        "flip-horizontal": {
            body: '<path fill="currentColor" d="M15 21h2v-2h-2m4-10h2V7h-2M3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2m16-2v2h2c0-1.1-.9-2-2-2m-8 20h2V1h-2m8 16h2v-2h-2M15 5h2V3h-2m4 10h2v-2h-2m0 10c1.1 0 2-.9 2-2h-2Z"/>'
        },
        "flip-to-back": {
            body: '<path fill="currentColor" d="M15 17h2v-2h-2m0-10h2V3h-2M5 7H3v12a2 2 0 0 0 2 2h12v-2H5m14-2a2 2 0 0 0 2-2h-2m0-6h2V7h-2m0 6h2v-2h-2M9 17v-2H7a2 2 0 0 0 2 2m4-14h-2v2h2m6-2v2h2a2 2 0 0 0-2-2m-6 12h-2v2h2M9 3c-1.11 0-2 .89-2 2h2m0 6H7v2h2m0-6H7v2h2V7Z"/>'
        },
        "flip-to-front": {
            body: '<path fill="currentColor" d="M7 21h2v-2H7m4 2h2v-2h-2m8-4H9V5h10m0-2H9c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-4 18h2v-2h-2M3 9h2V7H3m2 14v-2H3a2 2 0 0 0 2 2m-2-4h2v-2H3m0-2h2v-2H3v2Z"/>'
        },
        "flip-vertical": {
            body: '<path fill="currentColor" d="M3 15v2h2v-2m10 4v2h2v-2m2-16H5c-1.1 0-2 .9-2 2v4h2V5h14v4h2V5c0-1.1-.9-2-2-2m2 16h-2v2c1.1 0 2-.9 2-2M1 11v2h22v-2M7 19v2h2v-2m10-4v2h2v-2m-10 4v2h2v-2M3 19c0 1.1.9 2 2 2v-2Z"/>'
        },
        "floor-1": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zm-2 5h4v10h-2v-8h-2V8z" fill="currentColor"/>',
            hidden: true
        },
        "floor-2": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zM9 8h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2v-2H9V8z" fill="currentColor"/>',
            hidden: true
        },
        "floor-3": {
            body: '<path d="M12 3l10 9h-3v8H5v-8H2l10-9zm3 8.5V10a2 2 0 0 0-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 0 0 2-2v-1.5c0-.83-.67-1.5-1.5-1.5c.83 0 1.5-.67 1.5-1.5z" fill="currentColor"/>',
            hidden: true
        },
        "floor-a": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zm-1 5h2a2 2 0 0 1 2 2v8h-2v-3h-2v3H9v-8a2 2 0 0 1 2-2zm0 2v3h2v-3h-2z" fill="currentColor"/>',
            hidden: true
        },
        "floor-b": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zM9 8h4a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5V16a2 2 0 0 1-2 2H9V8zm2 2v2h2v-2h-2zm0 4v2h2v-2h-2z" fill="currentColor"/>',
            hidden: true
        },
        "floor-g": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zm-1 5h4v2h-4v6h2v-4h2v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z" fill="currentColor"/>',
            hidden: true
        },
        "floor-l": {
            body: '<path d="M12 3L2 12h3v8h14v-8h3L12 3zM9 8h2v8h4v2H9V8z" fill="currentColor"/>',
            hidden: true
        },
        "floor-lamp": {
            body: '<path fill="currentColor" d="m15 2l2 7H7l2-7m2 8h2v10h3v2H8v-2h3V10Z"/>'
        },
        "floor-lamp-dual": {
            body: '<path fill="currentColor" d="m11.73 10.06l-1.56 1.18l.83.96V20H8v2h8v-2h-3v-7.7l.85-1.04l-1.58-1.19l-.54-.01m-2.65.76L3 6.81L9.39 2l2.16 6.93l-2.47 1.89M14.61 2L21 6.81l-6.08 4.01l-2.48-1.87L14.61 2Z"/>'
        },
        "floor-lamp-dual-outline": {
            body: '<path fill="currentColor" d="m11.73 10.06l-1.56 1.18l.83.96V20H8v2h8v-2h-3v-7.7l.85-1.04l-1.58-1.19l-.54-.01M8.32 5.31l.91 2.88l-.23.18L6.47 6.7l1.85-1.39M9.39 2L3 6.81l6.08 4.01l2.47-1.89L9.39 2m6.28 3.3l1.86 1.4L15 8.37l-.23-.17l.9-2.9M14.61 2l-2.17 6.95l2.48 1.87L21 6.81L14.61 2Z"/>'
        },
        "floor-lamp-outline": {
            body: '<path fill="currentColor" d="m15 2l2 7H7l2-7m4.6 2h-3.2l-.85 3h4.9M11 10h2v10h3v2H8v-2h3Z"/>'
        },
        "floor-lamp-torchiere": {
            body: '<path fill="currentColor" d="m7 2l3 7h4l3-7H7m6 18h3v2H8v-2h3V10h2v10Z"/>'
        },
        "floor-lamp-torchiere-outline": {
            body: '<path fill="currentColor" d="m14 4l-1.3 3h-1.4L10 4h4m3-2H7l3 7h4l3-7m-4 18h3v2H8v-2h3V10h2v10Z"/>'
        },
        "floor-lamp-torchiere-variant": {
            body: '<path fill="currentColor" d="m7 2l3 7h4l3-7H7m8.92 20L13 15v7h-2v-7l-2.92 7H5.92l5-12h2.16l5 12h-2.16Z"/>'
        },
        "floor-lamp-torchiere-variant-outline": {
            body: '<path fill="currentColor" d="m13.97 4l-1.29 3h-1.36l-1.29-3h3.94M17 2H7l3 7h4l3-7m-1.08 20L13 15v7h-2v-7l-2.92 7H5.92l5-12h2.16l5 12h-2.16Z"/>'
        },
        "floor-plan": {
            body: '<path fill="currentColor" d="M10 5v5H9V5H5v8h4v-1h1v5H9v-3H5v5h7v-2h1v2h6v-2h2v4H3V3h18v12h-2v-5h-6v5h-1V9h7V5h-9Z"/>'
        },
        floppy: {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5.5L18.5 3H17v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V3H5m7 1v5h3V4h-3m-5 8h10a1 1 0 0 1 1 1v6H6v-6a1 1 0 0 1 1-1Z"/>'
        },
        "floppy-variant": {
            body: '<path fill="currentColor" d="M3 3v18h18V3H3m9 7a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0 5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1Z"/>'
        },
        flower: {
            body: '<path fill="currentColor" d="M3 13a9 9 0 0 0 9 9c0-5-4.03-9-9-9m9-7.5A2.5 2.5 0 0 1 14.5 8a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 8A2.5 2.5 0 0 1 12 5.5m-6.4 4.75a2.5 2.5 0 0 0 2.5 2.5c.53 0 1.02-.17 1.4-.44v.19A2.5 2.5 0 0 0 12 15a2.5 2.5 0 0 0 2.5-2.5v-.19c.38.27.87.44 1.4.44a2.5 2.5 0 0 0 2.5-2.5c0-1-.59-1.85-1.43-2.25c.84-.4 1.43-1.26 1.43-2.25a2.5 2.5 0 0 0-2.5-2.5c-.53 0-1.02.16-1.4.44V3.5A2.5 2.5 0 0 0 12 1a2.5 2.5 0 0 0-2.5 2.5v.19c-.38-.28-.87-.44-1.4-.44a2.5 2.5 0 0 0-2.5 2.5c0 .99.59 1.85 1.43 2.25c-.84.4-1.43 1.25-1.43 2.25M12 22a9 9 0 0 0 9-9c-5 0-9 4-9 9Z"/>'
        },
        "flower-outline": {
            body: '<path fill="currentColor" d="M8.66 13.07c-1.74 0-3.16-1.41-3.16-3.14c0-.71.26-1.39.69-1.93c-.42-.54-.69-1.22-.69-1.93c0-1.73 1.43-3.14 3.16-3.14l.43.03A3.15 3.15 0 0 1 12 1c1.31 0 2.44.81 2.91 1.96l.43-.03c1.73 0 3.16 1.41 3.16 3.14c0 .71-.26 1.39-.69 1.93c.42.54.69 1.22.69 1.93c0 1.73-1.43 3.14-3.16 3.14l-.43-.03A3.15 3.15 0 0 1 12 15a3.15 3.15 0 0 1-2.91-1.96l-.43.03M12 13c.62 0 1.12-.5 1.14-1.1l-.11-1.09c-.32.12-.67.19-1.03.19s-.7-.07-1-.19l-.14 1.09c.02.6.52 1.1 1.14 1.1m3.34-1.93c.63 0 1.16-.51 1.16-1.15c0-.42-.27-.84-.67-1.03l-.88-.42c-.12.74-.51 1.38-1.06 1.83l.81.57c.18.13.4.2.64.2m-.65-5.94l-.82.56c.56.45.95 1.09 1.07 1.81l.88-.4c.41-.2.68-.6.68-1.03c0-.63-.53-1.14-1.16-1.14c-.23 0-.45.07-.65.2M12 3c-.62 0-1.12.5-1.14 1.1L11 5.19c.3-.12.64-.19 1-.19s.71.07 1.03.19l.11-1.09C13.12 3.5 12.62 3 12 3M8.66 4.93c-.63 0-1.16.51-1.16 1.14c0 .43.27.83.67 1.03l.88.4c.12-.72.51-1.36 1.06-1.81l-.81-.56c-.18-.13-.4-.2-.64-.2M8.17 8.9c-.4.2-.67.6-.67 1.02c0 .63.53 1.14 1.16 1.14c.23 0 .45-.06.65-.2l.81-.55c-.56-.45-.95-1.09-1.07-1.81l-.88.4M12 22a9 9 0 0 1-9-9a9 9 0 0 1 9 9a9 9 0 0 1 9-9a9 9 0 0 1-9 9m2.44-2.44a7.04 7.04 0 0 0 4.12-4.12c-1.9.7-3.41 2.22-4.12 4.12m-9-4.12a7.04 7.04 0 0 0 4.12 4.12c-.7-1.9-2.22-3.41-4.12-4.12Z"/>'
        },
        "flower-pollen": {
            body: '<path fill="currentColor" d="M18.4 12.75a2.5 2.5 0 0 0-2.5-2.5c-.53 0-1.02.16-1.4.44v-.19a2.5 2.5 0 0 0-5 0v.19c-.38-.28-.87-.44-1.4-.44a2.5 2.5 0 0 0-2.5 2.5c0 .99.59 1.85 1.43 2.25c-.84.4-1.43 1.25-1.43 2.25a2.5 2.5 0 0 0 2.5 2.5c.53 0 1.02-.17 1.4-.44v.19a2.5 2.5 0 0 0 5 0v-.19c.38.27.87.44 1.4.44a2.5 2.5 0 0 0 2.5-2.5c0-1-.59-1.85-1.43-2.25c.84-.4 1.43-1.26 1.43-2.25M12 17.5a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M11 6c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1M7 8c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1M5 6c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3-3c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m6 0c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m6 2c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1m-4 2c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "flower-pollen-outline": {
            body: '<path fill="currentColor" d="M11 6c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1M8 9c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1M6 5c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1m3-1c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m6 0c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m4 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-4 4c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m3.5 5.07c0 .71-.26 1.39-.69 1.93c.42.54.69 1.22.69 1.93c0 1.73-1.43 3.14-3.16 3.14l-.43-.03C14.44 21.19 13.31 22 12 22s-2.44-.81-2.91-1.96l-.43.03c-1.74 0-3.16-1.41-3.16-3.14c0-.71.26-1.39.69-1.93c-.42-.54-.69-1.22-.69-1.93c0-1.73 1.43-3.14 3.16-3.14l.43.03C9.56 8.81 10.69 8 12 8s2.44.81 2.91 1.96l.43-.03c1.73 0 3.16 1.41 3.16 3.14m-11 0c0 .43.27.83.67 1.03l.88.4c.12-.72.51-1.36 1.06-1.81l-.81-.56c-.18-.13-.4-.2-.64-.2c-.63 0-1.16.51-1.16 1.14m2.62 4.24c-.56-.45-.95-1.09-1.07-1.81l-.88.4c-.4.2-.67.6-.67 1.02c0 .63.53 1.14 1.16 1.14c.23 0 .45-.06.65-.2l.81-.55m3.02 1.59l-.11-1.09c-.32.12-.67.19-1.03.19s-.7-.07-1-.19l-.14 1.09c.02.6.52 1.1 1.14 1.1s1.12-.5 1.14-1.1m0-7.8c-.02-.6-.52-1.1-1.14-1.1s-1.12.5-1.14 1.1l.14 1.09c.3-.12.64-.19 1-.19s.71.07 1.03.19l.11-1.09m3.36 5.82c0-.42-.27-.84-.67-1.03l-.88-.42c-.12.74-.51 1.38-1.06 1.83l.81.57c.18.13.4.2.64.2c.63 0 1.16-.51 1.16-1.15m0-3.85c0-.63-.53-1.14-1.16-1.14c-.23 0-.45.07-.65.2l-.82.56c.56.45.95 1.09 1.07 1.81l.88-.4c.41-.2.68-.6.68-1.03Z"/>'
        },
        "flower-poppy": {
            body: '<path fill="currentColor" d="M18.5 12A3.5 3.5 0 0 0 22 8.5A6.5 6.5 0 0 0 15.5 2A3.5 3.5 0 0 0 12 5.5A3.5 3.5 0 0 0 8.5 2A6.5 6.5 0 0 0 2 8.5A3.5 3.5 0 0 0 5.5 12A3.5 3.5 0 0 0 2 15.5A6.5 6.5 0 0 0 8.5 22a3.5 3.5 0 0 0 3.5-3.5a3.5 3.5 0 0 0 3.5 3.5a6.5 6.5 0 0 0 6.5-6.5a3.5 3.5 0 0 0-3.5-3.5M12 16a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m2.5-4a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 12A2.5 2.5 0 0 1 12 9.5a2.5 2.5 0 0 1 2.5 2.5Z"/>'
        },
        "flower-tulip": {
            body: '<path fill="currentColor" d="M3 13a9 9 0 0 0 9 9a9 9 0 0 0-9-9m9 9a9 9 0 0 0 9-9a9 9 0 0 0-9 9m6-19v5a6 6 0 0 1-6 6a6 6 0 0 1-6-6V3c.74 0 1.47.12 2.16.39c.55.23 1.04.57 1.45 1L12 2l2.39 2.39c.41-.43.9-.77 1.45-1A5.9 5.9 0 0 1 18 3Z"/>'
        },
        "flower-tulip-outline": {
            body: '<path fill="currentColor" d="M3 13a9 9 0 0 0 9 9a9 9 0 0 0-9-9m2.44 2.44c1.91.71 3.41 2.21 4.12 4.12a6.986 6.986 0 0 1-4.12-4.12M12 22a9 9 0 0 0 9-9a9 9 0 0 0-9 9m2.42-2.43a6.876 6.876 0 0 1 4.15-4.15a7.03 7.03 0 0 1-4.15 4.15M12 14a6 6 0 0 0 6-6V3a5.9 5.9 0 0 0-2.16.39c-.55.23-1.04.57-1.45 1L12 2L9.61 4.39c-.41-.43-.9-.77-1.45-1A5.9 5.9 0 0 0 6 3v5a6 6 0 0 0 6 6M8 5.61l1.57 1.65L12 4.83l2.43 2.43L16 5.61V8a4 4 0 0 1-4 4a4 4 0 0 1-4-4V5.61Z"/>'
        },
        "focus-auto": {
            body: '<path fill="currentColor" d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2m0-12h-4v2h4v4h2V5c0-1.1-.9-2-2-2M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m0 6H3v4c0 1.1.9 2 2 2h4v-2H5v-4m3-8c-1.1 0-2 .9-2 2v8h2v-4h2v4h2V9c0-1.1-.9-2-2-2H8m0 2h2v2H8V9m5-2v10h2v-4h2v-2h-2V9h3V7h-5Z"/>'
        },
        "focus-field": {
            body: '<path fill="currentColor" d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2m0-12h-4v2h4v4h2V5c0-1.1-.9-2-2-2M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m0 6H3v4c0 1.1.9 2 2 2h4v-2H5v-4m2-4h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2M7 7h2v2H7V7m4 0h2v2h-2V7m4 0h2v2h-2V7m-8 8h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "focus-field-horizontal": {
            body: '<path fill="currentColor" d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2m0-12h-4v2h4v4h2V5c0-1.1-.9-2-2-2M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m0 6H3v4c0 1.1.9 2 2 2h4v-2H5v-4m2-4h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "focus-field-vertical": {
            body: '<path fill="currentColor" d="M19 19h-4v2h4c1.1 0 2-.9 2-2v-4h-2m0-12h-4v2h4v4h2V5c0-1.1-.9-2-2-2M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m0 6H3v4c0 1.1.9 2 2 2h4v-2H5v-4m6-4h2v2h-2v-2m0-4h2v2h-2V7m0 8h2v2h-2v-2Z"/>'
        },
        folder: {
            body: '<path fill="currentColor" d="M10 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2Z"/>'
        },
        "folder-account": {
            body: '<path fill="currentColor" d="M19 17h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2m-4-7a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m5-3h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "folder-account-outline": {
            body: '<path fill="currentColor" d="M15 14c1.33 0 4 .67 4 2v1h-8v-1c0-1.33 2.67-2 4-2m0-1c1.11 0 2-.89 2-2s-.89-2-2-2a2 2 0 1 0 0 4m7-5v10c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 0H4v10h16V8Z"/>'
        },
        "folder-alert": {
            body: '<path fill="currentColor" d="M15 12h2v5h-2v-5m0 6h2v2h-2v-2m8-2a7 7 0 0 1-7 7c-2.38 0-4.5-1.19-5.75-3H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.1c1.24 1.26 2 2.99 2 4.9m-7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "folder-alert-outline": {
            body: '<path fill="currentColor" d="M15 12h2v5h-2v-5m0 6h2v2h-2v-2m1-9c1.07 0 2.09.24 3 .67V8H3v10h6.29A7.01 7.01 0 0 1 9 16a7 7 0 0 1 7-7m7 7a7 7 0 0 1-7 7c-2.38 0-4.5-1.19-5.75-3H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.1c1.24 1.26 2 2.99 2 4.9m-7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "folder-arrow-down": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 8h-2v4h-2l3 3l3-3h-2v-4Z"/>'
        },
        "folder-arrow-down-outline": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 8h-2v4h-2l3 3l3-3h-2v-4Z"/>'
        },
        "folder-arrow-left": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-4 8l-3 3l3 3v-2h4v-2h-4v-2Z"/>'
        },
        "folder-arrow-left-outline": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-4 8l-3 3l3 3v-2h4v-2h-4v-2Z"/>'
        },
        "folder-arrow-left-right": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m10-2l-3-2.5V16h-4v2h4v1.5l3-2.5m-5 1.5L15 21l3 2.5V22h4v-2h-4v-1.5Z"/>'
        },
        "folder-arrow-left-right-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m10-2l-3-2.5V16h-4v2h4v1.5l3-2.5m-5 1.5L15 21l3 2.5V22h4v-2h-4v-1.5Z"/>'
        },
        "folder-arrow-right": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m10 0l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "folder-arrow-right-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m10 0l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "folder-arrow-up": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-6 10h2v4h2v-4h2l-3-3l-3 3Z"/>'
        },
        "folder-arrow-up-down": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m4-4l-2.5 3H16v4h2v-4h1.5L17 15m5 5v-4h-2v4h-1.5l2.5 3l2.5-3H22Z"/>'
        },
        "folder-arrow-up-down-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m9 1v-4h-2v4h-1.5l2.5 3l2.5-3H22m-5-5l-2.5 3H16v4h2v-4h1.5L17 15Z"/>'
        },
        "folder-arrow-up-outline": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-6 10h2v4h2v-4h2l-3-3l-3 3Z"/>'
        },
        "folder-cancel": {
            body: '<path fill="currentColor" d="M12 18.5c0 .5.07 1 .18 1.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.04c-1-.65-2.21-1.04-3.5-1.04a6.5 6.5 0 0 0-6.5 6.5m11 0c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "folder-cancel-outline": {
            body: '<path fill="currentColor" d="M12 18.5c0 .5.07 1 .18 1.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.04c-.61-.39-1.28-.68-2-.86V8H4v10h8.03c-.03.17-.03.33-.03.5m11 0c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "folder-check": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m8.34-3.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "folder-check-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m8.34-3.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "folder-clock": {
            body: '<path fill="currentColor" d="M3 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7.26c1.31 1.88 3.45 3 5.74 3a7 7 0 0 0 7-7c0-1.83-.72-3.58-2-4.89V8a2 2 0 0 0-2-2h-8L9 4H3m13 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m-1 1v5l3.61 2.16l.75-1.22l-2.86-1.69V12H15Z"/>'
        },
        "folder-clock-outline": {
            body: '<path fill="currentColor" d="M15 12h1.5v4.25l2.86 1.69l-.75 1.22L15 17v-5m4-4H3v10h6.29C9.1 17.37 9 16.7 9 16a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67V8M3 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2h8a2 2 0 0 1 2 2v3.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-2.38 0-4.5-1.19-5.75-3H3m13-9a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "folder-cog": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h8.08a7 7 0 0 1-.08-1a7 7 0 0 1 7-7a7 7 0 0 1 3 .69V8a2 2 0 0 0-2-2h-8l-2-2H4m14 10a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 20 14h-2m1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "folder-cog-outline": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h8v-2H4V8h16v4h2V8a2 2 0 0 0-2-2h-8l-2-2m8 10a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5c0-.17-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 20 14m-1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "folder-download": {
            body: '<path fill="currentColor" d="M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8m-.75 7H16V9h-2v4h-3.25L15 17.25"/>'
        },
        "folder-download-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-6 3h2v4h3l-4 4l-4-4h3Z"/>'
        },
        "folder-edit": {
            body: '<path fill="currentColor" d="M19.39 10.74L11 19.13V20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.15c-.26-.09-.54-.15-.83-.15c-.67 0-1.3.26-1.78.74M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "folder-edit-outline": {
            body: '<path fill="currentColor" d="M4 18h8.13L11 19.13V20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.15c-.26-.09-.54-.15-.83-.15c-.42 0-.81.11-1.17.3V8H4v10m18.85-4.53l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96Z"/>'
        },
        "folder-eye": {
            body: '<path fill="currentColor" d="M9.3 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6l2 2h8c1.1 0 2 .9 2 2v6.6c-1.4-1-3.1-1.6-5-1.6c-3.5 0-6.6 2.1-7.9 5.3l-.3.7l.3.7c.1.1.1.2.2.3M23 19c-.9 2.3-3.3 4-6 4s-5.1-1.7-6-4c.9-2.3 3.3-4 6-4s5.1 1.7 6 4m-3.5 0c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5M17 18c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1"/>'
        },
        "folder-eye-outline": {
            body: '<path fill="currentColor" d="M9.3 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6l2 2h8c1.1 0 2 .9 2 2v6.6c-.6-.4-1.3-.8-2-1.1V8H4v10h5.3c0 .1-.1.2-.1.3l-.4.7l.3.7c.1.1.1.2.2.3M23 19c-.9 2.3-3.3 4-6 4s-5.1-1.7-6-4c.9-2.3 3.3-4 6-4s5.1 1.7 6 4m-3.5 0c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5M17 18c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1"/>'
        },
        "folder-file": {
            body: '<path fill="currentColor" d="M15 8c-2.21 0-4 1.79-4 4v8H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.17l-1.59-1.58l-.58-.59H15m8 6v7c0 1.11-.89 2-2 2h-6a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h4l4 4m-2 .83L18.17 12H18v3h3v-.17Z"/>'
        },
        "folder-file-outline": {
            body: '<path fill="currentColor" d="M4 18h7v2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.17l-1.59-1.58l-.41-.42V8H4v10m19-4v7c0 1.11-.89 2-2 2h-6a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h4l4 4m-2 1h-3v-3h-3v9h6v-6Z"/>'
        },
        "folder-google-drive": {
            body: '<path fill="currentColor" d="M13.75 9h2.39L19 14h-2.95L13.5 9.46M18.3 17h-5.55l1.4-2.5h5.12l.26.46M11.5 17l-1.1-2.14l2.84-4.96l1.5 2.66L12.25 17M20 6h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "folder-heart": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-1.58 7.5L15 17l-3.41-3.5c-.37-.38-.59-.88-.59-1.45c0-1.13.9-2.05 2-2.05c.54 0 1.05.23 1.42.61l.58.59l.59-.6c.36-.37.87-.6 1.41-.6c1.1 0 2 .92 2 2.05c0 .56-.22 1.08-.58 1.45Z"/>'
        },
        "folder-heart-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8a2 2 0 0 0-2-2m-7 4c-1.1 0-2 .92-2 2.05c0 .57.22 1.07.59 1.45L15 17l3.42-3.5c.36-.37.58-.89.58-1.45c0-1.13-.9-2.05-2-2.05c-.54 0-1.05.23-1.41.6l-.59.6l-.58-.59A1.99 1.99 0 0 0 13 10Z"/>'
        },
        "folder-hidden": {
            body: '<path fill="currentColor" d="M9 4v4H6V4h3M4 16v-3H2v3h2m-2-4h2V9H2v3m16-4h4a2 2 0 0 0-2-2h-2v2m4 5h-2v3h2v-3m-2-4v3h2V9h-2M9 20v-2H6v2h3m-4-2H4v-1H2v1a2 2 0 0 0 2 2h1v-2m15-1v1h-2v2h2c1.11 0 2-.89 2-2v-1h-2M4 8h1V4H4c-1.11 0-2 .89-2 2v2h2m13 10h-3v2h3v-2m-4 0h-3v2h3v-2m4-12h-3v2h3V6m-7 2h3V6h-1l-2-2v4Z"/>'
        },
        "folder-home": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-3 7v4h-2v-3h-2v3h-2v-4H9l5-4l5 4Z"/>'
        },
        "folder-home-outline": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 12H4V8h16m-7 9v-3h2v3h2v-4h2l-5-4l-5 4h2v4Z"/>'
        },
        "folder-image": {
            body: '<path fill="currentColor" d="m5 17l4.5-6l3.5 4.5l2.5-3L19 17m1-11h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "folder-information": {
            body: '<path fill="currentColor" d="M21 11.1V8c0-1.1-.9-2-2-2h-8L9 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7.3c1.3 1.9 3.5 3 5.7 3c3.9 0 7-3.1 7-7c0-1.8-.7-3.6-2-4.9M16 21c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m1-1h-2v-5h2v5m0-6h-2v-2h2v2Z"/>'
        },
        "folder-information-outline": {
            body: '<path fill="currentColor" d="M21 11.1V8c0-1.1-.9-2-2-2h-8L9 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7.2c1.2 1.8 3.4 3 5.8 3c3.9 0 7-3.1 7-7c0-1.9-.8-3.6-2-4.9M9.3 18H3V8h16v1.7c-.9-.5-1.9-.7-3-.7c-3.9 0-7 3.1-7 7c0 .7.1 1.4.3 2m6.7 3c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m1-7h-2v-2h2v2m0 6h-2v-5h2v5Z"/>'
        },
        "folder-key": {
            body: '<path fill="currentColor" d="M4 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2m1 6c1.3 0 2.4.8 2.8 2H20v2h-2v2h-2v-2h-2.2c-.4 1.2-1.5 2-2.8 2c-1.7 0-3-1.3-3-3s1.3-3 3-3m0 2c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1Z"/>'
        },
        "folder-key-network": {
            body: '<path fill="currentColor" d="M6 5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h5v2h-1c-.6 0-1 .4-1 1H2v2h7c0 .6.4 1 1 1h4c.6 0 1-.4 1-1h7v-2h-7c0-.6-.4-1-1-1h-1v-2h5c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-6l-2-2H6m3 4c1.3 0 2.4.8 2.8 2H18v2h-2v2h-2v-2h-2.2c-.4 1.2-1.5 2-2.8 2c-1.7 0-3-1.3-3-3s1.3-3 3-3m0 2c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1Z"/>'
        },
        "folder-key-network-outline": {
            body: '<path fill="currentColor" d="M9 8c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H14v2h2v-2h2v-2h-6.2c-.4-1.2-1.5-2-2.8-2m0 4c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m6 8c0-.5-.4-1-1-1h-1v-2h6c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-6l-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6v2h-1c-.6 0-1 .5-1 1H2v2h7c0 .5.4 1 1 1h4c.6 0 1-.5 1-1h7v-2h-7M5 15V7h14v8H5Z"/>'
        },
        "folder-key-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-7.2 6c-.4-1.2-1.5-2-2.8-2c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H15v2h2v-2h2v-2h-6.2M10 14c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1Z"/>'
        },
        "folder-lock": {
            body: '<path fill="currentColor" d="M13 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.04A4.911 4.911 0 0 0 19 10c-2.6 0-4.8 2.06-4.8 4.5v.24c-.7.6-1.2 1.5-1.2 2.46V20m10-2.7v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "folder-lock-open": {
            body: '<path fill="currentColor" d="M14.2 13.5v1.24c-.7.6-1.2 1.5-1.2 2.46V20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.04A4.911 4.911 0 0 0 19 9c-2.6 0-4.8 2.06-4.8 4.5m7.6 2.5h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "folder-lock-open-outline": {
            body: '<path fill="currentColor" d="M4 18h9v2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v2.04c-.58-.44-1.25-.78-2-.93V8H4v10m17.8-2h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "folder-lock-outline": {
            body: '<path fill="currentColor" d="M13 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.04c-.58-.44-1.25-.78-2-.93V8H4v10h9v2m10-2.7v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "folder-marker": {
            body: '<path fill="currentColor" d="m10 4l2 2h8a2 2 0 0 1 2 2v3.34c-.96-.84-2.18-1.34-3.5-1.34c-3 0-5.5 2.65-5.5 5.5c0 1.47.65 3.05 1.5 4.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6m8.5 8c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2Z"/>'
        },
        "folder-marker-outline": {
            body: '<path fill="currentColor" d="M18.5 12c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2M20 8H4v10h9.5c.29.68.63 1.35 1 2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.34c-.58-.5-1.26-.89-2-1.11V8Z"/>'
        },
        "folder-minus": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m2-1v2h8v-2h-8Z"/>'
        },
        "folder-minus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m2-1v2h8v-2h-8Z"/>'
        },
        "folder-move": {
            body: '<path fill="currentColor" d="M14 18v-3h-4v-4h4V8l5 5m1-7h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "folder-move-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16v10M12 6l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V8a2 2 0 0 0-2-2h-8m-1 8v-2h4V9l4 4l-4 4v-3h-4Z"/>'
        },
        "folder-multiple": {
            body: '<path fill="currentColor" d="M22 4h-8l-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M2 6H0v14a2 2 0 0 0 2 2h18v-2H2V6Z"/>'
        },
        "folder-multiple-image": {
            body: '<path fill="currentColor" d="m7 15l4.5-6l3.5 4.5l2.5-3L21 15m1-11h-8l-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M2 6H0v14a2 2 0 0 0 2 2h18v-2H2V6Z"/>'
        },
        "folder-multiple-outline": {
            body: '<path fill="currentColor" d="M22 4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6l2 2h8M2 6v14h18v2H2a2 2 0 0 1-2-2V6h2m4 0v10h16V6H6Z"/>'
        },
        "folder-multiple-plus": {
            body: '<path fill="currentColor" d="M2 20V6H0v14c0 1.1.9 2 2 2h18v-2H2M22 4h-8l-2-2H6c-.4 0-.8.1-1.1.3l-.6.6c-.2.3-.3.7-.3 1.1v12c0 .4.1.8.3 1.1c.1.1.2.2.2.3c.5.4 1 .6 1.5.6h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 8h-3v3h-2v-3h-3v-2h3V7h2v3h3v2Z"/>'
        },
        "folder-multiple-plus-outline": {
            body: '<path fill="currentColor" d="M22 4c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h6l2 2h8M2 6v14h18v2H2c-1.1 0-2-.9-2-2V6h2m4 0v10h16V6H6m8 4h2V8h2v2h2v2h-2v2h-2v-2h-2v-2Z"/>'
        },
        "folder-music": {
            body: '<path fill="currentColor" d="M22 8v3h-5.5v5.11c-1.84.42-3.24 1.98-3.46 3.89H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-3.5 5v5.21a2.5 2.5 0 1 0-1 4.79a2.5 2.5 0 0 0 2.5-2.5V15h2v-2h-3.5Z"/>'
        },
        "folder-music-outline": {
            body: '<path fill="currentColor" d="M22 8v3h-2V8H4v10h9.78c-.4.59-.65 1.26-.74 2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-3.5 5v5.21a2.5 2.5 0 1 0-1 4.79a2.5 2.5 0 0 0 2.5-2.5V15h2v-2h-3.5Z"/>'
        },
        "folder-network": {
            body: '<path fill="currentColor" d="M3 15V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-6v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H5a2 2 0 0 1-2-2Z"/>'
        },
        "folder-network-outline": {
            body: '<path fill="currentColor" d="M15 20c0-.55-.45-1-1-1h-1v-2h6c1.11 0 2-.89 2-2V7a2 2 0 0 0-2-2h-6l-2-2H5c-1.1 0-2 .9-2 2v10a2 2 0 0 0 2 2h6v2h-1c-.55 0-1 .45-1 1H2v2h7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1h7v-2h-7M5 15V7h14v8H5Z"/>'
        },
        "folder-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L18.11 20H4a2 2 0 0 1-2-2V6c0-.58.25-1.1.64-1.47L1.11 3l1.28-1.27l19.72 19.73M22 18V8a2 2 0 0 0-2-2h-8l-2-2H7.2l14.68 14.68c.08-.21.12-.44.12-.68Z"/>'
        },
        "folder-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l1.53 1.53C2.25 4.9 2 5.42 2 6v12a2 2 0 0 0 2 2h14.11l2.73 2.73l1.27-1.27L2.39 1.73M4 18V8h2.11l10 10H4m7.2-10l-4-4H10l2 2h8a2 2 0 0 1 2 2v10c0 .24-.04.47-.12.68L20 16.8V8h-8.8Z"/>'
        },
        "folder-open": {
            body: '<path fill="currentColor" d="M19 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h7a2 2 0 0 1 2 2H4v10l2.14-8h17.07l-2.28 8.5c-.23.87-1.01 1.5-1.93 1.5Z"/>'
        },
        "folder-open-outline": {
            body: '<path fill="currentColor" d="M6.1 10L4 18V8h17a2 2 0 0 0-2-2h-7l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h15c.9 0 1.7-.6 1.9-1.5l2.3-8.5H6.1M19 18H6l1.6-6h13L19 18Z"/>'
        },
        "folder-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "folder-outline-lock": {
            body: '<path d="M20 17.998v-10H4v10h16zm0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2l.01-12c0-1.104.884-2 1.99-2h6l2 2h8zM9 16v-3h1v-1a2 2 0 1 1 4 0v1h1v3H9zm4-3v-1a1 1 0 1 0-2 0v1h2z" fill="currentColor"/>',
            hidden: true
        },
        "folder-play": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-5 14l5-3l-5-3v6Z"/>'
        },
        "folder-play-outline": {
            body: '<path fill="currentColor" d="M22 8v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-5 14l5-3l-5-3v6Z"/>'
        },
        "folder-plus": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "folder-plus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "folder-pound": {
            body: '<path fill="currentColor" d="M15.25 13h2l-.5 2h-2l.5-2M22 8v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 4h-1.5l.5-2h-1l-.5 2h-2l.5-2h-1l-.5 2H13v1h1.25l-.5 2H12v1h1.5l-.5 2h1l.5-2h2l-.5 2h1l.5-2H19v-1h-1.25l.5-2H20v-1Z"/>'
        },
        "folder-pound-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-1 6v-1h-1.5l.5-2h-1l-.5 2h-2l.5-2h-1l-.5 2H12v1h1.25l-.5 2H11v1h1.5l-.5 2h1l.5-2h2l-.5 2h1l.5-2H18v-1h-1.25l.5-2H19m-3.25 2h-2l.5-2h2l-.5 2Z"/>'
        },
        "folder-question": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-3.2 12h-1.5v-1.5h1.5V18m0-2.2h-1.5c0-2.4 2.2-2.3 2.2-3.8c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5H13c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.9-2.2 2.1-2.2 3.8Z"/>'
        },
        "folder-question-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-1 5.7c0 1.7-2 1.8-2 3.3h-1.3c0-2.2 2-2 2-3.3c0-.7-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3h-1.3c0-1.5 1.2-2.7 2.7-2.7s2.5 1.2 2.5 2.7m-2 4V17h-1.3v-1.3H17Z"/>'
        },
        "folder-refresh": {
            body: '<path fill="currentColor" d="M18 14.5c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4M10 4l2 2h8a2 2 0 0 1 2 2v5c-1-.62-2.21-1-3.5-1a6.5 6.5 0 0 0-6.5 6.5c0 .5.06 1 .17 1.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6Z"/>'
        },
        "folder-refresh-outline": {
            body: '<path fill="currentColor" d="M18 14.5c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4M20 8H4v10h8v.5c0 .5.06 1 .17 1.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5a6.93 6.93 0 0 0-2-.83V8Z"/>'
        },
        "folder-remove": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m9.54-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "folder-remove-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v5.81c-.61-.35-1.28-.59-2-.72V8H4v10h9.09c-.05.33-.09.66-.09 1m9.54-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "folder-search": {
            body: '<path fill="currentColor" d="M16.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M9 4l2 2h8a2 2 0 0 1 2 2v3.81A6.48 6.48 0 0 0 16.5 10a6.5 6.5 0 0 0-6.5 6.5c0 1.29.37 2.5 1 3.5H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6Z"/>'
        },
        "folder-search-outline": {
            body: '<path fill="currentColor" d="M16.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L22 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M19 8H3v10h7.17c.17.72.46 1.39.83 2H3a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v3.81c-.58-.55-1.25-1-2-1.31V8Z"/>'
        },
        "folder-settings": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2H4m3 18v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2Z"/>'
        },
        "folder-settings-outline": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2H4m0 4h16v10H4V8m3 14v2h2v-2H7m4 0v2h2v-2h-2m4 0v2h2v-2h-2"/>'
        },
        "folder-star": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-2.06 11L15 15.28L12.06 17l.78-3.33l-2.59-2.24l3.41-.29L15 8l1.34 3.14l3.41.29l-2.59 2.24l.78 3.33Z"/>'
        },
        "folder-star-multiple": {
            body: '<path fill="currentColor" d="M2 6H0v14c0 1.11.895 2 2 2h18v-2H2V6m20-2h-8l-2-2H6c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-1.11-.89-2-2-2m-2.06 11L17 13.27L14.06 15l.78-3.34l-2.59-2.24l3.41-.29L17 6l1.34 3.13l3.41.29l-2.59 2.24l.78 3.34Z"/>'
        },
        "folder-star-multiple-outline": {
            body: '<path fill="currentColor" d="M2 6v14h18v2H2c-1.105 0-2-.89-2-2V6h2m10.78 4.05l3.03-.26L17 7l1.19 2.79l3.03.26l-2.3 1.99l.69 2.96L17 13.47L14.39 15l.69-2.96l-2.3-1.99M24 6v10c0 1.11-.89 2-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 0H6v10h16V6Z"/>'
        },
        "folder-star-outline": {
            body: '<path fill="currentColor" d="m10.78 12.05l3.03-.26L15 9l1.19 2.79l3.03.26l-2.3 1.99l.69 2.96L15 15.47L12.39 17l.69-2.96l-2.3-1.99M22 8v10c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2h8a2 2 0 0 1 2 2m-2 0H4v10h16V8Z"/>'
        },
        "folder-swap": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-5 10v-2H9v2l-3-3l3-3v2h6v-2l3 3Z"/>'
        },
        "folder-swap-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-2 7l-3-3v2H9v-2l-3 3l3 3v-2h6v2Z"/>'
        },
        "folder-sync": {
            body: '<path fill="currentColor" d="m10 4l2 2h8a2 2 0 0 1 2 2v3.5c-.77-.32-1.61-.5-2.5-.5a6.5 6.5 0 0 0-6.5 6.5c0 .89.18 1.73.5 2.5H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6m9 8v1.5a4 4 0 0 1 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12m0 11v-1.5a4 4 0 0 1-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23Z"/>'
        },
        "folder-sync-outline": {
            body: '<path fill="currentColor" d="m10 4l2 2h8a2 2 0 0 1 2 2v3.5a6.99 6.99 0 0 0-2-.5V8H4v10h9c.07.7.24 1.38.5 2H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6m9 8v1.5a4 4 0 0 1 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25l-.03-.03c.06-.05.13-.09 2.28-2.22m0 11v-1.5a4 4 0 0 1-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25l.03.03c-.06.05-.13.09-2.28 2.22Z"/>'
        },
        "folder-table": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2H4m8 5h3v2h-3V9m4 0h3v2h-3V9m-4 3h3v2h-3v-2m4 0h3v2h-3v-2m-4 3h3v2h-3v-2m4 0h3v2h-3v-2Z"/>'
        },
        "folder-table-outline": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2H4m0 4h16v10H4V8m8 1v2h3V9h-3m4 0v2h3V9h-3m-4 3v2h3v-2h-3m4 0v2h3v-2h-3m-4 3v2h3v-2h-3m4 0v2h3v-2h-3Z"/>'
        },
        "folder-text": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-5 10H6v-2h9v2m3-4H6v-2h12v2Z"/>'
        },
        "folder-text-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-5 10H6v-2h9v2m3-4H6v-2h12v2Z"/>'
        },
        "folder-upload": {
            body: '<path fill="currentColor" d="M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2h8m-9.25 7H14v4h2v-4h3.25L15 8.75"/>'
        },
        "folder-upload-outline": {
            body: '<path fill="currentColor" d="M20 18H4V8h16m0-2h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-4 11h-2v-4h-3l4-4l4 4h-3Z"/>'
        },
        "folder-wrench": {
            body: '<path fill="currentColor" d="M13.03 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v9.5l-1.04-1.06c.01-.14.04-.29.04-.44c0-2.76-2.24-5-5-5s-5 2.24-5 5c0 1.64.8 3.09 2.03 4m9.84 1.19l-4.11-4.11c.41-1.04.18-2.26-.68-3.11c-.9-.91-2.25-1.09-3.34-.59l1.94 1.94l-1.35 1.36l-1.99-1.95c-.54 1.09-.29 2.44.59 3.35a2.91 2.91 0 0 0 3.12.68l4.11 4.1c.18.19.45.19.63 0l1.04-1.03c.22-.18.22-.5.04-.64Z"/>'
        },
        "folder-wrench-outline": {
            body: '<path fill="currentColor" d="M13.03 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h8a2 2 0 0 1 2 2v9.5l-1.04-1.06c.01-.14.04-.29.04-.44c0-1.12-.38-2.14-1-2.97V8H4v10h7.42c.35.8.91 1.5 1.61 2m9.84 1.19l-4.11-4.11c.41-1.04.18-2.26-.68-3.11c-.9-.91-2.25-1.09-3.34-.59l1.94 1.94l-1.35 1.36l-1.99-1.95c-.54 1.09-.29 2.44.59 3.35a2.91 2.91 0 0 0 3.12.68l4.11 4.1c.18.19.45.19.63 0l1.04-1.03c.22-.18.22-.5.04-.64Z"/>'
        },
        "folder-zip": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2Z"/>'
        },
        "folder-zip-outline": {
            body: '<path fill="currentColor" d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 12h-4v-2h-2v2H4V8h10v2h2V8h4v10m-4-6v-2h2v2h-2m-2 0h2v2h-2v-2m4 4h-2v-2h2v2Z"/>'
        },
        "font-awesome": {
            body: '<path fill="currentColor" d="M19.76 2H4.24C3 2 2 3 2 4.24v15.52C2 21 3 22 4.24 22h15.52C21 22 22 21 22 19.76V4.24C22 3 21 2 19.76 2m-2.03 12.69c0 .19-.16.27-.35.35c-.74.32-1.54.61-2.38.61c-1.22 0-1.78-.74-3.22-.74c-1.04 0-2.13.37-3.01.77c-.06.03-.11.03-.16.05v2.03c0 .08 0 .16-.03.21v.06c-.11.37-.45.64-.85.64c-.51 0-.91-.41-.91-.91V8a1.49 1.49 0 0 1 .91-2.67c.83 0 1.5.67 1.5 1.5c0 .48-.23.9-.59 1.17v.83c.08-.03.16-.06.24-.11c.83-.35 1.82-.64 2.75-.64c1.01 0 1.81.27 2.72.61c.19.08.37.11.58.11c1.02 0 2.14-.72 2.41-.72c.21 0 .4.16.4.35v6.26h-.01Z"/>'
        },
        food: {
            body: '<path fill="currentColor" d="M18.06 23h1.66c.84 0 1.53-.65 1.63-1.47L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26c1.44 1.42 2.43 2.89 2.43 5.29V23M1 22v-1h15.03v1c0 .54-.45 1-1.03 1H2c-.55 0-1-.46-1-1m15.03-7C16.03 7 1 7 1 15h15.03M1 17h15v2H1v-2Z"/>'
        },
        "food-apple": {
            body: '<path fill="currentColor" d="M20 10c2 3-3 12-5 12s-2-1-3-1s-1 1-3 1s-7-9-5-12s5-3 7-2V5C5.38 8.07 4.11 3.78 4.11 3.78S6.77.19 11 5V3h2v5c2-1 5-1 7 2Z"/>'
        },
        "food-apple-outline": {
            body: '<path fill="currentColor" d="M20 10a5.268 5.268 0 0 0-7-2V3h-2v5a5.268 5.268 0 0 0-7 2c-2 3 3 12 5 12s2-1 3-1s1 1 3 1s7-9 5-12m-1.75 3.38c-.62 2.47-1.84 4.74-3.55 6.62c-.2 0-.43-.1-.6-.25a3.34 3.34 0 0 0-4.2 0c-.17.15-.4.25-.6.25a15.267 15.267 0 0 1-3.55-6.61c-.25-.73-.3-1.52-.09-2.27A3.37 3.37 0 0 1 8.5 9.4c.56.01 1.11.14 1.61.39l.89.45h2l.89-.45c.5-.25 1.05-.38 1.61-.39c1.18.03 2.26.68 2.84 1.71c.21.75.16 1.54-.09 2.27M11 5C5.38 8.07 4.11 3.78 4.11 3.78S6.77.19 11 5Z"/>'
        },
        "food-croissant": {
            body: '<path fill="currentColor" d="m22 19l-3-2l3-2v4m-7-4l4-6l3 4l-4 3l-3-1M5 17l-3 2v-4l3 2m4-2l-3 1l-4-3l3-4l4 6m5-9l4 2l-5 7h-2L6 8l4-2h4Z"/>'
        },
        "food-drumstick": {
            body: '<path fill="currentColor" d="M20.16 12.73A6.27 6.27 0 0 0 19.09 3c-2.01-1.33-4.7-1.34-6.73-.03c-1.76 1.13-2.73 2.89-2.9 4.71c-.13 1.32-.63 2.55-1.55 3.47l-.03.03c-1.16 1.16-1.16 2.93-.07 4.01l.99.99a2.794 2.794 0 0 0 3.95 0c.97-.97 2.25-1.5 3.64-1.65c1.37-.15 2.71-.75 3.77-1.8m-13.9 7.13c.27.56.18 1.24-.29 1.7a1.49 1.49 0 0 1-2.55-.98a1.49 1.49 0 0 1-.98-2.55c.46-.46 1.15-.56 1.7-.29l2.48-2.43c.14.19.3.41.48.59l.99.99c.21.2.41.37.67.52l-2.5 2.45Z"/>'
        },
        "food-drumstick-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-7.2-7.2c-.3.2-.6.4-.9.7c-1.1 1.1-2.9 1.1-4 0l-1-1c-1.1-1.1-1.1-2.9.1-4c.2-.2.4-.5.6-.8L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M8.1 16.9l-1-1c-.2-.2-.3-.4-.5-.6l-2.5 2.4c-.6-.3-1.2-.2-1.7.3c-.6.6-.6 1.5 0 2.1c.3.3.6.4 1 .4c0 .4.2.7.4 1c.6.6 1.5.6 2.1 0c.5-.5.6-1.1.3-1.7l2.5-2.4c-.2-.1-.4-.3-.6-.5m12.1-4.2C23 9.9 22.6 5.2 19.1 3c-2-1.3-4.7-1.3-6.7 0c-1.4.9-2.3 2.1-2.7 3.5l7.8 7.8c1-.3 1.9-.8 2.7-1.6Z"/>'
        },
        "food-drumstick-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l7.4 7.4c-.2.3-.4.5-.6.8c-1.2 1.2-1.2 2.9-.1 4l1 1c.5.5 1.3.8 2 .8s1.4-.3 2-.8c.3-.3.6-.5.9-.7l7.2 7.2l1.2-1.2m-10.8-6.7c-.2.2-.4.2-.5.2s-.4 0-.6-.2l-1-1c-.2-.2-.2-.4-.2-.6c0-.2.1-.5.3-.7c.2-.2.4-.5.6-.7l2.2 2.2c-.2.3-.5.5-.8.8m.1-6.6L9.7 6.5c.4-1.4 1.3-2.6 2.7-3.5c1-.6 2.2-1 3.3-1c1.2 0 2.4.3 3.4 1c3.5 2.3 3.8 7 1.1 9.7c-.8.8-1.7 1.3-2.7 1.6l-1.7-1.7c.1 0 .2-.1.4-.1c1-.1 1.9-.5 2.6-1.2c.9-.9 1.4-2.2 1.2-3.5c-.1-1.3-.8-2.4-2-3.2c-.7-.4-1.5-.6-2.3-.6c-.8 0-1.6.2-2.3.7c-1.2.7-1.9 1.9-2 3.2v.3m-2.6 9.2l-2.5 2.4c.3.6.2 1.2-.3 1.7c-.6.6-1.5.6-2.1 0c-.3-.3-.4-.6-.4-1c-.4 0-.7-.2-1-.4c-.6-.6-.6-1.5 0-2.1c.5-.5 1.1-.6 1.7-.3l2.5-2.4c.1.2.3.4.5.6l1 1c.1.2.3.4.6.5"/>'
        },
        "food-drumstick-outline": {
            body: '<path fill="currentColor" d="M15.71 4c.83 0 1.62.22 2.29.66c1.14.74 1.84 1.87 2 3.18a4.37 4.37 0 0 1-1.25 3.47c-.7.69-1.59 1.13-2.57 1.23c-1.91.2-3.59.96-4.84 2.23a.809.809 0 0 1-1.13 0l-.99-.99a.743.743 0 0 1-.22-.53c0-.25.11-.47.32-.68c1.21-1.22 1.95-2.84 2.13-4.7c.13-1.33.84-2.47 2-3.22c.66-.43 1.44-.65 2.26-.65m0-2c-1.17 0-2.34.32-3.35.97c-1.76 1.13-2.73 2.89-2.9 4.71c-.13 1.32-.63 2.55-1.55 3.47l-.03.03c-1.16 1.16-1.16 2.93-.07 4.01l.99.99c.55.55 1.26.82 1.97.82s1.43-.27 1.98-.82c.97-.97 2.25-1.5 3.64-1.65c1.37-.15 2.71-.75 3.77-1.8A6.27 6.27 0 0 0 19.09 3c-1.01-.67-2.19-1-3.38-1M6.26 19.86c.27.56.18 1.24-.29 1.7a1.49 1.49 0 0 1-2.55-.98a1.49 1.49 0 0 1-.98-2.55c.46-.46 1.15-.56 1.7-.29l2.48-2.43c.14.19.3.41.48.59l.99.99c.21.2.41.37.67.52l-2.5 2.45Z"/>'
        },
        "food-fork-drink": {
            body: '<path fill="currentColor" d="M3 3a1 1 0 0 0-1 1v5.5c0 1.69 1.03 3.13 2.5 3.72v6.28A1.5 1.5 0 0 0 6 21a1.5 1.5 0 0 0 1.5-1.5v-6.28c1.47-.59 2.5-2.03 2.5-3.72V4a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4a.5.5 0 0 1-.5.5A.5.5 0 0 1 7 8V4a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4a.5.5 0 0 1-.5.5A.5.5 0 0 1 4 8V4a1 1 0 0 0-1-1m16.88 0c-.13 0-.26.09-.38.16L16 5.25V9h-4v2h1l1 10h6l1-10h1V9h-4V6.34l2.5-1.5c.5-.28.63-.84.34-1.34c-.21-.36-.58-.55-.96-.5Z"/>'
        },
        "food-halal": {
            body: '<path fill="currentColor" d="M7 5v10c0 1.11-.89 2-2 2H4c-.55 0-1-.45-1-1v-3H1v3c0 1.66 1.34 3 3 3h1c2.21 0 4-1.79 4-4V5m14 8.38l-1.23-1.23A3.905 3.905 0 0 0 19 11h-2v2h2c.5 0 1 .2 1.35.56l.35.35l-1.2.69c-.46.26-.97.4-1.5.4h-1c-.56 0-1-.44-1-1V6h-2v3.81l-.62-.69C12.7 8.37 11.6 8 10.59 8H10v2h.59c.64 0 1.25.25 1.7.71l1.71 1.7V14c0 1.12-.88 2-2 2h-2v2h2c1.37 0 2.5-.7 3.17-1.76A2.5 2.5 0 0 0 17 17h1c.88 0 1.74-.23 2.5-.67l2.5-1.44Z"/>'
        },
        "food-hot-dog": {
            body: '<path fill="currentColor" d="M21 5.77c-.15-.12-.28-.22-.41-.32l.03-.04c.78-.78.78-2.04 0-2.82c-.78-.78-2.04-.78-2.83 0l-.74.74a3.465 3.465 0 0 0-4.55.32L3.65 12.5a3.465 3.465 0 0 0-.32 4.55l-.74.74c-.79.79-.79 2.05 0 2.83c.78.78 2.04.78 2.82 0l.04-.03c.1.13.2.26.32.41c1.36 1.34 3.58 1.34 4.95 0l10.25-10.28A3.522 3.522 0 0 0 21 5.77M4.77 15.61a1.5 1.5 0 0 1 .29-1.71l8.84-8.84a1.5 1.5 0 0 1 1.71-.29L4.77 15.61M19.56 9.3L9.3 19.56c-.58.59-1.53.59-2.12 0c-.58-.56-.58-1.56 0-2.12L17.44 7.18c.56-.58 1.56-.58 2.12 0c.59.59.59 1.54 0 2.12Z"/>'
        },
        "food-kosher": {
            body: '<path fill="currentColor" d="M1 7v2h2c.57 0 1 .43 1 1v7h2v-7c0-1.64-1.36-3-3-3H1m6 0v7c0 1.65 1.36 3 3 3h4c1.65 0 3-1.35 3-3V7h-2v7c0 .57-.43 1-1 1h-4c-.57 0-1-.43-1-1v-1h1c1.65 0 3-1.35 3-3V7h-2v3c0 .57-.43 1-1 1H9V7H7m11 0v2h2c.57 0 1 .43 1 1v4c0 .57-.43 1-1 1h-2v2h2c1.65 0 3-1.35 3-3v-4c0-1.64-1.35-3-3-3h-2Z"/>'
        },
        "food-off": {
            body: '<path fill="currentColor" d="M11.35 8.5L11 5h5V1h2v4h5l-1.38 13.79L11.35 8.5M1 21v1c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-1H1m20.9.9L2.1 2.1L.69 3.5l5.7 5.71C3.28 9.87 1 12 1 15h11.17l2 2H1v2h15v-.17l4.5 4.49l1.4-1.42Z"/>'
        },
        "food-off-outline": {
            body: '<path fill="currentColor" d="M1 21h15v1c0 .54-.44 1-1 1H2c-.55 0-1-.46-1-1v-1m19.5 2.31L16 18.83V19H1v-2h13.17l-2-2H1c0-3.24 2.46-5.17 5.38-5.79L.68 3.5L2.1 2.1L13 13l2 2l6.9 6.9l-1.4 1.41M10.17 13l-2-2c-1.42.06-3.52.56-4.55 2h6.55M23 5h-5V1h-2v4h-5l.23 2h9.56l-1 9.97l1.83 1.83L23 5Z"/>'
        },
        "food-outline": {
            body: '<path fill="currentColor" d="M1 22c0 .54.45 1 1 1h13c.56 0 1-.46 1-1v-1H1v1M8.5 9C4.75 9 1 11 1 15h15c0-4-3.75-6-7.5-6m-4.88 4c1.11-1.55 3.47-2 4.88-2s3.77.45 4.88 2H3.62M1 17h15v2H1v-2M18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5Z"/>'
        },
        "food-steak": {
            body: '<path fill="currentColor" d="M11.9 2C8 2 4.9 5.4 5 9.3c.1 2.6 1.6 4.8 3.7 5.9c1.4.7 2.3 2.1 2.3 3.6v.2c0 1.7 1.3 3 3 3c4 0 5-5 5-13c0 0 0-7-7.1-7M14 20c-.6 0-1-.4-1-1v-.2c0-2.2-1.3-4.3-3.3-5.4C8.1 12.6 7.1 11 7 9.2c0-1.3.5-2.7 1.4-3.7c.9-1 2.2-1.5 3.4-1.5C16.7 4 17 8.2 17 9c0 9.9-1.7 11-3 11m1.8-12.4l-7.5 2.7C8.1 10 8 9.6 8 9.1c0-.7.2-1.3.5-2l5.2-1.9c1.2.6 1.8 1.5 2.1 2.4m-2.9 7.5l2.8-1c-.1 1.5-.4 2.6-.6 3.3l-1.3.5c0-1-.3-1.9-.9-2.8M16 9.2c0 1.2 0 2.3-.1 3.2l-4 1.5c-.5-.5-1.1-1-1.8-1.3c-.4-.2-.8-.5-1.1-.8l7-2.6Z"/>'
        },
        "food-steak-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l4.16 4.16C5.08 7.83 5 8.53 5 9.26a7.03 7.03 0 0 0 3.74 5.93c1.36.71 2.26 2.06 2.26 3.6V19c0 1.66 1.34 3 3 3c1.68 0 2.83-.89 3.6-2.5l3.24 3.23l1.27-1.27L2.39 1.73M14 20c-.55 0-1-.45-1-1v-.21c0-2.23-1.28-4.29-3.33-5.37A5.039 5.039 0 0 1 7 9.18V8.9l1.16 1.15c.03.1.05.2.08.3l.16-.06l1.22 1.21l-.54.21c.3.33.65.61 1.06.82c.67.36 1.26.81 1.77 1.32l.04-.01l1.22 1.22l-.22.08c.51.82.85 1.75.98 2.71l1.27-.46c.02-.07.05-.15.07-.23l.8.8C15.47 19.68 14.68 20 14 20m1.79-12.4l-3.65 1.34l-2.26-2.26l3.81-1.38c1.25.47 1.84 1.42 2.1 2.3m-7.2-2.21L7.17 3.97C8.41 2.77 10.07 2 11.88 2C19 2 19 9 19 9c0 2.46-.1 4.63-.34 6.46l-1.82-1.82c.1-1.28.16-2.81.16-4.64c0-.82-.31-5-5.12-5c-1.21 0-2.38.5-3.29 1.39m7.09 7.11l-2.32-2.35L16 9.19c0 1.22-.03 2.27-.08 3.21l-.24.1Z"/>'
        },
        "food-takeout-box": {
            body: '<path fill="currentColor" d="M5.26 11h13.48l-.67 9H5.93l-.67-9M9 4h5.97L19 7.38l1.59-1.59L22 7.21L19.21 10H4.79L2 7.21L3.41 5.8L5 7.38L9 4Z"/>'
        },
        "food-takeout-box-outline": {
            body: '<path fill="currentColor" d="m7.79 18l-.51-7h9.46l-.51 7H7.79M9.83 5h4.33l2.8 2.73L16.87 9H7.12l-.09-1.27L9.83 5M22 7.46l-1.41-1.41L19 7.63l.03-.56L15 3H9L4.97 7.07l.03.5L3.41 6L2 7.44l3.23 3.11l.7 9.45h12.14l.7-9.44L22 7.46Z"/>'
        },
        "food-turkey": {
            body: '<path fill="currentColor" d="m5.44 7.96l.52-.53c.58-.58 1.54-.58 2.14.04l.02.03c.49.5 1.14.74 1.85.81c.97.09 1.91.61 2.53 1.55c.68 1.08.67 2.52-.04 3.59a3.322 3.322 0 0 1-5.18.55c-.56-.55-.88-1.26-.96-2c-.08-.73-.37-1.42-.88-1.93c-.58-.57-.58-1.53 0-2.11M9.64 16c-1.17 0-2.26-.45-3.07-1.28c-.7-.72-1.14-1.62-1.25-2.6c-.03-.3-.12-.69-.36-1.05C4.36 11.9 4 12.9 4 14c0 1.64.8 3.09 2.03 4H19v-1c0-3.6-2.39-6.65-5.66-7.65c.89 1.4.87 3.27-.04 4.65c-.8 1.25-2.18 2-3.66 2m5.14-8.44h1.27c.87 0 1.63.61 1.63 1.7V10h1.25V9c0-1.5-1.33-2.64-2.88-2.64h-1.27c-.83 0-1.54-.82-1.54-1.66s.71-1.46 1.54-1.46V2C13.24 2 12 3.24 12 4.78s1.24 2.78 2.78 2.78M4.5 7.55c.06-.1.14-.2.23-.3l.52-.52c.09-.09.19-.16.29-.23L4.13 5.07c.14-.27.09-.62-.13-.85a.767.767 0 0 0-1.07 0c-.14.14-.21.31-.22.49c-.18.01-.35.08-.49.22c-.29.29-.29.77 0 1.07c.23.22.57.27.85.13L4.5 7.55m13.89-3.16c.51-.51.83-1.2.83-1.97h-1.25c0 .83-.7 1.53-1.53 1.53v1.24c1.86 0 3.32 1.52 3.32 3.38V11H21V8.57a4.61 4.61 0 0 0-2.61-4.18M5 21h14c1.11 0 2-.89 2-2H3a2 2 0 0 0 2 2Z"/>'
        },
        "food-variant": {
            body: '<path fill="currentColor" d="M22 18a4 4 0 0 1-4 4h-3a4 4 0 0 1-4-4v-2h6.79l2.76-4.77l1.56.9L19.87 16H22v2M9 22H2c0-3 0-6 .33-9.17C2.6 10.3 3.08 7.66 3.6 5H3V3h5v2h-.6c.52 2.66 1 5.3 1.27 7.83C9 16 9 19 9 22Z"/>'
        },
        "food-variant-off": {
            body: '<path fill="currentColor" d="M2.28 3L1 4.27l2.31 2.31c-.4 2.12-.76 4.22-.98 6.25C2 16 2 19 2 22h7c0-3 0-6-.33-9.17c-.04-.33-.09-.68-.13-1.02L12.73 16H11v2c0 2.21 1.79 4 4 4h3c.23 0 .45 0 .67-.06L19.73 23L21 21.72M4.82 3l2.71 2.71c-.03-.24-.08-.47-.13-.71H8V3H7m13.55 8.23L17.8 16l3.79 3.76c.27-.55.41-1.15.41-1.76v-2h-2.13l2.24-3.87Z"/>'
        },
        "foot-print": {
            body: '<path fill="currentColor" d="M16 2a2 2 0 1 1-2 2a2 2 0 0 1 2-2m-3.96 1a1.5 1.5 0 1 1-1.5 1.5a1.5 1.5 0 0 1 1.5-1.5M9.09 4.5a1 1 0 1 1-1 1a1 1 0 0 1 1-1M7.04 6a1 1 0 1 1-1 1a1 1 0 0 1 1-1m7.49 6A2.5 2.5 0 0 0 17 9.24A2.6 2.6 0 0 0 14.39 7h-2.48a6 6 0 0 0-5.79 4.4a2 2 0 0 0 .11 1.4a6.8 6.8 0 0 1 .68 2.96a6.89 6.89 0 0 1-.69 2.79a1.92 1.92 0 0 0 .08 1.76a3.62 3.62 0 0 0 3.89 1.6a3.5 3.5 0 0 0 2.17-5.28a2.82 2.82 0 0 1-.45-1.63s-.23-3 2.62-3Z"/>'
        },
        football: {
            body: '<path fill="currentColor" d="M8.39 21L3 15.61c0 1.09.04 2.1.2 3.02c.15.92.3 1.47.51 1.66c.19.21.73.36 1.64.52s1.92.19 3.04.19M15.5 9.89L9.89 15.5L8.5 14.11l5.61-5.61l1.39 1.39M3.29 13.08l7.63 7.63c2.78-.5 4.98-1.56 6.61-3.18c1.62-1.63 2.68-3.83 3.18-6.61l-7.63-7.63c-2.78.5-4.98 1.56-6.61 3.18s-2.68 3.83-3.18 6.61M15.61 3L21 8.39c0-1.09-.04-2.1-.19-3.02c-.16-.92-.31-1.47-.52-1.66c-.19-.21-.73-.36-1.64-.51S16.73 3 15.61 3Z"/>'
        },
        "football-australian": {
            body: '<path fill="currentColor" d="M7.5 7.5c1.67-1.63 3.79-2.81 5.87-3.32C18 3 21 6 19.82 10.63c-.51 2.08-1.69 4.2-3.32 5.87c-1.67 1.63-3.79 2.81-5.87 3.32C6 21 3 18 4.18 13.37c.51-2.08 1.69-4.2 3.32-5.87m3.12 3.76l-.36.36l2.12 2.12l.36-.36l-2.12-2.12m1-1l-.36.36l2.12 2.12l.36-.36l-2.12-2.12m-2 2l-.36.36l2.12 2.12l.36-.36l-2.12-2.12m3.01-2.98l-.35.35l2.12 2.12l.35-.35l-2.12-2.12m-4 4l-.35.35l2.12 2.12l.35-.35l-2.12-2.12m5-5l-.35.35l2.12 2.12l.35-.35l-2.12-2.12Z"/>'
        },
        "football-helmet": {
            body: '<path fill="currentColor" d="M13.5 12a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m0-9c4.69 0 8.5 3.58 8.5 8c0 1.62 0 3-.91 5C17 16 16 20 12.5 20c-2.18 0-3.23-1.72-3.45-4h-.81l-1.28 4.3a1 1 0 0 1-1.12.7H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1v-3a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3.75l.48-1.61c-.51-.25-1.1-.39-1.73-.39h-.43L5 11c0-4.42 3.81-8 8.5-8M5 16v3h.26l.89-3H5Z"/>'
        },
        footer: {
            body: '<path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 6v8h4V8h-4z" fill="currentColor"/>',
            hidden: true
        },
        forest: {
            body: '<path fill="currentColor" d="M16 12L9 2L2 12h1.86L0 18h7v4h4v-4h7l-3.86-6H16m4.14 0H22L15 2l-2.39 3.41L17.92 13h-1.95l3.22 5H24l-3.86-6M13 19h4v3h-4v-3Z"/>'
        },
        forklift: {
            body: '<path fill="currentColor" d="M6 4v7H4c-1.11 0-2 .89-2 2v4a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3v-4l-4-9H6m11 1v14h5v-1.5h-3.5V5H17m-9.5.5h3.7l3.3 7.5h-7V5.5M5 15.5A1.5 1.5 0 0 1 6.5 17A1.5 1.5 0 0 1 5 18.5A1.5 1.5 0 0 1 3.5 17A1.5 1.5 0 0 1 5 15.5m8 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "form-dropdown": {
            body: '<path fill="currentColor" d="M17 5h3l-1.5 2L17 5M3 2h18a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2h-5v10c0 1.11-.89 2-2 2H3a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 2v4h11V4H3m18 4V4h-5v4h5M3 20h11V10H3v10m2-8h7v2H5v-2m0 4h7v2H5v-2Z"/>'
        },
        "form-select": {
            body: '<path fill="currentColor" d="M15 5h3l-1.5 2L15 5M5 2h14a2 2 0 0 1 2 2v16c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 2v4h14V4H5m0 16h14V10H5v10m2-8h10v2H7v-2m0 4h10v2H7v-2Z"/>'
        },
        "form-textarea": {
            body: '<path fill="currentColor" d="M13 9H4v14H2V7h11m10 2V7h-6V5a1 1 0 0 1 1-1h2V2h-2.5C17 2 16 2.45 16 3c0-.55-.95-1-1.5-1H12v2h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2v2h2.5c.55 0 1.5-.45 1.5-1c0 .55.95 1 1.5 1H20v-2h-2a1 1 0 0 1-1-1V9Z"/>'
        },
        "form-textbox": {
            body: '<path fill="currentColor" d="M17 7h5v10h-5v2a1 1 0 0 0 1 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1c0 .55-.95 1-1.5 1H12v-2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2V2h2.5c.55 0 1.5.45 1.5 1c0-.55.95-1 1.5-1H20v2h-2a1 1 0 0 0-1 1v2M2 7h11v2H4v6h9v2H2V7m18 8V9h-3v6h3Z"/>'
        },
        "form-textbox-lock": {
            body: '<path fill="currentColor" d="M2 7h4v2H4v6h2v2H2V7m8 0h12v5c-.58-.44-1.26-.75-2-.9V9H10v6h4.25c-.69 0-1.25.56-1.25 1.25V17h-3v2c0 .55.45 1 1 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1c0 .55-.95 1-1.5 1H5v-2h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H5V2h2.5C8.05 2 9 2.45 9 3c0-.55.95-1 1.5-1H13v2h-2c-.55 0-1 .45-1 1v2m11.8 10c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V17m-1.3 0v-1.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V17h3Z"/>'
        },
        "form-textbox-password": {
            body: '<path fill="currentColor" d="M17 7h5v10h-5v2a1 1 0 0 0 1 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1c0 .55-.95 1-1.5 1H12v-2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2V2h2.5c.55 0 1.5.45 1.5 1c0-.55.95-1 1.5-1H20v2h-2a1 1 0 0 0-1 1v2M2 7h11v2H4v6h9v2H2V7m18 8V9h-3v6h3M8.5 12A1.5 1.5 0 0 0 7 10.5A1.5 1.5 0 0 0 5.5 12A1.5 1.5 0 0 0 7 13.5A1.5 1.5 0 0 0 8.5 12m4.5-1.11c-.61-.56-1.56-.51-2.12.11c-.56.6-.51 1.55.12 2.11c.55.52 1.43.52 2 0v-2.22Z"/>'
        },
        "format-align-bottom": {
            body: '<path fill="currentColor" d="m13 9l2.5-2.5l1.42 1.42L12 12.84L7.08 7.92L8.5 6.5L11 9V3h2v6M3 15h18v2H3v-2m0 4h10v2H3v-2Z"/>'
        },
        "format-align-center": {
            body: '<path fill="currentColor" d="M3 3h18v2H3V3m4 4h10v2H7V7m-4 4h18v2H3v-2m4 4h10v2H7v-2m-4 4h18v2H3v-2Z"/>'
        },
        "format-align-justify": {
            body: '<path fill="currentColor" d="M3 3h18v2H3V3m0 4h18v2H3V7m0 4h18v2H3v-2m0 4h18v2H3v-2m0 4h18v2H3v-2Z"/>'
        },
        "format-align-left": {
            body: '<path fill="currentColor" d="M3 3h18v2H3V3m0 4h12v2H3V7m0 4h18v2H3v-2m0 4h12v2H3v-2m0 4h18v2H3v-2Z"/>'
        },
        "format-align-middle": {
            body: '<path fill="currentColor" d="m13 6l2-2l1.42 1.42L12 9.84L7.58 5.42L9 4l2 2V2h2v4M3 11h18v2H3v-2m10 7v4h-2v-4l-2 2l-1.42-1.42L12 14.16l4.42 4.42L15 20l-2-2Z"/>'
        },
        "format-align-right": {
            body: '<path fill="currentColor" d="M3 3h18v2H3V3m6 4h12v2H9V7m-6 4h18v2H3v-2m6 4h12v2H9v-2m-6 4h18v2H3v-2Z"/>'
        },
        "format-align-top": {
            body: '<path fill="currentColor" d="m13 15l2.5 2.5l1.42-1.42L12 11.16l-4.92 4.92L8.5 17.5L11 15v6h2v-6M3 3h18v2H3V3m0 4h10v2H3V7Z"/>'
        },
        "format-annotation-minus": {
            body: '<path fill="currentColor" d="M10.5 7h-2L3 21h2.2l1.1-3h6.2l1.1 3H16L10.5 7m-3.4 9l2.4-6.3l2.4 6.3H7.1M22 7h-8V5h8v2Z"/>'
        },
        "format-annotation-plus": {
            body: '<path fill="currentColor" d="M8.5 7h2L16 21h-2.4l-1.1-3H6.3l-1.1 3H3L8.5 7m-1.4 9h4.8L9.5 9.7L7.1 16M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3Z"/>'
        },
        "format-bold": {
            body: '<path fill="currentColor" d="M13.5 15.5H10v-3h3.5A1.5 1.5 0 0 1 15 14a1.5 1.5 0 0 1-1.5 1.5m-3.5-9h3A1.5 1.5 0 0 1 14.5 8A1.5 1.5 0 0 1 13 9.5h-3m5.6 1.29c.97-.68 1.65-1.79 1.65-2.79c0-2.26-1.75-4-4-4H7v14h7.04c2.1 0 3.71-1.7 3.71-3.79c0-1.52-.86-2.82-2.15-3.42Z"/>'
        },
        "format-clear": {
            body: '<path fill="currentColor" d="M6 5v.18L8.82 8h2.4l-.72 1.68l2.1 2.1L14.21 8H20V5H6M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21L18 19.73L3.55 5.27L3.27 5Z"/>'
        },
        "format-color": {
            body: '<path d="M9.624 11.998L12 5.665l2.375 6.333m-3.375-9l-5.5 14h2.25l1.125-3h6.25l1.125 3h2.25l-5.5-14h-2z" fill="currentColor"/>',
            hidden: true
        },
        "format-color-fill": {
            body: '<path fill="currentColor" d="M19 11.5s-2 2.17-2 3.5a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-1.33-2-3.5-2-3.5M5.21 10L10 5.21L14.79 10m1.77-1.06L7.62 0L6.21 1.41l2.38 2.38l-5.15 5.15c-.59.56-.59 1.53 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.59.59-1.56 0-2.12Z"/>'
        },
        "format-color-highlight": {
            body: '<path fill="currentColor" d="m4 17l2.75-2.75l-.03-.02c-.58-.59-.58-1.54 0-2.12l4.74-4.74l4.24 4.24l-4.74 4.74c-.57.58-1.5.58-2.09.02l-.63.63H4M15.91 2.91c.59-.58 1.54-.58 2.12 0l2.13 2.12c.58.59.58 1.54 0 2.13l-3.3 3.29l-4.24-4.24l3.29-3.3Z"/>'
        },
        "format-color-marker-cancel": {
            body: '<path fill="currentColor" d="M16.5 8C14 8 12 10 12 12.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5S19 8 16.5 8m0 7.5c-1.7 0-3-1.3-3-3c0-.6.2-1.1.4-1.5l4.1 4.1c-.4.2-.9.4-1.5.4m2.6-1.5L15 9.9c.4-.3.9-.4 1.5-.4c1.7 0 3 1.3 3 3c0 .6-.2 1.1-.4 1.5m-7-6.3l-1.5-1.5l3.3-3.3c.6-.6 1.5-.6 2.1 0L18.2 5c.4.4.5.8.4 1.3c-.6-.2-1.3-.3-2-.3c-1.8 0-3.3.7-4.5 1.7m-1.6 7.2L9 16.3c-.6.6-1.5.6-2.1 0l-.7.7H2l2.8-2.8c-.6-.6-.6-1.5 0-2.1l4.7-4.7L11.1 9c-.7 1-1.1 2.2-1.1 3.5c0 .8.2 1.6.5 2.4Z"/>'
        },
        "format-color-text": {
            body: '<path fill="currentColor" d="M9.62 12L12 5.67L14.37 12M11 3L5.5 17h2.25l1.12-3h6.25l1.13 3h2.25L13 3h-2Z"/>'
        },
        "format-columns": {
            body: '<path fill="currentColor" d="M3 3h8v2H3V3m10 0h8v2h-8V3M3 7h8v2H3V7m10 0h8v2h-8V7M3 11h8v2H3v-2m10 0h8v2h-8v-2M3 15h8v2H3v-2m10 0h8v2h-8v-2M3 19h8v2H3v-2m10 0h8v2h-8v-2Z"/>'
        },
        "format-float-center": {
            body: '<path fill="currentColor" d="M9 7h6v6H9V7M3 3h18v2H3V3m0 12h18v2H3v-2m0 4h14v2H3v-2Z"/>'
        },
        "format-float-left": {
            body: '<path fill="currentColor" d="M3 7h6v6H3V7m0-4h18v2H3V3m18 4v2H11V7h10m0 4v2H11v-2h10M3 15h14v2H3v-2m0 4h18v2H3v-2Z"/>'
        },
        "format-float-none": {
            body: '<path fill="currentColor" d="M3 7h6v6H3V7m0-4h18v2H3V3m18 8v2H11v-2h10M3 15h14v2H3v-2m0 4h18v2H3v-2Z"/>'
        },
        "format-float-right": {
            body: '<path fill="currentColor" d="M15 7h6v6h-6V7M3 3h18v2H3V3m10 4v2H3V7h10m-4 4v2H3v-2h6m-6 4h14v2H3v-2m0 4h18v2H3v-2Z"/>'
        },
        "format-font": {
            body: '<path fill="currentColor" d="M17 8h3v12h1v1h-4v-1h1v-3h-4l-1.5 3H14v1h-4v-1h1l6-12m1 1l-3.5 7H18V9M5 3h5c1.11 0 2 .89 2 2v11H9v-5H6v5H3V5c0-1.11.89-2 2-2m1 2v4h3V5H6Z"/>'
        },
        "format-font-size-decrease": {
            body: '<path fill="currentColor" d="M5.12 14L7.5 7.67L9.87 14M6.5 5L1 19h2.25l1.12-3h6.25l1.13 3H14L8.5 5h-2M18 17l5-5.07l-1.41-1.43L19 13.1V7h-2v6.1l-2.59-2.6L13 11.93L18 17Z"/>'
        },
        "format-font-size-increase": {
            body: '<path fill="currentColor" d="M5.12 14L7.5 7.67L9.87 14M6.5 5L1 19h2.25l1.12-3h6.25l1.13 3H14L8.5 5h-2M18 7l-5 5.07l1.41 1.43L17 10.9V17h2v-6.1l2.59 2.6L23 12.07L18 7Z"/>'
        },
        "format-header-1": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m11 14v-2h2V6.31l-2.5 1.44V5.44L16 4h2v12h2v2h-6Z"/>'
        },
        "format-header-2": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m18 14h-6a2 2 0 0 1-2-2c0-.53.2-1 .54-1.36l4.87-5.23c.37-.36.59-.86.59-1.41a2 2 0 0 0-2-2a2 2 0 0 0-2 2h-2a4 4 0 0 1 4-4a4 4 0 0 1 4 4c0 1.1-.45 2.1-1.17 2.83L15 16h6v2Z"/>'
        },
        "format-header-3": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m12 0h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h2v1h4v-4h-4v-2h4V6h-4v1h-2V6a2 2 0 0 1 2-2Z"/>'
        },
        "format-header-4": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m15 14v-5h-5v-2l5-7h2v7h1v2h-1v5h-2m0-7V7.42L15.45 11H18Z"/>'
        },
        "format-header-5": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m12 0h5v2h-5v4h2a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-2a2 2 0 0 1-2-2v-1h2v1h2a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/>'
        },
        "format-header-6": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m12 0h4a2 2 0 0 1 2 2v1h-2V6h-4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 8v4h4v-4h-4Z"/>'
        },
        "format-header-decrease": {
            body: '<path fill="currentColor" d="M4 4h2v6h4V4h2v14h-2v-6H6v6H4V4m16.42 3.41L16.83 11l3.59 3.59L19 16l-5-5l5-5l1.42 1.41Z"/>'
        },
        "format-header-down": {
            body: '<path d="M2 4h2v6h4V4h2v14H8v-6H4v6H2V4zm18.586 4.585L17 12.172l-3.586-3.587L12 9.999L17 15l5-5.001l-1.414-1.414z" fill="currentColor"/>',
            hidden: true
        },
        "format-header-equal": {
            body: '<path fill="currentColor" d="M4 4h2v6h4V4h2v14h-2v-6H6v6H4V4m10 6V8h7v2h-7m0 2h7v2h-7v-2Z"/>'
        },
        "format-header-increase": {
            body: '<path fill="currentColor" d="M4 4h2v6h4V4h2v14h-2v-6H6v6H4V4m10.59 3.41L18.17 11l-3.58 3.59L16 16l5-5l-5-5l-1.41 1.41Z"/>'
        },
        "format-header-pound": {
            body: '<path fill="currentColor" d="M3 4h2v6h4V4h2v14H9v-6H5v6H3V4m10 4h2.31l.32-3h2l-.32 3h2l.32-3h2l-.32 3H23v2h-1.9l-.2 2H23v2h-2.31l-.32 3h-2l.32-3h-2l-.32 3h-2l.32-3H13v-2h1.9l.2-2H13V8m4.1 2l-.2 2h2l.2-2h-2Z"/>'
        },
        "format-header-up": {
            body: '<path d="M2 4h2v6h4V4h2v14H8v-6H4v6H2V4zm18.586 10.415L17 10.828l-3.586 3.587L12 13.001L17 8l5 5.001l-1.414 1.414z" fill="currentColor"/>',
            hidden: true
        },
        "format-horizontal-align-center": {
            body: '<path fill="currentColor" d="M19 16v-3h4v-2h-4V8l-4 4l4 4M5 8v3H1v2h4v3l4-4l-4-4m6 12h2V4h-2v16Z"/>'
        },
        "format-horizontal-align-left": {
            body: '<path fill="currentColor" d="M11 16v-3h10v-2H11V8l-4 4l4 4m-8 4h2V4H3v16Z"/>'
        },
        "format-horizontal-align-right": {
            body: '<path fill="currentColor" d="M13 8v3H3v2h10v3l4-4l-4-4m6 12h2V4h-2v16Z"/>'
        },
        "format-indent-decrease": {
            body: '<path fill="currentColor" d="M11 13h10v-2H11m0-2h10V7H11M3 3v2h18V3M3 21h18v-2H3m0-7l4 4V8m4 9h10v-2H11v2Z"/>'
        },
        "format-indent-increase": {
            body: '<path fill="currentColor" d="M11 13h10v-2H11m0-2h10V7H11M3 3v2h18V3M11 17h10v-2H11M3 8v8l4-4m-4 9h18v-2H3v2Z"/>'
        },
        "format-italic": {
            body: '<path fill="currentColor" d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8Z"/>'
        },
        "format-letter-case": {
            body: '<path fill="currentColor" d="M20.06 18a3.99 3.99 0 0 1-.2-.89c-.67.7-1.48 1.05-2.41 1.05c-.83 0-1.52-.24-2.05-.71c-.53-.45-.8-1.06-.8-1.79c0-.88.33-1.56 1-2.05c.67-.49 1.61-.73 2.83-.73h1.4v-.64c0-.49-.15-.88-.45-1.17c-.3-.29-.75-.43-1.33-.43c-.52 0-.95.12-1.3.36c-.35.25-.52.54-.52.89h-1.46c0-.43.15-.84.45-1.24c.28-.4.71-.71 1.22-.94c.51-.21 1.06-.35 1.69-.35c.98 0 1.74.24 2.29.73s.84 1.16.86 2.02V16c0 .8.1 1.42.3 1.88V18h-1.52m-2.4-1.12c.45 0 .88-.11 1.29-.32c.4-.21.7-.49.88-.83v-1.57H18.7c-1.77 0-2.66.47-2.66 1.41c0 .43.15.73.46.96c.3.23.68.35 1.16.35m-12.2-3.17h4.07L7.5 8.29l-2.04 5.42M6.64 6h1.72l4.71 12h-1.93l-.97-2.57H4.82L3.86 18H1.93L6.64 6Z"/>'
        },
        "format-letter-case-lower": {
            body: '<path fill="currentColor" d="M20.06 18a3.99 3.99 0 0 1-.2-.89c-.67.7-1.48 1.05-2.41 1.05c-.83 0-1.52-.24-2.05-.71c-.53-.45-.8-1.06-.8-1.79c0-.88.33-1.56 1-2.05c.67-.49 1.61-.73 2.83-.73h1.4v-.64c0-.49-.15-.88-.45-1.17c-.3-.29-.75-.43-1.33-.43c-.52 0-.95.12-1.3.36c-.35.25-.52.54-.52.89h-1.46c0-.43.15-.84.45-1.24c.28-.4.71-.71 1.22-.94c.51-.21 1.06-.35 1.69-.35c.98 0 1.74.24 2.29.73s.84 1.16.86 2.02V16c0 .8.1 1.42.3 1.88V18h-1.52m-2.4-1.12c.45 0 .88-.11 1.29-.32c.4-.21.7-.49.88-.83v-1.57H18.7c-1.77 0-2.66.47-2.66 1.41c0 .43.15.73.46.96c.3.23.68.35 1.16.35m-12.2-3.17h4.07L7.5 8.29l-2.04 5.42M6.64 6h1.72l4.71 12h-1.93l-.97-2.57H4.82L3.86 18H1.93L6.64 6M22 20v2h-7.5v-2H22Z"/>'
        },
        "format-letter-case-upper": {
            body: '<path fill="currentColor" d="M20.06 18a3.99 3.99 0 0 1-.2-.89c-.67.7-1.48 1.05-2.41 1.05c-.83 0-1.52-.24-2.05-.71c-.53-.45-.8-1.06-.8-1.79c0-.88.33-1.56 1-2.05c.67-.49 1.61-.73 2.83-.73h1.4v-.64c0-.49-.15-.88-.45-1.17c-.3-.29-.75-.43-1.33-.43c-.52 0-.95.12-1.3.36c-.35.25-.52.54-.52.89h-1.46c0-.43.15-.84.45-1.24c.28-.4.71-.71 1.22-.94c.51-.21 1.06-.35 1.69-.35c.98 0 1.74.24 2.29.73s.84 1.16.86 2.02V16c0 .8.1 1.42.3 1.88V18h-1.52m-2.4-1.12c.45 0 .88-.11 1.29-.32c.4-.21.7-.49.88-.83v-1.57H18.7c-1.77 0-2.66.47-2.66 1.41c0 .43.15.73.46.96c.3.23.68.35 1.16.35m-12.2-3.17h4.07L7.5 8.29l-2.04 5.42M6.64 6h1.72l4.71 12h-1.93l-.97-2.57H4.82L3.86 18H1.93L6.64 6M2 20h11v2H2v-2Z"/>'
        },
        "format-letter-ends-with": {
            body: '<path fill="currentColor" d="M11.14 4L6.43 16h1.93l.96-2.57h5.35l.97 2.57h1.93L12.86 4M12 6.29l2.03 5.42H9.96M20 14v4H2v2h20v-6Z"/>'
        },
        "format-letter-matches": {
            body: '<path fill="currentColor" d="M11.14 4L6.43 16h1.93l.96-2.57h5.35l.97 2.57h1.93L12.86 4M12 6.29l2.03 5.42H9.96M20 14v4H4v-3H2v5h20v-6Z"/>'
        },
        "format-letter-spacing": {
            body: '<path fill="currentColor" d="M14.4 10.7h4.1l-2-5.4l-2.1 5.4M15.6 3h1.7L22 15h-1.9l-1-2.6h-5.4l-1 2.6h-1.9l4.8-12m-4.4 0h1.9L8.4 15H6.7L2 3h1.9l3.6 9.7M19 22v-2H5v2l-3-3l3-3v2h14v-2l3 3l-3 3Z"/>'
        },
        "format-letter-spacing-variant": {
            body: '<path fill="currentColor" d="M22 3v18h-2V3h2M4 3v18H2V3h2m6 10.7h4l-2-5.4l-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z"/>'
        },
        "format-letter-starts-with": {
            body: '<path fill="currentColor" d="M11.14 4L6.43 16h1.93l.96-2.57h5.35l.97 2.57h1.93L12.86 4M12 6.29l2.03 5.42H9.96M4 18v-3H2v5h20v-2Z"/>'
        },
        "format-line-height": {
            body: '<path fill="currentColor" d="M21 22H3v-2h18v2m0-18H3V2h18v2m-11 9.7h4l-2-5.4l-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z"/>'
        },
        "format-line-spacing": {
            body: '<path fill="currentColor" d="M10 13h12v-2H10m0 8h12v-2H10m0-10h12V5H10M6 7h2.5L5 3.5L1.5 7H4v10H1.5L5 20.5L8.5 17H6V7Z"/>'
        },
        "format-line-style": {
            body: '<path fill="currentColor" d="M3 16h5v-2H3v2m6.5 0h5v-2h-5v2m6.5 0h5v-2h-5v2M3 20h2v-2H3v2m4 0h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2M3 12h8v-2H3v2m10 0h8v-2h-8v2M3 4v4h18V4H3Z"/>'
        },
        "format-line-weight": {
            body: '<path fill="currentColor" d="M3 17h18v-2H3v2m0 3h18v-1H3v1m0-7h18v-3H3v3m0-9v4h18V4H3Z"/>'
        },
        "format-list-bulleted": {
            body: '<path fill="currentColor" d="M7 5h14v2H7V5m0 8v-2h14v2H7M4 4.5A1.5 1.5 0 0 1 5.5 6A1.5 1.5 0 0 1 4 7.5A1.5 1.5 0 0 1 2.5 6A1.5 1.5 0 0 1 4 4.5m0 6A1.5 1.5 0 0 1 5.5 12A1.5 1.5 0 0 1 4 13.5A1.5 1.5 0 0 1 2.5 12A1.5 1.5 0 0 1 4 10.5M7 19v-2h14v2H7m-3-2.5A1.5 1.5 0 0 1 5.5 18A1.5 1.5 0 0 1 4 19.5A1.5 1.5 0 0 1 2.5 18A1.5 1.5 0 0 1 4 16.5Z"/>'
        },
        "format-list-bulleted-square": {
            body: '<path fill="currentColor" d="M3 4h4v4H3V4m6 1v2h12V5H9m-6 5h4v4H3v-4m6 1v2h12v-2H9m-6 5h4v4H3v-4m6 1v2h12v-2H9"/>'
        },
        "format-list-bulleted-triangle": {
            body: '<path fill="currentColor" d="M5 15.5L7.5 20h-5L5 15.5M9 19h12v-2H9v2M5 9.5L7.5 14h-5L5 9.5M9 13h12v-2H9v2M5 3.5L7.5 8h-5L5 3.5M9 7h12V5H9v2Z"/>'
        },
        "format-list-bulleted-type": {
            body: '<path fill="currentColor" d="M5 9.5L7.5 14h-5L5 9.5M3 4h4v4H3V4m2 16a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2M9 5v2h12V5H9m0 14h12v-2H9v2m0-6h12v-2H9v2Z"/>'
        },
        "format-list-checkbox": {
            body: '<path fill="currentColor" d="M21 19v-2H8v2h13m0-6v-2H8v2h13M8 7h13V5H8v2M4 5v2h2V5H4M3 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5m1 6v2h2v-2H4m-1 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2m1 6v2h2v-2H4m-1 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2Z"/>'
        },
        "format-list-checks": {
            body: '<path fill="currentColor" d="M3 5h6v6H3V5m2 2v2h2V7H5m6 0h10v2H11V7m0 8h10v2H11v-2m-6 5l-3.5-3.5l1.41-1.41L5 17.17l4.59-4.58L11 14l-6 6Z"/>'
        },
        "format-list-group": {
            body: '<path fill="currentColor" d="M5 5v14h2v2H3V3h4v2H5m15 2H7v2h13V7m0 4H7v2h13v-2m0 4H7v2h13v-2Z"/>'
        },
        "format-list-group-plus": {
            body: '<path fill="currentColor" d="M17 14v3h-3v2h3v3h2v-3h3v-2h-3v-3m1-3v1.3c-.6-.2-1.3-.3-2-.3c-1.2 0-2.4.4-3.3 1H7v-2h13m-7.9 6H7v-2h5.8c-.3.6-.6 1.3-.7 2M7 7h13v2H7V7M5 19h2v2H3V3h4v2H5v14Z"/>'
        },
        "format-list-numbered": {
            body: '<path fill="currentColor" d="M7 13v-2h14v2H7m0 6v-2h14v2H7M7 7V5h14v2H7M3 8V5H2V4h2v4H3m-1 9v-1h3v4H2v-1h2v-.5H3v-1h1V17H2m2.25-7a.75.75 0 0 1 .75.75c0 .2-.08.39-.21.52L3.12 13H5v1H2v-.92L4 11H2v-1h2.25Z"/>'
        },
        "format-list-numbered-rtl": {
            body: '<path fill="currentColor" d="M3 13v-2h14v2H3m0 6v-2h14v2H3M3 7V5h14v2H3m17 1V5h-1V4h2v4h-1m-1 9v-1h3v4h-3v-1h2v-.5h-1v-1h1V17h-2m2.25-7a.749.749 0 0 1 .54 1.27L20.12 13H22v1h-3v-.92L21 11h-2v-1h2.25Z"/>'
        },
        "format-list-text": {
            body: '<path fill="currentColor" d="M2 14h6v6H2M16 8h-6v2h6M2 10h6V4H2m8 0v2h12V4M10 20h6v-2h-6m0-2h12v-2H10"/>'
        },
        "format-list-triangle": {
            body: '<path d="M5 15.5L7.5 20h-5L5 15.5M9 19h12v-2H9v2zM5 9.5L7.5 14h-5L5 9.5M9 13h12v-2H9v2zM5 3.5L7.5 8h-5L5 3.5M9 7h12V5H9v2z" fill="currentColor"/>',
            hidden: true
        },
        "format-overline": {
            body: '<path fill="currentColor" d="M5 5h14V3H5v2m4.62 11L12 9.67L14.37 16M11 7L5.5 21h2.25l1.12-3h6.25l1.13 3h2.25L13 7h-2Z"/>'
        },
        "format-page-break": {
            body: '<path fill="currentColor" d="M18 20H6v-2H4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2v2M14 2H6a2 2 0 0 0-2 2v8h2V4h8v4h4v4h2V8l-6-6m-3 14H8v-2h3v2m5 0h-3v-2h3v2M3 14h3v2H3v-2m18 2h-3v-2h3v2Z"/>'
        },
        "format-page-split": {
            body: '<path fill="currentColor" d="M11 11V7h2v4h-2m2-10v4h-2V1h2m-2 16v-4h2v4h-2m-2 3H6V4h3V2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h3v-2m6-17v5h3v12h-3v2h3c1.11 0 2-.89 2-2V8l-5-5m-2 16h-2v4h2v-4Z"/>'
        },
        "format-paint": {
            body: '<path fill="currentColor" d="M18 4V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6h1v4H9v11a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h8V4h-3Z"/>'
        },
        "format-paragraph": {
            body: '<path fill="currentColor" d="M13 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-2v6H9V4h4m0 6a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2v4h2Z"/>'
        },
        "format-paragraph-spacing": {
            body: '<path fill="currentColor" d="M3 17h18v2H3v-2M3 2h18v2H3V2m0 18h18v2H3v-2M13 8h2l-3-3l-3 3h2v5H9l3 3l3-3h-2V8Z"/>'
        },
        "format-pilcrow": {
            body: '<path fill="currentColor" d="M10 11a4 4 0 0 1-4-4a4 4 0 0 1 4-4h8v2h-2v16h-2V5h-2v16h-2V11Z"/>'
        },
        "format-pilcrow-arrow-left": {
            body: '<path fill="currentColor" d="M8 17v-3l-4 4l4 4v-3h12v-2m-10-7v5h2V4h2v11h2V4h2V2h-8a4 4 0 0 0-4 4a4 4 0 0 0 4 4Z"/>'
        },
        "format-pilcrow-arrow-right": {
            body: '<path fill="currentColor" d="m21 18l-4-4v3H5v2h12v3M9 10v5h2V4h2v11h2V4h2V2H9a4 4 0 0 0-4 4a4 4 0 0 0 4 4Z"/>'
        },
        "format-quote-close": {
            body: '<path fill="currentColor" d="M14 17h3l2-4V7h-6v6h3M6 17h3l2-4V7H5v6h3l-2 4Z"/>'
        },
        "format-quote-close-outline": {
            body: '<path fill="currentColor" d="M13 6v8h1.88l-2 4h5.74L21 13.24V6m-6 2h4v4.76L17.38 16h-1.26l2-4H15M3 6v8h1.88l-2 4h5.74L11 13.24V6M5 8h4v4.76L7.38 16H6.12l2-4H5Z"/>'
        },
        "format-quote-open": {
            body: '<path fill="currentColor" d="m10 7l-2 4h3v6H5v-6l2-4h3m8 0l-2 4h3v6h-6v-6l2-4h3Z"/>'
        },
        "format-quote-open-outline": {
            body: '<path fill="currentColor" d="M11 18v-8H9.12l2-4H5.38L3 10.76V18m6-2H5v-4.76L6.62 8h1.26l-2 4H9m12 6v-8h-1.88l2-4h-5.74L13 10.76V18m6-2h-4v-4.76L16.62 8h1.26l-2 4H19Z"/>'
        },
        "format-rotate-90": {
            body: '<path fill="currentColor" d="M7.34 6.41L.86 12.9l6.49 6.48l6.49-6.48l-6.5-6.49M3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66l-3.65-3.66m15.67-6.26A8.95 8.95 0 0 0 13 4V.76L8.76 5L13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9a6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10 21.62 11.5 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72Z"/>'
        },
        "format-section": {
            body: '<path fill="currentColor" d="M15.67 4.42a6.08 6.08 0 0 0-3.22-.86c-1.58 0-2.79.78-2.79 2c0 1.4 1.34 1.91 3.34 2.58c2.5.81 4.4 1.83 4.4 4.24a4.01 4.01 0 0 1-1.8 3.23c.65.61 1.01 1.47 1 2.36c0 2.82-2.6 4-5.1 4c-1.46.06-2.91-.33-4.15-1.1L8 19.34c1.04.71 2.27 1.09 3.53 1.1c1.72 0 3-.78 3-2.2c0-1.24-.78-1.93-3.28-2.79C8.5 14.5 6.6 13.5 6.6 11.21c.07-1.32.83-2.52 2-3.14c-.63-.57-.99-1.4-1-2.26C7.6 3.45 9.77 2 12.53 2c1.29 0 2.56.29 3.7.89l-.56 1.53m-4.32 9c1.06.33 2.09.76 3.06 1.29c.65-.49 1.02-1.26 1-2.07c0-1-.64-1.88-2.41-2.5c-1.11-.37-2.22-.83-3.28-1.37c-.75.45-1.22 1.26-1.22 2.14c0 .97.73 1.77 2.85 2.51Z"/>'
        },
        "format-size": {
            body: '<path fill="currentColor" d="M2 4v3h5v12h3V7h5V4H2m19 5h-9v3h3v7h3v-7h3V9Z"/>'
        },
        "format-strikethrough": {
            body: '<path fill="currentColor" d="M3 14h18v-2H3m2-8v3h5v3h4V7h5V4m-9 15h4v-3h-4v3Z"/>'
        },
        "format-strikethrough-variant": {
            body: '<path fill="currentColor" d="M23 12v2h-4.39c1 2.14.95 8-6.23 8c-8.33.05-8.01-6.5-8.01-6.5l3.97.05c.03 3.37 3.16 3.37 3.78 3.33c.64-.05 3.03-.04 3.22-2.38c.08-1.09-1.02-1.92-2.22-2.5H1v-2h22m-3.59-4.11l-3.98-.03s.17-2.77-3.28-2.78C8.7 5.06 9 7.28 9 7.56c.04.28.34 1.66 3 2.32H5.71S2.22 3.15 10.74 2c8.71-1.2 8.69 5.91 8.67 5.89Z"/>'
        },
        "format-subscript": {
            body: '<path fill="currentColor" d="M16 7.41L11.41 12L16 16.59L14.59 18L10 13.41L5.41 18L4 16.59L8.59 12L4 7.41L5.41 6L10 10.59L14.59 6L16 7.41m5.85 13.62h-4.88v-1l.89-.8c.76-.65 1.32-1.19 1.7-1.63c.37-.44.56-.85.57-1.24a.898.898 0 0 0-.27-.7c-.18-.16-.47-.28-.86-.28c-.31 0-.58.06-.84.18l-.66.38l-.45-1.17c.27-.21.59-.39.98-.53s.82-.24 1.29-.24c.78.04 1.38.25 1.78.66c.4.41.62.93.62 1.57c-.01.56-.19 1.08-.54 1.55c-.34.47-.76.92-1.27 1.36l-.64.52v.02h2.58v1.35Z"/>'
        },
        "format-superscript": {
            body: '<path fill="currentColor" d="M16 7.41L11.41 12L16 16.59L14.59 18L10 13.41L5.41 18L4 16.59L8.59 12L4 7.41L5.41 6L10 10.59L14.59 6L16 7.41M21.85 9h-4.88V8l.89-.82c.76-.64 1.32-1.18 1.7-1.63c.37-.44.56-.85.57-1.23a.884.884 0 0 0-.27-.7c-.18-.19-.47-.28-.86-.29c-.31.01-.58.07-.84.17l-.66.39l-.45-1.17c.27-.22.59-.39.98-.53S18.85 2 19.32 2c.78 0 1.38.2 1.78.61c.4.39.62.93.62 1.57c-.01.56-.19 1.08-.54 1.55c-.34.48-.76.93-1.27 1.36l-.64.52v.02h2.58V9Z"/>'
        },
        "format-text": {
            body: '<path fill="currentColor" d="m18.5 4l1.16 4.35l-.96.26c-.45-.87-.91-1.74-1.44-2.18C16.73 6 16.11 6 15.5 6H13v10.5c0 .5 0 1 .33 1.25c.34.25 1 .25 1.67.25v1H9v-1c.67 0 1.33 0 1.67-.25c.33-.25.33-.75.33-1.25V6H8.5c-.61 0-1.23 0-1.76.43c-.53.44-.99 1.31-1.44 2.18l-.96-.26L5.5 4h13Z"/>'
        },
        "format-text-rotation-angle-down": {
            body: '<path fill="currentColor" d="M14.25 21h-4.22l1.41-1.41l-8.86-8.86l1.45-1.4l8.81 8.86l1.41-1.41M12.61 8l2.62 2.64l2.2-4.87m1.98-.85l-4.46 11.11l-1.45-1.45l.89-2.2l-3.51-3.57l-2.2.94l-1.46-1.5l11.11-4.41Z"/>'
        },
        "format-text-rotation-angle-up": {
            body: '<path fill="currentColor" d="M20.58 9.33v4.22l-1.41-1.41L10.31 21l-1.4-1.41l8.81-8.86l-1.41-1.4M7.59 11l2.63-2.61l-4.88-2.25M4.5 4.22l11.11 4.41l-1.45 1.5l-2.2-.94l-3.57 3.56l.94 2.16l-1.5 1.5L3.42 5.25Z"/>'
        },
        "format-text-rotation-down": {
            body: '<path fill="currentColor" d="m6 19.73l-3-3h2V4.27h2v12.46h2l-3 3m8-10.35v3.75l5.03-1.88L14 9.38M21 12l-11 4.73v-2.06l2.19-.94V8.77L10 7.83V5.77l11 4.73V12Z"/>'
        },
        "format-text-rotation-down-vertical": {
            body: '<path fill="currentColor" d="M15.25 4h-1.5L9 15h2.1l.9-2.2h5l.9 2.2H20L15.25 4m-2.62 7l1.87-5l1.87 5h-3.74M5 17.5l3-3H6V2H4v12.5H2l3 3M22 20l-3-3v2H6.5v2H19v2l3-3Z"/>'
        },
        "format-text-rotation-none": {
            body: '<path fill="currentColor" d="m20.5 18l-3 3v-2H5v-2h12.5v-2l3 3m-10.37-8h3.75L12 4.97L10.13 10m2.62-7l4.75 11h-2.08l-.92-2.19h-5L8.58 14H6.5l4.75-11h1.5Z"/>'
        },
        "format-text-rotation-up": {
            body: '<path fill="currentColor" d="M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12m7 2.62l-5-1.87l5-1.87v3.74m8-10.37l-3 3h2v12.5h2V7.25h2l-3-3Z"/>'
        },
        "format-text-rotation-vertical": {
            body: '<path fill="currentColor" d="M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5m-2.62 7L15 7l1.87 5h-3.74M6 19.75l3-3H7V4.25H5v12.5H3l3 3Z"/>'
        },
        "format-text-variant": {
            body: '<path fill="currentColor" d="M9.6 14L12 7.7l2.4 6.3M11 5L5.5 19h2.2l1.1-3H15l1.1 3h2.2L13 5h-2Z"/>'
        },
        "format-text-variant-outline": {
            body: '<path fill="currentColor" d="M11 3c-.82 0-1.56.5-1.86 1.27l-5.5 14C3.12 19.58 4.09 21 5.5 21h2.25c.84 0 1.58-.5 1.87-1.3l.64-1.7h3.48l.64 1.7c.29.8 1.04 1.3 1.87 1.3h2.25c1.41 0 2.38-1.42 1.86-2.73l-5.5-14C14.56 3.5 13.82 3 13 3m-2 2h2l5.5 14h-2.25l-1.13-3H8.87l-1.12 3H5.5M12 7.67L9.62 14h4.75Z"/>'
        },
        "format-text-wrapping-clip": {
            body: '<path fill="currentColor" d="M7 21H5V3h2v18M17 3v8H9v2h8v8h2V3h-2Z"/>'
        },
        "format-text-wrapping-overflow": {
            body: '<path fill="currentColor" d="M7 21H5V3h2v18m7-18h-2v6h2V3m0 12h-2v6h2v-6m5-3l-3-3v2H9v2h7v2l3-3Z"/>'
        },
        "format-text-wrapping-wrap": {
            body: '<path fill="currentColor" d="M7 21H5V3h2v18M19 3h-2v18h2V3m-6 5H9v2h3.97c.17 0 1.03.16 1.03 2s-.86 2-1 2h-2v-2l-3 3l3 3v-2h2c1.04 0 3-.84 3-4s-1.96-4-3-4Z"/>'
        },
        "format-textbox": {
            body: '<path fill="currentColor" d="M21 7V3h-4v1H7V3H3v4h1v10H3v4h4v-1h10v1h4v-4h-1V7h1m-3-3h2v2h-2V4M4 4h2v2H4V4m2 16H4v-2h2v2m14 0h-2v-2h2v2m-2-3h-1v1H7v-1H6V7h1V6h10v1h1v10m-2-9v2h-3v6h-2v-6H8V8h8Z"/>'
        },
        "format-title": {
            body: '<path fill="currentColor" d="M5 4v3h5.5v12h3V7H19V4H5Z"/>'
        },
        "format-underline": {
            body: '<path fill="currentColor" d="M5 21h14v-2H5v2m7-4a6 6 0 0 0 6-6V3h-2.5v8a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8.5 11V3H6v8a6 6 0 0 0 6 6Z"/>'
        },
        "format-underline-wavy": {
            body: '<path fill="currentColor" d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6m8 5c-1.4 0-2.2-.7-2.7-1.3c-.5-.5-.7-.7-1.3-.7s-.8.2-1.3.7c-.5.6-1.3 1.3-2.7 1.3s-2.2-.7-2.7-1.3c-.5-.5-.7-.7-1.3-.7s-.8.2-1.3.7C6.2 21.3 5.4 22 4 22v-2c.6 0 .8-.2 1.3-.7c.5-.6 1.3-1.3 2.7-1.3s2.2.7 2.7 1.3c.5.5.7.7 1.3.7s.8-.2 1.3-.7c.5-.6 1.3-1.3 2.7-1.3s2.2.7 2.7 1.3c.5.5.7.7 1.3.7v2Z"/>'
        },
        "format-vertical-align-bottom": {
            body: '<path fill="currentColor" d="M16 13h-3V3h-2v10H8l4 4l4-4M4 19v2h16v-2H4Z"/>'
        },
        "format-vertical-align-center": {
            body: '<path fill="currentColor" d="M8 19h3v4h2v-4h3l-4-4l-4 4m8-14h-3V1h-2v4H8l4 4l4-4M4 11v2h16v-2H4Z"/>'
        },
        "format-vertical-align-top": {
            body: '<path fill="currentColor" d="M8 11h3v10h2V11h3l-4-4l-4 4M4 3v2h16V3H4Z"/>'
        },
        "format-wrap-inline": {
            body: '<path fill="currentColor" d="m8 7l5 10H3L8 7M3 3h18v2H3V3m18 12v2h-7v-2h7M3 19h18v2H3v-2Z"/>'
        },
        "format-wrap-square": {
            body: '<path fill="currentColor" d="m12 7l5 10H7l5-10M3 3h18v2H3V3m0 4h3v2H3V7m18 0v2h-3V7h3M3 11h3v2H3v-2m18 0v2h-3v-2h3M3 15h3v2H3v-2m18 0v2h-3v-2h3M3 19h18v2H3v-2Z"/>'
        },
        "format-wrap-tight": {
            body: '<path fill="currentColor" d="m12 7l5 10H7l5-10M3 3h18v2H3V3m0 4h6v2H3V7m18 0v2h-6V7h6M3 11h4v2H3v-2m18 0v2h-4v-2h4M3 15h3v2H3v-2m18 0v2h-3v-2h3M3 19h18v2H3v-2Z"/>'
        },
        "format-wrap-top-bottom": {
            body: '<path fill="currentColor" d="m12 7l5 10H7l5-10M3 3h18v2H3V3m0 16h18v2H3v-2Z"/>'
        },
        forum: {
            body: '<path fill="currentColor" d="M17 12V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14l4-4h10a1 1 0 0 0 1-1m4-6h-2v9H6v2a1 1 0 0 0 1 1h11l4 4V7a1 1 0 0 0-1-1Z"/>'
        },
        "forum-minus": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m6 15v2h-8v-2h8Z"/>'
        },
        "forum-minus-outline": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m-1 9H5.2L4 12.2V4h11v7m7 6v2h-8v-2h8Z"/>'
        },
        "forum-outline": {
            body: '<path fill="currentColor" d="M15 4v7H5.17L4 12.17V4h11m1-2H3a1 1 0 0 0-1 1v14l4-4h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m5 4h-2v9H6v2a1 1 0 0 0 1 1h11l4 4V7a1 1 0 0 0-1-1Z"/>'
        },
        "forum-plus": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m1 12h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "forum-plus-outline": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m-1 9H5.2L4 12.2V4h11v7m2 3h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "forum-remove": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m4.12 12.46l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.13Z"/>'
        },
        "forum-remove-outline": {
            body: '<path fill="currentColor" d="M21 6h-2v6.1c1.2.2 2.2.7 3 1.4V7c0-.5-.5-1-1-1M6 17c0 .5.5 1 1 1h5c0-1.1.3-2.1.8-3H6v2M16 2H3c-.5 0-1 .5-1 1v14l4-4h8.7c.7-.5 1.5-.8 2.3-.9V3c0-.5-.5-1-1-1m-1 9H5.2L4 12.2V4h11v7m5.12 3.46l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.13Z"/>'
        },
        forward: {
            body: '<path fill="currentColor" d="M12 8V4l8 8l-8 8v-4H4V8h8Z"/>'
        },
        forwardburger: {
            body: '<path fill="currentColor" d="M19 13H3v-2h16l-4-4l1.4-1.4l6.4 6.4l-6.4 6.4L15 17l4-4M3 6h10v2H3V6m10 10v2H3v-2h10Z"/>'
        },
        fountain: {
            body: '<path fill="currentColor" d="M7.5 2C4.47 2 2 4.46 2 7.5V8h2v-.5A3.5 3.5 0 0 1 7.5 4c1.5 0 2.76.93 3.26 2.24C10.37 6.08 9.95 6 9.5 6c-1.39 0-2.6.82-3.16 2l1.74 1c.21-.58.77-1 1.42-1A1.5 1.5 0 0 1 11 9.5V11h2V9.5A1.5 1.5 0 0 1 14.5 8c.66 0 1.21.42 1.42 1l1.74-1c-.56-1.18-1.76-2-3.16-2c-.45 0-.87.08-1.26.24C13.74 4.93 15 4 16.5 4A3.5 3.5 0 0 1 20 7.5V8h2v-.5A5.5 5.5 0 0 0 16.5 2c-1.86 0-3.5.93-4.5 2.34C11 2.93 9.36 2 7.5 2M6 12v2h1.42c.5 1.15 1.43 2.07 2.58 2.57V19H2s.82 1.23 1.41 2.11c.37.56.99.89 1.66.89h13.86c.67 0 1.29-.33 1.66-.89L22 19h-8v-2.43c1.15-.5 2.08-1.42 2.58-2.57H18v-2H6Z"/>'
        },
        "fountain-pen": {
            body: '<path fill="currentColor" d="m6.95 14.93l4.24-5.66l8.49-7.07c.39-.39 1.04-.39 1.41 0l.71.71c.39.37.39 1.02 0 1.41l-7.07 8.49l-5.66 4.24l-2.12-2.12m1.41 2.83l-2.12-2.12l-2.83 1.41L2 21.29l2.12-2.12c.2-.17.51-.17.71 0c.17.2.17.51 0 .71L2.71 22l4.24-1.41l1.41-2.83Z"/>'
        },
        "fountain-pen-tip": {
            body: '<path fill="currentColor" d="m15.54 3.5l4.96 4.97l-1.43 1.41l-4.95-4.95l1.42-1.43M3.5 19.78l6.5-6.47c-.1-.31-.03-.7.23-.96c.39-.39 1.03-.39 1.42 0c.39.4.39 1.03 0 1.42c-.26.26-.65.33-.96.23l-6.47 6.5l10.61-3.55l3.53-6.36l-4.94-4.95l-6.37 3.53L3.5 19.78Z"/>'
        },
        foursquare: {
            body: '<path d="M17 5l-.43 2.5c-.07.23-.37.5-.66.5H12c-.47 0-1.05.32-1.05.79v.41c0 .47.58.8 1.05.8h3.28c.33 0 .65.36.58.71c-.07.36-.92 2.57-.96 2.79c-.04.17-.26.5-.65.5h-2.88c-.52 0-.68.07-1.03.5c-.34.44-3.07 3.6-3.07 3.6c-.03.03-.27-.06-.27-.1V5c0-.3.61-1 1-1h8.5c.32 0 .58.61.5 1m0 9.45c.11-.48 1.78-7.73 2.22-9.9M17.58 2H6.91C5.43 2 5 3.11 5 3.8v16.96c0 .78.42 1.08.66 1.17c.24.1.89.18 1.28-.27c0 0 4.71-5.44 4.8-5.53c.13-.13.13-.13.26-.13h3.26c1.37 0 1.59-1 1.74-1.55c.11-.48 1.78-7.73 2.22-9.9c.34-1.66-.08-2.55-1.64-2.55z" fill="currentColor"/>',
            hidden: true
        },
        "fraction-one-half": {
            body: '<path fill="currentColor" d="m5.79 21.61l-1.58-1.22l14-18l1.58 1.22l-14 18M4 2v2h2v8h2V2H4m11 10v2h4v2h-2c-1.1 0-2 .9-2 2v4h6v-2h-4v-2h2c1.11 0 2-.89 2-2v-2a2 2 0 0 0-2-2h-4Z"/>'
        },
        freebsd: {
            body: '<path fill="currentColor" d="M2.69 2c.85-.05 3.39 1.16 3.44 1.19c-1.29.81-2.39 1.9-3.22 3.19C2.09 4.81 1.34 2.91 2 2.25c.17-.17.4-.25.69-.25m18.15.13c.41-.05.74.01.94.21c1.07 1.08-1.9 5.81-2.4 6.32c-.51.5-1.81.04-2.88-1.03c-1.07-1.08-1.53-2.37-1.03-2.88c.41-.41 3.62-2.45 5.37-2.62M12 2.56c1.29 0 2.53.26 3.66.72c-.49.32-.85.57-.97.69c-.99.99-.55 2.86 1.03 4.44c.98.97 2.12 1.56 3.06 1.56c.68 0 1.14-.29 1.38-.53c.17-.17.44-.56.75-1.03c.51 1.18.78 2.47.78 3.84c0 5.36-4.33 9.72-9.69 9.72c-5.36 0-9.69-4.36-9.69-9.72A9.68 9.68 0 0 1 12 2.56Z"/>'
        },
        "french-fries": {
            body: '<path fill="currentColor" d="M18 11V6h-3V4h-3V2H8v3H6v6H5l2 11h10l2-11h-1m-2.14 0c-.16.61-.46 1.16-.86 1.62v-4l2 1V11h-1.14M17 7v1.5l-2-1V7h2m-5-2h2v3.5l-2 1V5m0 5.62l2-1v3.83c-.59.35-1.27.55-2 .55v-3.38m-1 3.24c-.79-.21-1.5-.64-2-1.24v-3l2-1v5.24M9 3h2v4.5L10 8V5H9V3M7 6h2v2.5L8 9v2H7V6Z"/>'
        },
        "frequently-asked-questions": {
            body: '<path fill="currentColor" d="M18 15H6l-4 4V3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m5-6v14l-4-4H8a1 1 0 0 1-1-1v-1h14V8h1a1 1 0 0 1 1 1M8.19 4c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91C7.11 9.08 7 9.5 7 10h2c0-.31.04-.56.13-.74c.09-.18.26-.36.51-.52c.45-.24.82-.53 1.11-.93c.29-.4.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82C9.85 4.23 9.12 4 8.19 4M7 11v2h2v-2H7m6 2h2v-2h-2v2m0-9v6h2V4h-2Z"/>'
        },
        fridge: {
            body: '<path fill="currentColor" d="M7 2h10a2 2 0 0 1 2 2v5H5V4a2 2 0 0 1 2-2m12 17a2 2 0 0 1-2 2v1h-2v-1H9v1H7v-1a2 2 0 0 1-2-2v-9h14v9M8 5v2h2V5H8m0 7v3h2v-3H8Z"/>'
        },
        "fridge-alert": {
            body: '<path fill="currentColor" d="M5 2h10a2 2 0 0 1 2 2v5H3V4c0-1.1.9-2 2-2m12 17c0 1.11-.89 2-2 2v1h-2v-1H7v1H5v-1a2 2 0 0 1-2-2v-9h14v9M6 5v2h2V5H6m0 7v3h2v-3H6m13 3h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "fridge-alert-outline": {
            body: '<path fill="currentColor" d="M7 21v1H5v-1a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v15c0 1.11-.89 2-2 2v1h-2v-1H7M5 4v5h10V4H5m0 15h10v-8H5v8m1-7h2v3H6v-3m0-6h2v2H6V6m13 9h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "fridge-bottom": {
            body: '<path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7m1 4h2v2H8V6m-1 5h10v8H7v-8m1 1v3h2v-3H8Z"/>'
        },
        "fridge-industrial": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-7 13H8v-5h2v5Z"/>'
        },
        "fridge-industrial-alert": {
            body: '<path fill="currentColor" d="M15 2H5c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M8 15H6v-5h2v5m13-8v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "fridge-industrial-alert-outline": {
            body: '<path fill="currentColor" d="M8 15H6v-5h2v5m9-11v15c0 1.11-.89 2-2 2v1h-2v-1H7v1H5v-1a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2m-2 0H5v15h10V4m4 13h2v-2h-2v2m0-10v6h2V7h-2Z"/>'
        },
        "fridge-industrial-off": {
            body: '<path fill="currentColor" d="M19 15.8L5.7 2.5c.35-.31.8-.5 1.3-.5h10a2 2 0 0 1 2 2v11.8m3.11 5.66l-1.27 1.27l-2.38-2.38c-.36.4-.88.65-1.46.65v1h-2v-1H9v1H7v-1a2 2 0 0 1-2-2V6.89L1.11 3l1.28-1.27l19.72 19.73M10 11.89L8.11 10H8v5h2v-3.11Z"/>'
        },
        "fridge-industrial-off-outline": {
            body: '<path fill="currentColor" d="M7.2 4L5.7 2.5c.35-.31.8-.5 1.3-.5h10a2 2 0 0 1 2 2v11.8l-2-2V4H7.2m14.91 17.46l-1.27 1.27l-2.38-2.38c-.36.4-.88.65-1.46.65v1h-2v-1H9v1H7v-1a2 2 0 0 1-2-2V6.89L1.11 3l1.28-1.27l19.72 19.73M17 18.89l-7-7V15H8v-5h.11L7 8.89V19h10v-.11Z"/>'
        },
        "fridge-industrial-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 17H7V4h10v15m-7-4H8v-5h2v5Z"/>'
        },
        "fridge-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L5 6.89V9h2.11l1 1H5v9a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c.58 0 1.1-.25 1.46-.65l2.38 2.38l1.27-1.27M10 15H8v-3h2v3m9 .8L13.2 10H19v5.8M8.2 5L5.7 2.5c.35-.31.8-.5 1.3-.5h10a2 2 0 0 1 2 2v5h-6.8L10 6.8V5H8.2Z"/>'
        },
        "fridge-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L5 6.89V19a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c.58 0 1.1-.25 1.46-.65l2.38 2.38l1.27-1.27M17 19H7v-8h2.11L17 18.89V19M7.2 4L5.7 2.5c.35-.31.8-.5 1.3-.5h10a2 2 0 0 1 2 2v11.8l-2-2V11h-2.8l-2-2H17V4H7.2m.8 8h2v3H8v-3Z"/>'
        },
        "fridge-outline": {
            body: '<path fill="currentColor" d="M9 21v1H7v-1a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2v1h-2v-1H9M7 4v5h10V4H7m0 15h10v-8H7v8m1-7h2v3H8v-3m0-6h2v2H8V6Z"/>'
        },
        "fridge-top": {
            body: '<path fill="currentColor" d="M8 8V6h2v2H8M7 2h10a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2v1h-2v-1H9v1H7v-1a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v5h10V4H7m1 8v3h2v-3H8Z"/>'
        },
        "fridge-variant": {
            body: '<path fill="currentColor" d="M19 4v15c0 1.11-.89 2-2 2v1h-2v-1h-2.5V2H17a2 2 0 0 1 2 2M7 2h4.5v19H9v1H7v-1a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m3 8H7v4h3v-4Z"/>'
        },
        "fridge-variant-alert": {
            body: '<path fill="currentColor" d="M17 4v15c0 1.11-.89 2-2 2v1h-2v-1h-2.5V2H15a2 2 0 0 1 2 2M5 2h4.5v19H7v1H5v-1a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m3 8H5v4h3v-4m11-3v6h2V7h-2m0 10h2v-2h-2v2Z"/>'
        },
        "fridge-variant-alert-outline": {
            body: '<path fill="currentColor" d="M15 2H5c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M9 19H5v-5h3v-4H5V4h4v15m6 0h-4V4h4v15m4-4h2v2h-2v-2m2-8v6h-2V7h2Z"/>'
        },
        "fridge-variant-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3L5 6.89V19a2 2 0 0 0 2 2v1h2v-1h2.5v-7.61l1 1V21H15v1h2v-1c.58 0 1.1-.25 1.46-.65l2.38 2.38l1.27-1.27L2.39 1.73M10 14H7v-4h1.11L10 11.89V14m9 1.8l-6.5-6.5V2H17a2 2 0 0 1 2 2v11.8m-7.5-7.5L5.7 2.5c.35-.31.8-.5 1.3-.5h4.5v6.3Z"/>'
        },
        "fridge-variant-off-outline": {
            body: '<path fill="currentColor" d="M7.2 4L5.7 2.5c.35-.31.8-.5 1.3-.5h10a2 2 0 0 1 2 2v11.8l-2-2V4h-4v5.8l-2-2V4H7.2m14.91 17.46l-1.27 1.27l-2.38-2.38c-.36.4-.88.65-1.46.65v1h-2v-1H9v1H7v-1a2 2 0 0 1-2-2V6.89L1.11 3l1.28-1.27l19.72 19.73M7 10h1.11L7 8.89V10m4 2.89l-1-1V14H7v5h4v-6.11m6 6l-4-4V19h4v-.11Z"/>'
        },
        "fridge-variant-outline": {
            body: '<path fill="currentColor" d="M17 2H7c-1.1 0-2 .9-2 2v15a2 2 0 0 0 2 2v1h2v-1h6v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M7 19v-5h3v-4H7V4h4v15H7m10 0h-4V4h4v15Z"/>'
        },
        "fruit-cherries": {
            body: '<path fill="currentColor" d="M16 13h-.5c-.7-1.3-1.2-3-1.7-4.7l.9.9c2.7 2.1 5.1 1.7 5.1 1.7s.7-3.8-2-5.8c-2.3-1.8-4.4-1.8-5-1.7c-.1-.6-.1-1.1-.2-1.5l-1.4.1c0 3.2-2.7 9.1-3.6 11c-2 .2-3.6 1.9-3.6 4c0 2.2 1.8 4 4 4c1.1 0 2-.4 2.7-1.1c-.4-.9-.7-1.9-.7-2.9s.3-2 .7-2.9c-.4-.4-1-.7-1.5-.9c.7-1.5 1.9-4.2 2.7-6.8c.4 2.3 1.2 5 2.2 7.1c-1.2.7-2.1 2-2.1 3.5c0 2.2 1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m-8 2.5c-.8 0-1.5.7-1.5 1.5h-1c0-1.4 1.1-2.5 2.5-2.5v1m8 0c-.8 0-1.5.7-1.5 1.5h-1c0-1.4 1.1-2.5 2.5-2.5v1Z"/>'
        },
        "fruit-cherries-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l7.6 7.6c-.4 1-.8 1.9-1.1 2.4c-2 .2-3.6 1.9-3.6 4c0 2.2 1.8 4 4 4c1.1 0 2-.4 2.7-1.1c-.4-.9-.7-1.9-.7-2.9s.3-2 .7-2.9c-.4-.4-1-.7-1.5-.9c.2-.4.4-.9.7-1.5l2.9 2.9c-.5.7-.8 1.5-.8 2.4c0 2.2 1.8 4 4 4c.9 0 1.7-.3 2.3-.8l2.5 2.5l1.3-1.2M8 15.5c-.8 0-1.5.7-1.5 1.5h-1c0-1.4 1.1-2.5 2.5-2.5v1m6.5 1.5h-1c0-.5.1-.9.3-1.3l.8.8c-.1.2-.1.3-.1.5m5.5-.2L16.2 13c2 .1 3.7 1.8 3.8 3.8m-8.7-8.7l-1.2-1.2c.6-1.8 1.1-3.6 1.1-4.9l1.4-.1c.1.4.1.9.2 1.5c.6-.1 2.7-.1 5 1.7c2.7 2 2 5.8 2 5.8s-2.4.4-5.1-1.7l-.9-.9c.3 1.2.7 2.4 1.1 3.4l-2.3-2.3c-.3-1-.5-2-.7-3c-.2.6-.4 1.2-.6 1.7Z"/>'
        },
        "fruit-citrus": {
            body: '<path fill="currentColor" d="M9 15.9c-2.1-.2-3.9-1-5-2.3c-.8 0-1.6-.5-1.9-1.3c-.3-.8 0-1.6.7-2.1c.1-3 2.8-6.1 6.9-7.5C13.8 1.3 18 2.1 20 4.4c.8 0 1.6.5 1.9 1.3c.3.8 0 1.6-.7 2.1c0 .8-.2 1.6-.6 2.4C19.4 9.5 18 9 16.5 9c-3.9 0-7.2 3-7.5 6.9m13 .6c0 3-2.5 5.5-5.5 5.5S11 19.5 11 16.5s2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5M13.3 18l2.3-1.5l-2.3-1.5c-.2.5-.3 1-.3 1.5s.1 1 .3 1.5m2.7-.6l-2.1 1.4c.5.6 1.3 1 2.1 1.2v-2.6m0-4.3c-.8.1-1.6.5-2.1 1.2l2.1 1.4v-2.6m1 2.5l2.1-1.4c-.5-.6-1.3-1-2.1-1.2v2.6m2.1 3.2L17 17.4v2.5c.8-.1 1.6-.5 2.1-1.1m.9-2.3c0-.5-.1-1-.3-1.5l-2.3 1.5l2.3 1.5c.2-.5.3-1 .3-1.5Z"/>'
        },
        "fruit-citrus-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3.3 3.3c-1 1.2-1.5 2.6-1.6 3.9c-.7.5-1 1.3-.7 2.1c.3.8 1.1 1.3 1.9 1.3c1.1 1.3 2.9 2.1 5 2.3c.1-1.4.6-2.6 1.3-3.7l1.5 1.5c-.5.8-.8 1.8-.8 2.8c0 3 2.5 5.5 5.5 5.5c1 0 2-.3 2.8-.8l1.5 1.5l1.3-1.2m-9.1-5c0-.5.1-.9.3-1.4l1.7 1.7l-1.7 1.2c-.2-.5-.3-1-.3-1.5m.9 2.3l1.8-1.2l.3.3V20c-.8-.2-1.6-.6-2.1-1.2m3.1 1.1v-1l.8.8c-.3.1-.5.2-.8.2m3-3.1v-.3c0-.5-.1-1-.3-1.5l-.9.6l-.7-.7l1-.7c-.5-.6-1.3-1-2.1-1.2v.8l-2.4-2.4c.6-.2 1.3-.4 1.9-.4c3 0 5.5 2.5 5.5 5.5c0 .7-.1 1.3-.4 1.9L20 16.8m-7-7L7.1 3.9c.8-.5 1.7-.9 2.6-1.2C13.8 1.3 18 2.1 20 4.4c.8 0 1.6.5 1.9 1.3c.3.8 0 1.6-.7 2.1c0 .8-.2 1.6-.6 2.4C19.4 9.5 18 9 16.5 9c-1.2 0-2.4.3-3.5.8Z"/>'
        },
        "fruit-grapes": {
            body: '<path fill="currentColor" d="M14 12c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m-7-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-2.5-4c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-5 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m5 8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-5 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m2.5 4c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m2.4-15.8L13.6 1c-2.2 1-2.4 4.6-2.4 5h1.5c.1-.8.4-3.3 1.7-3.8Z"/>'
        },
        "fruit-grapes-outline": {
            body: '<path fill="currentColor" d="M19 12c0-1.39-.95-2.53-2.22-2.88A2.996 2.996 0 0 0 14 5c-.43 0-.83.1-1.19.26c.19-1.07.58-2.67 1.59-3.06L13.6 1c-1.7.77-2.2 3.09-2.34 4.29C10.87 5.11 10.45 5 10 5a2.996 2.996 0 0 0-2.78 4.12C5.94 9.46 5 10.62 5 12c0 1.39.95 2.54 2.23 2.88c-.14.34-.23.72-.23 1.12c0 1.39.94 2.54 2.22 2.88A2.996 2.996 0 0 0 12 23a2.996 2.996 0 0 0 2.78-4.12A2.974 2.974 0 0 0 17 16c0-.4-.08-.77-.23-1.12A2.982 2.982 0 0 0 19 12m-2.69-2.12v.02h-.01l.01-.02M14 6.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m-.5 5.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5M10 6.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S8.5 8.83 8.5 8s.67-1.5 1.5-1.5M6.5 12c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m2 4c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m3.5 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m2-4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m2-4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"/>'
        },
        "fruit-pear": {
            body: '<path fill="currentColor" d="M18 16c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-3 2-3 2-6c0-1.44.75-2.78 2-3.5c.4-.23.82-.38 1.25-.46V5c0-.37-.08-.58-.22-.72C10.9 4.14 10.63 4 10 4V2.5c.88 0 1.6.23 2.09.72c.49.49.66 1.16.66 1.78v1.04c.43.08.86.23 1.25.46c1.25.72 2 2.06 2 3.5c0 3 2 3 2 6Z"/>'
        },
        "fruit-pineapple": {
            body: '<path fill="currentColor" d="M14.4 7.7C16.4 6.4 19 7 19 7c-1.8-2.4-3.9-2.3-5.4-1.8V5c1.1-1.6 3.3-1.5 3.3-1.5c-1.6-1.4-3-1-3.9-.5c-.5-1.2-1-2-1-2c-.4.7-.7 1.4-1 2.1c-.9-.6-2.4-1-4 .4c0 0 2.3 0 3.4 1.7C8.9 4.7 6.8 4.6 5 7c0 0 2.6-.6 4.6.7C7.5 8.9 6 11.7 6 15c0 4.4 2.7 8 6 8s6-3.6 6-8c0-3.3-1.5-6.1-3.6-7.3m1.4 9.1c-.1.4-.2.8-.4 1.2L14 16l-1.5 2l1.6 2.1c-.3.2-.5.4-.8.6L12 19l-1.3 1.7c-.3-.1-.6-.3-.8-.6l1.6-2.1l-1.5-2l-1.5 1.9c-.1-.4-.3-.8-.4-1.2L9.5 15l-1.3-1.8c.1-.4.2-.8.4-1.2l1.4 2l1.5-2l-1.6-2.1c.3-.2.5-.4.8-.6L12 11l1.3-1.7c.3.1.6.3.8.6L12.5 12l1.5 2l1.5-1.9c.1.4.3.8.4 1.2L14.5 15l1.3 1.8M12 13l1.5 2l-1.5 2l-1.5-2l1.5-2Z"/>'
        },
        "fruit-watermelon": {
            body: '<path fill="currentColor" d="M16.4 16.4c3.4-3.4 3.4-8.9 0-12.2L4.2 16.4c3.3 3.4 8.8 3.4 12.2 0M16 7c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m0 4c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m-4 0c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m0 4c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m-4 2c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m10.6 1.6c-4.6 4.6-12 4.6-16.6 0l1.4-1.4c3.8 3.8 9.9 3.8 13.7 0c3.8-3.8 3.8-9.9 0-13.7L18.6 2c4.5 4.6 4.5 12 0 16.6Z"/>'
        },
        fuel: {
            body: '<path fill="currentColor" d="M3 2h3c.28 0 .53.11.71.29l2.08 2.09l.8-.79C10 3.2 10.5 3 11 3h6c.5 0 1 .2 1.41.59l1 1C19.8 5 20 5.5 20 6v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8c0-.5.2-1 .59-1.41l.79-.8L5.59 4H3V2m8 3v2h6V5h-6m.41 6l-2-2H8v1.41l2 2v3.18l-2 2V19h1.41l2-2h3.18l2 2H18v-1.41l-2-2v-3.18l2-2V9h-1.41l-2 2h-3.18m.59 2h2v2h-2v-2Z"/>'
        },
        "fuel-cell": {
            body: '<path fill="currentColor" d="M6 3v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-1h6v1c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-1c1.1 0 2-.9 2-2H11V5H8V3H6m10 0v2h-3v2h9c0-1.1-.9-2-2-2h-2V3h-2M7 7v4h2l-3 6v-4H4l3-6m6 2v2h9V9h-9m0 4v2h9v-2h-9Z"/>'
        },
        fullscreen: {
            body: '<path fill="currentColor" d="M5 5h5v2H7v3H5V5m9 0h5v5h-2V7h-3V5m3 9h2v5h-5v-2h3v-3m-7 3v2H5v-5h2v3h3Z"/>'
        },
        "fullscreen-exit": {
            body: '<path fill="currentColor" d="M14 14h5v2h-3v3h-2v-5m-9 0h5v5H8v-3H5v-2m3-9h2v5H5V8h3V5m11 3v2h-5V5h2v3h3Z"/>'
        },
        function: {
            body: '<path fill="currentColor" d="M15.6 5.29c-1.1-.1-2.07.71-2.17 1.82L13.18 10H16v2h-3l-.44 5.07a3.986 3.986 0 0 1-4.33 3.63a4.007 4.007 0 0 1-3.06-1.87l1.5-1.5c.24.74.9 1.31 1.73 1.38c1.1.1 2.07-.71 2.17-1.82L11 12H8v-2h3.17l.27-3.07c.19-2.2 2.13-3.83 4.33-3.63c1.31.11 2.41.84 3.06 1.87l-1.5 1.5c-.24-.74-.9-1.31-1.73-1.38Z"/>'
        },
        "function-variant": {
            body: '<path fill="currentColor" d="M12.42 5.29c-1.1-.1-2.07.71-2.17 1.82L10 10h2.82v2h-3l-.44 5.07A4.001 4.001 0 0 1 2 18.83l1.5-1.5c.33 1.05 1.46 1.64 2.5 1.3c.78-.24 1.33-.93 1.4-1.74L7.82 12h-3v-2H8l.27-3.07a4.01 4.01 0 0 1 4.33-3.65c1.26.11 2.4.81 3.06 1.89l-1.5 1.5c-.25-.77-.93-1.31-1.74-1.38M22 13.65l-1.41-1.41l-2.83 2.83l-2.83-2.83l-1.43 1.41l2.85 2.85l-2.85 2.81l1.43 1.41l2.83-2.83l2.83 2.83L22 19.31l-2.83-2.81L22 13.65Z"/>'
        },
        "furigana-horizontal": {
            body: '<path fill="currentColor" d="M8.5 2a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5m7 0a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5M11 8v2H5v2h9.95c-.42 1.13-1.45 2.5-2.79 3.67c-1.04-.93-1.81-1.85-2.34-2.67H7.5c.58 1.25 1.63 2.62 3.12 3.96l-4.07 3.26l-.79.62L7 22.41l.8-.63l4.37-3.5l4.38 3.5l.78.63l1.25-1.57l-.78-.62l-4.07-3.25c1.61-1.47 2.97-3.12 3.34-4.97H19v-2h-6V8h-2Z"/>'
        },
        "furigana-vertical": {
            body: '<path fill="currentColor" d="M8 5v2H2v2h9.95c-.42 1.13-1.45 2.5-2.79 3.67c-1.04-.93-1.81-1.85-2.34-2.67H4.5c.58 1.25 1.63 2.62 3.12 3.96l-4.07 3.26l-.79.62L4 19.41l.8-.63l4.37-3.5l4.38 3.5l.78.63l1.25-1.57l-.78-.62l-4.07-3.25c1.61-1.47 2.97-3.12 3.34-4.97H16V7h-6V5H8m11.5 1a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5m-.03 7a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5Z"/>'
        },
        fuse: {
            body: '<path fill="currentColor" d="M8 7v10h7V7H8m3.16 9v-3.13H9.41L11.91 8v3.14h1.68L11.16 16M16 2v4H7V2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1m0 16v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4h9Z"/>'
        },
        "fuse-alert": {
            body: '<path fill="currentColor" d="M6 7v10h7V7H6m3.16 9v-3.13H7.41L9.91 8v3.14h1.68L9.16 16M14 2v4H5V2c0-.55.45-1 1-1h7c.55 0 1 .45 1 1m0 16v4c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4h9m5-5h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "fuse-blade": {
            body: '<path fill="currentColor" d="M10 21H8l-2-2v-3h4v5m8-5h-4v5h2l2-2v-3M3 3v1a1 1 0 0 0 1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0 1-1V3H3m8.83 10V9.73H10l2.61-5.07v3.27h1.75L11.83 13Z"/>'
        },
        "fuse-off": {
            body: '<path fill="currentColor" d="M15 11.8L10.2 7H15v4.8M16 6V2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1.8L9.2 6H16M2.39 1.73L1.11 3L8 9.89V17h7.11l5.73 5.73l1.27-1.27L2.39 1.73M7 22c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4H7v4Z"/>'
        },
        gamepad: {
            body: '<path fill="currentColor" d="m16.5 9l-3 3l3 3H22V9M9 16.5V22h6v-5.5l-3-3M7.5 9H2v6h5.5l3-3M15 7.5V2H9v5.5l3 3l3-3Z"/>'
        },
        "gamepad-circle": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        "gamepad-circle-down": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m-7-5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m14 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "gamepad-circle-left": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0-14a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "gamepad-circle-outline": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m7-9a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 12a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m7-9a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "gamepad-circle-right": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m-7-5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "gamepad-circle-up": {
            body: '<path fill="currentColor" d="M5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m7-7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4M5 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m14 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-7 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "gamepad-down": {
            body: '<path fill="currentColor" d="M9 2v5.5l3 3l3-3V2H9M2 9v6h5.5l3-3l-3-3H2m14.5 0l-3 3l3 3H22V9h-5.5M12 13.5l-3 3V22h6v-5.5l-3-3M11 18h2v2h-2v-2Z"/>'
        },
        "gamepad-left": {
            body: '<path fill="currentColor" d="M9 2v5.5l3 3l3-3V2H9M2 9v6h5.5l3-3l-3-3H2m14.5 0l-3 3l3 3H22V9h-5.5M4 11h2v2H4v-2m8 2.5l-3 3V22h6v-5.5l-3-3Z"/>'
        },
        "gamepad-outline": {
            body: '<path fill="currentColor" d="M7.5 9H2v6h5.5l3-3l-3-3M6 13H4v-2h2v2m9-5.5V2H9v5.5l3 3l3-3M11 4h2v2h-2V4M9 16.5V22h6v-5.5l-3-3l-3 3m4 3.5h-2v-2h2v2m3.5-11l-3 3l3 3H22V9h-5.5m3.5 4h-2v-2h2v2Z"/>'
        },
        "gamepad-right": {
            body: '<path fill="currentColor" d="M9 2v5.5l3 3l3-3V2H9M2 9v6h5.5l3-3l-3-3H2m14.5 0l-3 3l3 3H22V9h-5.5m1.5 2h2v2h-2v-2m-6 2.5l-3 3V22h6v-5.5l-3-3Z"/>'
        },
        "gamepad-round": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Z"/>'
        },
        "gamepad-round-down": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6 8v4h4v-4h-4Z"/>'
        },
        "gamepad-round-left": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 2v4h4v-4H4Z"/>'
        },
        "gamepad-round-outline": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 2v4h6v6h4v-6h6v-4h-6V4h-4v6H4Z"/>'
        },
        "gamepad-round-right": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m12 2v4h4v-4h-4Z"/>'
        },
        "gamepad-round-up": {
            body: '<path fill="currentColor" d="M4 8h4V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m6-4v4h4V4h-4Z"/>'
        },
        "gamepad-square": {
            body: '<path fill="currentColor" d="M21 6H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-10 7H8v3H6v-3H3v-2h3V8h2v3h3m4.5 4a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m4-3a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 19.5 9a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "gamepad-square-outline": {
            body: '<path fill="currentColor" d="M21 6H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 10H3V8h18M6 15h2v-2h2v-2H8V9H6v2H4v2h2m8.5-1a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m4-3a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 18.5 9Z"/>'
        },
        "gamepad-up": {
            body: '<path fill="currentColor" d="M9 2v5.5l3 3l3-3V2H9m2 2h2v2h-2V4M2 9v6h5.5l3-3l-3-3H2m14.5 0l-3 3l3 3H22V9h-5.5M12 13.5l-3 3V22h6v-5.5l-3-3Z"/>'
        },
        "gamepad-variant": {
            body: '<path fill="currentColor" d="M7 6h10a6 6 0 0 1 6 6a6 6 0 0 1-6 6c-1.78 0-3.37-.77-4.47-2h-1.06c-1.1 1.23-2.69 2-4.47 2a6 6 0 0 1-6-6a6 6 0 0 1 6-6M6 9v2H4v2h2v2h2v-2h2v-2H8V9H6m9.5 3a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m3-3a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 18.5 9Z"/>'
        },
        "gamepad-variant-outline": {
            body: '<path fill="currentColor" d="M6 9h2v2h2v2H8v2H6v-2H4v-2h2V9m12.5 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 18.5 9m-3 3a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5M17 5a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.96 0-3.73-.8-5-2.1A6.96 6.96 0 0 1 7 19a7 7 0 0 1-7-7a7 7 0 0 1 7-7h10M7 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5c1.64 0 3.09-.79 4-2h2c.91 1.21 2.36 2 4 2a5 5 0 0 0 5-5a5 5 0 0 0-5-5H7Z"/>'
        },
        gamma: {
            body: '<path fill="currentColor" d="M11.76 19c1.16 0 1.82-1 1.82-2.71c0-1.09-.08-2.41-.28-3.62L18 5h-2.72l-2.57 4.82l-.16-.49C11.83 7.19 10.82 5 8.68 5C8 5 7.45 5.18 7 5.54C6 6.39 6 8 6 8.5h.91c.06-.44.3-1.67 1.34-1.67c1.75 0 2.55 3.17 3.15 5.59c-.9 2.16-1.4 3.72-1.4 4.55c0 .98.56 2.03 1.76 2.03"/>'
        },
        "gantry-crane": {
            body: '<path fill="currentColor" d="M21 6h1V4h-1V3h-3v1H6V3H3v1H2v2h1v14H2v2h5v-2H6V6h5v1h.5v3.62c-.5.17-.81.63-.81 1.14c0 .44.23.84.61 1.06V14h.62c.34 0 .62.27.63.61c0 .35-.27.63-.62.63a.63.63 0 0 1-.54-.31a.618.618 0 0 0-1.07.62c.33.57.94.92 1.6.92c1.02-.01 1.84-.85 1.83-1.87c-.01-.77-.49-1.46-1.22-1.72v-.06c.59-.32.81-1.04.5-1.62c-.11-.2-.29-.39-.5-.5V7H13V6h5v14h-1v2h5v-2h-1V6M5 15.29v1.42l-1 1v-1.42l1-1M4 20v-.76l1-1v1.42l-.34.34H4M4 7.29l1-1v1.42l-1 1V7.29m0 3l1-1v1.42l-1 1v-1.42m0 3l1-1v1.42l-1 1v-1.47v.05m16 2v1.42l-1 1v-1.42l1-1M19 20v-.76l1-1v1.42l-.34.34H19m0-12.71l1-1v1.42l-1 1V7.29m0 3l1-1v1.42l-1 1v-1.42m0 3l1-1v1.42l-1 1v-1.47v.05Z"/>'
        },
        garage: {
            body: '<path fill="currentColor" d="M19 20h-2v-9H7v9H5V9l7-4l7 4v11M8 12h8v2H8v-2m0 3h8v2H8v-2m8 3v2H8v-2h8Z"/>'
        },
        "garage-alert": {
            body: '<path fill="currentColor" d="M17 20h-2v-9H5v9H3V9l7-4l7 4v11M6 12h8v2H6v-2m0 3h8v2H6v-2m13 0v-5h2v5h-2m0 4v-2h2v2h-2Z"/>'
        },
        "garage-alert-variant": {
            body: '<path fill="currentColor" d="M20 9v11h-2v-9H2v9H0V9l10-4l10 4m-3 3H3v2h14v-2m0 3H3v2h14v-2m5 0v-5h2v5h-2m0 4v-2h2v2h-2Z"/>'
        },
        "garage-lock": {
            body: '<path fill="currentColor" d="M20.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16M5 12h8v2H5v-2m0 3h7.95c-.53.54-.87 1.24-.95 2H5v-2m7 5H5v-2h7v2m2-9H4v9H2V9l7-4l7 4v1.44c-.81.36-1.5.92-2 1.62V11Z"/>'
        },
        "garage-open": {
            body: '<path fill="currentColor" d="M19 20h-2v-9H7v9H5V9l7-4l7 4v11M8 12h8v2H8v-2Z"/>'
        },
        "garage-open-variant": {
            body: '<path fill="currentColor" d="M22 9v11h-2v-9H4v9H2V9l10-4l10 4m-3 3H5v2h14v-2Z"/>'
        },
        "garage-variant": {
            body: '<path fill="currentColor" d="M22 9v11h-2v-9H4v9H2V9l10-4l10 4m-3 3H5v2h14v-2m0 6H5v2h14v-2m0-3H5v2h14v-2Z"/>'
        },
        "garage-variant-lock": {
            body: '<path fill="currentColor" d="M21.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16M5 12h10.04c-.43.59-.69 1.27-.78 2H5v-2m11.06-1H4v9H2V9l10-4l10 4v2.04A4.911 4.911 0 0 0 19 10c-1.1 0-2.12.39-2.94 1M13 20H5v-2h8v2m-8-5h8.95c-.53.54-.87 1.24-.95 2H5v-2Z"/>'
        },
        "gas-burner": {
            body: '<path fill="currentColor" d="m16.14 8.79l-.02.01c.23.27.43.59.58.92l.09.19c.71 1.69.21 3.64-1.1 4.86c-1.19 1.09-2.85 1.38-4.39 1.18c-1.46-.18-2.8-1.1-3.57-2.37c-.23-.39-.43-.83-.53-1.28c-.13-.37-.17-.73-.2-1.1c-.09-1.6.55-3.3 1.76-4.3c-.55 1.21-.42 2.72.39 3.77l.11.13c.14.12.31.16.47.09c.15-.06.27-.21.27-.39l-.07-.22c-.88-2.32-.14-5.03 1.73-6.56c.51-.42 1.14-.8 1.8-.97c-.68 1.36-.46 3.14.63 4.21c.46.47 1.01.78 1.49 1.22l.56.61m-2.28 4.64l-.01-.01c.45-.39.7-1.06.68-1.66l-.03-.32c-.2-1-1.07-1.33-1.63-2.06c-.17-.22-.32-.5-.43-.78c-.22.5-.24.97-.15 1.51c.1.57.33 1.06.21 1.65c-.16.65-.67 1.3-1.56 1.51c.5.49 1.31.88 2.12.6c.26-.07.59-.26.8-.44M11 18v1c0 .55.45 1 1 1s1-.45 1-1v-1h2v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.11 0 3 .9 3 2v2H4v-2c0-1.1 1.9-2 3-2v1c0 .55.45 1 1 1s1-.45 1-1v-1h2Z"/>'
        },
        "gas-cylinder": {
            body: '<path fill="currentColor" d="M16 9v11a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9c0-1.86 1.27-3.43 3-3.87V4H9V2h6v2h-2v1.13c1.73.44 3 2.01 3 3.87Z"/>'
        },
        "gas-station": {
            body: '<path fill="currentColor" d="M18 10a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m-6 0H6V5h6m7.77 2.23l.01-.01l-3.72-3.72L15 4.56l2.11 2.11C16.17 7 15.5 7.93 15.5 9a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21a1 1 0 0 1-1 1a1 1 0 0 1-1-1V14a2 2 0 0 0-2-2h-1V5a2 2 0 0 0-2-2H6c-1.11 0-2 .89-2 2v16h10v-7.5h1.5v5A2.5 2.5 0 0 0 18 21a2.5 2.5 0 0 0 2.5-2.5V9c0-.69-.28-1.32-.73-1.77Z"/>'
        },
        "gas-station-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L21 21.72L19.73 23l-2.02-2a2.568 2.568 0 0 1-2.21-2.22L14 17.27V21H4V7.27l-3-3M18 10c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m-6 0V5H6.82L5.06 3.23c.28-.15.6-.23.94-.23h6a2 2 0 0 1 2 2v7h1a2 2 0 0 1 2 2v1.18L11.82 10H12m-6 0h.73L6 9.27V10m13.77-2.77c.45.45.73 1.08.73 1.77v9.67L19 17.18v-5.89c-.31.13-.64.21-1 .21A2.5 2.5 0 0 1 15.5 9c0-1.07.67-1.97 1.61-2.33L15 4.56l1.06-1.06l3.72 3.72l-.01.01Z"/>'
        },
        "gas-station-off-outline": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L6 6.72l15 15L19.73 23l-2.01-2a2.568 2.568 0 0 1-2.22-2.22L14 17.27V21H4V7.27l-3-3m18.77 2.96c.45.45.73 1.08.73 1.77v9.67L19 17.18v-5.89c-.31.13-.64.21-1 .21A2.5 2.5 0 0 1 15.5 9c0-1.07.67-1.97 1.61-2.33L15 4.56l1.06-1.06l3.72 3.72l-.01.01M11.82 10H12V5H6.82L5.06 3.24c.28-.15.6-.24.94-.24h6c1.1 0 2 .9 2 2v7h1c1.1 0 2 .9 2 2v1.18L11.82 10M6 10h.73L6 9.27V10m0 2v7h6v-3.73L8.73 12H6m12-2c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1Z"/>'
        },
        "gas-station-outline": {
            body: '<path fill="currentColor" d="m19.77 7.23l.01-.01l-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21a1 1 0 0 1-1 1a1 1 0 0 1-1-1V14a2 2 0 0 0-2-2h-1V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16h10v-7.5h1.5v5A2.5 2.5 0 0 0 18 21a2.5 2.5 0 0 0 2.5-2.5V9c0-.69-.28-1.32-.73-1.77M12 13.5V19H6v-7h6v1.5m0-3.5H6V5h6v5m6 0a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        gate: {
            body: '<path fill="currentColor" d="M9 6v5H7V7H5v4H3V9H1v12h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2V9h-2v2h-2V7h-2v4h-2V6h-2v5h-2V6H9m-6 7h2v4H3v-4m4 0h2v4H7v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4m4 0h2v4h-2v-4Z"/>'
        },
        "gate-alert": {
            body: '<path fill="currentColor" d="M21 17h-2v2h2v-2m0-8h-2v6h2V9m-4 4v-2h-2V6h-2v5h-2V6H9v5H7V7H5v4H3V9H1v12h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v-2h-2v-4h2M5 17H3v-4h2v4m4 0H7v-4h2v4m4 0h-2v-4h2v4Z"/>'
        },
        "gate-and": {
            body: '<path fill="currentColor" d="M2 4v16h12a8 8 0 0 0 8-8a8 8 0 0 0-8-8H2m2 2h10a6 6 0 0 1 6 6a6 6 0 0 1-6 6H4V6Z"/>'
        },
        "gate-arrow-left": {
            body: '<path fill="currentColor" d="M9 6H7v5H5V6H3v5H2v2h1v1.81c.62-.36 1.3-.6 2-.72V13h2v1.09c.7.12 1.38.36 2 .72V13h2v3.69c.65.98 1 2.13 1 3.31c0 .34-.03.67-.09 1H13v-2h2v2h2V9h-2v2h-2V7h-2v4H9V6m6 7v4h-2v-4h2M2 20l3 3v-2h4v-2H5v-2l-3 3Z"/>'
        },
        "gate-arrow-right": {
            body: '<path fill="currentColor" d="M15 6v5h-2V7h-2v4H9V9H7v12h2v-2h2v2h1.09c-.06-.33-.09-.66-.09-1c0-1.18.35-2.33 1-3.31V13h2v1.81c.62-.36 1.3-.6 2-.72V13h2v1.09c.7.12 1.38.36 2 .72V13h1v-2h-1V6h-2v5h-2V6h-2m-6 7h2v4H9v-4m10 4v2h-4v2h4v2l3-3l-3-3Z"/>'
        },
        "gate-buffer": {
            body: '<path fill="currentColor" d="M6 7.24L15.53 12L6 16.76V7.24M4 4v16l16-8L4 4Z"/>'
        },
        "gate-nand": {
            body: '<path fill="currentColor" d="M2 4v16h8c3.43 0 6.5-2.16 7.6-5.4c.4.2.9.4 1.4.4a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-.5 0-.97.15-1.4.4C16.5 6.16 13.43 4 10 4H2m2 2h6a6 6 0 0 1 6 6a6 6 0 0 1-6 6H4V6m15 5c.5 0 1 .5 1 1s-.5 1-1 1a1 1 0 0 1-1-1c0-.5.5-1 1-1Z"/>'
        },
        "gate-nor": {
            body: '<path fill="currentColor" d="M2 4c3 6 3 10 0 16h3c4.4 0 8-2.3 11.6-6.3c.55.8 1.44 1.3 2.4 1.3a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-.96 0-1.85.5-2.4 1.3C13 6.3 9.4 4 5 4H2m3 2c3.8 0 7 2.1 10.3 6C12 15.9 8.8 18 5 18c1.5-4 1.5-8 0-12m14 5c.5 0 1 .5 1 1s-.5 1-1 1a1 1 0 0 1-1-1c0-.5.5-1 1-1Z"/>'
        },
        "gate-not": {
            body: '<path fill="currentColor" d="M2 4v16l14.2-7c.42 1.19 1.54 2 2.8 2a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-1.26 0-2.38.81-2.8 2L2 4m2 3.3l9.7 4.7L4 16.7V7.3M19 11c.5 0 1 .5 1 1s-.5 1-1 1a1 1 0 0 1-1-1c0-.5.5-1 1-1Z"/>'
        },
        "gate-open": {
            body: '<path fill="currentColor" d="M7 21V7H5v4H3V9H1v12h2v-2h2v2h2m-4-4v-4h2v4H3m18-8v2h-2V7h-2v14h2v-2h2v2h2V9h-2m0 8h-2v-4h2v4Z"/>'
        },
        "gate-or": {
            body: '<path fill="currentColor" d="M2 4c3 6 3 10 0 16h6c5 0 11-4 14-8c-3-4-9-8-14-8H2m3 2h3c3.5 0 8.3 3 11.3 6c-3 3-7.8 6-11.3 6H5c1.4-4.1 1.4-7.9 0-12Z"/>'
        },
        "gate-xnor": {
            body: '<path fill="currentColor" d="M2 4c3 6 3 10 0 16h2c3-6 3-10 .1-16H2m4 0c3 6 3 10 0 16h3c3.2 0 5.8-3.2 7.7-6c.58.65 1.42 1 2.3 1a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-.88 0-1.72.35-2.3 1c-2-2.8-4.5-6-7.7-6H6m3 2c3 0 5 4 6.5 6C14 14 12 18 9 18c1.6-4 1.6-8 0-12m10 5c.5 0 1 .5 1 1s-.5 1-1 1a1 1 0 0 1-1-1c0-.5.5-1 1-1Z"/>'
        },
        "gate-xor": {
            body: '<path fill="currentColor" d="M2 4c3 6 3 10 0 16h2c3-6 3-10 .1-16H2m4 0c3 6 3 10 0 16h3c5 0 9-3 13-8c-4-5-8-8-13-8H6m3 2c3.8 0 7 2.1 10.3 6c-3.4 3.9-6.5 6-10.3 6c1.5-4 1.5-8 0-12Z"/>'
        },
        gatsby: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2c-3.73 0-6.86 2.55-7.75 6L14 19.75c3.45-.89 6-4.02 6-7.75h-5.25v1.5h3.45a6.37 6.37 0 0 1-3.89 4.44L6.06 9.69C7 7.31 9.3 5.63 12 5.63c2.13 0 4 1.04 5.18 2.65l1.23-1.06A7.959 7.959 0 0 0 12 4m-8 8a8 8 0 0 0 8 8c.04 0 .09 0-8-8Z"/>'
        },
        gauge: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8c0 2.4-1 4.5-2.7 6c-1.4-1.3-3.3-2-5.3-2s-3.8.7-5.3 2C5 16.5 4 14.4 4 12a8 8 0 0 1 8-8m2 1.89c-.38.01-.74.26-.9.65l-1.29 3.23l-.1.23c-.71.13-1.3.6-1.57 1.26c-.41 1.03.09 2.19 1.12 2.6c1.03.41 2.19-.09 2.6-1.12c.26-.66.14-1.42-.29-1.98l.1-.26l1.29-3.21l.01-.03c.2-.51-.05-1.09-.56-1.3c-.13-.05-.26-.07-.41-.07M10 6a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m10 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "gauge-empty": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 2.4 1 4.5 2.7 6c1.4-1.3 3.3-2 5.3-2s3.8.7 5.3 2c1.7-1.5 2.7-3.6 2.7-6a8 8 0 0 0-8-8m2 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M6.91 8.94c.13 0 .25.03.39.06l3.2 1.32l.27.11c.56-.43 1.32-.55 1.98-.28c1.02.41 1.52 1.58 1.1 2.6a1.992 1.992 0 0 1-2.6 1.1c-.66-.26-1.13-.85-1.25-1.57l-.23-.1l-3.22-1.3l-.02-.01c-.53-.21-.76-.79-.56-1.31a1 1 0 0 1 .94-.62M17 9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "gauge-full": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8c0 2.4-1 4.5-2.7 6c-1.4-1.3-3.3-2-5.3-2s-3.8.7-5.3 2C5 16.5 4 14.4 4 12a8 8 0 0 1 8-8m-2 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m3.09 2.94c-.13 0-.25.03-.39.06l-3.2 1.32l-.27.11c-.56-.43-1.32-.55-1.98-.28a1.992 1.992 0 0 0-1.1 2.6a1.992 1.992 0 0 0 2.6 1.1c.66-.26 1.13-.85 1.25-1.57l.23-.1l3.22-1.3l.02-.01c.53-.21.76-.79.56-1.31a1 1 0 0 0-.94-.62M7 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "gauge-low": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 2.4 1 4.5 2.7 6c1.4-1.3 3.3-2 5.3-2s3.8.7 5.3 2c1.7-1.5 2.7-3.6 2.7-6a8 8 0 0 0-8-8m-2 1.89c.38.01.74.26.9.65l1.29 3.23l.1.23c.71.13 1.3.6 1.57 1.26c.41 1.03-.09 2.19-1.12 2.6c-1.03.41-2.19-.09-2.6-1.12c-.26-.66-.14-1.42.29-1.98l-.1-.26l-1.29-3.21l-.01-.03c-.2-.51.05-1.09.56-1.3c.13-.05.26-.07.41-.07M14 6a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m3 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        gavel: {
            body: '<path fill="currentColor" d="m2.3 20.28l9.6-9.6l-1.4-1.42l-.72.71a.996.996 0 0 1-1.41 0l-.71-.71a.996.996 0 0 1 0-1.41l5.66-5.66a.996.996 0 0 1 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.69l1.42 1.43a.996.996 0 0 1 1.41 0c.39.39.39 1.03 0 1.42l1.41 1.41l.71-.71c.39-.39 1.03-.39 1.42 0l.7.71c.39.39.39 1.03 0 1.42l-5.65 5.65c-.39.39-1.03.39-1.42 0l-.7-.7a.99.99 0 0 1 0-1.42l.7-.71l-1.41-1.41l-9.61 9.61a.996.996 0 0 1-1.41 0c-.39-.39-.39-1.03 0-1.42M20 19a2 2 0 0 1 2 2v1H12v-1a2 2 0 0 1 2-2h6Z"/>'
        },
        "gender-female": {
            body: '<path fill="currentColor" d="M12 4a6 6 0 0 1 6 6c0 2.97-2.16 5.44-5 5.92V18h2v2h-2v2h-2v-2H9v-2h2v-2.08c-2.84-.48-5-2.95-5-5.92a6 6 0 0 1 6-6m0 2a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "gender-male": {
            body: '<path fill="currentColor" d="M9 9c1.29 0 2.5.41 3.47 1.11L17.58 5H13V3h8v8h-2V6.41l-5.11 5.09c.7 1 1.11 2.2 1.11 3.5a6 6 0 0 1-6 6a6 6 0 0 1-6-6a6 6 0 0 1 6-6m0 2a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "gender-male-female": {
            body: '<path fill="currentColor" d="M17.58 4H14V2h7v7h-2V5.41l-3.83 3.83A5 5 0 0 1 12 16.9V19h2v2h-2v2h-2v-2H8v-2h2v-2.1A5 5 0 0 1 6 12a5 5 0 0 1 5-5c1 0 1.96.3 2.75.83L17.58 4M11 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "gender-male-female-variant": {
            body: '<path fill="currentColor" d="M7 3a5 5 0 0 0 2 4a5 5 0 0 0-2 4a5 5 0 0 0 4 4.9V18H9v2h2v2h2v-2h2v-2h-2v-2.1a5 5 0 0 0 4-4.9a5 5 0 0 0-2-4a5 5 0 0 0 2-4h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3m3 5a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "gender-non-binary": {
            body: '<path fill="currentColor" d="M13 3h-2v2.27L9.04 4.13l-1 1.74L10 7L8.04 8.13l1 1.74L11 8.73v3.37a5 5 0 1 0 2 0V8.73l1.96 1.14l1-1.74L14 7l1.96-1.13l-1-1.74L13 5.27V3m-1 17c-1.65 0-3-1.35-3-3s1.35-3 3-3s3 1.35 3 3s-1.35 3-3 3Z"/>'
        },
        "gender-transgender": {
            body: '<path fill="currentColor" d="M19.58 3H15V1h8v8h-2V4.41l-4.83 4.83A5 5 0 0 1 13 16.9V19h2v2h-2v2h-2v-2H9v-2h2v-2.1a5 5 0 0 1-3.18-7.64L6.64 8.07l-1.4 1.39l-1.41-1.42l1.4-1.39L3 4.42V8H1V1h7v2H4.41l2.23 2.24l1.44-1.43L9.5 5.23L8.06 6.66l1.17 1.18C10 7.31 11 7 12 7s1.96.3 2.75.83L19.58 3M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        gentoo: {
            body: '<path fill="currentColor" d="M10.28 2c-.35 0-.71.03-1.05.1c-3.62.66-6.17 3.79-6.38 5.86c-.11 1.01.44 1.77.74 2.1c.81.91 2.44 1.6 3.48 2.17c-1.51 1.27-2.2 1.91-2.88 2.63c-1.02 1.07-1.74 2.24-1.74 3.09c0 .27-.05 1.14.31 1.82c.13.26.51 1.12 1.65 1.76c.73.41 1.76.56 2.78.42c3.14-.45 7.35-3.12 10.36-5.6c1.91-1.58 3.31-3.12 3.71-3.85c.33-.63.37-1.72.18-2.41c-.54-1.95-4.91-5.94-8.48-7.54c-.82-.37-1.76-.55-2.68-.55m1.06 2.91c.25 0 .47.03.66.09c1.15.3 3.08 1.68 2.91 2.94c-.23 1.66-1.68 2.33-3.35 2.09c-.98-.13-2.93-1.23-2.78-3.14c.11-1.49 1.52-1.99 2.56-1.98m-.02 1.74c-.27 0-.48.06-.58.22c-.47.72-.24 1.22.18 1.55c.15-.38 1.79.03 1.83.37c1.42-1.07-.39-2.13-1.43-2.14Z"/>'
        },
        gesture: {
            body: '<path fill="currentColor" d="M4.59 6.89C5.29 6.18 6 5.54 6.3 5.67c.5.2 0 1.03-.3 1.52c-.25.42-2.86 3.89-2.86 6.31c0 1.28.48 2.34 1.36 3a3 3 0 0 0 2.62.44c1.07-.31 1.95-1.4 3.06-2.77c1.21-1.49 2.82-3.44 4.08-3.44c1.63 0 1.65 1.01 1.74 1.77c-3.76.66-5.36 3.69-5.36 5.39c0 1.7 1.44 3.11 3.21 3.11c1.65 0 4.29-1.35 4.69-6.12H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2c-2.25 0-4.18 1.91-4.94 2.82c-.56.75-2.06 2.5-2.29 2.74c-.27.3-.68.84-1.11.84c-.45 0-.72-.83-.36-1.92c.35-1.09 1.4-2.86 1.85-3.52c.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3C5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71m9.29 11.66c-.31 0-.74-.26-.74-.72c0-.6.73-2.2 2.86-2.76c-.29 2.69-1.42 3.48-2.12 3.48Z"/>'
        },
        "gesture-double-tap": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9m1-4a4 4 0 0 1 4 4c0 1.5-.8 2.77-2 3.46v-1.22c.61-.55 1-1.35 1-2.24a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .89.39 1.69 1 2.24v1.22C7.8 11.77 7 10.5 7 9a4 4 0 0 1 4-4m0-2a6 6 0 0 1 6 6c0 1.7-.71 3.23-1.84 4.33l-1-.45A5.019 5.019 0 0 0 16 9a5 5 0 0 0-5-5a5 5 0 0 0-5 5c0 2.05 1.23 3.81 3 4.58v1.08C6.67 13.83 5 11.61 5 9a6 6 0 0 1 6-6Z"/>'
        },
        "gesture-pinch": {
            body: '<path fill="currentColor" d="M13 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.2c.52.24.85.76.85 1.34v4.36c-.03.82-.68 1.47-1.5 1.5H14c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L13 19V9m1-4c1.42 0 2.74.76 3.45 2c1.11 1.9.46 4.35-1.45 5.46v-1.23c.64-.56 1-1.38 1-2.23a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .85.36 1.67 1 2.23v1.23c-1.23-.71-2-2.03-2-3.46a4 4 0 0 1 4-4M4 9l3 3H5v3H3v-3H1l3-3m0-2L1 4h2V1h2v3h2L4 7m5 7c.73 0 1.41.19 2 .54v1.22c-.53-.47-1.23-.76-2-.76a3 3 0 0 0-3 3c0 1 .5 1.87 1.22 2.42L9.31 22H9a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        "gesture-spread": {
            body: '<path fill="currentColor" d="m4 1l3 3H5v3H3V4H1l3-3m0 14l-3-3h2V9h2v3h2l-3 3m9-6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.2c.52.24.85.76.85 1.34v4.36c-.03.82-.68 1.47-1.5 1.5H14c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L13 19V9m1-4c1.42 0 2.74.76 3.45 2c1.11 1.9.46 4.35-1.45 5.46v-1.23c.64-.56 1-1.38 1-2.23a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .85.36 1.67 1 2.23v1.23c-1.23-.71-2-2.03-2-3.46a4 4 0 0 1 4-4m-5 9c.73 0 1.41.19 2 .54v1.22c-.53-.47-1.23-.76-2-.76a3 3 0 0 0-3 3c0 1 .5 1.87 1.22 2.42L9.31 22H9a4 4 0 0 1-4-4a4 4 0 0 1 4-4Z"/>'
        },
        "gesture-swipe": {
            body: '<path fill="currentColor" d="M20.11 3.89L22 2v5h-5l2.08-2.08c-.53-.69-1.44-1.26-2.72-1.73c-1.28-.47-2.73-.69-4.36-.69c-1.62 0-3.08.22-4.36.69c-1.28.47-2.19 1.04-2.72 1.73L7 7H2V2l1.89 1.89C4.64 3 5.74 2.31 7.2 1.78C8.65 1.25 10.25 1 12 1s3.35.25 4.8.78c1.46.53 2.56 1.22 3.31 2.11m-.38 12.38v.18L19 21.7c-.08.38-.24.69-.5.94c-.27.25-.59.36-.97.36h-6.8c-.37 0-.73-.14-1.03-.45l-4.97-4.92l.8-.8c.22-.22.47-.33.8-.33h.23l3.44.75V6.5c0-.39.13-.74.43-1.04c.3-.3.65-.46 1.07-.46c.39 0 .74.16 1.04.46c.3.3.46.65.46 1.04v6h.78c.1 0 .27.05.52.11l4.54 2.25c.6.28.89.75.89 1.41Z"/>'
        },
        "gesture-swipe-down": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9M1 9l3 3l3-3H5V3H3v6H1Z"/>'
        },
        "gesture-swipe-horizontal": {
            body: '<path fill="currentColor" d="M6 1L3 4l3 3V5h3v2l3-3l-3-3v2H6V1m5 7a1 1 0 0 0-1 1v10l-3.2-1.72h-.22c-.28 0-.55.11-.74.32l-.74.77l4.9 4.2c.26.28.62.43 1 .43h6.5a1.5 1.5 0 0 0 1.5-1.5v-4.36c0-.58-.32-1.11-.85-1.35l-4.94-2.19l-1.21-.13V9a1 1 0 0 0-1-1Z"/>'
        },
        "gesture-swipe-left": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9M3 4l3 3V5h6V3H6V1L3 4Z"/>'
        },
        "gesture-swipe-right": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9m2-5L9 1v2H3v2h6v2l3-3Z"/>'
        },
        "gesture-swipe-up": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9M7 6L4 3L1 6h2v6h2V6h2Z"/>'
        },
        "gesture-swipe-vertical": {
            body: '<path fill="currentColor" d="M4 3L1 6h2v3H1l3 3l3-3H5V6h2L4 3m7 5a1 1 0 0 0-1 1v10l-3.2-1.72h-.22c-.28 0-.55.11-.74.32l-.74.77l4.9 4.2c.26.28.62.43 1 .43h6.5a1.5 1.5 0 0 0 1.5-1.5v-4.36c0-.58-.32-1.11-.85-1.35l-4.94-2.19l-1.21-.13V9a1 1 0 0 0-1-1Z"/>'
        },
        "gesture-tap": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9m1-4a4 4 0 0 1 4 4c0 1.5-.8 2.77-2 3.46v-1.22c.61-.55 1-1.35 1-2.24a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .89.39 1.69 1 2.24v1.22C7.8 11.77 7 10.5 7 9a4 4 0 0 1 4-4Z"/>'
        },
        "gesture-tap-box": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2m-9 2c2.21 0 4 1.79 4 4c0 1.5-.8 2.77-2 3.46v-1.22c.61-.55 1-1.35 1-2.24c0-1.66-1.34-3-3-3S8 6.34 8 8c0 .89.39 1.69 1 2.24v1.22C7.8 10.77 7 9.5 7 8c0-2.21 1.79-4 4-4m7 14.5c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4-4.2l.74-.77c.19-.21.46-.32.76-.32h.2L10 16V8c0-.55.45-1 1-1s1 .45 1 1v4.47l1.21.13l3.94 2.19c.53.24.85.77.85 1.35v2.36Z"/>'
        },
        "gesture-tap-button": {
            body: '<path fill="currentColor" d="M13 5c2.21 0 4 1.79 4 4c0 1.5-.8 2.77-2 3.46v-1.22c.61-.55 1-1.35 1-2.24c0-1.66-1.34-3-3-3s-3 1.34-3 3c0 .89.39 1.69 1 2.24v1.22C9.8 11.77 9 10.5 9 9c0-2.21 1.79-4 4-4m7 15.5c-.03.82-.68 1.47-1.5 1.5H13c-.38 0-.74-.15-1-.43l-4-4.2l.74-.77c.19-.21.46-.32.76-.32h.2L12 18V9c0-.55.45-1 1-1s1 .45 1 1v4.47l1.21.13l3.94 2.19c.53.24.85.77.85 1.35v3.36M20 2H4c-1.1 0-2 .9-2 2v8a2 2 0 0 0 2 2h4v-2H4V4h16v8h-2v2h2v-.04l.04.04c1.09 0 1.96-.91 1.96-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "gesture-tap-hold": {
            body: '<path fill="currentColor" d="M10 9a1 1 0 0 1 1-1a1 1 0 0 1 1 1v4.47l1.21.13l4.94 2.19c.53.24.85.77.85 1.35v4.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9m-1 3.44V9a2 2 0 0 1 2-2a2 2 0 0 1 2 2v3.44c1.19-.69 2-1.97 2-3.44a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 1.47.81 2.75 2 3.44Z"/>'
        },
        "gesture-two-double-tap": {
            body: '<path fill="currentColor" d="M19 15.14v6.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9a1 1 0 0 1 1-1a1 1 0 0 1 1 1V7a1 1 0 0 1 1-1a1 1 0 0 1 1 1v5l4.15 1.84c.51.23.85.74.85 1.3M13 3a4 4 0 0 1 4 4c0 1.5-.8 2.77-2 3.46V9.24c.61-.55 1-1.35 1-2.24a3 3 0 0 0-3-3c-1.35 0-2.5.9-2.87 2.13A3.003 3.003 0 0 0 9 11.24v1.22C7.8 11.77 7 10.5 7 9c0-1.62.97-3 2.35-3.65C10 3.97 11.38 3 13 3m0-2a6 6 0 0 1 6 6c0 2.06-1.04 3.88-2.62 4.96l-1.12-.5A4.982 4.982 0 0 0 18 7a5 5 0 0 0-5-5c-1.89 0-3.54 1.05-4.39 2.61C7.05 5.46 6 7.11 6 9c0 2.05 1.23 3.81 3 4.58v1.08C6.67 13.83 5 11.61 5 9c0-2.17 1.15-4.07 2.88-5.12A5.977 5.977 0 0 1 13 1Z"/>'
        },
        "gesture-two-tap": {
            body: '<path fill="currentColor" d="M19 15.14v6.36c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2l.74-.77c.19-.21.46-.32.74-.32h.22L10 19V9a1 1 0 0 1 1-1a1 1 0 0 1 1 1V7a1 1 0 0 1 1-1a1 1 0 0 1 1 1v5l4.15 1.84c.51.23.85.74.85 1.3m-4-4.69V9.23c.23-.2.42-.44.57-.69c.27-.45.43-.98.43-1.54a3 3 0 0 0-3-3c-.79 0-1.5.31-2.05.81l-.14.14c-.13.14-.25.29-.35.45c-.1.16-.19.34-.26.52c-.03.08-.05.14-.07.21A3.003 3.003 0 0 0 8 9c0 .7.24 1.34.64 1.85c.1.15.23.26.36.38v1.23C7.8 11.77 7 10.5 7 9c0-1.62.97-3 2.35-3.65C10 3.97 11.38 3 13 3a4 4 0 0 1 4 4c0 1.5-.8 2.77-2 3.46v-.01Z"/>'
        },
        ghost: {
            body: '<path fill="currentColor" d="M12 2a9 9 0 0 0-9 9v11l3-3l3 3l3-3l3 3l3-3l3 3V11a9 9 0 0 0-9-9M9 8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m6 0a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "ghost-off": {
            body: '<path fill="currentColor" d="M2 3.27L3.28 2L22 20.72L20.73 22l-2.86-2.87L15 22l-3-3l-3 3l-3-3l-3 3V11c0-1.91.59-3.67 1.6-5.13L2 3.27M12 2a9 9 0 0 1 9 9v6.18l-5.3-5.3c.76-.29 1.3-1.02 1.3-1.88a2 2 0 0 0-2-2c-.86 0-1.59.54-1.87 1.3L7.2 3.38A8.946 8.946 0 0 1 12 2m-5 8a2 2 0 0 0 2 2c.5 0 .93-.17 1.27-.46L7.46 8.73C7.17 9.07 7 9.5 7 10Z"/>'
        },
        "ghost-off-outline": {
            body: '<path fill="currentColor" d="M8.29 5.09L6.84 3.64A8.925 8.925 0 0 1 12 2a9 9 0 0 1 9 9v6.8l-2-2V11c0-3.86-3.14-7-7-7c-1.37 0-2.64.4-3.71 1.09m13.82 16.37l-1.27 1.27l-3.28-3.28L15 22l-3-3l-3 3l-3-3l-3 3V11c0-1.74.5-3.37 1.36-4.75L1.11 3l1.28-1.27l4.5 4.5l1.8 1.8l2.28 2.28l6.44 6.45h.01L21 20.34v.01l1.11 1.11m-5.97-3.43l-6.25-6.25c-.27.14-.57.22-.89.22a2 2 0 0 1-2-2c0-.32.08-.62.22-.89l-1.4-1.4C5.3 8.69 5 9.81 5 11v6.17l1-1l1.41 1.42L9 19.17l1.59-1.58L12 16.17l1.41 1.42L15 19.17l1.14-1.14M15 8c-1.04 0-1.89.8-2 1.82L15.18 12c1.02-.11 1.82-.96 1.82-2a2 2 0 0 0-2-2Z"/>'
        },
        "ghost-outline": {
            body: '<path fill="currentColor" d="M12 2a9 9 0 0 0-9 9v11l3-3l3 3l3-3l3 3l3-3l3 3V11a9 9 0 0 0-9-9m7 15.17l-1-1l-1.41 1.42L15 19.17l-1.59-1.58L12 16.17l-1.41 1.42L9 19.17l-1.59-1.58L6 16.17l-1 1V11c0-3.86 3.14-7 7-7s7 3.14 7 7v6.17M11 10c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m6 0c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        gif: {
            body: '<path d="M11 8h2v8h-2V8M7.67 8H4.33C3.53 8 3 8.67 3 9.33v5.34c0 .66.53 1.33 1.33 1.33h3.34c.8 0 1.33-.67 1.33-1.33V12H7v2H5v-4h4v-.67C9 8.67 8.47 8 7.67 8M21 10V8h-6v8h2v-2h2.5v-2H17v-2h4z" fill="currentColor"/>',
            hidden: true
        },
        gift: {
            body: '<path fill="currentColor" d="M9.06 1.93C7.17 1.92 5.33 3.74 6.17 6H3a2 2 0 0 0-2 2v2a1 1 0 0 0 1 1h9V8h2v3h9a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2h-3.17C19 2.73 14.6.42 12.57 3.24L12 4l-.57-.78c-.63-.89-1.5-1.28-2.37-1.29M9 4c.89 0 1.34 1.08.71 1.71C9.08 6.34 8 5.89 8 5a1 1 0 0 1 1-1m6 0c.89 0 1.34 1.08.71 1.71c-.63.63-1.71.18-1.71-.71a1 1 0 0 1 1-1M2 12v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8h-9v8h-2v-8H2Z"/>'
        },
        "gift-off": {
            body: '<path fill="currentColor" d="m1.11 3l3.03 3.04H3a2 2 0 0 0-2 2v2c0 .55.45 1 1 1h7.15l1 1H2v8c0 1.1.9 2 2 2h16c.05 0 .09-.01.13-.04l1.43 1.45l1.27-1.27L2.39 1.73L1.11 3M11 12.89l2 2v5.15h-2v-7.15m11-.85v6.76l-6.76-6.76H22m-1-6h-3.17C19 2.77 14.6.455 12.57 3.28l-.57.76l-.57-.78C10.8 2.37 9.93 2 9.06 1.97c-1-.01-1.98.53-2.56 1.33l1.54 1.54c.09-.46.46-.8.96-.8c.89 0 1.34 1.08.71 1.71c-.15.14-.32.25-.5.25l2.03 2.04H13V9.8l1.24 1.24H22c.55 0 1-.45 1-1v-2c0-1.11-.89-2-2-2m-5.29-.29c-.63.63-1.71.18-1.71-.71c0-.54.45-1 1-1c.89 0 1.34 1.08.71 1.71Z"/>'
        },
        "gift-off-outline": {
            body: '<path fill="currentColor" d="M21 6h-3.17A3 3 0 0 0 18 5c0-1.66-1.34-3-3-3c-1 0-1.88.5-2.43 1.24v-.01L12 4l-.57-.77v.01A3.034 3.034 0 0 0 9 2c-1.03 0-1.94.5-2.5 1.32l1.53 1.51C8.12 4.36 8.5 4 9 4c.55 0 1 .45 1 1c0 .5-.36.88-.83.97L13 9.8V8h8v2h-7.8l2 2H20v4.8l2 2V12c.55 0 1-.45 1-1V8a2 2 0 0 0-2-2m-6 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M1.11 3l3 3H3c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1v8a2 2 0 0 0 2 2h16.1l1.46 1.45l1.27-1.27L2.39 1.73L1.11 3M13 14.89L18.11 20H13v-5.11m-2-2V20H4v-8h6.11l.89.89M8.11 10H3V8h3.11l2 2Z"/>'
        },
        "gift-open": {
            body: '<path fill="currentColor" d="m22 10.92l-2.74-1.59c2.64-2.25-.01-6.45-3.18-5.02l-.87.37l-.11-.96c-.1-1.08-.66-1.85-1.4-2.3c-1.64-.953-4.14-.3-4.54 2.08L6.41 1.92c-.96-.56-2.18-.23-2.73.73l-1 1.73c-.28.48-.11 1.09.37 1.37l7.79 4.5l1.5-2.6l1.73 1l-1.5 2.6l7.79 4.5c.48.25 1.1.11 1.37-.37l1-1.73c.55-.96.23-2.18-.73-2.73M12.37 5c-.87.25-1.57-.68-1.13-1.45c.26-.48.89-.64 1.37-.37c.77.45.62 1.61-.24 1.82m5.19 3c-.86.25-1.56-.68-1.12-1.45c.27-.48.89-.64 1.36-.37c.77.45.62 1.61-.24 1.82m3.31 8.88c.41 0 .8-.14 1.13-.38V20c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-9h8.15l.85.5V20h2v-7.35l6.87 3.96c.3.18.63.27 1 .27Z"/>'
        },
        "gift-open-outline": {
            body: '<path fill="currentColor" d="m22 10.87l-2.74-1.59c.24-.21.47-.48.64-.78c.83-1.43.34-3.27-1.1-4.1c-.86-.5-1.87-.5-2.72-.14l.01-.01l-.88.39l-.11-.96l-.01.01c-.09-.91-.62-1.79-1.48-2.29A3.023 3.023 0 0 0 9.5 2.5c-.17.3-.28.63-.34.95L6.41 1.87c-.96-.55-2.18-.23-2.73.73l-1.5 2.6a.988.988 0 0 0 .37 1.36l1.73 1L8.5 10H2v10a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2v-5.13l.73-1.27c.55-.96.23-2.18-.73-2.73M16.44 6.5c.27-.5.89-.64 1.36-.37c.48.28.65.87.37 1.37c-.28.5-.89.64-1.37.37c-.47-.28-.64-.87-.36-1.37m-2.37 2.1l6.93 4l-1 1.73l-6.93-4l1-1.73M11 20H4v-8h7v8m.34-10.67l-6.93-4l1-1.73l6.93 4l-1 1.73m.27-4.46c-.48-.28-.64-.87-.37-1.37c.26-.5.89-.64 1.37-.37c.48.28.64.87.36 1.37c-.27.5-.88.64-1.36.37M13 20v-7.4l7 4.04V20h-7Z"/>'
        },
        "gift-outline": {
            body: '<path fill="currentColor" d="M22 12v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2h3.17A3 3 0 0 1 6 5a3 3 0 0 1 3-3c1 0 1.88.5 2.43 1.24v-.01L12 4l.57-.77v.01C13.12 2.5 14 2 15 2a3 3 0 0 1 3 3a3 3 0 0 1-.17 1H21a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1M4 20h7v-8H4v8m16 0v-8h-7v8h7M9 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M3 8v2h8V8H3m10 0v2h8V8h-8Z"/>'
        },
        git: {
            body: '<path fill="currentColor" d="M2.6 10.59L8.38 4.8l1.69 1.7c-.24.85.15 1.78.93 2.23v5.54c-.6.34-1 .99-1 1.73a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.74-.4-1.39-1-1.73V9.41l2.07 2.09c-.07.15-.07.32-.07.5a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2c-.18 0-.35 0-.5.07L13.93 7.5a1.98 1.98 0 0 0-1.15-2.34c-.43-.16-.88-.2-1.28-.09L9.8 3.38l.79-.78c.78-.79 2.04-.79 2.82 0l7.99 7.99c.79.78.79 2.04 0 2.82l-7.99 7.99c-.78.79-2.04.79-2.82 0L2.6 13.41c-.79-.78-.79-2.04 0-2.82Z"/>'
        },
        github: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33c.85 0 1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2Z"/>'
        },
        "github-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4.44c-.32-.07-.33-.68-.33-.89l.01-2.47c0-.84-.29-1.39-.61-1.67c2.01-.22 4.11-.97 4.11-4.44c0-.98-.35-1.79-.92-2.42c.09-.22.4-1.14-.09-2.38c0 0-.76-.23-2.48.93c-.72-.2-1.48-.3-2.25-.31c-.76.01-1.54.11-2.25.31c-1.72-1.16-2.48-.93-2.48-.93c-.49 1.24-.18 2.16-.09 2.38c-.57.63-.92 1.44-.92 2.42c0 3.47 2.1 4.22 4.1 4.47c-.26.2-.49.6-.57 1.18c-.52.23-1.82.63-2.62-.75c0 0-.48-.86-1.38-.93c0 0-.88 0-.06.55c0 0 .59.28 1 1.32c0 0 .52 1.75 3.03 1.21l.01 1.53c0 .21-.02.82-.34.89H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" fill="currentColor"/>',
            hidden: true
        },
        "github-face": {
            body: '<path d="M20.38 8.53c.16-.4.68-1.99-.17-4.14c0 0-1.31-.39-4.3 1.61c-1.25-.33-2.58-.38-3.91-.38c-1.32 0-2.66.05-3.91.38c-2.99-2.03-4.3-1.61-4.3-1.61c-.85 2.15-.33 3.74-.16 4.14C2.61 9.62 2 11 2 12.72c0 6.44 4.16 7.89 10 7.89c5.79 0 10-1.45 10-7.89c0-1.72-.61-3.1-1.62-4.19M12 19.38c-4.12 0-7.47-.19-7.47-4.19c0-.95.47-1.85 1.27-2.58c1.34-1.23 3.63-.58 6.2-.58c2.59 0 4.85-.65 6.2.58c.8.73 1.3 1.62 1.3 2.58c0 3.99-3.37 4.19-7.5 4.19m-3.14-6.26c-.82 0-1.5 1-1.5 2.22c0 1.23.68 2.24 1.5 2.24c.83 0 1.5-1 1.5-2.24c0-1.23-.67-2.22-1.5-2.22m6.28 0c-.83 0-1.5.99-1.5 2.22c0 1.24.67 2.24 1.5 2.24c.82 0 1.5-1 1.5-2.24c0-1.23-.64-2.22-1.5-2.22z" fill="currentColor"/>',
            hidden: true
        },
        gitlab: {
            body: '<path fill="currentColor" d="m21.94 13.11l-1.05-3.22c0-.03-.01-.06-.02-.09l-2.11-6.48a.859.859 0 0 0-.8-.57c-.36 0-.68.25-.79.58l-2 6.17H8.84L6.83 3.33a.851.851 0 0 0-.79-.58c-.37 0-.69.25-.8.58L3.13 9.82v.01l-1.07 3.28c-.16.5.01 1.04.44 1.34l9.22 6.71c.17.12.39.12.56-.01l9.22-6.7c.43-.3.6-.84.44-1.34M8.15 10.45l2.57 7.91l-6.17-7.91m8.73 7.92l2.47-7.59l.1-.33h3.61l-5.59 7.16m4.1-13.67l1.81 5.56h-3.62m-1.3.95l-1.79 5.51L12 19.24l-2.86-8.79M6.03 3.94L7.84 9.5H4.23m-1.18 4.19c-.09-.07-.13-.19-.09-.29l.79-2.43l5.82 7.45m11.38-4.73l-6.51 4.73l.02-.03l5.79-7.42l.79 2.43c.04.1 0 .22-.09.29"/>'
        },
        "glass-cocktail": {
            body: '<path fill="currentColor" d="m7.5 7l-2-2h13l-2 2M11 13v6H6v2h12v-2h-5v-6l8-8V3H3v2l8 8Z"/>'
        },
        "glass-cocktail-off": {
            body: '<path fill="currentColor" d="M13.33 12.67L7.66 7L6.13 5.47L2.39 1.73L1.11 3L3 4.89V5l8 8v6H6v2h12v-1.11l2.84 2.84l1.27-1.27l-8.78-8.79M13 19v-4.11L17.11 19H13M8.2 5l-2-2H21v2l-6.4 6.4L10.2 7h6.3l2-2H8.2Z"/>'
        },
        "glass-flute": {
            body: '<path fill="currentColor" d="M8 2h8c-.33 3-.67 6-1.25 7.83c-.58 1.84-1.42 2.5-1.83 4.25c-.42 1.75-.42 4.59.16 5.92c.59 1.33 1.75 1.17 2.34 1.25c.58.08.58.42.58.75H8c0-.33 0-.67.58-.75c.59-.08 1.75.08 2.34-1.25c.58-1.33.58-4.17.16-5.92c-.41-1.75-1.25-2.41-1.83-4.25C8.67 8 8.33 5 8 2m2 2c.07 1.03.15 2.07.24 3h3.52c.09-.93.17-1.97.24-3h-4Z"/>'
        },
        "glass-fragile": {
            body: '<path fill="currentColor" d="M13 20h5v2H6v-2h5v-6.03c-2.81-.27-5-2.63-5-5.51c0-.31.03-.61.08-.91L7 2h6.54l-1.21 2.41l-.54 1.09h2l-1.46 2.91l-.54 1.09H14l-1 3.25l2.67-3.66l.79-1.09h-2.25l1.46-2.91l.54-1.09h-2l1-2H17l.93 5.55c.07.3.07.6.07.91c0 2.88-2.19 5.24-5 5.51V20Z"/>'
        },
        "glass-mug": {
            body: '<path fill="currentColor" d="M10 4v3h8V4h-8M8 2h13v1l-1 1v16l1 1v1H7v-1l1-1v-1.4l-3.8-1.77C3.5 16.5 3 15.82 3 15V8a2 2 0 0 1 2-2h3V4L7 3V2h1M5 15l3 1.39V8H5v7Z"/>'
        },
        "glass-mug-off": {
            body: '<path fill="currentColor" d="M20 19.35v-.01L6.66 6l-.59-.59l-3.68-3.68L1.11 3l3.15 3.15C3.5 6.44 3 7.16 3 8v7c0 .82.5 1.5 1.2 1.83L8 18.6V20l-1 1v1h13.11l.73.73l1.27-1.27L20 19.35M8 16.39L5 15V8h1.11L8 9.89v6.5M8 4L7 3V2h14v1l-1 1v12.8L10.2 7H18V4h-8v2.8l-2-2V4Z"/>'
        },
        "glass-mug-variant": {
            body: '<path fill="currentColor" d="M9.5 3C7.56 3 5.85 4.24 5.23 6.08A3.996 3.996 0 0 0 6 14v8h11v-2h3c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-2V8c0-2.21-1.79-4-4-4h-1.68c-.82-.65-1.79-1-2.82-1m0 2c.79 0 1.53.37 2 1H14a2 2 0 0 1 2 2h-4c-2 0-2.68 1.13-3.5 2.63C7.68 12.13 6 12 6 12c-1.11 0-2-.89-2-2a2 2 0 0 1 2-2h1v-.5A2.5 2.5 0 0 1 9.5 5m7.5 7h2v6h-2Z"/>'
        },
        "glass-mug-variant-off": {
            body: '<path fill="currentColor" d="M8.44 5.24L7 3.79C7.71 3.29 8.57 3 9.5 3c1.03 0 2 .35 2.82 1H14c2.21 0 4 1.79 4 4v2h2c.55 0 1 .45 1 1v6.8l-2-2V12h-2v1.8l-5.74-5.74C11.5 8 11.73 8 12 8h4a2 2 0 0 0-2-2h-2.5a2.491 2.491 0 0 0-3.06-.76m13.67 16.22l-1.27 1.27L18.11 20H17v2H6v-8c-2.21 0-4-1.79-4-4a4 4 0 0 1 2.44-3.67L1.11 3l1.28-1.27l4.8 4.81l2.42 2.42L17 16.34v.01L18.65 18h.01l1.84 1.84v.01l1.61 1.61M8.59 10.5L6.11 8H6a2 2 0 0 0-2 2c0 1.11.89 2 2 2c0 0 1.68.13 2.5-1.37l.09-.13Z"/>'
        },
        "glass-pint-outline": {
            body: '<path fill="currentColor" d="m4 2l2 20h11l2-20H4m2.2 2h10.6l-1.6 16H7.8L6.2 4Z"/>'
        },
        "glass-stange": {
            body: '<path fill="currentColor" d="M8 2h8v20H8V2m2 2v3h4V4h-4Z"/>'
        },
        "glass-tulip": {
            body: '<path fill="currentColor" d="M8 2h8c-.33.67-.67 1.33-.42 3c.25 1.67 1.09 4.33.67 5.74c-.42 1.4-2.08 1.54-2.92 3.12c-.83 1.58-.83 4.61-.25 6.04c.59 1.43 1.75 1.27 2.34 1.35c.58.08.58.42.58.75H8c0-.33 0-.67.58-.75c.59-.08 1.75.08 2.34-1.35c.58-1.43.58-4.46-.25-6.04c-.84-1.58-2.5-1.72-2.92-3.12c-.42-1.41.42-4.07.67-5.74c.25-1.67-.09-2.33-.42-3m2 2c0 1.19-.17 2.17-.36 3h4.63c-.14-.83-.27-1.81-.27-3h-4Z"/>'
        },
        "glass-wine": {
            body: '<path fill="currentColor" d="m15.5 21.27l-.84-.09c-.76-.07-1.41-.58-1.66-1.31a11.52 11.52 0 0 1 0-6c2.32-.47 4-2.5 4-4.87c0-2-2-7-2-7H9S7 7 7 9a5 5 0 0 0 4 4.9c.53 1.96.53 4.04 0 6c-.24.72-.88 1.23-1.63 1.31l-.87.09s-.5-.02-.5.7h8c0-.72-.5-.73-.5-.73M9.44 7l1-3h3.12l1 3H9.44Z"/>'
        },
        glassdoor: {
            body: '<path d="M8 2a3 3 0 0 0-3 3v11.5h3V5h11a3 3 0 0 0-3-3H8m8 5.5V19H5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7.5h-3z" fill="currentColor"/>',
            hidden: true
        },
        glasses: {
            body: '<path fill="currentColor" d="M3 10c-.24 0-.45.09-.59.25c-.14.15-.2.37-.17.61l.5 2.99C2.82 14.5 3.4 15 4 15h3c.64 0 1.36-.56 1.5-1.18l1.06-3.19c.04-.13.01-.32-.06-.44c-.11-.12-.28-.19-.5-.19H3m4 7H4C2.38 17 .96 15.74.76 14.14l-.5-2.99C.15 10.3.39 9.5.91 8.92C1.43 8.34 2.19 8 3 8h6c.83 0 1.58.35 2.06.96c.11.15.21.31.29.49c.43-.09.87-.09 1.29 0c.08-.18.18-.34.3-.49C13.41 8.35 14.16 8 15 8h6c.81 0 1.57.34 2.09.92c.51.58.75 1.38.65 2.19l-.51 3.07C23.04 15.74 21.61 17 20 17h-3c-1.56 0-3.08-1.19-3.46-2.7l-.9-2.71c-.38-.28-.91-.28-1.29 0l-.92 2.78C10.07 15.82 8.56 17 7 17m8-7c-.22 0-.39.07-.5.19c-.08.12-.1.31-.05.51l1.01 3.05c.18.69.9 1.25 1.54 1.25h3c.59 0 1.18-.5 1.25-1.11l.51-3.07c.03-.2-.03-.42-.17-.57A.769.769 0 0 0 21 10h-6Z"/>'
        },
        "globe-light": {
            body: '<path fill="currentColor" d="M7.1 10c1-1 2.4-1.7 3.9-1.9V2h2v6.1c1.5.2 2.9.9 3.9 1.9H7.1m-1.8 3c-.2.6-.3 1.3-.3 2c0 3.9 3.1 7 7 7s7-3.1 7-7c0-.7-.1-1.4-.3-2H5.3Z"/>'
        },
        "globe-light-outline": {
            body: '<path fill="currentColor" d="M13 8.08V2h-2v6.08c-3.39.49-6 3.39-6 6.92c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.53-2.61-6.43-6-6.92M12 20c-2.76 0-5-2.24-5-5c0-1.13.39-2.16 1.03-3h7.94c.64.84 1.03 1.87 1.03 3c0 2.76-2.24 5-5 5Z"/>'
        },
        "globe-model": {
            body: '<path fill="currentColor" d="m17.36 2.64l-1.41 1.42A6.978 6.978 0 0 1 18 9a7 7 0 0 1-7 7c-1.85 0-3.63-.74-4.94-2.05l-1.42 1.41A8.945 8.945 0 0 0 10 17.93V20H6v2h10v-2h-4v-2.06c4.55-.51 8-4.36 8-8.94c0-2.38-.95-4.67-2.64-6.36M11 3.5A5.5 5.5 0 0 0 5.5 9a5.5 5.5 0 0 0 5.5 5.5A5.5 5.5 0 0 0 16.5 9A5.5 5.5 0 0 0 11 3.5m0 2c1.94 0 3.5 1.57 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 7.5 9A3.5 3.5 0 0 1 11 5.5Z"/>'
        },
        gmail: {
            body: '<path fill="currentColor" d="M20 18h-2V9.25L12 13L6 9.25V18H4V6h1.2l6.8 4.25L18.8 6H20m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        gnome: {
            body: '<path fill="currentColor" d="M18.42 2c-4.16 0-4.92 5.93-2.6 5.93c2.34 0 6.76-5.93 2.6-5.93M12 2.73c-.08 0-.15 0-.22.01c-2.34.3-1.52 4.38-.28 4.45c1.22.08 2.54-4.46.5-4.46M7.93 4.34c-.12 0-.26.03-.4.09c-1.88.78-.29 3.98.77 3.77c.97-.2 1.09-3.9-.37-3.86m-3 2.51c-.16-.01-.34.05-.52.18c-1.51 1.04.5 3.55 1.39 3.16c.77-.34.28-3.3-.87-3.34m8.36 1.92c-3.19.03-7.26 1.65-7.97 4.82C4.53 17.11 8.56 22 12.76 22c2.07 0 4.45-1.87 4.9-4.23c.34-1.8-4.01-1.08-3.85.11c.19 1.43-1.05 2.12-2.26 1.22c-3.86-2.94 6.38-4.4 5.7-8.41c-.22-1.3-1.91-1.93-3.96-1.92Z"/>'
        },
        "go-kart": {
            body: '<path fill="currentColor" d="M18 10h-2.47l-1.15-1.72l1.42-.95l-1.1-1.66l-4.5 3l1.1 1.66l1.43-.95l1.15 1.74L13 12h-2.8L5.83 5.45l-1.66 1.1l1.7 2.56A5.99 5.99 0 0 0 1 15v2h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-2a5 5 0 0 0-5-5M6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5m12 0a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "go-kart-track": {
            body: '<path fill="currentColor" d="M22 5.5A3.5 3.5 0 0 0 18.5 2A3.5 3.5 0 0 0 15 5.5V6a3 3 0 0 1-3 3c-2 0-3-3-6-3a4 4 0 0 0-4 4v1h2v-1a2 2 0 0 1 2-2c.86 0 1.42.45 2.32 1.24A5.584 5.584 0 0 0 12 11a5 5 0 0 0 5-5v-.5A1.5 1.5 0 0 1 18.5 4A1.5 1.5 0 0 1 20 5.5c-.14.85-.42 1.68-.83 2.44C18.5 9.2 18.11 10.58 18 12c.09 1.37.5 2.71 1.21 3.89c.39.65.66 1.36.79 2.11a2 2 0 0 1-2 2a2 2 0 0 1-2-2a3.75 3.75 0 0 0-3.75-3.75A3.75 3.75 0 0 0 8.5 18v.5A1.5 1.5 0 0 1 7 20a3 3 0 0 1-3-3v-2h2v-2H0v2h2v2a5 5 0 0 0 5 5a3.5 3.5 0 0 0 3.5-3.5V18a1.75 1.75 0 0 1 1.75-1.75A1.75 1.75 0 0 1 14 18a4 4 0 0 0 4 4a4 4 0 0 0 4-4c0-2-2-4-2-6s2-4.5 2-6.5Z"/>'
        },
        gog: {
            body: '<path fill="currentColor" d="M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m6.46 2.54c-.51 0-.92.41-.92.92v3.08a.92.92 0 0 0 .92.92h3.08a.92.92 0 0 0 .92-.92V6.46c0-.51-.41-.92-.92-.92h-3.08m.62 1.23h1.84a.31.31 0 0 1 .31.31v1.84a.31.31 0 0 1-.31.31h-1.84a.31.31 0 0 1-.31-.31V7.08a.31.31 0 0 1 .31-.31M4.92 5.54a.92.92 0 0 0-.92.92v3.08c0 .51.41.92.92.92h2.16V9.23H5.54c-.17 0-.31-.14-.31-.31V7.08c0-.17.14-.31.31-.31h1.84a.31.31 0 0 1 .31.31v3.69a.31.31 0 0 1-.31.31H4v1.23h4c.5 0 .92-.42.92-.93V6.46A.92.92 0 0 0 8 5.54H4.92m11.08 0c-.5 0-.92.41-.92.92v3.08c0 .51.42.92.92.92h2.15V9.23h-1.53c-.17 0-.31-.14-.31-.31V7.08c0-.17.14-.31.31-.31h1.84c.17 0 .31.14.31.31v3.69c0 .17-.14.31-.31.31h-3.38v1.23h4c.51 0 .92-.42.92-.93V6.46c0-.51-.41-.92-.92-.92H16m-6.15 8c-.51 0-.93.41-.93.92v3.08c0 .51.42.92.93.92h3.07c.51 0 .93-.41.93-.92v-3.08c0-.51-.42-.92-.93-.92H9.85m.61 1.23h1.85a.3.3 0 0 1 .31.31v1.84a.31.31 0 0 1-.31.31h-1.85c-.17 0-.31-.14-.31-.31v-1.84a.31.31 0 0 1 .31-.31m-5.54-1.23c-.51 0-.92.41-.92.92v3.08c0 .51.41.92.92.92h3.39v-1.23H5.54c-.17 0-.31-.14-.31-.31v-1.84c0-.17.14-.31.31-.31h2.77v-1.23H4.92m10.46 0c-.51 0-.92.41-.92.92v4h1.23v-3.38a.31.31 0 0 1 .31-.31h.62v3.69h1.23v-3.69h.92v3.69H20v-4.92h-4.62Z"/>'
        },
        gold: {
            body: '<path fill="currentColor" d="m1 22l1.5-5h7l1.5 5H1m12 0l1.5-5h7l1.5 5H13m-7-7l1.5-5h7l1.5 5H6m17-8.95l-3.86 1.09L18.05 11l-1.09-3.86l-3.86-1.09l3.86-1.09l1.09-3.86l1.09 3.86L23 6.05Z"/>'
        },
        golf: {
            body: '<path fill="currentColor" d="M19.5 18a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5M17 5.92L11 9v9.03c2.84.16 5 .97 5 1.97c0 1.1-2.69 2-6 2s-6-.9-6-2c0-.74 1.21-1.38 3-1.73V20h2V2l8 3.92Z"/>'
        },
        "golf-cart": {
            body: '<path fill="currentColor" d="M19.89 12.37L18.25 5H19V3H3v4H1v2h2v3.54A6 6 0 0 0 1 17v2h2a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h2v-2a5 5 0 0 0-3.11-4.63M6 20.5A1.5 1.5 0 1 1 7.5 19A1.5 1.5 0 0 1 6 20.5m9.53-8.5l-1.15-1.72l1.42-.95l-1.1-1.66l-4.5 3l1.1 1.66l1.43-.95l1.15 1.74L13 14h-2.8L5 7V5h11.2l1.55 7m.25 8.5a1.5 1.5 0 1 1 1.5-1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "golf-tee": {
            body: '<path fill="currentColor" d="M7 19v-2h10v2h-2c-.5 0-1 .2-1.4.6s-.6.9-.6 1.4v1h-2v-1c0-.5-.2-1-.6-1.4S9.5 19 9 19H7m4-13c0-.3.1-.5.3-.7s.4-.3.7-.3s.5.1.7.3s.3.4.3.7s-.1.5-.3.7s-.4.3-.7.3s-.5-.1-.7-.3s-.3-.4-.3-.7m2 2c0-.3.1-.5.3-.7s.4-.3.7-.3s.5.1.7.3s.3.4.3.7s-.1.5-.3.7s-.4.3-.7.3s-.5-.1-.7-.3s-.3-.4-.3-.7M9 8c0-.3.1-.5.3-.7s.4-.3.7-.3s.5.1.7.3s.3.4.3.7s-.1.5-.3.7s-.4.3-.7.3s-.5-.1-.7-.3S9 8.3 9 8m7.9-3.9c-1.4-1.4-3-2-4.9-2s-3.6.7-4.9 2S5 7.1 5 9s.7 3.6 2 4.9s3 2 4.9 2s3.6-.7 4.9-2s2-3 2-4.9s-.5-3.6-1.9-4.9m-1.4 8.4c-1 1-2.2 1.5-3.5 1.5s-2.6-.5-3.5-1.5S7 10.4 7 9s.5-2.6 1.5-3.5S10.6 4 12 4s2.6.5 3.5 1.5S17 7.6 17 9s-.5 2.6-1.5 3.5Z"/>'
        },
        gondola: {
            body: '<path fill="currentColor" d="M18 10h-5V7.59l9.12-1.52l-.24-1.48l-5.47.91c.05-.15.09-.32.09-.5A1.5 1.5 0 0 0 15 3.5A1.5 1.5 0 0 0 13.5 5c0 .35.13.68.34.93l-.84.14V5h-2v1.41l-.59.09c.05-.15.09-.32.09-.5A1.5 1.5 0 0 0 9 4.5A1.5 1.5 0 0 0 7.5 6c0 .36.13.68.33.93l-5.95 1l.24 1.48L11 7.93V10H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2M6 12h2.25v4H6v-4m3.75 4v-4h4.5v4h-4.5M18 16h-2.25v-4H18v4Z"/>'
        },
        goodreads: {
            body: '<path fill="currentColor" d="M17 12.77c-1.04 1.65-2.78 2.73-4.75 2.73c-3.18 0-5.75-2.8-5.75-6.25S9.07 3 12.25 3c1.97 0 3.71 1.08 4.75 2.73V3h1v12.25c0 5.46-3.46 5.75-6.5 5.75c-2.5 0-3.95-1.69-4.37-4h1.01c.36 1.75 1.4 3 3.36 3c2.22 0 5.5.05 5.5-4.75v-2.48M12.25 4C9.63 4 7.5 6.35 7.5 9.25s2.13 5.25 4.75 5.25S17 12.15 17 9.25S14.87 4 12.25 4Z"/>'
        },
        google: {
            body: '<path fill="currentColor" d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27c3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10c5.35 0 9.25-3.67 9.25-9.09c0-1.15-.15-1.81-.15-1.81Z"/>'
        },
        "google-ads": {
            body: '<path fill="currentColor" d="M12.25 1.47c-.7-.05-1.43.11-2.08.49a3.656 3.656 0 0 0-1.35 5l7.34 12.7c1.01 1.76 3.25 2.34 5.01 1.34c1.75-1 2.33-3.25 1.33-5L15.18 3.3a3.695 3.695 0 0 0-2.93-1.83M6.82 6.76L1.5 16a3.67 3.67 0 0 0-.5 1.83a3.67 3.67 0 0 0 3.67 3.67a3.67 3.67 0 0 0 3.17-1.84v.01L11 14.19c-1.35-2.3-2.73-4.59-3.97-6.96c-.08-.15-.15-.31-.2-.47ZL16.4 5Z"/>'
        },
        "google-allo": {
            body: '<path d="M22 12v9c0 .5-.24.82-.7.96-.45.14-.8.01-1.1-.4l-1.54-2.11C16.78 21.14 14.56 22 12 22c-2.75 0-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2s5.1 1 7.05 2.95C21 6.9 22 9.25 22 12z" fill="currentColor"/>',
            hidden: true
        },
        "google-analytics": {
            body: '<path fill="currentColor" d="M15.86 4.39v15c0 1.67 1.14 2.61 2.39 2.61c1.14 0 2.39-.79 2.39-2.61V4.5c0-1.54-1.14-2.5-2.39-2.5s-2.39 1.06-2.39 2.39M9.61 12v7.39C9.61 21.07 10.77 22 12 22c1.14 0 2.39-.79 2.39-2.61v-7.28c0-1.54-1.14-2.5-2.39-2.5S9.61 10.67 9.61 12m-3.86 5.23c1.32 0 2.39 1.07 2.39 2.38a2.39 2.39 0 1 1-4.78 0c0-1.31 1.07-2.38 2.39-2.38Z"/>'
        },
        "google-assistant": {
            body: '<path fill="currentColor" d="M7 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m14.5 4A1.5 1.5 0 0 0 20 7.5A1.5 1.5 0 0 0 21.5 9A1.5 1.5 0 0 0 23 7.5A1.5 1.5 0 0 0 21.5 6M17 8a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 7a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 17 22a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 17 15Z"/>'
        },
        "google-cardboard": {
            body: '<path fill="currentColor" d="M20.74 6H3.2C2.55 6 2 6.57 2 7.27v10.46c0 .7.55 1.27 1.23 1.27H8c.54 0 1-.32 1.16-.79l1.39-3.47c.24-.58.8-.99 1.45-.99c.65 0 1.21.41 1.45.99l1.39 3.47c.19.47.62.79 1.11.79h4.79c.71 0 1.26-.57 1.26-1.27V7.27c0-.7-.55-1.27-1.26-1.27M7.22 14.58C6 14.58 5 13.55 5 12.29C5 11 6 10 7.22 10c1.22 0 2.21 1 2.21 2.29c0 1.26-.99 2.29-2.21 2.29m9.56 0c-1.22 0-2.21-1.03-2.21-2.29S15.56 10 16.78 10S19 11.03 19 12.29s-1 2.29-2.22 2.29Z"/>'
        },
        "google-chrome": {
            body: '<path fill="currentColor" d="m12 20l3.46-6h-.01c.34-.6.55-1.27.55-2c0-1.2-.54-2.27-1.38-3h4.79c.38.93.59 1.94.59 3a8 8 0 0 1-8 8m-8-8c0-1.46.39-2.82 1.07-4l3.47 6h.01c.69 1.19 1.95 2 3.45 2c.45 0 .88-.09 1.29-.23l-2.4 4.14C7 19.37 4 16.04 4 12m11 0a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3m-3-8a7.98 7.98 0 0 1 6.92 4H12c-1.94 0-3.55 1.38-3.92 3.21L5.7 7.08A7.981 7.981 0 0 1 12 4m0-2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "google-circles": {
            body: '<path fill="currentColor" d="M16.66 15H17c1 0 2-.2 2.87-.54c-.7 4.27-4.4 7.54-8.87 7.54c-5 0-9-4.03-9-9c0-4.47 3.27-8.17 7.54-8.87C9.2 5 9 6 9 7v.34c-2.32.82-4 3.04-4 5.66a6 6 0 0 0 6 6c2.62 0 4.84-1.68 5.66-4m.34-5a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0-9a6 6 0 0 1 6 6a6 6 0 0 1-6 6a6 6 0 0 1-6-6c0-3.32 2.69-6 6-6Z"/>'
        },
        "google-circles-communities": {
            body: '<path fill="currentColor" d="M15 12c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-3 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m2 7a2 2 0 0 0-2-2c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2m-5 3a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "google-circles-extended": {
            body: '<path fill="currentColor" d="M18 19a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m0-6a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m-6-1.9a1.9 1.9 0 0 0-1.9 1.9a1.9 1.9 0 0 0 1.9 1.9a1.9 1.9 0 0 0 1.9-1.9a1.9 1.9 0 0 0-1.9-1.9M6 19a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m0-6a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m6-9a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m0 6a4 4 0 0 0 4-4a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4Z"/>'
        },
        "google-circles-group": {
            body: '<path fill="currentColor" d="M5 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m0 6a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m5.5-5H14V8l4 4l-4 4v-3h-3.5v-2M5 6c-.45 0-.89.05-1.31.14C5.63 3.05 9.08 1 13 1c6.08 0 11 4.92 11 11s-4.92 11-11 11c-3.92 0-7.37-2.05-9.31-5.14c.42.09.86.14 1.31.14c.8 0 1.56-.16 2.25-.44A7.956 7.956 0 0 0 13 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8c-2.26 0-4.29.93-5.75 2.44C6.56 6.16 5.8 6 5 6Z"/>'
        },
        "google-classroom": {
            body: '<path fill="currentColor" d="M23 2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18h-2v-1h-5v1H2V4h20v16M10.29 9.71A1.71 1.71 0 0 1 12 8c.95 0 1.71.77 1.71 1.71c0 .95-.76 1.72-1.71 1.72s-1.71-.77-1.71-1.72m-4.58 1.58c0-.71.58-1.29 1.29-1.29a1.29 1.29 0 0 1 1.29 1.29c0 .71-.58 1.28-1.29 1.28c-.71 0-1.29-.57-1.29-1.28m10 0A1.29 1.29 0 0 1 17 10a1.29 1.29 0 0 1 1.29 1.29c0 .71-.58 1.28-1.29 1.28c-.71 0-1.29-.57-1.29-1.28M20 15.14V16H4v-.86c0-.94 1.55-1.71 3-1.71c.55 0 1.11.11 1.6.3c.75-.69 2.1-1.16 3.4-1.16c1.3 0 2.65.47 3.4 1.16c.49-.19 1.05-.3 1.6-.3c1.45 0 3 .77 3 1.71Z"/>'
        },
        "google-cloud": {
            body: '<path fill="currentColor" d="M23 14.75C23 18.2 20.2 21 16.75 21h-9.5C3.8 21 1 18.2 1 14.75c0-2.14 1.08-4.03 2.71-5.15C4.58 5.82 7.96 3 12 3c4.04 0 7.42 2.82 8.29 6.6A6.22 6.22 0 0 1 23 14.75M16.63 17c1.31 0 2.37-1.06 2.37-2.37c0-1.28-1-2.33-2.28-2.38l.03-.5a4.754 4.754 0 0 0-8.32-3.14c1.5.29 2.8 1.11 3.71 2.25L9.5 13.5c-.42-.73-1.21-1.25-2.12-1.25c-1.32 0-2.38 1.06-2.38 2.38c0 1.27 1 2.3 2.25 2.37h9.38Z"/>'
        },
        "google-downasaur": {
            body: '<path fill="currentColor" d="M13 2v1h-1v6h-1v1H9v1H8v1H7v1H5v-1H4v-1H3V9H2v6h1v1h1v1h1v1h1v4h2v-1H7v-1h1v-1h1v-1h1v1h1v3h2v-1h-1v-4h1v-1h1v-1h1v-3h1v1h1v-2h-2V9h5V8h-3V7h5V3h-1V2m-7 1h1v1h-1Z"/>'
        },
        "google-drive": {
            body: '<path fill="currentColor" d="M7.71 3.5L1.15 15l3.43 6l6.55-11.5M9.73 15L6.3 21h13.12l3.43-6m-.57-1L15.42 2H8.57l6.86 12h6.85Z"/>'
        },
        "google-earth": {
            body: '<path fill="currentColor" d="M12 12.14c-.91-1.37-1.86-2.36-2.86-2.95c-1-.6-1.87-.81-2.64-.64c-.73.18-1.36.59-1.86 1.25c-.44.59-.64 1.26-.64 2.01V12c0 .78.11 1.58.36 2.39c.09.25.14.25.19 0c.12-.62.41-1.08.86-1.36c.46-.28 1.06-.27 1.81.02c.75.3 1.48.95 2.2 1.9c1.28 1.72 2.78 2.77 4.5 3.14c2.22.32 3.89-.39 5.02-2.09c.31-.61.56-1.14.7-1.61c.09-.31.05-.34-.14-.09c-.47.62-1.1 1.03-1.9 1.2c-.8.2-1.71 0-2.74-.5c-1.03-.57-1.98-1.5-2.86-2.86m4.97-3.98c-1.56-2.35-3.25-3.66-5.06-3.99c-1.44-.22-3 .28-4.69 1.5c-.22.16-.32.24-.31.26c.02.02.15-.04.4-.16c2.5-1.22 4.91.06 7.22 3.84c.5.84 1.02 1.5 1.57 1.97s1.06.75 1.55.84c.48.08.92.08 1.31-.04c.39-.13.74-.33 1.04-.61c0-.6-.09-1.27-.31-1.97c-.5.12-.95.08-1.34-.12c-.39-.18-.85-.71-1.38-1.52M12 2c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12s-1 5.1-2.95 7.05C17.1 21 14.75 22 12 22s-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2Z"/>'
        },
        "google-fit": {
            body: '<path fill="currentColor" d="M17 4a5 5 0 0 1 5 5c0 1.38-.56 2.63-1.46 3.54L12 21.07l-8.54-8.53C2.56 11.63 2 10.38 2 9a5 5 0 0 1 5-5c1.38 0 2.63.56 3.54 1.46L12 6.93l1.46-1.47C14.37 4.56 15.62 4 17 4m-1.41 3.59L9.17 14L12 16.83l6.41-6.42c.37-.36.59-.86.59-1.41a2 2 0 0 0-2-2c-.55 0-1.05.22-1.41.59m-7.18 0C8.05 7.22 7.55 7 7 7a2 2 0 0 0-2 2c0 .55.22 1.05.59 1.41l1.46 1.47l2.83-2.83l-1.47-1.46Z"/>'
        },
        "google-glass": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-3.25 16h-1.5V8.9L6.72 18H4.66L15.45 6.5c.21-.24.55-.31.82-.2c.29.12.48.39.48.7v11Z"/>'
        },
        "google-hangouts": {
            body: '<path fill="currentColor" d="m15 11l-1 2h-1.5l1-2H12V8h3m-4 3l-1 2H8.5l1-2H8V8h3m.5-6A8.5 8.5 0 0 0 3 10.5a8.5 8.5 0 0 0 8.5 8.5h.5v3.5c4.86-2.35 8-7.5 8-12A8.5 8.5 0 0 0 11.5 2Z"/>'
        },
        "google-home": {
            body: '<path fill="currentColor" d="M8.06 7.78c-.56 0-.89-.05-.98-.14l-.42 6.09c.53.32 1.22.57 2.06.77c.84.21 2.06.27 3.66.17c1.59-.09 3.25-.44 4.96-1.03l-.79-9.42c-.88.87-2.17 1.69-3.89 2.44c-1.53.65-2.85 1.03-3.94 1.12h-.66m-.09-2.44c-.69.6-.97 1-.84 1.22c.09.22.57.28 1.45.19c1.09-.09 2.33-.44 3.7-1.03c.94-.41 1.75-.84 2.44-1.31c.69-.47 1.16-.86 1.41-1.18c.25-.31.34-.53.28-.65c-.07-.16-.38-.24-.94-.24c-1.13 0-2.53.36-4.22 1.08c-1.44.63-2.53 1.27-3.28 1.92m9.37-3.14c.07.13.1.27.1.43L18.61 17c0 1.73-.61 3.09-1.78 4.07c-1.19.98-2.8 1.48-4.83 1.48c-2 0-3.6-.51-4.8-1.55c-1.2-1-1.81-2.36-1.81-4.08l.7-10.45c0-.25.11-.53.33-.84c.22-.32.42-.57.61-.75l.33-.29c.97-.81 2.14-1.51 3.52-2.09c.93-.42 1.85-.73 2.74-.93c.88-.2 1.68-.27 2.38-.19c.71.08 1.16.35 1.34.82Z"/>',
            hidden: true
        },
        "google-keep": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v13.33L17.33 22H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m13 15v3.25L20.25 17H17m-7 2h4v-1h1v-5a5.002 5.002 0 0 0-3-9a5.002 5.002 0 0 0-3 9v5h1v1m4-2h-4v-2h4v2M12 5c2.21 0 4 1.79 4 4c0 1.5-.8 2.77-2 3.46V14h-4v-1.54C8.8 11.77 8 10.5 8 9c0-2.21 1.79-4 4-4Z"/>'
        },
        "google-lens": {
            body: '<path fill="currentColor" d="M6 2h12a4 4 0 0 1 4 4v6h-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6v2H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4m6 6a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m6 8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "google-maps": {
            body: '<path fill="currentColor" d="M18.27 6c1.01 2.17.78 4.73-.33 6.81c-.94 1.69-2.29 3.12-3.44 4.69c-.5.7-1 1.45-1.37 2.26c-.13.27-.22.55-.32.83c-.1.28-.19.56-.28.84c-.09.26-.2.57-.53.57c-.39 0-.5-.44-.58-.74c-.24-.73-.48-1.43-.85-2.1c-.42-.79-.95-1.52-1.49-2.23L18.27 6M9.12 8.42l-3.3 3.92c.61 1.29 1.52 2.39 2.39 3.49c.21.25.42.51.62.78L13 11.67l-.04.01c-1.46.5-3.08-.24-3.66-1.68c-.08-.17-.14-.37-.18-.57a3.05 3.05 0 0 1 0-1v-.01m-2.54-3.8l-.01.01c-1.62 2.05-1.9 4.9-.93 7.31L9.63 7.2l-.05-.05l-3-2.53m7.64-2.26L11 6.17l.04-.01c1.34-.46 2.84.12 3.52 1.34c.15.28.27.58.31.88c.06.38.08.65.01 1.02v.01l3.2-3.8a6.988 6.988 0 0 0-3.85-3.24l-.01-.01M9.89 6.89l3.91-4.65l-.04-.01C13.18 2.08 12.59 2 12 2c-1.97 0-3.83.85-5.15 2.31l-.02.01l3.06 2.57Z"/>'
        },
        "google-my-business": {
            body: '<path fill="currentColor" d="M22 8.5c0 1.37-1.12 2.5-2.5 2.5S17 9.87 17 8.5c0 1.37-1.12 2.5-2.5 2.5S12 9.87 12 8.5c0 1.37-1.12 2.5-2.5 2.5S7 9.87 7 8.5C7 9.87 5.88 11 4.5 11S2 9.87 2 8.5l1.39-5.42S3.68 2 4.7 2h14.6c1.02 0 1.31 1.08 1.31 1.08L22 8.5m-1 3.7V20c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-7.8a3.96 3.96 0 0 0 4-.58c.69.55 1.56.88 2.5.88c.95 0 1.82-.33 2.5-.88c.69.55 1.56.88 2.5.88c.95 0 1.82-.33 2.5-.88c.68.55 1.56.88 2.5.88c.53 0 1.04-.11 1.5-.3m-2 5.13c0-.2 0-.41-.05-.63l-.03-.16h-2.97v1.17h1.81c-.06.22-.14.44-.31.62c-.33.33-.78.51-1.26.51c-.5 0-.99-.21-1.35-.56c-.69-.71-.69-1.86.02-2.58c.69-.7 1.83-.7 2.55-.03l.14.13l.84-.85l-.16-.14c-.56-.52-1.3-.81-2.08-.81h-.01c-.81 0-1.57.31-2.14.87c-.59.58-.92 1.34-.92 2.13c0 .8.31 1.54.88 2.09a3.2 3.2 0 0 0 2.22.91h.02c.8 0 1.51-.29 2.03-.8c.47-.48.77-1.2.77-1.87Z"/>'
        },
        "google-nearby": {
            body: '<path fill="currentColor" d="m21.36 10.46l-7.82-7.82c-.85-.85-2.23-.85-3.08 0l-7.82 7.82c-.85.85-.85 2.23 0 3.08l7.82 7.82c.85.85 2.23.85 3.08 0l7.82-7.82c.85-.85.85-2.23 0-3.08M12 19l-7-7l7-7l7 7l-7 7m4.5-7L12 16.5L7.5 12L12 7.5l4.5 4.5Z"/>'
        },
        "google-pages": {
            body: '<path d="M19 3h-6v5l4-1l-1 4h5V5a2 2 0 0 0-2-2m-2 14l-4-1v5h6a2 2 0 0 0 2-2v-6h-5m-8 0H3v6a2 2 0 0 0 2 2h6v-5l-4 1M3 5v6h5L7 7l4 1V3H5c-1.11 0-2 .89-2 2z" fill="currentColor"/>',
            hidden: true
        },
        "google-photos": {
            body: '<path d="M10 13c.55 0 1 .18 1.41.57c.39.39.59.87.59 1.43v7c0 .17-.09.27-.28.27c-.06 0-.14-.05-.22-.14L7 17.67V13h3m2.5-11.12L17 6.33V11h-3c-.55 0-1-.18-1.41-.57C12.2 10.04 12 9.56 12 9V2c0-.17.09-.27.28-.27c.06 0 .14.05.22.15M22 12c.17 0 .27.09.27.28c0 .06-.05.14-.14.22L17.67 17H13v-3c0-.55.18-1 .57-1.41c.39-.39.87-.59 1.43-.59h7M6.33 7H11v3c0 .55-.18 1-.57 1.41c-.39.39-.87.59-1.43.59H2c-.17 0-.27-.09-.27-.28c0-.06.05-.14.15-.22L6.33 7z" fill="currentColor"/>',
            hidden: true
        },
        "google-physical-web": {
            body: '<path d="M12 1.5a9 9 0 0 1 9 9c0 2.61-1.11 4.97-2.89 6.61l-1.06-1.06a7.503 7.503 0 0 0 2.45-5.55A7.5 7.5 0 0 0 12 3a7.5 7.5 0 0 0-7.5 7.5c0 2.2.95 4.18 2.45 5.55l-1.06 1.06C4.11 15.47 3 13.11 3 10.5a9 9 0 0 1 9-9m0 3a6 6 0 0 1 6 6c0 1.78-.78 3.39-2 4.5l-1.08-1.08c.97-.82 1.58-2.05 1.58-3.42C16.5 8 14.5 6 12 6s-4.5 2-4.5 4.5c0 1.37.61 2.6 1.58 3.42L8 15c-1.22-1.11-2-2.72-2-4.5a6 6 0 0 1 6-6M8.11 17.65l3.18-3.19c.39-.39 1.03-.39 1.42 0l3.18 3.19c.39.39.39 1.02 0 1.41l-3.18 3.18c-.39.39-1.03.39-1.42 0l-3.18-3.18a.996.996 0 0 1 0-1.41z" fill="currentColor"/>',
            hidden: true
        },
        "google-play": {
            body: '<path fill="currentColor" d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12l-9.85 9.85c-.5-.25-.84-.76-.84-1.35m13.81-5.38L6.05 21.34l8.49-8.49l2.27 2.27m3.35-4.31c.34.27.59.69.59 1.19s-.22.9-.57 1.18l-2.29 1.32l-2.5-2.5l2.5-2.5l2.27 1.31M6.05 2.66l10.76 6.22l-2.27 2.27l-8.49-8.49Z"/>'
        },
        "google-plus": {
            body: '<path fill="currentColor" d="M23 11h-2V9h-2v2h-2v2h2v2h2v-2h2M8 11v2.4h4c-.2 1-1.2 3-4 3c-2.4 0-4.3-2-4.3-4.4c0-2.4 1.9-4.4 4.3-4.4c1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 5.7 9.9 5 8 5c-3.9 0-7 3.1-7 7s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8c0-.5 0-.8-.1-1.2H8Z"/>'
        },
        "google-plus-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m14.5 9H18v-1.5h-1V12h-1.5v1H17v1.5h1V13h1.5v-1m-9.85-.64v1.54h2.57c-.13.64-.77 1.93-2.57 1.93c-1.54 0-2.76-1.29-2.76-2.83s1.22-2.83 2.76-2.83c.9 0 1.48.39 1.8.71l1.22-1.16c-.77-.77-1.8-1.22-3.02-1.22c-2.51 0-4.5 2-4.5 4.5s1.99 4.5 4.5 4.5c2.57 0 4.31-1.8 4.31-4.37c0-.32 0-.52-.07-.77H9.65z" fill="currentColor"/>',
            hidden: true
        },
        "google-podcast": {
            body: '<path fill="currentColor" d="M17.68 7.22v1.4c0 .68-.55 1.24-1.25 1.24c-.69 0-1.25-.56-1.25-1.24v-1.4a1.25 1.25 0 0 1 1.25-1.25c.7 0 1.25.56 1.25 1.25m-4.43 1.14v7.27a1.25 1.25 0 0 1-2.5 0V8.36c0-.68.56-1.25 1.25-1.25s1.25.57 1.25 1.25M22 11.3v1.4c0 .68-.56 1.24-1.25 1.24s-1.25-.56-1.25-1.24v-1.4c0-.69.56-1.24 1.25-1.24S22 10.61 22 11.3m-17.5 0v1.4c0 .68-.56 1.24-1.25 1.24c-.7 0-1.25-.56-1.25-1.24v-1.4c0-.69.55-1.24 1.25-1.24c.69 0 1.25.55 1.25 1.24m4.32 4.08v1.39c0 .68-.56 1.23-1.25 1.23s-1.25-.55-1.25-1.23v-1.39c0-.7.56-1.25 1.25-1.25a1.25 1.25 0 0 1 1.25 1.25m4.43 3.98v1.39A1.25 1.25 0 0 1 12 22a1.25 1.25 0 0 1-1.25-1.25v-1.39A1.25 1.25 0 0 1 12 18.11a1.25 1.25 0 0 1 1.25 1.25m0-16.11v1.39A1.25 1.25 0 0 1 12 5.89a1.25 1.25 0 0 1-1.25-1.25V3.25c0-.7.56-1.25 1.25-1.25a1.25 1.25 0 0 1 1.25 1.25m4.43 9.09v4.43c0 .69-.55 1.23-1.25 1.23c-.69 0-1.25-.54-1.25-1.23v-4.43c0-.7.56-1.25 1.25-1.25c.7 0 1.25.55 1.25 1.25M8.82 7.22v4.43c0 .7-.56 1.25-1.25 1.25a1.25 1.25 0 0 1-1.25-1.25V7.22a1.25 1.25 0 0 1 1.25-1.25a1.25 1.25 0 0 1 1.25 1.25Z"/>'
        },
        "google-spreadsheet": {
            body: '<path fill="currentColor" d="M19 11V9h-8V5H9v4H5v2h4v8h2v-8h8m0-8c.5 0 1 .2 1.39.61C20.8 4 21 4.5 21 5v14c0 .5-.2 1-.61 1.39c-.39.41-.89.61-1.39.61H5c-.5 0-1-.2-1.39-.61C3.2 20 3 19.5 3 19V5c0-.5.2-1 .61-1.39C4 3.2 4.5 3 5 3h14Z"/>'
        },
        "google-street-view": {
            body: '<path fill="currentColor" d="M11.95 9.27a3.64 3.64 0 0 0 3.64-3.64c0-2-1.63-3.63-3.64-3.63a3.63 3.63 0 0 0-3.63 3.63c0 2.01 1.62 3.64 3.63 3.64m-2.59 3.7s-1.09 2.97-1.4 3.53c-.11.21-.09.27-.36.27s-.69-.27-.69-.27s-.2-.13-.12-.36c.24-.74 1.33-5.06 1.56-5.89c.25-.89.93-.86.93-.86h.65l2.1 3.65l2.11-3.65h.78s.31.04.54.31c.24.27.29.74.29.74l1.39 5.4s.1.38.07.49c-.04.17-.13.17-.13.17s-.39.12-.61.19c-.4.13-.47-.25-.47-.25l-1.3-3.4l-.15 8.96H12.6l-.33-5.11s-.06-.13-.24-.13a.25.25 0 0 0-.23.13L11.45 22H9.5l-.13-9.03h-.01Z"/>'
        },
        "google-translate": {
            body: '<path fill="currentColor" d="M20 5h-9.12L10 2H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h7l1 3h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M7.17 14.59a4.09 4.09 0 0 1-4.09-4.09a4.09 4.09 0 0 1 4.09-4.09c1.04 0 1.99.37 2.74 1.09l.09.04l-1.25 1.18l-.06-.05c-.29-.27-.78-.59-1.52-.59c-1.31 0-2.38 1.09-2.38 2.42c0 1.33 1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.09c.04.19.05.38.05.59c0 2.35-1.59 4-3.92 4m6.03-1.71c.33.62.74 1.18 1.19 1.7l-.54.53l-.65-2.23m.77-.76H13l-.33-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7M21 20a1 1 0 0 1-1 1h-7l2-2l-.81-2.77l.92-.92L17.79 18l.71-.73l-2.69-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20a1 1 0 0 1 1 1v13Z"/>'
        },
        "google-wallet": {
            body: '<path d="M15.44 2.56h4.8s2.88 8.8 0 18.96h-4.72s-.4-4.72-2.24-8.72c0 0-.8 3.28-1.68 5.2H6.72s-.96-4.56-4.24-8.48h4.8s.88.88 1.6 2.08c0 0 .64-2.48.64-5.6h4.8s1.6 2.32 2.32 3.76c0 0-.24-3.52-1.2-7.2z" fill="currentColor"/>',
            hidden: true
        },
        "gradient-horizontal": {
            body: '<path fill="currentColor" d="M9 13v-2h2v2m0 2v-2h2v2m-2-4V9h2v2M9 9V7h2v2m-2 8v-2h2v2M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2m15 10v2h-2v-2m2-4v2h-2v-2m2-4v2h-2V7m-5-2v2h2V5h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v-2h-2v2H5V5Z"/>'
        },
        "gradient-vertical": {
            body: '<path fill="currentColor" d="M11 9h2v2h-2V9m-2 2h2v2H9v-2m4 0h2v2h-2v-2m2-2h2v2h-2V9M7 9h2v2H7V9m12-6H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M9 18H7v-2h2v2m4 0h-2v-2h2v2m4 0h-2v-2h2v2m2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6Z"/>'
        },
        grain: {
            body: '<path fill="currentColor" d="M10 12a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M6 8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m12-8a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m-4 8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m4-4a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-4-4a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-4-4a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        graph: {
            body: '<path fill="currentColor" d="M19.5 17c-.13 0-.26 0-.39.04l-1.61-3.25a2.5 2.5 0 0 0-1.75-4.29c-.13 0-.25 0-.39.04l-1.63-3.25c.48-.45.77-1.08.77-1.79a2.5 2.5 0 0 0-5 0c0 .71.29 1.34.76 1.79L8.64 9.54c-.14-.04-.26-.04-.39-.04a2.5 2.5 0 0 0-1.75 4.29l-1.61 3.25C4.76 17 4.63 17 4.5 17a2.5 2.5 0 0 0 0 5A2.5 2.5 0 0 0 7 19.5c0-.7-.29-1.34-.76-1.79l1.62-3.25c.14.04.26.04.39.04s.25 0 .39-.04l1.63 3.25c-.47.45-.77 1.09-.77 1.79a2.5 2.5 0 0 0 5 0A2.5 2.5 0 0 0 12 17c-.13 0-.26 0-.39.04L10 13.79c.46-.45.75-1.08.75-1.79s-.29-1.34-.75-1.79l1.61-3.25c.13.04.26.04.39.04s.26 0 .39-.04L14 10.21c-.45.45-.75 1.09-.75 1.79a2.5 2.5 0 0 0 2.5 2.5c.13 0 .25 0 .39-.04l1.63 3.25c-.47.45-.77 1.09-.77 1.79a2.5 2.5 0 0 0 5 0a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "graph-outline": {
            body: '<path fill="currentColor" d="M19.5 17c-.14 0-.26 0-.39.04L17.5 13.8c.45-.45.75-1.09.75-1.8a2.5 2.5 0 0 0-2.5-2.5c-.14 0-.25 0-.4.04L13.74 6.3c.47-.46.76-1.09.76-1.8a2.5 2.5 0 0 0-5 0c0 .7.29 1.34.76 1.79L8.65 9.54c-.15-.04-.26-.04-.4-.04a2.5 2.5 0 0 0-2.5 2.5c0 .71.29 1.34.75 1.79l-1.61 3.25C4.76 17 4.64 17 4.5 17a2.5 2.5 0 0 0 0 5A2.5 2.5 0 0 0 7 19.5c0-.7-.29-1.34-.76-1.79l1.62-3.25c.14.04.26.04.39.04s.25 0 .38-.04l1.63 3.25c-.47.45-.76 1.09-.76 1.79a2.5 2.5 0 0 0 5 0A2.5 2.5 0 0 0 12 17c-.13 0-.26 0-.39.04L10 13.8c.45-.45.75-1.09.75-1.8c0-.7-.29-1.33-.75-1.79l1.61-3.25c.13.04.26.04.39.04s.26 0 .39-.04L14 10.21a2.5 2.5 0 0 0 1.75 4.29c.13 0 .25 0 .38-.04l1.63 3.25c-.47.45-.76 1.09-.76 1.79a2.5 2.5 0 0 0 5 0a2.5 2.5 0 0 0-2.5-2.5m-15 3.5c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m8.5-1c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1M7.25 12c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1M11 4.5c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m3.75 7.5c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m4.75 8.5c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        graphql: {
            body: '<path fill="currentColor" d="m12 5.37l-.44-.06L6 14.9c.24.21.4.48.47.78h11.06c.07-.3.23-.57.47-.78l-5.56-9.59l-.44.06M6.6 16.53l4.28 2.53c.29-.27.69-.43 1.12-.43c.43 0 .83.16 1.12.43l4.28-2.53H6.6M12 22a1.68 1.68 0 0 1-1.68-1.68l.09-.56l-4.3-2.55c-.31.36-.76.58-1.27.58a1.68 1.68 0 0 1-1.68-1.68c0-.79.53-1.45 1.26-1.64V9.36c-.83-.11-1.47-.82-1.47-1.68A1.68 1.68 0 0 1 4.63 6c.55 0 1.03.26 1.34.66l4.41-2.53l-.06-.45c0-.93.75-1.68 1.68-1.68c.93 0 1.68.75 1.68 1.68l-.06.45l4.41 2.53c.31-.4.79-.66 1.34-.66a1.68 1.68 0 0 1 1.68 1.68c0 .86-.64 1.57-1.47 1.68v5.11c.73.19 1.26.85 1.26 1.64a1.68 1.68 0 0 1-1.68 1.68c-.51 0-.96-.22-1.27-.58l-4.3 2.55l.09.56A1.68 1.68 0 0 1 12 22M10.8 4.86L6.3 7.44l.02.24c0 .71-.44 1.32-1.06 1.57l.03 5.25l5.51-9.64m2.4 0l5.51 9.64l.03-5.25c-.62-.25-1.06-.86-1.06-1.57l.02-.24l-4.5-2.58Z"/>'
        },
        grass: {
            body: '<path fill="currentColor" d="M12 20H2v-2h5.75C7 15.19 4.81 13 2 12.26c.64-.16 1.31-.26 2-.26c4.42 0 8 3.58 8 8m10-7.74c-.64-.16-1.31-.26-2-.26c-2.93 0-5.5 1.58-6.88 3.93c.29.66.53 1.35.67 2.07c.13.65.21 1.32.21 2h8v-2h-5.76c.76-2.81 2.95-5 5.76-5.74M15.64 11c.78-2.07 2.23-3.82 4.09-5c-4.29.16-7.73 3.67-7.73 8c.95-1.25 2.2-2.28 3.64-3m-4.22-2.15A8.527 8.527 0 0 0 6.7 4C8.14 5.86 9 8.18 9 10.71c0 .21-.03.41-.04.61c.43.24.83.52 1.22.82a9.91 9.91 0 0 1 1.24-3.29Z"/>'
        },
        "grave-stone": {
            body: '<path fill="currentColor" d="M10 2h4c3.31 0 5 2.69 5 6v10.66C16.88 17.63 15.07 17 12 17s-4.88.63-7 1.66V8c0-3.31 1.69-6 5-6M8 8v1.5h8V8H8m1 4v1.5h6V12H9M3 22v-.69c2.66-1.69 10.23-5.47 18-.06V22H3Z"/>'
        },
        "grease-pencil": {
            body: '<path fill="currentColor" d="M18.62 1.5c-.51 0-1.02.19-1.41.59l-6.46 6.46l4.2 4.19l6.46-6.45c.79-.79.79-2.05 0-2.83l-1.37-1.37c-.39-.4-.9-.59-1.42-.59m-8.82 8l-6.57 6.57l.7.7c-.53.47-1.04 1.01-1.55 1.52c-.78.79-.78 2.05 0 2.83c.78.78 2.04.78 2.83 0c.51-.49 1.04-1.04 1.52-1.54l.7.69L14 13.7"/>'
        },
        "greater-than": {
            body: '<path fill="currentColor" d="m5.5 4.14l-1 1.72L15 12L4.5 18.14l1 1.72L19 12L5.5 4.14Z"/>'
        },
        "greater-than-or-equal": {
            body: '<path fill="currentColor" d="M6.5 2.27L20 10.14L6.5 18l-1-1.73l10.53-6.13L5.5 4l1-1.73M20 20v2H5v-2h15Z"/>'
        },
        greenhouse: {
            body: '<path fill="currentColor" d="M12 3L4 9v12h16V9l-8-6m-2 7h4v9h-4v-9m6 0h2v3h-2v-3m-.67-2H8.67L12 5.5L15.33 8M8 10v3H6v-3h2m-2 5h2v4H6v-4m10 4v-4h2v4h-2Z"/>'
        },
        grid: {
            body: '<path fill="currentColor" d="M10 4v4h4V4h-4m6 0v4h4V4h-4m0 6v4h4v-4h-4m0 6v4h4v-4h-4m-2 4v-4h-4v4h4m-6 0v-4H4v4h4m0-6v-4H4v4h4m0-6V4H4v4h4m2 6h4v-4h-4v4M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4c-1.08 0-2-.9-2-2V4a2 2 0 0 1 2-2Z"/>'
        },
        "grid-large": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4c-1.08 0-2-.9-2-2V4a2 2 0 0 1 2-2m0 2v7h7V4H4m0 16h7v-7H4v7m16 0v-7h-7v7h7m0-16h-7v7h7V4Z"/>'
        },
        "grid-off": {
            body: '<path fill="currentColor" d="M0 2.77L1.28 1.5L22.5 22.72L21.23 24l-2-2H4c-1.08 0-2-.9-2-2V4.77l-2-2M10 4v3.68l-2-2V4H6.32l-2-2H20a2 2 0 0 1 2 2v15.7l-2-2V16h-1.68l-2-2H20v-4h-4v3.68l-2-2V10h-1.68l-2-2H14V4h-4m6 0v4h4V4h-4m0 16h1.23L16 18.77V20M4 8h1.23L4 6.77V8m6 6h1.23L10 12.77V14m4 6v-3.23l-.77-.77H10v4h4m-6 0v-4H4v4h4m0-6v-3.23L7.23 10H4v4h4Z"/>'
        },
        grill: {
            body: '<path fill="currentColor" d="M8.06 2c-.18 1.17.11 2.16.89 2.97c.5.5.66 1.17.47 2.03h.99c.12-.55.14-1 .04-1.45c-.09-.42-.4-.92-.95-1.52c-.45-.56-.61-1.23-.45-2.03h-.99m2.49 0c-.19 1.17.11 2.16.89 2.97c.5.5.65 1.17.47 2.03h.98c.11-.55.14-1 .05-1.45c-.1-.42-.41-.92-.94-1.52c-.47-.56-.62-1.23-.47-2.03h-.98m2.53 0c-.19 1.17.11 2.16.89 2.97c.5.5.64 1.17.42 2.03h1.03c.13-.55.14-1 .05-1.45c-.09-.42-.41-.92-.94-1.52c-.47-.56-.62-1.23-.47-2.03h-.98M5 8c0 1.42.39 2.7 1.14 3.84a6.892 6.892 0 0 0 3 2.55l-3.98 6.05c-.1.12-.16.31-.16.56c0 .41.16.69.44.84c.12.1.31.16.56.16c.41 0 .69-.16.84-.44l.99-1.59h6.37c.21.58.59 1.08 1.08 1.45c.5.38 1.08.58 1.72.58c.83 0 1.53-.31 2.13-.91c.59-.59.87-1.29.87-2.09c0-.83-.28-1.53-.87-2.12c-.6-.6-1.3-.88-2.13-.88c-.64 0-1.22.17-1.72.55c-.5.37-.86.86-1.08 1.45H9.14l1.97-3.05c.16.05.45.05.89.05s.73 0 .89-.05l.99 1.55c.41-.54.96-.96 1.59-1.22l-.56-.89c1.12-.5 2.09-1.39 2.88-2.62C18.59 10.5 19 9.27 19 8H5m12 10c.3 0 .53.09.72.28c.19.19.28.44.28.72c0 .27-.09.5-.28.71c-.18.2-.44.29-.72.29c-.26 0-.5-.09-.71-.29A.998.998 0 0 1 16 19c0-.3.09-.53.29-.72c.21-.19.44-.28.71-.28Z"/>'
        },
        "grill-outline": {
            body: '<path fill="currentColor" d="M17 22a3 3 0 1 0-2.82-4H9.14l1.99-3.06a6.36 6.36 0 0 0 1.74 0l1.02 1.56c.42-.5.96-.94 1.61-1.2l-.61-.93A7 7 0 0 0 19 8H5a7 7 0 0 0 4.12 6.37l-3.95 6.08a1 1 0 0 0 1.67 1.09l1-1.54h6.34A3 3 0 0 0 17 22m0-4a1 1 0 0 1 1 1c0 .55-.45 1-1 1s-1-.45-1-1a1 1 0 0 1 1-1m-9.58-8h9.16a5 5 0 0 1-9.16 0m1.99-3h1c.15-1.15.23-1.64-.91-2.96c-.4-.5-.66-.77-.44-2.04h-.99a3.14 3.14 0 0 0 .89 2.96c.22.24.79.67.45 2.04m2.48 0h1c.15-1.15.23-1.64-.89-2.96c-.42-.5-.68-.78-.46-2.04h-.99a3.14 3.14 0 0 0 .89 2.96c.23.24.8.67.45 2.04m2.52 0h1c.15-1.15.23-1.64-.91-2.96c-.4-.5-.66-.77-.44-2.04h-.99a3.14 3.14 0 0 0 .89 2.96c.22.24.79.67.45 2.04Z"/>'
        },
        group: {
            body: '<path fill="currentColor" d="M1 1v4h1v14H1v4h4v-1h14v1h4v-4h-1V5h1V1h-4v1H5V1m0 3h14v1h1v14h-1v1H5v-1H4V5h1m1 1v8h3v4h9V9h-4V6M8 8h4v4H8m6-1h2v5h-5v-2h3"/>'
        },
        "guitar-acoustic": {
            body: '<path fill="currentColor" d="M19.59 3H22v2h-1.59l-4.24 4.24c-.37-.56-.85-1.04-1.41-1.41L19.59 3M12 8a4 4 0 0 1 4 4a3.99 3.99 0 0 1-3 3.87V16a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5h.13c.45-1.76 2.04-3 3.87-3m0 2.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m-5.06 3.74l-.71.7l2.83 2.83l.71-.71l-2.83-2.82Z"/>'
        },
        "guitar-electric": {
            body: '<path fill="currentColor" d="M19.59 3H22v2h-1.59l-5.29 5.29l-1.41-1.39L19.59 3M12 9c.26 0 .5.1.71.3l2 2c.18.2.29.43.29.7l-.1.4l-4 8c-.19.35-.54.53-.9.53c-.35 0-.71-.18-.89-.53l-1.86-3.7l-3.7-1.8c-.37-.2-.55-.55-.55-.9s.18-.7.55-.9l8-4c.14-.1.29-.1.45-.1m-2.65 2.82l-.7.68l2.85 2.85l.68-.7l-2.83-2.83m-1.41 1.41l-.71.71l2.83 2.83l.71-.71l-2.83-2.83Z"/>'
        },
        "guitar-pick": {
            body: '<path fill="currentColor" d="M19 4.1c-.9-.8-2-1.3-3.2-1.6c-.3-.1-2.2-.5-3.6-.5h-.4c-1.4 0-3.4.4-3.7.5c-1.1.3-2.2.8-3.1 1.6C3 5.9 3 8.7 4 11c1 2.5 2.1 4.7 3.6 6.9C8.8 19.6 10.1 22 12 22c1.9 0 3.2-2.4 4.5-4.1c1.5-2.1 2.6-4.4 3.6-6.9c.9-2.3.9-5.1-1.1-6.9Z"/>'
        },
        "guitar-pick-outline": {
            body: '<path fill="currentColor" d="M19 4.1c-.9-.8-2-1.3-3.2-1.6c-.3-.1-2.2-.5-3.6-.5h-.4c-1.4 0-3.4.4-3.7.5c-1.1.3-2.2.8-3.1 1.6C3 5.9 3 8.7 4 11c1 2.5 2.1 4.7 3.6 6.9C8.8 19.6 10.1 22 12 22c1.9 0 3.2-2.4 4.5-4.1c1.5-2.1 2.6-4.4 3.6-6.9c.9-2.3.9-5.1-1.1-6.9m-.8 6.1c-1.1 2.7-2.1 4.7-3.4 6.5c-.2.2-.3.5-.5.7c-.5.8-1.7 2.6-2.3 2.6c-.7 0-1.8-1.7-2.4-2.6c-.2-.2-.3-.5-.5-.7c-1.2-1.8-2.3-3.8-3.4-6.5c-.2-.7-1-3.2.6-4.7c.5-.5 1.3-.8 2.3-1.1c.4 0 2.1-.4 3.2-.4h.3c1.1 0 2.8.3 3.2.4c1 .3 1.8.6 2.3 1.1c1.7 1.5.9 4 .6 4.7Z"/>'
        },
        "guy-fawkes-mask": {
            body: '<path fill="currentColor" d="M21 13a9 9 0 0 1-9 9a9 9 0 0 1-9-9l.03-8.57C5.68 2.88 8.76 2 12.05 2c3.25 0 6.31.87 8.95 2.38V13m-8 6.93c3.39-.49 6-3.43 6-6.93V5.59C16.9 4.57 14.54 4 12.05 4c-2.55 0-4.97.6-7.11 1.66L5 13c0 3.5 2.63 6.44 6 6.93V18h2v1.93M11 16H8l-2-3l3 1h1l1-1h2l1 1h1l3-1l-2 3h-3l-1-1l-1 1M6 9.03c.64-.63 1.5-.98 2.5-.98c.95 0 1.84.35 2.5.98c-.66.62-1.55.97-2.5.97c-1 0-1.86-.35-2.5-.97m7 0c.64-.63 1.5-.98 2.5-.98c.95 0 1.84.35 2.5.98c-.66.62-1.55.97-2.5.97c-1 0-1.86-.35-2.5-.97Z"/>'
        },
        gymnastics: {
            body: '<path fill="currentColor" d="M4 6c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2M1 9h6l7-5l1.31 1.5l-4.17 3H14L21.8 4L23 5.4L14.5 12L14 22h-2l-.5-10L8 11H1V9Z"/>'
        },
        hail: {
            body: '<path fill="currentColor" d="M4 16h3v6H4v-6M19 2.39c-.08 1.47-.45 2.74-1.14 3.82C17.17 7.29 16.22 8 15 8.39V22h-2v-6h-2v6H9V10.08c-.28.09-.5.2-.61.33C7.45 11.16 7 12.19 7 13.5v.5H5v-.5c0-1.97.72-3.56 2.13-4.78C8.53 7.56 10.16 7 12 7c1.41 0 2.56-.36 3.47-1.05C16.5 5.11 17 3.95 17 2.5V2h2v.39M12 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "hair-dryer": {
            body: '<path fill="currentColor" d="M22 9a4.32 4.32 0 0 1-2.22-.55A3.4 3.4 0 0 0 18 8V7a4.32 4.32 0 0 1 2.22.55A3.4 3.4 0 0 0 22 8m0-2a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 5v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 7m0 3a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 9v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 11m-12 1.73A70.39 70.39 0 0 0 17 11V4s-6.5-2-9.5-2a5.5 5.5 0 0 0-1.38 10.82L7 19h1a3 3 0 0 0 1.46 2.33A3.15 3.15 0 0 1 11 24h1a4.12 4.12 0 0 0-1.91-3.45C9.39 20 9 19.63 9 19h1m-2.5-9A2.5 2.5 0 1 1 10 7.5A2.5 2.5 0 0 1 7.5 10Z"/>'
        },
        "hair-dryer-outline": {
            body: '<path fill="currentColor" d="M10 12.73A70.39 70.39 0 0 0 17 11V4s-6.5-2-9.5-2a5.5 5.5 0 0 0-1.38 10.82L7 19h1a3 3 0 0 0 1.46 2.33A3.15 3.15 0 0 1 11 24h1a4.12 4.12 0 0 0-1.91-3.45C9.39 20 9 19.63 9 19h1M4 7.5A3.5 3.5 0 0 1 7.5 4A37.08 37.08 0 0 1 15 5.5v4A37.08 37.08 0 0 1 7.5 11A3.5 3.5 0 0 1 4 7.5M22 9a4.32 4.32 0 0 1-2.22-.55A3.4 3.4 0 0 0 18 8V7a4.32 4.32 0 0 1 2.22.55A3.4 3.4 0 0 0 22 8m0-2a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 5v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 7m0 3a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 9v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 11M9 7.5A1.5 1.5 0 1 1 7.5 6A1.5 1.5 0 0 1 9 7.5Z"/>'
        },
        halloween: {
            body: '<path fill="currentColor" d="M6.5 6c.97 0 1.87.5 2.61 1.38c.55-.59 1.2-1.02 1.89-1.23V4a2 2 0 0 1 2-2h2v2h-2v2.15c.69.21 1.34.64 1.89 1.23C15.63 6.5 16.53 6 17.5 6C20 6 22 9.36 22 13.5c0 4.14-2 7.5-4.5 7.5c-.97 0-1.87-.5-2.61-1.38C14.08 20.5 13.08 21 12 21s-2.08-.5-2.89-1.38C8.37 20.5 7.47 21 6.5 21C4 21 2 17.64 2 13.5C2 9.36 4 6 6.5 6M9 10l-1.25 2.25h2.5L9 10m6 0l-1.25 2.25h2.5L15 10m-7 7h2l1-1l1 1h2l1-1l1 1l1.5-3l-3.58.62L13 16l-1-1h-2l-1 1l-1-1l-2-1l2 3Z"/>'
        },
        hamburger: {
            body: '<path fill="currentColor" d="M22 13c0 1.11-.89 2-2 2H4a2 2 0 1 1 0-4h9l2.5 2l2.5-2h2a2 2 0 0 1 2 2M12 3C3 3 3 9 3 9h18s0-6-9-6M3 18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-1H3v1Z"/>'
        },
        "hamburger-check": {
            body: '<path fill="currentColor" d="M21 9H3s0-6 9-6s9 6 9 6m-7.65 8H3v1c0 1.66 1.34 3 3 3h7.35c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2m8.51-3.27A2 2 0 0 0 20 11h-9l-2.5 2L6 11H4c-1.1 0-2 .9-2 2s.9 2 2 2h10.54c1.1-1.22 2.69-2 4.46-2c1.04 0 2 .26 2.86.73m-.52 2.11l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "hamburger-minus": {
            body: '<path fill="currentColor" d="M21 9H3s0-6 9-6s9 6 9 6m-7.65 8H3v1c0 1.66 1.34 3 3 3h7.35c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2m8.51-3.27A2 2 0 0 0 20 11h-9l-2.5 2L6 11H4c-1.1 0-2 .9-2 2s.9 2 2 2h10.54c1.1-1.22 2.69-2 4.46-2c1.04 0 2 .26 2.86.73M15 18v2h8v-2h-8Z"/>'
        },
        "hamburger-off": {
            body: '<path fill="currentColor" d="M20 11a2 2 0 1 1 0 4h-1.8l-4-4H20m.42 8.77v-.01L17.66 17h-.01l-2-2h.01l-4-4l-2-2l-7.27-7.27L1.11 3l3.01 3C3 7.5 3 9 3 9h4.11l2 2H4c-1.1 0-2 .9-2 2s.9 2 2 2h9.11l2 2H3v1c0 1.66 1.34 3 3 3h12c.33 0 .65-.07.94-.17l1.9 1.9l1.27-1.27l-1.69-1.69M21 9s0-6-9-6c-2.12 0-3.72.34-4.95.85L12.2 9H21Z"/>'
        },
        "hamburger-plus": {
            body: '<path fill="currentColor" d="M21 9H3s0-6 9-6s9 6 9 6m-7.65 8H3v1c0 1.66 1.34 3 3 3h7.35c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2m8.51-3.27A2 2 0 0 0 20 11h-9l-2.5 2L6 11H4c-1.1 0-2 .9-2 2s.9 2 2 2h10.54c1.1-1.22 2.69-2 4.46-2c1.04 0 2 .26 2.86.73M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "hamburger-remove": {
            body: '<path fill="currentColor" d="M21 9H3s0-6 9-6s9 6 9 6m-7.65 8H3v1c0 1.66 1.34 3 3 3h7.35c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2m8.51-3.27A2 2 0 0 0 20 11h-9l-2.5 2L6 11H4c-1.1 0-2 .9-2 2s.9 2 2 2h10.54c1.1-1.22 2.69-2 4.46-2c1.04 0 2 .26 2.86.73m.68 3.15l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        hammer: {
            body: '<path fill="currentColor" d="M2 19.63L13.43 8.2l-.71-.7l1.42-1.43L12 3.89c1.2-1.19 3.09-1.19 4.27 0l3.6 3.61l-1.42 1.41h2.84l.71.71l-3.55 3.59l-.71-.71V9.62l-1.47 1.42l-.71-.71L4.13 21.76L2 19.63Z"/>'
        },
        "hammer-screwdriver": {
            body: '<path fill="currentColor" d="m16.06 13.09l5.63 5.59l-3.32 3.28l-5.59-5.59v-.92l2.36-2.36h.92m.91-2.53L16 9.6l-4.79 4.8v1.97L5.58 22L2.3 18.68l5.59-5.59h1.97l.78-.78L6.8 8.46H5.5L2.69 5.62L5.31 3l2.8 2.8v1.31L12 10.95l2.66-2.66l-.96-1.01L15 5.97h-2.66l-.65-.65L15 2l.66.66v2.66L16.97 4l3.28 3.28c1.09 1.1 1.09 2.89 0 3.98l-1.97-2.01l-1.31 1.31Z"/>'
        },
        "hammer-sickle": {
            body: '<path fill="currentColor" d="M22 20.59L20.59 22l-3.14-3.14c-.56.37-1.15.7-1.79.92c-1.66.58-3.46.62-5.13.1c-1.03-.3-1.97-.83-2.78-1.51l-3.19 3.19c-.56.59-1.53.59-2.12 0c-.58-.56-.58-1.56 0-2.12l3.38-3.38l2.65-.52a6.1 6.1 0 0 0 2.81 1.96c1.16.35 2.44.34 3.59-.04c.29-.09.57-.2.83-.34L7.6 9l-1.77 1.78L3 7.95L7.95 3l4.24 1.41L9 7.6l8.31 8.29c.19-.18.34-.36.49-.56c1.5-1.97 1.62-4.91.29-7.33C16.78 5.57 14.5 3.55 12 2c1.41.5 2.76 1.17 4 2.04c1.24.87 2.43 1.89 3.33 3.21c.9 1.29 1.54 2.87 1.67 4.54c.1 1.68-.34 3.44-1.3 4.86c-.2.35-.46.63-.7.91l3 3.03Z"/>'
        },
        "hammer-wrench": {
            body: '<path fill="currentColor" d="m13.78 15.3l6 6l2.11-2.16l-6-6l-2.11 2.16m3.72-5.2c-.39 0-.81-.05-1.14-.19L4.97 21.25l-2.11-2.11l7.41-7.4L8.5 9.96l-.72.7l-1.45-1.41v2.86l-.7.7l-3.52-3.56l.7-.7h2.81l-1.4-1.41l3.56-3.56a2.976 2.976 0 0 1 4.22 0L9.89 5.74l1.41 1.4l-.71.71l1.79 1.78l1.82-1.88c-.14-.33-.2-.75-.2-1.12a3.49 3.49 0 0 1 3.5-3.52c.59 0 1.11.14 1.58.42L16.41 6.2l1.5 1.5l2.67-2.67c.28.47.42.97.42 1.6c0 1.92-1.55 3.47-3.5 3.47Z"/>'
        },
        "hand-back-left": {
            body: '<path fill="currentColor" d="M3 16V5.75a1.25 1.25 0 0 1 2.5 0V12h1V2.75a1.25 1.25 0 0 1 2.5 0V12h1V1.25a1.25 1.25 0 0 1 2.5 0V12h1V3.25a1.25 1.25 0 0 1 2.5 0V15h.75l1.41-3.53c.22-.55.68-.97 1.24-1.16l.79-.26a1 1 0 0 1 1.24 1.32L18.4 19c-1.21 3-4.14 5-7.4 5c-4.42 0-8-3.58-8-8Z"/>'
        },
        "hand-back-left-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.1 2.1c-.12.19-.21.4-.21.65V16c0 4.42 3.58 8 8 8c2.93 0 5.58-1.61 6.97-4.14l2.87 2.87l1.27-1.27M5.5 12V7.39l1 1V12h-1m4.5 0H9v-1.11l1 1V12m6 .8l-2.5-2.5V3.25a1.25 1.25 0 0 1 2.5 0v9.55m3.5 3.48l-2.34-2.32l1-2.49c.22-.55.68-.97 1.24-1.16l.79-.26a1 1 0 0 1 1.24 1.32l-1.93 4.91M9 5.8L6.5 3.3v-.55a1.25 1.25 0 0 1 2.5 0V5.8m3.5 3.5L10 6.8V1.25a1.25 1.25 0 0 1 2.5 0V9.3Z"/>'
        },
        "hand-back-left-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.45 2.45C3.21 5.87 3 6.41 3 7v9c0 4.42 3.58 8 8 8c2.94 0 5.62-1.55 7.12-4l2.72 2.73l1.27-1.27M11 22c-3.31 0-6-2.69-6-6V6.91l1 .98V12h2V9.89l1 1V12h1.11l6.54 6.54A6.353 6.353 0 0 1 11 22M8 4.8L6.21 3c.38-.88 1.26-1.5 2.29-1.5c.23 0 .46.03.67.09C9.54.66 10.44 0 11.5 0c1.23 0 2.25.89 2.46 2.06c.17-.06.35-.06.54-.06A2.5 2.5 0 0 1 17 4.5v5.89c.34-.31.76-.54 1.22-.66L19 9.5c.82-.21 1.69.11 2.18.85c.38.57.4 1.31.15 1.95l-1.66 4.17l-1.54-1.54l1.37-3.48l-.5.14c-.5.12-.85.46-1 .91l-.66 1.64L15 11.8V4.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v6.3l-2-2V2.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v5.3l-2-2V4c0-.28-.22-.5-.5-.5S8 3.72 8 4v.8Z"/>'
        },
        "hand-back-left-outline": {
            body: '<path fill="currentColor" d="M3 16c0 4.42 3.58 8 8 8c3.43 0 6.5-2.09 7.77-5.27l2.56-6.43c.25-.64.23-1.38-.15-1.95A2.004 2.004 0 0 0 19 9.5l-.78.23c-.46.12-.88.35-1.22.66V4.5A2.5 2.5 0 0 0 14.5 2c-.19 0-.37 0-.54.06A2.502 2.502 0 0 0 11.5 0c-1.06 0-1.96.66-2.33 1.59A2.5 2.5 0 0 0 6 4v.55c-.16-.05-.33-.05-.5-.05A2.5 2.5 0 0 0 3 7v9m2-9c0-.28.22-.5.5-.5s.5.22.5.5v5h2V4c0-.28.22-.5.5-.5s.5.22.5.5v8h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5V15h2l1-2.5c.15-.45.5-.79 1-.91l.5-.14L16.91 18c-.96 2.41-3.3 4-5.91 4c-3.31 0-6-2.69-6-6V7Z"/>'
        },
        "hand-back-right": {
            body: '<path fill="currentColor" d="M13 24c-3.26 0-6.19-2-7.4-5l-3.03-7.63a1 1 0 0 1 1.24-1.32l.79.26c.56.19 1.02.61 1.24 1.16L7.25 15H8V3.25a1.25 1.25 0 0 1 2.5 0V12h1V1.25a1.25 1.25 0 0 1 2.5 0V12h1V2.75a1.25 1.25 0 0 1 2.5 0V12h1V5.75a1.25 1.25 0 0 1 2.5 0V16c0 4.42-3.58 8-8 8Z"/>'
        },
        "hand-back-right-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-1.67-1.67C17.7 22.85 15.5 24 13 24c-3.26 0-6.19-2-7.4-5l-3.03-7.63a1 1 0 0 1 1.24-1.32l.79.26c.56.19 1.02.61 1.24 1.16L7.25 15H8V9.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M14 1.25a1.25 1.25 0 0 0-2.5 0V8.3l2.5 2.5V1.25M21 16V5.75a1.25 1.25 0 0 0-2.5 0V12h-1V2.75a1.25 1.25 0 0 0-2.5 0v9.05l5.83 5.83c.11-.52.17-1.07.17-1.63M10.5 3.25a1.25 1.25 0 0 0-2.5 0V4.8l2.5 2.5V3.25Z"/>'
        },
        "hand-back-right-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L7 8.89v1.5c-.34-.31-.76-.54-1.22-.66L5 9.5c-.82-.21-1.69.11-2.18.85c-.38.57-.4 1.31-.15 1.95l2.56 6.43A8.364 8.364 0 0 0 13 24c2.5 0 4.7-1.15 6.17-2.94l1.67 1.67l1.27-1.27M13 22a6.36 6.36 0 0 1-5.91-4L4.5 11.45l.5.14c.5.12.85.46 1 .91L7 15h2v-4.11l8.75 8.75A5.962 5.962 0 0 1 13 22M9 5.8L7.09 3.89A2.478 2.478 0 0 1 9.5 2c.19 0 .37 0 .54.06A2.502 2.502 0 0 1 12.5 0c1.06 0 1.96.66 2.33 1.59A2.5 2.5 0 0 1 18 4v.55c.16-.05.33-.05.5-.05A2.5 2.5 0 0 1 21 7v9c0 .56-.06 1.11-.17 1.63L19 15.8V7c0-.28-.22-.5-.5-.5s-.5.22-.5.5v5h-2V4c0-.28-.22-.5-.5-.5s-.5.22-.5.5v7.8l-2-2V2.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v6.3l-2-2V4.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1.3Z"/>'
        },
        "hand-back-right-outline": {
            body: '<path fill="currentColor" d="M21 7a2.5 2.5 0 0 0-2.5-2.5c-.17 0-.34 0-.5.05V4a2.5 2.5 0 0 0-3.17-2.41A2.509 2.509 0 0 0 12.5 0c-1.23 0-2.25.89-2.46 2.06C9.87 2 9.69 2 9.5 2A2.5 2.5 0 0 0 7 4.5v5.89c-.34-.31-.76-.54-1.22-.66L5 9.5c-.82-.21-1.69.11-2.18.85c-.38.57-.4 1.31-.15 1.95l2.56 6.43A8.364 8.364 0 0 0 13 24c4.42 0 8-3.58 8-8V7m-2 9c0 3.31-2.69 6-6 6a6.36 6.36 0 0 1-5.91-4L4.5 11.45l.5.14c.5.12.85.46 1 .91L7 15h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V4c0-.28.22-.5.5-.5s.5.22.5.5v8h2V7c0-.28.22-.5.5-.5s.5.22.5.5v9Z"/>'
        },
        "hand-clap": {
            body: '<path fill="currentColor" d="M7.9 21.47a6.09 6.09 0 0 1-1.72-6.63l2.13-5.93a.765.765 0 0 1 1.38-.13l.31.55c.24.39.29.87.14 1.3l-.98 2.74l.43.38L15.55 7c.35-.4.95-.44 1.36-.09c.39.35.43.96.09 1.35l-4.45 5.03l.58.51l5.45-6.18c.35-.4.96-.44 1.35-.09c.4.35.44.97.07 1.36l-5.44 6.18l.58.51l4.69-5.32c.35-.4.96-.44 1.35-.09s.44.96.09 1.33l-4.69 5.34l.57.51l3.17-3.59c.35-.4.96-.44 1.36-.09s.43.96.08 1.33l-5.2 5.92a6.13 6.13 0 0 1-8.66.55m3.69-12.25L14.43 6c.24-.27.54-.5.87-.63l.38-.78a.947.947 0 0 0-.44-1.28a.964.964 0 0 0-1.28.44l-2.51 5.14c.05.11.11.22.14.33M11 8v.05l2.78-5.67a.965.965 0 0 0-.45-1.28a.951.951 0 0 0-1.28.44L9.41 6.95c.65.11 1.22.48 1.59 1.05m-6.23 6.33L6.9 8.4c.27-.75.9-1.26 1.65-1.43l2.14-4.39a.961.961 0 0 0-.44-1.28a.952.952 0 0 0-1.28.44L5 9.84l-.5-.25l.21-2.91c.04-.45-.14-.9-.46-1.22L3.79 5c-.47-.43-1.24-.14-1.29.5L2 11.79c-.13 2.04.77 3.99 2.35 5.21c-.02-.88.11-1.79.42-2.67Z"/>'
        },
        "hand-clap-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l1.86 1.86c-.25.1-.47.33-.47.64L2 11.79c-.13 2.04.77 3.99 2.35 5.21c-.02-.88.11-1.79.42-2.67L6.8 8.69l1.17 1.17l-1.79 4.98a6.09 6.09 0 0 0 1.72 6.63a6.13 6.13 0 0 0 8.66-.55l1.16-1.31l3.12 3.12l1.27-1.27M5 9.84l-.5-.25l.21-2.91V6.6l1.26 1.26L5 9.84m4.59 3.91l-.43-.38l.61-1.71l.88.88l-1.06 1.21m5.35-2.01l3.64-4.12c.35-.4.96-.44 1.35-.09c.4.35.44.97.07 1.36l-3.7 4.21l-1.36-1.36m4.89-1.48c.35-.4.96-.44 1.35-.09c.39.33.44.96.09 1.33L18.2 15l-1.35-1.35l2.98-3.39m1.85 3.41c.4.33.43.96.08 1.33l-1.66 1.9l-1.36-1.36l1.58-1.78c.35-.4.96-.44 1.36-.09M15.55 7c.35-.4.95-.44 1.36-.09c.39.35.43.96.09 1.35l-2.6 2.94l-1.36-1.36L15.55 7m-3.89 1.46l2.3-4.71c.23-.47.81-.67 1.28-.44c.48.23.68.81.44 1.28l-.38.78c-.33.13-.63.36-.87.63L12 8.78l-.34-.32M9.08 5.88L7.64 4.44l1.33-2.7c.23-.48.8-.67 1.28-.44c.47.23.67.8.44 1.28l-1.61 3.3m.57.57l2.4-4.91a.951.951 0 0 1 1.28-.44c.48.23.67.8.45 1.28l-2.7 5.5l-1.43-1.43Z"/>'
        },
        "hand-coin": {
            body: '<path fill="currentColor" d="M16 12c2.76 0 5-2.24 5-5s-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5m5.45 5.6c-.39-.4-.88-.6-1.45-.6h-7l-2.08-.73l.33-.94L13 16h2.8c.35 0 .63-.14.86-.37s.34-.51.34-.82c0-.54-.26-.91-.78-1.12L8.95 11H7v9l7 2l8.03-3c.01-.53-.19-1-.58-1.4M5 11H.984v11H5V11Z"/>'
        },
        "hand-coin-outline": {
            body: '<path fill="currentColor" d="M16 2c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3m3 6h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94l8-2.5v-1c0-1.66-1.34-3-3-3M5 20H3v-7h2v7m8.97.41L7 18.5V13h1.61l5.82 2.17c.34.13.57.46.57.83c0 0-2-.05-2.3-.15l-2.38-.79l-.63 1.9l2.38.79c.51.17 1.04.25 1.58.25H19c.39 0 .74.24.9.57l-5.93 1.84Z"/>'
        },
        "hand-cycle": {
            body: '<path fill="currentColor" d="M19.5 13c-1.32 0-2.45.74-3.05 1.81l-3.22-2.63l-2.27.82l-1.09-1.68l1.34.37l2.66-2.19l-.94-1.14l-2.03 1.67L7.96 9h-.01c-.41-.15-.87-.11-1.26.14c-.65.42-.86 1.25-.53 1.93c-.21-.04-.43-.07-.66-.07C3 11 1 13 1 15.5S3 20 5.5 20s4.5-2 4.5-4.5c0-.13-.03-.25-.04-.38L13 14l3 2.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5m-14 5.5c-1.65 0-3-1.35-3-3s1.35-3 3-3s3 1.35 3 3s-1.35 3-3 3m14 0c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M6.44 7.57c-.59-.57-.59-1.51 0-2.07c.59-.61 1.53-.61 2.12 0c.59.56.59 1.5 0 2.07c-.59.58-1.53.58-2.12 0"/>'
        },
        "hand-extended": {
            body: '<path fill="currentColor" d="M20 13c.6 0 1.1.2 1.5.6c.3.4.5.9.5 1.4l-8 3l-7-2V7h1.9l7.3 2.7c.5.2.8.6.8 1.1c0 .3-.1.6-.3.8s-.6.4-.9.4H13l-1.8-.7l-.3.9l2.1.8h7M1 7h4v11H1V7Z"/>'
        },
        "hand-extended-outline": {
            body: '<path fill="currentColor" d="M22 15v1l-8 2.5l-7-1.9V18H1V7h8l6.2 2.3c1 .4 1.8 1.5 1.8 2.7h2c1.7 0 3 1.3 3 3M5 16V9H3v7h2m14.9-1.4c-.2-.4-.5-.6-.9-.6h-5.4c-.5 0-1.1-.1-1.6-.2L9.7 13l.6-1.9l2.4.8c.3 0 2.3.1 2.3.1c0-.4-.2-.7-.6-.8L8.6 9H7v5.5l7 1.9l5.9-1.8Z"/>'
        },
        "hand-front-left": {
            body: '<path fill="currentColor" d="M3 9.25v6.5C3 20.31 6.69 24 11.25 24s8.25-3.69 8.25-8.25v-10a1.25 1.25 0 0 0-2.5 0V12h-1V2.75a1.25 1.25 0 0 0-2.5 0V11h-1V1.25a1.25 1.25 0 0 0-2.5 0V11H9V3.25a1.25 1.25 0 0 0-2.5 0v10.78c1.97.25 3.5 1.93 3.5 3.97H9c0-1.65-1.35-3-3-3h-.5V9.25a1.25 1.25 0 0 0-2.5 0Z"/>'
        },
        "hand-front-left-outline": {
            body: '<path fill="currentColor" d="M3 10.5v5c0 4.69 3.81 8.5 8.5 8.5s8.5-3.81 8.5-8.5V7a2.5 2.5 0 0 0-2.5-2.5c-.17 0-.34 0-.5.05V4a2.5 2.5 0 0 0-3.17-2.41A2.509 2.509 0 0 0 11.5 0c-1.23 0-2.25.89-2.46 2.06C8.87 2 8.69 2 8.5 2A2.5 2.5 0 0 0 6 4.5v3.55C5.84 8 5.67 8 5.5 8A2.5 2.5 0 0 0 3 10.5m2 0c0-.28.22-.5.5-.5s.5.22.5.5V15c1.66 0 3 1.34 3 3h2c0-2.05-1.23-3.81-3-4.58V4.5c0-.28.22-.5.5-.5s.5.22.5.5V11h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V11h2V4c0-.28.22-.5.5-.5s.5.22.5.5v8h2V7c0-.28.22-.5.5-.5s.5.22.5.5v8.5a6.5 6.5 0 1 1-13 0v-5Z"/>'
        },
        "hand-front-right": {
            body: '<path fill="currentColor" d="M19.75 8c-.69 0-1.25.56-1.25 1.25V15H18c-1.65 0-3 1.35-3 3h-1c0-2.04 1.53-3.72 3.5-3.97V3.25a1.25 1.25 0 0 0-2.5 0V11h-1V1.25a1.25 1.25 0 0 0-2.5 0V11h-1V2.75a1.25 1.25 0 0 0-2.5 0V12H7V5.75a1.25 1.25 0 0 0-2.5 0v10c0 4.56 3.69 8.25 8.25 8.25S21 20.31 21 15.75v-6.5C21 8.56 20.44 8 19.75 8Z"/>'
        },
        "hand-front-right-outline": {
            body: '<path fill="currentColor" d="M18.5 8c-.17 0-.34 0-.5.05V4.5A2.5 2.5 0 0 0 15.5 2c-.19 0-.37 0-.54.06A2.502 2.502 0 0 0 12.5 0c-1.06 0-1.96.66-2.33 1.59A2.5 2.5 0 0 0 7 4v.55c-.16-.05-.33-.05-.5-.05A2.5 2.5 0 0 0 4 7v8.5c0 4.69 3.81 8.5 8.5 8.5s8.5-3.81 8.5-8.5v-5A2.5 2.5 0 0 0 18.5 8m.5 7.5a6.5 6.5 0 1 1-13 0V7c0-.28.22-.5.5-.5s.5.22.5.5v5h2V4c0-.28.22-.5.5-.5s.5.22.5.5v7h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V11h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5v8.92c-1.77.77-3 2.53-3 4.58h2c0-1.66 1.34-3 3-3v-4.5c0-.28.22-.5.5-.5s.5.22.5.5v5Z"/>'
        },
        "hand-heart": {
            body: '<path fill="currentColor" d="M20 17q.86 0 1.45.6t.58 1.4L14 22l-7-2v-9h1.95l7.27 2.69q.78.31.78 1.12q0 .47-.34.82t-.86.37H13l-1.75-.67l-.33.94L13 17h7M16 3.23Q17.06 2 18.7 2q1.36 0 2.3 1t1 2.3q0 1.03-1 2.46t-1.97 2.39T16 13q-2.08-1.89-3.06-2.85t-1.97-2.39T10 5.3q0-1.36.97-2.3t2.34-1q1.6 0 2.69 1.23M.984 11H5v11H.984V11Z"/>'
        },
        "hand-heart-outline": {
            body: '<path fill="currentColor" d="M16 3.23C16.71 2.41 17.61 2 18.7 2c.91 0 1.67.33 2.3 1c.63.67.96 1.43 1 2.3c0 .7-.33 1.51-1 2.46s-1.32 1.74-1.97 2.39c-.65.64-1.66 1.59-3.03 2.85c-1.39-1.26-2.41-2.21-3.06-2.85s-1.31-1.44-1.97-2.39C10.31 6.81 10 6 10 5.3c0-.91.32-1.67.97-2.3c.65-.63 1.43-.96 2.34-1c1.07 0 1.96.41 2.69 1.23M22 19v1l-8 2.5l-7-1.94V22H1V11h7.97l6.16 2.3A2.89 2.89 0 0 1 17 16h2c1.66 0 3 1.34 3 3M5 20v-7H3v7h2m14.9-1.43c-.16-.33-.51-.57-.9-.57h-5.35c-.54 0-1.07-.08-1.58-.25l-2.38-.79l.63-1.9l2.38.79c.3.1 2.3.15 2.3.15c0-.37-.23-.7-.57-.83L8.61 13H7v5.5l6.97 1.91l5.93-1.84Z"/>'
        },
        "hand-left": {
            body: '<path d="M3 6.58v12.09C3 20.5 4.5 22 6.33 22h6.09c.9 0 1.75-.36 2.37-1l6.54-6.64s-1.05-1.03-1.08-1.04a.985.985 0 0 0-1.16-.11c-.03.01-3.59 2.05-3.59 2.05V5.33a1.25 1.25 0 0 0-1.25-1.25A1.25 1.25 0 0 0 13 5.33v5.84h-.83V3.25A1.25 1.25 0 0 0 10.92 2a1.25 1.25 0 0 0-1.25 1.25v7.92h-.84V4.08a1.25 1.25 0 0 0-1.25-1.25a1.25 1.25 0 0 0-1.25 1.25v7.09H5.5V6.58a1.25 1.25 0 0 0-1.25-1.25A1.25 1.25 0 0 0 3 6.58z" fill="currentColor"/>',
            hidden: true
        },
        "hand-okay": {
            body: '<path fill="currentColor" d="m13.3 19.26l5.66-5.65l2.12 2.12l-5.66 5.65l-2.12-2.12m3.2-8.13l-3.1-3.08a1.68 1.68 0 0 0-.4-.29l-1.12-4.29a1.001 1.001 0 0 0-1.94.49L11 8.03L8.67 3.19c-.23-.5-.83-.69-1.33-.48c-.5.24-.71.84-.47 1.34l1.69 3.54l-3.37-3.34c-.39-.39-1.03-.39-1.42 0c-.39.4-.38 1.03.01 1.42l3.72 3.7l-.7.27l-1.08.43l-1.91 1.32s-.81 1.05-.88 1.5c-.08.45.79 2.71.79 2.71h.01c.16.34.5.58.9.58a1 1 0 0 0 1-1c0-.1-.03-.18-.06-.27l.02-.01L5 13.17l1.23-.98c.47.02 1.48.1 1.97.13c2.73 2.45.15 3.41.15 3.41l-3.46 1.06l-.17.14a.94.94 0 0 0-.3.75l.02 1.07l6.43-.5c.38.01.74-.13 1.02-.4l4.61-4.6c.53-.54.55-1.55 0-2.12Z"/>'
        },
        "hand-peace": {
            body: '<path fill="currentColor" d="M7 19h8v3H7v-3m9.15-7l-3.18-1.66a.49.49 0 0 0-.37.16l-.3.31l.59 2.42l-.98.24l-1.19-4.97l-1.47.68l1.04 4.29l-.97.23l-1-4.11l-.47.21c-.5.2-.85.73-.85 1.34v4.36c0 .8.73 1.5 1.5 1.5H15c.39 0 .74-.16 1-.43l.5-.41s.5-.38.5-.8V13.7s0-1.14-.85-1.7m.79-11c-.54-.09-1.07.25-1.18.8l-1.07 6.17c-.22-.03-.31-.11-.61-.14l-.43.05l-1.24-6.08a1.02 1.02 0 0 0-1.17-.8c-.55.13-.9.66-.79 1.2l1.2 5.91l.35 1.56c.28-.2.61-.33.97-.33h.34l3 1.61l1.41-8.75c.11-.54-.22-1.07-.78-1.2Z"/>'
        },
        "hand-peace-variant": {
            body: '<path fill="currentColor" d="M7 19h8v3H7v-3m9.94-18c-.54-.09-1.07.25-1.18.8l-1.01 5.77c-.22-.03-.46-.07-.75-.1l-.43.03l-1.16-5.7c-.1-.54-.63-.89-1.17-.8c-.54.13-.89.66-.79 1.2l1.2 5.91l-3.8 1.69c-.5.2-.85.73-.85 1.34v4.36c0 .8.73 1.5 1.5 1.5H15c.39 0 .74-.16 1-.43l.5-.41s.5-.38.5-.8V13s0-1.14-.87-1.7l1.58-9.1c.12-.54-.21-1.07-.77-1.2Z"/>'
        },
        "hand-pointing-down": {
            body: '<path fill="currentColor" d="M9.9 21V11l-3.2 1.69l-.2.03c-.31 0-.57-.12-.76-.32L5 11.63l4.9-4.2c.26-.27.6-.43 1-.43h6.5c.77 0 1.5.7 1.5 1.5v4.36c0 .61-.35 1.14-.85 1.34l-4.94 2.2l-1.21.13V21a1 1 0 0 1-1 1a1 1 0 0 1-1-1m9-16h-8V2h8v3Z"/>'
        },
        "hand-pointing-left": {
            body: '<path fill="currentColor" d="M3 9h10l-1.69-3.2l-.03-.22c0-.29.12-.55.32-.74l.77-.74l4.2 4.9c.27.26.43.61.43 1v6.5c0 .77-.7 1.5-1.5 1.5h-4.36c-.61 0-1.14-.35-1.34-.85l-2.2-4.94L7.47 11H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m16 9v-8h3v8h-3Z"/>'
        },
        "hand-pointing-right": {
            body: '<path fill="currentColor" d="M21 9a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-4.47l-.13 1.21l-2.2 4.94c-.2.5-.73.85-1.34.85H8.5c-.8 0-1.5-.73-1.5-1.5V10c0-.39.16-.74.43-1l4.2-4.9l.77.74c.2.19.32.45.32.74l-.03.22L11 9h10M2 18v-8h3v8H2Z"/>'
        },
        "hand-pointing-up": {
            body: '<path fill="currentColor" d="M14 3v10l3.2-1.69l.22-.03c.29 0 .55.12.74.32l.74.77l-4.9 4.2c-.26.27-.61.43-1 .43H6.5c-.77 0-1.5-.7-1.5-1.5v-4.36c0-.61.35-1.14.85-1.34l4.94-2.2L12 7.47V3a1 1 0 0 1 1-1a1 1 0 0 1 1 1M5 19h8v3H5v-3Z"/>'
        },
        "hand-right": {
            body: '<path d="M21 6.58v12.09A3.33 3.33 0 0 1 17.67 22h-6.09c-.9 0-1.75-.36-2.37-1l-6.54-6.64s1.05-1.03 1.08-1.04a.985.985 0 0 1 1.16-.11c.03.01 3.59 2.05 3.59 2.05V5.33a1.25 1.25 0 0 1 1.25-1.25A1.25 1.25 0 0 1 11 5.33v5.84h.83V3.25A1.25 1.25 0 0 1 13.08 2c.7 0 1.25.56 1.25 1.25v7.92h.84V4.08c0-.69.55-1.25 1.25-1.25a1.25 1.25 0 0 1 1.25 1.25v7.09h.83V6.58a1.25 1.25 0 0 1 1.25-1.25A1.25 1.25 0 0 1 21 6.58z" fill="currentColor"/>',
            hidden: true
        },
        "hand-saw": {
            body: '<path fill="currentColor" d="m9.8 17l-3.9-5.4L20 2l2 3v3h-3v3h-3v3h-3v3m-3.3 1.7l-.5 2.8l-1.6 1.2c-.9.6-2.1.4-2.8-.5l-3.5-4.9c-.6-.9-.4-2.1.5-2.8l3.3-2.3l4.6 6.5M4.6 15L3 16.1L6.5 21l1.6-1.2L4.6 15Z"/>'
        },
        "hand-wash": {
            body: '<path fill="currentColor" d="m17 5l.62 1.37L19 7l-1.38.63L17 9l-.64-1.37L15 7l1.36-.63L17 5m-6 1.13V4h2c.57 0 1.1.17 1.55.45L16 3c-.85-.61-1.87-1-3-1H7.5v2H9v2.14A4.99 4.99 0 0 0 5.26 9.5h3.98L15 11.65v-.62a5 5 0 0 0-4-4.9M1 22h4V11H1v11m19-5h-7l-2.09-.73l.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18c0-.49-.31-.93-.77-1.11L8.97 11H7v9l7 2l8-3a2 2 0 0 0-2-2m0-3c1.1 0 2-.9 2-2s-2-4-2-4s-2 2.9-2 4s.9 2 2 2Z"/>'
        },
        "hand-wash-outline": {
            body: '<path fill="currentColor" d="m17 5l.62 1.37L19 7l-1.38.63L17 9l-.64-1.37L15 7l1.36-.63L17 5m3 9c1.1 0 2-.9 2-2s-2-4-2-4s-2 2.9-2 4s.9 2 2 2m-9-7.9V4h2c.57 0 1.1.17 1.55.45L16 3c-.85-.61-1.87-1-3-1H7.5v2H9v2.11A5.06 5.06 0 0 0 5.25 9.5h2.16C7.94 8.61 8.89 8 10 8c1.62 0 2.94 1.29 3 2.9l2 .75V11a5 5 0 0 0-4-4.9M22 19v1l-8 2.5l-7-1.94V22H1V11h7.97l6.16 2.3A2.89 2.89 0 0 1 17 16h2c1.66 0 3 1.34 3 3M5 20v-7H3v7h2m14.9-1.43c-.16-.33-.51-.57-.9-.57h-5.35c-.54 0-1.07-.08-1.58-.25l-2.38-.79l.63-1.9l2.38.79c.3.1 2.3.15 2.3.15c0-.37-.23-.7-.57-.83L8.61 13H7v5.5l6.97 1.91l5.93-1.84Z"/>'
        },
        "hand-water": {
            body: '<path fill="currentColor" d="M17.42 22.5H5.33C3.5 22.5 2 21 2 19.17v-6.09c0-.9.36-1.75 1-2.37l5.63-5.54s1.03 1.05 1.04 1.08a.985.985 0 0 1 .11 1.16C9.77 7.44 8 10 8 10h10.67a1.25 1.25 0 0 1 0 2.5h-5.84v.83h7.92a1.25 1.25 0 0 1 0 2.5h-7.92v.84h7.09a1.25 1.25 0 0 1 0 2.5h-7.09V20h4.59a1.25 1.25 0 0 1 0 2.5M13.5 4.8S12 6.46 12 7.5c0 2 3 2 3 0c0-1.04-1.5-2.7-1.5-2.7m5-3.8S16 3.76 16 5.5c0 3.33 5 3.33 5 0C21 3.76 18.5 1 18.5 1Z"/>'
        },
        "hand-wave": {
            body: '<path fill="currentColor" d="M23 17c0 3.31-2.69 6-6 6v-1.5c2.5 0 4.5-2 4.5-4.5H23M1 7c0-3.31 2.69-6 6-6v1.5c-2.5 0-4.5 2-4.5 4.5H1m7-2.68l-4.59 4.6c-3.22 3.22-3.22 8.45 0 11.67s8.45 3.22 11.67 0l7.07-7.09c.49-.47.49-1.26 0-1.75a1.25 1.25 0 0 0-1.77 0l-4.42 4.42l-.71-.71l6.54-6.54c.49-.49.49-1.28 0-1.77s-1.29-.49-1.79 0L14.19 13l-.69-.73l6.87-6.89c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-6.89 6.89l-.71-.7l5.5-5.48c.5-.49.5-1.28 0-1.77s-1.28-.49-1.77 0l-7.62 7.62a4.003 4.003 0 0 1-.33 5.28l-.71-.71a3 3 0 0 0 0-4.24l-.35-.35l4.07-4.07c.49-.49.49-1.28 0-1.77c-.5-.48-1.29-.48-1.79.01Z"/>'
        },
        "hand-wave-outline": {
            body: '<path fill="currentColor" d="M7.03 4.95L3.5 8.5c-3.33 3.31-3.33 8.69 0 12s8.69 3.33 12 0l6-6c1-.97 1-2.56 0-3.54c-.1-.12-.23-.23-.37-.32l.37-.39c1-.97 1-2.56 0-3.54c-.14-.16-.33-.3-.5-.41c.38-.92.21-2.02-.54-2.77c-.87-.87-2.22-.96-3.2-.28a2.517 2.517 0 0 0-3.88-.42l-2.51 2.51c-.09-.14-.2-.27-.32-.39a2.53 2.53 0 0 0-3.52 0m1.41 1.42c.2-.2.51-.2.71 0s.2.51 0 .71l-3.18 3.18a3 3 0 0 1 0 4.24l1.41 1.41a5.004 5.004 0 0 0 1.12-5.36l6.3-6.3c.2-.2.51-.2.7 0s.21.51 0 .71l-4.59 4.6l1.41 1.41l6.01-6.01c.2-.2.51-.2.71 0c.2.2.2.51 0 .71l-6.01 6.01l1.41 1.41l4.95-4.95c.2-.2.51-.2.71 0c.2.2.2.51 0 .71l-5.66 5.65l1.41 1.42l3.54-3.54c.2-.2.51-.2.71 0c.2.2.2.51 0 .71l-6 6.01c-2.54 2.54-6.65 2.54-9.19 0s-2.54-6.65 0-9.19l3.53-3.54M23 17c0 3.31-2.69 6-6 6v-1.5c2.5 0 4.5-2 4.5-4.5H23M1 7c0-3.31 2.69-6 6-6v1.5c-2.5 0-4.5 2-4.5 4.5H1Z"/>'
        },
        handball: {
            body: '<path fill="currentColor" d="M15.83 10.43a6.93 6.93 0 0 1 2.56 4.43a6.64 6.64 0 0 1-.89 4.64l-1.72-1a5 5 0 0 0 .66-2.5a5.22 5.22 0 0 0-.98-2.94L9.18 23.93l-1.74-.98l3-5.2l-1.73-.99l-1.5 2.58l-1.71-.98l5.13-8.91A7 7 0 0 1 8.8 5.46a6.91 6.91 0 0 1 .89-4.36l1.74 1.03a4.84 4.84 0 0 0-.52 3.77a4.74 4.74 0 0 0 2.3 3.03M16 5a2 2 0 1 0 2 2a2 2 0 0 0-2-2m-2.5-4A1.5 1.5 0 1 0 15 2.5A1.5 1.5 0 0 0 13.5 1Z"/>'
        },
        handcuffs: {
            body: '<path fill="currentColor" d="M20.24 6.76c-1.84-1.85-4.59-2.23-6.82-1.17l-.96-.96a.996.996 0 0 0-1.41 0l-.08.09C10.83 3.75 10 3 9 3c-1.1 0-2 .9-2 2c0 .09 0 .18.03.26C6.42 5.61 6 6.25 6 7c0 .46.16.87.42 1.21A.97.97 0 0 0 6 9v1.35c-2.33.82-4 3.04-4 5.65c0 3.31 2.69 6 6 6s6-2.69 6-6a5.99 5.99 0 0 0-4-5.65V9a.97.97 0 0 0-.42-.79c.26-.34.42-.75.42-1.21c0-.09 0-.18-.03-.26c.18-.1.33-.24.46-.36C11.36 6.88 12 7.86 12 9v.08c.13.07.25.17.38.25c.19-.42.45-.83.79-1.16a4.008 4.008 0 0 1 5.66 0a4.008 4.008 0 0 1 0 5.66c-.8.8-1.83 1.17-2.9 1.17c.07.32.07.66.07 1c0 .34-.03.67-.07 1c1.57 0 3.12-.57 4.31-1.76a5.981 5.981 0 0 0 0-8.48M9 4c.55 0 1 .45 1 1c0 .33-.17.61-.42.79C9.22 5.31 8.65 5 8 5c0-.55.45-1 1-1M7.42 6.21c.36.48.93.79 1.58.79c0 .55-.45 1-1 1s-1-.45-1-1c0-.33.17-.61.42-.79M12 16c0 2.21-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4Z"/>'
        },
        "hands-pray": {
            body: '<path fill="currentColor" d="M11.43 9.67c.04.11.07.21.07.33v5.22c0 .5-.19.98-.53 1.35l-2.79 3.05l-3.4-3.4L6 15L8.8 2.86a1.114 1.114 0 0 1 2.2.25v4.96a2.08 2.08 0 0 0-.5-.07c-1.1 0-2 .9-2 2v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.55.45-1 1-1c.19 0 .35.07.5.16c.12.07.21.16.3.26c.03.04.06.08.08.13c.02.04.04.08.05.12M2 19l4 3l1.17-1.27l-3.45-3.45L2 19m16-4L15.2 2.86a1.114 1.114 0 0 0-2.2.25v4.96c.16-.04.33-.07.5-.07c1.1 0 2 .9 2 2v3c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3c0-.55-.45-1-1-1c-.19 0-.35.07-.5.16c-.12.07-.21.16-.29.26c-.03.04-.07.08-.09.13c-.02.04-.04.08-.05.12c-.04.11-.07.21-.07.33v5.22c0 .5.19.98.53 1.35l2.79 3.05l3.4-3.4L18 15m2.28 2.28l-3.45 3.45L18 22l4-3l-1.72-1.72Z"/>'
        },
        handshake: {
            body: '<path fill="currentColor" d="M11 6h3l3.29-3.3a1 1 0 0 1 1.42 0l2.58 2.59a1 1 0 0 1 0 1.41L19 9h-8v2a1 1 0 0 1-1 1a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2m-6 5v4l-2.29 2.29a1 1 0 0 0 0 1.41l2.58 2.59a1 1 0 0 0 1.42 0L11 17h4a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h-7v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z"/>'
        },
        "handshake-outline": {
            body: '<path fill="currentColor" d="M21.71 8.71c1.25-1.25.68-2.71 0-3.42l-3-3c-1.26-1.25-2.71-.68-3.42 0L13.59 4H11C9.1 4 8 5 7.44 6.15L3 10.59v4l-.71.7c-1.25 1.26-.68 2.71 0 3.42l3 3c.54.54 1.12.74 1.67.74c.71 0 1.36-.35 1.75-.74l2.7-2.71H15c1.7 0 2.56-1.06 2.87-2.1c1.13-.3 1.75-1.16 2-2C21.42 14.5 22 13.03 22 12V9h-.59l.3-.29M20 12c0 .45-.19 1-1 1h-1v1c0 .45-.19 1-1 1h-1v1c0 .45-.19 1-1 1h-4.41l-3.28 3.28c-.31.29-.49.12-.6.01l-2.99-2.98c-.29-.31-.12-.49-.01-.6L5 15.41v-4l2-2V11c0 1.21.8 3 3 3s3-1.79 3-3h7v1m.29-4.71L18.59 9H11v2c0 .45-.19 1-1 1s-1-.55-1-1V8c0-.46.17-2 2-2h3.41l2.28-2.28c.31-.29.49-.12.6-.01l2.99 2.98c.29.31.12.49.01.6Z"/>'
        },
        hanger: {
            body: '<path fill="currentColor" d="M12 4a3.5 3.5 0 0 0-3.5 3.5h2A1.5 1.5 0 0 1 12 6a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 9c-.55 0-1 .45-1 1v1.75L2.4 18.2A1 1 0 0 0 3 20h18a1 1 0 0 0 .6-1.8L13 11.75v-.9a3.5 3.5 0 0 0 2.5-3.35A3.5 3.5 0 0 0 12 4m0 9.5l6 4.5H6Z"/>'
        },
        hangouts: {
            body: '<path d="M15 10.998l-1 2h-1.5l1-2H12v-3h3m-4 3l-1 2H8.5l1-2H8v-3h3m.5-6a8.5 8.5 0 0 0 0 17h.5v3.5c4.858-2.344 8-7.5 8-12a8.5 8.5 0 0 0-8.5-8.5z" fill="currentColor"/>',
            hidden: true
        },
        "hard-hat": {
            body: '<path fill="currentColor" d="M9.87 12.15L9 6.46a9.91 9.91 0 0 1 6 0l-.87 5.69c-.07.49-.5.85-1 .85h-2.27a1 1 0 0 1-.99-.85M22 16c0-.79-.47-1.5-1.2-1.83A9.082 9.082 0 0 0 17 8.5l-1.76 4.84c-.14.4-.52.66-.94.66H9.7c-.42 0-.8-.26-.94-.66L7 8.5a9.087 9.087 0 0 0-3.8 5.66C2.47 14.5 2 15.2 2 16l6.45 1.84c.36.1.73.16 1.1.16h4.88c.37 0 .74-.06 1.1-.16L22 16Z"/>'
        },
        harddisk: {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m6 2a6 6 0 0 0-6 6c0 3.31 2.69 6 6.1 6l-.88-2.23a1.01 1.01 0 0 1 .37-1.37l.86-.5a1.01 1.01 0 0 1 1.37.37l1.92 2.42A5.977 5.977 0 0 0 18 10a6 6 0 0 0-6-6m0 5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-5 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m5.09-4.73l2.49 6.31l2.59-1.5l-4.22-5.31l-.86.5Z"/>'
        },
        "harddisk-plus": {
            body: '<path fill="currentColor" d="M12 9a1 1 0 1 0 1 1a1 1 0 0 0-1-1m0 0a1 1 0 1 0 1 1a1 1 0 0 0-1-1m6-7H6a2 2 0 0 0-2 2v9.09A5.47 5.47 0 0 1 5 13a5.71 5.71 0 0 1 2 .36a6 6 0 1 1 8.71 1.33l-1.92-2.42a1 1 0 0 0-1.37-.37l-.86.5a1 1 0 0 0-.37 1.37L12.1 16a6.12 6.12 0 0 1-2.1-.38a6 6 0 0 1 .19 6.38H18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-3.42 17.58l-2.49-6.31l.86-.5l4.22 5.31M12 11a1 1 0 1 0-1-1a1 1 0 0 0 1 1m-3 9H6v3H4v-3H1v-2h3v-3h2v3h3Z"/>'
        },
        "harddisk-remove": {
            body: '<path fill="currentColor" d="M12 9a1 1 0 1 0 1 1a1 1 0 0 0-1-1m0 0a1 1 0 1 0 1 1a1 1 0 0 0-1-1m6-7H6a2 2 0 0 0-2 2v9.09A5.47 5.47 0 0 1 5 13a5.71 5.71 0 0 1 2 .36a6 6 0 1 1 8.71 1.33l-1.92-2.42a1 1 0 0 0-1.37-.37l-.86.5a1 1 0 0 0-.37 1.37L12.1 16a6.12 6.12 0 0 1-2.1-.38a6 6 0 0 1 .19 6.38H18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-3.42 17.58l-2.49-6.31l.86-.5l4.22 5.31M12 11a1 1 0 1 0-1-1a1 1 0 0 0 1 1M7.12 22.54L5 20.41l-2.12 2.13l-1.42-1.42L3.59 19l-2.13-2.12l1.42-1.42L5 17.59l2.12-2.13l1.42 1.42L6.41 19l2.13 2.12Z"/>'
        },
        "hat-fedora": {
            body: '<path fill="currentColor" d="M19.11 11.92c.02-.21.03-.42.03-.63c0-3.43-1.43-7.15-2.86-7.15S13.42 5.57 12 5.57c-1.43 0-2.86-1.43-4.29-1.43c-1.43 0-2.85 3.65-2.85 7.15c0 .21 0 .42.02.63c2.34.53 4.72.8 7.12.79c2.45 0 4.83-.27 7.11-.79M3.45 18.18a29.69 29.69 0 0 0 17.09 0A2.142 2.142 0 0 0 22 16.17c0-.45-.14-.88-.39-1.25c-.26-.36-.61-.63-1.05-.78c-2.7.86-5.56 1.31-8.56 1.31c-3 0-5.87-.45-8.57-1.31c-.43.15-.78.43-1.04.79c-.25.36-.39.79-.39 1.24c0 .94.61 1.73 1.45 2.01Z"/>'
        },
        "hazard-lights": {
            body: '<path fill="currentColor" d="m12 12l2.33 4H9.68L12 12m0-4L6.21 18H17.8L12 8m0-6L1 21h22L12 2m0 4l7.53 13H4.47L12 6Z"/>'
        },
        "hdmi-port": {
            body: '<path fill="currentColor" d="M21 7H3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h1l1.4 1.4c.4.4.9.6 1.4.6h10.3c.5 0 1-.2 1.4-.6L20 16h1c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2M3 14V9h18v5h-1.8l-2 2H6.8l-2-2H3m16-3H5v2h14v-2Z"/>'
        },
        hdr: {
            body: '<path fill="currentColor" d="M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4m-1.5 0h-2v-1h2v1m-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2M13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5m0 4.5h-2v-3h2v3Z"/>'
        },
        "hdr-off": {
            body: '<path fill="currentColor" d="M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4m0-4.5h2v1h-2v-1m-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4m-3.5-1l-7-7l-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6l1.1-1.1l-12.1-12Z"/>'
        },
        head: {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 5.9 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7"/>'
        },
        "head-alert": {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 5.9 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7m1 12h-2v-2h2v1m0-3h-2V5h2v6Z"/>'
        },
        "head-alert-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.8-.6 1.8-.2 2.6c.4.7 1 1.2 1.7 1.3V16c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.7 4-4.4 4-7.5c0-5-4-9-9-9m1 14h-2v-2h2v2m0-4h-2V5h2"/>'
        },
        "head-check": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m-.53 10L9 9.5l1.4-1.41l2.07 2.08L16.6 6L18 7.41L12.47 13Z"/>'
        },
        "head-check-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m0-2C8.42 1 4.61 4.43 4.06 8.91L2.5 11c-.58.72-.68 1.72-.26 2.59c.36.72 1 1.21 1.76 1.36V16c0 1.86 1.28 3.43 3 3.87V23h11v-5.53c2.5-1.64 4-4.41 4-7.47c0-4.96-4.04-9-9-9m-.53 12L9 9.5l1.4-1.41l2.07 2.08L16.6 6L18 7.41L12.47 13Z"/>'
        },
        "head-cog": {
            body: '<path fill="currentColor" d="M13 8.58c.78 0 1.44.61 1.44 1.42s-.66 1.44-1.44 1.44s-1.42-.66-1.42-1.44s.61-1.42 1.42-1.42M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m3 7c0-.16 0-.25-.06-.39l.89-.66c.05-.04.09-.18.05-.28l-.8-1.36c-.05-.09-.19-.14-.28-.09l-.99.42c-.18-.19-.42-.33-.65-.42L14 6.19c-.03-.14-.08-.19-.22-.19h-1.59c-.1 0-.19.05-.19.19l-.14 1.03c-.23.09-.47.23-.66.42l-1.03-.42c-.09-.05-.17 0-.23.09l-.8 1.36c-.05.14-.05.24.05.28l.84.66c0 .14-.03.28-.03.39c0 .13.03.27.03.41l-.84.65c-.1.05-.1.14-.05.24l.8 1.4c.06.1.14.1.23.1l.99-.43c.23.19.42.29.7.38l.14 1.08c0 .09.09.17.19.17h1.59c.14 0 .19-.08.22-.17l.16-1.08c.23-.09.47-.19.65-.37l.99.42c.09 0 .23 0 .28-.1l.8-1.4c.04-.1 0-.19-.05-.24l-.83-.65V10Z"/>'
        },
        "head-cog-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m0-2C8.42 1 4.61 4.43 4.06 8.91L2.5 11c-.58.72-.68 1.72-.26 2.59c.36.72 1 1.21 1.76 1.36V16c0 1.86 1.28 3.43 3 3.87V23h11v-5.53c2.5-1.64 4-4.41 4-7.47c0-4.96-4.04-9-9-9m3.1 8.42V9c0-.15 0-.24-.06-.38l.89-.66c.07-.04.07-.18.07-.28l-.82-1.36c-.05-.09-.18-.14-.28-.09l-.99.42c-.18-.19-.41-.33-.65-.42L14.1 5.2c-.03-.14-.1-.2-.22-.2h-1.59c-.1 0-.19.06-.19.2l-.14 1.03c-.23.09-.46.23-.66.42l-1.03-.42c-.09-.05-.17 0-.23.09l-.8 1.36c-.05.14-.05.24.05.28l.84.66c0 .14-.03.28-.03.38c0 .14.03.28.03.42l-.84.65c-.1.05-.1.14-.05.24l.8 1.4c.06.1.14.1.23.1l.99-.43c.24.19.42.29.7.38l.14 1.08c0 .09.09.16.19.16h1.59c.12 0 .19-.07.22-.16l.16-1.08c.24-.09.47-.19.65-.37l.99.42c.1 0 .23 0 .28-.1l.82-1.4c0-.1 0-.19-.07-.24l-.83-.65m-3 1.03c-.78 0-1.42-.66-1.42-1.45s.61-1.41 1.42-1.41c.78 0 1.44.61 1.44 1.41s-.66 1.45-1.44 1.45Z"/>'
        },
        "head-dots-horizontal": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m-3 8c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "head-dots-horizontal-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.8-.6 1.8-.2 2.6c.4.7 1 1.2 1.7 1.3V16c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.7 4-4.4 4-7.5c0-5-4-9-9-9m-3 9c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m3 0c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m3 0c-.5 0-1-.4-1-1s.5-1 1-1s1 .4 1 1s-.5 1-1 1Z"/>'
        },
        "head-flash": {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 6 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7m2 6l-3.1 6l.6-4h-2l2-5H15l-1.5 3H15Z"/>'
        },
        "head-flash-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.8-.6 1.8-.2 2.6c.4.7 1 1.2 1.7 1.3V16c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.7 4-4.4 4-7.5c0-5-4-9-9-9m2 8l-3.1 6l.6-4h-2.1l2.1-5H15l-1.5 3H15Z"/>'
        },
        "head-heart": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m4 5.83c0 1.54-1.36 2.77-3.42 4.64L13 14l-.58-.53C10.36 11.6 9 10.37 9 8.83c0-1.2.96-2.19 2.16-2.2h.04c.69 0 1.35.31 1.8.83c.45-.52 1.11-.83 1.8-.83c1.2-.01 2.2.96 2.2 2.16v.04Z"/>'
        },
        "head-heart-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m0-2C8.41 1 4.61 4.42 4.06 8.9L2.5 11h-.03l-.02.03c-.55.76-.62 1.76-.19 2.59c.36.69 1 1.17 1.74 1.32V16c0 1.85 1.28 3.42 3 3.87V23h11v-5.5c2.5-1.67 4-4.44 4-7.5c0-4.97-4.04-9-9-9m4 7.83c0 1.54-1.36 2.77-3.42 4.64L13 14l-.58-.53C10.36 11.6 9 10.37 9 8.83c0-1.2.96-2.19 2.16-2.2h.04c.69 0 1.35.31 1.8.83c.45-.52 1.11-.83 1.8-.83c1.2-.01 2.2.96 2.2 2.16v.04Z"/>'
        },
        "head-lightbulb": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m1 11h-2v-1h2v1m1.6-4.5a3 3 0 0 1-1.1 1.08V12h-3v-1.42c-1.43-.83-1.93-2.66-1.1-4.08s2.67-1.94 4.1-1.12s1.93 2.67 1.1 4.12Z"/>'
        },
        "head-lightbulb-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.8-.6 1.8-.2 2.6c.4.7 1 1.2 1.7 1.3V16c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.7 4-4.4 4-7.5c0-5-4-9-9-9m1 13h-2v-1h2v1m1.6-4.5c-.3.4-.6.8-1.1 1.1V12h-3v-1.4c-1.4-.8-1.9-2.7-1.1-4.1s2.7-1.9 4.1-1.1s1.9 2.7 1.1 4.1Z"/>'
        },
        "head-minus": {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 5.9 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7m4 7H9V8h8v2Z"/>'
        },
        "head-minus-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.7-.7 1.7-.3 2.6c.4.7 1 1.2 1.8 1.4v1c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.6 4-4.4 4-7.5c0-5-4-9-9-9m4 9H9V8h8v2Z"/>'
        },
        "head-outline": {
            body: '<path fill="currentColor" d="M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.5.8-.6 1.8-.2 2.6c.4.7 1 1.2 1.7 1.3V16c0 1.8 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.7 4-4.4 4-7.5c0-5-4-9-9-9m3 15.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 6 9.2 3 13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3Z"/>'
        },
        "head-plus": {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 5.9 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7m4 7h-3v3h-2v-3H9V8h3V5h2v3h3v2Z"/>'
        },
        "head-plus-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.7-.7 1.7-.3 2.6c.4.7 1 1.2 1.8 1.4v1c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.6 4-4.4 4-7.5c0-5-4-9-9-9m4 9h-3v3h-2v-3H9V8h3V5h2v3h3v2Z"/>'
        },
        "head-question": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m1 11h-2v-2h2v2m1.75-5.19c-.29.4-.66.69-1.11.93c-.25.16-.42.33-.51.52c-.09.18-.13.43-.13.74h-2c0-.5.11-.92.31-1.18c.19-.27.54-.57 1.05-.91c.26-.16.47-.36.61-.59c.16-.23.23-.5.23-.82c0-.3-.08-.56-.26-.75c-.18-.18-.44-.28-.75-.28a1 1 0 0 0-.66.23c-.18.16-.27.39-.28.69h-1.93l-.01-.03c-.01-.79.25-1.36.77-1.77c.54-.39 1.24-.59 2.11-.59c.93 0 1.66.23 2.19.68c.54.45.81 1.06.81 1.82c0 .5-.15.91-.44 1.31Z"/>'
        },
        "head-question-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m-2.68 4.39h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91c-.2.26-.31.68-.31 1.18h2c0-.31.04-.56.13-.74c.09-.19.26-.36.51-.52c.45-.24.82-.53 1.11-.93c.29-.4.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82c-.53-.45-1.26-.68-2.19-.68c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03M12 14h2v-2h-2v2m1-13C8.41 1 4.61 4.42 4.06 8.9L2.5 11h-.03l-.02.03c-.55.76-.62 1.76-.19 2.59c.36.69 1 1.17 1.74 1.32V16c0 1.85 1.28 3.42 3 3.87V23h11v-5.5c2.5-1.67 4-4.44 4-7.5c0-4.97-4.04-9-9-9Z"/>'
        },
        "head-remove": {
            body: '<path fill="currentColor" d="M13 3C9.2 3 6.2 5.9 6 9.7l-1.9 2.5c-.2.3 0 .8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.7c2.4-1.1 4-3.5 4-6.3c0-3.9-3.1-7-7-7m2.1 9.5L13 10.4l-2.1 2.1l-1.4-1.4L11.6 9L9.5 6.9l1.4-1.4L13 7.6l2.1-2.1l1.4 1.4L14.4 9l2.1 2.1l-1.4 1.4Z"/>'
        },
        "head-remove-outline": {
            body: '<path fill="currentColor" d="M13 3c3.9 0 7 3.1 7 7c0 2.8-1.6 5.2-4 6.3V21H9v-3H8c-1.1 0-2-.9-2-2v-3H4.5c-.4 0-.7-.5-.4-.8L6 9.7C6.2 5.9 9.2 3 13 3m0-2C8.4 1 4.6 4.4 4.1 8.9L2.5 11c-.6.7-.7 1.7-.3 2.6c.4.7 1 1.2 1.8 1.4v1c0 1.9 1.3 3.4 3 3.9V23h11v-5.5c2.5-1.6 4-4.4 4-7.5c0-5-4-9-9-9m3.5 5.9L14.4 9l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4L11.6 9L9.5 6.9l1.4-1.4L13 7.6l2.1-2.1l1.4 1.4Z"/>'
        },
        "head-snowflake": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m4.06 6.57l-1.96.52l1.44 1.45a.9.9 0 0 1 0 1.27a.9.9 0 0 1-1.27 0l-1.46-1.44l-.51 1.96c-.12.49-.62.77-1.09.64a.892.892 0 0 1-.64-1.1l.53-1.97l-1.97.53a.887.887 0 0 1-1.1-.64c-.13-.47.15-.97.64-1.09l1.96-.51l-1.44-1.46a.9.9 0 0 1 1.27-1.27l1.45 1.44l.52-1.96a.88.88 0 0 1 1.07-.64c.5.13.78.62.66 1.11l-.53 1.96l1.96-.53a.91.91 0 0 1 1.11.66a.88.88 0 0 1-.64 1.07Z"/>'
        },
        "head-snowflake-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m0-2C8.41 1 4.61 4.42 4.06 8.9L2.5 11h-.03l-.02.03c-.55.76-.62 1.76-.19 2.59c.36.69 1 1.17 1.74 1.32V16c0 1.85 1.28 3.42 3 3.87V23h11v-5.5c2.5-1.67 4-4.44 4-7.5c0-4.97-4.04-9-9-9m4.33 8.3l-1.96.51l1.44 1.46c.35.34.35.92 0 1.27s-.93.35-1.27 0l-1.45-1.44l-.52 1.96c-.12.49-.61.76-1.07.64a.91.91 0 0 1-.66-1.11l.53-1.96l-1.96.53a.91.91 0 0 1-1.11-.66c-.12-.45.16-.95.64-1.07l1.96-.52l-1.44-1.45a.9.9 0 0 1 1.27-1.27l1.46 1.44l.51-1.96c.12-.49.62-.77 1.09-.64c.49.13.77.62.64 1.1L14.9 8.1l1.97-.53c.48-.13.97.15 1.1.64c.13.47-.15.97-.64 1.09Z"/>'
        },
        "head-sync": {
            body: '<path fill="currentColor" d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.51 4-6.31c0-3.86-3.12-7-7-7m0 12v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 13 12v-1.5l2.25 2.25L13 15m3.33-3.29l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 13 7v1.5l-2.25-2.25L13 4v1.5c2.21 0 4 1.79 4 4c0 .82-.25 1.58-.67 2.21Z"/>'
        },
        "head-sync-outline": {
            body: '<path fill="currentColor" d="M13 3c3.88 0 7 3.14 7 7c0 2.8-1.63 5.19-4 6.31V21H9v-3H8c-1.11 0-2-.89-2-2v-3H4.5c-.42 0-.66-.5-.42-.81L6 9.66A7.003 7.003 0 0 1 13 3m0-2C8.41 1 4.61 4.42 4.06 8.9L2.5 11h-.03l-.02.03c-.55.76-.62 1.76-.19 2.59c.36.69 1 1.17 1.74 1.32V16c0 1.85 1.28 3.42 3 3.87V23h11v-5.5c2.5-1.67 4-4.44 4-7.5c0-4.97-4.04-9-9-9m1 14v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 14 12v-1.5l2.25 2.25L14 15m3.33-3.29l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 14 7v1.5l-2.25-2.25L14 4v1.5c2.21 0 4 1.79 4 4c0 .82-.25 1.58-.67 2.21Z"/>'
        },
        headphones: {
            body: '<path fill="currentColor" d="M12 1c-5 0-9 4-9 9v7a3 3 0 0 0 3 3h3v-8H5v-2a7 7 0 0 1 7-7a7 7 0 0 1 7 7v2h-4v8h3a3 3 0 0 0 3-3v-7c0-5-4.03-9-9-9Z"/>'
        },
        "headphones-bluetooth": {
            body: '<path fill="currentColor" d="M8 6a6 6 0 0 0-6 6v4.8c0 .66.54 1.2 1.2 1.2H6v-4H4v-2a4 4 0 0 1 4-4a4 4 0 0 1 4 4v2h-2v4h2.8a1.2 1.2 0 0 0 1.2-1.2V12a6 6 0 0 0-6-6m11 1v3.79L16.71 8.5l-.71.71L18.79 12L16 14.79l.71.71L19 13.21V17h.5l2.85-2.86L20.21 12l2.14-2.15L19.5 7H19m1 1.91l.94.94l-.94.94V8.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "headphones-box": {
            body: '<path fill="currentColor" d="M7.2 18c-.66 0-1.2-.54-1.2-1.2V12a6 6 0 0 1 6-6a6 6 0 0 1 6 6v4.8a1.2 1.2 0 0 1-1.2 1.2H14v-4h2v-2a4 4 0 0 0-4-4a4 4 0 0 0-4 4v2h2v4m9-15H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "headphones-off": {
            body: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v7c0 .62-.19 1.19-.5 1.67L15 13.18V12h4v-2a7 7 0 0 0-7-7c-2 0-3.77.82-5.04 2.14L5.55 3.72A8.96 8.96 0 0 1 12 1M2.78 3.5L20.5 21.22l-1.27 1.28l-2.5-2.5H15v-1.73l-6-6V20H6a3 3 0 0 1-3-3v-7c0-1.11.2-2.18.57-3.16L1.5 4.77L2.78 3.5m2.39 4.94C5.06 8.94 5 9.46 5 10v2h3.73L5.17 8.44Z"/>'
        },
        "headphones-settings": {
            body: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v7a3 3 0 0 1-3 3h-3v-8h4v-2a7 7 0 0 0-7-7a7 7 0 0 0-7 7v2h4v8H6a3 3 0 0 1-3-3v-7a9 9 0 0 1 9-9m3 23v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7Z"/>'
        },
        headset: {
            body: '<path fill="currentColor" d="M12 1c-5 0-9 4-9 9v7a3 3 0 0 0 3 3h3v-8H5v-2a7 7 0 0 1 7-7a7 7 0 0 1 7 7v2h-4v8h4v1h-7v2h6a3 3 0 0 0 3-3V10c0-5-4.03-9-9-9Z"/>'
        },
        "headset-dock": {
            body: '<path fill="currentColor" d="M2 18h7V6.13C7.27 6.57 6 8.14 6 10v1h2v6H6a2 2 0 0 1-2-2v-5a6 6 0 0 1 6-6h1a6 6 0 0 1 6 6v2h1V9h2v3a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2h-2v-6h2v-1c0-1.86-1.27-3.43-3-3.87V18h10v2H2v-2Z"/>'
        },
        "headset-off": {
            body: '<path fill="currentColor" d="m1.5 4.77l2.07 2.07C3.2 7.82 3 8.89 3 10v10a3 3 0 0 0 3 3h6v-2H5v-1h4v-7.73l6 6V20h1.73l2.5 2.5l1.27-1.28L2.78 3.5L1.5 4.77M12 1a8.96 8.96 0 0 0-6.45 2.72l1.41 1.42A6.94 6.94 0 0 1 12 3a7 7 0 0 1 7 7v2h-4v1.18l5.5 5.49c.31-.48.5-1.05.5-1.67v-7a9 9 0 0 0-9-9M5 12v-2c0-.54.06-1.06.17-1.56L8.73 12H5Z"/>'
        },
        heart: {
            body: '<path fill="currentColor" d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35Z"/>'
        },
        "heart-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m7 14l.72-.66C15.3 14 17 12.46 17 10.57c0-1.54-1.21-2.75-2.75-2.75c-.87 0-1.7.41-2.25 1.05a3.007 3.007 0 0 0-2.25-1.05C8.21 7.82 7 9.03 7 10.57c0 1.89 1.7 3.43 4.28 5.77L12 17Z"/>'
        },
        "heart-box-outline": {
            body: '<path fill="currentColor" d="m12 17l-.72-.66C8.7 14 7 12.46 7 10.57c0-1.54 1.21-2.75 2.75-2.75c.87 0 1.7.41 2.25 1.05c.55-.64 1.38-1.05 2.25-1.05c1.54 0 2.75 1.21 2.75 2.75c0 1.89-1.7 3.43-4.28 5.77L12 17M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h14V5H5Z"/>'
        },
        "heart-broken": {
            body: '<path fill="currentColor" d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c.67 0 1.32.12 1.94.33L13 9.35l-4 5l3 7M16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35l-1-7l4.5-5l-2.65-5.08C13.87 3.47 15.17 3 16.5 3Z"/>'
        },
        "heart-broken-outline": {
            body: '<path fill="currentColor" d="M7.5 5c.2 0 .4 0 .6.1l2.4 4.1l-3.7 4.6C5.1 11.8 4 10.2 4 8.5C4 6.5 5.5 5 7.5 5m0-2C4.4 3 2 5.4 2 8.5c0 3.8 3.4 6.9 8.6 11.5l1.4 1.3l-3-7l4-5l-3.6-6C8.8 3.1 8.2 3 7.5 3m9 2c2 0 3.5 1.5 3.5 3.5c0 2.6-2.6 5.2-6.6 8.8l-.3-2.3l4.8-5.3l-2.3-4.5c.3-.2.6-.2.9-.2m0-2c-1.3 0-2.6.5-3.6 1.3l2.6 5.1l-4.5 5l1 7l1.4-1.3c5.2-4.7 8.6-7.8 8.6-11.5C22 5.4 19.6 3 16.5 3Z"/>'
        },
        "heart-circle": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M9.75 7.82c.87 0 1.7.41 2.25 1.05c.55-.64 1.38-1.05 2.25-1.05c1.54 0 2.75 1.21 2.75 2.75c0 1.89-1.7 3.43-4.28 5.77L12 17l-.72-.66C8.7 14 7 12.46 7 10.57c0-1.54 1.21-2.75 2.75-2.75Z"/>'
        },
        "heart-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8M9.75 7.82C8.21 7.82 7 9.03 7 10.57c0 1.89 1.7 3.43 4.28 5.77L12 17l.72-.66C15.3 14 17 12.46 17 10.57c0-1.54-1.21-2.75-2.75-2.75c-.87 0-1.7.41-2.25 1.05a3.007 3.007 0 0 0-2.25-1.05Z"/>'
        },
        "heart-cog": {
            body: '<path fill="currentColor" d="M12 19c0 .71.12 1.4.32 2.06l-.32.29l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.3-.41 2.5-1.16 3.75c-.59-.16-1.21-.25-1.84-.25c-3.86 0-7 3.14-7 7m11.83 1.64l-1 1.73c-.07.13-.2.13-.33.13l-1.23-.5c-.27.18-.54.34-.84.47l-.19 1.32c-.02.12-.13.21-.24.21h-2c-.14 0-.24-.09-.26-.21l-.19-1.32c-.31-.12-.59-.29-.85-.47l-1.24.5c-.12 0-.25 0-.31-.13l-1-1.73a.26.26 0 0 1 .06-.32l1.06-.82a4.193 4.193 0 0 1 0-1l-1.06-.82a.248.248 0 0 1-.06-.32l1-1.73c.07-.13.2-.13.31-.13l1.24.5c.26-.18.55-.34.85-.47l.19-1.32A.26.26 0 0 1 18 14h2c.11 0 .22.09.23.21l.19 1.32c.31.12.58.29.85.47l1.23-.5c.13 0 .26 0 .32.13l1 1.73c.06.11.03.24-.06.32l-1.06.82c.03.17.04.33.04.5s-.02.33-.04.5l1.07.82c.09.08.12.21.06.32M20.5 19c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.66 1.5 1.5 1.5c.83 0 1.5-.67 1.5-1.5Z"/>'
        },
        "heart-cog-outline": {
            body: '<path fill="currentColor" d="M16.5 5c-1.54 0-3.04 1-3.57 2.36h-1.86C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.89 10.05l.11.1v-.02v.37c0 .71.12 1.4.32 2.06l-.32.29l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.3-.41 2.5-1.16 3.75c-.59-.16-1.21-.25-1.84-.25h-.4c.9-1.21 1.4-2.35 1.4-3.5c0-2-1.5-3.5-3.5-3.5m7.33 15.64l-1 1.73c-.07.13-.2.13-.33.13l-1.23-.5c-.27.18-.54.34-.84.47l-.19 1.32c-.02.12-.13.21-.24.21h-2c-.14 0-.24-.09-.26-.21l-.19-1.32c-.31-.12-.59-.29-.85-.47l-1.24.5c-.12 0-.25 0-.31-.13l-1-1.73a.26.26 0 0 1 .06-.32l1.06-.82a4.193 4.193 0 0 1 0-1l-1.06-.82a.248.248 0 0 1-.06-.32l1-1.73c.07-.13.2-.13.31-.13l1.24.5c.26-.18.55-.34.85-.47l.19-1.32A.26.26 0 0 1 18 14h2c.11 0 .22.09.23.21l.19 1.32c.31.12.58.29.85.47l1.23-.5c.13 0 .26 0 .32.13l1 1.73c.06.11.03.24-.06.32l-1.06.82c.03.17.04.33.04.5s-.02.33-.04.5l1.07.82c.09.08.12.21.06.32M20.5 19c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.66 1.5 1.5 1.5c.83 0 1.5-.67 1.5-1.5Z"/>'
        },
        "heart-flash": {
            body: '<path fill="currentColor" d="M16.5 2.83c-1.74 0-3.41.81-4.5 2.07c-1.09-1.26-2.76-2.07-4.5-2.07c-3.08 0-5.5 2.41-5.5 5.5c0 3.77 3.4 6.86 8.55 11.53L12 21.17l1.45-1.31C18.6 15.19 22 12.1 22 8.33c0-3.09-2.42-5.5-5.5-5.5m-4.5 15v-4H9l3-7v4h3"/>'
        },
        "heart-half": {
            body: '<path fill="currentColor" d="M13 7.2v13.24l-1 .91l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C10 3 13 5 13 7.2Z"/>'
        },
        "heart-half-full": {
            body: '<path fill="currentColor" d="M16.5 5c-1.5 0-2.92.91-3.5 2.2v10.54c4.25-3.87 7-6.54 7-9.24c0-2-1.5-3.5-3.5-3.5m0-2C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3Z"/>'
        },
        "heart-half-outline": {
            body: '<path fill="currentColor" d="M4 8.5c0 2.7 2.75 5.37 7 9.24V7.2C10.42 5.91 9 5 7.5 5C5.5 5 4 6.5 4 8.5m9-1.3v13.24l-1 .91l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C10 3 13 5 13 7.2Z"/>'
        },
        "heart-minus": {
            body: '<path fill="currentColor" d="M12 18c0 1 .25 1.92.67 2.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.79-.38-1.68-.61-2.62-.61c-3.31 0-6 2.69-6 6m2-1v2h8v-2h-8Z"/>'
        },
        "heart-minus-outline": {
            body: '<path fill="currentColor" d="m12.67 20.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.62-.3-1.31-.5-2.03-.57C19.5 10.8 20 9.65 20 8.5c0-2-1.5-3.5-3.5-3.5c-1.54 0-3.04 1-3.57 2.36h-1.86C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.89 10.05l.11.1l.04-.04c.08.76.3 1.48.63 2.13M14 17v2h8v-2h-8Z"/>'
        },
        "heart-multiple": {
            body: '<path fill="currentColor" d="M13.5 20c-6.6-6.1-10-9.2-10-12.9C3.5 4 5.9 1.6 9 1.6c1.7 0 3.4.8 4.5 2.1c1.1-1.3 2.8-2.1 4.5-2.1c3.1 0 5.5 2.4 5.5 5.5c0 3.8-3.4 6.9-10 12.9M12 21.1C5.4 15.2 1.5 11.7 1.5 7v-.6c-.6.9-1 2-1 3.2c0 3.8 3.4 6.9 10 12.8l1.5-1.3Z"/>'
        },
        "heart-multiple-outline": {
            body: '<path fill="currentColor" d="m12 21.1l-1.5 1.3c-6.6-5.9-10-9-10-12.8c0-1.2.4-2.3 1-3.2V7c0 4.7 3.9 8.2 10.5 14.1m1.6-4.1c4.7-4.3 7.9-7.1 8-10c0-2-1.5-3.5-3.5-3.5c-1.6 0-3.1 1-3.6 2.4h-1.9C12 4.5 10.5 3.5 9 3.5C7 3.5 5.5 5 5.5 7c0 2.9 3.1 5.7 7.9 10l.1.1M18 1.5c3.1 0 5.5 2.4 5.5 5.5c0 3.7-3.4 6.8-10 12.8c-6.6-5.9-10-9-10-12.8c0-3.1 2.4-5.5 5.5-5.5c1.7 0 3.4.8 4.5 2.1c1.1-1.3 2.8-2.1 4.5-2.1Z"/>'
        },
        "heart-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L20 20.72L18.73 22l-3.55-3.56l-1.73 1.59L12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5c0-.95.23-1.83.63-2.6L1 4.27M7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 2.57-1.58 4.82-4.21 7.47L5.27 3.45C5.95 3.16 6.7 3 7.5 3Z"/>'
        },
        "heart-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l2.08 2.08C2.45 6 2 7.19 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32c.87-.79 1.69-1.53 2.45-2.24L20 22l1.27-1.27m-9.17-2.18l-.1.1l-.11-.1C7.14 14.24 4 11.39 4 8.5c0-.76.22-1.44.61-2l9.89 9.87c-.76.69-1.55 1.41-2.4 2.18M8.3 5.1L6.33 3.13C6.7 3.05 7.1 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 2.34-1.31 4.42-3.53 6.77l-1.41-1.41C18.91 11.88 20 10.2 20 8.5c0-2-1.5-3.5-3.5-3.5c-1.4 0-2.76.83-3.39 2h-2.22c-.51-.94-1.5-1.66-2.59-1.9Z"/>'
        },
        "heart-outline": {
            body: '<path fill="currentColor" d="m12.1 18.55l-.1.1l-.11-.1C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5c1.54 0 3.04 1 3.57 2.36h1.86C13.46 6 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5c0 2.89-3.14 5.74-7.9 10.05M16.5 3c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z"/>'
        },
        "heart-plus": {
            body: '<path fill="currentColor" d="M12 18c0 1 .25 1.92.67 2.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.79-.38-1.68-.61-2.62-.61c-3.31 0-6 2.69-6 6m7-4h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3Z"/>'
        },
        "heart-plus-outline": {
            body: '<path fill="currentColor" d="m12.67 20.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.62-.3-1.31-.5-2.03-.57C19.5 10.8 20 9.65 20 8.5c0-2-1.5-3.5-3.5-3.5c-1.54 0-3.04 1-3.57 2.36h-1.86C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.89 10.05l.11.1l.04-.04c.08.76.3 1.48.63 2.13M17 14v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "heart-pulse": {
            body: '<path fill="currentColor" d="M7.5 4A5.5 5.5 0 0 0 2 9.5c0 .5.09 1 .22 1.5H6.3l1.27-3.37c.3-.8 1.48-.88 1.86 0L11.5 13l.59-1.42c.13-.33.48-.58.91-.58h8.78c.13-.5.22-1 .22-1.5A5.5 5.5 0 0 0 16.5 4c-1.86 0-3.5.93-4.5 2.34C11 4.93 9.36 4 7.5 4M3 12.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1h2.44L11 20c1 .9 1 .9 2 0l5.56-5.5H21a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-7.6l-.93 2.3c-.4 1.01-1.55.87-1.92.03L8.5 9.5l-.96 2.33c-.15.38-.49.67-.94.67H3Z"/>'
        },
        "heart-remove": {
            body: '<path fill="currentColor" d="M12 18c0 1 .25 1.92.67 2.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.79-.38-1.68-.61-2.62-.61c-3.31 0-6 2.69-6 6m9.54-2.12l-1.42-1.41L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12Z"/>'
        },
        "heart-remove-outline": {
            body: '<path fill="currentColor" d="m12.67 20.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.62-.3-1.31-.5-2.03-.57C19.5 10.8 20 9.65 20 8.5c0-2-1.5-3.5-3.5-3.5c-1.54 0-3.04 1-3.57 2.36h-1.86C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.89 10.05l.11.1l.04-.04c.08.76.3 1.48.63 2.13m7.45-6.28L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12l-1.42-1.42Z"/>'
        },
        "heart-settings": {
            body: '<path fill="currentColor" d="M15 22h2v2h-2v-2m-4 2h2v-2h-2v2m-4 0h2v-2H7v2m9.5-21c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z"/>'
        },
        "heart-settings-outline": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 2h2v-2h-2v2m4 0h2v-2h-2v2m7-15.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5m-2 0c0-2-1.5-3.5-3.5-3.5c-1.54 0-3.04 1-3.57 2.36h-1.86C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.89 10.05l.11.1l.1-.1C16.86 14.24 20 11.39 20 8.5Z"/>'
        },
        "heat-pump": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6.25 4.08c.82.12 1.57.42 2.2.92l-2.2 2.19V7.08m-1.5 0v3.11L9.05 8c.63-.5 1.38-.8 2.2-.92M8 9.05l2.19 2.2H7.08c.12-.82.42-1.57.92-2.2m-.92 3.7h3.11L8 14.95c-.5-.63-.8-1.38-.92-2.2m4.17 4.17c-.82-.12-1.57-.42-2.2-.92l2.2-2.19v3.11M12 13c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m.75 3.92v-3.11l2.2 2.19c-.63.5-1.38.8-2.2.92M16 14.95l-2.19-2.2h3.11c-.12.82-.42 1.57-.92 2.2m-2.19-3.7L16 9.05c.5.64.8 1.39.92 2.2h-3.11Z"/>'
        },
        "heat-pump-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14v14m-7-1c3.31 0 6-2.69 6-6s-2.69-6-6-6s-6 2.69-6 6s2.69 6 6 6m-.75-2.08c-.55-.1-1.05-.32-1.5-.62l1.5-1.5v2.12m1.5 0v-2.11l1.5 1.5c-.45.3-.95.51-1.5.61m2.56-1.67l-1.5-1.5h2.11c-.1.55-.31 1.05-.61 1.5m.61-3h-2.11l1.5-1.5c.3.45.51.95.61 1.5m-3.17-3.17c.55.1 1.05.32 1.5.62l-1.5 1.5V8.08M12 11c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-.75-2.92v2.11l-1.5-1.5c.45-.3.95-.51 1.5-.61M8.69 9.75l1.5 1.5H8.08c.1-.55.31-1.05.61-1.5m1.5 3l-1.5 1.5c-.3-.44-.51-.95-.62-1.5h2.12Z"/>'
        },
        "heat-wave": {
            body: '<path fill="currentColor" d="m8.5 4.5l-3.1 5l3.1 5.2l-3.3 5.8l-1.8-.9l2.7-4.9L3 9.5l3.7-5.9l1.8.9m6.2-.1l-3.1 5.1l3.1 5l-3.3 5.8l-1.8-.9l2.7-4.9l-3.1-5l3.7-6l1.8.9m6.3 0l-3.1 5.1l3.1 5l-3.3 5.8l-1.8-.9l2.7-4.9l-3.1-5l3.7-6l1.8.9"/>'
        },
        "heating-coil": {
            body: '<path fill="currentColor" d="M19 17c1.21 0 3-.8 3-3s-1.79-3-3-3h-2V9h2c2.2 0 3-1.79 3-3c0-2.2-1.79-3-3-3h-2V2h-1v1H8V2H7v1H2v2h5v2H5c-1.21 0-3 .8-3 3s1.79 3 3 3h2v2H5c-1.21 0-3 .8-3 3s1.79 3 3 3h2v1h1v-1h8v1h1v-1h5v-2h-5v-2h2m0-4c.45 0 1 .19 1 1s-.55 1-1 1h-2v-2h2m-3-2H8V9h8v2m3-6c.45 0 1 .2 1 1c0 .45-.19 1-1 1h-2V5h2M8 5h8v2H8V5m-3 6c-.45 0-1-.19-1-1s.55-1 1-1h2v2H5m3 2h8v2H8v-2m-3 6c-.45 0-1-.19-1-1s.55-1 1-1h2v2H5m11 0H8v-2h8v2Z"/>'
        },
        helicopter: {
            body: '<path fill="currentColor" d="M3 3h14v2H3V3m20 3v4.5l-8.25 1.7A3.499 3.499 0 0 1 13 16.66V19h3v2H4a3 3 0 0 1-3-3v-1h2v1a1 1 0 0 0 1 1h1v-2.26c-1.75-.61-3-2.28-3-4.24C2 10 4 8 6.5 8H9V6h2v2h10V6h2M11 19v-2H7v2h4m-3.5-9c-1.38 0-2.5.9-2.5 2s1.12 2 2.5 2s2.5-.9 2.5-2s-1.12-2-2.5-2Z"/>'
        },
        help: {
            body: '<path fill="currentColor" d="M10 19h3v3h-3v-3m2-17c5.35.22 7.68 5.62 4.5 9.67c-.83 1-2.17 1.66-2.83 2.5C13 15 13 16 13 17h-3c0-1.67 0-3.08.67-4.08c.66-1 2-1.59 2.83-2.25C15.92 8.43 15.32 5.26 12 5a3 3 0 0 0-3 3H6a6 6 0 0 1 6-6Z"/>'
        },
        "help-box": {
            body: '<path fill="currentColor" d="M11 18h2v-2h-2v2m1-12a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/>'
        },
        "help-circle": {
            body: '<path fill="currentColor" d="m15.07 11.25l-.9.92C13.45 12.89 13 13.5 13 15h-2v-.5c0-1.11.45-2.11 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 0 0-2-2a2 2 0 0 0-2 2H8a4 4 0 0 1 4-4a4 4 0 0 1 4 4a3.2 3.2 0 0 1-.93 2.25M13 19h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10Z"/>'
        },
        "help-circle-outline": {
            body: '<path fill="currentColor" d="M11 18h2v-2h-2v2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4Z"/>'
        },
        "help-network": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10m-4.81 2c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91c-.2.26-.31.68-.31 1.18h2c0-.31.04-.56.13-.74c.09-.19.26-.36.51-.52c.45-.24.82-.53 1.11-.93c.29-.4.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82c-.53-.45-1.26-.68-2.19-.68M11 12v2h2v-2h-2Z"/>'
        },
        "help-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m4.95-9c-.78 0-1.4.18-1.88.5c-.46.39-.69.9-.68 1.6l.01.03h1.71c.01-.27.09-.48.25-.63c.14-.12.36-.19.59-.19c.27 0 .5.09.66.25c.16.17.24.4.24.66c0 .28-.07.53-.21.73c-.14.21-.31.38-.54.55c-.45.28-.76.55-.93.79c-.17.21-.28.6-.28 1.04h1.78c0-.27.03-.49.11-.65c.08-.18.22-.32.46-.47c.4-.21.73-.47.98-.82c.28-.36.4-.72.4-1.17c0-.67-.24-1.22-.72-1.61c-.48-.41-1.13-.61-1.95-.61m-1.06 6.22V14h1.78v-1.78h-1.78Z"/>'
        },
        "help-rhombus": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 4.95c2.7.11 3.87 2.83 2.28 4.86c-.42.5-1.09.83-1.43 1.26c-.35.43-.35.93-.35 1.43H11c0-.85 0-1.56.35-2.06c.33-.5 1-.8 1.42-1.13c1.23-1.13.91-2.72-.77-2.85c-.82 0-1.5.67-1.5 1.51H9c0-1.67 1.35-3.02 3-3.02m-1 8.55h1.5V17H11v-1.5Z"/>'
        },
        "help-rhombus-outline": {
            body: '<path fill="currentColor" d="M11 15.5h1.5V17H11v-1.5m1-8.55c2.7.11 3.87 2.83 2.28 4.86c-.42.5-1.09.83-1.43 1.26c-.35.43-.35.93-.35 1.43H11c0-.85 0-1.56.35-2.06c.33-.5 1-.8 1.42-1.13c1.23-1.13.91-2.72-.77-2.85c-.82 0-1.5.67-1.5 1.51H9c0-1.67 1.35-3.02 3-3.02M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l8 8l-8 8l-8-8Z"/>'
        },
        hexadecimal: {
            body: '<path fill="currentColor" d="M7 7c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9a2 2 0 0 0-2-2H7m0 2h2v6H7V9m10.6 8l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4l2.1 2.1l2.1-2.1l1.4 1.4l-2.1 2.1l2.1 2.1l-1.4 1.4Z"/>'
        },
        hexagon: {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9Z"/>'
        },
        "hexagon-multiple": {
            body: '<path fill="currentColor" d="M10.25 2c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26h-4.5c-.19 0-.36-.11-.44-.26L3.09 6.78L3 6.5l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5m0 11c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26h-4.5c-.19 0-.36-.11-.44-.26l-2.22-3.96L3 17.5l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5m9.25-5.5c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26H15c-.19 0-.36-.11-.44-.26l-2.22-3.96l-.09-.28l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5Z"/>'
        },
        "hexagon-multiple-outline": {
            body: '<path fill="currentColor" d="m9.37 4l1.41 2.5L9.37 9H6.63l-1.4-2.5L6.63 4h2.74m.88-2h-4.5c-.19 0-.36.11-.44.26L3.09 6.22L3 6.5l.09.28l2.22 3.96c.08.15.25.26.44.26h4.5c.19 0 .36-.11.44-.26l2.22-3.96l.09-.28l-.09-.28l-2.22-3.96a.505.505 0 0 0-.44-.26m8.37 7.5L20 12l-1.38 2.5h-2.74L14.5 12l1.38-2.5h2.74m.88-2H15c-.19 0-.36.11-.44.26l-2.22 3.96l-.09.28l.09.28l2.22 3.96c.08.15.25.26.44.26h4.5c.19 0 .36-.11.44-.26l2.22-3.96l.09-.28l-.09-.28l-2.22-3.96a.505.505 0 0 0-.44-.26M9.37 15l1.41 2.5L9.37 20H6.63l-1.4-2.5l1.4-2.5h2.74m.88-2h-4.5c-.19 0-.36.11-.44.26l-2.22 3.96l-.09.28l.09.28l2.22 3.96c.08.15.25.26.44.26h4.5c.19 0 .36-.11.44-.26l2.22-3.96l.09-.28l-.09-.28l-2.22-3.96a.505.505 0 0 0-.44-.26Z"/>'
        },
        "hexagon-outline": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "hexagon-slice-1": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94M12 12V5.32l5.94 3.34L12 12Z"/>'
        },
        "hexagon-slice-2": {
            body: '<path fill="currentColor" d="M18 15.38L12 12V5.32l6 3.37v6.69m3 1.12c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "hexagon-slice-3": {
            body: '<path fill="currentColor" d="m12 5.32l6 3.37v6.62l-6 3.37V5.32m9 11.18c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "hexagon-slice-4": {
            body: '<path fill="currentColor" d="m12 5.32l6 3.37v6.62l-6 3.37l-5.94-3.34L12 12V5.32m9 11.18c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "hexagon-slice-5": {
            body: '<path fill="currentColor" d="m12 5.32l6 3.37v6.62l-6 3.37l-6-3.37V8.69L12 12V5.32m9 11.18c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        "hexagon-slice-6": {
            body: '<path fill="currentColor" d="m12 5.32l6 3.37v6.62l-6 3.37l-6-3.37V8.69l6-3.37m9 11.18c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15L5 8.09v7.82l7 3.94l7-3.94V8.09l-7-3.94Z"/>'
        },
        hexagram: {
            body: '<path fill="currentColor" d="m14.5 7.66l6.14-.69L17 12l3.68 4.97l-6.18-.65L12.03 22L9.5 16.34l-6.14.69L7 12L3.32 7.03l6.18.65L11.97 2l2.53 5.66Z"/>'
        },
        "hexagram-outline": {
            body: '<path fill="currentColor" d="m12 7l1.3 2.8l3.2-.4l-2 2.6l1.9 2.5l-3.2-.4L12 17l-1.3-2.8l-3.2.4l2-2.6l-1.9-2.5l3.2.4L12 7m0-5L9.5 7.7L3.3 7L7 12l-3.6 5l6.2-.7L12 22l2.5-5.7l6.2.6L17 12l3.6-5l-6.2.7L12 2Z"/>'
        },
        "high-definition": {
            body: '<path fill="currentColor" d="M5 7h2v4h2V7h2v10H9v-4H7v4H5V7m8 0h3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-3V7m3 8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1v6h1Z"/>'
        },
        "high-definition-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6m2-6h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4V9m1.5 4.5h2v-3h-2v3Z"/>'
        },
        highway: {
            body: '<path fill="currentColor" d="M10 2L8 8h3V2h-1m3 0v6h3l-2-6h-1M2 9v1h2v1h2v-1h12l.06 1H20v-1h2V9H2m5 2L3.34 22H11V11H7m6 0v11h7.66L17 11h-4Z"/>'
        },
        hiking: {
            body: '<path fill="currentColor" d="M17.47 8.67H19V23h-1.53V12.6c-.8-.16-1.55-.46-2.26-.89s-1.31-.93-1.82-1.51l-.62 3.07l2.23 2.2V23h-2v-6l-2.24-2.2L8.89 23H6.73S9.86 7.22 9.89 7.09c.11-.48.33-.85.7-1.09c.37-.27.74-.4 1.12-.4c.39 0 .75.09 1.08.27c.34.17.6.42.79.74l1.06 1.63c.29.54.68 1.01 1.17 1.39s1.05.67 1.66.87V8.67M8.55 5.89L7.4 5.65c-.57-.15-1.09-.03-1.56.29c-.46.32-.74.76-.84 1.34l-.81 3.98c-.03.29.03.55.19.79s.37.37.62.41l2.21.43l1.34-7M13 1c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2Z"/>'
        },
        history: {
            body: '<path fill="currentColor" d="M13.5 8H12v5l4.28 2.54l.72-1.21l-3.5-2.08V8M13 3a9 9 0 0 0-9 9H1l3.96 4.03L9 12H6a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0 0 13 21a9 9 0 0 0 9-9a9 9 0 0 0-9-9"/>'
        },
        "hockey-puck": {
            body: '<path fill="currentColor" d="M12 5C6.5 5 2 6.57 2 8.5S6.5 12 12 12s10-1.57 10-3.5S17.5 5 12 5M2 11.76v4.74C2 18.43 6.5 20 12 20s10-1.57 10-3.5v-4.74c-.67.46-1.42.81-2.27 1.1C17.62 13.6 14.95 14 12 14s-5.62-.4-7.73-1.14c-.85-.29-1.6-.64-2.27-1.1Z"/>'
        },
        "hockey-sticks": {
            body: '<path fill="currentColor" d="M17.68 4H14.3l-1.74 4c-.03.04-.11.22-.25.5s-.25.54-.31.69L9.7 4H6.32l4.09 8.84c.09.22.32.75.7 1.59c.39.85.67 1.48.89 1.92l1.41 3.09c.19.34.48.51.89.51L19 20v-4h-4l-1.4-3.16L17.68 4m2.35 12v4H22v-3c0-.27-.09-.5-.28-.72c-.19-.2-.42-.28-.72-.28h-.97M5 16v4l4.7-.05c.41 0 .7-.17.89-.51l.85-1.94l-1.6-3.44L9 16H5m-3 4h1.97v-4H3c-.3 0-.53.08-.72.28c-.19.22-.28.45-.28.72v3Z"/>'
        },
        hololens: {
            body: '<path fill="currentColor" d="M12 8s10 0 10 3c0 0 .09 3.36-.25 3.25C21 11 12 11 12 11s-9 0-9.75 3.25C1.91 14.36 2 11 2 11c0-3 10-3 10-3m0 4c8 0 8.75 2.25 8.75 2.25c-1 3-1.75 3.75-5.75 3.75c-3 0-2-1.5-3-1.5S12 18 9 18c-4 0-4.75-.75-5.75-3.75C3.25 14.25 4 12 12 12Z"/>'
        },
        home: {
            body: '<path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8h5Z"/>'
        },
        "home-account": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m0 5.75A2.25 2.25 0 0 1 14.25 11A2.25 2.25 0 0 1 12 13.25A2.25 2.25 0 0 1 9.75 11A2.25 2.25 0 0 1 12 8.75M12 15c1.5 0 4.5.75 4.5 2.25V18h-9v-.75c0-1.5 3-2.25 4.5-2.25Z"/>'
        },
        "home-alert": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m1 15h-2v-2h2v2m0-4h-2V8h2v6Z"/>'
        },
        "home-alert-outline": {
            body: '<path fill="currentColor" d="m12 5.7l5 4.5V18H7v-7.8l5-4.5M19 20v-8h3L12 3L2 12h3v8m8-12h-2v5h2V8m0 7h-2v2h2v-2"/>'
        },
        "home-analytics": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3M9 18H7v-6h2m4 6h-2v-8h2m4 8h-2v-4h2"/>'
        },
        "home-assistant": {
            body: '<path fill="currentColor" d="M21.8 13H20v8h-7v-3.33l2.79-2.79l.71.12a2.1 2.1 0 1 0 0-4.2a2.1 2.1 0 0 0-2.1 2.1l.1.71l-1.5 1.52V9.65c.66-.36 1.1-1.05 1.1-1.85A2.1 2.1 0 0 0 12 5.7a2.1 2.1 0 0 0-2.1 2.1c0 .8.44 1.49 1.1 1.85v5.48l-1.5-1.52l.1-.71a2.1 2.1 0 0 0-2.1-2.1a2.1 2.1 0 0 0-2.1 2.1A2.1 2.1 0 0 0 7.5 15l.71-.12L11 17.67V21H4v-8H2.25c-.42 0-.83 0-.83-.21c.01-.22.43-.64.86-1.07L11 3c.33-.33.67-.67 1-.67c.33 0 .67.34 1 .67l4 4V6h2v3l2.78 2.78c.4.4.81.81.82 1.02c0 .2-.4.2-.8.2M7.5 12a.9.9 0 0 1 .9.9a.9.9 0 0 1-.9.9a.9.9 0 0 1-.9-.9a.9.9 0 0 1 .9-.9m9 0c.5 0 .9.4.9.9s-.4.9-.9.9a.9.9 0 0 1-.9-.9a.9.9 0 0 1 .9-.9M12 6.9c.5 0 .9.4.9.9s-.4.9-.9.9s-.9-.4-.9-.9s.4-.9.9-.9Z"/>'
        },
        "home-automation": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m0 5.5c2.34 0 4.46.93 6 2.44l-1.2 1.18a6.787 6.787 0 0 0-4.8-1.95c-1.88 0-3.58.74-4.8 1.95L6 10.94a8.541 8.541 0 0 1 6-2.44m0 3.33c1.4 0 2.67.56 3.6 1.47l-1.2 1.17a3.41 3.41 0 0 0-2.4-.97c-.94 0-1.79.37-2.4.97L8.4 13.3a5.13 5.13 0 0 1 3.6-1.47m0 3.34c.94 0 1.7.74 1.7 1.66c0 .92-.76 1.67-1.7 1.67s-1.7-.75-1.7-1.67c0-.92.76-1.66 1.7-1.66Z"/>'
        },
        "home-battery": {
            body: '<path fill="currentColor" d="M12 20H5v-8H2l10-9l2.78 2.5H14v1.67c-1.16.41-2 1.53-2 2.83v10m3-11h1V7.5h4V9h1c.55 0 1 .45 1 1v11c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1m1 2v3h4v-3h-4Z"/>'
        },
        "home-battery-outline": {
            body: '<path fill="currentColor" d="M15 9h1V7.5h4V9h1c.55 0 1 .45 1 1v11c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1m1 2v3h4v-3h-4m-4-5.31l-5 4.5V18h5v2H5v-8H2l10-9l2.78 2.5H14v1.67l-.24.1L12 5.69Z"/>'
        },
        "home-circle": {
            body: '<path fill="currentColor" d="M19.07 4.93C17.22 3 14.66 1.96 12 2c-2.66-.04-5.21 1-7.06 2.93C3 6.78 1.96 9.34 2 12c-.04 2.66 1 5.21 2.93 7.06C6.78 21 9.34 22.04 12 22c2.66.04 5.21-1 7.06-2.93C21 17.22 22.04 14.66 22 12c.04-2.66-1-5.22-2.93-7.07M17 12v6h-3.5v-5h-3v5H7v-6H5l7-7l7.5 7H17Z"/>'
        },
        "home-circle-outline": {
            body: '<path fill="currentColor" d="M12 20c-4.4 0-8-3.6-8-8s3.6-8 8-8s8 3.6 8 8s-3.6 8-8 8m0-18C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-1 12h2v3h3v-5h2l-6-5l-6 5h2v5h3v-3"/>'
        },
        "home-city": {
            body: '<path fill="currentColor" d="M0 21V10l7.5-5l7.5 5v11h-5v-7H5v7H0M24 2v19h-7V8.93l-1-.66V6h-2v.93l-4-2.66V2h14m-3 12h-2v2h2v-2m0-4h-2v2h2v-2m0-4h-2v2h2V6Z"/>'
        },
        "home-city-outline": {
            body: '<path fill="currentColor" d="M10 2v2.26l2 1.33V4h10v15h-5v2h7V2H10M7.5 5L0 10v11h15V10L7.5 5M14 6v.93L15.61 8H16V6h-2m4 0v2h2V6h-2M7.5 7.5L13 11v8h-3v-6H5v6H2v-8l5.5-3.5M18 10v2h2v-2h-2m0 4v2h2v-2h-2Z"/>'
        },
        "home-clock": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7c-2.38 0-4.47-1.19-5.74-3H4v-8H1l10-9l7 6.29c2.89.86 5 3.54 5 6.71m-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "home-clock-outline": {
            body: '<path fill="currentColor" d="m16.5 16.25l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M23 16c0 3.87-3.13 7-7 7c-2.38 0-4.47-1.19-5.74-3H4v-8H1l10-9l7 6.29c2.89.86 5 3.54 5 6.71M9.29 18c-.18-.63-.29-1.3-.29-2c0-3.46 2.5-6.32 5.8-6.89L11 5.69l-5 4.5V18h3.29M21 16c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "home-currency-usd": {
            body: '<path d="M12 3l10 9h-3v8H5v-8H2l10-9M9.22 8.93c-.47.47-.72 1.1-.72 1.82c0 1.68 2.04 2.32 3.26 2.71c1.5.47 1.71.75 1.74.79c0 .75-1.35.75-1.5.75c-.63 0-.97-.12-1.14-.22c-.19-.11-.36-.28-.36-.78h-2c0 1.43.74 2.16 1.35 2.5c.33.2.72.34 1.15.42V18h2v-1.09c1.53-.3 2.5-1.29 2.5-2.66c0-1.58-1.62-2.22-3.14-2.7c-1.56-.49-1.83-.78-1.86-.8c0-.25.07-.34.14-.41c.21-.21.72-.34 1.36-.34c.68 0 1.5.13 1.5.75h2c0-1.41-.94-2.38-2.5-2.66V7h-2v1.08c-.74.13-1.35.42-1.78.85z" fill="currentColor"/>',
            hidden: true
        },
        "home-edit": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h5v-6h4v1.11l5.43-5.43L12 3m9.04 8.14a.59.59 0 0 0-.39.16l-1 1l2.05 2.05l1-1a.55.55 0 0 0 0-.77l-1.28-1.28c-.1-.1-.24-.16-.38-.16m-1.98 1.74L13 18.94V21h2.06l6.05-6.07l-2.05-2.05Z"/>'
        },
        "home-edit-outline": {
            body: '<path fill="currentColor" d="M21.041 11.14c.142 0 .276.057.38.163l1.276 1.276a.541.541 0 0 1 0 .77l-1 1l-2.046-2.046l1-1a.567.567 0 0 1 .39-.163Zm-1.978 1.74l2.046 2.052L15.063 21H13v-2.063l6.063-6.057ZM12 5.688l-5 4.5V18h4v2H5v-8H2l10-9l7.459 6.713L17 12.172v-1.984l-5-4.5Z"/>'
        },
        "home-export-outline": {
            body: '<path fill="currentColor" d="m24 13l-4 4v-3h-9v-2h9V9l4 4M4 20v-8H1l10-9l7 6.3v.7h-2.21L11 5.69l-5 4.5V18h10v-2h2v4H4Z"/>'
        },
        "home-flood": {
            body: '<path fill="currentColor" d="M18.67 19c-1.95 0-2.09 1-3.33 1c-1.19 0-1.42-1-3.34-1c-1.94 0-2.09 1-3.33 1s-1.38-1-3.33-1s-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1c1.24 0 1.38 1 3.33 1s2.1-1 3.33-1s1.41 1 3.34 1s2.1-1 3.33-1c1.22 0 1.4 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1m-9.99-1.5c1.95 0 2.09-1 3.32-1c1.2 0 1.43 1 3.34 1c1.95 0 2.09-1 3.33-1c1.19 0 1.4 1 3.33 1v-2c-.65 0-1-.28-1.5-.55l-2-7.53l2.07.85l.74-1.86L9.78 2L2 11.61l1.57 1.23l1.39-1.78l.93 3.48c-.18-.04-.35-.04-.56-.04c-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1c1.19 0 1.42 1 3.33 1m5.36-7.32l1.42 5.32c-1.34.08-1.46-1-3.46-1c-.37 0-.66.04-.92.1l-.91-3.39l3.87-1.03Z"/>'
        },
        "home-floor-0": {
            body: '<path fill="currentColor" d="M11 10h2v6h-2v-6m11 2h-3v8H5v-8H2l10-9l10 9m-7-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6Z"/>'
        },
        "home-floor-1": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m-2 5h4v10h-2v-8h-2V8Z"/>'
        },
        "home-floor-2": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3M9 8h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2v-2H9V8Z"/>'
        },
        "home-floor-3": {
            body: '<path fill="currentColor" d="m12 3l10 9h-3v8H5v-8H2l10-9m3 8.5V10a2 2 0 0 0-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5Z"/>'
        },
        "home-floor-a": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m-1 5h2a2 2 0 0 1 2 2v8h-2v-3h-2v3H9v-8a2 2 0 0 1 2-2m0 2v3h2v-3h-2Z"/>'
        },
        "home-floor-b": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3M9 8h4a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5V16a2 2 0 0 1-2 2H9V8m2 2v2h2v-2h-2m0 4v2h2v-2h-2Z"/>'
        },
        "home-floor-g": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m-1 5h4v2h-4v6h2v-4h2v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2Z"/>'
        },
        "home-floor-l": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3M9 8h2v8h4v2H9V8Z"/>'
        },
        "home-floor-negative-1": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m-1 12H7v-2h4v2m4 3h-2v-8h-2V8h4v10Z"/>'
        },
        "home-group": {
            body: '<path fill="currentColor" d="M17 16h-2v6h-3v-5H8v5H5v-6H3l7-6l7 6M6 2l4 4H9v3H7V6H5v3H3V6H2l4-4m12 1l5 5h-1v4h-3V9h-2v3h-1.66L14 10.87V8h-1l5-5Z"/>'
        },
        "home-group-minus": {
            body: '<path fill="currentColor" d="M2 6H1l4-4l4 4H8v3H6V6H4v3H2V6m11 4.9l1.3 1.1H16V9h2v3h3V8h1l-5-5l-5 5h1v2.9m.8 11.1c-.5-.9-.8-1.9-.8-3c0-1.6.6-3.1 1.7-4.1L9 10l-7 6h2v6h3v-5h4v5h2.8m1.2-4v2h8v-2h-8Z"/>'
        },
        "home-group-plus": {
            body: '<path fill="currentColor" d="M2 6H1l4-4l4 4H8v3H6V6H4v3H2V6m11 4.9l1.3 1.1H16V9h2v3h3V8h1l-5-5l-5 5h1v2.9m.8 11.1c-.5-.9-.8-1.9-.8-3c0-1.6.6-3.1 1.7-4.1L9 10l-7 6h2v6h3v-5h4v5h2.8m4.2-7v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "home-group-remove": {
            body: '<path fill="currentColor" d="M2 6H1l4-4l4 4H8v3H6V6H4v3H2V6m11 4.9l1.3 1.1H16V9h2v3h3V8h1l-5-5l-5 5h1v2.9m.8 11.1c-.5-.9-.8-1.9-.8-3c0-1.6.6-3.1 1.7-4.1L9 10l-7 6h2v6h3v-5h4v5h2.8m7.3-6.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "home-heart": {
            body: '<path fill="currentColor" d="m2 12l10-9l10 9h-3v8H5v-8H2m10 6l.72-.66C15.3 15 17 13.46 17 11.57c0-1.54-1.21-2.75-2.75-2.75c-.87 0-1.7.41-2.25 1.05a3.007 3.007 0 0 0-2.25-1.05C8.21 8.82 7 10.03 7 11.57c0 1.89 1.7 3.43 4.28 5.77L12 18Z"/>'
        },
        "home-import-outline": {
            body: '<path fill="currentColor" d="m15 13l-4 4v-3H2v-2h9V9l4 4M5 20v-4h2v2h10v-7.81l-5-4.5L7.21 10H4.22L12 3l10 9h-3v8H5Z"/>'
        },
        "home-lightbulb": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3m-9 6h-2v-1h2m.5-2.42V16h-3v-1.42a3 3 0 1 1 3 0Z"/>'
        },
        "home-lightbulb-outline": {
            body: '<path fill="currentColor" d="M5 20v-8H2l10-9l10 9h-3v8H5m7-14.31l-5 4.5V18h10v-7.81l-5-4.5M11 17v-1h2v1h-2m0-2c-.28 0-.5-.22-.5-.5v-.9C9.6 13.08 9 12.11 9 11c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.11-.6 2.08-1.5 2.6v.9c0 .28-.22.5-.5.5h-2Z"/>'
        },
        "home-lightning-bolt": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m-.5 15v-4H9l3.5-7v4H15l-3.5 7Z"/>'
        },
        "home-lightning-bolt-outline": {
            body: '<path fill="currentColor" d="M5 20v-8H2l10-9l10 9h-3v8H5m7-14.31l-5 4.5V18h10v-7.81l-5-4.5M11.5 18v-4H9l3.5-7v4H15l-3.5 7Z"/>'
        },
        "home-lock": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m0 6a3 3 0 0 1 3 3v1h1v4H8v-4h1v-1a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v1h2v-1c0-.5-.4-1-1-1Z"/>'
        },
        "home-lock-open": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m0 5a3 3 0 0 1 3 3h-2a1 1 0 0 0-1-1a1 1 0 0 0-1 1v2h5v4H8v-4h1v-2a3 3 0 0 1 3-3Z"/>'
        },
        "home-map-marker": {
            body: '<path fill="currentColor" d="M12 3L2 12h3v8h14v-8h3L12 3m0 4.7c2.1 0 3.8 1.7 3.8 3.8c0 3-3.8 6.5-3.8 6.5s-3.8-3.5-3.8-6.5c0-2.1 1.7-3.8 3.8-3.8m0 2.3a1.5 1.5 0 0 0-1.5 1.5A1.5 1.5 0 0 0 12 13a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 12 10Z"/>'
        },
        "home-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8M12 3l10 9h-4a6.005 6.005 0 0 0-5.66 8H5v-8H2l10-9Z"/>'
        },
        "home-minus-outline": {
            body: '<path fill="currentColor" d="M14 17h8v2h-8v-2m-9 3v-8H2l10-9l10 9h-5v-1.81l-5-4.5l-5 4.5V18h5c0 .7.12 1.37.34 2H5Z"/>'
        },
        "home-modern": {
            body: '<path fill="currentColor" d="M6 21V8a2 2 0 0 1 2-2l8-3v3a2 2 0 0 1 2 2v13h-6v-5H8v5H6m8-2h2v-3h-2v3m-6-6h2V9H8v4m4 0h4V9h-4v4Z"/>'
        },
        "home-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.11 20H14v-4.11L12.11 14H10v6H5v-8H2l4.27-3.84L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M19 12h3L12 3L8.95 5.75L19 15.8V12Z"/>'
        },
        "home-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.16 5.16L2 12h3v8h6v-6h1.11l.89.89V20h5.11l2.73 2.73l1.27-1.27M9 12v6H7v-7.81l.68-.62L10.11 12H9m6 6v-1.11L16.11 18H15M10.36 7.16L8.95 5.75L12 3l10 9h-3v3.8l-2-2v-3.61l-5-4.5l-1.64 1.47Z"/>'
        },
        "home-outline": {
            body: '<path fill="currentColor" d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3"/>'
        },
        "home-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M12 3l10 9h-4a6.005 6.005 0 0 0-5.66 8H5v-8H2l10-9Z"/>'
        },
        "home-plus-outline": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M5 20v-8H2l10-9l10 9h-5v-1.81l-5-4.5l-5 4.5V18h5c0 .7.12 1.37.34 2H5Z"/>'
        },
        "home-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.12-2.12M12 3l10 9h-4a6.005 6.005 0 0 0-5.66 8H5v-8H2l10-9Z"/>'
        },
        "home-remove-outline": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.12l1.42 1.41L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.12-2.12M5 20v-8H2l10-9l10 9h-5v-1.81l-5-4.5l-5 4.5V18h5c0 .7.12 1.37.34 2H5Z"/>'
        },
        "home-roof": {
            body: '<path fill="currentColor" d="M19 16h3L12 7L2 16h3l7-6.31L19 16M7 8.81V7H4v4.5l3-2.69Z"/>'
        },
        "home-search": {
            body: '<path fill="currentColor" d="M19.31 18.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 23.39L22.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M5 20v-8H2l10-9l10 9h-1.82c-1.18-1.23-2.84-2-4.68-2c-3.58 0-6.5 2.92-6.5 6.5c0 1.29.38 2.5 1.03 3.5H5Z"/>'
        },
        "home-search-outline": {
            body: '<path fill="currentColor" d="M19.31 18.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 23.39L22.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M5 20v-8H2l10-9l10 9h-1.82A6.44 6.44 0 0 0 17 10.18l-5-4.49l-5 4.5V18h2.18c.17.72.46 1.39.85 2H5Z"/>'
        },
        "home-silo": {
            body: '<path fill="currentColor" d="M24 7.8C23.6 4.5 20.9 2 17.5 2c-1.7 0-3.4.7-4.6 1.9c-.7.7-1.2 1.4-1.5 2.3L17 9.9v.1h3v2h-3v2h3v2h-3v2h3v2h-3v2h7V7.8M13.3 7c.6-1.8 2.3-3 4.2-3s3.6 1.2 4.2 3h-8.4M0 11v11h5v-7h5v7h5V11L7.5 6L0 11Z"/>'
        },
        "home-silo-outline": {
            body: '<path fill="currentColor" d="M20 21h-3v-2h3v2m0-4h-3v-2h3v2m0-4h-3v-2h3v2m4-5.2C23.6 4.5 20.8 2 17.5 2c-1.7 0-3.4.7-4.6 1.9c-.7.7-1.2 1.4-1.5 2.3L15.6 9H22v13h2V7.8M13.3 7c.6-1.8 2.3-3 4.2-3s3.6 1.2 4.2 3h-8.4M7.5 6L0 11v11h15V11L7.5 6M13 20h-3v-6H5v6H2v-8l5.5-3.5L13 12v8Z"/>'
        },
        "home-switch": {
            body: '<path fill="currentColor" d="M6.5 15v-4h3v4H13V9h2L8 3L1 9h2v6h3.5M9 16v2h6v-2l3 3l-3 3v-2H9v2l-3-3l3-3m14-7h-2v6h-6v-5h4l-5.46-4.89L16 3l7 6Z"/>'
        },
        "home-switch-outline": {
            body: '<path fill="currentColor" d="M8 3L1 9h2v6h4v-4h2v4h4V9h2L8 3m3.5 6v4.5h-1v-4h-5v4h-1V8L8 5l3.5 3v1M9 16v2h6v-2l3 3l-3 3v-2H9v2l-3-3l3-3m14-7h-2v6h-6v-5h4l-5.46-4.89L16 3l7 6Z"/>'
        },
        "home-thermometer": {
            body: '<path fill="currentColor" d="M19 8a2 2 0 0 1 2 2v6.76c.61.55 1 1.35 1 2.24c0 1.66-1.34 3-3 3s-3-1.34-3-3c0-.89.39-1.69 1-2.24V10c0-1.1.9-2 2-2m0 1c-.55 0-1 .45-1 1v1h2v-1c0-.55-.45-1-1-1M5 20v-8H2l10-9l4.4 3.96A3.97 3.97 0 0 0 15 10v6c-.63.83-1 1.87-1 3l.1 1H5Z"/>'
        },
        "home-thermometer-outline": {
            body: '<path fill="currentColor" d="M19 8a2 2 0 0 1 2 2v6.76c.61.55 1 1.35 1 2.24c0 1.66-1.34 3-3 3s-3-1.34-3-3c0-.89.39-1.69 1-2.24V10c0-1.1.9-2 2-2m0 1c-.55 0-1 .45-1 1v1h2v-1c0-.55-.45-1-1-1m-7-3.31l-5 4.5V18h7.1l-.1 1l.1 1H5v-8H2l10-9l4.4 3.96c-.51.44-.9 1.01-1.15 1.65L12 5.69Z"/>'
        },
        "home-variant": {
            body: '<path fill="currentColor" d="m12 3l8 6v12h-5v-7H9v7H4V9l8-6Z"/>'
        },
        "home-variant-outline": {
            body: '<path fill="currentColor" d="M9 13h6v6h3v-9l-6-4.5L6 10v9h3v-6m-5 8V9l8-6l8 6v12H4Z"/>'
        },
        hook: {
            body: '<path fill="currentColor" d="M18 6a3.99 3.99 0 0 1-3 3.86V17a5 5 0 0 1-5 5a5 5 0 0 1-5-5v-5l5 5H7a3 3 0 0 0 3 3a3 3 0 0 0 3-3V9.86c-1.77-.46-3-2.06-3-3.89C10 3.76 11.8 2 14 2c2.22 0 4 1.79 4 4m-4 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2Z"/>'
        },
        "hook-off": {
            body: '<path fill="currentColor" d="M13 9.86v1.32l2 2V9.86c2.14-.55 3.43-2.73 2.87-4.86A4 4 0 0 0 13 2.11A4.008 4.008 0 0 0 10.13 7c.37 1.4 1.46 2.5 2.87 2.86M14 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4.73 18l-3.87-3.87a5.015 5.015 0 0 1-6.03 3.69C6.6 21.28 5 19.29 5 17v-5l5 5H7a3 3 0 0 0 3 3a3 3 0 0 0 3-3v-.73l-11-11L3.28 4L13 13.72l2 2l5 5L18.73 22Z"/>'
        },
        "hoop-house": {
            body: '<path fill="currentColor" d="M12 5C6.5 5 2 9.5 2 15v6h20v-6c0-5.5-4.5-10-10-10m0 2c2.53 0 4.78 1.17 6.25 3H5.76C7.22 8.17 9.47 7 12 7M8 19H4v-4c0-1.06.21-2.07.58-3H8v7m6 0h-4v-7h4v7m6 0h-4v-7h3.42c.37.93.58 1.94.58 3v4Z"/>'
        },
        hops: {
            body: '<path fill="currentColor" d="M21 12s-8.5-2-8.5-10c0 0 8.5 0 8.5 10M3 12C3 2 11.5 2 11.5 2c0 8-8.5 10-8.5 10m9-5.5s1 2.16 3 4c-.24 3.66-3 5.5-3 5.5s-2.76-1.84-3-5.5c2-1.84 3-4 3-4m8.75 6.75S20 17 18 19c0 0-2.47-1.64-3.67-4.19c.72-1.23 1.17-2.69 1.42-3.68c1.38 1.05 3 1.87 5 2.12m-5.25 5c-1 2-3.5 3.5-3.5 3.5s-2.5-1.5-3.5-3.5c0 0 1.09-.91 1.85-2.45c.47.55 1.01.99 1.65 1.2c.64-.21 1.18-.65 1.65-1.2c.76 1.54 1.85 2.45 1.85 2.45m-12.25-5c2-.25 3.62-1.07 5-2.12c.25.99.7 2.45 1.42 3.68C8.47 17.36 6 19 6 19c-2-2-2.75-5.75-2.75-5.75Z"/>'
        },
        "horizontal-rotate-clockwise": {
            body: '<path fill="currentColor" d="m12 14l-4-4l-4 4h3.1c.46 4.56 2.48 8 4.9 8s4.44-3.44 4.9-8h-1.99c-.34 3.45-1.51 6-2.91 6s-2.57-2.55-2.91-6H12m0-10c1.4 0 2.57 2.55 2.91 6h1.99c-.46-4.56-2.48-8-4.9-8c-2.16 0-4 2.74-4.7 6.58l.7-.7l1.21 1.2C9.64 6.11 10.73 4 12 4m10 9v-2H11l2 2h9M2 13h1l2-2H2v2Z"/>'
        },
        "horizontal-rotate-counterclockwise": {
            body: '<path fill="currentColor" d="M12 10H9.09C9.43 6.55 10.6 4 12 4s2.57 2.55 2.91 6h1.99c-.46-4.56-2.48-8-4.9-8s-4.44 3.44-4.9 8H4l4 4l4-4m0 10c-1.27 0-2.36-2.11-2.79-5.08L8 16.12l-.7-.7C8 19.26 9.84 22 12 22c2.42 0 4.44-3.44 4.9-8h-1.99c-.34 3.45-1.51 6-2.91 6m10-9h-9l-2 2h11v-2M2 13h3l-2-2H2v2"/>'
        },
        horse: {
            body: '<path fill="currentColor" d="M22 6v3.5l-1.5.5l-1.54-2.46c-.13-.21-.46-.12-.46.13v3.58c0 .98-.39 1.86-1 2.53V21H15v-6h-.25c-.21 0-.42-.03-.62-.06l-4.44-.74l-1.12 2.01l.96 4.79H7l-1-4.75c-.03-.3 0-.6.16-.86l1.02-1.81a3.272 3.272 0 0 1-1.68-2.77c-.04.15-.06.37-.03.69c.03.44.14 1.09.07 1.81c-.04.72-.37 1.46-.79 1.95c-.43.49-.9.83-1.4 1.09l-.7-.7c.19-.47.38-.89.42-1.28c.06-.37-.01-.67-.12-.94l-.53-1.13c-.21-.51-.47-1.25-.42-2.12c.03-.85.5-1.96 1.39-2.57c.9-.61 1.87-.69 2.66-.53c.5.1 1.01.34 1.45.68c.37-.17.8-.26 1.25-.26h5.75V7c0-2.21 1.79-4 4-4H22l-.89 1.34c.54.36.89.97.89 1.66Z"/>'
        },
        "horse-human": {
            body: '<path fill="currentColor" d="M10 3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S12.33 5 11.5 5S10 4.33 10 3.5M22 8v3.5l-1.03.35A2.5 2.5 0 0 1 18.5 14h-.08c-.14.68-.47 1.29-.92 1.78V22H15v-5h-.25c-.21 0-.42-.03-.62-.06l-4.44-.74l-1.12 2.01l.75 3.79H6.78L6 18.25c-.03-.3 0-.6.16-.86l1.02-1.81a3.272 3.272 0 0 1-1.68-2.77c-.04.15-.06.37-.03.69c.03.44.14 1.09.07 1.81c-.04.72-.37 1.46-.79 1.95c-.43.49-.9.83-1.4 1.09l-.7-.7c.19-.47.38-.89.42-1.28c.06-.37-.01-.67-.12-.94l-.53-1.13c-.21-.51-.47-1.25-.42-2.12c.03-.85.5-1.96 1.39-2.57c.9-.61 1.87-.7 2.66-.53c.5.1 1.01.34 1.45.68c.37-.17.8-.26 1.25-.26H9V8.11c0-1 .68-1.92 1.66-2.08A2 2 0 0 1 13 8v1.5h1.5V9c0-2.21 1.79-4 4-4H22l-.89 1.34c.54.36.89.97.89 1.66m-2 3.2l-1.04-1.66c-.13-.21-.46-.12-.46.13V13c.83 0 1.5-.67 1.5-1.5v-.3Z"/>'
        },
        "horse-variant": {
            body: '<path fill="currentColor" d="M20 8v8l-3 1l-3.09-5.5c-.26-.46-.99-.23-.91.31L14 21L4 17l1.15-8.06A6.923 6.923 0 0 1 12 3h8l-1.58 2.37C19.36 5.88 20 6.86 20 8Z"/>'
        },
        "horse-variant-fast": {
            body: '<path fill="currentColor" d="M23 8v8l-3 1l-3.09-5.5c-.26-.46-.99-.23-.91.31L17 21L7 17l1.15-8.06A6.923 6.923 0 0 1 15 3h8l-1.58 2.37C22.36 5.88 23 6.86 23 8M4 5h3.58c.5-.76 1.12-1.43 1.83-2H4c-.55 0-1 .45-1 1s.45 1 1 1m1.84 6H2c-.55 0-1 .45-1 1s.45 1 1 1h3.55l.29-2M3 9h3.12l.05-.34c.08-.58.22-1.13.41-1.66H3c-.55 0-1 .45-1 1s.45 1 1 1Z"/>'
        },
        horseshoe: {
            body: '<path fill="currentColor" d="M19 4h1V1h-4v3s2 4 2 8s-2 7-6 7s-6-3-6-7s2-8 2-8V1H4v3h1S2 8 2 14c0 5 5 9 10 9s10-4 10-9c0-6-3-10-3-10M4 13c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m2 6c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m6 3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m6-3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m2-6c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1Z"/>'
        },
        hospital: {
            body: '<path fill="currentColor" d="M18 14h-4v4h-4v-4H6v-4h4V6h4v4h4"/>'
        },
        "hospital-box": {
            body: '<path fill="currentColor" d="M18 14h-4v4h-4v-4H6v-4h4V6h4v4h4m1-7H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "hospital-box-outline": {
            body: '<path fill="currentColor" d="M18 14h-4v4h-4v-4H6v-4h4V6h4v4h4m2-8H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H4V4h16v16Z"/>'
        },
        "hospital-building": {
            body: '<path fill="currentColor" d="M2 22V7a1 1 0 0 1 1-1h4V2h10v4h4a1 1 0 0 1 1 1v15h-8v-5h-4v5H2M9 4v6h2V8h2v2h2V4h-2v2h-2V4H9M4 20h4v-3H4v3m0-5h4v-3H4v3m12 5h4v-3h-4v3m0-5h4v-3h-4v3m-6 0h4v-3h-4v3Z"/>'
        },
        "hospital-marker": {
            body: '<path fill="currentColor" d="M12 2c3.86 0 7 3.13 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7M9 6v6h2v-2h2v2h2V6h-2v2h-2V6H9Z"/>'
        },
        "hot-tub": {
            body: '<path fill="currentColor" d="M7 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4.15 8H22v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8h3v-.75C5 10 6 9 7.25 9h.03c.34 0 .67.09.96.23c.26.12.5.27.69.5l1.4 1.55c.23.26.51.5.82.72M7 20v-6H5v6h2m4 0v-6H9v6h2m4 0v-6h-2v6h2m4 0v-6h-2v6h2m-.35-14.14c1.03 1 1.51 2.35 1.3 3.71l-.06.43H18l.09-.59c.15-.79-.09-1.58-.67-2.2l-.07-.06c-1.03-1.01-1.5-2.36-1.3-3.72l.06-.43H18l-.09.59c-.15.79.09 1.58.67 2.2l.07.07m-4 0c1.03 1 1.51 2.35 1.3 3.71l-.06.43H14l.09-.59c.15-.79-.09-1.58-.67-2.2l-.07-.06c-1.03-1.01-1.5-2.36-1.3-3.72l.06-.43H14l-.09.59c-.15.79.09 1.58.67 2.2l.07.07Z"/>'
        },
        "hours-24": {
            body: '<path fill="currentColor" d="M13 2.05v2.02c3.95.49 7 3.85 7 7.93c0 3.21-1.92 6-4.72 7.28L13 17v5h5l-1.22-1.22C19.91 19.07 22 15.76 22 12c0-5.18-3.95-9.45-9-9.95M11 2c-1.95.2-3.8.96-5.32 2.21L7.1 5.63A8.195 8.195 0 0 1 11 4V2M4.2 5.68C2.96 7.2 2.2 9.05 2 11h2c.19-1.42.75-2.77 1.63-3.9L4.2 5.68M6 8v2h3v1H8c-1.1 0-2 .9-2 2v3h5v-2H8v-1h1c1.11 0 2-.89 2-2v-1a2 2 0 0 0-2-2H6m6 0v5h3v3h2v-3h1v-2h-1V8h-2v3h-1V8h-2M2 13c.2 1.95.97 3.8 2.22 5.32l1.42-1.42A8.21 8.21 0 0 1 4 13H2m5.11 5.37l-1.43 1.42A10.04 10.04 0 0 0 11 22v-2a8.063 8.063 0 0 1-3.89-1.63Z"/>'
        },
        houzz: {
            body: '<path d="M14 20.95h6V10.78L8 7.34V3.05H4v17.9h6v-5.64h4v5.64z" fill="currentColor"/>',
            hidden: true
        },
        "houzz-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m8.5 15.71H18v-7.62L9 8.5V5.29H6v13.42h4.5V14.5h3v4.21z" fill="currentColor"/>',
            hidden: true
        },
        hubspot: {
            body: '<path fill="currentColor" d="M17.1 8.6V6.2c.6-.3 1.1-.9 1.1-1.6v-.1c0-1-.8-1.8-1.8-1.8h-.1c-1 0-1.8.8-1.8 1.8v.1c0 .7.4 1.3 1.1 1.6v2.4c-.9.1-1.8.5-2.5 1.1L6.5 4.6c.3-1.1-.4-2.3-1.5-2.5c-1.1-.2-2.2.3-2.5 1.4c-.3 1.1.4 2.3 1.5 2.6c.5.1 1.1.1 1.6-.2l6.4 5c-1.2 1.8-1.2 4.1.1 5.9l-2 2c-.2 0-.3-.1-.5-.1c-.9 0-1.7.8-1.7 1.7c0 .9.8 1.6 1.7 1.6c.9 0 1.7-.8 1.7-1.7c0-.2 0-.3-.1-.5l1.9-1.9c2.3 1.7 5.6 1.3 7.3-1c1.7-2.3 1.3-5.6-1-7.3c-.6-.5-1.4-.9-2.3-1m-.8 7.8c-1.5 0-2.7-1.2-2.7-2.7c0-1.5 1.2-2.7 2.7-2.7c1.5 0 2.7 1.2 2.7 2.7c0 1.5-1.2 2.7-2.7 2.7"/>'
        },
        hulu: {
            body: '<path fill="currentColor" d="M19.5 12.8V22h-4.8v-8.1c0-.7-.6-1.3-1.3-1.3h-2.9c-.7 0-1.3.6-1.3 1.3V22H4.5V2h4.8v6.4c.3-.1.6-.2.9-.2H15c2.5 0 4.5 2.1 4.5 4.6Z"/>'
        },
        human: {
            body: '<path fill="currentColor" d="M21 9h-6v13h-2v-6h-2v6H9V9H3V7h18m-9-5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2Z"/>'
        },
        "human-baby-changing-table": {
            body: '<path fill="currentColor" d="M6.5 6.08c-.78.04-1.5.54-1.78 1.32L3 12.13V22h4v-9.16l1.42-3.9L10.7 10H14V8h-2.85L7.29 6.2a2.17 2.17 0 0 0-.79-.12M9 17h12v2H9m1-15.5a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2m11 11a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5M9 11v2h2v1c0 1.11.89 2 2 2h2c1.11 0 2-.89 2-2v-3h-2v2h-2v-1a1 1 0 0 0-1-1Z"/>'
        },
        "human-cane": {
            body: '<path fill="currentColor" d="M18 12.24V22h-.94v-9.76c0-.15-.06-.24-.13-.35a.416.416 0 0 0-.31-.13a.46.46 0 0 0-.35.13c-.09.11-.13.21-.13.35v.92h-.91v-.66c-.7-.17-1.33-.46-1.88-.87c-.55-.41-1.01-.89-1.39-1.44l-.35 1.2c-.11.42-.11.85-.11 1.29v.65l1.85 2.61V22H11.5v-4.66L9.82 15l-.17 3.25L6.86 22l-1.48-1.13l2.39-3.23v-4.96c0-.53.05-1.05.14-1.57l.34-1.57l-1.39.78v3.31H5v-4.4l5-2.83c.29-.14.59-.22.91-.22c.32 0 .63.09.92.26c.32.18.56.44.74.79l.74 1.57c.29.58.73 1.07 1.33 1.46c.59.39 1.25.59 1.98.59c.38 0 .7.15.98.39c.28.26.4.59.4 1M12 2a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4Z"/>'
        },
        "human-capacity-decrease": {
            body: '<path fill="currentColor" d="M16 4c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m4.78 3.58C19.93 7.21 19 7 18 7c-.67 0-1.31.1-1.92.28c.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.5-1.53-1.22-1.85M6 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m1.92 1.28C7.31 7.1 6.67 7 6 7c-1 0-1.93.21-2.78.58C2.5 7.9 2 8.62 2 9.43V10h5v-.57c0-.83.34-1.6.92-2.15M10 4c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6H8v-.57c0-.81.5-1.53 1.22-1.85C10.07 7.21 11 7 12 7c1 0 1.93.21 2.78.58C15.5 7.9 16 8.62 16 9.43V10m-1 6c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6h-8v-.57c0-.81.5-1.53 1.22-1.85C15.07 19.21 16 19 17 19c1 0 1.93.21 2.78.58c.72.32 1.22 1.04 1.22 1.85V22M5 16c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6H3v-.57c0-.81.5-1.53 1.22-1.85C5.07 19.21 6 19 7 19c1 0 1.93.21 2.78.58c.72.32 1.22 1.04 1.22 1.85V22m1.75-9v-2h-1.5v2H9l3 3l3-3h-2.25Z"/>'
        },
        "human-capacity-increase": {
            body: '<path fill="currentColor" d="M16 4c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m4.78 3.58C19.93 7.21 19 7 18 7c-.67 0-1.31.1-1.92.28c.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.5-1.53-1.22-1.85M6 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m1.92 1.28C7.31 7.1 6.67 7 6 7c-1 0-1.93.21-2.78.58C2.5 7.9 2 8.62 2 9.43V10h5v-.57c0-.83.34-1.6.92-2.15M10 4c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6H8v-.57c0-.81.5-1.53 1.22-1.85C10.07 7.21 11 7 12 7c1 0 1.93.21 2.78.58C15.5 7.9 16 8.62 16 9.43M15 16c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6h-8v-.57c0-.81.5-1.53 1.22-1.85C15.07 19.21 16 19 17 19c1 0 1.93.21 2.78.58c.72.32 1.22 1.04 1.22 1.85M5 16c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m6 6H3v-.57c0-.81.5-1.53 1.22-1.85C5.07 19.21 6 19 7 19c1 0 1.93.21 2.78.58c.72.32 1.22 1.04 1.22 1.85M12.75 14v2h-1.5v-2H9l3-3l3 3Z"/>'
        },
        "human-child": {
            body: '<path fill="currentColor" d="M12 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m-1 20H8v-6H6V9h12v7h-2v6h-3v-4h-2v4Z"/>'
        },
        "human-dolly": {
            body: '<path fill="currentColor" d="M16.78 21.84a1.998 1.998 0 1 1-1.56-3.68a1.998 1.998 0 1 1 1.56 3.68M7.62 6c1.11 0 2-.89 2-2a2 2 0 0 0-2-2c-1.12 0-2 .9-2 2c0 1.11.88 2 2 2m14.43 10.34L18.2 18c.22.22.42.5.56.82c.14.33.2.68.24 1l3.83-1.64l-.78-1.84M10.16 8.78l.74 1.81c-.24-.09-.46-.21-.64-.33c-.6-.39-1.04-.88-1.33-1.46l-.74-1.57c-.19-.35-.42-.61-.74-.79c-.29-.17-.6-.26-.92-.26c-.32 0-.62.08-.91.22c-1.4 1.1-1.75 3.14-1.75 3.14l-.34 1.57c-.09.52-.14 1.04-.14 1.57v4.96L1 20.87L2.5 22l2.77-3.75l.17-3.25l1.68 2.34V22h1.85v-6.06l-1.85-2.61v-.65c0-.44 0-.87.11-1.29l.35-1.2c.38.55.84 1.03 1.39 1.44c.45.34 1.71.94 2.9 1.23L14 17.8c.22-.22.5-.42.83-.56c.32-.14.67-.2.99-.24L12 8l-1.84.78m5.2 3.34l1.96 4.6l5.63-2.41L21 9.72"/>'
        },
        "human-edit": {
            body: '<path fill="currentColor" d="m19.07 14.88l2.05 2.05L15.06 23H13v-2.06l6.07-6.06m1.97-1.75c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17M21 9h-6v7l-2 2v-2h-2v6H9V9H3V7h18v2m-9-7c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "human-female": {
            body: '<path fill="currentColor" d="M12 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-1.5 20v-6h-3l2.59-7.59C10.34 7.59 11.1 7 12 7c.9 0 1.66.59 1.91 1.41L16.5 16h-3v6h-3Z"/>'
        },
        "human-female-boy": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 22v-6H3l2.6-7.6c.3-.8 1-1.4 1.9-1.4c.9 0 1.7.6 1.9 1.4L12 16H9v6H6m8.5-10a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-1 3h6v4H18v3h-3v-3h-1.5v-4Z"/>'
        },
        "human-female-dance": {
            body: '<path fill="currentColor" d="M17 17h-2v6h-2v-6h-2.12l-1.54 1.93l2.37 2.36l-1.42 1.42l-2.36-2.37c-.35-.34-.55-.81-.58-1.3c-.03-.49.12-.98.43-1.36l.54-.68H7l2-4v-3c-.62.47-1.12 1.07-1.47 1.76c-.35.7-.53 1.46-.53 2.24H5a7.001 7.001 0 0 1 7-7c1.33 0 2.6-.53 3.54-1.46C16.47 4.6 17 3.33 17 2h2c0 1.32-.38 2.62-1.09 3.73A6.982 6.982 0 0 1 15 8.31V13l2 4M14 4c0 .4-.12.78-.34 1.11c-.22.33-.53.59-.89.74a2.004 2.004 0 0 1-2.18-.44c-.28-.28-.47-.63-.55-1.02c-.08-.39-.04-.79.11-1.15c.15-.37.41-.68.74-.9c.33-.22.71-.34 1.11-.34c.53 0 1.04.21 1.41.59c.38.37.59.88.59 1.41Z"/>'
        },
        "human-female-female": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 22v-6H3l2.6-7.6c.3-.8 1-1.4 1.9-1.4c.9 0 1.7.6 1.9 1.4L12 16l2.6-7.6c.3-.8 1-1.4 1.9-1.4c.9 0 1.7.6 1.9 1.4L21 16h-3v6h-3v-6H9v6H6M16.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "human-female-girl": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 22v-6H3l2.6-7.6c.3-.8 1-1.4 1.9-1.4c.9 0 1.7.6 1.9 1.4L12 16H9v6H6m8.5-10a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m.5 3h3l1.5 4H18v3h-3v-3h-1.5l1.5-4Z"/>'
        },
        "human-greeting": {
            body: '<path fill="currentColor" d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m3.9 6.1c-.4-.4-1.1-1.1-2.4-1.1H11C8.2 7 6 4.8 6 2H4c0 3.2 2.1 5.8 5 6.7V22h2v-6h2v6h2V10.1l4 3.9l1.4-1.4l-4.5-4.5Z"/>'
        },
        "human-greeting-proximity": {
            body: '<path fill="currentColor" d="M11 14H9a9 9 0 0 1 9-9v2c-3.87 0-7 3.13-7 7m7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3M7 4c0-1.11-.89-2-2-2s-2 .89-2 2s.89 2 2 2s2-.89 2-2m4.45.5h-2A2.982 2.982 0 0 1 6.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.982 4.982 0 0 0 3.45-4.24M19 17c1.11 0 2-.89 2-2s-.89-2-2-2s-2 .89-2 2s.89 2 2 2m1.5 1h-3c-1.5 0-2.71-1.08-2.95-2.5h-2c.2 2 1.59 3.65 3.45 4.24V22h6v-2.5c0-.83-.67-1.5-1.5-1.5Z"/>'
        },
        "human-greeting-variant": {
            body: '<path fill="currentColor" d="M1.5 4v1.5c0 4.15 2.21 7.78 5.5 9.8V20h15v-2c0-2.66-5.33-4-8-4h-.25C9 14 5 10 5 5.5V4m9 0a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "human-handsdown": {
            body: '<path fill="currentColor" d="M12 1a2 2 0 0 0-2 2c0 1.11.89 2 2 2c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m-2 5c-.27 0-.5.11-.69.28H9.3L4 11.59L5.42 13L9 9.41V22h2v-7h2v7h2V9.41L18.58 13L20 11.59l-5.3-5.31c-.2-.17-.43-.28-.7-.28"/>'
        },
        "human-handsup": {
            body: '<path fill="currentColor" d="M5 1c0 2.7 1.56 5.16 4 6.32V22h2v-7h2v7h2V7.31C17.44 6.16 19 3.7 19 1h-2a5 5 0 0 1-5 5a5 5 0 0 1-5-5m5 0c-1.11 0-2 .89-2 2c0 1.11.89 2 2 2c1.11 0 2-.89 2-2c0-1.11-.89-2-2-2Z"/>'
        },
        "human-male": {
            body: '<path fill="currentColor" d="M12 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-1.5 5h3a2 2 0 0 1 2 2v5.5H14V22h-4v-7.5H8.5V9a2 2 0 0 1 2-2Z"/>'
        },
        "human-male-board": {
            body: '<path fill="currentColor" d="M20 17a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9.46c.35.61.54 1.3.54 2h10v11h-9v2m4-10v2H9v13H7v-6H5v6H3v-8H1.5V9a2 2 0 0 1 2-2H15M8 4a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2Z"/>'
        },
        "human-male-board-poll": {
            body: '<path fill="currentColor" d="M20 17c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H9.5c.3.6.5 1.3.5 2h10v11h-9v2m4-10v2H9v13H7v-6H5v6H3v-8H1.5V9c0-1.1.9-2 2-2H15M8 4c0 1.1-.9 2-2 2s-2-.9-2-2s.9-2 2-2s2 .9 2 2m9 2h2v8h-2V6m-3 4h2v4h-2v-4m-3 0h2v4h-2v-4Z"/>'
        },
        "human-male-boy": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 7h3a2 2 0 0 1 2 2v5.5H9.5V22h-4v-7.5H4V9a2 2 0 0 1 2-2m8.5 5a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-1 3h6v4H18v3h-3v-3h-1.5v-4Z"/>'
        },
        "human-male-child": {
            body: '<path fill="currentColor" d="M7 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2M5 7c-1.11 0-2 .89-2 2v6h2v7h5V11.6l2.53 4.4h2.44L16 14.66V22h4v-5h1v-3c0-1.11-.89-2-2-2h-2.5c-.6 0-1.13.26-1.5.68c-.33.42-.68.88-1 1.32h-.31L10 7.66C9.84 7.38 9.22 7 8.5 7H5m13 1c-.83 0-1.5.67-1.5 1.5S17.17 11 18 11s1.5-.67 1.5-1.5S18.83 8 18 8Z"/>'
        },
        "human-male-female": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 7h3a2 2 0 0 1 2 2v5.5H9.5V22h-4v-7.5H4V9a2 2 0 0 1 2-2m10.5-5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M15 22v-6h-3l2.59-7.59C14.84 7.59 15.6 7 16.5 7c.9 0 1.66.59 1.91 1.41L21 16h-3v6h-3Z"/>'
        },
        "human-male-female-child": {
            body: '<path fill="currentColor" d="M16 4c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m4 18v-6h2.5L20 8.4c-.3-.8-1-1.4-1.9-1.4H18c-.9 0-1.6.6-1.9 1.4l-.9 2.6c1.1.6 1.8 1.7 1.8 3.1v8h3m-7.5-10.6c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5S11 9.2 11 10s.7 1.5 1.5 1.5M5.5 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m2 16v-7H9V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6h1.5v7h4m6.5 0v-4h1v-4c0-.8-.7-1.5-1.5-1.5h-2c-.8 0-1.5.7-1.5 1.5v4h1v4h3Z"/>'
        },
        "human-male-girl": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 7h3a2 2 0 0 1 2 2v5.5H9.5V22h-4v-7.5H4V9a2 2 0 0 1 2-2m8.5 5a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m.5 3h3l1.5 4H18v3h-3v-3h-1.5l1.5-4Z"/>'
        },
        "human-male-height": {
            body: '<path fill="currentColor" d="M7 2c1.78 0 2.67 2.16 1.42 3.42C7.16 6.67 5 5.78 5 4a2 2 0 0 1 2-2M5.5 7h3a2 2 0 0 1 2 2v5.5H9V22H5v-7.5H3.5V9a2 2 0 0 1 2-2M21 8h-6v2h6m0 1h-3v2h3m0-11h-6v2h6m0 1h-3v2h3m0 7h-6v2h6m0 4h-6v2h6m0-5h-3v2h3"/>'
        },
        "human-male-height-variant": {
            body: '<path fill="currentColor" d="M7 2c1.78 0 2.67 2.16 1.42 3.42C7.16 6.67 5 5.78 5 4a2 2 0 0 1 2-2M5.5 7h3a2 2 0 0 1 2 2v5.5H9V22H5v-7.5H3.5V9a2 2 0 0 1 2-2M19 8h2l-3-4l-3 4h2v8h-2l3 4l3-4h-2m3-14h-8v2h8m0 16h-8v2h8"/>'
        },
        "human-male-male": {
            body: '<path fill="currentColor" d="M7.5 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 7h3a2 2 0 0 1 2 2v5.5H9.5V22h-4v-7.5H4V9a2 2 0 0 1 2-2m10.5-5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M15 7h3a2 2 0 0 1 2 2v5.5h-1.5V22h-4v-7.5H13V9a2 2 0 0 1 2-2Z"/>'
        },
        "human-non-binary": {
            body: '<path fill="currentColor" d="M12 2a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m1.91 6.41A1.992 1.992 0 0 0 12 7h-1.5c-1.1 0-2 .9-2 2v5.5H10V22h3.5v-6h3l-2.59-7.59Z"/>'
        },
        "human-pregnant": {
            body: '<path fill="currentColor" d="M9 4c0-1.11.89-2 2-2c1.11 0 2 .89 2 2c0 1.11-.89 2-2 2c-1.11 0-2-.89-2-2m7 9c0-1.34-.83-2.5-2-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3v7h2v5h3v-5h3v-4Z"/>'
        },
        "human-queue": {
            body: '<path fill="currentColor" d="M5 6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2m7-2a2 2 0 1 0 2 2c0-1.11-.89-2-2-2m7-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2M3.5 11c-.83 0-1.5.67-1.5 1.5V17h1v5h4v-5h1v-4.5c0-.83-.67-1.5-1.5-1.5h-3m7-2C9.67 9 9 9.67 9 10.5V15h1v5h4v-5h1v-4.5c0-.83-.67-1.5-1.5-1.5h-3m7-2c-.83 0-1.5.67-1.5 1.5V13h1v5h4v-5h1V8.5c0-.83-.67-1.5-1.5-1.5h-3Z"/>'
        },
        "human-scooter": {
            body: '<path fill="currentColor" d="M16.5 2.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5M20 18a2 2 0 0 1 2 2c0 1.11-.89 2-2 2c-.74 0-1.39-.4-1.73-1H8.73A2 2 0 1 1 7 18c.74 0 1.39.4 1.73 1H13v-5.5l-3.27-2.27L6.77 14c-.41.37-1.04.34-1.42-.06l-3.07-3.29c-.37-.41-.35-1.04.05-1.42c.41-.37 1.04-.35 1.41.05l2.39 2.56l7.13-6.64l.04-.02a1 1 0 0 1 1.41.12L16.97 8H20c.55 0 1 .45 1 1s-.45 1-1 1h-3.5c-.35 0-.65-.18-.83-.44l-1.5-1.79l-2.53 2.36l2.93 2.05c.26.18.43.48.43.82v6h.61c.43-1.87 2.02-3.3 3.97-3.5l-.77-4.5h1.5l1.08 6.34A3.004 3.004 0 0 0 17.17 19h1.1c.34-.6.99-1 1.73-1Z"/>'
        },
        "human-walker": {
            body: '<path fill="currentColor" d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m7.8 15.7l-.6-6.4c-.1-.8-.7-1.3-1.5-1.3H16c-1.5 0-2.9-.5-3.8-1.4l-2-2c-.1-.2-.6-.6-1.4-.6c-.5 0-1 .2-1.4.6L4.1 9.9c-.5.7-.5 1.6-.2 2.1l1.4 2.8l-3.1 4L3.8 20l3.7-4.7l-.3-1.3l.8.8V20h2v-6.1l-2.1-2.1l2.4-2.4c.9.9 1.7 1.8 3.6 2.3L13 20h1.5l.4-3.5h3.2l.1 1.2c-.4.3-.7.7-.7 1.3c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-.5-.3-1-.7-1.3M15.1 15l.4-3.5h2l.4 3.5h-2.8Z"/>'
        },
        "human-wheelchair": {
            body: '<path fill="currentColor" d="M8.5 4a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2M5 7c-1.11 0-2 .89-2 2v6h2v7h3.61a7 7 0 0 1-2.11-5a7 7 0 0 1 3.5-6.05V9c0-1.11-.89-2-2-2m5 1v8h5.5l2.7 3.6l1.6-1.2l-3.3-4.4H15V8m-3 4.23A5 5 0 0 0 8.5 17a5 5 0 0 0 5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 1.5-2.59Z"/>'
        },
        "human-white-cane": {
            body: '<path fill="currentColor" d="M8 4a2 2 0 1 1 4 0c0 1.11-.89 2-2 2a2 2 0 0 1-2-2m12.65 17.5L14.5 10.85c-.73 0-1.27-.2-1.86-.59c-.6-.39-1.04-.88-1.33-1.46l-.74-1.57c-.18-.35-.42-.61-.74-.79c-.29-.17-.6-.26-.92-.26c-.32 0-.62.08-.91.22L3 9.23v4.4h1.86v-3.31l1.39-.78l-.34 1.57c-.09.52-.14 1.04-.14 1.57v4.96l-2.39 3.23L4.86 22l2.79-3.75l.17-3.25l1.68 2.34V22h1.85v-6.06L9.5 13.33v-.65c0-.44 0-.87.11-1.29l.35-1.2c.38.55.85 1.01 1.39 1.44c.85.68 1.65.96 3 .95L19.78 22l.87-.5Z"/>'
        },
        "humble-bundle": {
            body: '<path fill="currentColor" d="M16.91 18.12c-2.82 0 1.52-15.99 1.52-15.99h-2.9s-1.19 3.76-1.98 7.94h-2.5c.06-.86.1-1.73.08-2.57C11 .59 7 1.87 5.18 3.45C3.47 4.95 2.03 7.8 2 10h1.35s.9-4.12 3.72-4.12c2.82 0-1.53 15.99-1.53 15.99h2.91s1.5-4.28 2.25-9.06l2.39-.01c-.14 1.24-.18 2.6-.16 3.87c.11 6.89 4.13 5.41 5.93 3.83C20.67 18.92 22 15.58 22 14h-1.39c.01.12-.88 4.12-3.7 4.12Z"/>'
        },
        hurricane: {
            body: '<path d="M15 6.79A6 6 0 0 1 18 12C18 22 6 22 6 22a17.7 17.7 0 0 0 3.34-3.29a1 1 0 0 0-.34-1.5A6 6 0 0 1 6 12C6 2 18 2 18 2a17.699 17.699 0 0 0-3.34 3.29a1.002 1.002 0 0 0 .34 1.5zM12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4z" fill="currentColor"/>',
            hidden: true
        },
        hvac: {
            body: '<path fill="currentColor" d="M8.58 14c-.28-.45-.47-.97-.52-1.5h7.88c-.05.53-.24 1.05-.47 1.5H8.58M12 16c-1.03 0-1.92-.39-2.62-1h5.25c-.71.61-1.6 1-2.63 1m0-8c1.03 0 1.92.39 2.63 1H9.38c.7-.61 1.59-1 2.62-1m-3.42 2h6.84c.28.45.47.97.52 1.5H8.06c.05-.53.24-1.05.52-1.5M3 3v18h18V3H3m9 15c-3.33 0-6-2.67-6-6s2.67-6 6-6s6 2.67 6 6s-2.67 6-6 6Z"/>'
        },
        "hvac-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L3 4.89V21h16.11l1.73 1.73l1.27-1.27M12 18c-3.33 0-6-2.67-6-6c0-1.18.34-2.27.92-3.19l1.51 1.51c-.19.37-.33.77-.37 1.18h1.55l1 1H8.06c.05.53.24 1.05.52 1.5h3.53l1 1H9.38c.7.61 1.59 1 2.62 1c.63 0 1.19-.16 1.7-.41l1.49 1.49c-.92.58-2.01.92-3.19.92m0-10c1.03 0 1.92.39 2.63 1H12.2l-.93-.93c.23-.04.48-.07.73-.07M9.67 6.47L6.2 3H21v14.8l-3.47-3.47c.3-.71.47-1.5.47-2.33c0-3.33-2.67-6-6-6c-.83 0-1.62.17-2.33.47m6.27 5.03H14.7L13.2 10h2.22c.28.45.47.97.52 1.5Z"/>'
        },
        "hydraulic-oil-level": {
            body: '<path fill="currentColor" d="M15 18c-1.66 0-3-1.34-3-3c0-2 3-5.37 3-5.37S18 13 18 15c0 1.66-1.34 3-3 3m5-14v16H10V4H8v16c0 1.11.89 2 2 2h10c1.11 0 2-.89 2-2V4h-2M2 19l5-5l-5-5v10M16 6V2h-2v4h-3v2h8V6h-3Z"/>'
        },
        "hydraulic-oil-temperature": {
            body: '<path fill="currentColor" d="M9 18c-1.66 0-3-1.34-3-3c0-2 3-5.37 3-5.37S12 13 12 15c0 1.66-1.34 3-3 3m5-14v16H4V4H2v16c0 1.11.89 2 2 2h10c1.11 0 2-.89 2-2V4h-2m-4 2V2H8v4H5v2h8V6h-3m11 11.5v-12c0-.83-.67-1.5-1.5-1.5S18 4.67 18 5.5v12a2.5 2.5 0 1 0 4 2c0-.79-.37-1.5-1-2M20 13h-1V6h1v7Z"/>'
        },
        "hydro-power": {
            body: '<path fill="currentColor" d="M17.12 3.55a2 2 0 0 0-1.92 1.4l-.8 2.55a3 3 0 0 0-1.07.24L11.5 5.77l-1.33-1.48a2 2 0 0 0-.12 2.83l1.81 1.97a3 3 0 0 0-.22.51a3 3 0 0 0-.11.53l-2.61.58l-1.96.44a2 2 0 0 0 2.39 1.52l2.61-.59a3 3 0 0 0 .74.81l-.8 2.55l-.6 1.91a2 2 0 0 0 2.5-1.31l.81-2.54a3 3 0 0 0 1.07-.24l1.82 1.97l1.33 1.47a2 2 0 0 0 .13-2.82l-1.81-1.97a3 3 0 0 0 .21-.51a3 3 0 0 0 .14-.54l2.59-.58l1.95-.43a2 2 0 0 0-2.38-1.52l-2.61.58a3 3 0 0 0-.74-.8l.8-2.56l.6-1.9a2 2 0 0 0-.59-.1M14.56 9a1.5 1.5 0 0 1 .39.07a1.5 1.5 0 0 1 .98 1.88a1.5 1.5 0 0 1-1.88.98a1.5 1.5 0 0 1-.98-1.88A1.5 1.5 0 0 1 14.55 9M8 13.67C6.78 14.53 5.39 15 4 15H2v2h2c1.37 0 2.74-.35 4-1c.77.4 1.58.66 2.41.81l.53-1.67l.09-.26c-1.06-.15-2.1-.56-3.03-1.21M20.45 15c.05.7-.12 1.41-.54 2H22v-2h-1.55M8 17.67C6.78 18.53 5.39 19 4 19H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2h-2c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0Z"/>'
        },
        "hydrogen-station": {
            body: '<path fill="currentColor" d="M6 3a2 2 0 0 0-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77l.01-.01l-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14a2 2 0 0 0-2-2h-1V5a2 2 0 0 0-2-2H6m0 4h2v4h2V7h2v10h-2v-4H8v4H6V7m12 1c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "ice-cream": {
            body: '<path fill="currentColor" d="M17.5 6.05C17.25 3.22 14.89 1 12 1S6.75 3.22 6.5 6.05C5.09 6.28 4 7.5 4 9c0 1.66 1.34 3 3 3l5 10l5-10c1.66 0 3-1.34 3-3c0-1.5-1.09-2.72-2.5-2.95M12 17.53l-3.11-6.22c.06-.05.11-.1.19-.15a5.503 5.503 0 0 0 5.84 0c.08.05.13.1.19.15L12 17.53Z"/>'
        },
        "ice-cream-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l3.84 3.84C4.37 7.38 4 8.14 4 9c0 1.66 1.34 3 3 3l5 10l2.7-5.41l6.14 6.14l1.27-1.27M12 17.53l-3.11-6.22c.06-.05.11-.1.19-.15c.13.08.27.14.42.21l3.71 3.73L12 17.53M7.15 3.95C8.07 2.2 9.89 1 12 1c2.89 0 5.25 2.22 5.5 5.05C18.91 6.28 20 7.5 20 9c0 1.66-1.34 3-3 3l-.6 1.2l-9.25-9.25Z"/>'
        },
        "ice-pop": {
            body: '<path fill="currentColor" d="m18.15 14.96l-8.2 3.69l-4.1-9a3.603 3.603 0 0 0 2.3-3.29c-.01-1.36-.79-2.6-2-3.21c.39-.35.85-.65 1.3-.9c2.26-1 4.92-.02 6 2.21m-.3 13.9l1.6 3.5l2.7-1.21l-1.6-3.5"/>'
        },
        "id-card": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2H4m0 2h16v4H4V6m0 6h4v2H4v-2m6 0h10v2H10v-2m-6 4h10v2H4v-2m12 0h4v2h-4v-2Z"/>'
        },
        identifier: {
            body: '<path fill="currentColor" d="M10 7v2H9v6h1v2H6v-2h1V9H6V7h4m6 0a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2h-4V7m4 2h-2v6h2V9Z"/>'
        },
        "ideogram-cjk": {
            body: '<path fill="currentColor" d="M11 4v2H4v4h2V8h12v2h2V6h-7V4m-5 6v2h5.59l-2 2H4v2h7v2h-1v2h3v-4h7v-2h-5.79L16 12.21V10Z"/>'
        },
        "ideogram-cjk-variant": {
            body: '<path fill="currentColor" d="M11 4v2H4v2h11.36c-.23.87-.73 1.77-1.48 2.69c-.53.66-1.17 1.31-1.88 1.98c-.71-.67-1.35-1.32-1.88-1.98c-.47-.57-.82-1.14-1.09-1.69H6.85c.36 1.05.97 2.03 1.71 2.95c.57.71 1.23 1.39 1.94 2.05l-5.14 4.23l1.28 1.54L12 15.34l5.36 4.43l1.28-1.54L13.5 14c.71-.66 1.37-1.34 1.94-2.05c.97-1.21 1.72-2.52 1.96-3.95H20V6h-7V4Z"/>'
        },
        image: {
            body: '<path fill="currentColor" d="m8.5 13.5l2.5 3l3.5-4.5l4.5 6H5m16 1V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2Z"/>'
        },
        "image-album": {
            body: '<path fill="currentColor" d="m6 19l3-3.86l2.14 2.58l3-3.86L18 19H6M6 4h5v8l-2.5-1.5L6 12M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "image-area": {
            body: '<path fill="currentColor" d="M20 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.11.89-2 2-2h16M5 16h14l-4.5-6l-3.5 4.5l-2.5-3L5 16Z"/>'
        },
        "image-area-close": {
            body: '<path fill="currentColor" d="m12 23l-4-4h8l-4 4m8-20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16M5 14h14l-4.5-6l-3.5 4.5l-2.5-3L5 14Z"/>'
        },
        "image-auto-adjust": {
            body: '<path fill="currentColor" d="M19 10v9H5V5h9V3H5c-1.08 0-2 .9-2 2v14c0 1.1.92 2 2 2h14c1.12 0 2-.9 2-2v-9h-2m-2 0l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94L17 10m-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25Z"/>'
        },
        "image-broken": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v6h-2v2h-2v2h-2v2h-2v2h-2v2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m2 12v4a2 2 0 0 1-2 2h-4v-2h2v-2h2v-2h2m-2-6.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H11v-1h2v-2h2v-2h2V9h2v-.5Z"/>'
        },
        "image-broken-variant": {
            body: '<path fill="currentColor" d="M21 5v6.59l-3-3.01l-4 4.01l-4-4l-4 4l-3-3.01V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-3 6.42l3 3.01V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6.58l3 2.99l4-4l4 4"/>'
        },
        "image-check": {
            body: '<path fill="currentColor" d="M12.5 21c-.32-.77-.5-1.61-.5-2.5c0-.17 0-.33.03-.5H5l3.5-4.5l2.5 3l3.5-4.5l.69.92c.97-.58 2.1-.92 3.31-.92c.89 0 1.73.18 2.5.5V5c0-.53-.21-1.04-.59-1.41C20.04 3.21 19.53 3 19 3H5c-1.1 0-2 .9-2 2v14c0 .53.21 1.04.59 1.41c.37.38.88.59 1.41.59h7.5m5.25 1L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 22Z"/>'
        },
        "image-check-outline": {
            body: '<path fill="currentColor" d="M12.18 17c.36-1.5 1.25-2.84 2.5-3.75l-.72-.96l-2.75 3.54l-1.96-2.36L6.5 17h5.68M5 5v14h7.03c.06.7.21 1.38.47 2H5c-.53 0-1.04-.21-1.41-.59C3.21 20.04 3 19.53 3 19V5c0-1.1.9-2 2-2h14c.53 0 1.04.21 1.41.59c.38.37.59.88.59 1.41v7.5c-.62-.26-1.3-.41-2-.47V5H5m12.75 17L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 22Z"/>'
        },
        "image-edit": {
            body: '<path fill="currentColor" d="m22.7 14.3l-1 1l-2-2l1-1c.1-.1.2-.2.4-.2c.1 0 .3.1.4.2l1.3 1.3c.1.2.1.5-.1.7M13 19.9V22h2.1l6.1-6.1l-2-2l-6.2 6M21 5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-1.9l1.1-1.1H5l3.5-4.5l2.5 3l3.5-4.5l1.6 2.1l4.9-5V5Z"/>'
        },
        "image-edit-outline": {
            body: '<path fill="currentColor" d="m22.7 14.3l-1 1l-2-2l1-1c.1-.1.2-.2.4-.2c.1 0 .3.1.4.2l1.3 1.3c.1.2.1.5-.1.7M13 19.9V22h2.1l6.1-6.1l-2-2l-6.2 6m-1.79-4.07l-1.96-2.36L6.5 17h6.62l2.54-2.45l-1.7-2.26l-2.75 3.54M11 19.9v-.85l.05-.05H5V5h14v6.31l2-1.93V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6v-1.1Z"/>'
        },
        "image-filter-black-white": {
            body: '<path fill="currentColor" d="m19 19l-7-8v8H5l7-8V5h7m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "image-filter-center-focus": {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m7 10h-4v2h4a2 2 0 0 0 2-2v-4h-2m0-12h-4v2h4v4h2V5a2 2 0 0 0-2-2M5 5h4V3H5a2 2 0 0 0-2 2v4h2m0 6H3v4a2 2 0 0 0 2 2h4v-2H5v-4Z"/>'
        },
        "image-filter-center-focus-strong": {
            body: '<path fill="currentColor" d="M12 8c-3.56 0-5.35 4.31-2.83 6.83C11.69 17.35 16 15.56 16 12c0-2.21-1.79-4-4-4m-7 7H3v4c0 1.1.9 2 2 2h4v-2H5M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m14-6h-4v2h4v4h2V5c0-1.1-.9-2-2-2m0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2"/>'
        },
        "image-filter-center-focus-strong-outline": {
            body: '<path fill="currentColor" d="M17 12c0-4.45-5.38-6.69-8.54-3.54C5.31 11.61 7.55 17 12 17c2.76 0 5-2.24 5-5m-5 3c-2.67 0-4-3.23-2.12-5.12C11.77 8 15 9.33 15 12c0 1.66-1.34 3-3 3m-7 0H3v4c0 1.1.9 2 2 2h4v-2H5M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2m14-6h-4v2h4v4h2V5c0-1.1-.9-2-2-2m0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2"/>'
        },
        "image-filter-center-focus-weak": {
            body: '<path fill="currentColor" d="M5 15H3v4a2 2 0 0 0 2 2h4v-2H5M5 5h4V3H5a2 2 0 0 0-2 2v4h2m14-6h-4v2h4v4h2V5a2 2 0 0 0-2-2m0 16h-4v2h4a2 2 0 0 0 2-2v-4h-2m-7-7a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 6a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2Z"/>'
        },
        "image-filter-drama": {
            body: '<path fill="currentColor" d="M19 18H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19a3 3 0 0 1 3 3a3 3 0 0 1-3 3m.35-7.96A7.49 7.49 0 0 0 12 4a7.48 7.48 0 0 0-6.64 4.04A5.996 5.996 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.96Z"/>'
        },
        "image-filter-frames": {
            body: '<path fill="currentColor" d="M18 8H6v10h12m2 2H4V6h4.5l3.54-3.5L15.5 6H20m0-2h-4l-4-4l-4 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "image-filter-hdr": {
            body: '<path fill="currentColor" d="m14 6l-3.75 5l2.85 3.8l-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6Z"/>'
        },
        "image-filter-none": {
            body: '<path fill="currentColor" d="M21 17H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "image-filter-tilt-shift": {
            body: '<path fill="currentColor" d="M5.68 19.74A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62m5.9 1.62v2.02c2-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62m5.31-3.03l1.43 1.43c1.21-1.48 2.01-3.33 2.21-5.33h-2.02a7.941 7.941 0 0 1-1.62 3.9M15 12a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3M4.07 13H2.05c.2 2 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13m1.62-5.9L4.26 5.68A9.981 9.981 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9M19.93 11h2.02c-.2-2-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 0 1 1.62 3.9m-1.61-6.74A9.981 9.981 0 0 0 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62M11 4.07V2.05c-2 .2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07Z"/>'
        },
        "image-filter-vintage": {
            body: '<path fill="currentColor" d="M12 16a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m6.7-3.6a6.06 6.06 0 0 0-.86-.4c.29-.11.58-.24.86-.4c1.92-1.1 2.99-3.1 3-5.19a6.007 6.007 0 0 0-6 0c-.28.16-.54.35-.78.54c.05-.31.08-.63.08-.95c0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95c-.24-.2-.5-.39-.78-.55a6.008 6.008 0 0 0-6 0c0 2.07 1.07 4.1 3 5.19c.28.16.57.29.86.41c-.29.1-.58.23-.86.39a6 6 0 0 0-3 5.19a6.007 6.007 0 0 0 6 0c.28-.16.54-.35.78-.54c-.05.32-.08.64-.08.96c0 2.22 1.21 4.15 3 5.19c1.79-1.04 3-2.97 3-5.19c0-.32-.03-.64-.08-.95c.24.2.5.38.78.54a6.008 6.008 0 0 0 6 0c-.01-2.09-1.08-4.09-3-5.19Z"/>'
        },
        "image-frame": {
            body: '<path fill="currentColor" d="M10 14.29L6.5 19h10.96l-2.71-3.54l-1.97 2.34L10 14.29M5 21V7h13.96v14H5m7-18.6l2.61 2.63H9.37L12 2.4M5 5.03c-.5 0-1 .19-1.39.58C3.2 6 3 6.46 3 7v14c0 .5.2 1 .61 1.39C4 22.8 4.5 23 5 23h13.96c.54 0 1-.2 1.41-.61c.4-.39.63-.89.63-1.39V7c0-.54-.23-1-.63-1.39c-.41-.39-.87-.58-1.41-.58H16L12 1L7.96 5.03H5Z"/>'
        },
        "image-lock": {
            body: '<path fill="currentColor" d="M21.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16M5 3c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.03c-.03-.1-.03-.2-.03-.3V18H5l3.5-4.5l2.5 3l3.5-4.5l.27.37C15.61 10.89 17.27 10 19 10c.69 0 1.37.16 2 .42V5a2 2 0 0 0-2-2H5Z"/>'
        },
        "image-lock-outline": {
            body: '<path fill="currentColor" d="M21.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16M5 3c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.03c-.03-.1-.03-.2-.03-.3V19H5V5h14v5c.69 0 1.37.16 2 .42V5a2 2 0 0 0-2-2H5m8.96 9.29l-2.75 3.54l-1.96-2.36L6.5 17H13c.08-.86.46-1.54.96-2.04c.07-.07.17-.11.24-.17v-.29c0-.55.1-1.06.27-1.53l-.51-.68Z"/>'
        },
        "image-marker": {
            body: '<path fill="currentColor" d="M13.55 18c.42 1.08 1.04 2.12 1.64 3H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v5.63c-.75-.4-1.61-.63-2.5-.63c-2.21 0-4.17 1.39-5.03 3.33L11 16.5l-2.5-3L5 18h8.55M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "image-marker-outline": {
            body: '<path fill="currentColor" d="M14 19c.36.72.78 1.4 1.19 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v5.63c-.61-.33-1.29-.54-2-.6V5H5v14h9m-.04-6.71l-2.75 3.54l-1.96-2.36L6.5 17h6.72c-.13-.5-.22-1-.22-1.5c0-1.15.38-2.24 1-3.13l-.04-.08M22 15.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "image-minus": {
            body: '<path fill="currentColor" d="M15 18v2h8v-2h-8m-1.7 3H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v8.3c-.6-.2-1.3-.3-2-.3c-1.1 0-2.2.3-3.1.9L14.5 12L11 16.5l-2.5-3L5 18h8.1c-.1.3-.1.7-.1 1c0 .7.1 1.4.3 2Z"/>'
        },
        "image-minus-outline": {
            body: '<path fill="currentColor" d="M15.4 14.21c-.93.7-1.65 1.67-2.05 2.79H6.5l2.75-3.53l1.96 2.36l2.75-3.54l1.44 1.92M5 19V5h14v8c.7 0 1.37.13 2 .35V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2H5m10-1v2h8v-2h-8Z"/>'
        },
        "image-move": {
            body: '<path fill="currentColor" d="M15 3h4V0l5 5l-5 5V7h-4V3m6 8.94V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.06c-.06.33-.06.67-.06 1a8 8 0 0 0 8 8c.33 0 .67 0 1-.06M19 18l-4.5-6l-3.5 4.5l-2.5-3L5 18h14Z"/>'
        },
        "image-multiple": {
            body: '<path fill="currentColor" d="M22 16V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-11-4l2.03 2.71L16 11l4 5H8M2 6v14a2 2 0 0 0 2 2h14v-2H4V6"/>'
        },
        "image-multiple-outline": {
            body: '<path fill="currentColor" d="M21 17H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3m12.96-10.71l-2.75 3.54l-1.96-2.36L8.5 15h11l-3.54-4.71Z"/>'
        },
        "image-off": {
            body: '<path fill="currentColor" d="M21 17.2L6.8 3H19c1.1 0 2 .9 2 2v12.2m-.3 4.8l-1-1H5c-1.1 0-2-.9-2-2V4.3l-1-1L3.3 2L22 20.7L20.7 22m-3.9-4l-3.9-3.9l-1.9 2.4l-2.5-3L5 18h11.8Z"/>'
        },
        "image-off-outline": {
            body: '<path fill="currentColor" d="M22 20.7L3.3 2L2 3.3l1 1V19c0 1.1.9 2 2 2h14.7l1 1l1.3-1.3M5 19V6.3l7.6 7.6l-1.5 1.9L9 13.1L6 17h9.7l2 2H5M8.8 5l-2-2H19c1.1 0 2 .9 2 2v12.2l-2-2V5H8.8"/>'
        },
        "image-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5.04 9.29l-2.75 3.54l-1.96-2.36L6.5 17h11l-3.54-4.71Z"/>'
        },
        "image-plus": {
            body: '<path fill="currentColor" d="M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2m-4.7 6H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v8.3c-.6-.2-1.3-.3-2-.3c-1.1 0-2.2.3-3.1.9L14.5 12L11 16.5l-2.5-3L5 18h8.1c-.1.3-.1.7-.1 1c0 .7.1 1.4.3 2Z"/>'
        },
        "image-plus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .7.13 1.37.35 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v8.35c-.63-.22-1.3-.35-2-.35V5H5v14h8m.96-6.71l-2.75 3.54l-1.96-2.36L6.5 17h6.85c.4-1.12 1.12-2.09 2.05-2.79l-1.44-1.92M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "image-refresh": {
            body: '<path fill="currentColor" d="M12 18.5c0 .89.18 1.73.5 2.5H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v7.5c-.77-.32-1.61-.5-2.5-.5c-1.21 0-2.34.34-3.31.92L14.5 12L11 16.5l-2.5-3L5 18h7.03c-.03.17-.03.33-.03.5m10 0v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "image-refresh-outline": {
            body: '<path fill="currentColor" d="M14.68 13.25a6.51 6.51 0 0 0-2.5 3.75H6.5l2.75-3.53l1.96 2.36l2.75-3.54l.72.96M5 19V5h14v7.03c.7.06 1.38.21 2 .47V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h7.5c-.26-.62-.41-1.3-.47-2H5m17-.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "image-remove": {
            body: '<path fill="currentColor" d="M5 3c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h9.09c-.06-.33-.09-.66-.09-1c0-.68.12-1.36.35-2H5l3.5-4.5l2.5 3l3.5-4.5l2.23 2.97c.97-.63 2.11-.97 3.27-.97c.34 0 .67.03 1 .09V5a2 2 0 0 0-2-2H5m11.47 14.88L18.59 20l-2.12 2.12l1.41 1.42L20 21.41l2.12 2.13l1.42-1.42L21.41 20l2.13-2.12l-1.42-1.42L20 18.59l-2.12-2.12l-1.42 1.41Z"/>'
        },
        "image-remove-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .7.13 1.37.35 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v8.35c-.63-.22-1.3-.35-2-.35V5H5v14h8m-1.79-3.17l-1.96-2.36L6.5 17h6.85c.4-1.12 1.12-2.09 2.05-2.79l-1.44-1.92l-2.75 3.54m11.33 1.05l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "image-search": {
            body: '<path fill="currentColor" d="M15.5 2C18 2 20 4 20 6.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 13.39l-3.12-3.07c-.69.43-1.51.68-2.38.68C13 11 11 9 11 6.5S13 2 15.5 2m0 2A2.5 2.5 0 0 0 13 6.5A2.5 2.5 0 0 0 15.5 9A2.5 2.5 0 0 0 18 6.5A2.5 2.5 0 0 0 15.5 4m-8 10.5L4 19h14l-4.5-6l-3.5 4.5l-2.5-3M20 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.5c-.32.77-.5 1.61-.5 2.5a6.5 6.5 0 0 0 6.5 6.5c.68 0 1.34-.11 1.96-.3L20 15.24V20Z"/>'
        },
        "image-search-outline": {
            body: '<path fill="currentColor" d="M15.5 9c.7 0 1.29-.24 1.77-.73c.49-.48.73-1.07.73-1.77c0-.67-.24-1.27-.73-1.77c-.48-.5-1.07-.73-1.77-.73c-.67 0-1.27.23-1.77.73S13 5.83 13 6.5c0 .7.23 1.29.73 1.77c.5.49 1.1.73 1.77.73m3.81-.09l3.1 3.09L21 13.41l-3.14-3.1c-.78.47-1.58.69-2.39.69c-1.25 0-2.31-.42-3.17-1.3c-.85-.87-1.3-1.93-1.3-3.2c0-1.23.45-2.3 1.33-3.17C13.2 2.45 14.27 2 15.5 2c1.27 0 2.33.45 3.2 1.33c.88.87 1.3 1.94 1.3 3.17c0 .83-.22 1.63-.69 2.41M16.5 18h-11l2.75-3.5l1.97 2.33l2.72-3.52L16.5 18m1.5-5l2 2v5c0 .55-.19 1-.59 1.4c-.41.39-.88.6-1.41.6H4c-.55 0-1-.21-1.4-.6c-.39-.4-.6-.85-.6-1.4V6c0-.53.21-1 .6-1.41C3 4.19 3.45 4 4 4h5.5c-.3.64-.47 1.31-.5 2H4v14h14v-7Z"/>'
        },
        "image-size-select-actual": {
            body: '<path fill="currentColor" d="M21 3H3C2 3 1 4 1 5v14a2 2 0 0 0 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2M5 17l3.5-4.5l2.5 3l3.5-4.5l4.5 6H5Z"/>'
        },
        "image-size-select-large": {
            body: '<path fill="currentColor" d="M21 15h2v2h-2v-2m0-4h2v2h-2v-2m2 8h-2v2c1 0 2-1 2-2M13 3h2v2h-2V3m8 4h2v2h-2V7m0-4v2h2c0-1-1-2-2-2M1 7h2v2H1V7m16-4h2v2h-2V3m0 16h2v2h-2v-2M3 3C2 3 1 4 1 5h2V3m6 0h2v2H9V3M5 3h2v2H5V3m-4 8v8a2 2 0 0 0 2 2h12V11H1m2 8l2.5-3.21l1.79 2.15l2.5-3.22L13 19H3Z"/>'
        },
        "image-size-select-small": {
            body: '<path fill="currentColor" d="M23 15h-2v2h2v-2m0-4h-2v2h2v-2m0 8h-2v2c1 0 2-1 2-2M15 3h-2v2h2V3m8 4h-2v2h2V7m-2-4v2h2c0-1-1-2-2-2M3 21h8v-6H1v4a2 2 0 0 0 2 2M3 7H1v2h2V7m12 12h-2v2h2v-2m4-16h-2v2h2V3m0 16h-2v2h2v-2M3 3C2 3 1 4 1 5h2V3m0 8H1v2h2v-2m8-8H9v2h2V3M7 3H5v2h2V3Z"/>'
        },
        "image-sync": {
            body: '<path fill="currentColor" d="M8.5 13.5L5 18h8.03c.08 1.1.44 2.12 1 3H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v6.18c-.5-.11-1-.18-1.5-.18c-1.72 0-3.27.67-4.43 1.76L14.5 12L11 16.5l-2.5-3M19 20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20m0-6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4Z"/>'
        },
        "image-sync-outline": {
            body: '<path fill="currentColor" d="M13.18 19c.17.72.46 1.39.85 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v6.18c-.5-.11-1-.18-1.5-.18c-.17 0-.33 0-.5.03V5H5v14h8.18m-1.97-3.17l-1.96-2.36L6.5 17h6.53c.11-1.46.7-2.78 1.61-3.81l-.68-.9l-2.75 3.54M19 13.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20Z"/>'
        },
        "image-text": {
            body: '<path fill="currentColor" d="M22 13h-8v-2h8v2m0-6h-8v2h8V7m-8 10h8v-2h-8v2m-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2m-1.5 6l-2.2-3l-1.8 2.3l-1.2-1.5L3.5 15h7Z"/>'
        },
        import: {
            body: '<path fill="currentColor" d="m14 12l-4-4v3H2v2h8v3m10 2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3h2V6h12v12H6v-3H4v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2Z"/>'
        },
        inbox: {
            body: '<path fill="currentColor" d="M19 15h-4a3 3 0 0 1-3 3a3 3 0 0 1-3-3H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "inbox-arrow-down": {
            body: '<path fill="currentColor" d="M16 10h-2V7h-4v3H8l4 4m7 1h-4a3 3 0 0 1-3 3a3 3 0 0 1-3-3H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "inbox-arrow-down-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M5 19v-2h3.13a4.13 4.13 0 0 0 1.27 2m9.6 0h-4.4a4.13 4.13 0 0 0 1.27-2H19m0-2h-5v1a2 2 0 0 1-4 0v-1H5V5h14m-3 5h-2V7h-4v3H8l4 4"/>'
        },
        "inbox-arrow-up": {
            body: '<path fill="currentColor" d="M14 14h-4v-3H8l4-4l4 4h-2v3m-9 1V5h14v10h-4a3 3 0 0 1-3 3a3 3 0 0 1-3-3H5M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"/>'
        },
        "inbox-arrow-up-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M5 19v-2h3.13a4.13 4.13 0 0 0 1.27 2m9.6 0h-4.4a4.13 4.13 0 0 0 1.27-2H19m0-2h-5v1a2 2 0 0 1-4 0v-1H5V5h14M8 11h2v3h4v-3h2l-4-4"/>'
        },
        "inbox-full": {
            body: '<path fill="currentColor" d="M19 15V5H5v10h4c0 1.66 1.34 3 3 3s3-1.34 3-3h4m0-12c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M7 13v-2h10v2H7m0-4V7h10v2H7Z"/>'
        },
        "inbox-full-outline": {
            body: '<path fill="currentColor" d="M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14M5 19h4.4a4.126 4.126 0 0 1-1.27-2H5v2m14 0v-2h-3.13c-.22.78-.66 1.47-1.27 2H19m0-4V5H5v10h5v1c0 2.67 4 2.67 4 0v-1h5M7 7h10v2H7V7m10 4v2H7v-2h10Z"/>'
        },
        "inbox-multiple": {
            body: '<path fill="currentColor" d="M19 8V5H5v3h4a3 3 0 0 0 3 3a3 3 0 0 0 3-3h4m0-5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M3 15h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4Z"/>'
        },
        "inbox-multiple-outline": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M5 10v2h4.4c-.6-.53-1.06-1.22-1.27-2H5m14 2v-2h-3.13c-.21.78-.67 1.47-1.27 2H19m0-4V5H5v3h5v1c0 1.07.93 2 2 2c1.07 0 2-.93 2-2V8h5m2 11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4h7v1c0 1.07.93 2 2 2c1.07 0 2-.93 2-2v-1h7v4M5 17v2h4.4c-.6-.53-1.06-1.22-1.27-2H5m14 2v-2h-3.13c-.21.78-.67 1.47-1.27 2H19Z"/>'
        },
        "inbox-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M5 19v-2h3.13a4.13 4.13 0 0 0 1.27 2m9.6 0h-4.4a4.13 4.13 0 0 0 1.27-2H19m0-2h-5v1a2 2 0 0 1-4 0v-1H5V5h14Z"/>'
        },
        "inbox-remove": {
            body: '<path fill="currentColor" d="M19 15h-4c0 1.7-1.3 3-3 3s-3-1.3-3-3H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-4.9 3.5l1.4 1.4l-2.1 2.1l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4L12 8.6l2.1-2.1Z"/>'
        },
        "inbox-remove-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M5 19v-2h3.1c.2.8.7 1.5 1.3 2m9.6 0h-4.4c.6-.5 1.1-1.2 1.3-2H19m0-2h-5v1c0 1.1-.9 2-2 2s-2-.9-2-2v-1H5V5h14v10m-4.9-8.5l1.4 1.4l-2.1 2.1l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4L12 8.6l2.1-2.1Z"/>'
        },
        incognito: {
            body: '<path fill="currentColor" d="M17.06 13c-1.86 0-3.42 1.33-3.82 3.1c-.95-.41-1.82-.3-2.48-.01C10.35 14.31 8.79 13 6.94 13C4.77 13 3 14.79 3 17s1.77 4 3.94 4c2.06 0 3.74-1.62 3.9-3.68c.34-.24 1.23-.69 2.32.02c.18 2.05 1.84 3.66 3.9 3.66c2.17 0 3.94-1.79 3.94-4s-1.77-4-3.94-4M6.94 19.86c-1.56 0-2.81-1.28-2.81-2.86s1.26-2.86 2.81-2.86c1.56 0 2.81 1.28 2.81 2.86s-1.25 2.86-2.81 2.86m10.12 0c-1.56 0-2.81-1.28-2.81-2.86s1.25-2.86 2.81-2.86s2.82 1.28 2.82 2.86s-1.27 2.86-2.82 2.86M22 10.5H2V12h20v-1.5m-6.47-7.87c-.22-.49-.78-.75-1.31-.58L12 2.79l-2.23-.74l-.05-.01c-.53-.15-1.09.13-1.29.64L6 9h12l-2.44-6.32l-.03-.05Z"/>'
        },
        "incognito-circle": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m2.92 10.81c-1.08 0-1.97.75-2.21 1.75c-.54-.23-1.05-.17-1.42-.01c-.24-1-1.14-1.74-2.21-1.74c-1.25 0-2.26 1.01-2.26 2.26c0 1.25 1.01 2.26 2.26 2.26c1.2 0 2.16-.91 2.25-2.08c.2-.13.71-.39 1.34.01a2.258 2.258 0 0 0 4.51-.19c0-1.25-1.01-2.26-2.26-2.26m-5.84.64c.92 0 1.62.73 1.62 1.62c0 .89-.7 1.62-1.62 1.62c-.89 0-1.62-.73-1.62-1.62c0-.89.73-1.62 1.62-1.62m5.84 0c.89 0 1.62.73 1.62 1.62c0 .89-.73 1.62-1.62 1.62c-.92 0-1.62-.73-1.62-1.62c0-.89.7-1.62 1.62-1.62m2.91-1.95H6.17v.67h11.66v-.67m-3.68-4.61a.672.672 0 0 0-.8-.36L12 7l-1.35-.47l-.04-.03a.672.672 0 0 0-.77.42l-1.48 3.91h7.28l-1.48-3.91l-.01-.03Z"/>'
        },
        "incognito-circle-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.95 2.95A9.888 9.888 0 0 0 2 12c0 5.5 4.5 10 10 10c2.28 0 4.37-.77 6.05-2.06l2.79 2.79l1.27-1.27M8.94 10.83h-.58l.14-.42l.44.42m-2.77.67h3.44l.67.67H6.17v-.67m8.75 5.83c-1.19 0-2.15-.91-2.25-2.07c-.63-.4-1.14-.14-1.34-.01a2.243 2.243 0 0 1-2.25 2.08c-1.25 0-2.26-1.01-2.26-2.26c0-1.25 1.01-2.26 2.26-2.26c1.07 0 1.97.74 2.21 1.74c.36-.15.84-.21 1.36-.01l.66.66c.06.8.69 1.41 1.47 1.47l.6.6c-.15.03-.3.06-.46.06M9.94 6.74L6.72 3.5C8.25 2.56 10.06 2 12 2c5.5 0 10 4.5 10 10c0 1.94-.56 3.75-1.5 5.28l-5.13-5.11h2.46v-.67H14.7l-.67-.67h1.61l-1.48-3.91l-.01-.03a.672.672 0 0 0-.8-.36L12 7l-1.35-.47l-.04-.03a.707.707 0 0 0-.67.24m.76 8.33c0 .89-.7 1.62-1.62 1.62c-.89 0-1.62-.73-1.62-1.62s.73-1.62 1.62-1.62c.92 0 1.62.73 1.62 1.62Z"/>'
        },
        "incognito-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.2 5.2L6 9h1.11l1.5 1.5H2V12h8.11l3.39 3.37c-.12.24-.2.48-.26.73c-.95-.41-1.83-.3-2.48-.01C10.35 14.31 8.79 13 6.94 13C4.77 13 3 14.79 3 17s1.77 4 3.94 4c2.06 0 3.74-1.62 3.9-3.68c.34-.24 1.23-.69 2.32.02c.18 2.05 1.84 3.66 3.9 3.66c.6 0 1.16-.14 1.66-.39l2.12 2.12l1.27-1.27m-15.17-1.6c-1.56 0-2.81-1.28-2.81-2.86c0-1.58 1.26-2.86 2.81-2.86c1.56 0 2.81 1.28 2.81 2.86c0 1.58-1.25 2.86-2.81 2.86m10.12 0c-1.56 0-2.81-1.28-2.81-2.86c0-.26.04-.5.11-.75l3.48 3.48c-.25.08-.5.13-.78.13M22 12h-6.8l-1.5-1.5H22V12m-4.94 1c2.17 0 3.94 1.79 3.94 4c0 .25-.03.5-.07.73l-1.09-1.09a2.825 2.825 0 0 0-2.46-2.47l-1.09-1.08c.25-.06.51-.09.77-.09M12.2 9L7.72 4.5l.71-1.82c.2-.51.76-.79 1.29-.64l.05.01l2.23.74l2.22-.74c.53-.17 1.1.09 1.32.58l.02.05L18 9h-5.8Z"/>'
        },
        indent: {
            body: '<path d="M2 3h20v3H2V3zm7 5h13v3H9V8zm0 5h13v3H9v-3zm-7 5h20v3H2v-3zM3 8l4 4l-4 4H2V8h1z" fill="currentColor"/>',
            hidden: true
        },
        induction: {
            body: '<path fill="currentColor" d="M23 2c-2.25 0-4.25.61-5.81 1.33C15.79 2.61 14 2 12 2s-3.79.61-5.19 1.33C5.25 2.61 3.25 2 1 2v2c1.36 0 2.61.27 3.71.64c-.68.51-1.08.9-1.12.95C3.21 5.96 3 6.47 3 7v11c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-.58-.25-1.12-.68-1.5c-.06-.05-.52-.45-1.32-.96c.92-.32 1.92-.54 3-.54s2.08.22 3 .54c-.8.51-1.26.91-1.32.96c-.43.38-.68.92-.68 1.5v11c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-.53-.21-1.04-.59-1.41c-.04-.05-.44-.44-1.12-.95C20.39 4.27 21.64 4 23 4V2M9 7v11c0 1.11-.89 2-2 2s-2-.89-2-2V7s.7-.69 1.87-1.42C8.2 6.31 9 7 9 7m10 0v11c0 1.11-.89 2-2 2s-2-.89-2-2V7s.8-.69 2.13-1.42C18.3 6.31 19 7 19 7Z"/>'
        },
        infinity: {
            body: '<path fill="currentColor" d="M18.6 6.62C21.58 6.62 24 9 24 12c0 2.96-2.42 5.37-5.4 5.37c-1.45 0-2.8-.56-3.82-1.57L12 13.34l-2.83 2.51c-.97.97-2.33 1.53-3.77 1.53C2.42 17.38 0 14.96 0 12s2.42-5.38 5.4-5.38c1.44 0 2.8.56 3.82 1.58L12 10.66l2.83-2.51c.97-.97 2.33-1.53 3.77-1.53M7.8 14.39L10.5 12L7.84 9.65c-.68-.68-1.53-1.03-2.44-1.03C3.53 8.62 2 10.13 2 12c0 1.87 1.53 3.38 3.4 3.38c.91 0 1.76-.35 2.4-.99m8.4-4.78L13.5 12l2.66 2.35c.68.68 1.54 1.03 2.44 1.03c1.87 0 3.4-1.51 3.4-3.38c0-1.87-1.53-3.38-3.4-3.38c-.91 0-1.76.35-2.4.99Z"/>'
        },
        information: {
            body: '<path fill="currentColor" d="M13 9h-2V7h2m0 10h-2v-6h2m-1-9A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "information-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 5.5 4.5 10 10 10c2.3 0 4.4-.8 6-2.1l2.8 2.8l1.3-1.2M13 17h-2v-4.1l2 2V17m-2-9.2L6.7 3.5C8.3 2.6 10.1 2 12 2c5.5 0 10 4.5 10 10c0 1.9-.6 3.7-1.5 5.3L12.2 9h.8V7h-2v.8Z"/>'
        },
        "information-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 5.5 4.5 10 10 10c2.3 0 4.4-.8 6-2.1l2.8 2.8l1.3-1.2M12 20c-4.4 0-8-3.6-8-8c0-1.7.6-3.3 1.5-4.6l5.5 5.5V17h2v-2.1l3.6 3.6c-1.3.9-2.9 1.5-4.6 1.5M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2c5.5 0 10 4.5 10 10c0 1.9-.6 3.7-1.5 5.3L19 15.8c.6-1.1 1-2.4 1-3.8c0-4.4-3.6-8-8-8c-1.4 0-2.7.4-3.8 1M11 7h2v2h-2V7Z"/>'
        },
        "information-outline": {
            body: '<path fill="currentColor" d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6Z"/>'
        },
        "information-variant": {
            body: '<path fill="currentColor" d="M13.5 4A1.5 1.5 0 0 0 12 5.5A1.5 1.5 0 0 0 13.5 7A1.5 1.5 0 0 0 15 5.5A1.5 1.5 0 0 0 13.5 4m-.36 4.77c-1.19.1-4.44 2.69-4.44 2.69c-.2.15-.14.14.02.42c.16.27.14.29.33.16c.2-.13.53-.34 1.08-.68c2.12-1.36.34 1.78-.57 7.07c-.36 2.62 2 1.27 2.61.87c.6-.39 2.21-1.5 2.37-1.61c.22-.15.06-.27-.11-.52c-.12-.17-.24-.05-.24-.05c-.65.43-1.84 1.33-2 .76c-.19-.57 1.03-4.48 1.7-7.17c.11-.64.41-2.04-.75-1.94Z"/>'
        },
        instagram: {
            body: '<path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        instapaper: {
            body: '<path d="M10 5a1 1 0 0 0-1-1H8V2h8v2h-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1v2H8v-2h1a1 1 0 0 0 1-1V5z" fill="currentColor"/>',
            hidden: true
        },
        "instrument-triangle": {
            body: '<path fill="currentColor" d="M11.5 2h-1v4.2c-.1.1-.2.1-.3.3L2.1 20.7c-.3.6.1 1.3.8 1.3H16v-2H4.8L11 9.2l5.7 10l1.7-1l-6.6-11.8l-.3-.3V2M21 6h-1v12l-.5 4h2l-.5-4V6Z"/>'
        },
        "integrated-circuit-chip": {
            body: '<path fill="currentColor" d="M10 4h10c1.11 0 2 .89 2 2v2h-3.41L16 10.59v4l-2 2V20h-4v-3.41l-2-2V9.41l2-2V4m8 7.41V14h4v-4h-2.59L18 11.41M6.59 8L8 6.59V4H4c-1.11 0-2 .89-2 2v2h4.59M6 14v-4H2v4h4m2 3.41L6.59 16H2v2c0 1.11.89 2 2 2h4v-2.59M17.41 16L16 17.41V20h4c1.11 0 2-.89 2-2v-2h-4.59Z"/>'
        },
        "invert-colors": {
            body: '<path fill="currentColor" d="M12 19.58c-1.6 0-3.11-.62-4.24-1.75A5.951 5.951 0 0 1 6 13.58c0-1.58.62-3.11 1.76-4.24L12 5.1m5.66 2.83L12 2.27L6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31A7.98 7.98 0 0 0 12 21.58c2.05 0 4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31Z"/>'
        },
        "invert-colors-off": {
            body: '<path fill="currentColor" d="M20.65 20.87L18.3 18.5L12 12.23L8.44 8.66L7 7.25L4.27 4.5L3 5.77l2.78 2.78a8.005 8.005 0 0 0 .56 10.69A7.98 7.98 0 0 0 12 21.58c1.79 0 3.57-.58 5.03-1.78l2.7 2.7L21 21.23l-.35-.36M12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 0 1 6 13.59C6 12.27 6.43 11 7.21 10L12 14.77v4.82M12 5.1v4.58l7.25 7.26a7.99 7.99 0 0 0-1.6-9.01L12 2.27l-3.7 3.7l1.41 1.41L12 5.1Z"/>'
        },
        iobroker: {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .04-1.5.11v2.74a7.631 7.631 0 0 1 3 0V2.12C13 2.04 12.5 2 12 2m-2.18.25C5.4 3.25 2.11 7.24 2.11 12c0 5.5 4.42 10 9.89 10c5.47 0 9.89-4.5 9.89-10c0-4.76-3.29-8.75-7.7-9.75v2.78c2.98.93 5.15 3.7 5.15 6.97c0 4-3.29 7.3-7.34 7.3c-4.04 0-7.33-3.3-7.33-7.3c0-3.27 2.17-6.04 5.15-6.97m2.18.42c-.5 0-1 .05-1.5.17v12.65c.5.11 1 .17 1.5.17s1-.05 1.5-.17V5.62c-.5-.12-1-.17-1.5-.17Z"/>'
        },
        ip: {
            body: '<path fill="currentColor" d="M16 11h-2V9h2v2M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m7 2H8v10h2V7m2 10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4v10Z"/>'
        },
        "ip-network": {
            body: '<path fill="currentColor" d="M15 9h-2V7h2v2m7 11v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7M9 5H7v10h2V5m2 10h2v-4h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v10Z"/>'
        },
        "ip-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m3-9H8v8h2V6m4 0h-3v8h2v-2h1a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 4h-1V8h1v2Z"/>'
        },
        "ip-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 7H7v10h2V7m6 0h-4v10h2v-4h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2m0 4h-2V9h2v2Z"/>'
        },
        ipod: {
            body: '<path fill="currentColor" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7m0 2h10v6H7V4m5 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        iron: {
            body: '<path fill="currentColor" d="M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1Z"/>'
        },
        "iron-board": {
            body: '<path fill="currentColor" d="M19 6h-3V4.8c0-1.12.56-2.17 1.5-2.8c.94.63 1.5 1.68 1.5 2.8V6m-3.72 7.63L19.59 19c.79.06 1.41.7 1.41 1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-.24l-4-5.03l-4 5.03v.24c0 .83-.67 1.5-1.5 1.5S7 21.33 7 20.5c0-.8.63-1.44 1.41-1.5l4.31-5.37L9 9H3V7h18v2h-2l-3.72 4.63M14 12l2.42-3h-4.84L14 12Z"/>'
        },
        "iron-outline": {
            body: '<path fill="currentColor" d="M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1m-6 10H4v-1c0-1.1.9-2 2-2h9v3Z"/>'
        },
        island: {
            body: '<path fill="currentColor" d="M20 20c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 19.53 5.39 20 4 20H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2h-2m.78-1H20c-1.18 0-2.36-.4-3.42-1.15l-.58-.4l-.58.4c-1.03.72-2.21 1.1-3.42 1.1c-1.23 0-2.41-.38-3.44-1.1l-.56-.4l-.57.4C6.36 18.6 5.18 19 4 19h-.78c.53-1.46 2.36-4 8.78-4c2 0 3 .24 3 .24c.68-1.37 1.83-4.47 1-8.42l1.06.71c.33 1.43.94 4.22-.26 8.12c2.63.85 3.62 2.35 3.98 3.35M22 7.59c-.79-1.09-2-1.88-3.42-2.06c.12.14.23.3.34.47a5.03 5.03 0 0 1-.45 5.95c.59-1.45.53-3.16-.39-4.59c-.08-.08-.12-.16-.18-.25c-.4-.58-.94-1.05-1.52-1.39c-2.03.65-3.5 2.55-3.5 4.78c0 .53.08 1.03.22 1.5c-.6-.83-.94-1.83-.94-2.93c0-1.66.8-3.12 2.04-4.04c-1.04-.08-2.11.15-3.06.75c-.44.27-.82.6-1.14.98c.39-.94 1.05-1.76 2-2.36a4.85 4.85 0 0 1 3.39-.71a5.2 5.2 0 0 0-1.06-1.09c-.41-.31-.86-.55-1.33-.72c1 .03 2.04.36 2.91 1.01c.44.33.79.73 1.09 1.16c.06 0 .12-.01.19-.01A5.03 5.03 0 0 1 22 7.59Z"/>'
        },
        itunes: {
            body: '<path d="M7.85 17.07c-.82.1-4.35.6-3.79 3.19c.63 3.04 5.81 2.33 5.77-1.26c-.02-2.43 0-9.8 0-9.8s-.07-.67.6-.81l7.76-1.6s.64-.14.64.5v6.91s.07.63-.71.8c-.78.12-4.21.4-3.93 3c.31 3.07 5.81 2.65 5.81-.93V2.61s.04-.99-1.1-.74L9.5 3.78s-.84.18-.84.99v11.34s0 .85-.81.96z" fill="currentColor"/>',
            hidden: true
        },
        "iv-bag": {
            body: '<path fill="currentColor" d="M14 1h-4C5 1 5 3 5 3v12s0 2 5 2v2h1v1c0 1.21.8 3 3 3h4v-2h-4c-.81 0-1-.55-1-1v-1h1v-2c5 0 5-2 5-2V3s0-2-5-2m3 11h-3v-1h3v1m0-7h-3v1h3v2h-3v1h3v1H7V3.5c.3-.18 1.13-.5 3-.5h4c1.88 0 2.7.32 3 .5V5Z"/>'
        },
        jabber: {
            body: '<path fill="currentColor" d="M5.23 5.72C4.61 5.55 5 3.19 5 3.17c0 .02 7.58-3.88 11.7 2.56c4.1 6.42-.84 9.13-2.73 10.33c-1.89 1.21-1.24 3.66-1.24 4.07c0 .4-.57.84-.73.28c-.12-.57-.75-3.86 1.33-5.25c3.8-2.55 4.57-5.06 2.67-8.74C14.2 3 8.28 3.41 7.03 4.08c-1.25.67-1.17 1.81-1.8 1.64m4.1 6.91l-.22-.47c.12-1.88-1.48-1.77-1.03 1.17c.13.83-.61.47-.63.4c-.56-2.29-.03-3.51 1.1-3.28c1.07.23.98 1.38.98 1.38c.03-.05 1.47-1.66 1.97-.91c1.08 1.58-.97 3.55-1.09 3.71c-.13.15-.27.42-.49.21c-.22-.2-.2-.34-.03-.57c2.88-4.27-.3-2.05-.56-1.64m-2.83 2.7v-.02s1.5 2.82 4.11 1.77c.39-.16.56.06.59.19c.07.26-.07.37-.34.46c-3 .99-4.97-1.1-5.23-1.6c-.24-.45-.13-.75.12-.91c.25-.16.75.11.75.11M6 17.5s1.67 2 4.8 1.5c.29-.06.4.13.45.38c.05.25-.03.46-.33.56c-.29.09-3.84.56-5.79-2.22c-.13-.16.17-.36.34-.36s.56.14.53.14m-.05 1.89c1.58 2.11 4.38 2.16 5.33 1.49c.22-.15.42.17.28.31c-1.92 1.97-5.89-.19-6.29-.86c-.18-.28-.14-.67.04-.88c.19-.2.62-.07.64-.06Z"/>'
        },
        jeepney: {
            body: '<path fill="currentColor" d="M19 13V7h1V4H4v3h1v6H2c0 .93.5 1.71 1.5 1.93V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h11v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5.07c1-.23 1.5-1 1.5-1.93h-3M8 15a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 8 12a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 8 15m8 0a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 16 12a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 16 15m1.5-4.5c-1.58-.32-3.47-.5-5.5-.5s-4 .18-5.5.5V7h11v3.5Z"/>'
        },
        jellyfish: {
            body: '<path fill="currentColor" d="M19.5 14.5a.898.898 0 0 0-1 1c0 .67-1 .67-1 0v-2.3l1.7-.5c.72-.34 1.21-1.02 1.3-1.8C20.5 5.5 16.7 2 12 2s-8.5 3.5-8.5 8.9c.06.8.56 1.5 1.3 1.8l1.7.5v2.3a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5a.898.898 0 0 0-1-1a.898.898 0 0 0-1 1A2.394 2.394 0 0 0 6 18c1.41.06 2.56-1.09 2.5-2.5v-1.8h1v5.7c0 .67-1 .67-1 0a.898.898 0 0 0-1-1a.898.898 0 0 0-1 1A2.4 2.4 0 0 0 9 22c1.41.06 2.56-1.09 2.5-2.5V14h1v5.5A2.394 2.394 0 0 0 15 22c1.41.06 2.56-1.09 2.5-2.5c0-1.33-2-1.33-2 0c0 .67-1 .67-1 0v-5.7h1v1.8c0 1.36 1.13 2.46 2.5 2.4c1.41.06 2.56-1.09 2.5-2.5a.898.898 0 0 0-1-1m-8.9-9.8A5.566 5.566 0 0 0 7 7.3c-.17.2-.5.27-.7.1a.507.507 0 0 1-.1-.7a6.904 6.904 0 0 1 4.2-3c.27-.02.51.15.6.4c.06.27-.12.55-.4.6Z"/>'
        },
        "jellyfish-outline": {
            body: '<path fill="currentColor" d="M12 4c3.8 0 6.5 2.8 6.5 6.8a18.311 18.311 0 0 1-13 0C5.5 6.8 8.2 4 12 4m0-2c-4.7 0-8.5 3.5-8.5 8.9c.06.8.56 1.5 1.3 1.8l1.7.5v2.3a.5.5 0 0 1-.5.5a.5.5 0 0 1-.5-.5a.898.898 0 0 0-1-1a.898.898 0 0 0-1 1A2.405 2.405 0 0 0 5.9 18H6c1.41.06 2.56-1.09 2.5-2.5v-1.8h1v5.7c0 .67-1 .67-1 0a.898.898 0 0 0-1-1a.898.898 0 0 0-1 1c-.11 1.4 1 2.6 2.4 2.6H9c1.41.06 2.56-1.09 2.5-2.5V14h1v5.5A2.394 2.394 0 0 0 15 22h.1c1.37 0 2.46-1.14 2.4-2.5c0-1.33-2-1.33-2 0c0 .67-1 .67-1 0v-5.7h1v1.8c0 1.36 1.13 2.46 2.5 2.4h.1c1.37 0 2.46-1.14 2.4-2.5c0-1.33-2-1.33-2 0c0 .67-1 .67-1 0v-2.3l1.7-.5c.72-.34 1.21-1.02 1.3-1.8C20.5 5.5 16.7 2 12 2m0 4.2c-1.47.4-2.76 1.33-3.6 2.6c-.4.53-1.2-.07-.8-.6a7.47 7.47 0 0 1 4.2-3a.5.5 0 0 1 .6.4c.1.3-.1.5-.4.6Z"/>'
        },
        jira: {
            body: '<path fill="currentColor" d="M11.53 2c0 2.4 1.97 4.35 4.35 4.35h1.78v1.7c0 2.4 1.94 4.34 4.34 4.35V2.84a.84.84 0 0 0-.84-.84h-9.63M6.77 6.8a4.362 4.362 0 0 0 4.34 4.34h1.8v1.72a4.362 4.362 0 0 0 4.34 4.34V7.63a.841.841 0 0 0-.83-.83H6.77M2 11.6c0 2.4 1.95 4.34 4.35 4.34h1.78v1.72c.01 2.39 1.95 4.34 4.34 4.34v-9.57a.84.84 0 0 0-.84-.84L2 11.6Z"/>'
        },
        jquery: {
            body: '<path fill="currentColor" d="M22.88 10.41a5.005 5.005 0 0 1-7.04-.62c-1.78-2.12-1.5-5.29.61-7.04l.51-.38A5.024 5.024 0 0 0 16.8 9c1.63 1.94 4.45 2.32 6.54.97l-.46.44M21.1 14.5a7.48 7.48 0 0 1-10.56-.92c-2.67-3.17-2.25-7.9.92-10.58l.92-.64a7.494 7.494 0 0 0-.12 9.78c2.42 2.86 6.54 3.49 9.65 1.58l-.81.78m-1.13 4.88c-4.44 3.73-11.07 3.15-14.8-1.3C1.45 13.64 2.03 7 6.47 3.29l1.11-.79c-3.51 3.8-3.73 9.73-.3 13.82c3.43 4.08 9.31 4.9 13.68 2.11l-.99.95Z"/>'
        },
        jsfiddle: {
            body: '<path fill="currentColor" d="M17.34 13.7c0 1.3-1.11 2.34-2.48 2.34c-1.21 0-2.22-1.04-3.11-2l-.25-.25c0-.03-.03-.06-.05-.09c-.71-.74-1.49-1.48-2.24-1.48c-.89 0-1.61.66-1.61 1.47c0 .81.72 1.48 1.61 1.48c.76 0 1.14-.42 1.42-.72l.07-.08c.16-.17.44-.18.61-.02c.19.15.19.44.02.61l-.06.07c-.33.35-.92 1-2.06 1c-1.37 0-2.48-1.03-2.48-2.34c0-1.29 1.11-2.34 2.48-2.34c1.21 0 2.22 1.06 3.11 2l.24.25l.06.09c.71.74 1.49 1.48 2.24 1.48c.89 0 1.61-.67 1.61-1.48c0-.81-.72-1.47-1.61-1.47c-.75 0-1.14.42-1.42.72l-.07.06c-.16.19-.43.2-.61.04a.45.45 0 0 1-.02-.62l.07-.06c.32-.36.92-1 2.05-1c1.37 0 2.48 1.04 2.48 2.34M22 14.85c0 1.11-.43 2.15-1.22 2.94c-.78.78-1.83 1.21-2.94 1.21H6.28c-2.32-.04-4.21-1.94-4.21-4.25c0-1.38.69-2.68 1.82-3.47c-.04-.19-.06-.38-.06-.58c0-1.67 1.37-3.03 3.05-3.03c.51 0 1 .12 1.44.36A6.147 6.147 0 0 1 13.6 5c3.37 0 6.1 2.72 6.1 6.07v.07c1.41.7 2.3 2.13 2.3 3.71m-.87 0c0-1.35-.8-2.53-2.04-3.04a.438.438 0 0 1-.27-.43l.01-.09c0-.07.01-.15.01-.22c0-2.87-2.34-5.2-5.24-5.2c-2 0-3.86 1.16-4.73 2.96c-.05.12-.16.21-.29.24c-.12.03-.26 0-.36-.07c-.39-.31-.85-.47-1.34-.47c-1.2 0-2.18.97-2.18 2.17c0 .22.03.44.1.64c.06.2-.02.41-.19.51c-1.05.62-1.67 1.7-1.67 2.9c0 1.84 1.5 3.35 3.35 3.38h11.54c.89 0 1.71-.34 2.33-.96c.63-.62.97-1.44.97-2.32Z"/>'
        },
        "jump-rope": {
            body: '<path fill="currentColor" d="M21 4.5v6c0 .7-.5 1.4-1.2 1.5v5.3c0 1.3-.8 3.8-3.8 3.8h-1.5c.4-.4.8-.9 1-1.5h.5c2.1 0 2.2-1.9 2.2-2.2V12c-.7-.1-1.2-.7-1.2-1.5v-6c0-.8.7-1.5 1.5-1.5h1c.8 0 1.5.7 1.5 1.5m-6.2 13.7c0 1.5-1.2 2.8-2.8 2.8H8c-3 0-3.8-2.5-3.8-3.8V12c-.7-.1-1.2-.8-1.2-1.5v-6C3 3.7 3.7 3 4.5 3h1C6.3 3 7 3.7 7 4.5v6c0 .7-.5 1.4-1.2 1.5v5.3c0 .4.1 2.2 2.2 2.2h1.6c-.2-.4-.3-.8-.3-1.2v-10c0-1.5 1.2-2.8 2.8-2.8s2.7 1.2 2.7 2.8m-1.6-.1c0-.6-.5-1.2-1.2-1.2s-1.2.6-1.2 1.2v10c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-10Z"/>'
        },
        kabaddi: {
            body: '<path fill="currentColor" d="M11.2 10.6c1 1 2.2 1.5 3.6 1.5l.1 2.1c-1.9 0-3.6-.7-5.1-2.1l-.7-.7l-2.3 2.4L9 15.9v6H7v-5.2l-1.3-1.2v2.2L1.5 22L.1 20.6L3.7 17l-1.2-3.5c-.2-.6.1-1.1.6-1.5l3.3-3.3c.4-.5.9-.7 1.4-.7c.5 0 .8.1 1.1.3l2.3 2.3M24 11.9h-2V8.5l-1.8-.7l.9 4.4l1 5.2l.9 4.4h-2.1l-1.8-8l-2.1 2v6h-2v-7.5l2.1-2l-.6-3c-.6.6-1.3 1.2-2.1 1.6c-.9-.1-1.8-.5-2.5-1.2c1.6-.3 2.7-1.1 3.4-2.3l1-1.6c.6-1 1.5-1.3 2.6-.8L24 7.2v4.7M11.4 4.4c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2M16.5.3c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        kangaroo: {
            body: '<path fill="currentColor" d="M19.8 6.59L19 7.97v2.07l-1.31 1.57l-.38 1.64L16 14l-.5-.88l.94-.53l.26-1.14l.07-.3l.7-.84c.18-.21.15-.53-.06-.7a.506.506 0 0 0-.71.06l-.85 1.02l-.29 1.24c-.18.03-.36.07-.56.07c-.69 0-1.32-.24-1.77-.6c-.08 1.3-.5 2.41-1.1 3.03l-1.63 1.76l-.54 3.6L8.07 21l-.54-.83l1.51-.98l.46-3.27v-.01l.5-1.37c-.53-.46-.92-1.26-1.12-2.24l-.17.31c-.36.64-.71 1.29-1.15 1.95c-.45.64-.9 1.34-1.78 1.88c-.44.28-1.08.4-1.61.29c-.56-.12-1.03-.47-1.31-.84c-.55-.76-.71-1.54-.86-2.27l.97-.26c.23.64.53 1.29.91 1.64c.38.33.69.26.96 0c.32-.27.63-.85.89-1.45c.27-.61.49-1.27.72-1.95c.48-1.36.94-2.78 1.75-4.24c.42-.72.93-1.47 1.72-2.14C10.7 4.55 11.73 4 13 4s2.7 1.22 3.58 2.34c.42.55 1.29.48 1.64-.13l.92-1.58a.929.929 0 0 1-.35-.23a.984.984 0 0 1 0-1.4l1.14 1.13c.03 0 .07-.02.07-.02a1 1 0 0 1 .91.58L22 7l-1 .5l-1.2-.91Z"/>'
        },
        karate: {
            body: '<path fill="currentColor" d="m19.8 2l-8.2 6.7l-1.21-1.04L14 5.58L9.41 1L8 2.41l2.74 2.74L5 8.46l-1.19 4.29L6.27 17L8 16l-2.03-3.5l.35-1.32L9.5 13l.5 9h2l.5-10L21 3.4L19.8 2M5 3a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"/>'
        },
        kayaking: {
            body: '<path fill="currentColor" d="M22 23v-2c-1.42.05-2.79-.1-4-1c-1.77 1.25-4.23 1.25-6 0c-1.77 1.25-4.23 1.25-6 0c-1.21.9-2.58 1.05-4 1v2c1.38.05 2.79-.06 4-.75c1.84 1 4.16 1 6 0c1.84 1 4.16 1 6 0c1.21.69 2.62.8 4 .75m1.39-5.79c-2.26-.92-5.09-1.65-7.73-1.99l3.7-8.34l1.31-.47l1.33-3L18.8 2l-1.3 2.95l.5 1.32l-1.69 3.7l-2.81 1.5L11 10.2a.492.492 0 0 0-.26-.14c-.92-.33-1.97.26-2.24 1.17l-1.37 4.18c-.54-.23-5.88 1.56-6.215 1.71L0 17.47c1.33.57 2.2.92 3.94 1.41c.81-.25 1.5-.79 2.06-1.41c1.5 1.95 4.5 1.95 6 0c1.5 1.95 4.5 1.95 6 0c.56.62 1.25 1.16 2.06 1.41l2.89-.97l1.05-.44l-.61-.26m-9.33-2.13c-.99-.08-2-.08-3-.08l.71-2.17l1.73.94l1.5-.85l-.94 2.16M14 7.5c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        keg: {
            body: '<path fill="currentColor" d="M5 22v-2h1v-4H5v-2h1v-3H5V7h6V3h-1V2h4v1h-1v4h6v4h-1v3h1v2h-1v4h1v2H5M17 9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z"/>'
        },
        kettle: {
            body: '<path fill="currentColor" d="M12.5 3C7.81 3 4 5.69 4 9c0 1.19.5 2.34 1.44 3.33A6.797 6.797 0 0 0 4 16.5V20c0 1.11.89 2 2 2h13c1.11 0 2-.89 2-2v-3.5c0-1.22-.34-2.43-1-3.5l2-2l-3-3l-2.1 2.1A9.231 9.231 0 0 0 12.5 9c-1.85 0-3.55.53-4.95 1.41C7.19 9.97 7 9.5 7 9c0-1.79 2.46-3.25 5.5-3.25c1.43 0 2.8.33 3.83.92l2.02-2.02C16.77 3.59 14.68 3 12.5 3m0 8c.34 0 .67.04 1 .09c-3.11.48-5.5 3.16-5.5 6.41V20H6v-2.5a6.5 6.5 0 0 1 6.5-6.5Z"/>'
        },
        "kettle-alert": {
            body: '<path fill="currentColor" d="M9.5 3C4.8 3 1 5.7 1 9c0 1.2.5 2.3 1.4 3.3C1.5 13.5 1 15 1 16.5V20c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-3.5c0-1.2-.3-2.4-1-3.5l2-2l-3-3l-2.1 2.1C12.6 9.4 11.1 9 9.5 9c-1.8 0-3.6.5-4.9 1.4C4.2 10 4 9.5 4 9c0-1.8 2.5-3.2 5.5-3.2c1.4 0 2.8.3 3.8.9l2-2C13.8 3.6 11.7 3 9.5 3m0 8c.3 0 .7 0 1 .1c-3.1.5-5.5 3.1-5.5 6.4V20H3v-2.5C3 13.9 5.9 11 9.5 11M21 13V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "kettle-alert-outline": {
            body: '<path fill="currentColor" d="M9.5 3C4.8 3 1 5.7 1 9c0 1.2.5 2.3 1.4 3.3C1.5 13.5 1 15 1 16.5V20c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-3.5c0-1.2-.3-2.4-1-3.5l2-2l-3-3l-2.1 2.1c-2.9-1.6-6.5-1.5-9.3.3C4.2 10 4 9.5 4 9c0-1.8 2.5-3.3 5.5-3.3c1.4 0 2.8.4 3.8 1l2-2C13.6 3.5 11.6 3 9.5 3m0 8c3.5 0 6.5 3 6.5 5.5V20H3v-3.5C3 14 6 11 9.5 11m.5 1.5c-3 0-5 1.5-5 4.5v1h2v-1c0-1 0-3.5 3-4.5m11 .5V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "kettle-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3.6 3.6C4.3 7.3 4 8.1 4 9c0 1.2.5 2.3 1.4 3.3C4.5 13.5 4 15 4 16.5V20c0 1.1.9 2 2 2h13c.3 0 .6-.1.9-.2l.9.9l1.3-1.2M8.2 10.1l-.6.3C7.2 10 7 9.5 7 9v-.1l1.2 1.2M8 17.5V20H6v-2.5c0-2.6 1.5-4.8 3.7-5.9l.8.8C9 13.6 8 15.4 8 17.5m8.9-7.4L19 8l3 3l-2 2c.7 1.1 1 2.3 1 3.5v1.3L12.2 9h.3c1.5 0 3.1.4 4.4 1.1M9.5 6.3L7.4 4.2C8.8 3.5 10.6 3 12.5 3c2.2 0 4.3.6 5.8 1.7l-2 2c-1-.6-2.4-.9-3.8-.9c-1.1 0-2.1.1-3 .5Z"/>'
        },
        "kettle-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3.6 3.6C4.3 7.3 4 8.1 4 9c0 1.2.5 2.3 1.4 3.3C4.5 13.5 4 15 4 16.5V20c0 1.1.9 2 2 2h13c.3 0 .6-.1.9-.2l.9.9l1.3-1.2M8.2 10.1l-.6.3C7.2 10 7 9.5 7 9v-.1l1.2 1.2M6 20v-3.5c0-1.8 1.6-3.9 3.7-4.9l1.2 1.2c-1.8.6-2.9 2-2.9 4.2v1h2v-1c0-.8 0-2.5 1.4-3.7l6.7 6.7H6m10.9-9.9L19 8l3 3l-2 2c.7 1.1 1 2.3 1 3.5v1.3l-2.1-2.1c-.4-1.8-2.1-3.6-4.3-4.3L12.2 9c1.6-.1 3.2.3 4.7 1.1M9.5 6.3L7.4 4.2C8.8 3.5 10.6 3 12.5 3c2.1 0 4.1.5 5.8 1.7l-2 2c-1-.6-2.4-1-3.8-1c-1.1 0-2.2.2-3 .6Z"/>'
        },
        "kettle-outline": {
            body: '<path fill="currentColor" d="M12.5 3C7.8 3 4 5.7 4 9c0 1.2.5 2.3 1.4 3.3A6.8 6.8 0 0 0 4 16.5V20c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2v-3.5c0-1.2-.3-2.4-1-3.5l2-2l-3-3l-2.1 2.1a9.2 9.2 0 0 0-9.3.3A2 2 0 0 1 7 9c0-1.8 2.5-3.3 5.5-3.3c1.4 0 2.8.4 3.8 1l2-2A10 10 0 0 0 12.5 3m0 8c3.5 0 6.5 3 6.5 5.5V20H6v-3.5C6 14 9 11 12.5 11m.5 1.5c-3 0-5 1.5-5 4.5v1h2v-1c0-1 0-3.5 3-4.5Z"/>'
        },
        "kettle-pour-over": {
            body: '<path fill="currentColor" d="M10 4c-.6 0-1 .4-1 1v1h5V5c0-.6-.4-1-1-1h-3M3 7l1.1 7.1c.1.7.4 1.4 1 2c.4.5 1.1.8 1.9.9c0 .6.4 1 1 1h8c.6 0 1-.4 1-1l-2-6h2l3.3 5l1.7-1l-3.3-5l1.3-.8l-1-1.7L16.4 9H15V7H8v4l-.8 5c-.7-.1-1.1-.3-1.4-.6c-.4-.4-.6-.9-.7-1.5L4 7H3m1 12v2h16v-2H4Z"/>'
        },
        "kettle-steam": {
            body: '<path fill="currentColor" d="m19 11l-3-3l-2.1 2.1A9.231 9.231 0 0 0 9.5 9c-1.85 0-3.55.53-4.95 1.41C4.19 9.97 4 9.5 4 9c0-1.79 2.46-3.25 5.5-3.25c1.43 0 2.8.33 3.83.92l2.02-2.02C13.77 3.59 11.68 3 9.5 3C4.81 3 1 5.69 1 9c0 1.19.5 2.34 1.44 3.33A6.797 6.797 0 0 0 1 16.5V20c0 1.11.89 2 2 2h13c1.11 0 2-.89 2-2v-3.5c0-1.22-.34-2.43-1-3.5l2-2M5 17.5V20H3v-2.5A6.5 6.5 0 0 1 9.5 11c.34 0 .67.04 1 .09c-3.11.48-5.5 3.16-5.5 6.41M23 7.3c0 1.63-1.09 3.3-2.62 3.67l-.67-.68L19 9.6h.75c1 0 1.75-1.38 1.75-2.4s-.85-2.06-1.85-2.06v-1.5C21.5 3.64 23 5.45 23 7.3m-5.35-.57c-.62-.61-1-1.45-1-2.38C16.65 2.5 18.15 1 20 1v1.5c-1 0-1.85.83-1.85 1.85S19 6.2 20 6.2v1.5c-.82 0-1.58.25-2.21.68l-1.07-1.07c.28-.22.6-.42.93-.58Z"/>'
        },
        "kettle-steam-outline": {
            body: '<path fill="currentColor" d="M9.5 3C4.8 3 1 5.7 1 9c0 1.2.5 2.3 1.4 3.3C1.5 13.5.985 15 1 16.5V20c0 1.1.9 2 2 2h13c1.11 0 2-.89 2-2v-3.5c0-1.2-.3-2.4-1-3.5l2-2l-3-3l-2.1 2.1a9.191 9.191 0 0 0-9.3.3C4.22 10.03 4 9.53 4 9c0-1.8 2.5-3.3 5.5-3.3c1.4 0 2.8.4 3.8 1l2-2A10.05 10.05 0 0 0 9.5 3m0 8c3.5 0 6.5 3 6.5 5.5V20H3v-3.5C3 14 6 11 9.5 11m.5 1.5c-3 0-5 1.5-5 4.5v1h2v-1c0-1 0-3.5 3-4.5m13-5.2c0 1.63-1.09 3.3-2.62 3.67l-.67-.68L19 9.6h.75c1 0 1.75-1.38 1.75-2.4s-.85-2.06-1.85-2.06v-1.5C21.5 3.64 23 5.45 23 7.3m-5.35-.57c-.62-.61-1-1.45-1-2.38C16.65 2.5 18.15 1 20 1v1.5c-1 0-1.85.83-1.85 1.85S19 6.2 20 6.2v1.5c-.82 0-1.58.25-2.21.68l-1.07-1.07c.28-.22.6-.42.93-.58Z"/>'
        },
        kettlebell: {
            body: '<path fill="currentColor" d="m16.2 10.7l.6-2.4c.1-.3.5-1.7-.3-2.9C15.9 4.5 14.7 4 13 4h-2c-1.7 0-2.9.5-3.5 1.4c-.8 1.2-.4 2.5-.3 2.9l.6 2.4C6.7 11.8 6 13.3 6 15c0 2.1 1.1 3.9 2.7 5h6.6c1.6-1.1 2.7-2.9 2.7-5c0-1.7-.7-3.2-1.8-4.3M9.6 9.5l-.5-1.7v-.1s-.2-.7.1-1.1c.2-.4.8-.6 1.8-.6h2c.9 0 1.6.2 1.9.5c.3.4.1 1.1.1 1.1l-.5 1.9c-.8-.3-1.6-.5-2.5-.5c-.9 0-1.7.2-2.4.5Z"/>'
        },
        key: {
            body: '<path fill="currentColor" d="M7 14c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m5.6-4c-.8-2.3-3-4-5.6-4c-3.3 0-6 2.7-6 6s2.7 6 6 6c2.6 0 4.8-1.7 5.6-4H16v4h4v-4h3v-4H12.6Z"/>'
        },
        "key-alert": {
            body: '<path fill="currentColor" d="M4 6.5C4 4 6 2 8.5 2S13 4 13 6.5c0 1.96-1.25 3.63-3 4.24V15h3v3h-3v4H7V10.74c-1.75-.61-3-2.28-3-4.24m3 0C7 7.33 7.67 8 8.5 8S10 7.33 10 6.5S9.33 5 8.5 5S7 5.67 7 6.5M18 7h2v6h-2m0 4h2v-2h-2"/>'
        },
        "key-alert-outline": {
            body: '<path fill="currentColor" d="M16 22h-4v2H6V13.32C3.58 12.17 2 9.72 2 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.72-1.58 5.18-4 6.32V16h4v6m-2-4h-4v-6.06l.67-.23C12.66 11 14 9.11 14 7c0-2.76-2.24-5-5-5S4 4.24 4 7c0 2.11 1.34 4 3.33 4.71l.67.23V22h2v-2h4v-2M12 7c0 1.66-1.34 3-3 3S6 8.66 6 7s1.34-3 3-3s3 1.34 3 3M9 8c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m11-1h2v6h-2m0 4h2v-2h-2"/>'
        },
        "key-arrow-right": {
            body: '<path fill="currentColor" d="M11.7 6c-.6-1.8-2.3-3-4.2-3C5 3 3 5 3 7.5S5 12 7.5 12c2 0 3.6-1.2 4.2-3H15v3h3V9h3V6h-9.3M7.5 9C6.7 9 6 8.3 6 7.5S6.7 6 7.5 6S9 6.7 9 7.5S8.3 9 7.5 9M13 21v-2H8v-2h5v-2l3 3l-3 3"/>'
        },
        "key-chain": {
            body: '<path fill="currentColor" d="M12.67 13.67c-.47.46-1.04.83-1.67 1.06V23H8v-2H5v-3h3v-3.28c-1.74-.62-3-2.26-3-4.22C5 8 7 6 9.5 6h.1c-.47.95-.68 2-.57 3.08c-.59.2-1.03.76-1.03 1.42c0 .83.67 1.5 1.5 1.5c.23 0 .45-.06.65-.15c.64.84 1.52 1.47 2.52 1.82m8.06 5.77l-2.76 1.16l-.78-1.84l-2.76 1.17l-1.17-2.77L16.03 16l-1.27-3c-1.85.08-3.65-.95-4.41-2.75c-.96-2.29.12-4.93 2.41-5.9c.24-.1.5-.17.74-.23C12.84 2.87 11.5 2 10 2C7.79 2 6 3.79 6 6v.24c-.3.26-.6.58-.85.91C5.06 6.78 5 6.4 5 6c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.42-.6 2.67-1.55 3.57c.42.43 1.05.56 1.63.31c.77-.32 1.12-1.2.8-1.96a.939.939 0 0 0-.14-.26C15.9 7.13 16 6.58 16 6c0-.63-.1-1.24-.28-1.81c1.28.36 2.38 1.25 2.93 2.57c.76 1.8.24 3.81-1.15 5.05l3.23 7.63M13 8.6c.37-.41.65-.89.82-1.42c-.54.27-.85.82-.82 1.42Z"/>'
        },
        "key-chain-variant": {
            body: '<path fill="currentColor" d="M12.66 13.67c-.34.33-.73.62-1.16.83V21l-2 2l-2-2l2-1.71L8 18l1.5-1.29l-2-1.71v-.5a4.42 4.42 0 0 1-2.5-4C5 8 7 6 9.5 6h.11c-.02.07-.07.12-.11.18c-.27.61-.42 1.25-.47 1.9A1.498 1.498 0 0 0 9.5 11h.1c.64 1.25 1.74 2.2 3.06 2.67M16 6c0-.63-.1-1.25-.28-1.82c1.34.38 2.49 1.37 3.01 2.78c.6 1.66.16 3.43-.98 4.63L20 17.68l-1.22 2.57l-2.56-1.2l1.28-2.29l-1.84-.7l.97-1.72l-2.47-.93l-.16-.46a4.48 4.48 0 0 1-3.73-2.91a4.51 4.51 0 0 1 2.69-5.77c.18-.06.37-.1.54-.14A3.946 3.946 0 0 0 10 2C7.79 2 6 3.79 6 6c0 .09 0 .17.03.26c-.33.27-.63.56-.88.89C5.06 6.78 5 6.4 5 6c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.16-.4 2.21-1.06 3.06C16.08 8.88 16 6 16 6m-3.19 2.1c.06.17.15.31.25.44c.56-.66.91-1.5.94-2.43c-.11.02-.2.04-.3.07c-.78.29-1.2 1.15-.89 1.92Z"/>'
        },
        "key-change": {
            body: '<path fill="currentColor" d="M7.5 2c2 0 3.6 1.2 4.2 3H21v3h-3v3h-3V8h-3.3c-.6 1.8-2.3 3-4.2 3C5 11 3 9 3 6.5S5 2 7.5 2m0 3C6.7 5 6 5.7 6 6.5S6.7 8 7.5 8S9 7.3 9 6.5S8.3 5 7.5 5m0 8c2 0 3.6 1.2 4.2 3H21v3h-1v3h-2v-3h-2v3h-3v-3h-1.3c-.6 1.8-2.3 3-4.2 3C5 22 3 20 3 17.5S5 13 7.5 13m0 3c-.8 0-1.5.7-1.5 1.5S6.7 19 7.5 19S9 18.3 9 17.5S8.3 16 7.5 16Z"/>'
        },
        "key-link": {
            body: '<path fill="currentColor" d="M7.5 3C5 3 3 5 3 7.5S5 12 7.5 12c2 0 3.6-1.2 4.2-3H15v3h3V9h3V6h-9.3c-.6-1.8-2.2-3-4.2-3m0 3C8.3 6 9 6.7 9 7.5S8.3 9 7.5 9S6 8.3 6 7.5S6.7 6 7.5 6m2.5 8c-1.6 0-4 1.1-4 4s2.4 4 4 4h1v-2h-1c-.3 0-2-.1-2-2c0-1.8 1.5-2 2-2h1v-2m2 0v2h1c.3 0 2 .1 2 2c0 1.8-1.5 2-2 2h-1v2h1c1.6 0 4-1.1 4-4s-2.4-4-4-4m-5 3v2h6v-2H9Z"/>'
        },
        "key-minus": {
            body: '<path fill="currentColor" d="M7.5 3c2 0 3.6 1.2 4.2 3H21v3h-3v3h-3V9h-3.3c-.6 1.8-2.3 3-4.2 3C5 12 3 10 3 7.5S5 3 7.5 3m0 3C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6M8 17h8v2H8v-2Z"/>'
        },
        "key-outline": {
            body: '<path fill="currentColor" d="M21 18h-6v-3h-1.7c-1.1 2.4-3.6 4-6.3 4c-3.9 0-7-3.1-7-7s3.1-7 7-7c2.7 0 5.2 1.6 6.3 4H24v6h-3v3m-4-2h2v-3h3v-2H11.9l-.2-.7C11 8.3 9.1 7 7 7c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.1 0 4-1.3 4.7-3.3l.2-.7H17v3M7 15c-1.7 0-3-1.3-3-3s1.3-3 3-3s3 1.3 3 3s-1.3 3-3 3m0-4c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1Z"/>'
        },
        "key-plus": {
            body: '<path fill="currentColor" d="M7.5 3c2 0 3.6 1.2 4.2 3H21v3h-3v3h-3V9h-3.3c-.6 1.8-2.3 3-4.2 3C5 12 3 10 3 7.5S5 3 7.5 3m0 3C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6M8 17h3v-3h2v3h3v2h-3v3h-2v-3H8v-2Z"/>'
        },
        "key-remove": {
            body: '<path fill="currentColor" d="M7.5 3c2 0 3.6 1.2 4.2 3H21v3h-3v3h-3V9h-3.3c-.6 1.8-2.3 3-4.2 3C5 12 3 10 3 7.5S5 3 7.5 3m0 3C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9S9 8.3 9 7.5S8.3 6 7.5 6m7.1 8l1.4 1.4l-2.6 2.6l2.6 2.6l-1.4 1.4l-2.6-2.6L9.4 22L8 20.6l2.6-2.6L8 15.4L9.4 14l2.6 2.6l2.6-2.6Z"/>'
        },
        "key-star": {
            body: '<path fill="currentColor" d="M7.5 3C5 3 3 5 3 7.5S5 12 7.5 12c2 0 3.6-1.2 4.2-3H15v3h3V9h3V6h-9.3c-.6-1.8-2.2-3-4.2-3m0 3C8.3 6 9 6.7 9 7.5S8.3 9 7.5 9S6 8.3 6 7.5S6.7 6 7.5 6m4.5 8l-1.1 2.6l-2.9.3l2.2 1.9l-.7 2.8l2.5-1.5l2.4 1.5l-.6-2.8l2.2-1.9l-2.9-.2L12 14Z"/>'
        },
        "key-variant": {
            body: '<path fill="currentColor" d="M22 18v4h-4v-3h-3v-3h-3l-2.26-2.26c-.55.17-1.13.26-1.74.26a6 6 0 0 1-6-6a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 .61-.09 1.19-.26 1.74L22 18M7 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "key-wireless": {
            body: '<path fill="currentColor" d="m4.9 5.9l1.4 1.4c3.1-3.1 8.2-3.1 11.3 0L19 5.9C15.2 2 8.8 2 4.9 5.9m2.9 2.9l1.4 1.4c1.6-1.6 4.1-1.6 5.7 0l1.4-1.4c-2.4-2.4-6.2-2.4-8.5 0m4 6.2c-.8-2.3-3.4-3.6-5.7-2.7S2.4 15.7 3.3 18s3.4 3.6 5.7 2.7c1.3-.5 2.3-1.5 2.7-2.7H15v3h3v-3h3v-3M7.5 18c-.8 0-1.5-.7-1.5-1.5S6.7 15 7.5 15s1.5.7 1.5 1.5S8.3 18 7.5 18Z"/>'
        },
        keyboard: {
            body: '<path fill="currentColor" d="M19 10h-2V8h2m0 5h-2v-2h2m-3-1h-2V8h2m0 5h-2v-2h2m0 6H8v-2h8m-9-5H5V8h2m0 5H5v-2h2m1 0h2v2H8m0-5h2v2H8m3 1h2v2h-2m0-5h2v2h-2m9-5H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z"/>'
        },
        "keyboard-backspace": {
            body: '<path fill="currentColor" d="M21 11H6.83l3.58-3.59L9 6l-6 6l6 6l1.41-1.42L6.83 13H21v-2Z"/>'
        },
        "keyboard-caps": {
            body: '<path fill="currentColor" d="M6 18h12v-2H6m6-7.59L16.59 13L18 11.58l-6-6l-6 6L7.41 13L12 8.41Z"/>'
        },
        "keyboard-close": {
            body: '<path fill="currentColor" d="m12 23l4-4H8M19 8h-2V6h2m0 5h-2V9h2m-3-1h-2V6h2m0 5h-2V9h2m0 6H8v-2h8M7 8H5V6h2m0 5H5V9h2m1 0h2v2H8m0-5h2v2H8m3 1h2v2h-2m0-5h2v2h-2m9-5H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "keyboard-esc": {
            body: '<path fill="currentColor" d="M1 7h6v2H3v2h4v2H3v2h4v2H1V7m10 0h4v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2H9v-2h4v-2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2m8 0h2a2 2 0 0 1 2 2v1h-2V9h-2v6h2v-1h2v1c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2Z"/>'
        },
        "keyboard-f1": {
            body: '<path fill="currentColor" d="M6 7h6v2H8v2h3v2H8v4H6V7m8 0h4v10h-2V9h-2V7Z"/>'
        },
        "keyboard-f10": {
            body: '<path fill="currentColor" d="M2 7h6v2H4v2h3v2H4v4H2V7m8 0h4v10h-2V9h-2V7m8 0h2a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2m0 2v6h2V9h-2Z"/>'
        },
        "keyboard-f11": {
            body: '<path fill="currentColor" d="M3 7h6v2H5v2h3v2H5v4H3V7m8 0h4v10h-2V9h-2V7m6 0h4v10h-2V9h-2V7Z"/>'
        },
        "keyboard-f12": {
            body: '<path fill="currentColor" d="M2 7h6v2H4v2h3v2H4v4H2V7m14 0h4a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-2v2h4v2h-6v-4c0-1.1.9-2 2-2h2V9h-4V7m-6 0h4v10h-2V9h-2V7Z"/>'
        },
        "keyboard-f2": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m8 0h4a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-2v2h4v2h-6v-4c0-1.1.9-2 2-2h2V9h-4V7Z"/>'
        },
        "keyboard-f3": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m14 8c0 1.11-.89 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 0 1 2 2v1.5c0 .83-.67 1.5-1.5 1.5c.83 0 1.5.67 1.5 1.5V15Z"/>'
        },
        "keyboard-f4": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m8 0h2v4h2V7h2v10h-2v-4h-4V7Z"/>'
        },
        "keyboard-f5": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m8 0h6v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-4v-2h4v-2h-4V7Z"/>'
        },
        "keyboard-f6": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m10 0h4v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2m0 6v2h2v-2h-2Z"/>'
        },
        "keyboard-f7": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m10 10h-2l4-8h-4V7h6v2l-4 8Z"/>'
        },
        "keyboard-f8": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m10 6v2h2v-2h-2m0-4v2h2V9h-2m0 8a2 2 0 0 1-2-2v-1.5c0-.83.67-1.5 1.5-1.5c-.83 0-1.5-.67-1.5-1.5V9c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1.5c0 .83-.67 1.5-1.5 1.5c.83 0 1.5.67 1.5 1.5V15c0 1.11-.89 2-2 2h-2Z"/>'
        },
        "keyboard-f9": {
            body: '<path fill="currentColor" d="M5 7h6v2H7v2h3v2H7v4H5V7m12 10h-4v-2h4v-2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2m0-6V9h-2v2h2Z"/>'
        },
        "keyboard-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L20 20.72L18.73 22l-3-3H4a2 2 0 0 1-2-2V7c0-.5.18-.93.46-1.27L1 4.27M19 10V8h-2v2h2m0 3v-2h-2v2h2m-3-3V8h-2v2h2m0 3v-2h-2v1.18L11.82 10H13V8h-2v1.18L9.82 8l-3-3H20a2 2 0 0 1 2 2v10c0 .86-.54 1.59-1.3 1.87L14.82 13H16m-8 2v2h5.73l-2-2H8m-3-5h1.73L5 8.27V10m2 3v-2H5v2h2m1 0h1.73L8 11.27V13Z"/>'
        },
        "keyboard-off-outline": {
            body: '<path fill="currentColor" d="m1 4.27l1.47 1.47A1.9 1.9 0 0 0 2 7v10a2 2 0 0 0 2 2h11.73l3 3L20 20.72L2.28 3L1 4.27M4 17V7.27l1 1V10h1.73L8 11.27V13h1.73l1 1H8v2h4.73l1 1H4m1-6h2v2H5v-2m12 0h2v2h-2v-2m2-1h-2V8h2v2m-5 1h2v2h-1.17l-.83-.83V11m-1-1h-1.17L11 9.17V8h2v2m9-3v10c0 .86-.55 1.58-1.3 1.87L18.83 17H20V7H8.83l-2-2H20a2 2 0 0 1 2 2m-6 3h-2V8h2v2Z"/>'
        },
        "keyboard-outline": {
            body: '<path fill="currentColor" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m0 2h16v10H4V7m1 1v2h2V8H5m3 0v2h2V8H8m3 0v2h2V8h-2m3 0v2h2V8h-2m3 0v2h2V8h-2M5 11v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2m-9 3v2h8v-2H8Z"/>'
        },
        "keyboard-return": {
            body: '<path fill="currentColor" d="M19 7v4H5.83l3.58-3.59L8 6l-6 6l6 6l1.41-1.42L5.83 13H21V7h-2Z"/>'
        },
        "keyboard-settings": {
            body: '<path fill="currentColor" d="M19 10h-2V8h2m0 5h-2v-2h2m-3-1h-2V8h2m0 5h-2v-2h2m0 6H8v-2h8m-9-5H5V8h2m0 5H5v-2h2m1 0h2v2H8m0-5h2v2H8m3 1h2v2h-2m0-5h2v2h-2m9-5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "keyboard-settings-outline": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m0 2h16v10H4V7m1 1v2h2V8H5m3 0v2h2V8H8m3 0v2h2V8h-2m3 0v2h2V8h-2m3 0v2h2V8h-2M5 11v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2m-9 3v2h8v-2H8Z"/>'
        },
        "keyboard-space": {
            body: '<path fill="currentColor" d="M3 15h2v4h14v-4h2v4c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-4Z"/>'
        },
        "keyboard-tab": {
            body: '<path fill="currentColor" d="M20 18h2V6h-2m-8.41 1.41L15.17 11H1v2h14.17l-3.58 3.58L13 18l6-6l-6-6l-1.41 1.41Z"/>'
        },
        "keyboard-tab-reverse": {
            body: '<path fill="currentColor" d="M4 6H2v12h2m7-12l-6 6l6 6l1.41-1.42L8.83 13H23v-2H8.83l3.58-3.59L11 6Z"/>'
        },
        "keyboard-variant": {
            body: '<path fill="currentColor" d="M6 16h12v2H6v-2m0-3v2H2v-2h4m1 2v-2h3v2H7m4 0v-2h2v2h-2m3 0v-2h3v2h-3m4 0v-2h4v2h-4M2 10h3v2H2v-2m17 2v-2h3v2h-3m-1 0h-2v-2h2v2M8 12H6v-2h2v2m4 0H9v-2h3v2m3 0h-2v-2h2v2M2 9V7h2v2H2m3 0V7h2v2H5m3 0V7h2v2H8m3 0V7h2v2h-2m3 0V7h2v2h-2m3 0V7h5v2h-5Z"/>'
        },
        khanda: {
            body: '<path fill="currentColor" d="M16 20c3.72-2 6-4.73 6-8c0-2.66-1.54-5.1-4.11-7h-.07a7.533 7.533 0 0 1 1.86 5c0 3-1.68 5-4.18 6.83c0 .01-1.12.71-2.5 1.58v-1.08L15 16s-.2-.6-.42-1.54C16.6 13.58 18 11.69 18 9.5c0-2.16-1.36-4.03-3.35-4.93C14.84 3.63 15 3 15 3l-3-2l-3 2s.16.63.35 1.57C7.37 5.47 6 7.34 6 9.5c0 2.19 1.4 4.08 3.42 4.96C9.2 15.4 9 16 9 16l2 1.33v1.08c-1.38-.87-2.5-1.57-2.5-1.58C6 15 4.32 13 4.32 10c0-1.91.68-3.65 1.86-5h-.06C3.54 6.9 2 9.34 2 12c0 3.27 2.29 6 6 8l1-1.5l1.92 1.23L7.34 22L8 23l3-1.93V23h2v-1.93L16 23l.66-1l-3.58-2.27L15 18.5l1 1.5m.75-10.5c0 1.59-.99 2.96-2.44 3.69c-.17-.96-.31-2.07-.31-3.19c0-1.33.2-2.85.42-4.14c1.39.74 2.33 2.09 2.33 3.64m-9.5 0c0-1.55.94-2.9 2.34-3.64C9.8 7.15 10 8.67 10 10c0 1.12-.14 2.23-.31 3.19c-1.45-.73-2.44-2.1-2.44-3.69Z"/>'
        },
        kickstarter: {
            body: '<path fill="currentColor" d="M19.3 10.2L17.5 12l1.8 1.8a4.774 4.774 0 0 1 0 6.79c-1.88 1.87-4.95 1.87-6.83 0l-.67-.66A4.77 4.77 0 0 1 7.83 22C5.16 22 3 19.85 3 17.2V6.8C3 4.15 5.16 2 7.83 2c1.67 0 3.1.82 3.97 2.07l.67-.66c1.88-1.87 4.95-1.87 6.83 0a4.774 4.774 0 0 1 0 6.79Z"/>'
        },
        kite: {
            body: '<path fill="currentColor" d="M13.69 3.46c-.34-.31-.73-.46-1.19-.46c-.45 0-.84.15-1.17.46L5.54 9.08c-.31.3-.48.67-.54 1.12c0 .44.08.84.33 1.2l6.12 8.43c-.25.53-.7.79-1.36.79c-.8 0-1.3-.37-1.49-1.12c-.2-.66-.6-1.23-1.22-1.7c-.62-.46-1.28-.7-1.97-.7c-1.05 0-1.91.4-2.56 1.2l1.36 1.12c.29-.39.71-.58 1.2-.58c.8 0 1.3.37 1.49 1.11c.19.67.6 1.24 1.22 1.72s1.28.73 1.97.73c1.24 0 2.19-.57 2.85-1.7l6.74-9.31c.25-.35.35-.75.32-1.19c-.05-.45-.23-.82-.53-1.12l-5.78-5.62Z"/>'
        },
        "kite-outline": {
            body: '<path fill="currentColor" d="m12.5 5.1l5.45 5.28l-5.45 7.5l-5.43-7.5L12.5 5.1m0-2.1c-.45 0-.84.15-1.17.46L5.54 9.08c-.31.3-.48.67-.54 1.12c0 .44.08.84.33 1.2l6.12 8.43c-.25.53-.7.79-1.36.79c-.8 0-1.3-.37-1.49-1.12c-.2-.66-.6-1.23-1.22-1.7c-.62-.46-1.28-.7-1.97-.7c-1.05 0-1.91.4-2.56 1.2l1.36 1.12c.29-.39.71-.58 1.2-.58c.8 0 1.3.37 1.49 1.11c.19.67.6 1.24 1.22 1.72s1.28.73 1.97.73c1.24 0 2.19-.57 2.85-1.7l6.74-9.3c.25-.36.35-.76.32-1.2c-.05-.44-.23-.82-.53-1.12l-5.79-5.62c-.33-.31-.72-.46-1.18-.46Z"/>'
        },
        kitesurfing: {
            body: '<path fill="currentColor" d="m16.5 4.5l-1-1.07L17.92 1H20l-3.5 3.5M20.96 23c-1.06 0-2.06-.25-3-.75c-1.84 1-4.15 1-5.99 0c-1.84 1-4.15 1-5.97 0c-1.23.69-2.64.8-4 .75v-2c1.41.05 2.77-.1 4-1c1.74 1.25 4.21 1.25 5.97 0c1.77 1.25 4.23 1.25 5.99 0c1.21.9 2.58 1.05 3.98 1v2h-.98m-.61-10.74c-2.05-.76-4.21.35-6.27 1.1l-1.69-1.86H9.58V8c2.31.19 4.71-.33 6.32-2.04l-1.4-1.4C13.6 5.46 12.3 6 11 6H8c-1.11 0-2.05.92-2 2c.07 1.35-.33 4.73.45 5.87L8 16.82c-.57.41-1.07.8-1.5 1.18c1.59 1.5 4.15 1.17 5.47-.5c.94 1.09 2.48 1.8 3.93 1.33c1.55-1.06 6.84-4.83 4.45-6.57m-8.92 2.39c-.43.24-1.27.72-1.61.96l-.85-2.02l2.49-.09l.7.75l-.73.4M8 1c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2Z"/>'
        },
        klingon: {
            body: '<path fill="currentColor" d="m4.79 21.5l-.08-.26c-.18-.59-.24-1.16-.21-1.84c.1-1.23.64-2.09 1.32-2.81a6.28 6.28 0 0 1-.29-1.85c0-1.74.73-3.3 1.92-4.44c.88-.84 2.01-1.44 3.26-1.7c.66-2.37 1.09-4.8 1.29-7.1c.24 2 .65 4.62 1.3 7.08a6.6 6.6 0 0 1 3.37 1.72c1.18 1.14 1.92 2.7 1.92 4.44c0 .61-.09 1.19-.26 1.76c.88.42 1.87.67 3.17.79l-.06.15c-.12.33-.44.56-.73.74l-.02.01c-.56.38-1.51.81-2.84.81h-.44c-.18 0-.35-.03-.51-.05c-.07.05-.15.15-.23.23C15.5 20.31 13.86 21 12.06 21c-1.79 0-3.42-.69-4.6-1.82l-.12-.12c-1 .53-1.8 1.27-2.4 2.21l-.14.23m1.7-5.56c.15-.12 1.7-1.44 2.13-2.16l.1-.17c.92 1.39 1.67 2.67 2.7 4.47l-.21.01c-1.14.07-2.17.28-3.07.61c1.02.92 2.4 1.49 3.91 1.49c1.48 0 2.82-.54 3.83-1.42c-.25-.05-.5-.12-.74-.18c-.77-.18-1.5-.37-2.34-.4l-.19-.01l.08-.18c.4-.8 2.1-3.59 2.53-4.37l.11.18c.66.96 1.39 1.69 2.24 2.26c.11-.43.17-.87.17-1.32c0-1.5-.64-2.86-1.66-3.85a5.616 5.616 0 0 0-2.54-1.4c.3 1 .65 2 1.04 2.85l.03.05l-.03.06c-.39.76-.83 1.49-1.26 2.2c-.39.64-.79 1.3-1.15 1.98l-.1.19l-.12-.18c-.57-.83-2.21-3.59-2.55-4.15c.4-1 .74-2 1.04-3c-.95.28-1.75.76-2.42 1.4a5.297 5.297 0 0 0-1.66 3.84c0 .42.05.82.13 1.21"/>'
        },
        knife: {
            body: '<path fill="currentColor" d="M20.62 2c3.35 5.61-8.15 18.15-8.15 18.15L9.6 17.28L4.91 22l-2.14-2.14L20.62 2Z"/>'
        },
        "knife-military": {
            body: '<path fill="currentColor" d="m22 2l-4.61 1.75l-6.93 6.93L14 14.22l6.92-6.93C22.43 5.78 22 2 22 2M8.33 10l-1.41 1.39l1.41 1.41l-5.65 5.66L6.21 22l5.66-5.66l1.41 1.42l1.42-1.42L8.33 10Z"/>'
        },
        knob: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m1 8h-2V4.1c.3-.1.7-.1 1-.1s.7 0 1 .1V10Z"/>'
        },
        koala: {
            body: '<path fill="currentColor" d="M19 3c-.9 0-3.5 0-4.7 3.1c-.4-.1-.9-.1-1.3-.1h-2c-.4 0-.9 0-1.3.1C8.5 3 5.9 3 5 3C4 3 1 4 1 9c0 3.6 2.5 4.6 4 4.9V15c0 3.3 2.7 6 6 6h2c3.3 0 6-2.7 6-6v-1.1c1.5-.3 4-1.3 4-4.9c0-5-3-6-4-6M5 12v.4c-2.1-.6-1.7-2.9-.7-3.7C4 8.3 3 9 3 8.6c0-.5 1.8-1.2 2.1-1.3c-.3-.5-1.5-.3-1.5-.7c0-.3 1.2-.8 2.2-.6c.5.1 1.1.3 1.6.7C6 8 5 9.8 5 12m3.5 3c-2 0-2-3 0-3s2 3 0 3m4 3h-1c-.7 0-1.2-.7-.9-1.3l.7-3c.1-.4.5-.6.8-.7c.3 0 .6.2.8.7l.7 3c.1.6-.4 1.3-1.1 1.3m3-3c-2 0-2-3 0-3s2 3 0 3m4.2-6.4c1 .8 1.4 3.1-.7 3.7c.1-2.2-.9-4.3-2.4-5.6c.5-.4 1.1-.6 1.6-.7c1-.2 2.2.2 2.2.6c0 .4-1.2.2-1.5.6c.3.2 2.1.9 2.1 1.4c0 .4-.9-.3-1.3 0Z"/>'
        },
        kodi: {
            body: '<path fill="currentColor" d="M12.03 1c-.21 0-.43.11-.62.31L8.88 3.84c-.22.22-.28.34-.5.54c-.29.24-.42.53-.41.9C8 6.57 8 7.84 8 9.13v4.03c0 .1 0 .18.03.28c.08.31.28.38.5.15c1.2-1.2 2.27-2.29 3.47-3.5c1.36-1.36 2.73-2.72 4.09-4.09c.41-.4.41-.85 0-1.25c-1.15-1.15-2.32-2.28-3.46-3.44c-.2-.2-.39-.31-.6-.31m6.63 6.66c-.21 0-.41.09-.6.28c-1.15 1.16-2.31 2.3-3.47 3.47c-.39.39-.39.82 0 1.22c1.15 1.15 2.29 2.31 3.44 3.46c.4.41.82.41 1.22 0c1.11-1.09 2.25-2.22 3.34-3.34c.17-.17.34-.33.41-.56v-.31c-.07-.24-.24-.38-.41-.57c-1.12-1.12-2.22-2.25-3.34-3.37c-.19-.19-.39-.28-.59-.28m-13.88.43c-.13-.05-.2.05-.28.13c-1.15 1.17-2.16 2.21-3.31 3.37c-.26.27-.26.65 0 .91c.62.63 1.25 1.25 1.87 1.88c.54.54.94.95 1.5 1.5c.16.15.3.12.38-.07c.06-.1.06-.23.06-.34V8.63c0-.08 0-.18-.03-.25c-.02-.13-.07-.24-.19-.29m7.31 6.16c-.2 0-.43.09-.62.28c-1.15 1.16-2.29 2.34-3.44 3.5c-.4.4-.4.82 0 1.22c1.11 1.12 2.23 2.22 3.35 3.34c.16.17.33.34.56.41h.28c.22-.06.4-.21.56-.37c1.12-1.13 2.25-2.25 3.38-3.38c.39-.4.34-.85-.03-1.25c-1.16-1.16-2.29-2.31-3.44-3.47c-.19-.19-.39-.28-.6-.28Z"/>'
        },
        kubernetes: {
            body: '<path fill="currentColor" d="M13.95 13.5h-.23c-.18.11-.26.32-.18.5l.86 2.11c.83-.53 1.46-1.32 1.79-2.25l-2.23-.36h-.01m-3.45.29a.415.415 0 0 0-.38-.29h-.08l-2.22.37c.33.92.96 1.7 1.79 2.23l.85-2.07V14c.04-.05.04-.14.04-.21m1.83.81a.378.378 0 0 0-.51-.15c-.07.05-.12.08-.15.15h-.01l-1.09 1.97c.78.26 1.62.31 2.43.12c.14-.03.29-.07.43-.12l-1.09-1.97h-.01m3.45-4.57L14.1 11.5l.01.03a.37.37 0 0 0-.04.53c.05.06.11.1.18.12l.01.01l2.17.62c.07-.97-.14-1.95-.65-2.78m-3.11.16c.01.21.18.37.39.36c.08 0 .15-.02.21-.05h.01l1.83-1.31a4.45 4.45 0 0 0-2.57-1.24l.13 2.24m-1.94.31c.17.11.4.08.52-.09c.05-.06.07-.13.08-.21h.01l.12-2.25c-.15.02-.3.05-.46.08c-.8.18-1.54.58-2.12 1.16l1.84 1.31h.01m-.99 1.69c.2-.05.32-.26.26-.46c0-.08-.05-.14-.11-.19v-.01L8.21 10c-.52.86-.74 1.84-.63 2.82l2.16-.62v-.01m1.64.66l.62.3l.62-.3l.15-.67l-.43-.53h-.69l-.43.53l.16.67m10.89 1.32L20.5 6.5c-.09-.42-.37-.76-.74-.94l-7.17-3.43c-.37-.17-.81-.17-1.19 0L4.24 5.56c-.37.18-.65.52-.74.94l-1.77 7.67c-.05.2-.05.4 0 .59c.01.06.03.12.05.18c.03.09.08.19.13.27c.03.04.05.08.09.11l4.95 6.18c.02 0 .05.04.05.06c.1.09.19.16.28.22c.12.08.26.14.4.17c.11.05.23.05.32.05h8.12c.07 0 .14-.03.2-.05c.05-.01.1-.03.14-.04c.04-.02.07-.03.11-.05c.05-.02.1-.05.15-.08c.12-.08.23-.18.33-.28l.15-.2l4.8-5.98c.1-.12.17-.25.22-.38c.02-.06.04-.12.05-.18c.05-.19.05-.4 0-.59m-7.43 2.99c.02.06.04.12.07.17c-.04.08-.06.17-.03.26c.12.24.23.46.38.68c.08.11.16.23.24.34c0 .03.03.08.04.12c.12.2.06.46-.15.59s-.47.05-.59-.15c-.01-.03-.02-.05-.03-.08c-.02-.03-.04-.09-.06-.09c-.05-.15-.09-.28-.12-.41c-.09-.25-.17-.49-.3-.72a.375.375 0 0 0-.21-.14l-.08-.16c-1.29.48-2.7.48-3.97-.01l-.1.18c-.07.01-.14.04-.19.09c-.14.24-.24.49-.33.77c-.03.13-.07.26-.12.4c-.02 0-.04.07-.06.1a.43.43 0 0 1-.81-.29c.01-.03.03-.05.04-.08c.04-.03.04-.08.04-.11c.09-.12.16-.23.24-.35c.16-.21.29-.45.39-.69a.54.54 0 0 0-.03-.25l.07-.18a5.611 5.611 0 0 1-2.47-3.09l-.2.03a.388.388 0 0 0-.23-.09c-.27.05-.51.13-.77.22c-.11.06-.24.11-.37.15c-.03.01-.07.02-.13.03a.438.438 0 0 1-.54-.27c-.07-.23.04-.47.28-.55c.02 0 .05-.01.08-.01v-.01h.01l.11-.02c.14-.04.28-.04.41-.04c.26 0 .52-.06.77-.12c.08-.05.14-.11.19-.19l.19-.05c-.21-1.36.1-2.73.86-3.87l-.14-.12c0-.09-.03-.18-.08-.25c-.2-.17-.41-.32-.64-.45c-.12-.06-.24-.13-.36-.21c-.02-.02-.06-.05-.08-.07l-.01-.01c-.2-.16-.25-.42-.11-.63c.09-.1.21-.15.35-.15c.11.01.21.05.3.12l.09.07c.1.09.19.2.28.3c.18.19.37.37.58.52c.08.04.17.05.26.03l.15.11c.75-.8 1.73-1.36 2.8-1.6c.25-.06.52-.1.78-.12l.01-.18a.45.45 0 0 0 .14-.23c.01-.26-.01-.52-.05-.77c-.03-.13-.05-.27-.06-.41V5.1c-.02-.24.15-.45.39-.48s.44.15.47.38v.22c-.01.14-.03.28-.06.41c-.04.25-.06.51-.05.77c.02.1.07.17.14.22l.01.19c1.36.12 2.62.73 3.56 1.72l.16-.12c.09.02.18.01.26-.03c.21-.15.41-.33.58-.52c.09-.1.18-.2.28-.3c.03-.02.07-.06.1-.06c.17-.18.44-.18.59 0c.19.16.18.43 0 .6c0 .02-.03.04-.06.06a2.495 2.495 0 0 1-.44.28c-.23.13-.45.28-.64.45c-.06.07-.09.15-.08.24l-.16.14a5.44 5.44 0 0 1 .88 3.86l.19.05c.04.08.11.14.19.18c.25.07.51.11.77.14h.41c.03.03.08.04.12.05c.24.03.4.25.37.49c-.05.23-.24.4-.48.37c-.03-.01-.07-.01-.07-.02v-.01c-.06 0-.1-.01-.14-.02c-.13-.04-.25-.09-.36-.15c-.26-.1-.5-.17-.77-.21c-.09 0-.17 0-.23.08c-.07-.01-.13-.02-.19-.03c-.41 1.31-1.31 2.41-2.47 3.11Z"/>'
        },
        label: {
            body: '<path fill="currentColor" d="M17.63 5.84C17.27 5.33 16.67 5 16 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11c.67 0 1.27-.34 1.63-.85L22 12l-4.37-6.16Z"/>'
        },
        "label-multiple": {
            body: '<path fill="currentColor" d="M4 19h9l-2 2H4c-.5 0-1.03-.21-1.41-.59C2.21 20.03 2 19.5 2 19V9h2v10M17.63 5.84C17.27 5.33 16.67 5 16 5H8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c.67 0 1.27-.34 1.63-.85L22 11l-4.37-5.16Z"/>'
        },
        "label-multiple-outline": {
            body: '<path fill="currentColor" d="M4 18h9l-2 2H4c-.5 0-1.03-.21-1.41-.59C2.21 19.03 2 18.5 2 18V8h2v10M17.63 4.84C17.27 4.33 16.67 4 16 4H8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c.67 0 1.27-.34 1.63-.85L22 10l-4.37-5.16M16 14H8V6h8l3.55 4Z"/>'
        },
        "label-off": {
            body: '<path fill="currentColor" d="M2 4.27L3.28 3L20 19.72L18.73 21l-2.1-2.1c-.2.06-.41.1-.63.1H5a2 2 0 0 1-2-2V7c0-.5.17-.93.46-1.27L2 4.27m15.63 1.57L22 12l-3 4.2L7.83 5H16c.67 0 1.27.33 1.63.84Z"/>'
        },
        "label-off-outline": {
            body: '<path fill="currentColor" d="M2 4.27L3.28 3L20 19.72L18.73 21l-2.1-2.1c-.2.06-.41.1-.63.1H5a2 2 0 0 1-2-2V7c0-.5.17-.93.46-1.27L2 4.27M5 17h9.73L5 7.27V17m14.55-5L16 7H9.82L7.83 5H16c.67 0 1.27.33 1.63.84L22 12l-3 4.2l-1.41-1.44L19.55 12Z"/>'
        },
        "label-outline": {
            body: '<path fill="currentColor" d="M16 17H5V7h11l3.55 5m-1.92-6.16C17.27 5.33 16.67 5 16 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11c.67 0 1.27-.34 1.63-.85L22 12l-4.37-6.16Z"/>'
        },
        "label-percent": {
            body: '<path fill="currentColor" d="M17.63 5.84C17.27 5.33 16.67 5 16 5H5c-1.1 0-2 .9-2 2v10a2 2 0 0 0 2 2h11c.67 0 1.27-.34 1.63-.85L22 12l-4.37-6.16M8.45 8.03c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42m5.1 7.94c-.78 0-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42s1.42.64 1.42 1.42s-.64 1.42-1.42 1.42M8.2 16L7 14.8L13.8 8L15 9.2L8.2 16Z"/>'
        },
        "label-percent-outline": {
            body: '<path fill="currentColor" d="M16 17H5V7h11l3.55 5m-1.92-6.16C17.27 5.33 16.67 5 16 5H5c-1.1 0-2 .9-2 2v10a2 2 0 0 0 2 2h11c.67 0 1.27-.34 1.63-.85L22 12l-4.37-6.16M13.8 8L15 9.2L8.2 16L7 14.8m1.45-6.77c.78 0 1.42.64 1.42 1.42s-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42s.64-1.42 1.42-1.42m5.1 5.1c.78 0 1.42.64 1.42 1.42c0 .78-.64 1.42-1.42 1.42c-.78 0-1.42-.64-1.42-1.42c0-.78.64-1.42 1.42-1.42Z"/>'
        },
        "label-variant": {
            body: '<path fill="currentColor" d="m3.5 19l4.84-7L3.5 5h11c.67 0 1.22.3 1.63.86L20.5 12l-4.37 6.14c-.41.56-.96.86-1.63.86h-11Z"/>'
        },
        "label-variant-outline": {
            body: '<path fill="currentColor" d="M6.5 17H15l3.5-5L15 7H6.5l3.5 5l-3.5 5m8.5 2H3l4.5-7L3 5h12c.69 0 1.23.3 1.64.86L21 12l-4.36 6.14c-.41.56-.95.86-1.64.86Z"/>'
        },
        ladder: {
            body: '<path fill="currentColor" d="M14 1v2h-4V1H8v21h2v-2h4v2h2V1h-2m0 4v3h-4V5h4m0 5v3h-4v-3h4m-4 8v-3h4v3h-4Z"/>'
        },
        ladybug: {
            body: '<path fill="currentColor" d="M12 5c.74 0 1.47.1 2.15.29l1.63-2.83c.28-.46.89-.64 1.37-.36c.48.27.64.9.35 1.36L16 6.07A8.07 8.07 0 0 1 18.93 9H5.07A8.07 8.07 0 0 1 8 6.07L6.5 3.46a.978.978 0 0 1 .35-1.36c.48-.28 1.09-.1 1.37.36l1.63 2.83C10.53 5.1 11.26 5 12 5m8 8a8 8 0 0 1-7.25 7.97V10.5h6.85c.26.79.4 1.63.4 2.5M4 13c0-.87.14-1.71.4-2.5h6.85v10.47A8 8 0 0 1 4 13Z"/>'
        },
        lambda: {
            body: '<path fill="currentColor" d="m6 20l4.16-12.09L9.34 6H8V4h2c.42 0 .78.26.93.63L16.66 18H18v2h-2c-.43 0-.79-.27-.93-.64l-3.74-8.71L8.12 20H6Z"/>'
        },
        lamp: {
            body: '<path fill="currentColor" d="M8 2h8l4 12H4L8 2m3 13h2v5h5v2H6v-2h5v-5Z"/>'
        },
        "lamp-outline": {
            body: '<path fill="currentColor" d="m14.56 4l2.67 8H6.78l2.66-8h5.12M16 2H8L4 14h16L16 2m-5 13h2v5h5v2H6v-2h5v-5Z"/>'
        },
        lamps: {
            body: '<path fill="currentColor" d="m10 2l2 7H2l2-7m2 8h2v10h3v2H3v-2h3V10m14-2l2 7H12l2-7m2 8h2v4h3v2h-8v-2h3v-4Z"/>'
        },
        "lamps-outline": {
            body: '<path fill="currentColor" d="m8.5 4l.85 3h-4.7l.85-3h3M10 2H4L2 9h10l-2-7m-4 8h2v10h3v2H3v-2h3V10m12.5 0l.85 3h-4.7l.85-3h3M20 8h-6l-2 7h10l-2-7m-4 8h2v4h3v2h-8v-2h3v-4Z"/>'
        },
        lan: {
            body: '<path fill="currentColor" d="M10 2c-1.11 0-2 .89-2 2v3c0 1.11.89 2 2 2h1v2H2v2h4v2H5c-1.11 0-2 .89-2 2v3c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-3c0-1.11-.89-2-2-2H8v-2h8v2h-1c-1.11 0-2 .89-2 2v3c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-3c0-1.11-.89-2-2-2h-1v-2h4v-2h-9V9h1c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2h-4m0 2h4v3h-4V4M5 17h4v3H5v-3m10 0h4v3h-4v-3Z"/>'
        },
        "lan-check": {
            body: '<path fill="currentColor" d="M4 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2H1v2h12V9h-3c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H4m0 2h6v4H4V3m10 10c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h-3v2h12v-2h-3c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2h-6m0 2h6v4h-6v-4m-8.5 5.5l5-5L9 14l-3.5 3.5l-2-2L2 17l3.5 3.5Z"/>'
        },
        "lan-connect": {
            body: '<path fill="currentColor" d="M4 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2H1v2h12V9h-3c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H4m0 2h6v4H4V3M3 13v7h7v-2H5v-5H3m11 0c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h-3v2h12v-2h-3c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2h-6m0 2h6v4h-6v-4Z"/>'
        },
        "lan-disconnect": {
            body: '<path fill="currentColor" d="M4 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2H1v2h12V9h-3c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H4m0 2h6v4H4V3m10 10c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h-3v2h12v-2h-3c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2h-6m-10.12.46l-1.42 1.42L4.59 17l-2.13 2.12l1.42 1.42L6 18.41l2.12 2.13l1.42-1.42L7.41 17l2.13-2.12l-1.42-1.42L6 15.59l-2.12-2.13M14 15h6v4h-6v-4Z"/>'
        },
        "lan-pending": {
            body: '<path fill="currentColor" d="M4 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2H1v2h12V9h-3c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H4m0 2h6v4H4V3m-1 9v2h2v-2H3m11 1c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h-3v2h12v-2h-3c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2h-6M3 15v2h2v-2H3m11 0h6v4h-6v-4M3 18v2h2v-2H3m3 0v2h2v-2H6m3 0v2h2v-2H9Z"/>'
        },
        "land-fields": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-4.7 2C14.5 5.1 14 6.5 14 8h-4c0-1.6.8-3.1 2-4h3.3M14 14h-4c0-1.5-.5-2.9-1.3-4H12c1.2.9 2 2.4 2 4M4 4h5.3C8.5 5.1 8 6.5 8 8H4V4m0 6h2c1.2.9 2 2.3 2 4H4v-4m0 10v-4h5.3C8.5 17.1 8 18.5 8 20H4m6 0c0-1.6.8-3.1 2-4h3.3c-.8 1.1-1.3 2.5-1.3 4h-4m10 0h-4c0-1.6.8-3.1 2-4h2v4m0-6h-4c0-1.5-.5-2.9-1.3-4H20v4m0-6h-4c0-1.6.8-3.1 2-4h2v4Z"/>'
        },
        "land-plots": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M4 4h4v10H4V4m0 16v-4h4v4H4m16 0H10V10h10v10m0-12H10V4h10v4Z"/>'
        },
        "land-plots-circle": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7 5.5C13 5.6 14.6 4 16.5 4S20 5.6 20 7.5S18.4 11 16.5 11S13 9.4 13 7.5M4 4h7v7H4V4m0 16v-7h7v7H4m16 0h-7v-7h7v7Z"/>'
        },
        "land-plots-circle-variant": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 7c0 2.8-2.2 5-5 5s-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5M4 4h4v10H4V4m0 16v-4h4v4H4m16 0H10v-4h10v4Z"/>'
        },
        "land-rows-horizontal": {
            body: '<path fill="currentColor" d="M22 20V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2M4 6.5V4h16v2.5H4M4 11V8.5h16V11H4m0 4.5V13h16v2.5H4M4 20v-2.5h16V20H4Z"/>'
        },
        "land-rows-vertical": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6.5 20H4V4h2.5v16m4.5 0H8.5V4H11v16m4.5 0H13V4h2.5v16m4.5 0h-2.5V4H20v16Z"/>'
        },
        landslide: {
            body: '<path fill="currentColor" d="m15.47 13.79l-2.58-1.03L6 15.05L2 13.5v2.11l4 1.34l9.47-3.16m-4.9-2.37L8 8H2v3.61l4 1.34l4.57-1.53M6 19.05l-4-1.33V22h20l-4.97-6.62L6 19.05M17 6V1l-5-1l-3 2v4l3 2l5-2m1.5 1L16 9v3l2.5 2l4.5-2V8l-4.5-1Z"/>'
        },
        "landslide-outline": {
            body: '<path fill="currentColor" d="M11 12L8 8H2v14h20l-6-8l-5-2m1.53 2.77L6 16.95l-2-.67v-1.89l2 .67l3.95-1.32l2.58 1.03M7 10l1.57 2.09l-2.57.86l-2-.67V10h3M4 20v-1.61l2 .67l9.03-3.01L18 20H4M17 6V1l-5-1l-3 2v4l3 2l5-2m-6-2.93l1.42-.95l2.58.52v2.01l-2.77 1.11L11 4.93V3.07M18.5 7L16 9v3l2.5 2l4.5-2V8l-4.5-1m2.5 3.7l-2.2.98l-.8-.64V9.96l1-.8l2 .44v1.1Z"/>'
        },
        "language-c": {
            body: '<path fill="currentColor" d="m15.45 15.97l.42 2.44c-.26.14-.68.27-1.24.39c-.57.13-1.24.2-2.01.2c-2.21-.04-3.87-.7-4.98-1.96c-1.14-1.27-1.68-2.88-1.68-4.83C6 9.9 6.68 8.13 8 6.89C9.28 5.64 10.92 5 12.9 5c.75 0 1.4.07 1.94.19s.94.25 1.2.4l-.6 2.49l-1.04-.34c-.4-.1-.87-.15-1.4-.15c-1.15-.01-2.11.36-2.86 1.1c-.76.73-1.14 1.85-1.18 3.34c.01 1.36.37 2.42 1.08 3.2c.71.77 1.7 1.17 2.99 1.18l1.33-.12c.43-.08.79-.19 1.09-.32Z"/>'
        },
        "language-cpp": {
            body: '<path fill="currentColor" d="m10.5 15.97l.41 2.44c-.26.14-.68.27-1.24.39c-.57.13-1.24.2-2.01.2c-2.21-.04-3.87-.7-4.98-1.96C1.56 15.77 1 14.16 1 12.21c.05-2.31.72-4.08 2-5.32C4.32 5.64 5.96 5 7.94 5c.75 0 1.4.07 1.94.19s.94.25 1.2.4l-.58 2.49l-1.06-.34c-.4-.1-.86-.15-1.39-.15c-1.16-.01-2.12.36-2.87 1.1c-.76.73-1.15 1.85-1.18 3.34c0 1.36.37 2.42 1.08 3.2c.71.77 1.71 1.17 2.99 1.18l1.33-.12c.43-.08.79-.19 1.1-.32M11 11h2V9h2v2h2v2h-2v2h-2v-2h-2v-2m7 0h2V9h2v2h2v2h-2v2h-2v-2h-2v-2Z"/>'
        },
        "language-csharp": {
            body: '<path fill="currentColor" d="m11.5 15.97l.41 2.44c-.26.14-.68.27-1.24.39c-.57.13-1.24.2-2.01.2c-2.21-.04-3.87-.7-4.98-1.96C2.56 15.77 2 14.16 2 12.21c.05-2.31.72-4.08 2-5.32C5.32 5.64 6.96 5 8.94 5c.75 0 1.4.07 1.94.19s.94.25 1.2.4l-.58 2.49l-1.06-.34c-.4-.1-.86-.15-1.39-.15c-1.16-.01-2.12.36-2.87 1.1c-.76.73-1.15 1.85-1.18 3.34c0 1.36.37 2.42 1.08 3.2c.71.77 1.71 1.17 2.99 1.18l1.33-.12c.43-.08.79-.19 1.1-.32M13.89 19l.61-4H13l.34-2h1.5l.32-2h-1.5L14 9h1.5l.61-4h2l-.61 4h1l.61-4h2l-.61 4H22l-.34 2h-1.5l-.32 2h1.5L21 15h-1.5l-.61 4h-2l.61-4h-1l-.61 4h-2m2.95-6h1l.32-2h-1l-.32 2Z"/>'
        },
        "language-css3": {
            body: '<path fill="currentColor" d="m5 3l-.65 3.34h13.59L17.5 8.5H3.92l-.66 3.33h13.59l-.76 3.81l-5.48 1.81l-4.75-1.81l.33-1.64H2.85l-.79 4l7.85 3l9.05-3l1.2-6.03l.24-1.21L21.94 3H5Z"/>'
        },
        "language-fortran": {
            body: '<path fill="currentColor" d="M5 4v2h1c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H5v2h9v-2h-2c-.55 0-1-.45-1-1v-4h2c.55 0 1 .45 1 1v2h2V8h-2v2c0 .55-.45 1-1 1h-2V6h5c1.11 0 2 1.34 2 3v1h2V4Z"/>'
        },
        "language-go": {
            body: '<path fill="currentColor" d="m2.64 10.33l-.02-.06l.22-.27l.12-.08H6.8l.03.08l-.18.26l-.11.06l-3.9.01m-1.61.98L1 11.26l.22-.29l.12-.06h4.9l.05.09l-.08.24l-.1.07H1.03m2.6.99l-.04-.06l.16-.28l.1-.06H6l.07.07l-.02.25l-.08.08H3.63m11.15-2.16l-1.78.47c-.19.04-.2.05-.34-.11c-.16-.18-.27-.29-.5-.4c-.66-.34-1.33-.24-1.94.15c-.72.48-1.11 1.17-1.1 2.05c.01.86.6 1.57 1.45 1.7c.73.09 1.34-.17 1.83-.72l.29-.39h-2.07c-.22 0-.27-.14-.2-.32l.55-1.18c.03-.06.11-.17.27-.17h3.44c.15-.5.41-.96.75-1.41c.78-1.03 1.73-1.57 3-1.81c1.07-.18 2.13-.07 3.07.57c.84.58 1.37 1.36 1.5 2.39c.19 1.45-.24 2.63-1.24 3.65c-.71.72-1.58 1.17-2.57 1.39l-.86.08c-.98-.02-1.87-.3-2.62-.95c-.52-.45-.88-.99-1.06-1.63c-.15.24-.27.47-.44.7c-.77 1.02-1.78 1.65-3.06 1.8c-1.05.16-2.03-.05-2.89-.69c-.79-.6-1.26-1.4-1.36-2.39c-.14-1.17.2-2.22.91-3.14c.76-1 1.77-1.63 3.01-1.86c1-.18 1.97-.06 2.84.52c.57.38.97.9 1.24 1.52c.04.09 0 .15-.12.18m6.11 1.6l-.03-.36c-.19-1.06-1.17-1.66-2.19-1.43c-1.01.22-1.67.85-1.88 1.86c-.19.84.21 1.69.98 2.03c.59.26 1.19.22 1.76-.06c.84-.43 1.31-1.12 1.36-2.04Z"/>'
        },
        "language-haskell": {
            body: '<path fill="currentColor" d="m2.08 19l4.67-7l-4.67-7h3.5l4.67 7l-4.67 7h-3.5m4.67 0l4.67-7l-4.67-7h3.5l9.34 14h-3.5l-2.92-4.37L10.25 19h-3.5m11.28-4.08l-1.53-2.34h5.42v2.34h-3.89m-2.33-3.5l-1.56-2.34h7.78v2.34H15.7Z"/>'
        },
        "language-html5": {
            body: '<path fill="currentColor" d="m12 17.56l4.07-1.13l.55-6.1H9.38L9.2 8.3h7.6l.2-1.99H7l.56 6.01h6.89l-.23 2.58l-2.22.6l-2.22-.6l-.14-1.66h-2l.29 3.19L12 17.56M4.07 3h15.86L18.5 19.2L12 21l-6.5-1.8L4.07 3Z"/>'
        },
        "language-java": {
            body: '<path fill="currentColor" d="M16.5 6.08s-6.84 1.71-3.56 5.48c.97 1.11-.25 2.11-.25 2.11s2.45-1.25 1.31-2.85c-1.06-1.47-1.86-2.2 2.5-4.74m-4.47 1.2C16.08 4.08 14 2 14 2c.84 3.3-2.96 4.3-4.33 6.36c-.94 1.4.46 2.91 2.33 4.64c-.71-1.7-3.22-3.16.03-5.72M9.37 17.47c-3.08.86 1.88 2.63 5.79.96c-.38-.15-.75-.33-1.1-.54c-1.36.31-2.76.37-4.14.18c-1.31-.16-.55-.6-.55-.6m5.32-1.68c-1.75.38-3.56.47-5.34.26c-1.31-.13-.45-.77-.45-.77c-3.4 1.13 1.88 2.4 6.6 1.02c-.29-.11-.57-.3-.81-.51m3.42 3.3s.57.47-.61.83c-2.28.68-9.43.89-11.41.03c-.71-.31.63-.74 1.05-.83c.23-.06.46-.08.69-.08c-.79-.54-5.13 1.1-2.19 1.56c7.97 1.3 14.54-.6 12.47-1.51m-2.74-4.86c.29-.19.6-.35.92-.49c0 0-1.51.26-3.02.4c-1.6.16-3.21.18-4.81.06c-2.35-.31 1.29-1.2 1.29-1.2c-1.1 0-2.18.26-3.16.75c-2.05 1 5.1 1.45 8.78.48m.9 2.42c-.02.04-.04.07-.08.1c5.01-1.31 3.17-4.64.77-3.81c-.13.06-.24.14-.31.25c.14-.05.28-.09.43-.12c1.2-.24 2.92 1.63-.81 3.58m.13 4.61c-3.01.52-6.09.56-9.12.14c0 0 .46.38 2.81.53c3.6.23 9.13-.13 9.26-1.83c.03.01-.23.65-2.95 1.16Z"/>'
        },
        "language-javascript": {
            body: '<path fill="currentColor" d="M3 3h18v18H3V3m4.73 15.04c.4.85 1.19 1.55 2.54 1.55c1.5 0 2.53-.8 2.53-2.55v-5.78h-1.7V17c0 .86-.35 1.08-.9 1.08c-.58 0-.82-.4-1.09-.87l-1.38.83m5.98-.18c.5.98 1.51 1.73 3.09 1.73c1.6 0 2.8-.83 2.8-2.36c0-1.41-.81-2.04-2.25-2.66l-.42-.18c-.73-.31-1.04-.52-1.04-1.02c0-.41.31-.73.81-.73c.48 0 .8.21 1.09.73l1.31-.87c-.55-.96-1.33-1.33-2.4-1.33c-1.51 0-2.48.96-2.48 2.23c0 1.38.81 2.03 2.03 2.55l.42.18c.78.34 1.24.55 1.24 1.13c0 .48-.45.83-1.15.83c-.83 0-1.31-.43-1.67-1.03l-1.38.8Z"/>'
        },
        "language-jsx": {
            body: '<path d="M3 3h18v18H3V3zm1.183 15.123c.355.753 1.055 1.377 2.26 1.377c1.334 0 2.249-.71 2.249-2.27v-5.144H7.185v5.122c0 .753-.312.947-.807.947c-.516 0-.732-.355-.968-.775l-1.227.743zm5.327-.162c.44.872 1.345 1.539 2.744 1.539c1.43 0 2.496-.742 2.496-2.098c0-1.26-.721-1.819-2.002-2.368l-.376-.16c-.646-.28-.925-.464-.925-.916c0-.365.28-.645.72-.645c.431 0 .71.183.969.645l1.173-.753C13.814 12.334 13.125 12 12.168 12c-1.345 0-2.206.86-2.206 1.99c0 1.227.72 1.809 1.808 2.271l.376.162c.689.3 1.097.484 1.097 1c0 .43-.398.743-1.022.743c-.742 0-1.162-.388-1.485-.915l-1.226.71zm8.002-4.092L16.68 12h-1.5l1.582 3.553l-1.757 3.947h1.5l1.008-2.262L18.52 19.5h1.5l-1.758-3.947L19.845 12h-1.5l-.832 1.869z" fill="currentColor"/>',
            hidden: true
        },
        "language-kotlin": {
            body: '<path fill="currentColor" d="M2 2h20L12 12l10 10H2Z"/>'
        },
        "language-lua": {
            body: '<path fill="currentColor" d="M10.5 5A8.5 8.5 0 0 0 2 13.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 10.5 5m3 8a2.5 2.5 0 0 1-2.5-2.5A2.5 2.5 0 0 1 13.5 8a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5m6-11A2.5 2.5 0 0 0 17 4.5A2.5 2.5 0 0 0 19.5 7A2.5 2.5 0 0 0 22 4.5A2.5 2.5 0 0 0 19.5 2"/>'
        },
        "language-markdown": {
            body: '<path fill="currentColor" d="M20.56 18H3.44C2.65 18 2 17.37 2 16.59V7.41C2 6.63 2.65 6 3.44 6h17.12c.79 0 1.44.63 1.44 1.41v9.18c0 .78-.65 1.41-1.44 1.41M6.81 15.19v-3.66l1.92 2.35l1.92-2.35v3.66h1.93V8.81h-1.93l-1.92 2.35l-1.92-2.35H4.89v6.38h1.92M19.69 12h-1.92V8.81h-1.92V12h-1.93l2.89 3.28L19.69 12Z"/>'
        },
        "language-markdown-outline": {
            body: '<path fill="currentColor" d="M20.56 18H3.44C2.65 18 2 17.37 2 16.59V7.41C2 6.63 2.65 6 3.44 6h17.12c.79 0 1.44.63 1.44 1.41v9.18c0 .78-.65 1.41-1.44 1.41M3.44 6.94c-.26 0-.48.21-.48.47v9.19c0 .25.22.46.48.46h17.12c.26 0 .48-.21.48-.46V7.41c0-.26-.22-.47-.48-.47H3.44m1.45 8.25V8.81h1.92l1.92 2.35l1.92-2.35h1.93v6.38h-1.93v-3.66l-1.92 2.35l-1.92-2.35v3.66H4.89m12.01 0l-2.9-3.1h1.94V8.81h1.92v3.28h1.93l-2.89 3.1"/>'
        },
        "language-php": {
            body: '<path fill="currentColor" d="M12 18.08c-6.63 0-12-2.72-12-6.08s5.37-6.08 12-6.08S24 8.64 24 12s-5.37 6.08-12 6.08m-5.19-7.95c.54 0 .91.1 1.09.31c.18.2.22.56.13 1.03c-.1.53-.29.87-.58 1.09c-.28.22-.71.33-1.29.33h-.87l.53-2.76h.99m-3.5 5.55h1.44l.34-1.75h1.23c.54 0 .98-.06 1.33-.17c.35-.12.67-.31.96-.58c.24-.22.43-.46.58-.73c.15-.26.26-.56.31-.88c.16-.78.05-1.39-.33-1.82c-.39-.44-.99-.65-1.82-.65H4.59l-1.28 6.58m7.25-8.33l-1.28 6.58h1.42l.74-3.77h1.14c.36 0 .6.06.71.18c.11.12.13.34.07.66l-.57 2.93h1.45l.59-3.07c.13-.62.03-1.07-.27-1.36c-.3-.27-.85-.4-1.65-.4h-1.27L12 7.35h-1.44M18 10.13c.55 0 .91.1 1.09.31c.18.2.22.56.13 1.03c-.1.53-.29.87-.57 1.09c-.29.22-.72.33-1.3.33h-.85l.5-2.76h1m-3.5 5.55h1.44l.34-1.75h1.22c.55 0 1-.06 1.35-.17c.35-.12.65-.31.95-.58c.24-.22.44-.46.58-.73c.15-.26.26-.56.32-.88c.15-.78.04-1.39-.34-1.82c-.36-.44-.99-.65-1.82-.65h-2.75l-1.29 6.58Z"/>'
        },
        "language-python": {
            body: '<path fill="currentColor" d="M19.14 7.5A2.86 2.86 0 0 1 22 10.36v3.78A2.86 2.86 0 0 1 19.14 17H12c0 .39.32.96.71.96H17v1.68a2.86 2.86 0 0 1-2.86 2.86H9.86A2.86 2.86 0 0 1 7 19.64v-3.75a2.85 2.85 0 0 1 2.86-2.85h5.25a2.85 2.85 0 0 0 2.85-2.86V7.5h1.18m-4.28 11.79c-.4 0-.72.3-.72.89c0 .59.32.71.72.71a.71.71 0 0 0 .71-.71c0-.59-.32-.89-.71-.89m-10-1.79A2.86 2.86 0 0 1 2 14.64v-3.78A2.86 2.86 0 0 1 4.86 8H12c0-.39-.32-.96-.71-.96H7V5.36A2.86 2.86 0 0 1 9.86 2.5h4.28A2.86 2.86 0 0 1 17 5.36v3.75a2.85 2.85 0 0 1-2.86 2.85H8.89a2.85 2.85 0 0 0-2.85 2.86v2.68H4.86M9.14 5.71c.4 0 .72-.3.72-.89c0-.59-.32-.71-.72-.71c-.39 0-.71.12-.71.71s.32.89.71.89Z"/>'
        },
        "language-python-text": {
            body: '<path d="M2 5.69c6.92-4.62 9.1 1.31 9.28 4.58c.18 3.26-2.99 7.37-6.97 4.65v5.38L2 18.77V5.69M4.22 7.4v5.38c3.62 2.17 4.86.39 4.86-2.69c0-4.35-2.51-4.5-4.86-2.69m10.86-3.25s-.18 3.49 0 6.92c.36 3.43 4.61.77 4.61.77V4.92L22 5.2v9.24c0 6.16-6.15 5.86-6.15 5.86l-.77-2.3c5.38 0 4.7-3.57 4.7-3.57c-6.51 2.54-7.01-1.82-7.01-1.82V5.69l2.31-1.54z" fill="currentColor"/>',
            hidden: true
        },
        "language-r": {
            body: '<path fill="currentColor" d="M12 4.29c-5.5 0-10 3-10 6.71c0 3.28 3.56 6 8.24 6.58v2.13h3.41v-2.12c.85-.09 1.64-.25 2.39-.48l1.38 2.6h3.86l-2.32-3.91C20.83 14.58 22 12.87 22 11c0-3.71-4.5-6.71-10-6.71m1.53 2.62c4.2 0 7.3 1.4 7.3 4.59c0 1.71-.92 2.91-2.42 3.65c-.09-.05-.17-.1-.22-.15c-.36-.16-.96-.34-.96-.34s2.98-.22 2.98-3.19c0-2.97-3.12-3.02-3.12-3.02h-6.85v7.16c-2.55-.74-4.31-2.31-4.31-4.11c0-2.54 3.4-4.59 7.6-4.59m.15 3.98h2.07s.95-.05.95.94c0 .97-.95.97-.95.97h-2.07v-1.91m-.03 4.41h.92c.18 0 .27.05.43.2c.13.1.27.29.39.46c-.55.07-1.13.1-1.74.1v-.76Z"/>'
        },
        "language-ruby": {
            body: '<path fill="currentColor" d="M18.8 2.07c2.52.43 3.24 2.16 3.2 3.97V6l-1.14 14.93l-14.78 1.01h.01c-1.23-.05-3.96-.17-4.09-3.99l1.37-2.5l2.77 6.46l2.36-7.62l-.05.01l.02-.02l7.71 2.46l-1.99-7.78l7.35-.46l-5.79-4.74l3.05-1.7v.01M2 17.91v.02v-.02M6.28 6.23c2.96-2.95 6.79-4.69 8.26-3.2c1.46 1.47-.08 5.09-3.04 8.03c-3 2.94-6.77 4.78-8.24 3.3c-1.47-1.49.04-5.19 3.01-8.13h.01Z"/>'
        },
        "language-ruby-on-rails": {
            body: '<path fill="currentColor" d="M19.8 16.7s1.8-.2 1.8-2.4c0-2.2-2.1-2.5-2.1-2.5h-3.8V19h1.9v-1.7l1.7 1.7H22l-2.2-2.3m-.8-1.4h-1.5v-1.6H19s.4.2.4.8c.1.6-.4.8-.4.8m2.3-7.1v.2C13.2 6.1 10 13.2 10.6 18.7H4.3c.7-5.4 7.5-16.1 17-10.5m-.8-1.3c-.7-.3-1.4-.6-2.1-.8l.1-1.3l2.1.8l-.1 1.3m-2 1.8c.7 0 1.4.1 2.1.3l-.1 1.2l-1.8-.2l-.2-1.3m-4.6-2.9l-.4-1.2l2.1-.2l.4 1.3c-.2 0-1.9.1-2.1.1m1.3 3.7c.4-.2 1.1-.5 2-.7l.4 1.2l-1.8.7l-.6-1.2m-3.4-3c-.6.3-1.2.6-1.8 1l-.8-1.3l1.8-1l.8 1.3m2.5 3.6l.8 1.2l-1.1 1.3l-1.1-1c.3-.6.8-1.1 1.4-1.5M11.6 15c.1-.8.3-1.5.6-2.3l1.2 1l-.3 1.9l-1.5-.6M7.9 9.3c-.5.5-1 1.1-1.4 1.6L5.2 9.8l1.5-1.6l1.2 1.1m-3.1 4.4c-.4.8-.7 1.6-1 2.3L2 15.3l.9-2.3l1.9.7m6.7 2.6l1.8.6l.3 2l-2-.5c0-.2-.1-.9-.1-2.1Z"/>'
        },
        "language-rust": {
            body: '<path fill="currentColor" d="m21.9 11.7l-.9-.5V11l.7-.7c.1-.1.1-.3 0-.4l-.1-.1l-.9-.3c0-.1 0-.2-.1-.2l.6-.8c.1-.1.1-.3-.1-.4c0 0-.1 0-.1-.1l-1-.2c0-.1-.1-.1-.1-.2l.4-.9v-.3c-.1-.1-.2-.1-.3-.1h-1s0-.1-.1-.1l.2-1c0-.2-.1-.3-.2-.3h-.1l-1 .2c0-.1-.1-.1-.2-.2v-1c0-.2-.1-.3-.3-.3h-.1l-.9.4h-.1L16 3c0-.2-.2-.3-.3-.2h-.1l-.8.6c-.1 0-.2 0-.2-.1l-.3-.9c-.1-.1-.2-.2-.4-.2c0 0-.1 0-.1.1L13 3h-.2l-.5-.8c-.1-.2-.3-.2-.5-.2l-.1.1l-.5.9H11l-.7-.7c-.1-.1-.3-.1-.4 0l-.1.1l-.3.9c-.1 0-.2 0-.2.1l-.8-.6c-.2-.1-.4-.1-.5.1V3l-.2 1s-.1 0-.2.1l-.9-.4c-.1-.1-.3 0-.4.1v1.1c0 .1-.1.1-.1.2l-1-.2c-.2-.1-.3 0-.3.2v.1l.2 1c-.1 0-.1.1-.2.1h-1c-.2 0-.3.1-.3.3v.1l.4.9v.2L3 8c-.2 0-.3.2-.3.3v.1l.6.8c0 .1 0 .2-.1.2l-.8.4c-.1.1-.2.2-.2.4c0 0 0 .1.1.1l.7.7v.2l-.8.5c-.2.1-.2.3-.2.4l.1.1l.9.6v.2l-.7.7c-.1.1-.1.3 0 .4l.1.1l.9.3c0 .1 0 .2.1.2l-.6.8c-.1.1-.1.3.1.4c0 0 .1 0 .1.1l1 .2c0 .1.1.1.1.2l-.4.9c-.1.1 0 .3.1.4h1.1c.1 0 .1.1.2.1l-.2 1c0 .2.1.3.2.3h.1l1-.2c0 .1.1.1.2.2v1c0 .2.1.3.3.3h.1l.9-.4h.1l.2 1c0 .2.2.3.3.2h.1l.8-.6c.1 0 .2 0 .2.1l.3.9c.1.1.2.2.4.2c0 0 .1 0 .1-.1l.8-.7h.2l.5.8c.1.1.3.2.4.1l.1-.1l.5-.8h.2l.7.7c.1.1.3.1.4 0l.1-.1l.3-.9c.1 0 .2 0 .2-.1l.8.6c.1.1.3.1.4-.1c0 0 0-.1.1-.1l.2-1c.1 0 .1-.1.2-.1l.9.4c.1.1.3 0 .4-.1v-1.1l.2-.2l1 .2c.2 0 .3-.1.3-.2v-.1l-.2-1l.2-.2h1c.2 0 .3-.1.3-.3v-.1l-.4-.9c0-.1.1-.1.1-.2l1-.2c.2 0 .3-.2.2-.3v-.1l-.6-.8l.1-.2l.9-.3c.1-.1.2-.2.2-.4c0 0 0-.1-.1-.1L21 13v-.2l.8-.5c.2-.1.2-.3.1-.6c0 .1 0 .1 0 0m-5.7 7c-.3-.1-.5-.4-.5-.7c.1-.3.4-.5.7-.5c.3.1.5.4.5.7c0 .4-.3.6-.7.5m-.2-1.9c-.3-.1-.6.1-.6.4l-.4 1.4c-.9.4-1.9.6-3 .6s-2.1-.2-3.1-.7l-.3-1.4c-.1-.3-.3-.5-.6-.4l-1.2.3c-.2-.2-.4-.5-.6-.7h6c.1 0 .1 0 .1-.1v-2.1c0-.1 0-.1-.1-.1h-1.7v-1.3h1.9c.2 0 .9 0 1.2 1c.1.3.2 1.3.4 1.6c.1.3.6 1 1.1 1h3.1c-.2.3-.4.5-.7.8l-1.5-.3m-8.3 1.9c-.3.1-.6-.1-.7-.5c-.1-.3.1-.6.5-.7s.6.1.7.5c0 .3-.2.6-.5.7M5.4 9.5c.1.3 0 .7-.3.8c-.3.1-.7 0-.8-.3c-.1-.3 0-.7.3-.8c.4-.1.7 0 .8.3m-.7 1.6l1.3-.5c.3-.1.4-.4.3-.7L6 9.3h1V14H5c-.3-1-.4-1.9-.3-2.9m5.6-.4V9.3h2.5c.1 0 .9.1.9.7c0 .5-.6.7-1.1.7h-2.3m9 1.2v.5h-.8c-.1 0-.1 0-.1.1v.3c0 .8-.5 1-.9 1s-.8-.2-.9-.4c-.2-1.3-.6-1.5-1.2-2c.7-.5 1.5-1.2 1.5-2.1c0-1-.7-1.6-1.1-1.9c-.7-.4-1.4-.5-1.6-.5H6.6c1.1-1.2 2.5-2 4.1-2.3l.9 1c.2.2.5.2.8 0l1-1c2.1.4 3.9 1.7 5 3.6l-.7 1.6c-.1.3 0 .6.3.7l1.3.6v.8m-7.7-8c.2-.2.6-.2.8 0c.2.2.2.6 0 .8c-.3.3-.6.3-.9 0c-.2-.2-.1-.5.1-.8m6.9 5.6c.1-.3.5-.4.8-.3c.3.1.4.5.3.8c-.1.3-.5.4-.8.3c-.3-.1-.4-.5-.3-.8Z"/>'
        },
        "language-swift": {
            body: '<path fill="currentColor" d="M17.09 19.72c-2.36 1.36-5.59 1.5-8.86.1A13.807 13.807 0 0 1 2 14.5c.67.55 1.46 1 2.3 1.4c3.37 1.57 6.73 1.46 9.1 0c-3.37-2.59-6.24-5.96-8.37-8.71c-.45-.45-.78-1.01-1.12-1.51c8.28 6.05 7.92 7.59 2.41-1.01c4.89 4.94 9.43 7.74 9.43 7.74c.16.09.25.16.36.22c.1-.25.19-.51.26-.78c.79-2.85-.11-6.12-2.08-8.81c4.55 2.75 7.25 7.91 6.12 12.24c-.03.11-.06.22-.05.39c2.24 2.83 1.64 5.78 1.35 5.22c-1.21-2.39-3.48-1.65-4.62-1.17Z"/>'
        },
        "language-typescript": {
            body: '<path fill="currentColor" d="M3 3h18v18H3V3m10.71 14.86c.5.98 1.51 1.73 3.09 1.73c1.6 0 2.8-.83 2.8-2.36c0-1.41-.81-2.04-2.25-2.66l-.42-.18c-.73-.31-1.04-.52-1.04-1.02c0-.41.31-.73.81-.73c.48 0 .8.21 1.09.73l1.31-.87c-.55-.96-1.33-1.33-2.4-1.33c-1.51 0-2.48.96-2.48 2.23c0 1.38.81 2.03 2.03 2.55l.42.18c.78.34 1.24.55 1.24 1.13c0 .48-.45.83-1.15.83c-.83 0-1.31-.43-1.67-1.03l-1.38.8M13 11.25H8v1.5h1.5V20h1.75v-7.25H13v-1.5Z"/>'
        },
        "language-xaml": {
            body: '<path fill="currentColor" d="m16.93 7.9l2.38 4.1l-2.36 4.09l-.62-1.09l1.47-2.5c.17-.31.17-.67 0-.96L16.32 9l.61-1.1m-.01-1.33a.12.12 0 0 0-.09.05l-1.27 2.25c-.06.07-.06.13 0 .22l1.62 2.81c.04.07.04.15 0 .22l-1.61 2.79c-.04.06-.04.15 0 .22l1.28 2.23c.02.04.06.06.09.06c.06 0 .06-.02.1-.06L20 12.23c.08-.14.08-.31 0-.44l-3-5.17c0-.03-.04-.05-.08-.05m4.99 5.1l-4.68-8.09a.676.676 0 0 0-.57-.33H7.28c-.23 0-.45.13-.57.33L2 11.67a.84.84 0 0 0 0 .66l4.71 8.09c.12.2.34.33.57.33h9.38c.23 0 .45-.13.57-.33l4.68-8.09a.65.65 0 0 0 0-.66M7.3 3.95h8.82l-4.36 7.7H6.93l3.94-6.83c.04-.07-.01-.16-.09-.16l-2.57-.01c-.08 0-.15.05-.21.11l-3.96 6.89h-1.2l4.46-7.7m-1.13 8.51l3.57 6.17H8.5l-3.63-6.28l-.2-.35l.2-.35L8.5 5.37h1.23l-3.56 6.16l-.06.12c-.08.23-.08.48.01.7c.01.04.03.08.05.11m1.13 7.59l-4.45-7.7h1.2l3.98 6.88c.04.07.11.11.19.11h2.57c.08 0 .13-.09.09-.16l-3.94-6.83h4.83l4.4 7.7H7.3m9.5-.3L12.37 12l4.41-7.79L21.29 12l-4.49 7.75Z"/>'
        },
        laptop: {
            body: '<path fill="currentColor" d="M4 6h16v10H4m16 2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4Z"/>'
        },
        "laptop-account": {
            body: '<path fill="currentColor" d="M20 4a2 2 0 0 1 2 2v10c0 1.11-.89 2-2 2h4v2H0v-2h4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16m0 2H4v10h16V6m-8 6c2.21 0 4 .9 4 2v1H8v-1c0-1.1 1.79-2 4-2m0-5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"/>'
        },
        "laptop-chromebook": {
            body: '<path d="M20 15H4V5h16m-6 13h-4v-1h4m8 1V3H2v15H0v2h24v-2h-2z" fill="currentColor"/>',
            hidden: true
        },
        "laptop-mac": {
            body: '<path d="M12 19a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1M4 5h16v11H4m16 2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v11a2 2 0 0 0 2 2H0a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2h-4z" fill="currentColor"/>',
            hidden: true
        },
        "laptop-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L20 20.72L18.73 22l-2-2H0v-2h4a2 2 0 0 1-2-2V6c0-.22.04-.43.1-.63L1 4.27M4 16h8.73L4 7.27V16m16 0V6H7.82l-2-2H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h4v2h-2.18l-4-4H20Z"/>'
        },
        "laptop-windows": {
            body: '<path d="M3 4h18a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h1l2 3v1H0v-1l2-3h1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m1 2v9h16V6H4z" fill="currentColor"/>',
            hidden: true
        },
        laravel: {
            body: '<path fill="currentColor" d="M21.7 6.53c.01.02.01.05.01.08v4.29c0 .1-.06.22-.15.27l-3.61 2.08v4.11c0 .11-.05.21-.15.27l-7.52 4.33c-.02.01-.04.04-.06.04H10s0-.03-.04-.04l-7.52-4.33a.315.315 0 0 1-.15-.27V4.5c0-.05 0-.08.01-.1c0-.01.01-.02.01-.03c0-.02.01-.03.02-.05c0-.01.01-.02.02-.03l.03-.03l.03-.03c.01-.01.02-.02.03-.02L6.2 2.04c.1-.04.22-.04.3 0l3.78 2.17c.01.01.02.01.03.02l.03.03l.03.03c.01.01.02.02.02.03c.01.02.02.03.02.05c0 .01.01.02.01.03c.01.03.01.05.01.1v8l3.14-1.78V6.61c0-.03 0-.06.01-.08l.01-.03s.01-.03.02-.05c0-.01.01-.02.02-.03l.03-.03l.03-.03c.01-.01.02-.02.03-.02l3.78-2.17c.08-.06.2-.06.3 0l3.76 2.17c.01 0 .02.01.03.02l.03.03l.03.03c.01.01.01.02.02.03c.01.02.01.05.02.05s.01 0 .01.03m-.61 4.19V7.15l-3.14 1.8v3.55l3.14-1.78m-3.76 6.46V13.6l-6.9 3.94v3.61l6.9-3.97M2.91 5v12.18l6.9 3.97v-3.61l-3.6-2.04H6.2c-.01 0-.02 0-.03-.03c-.01 0-.02-.01-.03-.02l-.03-.03c-.01-.01-.01-.02-.02-.03c-.01-.02-.01-.03-.02-.04c0-.02-.01-.03-.01-.04c-.01-.01-.01-.03-.01-.04V6.82L2.91 5m3.45-2.32L3.23 4.5l3.13 1.78L9.5 4.5L6.36 2.68m3.45 10.2V5L6.67 6.82v7.87l3.14-1.81m7.83-8.08L14.5 6.61l3.14 1.8l3.13-1.8l-3.13-1.81m-.31 4.15l-3.14-1.8v3.57l3.14 1.78V8.95M10.12 17L17 13.06l-3.12-1.8L7 15.23L10.12 17Z"/>'
        },
        "laser-pointer": {
            body: '<path fill="currentColor" d="m9 13l-4 3c-1 .88-1.14 2.12-1 3c.13 1 .91 2.22 2 2.68c1.57.67 3.09.22 4.04-.76L19 13c1.86-1.38 1-4-1-4h-6l7.46-4.39c.44-.32.62-.79.6-1.24C20 2.67 19.46 2 18.6 2h-.06c-.35 0-.68.11-.98.29L5 9c-.81.46-1.06 1.24-1 2c.05 1.03.74 2 2 2m-1 5.5a2.5 2.5 0 0 1 5 0a2.5 2.5 0 0 1-5 0Z"/>'
        },
        lasso: {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 3.13 10 7c0 3.26-3.19 6-7.5 6.78v-.28a5 5 0 0 0-.29-1.69C17.55 13.21 20 11.28 20 9c0-2.76-3.58-5-8-5S4 6.24 4 9c0 1.19.67 2.29 1.79 3.15c-.44.49-.79 1.06-1.01 1.7C3.06 12.59 2 10.88 2 9c0-3.87 4.5-7 10-7M9.5 12c1.93 0 3.5 1.57 3.5 3.5c0 1.9-1.5 3.45-3.4 3.5c-.21.36-.42 1 .23 1.68c1.17 1.2 3.45-.96 6.56-.97c2.04-.01 3.64.26 3.64.26s1.05.13.94 1.07c-.11.93-1.06.93-1.06.93c-.38-.04-1.88-.39-3.69-.29c-1.81.09-2.75.73-3.66 1.01c-.9.28-2.65.69-4.26-.64c-1.33-1.09-.84-2.94-.63-3.55a3.55 3.55 0 0 1-1.67-3C6 13.57 7.57 12 9.5 12m0 2c-.83 0-1.5.67-1.5 1.5S8.67 17 9.5 17s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5Z"/>'
        },
        lastfm: {
            body: '<path d="M18 17.93c-2.08-.01-3.19-1.03-3.96-2.84l-.22-.49l-1.9-4.37c-.63-1.54-2.2-2.59-3.96-2.59c-2.39 0-4.33 1.95-4.33 4.36s1.94 4.36 4.33 4.36c1.66 0 3.12-.95 3.84-2.36l.77 1.81A5.893 5.893 0 0 1 7.96 18C4.67 18 2 15.32 2 12c0-3.31 2.67-6 5.96-6c2.48 0 4.49 1.34 5.51 3.7c.07.19 1.07 2.54 1.95 4.54c.54 1.26 1 2.07 2.49 2.12c1.47.05 2.48-.86 2.48-1.99c0-1.11-.77-1.37-2.07-1.81c-2.32-.77-3.53-1.56-3.53-3.41c0-1.82 1.21-3.03 3.21-3.03c1.31 0 2.24.58 2.89 1.74l-1.27.64c-.48-.66-1.01-.93-1.68-.93c-.94 0-1.61.66-1.61 1.53c0 1.24 1.1 1.43 2.64 1.93c2.07.68 3.03 1.47 3.03 3.39c0 2.03-1.73 3.51-4 3.51z" fill="currentColor"/>',
            hidden: true
        },
        lastpass: {
            body: '<path fill="currentColor" d="M14 12a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m20-7h-2v14h2V5Z"/>'
        },
        latitude: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 2c3 0 5.5 1.6 6.9 4H5.1C6.5 5.6 9 4 12 4m0 16c-3 0-5.5-1.6-6.9-4h13.8c-1.4 2.4-3.9 4-6.9 4m-7.7-6c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2h15.5c.2.6.3 1.3.3 2s-.1 1.4-.3 2H4.3Z"/>'
        },
        launch: {
            body: '<path fill="currentColor" d="M14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7Z"/>'
        },
        "lava-lamp": {
            body: '<path fill="currentColor" d="M10 3L8 16h8L14 3h-4m1.5 2.75a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75m1 2.75a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-1 3.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5M8 17l2 2l-2 2h8l-2-2l2-2H8Z"/>'
        },
        layers: {
            body: '<path fill="currentColor" d="m12 16l7.36-5.73L21 9l-9-7l-9 7l1.63 1.27M12 18.54l-7.38-5.73L3 14.07l9 7l9-7l-1.63-1.27L12 18.54Z"/>'
        },
        "layers-edit": {
            body: '<path fill="currentColor" d="M4.63 10.27L3 9l9-7l7.94 6.17l-7.44 7.44l-.5.39l-7.37-5.73M10 18.94v-.83l.59-.58l.04-.03l-6.01-4.69L3 14.07l7 5.43v-.56m11.7-6.36l-1.28-1.28a.55.55 0 0 0-.77 0l-1 1l2.05 2.05l1-1a.55.55 0 0 0 0-.77M12 21h2.06l6.05-6.07l-2.05-2.05L12 18.94V21Z"/>'
        },
        "layers-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8m-11-1L2 9l9-7l9 7l-9 7m0 2.54l1-.79V18c0 .71.12 1.39.35 2L11 21.07l-9-7l1.62-1.26L11 18.54Z"/>'
        },
        "layers-off": {
            body: '<path fill="currentColor" d="M3.27 1L2 2.27L6.22 6.5L3 9l1.63 1.27L12 16l2.1-1.63l1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7l4.95-3.85L20.73 21L22 19.73L3.27 1m16.09 9.27L21 9l-9-7l-2.91 2.27l7.87 7.88l2.4-1.88m.45 4.73l1.19-.93l-1.43-1.43l-1.19.92L19.81 15Z"/>'
        },
        "layers-off-outline": {
            body: '<path fill="currentColor" d="m12 4.53l-1.17.91L9.41 4L12 2l9 7l-3.72 2.89l-1.43-1.42L17.74 9L12 4.53m9 9.54l-.87.68l-1.43-1.43l.67-.52L21 14.07M3.41.86l18.73 18.73L20.73 21l-3.78-3.78L12 21.07l-9-7l1.62-1.26L12 18.54l3.5-2.75l-1.4-1.42L12 16L3 9l3.22-2.5L2 2.27L3.41.86M12 13.47l.67-.53l-5.02-5.02L6.26 9L12 13.47Z"/>'
        },
        "layers-outline": {
            body: '<path fill="currentColor" d="m12 18.54l7.37-5.74L21 14.07l-9 7l-9-7l1.62-1.26L12 18.54M12 16L3 9l9-7l9 7l-9 7m0-11.47L6.26 9L12 13.47L17.74 9L12 4.53Z"/>'
        },
        "layers-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3m-6 2L2 9l9-7l9 7l-9 7m0 2.54l1-.79V18c0 .71.12 1.39.35 2L11 21.07l-9-7l1.62-1.26L11 18.54Z"/>'
        },
        "layers-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M11 16L2 9l9-7l9 7l-9 7m0 2.54l1-.79V18c0 .71.12 1.39.35 2L11 21.07l-9-7l1.62-1.26L11 18.54Z"/>'
        },
        "layers-search": {
            body: '<path fill="currentColor" d="M19.31 18.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 23.39L22.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5m-5.91.2L3 14.07l1.62-1.26L9 16.22v.28c0 .96.22 1.88.59 2.7m-4.96-8.93L3 9l9-7l9 7l-1.64 1.27l-.71.55c-.93-.52-2.01-.82-3.15-.82c-2.71 0-5.04 1.68-6 4.05l-4.87-3.78Z"/>'
        },
        "layers-search-outline": {
            body: '<path fill="currentColor" d="M19.31 18.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 23.39L22.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5m-5.91.2L3 14.07l1.62-1.26L9 16.22v.28c0 .96.22 1.88.59 2.7m-.09-5.16L3 9l9-7l9 7l-2.34 1.82a6.64 6.64 0 0 0-2.29-.75L17.74 9L12 4.53L6.26 9l4.27 3.32c-.43.52-.79 1.1-1.03 1.72Z"/>'
        },
        "layers-triple": {
            body: '<path fill="currentColor" d="M12 0L3 7l1.63 1.27L12 14l7.36-5.73L21 7l-9-7m7.37 10.73L12 16.47l-7.38-5.73L3 12l9 7l9-7l-1.63-1.27m0 5L12 21.47l-7.38-5.73L3 17l9 7l9-7l-1.63-1.27Z"/>'
        },
        "layers-triple-outline": {
            body: '<path fill="currentColor" d="m12 16.54l7.37-5.74L21 12.07l-9 7l-9-7l1.62-1.26L12 16.54M12 14L3 7l9-7l9 7l-9 7m0-11.47L6.26 7L12 11.47L17.74 7L12 2.53m0 18.94l7.37-5.74L21 17l-9 7l-9-7l1.62-1.26L12 21.47"/>'
        },
        "lead-pencil": {
            body: '<path fill="currentColor" d="M16.84 2.73c-.39 0-.77.15-1.07.44l-2.12 2.12l5.3 5.31l2.12-2.1c.6-.61.6-1.56 0-2.14L17.9 3.17c-.3-.29-.68-.44-1.06-.44M12.94 6l-8.1 8.11l2.56.28l.18 2.29l2.28.17l.29 2.56l8.1-8.11m-14 3.74L2.5 21.73l6.7-1.79l-.24-2.16l-2.31-.17l-.18-2.32"/>'
        },
        leaf: {
            body: '<path fill="currentColor" d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66l.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8Z"/>'
        },
        "leaf-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M9.6 17.2c-.22 0-.52-.08-.8-.2l-.57 1.4l-1.14-.4l.16-.39C8.45 14.59 9.83 11.15 15 10c0 0-6 0-7.95 5.55c0 0-1.05-1.05-1.05-2.25s1.2-3.75 4.2-4.35c.85-.17 1.8-.3 2.74-.45C15.3 8.18 17.57 7.86 18 7c0 0-1.8 10.2-8.4 10.2Z"/>'
        },
        "leaf-circle-outline": {
            body: '<path fill="currentColor" d="M8.04 16.34c1.01-2.51 2.15-5.38 6.46-6.34c0 0-5 0-6.62 4.63c0 0-.88-.88-.88-1.88s1-3.12 3.5-3.62c.71-.13 1.5-.26 2.28-.37c1.97-.26 3.86-.54 4.22-1.26c0 0-1.5 8.5-7 8.5c-.18 0-.43-.06-.67-.15L8.86 17l-.95-.33l.13-.33M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2Z"/>'
        },
        "leaf-maple": {
            body: '<path fill="currentColor" d="M21.79 13L16 16l1 2l-4-.75V21h-2v-3.75L7 18l1-2l-5.79-3l1-1.73L1.61 8l3.6-.23l1-1.77l3.42 3.9L8 5h2l2-3l2 3h2l-1.63 4.9L17.79 6l1 1.73l3.6.23l-1.6 3.23l1 1.81Z"/>'
        },
        "leaf-maple-off": {
            body: '<path fill="currentColor" d="M18.11 14.91L8.2 5H10l2-3l2 3h2l-1.63 4.9L17.79 6l1 1.73l3.6.23l-1.6 3.23l1 1.81l-3.68 1.91M2.39 1.73L1.11 3l4.34 4.34l-.24.43l-3.6.23l1.6 3.27l-1 1.73L8 16l-1 2l4-.75V21h2v-3.75l2.91.55l4.93 4.93l1.27-1.27L2.39 1.73Z"/>'
        },
        "leaf-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-5.7-5.7C13.26 18.79 10.92 20 8 20c-.36 0-.86-.13-1.34-.3L5.71 22l-1.89-.66c1.33-3.31 2.68-7.02 5.84-9.79l-.89-.89c-2.01 1.37-3.91 3.44-5.02 6.59c0 0-1.75-1.75-1.75-3.75C2 12 3.12 9.32 5.72 7.61L1.11 3l1.28-1.27l14 14.01l5.72 5.72l-1.27 1.27M17 8c-1.65.37-3.07.88-4.3 1.5l4.8 4.79C20.87 9.35 22 3 22 3c-.97 1.95-7.65 2.24-12.62 3.18l2.77 2.77C14.81 8 17 8 17 8Z"/>'
        },
        leak: {
            body: '<path fill="currentColor" d="M6 3H3v3a3 3 0 0 0 3-3m8 0h-2a9 9 0 0 1-9 9v2c6.08 0 11-4.93 11-11m-4 0H8a5 5 0 0 1-5 5v2a7 7 0 0 0 7-7m0 18h2a9 9 0 0 1 9-9v-2a11 11 0 0 0-11 11m8 0h3v-3a3 3 0 0 0-3 3m-4 0h2a5 5 0 0 1 5-5v-2a7 7 0 0 0-7 7Z"/>'
        },
        "leak-off": {
            body: '<path fill="currentColor" d="M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3M3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 0 1 3 12v2c2.71 0 5.19-1 7.11-2.62l2.5 2.5C11 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43A6.922 6.922 0 0 0 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21L21 19.73L4.27 3L3 4.27M14 3h-2c0 1.5-.37 2.91-1 4.16l1.44 1.46C13.42 7 14 5.06 14 3m5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.5l1.6 1.62m-4.56-4.56L16.84 13c1.25-.63 2.66-1 4.16-1v-2c-2.06 0-4 .58-5.62 1.56Z"/>'
        },
        lectern: {
            body: '<path fill="currentColor" d="M17 21v1H7v-1h2V11h6v10h2m.5-15c0-1.61-1.09-2.95-2.57-3.36c-.15-.37-.5-.64-.93-.64c-.55 0-1 .45-1 1s.45 1 1 1c.31 0 .58-.15.76-.37c1.01.32 1.74 1.26 1.74 2.37H4l1 4h14l1-4h-2.5Z"/>'
        },
        "led-off": {
            body: '<path fill="currentColor" d="M12 6a4 4 0 0 0-4 4v6H6v2h3v5h2v-5h2v5h2v-5h3v-2h-2v-6a4 4 0 0 0-4-4Z"/>'
        },
        "led-on": {
            body: '<path fill="currentColor" d="M11 0v4h2V0h-2m7.3 2.29l-3.06 3l1.4 1.42l3.06-3l-1.4-1.42m-12.59 0L4.29 3.71l3 3l1.42-1.42l-3-3M12 6a4 4 0 0 0-4 4v6H6v2h3v5h2v-5h2v5h2v-5h3v-2h-2v-6a4 4 0 0 0-4-4M2 9v2h4V9H2m16 0v2h4V9h-4Z"/>'
        },
        "led-outline": {
            body: '<path fill="currentColor" d="M12 6a4 4 0 0 0-4 4v6H6v2h3v5h2v-5h2v5h2v-5h3v-2h-2v-6a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2v5h-4v-5a2 2 0 0 1 2-2Z"/>'
        },
        "led-strip": {
            body: '<path fill="currentColor" d="M2.81 8.46L14.83 20.5l.71-.72l1.41 1.41l1.41-1.41l-1.41-1.42l1.41-1.41l1.42 1.41l1.41-1.41l-1.41-1.41l.72-.71L8.46 2.81L2.81 8.46m2.83 0l2.82-2.82l9.2 9.19l-2.83 2.83l-9.19-9.2m1.41 0l1.41 1.42l1.42-1.42l-1.42-1.41l-1.41 1.41m2.12 2.13L10.59 12L12 10.59l-1.41-1.42l-1.42 1.42m2.12 2.12l1.42 1.41l1.41-1.41l-1.41-1.42l-1.42 1.42m2.12 2.12l1.42 1.41l1.41-1.41l-1.41-1.42l-1.42 1.42Z"/>'
        },
        "led-strip-variant": {
            body: '<path fill="currentColor" d="M2.95 3L2 6.91l17.34 4.34l.95-3.91L2.95 3m3.14 3.89l-1.93-.48l.48-1.95l1.93.48l-.48 1.95m3.85.97L8 7.38l.5-1.96l1.92.49l-.48 1.95m3.86.96l-1.93-.48l.48-1.95l1.92.48l-.47 1.95m3.85.97l-1.93-.48l.48-1.96l1.93.49l-.48 1.95M4.66 12.75l-.95 3.91L21.05 21l.95-3.9l-17.34-4.35m3.14 3.9l-1.92-.49l.47-1.95l1.93.48l-.48 1.96m3.85.96l-1.92-.48l.47-1.95l1.93.48l-.48 1.95m3.85.97l-1.92-.49l.48-1.95l1.94.48l-.5 1.96m3.86.96l-1.93-.48l.48-1.95l1.93.48l-.48 1.95M6.25 12.11L11 10.2l6.75 1.69L13 13.8l-6.75-1.69Z"/>'
        },
        "led-strip-variant-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l1.48 1.5L2 6.91l4.03 1.01l3.05 3.05l-2.83 1.14l5.3 1.33l1.39 1.39l-8.28-2.08l-.95 3.91l14.75 3.69l2.38 2.38l1.27-1.27M7.8 16.65l-1.92-.49l.47-1.95l1.93.48l-.48 1.96m3.85.96l-1.92-.48l.47-1.95l1.93.48l-.48 1.95m3.85.97l-1.92-.49l.48-1.95l.25.06l1.43 1.43l-.24.95m4.23-2.05l2.27.57l-.33 1.37l-1.94-1.94m-3.88-3.88L14.2 11l3.55.89l-1.9.76m-5.43-6.74l-.26 1.05l2.66 2.66l6.52 1.63l.95-3.91l-13-3.25l1.37 1.37l1.76.45m5.78 1.44l1.93.49l-.48 1.95l-1.93-.48l.48-1.96m-3.85-.96l1.92.48l-.47 1.95l-1.93-.48l.48-1.95Z"/>'
        },
        "led-variant-off": {
            body: '<path fill="currentColor" d="M12 3c-1.95 0-3.57 1.4-3.92 3.25L16.82 15H18v-2h-2V7a4 4 0 0 0-4-4M3.28 4L2 5.27l6 6V13H6v2h3v6h2v-6h.73L13 16.27V21h2v-2.73L18.73 22L20 20.72l-5-5l-7-7L3.28 4Z"/>'
        },
        "led-variant-on": {
            body: '<path fill="currentColor" d="M12 3a4 4 0 0 0-4 4v6H6v2h3v6h2v-6h2v6h2v-6h3v-2h-2V7a4 4 0 0 0-4-4Z"/>'
        },
        "led-variant-outline": {
            body: '<path fill="currentColor" d="M12 3a4 4 0 0 0-4 4v6H6v2h3v6h2v-6h2v6h2v-6h3v-2h-2V7a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2v5h-4V7a2 2 0 0 1 2-2Z"/>'
        },
        leek: {
            body: '<path fill="currentColor" d="M10 2v3.55l2 2l2-2V2h-4M6.34 4L3.87 6.5L15 17.62v-4.95L6.34 4m11.32 0l-4.6 4.61l2.48 2.48l4.59-4.59L17.66 4M9 13.74V20a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-.26l-2-2V20h-2v-4.26l-2-2Z"/>'
        },
        "less-than": {
            body: '<path fill="currentColor" d="m18.5 4.14l1 1.72L8.97 12l10.53 6.14l-1 1.72L5 12l13.5-7.86Z"/>'
        },
        "less-than-or-equal": {
            body: '<path fill="currentColor" d="M18.5 2.27L5 10.14L18.5 18l1-1.73l-10.53-6.13L19.5 4l-1-1.73M5 20v2h15v-2H5Z"/>'
        },
        library: {
            body: '<path fill="currentColor" d="M12 8a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0 3.54C9.64 9.35 6.5 8 3 8v11c3.5 0 6.64 1.35 9 3.54c2.36-2.19 5.5-3.54 9-3.54V8c-3.5 0-6.64 1.35-9 3.54Z"/>'
        },
        "library-books": {
            body: '<path d="M19 7H9V5h10m-4 10H9v-2h6m4-2H9V9h10m1-7H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6z" fill="currentColor"/>',
            hidden: true
        },
        "library-outline": {
            body: '<path fill="currentColor" d="M12 14.27L10.64 13A11.242 11.242 0 0 0 5 10.18v6.95c2.61.34 5 1.34 7 2.82c2-1.48 4.39-2.48 7-2.82v-6.95c-2.16.39-4.09 1.39-5.64 2.82M19 8.15c.65-.1 1.32-.15 2-.15v11c-3.5 0-6.64 1.35-9 3.54C9.64 20.35 6.5 19 3 19V8c.68 0 1.35.05 2 .15c2.69.41 5.1 1.63 7 3.39c1.9-1.76 4.31-2.98 7-3.39M12 6c.27 0 .5-.1.71-.29c.19-.21.29-.44.29-.71s-.1-.5-.29-.71C12.5 4.11 12.27 4 12 4s-.5.11-.71.29c-.18.21-.29.45-.29.71s.11.5.29.71c.21.19.45.29.71.29m2.12 1.12a2.997 2.997 0 1 1-4.24-4.24a2.997 2.997 0 1 1 4.24 4.24Z"/>'
        },
        "library-shelves": {
            body: '<path fill="currentColor" d="M19.5 9V1.5h-3V9h-3V1.5h-3V9h-3V1.5H4.65V9H3v1.5h18V9h-1.5m0 4.5h-3V21h-3v-7.5h-3V21h-3v-7.5H4.65V21H3v1.5h18V21h-1.5v-7.5Z"/>'
        },
        license: {
            body: '<path fill="currentColor" d="M9 10a3.04 3.04 0 0 1 3-3a3.04 3.04 0 0 1 3 3a3.04 3.04 0 0 1-3 3a3.04 3.04 0 0 1-3-3m3 9l4 1v-3.08A7.54 7.54 0 0 1 12 18a7.54 7.54 0 0 1-4-1.08V20m4-16a5.78 5.78 0 0 0-4.24 1.74A5.78 5.78 0 0 0 6 10a5.78 5.78 0 0 0 1.76 4.23A5.78 5.78 0 0 0 12 16a5.78 5.78 0 0 0 4.24-1.77A5.78 5.78 0 0 0 18 10a5.78 5.78 0 0 0-1.76-4.26A5.78 5.78 0 0 0 12 4m8 6a8.04 8.04 0 0 1-.57 2.8A7.84 7.84 0 0 1 18 15.28V23l-6-2l-6 2v-7.72A7.9 7.9 0 0 1 4 10a7.68 7.68 0 0 1 2.33-5.64A7.73 7.73 0 0 1 12 2a7.73 7.73 0 0 1 5.67 2.36A7.68 7.68 0 0 1 20 10Z"/>'
        },
        lifebuoy: {
            body: '<path fill="currentColor" d="M19.79 15.41c.95-2.17.95-4.66 0-6.82l-2.74 1.24c.6 1.38.6 2.95.01 4.34l2.73 1.24m-4.37-11.2a8.54 8.54 0 0 0-6.83 0l1.24 2.73c1.39-.59 2.96-.59 4.35.01l1.24-2.74M4.21 8.58a8.564 8.564 0 0 0 0 6.84l2.74-1.25c-.6-1.38-.6-2.96 0-4.35L4.21 8.58m4.38 11.21a8.5 8.5 0 0 0 6.83-.01l-1.24-2.73a5.5 5.5 0 0 1-4.34.01l-1.25 2.73M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 6a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4Z"/>'
        },
        "light-flood-down": {
            body: '<path fill="currentColor" d="M8 11H2V9h6c.55 0 1 .45 1 1s-.45 1-1 1m6.87-6.65l-.37.92l-6.32-.41L6.9 8H8c1.1 0 2 .9 2 2s-.9 2-2 2H5.27l-.86 2.12l4.8 4.12l-.38.92l1.86.76L16.72 5.1l-1.85-.75m5.94 1.94l.76 1.85l-2.31.96l-.76-1.85l2.31-.96m-2.03 7.28l2.77 1.15l-.76 1.85L18 15.42l.78-1.85m-2.63 7.66L14.3 22l-.96-2.31l1.85-.76l.96 2.3Z"/>'
        },
        "light-flood-up": {
            body: '<path fill="currentColor" d="M8 15H2v-2h6c.55 0 1 .45 1 1s-.45 1-1 1m8.72 3.9L10.69 4.08l-1.86.76l.38.92l-4.8 4.12l.86 2.12H8c1.1 0 2 .9 2 2s-.9 2-2 2H6.9l1.28 3.14l6.32-.41l.37.92l1.85-.75m4.09-1.19l-2.31-.96l.76-1.85l2.31.96l-.76 1.85m-2.03-7.28L18 8.58l2.79-1.15l.76 1.85l-2.77 1.15m-3.59-5.36l-1.85-.76L14.3 2l1.85.77l-.96 2.3Z"/>'
        },
        "light-recessed": {
            body: '<path fill="currentColor" d="M12 7C6.5 7 2 9.46 2 12.5S6.5 18 12 18s10-2.46 10-5.5S17.5 7 12 7m4.5 3c0 .4-1.6 1.54-4.5 1.54S7.5 10.4 7.5 10c0-.09.15-.26.4-.45C9.06 9.21 10.44 9 12 9s2.94.21 4.1.55c.25.19.4.36.4.45M12 16c-4.88 0-8-2.07-8-3.5c0-.69.73-1.5 2.03-2.21c.27 1.54 2.84 2.75 5.97 2.75s5.7-1.21 5.97-2.75C19.27 11 20 11.81 20 12.5c0 1.43-3.12 3.5-8 3.5Z"/>'
        },
        "light-switch": {
            body: '<path fill="currentColor" d="M8 6v12h8V6H8m6 4h-4V8h4v2m5.4-8.4C19 1.2 18.5 1 18 1H6c-.5 0-1 .2-1.4.6C4.2 2 4 2.5 4 3v18c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6h12c.5 0 1-.2 1.4-.6c.4-.4.6-.9.6-1.4V3c0-.5-.2-1-.6-1.4M18 21H6V3h12v18Z"/>'
        },
        "light-switch-off": {
            body: '<path fill="currentColor" d="M19.4 1.6C19 1.2 18.5 1 18 1H6c-.5 0-1 .2-1.4.6C4.2 2 4 2.5 4 3v18c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6h12c.5 0 1-.2 1.4-.6c.4-.4.6-.9.6-1.4V3c0-.5-.2-1-.6-1.4M18 21H6V3h12v18M8 6v12h8V6H8m7 11H9V7h6v10m-5-3h4v2h-4v-2Z"/>'
        },
        lightbulb: {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7M9 21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H9v1Z"/>'
        },
        "lightbulb-alert": {
            body: '<path fill="currentColor" d="M10 2C6.1 2 3 5.1 3 9c0 2.4 1.2 4.5 3 5.7V17c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-2.3c1.8-1.3 3-3.4 3-5.7c0-3.9-3.1-7-7-7M7 21c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-1H7v1m12-9V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "lightbulb-alert-outline": {
            body: '<path fill="currentColor" d="M10 2c3.9 0 7 3.1 7 7c0 2.4-1.2 4.5-3 5.7V17c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-2.3C4.2 13.5 3 11.4 3 9c0-3.9 3.1-7 7-7M7 21v-1h6v1c0 .6-.4 1-1 1H8c-.6 0-1-.4-1-1m3-17C7.2 4 5 6.2 5 9c0 2.1 1.2 3.8 3 4.6V16h4v-2.4c1.8-.8 3-2.5 3-4.6c0-2.8-2.2-5-5-5m9 8V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "lightbulb-auto": {
            body: '<path fill="currentColor" d="M9 2C5.13 2 2 5.13 2 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74c0-3.87-3.13-7-7-7M6 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H6v1m13-8h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 13m-2.15 5.65L18 15l1.15 3.65h-2.3Z"/>'
        },
        "lightbulb-auto-outline": {
            body: '<path fill="currentColor" d="M9 2c3.87 0 7 3.13 7 7c0 2.38-1.19 4.47-3 5.74V17c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-2.26C3.19 13.47 2 11.38 2 9c0-3.87 3.13-7 7-7M6 21v-1h6v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1M9 4C6.24 4 4 6.24 4 9c0 2.05 1.23 3.81 3 4.58V16h4v-2.42c1.77-.77 3-2.53 3-4.58c0-2.76-2.24-5-5-5m10 9h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 13m-2.15 5.65L18 15l1.15 3.65h-2.3Z"/>'
        },
        "lightbulb-cfl": {
            body: '<path fill="currentColor" d="M10.5 2A2.5 2.5 0 0 1 13 4.5V14h1V4.47c0-.91-.37-1.77-1-2.42c.17-.05.33-.05.5-.05A2.5 2.5 0 0 1 16 4.5V14h1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3h1V4.5A2.5 2.5 0 0 1 10.5 2m0 2c-.28 0-.5.22-.5.5V14h1V4.5c0-.28-.22-.5-.5-.5M9 20h6v1c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-1Z"/>'
        },
        "lightbulb-cfl-off": {
            body: '<path fill="currentColor" d="M14 4.47c0-.91-.37-1.77-1-2.42c.17-.05.33-.05.5-.05A2.5 2.5 0 0 1 16 4.5V14h1v1.18l-3-3V4.47m-4 .03c0-.28.22-.5.5-.5s.5.22.5.5v4.68l2 2V4.5a2.5 2.5 0 0 0-5 0v1.68l2 2V4.5M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1m11-.28L18.73 22l-4-4H8c-.55 0-1-.45-1-1v-3h1v-2.73l-6-6L3.28 4L20 20.72Z"/>'
        },
        "lightbulb-cfl-spiral": {
            body: '<path fill="currentColor" d="M11 2c-.16 0-.31.03-.45.1l-2 1C7.56 3.66 8 5 9 5c.16 0 .32-.05.45-.1l2-1C12.43 3.36 12 2 11 2m4 2a.96.96 0 0 0-.45.1l-6 3C7.56 7.68 8 9 9 9c.18 0 .32-.05.45-.1l6-3C16.41 5.43 16 4 15 4m0 4c-.16 0-.31.03-.45.1L8.7 11.03c-.5.22-.7.57-.7.97v2H7v3c0 .55.44 1 1 1h8c.55 0 1-.45 1-1v-3h-1v-1c0-.56-.45-1-1-1s-1 .45-1 1v1h-4v-1.38l5.45-2.72C16.42 9.34 16 8 15 8M9 20v1c0 .57.46 1 1 1h4c.56 0 1-.45 1-1v-1"/>'
        },
        "lightbulb-cfl-spiral-off": {
            body: '<path fill="currentColor" d="m15.45 9.9l-1.57.78l-1.5-1.5l2.17-1.08c.14-.07.29-.1.45-.1c1 0 1.42 1.34.45 1.9M11.22 8l4.23-2.1C16.41 5.43 16 4 15 4a.96.96 0 0 0-.45.1L9.72 6.5l1.5 1.5m9.62 14.73L16.09 18H8c-.56 0-1-.45-1-1v-3h1v-2c0-.4.2-.75.7-.97l.3-.15L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M12.11 14l-1.61-1.62l-.5.24V14h2.11M9 21c0 .57.46 1 1 1h4c.56 0 1-.45 1-1v-1H9v1M9 5c.16 0 .32-.05.45-.1l2-1C12.43 3.36 12 2 11 2c-.16 0-.31.03-.45.1l-2 1C7.56 3.66 8 5 9 5Z"/>'
        },
        "lightbulb-fluorescent-tube": {
            body: '<path fill="currentColor" d="m7.05 2.81l-.55.53l-1.39-1.42l-1.24 1.24l1.41 1.42l-.7.7l-1.42-1.41l-1.24 1.24L3.34 6.5l-.53.55l14.14 14.14l.55-.53l1.39 1.42l1.24-1.24l-1.41-1.41l.7-.71l1.42 1.41l1.24-1.23l-1.42-1.4l.53-.55L7.05 2.81Z"/>'
        },
        "lightbulb-fluorescent-tube-outline": {
            body: '<path fill="currentColor" d="m7.05 2.81l-.55.53l-1.39-1.42l-1.24 1.24l1.41 1.42l-.7.7l-1.42-1.41l-1.24 1.24L3.34 6.5l-.53.55l1.41 1.41l11.32 11.32l1.41 1.41l.55-.53l1.39 1.42l1.24-1.24l-1.41-1.41l.71-.71l1.41 1.41l1.24-1.24l-1.42-1.39l.53-.55l-1.41-1.41L8.46 4.22M7.05 5.64l11.31 11.31l-1.41 1.41L5.64 7.05Z"/>'
        },
        "lightbulb-group": {
            body: '<path fill="currentColor" d="M15 14v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a5 5 0 1 1 6 0m-1 4h-4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m-7 0v-1H5v1a1 1 0 0 0 1 1h1.17A2.93 2.93 0 0 1 7 19m-2-9a6.79 6.79 0 0 1 .68-3A4 4 0 0 0 4 14.45V16a1 1 0 0 0 1 1h2v-2.12A6.92 6.92 0 0 1 5 10m12 8v1a2.93 2.93 0 0 1-.17 1H18a1 1 0 0 0 1-1v-1m-.68-11a6.79 6.79 0 0 1 .68 3a6.92 6.92 0 0 1-2 4.88V17h2a1 1 0 0 0 1-1v-1.55A4 4 0 0 0 18.32 7Z"/>'
        },
        "lightbulb-group-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L18.09 20h-1.26c.11-.32.17-.66.17-1v-.11l-2.25-2.25c-.18.22-.44.36-.75.36h-4c-.55 0-1-.45-1-1v-2c-1.6-1.2-2.26-3.16-1.88-5L5.5 7.4C5.18 8.23 5 9.11 5 10c0 1.83.72 3.58 2 4.88V17H5c-.55 0-1-.45-1-1v-1.55a4.046 4.046 0 0 1-2-3.14C1.85 9.27 3.25 7.5 5.2 7.09L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M15 6c-1.78-1.33-4.14-1.28-5.87-.07l6.95 6.95A5 5 0 0 0 15 6m4.79 10.59c.12-.17.21-.37.21-.59v-1.55c1.91-1.11 2.57-3.55 1.46-5.45a3.997 3.997 0 0 0-3.14-2c.45.94.68 1.96.68 3c0 1.57-.53 3.09-1.5 4.31l2.29 2.28M10 19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-4v1m-3-1H5v1c0 .55.45 1 1 1h1.17c-.11-.32-.17-.66-.17-1v-1Z"/>'
        },
        "lightbulb-group-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L5.2 7.09C3.25 7.5 1.85 9.27 2 11.31c.12 1.31.86 2.48 2 3.14V16c0 .55.45 1 1 1h2v-2.12c-1.28-1.3-2-3.05-2-4.88c0-.89.18-1.77.5-2.6L7.12 9c-.38 1.84.28 3.8 1.88 5v2c0 .55.45 1 1 1h4c.31 0 .57-.14.75-.36L17 18.89V19c0 .34-.06.68-.17 1h1.26l2.75 2.73l1.27-1.27M9.23 11.12l1.64 1.64c-.76-.3-1.34-.9-1.64-1.64M13 15h-2v-2.11l2 2V15m-2.43-7.63L9.13 5.93C10.86 4.72 13.22 4.67 15 6c1.26.94 2 2.43 2 4c0 1.05-.33 2.05-.92 2.88l-1.45-1.45c.23-.43.37-.93.37-1.43c0-1.66-1.33-3-3-3c-.5 0-1 .14-1.43.37m6.93 6.94c.97-1.22 1.5-2.74 1.5-4.31c0-1.04-.23-2.06-.68-3c1.31.11 2.48.85 3.14 2c1.11 1.9.45 4.34-1.46 5.45V16c0 .22-.09.42-.21.59l-2.29-2.28M10 18h4v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1m-3 1c0 .34.06.68.17 1H6c-.55 0-1-.45-1-1v-1h2v1Z"/>'
        },
        "lightbulb-group-outline": {
            body: '<path fill="currentColor" d="M7 19a2.93 2.93 0 0 0 .17 1H6a1 1 0 0 1-1-1v-1h2m3 1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h-4m-6-2a1 1 0 0 0 1 1h2v-2.12A6.92 6.92 0 0 1 5 10a6.79 6.79 0 0 1 .68-3A4 4 0 0 0 4 14.45M17 19a2.93 2.93 0 0 1-.17 1H18a1 1 0 0 0 1-1v-1h-2m0-8a5 5 0 0 1-2 4v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a5 5 0 1 1 8-4m-2 0a3 3 0 1 0-4 2.82V15h2v-2.18A3 3 0 0 0 15 10m3.32-3a6.79 6.79 0 0 1 .68 3a6.92 6.92 0 0 1-2 4.88V17h2a1 1 0 0 0 1-1v-1.55A4 4 0 0 0 18.32 7Z"/>'
        },
        "lightbulb-multiple": {
            body: '<path fill="currentColor" d="M17 16v2c0 .55-.47 1-1 1h-4c-.58 0-1-.45-1-1v-2c-2.23-1.66-2.68-4.79-1-7s4.77-2.66 7-1s2.63 4.79 1 7c-.31.38-.65.72-1 1m-1 4h-4v1c0 .55.42 1 1 1h2c.53 0 1-.45 1-1m-8.34-6H7v1c0 .55.42 1 1 1h1v-.12c-.56-.55-1-1.18-1.34-1.88m5.92-10C12.46 2.47 9.5 1.33 7 2.45S3.31 6.5 4.43 9.04C4.77 9.81 5.3 10.5 6 11v2c0 .55.42 1 1 1h.28c-.21-.65-.31-1.32-.28-2c-.03-3.71 2.87-6.79 6.58-7Z"/>'
        },
        "lightbulb-multiple-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-4.1-4.1c-.19.22-.45.37-.74.37h-4c-.58 0-1-.45-1-1v-2a4.917 4.917 0 0 1-1.9-5L7.5 9.39c-.33.81-.53 1.69-.5 2.61c-.03.68.07 1.35.28 2H7c-.58 0-1-.45-1-1v-2c-.7-.5-1.23-1.19-1.57-1.96A5 5 0 0 1 4.12 6L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M13.58 5C12.46 2.47 9.5 1.33 7 2.45c-.32.13-.61.3-.87.48l3.54 3.54A7.01 7.01 0 0 1 13.58 5m4.48 9.86C19.6 12.66 19.14 9.62 17 8a5.032 5.032 0 0 0-5.88-.08l6.94 6.94M12 21c0 .55.42 1 1 1h2c.53 0 1-.45 1-1v-1h-4v1m-5-6v1c0 .55.42 1 1 1h1v-.12c-.57-.55-1-1.18-1.34-1.88H7Z"/>'
        },
        "lightbulb-multiple-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l3.03 3.03C3.93 7 4 8.05 4.45 9.04c.34.77.88 1.46 1.55 1.96v2c0 .55.45 1 1 1h.3c-.2-.65-.3-1.32-.3-2c0-.92.19-1.79.5-2.59L9.11 11c-.06.33-.11.66-.11 1c0 1.57.74 3.06 2 4v2c0 .55.45 1 1 1h4c.31 0 .57-.14.75-.36l4.09 4.09l1.27-1.27m-10.88-8.34l1.64 1.64c-.77-.32-1.34-.91-1.64-1.64M15 17h-2v-2.11l2 2V17M9.69 6.5L6.14 2.94c.27-.19.56-.36.86-.5c2.53-1.11 5.5.03 6.6 2.56a6.87 6.87 0 0 0-3.91 1.5m1.43 1.42C11.94 7.35 12.93 7 14 7c1.57 0 3.06.74 4 2c1.33 1.78 1.28 4.14.07 5.87l-1.45-1.45c.08-.14.15-.28.21-.42c.55-1.57-.27-3.28-1.83-3.84c-.84-.29-1.71-.19-2.43.21l-1.45-1.45M7.68 15c.32.7.78 1.33 1.32 1.88V17H8c-.55 0-1-.45-1-1v-1h.68M12 20h4v1c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-1Z"/>'
        },
        "lightbulb-multiple-outline": {
            body: '<path fill="currentColor" d="M12 21c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-4m2-13a5.002 5.002 0 0 0-3 9v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2a4.997 4.997 0 0 0 1-7c-.94-1.26-2.43-2-4-2m1 7.82V17h-2v-2.18A3 3 0 0 1 11.17 11A3.003 3.003 0 0 1 15 9.16c1.56.56 2.38 2.27 1.83 3.84c-.3.85-.98 1.5-1.83 1.82M7.68 15H7v1c0 .55.45 1 1 1h1v-.12c-.54-.55-1-1.18-1.32-1.88M13.6 5C12.5 2.47 9.53 1.33 7 2.45S3.34 6.5 4.45 9.04c.34.77.88 1.46 1.55 1.96v2c0 .55.45 1 1 1h.3c-.2-.65-.3-1.32-.3-2c0-3.71 2.89-6.79 6.6-7Z"/>'
        },
        "lightbulb-night": {
            body: '<path fill="currentColor" d="M6 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H6v1m7-4.68V17c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-2.26C3.19 13.47 2 11.38 2 9c0-3.87 3.13-7 7-7c1.65 0 3.16.57 4.35 1.5C10.8 4.57 9 7.07 9 10c0 2.79 1.64 5.19 4 6.32m7.92-6.38l-1.42-.91l-1.4.97l.4-1.65l-1.33-1.03l1.68-.11l.56-1.61l.63 1.58l1.68.04l-1.3 1.08l.5 1.64M19.39 13c-1.89 2.27-5.36 2.19-7.17-.05C10 10.13 11.56 6 15 5.34c.34-.05.64.29.5.63c-.45 1.28-.38 2.74.35 4a4.622 4.622 0 0 0 3.27 2.28c.35.05.5.49.27.75Z"/>'
        },
        "lightbulb-night-outline": {
            body: '<path fill="currentColor" d="M6 20h6v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-1m5-5.11V16H7v-2.42C5.23 12.81 4 11.05 4 9c0-2.76 2.24-5 5-5c.9 0 1.73.26 2.46.67c.54-.47 1.2-.86 1.89-1.17C12.16 2.57 10.65 2 9 2C5.13 2 2 5.13 2 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-.68c-.75-.36-1.43-.82-2-1.43m9.92-4.95l-.5-1.64l1.3-1.08l-1.68-.04l-.63-1.58l-.56 1.61l-1.68.11l1.33 1.03l-.4 1.65l1.4-.97l1.42.91m-1.8 2.31a4.622 4.622 0 0 1-3.27-2.28c-.73-1.26-.8-2.72-.35-4c.14-.34-.16-.68-.5-.63c-3.44.66-5 4.79-2.78 7.61c1.81 2.24 5.28 2.32 7.17.05c.23-.26.08-.7-.27-.75Z"/>'
        },
        "lightbulb-off": {
            body: '<path fill="currentColor" d="M12 2C9.76 2 7.78 3.05 6.5 4.68l9.81 9.82C17.94 13.21 19 11.24 19 9a7 7 0 0 0-7-7M3.28 4L2 5.27L5.04 8.3C5 8.53 5 8.76 5 9c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h5.73l4 4L20 20.72L3.28 4M9 20v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H9Z"/>'
        },
        "lightbulb-off-outline": {
            body: '<path fill="currentColor" d="M12 2C9.76 2 7.78 3.05 6.5 4.68l1.43 1.43C8.84 4.84 10.32 4 12 4a5 5 0 0 1 5 5c0 1.68-.84 3.16-2.11 4.06l1.42 1.44C17.94 13.21 19 11.24 19 9a7 7 0 0 0-7-7M3.28 4L2 5.27L5.04 8.3C5 8.53 5 8.76 5 9c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h5.73l4 4L20 20.72L3.28 4m3.95 6.5l5.5 5.5H10v-2.42a5.004 5.004 0 0 1-2.77-3.08M9 20v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H9Z"/>'
        },
        "lightbulb-on": {
            body: '<path fill="currentColor" d="M12 6a6 6 0 0 1 6 6c0 2.22-1.21 4.16-3 5.2V19a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1.8c-1.79-1.04-3-2.98-3-5.2a6 6 0 0 1 6-6m2 15v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4m6-10h3v2h-3v-2M1 11h3v2H1v-2M13 1v3h-2V1h2M4.92 3.5l2.13 2.14l-1.42 1.41L3.5 4.93L4.92 3.5m12.03 2.13l2.12-2.13l1.43 1.43l-2.13 2.12l-1.42-1.42Z"/>'
        },
        "lightbulb-on-10": {
            body: '<path fill="currentColor" d="M1 11h3v2H1v-2m18.1-7.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M11 1h2v3h-2V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M10 22c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m2-16c-3.3 0-6 2.7-6 6c0 2.2 1.2 4.2 3 5.2V19c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-1.8c1.8-1 3-3 3-5.2c0-3.3-2.7-6-6-6m1 9.9V17h-2v-1.1c-1.7-.4-3-2-3-3.9c0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.9-1.3 3.4-3 3.9m7-4.9h3v2h-3v-2Z"/>'
        },
        "lightbulb-on-20": {
            body: '<path fill="currentColor" d="M1 11h3v2H1v-2m3.9-7.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1h-2v3h2V1m7 10v2h3v-2h-3M10 22c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m9.1-18.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M18 12c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4Z"/>'
        },
        "lightbulb-on-30": {
            body: '<path fill="currentColor" d="M7 5.6L5.6 7L3.5 4.9l1.4-1.4L7 5.6M1 13h3v-2H1v2M13 1h-2v3h2V1m5 11c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 1.2.54 2.27 1.38 3h5.24c.84-.73 1.38-1.8 1.38-3m-6 10c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m10-11v2h3v-2h-3m-.9-7.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4Z"/>'
        },
        "lightbulb-on-40": {
            body: '<path fill="currentColor" d="M1 11h3v2H1v-2M13 1h-2v3h2V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5m14.2 0L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M10 22c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m10-11v2h3v-2h-3m-2 1c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 .74.22 1.41.57 2h6.86c.35-.59.57-1.26.57-2Z"/>'
        },
        "lightbulb-on-50": {
            body: '<path fill="currentColor" d="M1 11h3v2H1v-2m9 11c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m3-21h-2v3h2V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M20 11v2h3v-2h-3m-.9-7.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M18 12c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6M8 12c0 .35.05.68.14 1h7.72c.09-.32.14-.65.14-1c0-2.21-1.79-4-4-4s-4 1.79-4 4Z"/>'
        },
        "lightbulb-on-60": {
            body: '<path fill="currentColor" d="M10 21h4v1c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-1m-9-8h3v-2H1v2m3.9-9.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1h-2v3h2V1m7 10v2h3v-2h-3m-2 1c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6M8 12h8c0-2.21-1.79-4-4-4s-4 1.79-4 4m11.1-8.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4Z"/>'
        },
        "lightbulb-on-70": {
            body: '<path fill="currentColor" d="M7 5.6L5.6 7L3.5 4.9l1.4-1.4L7 5.6M13 1h-2v3h2V1M1 13h3v-2H1v2m9 9c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m9.1-18.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M18 12c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-9.86-1h7.72c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3M20 11v2h3v-2h-3Z"/>'
        },
        "lightbulb-on-80": {
            body: '<path fill="currentColor" d="M7 5.6L5.6 7L3.5 4.9l1.4-1.4L7 5.6M1 13h3v-2H1v2M13 1h-2v3h2V1m-3 21c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m10-11v2h3v-2h-3m-.9-7.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M18 12c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-9.44-2h6.88C14.75 8.81 13.5 8 12 8s-2.75.81-3.44 2Z"/>'
        },
        "lightbulb-on-90": {
            body: '<path fill="currentColor" d="M7 5.6L5.6 7L3.5 4.9l1.4-1.4L7 5.6M10 22c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h-4v1m-9-9h3v-2H1v2M13 1h-2v3h2V1m7 10v2h3v-2h-3m-.9-7.5L17 5.6L18.4 7l2.1-2.1l-1.4-1.4M18 12c0 2.2-1.2 4.2-3 5.2V19c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1v-1.8c-1.8-1-3-3-3-5.2c0-3.3 2.7-6 6-6s6 2.7 6 6m-6-4c-1 0-1.91.38-2.61 1h5.22C13.91 8.38 13 8 12 8Z"/>'
        },
        "lightbulb-on-outline": {
            body: '<path fill="currentColor" d="M20 11h3v2h-3v-2M1 11h3v2H1v-2M13 1v3h-2V1h2M4.92 3.5l2.13 2.14l-1.42 1.41L3.5 4.93L4.92 3.5m12.03 2.13l2.12-2.13l1.43 1.43l-2.13 2.12l-1.42-1.42M12 6a6 6 0 0 1 6 6c0 2.22-1.21 4.16-3 5.2V19a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1.8c-1.79-1.04-3-2.98-3-5.2a6 6 0 0 1 6-6m2 15v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4m-3-3h2v-2.13c1.73-.44 3-2.01 3-3.87a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 1.86 1.27 3.43 3 3.87V18Z"/>'
        },
        "lightbulb-outline": {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7M9 21v-1h6v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1m3-17a5 5 0 0 0-5 5c0 2.05 1.23 3.81 3 4.58V16h4v-2.42c1.77-.77 3-2.53 3-4.58a5 5 0 0 0-5-5Z"/>'
        },
        "lightbulb-question": {
            body: '<path fill="currentColor" d="M8 2C4.1 2 1 5.1 1 9c0 2.4 1.2 4.5 3 5.7V17c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-2.3c1.8-1.3 3-3.4 3-5.7c0-3.9-3.1-7-7-7M5 21c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-1H5v1m15.5-6.5V16H19v-1.5h1.5m-2-5H17V9c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1-.5 1.9-1.3 2.4l-.3.2c-.6.4-.9 1-.9 1.7v.2H19v-.2c0-1.2.6-2.3 1.6-2.9l.3-.2c.4-.3.6-.7.6-1.2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v.5Z"/>'
        },
        "lightbulb-question-outline": {
            body: '<path fill="currentColor" d="M8 2c3.9 0 7 3.1 7 7c0 2.4-1.2 4.5-3 5.7V17c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-2.3C2.2 13.5 1 11.4 1 9c0-3.9 3.1-7 7-7M5 21v-1h6v1c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1M8 4C5.2 4 3 6.2 3 9c0 2.1 1.2 3.8 3 4.6V16h4v-2.4c1.8-.8 3-2.5 3-4.6c0-2.8-2.2-5-5-5m12.5 10.5V16H19v-1.5h1.5m-2-5H17V9c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1-.5 1.9-1.3 2.4l-.3.2c-.6.4-.9 1-.9 1.7v.2H19v-.2c0-1.2.6-2.3 1.6-2.9l.3-.2c.4-.3.6-.7.6-1.2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v.5Z"/>'
        },
        "lightbulb-spot": {
            body: '<path fill="currentColor" d="M9 19h2v3H9v-3m4 3h2v-3h-2v3M2 2v2h20V2H2m7 12v3h6v-3c2.5-1.43 5-3 5-8H4c0 5 2.5 6.57 5 8Z"/>'
        },
        "lightbulb-spot-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L15.11 17H9v-3c-2.5-1.43-5-3-5-8v-.11L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M22 4V2H5.2l2 2H22m-2 2H9.2l7.17 7.17C18.33 11.87 20 10.07 20 6m-7 16h2v-3h-2v3m-4 0h2v-3H9v3Z"/>'
        },
        "lightbulb-variant": {
            body: '<path fill="currentColor" d="M9 20h6v1c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-1M19 9c0 2.38-1.19 4.47-3 5.74V17c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-2.26C6.19 13.47 5 11.38 5 9c0-3.87 3.13-7 7-7s7 3.13 7 7m-4.29-.71c-.39-.39-1.03-.39-1.42 0L12 9.59l-1.29-1.3c-.39-.39-1.03-.39-1.42 0c-.39.39-.39 1.03 0 1.42l1.71 1.7V16h2v-4.59l1.71-1.7c.39-.39.39-1.03 0-1.42Z"/>'
        },
        "lightbulb-variant-outline": {
            body: '<path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74c0-3.87-3.13-7-7-7m2 11.58V16h-1v-4.59l1.71-1.7c.39-.39.39-1.03 0-1.42c-.39-.39-1.03-.39-1.42 0L12 9.59l-1.29-1.3c-.39-.39-1.03-.39-1.42 0c-.39.39-.39 1.03 0 1.42l1.71 1.7V16h-1v-2.42C8.23 12.81 7 11.05 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.05-1.23 3.81-3 4.58M9 20h6v1c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-1Z"/>'
        },
        lighthouse: {
            body: '<path fill="currentColor" d="M8 10V8h1V4H8V3l4-2l4 2v1h-1v4h1v2h-1.26l-6.3 3.64L9 10H8m5-2V4h-2v4h2M7 23l.04-.24l9.11-5.26l.52 3.38L13 23H7m1.05-6.83L15.31 12l.52 3.37l-8.4 4.85l.62-4.05Z"/>'
        },
        "lighthouse-on": {
            body: '<path fill="currentColor" d="M1 10V2l9 3v2l-9 3m7 0V8h5V4H8V3l4-2l4 2v1h-1v4h1v2h-1.26l-6.3 3.64L9 10H8M7 23l.04-.24l9.11-5.26l.52 3.38L13 23H7m1.05-6.83L15.31 12l.52 3.37l-8.4 4.85l.62-4.05Z"/>'
        },
        "lightning-bolt": {
            body: '<path fill="currentColor" d="M11 15H6l7-14v8h5l-7 14v-8Z"/>'
        },
        "lightning-bolt-circle": {
            body: '<path fill="currentColor" d="m11.5 20l4.86-9.73H13V4l-5 9.73h3.5V20M12 2c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12s-1 5.1-2.95 7.05C17.1 21 14.75 22 12 22s-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2Z"/>'
        },
        "lightning-bolt-outline": {
            body: '<path fill="currentColor" d="M11 9.47V11h3.76L13 14.53V13H9.24L11 9.47M13 1L6 15h5v8l7-14h-5V1Z"/>'
        },
        "line-scan": {
            body: '<path fill="currentColor" d="M17 22v-2h3v-3h2v3.5c0 .4-.2.7-.5 1c-.3.3-.7.5-1 .5H17M7 22H3.5c-.4 0-.7-.2-1-.5c-.3-.3-.5-.7-.5-1V17h2v3h3v2M17 2h3.5c.4 0 .7.2 1 .5c.3.3.5.6.5 1V7h-2V4h-3V2M7 2v2H4v3H2V3.5c0-.4.2-.7.5-1s.6-.5 1-.5H7m12 9H5v2h14v-2Z"/>'
        },
        lingerie: {
            body: '<path fill="currentColor" d="M22 7h-2V2h-2v2.34l-6 2.57l-6-2.57V2H4v5H2v2h2.05c.25 2.25 2.14 4 4.45 4c1.42 0 2.68-.67 3.5-1.7c.83 1.03 2.08 1.7 3.5 1.7c2.31 0 4.2-1.75 4.45-4H22V7M8.5 11A2.5 2.5 0 0 1 6 8.5v-2l5 2.15C10.9 9.96 9.83 11 8.5 11M18 8.5a2.5 2.5 0 0 1-2.5 2.5c-1.33 0-2.4-1.04-2.5-2.35l5-2.15v2M2 15v2h1c2.97 0 5.43 2.17 5.91 5h6.18c.48-2.83 2.94-5 5.91-5h1v-2H2m11.59 5h-3.18a8.085 8.085 0 0 0-2.12-3h7.42c-.92.82-1.65 1.84-2.12 3Z"/>'
        },
        link: {
            body: '<path fill="currentColor" d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7a5 5 0 0 0-5 5a5 5 0 0 0 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8v2m9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1c0 1.71-1.39 3.1-3.1 3.1h-4V17h4a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "link-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8 13h-1c-1.61 0-4-1.06-4-4c0-2.93 2.39-4 4-4h1v2h-1c-.46 0-2 .17-2 2c0 1.9 1.67 2 2 2h1v2m4-5v2H9v-2h6m-1 5h-1v-2h1c.46 0 2-.17 2-2c0-1.9-1.67-2-2-2h-1V8h1c1.61 0 4 1.07 4 4c0 2.94-2.39 4-4 4Z"/>'
        },
        "link-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-8-3h-1c-1.61 0-4-1.06-4-4c0-2.93 2.39-4 4-4h1v2h-1c-.46 0-2 .17-2 2c0 1.9 1.67 2 2 2h1v2m3 0h-1v-2h1c.46 0 2-.17 2-2c0-1.9-1.67-2-2-2h-1V8h1c1.61 0 4 1.07 4 4c0 2.94-2.39 4-4 4m1-3H9v-2h6v2Z"/>'
        },
        "link-box-variant": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5.06 11.81L11.73 17c-.65.67-1.51 1-2.37 1c-.86 0-1.72-.33-2.36-1c-1.33-1.29-1.33-3.42 0-4.74l1.35-1.36l-.01.6c-.01.5.07 1 .23 1.44l.05.15l-.4.41a1.597 1.597 0 0 0 0 2.28c.61.62 1.67.62 2.28 0l2.2-2.19c.3-.31.48-.72.48-1.15c0-.44-.18-.83-.48-1.14a.87.87 0 0 1 0-1.24c.33-.33.91-.32 1.24 0c.63.64.98 1.48.98 2.38c0 .9-.35 1.74-.98 2.37M17 11.74l-1.34 1.36v-.6c.01-.5-.07-1-.23-1.44l-.05-.14l.4-.42a1.597 1.597 0 0 0 0-2.28c-.61-.62-1.68-.61-2.28 0l-2.2 2.2c-.3.3-.48.71-.48 1.14c0 .44.18.83.48 1.14c.17.16.26.38.26.62s-.09.46-.26.62a.86.86 0 0 1-.62.25c-.22 0-.45-.08-.62-.25a3.362 3.362 0 0 1 0-4.75L12.27 7A3.311 3.311 0 0 1 17 7c.65.62 1 1.46 1 2.36c0 .9-.35 1.74-1 2.38Z"/>'
        },
        "link-box-variant-outline": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-5.06-8.94c.63.64.98 1.48.98 2.38c0 .9-.35 1.74-.98 2.37L11.73 17c-.65.67-1.51 1-2.37 1c-.86 0-1.72-.33-2.36-1c-1.33-1.29-1.33-3.42 0-4.74l1.35-1.36l-.01.6c-.01.5.07 1 .23 1.44l.05.15l-.4.41a1.597 1.597 0 0 0 0 2.28c.61.62 1.67.62 2.28 0l2.2-2.19c.3-.31.48-.72.48-1.15c0-.44-.18-.83-.48-1.14a.87.87 0 0 1 0-1.24c.33-.33.91-.32 1.24 0m4.06-.7c0 .9-.35 1.74-1 2.38l-1.34 1.36v-.6c.01-.5-.07-1-.23-1.44l-.05-.14l.4-.42a1.597 1.597 0 0 0 0-2.28c-.61-.62-1.68-.61-2.28 0l-2.2 2.2c-.3.3-.48.71-.48 1.14c0 .44.18.83.48 1.14c.17.16.26.38.26.62s-.09.46-.26.62a.86.86 0 0 1-.62.25c-.22 0-.45-.08-.62-.25a3.362 3.362 0 0 1 0-4.75L12.27 7A3.311 3.311 0 0 1 17 7c.65.62 1 1.46 1 2.36Z"/>'
        },
        "link-lock": {
            body: '<path fill="currentColor" d="M23 16v-.5a2.5 2.5 0 0 0-5 0v.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 0h-3v-.5a1.5 1.5 0 0 1 3 0M7 8.9h4V7H7a5 5 0 0 0 0 10h4v-1.9H7a3.1 3.1 0 0 1 0-6.2M8 11v2h8v-2m-3 4.1V17h2v-1.9M17 7h-4v1.9h4a3.09 3.09 0 0 1 2.94 2.1a5.12 5.12 0 0 1 .56 0h1.4A5 5 0 0 0 17 7Z"/>'
        },
        "link-off": {
            body: '<path fill="currentColor" d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1c0 1.43-.98 2.63-2.31 3l1.46 1.44C20.88 15.61 22 13.95 22 12a5 5 0 0 0-5-5m-1 4h-2.19l2 2H16v-2M2 4.27l3.11 3.11A4.991 4.991 0 0 0 2 12a5 5 0 0 0 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1c0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74L3.27 3L2 4.27Z"/>'
        },
        "link-plus": {
            body: '<path fill="currentColor" d="M7 7h4v2H7a3 3 0 0 0-3 3a3 3 0 0 0 3 3h4v2H7a5 5 0 0 1-5-5a5 5 0 0 1 5-5m10 0a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3h-4V7h4m-9 4h8v2H8v-2m9 1h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "link-variant": {
            body: '<path fill="currentColor" d="M10.59 13.41c.41.39.41 1.03 0 1.42c-.39.39-1.03.39-1.42 0a5.003 5.003 0 0 1 0-7.07l3.54-3.54a5.003 5.003 0 0 1 7.07 0a5.003 5.003 0 0 1 0 7.07l-1.49 1.49c.01-.82-.12-1.64-.4-2.42l.47-.48a2.982 2.982 0 0 0 0-4.24a2.982 2.982 0 0 0-4.24 0l-3.53 3.53a2.982 2.982 0 0 0 0 4.24m2.82-4.24c.39-.39 1.03-.39 1.42 0a5.003 5.003 0 0 1 0 7.07l-3.54 3.54a5.003 5.003 0 0 1-7.07 0a5.003 5.003 0 0 1 0-7.07l1.49-1.49c-.01.82.12 1.64.4 2.43l-.47.47a2.982 2.982 0 0 0 0 4.24a2.982 2.982 0 0 0 4.24 0l3.53-3.53a2.982 2.982 0 0 0 0-4.24a.973.973 0 0 1 0-1.42Z"/>'
        },
        "link-variant-minus": {
            body: '<path fill="currentColor" d="M10.6 13.4a1 1 0 0 1-1.4 1.4a4.8 4.8 0 0 1 0-7l3.5-3.6a5.1 5.1 0 0 1 7.1 0a5.1 5.1 0 0 1 0 7.1l-1.5 1.5a6.4 6.4 0 0 0-.4-2.4l.5-.5a3.2 3.2 0 0 0 0-4.3a3.2 3.2 0 0 0-4.3 0l-3.5 3.6a2.9 2.9 0 0 0 0 4.2M23 18v2h-8v-2m1.2-4.3a4.8 4.8 0 0 0-1.4-4.5a1 1 0 0 0-1.4 1.4a2.9 2.9 0 0 1 0 4.2l-3.5 3.6a3.2 3.2 0 0 1-4.3 0a3.2 3.2 0 0 1 0-4.3l.5-.4a7.3 7.3 0 0 1-.4-2.5l-1.5 1.5a5.1 5.1 0 0 0 0 7.1a5.1 5.1 0 0 0 7.1 0l1.8-1.8a6 6 0 0 1 3.1-4.3Z"/>'
        },
        "link-variant-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-4.83-4.83l-2.61 2.61a5.003 5.003 0 0 1-7.07 0a5.003 5.003 0 0 1 0-7.07l1.49-1.49c-.01.82.12 1.64.4 2.43l-.47.47a2.982 2.982 0 0 0 0 4.24a2.982 2.982 0 0 0 4.24 0l2.62-2.6l-1.62-1.61c-.01.24-.11.49-.29.68c-.39.39-1.03.39-1.42 0A4.973 4.973 0 0 1 7.72 11L2 5.27m10.71-1.05a5.003 5.003 0 0 1 7.07 0a5.003 5.003 0 0 1 0 7.07l-1.49 1.49c.01-.82-.12-1.64-.4-2.42l.47-.48a2.982 2.982 0 0 0 0-4.24a2.982 2.982 0 0 0-4.24 0l-3.33 3.33l-1.41-1.42l3.33-3.33m.7 4.95c.39-.39 1.03-.39 1.42 0a4.999 4.999 0 0 1 1.23 5.06l-1.78-1.77c-.05-.68-.34-1.35-.87-1.87a.973.973 0 0 1 0-1.42Z"/>'
        },
        "link-variant-plus": {
            body: '<path fill="currentColor" d="M10.6 13.4a1 1 0 0 1-1.4 1.4a4.8 4.8 0 0 1 0-7l3.5-3.6a5.1 5.1 0 0 1 7.1 0a5.1 5.1 0 0 1 0 7.1l-1.5 1.5a6.4 6.4 0 0 0-.4-2.4l.5-.5a3.2 3.2 0 0 0 0-4.3a3.2 3.2 0 0 0-4.3 0l-3.5 3.6a2.9 2.9 0 0 0 0 4.2M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3m-3.8-4.3a4.8 4.8 0 0 0-1.4-4.5a1 1 0 0 0-1.4 1.4a2.9 2.9 0 0 1 0 4.2l-3.5 3.6a3.2 3.2 0 0 1-4.3 0a3.2 3.2 0 0 1 0-4.3l.5-.4a7.3 7.3 0 0 1-.4-2.5l-1.5 1.5a5.1 5.1 0 0 0 0 7.1a5.1 5.1 0 0 0 7.1 0l1.8-1.8a6 6 0 0 1 3.1-4.3Z"/>'
        },
        "link-variant-remove": {
            body: '<path fill="currentColor" d="M10.6 13.4a1 1 0 0 1-1.4 1.4a4.8 4.8 0 0 1 0-7l3.5-3.6a5.1 5.1 0 0 1 7.1 0a5.1 5.1 0 0 1 0 7.1l-1.5 1.5a6.4 6.4 0 0 0-.4-2.4l.5-.5a3.2 3.2 0 0 0 0-4.3a3.2 3.2 0 0 0-4.3 0l-3.5 3.6a2.9 2.9 0 0 0 0 4.2m5.6.3a4.8 4.8 0 0 0-1.4-4.5a1 1 0 0 0-1.4 1.4a2.9 2.9 0 0 1 0 4.2l-3.5 3.6a3.2 3.2 0 0 1-4.3 0a3.2 3.2 0 0 1 0-4.3l.5-.4a7.3 7.3 0 0 1-.4-2.5l-1.5 1.5a5.1 5.1 0 0 0 0 7.1a5.1 5.1 0 0 0 7.1 0l1.8-1.8a6 6 0 0 1 3.1-4.3m4.9 1.8L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1Z"/>'
        },
        linkedin: {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77Z"/>'
        },
        linode: {
            body: '<path d="M7.11 19.125l2.257 2.396l-.386-2.638l-2.411-2.371l.54 2.613zM9.542 22l-.022-.002l-.022-.006l-.017-.009l-.026-.02l-2.541-2.698a.12.12 0 0 1-.03-.058l-.628-3.034l-.002-.038a.12.12 0 0 1 .057-.088l.674-.413l-1.018-.959a.12.12 0 0 1-.035-.063l-.81-3.917l-.002-.04a.12.12 0 0 1 .057-.087l.01-.006l1.058-.503l-1.463-1.14a.12.12 0 0 1-.044-.07L3.66 3.643l-.001-.04l.006-.026a.12.12 0 0 1 .044-.056l.033-.017L8.571 2a.12.12 0 0 1 .088.007L12.2 3.715l.014.008a.12.12 0 0 1 .054.095l.22 5.163a.12.12 0 0 1-.064.112l-1.314.684l1.404.943l.007.005a.12.12 0 0 1 .046.097l.058 1.364l1.35-.825a.12.12 0 0 1 .128.002l.938.62l.025-1.224a.12.12 0 0 1 .057-.1l2.305-1.41a.12.12 0 0 1 .121-.002l2.731 1.513l.004.003a.12.12 0 0 1 .058.095v.023l-.38 2.806a.121.121 0 0 1-.044.077l-2.137 1.704a.118.118 0 0 1-.077.026a.124.124 0 0 1-.072-.026l-.791-.55l-.08 1.31a.12.12 0 0 1-.045.087L14.1 18.4l-.028.02a.119.119 0 0 1-.103-.001l-.026-.017l-1.091-.919l.076 1.788a.12.12 0 0 1-.045.1l-3.268 2.603l-.023.014a.116.116 0 0 1-.052.012zm7.344-8.8a.122.122 0 0 1 .054.098v.01l-.081 1.33l.747.519l.225-2.607l-2.529-1.575l-.023 1.164l1.607 1.061zm-3.008 2.179l-1.153-.88l.009.206a.119.119 0 0 1-.053.104l-.87.586l.946.772l.027.031a.12.12 0 0 1 .017.057l.039.903l1.06.893l-.022-2.672zm-7.719-.852l2.535 2.387l-.535-3.654l-2.734-2.277l.734 3.544zm-1.195-5.77l2.863 2.231l-.76-5.182l-3.115-1.938l1.012 4.889zm13.108 3.796l-.221 2.553l1.88-1.5l.336-2.482l-1.995 1.429zm-3.932 5.51l2.386-1.902l.159-2.617l-2.567 1.836l.022 2.683zm-1.452 1.158l-.117-2.735l-3.347 2.395l.407 2.775l3.057-2.435zM7.31 5.81l.772 5.271l4.164-2.167l-.21-4.92L7.31 5.811zm1.09 7.45l.552 3.77l3.538-2.383l-.154-3.627L8.4 13.26z" fill="currentColor"/>',
            hidden: true
        },
        linux: {
            body: '<path fill="currentColor" d="M14.62 8.35c-.42.28-1.75 1.04-1.95 1.19c-.39.31-.75.29-1.14-.01c-.2-.16-1.53-.92-1.95-1.19c-.48-.31-.45-.7.08-.92c1.64-.69 3.28-.64 4.91.03c.49.21.51.6.05.9m7.22 7.28c-.93-2.09-2.2-3.99-3.84-5.66a4.31 4.31 0 0 1-1.06-1.88c-.1-.33-.17-.67-.24-1.01c-.2-.88-.29-1.78-.7-2.61c-.73-1.58-2-2.4-3.84-2.47c-1.81.05-3.16.81-3.95 2.4c-.21.43-.36.88-.46 1.34c-.17.76-.32 1.55-.5 2.32c-.15.65-.45 1.21-.96 1.71c-1.61 1.57-2.9 3.37-3.88 5.35c-.14.29-.28.58-.37.88c-.19.66.29 1.12.99.96c.44-.09.88-.18 1.3-.31c.41-.15.57-.05.67.35c.65 2.15 2.07 3.66 4.24 4.5c4.12 1.56 8.93-.66 9.97-4.58c.07-.27.17-.37.47-.27c.46.14.93.24 1.4.35c.49.09.85-.16.92-.64c.03-.26-.06-.49-.16-.73"/>'
        },
        "linux-mint": {
            body: '<path fill="currentColor" d="M2 3.23V6.8h1.5c1.09 0 1.28.73 1.28 1.75v6.31c0 3.26 2.87 5.91 6.4 5.91h8.72c1.1 0 2.1-.7 2.1-1.77V9.2c0-3.27-2.87-5.92-6.4-5.92h-3.67v-.01L2 3.23m4.62 2.23h1.75v8.99c0 1.2.82 2.14 1.79 2.14l5.97.02c1.25 0 2.22-.86 2.22-1.88l-.01-4.77c0-.31-.1-.55-.34-.77a.94.94 0 0 0-.75-.33c-.31 0-.54.1-.75.33c-.23.22-.34.46-.34.77v4.09h-1.85V9.96c0-.31-.1-.55-.31-.77c-.23-.23-.46-.33-.78-.33c-.3 0-.54.1-.76.33c-.22.22-.32.46-.32.77v4.09h-1.85V9.96c0-.81.29-1.52.86-2.1c.57-.57 1.28-.86 2.07-.86c.78 0 1.46.28 2.02.82c.55-.54 1.23-.82 2.01-.82c.8 0 1.51.29 2.07.86c.57.58.87 1.29.87 2.1l.01 5.1c-.09.85-.45 1.61-1.07 2.25c-.73.73-1.63 1.11-2.63 1.11H9.83c-.83-.08-1.54-.47-2.14-1.06c-.69-.71-1.07-1.57-1.07-2.57V5.46Z"/>'
        },
        lipstick: {
            body: '<path fill="currentColor" d="M9 23c-.55 0-1-.45-1-1v-9c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H9m1-12c-.55 0-1-.45-1-1V5.25S11 3 11.75 1c1.08.67 2.17 1.33 2.71 2.83S15 7.67 15 10c0 .55-.45 1-1 1h-4Z"/>'
        },
        "liquid-spot": {
            body: '<path fill="currentColor" d="M18.14 16.7c-.91 1.51-2.06 1.03-3.14.39s-2.1-1.41-2.75-.5c-.71.78-.16 2.03.12 3.13c.28 1.11.3 2.07-1.47 2.28c-1.4-.19-1.32-1.35-1.09-2.58c.23-1.23.59-2.53-.31-2.99c-.72-.48-1.22.35-1.85 1.17c-.65.81-1.39 1.6-2.61 1.02c-1.1-.91-.68-1.44-.1-2.12s1.33-1.59.9-3.19c-.18-.65-1.08-.5-1.97-.52c-.87-.02-1.75-.2-1.84-1.5c-.07-.79.52-1.11 1.13-1.36c.62-.25 1.25-.43 1.26-1.06c.03-.61-.38-1.04-.64-1.49s-.37-.92.25-1.62c1.05-.86 1.89-.13 2.73.66s1.67 1.62 2.7.97c.82-.54.07-1.49-.51-2.42s-.99-1.82.51-2.23c1.3-.36 1.8.53 2.25 1.56c.46 1.03.86 2.2 1.96 2.41c1.57.29 2.71-1.55 3.8-3.01s2.16-2.55 3.53-.75c1.5 1.89.07 2.77-1.6 3.55c-1.67.73-3.59 1.37-3.13 2.78c.27.82 1.15.37 2.08.06c.92-.31 1.91-.48 2.39.93c.51 1.49-.7 1.83-2.06 1.97c-1.36.14-2.88.08-2.98.76c-.11.71.8 1 1.59 1.42c.79.43 1.46 1 .85 2.28M20.5 19c-.95 0-1.44-.74-1.44-1.5s.48-1.5 1.44-1.5c1 0 1.5.74 1.5 1.5s-.5 1.5-1.5 1.5Z"/>'
        },
        liquor: {
            body: '<path fill="currentColor" d="M3 14c0 1.3.8 2.4 2 2.8V20H3v2h6v-2H7v-3.2c1.2-.4 2-1.5 2-2.8V6H3v8m2-6h2v3H5V8m15.6.5l-1-.3c-.3-.1-.6-.5-.6-.9V3c0-.5-.5-1-1-1h-3c-.6 0-1 .5-1 1v4.3c0 .4-.3.8-.7 1l-.9.3c-.8.3-1.4 1-1.4 1.9V20c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-9.6c0-.8-.5-1.6-1.4-1.9M16 4h1v1h-1V4m-3 6.4l.9-.3c1.3-.4 2.1-1.5 2.1-2.8V7h1v.3c0 1.3.8 2.4 2 2.8l1 .3V12h-7v-1.6m7 9.6h-7v-2h7v2Z"/>'
        },
        "list-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M7 7h2v2H7V7m0 4h2v2H7v-2m0 4h2v2H7v-2m10 2h-6v-2h6v2m0-4h-6v-2h6v2m0-4h-6V7h6v2Z"/>'
        },
        "list-box-outline": {
            body: '<path fill="currentColor" d="M11 15h6v2h-6v-2M9 7H7v2h2V7m2 6h6v-2h-6v2m0-4h6V7h-6v2m-2 2H7v2h2v-2m12-6v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2m-2 0H5v14h14V5M9 15H7v2h2v-2Z"/>'
        },
        "list-status": {
            body: '<path fill="currentColor" d="M16.5 11L13 7.5l1.4-1.4l2.1 2.1L20.7 4l1.4 1.4l-5.6 5.6M11 7H2v2h9V7m10 6.4L19.6 12L17 14.6L14.4 12L13 13.4l2.6 2.6l-2.6 2.6l1.4 1.4l2.6-2.6l2.6 2.6l1.4-1.4l-2.6-2.6l2.6-2.6M11 15H2v2h9v-2Z"/>'
        },
        litecoin: {
            body: '<path fill="currentColor" d="m12.55 15.92l.61-2.14l1.65-.59l1.44-5.56l-1.69.68L16.25 2H8l-2.62 9.77l-1.66.57l-1.5 5.57L4 17.27L2.66 22h17.5l1.62-6.08h-9.23M19.39 21H4l1.46-5.35l-1.74.65l.86-3.19l1.66-.57L8.74 3H15l-1.87 7l1.7-.7l-.83 3.12l-1.67.58l-1.11 3.91h9.28L19.39 21Z"/>'
        },
        loading: {
            body: '<path fill="currentColor" d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8Z"/>'
        },
        "location-enter": {
            body: '<path fill="currentColor" d="m14 12l-4-4v3H2v2h8v3m12-4a10 10 0 0 1-19.54 3h2.13a8 8 0 1 0 0-6H2.46A10 10 0 0 1 22 12Z"/>'
        },
        "location-exit": {
            body: '<path fill="currentColor" d="m22 12l-4-4v3h-8v2h8v3m2 2a10 10 0 1 1 0-12h-2.73a8 8 0 1 0 0 12Z"/>'
        },
        lock: {
            body: '<path fill="currentColor" d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3Z"/>'
        },
        "lock-alert": {
            body: '<path fill="currentColor" d="M10 17c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m6-9c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h1V6c0-2.8 2.2-5 5-5s5 2.2 5 5v2h1m-6-5C8.3 3 7 4.3 7 6v2h6V6c0-1.7-1.3-3-3-3m12 10h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "lock-alert-outline": {
            body: '<path fill="currentColor" d="M10 17c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m6 3V10H4v10h12m0-12c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h1V6c0-2.8 2.2-5 5-5s5 2.2 5 5v2h1m-6-5C8.3 3 7 4.3 7 6v2h6V6c0-1.7-1.3-3-3-3m12 4h-2v6h2V7m0 8h-2v2h2v-2Z"/>'
        },
        "lock-check": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6a2 2 0 0 0-2 2v10c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6m3 11a2 2 0 1 1 2-2c0 1.11-.89 2-2 2m10.5.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "lock-check-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2m-.91 5c.12.72.37 1.39.72 2H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h1V6c0-2.76 2.24-5 5-5s5 2.24 5 5v2h1a2 2 0 0 1 2 2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V10H6v10h7.09M9 8h6V6c0-1.66-1.34-3-3-3S9 4.34 9 6v2m12.34 7.84l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "lock-clock": {
            body: '<path fill="currentColor" d="M8.5 2C6 2 4 4 4 6.5V7c-1.11 0-2 .89-2 2v9c0 1.11.89 2 2 2h4.72c1.46 1.29 3.34 2 5.28 2a8 8 0 0 0 8-8a8 8 0 0 0-8-8c-.34 0-.68.03-1 .08C12.76 3.77 10.82 2 8.5 2m0 2A2.5 2.5 0 0 1 11 6.5V7H6v-.5A2.5 2.5 0 0 1 8.5 4M14 8a6 6 0 0 1 6 6a6 6 0 0 1-6 6a6 6 0 0 1-6-6a6 6 0 0 1 6-6m-1 2v5l3.64 2.19l.78-1.29l-2.92-1.75V10H13Z"/>'
        },
        "lock-minus": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6a2 2 0 0 0-2 2v10c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6m3 11a2 2 0 1 1 2-2c0 1.11-.89 2-2 2m11 1v2h-8v-2h8Z"/>'
        },
        "lock-minus-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2m-.91 5c.12.72.37 1.39.72 2H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h1V6c0-2.76 2.24-5 5-5s5 2.24 5 5v2h1a2 2 0 0 1 2 2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V10H6v10h7.09M9 8h6V6c0-1.66-1.34-3-3-3S9 4.34 9 6v2m6 10v2h8v-2h-8Z"/>'
        },
        "lock-off": {
            body: '<path fill="currentColor" d="M9 5.82L7.36 4.16A4.987 4.987 0 0 1 12 1c2.76 0 5 2.24 5 5v2h1a2 2 0 0 1 2 2v6.8L11.2 8H15V6c0-1.66-1.34-3-3-3c-1.59 0-2.89 1.25-3 2.82m13.11 15.64l-1.27 1.27l-1.38-1.38c-.36.4-.88.65-1.46.65H6c-1.11 0-2-.89-2-2V10a2 2 0 0 1 2-2h.11l-5-5l1.28-1.27l19.72 19.73m-8.26-5.72l-2.59-2.59C10.5 13.44 10 14.16 10 15a2 2 0 0 0 2 2c.84 0 1.56-.5 1.85-1.26Z"/>'
        },
        "lock-off-outline": {
            body: '<path fill="currentColor" d="M9 5.82L7.36 4.16A4.987 4.987 0 0 1 12 1c2.76 0 5 2.24 5 5v2h1a2 2 0 0 1 2 2v6.8l-2-2V10h-4.8l-2-2H15V6c0-1.66-1.34-3-3-3c-1.59 0-2.89 1.25-3 2.82m13.11 15.64l-1.27 1.27l-1.38-1.38c-.36.4-.88.65-1.46.65H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h.11l-5-5l1.28-1.27l19.72 19.73M18 19.89l-4.15-4.15C13.56 16.5 12.84 17 12 17a2 2 0 0 1-2-2c0-.85.5-1.56 1.26-1.85L8.11 10H6v10h12v-.11Z"/>'
        },
        "lock-open": {
            body: '<path fill="currentColor" d="M18 8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9V6a3 3 0 0 0-3-3a3 3 0 0 0-3 3H7a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6 9a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2Z"/>'
        },
        "lock-open-alert": {
            body: '<path fill="currentColor" d="M16 8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h9V6c0-1.7-1.3-3-3-3S7 4.3 7 6H5c0-2.8 2.2-5 5-5s5 2.2 5 5v2h1m-6 9c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m12-4h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "lock-open-alert-outline": {
            body: '<path fill="currentColor" d="M16 20V10H4v10h12m0-12c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h9V6c0-1.7-1.3-3-3-3S7 4.3 7 6H5c0-2.8 2.2-5 5-5s5 2.2 5 5v2h1m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M22 7h-2v6h2V7m0 8h-2v2h2v-2Z"/>'
        },
        "lock-open-check": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7 4c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m10.5.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "lock-open-check-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m-8 5V10h12v3.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.35-.61-.59-1.28-.72-2H6m15.34-4.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "lock-open-minus": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7 4c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m11 1v2h-8v-2h8Z"/>'
        },
        "lock-open-minus-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m-8 5V10h12v3.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.35-.61-.59-1.28-.72-2H6m9-2v2h8v-2h-8Z"/>'
        },
        "lock-open-outline": {
            body: '<path fill="currentColor" d="M18 20V10H6v10h12m0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9V6a3 3 0 0 0-3-3a3 3 0 0 0-3 3H7a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6 9a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2Z"/>'
        },
        "lock-open-plus": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7 4c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m11 1v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "lock-open-plus-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m-8 5V10h12v3.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.35-.61-.59-1.28-.72-2H6m14-2v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "lock-open-remove": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7 4c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m8.41 2l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "lock-open-remove-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m-8 5V10h12v3.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.81c-.35-.61-.59-1.28-.72-2H6m16.54-3.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "lock-open-variant": {
            body: '<path fill="currentColor" d="M18 1c-2.76 0-5 2.24-5 5v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V10a2 2 0 0 0-2-2h-1V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2h2V6c0-2.76-2.24-5-5-5m-8 12a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4Z"/>'
        },
        "lock-open-variant-outline": {
            body: '<path fill="currentColor" d="M10 13a2 2 0 0 1 2 2c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2m8-12c-2.76 0-5 2.24-5 5v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2h-1V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2h2V6c0-2.76-2.24-5-5-5m-2 9v10H4V10h12Z"/>'
        },
        "lock-outline": {
            body: '<path fill="currentColor" d="M12 17a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m6 3V10H6v10h12m0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3Z"/>'
        },
        "lock-pattern": {
            body: '<path fill="currentColor" d="M7 3a4 4 0 0 1 4 4c0 1.86-1.27 3.43-3 3.87v2.26c.37.09.72.24 1.04.43l4.52-4.52C13.2 8.44 13 7.75 13 7a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4c-.74 0-1.43-.2-2-.55L10.45 15c.35.57.55 1.26.55 2a4 4 0 0 1-4 4a4 4 0 0 1-4-4c0-1.86 1.27-3.43 3-3.87v-2.26C4.27 10.43 3 8.86 3 7a4 4 0 0 1 4-4m10 10a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "lock-plus": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6a2 2 0 0 0-2 2v10c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6m3 11a2 2 0 1 1 2-2c0 1.11-.89 2-2 2m11 1v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "lock-plus-outline": {
            body: '<path fill="currentColor" d="M6 20V10h12v3.09c.33-.05.66-.09 1-.09c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2h7.81c-.35-.61-.59-1.28-.72-2H6M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6m5 9c0 1.11-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2m9 3v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "lock-question": {
            body: '<path fill="currentColor" d="M12 1a5 5 0 0 0-5 5v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5m0 1.9c1.71 0 3.1 1.39 3.1 3.1v2H8.9V6c0-1.71 1.39-3.1 3.1-3.1m.19 7.6c.94 0 1.69.21 2.23.62c.54.42.81.98.81 1.68c0 .44-.15.83-.44 1.2c-.29.36-.67.64-1.13.85c-.26.15-.43.3-.52.47c-.09.18-.14.4-.14.68h-2c0-.5.1-.84.29-1.08c.21-.24.55-.52 1.07-.84c.26-.14.47-.32.64-.54c.14-.21.22-.46.22-.74c0-.3-.09-.52-.27-.69c-.18-.18-.45-.26-.76-.26c-.27 0-.49.07-.69.21c-.16.14-.26.35-.26.63H9.27c-.05-.69.23-1.29.78-1.65c.54-.36 1.25-.54 2.14-.54M11 17h2v2h-2v-2Z"/>'
        },
        "lock-remove": {
            body: '<path fill="currentColor" d="M19 13c.34 0 .67.04 1 .09V10a2 2 0 0 0-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6a2 2 0 0 0-2 2v10c0 1.11.89 2 2 2h7.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6m3 11a2 2 0 1 1 2-2c0 1.11-.89 2-2 2m8.41 2l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "lock-remove-outline": {
            body: '<path fill="currentColor" d="M14 15c0 1.11-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2m-.91 5c.12.72.37 1.39.72 2H6a2 2 0 0 1-2-2V10c0-1.11.89-2 2-2h1V6c0-2.76 2.24-5 5-5s5 2.24 5 5v2h1a2 2 0 0 1 2 2v3.09c-.33-.05-.66-.09-1-.09c-.34 0-.67.04-1 .09V10H6v10h7.09M9 8h6V6c0-1.66-1.34-3-3-3S9 4.34 9 6v2m13.54 8.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "lock-reset": {
            body: '<path fill="currentColor" d="M12.63 2c5.53 0 10.01 4.5 10.01 10s-4.48 10-10.01 10c-3.51 0-6.58-1.82-8.37-4.57l1.58-1.25C7.25 18.47 9.76 20 12.64 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8C8.56 4 5.2 7.06 4.71 11h2.76l-3.74 3.73L0 11h2.69c.5-5.05 4.76-9 9.94-9m2.96 8.24c.5.01.91.41.91.92v4.61c0 .5-.41.92-.92.92h-5.53c-.51 0-.92-.42-.92-.92v-4.61c0-.51.41-.91.91-.92V9.23c0-1.53 1.25-2.77 2.77-2.77c1.53 0 2.78 1.24 2.78 2.77v1.01m-2.78-2.38c-.75 0-1.37.61-1.37 1.37v1.01h2.75V9.23c0-.76-.62-1.37-1.38-1.37Z"/>'
        },
        "lock-smart": {
            body: '<path fill="currentColor" d="M12 2a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6M8 6h2v2H8V6m3 0h2v2h-2V6m3 0h2v2h-2V6M8 9h2v2H8V9m3 0h2v2h-2V9m3 0h2v2h-2V9m-6 3h2v2H8v-2m3 0h2v2h-2v-2m3 0h2v2h-2v-2m-2 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        locker: {
            body: '<path fill="currentColor" d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v16h8V4H8m2 9h2v4h-2v-4m0-7h4v1.5h-4V6m0 3h4v1.5h-4V9Z"/>'
        },
        "locker-multiple": {
            body: '<path fill="currentColor" d="M3 2h18a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m10 2v16h8V4h-8M3 4v16h8V4H3m2 9h2v4H5v-4m0-7h4v1.5H5V6m0 3h4v1.5H5V9m10 4h2v4h-2v-4m0-7h4v1.5h-4V6m0 3h4v1.5h-4V9Z"/>'
        },
        login: {
            body: '<path fill="currentColor" d="M10 17v-3H3v-4h7V7l5 5l-5 5m0-15h9a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-2h2v2h9V4h-9v2H8V4a2 2 0 0 1 2-2Z"/>'
        },
        "login-variant": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8.92 12.58L11.5 17l5-5l-5-5l-1.42 1.41L12.67 11H3v2h9.67l-2.59 2.58Z"/>'
        },
        logout: {
            body: '<path fill="currentColor" d="M16 17v-3H9v-4h7V7l5 5l-5 5M14 2a2 2 0 0 1 2 2v2h-2V4H5v16h9v-2h2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9Z"/>'
        },
        "logout-variant": {
            body: '<path fill="currentColor" d="M14.08 15.59L16.67 13H7v-2h9.67l-2.59-2.59L15.5 7l5 5l-5 5l-1.42-1.41M19 3a2 2 0 0 1 2 2v4.67l-2-2V5H5v14h14v-2.67l2-2V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14Z"/>'
        },
        longitude: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10.03 10.03 0 0 0 12 2M9.4 19.6a8.05 8.05 0 0 1 0-15.2A16.45 16.45 0 0 0 7.5 12a16.45 16.45 0 0 0 1.9 7.6m2.6.4a13.81 13.81 0 0 1-2.5-8A13.81 13.81 0 0 1 12 4a13.81 13.81 0 0 1 2.5 8a13.81 13.81 0 0 1-2.5 8m2.6-.4a16.15 16.15 0 0 0 0-15.2A8.03 8.03 0 0 1 20 12a7.9 7.9 0 0 1-5.4 7.6Z"/>'
        },
        looks: {
            body: '<path fill="currentColor" d="M12 6A11 11 0 0 0 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2A11 11 0 0 0 12 6m0 4c-3.86 0-7 3.14-7 7h2a5 5 0 0 1 5-5a5 5 0 0 1 5 5h2c0-3.86-3.14-7-7-7Z"/>'
        },
        lotion: {
            body: '<path fill="currentColor" d="M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5M16 12v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 3 1l-1.44 1.44C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91Z"/>'
        },
        "lotion-outline": {
            body: '<path fill="currentColor" d="M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5M16 12v8c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-8c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 3 1l-1.44 1.44C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91m-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4v8h8v-8Z"/>'
        },
        "lotion-plus": {
            body: '<path fill="currentColor" d="M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5M13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2m3-2v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 3 1l-1.44 1.44C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91Z"/>'
        },
        "lotion-plus-outline": {
            body: '<path fill="currentColor" d="M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5M13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2m3-2v8c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-8c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 3 1l-1.44 1.44C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91m-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4v8h8v-8Z"/>'
        },
        loupe: {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10h8a2 2 0 0 0 2-2v-8A10 10 0 0 0 12 2m1 5h-2v4H7v2h4v4h2v-4h4v-2h-4V7Z"/>'
        },
        lumx: {
            body: '<path fill="currentColor" d="m12.35 1.75l7.78 7.78l-6.36 6.36l-1.42-1.42l4.95-4.94l-6.36-6.37l1.41-1.41m3.54 7.78l-1.42 1.41l-4.24-4.24l-4.95 4.95l-1.41-1.42l6.36-6.36l5.66 5.66m-5.66-1.42l1.42 1.42l-4.95 4.94l6.36 6.37l-1.41 1.41l-7.78-7.78l6.36-6.36m-2.12 6.36l1.42-1.41l4.24 4.24l4.95-4.95l1.41 1.42l-6.36 6.36l-5.66-5.66Z"/>'
        },
        lungs: {
            body: '<path fill="currentColor" d="M15.47 3.11c-.47-.26-1.1-.06-1.36.43c-.07.14-.11.3-.11.46v2.59l-.71-.71a.984.984 0 0 1-.29-.7V1h-2v4.17c0 .27-.1.52-.29.71l-.71.71V4c0-.56-.46-1-1-1c-.17 0-.33.04-.47.11C4.72 5 2 9.97 2 15.77c0 1.9.33 3.78 1 5.55a1.007 1.007 0 0 0 1.44.55l5.06-2.8c.31-.17.5-.51.5-.88V9.41l1.3-1.29a.996.996 0 0 1 1.41 0L14 9.42v8.78c0 .36.21.7.5.88l5.08 2.8a1 1 0 0 0 1.36-.42c.02-.04.06-.09.06-.14c.67-1.77 1-3.65 1-5.55C22 9.97 19.29 5 15.47 3.11Z"/>'
        },
        lyft: {
            body: '<path d="M9.56 12.5c0 .1-.06.22-.16.29a.49.49 0 0 1-.81-.38V8.5H5.66v4.89a2.44 2.44 0 0 0 2.44 2.44c.58 0 1.14-.21 1.58-.59c-.04.36-.25.69-.57.87c-.36.2-.76.31-1.17.3c-.48 0-.94-.11-1.38-.32L6.39 16v2.6c.65.26 1.35.4 2.05.4c1.03 0 2.02-.34 2.81-1c.83-.75 1.29-1.82 1.25-2.94V8.5H9.56v4m-4.63.89v-7.8H2v7.31c-.16 1.45.88 2.75 2.33 2.91c.08.01.17.02.23.02c.37 0 .73-.09 1.07-.24l.12-.09l-.1-.09c-.48-.56-.74-1.28-.72-2.02m17.07-2V8.5h-1c-.41-2.12-2.47-3.5-4.59-3.09c-.24.04-.47.09-.7.2a4.102 4.102 0 0 0-2.45 3.57v6.65h.13c1.56-.07 2.8-1.36 2.8-2.93h1.22V10h-1.26v-.83c0-.31.17-.6.44-.76a.998.998 0 0 1 1.51.83v2.69a3.84 3.84 0 0 0 3.77 3.9H22V12.9a1 1 0 0 1-1-1v-.49l1-.02z" fill="currentColor"/>',
            hidden: true
        },
        mace: {
            body: '<path fill="currentColor" d="M19.92 9.27c.05-.27.08-.51.08-.77s-.03-.5-.08-.77L23 8.5l-3.08.77m-5.23 3.65l.81 3.24l.81-3.24c-.26.05-.53.08-.81.08s-.55-.03-.81-.08m-2.99-2.03l-4.91 4.9l-.7-.7L1 20.17L3.83 23l5.08-5.09l-.7-.7l4.9-4.91c-.57-.36-1.05-.84-1.41-1.41m4.57-6.81L15.5 1l-.77 3.08c.27-.05.51-.08.77-.08s.5.03.77.08M8 8.5l3.08.77C11.03 9 11 8.76 11 8.5s.03-.5.08-.77L8 8.5m10.63 1.54c.23-.46.37-.98.37-1.54s-.14-1.08-.37-1.54L21 3l-3.96 2.37c-.46-.23-.98-.37-1.54-.37s-1.08.14-1.54.37L10 3l2.37 3.96c-.23.46-.37.98-.37 1.54c0 1.93 1.57 3.5 3.5 3.5c.56 0 1.08-.14 1.54-.37L21 14l-2.37-3.96Z"/>'
        },
        "magazine-pistol": {
            body: '<path fill="currentColor" d="m14 1l-2 2H7l2 18H8v2h10v-2L16 1M9 5h3l.24 2h-3m.23 2h3l.24 2h-3m.23 2h3l.24 2h-3m.23 2h3l.24 2h-3Z"/>'
        },
        "magazine-rifle": {
            body: '<path fill="currentColor" d="M7 1v2h1v10l-3 6l9 4l4-10V3h1V1m-9 2h6v2h-4.12v8.45L9.6 18.14L8 17.5l2-4Z"/>'
        },
        "magic-staff": {
            body: '<path fill="currentColor" d="M17.5 9a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5m-3.07-.85L2 20.59L3.41 22L15.85 9.57c-.6-.33-1.09-.82-1.42-1.42M13 5l.63-1.37L15 3l-1.37-.63L13 1l-.62 1.37L11 3l1.38.63L13 5m8 0l.63-1.37L23 3l-1.37-.63L21 1l-.62 1.37L19 3l1.38.63L21 5m0 4l-.62 1.37L19 11l1.38.63L21 13l.63-1.37L23 11l-1.37-.63L21 9Z"/>'
        },
        magnet: {
            body: '<path fill="currentColor" d="M3 7v6a9 9 0 0 0 9 9a9 9 0 0 0 9-9V7h-4v6a5 5 0 0 1-5 5a5 5 0 0 1-5-5V7m10-2h4V2h-4M3 5h4V2H3"/>'
        },
        "magnet-on": {
            body: '<path fill="currentColor" d="M3 7v6a9 9 0 0 0 9 9a9 9 0 0 0 9-9V7h-4v6a5 5 0 0 1-5 5a5 5 0 0 1-5-5V7m10-2h4V2h-4M3 5h4V2H3m10-.5L9 9h2v5.5L15 7h-2V1.5Z"/>'
        },
        magnify: {
            body: '<path fill="currentColor" d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5l-1.5 1.5l-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14S14 12 14 9.5S12 5 9.5 5Z"/>'
        },
        "magnify-close": {
            body: '<path fill="currentColor" d="M9 2a7 7 0 0 1 7 7c0 1.5-.5 3-1.39 4.19l.8.81H16l6 6l-2 2l-6-6v-.59l-.81-.8A7.07 7.07 0 0 1 9 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7m2.12 3.46L9 7.59L6.88 5.46L5.46 6.88L7.59 9l-2.13 2.12l1.42 1.42L9 10.41l2.12 2.13l1.42-1.42L10.41 9l2.13-2.12l-1.42-1.42Z"/>'
        },
        "magnify-expand": {
            body: '<path fill="currentColor" d="M18 16h-.58l-.81-.81A7.07 7.07 0 0 0 18 11c0-3.87-3.13-7-7-7c-1.5 0-3 .5-4.21 1.4c-3.09 2.32-3.72 6.71-1.4 9.8c2.32 3.09 6.71 3.72 9.8 1.4l.81.81V18l5 5l2-2l-5-5m-7 0c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5M3 6L1 8V1h7L6 3H3v3m18-5v7l-2-2V3h-3l-2-2h7M6 19l2 2H1v-7l2 2v3h3Z"/>'
        },
        "magnify-minus": {
            body: '<path fill="currentColor" d="M9 2a7 7 0 0 1 7 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6l-2 2l-6-6v-.59l-.81-.8A6.916 6.916 0 0 1 9 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7M5 8v2h8V8H5Z"/>'
        },
        "magnify-minus-cursor": {
            body: '<path fill="currentColor" d="M11 4a7 7 0 0 1 7 7c0 1.5-.5 3-1.39 4.19l.81.81H18l5 5l-2 2l-5-5v-.59l-.81-.81c-3.09 2.32-7.48 1.69-9.8-1.4c-2.32-3.09-1.69-7.48 1.4-9.8C8 4.5 9.5 4 11 4m-4 6v2h8v-2H7M1 1v7l7-7H1Z"/>'
        },
        "magnify-minus-outline": {
            body: '<path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 0 0 9.5 3A6.5 6.5 0 0 0 3 9.5A6.5 6.5 0 0 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5l1.5-1.5l-5-5m-6 0C7 14 5 12 5 9.5S7 5 9.5 5S14 7 14 9.5S12 14 9.5 14M7 9h5v1H7V9Z"/>'
        },
        "magnify-plus": {
            body: '<path fill="currentColor" d="M9 2a7 7 0 0 1 7 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6l-2 2l-6-6v-.59l-.81-.8A6.916 6.916 0 0 1 9 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7M8 5v3H5v2h3v3h2v-3h3V8h-3V5H8Z"/>'
        },
        "magnify-plus-cursor": {
            body: '<path fill="currentColor" d="M11 4a7 7 0 0 1 7 7c0 1.5-.5 3-1.39 4.19l.81.81H18l5 5l-2 2l-5-5v-.59l-.81-.81c-3.09 2.32-7.48 1.69-9.8-1.4c-2.32-3.09-1.69-7.48 1.4-9.8C8 4.5 9.5 4 11 4m-1 3v3H7v2h3v3h2v-3h3v-2h-3V7h-2M1 1v7l7-7H1Z"/>'
        },
        "magnify-plus-outline": {
            body: '<path fill="currentColor" d="m15.5 14l5 5l-1.5 1.5l-5-5v-.79l-.27-.28A6.471 6.471 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79m-6 0C12 14 14 12 14 9.5S12 5 9.5 5S5 7 5 9.5S7 14 9.5 14m2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1Z"/>'
        },
        "magnify-remove-cursor": {
            body: '<path fill="currentColor" d="M1 1v7l7-7H1m17 15h-.58l-.81-.81A7.07 7.07 0 0 0 18 11c0-3.87-3.13-7-7-7c-1.5 0-3 .5-4.21 1.4c-3.09 2.32-3.72 6.71-1.4 9.8c2.32 3.09 6.71 3.72 9.8 1.4l.81.81V18l5 5l2-2l-5-5m-3.4-2.84l-1.42 1.42l-2.12-2.13l-2.12 2.13l-1.44-1.42l2.15-2.12L7.5 8.92L8.94 7.5l2.12 2.13l2.12-2.13l1.42 1.42l-2.13 2.12l2.13 2.12Z"/>'
        },
        "magnify-remove-outline": {
            body: '<path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5l1.5-1.5l-5-5m-6 0C7 14 5 12 5 9.5S7 5 9.5 5S14 7 14 9.5S12 14 9.5 14m1.41-2.38L9.5 10.21l-1.41 1.41l-.71-.71L8.79 9.5L7.38 8.09l.71-.71L9.5 8.79l1.41-1.41l.71.71l-1.41 1.41l1.41 1.41l-.71.71Z"/>'
        },
        "magnify-scan": {
            body: '<path fill="currentColor" d="M17 22v-2h3v-3h2v3.5c0 .39-.16.74-.46 1.04c-.3.3-.65.46-1.04.46H17M7 22H3.5c-.39 0-.74-.16-1.04-.46c-.3-.3-.46-.65-.46-1.04V17h2v3h3v2M17 2h3.5c.39 0 .74.16 1.04.46c.3.3.46.65.46 1.04V7h-2V4h-3V2M7 2v2H4v3H2V3.5c0-.39.16-.74.46-1.04c.3-.3.65-.46 1.04-.46H7m3.5 4C13 6 15 8 15 10.5c0 .88-.25 1.7-.69 2.4l3.26 3.26l-1.41 1.41l-3.26-3.26c-.7.44-1.52.69-2.4.69C8 15 6 13 6 10.5S8 6 10.5 6m0 2a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5Z"/>'
        },
        mail: {
            body: '<path fill="currentColor" d="M20 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-3 13H7v-2h10m0-2H7v-2h10m3-2h-3V6h3"/>'
        },
        "mail-ru": {
            body: '<path d="M15.45 11.91c-.11-2.21-1.75-3.54-3.73-3.54h-.08c-2.29 0-3.55 1.8-3.55 3.84c0 2.29 1.53 3.74 3.54 3.74c2.25 0 3.72-1.65 3.83-3.59m-3.81-5.97c1.53 0 2.97.68 4.02 1.74c0-.51.33-.89.83-.89h.11c.74 0 .89.7.89.92v7.9c-.04.52.54.78.87.44c1.27-1.29 2.78-6.69-.79-9.81c-3.33-2.92-7.8-2.44-10.18-.8c-2.52 1.74-4.14 5.61-2.57 9.22c1.71 3.95 6.61 5.13 9.52 3.95c1.48-.59 2.15 1.4.65 2.05c-2.34.99-8.77.89-11.78-4.32c-2.03-3.52-1.93-9.71 3.46-12.92C10.81 1.42 16.24 2.1 19.5 5.5c3.45 3.6 3.25 10.3-.1 12.91c-1.51 1.18-3.76.03-3.74-1.7l-.02-.56a5.611 5.611 0 0 1-3.99 1.66C8.63 17.81 6 15.15 6 12.13c0-3.05 2.63-5.74 5.65-5.74z" fill="currentColor"/>',
            hidden: true
        },
        mailbox: {
            body: '<path fill="currentColor" d="M17 4H7a5 5 0 0 0-5 5v11h18a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5m-7 14H4V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3v9m9-3h-2v-2h-4v-2h6v4M9 11H5V9h4v2Z"/>'
        },
        "mailbox-open": {
            body: '<path fill="currentColor" d="M8 4a5 5 0 0 0-5 5v9H1v2h20a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5H8m0 2a3 3 0 0 1 3 3v9H5V9a3 3 0 0 1 3-3m6 5h6v4h-2v-2h-4v-2Z"/>'
        },
        "mailbox-open-outline": {
            body: '<path fill="currentColor" d="M14 11h6v4h-2v-2h-4v-2m4-7H8a5 5 0 0 0-5 5v9H1v2h20a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5m-7 14H5V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3v9m10 0h-8V9c0-1.08-.35-2.14-1-3h6a3 3 0 0 1 3 3v9Z"/>'
        },
        "mailbox-open-up": {
            body: '<path fill="currentColor" d="M8 4a5 5 0 0 0-5 5v9H1v2h20a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5H8m0 2a3 3 0 0 1 3 3v9H5V9a3 3 0 0 1 3-3m5 7V7h4v2h-2v4h-2Z"/>'
        },
        "mailbox-open-up-outline": {
            body: '<path fill="currentColor" d="M14 12.85v-6h4v2h-2v4h-2m4-9H8a5 5 0 0 0-5 5v9H1v2h20a2 2 0 0 0 2-2v-9a5 5 0 0 0-5-5m-7 14H5v-9a3 3 0 0 1 3-3a3 3 0 0 1 3 3v9m10 0h-8v-9c0-1.09-.35-2.14-1-3h6a3 3 0 0 1 3 3v9Z"/>'
        },
        "mailbox-outline": {
            body: '<path fill="currentColor" d="M17 4H7a5 5 0 0 0-5 5v11h18a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5m-7 14H4V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3v9m10 0h-8V9c0-1.08-.35-2.14-1-3h6a3 3 0 0 1 3 3v9m-7-7v2h4v2h2v-4h-6m-4 0H5V9h4v2Z"/>'
        },
        "mailbox-up": {
            body: '<path fill="currentColor" d="M5 9h4v2H5V9m17 0v9a2 2 0 0 1-2 2H2V9a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5M10 9a3 3 0 0 0-3-3a3 3 0 0 0-3 3v9h6V9m6-2h-4v6h2V9h2V7Z"/>'
        },
        "mailbox-up-outline": {
            body: '<path fill="currentColor" d="M17 4H7a5 5 0 0 0-5 5v11h18a2 2 0 0 0 2-2V9a5 5 0 0 0-5-5m-7 14H4V9a3 3 0 0 1 3-3a3 3 0 0 1 3 3v9m10 0h-8V9c0-1.08-.35-2.14-1-3h6a3 3 0 0 1 3 3v9m-7-5h2V9h2V7h-4v6m-4-2H5V9h4v2Z"/>'
        },
        manjaro: {
            body: '<path fill="currentColor" d="M2 2v20h5.6V7.6h7.2V2H2m7.2 7.2V22h5.6V9.2H9.2M16.4 2v20H22V2h-5.6Z"/>'
        },
        map: {
            body: '<path fill="currentColor" d="m15 19l-6-2.11V5l6 2.11M20.5 3h-.16L15 5.1L9 3L3.36 4.9c-.21.07-.36.25-.36.48V20.5a.5.5 0 0 0 .5.5c.05 0 .11 0 .16-.03L9 18.9l6 2.1l5.64-1.9c.21-.1.36-.25.36-.48V3.5a.5.5 0 0 0-.5-.5Z"/>'
        },
        "map-check": {
            body: '<path fill="currentColor" d="m18.25 22l-2.75-3l1.16-1.18l1.59 1.59l3.59-3.59L23 17.23M20.5 3a.5.5 0 0 1 .5.5v9.86c-.64-.23-1.31-.36-2-.36c-1.54 0-2.94.6-4 1.56V7.1L9 5v11.9l4.04 1.4c-.04.24-.04.47-.04.7c0 .46.06.92.16 1.36L9 18.9l-5.34 2.07c-.07.03-.11.03-.16.03a.5.5 0 0 1-.5-.5V5.38c0-.23.16-.41.35-.48L9 3l6 2.1L20.33 3"/>'
        },
        "map-check-outline": {
            body: '<path fill="currentColor" d="m18.25 22l-2.75-3l1.16-1.18l1.59 1.59l3.59-3.59L23 17.23L18.25 22M20.5 3a.5.5 0 0 1 .5.5v9.84c-.63-.22-1.3-.34-2-.34V5.7l-3 1.16v6.94c-.8.47-1.5 1.11-2 1.88V6.87l-4-1.4v11.66l3.05 1.07l-.05.8c0 .46.05.92.15 1.35L9 18.9l-5.34 2.07l-.16.03a.5.5 0 0 1-.5-.5V5.38c0-.23.15-.41.36-.48L9 3l6 2.1l5.34-2.07l.16-.03M5 6.46v11.85l3-1.16V5.45L5 6.46Z"/>'
        },
        "map-clock": {
            body: '<path fill="currentColor" d="M15 12h1.5v4.25l2.86 1.69l-.75 1.22L15 17v-5m8 4a7 7 0 0 1-7 7c-3 0-5.6-1.92-6.58-4.6L8 17.9l-5.34 2.07l-.16.03a.5.5 0 0 1-.5-.5V4.38c0-.23.15-.41.36-.48L8 2l6 2.1L19.34 2h.16a.5.5 0 0 1 .5.5v7.75c1.81 1.25 3 3.37 3 5.75M9 16c0-3.17 2.11-5.85 5-6.71V6.11L8 4v11.89l1 .35V16m7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "map-clock-outline": {
            body: '<path fill="currentColor" d="M15 12h1.5v4.25l2.86 1.69l-.75 1.22L15 17v-5m1-3c.69 0 1.37.1 2 .29V4.7l-3 1.16v3.21c.33-.07.66-.07 1-.07m7 7a7 7 0 0 1-7 7c-3 0-5.6-1.92-6.58-4.6L8 17.9l-5.34 2.07l-.16.03a.5.5 0 0 1-.5-.5V4.38c0-.23.15-.41.36-.48L8 2l6 2.1l5.34-2.07l.16-.03a.5.5 0 0 1 .5.5v7.75c1.81 1.25 3 3.37 3 5.75M9 16c0-2.79 1.63-5.2 4-6.33v-3.8l-4-1.4v11.66V16m7-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5M4 5.46v11.85l3-1.16V4.45L4 5.46Z"/>'
        },
        "map-legend": {
            body: '<path fill="currentColor" d="M9 3L3.36 4.9c-.21.07-.36.25-.36.48V20.5a.5.5 0 0 0 .5.5l.16-.03L9 18.9l6 2.1l5.64-1.9c.21-.07.36-.25.36-.48V3.5a.5.5 0 0 0-.5-.5l-.16.03L15 5.1L9 3M8 5.45v11.7l-3 1.16V6.46l3-1.01m2 .02l4 1.4v11.66l-4-1.4V5.47m9 .23v11.84l-3 1.01V6.86l3-1.16m-11.54.6l-1.89.67v2.15l1.89-.67V6.3m0 2.75l-1.89.67v2.15l1.89-.67V9.05m0 2.75l-1.89.67v2.15l1.89-.67V11.8m0 2.75l-1.89.67v2.15l1.89-.67v-2.15Z"/>'
        },
        "map-marker": {
            body: '<path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Z"/>'
        },
        "map-marker-account": {
            body: '<path fill="currentColor" d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7m0 2a2 2 0 1 1 .001 4.001A2 2 0 0 1 12 4m0 10c-1.67 0-3.14-.85-4-2.15c0-1.32 2.67-2.05 4-2.05s4 .73 4 2.05A4.783 4.783 0 0 1 12 14Z"/>'
        },
        "map-marker-account-outline": {
            body: '<path fill="currentColor" d="M12 4c2.8 0 5 2.2 5 5c0 2.9-2.9 7.2-5 9.9c-2.1-2.7-5-7-5-9.9c0-2.8 2.2-5 5-5m0-2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7m0 8c1.33 0 4 .67 4 2v.16c-.97 1.12-2.4 1.84-4 1.84s-3.03-.72-4-1.84V12c0-1.33 2.67-2 4-2m0-1c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "map-marker-alert": {
            body: '<path fill="currentColor" d="M12 2c3.9 0 7 3.1 7 7c0 5.2-7 13-7 13S5 14.2 5 9c0-3.9 3.1-7 7-7m-1 4v6h2V6h-2m0 8v2h2v-2h-2Z"/>'
        },
        "map-marker-alert-outline": {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5c0 1 0 3 5 9.71C17 12 17 10 17 9a5 5 0 0 0-5-5m-1 2h2v5h-2V6m0 7h2v2h-2v-2Z"/>'
        },
        "map-marker-check": {
            body: '<path fill="currentColor" d="M12 2c3.86 0 7 3.14 7 7c0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7m-1.53 12L17 7.41L15.6 6l-5.13 5.18L8.4 9.09L7 10.5l3.47 3.5Z"/>'
        },
        "map-marker-check-outline": {
            body: '<path fill="currentColor" d="M12 4c2.8 0 5 2.2 5 5c0 2.9-2.9 7.2-5 9.9c-2.1-2.7-5-7-5-9.9c0-2.8 2.2-5 5-5m0-2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7m-.7 12l4.9-5l-1.4-1.4l-3.5 3.6l-1.6-1.6L8.3 11l3 3Z"/>'
        },
        "map-marker-circle": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 10.5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 9.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m0-5.3c-2.1 0-3.8 1.7-3.8 3.8c0 3 3.8 6.5 3.8 6.5s3.8-3.5 3.8-6.5c0-2.1-1.7-3.8-3.8-3.8Z"/>'
        },
        "map-marker-distance": {
            body: '<path fill="currentColor" d="M6.5 8.11c-.89 0-1.61-.72-1.61-1.61A1.61 1.61 0 0 1 6.5 4.89c.89 0 1.61.72 1.61 1.61A1.61 1.61 0 0 1 6.5 8.11M6.5 2C4 2 2 4 2 6.5c0 3.37 4.5 8.36 4.5 8.36S11 9.87 11 6.5C11 4 9 2 6.5 2m11 6.11a1.61 1.61 0 0 1-1.61-1.61a1.609 1.609 0 1 1 3.22 0a1.61 1.61 0 0 1-1.61 1.61m0-6.11C15 2 13 4 13 6.5c0 3.37 4.5 8.36 4.5 8.36S22 9.87 22 6.5C22 4 20 2 17.5 2m0 14c-1.27 0-2.4.8-2.82 2H9.32a3 3 0 0 0-3.82-1.83A3.003 3.003 0 0 0 3.66 20a3.017 3.017 0 0 0 3.84 1.83c.85-.3 1.5-.98 1.82-1.83h5.37c.55 1.56 2.27 2.38 3.81 1.83A3 3 0 0 0 20.35 18c-.43-1.2-1.57-2-2.85-2m0 4.5A1.5 1.5 0 0 1 16 19a1.5 1.5 0 0 1 1.5-1.5A1.5 1.5 0 0 1 19 19a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "map-marker-down": {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7m-4.5 8H10V5h4v5h2.5L12 14.5Z"/>'
        },
        "map-marker-left": {
            body: '<path fill="currentColor" d="M15 11.5a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M8 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7S8 5.13 8 9M6 7l-5 5l5 5V7Z"/>'
        },
        "map-marker-left-outline": {
            body: '<path fill="currentColor" d="M15 6.5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5M15 2c3.87 0 7 3.13 7 7c0 5.25-7 13-7 13S8 14.25 8 9c0-3.87 3.13-7 7-7m-5 7c0 1 0 3 5 9.71C20 12 20 10 20 9c0-2.76-2.24-5-5-5s-5 2.24-5 5M6 7l-5 5l5 5V7Z"/>'
        },
        "map-marker-minus": {
            body: '<path fill="currentColor" d="M9 11.5A2.5 2.5 0 0 0 11.5 9A2.5 2.5 0 0 0 9 6.5A2.5 2.5 0 0 0 6.5 9A2.5 2.5 0 0 0 9 11.5M9 2c3.86 0 7 3.13 7 7c0 5.25-7 13-7 13S2 14.25 2 9a7 7 0 0 1 7-7m6 15h8v2h-8v-2Z"/>'
        },
        "map-marker-minus-outline": {
            body: '<path fill="currentColor" d="M15 17h8v2h-8v-2M9 6.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5S6.5 10.4 6.5 9S7.6 6.5 9 6.5M9 2c3.9 0 7 3.1 7 7c0 5.2-7 13-7 13S2 14.2 2 9c0-3.9 3.1-7 7-7m0 2C6.2 4 4 6.2 4 9c0 1 0 3 5 9.7C14 12 14 10 14 9c0-2.8-2.2-5-5-5Z"/>'
        },
        "map-marker-multiple": {
            body: '<path fill="currentColor" d="M14 11.5A2.5 2.5 0 0 0 16.5 9A2.5 2.5 0 0 0 14 6.5A2.5 2.5 0 0 0 11.5 9a2.5 2.5 0 0 0 2.5 2.5M14 2c3.86 0 7 3.13 7 7c0 5.25-7 13-7 13S7 14.25 7 9a7 7 0 0 1 7-7M5 9c0 4.5 5.08 10.66 6 11.81L10 22S3 14.25 3 9c0-3.17 2.11-5.85 5-6.71C6.16 3.94 5 6.33 5 9Z"/>'
        },
        "map-marker-multiple-outline": {
            body: '<path fill="currentColor" d="M11.5 9A2.5 2.5 0 0 1 14 6.5c1.1 0 2.03.71 2.37 1.69c.08.26.13.53.13.81a2.5 2.5 0 0 1-2.5 2.5c-1.09 0-2-.69-2.36-1.66c-.09-.26-.14-.55-.14-.84M5 9c0 4.5 5.08 10.66 6 11.81L10 22S3 14.25 3 9c0-3.17 2.11-5.85 5-6.71C6.16 3.94 5 6.33 5 9m9-7c3.86 0 7 3.13 7 7c0 5.25-7 13-7 13S7 14.25 7 9c0-3.87 3.14-7 7-7m0 2c-2.76 0-5 2.24-5 5c0 1 0 3 5 9.71C19 12 19 10 19 9c0-2.76-2.24-5-5-5Z"/>'
        },
        "map-marker-off": {
            body: '<path fill="currentColor" d="m16.37 16.1l-4.62-4.63l-.11-.11L3.27 3L2 4.27l3.18 3.18C5.06 7.95 5 8.46 5 9c0 5.25 7 13 7 13s1.67-1.85 3.37-4.35L18.73 21L20 19.72M12 6.5A2.5 2.5 0 0 1 14.5 9c0 .73-.33 1.39-.83 1.85l3.63 3.65c.98-1.88 1.7-3.82 1.7-5.5a7 7 0 0 0-7-7c-2 0-3.76.82-5.04 2.14l3.19 3.19c.46-.51 1.11-.83 1.85-.83Z"/>'
        },
        "map-marker-off-outline": {
            body: '<path fill="currentColor" d="M20 19.7L3.3 3L2 4.3l3.2 3.2C5.1 8 5 8.5 5 9c0 5.2 7 13 7 13s1.7-1.9 3.4-4.4l3.4 3.4l1.2-1.3m-8-1c-4.6-6.2-5-8.3-5-9.4l6.8 6.8c-.5.8-1.1 1.6-1.8 2.6M8.4 5.6L7 4.2C8.2 2.8 10 2 12 2c3.9 0 7 3.1 7 7c0 1.7-.7 3.6-1.7 5.5L15.8 13C17 10.6 17 9.6 17 9c0-2.8-2.2-5-5-5c-1.4 0-2.7.6-3.6 1.6m3.6.9c1.4 0 2.5 1.1 2.5 2.5c0 .7-.3 1.4-.8 1.9l-3.5-3.5c.4-.6 1.1-.9 1.8-.9Z"/>'
        },
        "map-marker-outline": {
            body: '<path fill="currentColor" d="M12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5c0 1 0 3 5 9.71C17 12 17 10 17 9a5 5 0 0 0-5-5Z"/>'
        },
        "map-marker-path": {
            body: '<path fill="currentColor" d="M18 15a3 3 0 0 1 3 3a3 3 0 0 1-3 3a2.99 2.99 0 0 1-2.83-2H14v-2h1.17c.41-1.17 1.52-2 2.83-2m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-9a1.43 1.43 0 0 0 1.43-1.43a1.43 1.43 0 1 0-2.86 0A1.43 1.43 0 0 0 18 8m0-5.43a4 4 0 0 1 4 4C22 9.56 18 14 18 14s-4-4.44-4-7.43a4 4 0 0 1 4-4M8.83 17H10v2H8.83A2.99 2.99 0 0 1 6 21a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V14h2v1.17c.85.3 1.53.98 1.83 1.83M6 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M6 3a3 3 0 0 1 3 3c0 1.31-.83 2.42-2 2.83V10H5V8.83A2.99 2.99 0 0 1 3 6a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m5 14v-2h2v2h-2m-4-6H5v-2h2v2Z"/>'
        },
        "map-marker-plus": {
            body: '<path fill="currentColor" d="M9 11.5A2.5 2.5 0 0 0 11.5 9A2.5 2.5 0 0 0 9 6.5A2.5 2.5 0 0 0 6.5 9A2.5 2.5 0 0 0 9 11.5M9 2c3.86 0 7 3.13 7 7c0 5.25-7 13-7 13S2 14.25 2 9a7 7 0 0 1 7-7m6 15h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "map-marker-plus-outline": {
            body: '<path fill="currentColor" d="M15 17h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2M9 6.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5S6.5 10.4 6.5 9S7.6 6.5 9 6.5M9 2c3.9 0 7 3.1 7 7c0 5.2-7 13-7 13S2 14.2 2 9c0-3.9 3.1-7 7-7m0 2C6.2 4 4 6.2 4 9c0 1 0 3 5 9.7C14 12 14 10 14 9c0-2.8-2.2-5-5-5Z"/>'
        },
        "map-marker-question": {
            body: '<path fill="currentColor" d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7m.88 13.75h-1.75V14h1.75m0-1.12h-1.75c0-2.84 2.62-2.62 2.62-4.38A1.75 1.75 0 0 0 12 6.75a1.75 1.75 0 0 0-1.75 1.75H8.5A3.5 3.5 0 0 1 12 5a3.5 3.5 0 0 1 3.5 3.5c0 2.19-2.62 2.41-2.62 4.38Z"/>'
        },
        "map-marker-question-outline": {
            body: '<path fill="currentColor" d="M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.83l.74-.83C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8m0 19.47C9.82 17.86 6 12.54 6 9a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 3.83-4.25 9.36-6 11.47M11.13 14h1.75v1.75h-1.75M12 5a3.5 3.5 0 0 0-3.5 3.5h1.75A1.75 1.75 0 0 1 12 6.75a1.75 1.75 0 0 1 1.75 1.75c0 1.76-2.62 1.54-2.62 4.38h1.75c0-1.97 2.62-2.19 2.62-4.38A3.5 3.5 0 0 0 12 5Z"/>'
        },
        "map-marker-radius": {
            body: '<path fill="currentColor" d="M12 2c3.31 0 6 2.66 6 5.95C18 12.41 12 19 12 19S6 12.41 6 7.95C6 4.66 8.69 2 12 2m0 4a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m8 13c0 2.21-3.58 4-8 4s-8-1.79-8-4c0-1.29 1.22-2.44 3.11-3.17l.64.91C6.67 17.19 6 17.81 6 18.5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5c0-.69-.67-1.31-1.75-1.76l.64-.91C18.78 16.56 20 17.71 20 19Z"/>'
        },
        "map-marker-radius-outline": {
            body: '<path fill="currentColor" d="M12 4c2.2 0 4 1.8 4 4c0 2.1-2.1 5.5-4 7.9c-1.9-2.5-4-5.8-4-7.9c0-2.2 1.8-4 4-4m0-2C8.7 2 6 4.7 6 8c0 4.5 6 11 6 11s6-6.6 6-11c0-3.3-2.7-6-6-6m0 4c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m8 13c0 2.2-3.6 4-8 4s-8-1.8-8-4c0-1.3 1.2-2.4 3.1-3.2l.6.9c-1 .5-1.7 1.1-1.7 1.8c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5c0-.7-.7-1.3-1.8-1.8l.6-.9c2 .8 3.2 1.9 3.2 3.2Z"/>'
        },
        "map-marker-remove": {
            body: '<path fill="currentColor" d="M9 2C5.14 2 2 5.14 2 9c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7m0 4.5A2.5 2.5 0 0 1 11.5 9A2.5 2.5 0 0 1 9 11.5A2.5 2.5 0 0 1 6.5 9A2.5 2.5 0 0 1 9 6.5m7.58 7.66l-1.41 1.42L17.58 18l-2.41 2.41l1.41 1.41L19 19.41l2.41 2.41l1.42-1.41L20.41 18l2.42-2.42l-1.42-1.42L19 16.58"/>'
        },
        "map-marker-remove-outline": {
            body: '<path fill="currentColor" d="m16.6 14.2l-1.4 1.4l2.4 2.4l-2.4 2.4l1.4 1.4l2.4-2.4l2.4 2.4l1.4-1.4l-2.4-2.4l2.4-2.4l-1.4-1.4l-2.4 2.4M9 6.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5S6.5 10.4 6.5 9S7.6 6.5 9 6.5M9 2c3.9 0 7 3.1 7 7c0 5.2-7 13-7 13S2 14.2 2 9c0-3.9 3.1-7 7-7m0 2C6.2 4 4 6.2 4 9c0 1 0 3 5 9.7C14 12 14 10 14 9c0-2.8-2.2-5-5-5Z"/>'
        },
        "map-marker-remove-variant": {
            body: '<path fill="currentColor" d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7M9.59 5.17L12 7.58l2.41-2.41l1.42 1.41L13.41 9l2.42 2.41l-1.42 1.42L12 10.41l-2.41 2.42l-1.42-1.42L10.59 9L8.17 6.58"/>'
        },
        "map-marker-right": {
            body: '<path fill="currentColor" d="M9 11.5a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M9 2C5.13 2 2 5.13 2 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m9 15l5-5l-5-5v10Z"/>'
        },
        "map-marker-right-outline": {
            body: '<path fill="currentColor" d="M9 6.5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5M9 2c3.87 0 7 3.13 7 7c0 5.25-7 13-7 13S2 14.25 2 9c0-3.87 3.13-7 7-7m0 2C6.24 4 4 6.24 4 9c0 1 0 3 5 9.71C14 12 14 10 14 9c0-2.76-2.24-5-5-5m9 13l5-5l-5-5v10Z"/>'
        },
        "map-marker-star": {
            body: '<path fill="currentColor" d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7m2.5 11L12 11.5L9.5 13l.7-2.8L8 8.3l2.9-.2L12 5.4L13.1 8l2.9.3l-2.2 1.9l.7 2.8Z"/>'
        },
        "map-marker-star-outline": {
            body: '<path fill="currentColor" d="M12 2c3.9 0 7 3.1 7 7c0 5.2-7 13-7 13S5 14.2 5 9c0-3.9 3.1-7 7-7m0 2C9.2 4 7 6.2 7 9c0 1 0 3 5 9.7C17 12 17 10 17 9c0-2.8-2.2-5-5-5m0 7.5l2.4 1.5l-.6-2.8L16 8.3l-2.9-.2L12 5.4L10.9 8L8 8.3l2.2 1.9l-.7 2.8l2.5-1.5Z"/>'
        },
        "map-marker-up": {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7m4.5 7H14v5h-4V9H7.5L12 4.5Z"/>'
        },
        "map-minus": {
            body: '<path fill="currentColor" d="M15 18v2h8v-2h-8m-1.84 2.36L9 18.9l-5.34 2.07c-.06.03-.11.03-.16.03c-.28 0-.5-.22-.5-.5V5.38c0-.23.16-.41.36-.48L9 3l6 2.1L20.34 3h.16c.28 0 .5.22.5.5v9.85a5.93 5.93 0 0 0-6 1.19V7.1L9 5v11.9l4.04 1.42c-.04.22-.04.45-.04.68c0 .47.06.92.16 1.36Z"/>'
        },
        "map-outline": {
            body: '<path fill="currentColor" d="m20.5 3l-.16.03L15 5.1L9 3L3.36 4.9c-.21.07-.36.25-.36.48V20.5a.5.5 0 0 0 .5.5l.16-.03L9 18.9l6 2.1l5.64-1.9c.21-.07.36-.25.36-.48V3.5a.5.5 0 0 0-.5-.5M10 5.47l4 1.4v11.66l-4-1.4V5.47m-5 .99l3-1.01v11.7l-3 1.16V6.46m14 11.08l-3 1.01V6.86l3-1.16v11.84Z"/>'
        },
        "map-plus": {
            body: '<path fill="currentColor" d="M9 3L3.36 4.9c-.2.07-.36.25-.36.48V20.5a.5.5 0 0 0 .5.5c.05 0 .1 0 .16-.03L9 18.9l4.16 1.46c-.1-.44-.16-.9-.16-1.36c0-.23 0-.46.04-.7L9 16.9V5l6 2.1v7.46c1.07-.96 2.47-1.56 4-1.56c.7 0 1.37.13 2 .36V3.5a.5.5 0 0 0-.5-.5h-.16L15 5.1L9 3m9 12v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "map-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M14 6.11L8 4v11.89l1 .35v.26c0 .64.09 1.26.26 1.84L8 17.9l-5.34 2.07l-.16.03a.5.5 0 0 1-.5-.5V4.38c0-.23.15-.41.36-.48L8 2l6 2.1L19.34 2h.16a.5.5 0 0 1 .5.5v9.31A6.48 6.48 0 0 0 15.5 10c-.5 0-1 .06-1.5.17V6.11Z"/>'
        },
        "map-search-outline": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.7-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5m4-12a.5.5 0 0 1 .5.5v9.31c-.58-.55-1.25-1-2-1.31V4.7l-3 1.16V10c-.7.07-1.38.24-2 .5V5.87l-4-1.4V16.5c0 .64.09 1.26.26 1.84L8 17.9l-5.34 2.07l-.16.03a.5.5 0 0 1-.5-.5V4.38c0-.23.15-.41.36-.48L8 2l6 2.1l5.34-2.07l.16-.03M4 5.46v11.85l3-1.16V4.45L4 5.46Z"/>'
        },
        mapbox: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m4.75 12.45c1.9-1.9 1.83-5.06-.16-7.04c-1.99-1.98-5.14-2.06-7.04-.16c-3.43 3.43-2.33 9.53-2.33 9.53s6.11 1.09 9.53-2.33m-3.6-6.59l.98 2.01l2.01.98l-2.01.98l-.98 2.01l-.98-2.01l-2.01-.98l2.01-.98l.98-2.01Z"/>'
        },
        margin: {
            body: '<path fill="currentColor" d="M20 4v5l-1.5-1.5l-13 13l-2-2l13-13L15 4h5m-3 16a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3m0-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1M7 12a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3m0-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"/>'
        },
        marker: {
            body: '<path fill="currentColor" d="M18.5 1.15c-.53 0-1.04.19-1.43.58l-5.81 5.82l5.65 5.65l5.82-5.81c.77-.78.77-2.04 0-2.83l-2.84-2.83c-.39-.39-.89-.58-1.39-.58M10.3 8.5l-5.96 5.96c-.78.78-.78 2.04.02 2.85C3.14 18.54 1.9 19.77.67 21h5.66l.86-.86c.78.76 2.03.75 2.81-.02l5.95-5.96"/>'
        },
        "marker-cancel": {
            body: '<path fill="currentColor" d="M17.5 13c2.5 0 4.5 2 4.5 4.5S20 22 17.5 22S13 20 13 17.5s2-4.5 4.5-4.5m0 1.5c-.56 0-1.08.15-1.5.42L20.08 19c.27-.42.42-.94.42-1.5a3 3 0 0 0-3-3m-3 3a3 3 0 0 0 3 3c.56 0 1.08-.15 1.5-.42L14.92 16c-.27.42-.42.94-.42 1.5m4-16.35c.5 0 1 .19 1.39.58l2.84 2.83c.77.79.77 2.05 0 2.83l-3.78 3.77a6.543 6.543 0 0 0-3.8.28l-3.89-3.89l5.81-5.82c.39-.39.9-.58 1.43-.58M10.3 8.5l3.59 3.6A6.487 6.487 0 0 0 11 17.5c0 .5.06 1 .16 1.45L10 20.12c-.78.77-2.03.78-2.81.02l-.86.86H.67l3.69-3.69c-.8-.81-.8-2.07-.02-2.85L10.3 8.5Z"/>'
        },
        "marker-check": {
            body: '<path fill="currentColor" d="m10 16l-5-5l1.41-1.42L10 13.17l7.59-7.59L19 7m0-6H5c-1.11 0-2 .89-2 2v12.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.89-.97.89-1.66V3a2 2 0 0 0-2-2Z"/>'
        },
        mastodon: {
            body: '<path fill="currentColor" d="M20.94 14c-.28 1.41-2.44 2.96-4.97 3.26c-1.31.15-2.6.3-3.97.24c-2.25-.11-4-.54-4-.54v.62c.32 2.22 2.22 2.35 4.03 2.42c1.82.05 3.44-.46 3.44-.46l.08 1.65s-1.28.68-3.55.81c-1.25.07-2.81-.03-4.62-.5c-3.92-1.05-4.6-5.24-4.7-9.5l-.01-3.43c0-4.34 2.83-5.61 2.83-5.61C6.95 2.3 9.41 2 11.97 2h.06c2.56 0 5.02.3 6.47.96c0 0 2.83 1.27 2.83 5.61c0 0 .04 3.21-.39 5.43M18 8.91c0-1.08-.3-1.91-.85-2.56c-.56-.63-1.3-.96-2.23-.96c-1.06 0-1.87.41-2.42 1.23l-.5.88l-.5-.88c-.56-.82-1.36-1.23-2.43-1.23c-.92 0-1.66.33-2.23.96C6.29 7 6 7.83 6 8.91v5.26h2.1V9.06c0-1.06.45-1.62 1.36-1.62c1 0 1.5.65 1.5 1.93v2.79h2.07V9.37c0-1.28.5-1.93 1.51-1.93c.9 0 1.35.56 1.35 1.62v5.11H18V8.91Z"/>'
        },
        "mastodon-variant": {
            body: '<path d="M20.93 14c-.27 1.4-2.43 2.95-4.96 3.25c-1.31.15-2.59.3-3.97.25c-2.24-.12-4-.55-4-.55l.03.62c.29 2.21 2.19 2.35 4 2.43c1.82.04 3.44-.47 3.44-.47l.08 1.64s-1.28.69-3.55.83c-1.25.05-2.8-.05-4.61-.53c-3.92-1.04-4.6-5.22-4.7-9.47l-.01-3.43c0-4.34 2.82-5.61 2.82-5.61C6.95 2.3 9.41 2 11.97 2h.06c2.56 0 5.02.3 6.47.96c0 0 2.83 1.27 2.83 5.61c0 0 .03 3.2-.4 5.43m-12.6-3.68c0-.78-.63-1.41-1.4-1.41c-.78 0-1.43.63-1.43 1.41c0 .77.65 1.4 1.43 1.4a1.4 1.4 0 0 0 1.4-1.4m5.08 0A1.41 1.41 0 0 0 12 8.91a1.41 1.41 0 0 0-1.41 1.41c0 .77.63 1.4 1.41 1.4c.78 0 1.41-.63 1.41-1.4m5.09 0c0-.78-.65-1.41-1.43-1.41c-.77 0-1.4.63-1.4 1.41a1.4 1.4 0 0 0 1.4 1.4c.78 0 1.43-.63 1.43-1.4z" fill="currentColor"/>',
            hidden: true
        },
        "material-design": {
            body: '<path fill="currentColor" d="M21 12c0-2.03-.67-3.91-2-5.62v11.25c1.33-1.66 2-3.54 2-5.63m-3.37 7H6.38c.68.55 1.57 1 2.67 1.41c1.09.39 2.08.59 2.95.59c.88 0 1.86-.2 2.95-.59c1.1-.41 1.99-.86 2.68-1.41M11 17L7 9v8h4m6-8l-4 8h4V9m-5 5.53L15.75 7h-7.5L12 14.53M17.63 5C15.97 3.67 14.09 3 12 3s-3.97.67-5.62 2h11.25M5 17.63V6.38C3.67 8.09 3 9.97 3 12c0 2.09.67 3.97 2 5.63M23 12c0 3.03-1.06 5.63-3.22 7.78C17.63 21.94 15.03 23 12 23c-3.03 0-5.62-1.06-7.78-3.22C2.06 17.63 1 15.03 1 12c0-3.03 1.06-5.62 3.22-7.78S8.97 1 12 1c3.03 0 5.63 1.06 7.78 3.22C21.94 6.38 23 8.97 23 12Z"/>'
        },
        "material-ui": {
            body: '<path fill="currentColor" d="M8 16.61v-1.24l6-3.46V7.23l-5 2.89l-5-2.89V13l-1 .58L2 13V5l1.07-.62L9 7.81l3.93-2.27l2-1.16L16 5v8.06L10.92 16l4.05 2.33l5.03-2.9V11l1-.58l1 .58v5.58l-7.03 4.06L8 16.61m14-6.86l-1 .58l-1-.58V8.58L21 8l1 .58v1.17Z"/>'
        },
        "math-compass": {
            body: '<path fill="currentColor" d="M20 19.88V22l-1.8-1.17l-4.79-9c.66-.21 1.26-.55 1.78-1L20 19.88M15 7a3 3 0 0 1-3 3h-.44L5.8 20.83L4 22v-2.12L9.79 9c-1.1-1.23-1-3.13.24-4.24C10.57 4.28 11.27 4 12 4V2a1 1 0 0 1 1 1v1.18c1.2.42 2 1.55 2 2.82m-2 0a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1Z"/>'
        },
        "math-cos": {
            body: '<path fill="currentColor" d="M4 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1H6v1H4V9h2v1h2V9a2 2 0 0 0-2-2H4m7 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9m7-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4Z"/>'
        },
        "math-integral": {
            body: '<path fill="currentColor" d="M11.5 19.1c-.2 1.1-.6 1.9-1.3 2.4c-.7.5-1.6.6-2.7.4c-.4-.1-1.2-.2-1.5-.4l.5-1.5c.3.1.9.3 1.2.3c1.1.2 1.7-.3 1.9-1.5L12 5.2c.2-1.2.7-2 1.4-2.6c.7-.5 1.7-.7 2.8-.5c.4.1 1.2.2 1.8.5L17.5 4c-.2-.1-.9-.2-1.2-.3c-1.3-.2-2 .4-2.3 1.9l-2.5 13.5Z"/>'
        },
        "math-integral-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-3.1 3.9s-.7-.3-1-.3c-.6-.1-1 .1-1.2 1.1L12 16.8c-.2.8-.5 1.4-1 1.8c-.4.3-.8.4-1.3.4c-.8 0-2-.5-2-.5l.5-1.4s.8.3 1 .3c.3.1.5 0 .7-.1c.2-.1.3-.4.4-.7l1.6-9.2c.1-.8.5-1.4 1-1.9c.6-.4 1.3-.5 2.1-.4c.7.1 1.5.5 1.5.5l-.6 1.3Z"/>'
        },
        "math-log": {
            body: '<path fill="currentColor" d="M18 7c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-4h-2v4h-2V9h4V7h-4M2 7v10h6v-2H4V7H2m9 0c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "math-norm": {
            body: '<path fill="currentColor" d="M14 21V3h2v18h-2m-6 0V3h2v18H8Z"/>'
        },
        "math-norm-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 15H8V6h2v12m6 0h-2V6h2v12Z"/>'
        },
        "math-sin": {
            body: '<path fill="currentColor" d="M4 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H2v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H4V9h4V7H4m10 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4m2 0v10h2v-5l2 5h2V7h-2v5l-2-5h-2Z"/>'
        },
        "math-tan": {
            body: '<path fill="currentColor" d="M2 7v2h2v8h2V9h2V7H2m9 0a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2h-2m0 2h2v2h-2V9m5-2v10h2v-5l2 5h2V7h-2v5l-2-5h-2Z"/>'
        },
        matrix: {
            body: '<path fill="currentColor" d="M2 2h4v2H4v16h2v2H2V2m18 2h-2V2h4v20h-4v-2h2V4M9 5h1v5h1v1H8v-1h1V6l-1 .5v-1L9 5m6 8h1v5h1v1h-3v-1h1v-4l-1 .5v-1l1-.5m-6 0c1.1 0 2 1.34 2 3s-.9 3-2 3s-2-1.34-2-3s.9-3 2-3m0 1c-.55 0-1 .9-1 2s.45 2 1 2s1-.9 1-2s-.45-2-1-2m6-9c1.1 0 2 1.34 2 3s-.9 3-2 3s-2-1.34-2-3s.9-3 2-3m0 1c-.55 0-1 .9-1 2s.45 2 1 2s1-.9 1-2s-.45-2-1-2Z"/>'
        },
        maxcdn: {
            body: '<path d="M20.6 6.69C19.73 5.61 18.38 5 16.9 5H2.95l1.67 3.57L2.39 19h3.66L8.28 8.57h3.12L9.17 19h3.66l2.23-10.43h1.84c.4 0 .73.13.92.37c.18.23.25.56.18.96L16.04 19h3.65l1.81-8.35c.28-1.44-.04-2.89-.9-3.96z" fill="currentColor"/>',
            hidden: true
        },
        medal: {
            body: '<path fill="currentColor" d="M20 2H4v2l5.81 4.36a7.004 7.004 0 0 0-4.46 8.84a6.996 6.996 0 0 0 8.84 4.46a7 7 0 0 0 0-13.3L20 4V2m-5.06 17.5L12 17.78L9.06 19.5l.78-3.33l-2.59-2.24l3.41-.29L12 10.5l1.34 3.14l3.41.29l-2.59 2.24l.78 3.33Z"/>'
        },
        "medal-outline": {
            body: '<path fill="currentColor" d="M14.94 19.5L12 17.77L9.06 19.5l.78-3.34l-2.59-2.24l3.41-.29L12 10.5l1.34 3.13l3.41.29l-2.59 2.24M20 2H4v2l4.86 3.64a8 8 0 1 0 6.28 0L20 4m-2 11a6 6 0 1 1-7.18-5.88a5.86 5.86 0 0 1 2.36 0A6 6 0 0 1 18 15m-5.37-8h-1.26l-4-3h9.34Z"/>'
        },
        "medical-bag": {
            body: '<path fill="currentColor" d="M10 3L8 5v2H5C3.85 7 3.12 8 3 9L2 19c-.12 1 .54 2 2 2h16c1.46 0 2.12-1 2-2L21 9c-.12-1-.94-2-2-2h-3V5l-2-2h-4m0 2h4v2h-4V5m1 5h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z"/>'
        },
        "medical-cotton-swab": {
            body: '<path fill="currentColor" d="M3 3h12v2H3V3M2 21h14V6H2v15m3-9h2.5V9.5h3V12H13v3h-2.5v2.5h-3V15H5v-3m15-6c-1.7 0-3 1.8-3 4c0 1.8.8 3.2 2 3.8V21h2v-7.2c1.2-.5 2-2 2-3.8c0-2.2-1.3-4-3-4Z"/>'
        },
        medication: {
            body: '<path fill="currentColor" d="M6 3h12v2H6V3m11 3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-1 9h-2.5v2.5h-3V15H8v-3h2.5V9.5h3V12H16v3Z"/>'
        },
        "medication-outline": {
            body: '<path fill="currentColor" d="M10.5 15H8v-3h2.5V9.5h3V12H16v3h-2.5v2.5h-3V15M19 8v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2m-2 0H7v11h10V8m1-5H6v2h12V3"/>'
        },
        meditation: {
            body: '<path fill="currentColor" d="M12 4c1.11 0 2 .89 2 2s-.89 2-2 2s-2-.89-2-2s.9-2 2-2m9 12v-2c-2.24 0-4.16-.96-5.6-2.68l-1.34-1.6A1.98 1.98 0 0 0 12.53 9H11.5c-.61 0-1.17.26-1.55.72l-1.34 1.6C7.16 13.04 5.24 14 3 14v2c2.77 0 5.19-1.17 7-3.25V15l-3.88 1.55c-.67.27-1.12.95-1.12 1.66C5 19.2 5.8 20 6.79 20H9v-.5a2.5 2.5 0 0 1 2.5-2.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.83 0-1.5.67-1.5 1.5v.5h7.21c.99 0 1.79-.8 1.79-1.79c0-.71-.45-1.39-1.12-1.66L14 15v-2.25c1.81 2.08 4.23 3.25 7 3.25Z"/>'
        },
        medium: {
            body: '<path d="M4.37 7.3a.75.75 0 0 0-.25-.65L2.25 4.4v-.34h5.8l4.48 9.83l3.94-9.83H22v.34l-1.6 1.53c-.13.1-.2.28-.17.45v11.24c-.03.17.04.35.17.45l1.56 1.53v.34h-7.84v-.34l1.61-1.57c.16-.15.16-.2.16-.44V8.5L11.4 19.9h-.6L5.57 8.5v7.64c-.07.32.06.64.29.86l2.1 2.57v.33H2v-.33L4.1 17a.94.94 0 0 0 .27-.86V7.3z" fill="currentColor"/>',
            hidden: true
        },
        meetup: {
            body: '<path d="M19.61 14.86c0 1.82-1.31 3.39-3.11 3.69c-.21.04-.43.07-.66.06c-.08 0-.11.03-.13.1c-.36 1.03-1.07 1.64-2.14 1.79c-.71.1-1.35-.09-1.92-.53c-.08-.07-.15-.07-.21-.01c-.66.47-1.4.68-2.21.63c-1.57-.09-2.9-1.3-3.15-2.85c-.02-.11-.04-.24-.04-.33c0-.09-.04-.12-.12-.14c-.48-.09-.92-.27-1.29-.59c-.71-.55-1.13-1.27-1.23-2.18c-.11-1 .21-1.88.92-2.61c.06-.06.06-.1.02-.17c-.27-.48-.4-1-.38-1.55a2.935 2.935 0 0 1 2.35-2.8c.15-.04.23-.1.3-.24c.66-1.42 1.76-2.28 3.3-2.57c1.09-.2 2.09.02 3.03.57c.06.05.14.05.23.03c1.5-.44 2.83-.12 3.95.95c.66.63 1.03 1.43 1.14 2.35c.02.2.03.4.02.6c-.01.08.01.11.09.13c.67.25 1.13.72 1.34 1.41c.25.85.04 1.61-.6 2.23c-.06.06-.04.09-.01.14c.34.59.51 1.21.51 1.89m-6.68-.29c0 .77.5 1.43 1.21 1.69c.36.11.71.17 1.08.19c.28.01.53-.01.78-.13c.19-.1.28-.26.27-.47c-.01-.21-.11-.35-.31-.45a.808.808 0 0 0-.22-.07c-.24-.04-.44-.07-.67-.12c-.36-.07-.52-.26-.52-.64c-.01-.33.08-.64.18-.94c.19-.56.44-1.1.68-1.63c.23-.53.47-1.05.63-1.6c.09-.3.14-.6.05-.9c-.12-.5-.4-.8-.89-.89c-.45-.11-.9-.11-1.3.17c-.14.09-.27.07-.4-.04l-.24-.24c-.42-.38-.96-.4-1.41-.05c-.18.14-.35.31-.52.44c-.17.11-.33.14-.54.03c-.19-.09-.37-.18-.56-.27c-.2-.08-.38-.19-.6-.21c-.68-.06-1.39.35-1.69.97c-.14.27-.25.55-.35.84c-.48 1.32-.87 2.66-1.27 4.01c-.18.6.03 1.19.54 1.51c.4.23.83.32 1.28.18c.36-.11.57-.4.71-.73c.46-1.09.88-2.22 1.32-3.31c.12-.3.24-.61.37-.91c.13-.3.5-.4.72-.2c.14.12.18.29.16.46c-.01.19-.08.36-.15.53c-.27.71-.58 1.45-.87 2.18c-.06.14-.12.29-.15.45c-.04.27.06.51.29.58c.22.12.46.14.69.05c.27-.1.44-.31.56-.55l1.29-2.55c.2-.39.42-.78.6-1.17c.08-.14.17-.28.32-.37c.12-.08.25-.08.38-.01c.12.07.12.2.12.33c0 .07 0 .14-.03.2c-.06.14-.11.27-.17.4c-.36.76-.73 1.51-1.08 2.26c-.15.32-.31.64-.29.98m5.03 5.55c0-.5-.42-.92-.92-.92c-.54 0-.94.41-.94.92a.93.93 0 0 0 .93.93a.93.93 0 0 0 .93-.93M2.38 12.46c.48 0 .89-.41.89-.89c0-.48-.4-.88-.88-.88c-.5 0-.89.39-.89.88s.39.89.88.89m10.88-9.91c-.49 0-.89.39-.89.87c0 .49.4.88.88.88c.49 0 .88-.38.88-.87a.88.88 0 0 0-.87-.88m7.19 5.48c0-.4-.34-.74-.74-.74a.758.758 0 0 0-.76.75c0 .41.33.74.75.74s.76-.33.75-.75M5.04 5.89c0 .38.3.67.67.67c.38 0 .68-.3.67-.68c0-.38-.29-.66-.66-.66c-.39 0-.68.28-.68.67m7.02 15.55a.57.57 0 0 0-.56-.58a.57.57 0 0 0-.59.58c0 .31.25.56.59.56c.3 0 .56-.25.56-.56M21 12.5c-.29 0-.55.28-.55.58a.55.55 0 0 0 .55.55c.33 0 .57-.23.57-.55c0-.31-.24-.58-.57-.58M7.62 2c-.27 0-.48.2-.48.47c0 .26.21.47.48.47a.47.47 0 0 0 .47-.47c0-.27-.2-.47-.47-.47m14.46 8c-.22 0-.41.17-.42.4c0 .23.19.42.42.42c.24 0 .42-.18.42-.41c0-.24-.18-.41-.42-.41M5.5 18.26c0-.22-.21-.41-.44-.42c-.22 0-.41.19-.41.43c0 .23.19.41.42.41c.23 0 .43-.18.43-.42z" fill="currentColor"/>',
            hidden: true
        },
        memory: {
            body: '<path fill="currentColor" d="M17 17H7V7h10m4 4V9h-2V7a2 2 0 0 0-2-2h-2V3h-2v2h-2V3H9v2H7c-1.11 0-2 .89-2 2v2H3v2h2v2H3v2h2v2a2 2 0 0 0 2 2h2v2h2v-2h2v2h2v-2h2a2 2 0 0 0 2-2v-2h2v-2h-2v-2m-6 2h-2v-2h2m2-2H9v6h6V9Z"/>'
        },
        menorah: {
            body: '<path fill="currentColor" d="M21 11V6l-2-1v6h-2V6l-2-1v6h-2V3l-2-1v9H9V6L7 5v6H5V6L3 5v6c-.55 0-1 .45-1 1s.45 1 1 1h1.25c.7 1.92 2.69 4.58 6.75 4.95V20h-1c-1.1 0-2 .9-2 2h8a2 2 0 0 0-2-2h-1v-2.05c4.06-.38 6.05-3.03 6.75-4.95H21c.55 0 1-.45 1-1s-.45-1-1-1m-10 4.94c-2.66-.31-3.95-1.83-4.55-2.94H11v2.94m2 0V13h4.55c-.6 1.11-1.89 2.63-4.55 2.94Z"/>'
        },
        "menorah-fire": {
            body: '<path fill="currentColor" d="M21.5 11.15V10c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-1V8c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v3h-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1.15c-.29.18-.5.48-.5.85c0 .55.45 1 1 1h1.25c.7 1.92 2.69 4.58 6.75 4.95V20h-1c-1.1 0-2 .9-2 2h8a2 2 0 0 0-2-2h-1v-2.05c4.06-.38 6.05-3.03 6.75-4.95H21c.55 0 1-.45 1-1c0-.37-.21-.67-.5-.85M6.45 13H11v2.94c-2.66-.31-3.95-1.83-4.55-2.94M13 15.94V13h4.55c-.6 1.11-1.89 2.63-4.55 2.94M12 6c.83 0 1.5-.67 1.5-1.5S12.83 2 12 2s-1.5 1.67-1.5 2.5c0 .83.67 1.5 1.5 1.5m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M16 8c.83 0 1.5-.67 1.5-1.5S16.83 4 16 4s-1.5 1.67-1.5 2.5c0 .83.67 1.5 1.5 1.5m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M20 8c.83 0 1.5-.67 1.5-1.5S20.83 4 20 4s-1.5 1.67-1.5 2.5c0 .83.67 1.5 1.5 1.5m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M4 8c.83 0 1.5-.67 1.5-1.5S4.83 4 4 4S2.5 5.67 2.5 6.5C2.5 7.33 3.17 8 4 8m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M8 8c.83 0 1.5-.67 1.5-1.5S8.83 4 8 4S6.5 5.67 6.5 6.5C6.5 7.33 7.17 8 8 8m0-1.75c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5Z"/>'
        },
        menu: {
            body: '<path fill="currentColor" d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2Z"/>'
        },
        "menu-close": {
            body: '<path d="M21 15.61l-1.406 1.406L14.578 12l5.016-5.016L21 8.391L17.437 12L21 15.61zM3 6h12.984v2.016H3V6zm0 6.984v-1.968h9.984v1.968H3zM3 18v-2.016h12.984V18H3z" fill="currentColor"/>',
            hidden: true
        },
        "menu-down": {
            body: '<path fill="currentColor" d="m7 10l5 5l5-5H7Z"/>'
        },
        "menu-down-outline": {
            body: '<path fill="currentColor" d="M18 9v1.5l-6 6l-6-6V9h12m-6 4.67L14.67 11H9.33L12 13.67Z"/>'
        },
        "menu-left": {
            body: '<path fill="currentColor" d="m14 7l-5 5l5 5V7Z"/>'
        },
        "menu-left-outline": {
            body: '<path fill="currentColor" d="M15 18h-1.5l-6-6l6-6H15v12m-4.67-6L13 14.67V9.33L10.33 12Z"/>'
        },
        "menu-open": {
            body: '<path fill="currentColor" d="M21 15.61L19.59 17l-5.01-5l5.01-5L21 8.39L17.44 12L21 15.61M3 6h13v2H3V6m0 7v-2h10v2H3m0 5v-2h13v2H3Z"/>'
        },
        "menu-right": {
            body: '<path fill="currentColor" d="m10 17l5-5l-5-5v10Z"/>'
        },
        "menu-right-outline": {
            body: '<path fill="currentColor" d="M9 6h1.5l6 6l-6 6H9V6m4.67 6L11 9.33v5.34L13.67 12Z"/>'
        },
        "menu-swap": {
            body: '<path fill="currentColor" d="m12 6l-5 5h10l-5-5m-5 7l5 5l5-5H7Z"/>'
        },
        "menu-swap-outline": {
            body: '<path fill="currentColor" d="m12 3.5l-6 6V11h12V9.5l-6-6m0 2.83L14.67 9H9.33L12 6.33M6 13v1.5l6 6l6-6V13H6m3.33 2h5.34L12 17.67L9.33 15Z"/>'
        },
        "menu-up": {
            body: '<path fill="currentColor" d="m7 15l5-5l5 5H7Z"/>'
        },
        "menu-up-outline": {
            body: '<path fill="currentColor" d="M18 16v-1.5l-6-6l-6 6V16h12m-6-4.67L14.67 14H9.33L12 11.33Z"/>'
        },
        merge: {
            body: '<path fill="currentColor" d="m8 17l4-4h3.2c.4 1.2 1.5 2 2.8 2c1.7 0 3-1.3 3-3s-1.3-3-3-3c-1.3 0-2.4.8-2.8 2H12L8 7V3H3v5h3l4.2 4L6 16H3v5h5v-4Z"/>'
        },
        message: {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "message-alert": {
            body: '<path fill="currentColor" d="M13 11h-2V5h2m0 10h-2v-2h2m7-11H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"/>'
        },
        "message-alert-outline": {
            body: '<path fill="currentColor" d="M13 10h-2V6h2v4m0 2h-2v2h2v-2m9-8v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2m-2 0H4v13.2L5.2 16H20V4Z"/>'
        },
        "message-arrow-left": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-4 9h-4.5l1.8 1.8L12 14l-4-4l4-4l1.2 1.2L11.5 9H16v2Z"/>'
        },
        "message-arrow-left-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-4-5V9h-4.5l1.8-1.8L12 6l-4 4l4 4l1.2-1.2l-1.7-1.8H16Z"/>'
        },
        "message-arrow-right": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 12l-1.2-1.2l1.8-1.8H8V9h4.5l-1.8-1.8L12 6l4 4l-4 4Z"/>'
        },
        "message-arrow-right-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M8 9v2h4.5l-1.8 1.8L12 14l4-4l-4-4l-1.2 1.2L12.5 9H8Z"/>'
        },
        "message-badge": {
            body: '<path fill="currentColor" d="M22 7v9c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.1.3-.1.7-.1 1c0 2.8 2.2 5 5 5c1.1 0 2.2-.4 3-1m-6-4c0 1.7 1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3s-3 1.3-3 3Z"/>'
        },
        "message-badge-outline": {
            body: '<path fill="currentColor" d="M22 7v9c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.1.3-.1.7-.1 1s0 .7.1 1H4v12h16V7.9c.7-.1 1.4-.5 2-.9m-6-4c0 1.7 1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3s-3 1.3-3 3Z"/>'
        },
        "message-bookmark": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-1 11l-2.5-1.5L14 13V5h5v8Z"/>'
        },
        "message-bookmark-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-2-2V6h-5v8l2.5-1.5L18 14"/>'
        },
        "message-bulleted": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M8 14H6v-2h2v2m0-3H6V9h2v2m0-3H6V6h2v2m7 6h-5v-2h5v2m3-3h-8V9h8v2m0-3h-8V6h8v2Z"/>'
        },
        "message-bulleted-off": {
            body: '<path fill="currentColor" d="M1.27 1.73L0 3l2 2v17l4-4h9l5.73 5.73L22 22.46L1.27 1.73M8 14H6v-2h2v2m-2-3V9l2 2H6m14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 7c1.07-.05 1.93-.92 1.93-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "message-check": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-9.53 12L7 10.5l1.4-1.41l2.07 2.08L15.6 6L17 7.41L10.47 14Z"/>'
        },
        "message-check-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-9.53-2L7 10.5l1.4-1.41l2.07 2.08L15.6 6L17 7.41L10.47 14Z"/>'
        },
        "message-cog": {
            body: '<path fill="currentColor" d="M13.5 10a1.5 1.5 0 0 1-1.5 1.5c-.84 0-1.5-.67-1.5-1.5A1.5 1.5 0 0 1 12 8.5a1.5 1.5 0 0 1 1.5 1.5M22 4v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2m-5.23 7.32l-1.07-.82c.01-.17.01-.34 0-.5c.02-.16.02-.33 0-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.16-.32-.13l-1.23.5c-.27-.2-.54-.37-.85-.5l-.19-1.31A.235.235 0 0 0 13 5h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.12-.59.28-.86.47l-1.24-.5c-.12-.04-.25 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.84c-.04.32-.04.66 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.16.31.13L9.7 13c.26.2.54.37.85.5l.19 1.31c.03.12.14.19.26.19h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.56-.29.84-.47l1.25.5c.12 0 .25 0 .31-.13l1-1.73a.25.25 0 0 0-.07-.32Z"/>'
        },
        "message-cog-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-3.2-4.7l-1.1-.8v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.5-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.1 0-.2.1-.2.2l-.2 1.3c-.3.2-.6.3-.9.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.1.2-.1.3l1 1.7c.1.1.2.2.3.1l1.2-.3c.3.2.5.4.8.5l.2 1.3c0 .1.1.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.1.6-.3.8-.5l1.2.5c.1 0 .2 0 .3-.1l1-1.7c.2-.2.2-.3.1-.4m-4.8.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "message-draw": {
            body: '<path fill="currentColor" d="M18 14h-7.5l2-2H18M6 14v-2.5l6.88-6.86c.19-.19.51-.19.71 0l1.76 1.77c.2.2.2.51 0 .71L8.47 14M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "message-fast": {
            body: '<path fill="currentColor" d="M3 7c-.6 0-1 .4-1 1s.4 1 1 1h2V7H3m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h3v-2H2m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h4v-2H1M20 5H9c-1.1 0-2 .9-2 2v14l4-4h9c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Z"/>'
        },
        "message-fast-outline": {
            body: '<path fill="currentColor" d="M20 5H9c-1.1 0-2 .9-2 2v14l4-4h9c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 10h-9.8L9 16.2V7h11v8M3 7c-.6 0-1 .4-1 1s.4 1 1 1h2V7H3m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h3v-2H2m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h4v-2H1Z"/>'
        },
        "message-flash": {
            body: '<path fill="currentColor" d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v18l4-4h9v-8h7V4m.5 12h-2.2l1.7-4h-5v6h2v5l3.5-7Z"/>'
        },
        "message-flash-outline": {
            body: '<path fill="currentColor" d="M4 17.2V4h16v6h2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v18l4-4h9v-2H5.2L4 17.2M22.5 16h-2.2l1.7-4h-5v6h2v5l3.5-7Z"/>'
        },
        "message-image": {
            body: '<path fill="currentColor" d="m5 14l3.5-4.5l2.5 3L14.5 8l4.5 6m1-12H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "message-image-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M5 14l3.5-4.5l2.5 3L14.5 8l4.5 6"/>'
        },
        "message-lock": {
            body: '<path fill="currentColor" d="M20.5 0A2.5 2.5 0 0 0 18 2.5V3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1v-.5A2.5 2.5 0 0 0 20.5 0m0 1A1.5 1.5 0 0 1 22 2.5V3h-3v-.5A1.5 1.5 0 0 1 20.5 1M4 2a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2v-5h-5c-1.11 0-2-.89-2-2V2H4Z"/>'
        },
        "message-lock-outline": {
            body: '<path fill="currentColor" d="M23 3v-.5C23 1.1 21.9 0 20.5 0S18 1.1 18 2.5V3c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1m-1 0h-3v-.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V3m0 8v5c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h11v2H4v13.2L5.2 16H20v-5h2Z"/>'
        },
        "message-minus": {
            body: '<path fill="currentColor" d="M20 2a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2H6l-4 4V4a2 2 0 0 1 2-2h16M8 9v2h8V9H8Z"/>'
        },
        "message-minus-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M8 9v2h8V9H8Z"/>'
        },
        "message-off": {
            body: '<path fill="currentColor" d="M20.95 17.75L5.2 2H20a2 2 0 0 1 2 2v12c0 .76-.43 1.41-1.05 1.75M2.39 1.73L1.11 3l.89.9V22l4-4h10.11l4.73 4.73l1.27-1.27L2.39 1.73Z"/>'
        },
        "message-off-outline": {
            body: '<path fill="currentColor" d="m7.2 4l-2-2H20a2 2 0 0 1 2 2v12c0 .76-.43 1.41-1.05 1.75L19.2 16h.8V4H7.2m14.91 17.46l-1.27 1.27L16.11 18H6l-4 4V3.9L1.11 3l1.28-1.27L6.1 5.44L16.65 16h.01l2 2h-.01l3.46 3.46m-8-5.46L4 5.89V18l2-2h8.11Z"/>'
        },
        "message-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12Z"/>'
        },
        "message-plus": {
            body: '<path fill="currentColor" d="M20 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h16m-9 4v3H8v2h3v3h2v-3h3V9h-3V6h-2Z"/>'
        },
        "message-plus-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-4-7v2h-3v3h-2v-3H8V9h3V6h2v3h3Z"/>'
        },
        "message-processing": {
            body: '<path fill="currentColor" d="M17 11h-2V9h2m-4 2h-2V9h2m-4 2H7V9h2m11-7H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "message-processing-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-3-5h-2V9h2m-4 2h-2V9h2m-4 2H7V9h2"/>'
        },
        "message-question": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7 12h-2v-2h2v2m1.8-5c-.3.4-.7.6-1.1.8c-.3.2-.4.3-.5.5c-.2.2-.2.4-.2.7h-2c0-.5.1-.8.3-1.1c.2-.2.6-.5 1.1-.8c.3-.1.5-.3.6-.5c.1-.2.2-.5.2-.7c0-.3-.1-.5-.3-.7c-.2-.2-.5-.3-.8-.3c-.3 0-.5.1-.7.2c-.2.1-.3.3-.3.6h-2c.1-.7.4-1.3.9-1.7c.5-.4 1.2-.5 2.1-.5c.9 0 1.7.2 2.2.6c.5.4.8 1 .8 1.7c.1.4 0 .8-.3 1.2Z"/>'
        },
        "message-question-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M12.2 5.5c-.9 0-1.6.2-2.1.5c-.6.4-.9 1-.8 1.7h2c0-.3.1-.5.3-.6c.2-.1.4-.2.7-.2c.3 0 .6.1.8.3c.2.2.3.4.3.7c0 .3-.1.5-.2.7c-.2.2-.4.4-.6.5c-.5.3-.9.6-1.1.8c-.4.3-.5.6-.5 1.1h2c0-.3.1-.5.1-.7c.1-.2.3-.3.5-.5c.5-.2.8-.5 1.1-.9c.3-.4.4-.8.4-1.2c0-.7-.3-1.3-.8-1.7c-.4-.3-1.2-.5-2.1-.5M11 12v2h2v-2h-2Z"/>'
        },
        "message-reply": {
            body: '<path fill="currentColor" d="M22 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14l4 4V4Z"/>'
        },
        "message-reply-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2m0 15.2L18.8 16H4V4h16v13.2Z"/>'
        },
        "message-reply-text": {
            body: '<path fill="currentColor" d="M18 8H6V6h12v2m0 3H6V9h12v2m0 3H6v-2h12v2m4-10a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14l4 4V4Z"/>'
        },
        "message-reply-text-outline": {
            body: '<path fill="currentColor" d="M9 11h9v2H9v-2m9-4H6v2h12V7m4-3v18l-4-4H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2m-2 0H4v12h14.83L20 17.17V4Z"/>'
        },
        "message-settings": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-9 22h2v-2h-2v2m-4 0h2v-2H7v2m8 0h2v-2h-2v2Z"/>'
        },
        "message-settings-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-9 8h2v-2h-2v2m-4 0h2v-2H7v2m8 0h2v-2h-2v2"/>'
        },
        "message-star": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-5.4 12L12 12.4L9.4 14l.7-3l-2.3-2l3-.3L12 6l1.2 2.8l3 .3l-2.3 2l.7 2.9Z"/>'
        },
        "message-star-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12m-8-3.6l2.6 1.6l-.7-3l2.3-2l-3-.3L12 6l-1.2 2.8l-3 .2l2.3 2l-.7 3l2.6-1.6Z"/>'
        },
        "message-text": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12"/>'
        },
        "message-text-clock": {
            body: '<path fill="currentColor" d="M22 12.41V4a2 2 0 0 0-2-2H4c-1.1 0-2 .9-2 2v18l4-4h3.29A7.001 7.001 0 0 0 23 16c0-1.31-.37-2.54-1-3.59M6 6h12v2H6V6m10 3c-1.9 0-3.63.77-4.89 2H6V9h10M6 12h4.26c-.42.6-.76 1.28-.96 2H6v-2m10 8.85c-2.68 0-4.85-2.17-4.85-4.85s2.17-4.85 4.85-4.85c2.67 0 4.85 2.17 4.85 4.85s-2.18 4.85-4.85 4.85m.5-5.03l2.44 1.41l-.75 1.3L15 16.69V13h1.5v2.82Z"/>'
        },
        "message-text-clock-outline": {
            body: '<path fill="currentColor" d="M22 12.41V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v18l4-4h3.29A7.001 7.001 0 0 0 23 16c0-1.31-.37-2.54-1-3.59M5.17 16L4 17.17V4h16v6.26A6.963 6.963 0 0 0 16 9c-1.9 0-3.63.77-4.89 2H6v2h3.69c-.44.91-.69 1.93-.69 3H5.17M16 20.85c-2.68 0-4.85-2.17-4.85-4.85s2.17-4.85 4.85-4.85c2.67 0 4.85 2.17 4.85 4.85s-2.18 4.85-4.85 4.85M18 9H6V7h12v2m-1.5 6.82l2.44 1.41l-.75 1.3L15 16.69V13h1.5v2.82Z"/>'
        },
        "message-text-fast": {
            body: '<path fill="currentColor" d="M9 5c-1.1 0-2 .9-2 2v14l4-4h9c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H9M3 7c-.6 0-1 .4-1 1s.4 1 1 1h2V7H3m8 1h8v2h-8V8m-9 3c-.6 0-1 .4-1 1s.4 1 1 1h3v-2H2m9 1h5v2h-5v-2M1 15c-.6 0-1 .4-1 1s.4 1 1 1h4v-2H1Z"/>'
        },
        "message-text-fast-outline": {
            body: '<path fill="currentColor" d="M10 11.5h7V13h-7v-1.5m0-3h9V10h-9V8.5M20 5H9c-1.1 0-2 .9-2 2v14l4-4h9c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 10h-9.8L9 16.2V7h11v8M3 7c-.6 0-1 .4-1 1s.4 1 1 1h2V7H3m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h3v-2H2m-1 4c-.6 0-1 .4-1 1s.4 1 1 1h4v-2H1Z"/>'
        },
        "message-text-lock": {
            body: '<path fill="currentColor" d="M20.5 0A2.5 2.5 0 0 0 18 2.5V3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1v-.5A2.5 2.5 0 0 0 20.5 0m0 1A1.5 1.5 0 0 1 22 2.5V3h-3v-.5A1.5 1.5 0 0 1 20.5 1M4 2a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2v-5h-5c-1.11 0-2-.89-2-2V2H4m2 4h7v2H6V6m0 3h7v2H6V9m0 3h8v2H6v-2Z"/>'
        },
        "message-text-lock-outline": {
            body: '<path fill="currentColor" d="M23 3v-.5a2.5 2.5 0 0 0-5 0V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V3M6 11h9v2H6v-2m0-4h9v2H6V7m16 4v5c0 1.11-.89 2-2 2H6l-4 4V4a2 2 0 0 1 2-2h11v2H4v13.17L5.17 16H20v-5h2Z"/>'
        },
        "message-text-outline": {
            body: '<path fill="currentColor" d="M20 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h16M4 4v13.17L5.17 16H20V4H4m2 3h12v2H6V7m0 4h9v2H6v-2Z"/>'
        },
        "message-video": {
            body: '<path fill="currentColor" d="m18 14l-4-3.2V14H6V6h8v3.2L18 6m2-4H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        meteor: {
            body: '<path fill="currentColor" d="m2.8 3l16.87 15.82s.33.45-.09.89c-.41.44-.95.06-.95.06L2.8 3m5.01 1.59l13.1 12.05s.32.44-.09.86c-.42.47-.96.09-.96.09l-12.05-13M4.29 8l13.1 12.03s.32.44-.09.88c-.42.45-.96.09-.96.09L4.29 8m7.76-2.04l9.15 8.41s.22.31-.07.63c-.28.3-.66.03-.66.03l-8.42-9.07m-6.6 5.95l9.15 8.42s.22.31-.06.62c-.29.31-.67.05-.67.05l-8.42-9.09m10.93-3.99l4.17 3.82s.11.14-.05.29c-.12.14-.31.02-.31.02l-3.81-4.13M7.56 16.1l4.18 3.81s.11.15-.04.29c-.14.15-.33.02-.33.02L7.56 16.1Z"/>'
        },
        "meter-electric": {
            body: '<path fill="currentColor" d="M12 2c-4.96 0-9 4.04-9 9c0 3.91 2.5 7.24 6 8.47V22h2v-2.06c.33.06.66.06 1 .06s.67 0 1-.06V22h2v-2.53c3.5-1.24 6-4.57 6-8.47c0-4.96-4.04-9-9-9m2.25 12l-3 3l-1.5-1.5L11 14.25L9.75 13l3-3l1.5 1.5L13 12.75L14.25 14M16 9H8V7h8v2Z"/>'
        },
        "meter-electric-outline": {
            body: '<path fill="currentColor" d="M21 11a9 9 0 0 0-18 0c0 3.92 2.5 7.24 6 8.5V22h2v-2.06c.33.06.66.06 1 .06s.67 0 1-.06V22h2v-2.5c3.5-1.26 6-4.58 6-8.5m-9 7c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 7h8v2H8V7m4.75 3l-3 3L11 14.25L9.75 15.5l1.5 1.5l3-3L13 12.75l1.25-1.25l-1.5-1.5Z"/>'
        },
        "meter-gas": {
            body: '<path fill="currentColor" d="M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4m-4 14c-1.38 0-2.5-1.1-2.5-2.46c0-1.09.43-1.39 2.5-3.79c2.05 2.38 2.5 2.7 2.5 3.79C14.5 16.9 13.38 18 12 18m4-8H8V8h8v2Z"/>'
        },
        "meter-gas-outline": {
            body: '<path fill="currentColor" d="M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4m2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10m-8.5-2.46C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-1.09-.45-1.41-2.5-3.79c-2.07 2.4-2.5 2.71-2.5 3.79M8 8h8v2H8V8Z"/>'
        },
        metronome: {
            body: '<path fill="currentColor" d="m12 1.75l-3.43.92l-4.51 16.86c-.03.15-.06.31-.06.47c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2c0-.16-.03-.32-.06-.47l-1.36-5.11L17 16l.2 1h-3.79l2.84-2.84l-1.41-1.41L10.59 17H6.8l3.49-13h3.42l1.46 5.43l1.63-1.64l-1.37-5.12L12 1.75M11.25 5v9.75l1.5-1.5V5h-1.5m8.54 2.8l-2.83 2.83l-.71-.71l-1.41 1.42l2.82 2.82l1.42-1.41l-.71-.71l2.83-2.83l-1.41-1.41Z"/>'
        },
        "metronome-tick": {
            body: '<path fill="currentColor" d="m12 1.75l-3.43.92l-4.5 16.83c-.01 0-.07.34-.07.5c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2c0-.16-.06-.5-.07-.5l-4.5-16.83L12 1.75M10.29 4h3.42l3.49 13H13v-5h-2v5H6.8l3.49-13M11 5v4h-1v2h4V9h-1V5h-2Z"/>'
        },
        "micro-sd": {
            body: '<path fill="currentColor" d="M8 2a2 2 0 0 0-2 2v7l-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8m1 2h2v4H9V4m3 0h2v4h-2V4m3 0h2v4h-2V4Z"/>'
        },
        microphone: {
            body: '<path fill="currentColor" d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3m7 9c0 3.53-2.61 6.44-6 6.93V21h-2v-3.07c-3.39-.49-6-3.4-6-6.93h2a5 5 0 0 0 5 5a5 5 0 0 0 5-5h2Z"/>'
        },
        "microphone-message": {
            body: '<path fill="currentColor" d="M8 7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m6 7c0 2.97-2.16 5.44-5 5.92V22H7v-2.08c-2.84-.48-5-2.95-5-5.92h2a4 4 0 0 0 4 4a4 4 0 0 0 4-4h2m7.41-4.59l-4.24 4.25L18.18 10H14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4c0 .55-.22 1.05-.59 1.41Z"/>'
        },
        "microphone-message-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-5.35-5.35A6 6 0 0 1 9 19.92V22H7v-2.08c-2.84-.48-5-2.95-5-5.92h2a4 4 0 0 0 4 4c1.82 0 3.36-1.22 3.84-2.89L10 13.27V14a2 2 0 0 1-2 2a2 2 0 0 1-2-2V9.27l-4-4m19.41 4.14l-4.24 4.25L18.18 10H14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4c0 .55-.22 1.05-.59 1.41Z"/>'
        },
        "microphone-minus": {
            body: '<path fill="currentColor" d="M9 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3m7 9c0 3.5-2.56 6.43-6 6.93V21H8v-3.07c-3.44-.5-6-3.43-6-6.93h2a5 5 0 0 0 5 5a5 5 0 0 0 5-5h2m-1-6h8v2h-8V5Z"/>'
        },
        "microphone-off": {
            body: '<path fill="currentColor" d="M19 11c0 1.19-.34 2.3-.9 3.28l-1.23-1.23c.27-.62.43-1.31.43-2.05H19m-4 .16L9 5.18V5a3 3 0 0 1 3-3a3 3 0 0 1 3 3v6.16M4.27 3L21 19.73L19.73 21l-4.19-4.19c-.77.46-1.63.77-2.54.91V21h-2v-3.28c-3.28-.49-6-3.31-6-6.72h1.7c0 3 2.54 5.1 5.3 5.1c.81 0 1.6-.19 2.31-.52l-1.66-1.66L12 14a3 3 0 0 1-3-3v-.72L3 4.27L4.27 3Z"/>'
        },
        "microphone-outline": {
            body: '<path fill="currentColor" d="M17.3 11c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.49 6-3.31 6-6.72m-8.2-6.1c0-.66.54-1.2 1.2-1.2c.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2c-.66 0-1.2-.54-1.2-1.2M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3Z"/>'
        },
        "microphone-plus": {
            body: '<path fill="currentColor" d="M9 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3m7 9c0 3.5-2.56 6.43-6 6.93V21H8v-3.07c-3.44-.5-6-3.43-6-6.93h2a5 5 0 0 0 5 5a5 5 0 0 0 5-5h2m-1-6h3V2h2v3h3v2h-3v3h-2V7h-3V5Z"/>'
        },
        "microphone-question": {
            body: '<path fill="currentColor" d="M9 2c1.66 0 3 1.34 3 3v6c0 1.66-1.34 3-3 3s-3-1.34-3-3V5c0-1.66 1.34-3 3-3m7 9c0 3.53-2.61 6.44-6 6.93V21H8v-3.07c-3.39-.49-6-3.4-6-6.93h2c0 2.76 2.24 5 5 5s5-2.24 5-5h2m4.5 3.5V16H19v-1.5h1.5m-2-5H17V9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.01-.91 1.7v.2H19v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5Z"/>'
        },
        "microphone-question-outline": {
            body: '<path fill="currentColor" d="M14.3 11c0 3-2.54 5.1-5.3 5.1S3.7 14 3.7 11H2c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.49 6-3.31 6-6.72M7.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2s-1.2-.54-1.2-1.2M9 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S6 3.34 6 5v6c0 1.66 1.34 3 3 3m11.5.5V16H19v-1.5h1.5m-2-5H17V9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.01-.91 1.7v.2H19v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5Z"/>'
        },
        "microphone-settings": {
            body: '<path fill="currentColor" d="M19 10h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72m-4 14h2v-2h-2m-4 2h2v-2h-2m1-9a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3M7 24h2v-2H7v2Z"/>'
        },
        "microphone-variant": {
            body: '<path fill="currentColor" d="M9 3a4 4 0 0 1 4 4H5a4 4 0 0 1 4-4m2.84 6.82L11 18h-1v1a2 2 0 0 0 2 2a2 2 0 0 0 2-2v-5a4 4 0 0 1 4-4h2l-1 1l1 1h-2a2 2 0 0 0-2 2v5a4 4 0 0 1-4 4a4 4 0 0 1-4-4v-1H7l-.84-8.18C5.67 9.32 5.31 8.7 5.13 8h7.74c-.18.7-.54 1.32-1.03 1.82M9 11a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microphone-variant-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22L16 19.26A4.012 4.012 0 0 1 12 23a4 4 0 0 1-4-4v-1H7l-.84-8.18a4.12 4.12 0 0 1-.83-1.22L2 5.27M9 3a4 4 0 0 1 4 4H8.82L6.08 4.26C6.81 3.5 7.85 3 9 3m2.84 6.82l-.02.18l-2-2h3.05c-.18.7-.54 1.32-1.03 1.82M11 18h-1v1a2 2 0 0 0 2 2a2 2 0 0 0 2-2v-1.73l-2.65-2.65L11 18m7-8h2l-1 1l1 1h-2a2 2 0 0 0-2 2v.18l-1.7-1.68C14.9 11 16.33 10 18 10M8 12a1 1 0 0 0 1 1c.21 0 .4-.06.56-.17l-1.39-1.39c-.11.16-.17.35-.17.56Z"/>'
        },
        microscope: {
            body: '<path fill="currentColor" d="M9.46 6.28L11.05 9c-2.58.26-4.55 2.41-4.55 5a5 5 0 0 0 5 5c2.05 0 3.81-1.23 4.58-3H13.5v-2h8v2h-2.25a8.048 8.048 0 0 1-2.46 4h2.71v2h-16v-2h2.71a7.99 7.99 0 0 1-2.71-6c0-3.63 2.46-6.8 5.96-7.72m3.28-4.21l.76 1.3l.86-.5l3.5 6.06l-3.47 2l-3.5-6.06l.87-.5l-.76-1.3l1.74-1Z"/>'
        },
        microsoft: {
            body: '<path fill="currentColor" d="M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9Z"/>'
        },
        "microsoft-access": {
            body: '<path fill="currentColor" d="M14.5 2.63q1.34 0 2.68.14l.67.09q.45.07.99.18q.53.11 1.09.27q.57.16 1.03.38q.46.22.75.5t.29.62v14.38q0 .34-.29.62q-.3.28-.75.5q-.46.22-1.03.38q-.56.16-1.1.27q-.53.11-.97.18q-.45.07-.69.09q-1.33.15-2.67.15q-1.35 0-2.68-.15q-.23-.02-.67-.09q-.45-.07-.99-.18q-.53-.11-1.09-.27q-.57-.16-1.02-.38q-.46-.22-.76-.5q-.29-.28-.29-.62V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.81q0-.34.29-.62q.3-.28.76-.5q.45-.22 1.02-.38q.56-.16 1.1-.27q.53-.11.97-.18q.45-.06.69-.09q1.32-.14 2.67-.14m0 1.25q-.63 0-1.42.04q-.78.04-1.58.15q-.81.11-1.57.29t-1.35.45q.61.29 1.37.47q.75.18 1.55.28q.79.1 1.57.15q.78.04 1.43.04q.66 0 1.43-.04q.78-.05 1.57-.15q.8-.1 1.56-.28q.75-.18 1.36-.47q-.59-.27-1.35-.45q-.76-.18-1.57-.29q-.8-.11-1.58-.15q-.78-.04-1.42-.04m-8.56 9.91h2.12l.49 1.49h1.67L7.83 8.72H6.2l-2.42 6.56h1.66M20.75 19v-3q-.64.31-1.44.5q-.81.18-1.64.29q-.84.11-1.67.16q-.81.05-1.5.05q-.71 0-1.42-.04q-.71-.05-1.41-.13q-.23.17-.5.17H8.25v2q.28.21.75.38q.5.18 1.07.3q.58.13 1.22.22q.63.1 1.21.13q.62.06 1.14.08q.52.02.86.02q.34-.01.86-.03q.52-.01 1.14-.07q.58-.03 1.21-.13q.64-.09 1.22-.22q.57-.12 1.07-.3q.47-.17.75-.38m0-4.37V11q-.64.31-1.44.5q-.81.18-1.64.29q-.84.11-1.67.16q-.81.05-1.5.05q-.62 0-1.25-.03q-.62-.04-1.25-.1v3.75q.63.07 1.25.1q.63.03 1.25.03q.36 0 .88-.02t1.12-.07q.58-.06 1.2-.16q.63-.06 1.2-.19q.6-.13 1.06-.31q.49-.15.79-.37m0-5V6q-.64.31-1.44.5q-.81.18-1.64.29q-.84.11-1.67.16q-.81.05-1.5.05T13 6.95q-.83-.05-1.67-.16q-.83-.11-1.64-.29q-.8-.19-1.44-.5v1h2.92q.33 0 .59.24q.24.26.24.59v2.79q.63.07 1.25.1q.63.03 1.25.03q.36 0 .88-.02t1.12-.07q.58-.06 1.2-.16q.63-.06 1.2-.19q.6-.13 1.06-.31q.48-.15.79-.37M6.32 12.5l.68-2l.65 2Z"/>'
        },
        "microsoft-azure": {
            body: '<path fill="currentColor" d="M13.05 4.24L6.56 18.05L2 18l5.09-8.76l5.96-5m.7 1.09L22 19.76H6.74l9.3-1.66l-4.87-5.79l2.58-6.98Z"/>'
        },
        "microsoft-azure-devops": {
            body: '<path fill="currentColor" d="m22 18l-5 4l-8-3v3l-4.19-5.75l12.91 1.05V6.34L22 5.65V18M4.81 16.25V8.96l12.91-2.62L10.6 2v2.84L3.97 6.76L2 9.38v5.69l2.81 1.18Z"/>'
        },
        "microsoft-bing": {
            body: '<path fill="currentColor" d="M5 3v16l3.72 2L18 15.82v-4.09L9.77 8.95l1.61 3.89L13.94 14L8.7 16.92V4.27L5 3"/>'
        },
        "microsoft-dynamics-365": {
            body: '<path fill="currentColor" d="m6 2l11.25 6.5l-3.75 3L6 8V2m0 7l3.5 2.25L6 22L18 9v6L6 22V9Z"/>'
        },
        "microsoft-edge": {
            body: '<path fill="currentColor" d="M10.86 15.37c-.69-.77-1.16-1.69-1.31-2.72c-.3.46-.55.96-.73 1.5c-.92 2.75.68 6.18 3.4 7.18c2.34.78 4.97-.61 6.7-2.13c.26-.35 2.31-2.16 1.29-2.36c-3.02 1.55-7.02 1.11-9.35-1.47m.6-5.81c1.04-.01.04-.43-.39-.75c-1.04-.57-2.26-.85-3.44-.85C3.78 8 .995 10.41 2.3 14.4c.94 3.88 4.31 7 8.29 7.5c-2.05-1.29-3.29-3.71-3.29-6.12c.08-2.53 1.64-5.5 4.16-6.22M2.78 8.24C5.82 6 10.66 6.18 13.28 9c1.02 1.11 1.72 3 .79 4.37c-1.74 1.88 3.08 2.13 4.11 1.85c3.74-.72 4.73-5.07 2.95-8.07c-1.7-3.4-5.47-5.18-9.17-5.15c-4.06-.07-7.71 2.5-9.18 6.24Z"/>'
        },
        "microsoft-edge-legacy": {
            body: '<path d="M2.737 10.808c1.092-12.17 19.779-12.17 18.46 2.75H8.614c0 4.295 5.802 5.651 10.925 2.75v4.22c-6.291 3.353-14.542.904-14.542-6.443c0-5.5 4.973-7.27 4.973-7.27s-1.394 1.77-1.431 3.24h7.158c0-7.121-9.796-4.484-12.96.753z" fill="currentColor"/>',
            hidden: true
        },
        "microsoft-excel": {
            body: '<path fill="currentColor" d="M21.17 3.25q.33 0 .59.25q.24.24.24.58v15.84q0 .34-.24.58q-.26.25-.59.25H7.83q-.33 0-.59-.25q-.24-.24-.24-.58V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.08q0-.34.24-.58q.26-.25.59-.25M7 13.06l1.18 2.22h1.79L8 12.06l1.93-3.17H8.22L7.13 10.9l-.04.06l-.03.07q-.26-.53-.56-1.07q-.25-.53-.53-1.07H4.16l1.89 3.19L4 15.28h1.78m8.1 4.22V17H8.25v2.5m5.63-3.75v-3.12H12v3.12m1.88-4.37V8.25H12v3.13M13.88 7V4.5H8.25V7m12.5 12.5V17h-5.62v2.5m5.62-3.75v-3.12h-5.62v3.12m5.62-4.37V8.25h-5.62v3.13M20.75 7V4.5h-5.62V7Z"/>'
        },
        "microsoft-internet-explorer": {
            body: '<path fill="currentColor" d="m13 3l1 .06c2.8-1.27 5.23-1.42 6.5-.14c1 1.01 1.08 2.75.42 4.8A8.971 8.971 0 0 1 22 12l-.05 1H9.08c.37 2.28 1.98 4 3.92 4c1.31 0 2.47-.79 3.2-2h5.3c-1.25 3.5-4.58 6-8.5 6c-1.28 0-2.5-.27-3.59-.75c-2.91 1.43-5.52 1.65-6.84.31C1 18.96 1.68 15.57 4 12c.93-1.46 2.14-2.94 3.57-4.35l.81-.77c-1.17.69-2.67 1.74-4.19 3.29A9 9 0 0 1 13 3m0 4c-1.79 0-3.31 1.47-3.82 3.5h7.64C16.31 8.47 14.79 7 13 7m7.06-2.94c-.66-.67-1.84-.71-3.32-.25c1.48.69 2.76 1.75 3.67 3.08c.32-1.24.23-2.24-.35-2.83M3.89 20c.83.84 2.51.69 4.55-.24a9.052 9.052 0 0 1-3.97-4.88C3.27 17.15 3 19.07 3.89 20Z"/>'
        },
        "microsoft-office": {
            body: '<path fill="currentColor" d="M19.94 5.59v12.8q0 .67-.39 1.2q-.39.52-1.05.7l-5.73 1.65q-.12.03-.27.06h-.22q-.33 0-.6-.09q-.27-.09-.55-.24l-3.75-2.12q-.21-.12-.33-.31q-.12-.19-.12-.43q0-.36.26-.61q.25-.25.61-.25h4.86V6.14L9 7.44q-.43.16-.7.56q-.27.38-.27.85v6.73q0 .42-.21.76q-.2.34-.57.54l-1.72.94q-.24.13-.48.13q-.41 0-.7-.29t-.29-.71V7.47q0-.52.27-.97q.28-.5.73-.76l6.16-3.5q.21-.12.45-.18q.24-.06.48-.06q.17 0 .31.03q.14.02.31.07l5.73 1.59q.33.09.59.27q.26.18.45.43q.2.26.3.56q.1.31.1.64m-1.32 12.8V5.59q0-.23-.12-.4q-.15-.19-.37-.23l-2.82-.78Q15 4.09 14.65 4q-.33-.11-.65-.19v16.4L18.13 19q.22-.04.37-.21q.12-.17.12-.4Z"/>'
        },
        "microsoft-onedrive": {
            body: '<path fill="currentColor" d="M18.21 10.29q.79.05 1.49.39q.69.32 1.2.89q.51.55.81 1.26q.29.71.29 1.51q0 .84-.32 1.58q-.32.74-.88 1.29q-.55.55-1.3.87q-.72.33-1.56.33H7q-1.03 0-1.94-.41q-.91-.39-1.59-1.06q-.68-.68-1.07-1.59q-.4-.91-.4-1.94q0-.82.26-1.58q.24-.75.74-1.38q.44-.63 1.08-1.1q.64-.47 1.42-.72q.37-.13.71-.13q.35-.07.72-.09h.01q.43-.66 1.01-1.18q.55-.52 1.25-.89q.67-.34 1.42-.56q.75-.19 1.54-.19q1.06 0 2.04.35t1.8.97q.8.62 1.37 1.48q.58.87.84 1.9m-6.05-3.45q-1.11 0-2.1.46q-1 .45-1.7 1.3q.37.1.71.25q.33.15.66.35l3.98 2.38l2.29-.96q.21-.09.44-.17q.23-.07.48-.12q-.24-.78-.71-1.42q-.47-.64-1.1-1.1q-.61-.46-1.38-.71q-.73-.26-1.57-.26M4 15.66l8.27-3.48l-3.19-1.92q-.49-.29-1.02-.45q-.56-.15-1.11-.15q-.76 0-1.45.3q-.66.3-1.16.81q-.5.52-.8 1.2q-.29.68-.29 1.44q0 .59.2 1.18q.19.6.55 1.07m13.94 1.5q.47 0 .9-.16q.43-.14.8-.42L13.61 13l-8.58 3.59q.44.27.94.41q.5.16 1.03.16m13.45-1.55q.3-.61.3-1.27q0-.64-.25-1.17q-.24-.52-.65-.89q-.42-.37-.97-.57q-.56-.21-1.18-.21q-.35 0-.7.1q-.34.08-.67.21q-.33.12-.66.27q-.32.15-.63.29Z"/>'
        },
        "microsoft-onenote": {
            body: '<path fill="currentColor" d="M21.17 3.25q.33 0 .59.25q.24.24.24.58v15.84q0 .34-.24.58q-.26.25-.59.25H7.83q-.33 0-.59-.25q-.24-.24-.24-.58V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.08q0-.34.24-.58q.26-.25.59-.25M5.8 11.17l2.36 4.1h1.49V8.73H8.2v4.19L5.93 8.73H4.35v6.54H5.8m14.95 4.23V17h-2.5v2.5m2.5-3.75v-2.5h-2.5v2.5m2.5-3.75V9.5h-2.5V12m2.5-3.75V4.5H8.25V7h2.92q.33 0 .59.24q.24.26.24.59v8.34q0 .33-.24.59q-.26.24-.59.24H8.25v2.5H17V8.25Z"/>'
        },
        "microsoft-outlook": {
            body: '<path fill="currentColor" d="M8.56 12.03q0 .38-.06.73q-.11.34-.3.62q-.2.27-.49.43q-.3.16-.71.16q-.42 0-.71-.17t-.48-.45q-.19-.28-.27-.63q-.09-.35-.09-.72q0-.36.09-.72q.08-.35.27-.63t.5-.45q.3-.17.72-.17q.43 0 .72.17q.3.18.48.46q.18.29.27.64q.06.36.06.73M22 12v7.81q0 .39-.27.69q-.28.25-.67.25H7.94q-.39 0-.67-.25q-.27-.3-.27-.69V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7h5.42V4.13q0-.37.25-.63q.26-.25.63-.25h10.74q.37 0 .63.25q.25.26.25.63v6.91l1.04.6h.01q.08.06.14.16q.06.09.06.2m-5-6.87v2.5h2.5v-2.5M17 8.88v2.5h2.5v-2.5M17 12.63v1.52l2.54-1.52m-6.91-7.5v2.5h3.12v-2.5m-3.12 3.75v2.5h3.12v-2.5m-3.12 3.75v1.69l2.01 1.24l1.11-.66v-2.27M9.5 5.13V7h1.77q.06 0 .11.04V5.12M7 15.32q.73 0 1.32-.26q.58-.26.99-.71q.4-.45.6-1.07q.21-.62.22-1.34q0-.69-.21-1.29q-.2-.59-.6-1.03q-.39-.44-.95-.69q-.57-.25-1.29-.25q-.77 0-1.37.25q-.59.25-1 .7q-.41.46-.62 1.08q-.21.63-.21 1.37q0 .7.21 1.3q.22.59.62 1.02q.4.43.97.68q.58.24 1.32.24m1.25 4.18h10.32L12 15.4v.77q0 .33-.24.59q-.26.24-.59.24H8.25m12.5 2.39v-6.03l-4.92 2.95Z"/>'
        },
        "microsoft-powerpoint": {
            body: '<path fill="currentColor" d="M13.25 3.25q1.21 0 2.33.31q1.12.32 2.09.89q.97.55 1.77 1.36q.79.8 1.36 1.77q.58.97.89 2.09Q22 10.79 22 12t-.31 2.33q-.31 1.12-.89 2.09q-.57.97-1.36 1.77q-.8.81-1.77 1.36q-.97.58-2.09.89q-1.12.31-2.33.31q-1.07 0-2.1-.25q-1.03-.26-1.95-.74q-.92-.49-1.7-1.18q-.81-.7-1.43-1.58H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.58Q2.5 7 2.83 7h3.24q.62-.88 1.43-1.58q.78-.7 1.7-1.18q.93-.48 1.95-.74q1.03-.25 2.1-.25m.63 1.28v6.84h6.84q-.12-1.37-.69-2.56T18.55 6.7q-.91-.91-2.12-1.48q-1.2-.57-2.55-.69M9.5 10.84q0-.57-.2-.97q-.19-.41-.52-.66q-.33-.26-.78-.37q-.45-.12-1-.12H4.37v6.55h1.54V13h1.03q.48 0 .93-.16q.46-.14.82-.41q.36-.26.58-.67q.23-.4.23-.92m3.75 8.66q.98 0 1.89-.24q.9-.26 1.71-.68q.81-.45 1.48-1.08q.67-.61 1.17-1.37q.5-.77.83-1.66q.31-.89.39-1.85h-8.08V4.53q-1.45.12-2.73.76T7.67 7h3.5q.33 0 .59.25q.24.25.24.58v8.34q0 .33-.24.59q-.26.24-.59.24h-3.5q.53.6 1.17 1.06q.66.44 1.35.78q.72.33 1.49.49q.77.17 1.57.17M6.85 10q.47 0 .76.19q.28.19.28.7q0 .22-.1.36q-.1.14-.26.25q-.16.07-.35.1q-.18.04-.38.04h-.89V10h.94Z"/>'
        },
        "microsoft-sharepoint": {
            body: '<path fill="currentColor" d="M22 13.25q0 1.04-.4 1.95q-.39.9-1.07 1.58t-1.59 1.08q-.91.39-1.94.39q-.64 0-1.27-.16q-.09.83-.46 1.54q-.38.72-.97 1.25q-.58.53-1.33.82q-.76.3-1.59.3q-.91 0-1.71-.35q-.79-.34-1.39-.93q-.59-.59-.93-1.39q-.35-.8-.35-1.7v-.32q.03-.15.05-.31H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7h2.95q.12-1.06.61-2q.48-.89 1.24-1.56q.75-.68 1.71-1.06T11.38 2q1.16 0 2.18.44q1.03.45 1.79 1.21t1.21 1.79Q17 6.46 17 7.63v.31q0 .15-.04.31q1.04 0 1.95.39q.92.39 1.59 1.07q.71.67 1.1 1.58q.4.92.4 1.96m-10.63-10q-.81 0-1.54.29q-.74.28-1.33.78q-.56.5-.95 1.18q-.38.7-.5 1.5h4.12q.33 0 .59.25q.24.25.24.58v4.12l.18-.03q.17-.62.5-1.18q.32-.57.79-1.02q.45-.45 1.03-.79q.54-.33 1.17-.5q.08-.43.08-.8q0-.91-.35-1.71q-.34-.79-.94-1.38q-.59-.59-1.38-.94q-.8-.35-1.71-.35m-4.27 12q.45 0 .9-.09q.42-.09.76-.31q.34-.21.55-.56q.19-.36.19-.88q0-.53-.2-.88q-.22-.35-.55-.59q-.33-.23-.71-.38l-.72-.29Q7 11.14 6.77 11q-.22-.15-.22-.38q0-.16.12-.27q.12-.1.28-.15q.16-.07.33-.09q.18-.01.3-.01q.49 0 .88.12q.38.13.79.38V9.12Q9 9.05 8.81 9q-.2-.05-.39-.08q-.2-.03-.42-.05q-.2-.01-.45-.01q-.43 0-.88.09q-.45.1-.82.32q-.35.23-.59.56q-.23.35-.23.86q0 .5.22.81q.22.35.55.59q.33.23.7.41l.72.29q.34.14.56.29q.22.16.22.38q0 .19-.11.3q-.1.11-.26.16q-.13.08-.32.08H7q-.59 0-1.04-.18q-.46-.2-.92-.52v1.56q.99.39 2.06.39m4.27 5.5q.63 0 1.21-.25q.57-.24 1-.66q.42-.43.67-1q.25-.57.25-1.21q0-.56-.19-1.07q-.18-.51-.51-.91q-.34-.41-.8-.69q-.45-.28-1-.4v1.61q0 .33-.24.59q-.26.24-.59.24H8.31q-.06.31-.06.63q0 .64.25 1.21q.24.57.66 1q.43.42 1 .66q.57.25 1.21.25M17 17q.77 0 1.45-.29q.69-.29 1.2-.81q.51-.51.81-1.19q.29-.68.29-1.46q0-.75-.29-1.45q-.3-.69-.81-1.2t-1.2-.81Q17.77 9.5 17 9.5q-.77 0-1.45.3q-.68.3-1.19.81q-.51.51-.81 1.19q-.3.7-.3 1.45v.21l.02.22q.46.22.85.54q.38.32.7.71q.3.4.52.86q.21.46.32.95q.66.26 1.34.26Z"/>'
        },
        "microsoft-teams": {
            body: '<path fill="currentColor" d="M19.19 8.77q-.46 0-.86-.17q-.39-.17-.69-.47q-.3-.3-.47-.69q-.17-.4-.17-.86q0-.45.17-.85q.17-.4.47-.69q.3-.3.69-.47q.4-.18.86-.17q.45-.01.85.17q.4.17.7.47q.29.29.47.69q.17.4.17.85q0 .46-.17.86q-.17.39-.47.69q-.3.3-.7.47q-.4.17-.85.17m0-3.12q-.39 0-.69.27q-.25.27-.25.66t.25.67q.3.25.69.25q.39 0 .66-.25q.28-.25.28-.67q0-.39-.28-.66q-.27-.27-.66-.27M22 10.33V15q0 .63-.24 1.2q-.26.57-.67.99q-.43.43-1 .67q-.59.25-1.21.25q-.38 0-.76-.11q-.39-.07-.71-.25q-.24.79-.71 1.44q-.47.65-1.1 1.11q-.63.46-1.39.7q-.76.27-1.58.27q-.96 0-1.81-.33q-.82-.33-1.5-.94q-.66-.57-1.09-1.36q-.44-.8-.57-1.74H2.83q-.33 0-.59-.25q-.24-.24-.24-.58V7.73q0-.34.24-.59q.26-.24.59-.24H10q-.29-.6-.29-1.25q0-.61.23-1.15q.22-.5.62-.92q.4-.39.94-.62q.5-.23 1.12-.23q.61 0 1.14.23q.53.23.93.62q.4.42.62.92q.23.54.23 1.15q0 .6-.23 1.14q-.22.53-.62.92q-.4.4-.93.63q-.53.23-1.14.23q-.15 0-.31-.02q-.15-.02-.31-.05v.9h9.06q.39 0 .67.27q.27.27.27.66M12.63 4q-.35 0-.63.11q-.33.13-.56.36q-.22.23-.35.53q-.13.31-.13.65q0 .35.13.65q.13.3.35.53q.23.22.56.36q.28.13.63.13q.34 0 .64-.13q.3-.14.53-.36q.23-.23.36-.53q.14-.3.14-.65q0-.34-.14-.65q-.13-.3-.36-.53q-.23-.23-.53-.36q-.3-.11-.64-.11m-4.85 6.18h1.88V8.62H4.34v1.56h1.88v5h1.56m8.6 1.09v-5.62H12v5.42q0 .34-.24.58q-.26.25-.59.25H8.92q.13.67.47 1.25q.34.57.82.99q.48.41 1.1.65q.61.21 1.32.21q.77 0 1.45-.27q.68-.3 1.2-.81q.51-.51.8-1.19q.3-.68.3-1.46M20.75 15v-4.35h-3.12v5.71q.25.25.57.38q.3.12.68.12q.39 0 .73-.15q.34-.15.59-.4q.26-.25.4-.6q.15-.34.15-.71Z"/>'
        },
        "microsoft-visual-studio": {
            body: '<path fill="currentColor" d="m17 8.5l-4.75 3.82L17 16V8.5M4.7 18.4L2 16.7v-9l3-1l4.3 3.33L18 2l4 2.5V20l-5 2l-7.66-7.34L4.7 18.4M5 14l1.86-1.72L5 10.5V14Z"/>'
        },
        "microsoft-visual-studio-code": {
            body: '<path fill="currentColor" d="M17 16.47V7.39l-6 4.54M2.22 9.19a.858.858 0 0 1-.02-1.15l1.2-1.11c.2-.18.69-.26 1.05 0l3.42 2.61l7.93-7.25c.32-.32.87-.45 1.5-.12l4 1.91c.36.21.7.54.7 1.15v13.5c0 .4-.29.83-.6 1l-4.4 2.1c-.32.13-.92.01-1.13-.2l-8.02-7.3l-3.4 2.6c-.38.26-.85.19-1.05 0l-1.2-1.1c-.32-.33-.28-.87.05-1.2l3-2.7"/>'
        },
        "microsoft-windows": {
            body: '<path fill="currentColor" d="M3 12V6.75l6-1.32v6.48L3 12m17-9v8.75l-10 .15V5.21L20 3M3 13l6 .09v6.81l-6-1.15V13m17 .25V22l-10-1.91V13.1l10 .15Z"/>'
        },
        "microsoft-windows-classic": {
            body: '<path fill="currentColor" d="M2.67 5.3v.61l-.71.3V5.6l.71-.3m0 5.94v.62l-.71.29v-.59l.71-.32m0 6.03v.62l-.71.29v-.59l.71-.32M2.6 7.29v.55l-.57.26v-.54l.57-.27m0 1.99v.54l-.57.26v-.54l.57-.26m0 4.03v.53l-.57.26v-.54l.57-.25m0 2.02v.54l-.57.26v-.53l.57-.27m1.9-9.69v.72l-1 .37V6l1-.36m0 6.02v.71l-1 .37v-.71l1-.37m0 6.04v.71l-1 .4v-.71l1-.4m-.07-9.98v.66l-.79.3V8l.79-.28m0 2.01v.64l-.78.3V10l.78-.27m0 4.01v.64l-.78.31v-.66l.78-.29m0 2.02v.65l-.78.31v-.66l.78-.3m1.88-9.67v.85l-1.26.49v-.84l1.26-.5m0 6.02v.85l-1.26.49v-.84l1.26-.5m0 5.97v.85l-1.26.5v-.85l1.26-.5m-.06-9.9v.76l-1.06.4v-.73l1.06-.43m0 2v.75l-1.06.42v-.75l1.06-.42m0 4.01v.75l-1.06.43v-.75l1.06-.43m0 1.95v.76l-1.06.42v-.75l1.06-.43m2.04-10.1v1.12l-1.57.62V6.67l1.57-.63m0 6.02v1.13l-1.57.61v-1.12l1.57-.62m0 5.97v1.12l-1.57.62v-1.11l1.57-.63m-.09-9.9v1.03l-1.31.53V8.66l1.31-.53m0 2v1.02l-1.31.53v-1.03l1.31-.52m0 4.02v1.03l-1.31.52v-1.03l1.31-.52m0 1.95v1.02l-1.31.52v-1.01l1.31-.53m2.14-10.25v1.47L8.61 8V6.56l1.73-.71m0 6.02v1.46l-1.73.7v-1.47l1.73-.69m0 5.97v1.46l-1.73.7v-1.46l1.73-.7m-.08-9.79v1.23l-1.48.59V8.64l1.48-.59m0 1.92v1.23l-1.48.58v-1.22l1.48-.59m0 4.09v1.25l-1.48.57v-1.23l1.48-.59m0 1.94v1.25l-1.48.59V16.6l1.48-.6m2.19-10.88v2l-1.86.77V6c.64-.35 1.26-.65 1.86-.88m0 2.21v1.73l-1.86.78V8.1l1.86-.77m0 1.95v1.76l-1.86.78v-1.76l1.86-.78m0 1.97V13l-1.86.77V12l1.86-.75m0 1.96V15l-1.86.78V14l1.86-.79m0 2v1.75l-1.86.8V16l1.86-.79m0 1.96v1.87c-.73.28-1.35.55-1.86.8v-1.88l1.86-.79m9.59-11.99v14.05c-1.19-.79-2.67-1.18-4.45-1.18c-1.47 0-3.12.3-4.94.91v-1.9c.97-.37 2.03-.64 3.19-.8v-4.57c-.98.12-2.04.46-3.19 1.02V11.4c.99-.46 2.06-.77 3.19-.94V6c-1.02.18-2.08.53-3.19 1V5.03C14.27 4.34 15.86 4 17.41 4c1.68 0 3.22.39 4.63 1.18m-1.89 1.23c-.76-.41-1.65-.59-2.73-.59c-.13 0-.25.01-.37.02v4.54l.41-.01c.91 0 1.81.13 2.69.43V6.41m0 5.69c-.81-.36-1.72-.54-2.71-.54c-.13 0-.26.01-.39.02v4.58h.41c.99 0 1.89.12 2.69.37V12.1Z"/>'
        },
        "microsoft-word": {
            body: '<path fill="currentColor" d="M21.17 3.25q.33 0 .59.25q.24.24.24.58v15.84q0 .34-.24.58q-.26.25-.59.25H7.83q-.33 0-.59-.25q-.24-.24-.24-.58V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.08q0-.34.24-.58q.26-.25.59-.25m-.8 8.09l1.2 3.94H9.6l1.31-6.56H9.53l-.78 3.88l-1.11-3.75H6.5l-1.19 3.77l-.78-3.9H3.09l1.31 6.56h1.37m14.98 4.22V17H8.25v2.5m12.5-3.75v-3.12H12v3.12m8.75-4.37V8.25H12v3.13M20.75 7V4.5H8.25V7Z"/>'
        },
        "microsoft-xbox": {
            body: '<path fill="currentColor" d="M6.43 3.72c.07-.06.14-.12.19-.16C8.18 2.55 10 2 12 2c1.88 0 3.64.5 5.14 1.42c.11.08.4.27.56.46C16.25 2.28 12 5.7 12 5.7c-1.5-1.13-2.83-1.9-3.84-2.2c-.85-.21-1.43 0-1.7.2m12.88 1.51c-.05-.05-.1-.1-.14-.15c-.36-.4-.82-.5-1.2-.47c-.39.12-2.1.73-4.2 2.72c0 0 2.37 2.3 3.82 4.65c1.45 2.35 2.31 4.2 1.78 6.77C21 16.95 22 14.59 22 12c0-2.62-1-5-2.66-6.79m-3.61 7.75c-.65-.72-1.6-1.75-2.87-3.01c-.27-.27-.56-.55-.86-.85c0 0-.47.46-1.07 1.07c-.77.77-1.76 1.78-2.32 2.37c-.98 1.05-3.8 4.35-3.96 6.2c0 0-.65-1.46.75-4.85c.9-2.21 3.6-5.53 4.75-6.61c0 0-1.03-1.14-2.33-1.93l-.05-.03c-.63-.37-1.31-.66-1.97-.7c-.67.05-1.09.54-1.09.54A9.954 9.954 0 0 0 2 12a10 10 0 0 0 10 10c2.93 0 5.57-1.26 7.4-3.27c0 0-.21-1.33-1.56-3.23c-.31-.43-1.47-1.81-2.11-2.54Z"/>'
        },
        "microsoft-xbox-controller": {
            body: '<path fill="currentColor" d="M8.75 15.75C6.75 15.75 6 18 4 19c-2 0-3.5-3 .5-11.5h.25l.44-.83S8 5 9.33 6.23h5.34c1.33-1.23 4.14.44 4.14.44l.44.83h.25C23.5 16 22 19 20 19c-2-1-2.75-3.25-4.75-3.25h-6.5M12 7a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-alert": {
            body: '<path fill="currentColor" d="M21 19V7h-6v12h6m.67-14C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m6 1h2v5h-2V9m0 6h2v2h-2v-2Z"/>'
        },
        "microsoft-xbox-controller-battery-charging": {
            body: '<path fill="currentColor" d="M20 5h1.67C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2m1 2h-6v12h6V7m-5.5 7l3-6.5V12h2l-3 6.5V14h-2M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-empty": {
            body: '<path fill="currentColor" d="M21 19V7h-6v12h6m.67-14C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-full": {
            body: '<path fill="currentColor" d="M21.67 5C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-low": {
            body: '<path fill="currentColor" d="M21 16V7h-6v9h6m.67-11C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-medium": {
            body: '<path fill="currentColor" d="M21 12V7h-6v5h6m.67-7C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-battery-unknown": {
            body: '<path fill="currentColor" d="M21.67 5C22.4 5 23 5.6 23 6.33v13.34A1.33 1.33 0 0 1 21.67 21h-7.34c-.73 0-1.33-.6-1.33-1.33v-2.92H7.75C5.75 16.75 5 19 3 20c-2 0-3.5-3 .5-11.5h.25l.44-.83S7 6 8.33 7.23H13v-.9A1.33 1.33 0 0 1 14.33 5H16V3h4v2h1.67M11 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m7.19 0c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91c-.2.26-.31.68-.31 1.18h2c0-.31.04-.56.13-.74c.09-.18.26-.36.51-.52c.45-.24.82-.53 1.11-.93c.29-.4.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82c-.53-.45-1.26-.68-2.19-.68M17 15v2h2v-2h-2Z"/>'
        },
        "microsoft-xbox-controller-menu": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M6 7h12v2H6V7m0 4h12v2H6v-2m0 4h12v2H6v-2Z"/>'
        },
        "microsoft-xbox-controller-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-6.23-6.25H8.75C6.75 15.75 6 18 4 19c-2 0-3.5-2.96.42-11.31L2 5.27m7.33.96h5.34c1.33-1.23 4.14.44 4.14.44l.44.83h.25c3.5 7.5 2.78 10.7 1.19 11.37L7.62 5.8c.63-.07 1.25.01 1.71.43M12 7a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "microsoft-xbox-controller-view": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M6 7h9v2H8v5H6V7m3 3h9v7H9v-7m2 2v3h5v-3h-5Z"/>'
        },
        "microsoft-yammer": {
            body: '<path d="M22 12q0 .43-.03.94q-.02.51-.08 1.03q-.05.53-.13 1.03t-.2.89q-.06.18-.18.3q-.14.11-.34.11q-.09 0-.38-.07q-.29-.07-.63-.16l-.64-.19q-.3-.09-.43-.12q-.21.78-.55 1.62q-.33.83-.76 1.62q-.43.8-.95 1.5q-.52.75-1.09 1.32l-.18.13q-.1.05-.22.05q-.21 0-.37-.16l-4.74-4.73H2.85q-.35 0-.6-.25t-.25-.6V7.74q0-.35.25-.6t.6-.25h7.25l4.73-4.73Q15 2 15.21 2q.12 0 .21.05q.08.04.17.13q.26.26.49.53q.22.29.42.57q1.73 2.27 2.46 5q.18-.05.48-.14q.3-.09.62-.18q.31-.09.59-.16q.27-.06.39-.06q.2 0 .34.11q.12.12.18.3q.12.41.21.9q.08.5.14 1.01q.05.51.09 1.02V12M9.82 9.37q0-.31-.2-.52q-.22-.21-.52-.21q-.2 0-.38.1q-.17.11-.27.29l-1.3 2.44l-1.26-2.44q-.12-.23-.32-.31q-.2-.08-.44-.08q-.31 0-.52.21q-.21.21-.21.51q0 .21.1.37l1.75 3.14q.02.04.04.1q.01.06.01.11v1.55q0 .37.26.56q.25.17.59.17q.24 0 .39-.09q.14-.09.22-.24q.08-.15.11-.34q.03-.19.03-.41q0-.28-.02-.52q-.02-.26-.02-.48q0-.14.01-.25q.01-.1.06-.18l1.8-3.12q.1-.18.1-.36m5.34-5.74L11.8 7q.2.12.3.31q.12.19.12.43v2.33l5.5-1.46Q17.34 7.19 16.71 6q-.63-1.23-1.54-2.37m2.56 11.79l-5.51-1.47v2.31q0 .24-.12.43q-.1.19-.3.31l3.38 3.37q.89-1.08 1.54-2.33t1.01-2.61v-.01m2.74-.58q.13-.7.19-1.41q.06-.7.06-1.43q0-.71-.06-1.41t-.19-1.4q-2.07.55-4.12 1.1q-2.05.54-4.13 1.1q-.01.16-.01.31v.62l.01.31q2.08.56 4.13 1.1t4.12 1.11z" fill="currentColor"/>',
            hidden: true
        },
        microwave: {
            body: '<path fill="currentColor" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m0 2h12v10H4V7m15 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-6 2v6h2V9h-2m6 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "microwave-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.15 2.15C2.5 5.44 2 6.16 2 7v10a2 2 0 0 0 2 2h13.11l3.73 3.73l1.27-1.27M4 17V7h1.11l10 10H4M16 7v5.8l5.5 5.51c.31-.36.5-.81.5-1.31V7a2 2 0 0 0-2-2H8.2l2 2H16m3 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m0 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-6-1.2V9h2v2.8l-2-2Z"/>'
        },
        middleware: {
            body: '<path fill="currentColor" d="m23 12l-4-4v3h-4.18C14.4 9.84 13.3 9 12 9s-2.4.84-2.82 2H5L2 8v8l3-3h4.18c.42 1.16 1.52 2 2.82 2s2.4-.84 2.82-2H19v3l4-4Z"/>'
        },
        "middleware-outline": {
            body: '<path fill="currentColor" d="m23 12l-4-4v3h-3.14c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3H5L2 8v8l3-3h3.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H19v3l4-4m-11 2c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        midi: {
            body: '<path fill="currentColor" d="M20.15 8.26H22v7.48h-1.85M13 8.26h5.43c.57 0 .87.48.87 1.04v5.51c0 .69-.3.93-.92.93H13V11h1.87v2.91h2.63V9.95H13m-2.68-1.69h1.82v7.48h-1.82M2 8.26h6.55c.55 0 .86.48.86 1.04v6.44H7.59v-5.59H6.5v5.59H4.87v-5.59H3.83v5.59H2Z"/>'
        },
        "midi-input": {
            body: '<path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2zm8.182 10c0-3.82-2.635-7.039-6.182-7.934V6h-4V4.066C6.453 4.96 3.818 8.18 3.818 12c0 4.51 3.673 8.182 8.182 8.182c4.51 0 8.182-3.673 8.182-8.182zM7 10.636a1.364 1.364 0 1 1 0 2.728a1.364 1.364 0 0 1 0-2.728zm10 0a1.364 1.364 0 1 1 0 2.728a1.364 1.364 0 0 1 0-2.728zm-8.636 3.637a1.364 1.364 0 1 1 0 2.727a1.364 1.364 0 0 1 0-2.727zm7.272 0a1.364 1.364 0 1 1 0 2.727a1.364 1.364 0 0 1 0-2.727zM12 15.636a1.364 1.364 0 1 1 0 2.728a1.364 1.364 0 0 1 0-2.728z" fill="currentColor"/>',
            hidden: true
        },
        "midi-port": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m8.18 10c0-3.82-2.63-7.04-6.18-7.93V6h-4V4.07A8.185 8.185 0 0 0 3.82 12A8.18 8.18 0 0 0 12 20.18A8.18 8.18 0 0 0 20.18 12M7 10.64A1.36 1.36 0 0 1 8.36 12A1.36 1.36 0 0 1 7 13.36c-.75 0-1.36-.61-1.36-1.36c0-.75.61-1.36 1.36-1.36m10 0A1.36 1.36 0 0 1 18.36 12A1.36 1.36 0 0 1 17 13.36A1.36 1.36 0 0 1 15.64 12A1.36 1.36 0 0 1 17 10.64m-8.64 3.63a1.37 1.37 0 0 1 1.37 1.37c0 .75-.61 1.36-1.37 1.36A1.36 1.36 0 0 1 7 15.64c0-.76.61-1.37 1.36-1.37m7.28 0c.75 0 1.36.61 1.36 1.37A1.36 1.36 0 0 1 15.64 17c-.76 0-1.37-.61-1.37-1.36a1.37 1.37 0 0 1 1.37-1.37M12 15.64A1.36 1.36 0 0 1 13.36 17A1.36 1.36 0 0 1 12 18.36A1.36 1.36 0 0 1 10.64 17A1.36 1.36 0 0 1 12 15.64Z"/>'
        },
        mine: {
            body: '<path fill="currentColor" d="M23 13v-2h-3.07a7.988 7.988 0 0 0-1.62-3.9l2.19-2.17l-1.43-1.43l-2.17 2.19A7.988 7.988 0 0 0 13 4.07V1h-2v3.07c-1.42.18-2.77.74-3.9 1.62L4.93 3.5L3.5 4.93L5.69 7.1A7.988 7.988 0 0 0 4.07 11H1v2h3.07c.18 1.42.74 2.77 1.62 3.9L3.5 19.07l1.43 1.43l2.17-2.19c1.13.88 2.48 1.44 3.9 1.62V23h2v-3.07c1.42-.18 2.77-.74 3.9-1.62l2.17 2.19l1.43-1.43l-2.19-2.17a7.988 7.988 0 0 0 1.62-3.9H23M12 8a4 4 0 0 0-4 4H6a6 6 0 0 1 6-6v2Z"/>'
        },
        minecraft: {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m2 4v4h4v2H8v6h2v-2h4v2h2v-6h-2v-2h4V6h-4v4h-4V6H6Z"/>'
        },
        "mini-sd": {
            body: '<path fill="currentColor" d="M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6l-2-2V6a2 2 0 0 0-2-2H6m1 2h2v4H7V6m3 0h2v4h-2V6m3 0h2v4h-2V6Z"/>'
        },
        minidisc: {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m7 2a7 7 0 0 1 6.7 5H16a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2.71c-.89 2.97-3.62 5-6.71 5a7 7 0 0 1-7-7a7 7 0 0 1 7-7m0 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        minus: {
            body: '<path fill="currentColor" d="M19 13H5v-2h14v2Z"/>'
        },
        "minus-box": {
            body: '<path fill="currentColor" d="M17 13H7v-2h10m2-8H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "minus-box-multiple": {
            body: '<path fill="currentColor" d="M19 11H9V9h10m1-7H8c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6Z"/>'
        },
        "minus-box-multiple-outline": {
            body: '<path fill="currentColor" d="M18 11h-8V9h8m2-5v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6Z"/>'
        },
        "minus-box-outline": {
            body: '<path fill="currentColor" d="M19 19V5H5v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-2 8v2H7v-2h10Z"/>'
        },
        "minus-circle": {
            body: '<path fill="currentColor" d="M17 13H7v-2h10m-5-9A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "minus-circle-multiple": {
            body: '<path fill="currentColor" d="M2 12c0-2.79 1.64-5.2 4-6.32V3.5C2.5 4.76 0 8.09 0 12s2.5 7.24 6 8.5v-2.18C3.64 17.2 2 14.79 2 12m13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9s9-4.04 9-9s-4.04-9-9-9m5 10H10v-2h10v2Z"/>'
        },
        "minus-circle-multiple-outline": {
            body: '<path fill="currentColor" d="M11 11v2h8v-2h-8m-9 1c0-2.79 1.64-5.2 4-6.32V3.5C2.5 4.76 0 8.09 0 12s2.5 7.24 6 8.5v-2.18C3.64 17.2 2 14.79 2 12m13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9s9-4.04 9-9s-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7Z"/>'
        },
        "minus-circle-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 5.5 4.5 10 10 10c2.3 0 4.4-.8 6-2.1l2.8 2.8l1.3-1.2M7 13v-2h2.1l2 2H7m7.2-2L6.7 3.5C8.3 2.6 10.1 2 12 2c5.5 0 10 4.5 10 10c0 1.9-.6 3.7-1.5 5.3L16.2 13h.8v-2h-2.8Z"/>'
        },
        "minus-circle-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 5.5 4.5 10 10 10c2.3 0 4.4-.8 6-2.1l2.8 2.8l1.3-1.2M12 20c-4.4 0-8-3.6-8-8c0-1.7.6-3.3 1.5-4.6L9.1 11H7v2h4.1l5.5 5.5c-1.3.9-2.9 1.5-4.6 1.5M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2c5.5 0 10 4.5 10 10c0 1.9-.6 3.7-1.5 5.3L19 15.8c.6-1.1 1-2.4 1-3.8c0-4.4-3.6-8-8-8c-1.4 0-2.7.4-3.8 1m8 8l-2-2H17v2h-.8Z"/>'
        },
        "minus-circle-outline": {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 13h10v-2H7"/>'
        },
        "minus-network": {
            body: '<path fill="currentColor" d="M16 11V9H8v2h8m1-8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/>'
        },
        "minus-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m8-4V9H9v2h6"/>'
        },
        "minus-thick": {
            body: '<path fill="currentColor" d="M20 14H4v-4h16"/>'
        },
        mirror: {
            body: '<path fill="currentColor" d="M12 1c4.69 0 8.5 4.93 8.5 11c0 6.08-3.81 11-8.5 11c-4.69 0-8.5-4.92-8.5-11C3.5 5.93 7.31 1 12 1m0 2c-3.59 0-6.5 4.03-6.5 9s2.91 9 6.5 9s6.5-4.03 6.5-9s-2.91-9-6.5-9m-3.71 7.28l3.24-3.25l1.06 1.06l-3.24 3.25l-1.06-1.06m.41 4.33l5.66-5.66L15.42 10l-5.66 5.67l-1.06-1.06Z"/>'
        },
        "mirror-rectangle": {
            body: '<path fill="currentColor" d="m8.29 10.28l3.24-3.25l1.06 1.06l-3.24 3.25l-1.06-1.06m.41 4.33l5.66-5.66L15.42 10l-5.66 5.67l-1.06-1.06M18 3v18H6V3h12m2-2H4v22h16V1Z"/>'
        },
        "mirror-variant": {
            body: '<path fill="currentColor" d="m8.29 10.28l3.24-3.25l1.06 1.06l-3.24 3.25l-1.06-1.06m.41 4.33l5.66-5.66L15.42 10l-5.66 5.67l-1.06-1.06M14.17 3L18 6.83v10.34L14.17 21H9.83L6 17.17V6.83L9.83 3h4.34M15 1H9L4 6v12l5 5h6l5-5V6l-5-5Z"/>'
        },
        mixcloud: {
            body: '<path d="M21.11 18.5c-.14 0-.28-.06-.4-.14a.74.74 0 0 1-.21-1.02c.68-1 1.04-2.18 1.04-3.41c0-1.22-.36-2.4-1.04-3.43a.72.72 0 0 1 .21-1c.33-.22.79-.13 1.01.2A7.545 7.545 0 0 1 23 13.93c0 1.52-.44 2.98-1.28 4.23c-.14.21-.37.34-.61.34M19 17.29c-.12 0-.26-.04-.39-.12a.734.734 0 0 1-.19-1.02c.44-.65.68-1.42.68-2.22c0-.79-.24-1.56-.68-2.22a.736.736 0 0 1 .19-1.02c.34-.22.79-.14 1.02.2a5.44 5.44 0 0 1 0 6.08c-.13.21-.38.32-.63.32m-4.1-1.56a1.8 1.8 0 0 0 .65-3.48c-.05.3-.12.6-.21.89c-.11.3-.39.5-.7.5c-.07 0-.14-.02-.23-.04a.734.734 0 0 1-.46-.93c.14-.43.22-.89.22-1.35C14.17 8.93 12.22 7 9.82 7C8.1 7 6.56 8 5.87 9.5c.67.2 1.29.54 1.79 1.04c.29.29.29.75 0 1.04c-.28.28-.75.28-1.03 0c-.46-.46-1.07-.72-1.73-.72a2.45 2.45 0 0 0-2.44 2.44c0 1.34 1.1 2.43 2.44 2.43h10m.7-4.98c1.46.32 2.57 1.62 2.57 3.18c0 1.8-1.47 3.26-3.27 3.26h-10c-2.15 0-3.9-1.74-3.9-3.89c0-1.96 1.45-3.57 3.33-3.85c.79-2.33 3-3.95 5.49-3.95c3.01 0 5.49 2.32 5.78 5.25z" fill="currentColor"/>',
            hidden: true
        },
        "mixed-martial-arts": {
            body: '<path fill="currentColor" d="M15 10V7H7v3h8m3-3c.28 0 .5.09.7.29c.19.21.3.44.3.71v2.78c0 .19-.03.33-.06.42l-.8 3.99c-.14.53-.44.81-.94.81H6.8c-.53 0-.85-.28-.94-.81l-.8-3.99c-.03-.09-.06-.23-.06-.42V5c0-.5.21-1 .6-1.39C6 3.2 6.45 3 7 3h8c.53 0 1 .2 1.41.61c.4.39.59.89.59 1.39v3c0-.27.11-.5.3-.71c.2-.2.42-.29.7-.29M7 20v-3h10v3c0 .3-.09.53-.29.72c-.21.19-.44.28-.71.28H8c-.27 0-.5-.09-.71-.28c-.2-.19-.29-.42-.29-.72Z"/>'
        },
        "mixed-reality": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m3.25 12h1.5l1-3.43V15h1.5V9H10l-1 3.43L8 9H5.75v6h1.5v-3.43l1 3.43m5.25-6v6H15v-2h1.15l.85 2h1.5l-.9-2.1c.5-.25.9-.8.9-1.4v-1c0-.85-.65-1.5-1.5-1.5h-3.5m1.5 1.5h2v1h-2v-1Z"/>'
        },
        mixer: {
            body: '<path d="M5.68 3.96l5.73 7.69c.14.19.14.45 0 .64L5.65 20l-.15.18c-.74.82-2.03.89-2.86.13c-.79-.72-.85-1.94-.21-2.81l4.13-5.53l-4.1-5.5c-.63-.85-.58-2.08.21-2.8l.15-.13c.91-.67 2.18-.49 2.86.42m12.64 0c.68-.91 1.95-1.09 2.86-.42l.15.13c.79.72.84 1.94.21 2.8l-4.1 5.5l4.13 5.53c.64.86.58 2.09-.21 2.81c-.83.76-2.12.69-2.86-.13l-.15-.18l-5.76-7.71a.54.54 0 0 1 0-.64l5.73-7.69z" fill="currentColor"/>',
            hidden: true
        },
        molecule: {
            body: '<path fill="currentColor" d="M7.27 10L9 7h5.42l1.16-2l-.08-.5A1.5 1.5 0 0 1 17 3a1.5 1.5 0 0 1 1.5 1.5c0 .71-.5 1.31-1.17 1.46l-.96 1.67L17.73 10l.86-1.5l-.09-.5A1.5 1.5 0 0 1 20 6.5A1.5 1.5 0 0 1 21.5 8c0 .71-.5 1.3-1.15 1.46L18.89 12l1.73 3c.77.07 1.38.71 1.38 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5v-.26L17.73 14l-1.36 2.37l.96 1.67a1.5 1.5 0 0 1 1.17 1.46A1.5 1.5 0 0 1 17 21a1.5 1.5 0 0 1-1.5-1.5l.08-.5l-1.16-2h-3.84l-1.16 2l.08.5A1.5 1.5 0 0 1 8 21a1.5 1.5 0 0 1-1.5-1.5c0-.71.5-1.31 1.17-1.46l.96-1.67L4.38 9C3.61 8.93 3 8.29 3 7.5A1.5 1.5 0 0 1 4.5 6A1.5 1.5 0 0 1 6 7.5v.26L7.27 10m2.88-1l-1.73 3l1.73 3h4.7l1.73-3l-1.73-3h-4.7Z"/>'
        },
        "molecule-co": {
            body: '<path fill="currentColor" d="M8 7c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h3v-2H8V9h3V7H8m6 0c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9"/>'
        },
        "molecule-co2": {
            body: '<path fill="currentColor" d="M5 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3v-2H5V9h3V7H5m6 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9m5 1.5V12h3v1.5h-1.5A1.5 1.5 0 0 0 16 15v3h4.5v-1.5h-3V15H19a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5h-3Z"/>'
        },
        monitor: {
            body: '<path fill="currentColor" d="M21 16H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "monitor-account": {
            body: '<path fill="currentColor" d="M21 2c1.05 0 1.92.81 2 1.85V16c0 1.05-.82 1.92-1.85 2H14v2h2v2H8v-2h2v-2H3c-1.05 0-1.92-.82-2-1.85V4a2 2 0 0 1 1.85-2H21m0 2H3v12h18V4m-9 7c2.21 0 4 .9 4 2v1H8v-1c0-1.1 1.79-2 4-2m0-5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"/>'
        },
        "monitor-arrow-down": {
            body: '<path fill="currentColor" d="M21 16H3V4h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-5 8h-3V6h-2v4H8l4 4l4-4"/>'
        },
        "monitor-arrow-down-variant": {
            body: '<path fill="currentColor" d="m17 14l5-5l-1.4-1.4l-2.6 2.6V3h-2v7.2l-2.6-2.6L12 9l5 5m6 0v2c0 1.1-.9 2-2 2h-7v2h2v2H8v-2h2v-2H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h9v2H3v12h18v-2h2Z"/>'
        },
        "monitor-cellphone": {
            body: '<path fill="currentColor" d="M23 11h-5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m0 9h-5v-7h5v7M20 2H2C.89 2 0 2.89 0 4v12a2 2 0 0 0 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 0 0-2-2Z"/>'
        },
        "monitor-cellphone-star": {
            body: '<path fill="currentColor" d="M23 11h-5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m0 9h-5v-7h5v7M20 2H2C.89 2 0 2.89 0 4v12a2 2 0 0 0 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 0 0-2-2m-8.03 7L11 6l-.97 3H7l2.47 1.76l-.94 2.91l2.47-1.8l2.47 1.8l-.94-2.91L15 9h-3.03Z"/>'
        },
        "monitor-dashboard": {
            body: '<path fill="currentColor" d="M21 16V4H3v12h18m0-14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h18M5 6h9v5H5V6m10 0h4v2h-4V6m4 3v5h-4V9h4M5 12h4v2H5v-2m5 0h4v2h-4v-2Z"/>'
        },
        "monitor-edit": {
            body: '<path fill="currentColor" d="M21 2H3c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14H3V4h18v12m-5.16-7.8l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79M8 11.91l4.17-4.19l2.07 2.08l-4.16 4.2H8v-2.09Z"/>'
        },
        "monitor-eye": {
            body: '<path fill="currentColor" d="M3 4v12h18V4H3m0-2h18a2 2 0 0 1 2 2v12c0 .53-.21 1.04-.59 1.41c-.37.38-.88.59-1.41.59h-7v2h2v2H8v-2h2v-2H3c-.53 0-1.04-.21-1.41-.59C1.21 17.04 1 16.53 1 16V4c0-1.11.89-2 2-2m7.84 6.93c.31-.3.73-.48 1.16-.48c.43.01.85.18 1.16.49c.3.3.48.72.48 1.15c0 .44-.18.85-.48 1.16c-.31.31-.73.48-1.16.48c-.43 0-.85-.18-1.16-.48c-.3-.31-.48-.72-.48-1.16c0-.43.18-.85.48-1.16M10.07 12a2.679 2.679 0 0 0 3.86 0c.51-.5.8-1.19.8-1.91s-.29-1.42-.8-1.93s-1.21-.8-1.93-.8s-1.42.29-1.93.8s-.8 1.21-.8 1.93s.29 1.41.8 1.91M6 10.09A6.45 6.45 0 0 1 12 6c2.73 0 5.06 1.7 6 4.09a6.421 6.421 0 0 1-6 4.09c-2.73 0-5.06-1.68-6-4.09Z"/>'
        },
        "monitor-lock": {
            body: '<path fill="currentColor" d="M20.5 13a2.5 2.5 0 0 1 2.5 2.5v.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1v-.5a2.5 2.5 0 0 1 2.5-2.5m0 1a1.5 1.5 0 0 0-1.5 1.5v.5h3v-.5a1.5 1.5 0 0 0-1.5-1.5M20 4H2v12h13v2h-2v2h2v2H7v-2h2v-2H2a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h18a2 2 0 0 1 2 2v7.53c-.59-.34-1.27-.53-2-.53V4Z"/>'
        },
        "monitor-multiple": {
            body: '<path fill="currentColor" d="M22 17V7H6v10h16m0-12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6v2h2v2h-8v-2h2v-2H6c-1.11 0-2-.89-2-2V7a2 2 0 0 1 2-2h16M2 3v12H0V3a2 2 0 0 1 2-2h18v2H2Z"/>'
        },
        "monitor-off": {
            body: '<path fill="currentColor" d="M14 18v2h2v2H8v-2h2v-2H3a2 2 0 0 1-2-2V4L0 3l1.41-1.42l20.75 20.76l-1.41 1.41L15 18h-1M3 16h10L3 6v10M21 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-.34l-2-2H21V4H6.66l-2-2H21Z"/>'
        },
        "monitor-screenshot": {
            body: '<path fill="currentColor" d="M9 6H5v4h2V8h2m10 2h-2v2h-2v2h4m2 2H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"/>'
        },
        "monitor-share": {
            body: '<path fill="currentColor" d="M23 4v12c0 1.11-.89 2-2 2h-6v-2h6V4H3v12h6v2H3a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h18a2 2 0 0 1 2 2m-10 9h3l-4-4l-4 4h3v7H8v2h8v-2h-3v-7Z"/>'
        },
        "monitor-shimmer": {
            body: '<path fill="currentColor" d="M21 16H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-6 3.5l-.62 1.37L13 7.5l1.38.63L15 9.5l.63-1.37L17 7.5l-1.37-.63L15 5.5m-4.5 2L9.41 9.91L7 11l2.41 1.09l1.09 2.41l1.1-2.41L14 11l-2.4-1.09l-1.1-2.41"/>'
        },
        "monitor-small": {
            body: '<path fill="currentColor" d="M19 2H5c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2H8v2h8v-2h-2v-2h5c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14H5V4h14v12Z"/>'
        },
        "monitor-speaker": {
            body: '<path fill="currentColor" d="M3 2c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h4v-6H3V4h18v3h2V4c0-1.1-.9-2-2-2H3m18 7h-5c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2m-2.5 1.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S17 12.8 17 12s.7-1.5 1.5-1.5m0 10c-1.7 0-3-1.3-3-3c0-1.6 1.3-3 2.9-3h.1c1.7 0 3 1.3 3 3s-1.3 3-3 3m0-4.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5Z"/>'
        },
        "monitor-speaker-off": {
            body: '<path fill="currentColor" d="M2.4 1.7L1.1 3l.1.1c-.1.3-.2.6-.2.9v12c0 1.1.9 2 2 2h7v2H8v2h4v-6H3V4.9l11 11V20c0 1.1.9 2 2 2h4.1l.7.7s1.2-1 1.4-1.2L2.4 1.7m16.1 18.8c-1.7 0-3-1.3-3-3v-.1l3.1 3.1h-.1M23 4v3h-2V4H7.2l-2-2H21c1.1 0 2 .9 2 2m-2 5h-5c-1 0-1.9.8-2 1.8l3.8 3.8c.2-.1.4-.1.7-.1h.1c1.7 0 3 1.3 3 3c0 .2 0 .5-.1.7l1.6 1.6V11c-.1-1.1-1-2-2.1-2m-2.5 4.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"/>'
        },
        "monitor-star": {
            body: '<path fill="currentColor" d="M21 16V4H3v12h18m0-14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7v2h2v2H8v-2h2v-2H3a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h18m-8.03 7H16l-2.47 1.76l.94 2.91l-2.47-1.8l-2.47 1.8l.94-2.91L8 9h3.03L12 6l.97 3Z"/>'
        },
        "moon-first-quarter": {
            body: '<path fill="currentColor" d="M12 2v20a10 10 0 0 0 0-20Z"/>'
        },
        "moon-full": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 1 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "moon-last-quarter": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 0 0 20Z"/>'
        },
        "moon-new": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 1 1 8-8a8 8 0 0 1-8 8m0-18a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"/>'
        },
        "moon-waning-crescent": {
            body: '<path fill="currentColor" d="M2 12a10 10 0 0 0 13 9.54a10 10 0 0 1 0-19.08A10 10 0 0 0 2 12Z"/>'
        },
        "moon-waning-gibbous": {
            body: '<path fill="currentColor" d="M18 12c0-4.5-1.92-8.74-6-10a10 10 0 0 0 0 20c4.08-1.26 6-5.5 6-10Z"/>'
        },
        "moon-waxing-crescent": {
            body: '<path fill="currentColor" d="M12 2a9.91 9.91 0 0 0-3 .46a10 10 0 0 1 0 19.08A10 10 0 1 0 12 2Z"/>'
        },
        "moon-waxing-gibbous": {
            body: '<path fill="currentColor" d="M6 12c0-4.5 1.93-8.74 6-10a10 10 0 0 1 0 20c-4.07-1.26-6-5.5-6-10Z"/>'
        },
        moped: {
            body: '<path fill="currentColor" d="M19 15c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m-9-7H5v2h5V6m7-1h-3v2h3v2.65L13.5 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.5l4.5-5.65V7a2 2 0 0 0-2-2M7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1Z"/>'
        },
        "moped-electric": {
            body: '<path fill="currentColor" d="M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.5 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.5L19 8.35V5M7 15c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1M5 4h5v2H5V4m14 7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M7 20h4v-2l6 3h-4v2l-6-3Z"/>'
        },
        "moped-electric-outline": {
            body: '<path fill="currentColor" d="M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.5 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.5L19 8.35V5M4 12v-1c0-1.1.9-2 2-2h2v3H4m3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1M5 4h5v2H5V4m14 7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M7 20h4v-2l6 3h-4v2l-6-3Z"/>'
        },
        "moped-outline": {
            body: '<path fill="currentColor" d="M19 7a2 2 0 0 0-2-2h-3v2h3v2.65L13.5 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.5l4.5-5.65V7M7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1m1-3H4v-1c0-1.1.9-2 2-2h2v3m11-1c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m-9-9H5V6h5v2Z"/>'
        },
        more: {
            body: '<path fill="currentColor" d="M19 13.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-5 0a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-5 0A1.5 1.5 0 0 1 7.5 12A1.5 1.5 0 0 1 9 10.5a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 9 13.5M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.96.89 1.65.89H22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "mortar-pestle": {
            body: '<path fill="currentColor" d="m21 7l-2 6l2 6v2H3v-2l2-6l-2-6V5h12.7l1.5-4l2.3.8L18.3 5H21v2Z"/>'
        },
        "mortar-pestle-plus": {
            body: '<path fill="currentColor" d="M16 14h-3v3h-2v-3H8v-2h3V9h2v3h3m5-7h-2.65l1.15-3.15L17.15 1l-1.46 4H3v2l2 6l-2 6v2h18v-2l-2-6l2-6V5Z"/>'
        },
        mosque: {
            body: '<path fill="currentColor" d="M7 8h10c.3 0 .6.1.8.1c.1-.3.2-.7.2-1c0-1.3-.6-2.5-1.7-3.2L12 1L7.7 3.8c-1 .8-1.7 2-1.7 3.3c0 .4.1.7.2 1c.2 0 .5-.1.8-.1m17-1c0-1.1-2-3-2-3s-2 1.9-2 3c0 .7.4 1.4 1 1.7V13h-2v-2c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2H3V8.7c.6-.3 1-1 1-1.7c0-1.1-2-3-2-3S0 5.9 0 7c0 .7.4 1.4 1 1.7V21h9v-4c0-1.1.9-2 2-2s2 .9 2 2v4h9V8.7c.6-.3 1-1 1-1.7Z"/>'
        },
        "mosque-outline": {
            body: '<path fill="currentColor" d="M24 7c0-1.1-2-3-2-3s-2 1.9-2 3c0 .7.4 1.4 1 1.7V13h-2v-2c0-.9-.7-1.7-1.5-1.9c.3-.6.5-1.2.5-2c0-1.3-.6-2.5-1.7-3.2L12 1L7.7 3.8c-1 .8-1.7 2-1.7 3.3c0 .7.2 1.4.6 2c-.9.2-1.6 1-1.6 1.9v2H3V8.7c.6-.3 1-1 1-1.7c0-1.1-2-3-2-3S0 5.9 0 7c0 .7.4 1.4 1 1.7V21h10v-4c0-.5.4-1 1-1s1 .5 1 1v4h10V8.7c.6-.3 1-1 1-1.7M8.9 5.5L12 3.4l3.1 2.1c.6.4.9.9.9 1.6c0 1-.9 1.9-1.9 1.9H9.9C8.9 9 8 8.1 8 7.1c0-.7.3-1.2.9-1.6M21 19h-6v-2c0-1.6-1.4-3-3-3s-3 1.4-3 3v2H3v-4h4v-4h10v4h4v4Z"/>'
        },
        "mother-heart": {
            body: '<path fill="currentColor" d="M12 2c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m8 16l-2-5.44c-.35-.99-.66-1.85-2-2.56c-1.37-.7-2.37-1-4-1c-1.61 0-2.61.3-4 1c-1.32.71-1.63 1.57-2 2.56L4 18c-.23 1.13 2.38 2.44 4.13 3.19c1.21.53 2.51.81 3.87.81c1.38 0 2.67-.28 3.89-.81c1.75-.75 4.36-2.06 4.11-3.19m-4.58-.5L12 21l-3.42-3.5c-.36-.38-.58-.89-.58-1.45c0-1.13.9-2.05 2-2.05c.55 0 1.06.23 1.42.61l.58.59l.58-.6c.36-.37.87-.6 1.42-.6c1.11 0 2 .92 2 2.05c0 .56-.22 1.08-.58 1.45Z"/>'
        },
        "mother-nurse": {
            body: '<path fill="currentColor" d="M12 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m8 16l-2-5.44c-.35-.99-.66-1.85-2-2.56c-1.38-.7-2.38-1-4-1c-1.63 0-2.62.3-4 1c-1.34.71-1.65 1.57-2 2.56L4 18c-.32 1.35 2.36 2.44 4.11 3.19V19c0-.95.86-1.62 2.58-2.03c.16-.04.31-.06.43-.08c-.54-.82-.76-1.55-.78-1.61l1.77-.6c.01.02.52 1.59 1.73 2.38c.21.07.42.15.62.24c.77.34 1.23.78 1.38 1.31c-1.34.53-2.62.8-3.84.8l-1-.1v2.63l1 .06c1.37 0 2.67-.28 3.89-.81c1.75-.75 4.36-2.06 4.11-3.19m-4.5-1a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        motion: {
            body: '<path fill="currentColor" d="M7 13H3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M6 8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1m16 4c0 2.76-2.24 5-5 5H4c-.55 0-1-.45-1-1s.45-1 1-1h9c-.42-.58-.75-1.26-.9-2H10c-.55 0-1-.45-1-1s.45-1 1-1h2.1c.15-.74.48-1.42.9-2H8c-.55 0-1-.45-1-1s.45-1 1-1h9c2.76 0 5 2.24 5 5Z"/>'
        },
        "motion-outline": {
            body: '<path fill="currentColor" d="M7 13H3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M6 8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1m16 4c0 2.76-2.24 5-5 5H4c-.55 0-1-.45-1-1s.45-1 1-1h9c-.42-.58-.75-1.26-.9-2H10c-.55 0-1-.45-1-1s.45-1 1-1h2.1c.15-.74.48-1.42.9-2H8c-.55 0-1-.45-1-1s.45-1 1-1h9c2.76 0 5 2.24 5 5m-2 0c0-1.65-1.35-3-3-3s-3 1.35-3 3s1.35 3 3 3s3-1.35 3-3Z"/>'
        },
        "motion-pause": {
            body: '<path fill="currentColor" d="M22 12c0-5.54-4.46-10-10-10c-1.17 0-2.3.19-3.38.56l.7 1.94c.85-.34 1.74-.53 2.68-.53c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03c-4.41 0-8.03-3.62-8.03-8.03c0-.94.19-1.88.53-2.72l-1.94-.66C2.19 9.7 2 10.83 2 12c0 5.54 4.46 10 10 10s10-4.46 10-10M5.47 3.97c.85 0 1.53.71 1.53 1.5C7 6.32 6.32 7 5.47 7c-.79 0-1.5-.68-1.5-1.53c0-.79.71-1.5 1.5-1.5M18 12c0-3.33-2.67-6-6-6s-6 2.67-6 6s2.67 6 6 6s6-2.67 6-6m-7-3v6H9V9m6 0v6h-2V9"/>'
        },
        "motion-pause-outline": {
            body: '<path fill="currentColor" d="M22 12c0-5.54-4.46-10-10-10c-1.17 0-2.3.19-3.38.56l.7 1.94c.85-.34 1.74-.53 2.68-.53c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03c-4.41 0-8.03-3.62-8.03-8.03c0-.94.19-1.88.53-2.72l-1.94-.66C2.19 9.7 2 10.83 2 12c0 5.54 4.46 10 10 10s10-4.46 10-10M5.47 7c-.79 0-1.5-.68-1.5-1.53c0-.79.71-1.5 1.5-1.5c.85 0 1.53.71 1.53 1.5C7 6.32 6.32 7 5.47 7M9 9h2v6H9m4-6h2v6h-2"/>'
        },
        "motion-play": {
            body: '<path fill="currentColor" d="M22 12c0-5.54-4.46-10-10-10c-1.17 0-2.3.19-3.38.56l.7 1.94c.85-.34 1.74-.53 2.68-.53c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03c-4.41 0-8.03-3.62-8.03-8.03c0-.94.19-1.88.53-2.72l-1.94-.66C2.19 9.7 2 10.83 2 12c0 5.54 4.46 10 10 10s10-4.46 10-10M5.47 3.97c.85 0 1.53.71 1.53 1.5C7 6.32 6.32 7 5.47 7c-.79 0-1.5-.68-1.5-1.53c0-.79.71-1.5 1.5-1.5M18 12c0-3.33-2.67-6-6-6s-6 2.67-6 6s2.67 6 6 6s6-2.67 6-6m-3 0l-5 3V9"/>'
        },
        "motion-play-outline": {
            body: '<path fill="currentColor" d="m10 16.5l6-4.5l-6-4.5M22 12c0-5.54-4.46-10-10-10c-1.17 0-2.3.19-3.38.56l.7 1.94c.85-.34 1.74-.53 2.68-.53c4.41 0 8.03 3.62 8.03 8.03c0 4.41-3.62 8.03-8.03 8.03c-4.41 0-8.03-3.62-8.03-8.03c0-.94.19-1.88.53-2.72l-1.94-.66C2.19 9.7 2 10.83 2 12c0 5.54 4.46 10 10 10s10-4.46 10-10M5.47 3.97c.85 0 1.53.71 1.53 1.5C7 6.32 6.32 7 5.47 7c-.79 0-1.5-.68-1.5-1.53c0-.79.71-1.5 1.5-1.5Z"/>'
        },
        "motion-sensor": {
            body: '<path fill="currentColor" d="M10 .2C9 .2 8.2 1 8.2 2S9 3.8 10 3.8S11.8 3 11.8 2S11 .2 10 .2m5.67.8A7.33 7.33 0 0 0 23 8.33V7a6 6 0 0 1-6-6h-1.33m2.66 0c0 2.58 2.09 4.67 4.67 4.67V4.33c-1.84 0-3.33-1.49-3.33-3.33h-1.34M21 1a2 2 0 0 0 2 2V1h-2M7.92 4.03c-.17 0-.34.03-.5.08L2 5.8V11h1.8V7.33l2.11-.66L2 22h1.8l2.87-8.11L9 17v5h1.8v-6.41l-2.49-4.54l.73-2.87L10.12 10H15V8.2h-3.62l-2-3.33c-.3-.5-.84-.84-1.46-.84Z"/>'
        },
        "motion-sensor-off": {
            body: '<path fill="currentColor" d="M11.4 8.2H15V10h-1.8l-1.8-1.8M19.67 1h-1.34c0 2.58 2.09 4.67 4.67 4.67V4.33c-1.84 0-3.33-1.49-3.33-3.33M21 1a2 2 0 0 0 2 2V1h-2m-4 0h-1.33c0 4.05 3.28 7.33 7.33 7.33V7c-3.31 0-6-2.69-6-6m-7 2.8c1 0 1.8-.8 1.8-1.8S11 .2 10 .2S8.2 1 8.2 2S9 3.8 10 3.8M2.39 1.73L1.11 3l2.35 2.35L2 5.8V11h1.8V7.33l1.25-.39l.63.63L2 22h1.8l2.87-8.11L9 17v5h1.8v-6.41l-2.49-4.54l.19-.68l12.34 12.36l1.27-1.27L2.39 1.73m6.99 3.14c-.3-.5-.84-.84-1.46-.84c-.17 0-.34.03-.5.08l-.08.03l4.01 4.01l-1.97-3.28Z"/>'
        },
        motorbike: {
            body: '<path fill="currentColor" d="m17.42 10l-4.01-4H9v2h3.59l2 2H6.5C4 10 2 12 2 14.5S4 19 6.5 19c2.22 0 4.06-1.62 4.42-3.73L13.04 14c-.04.17-.04.33-.04.5c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m-8.66 5.26C8.5 16.27 7.58 17 6.47 17a2.5 2.5 0 0 1 0-5c1.12 0 2.03.74 2.37 1.75H6v1.5l2.84.01M17.47 17a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "motorbike-electric": {
            body: '<path fill="currentColor" d="m17.42 8l-4.01-4H9v2h3.59l2 2H6.5C4 8 2 10 2 12.5S4 17 6.5 17c2.22 0 4.06-1.62 4.42-3.73L13.04 12c-.04.17-.04.33-.04.5c0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5S20 8 17.5 8m-8.66 5.26C8.5 14.27 7.58 15 6.47 15a2.5 2.5 0 0 1 0-5c1.12 0 2.03.74 2.37 1.75H6v1.5l2.84.01M17.47 15a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M11 20H7l6 3v-2h4l-6-3v2Z"/>'
        },
        "motorbike-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l7 7H6.5C4 10 2 12 2 14.5S4 19 6.5 19c2.2 0 4.1-1.6 4.4-3.7l1.5-.9l.6.6c.2 2.1 1.9 3.8 4 4l3.8 3.8l1.3-1.3M8.8 15.3c-.3 1-1.3 1.7-2.4 1.7C5.1 17 4 15.9 4 14.5S5.1 12 6.5 12c1.1 0 2 .7 2.4 1.8H6v1.5h2.8M11.2 8l-2-2h4.2l4 4h.1c2.5 0 4.5 2 4.5 4.5c0 1.2-.5 2.3-1.2 3.1l-1.4-1.4c.4-.4.6-1 .6-1.6c0-1.4-1.1-2.5-2.5-2.5c-.6 0-1.2.2-1.6.6L13.2 10h1.4l-2-2h-1.4Z"/>'
        },
        mouse: {
            body: '<path fill="currentColor" d="M11 1.07C7.05 1.56 4 4.92 4 9h7m-7 6a8 8 0 0 0 8 8a8 8 0 0 0 8-8v-4H4m9-9.93V9h7c0-4.08-3.06-7.44-7-7.93Z"/>'
        },
        "mouse-bluetooth": {
            body: '<path fill="currentColor" d="M20 7h.5l2.85 2.85L21.21 12l2.14 2.14L20.5 17H20v-3.79l-2.29 2.29l-.71-.71L19.79 12L17 9.21l.71-.71L20 10.79V7m1 1.91v1.88l.94-.94l-.94-.94m0 4.3v1.87l.94-.94l-.94-.93M15 9v1H9V2.07c3.39.49 6 3.4 6 6.93M1 10V9c0-3.53 2.61-6.44 6-6.93V10H1m14 5a7 7 0 0 1-7 7a7 7 0 0 1-7-7v-3h14v3Z"/>'
        },
        "mouse-move-down": {
            body: '<path fill="currentColor" d="M7 9H2c0-2.96 2.17-5.43 5-5.91V9m13-2h-2v6h-3l4 4l4-4h-3V7M9 3.09V9h5c0-2.96-2.17-5.43-5-5.91M2 15c0 3.3 2.7 6 6 6s6-2.7 6-6v-4H2v4Z"/>'
        },
        "mouse-move-up": {
            body: '<path fill="currentColor" d="M7 9H2c0-2.96 2.17-5.43 5-5.91V9m11 8h2v-6h3l-4-4l-4 4h3v6M9 3.09V9h5c0-2.96-2.17-5.43-5-5.91M2 15c0 3.3 2.7 6 6 6s6-2.7 6-6v-4H2v4Z"/>'
        },
        "mouse-move-vertical": {
            body: '<path fill="currentColor" d="M20 6h3l-4-4l-4 4h3v12h-3l4 4l4-4h-3V6M9 3.09c2.83.48 5 2.95 5 5.91H9V3.09M14 11v4c0 3.3-2.7 6-6 6s-6-2.7-6-6v-4h12M7 9H2c0-2.96 2.17-5.43 5-5.91V9Z"/>'
        },
        "mouse-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-1.23-1.21A7.892 7.892 0 0 1 12 23a8 8 0 0 1-8-8v-4h3.73l-2-2H4c0-.54.05-1.07.15-1.58L2 5.27m9-4.2V9h-.18L5.79 3.96A7.95 7.95 0 0 1 11 1.07M20 11v4c0 .95-.17 1.86-.47 2.71L12.82 11H20m-7-9.93c3.94.49 7 3.85 7 7.93h-7V1.07Z"/>'
        },
        "mouse-variant": {
            body: '<path fill="currentColor" d="M14 7h-4V2.1A5 5 0 0 1 14 7M4 7a5 5 0 0 1 4-4.9V7H4m10 5a5 5 0 0 1-4 4.9V18a3 3 0 0 0 3 3a3 3 0 0 0 3-3v-5a4 4 0 0 1 4-4h2l-1 1l1 1h-2a2 2 0 0 0-2 2v5a5 5 0 0 1-5 5a5 5 0 0 1-5-5v-1.1A5 5 0 0 1 4 12V9h10v3Z"/>'
        },
        "mouse-variant-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-1.44-1.44C16.42 22 14.82 23 13 23a5 5 0 0 1-5-5v-1.1A5 5 0 0 1 4 12V9h1.73L2 5.27M14 7h-4V2.1A5 5 0 0 1 14 7M8 2.1v4.08L5.38 3.55C6.07 2.83 7 2.31 8 2.1m6 9.9v.17L10.82 9H14v3m-4 4.9V18a3 3 0 0 0 3 3c1.28 0 2.37-.8 2.8-1.93l-3.4-3.4c-.66.61-1.48 1.04-2.4 1.23m6-3.9a4 4 0 0 1 4-4h2l-1 1l1 1h-2a2 2 0 0 0-2 2v3.18l-2-2V13Z"/>'
        },
        "move-resize": {
            body: '<path fill="currentColor" d="M9 1v1h1v3H9v1h3V5h-1V2h1V1M9 7c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2M1 9v3h1v-1h3v1h1V9H5v1H2V9m7 0h12v12H9m5-11v1h1v5h-4v-1h-1v3h1v-1h4v2h-1v1h3v-1h-1v-2h3v1h1v-3h-1v1h-3v-5h1v-1"/>'
        },
        "move-resize-variant": {
            body: '<path fill="currentColor" d="M1.88.46L.46 1.88L5.59 7H2v2h7V2H7v3.59M11 7v2h10v6h2V9a2 2 0 0 0-2-2M7 11v10a2 2 0 0 0 2 2h6v-2H9V11m6.88 3.46l-1.42 1.42L19.6 21H17v2h6v-6h-2v2.59"/>'
        },
        movie: {
            body: '<path fill="currentColor" d="m18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4h-4Z"/>'
        },
        "movie-check": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m8.34-3.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "movie-check-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1m8.34-3.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "movie-cog": {
            body: '<path fill="currentColor" d="M12 19c0 .34.03.67.08 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v8.68A6.995 6.995 0 0 0 12 19m11.8 1.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "movie-cog-outline": {
            body: '<path fill="currentColor" d="M12 19c0 .34.03.67.08 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v8.68a7.03 7.03 0 0 0-2-.6V10H5.76L4 6.47V18h8.08c-.05.33-.08.66-.08 1m11.8 1.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "movie-edit": {
            body: '<path fill="currentColor" d="M21.04 11.13c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 0 0-.38-.17m-1.97 1.75L13 18.94V21h2.06l6.06-6.07l-2.05-2.05M11 20H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L7 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v4.12l-10 9.99V20Z"/>'
        },
        "movie-edit-outline": {
            body: '<path fill="currentColor" d="M21 4v4.12L19.12 10H4.76L3 6.47V18h8v2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L7 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4m.42 8.3l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17s.27.06.38.17m-.3 3.63L15.06 22H13v-2.06l6.07-6.06l2.05 2.05Z"/>'
        },
        "movie-filter": {
            body: '<path fill="currentColor" d="m18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4m-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25m5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94Z"/>'
        },
        "movie-filter-outline": {
            body: '<path fill="currentColor" d="m10 11l-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.09 0-2 .9-2 2v12c0 1.1.91 2 2 2h16a2 2 0 0 0 2-2V4h-4m2 14H4V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4v8Z"/>'
        },
        "movie-minus": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m2-1v2h8v-2h-8Z"/>'
        },
        "movie-minus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1m2-1v2h8v-2h-8Z"/>'
        },
        "movie-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L18.11 20H4a2 2 0 0 1-2-2V6c0-.58.25-1.1.65-1.46L1.11 3l1.28-1.27l19.72 19.73m-.23-2.78c.08-.21.12-.44.12-.68V4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l.8 1.6l13.08 13.08Z"/>'
        },
        "movie-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l1.54 1.54C2.25 4.9 2 5.42 2 6v12a2 2 0 0 0 2 2h14.11l2.73 2.73l1.27-1.27L2.39 1.73M4 18V6.47L5.76 10h2.35l8 8H4M8.8 5.6L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v14c0 .24-.04.47-.12.68L20 16.8V10h-6.8L8.8 5.6Z"/>'
        },
        "movie-open": {
            body: '<path fill="currentColor" d="m20.84 2.18l-3.93.78l2.74 3.54l1.97-.4l-.78-3.92m-6.87 1.36L12 3.93l2.75 3.53l1.96-.39l-2.74-3.53m-4.9.96l-1.97.41l2.75 3.53l1.96-.39L9.07 4.5m-4.91 1l-.98.19a2 2 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M2 10v10a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V10H2Z"/>'
        },
        "movie-open-check": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M19 13c1.1 0 2.12.3 3 .81V10H2v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7.19-4.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m17.18 10.34l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "movie-open-check-outline": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4m-9.81 1.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M4 20v-8h16v1.09c.72.12 1.39.37 2 .72V10H2v10a2 2 0 0 0 2 2h9.81c-.35-.61-.59-1.28-.72-2H4m17.34-4.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "movie-open-cog": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4M19 12c1.08 0 2.09.25 3 .68V10H2v10a2 2 0 0 0 2 2h8.68A6.995 6.995 0 0 1 19 12m-7.19-3.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M23.8 20.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "movie-open-cog-outline": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4m-9.81 1.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M4 20v-8h16v.08c.71.1 1.38.31 2 .61V10H2v10a2 2 0 0 0 2 2h8.68a7.03 7.03 0 0 1-.6-2H4m19.8.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "movie-open-edit": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M2 10v10a2 2 0 0 0 2 2h7v-2.87L20.13 10H2m9.81-1.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "movie-open-edit-outline": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4M4 12h14.13l2-2H2v10a2 2 0 0 0 2 2h7v-2H4v-8m7.81-3.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "movie-open-minus": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4m-9.81 1.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M19 13c1.1 0 2.12.3 3 .81V10H2v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-4 5v2h8v-2h-8Z"/>'
        },
        "movie-open-minus-outline": {
            body: '<path fill="currentColor" d="M13.09 20c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V10h20v3.81c-.61-.35-1.28-.59-2-.72V12H4v8h9.09m8.53-13.9l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4m-4.91.97l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m7.65 2.55L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M15 18v2h8v-2h-8Z"/>'
        },
        "movie-open-off": {
            body: '<path fill="currentColor" d="M13.2 10H22v8.8L13.2 10m8.4-3.9l-.8-3.9l-3.9.8l2.7 3.5l2-.4M11.8 8L9.1 4.5l-1.2.2l3.4 3.4l.5-.1M2.4 1.7L1.1 3l2.6 2.6l-.5.1C2.1 5.9 1.4 7 1.6 8l.4 2l5.1-1l1 1H2v10c0 1.1.9 2 2 2h16.1l.7.7l1.3-1.3L2.4 1.7m14.3 5.4L14 3.5l-2 .4l2.8 3.5l1.9-.3Z"/>'
        },
        "movie-open-off-outline": {
            body: '<path fill="currentColor" d="M19.7 6.5L16.9 3l3.9-.8l.8 3.9l-1.9.4m2.4 15l-1.3 1.3l-.7-.8H4c-1.1 0-2-.9-2-2V10h6.1l-1-1L2 10l-.4-2c-.2-1 .5-2.1 1.6-2.3l.5-.1L1.1 3l1.3-1.3l19.7 19.8m-4-1.5l-8-8H4v8h14.1m3.9-1.2V10h-8.8l2 2H20v4.8l2 2M16.7 7.1L14 3.5l-2 .4l2.8 3.5l1.9-.3m-4.9.9L9.1 4.5l-1.2.2l3.4 3.4l.5-.1Z"/>'
        },
        "movie-open-outline": {
            body: '<path fill="currentColor" d="m20.84 2.18l-3.93.78l2.74 3.54l1.97-.4l-.78-3.92m-6.87 1.36L12 3.93l2.75 3.53l1.96-.39l-2.74-3.53m-4.9.96l-1.97.41l2.75 3.53l1.96-.39L9.07 4.5m-4.91 1l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M20 12v8H4v-8h16m2-2H2v10a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V10Z"/>'
        },
        "movie-open-play": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m7.65 2.55L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M2 10v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6c1.1 0 2.12.3 3 .81V10H2m15 12l5-3l-5-3v6Z"/>'
        },
        "movie-open-play-outline": {
            body: '<path fill="currentColor" d="M22 10v3.81c-.61-.35-1.28-.59-2-.72V12H4v8h9.09c.12.72.37 1.39.72 2H4a2 2 0 0 1-2-2V10h20m-5.29-2.93l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39m4.91-.97l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4m-9.81 1.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M17 22l5-3l-5-3v6Z"/>'
        },
        "movie-open-plus": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M19 13c1.1 0 2.12.3 3 .81V10H2v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6m-7.19-4.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "movie-open-plus-outline": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4M4 20v-8h16v1.09c.72.12 1.39.37 2 .72V10H2v10a2 2 0 0 0 2 2h9.81c-.35-.61-.59-1.28-.72-2H4m7.81-11.95L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "movie-open-remove": {
            body: '<path fill="currentColor" d="M14.75 7.46L12 3.93l1.97-.39l2.74 3.53l-1.96.39m-2.94.59L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39m9.81-1.95l-.78-3.92l-3.93.78l2.74 3.54l1.97-.4M19 13c1.1 0 2.12.3 3 .81V10H2v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m18.38 11.38l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "movie-open-remove-outline": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m7.65 2.55L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4 20v-8h16v1.09c.72.12 1.39.37 2 .72V10H2v10a2 2 0 0 0 2 2h9.81c-.35-.61-.59-1.28-.72-2H4m18.54-3.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "movie-open-settings": {
            body: '<path fill="currentColor" d="M14.75 5.46L12 1.93l1.97-.39l2.74 3.53l-1.96.39m6.87-1.36L20.84.18l-3.93.78l2.74 3.54l1.97-.4m-9.81 1.95L9.07 2.5l-1.97.41l2.75 3.53l1.96-.39M2 8v10a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V8H2m2.16-4.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 8l4.9-.97L4.16 3.5M11 24h2v-2h-2v2m-4 0h2v-2H7v2m8 0h2v-2h-2v2Z"/>'
        },
        "movie-open-settings-outline": {
            body: '<path fill="currentColor" d="M19.65 4.5L16.91.96l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39m-4.9.98L9.07 2.5l-1.97.41l2.75 3.53l1.96-.39M4.16 3.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 8l4.9-.97L4.16 3.5M22 8v10c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V8h20m-2 2H4v8h16v-8M7 24h2v-2H7v2m8 0h2v-2h-2v2m-4 0h2v-2h-2v2Z"/>'
        },
        "movie-open-star": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M19 13c1.1 0 2.12.3 3 .81V10H2v10a2 2 0 0 0 2 2h9.81c-.51-.88-.81-1.9-.81-3c0-3.31 2.69-6 6-6M4.16 5.5l-.98.19a2.008 2.008 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m7.65 2.55L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M23 17.89l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "movie-open-star-outline": {
            body: '<path fill="currentColor" d="m19.65 6.5l-2.74-3.54l3.93-.78l.78 3.92l-1.97.4m-2.94.57l-2.74-3.53l-1.97.39l2.75 3.53l1.96-.39M4.16 5.5l-.98.19a1.995 1.995 0 0 0-1.57 2.35L2 10l4.9-.97L4.16 5.5m7.65 2.55L9.07 4.5l-1.97.41l2.75 3.53l1.96-.39M4 20v-8h16v1.09c.72.12 1.39.37 2 .72V10H2v10a2 2 0 0 0 2 2h9.81c-.35-.61-.59-1.28-.72-2H4m19-2.11l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "movie-outline": {
            body: '<path fill="currentColor" d="M5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4Z"/>'
        },
        "movie-play": {
            body: '<path fill="currentColor" d="M22 4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4m-5 18l5-3l-5-3v6Z"/>'
        },
        "movie-play-outline": {
            body: '<path fill="currentColor" d="M22 4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4m-5 18l5-3l-5-3v6Z"/>'
        },
        "movie-plus": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "movie-plus-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "movie-remove": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m9.54-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "movie-remove-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1m9.54-2.12l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "movie-roll": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 12 9a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 4M4.4 9.53A2.5 2.5 0 0 0 6 12.68c1.32.42 2.73-.29 3.15-1.61a2.5 2.5 0 0 0-1.6-3.15c-1.31-.42-2.73.29-3.15 1.61m15.21-.03c-.43-1.29-1.84-2-3.15-1.58a2.489 2.489 0 0 0-1.61 3.15a2.5 2.5 0 0 0 3.15 1.6c1.31-.42 2.03-1.84 1.61-3.17m-12.3 8.96c1.11.82 2.69.57 3.49-.55c.81-1.12.56-2.68-.56-3.49a2.506 2.506 0 0 0-3.49.55c-.81 1.12-.56 2.68.56 3.49m9.39 0c1.12-.81 1.37-2.37.56-3.49a2.488 2.488 0 0 0-3.49-.55a2.497 2.497 0 0 0-.56 3.49c.79 1.12 2.38 1.36 3.49.55M12 10.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "movie-search": {
            body: '<path fill="currentColor" d="M11.03 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.05A6.487 6.487 0 0 0 16.5 10c-3.58 0-6.5 2.92-6.5 6.5c0 1.29.38 2.5 1.03 3.5m12.36 2L22 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 16.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "movie-search-outline": {
            body: '<path fill="currentColor" d="M11 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9c-.5-.8-1.2-1.5-2-2v-1H5.8L4 6.5V18h6.2c.2.7.4 1.4.8 2m9.3-1.1c.4-.7.7-1.5.7-2.4c0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.2 2.4-.7l3.1 3.1l1.4-1.4l-3.1-3.1m-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5Z"/>'
        },
        "movie-settings": {
            body: '<path fill="currentColor" d="M22 4v14c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4M7 24h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        "movie-settings-outline": {
            body: '<path fill="currentColor" d="m18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V4h-4m2 14H4V6.47L5.76 10H20v8m-9 4h2v2h-2v-2m-4 0h2v2H7v-2m8 0h2v2h-2v-2Z"/>'
        },
        "movie-star": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.88-.51-1.9-.81-3-.81c-3.31 0-6 2.69-6 6m10-1.11l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "movie-star-outline": {
            body: '<path fill="currentColor" d="M13 19c0 .34.04.67.09 1H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1l2 4h3L8 4h2l2 4h3l-2-4h2l2 4h3l-2-4h4v9.81c-.61-.35-1.28-.59-2-.72V10H5.76L4 6.47V18h9.09c-.05.33-.09.66-.09 1m10-1.11l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        mower: {
            body: '<path fill="currentColor" d="M18.5 14c-.95 0-1.81.38-2.44 1H9.39L5.74 3H2v2h2.26L7 14.05c-.15-.02-.32-.05-.5-.05C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21c1.39 0 2.59-.82 3.15-2h5.7c.56 1.18 1.76 2 3.15 2c1.93 0 3.5-1.57 3.5-3.5S20.43 14 18.5 14m-12 5c-.83 0-1.5-.67-1.5-1.5S5.67 16 6.5 16s1.5.67 1.5 1.5S7.33 19 6.5 19m12 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m-8.37-5l-.6-2h3.23c.74 0 1.45.43 1.79 1.11L15 14h-4.87Z"/>'
        },
        "mower-bag": {
            body: '<path fill="currentColor" d="m11.95 14l-1.13-2h3.94c.74 0 1.45.43 1.79 1.11L17 14h-5.05M23 18c0 1.66-1.34 3-3 3c-1.3 0-2.4-.84-2.82-2h-5.53c-.56 1.18-1.76 2-3.15 2s-2.59-.82-3.15-2H2c-.55 0-1-.45-1-1v-7c0-.33.17-.64.44-.83c.27-.17.62-.22.93-.1l5.06 2.02L3.42 5H1V3h3.58l6.79 12H20c1.66 0 3 1.34 3 3M7.34 14.21L3 12.5V17h2.05c.19-1.3 1.08-2.36 2.29-2.79M10 17.5c0-.83-.67-1.5-1.5-1.5S7 16.67 7 17.5S7.67 19 8.5 19s1.5-.67 1.5-1.5m11 .5c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1Z"/>'
        },
        "mower-bag-on": {
            body: '<path fill="currentColor" d="M12 2h2v5h-2V2m10 4.3l-1.4-1.4L17 8.4l1.4 1.4s3.5-3.5 3.6-3.5M10.8 12l1.1 2H17l-.5-.9c-.3-.7-1-1.1-1.8-1.1h-3.9m9.2 3h-8.6L4.6 3H1v2h2.4l4 7.1l-5.1-2c-.2-.1-.6-.1-.9.1c-.2.2-.4.5-.4.8v7c0 .5.5 1 1 1h3.3c.6 1.2 1.8 2 3.2 2s2.6-.8 3.2-2h5.5c.4 1.2 1.5 2 2.8 2c1.7 0 3-1.3 3-3s-1.3-3-3-3M5 17H3v-4.5l4.3 1.7c-1.2.4-2.1 1.5-2.3 2.8m3.5 2c-.8 0-1.5-.7-1.5-1.5S7.7 16 8.5 16s1.5.7 1.5 1.5S9.3 19 8.5 19M20 19c-.5 0-1-.5-1-1s.5-1 1-1s1 .5 1 1s-.5 1-1 1Z"/>'
        },
        "mower-on": {
            body: '<path fill="currentColor" d="M12 2h2v5h-2V2m10 4.3l-1.4-1.4L17 8.4l1.4 1.4s3.5-3.5 3.6-3.5M18.5 14c-1 0-1.8.4-2.4 1H9.4L5.7 3H2v2h2.3L7 14h-.5C4.6 14 3 15.6 3 17.5S4.6 21 6.5 21c1.4 0 2.6-.8 3.2-2h5.7c.6 1.2 1.8 2 3.2 2c1.9 0 3.5-1.6 3.5-3.5S20.4 14 18.5 14m-12 5c-.8 0-1.5-.7-1.5-1.5S5.7 16 6.5 16s1.5.7 1.5 1.5S7.3 19 6.5 19m12 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m-9-7l.6 2H15l-.4-.9c-.3-.7-1.1-1.1-1.8-1.1H9.5Z"/>'
        },
        muffin: {
            body: '<path fill="currentColor" d="M16 5s-1-3-4-3s-4 3-4 3C6 5 4 7 4 9c-2.7 0-2.7 4 0 4h16c2.7 0 2.7-4 0-4c0-2-2-4-4-4M5 15l2 7h2l-1-7H5m5 0l1 7h2l1-7h-4m6 0l-1 7h2l2-7h-3Z"/>'
        },
        multicast: {
            body: '<path fill="currentColor" d="M17 2v2h-5a2 2 0 0 0-2 2v3h2V6h5v2l3-3l-3-3m0 7v2H6.73c-.36-.62-1.02-1-1.73-1c-1.1 0-2 .9-2 2s.9 2 2 2c.71 0 1.37-.38 1.73-1H17v2l3-3l-3-3m-7 6v3a2 2 0 0 0 2 2h5v2l3-3l-3-3v2h-5v-3h-2Z"/>'
        },
        multimedia: {
            body: '<path fill="currentColor" d="M9 13V5c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v6h-3.43l-1.28-1.74a.14.14 0 0 0-.24 0L15.06 12c-.06.06-.18.07-.24 0l-1.43-1.75a.152.152 0 0 0-.23 0l-2.11 2.66c-.08.09-.01.24.11.24h6.34V15H11c-1.11 0-2-.89-2-2m-3 9v-1H4v1H2V2h2v1h2V2h2.39C7.54 2.74 7 3.8 7 5v8c0 2.21 1.79 4 4 4h4.7c-1.03.83-1.7 2.08-1.7 3.5c0 .53.11 1.03.28 1.5H6M4 7h2V5H4v2m0 4h2V9H4v2m0 4h2v-2H4v2m2 4v-2H4v2h2m17-6v2h-2v5.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3.5-2.29V13H23Z"/>'
        },
        multiplication: {
            body: '<path fill="currentColor" d="M11 3h2v7.27l6.29-3.63l1 1.73L14 12l6.3 3.64l-1 1.73l-6.3-3.65V21h-2v-7.27l-6.31 3.63l-1-1.73L10 12L3.72 8.36l1-1.73L11 10.26V3Z"/>'
        },
        "multiplication-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14m-8 14h2v-3.27l2.83 1.63l1-1.73L14 12l2.83-1.64l-1-1.73L13 10.27V7h-2v3.27L8.17 8.63l-1 1.73L10 12l-2.83 1.63l1 1.73L11 13.73V17Z"/>'
        },
        mushroom: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2A10 10 0 0 1 12 2m0 6a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m5 4a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2M7 12a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m8 3l1.27 4.45l.08.55c0 1.1-.9 2-2 2h-4.7a2 2 0 0 1-2-2l.08-.55L9 15h6Z"/>'
        },
        "mushroom-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 1.1.9 2 2 2h8.1l1 1H9l-1.3 4.5v.5c0 1.1.9 2 2 2h4.7c1.1 0 2-.9 2-2l-.1-.5l-.5-1.8l5.1 5.1l1.2-1.3M7 12c-1.1 0-2-.9-2-2c0-.8.5-1.6 1.3-1.9l2.6 2.6C8.6 11.5 7.8 12 7 12m3-6c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2c-.5 0-.9-.2-1.3-.5l6.5 6.5H20c1.1 0 2-.9 2-2c0-5.5-4.5-10-10-10c-1.9 0-3.7.6-5.3 1.5l3.7 3.7c-.2-.3-.4-.7-.4-1.2m7 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        "mushroom-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3 3C2.8 7.6 2 9.7 2 12c0 1.1.9 2 2 2h8.1l1 1H9l-1 3.5l-.3 1c-.3 1.1.4 2.2 1.4 2.4l.6.1h4.7c1.1 0 2-.9 2-2l-.1-.5l-.3-1l-.2-.9l5.1 5.1l1.2-1.2M4 12c0-1.7.6-3.3 1.5-4.6l.7.7c-.1.3-.2.6-.2.9c0 1.1.9 2 2 2c.3 0 .6-.1.9-.2l1.2 1.2H4m5.7 8l.3-1l.6-2h3l.6 2l.3 1H9.7m6.3-9c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2c5.5 0 10 4.5 10 10c0 1.1-.9 2-2 2h-2.8l-2-2H20c0-3.7-2.6-6.9-6-7.8c-.1 1-1 1.8-2 1.8s-1.9-.8-2-1.8c-.6.2-1.3.5-1.8.8Z"/>'
        },
        "mushroom-outline": {
            body: '<path fill="currentColor" d="M4 12h16c0-3.73-2.56-6.87-6-7.75c-.14.99-1 1.75-2 1.75s-1.86-.76-2-1.75C6.56 5.13 4 8.27 4 12m8-10a10 10 0 0 1 10 10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2A10 10 0 0 1 12 2m1.5 15h-3l-.58 2l-.27 1h4.7l-.27-1l-.58-2m1.5-2l1 3.5l.27.95l.08.55c0 1.1-.9 2-2 2h-4.7l-.48-.06a2.004 2.004 0 0 1-1.44-2.44l.27-1L9 15h6m1-8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M8 7a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        music: {
            body: '<path fill="currentColor" d="M21 3v12.5a3.5 3.5 0 0 1-3.5 3.5a3.5 3.5 0 0 1-3.5-3.5a3.5 3.5 0 0 1 3.5-3.5c.54 0 1.05.12 1.5.34V6.47L9 8.6v8.9A3.5 3.5 0 0 1 5.5 21A3.5 3.5 0 0 1 2 17.5A3.5 3.5 0 0 1 5.5 14c.54 0 1.05.12 1.5.34V6l14-3Z"/>'
        },
        "music-accidental-double-flat": {
            body: '<path fill="currentColor" d="M15.5 9c-.7 0-1.39.28-2 .67V5h-2v4.62c-.46-.38-1.11-.62-2-.62c-.7 0-1.39.28-2 .67V5h-2v14c3-1.68 4.93-3.21 6-4.59V19c4.86-2.74 7-5.09 7-7c0-1.41-.71-3-3-3m-8 6.38v-3.12c.62-.67 1.45-1.26 2-1.26c.59 0 1 .07 1 1c0 .15-.1 1.3-3 3.38m6 0v-3.12c.62-.67 1.45-1.26 2-1.26c.59 0 1 .07 1 1c0 .15-.1 1.3-3 3.38Z"/>'
        },
        "music-accidental-double-sharp": {
            body: '<path fill="currentColor" d="M15.41 10H17V7h-3v1.59l-2 2l-2-2V7H7v3h1.59l2 2l-2 2H7v3h3v-1.59l2-2l2 2V17h3v-3h-1.59l-2-2l2-2Z"/>'
        },
        "music-accidental-flat": {
            body: '<path fill="currentColor" d="M8.5 19c4.86-2.74 7-5.09 7-7c0-1.41-.71-3-3-3c-.7 0-1.39.28-2 .67V5h-2m2 10.38v-3.12c.62-.67 1.45-1.26 2-1.26c.59 0 1 .07 1 1c0 .15-.1 1.3-3 3.38Z"/>'
        },
        "music-accidental-natural": {
            body: '<path fill="currentColor" d="M10 8.75V3.5H8v14l6-2.25v5.25h2v-14l-6 2.25m4 4.5l-4 1.5v-4l4-1.5v4Z"/>'
        },
        "music-accidental-sharp": {
            body: '<path fill="currentColor" d="M17 9.5v-2l-2 .6V5.5h-2v3.2l-2 .6V6.5H9v3.4l-2 .6v2l2-.6v2l-2 .6v2l2-.6v2.6h2v-3.2l2-.6v2.8h2v-3.4l2-.6v-2l-2 .6v-2l2-.6m-4 3.2l-2 .6v-2l2-.6v2Z"/>'
        },
        "music-box": {
            body: '<path fill="currentColor" d="M16 9h-3v5.5a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 8 14.5a2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.5V7h4m3-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "music-box-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4M18 7h-3v5.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.5V5h4m2-3H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "music-box-multiple-outline": {
            body: '<path fill="currentColor" d="M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 14H8V4h12m-7.5 11a2.5 2.5 0 0 0 2.5-2.5V7h3V5h-4v5.5c-.42-.31-.93-.5-1.5-.5a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5M4 6H2v14a2 2 0 0 0 2 2h14v-2H4"/>'
        },
        "music-box-outline": {
            body: '<path fill="currentColor" d="M16 9h-3v5.5a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 8 14.5a2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.5V7h4v2m3-6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M5 5v14h14V5H5Z"/>'
        },
        "music-circle": {
            body: '<path fill="currentColor" d="M16 9V7h-4v5.5c-.42-.31-.93-.5-1.5-.5A2.5 2.5 0 0 0 8 14.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5V9h3m-4-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "music-circle-outline": {
            body: '<path fill="currentColor" d="M16 9h-3v5.5a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 8 14.5a2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.5V7h4v2m-4-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "music-clef-alto": {
            body: '<path fill="currentColor" d="M5 4h2v16H5m10.46-7h-.63l-1-1l1-1h.63a3.5 3.5 0 1 0-3.5-3.5h2a1.5 1.5 0 1 1 1.5 1.5H14l-2 2h-1V4H9v16h2v-7h1l2 2h1.46a1.5 1.5 0 1 1-1.5 1.5h-2a3.5 3.5 0 1 0 3.5-3.5Z"/>'
        },
        "music-clef-bass": {
            body: '<path fill="currentColor" d="M18.5 5A1.5 1.5 0 1 1 17 6.5A1.5 1.5 0 0 1 18.5 5m0 6a1.5 1.5 0 1 1-1.5 1.5a1.5 1.5 0 0 1 1.5-1.5M10 4a5 5 0 0 0-5 5v1a2 2 0 1 0 2.18-2A3 3 0 0 1 10 6a4 4 0 0 1 4 4c0 3.59-2.23 6.19-7 8.2l.76 1.84C13.31 17.72 16 14.43 16 10a6 6 0 0 0-6-6Z"/>'
        },
        "music-clef-treble": {
            body: '<path fill="currentColor" d="M13 11V7.5l2.2-2.21c.8-.79.95-2.05.39-3.03A2.467 2.467 0 0 0 13.45 1c-.21 0-.45.03-.64.09C11.73 1.38 11 2.38 11 3.5v3.24L7.86 9.91a5.946 5.946 0 0 0-1.25 6.43c.77 1.9 2.45 3.21 4.39 3.55v.61c0 .26-.23.5-.5.5H9v2h1.5c1.35 0 2.5-1.11 2.5-2.5V20c2.03 0 4.16-1.92 4.16-4.75c0-2.3-1.92-4.25-4.16-4.25m0-7.5c0-.23.11-.41.32-.47c.22-.06.45.03.56.23a.5.5 0 0 1-.08.61l-.8.86V3.5m-2 8c-.97.64-1.7 1.74-1.96 2.76l1.96.52v3.05a3.86 3.86 0 0 1-2.57-2.26c-.59-1.46-.27-3.12.83-4.24L11 9.5v2m2 6.5v-5.06c1.17 0 2.18 1.1 2.18 2.31C15.18 17 13.91 18 13 18Z"/>'
        },
        "music-note": {
            body: '<path fill="currentColor" d="M12 3v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V7h4V3h-6Z"/>'
        },
        "music-note-bluetooth": {
            body: '<path fill="currentColor" d="M22 9.85L19.14 7h-.5v3.79L16.35 8.5l-.71.71L18.43 12l-2.79 2.79l.71.71l2.29-2.29V17h.5L22 14.15L19.85 12L22 9.85m-2.36-.94l.94.94l-.94.94V8.91m.94 5.24l-.94.94v-1.88l.94.94M9.64 3v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V7h4V3h-6Z"/>'
        },
        "music-note-bluetooth-off": {
            body: '<path fill="currentColor" d="M22 9.85L19.14 7h-.5v3.79L16.35 8.5l-.71.71L18.43 12l-2.79 2.79l.71.71l2.29-2.29V17h.5L22 14.15L19.85 12L22 9.85m-2.36-.94l.94.94l-.94.94V8.91m.94 5.24l-.94.94v-1.88l.94.94M1.96 3L.687 4.27l9.003 9v.28c-.59-.34-1.27-.55-2-.55c-2.19 0-4 1.79-4 4s1.81 4 4 4s4-1.79 4-4v-1.73L17.42 21l1.27-1.27L1.96 3m9.73 4h4V3h-6v5.18l2 2V7Z"/>'
        },
        "music-note-eighth": {
            body: '<path fill="currentColor" d="M12 3v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V7h4V3h-6Z"/>'
        },
        "music-note-eighth-dotted": {
            body: '<path fill="currentColor" d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3m-1.5 17a1.5 1.5 0 1 1 1.5-1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "music-note-half": {
            body: '<path fill="currentColor" d="M16 3h-2v10.56a3.96 3.96 0 0 0-2-.56a4 4 0 1 0 4 4V3m-4 16a2 2 0 1 1 2-2a2 2 0 0 1-2 2Z"/>'
        },
        "music-note-half-dotted": {
            body: '<path fill="currentColor" d="M14 3h-2v10.56a3.96 3.96 0 0 0-2-.56a4 4 0 1 0 4 4V3m-4 16a2 2 0 1 1 2-2a2 2 0 0 1-2 2m6.5 1a1.5 1.5 0 1 1 1.5-1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "music-note-minus": {
            body: '<path fill="currentColor" d="M14 12v2h8v-2h-8M9 3v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V7h4V3H9Z"/>'
        },
        "music-note-off": {
            body: '<path fill="currentColor" d="M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4v-1.73L19.73 21L21 19.73L4.27 3M14 7h4V3h-6v5.18l2 2Z"/>'
        },
        "music-note-off-outline": {
            body: '<path fill="currentColor" d="M14 7h4V3h-6v4.61l2 2m-2 .83L4.41 2.86L3 4.27l9 9v.28a3.94 3.94 0 0 0-3.33-.32a4 4 0 0 0 1.98 7.72a4.1 4.1 0 0 0 3.35-4.1v-1.58L19.73 21l1.41-1.41M10 19a2 2 0 1 1 2-2a2 2 0 0 1-2 2Z"/>'
        },
        "music-note-outline": {
            body: '<path fill="currentColor" d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3m-8 16a2 2 0 1 1 2-2a2 2 0 0 1-2 2Z"/>'
        },
        "music-note-plus": {
            body: '<path fill="currentColor" d="M17 9v3h-3v2h3v3h2v-3h3v-2h-3V9h-2M9 3v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V7h4V3H9Z"/>'
        },
        "music-note-quarter": {
            body: '<path fill="currentColor" d="M14 3v10.56c-.59-.35-1.27-.56-2-.56c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4V3h-2Z"/>'
        },
        "music-note-quarter-dotted": {
            body: '<path fill="currentColor" d="M12 13v.56a3.96 3.96 0 0 0-2-.56a4 4 0 1 0 4 4V3h-2m4.5 14a1.5 1.5 0 1 1-1.5 1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "music-note-sixteenth": {
            body: '<path fill="currentColor" d="M18 7V3h-6v10.55c-.59-.34-1.27-.55-2-.55c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4v-6h4V8h-4V7h4Z"/>'
        },
        "music-note-sixteenth-dotted": {
            body: '<path fill="currentColor" d="M18 18.5a1.5 1.5 0 1 1-1.5-1.5a1.5 1.5 0 0 1 1.5 1.5M18 7V3h-6v10.55A4 4 0 1 0 14 17v-6h4V8h-4V7Z"/>'
        },
        "music-note-whole": {
            body: '<path fill="currentColor" d="M12 15a2 2 0 1 1-2 2a2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4a4 4 0 0 0-4-4Z"/>'
        },
        "music-note-whole-dotted": {
            body: '<path fill="currentColor" d="M10 15a2 2 0 1 1-2 2a2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4a4 4 0 0 0-4-4m6.5 4a1.5 1.5 0 1 1-1.5 1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "music-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22L9 12.27v5.23A3.5 3.5 0 0 1 5.5 21A3.5 3.5 0 0 1 2 17.5A3.5 3.5 0 0 1 5.5 14c.54 0 1.05.12 1.5.34v-4.07l-5-5M21 3v12.5c0 1-.43 1.92-1.12 2.56l-4.94-4.94c.64-.69 1.56-1.12 2.56-1.12c.54 0 1.05.12 1.5.34V6.47l-8.83 1.88l-2.51-2.51L21 3Z"/>'
        },
        "music-rest-eighth": {
            body: '<path fill="currentColor" d="M14 6a5.56 5.56 0 0 1-3.05 1.86A1.5 1.5 0 1 0 9.5 9h.24a6.32 6.32 0 0 0 3.51-1.07L10 18h2l4-12Z"/>'
        },
        "music-rest-half": {
            body: '<path fill="currentColor" d="M6 14h2v-4h8v4h2v1H6v-1Z"/>'
        },
        "music-rest-quarter": {
            body: '<path fill="currentColor" d="M11.71 16.81c-.8.79-.83 2.03-.07 2.77L10.19 21c-1.53-1.5-1.47-3.97.13-5.54c.53-.52 1.18-.85 1.84-1.04L9 11.34l1.45-1.42l.37-.35c1-.98 1.03-2.53.08-3.46L9.16 4.42L10.62 3l4.16 4.06c.76.75.72 1.99-.07 2.77l-2.18 2.12L16 15.33l-.39.39c-.5.49-1.23.74-1.89.56c-.68-.18-1.46 0-2.01.53Z"/>'
        },
        "music-rest-sixteenth": {
            body: '<path fill="currentColor" d="M15 3a5.56 5.56 0 0 1-3.05 1.86A1.5 1.5 0 1 0 10.5 6h.24a6.32 6.32 0 0 0 3.51-1.07L12.9 9.1a5.56 5.56 0 0 1-2.95 1.76A1.5 1.5 0 1 0 8.5 12h.24a6.32 6.32 0 0 0 3.51-1.07L9 21h2l6-18Z"/>'
        },
        "music-rest-whole": {
            body: '<path fill="currentColor" d="M18 10h-2v4H8v-4H6V9h12v1Z"/>'
        },
        mustache: {
            body: '<path fill="currentColor" d="M21 12c-2 0-3-3-6-3s-3 2-3 2s0-2-3-2s-4 3-6 3c-1 0-2-1-2-1s1 5 5 5c5 0 6-3 6-3s1 3 6 3c4 0 5-5 5-5s-1 1-2 1Z"/>'
        },
        nail: {
            body: '<path fill="currentColor" d="M13.5 5v11L12 22l-1.5-6V5h3M17 2H7v2h10V2Z"/>'
        },
        nas: {
            body: '<path fill="currentColor" d="M4 5c-1.11 0-2 .89-2 2v10c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V7c0-1.11-.89-2-2-2H4m.5 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h13v10H7V7m1 1v8h3V8H8m4 0v8h3V8h-3m4 0v8h3V8h-3M9 9h1v1H9V9m4 0h1v1h-1V9m4 0h1v1h-1V9Z"/>'
        },
        nativescript: {
            body: '<path fill="currentColor" d="M7.5 3h9C19 3 21 5 21 7.5v9c0 2.5-2 4.5-4.5 4.5h-9C5 21 3 19 3 16.5v-9C3 5 5 3 7.5 3M6 13.5v3A1.5 1.5 0 0 0 7.5 18H9v-7.5l6 7.5h1.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1-1.5-1.5v-3A1.5 1.5 0 0 0 16.5 6H15v7.5L9 6H7.5A1.5 1.5 0 0 0 6 7.5v3A1.5 1.5 0 0 1 4.5 12A1.5 1.5 0 0 1 6 13.5Z"/>'
        },
        nature: {
            body: '<path fill="currentColor" d="M13 16.12a7 7 0 0 0 6.17-6.95c0-3.87-3.13-7-7-7a7 7 0 0 0-7 7c0 3.47 2.52 6.33 5.83 6.89V20H5v2h14v-2h-6v-3.88Z"/>'
        },
        "nature-people": {
            body: '<path fill="currentColor" d="M4.5 11A1.5 1.5 0 0 0 6 9.5A1.5 1.5 0 0 0 4.5 8A1.5 1.5 0 0 0 3 9.5A1.5 1.5 0 0 0 4.5 11m17.67-1.83c0-3.87-3.13-7-7-7a7 7 0 0 0-7 7c0 3.47 2.52 6.33 5.83 6.89V20H6v-3h1v-4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 0 0 6.17-6.95Z"/>'
        },
        navigation: {
            body: '<path fill="currentColor" d="M12 2L4.5 20.29l.71.71L12 18l6.79 3l.71-.71L12 2Z"/>'
        },
        "navigation-outline": {
            body: '<path fill="currentColor" d="m12 7.3l4.3 10.4l-3.5-1.5l-.8-.4l-.8.4l-3.5 1.5L12 7.3M12 2L4.5 20.3l.7.7l6.8-3l6.8 3l.7-.7L12 2Z"/>'
        },
        "navigation-variant": {
            body: '<path fill="currentColor" d="M21 3L3 10.53v.97l6.84 2.66L12.5 21h.96L21 3Z"/>'
        },
        "navigation-variant-outline": {
            body: '<path fill="currentColor" d="m17.27 6.73l-4.24 10.13l-1.32-3.42l-.32-.83l-.82-.32l-3.43-1.33l10.13-4.23M21 3L3 10.53v.97l6.84 2.66L12.5 21h.96L21 3Z"/>'
        },
        "near-me": {
            body: '<path fill="currentColor" d="M21 3L3 10.53v.97l6.84 2.66L12.5 21h.96L21 3Z"/>'
        },
        necklace: {
            body: '<path fill="currentColor" d="M21.5 5h-2c0 4.14-3.36 7.5-7.5 7.5c-4.14 0-7.5-3.36-7.5-7.5h-2c.05 5.11 4.09 9.29 9.2 9.5c-.6.9-1.7 2.7-1.7 3.5c0 2.67 4 2.67 4 0c0-.8-1.1-2.6-1.7-3.5c5.11-.21 9.15-4.39 9.2-9.5Z"/>'
        },
        needle: {
            body: '<path fill="currentColor" d="m11.15 15.18l-1.42-1.41l1.42-1.42l1.41 1.42l1.41-1.42l-1.41-1.41l1.41-1.41l1.42 1.41l1.41-1.41l-2.83-2.83l-7.07 7.07l2.83 2.83l1.42-1.42M3.08 19l3.12-3.11l-2.12-2.12l9.89-9.9L16.1 6l1.4-1.42l-1.4-1.42l1.4-1.41L21.75 6l-1.41 1.4L18.92 6L17.5 7.4l2.13 2.13l-9.9 9.89l-2.12-2.12l-4.53 4.54V19Z"/>'
        },
        "needle-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3L8 9.9l-3.9 3.9l2.1 2.1L3.1 19v2.8l4.5-4.5l2.1 2.1l3.9-3.9l7.2 7.2l1.3-1.2m-10.9-6.3l-1.4 1.4L7 13.8l2.5-2.5l1.4 1.4l-1.1 1.1l1.4 1.4m.7-6.5l-1.4-1.4L14 3.9L16.1 6l1.4-1.4l-1.4-1.4l1.4-1.4L21.8 6l-1.4 1.4L18.9 6l-1.4 1.4l2.1 2.1l-3.4 3.5l-2.8-2.8l.6-.7l1.4 1.4l1.4-1.4L14 6.7l-2.1 2Z"/>'
        },
        "nest-thermostat": {
            body: '<path d="M16.95 16.948l-2.122-2.121A3.987 3.987 0 0 0 16 11.997a3.95 3.95 0 0 0-.566-2.02L17.6 7.813a6.956 6.956 0 0 1 1.4 4.186a6.978 6.978 0 0 1-2.05 4.95zM12 4.998a6.96 6.96 0 0 1 4.186 1.4L14.02 8.564A3.954 3.954 0 0 0 12 7.998a4 4 0 0 0-2.828 6.829l-2.12 2.12A7 7 0 0 1 12 4.998zm0-3c-5.524 0-10 4.477-10 10s4.476 10 10 10c5.522 0 10-4.477 10-10s-4.478-10-10-10z" fill="currentColor"/>',
            hidden: true
        },
        netflix: {
            body: '<path fill="currentColor" d="M6.5 2h4l2.94 8.83L13.5 2h4v20c-1.25-.22-2.63-.36-4.09-.42L10.5 13l-.07 8.59c-1.4.06-2.73.2-3.93.41V2Z"/>'
        },
        network: {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/>'
        },
        "network-off": {
            body: '<path fill="currentColor" d="m1 5.27l4 4V15a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h2.73l2 2L21 22.72L2.28 4L1 5.27M15 20a1 1 0 0 0-1-1h-1v-1.73L15.73 20H15m2.69-3.13L5.13 4.31C5.41 3.55 6.14 3 7 3h10a2 2 0 0 1 2 2v10c0 .86-.55 1.59-1.31 1.87M22 20v1.18L20.82 20H22Z"/>'
        },
        "network-off-outline": {
            body: '<path fill="currentColor" d="M1.04 5.27L5 9.23V15a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h2.77l2 2l1.27-1.28L2.32 4L1.04 5.27M7 11.23L10.77 15H7v-3.77M15 20a1 1 0 0 0-1-1h-1v-1.77L15.77 20H15m7 0v1.14L20.86 20H22M7 6.14L5.14 4.28C5.43 3.53 6.16 3 7 3h10a2 2 0 0 1 2 2v10c0 .85-.53 1.57-1.28 1.86L15.86 15H17V5H7v1.14Z"/>'
        },
        "network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7Z"/>'
        },
        "network-pos": {
            body: '<path fill="currentColor" d="M17 9H8V7h9v2M7 7H5v2h2V7m0-3H5v2h2V4m3 0H8v2h2V4m3 13v2h1c.55 0 1 .45 1 1h7v2h-7c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1H2v-2h7c0-.55.45-1 1-1h1v-2H4c-1.11 0-2-.89-2-2V3a2 2 0 0 1 2-2h16c1.11 0 2 .89 2 2v12c0 1.11-.89 2-2 2h-7m7-2V3H4v12h16m-9-9h8V4h-8v2m-6 6h6v-2H5v2m8 2h6v-2h-6v2Z"/>'
        },
        "network-strength-1": {
            body: '<path fill="currentColor" d="M1 21h20V1m-2 4.83V19h-8v-5.17"/>'
        },
        "network-strength-1-alert": {
            body: '<path fill="currentColor" d="M21 1L1 21h16v-2h-6v-5.2l8-8V9h2m-2 2v6h2v-6m-2 8v2h2v-2"/>'
        },
        "network-strength-2": {
            body: '<path fill="currentColor" d="M1 21h20V1m-2 4.83V19h-6v-7.17"/>'
        },
        "network-strength-2-alert": {
            body: '<path fill="currentColor" d="M21 1L1 21h16v-2h-4v-7.2l6-6V9h2m-2 2v6h2v-6m-2 8v2h2v-2"/>'
        },
        "network-strength-3": {
            body: '<path fill="currentColor" d="M1 21h20V1m-2 4.83V19h-3V8.83"/>'
        },
        "network-strength-3-alert": {
            body: '<path fill="currentColor" d="M21 1L1 21h16v-2h-1V8.8l3-3V9h2m-2 2v6h2v-6m-2 8v2h2v-2"/>'
        },
        "network-strength-4": {
            body: '<path fill="currentColor" d="M1 21h20V1"/>'
        },
        "network-strength-4-alert": {
            body: '<path fill="currentColor" d="M19 17h2v-6h-2m0 10h2v-2h-2M1 21h16V9h4V1"/>'
        },
        "network-strength-4-cog": {
            body: '<path fill="currentColor" d="M17 13c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.1.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.3.2.5.4.8.5l.2 1.3c0 .1.1.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.1.6-.3.8-.5l1.2.5c.1 0 .3 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.8v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.1-.3-.1l-1.1.5c-.3-.2-.5-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2m1 3.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5M11.7 21H1L21 1v10.7c-.9-.4-1.9-.7-3-.7c-3.9 0-7 3.1-7 7c0 1.1.2 2.1.7 3Z"/>'
        },
        "network-strength-alert": {
            body: '<path d="M18.999 17.003H21V8.999H19m0 12.002H21V19H19M1 21h16.002V7.003H21V1" fill="currentColor"/>',
            hidden: true
        },
        "network-strength-alert-outline": {
            body: '<path d="M21.001 1l-20 20.001h16.002V19H6L19 5.83v1.173H21M19 8.998v8.004H21V8.999m-2.002 10V21H21V19" fill="currentColor"/>',
            hidden: true
        },
        "network-strength-off": {
            body: '<path fill="currentColor" d="m21 1l-8.6 8.6l8.6 8.59M4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73"/>'
        },
        "network-strength-off-outline": {
            body: '<path fill="currentColor" d="m21 1l-8.6 8.6l1.45 1.45L19 5.83v10.36l2 2M4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73M11.33 13.6l5.4 5.4H6"/>'
        },
        "network-strength-outline": {
            body: '<path fill="currentColor" d="M1 21h20V1m-2 4.83V19H6"/>'
        },
        "new-box": {
            body: '<path fill="currentColor" d="M20 4c1.11 0 2 .89 2 2v12c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2V6c0-1.11.89-2 2-2h16M8.5 15V9H7.25v3.5L4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2m5-4.74V9h-4v6h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5m7 3.74V9h-1.25v4.5h-1.12V10h-1.25v3.5h-1.13V9H14.5v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1Z"/>'
        },
        newspaper: {
            body: '<path fill="currentColor" d="M20 11H4V8h16m0 7h-7v-2h7m0 6h-7v-2h7m-9 2H4v-6h7m9.33-8.33L18.67 3L17 4.67L15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V3l-1.67 1.67Z"/>'
        },
        "newspaper-check": {
            body: '<path fill="currentColor" d="M20.33 4.67L18.67 3L17 4.67L15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3v16a2 2 0 0 0 2 2h8.8c-.51-.88-.8-1.91-.8-3c0-1.23.37-2.37 1-3.32V13h1.68c.95-.63 2.09-1 3.32-1c1.53 0 2.93.58 4 1.5V3l-1.67 1.67M11 19H4v-6h7v6m9-8H4V8h16v3m-3.25 10.16l-2.75-3L15.16 17l1.59 1.59L20.34 15l1.16 1.41l-4.75 4.75"/>'
        },
        "newspaper-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8m-2-6V8H4v3h16m-7 2v1.68c-.63.95-1 2.09-1 3.32c0 1.09.29 2.12.8 3H4a2 2 0 0 1-2-2V3l1.67 1.67L5.33 3L7 4.67L8.67 3l1.66 1.67L12 3l1.67 1.67L15.33 3L17 4.67L18.67 3l1.66 1.67L22 3v10.5a6.137 6.137 0 0 0-4-1.5c-1.23 0-2.37.37-3.32 1H13m-2 6v-6H4v6h7Z"/>'
        },
        "newspaper-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3m3-3V8H4v3h16m-7 2v1.68c-.63.95-1 2.09-1 3.32c0 1.09.29 2.12.8 3H4a2 2 0 0 1-2-2V3l1.67 1.67L5.33 3L7 4.67L8.67 3l1.66 1.67L12 3l1.67 1.67L15.33 3L17 4.67L18.67 3l1.66 1.67L22 3v10.5a6.137 6.137 0 0 0-4-1.5c-1.23 0-2.37.37-3.32 1H13m-2 6v-6H4v6h7Z"/>'
        },
        "newspaper-remove": {
            body: '<path fill="currentColor" d="m20.12 14.46l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.13m.21-9.79L18.67 3L17 4.67L15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3v16a2 2 0 0 0 2 2h8.8c-.51-.88-.8-1.91-.8-3c0-1.23.37-2.37 1-3.32V13h1.68c.95-.63 2.09-1 3.32-1c1.53 0 2.93.58 4 1.5V3l-1.67 1.67M11 19H4v-6h7v6m9-8H4V8h16v3Z"/>'
        },
        "newspaper-variant": {
            body: '<path fill="currentColor" d="M20 3H4c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2M5 7h5v6H5V7m14 10H5v-2h14v2m0-4h-7v-2h7v2m0-4h-7V7h7v2Z"/>'
        },
        "newspaper-variant-multiple": {
            body: '<path fill="currentColor" d="M4 7v12h15v2H4c-2 0-2-2-2-2V7h2m17.3-4H7.7C6.76 3 6 3.7 6 4.55v10.9c0 .86.76 1.55 1.7 1.55h13.6c.94 0 1.7-.69 1.7-1.55V4.55C23 3.7 22.24 3 21.3 3M8 5h5v6H8V5m13 10H8v-2h13v2m0-4h-6V9h6v2m0-4h-6V5h6v2Z"/>'
        },
        "newspaper-variant-multiple-outline": {
            body: '<path fill="currentColor" d="M4 7v12h15v2H4c-2 0-2-2-2-2V7h2m17-2v10H8V5h13m.3-2H7.7C6.76 3 6 3.7 6 4.55v10.9c0 .86.76 1.55 1.7 1.55h13.6c.94 0 1.7-.69 1.7-1.55V4.55C23 3.7 22.24 3 21.3 3M9 6h3v5H9V6m11 8H9v-2h11v2m0-6h-6V6h6v2m0 3h-6V9h6v2Z"/>'
        },
        "newspaper-variant-outline": {
            body: '<path fill="currentColor" d="M20 5v14H4V5h16m0-2H4c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m-2 12H6v2h12v-2m-8-8H6v6h4V7m2 2h6V7h-6v2m6 2h-6v2h6v-2Z"/>'
        },
        nfc: {
            body: '<path fill="currentColor" d="M7.24 2c-1.64 0-3.28 0-3.69.04c-.88.05-1.47.69-1.51 1.52c-.04.81-.04 16.03 0 16.85c.05.82.67 1.45 1.51 1.5c.91.05 3.89.06 4.74.06c-1.53-1.06-1.74-3.05-1.88-6.74c-.08-2.19-.01-9.87 0-10.19l.04-2.1L14.5 11v2.5L8.09 7.11c-.01 1.27-.03 2.92-.03 4.43c0 1.46.02 2.8.06 3.51c.24 4.02.62 5.91 2.71 6.65c.67.23 1.24.3 2.24.3c.82 0 6.56 0 7.38-.04c.88-.05 1.48-.69 1.52-1.52c.03-.81.03-15.99 0-16.82c-.06-.82-.68-1.44-1.52-1.49c-.91-.05-3.88-.1-4.74-.1c1.53 1.06 1.73 3.05 1.88 6.75c.08 2.19.01 9.86 0 10.19l-.04 2.09L9.53 13v-2.5l6.38 6.39c.01-1.27.03-2.92.03-4.43c0-1.46-.02-2.8-.06-3.5c-.24-4.03-.62-5.92-2.71-6.66c-.64-.23-1.24-.3-2.24-.3H7.24Z"/>'
        },
        "nfc-off": {
            body: '<path d="M3.25 4.03l16.7 16.7L18.7 22l-3.84-3.87a.924.924 0 0 1-.27-.08a.827.827 0 0 1-.48-.67l-1.93-1.93c-.04.08-.09.15-.13.21c-.43.6-.86.6-1.19.38c-.32-.21-5.36-4.04-5.63-4.17c-.28-.11-.38.16-.11 1.63c.27 1.5-.17 1.89-.55 1.95c-.37.05-1.51-.27-1.57-3.31c-.05-3.03.76-3.52 1.14-3.52c.46 0 2.94 2.07 4.7 3.5L2 5.28l1.25-1.25m15.13 12.53c.37-1.16.74-2.76.72-4.53V12c.04-3.5-1.44-6.42-1.44-6.42s-.24-.86.46-1.19c.71-.33 1.18.22 1.18.22C21.12 8.22 21 11.64 21 12c0 .27.09 2.96-1.12 6.05l-1.5-1.49m-3.24-3.25c.05-.39.08-.81.1-1.28V12c-.1-3.5-1.11-4.79-1.11-4.79s-.24-.87.46-1.21c.71-.31 1.18.23 1.18.23c1.49 2.71 1.39 5.41 1.37 5.77c.01.2.06 1.38-.32 3l-1.68-1.69M10.2 8.38c.03-.61.39-.74.39-.74s.6-.27.98.16c.34.39 1.15 1.77 1.32 3.27L10.2 8.38z" fill="currentColor"/>',
            hidden: true
        },
        "nfc-search-variant": {
            body: '<path fill="currentColor" d="M16.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.24 1.71-.68 2.4L23.4 22L22 23.39l-3.11-3.07c-.69.43-1.51.68-2.39.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5c1.39 0 2.5-1.12 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M18 6v4.18c-.67-.18-1.34-.21-2-.18V8h-3v2.28l.53.44a6.465 6.465 0 0 0-2.81 2.81c-.44-.36-.72-.91-.72-1.53c0-.74.41-1.38 1-1.72V8a2 2 0 0 1 2-2h5M6 18V6h4v2H8v8h2c-.04.68 0 1.35.17 2H6M20 4H4v16h7c.53.8 1.21 1.5 2.03 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9.04c-.5-.8-1.18-1.5-2-2.04V4Z"/>'
        },
        "nfc-tap": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M4 4h7a2 2 0 0 1 2 2v3h-2V6H4v5h2V9l3 3l-3 3v-2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m16 16h-7a2 2 0 0 1-2-2v-3h2v3h7v-5h-2v2l-3-3l3-3v2h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2Z"/>'
        },
        "nfc-variant": {
            body: '<path fill="currentColor" d="M18 6h-5a2 2 0 0 0-2 2v2.28c-.59.34-1 .98-1 1.72a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12m2 2H4V4h16m0-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4c0-1.11-.89-2-2-2Z"/>'
        },
        "nfc-variant-off": {
            body: '<path fill="currentColor" d="m1.25 2.05l20.7 20.7L20.7 24l-2-2H4a2 2 0 0 1-2-2V5.3l-2-2l1.25-1.25M3.81 2H20c1.11 0 2 .89 2 2v16.19l-2-1.99V4H5.8L3.81 2M6 9.3l-2-2V20h12.7l-2-2H6V9.3m12 6.9l-2-2V8h-3v2.28c.6.34 1 .98 1 1.72v.19L11 9.2V8a2 2 0 0 1 2-2h5v10.2M8 16h4.7L8 11.3V16m2-8h-.2l-2-2H10v2Z"/>'
        },
        ninja: {
            body: '<path fill="currentColor" d="M7.75 13c-.01-.35.15-.69.42-.92c.75.16 1.45.47 2.08.92c0 .68-.56 1.24-1.25 1.24S7.76 13.69 7.75 13m6 0c.63-.44 1.33-.75 2.08-.91c.27.23.43.57.42.91c0 .7-.56 1.26-1.25 1.26s-1.25-.56-1.25-1.26M12 9c-2.77-.04-5.5.65-7.93 2L4 12c0 1.23.29 2.44.84 3.54a47.642 47.642 0 0 1 14.32 0c.55-1.1.84-2.31.84-3.54l-.07-1A15.849 15.849 0 0 0 12 9m0-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "nintendo-game-boy": {
            body: '<path fill="currentColor" d="M7 1c-1.1 0-2 .9-2 2v18a2 2 0 0 0 2 2h7c2.76 0 5-2.24 5-5V3a2 2 0 0 0-2-2H7m1 3h8v7H8V4m1 10h1v2h2v1h-2v2H9v-2H7v-1h2v-2m7 1c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-2 2c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        "nintendo-switch": {
            body: '<path fill="currentColor" d="M10.04 20.4H7.12c-.93 0-1.82-.4-2.48-1.04C4 18.7 3.6 17.81 3.6 16.88V7.12c0-.93.4-1.82 1.04-2.48C5.3 4 6.19 3.62 7.12 3.62h2.92V20.4M7.12 2A5.12 5.12 0 0 0 2 7.12v9.76C2 19.71 4.29 22 7.12 22h4.53V2H7.12M5.11 8c0 1.04.84 1.88 1.89 1.88c1.03 0 1.87-.84 1.87-1.88S8.03 6.12 7 6.12c-1.05 0-1.89.84-1.89 1.88m12.5 3c1.11 0 2.01.89 2.01 2c0 1.12-.9 2-2.01 2c-1.11 0-2.03-.88-2.03-2c0-1.11.92-2 2.03-2m-.73 11A5.12 5.12 0 0 0 22 16.88V7.12C22 4.29 19.71 2 16.88 2h-3.23v20h3.23Z"/>'
        },
        "nintendo-wii": {
            body: '<path fill="currentColor" d="M17.84 16.94h-1.87v-6.15h1.87v6.15M18 8.58c0 .61-.5 1.11-1.1 1.11a1.11 1.11 0 0 1-1.11-1.11c0-.62.5-1.12 1.11-1.12c.6 0 1.1.5 1.1 1.12m3.82 8.36h-1.88v-6.15h1.88v6.15M22 8.58c0 .61-.5 1.11-1.12 1.11a1.11 1.11 0 0 1-1.11-1.11a1.116 1.116 0 1 1 2.23 0m-9.1-.53h2l-2.12 7.45s-.28 1.54-1.5 1.54c-1.21 0-1.49-1.54-1.49-1.54l-1.34-4.86l-1.34 4.86s-.29 1.54-1.5 1.54s-1.49-1.54-1.49-1.54L2 8.05h2l1.72 6.62L7.11 9.3c.32-1.35 1.34-1.33 1.34-1.33s1.02-.02 1.34 1.33l1.38 5.37l1.73-6.62Z"/>'
        },
        "nintendo-wiiu": {
            body: '<path fill="currentColor" d="M2 15.96c0 2.23 1.54 3.54 3.79 3.54h12.78c1.9 0 3.43-1.3 3.43-3.18V6.97c0-1.14-.85-2.37-1.89-2.37h-2.96v7.7c0 5.84-10.18 5.79-10.18.11V4.5H4.72C3.26 4.5 2 5.41 2 6.85v9.11m7.34-4.73c0 4.51 5.32 3.86 5.32.71V4.5H9.34v6.73Z"/>'
        },
        nix: {
            body: '<path fill="currentColor" d="M9.9 8.7L5 17.2l-1.1-1.9L5.2 13H2.6L2 12l.6-1h3.7l1.3-2.3h2.3m.3 6.8h9.7l-1.1 1.9h-2.6l1.3 2.3l-.6 1h-1.1L14 17.4h-2.7l-1.1-1.9m5.7-3.7L11 3.3h2.2l1.3 2.3l1.3-2.3h1.1l.6 1l-1.9 3.2L17 9.8l-1.1 2m-2.1-3.3H4l1.1-1.9h2.6L6.4 4.3l.6-1h1.1L10 6.5h2.7l1.1 2m.3 6.8L19 6.8l1.1 1.9l-1.3 2.3h2.6l.6 1l-.6 1h-3.7l-1.3 2.3h-2.3m-6-3.1l4.9 8.4h-2.2l-1.3-2.3l-1.1 2.3H7.1l-.6-1l1.9-3.2L7 14.2l1.1-2Z"/>'
        },
        nodejs: {
            body: '<path fill="currentColor" d="M12 1.85c-.27 0-.55.07-.78.2l-7.44 4.3c-.48.28-.78.8-.78 1.36v8.58c0 .56.3 1.08.78 1.36l1.95 1.12c.95.46 1.27.47 1.71.47c1.4 0 2.21-.85 2.21-2.33V8.44c0-.12-.1-.22-.22-.22H8.5c-.13 0-.23.1-.23.22v8.47c0 .66-.68 1.31-1.77.76L4.45 16.5a.26.26 0 0 1-.11-.21V7.71c0-.09.04-.17.11-.21l7.44-4.29c.06-.04.16-.04.22 0l7.44 4.29c.07.04.11.12.11.21v8.58c0 .08-.04.16-.11.21l-7.44 4.29c-.06.04-.16.04-.23 0L10 19.65c-.08-.03-.16-.04-.21-.01c-.53.3-.63.36-1.12.51c-.12.04-.31.11.07.32l2.48 1.47c.24.14.5.21.78.21s.54-.07.78-.21l7.44-4.29c.48-.28.78-.8.78-1.36V7.71c0-.56-.3-1.08-.78-1.36l-7.44-4.3c-.23-.13-.5-.2-.78-.2M14 8c-2.12 0-3.39.89-3.39 2.39c0 1.61 1.26 2.08 3.3 2.28c2.43.24 2.62.6 2.62 1.08c0 .83-.67 1.18-2.23 1.18c-1.98 0-2.4-.49-2.55-1.47a.226.226 0 0 0-.22-.18h-.96c-.12 0-.21.09-.21.22c0 1.24.68 2.74 3.94 2.74c2.35 0 3.7-.93 3.7-2.55c0-1.61-1.08-2.03-3.37-2.34c-2.31-.3-2.54-.46-2.54-1c0-.45.2-1.05 1.91-1.05c1.5 0 2.09.33 2.32 1.36c.02.1.11.17.21.17h.97c.05 0 .11-.02.15-.07c.04-.04.07-.1.05-.16C17.56 8.82 16.38 8 14 8Z"/>'
        },
        noodles: {
            body: '<path fill="currentColor" d="M22 3L10 4.41V6h12v1H10v5h12c0 1.81-.57 3.46-1.68 4.95s-2.55 2.58-4.32 3.3V22H8v-1.75c-1.76-.72-3.21-1.82-4.32-3.3S2 13.81 2 12h3V4l17-2v1M6 4.88V6h1V4.78l-1 .1M6 7v5h1V7H6m3 5V7H8v5h1m0-6V4.55l-1 .09V6h1Z"/>'
        },
        "not-equal": {
            body: '<path fill="currentColor" d="M21 10H9V8h12v2m0 6H9v-2h12v2M4 5h2v11H4V5m2 13v2H4v-2h2Z"/>'
        },
        "not-equal-variant": {
            body: '<path fill="currentColor" d="m14.08 4.61l1.84.79L14.8 8H19v2h-5.05l-1.72 4H19v2h-7.62l-1.46 3.4l-1.84-.79L9.2 16H5v-2h5.06l1.71-4H5V8h7.63l1.45-3.39Z"/>'
        },
        note: {
            body: '<path fill="currentColor" d="M14 10V4.5l5.5 5.5M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9l-6-6H5Z"/>'
        },
        "note-alert": {
            body: '<path fill="currentColor" d="M3 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V9l-6-6H3m9 7V4.5l5.5 5.5H12m11-3v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "note-alert-outline": {
            body: '<path fill="currentColor" d="M3 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V9l-6-6H3m14 16H3V5h7v7h7v7m-5-9V4.5l5.5 5.5H12m11-3v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "note-check": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6m-5-8.5l5.5 5.5H14V4.5m8.5 12.75L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "note-check-outline": {
            body: '<path fill="currentColor" d="M5 19V5h7v7h7v1c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2H5m9-14.5l5.5 5.5H14V4.5m8.5 12.75L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "note-edit": {
            body: '<path fill="currentColor" d="M21 10V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h6v-1.87l8.39-8.39c.44-.44 1-.68 1.61-.74m-7-5.5l5.5 5.5H14V4.5m8.85 9.69l-.98.98l-2.04-2.04l.98-.98c.19-.2.52-.2.72 0l1.32 1.32c.2.2.2.53 0 .72m-3.72-.36l2.04 2.04L15.04 22H13v-2.04l6.13-6.13Z"/>'
        },
        "note-edit-outline": {
            body: '<path fill="currentColor" d="m18.13 12l1.26-1.26c.44-.44 1-.68 1.61-.74V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h6v-1.87l.13-.13H5V5h7v7h6.13M14 4.5l5.5 5.5H14V4.5m5.13 9.33l2.04 2.04L15.04 22H13v-2.04l6.13-6.13m3.72.36l-.98.98l-2.04-2.04l.98-.98c.19-.2.52-.2.72 0l1.32 1.32c.2.2.2.53 0 .72Z"/>'
        },
        "note-minus": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6m-5-8.5l5.5 5.5H14V4.5M23 18v2h-8v-2h8Z"/>'
        },
        "note-minus-outline": {
            body: '<path fill="currentColor" d="M23 18v2h-8v-2h8m-10 1c0 .7.13 1.37.35 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h10l6 6v4.35c-.63-.22-1.3-.35-2-.35v-1h-7V5H5v14h8m1-9h5.5L14 4.5V10Z"/>'
        },
        "note-multiple": {
            body: '<path fill="currentColor" d="M16 9h5.5L16 3.5V9M7 2h10l6 6v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2M3 6v16h18v2H3a2 2 0 0 1-2-2V6h2Z"/>'
        },
        "note-multiple-outline": {
            body: '<path fill="currentColor" d="M3 6v16h18v2H3a2 2 0 0 1-2-2V6h2m13 3h5.5L16 3.5V9M7 2h10l6 6v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v14h14v-7h-7V4H7Z"/>'
        },
        "note-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27L20.7 20.04v.01l1.41 1.41M21 17.8L6.2 3H15l6 6v8.8M19.5 10L14 4.5V10h5.5Z"/>'
        },
        "note-off-outline": {
            body: '<path fill="currentColor" d="M12 5v3.8l3.2 3.2H19v3.8l2 2V9l-6-6H6.2l2 2H12m2-.5l5.5 5.5H14V4.5m6.7 15.55v-.01l-1.7-1.7v.01L12.66 12l-.66-.66v.01L6.14 5.5L2.39 1.73L1.11 3L3 4.9V19a2 2 0 0 0 2 2h14.1l1.74 1.73l1.27-1.27l-1.41-1.41M5 19V6.89L17.11 19H5Z"/>'
        },
        "note-outline": {
            body: '<path fill="currentColor" d="M14 10h5.5L14 4.5V10M5 3h10l6 6v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2m0 2v14h14v-7h-7V5H5Z"/>'
        },
        "note-plus": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6m-5-8.5l5.5 5.5H14V4.5M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "note-plus-outline": {
            body: '<path fill="currentColor" d="M5 19V5h7v7h7v1c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2H5m9-14.5l5.5 5.5H14V4.5M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "note-remove": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2c0-3.31 2.69-6 6-6m-5-8.5l5.5 5.5H14V4.5M20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "note-remove-outline": {
            body: '<path fill="currentColor" d="M5 19V5h7v7h7v1c.7 0 1.37.13 2 .35V9l-6-6H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h8.35c-.22-.63-.35-1.3-.35-2H5m9-14.5l5.5 5.5H14V4.5M20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "note-search": {
            body: '<path fill="currentColor" d="M15 3H5c-1.11 0-2 .89-2 2v5.82a6.505 6.505 0 0 1 9.1.08a6.525 6.525 0 0 1 0 9.2c-.36.35-.75.64-1.16.9H19c1.11 0 2-.89 2-2V9l-6-6m-1 7V4.5l5.5 5.5H14m-6.5 1C5 11 3 13 3 15.5c0 .88.25 1.71.69 2.4L.61 21L2 22.39l3.12-3.07c.69.43 1.51.68 2.38.68c2.5 0 4.5-2 4.5-4.5S10 11 7.5 11m0 7a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "note-search-outline": {
            body: '<path fill="currentColor" d="M15 3H5c-1.11 0-2 .89-2 2v5.82A6.44 6.44 0 0 1 5 9.5V5h7v5.82c.03.03.07.05.1.08c.34.34.63.71.87 1.1H19v7h-6.03c-.24.39-.53.76-.87 1.1c-.36.35-.75.64-1.16.9H19c1.11 0 2-.89 2-2V9l-6-6m-1 7V4.5l5.5 5.5H14m-6.5 1C5 11 3 13 3 15.5c0 .88.25 1.71.69 2.4L.61 21L2 22.39l3.12-3.07c.69.43 1.51.68 2.38.68c2.5 0 4.5-2 4.5-4.5S10 11 7.5 11m0 7a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "note-text": {
            body: '<path fill="currentColor" d="M14 10h5.5L14 4.5V10M5 3h10l6 6v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2m0 9v2h14v-2H5m0 4v2h9v-2H5Z"/>'
        },
        "note-text-outline": {
            body: '<path fill="currentColor" d="M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9l-6-6m4 16H5V5h9v5h5m-2 4H7v-2h10m-3 5H7v-2h7"/>'
        },
        notebook: {
            body: '<path fill="currentColor" d="M3 7V5h2V4a2 2 0 0 1 2-2h6v7l2.5-1.5L18 9V2h1c1.05 0 2 .95 2 2v16c0 1.05-.95 2-2 2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3m4 4H5v2h2v-2m0-4V5H5v2h2m0 12v-2H5v2h2Z"/>'
        },
        "notebook-check": {
            body: '<path fill="currentColor" d="m16.75 22.16l-2.75-3L15.16 18l1.59 1.59L20.34 16l1.16 1.41l-4.75 4.75M3 7V5h2V4a2 2 0 0 1 2-2h6v7l2.5-1.5L18 9V2h1c1.05 0 2 .95 2 2v9.8a6.005 6.005 0 0 0-8.2 8.2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2Z"/>'
        },
        "notebook-check-outline": {
            body: '<path fill="currentColor" d="m16.75 22.16l-2.75-3L15.16 18l1.59 1.59L20.34 16l1.16 1.41l-4.75 4.75M17 4v6l-2-2l-2 2V4H9v16h3.08c.12.72.37 1.39.72 2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4a2 2 0 0 1 2-2h12c1.05 0 2 .95 2 2v9.8c-.61-.35-1.28-.6-2-.72V4h-2M5 19h2v-2H5v2m0-6h2v-2H5v2m0-6h2V5H5v2Z"/>'
        },
        "notebook-edit": {
            body: '<path fill="currentColor" d="M21.04 13.13c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17m-1.97 1.75l2.05 2.05L15.06 23H13v-2.06l6.07-6.06M3 7V5h2V4a2 2 0 0 1 2-2h6v7l2.5-1.5L18 9V2h1c1.05 0 2 .95 2 2v6L11 20v2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2 0h2V5H5v2m0 4v2h2v-2H5m0 6v2h2v-2H5Z"/>'
        },
        "notebook-edit-outline": {
            body: '<path fill="currentColor" d="m19.07 14.88l2.05 2.05L15.06 23H13v-2.06l6.07-6.06m1.97-1.75c.14 0 .27.06.38.17l1.28 1.28c.22.21.22.56 0 .77l-1 1l-2.05-2.05l1-1c.11-.11.25-.17.39-.17M17 4v6l-2-2l-2 2V4H9v16h2v2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4a2 2 0 0 1 2-2h12c1.05 0 2 .95 2 2v6l-2 2V4h-2M5 5v2h2V5H5m0 6v2h2v-2H5m0 6v2h2v-2H5Z"/>'
        },
        "notebook-heart": {
            body: '<path fill="currentColor" d="m19 23.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M3 7V5h2V4a2 2 0 0 1 2-2h6v7l2.5-1.5L18 9V2h1c1.05 0 2 .95 2 2v9.34A6.005 6.005 0 0 0 13.8 22H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2Z"/>'
        },
        "notebook-heart-outline": {
            body: '<path fill="currentColor" d="m19 23.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M17 4v6l-2-2l-2 2V4H9v16h4.08c.12.72.37 1.39.72 2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4a2 2 0 0 1 2-2h12c1.05 0 2 .95 2 2v9.34c-.63-.22-1.3-.34-2-.34V4h-2M5 19h2v-2H5v2m0-6h2v-2H5v2m0-6h2V5H5v2Z"/>'
        },
        "notebook-minus": {
            body: '<path fill="currentColor" d="M3 7V5h2V4c0-1.1.9-2 2-2h6v7l2.5-1.5L18 9V2h1c1 0 2 1 2 2v9.8c-.9-.5-1.9-.8-3-.8c-3.3 0-6 2.7-6 6c0 1.1.3 2.1.8 3H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2m9 5v2h8v-2h-8Z"/>'
        },
        "notebook-minus-outline": {
            body: '<path fill="currentColor" d="M17 4v6l-2-2l-2 2V4H9v16h3.1c.1.7.4 1.4.7 2H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4c0-1.1.9-2 2-2h12c1 0 2 1 2 2v9.8c-.6-.4-1.3-.6-2-.7V4h-2M5 19h2v-2H5v2m0-6h2v-2H5v2m0-6h2V5H5v2m9 11v2h8v-2h-8Z"/>'
        },
        "notebook-multiple": {
            body: '<path fill="currentColor" d="M9.05 9H7.06V6h1.99V4.03H7.06v-1c0-1.11.89-1.99 1.99-1.99h5.98V8l2.47-1.5L20 8V1.04h1c1.05 0 2 .96 2 1.99V17c0 1.03-.95 2-2 2H9.05c-1.05 0-1.99-.95-1.99-2v-1h1.99v-2H7.06v-3h1.99V9M1 18h2v-3H1v-2h2v-3H1V8h2V5h2v3H3v2h2v3H3v2h2v3H3v2h2v1h16v2H5a2 2 0 0 1-2-2v-1H1v-2Z"/>'
        },
        "notebook-outline": {
            body: '<path fill="currentColor" d="M17 4v6l-2-2l-2 2V4H9v16h10V4h-2M3 7V5h2V4a2 2 0 0 1 2-2h12c1.05 0 2 .95 2 2v16c0 1.05-.95 2-2 2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2Z"/>'
        },
        "notebook-plus": {
            body: '<path fill="currentColor" d="M3 7V5h2V4c0-1.1.9-2 2-2h6v7l2.5-1.5L18 9V2h1c1 0 2 1 2 2v9.8c-.9-.5-1.9-.8-3-.8c-3.3 0-6 2.7-6 6c0 1.1.3 2.1.8 3H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2m12 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "notebook-plus-outline": {
            body: '<path fill="currentColor" d="M17 4v6l-2-2l-2 2V4H9v16h3.1c.1.7.4 1.4.7 2H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4c0-1.1.9-2 2-2h12c1 0 2 1 2 2v9.8c-.6-.4-1.3-.6-2-.7V4h-2M5 19h2v-2H5v2m0-6h2v-2H5v2m0-6h2V5H5v2m12 8v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "notebook-remove": {
            body: '<path fill="currentColor" d="M3 7V5h2V4c0-1.1.9-2 2-2h6v7l2.5-1.5L18 9V2h1c1 0 2 1 2 2v9.8c-.9-.5-1.9-.8-3-.8c-3.3 0-6 2.7-6 6c0 1.1.3 2.1.8 3H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3m2-2v2h2V5H5m0 14h2v-2H5v2m0-6h2v-2H5v2m15.1 2.5L18 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "notebook-remove-outline": {
            body: '<path fill="currentColor" d="M17 4v6l-2-2l-2 2V4H9v16h3.1c.1.7.4 1.4.7 2H7c-1.1 0-2-1-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5h2V4c0-1.1.9-2 2-2h12c1 0 2 1 2 2v9.8c-.6-.4-1.3-.6-2-.7V4h-2M5 19h2v-2H5v2m0-6h2v-2H5v2m0-6h2V5H5v2m15.1 8.5L18 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "notification-clear-all": {
            body: '<path fill="currentColor" d="M5 13h14v-2H5m-2 6h14v-2H3m4-8v2h14V7"/>'
        },
        npm: {
            body: '<path fill="currentColor" d="M4 10v4h2v-3h1v3h1v-4H4m5 0v5h2v-1h2v-4H9m3 1v2h-1v-2h1m2-1v4h2v-3h1v3h1v-3h1v3h1v-4h-6M3 9h18v6h-9v1H8v-1H3V9Z"/>'
        },
        "npm-variant": {
            body: '<path d="M20 4H4v16h8V8h4v12h4V4" fill="currentColor"/>',
            hidden: true
        },
        "npm-variant-outline": {
            body: '<path d="M3 3v18h18V3H3m3 3h12v12h-3V9h-3v9H6V6z" fill="currentColor"/>',
            hidden: true
        },
        nuke: {
            body: '<path fill="currentColor" d="M14.04 12H10v-1H5.5A3.5 3.5 0 0 1 2 7.5A3.5 3.5 0 0 1 5.5 4c1.03 0 1.95.44 2.59 1.15C8.5 3.35 10.08 2 12 2c1.92 0 3.5 1.35 3.91 3.15C16.55 4.44 17.47 4 18.5 4A3.5 3.5 0 0 1 22 7.5a3.5 3.5 0 0 1-3.5 3.5h-4.46v1M10 16.9v-1.14H5v-2h14v2h-4.96v1.16L20 19.08c.58.21 1 .76 1 1.42a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 20.5c0-.66.42-1.21 1-1.42l6-2.18Z"/>'
        },
        null: {
            body: '<path fill="currentColor" d="M12 2c1.85 0 3.55.78 4.9 2.1l1.7-2.17l1.58 1.23l-1.98 2.52C19.33 7.41 20 9.6 20 12c0 5.5-3.58 10-8 10c-1.85 0-3.55-.78-4.9-2.1l-1.7 2.17l-1.58-1.23l1.98-2.52C4.67 16.59 4 14.4 4 12C4 6.5 7.58 2 12 2m0 2c-3.31 0-6 3.58-6 8c0 1.73.41 3.33 1.11 4.64l8.56-10.97C14.66 4.62 13.38 4 12 4m0 16c3.31 0 6-3.58 6-8c0-1.73-.41-3.33-1.11-4.64L8.33 18.33C9.34 19.38 10.62 20 12 20Z"/>'
        },
        numeric: {
            body: '<path fill="currentColor" d="M4 17V9H2V7h4v10H4m18-2a2 2 0 0 1-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5V15m-8 0v2H8v-4a2 2 0 0 1 2-2h2V9H8V7h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4Z"/>'
        },
        "numeric-0": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "numeric-0-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-8 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "numeric-0-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14m-8 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2m0 2h2v6h-2V7Z"/>'
        },
        "numeric-0-box-multiple-outline": {
            body: '<path fill="currentColor" d="M21 17V3H7v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m10 0h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m0 2v6h2V7h-2Z"/>'
        },
        "numeric-0-box-outline": {
            body: '<path fill="currentColor" d="M19 19V5H5v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-8 4h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2Z"/>'
        },
        "numeric-0-circle": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m0 2h2v6h-2V9m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-0-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2m1-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-1": {
            body: '<path fill="currentColor" d="M10 7v2h2v8h2V7h-4Z"/>'
        },
        "numeric-1-box": {
            body: '<path fill="currentColor" d="M14 17h-2V9h-2V7h4m5-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-1-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14m-7 14h2V5h-4v2h2v8Z"/>'
        },
        "numeric-1-box-multiple-outline": {
            body: '<path fill="currentColor" d="M21 17H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m-7 14h2V5h-4v2h2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-1-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 14h2V7h-4v2h2"/>'
        },
        "numeric-1-circle": {
            body: '<path fill="currentColor" d="M10 7v2h2v8h2V7h-4m2-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-1-circle-outline": {
            body: '<path fill="currentColor" d="M10 7h4v10h-2V9h-2V7m2-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-10": {
            body: '<path fill="currentColor" d="M10 7H6v2h2v8h2V7m6 0h-2c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9a2 2 0 0 0-2-2m0 8h-2V9h2v6Z"/>'
        },
        "numeric-10-box": {
            body: '<path fill="currentColor" d="M14 9h2v6h-2V9m7-4v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2M10 7H6v2h2v8h2V7m8 2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9Z"/>'
        },
        "numeric-10-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m13 8h2V7h-2v6m5-12H7c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V3a2 2 0 0 0-2-2m-9 14h-2V7H8V5h4v10m8-2c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v6Z"/>'
        },
        "numeric-10-box-multiple-outline": {
            body: '<path fill="currentColor" d="M21 17V3H7v14h14m0-16a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2h14M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m9 0H8v2h2v8h2V5m6 0h-2c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V7a2 2 0 0 0-2-2m0 8h-2V7h2v6Z"/>'
        },
        "numeric-10-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2M8 17h2V7H6v2h2m6-2h2a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 2v6h2V9h-2Z"/>'
        },
        "numeric-10-circle": {
            body: '<path fill="currentColor" d="M14 9h2v6h-2V9m8 3c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10M10 7H6v2h2v8h2V7m8 2a2 2 0 0 0-2-2h-2c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9Z"/>'
        },
        "numeric-10-circle-outline": {
            body: '<path fill="currentColor" d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m-2 3H6v2h2v8h2V7m6 0h-2c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V9a2 2 0 0 0-2-2m0 8h-2V9h2v6Z"/>'
        },
        "numeric-2": {
            body: '<path fill="currentColor" d="M9 7v2h4v2h-2a2 2 0 0 0-2 2v4h6v-2h-4v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9Z"/>'
        },
        "numeric-2-box": {
            body: '<path fill="currentColor" d="M15 11a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2V9H9V7h4a2 2 0 0 1 2 2m4-6H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-2-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m14 8h-4v-2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v2h4v2h-2a2 2 0 0 0-2 2v4h6v-2m4-12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14Z"/>'
        },
        "numeric-2-box-multiple-outline": {
            body: '<path fill="currentColor" d="M17 13h-4v-2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v2h4v2h-2a2 2 0 0 0-2 2v4h6m4 2H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-2-box-outline": {
            body: '<path fill="currentColor" d="M15 15h-4v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9v2h4v2h-2a2 2 0 0 0-2 2v4h6m4 2H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-2-circle": {
            body: '<path fill="currentColor" d="M9 7v2h4v2h-2a2 2 0 0 0-2 2v4h6v-2h-4v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-2-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2V9H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-3": {
            body: '<path fill="currentColor" d="M15 15v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 0 0 2-2"/>'
        },
        "numeric-3-box": {
            body: '<path fill="currentColor" d="M15 10.5a1.5 1.5 0 0 1-1.5 1.5c.84 0 1.5.67 1.5 1.5V15c0 1.11-.89 2-2 2H9v-2h4v-2h-2v-2h2V9H9V7h4c1.11 0 2 .89 2 2m4-6H5c-1.09 0-2 .9-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-3-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m14 8v-1.5a1.5 1.5 0 0 0-1.5-1.5A1.5 1.5 0 0 0 17 8.5V7a2 2 0 0 0-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 0 0 2-2m4-12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14Z"/>'
        },
        "numeric-3-box-multiple-outline": {
            body: '<path fill="currentColor" d="M17 13v-1.5a1.5 1.5 0 0 0-1.5-1.5A1.5 1.5 0 0 0 17 8.5V7a2 2 0 0 0-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 0 0 2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3m18-4H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-3-box-outline": {
            body: '<path fill="currentColor" d="M15 15v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 0 0 2-2m4 4H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-3-circle": {
            body: '<path fill="currentColor" d="M15 15v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 0 0 2-2M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-3-circle-outline": {
            body: '<path fill="currentColor" d="M15 15a2 2 0 0 1-2 2H9v-2h4v-2h-2v-2h2V9H9V7h4a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5V15M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-4": {
            body: '<path fill="currentColor" d="M9 7v6h4v4h2V7h-2v4h-2V7H9Z"/>'
        },
        "numeric-4-box": {
            body: '<path fill="currentColor" d="M15 17h-2v-4H9V7h2v4h2V7h2m4-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-4-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14m-6 14h2V5h-2v4h-2V5h-2v6h4v4Z"/>'
        },
        "numeric-4-box-multiple-outline": {
            body: '<path fill="currentColor" d="M21 17H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m-6 14h2V5h-2v4h-2V5h-2v6h4M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-4-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-6 14h2V7h-2v4h-2V7H9v6h4"/>'
        },
        "numeric-4-circle": {
            body: '<path fill="currentColor" d="M9 7v6h4v4h2V7h-2v4h-2V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-4-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h2v4h2V7h2v10h-2v-4H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-5": {
            body: '<path fill="currentColor" d="M9 7v6h4v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7H9Z"/>'
        },
        "numeric-5-box": {
            body: '<path fill="currentColor" d="M15 9h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H9v-2h4v-2H9V7h6m4-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-5-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14m-4 12v-2a2 2 0 0 0-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 0 0 2-2Z"/>'
        },
        "numeric-5-box-multiple-outline": {
            body: '<path fill="currentColor" d="M17 13v-2a2 2 0 0 0-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 0 0 2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3m18-4H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-5-box-outline": {
            body: '<path fill="currentColor" d="M15 15v-2a2 2 0 0 0-2-2h-2V9h4V7H9v6h4v2H9v2h4a2 2 0 0 0 2-2m4 4H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-5-circle": {
            body: '<path fill="currentColor" d="M9 7v6h4v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7H9m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-5-circle-outline": {
            body: '<path fill="currentColor" d="M9 7h6v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H9v-2h4v-2H9V7m3-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-6": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4m0 6h2v2h-2v-2Z"/>'
        },
        "numeric-6-box": {
            body: '<path fill="currentColor" d="M15 9h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h4m4-4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8 12h2v-2h-2v2Z"/>'
        },
        "numeric-6-box-multiple": {
            body: '<path fill="currentColor" d="M13 11h2v2h-2v-2M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14m-8 14h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V7h4V5h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2Z"/>'
        },
        "numeric-6-box-multiple-outline": {
            body: '<path fill="currentColor" d="M13 11h2v2h-2m0 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V7h4V5h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2m8 2H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-6-box-outline": {
            body: '<path fill="currentColor" d="M11 13h2v2h-2m0 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2m8 2H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-6-circle": {
            body: '<path fill="currentColor" d="M11 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4m0 6h2v2h-2v-2m1-11a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-6-circle-outline": {
            body: '<path fill="currentColor" d="M11 7h4v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2m0 6v2h2v-2h-2m1-11a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-7": {
            body: '<path fill="currentColor" d="m11 17l4-8V7H9v2h4l-4 8"/>'
        },
        "numeric-7-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-8 14l4-8V7H9v2h4l-4 8h2Z"/>'
        },
        "numeric-7-box-multiple": {
            body: '<path fill="currentColor" d="M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m10 10l4-8V5h-6v2h4l-4 8h2m8-14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14Z"/>'
        },
        "numeric-7-box-multiple-outline": {
            body: '<path fill="currentColor" d="m13 15l4-8V5h-6v2h4l-4 8m10 2H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-7-box-outline": {
            body: '<path fill="currentColor" d="m11 17l4-8V7H9v2h4l-4 8m10 2H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-7-circle": {
            body: '<path fill="currentColor" d="m11 17l4-8V7H9v2h4l-4 8h2m1-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-7-circle-outline": {
            body: '<path fill="currentColor" d="M11 17H9l4-8H9V7h6v2l-4 8m1-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-8": {
            body: '<path fill="currentColor" d="M11 13h2v2h-2m0-6h2v2h-2m0 6h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 9 13.5V15a2 2 0 0 0 2 2"/>'
        },
        "numeric-8-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-8 14h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 9 13.5V15a2 2 0 0 0 2 2m0-4h2v2h-2v-2m0-4h2v2h-2V9Z"/>'
        },
        "numeric-8-box-multiple": {
            body: '<path fill="currentColor" d="M13 11h2v2h-2v-2m0-4h2v2h-2V7M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m10 10h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5A1.5 1.5 0 0 0 17 8.5V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0-1.5 1.5V13a2 2 0 0 0 2 2m8-14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14Z"/>'
        },
        "numeric-8-box-multiple-outline": {
            body: '<path fill="currentColor" d="M13 11h2v2h-2m0-6h2v2h-2m0 6h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5A1.5 1.5 0 0 0 17 8.5V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0-1.5 1.5V13a2 2 0 0 0 2 2m8 2H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-8-box-outline": {
            body: '<path fill="currentColor" d="M11 13h2v2h-2m0-6h2v2h-2m0 6h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 9 13.5V15a2 2 0 0 0 2 2m8 2H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-8-circle": {
            body: '<path fill="currentColor" d="M11 13h2v2h-2v-2m0-4h2v2h-2V9m0 8h2a2 2 0 0 0 2-2v-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0 1.5-1.5V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 9 13.5V15a2 2 0 0 0 2 2m1-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-8-circle-outline": {
            body: '<path fill="currentColor" d="M11 13v2h2v-2h-2m0-4v2h2V9h-2m0 8a2 2 0 0 1-2-2v-1.5a1.5 1.5 0 0 1 1.5-1.5A1.5 1.5 0 0 1 9 10.5V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5V15a2 2 0 0 1-2 2h-2m1-15a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-9": {
            body: '<path fill="currentColor" d="M13 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4m0-6h-2V9h2v2Z"/>'
        },
        "numeric-9-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-6 8h-2V9h2v2m0-4h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-9-box-multiple": {
            body: '<path fill="currentColor" d="M15 9h-2V7h2v2M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m12 0h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m6-4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14Z"/>'
        },
        "numeric-9-box-multiple-outline": {
            body: '<path fill="currentColor" d="M15 9h-2V7h2m0-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m6 12H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-9-box-outline": {
            body: '<path fill="currentColor" d="M13 11h-2V9h2m0-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m6 12H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "numeric-9-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m1 15a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4m0-6h-2V9h2v2Z"/>'
        },
        "numeric-9-circle-outline": {
            body: '<path fill="currentColor" d="M13 17H9v-2h4v-2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2m0-6V9h-2v2h2m-1-9a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-9-plus": {
            body: '<path fill="currentColor" d="M19 11h-2V9h-2v2h-2v2h2v2h2v-2h2v-2m-9-4H8c-1.1 0-2 .9-2 2v2a2 2 0 0 0 2 2h2v2H6v2h4c1.11 0 2-.89 2-2V9a2 2 0 0 0-2-2m0 4H8V9h2v2Z"/>'
        },
        "numeric-9-plus-box": {
            body: '<path fill="currentColor" d="M21 5v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-2 6h-2V9h-2v2h-2v2h2v2h2v-2h2v-2m-9-4H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H6v2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M8 9h2v2H8V9Z"/>'
        },
        "numeric-9-plus-box-multiple": {
            body: '<path fill="currentColor" d="M11 9V8h1v1h-1m10-8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m12 4v2h2v2h2v-2h2V9h-2V7h-2v2h-2m-1 3V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H9v2h3a2 2 0 0 0 2-2Z"/>'
        },
        "numeric-9-plus-box-multiple-outline": {
            body: '<path fill="currentColor" d="M21 9h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14m0-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2M11 9V8h1v1m2 3V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H9v2h3a2 2 0 0 0 2-2M3 5H1v16a2 2 0 0 0 2 2h16v-2H3V5Z"/>'
        },
        "numeric-9-plus-box-outline": {
            body: '<path fill="currentColor" d="M19 11h-2V9h-2v2h-2v2h2v2h2v-2h2v6H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M9 11v-1h1v1m2 3v-4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H7v2h3a2 2 0 0 0 2-2Z"/>'
        },
        "numeric-9-plus-circle": {
            body: '<path fill="currentColor" d="M19 11h-2V9h-2v2h-2v2h2v2h2v-2h2v-2m-9-4H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H6v2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M8 9h2v2H8V9m4-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"/>'
        },
        "numeric-9-plus-circle-outline": {
            body: '<path fill="currentColor" d="M19 11v2h-2v2h-2v-2h-2v-2h2V9h2v2h2m-9-4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6v-2h4v-2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2M8 9v2h2V9H8m4-7a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "numeric-negative-1": {
            body: '<path fill="currentColor" d="M13 7v2h2v8h2V7h-4m-2 6H5v-2h6v2Z"/>'
        },
        "numeric-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4 4H2v2h2v8h2V7.9l3.3 3.3c-.8.2-1.3 1-1.3 1.8v4h6v-1.1l6.8 6.8l1.3-1.2M10 15v-2h1.1l2 2H10m4-4.2L10.2 7H12c1.1 0 2 .9 2 2v1.8M20 9h-4V7h4c1.1 0 2 .9 2 2v1.5c0 .8-.7 1.5-1.5 1.5c.8 0 1.5.7 1.5 1.5V15c0 1-.8 1.9-1.8 2l-2-2H20v-2h-2v-2h2V9Z"/>'
        },
        "numeric-positive-1": {
            body: '<path fill="currentColor" d="M13 7v2h2v8h2V7h-4m-2 6H9v2H7v-2H5v-2h2V9h2v2h2v2Z"/>'
        },
        nut: {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        nutrition: {
            body: '<path fill="currentColor" d="M22 18a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4v-2h12v2M4 3h10a2 2 0 0 1 2 2v9H8v5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 3v2h2V6H4m10 2V6H8v2h6M4 10v2h2v-2H4m4 0v2h6v-2H8m-4 4v2h2v-2H4Z"/>'
        },
        nuxt: {
            body: '<path fill="currentColor" d="M21.8 18.36L16.03 8.08c-.1-.08-.4-.65-1-.65c-.25 0-.6.1-.96.65l-.74 1.18l-2.02-3.61c-.05-.1-.4-.65-1-.65c-.25 0-.65.1-.95.65L2.18 18.31c-.05.1-.35.69-.05 1.19c.1.25.4.5 1.06.5h17.66c.1 0 .75 0 1.05-.5c.1-.24.2-.64-.1-1.14m-13.7-.05l-.15.55H3.24l7.12-12.52l2.3 4.13l-4.56 7.84m1.11.55l4.11-7.2l4.18 7.2H9.21m9.53 0l-.2-.55L14 10.46l1.03-1.73l5.72 10.13h-2.01Z"/>'
        },
        oar: {
            body: '<path fill="currentColor" d="M20.23 15.21c-1.46-1.46-5.26-5.01-7.46-3.94L4.5 3L3 4.5l8.28 8.29c-.98 2.21 2.6 5.83 4.07 7.29c1.76 1.76 2.91.84 4.26-.51c1.49-1.49 2-2.96.62-4.36Z"/>'
        },
        ocarina: {
            body: '<path fill="currentColor" d="M20 12c-3.2-1.6-6.6-2.3-9.2-2.7L9.7 5.9c-.4-1.1-2-1.1-2.4 0L6.3 9C3.9 9.4 2 11.5 2 14c0 2.8 2.2 5 5 5c0 0 7 0 13-3c0 0 2-1 2-2s-2-2-2-2M5 14c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1m2 3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1m2-3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1m2 3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1m5-3c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1m3 1c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1Z"/>'
        },
        oci: {
            body: '<path fill="currentColor" d="M2 2v20h20V2m-2.88 17.03H4.87V5h14.26v14.03m-4.3-8.32h2.86v6.88h-2.86m0-11.18h2.86v2.86h-2.86M6.3 6.41v11.18h7.1v-2.87H9.17V9.28h4.23V6.41Z"/>'
        },
        ocr: {
            body: '<path fill="currentColor" d="M2 5v14h12v-2h-2c-1.11 0-2-.89-2-2V9c0-1.11.89-2 2-2h2V5m0 2v2h2V7m-2 2h-2v6h2m0 0v2h2v-2M5 7h2c1.11 0 2 .89 2 2v6c0 1.11-.89 2-2 2H5c-1.11 0-2-.89-2-2V9c0-1.11.89-2 2-2m12 0v10h2v-4h1v1h1v3h2v-3h-1v-2h1V8h-1V7M5 9v6h2V9m12 0h2v2h-2Z"/>'
        },
        octagon: {
            body: '<path fill="currentColor" d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27"/>'
        },
        "octagon-outline": {
            body: '<path fill="currentColor" d="M8.27 3L3 8.27v7.46L8.27 21h7.46C17.5 19.24 21 15.73 21 15.73V8.27L15.73 3M9.1 5h5.8L19 9.1v5.8L14.9 19H9.1L5 14.9V9.1"/>'
        },
        octagram: {
            body: '<path fill="currentColor" d="M2.2 16.06L3.88 12L2.2 7.94l4.06-1.68L7.94 2.2L12 3.88l4.06-1.68l1.68 4.06l4.06 1.68L20.12 12l1.68 4.06l-4.06 1.68l-1.68 4.06L12 20.12L7.94 21.8l-1.68-4.06l-4.06-1.68Z"/>'
        },
        "octagram-outline": {
            body: '<path fill="currentColor" d="M2.2 16.06L3.88 12L2.2 7.94l4.06-1.68L7.94 2.2L12 3.88l4.06-1.68l1.68 4.06l4.06 1.68L20.12 12l1.68 4.06l-4.06 1.68l-1.68 4.06L12 20.12L7.94 21.8l-1.68-4.06l-4.06-1.68M4.81 9l1.24 3l-1.24 3l2.98 1.21L9 19.19l3-1.24l3 1.24l1.21-2.98L19.19 15l-1.24-3l1.24-3l-2.98-1.21L15 4.81l-3 1.24l-3-1.24l-1.21 2.98L4.81 9Z"/>'
        },
        octahedron: {
            body: '<path fill="currentColor" d="M21.7 11.29h.01l-9-9C12.5 2.1 12.26 2 12 2c-.26 0-.5.1-.71.29l-9 9h.01c-.39.39-.39 1.03 0 1.42h-.01l9 9c.21.19.45.29.71.29c.26 0 .5-.1.71-.29l9-9h-.01c.39-.39.39-1.03 0-1.42M13 8.28V5.41l4.3 4.3L13 8.28m-2 0L6.7 9.71l4.3-4.3v2.87m1 1.77L17.84 12L12 13.95L6.16 12L12 10.05m-1 5.67v2.87l-4.3-4.3l4.3 1.43m2 0l4.3-1.43l-4.3 4.3v-2.87Z"/>'
        },
        "octahedron-off": {
            body: '<path fill="currentColor" d="M11 5.41V7.8l2.88 2.88L17.84 12l-1.98.66l2.95 2.95l2.9-2.9h-.01c.39-.39.39-1.03 0-1.42h.01l-9-9C12.5 2.1 12.26 2 12 2s-.5.1-.71.29l-2.9 2.9l1.42 1.42L11 5.41m2 0l4.3 4.3L13 8.28V5.41M2.39 1.73L1.11 3l4.74 4.74l-3.56 3.55h.01c-.39.39-.39 1.03 0 1.42h-.01l9 9c.21.19.45.29.71.29s.5-.1.71-.29l3.55-3.56l4.58 4.58l1.27-1.27L2.39 1.73m4.87 7.42l.28.28l-.84.28l.56-.56M11 18.59l-4.3-4.3l4.3 1.43v2.87m1-4.64L6.16 12l2.96-1l2.92 2.93l-.04.02m1 4.64v-2.87l.62-.22l1.23 1.24L13 18.59Z"/>'
        },
        odnoklassniki: {
            body: '<path fill="currentColor" d="M17.83 12.74c-.28-.57-1.07-1.05-2.12-.24c-1.43 1.14-3.71 1.14-3.71 1.14s-2.28 0-3.71-1.14c-1.05-.81-1.84-.33-2.12.24c-.5 1 .06 1.49 1.33 2.3c1.09.7 2.58.96 3.54 1.06l-.8.8C9.1 18.03 8 19.12 7.25 19.88c-.45.46-.45 1.19 0 1.62l.14.16c.45.45 1.19.45 1.64 0L12 18.68c1.15 1.13 2.24 2.22 3 2.98c.45.45 1.18.45 1.64 0l.13-.16c.46-.43.46-1.16 0-1.62l-2.98-2.98l-.79-.81c.95-.09 2.42-.36 3.5-1.05c1.27-.81 1.83-1.3 1.33-2.3M12 4.57c1.38 0 2.5 1.12 2.5 2.49c0 1.38-1.12 2.49-2.5 2.49S9.5 8.44 9.5 7.06c0-1.37 1.12-2.49 2.5-2.49m0 7.55c2.8 0 5.06-2.26 5.06-5.06a5.06 5.06 0 1 0-10.12 0c0 2.8 2.26 5.06 5.06 5.06Z"/>'
        },
        offer: {
            body: '<path fill="currentColor" d="M21 13c.6 0 1.1.2 1.4.6c.4.4.6.9.6 1.4l-8 3l-7-2V7h1.9l7.3 2.7c.5.2.8.6.8 1.1c0 .3-.1.6-.3.8c-.2.2-.5.4-.9.4H14l-1.7-.7l-.3.9l2 .8h7M2 7h4v11H2V7Z"/>'
        },
        "office-building": {
            body: '<path fill="currentColor" d="M5 3v18h6v-3.5h2V21h6V3H5m2 2h2v2H7V5m4 0h2v2h-2V5m4 0h2v2h-2V5M7 9h2v2H7V9m4 0h2v2h-2V9m4 0h2v2h-2V9m-8 4h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2m-8 4h2v2H7v-2m8 0h2v2h-2v-2Z"/>'
        },
        "office-building-cog": {
            body: '<path fill="currentColor" d="M16 13a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5s-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 18 13h-2m1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m-1-5.42V3H2v18h6v-3.5h2.03c.23-3.3 2.74-5.96 5.97-6.42M6 19H4v-2h2v2m0-4H4v-2h2v2m0-4H4V9h2v2m0-4H4V5h2v2m6-2h2v2h-2V5m0 4h2v2h-2V9m-2 6H8v-2h2v2m0-4H8V9h2v2M8 7V5h2v2H8Z"/>'
        },
        "office-building-cog-outline": {
            body: '<path fill="currentColor" d="M17 13a.26.26 0 0 0-.26.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.26.21h2c.11 0 .22-.09.24-.21l.19-1.32c.3-.13.57-.29.84-.47l1.23.5c.13 0 .26 0 .33-.13l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.82c.02-.17.04-.33.04-.5s-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.32-.13l-1.23.5c-.27-.18-.54-.35-.85-.47l-.19-1.32A.236.236 0 0 0 19 13h-2m1 3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.84 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5M10 5h2v2h-2V5m6 2h-2V5h2v2m-2 2h2v2h-2V9m-4 0h2v2h-2V9m3.11 14H2V1h18v10.29c-.63-.18-1.3-.29-2-.29V3H4v18h6v-3.5h1.03c-.03.17-.03.33-.03.5c0 1.96.81 3.73 2.11 5M8 15H6v-2h2v2m0-4H6V9h2v2m0-4H6V5h2v2M6 17h2v2H6v-2m4-4h2v1.41c-.11.19-.22.39-.32.59H10v-2Z"/>'
        },
        "office-building-marker": {
            body: '<path fill="currentColor" d="M15.19 21C14.12 19.43 13 17.36 13 15.5c0-1.83.96-3.5 2.4-4.5H15V9h2v1.23c.5-.14 1-.23 1.5-.23c.17 0 .34 0 .5.03V3H5v18h6v-3.5h2V21h2.19M15 5h2v2h-2V5M9 19H7v-2h2v2m0-4H7v-2h2v2m0-4H7V9h2v2m0-4H7V5h2v2m2-2h2v2h-2V5m0 4h2v2h-2V9m0 6v-2h2v2h-2m7.5-3c-1.9 0-3.5 1.61-3.5 3.5c0 2.61 3.5 6.5 3.5 6.5s3.5-3.89 3.5-6.5c0-1.89-1.6-3.5-3.5-3.5m0 4.81c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.59 1.2 1.2c.1.6-.5 1.2-1.2 1.2Z"/>'
        },
        "office-building-marker-outline": {
            body: '<path fill="currentColor" d="M15 9h2v2h-2V9m2-4h-2v2h2V5m-6 10h2v-2h-2v2m2-10h-2v2h2V5m-2 6h2V9h-2v2M9 5H7v2h2V5m0 4H7v2h2V9m5.55 12H13v-3.5h-2V21H5V3h14v8.03c.71.06 1.39.28 2 .6V1H3v22h12.91c-.41-.56-.91-1.24-1.36-2M7 19h2v-2H7v2m2-6H7v2h2v-2m13 3.5c0 2.6-3.5 6.5-3.5 6.5S15 19.1 15 16.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "office-building-minus": {
            body: '<path fill="currentColor" d="M13.4 21c-.2-.6-.4-1.3-.4-2c0-1.5.6-2.9 1.5-4H13v-2h2v1.5c.6-.5 1.3-.9 2-1.2V3H3v18h6v-3.5h2V21h2.4M13 5h2v2h-2V5m0 4h2v2h-2V9M7 19H5v-2h2v2m0-4H5v-2h2v2m0-4H5V9h2v2m0-4H5V5h2v2m2-2h2v2H9V5m0 4h2v2H9V9m0 6v-2h2v2H9m14 3v2h-8v-2h8Z"/>'
        },
        "office-building-minus-outline": {
            body: '<path fill="currentColor" d="M12 11h-2V9h2v2m2 0h2V9h-2v2m-.6 10H12v-3.5h-2V21H4V3h14v10.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V1H2v22h12.5c-.5-.6-.9-1.3-1.1-2M14 7h2V5h-2v2m2 6.8V13h-2v2h.5c.5-.5 1-.9 1.5-1.2M8 5H6v2h2V5m0 4H6v2h2V9M6 19h2v-2H6v2m6-14h-2v2h2V5m-2 10h2v-2h-2v2m-2-2H6v2h2v-2m7 5v2h8v-2h-8Z"/>'
        },
        "office-building-outline": {
            body: '<path fill="currentColor" d="M19 3v18h-6v-3.5h-2V21H5V3h14m-4 4h2V5h-2v2m-4 0h2V5h-2v2M7 7h2V5H7v2m8 4h2V9h-2v2m-4 0h2V9h-2v2m-4 0h2V9H7v2m8 4h2v-2h-2v2m-4 0h2v-2h-2v2m-4 0h2v-2H7v2m8 4h2v-2h-2v2m-8 0h2v-2H7v2M21 1H3v22h18V1Z"/>'
        },
        "office-building-plus": {
            body: '<path fill="currentColor" d="M13.4 21c-.2-.6-.4-1.3-.4-2c0-1.5.6-2.9 1.5-4H13v-2h2v1.5c.6-.5 1.3-.9 2-1.2V3H3v18h6v-3.5h2V21h2.4M13 5h2v2h-2V5m0 4h2v2h-2V9M7 19H5v-2h2v2m0-4H5v-2h2v2m0-4H5V9h2v2m0-4H5V5h2v2m2-2h2v2H9V5m0 4h2v2H9V9m0 6v-2h2v2H9m11 0v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "office-building-plus-outline": {
            body: '<path fill="currentColor" d="M12 11h-2V9h2v2m2 0h2V9h-2v2m-.6 10H12v-3.5h-2V21H4V3h14v10.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V1H2v22h12.5c-.5-.6-.9-1.3-1.1-2M14 7h2V5h-2v2m2 6.8V13h-2v2h.5c.5-.5 1-.9 1.5-1.2M8 5H6v2h2V5m0 4H6v2h2V9M6 19h2v-2H6v2m6-14h-2v2h2V5m-2 10h2v-2h-2v2m-2-2H6v2h2v-2m10 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "office-building-remove": {
            body: '<path fill="currentColor" d="M13.4 21c-.2-.6-.4-1.3-.4-2c0-1.5.6-2.9 1.5-4H13v-2h2v1.5c.6-.5 1.3-.9 2-1.2V3H3v18h6v-3.5h2V21h2.4M13 5h2v2h-2V5m0 4h2v2h-2V9M7 19H5v-2h2v2m0-4H5v-2h2v2m0-4H5V9h2v2m0-4H5V5h2v2m2-2h2v2H9V5m0 4h2v2H9V9m0 6v-2h2v2H9m13.5 1.9L20.4 19l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4l2.1 2.1l2.1-2.1l1.4 1.4Z"/>'
        },
        "office-building-remove-outline": {
            body: '<path fill="currentColor" d="M12 11h-2V9h2v2m2 0h2V9h-2v2m-.6 10H12v-3.5h-2V21H4V3h14v10.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V1H2v22h12.5c-.5-.6-.9-1.3-1.1-2M14 7h2V5h-2v2m2 6.8V13h-2v2h.5c.5-.5 1-.9 1.5-1.2M8 5H6v2h2V5m0 4H6v2h2V9M6 19h2v-2H6v2m6-14h-2v2h2V5m-2 10h2v-2h-2v2m-2-2H6v2h2v-2m13.1 2.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        oil: {
            body: '<path fill="currentColor" d="M22 12.5s2 2.17 2 3.5a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.33 2-3.5 2-3.5M6 6h4a1 1 0 0 1 1 1a1 1 0 0 1-1 1H9v2h2c.74 0 1.39.4 1.73 1l6.51-3.76l3.26 1.89c.5.27.64.87.37 1.37c-.28.47-.87.64-1.37.36l-2.1-1.21l-3.65 6.32c-.34.61-1 1.03-1.75 1.03H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h2V8H6a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-1 6v3h9l2.06-3.57l-3.46 2l-.91-1.43H5M.38 9.21L2.09 7.5c.41-.39 1.02-.39 1.41 0c.39.39.39 1 0 1.41l-1.71 1.71c-.39.38-1.02.38-1.41 0C0 10.23 0 9.6.38 9.21Z"/>'
        },
        "oil-lamp": {
            body: '<path fill="currentColor" d="M5 20h11v2H5m6-17h-1a2 2 0 0 0-2 2h5a2 2 0 0 0-2-2m5 3h6a2 2 0 0 1-2 2h-1a4 4 0 0 0-4 4v1a4 4 0 0 1-4 4h-1a4 4 0 0 1-4-4H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m2 2H4v3h2m13-8a2 2 0 0 1 2 2h1a2.9 2.9 0 0 0-3-3a2 2 0 0 1-2-2h-1a2.9 2.9 0 0 0 3 3"/>'
        },
        "oil-level": {
            body: '<path fill="currentColor" d="M8 18c-1.33 0-2.21.79-2.71 1.29S4.67 20 4 20s-.79-.21-1.29-.71c-.36-.36-.92-.87-1.71-1.13v2.25c.09.09.18.18.29.3c.5.5 1.38 1.29 2.71 1.29s2.21-.79 2.71-1.29S7.33 20 8 20s.79.21 1.29.71c.44.43 1.15 1.09 2.21 1.25c.16.04.33.04.5.04c1.33 0 2.21-.79 2.71-1.29S15.33 20 16 20s.79.21 1.29.71S18.67 22 20 22s2.21-.79 2.71-1.29c.11-.12.2-.21.29-.3v-2.25c-.79.26-1.35.77-1.71 1.13c-.5.5-.62.71-1.29.71s-.79-.21-1.29-.71S17.33 18 16 18s-2.21.79-2.71 1.29s-.62.71-1.29.71c-.22 0-.37-.03-.5-.08c-.28-.1-.45-.29-.79-.63C10.21 18.79 9.33 18 8 18m14-7.5s2 2.17 2 3.5c0 1.1-.9 2-2 2s-2-.9-2-2c0-1.33 2-3.5 2-3.5m.5-3.37l-3.26-1.89L12.73 9c-.34-.6-.99-1-1.73-1H9V6h1c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1h1v2H5c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h9c.75 0 1.41-.42 1.75-1.03l3.65-6.32l2.1 1.21c.5.28 1.09.11 1.37-.36c.27-.5.13-1.1-.37-1.37M14 13H5v-3h6.69l.91 1.43l3.46-2L14 13M3.5 6.92l-1.71 1.7A1 1 0 0 1 .38 7.21L2.09 5.5a1 1 0 0 1 1.41 0c.39.39.39 1 0 1.42Z"/>'
        },
        "oil-temperature": {
            body: '<path fill="currentColor" d="M10 5h3V3h-3V2c0-.6-.4-1-1-1s-1 .4-1 1v13.3c-.6.3-1 1-1 1.7c0 1.1.9 2 2 2s2-.9 2-2c0-.7-.4-1.4-1-1.7V13h3v-2h-3V9h3V7h-3V5m12 12.5s2 2.2 2 3.5c0 1.1-.9 2-2 2s-2-.9-2-2c0-1.3 2-3.5 2-3.5m.9-2c-.3.5-.9.6-1.4.4l-2.1-1.2l-3.6 6.3c-.3.6-1 1-1.8 1H5c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2v5h9l2.1-3.6l-3.1 1.8v-2.4l6.2-3.6l3.3 1.9c.5.3.6.9.4 1.4M3.5 13.9l-1.7 1.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l1.7-1.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4Z"/>'
        },
        om: {
            body: '<path fill="currentColor" d="m15 2l-1.5 1.5L15 5l1.5-1.5L15 2m-4 1c-1 6 6 7 9 3l-2-1.5C17 6 13 8 11 3M9 7C7 7 4.5 8.5 4.5 8.5L6 11c1-1 3-1.5 4-1c2 1-1 3-3 2v3.5c3-1.5 5 .5 4 2C8 22 3 16 3 13c-2 6 3 9 6 9s5-2 3.5-7H14c-1.5 4.5 4 9 7 3c1-2 1-8.5-4-8.5c-4 0-3 5.5-6.5 4C14 10 12 7 9 7m10 5c3 3-4 9-4 3c0-2 2-4.5 4-3Z"/>'
        },
        omega: {
            body: '<path fill="currentColor" d="M19.15 19h-5.76v-2.13c2.11-1.62 3.2-3.63 3.2-6.03c0-1.5-.43-2.68-1.27-3.55C14.47 6.42 13.37 6 12.03 6c-1.35 0-2.46.42-3.32 1.3c-.87.87-1.3 2.07-1.3 3.58c0 2.38 1.09 4.38 3.2 5.99V19H4.85v-2.13h3.56c-2.37-1.55-3.56-3.64-3.56-6.27c0-2.1.65-3.74 1.96-4.94c1.31-1.21 3.03-1.81 5.16-1.81c2.18 0 3.92.6 5.22 1.79c1.31 1.19 1.96 2.86 1.96 4.94c0 2.63-1.2 4.73-3.6 6.29h3.6V19Z"/>'
        },
        "one-up": {
            body: '<path fill="currentColor" d="M10 19c-.6 0-1-.4-1-1v-1c0-.5.4-1 1-1c.5 0 1 .4 1 1v1c0 .6-.4 1-1 1m5-1v-1c0-.5-.4-1-1-1c-.5 0-1 .4-1 1v1c0 .5.4 1 1 1s1-.4 1-1m7-6c0 2.6-1.6 4.9-4 6.4V20a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1.6c-2.4-1.5-4-3.8-4-6.4A10 10 0 0 1 12 2a10 10 0 0 1 10 10M7 10c0-1.1-.6-2.1-1.5-2.6C4.5 8.7 4 10.3 4 12c0 .3 0 .7.1 1c1.6-.1 2.9-1.4 2.9-3m2-1c0 1.7 1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3s-3 1.3-3 3m7 11v-4.5c-1.2-.3-2.6-.5-4-.5s-2.8.2-4 .5V20h8m3.9-7c.1-.3.1-.7.1-1c0-1.7-.5-3.3-1.5-4.6c-.9.5-1.5 1.5-1.5 2.6c0 1.6 1.3 2.9 2.9 3Z"/>'
        },
        onedrive: {
            body: '<path d="M21.5 16.87A4.037 4.037 0 0 1 17.94 19H7c-1.64 0-3.17-.8-4.1-2.14c-.57-.82-.9-1.79-.9-2.79A5.002 5.002 0 0 1 6.93 9a6.27 6.27 0 0 1 3.67-2.62c3.34-.88 6.75 1.16 7.61 4.5l-.01.01c.58.04 1.15.2 1.66.47a4.047 4.047 0 0 1 1.64 5.51z" fill="currentColor"/>',
            hidden: true
        },
        onenote: {
            body: '<path d="M1.96 4.8L14 3.08V5h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v8h-6v2L1.96 19.21V4.8M11 16.75v-8.5L9 8.5v4.25l-2-4L5 9v7l1.5.25v-5.5L9 16.5l2 .25M14 14h4v-1h-4v1m0-3h4v-1h-4v1m0-3h4V7h-4v1m0 8v1h4v-1h-4z" fill="currentColor"/>',
            hidden: true
        },
        onepassword: {
            body: '<path fill="currentColor" d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11s11-4.92 11-11S18.08 1 12 1m0 19a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m1-6.5c0 .63.4 1.2 1 1.41V18h-4v-6.09c.78-.27 1.19-1.11.93-1.91a1.5 1.5 0 0 0-.93-.91V6h4v6.09c-.6.21-1 .78-1 1.41Z"/>'
        },
        opacity: {
            body: '<path fill="currentColor" d="M17.66 8L12 2.35L6.34 8A8.02 8.02 0 0 0 4 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0 0 11.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8M6 14c0-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 18 12 18 14H6Z"/>'
        },
        "open-in-app": {
            body: '<path fill="currentColor" d="m12 10l-4 4h3v6h2v-6h3m3-10H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-2H5V8h14v10h-4v2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "open-in-new": {
            body: '<path fill="currentColor" d="M14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7Z"/>'
        },
        "open-source-initiative": {
            body: '<path fill="currentColor" d="M15.41 22h-.19a.46.46 0 0 1-.26-.27l-2.22-5.8c-.09-.24.03-.51.26-.61c.71-.26 1.28-.82 1.58-1.49c.64-1.43 0-3.1-1.43-3.74c-1.43-.64-3.1 0-3.74 1.41c-.3.71-.32 1.5-.05 2.19c.3.74.89 1.31 1.64 1.59c.24.09.37.36.28.61L9 21.69c-.04.12-.13.22-.25.27c-.12.04-.25.04-.36 0C3.24 19.97.67 14.18 2.66 9.03c1.99-5.15 7.78-7.72 12.93-5.73c2.47.96 4.46 2.85 5.54 5.27a9.905 9.905 0 0 1 .2 7.65c-1.01 2.66-3.1 4.78-5.75 5.78h-.17M12 3.59c-4.97-.13-9.1 3.8-9.23 8.77a9.007 9.007 0 0 0 5.55 8.54l1.89-4.9c-1.83-1-2.52-3.28-1.53-5.11a3.784 3.784 0 0 1 5.11-1.53a3.775 3.775 0 0 1 0 6.64l1.89 4.93a9.113 9.113 0 0 0 4.76-5c1.84-4.62-.4-9.85-5.02-11.7A9.107 9.107 0 0 0 12 3.59Z"/>'
        },
        openid: {
            body: '<path fill="currentColor" d="m14 2l-3 1.5v16.44C7 19.5 4 17.46 4 15c0-2.25 2.5-4.15 6-4.78V8.19c-5.14.69-9 3.47-9 6.81c0 3.56 4.36 6.5 10 6.94h.09L14 20.5V2m1 6.19v2.03c1.15.21 2.18.55 3.06 1L16.5 12l6.5 1.5l-.5-4.5l-2 1C19 9.12 17.12 8.47 15 8.19Z"/>'
        },
        opera: {
            body: '<path fill="currentColor" d="M9.04 17.07c-1-1.17-1.64-2.91-1.69-4.86v-.42c.05-1.95.69-3.69 1.69-4.86c.82-.98 1.89-1.56 3.06-1.56c2.62 0 4.74 2.97 4.74 6.63c0 3.66-2.12 6.63-4.74 6.63c-1.17 0-1.77-.13-3.06-1.56M12.03 3H12a9 9 0 0 0-9 9c0 4.83 3.8 8.77 8.57 9H12c2.3 0 4.4-.87 6-2.29c1.84-1.65 3-4.04 3-6.71s-1.16-5.06-3-6.71A8.938 8.938 0 0 0 12.03 3Z"/>'
        },
        orbit: {
            body: '<path fill="currentColor" d="M8.11 1.75C9.3 1.25 10.62 1 12 1c6.08 0 11 4.92 11 11s-4.92 11-11 11S1 18.08 1 12c0-1.38.25-2.7.72-3.92a4.5 4.5 0 0 0 1.73 1.1C3.16 10.07 3 11 3 12a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9c-1 0-1.93.16-2.82.45c-.22-.62-.57-1.21-1.07-1.7M4.93 2.93a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5Z"/>'
        },
        "orbit-variant": {
            body: '<path fill="currentColor" d="m19 8l-4 4h3c0 3.31-2.69 6-6 6c-1 0-1.97-.25-2.8-.7l-1.46 1.46A7.93 7.93 0 0 0 12 20c4.42 0 8-3.58 8-8h3M6 12c0-3.31 2.69-6 6-6c1 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0 0 12 4c-4.42 0-8 3.58-8 8H1l4 4l4-4m5 0c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        "order-alphabetical-ascending": {
            body: '<path fill="currentColor" d="M12 5h10v2H12m0 12v-2h10v2m-10-8h10v2H12m-3 0v2l-3.33 4H9v2H3v-2l3.33-4H3v-2M7 3H5c-1.1 0-2 .9-2 2v6h2V9h2v2h2V5a2 2 0 0 0-2-2m0 4H5V5h2Z"/>'
        },
        "order-alphabetical-descending": {
            body: '<path fill="currentColor" d="M7 13H5c-1.1 0-2 .9-2 2v6h2v-2h2v2h2v-6a2 2 0 0 0-2-2m0 4H5v-2h2M9 3v2L5.67 9H9v2H3V9l3.33-4H3V3m9 2h10v2H12m0 12v-2h10v2m-10-8h10v2H12Z"/>'
        },
        "order-bool-ascending": {
            body: '<path fill="currentColor" d="M6 3C3.79 3 2 4.79 2 7s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0 4c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m6-8h10v2H12V5m0 14v-2h10v2H12m0-8h10v2H12v-2Z"/>'
        },
        "order-bool-ascending-variant": {
            body: '<path fill="currentColor" d="M4 13c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2m.2 1.5l1.06 1.05l-3.99 3.95l-2.53-2.55l1.07-1.05l1.47 1.49M4 3c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2M4 5h4v4H4m8-4h10v2H12m0 12v-2h10v2m-10-8h10v2H12Z"/>'
        },
        "order-bool-descending": {
            body: '<path fill="currentColor" d="M6 13c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M6 3C3.79 3 2 4.79 2 7s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m6 2h10v2H12V5m0 14v-2h10v2H12m0-8h10v2H12v-2Z"/>'
        },
        "order-bool-descending-variant": {
            body: '<path fill="currentColor" d="M4 3c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m.2 1.5l1.06 1.05L5.27 9.5L2.74 6.95L3.81 5.9l1.47 1.49M4 13c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2m-4 2h4v4H4m8-14h10v2H12m0 12v-2h10v2m-10-8h10v2H12Z"/>'
        },
        "order-numeric-ascending": {
            body: '<path fill="currentColor" d="M7 21H3v-2h4v-1H5a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2m0-6H5v1h2M5 3h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 6h2V5H5m7 0h10v2H12m0 12v-2h10v2m-10-8h10v2H12Z"/>'
        },
        "order-numeric-descending": {
            body: '<path fill="currentColor" d="M7 11H3V9h4V8H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2m0-6H5v1h2m-2 7h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2m0 6h2v-4H5m7-10h10v2H12m0 12v-2h10v2m-10-8h10v2H12Z"/>'
        },
        origin: {
            body: '<path fill="currentColor" d="M12 2.13c0 .1-.05.2-.11.28c-.39.59-.73 1.23-.85 1.92l-.04.23l1-.06a7.5 7.5 0 0 1 7.5 7.5c0 1.62-.5 3.11-1.38 4.34c-1.39 2.34-3.4 4.31-5.78 5.63c-.09.03-.22.03-.28-.04c-.06-.1-.06-.23.03-.32c.38-.52.64-1.11.78-1.76l.06-.41l-.93.06A7.5 7.5 0 0 1 4.5 12c0-1.61.5-3.11 1.38-4.33C7.26 5.32 9.28 3.34 11.67 2c.11-.05.27 0 .33.13M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        ornament: {
            body: '<path fill="currentColor" d="M12 1a3 3 0 0 1 3 3v1a1 1 0 0 1 1 1v1.07c2.39 1.38 4 3.97 4 6.93a8 8 0 0 1-8 8a8 8 0 0 1-8-8c0-2.96 1.61-5.55 4-6.93V6a1 1 0 0 1 1-1V4a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v1h2V4a1 1 0 0 0-1-1m0 5c-1.78 0-3.37.77-4.47 2h8.94c-1.1-1.23-2.69-2-4.47-2m-5.66 8h1.25L6 14.43c.05.57.17 1.07.34 1.57m6.25 0l-4-4H6.41l4 4h2.18m5.07-4h-1.25L18 13.57c-.05-.57-.17-1.07-.34-1.57m-6.25 0l4 4h2.18l-4-4h-2.18m.59 8c1.78 0 3.37-.77 4.47-2H7.53c1.1 1.23 2.69 2 4.47 2Z"/>'
        },
        "ornament-variant": {
            body: '<path fill="currentColor" d="M12 1a3 3 0 0 1 3 3v1a1 1 0 0 1 1 1v1.07c2.39 1.38 4 3.97 4 6.93a8 8 0 0 1-8 8a8 8 0 0 1-8-8c0-2.96 1.61-5.55 4-6.93V6a1 1 0 0 1 1-1V4a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v1h2V4a1 1 0 0 0-1-1m0 5c-1.78 0-3.37.77-4.47 2h8.94c-1.1-1.23-2.69-2-4.47-2m0 12c1.78 0 3.37-.77 4.47-2H7.53c1.1 1.23 2.69 2 4.47 2m0-8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m6 2c0-.69-.12-1.35-.33-2c-.95.19-1.67 1-1.67 2s.72 1.81 1.67 1.97c.21-.62.33-1.28.33-1.97M6 14c0 .69.12 1.35.33 1.97C7.28 15.81 8 15 8 14s-.72-1.81-1.67-2c-.21.65-.33 1.31-.33 2Z"/>'
        },
        outbox: {
            body: '<path d="M14 14h-4v-3H8l4-4l4 4h-2v3m-9.01 1V5H19v10h-4a3 3 0 1 1-6 0H4.99M19 3H4.99c-1.104 0-1.98.895-1.98 2L3 19c0 1.105.886 2 1.99 2H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2" fill="currentColor"/>',
            hidden: true
        },
        outdent: {
            body: '<path d="M2 3h20v3H2V3zm7 5h13v3H9V8zm0 5h13v3H9v-3zm-7 5h20v3H2v-3zM6 8l-4 4l4 4h1V8H6z" fill="currentColor"/>',
            hidden: true
        },
        "outdoor-lamp": {
            body: '<path fill="currentColor" d="M15 22h-2c-1.1 0-2-.9-2-2v-5h6v5c0 1.1-.9 2-2 2m-8-8h14l-6-4.29V6c0-1.61-1.06-4-4-4S7 4.39 7 6c0 .45-.19 1-1 1H5V3H3v9h2V9h1c2.2 0 3-1.79 3-3c0-.33.1-2 2-2c1.83 0 2 1.54 2 2v3.71L7 14Z"/>'
        },
        outlook: {
            body: '<path d="M22 8v8c0 .6-.4 1-1 1h-7v4L2 19.2V4.8L14 3v4h7c.6 0 1 .4 1 1m-1 .1l-4 2.3l-3-1.7v1.6l3 1.7l4-2.3V8.1m-13.08.01c-2.1-.07-3.13 1.78-3.13 3.98s1.07 3.97 3.13 3.99c1.87.01 3.08-1.69 3.08-3.89c0-2.19-.87-4-3.08-4.08M7.61 9.7c.84 0 1.59.74 1.59 2.25c0 1.52-.75 2.36-1.59 2.36c-.83 0-1.51-1.11-1.51-2.36c0-1.24.68-2.25 1.51-2.25z" fill="currentColor"/>',
            hidden: true
        },
        overscan: {
            body: '<path fill="currentColor" d="M12 5.5L10 8h4l-2-2.5m6 4.5v4l2.5-2l-2.5-2M6 10l-2.5 2L6 14v-4m8 6h-4l2 2.5l2-2.5m7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H3V5h18v14Z"/>'
        },
        owl: {
            body: '<path fill="currentColor" d="M12 16c.56.84 1.31 1.53 2.2 2L12 20.2L9.8 18c.89-.47 1.65-1.16 2.2-2m5-4.8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-10 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m10-2.5a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m-10 0a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4M2.24 1c1.76 3.7.49 6.46-.69 9.2c-.36.8-.55 1.63-.55 2.5a6 6 0 0 0 6 6c.21-.01.42-.02.63-.05l2.96 2.96L12 23l1.41-1.39l2.96-2.96c.21.03.42.04.63.05a6 6 0 0 0 6-6c0-.87-.19-1.7-.55-2.5C21.27 7.46 20 4.7 21.76 1c-2.64 2.06-6.4 3.69-9.76 3.7C8.64 4.69 4.88 3.06 2.24 1Z"/>'
        },
        "pac-man": {
            body: '<path fill="currentColor" d="m12 12l7.07 7.07a9.953 9.953 0 0 1-14.14 0C1 15.17 1 8.84 4.93 4.93C8.83 1 15.16 1 19.07 4.93L12 12m7-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        package: {
            body: '<path fill="currentColor" d="M5.12 5h13.75l-.94-1h-12l-.81 1m15.42.23c.29.34.46.77.46 1.27V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5c0-.5.17-.93.46-1.27l1.38-1.68C5.12 3.21 5.53 3 6 3h12c.47 0 .88.21 1.15.55l1.39 1.68M6 18h6v-3H6v3Z"/>'
        },
        "package-check": {
            body: '<path fill="currentColor" d="M6 3c-.5 0-.9.2-1.2.6L3.5 5.2c-.3.4-.5.8-.5 1.3V19c0 1.1.9 2 2 2h8.3c-.2-.6-.3-1.3-.3-2c0-3.3 2.7-6 6-6c.7 0 1.4.1 2 .3V6.5c0-.5-.2-.9-.5-1.3l-1.4-1.7c-.2-.3-.6-.5-1.1-.5H6m-.1 1h12l.9 1H5.1l.8-1M6 15h6v3H6v-3m15.3.8l-3.6 3.6l-1.6-1.6L15 19l2.8 3l4.8-4.8l-1.3-1.4Z"/>'
        },
        "package-down": {
            body: '<path fill="currentColor" d="m5.12 5l.81-1h12l.94 1M12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5m8.54-12.27l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6 3 6.5V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.5c0-.5-.17-.93-.46-1.27Z"/>'
        },
        "package-up": {
            body: '<path fill="currentColor" d="M20.54 5.23c.29.34.46.77.46 1.27V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5c0-.5.17-.93.46-1.27l1.38-1.68C5.12 3.21 5.53 3 6 3h12c.47 0 .88.21 1.15.55l1.39 1.68M5.12 5h13.75l-.94-1h-12l-.81 1M12 9.5L6.5 15H10v2h4v-2h3.5L12 9.5Z"/>'
        },
        "package-variant": {
            body: '<path fill="currentColor" d="M2 10.96a.985.985 0 0 1-.37-1.37L3.13 7c.11-.2.28-.34.47-.42l7.83-4.4c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.19.1.35.26.44.46l1.45 2.52c.28.48.11 1.09-.36 1.36l-1 .58v4.96c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-5.54c-.3.17-.68.18-1 0m10-6.81v6.7l5.96-3.35L12 4.15M5 15.91l6 3.38v-6.71L5 9.21v6.7m14 0v-3.22l-5 2.9c-.33.18-.7.17-1 .01v3.69l6-3.38m-5.15-2.55l6.28-3.63l-.58-1.01l-6.28 3.63l.58 1.01Z"/>'
        },
        "package-variant-closed": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M12 4.15l-1.89 1.07L16 8.61l1.96-1.11L12 4.15M6.04 7.5L12 10.85l1.96-1.1l-5.88-3.4L6.04 7.5M5 15.91l6 3.38v-6.71L5 9.21v6.7m14 0v-6.7l-6 3.37v6.71l6-3.38Z"/>'
        },
        "package-variant-closed-check": {
            body: '<path fill="currentColor" d="M12 2c-.2 0-.4.1-.6.2L3.5 6.6c-.3.2-.5.5-.5.9v9c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2v-6.7l6-3.4V13c.7 0 1.4.1 2 .3V7.5c0-.4-.2-.7-.5-.9l-7.9-4.4c-.2-.1-.4-.2-.6-.2m0 2.2l6 3.3l-2 1.1l-5.9-3.4l1.9-1M8.1 6.3L14 9.8l-2 1.1l-6-3.4l2.1-1.2M5 9.2l6 3.4v6.7l-6-3.4V9.2m16.3 6.6l-3.6 3.6l-1.6-1.6L15 19l2.8 3l4.8-4.8l-1.3-1.4Z"/>'
        },
        "package-variant-closed-minus": {
            body: '<path fill="currentColor" d="m13 12.6l6-3.4V13c.7 0 1.4.1 2 .4V7.5c0-.4-.2-.7-.5-.9l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.5 6.6c-.3.2-.5.5-.5.9v9c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2M12 4.2l6 3.3l-2 1.1l-5.9-3.4l1.9-1m-1 15.1l-6-3.4V9.2l6 3.4v6.7m1-8.5L6 7.5l2-1.2l6 3.5l-2 1M23 18v2h-8v-2h8Z"/>'
        },
        "package-variant-closed-plus": {
            body: '<path fill="currentColor" d="M13 19.3v-6.7l6-3.4V13c.7 0 1.4.1 2 .4V7.5c0-.4-.2-.7-.5-.9l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.5 6.6c-.3.2-.5.5-.5.9v9c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2M12 4.2l6 3.3l-2 1.1l-5.9-3.4l1.9-1m-1 15.1l-6-3.4V9.2l6 3.4v6.7m1-8.5L6 7.5l2-1.2l6 3.5l-2 1m8 4.2v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "package-variant-closed-remove": {
            body: '<path fill="currentColor" d="m13 12.6l6-3.4V13c.7 0 1.4.1 2 .4V7.5c0-.4-.2-.7-.5-.9l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.5 6.6c-.3.2-.5.5-.5.9v9c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2M12 4.2l6 3.3l-2 1.1l-5.9-3.4l1.9-1m-1 15.1l-6-3.4V9.2l6 3.4v6.7m1-8.5L6 7.5l2-1.2l6 3.5l-2 1m4.9 4.7l2.1 2.1l2.1-2.1l1.4 1.4l-2.1 2.1l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4Z"/>'
        },
        "package-variant-minus": {
            body: '<path fill="currentColor" d="M13 15.6c.3.2.7.2 1 0l5-2.9v.3c.7 0 1.4.1 2 .4v-1.8l1-.6c.5-.3.6-.9.4-1.4l-1.5-2.5c-.1-.2-.2-.4-.4-.5l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.6 6.6c-.2.1-.4.2-.5.4L1.6 9.6c-.3.5-.1 1.1.4 1.4c.3.2.7.2 1 0v5.5c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2m-2 0l-6-3.4V9.2l6 3.4v6.7m9.1-9.6l-6.3 3.6l-.6-1l6.3-3.6l.6 1M12 10.8V4.2l6 3.3l-6 3.3M23 20h-8v-2h8v2Z"/>'
        },
        "package-variant-plus": {
            body: '<path fill="currentColor" d="M13 15.6c.3.2.7.2 1 0l5-2.9v.3c.7 0 1.4.1 2 .4v-1.8l1-.6c.5-.3.6-.9.4-1.4l-1.5-2.5c-.1-.2-.2-.4-.4-.5l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.6 6.6c-.2.1-.4.2-.5.4L1.6 9.6c-.3.5-.1 1.1.4 1.4c.3.2.7.2 1 0v5.5c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2m-2 0l-6-3.4V9.2l6 3.4v6.7m9.1-9.6l-6.3 3.6l-.6-1l6.3-3.6l.6 1M12 10.8V4.2l6 3.3l-6 3.3m8 4.2v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "package-variant-remove": {
            body: '<path fill="currentColor" d="M13 15.6c.3.2.7.2 1 0l5-2.9v.3c.7 0 1.4.1 2 .4v-1.8l1-.6c.5-.3.6-.9.4-1.4l-1.5-2.5c-.1-.2-.2-.4-.4-.5l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.6 6.6c-.2.1-.4.2-.5.4L1.6 9.6c-.3.5-.1 1.1.4 1.4c.3.2.7.2 1 0v5.5c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2m-2 0l-6-3.4V9.2l6 3.4v6.7m9.1-9.6l-6.3 3.6l-.6-1l6.3-3.6l.6 1M12 10.8V4.2l6 3.3l-6 3.3m10.5 6.1L20.4 19l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4l2.1 2.1l2.1-2.1l1.4 1.4Z"/>'
        },
        pages: {
            body: '<path d="M3 5V11H8L7 7L11 8V3H5C3.9 3 3 3.9 3 5ZM8 13H3V19C3 20.1 3.9 21 5 21H11V16L7 17L8 13ZM17 17L13 16V21H19C20.1 21 21 20.1 21 19V13H16L17 17ZM19 3H13V8L17 7L16 11H21V5C21 3.9 20.1 3 19 3Z" fill="currentColor"/>'
        },
        "page-first": {
            body: '<path fill="currentColor" d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6l6 6l1.41-1.41M6 6h2v12H6V6Z"/>'
        },
        "page-last": {
            body: '<path fill="currentColor" d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6l-6-6l-1.41 1.41M16 6h2v12h-2V6Z"/>'
        },
        "page-layout-body": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 6v8h12V8H6Z"/>'
        },
        "page-layout-footer": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 14v4h12v-4H6Z"/>'
        },
        "page-layout-header": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v4h12V4H6Z"/>'
        },
        "page-layout-header-footer": {
            body: '<path fill="currentColor" d="M18 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 18H6v-4h12v4m0-12H6V4h12v4Z"/>'
        },
        "page-layout-sidebar-left": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 6v8h4V8H6Z"/>'
        },
        "page-layout-sidebar-right": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m8 6v8h4V8h-4Z"/>'
        },
        "page-next": {
            body: '<path fill="currentColor" d="M20 3H5a2 2 0 0 0-2 2v6h4V9l4 3l-4 3v-2H3v6a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-3 14h-4v-2h4v2m3-4h-7v-2h7v2m0-4h-7V7h7v2M3 13H0v-2h3v2Z"/>'
        },
        "page-next-outline": {
            body: '<path fill="currentColor" d="M22 3H5a2 2 0 0 0-2 2v4h2V5h17v14H5v-4H3v4a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M7 15v-2H0v-2h7V9l4 3l-4 3m13-2h-7v-2h7v2m0-4h-7V7h7v2m-3 8h-4v-2h4v2Z"/>'
        },
        "page-previous": {
            body: '<path fill="currentColor" d="M4 21h15a2 2 0 0 0 2-2v-6h-4v2l-4-3l4-3v2h4V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2m0-6h4v2H4v-2m0-4h7v2H4v-2m0-4h7v2H4V7m17 4h3v2h-3v-2Z"/>'
        },
        "page-previous-outline": {
            body: '<path fill="currentColor" d="M2 3h17a2 2 0 0 1 2 2v4h-2V5H2v14h17v-4h2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m15 12v-2h7v-2h-7V9l-4 3l4 3M4 13h7v-2H4v2m0-4h7V7H4v2m0 8h4v-2H4v2Z"/>'
        },
        pail: {
            body: '<path fill="currentColor" d="M11.5 7.63a.976.976 0 0 1 1.36.37c.28.47.11 1.09-.36 1.36l-8.23 4.75a.998.998 0 1 1-1-1.73l8.23-4.75M7 21l-1.21-6.03l7.42-4.28c.79-.43 1.29-1.25 1.29-2.19a2.5 2.5 0 0 0-3.79-2.14L4.76 9.79L4 6H3V4h18v2h-1l-3 15H7Z"/>'
        },
        "pail-minus": {
            body: '<path fill="currentColor" d="m12.5 9.36l-8.23 4.75a.998.998 0 1 1-1-1.73l8.23-4.75a.976.976 0 0 1 1.36.37c.28.47.11 1.09-.36 1.36M13 19c0-3.18 2.47-5.77 5.6-6L20 6h1V4H3v2h1l.76 3.79l5.95-3.43A2.5 2.5 0 0 1 14.5 8.5c0 .94-.5 1.76-1.29 2.19l-7.42 4.28L7 21h6.35c-.22-.63-.35-1.3-.35-2m2-1v2h8v-2h-8Z"/>'
        },
        "pail-minus-outline": {
            body: '<path fill="currentColor" d="M4 6H3V4h18v2h-1l-1.4 7c-.77.07-1.49.26-2.15.58L17.96 6H6.04l.46 2.22l-1.85 1.05L4 6m8.86 2a.976.976 0 0 0-1.36-.37l-8.23 4.75a.998.998 0 1 0 1 1.73l8.23-4.75c.47-.27.64-.89.36-1.36M13 19H8.64l-.91-4.57L5.9 15.5L7 21h6.35c-.22-.63-.35-1.3-.35-2m2-1v2h8v-2h-8Z"/>'
        },
        "pail-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-3.49-3.49L17 21H7l-1.21-6.03l4.62-2.67l-1.1-1.1l-5.04 2.91a.998.998 0 1 1-1-1.73l4.58-2.64l-1.1-1.1l-1.99 1.15L4 6H3V4.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M10.71 6.36A2.5 2.5 0 0 1 14.5 8.5c0 .77-.34 1.44-.9 1.9l4.6 4.6L20 6h1V4H7.2L10 6.78l.71-.42m.79 1.27l-.42.25l1.45 1.45c.44-.28.6-.87.33-1.33a.976.976 0 0 0-1.36-.37Z"/>'
        },
        "pail-off-outline": {
            body: '<path fill="currentColor" d="m20.84 22.73l-3.49-3.49L17 21H7l-1.1-5.5l1.83-1.07l.91 4.57h6.72l.29-1.46l-6.34-6.34l-5.04 2.91a.998.998 0 1 1-1-1.73l4.58-2.64l-1.47-1.47l-1.73 1L4 6H3V4.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M17.96 6l-1.46 7.3l1.7 1.7L20 6h1V4H7.2l2 2h8.76M11.5 7.63l-.42.25l1.45 1.45c.44-.28.6-.87.33-1.33a.976.976 0 0 0-1.36-.37Z"/>'
        },
        "pail-outline": {
            body: '<path fill="currentColor" d="M11.5 7.63a.976.976 0 0 1 1.36.37c.28.47.11 1.09-.36 1.36l-8.23 4.75a.998.998 0 1 1-1-1.73l8.23-4.75M3 4v2h1l.65 3.27L6.5 8.22L6.04 6h11.92l-2.6 13H8.64l-.91-4.57L5.9 15.5L7 21h10l3-15h1V4H3Z"/>'
        },
        "pail-plus": {
            body: '<path fill="currentColor" d="m12.5 9.36l-8.23 4.75a.998.998 0 1 1-1-1.73l8.23-4.75a.976.976 0 0 1 1.36.37c.28.47.11 1.09-.36 1.36M13 19c0-3.18 2.47-5.77 5.6-6L20 6h1V4H3v2h1l.76 3.79l5.95-3.43A2.5 2.5 0 0 1 14.5 8.5c0 .94-.5 1.76-1.29 2.19l-7.42 4.28L7 21h6.35c-.22-.63-.35-1.3-.35-2m5-4v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "pail-plus-outline": {
            body: '<path fill="currentColor" d="M4 6H3V4h18v2h-1l-1.4 7c-.77.07-1.49.26-2.15.58L17.96 6H6.04l.46 2.22l-1.85 1.05L4 6m8.86 2a.976.976 0 0 0-1.36-.37l-8.23 4.75a.998.998 0 1 0 1 1.73l8.23-4.75c.47-.27.64-.89.36-1.36M13 19H8.64l-.91-4.57L5.9 15.5L7 21h6.35c-.22-.63-.35-1.3-.35-2m5-4v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "pail-remove": {
            body: '<path fill="currentColor" d="m12.5 9.36l-8.23 4.75a.998.998 0 1 1-1-1.73l8.23-4.75a.976.976 0 0 1 1.36.37c.28.47.11 1.09-.36 1.36M13 19c0-3.18 2.47-5.77 5.6-6L20 6h1V4H3v2h1l.76 3.79l5.95-3.43A2.5 2.5 0 0 1 14.5 8.5c0 .94-.5 1.76-1.29 2.19l-7.42 4.28L7 21h6.35c-.22-.63-.35-1.3-.35-2m8.12-3.54L19 17.59l-2.12-2.13l-1.41 1.42L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "pail-remove-outline": {
            body: '<path fill="currentColor" d="M4 6H3V4h18v2h-1l-1.4 7c-.77.07-1.49.26-2.15.58L17.96 6H6.04l.46 2.22l-1.85 1.05L4 6m8.86 2a.976.976 0 0 0-1.36-.37l-8.23 4.75a.998.998 0 1 0 1 1.73l8.23-4.75c.47-.27.64-.89.36-1.36M13 19H8.64l-.91-4.57L5.9 15.5L7 21h6.35c-.22-.63-.35-1.3-.35-2m8.12-3.54L19 17.59l-2.12-2.13l-1.42 1.42L17.58 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.41-1.42L20.41 19l2.12-2.12l-1.41-1.42Z"/>'
        },
        palette: {
            body: '<path fill="currentColor" d="M17.5 12a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 17.5 9a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-3-4A1.5 1.5 0 0 1 13 6.5A1.5 1.5 0 0 1 14.5 5A1.5 1.5 0 0 1 16 6.5A1.5 1.5 0 0 1 14.5 8m-5 0A1.5 1.5 0 0 1 8 6.5A1.5 1.5 0 0 1 9.5 5A1.5 1.5 0 0 1 11 6.5A1.5 1.5 0 0 1 9.5 8m-3 4A1.5 1.5 0 0 1 5 10.5A1.5 1.5 0 0 1 6.5 9A1.5 1.5 0 0 1 8 10.5A1.5 1.5 0 0 1 6.5 12M12 3a9 9 0 0 0-9 9a9 9 0 0 0 9 9a1.5 1.5 0 0 0 1.5-1.5c0-.39-.15-.74-.39-1c-.23-.27-.38-.62-.38-1a1.5 1.5 0 0 1 1.5-1.5H16a5 5 0 0 0 5-5c0-4.42-4.03-8-9-8Z"/>'
        },
        "palette-advanced": {
            body: '<path fill="currentColor" d="M22 22H10v-2h12v2M2 22v-2h7v2H2m16-4v-8h4v8h-4m0-15h4v6h-4V3M2 18V3h14v15H2m7-3.44a3 3 0 0 0 3-3c0-2-3-5.37-3-5.37s-3 3.37-3 5.37a3 3 0 0 0 3 3Z"/>'
        },
        "palette-outline": {
            body: '<path fill="currentColor" d="M12 22A10 10 0 0 1 2 12A10 10 0 0 1 12 2c5.5 0 10 4 10 9a6 6 0 0 1-6 6h-1.8c-.3 0-.5.2-.5.5c0 .1.1.2.1.3c.4.5.6 1.1.6 1.7c.1 1.4-1 2.5-2.4 2.5m0-18a8 8 0 0 0-8 8a8 8 0 0 0 8 8c.3 0 .5-.2.5-.5c0-.2-.1-.3-.1-.4c-.4-.5-.6-1-.6-1.6c0-1.4 1.1-2.5 2.5-2.5H16a4 4 0 0 0 4-4c0-3.9-3.6-7-8-7m-5.5 6c.8 0 1.5.7 1.5 1.5S7.3 13 6.5 13S5 12.3 5 11.5S5.7 10 6.5 10m3-4c.8 0 1.5.7 1.5 1.5S10.3 9 9.5 9S8 8.3 8 7.5S8.7 6 9.5 6m5 0c.8 0 1.5.7 1.5 1.5S15.3 9 14.5 9S13 8.3 13 7.5S13.7 6 14.5 6m3 4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        "palette-swatch": {
            body: '<path fill="currentColor" d="m2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.06 2.19 1.09 2.61m19.5-3.7L17.07 4a2 2 0 0 0-1.81-1.25c-.26 0-.53.04-.79.15L7.1 5.95a2.02 2.02 0 0 0-1.23 1.8c-.01.25.04.54.13.8l5 11.95c.29.78 1.03 1.24 1.81 1.25c.26 0 .52-.05.77-.15l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6M7.88 8.75a1 1 0 0 1-1-1a1 1 0 0 1 1-1c.55 0 1 .45 1 1s-.45 1-1 1m-2 11a2 2 0 0 0 2 2h1.45l-3.45-8.34v6.34Z"/>'
        },
        "palette-swatch-outline": {
            body: '<path fill="currentColor" d="m2.5 19.6l1.3.6v-9L1.4 17c-.4 1.1.1 2.2 1.1 2.6M15.2 4.8l5 12l-7.3 3l-5-11.9v-.1l7.3-3m.1-2c-.3 0-.5 0-.8.1L7.1 6c-.7.3-1.2 1-1.2 1.8c0 .2 0 .5.1.8l5 11.9c.3.8 1 1.2 1.8 1.2c.3 0 .5 0 .8-.1l7.4-3.1c1-.4 1.5-1.6 1.1-2.6L17.1 4c-.3-.8-1.1-1.2-1.8-1.2m-4.8 7.1c-.6 0-1-.4-1-1s.4-1 1-1s1 .5 1 1s-.4 1-1 1m-4.6 9.9c0 1.1.9 2 2 2h1.4l-3.4-8.3v6.3Z"/>'
        },
        "palette-swatch-variant": {
            body: '<path fill="currentColor" d="M20 14H6c-2.2 0-4 1.8-4 4s1.8 4 4 4h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2M6 20c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m.3-8L13 5.3c.8-.8 2-.8 2.8 0l2.8 2.8c.8.8.8 2 0 2.8l-.9 1.1H6.3M2 13.5V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1.5l-8 8Z"/>'
        },
        "palm-tree": {
            body: '<path fill="currentColor" d="M12 9c1.59 7.61-2 13-2 13h3c1.88-5.8 1-9.91.5-12m2.16-2.84c.17.21.34.43.47.66a7.1 7.1 0 0 1-.63 8.44a7.11 7.11 0 0 0-.55-6.49c-.08-.13-.17-.24-.25-.36a7.123 7.123 0 0 0-2.16-1.98a7.127 7.127 0 0 0-4.96 6.79c0 .74.11 1.45.31 2.11a7.073 7.073 0 0 1-1.33-4.14c0-2.35 1.14-4.43 2.89-5.73C8 6.35 6.46 6.67 5.12 7.5c-.62.41-1.16.88-1.62 1.41c.55-1.33 1.5-2.52 2.8-3.34c1.5-.94 3.2-1.25 4.84-1.01C10.73 4 10.23 3.47 9.63 3c-.58-.42-1.21-.76-1.87-1c1.44.04 2.88.5 4.11 1.43c.63.47 1.13 1.04 1.53 1.64c.1 0 .19-.01.29-.01c3.2 0 5.91 2.11 6.81 5.02a7.073 7.073 0 0 0-4.84-2.92Z"/>'
        },
        pan: {
            body: '<path fill="currentColor" d="M12 2.5L8 7h8l-4-4.5M7 8l-4.5 4L7 16V8m10 0v8l4.5-4L17 8m-5 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-4 7l4 4.5l4-4.5H8Z"/>'
        },
        "pan-bottom-left": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-6.65 3L11 18.65L5 19l.35-6Z"/>'
        },
        "pan-bottom-right": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m1 8.65L18.65 13l.35 6l-6-.35Z"/>'
        },
        "pan-down": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-4 7l4 4.5l4-4.5H8Z"/>'
        },
        "pan-horizontal": {
            body: '<path fill="currentColor" d="m7 8l-4.5 4L7 16V8m10 0v8l4.5-4L17 8m-5 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "pan-left": {
            body: '<path fill="currentColor" d="m7 8l-4.5 4L7 16V8m5 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "pan-right": {
            body: '<path fill="currentColor" d="M17 8v8l4.5-4L17 8m-5 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "pan-top-left": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-1-4.65L5.35 11L5 5l6 .35Z"/>'
        },
        "pan-top-right": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m6.65 1L13 5.35L19 5l-.35 6Z"/>'
        },
        "pan-up": {
            body: '<path fill="currentColor" d="M12 2.5L8 7h8l-4-4.5m0 7.5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "pan-vertical": {
            body: '<path fill="currentColor" d="M12 2.5L8 7h8l-4-4.5m0 7.5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-4 7l4 4.5l4-4.5H8Z"/>'
        },
        panda: {
            body: '<path fill="currentColor" d="M12 3c1.74 0 3.36.5 4.74 1.35C17.38 3.53 18.38 3 19.5 3A3.5 3.5 0 0 1 23 6.5c0 1.5-.95 2.78-2.28 3.28c.18.72.28 1.45.28 2.22a9 9 0 0 1-9 9a9 9 0 0 1-9-9c0-.77.1-1.5.28-2.22A3.51 3.51 0 0 1 1 6.5A3.5 3.5 0 0 1 4.5 3c1.12 0 2.12.53 2.76 1.35C8.64 3.5 10.26 3 12 3m0 2a7 7 0 0 0-7 7a7 7 0 0 0 7 7a7 7 0 0 0 7-7a7 7 0 0 0-7-7m4.19 5.3c.36 1.33-.11 2.61-1.04 2.86c-.94.26-1.98-.62-2.34-1.96c-.36-1.33.11-2.61 1.04-2.86c.94-.25 1.98.62 2.34 1.96m-8.38 0c.36-1.34 1.4-2.21 2.34-1.96c.93.25 1.4 1.53 1.04 2.86c-.36 1.34-1.4 2.22-2.34 1.96c-.93-.25-1.4-1.53-1.04-2.86M12 14c.6 0 1.13.19 1.5.5l-1 1c0 .42.34.75.75.75a.75.75 0 0 0 .75-.75a.5.5 0 0 1 .5-.5a.5.5 0 0 1 .5.5a1.75 1.75 0 0 1-1.75 1.75c-.49 0-.93-.2-1.25-.53c-.32.33-.76.53-1.25.53A1.75 1.75 0 0 1 9 15.5a.5.5 0 0 1 .5-.5a.5.5 0 0 1 .5.5a.75.75 0 0 0 .75.75a.75.75 0 0 0 .75-.75l-1-1c.37-.31.9-.5 1.5-.5Z"/>'
        },
        pandora: {
            body: '<path fill="currentColor" d="M10 20a1 1 0 0 1-1 1H4V3h9.71a6.75 6.75 0 0 1 6.75 6.75c0 3.75-3.02 6.75-6.75 6.75H10V20Z"/>'
        },
        panorama: {
            body: '<path fill="currentColor" d="m8.5 12.5l2.5 3l3.5-4.5l4.5 6H5m18 1V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2Z"/>'
        },
        "panorama-fisheye": {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2Z"/>'
        },
        "panorama-horizontal": {
            body: '<path fill="currentColor" d="M12 5.5c-3.9 0-6.9-.8-8.7-1.4c-.6-.3-1.3.2-1.3.9v14c0 .7.7 1.2 1.3 1c2.1-.7 4.8-1.5 8.7-1.5c3.9 0 6.7.8 8.7 1.5c.7.2 1.3-.3 1.3-1V5c0-.7-.7-1.2-1.3-.9c-2 .6-4.8 1.4-8.7 1.4Z"/>'
        },
        "panorama-horizontal-outline": {
            body: '<path fill="currentColor" d="M21.43 4c-.1 0-.2 0-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64C2.77 4 2.66 4 2.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62c.1 0 .2 0 .31-.06c2.94-1.1 6.03-1.64 9.12-1.64c3.09 0 6.18.55 9.12 1.64c.11.06.21.06.31.06c.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16c-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16c2.72.01 5.4-.38 8-1.16Z"/>'
        },
        "panorama-outline": {
            body: '<path fill="currentColor" d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H3V6h18v12m-6.5-7L11 15.5l-2.5-3L5 17h14l-4.5-6Z"/>'
        },
        "panorama-sphere": {
            body: '<path fill="currentColor" d="M22 8.1c-.3-.1-.7-.3-1-.4C19.4 4.3 16 2 12 2S4.6 4.3 3 7.7c-.3.1-.7.3-.9.4C1.4 8.5 1 9.2 1 9.9v4.2c0 .7.4 1.4 1 1.8c.3.1.7.3 1 .4c1.6 3.4 5 5.7 9 5.7s7.4-2.3 9-5.7c.3-.1.6-.3.9-.5c.6-.4 1.1-1 1.1-1.8V9.9c0-.7-.4-1.4-1-1.8M12 4c2.4 0 4.5 1 6 2.7c-1.8-.5-3.9-.7-6-.7s-4.2.2-5.9.7C7.5 5 9.6 4 12 4m0 16c-2.4 0-4.5-1-5.9-2.7c1.7.5 3.8.7 5.9.7s4.2-.2 6-.7C16.5 19 14.4 20 12 20Z"/>'
        },
        "panorama-sphere-outline": {
            body: '<path fill="currentColor" d="M22 8.1c-.3-.1-.7-.3-1-.4C19.4 4.3 16 2 12 2S4.6 4.3 3 7.7c-.3.1-.7.3-.9.4C1.4 8.5 1 9.2 1 9.9v4.2c0 .7.4 1.4 1 1.8c.3.1.7.3 1 .4c1.6 3.4 5 5.7 9 5.7s7.4-2.3 9-5.7c.3-.1.6-.3.9-.5c.6-.4 1.1-1 1.1-1.8V9.9c0-.7-.4-1.4-1-1.8m-1 1.8v4.2c-2.2 1.2-5.5 1.9-9 1.9s-6.8-.7-9-1.9V9.9C5.2 8.7 8.5 8 12 8s6.8.7 9 1.9M12 4c2.4 0 4.5 1 6 2.7c-1.8-.5-3.9-.7-6-.7s-4.2.2-5.9.7C7.5 5 9.6 4 12 4m0 16c-2.4 0-4.5-1-5.9-2.7c1.7.5 3.8.7 5.9.7s4.2-.2 6-.7C16.5 19 14.4 20 12 20Z"/>'
        },
        "panorama-variant": {
            body: '<path fill="currentColor" d="M20.7 4.1c-2 .7-4.8 1.4-8.7 1.4c-3.9 0-6.9-.8-8.7-1.4c-.6-.3-1.3.2-1.3.9v14c0 .7.7 1.2 1.3 1c2.1-.7 4.8-1.5 8.7-1.5c3.9 0 6.7.8 8.7 1.5c.7.2 1.3-.3 1.3-1V5c0-.7-.7-1.2-1.3-.9M12 15c-2.3 0-4.5.1-6.5.4L9.2 11l2 2.4L14 10l4.5 5.4c-2-.3-4.2-.4-6.5-.4Z"/>'
        },
        "panorama-variant-outline": {
            body: '<path fill="currentColor" d="M21 4c-.6 0-3.6 1.5-9 1.5C6.7 5.5 3.5 4 3 4s-1 .4-1 1v14c0 .6.5 1 1 1c.6 0 3.5-1.5 9-1.5c5.4 0 8.4 1.5 9 1.5c.5 0 1-.4 1-1V5c0-.6-.5-1-1-1m-1 13.6c-2-.6-4.6-1.1-8-1.1c-3.4 0-6 .5-8 1.1V6.4c2.6.7 5.3 1.1 8 1.1c3.4 0 6-.5 8-1.1v11.2M9.2 11l-3.7 4.4c2-.3 4.2-.4 6.5-.4s4.5.1 6.5.4L14 10l-2.8 3.4l-2-2.4Z"/>'
        },
        "panorama-vertical": {
            body: '<path fill="currentColor" d="M18.5 12c0-3.9.8-6.9 1.4-8.7c.2-.6-.2-1.3-.9-1.3H5c-.7 0-1.2.7-.9 1.3c.6 2.1 1.4 4.8 1.4 8.7c0 3.9-.8 6.7-1.4 8.7c-.3.6.2 1.3.9 1.3h14c.7 0 1.2-.7 1-1.3c-.7-2-1.5-4.8-1.5-8.7Z"/>'
        },
        "panorama-vertical-outline": {
            body: '<path fill="currentColor" d="M6.54 20c.77-2.6 1.16-5.28 1.16-8c0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8c0 2.72.39 5.4 1.16 8m2.49 1.12c-1.1-2.94-1.64-6.03-1.64-9.12c0-3.09.55-6.18 1.64-9.12c.06-.11.06-.22.06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57c0 .1 0 .2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12c-.07.11-.07.22-.07.31c0 .33.23.57.63.57h14.75c.39 0 .62-.24.62-.57c0-.1 0-.2-.06-.31Z"/>'
        },
        "panorama-wide-angle": {
            body: '<path fill="currentColor" d="M12 4c-4 0-6.8.6-9 1c-.5 2-1 3.9-1 7c0 3 .5 5 1 7c2.2.4 5 1 9 1s6.9-.6 9-1c.6-2 1-4 1-7s-.5-5.1-1-7c-2.1-.4-5-1-9-1Z"/>'
        },
        "panorama-wide-angle-outline": {
            body: '<path fill="currentColor" d="M12 4c-2.73 0-5.22.24-7.95.72l-.93.16l-.25.9C2.29 7.85 2 9.93 2 12c0 2.07.29 4.15.87 6.22l.25.89l.93.16c2.73.49 5.22.73 7.95.73c2.73 0 5.22-.24 7.95-.72l.93-.16l.25-.89c.58-2.08.87-4.16.87-6.23c0-2.07-.29-4.15-.87-6.22l-.25-.89l-.93-.16C17.22 4.24 14.73 4 12 4m0 2c2.45 0 4.71.2 7.29.64A21 21 0 0 1 20 12a21 21 0 0 1-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64A21 21 0 0 1 4 12a21 21 0 0 1 .71-5.36C7.29 6.2 9.55 6 12 6Z"/>'
        },
        "paper-cut-vertical": {
            body: '<path fill="currentColor" d="M11.43 3.23L12 4l.57-.77v.01C13.12 2.5 14 2 15 2a3 3 0 0 1 3 3a3 3 0 0 1-.17 1H20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.17A3 3 0 0 1 6 5a3 3 0 0 1 3-3c1 0 1.88.5 2.43 1.24v-.01M4 8v12h7a1 1 0 0 1 1-1a1 1 0 0 1 1 1h7V8h-5.1l2.1 2.92l-1.6 1.18L12.42 8h-.84L8.6 12.1L7 10.92L9.1 8H4m5-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-3 12a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m0-3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m0-3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "paper-roll": {
            body: '<path fill="currentColor" d="M9 3C5.69 3 3.14 5.69 3 9v12h9v-7.54c1.1.99 2.5 1.54 4 1.54c3.31 0 6-2.69 6-6s-2.69-6-6-6H9m7 2c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4m0 2.25c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75s1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75M4 12h1v1H4v-1m2 0h1v1H6v-1m2 0h1v1H8v-1m2 0h1v1h-1v-1Z"/>'
        },
        "paper-roll-outline": {
            body: '<path fill="currentColor" d="M9 3C5.69 3 3.14 5.69 3 9v12h9v-7.54c1.1.99 2.5 1.54 4 1.54c3.31 0 6-2.69 6-6s-2.69-6-6-6H9m0 2h2.54C10.55 6.1 10 7.5 10 9v3H9v1h1v6H5v-6h1v-1H5V9c0-2.21 1.79-4 4-4m7 0c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4m0 2.25c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75s1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75M7 12v1h1v-1H7Z"/>'
        },
        paperclip: {
            body: '<path fill="currentColor" d="M16.5 6v11.5a4 4 0 0 1-4 4a4 4 0 0 1-4-4V5A2.5 2.5 0 0 1 11 2.5A2.5 2.5 0 0 1 13.5 5v10.5a1 1 0 0 1-1 1a1 1 0 0 1-1-1V6H10v9.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5V5a4 4 0 0 0-4-4a4 4 0 0 0-4 4v12.5a5.5 5.5 0 0 0 5.5 5.5a5.5 5.5 0 0 0 5.5-5.5V6h-1.5Z"/>'
        },
        "paperclip-check": {
            body: '<path fill="currentColor" d="M13.5 21.36c.2.48.47.93.79 1.34A5.497 5.497 0 0 1 7 17.5V5c0-2.21 1.79-4 4-4s4 1.79 4 4v9.54c-.97.87-1.65 2.04-1.9 3.38c-.19.05-.39.08-.6.08a2.5 2.5 0 0 1-2.5-2.5V6h1.5v9.5c0 .55.45 1 1 1s1-.45 1-1V5a2.5 2.5 0 0 0-5 0v12.5c0 2.21 1.79 4 4 4c.34 0 .67-.06 1-.14M18 6h-1.5v7.55c.47-.21.97-.37 1.5-.46V6m3.34 9.84l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "paperclip-lock": {
            body: '<path fill="currentColor" d="M18 13c-1.4 0-2.8 1.1-2.8 2.5V17c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3v-1.5c0-1.4-1.4-2.5-2.8-2.5m0 1.2c.8 0 1.5.5 1.5 1.3V17h-3v-1.5c0-.8.7-1.3 1.5-1.3M8.9 2C6.8 2 5 3.8 5 6v10.5c0 3 2.5 5.5 5.5 5.5c.5 0 1-.1 1.5-.2v-1.6c-.5.2-1 .3-1.5.3c-2.2 0-4-1.8-4-4V6c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v8.5c0 .6-.4 1-1 1s-1-.4-1-1V7H8v7.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V6c0-2.2-1.8-4-4.1-4c.1 0 .1 0 0 0m5.6 5v5.4c.4-.4.9-.8 1.5-1V7h-1.5Z"/>'
        },
        "paperclip-minus": {
            body: '<path fill="currentColor" d="M18 13.09c-.53.09-1.03.25-1.5.46V6H18v7.09m-5.5 8.41c-2.21 0-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 2.5 2.5c.21 0 .41-.03.6-.08c.25-1.34.93-2.51 1.9-3.38V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5a5.497 5.497 0 0 0 7.29 5.2c-.32-.41-.59-.86-.79-1.34c-.33.08-.66.14-1 .14M15 18v2h8v-2h-8Z"/>'
        },
        "paperclip-off": {
            body: '<path fill="currentColor" d="M8.5 5.3L7.16 3.96C7.62 2.26 9.15 1 11 1c2.21 0 4 1.79 4 4v6.8l-1.5-1.5V5a2.5 2.5 0 0 0-5 0v.3M18 6h-1.5v7.3l1.5 1.5V6m4.11 15.46l-1.27 1.27l-3.22-3.23c-.81 2.05-2.79 3.5-5.12 3.5C9.46 23 7 20.54 7 17.5V8.89L1.11 3l1.28-1.27l19.72 19.73M11.5 15.5c0 .55.45 1 1 1s1-.45 1-1v-.11l-2-2v2.11m4.92 2.81l-1.69-1.69A2.48 2.48 0 0 1 12.5 18a2.5 2.5 0 0 1-2.5-2.5v-3.61l-1.5-1.5v7.11c0 2.21 1.79 4 4 4a4.01 4.01 0 0 0 3.92-3.19M10 6.8l1.5 1.5V6H10v.8Z"/>'
        },
        "paperclip-plus": {
            body: '<path fill="currentColor" d="M18 13.09c-.53.09-1.03.25-1.5.46V6H18v7.09m-5.5 8.41c-2.21 0-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 2.5 2.5c.21 0 .41-.03.6-.08c.25-1.34.93-2.51 1.9-3.38V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5a5.497 5.497 0 0 0 7.29 5.2c-.32-.41-.59-.86-.79-1.34c-.33.08-.66.14-1 .14M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "paperclip-remove": {
            body: '<path fill="currentColor" d="M18 13.09c-.53.09-1.03.25-1.5.46V6H18v7.09M11 1C8.79 1 7 2.79 7 5v12.5a5.497 5.497 0 0 0 7.29 5.2c-.32-.41-.59-.86-.79-1.34c-.33.08-.66.14-1 .14c-2.21 0-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 2.5 2.5c.21 0 .41-.03.6-.08c.25-1.34.93-2.51 1.9-3.38V5c0-2.21-1.79-4-4-4m11.54 15.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        parachute: {
            body: '<path fill="currentColor" d="M21.2 10.95L12 23L2.78 10.96l.09-.08c.21-.21.46-.38.71-.52l7.15 9.33L8.58 13l.66-1.19L12 20.38l2.73-8.58l.67 1.2l-2.13 6.69l7.14-9.34c.25.15.49.29.69.5l.1.1M5 9c1.5 0 2.81.86 3.5 2.1A3.97 3.97 0 0 1 12 9c1.5 0 2.8.85 3.5 2.09A3.93 3.93 0 0 1 19 9c1.09 0 2.09.42 2.81 1.14C20.94 5.5 16.88 2 12 2c-4.91 0-8.97 3.5-9.84 8.17C2.89 9.45 3.89 9 5 9Z"/>'
        },
        "parachute-outline": {
            body: '<path fill="currentColor" d="M21.2 10.95L12 23L2.78 10.96l.09-.08c.21-.21.46-.38.71-.52l7.15 9.33L8.58 13l.66-1.19L12 20.38l2.73-8.58l.67 1.2l-2.13 6.69l7.14-9.34c.25.15.49.29.69.5l.1.1M12 4c2.5 0 4.77 1.17 6.25 3.03a5.93 5.93 0 0 0-2.78 1.1C14.47 7.41 13.26 7 12 7c-1.29 0-2.5.41-3.5 1.14c-.82-.59-1.78-.97-2.79-1.1A8 8 0 0 1 12 4m0-2c-4.91 0-8.97 3.5-9.84 8.17C2.89 9.45 3.89 9 5 9c1.5 0 2.81.86 3.5 2.1A3.97 3.97 0 0 1 12 9c1.5 0 2.8.85 3.5 2.09A3.93 3.93 0 0 1 19 9c1.09 0 2.09.42 2.81 1.14C20.94 5.5 16.88 2 12 2Z"/>'
        },
        paragliding: {
            body: '<path fill="currentColor" d="M12 17c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m7-3h-2c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 2.79 1.64 5.19 4 6.32V23h6v-2.68c2.36-1.13 4-3.53 4-6.32m4-6.24c.04.8-.95 1.3-1.59.84c-.14-.14-.25-.16-.41-.28L18.97 13H17l-1.5-6.27c-2.29-.23-4.71-.23-7 0L7 13H5.03L3 8.32c-.16.12-.27.14-.41.28c-.64.46-1.631-.04-1.59-.84V4s0-3 11-3s11 3 11 3M6.9 7c-.9.2-1.75.43-2.53.71l1.5 3.56L6.9 7m12.73.71C18.85 7.43 18 7.2 17.1 7l1.03 4.27l1.5-3.56Z"/>'
        },
        parking: {
            body: '<path fill="currentColor" d="M13.2 11H10V7h3.2a2 2 0 0 1 2 2a2 2 0 0 1-2 2M13 3H6v18h4v-6h3a6 6 0 0 0 6-6c0-3.32-2.69-6-6-6Z"/>'
        },
        "party-popper": {
            body: '<path fill="currentColor" d="m14.53 1.45l-1.08 1.08l1.6 1.6c.22.25.33.54.33.87s-.11.64-.33.86L11.5 9.47l1 1.08l3.63-3.61c.53-.59.79-1.24.79-1.94s-.26-1.36-.79-1.95l-1.6-1.6m-3.98 2.02L9.47 4.55l.61.56c.22.22.33.52.33.89s-.11.67-.33.89l-.61.56l1.08 1.08l.56-.61c.53-.59.8-1.23.8-1.92c0-.72-.27-1.37-.8-1.97l-.56-.56M21 5.06c-.69 0-1.33.27-1.92.8l-5.63 5.64l1.08 1l5.58-5.56c.25-.25.55-.38.89-.38s.64.13.89.38l.61.61l1.03-1.08l-.56-.61c-.59-.53-1.25-.8-1.97-.8M7 8L2 22l14-5l-9-9m12 3.06c-.7 0-1.34.27-1.94.8l-1.59 1.59l1.08 1.08l1.59-1.59c.25-.25.53-.38.86-.38c.33 0 .63.13.88.38l1.62 1.59l1.05-1.03l-1.6-1.64c-.59-.53-1.25-.8-1.95-.8Z"/>'
        },
        passport: {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6m6 3a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 1c-.41.62-.75 1.29-.96 2h1.92A7.23 7.23 0 0 0 12 6m-1.3.22C9.78 6.53 9 7.17 8.54 8H10c.18-.62.4-1.22.7-1.78m2.59 0c.3.56.53 1.16.71 1.78h1.46c-.46-.83-1.25-1.46-2.17-1.78M8.13 9c-.08.32-.13.65-.13 1s.05.68.13 1h1.69c-.04-.33-.07-.66-.07-1c0-.34.03-.67.07-1H8.13m2.7 0c-.05.32-.08.66-.08 1c0 .34.03.67.08 1h2.34c.04-.33.08-.66.08-1c0-.34-.04-.68-.08-1h-2.34m3.35 0c.04.33.07.66.07 1c0 .34-.03.67-.07 1h1.69c.08-.32.13-.65.13-1s-.05-.68-.13-1h-1.69m-5.64 3c.46.83 1.24 1.46 2.16 1.78c-.3-.56-.52-1.15-.7-1.78H8.54m2.5 0c.21.72.55 1.38.96 2c.42-.62.75-1.28.96-2h-1.92M14 12c-.18.63-.41 1.22-.71 1.78c.92-.32 1.71-.95 2.17-1.78H14m-7 5h10v2H7v-2Z"/>'
        },
        "passport-biometric": {
            body: '<path fill="currentColor" d="M4 4a2 2 0 0 0-2 2v5h6.13c.46-1.76 2.05-3 3.87-3a4.01 4.01 0 0 1 3.87 3H22V6a2 2 0 0 0-2-2H4m8 6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M2 13v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5h-6.13A4.01 4.01 0 0 1 12 16a4.01 4.01 0 0 1-3.87-3H2Z"/>'
        },
        pasta: {
            body: '<path fill="currentColor" d="M4 16.5V8H3V7h1V6H3V5h1V4H3V3h6c.5.03.95.24 1.34.63s.61.87.66 1.37h10v1H11c-.05.53-.27 1-.66 1.43S9.5 8.05 9 8H7v7.05c.05 0 .13-.01.24-.05s.2 0 .26 0c.56 0 1.2.14 1.92.42c.41-.92 1.11-1.74 2.11-2.42s2-1 3-1c1.53 0 2.83.53 3.89 1.59S20 15.95 20 17.5v.27c0 .13-.03.2-.03.23H3.14c.13-.5.41-1 .86-1.5m2-1.27V8H5v7.7c.5-.25.81-.4 1-.47M9 7V6H7v1h2m0-3H7v1h2V4M5 4v1h1V4H5m0 2v1h1V6H5M2 19h20l-2 2H4l-2-2Z"/>'
        },
        "patio-heater": {
            body: '<path fill="currentColor" d="M15 22H9v-1h6v1m4-18l-4-2H9L5 4h14M8 5l.4 1h7.2l.4-1H8m2 5h1v5c-.6 0-1 .4-1 1v4h4v-4c0-.6-.4-1-1-1v-5h1l.4-1H9.6l.4 1m-.8-2h5.6l.4-1H8.8l.4 1Z"/>'
        },
        patreon: {
            body: '<path fill="currentColor" d="M14.82 2.41c3.96 0 7.18 3.24 7.18 7.21c0 3.96-3.22 7.18-7.18 7.18c-3.97 0-7.21-3.22-7.21-7.18c0-3.97 3.24-7.21 7.21-7.21M2 21.6h3.5V2.41H2V21.6Z"/>'
        },
        pause: {
            body: '<path fill="currentColor" d="M14 19h4V5h-4M6 19h4V5H6v14Z"/>'
        },
        "pause-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-8 13H9V8h2v8m4 0h-2V8h2v8Z"/>'
        },
        "pause-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14v14m-6-3V8h2v8h-2m-4 0V8h2v8H9"/>'
        },
        "pause-circle": {
            body: '<path fill="currentColor" d="M15 16h-2V8h2m-4 8H9V8h2m1-6A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "pause-circle-outline": {
            body: '<path fill="currentColor" d="M13 16V8h2v8h-2m-4 0V8h2v8H9m3-14a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "pause-octagon": {
            body: '<path fill="currentColor" d="M15.73 3L21 8.27v7.46L15.73 21H8.27L3 15.73V8.27L8.27 3h7.46M15 16V8h-2v8h2m-4 0V8H9v8h2Z"/>'
        },
        "pause-octagon-outline": {
            body: '<path fill="currentColor" d="M15 16h-2V8h2v8m-4 0H9V8h2v8m4.73-13L21 8.27v7.46L15.73 21H8.27L3 15.73V8.27L8.27 3h7.46m-.83 2H9.1L5 9.1v5.8L9.1 19h5.8l4.1-4.1V9.1L14.9 5Z"/>'
        },
        paw: {
            body: '<path fill="currentColor" d="M8.35 3c1.18-.17 2.43 1.12 2.79 2.9c.36 1.77-.29 3.35-1.47 3.53c-1.17.18-2.43-1.11-2.8-2.89c-.37-1.77.3-3.35 1.48-3.54m7.15 0c1.19.19 1.85 1.77 1.5 3.54c-.38 1.78-1.63 3.07-2.81 2.89c-1.19-.18-1.84-1.76-1.47-3.53c.36-1.78 1.61-3.07 2.78-2.9M3 7.6c1.14-.49 2.69.4 3.5 1.95c.76 1.58.5 3.24-.63 3.73c-1.13.49-2.67-.39-3.46-1.96C1.62 9.75 1.9 8.08 3 7.6m18 0c1.1.48 1.38 2.15.59 3.72c-.79 1.57-2.33 2.45-3.46 1.96c-1.13-.49-1.39-2.15-.63-3.73C18.31 8 19.86 7.11 21 7.6m-1.67 10.78c.04.94-.68 1.98-1.54 2.37c-1.79.82-3.91-.88-5.9-.88c-1.99 0-4.13 1.77-5.89.88c-1-.49-1.69-1.79-1.56-2.87c.18-1.49 1.97-2.29 3.03-3.38c1.41-1.41 2.41-4.06 4.42-4.06c2 0 3.06 2.61 4.41 4.06c1.11 1.22 2.96 2.25 3.03 3.88Z"/>'
        },
        "paw-off": {
            body: '<path fill="currentColor" d="M2 4.27L3.28 3L21.5 21.22l-1.27 1.28l-2-2c-.14.1-.29.18-.44.25c-1.79.82-3.91-.88-5.9-.88c-1.99 0-4.13 1.77-5.89.88c-1-.49-1.69-1.79-1.56-2.87c.18-1.49 1.97-2.29 3.03-3.38c.74-.73 1.37-1.81 2.08-2.68L2 4.27M8.35 3c1.18-.17 2.43 1.12 2.79 2.9c.18.85.12 1.66-.14 2.29L7.03 4.2c.26-.65.72-1.1 1.32-1.2m7.15 0c1.19.19 1.85 1.77 1.5 3.54c-.38 1.78-1.63 3.07-2.81 2.89c-1.19-.18-1.84-1.76-1.47-3.53c.36-1.78 1.61-3.07 2.78-2.9M3 7.6c1.14-.49 2.69.4 3.5 1.95c.76 1.58.5 3.24-.63 3.73c-1.13.49-2.67-.39-3.46-1.96C1.62 9.75 1.9 8.08 3 7.6m18 0c1.1.48 1.38 2.15.59 3.72c-.79 1.57-2.33 2.45-3.46 1.96c-1.13-.49-1.39-2.15-.63-3.73C18.31 8 19.86 7.11 21 7.6Z"/>'
        },
        "paw-off-outline": {
            body: '<path fill="currentColor" d="M22.83 8.25c-.27-.75-.78-1.29-1.44-1.57c-1.17-.5-2.59-.08-3.69.98c.11-.29.21-.6.3-.93c.25-1.35 0-2.7-.62-3.61c-.43-.62-1.05-1.01-1.74-1.12c-1.54-.22-3.07 1.08-3.71 3c-.65-1.95-2.19-3.24-3.74-3c-.69.12-1.31.53-1.74 1.16l-.03.06l1.49 1.49c.05-.17.09-.31.19-.42c.12-.17.26-.29.4-.29c.5-.09 1.38.69 1.66 2.1c.07.34.08.65.06.9l1.66 1.68c.01-.03.03-.06.05-.1c.04.11.11.2.16.31l1.34 1.34a2.27 2.27 0 0 0 .98.22c.72 0 1.42-.33 2.02-.88c-.43 1.07-.47 2.16-.14 3.06c.27.72.78 1.28 1.44 1.57c.34.14.7.21 1.07.21c1.38 0 2.86-1.01 3.7-2.64c.58-1.19.71-2.47.33-3.52M16 6.33c-.28 1.4-1.17 2.17-1.66 2.11c-.06-.01-.22-.03-.4-.29c-.25-.36-.44-1.08-.24-2.05c.27-1.34 1.1-2.1 1.59-2.1h.07c.14 0 .27.11.39.27c.32.46.43 1.27.25 2.06m4.7 4.54c-.58 1.13-1.62 1.73-2.17 1.49c-.06-.02-.25-.1-.37-.43c-.16-.5-.09-1.25.23-1.93c.51-.96 1.35-1.53 1.94-1.53c.1 0 .17.03.27.03c.15.08.27.22.35.44c.14.4.15 1.12-.25 1.93M1.11 3L4.8 6.69c-.74-.28-1.51-.3-2.2-.01c-.66.29-1.17.85-1.43 1.59c-.377 1.04-.251 2.31.33 3.5c.84 1.63 2.32 2.64 3.71 2.64c.36 0 .72-.07 1.06-.21c.66-.29 1.17-.85 1.44-1.57c.29-.84.29-1.86-.07-2.87c.19.15.4.27.6.37l1.49 1.49c-.79.88-1.46 2.08-2.26 2.88c-1.06 1.09-2.85 1.89-3.03 3.38c-.13 1.08.56 2.38 1.56 2.87c.35.18.72.25 1.1.25c1.51 0 3.2-1.13 4.79-1.13c1.61 0 3.29 1.1 4.82 1.1c.37 0 .73-.06 1.08-.22c.21-.1.44-.25.64-.43l2.41 2.41l1.27-1.27L2.39 1.73L1.11 3m10.04 10.04L17 18.9c0 .01-.03.02-.04.03a.56.56 0 0 1-.25.04c-.43 0-1.08-.22-1.71-.43c-.92-.31-1.97-.67-3.11-.67s-2.19.37-3.11.69c-.63.21-1.28.44-1.68.44c-.13 0-.18 0-.22-.05c-.22-.11-.48-.58-.45-.83c.07-.23.8-.81 1.16-1.12c.44-.32.91-.67 1.3-1.09c.55-.55 1-1.18 1.44-1.79c.22-.32.53-.74.82-1.08M5.6 10c.33.68.4 1.43.24 1.93c-.13.33-.31.41-.37.43c-.55.24-1.59-.36-2.17-1.49c-.4-.81-.39-1.52-.25-1.93c.08-.21.2-.36.35-.44c.1 0 .17-.04.28-.04c.58 0 1.42.57 1.92 1.54Z"/>'
        },
        "paw-outline": {
            body: '<path fill="currentColor" d="M22.83 8.25c-.27-.75-.78-1.29-1.43-1.57c-1.17-.5-2.59-.08-3.7.98c.11-.29.21-.6.3-.93c.25-1.35.03-2.7-.62-3.61c-.43-.62-1.05-1.01-1.74-1.12c-1.54-.22-3.07 1.08-3.71 3c-.64-1.95-2.19-3.24-3.74-3c-.69.12-1.31.53-1.74 1.16c-.64.93-.84 2.23-.56 3.58c.05.26.11.5.2.73C5 6.56 3.7 6.2 2.6 6.68c-.66.29-1.16.85-1.43 1.59c-.376 1.04-.25 2.31.33 3.5c.84 1.63 2.32 2.64 3.71 2.64c.36 0 .72-.07 1.06-.21c.66-.29 1.17-.85 1.44-1.57c.32-.84.29-1.86-.07-2.87c.55.43 1.17.69 1.81.69c.12 0 .25-.01.37-.03c.68-.1 1.3-.5 1.73-1.12c.15-.22.28-.46.38-.72c.1.26.22.5.37.71c.43.62 1.05 1.02 1.74 1.13c.12.02.25.03.37.03c.72 0 1.42-.33 2.02-.88c-.43 1.07-.47 2.16-.14 3.06c.27.73.78 1.28 1.44 1.57c.34.14.7.21 1.07.21c1.38 0 2.86-1.01 3.7-2.64c.58-1.19.71-2.47.33-3.52M5.84 11.93c-.12.33-.31.41-.37.43c-.55.24-1.59-.36-2.17-1.49c-.4-.81-.39-1.52-.25-1.93c.08-.21.2-.36.35-.44c.1 0 .18-.04.28-.04c.58 0 1.42.57 1.92 1.54c.33.68.43 1.43.24 1.93m4.07-3.77c-.12.16-.25.26-.41.28c-.5.06-1.36-.71-1.65-2.1c-.2-.96 0-1.68.25-2.05c.12-.17.26-.29.4-.29c.5-.09 1.38.69 1.66 2.1c.2.97 0 1.7-.25 2.06M16 6.33c-.28 1.4-1.17 2.17-1.66 2.11c-.06-.01-.22-.03-.4-.29c-.25-.36-.44-1.08-.24-2.05c.27-1.34 1.1-2.1 1.59-2.1h.07c.14 0 .27.11.39.27c.32.46.43 1.27.25 2.06m4.7 4.54c-.58 1.13-1.62 1.73-2.17 1.49c-.06-.02-.25-.1-.37-.43c-.16-.5-.09-1.25.23-1.93c.51-.96 1.36-1.53 1.94-1.53c.1 0 .17.03.27.03h.01c.15.08.26.22.34.44c.15.4.16 1.12-.25 1.93m-4.4 3.63c-1.35-1.45-2.41-4.06-4.41-4.06c-2.01 0-3.01 2.65-4.42 4.06c-1.06 1.09-2.85 1.89-3.03 3.38c-.13 1.08.56 2.38 1.56 2.87c.35.18.72.25 1.1.25c1.51 0 3.2-1.13 4.79-1.13c1.61 0 3.29 1.1 4.82 1.1c.37 0 .73-.06 1.08-.22c.86-.39 1.58-1.43 1.54-2.37c-.07-1.63-1.92-2.66-3.03-3.88m.66 4.43a.56.56 0 0 1-.25.04c-.42 0-1.08-.22-1.71-.43c-.92-.31-1.97-.67-3.11-.67s-2.19.37-3.11.69c-.63.21-1.28.44-1.68.44c-.13 0-.18 0-.22-.05c-.22-.11-.48-.58-.45-.83c.07-.23.8-.81 1.16-1.12c.44-.32.91-.67 1.3-1.09c.55-.55 1-1.18 1.44-1.79c.45-.62 1.2-1.68 1.56-1.68c.4 0 1.19 1.12 1.67 1.78c.39.56.8 1.13 1.26 1.63c.39.42.8.79 1.18 1.15c.54.45 1.32 1.14 1.33 1.44c-.01.14-.21.42-.37.49Z"/>'
        },
        paypal: {
            body: '<path d="M8.32 21.97a.546.546 0 0 1-.26-.32c-.03-.15-.06.11.6-4.09c.6-3.8.59-3.74.67-3.85c.13-.17.11-.17 1.61-.18c1.32-.03 1.6-.03 2.19-.12c3.25-.45 5.26-2.36 5.96-5.66c.04-.22.08-.41.09-.41c0-.01.07.04.15.1c1.03.78 1.38 2.22.99 4.14c-.46 2.29-1.68 3.81-3.58 4.46c-.81.28-1.49.39-2.69.42c-.8.04-.82.04-1.05.19c-.17.17-.16.14-.55 2.55c-.27 1.7-.37 2.25-.41 2.35c-.07.16-.21.3-.37.38l-.11.07H10c-1.29 0-1.62 0-1.68-.03m-4.5-2.23c-.19-.1-.32-.27-.32-.47C3.5 19 6.11 2.68 6.18 2.5c.09-.18.32-.37.5-.44L6.83 2h3.53c3.91 0 3.76 0 4.64.2c2.62.55 3.82 2.3 3.37 4.93c-.5 2.93-1.98 4.67-4.5 5.3c-.87.21-1.48.27-3.14.27c-1.31 0-1.41.01-1.67.15c-.26.15-.47.42-.56.75c-.04.07-.27 1.47-.53 3.1a241.3 241.3 0 0 0-.47 3.02l-.03.06H5.69c-1.58 0-1.8 0-1.87-.04z" fill="currentColor"/>',
            hidden: true
        },
        peace: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 12.41v5.52a7.988 7.988 0 0 1-3.9-1.62l3.9-3.9m2 0l3.9 3.9a7.988 7.988 0 0 1-3.9 1.62v-5.52M4 12c0-4.03 3-7.43 7-7.93v7.52L5.69 16.9A7.913 7.913 0 0 1 4 12m14.31 4.9L13 11.59V4.07c4 .5 7 3.9 7 7.93c0 1.78-.59 3.5-1.69 4.9Z"/>'
        },
        peanut: {
            body: '<path fill="currentColor" d="M16 12.77a2 2 0 0 1-.14-2.65a5 5 0 0 0-2.82-8A5.74 5.74 0 0 0 12 2a5 5 0 0 0-5 5a5 5 0 0 0 1.11 3.12a2 2 0 0 1-.11 2.6a5.5 5.5 0 0 0 2.81 9.15A5.42 5.42 0 0 0 12 22a5.5 5.5 0 0 0 4-9.23M13 5a1 1 0 1 1-1 1a1 1 0 0 1 1-1m-2 13a1 1 0 1 1 1-1a1 1 0 0 1-1 1m1-3a1 1 0 1 1 1 1a1 1 0 0 1-1-1m2 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "peanut-off": {
            body: '<path fill="currentColor" d="M15.9 10.12a5 5 0 0 0-2.82-8A5.74 5.74 0 0 0 12 2a5 5 0 0 0-4.32 2.5l8.7 8.68a4.35 4.35 0 0 0-.34-.41a2 2 0 0 1-.14-2.65M13 7a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-6-.61L2.39 1.73L1.11 3L7.8 9.69c.1.15.2.31.31.43a2 2 0 0 1-.11 2.6a5.5 5.5 0 0 0 2.81 9.15A5.42 5.42 0 0 0 12 22a5.5 5.5 0 0 0 5-3.14l3.87 3.87l1.27-1.27M11 18a1 1 0 1 1 1-1a1 1 0 0 1-1 1m3 1a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-1-3a1 1 0 0 1-1-1a1 1 0 0 1 .35-.76l1.41 1.41A1 1 0 0 1 13 16Z"/>'
        },
        "peanut-off-outline": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27l-3.15-3.15c-.33.63-.76 1.19-1.28 1.67a6.432 6.432 0 0 1-5.8 1.6c-3.51-.75-5.74-4.21-4.99-7.72c.25-1.18.83-2.26 1.66-3.13a.93.93 0 0 0 0-1.28a6.029 6.029 0 0 1-1.24-2.79L1.11 3l1.28-1.27l19.72 19.73m-6.81-1.9c.39-.43.7-.93.89-1.48l-2.44-2.44c-.18.23-.46.36-.75.36c-.55 0-1-.45-1-1c0-.29.13-.57.36-.75l-2.81-2.81c-.02.74-.31 1.44-.82 1.97c-1.7 1.81-1.6 4.66.21 6.36l.01.01a4.5 4.5 0 0 0 6.35-.22M14 17c-1.29 0-1.28 2 0 2s1.29-2 0-2M6.9 3.7l1.53 1.53c.25-.52.62-.98 1.07-1.34c.7-.58 1.59-.89 2.5-.89h.88c.59.14 1.12.41 1.62.79c1.72 1.38 2 3.9.62 5.62a3.01 3.01 0 0 0-.67 1.84l3.87 3.87c-.25-1.15-.82-2.2-1.6-3.06c-.35-.36-.39-.93-.1-1.34C16.62 10.72 18 9 18 7S15.97.997 12 .997S6.9 3.7 6.9 3.7M12 17c0-1.29-2-1.28-2 0s2 1.29 2 0m1-12c-1.29 0-1.28 2 0 2s1.29-2 0-2Z"/>'
        },
        "peanut-outline": {
            body: '<path fill="currentColor" d="M12 23c-.47 0-.93-.05-1.39-.15c-3.51-.75-5.74-4.21-4.99-7.72c.25-1.18.83-2.26 1.66-3.13a.93.93 0 0 0 0-1.28c-2.08-2.58-1.68-6.36.9-8.44s6.36-1.673 8.44.91c1.77 2.19 1.77 5.31 0 7.53c-.29.41-.25.98.1 1.34c2.45 2.62 2.32 6.74-.31 9.19A6.443 6.443 0 0 1 12 23m0-20c-.91 0-1.8.31-2.5.89a3.978 3.978 0 0 0-.62 5.61c.96 1.14.89 2.83-.15 3.91c-1.7 1.81-1.6 4.66.21 6.36s4.66 1.61 6.36-.21a4.499 4.499 0 0 0 0-6.15a3 3 0 0 1-.18-4a4.002 4.002 0 0 0-.62-5.62c-.5-.38-1.03-.65-1.62-.79H12m0 3c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m2 13c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m-1-3c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1m-2 2c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1Z"/>'
        },
        pen: {
            body: '<path fill="currentColor" d="M20.71 7.04c-.34.34-.67.67-.68 1c-.03.32.31.65.63.96c.48.5.95.95.93 1.44c-.02.49-.53 1-1.04 1.5l-4.13 4.14L15 14.66l4.25-4.24l-.96-.96l-1.42 1.41l-3.75-3.75l3.84-3.83c.39-.39 1.04-.39 1.41 0l2.34 2.34c.39.37.39 1.02 0 1.41M3 17.25l9.56-9.57l3.75 3.75L6.75 21H3v-3.75Z"/>'
        },
        "pen-lock": {
            body: '<path fill="currentColor" d="M21.7 7c-.3.4-.7.7-.7 1c0 .3.3.6.6 1c.5.5 1 .9.9 1.4c0 .5-.5 1-1 1.5L17.4 16L16 14.7l4.2-4.2l-1-1l-1.4 1.4L14 7.1l4-3.8c.4-.4 1-.4 1.4 0l2.3 2.3c.4.4.4 1.1 0 1.4M4 17.2l9.6-9.6l3.7 3.8L7.8 21H4v-3.8M8 5v-.5C8 3.1 6.9 2 5.5 2S3 3.1 3 4.5V5c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h5c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1M7 5H4v-.5C4 3.7 4.7 3 5.5 3S7 3.7 7 4.5V5Z"/>'
        },
        "pen-minus": {
            body: '<path fill="currentColor" d="M20.7 7c-.3.4-.7.7-.7 1c0 .3.3.6.6 1c.5.5 1 .9.9 1.4c0 .5-.5 1-1 1.5L16.4 16L15 14.7l4.2-4.2l-1-1l-1.4 1.4L13 7.1l4-3.8c.4-.4 1-.4 1.4 0l2.3 2.3c.4.4.4 1.1 0 1.4M3 17.2l9.6-9.6l3.7 3.8L6.8 21H3v-3.8M10 5v2H2V5h8Z"/>'
        },
        "pen-off": {
            body: '<path fill="currentColor" d="M2.3 5L1 6.3l6.5 6.5L3 17.2V21h3.8l4.5-4.5l6.5 6.5l1.3-1.3L2.3 5m14.6 5.9l-3.8-3.8L17 3.3c.4-.4 1-.4 1.4 0l2.3 2.3c.4.4.4 1 0 1.4c-.3.4-.7.7-.7 1c0 .3.3.7.6 1c.5.5 1 1 .9 1.4c0 .5-.5 1-1 1.5L16.4 16L15 14.7l4.2-4.2l-1-1l-1.3 1.4m-6.9-.7l2.5-2.5l3.8 3.8l-2.5 2.5l-3.8-3.8Z"/>'
        },
        "pen-plus": {
            body: '<path fill="currentColor" d="M20.7 7c-.3.4-.7.7-.7 1c0 .3.3.6.6 1c.5.5 1 .9.9 1.4c0 .5-.5 1-1 1.5L16.4 16L15 14.7l4.2-4.2l-1-1l-1.4 1.4L13 7.1l4-3.8c.4-.4 1-.4 1.4 0l2.3 2.3c.4.4.4 1.1 0 1.4M3 17.2l9.6-9.6l3.7 3.8L6.8 21H3v-3.8M7 2v3h3v2H7v3H5V7H2V5h3V2h2Z"/>'
        },
        "pen-remove": {
            body: '<path fill="currentColor" d="M20.7 7c-.3.4-.7.7-.7 1c0 .3.3.6.6 1c.5.5 1 .9.9 1.4c0 .5-.5 1-1 1.5L16.4 16L15 14.7l4.2-4.2l-1-1l-1.4 1.4L13 7.1l4-3.8c.4-.4 1-.4 1.4 0l2.3 2.3c.4.4.4 1.1 0 1.4M3 17.2l9.6-9.6l3.7 3.8L6.8 21H3v-3.8m.88-14.74L6 4.59l2.12-2.13l1.42 1.42L7.41 6l2.13 2.12l-1.42 1.42L6 7.41L3.88 9.54L2.46 8.12L4.59 6L2.46 3.88l1.42-1.42Z"/>'
        },
        pencil: {
            body: '<path fill="currentColor" d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83l3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25Z"/>'
        },
        "pencil-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-2.3 6.35c.22-.21.22-.56 0-.77L15.42 7.3a.532.532 0 0 0-.77 0l-1 1l2.05 2.05l1-1M7 14.94V17h2.06l6.06-6.06l-2.06-2.06L7 14.94Z"/>'
        },
        "pencil-box-multiple": {
            body: '<path fill="currentColor" d="M20.22 2H7.78C6.8 2 6 2.8 6 3.78v12.44C6 17.2 6.8 18 7.78 18h12.44c.98 0 1.78-.79 1.78-1.78V3.78C22 2.8 21.2 2 20.22 2m-9.16 13H9v-2.06l6.06-6.06l2.06 2.06L11.06 15m7.64-7.65l-1 1l-2.05-2.05l1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6Z"/>'
        },
        "pencil-box-multiple-outline": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m14.7 1.35l-1 1l-2.05-2.05l1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M9 12.94l6.06-6.06l2.06 2.06L11.06 15H9v-2.06M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"/>'
        },
        "pencil-box-outline": {
            body: '<path fill="currentColor" d="M19 19V5H5v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-2.3 6.35l-1 1l-2.05-2.05l1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M7 14.94l6.06-6.06l2.06 2.06L9.06 17H7v-2.06Z"/>'
        },
        "pencil-circle": {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>'
        },
        "pencil-circle-outline": {
            body: '<path fill="currentColor" d="m7 14.94l6.06-6.06l2.06 2.06L9.06 17H7v-2.06M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m4.7-10.65l-1 1l-2.05-2.05l1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2"/>'
        },
        "pencil-lock": {
            body: '<path fill="currentColor" d="M5.5 2A2.5 2.5 0 0 0 3 4.5V5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1v-.5A2.5 2.5 0 0 0 5.5 2m0 1A1.5 1.5 0 0 1 7 4.5V5H4v-.5A1.5 1.5 0 0 1 5.5 3m14.16 0c-.26 0-.5.09-.69.28l-1.84 1.85l3.75 3.75l1.84-1.85c.39-.39.39-1.03 0-1.4l-2.34-2.35c-.2-.19-.47-.28-.72-.28m-3.6 3.19L5 17.25V21h3.75L19.81 9.94l-3.75-3.75Z"/>'
        },
        "pencil-lock-outline": {
            body: '<path fill="currentColor" d="m16.1 9l.9.9L7.9 19H7v-.9L16.1 9m3.6-6c-.2 0-.5.1-.7.3l-1.8 1.8l3.7 3.8L22.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.2-.2-.5-.3-.7-.3m-3.6 3.2L5 17.2V21h3.8l11-11.1l-3.7-3.7M8 5v-.5C8 3.1 6.9 2 5.5 2S3 3.1 3 4.5V5c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h5c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1M7 5H4v-.5C4 3.7 4.7 3 5.5 3S7 3.7 7 4.5V5Z"/>'
        },
        "pencil-minus": {
            body: '<path fill="currentColor" d="M20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.8 1.8L19 8.9M3 17.2V21h3.8l11-11.1l-3.7-3.8L3 17.2M10 5v2H2V5h8Z"/>'
        },
        "pencil-minus-outline": {
            body: '<path fill="currentColor" d="m14.1 9l.9.9L5.9 19H5v-.9L14.1 9m3.6-6c-.2 0-.5.1-.7.3l-1.8 1.8l3.7 3.8L20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.2-.2-.5-.3-.7-.3m-3.6 3.2L3 17.2V21h3.8l11-11.1l-3.7-3.7M10 5v2H2V5h8Z"/>'
        },
        "pencil-off": {
            body: '<path fill="currentColor" d="M18.66 2c-.26 0-.5.09-.69.28l-1.84 1.85l3.75 3.75l1.84-1.85c.39-.39.39-1.03 0-1.4l-2.34-2.35c-.2-.19-.47-.28-.72-.28M3.28 4L2 5.28l6.5 6.47l-4.5 4.5V20h3.75l4.5-4.5l6.47 6.5L20 20.72l-6.5-6.47l-3.75-3.75L3.28 4m11.78 1.19l-4.03 4.03l3.75 3.75l4.03-4.03l-3.75-3.75Z"/>'
        },
        "pencil-off-outline": {
            body: '<path fill="currentColor" d="m10 10.2l4-4l3.8 3.8l-4 4l-1.4-1.4L15 9.9l-.9-.9l-2.6 2.6l-1.5-1.4m10.7-4.6l-2.3-2.3c-.2-.2-.5-.3-.7-.3c-.2 0-.5.1-.7.3l-1.8 1.8L19 8.9L20.7 7c.4-.3.4-1 0-1.4M19 21.7L17.7 23l-6.5-6.5L6.8 21H3v-3.8l4.5-4.5L1 6.3L2.3 5L19 21.7m-9.2-6.6l-.9-.9L5 18.1v.9h.9l3.9-3.9Z"/>'
        },
        "pencil-outline": {
            body: '<path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92L14.06 9m3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75Z"/>'
        },
        "pencil-plus": {
            body: '<path fill="currentColor" d="M20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.8 1.8L19 8.9M3 17.2V21h3.8l11-11.1l-3.7-3.8L3 17.2M7 2v3h3v2H7v3H5V7H2V5h3V2h2Z"/>'
        },
        "pencil-plus-outline": {
            body: '<path fill="currentColor" d="m14.1 9l.9.9L5.9 19H5v-.9L14.1 9m3.6-6c-.2 0-.5.1-.7.3l-1.8 1.8l3.7 3.8L20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.2-.2-.5-.3-.7-.3m-3.6 3.2L3 17.2V21h3.8l11-11.1l-3.7-3.7M7 2v3h3v2H7v3H5V7H2V5h3V2h2Z"/>'
        },
        "pencil-remove": {
            body: '<path fill="currentColor" d="M20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.8 1.8L19 8.9M3 17.2V21h3.8l11-11.1l-3.7-3.8L3 17.2m.9-14.8L6 4.5l2.1-2.1l1.4 1.4l-2.1 2.1L9.5 8L8.1 9.5L6 7.4L3.9 9.5L2.5 8.1L4.6 6L2.5 3.8l1.4-1.4Z"/>'
        },
        "pencil-remove-outline": {
            body: '<path fill="currentColor" d="M17.7 3c-.2 0-.5.1-.7.3l-1.8 1.8l3.7 3.8L20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.2-.2-.5-.3-.7-.3m-3.6 3.2L3 17.2V21h3.8l11-11.1l-3.7-3.7M5.9 19H5v-.9L14.1 9l.9.9L5.9 19m-2-16.5L6 4.6l2.1-2.1l1.4 1.4L7.4 6l2.1 2.1l-1.4 1.4L6 7.4L3.9 9.5L2.5 8.1L4.6 6L2.5 3.9l1.4-1.4Z"/>'
        },
        "pencil-ruler": {
            body: '<path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25m19.61 1.11l-4.25 4.25l-5.2-5.2l1.77-1.77l1 1l2.47-2.48l1.42 1.42L18.36 17l1.06 1l1.42-1.4l1.77 1.76m-16-7.53L1.39 5.64l4.25-4.25L7.4 3.16L4.93 5.64L6 6.7l2.46-2.48l1.42 1.42l-1.42 1.41l1 1l-2.85 2.78M20.71 7c.39-.39.39-1 0-1.41l-2.34-2.3c-.37-.39-1.02-.39-1.41 0l-1.84 1.83l3.75 3.75L20.71 7Z"/>'
        },
        penguin: {
            body: '<path fill="currentColor" d="M19 16c0 1.72-.63 3.3-1.66 4.5c.41.39.66.91.66 1.5H6c0-.59.25-1.11.66-1.5A6.902 6.902 0 0 1 5 16H3c0-1.25.57-2.36 1.46-3.09l.01-.02A6.004 6.004 0 0 0 7 8V7a5 5 0 0 1 5-5a5 5 0 0 1 5 5v1c0 2 1 3.81 2.53 4.89l.01.02c.89.73 1.46 1.84 1.46 3.09h-2m-3 0a4 4 0 0 0-4-4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4m-6-7l2 1.5L14 9l-2-1.5L10 9m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        pentagon: {
            body: '<path fill="currentColor" d="M12 2.5L2 9.8l3.8 11.7h12.4L22 9.8L12 2.5Z"/>'
        },
        "pentagon-outline": {
            body: '<path fill="currentColor" d="m12 5l7.6 5.5l-2.9 8.9H7.3l-2.9-8.9L12 5m0-2.5L2 9.8l3.8 11.7h12.3L22 9.8L12 2.5Z"/>'
        },
        pentagram: {
            body: '<path fill="currentColor" d="m16.15 14.4l2.56 7.86L12 17.4l-6.72 4.9l2.57-7.93l-6.7-4.87h8.29L12 1.61l2.56 7.89h8.33l-6.74 4.9m-2.85 2.07l2.56 1.86l-.98-3.01l-1.58 1.15M11 9.5h2l-1-3.03l-1 3.03m-.26 6.97L9.13 15.3l-1 3.07l2.61-1.9M18.28 11h-3.23l.62 1.9l2.61-1.9m-7.75 0l-.91 2.8L12 15.54l2.39-1.72l-.92-2.82h-2.94m-4.77 0l2.58 1.87l.61-1.87H5.76Z"/>'
        },
        percent: {
            body: '<path fill="currentColor" d="m18.5 3.5l-15 15l2 2l15-15M7 4a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m10 10a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "percent-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2M8.83 7.05c.98 0 1.77.79 1.77 1.78c0 .98-.79 1.77-1.77 1.77c-.99 0-1.78-.79-1.78-1.77c0-.99.79-1.78 1.78-1.78M15.22 17c-.98 0-1.77-.8-1.77-1.78s.79-1.77 1.77-1.77s1.78.79 1.78 1.77S16.2 17 15.22 17m-6.72.03L7 15.53L15.53 7l1.5 1.5l-8.53 8.53Z"/>'
        },
        "percent-box-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-2-3.78c0 .98-.8 1.78-1.78 1.78s-1.77-.8-1.77-1.78s.79-1.77 1.77-1.77s1.78.79 1.78 1.77m-8.5 1.81L7 15.53L15.53 7l1.5 1.5l-8.53 8.53m-1.45-8.2c0-.99.79-1.78 1.78-1.78c.98 0 1.77.79 1.77 1.78c0 .98-.79 1.77-1.77 1.77c-.99 0-1.78-.79-1.78-1.77Z"/>'
        },
        "percent-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M8.83 7.05c.98 0 1.77.79 1.77 1.78c0 .98-.79 1.77-1.77 1.77c-.99 0-1.78-.79-1.78-1.77c0-.99.79-1.78 1.78-1.78M15.22 17c-.98 0-1.77-.8-1.77-1.78s.79-1.77 1.77-1.77s1.78.79 1.78 1.77S16.2 17 15.22 17m-6.72.03L7 15.53L15.53 7l1.5 1.5l-8.53 8.53Z"/>'
        },
        "percent-circle-outline": {
            body: '<path fill="currentColor" d="M17 15.22c0 .98-.8 1.78-1.78 1.78s-1.77-.8-1.77-1.78s.79-1.77 1.77-1.77s1.78.79 1.78 1.77M8.83 10.6c.98 0 1.77-.79 1.77-1.77c0-.99-.79-1.78-1.77-1.78c-.99 0-1.78.79-1.78 1.78c0 .98.79 1.77 1.78 1.77M7 15.53l1.5 1.5l8.53-8.53l-1.5-1.5L7 15.53M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-2 0c0-4.41-3.59-8-8-8s-8 3.59-8 8s3.59 8 8 8s8-3.59 8-8Z"/>'
        },
        "percent-outline": {
            body: '<path fill="currentColor" d="m18.5 3.5l2 2l-15 15l-2-2l15-15M7 4c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m10 10c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3M7 6c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 10c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "periodic-table": {
            body: '<path fill="currentColor" d="M2 4v2h2V4H2m18 0v2h2V4h-2M2 7v2h2V7H2m3 0v2h2V7H5m9 0v2h2V7h-2m3 0v2h2V7h-2m3 0v2h2V7h-2M2 10v2h2v-2H2m3 0v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2M2 13v2h2v-2H2m3 0v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2M5 17v2h2v-2H5m3 0v2h2v-2H8m3 0v2h2v-2h-2m3 0v2h2v-2h-2m3 0v2h2v-2h-2Z"/>'
        },
        periscope: {
            body: '<path d="M12 7a2 2 0 0 1-2 2a2 2 0 0 1-2-2c-.63.84-1 1.87-1 3a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5c-.43 0-.84.05-1.23.15C11.5 5.45 12 6.17 12 7m0-5a8 8 0 0 1 8 8c0 1.05-.2 2.04-.57 2.96C17.89 17.38 13.63 22 12 22s-5.89-4.62-7.43-9.04A7.88 7.88 0 0 1 4 10a8 8 0 0 1 8-8z" fill="currentColor"/>',
            hidden: true
        },
        "perspective-less": {
            body: '<path fill="currentColor" d="m16.56 12l2.67 8H4.78l2.66-8h9.12M7 1L3 5l4 4V6h4V4H7V1m10 0v3h-4v2h4v3l4-4l-4-4m1 9H6L2 22h20l-4-12Z"/>'
        },
        "perspective-more": {
            body: '<path fill="currentColor" d="m16.56 12l2.67 8H4.78l2.66-8h9.12M17 1l-4 4l4 4V6h4V4h-4V1M7 1v3H3v2h4v3l4-4l-4-4m11 9H6L2 22h20l-4-12Z"/>'
        },
        ph: {
            body: '<path fill="currentColor" d="M13 7v10h2v-4h2v4h2V7h-2v4h-2V7h-2m-2 8v-2a2 2 0 0 0-2-2H5v10h2v-4h2c1.11 0 2-.89 2-2m-2 0H7v-2h2v2Z"/>'
        },
        phone: {
            body: '<path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2Z"/>'
        },
        "phone-alert": {
            body: '<path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4c0-.56.45-1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57c.11.35.03.74-.25 1.01l-2.2 2.21M17 12v-2h2v2h-2m0-4V2h2v6h-2Z"/>'
        },
        "phone-alert-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m-2-7v-2h2v2h-2m0-4V2h2v6h-2Z"/>'
        },
        "phone-bluetooth": {
            body: '<path fill="currentColor" d="M20 15.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1m-2-8.29l.94.93l-.94.94m0-6.17l.94.94l-.94.94M14.71 9.5L17 7.21V11h.5l2.85-2.86L18.21 6l2.14-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6L14 8.79l.71.71Z"/>'
        },
        "phone-bluetooth-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M18 7.21l.94.93l-.94.94m0-6.17l.94.94l-.94.94M14.71 9.5L17 7.21V11h.5l2.85-2.86L18.21 6l2.14-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6L14 8.79l.71.71Z"/>'
        },
        "phone-cancel": {
            body: '<path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2M16.5 2C14 2 12 4 12 6.5s2 4.5 4.5 4.5S21 9 21 6.5S19 2 16.5 2m0 7.5c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5L18 9.08c-.42.27-.94.42-1.5.42M19.08 8L15 3.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5Z"/>'
        },
        "phone-cancel-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M16.5 2C14 2 12 4 12 6.5s2 4.5 4.5 4.5S21 9 21 6.5S19 2 16.5 2m0 7.5c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5L18 9.08c-.42.27-.94.42-1.5.42M19.08 8L15 3.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5Z"/>'
        },
        "phone-check": {
            body: '<path fill="currentColor" d="M6.62 10.79a15.1 15.1 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1-.25a11.36 11.36 0 0 0 3.59.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1a11.36 11.36 0 0 0 .57 3.57a1 1 0 0 1-.25 1m12.89-3.86l-1.42-1.42L15 8.59l-2.29-2.3l-1.42 1.42l3.71 3.7Z"/>'
        },
        "phone-check-outline": {
            body: '<path fill="currentColor" d="M20 15.5a11.36 11.36 0 0 1-3.57-.57a1 1 0 0 0-1 .25l-2.2 2.2a15.1 15.1 0 0 1-6.59-6.59l2.2-2.2a1 1 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1M5 5h1.54A12.54 12.54 0 0 0 7 7.59L5.79 8.8A15 15 0 0 1 5 5m14 14a15 15 0 0 1-3.8-.76L16.41 17a12.31 12.31 0 0 0 2.59.45m-4-6.01l-3.71-3.7l1.42-1.42L15 8.59l5.29-5.3l1.42 1.42Z"/>'
        },
        "phone-classic": {
            body: '<path fill="currentColor" d="M12 3C7.46 3 3.34 4.78.29 7.67c-.18.18-.29.43-.29.71c0 .28.11.53.29.71l2.48 2.48a1.01 1.01 0 0 0 1.41.01c.79-.74 1.69-1.36 2.66-1.85c.33-.16.56-.5.56-.9v-3.1C8.85 5.25 10.39 5 12 5c1.59 0 3.14.25 4.59.72v3.1c0 .39.23.74.56.9c.98.49 1.85 1.12 2.67 1.85c.18.18.43.28.68.28c.3 0 .55-.11.73-.29l2.48-2.48c.18-.18.29-.43.29-.71c0-.28-.12-.52-.3-.7A16.965 16.965 0 0 0 12 3M9 7v3s-6 5-6 8v4h18v-4c0-3-6-8-6-8V7h-2v2h-2V7H9m3 5a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 1.5A2.5 2.5 0 0 0 9.5 16a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "phone-classic-off": {
            body: '<path fill="currentColor" d="M12 3c4.53 0 8.65 1.78 11.7 4.67c.18.18.3.42.3.7c0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.73.29c-.25 0-.5-.1-.68-.28c-.82-.73-1.69-1.36-2.67-1.85c-.33-.16-.56-.51-.56-.9v-3.1C15.14 5.25 13.59 5 12 5c-1.56 0-3.07.24-4.5.69L5.94 4.11C7.82 3.4 9.86 3 12 3M9 7h2v2h2V7h2v3s6 5 6 8v1.18l-12-12V7M1 4.27L2.28 3L21.5 22.22l-1.27 1.28l-1.5-1.5H3v-4c0-2.14 3.05-5.29 4.8-6.93L6.59 9.86c-.88.47-1.69 1.04-2.41 1.72a1.015 1.015 0 0 1-1.41-.01L.29 9.09A.997.997 0 0 1 0 8.38c0-.28.11-.53.29-.71C.996 7 2.58 5.85 2.58 5.85L1 4.27M8 16a3.999 3.999 0 0 0 7.17 2.44l-1.07-1.08A2.5 2.5 0 0 1 9.5 16c0-.88.45-1.65 1.14-2.09l-1.08-1.08C8.61 13.56 8 14.71 8 16Z"/>'
        },
        "phone-clock": {
            body: '<path fill="currentColor" d="M15.9 1C12.1 1.1 9 4.2 9 8c0 3.9 3.1 7 7 7s7-3.1 7-7s-3.1-7-7.1-7c.1 0 0 0 0 0m.1 2c2.8 0 5 2.2 5 5s-2.2 5-5 5s-5-2.2-5-5s2.2-5 5-5m-1 1v5l3.6 2.2l.8-1.2l-2.9-1.7V4H15M4.6 12.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2c1.1.4 2.3.6 3.6.6c.5 0 1 .5 1 1V22c0 .5-.5 1-1 1C8.6 23 1 15.4 1 6c0-.6.5-1 1-1h3.5c.6 0 1 .4 1 1c0 1.2.2 2.4.6 3.6c.1.4 0 .7-.2 1l-2.3 2.2"/>'
        },
        "phone-dial": {
            body: '<path fill="currentColor" d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2c1.1.4 2.3.6 3.6.6c.6 0 1 .4 1 1V20c0 .6-.4 1-1 1c-9.4 0-17-7.6-17-17c0-.6.5-1 1-1h3.5c.6 0 1 .4 1 1c0 1.2.2 2.4.6 3.6c.1.3 0 .7-.2 1l-2.3 2.2M14 3c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m-6 3c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m-6 3c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m3 0c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1Z"/>'
        },
        "phone-dial-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M15 4c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m-6 3c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m-6 3c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1m3 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1Z"/>'
        },
        "phone-forward": {
            body: '<path fill="currentColor" d="M20 15.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1M18 11l5-5l-5-5v3h-4v4h4v3Z"/>'
        },
        "phone-forward-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m-1-8l5-5l-5-5v3h-4v4h4v3Z"/>'
        },
        "phone-hangup": {
            body: '<path fill="currentColor" d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .4-.23.74-.56.9c-.98.49-1.87 1.12-2.67 1.85c-.17.18-.42.29-.67.29c-.3 0-.55-.12-.73-.3L.29 13.08a.99.99 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.77 7.46 7 12 7c4.54 0 8.66 1.77 11.71 4.67c.18.18.29.43.29.71c0 .27-.11.52-.29.7l-2.48 2.48c-.18.18-.43.3-.73.3a.98.98 0 0 1-.68-.29c-.79-.73-1.68-1.36-2.66-1.85a.996.996 0 0 1-.56-.9v-3.1C15.15 9.25 13.6 9 12 9Z"/>'
        },
        "phone-hangup-outline": {
            body: '<path fill="currentColor" d="M23.71 11.67a17 17 0 0 0-23.42 0a1 1 0 0 0-.29.71a1 1 0 0 0 .29.7l2.48 2.48a1 1 0 0 0 .73.29a1 1 0 0 0 .68-.28a11.5 11.5 0 0 1 2.66-1.85a1 1 0 0 0 .56-.9v-3.1A14.91 14.91 0 0 1 12 9a14.5 14.5 0 0 1 4.59.73v3.1a1 1 0 0 0 .56.9a11.27 11.27 0 0 1 2.67 1.85a1 1 0 0 0 .68.28a1 1 0 0 0 .73-.29l2.48-2.48a1 1 0 0 0 0-1.42m-18.31.55a13.68 13.68 0 0 0-1.87 1.28l-1.07-1.08A15.54 15.54 0 0 1 5.4 10.5m15.1 3a13.75 13.75 0 0 0-1.9-1.27v-1.7a14.26 14.26 0 0 1 2.95 1.9Z"/>'
        },
        "phone-in-talk": {
            body: '<path fill="currentColor" d="M15 12h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3m4 0h2c0-5-4.03-9-9-9v2c3.86 0 7 3.13 7 7m1 3.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Z"/>'
        },
        "phone-in-talk-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m-4-7h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3m4 0h2c0-5-4.03-9-9-9v2c3.86 0 7 3.13 7 7Z"/>'
        },
        "phone-incoming": {
            body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4m15 8V9.5h-3.5L21 4l-1-1l-5.5 5.5V5H13v6h6Z"/>'
        },
        "phone-incoming-outgoing": {
            body: '<path fill="currentColor" d="M20 17.5V21c0 .55-.45 1-1 1C9.61 22 2 14.39 2 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1l-2.2 2.21c1.44 2.84 3.76 5.15 6.59 6.59l2.2-2.2c.28-.27.67-.35 1.02-.24c1.12.37 2.32.57 3.57.57c.55 0 1 .45 1 1m-4-10h-3.5L18 2l-1-1l-5.5 5.5V3H10v6h6V7.5M17 6v1.5h3.5L15 13l1 1l5.5-5.5V12H23V6h-6Z"/>'
        },
        "phone-incoming-outgoing-outline": {
            body: '<path fill="currentColor" d="M19 16.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H3c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M4 6h1.5c.1.9.3 1.8.5 2.6L4.8 9.8C4.4 8.6 4.1 7.3 4 6m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V20M16 9V7.5h-3.5L18 2l-1-1l-5.5 5.5V3H10v6h6m1-3v1.5h3.5L15 13l1 1l5.5-5.5V12H23V6h-6Z"/>'
        },
        "phone-incoming-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m0-8V9.5h-3.5L21 4l-1-1l-5.5 5.5V5H13v6h6Z"/>'
        },
        "phone-lock": {
            body: '<path fill="currentColor" d="M19.2 4h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7m.8.5v-.5A2.5 2.5 0 0 0 17.5 1A2.5 2.5 0 0 0 15 3.5V4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m0 11.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Z"/>'
        },
        "phone-lock-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m.2-15h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7m.8.5v-.5A2.5 2.5 0 0 0 17.5 1A2.5 2.5 0 0 0 15 3.5V4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"/>'
        },
        "phone-log": {
            body: '<path fill="currentColor" d="M20 15.5a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57c.11.35.03.74-.25 1.01l-2.2 2.21c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57M12 3h2v2h-2m3-2h6v2h-6m-3 1h2v2h-2m3-2h6v2h-6m-3 1h2v2h-2m3-2h6v2h-6"/>'
        },
        "phone-log-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M12 3h2v2h-2m3-2h6v2h-6m-3 1h2v2h-2m3-2h6v2h-6m-3 1h2v2h-2m3-2h6v2h-6Z"/>'
        },
        "phone-message": {
            body: '<path fill="currentColor" d="M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.074 15.074 0 0 1-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1c0 9.39 7.61 17 17 17c.55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1M12 3v10l3-3h6V3h-9Z"/>'
        },
        "phone-message-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.25 0-2.45-.2-3.57-.57c-.1-.03-.21-.05-.31-.05c-.26 0-.51.12-.71.29l-2.2 2.2a15.074 15.074 0 0 1-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1c0 9.39 7.61 17 17 17c.55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1M5.03 5h1.5c.07.88.22 1.75.47 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8M19 18.97c-1.32-.09-2.6-.35-3.8-.76L16.4 17c.85.25 1.72.4 2.6.46v1.51M12 3v10l3-3h6V3h-9m7 5h-5V5h5v3Z"/>'
        },
        "phone-minus": {
            body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.24 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.24 8.5 4a1 1 0 0 0-1-1M13 6v2h8V6"/>'
        },
        "phone-minus-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M13 6v2h8V6Z"/>'
        },
        "phone-missed": {
            body: '<path fill="currentColor" d="M23.71 16.67C20.66 13.77 16.54 12 12 12C7.46 12 3.34 13.77.29 16.67c-.18.18-.29.43-.29.71c0 .27.11.52.29.7l2.48 2.48c.18.18.43.3.73.3c.25 0 .5-.11.68-.29c.79-.74 1.68-1.36 2.66-1.85c.33-.16.56-.5.56-.9v-3.1c1.45-.47 2.99-.72 4.6-.72c1.6 0 3.15.25 4.6.72v3.1c0 .4.23.74.56.9c.98.49 1.87 1.11 2.66 1.85c.18.18.43.29.68.29c.3 0 .55-.12.73-.3l2.48-2.48a.99.99 0 0 0 .29-.7c0-.28-.11-.53-.29-.71M6.5 5.5L12 11l7-7l-1-1l-6 6l-4.5-4.5H11V3H5v6h1.5V5.5Z"/>'
        },
        "phone-missed-outline": {
            body: '<path fill="currentColor" d="M18.6 15.5v1.8c.7.4 1.3.8 1.9 1.3l1.1-1.1c-.9-.9-1.9-1.5-3-2m-13.2 0c-1 .5-2 1.1-2.9 1.9l1.1 1.1c.6-.5 1.2-.9 1.9-1.3v-1.7M12 12c4.5 0 8.7 1.7 11.7 4.7c.2.2.3.4.3.7c0 .3-.1.5-.3.7l-2.5 2.5c-.2.2-.4.3-.7.3c-.2 0-.5-.1-.7-.3c-.8-.7-1.7-1.4-2.7-1.8c-.3-.2-.6-.5-.6-.9v-3.1c-1.5-.5-3-.7-4.6-.7c-1.6 0-3.1.2-4.6.7v3.1c0 .4-.2.7-.6.9c-1 .5-1.9 1.1-2.7 1.8c-.2.2-.4.3-.7.3c-.3 0-.5-.1-.7-.3L.1 18.1c0-.2-.1-.5-.1-.7c0-.3.1-.5.3-.7C3.3 13.8 7.5 12 12 12zM6.5 5.5V9H5V3h6v1.5H7.5L12 9l6-6l1 1l-7 7l-5.5-5.5z"/>'
        },
        "phone-off": {
            body: '<path fill="currentColor" d="M20.22 2.5L2.5 20.22l1.27 1.28l4.88-4.88C11.76 19.43 15.81 21 20 21a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2c-1.15-.58-2.21-1.32-3.15-2.17L21.5 3.77L20.22 2.5M4 3a1 1 0 0 0-1 1c0 3.57 1.14 7.05 3.24 9.94l1.42-1.44a13.9 13.9 0 0 1-1.04-1.71l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4Z"/>'
        },
        "phone-off-outline": {
            body: '<path fill="currentColor" d="M16.4 17c.8.2 1.7.4 2.6.5V19c-1.3-.1-2.6-.3-3.8-.8l1.2-1.2m3.8-14.5L2.5 20.2l1.3 1.3l4.9-4.9C11.8 19.4 15.8 21 20 21c.6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-1.1-.6-2.2-1.3-3.1-2.2L21.5 3.8l-1.3-1.3M6.5 5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5h1.5m1-2H4c-.6 0-1 .4-1 1c0 3.6 1.1 7 3.2 9.9l1.4-1.4c-.4-.5-.7-1.1-1-1.7l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.2-.5-2.4-.5-3.6c0-.6-.4-1-1-1Z"/>'
        },
        "phone-outgoing": {
            body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4m11 0v1.5h3.5L13 10l1 1l5.5-5.5V9H21V3h-6Z"/>'
        },
        "phone-outgoing-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M15 3v1.5h3.5L13 10l1 1l5.5-5.5V9H21V3h-6Z"/>'
        },
        "phone-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19Z"/>'
        },
        "phone-paused": {
            body: '<path fill="currentColor" d="M19 10h2V3h-2m1 12.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1M17 3h-2v7h2V3Z"/>'
        },
        "phone-paused-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m0-9h2V3h-2m-2 0h-2v7h2V3Z"/>'
        },
        "phone-plus": {
            body: '<path fill="currentColor" d="M4 3a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.24 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.24 8.5 4a1 1 0 0 0-1-1M16 3v3h-3v2h3v3h2V8h3V6h-3V3"/>'
        },
        "phone-plus-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M16 3v3h-3v2h3v3h2V8h3V6h-3V3Z"/>'
        },
        "phone-refresh": {
            body: '<path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2M17 7l1.77-1.77A2.5 2.5 0 1 0 19 8.5h1.71A3.991 3.991 0 0 1 17 11c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17L21 3v4h-4Z"/>'
        },
        "phone-refresh-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M17 7l1.77-1.77A2.5 2.5 0 1 0 19 8.5h1.71A3.991 3.991 0 0 1 17 11c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17L21 3v4h-4Z"/>'
        },
        "phone-remove": {
            body: '<path fill="currentColor" d="M4 3c-.6 0-1 .4-1 1c0 9.4 7.6 17 17 17c.6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1c-1.2 0-2.5-.2-3.6-.6c-.4-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.4-5.1-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.3-.5-3.5c0-.6-.4-1-1-1m11.6.5L17 5.6l-2.1-2.1l-1.4 1.4L15.6 7l-2.1 2.1l1.4 1.4L17 8.4l2.1 2.1l1.4-1.4L18.4 7l2.1-2.1"/>'
        },
        "phone-remove-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m.1-15.5L17 5.6l-2.1-2.1l-1.4 1.4L15.6 7l-2.1 2.1l1.4 1.4L17 8.4l2.1 2.1l1.4-1.4L18.4 7l2.1-2.1l-1.4-1.4Z"/>'
        },
        "phone-return": {
            body: '<path fill="currentColor" d="M21 6v5h-1.5V7.5h-5.63l2.43 2.43L15.24 11L11 6.75l4.24-4.25l1.06 1.07L13.87 6H21M8.82 8.58c.26-.26.35-.65.24-1C8.69 6.42 8.5 5.22 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1c-1.21 0-2.42-.19-3.57-.57a.997.997 0 0 0-1 .24l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.18-2.2Z"/>'
        },
        "phone-return-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19m2-13v5h-1.5V7.5h-5.63l2.43 2.43L15.24 11L11 6.75l4.24-4.25l1.06 1.07L13.87 6H21Z"/>'
        },
        "phone-ring": {
            body: '<path fill="currentColor" d="M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71c0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29c.27 0 .52-.11.7-.28c.79-.74 1.69-1.36 2.66-1.85c.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9c.98.49 1.87 1.12 2.66 1.85c.18.18.43.28.7.28c.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 0 0-.29-.7zM21.16 6.26l-1.41-1.41l-3.56 3.55l1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4L4.26 4.84L2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"/>'
        },
        "phone-ring-outline": {
            body: '<path fill="currentColor" d="M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71c0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29c.27 0 .52-.11.7-.28c.79-.74 1.69-1.36 2.66-1.85c.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9c.98.49 1.87 1.12 2.66 1.85c.18.18.43.28.7.28c.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 0 0-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7H5.4zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41l-3.56 3.55l1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2V2zM6.4 9.81L7.81 8.4L4.26 4.84L2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"/>'
        },
        "phone-rotate-landscape": {
            body: '<path fill="currentColor" d="M9 1H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 14H3V3h6v12m12-2h-8v2h8v6H9v-1H6v1a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2m2-3l-4-2l1.91-.91A7.516 7.516 0 0 0 14 2.5V1a9 9 0 0 1 9 9Z"/>'
        },
        "phone-rotate-portrait": {
            body: '<path fill="currentColor" d="M9 1H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h1v-3H3V3h6v8h2V3a2 2 0 0 0-2-2m14 20v-6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2M9 21v-6h12v6H9m14-11h-1.5c0-3-1.81-5.73-4.58-6.91L16 5l-2-4a9 9 0 0 1 9 9Z"/>'
        },
        "phone-settings": {
            body: '<path fill="currentColor" d="M19 11h2V9h-2m1 6.5c-1.25 0-2.45-.2-3.57-.57c-.35-.11-.74-.03-1.02.25l-2.2 2.2a15.097 15.097 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1a17 17 0 0 0 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1M17 9h-2v2h2m-4-2h-2v2h2V9Z"/>'
        },
        "phone-settings-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M17 9h-2v2h2m-4-2h-2v2h2V9m6 2h2V9h-2Z"/>'
        },
        "phone-sync": {
            body: '<path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02l-2.2 2.2M17 3V1.5l-2.25 2.25L17 6V4.5A2.5 2.5 0 0 1 19.5 7c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5A2.5 2.5 0 0 1 14.5 7c0-.4.09-.78.26-1.12l-1.09-1.09C13.25 5.42 13 6.18 13 7c0 2.21 1.79 4 4 4v1.5l2.25-2.25L17 8v1.5Z"/>'
        },
        "phone-sync-outline": {
            body: '<path fill="currentColor" d="M20 15.5c-1.2 0-2.5-.2-3.6-.6h-.3c-.3 0-.5.1-.7.3l-2.2 2.2c-2.8-1.5-5.2-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1c-.3-1.1-.5-2.4-.5-3.6c0-.5-.5-1-1-1H4c-.5 0-1 .5-1 1c0 9.4 7.6 17 17 17c.5 0 1-.5 1-1v-3.5c0-.5-.5-1-1-1M5 5h1.5c.1.9.3 1.8.5 2.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5m14 14c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2c.8.2 1.7.4 2.6.4V19M17 3V1.5l-2.25 2.25L17 6V4.5A2.5 2.5 0 0 1 19.5 7c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5A2.5 2.5 0 0 1 14.5 7c0-.4.09-.78.26-1.12l-1.09-1.09C13.25 5.42 13 6.18 13 7c0 2.21 1.79 4 4 4v1.5l2.25-2.25L17 8v1.5Z"/>'
        },
        "phone-voip": {
            body: '<path fill="currentColor" d="M13 17v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2h2m10.7-9.33c.18.18.3.42.3.7c0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.73.29c-.25 0-.5-.1-.68-.28c-.82-.73-1.69-1.36-2.67-1.85c-.33-.16-.56-.51-.56-.9v-3.1C15.14 5.25 13.59 5 12 5c-1.6 0-3.15.25-4.6.73v3.1c0 .4-.23.74-.56.9c-.97.49-1.87 1.11-2.66 1.85a1.015 1.015 0 0 1-1.41-.01L.29 9.09A.997.997 0 0 1 0 8.38c0-.28.11-.53.29-.71C3.34 4.78 7.46 3 12 3c4.53 0 8.65 1.78 11.7 4.67M11 10v5h-1v-5h1m1 0h3v3h-2v2h-1v-5m2 2v-1h-1v1h1Z"/>'
        },
        pi: {
            body: '<path fill="currentColor" d="M4 5v2h2v12h2V7h6v9a3 3 0 0 0 3 3a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1a1 1 0 0 1-1-1V7h2V5"/>'
        },
        "pi-box": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M6 7h11v2h-2v5a1 1 0 0 0 1 1a1 1 0 0 0 1-1h2a3 3 0 0 1-3 3a3 3 0 0 1-3-3V9h-3v8H8V9H6"/>'
        },
        "pi-hole": {
            body: '<path fill="currentColor" d="M5.62 2c3.88 0 5.95 2.29 6.15 5.93c.73-4.36 4.16-3.85 4.16-3.85c.17 2.47-1.86 3.97-4.16 4.09c-.65-1.36-4.52-4.7-4.52-4.7c-.02.03 3.72 3.27 3.58 4.68C8.33 7.88 5.82 6 5.62 2m.44 11.11l3.86-3.86a3 3 0 0 1 4.24 0L18 13.11a2.964 2.964 0 0 1 0 4.24l-3.84 3.86a3 3 0 0 1-4.24 0l-3.86-3.86a3 3 0 0 1 0-4.24m3.33 6.48c0-1.23.76-2.74 2.7-2.74c1.31 0 2.78 1.25 4.22 1.11c-1.44-.04-2.72-1.11-2.72-2.77c0-1.33 1.1-2.29 1.1-3.85c-.06.99-.87 2.43-2.69 2.43c-1.41 0-2.45-1.14-4.13-1.14c.71.04 2.63.67 2.63 2.72c0 1.65-1.11 2.15-1.11 4.24Z"/>'
        },
        piano: {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-5.26 12H15v6H9v-6h.31c.55 0 .99-.44.99-1V4h3.45v9c0 .56.44 1 .99 1M4 4h2.8v9c0 .56.44 1 .99 1H8v6H4V4m16 16h-4v-6h.26c.55 0 .99-.44.99-1V4H20v16Z"/>'
        },
        "piano-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l.89.89V20a2 2 0 0 0 2 2h16.11l.73.73l1.27-1.27M8 20H4V5.89l2.8 2.8V13c0 .56.44 1 .99 1H8v6m7 0H9v-6h.31c.55 0 .99-.44.99-1v-.81l4.7 4.7V20m1 0v-2.11L18.11 20H16M10.3 7.1L5.2 2H20a2 2 0 0 1 2 2v14.8l-2-2V4h-2.75v9c0 .3-.12.55-.32.73l-3.18-3.18V4H10.3v3.1Z"/>'
        },
        pickaxe: {
            body: '<path fill="currentColor" d="M14.79 10.62L3.5 21.9l-1.4-1.4L13.38 9.21l1.41 1.41m4.48-2.89l.59-.59l-.79-.79l.64-.64l-1.42-1.42l-.64.64l-.79-.79l-.59.59c-1.74-1.42-3.7-2.56-5.8-3.36l-.83 1.79c1.75.92 3.36 2.03 4.86 3.34L14 7l3 3l.5-.5c1.31 1.5 2.42 3.11 3.34 4.86l1.79-.83c-.8-2.1-1.94-4.06-3.36-5.8Z"/>'
        },
        "picture-in-picture-bottom-right": {
            body: '<path fill="currentColor" d="M19 11h-8v6h8v-6m4 8V5c0-1.12-.9-2-2-2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2m-2 0H3V4.97h18V19Z"/>'
        },
        "picture-in-picture-bottom-right-outline": {
            body: '<path fill="currentColor" d="M19 11h-8v6h8v-6m-2 4h-4v-2h4v2m4-12H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5c0-1.12-.9-2-2-2m0 16H3V4.97h18V19Z"/>'
        },
        "picture-in-picture-top-right": {
            body: '<path fill="currentColor" d="M19 7h-8v6h8V7m2-4H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H3V5h18v14Z"/>'
        },
        "picture-in-picture-top-right-outline": {
            body: '<path fill="currentColor" d="M19 7h-8v6h8V7m-2 4h-4V9h4v2m4-8H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5c0-1.09-.9-2-2-2m0 16H3V5h18v14Z"/>'
        },
        pier: {
            body: '<path fill="currentColor" d="M20 18c-1.4 0-2.8-.5-4-1.3c-2.4 1.7-5.6 1.7-8 0c-1.2.8-2.6 1.3-4 1.3H2v2h2c1.4 0 2.7-.4 4-1c2.5 1.3 5.5 1.3 8 0c1.3.6 2.6 1 4 1h2v-2h-2m0-5h-1v3.9c-.7-.1-1.4-.3-2-.7V13h-5v4c-.7 0-1.3-.1-2-.3V13H5v3.9c-.3.1-.7.1-1 .1H3v-4H2v-2h1V9h2v2h5V9h2v2h5V9h2v2h1v2Z"/>'
        },
        "pier-crane": {
            body: '<path fill="currentColor" d="M20 20c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 19.53 5.39 20 4 20H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2h-2m0-16V3a1 1 0 0 0-1-1H9V1H6v1H5v2h1v9H5v-2H3v2H2v2h1v4h1c.33 0 .67-.03 1-.08V15h5v3.65c.65.2 1.33.3 2 .3V15h1v-2h-1v-2h-2v2H9V4h8v4.62c-.47.17-.81.61-.81 1.14c0 .44.24.84.61 1.06V12h.62c.34 0 .61.28.61.62c0 .34-.27.62-.61.62c-.22 0-.42-.12-.54-.31a.606.606 0 0 0-.83-.22c-.3.16-.4.54-.23.84c.33.56.94.92 1.6.92c1.01 0 1.84-.83 1.84-1.85c0-.78-.5-1.48-1.23-1.74v-.06c.38-.22.62-.62.62-1.06c0-.46-.27-.85-.65-1.06V4h2M8 11.66l-1 1v-1.42l1-1v1.42m0-2.95l-1 1V8.29l1-1v1.42m-1-2V5.29l1-1v1.42l-1 1Z"/>'
        },
        pig: {
            body: '<path fill="currentColor" d="M9.5 9A1.5 1.5 0 0 0 8 10.5A1.5 1.5 0 0 0 9.5 12a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 9.5 9m5 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 14.5 9M12 4l.68.03c.94-.79 2.14-1.44 3.04-1.68c1.87-.5 5.16-.12 5.59 1.48c.31 1.17-.71 2.62-2.28 3.55A8.97 8.97 0 0 1 21 13a9 9 0 0 1-9 9a9 9 0 0 1-9-9c0-2.13.74-4.08 1.97-5.62C3.4 6.45 2.38 5 2.69 3.83c.43-1.6 3.72-1.98 5.59-1.48c.9.24 2.1.89 3.04 1.68L12 4m-2 12a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-2-3c-2.76 0-5 2.34-5 4c0 1.66 2.24 3 5 3s5-1.34 5-3s-2.24-4-5-4M7.76 4.28c-.45-.12-3.17.07-3.17.07S6.8 6.1 7.24 6.22c.45.12 2.53.21 2.67-.32c.15-.54-1.71-1.5-2.15-1.62m8.48 0c-.44.12-2.3 1.08-2.15 1.62c.14.53 2.22.44 2.67.32c.44-.12 2.65-1.87 2.65-1.87s-2.72-.19-3.17-.07Z"/>'
        },
        "pig-variant": {
            body: '<path fill="currentColor" d="m19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15A1.498 1.498 0 0 0 16.5 2c-1.64 0-3.09.79-4 2h-5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10v-2h2v2h5.5l1.68-5.59l2.82-.94V7.5h-2.17M16 11c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "pig-variant-outline": {
            body: '<path fill="currentColor" d="M15 10c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1m7-2.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5S4.46 4 7.5 4h5c.91-1.21 2.36-2 4-2a1.498 1.498 0 0 1 1.38 2.08c-.14.34-.26.73-.32 1.15l2.27 2.27H22m-2 2h-1L15.5 6c0-.65.09-1.29.26-1.91c-.97.25-1.76.97-2.09 1.91H7.5C5.57 6 4 7.57 4 9.5c0 1.88 1.22 6.65 2 9.5h2v-2h6v2h2l1.56-5.15l2.44-.82V9.5Z"/>'
        },
        "piggy-bank": {
            body: '<path fill="currentColor" d="m19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15A1.498 1.498 0 0 0 16.5 2c-1.64 0-3.09.79-4 2h-5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10v-2h2v2h5.5l1.68-5.59l2.82-.94V7.5h-2.17M13 9H8V7h5v2m3 2c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "piggy-bank-outline": {
            body: '<path fill="currentColor" d="M15 10c0-.55.45-1 1-1s1 .45 1 1s-.45 1-1 1s-1-.45-1-1M8 9h5V7H8v2m14-1.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5S4.46 4 7.5 4h5c.91-1.21 2.36-2 4-2a1.498 1.498 0 0 1 1.38 2.08c-.14.34-.26.73-.32 1.15l2.27 2.27H22m-2 2h-1L15.5 6c0-.65.09-1.29.26-1.91c-.97.25-1.76.97-2.09 1.91H7.5C5.57 6 4 7.57 4 9.5c0 1.88 1.22 6.65 2 9.5h2v-2h6v2h2l1.56-5.15l2.44-.82V9.5Z"/>'
        },
        pill: {
            body: '<path fill="currentColor" d="m4.22 11.29l7.07-7.07a6.011 6.011 0 0 1 8.49 0c2.34 2.34 2.34 6.14 0 8.49l-7.07 7.07c-2.35 2.34-6.15 2.34-8.49 0a6.011 6.011 0 0 1 0-8.49m1.42 1.42a3.976 3.976 0 0 0-1.04 3.86l5.99-5.98l4.24 4.24l3.53-3.54a3.978 3.978 0 0 0 0-5.65a3.978 3.978 0 0 0-5.65 0l-7.07 7.07Z"/>'
        },
        "pill-multiple": {
            body: '<path fill="currentColor" d="M16.2 3.5c-1-1-2.3-1.5-3.5-1.5s-2.6.5-3.5 1.5L3.4 9.1c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l5.7-5.7c1.9-1.9 1.9-5.1 0-7m-1.4 5.6L12 11.9L8.4 8.4L4 12.8c0-.8.2-1.7.9-2.3l5.7-5.7c.5-.5 1.3-.8 2-.8s1.5.3 2.1.8c1.2 1.3 1.2 3.1.1 4.3m4.8-2c0 .8-.2 1.5-.4 2.3c1 1.2 1 3-.1 4.1l-2.8 2.8l-1.5-1.5l-2.8 2.8c-1.3 1.3-3.1 2-4.8 2c.2.3.4.6.7.9c2 2 5.1 2 7.1 0l5.7-5.7c2-2 2-5.1 0-7.1c-.5-.2-.8-.4-1.1-.6Z"/>'
        },
        "pill-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.7 5.7l-2.59 2.59a6.011 6.011 0 0 0 0 8.49c2.34 2.34 6.14 2.34 8.49 0l2.59-2.59l5.54 5.54l1.27-1.27M4.6 16.57a3.976 3.976 0 0 1 1.04-3.86l2.59-2.59l1.41 1.41l-5.04 5.04m6.18-8.99L9.36 6.16l1.93-1.94a6.011 6.011 0 0 1 8.49 0c2.34 2.34 2.34 6.14 0 8.49l-1.93 1.94l-1.42-1.42l1.93-1.94a3.978 3.978 0 0 0 0-5.65a3.978 3.978 0 0 0-5.65 0l-1.93 1.94Z"/>'
        },
        pillar: {
            body: '<path fill="currentColor" d="M6 5h12a1 1 0 0 1 1 1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1a1 1 0 0 1 1-1m15-3v2H3V2h18m-6 6h2v14h-2V8M7 8h2v14H7V8m4 0h2v14h-2V8Z"/>'
        },
        pin: {
            body: '<path fill="currentColor" d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2Z"/>'
        },
        "pin-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-5.93-5.93V22h-1.6v-6H6v-2l2-2v-.73l-6-6M16 12l2 2v2h-.18L8 6.18V4H7V2h10v2h-1v8Z"/>'
        },
        "pin-off-outline": {
            body: '<path fill="currentColor" d="M8 6.2V4H7V2h10v2h-1v8l2 2v2h-.2L14 12.2V4h-4v4.2l-2-2m12 14.5L18.7 22l-5.9-5.9V22h-1.6v-6H6v-2l2-2v-.7l-6-6L3.3 4L20 20.7M8.8 14h1.8l-.9-.9l-.9.9Z"/>'
        },
        "pin-outline": {
            body: '<path fill="currentColor" d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2m-7.2 2l1.2-1.2V4h4v8.8l1.2 1.2H8.8Z"/>'
        },
        "pine-tree": {
            body: '<path fill="currentColor" d="M10 21v-3H3l5-5H5l5-5H7l5-5l5 5h-3l5 5h-3l5 5h-7v3h-4Z"/>'
        },
        "pine-tree-box": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m7 17h2v-2h5l-4-4h3l-4-4h3l-4-4l-4 4h3l-4 4h3l-4 4h5v2Z"/>'
        },
        "pine-tree-fire": {
            body: '<path fill="currentColor" d="m22.14 14.84l-.02.01c.23.28.43.59.58.92l.09.19c.71 1.69.21 3.64-1.1 4.86c-1.19 1.09-2.85 1.38-4.39 1.18c-1.46-.18-2.8-1.1-3.57-2.37c-.23-.39-.43-.83-.53-1.28c-.13-.35-.17-.73-.2-1.1c-.09-1.6.55-3.3 1.76-4.3c-.55 1.21-.42 2.72.39 3.77l.11.13c.14.12.31.15.47.09c.15-.06.27-.21.27-.37l-.07-.24c-.88-2.33-.14-5.03 1.73-6.56c.51-.42 1.14-.8 1.8-.97c-.68 1.36-.46 3.14.63 4.2c.46.5 1.02.79 1.49 1.23l.56.61m-2.28 4.66l-.01-.03c.45-.39.7-1.06.68-1.66l-.03-.31c-.2-1-1.07-1.34-1.63-2.07c-.17-.22-.32-.5-.43-.78c-.22.5-.24.97-.15 1.51c.1.57.32 1.06.21 1.65c-.16.65-.67 1.3-1.56 1.51c.5.49 1.31.88 2.12.6c.26-.07.59-.26.8-.42M9 21v-3H2l5-5H4l5-5H6l5-5l5 5h-3l1.82 1.82C12.55 11.06 11 13.59 11 16.5c0 1.69.5 3.25 1.4 4.5H9Z"/>'
        },
        pinterest: {
            body: '<path fill="currentColor" d="M9.04 21.54c.96.29 1.93.46 2.96.46a10 10 0 0 0 10-10A10 10 0 0 0 12 2A10 10 0 0 0 2 12c0 4.25 2.67 7.9 6.44 9.34c-.09-.78-.18-2.07 0-2.96l1.15-4.94s-.29-.58-.29-1.5c0-1.38.86-2.41 1.84-2.41c.86 0 1.26.63 1.26 1.44c0 .86-.57 2.09-.86 3.27c-.17.98.52 1.84 1.52 1.84c1.78 0 3.16-1.9 3.16-4.58c0-2.4-1.72-4.04-4.19-4.04c-2.82 0-4.48 2.1-4.48 4.31c0 .86.28 1.73.74 2.3c.09.06.09.14.06.29l-.29 1.09c0 .17-.11.23-.28.11c-1.28-.56-2.02-2.38-2.02-3.85c0-3.16 2.24-6.03 6.56-6.03c3.44 0 6.12 2.47 6.12 5.75c0 3.44-2.13 6.2-5.18 6.2c-.97 0-1.92-.52-2.26-1.13l-.67 2.37c-.23.86-.86 2.01-1.29 2.7v-.03Z"/>'
        },
        "pinterest-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9.29c.4-.67.9-1.62 1.1-2.36l.66-2.3c.31.61 1.23 1.11 2.17 1.11c2.95 0 5-2.67 5-6c0-3.17-2.58-5.56-5.92-5.56c-4.16 0-6.33 2.78-6.33 5.83c0 1.42.72 3.17 1.94 3.73c.17.11.28.05.28-.11l.28-1.06c.03-.14.03-.22-.06-.28c-.44-.55-.72-1.39-.72-2.22c0-2.14 1.61-4.17 4.34-4.17c2.39 0 4.05 1.58 4.05 3.89c0 2.61-1.33 4.45-3.05 4.45c-.98 0-1.64-.84-1.48-1.78c.28-1.14.84-2.34.84-3.17c0-.78-.39-1.39-1.23-1.39c-.94 0-1.77 1-1.77 2.34c0 .88.27 1.44.27 1.44l-1.11 4.78c-.16.83-.08 2.08 0 2.83H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" fill="currentColor"/>',
            hidden: true
        },
        pinwheel: {
            body: '<path fill="currentColor" d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12m0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11m0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11m0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12Z"/>'
        },
        "pinwheel-outline": {
            body: '<path fill="currentColor" d="M12 23h-1v-6.57C9.93 17.4 8.5 18 7 18c-3.25 0-6-2.75-6-6v-1h6.57C6.6 9.93 6 8.5 6 7c0-3.25 2.75-6 6-6h1v6.57C14.07 6.6 15.5 6 17 6c3.25 0 6 2.75 6 6v1h-6.57c.97 1.07 1.57 2.5 1.57 4c0 3.25-2.75 6-6 6m1-9.87v7.74c1.7-.46 3-2.04 3-3.87s-1.3-3.41-3-3.87M3.13 13c.46 1.7 2.04 3 3.87 3s3.41-1.3 3.87-3H3.13m10-2h7.74c-.46-1.7-2.05-3-3.87-3c-1.82 0-3.41 1.3-3.87 3M11 3.13C9.3 3.59 8 5.18 8 7c0 1.82 1.3 3.41 3 3.87V3.13Z"/>'
        },
        pipe: {
            body: '<path fill="currentColor" d="M22 14h-2v2h-6v-3h2v-2h-2V6a2 2 0 0 0-2-2H4V2H2v8h2V8h6v3H8v2h2v5a2 2 0 0 0 2 2h8v2h2"/>'
        },
        "pipe-disconnected": {
            body: '<path fill="currentColor" d="M16 9v2H8V9h2V8H4v2H2V2h2v2h8a2 2 0 0 1 2 2v3h2m-6 6v3a2 2 0 0 0 2 2h8v2h2v-8h-2v2h-6v-1h2v-2H8v2h2Z"/>'
        },
        "pipe-leak": {
            body: '<path fill="currentColor" d="M2 5v8h2v-2h6l2-2l-2-2H4V5H2m18 0v2h-8l2 2l-2 2h8v2h2V5h-2m-8 8s-2 2.17-2 3.5a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-1.33-2-3.5-2-3.5Z"/>'
        },
        "pipe-valve": {
            body: '<path fill="currentColor" d="M22 13v8h-2v-2h-3.42c-.77 1.76-2.53 3-4.58 3s-3.81-1.24-4.58-3H4v2H2v-8h2v2h3.43c.5-1.15 1.42-2.07 2.57-2.58V11H8V9h8v2h-2v1.42c1.15.51 2.07 1.43 2.57 2.58H20v-2h2M17 2H7c-.55 0-1 .45-1 1s.45 1 1 1h3v1h1v3h2V5h1V4h3c.55 0 1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "pipe-wrench": {
            body: '<path fill="currentColor" d="m16.17 5.63l-2.11 2.15l-2.15-2.15l4.26-4.22l3.52 3.51c1.17 1.17 1.17 3.08 0 4.27l-3.52-3.56M4.83 12.7L7 14.81l3.5-3.51l-2.11-2.11l-3.56 3.51m10.64-4.92L19 11.3l-1.42 1.4l-.7-.7L6.23 22.59l-2.81-2.81l8.49-8.48l-4.22-4.27L9.8 4.92l4.26 4.27l1.41-1.41Z"/>'
        },
        pirate: {
            body: '<path fill="currentColor" d="M8.2 12.1c-.3.2-.5.6-.4.9c0 .7.7 1.2 1.3 1.2c.6 0 1.2-.5 1.2-1.2c-.6-.4-1.3-.7-2.1-.9M22 11l1-4s-2 0-5-2s-3-4-6-4s-3 2-6 4s-5 2-5 2l1 4h.1c-.1.3-.1.7-.1 1c0 3.5 1.8 6.6 4.5 8.4l-.5.9c6.4 4.1 12 0 12 0l-.5-.9c2.7-1.8 4.5-4.9 4.5-8.4v-1M11.3 4.5L9.9 3.1l.7-.7L12 3.8l1.4-1.4l.7.7l-1.4 1.4l1.4 1.4l-.7.7L12 5.2l-1.4 1.4l-.7-.7l1.4-1.4m-2 4c1-.3 2-.5 2.7-.5c2.2 0 5.9 1.6 7.8 2.4c.1.3.1.6.1.9L9.3 8.5m4.3 10.6c-.7.4-1.4.7-2.2.8c-.5-.4-.5-1.2 0-1.6c.4-.4 1.3-.6 1.8-.1c.3.1.4.6.4.9m6.4-5.7c-.5 2.1-1.8 4-3.5 5.2L15 16H9l-1.5 2.6C5.4 17.2 4 14.8 4 12c0-.5.1-1 .2-1.5c.5-.2 1.1-.5 1.8-.8l7.1 1.9V14c0 .5.4 1 1 1h2c.5 0 1-.4 1-1v-1.4l2.9.8Z"/>'
        },
        pistol: {
            body: '<path fill="currentColor" d="M7 5h16v4h-1v1h-6a1 1 0 0 0-1 1v1a2 2 0 0 1-2 2H9.62c-.38 0-.73.22-.9.56l-2.45 4.89c-.17.34-.51.55-.89.55H2s-3 0 1-6c0 0 3-4-1-4V5h1l.5-1h3L7 5m7 7v-1a1 1 0 0 0-1-1h-1s-1 1 0 2a2 2 0 0 1-2-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Z"/>'
        },
        piston: {
            body: '<path fill="currentColor" d="M13 16.18c.5.17.9.45 1.23.82H15v4h-.79c-.32.35-.71.63-1.21.8c-1.15.42-2.42.07-3.22-.8H9v-4h.77c.33-.37.73-.65 1.23-.82V12h2v4.18M12 20a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m5-16h-2v1h2v6H7V5h2V4H7V2h10v2m-5 5a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1Z"/>'
        },
        pitchfork: {
            body: '<path fill="currentColor" d="m15.9.9l-2.8 2.8c-.8.8-.8 2 0 2.8L14.5 8l-5.3 5.4L7.8 12c-.8-.8-2-.8-2.8 0l-4 4l1.4 1.4l4-4l1.4 1.4l-4 4l1.4 1.4l4-4l1.4 1.4l-.7.8l-3.2 3.2L8 23l4-4c.8-.8.8-2 0-2.8l-1.4-1.4l5.3-5.4l1.4 1.4c.8.8 2 .8 2.8 0L23 8L15.9.9m2.8 8.5l-4.2-4.2l1.4-1.4L20.1 8l-1.4 1.4Z"/>'
        },
        pizza: {
            body: '<path fill="currentColor" d="M12 15a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2M7 7c0-1.11.89-2 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m5-5C8.43 2 5.23 3.54 3 6l9 16l9-16c-2.22-2.46-5.43-4-9-4Z"/>'
        },
        "plane-car": {
            body: '<path fill="currentColor" d="M21.57 12.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L11 16.77v5.51c0 .38.32.72.7.72h.62c.38 0 .68-.38.68-.76V21h8v1.24c0 .38.31.76.69.76h.61c.38 0 .7-.34.7-.72v-5.51l-1.43-4.11m-8.16.34h7.19l1.03 3h-9.25l1.03-3M13 19c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m8 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M6.66 14.53L7 17l-1.05 1.06l-1.76-3.18L1 13.11l1.06-1.08l2.5.37l3.87-3.87L1 4.62l1.42-1.41l9.19 2.12l3.89-3.89c.56-.585 1.56-.585 2.12 0c.59.59.59 1.56 0 2.12l-3.89 3.89l.82 3.55h-1.14c-.87 0-1.62.5-1.91 1.31l-.03.06l-.91-1.74l-3.9 3.9Z"/>'
        },
        "plane-train": {
            body: '<path fill="currentColor" d="M20 8h-6c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3l-1 1v1h1l2-2.03h2L20 23h1v-1l-1-1c1.66 0 3-1.34 3-3v-7c0-1.66-1.34-3-3-3m-6 11c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m6 0c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m1-3h-8v-6h8v6M6.66 14.53L7 17l-1.05 1.06l-1.76-3.18L1 13.11l1.06-1.08l2.5.37l3.87-3.87L1 4.62l1.42-1.41l9.19 2.12l3.89-3.89c.56-.585 1.56-.585 2.12 0c.59.59.59 1.56 0 2.12L14.18 7H14c-2.21 0-4 1.79-4 4v.19l-3.34 3.34Z"/>'
        },
        play: {
            body: '<path fill="currentColor" d="M8 5.14v14l11-7l-11-7Z"/>'
        },
        "play-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m-9 13V8l5 4"/>'
        },
        "play-box-lock": {
            body: '<path fill="currentColor" d="M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3M13 19v2H4a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v5.1l-1-.1l-1 .1a5.019 5.019 0 0 0-4 4.66c-.61.55-1 1.35-1 2.24v2m7.5-4.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5M9 8v8l5-4l-5-4Z"/>'
        },
        "play-box-lock-open": {
            body: '<path fill="currentColor" d="M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h4.3c.6 0 1.2.6 1.2 1.3M9 8v8l5-4l-5-4m4 11v2H4a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v4.1L19 9c-2.76 0-5 2.24-5 5v.76c-.61.55-1 1.35-1 2.24v2Z"/>'
        },
        "play-box-lock-open-outline": {
            body: '<path fill="currentColor" d="M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h4.3c.6 0 1.2.6 1.2 1.3M18 5H4v14h9v2H4a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v4.1L19 9l-1 .1V5M9 8l5 4l-5 4V8Z"/>'
        },
        "play-box-lock-outline": {
            body: '<path fill="currentColor" d="M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5M18 5H4v14h9v2H4a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v5.1l-1-.1l-1 .1V5M9 8l5 4l-5 4V8Z"/>'
        },
        "play-box-multiple": {
            body: '<path fill="currentColor" d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6m16-4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-8 12.5v-9l6 4.5l-6 4.5Z"/>'
        },
        "play-box-multiple-outline": {
            body: '<path fill="currentColor" d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6m16-2v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8 12.5v-9l6 4.5l-6 4.5Z"/>'
        },
        "play-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-9 5v8l5-4l-5-4Z"/>'
        },
        "play-circle": {
            body: '<path fill="currentColor" d="M10 16.5v-9l6 4.5M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "play-circle-outline": {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-2 14.5l6-4.5l-6-4.5v9Z"/>'
        },
        "play-network": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-5-6V6l5 4l-5 4Z"/>'
        },
        "play-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m3-1V6l5 4l-5 4Z"/>'
        },
        "play-outline": {
            body: '<path fill="currentColor" d="M8.5 8.64L13.77 12L8.5 15.36V8.64M6.5 5v14l11-7"/>'
        },
        "play-pause": {
            body: '<path fill="currentColor" d="M3 5v14l8-7m2 7h3V5h-3m5 0v14h3V5"/>'
        },
        "play-protected-content": {
            body: '<path fill="currentColor" d="M2 5v13h9v-2H4V7h13v4h2V5H2m7 4v5l3.5-2.5L9 9m12.04 2.67l-4.95 4.95l-2.13-2.12l-1.41 1.41l3.54 3.54l6.36-6.36l-1.41-1.42Z"/>'
        },
        "play-speed": {
            body: '<path fill="currentColor" d="M13 2.05v2c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97v.02M5.67 19.74A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63l-1.43 1.37m1.43-14c1.12-.9 2.47-1.48 3.9-1.68v-2c-1.95.19-3.81.94-5.33 2.2L7.1 5.74M5.69 7.1L4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9M4.06 13h-2c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13M10 16.5l6-4.5l-6-4.5v9Z"/>'
        },
        "playlist-check": {
            body: '<path fill="currentColor" d="M14 10H3v2h11v-2m0-4H3v2h11V6M3 16h7v-2H3v2m18.5-4.5L23 13l-7 7l-4.5-4.5L13 14l3 3l5.5-5.5Z"/>'
        },
        "playlist-edit": {
            body: '<path fill="currentColor" d="M3 6v2h11V6H3m0 4v2h11v-2H3m17 .1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V20h2.1l6.1-6.1l-2.1-2M3 14v2h7v-2H3Z"/>'
        },
        "playlist-minus": {
            body: '<path fill="currentColor" d="M3 16h7v-2H3m9 0v2h10v-2m-8-8H3v2h11m0 2H3v2h11v-2Z"/>'
        },
        "playlist-music": {
            body: '<path fill="currentColor" d="M15 6H3v2h12V6m0 4H3v2h12v-2M3 16h8v-2H3v2M17 6v8.18c-.31-.11-.65-.18-1-.18a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3V8h3V6h-5Z"/>'
        },
        "playlist-music-outline": {
            body: '<path fill="currentColor" d="M15 6v2H3V6h12m0 4v2H3v-2h12M3 16v-2h8v2H3M17 6h5v2h-3v9a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3c.35 0 .69.07 1 .18V6m-1 10a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "playlist-play": {
            body: '<path fill="currentColor" d="M3 10h11v2H3v-2m0-4h11v2H3V6m0 8h7v2H3v-2m13-1v8l6-4l-6-4Z"/>'
        },
        "playlist-plus": {
            body: '<path fill="currentColor" d="M3 16h7v-2H3m15 0v-4h-2v4h-4v2h4v4h2v-4h4v-2m-8-8H3v2h11m0 2H3v2h11v-2Z"/>'
        },
        "playlist-remove": {
            body: '<path fill="currentColor" d="M14 10H3v2h11v-2m0-4H3v2h11V6M3 16h7v-2H3v2m11.4 6l2.6-2.6l2.6 2.6l1.4-1.4l-2.6-2.6l2.6-2.6l-1.4-1.4l-2.6 2.6l-2.6-2.6l-1.4 1.4l2.6 2.6l-2.6 2.6l1.4 1.4Z"/>'
        },
        "playlist-star": {
            body: '<path fill="currentColor" d="m17 19.1l2.5 1.5l-.7-2.8l2.2-1.9l-2.9-.2L17 13l-1.1 2.6l-2.9.3l2.2 1.9l-.7 2.8l2.5-1.5M3 14h8v2H3v-2m0-8h12v2H3V6m0 4h12v2H3v-2Z"/>'
        },
        plex: {
            body: '<path fill="currentColor" d="M4 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2H4m4.56 4h3.5l3.44 6l-3.44 6h-3.5L12 12L8.56 6Z"/>'
        },
        pliers: {
            body: '<path fill="currentColor" d="M9.4 12.2s2.3 3.1 4.4 5.2c.9.9 1.8 1.5 2.5 2c.8.5 1 1.6.3 2.3c-.4.4-1.1.6-1.6.3c-.8-.4-2-1.2-3.3-2.4c-2.1-2.1-4.4-5.2-4.4-5.2l2.1-2.2m2.8-2.8s3.1 2.3 5.2 4.4c.9.9 1.5 1.8 2 2.5c.5.8 1.6 1 2.3.3c.4-.4.6-1.1.3-1.6c-.4-.8-1.2-2-2.4-3.3c-2.1-2.1-5.2-4.4-5.2-4.4l-2.2 2.1m-1.8-3.9L7.6 2.7L4.1 2l-.5.5l2.3 2.3c.5-.1 1 0 1.4.4c.6.6.6 1.5 0 2.1s-1.5.6-2.1 0c-.4-.4-.5-1-.4-1.5L2.5 3.6l-.5.5l.7 3.5l2.8 2.8l1.4 2.8l1.9-1.9l-1-1.8l1.6-1.6l1.9.9l1.9-1.9l-2.8-1.4Z"/>'
        },
        plus: {
            body: '<path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"/>'
        },
        "plus-box": {
            body: '<path fill="currentColor" d="M17 13h-4v4h-2v-4H7v-2h4V7h2v4h4m2-8H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "plus-box-multiple": {
            body: '<path fill="currentColor" d="M19 11h-4v4h-2v-4H9V9h4V5h2v4h4m1-7H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6Z"/>'
        },
        "plus-box-multiple-outline": {
            body: '<path fill="currentColor" d="M18 11h-3v3h-2v-3h-3V9h3V6h2v3h3m2-5v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6Z"/>'
        },
        "plus-box-outline": {
            body: '<path fill="currentColor" d="M19 19V5H5v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-8 4h2v4h4v2h-4v4h-2v-4H7v-2h4V7Z"/>'
        },
        "plus-circle": {
            body: '<path fill="currentColor" d="M17 13h-4v4h-2v-4H7v-2h4V7h2v4h4m-5-9A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "plus-circle-multiple": {
            body: '<path fill="currentColor" d="M2 12c0-2.8 1.6-5.2 4-6.3V3.5C2.5 4.8 0 8.1 0 12s2.5 7.2 6 8.5v-2.2c-2.4-1.1-4-3.5-4-6.3m13-9c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m5 10h-4v4h-2v-4h-4v-2h4V7h2v4h4v2Z"/>'
        },
        "plus-circle-multiple-outline": {
            body: '<path fill="currentColor" d="M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3M2 12c0-2.79 1.64-5.2 4-6.32V3.5C2.5 4.76 0 8.09 0 12s2.5 7.24 6 8.5v-2.18C3.64 17.2 2 14.79 2 12m13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9s9-4.04 9-9s-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7Z"/>'
        },
        "plus-circle-outline": {
            body: '<path fill="currentColor" d="M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m1 5h-2v4H7v2h4v4h2v-4h4v-2h-4V7Z"/>'
        },
        "plus-lock": {
            body: '<path fill="currentColor" d="M21.14 17.67v-.45C21.14 16 20.2 15 19 15s-2.14 1-2.14 2.22v.45c-.52 0-.86.33-.86.89v3.55c0 .54.34.89.86.89h4.28c.52 0 .86-.35.86-.89v-3.56c0-.55-.34-.88-.86-.88m-.85 0h-2.57v-.45c0-.72.59-1.33 1.28-1.33c.69 0 1.29.61 1.29 1.33v.45M11 5v6H5v2h6v6h2v-6h6v-2h-6V5h-2Z"/>'
        },
        "plus-lock-open": {
            body: '<path fill="currentColor" d="M11 5v6H5v2h6v6h2v-6h6v-2h-6V5h-2m8 10c-1.05 0-2.1.8-2.1 1.82v1.82c-.45 0-.9.43-.9.86v2.55c0 .51.45.95.9.95h4.13c.52 0 .97-.44.97-.87v-2.55c0-.51-.45-.94-.9-.94h-3.22v-1.82c0-.58.52-.95 1.12-.95s1.13.37 1.13.95v.36h.97v-.36C21.1 15.8 20.05 15 19 15Z"/>'
        },
        "plus-minus": {
            body: '<path fill="currentColor" d="M11 4v5H6v2h5v5h2v-5h5V9h-5V4h-2M6 18v2h12v-2H6Z"/>'
        },
        "plus-minus-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m6 3h2v3h3v2h-3v3h-2v-3H8V9h3V6M8 16h8v2H8v-2Z"/>'
        },
        "plus-minus-variant": {
            body: '<path fill="currentColor" d="M3 7h3V4h2v3h3v2H8v3H6V9H3V7m10 8h8v2h-8v-2m3.04-12h2.31L7.96 21H5.65L16.04 3Z"/>'
        },
        "plus-network": {
            body: '<path fill="currentColor" d="M16 11V9h-3V6h-2v3H8v2h3v3h2v-3h3m1-8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Z"/>'
        },
        "plus-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m8-4h-2v2h-2v-2H9V9h2V7h2v2h2v2Z"/>'
        },
        "plus-outline": {
            body: '<path fill="currentColor" d="M4 9h5V4h6v5h5v6h-5v5H9v-5H4V9m7 4v5h2v-5h5v-2h-5V6h-2v5H6v2h5Z"/>'
        },
        "plus-thick": {
            body: '<path fill="currentColor" d="M20 14h-6v6h-4v-6H4v-4h6V4h4v6h6v4Z"/>'
        },
        pocket: {
            body: '<path d="M21.9 4.26c-.26-.71-.94-1.19-1.7-1.19H3.81c-.74 0-1.42.47-1.69 1.17c-.08.21-.12.42-.12.64v6.04l.07 1.2c.29 2.73 1.71 5.11 3.9 6.78c.03.03.08.06.12.1h.02c1.18.86 2.49 1.44 3.89 1.73c.68.13 1.35.2 2 .2c.63 0 1.25-.06 1.85-.17c.08-.01.15-.03.22-.04c.02-.01.04-.02.07-.03A9.72 9.72 0 0 0 17.89 19h.02c.04-.04.09-.07.12-.1c2.19-1.67 3.61-4.05 3.9-6.78l.07-1.2V4.88c0-.2-.03-.41-.1-.62m-4.23 6.29l-4.71 4.51c-.26.26-.61.38-.96.38c-.33 0-.67-.12-.94-.38l-4.7-4.51a1.373 1.373 0 0 1 1.9-1.98l3.74 3.6l3.77-3.6c.54-.52 1.41-.5 1.94.04c.52.55.5 1.42-.04 1.94z" fill="currentColor"/>',
            hidden: true
        },
        podcast: {
            body: '<path fill="currentColor" d="M17 18.25v3.25H7v-3.25c0-1.38 2.24-2.5 5-2.5s5 1.12 5 2.5M12 5.5a6.5 6.5 0 0 1 6.5 6.5c0 1.25-.35 2.42-.96 3.41L16 14.04c.32-.61.5-1.31.5-2.04c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5c0 .73.18 1.43.5 2.04l-1.54 1.37c-.61-.99-.96-2.16-.96-3.41A6.5 6.5 0 0 1 12 5.5m0-4A10.5 10.5 0 0 1 22.5 12c0 2.28-.73 4.39-1.96 6.11l-1.5-1.35c.92-1.36 1.46-3 1.46-4.76A8.5 8.5 0 0 0 12 3.5A8.5 8.5 0 0 0 3.5 12c0 1.76.54 3.4 1.46 4.76l-1.5 1.35A10.473 10.473 0 0 1 1.5 12A10.5 10.5 0 0 1 12 1.5m0 8a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 12A2.5 2.5 0 0 1 12 9.5Z"/>'
        },
        podium: {
            body: '<path fill="currentColor" d="m12 7.09l2.45 1.49l-.65-2.81L16 3.89l-2.89-.25L12 1l-1.13 2.64L8 3.89l2.18 1.88l-.68 2.81L12 7.09m-8 6l2.45 1.49l-.65-2.81L8 9.89l-2.89-.25L4 7L2.87 9.64L0 9.89l2.18 1.88l-.68 2.81L4 13.09m16-3l2.45 1.49l-.65-2.81L24 6.89l-2.89-.25L20 4l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49M15 23H9V10h6v13m-8 0H1v-6h6v6m16 0h-6V13h6v10Z"/>'
        },
        "podium-bronze": {
            body: '<path fill="currentColor" d="m4 13.09l2.45 1.49l-.65-2.81L8 9.89l-2.89-.25L4 7L2.87 9.64L0 9.89l2.18 1.88l-.68 2.81L4 13.09M7 23H1v-6h6v6m2-13v13h6V10H9m4 11h-2v-9h2v9m4-8v10h6V13h-6m4 8h-2v-6h2v6Z"/>'
        },
        "podium-gold": {
            body: '<path fill="currentColor" d="m12 7.09l2.45 1.49l-.65-2.81L16 3.89l-2.89-.25L12 1l-1.13 2.64L8 3.89l2.18 1.88l-.68 2.81L12 7.09M15 23H9V10h6v13M1 17v6h6v-6H1m4 4H3v-2h2v2m12-8v10h6V13h-6m4 8h-2v-6h2v6Z"/>'
        },
        "podium-silver": {
            body: '<path fill="currentColor" d="m20 10.09l2.45 1.49l-.65-2.81L24 6.89l-2.89-.25L20 4l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49M23 23h-6V13h6v10M1 17v6h6v-6H1m4 4H3v-2h2v2m4-11v13h6V10H9m4 11h-2v-9h2v9Z"/>'
        },
        "point-of-sale": {
            body: '<path fill="currentColor" d="M20 5c-.6 0-1 .5-1 1.1V16c0 .6.4 1 1 1.1c.6 0 1-.5 1-1.1V6.1c0-.6-.4-1.1-1-1.1m-3.6-3H4.6C3.7 2 3 2.7 3 3.6v13.8c0 .9.7 1.6 1.6 1.6H6v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-2h2.4c.9 0 1.6-.7 1.6-1.6V3.6c0-.9-.7-1.6-1.6-1.6M5 8h3v2H5V8m7 3v2H9v-2h3m-3-1V8h3v2H9m3 4v2H9v-2h3m-7-3h3v2H5v-2m0 5v-2h3v2H5m3 5H7v-2h1v2m5 0h-3v-2h3v2m3-5h-3v-2h3v2m0-3h-3v-2h3v2m0-3h-3V8h3v2m0-4H5V4h11v2Z"/>'
        },
        pokeball: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2c-4.08 0-7.45 3.05-7.94 7h4.07c.44-1.73 2.01-3 3.87-3c1.86 0 3.43 1.27 3.87 3h4.07c-.49-3.95-3.86-7-7.94-7m0 16c4.08 0 7.45-3.05 7.94-7h-4.07c-.44 1.73-2.01 3-3.87 3c-1.86 0-3.43-1.27-3.87-3H4.06c.49 3.95 3.86 7 7.94 7m0-10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "pokemon-go": {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7c0 1.4-.41 2.71-1.12 3.8L12 22.21L6.12 12.8A6.948 6.948 0 0 1 5 9a7 7 0 0 1 7-7m0 1.5A5.5 5.5 0 0 0 6.59 8h2.58c.41-1.17 1.52-2 2.83-2s2.42.83 2.83 2h2.58A5.5 5.5 0 0 0 12 3.5m0 8.5a2.99 2.99 0 0 1-2.83-2H6.59c.13.69.38 1.34.75 1.91l.04.09A5.51 5.51 0 0 0 12 14.5c1.94 0 3.64-1 4.62-2.5l.04-.09c.37-.57.62-1.22.75-1.91h-2.58A2.99 2.99 0 0 1 12 12m0-4.5A1.5 1.5 0 0 0 10.5 9a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 13.5 9A1.5 1.5 0 0 0 12 7.5Z"/>'
        },
        "poker-chip": {
            body: '<path fill="currentColor" d="M23 12c0 6.08-4.92 11-11 11S1 18.08 1 12S5.92 1 12 1s11 4.92 11 11M13 4.06c2.13.27 4.07 1.39 5.37 3.1l1.74-1A10 10 0 0 0 13 2v2.06m-9.11 2.1l1.74 1A8.022 8.022 0 0 1 11 4.06V2a10 10 0 0 0-7.11 4.16m-1 9.94l1.73-1a8.03 8.03 0 0 1 0-6.2l-1.73-1a9.864 9.864 0 0 0 0 8.2M11 19.94a8.022 8.022 0 0 1-5.37-3.1l-1.74 1A10 10 0 0 0 11 22v-2.06m9.11-2.1l-1.74-1a8.022 8.022 0 0 1-5.37 3.1v2c2.85-.29 5.44-1.78 7.11-4.1m1-1.74c1.19-2.6 1.19-5.6 0-8.2l-1.73 1a8.03 8.03 0 0 1 0 6.2l1.73 1M15 12l-3-5l-3 5l3 5l3-5Z"/>'
        },
        polaroid: {
            body: '<path fill="currentColor" d="M6 3h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v12h12V5H6Z"/>'
        },
        "police-badge": {
            body: '<path fill="currentColor" d="m22 4l-2-2c-1.15.64-2.6 1-4 1s-2.86-.37-4-1c-1.14.63-2.6 1-4 1s-2.85-.36-4-1L2 4s2 2 2 4s-2 6-2 8c0 4 10 6 10 6s10-2 10-6c0-2-2-6-2-8s2-4 2-4m-6.95 12.45l-3.08-1.86l-3.07 1.86l.82-3.5L7 10.61l3.58-.31L11.97 7l1.4 3.29l3.58.31l-2.72 2.34l.82 3.51Z"/>'
        },
        "police-badge-outline": {
            body: '<path fill="currentColor" d="M12 4.21c1.24.51 2.65.79 4 .79c1.05 0 2.1-.16 3.08-.46C18.5 5.5 18 6.71 18 8c0 1.32.54 2.93 1.1 4.63c.4 1.2.9 2.7.9 3.37c0 1.03-3.53 3-8 3.96C7.54 19 4 17.03 4 16c0-.67.5-2.17.9-3.37C5.46 10.93 6 9.32 6 8c0-1.29-.5-2.5-1.08-3.46C5.9 4.84 6.96 5 8 5c1.35 0 2.76-.28 4-.79M20 2c-1.15.64-2.6 1-4 1s-2.86-.37-4-1c-1.14.63-2.6 1-4 1s-2.85-.36-4-1L2 4s2 2 2 4s-2 6-2 8c0 4 10 6 10 6s10-2 10-6c0-2-2-6-2-8s2-4 2-4l-2-2m-4.95 14.45l-3.08-1.86l-3.07 1.86l.82-3.5L7 10.61l3.58-.31L11.97 7l1.4 3.29l3.58.31l-2.72 2.34l.82 3.51"/>'
        },
        "police-station": {
            body: '<path fill="currentColor" d="M12 10s4-.8 4-2.4c0-.8-.8-2.4-.8-3.2c0-.8.8-1.6.8-1.6l-.8-.8c-.46.26-1.04.4-1.6.4S12.46 2.25 12 2c-.46.25-1.04.4-1.6.4S9.26 2.26 8.8 2l-.8.8s.8.8.8 1.6S8 6.8 8 7.6c0 1.6 4 2.4 4 2.4m-.57-4.68L12 4l.55 1.32l1.45.12l-1.11.94l.33 1.4L12 7.04l-1.24.74l.33-1.4L10 5.44l1.43-.12M21 6h-4.35c.19.58.35 1.12.35 1.6c0 2.25-3.68 3.16-4.8 3.4h-.4C10.68 10.76 7 9.85 7 7.6c0-.48.16-1.02.35-1.6H3c-.55 0-1 .45-1 1v15h8v-5h4v5h8V7c0-.55-.45-1-1-1M8 20H4v-3h4v3m0-5H4v-3h4v3m6 0h-4v-3h4v3m6 5h-4v-3h4v3m0-5h-4v-3h4v3Z"/>'
        },
        poll: {
            body: '<path fill="currentColor" d="M3 22V8h4v14H3m7 0V2h4v20h-4m7 0v-8h4v8h-4Z"/>'
        },
        polo: {
            body: '<path fill="currentColor" d="M22 9.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 5 0M11 17V3H8v14H2l4 4h7v-4h-2m5 0h-2v4h2v-4Z"/>'
        },
        polymer: {
            body: '<path fill="currentColor" d="M19 4h-4L7.1 16.63L4.5 12L9 4H5L.5 12L5 20h4l7.89-12.63L19.5 12L15 20h4l4.5-8L19 4Z"/>'
        },
        pool: {
            body: '<path fill="currentColor" d="M2 15c1.67-.75 3.33-1.5 5-1.83V5a3 3 0 0 1 3-3c1.31 0 2.42.83 2.83 2H10a1 1 0 0 0-1 1v1h5V5a3 3 0 0 1 3-3c1.31 0 2.42.83 2.83 2H17a1 1 0 0 0-1 1v9.94c2-.32 4-1.94 6-1.94v2c-2.22 0-4.44 2-6.67 2c-2.22 0-4.44-2-6.66-2c-2.23 0-4.45 1-6.67 2v-2m12-7H9v2h5V8m0 4H9v1c1.67.16 3.33 1.31 5 1.79V12M2 19c2.22-1 4.44-2 6.67-2c2.22 0 4.44 2 6.66 2c2.23 0 4.45-2 6.67-2v2c-2.22 0-4.44 2-6.67 2c-2.22 0-4.44-2-6.66-2c-2.23 0-4.45 1-6.67 2v-2Z"/>'
        },
        "pool-thermometer": {
            body: '<path fill="currentColor" d="M19 6c-1.1 0-2 .9-2 2v6.8c-.6.6-1 1.4-1 2.2c0 1.7 1.3 3 3 3s3-1.3 3-3c0-.9-.4-1.7-1-2.2V8c0-1.1-.9-2-2-2m0 1c.5 0 1 .4 1 1v1h-2V8c0-.6.5-1 1-1m-4 13.3c-.9.4-1.8.7-2.7.7c-2.2 0-4.4-2-6.7-2c-1.2 0-2.4.3-3.7.7v-2c1.3-.4 2.5-.7 3.8-.7c2.2 0 4.4 2 6.7 2c.9 0 1.8-.3 2.7-.7v2M12.3 17c.9 0 1.8-.3 2.7-.7v-2c-.7.3-1.3.5-2 .7V5c0-.6.4-1 1-1h2.8c-.4-1.2-1.5-2-2.8-2c-1.7 0-3 1.3-3 3v1H6V5c0-.6.4-1 1-1h2.8C9.4 2.8 8.3 2 7 2C5.3 2 4 3.3 4 5v8.2c-.7.1-1.3.3-2 .6v2c1.2-.5 2.4-.8 3.7-.8c2.2 0 4.4 2 6.6 2M6 8h5v2H6V8m0 4h5v2.8c-1.7-.5-3.3-1.6-5-1.8v-1Z"/>'
        },
        popcorn: {
            body: '<path fill="currentColor" d="M7 22H4.75s-.75 0-.94-1.35L2.04 3.81L2 3.5C2 2.67 2.9 2 4 2s2 .67 2 1.5C6 2.67 6.9 2 8 2s2 .67 2 1.5c0-.83.9-1.5 2-1.5c1.09 0 2 .66 2 1.5c0-.83.9-1.5 2-1.5s2 .67 2 1.5c0-.83.9-1.5 2-1.5s2 .67 2 1.5l-.04.31l-1.77 16.84C20 22 19.25 22 19.25 22H7M17.85 4.93C17.55 4.39 16.84 4 16 4c-.81 0-1.64.36-2 .87L13.78 20h2.88l1.19-15.07M10 4.87C9.64 4.36 8.81 4 8 4c-.84 0-1.55.39-1.85.93L7.34 20h2.88L10 4.87Z"/>'
        },
        post: {
            body: '<path fill="currentColor" d="M3 3v18h18V3H3m15 15H6v-1h12v1m0-2H6v-1h12v1m0-4H6V6h12v6Z"/>'
        },
        "post-lamp": {
            body: '<path fill="currentColor" d="m14 3l-1-2h-2l-1 2l-5 3h2l1 8l2 2l.5 1H9v6h6v-6h-1.5l.5-1l2-2l1-8h2l-5-3m.16 10H9.84L9 6h6l-.84 7Z"/>'
        },
        "post-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m2-2H3v18h18V3m-4 14H7v-1h10v1m0-2H7v-1h10v1m0-3H7V7h10v5Z"/>'
        },
        "postage-stamp": {
            body: '<path fill="currentColor" d="M2 2v3.5c1.1 0 2 1.12 2 2.5s-.9 2.5-2 2.5v3c1.1 0 2 1.12 2 2.5s-.9 2.5-2 2.5V22h3.5c0-1.1 1.12-2 2.5-2s2.5.9 2.5 2h3c0-1.1 1.12-2 2.5-2s2.5.9 2.5 2H22v-3.5c-1.1 0-2-1.12-2-2.5s.9-2.5 2-2.5v-3c-1.1 0-2-1.12-2-2.5s.9-2.5 2-2.5V2h-3.5c0 1.1-1.12 2-2.5 2s-2.5-.9-2.5-2h-3c0 1.1-1.12 2-2.5 2s-2.5-.9-2.5-2H2m4 4h12v12H6V6m3 1a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m8 3l-3 3l-2-1l-5 5h10v-7Z"/>'
        },
        pot: {
            body: '<path fill="currentColor" d="M19 19c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-7H3v-2h18v2h-2v7Z"/>'
        },
        "pot-mix": {
            body: '<path fill="currentColor" d="M14.6 9L18 3.1l1.7 1L16.9 9h-2.3m-.6 1H3v2h2v7c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-7h2v-2h-7Z"/>'
        },
        "pot-mix-outline": {
            body: '<path fill="currentColor" d="M14.6 9L18 3.1l1.7 1L16.9 9h-2.3m1.7 1H21v2h-2v7c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-7H3v-2h13.3m.7 2H7v7h10v-7Z"/>'
        },
        "pot-outline": {
            body: '<path fill="currentColor" d="M3 10v2h2v7c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-7h2v-2H3m4 2h10v7H7v-7Z"/>'
        },
        "pot-steam": {
            body: '<path fill="currentColor" d="M19 19c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2v-7H3v-2h18v2h-2M8 1.5a3.35 3.35 0 0 0 0 6.7h1.53c.39 0 .76.1 1.08.3h2.02c-.58-1.05-1.77-1.75-3.1-1.75H8c-1 0-1.85-.98-1.85-2S7 3 8 3m4.85-1c0 1-.85 1.85-1.85 1.85v1.5c1.92 0 3.5 1.35 3.89 3.15h1.53a5.541 5.541 0 0 0-3.07-4.12c.62-.61 1-1.45 1-2.38Z"/>'
        },
        "pot-steam-outline": {
            body: '<path fill="currentColor" d="M8 1.5a3.35 3.35 0 0 0 0 6.7h1.53c.39 0 .76.1 1.08.3h2.02c-.58-1.05-1.77-1.75-3.1-1.75H8c-1 0-1.85-.98-1.85-2S7 3 8 3V1.5m4.85.5c0 1-.85 1.85-1.85 1.85v1.5c1.92 0 3.5 1.35 3.89 3.15h1.53a5.541 5.541 0 0 0-3.07-4.12c.62-.61 1-1.45 1-2.38h-1.5M3 10v2h2v7a2 2 0 0 0 2 2h10c1.11 0 2-.89 2-2v-7h2v-2H3m4 2h10v7H7v-7Z"/>'
        },
        pound: {
            body: '<path fill="currentColor" d="m5.41 21l.71-4h-4l.35-2h4l1.06-6h-4l.35-2h4l.71-4h2l-.71 4h6l.71-4h2l-.71 4h4l-.35 2h-4l-1.06 6h4l-.35 2h-4l-.71 4h-2l.71-4h-6l-.71 4h-2M9.53 9l-1.06 6h6l1.06-6h-6Z"/>'
        },
        "pound-box": {
            body: '<path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m4 13h2l.35-2h4L13 18h2l.35-2h2l.36-2h-2l.7-4h2l.35-2h-2l.36-2h-2l-.36 2h-4l.36-2h-2l-.36 2h-2l-.35 2h2l-.7 4h-2l-.36 2h2L7 18m3.41-8h4l-.7 4h-4l.7-4Z"/>'
        },
        "pound-box-outline": {
            body: '<path fill="currentColor" d="M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M7 9h2.31l.32-3h2l-.32 3h2l.32-3h2l-.32 3H17v2h-1.9l-.2 2H17v2h-2.31l-.32 3h-2l.32-3h-2l-.32 3h-2l.32-3H7v-2h1.9l.2-2H7V9m4.1 2l-.2 2h2l.2-2Z"/>'
        },
        power: {
            body: '<path fill="currentColor" d="m16.56 5.44l-1.45 1.45A5.969 5.969 0 0 1 18 12a6 6 0 0 1-6 6a6 6 0 0 1-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 5.44A7.961 7.961 0 0 0 4 12a8 8 0 0 0 8 8a8 8 0 0 0 8-8c0-2.72-1.36-5.12-3.44-6.56M13 3h-2v10h2"/>'
        },
        "power-cycle": {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m0 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m1-2h-2V7h2v10Z"/>'
        },
        "power-off": {
            body: '<path fill="currentColor" d="M12 3a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9m0 16a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7Z"/>'
        },
        "power-on": {
            body: '<path fill="currentColor" d="M11 3h2v18h-2V3Z"/>'
        },
        "power-plug": {
            body: '<path fill="currentColor" d="M16 7V3h-2v4h-4V3H8v4C7 7 6 8 6 9v5.5L9.5 18v3h5v-3l3.5-3.5V9c0-1-1-2-2-2Z"/>'
        },
        "power-plug-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-5.53-5.53l-.81.8v3h-5v-3L6 14.5V9c0-.3.1-.59.25-.86L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M18 14.5V9c0-1-1-2-2-2V3h-2v4h-3.8l7.65 7.65l.15-.15M10 3H8v1.8l2 2V3Z"/>'
        },
        "power-plug-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.14 5.14C6.1 8.41 6 8.7 6 9v5.5L9.5 18v3h5v-3l.81-.8l5.53 5.53l1.27-1.27m-9.02-4.87l-.42.41h-1.34l-.41-.41L8 13.67V9.89l5.89 5.89l-.8.81M12.2 9l-2-2H14V3h2v4c1 0 2 1 2 2v5.5l-.15.15L16 12.8V9.09c0-.03-.05-.09-.08-.09H12.2M10 6.8l-2-2V3h2v3.8Z"/>'
        },
        "power-plug-outline": {
            body: '<path fill="currentColor" d="M16 7V3h-2v4h-4V3H8v4C7 7 6 8 6 9v5.5L9.5 18v3h5v-3l3.5-3.5V9c0-1-1-2-2-2m0 6.67l-2.91 2.92l-.42.41h-1.34l-.41-.41L8 13.67V9.09c0-.03.06-.09.09-.09h7.83c.03 0 .08.06.08.09v4.58Z"/>'
        },
        "power-settings": {
            body: '<path fill="currentColor" d="M15 24h2v-2h-2m1.56-17.56l-1.45 1.45A5.969 5.969 0 0 1 18 11a6 6 0 0 1-6 6a6 6 0 0 1-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 0 0 4 11a8 8 0 0 0 8 8a8 8 0 0 0 8-8c0-2.72-1.36-5.12-3.44-6.56M13 2h-2v10h2m-2 12h2v-2h-2m-4 2h2v-2H7v2Z"/>'
        },
        "power-sleep": {
            body: '<path fill="currentColor" d="M18.73 18c-3.33 3.69-9.02 4-12.73.64c-3.67-3.33-3.96-9.02-.63-12.71A9.052 9.052 0 0 1 11.27 3c-3.31 3.7-3 9.39.73 12.71c1.63 1.48 3.78 2.29 6 2.29h.73Z"/>'
        },
        "power-socket": {
            body: '<path fill="currentColor" d="M15 15h2v-4h-2m-8 4h2v-4H7m4 2h2V9h-2M8.83 7h6.37l3.8 3.8V17H5v-6.2M8 5l-5 5v9h18v-9l-5-5H8Z"/>'
        },
        "power-socket-au": {
            body: '<path fill="currentColor" d="M4.22 2A2.22 2.22 0 0 0 2 4.22v15.56C2 21 3 22 4.22 22h15.56A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M12 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8M8.27 7.54l-2 3.46L8 12l2-3.46l-1.73-1m7.46 0l-1.73 1L16 12l1.73-1l-2-3.46M11 14v4h2v-4h-2Z"/>'
        },
        "power-socket-ch": {
            body: '<path fill="currentColor" d="M19.78 2H4.22C3 2 2 3 2 4.22v15.56C2 21 3 22 4.22 22h15.56C21 22 22 21 22 19.78V4.22C22 3 21 2 19.78 2M20 13l-3.45 3.45c-.36.36-.8.55-1.25.55H8.7c-.45 0-.89-.19-1.25-.55L4 13c-.5-.5-.5-1.5 0-2l3.45-3.45c.36-.36.8-.55 1.25-.55h6.6c.45 0 .89.19 1.25.55L20 11c.5.5.5 1.5 0 2m-9.5 1c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m5-2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5m-10 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5Z"/>'
        },
        "power-socket-de": {
            body: '<path fill="currentColor" d="M4.22 2A2.22 2.22 0 0 0 2 4.22v15.56C2 21 3 22 4.22 22h15.56A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M11 4.07V6h2V4.07A8 8 0 0 1 20 12a8 8 0 0 1-7 7.93V18h-2v1.93A8 8 0 0 1 4 12a8 8 0 0 1 7-7.93M7.5 10.5A1.5 1.5 0 0 0 6 12c0 .83.66 1.5 1.5 1.5A1.5 1.5 0 0 0 9 12a1.5 1.5 0 0 0-1.5-1.5m9 0A1.5 1.5 0 0 0 15 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 18 12a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "power-socket-eu": {
            body: '<path fill="currentColor" d="M7.5 10.5A1.5 1.5 0 0 1 9 12a1.5 1.5 0 0 1-1.5 1.5c-.84 0-1.5-.67-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m9 0A1.5 1.5 0 0 1 18 12a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 15 12a1.5 1.5 0 0 1 1.5-1.5M4.22 2h15.56C21 2 22 3 22 4.22v15.56A2.22 2.22 0 0 1 19.78 22H4.22C3 22 2 21 2 19.78V4.22A2.22 2.22 0 0 1 4.22 2M12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "power-socket-fr": {
            body: '<path fill="currentColor" d="M4.22 2A2.22 2.22 0 0 0 2 4.22v15.56C2 21 3 22 4.22 22h15.56A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M12 4a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 2a1.5 1.5 0 0 0-1.5 1.5A1.5 1.5 0 0 0 12 9a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 12 6m-4.5 4.5A1.5 1.5 0 0 0 6 12c0 .83.66 1.5 1.5 1.5A1.5 1.5 0 0 0 9 12a1.5 1.5 0 0 0-1.5-1.5m9 0A1.5 1.5 0 0 0 15 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 18 12a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "power-socket-it": {
            body: '<path fill="currentColor" d="M10.5 16.5c0-.82.67-1.5 1.5-1.5s1.5.68 1.5 1.5c0 .84-.67 1.5-1.5 1.5s-1.5-.66-1.5-1.5m0-9c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S12.83 9 12 9s-1.5-.67-1.5-1.5M4.22 2h15.56C21 2 22 3 22 4.22v15.56C22 21 21 22 19.78 22H4.22C3 22 2 21 2 19.78V4.22C2 3 3 2 4.22 2M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m-1.5 8c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5Z"/>'
        },
        "power-socket-jp": {
            body: '<path fill="currentColor" d="M10 9.5v5H8v-5M19.78 2C21 2 22 3 22 4.22v15.56C22 21 21 22 19.78 22H4.22C3 22 2 21 2 19.78V4.22C2 3 3 2 4.22 2M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8m4 5.5v5h-2v-5Z"/>'
        },
        "power-socket-uk": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4m0 2h16v16H4V4m7 3v4h2V7h-2m-5 7.75V17h3.5v-2.25H6m8.5 0V17H18v-2.25h-3.5Z"/>'
        },
        "power-socket-us": {
            body: '<path fill="currentColor" d="M8 7h2v5H8V7M4.22 2h15.56C21 2 22 3 22 4.22v15.56A2.22 2.22 0 0 1 19.78 22H4.22C3 22 2 21 2 19.78V4.22A2.22 2.22 0 0 1 4.22 2M12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8m2 3.5h2v4h-2v-4m-3.5 8.75a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5V17h-3v-.75Z"/>'
        },
        "power-standby": {
            body: '<path fill="currentColor" d="M13 3h-2v10h2V3m4.83 2.17l-1.42 1.42A6.944 6.944 0 0 1 19 12a7 7 0 0 1-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17a9.001 9.001 0 0 0-1.03 12.69c3.22 3.78 8.9 4.24 12.69 1.02A9.003 9.003 0 0 0 21 12c0-2.63-1.16-5.13-3.17-6.83Z"/>'
        },
        powershell: {
            body: '<path fill="currentColor" d="M21.83 4c.49 0 .8.4.67.89l-3.16 14.22c-.11.49-.59.89-1.08.89H2.17c-.49 0-.8-.4-.67-.89L4.66 4.89C4.77 4.4 5.25 4 5.74 4h16.09m-6 12h-4c-.46 0-.83.38-.83.84c0 .47.37.85.83.85h4c.47 0 .85-.38.85-.85c0-.46-.38-.84-.85-.84m-10.05.28a.87.87 0 0 0-.21 1.22c.28.42.84.5 1.24.23c7.35-5.17 7.4-5.23 7.45-5.26c.18-.16.27-.38.28-.6c.01-.2-.04-.37-.16-.56L9.46 6.03A.867.867 0 0 0 8.21 6c-.36.32-.38.88-.05 1.24l4.15 4.44l-6.53 4.6Z"/>'
        },
        prescription: {
            body: '<path fill="currentColor" d="M4 4v10h2v-4h2l5.41 5.41L9.83 19l1.41 1.41l3.59-3.58l3.58 3.58L19.82 19l-3.58-3.59l3.58-3.58l-1.41-1.42L14.83 14l-4-4H11a3 3 0 0 0 3-3a3 3 0 0 0-3-3H4m2 2h5a1 1 0 0 1 1 1a1 1 0 0 1-1 1H6V6Z"/>'
        },
        presentation: {
            body: '<path fill="currentColor" d="M2 3h8a2 2 0 0 1 2-2a2 2 0 0 1 2 2h8v2h-1v11h-5.75L17 22h-2l-1.75-6h-2.5L9 22H7l1.75-6H3V5H2V3m3 2v9h14V5H5Z"/>'
        },
        "presentation-play": {
            body: '<path fill="currentColor" d="M2 3h8a2 2 0 0 1 2-2a2 2 0 0 1 2 2h8v2h-1v11h-5.75L17 22h-2l-1.75-6h-2.5L9 22H7l1.75-6H3V5H2V3m3 2v9h14V5H5m6.85 6.85a.49.49 0 0 1-.35.15a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5c.14 0 .26.06.35.15l1.4 1.39c.32.32.64.64.64.96c0 .32-.32.64-.64.96l-1.4 1.39Z"/>'
        },
        pretzel: {
            body: '<path fill="currentColor" d="M5.15 15.84A8.966 8.966 0 0 1 3 10v-.03C3 7.22 5.25 5 8 5c1.64 0 3.09.79 4 2c.91-1.21 2.37-2 4-2c2.76 0 5 2.24 5 5c0 2.23-.81 4.27-2.15 5.84l1.36 1.36l-1.42 1.41l-1.4-1.4A9.036 9.036 0 0 1 12 19c-2 0-3.89-.67-5.39-1.79l-1.4 1.4l-1.42-1.41l1.36-1.36m10.81-.07L12 11.82l-3.96 3.95C9.17 16.55 10.53 17 12 17c1.47 0 2.83-.45 3.96-1.23M11 10c0-1.66-1.35-3-3-3c-1.66 0-3 1.34-3 3c0 1.68.59 3.21 1.57 4.42L11 10m6.43 4.42A6.986 6.986 0 0 0 19 10c0-1.67-1.35-3-3-3s-3 1.34-3 3l4.43 4.42Z"/>'
        },
        prezi: {
            body: '<path d="M7.25 11.991c.025-1.9 1.343-4.71 4.78-4.71c2.597 0 4.722 2.108 4.722 4.71c0 2.603-2.125 4.773-4.721 4.773s-4.815-2.17-4.78-4.773zm4.78-4.2a4.194 4.194 0 0 0-4.188 4.2c0 2.32 1.875 4.161 4.189 4.161s4.13-1.841 4.13-4.16c0-2.32-1.816-4.2-4.13-4.2zm-5.944 4.2c0-3.509 2.838-5.908 5.944-5.908c3.107 0 5.866 2.616 5.866 5.908c0 3.292-2.735 5.88-5.866 5.88c-3.13 0-5.944-2.514-5.944-5.88zm5.944-5.374c-2.927 0-5.33 2.296-5.33 5.374c0 2.965 2.27 5.315 5.33 5.315c2.928 0 5.302-2.227 5.302-5.315c0-3.068-2.618-5.374-5.302-5.374zm-7.095 5.377c0-4.196 3.326-7.084 7.097-7.084c3.772 0 7.056 3.113 7.056 7.084c0 3.972-3.28 7.052-7.056 7.052c-3.776 0-7.097-2.992-7.097-7.052zm7.097-6.498c-3.531 0-6.545 2.785-6.545 6.498c0 3.577 2.955 6.487 6.464 6.487c3.532 0 6.54-2.762 6.54-6.487c0-3.7-3.042-6.498-6.459-6.498zm-.37 3.074h.749v6.823h-.748V8.57zm-1.56.536c.3-.238.748-.355.748-.355v6.442a2.185 2.185 0 0 1-.743-.346l-.005-5.74zm3.879-.014l-.005 5.74s-.319.246-.743.347V8.737s.448.116.748.355zm-4.703.795v4.15s-.688-.673-.688-2.064c0-1.39.688-2.086.688-2.086zm5.47-.029s.688.695.688 2.086s-.688 2.065-.688 2.065V9.858zm.786-4.864l-.716-.335l.786-2.003l.919.443l-.989 1.895zm-1.54-.584l-.77-.177l.35-2.123l.991.24l-.57 2.06zM12.4 4.163l-.79-.017l-.091-2.15l1.019.034l-.138 2.133zm-1.651.09l-.776.15l-.54-2.083l1.004-.181l.312 2.114zm-1.592.433l-.728.308l-.963-1.924l.944-.387l.747 2.003zm-1.464.754l-.647.454L5.7 4.213l.842-.575l1.15 1.802zM6.441 6.46l-.541.577l-1.659-1.37l.707-.736L6.44 6.46zM5.403 7.748l-.408.677l-1.909-.993l.537-.867l1.78 1.183zM4.672 9.19l-.26.746l-2.073-.58l.347-.959l1.986.793zm-.426 1.59l-.098.785L2 11.431l.14-1.01l2.106.36zm-.085 1.613l.064.788l-2.13.307l-.07-1.017l2.136-.078zm.257 1.633l.227.758l-2.018.747l-.282-.98l2.073-.525zm.59 1.54l.381.693l-1.817 1.153l-.48-.9l1.917-.946zm.899 1.38l.517.6l-1.537 1.505l-.657-.78l1.677-1.324zm1.141 1.143l.629.48l-1.197 1.788l-.803-.628l1.371-1.64zm1.386.902l.715.337l-.795 2l-.917-.446l.997-1.891zm1.552.594l.77.18l-.356 2.121l-.99-.243l.576-2.058zm1.627.253l.791.015l.095 2.15l-1.02-.032l.135-2.133zm1.612-.087l.777-.147l.533 2.084l-1.004.178l-.306-2.115zm1.597-.429l.73-.307l.957 1.927l-.945.384l-.742-2.004zm1.469-.752l.648-.452l1.34 1.684l-.844.573l-1.144-1.805zm1.276-1.04l.54-.578l1.662 1.368l-.705.736l-1.497-1.526zm1.014-1.256l.41-.676l1.906.998l-.54.866l-1.776-1.189zm.75-1.474l.26-.747l2.072.577l-.346.959l-1.986-.79zm.424-1.604l.097-.785l2.148.129l-.137 1.01l-2.108-.354zm.079-1.652l-.07-.787l2.127-.325l.078 1.017l-2.135.095zm-.268-1.627l-.233-.756l2.012-.762l.289.978l-2.068.54zm-.602-1.534l-.385-.69l1.809-1.165l.486.896l-1.91.96zm-.887-1.348l-.518-.597l1.532-1.51l.66.777l-1.674 1.33zm-1.175-1.164l-.632-.475L17.452 3.6l.808.623l-1.358 1.65z" fill="currentColor"/>',
            hidden: true
        },
        printer: {
            body: '<path fill="currentColor" d="M18 3H6v4h12m1 5a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m-3 7H8v-5h8m3-6H5a3 3 0 0 0-3 3v6h4v4h12v-4h4v-6a3 3 0 0 0-3-3Z"/>'
        },
        "printer-3d": {
            body: '<path fill="currentColor" d="M19 6a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-4a3 3 0 0 1 3 3v6h-4V7H6v4H2V5a3 3 0 0 1 3-3h14m-1 16.25c0 .38-.21.71-.53.88l-4.9 2.69c-.17.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-4.9-2.69a.991.991 0 0 1-.53-.88V13c0-.38.21-.71.53-.88l4.9-2.44c.16-.12.36-.18.57-.18c.21 0 .4.06.57.18l4.9 2.44c.32.17.53.5.53.88v5.25m-6-6.6L9.04 13L12 14.6l2.96-1.6L12 11.65m-4 6.01l3 1.63v-2.96l-3-1.62v2.95m8 0v-2.95l-3 1.62v2.96l3-1.63Z"/>'
        },
        "printer-3d-nozzle": {
            body: '<path fill="currentColor" d="M7 2h10v6h2v5h-2.5L13 17h-2l-3.5-4H5V8h2V2m3 20H2v-2h8a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3Z"/>'
        },
        "printer-3d-nozzle-alert": {
            body: '<path fill="currentColor" d="M7 2h10v6h2v5h-2.5L13 17h-2l-3.5-4H5V8h2V2m3 20H2v-2h8c.6 0 1-.5 1-1v-1h2v1c0 1.7-1.3 3-3 3m11-9V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "printer-3d-nozzle-alert-outline": {
            body: '<path fill="currentColor" d="M7 2h10v5h2v6h-2.5L13 17h-2l-3.5-4H5V7h2V2m3 20H2v-2h8c.6 0 1-.5 1-1v-1h2v1c0 1.7-1.3 3-3 3M7 9v2h1.5l3.5 4l3.5-4H17V9h-2V4H9v5H7m14 4V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "printer-3d-nozzle-heat": {
            body: '<path fill="currentColor" d="M4 2h10v5h2v6h-2.5L10 17H8l-3.5-4H2V7h2V2m19 12.5l-1.4 2.2l1.4 2.2l-2 3.1l-1.8-.9l1.5-2.2l-1.5-2.2l2-3.1l1.8.9m-4.3 0l-1.5 2.2l1.5 2.2l-2 3.1l-1.8-.9l1.4-2.2l-1.4-2.2l2-3.1l1.8.9"/>'
        },
        "printer-3d-nozzle-heat-outline": {
            body: '<path fill="currentColor" d="m23 14.5l-1.4 2.2l1.4 2.2l-2 3.1l-1.8-.9l1.5-2.2l-1.5-2.2l2-3.1l1.8.9m-4.3 0l-1.5 2.2l1.5 2.2l-2 3.1l-1.8-.9l1.4-2.2l-1.4-2.2l2-3.1l1.8.9M4 2h10v5h2v6h-2.5L10 17H8l-3.5-4H2V7h2V2m0 7v2h1.5L9 15l3.5-4H14V9h-2V4H6v5H4Z"/>'
        },
        "printer-3d-nozzle-off": {
            body: '<path fill="currentColor" d="M20.8 22.7L14 15.9L13 17h-2l-3.5-4H5V8h1.1l-5-5l1.3-1.3l19.7 19.7l-1.3 1.3M11 19c0 .6-.4 1-1 1H2v2h8c1.7 0 3-1.3 3-3v-1h-2v1m8-6V8h-2V2H7v1.8l9.2 9.2H19Z"/>'
        },
        "printer-3d-nozzle-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4 4H5v6h2.5l3.5 4h2l1-1.1l6.9 6.9l1.2-1.3M12 15l-3.5-4H7V9h.1l5.4 5.4l-.5.6m-1 3h2v1c0 1.7-1.3 3-3 3H2v-2h8c.6 0 1-.4 1-1v-1M9 5.8l-2-2V2h10v5h2v6h-2.8l-1.3-1.3l.6-.7H17V9h-2V4H9v1.8Z"/>'
        },
        "printer-3d-nozzle-outline": {
            body: '<path fill="currentColor" d="M7 2h10v5h2v6h-2.5L13 17h-2l-3.5-4H5V7h2V2m3 20H2v-2h8a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3M7 9v2h1.5l3.5 4l3.5-4H17V9h-2V4H9v5H7Z"/>'
        },
        "printer-3d-off": {
            body: '<path fill="currentColor" d="M2.3 2L1 3.3l1.1 1.1c-.1.2-.1.4-.1.6v6h4V8.3L8.7 11l-2.2 1.1c-.3.2-.5.5-.5.9v5.2c0 .4.2.7.5.9l4.9 2.7c.2.1.4.2.6.2s.4-.1.6-.2l4.5-2.5l3.7 3.7l1.3-1.3L2.3 2m2.6 0h-.1l5 5H18v4h4V5c0-1.7-1.3-3-3-3H4.9c.1 0 .1 0 0 0M19 4c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m-6.6 5.6l5.6 5.6V13c0-.4-.2-.7-.5-.9l-4.9-2.4c-.1 0-.1-.1-.2-.1m-2.2 2.9l2 2l-.2.1L9 13l1.2-.5M8 14.7l3 1.6v3l-3-1.6v-3m5.7 1.3l1.9 1.9l-2.6 1.4v-3l.7-.3Z"/>'
        },
        "printer-alert": {
            body: '<path fill="currentColor" d="M16 3H4v4h12m1 5c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m-3 7H6v-5h8m3-6H3c-1.7 0-3 1.3-3 3v6h4v4h12v-4h4v-6c0-1.7-1.3-3-3-3m7 5h-2V7h2v6m0 4h-2v-2h2v2Z"/>'
        },
        "printer-check": {
            body: '<path fill="currentColor" d="M18 7H6V3h12v4M6 21v-4H2v-6c0-1.66 1.34-3 3-3h14c1.66 0 3 1.34 3 3v2.81c-.88-.51-1.9-.81-3-.81c-1.23 0-2.36.37-3.31 1H8v5h5c0 .7.13 1.37.35 2H6m12-10c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m5.5 6L22 15.5L18.5 19l-2-2l-1.5 1.5l3.5 3.5l5-5"/>'
        },
        "printer-eye": {
            body: '<path fill="currentColor" d="M9.8 21c-.2-.4-.5-.8-.6-1.3l-.4-.7H8v-5h5c1.2-.6 2.6-1 4-1c1.9 0 3.6.6 5 1.6V11c0-1.7-1.3-3-3-3H5c-1.7 0-3 1.3-3 3v6h4v4h3.8M19 10c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m-1-3H6V3h12v4m-1 11c.6 0 1 .4 1 1s-.4 1-1 1s-1-.4-1-1s.4-1 1-1m0-3c-2.7 0-5.1 1.7-6 4c.9 2.3 3.3 4 6 4s5.1-1.7 6-4c-.9-2.3-3.3-4-6-4m0 6.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5Z"/>'
        },
        "printer-off": {
            body: '<path fill="currentColor" d="M6 3v1.18L8.82 7H18V3H6M2.28 3L1 4.27L4.75 8A3.02 3.02 0 0 0 2 11v6h4v4h11.73l2 2L21 21.72L2.28 3m7.54 5l9 9H22v-6a3 3 0 0 0-3-3H9.82M19 10a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M8 14h2.73l5 5H8v-5Z"/>'
        },
        "printer-off-outline": {
            body: '<path fill="currentColor" d="m1.41 1.6l20.95 20.95l-1.41 1.41L18 21H6v-4H2v-6c0-1.66 1.34-3 3-3L0 3l1.41-1.4M6 15v-2h4l-3-3H5c-.55 0-1 .45-1 1v4h2m2 4h8l-4-4H8v4M8 5v.36l-2-2V3h12v5h1c1.66 0 3 1.34 3 3v6h-2.34l-4-4H18v2h2v-4c0-.55-.45-1-1-1h-6.34l-2-2H16V5H8m11 6.5c0 .56-.45 1-1 1s-1-.44-1-1c0-.54.45-1 1-1s1 .46 1 1Z"/>'
        },
        "printer-outline": {
            body: '<path fill="currentColor" d="M19 8c1.66 0 3 1.34 3 3v6h-4v4H6v-4H2v-6c0-1.66 1.34-3 3-3h1V3h12v5h1M8 5v3h8V5H8m8 14v-4H8v4h8m2-4h2v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4h2v-2h12v2m1-3.5c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1Z"/>'
        },
        "printer-pos": {
            body: '<path fill="currentColor" d="M18 10H6a2 2 0 0 0-2 2v7h16v-7a2 2 0 0 0-2-2m0 4h-4v-2h4m-1-3H7V4h10Z"/>'
        },
        "printer-search": {
            body: '<path fill="currentColor" d="M20.3 18.9c.4-.7.7-1.5.7-2.4c0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.2 2.4-.7l3.1 3.1l1.4-1.4l-3.1-3.1m-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5M18 7H6V3h12v4M6 21v-4H2v-6c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v2c-1.2-1.8-3.2-3-5.5-3c-2.7 0-5 1.7-6 4H8v5h2.5c.3.7.8 1.4 1.3 2H6Z"/>'
        },
        "printer-settings": {
            body: '<path fill="currentColor" d="M18 2v4H6V2h12m1 9a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m-3 7v-5H8v5h8m3-11a3 3 0 0 1 3 3v6h-4v4H6v-4H2v-6a3 3 0 0 1 3-3h14m-4 17v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7Z"/>'
        },
        "printer-wireless": {
            body: '<path fill="currentColor" d="m4.93 3.92l1.41 1.41c3.12-3.13 8.19-3.13 11.32 0l1.41-1.41C15.17 0 8.84 0 4.93 3.92m2.83 2.83l1.41 1.41a4.008 4.008 0 0 1 5.66 0l1.41-1.41a6 6 0 0 0-8.48 0M19 14a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m-3 6H8v-5h8v5m3-10H5a3 3 0 0 0-3 3v5h4v4h12v-4h4v-5a3 3 0 0 0-3-3Z"/>'
        },
        "priority-high": {
            body: '<path fill="currentColor" d="M14 19h8v-2h-8v2m0-5.5h8v-2h-8v2M14 8h8V6h-8v2M2 12.5C2 8.92 4.92 6 8.5 6H9V4l3 3l-3 3V8h-.5C6 8 4 10 4 12.5S6 17 8.5 17H12v2H8.5C4.92 19 2 16.08 2 12.5Z"/>'
        },
        "priority-low": {
            body: '<path fill="currentColor" d="M14 5h8v2h-8V5m0 5.5h8v2h-8v-2m0 5.5h8v2h-8v-2M2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3l-3-3v2h-.5C6 16 4 14 4 11.5S6 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5Z"/>'
        },
        "professional-hexagon": {
            body: '<path fill="currentColor" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18c-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9M5 9v6h1.25v-2H7a2 2 0 0 0 2-2a2 2 0 0 0-2-2H5m1.25 3v-2h.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-.5m3.5-3v6H11v-2h.75l.66 2h1.32l-.79-2.39c.49-.36.81-.95.81-1.61a2 2 0 0 0-2-2h-2M11 12v-2h.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1H11m6-3c-1.38 0-2.5 1.34-2.5 3s1.12 3 2.5 3s2.5-1.34 2.5-3s-1.12-3-2.5-3m0 1.25c.76 0 1.38.78 1.38 1.75s-.62 1.75-1.38 1.75c-.76 0-1.37-.78-1.37-1.75s.61-1.75 1.37-1.75Z"/>'
        },
        "progress-alert": {
            body: '<path fill="currentColor" d="M13 2v2c4.39.54 7.5 4.53 6.96 8.92A8.014 8.014 0 0 1 13 19.88v2c5.5-.6 9.45-5.54 8.85-11.03C21.33 6.19 17.66 2.5 13 2m-2 0c-1.96.18-3.81.95-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.81 9.81 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5 5.37l-1.39 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63h-.04M13 13V7h-2v6h2m0 4v-2h-2v2h2Z"/>'
        },
        "progress-check": {
            body: '<path fill="currentColor" d="M13 2.03v2.02c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97m-2 .03c-1.95.19-3.81.94-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M15.5 8.5l-4.88 4.88l-2.12-2.12l-1.06 1.06l3.18 3.18l5.94-5.94L15.5 8.5M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5.04 5.37l-1.43 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63Z"/>'
        },
        "progress-clock": {
            body: '<path fill="currentColor" d="M13 2.03v2.02c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97m-2 .03c-1.95.19-3.81.94-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5.04 5.37l-1.43 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63M12.5 7v5.25l4.5 2.67l-.75 1.23L11 13V7h1.5Z"/>'
        },
        "progress-close": {
            body: '<path fill="currentColor" d="M13 2.03v2.02c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97m-2 .03c-1.95.19-3.81.94-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5.04 5.37l-1.43 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8Z"/>'
        },
        "progress-download": {
            body: '<path fill="currentColor" d="M13 2.03c4.73.47 8.5 4.22 8.95 8.97A9.976 9.976 0 0 1 13 21.93v-2c3.64-.43 6.5-3.32 6.96-6.96A7.994 7.994 0 0 0 13 4.05V2.03m-2 .03v2c-1.43.2-2.78.78-3.9 1.68L5.67 4.26A9.827 9.827 0 0 1 11 2.06M4.26 5.67L5.69 7.1A8.017 8.017 0 0 0 4.05 11h-2c.2-1.96.95-3.81 2.21-5.33M2.06 13h2c.18 1.42.75 2.77 1.63 3.9l-1.42 1.43A10.04 10.04 0 0 1 2.06 13m5.04 5.37c1.13.88 2.48 1.45 3.9 1.63v2c-1.96-.21-3.82-1-5.33-2.26l1.43-1.37M12 16.5L7.5 12H11V8h2v4h3.5L12 16.5Z"/>'
        },
        "progress-helper": {
            body: '<path fill="currentColor" d="M13 2v2c4.39.54 7.5 4.53 6.96 8.92A8.014 8.014 0 0 1 13 19.88v2c5.5-.6 9.45-5.54 8.85-11.03C21.33 6.19 17.66 2.5 13 2m-2 0c-1.96.18-3.81.95-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68V2M4.26 5.67A9.81 9.81 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5 5.37l-1.39 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63h-.04Z"/>'
        },
        "progress-pencil": {
            body: '<path fill="currentColor" d="m15.84 10.2l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79M8 13.91l4.17-4.19l2.07 2.08l-4.16 4.2H8v-2.09M13 2v2c4.39.54 7.5 4.53 6.96 8.92A8.014 8.014 0 0 1 13 19.88v2c5.5-.6 9.45-5.54 8.85-11.03C21.33 6.19 17.66 2.5 13 2m-2 0c-1.96.18-3.81.95-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.81 9.81 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5 5.37l-1.39 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63h-.04Z"/>'
        },
        "progress-question": {
            body: '<path fill="currentColor" d="M13 2.03v2.02c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97m-2 .03c-1.95.19-3.81.94-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5.04 5.37l-1.43 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63M20 4h24M13 18h-2v-2h2v2m0-3h-2c0-3.25 3-3 3-5c0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5Z"/>'
        },
        "progress-star": {
            body: '<path fill="currentColor" d="M13 2v2c4.39.54 7.5 4.53 6.96 8.92A8.014 8.014 0 0 1 13 19.88v2c5.5-.6 9.45-5.54 8.85-11.03C21.33 6.19 17.66 2.5 13 2m-2 0c-1.96.18-3.81.95-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.81 9.81 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5 5.37l-1.39 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63h-.04m1.52-1.57l.92-3.89l-3-2.58l3.95-.37L12 6.35L13.55 10l3.95.33l-3 2.58l.92 3.89L12 14.74L8.58 16.8"/>'
        },
        "progress-upload": {
            body: '<path fill="currentColor" d="M13 2.03c4.73.47 8.5 4.22 8.95 8.97A9.976 9.976 0 0 1 13 21.93v-2c3.64-.43 6.5-3.32 6.96-6.96A7.994 7.994 0 0 0 13 4.05V2.03m-2 .03v2c-1.43.2-2.78.78-3.9 1.68L5.67 4.26A9.827 9.827 0 0 1 11 2.06M4.26 5.67L5.69 7.1A8.017 8.017 0 0 0 4.05 11h-2c.2-1.96.95-3.81 2.21-5.33M2.06 13h2c.18 1.42.75 2.77 1.63 3.9l-1.42 1.43A10.04 10.04 0 0 1 2.06 13m5.04 5.37c1.13.88 2.48 1.45 3.9 1.63v2c-1.96-.21-3.82-1-5.33-2.26l1.43-1.37M12 7.5L7.5 12H11v4h2v-4h3.5L12 7.5Z"/>'
        },
        "progress-wrench": {
            body: '<path fill="currentColor" d="M13 2.03v2.02c4.39.54 7.5 4.53 6.96 8.92c-.46 3.64-3.32 6.53-6.96 6.96v2c5.5-.55 9.5-5.43 8.95-10.93c-.45-4.75-4.22-8.5-8.95-8.97m-2 .03c-1.95.19-3.81.94-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68v-2M4.26 5.67A9.885 9.885 0 0 0 2.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67M2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 0 1 4.06 13h-2m5.04 5.37l-1.43 1.37A9.994 9.994 0 0 0 11 22v-2a8.002 8.002 0 0 1-3.9-1.63m9.72-3.18l-4.11-4.11c.41-1.04.18-2.26-.68-3.11c-.9-.91-2.25-1.09-3.34-.59l1.94 1.94l-1.35 1.36l-1.99-1.95c-.54 1.09-.29 2.44.59 3.35c.86.86 2.08 1.08 3.12.68l4.11 4.1c.18.19.45.19.63 0l1.04-1.03c.22-.18.22-.5.04-.64Z"/>'
        },
        projector: {
            body: '<path fill="currentColor" d="M16 6c-1.13 0-2.23.35-3.16 1H4c-1.11 0-2 .89-2 2v6c0 1.11.89 2 2 2h1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-.85c-.92-.65-2.02-1-3.15-1m0 1.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5a3.5 3.5 0 0 1-3.5-3.5A3.5 3.5 0 0 1 16 7.5M4 9h4v1H4V9m12 0a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M4 11h4v1H4v-1m0 2h4v1H4v-1Z"/>'
        },
        "projector-off": {
            body: '<path fill="currentColor" d="M16 9c-1.03 0-1.9.79-2 1.82L16.18 13c2.54-.24 2.37-4-.18-4m-1 5.35l3.95 3.96v-.01M7.64 7l5.01 5l-5-5M20 7h-.85a5.488 5.488 0 0 0-6.31 0h-2.65l2.61 2.61c.98-2.27 3.93-2.83 5.7-1.08c1.72 1.74 1.16 4.69-1.11 5.67l2.79 2.8A2.01 2.01 0 0 0 22 15V9c0-1.1-.9-2-2-2m-4 2c-1.03 0-1.9.79-2 1.82L16.18 13c2.54-.24 2.37-4-.18-4m0 0c-1.03 0-1.9.79-2 1.82L16.18 13c2.54-.24 2.37-4-.18-4m6.25 12.61L2.53 1.89L1.26 3.16L5.1 7H4c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h6v1c0 .55.45 1 1 1h1.1l3.9 3.89l1.26-1.28M8 14H4v-1h4m0-1H4v-1h4m0-1H4V9h3.1l.9.9M2.54 1.89L7.64 7L2.53 1.89M7.65 7l5 5l-5.01-5m11.31 11.3v.01L15 14.35M7.64 7L2.53 1.89h.01M12.65 12L7.64 7h.01m11.3 11.3v.01L15 14.35"/>'
        },
        "projector-screen": {
            body: '<path fill="currentColor" d="M4 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v9h6v2.59l-4.21 4.2l1.42 1.42l2.79-2.8V22h2v-2.59l2.79 2.8l1.42-1.42l-4.21-4.2V14h6V5h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4Z"/>'
        },
        "projector-screen-off": {
            body: '<path fill="currentColor" d="M13 14.89v1.7l4.21 4.2l-1.42 1.42l-2.79-2.8V22h-2v-2.59l-2.79 2.8l-1.42-1.42l4.21-4.2V14H5V6.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27L13 14.89m6-.89V5h1c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H5.2l12 12H19Z"/>'
        },
        "projector-screen-off-outline": {
            body: '<path fill="currentColor" d="m20.84 22.73l1.27-1.27L2.39 1.73L1.11 3L5 6.89V14h6v2.59l-4.21 4.2l1.42 1.42l2.79-2.8V22h2v-2.59l2.79 2.8l1.42-1.42l-4.21-4.2v-1.7l7.84 7.84M7 12V8.89L10.11 12H7m1.2-7l-3-3H20c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1v9h-1.8l-2-2H17V5H8.2Z"/>'
        },
        "projector-screen-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h1v9h6v2.59l-4.21 4.2l1.42 1.42l2.79-2.8V22h2v-2.59l2.79 2.8l1.42-1.42l-4.21-4.2V14h6V5h1c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m-3 10H7V5h10v7Z"/>'
        },
        "projector-screen-variant": {
            body: '<path fill="currentColor" d="M19 18V9h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h1v9h14Z"/>'
        },
        "projector-screen-variant-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L16.11 18H5V9H4c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h.11l-3-3l1.28-1.27l19.72 19.73l-1.27 1.27M19 9h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H9.2l9.8 9.8V9Z"/>'
        },
        "projector-screen-variant-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l3 3H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h1v9h11.11l4.73 4.73l1.27-1.27M7 16V9h.11l7 7H7m5.2-7l-3-3H20c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1v6.8l-2-2V9h-4.8Z"/>'
        },
        "projector-screen-variant-outline": {
            body: '<path fill="currentColor" d="M20 6H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h1v9h14V9h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1m-3 10H7V9h10v7Z"/>'
        },
        "propane-tank": {
            body: '<path fill="currentColor" d="M4 15v3c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-3H4m16-2v-3c0-1.86-1.28-3.41-3-3.86V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v3h16M9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4Z"/>'
        },
        "propane-tank-outline": {
            body: '<path fill="currentColor" d="M17 6.14V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v8c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-8c0-1.86-1.28-3.41-3-3.86M9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4M8 8h8c1.1 0 2 .9 2 2v3H6v-3c0-1.1.9-2 2-2m8 12H8c-1.1 0-2-.9-2-2v-3h12v3c0 1.1-.9 2-2 2Z"/>'
        },
        protocol: {
            body: '<path fill="currentColor" d="M18 20h-4l4-16h4m-6 0h-4L8 20h4M2 16.5A2.5 2.5 0 0 0 4.5 19A2.5 2.5 0 0 0 7 16.5A2.5 2.5 0 0 0 4.5 14A2.5 2.5 0 0 0 2 16.5m0-7A2.5 2.5 0 0 0 4.5 12A2.5 2.5 0 0 0 7 9.5A2.5 2.5 0 0 0 4.5 7A2.5 2.5 0 0 0 2 9.5Z"/>'
        },
        publish: {
            body: '<path fill="currentColor" d="M5 4v2h14V4H5m0 10h4v6h6v-6h4l-7-7l-7 7Z"/>'
        },
        "publish-off": {
            body: '<path fill="currentColor" d="M20.8 22.7L15 16.9V20H9v-6H5l3.6-3.6L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M19 6V4H7.2l2 2H19m-1.8 8H19l-7-7l-.9.9l6.1 6.1Z"/>'
        },
        pulse: {
            body: '<path fill="currentColor" d="M3 13h2.79l4.31-8.21l1.18 8.96l3.22-4.09L17.83 13H21v2h-4l-2.33-2.33l-4.75 6.06l-.98-7.42L7 15H3v-2Z"/>'
        },
        pump: {
            body: '<path fill="currentColor" d="M2 21v-6h1.5a9.3 9.3 0 0 1-.5-3a9 9 0 0 1 9-9h10v6h-1.5c.32.94.5 1.95.5 3a9 9 0 0 1-9 9H2m3-9c0 1.28.34 2.47.94 3.5l3.46-2c-.25-.44-.4-.95-.4-1.5c0-.65.21-1.25.56-1.74L6.3 7.93C5.5 9.08 5 10.5 5 12m7 7c2.59 0 4.85-1.41 6.06-3.5l-3.46-2c-.52.9-1.49 1.5-2.6 1.5h-.29l-.38 3.97l.67.03m0-10c1.21 0 2.26.72 2.73 1.76l3.64-1.66A6.994 6.994 0 0 0 12 5v4m0 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        "pump-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l3.7 3.7C3.7 8.2 3 10 3 12c0 1 .2 2.1.5 3H2v6h10c2 0 3.8-.7 5.3-1.8l3.5 3.5l1.3-1.2m-16.2-6c-.6-1-.9-2.2-.9-3.5c0-1.4.5-2.8 1.2-3.9l3 3c-.1.2-.2.6-.2.9c0 .5.2 1.1.4 1.5l-3.5 2M12 19h-.7l.4-4h.3c.3 0 .6-.1.9-.2l3 3c-1.1.7-2.5 1.2-3.9 1.2m0-10.2L7.4 4.2C8.8 3.5 10.3 3 12 3h10v6h-1.5c.3.9.5 2 .5 3c0 1.7-.5 3.2-1.2 4.6L12.2 9c1.1.1 2.1.8 2.5 1.7L18.3 9c-1-2.3-3.5-4-6.3-4v3.8Z"/>'
        },
        pumpkin: {
            body: '<path fill="currentColor" d="M6.5 6c.97 0 1.87.5 2.61 1.38c.55-.59 1.2-1.02 1.89-1.23V4a2 2 0 0 1 2-2h2v2h-2v2.15c.69.21 1.34.64 1.89 1.23C15.63 6.5 16.53 6 17.5 6C20 6 22 9.36 22 13.5c0 4.14-2 7.5-4.5 7.5c-.97 0-1.87-.5-2.61-1.38C14.08 20.5 13.08 21 12 21s-2.08-.5-2.89-1.38C8.37 20.5 7.47 21 6.5 21C4 21 2 17.64 2 13.5C2 9.36 4 6 6.5 6Z"/>'
        },
        purse: {
            body: '<path fill="currentColor" d="m22 19.1l-1-8.6A1.65 1.65 0 0 0 19.3 9H16V5l-2-2h-4L8 5v4H4.7A1.65 1.65 0 0 0 3 10.5l-1 8.6A1.74 1.74 0 0 0 3.7 21h16.6a1.74 1.74 0 0 0 1.7-1.9M10 5h4v4h-4"/>'
        },
        "purse-outline": {
            body: '<path fill="currentColor" d="m19 11l1 8H4l1-8h14m-5-8h-4L8 5v4H4.7A1.65 1.65 0 0 0 3 10.5l-1 8.6A1.74 1.74 0 0 0 3.7 21h16.6a1.74 1.74 0 0 0 1.7-1.9l-1-8.6A1.65 1.65 0 0 0 19.3 9H16V5l-2-2m-4 6V5h4v4"/>'
        },
        puzzle: {
            body: '<path fill="currentColor" d="M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5A2.5 2.5 0 0 0 10.5 1A2.5 2.5 0 0 0 8 3.5V5H4a2 2 0 0 0-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7c0 1.5-1.2 2.7-2.7 2.7H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c1.5 0 2.7 1.2 2.7 2.7V22H17a2 2 0 0 0 2-2v-4h1.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "puzzle-check": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5m-3-6a2.5 2.5 0 0 1 2.5 2.5c0 .31-.06.61-.16.89C21.8 13.5 20.46 13 19 13c-3.31 0-6 2.69-6 6v.54c-.36-1.04-1.35-1.74-2.5-1.74c-1.5 0-2.7 1.2-2.7 2.7V22H4c-1.1 0-2-.9-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7a2 2 0 0 1 2-2h4V3.5C8 2.12 9.12.998 10.5.998S13 2.12 13 3.5V5h4a2 2 0 0 1 2 2v4h1.5"/>'
        },
        "puzzle-check-outline": {
            body: '<path fill="currentColor" d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5l1.5 1.5M22 13.5v.3c-.63-.36-1.33-.61-2.06-.73c-.19-.62-.76-1.07-1.44-1.07H17V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.97 0 1.87.3 2.62.8L13 19c0 1.09.29 2.12.8 3h-.6v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4c-1.1 0-2-.9-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5c0-1.5-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17c1.1 0 2 .9 2 2v3.04c1.7.24 3 1.7 3 3.46Z"/>'
        },
        "puzzle-edit": {
            body: '<path fill="currentColor" d="M21.04 12.13c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 0 0-.38-.17m-1.97 1.75L13 19.94V22h2.06l6.06-6.07l-2.05-2.05M19 11.12l-7.09 7.08c-.41-.25-.91-.4-1.41-.4c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4.12Z"/>'
        },
        "puzzle-edit-outline": {
            body: '<path fill="currentColor" d="M21.04 12.13c-.14 0-.28.06-.39.17l-1 1l2.05 2.05l1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 0 0-.38-.17m-1.97 1.75L13 19.94V22h2.06l6.06-6.07l-2.05-2.05m-8.02 5.18c-.18-.06-.36-.06-.55-.06c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c.36.05.69.17 1 .32c-.27.14-.54.3-.76.53L18.12 12H17V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.76 0 1.5.18 2.11.5l-1.56 1.56Z"/>'
        },
        "puzzle-heart": {
            body: '<path fill="currentColor" d="m19 22.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5M20.5 11H19V7a2 2 0 0 0-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-2 .9-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7S5 16.2 3.5 16.2H2V20a2 2 0 0 0 2 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7c.94 0 1.77.47 2.25 1.2h.34c-.05-.33-.09-.66-.09-1c0-3.31 2.69-6 6-6c1.54 0 2.94.58 4 1.53v-.03a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "puzzle-heart-outline": {
            body: '<path fill="currentColor" d="M13.2 22v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.45.21 2.61 1.3 2.91 2.72A5.95 5.95 0 0 0 19 12h-2V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.93 0 1.79.28 2.5.74V18c0 1.54.58 2.94 1.54 4H13.2m5.8.3l.6-.5c2-1.9 3.4-3.1 3.4-4.6c0-1.3-1-2.2-2.2-2.2c-.7 0-1.4.3-1.8.8c-.4-.5-1.1-.8-1.8-.8c-1.2 0-2.2 1-2.2 2.2c0 1.5 1.4 2.7 3.4 4.6l.6.5"/>'
        },
        "puzzle-minus": {
            body: '<path fill="currentColor" d="M13.04 19.61a2.682 2.682 0 0 0-2.54-1.81c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5c0 .32-.06.62-.17.89A5.991 5.991 0 0 0 19 13c-3.31 0-6 2.69-6 6c0 .2 0 .41.04.61M15 18v2h8v-2h-8Z"/>'
        },
        "puzzle-minus-outline": {
            body: '<path fill="currentColor" d="M13.2 22v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.7.24 3 1.7 3 3.46c0 .1 0 .2-.03.29c-.62-.35-1.3-.59-2.04-.71c-.18-.62-.75-1.08-1.43-1.08H17V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.97 0 1.87.3 2.62.81a5.956 5.956 0 0 0 .69 4.19h-.61m1.8-4v2h8v-2h-8Z"/>'
        },
        "puzzle-outline": {
            body: '<path fill="currentColor" d="M22 13.5c0 1.76-1.3 3.22-3 3.46V20a2 2 0 0 1-2 2h-3.8v-.3a2.7 2.7 0 0 0-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5c0-1.5-1.21-2.7-2.7-2.7H2V7a2 2 0 0 1 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.7.24 3 1.7 3 3.46M17 15h1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5H17V7h-5V5.5A1.5 1.5 0 0 0 10.5 4A1.5 1.5 0 0 0 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c2 0 3.7 1.25 4.38 3H17v-5Z"/>'
        },
        "puzzle-plus": {
            body: '<path fill="currentColor" d="M13.04 19.61a2.682 2.682 0 0 0-2.54-1.81c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5c0 .32-.06.62-.17.89A5.991 5.991 0 0 0 19 13c-3.31 0-6 2.69-6 6c0 .2 0 .41.04.61M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "puzzle-plus-outline": {
            body: '<path fill="currentColor" d="M13.2 22v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.7.24 3 1.7 3 3.46c0 .1 0 .2-.03.29c-.62-.35-1.3-.59-2.04-.71c-.18-.62-.75-1.08-1.43-1.08H17V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.97 0 1.87.3 2.62.81a5.956 5.956 0 0 0 .69 4.19h-.61m4.8-7v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "puzzle-remove": {
            body: '<path fill="currentColor" d="M13.04 19.61a2.682 2.682 0 0 0-2.54-1.81c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5c0 .32-.06.62-.17.89A5.991 5.991 0 0 0 19 13c-3.31 0-6 2.69-6 6c0 .2 0 .41.04.61m8.08-4.15L19 17.59l-2.12-2.13l-1.41 1.42L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "puzzle-remove-outline": {
            body: '<path fill="currentColor" d="M13.2 22v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.7.24 3 1.7 3 3.46c0 .1 0 .2-.03.29c-.62-.35-1.3-.59-2.04-.71c-.18-.62-.75-1.08-1.43-1.08H17V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.97 0 1.87.3 2.62.81a5.956 5.956 0 0 0 .69 4.19h-.61m7.92-6.54L19 17.59l-2.12-2.13l-1.41 1.42L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "puzzle-star": {
            body: '<path fill="currentColor" d="m19 20.09l2.45 1.49l-.65-2.81l2.2-1.88l-2.89-.25L19 14l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49m4-6.59v.03A5.97 5.97 0 0 0 19 12c-3.31 0-6 2.69-6 6c0 .34.04.67.09 1h-.34a2.68 2.68 0 0 0-2.25-1.2c-1.5 0-2.7 1.2-2.7 2.7V22H4a2 2 0 0 1-2-2v-3.8h1.5c1.5 0 2.7-1.2 2.7-2.7S5 10.8 3.5 10.8H2V7c0-1.1.9-2 2-2h4V3.5a2.5 2.5 0 0 1 5 0V5h4a2 2 0 0 1 2 2v4h1.5a2.5 2.5 0 0 1 2.5 2.5Z"/>'
        },
        "puzzle-star-outline": {
            body: '<path fill="currentColor" d="M13.2 22v-.3c0-1.49-1.2-2.7-2.7-2.7c-1.5 0-2.7 1.21-2.7 2.7v.3H4a2 2 0 0 1-2-2v-3.8h.3C3.79 16.2 5 15 5 13.5s-1.21-2.7-2.7-2.7H2V7c0-1.1.9-2 2-2h3.04c.24-1.7 1.7-3 3.46-3s3.22 1.3 3.46 3H17a2 2 0 0 1 2 2v3.04c1.45.21 2.61 1.3 2.91 2.72A5.95 5.95 0 0 0 19 12h-2V7h-5V5.5c0-.83-.67-1.5-1.5-1.5S9 4.67 9 5.5V7H4v2.12c1.76.68 3 2.38 3 4.38s-1.25 3.7-3 4.38V20h2.12a4.7 4.7 0 0 1 4.38-3c.93 0 1.79.28 2.5.74V18c0 1.54.58 2.94 1.54 4H13.2m5.8-1.91l-2.5 1.49l.68-2.81L15 16.89l2.87-.25L19 14l1.11 2.64l2.89.25l-2.2 1.88l.65 2.81L19 20.09"/>'
        },
        pyramid: {
            body: '<path fill="currentColor" d="m21.85 16.96l-9-14.49a1.003 1.003 0 0 0-1.7 0l-9 14.49c-.31.49-.15 1.22.49 1.47l9 3.5c.11.07.24.07.36.07s.25 0 .36-.07l9-3.5c.64-.25.8-.98.49-1.47M11 6.5v6.82L5.42 15.5l5.58-9m1 13.43L5.76 17.5L12 15.07l6.24 2.43L12 19.93m1-6.61V6.5l5.58 9L13 13.32Z"/>'
        },
        "pyramid-off": {
            body: '<path fill="currentColor" d="M10.5 7.3L9.05 5.85l2.1-3.38a1.003 1.003 0 0 1 1.7 0l9 14.49c.28.44.15 1.04-.35 1.36l-3.09-3.11L13 6.5v3.3l-2-2V6.5l-.5.8m11.61 14.16l-1.27 1.27l-2.95-2.95l-5.53 2.15c-.11.07-.24.07-.36.07s-.25 0-.36-.07l-9-3.5c-.64-.25-.8-.98-.49-1.47L7.1 9L1.11 3l1.28-1.27l19.72 19.73M5.42 15.5L11 13.32v-.43l-2.45-2.45l-3.13 5.06m10.93 2.74l-2.41-2.41l-1.94-.76l-6.24 2.43L12 19.93l4.35-1.69Z"/>'
        },
        qi: {
            body: '<path fill="currentColor" d="M12.09 6.56v8.08c0 .08-.09.15-.15.15c-2.32 0-4.19-1.88-4.19-4.19c0-2.32 1.87-4.2 4.19-4.2c.06 0 .15.07.15.16m0 11.3v2.43A2.666 2.666 0 0 0 14.5 23c.16 0 .28-.11.29-.27V4.47a.415.415 0 0 0-.29-.38c-3.58-1.42-7.64.35-9.06 3.94c-1.44 3.6.35 7.66 3.94 9.08c.78.31 1.62.47 2.43.49c.14-.01.26.11.27.27M16.19 5.5v10.22c0 .28 0 .48.27.28c2.96-2.5 3.35-6.91.87-9.87c-.26-.32-.56-.63-.87-.87c-.27-.21-.27 0-.27.27m-1.4-3.1c0-.77.63-1.4 1.4-1.4c.77 0 1.4.63 1.4 1.4c0 .77-.63 1.4-1.4 1.4c-.77 0-1.4-.63-1.4-1.4"/>'
        },
        qqchat: {
            body: '<path fill="currentColor" d="M3.18 13.54c.58-1.38 1.39-2.4 1.99-2.62c-.01-.8.14-1.3.39-1.7c0-.03-.06-.36.16-.77C5.87 4.85 8.21 2 12 2s6.13 2.85 6.28 6.45c.22.41.16.74.16.77c.25.4.4.9.39 1.7c.6.22 1.41 1.24 1.99 2.63c.75 1.76.87 3.45.27 3.75c-.41.2-1.06-.3-1.67-1.18c-.24.98-.84 1.88-1.69 2.59c.9.33 1.48.87 1.48 1.48c0 1-1.58 1.81-3.52 1.81c-1.76 0-3.19-.66-3.48-1.5h-.42c-.29.84-1.72 1.5-3.48 1.5c-1.94 0-3.52-.81-3.52-1.81c0-.61.58-1.15 1.48-1.48c-.85-.71-1.45-1.61-1.69-2.59c-.61.88-1.26 1.38-1.67 1.18c-.6-.3-.48-1.99.27-3.76Z"/>'
        },
        qrcode: {
            body: '<path fill="currentColor" d="M3 11h2v2H3v-2m8-6h2v4h-2V5m-2 6h4v4h-2v-2H9v-2m6 0h2v2h2v-2h2v2h-2v2h2v4h-2v2h-2v-2h-4v2h-2v-4h4v-2h2v-2h-2v-2m4 8v-4h-2v4h2M15 3h6v6h-6V3m2 2v2h2V5h-2M3 3h6v6H3V3m2 2v2h2V5H5M3 15h6v6H3v-6m2 2v2h2v-2H5Z"/>'
        },
        "qrcode-edit": {
            body: '<path fill="currentColor" d="M5 5h2v2H5V5M1 1h10v10H1V1m2 2v6h6V3H3m2 14h2v2H5v-2m-4-4h10v10H1V13m2 2v6h6v-6H3m10-2h4v2h2v-2h4v2h-4v2h4v6h-4v-2h-4v2h-2v-2h2v-2h-2v-6m8 8v-2h-2v2h2m-2-4h-2v-2h-2v4h4v-2m3.7-13.65l-1 1l-2.05-2l1-1c.2-.21.54-.22.77 0l1.28 1.23c.21.2.22.54 0 .77M13 8.94l6.07-6.06l2.05 2.05L15.06 11H13V8.94Z"/>'
        },
        "qrcode-minus": {
            body: '<path fill="currentColor" d="M5 5h2v2H5V5M1 1h10v10H1V1m2 2v6h6V3H3m2 14h2v2H5v-2m-4-4h10v10H1V13m2 2v6h6v-6H3m10-2h4v2h2v-2h4v2h-4v2h4v6h-4v-2h-4v2h-2v-2h2v-2h-2v-6m8 8v-2h-2v2h2m-2-4h-2v-2h-2v4h4v-2M14 5v2h8V5Z"/>'
        },
        "qrcode-plus": {
            body: '<path fill="currentColor" d="M5 5h2v2H5V5M1 1h10v10H1V1m2 2v6h6V3H3m2 14h2v2H5v-2m-4-4h10v10H1V13m2 2v6h6v-6H3m10-2h4v2h2v-2h4v2h-4v2h4v6h-4v-2h-4v2h-2v-2h2v-2h-2v-6m8 8v-2h-2v2h2m-2-4h-2v-2h-2v4h4v-2M17 2v3h-3v2h3v3h2V7h3V5h-3V2Z"/>'
        },
        "qrcode-remove": {
            body: '<path fill="currentColor" d="M5 5h2v2H5V5M1 1h10v10H1V1m2 2v6h6V3H3m2 14h2v2H5v-2m-4-4h10v10H1V13m2 2v6h6v-6H3m10-2h4v2h2v-2h4v2h-4v2h4v6h-4v-2h-4v2h-2v-2h2v-2h-2v-6m8 8v-2h-2v2h2m-2-4h-2v-2h-2v4h4v-2M15.17 1.76l-1.41 1.41L16.59 6l-2.83 2.83l1.41 1.41L18 7.41l2.83 2.83l1.41-1.41L19.41 6l2.83-2.83l-1.41-1.41L18 4.59l-2.83-2.83Z"/>'
        },
        "qrcode-scan": {
            body: '<path fill="currentColor" d="M4 4h6v6H4V4m16 0v6h-6V4h6m-6 11h2v-2h-2v-2h2v2h2v-2h2v2h-2v2h2v3h-2v2h-2v-2h-3v2h-2v-4h3v-1m2 0v3h2v-3h-2M4 20v-6h6v6H4M6 6v2h2V6H6m10 0v2h2V6h-2M6 16v2h2v-2H6m-2-5h2v2H4v-2m5 0h4v4h-2v-2H9v-2m2-5h2v4h-2V6M2 2v4H0V2a2 2 0 0 1 2-2h4v2H2m20-2a2 2 0 0 1 2 2v4h-2V2h-4V0h4M2 18v4h4v2H2a2 2 0 0 1-2-2v-4h2m20 4v-4h2v4a2 2 0 0 1-2 2h-4v-2h4Z"/>'
        },
        quadcopter: {
            body: '<path fill="currentColor" d="M5.5 1C8 1 10 3 10 5.5c0 .88-.25 1.7-.69 2.4l.1.1h5.18l.1-.1c-.44-.7-.69-1.52-.69-2.4C14 3 16 1 18.5 1S23 3 23 5.5S21 10 18.5 10c-.88 0-1.7-.25-2.4-.69l-1.1 1.1v3.18l1.1 1.1c.7-.44 1.52-.69 2.4-.69c2.5 0 4.5 2 4.5 4.5S21 23 18.5 23S14 21 14 18.5c0-.88.25-1.7.69-2.4l-.1-.1H9.41l-.1.1c.44.7.69 1.52.69 2.4C10 21 8 23 5.5 23S1 21 1 18.5S3 14 5.5 14c.88 0 1.7.25 2.4.69l1.1-1.1v-3.18l-1.1-1.1c-.7.44-1.52.69-2.4.69C3 10 1 8 1 5.5S3 1 5.5 1m0 2A2.5 2.5 0 0 0 3 5.5A2.5 2.5 0 0 0 5.5 8A2.5 2.5 0 0 0 8 5.5A2.5 2.5 0 0 0 5.5 3m0 13A2.5 2.5 0 0 0 3 18.5A2.5 2.5 0 0 0 5.5 21A2.5 2.5 0 0 0 8 18.5A2.5 2.5 0 0 0 5.5 16m13-13A2.5 2.5 0 0 0 16 5.5A2.5 2.5 0 0 0 18.5 8A2.5 2.5 0 0 0 21 5.5A2.5 2.5 0 0 0 18.5 3m0 13a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M3.91 17.25l1.13.66c.13-.1.29-.16.46-.16a.75.75 0 0 1 .75.75l-.01.1l1.13.65l-.28.5l-1.13-.66c-.13.1-.29.16-.46.16a.75.75 0 0 1-.75-.75l.01-.1l-1.13-.65l.28-.5m-.28-11l1.13-.65l-.01-.1a.75.75 0 0 1 .75-.75c.17 0 .33.06.46.16l1.13-.66l.28.5l-1.13.65l.01.1a.75.75 0 0 1-.75.75c-.17 0-.33-.06-.46-.16l-1.13.66l-.28-.5m13.28-2l1.13.66c.13-.1.29-.16.46-.16a.75.75 0 0 1 .75.75l-.01.1l1.13.65l-.28.5l-1.13-.66c-.13.1-.29.16-.46.16a.75.75 0 0 1-.75-.75l.01-.1l-1.13-.65l.28-.5m-.28 15l1.12-.75a.75.75 0 0 1 .75-.75c.17 0 .33.06.46.16l1.13-.66l.28.5l-1.12.75a.75.75 0 0 1-.75.75c-.17 0-.33-.06-.46-.16l-1.13.66l-.28-.5Z"/>'
        },
        "quality-high": {
            body: '<path fill="currentColor" d="M14.5 13.5h2v-3h-2M18 14a1 1 0 0 1-1 1h-.75v1.5h-1.5V15H14a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1m-7 5H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11m8-5H5c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "quality-low": {
            body: '<path fill="currentColor" d="M14.5 13.5h2v-3h-2M18 14c0 .6-.4 1-1 1h-.75v1.5h-1.5V15H14c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h3c.6 0 1 .4 1 1m1-6H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-8 9.5V15H6V9h1.5v4.5H11Z"/>'
        },
        "quality-medium": {
            body: '<path fill="currentColor" d="M21 6v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-9 4c0-.5-.5-1-1-1H6.5c-.5 0-1 .5-1 1v5H7v-4.5h1V14h1.5v-3.5h1V15H12v-5m2.5-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v1.5h1.25V15h.75a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3m.5 1.5h2v3h-2v-3Z"/>'
        },
        "quick-reply": {
            body: '<path d="M13 18l-7-7l7-7v4c8 0 11 11 11 11s-3-5-11-5v4zm-6 0l-7-7l7-7v3l-4 4l4 4v3z" fill="currentColor"/>',
            hidden: true
        },
        quicktime: {
            body: '<path d="M12 3a9 9 0 0 1 9 9c0 1.76-.5 3.4-1.38 4.79L21 18.17V20a1 1 0 0 1-1 1h-1.82l-1.39-1.38A8.887 8.887 0 0 1 12 21a9 9 0 0 1-9-9a9 9 0 0 1 9-9m0 4a5 5 0 0 0-5 5a5 5 0 0 0 5 5c.65 0 1.26-.12 1.83-.35l-2.88-2.88c-.78-.77-.78-2.05 0-2.83c.78-.78 2.05-.78 2.83 0l2.88 2.88c.22-.56.34-1.18.34-1.82a5 5 0 0 0-5-5z" fill="currentColor"/>',
            hidden: true
        },
        quize: {
            body: '<path d="M5.62167 7.24333H4V18.595C4 19.4869 4.72975 20.2167 5.62167 20.2167H16.9733V18.595H5.62167V7.24333Z" fill="currentColor"/><path d="M18.595 4H8.865C7.97308 4 7.24333 4.72975 7.24333 5.62167V15.3517C7.24333 16.2436 7.97308 16.9733 8.865 16.9733H18.595C19.4869 16.9733 20.2167 16.2436 20.2167 15.3517V5.62167C20.2167 4.72975 19.4869 4 18.595 4ZM13.7381 14.5408C13.2597 14.5408 12.8867 14.1597 12.8867 13.6895C12.8867 13.2111 13.2678 12.8462 13.7381 12.8462C14.2165 12.8462 14.5814 13.2111 14.5814 13.6895C14.5733 14.1597 14.2165 14.5408 13.7381 14.5408ZM15.7652 9.53799C15.2544 10.2921 14.7679 10.5191 14.5003 11.0056C14.3949 11.2002 14.3543 11.3299 14.3543 11.9624H13.1219C13.1219 11.6299 13.0732 11.0867 13.3327 10.6245C13.6651 10.0326 14.2895 9.68394 14.6544 9.16501C15.0436 8.61364 14.8246 7.59199 13.73 7.59199C13.0165 7.59199 12.6597 8.13525 12.5138 8.58932L11.4029 8.12714C11.711 7.2109 12.53 6.4325 13.7219 6.4325C14.7192 6.4325 15.4084 6.88657 15.7571 7.45415C16.0571 7.94876 16.2274 8.85689 15.7652 9.53799Z" fill="currentColor"/>'
        },
        quora: {
            body: '<path fill="currentColor" d="M19.7 18.8c.5-.6.4-1.1.4-1.1h1.5s0 .4-.1.9c-.1.4-.2.7-.3 1c-.2.7-1.2 1.5-1.2 1.5c-1.1.9-2.3.8-2.3.8s-1.4.2-2.5-.5s-2-2.2-2-2.2s-4.4 1.2-7.8-1.7c-3.4-2.9-3.2-6.4-3.2-6.7c0-.7.4-8.5 8.6-8.8c4.8-.2 7.4 2.8 8.4 5.2c.7 1.7.7 3 .7 3.2c0 .2 0 1.1-.2 2c-.1.9-.5 1.9-.8 2.4c-.3.5-.7 1.2-1.2 1.7c-.5.6-1.1 1.1-1.2 1.2c0 0 1 1.2 1.6 1.4c.2 0 1.1.3 1.6-.3m-7-1.5c.1-.1-.3-.6-.5-.9c-.2-.3.1.1-.7-1c-.3-.5-.7-.7-1.3-.8h-.7c-.5 0-.8.1-.9.1c0-.1-.2-.3-.3-.5c-.1-.2-.1-.5-.1-.5c0-.2 1.5-.9 3.2-.9c1.4 0 2.4.8 2.8 1.2c.4.3.5.7.9 1c0 0 .1 0 .1.1c.4.3.9-3 .8-5.2c-.1-2.2-.2-3.3-1-4.4c-.7-1-2.2-1.8-3.6-1.8c-.7 0-3 .1-4 1.8c-1.2 2-1 5.6-1 5.6s-.3 3.2 1.4 4.9c1.7 1.7 3.4 1.4 4.2 1.4l.7-.1Z"/>'
        },
        rabbit: {
            body: '<path fill="currentColor" d="m18.05 21l-2.73-4.74c0-1.73-1.07-2.84-2.37-2.84c-.9 0-1.68.5-2.08 1.24c.33-.19.72-.29 1.13-.29c1.3 0 2.36 1.06 2.36 2.36c0 1.31-1.05 2.38-2.36 2.38h3.3V21H6.79c-.24 0-.49-.09-.67-.28a.948.948 0 0 1 0-1.34l.5-.5c-.34-.15-.62-.38-.9-.62c-.22.5-.72.85-1.3.85a1.425 1.425 0 0 1 0-2.85l.47.08v-1.97a4.73 4.73 0 0 1 4.74-4.74h.02c2.12.01 3.77.84 3.77-.47c0-.93.2-1.3.54-1.82c-.73-.34-1.56-.55-2.43-.55c-.53 0-.95-.42-.95-.95c0-.43.28-.79.67-.91l-.67-.04c-.52 0-.95-.42-.95-.94c0-.53.43-.95.95-.95h.95c2.1 0 3.94 1.15 4.93 2.85l.28-.01c.71 0 1.37.23 1.91.61l.45.38c2.17 1.95 1.9 3.27 1.9 3.28c0 1.28-1.06 2.33-2.35 2.33l-.49-.05v.08c0 1.11-.48 2.1-1.23 2.8L20.24 21h-2.19m.11-13.26c-.53 0-.95.42-.95.94c0 .53.42.95.95.95c.52 0 .95-.42.95-.95c0-.52-.43-.94-.95-.94Z"/>'
        },
        "rabbit-variant": {
            body: '<path fill="currentColor" d="M16.84 14.5c-.26-.17-.62-.61-.79-.82C17.24 12 19 8.87 19 5c0-1.95-.74-3-2-3c-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2C5.74 2 5 3.05 5 5c0 3.87 1.76 7 2.95 8.68c-.17.21-.53.65-.79.82c-.5.43-1.66 1.39-1.66 3c0 2.21 1.79 4 4 4c1.55 0 2.5-.56 2.5-.56s.95.56 2.5.56c2.21 0 4-1.79 4-4c0-1.61-1.16-2.57-1.66-3m-7.49-2.3C8.34 10.7 7 8.12 7 5c0-.5.06-.8.12-.97c.94.31 3.24 2.71 3.38 7.64c-.47.12-.84.3-1.15.53m1.15 4.55c-.28 0-.5-.34-.5-.75s.22-.75.5-.75s.5.34.5.75s-.22.75-.5.75M12 19.5c-.55 0-1-.72-1-1s.45-.5 1-.5s1 .22 1 .5s-.45 1-1 1m1.5-2.75c-.28 0-.5-.34-.5-.75s.22-.75.5-.75s.5.34.5.75s-.22.75-.5.75m0-5.08c.14-4.93 2.44-7.33 3.38-7.64c.06.17.12.47.12.97c0 3.12-1.34 5.7-2.35 7.2c-.31-.23-.68-.41-1.15-.53Z"/>'
        },
        "rabbit-variant-outline": {
            body: '<path fill="currentColor" d="M17 14c-.24-.24-.44-.5-.65-.75C17.5 11.5 19 8.56 19 5c0-1.95-.74-3-2-3c-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2C5.74 2 5 3.05 5 5c0 3.56 1.5 6.5 2.65 8.25c-.21.25-.41.51-.65.75c-.25.25-2 1.39-2 3.5C5 20 7 22 9.5 22c1.5 0 2.5-.5 2.5-.5s1 .5 2.5.5c2.5 0 4.5-2 4.5-4.5c0-2.11-1.75-3.25-2-3.5m-.12-9.97c.06.17.12.47.12.97c0 2.84-1.11 5.24-2.07 6.78c-.38-.28-.83-.48-1.4-.62c.24-4.52 2.44-6.83 3.35-7.13M7 5c0-.5.06-.8.12-.97c.91.3 3.11 2.61 3.38 7.13c-.6.14-1.05.34-1.42.62C8.11 10.24 7 7.84 7 5m7.5 15c-1 0-1.8-.33-2.22-.56c.42-.18.72-.71.72-.94c0-.28-.45-.5-1-.5s-1 .22-1 .5c0 .23.3.76.72.94c-.42.23-1.22.56-2.22.56A2.5 2.5 0 0 1 7 17.5c0-.7.43-1.24 1-1.73c.44-.36.61-.52 1.3-1.37c.76-.95 1.09-1.4 2.7-1.4s1.94.45 2.7 1.4c.69.85.86 1.01 1.3 1.37c.57.49 1 1.03 1 1.73a2.5 2.5 0 0 1-2.5 2.5m-.5-4c0 .41-.22.75-.5.75s-.5-.34-.5-.75s.22-.75.5-.75s.5.34.5.75m-3 0c0 .41-.22.75-.5.75s-.5-.34-.5-.75s.22-.75.5-.75s.5.34.5.75Z"/>'
        },
        "racing-helmet": {
            body: '<path fill="currentColor" d="M2.2 11.2c-.2 2.4.5 4.4 2 6.2c1.5 1.8 3.5 2.6 5.9 2.6h10c.5 0 1-.2 1.4-.6c.4-.4.6-.9.6-1.4v-.8c0-.6-.1-1.3-.2-2.2h-8.2c-1 0-1.8-.4-2.5-1.1c-.7-.7-1.1-1.6-1.1-2.5c0-1.6.7-2.7 2.2-3.3L17.1 6c-1.7-1.2-3.7-1.9-6-2c-2.2-.2-4.2.5-6 1.9C3.3 7.3 2.4 9 2.2 11.2m9.9.2c0 .4.2.8.5 1.1c.3.3.7.5 1.1.5h7.8c-.6-2.2-1.5-4-2.8-5.4l-5.6 2.3c-.7.2-1 .7-1 1.5Z"/>'
        },
        racquetball: {
            body: '<path fill="currentColor" d="M18.5 16c1.4 0 2.5 1.1 2.5 2.5S19.9 21 18.5 21S16 19.9 16 18.5s1.1-2.5 2.5-2.5m-8-15C3 1 3 3.7 3 9.8c0 3.4 3.4 7.1 6 8.3V23h3v-4.9c2.6-1.2 6-4.9 6-8.3C18 3.6 18 1 10.5 1m4.9 3.2c.3.4.4 1 .5 1.8H15V3.8c.2.1.3.3.4.4m.6 5.6v.2h-1V7h1v2.8M14 14h-3v-3h3v3m-7 0v-3h3v3H7M5 9.8V7h1v3H5v-.2M7 7h3v3H7V7m4-4c1.4 0 2.4.2 3 .3V6h-3V3m-1 3H7V3.4c.6-.2 1.6-.4 3-.4v3m1 4V7h3v3h-3M6 3.8V6h-.9c.1-.8.2-1.4.5-1.8l.4-.4M5.2 11H6v1.7c-.3-.6-.6-1.1-.8-1.7M8 15h2v1.3l-.2-.1C9.2 16 8.6 15.5 8 15m3.2 1.3H11V15h2c-.6.5-1.2 1-1.8 1.3m3.8-3.6V11h.8c-.2.5-.5 1.1-.8 1.7Z"/>'
        },
        radar: {
            body: '<path fill="currentColor" d="m19.07 4.93l-1.41 1.41A8.014 8.014 0 0 1 20 12a8 8 0 0 1-8 8a8 8 0 0 1-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12a6 6 0 0 0 6 6a6 6 0 0 0 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12a4 4 0 0 1-4 4a4 4 0 0 1-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.74-.4-1.38-1-1.72V2h-1A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-2.76-1.12-5.26-2.93-7.07Z"/>'
        },
        radiator: {
            body: '<path fill="currentColor" d="M7.95 3L6.53 5.19L7.95 7.4h-.01l-1.99 3.1l-1.73-.9l1.42-2.21l-1.42-2.2l2-3.1L7.95 3m6-.11L12.53 5.1l1.42 2.2l-.01.01l-1.99 3.09l-1.73-.9l1.42-2.2l-1.42-2.2l2-3.1l1.73.89m6.05 0L18.56 5.1L20 7.3v.01l-2 3.09l-1.75-.9l1.42-2.2l-1.42-2.2l2-3.1l1.75.89M2 22v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8h-2v-2H4v2H2m4-8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"/>'
        },
        "radiator-disabled": {
            body: '<path fill="currentColor" d="M20 12H4a2 2 0 0 0-2 2v8h2v-2h16v2h2v-8a2 2 0 0 0-2-2M7 17a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2m4 0a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2m4 0a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2m4 0a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2Z"/>'
        },
        "radiator-off": {
            body: '<path fill="currentColor" d="M3.28 2L2 3.27l2.77 2.77l.87 1.35L4.22 9.6l1.73.9l1.28-2l3.5 3.5H4a2 2 0 0 0-2 2v8h2v-2h14.73L20 21.27V22h2v-1.28L3.28 2M7 17a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2m4 0a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1a1 1 0 0 1 1 1v2m4 0a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-2c0-.21.08-.39.18-.55L15 16.27V17m1.25-7.5l1.42-2.2l-1.42-2.2l2-3.1l1.75.89l-1.44 2.21L20 7.3v.01l-2 3.09l-1.75-.9M22 14v4.18l-3-3V15a1 1 0 0 0-1-1c-.05 0-.1 0-.15.03L15.82 12H20a2 2 0 0 1 2 2M11.64 7.3l-1.42-2.2l2-3.1l1.73.89l-1.42 2.21l1.42 2.2l-.01.01L12.84 9l-1.4-1.38l.2-.32M7.5 3.69L6.1 2.28l.12-.19L7.95 3l-.45.69Z"/>'
        },
        radio: {
            body: '<path fill="currentColor" d="M20 6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-.85.53-1.58 1.28-1.87L15.71 1l.76 1.83L8.83 6H20m0 2H4v4h12v-2h2v2h2V8M7 14a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "radio-am": {
            body: '<path fill="currentColor" d="M5 7a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2H5m0 2h2v2H5V9m8-2a2 2 0 0 0-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2h-6Z"/>'
        },
        "radio-fm": {
            body: '<path fill="currentColor" d="M3 7v10h2v-4h3v-2H5V9h4V7H3m10 0a2 2 0 0 0-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2h-6Z"/>'
        },
        "radio-handheld": {
            body: '<path fill="currentColor" d="M9 2a1 1 0 0 0-1 1v17c0 1.11.89 2 2 2h5c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-5V3a1 1 0 0 0-1-1m1 7h5v4h-5V9Z"/>'
        },
        "radio-off": {
            body: '<path fill="currentColor" d="m1 4.27l2 2c-.6.34-1 .99-1 1.73v12a2 2 0 0 0 2 2h14.73l2 2L22 22.72L2.28 3L1 4.27M20 6H8.83l7.64-3.17L15.71 1L6.59 4.76L9.82 8H20v4h-2v-2h-2v2h-2.18L22 20.18V8a2 2 0 0 0-2-2M4 8h.73l4 4H4V8m3 6c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3Z"/>'
        },
        "radio-tower": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8Z"/>'
        },
        radioactive: {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0 12c-1.95 0-3.78-.56-5.31-1.53l3.31-5a4.037 4.037 0 0 0 4 0l3.31 5A9.903 9.903 0 0 1 12 22M2 12c0-4.14 2.5-7.7 6.11-9.22l2.23 5.58A4.008 4.008 0 0 0 8 12H2m14 0c0-1.62-.96-3-2.34-3.64l2.23-5.58A9.985 9.985 0 0 1 22 12h-6Z"/>'
        },
        "radioactive-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 8a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m-8 2c0-3.3 2-6.13 4.86-7.36l1.48 3.72A4.008 4.008 0 0 0 8 12H4m8 8c-1.54 0-3-.44-4.2-1.2l2.2-3.33a4.037 4.037 0 0 0 4 0l2.2 3.33C15 19.56 13.54 20 12 20m4-8c0-1.62-.96-3-2.34-3.64l1.49-3.72C18 5.87 20 8.7 20 12h-4Z"/>'
        },
        "radioactive-circle-outline": {
            body: '<path fill="currentColor" d="M12 2c2.65 0 5.2 1.05 7.07 2.93A9.974 9.974 0 0 1 22 12c0 2.65-1.05 5.2-2.93 7.07A9.974 9.974 0 0 1 12 22c-2.65 0-5.2-1.05-7.07-2.93A9.974 9.974 0 0 1 2 12C2 6.5 6.5 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8c0-2.12-.84-4.16-2.34-5.66A8.008 8.008 0 0 0 12 4m1.5 10l2.05 2.84c-1 .73-2.22 1.16-3.55 1.16c-1.33 0-2.55-.43-3.55-1.16L10.5 14c.44.32.95.5 1.5.5s1.06-.18 1.5-.5M12 11c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M9.32 6.63l1.56 3.13C10.06 10.17 9.5 11 9.5 12H6c0-2.35 1.35-4.38 3.32-5.37m5.36 0C16.65 7.62 18 9.65 18 12h-3.5c0-1-.56-1.83-1.38-2.24l1.56-3.13Z"/>'
        },
        "radioactive-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L21 21.72L19.73 23l-2.48-2.5c-1.53.96-3.33 1.5-5.25 1.5c-1.95 0-3.78-.56-5.31-1.53l3.31-5c.6.34 1.28.53 2 .53c.23 0 .46 0 .67-.06l-4.61-4.61C8 11.54 8 11.77 8 12H2c0-1.92.54-3.72 1.5-5.25L1 4.27M12 10a2 2 0 0 1 2 2v.17L11.83 10H12M8.11 2.78l2.12 5.63L5.9 4.08c.67-.52 1.42-.96 2.21-1.3M16 12c0-1.62-.96-3-2.34-3.64l2.23-5.58A9.985 9.985 0 0 1 22 12h-6Z"/>'
        },
        "radiobox-blank": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "radiobox-marked": {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        "radiology-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m-1.9 10H13v1h4s-.06 3-1.5 3c-1.35 0-1-1.53-2.5-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c-1.5.47-1.15 2-2.5 2C7.06 17 7 14 7 14h4v-1H6.9c-.05-.31-.06-.65-.1-1H11v-1H6.81c.02-.33.1-.67.19-1h4V9H7.34c.16-.35.31-.69.49-1H11V7c0-.55.45-1 1-1s1 .45 1 1v1h3.17c.18.31.33.65.49 1H13v1h4c.1.33.17.67.19 1H13v1h4.2c-.04.35-.05.69-.1 1Z"/>'
        },
        "radiology-box-outline": {
            body: '<path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m-7 3c.55 0 1 .45 1 1v1h3.17c.18.31.33.65.49 1H13v1h4c.1.33.17.67.19 1H13v1h4.2c-.04.35-.05.69-.1 1H13v1h4s-.06 3-1.5 3c-1.35 0-1-1.53-2.5-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c-1.5.47-1.15 2-2.5 2C7.06 17 7 14 7 14h4v-1H6.9c-.05-.31-.06-.65-.1-1H11v-1H6.81c.02-.33.1-.67.19-1h4V9H7.34c.16-.35.31-.69.49-1H11V7c0-.55.45-1 1-1Z"/>'
        },
        radius: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m5 13v-2h-3.28c-.36.62-1.01 1-1.72 1a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.71 0 1.36.38 1.72 1H17V9l3 3l-3 3Z"/>'
        },
        "radius-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m4-5v-2h-2.28c-.36.62-1.01 1-1.72 1a2 2 0 0 1-2-2a2 2 0 0 1 2-2c.71 0 1.36.38 1.72 1H16V9l3 3l-3 3Z"/>'
        },
        "railroad-light": {
            body: '<path fill="currentColor" d="M17.67 10.5c-1.27 0-2.4.8-2.82 2h-1.68V7.77l3.49 2.09l1-1.72L14.11 6l3.57-2.14l-1-1.72l-3.51 2.09V2h-2v2.23L7.68 2.14l-1 1.72L10.23 6L6.66 8.14l1 1.72l3.51-2.09v4.73H9.5c-1.14-3.18-5.84-2.37-5.84 1s4.7 4.18 5.84 1h1.67V20a2 2 0 0 0-2 2h6a2 2 0 0 0-2-2v-5.5h1.68c.81 2.3 3.88 2.72 5.28.73c1.4-1.99-.03-4.73-2.46-4.73m-11 4c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71a1 1 0 0 1-1 1m11 0c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71a1 1 0 0 1-1 1Z"/>'
        },
        rake: {
            body: '<path fill="currentColor" d="M10.5 17.05L9.43 16L22.07 3.35l-1.41-1.42L8 14.58L6.95 13.5c-.78-.77-2.05-.77-2.83 0L2 15.64l.71.7l2.12-2.12l.71.71l-2.13 2.12l.71.71l2.12-2.12l.71.7l-2.12 2.12l.71.71l2.12-2.12l.7.71l-2.12 2.12l.71.71l2.12-2.13l.71.71l-2.12 2.12l.7.71l2.14-2.12c.77-.78.77-2.05 0-2.83Z"/>'
        },
        "raspberry-pi": {
            body: '<path fill="currentColor" d="M20 8h2v2h-2V8M4 5h16a2 2 0 0 1 2 2h-3v2H5v4h3v3h11v1h3a2 2 0 0 1-2 2h-4v1h-2v-1h-3v1H7v-1H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m15 10H9v-5h10v1h3v2h-3v2m-6-3v2h2v-2h-2M5 6v2h1V6H5m2 0v2h1V6H7m2 0v2h1V6H9m2 0v2h1V6h-1m2 0v2h1V6h-1m2 0v2h1V6h-1m5 8h2v2h-2v-2Z"/>'
        },
        raw: {
            body: '<path fill="currentColor" d="M6.5 9c.8 0 1.5.7 1.5 1.5v1c0 .6-.4 1.1-.9 1.4L8 15H6.5l-.9-2H4.5v2H3V9h3.5m0 2.5v-1h-2v1h2M10.25 9h2.5l1.5 6h-1.5l-.37-1.5h-1.75l-.38 1.5h-1.5l1.5-6m.75 3h1l-.25-1h-.5L11 12m9-3h1.5L20 15h-1.5l-.76-3.04L17 15h-1.5L14 9h1.5l.74 3L17 9h1.5l.74 3L20 9Z"/>'
        },
        "raw-off": {
            body: '<path fill="currentColor" d="m17.15 14.32l-2.43-2.42L14 9h1.5l.74 3L17 9h1.5l.74 3L20 9h1.5L20 15h-1.5l-.76-3.04l-.59 2.36M1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41l-9.11-9.11h-.04l-.38 1.5h-1.5l.68-2.74L8 10.83v.67c0 .6-.4 1.1-.9 1.4L8 15H6.5l-.9-2H4.5v2H3V9h3.17L1.39 4.22M6.5 11.5v-1h-2v1h2Z"/>'
        },
        "ray-end": {
            body: '<path fill="currentColor" d="M20 9c-1.31 0-2.42.83-2.83 2H2v2h15.17c.41 1.17 1.52 2 2.83 2a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "ray-end-arrow": {
            body: '<path fill="currentColor" d="m1 12l4 4v-3h12.17c.41 1.17 1.52 2 2.83 2a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-1.31 0-2.42.83-2.83 2H5V8l-4 4Z"/>'
        },
        "ray-start": {
            body: '<path fill="currentColor" d="M4 9c1.31 0 2.42.83 2.83 2H22v2H6.83A2.99 2.99 0 0 1 4 15a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "ray-start-arrow": {
            body: '<path fill="currentColor" d="m23 12l-4 4v-3H6.83A2.99 2.99 0 0 1 4 15a3 3 0 0 1-3-3a3 3 0 0 1 3-3c1.31 0 2.42.83 2.83 2H19V8l4 4Z"/>'
        },
        "ray-start-end": {
            body: '<path fill="currentColor" d="M4 9c1.31 0 2.42.83 2.83 2h10.34c.41-1.17 1.52-2 2.83-2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a2.99 2.99 0 0 1-2.83-2H6.83A2.99 2.99 0 0 1 4 15a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "ray-start-vertex-end": {
            body: '<path fill="currentColor" d="M20 9c-1.31 0-2.42.83-2.83 2h-2.35C14.4 9.84 13.3 9 12 9s-2.4.84-2.82 2H6.83A2.99 2.99 0 0 0 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.31 0 2.42-.83 2.83-2h2.35c.42 1.16 1.52 2 2.82 2s2.4-.84 2.82-2h2.35c.41 1.17 1.52 2 2.83 2c1.66 0 3-1.34 3-3s-1.34-3-3-3"/>'
        },
        "ray-vertex": {
            body: '<path fill="currentColor" d="M2 11h7.17c.41-1.17 1.52-2 2.83-2s2.42.83 2.83 2H22v2h-7.17A2.99 2.99 0 0 1 12 15a2.99 2.99 0 0 1-2.83-2H2v-2Z"/>'
        },
        "razor-double-edge": {
            body: '<path fill="currentColor" d="M20 8c-.55 0-1-.45-1-1s.45-1 1-1V5H4v1c.55 0 1 .45 1 1s-.45 1-1 1H2v7h2c.55 0 1 .45 1 1s-.45 1-1 1v1h16v-1c-.55 0-1-.45-1-1s.45-1 1-1h2V8h-2m0 4h-1v1h-2v-1h-3.59c-.21.58-.76 1-1.41 1s-1.2-.42-1.41-1H7v1H5v-1H4v-1h1v-1h2v1h3.59c.21-.58.76-1 1.41-1s1.2.42 1.41 1H17v-1h2v1h1v1Z"/>'
        },
        "razor-single-edge": {
            body: '<path fill="currentColor" d="M22 5v3H2V5h20m0 8v5H2v-5h1.5c.83 0 1.5-.67 1.5-1.5S4.33 10 3.5 10H2V9h20v1h-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H22m-9-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2Z"/>'
        },
        rdio: {
            body: '<path d="M19.292 10.844c.055.379.084.764.084 1.156c0 4.611-3.894 8.35-8.699 8.35c-4.803 0-8.697-3.739-8.697-8.35s3.894-8.35 8.697-8.35c.943 0 1.85.145 2.7.412l.001 5.046s-2.592-1.419-4.91.247c-2.317 1.663-1.88 3.409-1.88 3.409s.108 2.756 3.378 2.756c3.657 0 4.692-3.329 4.692-3.329V4.58c.706.347 1.361.783 1.991 1.275c1.555.962 3.17 1.581 5.017 1.535c0 0 .354-.076.354.627c0 .381-.136.818-.518 1.23c0 0-.727 1.084-2.21 1.598z" fill="currentColor"/>',
            hidden: true
        },
        react: {
            body: '<path fill="currentColor" d="M12 10.11c1.03 0 1.87.84 1.87 1.89c0 1-.84 1.85-1.87 1.85c-1.03 0-1.87-.85-1.87-1.85c0-1.05.84-1.89 1.87-1.89M7.37 20c.63.38 2.01-.2 3.6-1.7c-.52-.59-1.03-1.23-1.51-1.9a22.7 22.7 0 0 1-2.4-.36c-.51 2.14-.32 3.61.31 3.96m.71-5.74l-.29-.51c-.11.29-.22.58-.29.86c.27.06.57.11.88.16l-.3-.51m6.54-.76l.81-1.5l-.81-1.5c-.3-.53-.62-1-.91-1.47C13.17 9 12.6 9 12 9c-.6 0-1.17 0-1.71.03c-.29.47-.61.94-.91 1.47L8.57 12l.81 1.5c.3.53.62 1 .91 1.47c.54.03 1.11.03 1.71.03c.6 0 1.17 0 1.71-.03c.29-.47.61-.94.91-1.47M12 6.78c-.19.22-.39.45-.59.72h1.18c-.2-.27-.4-.5-.59-.72m0 10.44c.19-.22.39-.45.59-.72h-1.18c.2.27.4.5.59.72M16.62 4c-.62-.38-2 .2-3.59 1.7c.52.59 1.03 1.23 1.51 1.9c.82.08 1.63.2 2.4.36c.51-2.14.32-3.61-.32-3.96m-.7 5.74l.29.51c.11-.29.22-.58.29-.86c-.27-.06-.57-.11-.88-.16l.3.51m1.45-7.05c1.47.84 1.63 3.05 1.01 5.63c2.54.75 4.37 1.99 4.37 3.68c0 1.69-1.83 2.93-4.37 3.68c.62 2.58.46 4.79-1.01 5.63c-1.46.84-3.45-.12-5.37-1.95c-1.92 1.83-3.91 2.79-5.38 1.95c-1.46-.84-1.62-3.05-1-5.63c-2.54-.75-4.37-1.99-4.37-3.68c0-1.69 1.83-2.93 4.37-3.68c-.62-2.58-.46-4.79 1-5.63c1.47-.84 3.46.12 5.38 1.95c1.92-1.83 3.91-2.79 5.37-1.95M17.08 12c.34.75.64 1.5.89 2.26c2.1-.63 3.28-1.53 3.28-2.26c0-.73-1.18-1.63-3.28-2.26c-.25.76-.55 1.51-.89 2.26M6.92 12c-.34-.75-.64-1.5-.89-2.26c-2.1.63-3.28 1.53-3.28 2.26c0 .73 1.18 1.63 3.28 2.26c.25-.76.55-1.51.89-2.26m9 2.26l-.3.51c.31-.05.61-.1.88-.16c-.07-.28-.18-.57-.29-.86l-.29.51m-2.89 4.04c1.59 1.5 2.97 2.08 3.59 1.7c.64-.35.83-1.82.32-3.96c-.77.16-1.58.28-2.4.36c-.48.67-.99 1.31-1.51 1.9M8.08 9.74l.3-.51c-.31.05-.61.1-.88.16c.07.28.18.57.29.86l.29-.51m2.89-4.04C9.38 4.2 8 3.62 7.37 4c-.63.35-.82 1.82-.31 3.96a22.7 22.7 0 0 1 2.4-.36c.48-.67.99-1.31 1.51-1.9Z"/>'
        },
        read: {
            body: '<path fill="currentColor" d="M21.59 11.59L23 13l-9.5 9.5l-5.08-5.09L9.83 16l3.67 3.68l8.09-8.09M4 16V3h5a4 4 0 0 1 4 4c0 1.54-.87 2.88-2.15 3.55L14 16h-2l-2.89-5H6v5H4m2-7h3a2 2 0 0 0 2-2a2 2 0 0 0-2-2H6v4Z"/>'
        },
        receipt: {
            body: '<path fill="currentColor" d="m3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2"/>'
        },
        "receipt-outline": {
            body: '<path fill="currentColor" d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5M19 19H5V5h14v14Z"/>'
        },
        "receipt-text": {
            body: '<path fill="currentColor" d="m3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2m15 7H6V7h12m0 6H6v-2h12m0 6H6v-2h12v2Z"/>'
        },
        "receipt-text-check": {
            body: '<path fill="currentColor" d="m18.25 22l-2.75-3l1.16-1.18l1.59 1.59l3.59-3.59L23 17.23M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.26-1.26c-.17-.56-.26-1.15-.26-1.74c0-.68.12-1.36.34-2H6v-2h8.53A6.003 6.003 0 0 1 21 13.34V2l-1.5 1.5M18 13H6v-2h12v2m0-4H6V7h12v2Z"/>'
        },
        "receipt-text-check-outline": {
            body: '<path fill="currentColor" d="M13.26 20.74L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22V2l1.5 1.5L6 2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v11.35c-.63-.22-1.3-.35-2-.35V5H5v14h8c0 .57.1 1.22.26 1.74M6 15v2h7.35c.26-.75.65-1.42 1.19-2H6m0-2h12v-2H6v2m0-4h12V7H6v2m17 8.23l-1.16-1.41l-3.59 3.59l-1.59-1.59L15.5 19l2.75 3"/>'
        },
        "receipt-text-minus": {
            body: '<path fill="currentColor" d="M15 18v2h8v-2h-8m4.5-14.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.26-1.26c-.17-.56-.26-1.15-.26-1.74c0-.68.12-1.36.34-2H6v-2h8.53A6.003 6.003 0 0 1 21 13.34V2l-1.5 1.5M18 13H6v-2h12v2m0-4H6V7h12v2Z"/>'
        },
        "receipt-text-minus-outline": {
            body: '<path fill="currentColor" d="M15 18v2h8v-2h-8m-1.74 2.74L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22V2l1.5 1.5L6 2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v11.35c-.63-.22-1.3-.35-2-.35V5H5v14h8c0 .57.1 1.22.26 1.74M14.54 15c-.54.58-.93 1.25-1.19 2H6v-2h8.54M6 11h12v2H6v-2m0-4h12v2H6V7Z"/>'
        },
        "receipt-text-outline": {
            body: '<path fill="currentColor" d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5M19 19H5V5h14v14M6 15h12v2H6m0-6h12v2H6m0-6h12v2H6V7Z"/>'
        },
        "receipt-text-plus": {
            body: '<path fill="currentColor" d="M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2m1.5-11.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.26-1.26c-.17-.56-.26-1.15-.26-1.74c0-.68.12-1.36.34-2H6v-2h8.53A6.003 6.003 0 0 1 21 13.34V2l-1.5 1.5M18 13H6v-2h12v2m0-4H6V7h12v2Z"/>'
        },
        "receipt-text-plus-outline": {
            body: '<path fill="currentColor" d="M18 15v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2m-4.74 5.74L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22V2l1.5 1.5L6 2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v11.35c-.63-.22-1.3-.35-2-.35V5H5v14h8c0 .57.1 1.22.26 1.74M14.54 15c-.54.58-.93 1.25-1.19 2H6v-2h8.54M6 11h12v2H6v-2m0-4h12v2H6V7Z"/>'
        },
        "receipt-text-remove": {
            body: '<path fill="currentColor" d="M21.12 15.46L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.26-1.26c-.17-.56-.26-1.15-.26-1.74c0-.68.12-1.36.34-2H6v-2h8.53A6.003 6.003 0 0 1 21 13.34V2l-1.5 1.5M18 13H6v-2h12v2m0-4H6V7h12v2Z"/>'
        },
        "receipt-text-remove-outline": {
            body: '<path fill="currentColor" d="M21.12 15.46L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42m-7.86 5.28L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22V2l1.5 1.5L6 2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v11.35c-.63-.22-1.3-.35-2-.35V5H5v14h8c0 .57.1 1.22.26 1.74M14.54 15c-.54.58-.93 1.25-1.19 2H6v-2h8.54M6 11h12v2H6v-2m0-4h12v2H6V7Z"/>'
        },
        record: {
            body: '<path fill="currentColor" d="M19 12c0 3.86-3.14 7-7 7s-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7Z"/>'
        },
        "record-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 7a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "record-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2a8 8 0 0 1 8 8a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8m0 5a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "record-player": {
            body: '<path fill="currentColor" d="M5 17.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V17H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h17v-2H7l-1 1V9a1 1 0 0 1 1-1h12V7h2v1a1 1 0 0 1 1 1v1h-1v2h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V17H5v.5M3 14v1h2v-1H3m3 0v1h2v-1H6m14.5-.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "record-rec": {
            body: '<path fill="currentColor" d="M12.5 5A7.5 7.5 0 0 0 5 12.5a7.5 7.5 0 0 0 7.5 7.5a7.5 7.5 0 0 0 7.5-7.5A7.5 7.5 0 0 0 12.5 5M7 10h2a1 1 0 0 1 1 1v1c0 .5-.38.9-.86.97L10.31 15H9.15L8 13v2H7m5-5h2v1h-2v1h2v1h-2v1h2v1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1m4 0h2v1h-2v3h2v1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1m-8 1v1h1v-1"/>'
        },
        rectangle: {
            body: '<path fill="currentColor" d="M4 6v13h16V6H4Z"/>'
        },
        "rectangle-outline": {
            body: '<path fill="currentColor" d="M4 6v13h16V6H4m14 11H6V8h12v9Z"/>'
        },
        recycle: {
            body: '<path fill="currentColor" d="m21.82 15.42l-2.5 4.33c-.49.86-1.4 1.31-2.32 1.25h-2v2l-2.5-4.5L15 14v2h2.82l-2.22-3.85l4.33-2.5l1.8 3.12c.52.77.59 1.8.09 2.65M9.21 3.06h5c.98 0 1.83.57 2.24 1.39l1 1.74l1.73-1l-2.64 4.41l-5.15.09l1.73-1l-1.41-2.45l-2.21 3.85l-4.34-2.5l1.8-3.12c.41-.83 1.26-1.41 2.25-1.41m-4.16 16.7l-2.5-4.33c-.49-.85-.42-1.87.09-2.64l1-1.73l-1.73-1l5.14.08l2.65 4.42l-1.73-1L6.56 16H11v5H7.4a2.51 2.51 0 0 1-2.35-1.24Z"/>'
        },
        "recycle-variant": {
            body: '<path fill="currentColor" d="m7.17 7.91l1.73 1l3.18-5.49l2.25 3.89l-2.6 1.5l5.46 1.46l1.47-5.46l-2.6 1.5l-2.25-3.9a1.988 1.988 0 0 0-2.73-.73c-.27.15-.5.37-.67.63M10 20v-2H3.66l2.24-3.9l2.6 1.5l-1.46-5.46l-5.47 1.46l2.6 1.5L1.92 17a2.003 2.003 0 0 0 1.62 3m15.52-8.5l-1.74 1L20.5 18H16v-3l-4 4l4 4v-3h4.5c1.11 0 2-.89 2-2c0-.31-.08-.62-.22-.89Z"/>'
        },
        reddit: {
            body: '<path fill="currentColor" d="M14.5 15.41c.08.09.08.28 0 .39c-.73.7-2.09.76-2.5.76c-.39 0-1.75-.06-2.46-.76c-.1-.11-.1-.3 0-.39c.11-.1.28-.1.38 0c.46.46 1.41.59 2.08.59c.69 0 1.66-.13 2.1-.59c.11-.1.28-.1.4 0m-3.75-2.37c0-.57-.47-1.04-1.04-1.04c-.57 0-1.04.47-1.04 1.04c0 .57.47 1.05 1.04 1.04c.57 0 1.04-.47 1.04-1.04M14.29 12c-.57 0-1.04.5-1.04 1.05s.47 1.04 1.04 1.04c.57 0 1.04-.48 1.04-1.04c0-.55-.47-1.05-1.04-1.05M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-3.33 0c0-.81-.67-1.46-1.45-1.46c-.4 0-.76.16-1.02.41c-1-.72-2.37-1.18-3.9-1.24l.67-3.13l2.17.47c.02.55.48.99 1.04.99c.57 0 1.04-.47 1.04-1.04c0-.57-.47-1.04-1.04-1.04c-.41 0-.77.24-.93.59l-2.43-.52c-.07-.03-.14 0-.19.04c-.06.04-.09.1-.1.17l-.74 3.48c-1.55.05-2.95.51-3.97 1.24c-.26-.25-.62-.4-1.01-.4c-.81 0-1.46.65-1.46 1.44c0 .61.36 1.11.86 1.34c-.02.16-.03.28-.03.44c0 2.22 2.61 4.07 5.82 4.07c3.23 0 5.85-1.82 5.85-4.07c0-.14-.01-.28-.04-.44c.5-.23.86-.74.86-1.34Z"/>'
        },
        redhat: {
            body: '<path fill="currentColor" d="M15.34 13.16c1.32 0 3.22-.27 3.22-1.84c.01-.12 0-.24-.03-.36l-.78-3.4c-.18-.75-.34-1.09-1.66-1.75c-1.02-.52-3.24-1.38-3.9-1.38c-.61 0-.79.79-1.52.79c-.7 0-1.22-.59-1.88-.59c-.63 0-1.04.43-1.36 1.31c0 0-.88 2.5-1 2.86c-.01.07-.02.13-.02.2c0 .97 3.82 4.15 8.93 4.15m3.43-1.19c.18.86.18.95.18 1.04c0 1.5-1.66 2.31-3.83 2.31c-4.92 0-9.23-2.88-9.23-4.78c0-.27.06-.53.16-.77c-1.77.08-4.05.4-4.05 2.42c0 3.32 7.84 7.39 14.05 7.39c4.76 0 5.95-2.15 5.95-3.85c0-1.34-1.15-2.86-3.23-3.76"/>'
        },
        redo: {
            body: '<path fill="currentColor" d="M18.4 10.6C16.55 9 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6Z"/>'
        },
        "redo-variant": {
            body: '<path fill="currentColor" d="M10.5 7A6.5 6.5 0 0 0 4 13.5a6.5 6.5 0 0 0 6.5 6.5H14v-2h-3.5C8 18 6 16 6 13.5S8 9 10.5 9h5.67l-3.08 3.09l1.41 1.41L20 8l-5.5-5.5l-1.42 1.41L16.17 7H10.5M18 18h-2v2h2v-2Z"/>'
        },
        "reflect-horizontal": {
            body: '<path fill="currentColor" d="M22 20h-8a1 1 0 0 1-1-1V4.97a1 1 0 0 1 .74-.97c.45-.12.91.08 1.13.47l8.02 14.03c.18.31.18.69 0 1c-.18.31-.51.5-.89.5M2 20c-.38 0-.71-.19-.89-.5a.993.993 0 0 1 0-1L9.13 4.47c.22-.39.68-.59 1.13-.47a1 1 0 0 1 .74.97V19a1 1 0 0 1-1 1H2m7-2V8.74L3.71 18H9Z"/>'
        },
        "reflect-vertical": {
            body: '<path fill="currentColor" d="M18 23H6c-.39 0-.74-.21-.91-.55a.998.998 0 0 1 .1-1.05l6.01-8.02c.38-.51 1.22-.51 1.6 0l6.01 8.02c.23.3.27.71.1 1.05c-.17.34-.52.55-.91.55m0-22c.39 0 .74.21.91.55c.17.34.13.75-.1 1.05l-6.01 8.02c-.38.51-1.22.51-1.6 0L5.19 2.6a.998.998 0 0 1-.1-1.05C5.26 1.21 5.61 1 6 1h12M8 3l4 5.35L16 3H8Z"/>'
        },
        refresh: {
            body: '<path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0 0 12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18a6 6 0 0 1-6-6a6 6 0 0 1 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35Z"/>'
        },
        "refresh-auto": {
            body: '<path fill="currentColor" d="M12.68 6h-1.36L7 16h2l.73-2h4.54l.73 2h2L12.68 6m-2.38 6.5L12 8l1.7 4.5h-3.4m7.1 7.9L19 22h-5v-5l2 2c2.39-1.39 4-4.05 4-7c0-4.41-3.59-8-8-8s-8 3.59-8 8c0 2.95 1.61 5.53 4 6.92v2.24C4.47 19.61 2 16.1 2 12C2 6.5 6.5 2 12 2s10 4.5 10 10c0 3.53-1.83 6.62-4.6 8.4Z"/>'
        },
        "refresh-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m6 9h-5l1.81-1.81A3.94 3.94 0 0 0 12 8a4 4 0 1 0 3.86 5h2.05A6 6 0 1 1 12 6a5.91 5.91 0 0 1 4.22 1.78L18 6Z"/>'
        },
        regex: {
            body: '<path fill="currentColor" d="M16 16.92c-.33.05-.66.08-1 .08c-.34 0-.67-.03-1-.08v-3.51l-2.5 2.48c-.5-.39-1-.89-1.39-1.39l2.48-2.5H9.08c-.05-.33-.08-.66-.08-1c0-.34.03-.67.08-1h3.51l-2.48-2.5c.19-.25.39-.5.65-.74c.24-.26.49-.46.74-.65L14 8.59V5.08c.33-.05.66-.08 1-.08c.34 0 .67.03 1 .08v3.51l2.5-2.48c.5.39 1 .89 1.39 1.39L17.41 10h3.51c.05.33.08.66.08 1c0 .34-.03.67-.08 1h-3.51l2.48 2.5c-.19.25-.39.5-.65.74c-.24.26-.49.46-.74.65L16 13.41v3.51M5 19a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2Z"/>'
        },
        "registered-trademark": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m.25-6.73h-1.44v3.23H9V7.71h3.26c1.03 0 1.83.23 2.4.69c.56.47.84 1.1.84 1.96c0 .6-.13 1.1-.39 1.5c-.26.4-.65.72-1.18.95l1.9 3.59v.1h-1.94l-1.64-3.23m-1.44-1.46h1.46c.45 0 .8-.12 1.05-.35c.25-.23.37-.55.37-.96c0-.41-.11-.73-.35-.97c-.23-.24-.59-.35-1.08-.35h-1.45v2.63Z"/>'
        },
        reiterate: {
            body: '<path fill="currentColor" d="M10.5 4A6.5 6.5 0 0 0 4 10H1l4 4l4-4H6.03a4.5 4.5 0 0 1 4.47-4a4.5 4.5 0 0 1 4.5 4.5a4.5 4.5 0 0 1-4.5 4.5H2v2h8.5a6.5 6.5 0 0 0 6.5-6.5A6.5 6.5 0 0 0 10.5 4m8.5 8v3h-2.5a7.5 7.5 0 0 1-2.26 2H19v3l4-4Z"/>'
        },
        "relation-many-to-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2h-8V9H5l-2 2H2V5h1l2 2h8v8h6l2-2Z"/>'
        },
        "relation-many-to-one": {
            body: '<path fill="currentColor" d="M22 15v2h-3v2h-2v-2h-6V9H5l-2 2H2V5h1l2 2h8v8h4v-2h2v2Z"/>'
        },
        "relation-many-to-one-or-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2v2h-2v-2h-6V9H5l-2 2H2V5h1l2 2h8v8h4v-2h2v2l2-2Z"/>'
        },
        "relation-many-to-only-one": {
            body: '<path fill="currentColor" d="M22 15v2h-1v2h-2v-2h-1v2h-2v-2h-5V9H5l-2 2H2V5h1l2 2h8v8h3v-2h2v2h1v-2h2v2Z"/>'
        },
        "relation-many-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H5L3 5H2v6h1l2-2h6v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6m-5.5 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-many-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H5L3 5H2v6h1l2-2h6v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2m-5.5 2a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-one-or-many-to-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2h-8V9H7v2H5V9l-2 2H2V5h1l2 2V5h2v2h6v8h6l2-2Z"/>'
        },
        "relation-one-or-many-to-one": {
            body: '<path fill="currentColor" d="M22 15v2h-3v2h-2v-2h-6V9H7v2H5V9l-2 2H2V5h1l2 2V5h2v2h6v8h4v-2h2v2Z"/>'
        },
        "relation-one-or-many-to-one-or-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2v2h-2v-2h-6V9H7v2H5V9l-2 2H2V5h1l2 2V5h2v2h6v8h4v-2h2v2l2-2Z"/>'
        },
        "relation-one-or-many-to-only-one": {
            body: '<path fill="currentColor" d="M22 15v2h-1v2h-2v-2h-1v2h-2v-2h-5V9H7v2H5V9l-2 2H2V5h1l2 2V5h2v2h6v8h3v-2h2v2h1v-2h2v2Z"/>'
        },
        "relation-one-or-many-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H7V5H5v2L3 5H2v6h1l2-2v2h2V9h4v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6m-5.5 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-one-or-many-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H7V5H5v2L3 5H2v6h1l2-2v2h2V9h4v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2m-5.5 2a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-one-to-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2h-8V9H7v2H5V9H2V7h3V5h2v2h6v8h6l2-2Z"/>'
        },
        "relation-one-to-one": {
            body: '<path fill="currentColor" d="M22 15v2h-3v2h-2v-2h-6V9H7v2H5V9H2V7h3V5h2v2h6v8h4v-2h2v2Z"/>'
        },
        "relation-one-to-one-or-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2v2h-2v-2h-6V9H7v2H5V9H2V7h3V5h2v2h6v8h4v-2h2v2l2-2Z"/>'
        },
        "relation-one-to-only-one": {
            body: '<path fill="currentColor" d="M22 15v2h-1v2h-2v-2h-1v2h-2v-2h-5V9H7v2H5V9H2V7h3V5h2v2h6v8h3v-2h2v2h1v-2h2v2Z"/>'
        },
        "relation-one-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H7V5H5v2H2v2h3v2h2V9h4v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6m-5.5 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-one-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H7V5H5v2H2v2h3v2h2V9h4v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2m-5.5 2a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-only-one-to-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2h-8V9H8v2H6V9H5v2H3V9H2V7h1V5h2v2h1V5h2v2h5v8h6l2-2Z"/>'
        },
        "relation-only-one-to-one": {
            body: '<path fill="currentColor" d="M22 15v2h-3v2h-2v-2h-6V9H8v2H6V9H5v2H3V9H2V7h1V5h2v2h1V5h2v2h5v8h4v-2h2v2Z"/>'
        },
        "relation-only-one-to-one-or-many": {
            body: '<path fill="currentColor" d="M22 13v6h-1l-2-2v2h-2v-2h-6V9H8v2H6V9H5v2H3V9H2V7h1V5h2v2h1V5h2v2h5v8h4v-2h2v2l2-2Z"/>'
        },
        "relation-only-one-to-only-one": {
            body: '<path fill="currentColor" d="M22 15v2h-1v2h-2v-2h-1v2h-2v-2h-5V9H8v2H6V9H5v2H3V9H2V7h1V5h2v2h1V5h2v2h5v8h3v-2h2v2h1v-2h2v2Z"/>'
        },
        "relation-only-one-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H8V5H6v2H5V5H3v2H2v2h1v2h2V9h1v2h2V9h3v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6m-5.5 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-only-one-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H8V5H6v2H5V5H3v2H2v2h1v2h2V9h1v2h2V9h3v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2m-5.5 2a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-6V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h8l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-one": {
            body: '<path fill="currentColor" d="M19 15v-2h-2v2h-4V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h6v2h2v-2h3v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-one-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2v-2h-2v2h-4V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h6v2h2v-2l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-only-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-1v-2h-2v2h-3V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h5v2h2v-2h1v2h2v-2h1v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1m9 8a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-many-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H9.79a2.5 2.5 0 0 0-4.58 0H5L3 5H2v6h1l2-2h.21a2.5 2.5 0 0 0 4.58 0H11v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1m9 8a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-6V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h8l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-one": {
            body: '<path fill="currentColor" d="M19 15v-2h-2v2h-4V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h6v2h2v-2h3v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-one-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2v-2h-2v2h-4V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h6v2h2v-2l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-only-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-1v-2h-2v2h-3V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h5v2h2v-2h1v2h2v-2h1v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-zero-or-many": {
            body: '<path fill="currentColor" d="m21 13l-2 2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h3.21a2.5 2.5 0 0 0 4.58 0H19l2 2h1v-6M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1m9 8a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relation-zero-or-one-to-zero-or-one": {
            body: '<path fill="currentColor" d="M21 15v-2h-2v2h-.21a2.5 2.5 0 0 0-4.58 0H13V7H9.79a2.5 2.5 0 0 0-4.58 0H5V5H3v2H2v2h1v2h2V9h.21a2.5 2.5 0 0 0 4.58 0H11v8h3.21a2.5 2.5 0 0 0 4.58 0H19v2h2v-2h1v-2M7.5 9a1 1 0 1 1 1-1a1 1 0 0 1-1 1m9 8a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"/>'
        },
        "relative-scale": {
            body: '<path fill="currentColor" d="M20 18H4V6h16m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-8 6h-2v2h2m-4-2H6v2h2m8 2h-2v2h2m0-6h-2v2h2v-2Z"/>'
        },
        reload: {
            body: '<path fill="currentColor" d="M2 12a9 9 0 0 0 9 9c2.39 0 4.68-.94 6.4-2.6l-1.5-1.5A6.706 6.706 0 0 1 11 19c-6.24 0-9.36-7.54-4.95-11.95C10.46 2.64 18 5.77 18 12h-3l4 4h.1l3.9-4h-3a9 9 0 0 0-18 0Z"/>'
        },
        "reload-alert": {
            body: '<path fill="currentColor" d="M2 12c0 5 4 9 9 9c2.4 0 4.7-.9 6.4-2.6l-1.5-1.5c-1.3 1.4-3 2.1-4.9 2.1c-6.2 0-9.4-7.5-4.9-11.9S18 5.8 18 12h-3l4 4h.1l3.9-4h-3c0-5-4-9-9-9s-9 4-9 9m8 3h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        reminder: {
            body: '<path fill="currentColor" d="M7.25 3c.65 0 1.25.21 1.75.56V3a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.57c.5-.35 1.1-.57 1.75-.57a3 3 0 0 1 3 3c0 1.58-1.21 2.87-2.75 3h-2v1h1.24l.48.13l4.59 2.29c.82.31 1.22.92 1.22 1.83l-.03.14v.14l-1 6.75c-.06.47-.28.88-.66 1.22c-.37.34-.79.5-1.26.5H10c-.55 0-1-.19-1.42-.59L2 15.84l1.05-1.07c.28-.27.64-.43 1.08-.43h.32l4.55.99V9H7a3.021 3.021 0 0 1-2.75-3a3 3 0 0 1 3-3M9 6a1.75 1.75 0 0 0-1.75-1.75A1.75 1.75 0 0 0 5.5 6c0 .88.65 1.61 1.5 1.73v.02h2V6m6 1.75v-.01c.85-.12 1.5-.85 1.5-1.74c0-.96-.78-1.74-1.75-1.74S13 5.04 13 6v1.75h2Z"/>'
        },
        remote: {
            body: '<path fill="currentColor" d="M12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41A8.952 8.952 0 0 1 12 2c2.5 0 4.74 1 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0M7.05 6.05l1.41 1.41a5.022 5.022 0 0 1 7.08 0l1.41-1.41A6.976 6.976 0 0 0 12 4c-1.93 0-3.68.78-4.95 2.05M12 15a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m3-6H9a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1Z"/>'
        },
        "remote-desktop": {
            body: '<path fill="currentColor" d="M3 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M3 4h18v12H3M15 5l-3.5 3.5L15 12l1.4-1.4l-2.1-2.1l2.1-2.1M9 8L7.6 9.4l2.1 2.1l-2.1 2.1L9 15l3.5-3.5"/>'
        },
        "remote-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L21 21.72L19.73 23L16 19.27V22a1 1 0 0 1-1 1H9c-.54 0-1-.45-1-1V11.27l-6-6M12 0c3.05 0 5.8 1.23 7.77 3.23l-1.41 1.41C16.75 3 14.5 2 12 2c-2.28 0-4.36.85-5.94 2.24L4.64 2.82C6.59 1.07 9.17 0 12 0m0 4c1.94 0 3.69.78 4.95 2.05l-1.4 1.41C14.64 6.56 13.39 6 12 6c-1.17 0-2.24.4-3.1 1.08L7.5 5.66A6.85 6.85 0 0 1 12 4m3 5c.56 0 1 .45 1 1v4.18l-2.5-2.49l-.19-.19L10.82 9H15m-4.97 4.3c.13.86.81 1.55 1.68 1.7l-1.68-1.7Z"/>'
        },
        "remote-tv": {
            body: '<path fill="currentColor" d="M9 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h6c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2h-2v2h-2V2H9m2 4h2v2h2v2h-2v2h-2v-2H9V8h2V6m-2 8h2v2H9v-2m4 0h2v2h-2v-2m-4 4h2v2H9v-2m4 0h2v2h-2v-2Z"/>'
        },
        "remote-tv-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22L17 20.25c-.14.99-1 1.75-2 1.75H9a2 2 0 0 1-2-2v-9.73l-5-5M9 2h2v2h2V2h2a2 2 0 0 1 2 2v11.18l-4-4V10h2V8h-2V6h-2v2H9.82L7 5.18V4a2 2 0 0 1 2-2m0 18h2v-2H9v2m4 0h2v-1.73l-.27-.27H13v2m-4-6v2h2v-1.73l-.27-.27H9Z"/>'
        },
        "rename-box": {
            body: '<path fill="currentColor" d="M18 17h-7.5l2-2H18M6 17v-2.5l7.88-7.85c.19-.2.51-.2.71 0l1.76 1.76c.2.2.2.51 0 .71L8.47 17M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "reorder-horizontal": {
            body: '<path fill="currentColor" d="M3 15h18v-2H3v2m0 4h18v-2H3v2m0-8h18V9H3v2m0-6v2h18V5H3Z"/>'
        },
        "reorder-vertical": {
            body: '<path fill="currentColor" d="M9 3v18h2V3H9M5 3v18h2V3H5m8 0v18h2V3h-2m6 0h-2v18h2V3Z"/>'
        },
        repeat: {
            body: '<path fill="currentColor" d="M17 17H7v-3l-4 4l4 4v-3h12v-6h-2M7 7h10v3l4-4l-4-4v3H5v6h2V7Z"/>'
        },
        "repeat-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-3-3H7v3l-4-4l4-4v3h6.73L7 10.27V11H5V8.27l-3-3M17 13h2v4.18l-2-2V13m0-8V2l4 4l-4 4V7H8.82l-2-2H17Z"/>'
        },
        "repeat-once": {
            body: '<path fill="currentColor" d="M13 15V9h-1l-2 1v1h1.5v4m5.5 2H7v-3l-4 4l4 4v-3h12v-6h-2M7 7h10v3l4-4l-4-4v3H5v6h2V7Z"/>'
        },
        "repeat-variant": {
            body: '<path fill="currentColor" d="M6 5.75L10.25 10H7v6h6.5l2 2H7a2 2 0 0 1-2-2v-6H1.75L6 5.75m12 12.5L13.75 14H17V8h-6.5l-2-2H17a2 2 0 0 1 2 2v6h3.25L18 18.25Z"/>'
        },
        replay: {
            body: '<path fill="currentColor" d="M12 5V1L7 6l5 5V7a6 6 0 0 1 6 6a6 6 0 0 1-6 6a6 6 0 0 1-6-6H4a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        reply: {
            body: '<path fill="currentColor" d="M10 9V5l-7 7l7 7v-4.1c5 0 8.5 1.6 11 5.1c-1-5-4-10-11-11Z"/>'
        },
        "reply-all": {
            body: '<path fill="currentColor" d="M13 9V5l-7 7l7 7v-4.1c5 0 8.5 1.6 11 5.1c-1-5-4-10-11-11M7 8V5l-7 7l7 7v-3l-4-4l4-4Z"/>'
        },
        "reply-all-outline": {
            body: '<path fill="currentColor" d="M11 9.8v.9l1.7.2c2.6.4 4.5 1.4 5.9 2.7c-1.7-.5-3.5-.8-5.6-.8h-2v1.3L8.8 12L11 9.8M13 5l-7 7l7 7v-4.1c5 0 8.5 1.6 11 5.1c-1-5-4-10-11-11M7 8V5l-7 7l7 7v-3l-4-4"/>'
        },
        "reply-circle": {
            body: '<path fill="currentColor" d="M2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2S2 6.5 2 12m3-1l5-5v3c5.06.73 7.28 4.33 8 8c-1.81-2.57-4.39-4-8-4v3l-5-5Z"/>'
        },
        "reply-outline": {
            body: '<path fill="currentColor" d="M8 9.8v.9l1.7.3c2.6.4 4.5 1.4 5.9 2.7c-1.7-.5-3.5-.8-5.6-.8H8v1.3L5.8 12L8 9.8M10 5l-7 7l7 7v-4.1c5 0 8.5 1.6 11 5.1c-1-5-4-10-11-11"/>'
        },
        reproduction: {
            body: '<path fill="currentColor" d="m12.72 13.15l.9-.89c-.02-1.26.69-2.82 2-4.12c1.95-1.96 4.49-2.59 5.66-1.42s.54 3.71-1.42 5.66c-1.3 1.31-2.86 2.02-4.12 2l-.89.9c-.35.33-.85.38-1.25.13c-.84.3-1.6.67-2.04 1.39c-.53.88-.53 2.3-1.09 3.15c-.56.86-1.68 1.15-2.86 1.15S5 21 3.95 19.5l2.48.42c.57.08 2.07-.53 2.62-1.38c.56-.86.56-2.27 1.09-3.16c.47-.78 1.36-1.15 2.29-1.47c-.01-.27.07-.55.29-.76M7 2a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        resistor: {
            body: '<path fill="currentColor" d="M2 11h5l3.07 4.35L13.11 4L18 11h4v2h-5l-3.07-4.35L10.89 20L6 13H2v-2Z"/>'
        },
        "resistor-nodes": {
            body: '<path fill="currentColor" d="M2 11h1.67c.41-1.17 1.52-2 2.83-2a3 3 0 0 1 3 3c0 .65-.21 1.25-.56 1.74l1.13 1.61L13.11 4l1.5 2.13l2.09 2.98l.8-.11c1.31 0 2.42.83 2.83 2H22v2h-1.67a2.99 2.99 0 0 1-2.83 2a3 3 0 0 1-3-3c0-.65.21-1.25.56-1.74l-1.13-1.61L10.89 20L7.3 14.89A2.99 2.99 0 0 1 3.67 13H2v-2m15.5-.5A1.5 1.5 0 0 0 16 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 19 12a1.5 1.5 0 0 0-1.5-1.5m-11 0A1.5 1.5 0 0 0 5 12a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 8 12a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        resize: {
            body: '<path fill="currentColor" d="m10.59 12l4-4H11V6h7v7h-2V9.41l-4 4V16h8V4H8v8h2.59M22 2v16H12v4H2V12h4V2h16M10 14H4v6h6v-6Z"/>'
        },
        "resize-bottom-right": {
            body: '<path fill="currentColor" d="M22 22h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m0-4h-2v-2h2v2m-4 4h-2v-2h2v2m8-8h-2v-2h2v2Z"/>'
        },
        responsive: {
            body: '<path fill="currentColor" d="M4 6v10h5v-4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v4h2V6H4M0 20v-2h4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h4v2h-6a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2H0m11.5 0a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m4 0a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M13 20v1h1v-1h-1m-2-8v7h5v-7h-5Z"/>'
        },
        restart: {
            body: '<path fill="currentColor" d="M12 4c2.1 0 4.1.8 5.6 2.3c3.1 3.1 3.1 8.2 0 11.3c-1.8 1.9-4.3 2.6-6.7 2.3l.5-2c1.7.2 3.5-.4 4.8-1.7c2.3-2.3 2.3-6.1 0-8.5C15.1 6.6 13.5 6 12 6v4.6l-5-5l5-5V4M6.3 17.6C3.7 15 3.3 11 5.1 7.9l1.5 1.5c-1.1 2.2-.7 5 1.2 6.8c.5.5 1.1.9 1.8 1.2l-.6 2c-1-.4-1.9-1-2.7-1.8Z"/>'
        },
        "restart-alert": {
            body: '<path fill="currentColor" d="M10 4.03V.633L5 5.63l5 5v-4.6c1.5 0 3.11.6 4.21 1.7c2.29 2.4 2.29 6.2 0 8.5c-1.3 1.3-3.1 1.9-4.81 1.7l-.5 2c2.41.3 4.91-.4 6.71-2.3c3.09-3.1 3.09-8.2 0-11.3c-1.5-1.5-3.5-2.3-5.61-2.3m-5.69 13.6c.8.8 1.69 1.4 2.69 1.8l.61-2c-.7-.3-1.3-.7-1.8-1.2c-1.9-1.8-2.31-4.6-1.2-6.8l-1.5-1.5c-1.8 3.1-1.4 7.1 1.2 9.7M20 13h2V7h-2v6m0 4h2v-2h-2v2Z"/>'
        },
        "restart-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-4.2-4.2c-1.7 1.2-3.7 1.7-5.7 1.4l.5-2c1.3.1 2.6-.2 3.7-.9L1.1 3l1.3-1.3l14.1 14.1l1.4 1.4l4.2 4.2l-1.3 1.3M12 6c1.5 0 3.1.6 4.2 1.8c1.8 1.8 2.2 4.4 1.3 6.6l1.5 1.5c1.7-3 1.2-6.9-1.4-9.5C16.1 4.8 14 4 12 4V.7l-4.1 4L12 8.8V6M6.6 9.4L5.1 7.9C3.3 11 3.7 15 6.3 17.7c.8.7 1.7 1.3 2.7 1.7l.5-2c-.6-.3-1.2-.7-1.8-1.2c-1.8-1.8-2.2-4.6-1.1-6.8Z"/>'
        },
        restore: {
            body: '<path fill="currentColor" d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.896 8.896 0 0 0 13 21a9 9 0 0 0 9-9a9 9 0 0 0-9-9Z"/>'
        },
        "restore-alert": {
            body: '<path fill="currentColor" d="M13 3c-5 0-9 4-9 9H1l3.9 3.9l.1.1l4-4H6c0-3.9 3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7c-1.9 0-3.7-.8-4.9-2.1l-1.4 1.4C8.3 20 10.5 21 13 21c5 0 9-4 9-9s-4-9-9-9m-1 12h2v2h-2v-2m0-8h2v6h-2V7"/>'
        },
        rewind: {
            body: '<path fill="currentColor" d="m11.5 12l8.5 6V6m-9 12V6l-8.5 6l8.5 6Z"/>'
        },
        "rewind-10": {
            body: '<path fill="currentColor" d="M12.5 3c4.65 0 8.58 3.03 9.97 7.22L20.1 11c-1.05-3.19-4.06-5.5-7.6-5.5c-1.96 0-3.73.72-5.12 1.88L10 10H3V3l2.6 2.6C7.45 4 9.85 3 12.5 3M10 12v10H8v-8H6v-2h4m8 2v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-4 0v6h2v-6h-2Z"/>'
        },
        "rewind-15": {
            body: '<path fill="currentColor" d="M12.5 3c4.65 0 8.58 3.03 9.97 7.22L20.1 11c-1.05-3.19-4.06-5.5-7.6-5.5c-1.96 0-3.73.72-5.12 1.88L10 10H3V3l2.6 2.6C7.45 4 9.85 3 12.5 3M10 12v10H8v-8H6v-2h4m2 0h6v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-4v-2h4v-2h-4v-6Z"/>'
        },
        "rewind-30": {
            body: '<path fill="currentColor" d="M19 14v6c0 1.11-.89 2-2 2h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-4 0v6h2v-6h-2m-4 6a2 2 0 0 1-2 2H5v-2h4v-2H7v-2h2v-2H5v-2h4a2 2 0 0 1 2 2v1.5A1.5 1.5 0 0 1 9.5 17a1.5 1.5 0 0 1 1.5 1.5V20m1.5-17c4.65 0 8.58 3.03 9.97 7.22L20.1 11c-1.05-3.19-4.06-5.5-7.6-5.5c-1.96 0-3.73.72-5.12 1.88L10 10H3V3l2.6 2.6C7.45 4 9.85 3 12.5 3Z"/>'
        },
        "rewind-45": {
            body: '<path fill="currentColor" d="M12.5 3c4.6 0 8.6 3 10 7.2l-2.4.8C19 7.8 16 5.5 12.5 5.5c-2 0-3.7.7-5.1 1.9L10 10H3V3l2.6 2.6C7.4 4 9.9 3 12.5 3m.5 9h6v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2h4v-2h-4v-6m-8 0v6h4v4h2V12H9v4H7v-4H5Z"/>'
        },
        "rewind-5": {
            body: '<path fill="currentColor" d="M12.5 3c4.65 0 8.58 3.03 9.97 7.22L20.1 11c-1.05-3.19-4.06-5.5-7.6-5.5c-1.96 0-3.73.72-5.12 1.88L10 10H3V3l2.6 2.6C7.45 4 9.85 3 12.5 3M9 12h6v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2H9v-2h4v-2H9v-6Z"/>'
        },
        "rewind-60": {
            body: '<path fill="currentColor" d="M19 14v6c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2m-4 0v6h2v-6h-2M12.5 3c4.6 0 8.6 3 10 7.2l-2.4.8C19 7.8 16 5.5 12.5 5.5c-2 0-3.7.7-5.1 1.9L10 10H3V3l2.6 2.6C7.4 4 9.9 3 12.5 3M7 12c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H7v-2h4v-2H7m0 6h2v2H7v-2Z"/>'
        },
        "rewind-outline": {
            body: '<path fill="currentColor" d="M10 9.9L7 12l3 2.1V9.9m9 0L16 12l3 2.1V9.9M12 6v12l-8.5-6L12 6m9 0v12l-8.5-6L21 6Z"/>'
        },
        rhombus: {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2Z"/>'
        },
        "rhombus-medium": {
            body: '<path fill="currentColor" d="M12 6.46c-.28 0-.56.1-.78.32l-4.44 4.44c-.43.43-.43 1.13 0 1.56l4.44 4.44c.43.43 1.13.43 1.56 0l4.44-4.44c.43-.43.43-1.13 0-1.56l-4.44-4.44c-.22-.22-.5-.32-.78-.32Z"/>'
        },
        "rhombus-medium-outline": {
            body: '<path fill="currentColor" d="M12 6.46c-.28 0-.56.1-.78.32l-4.44 4.44c-.43.43-.43 1.13 0 1.56l4.44 4.44c.43.43 1.13.43 1.56 0l4.44-4.44c.43-.43.43-1.13 0-1.56l-4.44-4.44c-.22-.22-.5-.32-.78-.32m0 2.37L15.17 12L12 15.17L8.83 12L12 8.83Z"/>'
        },
        "rhombus-outline": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l8 8l-8 8l-8-8Z"/>'
        },
        "rhombus-split": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-3.3 3.29l4.71 4.7l4.71-4.7l-3.3-3.29C13 2.19 12.5 2 12 2M5.88 7.29l-3.29 3.3c-.79.78-.79 2.04 0 2.82l3.29 3.3l4.7-4.71l-4.7-4.71m12.24 0L13.42 12l4.7 4.71l3.29-3.3c.79-.78.79-2.04 0-2.82l-3.29-3.3M12 13.42l-4.71 4.7l3.3 3.29c.78.79 2.04.79 2.82 0l3.3-3.29l-4.71-4.7Z"/>'
        },
        "rhombus-split-outline": {
            body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l3.29 3.29l-3.29 3.3l-3.29-3.3L12 4M7.29 8.71l3.3 3.29l-3.3 3.29L4 12l3.29-3.29m9.42 0L20 12l-3.29 3.29l-3.3-3.29l3.3-3.29M12 13.41l3.29 3.3L12 20l-3.29-3.29l3.29-3.3Z"/>'
        },
        ribbon: {
            body: '<path fill="currentColor" d="m13.41 19.31l3.18 3.19L18 21.07l-3.17-3.17m.71-6.37h-.01L12 15.07l-3.53-3.54h-.01A4.98 4.98 0 0 1 7 8a5 5 0 0 1 5-5a5 5 0 0 1 5 5c0 1.38-.56 2.63-1.46 3.53M16.9 13A6.96 6.96 0 0 0 19 8a7 7 0 0 0-7-7a7 7 0 0 0-7 7c0 1.96.81 3.73 2.1 5l3.49 3.5L6 21.07l1.41 1.43L16.9 13Z"/>'
        },
        rice: {
            body: '<path fill="currentColor" d="M22 11h-2.3c-.3-1.1-.8-2.2-1.5-3l3.4-5.4l-1.7-1.1l-3.2 5.1c-.4-.3-.7-.5-1.2-.7l.9-3.6l-1.9-.5l-.8 3.4c-.6-.1-1.1-.2-1.7-.2c-3.7 0-6.8 2.6-7.7 6H2c0 4.1 2.5 7.6 6 9.2V22h8v-1.8c3.5-1.6 6-5.1 6-9.2M12 7c2.6 0 4.8 1.7 5.6 4H6.4c.8-2.3 3-4 5.6-4Z"/>'
        },
        rickshaw: {
            body: '<path fill="currentColor" d="M20 14.05v-1.32c0-.47-.16-.93-.46-1.29L15.6 6.72c-.38-.46-.94-.72-1.54-.72H4c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h.05a2.5 2.5 0 0 0 4.9 0h8.1A2.5 2.5 0 1 0 20 14.05M3.5 8c0-.27.23-.5.5-.5h3V12H3.5V8m3 9.5c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m6.5-2H9V14h2v-2H9V7.5h4v8m2-7.16L18.05 12H15V8.34m4.5 9.16c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "rickshaw-electric": {
            body: '<path fill="currentColor" d="M20 12.05v-1.32c0-.47-.16-.93-.46-1.29L15.6 4.72c-.38-.46-.94-.72-1.54-.72H4c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h.05a2.5 2.5 0 0 0 4.9 0h8.1A2.5 2.5 0 1 0 20 12.05M3.5 6c0-.27.23-.5.5-.5h3V10H3.5V6m3 9.5c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m6.5-2H9V12h2v-2H9V5.5h4v8m2-7.16L18.05 10H15V6.34m4.5 9.16c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1M11 20H7l6 3v-2h4l-6-3v2Z"/>'
        },
        ring: {
            body: '<path fill="currentColor" d="M12 10L8 4.4L9.6 2h4.8L16 4.4L12 10m3.5-3.2l-1.2 1.7c2.2.9 3.7 3 3.7 5.5a6 6 0 0 1-6 6a6 6 0 0 1-6-6c0-2.5 1.5-4.6 3.7-5.5L8.5 6.8C5.8 8.1 4 10.8 4 14a8 8 0 0 0 8 8a8 8 0 0 0 8-8c0-3.2-1.8-5.9-4.5-7.2Z"/>'
        },
        rivet: {
            body: '<path fill="currentColor" d="M11.43 2c-.82 0-1.49.65-1.49 1.5v3.46H7.95v.99h7.96v-.99h-1.99V3.5c0-.85-.67-1.5-1.49-1.5h-1m-.49 6.95v12.92l.99 1l.99-1V8.95h-1.98Z"/>'
        },
        road: {
            body: '<path fill="currentColor" d="M11 16h2v4h-2m0-10h2v4h-2m0-10h2v4h-2M4 22h16V2H4v20Z"/>'
        },
        "road-variant": {
            body: '<path fill="currentColor" d="M18.1 4.8c-.1-.5-.5-.8-1-.8H13l.2 3h-2.4l.2-3H6.8c-.5 0-.9.4-1 .8l-2.7 14c-.1.6.4 1.2 1 1.2H10l.3-5h3.4l.3 5h5.8c.6 0 1.1-.6 1-1.2l-2.7-14M10.4 13l.2-4h2.6l.2 4h-3Z"/>'
        },
        robber: {
            body: '<path fill="currentColor" d="M10.7 12.5c0 .3-1.3.7-2.3.7s-2.1-.7-2.1-.9c0-.3.7-1.2 2.3-1.3c.9-.1 1.9.5 2.1 1.5m4.7-1.5c-1-.1-1.9.5-2.1 1.5c0 .3 1.2.7 2.3.7c1.1 0 2.1-.7 2.1-.9s-.7-1.2-2.3-1.3m6.6 1c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-2-.8c0-2-.7-2.7-3.3-2.7c-2.6 0-3.4 1.1-4.7 1.1s-2-1.1-4.7-1.1S4 9.1 4 11.2c0 3.4 1.5 5.3 3.6 5.3c1.6 0 2.8-2 4.4-2s2.7 2 4.4 2c2.1 0 3.6-1.9 3.6-5.3Z"/>'
        },
        robot: {
            body: '<path fill="currentColor" d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2M7.5 13A2.5 2.5 0 0 0 5 15.5A2.5 2.5 0 0 0 7.5 18a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 7.5 13m9 0a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "robot-angry": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M7.5 18A2.5 2.5 0 0 1 5 15.5c0-.82.4-1.54 1-2l3.83 2.88C9.5 17.32 8.57 18 7.5 18m9 0c-1.07 0-2-.68-2.33-1.62L18 13.5c.6.46 1 1.18 1 2a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "robot-angry-outline": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1m-1 3h-2v3H5v-3H3v-1h2v-2c0-2.76 2.24-5 5-5h4c2.76 0 5 2.24 5 5v2h2v1m-3.5-1.5c0 1.11-.89 2-2 2c-.97 0-1.77-.69-1.96-1.6l2.96-2.12c.6.35 1 .98 1 1.72m-10-1.72l2.96 2.12c-.18.91-.99 1.6-1.96 1.6a2 2 0 0 1-2-2c0-.74.4-1.37 1-1.72Z"/>'
        },
        "robot-confused": {
            body: '<path fill="currentColor" d="M20 4h-2V3h2.5c.28 0 .5.22.5.5v2c0 .28-.22.5-.5.5H20v1h-1V5h1V4m-1 5h1V8h-1v1m-2-6h-1v4h1V3m6 12v3c0 .55-.45 1-1 1h-1v1c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-3.87 3.13-7 7-7h1V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c.34 0 .67.03 1 .08V10h4.74A6.94 6.94 0 0 1 21 14h1c.55 0 1 .45 1 1m-13 .5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0m9 0a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0M17 8h-1v1h1V8Z"/>'
        },
        "robot-confused-outline": {
            body: '<path fill="currentColor" d="M19 8h1v1h-1V8m1-3h-1v2h1V6h.5c.28 0 .5-.22.5-.5v-2c0-.28-.22-.5-.5-.5H18v1h2v1m-3-2h-1v4h1V3m-3.5 12.5a2 2 0 1 0 4 0c0-1.11-.89-2-2-2s-2 .9-2 2M17 8h-1v1h1V8m5 6h-1c0-1.5-.47-2.87-1.26-4h-2.77c1.22.91 2.03 2.36 2.03 4v2h2v1h-2v3H5v-3H3v-1h2v-2c0-2.76 2.24-5 5-5h4c.34 0 .68.04 1 .1V7.08c-.33-.05-.66-.08-1-.08h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1m-13.5-.5c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2Z"/>'
        },
        "robot-dead": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M9.86 16.68l-1.18 1.18l-1.18-1.18l-1.18 1.18l-1.18-1.18l1.18-1.18l-1.18-1.18l1.18-1.18l1.18 1.18l1.18-1.18l1.18 1.18l-1.18 1.18l1.18 1.18m9 0l-1.18 1.18l-1.18-1.18l-1.18 1.18l-1.18-1.18l1.18-1.18l-1.18-1.18l1.18-1.18l1.18 1.18l1.18-1.18l1.18 1.18l-1.18 1.18l1.18 1.18Z"/>'
        },
        "robot-dead-outline": {
            body: '<path fill="currentColor" d="M10.62 14.44L9.56 15.5l1.06 1.06l-1.06 1.06l-1.06-1.06l-1.06 1.06l-1.06-1.06l1.06-1.06l-1.06-1.06l1.06-1.06l1.06 1.06l1.06-1.06l1.06 1.06m5.94-1.06l-1.06 1.06l-1.06-1.06l-1.06 1.06l1.06 1.06l-1.06 1.06l1.06 1.06l1.06-1.06l1.06 1.06l1.06-1.06l-1.06-1.06l1.06-1.06l-1.06-1.06M23 15v3c0 .55-.45 1-1 1h-1v1c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-3.87 3.13-7 7-7h1V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c3.87 0 7 3.13 7 7h1c.55 0 1 .45 1 1m-2 1h-2v-2c0-2.76-2.24-5-5-5h-4c-2.76 0-5 2.24-5 5v2H3v1h2v3h14v-3h2v-1Z"/>'
        },
        "robot-excited": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M8.68 17.04L7.5 15.86l-1.18 1.18l-1.18-1.18L7.5 13.5l2.36 2.36l-1.18 1.18m9 0l-1.18-1.18l-1.18 1.18l-1.18-1.18l2.36-2.36l2.36 2.36l-1.18 1.18Z"/>'
        },
        "robot-excited-outline": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1m-1 3h-2v3H5v-3H3v-1h2v-2c0-2.76 2.24-5 5-5h4c2.76 0 5 2.24 5 5v2h2v1M8.5 13.5l2.36 2.36l-1.18 1.18l-1.18-1.18l-1.18 1.18l-1.18-1.18L8.5 13.5m7 0l2.36 2.36l-1.18 1.18l-1.18-1.18l-1.18 1.18l-1.18-1.18l2.36-2.36Z"/>'
        },
        "robot-happy": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M9.79 16.5C9.4 15.62 8.53 15 7.5 15s-1.9.62-2.29 1.5c-.13-.31-.21-.64-.21-1a2.5 2.5 0 0 1 5 0c0 .36-.08.69-.21 1m9 0c-.39-.88-1.29-1.5-2.29-1.5s-1.9.62-2.29 1.5c-.13-.31-.21-.64-.21-1a2.5 2.5 0 0 1 5 0c0 .36-.08.69-.21 1Z"/>'
        },
        "robot-happy-outline": {
            body: '<path fill="currentColor" d="M10.5 15.5c0 .37-.1.7-.28 1c-.34-.59-.98-1-1.72-1s-1.38.41-1.72 1c-.17-.3-.28-.63-.28-1c0-1.1.9-2 2-2s2 .9 2 2M23 15v3c0 .55-.45 1-1 1h-1v1c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-3.87 3.13-7 7-7h1V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c3.87 0 7 3.13 7 7h1c.55 0 1 .45 1 1m-2 1h-2v-2c0-2.76-2.24-5-5-5h-4c-2.76 0-5 2.24-5 5v2H3v1h2v3h14v-3h2v-1m-5.5-2.5c-1.1 0-2 .9-2 2c0 .37.11.7.28 1c.34-.59.98-1 1.72-1s1.38.41 1.72 1c.18-.3.28-.63.28-1a2 2 0 0 0-2-2Z"/>'
        },
        "robot-industrial": {
            body: '<path fill="currentColor" d="M18.41 4L16 6.41v.18L18.41 9H22v2h-4.41L16 9.41V12h-1a2 2 0 0 1-2-2V7.5H9.86c-.09.37-.24.72-.44 1.05L15.18 19H20a2 2 0 0 1 2 2v1H2v-1a2 2 0 0 1 2-2h6.61l-4.69-8.5a4.006 4.006 0 0 1-3.81-3A4 4 0 0 1 5 2.63c2.13-.55 4.31.73 4.86 2.87H13V3a2 2 0 0 1 2-2h1v2.59L17.59 2H22v2h-3.59M6 4.5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "robot-industrial-outline": {
            body: '<path fill="currentColor" d="M4 19h4.6L2.62 8.64C2.23 8 2 7.29 2 6.5a3.999 3.999 0 0 1 7.87-1H14V3c0-1.1.9-2 2-2v2.59L17.59 2H22v2h-3.59L16 6.41v.18L18.41 9H22v2h-4.41L16 9.41V12a2 2 0 0 1-2-2V7.5H9.87c-.1.39-.26.76-.46 1.1l6 10.4H20a2 2 0 0 1 2 2v1H2v-1c0-1.1.9-2 2-2m3.91-9c-.56.32-1.21.5-1.91.5l4.91 8.5h2.19l-5.19-9M6 4.5a2 2 0 0 0-2 2c0 1.11.89 2 2 2c1.11 0 2-.89 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "robot-love": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M9.7 15.45l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0c.4.39.4 1.05 0 1.45m9 0l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0c.4.39.4 1.05 0 1.45Z"/>'
        },
        "robot-love-outline": {
            body: '<path fill="currentColor" d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1m-1 3h-2v3H5v-3H3v-1h2v-2c0-2.76 2.24-5 5-5h4c2.76 0 5 2.24 5 5v2h2v1m-10.3-3c.4.39.4 1.05 0 1.45l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0m7 0c.4.39.4 1.05 0 1.45l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0Z"/>'
        },
        "robot-mower": {
            body: '<path fill="currentColor" d="M1 14V5h12c5.5 0 10 4.5 10 10v2h-2.17A2.99 2.99 0 0 1 18 19a2.99 2.99 0 0 1-2.83-2H10a5.002 5.002 0 0 1-9-3m5-3c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m9-1v2h5.25c-.33-.73-.75-1.4-1.25-2h-4Z"/>'
        },
        "robot-mower-outline": {
            body: '<path fill="currentColor" d="M1 14a5.002 5.002 0 0 0 9 3h5.17A3 3 0 0 0 18 19c1.31 0 2.42-.83 2.83-2H23v-2c0-5.5-4.5-10-10-10H1v9m20 1H10.9A5.002 5.002 0 0 0 3 10V7h9.5c2.6 0 4.92 1.16 6.5 3h-4v2h5.25c.42.92.67 1.94.75 3M6 11c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3Z"/>'
        },
        "robot-off": {
            body: '<path fill="currentColor" d="M23 15v3c0 .5-.36.88-.83.97l-3.2-3.2c.03-.09.03-.18.03-.27a2.5 2.5 0 0 0-2.5-2.5c-.09 0-.18 0-.27.03L10.2 7h.8V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c3.87 0 7 3.13 7 7h1c.55 0 1 .45 1 1m-.89 6.46l-1.27 1.27l-.95-.95c-.27.14-.57.22-.89.22H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-2.47 1.29-4.64 3.22-5.89L1.11 3l1.28-1.27l19.72 19.73M10 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0m6.07 2.46l-2.03-2.03c.19 1.04 1 1.84 2.03 2.03Z"/>'
        },
        "robot-off-outline": {
            body: '<path fill="currentColor" d="M23 15v3c0 .5-.36.88-.83.97L20.2 17h.8v-1h-1.8l-.2-.2V14c0-2.76-2.24-5-5-5h-1.8l-2-2h.8V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c3.87 0 7 3.13 7 7h1c.55 0 1 .45 1 1M8.5 13.5c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2m13.61 7.96l-1.27 1.27l-.95-.95c-.27.14-.57.22-.89.22H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-2.47 1.29-4.64 3.22-5.89L1.11 3l1.28-1.27l19.72 19.73m-4-1.46l-2.51-2.5h-.1a2 2 0 0 1-2-2v-.1L7.7 9.59C6.1 10.42 5 12.08 5 14v2H3v1h2v3h13.11Z"/>'
        },
        "robot-outline": {
            body: '<path fill="currentColor" d="M17.5 15.5c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2m-9-2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2M23 15v3c0 .55-.45 1-1 1h-1v1c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2v-1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1c0-3.87 3.13-7 7-7h1V5.73c-.6-.34-1-.99-1-1.73c0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.39-1 1.73V7h1c3.87 0 7 3.13 7 7h1c.55 0 1 .45 1 1m-2 1h-2v-2c0-2.76-2.24-5-5-5h-4c-2.76 0-5 2.24-5 5v2H3v1h2v3h14v-3h2v-1Z"/>'
        },
        "robot-vacuum": {
            body: '<path fill="currentColor" d="M12 2c2.65 0 5.19 1.06 7.07 2.93l-1.42 1.42A7.994 7.994 0 0 0 12 4c-2.12 0-4.16.84-5.65 2.35L4.93 4.93C6.81 3.06 9.35 2 12 2M3.66 6.5l1.45 1.44A8.043 8.043 0 0 0 4 12a8 8 0 0 0 8 8a8 8 0 0 0 8-8c0-1.43-.39-2.83-1.12-4.06l1.46-1.44A9.93 9.93 0 0 1 22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12c0-1.96.58-3.88 1.66-5.5M12 6a6 6 0 0 1 6 6c0 1.59-.63 3.12-1.76 4.24l-1.41-1.41a4.004 4.004 0 0 1-5.66 0l-1.41 1.41A5.97 5.97 0 0 1 6 12a6 6 0 0 1 6-6m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "robot-vacuum-alert": {
            body: '<path fill="currentColor" d="M10 2c2.6 0 5.2 1.1 7.1 2.9l-1.4 1.4C14.1 4.8 12.1 4 10 4s-4.2.8-5.7 2.3L2.9 4.9C4.8 3.1 7.4 2 10 2M1.7 6.5l1.5 1.4C2.4 9.2 2 10.6 2 12c0 4.4 3.6 8 8 8s8-3.6 8-8c0-1.4-.4-2.8-1.1-4.1l1.5-1.4C19.4 8.1 20 10 20 12c0 5.5-4.5 10-10 10S0 17.5 0 12c0-2 .6-3.9 1.7-5.5M10 6c3.3 0 6 2.7 6 6c0 1.6-.6 3.1-1.8 4.2l-1.4-1.4c-.7.8-1.7 1.2-2.8 1.2s-2.1-.4-2.8-1.2l-1.4 1.4C4.6 15.1 4 13.6 4 12c0-3.3 2.7-6 6-6m0 2c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m12 4V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "robot-vacuum-variant": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v2h2V5h14v2h2V5a2 2 0 0 0-2-2H5m3 4v2h8V7H8M3 9v3a9 9 0 0 0 9 9a9 9 0 0 0 9-9V9h-2v3a7 7 0 0 1-7 7a7 7 0 0 1-7-7V9H3m9 3a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 12 17a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 12Z"/>'
        },
        "robot-vacuum-variant-alert": {
            body: '<path fill="currentColor" d="M3 3c-1.1 0-2 .9-2 2v2h2V5h14v2h2V5c0-1.1-.9-2-2-2H3m3 4v2h8V7H6M1 9v3c0 5 4 9 9 9s9-4 9-9V9h-2v3c0 3.9-3.1 7-7 7s-7-3.1-7-7V9H1m9 3c-1.4 0-2.5 1.1-2.5 2.5S8.6 17 10 17s2.5-1.1 2.5-2.5S11.4 12 10 12m11 0V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        rocket: {
            body: '<path fill="currentColor" d="m20 22l-3.86-1.55c.7-1.53 1.2-3.11 1.51-4.72L20 22M7.86 20.45L4 22l2.35-6.27c.31 1.61.81 3.19 1.51 4.72M12 2s5 2 5 10c0 3.1-.75 5.75-1.67 7.83A2 2 0 0 1 13.5 21h-3a2 2 0 0 1-1.83-1.17C7.76 17.75 7 15.1 7 12c0-8 5-10 5-10m0 10c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2Z"/>'
        },
        "rocket-launch": {
            body: '<path fill="currentColor" d="m13.13 22.19l-1.63-3.83c1.57-.58 3.04-1.36 4.4-2.27l-2.77 6.1M5.64 12.5l-3.83-1.63l6.1-2.77C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39S16.66.269 11 5.93c-2.19 2.19-3.5 4.6-4.35 6.71c-.28.75-.09 1.57.46 2.13l2.13 2.12c.55.56 1.37.74 2.12.46A19.1 19.1 0 0 0 18.07 13c5.66-5.66 3.54-10.61 3.54-10.61m-7.07 7.07c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0c.77.78.78 2.05 0 2.83c-.78.78-2.05.78-2.83 0m-5.66 7.07l-1.41-1.41l1.41 1.41M6.24 22l3.64-3.64c-.34-.09-.67-.24-.97-.45L4.83 22h1.41M2 22h1.41l4.77-4.76l-1.42-1.41L2 20.59V22m0-2.83l4.09-4.08c-.21-.3-.36-.62-.45-.97L2 17.76v1.41Z"/>'
        },
        "rocket-launch-outline": {
            body: '<path fill="currentColor" d="m13.13 22.19l-1.63-3.83c1.57-.58 3.04-1.36 4.4-2.27l-2.77 6.1M5.64 12.5l-3.83-1.63l6.1-2.77C7 9.46 6.22 10.93 5.64 12.5M19.22 4c.28 0 .53 0 .74.05c.17 1.39-.02 4.25-3.3 7.53c-1.7 1.71-3.73 3.02-6.01 3.89l-2.15-2.1c.92-2.31 2.23-4.34 3.92-6.03C15.18 4.58 17.64 4 19.22 4m0-2c-1.98 0-4.98.69-8.22 3.93c-2.19 2.19-3.5 4.6-4.35 6.71c-.28.75-.09 1.57.46 2.13l2.13 2.12c.38.38.89.61 1.42.61c.23 0 .47-.06.7-.15A19.1 19.1 0 0 0 18.07 13c5.66-5.66 3.54-10.61 3.54-10.61S20.7 2 19.22 2m-4.68 7.46c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0c.77.78.78 2.05 0 2.83c-.78.78-2.05.78-2.83 0m-5.66 7.07l-1.41-1.41l1.41 1.41M6.24 22l3.64-3.64c-.34-.09-.67-.24-.97-.45L4.83 22h1.41M2 22h1.41l4.77-4.76l-1.42-1.41L2 20.59V22m0-2.83l4.09-4.08c-.21-.3-.36-.62-.45-.97L2 17.76v1.41Z"/>'
        },
        "rocket-outline": {
            body: '<path fill="currentColor" d="M12 2S7 4 7 12c0 3.1.76 5.75 1.67 7.83A2 2 0 0 0 10.5 21h3a2 2 0 0 0 1.83-1.17C16.25 17.75 17 15.1 17 12c0-8-5-10-5-10m1.5 17h-3c-1-2.24-1.5-4.59-1.5-7c0-4.64 1.9-6.8 3-7.67c1.1.87 3 3.03 3 7.67c0 2.41-.5 4.76-1.5 7m6.5 3l-3.86-1.55c.7-1.53 1.2-3.11 1.51-4.72m-9.79 4.72L4 22l2.35-6.27c.31 1.61.81 3.19 1.51 4.72M12 12c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        rodent: {
            body: '<path fill="currentColor" d="M21.33 17.39c1.4 1.27.47 3.61-1.41 3.61h-8.86A5.04 5.04 0 0 1 6 15.94v-.05c-2.3-.47-4-2.48-4-4.89c0-2.75 2.22-5 5-5h2.5c.3 0 .5-.23.5-.5S9.8 5 9.5 5H7V3h2.5C10.88 3 12 4.13 12 5.5C12 6.89 10.88 8 9.5 8H7c-1.66 0-3 1.33-3 3c0 1.37.92 2.5 2.14 2.87c.56-2.2 2.53-3.87 4.92-3.87c.8 0 1.6.22 2.3.55c-1.41.79-2.36 2.25-2.36 3.95c0 1.25.5 2.37 1.33 3.17l.7-.7c-.65-.61-1.03-1.5-1.03-2.47c0-2.59 2.34-3.5 3.5-3.5c2.08 0 3.95 1.89 3.44 4.23l2.39 2.16M18 19c.56 0 1-.44 1-1s-.44-1-1-1s-1 .44-1 1s.44 1 1 1Z"/>'
        },
        "roller-shade": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h20v-2h-2M6 19v-6h5v1.8c-.4.3-.8.8-.8 1.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8c0-.6-.3-1.1-.8-1.4V13h5v6H6Z"/>'
        },
        "roller-shade-closed": {
            body: '<path fill="currentColor" d="M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2M6 19v-2h5v2H6m7 0v-2h5v2h-5Z"/>'
        },
        "roller-skate": {
            body: '<path fill="currentColor" d="M6.5 18C5.1 18 4 19.12 4 20.5S5.1 23 6.5 23S9 21.88 9 20.5S7.86 18 6.5 18m10 0c-1.4 0-2.5 1.12-2.5 2.5s1.1 2.5 2.5 2.5s2.5-1.12 2.5-2.5s-1.14-2.5-2.5-2.5m3.5-1c0-1.37.09-3.19-.5-4.05c-.95-2.05-3.68-2.39-5.59-2.9C13 10 12 9 11.82 8H9a.49.49 0 0 1-.5-.5c0-.28.21-.5.5-.5h2.5V6H9a.49.49 0 0 1-.5-.5c0-.28.21-.5.5-.5h2.5V2H3v15h17Z"/>'
        },
        "roller-skate-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-1.89-1.89c-.17 1.22-1.2 2.16-2.45 2.16c-1.4 0-2.5-1.12-2.5-2.5c0-1.26.93-2.3 2.14-2.47L15.11 17H3V4.9L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M9 5h2.5V2H5.2l3.3 3.32c.09-.19.27-.32.5-.32m3.56 4.36C12.18 9 11.9 8.5 11.82 8h-.62l1.36 1.36m6.94 3.59c-.95-2.05-3.68-2.39-5.59-2.9c-.46-.02-.91-.28-1.31-.65l7.4 7.39c0-1.34.06-3.03-.5-3.84M9.2 6l1 1h1.3V6H9.2M6.5 18C5.1 18 4 19.12 4 20.5S5.1 23 6.5 23S9 21.88 9 20.5S7.86 18 6.5 18Z"/>'
        },
        rollerblade: {
            body: '<path fill="currentColor" d="M4.5 18a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5m14 0a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5m1.5-1c0-1.37.09-3.19-.5-4.05c-.95-2.05-3.68-2.39-5.59-2.9C13 10 12 9 11.82 8H9a.49.49 0 0 1-.5-.5c0-.28.21-.5.5-.5h2.5V6H9a.49.49 0 0 1-.5-.5c0-.28.21-.5.5-.5h2.5V2H3v15h17m-8.5 1a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5Z"/>'
        },
        "rollerblade-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-.52-.52c-.46.48-1.1.79-1.82.79a2.5 2.5 0 0 1-2.5-2.5c0-.72.31-1.36.79-1.82L15.11 17H3V4.9L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27m-1.34-9.78c-.95-2.05-3.68-2.39-5.59-2.9c-.46-.02-.91-.28-1.31-.65l7.4 7.39c0-1.34.06-3.03-.5-3.84M9.2 6l1 1h1.3V6H9.2m3.36 3.36C12.18 9 11.9 8.5 11.82 8h-.62l1.36 1.36M11.5 18a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5M9 5h2.5V2H5.2l3.3 3.32c.09-.19.27-.32.5-.32M4.5 18a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5Z"/>'
        },
        rollupjs: {
            body: '<path fill="currentColor" d="M19.46 8.64c0 2.47-1.35 4.62-3.34 5.76c-.12.1-.19.26-.12.41l3.41 6.74c.09.21-.05.45-.28.45H6.1l.07-.04c.49-.28 3.89-6.99 7.21-10.17c3.32-3.18 3.74-2.12 1.91-5.58c0 0 1.41 2.75.21 2.96c-.94.17-3.1-1.92-2.3-3.8c.8-1.84 3.95-1.49 5.4.01c.55.96.86 2.07.86 3.26m-12.3 4.49c-1.32 2.43-2.16 4.2-2.62 5.44V2.31c0-.17.14-.31.31-.31h8.07a6.62 6.62 0 0 1 5.54 3.15C17.62 4.1 16.3 3.5 15 3.5c-2.47 0-3.09.9-7.84 9.63Z"/>'
        },
        rolodex: {
            body: '<path fill="currentColor" d="M19.89 5H18.5v2a2.5 2.5 0 0 1-5 0V5.25c0-.14-.11-.25-.25-.25h-2.5c-.14 0-.25.11-.25.25V7a2.5 2.5 0 0 1-5 0V5H4.11C3 4.97 2.03 5.87 2 7v12c.03 1.13 1 2.03 2.11 2h15.78c1.11.03 2.08-.87 2.11-2V7c-.03-1.13-1-2.03-2.11-2M7 18H5v-2h2v2m0-4H5v-2h2v2m4 4H9v-2h2v2m0-4H9v-2h2v2m4 4h-2v-2h2v2m0-4h-2v-2h2v2m4 4h-2v-2h2v2m0-4h-2v-2h2v2m-3-6c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1M8 8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1Z"/>'
        },
        "rolodex-outline": {
            body: '<path fill="currentColor" d="M7 18H5v-2h2v2m0-4H5v-2h2v2m4 4H9v-2h2v2m0-4H9v-2h2v2m4 4h-2v-2h2v2m0-4h-2v-2h2v2m4 4h-2v-2h2v2m0-4h-2v-2h2v2m-3-6c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1M8 8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1m11.89-3H18.5v2a2.5 2.5 0 0 1-5 0V5.25c0-.14-.11-.25-.25-.25h-2.5c-.14 0-.25.11-.25.25V7a2.5 2.5 0 0 1-5 0V5H4.11C3 4.97 2.03 5.87 2 7v12c.03 1.13 1 2.03 2.11 2h15.78c1.11.03 2.08-.87 2.11-2V7c-.03-1.13-1-2.03-2.11-2M20 19H4v-8h16v8Z"/>'
        },
        "roman-numeral-1": {
            body: '<path fill="currentColor" d="M14 7v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-10": {
            body: '<path fill="currentColor" d="m9 7l2 5l-2 5h2l1-2.5l1 2.5h2l-2-5l2-5h-2l-1 2.5L11 7H9Z"/>'
        },
        "roman-numeral-2": {
            body: '<path fill="currentColor" d="M11 7v2h-1v6h1v2H7v-2h1V9H7V7h4m6 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-3": {
            body: '<path fill="currentColor" d="M9 7v2H8v6h1v2H5v-2h1V9H5V7h4m5 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4m5 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-4": {
            body: '<path fill="currentColor" d="m12 7l2 10h2l2-10h-2l-1 5l-1-5h-2m-1 0v2h-1v6h1v2H7v-2h1V9H7V7h4Z"/>'
        },
        "roman-numeral-5": {
            body: '<path fill="currentColor" d="m9 7l2 10h2l2-10h-2l-1 5l-1-5H9Z"/>'
        },
        "roman-numeral-6": {
            body: '<path fill="currentColor" d="m6 7l2 10h2l2-10h-2l-1 5l-1-5H6m11 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-7": {
            body: '<path fill="currentColor" d="m4 7l2 10h2l2-10H8l-1 5l-1-5H4m11 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4m5 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-8": {
            body: '<path fill="currentColor" d="m1 7l2 10h2L7 7H5l-1 5l-1-5H1m11 0v2h-1v6h1v2H8v-2h1V9H8V7h4m5 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4m5 0v2h-1v6h1v2h-4v-2h1V9h-1V7h4Z"/>'
        },
        "roman-numeral-9": {
            body: '<path fill="currentColor" d="M11 7v2h-1v6h1v2H7v-2h1V9H7V7h4m1 0l2 5l-2 5h2l1-2.5l1 2.5h2l-2-5l2-5h-2l-1 2.5L14 7h-2Z"/>'
        },
        "room-service": {
            body: '<path fill="currentColor" d="M12 5a2 2 0 0 1 2 2c0 .24-.04.47-.12.69C17.95 8.5 21 11.91 21 16H3c0-4.09 3.05-7.5 7.12-8.31c-.08-.22-.12-.45-.12-.69a2 2 0 0 1 2-2m10 14H2v-2h20v2Z"/>'
        },
        "room-service-outline": {
            body: '<path fill="currentColor" d="M12 5a2 2 0 0 1 2 2c0 .24-.04.47-.12.69C17.95 8.5 21 11.91 21 16H3c0-4.09 3.05-7.5 7.12-8.31c-.08-.22-.12-.45-.12-.69a2 2 0 0 1 2-2m10 14H2v-2h20v2M12 9.5c-3.11 0-5.75 1.89-6.66 4.5h13.32c-.91-2.61-3.55-4.5-6.66-4.5Z"/>'
        },
        "rotate-360": {
            body: '<path fill="currentColor" d="M12 7C6.5 7 2 9.2 2 12c0 2.2 2.9 4.1 7 4.8V20l4-4l-4-4v2.7c-3.2-.6-5-1.9-5-2.7c0-1.1 3-3 8-3s8 1.9 8 3c0 .7-1.5 1.9-4 2.5v2.1c3.5-.8 6-2.5 6-4.6c0-2.8-4.5-5-10-5Z"/>'
        },
        "rotate-3d": {
            body: '<path fill="currentColor" d="M7.47 21.5C4.2 19.94 1.86 16.76 1.5 13H0c.5 6.16 5.66 11 11.95 11l.66-.03l-3.81-3.81l-1.33 1.34m.89-6.54c-.19 0-.36-.03-.52-.08a1.07 1.07 0 0 1-.4-.24c-.11-.1-.2-.22-.26-.37c-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.7.21.95c.14.25.33.5.56.69c.24.18.51.32.82.41c.3.1.62.15.96.15c.37 0 .72-.05 1.03-.15c.32-.1.6-.25.83-.44c.23-.19.42-.41.55-.72c.13-.29.2-.61.2-.97c0-.19-.02-.38-.07-.56c-.05-.16-.12-.35-.23-.51c-.1-.15-.24-.3-.4-.43c-.17-.13-.37-.22-.61-.31a2.067 2.067 0 0 0 .89-.75c.1-.16.17-.3.22-.46c.05-.16.07-.32.07-.48c0-.36-.06-.68-.18-.96c-.14-.26-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.05 8.05 8.71 8 8.34 8c-.34 0-.69.05-1 .16c-.3.11-.57.26-.79.45c-.21.19-.38.39-.51.67c-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45a.94.94 0 0 1 .25-.34c.11-.09.23-.17.38-.22c.15-.05.3-.08.48-.08c.4 0 .7.1.89.31c.19.2.29.49.29.86c0 .18-.04.34-.08.49a.87.87 0 0 1-.25.37c-.11.1-.25.18-.41.24c-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.23.24.29.4c.07.16.1.37.1.57c0 .41-.12.72-.35.93c-.23.23-.55.33-.95.33m8.55-5.92c-.32-.33-.7-.59-1.14-.77c-.43-.18-.92-.27-1.46-.27h-2.36v8h2.3c.55 0 1.06-.09 1.51-.27c.45-.18.84-.43 1.16-.76c.32-.33.58-.73.74-1.19c.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57c-.16-.47-.43-.87-.75-1.2m-.41 3.16c0 .42-.03.8-.12 1.13c-.1.33-.24.62-.43.85c-.19.23-.45.41-.71.53c-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69c.38.46.55 1.12.55 1.99M11.95 0l-.66.03l3.81 3.81l1.33-1.34c3.27 1.56 5.61 4.73 5.96 8.5h1.5c-.5-6.16-5.65-11-11.94-11Z"/>'
        },
        "rotate-3d-variant": {
            body: '<path fill="currentColor" d="M12 5c4.97 0 9 2.69 9 6c0 1.68-1.04 3.2-2.71 4.29c1.07-.87 1.71-1.97 1.71-3.16C20 9.29 16.42 7 12 7v3L8 6l4-4v3m0 14c-4.97 0-9-2.69-9-6c0-1.68 1.04-3.2 2.71-4.29C4.64 9.58 4 10.68 4 11.88C4 14.71 7.58 17 12 17v-3l4 4l-4 4v-3Z"/>'
        },
        "rotate-left": {
            body: '<path fill="currentColor" d="M13 4.07V1L8.45 5.55L13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93M7.1 18.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32M6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47m1.02-4.47L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47Z"/>'
        },
        "rotate-left-variant": {
            body: '<path fill="currentColor" d="M4 2h3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m16 13a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-9v-7h9M14 4a8 8 0 0 1 8 8l-.06 1h-2.02l.08-1a6 6 0 0 0-6-6v3l-4-4l4-4v3Z"/>'
        },
        "rotate-orbit": {
            body: '<path fill="currentColor" d="M8 14.25L4.75 11H7c.25-5.61 2.39-10 5-10c2 0 3.77 2.64 4.55 6.45C20.36 8.23 23 10 23 12c0 1.83-2.17 3.43-5.4 4.3l.29-2.03C19.8 13.72 21 12.91 21 12c0-1.06-1.65-2-4.13-2.5c.08.79.13 1.63.13 2.5c0 6.08-2.24 11-5 11c-1.83 0-3.43-2.17-4.3-5.4l2.03.29C10.28 19.8 11.09 21 12 21c1.66 0 3-4.03 3-9c0-1-.05-1.95-.15-2.85C13.95 9.05 13 9 12 9l-1.86.06l.29-2.01L12 7c.87 0 1.71.05 2.5.13C14 4.65 13.06 3 12 3c-1.54 0-2.82 3.5-3 8h2.25L8 14.25M14.25 16L11 19.25V17c-5.61-.25-10-2.39-10-5c0-1.83 2.17-3.43 5.4-4.3l-.29 2.03C4.2 10.28 3 11.09 3 12c0 1.54 3.5 2.82 8 3v-2.25L14.25 16Z"/>'
        },
        "rotate-right": {
            body: '<path fill="currentColor" d="m16.89 15.5l1.42 1.39c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.5M13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03m6.93-6.9a7.906 7.906 0 0 0-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47m-2.36-5.45L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45Z"/>'
        },
        "rotate-right-variant": {
            body: '<path fill="currentColor" d="M10 4V1l4 4l-4 4V6a6 6 0 0 0-6 6l.08 1H2.06L2 12a8 8 0 0 1 8-8m7-2h3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2M4 15h9v7H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Z"/>'
        },
        "rounded-corner": {
            body: '<path fill="currentColor" d="M19 19h2v2h-2v-2m0-2h2v-2h-2v2M3 13h2v-2H3v2m0 4h2v-2H3v2m0-8h2V7H3v2m0-4h2V3H3v2m4 0h2V3H7v2m8 16h2v-2h-2v2m-4 0h2v-2h-2v2m4 0h2v-2h-2v2m-8 0h2v-2H7v2m-4 0h2v-2H3v2M21 8a5 5 0 0 0-5-5h-5v2h5a3 3 0 0 1 3 3v5h2V8Z"/>'
        },
        router: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8m1-7v3h2l-3 3l-3-3h2v-3m-6 0h3v2l3-3l-3-3v2H5m6 0V8H9l3-3l3 3h-2v3m6 0h-3V9l-3 3l3 3v-2h3"/>'
        },
        "router-network": {
            body: '<path fill="currentColor" d="M5 9c-1.1 0-2 .9-2 2v4a2 2 0 0 0 2 2h6v2h-1c-.55 0-1 .45-1 1H2v2h7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1h7v-2h-7c0-.55-.45-1-1-1h-1v-2h6c1.11 0 2-.89 2-2v-4a2 2 0 0 0-2-2H5m1 3h2v2H6v-2m3.5 0h2v2h-2v-2m3.5 0h2v2h-2v-2Z"/>'
        },
        "router-wireless": {
            body: '<path fill="currentColor" d="m20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3c-1.8 0-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7m-.9.8c-.9-.9-2.1-1.4-3.3-1.4c-1.2 0-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1c.9 0 1.8.3 2.5 1l.8-.8M19 13h-2V9h-2v4H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M8 18H6v-2h2v2m3.5 0h-2v-2h2v2m3.5 0h-2v-2h2v2Z"/>'
        },
        "router-wireless-off": {
            body: '<path fill="currentColor" d="m11.8 5.9l-.8-.8C12.4 3.7 14.2 3 16 3s3.6.7 5 2.1l-.8.8C19 4.8 17.5 4.2 16 4.2s-3 .6-4.2 1.7M21 15c0-1.1-.9-2-2-2h-2V9h-2v2.8l6 6V15m-2.5-7.5l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1c.9 0 1.8.3 2.5 1m3.6 14l-1.3 1.3l-1.7-1.8H5c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6.1L1.1 3l1.3-1.3l19.7 19.8M8 16H6v2h2v-2m3.5 0h-2v2h2v-2m3.5.9l-.9-.9H13v2h2v-1.1Z"/>'
        },
        "router-wireless-settings": {
            body: '<path fill="currentColor" d="M20.2 4.9C19 3.8 17.5 3.2 16 3.2s-3 .6-4.2 1.7l-.8-.8C12.4 2.7 14.2 2 16 2c1.8 0 3.6.7 5 2.1l-.8.8m-.9.8l-.8.8c-.7-.7-1.6-1-2.5-1c-.9 0-1.8.3-2.5 1l-.8-.8c.9-.9 2.1-1.4 3.3-1.4c1.2 0 2.4.5 3.3 1.4M19 12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h10V8h2v4h2M8 17v-2H6v2h2m3.5 0v-2h-2v2h2m3.5 0v-2h-2v2h2m-8 5h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        routes: {
            body: '<path fill="currentColor" d="M11 10H5L3 8l2-2h6V3l1-1l1 1v1h6l2 2l-2 2h-6v2h6l2 2l-2 2h-6v6a2 2 0 0 1 2 2H9a2 2 0 0 1 2-2V10Z"/>'
        },
        "routes-clock": {
            body: '<path fill="currentColor" d="M16.5 13H15v3.69l3.19 1.84l.75-1.3l-2.44-1.41V13M16 9c-1.96 0-3.73.82-5 2.12V7h6l2-2l-2-2h-6V2l-1-1l-1 1v4H3L1 8l2 2h6v10c-1.1 0-2 .9-2 2h5.41c1.05.63 2.28 1 3.59 1c3.87 0 7-3.13 7-7s-3.13-7-7-7m0 11.85c-2.68 0-4.85-2.17-4.85-4.85s2.17-4.85 4.85-4.85s4.85 2.17 4.85 4.85s-2.17 4.85-4.85 4.85Z"/>'
        },
        rowing: {
            body: '<path fill="currentColor" d="M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5M15 1a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m6 20l-3 3l-3-3v-1.5l-7.09-7.09c-.31.05-.61.09-.91.09v-2.18c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.23.43-.38.69-.5c.29-.14.62-.23.96-.23h.03C16 6 17 7 17 8.26V14c0 .85-.35 1.62-.92 2.17l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3Z"/>'
        },
        rss: {
            body: '<path fill="currentColor" d="M6.18 15.64a2.18 2.18 0 0 1 2.18 2.18C8.36 19 7.38 20 6.18 20C5 20 4 19 4 17.82a2.18 2.18 0 0 1 2.18-2.18M4 4.44A15.56 15.56 0 0 1 19.56 20h-2.83A12.73 12.73 0 0 0 4 7.27V4.44m0 5.66a9.9 9.9 0 0 1 9.9 9.9h-2.83A7.07 7.07 0 0 0 4 12.93V10.1Z"/>'
        },
        "rss-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2.5 12A1.5 1.5 0 0 0 6 16.5A1.5 1.5 0 0 0 7.5 18A1.5 1.5 0 0 0 9 16.5A1.5 1.5 0 0 0 7.5 15M6 10v2a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8m0-4v2a10 10 0 0 1 10 10h2A12 12 0 0 0 6 6Z"/>'
        },
        "rss-off": {
            body: '<path fill="currentColor" d="M2.5 3.77L3.78 2.5L21.5 20.22l-1.27 1.28l-1.5-1.5h-2c0-.75-.06-1.5-.19-2.19L6.19 7.46C5.5 7.33 4.75 7.27 4 7.27v-2l-1.5-1.5m3.68 11.87a2.18 2.18 0 0 1 2.18 2.18C8.36 19 7.38 20 6.18 20C5 20 4 19 4 17.82a2.18 2.18 0 0 1 2.18-2.18M4 10.1a9.9 9.9 0 0 1 9.9 9.9h-2.83A7.07 7.07 0 0 0 4 12.93V10.1m5.13-4.79c4.46 1.56 8 5.1 9.56 9.56L9.13 5.31Z"/>'
        },
        rug: {
            body: '<path fill="currentColor" d="M12 14c-1.1 0-2-.89-2-2s.9-2 2-2s2 .9 2 2s-.89 2-2 2m11 5H1v-2h3v-2H1v-2h3v-2H1V9h3V7H1V5h22v2h-3v2h3v2h-3v2h3v2h-3v2h3v2m-11-3.08c.62.7 1.66.89 2.5.41c.84-.48 1.19-1.49.9-2.37c.91-.18 1.6-.99 1.6-1.96s-.69-1.78-1.6-1.96c.29-.88-.06-1.89-.9-2.37c-.84-.48-1.88-.29-2.5.41a1.995 1.995 0 0 0-3.39 1.96C7.69 10.22 7 11.03 7 12s.69 1.78 1.61 1.96A1.995 1.995 0 0 0 12 15.92Z"/>'
        },
        rugby: {
            body: '<path fill="currentColor" d="M16.22 16.22c2.03-2.03 3.11-4.72 3.23-8.02c-1.09 2.41-2.64 4.61-4.64 6.61c-2 2-4.2 3.55-6.61 4.64c3.3-.09 5.96-1.17 8.02-3.23M7.78 7.78C5.75 9.81 4.67 12.5 4.55 15.8c.45-1 1.15-2.15 2.06-3.45c.89-1.3 1.77-2.35 2.58-3.16c2-2 4.2-3.55 6.61-4.64c-3.3.09-5.96 1.17-8.02 3.23M20.5 3.5c.5.55.84 1.61.97 3.2c.12 1.6-.12 3.46-.73 5.6c-.61 2.15-1.63 3.93-3.07 5.37C16.36 19 14.8 19.95 13 20.55c-1.79.61-3.56.92-5.31.92c-2.13 0-3.52-.33-4.19-.97c-.5-.55-.84-1.61-.97-3.2c-.12-1.6.12-3.46.73-5.6c.61-2.15 1.63-3.93 3.07-5.37C7.64 5 9.2 4.05 11 3.45c1.79-.61 3.56-.92 5.31-.92c2.13 0 3.52.33 4.19.97Z"/>'
        },
        ruler: {
            body: '<path fill="currentColor" d="m1.39 18.36l1.77-1.76L4.58 18l1.06-1.05l-1.42-1.41l1.42-1.42l2.47 2.48l1.06-1.06l-2.47-2.48l1.41-1.41l1.42 1.41L10.59 12l-1.42-1.41l1.42-1.42l2.47 2.48l1.06-1.06l-2.47-2.48l1.41-1.41l1.41 1.41l1.07-1.06l-1.42-1.41l1.42-1.42L18 6.7l1.07-1.06l-2.47-2.48l1.76-1.77l4.25 4.25L5.64 22.61l-4.25-4.25Z"/>'
        },
        "ruler-square": {
            body: '<path fill="currentColor" d="M3 5v16h6v-1.5H7V18h2v-1.5H5V15h4v-1.5H7V12h2v-1.5H5V9h4V5h1.5v4H12V7h1.5v2H15V5h1.5v4H18V7h1.5v2H21V3H5a2 2 0 0 0-2 2m3 2a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        "ruler-square-compass": {
            body: '<path fill="currentColor" d="M20 19.88V22l-1.8-1.17l-4.79-9a4.94 4.94 0 0 0 1.78-1M15 7a3 3 0 0 1-3 3a3.27 3.27 0 0 1-.44 0L5.8 20.83L4 22v-2.12L9.79 9A3 3 0 0 1 12 4V2a1 1 0 0 1 1 1v1.18A3 3 0 0 1 15 7m-2 0a1 1 0 1 0-1 1a1 1 0 0 0 1-1m-8.78 3L6 11.8l-1.44 2.76L2.1 12.1m9.9 5.66l-1.5-1.51L9 19l3 3l3-3l-1.47-2.77M19.78 10L18 11.8l1.5 2.76l2.4-2.46Z"/>'
        },
        run: {
            body: '<path fill="currentColor" d="M13.5 5.5c1.09 0 2-.92 2-2a2 2 0 0 0-2-2c-1.11 0-2 .88-2 2c0 1.08.89 2 2 2M9.89 19.38l1-4.38L13 17v6h2v-7.5l-2.11-2l.61-3A7.29 7.29 0 0 0 19 13v-2c-1.91 0-3.5-1-4.31-2.42l-1-1.58c-.4-.62-1-1-1.69-1c-.31 0-.5.08-.81.08L6 8.28V13h2V9.58l1.79-.7L8.19 17l-4.9-1l-.4 2l7 1.38Z"/>'
        },
        "run-fast": {
            body: '<path fill="currentColor" d="M16.5 5.5a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m-3.6 13.9l1-4.4l2.1 2v6h2v-7.5l-2.1-2l.6-3A7.298 7.298 0 0 0 22 13v-2c-1.76.03-3.4-.89-4.3-2.4l-1-1.6c-.36-.6-1-1-1.7-1c-.3 0-.5.1-.8.1L9 8.3V13h2V9.6l1.8-.7l-1.6 8.1l-4.9-1l-.4 2l7 1.4M4 9a1 1 0 0 1-1-1a1 1 0 0 1 1-1h3v2H4m1-4a1 1 0 0 1-1-1a1 1 0 0 1 1-1h5v2H5m-2 8a1 1 0 0 1-1-1a1 1 0 0 1 1-1h4v2H3Z"/>'
        },
        "rv-truck": {
            body: '<path fill="currentColor" d="M20 8h2V6l-2-2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1a3 3 0 0 0 3 3a3 3 0 0 0 3-3h5a3 3 0 0 0 6 0h2v-5M7 18.5a1.5 1.5 0 0 1 0-3a1.5 1.5 0 0 1 0 3M9 12H3V9h6m5 6h-3V9h3m4 9.5a1.5 1.5 0 1 1 1.5-1.5a1.54 1.54 0 0 1-1.5 1.5M17 12V9.5h2.5l2 2.5Z"/>'
        },
        sack: {
            body: '<path fill="currentColor" d="M16 9c4 2 5 9 5 9s1 4-5 4H8c-6 0-5-4-5-4s1-7 5-9m6-5l-2-2l-2 2l-4-2l2 5h8l2-5l-4 2Z"/>'
        },
        "sack-percent": {
            body: '<path fill="currentColor" d="M8 7L6 2l4 2l2-2l2 2l4-2l-2 5H8m8 15H8c-6 0-5-4-5-4s1-7 5-9h8c4 2 5 9 5 9s1 4-5 4m-8.5-9.5A1.5 1.5 0 0 0 9 14a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 9 11a1.5 1.5 0 0 0-1.5 1.5m9 6A1.5 1.5 0 0 0 15 17a1.5 1.5 0 0 0-1.5 1.5A1.5 1.5 0 0 0 15 20a1.5 1.5 0 0 0 1.5-1.5m0-6.15L15.15 11L7.5 18.65L8.87 20l7.63-7.65Z"/>'
        },
        safe: {
            body: '<path fill="currentColor" d="M4 4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2v1h2v-1h11v1h2v-1a2 2 0 0 0 2-2v-1h1v-2h-1V9h1V7h-1V6a2 2 0 0 0-2-2H4m0 2h15v11H4V6m9.5 1.5a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4M5 9v5h2V9H5m8.5.5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "safe-square": {
            body: '<path fill="currentColor" d="M20 2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2h-1v1h-4v-1H9v1H5v-1H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16m-3 10c0-1-.3-2-.8-2.8l1.5-1.5l-1.4-1.4l-1.5 1.5C14 7.3 13 7 12 7c-1 0-2 .3-2.8.8L7.8 6.3L6.3 7.8l1.5 1.5C7.3 10 7 11 7 12c0 1 .3 2 .8 2.8l-1.5 1.5l1.5 1.4l1.5-1.5c.7.5 1.7.8 2.7.8c1 0 2-.3 2.8-.8l1.5 1.5l1.4-1.4l-1.5-1.5c.5-.8.8-1.8.8-2.8m-5-3c1.7 0 3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3s1.3-3 3-3m0 5c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2Z"/>'
        },
        "safe-square-outline": {
            body: '<path fill="currentColor" d="M10 12c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2m-2.2 5.7l-1.5-1.4l1.5-1.5C7.3 14 7 13 7 12c0-1 .3-2 .8-2.7L6.3 7.8l1.5-1.5l1.4 1.5C10 7.3 11 7 12 7c1 0 2 .3 2.8.8l1.5-1.5l1.4 1.4l-1.5 1.5c.5.8.8 1.8.8 2.8c0 1-.3 2-.8 2.8l1.5 1.5l-1.4 1.4l-1.5-1.5c-.8.5-1.8.8-2.8.8c-1 0-2-.3-2.7-.8l-1.5 1.5M12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3s3-1.3 3-3s-1.3-3-3-3m8-7c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2h-1v1h-4v-1H9v1H5v-1H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16m0 18V4H4v16h16Z"/>'
        },
        "safety-goggles": {
            body: '<path fill="currentColor" d="M18 9c1.11 0 2 .89 2 2v3c0 1.11-.89 2-2 2h-2.23l-1.24-1.23c-.75-.77-1.76-1.17-2.83-1.17s-2.07.4-2.83 1.17L7.64 16H6c-1.11 0-2-.89-2-2v-3c0-1.11.89-2 2-2h12m0-2H6a4 4 0 0 0-4 4H1v3h1a4 4 0 0 0 4 4h2.5c.04-.06.09-.12 1.79-1.82c.39-.39.9-.58 1.41-.58c.52 0 1.03.19 1.42.58L14.91 18H18a4 4 0 0 0 4-4h1v-3h-1a4 4 0 0 0-4-4Z"/>'
        },
        "safety-googles": {
            body: '<path d="M18.006 9c1.1 0 1.994.894 1.994 2v3.006c0 1.1-.894 1.994-1.994 1.994h-2.238l-1.234-1.234a3.978 3.978 0 0 0-2.832-1.171a3.977 3.977 0 0 0-2.832 1.171L7.636 16H5.994C4.894 16 4 15.106 4 14v-3.006C4 9.894 4.894 9 5.994 9h12.012m0-2H5.994A4.005 4.005 0 0 0 2 10.994V11H1v3h1v.006A4.005 4.005 0 0 0 5.994 18h2.503c.046-.058.088-.12 1.788-1.82a2 2 0 0 1 1.418-.585a2 2 0 0 1 1.418.585L14.909 18h3.098A4.005 4.005 0 0 0 22 14.006V14h1v-3h-1v-.006A4.005 4.005 0 0 0 18.006 7z" fill="currentColor"/>',
            hidden: true
        },
        "sail-boat": {
            body: '<path fill="currentColor" d="m3 13.5l8-11.47V13.5H3m9.5 0c1.35-3.75 1.17-8.79 0-12.5c4.76 1.54 8.4 7.4 8.46 12.5H12.5m8.6 3.58c-.41.64-.89 1.19-1.45 1.66c-.65-.29-1.23-.74-1.69-1.24c-1.49 1.93-4.5 1.93-5.99 0c-1.47 1.93-4.5 1.93-5.97 0c-.5.5-1.05.95-1.7 1.24c-1.14-.94-2-2.28-2.3-3.74h19.94a6.41 6.41 0 0 1-.84 2.08M20.96 23c-1.06 0-2.06-.25-3-.75c-1.84 1-4.15 1-5.99 0c-1.84 1-4.15 1-5.97 0c-1.23.69-2.64.8-4 .75v-2c1.41.05 2.77-.1 4-1c1.74 1.25 4.21 1.25 5.97 0c1.77 1.25 4.23 1.25 5.99 0c1.21.9 2.58 1.05 3.98 1v2h-.98Z"/>'
        },
        "sail-boat-sink": {
            body: '<path fill="currentColor" d="M20.96 21c-1.06 0-2.06-.26-3-.76c-1.84 1-4.15 1-5.99 0c-1.84 1-4.15 1-5.97 0c-1.23.69-2.64.8-4 .76v-2c1.41.04 2.77-.11 4-1c1.74 1.24 4.21 1.24 5.97 0c1.77 1.24 4.23 1.24 5.99 0c1.21.89 2.58 1.04 3.98 1v2h-.98M22 3.5L7.11 5.96l6 6.21L22 3.5M10.81 16.36l1.16-.82l1.15.82c.53.36 1.18.57 1.85.57c.15 0 .31-.02.46-.04L5.2 6.31C4.29 7.65 3.9 9.32 4 10.92l5.74 5.91c.39-.09.76-.25 1.07-.47Z"/>'
        },
        sale: {
            body: '<path fill="currentColor" d="m18.65 2.85l.61 3.86l3.51 1.79L21 12l1.78 3.5l-3.54 1.79l-.61 3.86l-3.89-.61l-2.77 2.76l-2.78-2.8l-3.86.64l-.62-3.89l-3.49-1.78L3 11.97L1.23 8.5l3.51-1.81l.61-3.83l3.87.64L12 .69l2.77 2.77l3.88-.61M9.5 7A1.5 1.5 0 0 0 8 8.5A1.5 1.5 0 0 0 9.5 10A1.5 1.5 0 0 0 11 8.5A1.5 1.5 0 0 0 9.5 7m5 7a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m-6.09 3L17 8.41L15.59 7L7 15.59L8.41 17Z"/>'
        },
        "sale-outline": {
            body: '<path fill="currentColor" d="M9.5 7c.83 0 1.5.67 1.5 1.5S10.33 10 9.5 10S8 9.33 8 8.5S8.67 7 9.5 7m5 7c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m-6.09 3L7 15.59L15.59 7L17 8.41L8.41 17M18.65 2.85l.61 3.86l3.51 1.79L21 12l1.78 3.5l-3.54 1.79l-.61 3.86l-3.89-.61l-2.77 2.77l-2.78-2.81l-3.86.64l-.62-3.89l-3.49-1.78L3 11.97L1.23 8.5l3.51-1.81l.61-3.82l3.87.63L12 .695l2.76 2.765l3.89-.61m1.45 6.52L17.5 8L17 5.11l-2.9.42L12 3.5L9.9 5.53L7 5.11L6.5 8L3.9 9.37L5.2 12l-1.3 2.63L6.5 16l.5 2.89l2.9-.42L12 20.5l2.1-2.03l2.9.42l.5-2.89l2.6-1.37L18.8 12l1.3-2.63Z"/>'
        },
        salesforce: {
            body: '<path fill="currentColor" d="M18.38 6.37c-.7 0-1.31.21-1.91.41c-.7-1.21-2.01-2.01-3.42-2.01c-1.1 0-2.1.5-2.81 1.2c-.8-1-2.01-1.71-3.41-1.71C4.5 4.26 2.5 6.17 2.5 8.5c0 .59.21 1.19.41 1.79A3.678 3.678 0 0 0 1 13.5c0 2 1.61 3.72 3.62 3.72c.3 0 .6 0 .8-.1c.4 1.51 1.91 2.62 3.72 2.62c1.7 0 3.11-1.01 3.61-2.42c.51.21 1.01.41 1.51.41c1.31 0 2.51-.73 3.11-1.81c.31.08.63.08.91.08c2.61 0 4.72-2.09 4.72-4.8c.1-2.7-2-4.83-4.62-4.83Z"/>'
        },
        sass: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m-2 13.33c.16.54.14 1.04 0 1.5c0 .05-.04.1-.06.17c-.02 0-.04.07-.07.12c-.11.24-.27.47-.46.67c-.58.64-1.41.88-1.74.68c-.38-.22-.17-1.12.49-1.83c.72-.76 1.76-1.26 1.76-1.26l.08-.05m8.27-9.05c-.45-1.78-3.4-2.36-6.18-1.37c-1.66.59-3.46 1.51-4.75 2.72c-1.53 1.44-1.78 2.69-1.68 3.21c.34 1.84 2.88 3.05 3.92 3.94v.01c-.3.15-2.54 1.28-3.08 2.44c-.54 1.22.1 2.1.5 2.22c1.34.36 2.69-.29 3.41-1.38c.7-1.04.65-2.39.34-3.07c.42-.1.91-.15 1.53-.08c1.76.21 2.1 1.3 2.03 1.76c-.06.46-.43.71-.55.79c-.12.07-.16.1-.15.16c.01.08.07.08.17.06c.15-.03.93-.37.96-1.22c.04-1.08-.99-2.28-2.81-2.25c-.75.02-1.22.09-1.56.22l-.08-.09c-1.13-1.2-3.21-2.05-3.12-3.67c.03-.59.23-2.13 4-4.01c3.08-1.54 5.55-1.12 5.98-.17c.61 1.33-1.32 3.82-4.52 4.18c-1.22.14-1.87-.34-2.03-.51c-.17-.17-.19-.2-.25-.17c-.11.07-.04.23 0 .33c.09.25.49.67 1.15.91c.59.19 2.03.3 3.76-.37c1.94-.75 3.46-2.84 3.01-4.59Z"/>'
        },
        satellite: {
            body: '<path fill="currentColor" d="m5 18l3.5-4.5l2.5 3l3.5-4.5l4.5 6M5 12v-2a5 5 0 0 0 5-5h2a7 7 0 0 1-7 7m0-7h3a3 3 0 0 1-3 3m14-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "satellite-uplink": {
            body: '<path fill="currentColor" d="m11.86 2l-.52 1.93c4.41.85 7.86 4.3 8.71 8.72l1.95-.52C20.95 7.03 16.96 3.04 11.86 2m-1.04 3.86l-.52 1.95c3.04.46 5.42 2.84 5.88 5.87l1.94-.52c-.66-3.72-3.57-6.66-7.3-7.3m-7.1 3.83A7.96 7.96 0 0 0 5 18.28V22h3v-1.59c.95.39 1.97.59 3 .59c1.14 0 2.27-.25 3.3-.72L3.72 9.69m6.07.07l-.53 1.96a3 3 0 0 1 3 3l1.97-.52c-.23-2.34-2.1-4.2-4.44-4.44Z"/>'
        },
        "satellite-variant": {
            body: '<path fill="currentColor" d="m11.62 1l5.66 5.67l-2.12 2.12l-2.12-2.12l-1.42 1.42l2.33 2.32l-1.16 1.17l.45.46a2.5 2.5 0 0 1 2.83.5l-3.53 3.53a2.5 2.5 0 0 1-.5-2.83l-.46-.45l-1.17 1.16l-2.32-2.33l-1.42 1.42l2.12 2.12l-2.12 2.12L1 11.62L3.14 9.5l2.12 2.12l1.41-1.41l-2.83-2.83c-.78-.78-.78-2.05 0-2.83l.71-.71c.78-.78 2.05-.78 2.83 0l2.83 2.83l1.41-1.41L9.5 3.14L11.62 1M18 14a4 4 0 0 1-4 4v-2a2 2 0 0 0 2-2h2m4 0a8 8 0 0 1-8 8v-2a6 6 0 0 0 6-6h2Z"/>'
        },
        sausage: {
            body: '<path fill="currentColor" d="M19 5.3c1.2.5 2 1.8 2 3.2C21 15.4 15.4 21 8.5 21c-1.4 0-2.6-.8-3.2-2L3 20.5v-6L5.3 16c.6-1.2 1.8-2 3.2-2c3 0 5.5-2.5 5.5-5.5c0-1.4.8-2.6 2-3.2L14.5 3h6L19 5.3Z"/>'
        },
        "sausage-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-4.5-4.5c-2.1 1.7-4.9 2.8-7.8 2.8c-1.4 0-2.6-.8-3.2-2L3 20.5v-6L5.3 16c.5-1.2 1.8-2 3.2-2c1 0 2-.3 2.8-.8L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M21 8.5c0-1.4-.8-2.6-2-3.2L20.5 3h-6L16 5.3c-1.2.5-2 1.8-2 3.2c0 .7-.1 1.3-.4 1.9l5.1 5.2c1.5-2 2.3-4.5 2.3-7.1Z"/>'
        },
        "saw-blade": {
            body: '<path fill="currentColor" d="M20 15s-1.4 1.3 1.1 2l-2.8 2.8h-2.8s-1.9-.1-.5 2.2h-4l-2-2s-1.3-1.4-2 1.1l-2.8-2.8v-2.8s.1-1.9-2.2-.5v-4l2-2s1.4-1.3-1.2-1.9l2.8-2.9h2.9s1.9.1.5-2.2h4l2 2s1.3 1.4 2-1.2l2.8 2.8v2.9s-.1 1.9 2.2.5v4l-2 2m-6-3a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2Z"/>'
        },
        "sawtooth-wave": {
            body: '<path fill="currentColor" d="M11 22V6.83L2 16v-2.83L13 2v15.17L22 8v2.83L11 22Z"/>'
        },
        saxophone: {
            body: '<path fill="currentColor" d="M4 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a3 3 0 0 1 3 3v8.5c0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5V13a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1a1 1 0 0 0 1 1v2a1 1 0 0 1-1 1a1 1 0 0 1-1-1v-4a1 1 0 0 0 1-1a1 1 0 0 0-1-1V8a1 1 0 0 0 1-1a1 1 0 0 0-1-1v-.5A3.5 3.5 0 0 0 8.5 2H4Z"/>'
        },
        scale: {
            body: '<path fill="currentColor" d="m8.46 15.06l-1.41 1.41l-1.37-1.37A7.941 7.941 0 0 0 4.06 19H6v2H2v-1c0-4.84 3.44-8.87 8-9.8v-2L2 5V3h20v2l-8 3.2v2c4.56.93 8 4.96 8 9.8v1h-4v-2h1.94a7.941 7.941 0 0 0-1.62-3.9l-1.37 1.37l-1.41-1.41l1.37-1.38A7.976 7.976 0 0 0 13 12.06V14h-2v-1.94c-1.46.18-2.8.76-3.91 1.62l1.37 1.38M12 18a2 2 0 0 1 2 2a2 2 0 0 1-2 2c-.32 0-.62-.07-.88-.21L7.27 20l3.85-1.79c.26-.14.56-.21.88-.21Z"/>'
        },
        "scale-balance": {
            body: '<path fill="currentColor" d="M12 3c-1.27 0-2.4.8-2.82 2H3v2h1.95L2 14c-.47 2 1 3 3.5 3s4.06-1 3.5-3L6.05 7h3.12c.33.85.98 1.5 1.83 1.83V20H2v2h20v-2h-9V8.82c.85-.32 1.5-.97 1.82-1.82h3.13L15 14c-.47 2 1 3 3.5 3s4.06-1 3.5-3l-2.95-7H21V5h-6.17C14.4 3.8 13.27 3 12 3m0 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-6.5 5.25L7 14H4l1.5-3.75m13 0L20 14h-3l1.5-3.75Z"/>'
        },
        "scale-bathroom": {
            body: '<path fill="currentColor" d="M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m7 2a4 4 0 0 0-4 4h3.26l-.41-2.77L12.9 8H16a4 4 0 0 0-4-4m-7 6v10h14V10H5Z"/>'
        },
        "scale-off": {
            body: '<path fill="currentColor" d="m22.11 21.46l-1.27 1.27L19.11 21H18v-1.11L12.11 14H11v-1.11l-.69-.69a7.92 7.92 0 0 0-3.22 1.48l1.37 1.38l-1.41 1.41l-1.37-1.37A7.94 7.94 0 0 0 4.06 19H6v2H2v-1a10 10 0 0 1 6.68-9.43L3.85 5.74L2 5V3.89L1.11 3l1.28-1.27m19.52 16.98A10 10 0 0 0 14 10.2v-2L22 5V3H6.2M12 18a1.84 1.84 0 0 0-.88.21L7.27 20l3.85 1.79A1.84 1.84 0 0 0 12 22a2 2 0 0 0 0-4Z"/>'
        },
        "scale-unbalanced": {
            body: '<path fill="currentColor" d="M13 20V8.8c.5-.2 1-.5 1.3-.9l3.5 1.3l-2.9 6.8c-.5 2 1 3 3.5 3s4.1-1 3.5-3l-2.6-6.3l.9.3l.7-1.9L15 6c0-1.2-.7-2.4-2-2.9c-1.2-.5-2.5 0-3.3.9L3.9 2l-.7 1.8l1.6.6L2.1 11c-.5 2 1 3 3.5 3s4.1-1 3.5-3L6.6 5.1L9 6c0 1.2.7 2.4 2 2.9V20H2v2h20v-2h-9m6.9-4h-3l1.5-3.8l1.5 3.8M7.1 11h-3l1.5-3.8L7.1 11m4-5.3c.2-.5.8-.8 1.3-.6s.8.8.6 1.3s-.8.8-1.3.6s-.8-.8-.6-1.3Z"/>'
        },
        "scan-helper": {
            body: '<path fill="currentColor" d="M0 2a2 2 0 0 1 2-2h4v2H2v4H0V2m24 20a2 2 0 0 1-2 2h-4v-2h4v-4h2v4M2 24a2 2 0 0 1-2-2v-4h2v4h4v2H2M22 0a2 2 0 0 1 2 2v4h-2V2h-4V0h4Z"/>'
        },
        scanner: {
            body: '<path fill="currentColor" d="M4.2 10.7L19.8 5l.7 1.9L6.4 12H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5.5c0-.8.5-1.6 1.2-1.8M17 17h2v-2h-2v2M5 17h10v-2H5v2Z"/>'
        },
        "scanner-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-2-2H5a2 2 0 0 1-2-2v-5.5c0-.8.5-1.6 1.2-1.8l2.37-.86L2 5.27M6.4 12h2.33l-.62-.62L6.4 12M5 15v2h8.73l-2-2H5M19.8 5l.7 1.9l-8.65 3.13l-1.55-1.56L19.8 5m-.8 7a2 2 0 0 1 2 2v4c0 .34-.09.66-.24.94L19 17.18V15h-2.18l-3-3H19Z"/>'
        },
        "scatter-plot": {
            body: '<path fill="currentColor" d="M7 11a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m4-8a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m5.6 11.6c1.65 0 3 1.34 3 3a3 3 0 0 1-3 3c-1.66 0-3-1.35-3-3a3 3 0 0 1 3-3Z"/>'
        },
        "scatter-plot-outline": {
            body: '<path fill="currentColor" d="M7 18a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m0-6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m4-2a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m0-6a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m5.6 17.6c-2.21 0-4-1.79-4-4a4 4 0 0 1 4-4c2.21 0 4 1.79 4 4a4 4 0 0 1-4 4m0-6a2 2 0 0 0-2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1-.9-2-2-2Z"/>'
        },
        scent: {
            body: '<path fill="currentColor" d="M17.5 5.1C18.5 6.4 19 7.6 19 9c0 1.7-.7 3.3-2.4 5.1c-1.9 2-3.6 4.2-3.6 6.4c0 .4.1.8.2 1.3c0 .1 0 .2-.1.3c-.1.1-.2 0-.2-.1c-1-1.3-1.5-2.5-1.5-3.9c0-1.7.7-3.3 2.4-5.1c1.9-2 3.6-4.2 3.6-6.4c0-.4-.1-.8-.2-1.3c0-.1 0-.2.1-.3c.1 0 .1 0 .2.1m-7.8-3c.7.9 1 1.9 1 2.8c0 1.3-.6 2.5-1.8 3.8c-1.4 1.5-2.7 3.2-2.7 4.8c0 .3.1.7.2.9c0 .1 0 .1-.1.2s-.2 0-.2 0c-.8-1-1.1-2-1.1-2.9c0-1.3.6-2.5 1.8-3.8c1.4-1.5 2.7-3.2 2.7-4.8c0-.3-.1-.7-.2-.9V2c.2 0 .3 0 .4.1m.4 7.8c1.9-2 3.6-4.2 3.6-6.4c0-.4-.1-.8-.2-1.3c0-.1 0-.2.1-.3c.1-.1.2 0 .2.1c1 1.3 1.5 2.5 1.5 3.9c0 1.7-.7 3.3-2.4 5.1c-1.9 2-3.6 4.2-3.6 6.4c0 .4.1.8.2 1.3c0 .1 0 .2-.1.3c-.1.1-.2 0-.2-.1c-1-1.3-1.5-2.5-1.5-3.9c0-1.7.7-3.3 2.4-5.1Z"/>'
        },
        "scent-off": {
            body: '<path fill="currentColor" d="M14.6 16.5c-.9 1.3-1.6 2.7-1.6 4c0 .4.1.8.2 1.3c0 .1 0 .2-.1.3c-.1.1-.2 0-.2-.1c-1-1.3-1.5-2.5-1.5-3.9c0-1.2.4-2.4 1.2-3.6l-1.4-1.4c-1.1 1.4-1.8 2.9-1.8 4.4c0 .4.1.8.2 1.3c0 .1 0 .2-.1.3c-.1.1-.2 0-.2-.1c-1-1.3-1.5-2.5-1.5-3.9c0-1.3.5-2.6 1.5-4L7.9 9.8c-1 1.2-1.7 2.4-1.7 3.6c0 .3.1.7.2.9c0 .1 0 .1-.1.2s-.2 0-.2 0c-.8-.9-1.1-1.9-1.1-2.8c0-1.1.5-2.2 1.4-3.3L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3l-6.2-6.2M10.2 7c.4-.7.6-1.4.6-2.1c0-.9-.3-1.9-1.1-2.8c-.1-.1-.2-.1-.3-.1c-.1 0 0 .1 0 .2c.1.3.2.6.2.9c0 .8-.3 1.6-.8 2.4L10.2 7m7.1-.5c0 1.7-1.1 3.5-2.5 5.1l2 2c1.5-1.5 2.2-3 2.2-4.6c0-1.3-.5-2.6-1.5-3.9c-.1-.1-.1-.1-.2-.1c-.1.1-.1.2-.1.3c0 .4.1.8.1 1.2m-3.8 3.8c1.2-1.5 1.8-2.9 1.8-4.4c0-1.3-.5-2.6-1.5-3.9h-.2c-.1.1-.1.2-.1.3c.1.4.2.8.2 1.3c0 1.6-.9 3.2-2.2 4.8l2 1.9Z"/>'
        },
        school: {
            body: '<path fill="currentColor" d="M12 3L1 9l11 6l9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82Z"/>'
        },
        "school-outline": {
            body: '<path fill="currentColor" d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3m6.82 6L12 12.72L5.18 9L12 5.28L18.82 9M17 16l-5 2.72L7 16v-3.73L12 15l5-2.73V16Z"/>'
        },
        "scissors-cutting": {
            body: '<path fill="currentColor" d="M11 21H7v-2h4v2m4.5-2H17v2h-4v-2h.2l-1.4-6.1l-2.5.6c-.1.5-.3.9-.5 1.3c-.9 1.5-2.8 1.9-4.3 1c-1.5-.9-1.9-2.8-1-4.3c.9-1.5 2.8-1.9 4.3-1c.4.2.7.6.9.9l2.5-.6l-.6-2.5c-.4-.1-.8-.3-1.2-.5C8 6.9 7.5 5 8.4 3.5c.9-1.5 2.8-1.9 4.3-1c1.5.9 1.9 2.8 1 4.3c-.2.4-.6.7-.9.9L15.5 19M7 11.8c-.7-.5-1.7-.2-2.2.5c-.5.7-.2 1.7.5 2.1c.7.5 1.7.3 2.2-.5c.4-.7.2-1.7-.5-2.1M12.4 6c.5-.7.2-1.7-.5-2.2c-.7-.5-1.7-.2-2.2.5c-.4.7-.2 1.7.6 2.2c.7.4 1.7.2 2.1-.5m.4 5.3c-.2-.1-.4-.1-.5.1c-.1.2-.1.4.1.5c.2.1.4.1.5-.1c.2-.2.1-.4-.1-.5M21 8.5L14.5 10l.5 2.2l7.5-1.8l.5-.7l-2-1.2M23 19h-4v2h4v-2M5 19H1v2h4v-2Z"/>'
        },
        scooter: {
            body: '<path fill="currentColor" d="M7.82 19H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0 0 15.89 4H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0 0 13.09 17H7.82a2.996 2.996 0 0 0-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 0 0 5 21c1.3 0 2.4-.84 2.82-2M5 19c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m14-4c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "scooter-electric": {
            body: '<path fill="currentColor" d="M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0 0 15.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0 0 13.09 14H7.82a2.996 2.996 0 0 0-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 0 0 5 18c1.3 0 2.4-.84 2.82-2M5 16c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m14-4c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m-8 4H7l6 3v-2h4l-6-3v2Z"/>'
        },
        scoreboard: {
            body: '<path fill="currentColor" d="M6 9h2v6H6V9m10 0h2v6h-2V9m5-6c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h18M5 7c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1H5m10 0c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1h-4m-3 4c.6 0 1-.4 1-1s-.4-1-1-1s-1 .4-1 1s.4 1 1 1m0 4c.6 0 1-.4 1-1s-.4-1-1-1s-1 .4-1 1s.4 1 1 1Z"/>'
        },
        "scoreboard-outline": {
            body: '<path fill="currentColor" d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H3V5h18M5 7h4c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1m1 2v6h2V9m7-2h4c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1m1 2v6h2V9m-6 2c.6 0 1-.4 1-1s-.4-1-1-1s-1 .4-1 1s.4 1 1 1m0 4c.6 0 1-.4 1-1s-.4-1-1-1s-1 .4-1 1s.4 1 1 1Z"/>'
        },
        "screen-rotation": {
            body: '<path fill="currentColor" d="M7.5 21.5c-3.25-1.56-5.59-4.74-5.95-8.5H.05C.56 19.16 5.71 24 12 24l.66-.03l-3.81-3.81m5.98 1.03L2.81 9.17l6.36-6.36l12.02 12.02M10.23 1.75a1.49 1.49 0 0 0-2.12 0L1.75 8.11a1.49 1.49 0 0 0 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75m6.27.75c3.25 1.57 5.59 4.74 5.95 8.5h1.5C23.44 4.84 18.29 0 12 0l-.66.03l3.81 3.81L16.5 2.5Z"/>'
        },
        "screen-rotation-lock": {
            body: '<path fill="currentColor" d="M16.8 2.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5M16 9h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1v-.5A2.5 2.5 0 0 0 18.5 0A2.5 2.5 0 0 0 16 2.5V3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1M8.47 20.5C5.2 18.94 2.86 15.76 2.5 12H1c.5 6.16 5.66 11 11.95 11l.66-.03l-3.81-3.82l-1.33 1.35m14.78-7.73l-2.57-2.57l-1.41 1.41l2.23 2.22l-5.67 5.67L4.5 8.17l5.67-5.67l2.1 2.11l1.41-1.41L11.23.75a1.49 1.49 0 0 0-2.12 0L2.75 7.11a1.49 1.49 0 0 0 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12Z"/>'
        },
        "screw-flat-top": {
            body: '<path fill="currentColor" d="M13.5 17v2L12 22l-1.5-3l3-2m1-10.7l-1 .7V6h-3v3l-1 .7v1l5-3.3V6.3m0 4l-1 .7V9l-3 2v2l-1 .7v1l5-3.3v-1.1m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1M8 2S7 2 7 3l3 2h4l3-2s0-1-1-1H8Z"/>'
        },
        "screw-lag": {
            body: '<path fill="currentColor" d="m10 19.3l4-2.7V20l-2 2l-2-2v-.7m4-6.6l-4 2.7v2L9 18v1l6-3.9V14l-1 .7v-2M7 2v3h10V2H7m2 4v3l1 .7v3.7L9 14v1l6-3.9V10l-1 .7v-1l1-.7V6H9Z"/>'
        },
        "screw-machine-flat-top": {
            body: '<path fill="currentColor" d="m14.5 7.3l-1 .7V7h-3v3l-1 .7v1l5-3.3V7.3m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1M8 3S7 3 7 4l3 2h4l3-2s0-1-1-1H8m5.5 15v3h-3v-1l3-2Z"/>'
        },
        "screw-machine-round-top": {
            body: '<path fill="currentColor" d="m14.5 7.3l-1 .7V7h-3v3l-1 .7v1l5-3.3V7.3m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1M7 6h10s-1-3-5-3s-5 3-5 3m6.5 12v3h-3v-1l3-2Z"/>'
        },
        "screw-round-top": {
            body: '<path fill="currentColor" d="M13.5 17v2L12 22l-1.5-3l3-2m1-10.7l-1 .7V6h-3v3l-1 .7v1l5-3.3V6.3m0 4l-1 .7V9l-3 2v2l-1 .7v1l5-3.3v-1.1m0 4l-1 .7v-2l-3 2v2l-1 .7v1l5-3.3v-1.1M7 5h10s-1-3-5-3s-5 3-5 3Z"/>'
        },
        screwdriver: {
            body: '<path fill="currentColor" d="M18 1.83c-.5 0-1 .17-1.41.58L8 11l1.5 1.5L6 16H4l-2 4l2 2l4-2v-2l3.5-3.5L13 16l8.59-8.59c.62-.91.78-2.04 0-2.82l-2.18-2.18A1.95 1.95 0 0 0 18 1.83M18 4l2 2l-7 7l-2-2l7-7Z"/>'
        },
        script: {
            body: '<path fill="currentColor" d="M17.8 20c-.4 1.2-1.5 2-2.8 2H5c-1.7 0-3-1.3-3-3v-1h12.2c.4 1.2 1.5 2 2.8 2h.8M19 2H8C6.3 2 5 3.3 5 5v11h11v1c0 .6.4 1 1 1h1V5c0-.6.4-1 1-1s1 .4 1 1v1h2V5c0-1.7-1.3-3-3-3Z"/>'
        },
        "script-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0 1-1V4H8a1 1 0 0 0-1 1v11H5V5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v1h-2V5a1 1 0 0 0-1-1a1 1 0 0 0-1 1v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-1h11a2 2 0 0 0 2 2Z"/>'
        },
        "script-text": {
            body: '<path fill="currentColor" d="M17.8 20c-.4 1.2-1.5 2-2.8 2H5c-1.7 0-3-1.3-3-3v-1h12.2c.4 1.2 1.5 2 2.8 2h.8M19 2c1.7 0 3 1.3 3 3v1h-2V5c0-.6-.4-1-1-1s-1 .4-1 1v13h-1c-.6 0-1-.4-1-1v-1H5V5c0-1.7 1.3-3 3-3h11M8 6v2h7V6H8m0 4v2h6v-2H8Z"/>'
        },
        "script-text-key": {
            body: '<path fill="currentColor" d="M17.8 19c-.4-1.2-1.5-2-2.8-2c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H19v2h2v-2h2v-2h-5.2M15 21.3c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3s1.3.6 1.3 1.3s-.6 1.3-1.3 1.3m0-6.3c1.1 0 2.2.4 3 1V5c0-.6.4-1 1-1s1 .4 1 1v1h2V5c0-1.7-1.3-3-3-3H8C6.3 2 5 3.3 5 5v11h7c.8-.6 1.9-1 3-1M8 6h7v2H8V6m0 4h6v2H8v-2m2.4 12H5c-1.7 0-3-1.3-3-3v-1h8.4c-.3.6-.4 1.3-.4 2s.1 1.4.4 2"/>'
        },
        "script-text-key-outline": {
            body: '<path fill="currentColor" d="M17.8 19c-.4-1.2-1.5-2-2.8-2c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H19v2h2v-2h2v-2h-5.2M15 21.3c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3s1.3.6 1.3 1.3s-.6 1.3-1.3 1.3M9 10h5v2H9v-2m0-4h5v2H9V6M7 5c0-.6.4-1 1-1h8v11.1c.7.2 1.4.5 2 .9V5c0-.6.4-1 1-1s1 .4 1 1v1h2V5c0-1.7-1.3-3-3-3H8C6.3 2 5 3.3 5 5v11h2V5m3 15c0-.7.1-1.4.4-2H2v1c0 1.7 1.3 3 3 3h5.4c-.3-.6-.4-1.3-.4-2m-1-4h3c.6-.4 1.3-.8 2-.9V14H9v2Z"/>'
        },
        "script-text-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0 1-1V4H8a1 1 0 0 0-1 1v11H5V5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v1h-2V5a1 1 0 0 0-1-1a1 1 0 0 0-1 1v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-1h11a2 2 0 0 0 2 2M9 6h5v2H9V6m0 4h5v2H9v-2m0 4h5v2H9v-2Z"/>'
        },
        "script-text-play": {
            body: '<path fill="currentColor" d="M13.8 22H5c-1.7 0-3-1.3-3-3v-1h11.1c-.1.3-.1.7-.1 1c0 1.1.3 2.1.8 3m0-6H5V5c0-1.7 1.3-3 3-3h11c1.7 0 3 1.3 3 3v1h-2V5c0-.6-.4-1-1-1s-1 .4-1 1v8.1c-1.8.3-3.3 1.4-4.2 2.9M8 8h7V6H8v2m0 4h6v-2H8v2m9 4v6l5-3l-5-3Z"/>'
        },
        "script-text-play-outline": {
            body: '<path fill="currentColor" d="M9 14h5v1.7c-.1.1-.1.2-.2.3H9v-2m0-2h5v-2H9v2m0-4h5V6H9v2M7 5c0-.6.4-1 1-1h8v9.8c.6-.4 1.3-.6 2-.7V5c0-.6.4-1 1-1s1 .4 1 1v1h2V5c0-1.7-1.3-3-3-3H8C6.3 2 5 3.3 5 5v11h2V5m6 14v-1H2v1c0 1.7 1.3 3 3 3h8.8c-.5-.9-.8-1.9-.8-3m4-3v6l5-3l-5-3Z"/>'
        },
        sd: {
            body: '<path fill="currentColor" d="M18 8h-2V4h2m-3 4h-2V4h2m-3 4h-2V4h2m6-2h-8L4 8v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        seal: {
            body: '<path fill="currentColor" d="M20.39 19.37L16.38 18L15 22l-3.08-6L9 22l-1.38-4l-4.01 1.37l2.92-6A6.97 6.97 0 0 1 5 9a7 7 0 0 1 7-7a7 7 0 0 1 7 7c0 1.65-.57 3.17-1.53 4.37l2.92 6M7 9l2.69 1.34l-.19 3l2.5-1.66l2.5 1.65l-.17-2.99L17 9l-2.68-1.35l.18-2.98L12 6.31L9.5 4.65l.17 3.01L7 9Z"/>'
        },
        "seal-variant": {
            body: '<path fill="currentColor" d="M17.71 6.15c-.25-.77-.92-.94-1.26-1.38c-.31-.46-.27-1.15-.92-1.62s-1.3-.23-1.83-.38S12.81 2 12 2s-1.18.58-1.7.77s-1.17-.1-1.83.38s-.61 1.16-.92 1.62c-.34.44-1 .61-1.26 1.38S6.5 7.45 6.5 8S6 9.08 6.29 9.85s.92.94 1.26 1.38c.31.46.27 1.15.92 1.62s1.3.23 1.83.38s.89.77 1.7.77s1.18-.58 1.7-.77s1.17.1 1.83-.38s.61-1.16.92-1.62c.34-.44 1-.61 1.26-1.38S17.5 8.55 17.5 8s.5-1.08.21-1.85M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4m2-4a2 2 0 1 1-2-2a2 2 0 0 1 2 2m-.29 7.56l-.63 3.6l-.73 4.13l-2.61-2.49l-3.3 1.45l1.33-7.5a4 4 0 0 0 1.89.42a4.15 4.15 0 0 0 1.34.68a3.32 3.32 0 0 0 1 .15a3.5 3.5 0 0 0 1.71-.44m4.21 3.22l-2.58-.92l.51-2.94a3.2 3.2 0 0 0 .85-.45l.12-.1Z"/>'
        },
        "search-web": {
            body: '<path fill="currentColor" d="m15.5 14l5 5l-1.5 1.5l-5-5v-.79l-.27-.28A6.471 6.471 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79m-6-9.5l-.55.03c-.24.52-.61 1.4-.88 2.47h2.86c-.27-1.07-.64-1.95-.88-2.47c-.18-.03-.36-.03-.55-.03M13.83 7a4.943 4.943 0 0 0-2.68-2.22c.24.53.55 1.3.78 2.22h1.9M5.17 7h1.9c.23-.92.54-1.69.78-2.22A4.943 4.943 0 0 0 5.17 7M4.5 9.5c0 .5.08 1.03.23 1.5h2.14l-.12-1.5l.12-1.5H4.73c-.15.47-.23 1-.23 1.5m9.77 1.5c.15-.47.23-1 .23-1.5s-.08-1.03-.23-1.5h-2.14a9.48 9.48 0 0 1 0 3h2.14m-6.4-3l-.12 1.5l.12 1.5h3.26a9.48 9.48 0 0 0 0-3H7.87m1.63 6.5c.18 0 .36 0 .53-.03c.25-.52.63-1.4.9-2.47H8.07c.27 1.07.65 1.95.9 2.47l.53.03m4.33-2.5h-1.9c-.23.92-.54 1.69-.78 2.22A4.943 4.943 0 0 0 13.83 12m-8.66 0a4.943 4.943 0 0 0 2.68 2.22c-.24-.53-.55-1.3-.78-2.22h-1.9Z"/>'
        },
        seat: {
            body: '<path fill="currentColor" d="M4 18v3h3v-3h10v3h3v-6H4v3m15-8h3v3h-3v-3M2 10h3v3H2v-3m15 3H7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8Z"/>'
        },
        "seat-flat": {
            body: '<path fill="currentColor" d="M22 11v2H9V7h9a4 4 0 0 1 4 4M2 14v2h6v2h8v-2h6v-2M7.14 12.1C8.3 10.91 8.28 9 7.1 7.86C5.91 6.7 4 6.72 2.86 7.9C1.7 9.09 1.72 11 2.9 12.14c1.19 1.16 3.1 1.14 4.24-.04Z"/>'
        },
        "seat-flat-angled": {
            body: '<path fill="currentColor" d="m22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66l8.56 3.09c2.1.76 3.16 3.06 2.41 5.15M1.5 12.14L8 14.5V19h8v-1.63L20.5 19l.71-1.89l-19.02-6.86m5.11-.05c1.49-.7 2.12-2.51 1.41-4C8 4.71 6.2 4.08 4.7 4.8c-1.49.7-2.12 2.5-1.4 4c.7 1.49 2.5 2.12 4 1.4Z"/>'
        },
        "seat-individual-suite": {
            body: '<path fill="currentColor" d="M7 13a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m12-6h-8v7H3V7H1v10h22v-6a4 4 0 0 0-4-4Z"/>'
        },
        "seat-legroom-extra": {
            body: '<path fill="currentColor" d="M4 12V3H2v9a5 5 0 0 0 5 5h6v-2H7a3 3 0 0 1-3-3m18.83 5.24c-.38-.74-1.29-.97-2.03-.63l-1.09.5l-3.41-6.98A2.022 2.022 0 0 0 14.5 9H11V3H5v8a3 3 0 0 0 3 3h7l3.41 7l3.72-1.7c.77-.36 1.1-1.3.7-2.06Z"/>'
        },
        "seat-legroom-normal": {
            body: '<path fill="currentColor" d="M5 12V3H3v9a5 5 0 0 0 5 5h6v-2H8a3 3 0 0 1-3-3m15.5 6H19v-7a2 2 0 0 0-2-2h-5V3H6v8a3 3 0 0 0 3 3h7v7h4.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "seat-legroom-reduced": {
            body: '<path fill="currentColor" d="M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9a3 3 0 0 1-3-3V3h6v6h5a2 2 0 0 1 2 2l-2 7h1.44c.73 0 1.39.5 1.53 1.2M5 12V3H3v9a5 5 0 0 0 5 5h4v-2H8a3 3 0 0 1-3-3Z"/>'
        },
        "seat-outline": {
            body: '<path fill="currentColor" d="M15 5v7H9V5h6m0-2H9a2 2 0 0 0-2 2v9h10V5a2 2 0 0 0-2-2m7 7h-3v3h3v-3M5 10H2v3h3v-3m15 5H4v6h2v-4h12v4h2v-6Z"/>'
        },
        "seat-passenger": {
            body: '<path fill="currentColor" d="M9 19h6v2H9c-2.76 0-5-2.24-5-5V7h2v9c0 1.66 1.34 3 3 3m1.42-13.59c.78-.78.78-2.05 0-2.83c-.78-.78-2.05-.78-2.83 0c-.78.78-.78 2.05 0 2.83c.78.79 2.04.79 2.83 0M11.5 9c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07L14.93 15H11.5V9Z"/>'
        },
        "seat-recline-extra": {
            body: '<path fill="currentColor" d="M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79c.64-.9 1.88-1.12 2.79-.49c.9.64 1.12 1.88.49 2.79c-.64.9-1.88 1.12-2.79.49M16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l2 9.76A4.992 4.992 0 0 0 8.94 21H16m.23-6h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V10c-1.63.3-3.44-.28-4.69-1.26L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 0 0-.99-.06h-.02a2.268 2.268 0 0 0-1.84 2.61l1.35 5.92A2.989 2.989 0 0 0 9.83 18h6.85l3.82 3l1.5-1.5"/>'
        },
        "seat-recline-normal": {
            body: '<path fill="currentColor" d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83c.78-.78 2.05-.78 2.83 0c.78.78.78 2.05 0 2.83c-.79.79-2.05.79-2.83 0M6 16V7H4v9a5 5 0 0 0 5 5h6v-2H9a3 3 0 0 1-3-3m14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.18 5.5 2.18v-2.18c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.23-.43-.38-.69-.5c-.29-.14-.62-.23-.96-.23h-.03C8 7 7 8 7 9.25V15a3 3 0 0 0 3 3h5.07l3.5 3.5"/>'
        },
        seatbelt: {
            body: '<path fill="currentColor" d="M12 2a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m.39 12.79a34 34 0 0 1 4.25.25c.06-2.72-.18-5.12-.64-6.04c-.13-.27-.31-.5-.5-.7l-8.07 6.92c1.36-.22 3.07-.43 4.96-.43M7.46 17c.13 1.74.39 3.5.81 5h2.07c-.29-.88-.5-1.91-.66-3c0 0 2.32-.44 4.64 0c-.16 1.09-.37 2.12-.66 3h2.07c.44-1.55.7-3.39.83-5.21a34.58 34.58 0 0 0-4.17-.25c-1.93 0-3.61.21-4.93.46M12 7S9 7 8 9c-.34.68-.56 2.15-.63 3.96l6.55-5.62C12.93 7 12 7 12 7m6.57-1.33l-1.14-1.33l-3.51 3.01c.55.19 1.13.49 1.58.95l3.07-2.63m2.1 10.16c-.09-.03-1.53-.5-4.03-.79c-.01.57-.04 1.16-.08 1.75c2.25.28 3.54.71 3.56.71l.55-1.67m-13.3-2.87l-3.94 3.38l.89 1.48c.02-.01 1.18-.46 3.14-.82c-.11-1.41-.14-2.8-.09-4.04Z"/>'
        },
        security: {
            body: '<path fill="currentColor" d="M12 12h7c-.53 4.11-3.28 7.78-7 8.92V12H5V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.73 9 12c5.16-1.27 9-6.45 9-12V5l-9-4Z"/>'
        },
        "security-close": {
            body: '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4zm5 14.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59z" fill="currentColor"/>',
            hidden: true
        },
        "security-network": {
            body: '<path fill="currentColor" d="M13 19h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-1.66C8.07 16.13 6 13 6 9.67v-4L12 3l6 2.67v4c0 3.33-2.07 6.46-5 7.67V19M12 5L8 6.69V10h4V5m0 5v6c1.91-.47 4-2.94 4-5v-1h-4Z"/>'
        },
        seed: {
            body: '<path fill="currentColor" d="M20.7 3.3S19.3 3 17.2 3c-5.5 0-15.6 2.1-14 17.8c1.1.1 2.2.2 3.2.2C24.3 21 20.7 3.3 20.7 3.3M7 17S7 7 17 7c0 0-6 2-10 10Z"/>'
        },
        "seed-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4.8 4.8c-2.1 2.7-3.3 6.8-2.7 13c1.1.1 2.2.2 3.2.2c4.5 0 7.7-1.1 9.9-2.8l4.6 4.6l1.2-1.3M7 17s0-3.3 1.9-6.2l1.3 1.3C9.1 13.4 8 15 7 17m4.6-8.6L8.5 5.3C11.3 3.4 14.7 3 17.2 3c2.1 0 3.5.3 3.5.3s1.4 7-2 12.2l-5.9-5.9C15.1 7.6 17 7 17 7c-2.3 0-4.1.5-5.4 1.4Z"/>'
        },
        "seed-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l4.8 4.8c-2.1 2.7-3.3 6.8-2.7 13c1.1.1 2.2.2 3.2.2c4.5 0 7.7-1.1 9.9-2.8l4.6 4.6l1.2-1.3M6.4 19H5.1c-.2-4.2.5-7.5 2.2-9.8l1.6 1.6C7 13.7 7 17 7 17c1-2 2.1-3.6 3.2-4.9l4.6 4.6c-2 1.5-4.8 2.3-8.4 2.3M10 6.8L8.5 5.3C11.3 3.4 14.7 3 17.2 3c2.1 0 3.5.3 3.5.3s1.4 7-2 12.2L17.2 14c1.9-3.1 1.8-6.9 1.7-8.9c-.5-.1-1.1-.1-1.7-.1c-2.1 0-4.9.3-7.2 1.8m2.8 2.8l-1.2-1.2C12.9 7.5 14.7 7 17 7c0 0-1.9.6-4.2 2.6Z"/>'
        },
        "seed-outline": {
            body: '<path fill="currentColor" d="M17.2 5c.6 0 1.2 0 1.7.1c.2 2.3.2 6.9-2.5 10.1c-2 2.5-5.4 3.8-10 3.8H5.1c-.2-4.6.7-8.2 2.8-10.5C10.4 5.6 14.4 5 17.2 5m0-2c-5.5 0-15.6 2.1-14 17.8c1.1.1 2.2.2 3.2.2C24.3 21 20.7 3.3 20.7 3.3S19.3 3 17.2 3M17 7C7 7 7 17 7 17C11 9 17 7 17 7Z"/>'
        },
        "seed-plus": {
            body: '<path fill="currentColor" d="M17 17h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3m-5 1c0-3.31 2.69-6 6-6c.77 0 1.5.15 2.17.41c1.46-4.51.53-9.11.53-9.11S19.3 3 17.2 3c-5.5 0-15.6 2.1-14 17.8c1.1.1 2.2.2 3.2.2c2.36 0 4.34-.31 6.01-.85c-.26-.65-.41-1.39-.41-2.15m-5-1S7 7 17 7c0 0-6 2-10 10Z"/>'
        },
        "seed-plus-outline": {
            body: '<path fill="currentColor" d="M17.2 5c.6 0 1.2 0 1.7.1c.14 1.6.18 4.32-.72 6.9c.71 0 1.38.17 2 .41c1.46-4.51.52-9.11.52-9.11S19.3 3 17.2 3c-5.5 0-15.6 2.1-14 17.8c1.1.1 2.2.2 3.2.2c2.35 0 4.34-.31 6-.84c-.24-.62-.4-1.29-.4-1.99c-1.59.55-3.47.83-5.6.83H5.1c-.2-4.6.7-8.2 2.8-10.5C10.4 5.6 14.4 5 17.2 5M17 7C7 7 7 17 7 17C11 9 17 7 17 7m0 10h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3Z"/>'
        },
        seesaw: {
            body: '<path fill="currentColor" d="m21.68 13.26l.36 1.97l-19.69 3.54L2 16.8l2.95-.53l-.35-1.97c-.1-.54.26-1.06.81-1.16c.54-.1 1.06.26 1.16.81l.35 1.96l9.84-1.76l-.35-1.97c-.1-.55.26-1.07.81-1.18c.54-.08 1.06.28 1.16.82l.35 1.97l2.95-.53M10.06 18.4L8 22h8l-2.42-4.23l-3.52.63Z"/>'
        },
        segment: {
            body: '<path fill="currentColor" d="M21 8H3V6h18M9 13h12v-2H9m0 7h12v-2H9"/>'
        },
        select: {
            body: '<path fill="currentColor" d="M4 3h1v2H3V4a1 1 0 0 1 1-1m16 0a1 1 0 0 1 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m14 15a1 1 0 0 1-1 1h-1v-2h2v1m-6 1v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7m-3 0a1 1 0 0 1-1-1v-1h2v2H4m-1-6h2v2H3v-2m18 0v2h-2v-2h2M3 11h2v2H3v-2m18 0v2h-2v-2h2M3 7h2v2H3V7m18 0v2h-2V7h2Z"/>'
        },
        "select-all": {
            body: '<path fill="currentColor" d="M9 9h6v6H9m-2 2h10V7H7m8-2h2V3h-2m0 18h2v-2h-2m4-2h2v-2h-2m0-6h2V7h-2m0 14a2 2 0 0 0 2-2h-2m0-6h2v-2h-2m-8 10h2v-2h-2M9 3H7v2h2M3 17h2v-2H3m2 6v-2H3a2 2 0 0 0 2 2M19 3v2h2a2 2 0 0 0-2-2m-6 0h-2v2h2M3 9h2V7H3m4 14h2v-2H7m-4-6h2v-2H3m0-6h2V3a2 2 0 0 0-2 2Z"/>'
        },
        "select-arrow-down": {
            body: '<path fill="currentColor" d="M4 3h1v2H3V4c0-.6.4-1 1-1m16 0c.6 0 1 .4 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m4 16v-2h2v2h-2m-4 0v-2h2v2H7m-3 0c-.6 0-1-.4-1-1v-1h2v2H4m-1-6h2v2H3v-2m0-4h2v2H3v-2m18 0v2h-2v-2h2M3 7h2v2H3V7m18 0v2h-2V7h2m-2 15l3-3h-2v-4h-2v4h-2l3 3Z"/>'
        },
        "select-arrow-up": {
            body: '<path fill="currentColor" d="M4 3h1v2H3V4c0-.6.4-1 1-1m16 0c.6 0 1 .4 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m4 16v-2h2v2h-2m-4 0v-2h2v2H7m-3 0c-.6 0-1-.4-1-1v-1h2v2H4m-1-6h2v2H3v-2m0-4h2v2H3v-2m18 0v2h-2v-2h2M3 7h2v2H3V7m18 0v2h-2V7h2m-2 8l-3 3h2v4h2v-4h2l-3-3Z"/>'
        },
        "select-color": {
            body: '<path fill="currentColor" d="M3.88 3c-.5.06-.88.5-.88 1v1h2V3H3.88M7 3v2h2V3H7m4 0v2h2V3h-2m4 0v2h2V3h-2m4 0v2h2V3.88c-.06-.5-.5-.88-1-.88h-1M3 7v2h2V7H3m16 0v2h2V7h-2M3 11v2h2v-2H3m16.31 1c-.13 0-.26.05-.36.14l-1.56 1.57l-.96-.96l-.71.71l.71.71l-4.46 4.46V21h2.38l4.45-4.46l.7.71l.72-.71l-.96-.96l1.56-1.55c.18-.2.18-.53 0-.72l-1.17-1.17a.476.476 0 0 0-.34-.14M3 15v2h2v-2H3m14 0l.97.97L13.93 20l-.96-.96L17 15M3 19v1.12c.06.5.5.88 1 .88h1v-2H3m4 0v2h2v-2H7Z"/>'
        },
        "select-compare": {
            body: '<path fill="currentColor" d="M13 23h-2V1h2v22m-4-4H5V5h4V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h4v-2M19 7v2h2V7h-2m0-2h2a2 2 0 0 0-2-2v2m2 10h-2v2h2v-2m-2-4v2h2v-2h-2m-2-8h-2v2h2V3m2 18c1.11 0 2-.89 2-2h-2v2m-2-2h-2v2h2v-2Z"/>'
        },
        "select-drag": {
            body: '<path fill="currentColor" d="M13 17h4v-4h2v4h4v2h-4v4h-2v-4h-4v-2m-2 0v2H9v-2h2m-4 0v2H5v-2h2m12-8v2h-2V9h2m0-4v2h-2V5h2m-4 0v2h-2V5h2m-4 0v2H9V5h2M7 5v2H5V5h2m0 8v2H5v-2h2m0-4v2H5V9h2Z"/>'
        },
        "select-group": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2h2m2-2v2h2V3m2 0v2h2V3m2 0v2h2V3m2 0v2h2a2 2 0 0 0-2-2M3 7v2h2V7m2 0v4h4V7m2 0v4h4V7m2 0v2h2V7M3 11v2h2v-2m14 0v2h2v-2M7 13v4h4v-4m2 0v4h4v-4M3 15v2h2v-2m14 0v2h2v-2M3 19a2 2 0 0 0 2 2v-2m2 0v2h2v-2m2 0v2h2v-2m2 0v2h2v-2m2 0v2a2 2 0 0 0 2-2Z"/>'
        },
        "select-inverse": {
            body: '<path fill="currentColor" d="M5 3h2v2h2V3h2v2h2V3h2v2h2V3h2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2H3v-2h2v-2H3v-2h2v-2H3V9h2V7H3V5h2V3Z"/>'
        },
        "select-marker": {
            body: '<path fill="currentColor" d="M4 3h1v2H3V4c0-.55.45-1 1-1m16 0c.55 0 1 .45 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m4 16v-2h2v2h-2m-4 0v-2h2v2H7m-3 0c-.55 0-1-.45-1-1v-1h2v2H4m-1-6h2v2H3v-2m0-4h2v2H3v-2m0-4h2v2H3V7m18 0v2h-2V7h2m-1.5 6c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S16 19.1 16 16.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2Z"/>'
        },
        "select-multiple": {
            body: '<path fill="currentColor" d="M18 12h2v2h-2v-2m-4 4h2v2h-2v-2m6 1c0 .55-.45 1-1 1h-1v-2h2v1M7 4h1v2H6V5c0-.55.45-1 1-1m12 0c.55 0 1 .45 1 1v1h-2V4h1m-5 2V4h2v2h-2m-4 0V4h2v2h-2m0 12v-2h2v2h-2m-3 0c-.55 0-1-.45-1-1v-1h2v2H7m-1-6h2v2H6v-2m0-4h2v2H6V8m14 0v2h-2V8h2M3 8h1v12h12v1c0 .54-.43 1-.97 1H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1Z"/>'
        },
        "select-multiple-marker": {
            body: '<path fill="currentColor" d="M7 4h1v2H6V5c0-.55.45-1 1-1m12 0c.55 0 1 .45 1 1v1h-2V4h1m-5 2V4h2v2h-2m-4 0V4h2v2h-2m0 12v-2h2v2h-2m-3 0c-.55 0-1-.45-1-1v-1h2v2H7m-1-6h2v2H6v-2m0-4h2v2H6V8m14 0v2h-2V8h2M3 8h1v12h10.58l1.45 2H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m15.5 4c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2Z"/>'
        },
        "select-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L21 21.72L19.73 23L17 20.27V21h-2v-2h.73L5 8.27V9H3V7h.73L1 4.27M20 3a1 1 0 0 1 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m4 16v-2h2v2h-2m-4 0v-2h2v2H7m-3 0a1 1 0 0 1-1-1v-1h2v2H4m-1-6h2v2H3v-2m18 0v2h-2v-2h2M3 11h2v2H3v-2m18 0v2h-2v-2h2m0-4v2h-2V7h2Z"/>'
        },
        "select-place": {
            body: '<path fill="currentColor" d="M4 3h1v2H3V4c0-.5.5-1 1-1m16 0c.5 0 1 .5 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7m14 7c0 .5-.5 1-1 1h-1v-2h2v1m-6 1v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7m-3 0c-.5 0-1-.5-1-1v-1h2v2H4M3 7h2v2H3V7m18 0v2h-2V7h2M7 16l5 5l5-5H7Z"/>'
        },
        "select-remove": {
            body: '<path fill="currentColor" d="M21 20c0 .55-.45 1-1 1h-1v-2h2v1m-6 1v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7m-3 0c-.55 0-1-.45-1-1v-1h2v2H4m-1-6h2v2H3v-2m18 0v2h-2v-2h2m-6.41-7L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8M3 11h2v2H3v-2m18 0v2h-2v-2h2M3 7h2v2H3V7m18 0v2h-2V7h2M4 3h1v2H3V4c0-.55.45-1 1-1m16 0c.55 0 1 .45 1 1v1h-2V3h1m-5 2V3h2v2h-2m-4 0V3h2v2h-2M7 5V3h2v2H7Z"/>'
        },
        "select-search": {
            body: '<path fill="currentColor" d="M19.31 18.9c.44-.69.69-1.52.69-2.4c0-2.5-2-4.5-4.5-4.5S11 14 11 16.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 23.39L22.39 22l-3.08-3.1m-3.81.1a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M21 9h-2V7h2v2m0-4h-2V3h1c.55 0 1 .45 1 1v1m-2 6.03V11h2v2h-.03A6.608 6.608 0 0 0 19 11.03M17 5h-2V3h2v2m-4 0h-2V3h2v2M3 7h2v2H3V7m4 12h2v2H7v-2m-4-8h2v2H3v-2m1-8h1v2H3V4c0-.55.45-1 1-1m5 2H7V3h2v2M3 19h2v2H4c-.55 0-1-.45-1-1v-1m0-4h2v2H3v-2Z"/>'
        },
        selection: {
            body: '<path fill="currentColor" d="M2 4a2 2 0 0 1 2-2h3v2H4v3H2V4m20 0v3h-2V4h-3V2h3a2 2 0 0 1 2 2m-2 16v-3h2v3a2 2 0 0 1-2 2h-3v-2h3M2 20v-3h2v3h3v2H4a2 2 0 0 1-2-2m8-18h4v2h-4V2m0 18h4v2h-4v-2m10-10h2v4h-2v-4M2 10h2v4H2v-4Z"/>'
        },
        "selection-drag": {
            body: '<path fill="currentColor" d="M14 17h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2m-2 0v2H9v-2h3m-5 0v2H3v-4h2v2h2m-4-4v-3h2v3H3m0-5V4h4v2H5v2H3m6-4h3v2H9V4m6 0h4v4h-2V6h-2V4m4 6v2h-2v-2h2Z"/>'
        },
        "selection-ellipse": {
            body: '<path fill="currentColor" d="m6.35 20.25l1.21-1.59c.86.57 1.83.98 2.87 1.19l-.27 1.98c-1.39-.26-2.66-.83-3.81-1.58m10.08-1.59l1.21 1.6c-1.14.77-2.41 1.31-3.8 1.57l-.27-1.98c1.04-.21 2-.62 2.86-1.19m3.41-5.07l1.99.27c-.26 1.39-.83 2.68-1.59 3.8l-1.59-1.21c.57-.85.98-1.82 1.19-2.86m-17.67.25l1.98-.27a8.09 8.09 0 0 0 1.19 2.87l-1.59 1.21C3 16.5 2.43 15.23 2.17 13.84m16.49-6.28l1.59-1.21a9.885 9.885 0 0 1 1.58 3.83l-1.98.27a8.11 8.11 0 0 0-1.19-2.89m-5.09-3.41l.27-1.98c1.39.26 2.66.83 3.81 1.58l-1.21 1.59a8.09 8.09 0 0 0-2.87-1.19M7.56 5.34L6.35 3.75C7.5 3 8.77 2.43 10.16 2.17l.27 1.98a8.09 8.09 0 0 0-2.87 1.19m-3.41 5.09l-1.98-.27C2.43 8.77 3 7.5 3.75 6.35l1.59 1.21a8.09 8.09 0 0 0-1.19 2.87Z"/>'
        },
        "selection-ellipse-arrow-inside": {
            body: '<path fill="currentColor" d="M11.2 4c-1.26.12-2.48.53-3.56 1.2l-1-1.73A9.675 9.675 0 0 1 11 2m6.53 4.25c-.91-.86-2-1.52-3.19-1.92L15 2.39c1.5.45 2.89 1.27 4 2.39M5.34 7.41A8.312 8.312 0 0 0 4 10.83l-2-.28C2.2 9 2.79 7.5 3.7 6.23M22 12v.66l-2-.16V12c0-1.08-.19-2.14-.61-3.14l1.83-.8c.53 1.25.78 2.59.78 3.94M6 17.3l-1.5 1.31a10.457 10.457 0 0 1-2.2-4.08L4.17 14c.36 1.22.99 2.35 1.83 3.3m6.14 4.7H12c-1.5 0-3-.32-4.36-.93l.89-1.83c1.09.51 2.27.76 3.47.76h.19M17 21h-2v-6h6v2h-2.58l2.72 2.76l-1.41 1.41L17 18.5"/>'
        },
        "selection-ellipse-remove": {
            body: '<path fill="currentColor" d="m6.35 20.25l1.21-1.59c.86.57 1.83.98 2.87 1.19l-.27 1.98c-1.39-.26-2.66-.83-3.81-1.58m10.08-1.59l1.21 1.6c-1.14.77-2.41 1.31-3.8 1.57l-.27-1.98c1.04-.21 2-.62 2.86-1.19m3.41-5.07l1.99.27c-.26 1.39-.83 2.68-1.59 3.8l-1.59-1.21c.57-.85.98-1.82 1.19-2.86m-17.67.25l1.98-.27a8.09 8.09 0 0 0 1.19 2.87l-1.59 1.21C3 16.5 2.43 15.23 2.17 13.84M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8m4.07-.44l1.59-1.21a9.885 9.885 0 0 1 1.58 3.83l-1.98.27a8.11 8.11 0 0 0-1.19-2.89M4.15 10.43l-1.98-.27C2.43 8.77 3 7.5 3.75 6.35l1.59 1.21a8.09 8.09 0 0 0-1.19 2.87m9.42-6.28l.27-1.98c1.39.26 2.66.83 3.81 1.58l-1.21 1.59a8.09 8.09 0 0 0-2.87-1.19M7.56 5.34L6.35 3.75C7.5 3 8.77 2.43 10.16 2.17l.27 1.98a8.09 8.09 0 0 0-2.87 1.19Z"/>'
        },
        "selection-lasso": {
            body: '<path d="M11.203 3.984a8.081 8.081 0 0 0-3.562 1.22L6.609 3.468c1.375-.844 2.829-1.328 4.36-1.453l.234 1.968zm6.328 2.25c-.875-.843-1.937-1.484-3.187-1.921l.61-1.922c1.5.437 2.827 1.234 3.983 2.39l-1.406 1.453zM5.344 7.406a8.298 8.298 0 0 0-1.36 3.422l-1.968-.281a9.62 9.62 0 0 1 1.687-4.313l1.64 1.172zM21.984 12v.656l-2.015-.14V12c0-1.156-.203-2.203-.61-3.14l1.828-.797A9.963 9.963 0 0 1 21.985 12zm-16.03 5.297l-1.5 1.312a10.571 10.571 0 0 1-2.204-4.078l1.922-.515a8.421 8.421 0 0 0 1.781 3.28zm6.187 4.687h-.188c-1.5 0-2.953-.312-4.36-.937l.891-1.828a8.038 8.038 0 0 0 3.47.797h.187v1.968zM17.016 21H15v-6h6v2.016h-2.578l2.719 2.765l-1.407 1.407l-2.718-2.672V21z" fill="currentColor"/>',
            hidden: true
        },
        "selection-marker": {
            body: '<path fill="currentColor" d="M2 4a2 2 0 0 1 2-2h3v2H4v3H2V4m20 0v3h-2V4h-3V2h3a2 2 0 0 1 2 2M2 20v-3h2v3h3v2H4a2 2 0 0 1-2-2m8-18h4v2h-4V2m0 18h4v2h-4v-2M2 10h2v4H2v-4m16.5 3c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S15 19.1 15 16.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2M20 10h2v2.34c-.58-.5-1.26-.89-2-1.11V10Z"/>'
        },
        "selection-multiple": {
            body: '<path fill="currentColor" d="M11 6V4h4v2h-4M6 9h2v4H6V9m0-3a2 2 0 0 1 2-2h1v2H8v1H6V6m2 12a2 2 0 0 1-2-2v-1h2v1h1v2H8M18 4a2 2 0 0 1 2 2v1h-2V6h-1V4h1m-3 12v2h-4v-2h4m5-3h-2V9h2v4m0 3a2 2 0 0 1-2 2h-1v-2h1v-1h2v1M3 8h1v12h12v1c0 .54-.43 1-.97 1H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1Z"/>'
        },
        "selection-multiple-marker": {
            body: '<path fill="currentColor" d="M7 4h2v2H8v1H6V5c0-.55.45-1 1-1m12 0c.55 0 1 .45 1 1v2h-2V6h-1V4h2m-8 2V4h4v2h-4M7 18c-.55 0-1-.45-1-1v-2h2v1h1v2H7M6 9h2v4H6V9M3 8h1v12h10.58l1.45 2H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m15.5 4c1.9 0 3.5 1.6 3.5 3.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5m0 4.8c.7 0 1.3-.6 1.2-1.2c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2M11 18v-2h2c.09.66.27 1.33.5 2H11m9-9v1.23c-.5-.15-1-.23-1.5-.23l-.5.03V9h2Z"/>'
        },
        "selection-off": {
            body: '<path fill="currentColor" d="M.5 3.77L1.78 2.5L21.5 22.22l-1.27 1.28l-1.5-1.5H17v-1.73L3.73 7H2V5.27L.5 3.77M4 2h3v2H5.82L3.83 2H4m18 2v3h-2V4h-3V2h3a2 2 0 0 1 2 2m-2 13h2v3.17l-2-1.99V17M2 20v-3h2v3h3v2H4a2 2 0 0 1-2-2m8-18h4v2h-4V2m0 18h4v2h-4v-2m10-10h2v4h-2v-4M2 10h2v4H2v-4Z"/>'
        },
        "selection-remove": {
            body: '<path fill="currentColor" d="M20 20v-3h2v3a2 2 0 0 1-2 2h-3v-2h3M2 20v-3h2v3h3v2H4c-1.1 0-2-.9-2-2m8 0h4v2h-4v-2m4.59-12L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8M20 10h2v4h-2v-4M2 10h2v4H2v-4m0-6a2 2 0 0 1 2-2h3v2H4v3H2V4m20 0v3h-2V4h-3V2h3c1.1 0 2 .9 2 2M10 2h4v2h-4V2Z"/>'
        },
        "selection-search": {
            body: '<path fill="currentColor" d="M19.27 18.9c.43-.69.68-1.52.68-2.4c0-2.5-2-4.5-4.49-4.5s-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68l3.12 3.07L22.35 22l-3.08-3.1m-3.81.1c-1.39 0-2.5-1.12-2.5-2.5s1.11-2.5 2.5-2.5s2.49 1.12 2.49 2.5s-1.11 2.5-2.49 2.5M22 14h-.55c-.33-.81-.83-1.53-1.45-2.14V10h2v4M20 4h-3V2h3a2 2 0 0 1 2 2v3h-2V4m-6 0h-4V2h4v2M4 2h3v2H4v3H2V4a2 2 0 0 1 2-2m8 20h-2v-2c.5.82 1.2 1.5 2 2m-8-2h3v2H4a2 2 0 0 1-2-2v-3h2v3m0-6H2v-4h2v4Z"/>'
        },
        "semantic-web": {
            body: '<path fill="currentColor" d="M12.9 4.22C18.73 6.84 20 2 20 2s-1.11 6.07-6.21 8.55c-1.04.51-1.69.78-1.69.78L3.73 7.25l8.37-3.43s-.2-.06.8.4M11.12 22l-7.79-4.22V9.07l7.79 3.97V22m1.76 0l7.8-4.22V9.07l-7.8 3.97V22Z"/>'
        },
        send: {
            body: '<path fill="currentColor" d="m2 21l21-9L2 3v7l15 2l-15 2v7Z"/>'
        },
        "send-check": {
            body: '<path fill="currentColor" d="M2 3v7l15 2l-15 2v7l21-9m-1 3.5L18.5 19l-2-2l-1.5 1.5l3.5 3.5l5-5Z"/>'
        },
        "send-check-outline": {
            body: '<path fill="currentColor" d="M2 3v7l15 2l-15 2v7l21-9M4 6.03l7.53 3.22l-7.53-1m7.53 6.5L4 17.97v-2.22m18-.25L18.5 19l-2-2l-1.5 1.5l3.5 3.5l5-5Z"/>'
        },
        "send-circle": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2M8 7.71v3.34l7.14.95l-7.14.95v3.34L18 12L8 7.71Z"/>'
        },
        "send-circle-outline": {
            body: '<path fill="currentColor" d="M8 7.71L18 12L8 16.29v-3.34l7.14-.95L8 11.05V7.71M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "send-clock": {
            body: '<path fill="currentColor" d="M2 3v7l9 2l-9 2v7l7.27-3.11A7 7 0 0 0 16 23a7 7 0 0 0 7-7a7 7 0 0 0-7-7L2 3m14 8a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m-1 1.5v4l3 2l.75-1.25l-2.25-1.5V12.5H15Z"/>'
        },
        "send-clock-outline": {
            body: '<path fill="currentColor" d="M2 3v7l9 2l-9 2v7l7.27-3.11A7 7 0 0 0 16 23a7 7 0 0 0 7-7a7 7 0 0 0-7-7L2 3m2 3.03l8.78 3.77a7 7 0 0 0-.68.4L4 8.4V6.03M16 11a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m-1 1.5v4l3 2l.75-1.25l-2.25-1.5V12.5H15m-5.82 1.95A7 7 0 0 0 9 15.82l-5 2.15V15.6l5.18-1.15Z"/>'
        },
        "send-lock": {
            body: '<path fill="currentColor" d="M23 18v-.5a2.5 2.5 0 0 0-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5v.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 0h-3v-.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5v.5m1-6L2 21v-7l15-2l-15-2V3l21 9Z"/>'
        },
        "send-lock-outline": {
            body: '<path fill="currentColor" d="M23 18v-.5a2.5 2.5 0 0 0-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5M4 6.03l7.5 3.22l-7.5-1V6.03m7.5 8.72L4 17.97v-2.22l7.5-1M2 3v7l15 2l-15 2v7l21-9L2 3Z"/>'
        },
        "send-outline": {
            body: '<path fill="currentColor" d="m4 6.03l7.5 3.22l-7.5-1V6.03m7.5 8.72L4 17.97v-2.22l7.5-1M2 3v7l15 2l-15 2v7l21-9L2 3Z"/>'
        },
        "serial-port": {
            body: '<path fill="currentColor" d="M7 3h10v2h2v3h-3v6H8V8H5V5h2V3m10 6h2v5h-2V9m-6 6h2v7h-2v-7M5 9h2v5H5V9Z"/>'
        },
        server: {
            body: '<path fill="currentColor" d="M4 1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1m0 8h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0 8h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M9 5h1V3H9v2m0 8h1v-2H9v2m0 8h1v-2H9v2M5 3v2h2V3H5m0 8v2h2v-2H5m0 8v2h2v-2H5Z"/>'
        },
        "server-minus": {
            body: '<path fill="currentColor" d="M4 4h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m5 4h1V6H9v2M5 6v2h2V6H5m3 10h8v2H8v-2Z"/>'
        },
        "server-network": {
            body: '<path fill="currentColor" d="M13 19h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7v2M4 3h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 4h1V5H9v2m0 8h1v-2H9v2M5 5v2h2V5H5m0 8v2h2v-2H5Z"/>'
        },
        "server-network-off": {
            body: '<path fill="currentColor" d="M13 19h1a1 1 0 0 1 1 1h.73L13 17.27V19m9 1v1.18L20.82 20H22m-1 2.72L19.73 24l-2-2H15a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2.73l-2-2H4a1 1 0 0 1-1-1v-.73l-2-2L2.28 4L21 22.72M4 3h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.82L7 6.18V5H5.82L3.84 3H4m16 8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2.18l-6-6H20M9 7h1V5H9v2m0 8h1v-.73l-1-1V15m-4-2v2h2v-2H5Z"/>'
        },
        "server-off": {
            body: '<path fill="currentColor" d="M4 1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8.82l-2-2H7V3H5v.18L3.21 1.39C3.39 1.15 3.68 1 4 1m18 21.72L20.73 24l-1-1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h9.73l-2-2H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.73L3.68 6.95c-.3-.1-.53-.33-.63-.63L1 4.27L2.28 3L22 22.72M20 9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3.18l-6-6H20m0 8a1 1 0 0 1 1 1v1.18L18.82 17H20M9 5h1V3H9v2m0 8h.73L9 12.27V13m0 8h1v-2H9v2M5 11v2h2v-2H5m0 8v2h2v-2H5Z"/>'
        },
        "server-plus": {
            body: '<path fill="currentColor" d="M4 4h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m5 4h1V6H9v2M5 6v2h2V6H5m3 10h3v-3h2v3h3v2h-3v3h-2v-3H8v-2Z"/>'
        },
        "server-remove": {
            body: '<path fill="currentColor" d="M4 4h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m5 4h1V6H9v2M5 6v2h2V6H5m5.59 11L8 14.41L9.41 13L12 15.59L14.59 13L16 14.41L13.41 17L16 19.59L14.59 21L12 18.41L9.41 21L8 19.59L10.59 17Z"/>'
        },
        "server-security": {
            body: '<path fill="currentColor" d="M3 1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1m0 8h16a1 1 0 0 1 1 1v.67l-2.5-1.11l-6.5 2.88V15H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0 8h8c.06 2.25 1 4.4 2.46 6H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M8 5h1V3H8v2m0 8h1v-2H8v2m0 8h1v-2H8v2M4 3v2h2V3H4m0 8v2h2v-2H4m0 8v2h2v-2H4m13.5-7l4.5 2v3c0 2.78-1.92 5.37-4.5 6c-2.58-.63-4.5-3.22-4.5-6v-3l4.5-2m0 1.94L15 15.06v2.66c0 1.54 1.07 2.98 2.5 3.34v-7.12Z"/>'
        },
        "set-all": {
            body: '<path fill="currentColor" d="M9 5c1.04 0 2.06.24 3 .68c.94-.44 1.96-.68 3-.68a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.04 0-2.06-.24-3-.68c-.94.44-1.96.68-3 .68a7 7 0 0 1-7-7a7 7 0 0 1 7-7m-.5 7c0 1.87.79 3.56 2.06 4.75l1-.46c-1.25-1-2.06-2.55-2.06-4.29c0-1.74.81-3.29 2.06-4.29l-1-.46A6.491 6.491 0 0 0 8.5 12m7 0c0-1.87-.79-3.56-2.06-4.75l-1 .46c1.25 1 2.06 2.55 2.06 4.29c0 1.74-.81 3.29-2.06 4.29l1 .46A6.491 6.491 0 0 0 15.5 12Z"/>'
        },
        "set-center": {
            body: '<path fill="currentColor" d="M9 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7c1.04 0 2.06-.24 3-.68c.94.44 1.96.68 3 .68a7 7 0 0 0 7-7a7 7 0 0 0-7-7c-1.04 0-2.06.24-3 .68c-.94-.44-1.96-.68-3-.68m0 2c.34 0 .67.03 1 .1c-1.28 1.31-2 3.07-2 4.9c0 1.83.72 3.59 2 4.89c-.33.07-.66.11-1 .11a5 5 0 0 1-5-5a5 5 0 0 1 5-5m6 0a5 5 0 0 1 5 5a5 5 0 0 1-5 5c-.34 0-.67-.03-1-.1c1.28-1.31 2-3.07 2-4.9c0-1.83-.72-3.59-2-4.89c.33-.07.66-.11 1-.11Z"/>'
        },
        "set-center-right": {
            body: '<path fill="currentColor" d="M15 19c-1.04 0-2.06-.24-3-.68c-.94.44-1.96.68-3 .68a7 7 0 0 1-7-7a7 7 0 0 1 7-7c1.04 0 2.06.24 3 .68c.94-.44 1.96-.68 3-.68a7 7 0 0 1 7 7a7 7 0 0 1-7 7m-6-2l1-.11c-1.28-1.3-2-3.06-2-4.89c0-1.83.72-3.59 2-4.9L9 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5m6.5-5c0-1.87-.79-3.56-2.06-4.75l-1 .46c1.25 1 2.06 2.55 2.06 4.29c0 1.74-.81 3.29-2.06 4.29l1 .46A6.491 6.491 0 0 0 15.5 12Z"/>'
        },
        "set-left": {
            body: '<path fill="currentColor" d="M9 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7c1.04 0 2.06-.24 3-.68c.94.44 1.96.68 3 .68a7 7 0 0 0 7-7a7 7 0 0 0-7-7c-1.04 0-2.06.24-3 .68c-.94-.44-1.96-.68-3-.68m6 2a5 5 0 0 1 5 5a5 5 0 0 1-5 5c-.34 0-.67-.03-1-.1c1.28-1.31 2-3.07 2-4.9c0-1.83-.72-3.59-2-4.89c.33-.07.66-.11 1-.11m-3 1c1.26.95 2 2.43 2 4c0 1.57-.74 3.05-2 4a5.01 5.01 0 0 1-2-4c0-1.57.74-3.05 2-4Z"/>'
        },
        "set-left-center": {
            body: '<path fill="currentColor" d="M9 5c1.04 0 2.06.24 3 .68c.94-.44 1.96-.68 3-.68a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.04 0-2.06-.24-3-.68c-.94.44-1.96.68-3 .68a7 7 0 0 1-7-7a7 7 0 0 1 7-7m6 2l-1 .11c1.28 1.3 2 3.06 2 4.89c0 1.83-.72 3.59-2 4.9l1 .1a5 5 0 0 0 5-5a5 5 0 0 0-5-5m-6.5 5c0 1.87.79 3.56 2.06 4.75l1-.46c-1.25-1-2.06-2.55-2.06-4.29c0-1.74.81-3.29 2.06-4.29l-1-.46A6.491 6.491 0 0 0 8.5 12Z"/>'
        },
        "set-left-right": {
            body: '<path fill="currentColor" d="M9 5c1.04 0 2.06.24 3 .68c.94-.44 1.96-.68 3-.68a7 7 0 0 1 7 7a7 7 0 0 1-7 7c-1.04 0-2.06-.24-3-.68c-.94.44-1.96.68-3 .68a7 7 0 0 1-7-7a7 7 0 0 1 7-7m0 7c0 2.22 1.21 4.16 3 5.2c1.79-1.04 3-2.98 3-5.2s-1.21-4.16-3-5.2C10.21 7.84 9 9.78 9 12Z"/>'
        },
        "set-merge": {
            body: '<path fill="currentColor" d="M2 7v2h5V7H2m10 2v2H9v2h3v2l3-3l-3-3m5 0v6h5V9h-5M2 11v2h5v-2H2m0 4v2h5v-2H2Z"/>'
        },
        "set-none": {
            body: '<path fill="currentColor" d="M9 5a7 7 0 0 0-7 7a7 7 0 0 0 7 7c1.04 0 2.06-.24 3-.68c.94.44 1.96.68 3 .68a7 7 0 0 0 7-7a7 7 0 0 0-7-7c-1.04 0-2.06.24-3 .68c-.94-.44-1.96-.68-3-.68m0 2c.34 0 .67.03 1 .1c-1.28 1.31-2 3.07-2 4.9c0 1.83.72 3.59 2 4.89c-.33.07-.66.11-1 .11a5 5 0 0 1-5-5a5 5 0 0 1 5-5m6 0a5 5 0 0 1 5 5a5 5 0 0 1-5 5c-.34 0-.67-.03-1-.1c1.28-1.31 2-3.07 2-4.9c0-1.83-.72-3.59-2-4.89c.33-.07.66-.11 1-.11m-3 1c1.26.95 2 2.43 2 4c0 1.57-.74 3.05-2 4a5.01 5.01 0 0 1-2-4c0-1.57.74-3.05 2-4Z"/>'
        },
        "set-right": {
            body: '<path fill="currentColor" d="M15 19c-1.04 0-2.06-.24-3-.68c-.94.44-1.96.68-3 .68a7 7 0 0 1-7-7a7 7 0 0 1 7-7c1.04 0 2.06.24 3 .68c.94-.44 1.96-.68 3-.68a7 7 0 0 1 7 7a7 7 0 0 1-7 7m-6-2l1-.11c-1.28-1.3-2-3.06-2-4.89c0-1.83.72-3.59 2-4.9L9 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5m3-1c1.26-.95 2-2.43 2-4c0-1.57-.74-3.05-2-4c-1.26.95-2 2.43-2 4c0 1.57.74 3.05 2 4Z"/>'
        },
        "set-split": {
            body: '<path fill="currentColor" d="M17 7v2h5V7h-5M2 9v6h5V9H2m10 0v2H9v2h3v2l3-3l-3-3m5 2v2h5v-2h-5m0 4v2h5v-2h-5Z"/>'
        },
        "set-square": {
            body: '<path fill="currentColor" d="m17.7 17.7l-1.1 1.1l-.7-.8l1.1-1l-2-2l-1 1.1l-.7-.7l1.1-1.1l-1.9-1.9l-1.1 1.1l-.7-.7l1.1-1.1l-2-1.9l-1.1 1.1l-.7-.7L9 9L7.1 7.1L6 8.1l-.7-.7l1.1-1.1L4 4v16h16l-2.3-2.3M7 17v-5.8l5.8 5.8H7Z"/>'
        },
        "set-top-box": {
            body: '<path fill="currentColor" d="M5 15.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V15H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V15H5v.5M3 12v1h2v-1H3m3 0v1h2v-1H6m14.5-.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "settings-helper": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        shaker: {
            body: '<path fill="currentColor" d="M7 16c0 .55-.45 1-1 1s-1-.45-1-1s.45-1 1-1s1 .45 1 1m2 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-5 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 1c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m8.33-16.28L9.8 9.65l3.54 3.54l6.94-5.52c.9-.76.97-2.13.13-2.97L18.3 2.59c-.84-.84-2.21-.77-2.97.13M8.39 12.5l2.11 2.1c.4.4 1.04.4 1.43 0l.7-.7l-3.53-3.54l-.71.71a1.02 1.02 0 0 0 0 1.43Z"/>'
        },
        "shaker-outline": {
            body: '<path fill="currentColor" d="m16.88 4l2.15 2.1l-5.53 4.4l-1-1L16.87 4h.01m0-2a2 2 0 0 0-1.55.72L9.8 9.65l3.54 3.54l6.94-5.52c.9-.76.97-2.13.13-2.97L18.3 2.59c-.4-.4-.91-.59-1.42-.59M9.1 10.36l-.71.71a1.02 1.02 0 0 0 0 1.43l2.11 2.1c.21.2.46.29.72.29s.51-.09.71-.29l.7-.7l-3.53-3.54M6 15c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 1c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-5 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 1c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        shape: {
            body: '<path fill="currentColor" d="M11 13.5v8H3v-8h8M12 2l5.5 9h-11L12 2m5.5 11c2.5 0 4.5 2 4.5 4.5S20 22 17.5 22S13 20 13 17.5s2-4.5 4.5-4.5Z"/>'
        },
        "shape-circle-plus": {
            body: '<path fill="currentColor" d="M11 19a6 6 0 0 0 6-6h2a8 8 0 0 1-8 8a8 8 0 0 1-8-8a8 8 0 0 1 8-8v2a6 6 0 0 0-6 6a6 6 0 0 0 6 6m8-14h3v2h-3v3h-2V7h-3V5h3V2h2v3Z"/>'
        },
        "shape-outline": {
            body: '<path fill="currentColor" d="M11 13.5v8H3v-8h8m-2 2H5v4h4v-4M12 2l5.5 9h-11L12 2m0 3.86L10.08 9h3.84L12 5.86M17.5 13c2.5 0 4.5 2 4.5 4.5S20 22 17.5 22S13 20 13 17.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5Z"/>'
        },
        "shape-oval-plus": {
            body: '<path fill="currentColor" d="M19 5h3v2h-3v3h-2V7h-3V5h3V2h2v3m-8-1l1 .09v2.05c-.32-.09-.66-.14-1-.14c-2.76 0-5 3.13-5 7s2.24 7 5 7s5-3.13 5-7l-.05-1h2.01l.04 1c0 4.97-3.13 9-7 9s-7-4.03-7-9s3.13-9 7-9Z"/>'
        },
        "shape-plus": {
            body: '<path fill="currentColor" d="M2 2h9v9H2V2m15.5 0C20 2 22 4 22 6.5S20 11 17.5 11S13 9 13 6.5S15 2 17.5 2m-11 12l4.5 8H2l4.5-8M19 17h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Z"/>'
        },
        "shape-polygon-plus": {
            body: '<path fill="currentColor" d="M17 15.7V13h2v4l-9 4l-7-7l4-9h4v2H8.3l-2.9 6.6l5 5l6.6-2.9M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3Z"/>'
        },
        "shape-rectangle-plus": {
            body: '<path fill="currentColor" d="M19 6h3v2h-3v3h-2V8h-3V6h3V3h2v3m-2 11v-3h2v5H3V6h8v2H5v9h12Z"/>'
        },
        "shape-square-plus": {
            body: '<path fill="currentColor" d="M19 5h3v2h-3v3h-2V7h-3V5h3V2h2v3m-2 14v-6h2v8H3V5h8v2H5v12h12Z"/>'
        },
        "shape-square-rounded-plus": {
            body: '<path fill="currentColor" d="M17 2h2v3h3v2h-3v3h-2V7h-3V5h3V2M7 5h4v2H7c-1.1 0-2 .9-2 2v8a2 2 0 0 0 2 2h8c1.11 0 2-.89 2-2v-4h2v4c0 2.21-1.79 4-4 4H7c-2.21 0-4-1.79-4-4V9c0-2.21 1.79-4 4-4Z"/>'
        },
        share: {
            body: '<path fill="currentColor" d="m21 12l-7-7v4C7 10 4 15 3 20c2.5-3.5 6-5.1 11-5.1V19l7-7Z"/>'
        },
        "share-all": {
            body: '<path fill="currentColor" d="M11 9V5l7 7l-7 7v-4.1c-5 0-8.5 1.6-11 5.1c1-5 4-10 11-11m6-1V5l7 7l-7 7v-3l4-4l-4-4Z"/>'
        },
        "share-all-outline": {
            body: '<path fill="currentColor" d="M13 9.8v.9l-1.7.2c-2.6.4-4.5 1.4-5.9 2.7c1.7-.5 3.5-.8 5.6-.8h2v1.3l2.2-2.1L13 9.8M11 5l7 7l-7 7v-4.1c-5 0-8.5 1.6-11 5.1c1-5 4-10 11-11m6-1V5l7 7l-7 7v-3l4-4"/>'
        },
        "share-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m2 14v-3c-3.61 0-6.19 1.43-8 4c.72-3.67 2.94-7.27 8-8V6l5 5l-5 5Z"/>'
        },
        "share-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-5.2-5.2L14 19v-3.1l-.9-1c-4.5.3-7.7 1.9-10.1 5.2c.58-3.79 2.72-7.16 5.9-9.3L1.1 3l1.3-1.3l19.7 19.8m-4-6.6L21 12l-7-7v4l-1.5.3"/>'
        },
        "share-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l7.8 7.8C5.4 12.9 3.7 16.4 3 20c2.3-3.3 5.6-4.9 10-5.1l1 1V19l1.6-1.6l5.2 5.3M8.3 13.8c.64-.58 1.35-1.09 2.1-1.5l.9.8m2.9-2.1l-1.7-1.7L14 9V5l7 7l-2.9 2.9l-1.4-1.4l1.5-1.5L16 9.8v.9"/>'
        },
        "share-outline": {
            body: '<path fill="currentColor" d="M14 5v4C7 10 4 15 3 20c2.5-3.5 6-5.1 11-5.1V19l7-7l-7-7m2 4.83L18.17 12L16 14.17V12.9h-2c-2.07 0-3.93.38-5.66.95c1.4-1.39 3.2-2.48 5.94-2.85l1.72-.27v-.9Z"/>'
        },
        "share-variant": {
            body: '<path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7c0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.15c-.05.21-.08.43-.08.66c0 1.61 1.31 2.91 2.92 2.91c1.61 0 2.92-1.3 2.92-2.91A2.92 2.92 0 0 0 18 16.08Z"/>'
        },
        "share-variant-outline": {
            body: '<path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81c1.66 0 3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.15c-.05.21-.08.43-.08.66c0 1.61 1.31 2.91 2.92 2.91s2.92-1.3 2.92-2.91s-1.31-2.92-2.92-2.92M18 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M6 13c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m12 7c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        shark: {
            body: '<path fill="currentColor" d="M15.56 9.09C14.66 7.18 12.54 6 11 6c.47 1.4.28 2.57-.05 3.43C8.45 10 6 11 6 11S3 7 1 7l2 6l-1 4c2 0 4-3 4-3s5 2 8 2v2c.65 0 1.91-.83 2.73-2.23c1.24-.21 2.27-.56 3.14-.96c-.15-.18-.34-.37-.59-.51c-.65-.39-1.46-.63-2.28-.8c.82-.16 1.67-.28 2.59-.15c.46.06.95.19 1.41.51c.1.06.17.14.24.19C22.4 13.26 23 12.44 23 12c0-.87-3.81-2.5-7.44-2.91M18 12c-.55 0-1-.45-1-1c0-.24.1-.45.23-.62c.61.12 1.2.29 1.74.46c.03.05.03.1.03.16c0 .55-.45 1-1 1Z"/>'
        },
        "shark-fin": {
            body: '<path fill="currentColor" d="M22 16v2h-2c-1.4 0-2.8-.4-4-1c-2.5 1.3-5.5 1.3-8 0c-1.2.6-2.6 1-4 1H2v-2h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0c1.2.8 2.6 1.3 4 1.3h2M5.28 13.79c.54-.16 1.09-.41 1.61-.75l1.14-.77l1.13.8C10 13.66 11 14 12 14c1 0 2-.34 2.84-.93l1.13-.8l1.14.77c.82.55 1.72.86 2.56.93C18.24 7.4 12.37 2 6 2c-.35 0-.67.18-.85.47c-.18.3-.2.67-.04.98c2.17 4.34 1.5 7.84.17 10.34M16 18.7c-2.4 1.7-5.6 1.7-8 0c-1.2.8-2.6 1.3-4 1.3H2v2h2c1.4 0 2.8-.4 4-1c2.5 1.3 5.5 1.3 8 0c1.2.6 2.6 1 4 1h2v-2h-2c-1.4 0-2.8-.5-4-1.3Z"/>'
        },
        "shark-fin-outline": {
            body: '<path fill="currentColor" d="M22 16v2h-2c-1.4 0-2.8-.4-4-1c-2.5 1.3-5.5 1.3-8 0c-1.2.6-2.6 1-4 1H2v-2h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0c1.2.8 2.6 1.3 4 1.3h2M5.28 13.79c.54-.16 1.09-.41 1.61-.75L8 12.28c.69-2.28.78-5.01-.41-8.14c4.36.75 8.3 4.51 9.78 9.05c.75.45 1.54.72 2.29.78C18.24 7.4 12.37 2 6 2c-.35 0-.67.18-.85.47c-.18.3-.2.67-.04.98c2.17 4.34 1.5 7.84.17 10.34M16 18.7c-2.4 1.7-5.6 1.7-8 0c-1.2.8-2.6 1.3-4 1.3H2v2h2c1.4 0 2.8-.4 4-1c2.5 1.3 5.5 1.3 8 0c1.2.6 2.6 1 4 1h2v-2h-2c-1.4 0-2.8-.5-4-1.3Z"/>'
        },
        "shark-off": {
            body: '<path fill="currentColor" d="m11.26 8.06l7.27 7.27c.47-.16.93-.33 1.34-.52c-.15-.18-.34-.37-.59-.51c-.65-.39-1.46-.63-2.28-.8c.82-.16 1.67-.28 2.59-.15c.46.06.95.19 1.41.51c.1.06.17.14.24.19C22.4 13.26 23 12.44 23 12c0-.87-3.81-2.5-7.44-2.91C14.66 7.18 12.54 6 11 6c.25.76.31 1.45.26 2.06m5.97 2.32c.61.12 1.2.29 1.74.46c.03.05.03.1.03.16c0 .55-.45 1-1 1s-1-.45-1-1c0-.24.1-.45.23-.62m4.88 11.08l-1.27 1.27l-5.42-5.42c-.54.44-1.07.69-1.42.69v-2c-3 0-8-2-8-2s-2 3-4 3l1-4l-2-6c2 0 5 4 5 4s.96-.38 2.3-.81L1.11 3l1.28-1.27l19.72 19.73Z"/>'
        },
        sheep: {
            body: '<path fill="currentColor" d="M20 8.5a2.5 2.5 0 0 1-2.5 2.5c-1.08 0-2-.69-2.34-1.64c-.44.39-1.02.64-1.66.64c-.56 0-1.08-.19-1.5-.5c-.42.31-.93.5-1.5.5c-.64 0-1.22-.25-1.66-.64C8.5 10.31 7.58 11 6.5 11A2.5 2.5 0 0 1 4 8.5c0-1.24.91-2.27 2.1-2.46c-.06-.17-.1-.35-.1-.54A1.5 1.5 0 0 1 7.5 4c.2 0 .39.04.56.11C8.23 3.47 8.81 3 9.5 3c.25 0 .5.07.68.17C10.5 2.5 11.19 2 12 2s1.5.5 1.82 1.17c.18-.1.43-.17.68-.17c.69 0 1.27.47 1.44 1.11c.17-.07.36-.11.56-.11A1.5 1.5 0 0 1 18 5.5c0 .19-.04.37-.1.54c1.19.19 2.1 1.22 2.1 2.46M10 12a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m6.23-1.34c-.64.81-1.62 1.34-2.73 1.34c-.45 0-.88-.1-1.29-.27c-.01 2.55-.38 5.63-1.76 7.22c-.52.59-1.15.91-1.95 1.01V18h-1v1.96c-.8-.1-1.43-.41-1.95-1.01c-1.39-1.6-1.76-4.66-1.77-7.21c-.4.16-.83.26-1.28.26c-1.11 0-2.09-.53-2.73-1.34C2.88 11.55 2 12 2 12s1 2 3 2c.36 0 .64-.04.88-.09C6.22 17.73 7.58 22 12 22s5.78-4.27 6.12-8.09c.24.05.52.09.88.09c2 0 3-2 3-2s-.88-.45-1.77-1.34Z"/>'
        },
        shield: {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4Z"/>'
        },
        "shield-account": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m0 4a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m5.13 12A9.69 9.69 0 0 1 12 20.92A9.69 9.69 0 0 1 6.87 17c-.34-.5-.63-1-.87-1.53c0-1.65 2.71-3 6-3s6 1.32 6 3c-.24.53-.53 1.03-.87 1.53Z"/>'
        },
        "shield-account-outline": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m0 2.18l7 3.12v4.92c0 1.7-.5 3.43-1.35 4.95C16 14.94 13.26 14.5 12 14.5c-1.26 0-4 .44-5.65 1.67C5.5 14.65 5 12.92 5 11.22V6.3l7-3.12M12 6a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 12 13a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12 6m0 2a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 11a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 8m0 8.5c1.57 0 3.64.61 4.53 1.34C15.29 19.38 13.7 20.55 12 21c-1.7-.45-3.29-1.62-4.53-3.16c.9-.73 2.96-1.34 4.53-1.34Z"/>'
        },
        "shield-account-variant": {
            body: '<path fill="currentColor" d="M17 11c.3 0 .7 0 1 .1V6.3L10.5 3L3 6.3v4.9c0 4.5 3.2 8.8 7.5 9.8c.6-.1 1.1-.3 1.6-.5c-.7-1-1.1-2.2-1.1-3.5c0-3.3 2.7-6 6-6m0 2c-2.2 0-4 1.8-4 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1.4c.6 0 1.1.5 1.1 1.1c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1m0 5.4c-.9 0-1.7-.5-2.2-1.2c.1-.7 1.5-1.1 2.2-1.1s2.2.4 2.2 1.1c-.5.7-1.3 1.2-2.2 1.2Z"/>'
        },
        "shield-account-variant-outline": {
            body: '<path fill="currentColor" d="M17 14.4c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1m0 3.1c-.7 0-2.2.4-2.2 1.1c.5.7 1.3 1.2 2.2 1.2s1.7-.5 2.2-1.2c0-.7-1.5-1.1-2.2-1.1m1-6.4V6.3L10.5 3L3 6.3v4.9c0 4.5 3.2 8.8 7.5 9.8c.6-.1 1.1-.3 1.6-.5C13.2 22 15 23 17 23c3.3 0 6-2.7 6-6c0-3-2.2-5.4-5-5.9M11 17c0 .6.1 1.1.2 1.6c-.2.1-.5.2-.7.3c-3.2-1-5.5-4.2-5.5-7.7V7.6l5.5-2.4L16 7.6v3.5c-2.8.5-5 2.9-5 5.9m6 4c-2.2 0-4-1.8-4-4s1.8-4 4-4s4 1.8 4 4s-1.8 4-4 4Z"/>'
        },
        "shield-airplane": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m0 4.68c.5 0 .95.43.95.95v3.48L18 13.26v1.27l-5.05-1.58v3.47l1.26.95v.95L12 17.68l-2.21.64v-.95l1.26-.95v-3.47L6 14.53v-1.27l5.05-3.15V6.63c0-.52.45-.95.95-.95Z"/>'
        },
        "shield-airplane-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m0-15.32c.5 0 .95.43.95.95v3.48L18 13.26v1.27l-5.05-1.58v3.47l1.26.95v.95L12 17.68l-2.21.64v-.95l1.26-.95v-3.47L6 14.53v-1.27l5.05-3.15V6.63c0-.52.45-.95.95-.95Z"/>'
        },
        "shield-alert": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5M11 7h2v6h-2m0 2h2v2h-2"/>'
        },
        "shield-alert-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21M11 7h2v6h-2V7m0 8h2v2h-2v-2Z"/>'
        },
        "shield-bug": {
            body: '<path fill="currentColor" d="M11 13h2v1h-2v-1m10-8v6c0 5.5-3.8 10.7-9 12c-5.2-1.3-9-6.5-9-12V5l9-4l9 4m-4 5h-2.2c-.2-.6-.6-1.1-1.1-1.5l1.2-1.2l-.7-.7L12.8 8H12c-.2 0-.5 0-.7.1L9.9 6.6l-.8.8l1.2 1.2c-.5.3-.9.8-1.1 1.4H7v1h2v1H7v1h2v1H7v1h2.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H17v-1h-2v-1h2v-1h-2v-1h2v-1m-6 2h2v-1h-2v1Z"/>'
        },
        "shield-bug-outline": {
            body: '<path fill="currentColor" d="m9.9 6.6l-.8.8l1.2 1.2c-.5.3-.9.8-1.1 1.4H7v1h2v1H7v1h2v1H7v1h2.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H17v-1h-2v-1h2v-1h-2v-1h2v-1h-2.2c-.2-.6-.6-1.1-1.1-1.5l1.2-1.2l-.7-.7L12.8 8H12c-.2 0-.5 0-.7.1L9.9 6.6M11 11h2v1h-2v-1m0 2h2v1h-2v-1m10-2c0 5.5-3.8 10.7-9 12c-5.2-1.3-9-6.5-9-12V5l9-4l9 4v6m-9 10c3.8-1 7-5.5 7-9.8V6.3l-7-3.1l-7 3.1v4.9c0 4.3 3.2 8.8 7 9.8Z"/>'
        },
        "shield-car": {
            body: '<path fill="currentColor" d="M14.42 7.5L16 11H8l1.42-3.5h5M9 12c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m6 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m6-7v6c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4m-3 7l-2.16-5c-.2-.58-.76-1-1.42-1h-5C8.76 6 8.2 6.42 8 7l-2 5v4c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h6v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-4Z"/>'
        },
        "shield-check": {
            body: '<path fill="currentColor" d="m10 17l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9m-6-8L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4Z"/>'
        },
        "shield-check-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m-2-4l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9"/>'
        },
        "shield-cross": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12c5.2-1.3 9-6.5 9-12V5l-9-4m4 9h-3v8h-2v-8H8V8h3V5h2v3h3v2Z"/>'
        },
        "shield-cross-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.5-3.8 10.7-9 12c-5.2-1.3-9-6.5-9-12V5l9-4l9 4v6m-9 10c3.8-1 7-5.5 7-9.8V6.3l-7-3.1l-7 3.1v4.9c0 4.3 3.3 8.8 7 9.8m4-12h-3V6h-2v3H8v2h3v8h2v-8h3V9Z"/>'
        },
        "shield-crown": {
            body: '<path fill="currentColor" d="m12 1l9 4v6c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4m4 13H8v1.5c0 .27.19.46.47.5h6.96c.31 0 .52-.16.57-.41V14m1-6l-2.67 2.67L12 8.34l-2.33 2.33L7 8l1 5h8l1-5Z"/>'
        },
        "shield-crown-outline": {
            body: '<path fill="currentColor" d="m12 1l9 4v6c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4m0 2.18L5 6.3v4.92C5 15.54 8.25 20 12 21c3.75-1 7-5.46 7-9.78V6.3l-7-3.12M16 14v1.59c-.04.22-.22.37-.47.41H8.47c-.25-.04-.43-.19-.47-.41V14h8m1-6l-1 5H8L7 8l2.67 2.67L12 8.34l2.33 2.33L17 8Z"/>'
        },
        "shield-edit": {
            body: '<path fill="currentColor" d="m21.7 14.4l-1 1l-2.1-2.1l1-1c.2-.2.6-.2.8 0l1.3 1.3c.2.2.2.5 0 .8M12 19.9l6.1-6.1l2.1 2.1l-6.1 6.1H12v-2.1m-2-.8l11-11V5l-9-4l-9 4v6c0 4.8 2.9 9.3 7 11.3v-3.2Z"/>'
        },
        "shield-edit-outline": {
            body: '<path fill="currentColor" d="m21.7 13.6l-1.3-1.3c-.1-.1-.2-.2-.4-.2c-.1 0-.3.1-.4.2l-1 1l2 2l1-1c.3-.2.3-.5.1-.7M12 19.9V22h2.1l6.1-6.1l-2-2.1l-6.2 6.1m-2 2.4c-4.1-2-7-6.5-7-11.3V5l9-4l9 4v3.1l-2 2V6.3l-7-3.1l-7 3.1v4.9c0 3.5 2.2 7.1 5 8.9v2.2Z"/>'
        },
        "shield-half": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12V1Z"/>'
        },
        "shield-half-full": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12V21Z"/>'
        },
        "shield-home": {
            body: '<path fill="currentColor" d="M11 13h2v3h3v-5h2l-6-5l-6 5h2v5h3v-3m1-12l9 4v6c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4Z"/>'
        },
        "shield-home-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m-1-7h2v3h3v-5h2l-6-5l-6 5h2v5h3v-3"/>'
        },
        "shield-key": {
            body: '<path fill="currentColor" d="M12 8a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m9 3c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9-5a3 3 0 0 0-3 3c0 1.31.83 2.42 2 2.83V18h2v-2h2v-2h-2v-2.17c1.17-.41 2-1.52 2-2.83a3 3 0 0 0-3-3Z"/>'
        },
        "shield-key-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m0-15a3 3 0 0 1 3 3c0 1.31-.83 2.42-2 2.83V14h2v2h-2v2h-2v-6.17A2.99 2.99 0 0 1 9 9a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "shield-link-variant": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m2.28 13.08l-2.02 2.02c-.6.6-1.39.9-2.18.9c-.79 0-1.58-.3-2.18-.9a3.09 3.09 0 0 1 0-4.36l1.25-1.24l-.01.56c0 .44.07.89.22 1.31l.05.13l-.37.37c-.28.28-.44.66-.44 1.05c0 .4.16.77.44 1.05c.56.56 1.53.56 2.09 0l2.01-2.01c.29-.29.44-.66.44-1.05c0-.41-.15-.77-.43-1.05a.83.83 0 0 1-.25-.57c0-.21.1-.41.25-.56c.3-.31.85-.3 1.13 0c.58.58.9 1.35.9 2.17c0 .83-.32 1.6-.9 2.18m2.82-2.82l-1.25 1.24l.01-.56c0-.44-.07-.88-.22-1.3l-.04-.14l.36-.37c.29-.28.44-.63.44-1.05c0-.39-.15-.76-.43-1.04c-.57-.57-1.54-.57-2.1 0l-2.01 2.01c-.28.28-.44.65-.44 1.05s.15.76.44 1.04c.14.15.24.36.24.57c0 .22-.1.42-.25.57c-.15.16-.35.22-.56.22c-.2 0-.41-.07-.57-.22a3.054 3.054 0 0 1 0-4.36l2.02-2.02a3.09 3.09 0 0 1 4.36 0c.58.6.9 1.36.9 2.18c0 .82-.32 1.6-.9 2.18Z"/>'
        },
        "shield-link-variant-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m2.28-11.27c.58.58.9 1.35.9 2.17c0 .83-.32 1.6-.9 2.18l-2.02 2.02c-.6.6-1.39.9-2.18.9c-.79 0-1.58-.3-2.18-.9a3.09 3.09 0 0 1 0-4.36l1.25-1.24l-.01.56c0 .44.07.89.22 1.3l.04.14l-.36.37c-.29.28-.44.63-.44 1.05c0 .39.15.76.43 1.04c.57.57 1.54.57 2.1.01l2.01-2.02c.29-.28.44-.65.44-1.04c0-.41-.15-.77-.44-1.05a.866.866 0 0 1-.24-.57c0-.21.1-.42.24-.57c.31-.3.86-.3 1.14.01M18 9.08c0 .82-.32 1.6-.9 2.18l-1.25 1.24l.01-.56c0-.44-.07-.88-.22-1.3l-.05-.14l.37-.37c.29-.28.44-.63.44-1.05c0-.39-.15-.76-.44-1.04c-.56-.57-1.53-.57-2.09-.01l-2.01 2.02c-.29.28-.44.65-.44 1.05s.15.76.43 1.04c.15.15.25.36.25.57c0 .22-.1.42-.25.57c-.15.15-.35.22-.56.22c-.2 0-.41-.07-.57-.22a3.054 3.054 0 0 1 0-4.36l2.02-2.02a3.09 3.09 0 0 1 4.36 0c.58.6.9 1.36.9 2.18Z"/>'
        },
        "shield-lock": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m0 6c1.4 0 2.8 1.1 2.8 2.5V11c.6 0 1.2.6 1.2 1.3v3.5c0 .6-.6 1.2-1.3 1.2H9.2c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2V9.5C9.2 8.1 10.6 7 12 7m0 1.2c-.8 0-1.5.5-1.5 1.3V11h3V9.5c0-.8-.7-1.3-1.5-1.3Z"/>'
        },
        "shield-lock-open": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12c5.2-1.3 9-6.5 9-12V5l-9-4m4 14.8c0 .6-.6 1.2-1.3 1.2H9.2c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2V8.5C9.2 7.1 10.6 6 12 6s2.8 1.1 2.8 2.5V9h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V11h4.3c.6 0 1.2.6 1.2 1.3v3.5Z"/>'
        },
        "shield-lock-open-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.5-3.8 10.7-9 12c-5.2-1.3-9-6.5-9-12V5l9-4l9 4v6m-9 10c3.8-1 7-5.5 7-9.8V6.3l-7-3.1l-7 3.1v4.9c0 4.3 3.2 8.8 7 9.8m2.8-10h-4.3V8.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V9h1.3v-.5C14.8 7.1 13.4 6 12 6S9.2 7.1 9.2 8.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "shield-lock-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m2.8-10V9.5C14.8 8.1 13.4 7 12 7S9.2 8.1 9.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11Z"/>'
        },
        "shield-moon": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m3.97 13.41c-1.84 2.17-5.21 2.09-6.97-.07c-2.18-2.72-.64-6.72 2.7-7.34c.34-.05.63.28.51.61c-.46 1.23-.39 2.64.32 3.86a4.51 4.51 0 0 0 3.18 2.2c.34.05.49.47.26.74Z"/>'
        },
        "shield-moon-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m-3-6.67c1.76 2.17 5.13 2.24 6.97.07c.23-.27.08-.68-.26-.74a4.491 4.491 0 0 1-3.18-2.2a4.503 4.503 0 0 1-.32-3.86a.453.453 0 0 0-.51-.6c-3.34.62-4.89 4.61-2.7 7.33"/>'
        },
        "shield-off": {
            body: '<path fill="currentColor" d="M1 4.27L2.28 3L20.5 21.22l-1.27 1.28L17 20.25c-1.43 1.32-3.13 2.29-5 2.75c-5.16-1.26-9-6.45-9-12V6.27l-2-2M12 1l9 4v6c0 2.28-.65 4.5-1.77 6.41L5.65 3.82L12 1Z"/>'
        },
        "shield-off-outline": {
            body: '<path fill="currentColor" d="m1 4.27l2 2V11c0 5.55 3.84 10.74 9 12c1.87-.46 3.57-1.44 4.97-2.76l2.26 2.26l1.27-1.28L2.28 3L1 4.27M12 21c-3.75-1-7-5.46-7-9.78V8.27l10.59 10.59C14.53 19.89 13.3 20.65 12 21m9-16v6c0 2.28-.65 4.5-1.77 6.4l-1.46-1.45c.77-1.45 1.23-3.11 1.23-4.73V6.3l-7-3.12l-4.84 2.16l-1.51-1.52L12 1l9 4Z"/>'
        },
        "shield-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21Z"/>'
        },
        "shield-plus": {
            body: '<path fill="currentColor" d="M19 20v2.97h-2V20h-3v-2h3v-3h2v3h3v2h-3M12 1l9 4v6c0 .9-.1 1.78-.29 2.65A5.8 5.8 0 0 0 18 13a6 6 0 0 0-6 6c0 1.36.45 2.62 1.22 3.62L12 23c-5.16-1.26-9-6.45-9-12V5l9-4Z"/>'
        },
        "shield-plus-outline": {
            body: '<path fill="currentColor" d="M19 20v2.97h-2V20h-3v-2h3v-3h2v3h3v2h-3m2-9c0 .9-.1 1.78-.29 2.65c-.58-.3-1.21-.5-1.9-.6c.12-.6.19-1.22.19-1.83V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21l.31-.09c.19.62.52 1.2.91 1.71L12 23c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6Z"/>'
        },
        "shield-refresh": {
            body: '<path fill="currentColor" d="M18 12c1 0 2 .2 2.9.7c.1-.6.1-1.1.1-1.7V5l-9-4l-9 4v6c0 5.5 3.8 10.7 9 12c.4-.1.7-.2 1-.3c-1-1.2-1.5-2.7-1.5-4.2c0-3.6 2.9-6.5 6.5-6.5m0 2.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4Z"/>'
        },
        "shield-refresh-outline": {
            body: '<path fill="currentColor" d="M12 21c-3.8-1-7-5.5-7-9.8V6.3l7-3.1l7 3.1v5.8c.7.1 1.3.3 1.9.6c.1-.6.1-1.1.1-1.7V5l-9-4l-9 4v6c0 5.5 3.8 10.7 9 12c.4-.1.7-.2 1-.3c-.4-.5-.8-1.1-1-1.7m6-6.5c1.1 0 2.1.4 2.8 1.2l1.2-1.2v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5S16.6 21 18 21c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4Z"/>'
        },
        "shield-remove": {
            body: '<path fill="currentColor" d="m19.43 19l2.07 2.11l-1.38 1.39l-2.09-2.09l-2.12 2.12l-1.41-1.42L16.61 19l-2.11-2.14l1.38-1.39L18 17.59l2.12-2.12l1.43 1.43l-2.12 2.1M12 1l9 4v6c0 .9-.1 1.78-.29 2.65A5.8 5.8 0 0 0 18 13a6 6 0 0 0-6 6c0 1.36.45 2.62 1.22 3.62L12 23c-5.16-1.26-9-6.45-9-12V5l9-4Z"/>'
        },
        "shield-remove-outline": {
            body: '<path fill="currentColor" d="m19.43 19l2.07 2.11l-1.38 1.39l-2.09-2.09l-2.12 2.12l-1.41-1.42L16.61 19l-2.11-2.14l1.38-1.39L18 17.59l2.12-2.12l1.43 1.43l-2.12 2.1M21 11c0 .9-.1 1.78-.29 2.65c-.58-.3-1.21-.5-1.9-.6c.12-.6.19-1.22.19-1.83V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21l.31-.09c.19.62.52 1.2.91 1.71L12 23c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6Z"/>'
        },
        "shield-search": {
            body: '<path fill="currentColor" d="M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m5.86 10.31C16.23 21.22 14.28 22.45 12 23c-2.56-.61-4.7-2.07-6.42-4.37C3.86 16.34 3 13.8 3 11V5l9-4l9 4v6c0 2.39-.64 4.61-1.92 6.67l-2.91-2.91c.52-.79.83-1.76.83-2.76a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5c1 0 1.97-.31 2.76-.83l3.1 3.14Z"/>'
        },
        "shield-star": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m3.08 15L12 14.15L8.93 16l.81-3.5l-2.71-2.34l3.58-.31L12 6.55l1.39 3.29l3.58.31l-2.71 2.35l.82 3.5Z"/>'
        },
        "shield-star-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m3.05-5l-3.08-1.85L8.9 16l.81-3.5L7 10.16l3.58-.31l1.39-3.3l1.4 3.29l3.58.31l-2.72 2.35l.82 3.5"/>'
        },
        "shield-sun": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4m0 7.89c1.6 0 2.89 1.29 2.89 2.89S13.6 14.67 12 14.67s-2.89-1.3-2.89-2.89s1.3-2.89 2.89-2.89M12 6l1.38 2c-.42-.18-.88-.27-1.38-.27s-.95.09-1.38.27L12 6M7 8.89l2.4-.2c-.34.31-.66.65-.9 1.07c-.25.42-.4.86-.5 1.32L7 8.89m0 5.78l1.03-2.17c.08.43.24.88.47 1.3c.25.43.56.79.9 1.08L7 14.67m10-5.78l-1 2.19c-.1-.46-.26-.9-.5-1.32c-.24-.42-.55-.76-.9-1.08l2.4.21m0 5.78l-2.4.2c.34-.29.65-.65.9-1.07c.24-.42.39-.87.47-1.3L17 14.67m-5 2.88l-1.39-1.98c.43.15.89.25 1.39.25c.5 0 .95-.1 1.37-.25L12 17.55Z"/>'
        },
        "shield-sun-outline": {
            body: '<path fill="currentColor" d="M21 11c0 5.55-3.84 10.74-9 12c-5.16-1.26-9-6.45-9-12V5l9-4l9 4v6m-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21m0-12.11c1.6 0 2.89 1.29 2.89 2.89S13.6 14.67 12 14.67s-2.89-1.3-2.89-2.89s1.3-2.89 2.89-2.89M12 6l1.38 2c-.42-.18-.88-.27-1.38-.27s-.95.09-1.38.27L12 6M7 8.89l2.4-.2c-.34.31-.66.65-.9 1.07c-.25.42-.4.86-.5 1.32L7 8.89m0 5.78l1.03-2.17c.08.43.24.88.47 1.3c.25.43.56.79.9 1.08L7 14.67m10-5.78l-1 2.19c-.1-.46-.26-.9-.5-1.32c-.24-.42-.55-.76-.9-1.08l2.4.21m0 5.78l-2.4.2c.34-.29.65-.65.9-1.07c.24-.42.39-.87.47-1.3L17 14.67m-5 2.88l-1.39-1.98c.43.15.89.25 1.39.25c.5 0 .95-.1 1.37-.25L12 17.55Z"/>'
        },
        "shield-sword": {
            body: '<path fill="currentColor" d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12c5.2-1.3 9-6.5 9-12V5l-9-4m3 14h-2v3h-2v-3H9v-2h2l-1-5.9l2-1.6l2 1.6l-1 5.9h2v2Z"/>'
        },
        "shield-sword-outline": {
            body: '<path fill="currentColor" d="m12 1l9 4v6c0 5.5-3.8 10.7-9 12c-5.2-1.3-9-6.5-9-12V5l9-4m0 2.2L5 6.3v4.9c0 4.3 3.2 8.8 7 9.8c3.8-1 7-5.5 7-9.8V6.3l-7-3.1m0 2.3l2 1.6l-1 5.9h2v2h-2v3h-2v-3H9v-2h2l-1-5.9l2-1.6Z"/>'
        },
        "shield-sync": {
            body: '<path fill="currentColor" d="M18 12a6.41 6.41 0 0 1 2.87.67A11.63 11.63 0 0 0 21 11V5l-9-4l-9 4v6c0 5.55 3.84 10.74 9 12c.35-.09.7-.2 1-.32a6.42 6.42 0 0 1-1.5-4.18A6.5 6.5 0 0 1 18 12m0 2.5V13l-2.25 2.25L18 17.5V16a2.5 2.5 0 0 1 2.24 3.62l1.09 1.09A4 4 0 0 0 18 14.5m0 6.5a2.5 2.5 0 0 1-2.24-3.62l-1.09-1.09A4 4 0 0 0 18 22.5V24l2.25-2.25L18 19.5Z"/>'
        },
        "shield-sync-outline": {
            body: '<path fill="currentColor" d="M12 21c-3.75-1-7-5.46-7-9.78V6.3l7-3.12l7 3.12v5.77a6.45 6.45 0 0 1 1.91.6A11.63 11.63 0 0 0 21 11V5l-9-4l-9 4v6c0 5.55 3.84 10.74 9 12c.35-.09.7-.2 1-.32A6.3 6.3 0 0 1 12 21m6-6.5V13l-2.25 2.25L18 17.5V16a2.5 2.5 0 0 1 2.24 3.62l1.09 1.09A4 4 0 0 0 18 14.5m0 6.5a2.5 2.5 0 0 1-2.24-3.62l-1.09-1.09A4 4 0 0 0 18 22.5V24l2.25-2.25L18 19.5Z"/>'
        },
        shimmer: {
            body: '<path fill="currentColor" d="M10.6 9.6L9 15L7.4 9.6L2 8l5.4-1.6L9 1l1.6 5.4L16 8l-5.4 1.6m6.4 4.6l4-2.2l-2.2 4l2.2 4l-4-2.2l-4 2.2l2.2-4l-2.2-4l4 2.2M10 16l-1.7 3l1.7 3l-3-1.7L4 22l1.7-3L4 16l3 1.7l3-1.7"/>'
        },
        "ship-wheel": {
            body: '<path fill="currentColor" d="m2 11l2.05.1a7.96 7.96 0 0 1 3.2-5.54L6.13 3.84c-.27-.48-.13-1.09.37-1.37c.5-.27 1.09-.11 1.37.37l.93 1.82a8.102 8.102 0 0 1 6.4 0l.93-1.82c.28-.48.87-.64 1.37-.37c.5.28.64.89.37 1.37l-1.12 1.72a7.96 7.96 0 0 1 3.2 5.54L22 11a1 1 0 0 1 1 1a1 1 0 0 1-1 1l-2.05-.1a7.96 7.96 0 0 1-3.2 5.54l1.12 1.72c.27.48.13 1.09-.37 1.37c-.5.27-1.09.11-1.37-.37l-.93-1.82a8.102 8.102 0 0 1-6.4 0l-.93 1.82c-.28.48-.87.64-1.37.37c-.5-.28-.64-.89-.37-1.37l1.12-1.72a7.96 7.96 0 0 1-3.2-5.54L2 13a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7.07.35c.13-.61.46-1.15.93-1.56L8.34 7.25a5.993 5.993 0 0 0-2.29 3.95l3.02.15M12 9c.32 0 .62.05.9.14l1.38-2.69C13.58 6.16 12.81 6 12 6c-.81 0-1.58.16-2.28.45l1.38 2.69c.28-.09.58-.14.9-.14m2.93 2.35l3.02-.15a5.993 5.993 0 0 0-2.29-3.95L14 9.79c.47.41.8.95.93 1.56m0 1.3c-.13.61-.46 1.15-.93 1.56l1.66 2.54a5.993 5.993 0 0 0 2.29-3.95l-3.02-.15M12 15c-.32 0-.62-.05-.91-.14l-1.37 2.69c.7.29 1.47.45 2.28.45c.81 0 1.58-.16 2.28-.45l-1.37-2.69c-.29.09-.59.14-.91.14m-2.93-2.35l-3.02.15c.22 1.6 1.06 3.01 2.29 3.95L10 14.21c-.47-.41-.8-.95-.93-1.56Z"/>'
        },
        "shipping-pallet": {
            body: '<path fill="currentColor" d="M3 20h2v-2h6v2h2v-2h6v2h2v-5h-2v1h-2v-1h-2v1h-2v-1h-2v1H9v-1H7v1H5v-1H3m2-2h14V4H5Z"/>'
        },
        "shoe-ballet": {
            body: '<path fill="currentColor" d="M12.78 11.97C12.27 8.54 10.86 2 7.53 2S2.8 8.54 2.28 11.97c-.21 1.45-.28 2.92-.12 4.38c.34 3.04 1.39 4.49 2.11 5.15c.37.33.84.5 1.33.5h3.87c.49 0 .96-.17 1.33-.5c.7-.66 1.75-2.11 2.11-5.15c.17-1.46.09-2.93-.13-4.38M7.53 4c.36-.13 1.06.73 1.74 2.31l-4.69 4.02C5.41 6.26 6.94 3.79 7.53 4m2.22 9H5.31a.96.96 0 0 1-.55-.19L10 8.33c.29 1.02.56 2.17.75 3.5c.09.61-.38 1.17-1 1.17m12.03-1.03C21.27 8.54 19.86 2 16.53 2c-1.49 0-2.59 1.32-3.4 3.08c.37.96.71 2.06 1 3.29l5.18 4.44c-.16.11-.34.19-.56.19h-3.83c.12 1.27.11 2.45-.03 3.59c-.27 2.28-.89 3.86-1.57 4.94c.36.31.81.47 1.28.47h3.87c.49 0 .96-.17 1.33-.5c.7-.66 1.75-2.11 2.11-5.15c.17-1.46.09-2.93-.13-4.38M14.8 6.31c.7-1.58 1.38-2.44 1.73-2.31c.6-.21 2.12 2.26 2.97 6.33l-4.7-4.02Z"/>'
        },
        "shoe-cleat": {
            body: '<path fill="currentColor" d="M21 8h-.7l-.05-.03c-2.11-.13-3.87-.8-4.72-1.74L14 7c-.05.1-.11.19-.16.28c.71.61 1.16 1.37 1.16 2.22c0 .33-.09.64-.21.95l-1.87-1.87c-.22.25-.45.49-.7.71l2.03 2.03c-.21.25-.45.47-.75.68l-2.07-2.09c-.29.2-.58.37-.88.54l2.03 2.05c-.33.13-.69.24-1.08.32l-1.91-1.91c-.34.14-.68.27-1.03.38l1.7 1.71H10c-1.5 0-2.8-.46-3.72-1.18c-.82.13-1.6.18-2.28.18c-2 0-2 3-2 3c0 1.11.89 2 2 2v1c0 .55.45 1 1 1s1-.45 1-1v-1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h3v1c0 .55.45 1 1 1s1-.45 1-1v-1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1s1 0 1-4.5C22 9 21 8 21 8Z"/>'
        },
        "shoe-formal": {
            body: '<path fill="currentColor" d="M21.5 9V8h-1l-1 1H15l-1-1h-1l-6 4H4a2 2 0 0 0-2 2v2h8l3-1h2v1h6.5v-2s.5-1 .5-2.5s-.5-2.5-.5-2.5Z"/>'
        },
        "shoe-heel": {
            body: '<path fill="currentColor" d="M3 18h8.7l5.3-4h1v4h2v-4s1-2 1-4s-.5-4-.5-4h-2L18 7l-8 7H8l-5 2v2Z"/>'
        },
        "shoe-print": {
            body: '<path fill="currentColor" d="M10.74 11.72c.47 1.23.42 2.51-.99 3.02c-2.9 1.07-3.55-1.74-3.59-1.88l4.58-1.14m-5.03-.81l4.32-1.07c-.19-1.05.1-2.1.1-3.34c0-1.68-1.33-4.97-3.45-4.44c-2.42.6-2.77 3.29-2.68 4.59c.12 1.3 1.64 4.08 1.71 4.26m12.14 8.94c-.03.15-.69 2.95-3.59 1.89c-1.4-.52-1.46-1.8-.99-3.03l4.58 1.14m2.15-6.2c.1-1.3-.24-4-2.67-4.6c-2.11-.55-3.44 2.76-3.44 4.45c0 1.23.28 2.28.11 3.33l4.3 1.07c.08-.18 1.59-2.96 1.7-4.25Z"/>'
        },
        "shoe-sneaker": {
            body: '<path fill="currentColor" d="M2 15s0-3 2-3c.68 0 1.46-.05 2.28-.18C7.2 12.54 8.5 13 10 13h.25l-1.69-1.71c.35-.11.69-.24 1.03-.38l1.91 1.91c.39-.08.75-.19 1.08-.32l-2.03-2.05c.3-.17.59-.34.88-.54L13.5 12c.3-.21.54-.44.75-.68l-2.03-2.03c.24-.22.48-.46.7-.71l1.87 1.87c.12-.31.21-.62.21-.95c0-.85-.45-1.61-1.16-2.22c.05-.09.11-.18.16-.28l1.53-.77c.85.94 2.61 1.61 4.72 1.74l.05.03h.7s1 1 1 4.5c0 .57 0 1.07-.04 1.5H19c-1.1 0-2.42.26-3.7.5c-1.18.26-2.4.5-3.3.5H2m19 2s.58 0 .86-2H19c-2 0-5 1-7 1H2.28c.34.6.98 1 1.72 1h17Z"/>'
        },
        shopify: {
            body: '<path d="M18.61 5.89c-.01-.1-.11-.16-.17-.16c-.07-.01-1.61-.12-1.61-.12s-1.07-1.06-1.18-1.18c-.12-.12-.35-.08-.44-.06c-.01 0-.21.07-.6.18c-.36-1.05-.99-1.97-2.18-1.97c-.32-.4-.71-.58-1.05-.58c-2.58 0-3.81 3.22-4.2 4.86l-1.81.56c-.55.18-.57.2-.64.72c-.06.4-1.52 11.72-1.52 11.72L14.61 22l6.18-1.34S18.62 6 18.61 5.89M14 4.76c-.31.09-.63.19-1 .3v-.21c0-.64-.07-1.15-.21-1.56c.56.07.94.71 1.21 1.47m-1.92-1.34c.16.4.26.97.26 1.74v.11c-.63.19-1.31.41-1.99.62c.38-1.49 1.1-2.2 1.73-2.47m-.77-.73c.11 0 .22.04.33.11c-.83.39-1.71 1.37-2.09 3.32c-.55.18-1.08.34-1.55.5c.42-1.5 1.46-3.93 3.31-3.93m1.19 6.46l-.74 2.27s-.67-.36-1.49-.36c-1.2 0-1.27.75-1.27.94c0 1.04 2.71 1.43 2.71 3.86c0 1.91-1.21 3.14-2.84 3.14c-1.96 0-2.96-1.22-2.96-1.22l.52-1.73s1.03.88 1.9.88c.57 0 .8-.43.8-.77c0-1.35-2.21-1.41-2.21-3.63c0-1.87 1.34-3.68 4.05-3.68c1.03 0 1.53.3 1.53.3m2.93-3.86l1.32 1.31l.96.08c.34 2.32 1.48 10.05 1.95 13.2l-5 1.09l.77-15.68z" fill="currentColor"/>',
            hidden: true
        },
        shopping: {
            body: '<path fill="currentColor" d="M12 13a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2a5 5 0 0 1-5 5m0-10a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3m7 3h-2a5 5 0 0 0-5-5a5 5 0 0 0-5 5H5c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/>'
        },
        "shopping-music": {
            body: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3m7 3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.11.89-2 2-2h2a5 5 0 0 1 5-5a5 5 0 0 1 5 5h2M9 19l7.5-5L9 10v9Z"/>'
        },
        "shopping-outline": {
            body: '<path fill="currentColor" d="M19 6h-2c0-2.8-2.2-5-5-5S7 3.2 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-7-3c1.7 0 3 1.3 3 3H9c0-1.7 1.3-3 3-3m7 17H5V8h14v12m-7-8c-1.7 0-3-1.3-3-3H7c0 2.8 2.2 5 5 5s5-2.2 5-5h-2c0 1.7-1.3 3-3 3Z"/>'
        },
        "shopping-search": {
            body: '<path fill="currentColor" d="M19 6h-2A5 5 0 0 0 7 6H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7.05A6.5 6.5 0 0 1 9 16.5a6.4 6.4 0 0 1 1.25-3.82A5 5 0 0 1 7 8h2a3 3 0 0 0 3 3h.06a6.22 6.22 0 0 1 2-.84A3 3 0 0 0 15 8h2a4.88 4.88 0 0 1-.46 2.09a6.5 6.5 0 0 1 4.46 3V8a2 2 0 0 0-2-2M9 6a3 3 0 0 1 6 0m4.31 12.9a4.5 4.5 0 1 0-1.43 1.42L21 23.39L22.39 22m-6.89-3a2.5 2.5 0 1 1 2.5-2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "shopping-search-outline": {
            body: '<path fill="currentColor" d="M19.31 18.9c1.33-2.1.69-4.9-1.4-6.21S13.03 12 11.7 14.1s-.7 4.9 1.4 6.2c1.46.92 3.32.93 4.78.02L21 23.39L22.39 22m-6.89-3a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5m-5.47 1H5V8h14v3.03c.81.52 1.5 1.21 2 2.02V8c0-1.1-.9-2-2-2h-2c0-2.8-2.2-5-5-5S7 3.2 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7.05c-.81-.5-1.5-1.19-2.02-2M12 3c1.7 0 3 1.3 3 3H9c0-1.7 1.3-3 3-3m3 6h2c0 .4-.05.78-.14 1.15c-.44-.1-.89-.15-1.36-.15c-.23 0-.46 0-.68.04c.11-.33.18-.67.18-1.04m-5.24 4.46A4.915 4.915 0 0 1 7 9h2c0 1.34.82 2.42 2 2.82c-.5.48-.92 1.03-1.24 1.64Z"/>'
        },
        shore: {
            body: '<path fill="currentColor" d="M20 12h2v2h-2c-1.4 0-2.7-.4-4-1c-2.5 1.3-5.5 1.3-8 0c-1.3.6-2.6 1-4 1H2v-2h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0c1.2.8 2.6 1.3 4 1.3m0-6h2v2h-2c-1.4 0-2.7-.3-4-1c-2.5 1.3-5.5 1.3-8 0c-1.3.7-2.6 1-4 1H2V6h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0c1.2.8 2.6 1.3 4 1.3m2 14H2v-2h20"/>'
        },
        shovel: {
            body: '<path fill="currentColor" d="m15.1 1.81l-2.83 2.83c-.77.78-.77 2.05 0 2.83l1.41 1.41l-4.55 4.55l-2.82-2.83L4.89 12c-4.95 5-1.39 8.5-1.39 8.5S7 24 12 19.09l1.41-1.41l-2.8-2.8l4.54-4.54l1.39 1.39c.78.77 2.05.77 2.83 0L22.2 8.9l-7.1-7.09m2.83 8.47L16.55 8.9l-1.44-1.44l-1.4-1.4l1.41-1.41l4.23 4.23l-1.42 1.4Z"/>'
        },
        "shovel-off": {
            body: '<path fill="currentColor" d="m15.1 1.81l-2.83 2.84a2.01 2.01 0 0 0 0 2.82l1.41 1.42l-.68.73l1.44 1.44l.73-.73l1.39 1.39c.78.78 2.05.78 2.83 0l2.83-2.84l-7.12-7.07m2.83 8.47L13.7 6.06l1.41-1.41l4.23 4.23l-1.41 1.4m2.77 9.96l-1.41 1.41l-7.79-7.77l-1 1l2.83 2.81l-1.33 1.4C7 24 3.5 20.5 3.5 20.5S-.06 17 4.89 12l1.42-1.4l2.82 2.83l1-1l-7.78-7.75l1.42-1.42L20.7 20.24Z"/>'
        },
        shower: {
            body: '<path fill="currentColor" d="M21 14v1c0 1.91-1.07 3.57-2.65 4.41L19 22h-2l-.5-2h-9L7 22H5l.65-2.59A4.987 4.987 0 0 1 3 15v-1H2v-2h18V5a1 1 0 0 0-1-1c-.5 0-.88.34-1 .79c.63.54 1 1.34 1 2.21h-6a3 3 0 0 1 3-3h.17c.41-1.16 1.52-2 2.83-2a3 3 0 0 1 3 3v9h-1m-2 0H5v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1Z"/>'
        },
        "shower-head": {
            body: '<path fill="currentColor" d="M20 20a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m2-3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M8 14a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m3-2H5v-2h14v2m-1.08-3H6.08C6.5 6.5 8.5 4.5 11 4.08V2h2v2.08c2.5.42 4.5 2.42 4.92 4.92Z"/>'
        },
        shredder: {
            body: '<path fill="currentColor" d="M6 3v4h2V5h8v2h2V3H6M5 8a3 3 0 0 0-3 3v6h3v-3h14v3h3v-6a3 3 0 0 0-3-3H5m13 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 16v5h2v-5H7m4 0v4h2v-4h-2m4 0v5h2v-5h-2Z"/>'
        },
        shuffle: {
            body: '<path fill="currentColor" d="m14.83 13.41l-1.41 1.41l3.13 3.13L14.5 20H20v-5.5l-2.04 2.04l-3.13-3.13M14.5 4l2.04 2.04L4 18.59L5.41 20L17.96 7.46L20 9.5V4m-9.41 5.17L5.41 4L4 5.41l5.17 5.17l1.42-1.41Z"/>'
        },
        "shuffle-disabled": {
            body: '<path fill="currentColor" d="M16 4.5V7H5v2h11v2.5L19.5 8M16 12.5V15H5v2h11v2.5l3.5-3.5"/>'
        },
        "shuffle-variant": {
            body: '<path fill="currentColor" d="m17 3l5.25 4.5L17 12l5.25 4.5L17 21v-3h-2.74l-2.82-2.82l2.12-2.12L15.5 15H17V9h-1.5l-9 9H2v-3h3.26l9-9H17V3M2 6h4.5l2.82 2.82l-2.12 2.12L5.26 9H2V6Z"/>'
        },
        shuriken: {
            body: '<path fill="currentColor" d="M14.5 9.5L12 2L9.5 9.5L2 12l7.5 2.5L12 22l2.5-7.5L22 12l-7.5-2.5M12 13.7c-.9 0-1.7-.7-1.7-1.7c0-.9.7-1.7 1.7-1.7c.9 0 1.7.7 1.7 1.7c0 .9-.8 1.7-1.7 1.7Z"/>'
        },
        sickle: {
            body: '<path fill="currentColor" d="M19.3 7.2C17.5 4.7 14.9 3 12 2c14.2 8.5 3.4 20.9-3.5 13.5l-2.6.5l-3.4 3.4c-.6.6-.6 1.6 0 2.1c.6.6 1.6.6 2.1 0l3.2-3.2c7.5 6 17.2-3.3 11.5-11.1Z"/>'
        },
        sigma: {
            body: '<path fill="currentColor" d="M18 6H8.83l6 6l-6 6H18v2H6v-2l6-6l-6-6V4h12v2Z"/>'
        },
        "sigma-lower": {
            body: '<path fill="currentColor" d="M19 12c0 4.42-3.36 8-7.5 8C7.36 20 4 16.42 4 12s3.36-8 7.5-8H20v2h-3.54A8.291 8.291 0 0 1 19 12m-7.5-6C8.46 6 6 8.69 6 12s2.46 6 5.5 6s5.5-2.69 5.5-6s-2.46-6-5.5-6Z"/>'
        },
        "sign-caution": {
            body: '<path fill="currentColor" d="M2 3h20v10h-4v8h-2v-8H8v8H6v-8H2V3m16.97 8L20 9.97V7.15L16.15 11h2.82m-5.65 0l6-6H16.5l-6 6h2.82m-5.66 0l6-6h-2.83l-6 6h2.83M5.18 5L4 6.18V9l4-4H5.18Z"/>'
        },
        "sign-direction": {
            body: '<path fill="currentColor" d="M11 12H3.5L6 9.5L3.5 7H11V3l1-1l1 1v4h5l2.5 2.5L18 12h-5v8a2 2 0 0 1 2 2H9a2 2 0 0 1 2-2v-8Z"/>'
        },
        "sign-direction-minus": {
            body: '<path fill="currentColor" d="M20.5 9.5L18 12h-5v10H9a2 2 0 0 1 2-2v-8H3.5L6 9.5L3.5 7H11V3l1-1l1 1v4h5m5 11h-8v2h8Z"/>'
        },
        "sign-direction-plus": {
            body: '<path fill="currentColor" d="M13 20h.09a5.5 5.5 0 0 0 .72 2H9a2 2 0 0 1 2-2v-8H3.5L6 9.5L3.5 7H11V3l1-1l1 1v4h5l2.5 2.5L18 12h-5m5 3v3h-3v2h3v3h2v-3h3v-2h-3v-3Z"/>'
        },
        "sign-direction-remove": {
            body: '<path fill="currentColor" d="M13 20h.09a5.5 5.5 0 0 0 .72 2H9a2 2 0 0 1 2-2v-8H3.5L6 9.5L3.5 7H11V3l1-1l1 1v4h5l2.5 2.5L18 12h-5m8.12 3.46L19 17.59l-2.12-2.13l-1.42 1.42L17.59 19l-2.13 2.12l1.42 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "sign-language": {
            body: '<path fill="currentColor" d="M7.5 4c.4-.4 1-.4 1.4 0l2.9 3c-.8.4-1.2.6-1.6 1.2L7.5 5.5c-.4-.4-.4-1.1 0-1.5M6.3 7.2c.4-.4 1-.4 1.4 0l1.9 2c-.2.6-.3 1.3-.2 1.8h-.8L6.3 8.6c-.4-.4-.4-1 0-1.4M19 21.5c0 1.4-1.1 2.5-2.5 2.5h-11c-.5 0-1-.5-1-1s.5-1 1-1H10v-1H4c-.5 0-1-.5-1-1s.5-1 1-1h6v-1H3c-.5 0-1-.5-1-1s.5-1 1-1h7v-1H4.5c-.5 0-1-.5-1-1s.5-1 1-1h8l-.9-1.9c-.4-.7-.1-1.6.7-2l.2-.1l5.7 5.5c.5.5.8 1.1.8 1.8v5.2m3-10.2c0 .7-.3 1.3-.8 1.8l-.9.8c-.2-.3-.4-.6-.7-.9l-.6-.6L15.4 9l-2.7-2.4l-3.8-4c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l4.8 5.1l.7-.7l-3.8-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L18.9 6l.7-2c.5-.6 1.4-1 2.1-.8l.3.1v8Z"/>'
        },
        "sign-language-outline": {
            body: '<path fill="currentColor" d="M7.5 4c.4-.4 1-.4 1.4 0l2.9 3c-.8.4-1.2.6-1.6 1.2L7.5 5.5c-.4-.4-.4-1.1 0-1.5M6.3 7.2c.4-.4 1-.4 1.4 0l1.9 2c-.2.6-.3 1.3-.2 1.8h-.8L6.3 8.6c-.4-.4-.4-1 0-1.4m11.9 7.3L12.5 9l-.3.1c-.7.4-1 1.3-.7 2l.9 1.9h-8c-.5 0-1 .5-1 1s.5 1 1 1H10v1H3c-.5 0-1 .5-1 1s.5 1 1 1h7v1H4c-.5 0-1 .5-1 1s.5 1 1 1h6v1H5.5c-.5 0-1 .5-1 1s.5 1 1 1h11c1.4 0 2.5-1.1 2.5-2.5v-5.2c0-.7-.3-1.4-.8-1.8M17 21c0 .5-.5 1-1 1h-4v-7h2v-1.8l2.7 2.5c.2.2.3.5.3.7V21m5-9.7c0 .7-.3 1.3-.8 1.8l-.9.8c-.2-.3-.4-.6-.7-.9l-.6-.6l.7-.7c.2-.2.3-.5.3-.7V7.3l-1.3 1.2L17.3 7l-1.9 2l-2.7-2.4l-3.8-4c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l4.8 5.1l.7-.7l-3.8-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L18.9 6l.7-2c.5-.6 1.4-1 2.1-.8l.3.1v8Z"/>'
        },
        "sign-pole": {
            body: '<path fill="currentColor" d="m11 3l1-1l1 1v17a2 2 0 0 1 2 2H9c0-1.1.9-2 2-2V3Z"/>'
        },
        "sign-real-estate": {
            body: '<path fill="currentColor" d="M18 8H8c-1.1 0-2 .9-2 2v6a2 2 0 0 0 2 2h10c1.11 0 2-.89 2-2v-6a2 2 0 0 0-2-2m-4 8H8v-2h6v2m4-4H8v-2h10v2m4-6H4v16H2V2h2v2h18v2Z"/>'
        },
        "sign-text": {
            body: '<path fill="currentColor" d="m11 3l1-1l1 1v2h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7v3a2 2 0 0 1 2 2H9a2 2 0 0 1 2-2v-3H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7V3M6 8v2h12V8H6m0 4v2h7v-2H6Z"/>'
        },
        "sign-yield": {
            body: '<path fill="currentColor" d="M20.5 3h-17C2.4 3 1.6 4.3 2.2 5.3l8.5 14.9c.3.5.8.8 1.3.8s1-.3 1.3-.8l8.5-14.9c.6-1-.2-2.3-1.3-2.3M12 18.5L4.3 5h15.3L12 18.5m-5.1-12h10.2l-5.1 9l-5.1-9Z"/>'
        },
        signal: {
            body: '<path fill="currentColor" d="M3 21h3v-3H3m5 3h3v-7H8m5 7h3V9h-3m5 12h3V3h-3v18Z"/>'
        },
        "signal-2g": {
            body: '<path fill="currentColor" d="M11 19.5H2v-6a3 3 0 0 1 3-3h3v-3H2v-3h6a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5v3h6m11-6h-4.5v3H19v3h-3v-9h6v-3h-6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3"/>'
        },
        "signal-3g": {
            body: '<path fill="currentColor" d="M11 16.5v-2.25C11 13 10 12 8.75 12C10 12 11 11 11 9.75V7.5a3 3 0 0 0-3-3H2v3h6v3H5v3h3v3H2v3h6a3 3 0 0 0 3-3m11 0v-6h-4.5v3H19v3h-3v-9h6v-3h-6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3Z"/>'
        },
        "signal-4g": {
            body: '<path fill="currentColor" d="M22 16.5v-6h-4.5v3H19v3h-3v-9h6v-3h-6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3m-14 3h3v-15H8v6H5v-6H2v9h6v6Z"/>'
        },
        "signal-5g": {
            body: '<path fill="currentColor" d="M22 16.5v-6h-4.5v3H19v3h-3v-9h6v-3h-6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3m-12-12H3v9h4v3H3v3h5.5A1.5 1.5 0 0 0 10 18v-6a1.5 1.5 0 0 0-1.5-1.5H6v-3h4v-3Z"/>'
        },
        "signal-cellular-1": {
            body: '<path fill="currentColor" d="M19.5 5.5v13h-2v-13h2m-7 5v8h-2v-8h2M21 4h-5v16h5V4m-7 5H9v11h5V9m-7 5H2v6h5v-6Z"/>'
        },
        "signal-cellular-2": {
            body: '<path fill="currentColor" d="M19.5 5.5v13h-2v-13h2M21 4h-5v16h5V4m-7 5H9v11h5V9m-7 5H2v6h5v-6Z"/>'
        },
        "signal-cellular-3": {
            body: '<path fill="currentColor" d="M21 4h-5v16h5V4m-7 5H9v11h5V9m-7 5H2v6h5v-6Z"/>'
        },
        "signal-cellular-outline": {
            body: '<path fill="currentColor" d="M19.5 5.5v13h-2v-13h2m-7 5v8h-2v-8h2m-7 5v3h-2v-3h2M21 4h-5v16h5V4m-7 5H9v11h5V9m-7 5H2v6h5v-6Z"/>'
        },
        "signal-distance-variant": {
            body: '<path fill="currentColor" d="M4 6V4a12 12 0 0 1 12 12h-2A10 10 0 0 0 4 6m0 4V8a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6m0 2a4 4 0 0 1 4 4H4v-4m-1 6h16v-2l3 3l-3 3v-2H3v-2Z"/>'
        },
        "signal-hspa": {
            body: '<path fill="currentColor" d="M10.5 10.5h3v-6h3v15h-3v-6h-3v6h-3v-15h3v6Z"/>'
        },
        "signal-hspa-plus": {
            body: '<path fill="currentColor" d="M19 8v3h3v3h-3v3h-3v-3h-3v-3h3V8h3M5 10.5h3v-6h3v15H8v-6H5v6H2v-15h3v6Z"/>'
        },
        "signal-off": {
            body: '<path fill="currentColor" d="M18 3v13.18l3 3V3h-3M4.28 5L3 6.27L10.73 14H8v7h3v-6.73l2 2V21h3v-1.73L19.73 23L21 21.72L4.28 5M13 9v2.18l3 3V9h-3M3 18v3h3v-3H3Z"/>'
        },
        "signal-variant": {
            body: '<path fill="currentColor" d="M4 6V4h.1C12.9 4 20 11.1 20 19.9v.1h-2v-.1C18 12.2 11.8 6 4 6m0 4V8a12 12 0 0 1 12 12h-2A10 10 0 0 0 4 10m0 4v-2a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6m0 2a4 4 0 0 1 4 4H4v-4Z"/>'
        },
        signature: {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2M2.26 16.83L5.09 14l-2.83-2.83l1.41-1.41l2.83 2.83l2.83-2.83l1.41 1.41L7.91 14l2.83 2.83l-1.41 1.41l-2.83-2.83l-2.83 2.83l-1.41-1.41Z"/>'
        },
        "signature-freehand": {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2M6.2 17.3l-.7.7l-1.4-1.4L2.7 18l-.7-.7l1.4-1.4L2 14.5l.7-.7l1.4 1.4l1.4-1.4l.7.7l-1.4 1.4l1.4 1.4m10.02-2.87c0-.58-.72-1.23-2.16-1.97c-1.83-.92-3.06-1.67-3.7-2.22c-.65-.56-.97-1.18-.97-1.87c0-1.78.91-3.25 2.73-4.42c1.82-1.17 3.31-1.76 4.45-1.76c.74 0 1.28.13 1.61.39c.32.25.5.69.5 1.32c0 .28-.12.52-.37.73c-.24.2-.44.3-.57.3c-.11 0-.31-.1-.61-.29l-.58-.26c-.47 0-1.41.33-2.84 1c-1.42.66-2.13 1.41-2.13 2.25c0 .51.24.97.74 1.37c.5.42 1.39.93 2.68 1.53c1.03.47 1.86.97 2.5 1.54c.6.54.91 1.18.91 1.93c0 1.34-.94 2.41-2.83 3.17c-1.88.77-3.68 1.15-5.39 1.15c-1.44 0-2.19-.49-2.19-1.46c0-.36.19-.59.5-.75c.33-.16.66-.24 1-.24l.75.13l.72.13c.98 0 2.03-.16 3.16-.49c1.13-.32 1.83-.73 2.09-1.21Z"/>'
        },
        "signature-image": {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2M6.2 17.3l-1.4-1.4l1.4-1.4l-.7-.7l-1.4 1.4l-1.4-1.4l-.7.7l1.4 1.4L2 17.3l.7.7l1.4-1.4L5.5 18l.7-.7M20 5H10a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M10 16l2.6-3.3l1.8 2.2l2.4-3.3L20 16H10Z"/>'
        },
        "signature-text": {
            body: '<path fill="currentColor" d="M22 22H2v-2h20v2M6.2 17.3l-1.4-1.4l1.4-1.4l-.7-.7l-1.4 1.4l-1.4-1.4l-.7.7l1.4 1.4L2 17.3l.7.7l1.4-1.4L5.5 18l.7-.7M20.5 3l1.2 4.4l-1 .3c-.5-.9-.9-1.7-1.4-2.2c-.6-.5-1.2-.5-1.8-.5H15v10.5c0 .5 0 1 .3 1.2c.3.2 1 .2 1.7.2v1h-6v-1c.7 0 1.3 0 1.7-.2c.3-.2.3-.7.3-1.2V5h-2.5c-.6 0-1.2 0-1.8.4c-.5.4-1 1.3-1.4 2.2l-1-.3L7.5 3h13Z"/>'
        },
        silo: {
            body: '<path fill="currentColor" d="M15 7.8C14.6 4.5 11.8 2 8.5 2c-1.7 0-3.4.7-4.6 1.9S2 6.8 2 8.5V22h13V9.8l3 1.8V22h2v-9.2l2 1.2v-2l-7-4.2M11 20H6v-2h5v2m0-4H6v-2h5v2m0-4H6v-2h5v2M4.3 7c.6-1.8 2.3-3 4.2-3s3.6 1.2 4.2 3H4.3Z"/>'
        },
        "silo-outline": {
            body: '<path fill="currentColor" d="M8.5 2a6.5 6.5 0 0 1 6.46 5.78L22 12v2l-2-1.2V22h-2V11.6l-3-1.8V22h-2V9H4v13H2V8.5A6.5 6.5 0 0 1 8.5 2m0 2C6.54 4 4.87 5.25 4.26 7h8.48c-.61-1.75-2.28-3-4.24-3M6 11h5v2H6v-2m0 4h5v2H6v-2m0 4h5v2H6v-2Z"/>'
        },
        silverware: {
            body: '<path fill="currentColor" d="M8.1 13.34L3.91 9.16a4.008 4.008 0 0 1 0-5.66l7.02 7l-2.83 2.84m6.78-1.81L13.41 13l6.88 6.88l-1.41 1.41L12 14.41l-6.88 6.88l-1.41-1.41l9.76-9.76c-.71-1.53-.21-3.68 1.38-5.27c1.91-1.92 4.65-2.28 6.11-.82c1.47 1.47 1.11 4.21-.81 6.12c-1.59 1.59-3.74 2.09-5.27 1.38Z"/>'
        },
        "silverware-clean": {
            body: '<path fill="currentColor" d="m15 0l-.62 1.37L13 2l1.38.63L15 4l.63-1.37L17 2l-1.37-.63L15 0m-4.5 2L9.41 4.41L7 5.5l2.41 1.09L10.5 9l1.1-2.41L14 5.5l-2.4-1.09L10.5 2m8.39 3.14c-1.33-.08-2.85.51-4.05 1.7c-1.59 1.59-2.09 3.74-1.38 5.27L3.7 21.87l1.41 1.41L12 16.41l6.88 6.88l1.41-1.41L13.41 15l1.47-1.47c1.53.71 3.68.21 5.27-1.38c1.91-1.91 2.28-4.65.81-6.12c-.55-.53-1.28-.84-2.07-.89M3.91 5.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18l2.83-2.84l-7.02-7Z"/>'
        },
        "silverware-fork": {
            body: '<path fill="currentColor" d="m5.12 21.29l-1.41-1.41l9.65-9.66l-.2-.22a1.98 1.98 0 0 1 0-2.81l4.34-4.37l.93.92L15.19 7l.96.94l3.24-3.25l.92.92l-3.25 3.24l.94.96l3.26-3.25l.92.94l-4.37 4.34c-.78.78-2.04.78-2.81 0l-.22-.2l-9.66 9.65Z"/>'
        },
        "silverware-fork-knife": {
            body: '<path fill="currentColor" d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7m5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4Z"/>'
        },
        "silverware-spoon": {
            body: '<path fill="currentColor" d="m14.88 11.53l-9.76 9.76l-1.41-1.41l9.76-9.76c-.71-1.53-.21-3.68 1.38-5.27c1.91-1.92 4.65-2.28 6.11-.82c1.47 1.47 1.11 4.21-.81 6.12c-1.59 1.59-3.74 2.09-5.27 1.38Z"/>'
        },
        "silverware-variant": {
            body: '<path fill="currentColor" d="M8.1 13.34L3.91 9.16a4.008 4.008 0 0 1 0-5.66l7.02 7l-2.83 2.84m5.31-.34l6.88 6.88l-1.41 1.41L12 14.41l-6.88 6.88l-1.41-1.41l9.65-9.66l-.2-.22a1.98 1.98 0 0 1 0-2.81l4.34-4.37l.93.92L15.19 7l.96.94l3.24-3.25l.92.92l-3.25 3.24l.94.96l3.26-3.25l.92.94l-4.37 4.34c-.78.78-2.04.78-2.81 0l-.22-.2L13.41 13Z"/>'
        },
        sim: {
            body: '<path fill="currentColor" d="M20 4a2 2 0 0 0-2-2h-8L4 8v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4M9 19H7v-2h2v2m8 0h-2v-2h2v2m-8-4H7v-4h2v4m4 4h-2v-4h2v4m0-6h-2v-2h2v2m4 2h-2v-4h2v4Z"/>'
        },
        "sim-alert": {
            body: '<path fill="currentColor" d="M13 13h-2V7h2m0 10h-2v-2h2m5-13h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"/>'
        },
        "sim-alert-outline": {
            body: '<path fill="currentColor" d="M13 13h-2V7h2m0 10h-2v-2h2m5-11v16H6V8.8L10.8 4H18m0-2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z"/>'
        },
        "sim-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-1.38-1.38c-.36.4-.88.65-1.46.65H6c-1.11 0-2-.89-2-2V8l1.06-1.05L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M20 4a2 2 0 0 0-2-2h-8L7.6 4.4L20 16.8V4Z"/>'
        },
        "sim-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l3.95 3.95L4 8v12c0 1.11.89 2 2 2h12c.58 0 1.1-.25 1.46-.65l1.38 1.38l1.27-1.27M18 20H6V8.83l.47-.47L18 19.89V20M10.83 4H18v10.8l2 2V4a2 2 0 0 0-2-2h-8L7.6 4.4L9 5.81L10.83 4Z"/>'
        },
        "sim-outline": {
            body: '<path fill="currentColor" d="M18 4v16H6V8.8L10.8 4H18m0-2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M9.5 19h-2v-2h2v2m7 0h-2v-2h2v2m-7-4h-2v-4h2v4m3.5 4h-2v-4h2v4m0-6h-2v-2h2v2m3.5 2h-2v-4h2v4Z"/>'
        },
        "simple-icons": {
            body: '<path fill="currentColor" d="M18.25 17c0 .88-.18 1.74-.54 2.53h-1.4c1.4-2.38.6-5.44-1.78-6.84A5.01 5.01 0 0 0 12 12c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5h-1.25c0-2.07-1.68-3.75-3.75-3.75c-2.07 0-3.75 1.68-3.75 3.75c0 2.07 1.68 3.75 3.75 3.75c3.45 0 6.25 2.81 6.25 6.25M6.29 19.53c-.36-.79-.54-1.66-.54-2.53H7c0 .93.25 1.79.69 2.53h-1.4m11.96 1.22V22H5.75v-1.25H9.5v-5H8.25V14.5h7.5v1.25H14.5v5h3.75m-5-5h-2.5v5h2.5v-5m1.19-8.68A2.502 2.502 0 0 1 12 9.5a2.493 2.493 0 0 1-2.43-2.56C9.6 5.61 10.67 4.53 12 4.5a2.51 2.51 0 0 1 2.44 2.57M13.25 7a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0Z"/>'
        },
        "sina-weibo": {
            body: '<path fill="currentColor" d="M9.82 13.87c1.07 0 1.95.87 1.95 1.95a1.95 1.95 0 0 1-1.95 1.95c-1.08 0-1.95-.88-1.95-1.95c0-1.08.87-1.95 1.95-1.95M14.5 3.34l.68-.03c3.76 0 6.82 3.06 6.82 6.82l-.05.82l-1.19-.37l.02-.45c0-3.09-2.51-5.6-5.6-5.6l-.35.01l-.33-1.2m.82 2.89c2.06.07 3.73 1.77 3.76 3.83l-1.24-.38c-.19-1.12-1.06-2-2.17-2.18l-.35-1.27M2 15.41c-.03-.61.07-2.77 2.95-5.44c3.4-3.16 4.87-2.92 4.87-2.92s3.18-.3 1.24 3.41h.07c.47-.5 1.49-1.25 3.56-1.46c2.08-.21 2.08 1.5 1.81 2.7c1.88.94 3.06 2.33 3.06 3.88c0 2.82-3.93 5.11-8.78 5.11h-.28c-3.5 0-6.5-1.27-7.79-3.1c-.46-.62-.71-1.3-.71-2.01v-.17m7.82-3.49c-3.23 0-5.85 1.75-5.85 3.9s2.62 3.9 5.85 3.9c3.23 0 5.85-1.75 5.85-3.9s-2.62-3.9-5.85-3.9Z"/>'
        },
        "sine-wave": {
            body: '<path fill="currentColor" d="M16.5 21c-3 0-4.19-4.24-5.45-8.72C10.14 9.04 9 5 7.5 5C4.11 5 4 11.93 4 12H2c0-.37.06-9 5.5-9c3 0 4.21 4.25 5.47 8.74C13.83 14.8 15 19 16.5 19c3.44 0 3.53-6.93 3.53-7h2c0 .37-.06 9-5.53 9Z"/>'
        },
        sitemap: {
            body: '<path fill="currentColor" d="M9 2v6h2v3H5c-1.11 0-2 .89-2 2v3H1v6h6v-6H5v-3h6v3H9v6h6v-6h-2v-3h6v3h-2v6h6v-6h-2v-3c0-1.11-.89-2-2-2h-6V8h2V2H9Z"/>'
        },
        "sitemap-outline": {
            body: '<path fill="currentColor" d="M21 16v-3c0-1.11-.89-2-2-2h-6V8h2V2H9v6h2v3H5c-1.11 0-2 .89-2 2v3H1v6h6v-6H5v-3h6v3H9v6h6v-6h-2v-3h6v3h-2v6h6v-6h-2M11 4h2v2h-2V4M5 20H3v-2h2v2m8 0h-2v-2h2v2m8 0h-2v-2h2v2Z"/>'
        },
        "size-l": {
            body: '<path fill="currentColor" d="M9 7v10h6v-2h-4V7H9Z"/>'
        },
        "size-m": {
            body: '<path fill="currentColor" d="M9 7c-1.1 0-2 .9-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2H9Z"/>'
        },
        "size-s": {
            body: '<path fill="currentColor" d="M11 7c-1.1 0-2 .9-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4c1.11 0 2-.89 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4Z"/>'
        },
        "size-xl": {
            body: '<path fill="currentColor" d="M6 7h2l1 2.5L10 7h2l-2 5l2 5h-2l-1-2.5L8 17H6l2-5l-2-5m7 0h2v8h4v2h-6V7Z"/>'
        },
        "size-xs": {
            body: '<path fill="currentColor" d="M6 7h2l1 2.5L10 7h2l-2 5l2 5h-2l-1-2.5L8 17H6l2-5l-2-5m9 0h4v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-4v-2h4v-2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2Z"/>'
        },
        "size-xxl": {
            body: '<path fill="currentColor" d="M9 7h2l1 2.5L13 7h2l-2 5l2 5h-2l-1-2.5l-1 2.5H9l2-5l-2-5m7 0h2v8h4v2h-6V7M2 7h2l1 2.5L6 7h2l-2 5l2 5H6l-1-2.5L4 17H2l2-5l-2-5Z"/>'
        },
        "size-xxs": {
            body: '<path fill="currentColor" d="M9 7h2l1 2.5L13 7h2l-2 5l2 5h-2l-1-2.5l-1 2.5H9l2-5l-2-5m9 0h4v2h-4v2h2a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2h-4v-2h4v-2h-2a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2M2 7h2l1 2.5L6 7h2l-2 5l2 5H6l-1-2.5L4 17H2l2-5l-2-5Z"/>'
        },
        "size-xxxl": {
            body: '<path fill="currentColor" d="M9 7h2l1 2.5L13 7h2l-2 5l2 5h-2l-1-2.5l-1 2.5H9l2-5l-2-5m7 0h2v8h4v2h-6V7m-8 8c0 1.11-.89 2-2 2H2v-2h4v-2H4v-2h2V9H2V7h4a2 2 0 0 1 2 2v1.5c0 .83-.67 1.5-1.5 1.5c.83 0 1.5.67 1.5 1.5V15Z"/>'
        },
        skate: {
            body: '<path fill="currentColor" d="M20.95 17c-.25 1.69-1.69 3-3.45 3H16v-2h3c-.07-1.28.26-3.96-.47-5.05c-.97-2.05-3.7-2.39-5.6-2.9C12 10 11 9 10.84 8H8c-.28 0-.5-.22-.5-.5S7.72 7 8 7h2.5V6H8c-.28 0-.5-.22-.5-.5S7.72 5 8 5h2.5V2H2.03v16H5v2H1v2h16.5c2.86 0 5.22-2.2 5.5-5h-2.05M14 20H7v-2h7v2Z"/>'
        },
        "skate-off": {
            body: '<path fill="currentColor" d="m19 15.81l-5.64-5.65c1.86.46 4.27.89 5.17 2.79c.42.62.47 1.76.47 2.86M20.95 17c-.03.21-.08.41-.15.6l1.52 1.52c.36-.62.6-1.35.68-2.12h-2.05M10.5 7V6H9.2l1 1h.3m11.61 14.46l-1.27 1.27l-1.18-1.18c-.66.28-1.39.45-2.16.45H1v-2h4v-2H2.03V3.92L1.11 3l.92-.91V2h.09l.27-.27l19.72 19.73M14 18H7v2h7v-2m4.06 1.95L16.11 18H16v2h1.5c.19 0 .38 0 .56-.05M10.5 5V2H5.2l3 3h2.3Z"/>'
        },
        skateboard: {
            body: '<path fill="currentColor" d="M9 14.5c0 .83-.67 1.5-1.5 1.5S6 15.33 6 14.5S6.67 13 7.5 13s1.5.67 1.5 1.5m7.5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5m5.09-3.81c-.45-.32-1.09-.22-1.4.22l-.13.18c-.18.26-.49.41-.8.41H4.74c-.31 0-.61-.15-.8-.41l-.13-.18c-.31-.44-.95-.54-1.4-.22c-.45.31-.54.96-.22 1.4l.13.18c.56.77 1.47 1.23 2.42 1.23h14.52c.95 0 1.86-.46 2.42-1.23l.13-.18c.32-.44.23-1.09-.22-1.4Z"/>'
        },
        skateboarding: {
            body: '<path fill="currentColor" d="M19.78 18.39c.15.15.22.31.22.49c0 .12-.06.29-.18.44c-.38.53-.86.94-1.45 1.24c-.59.29-1.22.44-1.9.44H7.53c-.71 0-1.36-.15-1.94-.44c-.59-.3-1.09-.71-1.46-1.24a.828.828 0 0 1-.13-.44c0-.18.07-.34.2-.49s.3-.22.51-.22c.23 0 .42.1.57.33c.41.5.94.86 1.59 1.04l2.95-3.58l-1.28-3.89c-.18-.57-.1-1.07.22-1.57L11 6.86H8.8L7 9.77L5.41 8.76L7.75 5h5.37c.42 0 .75.12 1.02.35c.26.24.44.45.53.62l.48 1.15C15.5 7.89 16 8.5 16.7 9c.7.45 1.48.69 2.33.69v1.9c-1.09 0-2.08-.27-3-.8a6.073 6.073 0 0 1-2.16-2.08l-1.71 2.7l4.05 2.52v5.66h.26c.45 0 .86-.09 1.26-.31s.73-.47.99-.78c.15-.23.33-.33.53-.33s.38.08.53.22m-5.42-3.14l-3.31-2.07l.95 3.14l-2.76 3.27h5.12v-4.34M15 1c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2M8 21.5c-.41 0-.75.34-.75.75s.34.75.75.75s.75-.34.75-.75s-.34-.75-.75-.75m8 0c-.41 0-.75.34-.75.75s.34.75.75.75s.75-.34.75-.75s-.34-.75-.75-.75Z"/>'
        },
        "skew-less": {
            body: '<path fill="currentColor" d="m17.5 11l-2.09 9H10.5l2.09-9h4.91M20 9h-9L8 22h9l3-13M4 6l4-4v3h8v2H8v3L4 6Z"/>'
        },
        "skew-more": {
            body: '<path fill="currentColor" d="m12.5 11l-2.09 9H5.5l2.09-9h4.91M15 9H6L3 22h9l3-13m6-3l-4-4v3H9v2h8v3l4-4Z"/>'
        },
        ski: {
            body: '<path fill="currentColor" d="M17.92 13.32c-.25-.04-1.21-.32-1.46-.43l-2.07 6.48l-3.09-1.13l2.2-5.77L10.45 9L13 7.54c.45 1.13 1.17 2.08 2.12 2.86s2.04 1.27 3.26 1.46l1.12-3.43l-1.44-.47l-.52 1.6c-.66-.28-1.24-.7-1.74-1.24c-.5-.55-.86-1.19-1.08-1.91l-.33-1.08c-.12-.4-.35-.72-.68-.96c-.33-.23-.71-.37-1.08-.4c-.39-.03-.77.03-1.13.24L8 6.23c-.37.21-.64.51-.81.89c-.19.38-.23.76-.19 1.17s.26.77.54 1.08l3.57 3.71l-1.69 4.46l-6.95-2.49L2 16.46l14.04 5.12a7.522 7.522 0 0 0 4.32.19c.59-.16 1.14-.38 1.64-.66L20.87 20c-.75.33-1.53.5-2.34.5c-.66 0-1.32-.11-1.98-.33l-.75-.28l2.12-6.57M19 3c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        "ski-cross-country": {
            body: '<path fill="currentColor" d="M19 14h-1.4v8H19v-8M6.44 22H5l2-8h1.44l-2 8M8.76 9.54V13H7V8.32l4.61-2.01c.43-.17.89-.18 1.35-.04s.83.42 1.1.83L15 8.58c.37.67.9 1.37 1.62 1.79c.71.42 1.51.63 2.38.63v1.83c-1 0-2-.21-2.87-.63s-1.63-1.14-2.25-1.83l-.57 2.79L15.28 15v7H13.4v-5.5l-1.9-1.95L9.77 22H7.8l2.63-13.11l-1.67.65M16 4c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        "ski-water": {
            body: '<path fill="currentColor" d="M4.2 3.5c0-.8.7-1.6 1.6-1.6c.9 0 1.6.7 1.6 1.6S6.6 5 5.8 5s-1.6-.7-1.6-1.5m17.8.4l-.5-.9l-8 4.1l.5.9l8-4.1m-1.2 16.4l.9.9c-.6.6-1.2 1-1.9 1.3s-1.5.5-2.3.5H2v-1.3h2.7l2.1-3.5L4.5 15l-.8-7.8c0-.9.8-1.7 1.7-1.7c.3 0 .6.1.8.2l3.5 2.6l2.3-.8l.8 1.6l-3.5 1.5c-.1-.1-1.6-1.2-2.7-2.1L7 12l5.3 4.5l1.7 5.2h3.5c.6 0 1.2-.1 1.8-.4c.6-.2 1.1-.6 1.5-1M7 21.7h5l-1.6-3.9l-2.3-1.9l1.2 2.5L7 21.7Z"/>'
        },
        "skip-backward": {
            body: '<path fill="currentColor" d="M20 5v14l-7-7M6 5v14H4V5m9 0v14l-7-7"/>'
        },
        "skip-backward-outline": {
            body: '<path fill="currentColor" d="M18 14.17L15.83 12L18 9.83v4.34M20 19V5l-7 7m-9 7h2V5H4m7 9.17L8.83 12L11 9.83v4.34M13 19V5l-7 7"/>'
        },
        "skip-forward": {
            body: '<path fill="currentColor" d="M4 5v14l7-7m7-7v14h2V5m-9 0v14l7-7"/>'
        },
        "skip-forward-outline": {
            body: '<path fill="currentColor" d="M6 9.83L8.17 12L6 14.17V9.83M4 5v14l7-7m9-7h-2v14h2m-7-9.17L15.17 12L13 14.17V9.83M11 5v14l7-7"/>'
        },
        "skip-next": {
            body: '<path fill="currentColor" d="M16 18h2V6h-2M6 18l8.5-6L6 6v12Z"/>'
        },
        "skip-next-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M8 8l5 4l-5 4m6-8h2v8h-2"/>'
        },
        "skip-next-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8M8 8v8l5-4m1-4v8h2V8"/>'
        },
        "skip-next-outline": {
            body: '<path fill="currentColor" d="m6 18l8.5-6L6 6m2 3.86L11.03 12L8 14.14M16 6h2v12h-2"/>'
        },
        "skip-previous": {
            body: '<path fill="currentColor" d="M6 18V6h2v12H6m3.5-6L18 6v12l-8.5-6Z"/>'
        },
        "skip-previous-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M8 8h2v8H8m8-8v8l-5-4"/>'
        },
        "skip-previous-circle-outline": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2c-4.41 0-8 3.59-8 8s3.59 8 8 8s8-3.59 8-8s-3.59-8-8-8m4 4v8l-5-4m-1-4v8H8V8"/>'
        },
        "skip-previous-outline": {
            body: '<path fill="currentColor" d="M6 6h2v12H6m3.5-6l8.5 6V6m-2 8.14L12.97 12L16 9.86v4.28Z"/>'
        },
        skull: {
            body: '<path fill="currentColor" d="M12 2a9 9 0 0 0-9 9a8.99 8.99 0 0 0 4 7.47V22h2v-3h2v3h2v-3h2v3h2v-3.54c2.47-1.65 4-4.46 4-7.46a9 9 0 0 0-9-9m-4 9a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m8 0a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-4 3l1.5 3h-3l1.5-3Z"/>'
        },
        "skull-crossbones": {
            body: '<path fill="currentColor" d="m15.8 18.5l6 1.6l-.4 1.9l-9.4-2.5L2.6 22l-.5-1.9l6-1.6L2 16.9l.5-1.9l9.4 2.5l9.4-2.5l.5 1.9l-6 1.6M18 8c0 1.8-.8 3.3-2 4.4V15h-2v-2h-1v2h-2v-2h-1v2H8v-2.6C6.8 11.3 6 9.8 6 8a6 6 0 0 1 6-6a6 6 0 0 1 6 6m-7-.5c0-.8-.7-1.5-1.5-1.5S8 6.7 8 7.5S8.7 9 9.5 9S11 8.3 11 7.5m2 3.5l-1-2l-1 2h2m3-3.5c0-.8-.7-1.5-1.5-1.5S13 6.7 13 7.5S13.7 9 14.5 9S16 8.3 16 7.5Z"/>'
        },
        "skull-crossbones-outline": {
            body: '<path fill="currentColor" d="m15.8 18.5l6 1.6l-.4 1.9l-9.4-2.5L2.6 22l-.5-1.9l6-1.6L2 16.9l.5-1.9l9.4 2.5l9.4-2.5l.5 1.9l-6 1.6M9.5 6C8.7 6 8 6.7 8 7.5S8.7 9 9.5 9S11 8.3 11 7.5S10.3 6 9.5 6m5 0c-.8 0-1.5.7-1.5 1.5S13.7 9 14.5 9S16 8.3 16 7.5S15.3 6 14.5 6M13 11l-1-2l-1 2h2M12 1C8.1 1 5 4.1 5 8c0 1.9.8 3.6 2 4.9V16h10v-3.1c1.2-1.3 2-3 2-4.9c0-3.9-3.1-7-7-7m3 11v2h-1v-2h-1v2h-2v-2h-1v2H9v-2c-1.2-.9-2-2.3-2-4c0-2.8 2.2-5 5-5s5 2.2 5 5c0 1.6-.8 3.1-2 4Z"/>'
        },
        "skull-outline": {
            body: '<path fill="currentColor" d="M8 15a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m2.5 2l1.5-3l1.5 3h-3m5.5-2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m6-4A10 10 0 0 0 12 1A10 10 0 0 0 2 11c0 2.8 1.2 5.3 3 7.1V22h14v-3.9c1.8-1.8 3-4.3 3-7.1m-5 9h-2v-2h-2v2h-2v-2H9v2H7v-2.8c-1.8-1.5-3-3.7-3-6.2a8 8 0 0 1 8-8a8 8 0 0 1 8 8c0 2.5-1.2 4.8-3 6.2V20Z"/>'
        },
        "skull-scan": {
            body: '<path fill="currentColor" d="M2 0C.9 0 0 .9 0 2v4h2V2h4V0H2m16 0v2h4v4h2V2c0-1.1-.9-2-2-2h-4m-6 3c-4.4 0-8 3.6-8 8c0 2.5 1.2 4.8 3 6.2V21h2v-3h2v3h2v-3h2v3h2v-3.8c1.8-1.5 3-3.7 3-6.2c0-4.4-3.6-8-8-8M8 14c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m2.5 2l1.5-3l1.5 3h-3m5.5-2c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M0 18v4c0 1.1.9 2 2 2h4v-2H2v-4H0m22 0v4h-4v2h4c1.1 0 2-.9 2-2v-4h-2Z"/>'
        },
        "skull-scan-outline": {
            body: '<path fill="currentColor" d="M2 0C.9 0 0 .9 0 2v4h2V2h4V0H2m16 0v2h4v4h2V2c0-1.1-.9-2-2-2h-4M9.5 13c-.8 0-1.5-.7-1.5-1.5S8.7 10 9.5 10s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m1.5 2l1-2l1 2h-2m3.5-2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M0 18v4c0 1.1.9 2 2 2h4v-2H2v-4H0m22 0v4h-4v2h4c1.1 0 2-.9 2-2v-4h-2M12 3c-4.4 0-8 3.6-8 8c0 2 .8 3.9 2 5.3V21h12v-4.7c1.2-1.4 2-3.2 2-5.3c0-4.4-3.6-8-8-8m4 12.4V19h-2v-2h-1v2h-2v-2h-1v2H8v-3.6c-1.2-1.1-2-2.7-2-4.4c0-3.3 2.7-6 6-6s6 2.7 6 6c0 1.8-.8 3.3-2 4.4Z"/>'
        },
        skype: {
            body: '<path fill="currentColor" d="M18 6c2.07 2.04 2.85 4.89 2.36 7.55c.41.72.64 1.56.64 2.45a5 5 0 0 1-5 5c-.89 0-1.73-.23-2.45-.64c-2.66.49-5.51-.29-7.55-2.36c-2.07-2.04-2.85-4.89-2.36-7.55C3.23 9.73 3 8.89 3 8a5 5 0 0 1 5-5c.89 0 1.73.23 2.45.64c2.66-.49 5.51.29 7.55 2.36m-5.96 11.16c2.87 0 4.3-1.38 4.3-3.24c0-1.19-.56-2.46-2.73-2.95l-1.99-.44c-.76-.17-1.62-.4-1.62-1.11c0-.72.6-1.22 1.7-1.22c2.23 0 2.02 1.53 3.13 1.53c.58 0 1.08-.34 1.08-.93c0-1.37-2.19-2.4-4.05-2.4c-2.01 0-4.16.86-4.16 3.14c0 1.1.39 2.27 2.55 2.81l2.69.68c.81.2 1.01.65 1.01 1.07c0 .68-.68 1.35-1.91 1.35c-2.41 0-2.08-1.85-3.37-1.85c-.58 0-1 .4-1 .97c0 1.11 1.33 2.59 4.37 2.59Z"/>'
        },
        "skype-business": {
            body: '<path fill="currentColor" d="M12.03 16.53c-2.66 0-3.85-1.31-3.85-2.29c0-.5.37-.86.88-.86c1.14 0 .85 1.62 2.97 1.62c1.09 0 1.7-.57 1.7-1.18c0-.36-.18-.76-.9-.94l-2.37-.59c-1.91-.48-2.26-1.51-2.26-2.48c0-2.02 1.9-2.78 3.68-2.78c1.62 0 3.58.91 3.58 2.12c0 .52-.46.82-.96.82c-1 0-.8-1.35-2.76-1.35c-.97 0-1.51.44-1.51 1.07c0 .63.77.81 1.43.99l1.76.39c1.92.43 2.41 1.55 2.41 2.6c0 1.64-1.26 2.86-3.8 2.86M18 6c2.07 2.04 2.85 4.89 2.36 7.55c.41.72.64 1.56.64 2.45a5 5 0 0 1-5 5c-.89 0-1.73-.23-2.45-.64c-2.66.49-5.51-.29-7.55-2.36c-2.07-2.04-2.85-4.89-2.36-7.55C3.23 9.73 3 8.89 3 8a5 5 0 0 1 5-5c.89 0 1.73.23 2.45.64c2.66-.49 5.51.29 7.55 2.36M8 5a3 3 0 0 0-3 3c0 .79.3 1.5.8 2.04c-.7 2.24-.17 4.78 1.6 6.56a6.527 6.527 0 0 0 6.56 1.6c.54.5 1.25.8 2.04.8a3 3 0 0 0 3-3c0-.79-.3-1.5-.8-2.04c.7-2.24.17-4.78-1.6-6.56a6.527 6.527 0 0 0-6.56-1.6C9.5 5.3 8.79 5 8 5Z"/>'
        },
        slack: {
            body: '<path fill="currentColor" d="M6 15a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2v2m1 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-5m2-8a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2v2H9m0 1a2 2 0 0 1 2 2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2a2 2 0 0 1 2-2h5m8 2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2v-2m-1 0a2 2 0 0 1-2 2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5m-2 8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-2h2m0-1a2 2 0 0 1-2-2a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-5Z"/>'
        },
        slackware: {
            body: '<path d="M7.47 17.19c-.1.76-.39 1.02-1.28 1.02c-.92 0-1.32-.42-1.38-1.34l-.2-3.22c0-.74.26-1.1 1.25-1.1c1.35 0 1.18.99 1.78 1.95c.69 1.12 2.36 1.85 4.67 1.85c2.86 0 4.69-1.21 4.69-2.78c0-1.34-1.11-2.18-3.15-2.41l-2.35-.27c-4.29-.47-6.4-1.7-6.4-4.27C5.1 4.07 8.06 2 12.21 2c1.29 0 2.6.29 4.08.76c0-.5.29-.66 1.01-.66c1.16 0 1.25.29 1.32.98l.23 2.8c0 .62-.46.95-1.22.95c-1.28 0-1.08-.95-1.77-1.76s-2.07-1.34-3.78-1.34C9.44 3.73 7.7 4.89 7.7 6.5c0 1.3 1.22 2.06 3.68 2.32l2.57.26c3.75.42 5.66 1.84 5.66 4.25c0 2.84-2.9 4.75-7.4 4.75c-1.65 0-3.13-.31-4.74-.89M1 16h1v5h21v1H1v-6z" fill="currentColor"/>',
            hidden: true
        },
        "slash-forward": {
            body: '<path fill="currentColor" d="m7 21l7.9-18H17L9.1 21H7Z"/>'
        },
        "slash-forward-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9.3 19H7l7.7-14H17L9.3 19Z"/>'
        },
        sledding: {
            body: '<path fill="currentColor" d="M22.91 16.64a4.11 4.11 0 0 0-.94-1.83a3.82 3.82 0 0 0-1.77-1.12l-.43 1.45c.66.19 1.14.59 1.46 1.22c.31.64.35 1.26.14 1.91c-.22.66-.64 1.14-1.25 1.46s-1.24.35-1.89.13l-3.33-1.07l.47-1.41l3.33 1.08l.46-1.46l-1.96-.6l-2.06-4.49c-.19-.41-.48-.72-.87-.94c-.39-.22-.82-.3-1.27-.23l-2.12.37l1.03-3.27c.15-.47.12-.93-.1-1.34c-.21-.46-.57-.76-1.07-.91c-.41-.13-.83-.09-1.27.09L4 8v4.1l-1.6-.52L1.94 13l3.93 1.3l-.47 1.4l-3.93-1.26l-.47 1.4l16.76 5.48c.69.22 1.37.25 2.06.09c.68-.15 1.3-.47 1.83-.91c.53-.5.9-1.07 1.12-1.76c.23-.74.3-1.42.14-2.1M6 9.33l1.93-.83l-1.03 3.17c-.16.47-.11.94.14 1.41L6 12.75V9.33m7.5 8.99l-6.69-2.15l.46-1.41l6.65 2.16l-.42 1.4m-4.03-4.45l3.98-.87l1.17 2.56l-5.15-1.69M14 3c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        sleep: {
            body: '<path fill="currentColor" d="M23 12h-6v-2l3.39-4H17V4h6v2l-3.38 4H23v2m-8 4H9v-2l3.39-4H9V8h6v2l-3.38 4H15v2m-8 4H1v-2l3.39-4H1v-2h6v2l-3.38 4H7v2Z"/>'
        },
        "sleep-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-6-6H9v-2l.79-.94L2 5.27M23 12h-6v-2l3.39-4H17V4h6v2l-3.38 4H23v2M9.82 8H15v2l-1.46 1.72L9.82 8M7 20H1v-2l3.39-4H1v-2h6v2l-3.38 4H7v2Z"/>'
        },
        slide: {
            body: '<path fill="currentColor" d="M14.83 15.45c-.36-.55-.65-1.06-.92-1.53c-1.17-2.01-2.12-3.37-4.91-3.79V5.5C9 3.57 7.43 2 5.5 2S2 3.57 2 5.5V22h2v-2h3v2h2v-9.84c1.76.34 2.29 1.23 3.17 2.76c.29.51.61 1.05 1 1.64C15.41 19.92 17.67 22 22 22v-2c-3.47 0-5.2-1.6-7.17-4.55M5.5 4C6.33 4 7 4.67 7 5.5V10H4V5.5C4 4.67 4.67 4 5.5 4M4 18v-2h3v2H4m3-4H4v-2h3v2Z"/>'
        },
        "slope-downhill": {
            body: '<path fill="currentColor" d="M22 19v3H2v-9l20 6M19.09 7.5l-.84 2.76l-10.12-3A2.89 2.89 0 0 0 5.1 4.5a2.89 2.89 0 0 0-2.76 3.03a2.897 2.897 0 0 0 5.23 1.58l10.12 3l-.84 2.78l4.82-2.6l-2.58-4.79Z"/>'
        },
        "slope-uphill": {
            body: '<path fill="currentColor" d="M22 13v9H2v-3l20-6m-.32-5.94l-4.82-2.6l.84 2.78l-10.12 3a2.895 2.895 0 0 0-4.05-.62a2.895 2.895 0 0 0-.62 4.05c.94 1.3 2.76 1.57 4.05.62c.71-.51 1.14-1.32 1.18-2.2l10.12-3l.84 2.78l2.58-4.81Z"/>'
        },
        "slot-machine": {
            body: '<path fill="currentColor" d="m5 12l2-4V7H4v1h2l-2 4m5 0l2-4V7H8v1h2l-2 4m5 0l2-4V7h-3v1h2l-2 4m9-10c-1.1 0-2 .9-2 2c0 .7.4 1.4 1 1.7V17h-3v-2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-3.8c-.8-1.2-2.2-2-3.7-2s-2.9.8-3.7 2H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1v7h15v-3h3c1.1 0 2-.9 2-2V5.7c.6-.3 1-1 1-1.7c0-1.1-.9-2-2-2m-8 17H6v-2h7v2m3-6H3V6h13v7Z"/>'
        },
        "slot-machine-outline": {
            body: '<path fill="currentColor" d="m5 12l2-4V7H4v1h2l-2 4m5 0l2-4V7H8v1h2l-2 4m5 0l2-4V7h-3v1h2l-2 4m9-10c-1.1 0-2 .9-2 2c0 .7.4 1.4 1 1.7V17h-3v-2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-3.8c-.8-1.2-2.2-2-3.7-2s-2.9.8-3.7 2H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1v7h15v-3h3c1.1 0 2-.9 2-2V5.7c.6-.3 1-1 1-1.7c0-1.1-.9-2-2-2M3 6h13v7H3V6m12 14H4v-5h11v5m-2-1H6v-2h7v2Z"/>'
        },
        "smart-card": {
            body: '<path fill="currentColor" d="M2 3h20a2.07 2.07 0 0 1 2 2v14a2.07 2.07 0 0 1-2 2H2a2.07 2.07 0 0 1-2-2V5a2.07 2.07 0 0 1 2-2m6 10.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 1 0 3 3a3 3 0 0 0-3-3m9 4v3h4v-3h-4"/>'
        },
        "smart-card-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l.16.16A2.08 2.08 0 0 0 0 5v14a2.072 2.072 0 0 0 2 2h17.11l1.73 1.73l1.27-1.27L2.39 1.73M14 18H2v-1c0-2 4-3.09 6-3.09S14 15 14 17v1m-6-6c-1.66 0-3-1.34-3-3c0-.6.18-1.16.5-1.62l4.12 4.12c-.46.32-1.02.5-1.62.5m14-9H6.2l3.68 3.68c.16.13.31.28.44.44L23.5 20.29c.29-.35.5-.79.5-1.29V5a2.074 2.074 0 0 0-2-2m-1 10h-4v-3h4v3Z"/>'
        },
        "smart-card-off-outline": {
            body: '<path fill="currentColor" d="M19 13h-2.8L15 11.8V10h4v3m3-10H6.2l2 2H22v13.8l1.5 1.49c.29-.35.5-.79.5-1.29V5a2.074 2.074 0 0 0-2-2m.11 18.46l-1.27 1.27L19.11 21H2a2.072 2.072 0 0 1-2-2V5a2.08 2.08 0 0 1 1.27-1.84L1.11 3l1.28-1.27l19.72 19.73m-5-2.46L14 15.89V17H4v-1.25c0-1.66 3.34-2.5 5-2.5c.78 0 1.91.19 2.91.55l-2-2c-.28.12-.58.2-.91.2a2.5 2.5 0 0 1-2.5-2.5c0-.33.08-.63.2-.91L3.11 5H2v14h15.11Z"/>'
        },
        "smart-card-outline": {
            body: '<path fill="currentColor" d="M22 3H2a2.07 2.07 0 0 0-2 2v14a2.07 2.07 0 0 0 2 2h20a2.07 2.07 0 0 0 2-2V5a2.07 2.07 0 0 0-2-2m0 16H2V5h20m-8 12v-1.25c0-1.66-3.34-2.5-5-2.5s-5 .84-5 2.5V17h10M9 7a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 9 7m6 3v3h4v-3h-4"/>'
        },
        "smart-card-reader": {
            body: '<path fill="currentColor" d="M21 4a2.07 2.07 0 0 0-2-2H5a2.07 2.07 0 0 0-2 2v14h18M8.25 16H7V6h1.25c1.66 0 2.5 3.34 2.5 5s-.84 5-2.5 5m6.25-2.5A2.5 2.5 0 1 1 17 11a2.5 2.5 0 0 1-2.5 2.5M23 21v1H1v-1a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2Z"/>'
        },
        "smart-card-reader-outline": {
            body: '<path fill="currentColor" d="M14.5 8.5A2.5 2.5 0 1 0 17 11a2.5 2.5 0 0 0-2.5-2.5M8.25 6H7v10h1.25c1.66 0 2.5-3.34 2.5-5s-.84-5-2.5-5M19 2H5a2.07 2.07 0 0 0-2 2v14h2V4h14v14h2V4a2.07 2.07 0 0 0-2-2m4 20H1v-1a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2Z"/>'
        },
        smog: {
            body: '<path fill="currentColor" d="M12 2c-1.92 0-3.5 1.35-3.91 3.15A3.467 3.467 0 0 0 5.5 4A3.5 3.5 0 0 0 2 7.5A3.5 3.5 0 0 0 5.5 11h1.18v1h4.04v-1h2.56v1h4.04v-1h1.18A3.5 3.5 0 0 0 22 7.5A3.5 3.5 0 0 0 18.5 4c-1.03 0-1.95.44-2.59 1.15C15.5 3.35 13.92 2 12 2M7.2 14l-.8 8H11l-.8-8h-3m6.6 0l-.8 8h4.6l-.8-8h-3Z"/>'
        },
        smoke: {
            body: '<path fill="currentColor" d="M17 19v3h-2v-3c0-1.1-.9-2-2-2h-3c-2.8 0-5-2.2-5-5c0-1.2.4-2.2 1.1-3.1C3.8 8.5 2 6.4 2 4c0-.7.2-1.4.4-2h2.4c-.5.5-.8 1.2-.8 2c0 1.7 1.3 3 3 3h3v2c-1.7 0-3 1.3-3 3s1.3 3 3 3h3c2.2 0 4 1.8 4 4m.9-10.1C20.2 8.5 22 6.4 22 4c0-.7-.2-1.4-.4-2h-2.4c.5.5.8 1.2.8 2c0 1.7-1.3 3-3 3h-1.2c.1.3.2.6.2 1c0 1.7-1.3 3-3 3v2c2.8 0 5 2.2 5 5v4h2v-4c0-2.7-1.5-5-3.8-6.2c.9-.7 1.5-1.7 1.7-2.9Z"/>'
        },
        "smoke-detector": {
            body: '<path fill="currentColor" d="M12 18a6 6 0 0 0 6-6c0-3.32-2.69-6-6-6c-3.32 0-6 2.68-6 6a6 6 0 0 0 6 6m7-15a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14M8 12a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4Z"/>'
        },
        "smoke-detector-alert": {
            body: '<path fill="currentColor" d="M10 18c3.3 0 6-2.7 6-6s-2.7-6-6-6s-6 2.7-6 6s2.7 6 6 6m7-15c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14M6 12c0-2.2 1.8-4 4-4s4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4m17-5h-2v6h2V8m0 7h-2v2h2v-2Z"/>'
        },
        "smoke-detector-alert-outline": {
            body: '<path fill="currentColor" d="M17 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H3V5h14v14m-7-1c3.3 0 6-2.7 6-6s-2.7-6-6-6s-6 2.7-6 6s2.7 6 6 6m0-10c2.2 0 4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4m13-1h-2v6h2V8m0 7h-2v2h2v-2Z"/>'
        },
        "smoke-detector-off": {
            body: '<path fill="currentColor" d="M12 8c2.21 0 4 1.79 4 4c0 .25-.03.5-.07.73l-4.66-4.66c.23-.04.48-.07.73-.07m0-2c3.31 0 6 2.68 6 6c0 .83-.18 1.6-.5 2.32L21 17.8V5a2 2 0 0 0-2-2H6.2l3.48 3.5C10.4 6.18 11.17 6 12 6m10.11 15.46l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73m-6.92-4.38l-1.48-1.48c-.52.25-1.09.4-1.71.4c-2.21 0-4-1.79-4-4c0-.61.15-1.19.4-1.71L6.92 8.81C6.34 9.74 6 10.83 6 12c0 3.31 2.69 6 6 6c1.17 0 2.26-.34 3.19-.92Z"/>'
        },
        "smoke-detector-off-outline": {
            body: '<path fill="currentColor" d="m8.2 5l-2-2H19a2 2 0 0 1 2 2v12.8l-2-2V5H8.2m9.3 9.32c.32-.72.5-1.49.5-2.32c0-3.32-2.69-6-6-6c-.83 0-1.6.18-2.32.5l1.59 1.57c.23-.04.48-.07.73-.07c2.21 0 4 1.79 4 4c0 .25-.03.5-.07.73l1.57 1.59m4.61 7.14l-1.27 1.27L19.1 21H5a2 2 0 0 1-2-2V4.9L1.11 3l1.28-1.27l19.72 19.73M8 12c0 2.21 1.79 4 4 4c.62 0 1.19-.15 1.71-.4L8.4 10.29c-.25.52-.4 1.1-.4 1.71m9.11 7l-1.92-1.92c-.93.58-2.02.92-3.19.92c-3.31 0-6-2.69-6-6c0-1.17.34-2.26.92-3.19L5 6.89V19h12.11Z"/>'
        },
        "smoke-detector-outline": {
            body: '<path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-7-1c3.31 0 6-2.69 6-6c0-3.32-2.69-6-6-6c-3.32 0-6 2.68-6 6c0 3.31 2.69 6 6 6m0-10c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4Z"/>'
        },
        "smoke-detector-variant": {
            body: '<path fill="currentColor" d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8m0-2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 9c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-1.28-1.7c.39-.19.82-.3 1.28-.3s.89.11 1.29.3l.71-.73c-.57-.35-1.26-.57-2-.57s-1.42.22-2 .57l.72.73M15 12c0 .46-.11.89-.3 1.29l.73.71c.36-.57.57-1.26.57-2s-.21-1.42-.57-2l-.73.72c.19.39.3.82.3 1.28m-6 0c0-.46.11-.89.3-1.28L8.57 10c-.35.58-.57 1.26-.57 2s.22 1.43.57 2l.73-.71c-.19-.4-.3-.83-.3-1.29m4.29 2.7c-.4.19-.83.3-1.29.3s-.89-.11-1.28-.3l-.72.73c.58.36 1.26.57 2 .57s1.43-.21 2-.57l-.71-.73m3.6-6.17l-.72.72c.52.79.83 1.75.83 2.75s-.31 1.96-.83 2.75l.72.72C17.59 14.5 18 13.3 18 12s-.41-2.5-1.11-3.47m-7.64-.7C10.04 7.31 11 7 12 7s1.96.31 2.75.83l.72-.72a5.978 5.978 0 0 0-6.94 0l.72.72m5.5 8.34c-.79.52-1.75.83-2.75.83s-1.96-.31-2.75-.83l-.72.72C9.5 17.59 10.7 18 12 18s2.5-.41 3.47-1.11l-.72-.72m-6.92-1.42C7.31 13.96 7 13 7 12s.31-1.96.83-2.75l-.72-.72a5.978 5.978 0 0 0 0 6.94l.72-.72Z"/>'
        },
        "smoke-detector-variant-alert": {
            body: '<path fill="currentColor" d="M10 4c4.4 0 8 3.6 8 8s-3.6 8-8 8s-8-3.6-8-8s3.6-8 8-8m0-2C4.5 2 0 6.5 0 12s4.5 10 10 10s10-4.5 10-10S15.5 2 10 2m0 9c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1M8.7 9.3c.4-.2.8-.3 1.3-.3s.9.1 1.3.3l.7-.7c-.6-.4-1.3-.6-2-.6s-1.4.2-2 .6l.7.7M13 12c0 .5-.1.9-.3 1.3l.7.7c.4-.6.6-1.3.6-2s-.2-1.4-.6-2l-.7.7c.2.4.3.8.3 1.3m-6 0c0-.5.1-.9.3-1.3l-.7-.7c-.4.6-.6 1.3-.6 2s.2 1.4.6 2l.7-.7c-.2-.4-.3-.8-.3-1.3m4.3 2.7c-.4.2-.8.3-1.3.3s-.9-.1-1.3-.3l-.7.7c.6.4 1.3.6 2 .6s1.4-.2 2-.6l-.7-.7m3.6-6.2l-.7.7c.5.8.8 1.8.8 2.8s-.3 2-.8 2.8l.7.7c.7-1 1.1-2.2 1.1-3.5s-.4-2.5-1.1-3.5m-7.7-.7C8 7.3 9 7 10 7s2 .3 2.8.8l.7-.7C12.5 6.4 11.3 6 10 6s-2.5.4-3.5 1.1l.7.7m5.6 8.4c-.8.5-1.8.8-2.8.8s-2-.3-2.8-.8l-.7.7c1 .7 2.2 1.1 3.5 1.1s2.5-.4 3.5-1.1l-.7-.7m-7-1.4C5.3 14 5 13 5 12s.3-2 .8-2.8l-.7-.7C4.4 9.5 4 10.7 4 12s.4 2.5 1.1 3.5l.7-.7M24 7h-2v6h2V8m0 7h-2v2h2v-2Z"/>'
        },
        "smoke-detector-variant-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.95 2.95A9.888 9.888 0 0 0 2 12c0 5.5 4.5 10 10 10c2.28 0 4.37-.77 6.05-2.06l2.79 2.79l1.27-1.27M12 20c-4.41 0-8-3.59-8-8c0-1.72.56-3.31 1.5-4.62l1.43 1.44A5.98 5.98 0 0 0 6 12c0 1.3.42 2.5 1.11 3.47l.72-.72C7.31 13.96 7 13 7 12c0-.89.25-1.72.66-2.45l.74.75c-.25.51-.4 1.09-.4 1.7c0 .74.22 1.43.57 2l.73-.71c-.19-.4-.3-.83-.3-1.29c0-.33.07-.64.18-.93l3.75 3.75c-.29.11-.6.18-.93.18c-.46 0-.89-.11-1.28-.3l-.72.73c.58.36 1.26.57 2 .57c.61 0 1.19-.15 1.71-.4l.74.74c-.73.41-1.56.66-2.45.66c-1 0-1.96-.31-2.75-.83l-.72.72C9.5 17.59 10.7 18 12 18c1.17 0 2.25-.35 3.18-.93l1.44 1.43c-1.3.94-2.9 1.5-4.62 1.5m0-12c.74 0 1.43.22 2 .57l-.71.73c-.33-.15-.69-.24-1.06-.27l-.95-.95c.22-.05.47-.08.72-.08m2.97 3.77c-.03-.37-.11-.73-.27-1.05l.73-.72c.36.58.57 1.26.57 2c0 .25-.03.5-.08.72l-.95-.95m-.22-3.94C13.96 7.31 13 7 12 7c-.54 0-1.06.09-1.55.25l-.76-.75C10.4 6.18 11.18 6 12 6c1.3 0 2.5.42 3.47 1.11l-.72.72M8.18 5L6.72 3.5C8.25 2.56 10.06 2 12 2c5.5 0 10 4.5 10 10c0 1.94-.56 3.75-1.5 5.28L19 15.83c.65-1.14 1-2.45 1-3.83c0-4.41-3.59-8-8-8c-1.38 0-2.69.35-3.82 1m8.57 8.55c.16-.49.25-1.01.25-1.55c0-1-.31-1.96-.83-2.75l.72-.72C17.59 9.5 18 10.7 18 12c0 .83-.18 1.6-.5 2.32l-.75-.77Z"/>'
        },
        smoking: {
            body: '<path fill="currentColor" d="M2 16h15v3H2v-3m18.5 0H22v3h-1.5v-3M18 16h1.5v3H18v-3m.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1 0 1.85.83 1.85 1.85S17.5 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03m-2.82 2.47H14.5c-1 0-1.85-.98-1.85-2s.85-1.75 1.85-1.75v-1.5a3.35 3.35 0 0 0-3.35 3.35a3.35 3.35 0 0 0 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16Z"/>'
        },
        "smoking-off": {
            body: '<path fill="currentColor" d="m2 6l7 7H2v3h10l7 7l1.25-1.25l-17-17L2 6m18.5 7H22v3h-1.5v-3M18 13h1.5v3H18v-3m.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1-.85 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04M14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1 0-1.85-.98-1.85-2S13.5 3.5 14.5 3.5V2a3.35 3.35 0 0 0-3.35 3.35A3.35 3.35 0 0 0 14.5 8.7m2.5 7.23V13h-2.93L17 15.93Z"/>'
        },
        "smoking-pipe": {
            body: '<path fill="currentColor" d="M16 13c-1.11 0-2 .89-2 2v3h-1c-1 0-2-.08-2.7-.77l-3.77-3.76C5.6 12.53 4.33 12 3 12H2v2h1c.8 0 1.56.32 2.12.88l3.77 3.77C11.72 21.5 13 22 16 22h2c2.21 0 4-1.79 4-4v-3c0-1.11-.89-2-2-2h-4m-2-5.8h-1.5a1.999 1.999 0 0 1-1.85-2c.02-.98.85-1.77 1.81-1.75h.04V2a3.35 3.35 0 0 0 0 6.7H14c1.07-.04 1.96.8 2 1.86V12h1.5v-1.64a3.302 3.302 0 0 0-3.45-3.16H14m6 2.56V12h-1.5V9.7c0-2.2-1.79-4-4-4V4.2A1.865 1.865 0 0 0 16.32 2h1.47c.1 1-.21 2-.97 2.73h.03C18.78 5.66 20 7.62 20 9.76Z"/>'
        },
        "smoking-pipe-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-1.13-1.13c-.52.25-1.09.4-1.71.4h-2c-3 0-4.28-.5-7.11-3.35l-3.77-3.77C4.56 14.32 3.8 14 3 14H2v-2h1c1.33 0 2.6.53 3.53 1.47l3.77 3.76c.7.69 1.7.77 2.7.77h1v-2.11L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27m1.09-4c.04-.23.07-.48.07-.73v-3c0-1.11-.89-2-2-2h-3.8l5.73 5.73M18.5 9.7V12H20V9.76c0-2.14-1.22-4.1-3.15-5.03h-.03C17.58 4 17.9 3 17.8 2h-1.48a1.865 1.865 0 0 1-1.82 2.2v1.5c2.21 0 4 1.8 4 4m-6.67-1.07c.22.05.44.07.67.07H14c1.07-.04 1.96.8 2 1.86V12h1.5v-1.64a3.302 3.302 0 0 0-3.45-3.16H12.5a1.999 1.999 0 0 1-1.85-2c.02-.98.85-1.77 1.81-1.75h.04V2a3.35 3.35 0 0 0-3.35 3.35c0 .23.02.45.07.65l2.61 2.63Z"/>'
        },
        snail: {
            body: '<path fill="currentColor" d="m20.31 8.03l.93-3.08c.43-.1.76-.48.76-.95c0-.55-.45-1-1-1s-1 .45-1 1c0 .26.11.5.27.68l-.77 2.58l-.77-2.58c.16-.18.27-.42.27-.68c0-.55-.45-1-1-1s-1 .45-1 1c0 .47.33.85.76.95l.93 3.08C17.73 8.18 17 9 17 10v2.25C15.65 9.16 12.63 7 9.11 7C5.19 7 2 10.26 2 14.26c0 1.84.82 3.49 2.1 4.59L2.88 19A1.003 1.003 0 0 0 3 21h16.12c1.04 0 1.88-.84 1.88-1.88v-7.4c.6-.34 1-.98 1-1.72c0-1-.73-1.82-1.69-1.97m-4.71 9.38l-3.53.45c.43-.76.73-1.65.73-2.6c0-2.32-1.85-4.2-4.13-4.2c-.53 0-1.05.12-1.53.35c-.49.25-.7.85-.45 1.34a1 1 0 0 0 1.34.46c.2-.1.42-.15.64-.15c1.18 0 2.13.98 2.13 2.2c0 1.66-1.3 3.01-2.91 3.01c-2.14 0-3.89-1.8-3.89-4.01C4 11.36 6.29 9 9.11 9c3.66 0 6.64 3.06 6.64 6.82c0 .54-.06 1.07-.15 1.59Z"/>'
        },
        snake: {
            body: '<path fill="currentColor" d="M19.5 17H18c1.1 0 2-.9 2-2s-.9-2-2-2V9c0-1 0-2-1.08-2.86c.05-.21.08-.42.08-.64C17 3.57 15 2 12.5 2c-2.26 0-4.12 1.31-4.43 3H6L3.71 2.79L3 3.5l2 2l-2 2l.71.71L6 6h2.07c.31 1.69 2.17 3 4.43 3c.5 0 1-.08 1.43-.2c.04.07.07.14.07.2v4H8c-1.1 0-2 .9-2 2s.9 2 2 2H6.5A2.5 2.5 0 0 0 4 19.5c0 .17 0 .34.05.5H4c-1.1 0-2 .9-2 2h17.5a2.5 2.5 0 0 0 0-5M12 5c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        snapchat: {
            body: '<path fill="currentColor" d="M21.93 16.56c-.14-.38-.43-.56-.71-.75c-.05-.03-.11-.06-.15-.08c-.07-.05-.18-.09-.27-.14c-.94-.5-1.68-1.13-2.19-1.87a6.15 6.15 0 0 1-.37-.66c-.04-.13-.04-.2-.01-.26c.03-.05.07-.1.12-.13c.15-.11.33-.21.44-.29c.21-.13.36-.23.46-.3c.39-.27.66-.58.83-.88c.24-.45.27-.98.08-1.45c-.25-.67-.89-1.09-1.66-1.09c-.16 0-.32.02-.5.05c0 .01-.06.02-.1.03c0-.46-.01-.94-.05-1.42c-.14-1.68-.73-2.56-1.35-3.26c-.39-.44-.85-.82-1.36-1.11c-.93-.53-1.99-.8-3.14-.8s-2.2.27-3.13.8c-.52.29-.98.67-1.37 1.11c-.62.7-1.2 1.58-1.35 3.26c-.04.48-.05.96-.04 1.42c-.05-.01-.11-.02-.11-.03c-.18-.03-.34-.05-.5-.05c-.77 0-1.41.42-1.66 1.09c-.19.47-.16 1 .08 1.45c.17.3.44.61.83.88c.1.07.25.17.46.31l.42.27c.06.04.1.09.14.14c.03.07.03.14-.02.27c-.1.23-.22.43-.36.65c-.5.73-1.21 1.35-2.12 1.84c-.49.26-.99.44-1.2 1c-.16.44-.07.94.35 1.35c.15.15.32.28.51.38c.4.21.82.39 1.25.5c.09.03.18.06.25.12c.15.12.13.32.33.59c.1.16.24.29.37.39c.41.29.87.3 1.37.32c.44.02.94.04 1.5.23c.26.06.5.23.79.41c.71.42 1.63 1 3.21 1c1.57 0 2.5-.58 3.22-1.01c.28-.17.53-.34.78-.4c.55-.19 1.06-.21 1.5-.23c.5-.01.96-.03 1.37-.32c.17-.12.31-.28.42-.46c.14-.24.14-.43.27-.52c.07-.05.15-.09.24-.11c.44-.12.86-.3 1.26-.51c.21-.11.39-.25.54-.42h.01c.39-.41.47-.87.32-1.31m-1.4.75c-.86.47-1.43.42-1.87.69c-.16.12-.21.28-.24.44l-.03.2c-.02.14-.05.26-.15.33c-.34.23-1.33-.02-2.61.4c-1.06.35-1.73 1.36-3.63 1.36s-2.55-1-3.63-1.36c-1.27-.42-2.27-.17-2.6-.4c-.27-.19-.05-.71-.43-.97c-.44-.27-1.01-.22-1.84-.69c-.31-.16-.36-.31-.32-.38c.04-.09.16-.16.24-.2c1.65-.79 2.58-1.82 3.05-2.63c.44-.72.53-1.27.56-1.35c.03-.21.06-.37-.17-.58c-.22-.21-1.2-.81-1.47-1c-.46-.32-.65-.63-.51-1.02c.12-.27.35-.37.62-.37c.08 0 .16.01.24.03c.5.1.98.35 1.26.42c.03.01.06.01.1.01c.09 0 .14-.03.17-.09c.01-.04.02-.09.02-.15c-.04-.54-.11-1.59-.03-2.58c.04-.42.11-.78.2-1.09c.2-.68.54-1.13.88-1.54c.25-.29 1.41-1.52 3.66-1.52c1.85 0 2.96.84 3.44 1.29c.1.1.18.18.22.23c.38.44.72.92.92 1.68c.07.27.13.59.16.95c.08.98.01 2.04-.03 2.58c0 .04 0 .08.01.11c.01.09.07.13.18.13c.04 0 .07 0 .1-.01c.28-.07.76-.32 1.26-.43c.08-.01.16-.02.24-.02c.25 0 .5.09.6.32l.01.04h.01v.01c.15.38-.05.7-.5 1.01c-.27.19-1.26.8-1.48 1c-.23.22-.2.38-.17.59c.03.1.21 1.05 1.11 2.11c.55.64 1.34 1.31 2.5 1.87c.07.03.16.08.21.14c.03.05.05.09.04.13c-.01.1-.1.2-.3.31Z"/>'
        },
        snowboard: {
            body: '<path fill="currentColor" d="M21.87 20.37c-.11-.17-.25-.28-.44-.31a.71.71 0 0 0-.65.14c-.35.3-.74.53-1.2.66c-.45.14-.92.14-1.42.04l-1.12-.28L16 14.46l-3.26-2.67l1.76-2.85c.58.91 1.35 1.64 2.33 2.2c.98.56 2.05.86 3.2.86V9.97c-.94 0-1.77-.25-2.5-.75s-1.27-1.15-1.61-1.96l-.56-1.21c-.1-.19-.28-.41-.54-.66c-.27-.25-.63-.39-1.1-.39H8.07L5.54 9l1.73 1.06L9.14 7h2.36L9 10.95c-.31.47-.4.98-.28 1.55l.84 3.45l-3.5 2.34l-.47-.1a2.85 2.85 0 0 1-1.26-.58c-.37-.3-.65-.65-.83-1.05c-.1-.25-.27-.39-.5-.42c-.24-.06-.44-.03-.61.09s-.27.27-.3.47c-.03.15-.02.3.04.47c.29.62.7 1.16 1.24 1.61c.55.45 1.18.72 1.9.86l12.61 2.71c.72.15 1.41.15 2.08-.05c.67-.18 1.27-.51 1.8-.98c.12-.09.2-.21.24-.37c0-.22 0-.41-.13-.58m-13.1-1.48l3.04-2l-.47-3.32l2.85 2.01l.75 4.62l-6.17-1.31M18 3c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        snowflake: {
            body: '<path fill="currentColor" d="m20.79 13.95l-2.33.62l-2-1.13v-2.88l2-1.13l2.33.62l.52-1.93l-1.77-.47l.46-1.77l-1.93-.52l-.62 2.33l-2 1.13L13 7.38V5.12l1.71-1.71L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12v2.26L8.5 8.82l-2-1.13l-.58-2.33L4 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13v2.89l-2 1.13l-2.33-.62l-.52 1.93l1.77.47L4 18.12l1.93.52l.62-2.33l2-1.13L11 16.62v2.26l-1.71 1.71L10.71 22L12 20.71L13.29 22l1.41-1.41l-1.7-1.71v-2.26l2.5-1.45l2 1.13l.62 2.33l1.88-.51l-.47-1.77l1.77-.47l-.51-1.93M9.5 10.56L12 9.11l2.5 1.45v2.88L12 14.89l-2.5-1.45v-2.88Z"/>'
        },
        "snowflake-alert": {
            body: '<path fill="currentColor" d="M16.46 9.41L13 7.38V5.12l1.71-1.71L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12v2.26L8.5 8.82l-2-1.13l-.58-2.33L4 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13v2.89l-2 1.13l-2.33-.62l-.52 1.93l1.77.47L4 18.12l1.93.52l.62-2.33l2-1.13L11 16.62v2.26l-1.71 1.71L10.71 22L12 20.71L13.29 22l1.41-1.41l-1.7-1.71v-2.26l3.46-2.01M9.5 10.56L12 9.11l2.5 1.45v2.88L12 14.89l-2.5-1.45M19 13V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "snowflake-check": {
            body: '<path fill="currentColor" d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41l-4.75 4.75M12 18c0-1.54.59-2.94 1.54-4l-1.54.89l-2.5-1.45v-2.88L12 9.11l2.5 1.45v2.57a5.98 5.98 0 0 1 1.96-.92v-1.65l2-1.13l2.33.62l.52-1.93l-1.77-.47l.46-1.77l-1.93-.52l-.62 2.33l-2 1.13L13 7.38V5.12l1.71-1.71L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12v2.26L8.5 8.82l-2-1.13l-.58-2.33L4 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13v2.89l-2 1.13l-2.33-.62l-.52 1.93l1.77.47L4 18.12l1.93.52l.62-2.33l2-1.13L11 16.62v2.26l-1.71 1.71L10.71 22L12 20.71L13.29 22l.13-.13A5.935 5.935 0 0 1 12 18Z"/>'
        },
        "snowflake-melt": {
            body: '<path fill="currentColor" d="M8 17.85C8 19.04 7.11 20 6 20s-2-.96-2-2.15C4 16.42 6 14 6 14s2 2.42 2 3.85M16.46 12v-1.44l2-1.13l2.33.62l.52-1.93l-1.77-.47l.46-1.77l-1.93-.52l-.62 2.33l-2 1.13L13 7.38V5.12l1.71-1.71L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12v2.26L8.5 8.82l-2-1.13l-.58-2.33L4 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13V12H2v1h20v-1h-5.54M9.5 12v-1.44L12 9.11l2.5 1.45V12h-5M20 17.85c0 1.19-.89 2.15-2 2.15s-2-.96-2-2.15c0-1.43 2-3.85 2-3.85s2 2.42 2 3.85m-6 3c0 1.19-.89 2.15-2 2.15s-2-.96-2-2.15c0-1.43 2-3.85 2-3.85s2 2.42 2 3.85Z"/>'
        },
        "snowflake-off": {
            body: '<path fill="currentColor" d="M11 5.12L9.29 3.41L10.71 2L12 3.29L13.29 2l1.42 1.41L13 5.12v2.26l2.45 1.44l2-1.13l.62-2.33l1.93.52l-.46 1.77l1.77.47l-.52 1.93l-2.33-.62l-2 1.13v2.7L14.5 11.3v-.74l-1.76-1.02l-2.01-2.01l.27-.15V5.12m7.46 9.45l-1.59-.9l2.68 2.68l1.75-.47l-.51-1.93l-2.33.62M13 16.62v2.26l1.7 1.71L13.29 22L12 20.71L10.71 22l-1.42-1.41L11 18.88v-2.26l-2.45-1.44l-2 1.13l-.62 2.33L4 18.12l.47-1.76l-1.77-.47l.52-1.93l2.33.62l2-1.13v-2.89l-2-1.13l-2.33.62l-.52-1.93l1.77-.47L4 5.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27L14.1 16l-1.1.62m-1-1.73l.63-.39l-3.13-3.11v2.05l2.5 1.45Z"/>'
        },
        "snowflake-thermometer": {
            body: '<path fill="currentColor" d="M14.46 9.41L11 7.38V5.12l1.71-1.71L11.29 2L10 3.29L8.71 2L7.29 3.41L9 5.12v2.26L6.5 8.82l-2-1.13l-.58-2.33L2 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13v2.89l-2 1.13l-2.33-.62l-.52 1.93l1.77.47L2 18.12l1.93.52l.62-2.33l2-1.13L9 16.62v2.26l-1.71 1.71L8.71 22L10 20.71L11.29 22l1.41-1.41l-1.7-1.71v-2.26l3.46-2.01M7.5 10.56L10 9.11l2.5 1.45v2.88L10 14.89l-2.5-1.45M19 5c-1.11 0-2 .89-2 2v6.76c-.64.57-1 1.39-1 2.24c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.85-.36-1.67-1-2.23V7c0-1.11-.89-2-2-2m0 1c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1"/>'
        },
        "snowflake-variant": {
            body: '<path fill="currentColor" d="m14.25 12l2.02-1H23l-1-2h-3.97l2.39-3.17l-.99-2l-4.06 5.37l-2.02 1.01l.4-2.21l4.08-5.38l-2.19-.4L12 7L8.4 2.2l-2.2.4L10.26 8l.4 2.21l-1.84-.92l-.16-.08L4.6 3.8l-1 2L6 9H2l-1 2h6.77l1.98 1l-2.02 1H1l1 2h3.97l-2.39 3.17l.99 2l4.06-5.37l2.02-1.01l-.4 2.21l-4.08 5.38l2.19.41L12 17l3.6 4.8l2.2-.4l-4.06-5.4l-.4-2.21l2 1l4.06 5.41l1-2L18 15h4l1-2h-6.77"/>'
        },
        snowman: {
            body: '<path fill="currentColor" d="M17 17a5 5 0 0 1-5 5a5 5 0 0 1-5-5c0-1.5.65-2.83 1.69-3.75C8.26 12.61 8 11.83 8 11v-.41L5.04 8.87l-.21-.16l-2.54.68l-.26-.96l2.21-.59l-1.98-1.15l.5-.87l1.98 1.15l-.59-2.22l.96-.25l.69 2.54l.24.1l2.69 1.55a3.9 3.9 0 0 1 1.49-1.27C9.5 6.87 9 6 9 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1-.5 1.87-1.22 2.42c.6.29 1.11.73 1.49 1.27l2.69-1.55l.24-.1l.69-2.54l.96.25l-.59 2.22l1.98-1.15l.5.87l-1.98 1.15l2.21.59l-.26.96l-2.54-.68l-.21.16L16 10.59V11c0 .83-.26 1.61-.69 2.25C16.35 14.17 17 15.5 17 17Z"/>'
        },
        snowmobile: {
            body: '<path fill="currentColor" d="M20.34 17.93L18.4 16c1.1-.09 4.26-.47 4.57-2.64a.92.92 0 0 0-.19-.66c-.66-.88-2.9-3.63-7.78-7.7h-3v2h2l2 2l-4 2l-9-1l-2 3l4.58 1.38l-3 1.71c-.36.17-1.58.8-1.58 1.96c0 .35 0 .84.33 1.27c.5.68 1.38.68 1.67.68h6c1.26 0 3.53-.87 3.93-4h2.66l2 2H15v2h5c1.65 0 3-1.35 3-3h-2c0 .43-.27.79-.66.93M9 18H3.25c.08-.05.16-.09.25-.13l4.72-2.7l2.7.83c-.34 1.84-1.64 2-1.92 2Z"/>'
        },
        snowshoeing: {
            body: '<path fill="currentColor" d="M12.5 3.5c0-1.1.9-2 2-2s2 .9 2 2s-.9 2-2 2s-2-.9-2-2M6.32 19.03l-1.14-1.47L4 18.5l2.38 3.04c.51.65 1.16 1.15 1.88 1.41c.28.1.53.05.74-.11c.28-.23.4-.7.1-1.07c-.1-.1-.2-.17-.31-.22a2.97 2.97 0 0 1-1.14-.83l-.08-.1L11 18.2l.89-3.2L14 17v4.5h-2V23h3.87c.82 0 1.63-.21 2.26-.61c.26-.16.37-.39.37-.64c0-.38-.3-.75-.77-.75c-.13 0-.26.04-.37.1c-.4.23-.86.37-1.36.4v-6l-2.11-2l.61-3C15.79 12 17.8 13 20 13v-2c-1.9 0-3.5-1-4.31-2.42l-1-1.58c-.4-.6-1-1-1.69-1c-.76 0-1.42.34-6 2.28V13h2V9.58l1.79-.7L9.2 17l-2.88 2.03Z"/>'
        },
        soccer: {
            body: '<path fill="currentColor" d="m16.93 17.12l-.8-1.36l1.46-4.37l1.41-.47l1 .75v.14c0 .07.03.13.03.19c0 1.97-.66 3.71-1.97 5.21l-1.13-.09M9.75 15l-1.37-4.03L12 8.43l3.62 2.54L14.25 15h-4.5M12 20.03c-.88 0-1.71-.14-2.5-.42l-.69-1.51l.66-1.1h5.11l.61 1.1l-.69 1.51c-.79.28-1.62.42-2.5.42m-6.06-2.82c-.53-.62-.99-1.45-1.38-2.46c-.39-1.02-.59-1.94-.59-2.75c0-.06.03-.12.03-.19v-.14l1-.75l1.41.47l1.46 4.37l-.8 1.36l-1.13.09M11 5.29v1.4L7 9.46l-1.34-.42l-.42-1.36C5.68 7 6.33 6.32 7.19 5.66s1.68-1.09 2.46-1.31l1.35.94m3.35-.94c.78.22 1.6.65 2.46 1.31c.86.66 1.51 1.34 1.95 2.02l-.42 1.36l-1.34.43l-4-2.77V5.29l1.35-.94m-9.42.58C3 6.89 2 9.25 2 12s1 5.11 2.93 7.07S9.25 22 12 22s5.11-1 7.07-2.93S22 14.75 22 12s-1-5.11-2.93-7.07S14.75 2 12 2S6.89 3 4.93 4.93Z"/>'
        },
        "soccer-field": {
            body: '<path fill="currentColor" d="M4 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4m0 2h7v2.13c-1.76.46-3 2.05-3 3.87a4.01 4.01 0 0 0 3 3.87V18H4v-2h3V8H4V6m9 0h7v2h-3v8h3v2h-7v-2.13c1.76-.46 3-2.05 3-3.87a4.01 4.01 0 0 0-3-3.87V6m-9 4h1v4H4v-4m15 0h1v4h-1v-4m-6 .27c.62.36 1 1.02 1 1.73s-.38 1.37-1 1.73v-3.46m-2 0v3.46c-.62-.36-1-1.02-1-1.73s.38-1.37 1-1.73Z"/>'
        },
        "social-distance-2-meters": {
            body: '<path fill="currentColor" d="M6 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4 3.43c0-.81-.5-1.53-1.22-1.85C7.93 7.21 7 7 6 7s-1.93.21-2.78.58C2.5 7.9 2 8.62 2 9.43V10h8v-.57M18 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4 3.43c0-.81-.5-1.53-1.22-1.85C19.93 7.21 19 7 18 7s-1.93.21-2.78.58C14.5 7.9 14 8.62 14 9.43V10h8v-.57M19 17v-2H5v2l-3-3l3-3v2h14v-2l3 3l-3 3M9 20.5v.5h2v1H8v-1.5c0-.55.45-1 1-1h1V19H8v-1h2c.55 0 1 .45 1 1v.5c0 .55-.45 1-1 1H9m7-1.5v3h-1v-3h-.5v2h-1v-2H13v3h-1v-3c0-.55.45-1 1-1h2c.55 0 1 .45 1 1Z"/>'
        },
        "social-distance-6-feet": {
            body: '<path fill="currentColor" d="M6 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4 3.43c0-.81-.5-1.53-1.22-1.85C7.93 7.21 7 7 6 7s-1.93.21-2.78.58C2.5 7.9 2 8.62 2 9.43V10h8v-.57M18 6c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4 3.43c0-.81-.5-1.53-1.22-1.85C19.93 7.21 19 7 18 7s-1.93.21-2.78.58C14.5 7.9 14 8.62 14 9.43V10h8v-.57M19 17v-2H5v2l-3-3l3-3v2h14v-2l3 3l-3 3m-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2m-1 1.5v.5H8v-.5h1m8.5-1.5h-1v3h-1v-3h-1v-1h3v1m-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5Z"/>'
        },
        sofa: {
            body: '<path fill="currentColor" d="M12.5 7c0-1.11.89-2 2-2H18c1.1 0 2 .9 2 2v2.16c-1.16.41-2 1.51-2 2.81V14h-5.5V7M6 11.96V14h5.5V7c0-1.11-.89-2-2-2H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.52 2 2.81m14.66-1.93c-.98.16-1.66 1.09-1.66 2.09V15H5v-3a2 2 0 1 0-4 0v5c0 1.1.9 2 2 2v2h2v-2h14v2h2v-2c1.1 0 2-.9 2-2v-5c0-1.21-1.09-2.18-2.34-1.97Z"/>'
        },
        "sofa-outline": {
            body: '<path fill="currentColor" d="M21 9V7c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78c-.53-.48-1.23-.78-2-.78H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v2h2v-2h14v2h2v-2c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3m-7-3h4c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2h-5V7c0-.55.45-1 1-1M5 7c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v7H6v-2c0-.88-.39-1.67-1-2.22V7m17 10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5Z"/>'
        },
        "sofa-single": {
            body: '<path fill="currentColor" d="M5 9.15V7c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v2.16c-1.16.41-2 1.51-2 2.81V14H7v-2.04c0-1.29-.84-2.4-2-2.81M20 10c-1.1 0-2 .9-2 2v3H6v-3a2 2 0 1 0-4 0v5c0 1.1.9 2 2 2v2h2v-2h12v2h2v-2c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2Z"/>'
        },
        "sofa-single-outline": {
            body: '<path fill="currentColor" d="M19 9V7c0-1.65-1.35-3-3-3H8C6.35 4 5 5.35 5 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v2h2v-2h10v2h2v-2c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3M7 7c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H8v-2c0-.88-.39-1.67-1-2.22V7m13 10c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h12v-4c0-.55.45-1 1-1s1 .45 1 1v5Z"/>'
        },
        "solar-panel": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5v4h3v2h-5v-6h-2v6H6v-2h3v-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v4h7V4H4m0 10h7v-4H4v4m16 0v-4h-7v4h7m0-10h-7v4h7V4Z"/>'
        },
        "solar-panel-large": {
            body: '<path fill="currentColor" d="M3 6h3V3H3v3m5-3v3h3V3H8m5 0v3h3V3h-3m5 0v3h3V3h-3m3 5h-3v3h3V8m0 5h-3v3h3v-3m-5 3v-3h-3v3h3m-5 0v-3H8v3h3m-5 0v-3H3v3h3m-3-5h3V8H3v3m10-3v3h3V8h-3M8 8v3h3V8H8M3 1h18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-6v3h3v2h-5v-5h-2v5H6v-2h3v-3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Z"/>'
        },
        "solar-power": {
            body: '<path fill="currentColor" d="M11.45 2v3.55L15 3.77L11.45 2m-1 6L8 10.46l3.75 1.25L10.45 8M2 11.45L3.77 15l1.78-3.55H2M10 2H2v8c.57.17 1.17.25 1.77.25c3.58.01 6.49-2.9 6.5-6.5c-.01-.59-.1-1.18-.27-1.75m7 20v-6h-3l5-9v6h3l-5 9Z"/>'
        },
        "solar-power-variant": {
            body: '<path fill="currentColor" d="M3.33 16H11v-3H4l-.67 3M13 16h7.67L20 13h-7v3m8.11 2H13v4h9l-.89-4M2 22h9v-4H2.89L2 22m9-14h2v3h-2V8m4.76-.79l1.42-1.42l2.12 2.12l-1.41 1.42l-2.13-2.12m-11.05.7l2.12-2.12l1.41 1.42l-2.12 2.12l-1.41-1.42M3 2h3v2H3V2m15 0h3v2h-3V2m-6 5c2.76 0 5-2.24 5-5H7c0 2.76 2.24 5 5 5Z"/>'
        },
        "solar-power-variant-outline": {
            body: '<path fill="currentColor" d="M20 12H4L2 22h20l-2-10m-1.64 2l.4 2H13v-2h5.36M11 14v2H5.24l.4-2H11m-6.16 4H11v2H4.44l.4-2M13 20v-2h6.16l.4 2H13M11 8h2v3h-2V8m4.76-.79l1.42-1.42l2.12 2.12l-1.41 1.42l-2.13-2.12m-11.05.7l2.12-2.12l1.41 1.42l-2.12 2.12l-1.41-1.42M3 2h3v2H3V2m15 0h3v2h-3V2m-6 5c2.76 0 5-2.24 5-5h-2c0 1.65-1.35 3-3 3S9 3.65 9 2H7c0 2.76 2.24 5 5 5Z"/>'
        },
        "soldering-iron": {
            body: '<path fill="currentColor" d="M4.86 4.03L2.03 6.86l3.18 3.18v2.83l1.42 1.41l5.65-5.65l-1.41-1.42H8.04L4.86 4.03M17 6v1.5c1 0 1.85.83 1.85 1.85S18 11.2 17 11.2v1.5c2.24 0 4 1.83 4 4.07V21h1.5v-4.24c0-2.22-1.28-4.14-3.15-5.03c.62-.61 1-1.45 1-2.38C20.35 7.5 18.85 6 17 6m-5.07 5.1L9.1 13.93l4.95 4.95l.71-.71l2.12 2.12L19 21l-.71-2.12l-2.12-2.12l.71-.71l-4.95-4.95Z"/>'
        },
        solid: {
            body: '<path fill="currentColor" d="M0 0h24v24H0"/>'
        },
        "sony-playstation": {
            body: '<path fill="currentColor" d="M9.5 4.27c1.38.26 3.4.87 4.5 1.23c2.75.95 3.69 2.13 3.69 4.79c0 2.6-1.6 3.58-3.64 2.6V8.05c0-.55-.1-1.08-.64-1.23c-.41-.13-.65.25-.65.81v12.1L9.5 18.69V4.27m3.87 13.35l5.25-1.87c.6-.21.69-.51.21-.67c-.49-.16-1.36-.11-1.96.1l-3.5 1.23v-1.96l.21-.07s1.01-.38 2.42-.51c1.43-.16 3.17.02 4.53.53c1.54.49 1.72 1.21 1.33 1.7c-.4.5-1.36.85-1.36.85l-7.13 2.55v-1.88m-9.87-.2C1.93 17 1.66 16.05 2.38 15.5c.67-.5 1.8-.85 1.8-.85L8.86 13v1.88L5.5 16.09c-.6.21-.69.51-.21.67c.48.16 1.36.12 1.95-.1l1.62-.58v1.69l-.32.06c-1.62.26-3.34.17-5.04-.41Z"/>'
        },
        sort: {
            body: '<path fill="currentColor" d="m18 21l-4-4h3V7h-3l4-4l4 4h-3v10h3M2 19v-2h10v2M2 13v-2h7v2M2 7V5h4v2H2Z"/>'
        },
        "sort-alphabetical-ascending": {
            body: '<path fill="currentColor" d="M19 17h3l-4 4l-4-4h3V3h2m-8 10v2l-3.33 4H11v2H5v-2l3.33-4H5v-2M9 3H7c-1.1 0-2 .9-2 2v6h2V9h2v2h2V5a2 2 0 0 0-2-2m0 4H7V5h2Z"/>'
        },
        "sort-alphabetical-ascending-variant": {
            body: '<path fill="currentColor" d="m9.25 5l3.25-3.25L15.75 5h-6.5m-.36 9.3H6L5.28 17H2.91L6 7h3l3.13 10H9.67l-.78-2.7m-2.56-1.62h2.23l-.63-2.12l-.26-.97l-.25-.96h-.03l-.22.97l-.24.98l-.6 2.1M13.05 17v-1.26l4.75-6.77v-.06h-4.3V7h7.23v1.34L16.09 15v.08h4.71V17h-7.75Z"/>'
        },
        "sort-alphabetical-descending": {
            body: '<path fill="currentColor" d="M19 7h3l-4-4l-4 4h3v14h2m-8-8v2l-3.33 4H11v2H5v-2l3.33-4H5v-2M9 3H7c-1.1 0-2 .9-2 2v6h2V9h2v2h2V5a2 2 0 0 0-2-2m0 4H7V5h2Z"/>'
        },
        "sort-alphabetical-descending-variant": {
            body: '<path fill="currentColor" d="m15.75 19l-3.25 3.25L9.25 19h6.5m-6.86-4.7H6L5.28 17H2.91L6 7h3l3.13 10H9.67l-.78-2.7m-2.56-1.62h2.23l-.63-2.12l-.26-.97l-.25-.96h-.03l-.22.97l-.24.98l-.6 2.1M13.05 17v-1.26l4.75-6.77v-.06h-4.3V7h7.23v1.34L16.09 15v.08h4.71V17h-7.75Z"/>'
        },
        "sort-alphabetical-variant": {
            body: '<path fill="currentColor" d="m9.25 5l3.25-3.25L15.75 5h-6.5m6.5 14l-3.25 3.25L9.25 19h6.5m-6.86-4.7H6L5.28 17H2.91L6 7h3l3.13 10H9.67l-.78-2.7m-2.56-1.62h2.23l-.63-2.12l-.26-.97l-.25-.96h-.03l-.22.97l-.24.98l-.6 2.1M13.05 17v-1.26l4.75-6.77v-.06h-4.3V7h7.23v1.34L16.09 15v.08h4.71V17h-7.75Z"/>'
        },
        "sort-ascending": {
            body: '<path fill="currentColor" d="M19 17h3l-4 4l-4-4h3V3h2M2 17h10v2H2M6 5v2H2V5m0 6h7v2H2v-2Z"/>'
        },
        "sort-bool-ascending": {
            body: '<path fill="currentColor" d="M19 17h3l-4 4l-4-4h3V3h2v14M7 3C4.79 3 3 4.79 3 7s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2m0 4c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4Z"/>'
        },
        "sort-bool-ascending-variant": {
            body: '<path fill="currentColor" d="M19 17h3l-4 4l-4-4h3V3h2v14M9 13H5c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2m-2.73 6.5l-2.53-2.55l1.07-1.05l1.47 1.49L9.2 14.5l1.06 1.05l-3.99 3.95M9 3H5c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m0 6H5V5h4v4Z"/>'
        },
        "sort-bool-descending": {
            body: '<path fill="currentColor" d="M19 7h3l-4-4l-4 4h3v14h2M5 7c0 1.1.9 2 2 2s2-.9 2-2s-.9-2-2-2s-2 .9-2 2m2-4c2.21 0 4 1.79 4 4s-1.79 4-4 4s-4-1.79-4-4s1.79-4 4-4m0 10c-2.21 0-4 1.79-4 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4Z"/>'
        },
        "sort-bool-descending-variant": {
            body: '<path fill="currentColor" d="M19 7h3l-4-4l-4 4h3v14h2M5 13c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2v-4c0-1.11-.89-2-2-2m.2 1.5l1.06 1.05l-3.99 3.95l-2.53-2.55l1.07-1.05l1.47 1.49M5 3c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h4c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2M5 5h4v4H5Z"/>'
        },
        "sort-calendar-ascending": {
            body: '<path fill="currentColor" d="M21 17h3l-4 4l-4-4h3V3h2v14M8 16h3v-3H8v3m5-11h-1V3h-2v2H6V3H4v2H3c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h10c1.11 0 2-.89 2-2V7c0-1.11-.89-2-2-2M3 18v-7h10v7H3Z"/>'
        },
        "sort-calendar-descending": {
            body: '<path fill="currentColor" d="M19 7h-3l4-4l4 4h-3v14h-2V7M8 16h3v-3H8v3m5-11h-1V3h-2v2H6V3H4v2H3c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h10c1.11 0 2-.89 2-2V7c0-1.11-.89-2-2-2M3 18v-7h10v7H3Z"/>'
        },
        "sort-clock-ascending": {
            body: '<path fill="currentColor" d="M20 17h3l-4 4l-4-4h3V3h2v14M8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m2.19 9.53L7 12.69V9h1.5v2.82l2.44 1.41l-.75 1.3Z"/>'
        },
        "sort-clock-ascending-outline": {
            body: '<path fill="currentColor" d="M20 17h3l-4 4l-4-4h3V3h2v14M8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85c0 2.68-2.17 4.85-4.85 4.85c-2.68 0-4.85-2.17-4.85-4.85c0-2.68 2.17-4.85 4.85-4.85M7 9v3.69l3.19 1.84l.75-1.3l-2.44-1.41V9"/>'
        },
        "sort-clock-descending": {
            body: '<path fill="currentColor" d="M18 7h-3l4-4l4 4h-3v14h-2V7M8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m2.19 9.53L7 12.69V9h1.5v2.82l2.44 1.41l-.75 1.3Z"/>'
        },
        "sort-clock-descending-outline": {
            body: '<path fill="currentColor" d="M18 7h-3l4-4l4 4h-3v14h-2V7M8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85c0 2.68-2.17 4.85-4.85 4.85c-2.68 0-4.85-2.17-4.85-4.85c0-2.68 2.17-4.85 4.85-4.85M7 9v3.69l3.19 1.84l.75-1.3l-2.44-1.41V9"/>'
        },
        "sort-descending": {
            body: '<path fill="currentColor" d="M19 7h3l-4-4l-4 4h3v14h2M2 17h10v2H2M6 5v2H2V5m0 6h7v2H2v-2Z"/>'
        },
        "sort-numeric-ascending": {
            body: '<path fill="currentColor" d="M19 17h3l-4 4l-4-4h3V3h2v14M9 13H7c-1.1 0-2 .9-2 2v1a2 2 0 0 0 2 2h2v1H5v2h4c1.11 0 2-.89 2-2v-4a2 2 0 0 0-2-2m0 3H7v-1h2v1M9 3H7c-1.1 0-2 .9-2 2v4a2 2 0 0 0 2 2h2c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 6H7V5h2v4Z"/>'
        },
        "sort-numeric-ascending-variant": {
            body: '<path fill="currentColor" d="M7.78 7c1.3.04 2.22.53 2.79 1.46c.56.94.84 2.1.82 3.49c.01 1.55-.3 2.78-.89 3.67c-.62.88-1.55 1.35-2.79 1.38c-1.26-.04-2.17-.5-2.75-1.44c-.58-.93-.87-2.11-.87-3.56s.3-2.64.91-3.56C5.59 7.5 6.5 7.04 7.78 7m-.03 1.63c-.44 0-.79.27-1.05.83c-.26.54-.38 1.41-.38 2.54c-.01 1.15.12 2 .37 2.54c.26.56.62.83 1.08.83c.92 0 1.39-1.13 1.4-3.37c0-2.23-.47-3.35-1.42-3.37M13.33 17v-1.78l.43.02l.54-.02l1.04-.19c.34-.11.66-.25.92-.45c.33-.23.6-.5.81-.82c.22-.31.37-.64.46-.98l-.03-.01c-.45.42-1.12.63-2.03.64c-.85-.01-1.56-.26-2.13-.76s-.84-1.22-.88-2.15c.01-1 .35-1.81 1.01-2.47c.67-.66 1.53-1 2.65-1.03c1.25.04 2.17.45 2.76 1.24c.59.76.88 1.76.88 2.95c-.01.96-.15 1.81-.44 2.57c-.29.74-.68 1.37-1.2 1.88c-.46.42-1.01.74-1.65.97c-.64.22-1.35.35-2.13.39h-1.01m2.73-8.37c-.41.01-.74.17-1 .48c-.25.31-.38.73-.38 1.25c0 .44.12.8.35 1.1c.24.31.6.46 1.08.47c.32 0 .59-.07.81-.19c.22-.13.38-.28.49-.46c.09-.11.12-.31.12-.57c.01-.55-.1-1.02-.33-1.43c-.23-.41-.61-.63-1.14-.65M9.25 5l3.25-3.25L15.75 5h-6.5"/>'
        },
        "sort-numeric-descending": {
            body: '<path fill="currentColor" d="M19 7h3l-4-4l-4 4h3v14h2M9 21H5v-2h4v-1H7a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2m0-6H7v1h2M7 3h2a2 2 0 0 1 2 2v4c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 6h2V5H7Z"/>'
        },
        "sort-numeric-descending-variant": {
            body: '<path fill="currentColor" d="M7.78 7c1.3.04 2.22.53 2.79 1.46c.56.94.84 2.1.82 3.49c.01 1.55-.3 2.78-.89 3.67c-.62.88-1.55 1.35-2.79 1.38c-1.26-.04-2.17-.5-2.75-1.44c-.58-.93-.87-2.11-.87-3.56s.3-2.64.91-3.56C5.59 7.5 6.5 7.04 7.78 7m-.03 1.63c-.44 0-.79.27-1.05.83c-.26.54-.38 1.41-.38 2.54c-.01 1.15.12 2 .37 2.54c.26.56.62.83 1.08.83c.92 0 1.39-1.13 1.4-3.37c0-2.23-.47-3.35-1.42-3.37M13.33 17v-1.78l.43.02l.54-.02l1.04-.19c.34-.11.66-.25.92-.45c.33-.23.6-.5.81-.82c.22-.31.37-.64.46-.98l-.03-.01c-.45.42-1.12.63-2.03.64c-.85-.01-1.56-.26-2.13-.76s-.84-1.22-.88-2.15c.01-1 .35-1.81 1.01-2.47c.67-.66 1.53-1 2.65-1.03c1.25.04 2.17.45 2.76 1.24c.59.76.88 1.76.88 2.95c-.01.96-.15 1.81-.44 2.57c-.29.74-.68 1.37-1.2 1.88c-.46.42-1.01.74-1.65.97c-.64.22-1.35.35-2.13.39h-1.01m2.73-8.37c-.41.01-.74.17-1 .48c-.25.31-.38.73-.38 1.25c0 .44.12.8.35 1.1c.24.31.6.46 1.08.47c.32 0 .59-.07.81-.19c.22-.13.38-.28.49-.46c.09-.11.12-.31.12-.57c.01-.55-.1-1.02-.33-1.43c-.23-.41-.61-.63-1.14-.65M15.75 19l-3.25 3.25L9.25 19h6.5Z"/>'
        },
        "sort-numeric-variant": {
            body: '<path fill="currentColor" d="M7.78 7c1.3.04 2.22.53 2.79 1.46c.56.94.84 2.1.82 3.49c.01 1.55-.3 2.78-.89 3.67c-.62.88-1.55 1.35-2.79 1.38c-1.26-.04-2.17-.5-2.75-1.44c-.58-.93-.87-2.11-.87-3.56c0-1.45.3-2.64.91-3.56c.59-.94 1.5-1.4 2.78-1.44m-.03 1.63c-.44 0-.79.27-1.05.83c-.26.54-.38 1.41-.38 2.54c-.01 1.15.12 2 .37 2.54c.26.56.62.83 1.08.83c.92 0 1.39-1.13 1.4-3.37c0-2.23-.47-3.35-1.42-3.37M13.33 17v-1.78l.43.02l.54-.02l1.04-.19c.34-.11.66-.25.92-.45c.33-.23.6-.5.81-.82c.22-.31.37-.64.46-.98l-.03-.01c-.45.42-1.12.63-2.03.64c-.85-.01-1.56-.26-2.13-.76c-.57-.5-.84-1.22-.88-2.15c.01-1 .35-1.81 1.01-2.47c.67-.66 1.53-1 2.65-1.03c1.25.04 2.17.45 2.76 1.24c.59.76.88 1.76.88 2.95c-.01.96-.15 1.81-.44 2.57c-.29.74-.68 1.37-1.2 1.88c-.46.42-1.01.74-1.65.97c-.64.22-1.35.35-2.13.39h-1.01m2.73-8.37c-.41.01-.74.17-1 .48c-.25.31-.38.73-.38 1.25c0 .44.12.8.35 1.1c.24.31.6.46 1.08.47c.32 0 .59-.07.81-.19c.22-.13.38-.28.49-.46c.09-.11.12-.31.12-.57c.01-.55-.1-1.02-.33-1.43c-.23-.41-.61-.63-1.14-.65M9.25 5l3.25-3.25L15.75 5h-6.5m6.5 14l-3.25 3.25L9.25 19h6.5Z"/>'
        },
        "sort-reverse-variant": {
            body: '<path fill="currentColor" d="M3 11h12v2H3m0 5v-2h18v2M3 6h6v2H3Z"/>'
        },
        "sort-variant": {
            body: '<path fill="currentColor" d="M3 13h12v-2H3m0-5v2h18V6M3 18h6v-2H3v2Z"/>'
        },
        "sort-variant-lock": {
            body: '<path fill="currentColor" d="M21.8 16v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16M3 13v-2h12v2H3m0-7h18v2H3V6m0 12v-2h6v2H3"/>'
        },
        "sort-variant-lock-open": {
            body: '<path fill="currentColor" d="M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-2.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5v.5h-1.3v-.5c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h4.3c.6 0 1.2.6 1.2 1.3M3 13v-2h12v2H3m0-7h18v2H3V6m0 12v-2h6v2H3"/>'
        },
        "sort-variant-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L11.11 13H3v-2h6.11l-3-3H3V6h1.11l-3-3l1.28-1.27l19.72 19.73l-1.27 1.27M15 11h-.8l.8.8V11m6-3V6H9.2l2 2H21M3 18h6v-2H3v2Z"/>'
        },
        "sort-variant-remove": {
            body: '<path fill="currentColor" d="M3 13h12v-2H3m0-5v2h18V6M3 18h6v-2H3v2m19.54-1.12L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.13l1.42 1.42"/>'
        },
        soundbar: {
            body: '<path fill="currentColor" d="M4 8c-1.1 0-2 .9-2 2v4a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2v-4a2 2 0 0 0-2-2M9 10a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4m6 0a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4M5 11c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m4 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m6 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m4 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        soundcloud: {
            body: '<path fill="currentColor" d="M11.56 8.87V17h8.76c1.85-.13 2.68-1.27 2.68-2.67c0-1.48-1.12-2.67-2.62-2.67c-.38 0-.7.08-1.03.22c-.24-2.34-2.23-4.17-4.68-4.17c-1.17 0-2.28.44-3.11 1.16m-.88 1.02c-.3-.18-.62-.32-.97-.39V17h1.39V9.34c-.15.16-.29.36-.42.55m-2.35-.54V17h.92V9.38c-.19-.03-.38-.04-.58-.04c-.12 0-.23 0-.34.01M6.5 10v7h.91V9.54c-.33.11-.64.27-.91.46m-1.67 2.5c-.06 0-.12-.06-.19-.09V17h.92v-6.14c-.37.48-.62 1.05-.73 1.64m-2.04-.28v4.69c.21.06.45.09.71.09h.22v-4.86c-.08-.01-.16-.02-.22-.02c-.26 0-.5.04-.71.1M1 14.56c0 .75.34 1.41.87 1.86v-3.71c-.53.44-.87 1.11-.87 1.85Z"/>'
        },
        "source-branch": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24C9.25 16.7 10 17.76 10 19a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M7 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m10 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "source-branch-check": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-.25 15.16l-2.75-3L15.16 17l1.59 1.59L20.34 15l1.16 1.41l-4.75 4.75"/>'
        },
        "source-branch-minus": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m-3 11v2h8v-2h-8Z"/>'
        },
        "source-branch-plus": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m0 8v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "source-branch-refresh": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m1 8c1.1 0 2.1.4 2.8 1.2L22 14v4h-4l1.8-1.8c-.5-.4-1.1-.7-1.8-.7c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5c.8 0 1.5-.4 2-1h1.7c-.6 1.5-2 2.5-3.7 2.5c-2.2 0-4-1.8-4-4s1.8-4 4-4Z"/>'
        },
        "source-branch-remove": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3.12 8.46L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12l-1.42-1.42Z"/>'
        },
        "source-branch-sync": {
            body: '<path fill="currentColor" d="M13 14c-3.36 0-4.46 1.35-4.82 2.24A3.002 3.002 0 0 1 7 22c-1.66 0-3-1.34-3-3c0-1.31.83-2.42 2-2.83V7.83A2.99 2.99 0 0 1 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.31-.83 2.42-2 2.83v5.29c.88-.65 2.16-1.12 4-1.12c2.67 0 3.56-1.34 3.85-2.23A3.006 3.006 0 0 1 14 7c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.34-.88 2.5-2.09 2.86C17.65 11.29 16.68 14 13 14m-6 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M7 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m10 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m1 7v1.5c2.21 0 4 1.79 4 4c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 18 16v1.5l-2.25-2.25l-.03-.03c.06-.05.13-.09 2.28-2.22m0 11v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 18 21v-1.5l2.25 2.25l.03.03c-.06.05-.13.09-2.28 2.22"/>'
        },
        "source-commit": {
            body: '<path fill="currentColor" d="M17 12a5 5 0 0 1-4 4.9V21h-2v-4.1a5 5 0 0 1 0-9.8V3h2v4.1a5 5 0 0 1 4 4.9m-5-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "source-commit-end": {
            body: '<path fill="currentColor" d="M17 12a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 4-4.9V3h2v4.1a5 5 0 0 1 4 4.9m-5-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "source-commit-end-local": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m-1-4V3h2v2h-2Z"/>'
        },
        "source-commit-local": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m-1-4V3h2v2h-2m0 16v-2h2v2h-2Z"/>'
        },
        "source-commit-next-local": {
            body: '<path fill="currentColor" d="M17 12a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 4-4.9V3h2v4.1a5 5 0 0 1 4 4.9m-5-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m-1 12v-2h2v2h-2Z"/>'
        },
        "source-commit-start": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-4 4.9V21h-2v-4.1A5 5 0 0 1 7 12a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/>'
        },
        "source-commit-start-next-local": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m-1 12v-2h2v2h-2Z"/>'
        },
        "source-fork": {
            body: '<path fill="currentColor" d="M6 2a3 3 0 0 1 3 3c0 1.28-.81 2.38-1.94 2.81c.09.46.33 1.02.94 1.82c1 1.29 3 3.2 4 4.54c1-1.34 3-3.25 4-4.54c.61-.8.85-1.36.94-1.82A3.015 3.015 0 0 1 15 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.32-.86 2.45-2.05 2.85c-.08.52-.31 1.15-.95 1.98c-1 1.34-3 3.25-4 4.55c-.61.79-.85 1.35-.94 1.81C14.19 16.62 15 17.72 15 19a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.28.81-2.38 1.94-2.81c-.09-.46-.33-1.02-.94-1.81c-1-1.3-3-3.21-4-4.55c-.64-.83-.87-1.46-.95-1.98A3.015 3.015 0 0 1 3 5a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m12 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-6 14a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "source-merge": {
            body: '<path fill="currentColor" d="M7 3a3 3 0 0 1 3 3c0 1.29-.81 2.39-1.96 2.81c.54 5 5.04 5.96 7.15 6.15A2.985 2.985 0 0 1 18 13a3 3 0 0 1 3 3a3 3 0 0 1-3 3c-1.31 0-2.43-.84-2.84-2c-4.25-.2-5.72-1.81-7.16-3.61v1.78c1.17.41 2 1.52 2 2.83a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V8.83A2.99 2.99 0 0 1 4 6a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 12a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m11-2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "source-pull": {
            body: '<path fill="currentColor" d="M6 3a3 3 0 0 1 3 3c0 1.31-.83 2.42-2 2.83v6.34c1.17.41 2 1.52 2 2.83a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V8.83A2.99 2.99 0 0 1 3 6a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 12a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m15 1a3 3 0 0 1-3 3a3 3 0 0 1-3-3c0-1.31.83-2.42 2-2.83V7h-2v3.25L10.75 6L15 1.75V5h2a2 2 0 0 1 2 2v8.17c1.17.41 2 1.52 2 2.83m-3-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "source-repository": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m6.75 11.5c2.75 0 3.49-2.03 3.68-3.1c.91-.29 1.57-1.14 1.57-2.15C18 7 17 6 15.75 6S13.5 7 13.5 8.25c0 .94.57 1.75 1.39 2.08C14.67 11 14 12 12 12c-1.38 0-2.34.35-3 .84V8.87c.87-.31 1.5-1.14 1.5-2.12c0-1.25-1-2.25-2.25-2.25S6 5.5 6 6.75c0 .98.63 1.81 1.5 2.12v6.26c-.87.31-1.5 1.14-1.5 2.12c0 1.25 1 2.25 2.25 2.25s2.25-1 2.25-2.25c0-.93-.56-1.75-1.37-2.07c.28-.68 1.1-1.68 3.62-1.68m-4.5 3a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75m0-10.5a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75m7.5 1.5a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75Z"/>'
        },
        "source-repository-multiple": {
            body: '<path fill="currentColor" d="M8 0h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.75 11.5c2.75 0 3.49-2.03 3.68-3.1c.91-.29 1.57-1.14 1.57-2.15C20 5 19 4 17.75 4S15.5 5 15.5 6.25c0 .94.57 1.75 1.39 2.08C16.67 9 16 10 14 10c-1.38 0-2.34.35-3 .84V6.87c.87-.31 1.5-1.14 1.5-2.12c0-1.25-1-2.25-2.25-2.25S8 3.5 8 4.75c0 .98.63 1.81 1.5 2.12v6.26c-.87.31-1.5 1.14-1.5 2.12c0 1.25 1 2.25 2.25 2.25s2.25-1 2.25-2.25c0-.93-.56-1.75-1.37-2.07c.28-.68 1.1-1.68 3.62-1.68m-4.5 3a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75m0-10.5a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75m7.5 1.5a.75.75 0 0 1 .75.75a.75.75 0 0 1-.75.75a.75.75 0 0 1-.75-.75a.75.75 0 0 1 .75-.75M16 22v2H4a2 2 0 0 1-2-2V6h2v16h12Z"/>'
        },
        "soy-sauce": {
            body: '<path fill="currentColor" d="M13.9 7.5c0-.7.2-1.2.3-1.5h.6l.9-2.5h.8V2h-9v1.5h.8L9.2 6h.6c.2.3.3.8.3 1.5c0 1.3-4.1 6.2-4.1 10.1v2c0 1.4 2.7 2.3 6 2.3s6-.9 6-2.3v-2c0-3.9-4.1-8.8-4.1-10.1M12 15a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2Z"/>'
        },
        "soy-sauce-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l7.5 7.5C7.5 12.6 6 15.3 6 17.6v2c0 1.4 2.7 2.3 6 2.3c3.1 0 5.7-.8 6-2l2.9 2.9l1.2-1.3M12 15c-1.1 0-2-.9-2-2c0-.3.1-.6.2-.9l2.7 2.7c-.3.1-.6.2-.9.2M8.3 3.5h-.8V2h9v1.5h-.8L14.8 6h-.6c-.1.3-.3.8-.3 1.5c0 .9 2 3.5 3.2 6.4l-7-7c-.1-.4-.2-.7-.3-.9h-.6l-.9-2.5Z"/>'
        },
        spa: {
            body: '<path fill="currentColor" d="M15.5 9.63c-.19-2.79-1.32-5.51-3.44-7.63A12.253 12.253 0 0 0 8.5 9.63c1.29.68 2.47 1.56 3.5 2.63a14.22 14.22 0 0 1 3.5-2.63M12 15.45C9.85 12.17 6.18 10 2 10c0 10 9.32 11.89 10 12c.68-.12 10-2 10-12c-4.18 0-7.85 2.17-10 5.45Z"/>'
        },
        "spa-outline": {
            body: '<path fill="currentColor" d="M15.5 9.63a14.22 14.22 0 0 0-3.5 2.63a13.74 13.74 0 0 0-3.5-2.63C8.74 6.86 9.92 4.14 12.06 2c2.12 2.12 3.25 4.84 3.44 7.63M12 15.45C14.15 12.17 17.82 10 22 10c0 10-9.32 11.88-10 12c-.68-.11-10-2-10-12c4.18 0 7.85 2.17 10 5.45m.05-10.26c-.66 1.04-1.12 2.19-1.37 3.39l1.32.97l1.35-.98c-.23-1.2-.67-2.35-1.3-3.38M12 19.97s6-.97 7.74-7.72C14 14 12 19.1 12 19.1S9 13 4.26 12.26C6 19 12 19.97 12 19.97Z"/>'
        },
        "space-invaders": {
            body: '<path fill="currentColor" d="M7 6H5V4h2v2m10 0h2V4h-2v2m6 6v6h-2v-4h-2v4h-2v-2H7v2H5v-4H3v4H1v-6h2v-2h2V8h2V6h2v2h6V6h2v2h2v2h2v2h2m-8-2v2h2v-2h-2m-8 2h2v-2H7v2m4 6H7v2h4v-2m6 0h-4v2h4v-2Z"/>'
        },
        "space-station": {
            body: '<path fill="currentColor" d="M15.5 19v2h-1.77c-.34.6-.99 1-1.73 1s-1.39-.4-1.73-1H8.5v-2h1.77c.17-.3.43-.56.73-.73V17h-1c-.55 0-1-.45-1-1v-3H6v4c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3h3V8c0-.55.45-1 1-1h1V6h-1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1v1h1c.55 0 1 .45 1 1v3h3V8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-4h-3v3c0 .55-.45 1-1 1h-1v1.27c.3.17.56.43.73.73h1.77M3 16v1h2v-1H3m0-2v1h2v-1H3m0-2v1h2v-1H3m0-2v1h2v-1H3m0-2v1h2V8H3m16 8v1h2v-1h-2m0-2v1h2v-1h-2m0-2v1h2v-1h-2m0-2v1h2v-1h-2m0-2v1h2V8h-2Z"/>'
        },
        spade: {
            body: '<path fill="currentColor" d="m15.71 1.22l-2.83 2.83c-.78.78-.78 2.04 0 2.82l1.42 1.42l-4.24 4.24l-2.48-2.47l-6.36 6.36l6.36 6.36l6.36-6.36l-2.47-2.48l4.24-4.24l1.42 1.42c.78.78 2.04.78 2.82 0l2.83-2.83l-7.07-7.07m0 2.83l4.24 4.24l-1.41 1.41l-4.24-4.24l1.41-1.41Z"/>'
        },
        speaker: {
            body: '<path fill="currentColor" d="M12 12a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m5-2H7c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"/>'
        },
        "speaker-bluetooth": {
            body: '<path fill="currentColor" d="M4 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4m4 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m11 2v3.79L16.71 8.5l-.71.71L18.79 12L16 14.79l.71.71L19 13.21V17h.5l2.85-2.86L20.21 12l2.14-2.15L19.5 7H19m1 1.91l.94.94l-.94.94V8.91M8 11a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m12 .21l.94.93l-.94.94v-1.87Z"/>'
        },
        "speaker-message": {
            body: '<path fill="currentColor" d="M16.5 3h5c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5H18l-3 3V4.5c0-.8.7-1.5 1.5-1.5M3 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H3m4 2c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 6c2.2 0 4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4m0 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"/>'
        },
        "speaker-multiple": {
            body: '<path fill="currentColor" d="M14 10a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m5-2H9a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M5 22h12v2H5a2 2 0 0 1-2-2V4h2"/>'
        },
        "speaker-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L21 21.72L19.73 23l-1.46-1.46c-.34.29-.77.46-1.27.46H7a2 2 0 0 1-2-2V8.27l-3-3M12 18a3 3 0 0 1-3-3c0-.76.28-1.46.75-2l-1.42-1.4C7.5 12.5 7 13.69 7 15a5 5 0 0 0 5 5c1.31 0 2.5-.5 3.4-1.33L14 17.25c-.55.47-1.24.75-2 .75m5-3a5 5 0 0 0-5-5h-.18l-6.7-6.7C5.41 2.54 6.14 2 7 2h10a2 2 0 0 1 2 2v13.18l-2-2.01V15M12 4c-1.11 0-2 .89-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "speaker-pause": {
            body: '<path fill="currentColor" d="M12.28 19.81c-.41.11-.83.19-1.28.19c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.89 0 3.5 1.06 4.37 2.61c.79-.38 1.69-.61 2.63-.61V4a2 2 0 0 0-2-2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.54c-.54-.63-1-1.37-1.26-2.19M11 4c1.11 0 2 .89 2 2s-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m2.74 9.78A5.994 5.994 0 0 0 12 17.81c-.31.12-.64.19-1 .19c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.22 0 2.27.73 2.74 1.78M19 15h2v6h-2m-4-6h2v6h-2v-6Z"/>'
        },
        "speaker-play": {
            body: '<path fill="currentColor" d="M16 15v6l5-3l-5-3m-3.72 4.81c-.41.11-.83.19-1.28.19c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.89 0 3.5 1.06 4.37 2.61c.79-.38 1.69-.61 2.63-.61V4a2 2 0 0 0-2-2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.54c-.54-.63-1-1.37-1.26-2.19M11 4c1.11 0 2 .89 2 2s-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m2.74 9.78A5.994 5.994 0 0 0 12 17.81c-.31.12-.64.19-1 .19c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.22 0 2.27.73 2.74 1.78Z"/>'
        },
        "speaker-stop": {
            body: '<path fill="currentColor" d="M12.28 19.81c-.41.11-.83.19-1.28.19c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.89 0 3.5 1.06 4.37 2.61c.79-.38 1.69-.61 2.63-.61V4a2 2 0 0 0-2-2H6c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h7.54c-.54-.63-1-1.37-1.26-2.19M11 4c1.11 0 2 .89 2 2s-.89 2-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m2.74 9.78A5.994 5.994 0 0 0 12 17.81c-.31.12-.64.19-1 .19c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.22 0 2.27.73 2.74 1.78M21 15h-6v6h6v-6Z"/>'
        },
        "speaker-wireless": {
            body: '<path fill="currentColor" d="m20.07 19.07l-1.41-1.41A7.955 7.955 0 0 0 21 12c0-2.22-.89-4.22-2.34-5.66l1.41-1.41A9.969 9.969 0 0 1 23 12c0 2.76-1.12 5.26-2.93 7.07m-2.83-2.83l-1.41-1.41A3.99 3.99 0 0 0 17 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41A5.98 5.98 0 0 1 19 12c0 1.65-.67 3.15-1.76 4.24M4 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m4 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 6a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        spear: {
            body: '<path fill="currentColor" d="M16 9h.41l-13 13L2 20.59l13-13V9h1m0-5v4h4l2-6l-6 2Z"/>'
        },
        speedometer: {
            body: '<path fill="currentColor" d="M12 16a3 3 0 0 1-3-3c0-1.12.61-2.1 1.5-2.61l9.71-5.62l-5.53 9.58c-.5.98-1.51 1.65-2.68 1.65m0-13c1.81 0 3.5.5 4.97 1.32l-2.1 1.21C14 5.19 13 5 12 5a8 8 0 0 0-8 8c0 2.21.89 4.21 2.34 5.65h.01c.39.39.39 1.02 0 1.41c-.39.39-1.03.39-1.42.01A9.969 9.969 0 0 1 2 13A10 10 0 0 1 12 3m10 10c0 2.76-1.12 5.26-2.93 7.07c-.39.38-1.02.38-1.41-.01a.996.996 0 0 1 0-1.41A7.95 7.95 0 0 0 20 13c0-1-.19-2-.54-2.9L20.67 8C21.5 9.5 22 11.18 22 13Z"/>'
        },
        "speedometer-medium": {
            body: '<path fill="currentColor" d="M12 1.38L9.14 12.06c-.34 1.04-.1 2.23.72 3.06a3.012 3.012 0 0 0 4.25 0c.79-.79 1.05-1.92.78-2.91m-.29-8.86l.62 2.33A7.99 7.99 0 0 1 20 13c0 2.21-.89 4.21-2.34 5.65h-.01a.996.996 0 0 0 0 1.41c.39.39 1.03.39 1.42.01A9.969 9.969 0 0 0 22 13c0-4.62-3.14-8.5-7.4-9.65m-5.2.01C5.15 4.5 2 8.4 2 13c0 2.76 1.12 5.26 2.93 7.07c.39.38 1.02.38 1.41-.01a.996.996 0 0 0 0-1.41A7.95 7.95 0 0 1 4 13c0-3.35 1.94-6.14 4.79-7.35"/>'
        },
        "speedometer-slow": {
            body: '<path fill="currentColor" d="M12 16c1.66 0 3-1.34 3-3c0-1.12-.61-2.1-1.5-2.61L3.79 4.77l5.53 9.58c.5.98 1.51 1.65 2.68 1.65m0-13c-1.81 0-3.5.5-4.97 1.32l2.1 1.21C10 5.19 11 5 12 5c4.42 0 8 3.58 8 8c0 2.21-.89 4.21-2.34 5.65h-.01a.996.996 0 0 0 0 1.41c.39.39 1.03.39 1.42.01A9.969 9.969 0 0 0 22 13c0-5.5-4.5-10-10-10M2 13c0 2.76 1.12 5.26 2.93 7.07c.39.38 1.02.38 1.41-.01a.996.996 0 0 0 0-1.41A7.95 7.95 0 0 1 4 13c0-1 .19-2 .54-2.9L3.33 8C2.5 9.5 2 11.18 2 13Z"/>'
        },
        spellcheck: {
            body: '<path fill="currentColor" d="m21.59 11.59l-8.09 8.09L9.83 16l-1.41 1.41l5.08 5.09L23 13M6.43 11L8.5 5.5l2.07 5.5m1.88 5h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3Z"/>'
        },
        sphere: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 12c-4.42 0-8-.89-8-2c0-1.1 3.58-2 8-2s8 .9 8 2c0 1.11-3.58 2-8 2m0-10c3.37 0 6.25 2.09 7.43 5.05C17.93 8.43 15.61 8 12 8c-2.2 0-5.27.19-7.43 1.05C5.75 6.09 8.63 4 12 4m0 16c-3.37 0-6.25-2.09-7.43-5.05C6.07 15.57 8.39 16 12 16c2.2 0 5.27-.19 7.43-1.05C18.25 17.91 15.37 20 12 20Z"/>'
        },
        "sphere-off": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l2.95 2.95A9.888 9.888 0 0 0 2 12c0 5.5 4.5 10 10 10c2.28 0 4.37-.77 6.05-2.06l2.79 2.79l1.27-1.27L2.39 1.73M5.5 7.39l1.08 1.08c-.71.15-1.4.33-2.01.58c.24-.6.56-1.15.93-1.66M4 12c0-.77 1.76-1.44 4.33-1.78L12.11 14H12c-4.42 0-8-.89-8-2m8 8c-3.37 0-6.25-2.09-7.43-5.05C6.07 15.57 8.39 16 12 16c.63 0 1.33 0 2.05-.06l2.58 2.56c-1.31.95-2.9 1.5-4.63 1.5M8.19 5L6.72 3.5C8.25 2.56 10.06 2 12 2c5.5 0 10 4.5 10 10c0 1.94-.56 3.75-1.5 5.28L19 15.81c.17-.27.31-.56.43-.85c-.3.12-.62.22-.96.31L16.8 13.6c1.94-.37 3.2-.95 3.2-1.6c0-1-2.94-1.83-6.77-1.97L11.21 8H12c3.61 0 5.93.43 7.43 1.05C18.25 6.09 15.37 4 12 4c-1.39 0-2.68.36-3.81 1Z"/>'
        },
        spider: {
            body: '<path fill="currentColor" d="m21.29 16.71l1.42-1.42l-3.21-3.18l-3-.85l1.91-.26l4.19-3.2l-1.2-1.6l-3.81 2.85l-2.68.45l3.2-3.19L17 1.76l-2 .48l.86 3.45l-1.1 1.14a3 3 0 0 0-5.52 0L8.11 5.69L9 2.24l-2-.48l-1.11 4.55l3.2 3.19l-2.69-.45L2.6 6.2L1.4 7.8L5.6 11l1.86.31l-3 .85l-3.17 3.13l1.42 1.42l2.79-2.82l2.37-.67L4 16.54V22h2v-4.54l1.56-1.34a4.5 4.5 0 0 0 8.88 0L18 17.46V22h2v-5.46l-3.87-3.32l2.37.67Z"/>'
        },
        "spider-thread": {
            body: '<path fill="currentColor" d="M13 2v5.08A5.47 5.47 0 0 0 12 7a5.47 5.47 0 0 0-1 .08V2m5.9 13a5 5 0 0 1-.17.55L20 17.42V22h-2v-3.42l-2.26-1.29a4.94 4.94 0 0 1-7.48 0L6 18.58V22H4v-4.58l3.27-1.87A5 5 0 0 1 7.1 15H5.3l-2.75 1.83l-1.1-1.66L4.7 13h2.4a5 5 0 0 1 .27-.88l-1.56-1l-3.57.88l-.48-2l4.43-1.08l2.31 1.53a5 5 0 0 1 7 0l2.27-1.53L22.24 10l-.48 2l-3.57-.89l-1.56 1a5 5 0 0 1 .27.89h2.4l3.25 2.16l-1.1 1.66L18.7 15M11 14a1 1 0 1 0-1 1a1 1 0 0 0 1-1m4 0a1 1 0 1 0-1 1a1 1 0 0 0 1-1Z"/>'
        },
        "spider-web": {
            body: '<path fill="currentColor" d="m13.62 13.28l1.64 2.26c.03-.54.12-1.07.3-1.61c.18-.56.44-1.07.74-1.52l-2.68.87M17.77 19c-.02-1.32.18-2.73.64-4.15c.47-1.43 1.15-2.71 1.95-3.76l-2.04.66c-.78.51-1.45 1.39-1.82 2.48c-.33 1.06-.32 2.13 0 2.99L17.77 19m1.48 2c-.5.46-1.04.86-1.62 1.2l-.32-.44C15.9 21 14.04 20.5 12 20.5c-2.04 0-3.9.5-5.31 1.26l-.32.44c-.58-.34-1.12-.74-1.62-1.2l.25-.31c.33-1.61.22-3.57-.42-5.55c-.64-1.95-1.68-3.58-2.87-4.68l-.44-.14c.15-.66.36-1.32.62-1.91l.4.13c1.63-.17 3.45-.89 5.14-2.11c1.66-1.21 2.89-2.7 3.57-4.17v-.47l1-.04l1 .04v.42c.67 1.5 1.91 3.02 3.6 4.24c1.66 1.21 3.46 1.92 5.07 2.11l.44-.15c.26.59.47 1.25.62 1.91l-.5.18c-1.19 1.08-2.23 2.71-2.86 4.66c-.63 1.93-.75 3.84-.45 5.41l.33.43M11 11.37V8.5c-.34.42-.74.82-1.22 1.17c-.49.33-1.01.62-1.53.83l2.75.87m0-7.15c-.75 1.09-1.76 2.13-3 3.02c-1.22.9-2.54 1.54-3.82 1.92l1.97.64c.96.08 2.07-.24 3.04-.94c.94-.68 1.57-1.59 1.81-2.5V4.22m2 7.15l2.74-.87c-.51-.2-1.02-.47-1.49-.81c-.49-.36-.91-.77-1.25-1.19v2.87m6.8-2.21c-1.27-.38-2.57-1.01-3.8-1.9c-1.23-.9-2.24-1.95-3-3.06v2.07c.22.94.86 1.9 1.84 2.61c.93.68 1.99.99 2.93.94l2.03-.66m-9.42 4.12l-2.74-.89c.31.45.56.96.74 1.52c.19.59.28 1.15.3 1.71l1.7-2.34m-6.8-2.21c.8 1.05 1.48 2.33 1.95 3.76c.47 1.46.67 2.91.64 4.25l1.21-1.67c.38-.91.42-2.05.05-3.19c-.36-1.1-1.03-1.98-1.82-2.49l-2.03-.66M12 14.45l-1.65 2.27a6.321 6.321 0 0 1 3.3 0L12 14.45m-4.16 5.73c1.24-.43 2.66-.68 4.16-.68s2.92.25 4.16.68l-1.28-1.76c-.72-.57-1.75-.92-2.88-.92s-2.16.35-2.88.92l-1.28 1.76Z"/>'
        },
        "spirit-level": {
            body: '<path fill="currentColor" d="M22 8H2v8h20V8m-4 6v-4h2v4h-2m-7-2h2a2 2 0 0 0 2-2h2v4H7v-4h2a2 2 0 0 0 2 2m-7 2v-4h2v4H4Z"/>'
        },
        "split-horizontal": {
            body: '<path d="M3 5.016h18v1.968H3V5.016zm0 6V9h18v2.016H3zm0 7.968v-6h18v6H3z" fill="currentColor"/>',
            hidden: true
        },
        "split-vertical": {
            body: '<path d="M12.984 5.016H21v13.968h-8.016V5.016zM3 5.016h8.016v1.968H3V5.016zm0 6V9h8.016v2.016H3zm0 7.968v-1.968h8.016v1.968H3zM3 15v-2.016h8.016V15H3z" fill="currentColor"/>',
            hidden: true
        },
        "spoon-sugar": {
            body: '<path fill="currentColor" d="M6 13H3v-3h3v3m4-3H7v3h3v-3M8 6H5v3h3V6m10 6c-3.75 0-5.72 1.25-7 2H2c0 2.21 1.79 4 4 4h1c1 0 1.92-.37 2.62-1c1.44-1.22 3.06-2.26 4.93-2.64c1.06-.21 2.23-.36 3.45-.36h4v-2h-4Z"/>'
        },
        spotify: {
            body: '<path fill="currentColor" d="M17.9 10.9C14.7 9 9.35 8.8 6.3 9.75c-.5.15-1-.15-1.15-.6c-.15-.5.15-1 .6-1.15c3.55-1.05 9.4-.85 13.1 1.35c.45.25.6.85.35 1.3c-.25.35-.85.5-1.3.25m-.1 2.8c-.25.35-.7.5-1.05.25c-2.7-1.65-6.8-2.15-9.95-1.15c-.4.1-.85-.1-.95-.5c-.1-.4.1-.85.5-.95c3.65-1.1 8.15-.55 11.25 1.35c.3.15.45.65.2 1m-1.2 2.75c-.2.3-.55.4-.85.2c-2.35-1.45-5.3-1.75-8.8-.95c-.35.1-.65-.15-.75-.45c-.1-.35.15-.65.45-.75c3.8-.85 7.1-.5 9.7 1.1c.35.15.4.55.25.85M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        spotlight: {
            body: '<path fill="currentColor" d="m2 6l5.09 2.55C6.4 9.5 6 10.71 6 12s.4 2.5 1.09 3.45L2 18V6m4-3h12l-2.55 4.09C14.5 6.4 13.29 6 12 6s-2.5.4-3.45 1.09L6 3m16 3v12l-5.09-2.55C17.6 14.5 18 13.29 18 12s-.4-2.5-1.09-3.45L22 6m-4 15H6l2.55-4.09C9.5 17.6 10.71 18 12 18s2.5-.4 3.45-1.09L18 21M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "spotlight-beam": {
            body: '<path fill="currentColor" d="m9 16.5l.91-.91l5.22 5.21l-.92.91L9 16.5m6.5-6.5l.91-.91l5.22 5.21l-.92.91L15.5 10M6.72 2.72l3.43 3.43l-4 4l-3.43-3.43c-.78-.78-.78-2.05 0-2.83l1.17-1.17c.78-.78 2.05-.78 2.83 0m7.85 4.78l.71.71l-7.07 7.07l-.71-.71l-.86-3.5l4.43-4.43l3.5.86Z"/>'
        },
        spray: {
            body: '<path fill="currentColor" d="M10 4h2v2h-2V4M7 3h2v2H7V3m0 3h2v2H7V6M6 8v2H4V8h2m0-3v2H4V5h2m0-3v2H4V2h2m7 20a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2V7h1V4h3v3h1v1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5m0-12v10h5V10h-5Z"/>'
        },
        "spray-bottle": {
            body: '<path fill="currentColor" d="M16.72 10.43C14.68 8.39 14.5 4.66 14.5 4H13v2H9V4H7c0-1.1.9-2 2-2h7v1c0 .08.04 4.63 1.78 6.37l-1.06 1.06M17 2v2h1V2h-1m-2 10c-2-2-2-5-2-5H9v2c0 1 0 1-1 2s-1 2-1 2v7c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-8Z"/>'
        },
        spreadsheet: {
            body: '<path d="M19 3H5c-1.104 0-1.99.896-1.99 2l-.008 3H3v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 8h-8v8H9v-8H5V9h4V5h2v4h8v2z" fill="currentColor"/>',
            hidden: true
        },
        sprinkler: {
            body: '<path fill="currentColor" d="M11 7h2v2h-2V7M5 22h4V10H5v12m9-11h2V9h-2v2m3-1h2V8h-2v2m0-5v2h2V5h-2m-3 3h2V6h-2v2m3 5h2v-2h-2v2M5 7h.33L6 9h2l.67-2H9V6H5v1Z"/>'
        },
        "sprinkler-fire": {
            body: '<path fill="currentColor" d="M5 21v2h2v-2H5m6 0H9v2h2v-2m-4-3v2h2v-2H7m4-3v2H9v-2h2m4 6h-2v2h2v-2m-4-3v2h2v-2h-2m4-3v2h-2v-2h2m4 6h-2v2h2v-2m-4-3v2h2v-2h-2m1-7v2H8v-2h3V5h2v6h3m5-10v2h-3v3l-4 4V7.2l2-2V3H8v2.2l2 2V10L6 6V3H3V1h18Z"/>'
        },
        "sprinkler-variant": {
            body: '<path fill="currentColor" d="M10 10h4v12h-4V10M7 9h2V7H7v2M4 8h2V6H4v2m0 3h2V9H4v2m-3 2h2v-2H1v2m0-6h2V5H1v2m0 3h2V8H1v2m17 1h2V9h-2v2m3-1h2V8h-2v2m0-5v2h2V5h-2m0 8h2v-2h-2v2m-6-4h2V7h-2v2m3-1h2V6h-2v2m-8-1h.33L11 9h2l.67-2H14V6h-4v1Z"/>'
        },
        sprout: {
            body: '<path fill="currentColor" d="M2 22v-2s5-2 10-2s10 2 10 2v2H2m9.3-12.9c-1.2-3.9-7.3-3-7.3-3s.2 7.8 5.9 6.6C9.5 9.8 8 9 8 9c2.8 0 3 3.4 3 3.4V17h2v-4.2s0-3.9 3-4.9c0 0-2 3-2 5c7 .7 7-8.9 7-8.9s-8.9-1-9.7 5.1Z"/>'
        },
        "sprout-outline": {
            body: '<path fill="currentColor" d="M23 4.1V2.3l-1.8-.2c-.1 0-.7-.1-1.7-.1c-4.1 0-7.1 1.2-8.8 3.3C9.4 4.5 7.6 4 5.5 4c-1 0-1.7.1-1.7.1l-1.9.3l.1 1.7c.1 3 1.6 8.7 6.8 8.7H9v3.4c-3.8.5-7 1.8-7 1.8v2h20v-2s-3.2-1.3-7-1.8V15c6.3-.1 8-7.2 8-10.9M12 18h-1v-5.6S10.8 9 8 9c0 0 1.5.8 1.9 3.7c-.4.1-.8.1-1.1.1C4.2 12.8 4 6.1 4 6.1S4.6 6 5.5 6c1.9 0 5 .4 5.9 3.1C11.9 4.6 17 4 19.5 4c.9 0 1.5.1 1.5.1s0 9-6.3 9H14c0-2 2-5 2-5c-3 1-3 4.9-3 4.9v5h-1Z"/>'
        },
        square: {
            body: '<path fill="currentColor" d="M3 3v18h18V3"/>'
        },
        "square-circle": {
            body: '<path fill="currentColor" d="M20 4v16H4V4h16m2-2H2v20h20V2M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6Z"/>'
        },
        "square-edit-outline": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7H5V5h7V3H5m12.78 1a.69.69 0 0 0-.48.2l-1.22 1.21l2.5 2.5L19.8 6.7c.26-.26.26-.7 0-.95L18.25 4.2c-.13-.13-.3-.2-.47-.2m-2.41 2.12L8 13.5V16h2.5l7.37-7.38l-2.5-2.5Z"/>'
        },
        "square-inc": {
            body: '<path d="M6 3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3m1 3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7m2.5 3h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5z" fill="currentColor"/>',
            hidden: true
        },
        "square-inc-cash": {
            body: '<path d="M5.5 0h13A5.5 5.5 0 0 1 24 5.5v13a5.5 5.5 0 0 1-5.5 5.5h-13A5.5 5.5 0 0 1 0 18.5v-13A5.5 5.5 0 0 1 5.5 0m9.89 15.18c0 1.58-.89 2.63-2.54 2.77v-5.34c1.7.52 2.54 1.05 2.54 2.57M11.65 6v4.88c-1.31-.38-2.62-.95-2.62-2.45c0-1.49 1.15-2.31 2.62-2.43m3.85 1.6l1-.8c-.88-1.14-2.1-1.88-3.65-2.03V3.8h-1.2v.95C9.5 4.89 7.68 6.17 7.68 8.5c0 2.5 2.06 3.28 3.97 3.79v5.67c-1.11-.12-2.36-.65-3.22-1.93l-1.13.75c.9 1.34 2.46 2.22 4.35 2.36v1.06h1.2v-1.04c2.5-.16 3.85-1.82 3.85-4.02c0-2.56-1.89-3.38-3.85-3.95V6.05c1.15.17 2 .71 2.65 1.55z" fill="currentColor"/>',
            hidden: true
        },
        "square-medium": {
            body: '<path fill="currentColor" d="M16 8H8v8h8V8Z"/>'
        },
        "square-medium-outline": {
            body: '<path fill="currentColor" d="M14 10v4h-4v-4h4m2-2H8v8h8V8Z"/>'
        },
        "square-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L19.11 21H3V4.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M21 3H6.2L21 17.8V3Z"/>'
        },
        "square-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L3 4.89V21h16.11l1.73 1.73l1.27-1.27M5 19V6.89L17.11 19H5M8.2 5l-2-2H21v14.8l-2-2V5H8.2Z"/>'
        },
        "square-opacity": {
            body: '<path fill="currentColor" d="M19 13v-2h2v2h-2m2-4V7h-2v2h2m0-6h-2v2h2V3m-4 12h2v-2h-2v2m4 2v-2h-2v2h2m-8 0v-2h2v-2h-2v-2h2V9h-2V7h2V5h-2V3H3v18h10v-2h2v-2h-2m2 4h2v-2h-2v2m2-18h-2v2h2V3m0 8h2V9h-2v2m-2 6h2v-2h-2v2m2 2h2v-2h-2v2m4 2v-2h-2v2h2M15 9h2V7h-2v2m0 4h2v-2h-2v2m2-8v2h2V5h-2Z"/>'
        },
        "square-outline": {
            body: '<path fill="currentColor" d="M3 3h18v18H3V3m2 2v14h14V5H5Z"/>'
        },
        "square-root": {
            body: '<path fill="currentColor" d="M11.76 16.83L14.59 14l-2.83-2.83l1.41-1.41L16 12.59l2.83-2.83l1.41 1.41L17.41 14l2.83 2.83l-1.41 1.41L16 15.41l-2.83 2.83l-1.41-1.41M2 11h3l2.29 5.4L10 6h12v2H11.55L8.68 19H6.22l-2.54-6H2v-2Z"/>'
        },
        "square-root-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m6.24 3H19v2h-6.24L10 18H8l-1.75-6H5v-2h2.75L9 14.28L11.24 6M14 10.59l1.79 1.79l1.8-1.79L19 12l-1.79 1.79l1.79 1.8L17.59 17l-1.8-1.79L14 17l-1.41-1.41l1.79-1.8L12.59 12L14 10.59Z"/>'
        },
        "square-rounded": {
            body: '<path fill="currentColor" d="M8 3h8c2.76 0 5 2.24 5 5v8c0 2.76-2.24 5-5 5H8c-2.76 0-5-2.24-5-5V8c0-2.76 2.24-5 5-5Z"/>'
        },
        "square-rounded-badge": {
            body: '<path fill="currentColor" d="M19.5 8C21.43 8 23 6.43 23 4.5S21.43 1 19.5 1S16 2.57 16 4.5S17.57 8 19.5 8m0 2c.5 0 1-.07 1.5-.21V16c0 2.76-2.24 5-5 5H8c-2.76 0-5-2.24-5-5V8c0-2.76 2.24-5 5-5h6.21a5.497 5.497 0 0 0 5.29 7Z"/>'
        },
        "square-rounded-badge-outline": {
            body: '<path fill="currentColor" d="M19.5 8C21.43 8 23 6.43 23 4.5S21.43 1 19.5 1S16 2.57 16 4.5S17.57 8 19.5 8m1.5 8V9.79c-.5.14-1 .21-1.5.21H19v6c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3V8c0-1.66 1.34-3 3-3h6v-.5c0-.5.07-1 .21-1.5H8C5.24 3 3 5.24 3 8v8c0 2.76 2.24 5 5 5h8c2.76 0 5-2.24 5-5Z"/>'
        },
        "square-rounded-outline": {
            body: '<path fill="currentColor" d="M8 3h8c2.76 0 5 2.24 5 5v8c0 2.76-2.24 5-5 5H8c-2.76 0-5-2.24-5-5V8c0-2.76 2.24-5 5-5m0 2C6.34 5 5 6.34 5 8v8c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3H8Z"/>'
        },
        "square-small": {
            body: '<path fill="currentColor" d="M10 14v-4h4v4h-4Z"/>'
        },
        "square-wave": {
            body: '<path fill="currentColor" d="M2 2v10h2V4h7v18h11V12h-2v8h-7V2H2Z"/>'
        },
        squeegee: {
            body: '<path fill="currentColor" d="M22 2v3H2V2h20M2 8h5l2 2h1v10a2 2 0 0 0 2 2a2 2 0 0 0 2-2V10h1l2-2h5V6H2v2Z"/>'
        },
        ssh: {
            body: '<path fill="currentColor" d="M4.5 9c-.6 0-1 .5-1 1v1.75c0 .5.4 1 1 1H7v.75H3.5V15h4c.6 0 1-.5 1-1v-1.75c0-.5-.4-1-1-1H5v-.75h3.5V9h-4m6 0c-.6 0-1 .5-1 1v1.75c0 .5.4 1 1 1H13v.75H9.5V15h4c.6 0 1-.5 1-1v-1.75c0-.5-.4-1-1-1H11v-.75h3.5V9h-4m5 0v6H17v-2.5h2V15h1.5V9H19v2h-2V9h-1.5Z"/>'
        },
        "stack-exchange": {
            body: '<path fill="currentColor" d="M3.9 10.72H20v3.31H3.9v-3.31m0-4.28H20v3.31H3.9V6.44M17.5 2h-11C5.06 2 3.9 3.18 3.9 4.65v.85H20v-.85C20 3.18 18.88 2 17.5 2M3.9 15v.84c0 1.47 1.16 2.66 2.6 2.66h6.87V22l3.4-3.5h.73c1.44 0 2.61-1.19 2.61-2.66V15H3.9Z"/>'
        },
        "stack-overflow": {
            body: '<path fill="currentColor" d="M17.36 20.2v-5.38h1.79V22H3v-7.18h1.8v5.38h12.56M6.77 14.32l.37-1.76l8.79 1.85l-.37 1.76l-8.79-1.85m1.16-4.21l.76-1.61l8.14 3.78l-.76 1.62l-8.14-3.79m2.26-3.99l1.15-1.38l6.9 5.76l-1.15 1.37l-6.9-5.75m4.45-4.25L20 9.08l-1.44 1.07l-5.36-7.21l1.44-1.07M6.59 18.41v-1.8h8.98v1.8H6.59Z"/>'
        },
        stackpath: {
            body: '<path fill="currentColor" d="M4.91 8c-.87 0-1.59.2-2.15.61c-.57.39-.85.92-.85 1.58s.24 1.18.71 1.53c.48.35 1.2.69 2.18 1c.47.16.8.32.98.47c.18.15.27.36.27.64c0 .24-.09.43-.27.58c-.18.15-.46.22-.84.22c-.49 0-.85-.09-1.09-.28c-.25-.19-.35-.51-.35-.96H1.72l-.01.03c-.01.83.29 1.47.95 1.91c.64.45 1.4.67 2.28.67c.88 0 1.56-.2 2.12-.58c.53-.39.8-.92.8-1.61c0-.67-.23-1.2-.67-1.58c-.45-.39-1.11-.73-1.99-.97c-.58-.21-.97-.38-1.2-.52c-.19-.14-.29-.32-.29-.54c0-.24.1-.44.29-.6c.22-.16.5-.24.87-.24s.66.1.87.29c.22.19.33.47.32.76H7.8l.02-.04c.02-.69-.25-1.26-.82-1.71C6.47 8.22 5.77 8 4.91 8M9 8.05v7.88h1.84v-2.7h1.12c.93 0 1.67-.23 2.22-.73c.55-.45.82-1.08.82-1.86c0-.77-.27-1.39-.82-1.87c-.55-.48-1.29-.72-2.22-.72H9m8.24 0l-2.74 7.88h1.72L19 8.05m1.5 0l-2.71 7.88h1.71l2.79-7.88M10.84 9.46h1.12c.39 0 .7.11.9.34c.21.2.31.51.31.85c0 .35-.1.63-.31.85c-.2.21-.51.32-.9.32h-1.12"/>'
        },
        stadium: {
            body: '<path fill="currentColor" d="M7 5L3 7V3l4 2m11-2v4l4-2l-4-2m-7-1v4l4-2l-4-2m-6 8c1.4.5 3.8 1 7 1s5.6-.5 7-1c0-.2-2.8-1-7-1s-7 .9-7 1m10 7H9v4.9c-4.1-.4-7-1.5-7-2.9v-9c0-1.7 4.5-3 10-3s10 1.3 10 3v9c0 1.3-2.9 2.5-7 2.9V17Z"/>'
        },
        "stadium-outline": {
            body: '<path fill="currentColor" d="M7 5L3 7V3l4 2m11-2v4l4-2l-4-2m-7-1v4l4-2l-4-2m2 16h-2v4c-5.1-.1-9-1.4-9-3v-9c0-1.7 4.5-3 10-3s10 1.3 10 3v9c0 1.6-4 2.9-9 3v-4m-8-8c1.4.5 3.8 1 7 1s5.6-.5 7-1c0-.2-2.8-1-7-1s-7 .9-7 1m15 1.8c-1.8.7-4.7 1.2-8 1.2s-6.2-.5-8-1.2v6.8c.6.4 2.4 1 5 1.3V16h6v3.9c2.6-.3 4.4-.9 5-1.3v-6.8Z"/>'
        },
        "stadium-variant": {
            body: '<path fill="currentColor" d="M5 3h2l3 2l-3 2v1.33C8.47 8.12 10.18 8 12 8c1.82 0 3.53.12 5 .33V3h2l3 2l-3 2v1.71c1.85.46 3 1.09 3 1.79c0 1.38-4.5 2.5-10 2.5S2 11.88 2 10.5c0-.7 1.15-1.33 3-1.79V3m7 6.5c-3.31 0-5 .17-5 1s1.69 1 5 1s5-.17 5-1s-1.69-1-5-1m0 5.25c3.81 0 7.2-.67 9.4-1.7L20 21h-5v-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2H4l-1.4-7.95c2.2 1.03 5.59 1.7 9.4 1.7Z"/>'
        },
        "stats-query": {
            body: '<path fill="currentColor" d="M19.88 18.47C20.32 17.77 20.58 16.96 20.58 16.08C20.58 13.59 18.57 11.58 16.08 11.58C13.59 11.58 11.58 13.59 11.58 16.08C11.58 18.57 13.59 20.58 16.07 20.58C16.95 20.58 17.77 20.32 18.46 19.88L21.58 23L23 21.58L19.88 18.47ZM16.08 18.58C14.7 18.58 13.58 17.46 13.58 16.08C13.58 14.7 14.7 13.58 16.08 13.58C17.46 13.58 18.58 14.7 18.58 16.08C18.58 17.46 17.46 18.58 16.08 18.58ZM15.72 10.08C14.98 10.1 14.27 10.26 13.62 10.53L13.07 9.7L9.27 15.88L6.26 12.36L2.63 18.17L1 17L6 9L9 12.5L13 6L15.72 10.08ZM18.31 10.58C17.67 10.3 16.98 10.13 16.26 10.09L21.38 2L23 3.18L18.31 10.58Z"/>'
        },
        stairs: {
            body: '<path fill="currentColor" d="M15 5v4h-4v4H7v4H3v3h7v-4h4v-4h4V8h4V5h-7Z"/>'
        },
        "stairs-box": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m9 4h5v2h-3v3h-3v3h-3v3H5v-2h3v-3h3v-3h3V7Z"/>'
        },
        "stairs-down": {
            body: '<path fill="currentColor" d="M15 6h7v3h-4v4h-4v4h-4v4H3v-3h4v-4h4v-4h4V6M4.83 8.34l5.51-5.51l1.83 1.83l-5.51 5.51L8.5 12H3V6.5l1.83 1.84Z"/>'
        },
        "stairs-up": {
            body: '<path fill="currentColor" d="M15 6h7v3h-4v4h-4v4h-4v4H3v-3h4v-4h4v-4h4V6m-4.83.66l-5.51 5.51l-1.83-1.83l5.51-5.51L6.5 3H12v5.5l-1.83-1.84Z"/>'
        },
        stamper: {
            body: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3c0 3 5 7-3 7a2 2 0 0 0-2 2v2h16v-2a2 2 0 0 0-2-2c-8 0-3-4-3-7c0-2-1.34-3-3-3M6 19v2h12v-2H6Z"/>'
        },
        "standard-definition": {
            body: '<path fill="currentColor" d="M13 7h3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-3V7m3 8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1v6h1M7 7h4v2H7v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5v-2h4v-2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"/>'
        },
        star: {
            body: '<path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21L12 17.27Z"/>'
        },
        "star-box": {
            body: '<path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-3.42 14l-.95-4.08l3.16-2.73l-4.17-.36L12 6l-1.62 3.84l-4.17.36l3.16 2.73L8.42 17L12 14.84L15.58 17Z"/>'
        },
        "star-box-multiple": {
            body: '<path fill="currentColor" d="M4 6v14h14v2H3c-.6 0-1-.4-1-1V6h2m4-4h12a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2H8a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m8.3 11.3l-.4-2.6l1.9-1.9l-2.6-.4L14 6l-1.2 2.4l-2.6.4l1.9 1.8l-.5 2.6L14 12l2.3 1.3Z"/>'
        },
        "star-box-multiple-outline": {
            body: '<path fill="currentColor" d="M4 6v14h14v2H3c-.6 0-1-.4-1-1V6h2m8.1 4.6l-1.9-1.8l2.6-.4L14 6l1.2 2.4l2.6.4l-1.9 1.9l.4 2.6L14 12l-2.4 1.2l.5-2.6M8 2h12a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2H8a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 2v12h12V4H8Z"/>'
        },
        "star-box-outline": {
            body: '<path fill="currentColor" d="M15.58 17L12 14.84L8.42 17l.95-4.07l-3.16-2.73l4.17-.36L12 6l1.62 3.83l4.17.36l-3.16 2.73l.95 4.08M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M5 5v14h14V5H5Z"/>'
        },
        "star-check": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-3.1 0-5.6 2.3-6 5.3L5.8 21m12 .2l4.8-4.8l-1.3-1.4l-3.6 3.6l-1.5-1.6l-1.2 1.2l2.8 3"/>'
        },
        "star-check-outline": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-.7 0-1.4.1-2.1.4l2.2-1.9l-4.4-.4l-1.7-4l-1.7 4l-4.4.4l3.3 2.9l-1 4.3l3.8-2.3l.5.3c-.2.5-.4 1.1-.4 1.6L5.8 21m12 .2l-2.8-3l1.2-1.2l1.6 1.6l3.6-3.6l1.2 1.4l-4.8 4.8"/>'
        },
        "star-circle": {
            body: '<path fill="currentColor" d="M16.23 18L12 15.45L7.77 18l1.12-4.81l-3.73-3.23l4.92-.42L12 5l1.92 4.53l4.92.42l-3.73 3.23L16.23 18M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "star-circle-outline": {
            body: '<path fill="currentColor" d="m8.58 17.25l.92-3.89l-3-2.58l3.95-.37L12 6.8l1.55 3.65l3.95.33l-3 2.58l.92 3.89L12 15.19l-3.42 2.06M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8Z"/>'
        },
        "star-cog": {
            body: '<path fill="currentColor" d="M18.8 12c-3.21.1-5.89 2.37-6.61 5.39l-.19-.12L5.82 21l1.63-7.03L2 9.24l7.19-.62L12 2l2.81 6.62l7.19.62L18.8 12m5.03 8.64l-1 1.73c-.07.13-.2.13-.33.13l-1.23-.5c-.27.18-.54.34-.84.47l-.19 1.32c-.02.12-.13.21-.24.21h-2c-.14 0-.24-.09-.26-.21l-.19-1.32c-.31-.12-.59-.29-.85-.47l-1.24.5c-.12 0-.25 0-.31-.13l-1-1.73a.26.26 0 0 1 .06-.32l1.06-.82a4.193 4.193 0 0 1 0-1l-1.06-.82a.248.248 0 0 1-.06-.32l1-1.73c.07-.13.2-.13.31-.13l1.24.5c.26-.18.55-.34.85-.47l.19-1.32A.26.26 0 0 1 18 14h2c.11 0 .22.09.23.21l.19 1.32c.31.12.58.29.85.47l1.23-.5c.13 0 .26 0 .32.13l1 1.73c.06.11.03.24-.06.32l-1.06.82c.03.17.04.33.04.5s-.02.33-.04.5l1.07.82c.09.08.12.21.06.32M20.5 19c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.66 1.5 1.5 1.5c.83 0 1.5-.67 1.5-1.5Z"/>'
        },
        "star-cog-outline": {
            body: '<path fill="currentColor" d="m10.29 10.13l-4.38.37l3.32 2.88l-.99 4.28L12 15.39l.76.46c-.26.48-.44 1-.57 1.54l-.19-.12L5.82 21l1.63-7.03L2 9.24l7.19-.61L12 2l2.81 6.63l7.19.61L18.8 12a6.98 6.98 0 0 0-4.02 1.43l-.01-.05l3.32-2.88l-4.38-.37L12 6.09l-1.71 4.04m13.54 10.51l-1 1.73c-.07.13-.2.13-.33.13l-1.23-.5c-.27.18-.54.34-.84.47l-.19 1.32c-.02.12-.13.21-.24.21h-2c-.14 0-.24-.09-.26-.21l-.19-1.32c-.31-.12-.59-.29-.85-.47l-1.24.5c-.12 0-.25 0-.31-.13l-1-1.73a.26.26 0 0 1 .06-.32l1.06-.82a4.193 4.193 0 0 1 0-1l-1.06-.82a.248.248 0 0 1-.06-.32l1-1.73c.07-.13.2-.13.31-.13l1.24.5c.26-.18.55-.34.85-.47l.19-1.32A.26.26 0 0 1 18 14h2c.11 0 .22.09.23.21l.19 1.32c.31.12.58.29.85.47l1.23-.5c.13 0 .26 0 .32.13l1 1.73c.06.11.03.24-.06.32l-1.06.82c.03.17.04.33.04.5s-.02.33-.04.5l1.07.82c.09.08.12.21.06.32M20.5 19c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.66 1.5 1.5 1.5c.83 0 1.5-.67 1.5-1.5Z"/>'
        },
        "star-crescent": {
            body: '<path fill="currentColor" d="M12.3 2H12A10 10 0 0 0 2 12a10 10 0 0 0 10 10c3 0 4.7-1 6.5-2.5C13 21 8 17 8 12s5-9 10.5-7.5A8.56 8.56 0 0 0 12.3 2m4.5 4.2l-1.5 3.5l-3.7.3l2.9 2.5l-.9 3.5l3.2-2l3.2 2l-1-3.5l3-2.5l-3.7-.3l-1.5-3.5Z"/>'
        },
        "star-david": {
            body: '<path fill="currentColor" d="M12 2L9.1 7H3.3l3 5l-3 5h5.8l2.9 5l2.9-5h5.8l-3-5l3-5h-5.8L12 2m0 3l1.2 2h-2.4L12 5M8.2 8.5l-1.1 2l-1.2-2h2.3m1.8 0h4l2 3.5l-2 3.5h-4L8 12l2-3.5m8 0l-1.2 2l-1.1-2H18m-10.9 5l1.1 2H6l1.1-2m9.8 0l1.2 2h-2.3l1.1-2M13.3 17L12 19l-1.2-2h2.5Z"/>'
        },
        "star-face": {
            body: '<path fill="currentColor" d="M12 2.5L8.42 8.06L2 9.74l4.2 5.14l-.38 6.62L12 19.09l6.18 2.41l-.38-6.62L22 9.74l-6.42-1.68L12 2.5m-2.62 8c.62 0 1.12.5 1.12 1.13a1.12 1.12 0 0 1-1.12 1.12c-.63 0-1.13-.5-1.13-1.12c0-.63.5-1.13 1.13-1.13m5.25 0c.62 0 1.12.5 1.12 1.13a1.12 1.12 0 0 1-1.12 1.12c-.63 0-1.13-.5-1.13-1.12c0-.63.5-1.13 1.13-1.13M9 15h6a3.249 3.249 0 0 1-6 0Z"/>'
        },
        "star-four-points": {
            body: '<path fill="currentColor" d="M12 1L9 9l-8 3l8 3l3 8l3-8l8-3l-8-3l-3-8Z"/>'
        },
        "star-four-points-outline": {
            body: '<path fill="currentColor" d="m12 6.7l1.45 3.85L17.3 12l-3.85 1.45L12 17.3l-1.45-3.85L6.7 12l3.85-1.45L12 6.7M12 1L9 9l-8 3l8 3l3 8l3-8l8-3l-8-3l-3-8Z"/>'
        },
        "star-half": {
            body: '<path fill="currentColor" d="M12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21L12 17.27V2Z"/>'
        },
        "star-half-full": {
            body: '<path fill="currentColor" d="M12 15.4V6.1l1.71 4.03l4.38.37l-3.32 2.89l.99 4.28M22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.45 4.73L5.82 21L12 17.27L18.18 21l-1.64-7.03L22 9.24Z"/>'
        },
        "star-minus": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-3.1 0-5.6 2.3-6 5.3L5.8 21m8.2-4v2h8v-2h-8Z"/>'
        },
        "star-minus-outline": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-.7 0-1.4.1-2.1.4l2.2-1.9l-4.4-.4l-1.7-4l-1.7 4l-4.4.4l3.3 2.9l-1 4.3l3.8-2.3l.5.3c-.2.5-.4 1.1-.4 1.6L5.8 21m8.2-4v2h8v-2h-8Z"/>'
        },
        "star-off": {
            body: '<path fill="currentColor" d="m20.8 22.7l-2.9-2.9l.3 1.2l-6.2-3.7L5.8 21l1.6-7L2 9.2l4.9-.4L1.1 3l1.3-1.3l19.7 19.7l-1.3 1.3M22 9.2l-7.2-.6L12 2l-2 4.8l6.9 6.9L22 9.2Z"/>'
        },
        "star-off-outline": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l5.8 5.8l-4.9.4L7.5 14l-1.6 7l6.2-3.7l6.2 3.7l-.3-1.2l2.9 2.9l1.2-1.2m-6.3-3.8L12 15.4l-3.8 2.3l1-4.3l-3.3-2.9l2.5-.2l7.4 7.4M11.2 8L10 6.8L12 2l2.8 6.6l7.2.6l-5.1 4.4l-1.1-1.1l2.4-2l-4.4-.4l-1.7-4l-.9 1.9Z"/>'
        },
        "star-outline": {
            body: '<path fill="currentColor" d="m12 15.39l-3.76 2.27l.99-4.28l-3.32-2.88l4.38-.37L12 6.09l1.71 4.04l4.38.37l-3.32 2.88l.99 4.28M22 9.24l-7.19-.61L12 2L9.19 8.63L2 9.24l5.45 4.73L5.82 21L12 17.27L18.18 21l-1.64-7.03L22 9.24Z"/>'
        },
        "star-plus": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-3.1 0-5.6 2.3-6 5.3L5.8 21M17 14v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "star-plus-outline": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-.7 0-1.4.1-2.1.4l2.2-1.9l-4.4-.4l-1.7-4l-1.7 4l-4.4.4l3.3 2.9l-1 4.3l3.8-2.3l.5.3c-.2.5-.4 1.1-.4 1.6L5.8 21M17 14v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "star-remove": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-3.1 0-5.6 2.3-6 5.3L5.8 21m14.3-6.5L18 16.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "star-remove-outline": {
            body: '<path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-3.2 2.8H18c-.7 0-1.4.1-2.1.4l2.2-1.9l-4.4-.4l-1.7-4l-1.7 4l-4.4.4l3.3 2.9l-1 4.3l3.8-2.3l.5.3c-.2.5-.4 1.1-.4 1.6L5.8 21m14.3-6.5L18 16.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4Z"/>'
        },
        "star-settings": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 2h2v-2h-2v2m4 0h2v-2h-2v2m7-14.76l-7.19-.62L12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21L12 17.27L18.18 21l-1.64-7.03L22 9.24Z"/>'
        },
        "star-settings-outline": {
            body: '<path fill="currentColor" d="M11 22h2v2h-2v-2m-4 2h2v-2H7v2m8 0h2v-2h-2v2m1.54-10.03L18.18 21L12 17.27L5.82 21l1.63-7.03L2 9.24l7.19-.61L12 2l2.81 6.63l7.19.61l-5.46 4.73m-.78 3.69l-.99-4.28l3.32-2.88l-4.38-.37L12 6.09l-1.71 4.04l-4.38.37l3.32 2.88l-.99 4.28L12 15.39l3.76 2.27Z"/>'
        },
        "star-shooting": {
            body: '<path fill="currentColor" d="m18.09 11.77l1.47 6.33L14 14.74L8.44 18.1l1.46-6.33L5 7.5l6.47-.54L14 1l2.53 5.96L23 7.5l-4.91 4.27M2 12.43c.19 0 .38-.06.55-.17l3.2-2.11l-1.57-1.36l-2.73 1.8c-.461.3-.589.91-.29 1.41c.2.27.52.43.84.43m-.84 9.12c.2.29.52.45.84.45c.19 0 .38-.05.55-.16l4.11-2.71l.34-1.37l.31-1.45l-5.86 3.85c-.461.31-.589.93-.29 1.39m.29-6.17a1 1 0 0 0-.29 1.38c.2.3.52.45.84.45c.19 0 .38-.05.55-.16l5.42-3.55l.27-1.19l-.92-.81l-5.87 3.88Z"/>'
        },
        "star-shooting-outline": {
            body: '<path fill="currentColor" d="m23 7.5l-6.47-.54L14 1l-2.53 5.96L5 7.5l4.9 4.27l-1.46 6.33L14 14.74l5.56 3.36l-1.47-6.33L23 7.5m-6.86 4.73l.4 1.71l-1.51-.91l-1.03-.62l-1.03.62l-1.51.91l.39-1.71l.28-1.18l-.91-.79L9.88 9.1l1.76-.15l1.2-.1l.47-1.11l.69-1.62l.69 1.62l.47 1.11l1.2.1l1.75.15l-1.33 1.16l-.92.79l.28 1.18M1.16 12c-.299-.5-.171-1.11.29-1.41l2.73-1.8l1.57 1.36l-3.2 2.11c-.17.11-.36.17-.55.17c-.32 0-.64-.16-.84-.43m.29 8.16l5.86-3.85L7 17.76l-.34 1.37l-4.11 2.71c-.17.11-.36.16-.55.16c-.32 0-.64-.16-.84-.45a1.013 1.013 0 0 1 .29-1.39m5.87-8.66l.92.81l-.27 1.19l-5.42 3.55c-.17.11-.36.16-.55.16c-.32 0-.64-.15-.84-.45a1 1 0 0 1 .29-1.38l5.87-3.88Z"/>'
        },
        "star-three-points": {
            body: '<path fill="currentColor" d="m12 2.6l-3 9.8l-7 7.5l10-2.3L22 20l-7-7.5l-3-9.9Z"/>'
        },
        "star-three-points-outline": {
            body: '<path fill="currentColor" d="m12 9.5l1.2 4l2.8 3l-4-.9l-4.1.9l2.8-3l1.3-4m0-6.9l-3 9.8l-7 7.5l10-2.3L22 20l-7-7.5l-3-9.9Z"/>'
        },
        "state-machine": {
            body: '<path fill="currentColor" d="M6.27 17.05A2.991 2.991 0 0 1 4 22c-1.66 0-3-1.34-3-3s1.34-3 3-3c.18 0 .36 0 .53.05l3.07-5.36l-1.74-.99l4.09-1.12l1.12 4.09l-1.74-.99l-3.06 5.37M20 16c-1.3 0-2.4.84-2.82 2H11v-2l-3 3l3 3v-2h6.18c.42 1.16 1.52 2 2.82 2c1.66 0 3-1.34 3-3s-1.34-3-3-3m-8-8c.18 0 .36 0 .53-.05l3.07 5.36l-1.74.99l4.09 1.12l1.12-4.09l-1.74.99l-3.06-5.37A2.991 2.991 0 0 0 12 2c-1.66 0-3 1.34-3 3s1.34 3 3 3Z"/>'
        },
        steam: {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10c-4.6 0-8.45-3.08-9.64-7.27l3.83 1.58a2.843 2.843 0 0 0 2.78 2.27c1.56 0 2.83-1.27 2.83-2.83v-.13l3.4-2.43h.08c2.08 0 3.77-1.69 3.77-3.77s-1.69-3.77-3.77-3.77s-3.78 1.69-3.78 3.77v.05l-2.37 3.46l-.16-.01c-.59 0-1.14.18-1.59.49L2 11.2C2.43 6.05 6.73 2 12 2M8.28 17.17c.8.33 1.72-.04 2.05-.84c.33-.8-.05-1.71-.83-2.04l-1.28-.53c.49-.18 1.04-.19 1.56.03c.53.21.94.62 1.15 1.15c.22.52.22 1.1 0 1.62c-.43 1.08-1.7 1.6-2.78 1.15c-.5-.21-.88-.59-1.09-1.04l1.22.5m9.52-7.75c0 1.39-1.13 2.52-2.52 2.52a2.52 2.52 0 0 1-2.51-2.52a2.5 2.5 0 0 1 2.51-2.51a2.52 2.52 0 0 1 2.52 2.51m-4.4 0c0 1.04.84 1.89 1.89 1.89c1.04 0 1.88-.85 1.88-1.89s-.84-1.89-1.88-1.89c-1.05 0-1.89.85-1.89 1.89Z"/>'
        },
        "steam-box": {
            body: '<path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4l3.19 1.31a2.843 2.843 0 0 0 2.78 2.27c1.56 0 2.83-1.27 2.83-2.83v-.13l3.4-2.43h.08c2.08 0 3.77-1.69 3.77-3.77s-1.69-3.77-3.77-3.77s-3.78 1.69-3.78 3.77v.05l-2.37 3.46l-.16-.01c-.59 0-1.14.18-1.59.49L3 11.6V5a2 2 0 0 1 2-2h14M8.28 17.17c.8.33 1.72-.04 2.05-.84c.33-.8-.05-1.71-.83-2.04l-1.28-.53c.49-.18 1.04-.19 1.56.03c.53.21.94.62 1.15 1.15c.22.52.22 1.1 0 1.62c-.43 1.08-1.7 1.6-2.78 1.15c-.5-.21-.88-.59-1.09-1.04l1.22.5m9.52-7.75c0 1.39-1.13 2.52-2.52 2.52a2.52 2.52 0 0 1-2.51-2.52a2.51 2.51 0 0 1 2.51-2.51a2.52 2.52 0 0 1 2.52 2.51m-4.4 0c0 1.04.84 1.89 1.89 1.89c1.04 0 1.88-.85 1.88-1.89s-.84-1.89-1.88-1.89c-1.05 0-1.89.85-1.89 1.89z" fill="currentColor"/>',
            hidden: true
        },
        steering: {
            body: '<path fill="currentColor" d="M13 19.92c1.8-.22 3.35-.97 4.65-2.27c1.3-1.3 2.05-2.85 2.27-4.65h-3c-.22 1-.68 1.84-1.38 2.54c-.7.7-1.54 1.16-2.54 1.38v3M10 8h4l3 3h2.92c-.25-1.95-1.13-3.62-2.65-5C15.76 4.66 14 4 12 4c-2 0-3.76.66-5.27 2c-1.52 1.38-2.4 3.05-2.65 5H7l3-3m1 11.92v-3c-1-.22-1.84-.68-2.54-1.38c-.7-.7-1.16-1.54-1.38-2.54h-3c.22 1.77.97 3.3 2.27 4.6c1.3 1.3 2.85 2.07 4.65 2.32M12 2c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12s-1 5.1-2.95 7.05C17.1 21 14.75 22 12 22s-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2Z"/>'
        },
        "steering-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-1.48-1.5c-1.55 1-3.3 1.5-5.25 1.5c-2.75 0-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12c0-1.95.5-3.7 1.5-5.25L2 5.27m11 14.65c1-.12 1.93-.42 2.78-.87l-2.28-2.27c-.16.06-.34.1-.5.14v3M4.08 11H7l.37-.37l-2.41-2.4A7.89 7.89 0 0 0 4.08 11m15.84 2h-3c-.12.54-.32 1.05-.59 1.5L9.91 8.09L10 8h4l3 3h2.92c-.25-1.95-1.13-3.62-2.65-5C15.76 4.66 14 4 12 4c-1.74 0-3.29.5-4.66 1.5L5.91 4.09C7.66 2.71 9.69 2 12 2c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12c0 2.31-.71 4.34-2.09 6.09l-1.41-1.42A7.726 7.726 0 0 0 19.92 13M11 19.92v-3c-1-.22-1.84-.68-2.54-1.38c-.7-.7-1.16-1.54-1.38-2.54h-3c.22 1.77.97 3.3 2.27 4.6c1.3 1.3 2.85 2.07 4.65 2.32Z"/>'
        },
        "step-backward": {
            body: '<path fill="currentColor" d="M19 5v14h-3V5m-2 0v14L3 12"/>'
        },
        "step-backward-2": {
            body: '<path fill="currentColor" d="M17 5h-3v14h3V5m-5 0L1 12l11 7V5m10 0h-3v14h3V5Z"/>'
        },
        "step-forward": {
            body: '<path fill="currentColor" d="M5 5v14h3V5m2 0v14l11-7"/>'
        },
        "step-forward-2": {
            body: '<path fill="currentColor" d="M7 5h3v14H7V5m5 0l11 7l-11 7V5M2 5h3v14H2V5Z"/>'
        },
        stethoscope: {
            body: '<path fill="currentColor" d="M19 8c.56 0 1 .43 1 1a1 1 0 0 1-1 1c-.57 0-1-.45-1-1c0-.57.43-1 1-1M2 2v9c0 2.96 2.19 5.5 5.14 5.91c.62 3.01 3.28 5.09 6.36 5.09a6.5 6.5 0 0 0 6.5-6.5v-3.69c1.16-.42 2-1.52 2-2.81a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 1.29.84 2.4 2 2.81v3.6c0 2.5-2 4.5-4.5 4.5c-2 0-3.68-1.21-4.28-3.01C12 16.3 14 13.8 14 11V2h-4v3h2v6a4 4 0 0 1-4 4a4 4 0 0 1-4-4V5h2V2H2Z"/>'
        },
        sticker: {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M15 20v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-alert": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M13 17h-2v-2h2v1m0-3h-2V7h2v5m2 8v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-alert-outline": {
            body: '<path fill="currentColor" d="M11 15h2v2h-2v-2m0-2h2V7h-2v6m11-7.5V16l-6 6H5.5C3.6 22 2 20.4 2 18.5v-13C2 3.6 3.6 2 5.5 2h13C20.4 2 22 3.6 22 5.5m-2 .3c0-1-.8-1.8-1.8-1.8H5.8C4.8 4 4 4.8 4 5.8v12.5c0 1 .8 1.8 1.8 1.8H15v-1.5c0-1.9 1.6-3.5 3.5-3.5H20V5.8Z"/>'
        },
        "sticker-check": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M7 12.5l1.3-1.4l2.1 2.1L15.6 8L17 9.4L10.5 16L7 12.5m8 7.5v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-check-outline": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M20 15h-1.5c-1.9 0-3.5 1.6-3.5 3.5V20H5.8c-1 0-1.8-.8-1.8-1.8V5.8C4 4.8 4.8 4 5.8 4h12.5c1 0 1.8.8 1.8 1.8V15m-4.9-6.8l1.5 1.5l-6 6l-3.5-3.5l1.5-1.5l2 2l4.5-4.5Z"/>'
        },
        "sticker-circle-outline": {
            body: '<path fill="currentColor" d="m12.12 18.46l6.18-6.18c-1.36.31-2.99.92-4.23 2.18c-1.03 1.04-1.68 2.37-1.95 4M20.75 10h.3c.39 0 .74.27.88.64c.14.36.07.79-.23 1.07l-10 10c-.2.19-.44.29-.7.29l-.36-.07c-.37-.14-.64-.49-.64-.88c-.16-3.39.73-6.09 2.66-8.02C15.5 10.2 19.62 10 20.75 10M12 2c4.5 0 8.34 3 9.58 7.11L20 9h-.58C18.24 6.07 15.36 4 12 4a8 8 0 0 0-8 8c0 3.36 2.07 6.24 5 7.42c-.03.71 0 1.43.11 2.15C5 20.33 2 16.5 2 12C2 6.47 6.5 2 12 2Z"/>'
        },
        "sticker-emoji": {
            body: '<path fill="currentColor" d="M5.5 2C3.56 2 2 3.56 2 5.5v13C2 20.44 3.56 22 5.5 22H16l6-6V5.5C22 3.56 20.44 2 18.5 2h-13m.25 2h12.5A1.75 1.75 0 0 1 20 5.75V15h-1.5c-1.94 0-3.5 1.56-3.5 3.5V20H5.75A1.75 1.75 0 0 1 4 18.25V5.75A1.75 1.75 0 0 1 5.75 4m8.69 2.77c-.16 0-.32.02-.47.06c-.94.26-1.47 1.22-1.23 2.17c.05.15.12.3.21.44l3.23-.88c0-.17-.02-.34-.06-.51c-.21-.75-.9-1.28-1.68-1.28M8.17 8.5c-.17 0-.32 0-.47.05c-.93.26-1.48 1.22-1.23 2.15c.03.16.12.3.21.46l3.23-.88c0-.17-.02-.34-.06-.5A1.72 1.72 0 0 0 8.17 8.5m8.55 2.76l-9.13 2.51a5.266 5.266 0 0 0 5.36 1.64a5.273 5.273 0 0 0 3.77-4.15Z"/>'
        },
        "sticker-minus": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M8 11h8v2H8v-2m7 9v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-minus-outline": {
            body: '<path fill="currentColor" d="M8 11h8v2H8v-2m14-5.5V16l-6 6H5.5C3.6 22 2 20.4 2 18.5v-13C2 3.6 3.6 2 5.5 2h13C20.4 2 22 3.6 22 5.5m-2 .3c0-1-.8-1.8-1.8-1.8H5.8C4.8 4 4 4.8 4 5.8v12.5c0 1 .8 1.8 1.8 1.8H15v-1.5c0-1.9 1.6-3.5 3.5-3.5H20V5.8Z"/>'
        },
        "sticker-outline": {
            body: '<path fill="currentColor" d="M5.5 2C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2h-13m.3 2h12.5c1 0 1.8.8 1.8 1.8V15h-1.5c-1.9 0-3.5 1.6-3.5 3.5V20H5.8c-1 0-1.8-.8-1.8-1.8V5.8C4 4.8 4.8 4 5.8 4"/>'
        },
        "sticker-plus": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M13 16h-2v-3H8v-2h3V8h2v3h3v2h-3v3m2 4v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-plus-outline": {
            body: '<path fill="currentColor" d="M13 11h3v2h-3v3h-2v-3H8v-2h3V8h2v3m9-5.5V16l-6 6H5.5C3.6 22 2 20.4 2 18.5v-13C2 3.6 3.6 2 5.5 2h13C20.4 2 22 3.6 22 5.5m-2 .3c0-1-.8-1.8-1.8-1.8H5.8C4.8 4 4 4.8 4 5.8v12.5c0 1 .8 1.8 1.8 1.8H15v-1.5c0-1.9 1.6-3.5 3.5-3.5H20V5.8Z"/>'
        },
        "sticker-remove": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M12 13.4l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4l2.1 2.1l2.1-2.1l1.4 1.4l-2.1 2.1l2.1 2.1l-1.4 1.4l-2.1-2.1m3 6.6v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-remove-outline": {
            body: '<path fill="currentColor" d="M16 9.4L13.4 12l2.6 2.6l-1.4 1.4l-2.6-2.6L9.4 16L8 14.6l2.6-2.6L8 9.4L9.4 8l2.6 2.6L14.6 8L16 9.4m6-3.9V16l-6 6H5.5C3.6 22 2 20.4 2 18.5v-13C2 3.6 3.6 2 5.5 2h13C20.4 2 22 3.6 22 5.5m-2 .3c0-1-.8-1.8-1.8-1.8H5.8C4.8 4 4 4.8 4 5.8v12.5c0 1 .8 1.8 1.8 1.8H15v-1.5c0-1.9 1.6-3.5 3.5-3.5H20V5.8Z"/>'
        },
        "sticker-text": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M6 7h12v2H6V7m0 4h12v2H6v-2m7 6H6v-2h7v2m2 3v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5Z"/>'
        },
        "sticker-text-outline": {
            body: '<path fill="currentColor" d="M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2m1.6 13h-1.5c-1.9 0-3.5 1.6-3.5 3.5V20H5.8c-1 0-1.8-.8-1.8-1.8V5.8C4 4.8 4.8 4 5.8 4h12.5c1 0 1.8.8 1.8 1.8V15M7 7h10v2H7V7m0 4h10v2H7v-2m0 4h6v2H7v-2Z"/>'
        },
        stocking: {
            body: '<path fill="currentColor" d="M17 2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2v8c0 .85-.5 1.57-1.26 1.86L9.5 21.77c-1 .47-2.21.04-2.67-.96L6 19c-.5-1-.05-2.2.95-2.66L10 14.91V9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7m-7 2v3h7V4h-7Z"/>'
        },
        stomach: {
            body: '<path fill="currentColor" d="M4 18c.67 1.85 2.07 4 8 4c2.36 0 5.07-.07 7-2c1-1 3-3 3-9s-2-7-4-7c-1.38 0-3 0-4 2v.03a1.82 1.82 0 0 1-1.87.92C11 6.81 11 6.37 11 6V2H9v4a2.92 2.92 0 0 0 3 3c1 0 1 1.78 1 3c0 1.89-.5 3.26-2 4c-2.31 1.15-4.61 1-5.39-.53a1.5 1.5 0 0 0-2.47-.6A3.67 3.67 0 0 0 2 18v4h2Z"/>'
        },
        stool: {
            body: '<path fill="currentColor" d="M20 6c0-2.21-1.79-4-4-4H8C5.78 2 4 3.79 4 6v2h3L4 22h2l1.5-7H11v7h2v-7h3.5l1.5 7h2L17 8h3V6M7.93 13L9 8h2v5H7.93m8.14 0H13V8h2l1.07 5Z"/>'
        },
        "stool-outline": {
            body: '<path fill="currentColor" d="M20 6c0-2.21-1.79-4-4-4H8C5.78 2 4 3.79 4 6v2h3L4 22h2l1.5-7H11v7h2v-7h3.5l1.5 7h2L17 8h3V6M7.93 13L9 8h2v5H7.93m8.14 0H13V8h2l1.07 5M6 6a2 2 0 0 1 2-2h8c1.1 0 2 .9 2 2H6Z"/>'
        },
        stop: {
            body: '<path fill="currentColor" d="M18 18H6V6h12v12Z"/>'
        },
        "stop-circle": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M9 9h6v6H9"/>'
        },
        "stop-circle-outline": {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 2c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8M9 9v6h6V9"/>'
        },
        "storage-tank": {
            body: '<path fill="currentColor" d="M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6m-7-1h4v1h-4V5Z"/>'
        },
        "storage-tank-outline": {
            body: '<path fill="currentColor" d="M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6m-7-1h4v1h-4V5m7 11H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4Z"/>'
        },
        store: {
            body: '<path fill="currentColor" d="M12 18H6v-4h6m9 0v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6m0-10H4v2h16V4Z"/>'
        },
        "store-24-hour": {
            body: '<path fill="currentColor" d="M16 12h-1v-2h-2V7h1v2h1V7h1m-5 3H9v1h2v1H8V9h2V8H8V7h3m8 0V4H5v3H2v13h8v-4h4v4h8V7h-3Z"/>'
        },
        "store-alert": {
            body: '<path fill="currentColor" d="m2 7l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5H2m8 11H4v-4h6v4m8-12H2V4h16v2m5 1v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "store-alert-outline": {
            body: '<path fill="currentColor" d="m2 7l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5H2m8 11H4v-4h6v4m-6.96-6l.6-3h12.72l.6 3H3.04M18 6H2V4h16v2m5 1v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "store-check": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-4.31 8H14v1.69c-.63.95-1 2.08-1 3.31c0 .34.04.67.09 1H4v-6H3v-2l1-5h16l1 5v1.35c-.63-.22-1.3-.35-2-.35c-1.23 0-2.36.37-3.31 1M12 14H6v4h6v-4m9.34 1.84l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "store-check-outline": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.37.13 2 .35V12l-1-5H4l-1 5v2h1v6h9.09c-.05-.33-.09-.66-.09-1c0-1.23.37-2.36 1-3.31V14h1.69c.95-.63 2.08-1 3.31-1m-7 5H6v-4h6v4m-6.96-6l.6-3h12.72l.6 3H5.04M20 6H4V4h16v2m2.5 11.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41"/>'
        },
        "store-clock": {
            body: '<path fill="currentColor" d="M18 4H2V2h16v2m-.5 9H16v5l3.61 2.16l.75-1.22l-2.86-1.69V13m6.5 4c0 3.87-3.13 7-7 7c-3.53 0-6.43-2.61-6.92-6H2v-6H1v-2l1-5h16l1 5v.29c2.89.87 5 3.54 5 6.71M4 16h6v-4H4v4m18 1c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "store-clock-outline": {
            body: '<path fill="currentColor" d="M18 4H2V2h16v2m-.5 9H16v5l3.61 2.16l.75-1.22l-2.86-1.69V13m6.5 4c0 3.87-3.13 7-7 7c-3.53 0-6.43-2.61-6.92-6H2v-6H1v-2l1-5h16l1 5v.29c2.89.87 5 3.54 5 6.71M3.04 10h13.92l-.6-3H3.64l-.6 3M4 16h6v-4H4v4m18 1c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5Z"/>'
        },
        "store-cog": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-1 6c-1.91 0-3.63.76-4.89 2H14v.11c-1.24 1.26-2 2.98-2 4.89c0 .34.03.67.08 1H4v-6H3v-2l1-5h16l1 5v.3c-.63-.19-1.3-.3-2-.3m-7 2H6v4h6v-4m11.8 6.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "store-cog-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-1 6c-1.91 0-3.63.76-4.89 2H14v.11c-1.24 1.26-2 2.98-2 4.89c0 .34.03.67.08 1H4v-6H3v-2l1-5h16l1 5v.3c-.63-.19-1.3-.3-2-.3m-7 2H6v4h6v-4m6.96-2l-.6-3H5.64l-.6 3h13.92m4.84 8.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "store-edit": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-6 10.13l-3 3V20H4v-6H3v-2l1-5h16l.61 3.07c-.45.1-.88.33-1.22.67L16.13 14H14v2.13M12 14H6v4h6v-4m10.85-.53l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96Z"/>'
        },
        "store-edit-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-6 10.13l-3 3V20H4v-6H3v-2l1-5h16l.61 3.07c-.45.1-.88.33-1.22.67l-.57.57L18.36 9H5.64l-.6 3h13.09l-2 2H14v2.13M12 14H6v4h6v-4m10.85-.53l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72M13 19.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96Z"/>'
        },
        "store-marker": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-7 9.5c0 1.14.43 2.36 1 3.5v1H4v-6H3v-2l1-5h16l.7 3.5c-.7-.32-1.42-.5-2.2-.5c-3 0-5.5 2.5-5.5 5.5M12 14H6v4h6v-4m10 1.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "store-marker-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-5.7 6c-.8.96-1.3 2.18-1.3 3.5c0 1.14.43 2.36 1 3.5v1H4v-6H3v-2l1-5h16l.7 3.5c-.66-.32-1.38-.5-2.14-.5l-.2-1H5.64l-.6 3h9.26M12 14H6v4h6v-4m10 1.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "store-minus": {
            body: '<path fill="currentColor" d="M4 4v2h16V4M4 7l-1 5v2h1v6h9c-.05-.34-.08-.69-.08-1.05c0-1.22.38-2.42 1.08-3.42V14h1.54c1-.67 2.17-1.04 3.37-1.04c.71 0 1.42.13 2.09.38V12l-1-5M6 14h6v4H6m9 0v2h8v-2"/>'
        },
        "store-minus-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-4.31 8H14v1.69c-.63.95-1 2.08-1 3.31c0 .34.04.67.09 1H4v-6H3v-2l1-5h16l1 5v1.35c-.63-.22-1.3-.35-2-.35c-1.23 0-2.36.37-3.31 1M12 14H6v4h6v-4m6.96-2l-.6-3H5.64l-.6 3h13.92M15 18v2h8v-2h-8Z"/>'
        },
        "store-off": {
            body: '<path fill="currentColor" d="m9.2 6l-2-2H20v2H9.2M20 16.8V14h1v-2l-1-5h-9.8l7 7h.8v.8l2 2m2.11 4.66l-1.27 1.27L14 15.89V20H4v-6H3v-2l1-5h1.11l-4-4l1.28-1.27l19.72 19.73M12 14H6v4h6v-4Z"/>'
        },
        "store-off-outline": {
            body: '<path fill="currentColor" d="M2.39 1.73L1.11 3l4 4H4l-1 5v2h1v6h10v-4.11l6.84 6.84l1.27-1.27L2.39 1.73M5.64 9h1.47l3 3H5.04l.6-3M12 18H6v-4h6v4m6-3.2V14h-.8l-2-2h3.76l-.6-3H12.2l-2-2H20l1 5v2h-1v2.8l-2-2M9.2 6l-2-2H20v2H9.2Z"/>'
        },
        "store-outline": {
            body: '<path fill="currentColor" d="m18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4m0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5M6 18v-4h6v4H6Z"/>'
        },
        "store-plus": {
            body: '<path fill="currentColor" d="M4 4v2h16V4M4 7l-1 5v2h1v6h9c-.05-.34-.08-.69-.08-1.05c0-1.22.38-2.42 1.08-3.42V14h1.54c1-.67 2.17-1.04 3.37-1.04c.71 0 1.42.13 2.09.38V12l-1-5M6 14h6v4H6m12-3v3h-3v2h3v3h2v-3h3v-2h-3v-3"/>'
        },
        "store-plus-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-4.31 8H14v1.69c-.63.95-1 2.08-1 3.31c0 .34.04.67.09 1H4v-6H3v-2l1-5h16l1 5v1.35c-.63-.22-1.3-.35-2-.35c-1.23 0-2.36.37-3.31 1M12 14H6v4h6v-4m6.96-2l-.6-3H5.64l-.6 3h13.92M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "store-remove": {
            body: '<path fill="currentColor" d="M4 4h16v2H4V4m11.46 12.88l1.42-1.42L19 17.59l2.12-2.12l1.42 1.41L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.12-2.12M4 7h16l1 5v1.34a5.99 5.99 0 0 0-2.09-.38c-1.2 0-2.37.37-3.37 1.04H14v1.53c-.7 1-1.08 2.2-1.08 3.42L13 20H4v-6H3v-2l1-5m2 7v4h6v-4H6Z"/>'
        },
        "store-remove-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m-4.31 8H14v1.69c-.63.95-1 2.08-1 3.31c0 .34.04.67.09 1H4v-6H3v-2l1-5h16l1 5v1.35c-.63-.22-1.3-.35-2-.35c-1.23 0-2.36.37-3.31 1M12 14H6v4h6v-4m6.96-2l-.6-3H5.64l-.6 3h13.92m3.58 4.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "store-search": {
            body: '<path fill="currentColor" d="M11.9 10.9a6.53 6.53 0 0 0-1.9 4.6V12H4v4h6v-.5c0 .85.17 1.7.5 2.5H2v-6H1v-2l1-5h16l.89 4.46a6.47 6.47 0 0 0-6.99 1.44M18 2H2v2h16V2m5.39 19L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "store-search-outline": {
            body: '<path fill="currentColor" d="M18 4H2V2h16v2m-4.96 6h-10l.6-3h12.72l.4 2c.74.04 1.45.19 2.13.46L18 5H2l-1 5v2h1v6h8.5c-.33-.8-.5-1.65-.5-2.5v.5H4v-4h6v3.5c0-1.66.64-3.33 1.9-4.6c.36-.35.74-.65 1.14-.9m10.35 11L22 22.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1M19 15.5a2.5 2.5 0 0 0-5 0a2.5 2.5 0 0 0 5 0Z"/>'
        },
        "store-settings": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m1 6v2h-1v6h-2v-6h-4v6H4v-6H3v-2l1-5h16l1 5m-9 2H6v4h6v-4M7 24h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        "store-settings-outline": {
            body: '<path fill="currentColor" d="M20 6H4V4h16v2m1 6v2h-1v6h-2v-6h-4v6H4v-6H3v-2l1-5h16l1 5m-9 2H6v4h6v-4m6.96-2l-.6-3H5.64l-.6 3h13.92M7 24h2v-2H7v2m4 0h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        storefront: {
            body: '<path fill="currentColor" d="M5.06 3c-.43 0-.84.14-1.22.42c-.38.28-.6.64-.7 1.08L2.11 8.91c-.25 1.09-.05 2.01.58 2.82c.12.12.24.24.35.34c.59.57 1.24.93 2.18.93c.94 0 1.69-.41 2.25-.95c.63.62 1.39.95 2.33.95c.84 0 1.64-.37 2.2-.93c.68.63 1.45.93 2.3.93c.87 0 1.61-.33 2.24-.95c.57.57 1.32.95 2.27.95s1.62-.35 2.19-.94c.09-.09.18-.19.28-.29c.66-.82.86-1.77.61-2.86L20.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 3m-.05 1.97l1.08 4.41c.09.43 0 .82-.28 1.17c-.25.31-.56.45-.94.45c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 5M5.06 5h1.97l-.61 4.84C6.3 10.63 5.91 11 5.25 11c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17M9.05 5H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41c-.23-.29-.34-.59-.34-.93V9.5M13 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38A1.29 1.29 0 0 1 13 9.7M3 14.03V19c0 1.11.89 2 2 2h14a2 2 0 0 0 2-2v-4.95c-.55.58-1.25.91-2 .95c-1 .03-1.75-.26-2.46-.95c-.6.6-1.4.95-2.24.95c-.9 0-1.7-.36-2.3-.93c-.57.57-1.35.93-2.22.93c-.91 0-1.71-.35-2.31-.95c-.58.59-1.37.95-2.24.95c-.9 0-1.57-.35-2.23-.97Z"/>'
        },
        "storefront-check": {
            body: '<path fill="currentColor" d="M5.06 3c-.43 0-.84.14-1.22.42s-.6.64-.7 1.08L2.11 8.91c-.25 1.09-.05 2.01.58 2.82c.12.12.24.24.35.34c.59.57 1.24.93 2.18.93s1.69-.41 2.25-.95c.63.62 1.39.95 2.33.95c.84 0 1.64-.37 2.2-.93c.68.63 1.45.93 2.3.93c.87 0 1.61-.33 2.24-.95c.57.57 1.32.95 2.27.95s1.62-.35 2.19-.94l.13-.14l.15-.15c.66-.82.86-1.77.61-2.86L20.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 3m-.05 1.97l1.08 4.41c.09.43 0 .82-.28 1.17c-.25.31-.56.45-.94.45c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 5M5.06 5h1.97l-.61 4.84C6.3 10.63 5.91 11 5.25 11c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17M9.05 5H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41S8.5 10 8.5 9.66V9.5M13 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38A1.29 1.29 0 0 1 13 9.7m-.03 5.02a3.37 3.37 0 0 1-.97-.65c-.57.57-1.35.93-2.22.93c-.91 0-1.71-.35-2.31-.95c-.58.59-1.37.95-2.24.95c-.9 0-1.57-.35-2.23-.97V19c0 1.11.89 2 2 2h7.8c-.51-.88-.8-1.91-.8-3c0-1.21.36-2.34.97-3.28M17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41Z"/>'
        },
        "storefront-check-outline": {
            body: '<path fill="currentColor" d="M5.06 3c-.43 0-.84.14-1.22.42s-.6.64-.7 1.08L2.11 8.91c-.25 1.09-.05 2.01.58 2.82c.11.11.21.21.31.3V19c0 .5.2 1 .61 1.39S4.5 21 5 21h7.8c-.35-.61-.6-1.28-.72-2H5v-6h.22c.94 0 1.69-.41 2.25-.95c.63.62 1.39.95 2.33.95c.84 0 1.64-.37 2.2-.93c.68.63 1.45.93 2.3.93c.87 0 1.61-.33 2.24-.95c.57.57 1.32.95 2.27.95s1.62-.35 2.19-.94l.13-.14l.15-.15c.66-.82.86-1.77.61-2.86L20.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 3m-.05 1.97l1.08 4.41c.09.43 0 .82-.28 1.17c-.25.31-.56.45-.94.45c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 5M5.06 5h1.97l-.61 4.84C6.3 10.63 5.91 11 5.25 11c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17M9.05 5H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41S8.5 10 8.5 9.66V9.5M13 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38A1.29 1.29 0 0 1 13 9.7M17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41Z"/>'
        },
        "storefront-edit": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.11.5.11.96.06 1.4c-.72-.28-1.55-.21-2.22.19c.27-.33.33-.71.24-1.12l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.16 0 .31-.03.45-.08l-.13.14l-.01-.01l-1.64 1.64c-.33-.16-.62-.38-.88-.64c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95s-1.59-.36-2.18-.93c-.11-.1-.23-.22-.35-.34c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92M14.95 5H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07m5.61 6.43l-2.05-2.05L13 19.94V22h2.06m-.76-7c.33 0 .66-.05.97-.16L11 19.11V21H5c-1.11 0-2-.89-2-2v-4.97c.66.62 1.33.97 2.23.97c.87 0 1.66-.36 2.24-.95c.6.6 1.4.95 2.31.95c.87 0 1.65-.36 2.22-.93c.6.57 1.4.93 2.3.93m8.4-.65l-1 1l-2.05-2.05l1-1c.07-.07.16-.12.25-.14c.18-.05.38 0 .52.14l1.28 1.28c.21.21.21.56 0 .77Z"/>'
        },
        "storefront-edit-outline": {
            body: '<path fill="currentColor" d="M5.06 3c-.43 0-.84.14-1.22.42s-.6.64-.7 1.08L2.11 8.91c-.25 1.09-.05 2.04.61 2.86l.28.28V19c0 .5.2 1 .61 1.39S4.5 21 5 21h6v-1.89l.11-.11H5v-6h.25c.91 0 1.64-.33 2.2-.95c.63.62 1.41.95 2.35.95c.84 0 1.58-.33 2.2-.95c.69.62 1.45.95 2.3.95c.87 0 1.62-.33 2.25-.95c.25.28.54.49.86.65l1.65-1.65l.01.01l.13-.14c-.14.05-.29.08-.45.08c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 5l1.92-.03l1.08 4.41c.09.41.03.78-.24 1.12c.67-.4 1.5-.47 2.22-.19c.05-.44.05-.9-.06-1.4L20.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 3M5.06 5h1.97l-.61 4.84C6.3 10.63 5.91 11 5.25 11c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17M9.05 5H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41S8.5 10 8.5 9.66V9.5M13 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38A1.29 1.29 0 0 1 13 9.7M15.06 22H13v-2.06l6.06-6.06l2.05 2.05m-.46-3.63c.1-.1.22-.15.35-.16c.15 0 .31.05.42.16l1.28 1.28c.21.21.21.56 0 .77l-1 1l-2.05-2.05Z"/>'
        },
        "storefront-minus": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95s-1.59-.36-2.18-.93c-.11-.1-.23-.22-.35-.34c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16L7.03 5M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92V5m3.95 0H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07L14.95 5M22 17v2h-8v-2h8m-10-2.93c.28.27.61.49.97.65c-.61.94-.97 2.07-.97 3.28c0 1.09.29 2.12.8 3H5c-1.11 0-2-.89-2-2v-4.97c.66.62 1.33.97 2.23.97c.87 0 1.66-.36 2.24-.95c.6.6 1.4.95 2.31.95c.87 0 1.65-.36 2.22-.93Z"/>'
        },
        "storefront-minus-outline": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95H5v6h7.08c.12.72.37 1.39.72 2H5c-.5 0-1-.22-1.39-.61S3 19.5 3 19v-6.97c-.1-.09-.2-.19-.31-.3c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16L7.03 5M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92V5m3.95 0H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07L14.95 5M14 17v2h8v-2h-8Z"/>'
        },
        "storefront-outline": {
            body: '<path fill="currentColor" d="M5.06 3c-.43 0-.84.14-1.22.42s-.6.64-.7 1.08L2.11 8.91c-.25 1.09-.05 2.04.61 2.86l.28.28V19c0 .5.2 1 .61 1.39S4.5 21 5 21h14c.5 0 1-.2 1.39-.61S21 19.5 21 19v-6.95l.28-.28c.66-.82.86-1.77.61-2.86L20.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0 0 18.94 3H5.06m13.83 1.97l1.08 4.41c.09.43 0 .82-.28 1.17c-.25.31-.56.45-.94.45c-.31 0-.58-.1-.8-.34c-.22-.23-.34-.5-.37-.82L16.97 5l1.92-.03M5.06 5h1.97l-.61 4.84C6.3 10.63 5.91 11 5.25 11c-.41 0-.72-.14-.94-.45c-.28-.35-.37-.74-.28-1.17L5.06 5m3.99 0H11v4.7c0 .35-.11.65-.36.92c-.25.26-.56.38-.94.38c-.34 0-.63-.12-.86-.41S8.5 10 8.5 9.66V9.5L9.05 5M13 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07c-.26.3-.6.43-1.01.43c-.31 0-.59-.12-.84-.38A1.29 1.29 0 0 1 13 9.7V5m-5.55 7.05c.63.62 1.41.95 2.35.95c.84 0 1.58-.33 2.2-.95c.69.62 1.45.95 2.3.95c.87 0 1.62-.33 2.25-.95c.56.62 1.31.95 2.25.95h.23v6H5v-6h.25c.91 0 1.64-.33 2.2-.95Z"/>'
        },
        "storefront-plus": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95s-1.59-.36-2.18-.93c-.11-.1-.23-.22-.35-.34c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92M14.95 5H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3m-5-2.93c.28.27.61.49.97.65c-.61.94-.97 2.07-.97 3.28c0 1.09.29 2.12.8 3H5c-1.11 0-2-.89-2-2v-4.97c.66.62 1.33.97 2.23.97c.87 0 1.66-.36 2.24-.95c.6.6 1.4.95 2.31.95c.87 0 1.65-.36 2.22-.93Z"/>'
        },
        "storefront-plus-outline": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95H5v6h7.08c.12.72.37 1.39.72 2H5c-.5 0-1-.22-1.39-.61S3 19.5 3 19v-6.97c-.1-.09-.2-.19-.31-.3c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92M14.95 5H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "storefront-remove": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95s-1.59-.36-2.18-.93c-.11-.1-.23-.22-.35-.34c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16L7.03 5M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92V5m3.95 0H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07L14.95 5m5.17 9.46l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.41-1.42L16.59 18l-2.12-2.12l1.41-1.41L18 16.59l2.12-2.13M12 14.07c.28.27.61.49.97.65c-.61.94-.97 2.07-.97 3.28c0 1.09.29 2.12.8 3H5c-1.11 0-2-.89-2-2v-4.97c.66.62 1.33.97 2.23.97c.87 0 1.66-.36 2.24-.95c.6.6 1.4.95 2.31.95c.87 0 1.65-.36 2.22-.93Z"/>'
        },
        "storefront-remove-outline": {
            body: '<path fill="currentColor" d="M3.84 3.42c.38-.28.79-.42 1.22-.42h13.88c.44 0 .83.14 1.19.42c.37.28.6.64.73 1.08l1.03 4.41c.25 1.09.05 2.04-.61 2.86l-.15.15l-.13.14c-.57.59-1.24.94-2.19.94s-1.7-.38-2.27-.95c-.63.62-1.37.95-2.24.95c-.85 0-1.62-.3-2.3-.93c-.56.56-1.36.93-2.2.93c-.94 0-1.7-.33-2.33-.95c-.56.54-1.31.95-2.25.95H5v6h7.08c.12.72.37 1.39.72 2H5c-.5 0-1-.22-1.39-.61S3 19.5 3 19v-6.97c-.1-.09-.2-.19-.31-.3c-.63-.81-.83-1.73-.58-2.82L3.14 4.5c.1-.44.32-.8.7-1.08m16.13 5.96l-1.08-4.41l-1.92.03l.61 4.84c.03.32.15.59.37.82c.22.24.49.34.8.34c.38 0 .69-.14.94-.45c.28-.35.37-.74.28-1.17M7.03 5H5.06L4.03 9.38c-.09.43 0 .82.28 1.17c.22.31.53.45.94.45c.66 0 1.05-.37 1.17-1.16L7.03 5M11 5H9.05L8.5 9.5v.16c0 .34.11.64.34.93s.52.41.86.41c.38 0 .69-.12.94-.38c.25-.27.36-.57.36-.92V5m3.95 0H13v4.7c0 .35.11.65.36.92c.25.26.53.38.84.38c.41 0 .75-.13 1.01-.43c.29-.3.37-.65.29-1.07L14.95 5m6.59 10.88l-1.42-1.41L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18l2.13-2.12Z"/>'
        },
        stove: {
            body: '<path fill="currentColor" d="M6 14h2l3 3H9l-3-3M4 4h1V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h2V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2v1h-3v-1H7v1H4v-1a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m14 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6-1H4v4h16V6M4 19h16v-7H4v7M6 7a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m7 7h2l3 3h-2l-3-3Z"/>'
        },
        strategy: {
            body: '<path fill="currentColor" d="m6.91 5.5l2.3 2.29l-1.42 1.42l-2.29-2.3l-2.29 2.3l-1.42-1.42l2.3-2.29l-2.3-2.29l1.42-1.42l2.29 2.3l2.29-2.3l1.42 1.42m13 13l-1.42-1.42l-2.29 2.3l-2.29-2.3l-1.42 1.42l2.3 2.29l-2.3 2.29l1.42 1.42l2.29-2.3l2.29 2.3l1.42-1.42l-2.3-2.29m.49-11.67L17.18 11L15.6 9.73l1.17-1.5a9.08 9.08 0 0 0-6.66 5.62A4.5 4.5 0 1 1 7.5 13a4 4 0 0 1 .78.08a11.27 11.27 0 0 1 8.15-6.82L15 5.18l1.27-1.58M10 17.5A2.5 2.5 0 1 0 7.5 20a2.5 2.5 0 0 0 2.5-2.5Z"/>'
        },
        strava: {
            body: '<path d="M14.92 17.16l1.83-3.63h2.7l-4.51 8.97l-4.57-8.97h2.7l1.85 3.63m-4.29-8.5l-2.45 4.89H4.55L10.61 1.5l6.13 12.05h-3.63l-2.48-4.89z" fill="currentColor"/>',
            hidden: true
        },
        "stretch-to-page": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2M9 19H5v-4l1.29 1.29l1.54-1.54l1.42 1.42l-1.54 1.54m.12-8.46L6.29 7.71L5 9V5h4L7.71 6.29l1.54 1.54M19 19h-4l1.29-1.29l-1.54-1.54l1.42-1.42l1.54 1.54L19 15m0-6l-1.29-1.29l-1.54 1.54l-1.42-1.42l1.54-1.54L15 5h4"/>'
        },
        "stretch-to-page-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2m0 18H4V4h16M8.83 10.25L7.29 8.71L6 10V6h4L8.71 7.29l1.54 1.54m3.5 0l1.54-1.54L14 6h4v4l-1.29-1.29l-1.54 1.54m0 3.5l1.54 1.54L18 14v4h-4l1.29-1.29l-1.54-1.54m-3.5 0l-1.54 1.54L10 18H6v-4l1.29 1.29l1.54-1.54"/>'
        },
        "string-lights": {
            body: '<path fill="currentColor" d="M22.56 11.39c-.2-.8-.74-1.54-1.51-1.95l-.42-1.7c.48-.16.94-.33 1.37-.51V5c-2 1.07-5.47 2.03-10 2.03S4 6.07 2 5v2.23c.43.18.89.35 1.37.51l-.42 1.7a3.07 3.07 0 0 0-1.51 1.95c-.535 2.18-1.055 5.92 1.48 6.54C4 18.2 6 17.89 7.27 12.82c.19-.82.06-1.7-.43-2.43l.42-1.72c.88.14 1.79.23 2.74.29v1.78c-.65.59-1 1.43-1 2.26c0 2.24.39 6 3 6c1.12 0 3-.78 3-6c0-.83-.35-1.67-1-2.26V8.96c.95-.06 1.86-.15 2.74-.29l.42 1.72a3.09 3.09 0 0 0-.43 2.43C18 17.89 20 18.2 21.08 17.93c2.53-.62 2.01-4.36 1.48-6.54M5.81 12.47s-1.07 4.37-2.53 4.03c-1.46-.38-.38-4.75-.38-4.75s.36-1.46 1.81-1.1s1.1 1.82 1.1 1.82M12 17.5c-1.5 0-1.5-4.5-1.5-4.5s0-1.5 1.5-1.5s1.5 1.5 1.5 1.5s0 4.5-1.5 4.5m8.72-1c-1.45.34-2.53-4.03-2.53-4.03s-.36-1.47 1.1-1.82s1.81 1.1 1.81 1.1s1.08 4.37-.38 4.75Z"/>'
        },
        "string-lights-off": {
            body: '<path fill="currentColor" d="M14 10.74V8.96c.95-.06 1.86-.15 2.74-.29l.42 1.72a3.09 3.09 0 0 0-.43 2.43c.09.35.18.68.27.98l4.12 4.12c2.49-.66 1.97-4.37 1.44-6.53c-.2-.8-.74-1.54-1.51-1.95l-.42-1.7c.48-.16.94-.33 1.37-.51V5c-2 1.07-5.47 2.03-10 2.03c-.63 0-1.24-.03-1.83-.06m10.55 9.53c-1.45.34-2.53-4.03-2.53-4.03s-.36-1.47 1.1-1.82s1.81 1.1 1.81 1.1s1.08 4.37-.38 4.75m-5.77-2.21l-1.45-1.46l-1.32-1.33L10 9.34l-.42-.41h.01L7.32 6.66L2.39 1.73L1.11 3l2.8 2.8C3.19 5.55 2.53 5.28 2 5v2.23c.43.18.89.35 1.37.51l-.42 1.7a3.07 3.07 0 0 0-1.51 1.95c-.535 2.18-1.055 5.92 1.48 6.54C4 18.2 6 17.89 7.27 12.82c.19-.82.06-1.7-.43-2.43l.33-1.33l2.33 2.32c-.32.49-.5 1.06-.5 1.62c0 2.24.39 6 3 6c.8 0 1.97-.41 2.59-2.5l6.25 6.23l1.27-1.27l-7.16-7.16v-.01m-9.14-1.82s-1.07 4.37-2.53 4.03c-1.46-.38-.38-4.75-.38-4.75s.36-1.46 1.81-1.1s1.1 1.82 1.1 1.82M12 17.5c-1.5 0-1.5-4.5-1.5-4.5s0-.23.1-.5l2.72 2.71c-.19 1.14-.56 2.29-1.32 2.29Z"/>'
        },
        "subdirectory-arrow-left": {
            body: '<path fill="currentColor" d="m11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6l6-6Z"/>'
        },
        "subdirectory-arrow-right": {
            body: '<path fill="currentColor" d="m19 15l-6 6l-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6Z"/>'
        },
        submarine: {
            body: '<path fill="currentColor" d="M8 3.67C6.78 4.53 5.39 4.93 4 5H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62.94 4 1h2V5h-2c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0m8 5L15 10v2h-1l-2 2H9l-3 2l-1-2H4v2l-2 1l2 1v2h1.14L6 18l3 2h11a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2l-1-1v-1h-1v-2h1V8.67Z"/>'
        },
        subtitles: {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M4 12h4v2H4v-2m10 6H4v-2h10v2m6 0h-4v-2h4v2m0-4H10v-2h10v2Z"/>'
        },
        "subtitles-outline": {
            body: '<path fill="currentColor" d="M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16m0 14V6H4v12h16M6 10h2v2H6v-2m0 4h8v2H6v-2m10 0h2v2h-2v-2m-6-4h8v2h-8v-2Z"/>'
        },
        subway: {
            body: '<path fill="currentColor" d="M8.5 15a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 9h10v5H7V9m8.5 6a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m2.5.88V9c0-2.62-2.68-3-6-3c-3 0-6 .37-6 3v6.88a2.62 2.62 0 0 0 2.62 2.62L7.5 19.62V20h1.67l1.5-1.5h2.83L15 20h1.5v-.38l-1.13-1.12c1.45 0 2.63-1.17 2.63-2.62M17.8 2.8C20.47 3.84 22 6.05 22 8.86V22H2V8.86C2 6.05 3.53 3.84 6.2 2.8C8 2.09 10.14 2 12 2c1.86 0 4 .09 5.8.8Z"/>'
        },
        "subway-alert-variant": {
            body: '<path fill="currentColor" d="M16 11V6h-5v5h5m-1.5 6c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5M9 11V6H4v5h5m-3.5 6c.8 0 1.5-.7 1.5-1.5S6.3 14 5.5 14S4 14.7 4 15.5S4.7 17 5.5 17M10 2c4.4 0 8 .5 8 4v9.5c0 1.9-1.6 3.5-3.5 3.5l1.5 1.5v.5H4v-.5L5.5 19C3.6 19 2 17.4 2 15.5V6c0-3.5 3.6-4 8-4m10 11V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "subway-variant": {
            body: '<path fill="currentColor" d="M18 11h-5V6h5m-1.5 11a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5M11 11H6V6h5M7.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 14A1.5 1.5 0 0 1 9 15.5A1.5 1.5 0 0 1 7.5 17M12 2c-4.42 0-8 .5-8 4v9.5A3.5 3.5 0 0 0 7.5 19L6 20.5v.5h12v-.5L16.5 19a3.5 3.5 0 0 0 3.5-3.5V6c0-3.5-3.58-4-8-4Z"/>'
        },
        summit: {
            body: '<path fill="currentColor" d="M15 3h2l5 2l-5 2v3.17L22 21H2l6-8l3.5 4.7l3.5-7.53V3Z"/>'
        },
        "sun-angle": {
            body: '<path fill="currentColor" d="M13.8 5.2C13 5 12.2 5 11.4 5l3.2-2.7l1.4 4c-.7-.5-1.4-.8-2.2-1.1M7 7.1c.6-.6 1.3-1.1 2-1.4l-4.1-.8l.7 4.1c.4-.7.8-1.4 1.4-1.9m-1.8 6.7C5 13 5 12.2 5 11.4l-2.7 3.2l4 1.4c-.5-.6-.9-1.4-1.1-2.2M22 19v2H3l5.4-5.5c-1.9-2-1.9-5.1 0-7.1c1.9-1.9 5.1-1.9 7 0l3-3l1.4 1.4L7.7 19H22Z"/>'
        },
        "sun-angle-outline": {
            body: '<path fill="currentColor" d="M13.8 5.2C13 5 12.2 5 11.4 5l3.2-2.7l1.4 4c-.7-.5-1.4-.8-2.2-1.1M7 7.1c.6-.6 1.3-1.1 2-1.4l-4.1-.8l.7 4.1c.4-.7.8-1.4 1.4-1.9m-1.8 6.7C5 13 5 12.2 5 11.4l-2.7 3.2l4 1.4c-.5-.6-.9-1.4-1.1-2.2M22 19v2H3l5.4-5.5c-1.9-2-1.9-5.1 0-7.1c1.9-1.9 5.1-1.9 7 0l3-3l1.4 1.4L7.7 19H22M9.8 14.1L14 9.8c-1.2-1.1-3-1.1-4.2 0c-1.1 1.2-1.1 3.1 0 4.3Z"/>'
        },
        "sun-clock": {
            body: '<path fill="currentColor" d="M18.1 9.3L19.6 6l-4.1-.4c.6.5 1.1 1.1 1.5 1.9c.3.6.5 1.1.7 1.7c-.5-.1-1.1-.2-1.7-.2h-.4c-.8-1.8-2.5-3-4.6-3c-2.8 0-5 2.2-5 5c0 2.1 1.2 3.8 3 4.6v.4c0 3.9 3.1 7 7 7s7-3.1 7-7c0-3.1-2.1-5.8-4.9-6.7M16 21c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m.5-4.8l2.9 1.7l-.8 1.2L15 17v-5h1.5v4.2M11 4c-.8 0-1.6.2-2.4.4L11 1l2.4 3.4c-.8-.2-1.6-.4-2.4-.4M4.9 14.5c.4.7 1 1.4 1.6 1.9L2.4 16l1.8-3.8c.1.8.3 1.6.7 2.3m-.8-4.7L2.3 6l4.2-.3c-.6.5-1.1 1.1-1.6 1.8c-.4.7-.7 1.5-.8 2.3Z"/>'
        },
        "sun-clock-outline": {
            body: '<path fill="currentColor" d="M18.1 9.32L19.65 6l-4.15-.36c.6.51 1.13 1.14 1.55 1.86c.32.55.53 1.13.68 1.72C17.18 9.08 16.6 9 16 9h-.42A5.01 5.01 0 0 0 11 6c-2.76 0-5 2.24-5 5a5.01 5.01 0 0 0 3 4.58V16c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.13-2.06-5.79-4.9-6.68M8 11c0-1.65 1.35-3 3-3c1.08 0 2.03.58 2.56 1.45c-1.9.7-3.41 2.21-4.11 4.11A2.999 2.999 0 0 1 8 11m8 10c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m.5-4.75l2.86 1.69l-.75 1.22L15 17v-5h1.5v4.25M11 4c-.84 0-1.65.15-2.39.42L11 1l2.39 3.42C12.65 4.15 11.84 4 11 4M4.95 14.5c.42.74.96 1.36 1.55 1.87L2.36 16l1.76-3.77c.14.77.41 1.55.83 2.27m-.84-4.71L2.34 6l4.16-.35A7.2 7.2 0 0 0 4.94 7.5c-.44.74-.69 1.5-.83 2.29Z"/>'
        },
        "sun-compass": {
            body: '<path fill="currentColor" d="M9.7 4.3L12 1l2.3 3.3c-.7-.2-1.5-.3-2.3-.3s-1.6.1-2.3.3m7.8 1.9c1.1 1.1 2 2.5 2.3 4.1l1.7-3.7l-4-.4M5 8.1c.1-.1.1-.1 0 0c.1-.1.1-.1.1-.2c.4-.6.9-1.2 1.4-1.7l-4 .3l1.7 3.7c.2-.7.5-1.5.8-2.1m14.2 7.3s0 .1 0 0c-.1.2-.2.4-.3.5v.2c-.4.7-.9 1.2-1.4 1.8l4.1-.3l-1.7-3.7c-.2.5-.4 1-.7 1.5m-14 .8c0-.1-.1-.1-.1-.2c-.1-.1-.1-.1-.1-.2c-.1-.2-.2-.3-.2-.5c-.2-.5-.4-1-.5-1.5l-1.7 3.7l4.1.3c-.7-.5-1.1-1-1.5-1.6m7.4 3.8h-1.2c-.6 0-1.2-.2-1.7-.3L12 23l2.3-3.3c-.5.1-1.1.2-1.7.3m3.6-12.2c-2.3-2.3-6.1-2.3-8.5 0s-2.3 6.1 0 8.5s6.1 2.3 8.5 0s2.4-6.2 0-8.5m-7.7 7.7l2.1-4.9l5-2.2l-2.1 4.9l-5 2.2m4.2-2.8c-.4.4-1 .4-1.4 0c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0c.4.4.4 1 0 1.4Z"/>'
        },
        "sun-snowflake": {
            body: '<path fill="currentColor" d="M12 .69L8.69 4H4v4.69L.69 12L4 15.31V20h4.69L12 23.31l1-1v-4.48l3.24 3.24l1.42-1.41L13 15v-2h2l4.66 4.66l1.41-1.42L17.83 13H22v-2h-4.17l3.24-3.24l-1.41-1.42L15 11h-2V9l4.66-4.66l-1.42-1.41L13 6.17V1.69m-2 4.4v2.04c-1.76.46-3 2.05-3 3.87a4.01 4.01 0 0 0 3 3.87v2.04A6 6 0 0 1 6 12c0-2.93 2.11-5.43 5-5.91Z"/>'
        },
        "sun-snowflake-variant": {
            body: '<path fill="currentColor" d="m12.92 1.58l-1.74 1l1.21 2.09l-.59 2.18L9 7.6L7.38 6l.04-2.41H5.43v1.83H3.59l.01 2H6l1.65 1.61l-.75 2.79l-2.22.58l-2.09-1.2l-1 1.73l1.58.91l-.91 1.58l1.74 1l1.19-2.09l2.23-.58l.5.51l1.4-1.4l-.54-.54l.75-2.78l2.79-.76l.53.54l1.41-1.41l-.53-.54l.59-2.18L16.41 4l-1-1.75l-1.58.91l-.91-1.58M20.72 4L4 20.72L5.27 22l4.89-4.89a4.99 4.99 0 0 0 7.67-2.82c.39-1.43.1-2.93-.72-4.13L22 5.27L20.72 4m-1.98 5c.44.63.79 1.38 1.01 2.19c.22.81.28 1.62.21 2.42l2.69-3.2L18.74 9m.58 6.95c-.32.72-.82 1.4-1.39 1.99c-.59.59-1.27 1.06-1.97 1.4l4.09.72l-.73-4.11M9 18.71l1.41 3.95l3.18-2.71c-.78.05-1.59.02-2.4-.19c-.83-.22-1.57-.59-2.19-1.05Z"/>'
        },
        "sun-thermometer": {
            body: '<path fill="currentColor" d="M10 2L7.6 5.4C8.4 5.2 9.2 5 10 5c.8 0 1.6.2 2.4.4M19 5c-1.11 0-2 .89-2 2v6.76c-.64.57-1 1.39-1 2.24c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.85-.36-1.67-1-2.23V7c0-1.11-.89-2-2-2m0 1c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1m-13.5.7L1.3 7l1.8 3.8c.1-.8.4-1.6.8-2.3c.5-.7 1-1.3 1.6-1.8M10 7c-2.8 0-5 2.2-5 5s2.2 5 5 5s5-2.2 5-5s-2.2-5-5-5m-6.8 6.2L1.4 17l4.1.4c-.5-.5-1.1-1.2-1.5-1.9c-.5-.7-.7-1.5-.8-2.3m4.4 5.4L10 22l2.4-3.4c-.8.2-1.6.4-2.4.4c-.9 0-1.7-.2-2.4-.4Z"/>'
        },
        "sun-thermometer-outline": {
            body: '<path fill="currentColor" d="M10 2L7.6 5.4C8.4 5.2 9.2 5 10 5s1.6.2 2.4.4L10 2m11 11.8V7c0-1.1-.9-2-2-2s-2 .9-2 2v6.8c-.6.6-1 1.4-1 2.2c0 1.7 1.3 3 3 3s3-1.3 3-3c0-.9-.4-1.7-1-2.2M20 8h-2V7c0-.6.4-1 1-1s1 .4 1 1v1M5.5 6.7L1.3 7l1.8 3.8c.1-.8.4-1.6.8-2.3c.5-.7 1-1.3 1.6-1.8M10 7c-2.8 0-5 2.2-5 5s2.2 5 5 5s5-2.2 5-5s-2.2-5-5-5m0 8c-1.7 0-3-1.3-3-3s1.3-3 3-3s3 1.3 3 3s-1.3 3-3 3m-6.8-1.8L1.4 17l4.1.4c-.5-.5-1.1-1.2-1.5-1.9c-.5-.7-.7-1.5-.8-2.3m4.4 5.4L10 22l2.4-3.4c-.8.2-1.6.4-2.4.4c-.9 0-1.7-.2-2.4-.4Z"/>'
        },
        "sun-wireless": {
            body: '<path fill="currentColor" d="M11 6c2.76 0 5 2.24 5 5s-2.24 5-5 5s-5-2.24-5-5s2.24-5 5-5m0-5l2.39 3.42C12.65 4.15 11.84 4 11 4s-1.65.15-2.39.42L11 1M2.34 6l4.16-.35A7.2 7.2 0 0 0 4.94 7.5c-.44.74-.69 1.5-.83 2.29L2.34 6m.02 10l1.76-3.77a7.131 7.131 0 0 0 2.38 4.14L2.36 16M19.65 6l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36M23 13h-2c0 2.05-.78 4.1-2.34 5.66A7.955 7.955 0 0 1 13 21v2c2.56 0 5.12-1 7.07-2.93S23 15.56 23 13m-4 0h-2c0 1-.39 2.05-1.17 2.83C15.05 16.61 14 17 13 17v2a5.989 5.989 0 0 0 6-6"/>'
        },
        "sun-wireless-outline": {
            body: '<path fill="currentColor" d="m11 1l2.39 3.42C12.65 4.15 11.84 4 11 4s-1.65.15-2.39.42L11 1M2.34 6l4.16-.35A7.2 7.2 0 0 0 4.94 7.5c-.44.74-.69 1.5-.83 2.29L2.34 6m.02 10l1.76-3.77a7.131 7.131 0 0 0 2.38 4.14L2.36 16M19.65 6l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36M23 13h-2c0 2.05-.78 4.1-2.34 5.66A7.955 7.955 0 0 1 13 21v2c2.56 0 5.12-1 7.07-2.93S23 15.56 23 13m-4 0h-2c0 1-.39 2.05-1.17 2.83C15.05 16.61 14 17 13 17v2a5.989 5.989 0 0 0 6-6m-8-5c1.65 0 3 1.35 3 3s-1.35 3-3 3s-3-1.35-3-3s1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5Z"/>'
        },
        sunglasses: {
            body: '<path fill="currentColor" d="M7 17H4C2.38 17 .96 15.74.76 14.14l-.5-2.99C.15 10.3.39 9.5.91 8.92C1.43 8.34 2.19 8 3 8h6c.83 0 1.58.35 2.06.96c.11.15.21.31.29.49c.43-.09.87-.09 1.29 0c.08-.18.18-.34.3-.49C13.41 8.35 14.16 8 15 8h6c.81 0 1.57.34 2.09.92c.51.58.75 1.38.65 2.19l-.51 3.07C23.04 15.74 21.61 17 20 17h-3c-1.56 0-3.08-1.19-3.46-2.7l-.9-2.71c-.38-.28-.91-.28-1.29 0l-.92 2.78C10.07 15.82 8.56 17 7 17Z"/>'
        },
        surfing: {
            body: '<path fill="currentColor" d="M22 23v-2c-1.41.05-2.78-.1-4-1c-1.76 1.25-4.23 1.25-6 0c-1.77 1.25-4.24 1.25-6 0c-1.22.9-2.59 1.05-4 1v2c1.37.05 2.78-.06 4-.75c1.84 1 4.15 1 6 0c1.85 1 4.16 1 6 0c1.22.69 2.63.8 4 .75m-1.5-11.03V9.95c-1.76.01-3.5-.95-4.32-2.54l-.89-1.55c-.29-.46-.74-.75-1.22-.89L8.5 3.94L5 6.38L6.13 8l2.82-1.9l2.02.33l-2.16 1.45C8.21 8.29 7.88 9 8 9.71l.53 3.1C7.12 12.26 3.21 11 3 13.23c.36 2.44 3.07 4.09 5.06 5.59c1.44.47 3-.24 3.94-1.36c1.32 1.7 3.89 2 5.5.54c-.47-.42-1-.85-1.5-1.2v-3.85l-3.81-3l2.25-1.51C15.62 10.59 18 12 20.5 11.97M14 14v1.47c0-.04-2.34-1.31-2.19-1.23l-1.08-.54l-.42-2.62L14 14m5-10.5c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        "surround-sound": {
            body: '<path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M7.76 16.24l-1.41 1.41A7.909 7.909 0 0 1 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41A6.046 6.046 0 0 0 6 12c0 1.54.59 3.07 1.76 4.24M12 16a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4a4 4 0 0 1-4 4m5.66 1.66l-1.41-1.41A6.046 6.046 0 0 0 18 12c0-1.54-.59-3.07-1.76-4.24l1.41-1.41A7.909 7.909 0 0 1 20 12c0 2.05-.78 4.1-2.34 5.66M12 10a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "surround-sound-2-0": {
            body: '<path fill="currentColor" d="M3 7v2h4v2H5c-1.1 0-2 .9-2 2v4h6v-2H5v-2h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H3m10 10h-2v-2h2v2m4-10c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-2m0 2h2v6h-2V9Z"/>'
        },
        "surround-sound-2-1": {
            body: '<path fill="currentColor" d="M4 7v2h4v2H6c-1.1 0-2 .9-2 2v4h6v-2H6v-2h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H4m10 10h-2v-2h2v2m2-10v2h2v8h2V7h-4Z"/>'
        },
        "surround-sound-3-1": {
            body: '<path fill="currentColor" d="M14 17h-2v-2h2v2m6-10v10h-2V9h-2V7h4m-10 8c0 1.1-.9 2-2 2H4v-2h4v-2H6v-2h2V9H4V7h4c1.1 0 2 .9 2 2v1.5c0 .8-.7 1.5-1.5 1.5c.8 0 1.5.7 1.5 1.5V15"/>'
        },
        "surround-sound-5-1": {
            body: '<path fill="currentColor" d="M14 17h-2v-2h2v2m6-10v10h-2V9h-2V7h4M10 7v2H6v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H4v-2h4v-2H4V7h6Z"/>'
        },
        "surround-sound-5-1-2": {
            body: '<path fill="currentColor" d="M18 7v2h4v2h-2c-1.1 0-2 .9-2 2v4h6v-2h-4v-2h2c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-4M9 17H7v-2h2v2M9 7v2h2v8h2V7H9M0 7v6h4v2H0v2h4c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H2V9h4V7H0m17 10h-2v-2h2v2"/>'
        },
        "surround-sound-7-1": {
            body: '<path fill="currentColor" d="M14 17h-2v-2h2v2m6-10v10h-2V9h-2V7h4M4 17l4-8H4V7h6v2l-4 8"/>'
        },
        svg: {
            body: '<path fill="currentColor" d="M5.13 10.71h3.74L6.22 8.06c-1.01 0-1.83-.82-1.83-1.84a1.83 1.83 0 0 1 1.83-1.83c1.02 0 1.84.82 1.84 1.83l2.65 2.65V5.13a1.84 1.84 0 0 1 0-2.59a1.81 1.81 0 0 1 2.58 0c.71.71.71 1.87 0 2.59v3.74l2.66-2.65a1.83 1.83 0 0 1 3.66 0c0 1.02-.82 1.84-1.83 1.84l-2.65 2.65h3.74a1.84 1.84 0 0 1 2.59 0c.72.71.72 1.87 0 2.58c-.71.71-1.87.71-2.59 0h-3.74l2.65 2.66c1.01 0 1.83.81 1.83 1.83a1.83 1.83 0 0 1-1.83 1.83c-1.02 0-1.83-.82-1.83-1.83l-2.66-2.65v3.74c.71.72.71 1.88 0 2.59c-.71.72-1.87.72-2.58 0a1.84 1.84 0 0 1 0-2.59v-3.74l-2.65 2.65c0 1.01-.82 1.83-1.84 1.83a1.83 1.83 0 0 1 0-3.66l2.65-2.66H5.13c-.72.71-1.88.71-2.59 0a1.81 1.81 0 0 1 0-2.58a1.84 1.84 0 0 1 2.59 0Z"/>'
        },
        "swap-horizontal": {
            body: '<path fill="currentColor" d="m21 9l-4-4v3h-7v2h7v3M7 11l-4 4l4 4v-3h7v-2H7v-3Z"/>'
        },
        "swap-horizontal-bold": {
            body: '<path fill="currentColor" d="M8 10v3h6v5H8v3l-6-5.5L8 10m14-1.5L16 3v3h-6v5h6v3l6-5.5Z"/>'
        },
        "swap-horizontal-circle": {
            body: '<path fill="currentColor" d="M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10s10-4.5 10-10m-7-5.5l3.5 3.5l-3.5 3.5V11h-4V9h4V6.5m-6 11L5.5 14L9 10.5V13h4v2H9v2.5Z"/>'
        },
        "swap-horizontal-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m3-13.5V9h-4v2h4v2.5l3.5-3.5L15 6.5m-6 4L5.5 14L9 17.5V15h4v-2H9v-2.5Z"/>'
        },
        "swap-horizontal-variant": {
            body: '<path fill="currentColor" d="m4 6l4 4V7h8a2 2 0 0 1 2 2a2 2 0 0 1-2 2H8a4 4 0 0 0-4 4a4 4 0 0 0 4 4h8v3l4-4l-4-4v3H8a2 2 0 0 1-2-2a2 2 0 0 1 2-2h8a4 4 0 0 0 4-4a4 4 0 0 0-4-4H8V2L4 6Z"/>'
        },
        "swap-vertical": {
            body: '<path fill="currentColor" d="M9 3L5 7h3v7h2V7h3m3 10v-7h-2v7h-3l4 4l4-4h-3Z"/>'
        },
        "swap-vertical-bold": {
            body: '<path fill="currentColor" d="M14 8h-3v6H6V8H3l5.5-6L14 8m1.5 14l5.5-6h-3v-6h-5v6h-3l5.5 6Z"/>'
        },
        "swap-vertical-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2M6.5 9L10 5.5L13.5 9H11v4H9V9H6.5m11 6L14 18.5L10.5 15H13v-4h2v4h2.5Z"/>'
        },
        "swap-vertical-circle-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8M6.5 9L10 5.5L13.5 9H11v4H9V9H6.5m11 6L14 18.5L10.5 15H13v-4h2v4h2.5Z"/>'
        },
        "swap-vertical-variant": {
            body: '<path fill="currentColor" d="m18 4l-4 4h3v8a2 2 0 0 1-2 2a2 2 0 0 1-2-2V8a4 4 0 0 0-4-4a4 4 0 0 0-4 4v8H2l4 4l4-4H7V8a2 2 0 0 1 2-2a2 2 0 0 1 2 2v8a4 4 0 0 0 4 4a4 4 0 0 0 4-4V8h3l-4-4Z"/>'
        },
        swim: {
            body: '<path fill="currentColor" d="M2 18c2.22-1 4.44-2 6.67-2c2.22 0 4.44 2 6.66 2c2.23 0 4.45-2 6.67-2v3c-2.22 0-4.44 2-6.67 2c-2.22 0-4.44-2-6.66-2c-2.23 0-4.45 1-6.67 2v-3m6.67-5c-.78 0-1.55.12-2.32.32l4.92-3.44l-1.04-1.24c-.14-.17-.23-.4-.23-.64c0-.34.17-.65.44-.83l5.72-4l1.15 1.63l-4.84 3.39l5.23 6.23c-.79.33-1.58.58-2.37.58c-2.22 0-4.44-2-6.66-2M18 7a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        switch: {
            body: '<path fill="currentColor" d="M13 18h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H8a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-3v2m0-12h1V4h-1v2M9 4v2h2V4H9m0 4v2h2V8H9m0 4v2h2v-2H9Z"/>'
        },
        sword: {
            body: '<path fill="currentColor" d="M6.92 5H5l9 9l1-.94m4.96 6.06l-.84.84a.996.996 0 0 1-1.41 0l-3.12-3.12l-2.68 2.66l-1.41-1.41l1.42-1.42L3 7.75V3h4.75l8.92 8.92l1.42-1.42l1.41 1.41l-2.67 2.67l3.12 3.12c.4.4.4 1.03.01 1.42Z"/>'
        },
        "sword-cross": {
            body: '<path fill="currentColor" d="m6.2 2.44l11.9 11.9l2.12-2.12l1.41 1.41l-2.47 2.47l3.18 3.18c.39.39.39 1.02 0 1.41l-.71.71a.996.996 0 0 1-1.41 0L17 18.23l-2.44 2.47l-1.41-1.41l2.12-2.12l-11.9-11.9V2.44H6.2M15.89 10l4.74-4.74V2.44H17.8l-4.74 4.74L15.89 10m-4.95 5l-2.83-2.87l-2.21 2.21l-2.12-2.12l-1.41 1.41l2.47 2.47l-3.18 3.19a.996.996 0 0 0 0 1.41l.71.71c.39.39 1.02.39 1.41 0L7 18.23l2.44 2.47l1.41-1.41l-2.12-2.12L10.94 15Z"/>'
        },
        "syllabary-hangul": {
            body: '<path fill="currentColor" d="M8 4v2H4v2h2.39C5.55 8.74 5 9.8 5 11c0 2.2 1.8 4 4 4s4-1.8 4-4c0-1.2-.55-2.26-1.39-3H14V6h-4V4m5 0v12h2v-5h3V9h-3V4M9 9c1.12 0 2 .88 2 2s-.88 2-2 2s-2-.88-2-2s.88-2 2-2m-2 7v4h10v-2H9v-2Z"/>'
        },
        "syllabary-hiragana": {
            body: '<path fill="currentColor" d="M9 4v2H6v2h3v2c-2.75 0-5 2.27-5 5.03a5.04 5.04 0 0 0 5.03 5.03c.86 0 1.69-.29 2.37-.8c.23.28.48.56.75.83l1.41-1.42c-.26-.25-.49-.52-.7-.78l1-1c1.07-1.07 1.92-2.66 2.56-4.3c.89.52 1.58 1.31 1.58 2.41c0 1.32-.53 2.6-1.46 3.54l1.41 1.41A7.001 7.001 0 0 0 20 15c0-1.96-1.18-3.64-2.85-4.45l.35-1.26l-1.95-.51l-.34 1.27c-.08 0-.15-.05-.24-.05H11V8h5V6h-5V4m0 8h3.5c-.56 1.37-1.31 2.72-2.06 3.47l-.65.66c-.54-1.2-.79-2.54-.79-4.13m-2 0c0 2.07.41 3.94 1.3 5.59c-.36.3-.8.47-1.27.47c-1.7 0-3.03-1.33-3.03-3.03C6 13.34 7.32 12 9 12Z"/>'
        },
        "syllabary-katakana": {
            body: '<path fill="currentColor" d="M4 4v2h14v.09l-3.71 3.7l1.42 1.42L20 6.91V4m-9 5v4c0 2.78-.75 3.89-2.64 5.46L9.64 20c2.11-1.76 3.36-3.78 3.36-7V9Z"/>'
        },
        "syllabary-katakana-halfwidth": {
            body: '<path fill="currentColor" d="M8 4v2h6l-1 4.81l2 .39l1-5.1V4m-6 5v3c0 2.86-.66 5.29-1.92 6.61L9.5 20c1.85-1.92 2.5-4.85 2.5-8V9Z"/>'
        },
        symbol: {
            body: '<path fill="currentColor" d="M2 7v7h2V7H2m4 0v2h4v2H8v3h2v-1c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2H6m9.8 0l-.2 2H14v2h1.4l-.2 2H14v2h1l-.2 2h2l.2-2h1.4l-.2 2h2l.2-2H22v-2h-1.4l.2-2H22V9h-1l.2-2h-2L19 9h-1.4l.2-2h-2m1.6 4h1.4l-.2 2h-1.4l.2-2M2 15v2h2v-2H2m6 0v2h2v-2H8Z"/>'
        },
        symfony: {
            body: '<path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m4.37 3.7c1.02-.03 1.78.43 1.84 1.14c.01.31-.17.91-.79.93c-.47.02-.79-.27-.8-.68c-.01-.16.26-.67.26-.76c-.01-.27-.41-.28-.52-.27c-1.5.05-1.9 2.07-2.22 3.72l-.14.87c.84.13 1.46-.03 1.8-.25c.48-.31-.14-.63-.06-.99c.08-.37.41-.54.67-.55c.37-.01.63.37.62.76c-.03.64-.86 1.52-2.53 1.48c-.22 0-.41-.02-.59-.04c-.61 3.1-.99 4.94-2.35 6.52c-1.17 1.39-2.36 1.6-2.89 1.62c-1 .04-1.67-.49-1.67-1.2c-.03-.68.57-1.06.97-1.07c.53-.02.9.37.91.81c.02.37-.18.49-.31.56c-.07.07-.22.15-.21.3c0 .07.07.22.29.21c.42-.01.69-.22.89-.36c.96-.8 1.34-2.21 1.83-4.77c.26-1.45.45-2.38.73-3.3c-.68-.51-1.1-1.15-2.01-1.38c-.63-.19-1.01-.04-1.28.3c-.31.41-.21.93.09 1.24c1.15 1.28 1.49 1.84 1.36 2.6c-.2 1.21-1.64 2.13-3.34 1.61c-1.45-.45-1.72-1.47-1.55-2.04c.16-.49.55-.59.94-.47c.42.13.58.63.46 1.02c-.02.04-.22.41-.27.53c-.09.31.33.52.62.61c.65.2 1.28-.14 1.43-.67c.15-.48-.15-.82-.28-.95c-.89-.98-1.51-1.85-1.21-2.83c.12-.37.36-.77.72-1.04c.75-.55 1.57-.65 2.34-.41c1.01.27 1.49.94 2.12 1.45c.35-1.02.84-2.03 1.57-2.88c.66-.77 1.54-1.33 2.56-1.37Z"/>'
        },
        synagogue: {
            body: '<path fill="currentColor" d="M6 8v13h4v-5c0-1.1.9-2 2-2s2 .9 2 2v5h4V8l-6-5l-6 5m7.5 2c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5M3 5c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2M1 9h4v12H1V9m20-4c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2m-2 4h4v12h-4V9Z"/>'
        },
        "synagogue-outline": {
            body: '<path fill="currentColor" d="M20 4c-1.7 0-3 1.3-3 3v.3L12 3L7 7.3V7c0-1.7-1.3-3-3-3S1 5.3 1 7v14h10v-5c0-.6.4-1 1-1s1 .4 1 1v5h10V7c0-1.7-1.3-3-3-3m0 2c.5 0 1 .4 1 1v1h-2V7c0-.6.5-1 1-1M4 6c.6 0 1 .4 1 1v1H3V7c0-.6.5-1 1-1M3 19v-9h2v9H3m14 0h-2v-3c0-1.6-1.4-3-3-3s-3 1.4-3 3v3H7V9.9l5-4.3l5 4.3V19m2 0v-9h2v9h-2M12 8.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        sync: {
            body: '<path fill="currentColor" d="M12 18a6 6 0 0 1-6-6c0-1 .25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12a8 8 0 0 0 8 8v3l4-4l-4-4m0-11V1L8 5l4 4V6a6 6 0 0 1 6 6c0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12a8 8 0 0 0-8-8Z"/>'
        },
        "sync-alert": {
            body: '<path fill="currentColor" d="M11 13h2V7h-2m10-3h-6v6l2.24-2.24A6.003 6.003 0 0 1 19 12a5.99 5.99 0 0 1-4 5.65v2.09c3.45-.89 6-4.01 6-7.74c0-2.21-.91-4.2-2.36-5.64M11 17h2v-2h-2m-8-3c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 5 12a5.99 5.99 0 0 1 4-5.65V4.26C5.55 5.15 3 8.27 3 12Z"/>'
        },
        "sync-circle": {
            body: '<path fill="currentColor" d="M2 12A10 10 0 1 0 12 2A10 10 0 0 0 2 12m13.6 1.72A4 4 0 0 0 16 12a4 4 0 0 0-4-4v2L8.88 7L12 4v2a6 6 0 0 1 6 6a5.9 5.9 0 0 1-.93 3.19M6 12a5.9 5.9 0 0 1 .93-3.19l1.47 1.47A4 4 0 0 0 8 12a4 4 0 0 0 4 4v-2l3 3l-3 3v-2a6 6 0 0 1-6-6Z"/>'
        },
        "sync-off": {
            body: '<path fill="currentColor" d="M20 4h-6v6l2.24-2.24A6.003 6.003 0 0 1 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 0 0-1.14-9.87L20 4M2.86 5.41l2.36 2.36a7.925 7.925 0 0 0 1.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.26.13-.5.25-.76.34v2.09c.79-.21 1.54-.54 2.22-.96l2.36 2.36l1.27-1.27L4.14 4.14L2.86 5.41m7.14.94V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.27-.12.5-.24.77-.33Z"/>'
        },
        tab: {
            body: '<path fill="currentColor" d="M21 3H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H3V5h10v4h8v10Z"/>'
        },
        "tab-minus": {
            body: '<path fill="currentColor" d="M3 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3m0 2h10v4h8v10H3V5m4 8v2h8v-2H7Z"/>'
        },
        "tab-plus": {
            body: '<path fill="currentColor" d="M3 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3m0 2h10v4h8v10H3V5m7 5v3H7v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "tab-remove": {
            body: '<path fill="currentColor" d="m7.46 11.88l1.42-1.42L11 12.59l2.12-2.13l1.42 1.42L12.41 14l2.13 2.12l-1.42 1.42L11 15.41l-2.12 2.13l-1.42-1.42L9.59 14l-2.13-2.12M3 3h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v14h18V9h-8V5H3Z"/>'
        },
        "tab-search": {
            body: '<path fill="currentColor" d="M7.5 11C5 11 3 13 3 15.5c0 .88.25 1.71.69 2.4L.61 21L2 22.39l3.12-3.07c.69.43 1.51.68 2.38.68c2.5 0 4.5-2 4.5-4.5S10 11 7.5 11m0 7a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5M23 5v14c0 1.11-.89 2-2 2H10.95c.81-.5 1.5-1.19 2.02-2H21V9h-8V5H3v5.82C1.77 12 1 13.66 1 15.5V5c0-1.1.9-2 2-2h18a2 2 0 0 1 2 2Z"/>'
        },
        "tab-unselected": {
            body: '<path fill="currentColor" d="M1 9h2V7H1v2m0 4h2v-2H1v2m0-8h2V3a2 2 0 0 0-2 2m8 16h2v-2H9v2m-8-4h2v-2H1v2m2 4v-2H1a2 2 0 0 0 2 2M21 3h-8v6h10V5a2 2 0 0 0-2-2m0 14h2v-2h-2v2M9 5h2V3H9v2M5 21h2v-2H5v2M5 5h2V3H5v2m16 16a2 2 0 0 0 2-2h-2v2m0-8h2v-2h-2v2m-8 8h2v-2h-2v2m4 0h2v-2h-2v2Z"/>'
        },
        table: {
            body: '<path fill="currentColor" d="M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 4v4h6V8H5m8 0v4h6V8h-6m-8 6v4h6v-4H5m8 0v4h6v-4h-6Z"/>'
        },
        "table-account": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m19 9v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8c-1.1 0-2 .9-2 2s.9 2 2 2s2-.89 2-2s-.89-2-2-2Z"/>'
        },
        "table-alert": {
            body: '<path fill="currentColor" d="M3 4h14c1.11 0 2 .89 2 2v12c0 1.11-.89 2-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 4v4h6V8H3m8 0v4h6V8h-6m-8 6v4h6v-4H3m8 0v4h6v-4h-6m12-7h-2v6h2V7m0 8h-2v2h2v-2Z"/>'
        },
        "table-arrow-down": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m11.94 5.5h2v-4h2v4h2l-3 3l-3-3"/>'
        },
        "table-arrow-left": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m14.44 2v2h4v2h-4v2l-3-3l3-3"/>'
        },
        "table-arrow-right": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m15.44 8v-2h-4v-2h4v-2l3 3l-3 3"/>'
        },
        "table-arrow-up": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m17.94 4.5h-2v4h-2v-4h-2l3-3l3 3"/>'
        },
        "table-border": {
            body: '<path fill="currentColor" d="M21 19a1 1 0 0 1-1 1h-1v-2h2v1m-6 1v-2h2v2h-2m-4 0v-2h2v2h-2m-4 0v-2h2v2H7m-3 0a1 1 0 0 1-1-1v-1h2v2H4M19 4H5a2 2 0 0 0-2 2v2h18V6c0-1.11-.89-2-2-2M5 14H3v2h2v-2m0-4H3v2h2v-2m16 0h-2v2h2v-2m0 4h-2v2h2v-2m-10 2v-2h2v2h-2m0-4v-2h2v2h-2"/>'
        },
        "table-cancel": {
            body: '<path fill="currentColor" d="M3 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H11v4h1.08c-.11.68-.11 1.35 0 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H3m8 0v4h6V7h-6m-8 6v4h6v-4H3m15.5 1C16 14 14 16 14 18.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m0 7.5c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5L20 21.08c-.42.27-.94.42-1.5.42m2.58-1.5L17 15.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5Z"/>'
        },
        "table-chair": {
            body: '<path fill="currentColor" d="M12 22H6a2 2 0 0 1 2-2V8H2V5h14v3h-6v12a2 2 0 0 1 2 2M22 2v20h-2v-7h-5v7h-2v-8a2 2 0 0 1 2-2h5V2Z"/>'
        },
        "table-check": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m13.75 8L15 18l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41L17.75 21"/>'
        },
        "table-clock": {
            body: '<path fill="currentColor" d="m16.5 15.82l2.44 1.41l-.75 1.3L15 16.69V13h1.5v2.82m3.5-5.56V5a2 2 0 0 0-2-2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h5.68c1.13 2.36 3.53 4 6.32 4c3.87 0 7-3.13 7-7c0-2.38-1.19-4.47-3-5.74M18 7v2.29c-.63-.18-1.3-.29-2-.29c-1.5 0-2.87.47-4 1.26V7h6M4 7h6v4H4V7m0 10v-4h5.68A7.02 7.02 0 0 0 9 16c0 .34.03.67.08 1H4m12 4c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5Z"/>'
        },
        "table-cog": {
            body: '<path fill="currentColor" d="M3 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H11v4h1.08c-.11.68-.11 1.35 0 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H3m8 0v4h6V7h-6m-8 6v4h6v-4H3m19.78 6.32l-1.07-.82c.02-.17.04-.33.04-.5s-.01-.33-.04-.5l1.06-.82a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.13-.19-.13-.33-.13l-1.22.5c-.28-.18-.54-.35-.85-.47l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.47l-1.24-.5c-.11 0-.24 0-.31.13l-1 1.73c-.06.11-.04.24.06.32l1.06.82a4.193 4.193 0 0 0 0 1l-1.06.82a.26.26 0 0 0-.06.32l1 1.73c.06.13.19.13.31.13l1.24-.5c.26.18.54.35.85.47l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.56-.29.84-.47l1.22.5c.14 0 .27 0 .34-.13l1-1.73a.26.26 0 0 0-.06-.32M18 19.5c-.83 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5s1.5.67 1.5 1.5s-.66 1.5-1.5 1.5Z"/>'
        },
        "table-column": {
            body: '<path fill="currentColor" d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 8v4h8v-4H8m0 6v4h8v-4H8M8 4v4h8V4H8Z"/>'
        },
        "table-column-plus-after": {
            body: '<path fill="currentColor" d="M11 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2V2h9m-7 8v4h7v-4H4m0 6v4h7v-4H4M4 4v4h7V4H4m11 7h3V8h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "table-column-plus-before": {
            body: '<path fill="currentColor" d="M13 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h9V2h-9m7 8v4h-7v-4h7m0 6v4h-7v-4h7m0-12v4h-7V4h7M9 11H6V8H4v3H1v2h3v3h2v-3h3v-2Z"/>'
        },
        "table-column-remove": {
            body: '<path fill="currentColor" d="M4 2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 8v4h7v-4H4m0 6v4h7v-4H4M4 4v4h7V4H4m13.59 8L15 9.41L16.41 8L19 10.59L21.59 8L23 9.41L20.41 12L23 14.59L21.59 16L19 13.41L16.41 16L15 14.59L17.59 12Z"/>'
        },
        "table-column-width": {
            body: '<path fill="currentColor" d="M5 8h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m0 4v3h6v-3H5m8 0v3h6v-3h-6m-8 5v3h6v-3H5m8 0v3h6v-3h-6M11 2h10v4h-2V4h-6v2h-2V2Z"/>'
        },
        "table-edit": {
            body: '<path fill="currentColor" d="m21.7 13.35l-1 1l-2.05-2.05l1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M12 18.94l6.07-6.06l2.05 2.05L14.06 21H12v-2.06M4 2h14a2 2 0 0 1 2 2v4.17L16.17 12H12v4.17L10.17 18H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 4v4h6V6H4m8 0v4h6V6h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-eye": {
            body: '<path fill="currentColor" d="M17 16.88c.56 0 1 .44 1 1s-.44 1-1 1s-1-.45-1-1s.44-1 1-1m0-3c2.73 0 5.06 1.66 6 4c-.94 2.34-3.27 4-6 4s-5.06-1.66-6-4c.94-2.34 3.27-4 6-4m0 1.5a2.5 2.5 0 0 0 0 5a2.5 2.5 0 0 0 0-5M18 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5.42c-.16-.32-.3-.66-.42-1c.12-.34.26-.68.42-1H4v-4h6v2.97c.55-.86 1.23-1.6 2-2.21V13h1.15c1.16-.64 2.47-1 3.85-1c1.06 0 2.07.21 3 .59V5c0-1.1-.9-2-2-2m-8 8H4V7h6v4m8 0h-6V7h6v4Z"/>'
        },
        "table-eye-off": {
            body: '<path fill="currentColor" d="M12 8.8L6.2 3H18c1.1 0 2 .9 2 2v7.59c-.93-.38-1.94-.59-3-.59c-.55 0-1.09.07-1.62.18L14.2 11H18V7h-6v1.8m5.09 5.09l5.22 5.22c.27-.38.51-.79.69-1.23c-.93-2.31-3.22-3.96-5.91-3.99m5.02 7.57l-1.27 1.27l-1.34-1.36c-.79.32-1.62.51-2.5.51c-2.73 0-5.06-1.66-6-4a6.344 6.344 0 0 1 2.21-2.78l-1.28-1.28c-.74.6-1.4 1.32-1.93 2.15V13H4v4h5.42c-.16.32-.3.66-.42 1c.12.34.26.68.42 1H4c-1.1 0-2-.9-2-2V5c0-.32.08-.62.22-.89L1.11 3l1.28-1.27l19.72 19.73M9.11 11l-4-4H4v4h5.11m9.07 9.07l-3.37-3.37c-.2.35-.31.75-.31 1.18a2.5 2.5 0 0 0 2.5 2.5c.43 0 .83-.11 1.18-.31Z"/>'
        },
        "table-filter": {
            body: '<path fill="currentColor" d="m17 21l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3m-5-10h8V3a2 2 0 0 0-2-2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h9.42L12 15v-4m0-6h6v4h-6V5m-2 10H4v-4h6v4m0-6H4V5h6v4Z"/>'
        },
        "table-furniture": {
            body: '<path fill="currentColor" d="M2 7h20v3h-2l1 9h-2.5l-.56-5H6.06l-.56 5H3l1-9H2V7m15.5 3h-11l-.21 2h11.42l-.21-2Z"/>'
        },
        "table-headers-eye": {
            body: '<path fill="currentColor" d="M1 6v13a2 2 0 0 0 2 2h6V11h12V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2m2 0h4v3H3m4 10H3v-3h4m0-2H3v-3h4m2-2V6h4v3m6 0h-4V6h4m-2 10a1 1 0 1 1-1 1a1 1 0 0 1 1-1m0-3a6.45 6.45 0 0 1 6 4a6.5 6.5 0 0 1-12 0a6.45 6.45 0 0 1 6-4m0 1.5a2.5 2.5 0 1 0 2.5 2.5a2.5 2.5 0 0 0-2.5-2.5"/>'
        },
        "table-headers-eye-off": {
            body: '<path fill="currentColor" d="M2.38 1.73L1.11 3l1.15 1.15A2 2 0 0 0 1 6v13a2 2 0 0 0 2 2h6V11h.11l3.61 3.61A6.21 6.21 0 0 0 11 17a6.45 6.45 0 0 0 6 4a6.55 6.55 0 0 0 1.84-.27l2 2l1.27-1.27l-1.53-1.53M7 19H3v-3h4m0-2H3v-3h4m0-2H3V6h1.11L7 8.89M17 19.5a2.5 2.5 0 0 1-2.44-3.05l3 3a2.5 2.5 0 0 1-.56.05m-.76-6.5l1.61 1.61a2.5 2.5 0 0 1 1.5 1.5l2.59 2.59A6.44 6.44 0 0 0 23 17a6.45 6.45 0 0 0-6-4h-.76M13 6v3h-.8l2 2H21V6a2 2 0 0 0-2-2H7.2l2 2M15 6h4v3h-4Z"/>'
        },
        "table-heart": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m15 9.3l-.6-.5c-2-1.9-3.4-3.1-3.4-4.6c0-1.2 1-2.2 2.2-2.2c.7 0 1.4.3 1.8.8c.4-.5 1.1-.8 1.8-.8c1.2 0 2.2.9 2.2 2.2c0 1.5-1.4 2.7-3.4 4.6l-.6.5"/>'
        },
        "table-key": {
            body: '<path fill="currentColor" d="M16.8 17c-.4-1.2-1.5-2-2.8-2c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H19v2h2v-2h2v-2h-6.2M14 19c-.6 0-1-.5-1-1s.4-1 1-1s1 .5 1 1s-.4 1-1 1m-5-1H4v-4h6v1c.9-1.2 2.4-2 4-2c1.1 0 2.1.4 3 1h1v1h2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5.4c-.3-.6-.4-1.3-.4-2m3-10h6v4h-6V8M4 8h6v4H4V8Z"/>'
        },
        "table-large": {
            body: '<path fill="currentColor" d="M4 3h16a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 4v3h4V7H4m6 0v3h4V7h-4m10 3V7h-4v3h4M4 12v3h4v-3H4m0 8h4v-3H4v3m6-8v3h4v-3h-4m0 8h4v-3h-4v3m10 0v-3h-4v3h4m0-8h-4v3h4v-3Z"/>'
        },
        "table-large-plus": {
            body: '<path fill="currentColor" d="M12.35 20H10v-3h2.09c.12-.72.37-1.39.72-2H10v-3h4v1.54c.58-.54 1.25-.93 2-1.19V12h4v.35c.75.26 1.42.65 2 1.19V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h9.54c-.54-.58-.93-1.25-1.19-2M16 7h4v3h-4V7m-6 0h4v3h-4V7M8 20H4v-3h4v3m0-5H4v-3h4v3m0-5H4V7h4v3m9 4h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3"/>'
        },
        "table-large-remove": {
            body: '<path fill="currentColor" d="M12.35 20H10v-3h2.09c.12-.72.37-1.39.72-2H10v-3h4v1.54c.58-.54 1.25-.93 2-1.19V12h4v.35c.75.26 1.42.65 2 1.19V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h9.54c-.54-.58-.93-1.25-1.19-2M16 7h4v3h-4V7m-6 0h4v3h-4V7M8 20H4v-3h4v3m0-5H4v-3h4v3m0-5H4V7h4v3m6.46 5.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12"/>'
        },
        "table-lock": {
            body: '<path fill="currentColor" d="M21 16v-.5a2.5 2.5 0 0 0-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5m-7 2h-1v-4h2.26c.28-.79.78-1.5 1.43-2H12V8h6v3.05c.17-.02.33-.05.5-.05c.53 0 1.03.1 1.5.26V6c0-1.11-.89-2-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v-2m-3 0H4v-4h6v4m0-6H4V8h6v4Z"/>'
        },
        "table-merge-cells": {
            body: '<path fill="currentColor" d="M5 10H3V4h8v2H5v4m14 8h-6v2h8v-6h-2v4M5 18v-4H3v6h8v-2H5M21 4h-8v2h6v4h2V4M8 13v2l3-3l-3-3v2H3v2h5m8-2V9l-3 3l3 3v-2h5v-2h-5Z"/>'
        },
        "table-minus": {
            body: '<path fill="currentColor" d="M15 19v-2h8v2h-8M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-multiple": {
            body: '<path fill="currentColor" d="M7 2h14a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 4v4h6V6H7m8 0v4h6V6h-6m-8 6v4h6v-4H7m8 0v4h6v-4h-6M3 20V6H1v14c0 1.11.89 2 2 2h16v-2H3Z"/>'
        },
        "table-network": {
            body: '<path fill="currentColor" d="M15 20c0-.55-.45-1-1-1h-1v-2h6c1.11 0 2-.89 2-2V3a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h6v2h-1c-.55 0-1 .45-1 1H2v2h7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1h7v-2h-7M13 5h6v4h-6V5m0 6h6v4h-6v-4M5 5h6v4H5V5m0 10v-4h6v4H5Z"/>'
        },
        "table-of-contents": {
            body: '<path fill="currentColor" d="M3 9h14V7H3v2m0 4h14v-2H3v2m0 4h14v-2H3v2m16 0h2v-2h-2v2m0-10v2h2V7h-2m0 6h2v-2h-2v2Z"/>'
        },
        "table-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l2.11 2.11C3.08 5.38 3 5.68 3 6v12a2 2 0 0 0 2 2h13.11l2.73 2.73l1.27-1.27m-12-9.46H5V8h1.11l4 4m.89 6H5v-4h6v4m2 0v-3.11L16.11 18H13m0-8.2L7.2 4H19c1.11 0 2 .89 2 2v11.8l-2-2V14h-1.8l-2-2H19V8h-6v1.8Z"/>'
        },
        "table-picnic": {
            body: '<path fill="currentColor" d="M4 6h16v3h-2l.22 2H23v2h-4.56l.56 5h-2.5l-.56-5H8.06l-.56 5H5l.56-5H1v-2h4.78L6 9H4m11.5 0h-7l-.21 2h7.42Z"/>'
        },
        "table-pivot": {
            body: '<path fill="currentColor" d="M22 15h-2v3c0 1.11-.89 2-2 2h-3v2l-3-3l3-3v2h3v-3h-2l3-3l3 3m0-11v4c0 1.1-.9 2-2 2H10v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2M4 8h4V4H4v4m0 2v4h4v-4H4m4 10v-4H4v4h4m6-12V4h-4v4h4m6-4h-4v4h4V4Z"/>'
        },
        "table-plus": {
            body: '<path fill="currentColor" d="M18 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-question": {
            body: '<path fill="currentColor" d="M19.5 20.5V22H18v-1.5h1.5m-2-5H16V15c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.01-.91 1.7v.2H18v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5M18 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10v-2h-2v-4h2.42c.36-.8.92-1.5 1.61-2H12V7h6v3.1c.32-.06.66-.1 1-.1s.68.04 1 .1V5a2 2 0 0 0-2-2m-8 14H4v-4h6v4m0-6H4V7h6v4Z"/>'
        },
        "table-refresh": {
            body: '<path fill="currentColor" d="M18 14.5c1.11 0 2.11.45 2.83 1.17L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4M4 3h14a2 2 0 0 1 2 2v7.17c-.5-.11-1-.17-1.5-.17c-1.27 0-2.46.37-3.46 1H12v4h.18c-.12.5-.18 1-.18 1.5v.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-remove": {
            body: '<path fill="currentColor" d="m15.46 15.88l1.42-1.42L19 16.59l2.12-2.13l1.42 1.42L20.41 18l2.13 2.12l-1.42 1.42L19 19.41l-2.12 2.13l-1.42-1.42L17.59 18l-2.13-2.12M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-row": {
            body: '<path fill="currentColor" d="M22 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4M4 14h4v-4H4v4m6 0h4v-4h-4v4m6 0h4v-4h-4v4Z"/>'
        },
        "table-row-height": {
            body: '<path fill="currentColor" d="M3 5h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m0 4v3h5V9H3m7 0v3h5V9h-5m-7 5v3h5v-3H3m7 0v3h5v-3h-5m13 0V7h-4v2h2v3h-2v2h4Z"/>'
        },
        "table-row-plus-after": {
            body: '<path fill="currentColor" d="M22 10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h2v2h4V3h2v2h4V3h2v2h4V3h2v7M4 10h4V7H4v3m6 0h4V7h-4v3m10 0V7h-4v3h4m-9 4h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z"/>'
        },
        "table-row-plus-before": {
            body: '<path fill="currentColor" d="M22 14a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7h2v-2h4v2h2v-2h4v2h2v-2h4v2h2v-7M4 14h4v3H4v-3m6 0h4v3h-4v-3m10 0v3h-4v-3h4m-9-4h2V7h3V5h-3V2h-2v3H8v2h3v3Z"/>'
        },
        "table-row-remove": {
            body: '<path fill="currentColor" d="M9.41 13L12 15.59L14.59 13L16 14.41L13.41 17L16 19.59L14.59 21L12 18.41L9.41 21L8 19.59L10.59 17L8 14.41L9.41 13M22 9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3M4 9h4V6H4v3m6 0h4V6h-4v3m6 0h4V6h-4v3Z"/>'
        },
        "table-search": {
            body: '<path fill="currentColor" d="M19.3 17.89c1.32-2.1.7-4.89-1.41-6.21a4.52 4.52 0 0 0-6.21 1.41C10.36 15.2 11 18 13.09 19.3c1.47.92 3.33.92 4.8 0L21 22.39L22.39 21l-3.09-3.11m-2-.62c-.98.98-2.56.97-3.54 0c-.97-.98-.97-2.56.01-3.54c.97-.97 2.55-.97 3.53 0c.96.99.95 2.57-.03 3.54h.03M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5.81a6.3 6.3 0 0 1-1.31-2H5v-4h4.18c.16-.71.43-1.39.82-2H5V8h6v2.81a6.3 6.3 0 0 1 2-1.31V8h6v2a6.499 6.499 0 0 1 2 2V6a2 2 0 0 0-2-2Z"/>'
        },
        "table-settings": {
            body: '<path fill="currentColor" d="M7 22h2v2H7v-2m4 0h2v2h-2v-2m4 0h2v2h-2v-2M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 4v4h6V8H5m8 0v4h6V8h-6m-8 6v4h6v-4H5m8 0v4h6v-4h-6Z"/>'
        },
        "table-split-cell": {
            body: '<path fill="currentColor" d="M19 14h2v6H3v-6h2v4h14v-4M3 4v6h2V6h14v4h2V4H3m8 7v2H8v2l-3-3l3-3v2h3m5 0V9l3 3l-3 3v-2h-3v-2h3Z"/>'
        },
        "table-star": {
            body: '<path fill="currentColor" d="M4 3h14a2 2 0 0 1 2 2v7.08a6.01 6.01 0 0 0-4.32.92H12v4h1.08c-.11.68-.11 1.35 0 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4m12.5 8.6l.7-2.8l-2.2-1.9l2.9-.2L19 14l1.1 2.6l2.9.2l-2.2 1.9l.7 2.8l-2.5-1.4l-2.5 1.5Z"/>'
        },
        "table-sync": {
            body: '<path fill="currentColor" d="M19 12v1.5c2.21 0 4 1.79 4 4c0 .82-.24 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12m0 11v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23M4 3h14a2 2 0 0 1 2 2v6h-.5c-1.84 0-3.5.77-4.69 2H12v4h1v.5c0 .5.06 1 .17 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2m0 4v4h6V7H4m8 0v4h6V7h-6m-8 6v4h6v-4H4Z"/>'
        },
        "table-tennis": {
            body: '<path fill="currentColor" d="M18.5 14c1.4 0 2.5 1.1 2.5 2.5S19.9 19 18.5 19S16 17.9 16 16.5s1.1-2.5 2.5-2.5M7 15s1 1 1 2v3.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V17c0-1 1-2 1-2H7m1-1h3s5 0 5-5s-4-7-6.5-7S3 4 3 9s5 5 5 5Z"/>'
        },
        tablet: {
            body: '<path fill="currentColor" d="M19 18H5V6h14m2-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "tablet-android": {
            body: '<path fill="currentColor" d="M19.25 19H4.75V3h14.5M14 22h-4v-1h4m4-21H6a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Z"/>',
            hidden: true
        },
        "tablet-cellphone": {
            body: '<path fill="currentColor" d="M3 4h17a2 2 0 0 1 2 2v2h-4V6H5v12h9v2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m14 6h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1m1 2v7h4v-7h-4Z"/>'
        },
        "tablet-dashboard": {
            body: '<path fill="currentColor" d="M19 18H5V6h14m2-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M7 8h6v5H7V8m7 0h3v2h-3V8m3 3v5h-3v-5h3M7 14h6v2H7v-2Z"/>'
        },
        "tablet-ipad": {
            body: '<path d="M19 19H4V3h15m-7.5 20a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m7-23h-14A2.5 2.5 0 0 0 2 2.5v19A2.5 2.5 0 0 0 4.5 24h14a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0z" fill="currentColor"/>',
            hidden: true
        },
        taco: {
            body: '<path fill="currentColor" d="M19 18H5a4 4 0 0 1-4-4a8 8 0 0 1 8-8c1.06 0 2.07.21 3 .58c.93-.37 1.94-.58 3-.58a8 8 0 0 1 8 8a4 4 0 0 1-4 4M3 14a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-2.37 1.03-4.5 2.67-5.96L9 8a6 6 0 0 0-6 6m16 2a2 2 0 0 0 2-2a6 6 0 0 0-6-6a6 6 0 0 0-6 6c0 .73-.19 1.41-.54 2H19Z"/>'
        },
        tag: {
            body: '<path fill="currentColor" d="M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7m15.91 4.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.11 0-2 .89-2 2v7c0 .55.22 1.05.59 1.41l8.99 9c.37.36.87.59 1.42.59c.55 0 1.05-.23 1.41-.59l7-7c.37-.36.59-.86.59-1.41c0-.56-.23-1.06-.59-1.42Z"/>'
        },
        "tag-arrow-down": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7M7 19v-4H5v4H3l3 3l3-3H7Z"/>'
        },
        "tag-arrow-down-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5M8 18v-4H6v4H4l3 3l3-3H8Z"/>'
        },
        "tag-arrow-left": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7M5 19h4v-2H5v-2l-3 3l3 3v-2Z"/>'
        },
        "tag-arrow-left-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5M5 19h4v-2H5v-2l-3 3l3 3v-2Z"/>'
        },
        "tag-arrow-right": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7M6 17H2v2h4v2l3-3l-3-3v2Z"/>'
        },
        "tag-arrow-right-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5M6 17H2v2h4v2l3-3l-3-3v2Z"/>'
        },
        "tag-arrow-up": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7M5 17v4h2v-4h2l-3-3l-3 3h2Z"/>'
        },
        "tag-arrow-up-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5M6 17v4h2v-4h2l-3-3l-3 3h2Z"/>'
        },
        "tag-check": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7m3.13 7.27l-3.87 3.9l-1.35-1.37L2 18.22L4.75 21l5.28-5.32l-1.4-1.41"/>'
        },
        "tag-check-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m2.13 9.27l-3.87 3.9l-1.35-1.37L2 18.22L4.75 21l5.28-5.32l-1.4-1.41"/>'
        },
        "tag-faces": {
            body: '<path fill="currentColor" d="M15 18c-3.32 0-6-2.69-6-6c0-3.32 2.68-6 6-6a6 6 0 0 1 6 6a6 6 0 0 1-6 6M4 13a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1M22 3H7.63c-.66 0-1.25.32-1.63.81L0 12l6 8.18c.38.5.97.82 1.63.82H22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-9 8a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m2 5c1.86 0 3.35-1.28 3.8-3h-7.6c.45 1.72 1.94 3 3.8 3m2-5a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1Z"/>'
        },
        "tag-heart": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4a2 2 0 0 0-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58c.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41c0-.55-.23-1.06-.59-1.42M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7m11.77 8.27L13 19.54l-4.27-4.27A2.52 2.52 0 0 1 8 13.5a2.5 2.5 0 0 1 2.5-2.5c.69 0 1.32.28 1.77.74l.73.72l.73-.73c.45-.45 1.08-.73 1.77-.73a2.5 2.5 0 0 1 2.5 2.5c0 .69-.28 1.32-.73 1.77Z"/>'
        },
        "tag-heart-outline": {
            body: '<path fill="currentColor" d="M4 2a2 2 0 0 0-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58c.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41c0-.55-.23-1.06-.59-1.42l-9-9C12.05 2.22 11.55 2 11 2H4m7 2l9 9l-7 7l-9-9V4h7M6.5 5A1.5 1.5 0 0 0 5 6.5A1.5 1.5 0 0 0 6.5 8A1.5 1.5 0 0 0 8 6.5A1.5 1.5 0 0 0 6.5 5m4.45 5.5c-1.13 0-2.05.92-2.05 2.05c0 .57.23 1.07.6 1.45l3.5 3.5l3.5-3.5c.37-.37.6-.89.6-1.45a2.05 2.05 0 0 0-2.05-2.05c-.55 0-1.08.23-1.45.6l-.6.6l-.6-.59c-.37-.38-.9-.61-1.45-.61Z"/>'
        },
        "tag-minus": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4a2 2 0 0 0-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81a6 6 0 0 1 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7M10 19H2v-2h8v2Z"/>'
        },
        "tag-minus-outline": {
            body: '<path fill="currentColor" d="M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m0 0C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5m14.91 6.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.42l.41.4c.64-.38 1.35-.63 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08c-.1.74-.36 1.44-.74 2.08l.41.41c.37.38.88.59 1.41.59c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5M10 19H2v-2h8v2Z"/>'
        },
        "tag-multiple": {
            body: '<path fill="currentColor" d="M5.5 9A1.5 1.5 0 0 0 7 7.5A1.5 1.5 0 0 0 5.5 6A1.5 1.5 0 0 0 4 7.5A1.5 1.5 0 0 0 5.5 9m11.91 2.58c.36.36.59.86.59 1.42c0 .55-.22 1.05-.59 1.41l-5 5a1.996 1.996 0 0 1-2.83 0l-6.99-6.99C2.22 12.05 2 11.55 2 11V6c0-1.11.89-2 2-2h5c.55 0 1.05.22 1.41.58l7 7m-3.87-5.87l1-1l6.87 6.87c.37.36.59.87.59 1.42c0 .55-.22 1.05-.58 1.41l-5.38 5.38l-1-1L20.75 13l-7.21-7.29Z"/>'
        },
        "tag-multiple-outline": {
            body: '<path fill="currentColor" d="M6.5 10C7.3 10 8 9.3 8 8.5S7.3 7 6.5 7S5 7.7 5 8.5S5.7 10 6.5 10M9 6l7 7l-5 5l-7-7V6h5m0-2H4c-1.1 0-2 .9-2 2v5c0 .6.2 1.1.6 1.4l7 7c.3.4.8.6 1.4.6s1.1-.2 1.4-.6l5-5c.4-.4.6-.9.6-1.4c0-.6-.2-1.1-.6-1.4l-7-7C10.1 4.2 9.6 4 9 4m4.5 1.7l1-1l6.9 6.9c.4.4.6.9.6 1.4s-.2 1.1-.6 1.4L16 19.8l-1-1l5.7-5.8l-7.2-7.3Z"/>'
        },
        "tag-off": {
            body: '<path fill="currentColor" d="m18.33 8.5l4.59-4.58L21.5 2.5l-19 19l1.42 1.42l4.58-4.59l3.08 3.08A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42m-15.8 3.85l9.86-9.78l-3.06-3.07A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.41M5.5 4A1.5 1.5 0 1 1 4 5.5A1.5 1.5 0 0 1 5.5 4Z"/>'
        },
        "tag-off-outline": {
            body: '<path fill="currentColor" d="M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m0 0A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m11.83 3.5l4.59-4.58L21.5 2.5l-19 19l1.42 1.42l4.58-4.59l3.09 3.09A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M13 20l-3.08-3.08l7-7L20 13M5.61 15.43L7 14l-3-3V4h7l3.06 3.06l1.41-1.4l-3.06-3.08A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42M5 6.5A1.5 1.5 0 1 0 6.5 5A1.5 1.5 0 0 0 5 6.5Z"/>'
        },
        "tag-outline": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M13 20l-9-9V4h7l9 9M6.5 5A1.5 1.5 0 1 1 5 6.5A1.5 1.5 0 0 1 6.5 5Z"/>'
        },
        "tag-plus": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4a2 2 0 0 0-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81a6 6 0 0 1 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7M10 19H7v3H5v-3H2v-2h3v-3h2v3h3v2Z"/>'
        },
        "tag-plus-outline": {
            body: '<path fill="currentColor" d="M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m0 0A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m14.91 6.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l.41.4a5.62 5.62 0 0 1 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08a5.57 5.57 0 0 1-.74 2.08l.41.41A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M10 19H7v3H5v-3H2v-2h3v-3h2v3h3Z"/>'
        },
        "tag-remove": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4a2 2 0 0 0-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81a6 6 0 0 1 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6c.53 0 1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41c0-.53-.21-1.04-.59-1.42M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7m2.62 14.54L6 19.41l-2.12 2.13l-1.42-1.42L4.59 18l-2.13-2.12l1.41-1.41L6 16.59l2.12-2.12l1.41 1.41L7.41 18l2.12 2.12l-1.41 1.42Z"/>'
        },
        "tag-remove-outline": {
            body: '<path fill="currentColor" d="M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m0 0A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m14.91 6.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l.41.4a5.62 5.62 0 0 1 2.08-.74L4 11V4h7l9 9l-7 7l-1.08-1.08a5.57 5.57 0 0 1-.74 2.08l.41.41A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5m1.62 16.54L6 19.41l-2.12 2.13l-1.42-1.42L4.59 18l-2.13-2.12l1.42-1.42L6 16.59l2.12-2.13l1.42 1.42L7.41 18l2.13 2.12Z"/>'
        },
        "tag-search": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.11 0-2 .89-2 2v7c0 .55.22 1.05.59 1.41l8.99 9c.37.36.87.59 1.42.59s1.05-.23 1.41-.59l.42-.41C11.6 20.9 9 18.26 9 15c0-3.31 2.69-6 6-6c3.26 0 5.9 2.6 6 5.83l.41-.42c.37-.36.59-.86.59-1.41c0-.56-.23-1.06-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7m9.61 3.61c2.5 0 4.5 2 4.5 4.5c0 .89-.25 1.71-.69 2.39L22 20.61L20.61 22l-3.11-3.07c-.7.43-1.5.68-2.39.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 1 0 2.5 2.5c0-1.39-1.11-2.5-2.5-2.5"/>'
        },
        "tag-search-outline": {
            body: '<path fill="currentColor" d="M22 13c0 .53-.21 1.04-.59 1.41l-.41.42a6.004 6.004 0 0 0-4.89-5.72L11 4H4v7l5.11 5.11c.51 2.73 2.86 4.8 5.72 4.89l-.42.41c-.37.38-.88.59-1.41.59c-.53 0-1.03-.21-1.41-.58l-9-9C2.21 12.04 2 11.53 2 11V4c0-1.1.9-2 2-2h7c.53 0 1.04.21 1.41.58l9 9c.38.38.59.89.59 1.42M5 6.5C5 7.33 5.67 8 6.5 8S8 7.33 8 6.5S7.33 5 6.5 5S5 5.67 5 6.5m10.11 4.11c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.89 0 1.69-.25 2.39-.68L20.61 22L22 20.61l-3.08-3.11c.44-.68.69-1.5.69-2.39c0-2.5-2-4.5-4.5-4.5m0 2c1.39 0 2.5 1.12 2.5 2.5s-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5s1.12-2.5 2.5-2.5"/>'
        },
        "tag-text": {
            body: '<path fill="currentColor" d="m21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.41l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M6.5 8A1.5 1.5 0 1 1 8 6.5A1.5 1.5 0 0 1 6.5 8m5.09 7.41l-4-4L9 10l4 4m2.59.41l-5.5-5.5L11.5 7.5L17 13Z"/>'
        },
        "tag-text-outline": {
            body: '<path fill="currentColor" d="m21.4 11.6l-9-9C12 2.2 11.5 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .5.2 1 .6 1.4l9 9c.4.4.9.6 1.4.6c.5 0 1-.2 1.4-.6l7-7c.4-.4.6-.9.6-1.4c0-.5-.2-1-.6-1.4M13 20l-9-9V4h7l9 9M6.5 5C7.3 5 8 5.7 8 6.5S7.3 8 6.5 8S5 7.3 5 6.5S5.7 5 6.5 5m3.6 3.9l1.4-1.4L17 13l-1.4 1.4l-5.5-5.5m-2.5 2.5L9 10l4 4l-1.4 1.4l-4-4Z"/>'
        },
        tailwind: {
            body: '<path fill="currentColor" d="M12 6c-2.67 0-4.33 1.33-5 4c1-1.33 2.17-1.83 3.5-1.5c.76.19 1.31.74 1.91 1.35c.98 1 2.09 2.15 4.59 2.15c2.67 0 4.33-1.33 5-4c-1 1.33-2.17 1.83-3.5 1.5c-.76-.19-1.3-.74-1.91-1.35C15.61 7.15 14.5 6 12 6m-5 6c-2.67 0-4.33 1.33-5 4c1-1.33 2.17-1.83 3.5-1.5c.76.19 1.3.74 1.91 1.35C8.39 16.85 9.5 18 12 18c2.67 0 4.33-1.33 5-4c-1 1.33-2.17 1.83-3.5 1.5c-.76-.19-1.3-.74-1.91-1.35C10.61 13.15 9.5 12 7 12Z"/>'
        },
        "tally-mark-1": {
            body: '<path fill="currentColor" d="M13 19h-2V5h2v14Z"/>'
        },
        "tally-mark-2": {
            body: '<path fill="currentColor" d="M11 19H9V5h2v14m4-14h-2v14h2V5Z"/>'
        },
        "tally-mark-3": {
            body: '<path fill="currentColor" d="M9 19H7V5h2v14m4-14h-2v14h2V5m4 0h-2v14h2V5Z"/>'
        },
        "tally-mark-4": {
            body: '<path fill="currentColor" d="M7 19H5V5h2v14m4-14H9v14h2V5m4 0h-2v14h2V5m4 0h-2v14h2V5Z"/>'
        },
        "tally-mark-5": {
            body: '<path fill="currentColor" d="M19 10.73V19h-2v-7.64L15 12v7h-2v-6.38l-2 .64V19H9v-5.11l-2 .61V19H5v-3.85l-2.43.77L2 14l3-.95V5h2v7.42l2-.63V5h2v6.16l2-.63V5h2v4.9l2-.64V5h2v3.63L21 8l.57 1.92l-2.57.81Z"/>'
        },
        tangram: {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-1.41 2L12 10.59L5.41 4h13.18m-5.18 8l3.09-3.09L19.59 12l-3.09 3.09L13.41 12m1.18 4H9.41L12 13.41L14.59 16M4 5.41L10.59 12L4 18.59V5.41M11.59 20H5.41l2-2h6.18l-2 2M20 20h-5.59L20 14.41V20m0-10.41L17.91 7.5L20 5.41v4.18Z"/>'
        },
        tank: {
            body: '<path fill="currentColor" d="M20 12H4v-1h2l1-5h5l1 5h7v1m-6.78-5l.4 2H22V7h-8.78M22 16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3M6 16a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1m7 0a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1m7 0a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1Z"/>'
        },
        "tanker-truck": {
            body: '<path fill="currentColor" d="M20 8h-5v6H2v3h1c0 1.7 1.3 3 3 3s3-1.3 3-3h6c0 1.7 1.3 3 3 3s3-1.3 3-3h2v-5l-3-4M6 18.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m12 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M17 12V9.5h2.5l2 2.5H17m-3-2.5c0 1.9-1.6 3.5-3.5 3.5h-6C2.6 13 1 11.4 1 9.5S2.6 6 4.5 6H5V5H4V4h4v1H7v1h3.5C12.4 6 14 7.6 14 9.5Z"/>'
        },
        "tape-drive": {
            body: '<path fill="currentColor" d="M12 10a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4M5 3h14a2 2 0 0 1 2 2v12h-4.1a6.96 6.96 0 0 0 2.1-5c0-3.87-3.13-7-7-7s-7 3.13-7 7s3.13 7 7 7h9c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2Z"/>'
        },
        "tape-measure": {
            body: '<path fill="currentColor" d="M9 5a7 7 0 0 1 7 7h1v3h-1v4H9a7 7 0 0 1-7-7a7 7 0 0 1 7-7m0 3a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m8 9h5v4h-2v-2h-3v-2Z"/>'
        },
        target: {
            body: '<path fill="currentColor" d="M11 2v2.07A8.002 8.002 0 0 0 4.07 11H2v2h2.07A8.002 8.002 0 0 0 11 19.93V22h2v-2.07A8.002 8.002 0 0 0 19.93 13H22v-2h-2.07A8.002 8.002 0 0 0 13 4.07V2m-2 4.08V8h2V6.09c2.5.41 4.5 2.41 4.92 4.91H16v2h1.91c-.41 2.5-2.41 4.5-4.91 4.92V16h-2v1.91C8.5 17.5 6.5 15.5 6.08 13H8v-2H6.09C6.5 8.5 8.5 6.5 11 6.08M12 11a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "target-account": {
            body: '<path fill="currentColor" d="M20.95 11h1.55v2h-1.55c-.45 4.17-3.78 7.5-7.95 7.95v1.55h-2v-1.55C6.83 20.5 3.5 17.17 3.05 13H1.5v-2h1.55C3.5 6.83 6.83 3.5 11 3.05V1.5h2v1.55c4.17.45 7.5 3.78 7.95 7.95M5.07 11H6.5v2H5.07A6.98 6.98 0 0 0 11 18.93V17.5h2v1.43A6.98 6.98 0 0 0 18.93 13H17.5v-2h1.43A6.98 6.98 0 0 0 13 5.07V6.5h-2V5.07A6.98 6.98 0 0 0 5.07 11M16 16H8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1m-4-8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "target-variant": {
            body: '<path fill="currentColor" d="M22.08 11.04h-2V4h-7.03V2h-2.01v2H4v7.04H2v2.01h2v7.03h7.04v2h2.01v-2h7.03v-7.03h2v-2.01m-4.01 7.03h-5.02v-2.01h-2.01v2.01H6v-5.02h2.03v-2.01H6V6h5.04v2.03h2.01V6h5.02v5.04h-2.01v2.01h2.01v5.02m-5.02-6.02a1 1 0 0 1-1 1c-.55 0-1.01-.45-1.01-1s.46-1.01 1.01-1.01s1 .46 1 1.01Z"/>'
        },
        taxi: {
            body: '<path fill="currentColor" d="m5 11l1.5-4.5h11L19 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1H15V3H9v2H6.5c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6Z"/>'
        },
        tea: {
            body: '<path fill="currentColor" d="M4 19h16v2H4v-2M20 8V5h-2v3h2m0-5c.6 0 1 .2 1.4.6c.4.4.6.9.6 1.4v3c0 .6-.2 1-.6 1.4c-.4.4-.8.6-1.4.6h-2v3c0 1.1-.4 2-1.2 2.8c-.8.8-1.7 1.2-2.8 1.2H8c-1.1 0-2-.4-2.8-1.2C4.4 15 4 14.1 4 13V3h5v2.4L7.2 6.8c-.1.1-.2.3-.2.4v4.3c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5V7.2c0-.2-.1-.3-.2-.4L10 5.4V3h10Z"/>'
        },
        "tea-outline": {
            body: '<path fill="currentColor" d="M4 19h16v2H4v-2M21.4 3.6C21 3.2 20.6 3 20 3H4v10c0 1.1.4 2 1.2 2.8C6 16.6 6.9 17 8 17h6c1.1 0 2-.4 2.8-1.2c.8-.8 1.2-1.7 1.2-2.8v-3h2c.6 0 1-.2 1.4-.6c.4-.4.6-.8.6-1.4V5c0-.5-.2-1-.6-1.4M16 5v8c0 .6-.2 1-.6 1.4c-.4.4-.8.6-1.4.6H8c-.6 0-1-.2-1.4-.6c-.4-.4-.6-.9-.6-1.4V5h4v1.4L8.2 7.8c-.2.1-.2.3-.2.4v4.3c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5V8.2c0-.2-.1-.3-.2-.4L11 6.4V5h5m4 3h-2V5h2v3Z"/>'
        },
        teamspeak: {
            body: '<path d="M12.202 13.027c.087.125.208.326.148.47c-.036.089-.207.137-.318.175l-.36.122l-.442.163c-.263.14-.269.393-.239.559l.108.32c.05.128.145.262.116.41c-.037.196-.411.21-.413.47c0 .119.076.176.158.236l.159.12l-.123.153l-.205.297l-.014.032l-.047.157l.016.22l.027.1v.002c.106.404.224.907.04 1.238c-.473.85-2.376.578-3.383.379c-.01-.06.061-.084.095-.113c.648-.543 1.187-1.278 1.56-2.105a6.93 6.93 0 0 0 .625-3.22c-.09-1.847-.662-3.189-1.58-4.253l-.753-.715l-.233-.181V3.656c1.102.428 1.879 1.213 2.513 2.176c.461.7.843 1.488 1.145 2.392c.15.445.317.999.074 1.42c-.102.178-.336.3-.37.542c-.028.188.08.347.158.49c.465.849.988 1.564 1.538 2.351zm9.321-3.83a7.83 7.83 0 0 1 .477 2.7a8.593 8.593 0 0 1-.426 2.75c-1.046 3.117-3.45 5.097-6.401 6.273c-1.49.593-3.09.954-5.204.954c-2.06 0-3.723-.483-5.336-1.015l.091-.081c.091-.059.315-.242.426-.244l.305.091c1.433.435 3.285.708 5.163.528c1.907-.183 3.352-.699 4.768-1.41c1.344-.676 2.538-1.569 3.449-2.741c.456-.588.814-1.228 1.167-1.928c.346-.69.532-1.55.598-2.487a9.17 9.17 0 0 0-.223-2.832a6.571 6.571 0 0 0-.964-2.131c-.843-1.252-1.82-2.292-3.084-3.096c-1.266-.805-2.678-1.432-4.433-1.746c-1.759-.314-3.797-.31-5.427.102V6.5h.001v1.602a2.987 2.987 0 0 1 1.431 2.556c0 1.564-1.19 2.846-2.706 2.972h-.006l-.12.008l-.073.001l-.045.002h-.016l-.121-.004h-.02l-.192-.016a2.978 2.978 0 0 1-1.714-.812c-.428-.4-.744-.97-.852-1.675L2 10.67L2 10.66c0-1.266.78-2.346 1.88-2.78l.732-3.464c.077-.368.143-.83.345-1.086c.41-.517 1.264-.67 2.02-.852c.796-.193 1.57-.301 2.515-.345c1.012-.047 2.11.072 2.992.213c2.751.44 4.81 1.542 6.442 3.086c1.076 1.017 2.03 2.203 2.597 3.765zM6.588 10.852c0-1.13-.914-2.046-2.042-2.046c-1.127 0-2.04.916-2.04 2.046s.913 2.046 2.04 2.046a2.044 2.044 0 0 0 2.042-2.046zm4.38-7.242c4.556.624 8.023 3.78 8.023 7.581c0 3.407-2.784 6.294-6.64 7.307c-.362.135-1.006.187-.975.115l-.002.003l.16-.573c.048-.274.08-.609.026-.902l-.013-.064c0-.004-.12-.239.083-.425v-.001l.03-.023c.076-.067.27-.271.191-.562l-.044-.082c-.092-.1-.065-.192-.007-.264l.13-.111c.198-.156.141-.373.075-.508l-.138-.195l-.019-.023l-.001-.001c-.334-.419.15-.615.492-.697l.092-.02c.246-.062.891-.277.735-.819l-.12-.216l-.47-.706h.015L11.32 10.69c-.135-.171-.076-.312-.014-.392l.319-.562c.096-.288.091-.588.07-.792a5.244 5.244 0 0 1 1.643 1.277c.456.528.842 1.204.842 2.145c0 .955-.39 1.618-.842 2.156a4.733 4.733 0 0 1-1.457 1.16l-.08.039c-.052.065-.078.146-.017.234l.127-.027a7.381 7.381 0 0 0 1.766-.831c.888-.577 1.719-1.279 2.258-2.197c.178-.301.315-.674.442-1.047c.257-.757.34-1.685.102-2.556c-.205-.75-.58-1.402-.995-1.98c-1.227-1.71-3.407-2.583-6.066-2.792v.004a8.958 8.958 0 0 0-1.06-.995s-.067-.087.303-.087s1.684.063 2.27.157l.038.007z" fill="currentColor"/>',
            hidden: true
        },
        teamviewer: {
            body: '<path fill="currentColor" d="M10.04 9.2L9.3 11h5.45L14 9.2l5.55 2.8L14 14.8l.75-1.8H9.3l.74 1.8L4.5 12l5.54-2.8M20.83 22H3.17C2.53 22 2 21.5 2 20.83V3.17C2 2.53 2.53 2 3.17 2h17.66C21.5 2 22 2.53 22 3.17v17.66c0 .64-.5 1.17-1.17 1.17m-8.9-18.24C7.41 3.82 3.78 7.5 3.76 12c-.04 4.5 3.59 8.2 8.1 8.24H12A8.346 8.346 0 0 0 20.24 12c.07-4.5-3.5-8.17-7.98-8.24c-.11-.01-.22 0-.33 0Z"/>'
        },
        "teddy-bear": {
            body: '<path fill="currentColor" d="M15.75 19.13c-.83 0-1.5-.84-1.5-1.88c0-1.03.67-1.87 1.5-1.87s1.5.84 1.5 1.87c0 1.04-.67 1.88-1.5 1.88M12 11.25c-1.24 0-2.25-.84-2.25-1.87c0-1.04 1.01-1.88 2.25-1.88s2.25.84 2.25 1.88c0 1.03-1.01 1.87-2.25 1.87m-3.75 7.88c-.83 0-1.5-.84-1.5-1.88c0-1.03.67-1.87 1.5-1.87s1.5.84 1.5 1.87c0 1.04-.67 1.88-1.5 1.88M12 8.25c.41 0 .75.34.75.75s-.34.75-.75.75s-.75-.34-.75-.75s.34-.75.75-.75M18.75 12c-.32 0-.63.07-.91.2c-.48-.61-1.13-1.13-1.91-1.53c.57-.8.91-1.77.91-2.82v-.06c1.09-.23 1.91-1.2 1.91-2.37c0-1.33-1.09-2.42-2.42-2.42c-.69 0-1.33.29-1.75.75a4.813 4.813 0 0 0-5.16 0C9 3.29 8.36 3 7.67 3C6.34 3 5.25 4.09 5.25 5.42c0 1.16.82 2.13 1.9 2.37v.06c0 1.05.35 2.03.91 2.82c-.77.4-1.42.92-1.9 1.53A2.24 2.24 0 0 0 3 14.25c0 1.25 1 2.25 2.25 2.25h.06c-.04.24-.06.5-.06.75c0 2.07 1.34 3.75 3 3.75c1.01 0 1.9-.63 2.45-1.59c.42.06.85.09 1.3.09c.45 0 .88-.03 1.3-.09c.55.96 1.44 1.59 2.45 1.59c1.66 0 3-1.68 3-3.75c0-.25-.02-.51-.06-.75h.06c1.25 0 2.25-1 2.25-2.25S20 12 18.75 12"/>'
        },
        telegram: {
            body: '<path d="M9.78 18.65l.28-4.23l7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3L3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" fill="currentColor"/>',
            hidden: true
        },
        "telegram-circle-custom": {
            body: '<path fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12.3942 9.12068C11.3243 9.5657 9.18596 10.4868 5.97924 11.8839C5.45851 12.091 5.18574 12.2935 5.1609 12.4916C5.11894 12.8264 5.53815 12.9582 6.10901 13.1377C6.18667 13.1621 6.26712 13.1874 6.34961 13.2142C6.91125 13.3968 7.66676 13.6104 8.05951 13.6189C8.41578 13.6266 8.81342 13.4797 9.25242 13.1782C12.2486 11.1558 13.7952 10.1335 13.8923 10.1115C13.9608 10.0959 14.0557 10.0764 14.12 10.1335C14.1844 10.1907 14.178 10.299 14.1712 10.328C14.1297 10.505 12.4841 12.0349 11.6325 12.8266C11.367 13.0734 11.1787 13.2485 11.1402 13.2885C11.054 13.3781 10.9661 13.4628 10.8817 13.5442C10.3599 14.0472 9.96859 14.4244 10.9033 15.0404C11.3525 15.3364 11.7119 15.5812 12.0705 15.8254C12.4622 16.0921 12.8528 16.3581 13.3581 16.6894C13.4869 16.7738 13.6099 16.8614 13.7296 16.9468C14.1854 17.2717 14.5949 17.5636 15.1007 17.5171C15.3946 17.49 15.6983 17.2136 15.8525 16.3893C16.2169 14.4412 16.9332 10.2203 17.0987 8.48089C17.1132 8.3285 17.095 8.13347 17.0803 8.04786C17.0657 7.96225 17.035 7.84027 16.9238 7.74997C16.792 7.64303 16.5885 7.62047 16.4975 7.62208C16.0838 7.62937 15.449 7.85008 12.3942 9.12068Z" fill="currentColor"/>'
        },
        telescope: {
            body: '<path fill="currentColor" d="m21.9 8.9l-1.7 1l-4-6.9l1.7-1l4 6.9m-12.1-1l3 5.2l6.1-3.5l-3-5.2l-6.1 3.5m1.6 4.8l-2-3.5l-4.3 2.5l2 3.5l4.3-2.5m-9.3 1.9l1 1.7l2.6-1.5l-1-1.7l-2.6 1.5m10-.6l-.3-.4l-4.3 2.5l.3.4c.2.3.5.6.8.8L7 22h2l1.4-4.3h.1L12 22h2l-1.9-5.6c.5-.7.5-1.6 0-2.4Z"/>'
        },
        television: {
            body: '<path fill="currentColor" d="M21 17H3V5h18m0-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "television-ambient-light": {
            body: '<path fill="currentColor" d="M3 11H0V9h3v2m0 3H0v2h3v-2m2-8.88L2.88 3L1.46 4.41l2.13 2.13L5 5.12M10 5V2H8v3h2m14 4h-3v2h3V9m-8-4V2h-2v3h2m4.41 1.54l2.13-2.12L21.12 3L19 5.12l1.41 1.42M24 14h-3v2h3v-2m-5-5v7c0 1.1-.9 2-2 2h-2v2H9v-2H7c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2m-2 0H7v7h10V9m2 10.88L21.12 22l1.42-1.41l-2.13-2.12L19 19.88M3.59 18.46l-2.12 2.13L2.88 22L5 19.88l-1.41-1.42Z"/>'
        },
        "television-box": {
            body: '<path fill="currentColor" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m11 13l3-8h-2.5L15 12.5L13.5 8H5v2h3v6h2v-6h1.77L14 16h2Z"/>'
        },
        "television-classic": {
            body: '<path fill="currentColor" d="M8.16 3L6.75 4.41L9.34 7H4c-1.11 0-2 .89-2 2v10c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-5.34l2.59-2.59L15.84 3L12 6.84L8.16 3M4 9h13v10H4V9m15.5 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m0 3a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "television-classic-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L21 21.72L19.73 23l-2-2H4c-1.11 0-2-.89-2-2V9c0-1 .76-1.86 1.75-2L2 5.27M8.16 3L12 6.84L15.84 3l1.41 1.41L14.66 7H20c1.11 0 2 .89 2 2v10c0 .34-.08.66-.23.94L17 15.18V9h-6.18l-2-2h.52L6.75 4.41L8.16 3M4 9v10h11.73l-10-10H4m15.5 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 3a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "television-guide": {
            body: '<path fill="currentColor" d="M21 17V5H3v12h18m0-14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-5v2H8v-2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h18M5 7h6v4H5V7m0 6h6v2H5v-2m8-6h6v2h-6V7m0 4h6v4h-6v-4Z"/>'
        },
        "television-off": {
            body: '<path fill="currentColor" d="M.5 2.77L1.78 1.5L21 20.72L19.73 22l-3-3H16v2H8v-2H3a2 2 0 0 1-2-2V5c0-.5.17-.93.46-1.27L.5 2.77M21 17V5H7.82l-2-2H21a2 2 0 0 1 2 2v12c0 .85-.55 1.59-1.3 1.87L19.82 17H21M3 17h11.73L3 5.27V17Z"/>'
        },
        "television-pause": {
            body: '<path fill="currentColor" d="M3 3c-1.11 0-2 .89-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2M3 5h18v12H3m6-9v6h2V8m2 0v6h2V8"/>'
        },
        "television-play": {
            body: '<path fill="currentColor" d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 14H3V5h18m-5 6l-7 4V7"/>'
        },
        "television-shimmer": {
            body: '<path fill="currentColor" d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-6 3.5l-.62 1.37L13 8.5l1.38.63l.62 1.37l.63-1.37L17 8.5l-1.37-.63L15 6.5m-4.5 2l-1.09 2.41L7 12l2.41 1.09l1.09 2.41l1.1-2.41L14 12l-2.4-1.09l-1.1-2.41"/>'
        },
        "television-speaker": {
            body: '<path fill="currentColor" d="M3 3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h4v-4H3V5h18v2h2V5c0-1.1-.9-2-2-2H3m18 6h-5c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2m-2.5 1.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S17 12.8 17 12s.7-1.5 1.5-1.5m0 10c-1.7 0-3-1.3-3-3c0-1.6 1.3-3 2.9-3h.1c1.7 0 3 1.3 3 3s-1.3 3-3 3m0-4.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5Z"/>'
        },
        "television-speaker-off": {
            body: '<path fill="currentColor" d="M21 9h-5c-1 0-1.9.8-2 1.8l3.8 3.8c.2-.1.4-.1.7-.1h.1c1.7 0 3 1.3 3 3c0 .2 0 .5-.1.7l1.6 1.6V11c-.1-1.1-1-2-2.1-2m-2.5 4.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M23 5v2h-2V5H8.2l-2-2H21c1.1 0 2 .9 2 2M2.4 1.7L1.1 3l.5.5c-.3.4-.6.9-.6 1.5v12c0 1.1.9 2 2 2h5v2h4v-4H3V5h.1L14 15.9V20c0 1.1.9 2 2 2h4.1l.7.7l1.4-1.2L2.4 1.7m16.1 18.8c-1.7 0-3-1.3-3-3v-.1l3.1 3.1h-.1Z"/>'
        },
        "television-stop": {
            body: '<path fill="currentColor" d="M3 3h18a2 2 0 0 1 2 2v12c0 1.1-.9 2-2 2h-5v2H8v-2H3c-1.1 0-2-.9-2-2V5c0-1.11.89-2 2-2m0 2v12h18V5H3m6 3h6v6H9V8Z"/>'
        },
        "temperature-celsius": {
            body: '<path fill="currentColor" d="M16.5 5c1.55 0 3 .47 4.19 1.28l-1.16 2.89A4.47 4.47 0 0 0 16.5 8C14 8 12 10 12 12.5s2 4.5 4.5 4.5c1.03 0 1.97-.34 2.73-.92l1.14 2.85A7.47 7.47 0 0 1 16.5 20A7.5 7.5 0 0 1 9 12.5A7.5 7.5 0 0 1 16.5 5M6 3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "temperature-fahrenheit": {
            body: '<path fill="currentColor" d="M11 20V5h9v3h-6v3h5v3h-5v6h-3M6 3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "temperature-kelvin": {
            body: '<path fill="currentColor" d="M7 5h3v6l5-6h4l-5.12 5.78L19 20h-3.62l-3.62-6.83L10 15.15V20H7V5Z"/>'
        },
        "temple-buddhist": {
            body: '<path fill="currentColor" d="M21 9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2H1c0 1.9 1.3 3.4 3 3.8V22h6v-3c0-1.1.9-2 2-2s2 .9 2 2v3h6v-9.1c.5-.1 3-1 3-3.9h-2M6 8.9V10h12V8.9c.5-.1 3-1 3-3.9h-2c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2H3c0 1.9 1.3 3.4 3 3.9M12 1L8.2 6h7.5L12 1Z"/>'
        },
        "temple-buddhist-outline": {
            body: '<path fill="currentColor" d="M21 9c0 1.1-.9 2-2 2h-1V8.9c1.7-.4 3-2 3-3.8h-2c0 1.1-.9 2-2 2h-.5L12 1L7.5 7H7c-1.1 0-2-.9-2-2H3c0 1.9 1.3 3.4 3 3.8V11H5c-1.1 0-2-.9-2-2H1c0 1.9 1.3 3.4 3 3.8V22h7v-4c0-.5.4-1 1-1s1 .5 1 1v4h7v-9.1c1.7-.4 3-2 3-3.8L21 9m-9-4.7L14 7h-4l2-2.7M8 9h8v2H8V9m10 11h-3v-2c0-1.6-1.4-3-3-3s-3 1.4-3 3v2H6v-7h12v7Z"/>'
        },
        "temple-hindu": {
            body: '<path fill="currentColor" d="M6.6 11h10.8l-.9-3h-9l-.9 3M20 11v2H4v-2H2v11h8v-5h4v5h8V11h-2m-4.1-5L15 3V1h-2v2h-2V1H9v2.1L8.1 6h7.8Z"/>'
        },
        "temple-hindu-outline": {
            body: '<path fill="currentColor" d="M20 11v2h-2L15 3V1h-2v2h-2V1H9v2.1L6 13H4v-2H2v11h9v-5h2v5h9V11h-2m-4.7 0H8.7l.6-2h5.4l.6 2m-1.2-4H9.9l.6-2h3l.6 2M20 20h-5v-5H9v5H4v-5h3.5l.6-2h7.8l.6 2H20v5Z"/>'
        },
        tennis: {
            body: '<path fill="currentColor" d="M18 15a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2M6.05 14.54s1.41-1.42 1.42-4.24c-.36-2.19.5-4.76 2.47-6.72C12.87.65 17.14.17 19.5 2.5c2.33 2.36 1.85 6.63-1.08 9.56c-1.96 1.97-4.53 2.83-6.72 2.47c-2.82.01-4.24 1.42-4.24 1.42l-4.24 4.24l-1.41-1.41l4.24-4.24M18.07 3.93C16.5 2.37 13.5 2.84 11.35 5c-2.14 2.14-2.62 5.15-1.06 6.71c1.57 1.56 4.57 1.08 6.71-1.06c2.16-2.15 2.63-5.15 1.07-6.72Z"/>'
        },
        "tennis-ball": {
            body: '<path fill="currentColor" d="M12 2c2.5 0 4.75.9 6.5 2.4A9.982 9.982 0 0 0 15 12c0 3.04 1.36 5.77 3.5 7.6c-1.75 1.5-4 2.4-6.5 2.4s-4.75-.9-6.5-2.4A9.982 9.982 0 0 0 9 12c0-3.04-1.36-5.77-3.5-7.6C7.25 2.9 9.5 2 12 2m10 10c0 2.32-.79 4.45-2.12 6.15A7.994 7.994 0 0 1 17 12c0-2.47 1.12-4.68 2.88-6.15A9.936 9.936 0 0 1 22 12M2 12c0-2.32.79-4.45 2.12-6.15A7.994 7.994 0 0 1 7 12c0 2.47-1.12 4.68-2.88 6.15A9.936 9.936 0 0 1 2 12Z"/>'
        },
        tent: {
            body: '<path fill="currentColor" d="M4 6c0 1.19.39 2.27 1 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3c-.61.73-1 1.81-1 3M2 21v-2h2.76L12 4.78L19.24 19H22v2H2M12 9.19L7 19h10l-5-9.81Z"/>'
        },
        terraform: {
            body: '<path fill="currentColor" d="M21 5.4v6.4L15.4 15V8.7L21 5.4m-6.2 3.3V15l-5.6-3.2V5.4l5.6 3.3m0 7v6.4l-5.6-3.2v-6.4l5.6 3.2M8.6 5.1v6.4L3 8.3V1.9l5.6 3.2Z"/>'
        },
        terrain: {
            body: '<path fill="currentColor" d="m14 6l-3.75 5l2.85 3.8l-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6Z"/>'
        },
        "test-tube": {
            body: '<path fill="currentColor" d="M7 2v2h1v14a4 4 0 0 0 4 4a4 4 0 0 0 4-4V4h1V2H7m4 14c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m2-4c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m1-5h-4V4h4v3Z"/>'
        },
        "test-tube-empty": {
            body: '<path fill="currentColor" d="M7 2h10v2h-1v14a4 4 0 0 1-4 4a4 4 0 0 1-4-4V4H7V2m7 2h-4v14a2 2 0 0 0 2 2a2 2 0 0 0 2-2V4Z"/>'
        },
        "test-tube-off": {
            body: '<path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-2.89-2.89A4.01 4.01 0 0 1 12 22a4 4 0 0 1-4-4v-6.73l-6-6M7 2h10v2h-1v10.18l-2.37-2.37c.23-.18.37-.46.37-.81c0-.6-.4-1-1-1c-.35 0-.63.14-.81.37L8 6.18V4H7V2m4 14c.5 0 .88-.29 1-.76L10.76 14c-.47.12-.76.5-.76 1c0 .6.4 1 1 1m3-9V4h-4v3h4Z"/>'
        },
        text: {
            body: '<path fill="currentColor" d="M21 6v2H3V6h18M3 18h9v-2H3v2m0-5h18v-2H3v2Z"/>'
        },
        "text-account": {
            body: '<path fill="currentColor" d="M21 5v2H3V5h18M3 17h9v-2H3v2m0-5h18v-2H3v2m15 2a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2m-4 8v-1c0-1.1 1.79-2 4-2s4 .9 4 2v1h-8Z"/>'
        },
        "text-box": {
            body: '<path fill="currentColor" d="M14 17H7v-2h7m3-2H7v-2h10m0-2H7V7h10m2-4H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "text-box-check": {
            body: '<path fill="currentColor" d="m17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41M12.8 21H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11H7v2h7.69A5.983 5.983 0 0 0 12 18c0 1.09.29 2.12.8 3m-.8-6H7v2h5m5-10H7v2h10"/>'
        },
        "text-box-check-outline": {
            body: '<path fill="currentColor" d="m17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41M12.8 21H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2m-.8-4H7v-2h5m2.68-2H7v-2h10v1.08c-.85.14-1.63.46-2.32.92M17 9H7V7h10"/>'
        },
        "text-box-edit": {
            body: '<path fill="currentColor" d="M10 19.11L12.11 17H7v-2h7v.12L16.12 13H7v-2h10v1.12l1.24-1.23c.48-.48 1.11-.75 1.8-.75c.33 0 .66.07.96.19V5a2 2 0 0 0-2-2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h5v-1.89M7 7h10v2H7V7m14.7 7.35l-1 1l-2.05-2.05l1-1a.55.55 0 0 1 .77 0l1.28 1.28c.21.21.21.56 0 .77M12 19.94l6.06-6.06l2.05 2.05L14.06 22H12v-2.06Z"/>'
        },
        "text-box-edit-outline": {
            body: '<path fill="currentColor" d="M10 21H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2h14c1.11 0 2 .89 2 2v5.33c-.3-.12-.63-.19-.96-.19c-.37 0-.72.08-1.04.23V5H5v14h5.11l-.11.11V21M7 9h10V7H7v2m0 8h5.11L14 15.12V15H7v2m0-4h9.12l.88-.88V11H7v2m14.7.58l-1.28-1.28a.55.55 0 0 0-.77 0l-1 1l2.05 2.05l1-1a.55.55 0 0 0 0-.77M12 22h2.06l6.05-6.07l-2.05-2.05L12 19.94V22Z"/>'
        },
        "text-box-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8m-10 0v-2H7v2h5m5-6H7v2h7.69A5.983 5.983 0 0 0 12 18c0 1.09.29 2.12.8 3H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11m0-2V7H7v2h10Z"/>'
        },
        "text-box-minus-outline": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8M5 3h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2m2 4h10v2H7V7m0 4h10v1.08c-.85.14-1.63.46-2.32.92H7v-2m0 4h5v2H7v-2Z"/>'
        },
        "text-box-multiple": {
            body: '<path fill="currentColor" d="M16 15H9v-2h7m3-2H9V9h10m0-2H9V5h10m2-4H7c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V3a2 2 0 0 0-2-2M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2Z"/>'
        },
        "text-box-multiple-outline": {
            body: '<path fill="currentColor" d="M16 15H9v-2h7v2m3-4H9V9h10v2m0-4H9V5h10v2M3 5v16h16v2H3a2 2 0 0 1-2-2V5h2m18-4a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H7a2 2 0 0 1-2-2V3c0-1.11.89-2 2-2h14M7 3v14h14V3H7Z"/>'
        },
        "text-box-outline": {
            body: '<path fill="currentColor" d="M5 3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H5m0 2h14v14H5V5m2 2v2h10V7H7m0 4v2h10v-2H7m0 4v2h7v-2H7Z"/>'
        },
        "text-box-plus": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3m-5 3v-2H7v2h5m5-6H7v2h7.69A5.983 5.983 0 0 0 12 18c0 1.09.29 2.12.8 3H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11m0-2V7H7v2h10Z"/>'
        },
        "text-box-plus-outline": {
            body: '<path fill="currentColor" d="M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M5 3h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2m2 4h10v2H7V7m0 4h10v1.08c-.85.14-1.63.46-2.32.92H7v-2m0 4h5v2H7v-2Z"/>'
        },
        "text-box-remove": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M12 17v-2H7v2h5m5-6H7v2h7.69A5.983 5.983 0 0 0 12 18c0 1.09.29 2.12.8 3H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11m0-2V7H7v2h10Z"/>'
        },
        "text-box-remove-outline": {
            body: '<path fill="currentColor" d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M5 3h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2m2 4h10v2H7V7m0 4h10v1.08c-.85.14-1.63.46-2.32.92H7v-2m0 4h5v2H7v-2Z"/>'
        },
        "text-box-search": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M7 15v2h2c.14 1.55.8 2.94 1.81 4H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v8.03A6.492 6.492 0 0 0 15.5 10c-1.27 0-2.46.37-3.46 1H7v2h3c-.36.6-.66 1.28-.83 2H7m10-6V7H7v2h10Z"/>'
        },
        "text-box-search-outline": {
            body: '<path fill="currentColor" d="M15.5 12c2.5 0 4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5m0 2a2.5 2.5 0 0 0-2.5 2.5a2.5 2.5 0 0 0 2.5 2.5a2.5 2.5 0 0 0 2.5-2.5a2.5 2.5 0 0 0-2.5-2.5M5 3h14c1.11 0 2 .89 2 2v8.03c-.5-.8-1.19-1.49-2-2.03V5H5v14h4.5c.31.75.76 1.42 1.31 2H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2m2 4h10v2H7V7m0 4h5.03c-.8.5-1.49 1.19-2.03 2H7v-2m0 4h2.17c-.11.5-.17 1-.17 1.5v.5H7v-2Z"/>'
        },
        "text-long": {
            body: '<path fill="currentColor" d="M4 5h16v2H4V5m0 4h16v2H4V9m0 4h16v2H4v-2m0 4h10v2H4v-2Z"/>'
        },
        "text-recognition": {
            body: '<path fill="currentColor" d="M2 4c0-1.1.9-2 2-2h4v2H4v4H2V4m20 16c0 1.11-.89 2-2 2h-4v-2h4v-4h2v4M4 22a2 2 0 0 1-2-2v-4h2v4h4v2H4M20 2a2 2 0 0 1 2 2v4h-2V4h-4V2h4M9 7v2h2v8h2V9h2V7H9Z"/>'
        },
        "text-search": {
            body: '<path fill="currentColor" d="m19.31 18.9l3.08 3.1L21 23.39l-3.12-3.07c-.69.43-1.51.68-2.38.68c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5c0 .88-.25 1.71-.69 2.4m-3.81.1a2.5 2.5 0 0 0 0-5a2.5 2.5 0 0 0 0 5M21 4v2H3V4h18M3 16v-2h6v2H3m0-5V9h18v2h-2.03c-1.01-.63-2.2-1-3.47-1s-2.46.37-3.47 1H3Z"/>'
        },
        "text-search-variant": {
            body: '<path fill="currentColor" d="M9 6v2H2V6h7m0 5v2H2v-2h7m9 5v2H2v-2h16m1.31-4.5c.44-.68.69-1.5.69-2.39c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.87 0 1.69-.25 2.38-.68L21 16l1.39-1.39l-3.08-3.11m-3.81.11c-1.38 0-2.5-1.11-2.5-2.5s1.12-2.5 2.5-2.5a2.5 2.5 0 0 1 0 5Z"/>'
        },
        "text-shadow": {
            body: '<path fill="currentColor" d="M3 3h13v3h-5v12H8V6H3V3m9 4h2v2h-2V7m3 0h2v2h-2V7m3 0h2v2h-2V7m-6 3h2v2h-2v-2m0 3h2v2h-2v-2m0 3h2v2h-2v-2m0 3h2v2h-2v-2Z"/>'
        },
        "text-short": {
            body: '<path fill="currentColor" d="M4 9h16v2H4V9m0 4h10v2H4v-2Z"/>'
        },
        texture: {
            body: '<path fill="currentColor" d="M9.29 21h2.83L21 12.12V9.29M19 21c.55 0 1.05-.22 1.41-.59c.37-.36.59-.86.59-1.41v-2l-4 4M5 3a2 2 0 0 0-2 2v2l4-4m4.88 0L3 11.88v2.83L14.71 3m4.79.08L3.08 19.5c.09.35.27.66.51.91c.25.24.56.42.91.51L20.93 4.5c-.19-.7-.73-1.24-1.43-1.42Z"/>'
        },
        "texture-box": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v16a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M4 6l2-2h4.9L4 10.9V6m0 7.7L13.7 4h4.9L4 18.6v-4.9M20 18l-2 2h-4.9l6.9-6.9V18m0-7.7L10.3 20H5.4L20 5.4v4.9Z"/>'
        },
        theater: {
            body: '<path fill="currentColor" d="M4 15h2a2 2 0 0 1 2 2v2h1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2h1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2h1v3H1v-3h1v-2a2 2 0 0 1 2-2m7-8l4 3l-4 3V7M4 2h16a2 2 0 0 1 2 2v9.54a3.89 3.89 0 0 0-2-.54V4H4v9c-.73 0-1.41.19-2 .54V4a2 2 0 0 1 2-2Z"/>'
        },
        "theme-light-dark": {
            body: '<path fill="currentColor" d="M7.5 2c-1.79 1.15-3 3.18-3 5.5s1.21 4.35 3.03 5.5C4.46 13 2 10.54 2 7.5A5.5 5.5 0 0 1 7.5 2m11.57 1.5l1.43 1.43L4.93 20.5L3.5 19.07L19.07 3.5m-6.18 2.43L11.41 5L9.97 6l.42-1.7L9 3.24l1.75-.12l.58-1.65L12 3.1l1.73.03l-1.35 1.13l.51 1.67m-3.3 3.61l-1.16-.73l-1.12.78l.34-1.32l-1.09-.83l1.36-.09l.45-1.29l.51 1.27l1.36.03l-1.05.87l.4 1.31M19 13.5a5.5 5.5 0 0 1-5.5 5.5c-1.22 0-2.35-.4-3.26-1.07l7.69-7.69c.67.91 1.07 2.04 1.07 3.26m-4.4 6.58l2.77-1.15l-.24 3.35l-2.53-2.2m4.33-2.7l1.15-2.77l2.2 2.54l-3.35.23m1.15-4.96l-1.14-2.78l3.34.24l-2.2 2.54M9.63 18.93l2.77 1.15l-2.53 2.19l-.24-3.34Z"/>'
        },
        thermometer: {
            body: '<path fill="currentColor" d="M15 13V5a3 3 0 0 0-6 0v8a5 5 0 1 0 6 0m-3-9a1 1 0 0 1 1 1v3h-2V5a1 1 0 0 1 1-1Z"/>'
        },
        "thermometer-alert": {
            body: '<path fill="currentColor" d="M17 13V7h2v6h-2m0 4v-2h2v2h-2m-4-4V5c0-1.7-1.3-3-3-3S7 3.3 7 5v8c-2.2 1.7-2.7 4.8-1 7s4.8 2.7 7 1s2.7-4.8 1-7c-.3-.4-.6-.7-1-1m-3-9c.6 0 1 .4 1 1v3H9V5c0-.6.4-1 1-1Z"/>'
        },
        "thermometer-auto": {
            body: '<path fill="currentColor" d="M12 14c-.3-.4-.6-.7-1-1V5c0-1.7-1.3-3-3-3S5 3.3 5 5v8c-2.2 1.7-2.7 4.8-1 7s4.8 2.7 7 1s2.7-4.8 1-7M9 8H7V5c0-.5.5-1 1-1s1 .5 1 1v3m9-5h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L18 3m-2.2 5.7L17 5l1.2 3.7h-2.4Z"/>'
        },
        "thermometer-bluetooth": {
            body: '<path fill="currentColor" d="M11 13V5c0-1.66-1.34-3-3-3S5 3.34 5 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M8 4c.55 0 1 .45 1 1v3H7V5c0-.55.45-1 1-1m10 4v3.79L15.71 9.5l-.71.71L17.79 13L15 15.79l.71.71L18 14.21V18h.5l2.85-2.86L19.21 13l2.14-2.15L18.5 8H18m1 1.91l.94.94l-.94.94V9.91m0 4.3l.94.93l-.94.94v-1.87Z"/>'
        },
        "thermometer-check": {
            body: '<path fill="currentColor" d="M10 13V5c0-1.66-1.34-3-3-3S4 3.34 4 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M7 4c.55 0 1 .45 1 1v3H6V5c0-.55.45-1 1-1m9.25 11.16l-2.75-3L14.66 11l1.59 1.59L19.84 9L21 10.41l-4.75 4.75"/>'
        },
        "thermometer-chevron-down": {
            body: '<path fill="currentColor" d="M17.41 12.17L14.24 9l-1.41 1.41L17.41 15L22 10.41L20.58 9M10 13V5c0-1.66-1.34-3-3-3S4 3.34 4 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M7 4c.55 0 1 .45 1 1v3H6V5c0-.55.45-1 1-1Z"/>'
        },
        "thermometer-chevron-up": {
            body: '<path fill="currentColor" d="M17.41 11.83L20.58 15L22 13.59L17.41 9l-4.59 4.59L14.24 15l3.17-3.17M10 13V5c0-1.66-1.34-3-3-3S4 3.34 4 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M7 4c.55 0 1 .45 1 1v3H6V5c0-.55.45-1 1-1Z"/>'
        },
        "thermometer-high": {
            body: '<path fill="currentColor" d="M15 13V5a3 3 0 0 0-6 0v8a5 5 0 1 0 6 0m-3-9a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1Z"/>'
        },
        "thermometer-lines": {
            body: '<path fill="currentColor" d="M17 3h4v2h-4V3m0 4h4v2h-4V7m0 4h4v2h-3.25l-.75-.9V11m4 4v2h-2c0-.69-.1-1.37-.29-2H21M7 3v2H3V3h4m0 4v2H3V7h4m0 4v1.1l-.75.9H3v-2h4m-4 4h2.29c-.19.63-.29 1.31-.29 2H3v-2m12-2V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1m-3-9c.55 0 1 .45 1 1v3h-2V5c0-.55.45-1 1-1Z"/>'
        },
        "thermometer-low": {
            body: '<path fill="currentColor" d="M15 13V5a3 3 0 0 0-6 0v8a5 5 0 1 0 6 0m-3-9a1 1 0 0 1 1 1v7h-2V5a1 1 0 0 1 1-1Z"/>'
        },
        "thermometer-minus": {
            body: '<path fill="currentColor" d="M22 11h-8v2h8v-2m-11 2V5c0-1.66-1.34-3-3-3S5 3.34 5 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M8 4c.55 0 1 .45 1 1v3H7V5c0-.55.45-1 1-1Z"/>'
        },
        "thermometer-off": {
            body: '<path fill="currentColor" d="m11 7.8l-2-2V5c0-1.66 1.34-3 3-3s3 1.34 3 3v6.8L11.2 8H13V5c0-.55-.45-1-1-1s-1 .45-1 1v2.8m11.11 13.66L2.39 1.73L1.11 3L9 10.89V13a4.997 4.997 0 0 0-1 7a4.997 4.997 0 0 0 7 1c.84-.63 1.4-1.5 1.71-2.4l4.13 4.13l1.27-1.27Z"/>'
        },
        "thermometer-plus": {
            body: '<path fill="currentColor" d="M19 11V8h-2v3h-3v2h3v3h2v-3h3v-2m-11 2V5c0-1.66-1.34-3-3-3S5 3.34 5 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M8 4c.55 0 1 .45 1 1v3H7V5c0-.55.45-1 1-1Z"/>'
        },
        "thermometer-probe": {
            body: '<path fill="currentColor" d="m19.47 3.47l-6 6l-2.94.53c-.31.03-.59.18-.81.4l-6.91 6.91a2.758 2.758 0 0 0 0 3.89a2.758 2.758 0 0 0 3.89 0l6.91-6.91c.22-.22.39-.5.42-.79l.51-2.96l6-6L22 2l-2.53 1.47M11 14.38c-.76 0-1.38-.62-1.38-1.38s.62-1.38 1.38-1.38s1.38.62 1.38 1.38A1.39 1.39 0 0 1 11 14.38Z"/>'
        },
        "thermometer-probe-off": {
            body: '<path fill="currentColor" d="m2 3.64l7.24 7.24l-6.43 6.43a2.758 2.758 0 0 0 0 3.89a2.758 2.758 0 0 0 3.89 0l6.43-6.43l7.6 7.6L22 21.1L3.27 2.37L2 3.64m8.23 8.22l1.91 1.91a1.376 1.376 0 1 1-1.91-1.91m4.23-.86L13 9.55l.47-.08l6-6L22 2l-1.46 2.54l-6 6l-.08.46Z"/>'
        },
        "thermometer-water": {
            body: '<path fill="currentColor" d="M10 13V5c0-1.66-1.34-3-3-3S4 3.34 4 5v8c-2.21 1.66-2.66 4.79-1 7s4.79 2.66 7 1s2.66-4.79 1-7a4.74 4.74 0 0 0-1-1M7 4c.55 0 1 .45 1 1v3H6V5c0-.55.45-1 1-1m11 3s-4 4.34-4 7.07c0 5.24 8 5.24 8 0C22 11.34 18 7 18 7Z"/>'
        },
        thermostat: {
            body: '<path fill="currentColor" d="m16.95 16.95l-2.12-2.12C15.55 14.1 16 13.1 16 12c0-.74-.21-1.43-.57-2l2.17-2.19A6.86 6.86 0 0 1 19 12c0 1.93-.78 3.68-2.05 4.95M12 5c1.57 0 3 .5 4.19 1.4L14 8.56c-.57-.35-1.26-.56-2-.56a4 4 0 0 0-4 4c0 1.1.45 2.1 1.17 2.83l-2.12 2.12A6.976 6.976 0 0 1 5 12a7 7 0 0 1 7-7m0-3A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10Z"/>'
        },
        "thermostat-auto": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.4 0 .7 0 1.1-.1l2.3-6.6l-.6-.6c.7-.7 1.2-1.7 1.2-2.8c0-.7-.2-1.4-.6-2l2.2-2.2C18.5 9 19 10.4 19 12h1c.3 0 .6.1.8.2c0 0 .1 0 .1.1c.4.2.8.6 1 1.1c.1-.5.1-.9.1-1.4c0-5.5-4.5-10-10-10m2 6.6c-.6-.4-1.3-.6-2-.6c-2.2 0-4 1.8-4 4c0 1.1.4 2.1 1.2 2.8l-2.1 2.1C5.8 15.7 5 13.9 5 12c0-3.9 3.1-7 7-7c1.6 0 3 .5 4.2 1.4L14 8.6m6 5.4h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L20 14m-2.2 5.7L19 16l1.2 3.7h-2.4Z"/>'
        },
        "thermostat-box": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m7 2c1.57 0 3 .5 4.19 1.4L14 8.56c-.57-.35-1.26-.56-2-.56a4 4 0 0 0-4 4c0 1.1.45 2.1 1.17 2.83l-2.12 2.12A6.976 6.976 0 0 1 5 12a7 7 0 0 1 7-7m5.6 2.81A6.86 6.86 0 0 1 19 12c0 1.93-.78 3.68-2.05 4.95l-2.12-2.12C15.55 14.1 16 13.1 16 12c0-.74-.21-1.43-.57-2l2.17-2.19Z"/>'
        },
        "thermostat-box-auto": {
            body: '<path fill="currentColor" d="M20 14h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L20 14m-2.2 5.7L19 16l1.2 3.7h-2.4m-2.4-4.3l-.6-.6c.7-.7 1.2-1.7 1.2-2.8c0-.7-.2-1.4-.6-2l2.2-2.2C18.5 9 19 10.4 19 12h2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8.4l2-5.6m-6.2-.6L7 17c-1.3-1.3-2-3-2-5c0-3.9 3.1-7 7-7c1.6 0 3 .5 4.2 1.4L14 8.6c-.6-.4-1.3-.6-2-.6c-2.2 0-4 1.8-4 4c0 1.1.5 2.1 1.2 2.8Z"/>'
        },
        "thought-bubble": {
            body: '<path fill="currentColor" d="M3.5 19A1.5 1.5 0 0 1 5 20.5A1.5 1.5 0 0 1 3.5 22A1.5 1.5 0 0 1 2 20.5A1.5 1.5 0 0 1 3.5 19m5-3a2.5 2.5 0 0 1 2.5 2.5A2.5 2.5 0 0 1 8.5 21A2.5 2.5 0 0 1 6 18.5A2.5 2.5 0 0 1 8.5 16m6-1c-1.19 0-2.27-.5-3-1.35c-.73.85-1.81 1.35-3 1.35c-1.96 0-3.59-1.41-3.93-3.26A4.02 4.02 0 0 1 2 8a4 4 0 0 1 4-4c.26 0 .5.03.77.07C7.5 3.41 8.45 3 9.5 3c1.19 0 2.27.5 3 1.35c.73-.85 1.81-1.35 3-1.35c1.96 0 3.59 1.41 3.93 3.26A4.02 4.02 0 0 1 22 10a4 4 0 0 1-4 4l-.77-.07c-.73.66-1.68 1.07-2.73 1.07Z"/>'
        },
        "thought-bubble-outline": {
            body: '<path fill="currentColor" d="M3.5 19A1.5 1.5 0 0 1 5 20.5A1.5 1.5 0 0 1 3.5 22A1.5 1.5 0 0 1 2 20.5A1.5 1.5 0 0 1 3.5 19m5-3a2.5 2.5 0 0 1 2.5 2.5A2.5 2.5 0 0 1 8.5 21A2.5 2.5 0 0 1 6 18.5A2.5 2.5 0 0 1 8.5 16m6-1c-1.19 0-2.27-.5-3-1.35c-.73.85-1.81 1.35-3 1.35c-1.96 0-3.59-1.41-3.93-3.26A4.02 4.02 0 0 1 2 8a4 4 0 0 1 4-4l.77.07C7.5 3.41 8.45 3 9.5 3c1.19 0 2.27.5 3 1.35c.73-.85 1.81-1.35 3-1.35c1.96 0 3.59 1.41 3.93 3.26A4.02 4.02 0 0 1 22 10a4 4 0 0 1-4 4l-.77-.07c-.73.66-1.68 1.07-2.73 1.07M6 6a2 2 0 0 0-2 2a2 2 0 0 0 2 2c.33 0 .64-.08.92-.22A2 2 0 0 0 6.5 11a2 2 0 0 0 2 2c.6 0 1.14-.27 1.5-.69l1.47-1.68L13 12.34c.38.4.91.66 1.5.66c1 0 1.83-.74 2-1.7c.34.43.89.7 1.5.7a2 2 0 0 0 2-2a2 2 0 0 0-2-2c-.33 0-.64.08-.92.22A2 2 0 0 0 17.5 7a2 2 0 0 0-2-2c-.59 0-1.12.26-1.5.66l-1.53 1.71L11 5.69c-.36-.42-.9-.69-1.5-.69c-1 0-1.83.74-2 1.7C7.16 6.27 6.61 6 6 6m2.5 11.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "thumb-down": {
            body: '<path fill="currentColor" d="M19 15h4V3h-4m-4 0H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2a2 2 0 0 0 2 2h6.31l-.95 4.57c-.02.1-.03.2-.03.31c0 .42.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5a2 2 0 0 0-2-2Z"/>'
        },
        "thumb-down-outline": {
            body: '<path fill="currentColor" d="M19 15V3h4v12h-4M15 3a2 2 0 0 1 2 2v10c0 .55-.22 1.05-.59 1.41L9.83 23l-1.06-1.06c-.27-.27-.44-.64-.44-1.06l.03-.31l.95-4.57H3a2 2 0 0 1-2-2v-2c0-.26.05-.5.14-.73l3.02-7.05C4.46 3.5 5.17 3 6 3h9m0 2H5.97L3 12v2h8.78l-1.13 5.32L15 14.97V5Z"/>'
        },
        "thumb-up": {
            body: '<path fill="currentColor" d="M23 10a2 2 0 0 0-2-2h-6.32l.96-4.57c.02-.1.03-.21.03-.32c0-.41-.17-.79-.44-1.06L14.17 1L7.59 7.58C7.22 7.95 7 8.45 7 9v10a2 2 0 0 0 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2M1 21h4V9H1v12Z"/>'
        },
        "thumb-up-outline": {
            body: '<path fill="currentColor" d="M5 9v12H1V9h4m4 12a2 2 0 0 1-2-2V9c0-.55.22-1.05.59-1.41L14.17 1l1.06 1.06c.27.27.44.64.44 1.05l-.03.32L14.69 8H21a2 2 0 0 1 2 2v2c0 .26-.05.5-.14.73l-3.02 7.05C19.54 20.5 18.83 21 18 21H9m0-2h9.03L21 12v-2h-8.79l1.13-5.32L9 9.03V19Z"/>'
        },
        "thumbs-up-down": {
            body: '<path fill="currentColor" d="M22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18a1 1 0 0 0 1 1h5.18l-.68 3.18v.24c0 .31.13.58.33.8l.79.78l4.94-4.94c.27-.27.44-.65.44-1.06v-6.5a1.5 1.5 0 0 0-1.5-1.5M12 6a1 1 0 0 0-1-1H5.82l.68-3.18v-.23c0-.31-.13-.59-.33-.8L5.38 0L.44 4.94C.17 5.21 0 5.59 0 6v6.5A1.5 1.5 0 0 0 1.5 14h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6Z"/>'
        },
        "thumbs-up-down-outline": {
            body: '<path fill="currentColor" d="M12 6c0-.55-.45-1-1-1H5.82l.68-3.18v-.23c0-.31-.13-.59-.33-.8L5.38 0L.44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6m-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13M22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.68 3.18v.24c0 .31.13.58.33.8l.79.78l4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5m-.5 7.79l-1.93 1.93l.57-2.72H14v-.13L16.08 12H22v5.79Z"/>'
        },
        ticket: {
            body: '<path fill="currentColor" d="M15.58 16.8L12 14.5l-3.58 2.3l1.08-4.12L6.21 10l4.25-.26L12 5.8l1.54 3.94l4.25.26l-3.29 2.68M20 12a2 2 0 0 1 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2a2 2 0 0 1-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1-2-2Z"/>'
        },
        "ticket-account": {
            body: '<path fill="currentColor" d="M20 12a2 2 0 0 0 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 0 2-2a2 2 0 0 0-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 0-2 2m-3.5 4.25c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75m-4.5-4A2.25 2.25 0 0 0 14.25 10A2.25 2.25 0 0 0 12 7.75A2.25 2.25 0 0 0 9.75 10A2.25 2.25 0 0 0 12 12.25Z"/>'
        },
        "ticket-confirmation": {
            body: '<path fill="currentColor" d="M13 8.5h-2v-2h2v2m0 4.5h-2v-2h2v2m0 4.5h-2v-2h2v2m9-7.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2a2 2 0 0 1-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "ticket-confirmation-outline": {
            body: '<path fill="currentColor" d="M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 1 1 0 4v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2m-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46c0-1.5-.8-2.77-2-3.46V6h16v2.54M11 15h2v2h-2m0-6h2v2h-2m0-6h2v2h-2Z"/>'
        },
        "ticket-outline": {
            body: '<path fill="currentColor" d="M4 4a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2a2 2 0 0 1-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1-2-2a2 2 0 0 1 2-2V6a2 2 0 0 0-2-2H4m0 2h16v2.54c-1.24.71-2 2.03-2 3.46c0 1.43.76 2.75 2 3.46V18H4v-2.54c1.24-.71 2-2.03 2-3.46c0-1.43-.76-2.75-2-3.46V6Z"/>'
        },
        "ticket-percent": {
            body: '<path fill="currentColor" d="M4 4a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2a2 2 0 0 1-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1-2-2a2 2 0 0 1 2-2V6a2 2 0 0 0-2-2H4m11.5 3L17 8.5L8.5 17L7 15.5L15.5 7m-6.69.04c.98 0 1.77.79 1.77 1.77a1.77 1.77 0 0 1-1.77 1.77c-.98 0-1.77-.79-1.77-1.77a1.77 1.77 0 0 1 1.77-1.77m6.38 6.38c.98 0 1.77.79 1.77 1.77a1.77 1.77 0 0 1-1.77 1.77c-.98 0-1.77-.79-1.77-1.77a1.77 1.77 0 0 1 1.77-1.77Z"/>'
        },
        "ticket-percent-outline": {
            body: '<path fill="currentColor" d="M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8M4 4h16c1.11 0 2 .89 2 2v4a2 2 0 1 0 0 4v4c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2V6a2 2 0 0 1 2-2m0 2v2.54a3.994 3.994 0 0 1 0 6.92V18h16v-2.54a3.994 3.994 0 0 1 0-6.92V6H4m5.5 2c.83 0 1.5.67 1.5 1.5S10.33 11 9.5 11S8 10.33 8 9.5S8.67 8 9.5 8m5 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        tie: {
            body: '<path fill="currentColor" d="m6 2l4 4l-3 11l5 5l5-5l-3-11l4-4Z"/>'
        },
        tilde: {
            body: '<path fill="currentColor" d="M2 15s0-6 6-6c4 0 4.5 3.5 7.5 3.5c4 0 4-3.5 4-3.5H22s0 6-6 6c-4 0-5.5-3.5-7.5-3.5c-4 0-4 3.5-4 3.5H2"/>'
        },
        "tilde-off": {
            body: '<path fill="currentColor" d="M20.84 22.73L10.78 12.67C10 12.03 9.27 11.5 8.5 11.5c-4 0-4 3.5-4 3.5H2s0-5.41 5.16-5.95L1.11 3l1.28-1.27l7.64 7.64L15.64 15h-.01l6.48 6.46l-1.27 1.27M22 9h-2.5s0 3.38-3.81 3.5l2.26 2.25C22 13.62 22 9 22 9Z"/>'
        },
        timelapse: {
            body: '<path fill="currentColor" d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m4.24 5.76A5.95 5.95 0 0 0 12 6v6l-4.24 4.24a6 6 0 0 0 8.48 0a5.981 5.981 0 0 0 0-8.48Z"/>'
        },
        timeline: {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2Z"/>'
        },
        "timeline-alert": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-9 1v6h2V7h-2m0 8v2h2v-2h-2Z"/>'
        },
        "timeline-alert-outline": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2M10 6v12h12V6H10m5 1h2v6h-2V7m0 8h2v2h-2v-2Z"/>'
        },
        "timeline-check": {
            body: '<path fill="currentColor" d="M4 8H2V2h2v6M2 22h2v-6H2v6m1-12a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m21-4v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-4.25 4.33l-1.16-1.41L15 12.5l-1.59-1.58l-1.16 1.16l2.75 3l4.75-4.75Z"/>'
        },
        "timeline-check-outline": {
            body: '<path fill="currentColor" d="M22 4H10a2 2 0 0 0-2 2v4l-2 2l2 2v4a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H10V6h12v12M4 8H2V2h2v6m-2 8h2v6H2v-6m3-4c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m10 3.08l-2.75-3l1.16-1.16L15 12.5l3.59-3.58l1.16 1.41L15 15.08Z"/>'
        },
        "timeline-clock": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m11-8c4.42 0 8 3.58 8 8s-3.58 8-8 8c-3.6 0-6.64-2.38-7.65-5.65L6 12l2.35-2.35C9.36 6.38 12.4 4 16 4m-1 9l4.53 2.79l.8-1.29l-3.83-2.3V7H15v6Z"/>'
        },
        "timeline-clock-outline": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m11-8c4.42 0 8 3.58 8 8s-3.58 8-8 8c-3.6 0-6.64-2.38-7.65-5.65L6 12l2.35-2.35C9.36 6.38 12.4 4 16 4m0 2c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6m-1 7V8h1.5v4.2l3 1.8l-.82 1.26L15 13Z"/>'
        },
        "timeline-minus": {
            body: '<path fill="currentColor" d="M4 8H2V2h2v6m20-2v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-4 5h-8v2h8v-2M2 22h2v-6H2v6m1-12a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "timeline-minus-outline": {
            body: '<path fill="currentColor" d="M2 16h2v6H2v-6M4 2H2v6h2V2m16 9h-8v2h8v-2M3 10a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m21-4v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-2 0H10v12h12V6Z"/>'
        },
        "timeline-outline": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2M10 6v12h12V6H10Z"/>'
        },
        "timeline-plus": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-4 5h-3V8h-2v3h-3v2h3v3h2v-3h3v-2Z"/>'
        },
        "timeline-plus-outline": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m15-1v2h-3v3h-2v-3h-3v-2h3V8h2v3h3m4-5v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2M10 6v12h12V6H10Z"/>'
        },
        "timeline-question": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22v-6h2v6H2m3-10c0 1.11-.89 2-2 2a2 2 0 1 1 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-7.5 9.5H15V17h1.5v-1.5m-2-5V10c0-.83.67-1.5 1.5-1.5s1.5.68 1.5 1.5c0 .47-.23.9-.62 1.16l-.29.19C15.6 12 15 13.11 15 14.3v.2h1.5v-.2c0-.68.34-1.3.91-1.7l.3-.19C18.5 11.88 19 10.97 19 10c0-1.66-1.34-3-3-3s-3 1.34-3 3v.5h1.5Z"/>'
        },
        "timeline-question-outline": {
            body: '<path fill="currentColor" d="M5 12c0 1.11-.89 2-2 2a2 2 0 1 1 2-2M4 2v6H2V2h2M2 22v-6h2v6H2M24 6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-2 0H10v4.83L8.83 12L10 13.17V18h12V6m-5.5 9.5V17H15v-1.5h1.5m-2-5H13V10c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .97-.5 1.88-1.29 2.41l-.3.19c-.57.4-.91 1.02-.91 1.7v.2H15v-.2c0-1.19.6-2.3 1.59-2.95l.29-.19c.39-.26.62-.69.62-1.16c0-.82-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.5Z"/>'
        },
        "timeline-remove": {
            body: '<path fill="currentColor" d="M4 8H2V2h2v6M2 22h2v-6H2v6m1-12a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m21-4v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-6.59 6l2.12-2.12l-1.41-1.41L16 10.59l-2.12-2.12l-1.41 1.41L14.59 12l-2.12 2.12l1.41 1.41L16 13.41l2.12 2.12l1.41-1.41L17.41 12Z"/>'
        },
        "timeline-remove-outline": {
            body: '<path fill="currentColor" d="M4 8H2V2h2v6M2 22h2v-6H2v6m1-12a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2m10.88 5.54L16 13.41l2.12 2.12l1.41-1.41L17.41 12l2.12-2.12l-1.41-1.41L16 10.59l-2.12-2.12l-1.41 1.41L14.59 12l-2.12 2.12l1.41 1.42M24 6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-2 0H10v12h12V6Z"/>'
        },
        "timeline-text": {
            body: '<path fill="currentColor" d="M4 2v6H2V2h2M2 22h2v-6H2v6m3-10a2 2 0 1 0-2 2c1.11 0 2-.89 2-2m19-6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-5 7h-8v2h8v-2m2-4H11v2h10V9Z"/>'
        },
        "timeline-text-outline": {
            body: '<path fill="currentColor" d="M5 12c0 1.11-.89 2-2 2a2 2 0 1 1 2-2M4 2v6H2V2h2M2 22v-6h2v6H2M24 6v12c0 1.11-.89 2-2 2H10a2 2 0 0 1-2-2v-4l-2-2l2-2V6a2 2 0 0 1 2-2h12c1.11 0 2 .89 2 2m-2 0H10v4.83L8.83 12L10 13.17V18h12V6M12 9h8v2h-8V9m0 4h6v2h-6v-2Z"/>'
        },
        timer: {
            body: '<path fill="currentColor" d="m19.03 7.39l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c5 0 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61M13 14h-2V7h2v7m2-13H9v2h6V1Z"/>'
        },
        "timer-10": {
            body: '<path fill="currentColor" d="M12.9 13.22c0 .6-.04 1.11-.12 1.53c-.08.42-.2.75-.36 1.02c-.16.26-.36.45-.59.57c-.23.12-.51.16-.83.16c-.29 0-.57-.04-.81-.16c-.24-.12-.44-.31-.6-.57c-.16-.27-.29-.6-.38-1.02c-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52c.09-.41.21-.74.38-1c.16-.25.36-.43.6-.55c.24-.11.51-.15.81-.15c.31 0 .58.04.81.15c.24.11.44.29.6.55c.16.25.29.58.37.99c.08.41.13.92.13 1.52v2.51m.91-6.17c-.32-.4-.75-.7-1.23-.88A4.69 4.69 0 0 0 11 5.9c-.58 0-1.11.1-1.59.27c-.48.18-.91.47-1.23.88c-.34.41-.6.95-.79 1.59c-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39c.19.66.45 1.19.8 1.6c.34.41.75.71 1.23.89a4.658 4.658 0 0 0 3.18 0c.48-.18.9-.48 1.22-.89c.34-.41.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39c-.18-.64-.44-1.19-.78-1.59m9.96 7.32c-.14-.28-.35-.53-.63-.74c-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.22c-.23-.09-.42-.17-.55-.26a.717.717 0 0 1-.28-.3a.934.934 0 0 1-.09-.39c0-.14.04-.28.1-.41a.82.82 0 0 1 .27-.34c.13-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.03.66.11c.19.07.35.17.48.29c.13.13.22.26.29.42c.06.16.11.32.11.49h1.94c0-.39-.08-.75-.24-1.09c-.16-.34-.39-.63-.7-.88c-.29-.25-.65-.44-1.08-.59C21.5 9.07 21 9 20.46 9c-.51 0-.96.07-1.39.21c-.41.14-.77.33-1.07.57c-.28.22-.5.52-.66.84a2.2 2.2 0 0 0-.23 1.01c0 .37.08.69.23.96c.16.28.36.52.66.73c.25.21.58.38.96.53c.38.15.81.26 1.27.36c.39.08.71.17.95.26s.43.19.57.29c.13.1.22.24.25.34c.07.12.09.25.09.4c0 .31-.13.56-.4.76c-.27.2-.66.29-1.19.29c-.2 0-.41-.02-.62-.08a1.86 1.86 0 0 1-.56-.24c-.17-.11-.32-.26-.41-.44c-.11-.18-.17-.41-.18-.67h-1.89c0 .38.08.71.24 1.05c.16.33.39.65.7.93c.31.27.69.49 1.15.66c.46.17.98.24 1.57.24c.54 0 1-.05 1.45-.18c.43-.13.8-.32 1.11-.54c.31-.23.54-.51.71-.83c.17-.32.23-.67.23-1.06s-.07-.74-.22-1.02M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72Z"/>'
        },
        "timer-3": {
            body: '<path fill="currentColor" d="M20.87 14.37c-.14-.28-.37-.53-.63-.74c-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.88-.22c-.22-.09-.4-.17-.54-.26a.717.717 0 0 1-.28-.3a.935.935 0 0 1-.08-.39c0-.15.03-.28.09-.41a.82.82 0 0 1 .27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .45.03.66.11c.19.07.35.17.48.29c.13.13.22.26.31.42c.04.16.08.32.08.49h1.95a2.517 2.517 0 0 0-.93-1.97c-.3-.25-.66-.44-1.1-.59c-.42-.15-.91-.22-1.45-.22c-.51 0-.98.07-1.39.21c-.41.14-.77.33-1.06.57c-.29.22-.51.52-.67.84a2.2 2.2 0 0 0-.23 1.01c0 .37.08.68.23.96c.15.28.37.52.64.73c.27.21.6.38.98.53c.38.15.81.26 1.27.36c.39.08.71.17.95.26c.23.09.43.19.57.29c.13.1.22.24.27.34c.05.12.07.25.07.4c0 .31-.13.56-.4.76c-.28.2-.66.29-1.17.29c-.22 0-.43-.02-.64-.08c-.21-.05-.4-.13-.56-.24a1.333 1.333 0 0 1-.59-1.11h-1.89c0 .38.07.71.24 1.05c.16.33.39.65.7.93c.31.27.69.49 1.13.66c.5.17 1 .24 1.6.24c.53 0 1.01-.05 1.44-.18c.43-.13.8-.32 1.11-.54c.31-.23.54-.51.71-.83c.17-.32.25-.67.25-1.06c-.02-.39-.11-.74-.24-1.02m-9.26-1.4c-.16-.24-.36-.47-.61-.65a3.6 3.6 0 0 0-.94-.48c.3-.14.57-.3.8-.5c.23-.2.42-.41.57-.64c.15-.23.27-.46.34-.7c.08-.25.11-.5.11-.74c0-.55-.09-1.04-.28-1.46c-.18-.42-.44-.77-.78-1.06c-.32-.28-.73-.5-1.2-.64c-.45-.13-.97-.2-1.53-.2c-.55 0-1.06.1-1.52.24c-.47.17-.87.4-1.2.69c-.33.29-.6.63-.78 1.03c-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69c.08-.2.22-.38.38-.52c.17-.14.36-.25.58-.33c.22-.08.46-.11.73-.11c.61 0 1.06.15 1.36.46c.3.31.44.75.44 1.32c0 .27-.04.52-.12.72c-.08.24-.21.43-.38.59c-.17.16-.38.28-.63.37c-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11c.27.08.5.19.69.35c.19.16.34.38.44.61c.1.24.16.54.16.87c0 .62-.18 1.09-.53 1.4c-.35.35-.84.5-1.45.5c-.29 0-.56-.03-.8-.12c-.24-.08-.44-.2-.61-.38c-.17-.14-.3-.32-.39-.54c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.31 1.45c.22.42.5.77.87 1.05c.36.26.77.49 1.24.63c.47.13.96.21 1.48.21c.57 0 1.09-.08 1.58-.23c.49-.15.91-.38 1.26-.68c.36-.3.64-.67.84-1.1c.2-.43.3-.93.3-1.48c0-.29-.04-.59-.11-.86c-.08-.23-.19-.51-.35-.76Z"/>'
        },
        "timer-alert": {
            body: '<path fill="currentColor" d="M18.45 5.97c-.45-.51-.9-.97-1.41-1.41L15.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c5 0 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61l1.42-1.42M11 14H9V7h2v7m2-11H7V1h6v2m10 4v6h-2V7h2m-2 8h2v2h-2v-2Z"/>'
        },
        "timer-alert-outline": {
            body: '<path fill="currentColor" d="M9 8h2v6H9V8m4-7H7v2h6V1m4.03 6.39A8.963 8.963 0 0 1 19 13c0 4.97-4 9-9 9a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42M17 13c0-3.87-3.13-7-7-7s-7 3.13-7 7s3.13 7 7 7s7-3.13 7-7m4-6v6h2V7h-2m0 10h2v-2h-2v2Z"/>'
        },
        "timer-cancel": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-3 15.5c0 1.27.37 2.44 1 3.44c-.33.06-.66.06-1 .06a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A9.162 9.162 0 0 1 21 12.5a6.5 6.5 0 0 0-9 6M13 7h-2v7h2V7m10 11.5c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "timer-cancel-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7c3.54 0 6.45 2.62 6.93 6.03c.72.05 1.41.2 2.07.47a9.162 9.162 0 0 0-1.97-5.11l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.34 0 .67 0 1-.06c-.37-.59-.65-1.25-.82-1.94H12m11-1.5c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "timer-check": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 16c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6m0-12h-2v7h2V7m8.34 8.84l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "timer-check-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09m9.34-4.16l-3.59 3.59l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41Z"/>'
        },
        "timer-cog": {
            body: '<path fill="currentColor" d="M22.8 19.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M19.5 18c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5M11 18c0-1.5.5-2.9 1.3-4H11V7h2v6.1c1.3-1.3 3-2.1 5-2.1c1 0 2 .2 2.9.6c-.3-1.6-.9-3-1.9-4.2L20.5 6c-.5-.5-1-1-1.5-1.4L17.6 6c-1.5-1.3-3.5-2-5.6-2c-5 0-9 4-9 9s4 9 9 9h.3c-.8-1.1-1.3-2.5-1.3-4m4-17H9v2h6V1Z"/>'
        },
        "timer-cog-outline": {
            body: '<path fill="currentColor" d="M22.8 19.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M19.5 18c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5M13 14V8h-2v6m4-13H9v2h6V1m-3.7 19C7.8 19.6 5 16.6 5 13c0-3.9 3.1-7 7-7c3.2 0 5.9 2.1 6.7 5c.8.1 1.5.3 2.2.6c-.3-1.6-.9-3-1.9-4.2L20.5 6c-.5-.5-1-1-1.5-1.4L17.6 6c-1.5-1.3-3.5-2-5.6-2c-5 0-9 4-9 9s4 9 9 9h.3c-.5-.6-.8-1.3-1-2Z"/>'
        },
        "timer-edit": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m4.39 7.74L11 19.13v2.81c-4.5-.5-8-4.31-8-8.94a9 9 0 0 1 9-9c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42c.64.8 1.14 1.72 1.47 2.71c-.4.11-.79.32-1.11.64M13 7h-2v7h2V7m0 12.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "timer-edit-outline": {
            body: '<path fill="currentColor" d="M13 14h-2V8h2v6m2-13H9v2h6V1M5 13a6.995 6.995 0 0 1 13.79-1.66l.6-.6c.32-.32.71-.53 1.11-.64a8.59 8.59 0 0 0-1.47-2.71l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0-9 9c0 4.63 3.5 8.44 8 8.94v-2.02c-3.39-.49-6-3.39-6-6.92m8 6.96V22h2.04l6.13-6.12l-2.04-2.05L13 19.96m9.85-6.49l-1.32-1.32c-.2-.2-.53-.2-.72 0l-.98.98l2.04 2.04l.98-.98c.2-.19.2-.52 0-.72Z"/>'
        },
        "timer-lock": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-.8 11.5v.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .42.09.83.24 1.21c-.41.05-.82.09-1.24.09a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42c.68.85 1.2 1.83 1.54 2.89c-.5-.17-1.02-.28-1.57-.28c-2.6 0-4.8 2.06-4.8 4.5M13 7h-2v7h2V7m10 10.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "timer-lock-open": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-.8 10.5v1.24c-.7.6-1.2 1.5-1.2 2.46v3.5c0 .42.09.83.24 1.21c-.41.05-.82.09-1.24.09a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42c.43.54.79 1.11 1.09 1.75C19.76 9.06 19.39 9 19 9c-2.6 0-4.8 2.06-4.8 4.5M13 7h-2v7h2V7m8.8 9h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "timer-lock-open-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m2 11.92c-.33.05-.66.08-1 .08c-3.87 0-7-3.13-7-7s3.13-7 7-7c2.44 0 4.59 1.26 5.85 3.15c.37-.09.75-.15 1.15-.15c.39 0 .76.06 1.12.14c-.3-.64-.66-1.21-1.09-1.75l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.42 0 .83-.04 1.24-.09c-.15-.38-.24-.79-.24-1.21v-.78M15 1H9v2h6V1m6.8 15h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "timer-lock-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m2 11.92c-.33.05-.66.08-1 .08c-3.87 0-7-3.13-7-7s3.13-7 7-7c2.82 0 5.24 1.67 6.35 4.06c.21-.02.43-.06.65-.06c.55 0 1.07.11 1.57.28a9.037 9.037 0 0 0-1.54-2.89l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.42 0 .83-.04 1.24-.09c-.15-.38-.24-.79-.24-1.21v-.78M15 1H9v2h6V1m8 16.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "timer-marker": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 12.5c0 2 1.28 4.23 2.42 5.83c-1.05.43-2.21.67-3.42.67a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42c.71.89 1.26 1.93 1.59 3.05A5.36 5.36 0 0 0 18.5 10c-3 0-5.5 2.5-5.5 5.5m0-1.5V7h-2v7h2m9 1.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "timer-marker-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7c2.79 0 5.2 1.64 6.32 4h.18c.75 0 1.47.16 2.12.44a8.979 8.979 0 0 0-1.59-3.05l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c1.21 0 2.37-.24 3.42-.67c-.37-.52-.75-1.11-1.1-1.73c-.73.25-1.51.4-2.32.4m10-4.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "timer-minus": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17C13.26 21 13 20.03 13 19c0-3.31 2.69-6 6-6m-6 1h-2V7h2v7m2-11H9V1h6v2m8 15v2h-8v-2h8Z"/>'
        },
        "timer-minus-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09m3-2v2h8v-2h-8Z"/>'
        },
        "timer-music": {
            body: '<path fill="currentColor" d="M16.5 16.11V11h4.27a9.053 9.053 0 0 0-1.74-3.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.42 0 .83-.04 1.24-.09c-.15-.45-.24-.91-.24-1.41c0-2.14 1.5-3.93 3.5-4.39M13 14h-2V7h2v7m2-11H9V1h6v2m7 10v2h-2v5.5a2.5 2.5 0 0 1-5 0a2.5 2.5 0 0 1 3.5-2.29V13H22Z"/>'
        },
        "timer-music-outline": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-4 11h2V8h-2v6m2.05 5.91c-.34.06-.69.09-1.05.09c-3.87 0-7-3.13-7-7s3.13-7 7-7c3.17 0 5.85 2.11 6.71 5h2.06a9.053 9.053 0 0 0-1.74-3.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.42 0 .83-.04 1.24-.09c-.15-.45-.24-.91-.24-1.41c0-.2.03-.39.05-.59M18.5 13v5.21a2.5 2.5 0 1 0-1 4.79a2.5 2.5 0 0 0 2.5-2.5V15h2v-2h-3.5Z"/>'
        },
        "timer-off": {
            body: '<path fill="currentColor" d="M3 4L1.75 5.27L4.5 8.03A8.905 8.905 0 0 0 3 13a9 9 0 0 0 9 9c1.84 0 3.55-.55 5-1.5l2.5 2.5l1.25-1.27L13.04 14L3 4m12-3H9v2h6m6 10c0 1.83-.55 3.53-1.5 4.94L13 11.45V7h-2v2.45L7.05 5.5C8.47 4.55 10.17 4 12 4c2.12 0 4.07.74 5.62 1.97l1.42-1.42l1.41 1.42l-1.42 1.42A8.963 8.963 0 0 1 21 13Z"/>'
        },
        "timer-off-outline": {
            body: '<path fill="currentColor" d="M12 20a7 7 0 0 1-7-7c0-1.28.35-2.5.95-3.5l9.55 9.54c-1 .61-2.22.96-3.5.96M3 4L1.75 5.27L4.5 8.03A8.905 8.905 0 0 0 3 13a9 9 0 0 0 9 9c1.84 0 3.55-.55 5-1.5l2.5 2.5l1.25-1.27L13.04 14L3 4m8 5.44l2 2V8h-2m4-7H9v2h6m4.04 1.55l-1.42 1.42A9.012 9.012 0 0 0 12 4c-1.83 0-3.53.55-4.95 1.5L8.5 6.94C9.53 6.35 10.73 6 12 6a7 7 0 0 1 7 7c0 1.27-.35 2.47-.94 3.5l1.44 1.44c.95-1.41 1.5-3.11 1.5-4.94c0-2.12-.74-4.07-1.97-5.61l1.42-1.42l-1.41-1.42Z"/>'
        },
        "timer-outline": {
            body: '<path fill="currentColor" d="M12 20a7 7 0 0 1-7-7a7 7 0 0 1 7-7a7 7 0 0 1 7 7a7 7 0 0 1-7 7m7.03-12.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0-9 9a9 9 0 0 0 9 9c5 0 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61M11 14h2V8h-2m4-7H9v2h6V1Z"/>'
        },
        "timer-pause": {
            body: '<path fill="currentColor" d="M16.5 16.5h1.88v5H16.5v-5m3.13 0v5h1.87v-5h-1.87M15 1H9v2h6V1m6 12.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35M13 7h-2v7h2V7Z"/>'
        },
        "timer-pause-outline": {
            body: '<path fill="currentColor" d="M21 13.35c-.64-.22-1.3-.35-2-.35c0-3.87-3.13-7-7-7s-7 3.13-7 7s3.13 7 7 7c.37 0 .72-.04 1.08-.09c.1.69.32 1.34.63 1.92c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35M11 14h2V8h-2v6m4-13H9v2h6V1m4.63 15.5v5h1.87v-5h-1.87m-3.13 5h1.88v-5H16.5v5Z"/>'
        },
        "timer-play": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 16c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6m0-12h-2v7h2V7m4 9v6l5-3l-5-3Z"/>'
        },
        "timer-play-outline": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-4 11h2V8h-2v6m8-1c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7m-2 3v6l5-3l-5-3Z"/>'
        },
        "timer-plus": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 16c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6m0-12h-2v7h2V7m7 11v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "timer-plus-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09m8-2v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "timer-refresh": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-3 15.5c0 1.27.37 2.44 1 3.44c-.33.06-.66.06-1 .06a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A9.162 9.162 0 0 1 21 12.5a6.5 6.5 0 0 0-9 6M13 7h-2v7h2V7m9 11.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "timer-refresh-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7c3.54 0 6.45 2.62 6.93 6.03c.72.05 1.41.2 2.07.47a9.162 9.162 0 0 0-1.97-5.11l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.34 0 .67 0 1-.06c-.37-.59-.65-1.25-.82-1.94H12m10-1.5v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4Z"/>'
        },
        "timer-remove": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 16c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6m0-12h-2v7h2V7m9.54 9.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "timer-remove-outline": {
            body: '<path fill="currentColor" d="M13.08 19.91c.1.69.32 1.34.63 1.92c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c0-3.87-3.13-7-7-7s-7 3.13-7 7s3.13 7 7 7c.37 0 .72-.04 1.08-.09M11 14h2V8h-2v6m4-13H9v2h6V1m7.54 15.88l-1.42-1.41L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12Z"/>'
        },
        "timer-sand": {
            body: '<path fill="currentColor" d="M6 2h12v6l-4 4l4 4v6H6v-6l4-4l-4-4V2m10 14.5l-4-4l-4 4V20h8v-3.5m-4-5l4-4V4H8v3.5l4 4M10 6h4v.75l-2 2l-2-2V6Z"/>'
        },
        "timer-sand-complete": {
            body: '<path fill="currentColor" d="M18 22H6v-6l4-4l-4-4V2h12v6l-4 4l4 4M8 7.5l4 4l4-4V4H8m4 8.5l-4 4V20h8v-3.5M14 18h-4v-.8l2-2l2 2Z"/>'
        },
        "timer-sand-empty": {
            body: '<path fill="currentColor" d="M6 2v6l4 4l-4 4v6h12v-6l-4-4l4-4V2H6m10 14.5V20H8v-3.5l4-4l4 4m-4-5l-4-4V4h8v3.5l-4 4Z"/>'
        },
        "timer-sand-full": {
            body: '<path fill="currentColor" d="M6 2v6l4 4l-4 4v6h12v-6l-4-4l4-4V2H6Z"/>'
        },
        "timer-sand-paused": {
            body: '<path fill="currentColor" d="M22 6v12h-6l-4-4l-4 4H2V6h6l4 4l4-4M7.5 16l4-4l-4-4H4v8m8.5-4l4 4H20V8h-3.5m1.5 4v2h-.8l-2-2m-6.4 0l-2 2H6v-2Z"/>'
        },
        "timer-settings": {
            body: '<path fill="currentColor" d="M19 6.4L20.5 5c-.5-.5-1-1-1.5-1.4L17.6 5C16 3.7 14.1 3 12 3c-5 0-9 4-9 9s4 9 9 9s9-4 9-9c0-2.1-.7-4.1-2-5.6M13 13h-2V6h2v7m2-13H9v2h6V0m-2 24h-2v-2h2v2m4 0h-2v-2h2v2m-8 0H7v-2h2v2Z"/>'
        },
        "timer-settings-outline": {
            body: '<path fill="currentColor" d="M12 19c-3.9 0-7-3.1-7-7s3.1-7 7-7s7 3.1 7 7s-3.1 7-7 7m7-12.6L20.5 5c-.5-.5-1-1-1.5-1.4L17.6 5C16 3.7 14.1 3 12 3c-5 0-9 4-9 9s4 9 9 9s9-4 9-9c0-2.1-.7-4.1-2-5.6M11 13h2V7h-2m4-7H9v2h6V0m-2 22h-2v2h2v-2m4 0h-2v2h2v-2m-8 0H7v2h2v-2Z"/>'
        },
        "timer-star": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 16c0 1.03.26 2 .71 2.83c-.55.11-1.12.17-1.71.17a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42A8.963 8.963 0 0 1 21 13v.35c-.64-.22-1.3-.35-2-.35c-3.31 0-6 2.69-6 6m0-12h-2v7h2V7m10 10.89l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "timer-star-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m4-7H9v2h6V1m-3 19c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09m11-2.11l-2.89-.25L19 15l-1.13 2.64l-2.87.25l2.18 1.88l-.68 2.81l2.5-1.49l2.45 1.49l-.65-2.81l2.2-1.88Z"/>'
        },
        "timer-stop": {
            body: '<path fill="currentColor" d="M19 13c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17C13.26 21 13 20.03 13 19c0-3.31 2.69-6 6-6m-6 1h-2V7h2v7m2-11H9V1h6v2m6.5 13.5v5h-5v-5h5Z"/>'
        },
        "timer-stop-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m1 12c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7c.7 0 1.36.13 2 .35V13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.59 0 1.16-.06 1.71-.17c-.31-.58-.53-1.23-.63-1.92c-.36.05-.71.09-1.08.09m3-19H9v2h6V1m1.5 15.5v5h5v-5h-5Z"/>'
        },
        "timer-sync": {
            body: '<path fill="currentColor" d="M15 3H9V1h6v2m-2 14.5c0 1.58.56 3 1.5 4.15c-.8.22-1.63.35-2.5.35a9 9 0 0 1 0-18c2.12 0 4.07.74 5.62 2l1.42-1.44c.51.44.96.9 1.41 1.41l-1.42 1.42a8.994 8.994 0 0 1 1.77 3.74A6.5 6.5 0 0 0 13 17.5M13 7h-2v7h2V7m6 6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20Z"/>'
        },
        "timer-sync-outline": {
            body: '<path fill="currentColor" d="M11 8h2v6h-2V8m1 12c-3.87 0-7-3.13-7-7s3.13-7 7-7c3.19 0 5.88 2.14 6.72 5.05c.28-.05.52-.05.78-.05c.44 0 .88.05 1.3.13c-.3-1.39-.91-2.67-1.77-3.74l1.42-1.42c-.45-.51-.9-.97-1.41-1.41L17.62 6c-1.55-1.26-3.5-2-5.62-2a9 9 0 0 0 0 18c.87 0 1.7-.13 2.5-.35c-.45-.54-.8-1.15-1.05-1.8c-.45.1-.95.15-1.45.15m3-19H9v2h6V1m4 12.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20Z"/>'
        },
        timetable: {
            body: '<path fill="currentColor" d="M14 12h1.5v2.82l2.44 1.41l-.75 1.3L14 15.69V12M4 2h14a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 13v3h4.67c-.43-.91-.67-1.93-.67-3H4m0-7h6V5H4v3m14 0V5h-6v3h6M4 13h4.29c.34-1.15.97-2.18 1.81-3H4v3m11-2.85A4.85 4.85 0 0 0 10.15 15c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0 0 19.85 15c0-2.68-2.17-4.85-4.85-4.85Z"/>'
        },
        tire: {
            body: '<path fill="currentColor" d="m19.66 9.64l-.36-.94l1.86-.7c-.92-2.12-2.56-3.82-4.62-4.86l-.8 1.78l-.92-.42l.8-1.8C14.5 2.26 13.28 2 12 2c-1.06 0-2.08.22-3.04.5l.68 1.84l-.94.36L8 2.84c-2.12.92-3.82 2.56-4.86 4.62l1.78.8l-.42.92l-1.8-.8C2.26 9.5 2 10.72 2 12c0 1.06.22 2.08.5 3.04l1.84-.68l.36.94l-1.86.7c.92 2.12 2.56 3.82 4.62 4.86l.8-1.78l.92.42l-.8 1.8c1.12.44 2.34.7 3.62.7c1.06 0 2.08-.22 3.04-.5l-.68-1.84l.94-.36l.7 1.86c2.12-.92 3.82-2.56 4.86-4.62l-1.78-.8l.42-.92l1.8.8c.44-1.12.7-2.34.7-3.62c0-1.06-.22-2.08-.5-3.04l-1.84.68m-5.36 7.9c-3.06 1.26-6.58-.18-7.84-3.24s.18-6.58 3.24-7.84s6.58.18 7.84 3.24a5.986 5.986 0 0 1-3.24 7.84Z"/>'
        },
        toaster: {
            body: '<path fill="currentColor" d="M21 11a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2H2v2h1v7h18v-7h1v-2m-5 4a2 2 0 1 1 2-2a2 2 0 0 1-2 2m1-7H6c.33-2.25 2.88-4 6-4s5.63 1.75 6 4Z"/>'
        },
        "toaster-off": {
            body: '<path fill="currentColor" d="M20.8 22.7L18.1 20H3v-7H2v-2h1c0-1.1.9-2 2-2h2.1l-6-6l1.3-1.3l19.7 19.7l-1.3 1.3m-5.5-10.6c.3-.6 1-1.1 1.7-1.1c1.1 0 2 .9 2 2c0 .8-.4 1.4-1.1 1.7l3.1 3.1V13h1v-2h-1c0-1.1-.9-2-2-2h-6.8l3.1 3.1M18 8c-.4-2.2-2.9-4-6-4c-1.4 0-2.8.4-3.8 1l3 3H18Z"/>'
        },
        "toaster-oven": {
            body: '<path fill="currentColor" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4m0 2h12v10H4V7m15 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M6 9v2h8V9H6m13 2a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "toggle-switch": {
            body: '<path fill="currentColor" d="M17 7H7a5 5 0 0 0-5 5a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 8a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3Z"/>'
        },
        "toggle-switch-off": {
            body: '<path fill="currentColor" d="M17 7H7a5 5 0 0 0-5 5a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5a5 5 0 0 0-5-5M7 15a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3Z"/>'
        },
        "toggle-switch-off-outline": {
            body: '<path fill="currentColor" d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3z"/>'
        },
        "toggle-switch-outline": {
            body: '<path fill="currentColor" d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6m0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4m0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3Z"/>'
        },
        "toggle-switch-variant": {
            body: '<path fill="currentColor" d="M18.4 1.6C18 1.2 17.5 1 17 1H7c-.5 0-1 .2-1.4.6C5.2 2 5 2.5 5 3v18c0 .5.2 1 .6 1.4c.4.4.9.6 1.4.6h10c.5 0 1-.2 1.4-.6c.4-.4.6-.9.6-1.4V3c0-.5-.2-1-.6-1.4M16 7c0 .6-.4 1-1 1H9c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v2Z"/>'
        },
        "toggle-switch-variant-off": {
            body: '<path fill="currentColor" d="M5.6 1.6C6 1.2 6.5 1 7 1h10c.5 0 1 .2 1.4.6c.4.4.6.9.6 1.4v18c0 .5-.2 1-.6 1.4c-.4.4-.9.6-1.4.6H7c-.5 0-1-.2-1.4-.6c-.4-.4-.6-.9-.6-1.4V3c0-.5.2-1 .6-1.4M8 3c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1H8m0 14c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H9c-.6 0-1-.4-1-1v-2Z"/>'
        },
        toilet: {
            body: '<path fill="currentColor" d="M9 22h8v-2.5c2.41-1.63 4-4.38 4-7.5V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8H3c0 3.09 2 6 6 7.5V22m-3.71-8h13.42A7.017 7.017 0 0 1 15 18.33V20h-4v-1.67C9 18 5.86 15.91 5.29 14M15 4h4v8h-4V4m1 1v3h2V5h-2Z"/>'
        },
        toolbox: {
            body: '<path fill="currentColor" d="M18 16h-2v-1H8v1H6v-1H2v5h20v-5h-4v1m2-8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v4h4v-2h2v2h8v-2h2v2h4v-4c0-1.1-.9-2-2-2m-5 0H9V6h6v2Z"/>'
        },
        "toolbox-outline": {
            body: '<path fill="currentColor" d="M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10h20V10c0-1.1-.9-2-2-2M9 6h6v2H9V6m11 12H4v-3h2v1h2v-1h8v1h2v-1h2v3m-2-5v-1h-2v1H8v-1H6v1H4v-3h16v3h-2Z"/>'
        },
        tools: {
            body: '<path fill="currentColor" d="m21.71 20.29l-1.42 1.42a1 1 0 0 1-1.41 0L7 9.85A3.81 3.81 0 0 1 6 10a4 4 0 0 1-3.78-5.3l2.54 2.54l.53-.53l1.42-1.42l.53-.53L4.7 2.22A4 4 0 0 1 10 6a3.81 3.81 0 0 1-.15 1l11.86 11.88a1 1 0 0 1 0 1.41M2.29 18.88a1 1 0 0 0 0 1.41l1.42 1.42a1 1 0 0 0 1.41 0l5.47-5.46l-2.83-2.83M20 2l-4 2v2l-2.17 2.17l2 2L18 8h2l2-4Z"/>'
        },
        tooltip: {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>'
        },
        "tooltip-account": {
            body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-8 2.3c1.5 0 2.7 1.2 2.7 2.7c0 1.5-1.2 2.7-2.7 2.7c-1.5 0-2.7-1.2-2.7-2.7c0-1.5 1.2-2.7 2.7-2.7M18 15H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9Z"/>'
        },
        "tooltip-cellphone": {
            body: '<path fill="currentColor" d="M9 6h6v8H9V6m13-2v12c0 1.11-.89 2-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2m-6 1.09C16 4.5 15.5 4 14.86 4H9.14C8.5 4 8 4.5 8 5.09v9.82C8 15.5 8.5 16 9.14 16h5.72c.64 0 1.14-.5 1.14-1.09V5.09Z"/>'
        },
        "tooltip-check": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-9.54 12l-3.5-3.5l1.41-1.42l2.09 2.09L15.64 6l1.41 1.41L10.46 14Z"/>'
        },
        "tooltip-check-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14h-4.83L12 19.17L8.83 16H4V4h16v12m-9.25-2.29l-3.5-3.5l1.41-1.42l2.09 2.09l4.59-4.58l1.41 1.41l-6 6Z"/>'
        },
        "tooltip-edit": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2M9.08 15H7v-2.09l6.17-6.19l2.07 2.08L9.08 15m7.76-7.8l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79Z"/>'
        },
        "tooltip-edit-outline": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12c0 1.11-.89 2-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m0 2v12h4.83L12 19.17L15.17 16H20V4H4m11.84 4.2l-1.01 1.01l-2.07-2.03l1.01-1.02c.2-.21.54-.22.78 0l1.29 1.25c.21.21.22.55 0 .79M8 11.91l4.17-4.19l2.07 2.08l-4.16 4.2H8v-2.09Z"/>'
        },
        "tooltip-image": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m15 13V7l-4 4l-2-2l-6 6h12M7 5a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "tooltip-image-outline": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v12h4.83L12 19.17L15.17 16H20V4H4m3.5 2A1.5 1.5 0 0 1 9 7.5A1.5 1.5 0 0 1 7.5 9A1.5 1.5 0 0 1 6 7.5A1.5 1.5 0 0 1 7.5 6M6 14l5-5l2 2l5-5v8H6Z"/>'
        },
        "tooltip-minus": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-4 9H8V9h8v2Z"/>'
        },
        "tooltip-minus-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14h-4.83L12 19.17L8.83 16H4V4h16v12m-4-5H8V9h8v2Z"/>'
        },
        "tooltip-outline": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v12h4.83L12 19.17L15.17 16H20V4H4Z"/>'
        },
        "tooltip-plus": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m7 4v3H8v2h3v3h2v-3h3V9h-3V6h-2Z"/>'
        },
        "tooltip-plus-outline": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v12h4.83L12 19.17L15.17 16H20V4H4m7 2h2v3h3v2h-3v3h-2v-3H8V9h3V6Z"/>'
        },
        "tooltip-question": {
            body: '<path fill="currentColor" d="M20 2H4c-.53 0-1.04.21-1.41.59C2.21 2.96 2 3.47 2 4v12c0 .53.21 1.04.59 1.41c.37.38.88.59 1.41.59h4l4 4l4-4h4c.53 0 1.04-.21 1.41-.59S22 16.53 22 16V4c0-.53-.21-1.04-.59-1.41C21.04 2.21 20.53 2 20 2m-9.95 4.04c.54-.36 1.25-.54 2.14-.54c.94 0 1.69.21 2.23.62c.54.42.81.98.81 1.68c0 .44-.15.83-.44 1.2c-.29.36-.67.64-1.13.85c-.26.15-.43.3-.52.47c-.09.18-.14.4-.14.68h-2c0-.5.1-.84.29-1.08c.21-.24.55-.52 1.07-.84c.26-.14.47-.32.64-.54c.14-.21.22-.46.22-.74c0-.3-.09-.52-.27-.69c-.18-.18-.45-.26-.76-.26c-.27 0-.49.07-.69.21c-.16.14-.26.35-.26.63H9.27c-.05-.69.23-1.29.78-1.65M11 14v-2h2v2Z"/>'
        },
        "tooltip-question-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-.53 0-1.04.21-1.41.59C2.21 2.96 2 3.47 2 4v12c0 .53.21 1.04.59 1.41c.37.38.88.59 1.41.59h4l4 4l4-4h4c.53 0 1.04-.21 1.41-.59S22 16.53 22 16V4c0-.53-.21-1.04-.59-1.41C21.04 2.21 20.53 2 20 2M4 16V4h16v12h-4.83L12 19.17L8.83 16m1.22-9.96c.54-.36 1.25-.54 2.14-.54c.94 0 1.69.21 2.23.62c.54.42.81.98.81 1.68c0 .44-.15.83-.44 1.2c-.29.36-.67.64-1.13.85c-.26.15-.43.3-.52.47c-.09.18-.14.4-.14.68h-2c0-.5.1-.84.29-1.08c.21-.24.55-.52 1.07-.84c.26-.14.47-.32.64-.54c.14-.21.22-.46.22-.74c0-.3-.09-.52-.27-.69c-.18-.18-.45-.26-.76-.26c-.27 0-.49.07-.69.21c-.16.14-.26.35-.26.63H9.27c-.05-.69.23-1.29.78-1.65M11 14v-2h2v2Z"/>'
        },
        "tooltip-remove": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m-4.46 10.12l-1.42 1.42L12 11.41l-2.12 2.13l-1.41-1.42L10.59 10L8.46 7.88l1.42-1.41L12 8.59l2.12-2.12l1.42 1.41L13.41 10l2.13 2.12Z"/>'
        },
        "tooltip-remove-outline": {
            body: '<path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4l4 4l4-4h4c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2m0 14h-4.83L12 19.17L8.83 16H4V4h16v12M8.46 12.12L10.59 10L8.46 7.88l1.42-1.41L12 8.59l2.12-2.12l1.42 1.41L13.41 10l2.13 2.12l-1.42 1.42L12 11.41l-2.12 2.13l-1.42-1.42Z"/>'
        },
        "tooltip-text": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m1 3v2h14V5H5m0 4v2h10V9H5m0 4v2h12v-2H5Z"/>'
        },
        "tooltip-text-outline": {
            body: '<path fill="currentColor" d="M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4l-4 4l-4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v12h4.83L12 19.17L15.17 16H20V4H4m2 3h12v2H6V7m0 4h10v2H6v-2Z"/>'
        },
        tooth: {
            body: '<path fill="currentColor" d="M7 2C4 2 2 5 2 8c0 2.11 1 5 2 6s2 8 4 8c4.54 0 2-7 4-7s-.54 7 4 7c2 0 3-7 4-8s2-3.89 2-6c0-3-2-6-5-6s-3 1-5 1s-2-1-5-1Z"/>'
        },
        "tooth-outline": {
            body: '<path fill="currentColor" d="M7 2C4 2 2 5 2 8c0 2.11 1 5 2 6s2 8 4 8c4.54 0 2-7 4-7s-.54 7 4 7c2 0 3-7 4-8s2-3.89 2-6c0-3-2-6-5-6s-3 1-5 1s-2-1-5-1m0 2c2 0 3 1 5 1s3-1 5-1c1.67 0 3 2 3 4c0 1.75-.86 4.11-1.81 5.06c-.86.86-2.13 6.88-2.69 6.88c-.21 0-.5-1.06-.5-2.35c0-2.04-.57-4.59-3-4.59s-3 2.55-3 4.59c0 1.29-.29 2.35-.5 2.35c-.56 0-1.83-6.02-2.69-6.88C4.86 12.11 4 9.75 4 8c0-2 1.33-4 3-4Z"/>'
        },
        toothbrush: {
            body: '<path fill="currentColor" d="m12.91 6.43l2.12 2.12l1.06-1.05l-1.06-1.07l2.83-2.83l1.06 1.06L20 3.6l-2.14-2.1M3 20.57L4.43 22L14.5 11.9l2.13-.71l4.77-4.76c.78-.78.78-2.05 0-2.83l-5.85 5.84l-2.12.71Z"/>'
        },
        "toothbrush-electric": {
            body: '<path fill="currentColor" d="M12 1.5V14c-1.66 0-3 1.34-3 3v5h8v-5c0-1.66-1.34-3-3-3V3.5a2 2 0 0 0-2-2M7.5 2v7H11V7.5H9v-4h2V2H7.5M13 17.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "toothbrush-paste": {
            body: '<path fill="currentColor" d="m17.86 1.5l-4.95 4.93l2.12 2.12l1.06-1.05l-1.06-1.07l2.83-2.83l1.06 1.06L20 3.6m1.4 0l-5.84 5.84l-2.13.71L3 20.57L4.43 22l5.65-5.67l4.25 4.24l4.24-4.24l-4.24-4.24l.17-.19l2.13-.71l4.77-4.76c.78-.78.78-2.05 0-2.83m-14.85.71L2.31 8.55l4.95 4.95l4.24-4.24m6.72 8.84l-2.13 2.12l1.41 1.41l2.13-2.13Z"/>'
        },
        tor: {
            body: '<path d="M12 14c-1 0-3 1-3 2c0 2 3 2 3 2v-1a1 1 0 0 1-1-1a1 1 0 0 1 1-1v-1m0 5s-4-.5-4-2.5c0-3 3-3.75 4-3.75V11.5c-1 0-5 1.5-5 4.5c0 4 5 4 5 4v-1M10.07 7.03l1.19.53c.43-2.44 1.58-4.06 1.58-4.06c-.43 1.03-.71 1.88-.89 2.55C13.16 3.55 15.61 2 15.61 2a15.916 15.916 0 0 0-2.64 3.53c1.58-1.68 3.77-2.78 3.77-2.78c-2.69 1.72-3.9 4.45-4.2 5.21l.55.08c0 .52 0 1 .25 1.38C14.1 11.31 18 11.47 18 16s-4.03 6-6.17 6C9.69 22 5 21.03 5 16s4.95-5.07 5.83-7.08c.12-.38-.76-1.89-.76-1.89z" fill="currentColor"/>',
            hidden: true
        },
        torch: {
            body: '<path fill="currentColor" d="M8.6 9.6c.4.6.9 1.1 1.6 1.4h4c.3-.1.5-.3.7-.5c1-1 1.4-2.5.9-3.8l-.1-.2c-.1-.3-.3-.5-.5-.7c-.1-.2-.3-.3-.4-.5c-.4-.3-.8-.6-1.2-1c-.9-.9-1-2.3-.5-3.3c-.5.1-1 .4-1.4.8C10.2 3 9.6 5.1 10.3 7v.2c0 .1-.1.2-.2.3c-.1.1-.3 0-.4-.1l-.1-.1c-.6-.8-.7-2-.3-3c-.9.8-1.4 2.1-1.3 3.4c0 .3.1.6.2.9c0 .3.2.7.4 1m3.7-1.5c.1-.5-.1-.9-.2-1.3s-.1-.8.1-1.2l.3.6c.4.6 1.1.8 1.3 1.6v.3c0 .5-.2 1-.5 1.3c-.2.1-.4.3-.6.3c-.6.2-1.3-.1-1.7-.5c.8 0 1.2-.6 1.3-1.1M15 12v2h-1l-1 8h-2l-1-8H9v-2h6Z"/>'
        },
        tortoise: {
            body: '<path fill="currentColor" d="M19.31 5.6c-1.22-.04-2.43.9-2.81 2.4c-.5 2-.5 2-1.5 3c-2 2-5 3-11 4c-1 .16-1.5.5-2 1c2 0 4 0 2.5 1.5L3 19h3l2-2c2 1 3.33 1 5.33 0l.67 2h3l-1-3s1-4 2-5s1 0 2 0s2-1 2-2.5C22 8 22 7 20.5 6c-.35-.24-.76-.38-1.19-.4M9 6a6 6 0 0 0-6 6c0 .6.13 1.08.23 1.6c5.92-.98 9.06-2.01 10.7-3.66l.5-.5A6.007 6.007 0 0 0 9 6Z"/>'
        },
        toslink: {
            body: '<path fill="currentColor" d="M20 10V7l-3-3H7L4 7v3c-1.1 0-2 .9-2 2s.9 2 2 2v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.11 0 2-.89 2-2s-.89-2-2-2m-8 6c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4m2-4c0 1.11-.89 2-2 2s-2-.89-2-2s.9-2 2-2s2 .9 2 2Z"/>'
        },
        tournament: {
            body: '<path fill="currentColor" d="M2 2v2h5v4H2v2h5c1.11 0 2-.89 2-2V7h5v10H9v-1c0-1.11-.89-2-2-2H2v2h5v4H2v2h5c1.11 0 2-.89 2-2v-1h5c1.11 0 2-.89 2-2v-4h6v-2h-6V7c0-1.11-.89-2-2-2H9V4c0-1.11-.89-2-2-2H2Z"/>'
        },
        "tow-truck": {
            body: '<path fill="currentColor" d="M15 10h5.39l-3.33-4H15v4m2.5 8.5c.39 0 .74-.13 1.04-.43c.3-.3.46-.65.46-1.07c0-.39-.16-.74-.46-1.04c-.3-.3-.65-.46-1.04-.46c-.42 0-.77.16-1.07.46c-.3.3-.43.65-.43 1.04c0 .42.13.77.43 1.07c.3.3.65.43 1.07.43M6 18.5c.44 0 .8-.13 1.08-.43s.42-.65.42-1.07c0-.39-.14-.74-.42-1.04c-.28-.3-.64-.46-1.08-.46c-.44 0-.8.16-1.08.46c-.28.3-.42.65-.42 1.04c0 .42.14.77.42 1.07c.28.3.64.43 1.08.43M18 4l5 6v7h-2.5c0 .83-.31 1.53-.91 2.13c-.59.59-1.29.87-2.09.87c-.83 0-1.53-.28-2.12-.87c-.6-.6-.88-1.3-.88-2.13H9c0 .83-.3 1.53-.89 2.13c-.61.59-1.3.87-2.11.87c-.81 0-1.5-.28-2.11-.87C3.3 18.53 3 17.83 3 17H1v-4h8.19L3 8.11V11H1V5h1l11 6.06V4h5Z"/>'
        },
        "tower-beach": {
            body: '<path fill="currentColor" d="M17 4v4h1v2h-.36L21 23h-2.07l-.56-2.17L12 17.15l-6.37 3.68L5.07 23H3l3.36-13H6V8h1V4H6V3l12-2v3h-1M7.28 14.43l-.95 3.69L10 16l-2.72-1.57M15.57 10H8.43l-.63 2.42l4.2 2.43l4.2-2.43l-.63-2.42m2.1 8.12l-.95-3.69L14 16l3.67 2.12Z"/>'
        },
        "tower-fire": {
            body: '<path fill="currentColor" d="M17 4v4h1v2h-.36L21 23h-2.07l-.56-2.17L12 17.15l-6.37 3.68L5.07 23H3l3.36-13H6V8h1V4H6V3l6-2l6 2v1h-1M7.28 14.43l-.95 3.69L10 16l-2.72-1.57M15.57 10H8.43l-.63 2.42l4.2 2.43l4.2-2.43l-.63-2.42m2.1 8.12l-.95-3.69L14 16l3.67 2.12Z"/>'
        },
        "town-hall": {
            body: '<path fill="currentColor" d="M21 10h-4V8l-4.5-1.8V4H15V2h-3.5v4.2L7 8v2H3c-.55 0-1 .45-1 1v11h8v-5h4v5h8V11c0-.55-.45-1-1-1M8 20H4v-3h4v3m0-5H4v-3h4v3m4-7c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m2 7h-4v-3h4v3m6 5h-4v-3h4v3m0-5h-4v-3h4v3Z"/>'
        },
        "toy-brick": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h18V6Z"/>'
        },
        "toy-brick-marker": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h11.54A9.55 9.55 0 0 1 13 15.5a5.58 5.58 0 0 1 5.5-5.5a5.3 5.3 0 0 1 2.5.63V6m-2.5 6a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2Z"/>'
        },
        "toy-brick-marker-outline": {
            body: '<path fill="currentColor" d="M18.5 12a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h11.54a15.55 15.55 0 0 1-1-2H5V8h14v2a5.11 5.11 0 0 1 2 .6V6Z"/>'
        },
        "toy-brick-minus": {
            body: '<path fill="currentColor" d="M23 20h-8v-2h8v2m-10-1c0-3.31 2.69-6 6-6c.7 0 1.37.13 2 .35V6h-2V5a2 2 0 0 0-2-2h-2c-1.1 0-2 .9-2 2v1h-2V5a2 2 0 0 0-2-2H7c-1.1 0-2 .9-2 2v1H3v14h10.09c-.05-.33-.09-.66-.09-1Z"/>'
        },
        "toy-brick-minus-outline": {
            body: '<path fill="currentColor" d="M13.09 20H3V6h2V5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1h2V5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1h2v7.35c-.63-.22-1.3-.35-2-.35V8H5v10h8.09c-.05.33-.09.66-.09 1s.04.67.09 1M23 18h-8v2h8v-2Z"/>'
        },
        "toy-brick-outline": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h18V6m-2 12H5V8h14Z"/>'
        },
        "toy-brick-plus": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h10.09a5.47 5.47 0 0 1-.09-1a6 6 0 0 1 8-5.66V6m-1 9v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "toy-brick-plus-outline": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h11v-2H5V8h14v5h2V6m0 9v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z"/>'
        },
        "toy-brick-remove": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h10.09a5.47 5.47 0 0 1-.09-1a6 6 0 0 1 8-5.66V6m1.54 10.88L20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.42-1.42L17.59 19l-2.13-2.12l1.42-1.42L19 17.59l2.12-2.13Z"/>'
        },
        "toy-brick-remove-outline": {
            body: '<path fill="currentColor" d="M19 6V5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v1h-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v1H3v14h11v-2H5V8h14v5h2V6m-3.12 9.46L20 17.59l2.12-2.12l1.42 1.41L21.41 19l2.13 2.12l-1.42 1.42L20 20.41l-2.12 2.13l-1.42-1.42L18.59 19l-2.12-2.12"/>'
        },
        "toy-brick-search": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h8.81A6.5 6.5 0 0 1 21 10.81V6m-.69 11.9a4.5 4.5 0 1 0-1.43 1.42L22 22.39L23.39 21m-6.89-3a2.5 2.5 0 1 1 2.5-2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "toy-brick-search-outline": {
            body: '<path fill="currentColor" d="M19 6V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H3v14h8.81a6.59 6.59 0 0 1-1.31-2H5V8h14v1.5a6.59 6.59 0 0 1 2 1.31V6m-.69 11.9a4.5 4.5 0 1 0-1.43 1.42L22 22.39L23.39 21m-6.89-3a2.5 2.5 0 1 1 2.5-2.5a2.5 2.5 0 0 1-2.5 2.5Z"/>'
        },
        "track-light": {
            body: '<path fill="currentColor" d="M6 1v2h3v3.4L4.11 4.38l-2.68 6.46l5.54 2.3l4.97 3.68l1.85.77l3.83-9.24l-1.85-.77L11 6.87V3h3V1H6m15.81 5.29l-2.31.96l.76 1.85l2.31-.96l-.76-1.85m-2.03 7.28L19 15.42l2.79 1.15l.76-1.85l-2.77-1.15m-3.59 5.36l-1.85.76l.96 2.31l1.85-.77l-.96-2.3Z"/>'
        },
        "track-light-off": {
            body: '<path fill="currentColor" d="m19.78 13.57l2.77 1.15l-.76 1.85L19 15.42l.78-1.85m2.79-5.43l-.76-1.85l-2.31.96l.76 1.85l2.31-.96m-8.23 11.55L15.3 22l1.85-.77l-.96-2.3l-1.85.76M2.39 1.73L1.11 3l2.53 2.53l-2.21 5.31l5.54 2.3l4.97 3.68l1.85.77l.56-1.35l6.49 6.49l1.27-1.27L2.39 1.73M6.2 3L6 2.8V1h8v2h-3v3.87l4.77.71l1.85.77l-1.78 4.29L9 5.8V3H6.2Z"/>'
        },
        trackpad: {
            body: '<path fill="currentColor" d="M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m0 2v8h16V5H4m0 14h7v-4H4v4m16 0v-4h-7v4h7Z"/>'
        },
        "trackpad-lock": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h11v-2h-2v-4h4.68c.82-.65 1.79-1 2.82-1c.5 0 1 .09 1.5.26V3c0-1.11-.89-2-2-2H3m0 2h16v8H3V3m0 10h7v4H3v-4m16.5 1a2.5 2.5 0 0 0-2.5 2.5v.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1v-.5a2.5 2.5 0 0 0-2.5-2.5m0 1a1.5 1.5 0 0 1 1.5 1.5v.5h-3v-.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        tractor: {
            body: '<path fill="currentColor" d="M5 4v7.26c-1.8.64-3 2.34-3 4.24C2 18 4 20 6.5 20c2.29 0 4.21-1.72 4.47-4h4.2c-.11.32-.17.66-.17 1a3 3 0 0 0 3 3a3 3 0 0 0 3-3c0-.34-.06-.68-.18-1H22v-3c0-1.11-.89-2-2-2h-4.96l-1.39-7H5m2 2h5l1 5v3h-2.26A4.53 4.53 0 0 0 7 11.03V6m-.5 7.25a2.25 2.25 0 0 1 2.25 2.25a2.25 2.25 0 0 1-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25a2.25 2.25 0 0 1 2.25-2.25M18 15.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "tractor-variant": {
            body: '<path fill="currentColor" d="m13.3 2.79l-3.5 3.5l.7.71l1.4-1.39l1.1 1.1V9c0 1.11-.89 2-2 2h-.54A6 6 0 0 1 12 15a6 6 0 0 1-.09 1h3.12a4.5 4.5 0 0 1 4.47-4a4.5 4.5 0 0 1 2.5.76V8c0-1.11-.89-2-2-2h-6.29l-1.1-1.1L14 3.5l-.7-.71M4 7c-.55 0-1 .45-1 1s.45 1 1 1h5a2 2 0 0 0-2-2H4m2 3a5 5 0 0 0-1.56.25l.36.93l-.47.18l-.33-.93a5 5 0 0 0-2.46 2.31l.91.41l-.21.45l-.9-.4A5 5 0 0 0 1 15a5 5 0 0 0 .25 1.56l.93-.36l.18.47l-.93.33a5 5 0 0 0 2.31 2.46l.4-.91l.46.21l-.4.9A5 5 0 0 0 6 20a5 5 0 0 0 1.56-.25l-.36-.93l.47-.18l.33.93a5 5 0 0 0 2.46-2.31l-.91-.4l.21-.46l.9.4A5 5 0 0 0 11 15a5 5 0 0 0-.25-1.56l-.93.36l-.18-.47l.93-.33a5 5 0 0 0-2.31-2.46l-.4.91l-.46-.21l.4-.9A5 5 0 0 0 6 10m0 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m13.5 1a3.5 3.5 0 0 0-3.5 3.5a3.5 3.5 0 0 0 3.5 3.5a3.5 3.5 0 0 0 3.5-3.5a3.5 3.5 0 0 0-3.5-3.5m0 2a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        trademark: {
            body: '<path fill="currentColor" d="M9.8 8.44H6.87V16H4.89V8.44H2V7h7.8v1.44M13.5 7l2.46 6.5L18.41 7H21v9h-2v-2.5l.22-4.26L16.63 16h-1.35L12.7 9.25l.2 4.25V16h-1.97V7h2.57Z"/>'
        },
        "traffic-cone": {
            body: '<path fill="currentColor" d="m17 15l1 4h3v3H3v-3h3l1-4h10m-2-7l1 4H8l1-4h6m-2-7l1 4h-4l1-4h2Z"/>'
        },
        "traffic-light": {
            body: '<path fill="currentColor" d="M12 9a2 2 0 0 1-2-2a2 2 0 0 1 2-2c1.11 0 2 .89 2 2a2 2 0 0 1-2 2m0 5a2 2 0 0 1-2-2a2 2 0 0 1 2-2c1.11 0 2 .89 2 2a2 2 0 0 1-2 2m0 5a2 2 0 0 1-2-2a2 2 0 0 1 2-2c1.11 0 2 .89 2 2a2 2 0 0 1-2 2m8-9h-3V8.86c1.72-.45 3-2 3-3.86h-3V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86Z"/>'
        },
        "traffic-light-outline": {
            body: '<path fill="currentColor" d="M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86m-5 9H9V5h6v14m-3-1c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m0-4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9Z"/>'
        },
        train: {
            body: '<path fill="currentColor" d="M12 2c-4 0-8 .5-8 4v9.5A3.5 3.5 0 0 0 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19a3.5 3.5 0 0 0 3.5-3.5V6c0-3.5-3.58-4-8-4M7.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 14A1.5 1.5 0 0 1 9 15.5A1.5 1.5 0 0 1 7.5 17m3.5-7H6V6h5v4m2 0V6h5v4h-5m3.5 7a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "train-car": {
            body: '<path fill="currentColor" d="M12 4H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3l-1 1v1h1l2-2.03L9 18v-5H4V6h9v2h2V7a3 3 0 0 0-3-3M5 14a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 13.77v5.51c0 .38.32.72.7.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .7-.34.7-.72v-5.51l-1.43-4.11m-8.16.34h7.19l1.03 3h-9.25l1.03-3M12 16a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1m8 0a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        "train-car-autorack": {
            body: '<path fill="currentColor" d="M21 6H3c-1.1 0-2 .9-2 2v9h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V8a2 2 0 0 0-2-2M7.58 12.18c.61 0 1.1.5 1.1 1.11s-.49 1.1-1.1 1.1c-.61 0-1.11-.49-1.11-1.1s.5-1.11 1.11-1.11m-.55-1.1l1.65-1.47h2.95l2.95 1.47H7.03m2.63 2.95h4.68c.16.39.4.72.71.97h-6.1c.31-.25.55-.58.71-.97m5.66-.74c0-.61.49-1.11 1.1-1.11c.61 0 1.11.5 1.11 1.11s-.5 1.1-1.11 1.1c-.61.01-1.1-.49-1.1-1.1M17.79 15c.32-.25.57-.58.71-.97h1.61v-.74c0-.82-.76-1.08-1.48-1.47L12 8.5H8.32l-2.21 1.84h-.74c-.82 0-1.48.66-1.48 1.48v2.21H5.5c.14.39.39.72.71.97H3V8h18v7h-3.21Z"/>'
        },
        "train-car-box": {
            body: '<path fill="currentColor" d="M1 7v10h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V7H1Z"/>'
        },
        "train-car-box-full": {
            body: '<path fill="currentColor" d="M1 7v10h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V7H1m15 9h-2v-5h-4v5H8V9h8v7Z"/>'
        },
        "train-car-box-open": {
            body: '<path fill="currentColor" d="M1 7v10h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V7H1m15 9H8V9h8v7Z"/>'
        },
        "train-car-caboose": {
            body: '<path fill="currentColor" d="M23 9V7h-8V6h1V4H8v2h1v1H1v2h1v6H1v2h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-2h-1V9h1M4 15H3V9h1v6m7-3H6V9h5v3m7 0h-5V9h5v3m3 3h-1V9h1v6Z"/>'
        },
        "train-car-centerbeam": {
            body: '<path fill="currentColor" d="M23 6v11h-1c0 1.11-.89 2-2 2s-2-.89-2-2H6c0 1.11-.89 2-2 2s-2-.89-2-2H1V6h2v9h18V6h2Z"/>'
        },
        "train-car-centerbeam-full": {
            body: '<path fill="currentColor" d="M23 6v11h-1c0 1.11-.89 2-2 2s-2-.89-2-2H6c0 1.11-.89 2-2 2s-2-.89-2-2H1V6h2v9h18V6h2M8 12H4v2h4v-2m7 0H9v2h6v-2m5 0h-4v2h4v-2M8 9H4v2h4V9m7 0H9v2h6V9m5 0h-4v2h4V9M8 6H4v2h4V6m7 0H9v2h6V6m5 0h-4v2h4V6Z"/>'
        },
        "train-car-container": {
            body: '<path fill="currentColor" d="M1 6v11h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V6H1m20 9h-2V9h-2v6h-2V9h-2v6h-2V9H9v6H7V9H5v6H3V8h18v7Z"/>'
        },
        "train-car-flatbed": {
            body: '<path fill="currentColor" d="M23 15v2h-1c0 1.11-.89 2-2 2s-2-.89-2-2H6c0 1.11-.89 2-2 2s-2-.89-2-2H1v-2h22Z"/>'
        },
        "train-car-flatbed-car": {
            body: '<path fill="currentColor" d="M23 13v-3c0-1.11-.89-2-2-2h-2l-3-4H6L3 8c-1.11 0-2 .89-2 2v3h2c0 .77.3 1.47.78 2H1v2h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-2h-2.78c.48-.53.78-1.23.78-2h2m-3.5 0c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5M12 5.5h3.25L17.14 8H12V5.5m3.78 9.5H8.22c.48-.53.78-1.23.78-2h6c0 .77.3 1.47.78 2M6.75 5.5h3.75V8H4.86l1.89-2.5m-.75 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "train-car-flatbed-tank": {
            body: '<path fill="currentColor" d="M21.22 15c.48-.53.78-1.23.78-2c0-1.66-1.34-3-3-3H5c-1.66 0-3 1.34-3 3c0 .77.3 1.47.78 2H1v2h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-2h-1.78M19 12c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m8.62-6l-.4-2H22v2h-8.38M20 9H4V8h2l1-5h5l1 5h7v1Z"/>'
        },
        "train-car-gondola": {
            body: '<path fill="currentColor" d="M1 10v7h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-7H1m20 5h-2v-2h-2v2h-2v-2h-2v2h-2v-2H9v2H7v-2H5v2H3v-3h18v3Z"/>'
        },
        "train-car-gondola-full": {
            body: '<path fill="currentColor" d="M21 10c-1.96-1.81-5.26-3-9-3s-7.04 1.19-9 3H1v7h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-7h-2m0 5h-2v-2h-2v2h-2v-2h-2v2h-2v-2H9v2H7v-2H5v2H3v-3h18v3Z"/>'
        },
        "train-car-hopper": {
            body: '<path fill="currentColor" d="M1 8v9h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V8H1m12 7v-4h-2v4H8v-4H6v4H3v-5h18v5h-3v-4h-2v4h-3Z"/>'
        },
        "train-car-hopper-covered": {
            body: '<path fill="currentColor" d="M23 9V7H1v2l1 1.33V15H1v2h1a2 2 0 1 0 4 0h4l1 1h2l1-1h4a2 2 0 1 0 4 0h1v-2h-1v-4.67L23 9M4 15v-2l1.5 2H4m1-5V9h14v1H5m15 5h-1.5l1.5-2v2Z"/>'
        },
        "train-car-hopper-full": {
            body: '<path fill="currentColor" d="M21 8c-1.96-1.81-5.26-3-9-3S4.96 6.19 3 8H1v9h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V8h-2m-8 7v-4h-2v4H8v-4H6v4H3v-5h18v5h-3v-4h-2v4h-3Z"/>'
        },
        "train-car-intermodal": {
            body: '<path fill="currentColor" d="M21 15v-4H3v4H1v2h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1v-2h-2m-5-1H8v-1h8v1m5-9H3v5h18V5m-5 3H8V7h8v1Z"/>'
        },
        "train-car-passenger": {
            body: '<path fill="currentColor" d="M21 7H3c-1.1 0-2 .9-2 2v8h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V9a2 2 0 0 0-2-2M7 12H3V9h4v3m8 0H9V9h6v3m6 0h-4V9h4v3Z"/>'
        },
        "train-car-passenger-door": {
            body: '<path fill="currentColor" d="M21 7H3c-1.1 0-2 .9-2 2v8h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V9a2 2 0 0 0-2-2M7 12H3V9h4v3m4 4H9V9h2v7m4 0h-2V9h2v7m6-4h-4V9h4v3Z"/>'
        },
        "train-car-passenger-door-open": {
            body: '<path fill="currentColor" d="M21 7H3c-1.1 0-2 .9-2 2v8h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V9a2 2 0 0 0-2-2M8 12H3V9h5v3m6 4h-4V9h4v7m7-4h-5V9h5v3Z"/>'
        },
        "train-car-passenger-variant": {
            body: '<path fill="currentColor" d="M21 7H3c-1.1 0-2 .9-2 2v8h1a2 2 0 1 0 4 0h12a2 2 0 1 0 4 0h1V9a2 2 0 0 0-2-2m-10 5H3V9h8v3m10 0h-8V9h8v3Z"/>'
        },
        "train-car-tank": {
            body: '<path fill="currentColor" d="M23 15v2h-1c0 1.11-.89 2-2 2s-2-.89-2-2H6c0 1.11-.89 2-2 2s-2-.89-2-2H1v-2h22m-2-7h-6V7H9v1H3c-1.1 0-2 .9-2 2v2a2 2 0 0 0 2 2h18c1.11 0 2-.89 2-2v-2a2 2 0 0 0-2-2Z"/>'
        },
        "train-variant": {
            body: '<path fill="currentColor" d="M18 10H6V5h12m-6 12a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2m-8-1.5A3.5 3.5 0 0 0 7.5 19L6 20.5v.5h12v-.5L16.5 19a3.5 3.5 0 0 0 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5Z"/>'
        },
        tram: {
            body: '<path fill="currentColor" d="M19 16.94V8.5c0-2.79-2.61-3.4-6-3.5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.14.11-6 .73-6 3.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06m-7 1.56a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m5-4.5H7V9h10v5Z"/>'
        },
        "tram-side": {
            body: '<path fill="currentColor" d="M9 1L5 4l2.5 2H5S2 6 2 9v10h5s0-2 2-2h13v-3h-4V8h4V6H10.5L13 4L9 1M4 8h5v6H4V8m7 0h5v6h-5V8m-7 8h1v2H4v-2m5 3v.5a2.5 2.5 0 0 0 2.5 2.5c1 0 1.89-.59 2.29-1.5h1.42c.4.91 1.29 1.5 2.29 1.5a2.5 2.5 0 0 0 2.5-2.5V19H9Z"/>'
        },
        transcribe: {
            body: '<path fill="currentColor" d="M20 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.11.89-2 2-2h16m-2 12v-2h-5.5l-2 2H18M6 17h2.5l6.85-6.88c.2-.19.2-.51 0-.71l-1.76-1.76c-.2-.2-.52-.2-.71 0L6 14.53V17Z"/>'
        },
        "transcribe-close": {
            body: '<path fill="currentColor" d="m12 23l-4-4h8l-4 4m8-20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16m-2 12v-2h-5.5l-2 2H18M6 15h2.5l6.85-6.88c.2-.19.2-.51 0-.7l-1.76-1.77c-.2-.2-.52-.2-.71 0L6 12.53V15Z"/>'
        },
        transfer: {
            body: '<path fill="currentColor" d="M8 4a2 2 0 0 0-2 2v4h2V6h8v3h-2.5l3.5 3.5L20.5 9H18V6a2 2 0 0 0-2-2H8m-5 8v2h8v-2H3m0 3v2h8v-2H3m10 0v2h8v-2h-8M3 18v2h8v-2H3m10 0v2h8v-2h-8Z"/>'
        },
        "transfer-down": {
            body: '<path fill="currentColor" d="M16 3v2H8V3h8m0 4v2H8V7h8m0 4v2H8v-2h8M5 15h14l-7 7l-7-7Z"/>'
        },
        "transfer-left": {
            body: '<path fill="currentColor" d="M21 16h-2V8h2v8m-4 0h-2V8h2v8m-4 0h-2V8h2v8M9 5v14l-7-7l7-7Z"/>'
        },
        "transfer-right": {
            body: '<path fill="currentColor" d="M3 8h2v8H3V8m4 0h2v8H7V8m4 0h2v8h-2V8m4 11.25V4.75L22.25 12L15 19.25Z"/>'
        },
        "transfer-up": {
            body: '<path fill="currentColor" d="M8 21v-2h8v2H8m0-4v-2h8v2H8m0-4v-2h8v2H8m11-4H5l7-7l7 7Z"/>'
        },
        "transit-connection": {
            body: '<path fill="currentColor" d="M15 12c0-1.3-.84-2.4-2-2.82V6.82C14.16 6.4 15 5.3 15 4a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 1.3.84 2.4 2 2.82v2.37C9.84 9.6 9 10.7 9 12s.84 2.4 2 2.82v2.36C9.84 17.6 9 18.7 9 20a3 3 0 0 0 3 3a3 3 0 0 0 3-3c0-1.3-.84-2.4-2-2.82v-2.36c1.16-.42 2-1.52 2-2.82m-3-9a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m0 18a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        "transit-connection-horizontal": {
            body: '<path fill="currentColor" d="M12 9c-1.3 0-2.4.8-2.8 2H6.8C6.4 9.8 5.3 9 4 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2h2.4c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2h2.4c.4 1.2 1.5 2 2.8 2c1.7 0 3-1.3 3-3s-1.3-3-3-3c-1.3 0-2.4.8-2.8 2h-2.4c-.4-1.2-1.5-2-2.8-2m-9 3c0-.6.4-1 1-1s1 .4 1 1s-.4 1-1 1s-1-.4-1-1m18 0c0 .6-.4 1-1 1s-1-.4-1-1s.4-1 1-1s1 .4 1 1Z"/>'
        },
        "transit-connection-variant": {
            body: '<path fill="currentColor" d="M18 11h-3.18C14.4 9.84 13.3 9 12 9c-1.3 0-2.4.84-2.82 2H6c-.33 0-2-.1-2-2V8c0-1.83 1.54-2 2-2h10.18C16.6 7.16 17.7 8 19 8a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-1.3 0-2.4.84-2.82 2H6C4.39 4 2 5.06 2 8v1c0 2.94 2.39 4 4 4h3.18c.42 1.16 1.52 2 2.82 2c1.3 0 2.4-.84 2.82-2H18c.33 0 2 .1 2 2v1c0 1.83-1.54 2-2 2H7.82C7.4 16.84 6.3 16 5 16a3 3 0 0 0-3 3a3 3 0 0 0 3 3c1.3 0 2.4-.84 2.82-2H18c1.61 0 4-1.07 4-4v-1c0-2.93-2.39-4-4-4m1-7a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M5 20a1 1 0 0 1-1-1a1 1 0 0 1 1-1a1 1 0 0 1 1 1a1 1 0 0 1-1 1Z"/>'
        },
        "transit-detour": {
            body: '<path fill="currentColor" d="M19 3a3 3 0 0 0-2.39 1.21A11.5 11.5 0 0 0 13.75 4l.13 2a9.47 9.47 0 0 1 2.12.13A3 3 0 1 0 19 3m0 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1m-10.14.86L7.67 6.25a11.5 11.5 0 0 1 3.93-1.88l.5 1.94a9.5 9.5 0 0 0-3.24 1.55M21 18a3 3 0 1 1-5.31-1.89a9.47 9.47 0 0 0-7.1-2.65c-.22.01-.43.04-.65.08a3 3 0 1 1-3.55-3.48A11.54 11.54 0 0 1 6.04 7.7L7.5 9.06a9.34 9.34 0 0 0-1 1.35a3.04 3.04 0 0 1 1.12 1.15c.29-.06.57-.06.88-.1a11.47 11.47 0 0 1 8.96 3.59A2.96 2.96 0 0 1 18 15a3 3 0 0 1 3 3Z"/>'
        },
        "transit-skip": {
            body: '<path fill="currentColor" d="M21 12c0-4-2.5-7.3-6-8.5c-.3-1.4-1.5-2.5-3-2.5c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.1 0 2.1-.6 2.6-1.5C17.2 6.5 19 9 19 12c0 2.9-1.8 5.5-4.4 6.5c-.5-.9-1.5-1.5-2.6-1.5c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.5 0 2.7-1.1 3-2.5c3.5-1.2 6-4.6 6-8.5m-9-7c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m0 16c-.6 0-1-.4-1-1s.4-1 1-1s1 .4 1 1s-.4 1-1 1m0-12c1.7 0 3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3s1.3-3 3-3Z"/>'
        },
        "transit-transfer": {
            body: '<path fill="currentColor" d="M16.5 15.5H22V17h-5.5v1.75l-2.5-2.5l2.5-2.5v1.75m3 4.25V18l2.5 2.5l-2.5 2.5v-1.75H14v-1.5h5.5M9.5 5.5a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2M5.75 8.9L4 9.65V13H2V8.3l5.25-2.15c.25-.1.5-.15.75-.15c.7 0 1.35.35 1.7.95l.95 1.6C11.55 10 13.15 11 15 11v2c-2.2 0-4.15-1-5.45-2.6l-.6 3L11 15.45V23H9v-6l-2.15-2l-1.75 8H3L5.75 8.9Z"/>'
        },
        transition: {
            body: '<path fill="currentColor" d="M15 2a7 7 0 0 1 7 7c0 2.71-1.54 5.05-3.78 6.22a7.117 7.117 0 0 1-3 3A7.014 7.014 0 0 1 9 22a7 7 0 0 1-7-7c0-2.71 1.54-5.05 3.78-6.22a7.117 7.117 0 0 1 3-3A7.014 7.014 0 0 1 15 2m-3 17a7 7 0 0 1-7-7c-.63.84-1 1.87-1 3a5 5 0 0 0 5 5c1.13 0 2.16-.37 3-1m3-3a7 7 0 0 1-7-7c-.63.84-1 1.87-1 3a5 5 0 0 0 5 5c1.13 0 2.16-.37 3-1m0-12c-1.13 0-2.16.37-3 1a7 7 0 0 1 7 7c.63-.84 1-1.87 1-3a5 5 0 0 0-5-5m-5 5a5 5 0 0 0 5 5c.6 0 1.17-.1 1.7-.3c.2-.53.3-1.1.3-1.7a5 5 0 0 0-5-5c-.6 0-1.17.1-1.7.3c-.2.53-.3 1.1-.3 1.7Z"/>'
        },
        "transition-masked": {
            body: '<path fill="currentColor" d="M15 2c1.94 0 3.59.7 4.95 2.05C21.3 5.41 22 7.06 22 9c0 1.56-.5 2.96-1.42 4.2c-.94 1.23-2.14 2.07-3.61 2.5l.03-.32V15c0-2.19-.77-4.07-2.35-5.65S11.19 7 9 7h-.37l-.33.03c.43-1.47 1.27-2.67 2.5-3.61C12.04 2.5 13.44 2 15 2M9 8a7 7 0 0 1 7 7a7 7 0 0 1-7 7a7 7 0 0 1-7-7a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5Z"/>'
        },
        translate: {
            body: '<path fill="currentColor" d="m12.87 15.07l-2.54-2.51l.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5l3.11 3.11l.76-2.04M18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12m-2.62 7l1.62-4.33L19.12 17h-3.24Z"/>'
        },
        "translate-off": {
            body: '<path fill="currentColor" d="M12.17 5.81c-.3.88-.7 1.74-1.17 2.58l1.35 1.35c.76-1.24 1.36-2.56 1.78-3.93h3.03V3.75H9.94V1.69H7.87v2.06h-1.5l2.06 2.06h3.74m3.36 7.1l1.5 1.5l.64-1.72l1.41 3.78l3.31 3.3l-3.69-9.83h-2.06l-1.11 2.97M1.31 1.31L0 2.62l1.13 1.13H.65v2.06h2.54l2.07 2.07h-.8c.75 1.68 1.78 3.27 3.07 4.7l-5.25 5.18l1.47 1.46l5.16-5.15l3.2 3.2l.69-1.84l1.3 1.29l-2.1 5.59h2.06l1.16-3.09h1.38L21.38 24l1.31-1.31L1.31 1.31Z"/>'
        },
        "translate-variant": {
            body: '<path fill="currentColor" d="M11 1H3c-1.1 0-2 .9-2 2v12l3-3h5v-1c0-2.2 1.79-4 4-4V3c0-1.1-.9-2-2-2m0 3H9.5c-.34 1.19-.96 2.3-1.82 3.26l-.02.02l1.26 1.25l-.37 1.01L7 8l-2.5 2.5l-.69-.73l2.53-2.49A8.58 8.58 0 0 1 4.86 5h.99c.31.6.69 1.17 1.15 1.68A7.69 7.69 0 0 0 8.57 4H3V3h3.5V2h1v1H11v1m10 5h-8c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7l3 3V11c0-1.1-.9-2-2-2m-1.37 10l-.85-2.25h-3.56L14.38 19h-1.5l3.37-9h1.5l3.38 9h-1.5M17 12l1.22 3.25h-2.43L17 12Z"/>'
        },
        "transmission-tower": {
            body: '<path fill="currentColor" d="m8.28 5.45l-1.78-.9L7.76 2h8.47l1.27 2.55l-1.78.89L15 4H9l-.72 1.45M18.62 8h-4.53l-.79-3h-2.6l-.79 3H5.38L4.1 10.55l1.79.89l.73-1.44h10.76l.72 1.45l1.79-.89L18.62 8m-.85 14H15.7l-.24-.9L12 15.9l-3.47 5.2l-.23.9H6.23l2.89-11h2.07l-.36 1.35L12 14.1l1.16-1.75l-.35-1.35h2.07l2.89 11m-6.37-7l-.9-1.35l-1.18 4.48L11.4 15m3.28 3.12l-1.18-4.48l-.9 1.36l2.08 3.12Z"/>'
        },
        "transmission-tower-export": {
            body: '<path fill="currentColor" d="m5.18 5.45l-1.78-.9L4.66 2h8.47l1.27 2.55l-1.78.89L11.9 4h-6l-.72 1.45M15.5 8H11l-.8-3H7.6l-.79 3H2.28L1 10.55l1.79.89L3.5 10h10.78l.72 1.45l1.79-.89L15.5 8m-.83 14H12.6l-.24-.9l-3.46-5.2l-3.47 5.2l-.23.9H3.13L6 11h2.09l-.36 1.35L8.9 14.1l1.16-1.75L9.71 11h2.07l2.89 11M8.3 15l-.9-1.35l-1.18 4.48L8.3 15m3.28 3.12l-1.18-4.48L9.5 15l2.08 3.12M23 16l-4-4v3h-4v2h4v3l4-4Z"/>'
        },
        "transmission-tower-import": {
            body: '<path fill="currentColor" d="m11.39 5.45l-1.78-.9L10.87 2h8.47l1.27 2.55l-1.78.89L18.11 4h-6l-.72 1.45M21.73 8H17.2l-.79-3h-2.6L13 8H8.5l-1.29 2.55l1.79.89l.73-1.44H20.5l.71 1.45l1.79-.89L21.73 8m-.85 14h-2.07l-.24-.9l-3.46-5.2l-3.47 5.2l-.23.9H9.34l2.89-11h2.07l-.36 1.35l1.17 1.75l1.16-1.75l-.35-1.35H18l2.88 11m-6.38-7l-.89-1.35l-1.18 4.48L14.5 15m3.29 3.12l-1.18-4.48l-.9 1.36l2.08 3.12M9 16l-4-4v3H1v2h4v3l4-4Z"/>'
        },
        "transmission-tower-off": {
            body: '<path fill="currentColor" d="M22.1 21.5L2.4 1.7L1.1 3l5 5h-.7l-1.3 2.5l1.8.9l.7-1.4h1.5l1 1l-2.9 11h2.1l.2-.9l3.5-5.2l3.5 5.2l.2.9h2.1l-.8-3.2l3.9 3.9l1.2-1.2M9.3 18.1l1.2-4.5l.9 1.3l-2.1 3.2m5.4 0L12.6 15l.2-.3l1.3 1.3l.6 2.1m-.5-7.1h.7l.2.9l-.9-.9m-.1-3h4.5l1.3 2.6l-1.8.9l-.7-1.5h-4.2l-3-3l.5-2h2.6l.8 3M8.4 5.2L6.9 3.7L7.8 2h8.5l1.3 2.5l-1.8.9L15 4H9l-.6 1.2Z"/>'
        },
        "trash-can": {
            body: '<path fill="currentColor" d="M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3H9m0 5h2v9H9V8m4 0h2v9h-2V8Z"/>'
        },
        "trash-can-outline": {
            body: '<path fill="currentColor" d="M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3H9M7 6h10v13H7V6m2 2v9h2V8H9m4 0v9h2V8h-2Z"/>'
        },
        tray: {
            body: '<path fill="currentColor" d="M2 12h2v5h16v-5h2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2Z"/>'
        },
        "tray-alert": {
            body: '<path fill="currentColor" d="M2 12h2v5h16v-5h2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2m11-5h-2v2h2m0-10h-2v6h2Z"/>'
        },
        "tray-arrow-down": {
            body: '<path fill="currentColor" d="M2 12h2v5h16v-5h2v5c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-5m10 3l5.55-5.46l-1.42-1.41L13 11.25V2h-2v9.25L7.88 8.13L6.46 9.55L12 15Z"/>'
        },
        "tray-arrow-up": {
            body: '<path fill="currentColor" d="M2 12h2v5h16v-5h2v5c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-5M12 2L6.46 7.46l1.42 1.42L11 5.75V15h2V5.75l3.13 3.13l1.42-1.43L12 2Z"/>'
        },
        "tray-full": {
            body: '<path fill="currentColor" d="M18 5H6v2h12M6 9h12v2H6m-4 1h2v5h16v-5h2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2m16-4H6v2h12Z"/>'
        },
        "tray-minus": {
            body: '<path fill="currentColor" d="M16 10H8V8h8M2 17a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5h-2v5H4v-5H2Z"/>'
        },
        "tray-plus": {
            body: '<path fill="currentColor" d="M2 12h2v5h16v-5h2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2m9-12h2v3h3v2h-3v3h-2v-3H8V8h3Z"/>'
        },
        "tray-remove": {
            body: '<path fill="currentColor" d="M2 17a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5h-2v5H4v-5H2m12.12-6.54l1.42 1.42L13.41 9l2.13 2.12l-1.42 1.42L12 10.41l-2.12 2.13l-1.42-1.42L10.59 9L8.46 6.88l1.42-1.42L12 7.59Z"/>'
        },
        "treasure-chest": {
            body: '<path fill="currentColor" d="M5 4h14a3 3 0 0 1 3 3v4h-7v-1H9v1H2V7a3 3 0 0 1 3-3m6 7h2v2h-2v-2m-9 1h7v1l2 2h2l2-2v-1h7v8H2v-8Z"/>'
        },
        tree: {
            body: '<path fill="currentColor" d="M11 21v-4.26c-.47.17-.97.26-1.5.26C7 17 5 15 5 12.5c0-1.27.5-2.41 1.36-3.23C6.13 8.73 6 8.13 6 7.5C6 5 8 3 10.5 3c1.56 0 2.94.8 3.75 2h.25a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5c-.5 0-1-.07-1.5-.21V21h-2Z"/>'
        },
        "tree-outline": {
            body: '<path fill="currentColor" d="M10.5 3a4.481 4.481 0 0 0-4.13 6.27C5.5 10.12 5 11.28 5 12.5C5 15 7 17 9.5 17c.5 0 1-.11 1.5-.28V21h2v-5.23c.5.14 1 .23 1.5.23a5.5 5.5 0 0 0 5.5-5.5A5.5 5.5 0 0 0 14.5 5h-.26C13.41 3.76 12 3 10.5 3m0 2c1.32 0 2.41 1.03 2.5 2.35c.46-.23 1-.35 1.5-.35a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5c-.96 0-1.87-.39-2.54-1.09A2.491 2.491 0 0 1 9.5 15A2.5 2.5 0 0 1 7 12.5c0-1.38.8-1.96 2-2.71c-.8-1.03-1-1.63-1-2.29A2.5 2.5 0 0 1 10.5 5Z"/>'
        },
        trello: {
            body: '<path fill="currentColor" d="M19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 19.5 2m-8.8 15.2a1.2 1.2 0 0 1-1.2 1.2H5.8c-.66 0-1.2-.54-1.2-1.2V5.8a1.2 1.2 0 0 1 1.2-1.2h3.7c.66 0 1.2.54 1.2 1.2v11.4m8.7-5c0 .66-.54 1.2-1.2 1.2h-3.7c-.66 0-1.2-.54-1.2-1.2V5.8c0-.66.54-1.2 1.2-1.2h3.7c.66 0 1.2.54 1.2 1.2v6.4Z"/>'
        },
        "trending-down": {
            body: '<path fill="currentColor" d="m16 18l2.29-2.29l-4.88-4.88l-4 4L2 7.41L3.41 6l6 6l4-4l6.3 6.29L22 12v6h-6Z"/>'
        },
        "trending-neutral": {
            body: '<path fill="currentColor" d="m22 12l-4-4v3H3v2h15v3l4-4Z"/>'
        },
        "trending-up": {
            body: '<path fill="currentColor" d="m16 6l2.29 2.29l-4.88 4.88l-4-4L2 16.59L3.41 18l6-6l4 4l6.3-6.29L22 12V6h-6Z"/>'
        },
        triangle: {
            body: '<path fill="currentColor" d="M1 21h22L12 2"/>'
        },
        "triangle-outline": {
            body: '<path fill="currentColor" d="M12 2L1 21h22M12 6l7.53 13H4.47"/>'
        },
        "triangle-small-down": {
            body: '<path fill="currentColor" d="M8 9h8l-4 7"/>'
        },
        "triangle-small-up": {
            body: '<path fill="currentColor" d="M8 15h8l-4-7"/>'
        },
        "triangle-wave": {
            body: '<path fill="currentColor" d="m22 12l-5 10L7.1 6.04L4.24 12H2L7 2l9.9 15.96L19.76 12H22Z"/>'
        },
        triforce: {
            body: '<path fill="currentColor" d="M1.5 21L12 3.5L22.5 21h-21M12 21l5-9H7l5 9Z"/>'
        },
        trophy: {
            body: '<path fill="currentColor" d="M18 2c-.9 0-2 1-2 2H8c0-1-1.1-2-2-2H2v9c0 1 1 2 2 2h2.2c.4 2 1.7 3.7 4.8 4v2.08C8 19.54 8 22 8 22h8s0-2.46-3-2.92V17c3.1-.3 4.4-2 4.8-4H20c1 0 2-1 2-2V2h-4M6 11H4V4h2v7m14 0h-2V4h2v7Z"/>'
        },
        "trophy-award": {
            body: '<path fill="currentColor" d="m15.2 10.7l1.4 5.3l-4.6-3.8L7.4 16l1.4-5.2l-4.2-3.5L10 7l2-5l2 5l5.4.3l-4.2 3.4M14 19h-1v-3l-1-1l-1 1v3h-1c-1.1 0-2 .9-2 2v1h8v-1a2 2 0 0 0-2-2Z"/>'
        },
        "trophy-broken": {
            body: '<path fill="currentColor" d="M6.2 13c.4 1.8 1.4 3.3 3.8 3.8v2.54C8 20.12 8 22 8 22h5.2l-3-7l4-5l-3.5-6H8c0-1-1.1-2-2-2H2v9c0 1 1 2 2 2h2.2M6 11H4V4h2v7m11.8 2H20c1 0 2-1 2-2V2h-4c-.9 0-2 1-2 2h-2.1l2.8 6l-4.5 5l1 7H16s0-1.88-2-2.66v-2.49c2.39-.5 3.5-2.15 3.8-3.85m2.2-2h-2V4h2v7Z"/>'
        },
        "trophy-outline": {
            body: '<path fill="currentColor" d="M18 2c-.9 0-2 1-2 2H8c0-1-1.1-2-2-2H2v9c0 1 1 2 2 2h2.2c.4 2 1.7 3.7 4.8 4v2.08C8 19.54 8 22 8 22h8s0-2.46-3-2.92V17c3.1-.3 4.4-2 4.8-4H20c1 0 2-1 2-2V2h-4M6 11H4V4h2v7m10 .5c0 1.93-.58 3.5-4 3.5c-3.41 0-4-1.57-4-3.5V6h8v5.5m4-.5h-2V4h2v7Z"/>'
        },
        "trophy-variant": {
            body: '<path fill="currentColor" d="M17 4V2H7v2H2v7c0 1.1.9 2 2 2h3.1a5.01 5.01 0 0 0 3.9 3.9v2.18C8 19.54 8 22 8 22h8s0-2.46-3-2.92V16.9a5.01 5.01 0 0 0 3.9-3.9H20c1.1 0 2-.9 2-2V4h-5M4 11V6h3v5H4m16 0h-3V6h3v5Z"/>'
        },
        "trophy-variant-outline": {
            body: '<path fill="currentColor" d="M17 4V2H7v2H2v7c0 1.1.9 2 2 2h3.1a5.01 5.01 0 0 0 3.9 3.9v2.18C8 19.54 8 22 8 22h8s0-2.46-3-2.92V16.9a5.01 5.01 0 0 0 3.9-3.9H20c1.1 0 2-.9 2-2V4h-5M4 11V6h3v5H4m11 1c0 1.65-1.35 3-3 3s-3-1.35-3-3V4h6v8m5-1h-3V6h3v5Z"/>'
        },
        truck: {
            body: '<path fill="currentColor" d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5H17V9.5m-11 9A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4Z"/>'
        },
        "truck-alert": {
            body: '<path fill="currentColor" d="M3 4c-1.1 0-2 .9-2 2v11h2c0 1.7 1.3 3 3 3s3-1.3 3-3h6c0 1.7 1.3 3 3 3s3-1.3 3-3h2v-5l-3-4h-3V4H3m5 2h2v4H8V6m9 3.5h2.5l2 2.5H17V9.5M8 12h2v2H8v-2m-2 3.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5m12 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        "truck-alert-outline": {
            body: '<path fill="currentColor" d="M8 12h2v2H8v-2m0-5h2v4H8V7m10 11.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5m1.5-9H17V12h4.5l-2-2.5M6 18.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.7-1.3 3-3 3s-3-1.3-3-3H9c0 1.7-1.3 3-3 3s-3-1.3-3-3H1V6c0-1.1.9-2 2-2h14v4h3M3 6v9h.8c.5-.6 1.4-1 2.2-1s1.7.4 2.2 1H15V6H3Z"/>'
        },
        "truck-cargo-container": {
            body: '<path fill="currentColor" d="M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4M6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M15 7h-2v7h-2V7H9v7H7V7H5v7H3V6h12v1m3 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5H17Z"/>'
        },
        "truck-check": {
            body: '<path fill="currentColor" d="M3 4h14v4h3l3 4v5h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3H9a3 3 0 0 1-3 3a3 3 0 0 1-3-3H1V6a2 2 0 0 1 2-2m14 5.5V12h4.47L19.5 9.5H17m-11 6A1.5 1.5 0 0 0 4.5 17A1.5 1.5 0 0 0 6 18.5A1.5 1.5 0 0 0 7.5 17A1.5 1.5 0 0 0 6 15.5m12 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M8 14l6-6l-1.41-1.42L8 11.17L5.91 9.08L4.5 10.5L8 14Z"/>'
        },
        "truck-check-outline": {
            body: '<path fill="currentColor" d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3M3 6v9h.76c.55-.61 1.35-1 2.24-1c.89 0 1.69.39 2.24 1H15V6H3m2 4.5L6.5 9L8 10.5L11.5 7L13 8.5l-5 5l-3-3Z"/>'
        },
        "truck-delivery": {
            body: '<path fill="currentColor" d="M3 4a2 2 0 0 0-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5l-3-4h-3V4m-7 2l4 4l-4 4v-3H4V9h6m7 .5h2.5l1.97 2.5H17M6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "truck-delivery-outline": {
            body: '<path fill="currentColor" d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3M3 6v9h.76c.55-.61 1.35-1 2.24-1c.89 0 1.69.39 2.24 1H15V6H3m7 1l3.5 3.5L10 14v-2.5H5v-2h5V7Z"/>'
        },
        "truck-fast": {
            body: '<path fill="currentColor" d="M3 13.5L2.25 12H7.5l-.6-1.5H2L1.25 9h7.8l-.6-1.5H1.11L.25 6H4a2 2 0 0 1 2-2h12v4h3l3 4v5h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3h-4a3 3 0 0 1-3 3a3 3 0 0 1-3-3H4v-3.5H3m16 5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5m1.5-9H18V12h4.46L20.5 9.5M9 18.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 9 15.5A1.5 1.5 0 0 0 7.5 17A1.5 1.5 0 0 0 9 18.5Z"/>'
        },
        "truck-fast-outline": {
            body: '<path fill="currentColor" d="M.75 7.5h9.75l.75 1.5H1.5L.75 7.5m1 3h9.75l.75 1.5H2.5l-.75-1.5m16.25 8c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M8 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3h-4c0 1.66-1.35 3-3 3c-1.66 0-3-1.34-3-3H3v-3.5h2V15h.76c.55-.61 1.35-1 2.24-1c.89 0 1.69.39 2.24 1H15V6H3c0-1.11.89-2 2-2h12v4h3Z"/>'
        },
        "truck-flatbed": {
            body: '<path fill="currentColor" d="M18 4h-5v9H1v4h2c0 .83.3 1.53.89 2.13c.61.59 1.3.87 2.11.87s1.5-.28 2.11-.87c.59-.6.89-1.3.89-2.13h5.5c0 .83.28 1.53.88 2.13c.59.59 1.29.87 2.12.87c.8 0 1.5-.28 2.09-.87c.6-.6.91-1.3.91-2.13H23v-7l-5-6M7.08 18.07c-.28.3-.64.43-1.08.43s-.8-.13-1.08-.43s-.42-.65-.42-1.07c0-.39.14-.74.42-1.04c.28-.3.64-.46 1.08-.46s.8.16 1.08.46c.28.3.42.65.42 1.04c0 .42-.14.77-.42 1.07m11.46 0c-.3.3-.65.43-1.04.43c-.42 0-.77-.13-1.07-.43S16 17.42 16 17c0-.39.13-.74.43-1.04c.3-.3.65-.46 1.07-.46c.39 0 .74.16 1.04.46c.3.3.46.65.46 1.04c0 .42-.16.77-.46 1.07M15 10V6h2.06l3.33 4H15Z"/>'
        },
        "truck-minus": {
            body: '<path fill="currentColor" d="M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4M6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m7-7.5H5V9h8v2m5 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5H17"/>'
        },
        "truck-minus-outline": {
            body: '<path fill="currentColor" d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.7 1.3 3 3 3s3-1.3 3-3h6c0 1.7 1.3 3 3 3s3-1.3 3-3h2v-5l-3-4M6 18.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m9-3.5H8.2c-.5-.6-1.3-1-2.2-1s-1.7.4-2.2 1H3V6h12v9m3 3.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M17 12V9.5h2.5l2 2.5H17M6 11V9h6v2H6Z"/>'
        },
        "truck-outline": {
            body: '<path fill="currentColor" d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3M3 6v9h.76c.55-.61 1.35-1 2.24-1c.89 0 1.69.39 2.24 1H15V6H3Z"/>'
        },
        "truck-plus": {
            body: '<path fill="currentColor" d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46L19.5 9.5M6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3M8 6v3H5v2h3v3h2v-3h3V9h-3V6H8Z"/>'
        },
        "truck-plus-outline": {
            body: '<path fill="currentColor" d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.7 1.3 3 3 3s3-1.3 3-3h6c0 1.7 1.3 3 3 3s3-1.3 3-3h2v-5l-3-4M6 18.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5m9-3.5H8.2c-.5-.6-1.3-1-2.2-1s-1.7.4-2.2 1H3V6h12v9m3 3.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M17 12V9.5h2.5l2 2.5H17m-9-1H6V9h2V7h2v2h2v2h-2v2H8v-2Z"/>'
        },
        "truck-remove": {
            body: '<path fill="currentColor" d="M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4M6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m6.54-6.38l-1.42 1.42L9 11.41l-2.12 2.13l-1.41-1.42L7.59 10L5.46 7.88l1.42-1.41L9 8.59l2.12-2.12l1.42 1.41L10.41 10l2.13 2.12M18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5H17Z"/>'
        },
        "truck-remove-outline": {
            body: '<path fill="currentColor" d="M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4M6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m9-3.5H8.24c-.55-.61-1.35-1-2.24-1s-1.69.39-2.24 1H3V6h12v9m3 3.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5H17m-11.18-.23L7.59 10L5.82 8.23l1.41-1.41L9 8.59l1.77-1.77l1.41 1.41L10.41 10l1.77 1.77l-1.41 1.41L9 11.41l-1.77 1.77l-1.41-1.41Z"/>'
        },
        "truck-snowflake": {
            body: '<path fill="currentColor" d="M17 4H3c-1.1 0-2 .9-2 2v11h2c0 1.7 1.3 3 3 3s3-1.3 3-3h6c0 1.7 1.3 3 3 3s3-1.3 3-3h2v-5l-3-4h-3V4m-6.8 1.3h.3c.5.1.8.6.7 1.1l-.5 2l2-.5c.5-.1 1 .2 1.1.7c.1.5-.2 1-.6 1.1l-2 .5l1.4 1.4c.4.3.4.9 0 1.3c-.3.4-.9.4-1.3 0l-1.5-1.4l-.5 2c-.1.5-.6.8-1.1.6a.8.8 0 0 1-.6-1.1l.5-2l-2 .5c-.5.1-1-.2-1.1-.6c-.1-.5.2-1 .6-1.1l2-.5l-1.4-1.6c-.3-.3-.3-.9 0-1.3c.3-.3.9-.3 1.3 0l1.4 1.4l.5-2c.1-.2.4-.5.8-.5M17 9.5h2.5l2 2.5H17V9.5m-11 6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5m12 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5Z"/>'
        },
        "truck-trailer": {
            body: '<path fill="currentColor" d="M22 15v2H10a3 3 0 0 1-3 3a3 3 0 0 1-3-3H2V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9h3M7 16a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        trumpet: {
            body: '<path fill="currentColor" d="M22 6c-1 5-7 5-7 5H4c-1 0-2-1-2-1H1v4h1s1-1 2-1h.3c-.2.3-.3.6-.3 1v2c0 1.1.9 2 2 2h1v1h2v-1h1v1h2v-1h1v1h2v-1h1c1.1 0 2-.9 2-2v-2c0-.1 0-.3-.1-.4c1.7.6 3.5 1.8 4.1 4.4h1V6h-1M6 16.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h1v3H6m3 0v-3h1v3H9m3 0v-3h1v3h-1m4.5-.5c0 .3-.2.5-.5.5h-1v-3h1c.3 0 .5.2.5.5v2M9 10H7V9h2v1m3 0h-2V9h2v1m3 0h-2V9h2v1Z"/>'
        },
        "tshirt-crew": {
            body: '<path fill="currentColor" d="M16 21H8a1 1 0 0 1-1-1v-7.93l-1.3 1a.996.996 0 0 1-1.41 0l-2.83-2.78a.996.996 0 0 1 0-1.41L7.34 3H9c0 1.1 1.34 2 3 2s3-.9 3-2h1.66l5.88 5.88c.39.39.39 1.02 0 1.41l-2.83 2.83c-.39.38-1.02.38-1.41 0l-1.3-1V20a1 1 0 0 1-1 1"/>'
        },
        "tshirt-crew-outline": {
            body: '<path fill="currentColor" d="M16 21H8a1 1 0 0 1-1-1v-7.93l-1.3 1.05c-.39.38-1.02.38-1.41 0l-2.83-2.83a.996.996 0 0 1 0-1.41L7.34 3H9c0 1.1 1.34 2 3 2s3-.9 3-2h1.66l5.88 5.88c.39.39.39 1.02 0 1.41l-2.83 2.83c-.39.38-1.02.38-1.41 0L17 12.07V20a1 1 0 0 1-1 1m4.42-11.42l-4.31-4.3c-.31.35-.68.66-1.11.92c-.84.5-1.87.8-3 .8c-1.7 0-3.21-.68-4.11-1.72l-4.31 4.3L5 11l3-2h1v10h6V9h1l3 2l1.42-1.42Z"/>'
        },
        "tshirt-v": {
            body: '<path fill="currentColor" d="M16 21H8a1 1 0 0 1-1-1v-7.93l-1.3 1a.996.996 0 0 1-1.41 0l-2.83-2.78a.996.996 0 0 1 0-1.41L7.34 3H9c.29 1.8 1.4 3.37 3 4.25c1.6-.88 2.71-2.45 3-4.25h1.66l5.88 5.88c.39.39.39 1.02 0 1.41l-2.83 2.83c-.39.38-1.02.38-1.41 0l-1.3-1V20a1 1 0 0 1-1 1"/>'
        },
        "tshirt-v-outline": {
            body: '<path fill="currentColor" d="M16 21H8a1 1 0 0 1-1-1v-7.93l-1.3 1.05c-.39.38-1.02.38-1.41 0l-2.83-2.83a.996.996 0 0 1 0-1.41L7.34 3H9c0 1.1 1 3 3 4.25C14 6 15 4.1 15 3h1.66l5.88 5.88c.39.39.39 1.02 0 1.41l-2.83 2.83c-.39.38-1.02.38-1.41 0L17 12.07V20a1 1 0 0 1-1 1m4.42-11.42l-4.31-4.3C15 7 14 8.25 12 9.25c-2-1-3-2.25-4.11-3.97l-4.31 4.3L5 11l3-2h1v10h6V9h1l3 2l1.42-1.42Z"/>'
        },
        tsunami: {
            body: '<path fill="currentColor" d="M18.67 17.63c-3.8 2.8-6.12.4-6.67 0c-.66.49-2.92 2.76-6.67 0C3.43 19.03 2.65 19 2 19v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 0 0 6.67 0a6.535 6.535 0 0 0 6.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5 0-3.33-1.37m.66-5.63H22v-2h-2.67C17.5 10 16 8.5 16 6.67c0-1.02.38-1.74 1.09-3.34c-1.37-.21-2-.33-3.09-.33C7.36 3 2.15 8.03 2 14.5v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 0 0 6.67 0a6.535 6.535 0 0 0 6.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5 0-3.33-1.37c-3.8 2.8-6.12.4-6.67 0c-.9.67-.54.41-.91.63c-.7-.94-1.09-2.06-1.09-3.26c0-2.58 1.77-4.74 4.21-5.33c-.13.51-.21 1.02-.21 1.5C14 9.61 16.39 12 19.33 12Z"/>'
        },
        "tumble-dryer": {
            body: '<path fill="currentColor" d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m1 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m3 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m2 4a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m-3.89 2.5H10c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H10c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21m4 0H14c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H14c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21Z"/>'
        },
        "tumble-dryer-alert": {
            body: '<path fill="currentColor" d="M4 2h12a2 2 0 0 1 2 2v16c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m1 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m2 4c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6m-3.89 2.5H8c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H8c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21m4 0H12c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H12c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21M20 15h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "tumble-dryer-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20c0 1.11.89 2 2 2h12c.58 0 1.1-.25 1.46-.65l1.38 1.38l1.27-1.27M12 20c-3.31 0-6-2.69-6-6c0-1.68.7-3.2 1.82-4.29l.79.79h-.5c-.26 1.79.21 3.14 1.31 4.21c.58.62.82 1.41.58 2.79h1.89c.27-1.79-.21-3.14-1.31-4.21c-.36-.38-.58-.85-.63-1.45l4.08 4.08c.08.43.08.94-.03 1.58h1.61l.68.68A5.956 5.956 0 0 1 12 20m-.75-11.95C11.5 8 11.75 8 12 8c3.31 0 6 2.69 6 6c0 .25 0 .5-.05.75L20 16.8V4a2 2 0 0 0-2-2H6c-.24 0-.46.05-.67.13l5.92 5.92M10 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        tumblr: {
            body: '<path d="M17 11h-4v4.5c0 .94.28 1.5 1.5 1.5H17v4s-1.46.05-2.83.05c-3.37 0-4.67-2.05-4.67-4.3V11H7V7c3.07-.26 3.27-2.5 3.5-4H13v4h4" fill="currentColor"/>',
            hidden: true
        },
        "tumblr-box": {
            body: '<path d="M16 11h-3v3.9c0 .73.14 1.1 1.1 1.1H16v3s-1.03.1-2.1.1c-2.65 0-3.9-1.6-3.9-3.4V11H8V8.2c2.41-.2 2.62-2.04 2.8-3.2H13v3h3m4-6H4c-1.11 0-2 .89-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" fill="currentColor"/>',
            hidden: true
        },
        "tumblr-reblog": {
            body: '<path d="M3.75 17L8 12.75V16h10v-4.5l2-2V16a2 2 0 0 1-2 2H8v3.25L3.75 17m16.5-10L16 11.25V8H6v4.5l-2 2V8a2 2 0 0 1 2-2h10V2.75L20.25 7z" fill="currentColor"/>',
            hidden: true
        },
        tune: {
            body: '<path fill="currentColor" d="M3 17v2h6v-2H3M3 5v2h10V5H3m10 16v-2h8v-2h-8v-2h-2v6h2M7 9v2H3v2h4v2h2V9H7m14 4v-2H11v2h10m-6-4h2V7h4V5h-4V3h-2v6Z"/>'
        },
        "tune-variant": {
            body: '<path fill="currentColor" d="M8 13c-1.86 0-3.41 1.28-3.86 3H2v2h2.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H22v-2H11.86c-.45-1.72-2-3-3.86-3m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M19.86 6c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3H2v2h10.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H22V6h-2.14M16 9c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2Z"/>'
        },
        "tune-vertical": {
            body: '<path fill="currentColor" d="M7 3H5v6h2V3m12 0h-2v10h2V3M3 13h2v8h2v-8h2v-2H3v2m12-6h-2V3h-2v4H9v2h6V7m-4 14h2V11h-2v10m4-6v2h2v4h2v-4h2v-2h-6Z"/>'
        },
        "tune-vertical-variant": {
            body: '<path fill="currentColor" d="M8 12.14V2H6v10.14c-1.72.45-3 2-3 3.86s1.28 3.41 3 3.86V22h2v-2.14c1.72-.45 3-2 3-3.86s-1.28-3.41-3-3.86M7 14c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2M18 2h-2v2.14c-1.72.45-3 2-3 3.86s1.28 3.41 3 3.86V22h2V11.86c1.72-.45 3-2 3-3.86s-1.28-3.41-3-3.86V2m-1 4c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2Z"/>'
        },
        tunnel: {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12v10h20V12c0-5.5-4.5-10-10-10M7.1 5.69A7.941 7.941 0 0 1 11 4.07v2.02c-.91.15-1.75.51-2.47 1.02L7.1 5.69m8.37 1.42A5.95 5.95 0 0 0 13 6.09V4.07c1.46.18 2.79.76 3.9 1.62l-1.43 1.42M5.69 7.1l1.42 1.43A5.95 5.95 0 0 0 6.09 11H4.07c.18-1.46.76-2.79 1.62-3.9M6 13v2.5H4V13h2m-2 7v-2.5h2V20H4M16.89 8.53l1.42-1.43a7.941 7.941 0 0 1 1.62 3.9h-2.02a5.95 5.95 0 0 0-1.02-2.47M18 13h2v2.5h-2V13m0 7v-2.5h2V20h-2Z"/>'
        },
        "tunnel-outline": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12v10h20V12c0-5.5-4.5-10-10-10m3.47 5.11A5.95 5.95 0 0 0 13 6.09V4.07c1.46.18 2.79.76 3.9 1.62l-1.43 1.42m-6.94 0L7.1 5.69A7.941 7.941 0 0 1 11 4.07v2.02c-.91.15-1.75.51-2.47 1.02M5.69 7.1l1.42 1.43A5.95 5.95 0 0 0 6.09 11H4.07c.18-1.46.76-2.79 1.62-3.9M6 13v2.5H4V13h2m-2 7v-2.5h2V20H4m12 0H8v-8c0-2.21 1.79-4 4-4s4 1.79 4 4v8m.89-11.47l1.42-1.43a7.941 7.941 0 0 1 1.62 3.9h-2.02a5.95 5.95 0 0 0-1.02-2.47M18 13h2v2.5h-2V13m0 7v-2.5h2V20h-2Z"/>'
        },
        turbine: {
            body: '<path fill="currentColor" d="M12 2C6.47 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8m5.21-7.45l-1.35-.36l1.44-.38l1.93-.52a1.996 1.996 0 0 0-2.44-1.42l-1.35.36l1.06-1.05l1.41-1.41c-.78-.77-2.05-.77-2.83-.01v.01l-.98.98l.4-1.44l.5-1.93c-1.07-.29-2.16.34-2.45 1.41l-.36 1.35l-.38-1.44l-.52-1.93c-1.07.28-1.7 1.38-1.42 2.45l.36 1.34L9.18 7.5L7.77 6.09C7 6.87 7 8.14 7.76 8.92h.01l.98.98l-1.44-.4L5.38 9c-.29 1.07.34 2.16 1.41 2.45l1.35.36l-1.44.39l-1.93.51c.28 1.07 1.38 1.7 2.45 1.42l1.34-.36l-1.06 1.05l-1.41 1.41c.78.77 2.05.77 2.83.01v-.01l.98-.98l-.4 1.44l-.5 1.93c1.07.29 2.16-.34 2.45-1.41l.36-1.35l.39 1.44l.51 1.93c1.07-.28 1.7-1.38 1.42-2.44l-.36-1.35l1.05 1.06l1.42 1.41c.76-.78.76-2.05 0-2.83l-.99-.98l1.44.4l1.93.5c.29-1.07-.34-2.16-1.41-2.45M12 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"/>'
        },
        turkey: {
            body: '<path fill="currentColor" d="M10.5 19.44c-.75.36-1.6.56-2.5.56c-3.31 0-6-2.69-6-6V9c0-3.31 2.69-6 6-6l2.5 4.58c-2.4 1.23-4 3.42-4 5.92s1.61 4.7 4 5.94m5.5-.5V20h1c.55 0 1 .45 1 1s-.45 1-1 1h-3c-.55 0-1-.45-1-1s.45-1 1-1v-1.06c-3.39-.38-6-2.67-6-5.44C8 10.46 11.13 8 15 8h.56C14.84 6.63 14 5.23 14 4c0-1.1.9-2 2-2c2.21 0 4 1.79 4 4h-2s4 3 4 7.5c0 2.77-2.61 5.06-6 5.44M16 4c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1s-1 .45-1 1m1 8a2 2 0 0 0-2-2c-2.21 0-4 1.79-4 4h4c1.11 0 2-.89 2-2Z"/>'
        },
        turnstile: {
            body: '<path fill="currentColor" d="M22 22h-6V11l-6-6V2h12v20M9.17 6.17C8.42 6.92 8 7.94 8 9H2v2h6.55c.35.6.85 1.1 1.45 1.45V19h2v-6c1.06 0 2.08-.42 2.83-1.17L9.17 6.17Z"/>'
        },
        "turnstile-outline": {
            body: '<path fill="currentColor" d="M13.41 10.41c-.37.38-.88.59-1.41.59a2 2 0 0 1-2-2c0-.53.21-1.04.59-1.41L9.17 6.17C8.42 6.92 8 7.94 8 9H2v2h6.55c.35.6.85 1.1 1.45 1.45V19h2v-6c1.06 0 2.08-.42 2.83-1.17l-1.42-1.42M10 2v3l6 6v11h6V2H10m10 18h-2v-9.83l-6-6V4h8v16Z"/>'
        },
        turtle: {
            body: '<path fill="currentColor" d="M8.47 5.95c.48-.28 1-.51 1.53-.67V4c0-1.1.87-2 1.97-2.03C13.13 2 14 2.9 14 4v1.28c.53.17 1.05.39 1.53.67l-1.6 2.12h-3.86l-1.6-2.12M19 12c0 .5-.05.95-.14 1.4l-2.53-.78l-1.19-3.66l1.6-2.11c.43.4.81.85 1.14 1.35c.79-.07 1.55.05 2.23.39c1.03.53 1.73 1.54 1.89 2.69l-3 .36V12M5 12v-.35l-3-.37c.16-1.15.86-2.16 1.89-2.69a3.54 3.54 0 0 1 2.19-.33c.33-.51.71-.98 1.16-1.39l1.62 2.08l-1.19 3.67l-2.53.78C5.05 12.95 5 12.5 5 12m5.24-2.43h3.52l1.09 3.36L12 15l-2.85-2.07l1.09-3.36m-2.11 4.48l3.12 2.26v2.65c-.57-.06-1.12-.19-1.63-.38l-1.23 2.76a3.487 3.487 0 0 1-2.02-2.58c-.14-.76-.02-1.52.32-2.2c-.45-.52-.82-1.1-1.1-1.74l2.54-.77m7.74 0l2.54.77c-.28.64-.65 1.22-1.1 1.74c.34.68.46 1.44.33 2.2a3.522 3.522 0 0 1-2.03 2.58l-1.22-2.76c-.53.19-1.06.36-1.64.42v-2.69l3.12-2.26Z"/>'
        },
        twitch: {
            body: '<path fill="currentColor" d="M11.64 5.93h1.43v4.28h-1.43m3.93-4.28H17v4.28h-1.43M7 2L3.43 5.57v12.86h4.28V22l3.58-3.57h2.85L20.57 12V2m-1.43 9.29l-2.85 2.85h-2.86l-2.5 2.5v-2.5H7.71V3.43h11.43Z"/>'
        },
        twitter: {
            body: '<path fill="currentColor" d="M22.46 6c-.77.35-1.6.58-2.46.69c.88-.53 1.56-1.37 1.88-2.38c-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29c0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15c0 1.49.75 2.81 1.91 3.56c-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07a4.28 4.28 0 0 0 4 2.98a8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21C16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56c.84-.6 1.56-1.36 2.14-2.23Z"/>'
        },
        "twitter-box": {
            body: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m12.71 6.33c.48-.4 1.04-.88 1.29-1.41c-.41.21-.9.34-1.44.41c.5-.36.91-.83 1.12-1.47c-.52.28-1.05.52-1.71.64c-1.55-1.87-5.26-.35-4.6 2.45c-2.61-.16-4.2-1.34-5.52-2.79c-.75 1.22-.1 3.07.79 3.58c-.46-.03-.81-.17-1.14-.33c.04 1.54.89 2.28 2.08 2.68c-.36.07-.76.09-1.14.03c.37 1.07 1.14 1.74 2.46 1.88c-.9.76-2.56 1.29-3.9 1.08c1.15.73 2.46 1.31 4.28 1.23c4.41-.2 7.36-3.36 7.43-7.98z" fill="currentColor"/>',
            hidden: true
        },
        "twitter-circle": {
            body: '<path d="M17.71 9.33c.48-.4 1.04-.88 1.29-1.41c-.41.21-.9.34-1.44.41c.5-.36.91-.83 1.12-1.47c-.52.28-1.05.52-1.71.64c-1.55-1.87-5.26-.35-4.6 2.45c-2.61-.16-4.2-1.34-5.52-2.79c-.75 1.22-.1 3.07.79 3.58c-.46-.03-.81-.17-1.14-.33c.04 1.54.89 2.28 2.08 2.68c-.36.07-.76.09-1.14.03c.37 1.07 1.14 1.74 2.46 1.88c-.9.76-2.56 1.29-3.9 1.08c1.15.73 2.46 1.31 4.28 1.23c4.41-.2 7.36-3.36 7.43-7.98M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2z" fill="currentColor"/>',
            hidden: true
        },
        "two-factor-authentication": {
            body: '<path fill="currentColor" d="M2 7v2h4v2H4a2 2 0 0 0-2 2v4h6v-2H4v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H2m7 0v10h2v-4h3v-2h-3V9h4V7H9m9 0a2 2 0 0 0-2 2v8h2v-3h2v3h2V9a2 2 0 0 0-2-2h-2m0 2h2v3h-2V9Z"/>'
        },
        typewriter: {
            body: '<path fill="currentColor" d="M20 13h-4c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2H4l-2 5v2c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2M6 20c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71c0 .55-.45 1-1 1m4 0c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71c0 .55-.45 1-1 1m4 0c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71c0 .55-.45 1-1 1m4 0c-.89 0-1.34-1.08-.71-1.71c.63-.63 1.71-.18 1.71.71c0 .55-.45 1-1 1m0-10V3H6v7H3v2h18v-2M8 5h8v1H8m0 1h6v1H8"/>'
        },
        uber: {
            body: '<path d="M6.38 13.24v-4.2H7.4v6.8H6.39v-.63c-.46.47-1.1.75-1.81.75C3.12 15.96 2 14.9 2 13.3V9.04h1v4.2c0 1.09.74 1.8 1.7 1.8c.94 0 1.68-.73 1.68-1.8m2.76-4.2v2.46c.23-.21.51-.4.81-.53c.3-.12.63-.19.96-.19c1.46 0 2.59 1.16 2.59 2.59s-1.13 2.59-2.59 2.59c-.33 0-.66-.07-.96-.19c-.31-.13-.58-.32-.82-.55v.62h-.97v-6.8h.98m3.41 4.33c0-.96-.78-1.72-1.71-1.72c-.95 0-1.71.76-1.71 1.72c0 .95.75 1.72 1.71 1.72c.93 0 1.71-.77 1.71-1.72m3.91-2.58c1.44 0 2.49 1.1 2.49 2.57v.33h-4.04c.13.81.8 1.4 1.64 1.4c.58 0 1.06-.23 1.45-.73l.7.53a2.62 2.62 0 0 1-2.15 1.06c-1.49 0-2.64-1.11-2.64-2.59c0-1.39 1.09-2.57 2.55-2.57m-1.54 2.12h3.03c-.16-.76-.77-1.26-1.51-1.26c-.73 0-1.34.5-1.52 1.26m5.58.09v2.84h-1v-4.95h.97v.61c.24-.4.64-.65 1.19-.65H22v.91h-.41c-.64 0-1.09.5-1.09 1.24" fill="currentColor"/>',
            hidden: true
        },
        ubisoft: {
            body: '<path fill="currentColor" d="M11.41 2c-6.2 0-8.88 5.53-8.88 5.53l.79.56S2.33 10 2.35 12.4c0 4.94 3.94 9.6 9.72 9.6c5.26 0 9.6-4.29 9.6-9.59C21.67 5.5 16.31 2 11.41 2m.06 1.69c4.84 0 8.6 3.91 8.6 8.45c0 4.81-3.62 8.16-7.84 8.16c-3.1 0-5.9-2.36-5.9-5.6c0-1.88.99-3.2 2.11-3.88l.16.18c-.3.24-1.17 1.64-1.17 3c0 2.56 2 4.33 4.52 4.33c3.21 0 5.35-2.74 5.35-5.92c0-3.7-3.27-6.84-7.2-6.84c-2.17 0-4.01.93-5.07 1.76l-.17-.15c1.39-2.14 3.79-3.49 6.61-3.49M10 7.23c2.53 0 4.97 1.66 5.59 4.02l-.23.08c-1.09-1.45-2.89-2.65-5.01-2.65c-3.91 0-5.96 3.55-5.66 6.51l-.23.09s-.43-.95-.43-2.08c0-3.27 2.68-5.97 5.97-5.97m1.68 4.1c1.18 0 2.13.97 2.13 2.11c0 .94-.6 1.5-.6 1.5l.71.51s-.71 1.12-2.16 1.12c-1.39 0-2.63-1.13-2.63-2.64c0-1.55 1.34-2.6 2.55-2.6Z"/>'
        },
        ubuntu: {
            body: '<path fill="currentColor" d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-7.66-4.26c.58.33 1.31.13 1.66-.44c.31-.57.12-1.3-.46-1.64c-.57-.33-1.31-.16-1.64.44c-.33.57-.13 1.31.44 1.64m-2.46 7.76c-.53 0-1.03-.11-1.47-.32l-.84 1.5c.7.32 1.48.54 2.31.54c.49 0 .95-.07 1.4-.19c.08-.49.36-.93.82-1.19c.46-.27.98-.29 1.44-.12c.89-.87 1.46-2.06 1.55-3.39l-1.71-.02a3.506 3.506 0 0 1-3.5 3.19m0-7c1.84 0 3.34 1.39 3.5 3.19l1.71-.03a5.209 5.209 0 0 0-1.55-3.38c-.46.17-.99.14-1.44-.12c-.46-.26-.74-.71-.82-1.19c-.45-.12-.91-.19-1.4-.19c-.83 0-1.61.19-2.31.54l.84 1.5c.44-.21.94-.32 1.47-.32M8.37 12c0-1.19.59-2.24 1.49-2.87L9 7.65a5.217 5.217 0 0 0-2.17 3.04c.38.31.62.78.62 1.31s-.24 1-.62 1.31A5.195 5.195 0 0 0 9 16.34l.86-1.47c-.9-.63-1.49-1.68-1.49-2.87m5.97 4.26c-.57.33-.77 1.06-.44 1.64c.33.57 1.07.77 1.64.44c.58-.34.77-1.07.46-1.64c-.35-.58-1.08-.77-1.66-.44M5.76 10.8c-.66 0-1.2.54-1.2 1.2c0 .66.54 1.2 1.2 1.2c.67 0 1.2-.54 1.2-1.2c0-.66-.53-1.2-1.2-1.2Z"/>'
        },
        ufo: {
            body: '<path fill="currentColor" d="M15.94 10.28C15.66 7.87 14 6 12 6s-3.66 1.87-3.94 4.28C4.5 10.82 2 12.06 2 13.5C2 15.43 6.5 17 12 17s10-1.57 10-3.5c0-1.44-2.5-2.68-6.06-3.22Z"/>'
        },
        "ufo-outline": {
            body: '<path fill="currentColor" d="M17 10.54C16.78 7.44 14.63 5 12 5s-4.78 2.44-5 5.54C4 11.23 2 12.5 2 14c0 2.21 4.5 4 10 4s10-1.79 10-4c0-1.5-2-2.77-5-3.46m-2.07 1.3c-1.9.21-3.96.21-5.86 0c-.04-.28-.07-.56-.07-.84c0-2.2 1.35-4 3-4s3 1.8 3 4c0 .28 0 .56-.07.84Z"/>'
        },
        "ultra-high-definition": {
            body: '<path fill="currentColor" d="M9 7h2v4h2V7h2v10h-2v-4h-2v4H9V7m8 0h3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-3V7m3 8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1v6h1M7 14a3 3 0 0 1-3 3a3 3 0 0 1-3-3V7h2v7a1 1 0 0 0 1 1a1 1 0 0 0 1-1V7h2v7Z"/>'
        },
        umbraco: {
            body: '<path fill="currentColor" d="m8.6 8.6l-1.43-.22c-.67 3.29-.71 5.86.44 7.12c.99 1.11 4.28 1.11 4.28 1.11s3.4 0 4.39-1.11c1.15-1.26 1.1-3.83.44-7.12l-1.43.22s1.25 5.28-.6 6.09c-.88.38-2.8.38-2.8.38s-1.81 0-2.69-.38c-1.85-.81-.6-6.09-.6-6.09M12 3a9 9 0 0 1 9 9a9 9 0 0 1-9 9a9 9 0 0 1-9-9a9 9 0 0 1 9-9Z"/>'
        },
        umbrella: {
            body: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9h-8v8a3 3 0 0 1-3 3a3 3 0 0 1-3-3v-1h2v1a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-8H3a9 9 0 0 1 9-9Z"/>'
        },
        "umbrella-beach": {
            body: '<path fill="currentColor" d="m13.13 14.56l1.43-1.43L21 19.57L19.57 21l-6.44-6.44m4.29-5.73l2.86-2.86C16.33 2 9.93 2 6 5.95c3.91-1.3 8.29-.25 11.42 2.88M5.95 6C2 9.93 2 16.33 5.97 20.28l2.86-2.86C5.7 14.29 4.65 9.91 5.95 6m.02-.04l-.01.01C5.58 9 7.13 12.85 10.26 16L16 10.26c-3.14-3.13-7-4.68-10.03-4.3Z"/>'
        },
        "umbrella-beach-outline": {
            body: '<path fill="currentColor" d="M21 19.57L19.57 21l-6.44-6.44l1.43-1.43L21 19.57M13.12 3C10.54 3 7.96 4 6 5.95l-.03.01a10.086 10.086 0 0 0 0 14.31l14.3-14.31A10.128 10.128 0 0 0 13.12 3M6.14 17.27a8.063 8.063 0 0 1-.68-6.82c.19 1.91.89 3.79 2.07 5.44l-1.39 1.38M9 14.43c-1.37-2.05-1.88-4.5-1.4-6.83c.58-.1 1.16-.18 1.75-.18c1.8 0 3.55.55 5.08 1.58L9 14.43m1.45-8.97a8.063 8.063 0 0 1 6.82.68l-1.39 1.39a11.25 11.25 0 0 0-5.43-2.07Z"/>'
        },
        "umbrella-closed": {
            body: '<path fill="currentColor" d="M12 2c-.4 0-.7.2-.9.6L6.5 15H11v4c0 .6-.4 1-1 1s-1-.4-1-1v-1H7v1c0 1.7 1.3 3 3 3s3-1.3 3-3v-4h4.5L12.9 2.6c-.2-.4-.5-.6-.9-.6Z"/>'
        },
        "umbrella-closed-outline": {
            body: '<path fill="currentColor" d="M12 2c.4 0 .8.2.9.6L17.5 15H13v4c0 1.7-1.3 3-3 3s-3-1.3-3-3v-1h2v1c0 .6.4 1 1 1s1-.4 1-1v-4H6.5l4.6-12.4c.1-.4.5-.6.9-.6m0 3.9L9.4 13h5.3L12 5.9Z"/>'
        },
        "umbrella-closed-variant": {
            body: '<path fill="currentColor" d="m15 7l-2-1V3.5c0-.3.2-.5.5-.5s.5.2.5.5V4h2v-.5C16 2.1 14.9 1 13.5 1S11 2.1 11 3.5V6L9 7L6 6l5.1 15.3c.3.9 1.6.9 1.9 0C14.6 16.2 18 6 18 6l-3 1m-4 8L9 8.9l.7.2l1.3-1V15m2-6.9l1.3 1l.7-.2l-2 6.1V8.1Z"/>'
        },
        "umbrella-outline": {
            body: '<path fill="currentColor" d="M12 4C8.9 4 6.18 6.03 5.3 9h13.4A7 7 0 0 0 12 4m0-2a9 9 0 0 1 9 9h-8v8a3 3 0 0 1-3 3a3 3 0 0 1-3-3v-1h2v1a1 1 0 0 0 1 1a1 1 0 0 0 1-1v-8H3a9 9 0 0 1 9-9Z"/>'
        },
        undo: {
            body: '<path fill="currentColor" d="M12.5 8c-2.65 0-5.05 1-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88c3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8Z"/>'
        },
        "undo-variant": {
            body: '<path fill="currentColor" d="M13.5 7a6.5 6.5 0 0 1 6.5 6.5a6.5 6.5 0 0 1-6.5 6.5H10v-2h3.5c2.5 0 4.5-2 4.5-4.5S16 9 13.5 9H7.83l3.08 3.09L9.5 13.5L4 8l5.5-5.5l1.42 1.41L7.83 7h5.67M6 18h2v2H6v-2Z"/>'
        },
        "unfold-less-horizontal": {
            body: '<path fill="currentColor" d="M16.59 5.41L15.17 4L12 7.17L8.83 4L7.41 5.41L12 10m-4.59 8.59L8.83 20L12 16.83L15.17 20l1.41-1.41L12 14l-4.59 4.59Z"/>'
        },
        "unfold-less-vertical": {
            body: '<path fill="currentColor" d="M5.41 7.41L10 12l-4.59 4.59L4 15.17L7.17 12L4 8.83l1.41-1.42m13.18 9.18L14 12l4.59-4.58L20 8.83L16.83 12L20 15.17l-1.41 1.42Z"/>'
        },
        "unfold-more-horizontal": {
            body: '<path fill="currentColor" d="M12 18.17L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15M12 5.83L15.17 9l1.41-1.41L12 3L7.41 7.59L8.83 9L12 5.83Z"/>'
        },
        "unfold-more-vertical": {
            body: '<path fill="currentColor" d="M18.17 12L15 8.83l1.41-1.42L21 12l-4.59 4.58L15 15.17L18.17 12M5.83 12L9 15.17l-1.41 1.42L3 12l4.59-4.58L9 8.83L5.83 12Z"/>'
        },
        ungroup: {
            body: '<path fill="currentColor" d="M2 2h4v1h7V2h4v4h-1v3h2V8h4v4h-1v6h1v4h-4v-1h-6v1H8v-4h1v-2H6v1H2v-4h1V6H2V2m16 10v-1h-2v2h1v4h-4v-1h-2v2h1v1h6v-1h1v-6h-1m-5-6V5H6v1H5v7h1v1h3v-2H8V8h4v1h2V6h-1m-1 6h-1v2h2v-1h1v-2h-2v1Z"/>'
        },
        unicode: {
            body: '<path fill="currentColor" d="M22 6a1.46 1.46 0 0 1-1.46 1.44A1.46 1.46 0 0 1 19.09 6a1.46 1.46 0 0 1 1.45-1.5A1.46 1.46 0 0 1 22 6m-.44 2.86h-2.03c-.13-.01-.19.05-.19.14v3.59c0 .49 0 .91.01 1.27l.02.9c.01.24.02.45.02.63c.01.17.01.33.01.47h-.02c-.12-.26-.31-.64-.56-1.12c-.24-.47-.53-1.02-.85-1.63c-.33-.61-.68-1.27-1.05-1.96c-.37-.68-.74-1.37-1.11-2.04c-.36-.68-.72-1.33-1.06-1.95c-.35-.62-.65-1.16-.9-1.62c-.03-.04-.06-.1-.08-.12c-.03-.02-.09-.03-.17-.03h-2.98c-.12 0-.15.05-.15.15h.03c-.03.02-.03.03-.03.04v8.26c0 .66-.07 1.16-.22 1.61c-.15.43-.35.78-.61 1.05c-.26.25-.57.43-.92.55c-.36.11-.72.17-1.16.17c-1.02 0-1.77-.31-2.26-.91c-.5-.61-.74-1.42-.74-2.43V5.56c0-.11-.06-.17-.17-.17H2.17c-.11 0-.17.06-.17.19v8.49c0 .93.13 1.71.38 2.39c.25.67.62 1.23 1.12 1.68c.46.44 1.03.78 1.71 1c.68.22 1.43.36 2.26.36c.77 0 1.5-.12 2.18-.33c.69-.2 1.28-.53 1.77-.97c.49-.45.88-1.02 1.17-1.7c.29-.71.44-1.55.44-2.54V8.62c.11.24.25.53.41.85c.29.58.61 1.21.98 1.91s.75 1.42 1.16 2.18c.42.76.81 1.5 1.19 2.2c.39.7.73 1.35 1.06 1.94c.32.59.57 1.06.75 1.42c.05.1.15.15.27.15h2.69c.14 0 .21-.07.21-.19V9.05c0-.13-.07-.2-.19-.2Z"/>'
        },
        unicorn: {
            body: '<path fill="currentColor" d="m22 5l-.89 1.34c.54.36.89.97.89 1.66v3.5l-1.5.5l-1.54-2.46c-.13-.21-.46-.12-.46.13v3.58c0 .98-.39 1.86-1 2.53V22H15v-5h-.25c-.21 0-.42-.03-.62-.06l-4.68-.78l-.88 1.96l.97 3.88H6.96l-.92-3.7c-.07-.27-.04-.56.07-.8l.89-2a3.319 3.319 0 0 1-1.5-2.69c-.04.15-.06.37-.03.69c.03.44.14 1.09.07 1.81c-.04.72-.36 1.46-.78 1.95c-.44.49-.91.83-1.41 1.09l-.7-.7c.19-.47.38-.89.42-1.28c.06-.37-.01-.67-.12-.94l-.53-1.13c-.21-.51-.47-1.25-.42-2.12c.03-.85.5-1.96 1.39-2.57c.9-.61 1.87-.7 2.66-.53c.5.1 1.01.34 1.45.68c.37-.17.8-.26 1.25-.26h5.75V9c0-2.21 1.79-4 4-4L22 2l-1 3h1Z"/>'
        },
        "unicorn-variant": {
            body: '<path fill="currentColor" d="M20 12v7l-3 1l-3-4.67c-.29-.44-1-.19-.92.34L14 23L4 18l.96-5.25C5.56 9.42 8.46 7 11.84 7H13l6-6l-2 6h3l-1.58 2.37C19.36 9.88 20 10.86 20 12Z"/>'
        },
        unicycle: {
            body: '<path fill="currentColor" d="M13 9.09V5h1c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1h1v4.09c-2.84.48-5 2.94-5 5.91c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.97-2.16-5.43-5-5.91M12 19c-2.21 0-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86V16h2v-4.86c1.72.45 3 2 3 3.86c0 2.21-1.79 4-4 4Z"/>'
        },
        unity: {
            body: '<path fill="currentColor" d="M10.11 17H7.5l-4.91-5L7.5 7h2.61l1.31-2.26L18.21 3l1.87 6.74L18.77 12l1.31 2.26L18.21 21l-6.79-1.74L10.11 17m.14-.25l5.13 1.38L12.42 13H6.5l3.75 3.75m6.87.38L18.5 12l-1.38-5.13L14.15 12l2.97 5.13m-6.87-9.88L6.5 11h5.92l2.96-5.13l-5.13 1.38Z"/>'
        },
        unreal: {
            body: '<path fill="currentColor" d="M2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2A10 10 0 0 0 2 12m3.24 6.76A9.493 9.493 0 0 1 2.44 12c0-2.55.99-4.95 2.8-6.76A9.493 9.493 0 0 1 12 2.44c2.55 0 4.95.99 6.76 2.8a9.493 9.493 0 0 1 2.8 6.76c0 2.55-.99 4.95-2.8 6.76a9.493 9.493 0 0 1-6.76 2.8c-2.55 0-4.95-.99-6.76-2.8M6.35 9.5c-2.01 2.29-1.62 4.18-1.62 4.18s.55-1.3 1.88-2.68c.64-.63 1.11-.85 1.43-.85c.36 0 .53.26.53.5v4.64c0 .46-.3.56-.57.55a1.5 1.5 0 0 1-.45-.08C8.92 17.73 12.19 18 12.19 18l1.44-1.5h.04L15 17.63c2.39-1.42 3.55-4.05 3.55-4.05c-1.05 1.12-1.76 1.39-2.16 1.38c-.36 0-.51-.21-.51-.21c-.01-.1-.06-5.85.01-5.85c.42-.77 1.74-2.34 1.74-2.34c-2.47.49-3.82 2.1-3.82 2.1c-.4-.31-1.22-.26-1.22-.26c.38.21.76.81.76 1.32v4.93s-.85.73-1.47.73c-.38 0-.61-.21-.74-.38c-.09-.12-.14-.21-.14-.21v-6.1c-.07.06-.18.11-.29.11c-.14-.01-.28-.07-.37-.27c-.08-.15-.12-.38-.12-.7c0-1.13 1.28-1.87 1.28-1.87c-1.63.43-3.14 1.26-5.15 3.54"/>'
        },
        untappd: {
            body: '<path d="M14.41 4s.53.39.56.71c0 .1-.24.14-.29.22c-.06.07.02.22-.03.28c-.06.05-.15.05-.24.2c-.08.15-2.34 4.68-2.68 5.22c-.14.4-.26 1.83-.36 2.03c-.11.19-5.03 7.18-5.21 7.39c-.49.58-1.85.25-2.88-.49c-.98-.7-1.54-1.86-1.17-2.4c.16-.23 5.04-7.24 5.18-7.41c.15-.17 1.46-.75 1.78-1.04c.4-.49 3.89-4.17 4-4.29c.11-.12.08-.22.11-.29c.04-.07.2-.05.25-.13c.07-.07-.04-.29.07-.32c.09-.04.46-.01.91.32m-3.56.44l.89.93l-1.48 1.57l-.8-1.57c-.08-.15-.18-.15-.24-.2c-.05-.06.02-.2-.03-.28c-.06-.08-.29-.06-.29-.16c0-.11.15-.45.6-.77c0 0 .56-.36.87-.28c.1.03.06.27.13.32c.04.1.2.08.23.15c.04.06 0 .17.12.29m11.07 12.71c.37.66-.39 1.85-1.42 2.55c-1 .69-2.29.84-2.67.3c-.17-.22-5.16-7.18-5.27-7.38c-.11-.19-.24-1.62-.38-2.03l-.03-.04c.3-.55.92-1.78 1.58-3.08c.57.59 1.02 1.09 1.15 1.25c.33.28 1.65.86 1.8 1.03c.14.17 5.1 7.16 5.24 7.4z" fill="currentColor"/>',
            hidden: true
        },
        update: {
            body: '<path fill="currentColor" d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.887 6.887 0 0 0 0 9.8c2.73 2.7 7.15 2.7 9.88 0c1.36-1.35 2.04-2.92 2.04-4.9h2c0 1.98-.88 4.55-2.64 6.29c-3.51 3.48-9.21 3.48-12.72 0c-3.5-3.47-3.53-9.11-.02-12.58a8.987 8.987 0 0 1 12.65 0L21 3v7.12M12.5 8v4.25l3.5 2.08l-.72 1.21L11 13V8h1.5Z"/>'
        },
        upload: {
            body: '<path fill="currentColor" d="M9 16v-6H5l7-7l7 7h-4v6H9m-4 4v-2h14v2H5Z"/>'
        },
        "upload-lock": {
            body: '<path fill="currentColor" d="M22 22h-5c-.5 0-1-.5-1-1v-4c0-.5.5-1 1-1v-1.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5V16c.5 0 1 .5 1 1v4c0 .5-.5 1-1 1m-8-2H5v-2h9v2m7-4v-1.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V16h3m-6 0H9v-6H5l7-7l7 7h-4v6Z"/>'
        },
        "upload-lock-outline": {
            body: '<path fill="currentColor" d="M22 22h-5c-.5 0-1-.5-1-1v-4c0-.5.5-1 1-1v-1.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5V16c.5 0 1 .5 1 1v4c0 .5-.5 1-1 1M5 18h9v2H5v-2m16-2v-1.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V16h3M9 16v-6H5l7-7l7 7h-4v6H9m.83-8H11v6h2V8h1.17L12 5.83L9.83 8Z"/>'
        },
        "upload-multiple": {
            body: '<path fill="currentColor" d="M9 14V8H5l7-7l7 7h-4v6H9m-4 4v-2h14v2H5m14 2H5v2h14v-2Z"/>'
        },
        "upload-network": {
            body: '<path fill="currentColor" d="M17 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10m-5 2.5L7.5 10H11v4h2v-4h3.5L12 5.5Z"/>'
        },
        "upload-network-outline": {
            body: '<path fill="currentColor" d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m5-9l-4 4h3v4h2v-4h3l-4-4Z"/>'
        },
        "upload-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.45 5.45L5 10h3.11l.89.89V16h5.11l2 2H5v2h13.11l2.73 2.73l1.27-1.27M15 10h4l-7-7l-2.9 2.9l5.9 5.9V10Z"/>'
        },
        "upload-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l5.45 5.45L5 10h3.11l.89.89V16h5.11l2 2H5v2h13.11l2.73 2.73l1.27-1.27M11 14v-1.11L12.11 14H11m1-8.2L14.2 8H13v1.8l2 2V10h4l-7-7l-2.9 2.9l1.4 1.4L12 5.8Z"/>'
        },
        "upload-outline": {
            body: '<path fill="currentColor" d="M9 10v6h6v-6h4l-7-7l-7 7h4m3-4.2L14.2 8H13v6h-2V8H9.8L12 5.8M19 18H5v2h14v-2Z"/>'
        },
        usb: {
            body: '<path fill="currentColor" d="M15 7v4h1v2h-3V5h2l-3-4l-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93A2.2 2.2 0 0 0 7 6.8c-1.22 0-2.2.98-2.2 2.2c0 .85.5 1.56 1.2 1.93V13a2 2 0 0 0 2 2h3v3.05c-.71.36-1.2 1.1-1.2 1.95a2.2 2.2 0 0 0 2.2 2.2a2.2 2.2 0 0 0 2.2-2.2c0-.85-.49-1.59-1.2-1.95V15h3a2 2 0 0 0 2-2v-2h1V7h-4Z"/>'
        },
        "usb-flash-drive": {
            body: '<path fill="currentColor" d="M8 15c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m7.07-10.31L16.5 6.1l-1.43 1.4l-1.41-1.4l1.41-1.41M17.9 7.5l1.41 1.43l-1.41 1.41l-1.4-1.41l1.4-1.43M8 13c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3m1.77-8.67l.73.75l3.79-3.79c.18-.18.43-.29.71-.29c.28 0 .53.11.71.29l7.07 7.07v.01a1.02 1.02 0 0 1-.12 1.39l-3.73 3.74l.74.73l-6.72 6.72A6.976 6.976 0 0 1 8 23c-3.87 0-7-3.13-7-7c0-1.93.78-3.68 2.05-4.95l6.72-6.72M20.59 9L15 3.41L11.93 6.5l5.57 5.58L20.59 9Z"/>'
        },
        "usb-flash-drive-outline": {
            body: '<path fill="currentColor" d="M8 13c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3m0 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M9.77 4.33l.73.75l3.79-3.79c.18-.18.43-.29.71-.29c.28 0 .53.11.71.29l7.07 7.07v.01a1.02 1.02 0 0 1-.12 1.39l-3.73 3.74l.74.73l-6.72 6.72A6.976 6.976 0 0 1 8 23c-3.87 0-7-3.13-7-7c0-1.93.78-3.68 2.05-4.95l6.72-6.72m1.77 15.21l5.3-5.31l-7.07-7.07l-5.31 5.3C3.56 13.37 3 14.62 3 16c0 2.76 2.24 5 5 5c1.38 0 2.63-.56 3.54-1.46m3.53-14.85L16.5 6.1l-1.43 1.4l-1.41-1.4l1.41-1.41M17.9 7.5l1.41 1.43l-1.41 1.41l-1.4-1.41l1.4-1.43M20.59 9L15 3.41L11.93 6.5l5.57 5.58L20.59 9Z"/>'
        },
        "usb-port": {
            body: '<path fill="currentColor" d="M8 2c-1.1 0-2 .9-2 2v8H5v4l4 4v2h6v-2l4-4v-4h-1V4a2 2 0 0 0-2-2M8 4h8v8H8m1-5v2h2V7m2 0v2h2V7Z"/>'
        },
        vacuum: {
            body: '<path fill="currentColor" d="M23 20v2h-7v-2h2.46L12 4.61c-.19-.47-.5-.85-.94-1.15S10.14 3 9.61 3c-.71 0-1.33.27-1.85.79S7 4.92 7 5.64V9h1c2.21 0 4 1.79 4 4v9H8c.61-.84 1-1.87 1-3c0-2.76-2.24-5-5-5c-.71 0-1.39.15-2 .42V9h3V5.64c0-.84.23-1.64.63-2.32c.41-.7.96-1.26 1.67-1.69C8 1.21 8.77 1 9.61 1c.94 0 1.79.26 2.55.77s1.34 1.2 1.71 2.04L20.66 20H23M7 19c0 1.66-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3m-2 0c0-.55-.45-1-1-1s-1 .45-1 1s.45 1 1 1s1-.45 1-1Z"/>'
        },
        "vacuum-outline": {
            body: '<path fill="currentColor" d="M20.66 20L13.87 3.81c-.37-.84-.94-1.52-1.71-2.04C11.4 1.26 10.55 1 9.61 1c-.84 0-1.61.21-2.31.63s-1.26.99-1.67 1.69S5 4.8 5 5.64L5.03 9h-3v5.45c.62-.28 1.28-.42 1.97-.42v-3h5c.57 0 1.04.2 1.43.59c.39.38.57.85.57 1.38v7.03H8.91A4.67 4.67 0 0 1 7.97 22H13v-9c0-.72-.2-1.38-.55-2S11.61 9.91 11 9.56C10.42 9.2 9.75 9 9 9H7V5.64c0-.72.25-1.33.76-1.85S8.89 3 9.61 3c.53 0 1.02.16 1.45.46s.75.68.94 1.15L18.46 20l-2.46.03V22h7v-1.97L20.66 20M4 18c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3Z"/>'
        },
        valve: {
            body: '<path fill="currentColor" d="M4 22H2V2h2m18 0h-2v20h2M17.24 5.34l-4 4a3 3 0 0 0-4 4l-4 4l1.42 1.42l4-4a3 3 0 0 0 4-4l4-4Z"/>'
        },
        "valve-closed": {
            body: '<path fill="currentColor" d="M22 2v20h-2v-9h-5.18a3 3 0 0 1-5.64 0H4v9H2V2h2v9h5.18a3 3 0 0 1 5.64 0H20V2Z"/>'
        },
        "valve-open": {
            body: '<path fill="currentColor" d="M4 22H2V2h2m18 0h-2v20h2M11 4v5.18a3 3 0 0 0 0 5.64V20h2v-5.18a3 3 0 0 0 0-5.64V4Z"/>'
        },
        "van-passenger": {
            body: '<path fill="currentColor" d="M3 7c-1.11 0-2 .89-2 2v8h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-4c0-1.11-.89-2-2-2l-3-4H3m0 1.5h4V11H3V8.5m6 0h4V11H9V8.5m6 0h2.5l1.96 2.5H15V8.5m-9 7A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "van-utility": {
            body: '<path fill="currentColor" d="M3 7c-1.11 0-2 .89-2 2v8h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-4c0-1.11-.89-2-2-2l-3-4H3m12 1.5h2.5l1.96 2.5H15V8.5m-9 7A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5A1.5 1.5 0 0 1 4.5 17A1.5 1.5 0 0 1 6 15.5m12 0a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        vanish: {
            body: '<path fill="currentColor" d="M16 13v-2h5v2h-5m-1.17-5.24l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41M11 16h2v5h-2v-5m0-13h2v5h-2V3M4.93 17.66l2.83-2.83l1.41 1.41l-2.83 2.83l-1.41-1.41m0-11.32l1.41-1.41l2.83 2.83l-1.41 1.41l-2.83-2.83M8 13H3v-2h5v2m11.07 4.66l-1.41 1.41l-2.83-2.83l1.41-1.41l2.83 2.83Z"/>'
        },
        "vanish-quarter": {
            body: '<path fill="currentColor" d="M11 3h2v5h-2V3M4.9 6.3l1.4-1.4l2.8 2.8l-1.3 1.5l-2.9-2.9M8 13H3v-2h5v2"/>'
        },
        "vanity-light": {
            body: '<path fill="currentColor" d="M22 20h-6c0-1.66 1.34-7 3-7s3 5.34 3 7m-10-7c-1.66 0-3 5.34-3 7h6c0-1.66-1.34-7-3-7m-7 0c-1.66 0-3 5.34-3 7h6c0-1.66-1.34-7-3-7m9.82-7c-.56-1.56-2.29-2.36-3.82-1.8c-.86.3-1.5.97-1.82 1.8H2v2h2v4h2V8h3.18c.32.85.97 1.5 1.82 1.82V12h2V9.82c.85-.32 1.5-.97 1.82-1.82H18v4h2V8h2V6h-7.18Z"/>'
        },
        variable: {
            body: '<path fill="currentColor" d="M20.41 3c1.39 2.71 1.94 5.84 1.59 9c-.2 3.16-1.3 6.29-3.17 9l-1.53-1c1.61-2.43 2.55-5.2 2.7-8c.34-2.8-.11-5.57-1.3-8l1.71-1M5.17 3L6.7 4C5.09 6.43 4.15 9.2 4 12c-.34 2.8.12 5.57 1.3 8l-1.69 1c-1.4-2.71-1.96-5.83-1.61-9c.2-3.16 1.3-6.29 3.17-9m6.91 7.68l2.32-3.23h2.53l-3.78 5l2.2 4.92h-2.26L11.71 14l-2.43 3.33H6.76l3.9-5.12l-2.13-4.76h2.27l1.28 3.23Z"/>'
        },
        "variable-box": {
            body: '<path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M7.4 18C5.9 16.5 5 14.3 5 12s.9-4.5 2.4-6l1.6.7C7.7 7.9 7 9.9 7 12s.7 4.1 2 5.3l-1.6.7m5.3-3l-.8-2l-1.4 2H9l2.3-3.1L10 9h1.3l.8 2l1.4-2H15l-2.2 3l1.3 3h-1.4m3.9 3l-1.6-.7c1.3-1.3 2-3.2 2-5.3s-.7-4.1-2-5.3l1.6-.7c1.5 1.5 2.4 3.7 2.4 6s-.9 4.5-2.4 6Z"/>'
        },
        "vector-arrange-above": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V3c0-1.11-.89-2-2-2H3m0 2h11v11H3V3m15 4v2h2v11H9v-2H7v2c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-2Z"/>'
        },
        "vector-arrange-below": {
            body: '<path fill="currentColor" d="M20 22c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h11m0-2H9V9h11v11M5 16v-2H3V3h11v2h2V3c0-1.11-.89-2-2-2H3c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h2Z"/>'
        },
        "vector-bezier": {
            body: '<path fill="currentColor" d="M7.5 4A1.5 1.5 0 0 0 6 5.5A1.5 1.5 0 0 0 7.5 7c.63 0 1.2-.4 1.41-1H13c.67-.67 1.33-1 2-1H8.91c-.21-.6-.78-1-1.41-1M19 5C8 5 14 17 5 17v2c11 0 5-12 14-12V5m-2.5 12c-.63 0-1.2.4-1.41 1H11c-.67.67-1.33 1-2 1h6.09c.21.6.78 1 1.41 1a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "vector-circle": {
            body: '<path fill="currentColor" d="M9 2v2.06A8.522 8.522 0 0 0 4.05 9H2v6h2.06A8.494 8.494 0 0 0 9 19.95V22h6v-2.06A8.494 8.494 0 0 0 19.95 15H22V9h-2.06A8.522 8.522 0 0 0 15 4.05V2m-4 2h2v2h-2m-2 .25V8h6V6.25c1.18.61 2.14 1.57 2.75 2.75H16v6h1.75A6.406 6.406 0 0 1 15 17.75V16H9v1.75A6.406 6.406 0 0 1 6.25 15H8V9H6.25A6.406 6.406 0 0 1 9 6.25M4 11h2v2H4m14-2h2v2h-2m-7 5h2v2h-2"/>'
        },
        "vector-circle-variant": {
            body: '<path fill="currentColor" d="M22 9h-2.03c-1.27-3.59-4.66-6-8.47-6a9 9 0 0 0-9 9c0 5 4.03 9 9 9c3.81 0 7.2-2.4 8.5-6h2m-2-4v2h-2v-2m-.18 4c-1.16 2.44-3.62 4-6.32 4c-3.86 0-7-3.13-7-7c0-3.86 3.14-7 7-7c2.7 0 5.16 1.57 6.31 4H16v6"/>'
        },
        "vector-combine": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v4c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-4V3c0-1.11-.89-2-2-2H3m0 2h11v4H9c-1.11 0-2 .89-2 2v5H3V3m6 6h5v5H9V9m7 0h4v11H9v-4h5c1.11 0 2-.89 2-2V9Z"/>'
        },
        "vector-curve": {
            body: '<path fill="currentColor" d="M18.5 2A1.5 1.5 0 0 1 20 3.5A1.5 1.5 0 0 1 18.5 5c-.23 0-.45-.05-.65-.15l-3.69 3.7l.34.45c2.19-1.26 4.76-2 7.5-2l1 .03v2.01L22 9c-2.58 0-5 .75-7 2.04A3.96 3.96 0 0 1 11.04 15C9.75 17 9 19.42 9 22l.04 1H7.03L7 22c0-2.74.74-5.31 2-7.5l-.45-.34l-3.7 3.69c.1.2.15.42.15.65A1.5 1.5 0 0 1 3.5 20A1.5 1.5 0 0 1 2 18.5A1.5 1.5 0 0 1 3.5 17c.23 0 .45.05.65.15l3.69-3.7C7.31 12.78 7 11.92 7 11a4 4 0 0 1 4-4c.92 0 1.78.31 2.45.84l3.7-3.69c-.1-.2-.15-.42-.15-.65A1.5 1.5 0 0 1 18.5 2M11 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "vector-difference": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h2v-2H3V3h11v2h2V3c0-1.11-.89-2-2-2H3m6 6c-1.11 0-2 .89-2 2v2h2V9h2V7H9m4 0v2h1v1h2V7h-3m5 0v2h2v11H9v-2H7v2c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-2m-4 5v2h-2v2h2c1.11 0 2-.89 2-2v-2h-2m-7 1v3h3v-2H9v-1H7Z"/>'
        },
        "vector-difference-ab": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v2h2V3h2V1H3m4 0v2h3V1H7m5 0v2h2v2h2V3c0-1.11-.89-2-2-2h-2M1 7v3h2V7H1m13 0v7H7v6c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-6m2 2h4v11H9v-4h5c1.11 0 2-.89 2-2V9M1 12v2c0 1.11.89 2 2 2h2v-2H3v-2H1Z"/>'
        },
        "vector-difference-ba": {
            body: '<path fill="currentColor" d="M20 22c1.11 0 2-.89 2-2v-2h-2v2h-2v2h2m-4 0v-2h-3v2h3m-5 0v-2H9v-2H7v2c0 1.11.89 2 2 2h2m11-6v-3h-2v3h2M9 16V9h7V3c0-1.11-.89-2-2-2H3c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h6m-2-2H3V3h11v4H9c-1.11 0-2 .89-2 2v5m15-3V9c0-1.11-.89-2-2-2h-2v2h2v2h2Z"/>'
        },
        "vector-ellipse": {
            body: '<path fill="currentColor" d="M23 9v6h-2.65c-.97 2.12-2.92 3.78-5.35 4.54V22H9v-2.46C5.5 18.45 3 15.5 3 12c0-4.42 4.03-8 9-8c3.78 0 7 2.07 8.35 5H23m-6 6V9h1.06C16.85 7.21 14.59 6 12 6c-3.87 0-7 2.69-7 6c0 2.39 1.64 4.46 4 5.42V16h6v1.42c1.29-.52 2.35-1.37 3.06-2.42H17m2-2h2v-2h-2v2m-8 7h2v-2h-2v2Z"/>'
        },
        "vector-intersection": {
            body: '<path fill="currentColor" d="M3.14 1A2.14 2.14 0 0 0 1 3.14V5h2V3h2V1H3.14M7 1v2h3V1H7m5 0v2h2v2h2V3.14C16 1.96 15.04 1 13.86 1H12M1 7v3h2V7H1m8 0c-1.11 0-2 .89-2 2v7h6.86A2.14 2.14 0 0 0 16 13.86V7H9m9 0v2h2v2h2V9c0-1.11-.89-2-2-2h-2M9 9h5v5H9V9m-8 3v1.86C1 15.04 1.96 16 3.14 16H5v-2H3v-2H1m19 1v3h2v-3h-2M7 18v2c0 1.11.89 2 2 2h2v-2H9v-2H7m13 0v2h-2v2h2c1.11 0 2-.89 2-2v-2h-2m-7 2v2h3v-2h-3Z"/>'
        },
        "vector-line": {
            body: '<path fill="currentColor" d="M15 3v4.59L7.59 15H3v6h6v-4.58L16.42 9H21V3m-4 2h2v2h-2M5 17h2v2H5"/>'
        },
        "vector-link": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2v-3h-2v3H3V3h11v2h2V3c0-1.11-.89-2-2-2M9 7c-1.11 0-2 .89-2 2v3h2V9h11v11H9v-2H7v2c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2H9"/>'
        },
        "vector-point": {
            body: '<path fill="currentColor" d="M9 9v6h6V9H9m2 2h2v2h-2v-2Z"/>'
        },
        "vector-point-edit": {
            body: '<path fill="currentColor" d="M9 9v6h6V9H9m2 2h2v2h-2v-2m10.2 2c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.2-.1-.3-.2-.4-.2m-2.1 1.8L13 20.9V23h2.1l6.1-6.2l-2.1-2Z"/>'
        },
        "vector-point-minus": {
            body: '<path fill="currentColor" d="M9 9v6h6V9H9m2 2h2v2h-2v-2m4 7v2h8v-2h-8Z"/>'
        },
        "vector-point-plus": {
            body: '<path fill="currentColor" d="M9 9v6h6V9H9m2 2h2v2h-2v-2m7 4v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z"/>'
        },
        "vector-point-select": {
            body: '<path fill="currentColor" d="m12 20l-5 2l5-11l5 11l-5-2M8 2h8v3h6v2h-6v3H8V7H2V5h6V2m2 2v4h4V4h-4Z"/>'
        },
        "vector-polygon": {
            body: '<path fill="currentColor" d="M2 2v6h2.28l1.29 8H4v6h6v-1.94l5-.01V22h6v-6h-1.83L20 9h2V3h-6v3.53L14.8 8H9.59L8 5.82V2M4 4h2v2H4m14-1h2v2h-2M6.31 8h.8L9 10.59V14h6v-3.09L16.57 9H18l-.84 7H15v2.06h-5V16H7.6m3.4-6h2v2h-2m-5 6h2v2H6m11-2h2v2h-2"/>'
        },
        "vector-polygon-variant": {
            body: '<path fill="currentColor" d="M22 8V2h-6v3.8L14.4 8H9.6L8 5.8V2H2v6h2v8H2v6h6v-2h8v2h6v-6h-2V8h2m-11 2h2v2h-2v-2M4 4h2v2H4V4m2 16H4v-2h2v2m10-2H8v-2H6V8h1.1L9 10.6V14h6v-3.4L16.9 8H18v8h-2v2m4 2h-2v-2h2v2M18 6V4h2v2h-2Z"/>'
        },
        "vector-polyline": {
            body: '<path fill="currentColor" d="M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3M4 5h2v2H4m14 0h2v2h-2M8 17h2v2H8Z"/>'
        },
        "vector-polyline-edit": {
            body: '<path fill="currentColor" d="M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3H2m2 2h2v2H4V5m14 2h2v2h-2V7m3.15 6c-.15 0-.28.05-.39.16l-1.01 1.02l2.07 2.07l1.02-1.01c.21-.21.21-.57 0-.78l-1.3-1.3a.544.544 0 0 0-.39-.16m-2 1.76L13 20.91V23h2.09l6.14-6.16l-2.08-2.08M8 17h2v2H8v-2Z"/>'
        },
        "vector-polyline-minus": {
            body: '<path fill="currentColor" d="M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3H2m2 2h2v2H4V5m14 2h2v2h-2V7M8 17h2v2H8v-2m7 1v2h8v-2h-8Z"/>'
        },
        "vector-polyline-plus": {
            body: '<path fill="currentColor" d="M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3H2m2 2h2v2H4V5m14 2h2v2h-2V7m0 8v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2M8 17h2v2H8v-2Z"/>'
        },
        "vector-polyline-remove": {
            body: '<path fill="currentColor" d="M21.1 15.5L19 17.6l-2.1-2.1l-1.4 1.4l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4l-2.1-2.1l2.1-2.1l-1.4-1.4M16 5v4.6L10.6 15H9.1l-2-6H8V3H2v6h3l2 6H6v6h6v-4.6l5.4-5.4H22V5h-6M6 7H4V5h2v2m4 12H8v-2h2v2M20 9h-2V7h2v2"/>'
        },
        "vector-radius": {
            body: '<path fill="currentColor" d="M2 4h2V2h6v2a10 10 0 0 1 10 10h2v6h-2v2h-2v-2h-2v-6h2a8 8 0 0 0-8-8v2H4V6H2V4m16 12v2h2v-2h-2M6 4v2h2V4H6Z"/>'
        },
        "vector-rectangle": {
            body: '<path fill="currentColor" d="M2 4h6v2h8V4h6v6h-2v4h2v6h-6v-2H8v2H2v-6h2v-4H2V4m14 6V8H8v2H6v4h2v2h8v-2h2v-4h-2M4 6v2h2V6H4m14 0v2h2V6h-2M4 16v2h2v-2H4m14 0v2h2v-2h-2Z"/>'
        },
        "vector-selection": {
            body: '<path fill="currentColor" d="M3 1h2v2H3v2H1V3a2 2 0 0 1 2-2m11 0a2 2 0 0 1 2 2v2h-2V3h-2V1h2m6 6a2 2 0 0 1 2 2v2h-2V9h-2V7h2m2 13a2 2 0 0 1-2 2h-2v-2h2v-2h2v2m-2-7h2v3h-2v-3m-7-4V7h3v3h-2V9h-1m0 13v-2h3v2h-3m-4 0a2 2 0 0 1-2-2v-2h2v2h2v2H9m-2-6v-3h2v1h1v2H7M7 3V1h3v2H7M3 16a2 2 0 0 1-2-2v-2h2v2h2v2H3M1 7h2v3H1V7m8 0h2v2H9v2H7V9a2 2 0 0 1 2-2m7 7a2 2 0 0 1-2 2h-2v-2h2v-2h2v2Z"/>'
        },
        "vector-square": {
            body: '<path fill="currentColor" d="M2 2h6v2h8V2h6v6h-2v8h2v6h-6v-2H8v2H2v-6h2V8H2V2m14 6V6H8v2H6v8h2v2h8v-2h2V8h-2M4 4v2h2V4H4m14 0v2h2V4h-2M4 18v2h2v-2H4m14 0v2h2v-2h-2Z"/>'
        },
        "vector-square-close": {
            body: '<path fill="currentColor" d="M4 4h2v2H4V4m2 16H4v-2h2v2M18 8v8h-2v2H8v-2H6V8h2V2H2v6h2v8H2v6h6v-2h8v2h6v-6h-2V8h2V2h-6v6h2m2 12h-2v-2h2v2M18 6V4h2v2h-2m-4 0h-4V4h4v2Z"/>'
        },
        "vector-square-edit": {
            body: '<path fill="currentColor" d="m22.7 14.4l-1 1l-2.1-2.1l1-1c.2-.2.6-.2.8 0l1.3 1.3c.2.2.2.5 0 .8M13 19.9l6.1-6.1l2.1 2.1l-6.1 6.1H13v-2.1m-2 0v-.8l.6-.6l.5-.5H8v-2H6V8h2V6h8v2h2v4.1l1.1-1.1l.2-.2c.2-.2.5-.4.8-.5V8h2V2h-6v2H8V2H2v6h2v8H2v6h6v-2l3-.1M18 4h2v2h-2V4M4 4h2v2H4V4m2 16H4v-2h2v2Z"/>'
        },
        "vector-square-minus": {
            body: '<path fill="currentColor" d="M13 19c0-.3 0-.7.1-1H8v-2H6V8h2V6h8v2h2v5.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V8h2V2h-6v2H8V2H2v6h2v8H2v6h6v-2h5.1c-.1-.3-.1-.7-.1-1m5-15h2v2h-2V4M4 4h2v2H4V4m2 16H4v-2h2v2m17-2v2h-8v-2h8Z"/>'
        },
        "vector-square-open": {
            body: '<path fill="currentColor" d="M4 4h2v2H4V4m2 16H4v-2h2v2M18 8v8h-2v2H8v-2H6V8h2V2H2v6h2v8H2v6h6v-2h8v2h6v-6h-2V8h2V2h-6v6h2m2 12h-2v-2h2v2M18 6V4h2v2h-2Z"/>'
        },
        "vector-square-plus": {
            body: '<path fill="currentColor" d="M13 19c0-.3 0-.7.1-1H8v-2H6V8h2V6h8v2h2v5.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V8h2V2h-6v2H8V2H2v6h2v8H2v6h6v-2h5.1c-.1-.3-.1-.7-.1-1m5-15h2v2h-2V4M4 4h2v2H4V4m2 16H4v-2h2v2m14-5v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "vector-square-remove": {
            body: '<path fill="currentColor" d="M13 19c0-.3 0-.7.1-1H8v-2H6V8h2V6h8v2h2v5.1c.3-.1.7-.1 1-.1c.3 0 .7 0 1 .1V8h2V2h-6v2H8V2H2v6h2v8H2v6h6v-2h5.1c-.1-.3-.1-.7-.1-1m5-15h2v2h-2V4M4 4h2v2H4V4m2 16H4v-2h2v2m16.5-3.1L20.4 19l2.1 2.1l-1.4 1.4l-2.1-2.1l-2.1 2.1l-1.4-1.4l2.1-2.1l-2.1-2.1l1.4-1.4l2.1 2.1l2.1-2.1l1.4 1.4Z"/>'
        },
        "vector-triangle": {
            body: '<path fill="currentColor" d="M9 3v6h.73l-3.94 7H2v6h6v-2h8v2h6v-6h-3.79l-3.94-7H15V3m-4 2h2v2h-2m1 2.04l4 7.11V18H8v-1.85M4 18h2v2H4m14-2h2v2h-2"/>'
        },
        "vector-union": {
            body: '<path fill="currentColor" d="M3 1c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v4c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2V9c0-1.11-.89-2-2-2h-4V3c0-1.11-.89-2-2-2H3m0 2h11v6h6v11H9v-6H3V3Z"/>'
        },
        venmo: {
            body: '<path d="M19.5 3c.64 1.08.94 2.19.94 3.6c0 4.48-3.83 10.31-6.94 14.4H6.41L3.56 4l6.21-.61l1.51 12.11c1.41-2.29 3.14-5.89 3.14-8.34c0-1.35-.23-2.26-.59-3.01L19.5 3z" fill="currentColor"/>',
            hidden: true
        },
        vhs: {
            body: '<path fill="currentColor" d="M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4m.54 4H7v4H4.54c-.35-.61-.54-1.3-.54-2s.19-1.39.54-2M9 10h6v4H9v-4m8 0h2.46c.35.61.54 1.3.54 2s-.19 1.39-.54 2H17v-4Z"/>'
        },
        vibrate: {
            body: '<path fill="currentColor" d="M16 19H8V5h8m.5-2h-9A1.5 1.5 0 0 0 6 4.5v15A1.5 1.5 0 0 0 7.5 21h9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 16.5 3M19 17h2V7h-2m3 2v6h2V9M3 17h2V7H3m-3 8h2V9H0v6Z"/>'
        },
        "vibrate-off": {
            body: '<path fill="currentColor" d="M8.2 5L6.55 3.35c.26-.23.6-.35.95-.35h9A1.5 1.5 0 0 1 18 4.5v10.3l-2-2V5H8.2M0 15h2V9H0v6m21 2V7h-2v8.8l1.2 1.2h.8M3 17h2V7H3v10m15 .35l4.11 4.11l-1.27 1.27L18 19.85c-.17.69-.79 1.15-1.5 1.15h-9A1.5 1.5 0 0 1 6 19.5V7.89L1.11 3l1.28-1.27l3.7 3.71L8 7.34l8 8l2 2v.01m-2 .54l-8-8V19h8v-1.11M22 9v6h2V9h-2Z"/>'
        },
        video: {
            body: '<path fill="currentColor" d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4Z"/>'
        },
        "video-2d": {
            body: '<path fill="currentColor" d="M13 7h3c1.66 0 3 1.34 3 3v4c0 1.66-1.34 3-3 3h-3V7m3 8c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-1v6h1M5 7h4a2 2 0 0 1 2 2v2c0 1.11-.89 2-2 2H7v2h4v2H5v-4c0-1.1.9-2 2-2h2V9H5V7Z"/>'
        },
        "video-3d": {
            body: '<path fill="currentColor" d="M5 7h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5v-2h4v-2H6v-2h3V9H5V7m8 0h3a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-3V7m3 8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1v6h1Z"/>'
        },
        "video-3d-off": {
            body: '<path fill="currentColor" d="m2.61 2l18.74 18.74l-1.41 1.41L14.8 17H13v-1.8l-2-1.97v1.98c-.07.47-.26.87-.59 1.2c-.33.32-.73.52-1.2.59H5v-2h4v-2H6v-2h2.8L6.79 9H5V7.23L1.2 3.41L2.61 2M16 7h.22c.78.07 1.41.36 1.92.88c.51.51.79 1.12.86 1.88v4.48c-.05.39-.13.76-.28 1.06L17 13.6V9.85c-.05-.22-.16-.41-.31-.57c-.16-.15-.35-.25-.57-.28H15v2.59l-2-2.02V7h3Z"/>'
        },
        "video-3d-variant": {
            body: '<path fill="currentColor" d="M14 10v4a.5.5 0 0 1-.5.5h-1v-5h1a.5.5 0 0 1 .5.5m7-3.5v11l-4-4V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3.5m-7.5-1A1.5 1.5 0 0 0 8 8H4.5v1.5H8v1.75H5.5v1.5H8v1.75H4.5V16H8a1.5 1.5 0 0 0 1.5-1.5m6-5A1.5 1.5 0 0 0 14 8h-3v8h3a1.5 1.5 0 0 0 1.5-1.5"/>'
        },
        "video-4k-box": {
            body: '<path fill="currentColor" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 10.5h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.5m6 1.5h-1.8l-1.8-2.2V15H13V9h1.5v2.2L16.2 9H18l-2.2 3l2.2 3Z"/>'
        },
        "video-account": {
            body: '<path fill="currentColor" d="m17 10.5l4-4v11l-4-4V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3.5M14 16v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1h8m-4-8a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "video-box": {
            body: '<path fill="currentColor" d="m18 16l-4-3.2V16H6V8h8v3.2L18 8m2-4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"/>'
        },
        "video-box-off": {
            body: '<path fill="currentColor" d="M6 8h.73L14 15.27V16H6M2.27 1L1 2.27l2 2.01c-.59.34-1 .98-1 1.72v12a2 2 0 0 0 2 2h14.73l2 2L22 20.73M20 4H7.82l4 4H14v2.18l.57.57L18 8v6.18l4 3.99V6a2 2 0 0 0-2-2Z"/>'
        },
        "video-check": {
            body: '<path fill="currentColor" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4M8.93 15L6 11.8l1.24-1.24l1.69 1.7l3.83-3.83L14 9.93L8.93 15Z"/>'
        },
        "video-check-outline": {
            body: '<path fill="currentColor" d="M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1m-9.65 6.08l1.15-1.13L9 12.5L12.5 9l1.15 1.37L9 15l-2.65-2.92Z"/>'
        },
        "video-high-definition": {
            body: '<path fill="currentColor" d="M14 10v4c0 .3-.2.5-.5.5h-1v-5h1c.3 0 .5.2.5.5m3 .5V7c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-3.5l4 4v-11l-4 4M9.5 16H8v-3.2H6V16H4.5V8H6v3.2h2V8h1.5v8m6-1.5c0 .8-.7 1.5-1.5 1.5h-3V8h3c.8 0 1.5.7 1.5 1.5v5Z"/>'
        },
        "video-image": {
            body: '<path fill="currentColor" d="m17 10.5l4-4v11l-4-4V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3.5m-6.09-.95L9.2 11.82l1.3 1.73l-.73.54l-2.04-2.73L5 15h10l-4.09-5.45Z"/>'
        },
        "video-input-antenna": {
            body: '<path fill="currentColor" d="M12 5a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7m1 9.29c.88-.39 1.5-1.26 1.5-2.29A2.5 2.5 0 0 0 12 9.5A2.5 2.5 0 0 0 9.5 12c0 1 .62 1.9 1.5 2.29v3.3L7.59 21L9 22.41l3-3l3 3L16.41 21L13 17.59v-3.3M12 1A11 11 0 0 0 1 12h2a9 9 0 0 1 9-9a9 9 0 0 1 9 9h2A11 11 0 0 0 12 1Z"/>'
        },
        "video-input-component": {
            body: '<path fill="currentColor" d="M5 2a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4H1v6h6V6H5V2m4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2m-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2M21 6V2a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4h-2v6h6V6h-2m-8-4a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4H9v6h6V6h-2V2m4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2Z"/>'
        },
        "video-input-hdmi": {
            body: '<path fill="currentColor" d="M18 7V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1M8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4Z"/>'
        },
        "video-input-scart": {
            body: '<path fill="currentColor" d="m20.6 2.2l-3.3.2l-3.5 2l-.5-.9L2 10v7h1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-2h1v-7h-1l-.2-.4l3.5-2l1.8-2.8l-1.5-2.6M15 17v2H5v-2h10Z"/>'
        },
        "video-input-svideo": {
            body: '<path fill="currentColor" d="M8 11.5A1.5 1.5 0 0 0 6.5 10A1.5 1.5 0 0 0 5 11.5A1.5 1.5 0 0 0 6.5 13A1.5 1.5 0 0 0 8 11.5m7-5A1.5 1.5 0 0 0 13.5 5h-3A1.5 1.5 0 0 0 9 6.5A1.5 1.5 0 0 0 10.5 8h3A1.5 1.5 0 0 0 15 6.5M8.5 15A1.5 1.5 0 0 0 7 16.5A1.5 1.5 0 0 0 8.5 18a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 8.5 15M12 1A11 11 0 0 0 1 12a11 11 0 0 0 11 11a11 11 0 0 0 11-11A11 11 0 0 0 12 1m0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9s9 4.04 9 9s-4.04 9-9 9m5.5-11a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5m-2 5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "video-marker": {
            body: '<path fill="currentColor" d="M5.5 16.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2m0-4.8C3.6 12 2 13.6 2 15.5C2 18.1 5.5 22 5.5 22S9 18.1 9 15.5C9 13.6 7.4 12 5.5 12M4 6c-.6 0-1 .4-1 1v3.6c.8-.4 1.6-.6 2.5-.6c3 0 5.5 2.5 5.5 5.5c0 .9-.2 1.7-.5 2.5H16c.6 0 1-.4 1-1v-3.5l4 4v-11l-4 4V7c0-.6-.4-1-1-1H4Z"/>'
        },
        "video-marker-outline": {
            body: '<path fill="currentColor" d="M5.5 16.8c-.7 0-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c.1.6-.5 1.2-1.2 1.2m0-4.8C3.6 12 2 13.6 2 15.5C2 18.1 5.5 22 5.5 22S9 18.1 9 15.5C9 13.6 7.4 12 5.5 12M4 6c-.6 0-1 .4-1 1v3.6c.6-.3 1.3-.5 2-.6V8h10v8h-4c-.1.7-.2 1.4-.5 2H16c.6 0 1-.4 1-1v-3.5l4 4v-11l-4 4V7c0-.6-.4-1-1-1H4Z"/>'
        },
        "video-minus": {
            body: '<path fill="currentColor" d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4M14 13H6v-2h8v2Z"/>'
        },
        "video-minus-outline": {
            body: '<path fill="currentColor" d="M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1m-3 7H7v-2h6v2Z"/>'
        },
        "video-off": {
            body: '<path fill="currentColor" d="M3.27 2L2 3.27L4.73 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12c.2 0 .39-.08.54-.18L19.73 21L21 19.73M21 6.5l-4 4V7a1 1 0 0 0-1-1H9.82L21 17.18V6.5Z"/>'
        },
        "video-off-outline": {
            body: '<path fill="currentColor" d="M3.41 1.86L2 3.27L4.73 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41l-8.86-8.86l-8.87-8.87M5 16V8h1.73l8 8H5m10-8v2.61l6 6V6.5l-4 4V7a1 1 0 0 0-1-1h-5.61l2 2H15Z"/>'
        },
        "video-outline": {
            body: '<path fill="currentColor" d="M15 8v8H5V8h10m1-2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4V7a1 1 0 0 0-1-1Z"/>'
        },
        "video-plus": {
            body: '<path fill="currentColor" d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4M14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2Z"/>'
        },
        "video-plus-outline": {
            body: '<path fill="currentColor" d="M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1m-3 7h-2v2H9v-2H7v-2h2V9h2v2h2v2Z"/>'
        },
        "video-stabilization": {
            body: '<path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h16V6H4m3.24.58l11.59 3.11l-2.07 7.73l-11.59-3.11l2.07-7.73Z"/>'
        },
        "video-switch": {
            body: '<path fill="currentColor" d="M13 15.5V13H7v2.5L3.5 12L7 8.5V11h6V8.5l3.5 3.5M18 9.5V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.5l4 4v-13l-4 4Z"/>'
        },
        "video-switch-outline": {
            body: '<path fill="currentColor" d="M8 13h4v2l3-3l-3-3v2H8V9l-3 3l3 3v-2m10-3.5V6c0-.6-.5-1-1-1H3c-.5 0-1 .4-1 1v12c0 .5.5 1 1 1h14c.5 0 1-.5 1-1v-3.5l4 4v-13l-4 4M16 17H4V7h12v10Z"/>'
        },
        "video-vintage": {
            body: '<path fill="currentColor" d="M18 14.5V11a1 1 0 0 0-1-1h-1c2.24-1.61 2.76-4.73 1.15-7a5.02 5.02 0 0 0-6.98-1.13C9.5 2.35 8.96 3 8.6 3.73a4.985 4.985 0 0 0-6.88 1.64a5.002 5.002 0 0 0 1.64 6.88c.21.12.42.25.64.33V21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4M13 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"/>'
        },
        "video-wireless": {
            body: '<path fill="currentColor" d="M17 14.5V11a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11M3 3.86l1.4 1.38c3.1-3.05 8.1-3.05 11.2 0L17 3.86C13.14.05 6.87.05 3 3.86m2.8 2.76L7.2 8c1.55-1.5 4.05-1.5 5.6 0l1.4-1.38c-2.32-2.28-6.08-2.28-8.4 0Z"/>'
        },
        "video-wireless-outline": {
            body: '<path fill="currentColor" d="M15 12v8H5v-8h10m1-2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4V11a1 1 0 0 0-1-1M3 3.86l1.4 1.38c3.1-3.05 8.1-3.05 11.2 0L17 3.86C13.14.05 6.87.05 3 3.86m2.8 2.77L7.2 8c1.55-1.5 4.05-1.5 5.6 0l1.4-1.37c-2.32-2.29-6.08-2.29-8.4 0Z"/>'
        },
        "view-agenda": {
            body: '<path fill="currentColor" d="M21 3H3c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1m0 10H3c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1Z"/>'
        },
        "view-agenda-outline": {
            body: '<path fill="currentColor" d="M21 13H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-1 6H4v-4h16m1-12H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-1 6H4V5h16Z"/>'
        },
        "view-array": {
            body: '<path fill="currentColor" d="M8 18h9V5H8m10 0v13h3V5M4 18h3V5H4v13Z"/>'
        },
        "view-array-outline": {
            body: '<path fill="currentColor" d="M15 7v9h-5V7h5m6-2h-3v13h3V5m-4 0H8v13h9V5M7 5H4v13h3V5Z"/>'
        },
        "view-carousel": {
            body: '<path fill="currentColor" d="M18 6v11h4V6M2 17h4V6H2m5 13h10V4H7v15Z"/>'
        },
        "view-carousel-outline": {
            body: '<path fill="currentColor" d="M2 6h4v11H2V6m5 13h10V4H7v15M9 6h6v11H9V6m9 0h4v11h-4V6Z"/>'
        },
        "view-column": {
            body: '<path fill="currentColor" d="M16 5v13h5V5M4 18h5V5H4m6 13h5V5h-5v13Z"/>'
        },
        "view-column-outline": {
            body: '<path fill="currentColor" d="M4 5v13h17V5H4m10 2v9h-3V7h3M6 7h3v9H6V7m13 9h-3V7h3v9Z"/>'
        },
        "view-comfy": {
            body: '<path fill="currentColor" d="M3 9h4V5H3v4m0 5h4v-4H3v4m5 0h4v-4H8v4m5 0h4v-4h-4v4M8 9h4V5H8v4m5-4v4h4V5h-4m5 9h4v-4h-4v4M3 19h4v-4H3v4m5 0h4v-4H8v4m5 0h4v-4h-4v4m5 0h4v-4h-4v4m0-14v4h4V5h-4Z"/>'
        },
        "view-comfy-outline": {
            body: '<path fill="currentColor" d="M3 5v14h19V5H3m17 4h-2.25V7H20v2M9.25 11h2.25v2H9.25v-2m-2 2H5v-2h2.25v2m4.25-4H9.25V7h2.25v2m2-2h2.25v2H13.5V7m-2 8v2H9.25v-2h2.25m2 0h2.25v2H13.5v-2m0-2v-2h2.25v2H13.5m4.25-2H20v2h-2.25v-2M7.25 7v2H5V7h2.25M5 15h2.25v2H5v-2m12.75 2v-2H20v2h-2.25Z"/>'
        },
        "view-compact": {
            body: '<path fill="currentColor" d="M3 19h6v-7H3v7m7 0h12v-7H10v7M3 5v6h19V5H3Z"/>'
        },
        "view-compact-outline": {
            body: '<path fill="currentColor" d="M3 5v14h19V5H3m2 2h15v4H5V7m0 10v-4h4v4H5m6 0v-4h9v4h-9Z"/>'
        },
        "view-dashboard": {
            body: '<path fill="currentColor" d="M13 3v6h8V3m-8 18h8V11h-8M3 21h8v-6H3m0-2h8V3H3v10Z"/>'
        },
        "view-dashboard-edit": {
            body: '<path fill="currentColor" d="M21 13.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V23h2.1l6.1-6.1l-2.1-2M21 9h-8V3h8v6m-8 9.06V11h8v.1c-.76 0-1.43.4-1.81.79L13 18.06M11 13H3V3h8v10m0 8H3v-6h8v6Z"/>'
        },
        "view-dashboard-edit-outline": {
            body: '<path fill="currentColor" d="M21 13.1c-.1 0-.3.1-.4.2l-1 1l2.1 2.1l1-1c.2-.2.2-.6 0-.8l-1.3-1.3c-.1-.1-.2-.2-.4-.2m-1.9 1.8l-6.1 6V23h2.1l6.1-6.1l-2.1-2M21 3h-8v6h8V3m-2 4h-4V5h4v2m-6 11.06V11h8v.1c-.76 0-1.43.4-1.81.79L18.07 13H15v3.07l-2 1.99M11 3H3v10h8V3m-2 8H5V5h4v6m2 9.06V15H3v6h8v-.94M9 19H5v-2h4v2Z"/>'
        },
        "view-dashboard-outline": {
            body: '<path fill="currentColor" d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3M11 3H3v10h8V3m10 8h-8v10h8V11m-10 4H3v6h8v-6Z"/>'
        },
        "view-dashboard-variant": {
            body: '<path fill="currentColor" d="M2 5v14h6V5H2m7 0v5h6V5H9m7 0v9h6V5h-6m-7 6v8h6v-8H9m7 4v4h6v-4h-6Z"/>'
        },
        "view-dashboard-variant-outline": {
            body: '<path fill="currentColor" d="M2 5v14h20V5H2m18 7h-4V7h4v5m-6-2h-4V7h4v3m-4 2h4v5h-4v-5M4 7h4v10H4V7m12 10v-3h4v3h-4Z"/>'
        },
        "view-day": {
            body: '<path fill="currentColor" d="M2 3v3h19V3m-1 5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1M2 21h19v-3H2v3Z"/>'
        },
        "view-day-outline": {
            body: '<path fill="currentColor" d="M21 18H2v2h19v-2m-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1m1-4H2v2h19V4Z"/>'
        },
        "view-gallery": {
            body: '<path fill="currentColor" d="M21 3H2v13h19V3M2 17h4v4H2v-4m5 0h4v4H7v-4m5 0h4v4h-4v-4m5 0h4v4h-4v-4Z"/>'
        },
        "view-gallery-outline": {
            body: '<path fill="currentColor" d="M1 3v18h22V3H1m20 2v9H3V5h18M11 16v3H8v-3h3m-8 0h3v3H3v-3m10 3v-3h3v3h-3m5 0v-3h3v3h-3Z"/>'
        },
        "view-grid": {
            body: '<path fill="currentColor" d="M3 11h8V3H3m0 18h8v-8H3m10 8h8v-8h-8m0-10v8h8V3"/>'
        },
        "view-grid-outline": {
            body: '<path fill="currentColor" d="M3 11h8V3H3m2 2h4v4H5m8 12h8v-8h-8m2 2h4v4h-4M3 21h8v-8H3m2 2h4v4H5m8-16v8h8V3m-2 6h-4V5h4Z"/>'
        },
        "view-grid-plus": {
            body: '<path fill="currentColor" d="M13 3v8h8V3h-8M3 21h8v-8H3v8M3 3v8h8V3H3m10 13h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "view-grid-plus-outline": {
            body: '<path fill="currentColor" d="M3 21h8v-8H3m2 2h4v4H5m-2-8h8V3H3m2 2h4v4H5m8-6v8h8V3m-2 6h-4V5h4m-1 11h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/>'
        },
        "view-headline": {
            body: '<path fill="currentColor" d="M4 5v2h17V5M4 11h17V9H4m0 10h17v-2H4m0-2h17v-2H4v2Z"/>'
        },
        "view-list": {
            body: '<path fill="currentColor" d="M9 5v4h12V5M9 19h12v-4H9m0-1h12v-4H9M4 9h4V5H4m0 14h4v-4H4m0-1h4v-4H4v4Z"/>'
        },
        "view-list-outline": {
            body: '<path fill="currentColor" d="M3 5v14h17V5H3m4 2v2H5V7h2m-2 6v-2h2v2H5m0 2h2v2H5v-2m13 2H9v-2h9v2m0-4H9v-2h9v2m0-4H9V7h9v2Z"/>'
        },
        "view-module": {
            body: '<path fill="currentColor" d="M16 5v6h5V5m-11 6h5V5h-5m6 13h5v-6h-5m-6 6h5v-6h-5m-6 6h5v-6H4m0-1h5V5H4v6Z"/>'
        },
        "view-module-outline": {
            body: '<path fill="currentColor" d="M4 5v13h17V5H4m10 2v3.5h-3V7h3M6 7h3v3.5H6V7m0 9v-3.5h3V16H6m5 0v-3.5h3V16h-3m8 0h-3v-3.5h3V16m-3-5.5V7h3v3.5h-3Z"/>'
        },
        "view-parallel": {
            body: '<path fill="currentColor" d="M19 3v18h-4V3h4m-5 0v18h-4V3h4M9 3v18H5V3h4Z"/>'
        },
        "view-parallel-outline": {
            body: '<path fill="currentColor" d="M19 3H5v18h14V3m-2 16h-2V5h2v14m-4 0h-2V5h2v14M7 5h2v14H7V5Z"/>'
        },
        "view-quilt": {
            body: '<path fill="currentColor" d="M10 5v6h11V5m-5 13h5v-6h-5M4 18h5V5H4m6 13h5v-6h-5v6Z"/>'
        },
        "view-quilt-outline": {
            body: '<path fill="currentColor" d="M4 5v13h17V5H4m2 11V7h3v9H6m5 0v-3.5h3V16h-3m8 0h-3v-3.5h3V16m-8-5.5V7h8v3.5h-8Z"/>'
        },
        "view-sequential": {
            body: '<path fill="currentColor" d="M3 5h18v4H3V5m0 5h18v4H3v-4m0 5h18v4H3v-4Z"/>'
        },
        "view-sequential-outline": {
            body: '<path fill="currentColor" d="M3 5v14h18V5H3m16 2v2H5V7h14m0 4v2H5v-2h14M5 17v-2h14v2H5Z"/>'
        },
        "view-split-horizontal": {
            body: '<path fill="currentColor" d="M3 5h18v2H3V5m0 6V9h18v2H3m0 8v-6h18v6H3Z"/>'
        },
        "view-split-vertical": {
            body: '<path fill="currentColor" d="M13 5h8v14h-8V5M3 5h8v2H3V5m0 6V9h8v2H3m0 8v-2h8v2H3m0-4v-2h8v2H3Z"/>'
        },
        "view-stream": {
            body: '<path fill="currentColor" d="M4 5v6h17V5M4 18h17v-6H4v6Z"/>'
        },
        "view-stream-outline": {
            body: '<path fill="currentColor" d="M4 6v12h17V6H4m15 10H6v-3h13v3M6 11V8h13v3H6Z"/>'
        },
        "view-week": {
            body: '<path fill="currentColor" d="M13 5h-3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m7 0h-3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M6 5H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"/>'
        },
        "view-week-outline": {
            body: '<path fill="currentColor" d="M21 4H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1M8 18H4V6h4v12m6 0h-4V6h4v12m6 0h-4V6h4v12Z"/>'
        },
        vimeo: {
            body: '<path fill="currentColor" d="M22 7.42c-.09 1.95-1.45 4.62-4.08 8.02C15.2 19 12.9 20.75 11 20.75c-1.15 0-2.14-1.08-2.95-3.25c-.55-1.96-1.05-3.94-1.61-5.92c-.6-2.16-1.24-3.24-1.94-3.24c-.14 0-.66.32-1.56.95L2 8.07c1-.87 1.96-1.74 2.92-2.61c1.32-1.14 2.31-1.74 2.96-1.8c1.56-.16 2.52.92 2.88 3.2c.39 2.47.66 4 .81 4.6c.43 2.04.93 3.04 1.48 3.04c.42 0 1.05-.64 1.89-1.97c.84-1.32 1.29-2.33 1.35-3.03c.12-1.14-.33-1.71-1.35-1.71c-.48 0-.97.11-1.48.33c.98-3.23 2.86-4.8 5.63-4.71c2.06.06 3.03 1.4 2.91 4.01Z"/>'
        },
        vine: {
            body: '<path d="M19.89 11.948a5.907 5.907 0 0 1-1.316.154c-2.27 0-4.02-1.586-4.02-4.344c0-1.351.523-2.054 1.262-2.054c.703 0 1.172.63 1.172 1.91c0 .728-.195 1.525-.339 1.997c0 0 .7 1.221 2.614.846c.406-.902.627-2.07.627-3.095C19.89 4.604 18.484 3 15.906 3c-2.649 0-4.2 2.037-4.2 4.723c0 2.66 1.245 4.944 3.295 5.985c-.862 1.725-1.96 3.245-3.104 4.39c-2.076-2.51-3.953-5.86-4.724-12.394H4.11c1.415 10.883 5.633 14.349 6.748 15.014c.631.379 1.174.36 1.751.036c.906-.515 3.625-3.233 5.132-6.417a10.133 10.133 0 0 0 2.15-.246v-2.143z" fill="currentColor"/>',
            hidden: true
        },
        violin: {
            body: '<path fill="currentColor" d="M11 2a1 1 0 0 0-1 1v6a.5.5 0 0 0 .5.5H12a.5.5 0 0 1 .5.5a.5.5 0 0 1-.5.5h-1.5C9.73 10.5 9 9.77 9 9V5.16C7.27 5.6 6 7.13 6 9v1.5A2.5 2.5 0 0 1 8.5 13A2.5 2.5 0 0 1 6 15.5V17c0 2.77 2.23 5 5 5h2c2.77 0 5-2.23 5-5v-1.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5V9c0-2.22-1.78-4-4-4V3a1 1 0 0 0-1-1h-2m-.25 14.5h2.5l-.5 3.5h-1.5l-.5-3.5Z"/>'
        },
        "virtual-reality": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m1 6h1.5l1 3.43L9.5 9H11l-1.75 6h-1.5L6 9m7 0h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4L18 15h-1.5l-.85-2H14.5v2H13V9m1.5 1.5v1h2v-1h-2Z"/>'
        },
        virus: {
            body: '<path fill="currentColor" d="M19.82 14A1.746 1.746 0 0 0 23 13a1.746 1.746 0 0 0-3.18-1H19c0-1.57-.5-3-1.4-4.19l1.34-1.34c.56.1 1.13-.06 1.56-.47c.67-.69.67-1.8 0-2.5c-.69-.67-1.8-.67-2.5 0c-.41.43-.57 1-.47 1.56L16.19 6.4c-.92-.69-2-1.15-3.19-1.32v-1.4A1.746 1.746 0 0 0 12 .5a1.746 1.746 0 0 0-1 3.18v1.4c-.9.13-1.74.42-2.5.86L7.39 4.35c.19-.52.14-1.12-.2-1.6a1.75 1.75 0 0 0-2.44-.43c-.79.55-.99 1.64-.43 2.43c.34.49.88.75 1.43.75l1.18 1.68c-.43.43-.77.91-1.06 1.44A1.76 1.76 0 0 0 4 9c-.67.7-.67 1.8 0 2.5c.29.27.64.43 1 .5c0 .54.07 1.06.18 1.56l-1.31.35c-.42-.35-1-.5-1.58-.35a1.75 1.75 0 1 0 .92 3.38c.57-.16 1-.58 1.18-1.1l1.51-.41c.45.79 1.05 1.49 1.75 2.07l-1.1 2c-.55.08-1.05.39-1.34.92a1.749 1.749 0 1 0 3.08 1.66c.28-.52.27-1.12.02-1.61l1.07-1.97c.81.32 1.69.5 2.62.5h.18c-.13.26-.18.56-.18.88c.08.97.92 1.69 1.88 1.62s1.69-.92 1.62-1.88c-.04-.5-.29-.94-.65-1.23c.47-.21.92-.48 1.34-.79l2.34 2.34c-.1.56.06 1.13.47 1.56c.7.67 1.8.67 2.5 0s.67-1.8 0-2.5c-.43-.41-1-.57-1.56-.47l-2.34-2.34c.49-.65.87-1.39 1.11-2.19h1.11m-9.32-2c-.83 0-1.5-.67-1.5-1.5S9.67 9 10.5 9s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m3.5 3c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "virus-off": {
            body: '<path fill="currentColor" d="M7.42 4.22L5.28 2.08c.69-.2 1.47.04 1.91.67c.31.44.37.98.23 1.47m13.83 7.03c-.59 0-1.12.3-1.43.75H19c0-1.57-.5-3-1.4-4.19l1.34-1.34c.56.1 1.13-.06 1.56-.47c.67-.69.67-1.8 0-2.5c-.69-.67-1.8-.67-2.5 0c-.41.43-.57 1-.47 1.56L16.19 6.4c-.92-.69-2-1.15-3.19-1.32v-1.4A1.746 1.746 0 0 0 12 .5a1.746 1.746 0 0 0-1 3.18v1.4c-.74.11-1.43.33-2.08.64l9.36 9.36c.17-.35.32-.7.43-1.08h1.11A1.746 1.746 0 0 0 23 13c0-.97-.78-1.75-1.75-1.75m.86 10.21l-1.27 1.27l-.74-.73c-.4-.04-.79-.2-1.1-.5c-.3-.31-.46-.7-.5-1.1l-2.6-2.61c-.33.21-.68.44-1.05.6c.36.29.61.73.65 1.23c.07.96-.66 1.81-1.62 1.88s-1.8-.65-1.88-1.62c0-.32.05-.62.18-.88H12c-.93 0-1.81-.18-2.62-.5l-1.07 1.97c.25.49.26 1.09-.02 1.61a1.749 1.749 0 1 1-3.08-1.66c.29-.53.79-.84 1.34-.92l1.1-2c-.7-.58-1.3-1.28-1.75-2.07l-1.51.41c-.18.52-.61.94-1.18 1.1a1.75 1.75 0 1 1-.92-3.38c.58-.15 1.16 0 1.58.35l1.31-.35A7.24 7.24 0 0 1 5 12c-.36-.07-.71-.23-1-.5c-.67-.7-.67-1.8 0-2.5c.5-.5 1.25-.62 1.87-.38c.1-.18.22-.35.33-.53L1.11 3l1.28-1.27l19.72 19.73Z"/>'
        },
        "virus-off-outline": {
            body: '<path fill="currentColor" d="M23 13a1.746 1.746 0 0 1-3.18 1h-1.11c-.11.38-.26.73-.43 1.08l-1.55-1.55c.16-.48.27-.99.27-1.53c0-2.76-2.24-5-5-5c-.54 0-1.05.11-1.53.27L8.92 5.72c.65-.31 1.34-.53 2.08-.64v-1.4A1.746 1.746 0 0 1 12 .5a1.746 1.746 0 0 1 1 3.18v1.4c1.19.17 2.27.63 3.19 1.32l1.34-1.34c-.1-.56.06-1.13.47-1.56c.35-.33.8-.5 1.25-.5s.9.17 1.25.5c.67.7.67 1.81 0 2.5c-.35.33-.8.5-1.25.5c-.1 0-.2 0-.31-.03L17.6 7.81A6.86 6.86 0 0 1 19 12h.82A1.746 1.746 0 0 1 23 13m-.89 8.46l-1.27 1.27l-.74-.73c-.4-.05-.79-.21-1.1-.5c-.3-.31-.46-.7-.5-1.1l-2.6-2.61c-.33.21-.68.44-1.05.6c.36.29.61.73.65 1.23c.07.96-.65 1.8-1.62 1.88h-.13c-.91 0-1.67-.7-1.75-1.62c0-.32.05-.62.18-.88H12c-.93 0-1.81-.18-2.62-.5l-1.07 1.97c.25.49.26 1.09-.02 1.61a1.748 1.748 0 0 1-2.37.71a1.749 1.749 0 0 1-.71-2.37c.29-.53.79-.84 1.34-.92l1.1-2c-.7-.58-1.3-1.28-1.75-2.07l-1.51.41c-.18.52-.61.94-1.18 1.1c-.16.06-.31.06-.46.06c-.75 0-1.48-.5-1.69-1.29c-.251-.94.3-1.9 1.23-2.15c.15-.06.31-.06.46-.06c.41 0 .81.15 1.12.41l1.31-.35A7.24 7.24 0 0 1 5 12c-.36-.08-.71-.23-1-.5c-.67-.7-.67-1.8 0-2.5c.35-.33.8-.5 1.25-.5c.21 0 .42.04.62.12c.1-.18.22-.35.33-.53L1.11 3l1.28-1.27l19.72 19.73m-7.66-5.12L7.66 9.55C7.25 10.28 7 11.11 7 12c0 2.76 2.24 5 5 5c.9 0 1.73-.25 2.45-.66M7.19 2.75C6.84 2.26 6.3 2 5.75 2c-.16 0-.32.03-.48.07l2.15 2.15c.14-.49.08-1.03-.23-1.47Z"/>'
        },
        "virus-outline": {
            body: '<path fill="currentColor" d="M12 .5a1.746 1.746 0 0 0-1 3.18v1.4c-.9.13-1.74.42-2.5.86L7.39 4.35c.19-.52.14-1.12-.2-1.6C6.84 2.26 6.3 2 5.75 2c-.35 0-.7.1-1 .32c-.79.55-.99 1.64-.43 2.43c.34.49.88.75 1.43.75l1.18 1.68c-.43.43-.77.91-1.06 1.44c-.2-.08-.41-.12-.62-.12c-.45 0-.9.17-1.25.5c-.67.7-.67 1.8 0 2.5c.29.27.64.42 1 .5c0 .54.07 1.06.18 1.56l-1.31.35c-.31-.26-.71-.41-1.12-.41c-.15 0-.31 0-.46.06a1.752 1.752 0 0 0-1.23 2.15C1.27 16.5 2 17 2.75 17c.15 0 .3 0 .46-.06c.57-.16 1-.58 1.18-1.1l1.51-.41c.45.79 1.05 1.49 1.75 2.07l-1.1 2c-.55.08-1.05.39-1.34.92a1.749 1.749 0 1 0 3.08 1.66c.28-.52.27-1.12.02-1.61l1.07-1.97c.81.32 1.69.5 2.62.5h.18c-.13.26-.18.56-.18.88c.08.92.84 1.62 1.75 1.62h.13c.97-.08 1.69-.92 1.62-1.88c-.04-.5-.29-.94-.65-1.23c.47-.21.92-.48 1.34-.79l2.34 2.34c-.1.56.06 1.13.47 1.56c.35.33.8.5 1.25.5s.9-.17 1.25-.5c.67-.7.67-1.8 0-2.5c-.35-.33-.8-.5-1.25-.5c-.1 0-.2 0-.31.03l-2.34-2.34c.49-.65.87-1.39 1.11-2.19h1.11A1.746 1.746 0 0 0 23 13a1.746 1.746 0 0 0-3.18-1H19c0-1.57-.5-3-1.4-4.19l1.34-1.34c.11.03.21.03.31.03c.45 0 .9-.17 1.25-.5c.67-.69.67-1.8 0-2.5c-.35-.33-.8-.5-1.25-.5s-.9.17-1.25.5c-.41.43-.57 1-.47 1.56L16.19 6.4c-.92-.69-2-1.15-3.19-1.32v-1.4A1.746 1.746 0 0 0 12 .5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m-1.5-8C9.67 9 9 9.67 9 10.5s.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S11.33 9 10.5 9m3.5 4c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1Z"/>'
        },
        vk: {
            body: '<path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14c5.6 0 6.93-1.33 6.93-6.93V8.93C22 3.33 20.67 2 15.07 2m3.08 14.27h-1.46c-.55 0-.72-.45-1.69-1.44c-.88-.83-1.26-.95-1.47-.95c-.29 0-.38.08-.38.5v1.31c0 .35-.11.57-1.04.57c-1.54 0-3.25-.94-4.45-2.67c-1.81-2.54-2.3-4.46-2.3-4.84c0-.21.07-.41.49-.41h1.47c.37 0 .51.16.65.56c.72 2.1 1.92 3.9 2.41 3.9c.19 0 .27-.09.27-.55V10.1c-.05-.98-.58-1.07-.58-1.42c0-.18.14-.34.37-.34h2.29c.31 0 .42.16.42.54v2.89c0 .31.13.42.23.42c.18 0 .34-.11.67-.45c1.05-1.17 1.8-2.98 1.8-2.98c.1-.21.26-.41.65-.41h1.43c.44 0 .54.23.44.54c-.18.85-1.96 3.36-1.94 3.36c-.16.25-.22.36 0 .65c.15.21.66.65 1 1.04c.62.71 1.1 1.3 1.23 1.71c.11.41-.09.62-.51.62z" fill="currentColor"/>',
            hidden: true
        },
        "vk-box": {
            body: '<path d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5m.5 5.5H7c.36 0 .5.16.64.57c.72 2.1 1.93 3.93 2.43 3.93c.19 0 .28-.08.28-.55v-2.17c-.06-1-.59-1.09-.59-1.44c0-.17.14-.34.38-.34h2.31c.32 0 .42.17.42.54v2.92c0 .31.13.42.23.42c.19 0 .35-.11.69-.45c1.06-1.19 1.81-3.01 1.81-3.01c.1-.22.27-.42.64-.42h1.47c.45 0 .55.23.45.54c-.19.86-1.98 3.39-1.98 3.39c-.18.25-.22.37 0 .66c.15.21.67.65 1.01 1.06c.64.71 1.11 1.31 1.25 1.72c.12.42-.09.63-.51.63h-1.48c-.56 0-.72-.45-1.72-1.45c-.88-.84-1.23-.95-1.47-.95c-.3 0-.39.08-.39.51v1.32c0 .36-.11.57-1.05.57c-1.56 0-3.28-.95-4.49-2.7C5.5 11.24 5 9.31 5 8.92c0-.22.08-.42.5-.42z" fill="currentColor"/>',
            hidden: true
        },
        "vk-circle": {
            body: '<path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M5.5 8.5H7c.36 0 .5.16.64.57c.72 2.1 1.93 3.93 2.43 3.93c.19 0 .28-.08.28-.55v-2.17c-.06-1-.59-1.09-.59-1.44c0-.17.14-.34.38-.34h2.31c.32 0 .42.17.42.54v2.92c0 .31.13.42.23.42c.19 0 .35-.11.69-.45c1.06-1.19 1.81-3.01 1.81-3.01c.1-.22.27-.42.64-.42h1.47c.45 0 .55.23.45.54c-.19.86-1.98 3.39-1.98 3.39c-.18.25-.22.37 0 .66c.15.21.67.65 1.01 1.06c.64.71 1.11 1.31 1.25 1.72c.12.42-.09.63-.51.63h-1.48c-.56 0-.72-.45-1.72-1.45c-.88-.84-1.23-.95-1.47-.95c-.3 0-.39.08-.39.51v1.32c0 .36-.11.57-1.05.57c-1.56 0-3.28-.95-4.49-2.7C5.5 11.24 5 9.31 5 8.92c0-.22.08-.42.5-.42z" fill="currentColor"/>',
            hidden: true
        },
        "vk-circle-custom": {
            body: '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.95 5.95 1 12 1C18.05 1 23 5.95 23 12C23 18.05 18.05 23 12 23C5.95 23 1 18.05 1 12ZM5.58333 8.33333C5.68167 13.5147 8.18934 16.5833 12.6146 16.5833H12.7621V13.6153C14.3847 13.8166 15.614 15.0239 16.1057 16.5833H18.4167C17.8266 14.2693 16.1549 12.9614 15.1223 12.4583C16.1549 11.8547 17.6299 10.3455 17.9741 8.33333H15.909C15.4665 9.99339 14.1389 11.4522 12.8605 11.6032V8.33333H10.7953V14.0178C9.51692 13.716 7.84515 12.1062 7.79598 8.33333H5.58333Z" fill="currentColor"/>'
        },
        vlc: {
            body: '<path fill="currentColor" d="M12 1c-.42 0-.81.23-1 .75L9.88 4.88c.48.52 1.4.62 2.12.62c.72 0 1.64-.1 2.13-.62L13 1.75c-.18-.5-.58-.75-1-.75M8.44 8.91l-1.44 4c1.07 1.36 3.26 1.59 5 1.59c1.74 0 3.93-.23 5-1.59l-1.44-4C14.76 9.83 13.24 10 12 10c-1.24 0-2.76-.17-3.56-1.09m-3 6.09c-.82 0-1.68.65-1.91 1.44l-1.47 5.12c-.22.79.24 1.44 1.07 1.44h17.75c.82 0 1.28-.65 1.06-1.44l-1.47-5.12c-.23-.79-1.09-1.44-1.91-1.44h-.81l.34.97c.12.32.2.72 0 1C16.84 18.7 14.14 19 12 19c-2.14 0-4.84-.3-6.09-2.03c-.2-.28-.12-.68 0-1l.34-.97h-.81Z"/>'
        },
        voicemail: {
            body: '<path fill="currentColor" d="M18.5 15a3.5 3.5 0 0 1-3.5-3.5A3.5 3.5 0 0 1 18.5 8a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m-13 0A3.5 3.5 0 0 1 2 11.5A3.5 3.5 0 0 1 5.5 8A3.5 3.5 0 0 1 9 11.5A3.5 3.5 0 0 1 5.5 15m13-9a5.5 5.5 0 0 0-5.5 5.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5A5.5 5.5 0 0 0 5.5 6A5.5 5.5 0 0 0 0 11.5A5.5 5.5 0 0 0 5.5 17h13a5.5 5.5 0 0 0 5.5-5.5A5.5 5.5 0 0 0 18.5 6Z"/>'
        },
        volcano: {
            body: '<path fill="currentColor" d="M18 8h-7l-2 5H6l-4 9h20L18 8m-5-7h2v4h-2V1m3.12 4.47l2.83-2.83l1.41 1.41l-2.82 2.83l-1.42-1.41M7.64 4.05l1.41-1.41l2.83 2.82l-1.41 1.42l-2.83-2.83Z"/>'
        },
        "volcano-outline": {
            body: '<path fill="currentColor" d="M18 8h-7l-2 5H6l-4 9h20L18 8M7.3 15h3.05l.5-1.26l1.5-3.74h4.15l2.85 10H5.08l2.22-5M13 1h2v4h-2V1m3.12 4.47l2.83-2.83l1.41 1.41l-2.82 2.83l-1.42-1.41M7.64 4.05l1.41-1.41l2.83 2.82l-1.41 1.42l-2.83-2.83Z"/>'
        },
        volleyball: {
            body: '<path fill="currentColor" d="M19.04 4.85C17.34 3.2 15.33 2.25 13 2v3.62l9 5.18c-.28-2.3-1.27-4.3-2.96-5.95M12 22c3.44 0 6.16-1.38 8.17-4.14L17.06 16l-8.99 5.2c1.25.53 2.57.8 3.93.8m1-10.59l8.15 4.66c.44-.94.73-1.93.85-2.96l-9-5.18v3.48m-9.12 6.4c.66.91 1.38 1.65 2.17 2.19l8.99-5.1L12 13.15l-8.12 4.66M11.04 2C10 2.09 9 2.36 8 2.8v10.35l3.04-1.74V2M2 12c0 1.39.3 2.77.89 4.12L6 14.28V4c-2.67 2-4 4.65-4 8Z"/>'
        },
        volume: {
            body: '<path d="M3 9h4l5-5v16l-5-5H3V9zm18 3a9.003 9.003 0 0 1-7 8.777V18.71a7.003 7.003 0 0 0 0-13.42V3.223c4.008.91 7 4.494 7 8.777zm-4 0a5.001 5.001 0 0 1-3 4.584V7.416c1.766.772 3 2.534 3 4.584z" fill="currentColor"/>',
            hidden: true
        },
        "volume-equal": {
            body: '<path fill="currentColor" d="M3 9h4l5-5v16l-5-5H3V9m11 4h8v2h-8m0-6h8v2h-8Z"/>'
        },
        "volume-high": {
            body: '<path fill="currentColor" d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.84-5 6.7v2.07c4-.91 7-4.49 7-8.77c0-4.28-3-7.86-7-8.77M16.5 12c0-1.77-1-3.29-2.5-4.03V16c1.5-.71 2.5-2.24 2.5-4M3 9v6h4l5 5V4L7 9H3Z"/>'
        },
        "volume-low": {
            body: '<path fill="currentColor" d="M7 9v6h4l5 5V4l-5 5H7Z"/>'
        },
        "volume-medium": {
            body: '<path fill="currentColor" d="M5 9v6h4l5 5V4L9 9m9.5 3c0-1.77-1-3.29-2.5-4.03V16c1.5-.71 2.5-2.24 2.5-4Z"/>'
        },
        "volume-minus": {
            body: '<path fill="currentColor" d="M3 9h4l5-5v16l-5-5H3V9m11 2h8v2h-8v-2Z"/>'
        },
        "volume-mute": {
            body: '<path fill="currentColor" d="M3 9h4l5-5v16l-5-5H3V9m13.59 3L14 9.41L15.41 8L18 10.59L20.59 8L22 9.41L19.41 12L22 14.59L20.59 16L18 13.41L15.41 16L14 14.59L16.59 12Z"/>'
        },
        "volume-off": {
            body: '<path fill="currentColor" d="M12 4L9.91 6.09L12 8.18M4.27 3L3 4.27L7.73 9H3v6h4l5 5v-6.73l4.25 4.26c-.67.51-1.42.93-2.25 1.17v2.07c1.38-.32 2.63-.95 3.68-1.81L19.73 21L21 19.73l-9-9M19 12c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.916 8.916 0 0 0 21 12c0-4.28-3-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71m-2.5 0c0-1.77-1-3.29-2.5-4.03v2.21l2.45 2.45c.05-.2.05-.42.05-.63Z"/>'
        },
        "volume-plus": {
            body: '<path fill="currentColor" d="M3 9h4l5-5v16l-5-5H3V9m11 2h3V8h2v3h3v2h-3v3h-2v-3h-3v-2Z"/>'
        },
        "volume-source": {
            body: '<path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3m13 6h-2V9h2v6m4 4h-2V5h2v14Z"/>'
        },
        "volume-variant-off": {
            body: '<path fill="currentColor" d="m5.64 3.64l15.72 15.72l-1.41 1.42L16 16.83V20l-5-5H7V9h1.17L4.22 5.05l1.42-1.41M16 4v7.17l-3.59-3.59L16 4Z"/>'
        },
        "volume-vibrate": {
            body: '<path fill="currentColor" d="M4 9v6h4l5 5V4L8 9H4m12.55-6.53L15.5 3.53L17.93 6L15 9l2.93 3L15 15l2.93 3l-2.43 2.47l1.05 1.06L20 18l-2.93-3L20 12l-2.93-3L20 6l-3.45-3.53Z"/>'
        },
        vote: {
            body: '<path fill="currentColor" d="M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4l-3-3m-1-5.05l-4.95 4.95L8.5 9.36l4.96-4.95L17 7.95m-4.24-5.66L6.39 8.66a.996.996 0 0 0 0 1.41L11.34 15c.39.41 1.02.41 1.41 0l6.36-6.34a.996.996 0 0 0 0-1.41L14.16 2.3a.975.975 0 0 0-1.4-.01Z"/>'
        },
        "vote-outline": {
            body: '<path fill="currentColor" d="m18 13l3 3v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4l3-3h.83l2 2H6.78L5 17h14l-1.77-2h-1.91l2-2H18m1 7v-1H5v1h14m-7.66-5l-4.95-4.93a.996.996 0 0 1 0-1.41l6.37-6.37a.975.975 0 0 1 1.4.01l4.95 4.95c.39.39.39 1.02 0 1.41L12.75 15a.962.962 0 0 1-1.41 0m2.12-10.59L8.5 9.36l3.55 3.54L17 7.95l-3.54-3.54Z"/>'
        },
        vpn: {
            body: '<path fill="currentColor" d="M9 5h6l-3 3l-3-3m1.5 9.66c-.3.34-.5.84-.5 1.34a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.55-.22-1.05-.59-1.41l1.42-1.42C15.55 13.9 16 14.9 16 16a4 4 0 0 1-4 4a4 4 0 0 1-4-4c0-1.07.42-2.04 1.1-2.75l-.01-.01l7.08-7.07A3.99 3.99 0 0 1 19 5a4 4 0 0 1 4 4a4 4 0 0 1-4 4c-1.1 0-2.1-.45-2.83-1.17l1.42-1.42c.36.37.86.59 1.41.59a2 2 0 0 0 2-2a2 2 0 0 0-2-2c-.55 0-1.05.22-1.41.59l-7.09 7.07M6.41 7.59C6.05 7.22 5.55 7 5 7a2 2 0 0 0-2 2a2 2 0 0 0 2 2c.55 0 1.05-.22 1.41-.59l1.42 1.42C7.1 12.55 6.1 13 5 13a4 4 0 0 1-4-4a4 4 0 0 1 4-4c1.11 0 2.11.45 2.83 1.17l2.76 2.76l-1.42 1.42l-2.76-2.76Z"/>'
        },
        vuejs: {
            body: '<path fill="currentColor" d="M2 3h3.5L12 15l6.5-12H22L12 21L2 3m4.5 0h3L12 7.58L14.5 3h3L12 13.08L6.5 3Z"/>'
        },
        vuetify: {
            body: '<path fill="currentColor" d="M12 11.64L7.92 2h8.16L12 11.64m0 10.31L3.27 4.91h4.57L12 14.47l4.16-9.56h4.57L12 21.95Z"/>'
        },
        walk: {
            body: '<path fill="currentColor" d="M14.12 10H19V8.2h-3.62l-2-3.33c-.3-.5-.84-.84-1.46-.84c-.18 0-.34.03-.5.08L6 5.8V11h1.8V7.33l2.11-.66L6 22h1.8l2.87-8.11L13 17v5h1.8v-6.41l-2.49-4.54l.73-2.87M14 3.8c1 0 1.8-.8 1.8-1.8S15 .2 14 .2S12.2 1 12.2 2S13 3.8 14 3.8Z"/>'
        },
        wall: {
            body: '<path fill="currentColor" d="M3 16h9v5H3v-5m-1-6h6v5H2v-5m7 0h6v5H9v-5m7 0h6v5h-6v-5m-3 6h8v5h-8v-5M3 4h8v5H3V4m9 0h9v5h-9V4Z"/>'
        },
        "wall-fire": {
            body: '<path fill="currentColor" d="m22.14 15.34l-.02.01c.23.28.43.59.58.92l.09.19c.71 1.69.21 3.64-1.1 4.86c-1.19 1.09-2.85 1.38-4.39 1.18c-1.46-.18-2.8-1.1-3.57-2.37c-.23-.39-.43-.83-.53-1.28c-.13-.35-.17-.73-.2-1.1c-.09-1.6.55-3.3 1.76-4.3c-.55 1.21-.42 2.72.39 3.77l.11.13c.14.12.31.15.47.09c.15-.06.27-.21.27-.37l-.07-.24c-.88-2.33-.14-5.03 1.73-6.56c.51-.42 1.14-.8 1.8-.97c-.68 1.36-.46 3.14.63 4.2c.46.5 1.02.79 1.49 1.23l.56.61M19.86 20l-.01-.03c.45-.39.7-1.06.68-1.66L20.5 18c-.2-1-1.07-1.34-1.63-2.07l-.43-.78c-.22.5-.24.97-.15 1.51c.1.57.32 1.06.21 1.65c-.16.65-.67 1.3-1.56 1.51c.5.49 1.31.88 2.12.6c.26-.07.59-.26.8-.42M3 16h8.06L11 17c0 1.41.36 2.73 1 3.88V21H3v-5m-1-6h6v5H2v-5m7 0h6v.07A8.032 8.032 0 0 0 11.25 15H9v-5M3 4h8v5H3V4m9 0h9v5h-9V4Z"/>'
        },
        "wall-sconce": {
            body: '<path fill="currentColor" d="m11 4l-4 9h12l-4-9h-4M4 14v8h2v-3h8v-5h-2v3H6v-3H4Z"/>'
        },
        "wall-sconce-flat": {
            body: '<path fill="currentColor" d="M5 5v6h14V5H5m.27 8.32L3.5 15.09l1.41 1.41l1.77-1.77l-1.41-1.41m13.46 0l-1.41 1.41l1.77 1.77l1.41-1.41l-1.77-1.77M11 16v3h2v-3h-2Z"/>'
        },
        "wall-sconce-flat-outline": {
            body: '<path fill="currentColor" d="M5 5v6h14V5H5m12 4H7V7h10v2M5.27 13.32L3.5 15.09l1.41 1.41l1.77-1.77l-1.41-1.41m13.46 0l-1.41 1.41l1.77 1.77l1.41-1.41l-1.77-1.77M11 16v3h2v-3h-2Z"/>'
        },
        "wall-sconce-flat-variant": {
            body: '<path fill="currentColor" d="M19 19v-6H5v6h14m-.27-8.32l1.77-1.77l-1.41-1.41l-1.77 1.77l1.41 1.41m-13.46 0l1.41-1.41L4.91 7.5L3.5 8.91l1.77 1.77M13 8V5h-2v3h2Z"/>'
        },
        "wall-sconce-flat-variant-outline": {
            body: '<path fill="currentColor" d="M5 13v6h14v-6H5m12 4H7v-2h10v2m1.73-6.32l1.77-1.77l-1.41-1.41l-1.77 1.77l1.41 1.41m-13.46 0l1.41-1.41L4.91 7.5L3.5 8.91l1.77 1.77M13 8V5h-2v3h2Z"/>'
        },
        "wall-sconce-outline": {
            body: '<path fill="currentColor" d="m13.7 6l2.22 5h-5.84l2.22-5h1.4M15 4h-4l-4 9h12l-4-9M4 14v8h2v-3h8v-5h-2v3H6v-3H4Z"/>'
        },
        "wall-sconce-round": {
            body: '<path fill="currentColor" d="M13 19v-3h-2v3h2m6.09-2.5l1.41-1.41l-1.77-1.77l-1.41 1.41l1.77 1.77m-14.18 0l1.77-1.77l-1.41-1.41l-1.77 1.77l1.41 1.41M20 12c0-2.86-1.5-5.5-4-6.93s-5.5-1.43-8 0S4 9.14 4 12h16Z"/>'
        },
        "wall-sconce-round-outline": {
            body: '<path fill="currentColor" d="M13 19v-3h-2v3h2m6.09-2.5l1.41-1.41l-1.77-1.77l-1.41 1.41l1.77 1.77m-14.18 0l1.77-1.77l-1.41-1.41l-1.77 1.77l1.41 1.41M12 6c1.04 0 2.08.28 3 .81c1.26.69 2.19 1.86 2.66 3.19H6.34C6.81 8.67 7.74 7.5 9 6.81A6.03 6.03 0 0 1 12 6m0-2c-1.37 0-2.75.36-4 1.07C5.5 6.5 4 9.14 4 12h16c0-2.86-1.5-5.5-4-6.93A8.077 8.077 0 0 0 12 4Z"/>'
        },
        "wall-sconce-round-variant": {
            body: '<path fill="currentColor" d="M11 5v3h2V5h-2M4.91 7.5L3.5 8.91l1.77 1.77l1.41-1.41L4.91 7.5m14.18 0l-1.77 1.77l1.41 1.41l1.77-1.77l-1.41-1.41M4 12c0 2.86 1.5 5.5 4 6.93s5.5 1.43 8 0s4-4.07 4-6.93H4Z"/>'
        },
        "wall-sconce-round-variant-outline": {
            body: '<path fill="currentColor" d="M11 5v3h2V5h-2M4.91 7.5L3.5 8.91l1.77 1.77l1.41-1.41L4.91 7.5m14.18 0l-1.77 1.77l1.41 1.41l1.77-1.77l-1.41-1.41M17.66 14c-.47 1.33-1.4 2.5-2.66 3.19c-.92.53-1.96.81-3 .81s-2.08-.28-3-.81C7.74 16.5 6.81 15.33 6.34 14h11.32M20 12H4c0 2.86 1.5 5.5 4 6.93A8 8 0 0 0 12 20a8 8 0 0 0 4-1.07c2.5-1.43 4-4.07 4-6.93Z"/>'
        },
        "wall-sconce-variant": {
            body: '<path d="M11 4.5v3h2v-3h-2M4.91 7L3.5 8.41l1.77 1.77l1.41-1.41L4.91 7m14.18 0l-1.77 1.77l1.41 1.41l1.77-1.77L19.09 7M4 11.5c0 2.86 1.5 5.5 4 6.93c2.5 1.43 5.5 1.43 8 0s4-4.07 4-6.93H4z" fill="currentColor"/>',
            hidden: true
        },
        wallet: {
            body: '<path fill="currentColor" d="M21 18v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1h-9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2m0-2h10V8H12m4 5.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5Z"/>'
        },
        "wallet-giftcard": {
            body: '<path fill="currentColor" d="M20 14H4V8h5.08L7 10.83L8.62 12L11 8.76l1-1.36l1 1.36L15.38 12L17 10.83L14.92 8H20m0 11H4v-2h16M9 4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m5 2h-2.18c.11-.31.18-.65.18-1a3 3 0 0 0-3-3c-1.05 0-1.96.54-2.5 1.35L12 4l-.5-.66C10.96 2.54 10.05 2 9 2a3 3 0 0 0-3 3c0 .35.07.69.18 1H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2Z"/>'
        },
        "wallet-membership": {
            body: '<path fill="currentColor" d="M20 10H4V4h16m0 11H4v-2h16m0-11H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2l4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2Z"/>'
        },
        "wallet-outline": {
            body: '<path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72V5a2 2 0 0 0-2-2H5m0 2h14v2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6v2H5V5m8 4h7v6h-7V9m3 1.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "wallet-plus": {
            body: '<path fill="currentColor" d="M3 0v3H0v2h3v3h2V5h3V3H5V0H3m6 3v3H6v3H3v10a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h-9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h9V5a2 2 0 0 0-2-2H9m3 5v8h10V8H12m4 2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z"/>'
        },
        "wallet-plus-outline": {
            body: '<path fill="currentColor" d="M3 0v3H0v2h3v3h2V5h3V3H5V0H3m7 3v2h9v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5v-9H3v9a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72V5c0-1.1-.9-2-2-2h-9m3 6h7v6h-7V9m3 1.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        "wallet-travel": {
            body: '<path fill="currentColor" d="M20 14H4V8h3v2h2V8h6v2h2V8h3m0 11H4v-2h16M9 4h6v2H9m11 0h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2Z"/>'
        },
        wallpaper: {
            body: '<path fill="currentColor" d="M4 4h7V2H4a2 2 0 0 0-2 2v7h2V4m6 9l-4 5h12l-3-4l-2.03 2.71L10 13m7-4.5A1.5 1.5 0 0 0 15.5 7A1.5 1.5 0 0 0 14 8.5a1.5 1.5 0 0 0 1.5 1.5A1.5 1.5 0 0 0 17 8.5M20 2h-7v2h7v7h2V4a2 2 0 0 0-2-2m0 18h-7v2h7a2 2 0 0 0 2-2v-7h-2v7M4 13H2v7a2 2 0 0 0 2 2h7v-2H4v-7Z"/>'
        },
        wan: {
            body: '<path fill="currentColor" d="M12 2a8 8 0 0 0-8 8c0 4.03 3 7.42 7 7.93V19h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7a1 1 0 0 0-1-1h-1v-1.07c4-.5 7-3.9 7-7.93a8 8 0 0 0-8-8m0 2s.74 1.28 1.26 3h-2.52C11.26 5.28 12 4 12 4m-2.23.43c-.27.5-.68 1.41-1.03 2.57H6.81C7.5 5.84 8.5 4.93 9.77 4.43m4.46.01c1.27.5 2.27 1.4 2.96 2.56h-1.93c-.35-1.16-.76-2.07-1.03-2.56M6.09 9h2.23c-.04.33-.07.66-.07 1c0 .34.03.67.07 1H6.09a5.551 5.551 0 0 1 0-2m4.23 0h3.36c.04.33.07.66.07 1c0 .34-.03.67-.07 1h-3.36c-.04-.33-.07-.66-.07-1c0-.34.03-.67.07-1m5.36 0h2.23a5.551 5.551 0 0 1 0 2h-2.23c.04-.33.07-.66.07-1c0-.34-.03-.67-.07-1m-8.87 4h1.93c.35 1.16.76 2.07 1.03 2.56c-1.27-.5-2.27-1.4-2.96-2.56m3.93 0h2.52c-.52 1.72-1.26 3-1.26 3s-.74-1.28-1.26-3m4.52 0h1.93c-.69 1.16-1.69 2.07-2.96 2.57c.27-.5.68-1.41 1.03-2.57Z"/>'
        },
        wardrobe: {
            body: '<path fill="currentColor" d="M4 4v15c0 1.1.9 2 2 2v1h2v-1h3.5V2H6c-1.1 0-2 .9-2 2m4 6h2v3H8v-3m10-8h-5.5v19H16v1h2v-1c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-2 11h-2v-3h2v3Z"/>'
        },
        "wardrobe-outline": {
            body: '<path fill="currentColor" d="M6 2a2 2 0 0 0-2 2v15c0 1.11.89 2 2 2v1h2v-1h8v1h2v-1c1.11 0 2-.89 2-2V4a2 2 0 0 0-2-2H6m0 2h5v15H6V4m7 0h5v15h-5V4m-5 6v3h2v-3H8m6 0v3h2v-3h-2Z"/>'
        },
        warehouse: {
            body: '<path fill="currentColor" d="M6 19h2v2H6v-2m6-16L2 8v13h2v-8h16v8h2V8L12 3m-4 8H4V9h4v2m6 0h-4V9h4v2m6 0h-4V9h4v2M6 15h2v2H6v-2m4 0h2v2h-2v-2m0 4h2v2h-2v-2m4 0h2v2h-2v-2Z"/>'
        },
        "washing-machine": {
            body: '<path fill="currentColor" d="M14.83 11.17a4.008 4.008 0 0 1 0 5.66a4.008 4.008 0 0 1-5.66 0l5.66-5.66M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m1 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m3 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m2 4a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6Z"/>'
        },
        "washing-machine-alert": {
            body: '<path fill="currentColor" d="M12.83 11.17c1.56 1.56 1.56 4.1 0 5.66s-4.1 1.56-5.66 0l5.66-5.66M4 2h12a2 2 0 0 1 2 2v16c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2m1 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m3 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1m2 4c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6m10 7h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "washing-machine-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20c0 1.11.89 2 2 2h12c.58 0 1.1-.25 1.46-.65l1.38 1.38l1.27-1.27M12 20c-3.31 0-6-2.69-6-6c0-1.68.7-3.2 1.82-4.29l4.24 4.24l-2.89 2.88a4.008 4.008 0 0 0 5.66 0c.02-.02.03-.04.05-.06l1.41 1.41A5.956 5.956 0 0 1 12 20m-.75-11.95C11.5 8 11.75 8 12 8c3.31 0 6 2.69 6 6c0 .25 0 .5-.05.75L20 16.8V4a2 2 0 0 0-2-2H6c-.24 0-.46.05-.67.13l5.92 5.92M10 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1Z"/>'
        },
        watch: {
            body: '<path fill="currentColor" d="M6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6a6 6 0 0 1-6 6a6 6 0 0 1-6-6m14 0a7.94 7.94 0 0 0-3.05-6.27L16 0H8l-.95 5.73A7.94 7.94 0 0 0 4 12c0 2.54 1.19 4.81 3.05 6.27L8 24h8l.95-5.73A7.955 7.955 0 0 0 20 12Z"/>'
        },
        "watch-export": {
            body: '<path fill="currentColor" d="M14 11h5l-2.5-2.5l1.42-1.42L22.84 12l-4.92 4.92l-1.42-1.42L19 13h-5v-2m-2 7a6 6 0 0 1-6-6a6 6 0 0 1 6-6c1.4 0 2.69.5 3.71 1.29l1.42-1.42l-.18-.14L16 0H8l-.95 5.73A7.955 7.955 0 0 0 4 12a7.94 7.94 0 0 0 3.05 6.27L8 24h8l.95-5.73l.18-.14l-1.42-1.42A6.066 6.066 0 0 1 12 18Z"/>'
        },
        "watch-export-variant": {
            body: '<path fill="currentColor" d="M14 11h5l-2.5-2.5l1.42-1.42L22.84 12l-4.92 4.92l-1.42-1.42L19 13h-5v-2M8 0h8l.83 5H17c.28 0 .54.06.78.16L15.94 7H7v10h8.94l1.84 1.84c-.24.1-.5.16-.78.16h-.17L16 24H8l-.83-5H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h.17L8 0Z"/>'
        },
        "watch-import": {
            body: '<path fill="currentColor" d="M2 11h5L4.5 8.5l1.42-1.42L10.84 12l-4.92 4.92L4.5 15.5L7 13H2v-2m10 7a6 6 0 0 0 6-6a6 6 0 0 0-6-6c-1.4 0-2.69.5-3.71 1.29L6.87 5.87l.18-.14L8 0h8l.95 5.73A7.94 7.94 0 0 1 20 12c0 2.54-1.19 4.81-3.05 6.27L16 24H8l-.95-5.73l-.18-.14l1.42-1.42C9.31 17.5 10.6 18 12 18Z"/>'
        },
        "watch-import-variant": {
            body: '<path fill="currentColor" d="M1 11h5L3.5 8.5l1.42-1.42L9.84 12l-4.92 4.92L3.5 15.5L6 13H1v-2M8 0h8l.83 5H17a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-.17L16 24H8l-.83-5H7c-.54 0-1-.21-1.38-.56L7.06 17H17V7H7.06L5.62 5.56C6 5.21 6.46 5 7 5h.17L8 0Z"/>'
        },
        "watch-variant": {
            body: '<path fill="currentColor" d="m8 0l-.83 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h.17L8 24h8l.83-5H17a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-.17L16 0H8M7 7h10v10H7V7Z"/>'
        },
        "watch-vibrate": {
            body: '<path fill="currentColor" d="M3 17V7h2v10H3m16 0V7h2v10h-2m3-8h2v6h-2V9M0 15V9h2v6H0m17.96-3.03c0 1.9-.89 3.6-2.28 4.7l-.71 4.28H9l-.73-4.28A5.976 5.976 0 0 1 6 11.97c0-1.9.88-3.6 2.27-4.69L9 3h5.97l.71 4.28a5.95 5.95 0 0 1 2.28 4.69m-10.46 0c0 2.48 2 4.49 4.47 4.49a4.5 4.5 0 0 0 4.49-4.49c0-2.47-2.01-4.47-4.49-4.47a4.47 4.47 0 0 0-4.47 4.47Z"/>'
        },
        "watch-vibrate-off": {
            body: '<path fill="currentColor" d="M0 9h2v6H0V9m12-1.5c2.47 0 4.47 2.03 4.46 4.5c-.01.38-.06.76-.16 1.13l1.2 1.18c.31-.73.5-1.51.5-2.31c0-1.83-.84-3.56-2.28-4.69L15 3H9l-.41 2.39l2.27 2.27c.37-.11.75-.16 1.14-.16m9 9.5V7h-2v8.8l1.2 1.2h.8m-4.5-1.14l5.61 5.6l-1.27 1.27l-5.29-5.29L15 21H9l-.73-4.28c-2.42-1.9-3-5.32-1.36-7.92L1.11 3l1.28-1.27l5.7 5.71L9.17 8.5l6.27 6.29l1.06 1.07m-2.45.08l-6-6c-.35.63-.55 1.34-.55 2.06c0 2.47 2.03 4.47 4.5 4.46c.72 0 1.42-.18 2.05-.52M22 9v6h2V9h-2M3 17h2V7H3v10Z"/>'
        },
        water: {
            body: '<path fill="currentColor" d="M12 20a6 6 0 0 1-6-6c0-4 6-10.75 6-10.75S18 10 18 14a6 6 0 0 1-6 6Z"/>'
        },
        "water-alert": {
            body: '<path fill="currentColor" d="M10 3.25S16 10 16 14c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-4 6-10.75 6-10.75M20 7v6h-2V7h2m-2 10h2v-2h-2v2Z"/>'
        },
        "water-alert-outline": {
            body: '<path fill="currentColor" d="M10 3.25S4 10 4 14c0 3.31 2.69 6 6 6s6-2.69 6-6c0-4-6-10.75-6-10.75M10 18c-2.21 0-4-1.79-4-4c0-1.77 2-5.04 4-7.61c2 2.56 4 5.84 4 7.61c0 2.21-1.79 4-4 4M20 7v6h-2V7h2m-2 10h2v-2h-2v2Z"/>'
        },
        "water-boiler": {
            body: '<path fill="currentColor" d="M8 2c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h1v2H6v2h3c1.11 0 2-.89 2-2v-2h2v2c0 1.11.89 2 2 2h3v-2h-3v-2h1c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2H8m4 2.97a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-2 9.53h4V16h-4v-1.5Z"/>'
        },
        "water-boiler-alert": {
            body: '<path fill="currentColor" d="M6 2c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h1v2H4v2h3c1.11 0 2-.89 2-2v-2h2v2c0 1.11.89 2 2 2h3v-2h-3v-2h1c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2H6m4 2.97a2 2 0 1 1 .001 3.999A2 2 0 0 1 10 4.97M8 14.5h4V16H8v-1.5m10 .5h2v2h-2v-2m0-8h2v6h-2V7Z"/>'
        },
        "water-boiler-auto": {
            body: '<path fill="currentColor" d="M4 2c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h1v2H2v2h3c1.11 0 2-.89 2-2v-2h2v2c0 1.11.89 2 2 2h2l.75-2H11v-2h1c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2H4m4 2.97a2 2 0 1 1 .001 3.999A2 2 0 0 1 8 4.97M6 14.5h4V16H6v-1.5M19.8 13h-2l-3.2 9h1.9l.7-2h3.2l.7 2H23l-3.2-9m-2.2 5.7l1.2-3.7l1.2 3.7h-2.4Z"/>'
        },
        "water-boiler-off": {
            body: '<path fill="currentColor" d="M10 6.82L6.25 3.05C6.59 2.42 7.24 2 8 2h8c1.11 0 2 .89 2 2v10.8l-5.84-5.84C13.19 8.87 14 8 14 6.97a2 2 0 0 0-2-2c-1.05 0-1.9.81-2 1.85M15 18v2h3v2h-3c-1.11 0-2-.89-2-2v-2h-2v2c0 1.11-.89 2-2 2H6v-2h3v-2H8c-1.11 0-2-.89-2-2V7.89L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27L16.1 18H15m-1-2v-.11l-1.39-1.39H10V16h4Z"/>'
        },
        "water-check": {
            body: '<path fill="currentColor" d="M21.75 16.25L17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41M17.62 12C16.31 8.1 12 3.25 12 3.25S6 10 6 14c0 3.31 2.69 6 6 6h.34c-.22-.64-.34-1.3-.34-2c0-3.18 2.5-5.78 5.62-6Z"/>'
        },
        "water-check-outline": {
            body: '<path fill="currentColor" d="M21.75 16.25L17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41M8 14c0-1.77 2-5.04 4-7.61c1.5 1.94 3 4.28 3.67 6.08c.6-.26 1.26-.41 1.95-.47C16.31 8.1 12 3.25 12 3.25S6 10 6 14c0 3.31 2.69 6 6 6h.34c-.22-.64-.34-1.3-.34-2c-2.21 0-4-1.79-4-4Z"/>'
        },
        "water-circle": {
            body: '<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 17c-2.76 0-5-2.24-5-5c0-3.33 5-8.96 5-8.96s5 5.63 5 8.96c0 2.76-2.24 5-5 5Z"/>'
        },
        "water-minus": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8m-4.38-5C16.31 8.1 12 3.25 12 3.25S6 10 6 14c0 3.31 2.69 6 6 6h.34c-.22-.64-.34-1.3-.34-2c0-3.18 2.5-5.78 5.62-6Z"/>'
        },
        "water-minus-outline": {
            body: '<path fill="currentColor" d="M22 17v2h-8v-2h8M8 14c0-1.77 2-5.04 4-7.61c1.5 1.94 3 4.28 3.67 6.08c.6-.26 1.26-.41 1.95-.47C16.31 8.1 12 3.25 12 3.25S6 10 6 14c0 3.31 2.69 6 6 6h.34c-.22-.64-.34-1.3-.34-2c-2.21 0-4-1.79-4-4Z"/>'
        },
        "water-off": {
            body: '<path fill="currentColor" d="m20.84 22.73l-4.55-4.55A5.956 5.956 0 0 1 12 20c-3.31 0-6-2.69-6-6c0-1.33.67-2.97 1.55-4.56L1.11 3l1.28-1.27l19.72 19.73l-1.27 1.27M18 14c0-4-6-10.75-6-10.75s-1.16 1.3-2.45 3.1l8.4 8.4c.05-.25.05-.5.05-.75Z"/>'
        },
        "water-off-outline": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l6.54 6.54C6.74 11.03 6 12.65 6 14.23c0 3.31 2.69 6 6 6a5.9 5.9 0 0 0 4.4-1.94l4.44 4.44l1.27-1.27M12 18.23c-2.22 0-4-1.78-4-4c0-.73.5-1.96 1.14-3.2L15 16.88c-.74.83-1.8 1.35-3 1.35m-.86-10.29L9.71 6.5c.86-1.12 1.54-1.89 1.54-1.89l.75-.84l.75.84s1.28 1.45 2.57 3.33S18 12.07 18 14.23c0 .18 0 .36-.03.54l-2.51-2.51c-.46-1.03-1.09-2.19-1.78-3.19c-.84-1.22-1.24-1.65-1.68-2.17c-.27.31-.5.6-.86 1.04Z"/>'
        },
        "water-opacity": {
            body: '<path fill="currentColor" d="M16 14v-2h1.61c.24.71.39 1.39.39 2h-2m-.42-6c-.46-.71-.93-1.39-1.38-2H14v2h1.58m.42 4v-2h-2v2h2m0-3.32V10h.74c-.24-.44-.48-.89-.74-1.32M12 16v-2h2v-2h-2v-2h2V8h-2V6h2v-.27c-1.1-1.47-2-2.48-2-2.48S6 10 6 14c0 3.31 2.69 6 6 6v-2h2v-2h-2m2 3.65c.75-.26 1.42-.65 2-1.19V18h-2v1.65M14 16h2v-2h-2v2m2 2h.46c.54-.58.93-1.25 1.19-2H16v2Z"/>'
        },
        "water-outline": {
            body: '<path fill="currentColor" d="m12 3.77l-.75.84S9.97 6.06 8.68 7.94C7.39 9.82 6 12.07 6 14.23a6 6 0 0 0 6 6a6 6 0 0 0 6-6c0-2.16-1.39-4.41-2.68-6.29a38.7 38.7 0 0 0-2.57-3.33L12 3.77m0 3.13c.44.52.84.95 1.68 2.17c1.21 1.76 2.32 4 2.32 5.16c0 2.22-1.78 4-4 4c-2.22 0-4-1.78-4-4c0-1.16 1.11-3.4 2.32-5.16c.84-1.22 1.24-1.65 1.68-2.17Z"/>'
        },
        "water-percent": {
            body: '<path fill="currentColor" d="M12 3.25S6 10 6 14c0 3.32 2.69 6 6 6a6 6 0 0 0 6-6c0-4-6-10.75-6-10.75m2.47 6.72l1.06 1.06l-6 6l-1.06-1.06M9.75 10A1.25 1.25 0 0 1 11 11.25a1.25 1.25 0 0 1-1.25 1.25a1.25 1.25 0 0 1-1.25-1.25A1.25 1.25 0 0 1 9.75 10m4.5 4.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 14.25 17A1.25 1.25 0 0 1 13 15.75a1.25 1.25 0 0 1 1.25-1.25Z"/>'
        },
        "water-percent-alert": {
            body: '<path fill="currentColor" d="M20 7v6h-2V7h2m-2 10h2v-2h-2v2M10 3.25S4 10 4 14c0 3.32 2.69 6 6 6s6-2.69 6-6c0-4-6-10.75-6-10.75M7.75 10a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5m4.5 7a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m-4.72.03l-1.06-1.06l6-6l1.06 1.06l-6 6Z"/>'
        },
        "water-plus": {
            body: '<path fill="currentColor" d="M12 18c0 .7.12 1.36.34 2H12c-3.31 0-6-2.69-6-6c0-4 6-10.75 6-10.75S16.31 8.1 17.62 12c-3.12.22-5.62 2.82-5.62 6m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "water-plus-outline": {
            body: '<path fill="currentColor" d="M12 18c0 .7.12 1.36.34 2H12c-3.31 0-6-2.69-6-6c0-4 6-10.75 6-10.75S16.31 8.1 17.62 12c-.69.06-1.34.22-1.95.47C15 10.68 13.5 8.33 12 6.39C10 8.96 8 12.23 8 14c0 2.21 1.79 4 4 4m7-1v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "water-polo": {
            body: '<path fill="currentColor" d="M20 16h2v2h-2c-1.4 0-2.8-.4-4-1c-2.5 1.3-5.5 1.3-8 0c-1.2.6-2.6 1-4 1H2v-2h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0c1.2.8 2.6 1.3 4 1.3m-7-5.4c.6-.3 1.3-.6 2-.7v.3c.3 1 .3 1.9.2 2.9c-.9.5-2 .8-3 .8c.5-1 .8-2.2.8-3.3m-.1-7c-1.4.4-2.6 1.1-3.6 2.1c-.4-1-.6-2-.6-3c2.2-1 4.7-.9 6.9.2c.3.1.6.2.8.4c-1.2-.1-2.4 0-3.5.3m-6.1 9.7c-.6.3-1.2.5-1.8.6c-.7-1.3-1-2.7-1-4.1c.5 1 1.2 2 2 2.8c.3.2.5.5.8.7m12.2.6c-.6-.1-1.2-.3-1.7-.5c.2-1.2.1-2.4-.2-3.6c1.1.1 2.1.4 3 1c-.1 1-.4 1.9-.9 2.8l-.2.3M7.4 11.2c-1.2-1.1-1.9-2.7-2.2-4.3L5.1 6c.5-.8 1-1.4 1.7-2c.1 1.4.6 2.7 1.4 3.8c.7 1.1 1.7 2.1 2.8 2.7c0 .8-.2 1.6-.5 2.4c-1.2-.3-2.2-.9-3.1-1.7m6.1-5.7c1.5-.4 3.2-.3 4.7.2l.8.4c.4.7.6 1.5.8 2.3c-2.5-1.1-5.4-.9-7.8.4c-.7-.3-1.2-.8-1.7-1.4l.1-.1c.9-.8 1.9-1.5 3.1-1.8M16 18.7c1.2.8 2.6 1.3 4 1.3h2v2h-2c-1.4 0-2.8-.4-4-1c-2.5 1.3-5.5 1.3-8 0c-1.2.6-2.6 1-4 1H2v-2h2c1.4 0 2.8-.5 4-1.3c2.4 1.7 5.6 1.7 8 0Z"/>'
        },
        "water-pump": {
            body: '<path fill="currentColor" d="M19 14.5s2 2.17 2 3.5a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.33 2-3.5 2-3.5M5 18V9a2 2 0 0 1-2-2a2 2 0 0 1 2-2V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h8a2 2 0 0 1 2 2v4a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1a1 1 0 0 1 1-1V9h-6v9h1a2 2 0 0 1 2 2v2H2v-2a2 2 0 0 1 2-2h1Z"/>'
        },
        "water-pump-off": {
            body: '<path fill="currentColor" d="M5.7 2.5A2 2 0 0 1 7 2h2a2 2 0 0 1 2 2v1h8a2 2 0 0 1 2 2v4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2V9h-4.8m8.64 13.73l1.27-1.27L11 10.34L2.39 1.73L1.11 3l2.54 2.54A2 2 0 0 0 5 9v9H4a2 2 0 0 0-2 2v2h12v-2a2 2 0 0 0-2-2h-1v-5.11Z"/>'
        },
        "water-remove": {
            body: '<path fill="currentColor" d="M12 18c0 .7.12 1.36.34 2H12c-3.31 0-6-2.69-6-6c0-4 6-10.75 6-10.75S16.31 8.1 17.62 12c-3.12.22-5.62 2.82-5.62 6m9.54-2.12l-1.41-1.41L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.41L18 19.41l2.12 2.12l1.41-1.41L19.41 18l2.13-2.12Z"/>'
        },
        "water-remove-outline": {
            body: '<path fill="currentColor" d="M12 18c0 .7.12 1.36.34 2H12c-3.31 0-6-2.69-6-6c0-4 6-10.75 6-10.75S16.31 8.1 17.62 12c-.69.06-1.34.22-1.95.47C15 10.68 13.5 8.33 12 6.39C10 8.96 8 12.23 8 14c0 2.21 1.79 4 4 4m9.54-2.12l-1.41-1.41L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.41L18 19.41l2.12 2.12l1.41-1.41L19.41 18l2.13-2.12Z"/>'
        },
        "water-sync": {
            body: '<path fill="currentColor" d="M12 3.2S6 10 6 14c0 3.3 2.7 6 6 6s6-2.7 6-6c0-4-6-10.8-6-10.8m0 5.3V10c2.2 0 4 1.8 4 4c0 .8-.2 1.6-.7 2.2l-1.1-1.1c.2-.3.3-.7.3-1.1c0-1.4-1.1-2.5-2.5-2.5V13l-2.2-2.2L12 8.5m-3.3 3.3l1.1 1.1c-.2.3-.3.7-.3 1.1c0 1.4 1.1 2.5 2.5 2.5V15l2.2 2.2l-2.2 2.3V18c-2.2 0-4-1.8-4-4c0-.8.2-1.6.7-2.2Z"/>'
        },
        "water-thermometer": {
            body: '<path fill="currentColor" d="M19 5c-1.11 0-2 .89-2 2v6.76c-.64.57-1 1.39-1 2.24c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.85-.36-1.67-1-2.23V7c0-1.11-.89-2-2-2m0 1c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1M8 20c-3.31 0-6-2.69-6-6C2 10 8 3.25 8 3.25S14 10 14 14c0 3.31-2.69 6-6 6Z"/>'
        },
        "water-thermometer-outline": {
            body: '<path fill="currentColor" d="M19 5c-1.11 0-2 .89-2 2v6.76c-.64.57-1 1.39-1 2.24c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.85-.36-1.67-1-2.23V7c0-1.11-.89-2-2-2m0 1c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1M8 3.54l-.75.84S5.97 5.83 4.68 7.71S2 11.84 2 14c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.16-1.39-4.41-2.68-6.29S8.75 4.38 8.75 4.38L8 3.54m0 3.13c.44.52.84.95 1.68 2.17C10.89 10.6 12 12.84 12 14c0 2.22-1.78 4-4 4s-4-1.78-4-4c0-1.16 1.11-3.4 2.32-5.16C7.16 7.62 7.56 7.19 8 6.67Z"/>'
        },
        "water-well": {
            body: '<path fill="currentColor" d="M22 16H2v2h2v4h16v-4h2v-2m-11.56-1c-.25 0-.44-.19-.49-.44l-.38-3v-.06c0-.28.22-.5.5-.5H14c.27.04.46.29.43.56l-.38 3c-.05.25-.24.44-.49.44h-3.12M19 2l2.56 4.68c.04.1.05.21.05.32c0 .56-.45 1-1 1H19v7h-2V8h-4v2h-2V8H7v7H5V8H3.62a.998.998 0 0 1-.9-1.45L5 2h14Z"/>'
        },
        "water-well-outline": {
            body: '<path fill="currentColor" d="M3.62 8H5v7h2V8h4v2h2V8h4v7h2V8h1.61c.55 0 1-.44 1-1a.86.86 0 0 0-.05-.32L19 2H5L2.72 6.55A.998.998 0 0 0 3.62 8m2.62-4h11.52l1 2H5.24l1-2M2 16v2h2v4h16v-4h2v-2H2m16 4H6v-2h12v2m-4.07-9c.28 0 .5.22.5.5v.06l-.38 3c-.05.25-.24.44-.49.44h-3.12c-.25 0-.44-.19-.49-.44l-.38-3A.51.51 0 0 1 10 11h3.93Z"/>'
        },
        waterfall: {
            body: '<path fill="currentColor" d="M20 20c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 19.53 5.39 20 4 20H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2m-2-4c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 15.53 5.39 16 4 16H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2m0-14H2v2h4v12h12V4h4M9 4h2v6H9m4-2h2v6h-2Z"/>'
        },
        "watering-can": {
            body: '<path fill="currentColor" d="M18.5 7.47c-.74.73-.93 1.78-.58 2.68L15 13.07V11c0-.55-.45-1-1-1h-1.03c.03-.17.03-.33.03-.5C13 6.46 10.54 4 7.5 4A5.497 5.497 0 0 0 4 13.74V20c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-4.11l4.33-4.33c.9.35 1.95.17 2.67-.56l-3.5-3.53M4.05 10C4.03 9.83 4 9.67 4 9.5C4 7.57 5.57 6 7.5 6S11 7.57 11 9.5c0 .17-.03.33-.05.5h-6.9Z"/>'
        },
        "watering-can-outline": {
            body: '<path fill="currentColor" d="M18.5 7.47c-.74.73-.93 1.78-.58 2.68L15 13.07V11c0-.55-.45-1-1-1h-1.03c.03-.17.03-.33.03-.5C13 6.46 10.54 4 7.5 4A5.497 5.497 0 0 0 4 13.74V20c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-4.11l4.33-4.33c.9.35 1.95.17 2.67-.56l-3.5-3.53M4.05 10C4.03 9.83 4 9.67 4 9.5C4 7.57 5.57 6 7.5 6S11 7.57 11 9.5c0 .17-.03.33-.05.5M13 19H6v-7h7v7Z"/>'
        },
        watermark: {
            body: '<path fill="currentColor" d="M21 3H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16h-9v-6h9v6Z"/>'
        },
        wave: {
            body: '<path fill="currentColor" d="M20 12c-1.39 0-2.78-.47-4-1.33c-2.44 1.71-5.56 1.71-8 0C6.78 11.53 5.39 12 4 12H2v2h2c1.37 0 2.74-.35 4-1c2.5 1.3 5.5 1.3 8 0c1.26.65 2.62 1 4 1h2v-2"/>'
        },
        waveform: {
            body: '<path fill="currentColor" d="m22 12l-2 1l-1 1l-1-1l-1 3l-1-3l-1 8l-1-8l-1 2l-1-2l-1 4l-1-4l-1 9l-1-9l-1 6l-1-6l-1 1l-1-1l-2-1l2-1l1-1l1 1l1-6l1 6l1-9l1 9l1-4l1 4l1-2l1 2l1-8l1 8l1-3l1 3l1-1l1 1l2 1Z"/>'
        },
        waves: {
            body: '<path fill="currentColor" d="M20 12h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33m0-6h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2V6h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0C17.22 5.53 18.61 6 20 6m0 12h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33Z"/>'
        },
        "waves-arrow-left": {
            body: '<path fill="currentColor" d="M4 14c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33h2v2h-2c-1.37 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.62 1-4 1H2v-2h2m4 4.67c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33h2v2h-2c-1.37 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.62 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33M6 10V7h5V5H6V2L2 6"/>'
        },
        "waves-arrow-right": {
            body: '<path fill="currentColor" d="M20 14h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33m0 6h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33m2-14l-4-4v3h-5v2h5v3"/>'
        },
        "waves-arrow-up": {
            body: '<path fill="currentColor" d="M20 14h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33m0 6h2v2h-2c-1.38 0-2.74-.35-4-1c-2.5 1.3-5.5 1.3-8 0c-1.26.65-2.63 1-4 1H2v-2h2c1.39 0 2.78-.47 4-1.33c2.44 1.71 5.56 1.71 8 0c1.22.86 2.61 1.33 4 1.33M7 2L3 6h3v5h2V6h3m6-4l-4 4h3v5h2V6h3"/>'
        },
        waze: {
            body: '<path fill="currentColor" d="M20.54 6.63c.69.94 1.15 2.04 1.35 3.19c.21 1.25.11 2.52-.31 3.72a7.349 7.349 0 0 1-2 3.06a9.1 9.1 0 0 1-2.26 1.58c.41 1.07-.13 2.27-1.2 2.68c-.24.09-.49.14-.74.14a2.08 2.08 0 0 1-2.07-2h-3.07c-.11 1.14-1.13 2-2.27 1.87c-1.06-.1-1.86-.98-1.88-2.04c.01-.19.04-.39.1-.57a8.37 8.37 0 0 1-4-2.85c-.33-.44-.23-1.07.23-1.41c.18-.14.4-.22.63-.22c.72 0 1-.25 1.17-.63c.24-.72.38-1.47.39-2.23c.03-.53.09-1.05.17-1.57A7.307 7.307 0 0 1 7.5 5c1.66-1.3 3.69-2 5.79-2c1.43 0 2.84.35 4.11 1a8.67 8.67 0 0 1 3.14 2.63m-3.82 10.68c1.78-.81 3.18-2.27 3.87-4.1c1.62-4.94-2.59-9.16-7.3-9.16c-.35 0-.71.02-1.06.07C9.36 4.5 6.4 6.5 5.81 9.5c-.38 2 .19 5.29-2.76 5.29C4 16 5.32 16.93 6.81 17.37c.85-.76 2.16-.68 2.93.18c.11.12.2.25.26.39h3.55c.52-1.02 1.78-1.44 2.8-.9c.15.08.25.17.37.27m-5.75-7c-.58.03-1.09-.41-1.12-1c-.03-.58.42-1.08 1-1.12c.58-.03 1.09.42 1.12 1.06a.999.999 0 0 1-.97 1.04l-.03.02m4.69 0c-.58.03-1.09-.41-1.12-1c-.04-.58.42-1.08 1-1.12c.58-.03 1.09.42 1.12 1.06c.02.55-.41 1.02-1 1.04v.02m-5.95 1.76c-.06-.28.13-.57.41-.62c.28-.05.56.13.62.41a2.501 2.501 0 0 0 2.58 1.74c1.14.06 2.18-.64 2.57-1.72c.14-.26.46-.38.71-.23c.18.1.29.27.29.47c-.19.71-.63 1.33-1.23 1.76c-.69.48-1.5.75-2.34.76h-.11c-1.63.07-3.1-1-3.53-2.58l.03.01Z"/>'
        },
        "weather-cloudy": {
            body: '<path fill="currentColor" d="M6 19a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 11a4 4 0 0 1 4 4a4 4 0 0 1-4 4H6m13-6h-2v-1a5 5 0 0 0-5-5c-2.5 0-4.55 1.82-4.94 4.19C6.73 11.07 6.37 11 6 11a3 3 0 0 0-3 3a3 3 0 0 0 3 3h13a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "weather-cloudy-alert": {
            body: '<path fill="currentColor" d="M6 19a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 11a4 4 0 0 1 4 4a4 4 0 0 1-4 4H6m13-6h-2v-1a5 5 0 0 0-5-5c-2.5 0-4.55 1.82-4.94 4.19C6.73 11.07 6.37 11 6 11a3 3 0 0 0-3 3a3 3 0 0 0 3 3h13a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-6-1h-2V8h2v4m0 4h-2v-2h2"/>'
        },
        "weather-cloudy-arrow-right": {
            body: '<path fill="currentColor" d="m6 7l.69.06A5.499 5.499 0 0 1 12 3a5.5 5.5 0 0 1 5.5 5.5l-.08.95c.46-.29 1-.45 1.58-.45a3 3 0 0 1 3 3a3 3 0 0 1-3 3H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-3.5V8.5A3.5 3.5 0 0 0 12 5a3.5 3.5 0 0 0-3.5 3.5V9H6m16 10l-3 3v-2H2v-2h17v-2l3 3"/>'
        },
        "weather-cloudy-clock": {
            body: '<path fill="currentColor" d="M15 13h1.5v2.82l2.44 1.41l-.75 1.3L15 16.69V13m3.13-3.67C17.23 6.81 14.83 5 12 5C9.3 5 7 6.65 6 9c-2.76 0-5 2.24-5 5s2.24 5 5 5h3.68c1.13 2.36 3.53 4 6.32 4c3.87 0 7-3.13 7-7c0-3.12-2.04-5.76-4.87-6.67M6 17c-1.66 0-3-1.34-3-3s1.34-3 3-3c.37 0 .73.07 1.06.19A5.004 5.004 0 0 1 12 7c1.63 0 3.07.79 4 2c-3.88 0-7 3.14-7 7c0 .34.03.67.08 1H6m10 4c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5Z"/>'
        },
        "weather-dust": {
            body: '<path fill="currentColor" d="M3 5c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1m1 8c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1-.4-1-1m0 3c-.6 0-1 .4-1 1s.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1H4M18 5c0-.6.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1M7 20c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H7M3 10c-.6 0-1-.4-1-1s.4-1 1-1h9c1.1 0 2-.9 2-2s-.9-2-2-2c-.6 0-1.1.2-1.4.6c-.4.4-1 .4-1.4 0c-.4-.4-.4-1 0-1.4C9.9 2.5 10.9 2 12 2c2.2 0 4 1.8 4 4s-1.8 4-4 4H3m16 2c.6 0 1-.4 1-1s-.4-1-1-1c-.3 0-.5.1-.7.3c-.4.4-1 .4-1.4 0c-.4-.4-.4-1 0-1.4c.5-.6 1.3-.9 2.1-.9c1.7 0 3 1.3 3 3s-1.3 3-3 3h-9c-.6 0-1-.4-1-1s.4-1 1-1h9m-1 6h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c1.7 0 3 1.3 3 3s-1.3 3-3 3c-.8 0-1.6-.3-2.1-.9c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0c.2.2.4.3.7.3c.6 0 1-.4 1-1s-.4-1-1-1Z"/>'
        },
        "weather-fog": {
            body: '<path fill="currentColor" d="M3 15h10a1 1 0 0 1 1 1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m13 0h5a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1a1 1 0 0 1 1-1M1 12a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 9c2.19 0 3.97 1.76 4 4h-2a2 2 0 0 0-2-2h-2v-1a5 5 0 0 0-5-5C9.5 5 7.45 6.82 7.06 9.19C6.73 9.07 6.37 9 6 9a3 3 0 0 0-3 3a3 3 0 0 0 .17 1H1.1L1 12m2 7h2a1 1 0 0 1 1 1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m5 0h13a1 1 0 0 1 1 1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        "weather-hail": {
            body: '<path fill="currentColor" d="M6 14a1 1 0 0 1 1 1a1 1 0 0 1-1 1a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-1a1 1 0 0 1-1-1a1 1 0 0 1 1-1h1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3a3 3 0 0 0 3 3m4 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m4.5-2a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5m-4-4a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 9 13.5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
        },
        "weather-hazy": {
            body: '<path fill="currentColor" d="m12 2l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m17.31 0l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15M14 15a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1m8 0a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1m-12 4a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1m-7 0a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m9-10a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3Z"/>'
        },
        "weather-hurricane": {
            body: '<path fill="currentColor" d="M15 6.79c1.86 1.07 3 3.06 3 5.21C18 22 6 22 6 22c1.25-.94 2.38-2.05 3.34-3.29a.99.99 0 0 0-.34-1.5C7.14 16.14 6 14.15 6 12C6 2 18 2 18 2c-1.25.94-2.38 2.05-3.34 3.29a.99.99 0 0 0 .34 1.5M12 14a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2Z"/>'
        },
        "weather-lightning": {
            body: '<path fill="currentColor" d="M6 16a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-1a1 1 0 0 1-1-1a1 1 0 0 1 1-1h1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3a3 3 0 0 0 3 3h1a1 1 0 0 1 1 1a1 1 0 0 1-1 1H6m6-5h3l-2 4h2l-3.75 7l.75-5H9.5l2.5-6Z"/>'
        },
        "weather-lightning-rainy": {
            body: '<path fill="currentColor" d="M4.5 13.59c.5.28.64.91.37 1.37c-.28.48-.87.64-1.37.37A4.98 4.98 0 0 1 1 11a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a1 1 0 0 1-1-1a1 1 0 0 1 1-1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3c0 1.11.6 2.08 1.5 2.6v-.01m5-2.59h3l-2 4h2l-3.75 7l.75-5H7l2.5-6m8 7.67c0 1.29-1 2.33-2.25 2.33S13 19.96 13 18.67c0-1.55 2.25-4.17 2.25-4.17s2.25 2.62 2.25 4.17Z"/>'
        },
        "weather-night": {
            body: '<path fill="currentColor" d="m17.75 4.09l-2.53 1.94l.91 3.06l-2.63-1.81l-2.63 1.81l.91-3.06l-2.53-1.94L12.44 4l1.06-3l1.06 3l3.19.09m3.5 6.91l-1.64 1.25l.59 1.98l-1.7-1.17l-1.7 1.17l.59-1.98L15.75 11l2.06-.05L18.5 9l.69 1.95l2.06.05m-2.28 4.95c.83-.08 1.72 1.1 1.19 1.85c-.32.45-.66.87-1.08 1.27C15.17 23 8.84 23 4.94 19.07c-3.91-3.9-3.91-10.24 0-14.14c.4-.4.82-.76 1.27-1.08c.75-.53 1.93.36 1.85 1.19c-.27 2.86.69 5.83 2.89 8.02a9.96 9.96 0 0 0 8.02 2.89m-1.64 2.02a12.08 12.08 0 0 1-7.8-3.47c-2.17-2.19-3.33-5-3.49-7.82c-2.81 3.14-2.7 7.96.31 10.98c3.02 3.01 7.84 3.12 10.98.31Z"/>'
        },
        "weather-night-partly-cloudy": {
            body: '<path fill="currentColor" d="M22 10.28c-.26.02-.5.03-.74.03c-1.94 0-3.87-.74-5.35-2.22A7.518 7.518 0 0 1 13.72 2c.05-.47-.5-1-1.01-1a.69.69 0 0 0-.39.12c-.32.24-.66.52-.96.82c-2.31 2.3-2.81 5.72-1.52 8.52a5.479 5.479 0 0 0-3.15 3.6L6 14a4 4 0 0 0-4 4a4 4 0 0 0 4 4h13a3 3 0 0 0 3-3a3 3 0 0 0-3-3c-.58 0-1.12.16-1.58.45l.08-.95c0-.22 0-.45-.04-.67a7.45 7.45 0 0 0 4.6-2.19c.32-.3.58-.64.82-.96c.39-.55-.23-1.4-.84-1.4M19 18a1 1 0 0 1 1 1a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2.5v-.5c0-1.56 1.03-2.86 2.44-3.32c.16-.05.32-.09.49-.12c.18-.03.37-.06.57-.06c.23 0 .45.03.66.07c.07.01.14.03.21.06c.13.03.28.07.41.12c.08.03.16.07.22.11c.13.05.24.11.34.18c.08.05.16.1.23.16c.1.07.18.14.27.22c.07.08.16.13.21.2c.08.08.14.17.21.25c.06.08.13.16.18.25c.06.09.1.18.15.28c.05.1.11.18.15.28c.17.41.26.85.26 1.32V18m1.33-5.14A5.51 5.51 0 0 0 12 10h-.13c-.46-.81-.73-1.74-.73-2.71c0-.98.25-1.92.72-2.74A9.383 9.383 0 0 0 14.5 9.5a9.347 9.347 0 0 0 4.95 2.64c-.79.46-1.69.7-2.62.72Z"/>'
        },
        "weather-partly-cloudy": {
            body: '<path fill="currentColor" d="M12.74 5.47c2.36 1.03 3.61 3.56 3.18 5.99A6.002 6.002 0 0 1 18 16v.17a3 3 0 0 1 1-.17a3 3 0 0 1 3 3a3 3 0 0 1-3 3H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4h.27C5 12.45 4.6 10.24 5.5 8.26a5.49 5.49 0 0 1 7.24-2.79m-.81 1.83c-1.77-.8-3.84.01-4.62 1.77c-.46 1.02-.38 2.15.1 3.06A5.988 5.988 0 0 1 12 10c.7 0 1.38.12 2 .34a3.506 3.506 0 0 0-2.07-3.04m1.62-3.66c-.55-.24-1.1-.41-1.67-.52l2.49-1.3l.9 2.89a7.67 7.67 0 0 0-1.72-1.07m-7.46.8c-.49.35-.92.75-1.29 1.19l.11-2.81l2.96.68c-.62.21-1.22.53-1.78.94M18 9.71c-.09-.59-.22-1.16-.41-1.71l2.38 1.5l-2.05 2.23c.11-.65.13-1.33.08-2.02M3.04 11.3c.07.6.2 1.17.39 1.7l-2.37-1.5L3.1 9.28c-.1.65-.13 1.33-.06 2.02M19 18h-3v-2a4 4 0 0 0-4-4a4 4 0 0 0-4 4H6a2 2 0 0 0-2 2a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "weather-partly-lightning": {
            body: '<path fill="currentColor" d="M19 15a3 3 0 0 0-1 .17V15c0-1.81-.81-3.44-2.08-4.54c.43-2.43-.82-4.96-3.17-5.99c-2.78-1.23-6.03.03-7.25 2.78c-.9 1.99-.5 4.2.77 5.75H6a4 4 0 0 0-4 4a4 4 0 0 0 4 4h1s1 0 1-1s-1-1-1-1H6a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2a4 4 0 0 1 4-4a4 4 0 0 1 4 4v2h3a1 1 0 0 1 1 1a1 1 0 0 1-1 1h-2s-1 0-1 1s1 1 1 1h2a3 3 0 0 0 3-3a3 3 0 0 0-3-3m-7-6c-1.84 0-3.5.83-4.59 2.13c-.48-.91-.56-2.04-.1-3.06a3.487 3.487 0 0 1 4.62-1.77c1.25.56 2.01 1.76 2.07 3.04c-.62-.22-1.3-.34-2-.34m1.55-6.37c-.55-.23-1.1-.4-1.67-.51l2.49-1.3l.9 2.89c-.51-.42-1.08-.78-1.72-1.08m-7.46.81c-.49.35-.92.75-1.29 1.19l.11-2.81l2.96.68c-.62.21-1.22.53-1.78.94M18 8.71c-.09-.59-.22-1.16-.41-1.71l2.38 1.5l-2.05 2.23c.11-.65.13-1.33.08-2.02M3.04 10.3c.07.6.21 1.17.39 1.7l-2.37-1.5L3.1 8.28c-.1.65-.13 1.33-.06 2.02M11.8 15h2.45l-1.64 3.27h1.64L11.18 24l.62-4.09H9.75"/>'
        },
        "weather-partly-rainy": {
            body: '<path fill="currentColor" d="M12.75 4.47c2.35 1.03 3.6 3.56 3.17 5.99A6.002 6.002 0 0 1 18 15v.17a3 3 0 0 1 1-.17a3 3 0 0 1 3 3a3 3 0 0 1-3 3h-2s-1 0-1-1s1-1 1-1h2a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-3v-2a4 4 0 0 0-4-4a4 4 0 0 0-4 4H6a2 2 0 0 0-2 2a2 2 0 0 0 2 2h1s1 0 1 1s-1 1-1 1H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4h.27C5 11.45 4.6 9.24 5.5 7.25c1.22-2.75 4.47-4.01 7.25-2.78m-.82 1.83c-1.77-.8-3.84.01-4.62 1.77c-.46 1.02-.38 2.15.1 3.06A5.988 5.988 0 0 1 12 9c.7 0 1.38.12 2 .34a3.506 3.506 0 0 0-2.07-3.04m1.62-3.67c-.55-.23-1.1-.4-1.67-.51l2.49-1.3l.9 2.89c-.51-.42-1.08-.78-1.72-1.08m-7.46.81c-.49.35-.92.75-1.29 1.19l.11-2.81l2.96.68c-.62.21-1.22.53-1.78.94M18 8.71c-.09-.59-.22-1.16-.41-1.71l2.38 1.5l-2.05 2.23c.11-.65.13-1.33.08-2.02M3.04 10.3c.07.6.21 1.17.39 1.7l-2.37-1.5L3.1 8.28c-.1.65-.13 1.33-.06 2.02M12 18.91c.59.91 1 1.72 1 2.09a1 1 0 0 1-1 1a1 1 0 0 1-1-1c0-.37.41-1.18 1-2.09m0-3.29S9 19 9 21a3 3 0 0 0 3 3a3 3 0 0 0 3-3c0-2-3-5.38-3-5.38Z"/>'
        },
        "weather-partly-snowy": {
            body: '<path fill="currentColor" d="M6 19.03a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2c0-2.22 1.79-4 4-4a4 4 0 0 1 4 4v2h3a1 1 0 0 1 1 1c0 .54-.45 1-1 1h-2s-1 0-1 1s1 1 1 1h2a3 3 0 0 0 3-3c0-1.66-1.34-3-3-3c-.35 0-.69.05-1 .16v-.16c0-1.82-.81-3.45-2.08-4.53c.43-2.45-.82-4.97-3.17-6c-2.78-1.23-6.03.03-7.25 2.78c-.9 1.99-.5 4.19.77 5.75H6c-2.21 0-4 1.78-4 4a4 4 0 0 0 4 4s1 0 1-1s-1-1-1-1m6-10c-1.84 0-3.5.82-4.59 2.13a3.51 3.51 0 0 1-.1-3.07a3.496 3.496 0 0 1 4.62-1.77A3.52 3.52 0 0 1 14 9.37c-.62-.22-1.3-.34-2-.34m1.55-6.37c-.55-.24-1.1-.4-1.67-.51L14.37.84l.9 2.89a7.67 7.67 0 0 0-1.72-1.07m-7.46.8c-.49.35-.92.75-1.29 1.2l.11-2.82l2.96.69c-.62.2-1.22.52-1.78.93M18 8.73c-.09-.58-.22-1.16-.41-1.7l2.38 1.5l-2.05 2.23c.11-.66.13-1.34.08-2.03M3.04 10.32c.07.6.21 1.18.39 1.71l-2.37-1.5L3.1 8.3c-.1.65-.13 1.34-.06 2.02m4.99 11.13c.1.39.5.61.88.51l1.59-.42l-.44 1.57c-.1.39.13.79.51.89c.38.1.78-.13.88-.5l.42-1.59l1.16 1.16c.27.28.74.28 1.02 0s.28-.75 0-1.02l-1.16-1.17l1.58-.41c.38-.1.61-.5.53-.88c-.12-.38-.5-.59-.91-.51l-1.59.42l.44-1.57c.1-.39-.12-.78-.51-.88c-.38-.1-.77.12-.88.51l-.41 1.58L10 17.97c-.3-.28-.77-.28-1.05 0c-.27.3-.27.75 0 1.03l1.16 1.16l-1.57.41c-.39.11-.61.5-.51.88Z"/>'
        },
        "weather-partly-snowy-rainy": {
            body: '<path fill="currentColor" d="M13.55 2.66c-.55-.24-1.1-.4-1.67-.51L14.37.84l.9 2.89a7.67 7.67 0 0 0-1.72-1.07m-7.46.8c-.49.35-.92.75-1.29 1.2l.11-2.82l2.96.69c-.62.2-1.22.52-1.78.93M18 8.73c-.09-.58-.22-1.16-.41-1.7l2.38 1.5l-2.05 2.23c.11-.66.13-1.34.08-2.03M3.04 10.32c.07.6.21 1.18.39 1.71l-2.37-1.5L3.1 8.3c-.1.65-.13 1.34-.06 2.02m13.64 11.89c0 .99-.77 1.79-1.73 1.79c-.95 0-1.72-.8-1.72-1.79c0-1.18 1.72-3.18 1.72-3.18s1.73 2 1.73 3.18m-10.65-.76c-.1-.38.12-.77.51-.87l1.59-.43L6.96 19a.7.7 0 0 1 0-1c.27-.3.74-.3 1.04 0l1.14 1.14l.41-1.58c.1-.39.5-.62.88-.51c.39.1.62.5.5.88l-.43 1.57l1.6-.4c.4-.1.78.11.9.5a.74.74 0 0 1-.53.87l-1.58.42l1.16 1.16c.28.27.28.74 0 1.02s-.74.28-1.02 0L9.87 21.9l-.42 1.6c-.1.38-.5.6-.88.5c-.39-.1-.6-.5-.51-.88l.44-1.57l-1.59.41c-.41.1-.78-.12-.88-.51M19 15.03c-.35 0-.69.05-1 .16v-.16c0-1.82-.81-3.45-2.08-4.53c.43-2.45-.82-4.97-3.17-6c-2.78-1.23-6.03.03-7.25 2.78c-.9 1.99-.5 4.19.77 5.75H6c-2.21 0-4 1.78-4 4c0 1.14.5 2.17 1.27 2.9c0 0 .7.71 1.41 0s0-1.43 0-1.43c-.41-.35-.68-.88-.68-1.47a2 2 0 0 1 2-2h2c0-2.22 1.79-4 4-4a4 4 0 0 1 4 4v2h3a1 1 0 0 1 1 1c0 .54-.45 1-1 1h-1s-1 0-1 1s1 1 1 1h1a3 3 0 0 0 3-3c0-1.66-1.34-3-3-3m-7-6c-1.84 0-3.5.82-4.59 2.13a3.51 3.51 0 0 1-.1-3.07a3.496 3.496 0 0 1 4.62-1.77A3.52 3.52 0 0 1 14 9.37c-.62-.22-1.3-.34-2-.34Z"/>'
        },
        "weather-pouring": {
            body: '<path fill="currentColor" d="M9 12c.53.14.85.69.71 1.22l-1.3 4.83c-.14.54-.69.85-1.22.71a.967.967 0 0 1-.69-1.22l1.28-4.83c.14-.54.69-.85 1.22-.71m4 0c.53.14.85.69.71 1.22l-2.07 7.73c-.14.55-.69.85-1.23.71c-.53-.16-.85-.69-.71-1.23l2.08-7.72c.14-.54.69-.85 1.22-.71m4 0c.53.14.85.69.71 1.22l-1.3 4.83c-.14.54-.69.85-1.22.71a.967.967 0 0 1-.69-1.22l1.28-4.83c.14-.54.69-.85 1.22-.71m0-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3c0 1.11.6 2.08 1.5 2.6v-.01c.5.28.64.91.37 1.37c-.28.47-.87.64-1.37.36v.01A4.98 4.98 0 0 1 1 11a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4c0 1.5-.8 2.77-2 3.46c-.5.27-1.09.11-1.37-.37c-.27-.48-.13-1.09.37-1.37v.01c.6-.34 1-.99 1-1.73a2 2 0 0 0-2-2h-2Z"/>'
        },
        "weather-rainy": {
            body: '<path fill="currentColor" d="M6 14.03a1 1 0 0 1 1 1c0 .55-.45 1-1 1c-2.76 0-5-2.24-5-5s2.24-5 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03l.5-.03a4 4 0 0 1 4 4c0 2.2-1.79 4-4 4h-1c-.55 0-1-.45-1-1c0-.56.45-1 1-1h1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2v-1c0-2.76-2.24-5-5-5c-2.5 0-4.55 1.81-4.94 4.18c-.33-.12-.69-.18-1.06-.18a3 3 0 0 0-3 3a3 3 0 0 0 3 3m6 .12c.18.24.37.51.56.79C13 15.56 14 17.03 14 18a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-.97 1-2.44 1.44-3.06c.19-.28.38-.54.56-.79m0-3.12l-.5.56s-.85.96-1.71 2.22C8.93 15.06 8 16.56 8 18a4 4 0 0 0 4 4a4 4 0 0 0 4-4c0-1.44-.93-2.94-1.79-4.19c-.86-1.26-1.71-2.22-1.71-2.22"/>'
        },
        "weather-snowy": {
            body: '<path fill="currentColor" d="M6 14a1 1 0 0 1 1 1a1 1 0 0 1-1 1a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4h-1a1 1 0 0 1-1-1a1 1 0 0 1 1-1h1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3a3 3 0 0 0 3 3m1.88 4.07l2.19-.57l-1.61-1.62c-.39-.38-.39-1.02 0-1.42c.39-.39 1.04-.39 1.42 0l1.62 1.61l.57-2.19a1 1 0 1 1 1.93.52l-.59 2.19L15.6 16a1 1 0 1 1 .52 1.93l-2.19.57l1.61 1.62c.39.38.39 1.03 0 1.42c-.39.39-1.04.39-1.42 0l-1.62-1.61l-.57 2.19A1 1 0 1 1 10 21.6l.59-2.19L8.4 20a1 1 0 1 1-.52-1.93Z"/>'
        },
        "weather-snowy-heavy": {
            body: '<path fill="currentColor" d="M4 16.36c-.14-.54.18-1.11.73-1.25L7 14.5l-1.67-1.64c-.4-.4-.4-1.05 0-1.46c.4-.4 1.07-.4 1.46 0l1.66 1.65l.59-2.25c.14-.56.71-.88 1.25-.73c.56.14.88.71.71 1.26l-.58 2.25l2.25-.58a.99.99 0 0 1 1.26.71c.15.54-.17 1.11-.73 1.25l-2.25.59l1.65 1.66c.4.39.4 1.06 0 1.46c-.4.4-1.06.4-1.45 0L9.5 17l-.61 2.27c-.14.56-.71.87-1.25.73c-.56-.14-.87-.71-.73-1.26l.59-2.24l-2.24.59c-.55.14-1.12-.17-1.26-.73M1 10a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 7a4 4 0 0 1 4 4a4 4 0 0 1-4 4a1 1 0 0 1-1-1a1 1 0 0 1 1-1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V8a5 5 0 0 0-5-5C9.5 3 7.45 4.82 7.06 7.19C6.73 7.07 6.37 7 6 7a3 3 0 0 0-3 3c0 .85.35 1.61.91 2.16c.36.39.35 1-.03 1.38a.996.996 0 0 1-1.41 0A4.988 4.988 0 0 1 1 10m13.03 10.43c.1.39.47.61.88.51l1.59-.44l-.44 1.59c-.1.41.12.78.51.88c.38.11.78-.12.88-.51l.41-1.57l1.17 1.16c.27.28.74.28 1.02 0s.28-.75 0-1.02l-1.16-1.17l1.57-.41c.39-.1.62-.5.51-.88c-.1-.39-.47-.61-.88-.51l-1.59.44l.44-1.59c.1-.41-.12-.78-.51-.88a.71.71 0 0 0-.88.51l-.41 1.57l-1.17-1.16a.724.724 0 0 0-1.02 0c-.28.29-.28.75 0 1.02l1.16 1.17l-1.57.41c-.39.1-.62.5-.51.88Z"/>'
        },
        "weather-snowy-rainy": {
            body: '<path fill="currentColor" d="M18.5 18.67c0 1.29-1 2.33-2.25 2.33S14 19.96 14 18.67c0-1.55 2.25-4.17 2.25-4.17s2.25 2.62 2.25 4.17M4 17.36c-.14-.54.18-1.11.73-1.25L7 15.5l-1.67-1.64c-.4-.4-.4-1.05 0-1.46c.4-.4 1.07-.4 1.46 0l1.66 1.65l.59-2.25c.14-.56.71-.88 1.25-.73c.56.14.88.71.71 1.26l-.58 2.25l2.25-.58a.99.99 0 0 1 1.26.71c.15.54-.17 1.11-.73 1.25l-2.25.59l1.65 1.66c.4.39.4 1.06 0 1.46c-.4.4-1.06.4-1.45 0L9.5 18l-.61 2.27c-.14.56-.71.87-1.25.73c-.56-.14-.87-.71-.73-1.26l.59-2.24l-2.24.59c-.55.14-1.12-.17-1.26-.73M1 11a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a1 1 0 0 1-1-1a1 1 0 0 1 1-1a2 2 0 0 0 2-2a2 2 0 0 0-2-2h-2V9a5 5 0 0 0-5-5C9.5 4 7.45 5.82 7.06 8.19C6.73 8.07 6.37 8 6 8a3 3 0 0 0-3 3c0 .85.35 1.61.91 2.16c.36.39.35 1-.03 1.38a.996.996 0 0 1-1.41 0A4.988 4.988 0 0 1 1 11Z"/>'
        },
        "weather-sunny": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0-7l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m.02 10l1.76-3.77a7.131 7.131 0 0 0 2.38 4.14L3.36 17M20.65 7l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36m-.01 10l-4.14.36c.59-.51 1.12-1.14 1.54-1.86c.42-.73.69-1.5.83-2.29L20.64 17M12 22l-2.41-3.44c.74.27 1.55.44 2.41.44c.82 0 1.63-.17 2.37-.44L12 22Z"/>'
        },
        "weather-sunny-alert": {
            body: '<path fill="currentColor" d="M12 7a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 8a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m0-13l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m.02 10l1.76-3.77a7.131 7.131 0 0 0 2.38 4.14L3.36 17M12 22l-2.41-3.44c.74.27 1.55.44 2.41.44c.82 0 1.63-.17 2.37-.44M19 13V7h2v6h-2m0 4v-2h2v2"/>'
        },
        "weather-sunny-off": {
            body: '<path fill="currentColor" d="M22.11 21.46L2.39 1.73L1.11 3l3.86 3.86L3.34 7l1.77 3.79c.14-.79.39-1.55.83-2.29c.06-.14.19-.26.28-.39l1.44 1.44C7.25 10.27 7 11.11 7 12c0 2.76 2.24 5 5 5c.9 0 1.73-.25 2.45-.66l6.39 6.39l1.27-1.27M12 15c-1.66 0-3-1.34-3-3c0-.33.07-.64.17-.94l3.77 3.77c-.3.1-.61.17-.94.17m6.05-6.5c-.42-.72-.95-1.35-1.55-1.86l4.15.36l-1.77 3.79c-.14-.79-.41-1.56-.83-2.29M12 7c2.76 0 5 2.24 5 5c0 .54-.11 1.05-.26 1.54L15 11.78A3.057 3.057 0 0 0 12.22 9l-1.75-1.73c.48-.16.99-.27 1.53-.27m0-2c-.84 0-1.65.15-2.39.42L12 2l2.39 3.42C13.65 5.15 12.84 5 12 5m6.87 8.21L20.64 17l-.4.04l-1.99-1.99c.29-.6.51-1.21.62-1.84M12 19c.82 0 1.63-.17 2.37-.44L12 22l-2.41-3.44c.74.27 1.55.44 2.41.44m-6.05-3.5c.42.74.96 1.36 1.55 1.87L3.36 17l1.76-3.77c.14.77.41 1.55.83 2.27Z"/>'
        },
        "weather-sunset": {
            body: '<path fill="currentColor" d="M3 12h4a5 5 0 0 1 5-5a5 5 0 0 1 5 5h4a1 1 0 0 1 1 1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m2 4h14a1 1 0 0 1 1 1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1a1 1 0 0 1 1-1m12 4a1 1 0 0 1 1 1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1a1 1 0 0 1 1-1h10m-2-8a3 3 0 0 0-3-3a3 3 0 0 0-3 3h6M12 2l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m17.31 0l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36Z"/>'
        },
        "weather-sunset-down": {
            body: '<path fill="currentColor" d="M3 12h4a5 5 0 0 1 5-5a5 5 0 0 1 5 5h4a1 1 0 0 1 1 1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m12 0a3 3 0 0 0-3-3a3 3 0 0 0-3 3h6M12 2l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m17.31 0l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36m-7.94 13.71l3.11-3.11c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0L12 18.59l-2.41-2.41a.996.996 0 0 0-1.41 0c-.39.39-.39 1.03 0 1.42l3.11 3.11c.21.19.45.29.71.29c.26 0 .5-.1.71-.29Z"/>'
        },
        "weather-sunset-up": {
            body: '<path fill="currentColor" d="M3 12h4a5 5 0 0 1 5-5a5 5 0 0 1 5 5h4a1 1 0 0 1 1 1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1m12 0a3 3 0 0 0-3-3a3 3 0 0 0-3 3h6M12 2l2.39 3.42C13.65 5.15 12.84 5 12 5c-.84 0-1.65.15-2.39.42L12 2M3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29L3.34 7m17.31 0l-1.77 3.79a7.023 7.023 0 0 0-2.38-4.15l4.15.36m-7.94 9.3l3.11 3.11a.996.996 0 1 1-1.41 1.41L12 18.41l-2.41 2.41a.996.996 0 1 1-1.41-1.41l3.11-3.11c.21-.2.45-.3.71-.3c.26 0 .5.1.71.3Z"/>'
        },
        "weather-tornado": {
            body: '<path fill="currentColor" d="M21 5H3a1 1 0 0 1-1-1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1a1 1 0 0 1-1 1m-1 3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1m1 4a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1m-5 4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1m-3 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z"/>'
        },
        "weather-windy": {
            body: '<path fill="currentColor" d="M4 10a1 1 0 0 1-1-1a1 1 0 0 1 1-1h8a2 2 0 0 0 2-2a2 2 0 0 0-2-2c-.55 0-1.05.22-1.41.59a.973.973 0 0 1-1.42 0c-.39-.39-.39-1.03 0-1.42C9.9 2.45 10.9 2 12 2a4 4 0 0 1 4 4a4 4 0 0 1-4 4H4m15 2a1 1 0 0 0 1-1a1 1 0 0 0-1-1c-.28 0-.53.11-.71.29a.996.996 0 0 1-1.41 0c-.38-.39-.38-1.02 0-1.41C17.42 8.34 18.17 8 19 8a3 3 0 0 1 3 3a3 3 0 0 1-3 3H5a1 1 0 0 1-1-1a1 1 0 0 1 1-1h14m-1 6H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1h14a3 3 0 0 1 3 3a3 3 0 0 1-3 3c-.83 0-1.58-.34-2.12-.88c-.38-.39-.38-1.02 0-1.41a.996.996 0 0 1 1.41 0c.18.18.43.29.71.29a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        "weather-windy-variant": {
            body: '<path fill="currentColor" d="m6 6l.69.06A5.499 5.499 0 0 1 12 2a5.5 5.5 0 0 1 5.5 5.5l-.08.95c.46-.29 1-.45 1.58-.45a3 3 0 0 1 3 3a3 3 0 0 1-3 3H6a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1a1 1 0 0 0-1-1h-3.5V7.5A3.5 3.5 0 0 0 12 4a3.5 3.5 0 0 0-3.5 3.5V8H6m12 10H4a1 1 0 0 1-1-1a1 1 0 0 1 1-1h14a3 3 0 0 1 3 3a3 3 0 0 1-3 3c-.83 0-1.58-.34-2.12-.88c-.38-.39-.38-1.02 0-1.41a.996.996 0 0 1 1.41 0c.18.18.43.29.71.29a1 1 0 0 0 1-1a1 1 0 0 0-1-1Z"/>'
        },
        web: {
            body: '<path fill="currentColor" d="M16.36 14c.08-.66.14-1.32.14-2c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2m-5.15 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56M14.34 14H9.66c-.1-.66-.16-1.32-.16-2c0-.68.06-1.35.16-2h4.68c.09.65.16 1.32.16 2c0 .68-.07 1.34-.16 2M12 19.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m-2.92 8H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16m-.82-2C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2c0 .68.06 1.34.14 2M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M18.92 8h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"/>'
        },
        "web-box": {
            body: '<path fill="currentColor" d="M8.95 13.4H6.58a5.5 5.5 0 0 1 0-2.8h2.37a11.56 11.56 0 0 0-.1 1.4a11.56 11.56 0 0 0 .1 1.4M7.16 9.2H9.2a12.06 12.06 0 0 1 .98-2.49A5.55 5.55 0 0 0 7.16 9.2m9.68 0a5.59 5.59 0 0 0-3.03-2.49a10.95 10.95 0 0 1 .97 2.49M12 17.57a9.5 9.5 0 0 0 1.34-2.77h-2.68A9.5 9.5 0 0 0 12 17.57m0-11.15a9.53 9.53 0 0 0-1.34 2.78h2.68A9.53 9.53 0 0 0 12 6.42M7.16 14.8a5.61 5.61 0 0 0 3.02 2.49a12.06 12.06 0 0 1-.98-2.49M21 5v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2m-2 7a7 7 0 1 0-7 7a7 7 0 0 0 7-7m-3.85 0a11.56 11.56 0 0 1-.1 1.4h2.37a5.5 5.5 0 0 0 0-2.8h-2.37a11.56 11.56 0 0 1 .1 1.4m-1.34 5.29a5.62 5.62 0 0 0 3.03-2.49h-2.06a10.95 10.95 0 0 1-.97 2.49m-3.45-6.69a8.81 8.81 0 0 0 0 2.8h3.28a10.3 10.3 0 0 0 .11-1.4a10.21 10.21 0 0 0-.11-1.4Z"/>'
        },
        "web-cancel": {
            body: '<path fill="currentColor" d="M13.82 14H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2c0 .5-.04 1-.1 1.46c.6-.5 1.32-.89 2.1-1.14V12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2v.18c.7.17 1.35.45 1.95.82c.05-.32.05-.66.05-1c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.34 0 .68 0 1-.05c-.41-.66-.71-1.4-.87-2.2c-.04.07-.08.14-.13.21c-.83-1.2-1.5-2.53-1.91-3.96h2.41c.31-.75.76-1.42 1.32-2m5.1-6h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m10.5 6C16 14 14 16 14 18.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5m0 7.5c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5L20 21.08c-.42.27-.94.42-1.5.42m2.58-1.5L17 15.92c.42-.27.94-.42 1.5-.42c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5Z"/>'
        },
        "web-check": {
            body: '<path fill="currentColor" d="M16.5 12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2c0 .37-.03.73-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.59 0 1.16-.06 1.72-.16A5.9 5.9 0 0 1 13 19c0-.29.03-.57.07-.85c-.32.63-.67 1.24-1.07 1.81c-.83-1.2-1.5-2.53-1.91-3.96h3.72a5.95 5.95 0 0 1 2.59-2.4c.06-.53.1-1.06.1-1.6M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m6.34 6H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25-9.56c1.84.63 3.37 1.9 4.33 3.56h-2.95a15.65 15.65 0 0 0-1.38-3.56m7.91 12.81L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59l1.16 1.41Z"/>'
        },
        "web-clock": {
            body: '<path fill="currentColor" d="M15 12.5v4l3 2l.75-1.25l-2.25-1.5V12.5H15m7-.11V12c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.13 0 .24 0 .37-.03c1.06.65 2.3 1.03 3.63 1.03c3.86 0 7-3.14 7-7c0-1.32-.38-2.56-1-3.61m-2.24-2.28l-.17-.11h.15c.01.03.01.07.02.11M18.92 8h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M9.66 10h2.75a7 7 0 0 0-2.84 3.24c-.04-.41-.07-.82-.07-1.24c0-.68.06-1.35.16-2M9.4 4.44C8.8 5.55 8.35 6.75 8 8H5.08A7.923 7.923 0 0 1 9.4 4.44M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M16 21c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5Z"/>'
        },
        "web-minus": {
            body: '<path fill="currentColor" d="M16.5 12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2c0 .37-.03.73-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.59 0 1.16-.06 1.72-.16A5.9 5.9 0 0 1 13 19c0-.29.03-.57.07-.85c-.32.63-.67 1.24-1.07 1.81c-.83-1.2-1.5-2.53-1.91-3.96h3.72a5.95 5.95 0 0 1 2.59-2.4c.06-.53.1-1.06.1-1.6M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m6.34 6H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25-9.56c1.84.63 3.37 1.9 4.33 3.56h-2.95a15.65 15.65 0 0 0-1.38-3.56M23 18v2h-8v-2h8Z"/>'
        },
        "web-off": {
            body: '<path fill="currentColor" d="M9.4 4.44c-.21.39-.4.79-.56 1.2l1.53 1.53c.41-1.12.96-2.17 1.63-3.14c.83 1.2 1.5 2.54 1.91 3.97H11.2l2 2h1.14c.06.41.1.84.13 1.27l1.97 1.97c.03-.41.06-.82.06-1.24c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2H17.2l3.3 3.28c.94-1.53 1.5-3.34 1.5-5.28c0-5.5-4.5-10-10-10c-1.94 0-3.75.56-5.28 1.5L8.18 5c.39-.23.82-.42 1.22-.56M18.92 8h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M2.39 1.73L1.11 3l2.95 2.95A9.91 9.91 0 0 0 2 12c0 5.5 4.5 10 10 10c2.28 0 4.37-.77 6.06-2.05l2.78 2.78l1.27-1.27L2.39 1.73M5.5 7.37l.61.63H5.08c.12-.22.26-.42.42-.63M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16m4.42-4c0-.2 0-.39.03-.58L12.11 14H9.66c-.1-.66-.16-1.32-.16-2m2.5 7.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96m2.59-.4c.37-.68.67-1.41.91-2.15l1.12 1.09c-.62.45-1.3.81-2.03 1.06Z"/>'
        },
        "web-plus": {
            body: '<path fill="currentColor" d="M16.5 12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2c0 .37-.03.73-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.59 0 1.16-.06 1.72-.16A5.9 5.9 0 0 1 13 19c0-.29.03-.57.07-.85c-.32.63-.67 1.24-1.07 1.81c-.83-1.2-1.5-2.53-1.91-3.96h3.72a5.95 5.95 0 0 1 2.59-2.4c.06-.53.1-1.06.1-1.6M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m6.34 6H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25-9.56c1.84.63 3.37 1.9 4.33 3.56h-2.95a15.65 15.65 0 0 0-1.38-3.56M23 18v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3Z"/>'
        },
        "web-refresh": {
            body: '<path fill="currentColor" d="M13.82 14H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2c0 .5-.04 1-.1 1.46c.6-.5 1.32-.89 2.1-1.14V12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2v.18c.7.17 1.35.45 1.95.82c.05-.32.05-.66.05-1c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.34 0 .68 0 1-.05c-.41-.66-.71-1.4-.87-2.2c-.04.07-.08.14-.13.21c-.83-1.2-1.5-2.53-1.91-3.96h2.41c.31-.75.76-1.42 1.32-2m5.1-6h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m12.83 7.67L22 14.5v4h-4l1.77-1.77A2.5 2.5 0 1 0 20 20h1.71A3.991 3.991 0 0 1 18 22.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.11 0 2.11.45 2.83 1.17Z"/>'
        },
        "web-remove": {
            body: '<path fill="currentColor" d="M16.5 12c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2c0 .37-.03.73-.08 1.08c.69.1 1.33.32 1.92.64c.1-.56.16-1.13.16-1.72c0-5.5-4.5-10-10-10C6.47 2 2 6.5 2 12s4.5 10 10 10c.59 0 1.16-.06 1.72-.16A5.9 5.9 0 0 1 13 19c0-.29.03-.57.07-.85c-.32.63-.67 1.24-1.07 1.81c-.83-1.2-1.5-2.53-1.91-3.96h3.72a5.95 5.95 0 0 1 2.59-2.4c.06-.53.1-1.06.1-1.6M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m6.34 6H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25-9.56c1.84.63 3.37 1.9 4.33 3.56h-2.95a15.65 15.65 0 0 0-1.38-3.56M20.41 19l2.13 2.12l-1.42 1.42L19 20.41l-2.12 2.13l-1.41-1.42L17.59 19l-2.12-2.12l1.41-1.41L19 17.59l2.12-2.12l1.42 1.41L20.41 19Z"/>'
        },
        "web-sync": {
            body: '<path fill="currentColor" d="M16.5 11.74c0-.59-.07-1.16-.14-1.74h3.38c.08.33.15.67.19 1c.72.07 1.41.23 2.07.5C21.71 6.21 17.35 2 12 2C6.47 2 2 6.5 2 12s4.5 10 10 10c.87 0 1.71-.12 2.5-.33a6.599 6.599 0 0 1-1.46-3.47c-.31.61-.65 1.2-1.04 1.76c-.83-1.2-1.5-2.53-1.91-3.96h3.09c.17-.72.46-1.39.85-2H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2c0 .5-.04 1-.1 1.5a6.36 6.36 0 0 1 2.1-1.76M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26m.82 2H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m2.09 0c.41-1.43 1.08-2.77 1.91-3.97c.83 1.2 1.5 2.54 1.91 3.97h-3.82m8.83 0h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M23 17.5c0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25L19 12v1.5c2.21 0 4 1.79 4 4m-4 1l2.25 2.25L19 23v-1.5c-2.21 0-4-1.79-4-4c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5Z"/>'
        },
        webcam: {
            body: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7a7 7 0 0 1-7 7a7 7 0 0 1-7-7a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3M6 22a2 2 0 0 1-2-2c0-.38.1-.73.29-1.03l1.82-3.16A9.007 9.007 0 0 0 12 18c2.25 0 4.31-.83 5.89-2.19l1.82 3.16c.19.3.29.65.29 1.03a2 2 0 0 1-2 2H6Z"/>'
        },
        "webcam-off": {
            body: '<path fill="currentColor" d="M12 6c1.66 0 3 1.34 3 3c0 .78-.3 1.5-.79 2L10 6.79c.5-.49 1.22-.79 2-.79m0-2c2.76 0 5 2.24 5 5c0 1.33-.53 2.53-1.38 3.42l1.42 1.42A6.945 6.945 0 0 0 19 9c0-3.87-3.13-7-7-7c-1.88 0-3.59.75-4.84 1.96l1.42 1.42C9.47 4.53 10.67 4 12 4m10.11 17.46l-1.27 1.27l-1.38-1.38c-.36.4-.88.65-1.46.65H6c-1.11 0-2-.89-2-2c0-.38.1-.73.29-1.03l1.82-3.16A9.007 9.007 0 0 0 12 18c1.21 0 2.37-.25 3.43-.68l-1.58-1.58c-.59.17-1.21.26-1.85.26c-3.87 0-7-3.13-7-7c0-.64.09-1.26.26-1.85L1.11 3l1.28-1.27l19.72 19.73M12.1 14L7 8.9V9c0 2.76 2.24 5 5 5h.1Z"/>'
        },
        webhook: {
            body: '<path fill="currentColor" d="M10.46 19C9 21.07 6.15 21.59 4.09 20.15c-2.05-1.44-2.53-4.31-1.09-6.4a4.585 4.585 0 0 1 3.58-1.98l.05 1.43c-.91.07-1.79.54-2.36 1.36c-1 1.44-.69 3.38.68 4.35c1.38.96 3.31.59 4.31-.84c.31-.45.49-.94.56-1.44v-1.01l5.58-.04l.07-.11c.53-.92 1.68-1.24 2.58-.72a1.9 1.9 0 0 1 .68 2.6c-.53.91-1.69 1.23-2.59.71c-.41-.23-.7-.6-.83-1.02l-4.07.02a4.96 4.96 0 0 1-.78 1.94m7.28-7.14c2.53.31 4.33 2.58 4.02 5.07c-.31 2.5-2.61 4.27-5.14 3.96a4.629 4.629 0 0 1-3.43-2.21l1.24-.72a3.22 3.22 0 0 0 2.32 1.45c1.75.21 3.3-.98 3.51-2.65c.21-1.67-1.03-3.2-2.76-3.41c-.54-.06-1.06.01-1.53.18l-.85.44l-2.58-4.77h-.22a1.906 1.906 0 0 1-1.85-1.95c.03-1.04.93-1.85 1.98-1.81c1.05.06 1.88.91 1.85 1.95c-.02.44-.19.84-.46 1.15l1.9 3.51c.62-.2 1.3-.27 2-.19M8.25 9.14c-1-2.35.06-5.04 2.37-6.02c2.32-.98 5 .13 6 2.48c.59 1.37.47 2.87-.2 4.07l-1.24-.72c.42-.81.49-1.8.09-2.73c-.68-1.6-2.49-2.37-4.04-1.72c-1.56.66-2.26 2.5-1.58 4.1c.28.66.75 1.17 1.32 1.51l.39.21l-3.07 4.99c.03.05.07.11.1.19c.49.91.15 2.06-.77 2.55c-.91.49-2.06.13-2.56-.81c-.49-.93-.15-2.08.77-2.57c.39-.21.82-.26 1.23-.17l2.31-3.77c-.47-.43-.87-.97-1.12-1.59Z"/>'
        },
        webpack: {
            body: '<path fill="currentColor" d="m20.45 17.39l-8.09 4.58V18.4l5.04-2.77l3.05 1.76m.55-.5V7.31L18.04 9v6.18L21 16.89m-17.45.5l8.09 4.57V18.4L6.6 15.63l-3.05 1.76m-.55-.5V7.31L5.96 9v6.18L3 16.89m.35-10.2L11.64 2v3.45L6.33 8.37l-.05.02l-2.93-1.7m17.3 0L12.36 2v3.45l5.31 2.93l.04.02l2.94-1.71m-9.01 10.9l-4.97-2.74V9.44l4.97 2.87v5.28m.72 0l4.97-2.73V9.44l-4.97 2.87v5.28M7 8.81l5-2.75l5 2.75l-5 2.88l-5-2.88Z"/>'
        },
        webrtc: {
            body: '<path fill="currentColor" d="M12 2c2.44 0 4.5 1.75 4.91 4.07l.84-.07c2.75 0 5 2.24 5 5a5 5 0 0 1-2.59 4.38a5.015 5.015 0 0 1-4.41 7.37A4.99 4.99 0 0 1 12 21.06a4.99 4.99 0 0 1-3.75 1.69c-2.75 0-5-2.25-5-5c0-.86.22-1.66.59-2.37A5 5 0 0 1 1.25 11c0-2.76 2.25-5 5-5l.84.07C7.5 3.75 9.56 2 12 2M6.75 20.25L13.66 17H17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h.77l-1.02 3.25Z"/>'
        },
        wechat: {
            body: '<path fill="currentColor" d="M9.5 4C5.36 4 2 6.69 2 10c0 1.89 1.08 3.56 2.78 4.66L4 17l2.5-1.5c.89.31 1.87.5 2.91.5A5.22 5.22 0 0 1 9 14c0-3.31 3.13-6 7-6c.19 0 .38 0 .56.03C15.54 5.69 12.78 4 9.5 4m-3 2.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m5 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M16 9c-3.31 0-6 2.24-6 5s2.69 5 6 5c.67 0 1.31-.08 1.91-.25L20 20l-.62-1.87C20.95 17.22 22 15.71 22 14c0-2.76-2.69-5-6-5m-2 2.5a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1Z"/>'
        },
        weight: {
            body: '<path fill="currentColor" d="M12 3a4 4 0 0 1 4 4c0 .73-.19 1.41-.54 2H18c.95 0 1.75.67 1.95 1.56C21.96 18.57 22 18.78 22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2c0-.22.04-.43 2.05-8.44C4.25 9.67 5.05 9 6 9h2.54A3.89 3.89 0 0 1 8 7a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2Z"/>'
        },
        "weight-gram": {
            body: '<path fill="currentColor" d="M19.95 10.56C19.75 9.67 18.95 9 18 9h-2.54c.35-.59.54-1.27.54-2a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 .73.19 1.41.54 2H6c-.95 0-1.75.67-1.95 1.56C2.04 18.57 2 18.78 2 19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2c0-.22-.04-.43-2.05-8.44M12 5a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m3 8h-4v4h2v-3h2v5h-4c-1.11 0-2-.89-2-2v-4c0-1.11.89-2 2-2h4v2Z"/>'
        },
        "weight-kilogram": {
            body: '<path fill="currentColor" d="M12 3a4 4 0 0 1 4 4c0 .73-.19 1.41-.54 2H18c.95 0 1.75.67 1.95 1.56C21.96 18.57 22 18.78 22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2c0-.22.04-.43 2.05-8.44C4.25 9.67 5.05 9 6 9h2.54A3.89 3.89 0 0 1 8 7a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-6 6v8h2v-2.5l1 1V19h2v-2l-2-2l2-2v-2H9v1.5l-1 1V11H6m9 0c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h3v-5h-2v3h-1v-4h3v-2h-3Z"/>'
        },
        "weight-lifter": {
            body: '<path fill="currentColor" d="M12 5c-1.11 0-2 .89-2 2s.89 2 2 2s2-.89 2-2s-.89-2-2-2m10-4v5h-2V4H4v2H2V1h2v2h16V1h2m-7 10.26V23h-2v-5h-2v5H9V11.26C6.93 10.17 5.5 8 5.5 5.5V5h2v.5C7.5 8 9.5 10 12 10s4.5-2 4.5-4.5V5h2v.5c0 2.5-1.43 4.67-3.5 5.76Z"/>'
        },
        "weight-pound": {
            body: '<path fill="currentColor" d="M12 3a4 4 0 0 1 4 4c0 .73-.19 1.41-.54 2H18c.95 0 1.75.67 1.95 1.56C21.96 18.57 22 18.78 22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2c0-.22.04-.43 2.05-8.44C4.25 9.67 5.05 9 6 9h2.54A3.89 3.89 0 0 1 8 7a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-6 6v8h5v-2H8v-6H6m7 0v8h3c1.11 0 2-.89 2-2v-.5c0-.57-.25-1.12-.68-1.5c.43-.38.68-.93.68-1.5V13c0-1.11-.89-2-2-2h-3m2 2h1v1h-1v-1m0 3h1v1h-1v-1Z"/>'
        },
        whatsapp: {
            body: '<path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18c.21-.58.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01Z"/>'
        },
        "wheel-barrow": {
            body: '<path fill="currentColor" d="M18 15.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5m0-1.5c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3M7 8L5 5H2v2h3.13L8 11.3V20h2l2.57-5h1.98c.7-1.19 1.95-2 3.45-2c.88 0 1.69.29 2.35.78L22 8H7m2.39 11H9v-6.2l.87 1.31c.36.53.95.85 1.58.89l-2.06 4Z"/>'
        },
        wheelchair: {
            body: '<path fill="currentColor" d="m14 16l1.32 1.76C14.32 19.68 12.31 21 10 21c-3.31 0-6-2.69-6-6c0-2.43 1.46-4.5 3.55-5.45l.21 2.17C6.71 12.44 6 13.63 6 15c0 2.21 1.79 4 4 4c1.86 0 3.41-1.28 3.86-3H14m5.55.11l-1.25.62L15.5 13h-4.59l-.2-2H14V9h-3.5l-.3-3c1.01-.12 1.8-.96 1.8-2a2 2 0 1 0-4 0v.1L9.1 15h5.4l3.2 4.27l2.75-1.37l-.9-1.79Z"/>'
        },
        "wheelchair-accessibility": {
            body: '<path fill="currentColor" d="m18.4 11.2l-4.1.2l2.3-2.6c.2-.3.3-.8.2-1.3c-.1-.3-.2-.6-.5-.8l-5.4-3.2c-.4-.3-1-.2-1.4.1L6.8 6.1c-.5.5-.6 1.2-.1 1.7c.4.5 1.2.5 1.7.1l2-1.8l1.9 1.1l-4.2 4.3c-.1.1-.1.2-.2.2c-.5.2-1 .4-1.4.7L8 13.9c.5-.2 1-.4 1.5-.4c1.9 0 3.5 1.6 3.5 3.5c0 .6-.1 1.1-.4 1.5l1.5 1.5c.6-.9.9-1.9.9-3c0-1.2-.4-2.4-1.1-3.3l3.3-.3l-.2 4.8c-.1.7.4 1.2 1.1 1.3h.1c.6 0 1.1-.5 1.2-1.1l.2-5.9c0-.3-.1-.7-.3-.9c-.3-.3-.6-.4-.9-.4M18 5.5a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m-5.5 16.1c-.9.6-1.9.9-3 .9C6.5 22.5 4 20 4 17c0-1.1.3-2.1.9-3l1.5 1.5c-.2.5-.4 1-.4 1.5c0 1.9 1.6 3.5 3.5 3.5c.6 0 1.1-.1 1.5-.4l1.5 1.5Z"/>'
        },
        whistle: {
            body: '<path fill="currentColor" d="M8.5 9A6.5 6.5 0 0 0 2 15.5A6.5 6.5 0 0 0 8.5 22a6.5 6.5 0 0 0 6.5-6.5v-1.59L22 12V9H11v2H9V9h-.5M11 2v5H9V2h2M6.35 7.28c-.67.16-1.31.4-1.92.72L2.14 4.88L3.76 3.7l2.59 3.58m11.51-2.4L16.32 7h-2.47l2.39-3.3l1.62 1.18Z"/>'
        },
        "whistle-outline": {
            body: '<path fill="currentColor" d="M3.76 3.7L2.14 4.88L4.43 8a8.23 8.23 0 0 1 1.92-.72M11 9v2h7v.29l-5 1.42v2.79A4.5 4.5 0 1 1 8.5 11H9V9h-.5a6.5 6.5 0 1 0 6.5 6.5v-1.59L22 12V9m-5.76-5.3L13.85 7h2.47l1.54-2.12M9 2v5h2V2Z"/>'
        },
        "white-balance-auto": {
            body: '<path fill="currentColor" d="m10.3 16l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9M22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.5 4 8 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9M6.85 12.65h2.3L8 9l-1.15 3.65Z"/>'
        },
        "white-balance-incandescent": {
            body: '<path fill="currentColor" d="m17.24 18.15l1.8 1.8l1.41-1.42l-1.79-1.79M20 12.5h3v-2h-3m-5-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5a6 6 0 0 0 6 6a6 6 0 0 0 6-6c0-2.22-1.21-4.15-3-5.19M4 10.5H1v2h3m7 9.95h2V19.5h-2m-7.45-.97l1.41 1.42l1.8-1.8l-1.42-1.41l-1.79 1.79Z"/>'
        },
        "white-balance-iridescent": {
            body: '<path fill="currentColor" d="m4.96 19.95l1.8-1.8l-1.42-1.41l-1.79 1.79m0-14.07l1.79 1.8l1.42-1.42l-1.8-1.79m15.49 15.48l-1.79-1.79l-1.42 1.41l1.8 1.8M13 22.45V19.5h-2v2.95h2m6.04-19.4l-1.8 1.79l1.42 1.42l1.79-1.8M11 3.5h2V.55h-2M5 14.5h14v-6H5v6Z"/>'
        },
        "white-balance-sunny": {
            body: '<path fill="currentColor" d="m3.55 19.09l1.41 1.41l1.8-1.79l-1.42-1.42M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6c0-3.32-2.69-6-6-6m8 7h3v-2h-3m-2.76 7.71l1.8 1.79l1.41-1.41l-1.79-1.8M20.45 5l-1.41-1.4l-1.8 1.79l1.42 1.42M13 1h-2v3h2M6.76 5.39L4.96 3.6L3.55 5l1.79 1.81l1.42-1.42M1 13h3v-2H1m12 9h-2v3h2"/>'
        },
        widgets: {
            body: '<path fill="currentColor" d="M3 3h8v4.34l5.66-5.65l5.65 5.65L16.66 13H21v8h-8v-8h3.66L11 7.34V11H3V3m0 10h8v8H3v-8Z"/>'
        },
        "widgets-outline": {
            body: '<path fill="currentColor" d="m16.7 4.5l2.8 2.8l-2.8 2.8l-2.8-2.8l2.8-2.8M9 5v4H5V5h4m10 10v4h-4v-4h4M16.7 1.7L11 7.3l5.7 5.7H13v8h8v-8h-4.3l5.6-5.7l-5.6-5.6M11 3H3v8h8V3M9 15v4H5v-4h4m2-2H3v8h8v-8Z"/>'
        },
        wifi: {
            body: '<path fill="currentColor" d="m12 21l3.6-4.8c-1-.75-2.25-1.2-3.6-1.2s-2.6.45-3.6 1.2L12 21m0-18C7.95 3 4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3l1.8-2.4C19.79 4.34 16.05 3 12 3m0 6c-2.7 0-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c2.03 0 3.9.67 5.4 1.8l1.8-2.4C17.19 9.89 14.7 9 12 9Z"/>'
        },
        "wifi-alert": {
            body: '<path fill="currentColor" d="M20.24 5H18v2.25A15.02 15.02 0 0 0 12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3c2.97 0 5.77.73 8.24 2M8.4 16.2L12 21l3.6-4.8c-1-.75-2.25-1.2-3.6-1.2s-2.6.45-3.6 1.2m-3.6-4.8l1.8 2.4C8.1 12.67 9.97 12 12 12s3.9.67 5.4 1.8l.6-.8v-2.38A11.867 11.867 0 0 0 12 9c-2.7 0-5.19.89-7.2 2.4M20 17h2v-2h-2v2m0-10v6h2V7h-2Z"/>'
        },
        "wifi-arrow-down": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m0 9c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m4.84-1.59c.34-.14.71-.24 1.08-.31l1.28-1.7C17.19 9.89 14.7 9 12 9s-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c1.78 0 3.44.5 4.84 1.41M20 16h-2v4h-2l3 3l3-3h-2v-4Z"/>'
        },
        "wifi-arrow-left": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m6 1l-3 3l3 3v-2h4v-2h-4v-2Z"/>'
        },
        "wifi-arrow-left-right": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m6 3.5L15 21l3 2.5V22h4v-2h-4v-1.5m5-1.5l-3-2.5V16h-4v2h4v1.5l3-2.5Z"/>'
        },
        "wifi-arrow-right": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m4.84 7.41c.34-.14.71-.24 1.08-.31l1.28-1.7C17.19 9.89 14.7 9 12 9s-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c1.78 0 3.44.5 4.84 1.41M12 15c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m11 4l-3-3v2h-4v2h4v2l3-3Z"/>'
        },
        "wifi-arrow-up": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m4 3h2v4h2v-4h2l-3-3l-3 3Z"/>'
        },
        "wifi-arrow-up-down": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m5 0l-2.5 3H16v4h2v-4h1.5L17 15m5 5v-4h-2v4h-1.5l2.5 3l2.5-3H22Z"/>'
        },
        "wifi-cancel": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m3.53 6.72c.89-.46 1.9-.72 2.97-.72h.24l.46-.6C17.19 9.89 14.7 9 12 9s-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c1.26 0 2.45.26 3.53.72M12 15c-1.35 0-2.6.45-3.6 1.2L12 21l.34-.46c-.21-.64-.34-1.32-.34-2.04c0-1.26.36-2.42 1-3.42c-.34-.05-.67-.08-1-.08m11 3.5c0 2.5-2 4.5-4.5 4.5S14 21 14 18.5s2-4.5 4.5-4.5s4.5 2 4.5 4.5m-3 2.58L15.92 17c-.27.42-.42.94-.42 1.5c0 1.66 1.34 3 3 3c.56 0 1.08-.15 1.5-.42m1.5-2.58c0-1.66-1.34-3-3-3c-.56 0-1.08.15-1.5.42L21.08 20c.27-.42.42-.94.42-1.5Z"/>'
        },
        "wifi-check": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m5.75 4.43l-1.59-1.59L15 19l2.75 3l4.75-4.75l-1.16-1.41l-3.59 3.59Z"/>'
        },
        "wifi-cog": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-.46.6c-1.08.05-2.11.33-3.01.81A8.92 8.92 0 0 0 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l.22-.29a6.91 6.91 0 0 1 .95-5.58c-.38-.08-.77-.13-1.17-.13m11.8 5.4c.1 0 .1.1 0 .2l-1 1.7c-.1.1-.2.1-.3.1l-1.2-.4c-.3.2-.5.3-.8.5l-.2 1.3c0 .1-.1.2-.2.2h-2c-.1 0-.2-.1-.3-.2l-.2-1.3c-.3-.1-.6-.3-.8-.5l-1.2.5c-.1 0-.2 0-.3-.1l-1-1.7c-.1-.1 0-.2.1-.3l1.1-.8v-1l-1.1-.8c-.1-.1-.1-.2-.1-.3l1-1.7c.1-.1.2-.1.3-.1l1.2.5c.3-.2.5-.3.8-.5l.2-1.3c0-.1.1-.2.3-.2h2c.1 0 .2.1.2.2l.2 1.3c.3.1.6.3.9.5l1.2-.5c.1 0 .3 0 .3.1l1 1.7c.1.1 0 .2-.1.3l-1.1.8v1l1.1.8M20.5 19c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5s.7 1.5 1.5 1.5s1.5-.7 1.5-1.5Z"/>'
        },
        "wifi-lock": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m5.4 4.29A11.976 11.976 0 0 0 4.8 11.4l1.8 2.4C8.1 12.67 9.97 12 12 12c.97 0 1.9.16 2.78.44c.56-.99 1.49-1.76 2.62-2.15m-9 5.91L12 21l1-1.33V17.2c0-.7.27-1.39.7-1.94A5.98 5.98 0 0 0 12 15c-1.35 0-2.6.45-3.6 1.2M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "wifi-lock-open": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m4.31 3.81A11.959 11.959 0 0 0 4.8 11.4l1.8 2.4a8.942 8.942 0 0 1 7.79-1.47a4.58 4.58 0 0 1 1.92-2.52M8.4 16.2L12 21l1-1.33V17.2c0-.7.27-1.39.7-1.94A5.98 5.98 0 0 0 12 15c-1.35 0-2.6.45-3.6 1.2m13.4-.2h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-marker": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m1 9.09c-.31-.06-.65-.09-1-.09c-1.35 0-2.6.45-3.6 1.2L12 21l1.8-2.4c-.47-1.02-.8-2.1-.8-3.1v-.41M12 9c-2.7 0-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c.73 0 1.43.09 2.1.25c.76-1 1.83-1.75 3.07-2.07A11.96 11.96 0 0 0 12 9m10 6.5c0 2.6-3.5 6.5-3.5 6.5S15 18.1 15 15.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5m-2.3.1c0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2s1.3-.6 1.2-1.2Z"/>'
        },
        "wifi-minus": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m3 3v2h8v-2h-8Z"/>'
        },
        "wifi-off": {
            body: '<path fill="currentColor" d="M2.28 3L1 4.27l1.47 1.47c-.43.26-.86.55-1.27.86L3 9c.53-.4 1.08-.75 1.66-1.07l2.23 2.23c-.74.34-1.45.75-2.09 1.24l1.8 2.4c.78-.58 1.66-1.03 2.6-1.33L11.75 15c-1.25.07-2.41.5-3.35 1.2L12 21l2.46-3.27L17.74 21L19 19.72M12 3c-2.15 0-4.2.38-6.1 1.07l2.39 2.4C9.5 6.16 10.72 6 12 6c3.38 0 6.5 1.11 9 3l1.8-2.4C19.79 4.34 16.06 3 12 3m0 6c-.38 0-.75 0-1.12.05l3.19 3.2c1.22.28 2.36.82 3.33 1.55l1.8-2.4C17.2 9.89 14.7 9 12 9Z"/>'
        },
        "wifi-plus": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m0 9c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m4.84-1.59c.34-.14.71-.24 1.08-.31l1.28-1.7C17.19 9.89 14.7 9 12 9s-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c1.78 0 3.44.5 4.84 1.41M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z"/>'
        },
        "wifi-refresh": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-.46.6h-.24c-1.07 0-2.08.26-2.97.72A8.978 8.978 0 0 0 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l.34-.46c-.21-.64-.34-1.32-.34-2.04c0-1.26.36-2.42 1-3.42c-.34-.05-.67-.08-1-.08m6-.5c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.68 0 3.12-1.03 3.71-2.5H20a2.5 2.5 0 1 1-.23-3.27L18 18.5h4v-4l-1.17 1.17A3.99 3.99 0 0 0 18 14.5Z"/>'
        },
        "wifi-remove": {
            body: '<path fill="currentColor" d="M12 12c-2.03 0-3.9.67-5.4 1.8l-1.8-2.4C6.81 9.89 9.3 9 12 9s5.19.89 7.2 2.4l-1.28 1.7c-.37.07-.74.17-1.08.31C15.44 12.5 13.78 12 12 12m9-3l1.8-2.4C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3m-9 6c-1.35 0-2.6.45-3.6 1.2L12 21l1.04-1.39c-.04-.2-.04-.4-.04-.61c0-1.34.44-2.57 1.19-3.57c-.69-.27-1.42-.43-2.19-.43m9.12.46L19 17.59l-2.12-2.12l-1.41 1.41L17.59 19l-2.12 2.12l1.41 1.42L19 20.41l2.12 2.13l1.42-1.42L20.41 19l2.13-2.12l-1.42-1.42Z"/>'
        },
        "wifi-settings": {
            body: '<path fill="currentColor" d="m12 20l-3.6-4.8c1-.75 2.25-1.2 3.6-1.2s2.6.45 3.6 1.2L12 20m-7.2-9.6l1.8 2.4C8.1 11.67 9.97 11 12 11s3.9.67 5.4 1.8l1.8-2.4C17.19 8.89 14.7 8 12 8s-5.19.89-7.2 2.4M12 2C7.95 2 4.21 3.34 1.2 5.6L3 8c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3l1.8-2.4C19.79 3.34 16.05 2 12 2M7 24h2v-2H7v2m8 0h2v-2h-2v2m-4 0h2v-2h-2v2Z"/>'
        },
        "wifi-star": {
            body: '<path fill="currentColor" d="M12 6C8.6 6 5.5 7.1 3 9L1.2 6.6C4.2 4.3 8 3 12 3c4 0 7.8 1.3 10.8 3.6L21 9c-2.5-1.9-5.6-3-9-3m1 13c0-1.3.4-2.6 1.2-3.6c-.7-.2-1.4-.4-2.2-.4c-1.3 0-2.6.5-3.6 1.2L12 21l1-1.4V19m3.8-5.6c.3-.1.7-.2 1.1-.3l1.3-1.7C17.2 9.9 14.7 9 12 9s-5.2.9-7.2 2.4l1.8 2.4C8.1 12.7 10 12 12 12c1.8 0 3.4.5 4.8 1.4m-.3 9.2l.7-2.8l-2.2-1.9l2.9-.2L19 15l1.1 2.6l2.9.2l-2.2 1.9l.7 2.8l-2.5-1.4l-2.5 1.5Z"/>'
        },
        "wifi-strength-1": {
            body: '<path fill="currentColor" d="M12 3C7.79 3 3.7 4.41.38 7C4.41 12.06 7.89 16.37 12 21.5c4.08-5.08 8.24-10.26 11.65-14.5C20.32 4.41 16.22 3 12 3m0 2c3.07 0 6.09.86 8.71 2.45l-5.1 6.36A8.432 8.432 0 0 0 12 13c-1.25 0-2.5.28-3.61.8L3.27 7.44C5.91 5.85 8.93 5 12 5Z"/>'
        },
        "wifi-strength-1-alert": {
            body: '<path fill="currentColor" d="M12 3C7.8 3 3.7 4.4.4 7c4 5.1 7.5 9.4 11.6 14.5c2.4-3 4.7-5.8 7-8.7V9.6l-3.4 4.2c-1.1-.5-2.4-.8-3.6-.8s-2.5.3-3.6.8L3.3 7.4C5.9 5.8 8.9 5 12 5s6.1.9 8.7 2.4l-.4.6h2.6c.2-.3.6-.7.8-1c-3.4-2.6-7.5-4-11.7-4m9 7v6h2v-6m-2 8v2h2v-2"/>'
        },
        "wifi-strength-1-lock": {
            body: '<path fill="currentColor" d="M12 13c.8 0 1.61.13 2.38.36c-.1.37-.18.75-.18 1.14v.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4l-2.73 3.39c-.59-.25-1.23-.39-1.91-.39c-.13 0-.25.03-.38.04l2.08-2.59C18.08 5.86 15.06 5 12 5s-6.1.85-8.74 2.44l5.12 6.36c1.12-.52 2.36-.8 3.62-.8m11 4.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "wifi-strength-1-lock-open": {
            body: '<path fill="currentColor" d="M12 13c.74 0 1.5.12 2.22.31c0 .07-.02.13-.02.19v1.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4L21.5 9.69a5.22 5.22 0 0 0-2.08-.65l1.28-1.59C18.08 5.86 15.06 5 12 5s-6.1.85-8.74 2.44l5.12 6.36c1.12-.52 2.36-.8 3.62-.8m9.8 3h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-strength-2": {
            body: '<path fill="currentColor" d="M12 3C7.79 3 3.7 4.41.38 7C4.41 12.06 7.89 16.37 12 21.5c4.08-5.08 8.24-10.26 11.65-14.5C20.32 4.41 16.22 3 12 3m0 2c3.07 0 6.09.86 8.71 2.45l-3.21 3.98C16.26 10.74 14.37 10 12 10c-2.38 0-4.26.75-5.5 1.43L3.27 7.44C5.91 5.85 8.93 5 12 5Z"/>'
        },
        "wifi-strength-2-alert": {
            body: '<path fill="currentColor" d="M12 3C7.8 3 3.7 4.4.4 7c4 5.1 7.5 9.4 11.6 14.5c2.4-3 4.7-5.8 7-8.7V9.6l-1.5 1.8c-1.2-.7-3.1-1.4-5.5-1.4s-4.3.8-5.5 1.4l-3.2-4C5.9 5.8 8.9 5 12 5s6.1.9 8.7 2.4l-.4.6h2.6c.2-.3.6-.7.8-1c-3.4-2.6-7.5-4-11.7-4m9 7v6h2v-6m-2 8v2h2v-2"/>'
        },
        "wifi-strength-2-lock": {
            body: '<path fill="currentColor" d="M14.2 14.5v.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4l-2.73 3.39c-.59-.25-1.23-.39-1.91-.39c-.13 0-.26.03-.39.04l2.09-2.59C18.08 5.86 15.06 5 12 5s-6.1.85-8.74 2.44l3.24 3.99C7.73 10.75 9.61 10 12 10c1.68 0 3.12.38 4.26.84c-1.23.83-2.06 2.16-2.06 3.66m8.8 2.8v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "wifi-strength-2-lock-open": {
            body: '<path fill="currentColor" d="M15.44 10.55c-.76.8-1.24 1.83-1.24 2.95v1.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4L21.5 9.69c-.64-.36-1.34-.59-2.09-.65l1.29-1.59C18.08 5.86 15.06 5 12 5s-6.1.85-8.74 2.44l3.24 3.99C7.73 10.75 9.61 10 12 10c1.29 0 2.45.23 3.44.55M21.8 16h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-strength-3": {
            body: '<path fill="currentColor" d="M12 3C7.79 3 3.7 4.41.38 7C4.41 12.06 7.89 16.37 12 21.5c4.08-5.08 8.24-10.26 11.65-14.5C20.32 4.41 16.22 3 12 3m0 2c3.07 0 6.09.86 8.71 2.45l-1.94 2.43C17.26 9 14.88 8 12 8C9 8 6.68 9 5.21 9.84l-1.94-2.4C5.91 5.85 8.93 5 12 5Z"/>'
        },
        "wifi-strength-3-alert": {
            body: '<path fill="currentColor" d="M12 3C7.8 3 3.7 4.4.4 7c4 5.1 7.5 9.4 11.6 14.5c2.4-3 4.7-5.8 7-8.7V9.6l-.2.3C17.3 9 14.9 8 12 8C9 8 6.7 9 5.2 9.8L3.3 7.4C5.9 5.8 8.9 5 12 5s6.1.9 8.7 2.4l-.4.6h2.6c.2-.3.6-.7.8-1c-3.4-2.6-7.5-4-11.7-4m9 7v6h2v-6m-2 8v2h2v-2"/>'
        },
        "wifi-strength-3-lock": {
            body: '<path fill="currentColor" d="M19 10c.68 0 1.32.14 1.91.39L23.64 7C20.31 4.41 16.2 3 12 3C7.78 3 3.69 4.41.365 7C4.39 12.06 7.88 16.37 12 21.5l1-1.26V17.2c0-.96.5-1.86 1.2-2.46v-.24c0-2.44 2.2-4.5 4.8-4.5m-7-2C9 8 6.67 9 5.2 9.84l-1.94-2.4C5.9 5.85 8.91 5 12 5s6.08.86 8.7 2.45l-1.94 2.43C17.25 9 14.87 8 12 8m9.8 8v-1.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3m-1.3 0h-3v-1.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V16Z"/>'
        },
        "wifi-strength-3-lock-open": {
            body: '<path fill="currentColor" d="M14.2 13.5v1.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4L21.5 9.69a5.17 5.17 0 0 0-2.08-.65l1.28-1.59C18.08 5.86 15.06 5 12 5s-6.1.85-8.74 2.44l1.94 2.4C6.67 9 9 8 12 8c2.18 0 4.08.58 5.53 1.25c-1.9.6-3.33 2.29-3.33 4.25m7.6 2.5h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-strength-4": {
            body: '<path fill="currentColor" d="M12 3C7.79 3 3.7 4.41.38 7C4.41 12.06 7.89 16.37 12 21.5c4.08-5.08 8.24-10.26 11.65-14.5C20.32 4.41 16.22 3 12 3Z"/>'
        },
        "wifi-strength-4-alert": {
            body: '<path fill="currentColor" d="M12 3C7.8 3 3.7 4.4.4 7c4 5.1 7.5 9.4 11.6 14.5c2.4-3 4.7-5.8 7-8.7V8h3.8c.2-.3.6-.7.8-1c-3.3-2.6-7.4-4-11.6-4m9 7v6h2v-6m-2 8v2h2v-2"/>'
        },
        "wifi-strength-4-lock": {
            body: '<path fill="currentColor" d="M14.2 14.5v.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4l-2.73 3.39c-.59-.25-1.23-.39-1.91-.39c-2.6 0-4.8 2.06-4.8 4.5m8.8 2.8v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "wifi-strength-4-lock-open": {
            body: '<path fill="currentColor" d="M14.2 13.5v1.24c-.7.6-1.2 1.5-1.2 2.46v3.04l-1 1.26C7.88 16.37 4.39 12.06.365 7C3.69 4.41 7.78 3 12 3c4.2 0 8.31 1.41 11.64 4L21.5 9.69C20.75 9.26 19.9 9 19 9c-2.6 0-4.8 2.06-4.8 4.5m7.6 2.5h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-strength-alert-outline": {
            body: '<path fill="currentColor" d="M12 3C7.8 3 3.7 4.4.4 7c3.9 4.8 7.8 9.7 11.6 14.5c2.3-2.9 4.7-5.8 7-8.7V9.6l-7 8.7L3.3 7.4C5.9 5.8 8.9 5 12 5c3.1 0 6.1.9 8.7 2.4l-.4.6h2.6c.3-.3.5-.7.8-1c-3.4-2.6-7.5-4-11.7-4m9 7v6h2v-6m-2 8v2h2v-2"/>'
        },
        "wifi-strength-lock-open-outline": {
            body: '<path fill="currentColor" d="M23.65 7h-.01c-.72.9-1.44 1.79-2.14 2.69c-.63-.36-1.33-.58-2.07-.65l1.28-1.59A16.824 16.824 0 0 0 12 5c-3.09 0-6.1.85-8.73 2.44L12 18.3l1-1.3v3.25l-1 1.25C8.13 16.66 4.24 11.83.355 7h.02A18.92 18.92 0 0 1 12 3c4.22 0 8.32 1.41 11.65 4m-1.85 9h-4.3v-2.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3v.5h1.3v-.5c0-1.4-1.4-2.5-2.8-2.5s-2.8 1.1-2.8 2.5V16c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3Z"/>'
        },
        "wifi-strength-lock-outline": {
            body: '<path fill="currentColor" d="M23.65 7h-.01l-2.73 3.39c-.59-.25-1.23-.39-1.91-.39c-.13 0-.25.03-.37.04l2.08-2.59A16.824 16.824 0 0 0 12 5c-3.09 0-6.1.85-8.73 2.44L12 18.3l1-1.3v3.25l-1 1.25C8.13 16.66 4.24 11.83.355 7h.02A18.92 18.92 0 0 1 12 3c4.22 0 8.32 1.41 11.65 4M23 17.3v3.5c0 .6-.6 1.2-1.3 1.2h-5.5c-.6 0-1.2-.6-1.2-1.3v-3.5c0-.6.6-1.2 1.2-1.2v-1.5c0-1.4 1.4-2.5 2.8-2.5s2.8 1.1 2.8 2.5V16c.6 0 1.2.6 1.2 1.3m-2.5-2.8c0-.8-.7-1.3-1.5-1.3s-1.5.5-1.5 1.3V16h3v-1.5Z"/>'
        },
        "wifi-strength-off": {
            body: '<path fill="currentColor" d="M3.27 1.44L2 2.72l2.05 2.05C2.75 5.37 1.5 6.11.38 7C4.41 12.06 12 21.5 12 21.5l3.91-4.87l3.32 3.32l1.27-1.27M12 3c-1.4 0-2.79.17-4.14.5l10.32 10.31C20 11.5 22.05 9 23.65 7C20.32 4.41 16.22 3 12 3Z"/>'
        },
        "wifi-strength-off-outline": {
            body: '<path fill="currentColor" d="M3.27 1.44L2 2.72l2.05 2.05C2.75 5.37 1.5 6.11.38 7C4.2 11.8 8.14 16.67 12 21.5l3.91-4.87l3.32 3.32l1.27-1.27C14.87 13.04 3.27 1.44 3.27 1.44M12 3c-1.4 0-2.79.17-4.14.5l1.7 1.69C10.37 5.07 11.18 5 12 5c3.07 0 6.09.86 8.71 2.45l-3.95 4.93l1.42 1.42C20.08 11.43 22 9 23.65 7C20.32 4.41 16.22 3 12 3M5.57 6.29l8.93 8.92L12 18.3L3.27 7.44C4 7 4.78 6.61 5.57 6.29Z"/>'
        },
        "wifi-strength-outline": {
            body: '<path fill="currentColor" d="M12 3C7.79 3 3.7 4.41.38 7H.36C4.24 11.83 8.13 16.66 12 21.5c3.89-4.84 7.77-9.67 11.64-14.5h.01C20.32 4.41 16.22 3 12 3m0 2c3.07 0 6.09.86 8.71 2.45L12 18.3L3.27 7.44C5.9 5.85 8.92 5 12 5Z"/>'
        },
        "wifi-sync": {
            body: '<path fill="currentColor" d="M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3s7.79 1.34 10.8 3.6L21 9c-2.5-1.88-5.62-3-9-3m0 9c-1.35 0-2.6.45-3.6 1.2L12 21l1.26-1.68A6.84 6.84 0 0 1 13 17.5c0-.81.16-1.59.43-2.31c-.46-.11-.93-.19-1.43-.19m3.23-2.39a6.5 6.5 0 0 1 3.47-1.56A11.92 11.92 0 0 0 12 9c-2.7 0-5.19.89-7.2 2.4l1.8 2.4a8.942 8.942 0 0 1 8.63-1.19M19 20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20m0-6.5V12l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4Z"/>'
        },
        wikipedia: {
            body: '<path fill="currentColor" d="m14.97 18.95l-2.56-6.03c-1.02 1.99-2.14 4.08-3.1 6.03c-.01.01-.47 0-.47 0C7.37 15.5 5.85 12.1 4.37 8.68C4.03 7.84 2.83 6.5 2 6.5v-.45h5.06v.45c-.6 0-1.62.4-1.36 1.05c.72 1.54 3.24 7.51 3.93 9.03c.47-.94 1.8-3.42 2.37-4.47c-.45-.88-1.87-4.18-2.29-5c-.32-.54-1.13-.61-1.75-.61c0-.15.01-.25 0-.44l4.46.01v.4c-.61.03-1.18.24-.92.82c.6 1.24.95 2.13 1.5 3.28c.17-.34 1.07-2.19 1.5-3.16c.26-.65-.13-.91-1.21-.91c.01-.12.01-.33.01-.43c1.39-.01 3.48-.01 3.85-.02v.42c-.71.03-1.44.41-1.82.99L13.5 11.3c.18.51 1.96 4.46 2.15 4.9l3.85-8.83c-.3-.72-1.16-.87-1.5-.87v-.45l4 .03v.42c-.88 0-1.43.5-1.75 1.25c-.8 1.79-3.25 7.49-4.85 11.2h-.43Z"/>'
        },
        "wind-power": {
            body: '<path fill="currentColor" d="M4 3h6v2H4V3M1 7h5v2H1V7m2 12h5v2H3v-2m10.73-8.39c.77.23 1.3.78 1.57 1.46l4.27-7.11c.65-1.08.3-2.46-.78-3.13c-.87-.52-1.99-.41-2.73.29l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.93c.36-.15 1-.33 1.73-.1m-3.12 1.66c.16-.52.48-.96.89-1.27H3.28C2 11 1 12 1 13.28c0 1.02.67 1.91 1.65 2.19l4.51 1.29c.53.15 1.1.08 1.58-.21l2.69-1.61a2.487 2.487 0 0 1-.82-2.67m11.6 6.34l-2.28-4.11a2.07 2.07 0 0 0-1.26-.96l-3.17-.8c0 .32 0 .66-.11.99A2.478 2.478 0 0 1 13 15.5c-.61 0-1-.22-1-.22V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.89.89 2.33.89 3.22 0c.72-.72.88-1.83.38-2.72m-9.65-4.18c.79.24 1.63-.2 1.87-1c.24-.79-.2-1.63-1-1.87c-.79-.24-1.63.2-1.87 1c-.24.79.21 1.63 1 1.87Z"/>'
        },
        "wind-power-outline": {
            body: '<path fill="currentColor" d="M4 3h6v2H4V3M1 7h5v2H1V7m2 12h5v2H3v-2m19.21-.39l-2.28-4.11a2.07 2.07 0 0 0-1.26-.96L16 12.87c-.04-.47-.16-.92-.39-1.33l3.96-6.59c.65-1.08.3-2.48-.78-3.13a2.288 2.288 0 0 0-2.73.3l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.4c-.47.17-.89.45-1.23.82H3.28C2 11 1 12 1 13.28c0 1.02.67 1.91 1.65 2.19l4.51 1.29c.18.05.37.08.55.08c.36 0 .72-.1 1.03-.29L11 15.21c.27.26.61.47 1 .61V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.45.45 1.03.67 1.61.67s1.17-.22 1.61-.67c.72-.72.88-1.83.38-2.72M7.72 14.84L3.2 13.55c-.12-.05-.2-.15-.2-.27c0-.15.13-.28.28-.28H10c0 .15 0 .3.04.44l-2.32 1.4M13 14c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m1-3.86V6.78l3.43-3.21c.07-.07.19-.12.34-.04c.13.08.18.25.1.38l-3.74 6.24l-.13-.01m6.42 9.78c-.05.05-.24.16-.42 0l-4.83-4.85c.08-.07.16-.18.24-.28l2.78.71l2.28 4.08c.06.11.03.25-.05.34Z"/>'
        },
        "wind-turbine": {
            body: '<path fill="currentColor" d="m13.33 11.67l2.88 2.91c1.41-1.42 0-2.83 0-2.83l-1.49-1.51c.18-.38.28-.8.28-1.24c0-1.05-.54-1.97-1.36-2.5L15 2.11c-1.91-.58-2.5 1.33-2.5 1.33l-.81 2.59c-1.23.13-2.23.97-2.56 2.15L4.67 9.63c.64 1.9 2.53 1.27 2.53 1.27l2.07-.67c.34.74.96 1.31 1.73 1.59V19s-2 0-2 2v1h6v-1s0-2-2-2v-7.18c.12-.04.23-.1.33-.15M10.5 9A1.5 1.5 0 0 1 12 7.5A1.5 1.5 0 0 1 13.5 9a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 10.5 9Z"/>'
        },
        "wind-turbine-alert": {
            body: '<path fill="currentColor" d="m12.33 11.67l2.88 2.91c1.41-1.42 0-2.83 0-2.83l-1.49-1.51c.18-.38.28-.8.28-1.24c0-1.05-.54-1.97-1.36-2.5L14 2.11c-1.91-.58-2.5 1.33-2.5 1.33l-.81 2.59c-1.23.13-2.23.97-2.56 2.15L3.67 9.63c.64 1.9 2.53 1.27 2.53 1.27l2.07-.67c.34.74.96 1.31 1.73 1.59V19s-2 0-2 2v1h6v-1s0-2-2-2v-7.18c.12-.04.23-.1.33-.15M9.5 9c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S9.5 9.83 9.5 9m8.5 3V7h2v6h-2m0 4v-2h2v2h-2Z"/>'
        },
        "wind-turbine-check": {
            body: '<path fill="currentColor" d="m11.33 11.67l2.88 2.91c1.41-1.42 0-2.83 0-2.83l-1.49-1.51c.18-.38.28-.8.28-1.24c0-1.05-.54-1.97-1.36-2.5L13 2.11c-1.91-.58-2.5 1.33-2.5 1.33l-.81 2.59c-1.23.13-2.23.97-2.56 2.15L2.67 9.63c.64 1.9 2.53 1.27 2.53 1.27l2.07-.67c.34.74.96 1.31 1.73 1.59V19s-2 0-2 2v1h6v-1s0-2-2-2v-7.18c.12-.04.23-.1.33-.15M8.5 9c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S8.5 9.83 8.5 9m8.25 12.16l-2.75-3L15.16 17l1.59 1.59L20.34 15l1.16 1.41l-4.75 4.75"/>'
        },
        "window-close": {
            body: '<path fill="currentColor" d="M13.46 12L19 17.54V19h-1.46L12 13.46L6.46 19H5v-1.46L10.54 12L5 6.46V5h1.46L12 10.54L17.54 5H19v1.46L13.46 12Z"/>'
        },
        "window-closed": {
            body: '<path fill="currentColor" d="M6 11h4V9h4v2h4V4H6v7m12 2H6v7h12v-7M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>'
        },
        "window-closed-variant": {
            body: '<path fill="currentColor" d="M21 20V2H3v18H1v3h22v-3M19 4v7h-6V4M5 4h6v7H5m0 9v-7h6v7m2 0v-7h6v7Z"/>'
        },
        "window-checkered": {
            body: '<path fill="currentColor" d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 11H13V4H20V11ZM11 4V11H4V4H11ZM4 13H11V20H4V13ZM13 20V13H20V20H13Z"/>'
        },
        "window-maximize": {
            body: '<path fill="currentColor" d="M4 4h16v16H4V4m2 4v10h12V8H6Z"/>'
        },
        "window-minimize": {
            body: '<path fill="currentColor" d="M20 14H4v-4h16"/>'
        },
        "window-open": {
            body: '<path fill="currentColor" d="M6 8h4V6h4v2h4V4H6v4m12 2H6v5h12v-5M6 20h12v-3H6v3M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"/>'
        },
        "window-open-variant": {
            body: '<path fill="currentColor" d="M21 20V2H3v18H1v3h22v-3M19 4v7h-2V4M5 4h2v7H5m0 9v-7h2v7m2 0V4h6v16m2 0v-7h2v7Z"/>'
        },
        "window-restore": {
            body: '<path fill="currentColor" d="M4 8h4V4h12v12h-4v4H4V8m12 0v6h2V6h-8v2h6M6 12v6h8v-6H6Z"/>'
        },
        "window-shutter": {
            body: '<path fill="currentColor" d="M3 4h18v4h-2v12h-2V8H7v12H5V8H3V4m5 5h8v2H8V9m0 3h8v2H8v-2m0 3h8v2H8v-2m0 3h8v2H8v-2Z"/>'
        },
        "window-shutter-alert": {
            body: '<path fill="currentColor" d="M2 4h18v4h-2v12h-2V8H6v12H4V8H2V4m5 5h8v2H7V9m0 3h8v2H7v-2m13 7v-2h2v2h-2m0-4v-5h2v5h-2Z"/>'
        },
        "window-shutter-auto": {
            body: '<path fill="currentColor" d="M20 14h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L20 14m-2.2 5.7L19 16l1.2 3.7h-2.4M7 9h8v2H7V9m0 3h8v2H7v-2m0 3h8v1.5l-.2.5H7v-2m6.7 5H7v-2h7.5l-.8 2M16 8H6v12H4V8H2V4h18v4h-2v4h-1.4l-.5 1.3l-.1.4V8Z"/>'
        },
        "window-shutter-cog": {
            body: '<path fill="currentColor" d="M21.7 18.6v-1l1.1-.8c.1-.1.2-.2.1-.3l-1-1.7c0-.1-.2-.1-.3-.1l-1.2.5c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.2-.2h-2c-.2 0-.3.1-.3.2l-.2 1.3c-.3.2-.5.3-.8.5l-1.2-.5c-.1 0-.2 0-.3.1l-1 1.7c0 .1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.1-.2.2-.1.3l1 1.7c.1.1.2.1.3.1l1.2-.5c.2.2.5.4.8.5l.2 1.3c.1.1.2.2.3.2h2c.1 0 .2-.1.2-.2l.2-1.3c.3-.2.5-.3.8-.5l1.2.4c.1 0 .2 0 .3-.1l1-1.7c.1-.1.1-.2 0-.2l-1.1-.8m-3.7.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5M8 9h8v2H8V9m9-1H7v12H5V8H3V4h18v4h-2v3.1c-.3 0-.7-.1-1-.1s-.7 0-1 .1V8m-5.7 12H8v-2h3c0 .7.1 1.4.3 2M8 12h6.4c-.8.5-1.6 1.2-2.1 2H8v-2m0 3h3.7c-.3.6-.5 1.3-.6 2H8v-2Z"/>'
        },
        "window-shutter-open": {
            body: '<path fill="currentColor" d="M3 4h18v4h-2v12h-2V8H7v12H5V8H3V4m5 5h8v2H8V9Z"/>'
        },
        "window-shutter-settings": {
            body: '<path fill="currentColor" d="M3 4h18v4h-2v12h-2V8H7v12H5V8H3V4m5 5h8v2H8V9m0 3h8v2H8v-2m0 3h8v2H8v-2m0 3h8v2H8v-2m5 4h-2v2h2v-2m4 0h-2v2h2v-2m-8 0H7v2h2v-2Z"/>'
        },
        windsock: {
            body: '<path fill="currentColor" d="M7 5v8l15-2V7L7 5m3 1.91l3 .4v3.38l-3 .4V6.91m6 .8l3 .4v1.78l-3 .4V7.71M5 10v1h1v1H5v9H3V4c0-.55.45-1 1-1s1 .45 1 1v2h1v1H5v3Z"/>'
        },
        wiper: {
            body: '<path fill="currentColor" d="M12 4C5 4 2 9 2 9l7 7s.5-.9 1.4-1.5l.3 2c-.4.3-.7.9-.7 1.5a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.9-.5-1.6-1.3-1.9l-.4-2.1c1.8.2 2.7 2 2.7 2l7-7s-3-5-10-5m3.1 9.1c-.8-.6-1.8-1.1-3.1-1.1l-1-5.9c.3-.1.7-.1 1-.1c3.7 0 6.1 1.7 7.3 2.9l-4.2 4.2m-6.2 0L4.7 8.9C5.5 8 7 7 9 6.4l1 6c-.4.2-.8.4-1.1.7Z"/>'
        },
        "wiper-wash": {
            body: '<path fill="currentColor" d="M13 6c0-.3.1-1.4.8-2.2L12 2.4l-1.8 1.5c.7.7.8 1.8.8 2.1c-6.3.4-9 5-9 5l7 7s.7-1.3 2-1.8v2.1c-.6.3-1 1-1 1.7a2 2 0 0 0 2 2a2 2 0 0 0 2-2c0-.7-.4-1.4-1-1.7v-2.1c1.3.5 2 1.8 2 1.8l7-7s-2.7-4.5-9-5m-2 8.1c-.8.2-1.5.5-2.1 1l-4.2-4.2C5.8 9.8 7.8 8.3 11 8.1v6m4.1 1c-.6-.4-1.3-.8-2.1-1v-6c3.2.3 5.2 1.7 6.3 2.8l-4.2 4.2M18 1.3l-.7 1.9c-.7-.3-1.8-.3-2.6 0L14 1.3c1.2-.4 2.8-.4 4 0M21 6h-2s0-1.3-.8-2.1l1.5-1.3C21 4 21 5.9 21 6M4.2 2.6l1.5 1.3C5 4.7 5 6 5 6H3c0-.1 0-2 1.2-3.4M10 1.3l-.7 1.9c-.7-.3-1.8-.3-2.6 0L6 1.3c1.2-.4 2.8-.4 4 0Z"/>'
        },
        "wiper-wash-alert": {
            body: '<path fill="currentColor" d="M11 6c0-.3.1-1.4.8-2.2L10 2.4L8.2 3.9c.7.7.8 1.8.8 2.1c-6.3.4-9 5-9 5l7 7s.7-1.3 2-1.8v2.1c-.6.3-1 1-1 1.7a2 2 0 1 0 4 0c0-.7-.4-1.4-1-1.7v-2.1c1.3.5 2 1.8 2 1.8l7-7s-2.7-4.5-9-5m-2 8.1c-.8.2-1.5.5-2.1 1l-4.2-4.2C3.8 9.8 5.8 8.3 9 8.1v6m4.1 1c-.6-.4-1.3-.8-2.1-1v-6c3.2.3 5.2 1.7 6.3 2.8l-4.2 4.2M16 1.3l-.7 1.9c-.7-.3-1.8-.3-2.6 0L12 1.3c1.2-.4 2.8-.4 4 0M19 6h-2s0-1.3-.8-2.1l1.5-1.3C19 4 19 5.9 19 6M2.2 2.6l1.5 1.3C3 4.7 3 6 3 6H1c0-.1 0-2 1.2-3.4M8 1.3l-.7 1.9c-.7-.3-1.8-.3-2.6 0L4 1.3c1.2-.4 2.8-.4 4 0M22 12V7h2v6h-2m0 4h2v-2h-2"/>'
        },
        "wizard-hat": {
            body: '<path fill="currentColor" d="M21 22H3v-2h18v2m-2-3H5l6.1-16.4c.2-.4.5-.6.9-.6l6 3h-4.1L19 19M10 7.5l1.04.47L11.5 9l.47-1.03L13 7.5l-1.03-.47L11.5 6l-.46 1.03L10 7.5m3 7.5l-2.06-.93L10 12l-.93 2.07L7 15l2.07.93L10 18l.94-2.07L13 15m.97-3.03L15 11.5l-1.03-.47L13.5 10l-.46 1.03l-1.04.47l1.04.47l.46 1.03l.47-1.03m2 4L17 15.5l-1.03-.47L15.5 14l-.46 1.03l-1.04.47l1.04.47l.46 1.03l.47-1.03Z"/>'
        },
        wordpress: {
            body: '<path fill="currentColor" d="M3.42 12c0-1.24.27-2.42.74-3.5l4.1 11.22A8.563 8.563 0 0 1 3.42 12m14.37-.43c0 .73-.29 1.58-.65 2.77l-.86 2.86l-3.1-9.2l.98-.1c.47-.06.41-.74-.05-.71c0 0-1.39.11-2.29.11l-2.26-.11c-.46-.03-.51.68-.06.71l.91.1l1.34 3.64l-1.88 5.63L6.74 8l.99-.1c.46-.06.4-.74-.06-.71c0 0-1.39.11-2.29.11l-.55-.01C6.37 4.96 9 3.42 12 3.42c2.23 0 4.27.86 5.79 2.25h-.11c-.84 0-1.44.73-1.44 1.52c0 .71.41 1.31.84 2.01c.33.57.71 1.3.71 2.37m-5.64 1.18l2.64 7.22l.06.12c-.89.32-1.85.49-2.85.49c-.84 0-1.65-.12-2.42-.35l2.57-7.48m7.38-4.87A8.548 8.548 0 0 1 20.58 12c0 3.16-1.72 5.93-4.27 7.41l2.62-7.57c.49-1.22.66-2.2.66-3.07l-.06-.89M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 19.54c5.26 0 9.54-4.28 9.54-9.54c0-5.26-4.28-9.54-9.54-9.54c-5.26 0-9.54 4.28-9.54 9.54c0 5.26 4.28 9.54 9.54 9.54Z"/>'
        },
        wrap: {
            body: '<path fill="currentColor" d="M21 5H3v2h18V5M3 19h7v-2H3v2m0-6h15c1 0 2 .43 2 2s-1 2-2 2h-2v-2l-4 3l4 3v-2h2c2.95 0 4-1.27 4-4c0-2.72-1-4-4-4H3v2Z"/>'
        },
        "wrap-disabled": {
            body: '<path fill="currentColor" d="M16 7H3V5h13v2M3 19h13v-2H3v2m19-7l-4-3v2H3v2h15v2l4-3Z"/>'
        },
        wrench: {
            body: '<path fill="currentColor" d="m22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9c-2-2-5-2.4-7.4-1.3L9 6L6 9L1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4Z"/>'
        },
        "wrench-check": {
            body: '<path fill="currentColor" d="M9 2c1.8.6 3 2.3 3 4.2c0 2-1.2 3.7-3 4.3v11c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.6v-11c-1.8-.6-3-2.3-3-4.2S4.2 2.6 6 2v3.7h3V2m11.6 11l1.4 1.41L15.47 21L12 17.5l1.4-1.41l2.07 2.08L20.6 13"/>'
        },
        "wrench-check-outline": {
            body: '<path fill="currentColor" d="M9 1.09V6H7V1.09C4.16 1.57 2 4.03 2 7c0 2.22 1.21 4.15 3 5.19V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8.81c1.79-1.04 3-2.97 3-5.19c0-2.97-2.16-5.43-5-5.91m1 9.37l-1 .58V20H7v-8.96l-1-.58C4.77 9.74 4 8.42 4 7c0-1 .37-1.94 1-2.65V8h6V4.35c.63.71 1 1.65 1 2.65c0 1.42-.77 2.74-2 3.46M21.6 13l1.4 1.41L16.47 21L13 17.5l1.4-1.41l2.07 2.08L21.6 13"/>'
        },
        "wrench-clock": {
            body: '<path fill="currentColor" d="M10 6.2C10 4.3 8.8 2.6 7 2v3.7H4V2c-1.8.6-3 2.3-3 4.2c0 1.9 1.2 3.6 3 4.2v11c0 .4.2.6.5.6h2c.3 0 .5-.2.5-.5v-11c1.8-.6 3-2.3 3-4.3M16 8s-.1 0 0 0c-3.9.1-7 3.2-7 7c0 3.9 3.1 7 7 7s7-3.1 7-7s-3.1-7-7-7m0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m-1-9v5l3.6 2.2l.8-1.2l-2.9-1.7V11H15Z"/>'
        },
        "wrench-clock-outline": {
            body: '<path fill="currentColor" d="M16 8a7.3 7.3 0 0 0-3.32.89c.2-.6.32-1.23.32-1.89c0-2.97-2.16-5.43-5-5.91V6H6V1.09C3.16 1.57 1 4.03 1 7c0 2.22 1.21 4.15 3 5.19V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2.38A6.956 6.956 0 0 0 16 22c3.9 0 7-3.1 7-7s-3.1-7-7-7m-8 3.04V20H6v-8.96l-1-.58C3.77 9.74 3 8.42 3 7c0-1 .37-1.94 1-2.65V8h6V4.35c.63.71 1 1.65 1 2.65c0 1.42-.77 2.74-2 3.46l-1 .58M16 20c-2.8 0-5-2.2-5-5s2.2-5 5-5s5 2.2 5 5s-2.2 5-5 5m.5-4.7l2.9 1.7l-.8 1.2L15 16v-5h1.5v4.3Z"/>'
        },
        "wrench-cog": {
            body: '<path fill="currentColor" d="M19.94 17.94a3.253 3.253 0 0 0 0-.89l.97-.73a.22.22 0 0 0 .06-.29l-.92-1.56c-.05-.1-.19-.14-.29-.1l-1.15.45c-.24-.17-.49-.32-.78-.44l-.17-1.19a.235.235 0 0 0-.23-.19h-1.85c-.12 0-.22.08-.24.19l-.17 1.19c-.29.12-.54.27-.78.44l-1.15-.45c-.1-.04-.24 0-.28.1l-.93 1.56c-.06.1-.03.22.06.29l.97.73c-.01.15-.03.3-.03.45s.02.29.03.44l-.97.74a.22.22 0 0 0-.06.29l.93 1.56c.04.1.18.13.28.1l1.15-.46c.24.18.49.33.78.45l.17 1.19c.02.11.12.19.24.19h1.85c.11 0 .21-.08.23-.19l.17-1.19c.29-.12.54-.27.78-.45l1.15.46c.1.03.24 0 .29-.1l.92-1.56a.22.22 0 0 0-.06-.29l-.97-.74M16.5 19c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M9 2c1.8.6 3 2.3 3 4.2c0 2-1.2 3.7-3 4.3v11c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.6v-11c-1.8-.6-3-2.3-3-4.2S4.2 2.6 6 2v3.7h3V2Z"/>'
        },
        "wrench-cog-outline": {
            body: '<path fill="currentColor" d="M9 1.09V6H7V1.09C4.16 1.57 2 4.03 2 7c0 2.22 1.21 4.15 3 5.19V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8.81c1.79-1.04 3-2.97 3-5.19c0-2.97-2.16-5.43-5-5.91m1 9.37l-1 .58V20H7v-8.96l-1-.58C4.77 9.74 4 8.42 4 7c0-1 .37-1.94 1-2.65V8h6V4.35c.63.71 1 1.65 1 2.65c0 1.42-.77 2.74-2 3.46m10.94 7.48a3.253 3.253 0 0 0 0-.89l.97-.73a.22.22 0 0 0 .06-.29l-.92-1.56c-.05-.1-.18-.14-.29-.1l-1.15.45c-.24-.17-.49-.32-.78-.44l-.17-1.19a.235.235 0 0 0-.23-.19h-1.85c-.12 0-.22.08-.24.19l-.17 1.19c-.29.12-.54.27-.78.44l-1.15-.45c-.1-.04-.24 0-.28.1l-.93 1.56c-.06.1-.03.22.06.29l.97.73c-.01.15-.03.3-.03.45s.02.29.03.44l-.97.74a.22.22 0 0 0-.06.29l.93 1.56c.04.1.18.13.28.1l1.15-.46c.24.18.49.33.78.45l.17 1.19c.02.11.12.19.24.19h1.85c.11 0 .21-.08.23-.19l.17-1.19c.29-.12.54-.27.78-.45l1.15.46c.11.03.24 0 .29-.1l.92-1.56a.22.22 0 0 0-.06-.29l-.97-.74M17.5 19c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"/>'
        },
        "wrench-outline": {
            body: '<path fill="currentColor" d="m22.61 19l-9.08-9.09c.93-2.34.47-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11L6.08 7.5L2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.39-.4.39-1.01 0-1.4m-3 1.59l-9.46-9.46c-.61.45-1.29.72-2 .82c-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09l4.24-4.24L7.24 3c1.26-.05 2.49.39 3.44 1.33a4.469 4.469 0 0 1 1.24 3.96a4.35 4.35 0 0 1-.88 1.96l9.46 9.45l-.89.89Z"/>'
        },
        wunderlist: {
            body: '<path d="M17 17.5L12 15l-5 2.5V5H5v14h14V5h-2v12.5m-5-5.08l2.25 1.35l-.6-2.55l1.99-1.72L13 9.27l-1-2.41l-1 2.41l-2.64.23l1.99 1.72l-.6 2.55L12 12.42M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" fill="currentColor"/>',
            hidden: true
        },
        xamarin: {
            body: '<path fill="currentColor" d="M22.75 11.07c.16.28.25.6.25.93c0 .33-.09.65-.25.93L18.08 21c-.36.62-1.02 1-1.73 1h-8.7c-.71 0-1.37-.38-1.73-1l-4.67-8.07c-.16-.28-.25-.6-.25-.93c0-.33.09-.65.25-.93L5.92 3c.36-.62 1.02-1 1.73-1h8.7c.71 0 1.37.38 1.73 1l4.67 8.07M12 12v-.1L9.42 7.1L9.25 7H7.66l-.16.1v.2L10 12l-2.5 4.7v.2l.16.1h1.59l.17-.1L12 12.1V12l.03.1l2.55 4.8l.17.1h1.59l.16-.1v-.2L14 12l2.5-4.7v-.2l-.16-.1h-1.59l-.17.1l-2.55 4.8l-.03.1Z"/>'
        },
        "xamarin-outline": {
            body: '<path d="M12 12l.03-.1l2.55-4.8l.17-.1h1.59l.16.1v.2L14 12l2.5 4.7v.2l-.16.1h-1.59l-.17-.1l-2.55-4.8L12 12v.1l-2.58 4.8l-.17.1H7.66l-.16-.1v-.2L10 12L7.5 7.3v-.2l.16-.1h1.59l.17.1L12 11.9v.1m10.75-.93c.16.28.25.6.25.93c0 .33-.09.65-.25.93L18.08 21c-.36.62-1.02 1-1.73 1h-8.7c-.71 0-1.37-.38-1.73-1l-4.67-8.07c-.16-.28-.25-.6-.25-.93c0-.33.09-.65.25-.93L5.92 3c.36-.62 1.02-1 1.73-1h8.7c.71 0 1.37.38 1.73 1l4.67 8.07m-1.95.18L16.97 4.8c-.29-.5-.83-.8-1.41-.8H8.44c-.58 0-1.12.3-1.41.8L3.2 11.25c-.13.25-.2.49-.2.75s.07.5.2.75l3.83 6.45c.29.5.83.8 1.41.8h7.12c.58 0 1.12-.3 1.41-.8l3.83-6.45c.13-.25.2-.49.2-.75s-.07-.5-.2-.75z" fill="currentColor"/>',
            hidden: true
        },
        xda: {
            body: '<path d="M0 16.7l3.2-3.8L0 9.1l1.5-1.3l3 3.5l3-3.5L9 9.1l-3.2 3.8L9 16.7L7.5 18l-3-3.6l-3 3.6L0 16.7m24 .2c0 .5-.4 1-1 1h-3c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h2v-2h-4V8h5c.5 0 1 .4 1 1m-2 5h-2v2h2v-2m-6 2.9c0 .5-.4 1-1 1h-3c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h2V5h2v11.9m-2-1v-6h-2v6h2z" fill="currentColor"/>',
            hidden: true
        },
        xing: {
            body: '<path d="M4.8 3C3.8 3 3 3.8 3 4.8v14.4c0 1 .8 1.8 1.8 1.8h14.4c1 0 1.8-.8 1.8-1.8V4.8c0-1-.8-1.8-1.8-1.8m-3.13 2h2.04c.12 0 .22.04.26.13c.06.09.06.2 0 .31l-4.47 7.92l2.85 5.2c.06.11.06.22 0 .31c-.05.08-.14.13-.25.13h-2.03c-.31 0-.47-.21-.56-.39l-2.87-5.26l4.49-7.96c.11-.2.24-.39.54-.39M7.09 7.76H9.1c.31 0 .47.2.57.39l1.39 2.42c-.09.14-2.18 3.85-2.18 3.85c-.11.19-.25.39-.56.39H6.3c-.12 0-.21-.05-.26-.14a.413.413 0 0 1 0-.31l2.14-3.79L6.82 8.2c-.05-.11-.07-.2-.01-.31c.05-.08.15-.13.28-.13z" fill="currentColor"/>',
            hidden: true
        },
        "xing-circle": {
            body: '<path d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m3.85 4h1.89c.12 0 .2.04.26.12c.04.08.04.18 0 .29l-4.16 7.35l2.66 4.83c.03.1.03.21 0 .29c-.07.08-.15.12-.26.12h-1.88c-.29 0-.43-.19-.52-.36l-2.67-4.88c.14-.26 4.18-7.4 4.18-7.4c.1-.18.22-.36.5-.36M7.5 8.57h1.89c.28 0 .42.18.51.35l1.29 2.25c-.07.13-2.02 3.58-2.02 3.58c-.1.17-.23.36-.51.36H6.78c-.11 0-.19-.05-.24-.11c-.04-.1-.04-.2 0-.31l1.99-3.52L7.27 9c-.06-.13-.07-.23-.02-.31c.05-.08.14-.12.25-.12z" fill="currentColor"/>',
            hidden: true
        },
        xml: {
            body: '<path fill="currentColor" d="m12.89 3l1.96.4L11.11 21l-1.96-.4L12.89 3m6.7 9L16 8.41V5.58L22.42 12L16 18.41v-2.83L19.59 12M1.58 12L8 5.58v2.83L4.41 12L8 15.58v2.83L1.58 12Z"/>'
        },
        xmpp: {
            body: '<path fill="currentColor" d="M12 15.4C9.75 13.09 8 9.54 8 6L2 4c0 5.65 4.33 10.11 8.55 12.66C9.38 17.5 8.15 18 7 18v1c1.2 0 3.03-.54 5-1.54c1.97 1 3.8 1.54 5 1.54v-1c-1.15 0-2.38-.5-3.55-1.34C17.66 14.11 22 9.65 22 4l-6 2c0 3.54-1.75 7.09-4 9.4Z"/>'
        },
        "y-combinator": {
            body: '<path d="M2 2h20v20H2V2m9.25 15.5h1.5v-4.44L16 7h-1.5L12 11.66L9.5 7H8l3.25 6.06v4.44z" fill="currentColor"/>',
            hidden: true
        },
        yahoo: {
            body: '<path fill="currentColor" d="M10.5 7.59L8.16 13.2L5.85 7.59H2l4.29 9.64l-1.54 3.47H8.5l5.74-13.11H10.5m4.5 5.14c-1.37 0-2.41 1.04-2.41 2.27c0 1.17 1 2.16 2.34 2.16c1.39 0 2.43-1.03 2.43-2.26c0-1.21-1-2.17-2.36-2.17m2.72-9.43l-3.83 8.59h4.28L22 3.3h-4.28Z"/>'
        },
        yammer: {
            body: '<path d="M13.54 5.93L9.18 17.11c-.02.08-.92 2.54-3.95 2.54a1 1 0 0 1-1-1c0-.56.45-1 1-1c1.56 0 2.03-1.12 2.08-1.24l.37-1.01l-3.86-9.46c-.2-.51.04-1.1.55-1.3a1 1 0 0 1 1.31.55l3.07 7.53l2.93-7.52c.2-.52.78-.77 1.32-.57c.5.2.75.78.54 1.3m4.96.45c-.18 0-.37.07-.5.19c0 0-4.2 2.99-4 3.31c.19.32 4.83-1.85 4.84-1.88c.31-.1.54-.41.54-.77c0-.47-.38-.85-.88-.85m.77 10.46c-.1-.17-.27-.3-.44-.38c0 0-4.66-2.17-4.83-1.85c-.19.33 4 3.31 4 3.31c.25.22.63.26.94.08c.41-.23.56-.75.33-1.16m1.7-5.42c-.18-.1-.37-.13-.57-.1c0 0-5.11.53-5.1.9c.01.37 5.11.78 5.12.78c.34.05.69-.1.87-.42c.21-.41.09-.93-.32-1.16z" fill="currentColor"/>',
            hidden: true
        },
        yeast: {
            body: '<path fill="currentColor" d="M18 14a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4l.09-.85c-.04-.7-.17-1.31-.54-1.65c-.2-.2-.48-.31-.8-.37c-.96.55-2.07.87-3.25.87A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.18-.32 2.29-.87 3.25c.06.32.17.6.37.8c.34.37.95.5 1.65.54L18 14M7.5 10A1.5 1.5 0 0 1 9 11.5A1.5 1.5 0 0 1 7.5 13A1.5 1.5 0 0 1 6 11.5A1.5 1.5 0 0 1 7.5 10m2-5C7 5 5 7 5 9.5S7 14 9.5 14S14 12 14 9.5S12 5 9.5 5Z"/>'
        },
        yelp: {
            body: '<path d="M10.59 2c.64 0 .91.27.99.97l.21 3.17l.24 4.15c.02.35-.03.71-.17 1.03c-.22.45-.72.57-1.13.26c-.23-.19-.42-.44-.58-.71L6.42 4.55c-.36-.61-.25-1.01.35-1.39C7.5 2.68 9.73 2 10.59 2m4.24 12.85l.26.06l3.86 1.4c.66.24.84.61.55 1.26c-.44 1.13-1.16 2.09-2.08 2.88c-.46.4-.92.33-1.21-.17l-2.27-3.96c-.39-.71.09-1.52.89-1.47M4.5 14c0-.74 0-1.45.25-2.13c.22-.67.58-.87 1.25-.6l3.63 1.54c.46.19.72.51.7 1.03c-.03.52-.36.74-.8.89l-3.68 1.21c-.7.23-1.06.02-1.21-.69c-.09-.42-.17-.85-.14-1.25m7.47 7c-.02.81-.37 1.12-1.16 1c-1.04-.2-2-.6-2.85-1.24c-.42-.32-.51-.81-.2-1.23l2.71-3.56c.23-.3.56-.37.92-.23c.38.14.58.44.58.85V21m2.48-7.68c-.72.01-1.22-.82-.81-1.41c.83-1.24 1.71-2.45 2.59-3.65c.27-.41.71-.44 1.08-.1c.93.84 1.6 1.84 1.98 3.06c.14.45-.04.86-.46.98l-3.74.97l-.64.15z" fill="currentColor"/>',
            hidden: true
        },
        "yin-yang": {
            body: '<path fill="currentColor" d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2.5A1.5 1.5 0 0 1 13.5 8A1.5 1.5 0 0 1 12 9.5A1.5 1.5 0 0 1 10.5 8A1.5 1.5 0 0 1 12 6.5m0 8a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5Z"/>'
        },
        yoga: {
            body: '<path fill="currentColor" d="M13 2a2 2 0 1 0 0 4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2M4 7v2h6v6l-5.07 5.07l1.41 1.43l6.72-6.73L17 17.13V21h2v-4.43c0-.36-.18-.68-.5-.86L15 13.6V9h6V7H4Z"/>'
        },
        youtube: {
            body: '<path fill="currentColor" d="m10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73Z"/>'
        },
        "youtube-gaming": {
            body: '<path fill="currentColor" d="M22 13V8l-5-3l-5 3l-5-3l-5 3v5l10 6l10-6M9 11H7v2H6v-2H4v-1h2V8h1v2h2v1m6 2c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m3-2c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1Z"/>'
        },
        "youtube-studio": {
            body: '<path fill="currentColor" d="m10 15l5-3l-5-3v6m9.45-2l2.11 1.63c.22.15.25.37.1.65l-2.02 3.47c-.14.22-.33.28-.61.19l-2.48-.99c-.66.47-1.22.8-1.69.99l-.36 2.62c-.08.28-.23.44-.5.44h-4c-.27 0-.42-.16-.5-.44l-.36-2.62c-.59-.25-1.14-.58-1.69-.99l-2.48.99c-.28.09-.47.03-.61-.19l-2.02-3.47c-.15-.28-.12-.5.1-.65L4.55 13c-.05-.23-.05-.56-.05-1c0-.44 0-.77.05-1L2.44 9.38c-.22-.16-.25-.38-.1-.66l2.02-3.47c.14-.22.33-.28.61-.19l2.48.99c.66-.47 1.22-.8 1.69-.99l.36-2.62c.08-.28.23-.44.5-.44h4c.27 0 .42.16.5.44l.36 2.62c.59.25 1.14.58 1.69.99l2.48-.99c.28-.09.47-.03.61.19l2.02 3.47c.15.28.12.5-.1.66L19.45 11c.05.23.05.56.05 1c0 .44 0 .77-.05 1Z"/>'
        },
        "youtube-subscription": {
            body: '<path fill="currentColor" d="M20 8H4V6h16v2m-2-6H6v2h12V2m4 10v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2m-6 4l-6-3.27v6.53L16 16Z"/>'
        },
        "youtube-circle-custom": {
            body: '<path d="M13.7875 12L10.9 10.35V13.65L13.7875 12Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM16.2625 8.35625C16.7438 8.49375 17.0875 8.8375 17.225 9.31875C17.5 10.2125 17.5 12 17.5 12C17.5 12 17.5 13.7875 17.2938 14.6813C17.1563 15.1625 16.8125 15.5063 16.3312 15.6438C15.4375 15.85 12 15.85 12 15.85C12 15.85 8.49375 15.85 7.66875 15.6438C7.1875 15.5063 6.84375 15.1625 6.70625 14.6813C6.5 13.7875 6.5 12 6.5 12C6.5 12 6.5 10.2125 6.6375 9.31875C6.775 8.8375 7.11875 8.49375 7.6 8.35625C8.49375 8.15 11.9312 8.15 11.9312 8.15C11.9312 8.15 15.4375 8.15 16.2625 8.35625Z" fill="currentColor"/>'
        },
        "youtube-tv": {
            body: '<path fill="currentColor" d="M2.5 4.5h19c.84 0 1.5.65 1.5 1.5v11.5c0 .85-.66 1.5-1.5 1.5h-19c-.85 0-1.5-.65-1.5-1.5V6c0-.85.65-1.5 1.5-1.5m7.21 4V15l5.71-3.3l-5.71-3.2M17.25 21H6.65c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10.7c.3 0 .5.2.5.5s-.3.5-.6.5Z"/>'
        },
        yurt: {
            body: '<path fill="currentColor" d="M22 14.87V22h-8v-6h-4v6H2v-7.13c0-.54.29-1.04.76-1.3l5.9-3.37c.22-.13.48-.2.74-.2h3.1V9H14v1h.59c.26 0 .52.07.74.2l5.9 3.37c.48.27.77.76.77 1.3M7.86 6.25H9.4c1.33 0 2.52.7 3.1 1.75H14c-.4-1.8-2-3.15-3.9-3.15v-1.5c1 0 1.85-.85 1.85-1.85V1H7.86v1.5c-1 0-1.86.73-1.86 1.75s.86 2 1.86 2Z"/>'
        },
        "z-wave": {
            body: '<path fill="currentColor" d="M16.3 10.58c-3.16 0-5.7 2.55-5.7 5.7c0 3.15 2.55 5.72 5.7 5.72c3.15 0 5.7-2.57 5.7-5.72s-2.55-5.7-5.7-5.7m1.7 8.5h-4.81L15.81 15h-2.5l1.09-1.77h4.78l-2.55 4.05h2.55L18 19.08M16.3 3.93V2C8.41 2 2 8.42 2 16.31h1.92C3.94 9.46 9.5 3.93 16.3 3.93m0 3.81V5.82c-5.8 0-10.49 4.71-10.49 10.49h1.92c.02-4.73 3.86-8.57 8.57-8.57"/>'
        },
        zend: {
            body: '<path fill="currentColor" d="M11.28 9.81S11.28 7 14.09 7h8.41s0 2.81-2.79 2.81h-8.43m0 3.6s0-2.81 2.81-2.81h4.22s0 2.81-2.81 2.81h-4.22m0 3.59s0-2.81 2.81-2.81h1.41s0 2.81-2.82 2.81h-1.4m-.82-2.2V17H1.58L7.3 9.21H2.4V7h9.26l-5.7 7.8h4.5Z"/>'
        },
        zigbee: {
            body: '<path fill="currentColor" d="M4.06 6.15c-.09.02-.18.07-.26.13A9.892 9.892 0 0 0 2 12a10 10 0 0 0 10 10c3 0 5.68-1.32 7.5-3.4l-2.5.25c-2.75.3-5.55.34-8.34.11c-.71-.02-1.42-.2-2.07-.51a2.615 2.615 0 0 1-1.52-2.16c-.01-.16.05-.29.16-.42l2.19-2.27l7.61-7.9v-.1h-4.19c-2.27.04-4.53.22-6.78.55M20.17 17.5c.09-.03.18-.06.26-.11A9.984 9.984 0 0 0 22 12A10 10 0 0 0 12 2C9.22 2 6.7 3.13 4.89 4.97h.28c3.11-.4 6.26-.5 9.39-.32c.94-.01 1.89.17 2.77.52A2.67 2.67 0 0 1 19 7.37c0 .16-.07.33-.18.45l-9.11 9.37l-.71.76v.11h4.14c2.36-.06 4.7-.25 7.03-.56Z"/>'
        },
        "zip-box": {
            body: '<path fill="currentColor" d="M14 17h-2v-2h-2v-2h2v2h2m0-6h-2v2h2v2h-2v-2h-2V9h2V7h-2V5h2v2h2m5-4H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>'
        },
        "zip-box-outline": {
            body: '<path fill="currentColor" d="M12 17v-2h2v2h-2m2-4v-2h-2v2h2m0-4V7h-2v2h2m-4 2h2V9h-2v2m0 4h2v-2h-2v2M21 5v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2m-2 0h-7v2h-2V5H5v14h14V5Z"/>'
        },
        "zip-disk": {
            body: '<path fill="currentColor" d="M7 3L3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5l-4-2v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V3H7m1 7h8a1 1 0 0 1 1 1v8H7v-8a1 1 0 0 1 1-1Z"/>'
        },
        "zodiac-aquarius": {
            body: '<path fill="currentColor" d="m15 12.41l-3-3l-3 3l-3-3l-2.29 2.3l-1.42-1.42L6 6.59l3 3l3-3l3 3l3-3l3.71 3.7l-1.42 1.42L18 9.41l-3 3m3 3l2.29 2.3l1.42-1.42l-3.71-3.7l-3 3l-3-3l-3 3l-3-3l-3.71 3.7l1.42 1.42L6 15.41l3 3l3-3l3 3l3-3Z"/>'
        },
        "zodiac-aries": {
            body: '<path fill="currentColor" d="M16 2c-1.05 0-2.09.27-3 .81c-.36.19-.7.45-1 .73c-.3-.28-.64-.54-1-.73C10.09 2.27 9.05 2 8 2a6 6 0 0 0-6 6a6 6 0 0 0 6 6v-2a4 4 0 0 1-4-4a4 4 0 0 1 4-4a4.029 4.029 0 0 1 3 1.36V22h2V5.36c.08-.09.16-.18.25-.26a4 4 0 0 1 5.66.15a3.997 3.997 0 0 1-.15 5.65C18 11.61 17.03 12 16 12v2a6 6 0 0 0 6-6a6 6 0 0 0-6-6Z"/>'
        },
        "zodiac-cancer": {
            body: '<path fill="currentColor" d="M12 4C6.5 4 2 7.58 2 12c0 2.12 1.65 3.87 3.76 4H6a4 4 0 0 0 4-4a4 4 0 0 0-4-4h-.24A8.81 8.81 0 0 1 12 5.6c1.77-.02 3.5.47 5 1.4l1.25-1.25A11.492 11.492 0 0 0 12 4m-6 6a2 2 0 0 1 2 2c0 1.11-.92 2-2 2a2 2 0 0 1-2-1.8v-.4A2 2 0 0 1 6 10m12.24-2H18a4 4 0 0 0-4 4a4 4 0 0 0 4 4h.24A8.81 8.81 0 0 1 12 18.4c-1.77.02-3.5-.47-5-1.4l-1.24 1.24C7.63 19.41 9.79 20 12 20c5.5 0 10-3.58 10-8c0-2.12-1.65-3.87-3.76-4M18 14a2 2 0 0 1-2-2c0-1.11.92-2 2-2a2 2 0 0 1 2 1.8v.4a2 2 0 0 1-2 1.8Z"/>'
        },
        "zodiac-capricorn": {
            body: '<path fill="currentColor" d="M15 13c-.7 0-1.39.19-2 .55V6a3 3 0 0 0-3-3c-.75 0-1.45.29-2 .78C7.45 3.28 6.74 3 6 3v2a1 1 0 0 1 1 1v10h2V6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2v2c1.15 0 2.25-.5 3-1.38a3.974 3.974 0 0 0 5.64.38c1.67-1.42 1.86-3.95.4-5.62A4.01 4.01 0 0 0 15 13m0 6a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2Z"/>'
        },
        "zodiac-gemini": {
            body: '<path fill="currentColor" d="M18 5.3c1.35-.33 2.66-.76 3.94-1.3l-.76-1.86a23.753 23.753 0 0 1-18.36.03L2.06 4c1.28.54 2.59.97 3.94 1.3v13.4c-1.35.33-2.66.76-3.94 1.3l.76 1.86a23.94 23.94 0 0 1 18.36 0l.76-1.86c-1.28-.54-2.59-.97-3.94-1.3V5.3m-10 13V5.69c1.32.2 2.66.31 4 .31c1.34 0 2.68-.11 4-.31v12.62a26.17 26.17 0 0 0-8 0v-.01Z"/>'
        },
        "zodiac-leo": {
            body: '<path fill="currentColor" d="M20 17a3 3 0 0 1-3 3a3.163 3.163 0 0 1-3-3c.16-1.61.5-3.2 1-4.74c.54-1.71.87-3.47 1-5.26a5.136 5.136 0 0 0-5-5a5.136 5.136 0 0 0-5 5c.15 1.53.5 3.03 1 4.5l.21.7c-2.11-.67-4.35.5-5.02 2.6c-.69 2.11.49 4.36 2.6 5.03c2.11.67 4.35-.5 5.02-2.61c.13-.39.19-.81.19-1.22c-.16-1.73-.5-3.44-1.09-5.08A18.76 18.76 0 0 1 8 7a3.163 3.163 0 0 1 3-3c1.62.08 2.92 1.38 3 3a22.6 22.6 0 0 1-1 4.74c-.54 1.71-.87 3.47-1 5.26a5.136 5.136 0 0 0 5 5a5 5 0 0 0 5-5h-2M6 18a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2Z"/>'
        },
        "zodiac-libra": {
            body: '<path fill="currentColor" d="M20 16v2h-7v-2.09c3-.55 4.96-3.41 4.41-6.41c-.55-3-3.41-4.96-6.41-4.41c-3 .56-4.96 3.41-4.41 6.41c.41 2.24 2.17 4 4.41 4.41V18H4v-2h2.92a7.428 7.428 0 0 1-2.42-5.5A7.5 7.5 0 0 1 12 3a7.5 7.5 0 0 1 7.5 7.5c0 2.09-.87 4.09-2.42 5.5H20m0 3H4v2h16v-2Z"/>'
        },
        "zodiac-pisces": {
            body: '<path fill="currentColor" d="M20 11h-2c.11-2.81.73-5.58 1.81-8.18L18 2.06A25.943 25.943 0 0 0 16 11H8c-.13-3.08-.81-6.1-2-8.94l-1.86.76C5.24 5.41 5.87 8.18 6 11H4v2h2a23.76 23.76 0 0 1-1.81 8.18l1.81.76C7.19 19.1 7.87 16.08 8 13h8c.13 3.08.81 6.1 2 8.94l1.86-.76c-1.1-2.59-1.73-5.36-1.86-8.18h2v-2Z"/>'
        },
        "zodiac-sagittarius": {
            body: '<path fill="currentColor" d="M22 2v10h-2V5.41L10.41 15l2.3 2.29l-1.42 1.42L9 16.41l-5.29 5.3l-1.42-1.42L7.59 15l-2.3-2.29l1.42-1.42L9 13.59L18.59 4H12V2h10Z"/>'
        },
        "zodiac-scorpio": {
            body: '<path fill="currentColor" d="m17.71 15.29l-1.42 1.42l1.3 1.29H16a2 2 0 0 1-2-2V6a3 3 0 0 0-3-3c-.75 0-1.45.29-2 .78a2.997 2.997 0 0 0-4 0C4.45 3.28 3.74 3 3 3v2a1 1 0 0 1 1 1v10h2V6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v10h2V6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v10a4 4 0 0 0 4 4h1.59l-1.3 1.29l1.42 1.42l3.7-3.71l-3.7-3.71Z"/>'
        },
        "zodiac-taurus": {
            body: '<path fill="currentColor" d="M15.59 9A6.996 6.996 0 0 0 19 3h-2a5 5 0 0 1-5 5a5 5 0 0 1-5-5H5c0 2.46 1.3 4.74 3.41 6C5.09 11 4 15.28 6 18.6c1.97 3.32 6.27 4.4 9.59 2.4c3.32-1.96 4.41-6.26 2.41-9.58A6.896 6.896 0 0 0 15.59 9M12 20a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5Z"/>'
        },
        "zodiac-virgo": {
            body: '<path fill="currentColor" d="M18.5 19.13C20 17.77 20 15.18 20 14a4 4 0 0 0-4-4c-.7 0-1.4.2-2 .56V6a3 3 0 0 0-3-3c-.75 0-1.45.29-2 .78a2.997 2.997 0 0 0-4 0C4.45 3.28 3.74 3 3 3v2a1 1 0 0 1 1 1v10h2V6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v10h2V6a1 1 0 0 1 1-1a1 1 0 0 1 1 1v8c0 1.18 0 3.77 1.5 5.13c-.78.41-1.62.71-2.5.87v2c1.29 0 3.84-1.26 5-1.87c1.16.61 3.71 1.87 5 1.87v-2c-.88-.16-1.72-.46-2.5-.87M16 12a2 2 0 0 1 2 2c0 2.92-.54 4-2 4s-2-1.08-2-4a2 2 0 0 1 2-2Z"/>'
        }
    },
    aliases: {
        123: {
            parent: "numeric"
        },
        "1-2-3": {
            parent: "numeric"
        },
        "123-off": {
            parent: "numeric-off"
        },
        "1password": {
            parent: "onepassword"
        },
        "1up": {
            parent: "one-up"
        },
        "3d-rotation": {
            parent: "rotate-3d-variant"
        },
        "4k": {
            parent: "video-4k-box"
        },
        "8-track": {
            parent: "eight-track"
        },
        "a-b-c": {
            parent: "alphabetical"
        },
        "a-b-c-off": {
            parent: "alphabetical-off"
        },
        abc: {
            parent: "alphabetical"
        },
        "abc-off": {
            parent: "alphabetical-off"
        },
        about: {
            parent: "information"
        },
        "about-circle": {
            parent: "information"
        },
        "about-circle-outline": {
            parent: "information-outline"
        },
        "about-outline": {
            parent: "information-outline"
        },
        "about-variant": {
            parent: "information-variant"
        },
        "ac-unit": {
            parent: "air-conditioner"
        },
        "academic-cap": {
            parent: "school"
        },
        "academic-cap-outline": {
            parent: "school-outline"
        },
        accelerometer: {
            parent: "axis-arrow"
        },
        "access-alarms": {
            parent: "alarm"
        },
        "access-time": {
            parent: "clock-outline"
        },
        accessibility: {
            parent: "human"
        },
        accessible: {
            parent: "wheelchair"
        },
        "account-add": {
            parent: "account-plus"
        },
        "account-add-outline": {
            parent: "account-plus-outline"
        },
        "account-badge-alert": {
            parent: "badge-account-alert"
        },
        "account-badge-alert-outline": {
            parent: "badge-account-alert-outline"
        },
        "account-badge-horizontal": {
            parent: "badge-account-horizontal"
        },
        "account-badge-horizontal-outline": {
            parent: "badge-account-horizontal-outline"
        },
        "account-badge-warning": {
            parent: "badge-account-alert"
        },
        "account-badge-warning-outline": {
            parent: "badge-account-alert-outline"
        },
        "account-balance": {
            parent: "bank"
        },
        "account-balance-wallet": {
            parent: "wallet"
        },
        "account-balance-wallet-outline": {
            parent: "wallet-outline"
        },
        "account-boxes": {
            parent: "account-box-multiple"
        },
        "account-cache": {
            parent: "account-sync"
        },
        "account-cache-outline": {
            parent: "account-sync-outline"
        },
        "account-card-details": {
            parent: "card-account-details"
        },
        "account-card-details-outline": {
            parent: "card-account-details-outline"
        },
        "account-disability": {
            parent: "account-injury"
        },
        "account-disability-outline": {
            parent: "account-injury-outline"
        },
        "account-download": {
            parent: "account-arrow-down"
        },
        "account-download-outline": {
            parent: "account-arrow-down-outline"
        },
        "account-favorite": {
            parent: "account-star"
        },
        "account-funnel": {
            parent: "account-filter"
        },
        "account-funnel-outline": {
            parent: "account-filter-outline"
        },
        "account-graduation": {
            parent: "account-school"
        },
        "account-graduation-outline": {
            parent: "account-school-outline"
        },
        "account-help": {
            parent: "account-question"
        },
        "account-help-outline": {
            parent: "account-question-outline"
        },
        "account-location": {
            parent: "tooltip-account"
        },
        "account-multiple-2-meters": {
            parent: "social-distance-2-meters"
        },
        "account-multiple-6-feet": {
            parent: "social-distance-6-feet"
        },
        "account-multiple-add": {
            parent: "account-multiple-plus"
        },
        "account-multiple-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "account-multiple-tick": {
            parent: "account-multiple-check"
        },
        "account-multiple-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        "account-online": {
            parent: "account-badge"
        },
        "account-online-outline": {
            parent: "account-badge-outline"
        },
        "account-payment": {
            parent: "account-credit-card"
        },
        "account-payment-outline": {
            parent: "account-credit-card-outline"
        },
        "account-pending": {
            parent: "account-clock"
        },
        "account-pending-outline": {
            parent: "account-clock-outline"
        },
        "account-pilot": {
            parent: "account-tie-hat"
        },
        "account-pilot-outline": {
            parent: "account-tie-hat-outline"
        },
        "account-question-mark": {
            parent: "account-question"
        },
        "account-question-mark-outline": {
            parent: "account-question-outline"
        },
        "account-secure": {
            parent: "account-lock"
        },
        "account-secure-outline": {
            parent: "account-lock-outline"
        },
        "account-security": {
            parent: "account-lock"
        },
        "account-security-outline": {
            parent: "account-lock-outline"
        },
        "account-service": {
            parent: "account-wrench"
        },
        "account-service-outline": {
            parent: "account-wrench-outline"
        },
        "account-student": {
            parent: "account-school"
        },
        "account-student-outline": {
            parent: "account-school-outline"
        },
        "account-supervisor-circle-outlined": {
            parent: "account-supervisor-circle-outline"
        },
        "account-tick": {
            parent: "account-check"
        },
        "account-tick-outline": {
            parent: "account-check-outline"
        },
        "account-unlocked": {
            parent: "account-lock-open"
        },
        "account-unlocked-outline": {
            parent: "account-lock-open-outline"
        },
        "account-upload": {
            parent: "account-arrow-up"
        },
        "account-upload-outline": {
            parent: "account-arrow-up-outline"
        },
        "account-view": {
            parent: "account-eye"
        },
        "account-view-outline": {
            parent: "account-eye-outline"
        },
        "account-warning": {
            parent: "account-alert"
        },
        "account-warning-outline": {
            parent: "account-alert-outline"
        },
        accounts: {
            parent: "account-multiple"
        },
        "accounts-add": {
            parent: "account-multiple-plus"
        },
        "accounts-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "accounts-check": {
            parent: "account-multiple-check"
        },
        "accounts-check-outline": {
            parent: "account-multiple-check-outline"
        },
        "accounts-group": {
            parent: "account-group"
        },
        "accounts-group-outline": {
            parent: "account-group-outline"
        },
        "accounts-minus": {
            parent: "account-multiple-minus"
        },
        "accounts-minus-outline": {
            parent: "account-multiple-minus-outline"
        },
        "accounts-outline": {
            parent: "account-multiple-outline"
        },
        "accounts-plus": {
            parent: "account-multiple-plus"
        },
        "accounts-plus-outline": {
            parent: "account-multiple-plus-outline"
        },
        "accounts-switch": {
            parent: "account-switch"
        },
        "accounts-tick": {
            parent: "account-multiple-check"
        },
        "accounts-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        achievement: {
            parent: "trophy"
        },
        "achievement-award": {
            parent: "trophy-award"
        },
        "achievement-outline": {
            parent: "trophy-outline"
        },
        "achievement-variant": {
            parent: "trophy-variant"
        },
        "achievement-variant-outline": {
            parent: "trophy-variant-outline"
        },
        acid: {
            parent: "ph"
        },
        adb: {
            parent: "android-debug-bridge"
        },
        add: {
            parent: "plus"
        },
        "add-alarm": {
            parent: "alarm-plus"
        },
        "add-alert": {
            parent: "bell-plus"
        },
        "add-alert-outline": {
            parent: "bell-plus-outline"
        },
        "add-bold": {
            parent: "plus-thick"
        },
        "add-box": {
            parent: "plus-box"
        },
        "add-call": {
            parent: "phone-plus"
        },
        "add-circle": {
            parent: "plus-circle"
        },
        "add-circle-outline": {
            parent: "plus-circle-outline"
        },
        "add-location": {
            parent: "map-marker-plus"
        },
        "add-network": {
            parent: "plus-network"
        },
        "add-network-outline": {
            parent: "plus-network-outline"
        },
        "add-shopping-cart": {
            parent: "cart-plus"
        },
        "add-thick": {
            parent: "plus-thick"
        },
        "add-to-photos": {
            parent: "plus-box-multiple"
        },
        "address-marker": {
            parent: "map-marker"
        },
        "address-marker-outline": {
            parent: "map-marker-outline"
        },
        adjuster: {
            parent: "knob"
        },
        administrator: {
            parent: "shield-crown"
        },
        "administrator-outline": {
            parent: "shield-crown-outline"
        },
        "adobe-acrobat": {
            parent: "file-pdf-box"
        },
        ads: {
            parent: "advertisements"
        },
        "ads-off": {
            parent: "advertisements-off"
        },
        aed: {
            parent: "heart-flash"
        },
        aeroplane: {
            parent: "airplane"
        },
        "aeroplane-landing": {
            parent: "airplane-landing"
        },
        "aeroplane-off": {
            parent: "airplane-off"
        },
        "aeroplane-takeoff": {
            parent: "airplane-takeoff"
        },
        aerosol: {
            parent: "spray"
        },
        agriculture: {
            parent: "tractor-variant"
        },
        "air-conditioning": {
            parent: "hvac"
        },
        "air-conditioning-off": {
            parent: "hvac-off"
        },
        "air-dehumidifier": {
            parent: "air-humidifier-off"
        },
        "airline-seat-flat": {
            parent: "seat-flat"
        },
        "airline-seat-flat-angled": {
            parent: "seat-flat-angled"
        },
        "airline-seat-individual-suite": {
            parent: "seat-individual-suite"
        },
        "airline-seat-legroom-extra": {
            parent: "seat-legroom-extra"
        },
        "airline-seat-legroom-normal": {
            parent: "seat-legroom-normal"
        },
        "airline-seat-legroom-reduced": {
            parent: "seat-legroom-reduced"
        },
        "airline-seat-recline-extra": {
            parent: "seat-recline-extra"
        },
        "airline-seat-recline-normal": {
            parent: "seat-recline-normal"
        },
        "airplane-car": {
            parent: "plane-car"
        },
        "airplane-date": {
            parent: "airplane-clock"
        },
        "airplane-find": {
            parent: "airplane-search"
        },
        "airplane-gps": {
            parent: "airplane-marker"
        },
        "airplane-location": {
            parent: "airplane-marker"
        },
        "airplane-schedule": {
            parent: "airplane-clock"
        },
        "airplane-take-off": {
            parent: "airplane-takeoff"
        },
        "airplane-time": {
            parent: "airplane-clock"
        },
        "airplane-train": {
            parent: "plane-train"
        },
        "airplanemode-active": {
            parent: "airplane"
        },
        "airplanemode-inactive": {
            parent: "airplane-off"
        },
        airplay: {
            parent: "cast-variant"
        },
        "airport-shuttle": {
            parent: "plane-car"
        },
        "airport-taxi": {
            parent: "plane-car"
        },
        "alarm-add": {
            parent: "alarm-plus"
        },
        "alarm-arm-away": {
            parent: "shield-lock"
        },
        "alarm-arm-away-outline": {
            parent: "shield-lock-outline"
        },
        "alarm-arm-home": {
            parent: "shield-account"
        },
        "alarm-arm-home-outline": {
            parent: "shield-account-outline"
        },
        "alarm-arm-night": {
            parent: "shield-moon"
        },
        "alarm-arm-night-outline": {
            parent: "shield-moon-outline"
        },
        "alarm-clock": {
            parent: "alarm"
        },
        "alarm-clock-add": {
            parent: "alarm-plus"
        },
        "alarm-clock-check": {
            parent: "alarm-check"
        },
        "alarm-clock-multiple": {
            parent: "alarm-multiple"
        },
        "alarm-clock-off": {
            parent: "alarm-off"
        },
        "alarm-clock-plus": {
            parent: "alarm-plus"
        },
        "alarm-clock-snooze": {
            parent: "alarm-snooze"
        },
        "alarm-clock-tick": {
            parent: "alarm-check"
        },
        "alarm-clocks": {
            parent: "alarm-multiple"
        },
        "alarm-on": {
            parent: "alarm-check"
        },
        "alarm-tick": {
            parent: "alarm-check"
        },
        alarms: {
            parent: "alarm-multiple"
        },
        alcohol: {
            parent: "glass-cocktail"
        },
        "align-horizontal-centre": {
            parent: "align-horizontal-center"
        },
        "align-vertical-centre": {
            parent: "align-vertical-center"
        },
        "all-terrain-vehicle": {
            parent: "atv"
        },
        allergen: {
            parent: "peanut"
        },
        "allergen-off": {
            parent: "peanut-off"
        },
        "allergen-off-outline": {
            parent: "peanut-off-outline"
        },
        "allergen-outline": {
            parent: "peanut-outline"
        },
        "allergy-outline": {
            parent: "flower-pollen-outline"
        },
        "alphabet-a": {
            parent: "alpha-a"
        },
        "alphabet-a-box": {
            parent: "alpha-a-box"
        },
        "alphabet-a-box-outline": {
            parent: "alpha-a-box-outline"
        },
        "alphabet-a-circle": {
            parent: "alpha-a-circle"
        },
        "alphabet-a-circle-outline": {
            parent: "alpha-a-circle-outline"
        },
        "alphabet-b": {
            parent: "alpha-b"
        },
        "alphabet-b-box": {
            parent: "alpha-b-box"
        },
        "alphabet-b-box-outline": {
            parent: "alpha-b-box-outline"
        },
        "alphabet-b-circle": {
            parent: "alpha-b-circle"
        },
        "alphabet-b-circle-outline": {
            parent: "alpha-b-circle-outline"
        },
        "alphabet-c": {
            parent: "alpha-c"
        },
        "alphabet-c-box": {
            parent: "alpha-c-box"
        },
        "alphabet-c-box-outline": {
            parent: "alpha-c-box-outline"
        },
        "alphabet-c-circle": {
            parent: "alpha-c-circle"
        },
        "alphabet-c-circle-outline": {
            parent: "alpha-c-circle-outline"
        },
        "alphabet-d": {
            parent: "alpha-d"
        },
        "alphabet-d-box": {
            parent: "alpha-d-box"
        },
        "alphabet-d-box-outline": {
            parent: "alpha-d-box-outline"
        },
        "alphabet-d-circle": {
            parent: "alpha-d-circle"
        },
        "alphabet-d-circle-outline": {
            parent: "alpha-d-circle-outline"
        },
        "alphabet-e": {
            parent: "alpha-e"
        },
        "alphabet-e-box": {
            parent: "alpha-e-box"
        },
        "alphabet-e-box-outline": {
            parent: "alpha-e-box-outline"
        },
        "alphabet-e-circle": {
            parent: "alpha-e-circle"
        },
        "alphabet-e-circle-outline": {
            parent: "alpha-e-circle-outline"
        },
        "alphabet-f": {
            parent: "alpha-f"
        },
        "alphabet-f-box": {
            parent: "alpha-f-box"
        },
        "alphabet-f-box-outline": {
            parent: "alpha-f-box-outline"
        },
        "alphabet-f-circle": {
            parent: "alpha-f-circle"
        },
        "alphabet-f-circle-outline": {
            parent: "alpha-f-circle-outline"
        },
        "alphabet-g": {
            parent: "alpha-g"
        },
        "alphabet-g-box": {
            parent: "alpha-g-box"
        },
        "alphabet-g-box-outline": {
            parent: "alpha-g-box-outline"
        },
        "alphabet-g-circle": {
            parent: "alpha-g-circle"
        },
        "alphabet-g-circle-outline": {
            parent: "alpha-g-circle-outline"
        },
        "alphabet-h": {
            parent: "alpha-h"
        },
        "alphabet-h-box": {
            parent: "alpha-h-box"
        },
        "alphabet-h-box-outline": {
            parent: "alpha-h-box-outline"
        },
        "alphabet-h-circle": {
            parent: "alpha-h-circle"
        },
        "alphabet-h-circle-outline": {
            parent: "alpha-h-circle-outline"
        },
        "alphabet-i": {
            parent: "alpha-i"
        },
        "alphabet-i-box": {
            parent: "alpha-i-box"
        },
        "alphabet-i-box-outline": {
            parent: "alpha-i-box-outline"
        },
        "alphabet-i-circle": {
            parent: "alpha-i-circle"
        },
        "alphabet-i-circle-outline": {
            parent: "alpha-i-circle-outline"
        },
        "alphabet-j": {
            parent: "alpha-j"
        },
        "alphabet-j-box": {
            parent: "alpha-j-box"
        },
        "alphabet-j-box-outline": {
            parent: "alpha-j-box-outline"
        },
        "alphabet-j-circle": {
            parent: "alpha-j-circle"
        },
        "alphabet-j-circle-outline": {
            parent: "alpha-j-circle-outline"
        },
        "alphabet-k": {
            parent: "alpha-k"
        },
        "alphabet-k-box": {
            parent: "alpha-k-box"
        },
        "alphabet-k-box-outline": {
            parent: "alpha-k-box-outline"
        },
        "alphabet-k-circle": {
            parent: "alpha-k-circle"
        },
        "alphabet-k-circle-outline": {
            parent: "alpha-k-circle-outline"
        },
        "alphabet-l": {
            parent: "alpha-l"
        },
        "alphabet-l-box": {
            parent: "alpha-l-box"
        },
        "alphabet-l-box-outline": {
            parent: "alpha-l-box-outline"
        },
        "alphabet-l-circle": {
            parent: "alpha-l-circle"
        },
        "alphabet-l-circle-outline": {
            parent: "alpha-l-circle-outline"
        },
        "alphabet-m": {
            parent: "alpha-m"
        },
        "alphabet-m-box": {
            parent: "alpha-m-box"
        },
        "alphabet-m-box-outline": {
            parent: "alpha-m-box-outline"
        },
        "alphabet-m-circle": {
            parent: "alpha-m-circle"
        },
        "alphabet-m-circle-outline": {
            parent: "alpha-m-circle-outline"
        },
        "alphabet-n": {
            parent: "alpha-n"
        },
        "alphabet-n-box": {
            parent: "alpha-n-box"
        },
        "alphabet-n-box-outline": {
            parent: "alpha-n-box-outline"
        },
        "alphabet-n-circle": {
            parent: "alpha-n-circle"
        },
        "alphabet-n-circle-outline": {
            parent: "alpha-n-circle-outline"
        },
        "alphabet-o": {
            parent: "alpha-o"
        },
        "alphabet-o-box": {
            parent: "alpha-o-box"
        },
        "alphabet-o-box-outline": {
            parent: "alpha-o-box-outline"
        },
        "alphabet-o-circle": {
            parent: "alpha-o-circle"
        },
        "alphabet-o-circle-outline": {
            parent: "alpha-o-circle-outline"
        },
        "alphabet-p": {
            parent: "alpha-p"
        },
        "alphabet-p-box": {
            parent: "alpha-p-box"
        },
        "alphabet-p-box-outline": {
            parent: "alpha-p-box-outline"
        },
        "alphabet-p-circle": {
            parent: "alpha-p-circle"
        },
        "alphabet-p-circle-outline": {
            parent: "alpha-p-circle-outline"
        },
        "alphabet-q": {
            parent: "alpha-q"
        },
        "alphabet-q-box": {
            parent: "alpha-q-box"
        },
        "alphabet-q-box-outline": {
            parent: "alpha-q-box-outline"
        },
        "alphabet-q-circle": {
            parent: "alpha-q-circle"
        },
        "alphabet-q-circle-outline": {
            parent: "alpha-q-circle-outline"
        },
        "alphabet-r": {
            parent: "alpha-r"
        },
        "alphabet-r-box": {
            parent: "alpha-r-box"
        },
        "alphabet-r-box-outline": {
            parent: "alpha-r-box-outline"
        },
        "alphabet-r-circle": {
            parent: "alpha-r-circle"
        },
        "alphabet-r-circle-outline": {
            parent: "alpha-r-circle-outline"
        },
        "alphabet-s": {
            parent: "alpha-s"
        },
        "alphabet-s-box": {
            parent: "alpha-s-box"
        },
        "alphabet-s-box-outline": {
            parent: "alpha-s-box-outline"
        },
        "alphabet-s-circle": {
            parent: "alpha-s-circle"
        },
        "alphabet-s-circle-outline": {
            parent: "alpha-s-circle-outline"
        },
        "alphabet-t": {
            parent: "alpha-t"
        },
        "alphabet-t-box": {
            parent: "alpha-t-box"
        },
        "alphabet-t-box-outline": {
            parent: "alpha-t-box-outline"
        },
        "alphabet-t-circle": {
            parent: "alpha-t-circle"
        },
        "alphabet-t-circle-outline": {
            parent: "alpha-t-circle-outline"
        },
        "alphabet-u": {
            parent: "alpha-u"
        },
        "alphabet-u-box": {
            parent: "alpha-u-box"
        },
        "alphabet-u-box-outline": {
            parent: "alpha-u-box-outline"
        },
        "alphabet-u-circle": {
            parent: "alpha-u-circle"
        },
        "alphabet-u-circle-outline": {
            parent: "alpha-u-circle-outline"
        },
        "alphabet-v": {
            parent: "alpha-v"
        },
        "alphabet-v-box": {
            parent: "alpha-v-box"
        },
        "alphabet-v-box-outline": {
            parent: "alpha-v-box-outline"
        },
        "alphabet-v-circle": {
            parent: "alpha-v-circle"
        },
        "alphabet-v-circle-outline": {
            parent: "alpha-v-circle-outline"
        },
        "alphabet-w": {
            parent: "alpha-w"
        },
        "alphabet-w-box": {
            parent: "alpha-w-box"
        },
        "alphabet-w-box-outline": {
            parent: "alpha-w-box-outline"
        },
        "alphabet-w-circle": {
            parent: "alpha-w-circle"
        },
        "alphabet-w-circle-outline": {
            parent: "alpha-w-circle-outline"
        },
        "alphabet-x": {
            parent: "alpha-x"
        },
        "alphabet-x-box": {
            parent: "alpha-x-box"
        },
        "alphabet-x-box-outline": {
            parent: "alpha-x-box-outline"
        },
        "alphabet-x-circle": {
            parent: "alpha-x-circle"
        },
        "alphabet-x-circle-outline": {
            parent: "alpha-x-circle-outline"
        },
        "alphabet-y": {
            parent: "alpha-y"
        },
        "alphabet-y-box": {
            parent: "alpha-y-box"
        },
        "alphabet-y-box-outline": {
            parent: "alpha-y-box-outline"
        },
        "alphabet-y-circle": {
            parent: "alpha-y-circle"
        },
        "alphabet-y-circle-outline": {
            parent: "alpha-y-circle-outline"
        },
        "alphabet-z": {
            parent: "alpha-z"
        },
        "alphabet-z-box": {
            parent: "alpha-z-box"
        },
        "alphabet-z-box-outline": {
            parent: "alpha-z-box-outline"
        },
        "alphabet-z-circle": {
            parent: "alpha-z-circle"
        },
        "alphabet-z-circle-outline": {
            parent: "alpha-z-circle-outline"
        },
        "alternate-email": {
            parent: "at"
        },
        "alternating-current": {
            parent: "current-ac"
        },
        "amazon-clouddrive": {
            parent: "amazon-drive"
        },
        "ammunition-pistol": {
            parent: "magazine-pistol"
        },
        "ammunition-rifle": {
            parent: "magazine-rifle"
        },
        amp: {
            parent: "lightning-bolt-circle"
        },
        amplitude: {
            parent: "cosine-wave"
        },
        analog: {
            parent: "sine-wave"
        },
        analytics: {
            parent: "poll"
        },
        and: {
            parent: "ampersand"
        },
        "animation-minus": {
            parent: "collapse-all"
        },
        "animation-minus-outline": {
            parent: "collapse-all-outline"
        },
        "animation-plus": {
            parent: "expand-all"
        },
        "animation-plus-outline": {
            parent: "expand-all-outline"
        },
        announcement: {
            parent: "bullhorn"
        },
        "announcement-outline": {
            parent: "bullhorn-outline"
        },
        anonymous: {
            parent: "incognito"
        },
        "anonymous-circle": {
            parent: "incognito-circle"
        },
        "anonymous-circle-off": {
            parent: "incognito-circle-off"
        },
        "anonymous-off": {
            parent: "incognito-off"
        },
        "anti-lock-brake-system": {
            parent: "car-brake-abs"
        },
        "anti-lock-braking-system": {
            parent: "car-brake-abs"
        },
        antivirus: {
            parent: "shield-bug"
        },
        "antivirus-outline": {
            parent: "shield-bug-outline"
        },
        apiarists: {
            parent: "beekeeper"
        },
        apiculturists: {
            parent: "beekeeper"
        },
        "app-badge": {
            parent: "checkbox-blank-badge"
        },
        "app-badge-outline": {
            parent: "checkbox-blank-badge-outline"
        },
        "app-notification": {
            parent: "checkbox-blank-badge"
        },
        "app-notification-outline": {
            parent: "checkbox-blank-badge-outline"
        },
        applause: {
            parent: "hand-clap"
        },
        "applause-off": {
            parent: "hand-clap-off"
        },
        "apple-airplay": {
            parent: "cast-audio-variant"
        },
        "apple-ipod": {
            parent: "ipod"
        },
        "apple-mobileme": {
            parent: "apple-icloud"
        },
        "application-export-outline": {
            parent: "application-export"
        },
        "application-import-outline": {
            parent: "application-import"
        },
        approval: {
            parent: "check-decagram"
        },
        approve: {
            parent: "check-decagram"
        },
        aquarium: {
            parent: "fishbowl"
        },
        "aquarium-outline": {
            parent: "fishbowl-outline"
        },
        arachnid: {
            parent: "spider"
        },
        "arachnid-thread": {
            parent: "spider-thread"
        },
        "arachnid-web": {
            parent: "spider-web"
        },
        architecture: {
            parent: "ruler-square"
        },
        "archive-add": {
            parent: "archive-plus"
        },
        "archive-add-outline": {
            parent: "archive-plus-outline"
        },
        "archive-favorite": {
            parent: "archive-star"
        },
        "archive-favorite-outline": {
            parent: "archive-star-outline"
        },
        "archive-location": {
            parent: "archive-marker"
        },
        "archive-location-outline": {
            parent: "archive-marker-outline"
        },
        "archive-time": {
            parent: "archive-clock"
        },
        "archive-time-outline": {
            parent: "archive-clock-outline"
        },
        "archive-view": {
            parent: "archive-eye"
        },
        "archive-view-outline": {
            parent: "archive-eye-outline"
        },
        arena: {
            parent: "stadium"
        },
        "arena-outline": {
            parent: "stadium-outline"
        },
        "arm-barrier": {
            parent: "boom-gate"
        },
        "arm-barrier-alert": {
            parent: "boom-gate-alert"
        },
        "arm-barrier-alert-outline": {
            parent: "boom-gate-alert-outline"
        },
        "arm-barrier-down": {
            parent: "boom-gate-arrow-down"
        },
        "arm-barrier-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        "arm-barrier-outline": {
            parent: "boom-gate-outline"
        },
        "arm-barrier-up": {
            parent: "boom-gate-arrow-up"
        },
        "arm-barrier-up-outline": {
            parent: "boom-gate-arrow-up-outline"
        },
        aroma: {
            parent: "scent"
        },
        "aroma-off": {
            parent: "scent-off"
        },
        arrow: {
            parent: "redo"
        },
        "arrow-back": {
            parent: "arrow-left"
        },
        "arrow-back-circle": {
            parent: "arrow-left-circle"
        },
        "arrow-bottom": {
            parent: "arrow-down"
        },
        "arrow-bottom-bold": {
            parent: "arrow-down-bold"
        },
        "arrow-bottom-bold-box": {
            parent: "arrow-down-bold-box"
        },
        "arrow-bottom-bold-box-outline": {
            parent: "arrow-down-bold-box-outline"
        },
        "arrow-bottom-bold-circle": {
            parent: "arrow-down-bold-circle"
        },
        "arrow-bottom-bold-circle-outline": {
            parent: "arrow-down-bold-circle-outline"
        },
        "arrow-bottom-bold-hexagon-outline": {
            parent: "arrow-down-bold-hexagon-outline"
        },
        "arrow-bottom-bold-outline": {
            parent: "arrow-down-bold-outline"
        },
        "arrow-bottom-box": {
            parent: "arrow-down-box"
        },
        "arrow-bottom-circle": {
            parent: "arrow-down-circle"
        },
        "arrow-bottom-circle-outline": {
            parent: "arrow-down-circle-outline"
        },
        "arrow-bottom-drop-circle": {
            parent: "arrow-down-drop-circle"
        },
        "arrow-bottom-drop-circle-outline": {
            parent: "arrow-down-drop-circle-outline"
        },
        "arrow-bottom-left-bold": {
            parent: "arrow-bottom-left-thick"
        },
        "arrow-bottom-right-bold": {
            parent: "arrow-bottom-right-thick"
        },
        "arrow-bottom-thick": {
            parent: "arrow-down-thick"
        },
        "arrow-compass": {
            parent: "navigation"
        },
        "arrow-compress": {
            parent: "arrow-collapse"
        },
        "arrow-compress-all": {
            parent: "arrow-collapse-all"
        },
        "arrow-compress-down": {
            parent: "arrow-collapse-down"
        },
        "arrow-compress-left": {
            parent: "arrow-collapse-left"
        },
        "arrow-compress-right": {
            parent: "arrow-collapse-right"
        },
        "arrow-compress-up": {
            parent: "arrow-collapse-up"
        },
        "arrow-down-drop": {
            parent: "menu-down"
        },
        "arrow-down-left-bold-outline": {
            parent: "arrow-bottom-left-bold-outline"
        },
        "arrow-down-left-thick": {
            parent: "arrow-bottom-left-thick"
        },
        "arrow-down-right-bold-outline": {
            parent: "arrow-bottom-right-bold-outline"
        },
        "arrow-down-right-thick": {
            parent: "arrow-bottom-right-thick"
        },
        "arrow-downward": {
            parent: "arrow-down"
        },
        "arrow-drop-down": {
            parent: "menu-down"
        },
        "arrow-drop-down-circle": {
            parent: "arrow-down-drop-circle"
        },
        "arrow-drop-up": {
            parent: "menu-up"
        },
        "arrow-forward": {
            parent: "arrow-right"
        },
        "arrow-forward-circle": {
            parent: "arrow-right-circle"
        },
        "arrow-horizontal-collapse": {
            parent: "format-horizontal-align-center"
        },
        "arrow-rotate-left": {
            parent: "rotate-left"
        },
        "arrow-rotate-right": {
            parent: "rotate-right"
        },
        "arrow-top": {
            parent: "arrow-up"
        },
        "arrow-top-bold": {
            parent: "arrow-up-bold"
        },
        "arrow-top-bold-box": {
            parent: "arrow-up-bold-box"
        },
        "arrow-top-bold-box-outline": {
            parent: "arrow-up-bold-box-outline"
        },
        "arrow-top-bold-circle": {
            parent: "arrow-up-bold-circle"
        },
        "arrow-top-bold-circle-outline": {
            parent: "arrow-up-bold-circle-outline"
        },
        "arrow-top-bold-hexagon-outline": {
            parent: "arrow-up-bold-hexagon-outline"
        },
        "arrow-top-bold-outline": {
            parent: "arrow-up-bold-outline"
        },
        "arrow-top-circle": {
            parent: "arrow-up-circle"
        },
        "arrow-top-circle-outline": {
            parent: "arrow-up-circle-outline"
        },
        "arrow-top-drop-circle": {
            parent: "arrow-up-drop-circle"
        },
        "arrow-top-drop-circle-outline": {
            parent: "arrow-up-drop-circle-outline"
        },
        "arrow-top-left-bold": {
            parent: "arrow-top-left-thick"
        },
        "arrow-top-right-bold": {
            parent: "arrow-top-right-thick"
        },
        "arrow-top-thick": {
            parent: "arrow-up-thick"
        },
        "arrow-up-left-bold-outline": {
            parent: "arrow-top-left-bold-outline"
        },
        "arrow-up-left-thick": {
            parent: "arrow-top-left-thick"
        },
        "arrow-up-right-bold-outline": {
            parent: "arrow-top-right-bold-outline"
        },
        "arrow-up-right-thick": {
            parent: "arrow-top-right-thick"
        },
        "arrow-upward": {
            parent: "arrow-up"
        },
        "arrow-vertical-collapse": {
            parent: "format-vertical-align-center"
        },
        art: {
            parent: "palette"
        },
        artist: {
            parent: "account-music"
        },
        "artist-outline": {
            parent: "account-music-outline"
        },
        "asian-noodles": {
            parent: "noodles"
        },
        assembly: {
            parent: "robot-industrial"
        },
        assignment: {
            parent: "clipboard-text"
        },
        "assignment-ind": {
            parent: "clipboard-account"
        },
        "assignment-ind-outline": {
            parent: "clipboard-account-outline"
        },
        "assignment-late": {
            parent: "clipboard-alert"
        },
        "assignment-return": {
            parent: "clipboard-arrow-left"
        },
        "assignment-returned": {
            parent: "clipboard-arrow-down"
        },
        "assignment-returned-outline": {
            parent: "clipboard-arrow-down-outline"
        },
        "assignment-turned-in": {
            parent: "clipboard-check"
        },
        "assistant-photo": {
            parent: "flag"
        },
        "atomic-bomb": {
            parent: "nuke"
        },
        "attach-drive": {
            parent: "google-drive"
        },
        "attach-file": {
            parent: "paperclip"
        },
        "attach-money": {
            parent: "currency-usd"
        },
        "attachment-add": {
            parent: "attachment-plus"
        },
        "attachment-subtract": {
            parent: "attachment-minus"
        },
        "attachment-tick": {
            parent: "attachment-check"
        },
        "attachment-vertical": {
            parent: "paperclip"
        },
        audio: {
            parent: "multimedia"
        },
        "audio-book": {
            parent: "book-music"
        },
        "audio-induction-loop": {
            parent: "ear-hearing-loop"
        },
        "audio-off": {
            parent: "volume-off"
        },
        audiobook: {
            parent: "book-music"
        },
        "aurora-australis": {
            parent: "aurora"
        },
        "aurora-borealis": {
            parent: "aurora"
        },
        "auto-awesome": {
            parent: "creation"
        },
        "auto-awesome-mosaic": {
            parent: "collage"
        },
        "auto-awesome-motion": {
            parent: "animation"
        },
        "auto-fix-high": {
            parent: "auto-fix"
        },
        "auto-pay": {
            parent: "cash-clock"
        },
        "auto-start": {
            parent: "refresh-auto"
        },
        "auto-stop": {
            parent: "refresh-auto"
        },
        "auto-stories": {
            parent: "book-open-page-variant"
        },
        "auto-towing": {
            parent: "tow-truck"
        },
        autobahn: {
            parent: "highway"
        },
        automatic: {
            parent: "refresh-auto"
        },
        "automatic-gate": {
            parent: "boom-gate"
        },
        "automatic-gate-alert": {
            parent: "boom-gate-alert"
        },
        "automatic-gate-alert-outline": {
            parent: "boom-gate-alert-outline"
        },
        "automatic-gate-down": {
            parent: "boom-gate-arrow-down"
        },
        "automatic-gate-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        "automatic-gate-outline": {
            parent: "boom-gate-outline"
        },
        "automatic-gate-up": {
            parent: "boom-gate-arrow-up"
        },
        "automatic-gate-up-outline": {
            parent: "boom-gate-arrow-up-outline"
        },
        "automatic-start": {
            parent: "refresh-auto"
        },
        "automatic-stop": {
            parent: "refresh-auto"
        },
        autonomous: {
            parent: "robot-industrial"
        },
        "av-receiver": {
            parent: "audio-video"
        },
        "av-receiver-off": {
            parent: "audio-video-off"
        },
        avalanche: {
            parent: "landslide"
        },
        "avalanche-outline": {
            parent: "landslide-outline"
        },
        award: {
            parent: "license"
        },
        azure: {
            parent: "microsoft-azure"
        },
        "azure-devops": {
            parent: "microsoft-azure-devops"
        },
        "baby-room": {
            parent: "cradle"
        },
        "baby-room-outline": {
            parent: "cradle-outline"
        },
        backpack: {
            parent: "bag-personal"
        },
        "backpack-off": {
            parent: "bag-personal-off"
        },
        "backpack-off-outline": {
            parent: "bag-personal-off-outline"
        },
        "backpack-outline": {
            parent: "bag-personal-outline"
        },
        backup: {
            parent: "cloud-upload"
        },
        "backup-outline": {
            parent: "cloud-upload-outline"
        },
        badge: {
            parent: "shield-star"
        },
        "badge-outline": {
            parent: "shield-star-outline"
        },
        bakery: {
            parent: "baguette"
        },
        ballet: {
            parent: "human-female-dance"
        },
        ban: {
            parent: "cancel"
        },
        "band-aid": {
            parent: "bandage"
        },
        "bangladeshi-taka": {
            parent: "currency-bdt"
        },
        "bank-add": {
            parent: "bank-plus"
        },
        bar: {
            parent: "beer"
        },
        "bar-chart": {
            parent: "poll"
        },
        "bar-outline": {
            parent: "beer-outline"
        },
        barbecue: {
            parent: "grill"
        },
        "barbecue-outline": {
            parent: "grill-outline"
        },
        barbell: {
            parent: "dumbbell"
        },
        "barcode-scanner": {
            parent: "barcode-scan"
        },
        barometer: {
            parent: "gauge"
        },
        barrier: {
            parent: "boom-gate"
        },
        "barrier-alert": {
            parent: "boom-gate-alert"
        },
        "barrier-alert-outline": {
            parent: "boom-gate-alert-outline"
        },
        "barrier-down": {
            parent: "boom-gate-arrow-down"
        },
        "barrier-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        "barrier-outline": {
            parent: "boom-gate-outline"
        },
        "barrier-up": {
            parent: "boom-gate-arrow-up"
        },
        "barrier-up-outline": {
            parent: "boom-gate-arrow-up-outline"
        },
        base: {
            parent: "ph"
        },
        bassinet: {
            parent: "cradle"
        },
        bathroom: {
            parent: "shower"
        },
        "bathroom-tap": {
            parent: "faucet"
        },
        "bathroom-tissue": {
            parent: "paper-roll"
        },
        "bathroom-tissue-outline": {
            parent: "paper-roll-outline"
        },
        "batter-0-clock": {
            parent: "battery-clock-outline"
        },
        "battery-0": {
            parent: "battery-outline"
        },
        "battery-100": {
            parent: "battery"
        },
        "battery-100-clock": {
            parent: "battery-clock"
        },
        "battery-add": {
            parent: "battery-plus-variant"
        },
        "battery-bluetooth-100": {
            parent: "battery-bluetooth"
        },
        "battery-bluetooth-full": {
            parent: "battery-bluetooth"
        },
        "battery-charging-full": {
            parent: "battery-charging"
        },
        "battery-charging-wireless-0": {
            parent: "battery-charging-wireless-outline"
        },
        "battery-charging-wireless-100": {
            parent: "battery-charging-wireless"
        },
        "battery-charging-wireless-empty": {
            parent: "battery-charging-wireless-outline"
        },
        "battery-charging-wireless-full": {
            parent: "battery-charging-wireless"
        },
        "battery-charging-wireless-warning": {
            parent: "battery-charging-wireless-alert"
        },
        "battery-eco": {
            parent: "battery-sync"
        },
        "battery-eco-outline": {
            parent: "battery-sync-outline"
        },
        "battery-empty": {
            parent: "battery-outline"
        },
        "battery-empty-clock": {
            parent: "battery-clock-outline"
        },
        "battery-full": {
            parent: "battery"
        },
        "battery-full-clock": {
            parent: "battery-clock"
        },
        "battery-recycle": {
            parent: "battery-sync"
        },
        "battery-recycle-outline": {
            parent: "battery-sync-outline"
        },
        "battery-saver": {
            parent: "battery-plus-variant"
        },
        "battery-saver-outline": {
            parent: "battery-sync-outline"
        },
        "battery-std": {
            parent: "battery"
        },
        "battery-warning": {
            parent: "battery-alert"
        },
        "battery-warning-bluetooth": {
            parent: "battery-alert-bluetooth"
        },
        "battle-net": {
            parent: "battlenet"
        },
        bbq: {
            parent: "grill"
        },
        "bbq-outline": {
            parent: "grill-outline"
        },
        beacon: {
            parent: "lighthouse"
        },
        "beats-per-minute": {
            parent: "metronome"
        },
        "beats-per-minute-tick": {
            parent: "metronome-tick"
        },
        "bed-schedule": {
            parent: "bed-clock"
        },
        "bed-time": {
            parent: "bed-clock"
        },
        bedroom: {
            parent: "bed-double"
        },
        "bedroom-outline": {
            parent: "bed-double-outline"
        },
        beef: {
            parent: "food-steak"
        },
        "beef-off": {
            parent: "food-steak-off"
        },
        beenhere: {
            parent: "marker-check"
        },
        "bell-add": {
            parent: "bell-plus"
        },
        "bell-add-outline": {
            parent: "bell-plus-outline"
        },
        "bell-notification": {
            parent: "bell-badge"
        },
        "bell-notification-outline": {
            parent: "bell-badge-outline"
        },
        "bell-settings": {
            parent: "bell-cog"
        },
        "bell-settings-outline": {
            parent: "bell-cog-outline"
        },
        "bell-warning": {
            parent: "bell-alert"
        },
        beverages: {
            parent: "liquor"
        },
        bezier: {
            parent: "vector-curve"
        },
        bible: {
            parent: "book-cross"
        },
        "bicycle-antique": {
            parent: "bicycle-penny-farthing"
        },
        "bicycle-high-wheel": {
            parent: "bicycle-penny-farthing"
        },
        bidet: {
            parent: "toilet"
        },
        "bike-basket": {
            parent: "bicycle-basket"
        },
        "bike-cargo": {
            parent: "bicycle-cargo"
        },
        "bike-electric": {
            parent: "bicycle-electric"
        },
        "billiards-triangle": {
            parent: "billiards-rack"
        },
        bin: {
            parent: "delete"
        },
        "bin-circle": {
            parent: "delete-circle"
        },
        "bin-circle-outline": {
            parent: "delete-circle-outline"
        },
        "bin-empty": {
            parent: "delete-empty"
        },
        "bin-outline": {
            parent: "delete-outline"
        },
        "bin-restore": {
            parent: "delete-restore"
        },
        "bin-variant": {
            parent: "delete-variant"
        },
        bing: {
            parent: "microsoft-bing"
        },
        biography: {
            parent: "text-account"
        },
        "birthday-cake": {
            parent: "cake"
        },
        "birthday-cake-outline": {
            parent: "cake-variant-outline"
        },
        biscuit: {
            parent: "cookie"
        },
        "biscuit-alert": {
            parent: "cookie-alert"
        },
        "biscuit-alert-outline": {
            parent: "cookie-alert-outline"
        },
        "biscuit-check": {
            parent: "cookie-check"
        },
        "biscuit-check-outline": {
            parent: "cookie-check-outline"
        },
        "biscuit-clock": {
            parent: "cookie-clock"
        },
        "biscuit-clock-outline": {
            parent: "cookie-clock-outline"
        },
        "biscuit-cog": {
            parent: "cookie-cog"
        },
        "biscuit-cog-outline": {
            parent: "cookie-cog-outline"
        },
        "biscuit-crumbs": {
            parent: "cookie-settings"
        },
        "biscuit-crumbs-outline": {
            parent: "cookie-settings-outline"
        },
        "biscuit-edit": {
            parent: "cookie-edit"
        },
        "biscuit-edit-outline": {
            parent: "cookie-edit-outline"
        },
        "biscuit-lock": {
            parent: "cookie-lock"
        },
        "biscuit-lock-outline": {
            parent: "cookie-lock-outline"
        },
        "biscuit-minus": {
            parent: "cookie-minus"
        },
        "biscuit-minus-outline": {
            parent: "cookie-minus-outline"
        },
        "biscuit-off": {
            parent: "cookie-off"
        },
        "biscuit-off-outline": {
            parent: "cookie-off-outline"
        },
        "biscuit-outline": {
            parent: "cookie-outline"
        },
        "biscuit-plus": {
            parent: "cookie-plus"
        },
        "biscuit-plus-outline": {
            parent: "cookie-plus-outline"
        },
        "biscuit-refresh": {
            parent: "cookie-refresh"
        },
        "biscuit-refresh-outline": {
            parent: "cookie-refresh-outline"
        },
        "biscuit-remove": {
            parent: "cookie-remove"
        },
        "biscuit-remove-outline": {
            parent: "cookie-remove-outline"
        },
        "biscuit-settings": {
            parent: "cookie-settings"
        },
        "biscuit-settings-outline": {
            parent: "cookie-settings-outline"
        },
        blackboard: {
            parent: "human-male-board"
        },
        "blinds-closed": {
            parent: "roller-shade-closed"
        },
        blinky: {
            parent: "ghost"
        },
        block: {
            parent: "cancel"
        },
        "block-chain": {
            parent: "link-lock"
        },
        blog: {
            parent: "post"
        },
        "blog-outline": {
            parent: "post-outline"
        },
        blood: {
            parent: "liquid-spot"
        },
        "blood-alert": {
            parent: "water-alert"
        },
        "blood-alert-outline": {
            parent: "water-alert-outline"
        },
        "blood-check": {
            parent: "water-check"
        },
        "blood-check-outline": {
            parent: "water-check-outline"
        },
        "blood-circle": {
            parent: "water-circle"
        },
        "blood-minus": {
            parent: "water-minus"
        },
        "blood-minus-outline": {
            parent: "water-minus-outline"
        },
        "blood-off": {
            parent: "water-off"
        },
        "blood-off-outline": {
            parent: "water-off-outline"
        },
        "blood-outline": {
            parent: "water-outline"
        },
        "blood-plus": {
            parent: "water-plus"
        },
        "blood-plus-outline": {
            parent: "water-plus-outline"
        },
        "blood-remove": {
            parent: "water-remove"
        },
        "blood-remove-outline": {
            parent: "water-remove-outline"
        },
        "blood-saver": {
            parent: "water-opacity"
        },
        "blood-transparent": {
            parent: "water-opacity"
        },
        "bluetooth-connected": {
            parent: "bluetooth-connect"
        },
        "bluetooth-disabled": {
            parent: "bluetooth-off"
        },
        "bluetooth-searching": {
            parent: "bluetooth-audio"
        },
        "blur-circular": {
            parent: "blur-radial"
        },
        "blur-on": {
            parent: "blur"
        },
        boat: {
            parent: "ferry"
        },
        "boil-point": {
            parent: "water-thermometer"
        },
        "boil-point-outline": {
            parent: "water-thermometer-outline"
        },
        "boiling-point": {
            parent: "thermometer-water"
        },
        "bolnisi-cross": {
            parent: "cross-bolnisi"
        },
        "book-add": {
            parent: "book-plus"
        },
        "book-favorite": {
            parent: "book-heart"
        },
        "book-favorite-outline": {
            parent: "book-heart-outline"
        },
        "book-image": {
            parent: "image-album"
        },
        "book-location": {
            parent: "book-marker"
        },
        "book-location-outline": {
            parent: "book-marker-outline"
        },
        "book-love": {
            parent: "book-heart"
        },
        "book-love-outline": {
            parent: "book-heart-outline"
        },
        "book-multiple-add": {
            parent: "book-plus-multiple"
        },
        "book-schedule": {
            parent: "book-clock"
        },
        "book-secure": {
            parent: "book-lock"
        },
        "book-secure-outline": {
            parent: "book-lock-outline"
        },
        "book-time": {
            parent: "book-clock"
        },
        "book-unsecure": {
            parent: "book-lock-open"
        },
        "bookmark-add": {
            parent: "bookmark-plus"
        },
        "bookmark-add-outline": {
            parent: "bookmark-plus-outline"
        },
        "bookmark-border": {
            parent: "bookmark-outline"
        },
        "bookmark-tick": {
            parent: "bookmark-check"
        },
        books: {
            parent: "book-multiple"
        },
        "books-add": {
            parent: "book-plus-multiple"
        },
        "books-minus": {
            parent: "book-minus-multiple"
        },
        "books-plus": {
            parent: "book-plus-multiple"
        },
        "books-remove": {
            parent: "book-remove-multiple"
        },
        "books-variant": {
            parent: "book-variant-multiple"
        },
        "boom-arm": {
            parent: "boom-gate"
        },
        "boom-arm-alert": {
            parent: "boom-gate-alert"
        },
        "boom-arm-alert-outline": {
            parent: "boom-gate-alert-outline"
        },
        "boom-arm-down": {
            parent: "boom-gate-arrow-down"
        },
        "boom-arm-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        "boom-arm-outline": {
            parent: "boom-gate-outline"
        },
        "boom-arm-up": {
            parent: "boom-gate-arrow-up"
        },
        "boom-arm-up-outline": {
            parent: "boom-gate-arrow-up-outline"
        },
        "boom-barrier": {
            parent: "boom-gate"
        },
        "boom-barrier-alert": {
            parent: "boom-gate-alert"
        },
        "boom-barrier-alert-outline": {
            parent: "boom-gate-alert-outline"
        },
        "boom-barrier-down": {
            parent: "boom-gate-arrow-down"
        },
        "boom-barrier-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        "boom-barrier-outline": {
            parent: "boom-gate-outline"
        },
        "boom-barrier-up": {
            parent: "boom-gate-arrow-up"
        },
        "boom-barrier-up-outline": {
            parent: "boom-gate-arrow-up-outline"
        },
        "boom-gate-down": {
            parent: "boom-gate-arrow-down"
        },
        "boom-gate-down-outline": {
            parent: "boom-gate-arrow-down-outline"
        },
        booze: {
            parent: "liquor"
        },
        "border-clear": {
            parent: "border-none"
        },
        "border-colour": {
            parent: "border-color"
        },
        "border-outer": {
            parent: "border-outside"
        },
        "border-round-corners": {
            parent: "border-radius"
        },
        "bottle-coke": {
            parent: "bottle-soda"
        },
        "bottle-coke-classic": {
            parent: "bottle-soda-classic"
        },
        "bottle-coke-outline": {
            parent: "bottle-soda-outline"
        },
        "bottle-plus": {
            parent: "medication"
        },
        "bottle-plus-outline": {
            parent: "medication-outline"
        },
        "bottle-pop": {
            parent: "bottle-soda"
        },
        "bottle-pop-classic": {
            parent: "bottle-soda-classic"
        },
        "bottle-pop-outline": {
            parent: "bottle-soda-outline"
        },
        "bottle-rocket": {
            parent: "firework"
        },
        "box-add": {
            parent: "archive-plus"
        },
        "box-add-outline": {
            parent: "archive-plus-outline"
        },
        "box-alert": {
            parent: "archive-alert"
        },
        "box-alert-outline": {
            parent: "archive-alert-outline"
        },
        "box-arrow-down": {
            parent: "archive-arrow-down"
        },
        "box-arrow-up": {
            parent: "archive-arrow-up"
        },
        "box-arrow-up-outline": {
            parent: "archive-arrow-up-outline"
        },
        "box-cancel": {
            parent: "archive-cancel"
        },
        "box-cancel-outline": {
            parent: "archive-cancel-outline"
        },
        "box-check": {
            parent: "archive-check"
        },
        "box-check-outline": {
            parent: "archive-check-outline"
        },
        "box-clock": {
            parent: "archive-clock"
        },
        "box-clock-outline": {
            parent: "archive-clock-outline"
        },
        "box-cog": {
            parent: "archive-cog"
        },
        "box-cog-outline": {
            parent: "archive-cog-outline"
        },
        "box-down": {
            parent: "package-down"
        },
        "box-edit": {
            parent: "archive-edit"
        },
        "box-edit-outline": {
            parent: "archive-edit-outline"
        },
        "box-eye": {
            parent: "archive-eye"
        },
        "box-eye-outline": {
            parent: "archive-eye-outline"
        },
        "box-favorite": {
            parent: "archive-star"
        },
        "box-favorite-outline": {
            parent: "archive-star-outline"
        },
        "box-location": {
            parent: "archive-marker"
        },
        "box-location-outline": {
            parent: "archive-marker-outline"
        },
        "box-lock": {
            parent: "archive-lock"
        },
        "box-lock-open": {
            parent: "archive-lock-open"
        },
        "box-lock-open-outline": {
            parent: "archive-lock-open-outline"
        },
        "box-lock-outline": {
            parent: "archive-lock-outline"
        },
        "box-marker": {
            parent: "archive-marker"
        },
        "box-marker-outline": {
            parent: "archive-marker-outline"
        },
        "box-minus": {
            parent: "archive-minus"
        },
        "box-minus-outline": {
            parent: "archive-minus-outline"
        },
        "box-music": {
            parent: "archive-music"
        },
        "box-music-outline": {
            parent: "archive-music-outline"
        },
        "box-off": {
            parent: "archive-off"
        },
        "box-off-outline": {
            parent: "archive-off-outline"
        },
        "box-outline": {
            parent: "archive-outline"
        },
        "box-plus": {
            parent: "archive-plus"
        },
        "box-plus-outline": {
            parent: "archive-plus-outline"
        },
        "box-refresh": {
            parent: "archive-refresh"
        },
        "box-refresh-outline": {
            parent: "archive-refresh-outline"
        },
        "box-remove": {
            parent: "archive-remove"
        },
        "box-remove-outline": {
            parent: "archive-remove-outline"
        },
        "box-search": {
            parent: "archive-search"
        },
        "box-search-outline": {
            parent: "archive-search-outline"
        },
        "box-settings": {
            parent: "archive-settings"
        },
        "box-settings-outline": {
            parent: "archive-settings-outline"
        },
        "box-star": {
            parent: "archive-star"
        },
        "box-star-outline": {
            parent: "archive-star-outline"
        },
        "box-sync": {
            parent: "archive-sync"
        },
        "box-sync-outline": {
            parent: "archive-sync-outline"
        },
        "box-time": {
            parent: "archive-clock"
        },
        "box-time-outline": {
            parent: "archive-clock-outline"
        },
        "box-up": {
            parent: "package-up"
        },
        "box-variant": {
            parent: "package-variant"
        },
        "box-variant-add": {
            parent: "package-variant-plus"
        },
        "box-variant-closed": {
            parent: "package-variant-closed"
        },
        "box-variant-closed-add": {
            parent: "package-variant-closed-plus"
        },
        "box-variant-closed-minus": {
            parent: "package-variant-closed-minus"
        },
        "box-variant-closed-plus": {
            parent: "package-variant-closed-plus"
        },
        "box-variant-closed-remove": {
            parent: "package-variant-closed-remove"
        },
        "box-variant-closed-subtract": {
            parent: "package-variant-closed-minus"
        },
        "box-variant-minus": {
            parent: "package-variant-minus"
        },
        "box-variant-plus": {
            parent: "package-variant-plus"
        },
        "box-variant-remove": {
            parent: "package-variant-remove"
        },
        "box-variant-subtract": {
            parent: "package-variant-minus"
        },
        "box-view": {
            parent: "archive-eye"
        },
        "box-view-outline": {
            parent: "archive-eye-outline"
        },
        bpm: {
            parent: "metronome"
        },
        "bpm-tick": {
            parent: "metronome-tick"
        },
        bra: {
            parent: "lingerie"
        },
        bracket: {
            parent: "tournament"
        },
        "brain-freeze": {
            parent: "head-snowflake"
        },
        "brain-freeze-outline": {
            parent: "head-snowflake-outline"
        },
        "branding-watermark": {
            parent: "watermark"
        },
        "brazilian-real": {
            parent: "currency-brl"
        },
        bread: {
            parent: "baguette"
        },
        "breast-feed": {
            parent: "mother-nurse"
        },
        bricks: {
            parent: "wall"
        },
        "briefcase-add": {
            parent: "briefcase-plus"
        },
        "briefcase-add-outline": {
            parent: "briefcase-plus-outline"
        },
        "briefcase-exchange": {
            parent: "briefcase-arrow-left-right"
        },
        "briefcase-exchange-outline": {
            parent: "briefcase-arrow-left-right-outline"
        },
        "briefcase-person": {
            parent: "briefcase-account"
        },
        "briefcase-person-outline": {
            parent: "briefcase-account-outline"
        },
        "briefcase-swap": {
            parent: "briefcase-arrow-left-right"
        },
        "briefcase-swap-outline": {
            parent: "briefcase-arrow-left-right-outline"
        },
        "briefcase-tick": {
            parent: "briefcase-check"
        },
        "briefcase-transfer": {
            parent: "briefcase-arrow-left-right"
        },
        "briefcase-transfer-outline": {
            parent: "briefcase-arrow-left-right-outline"
        },
        "briefcase-user": {
            parent: "briefcase-account"
        },
        "briefcase-user-outline": {
            parent: "briefcase-account-outline"
        },
        "briefcase-view": {
            parent: "briefcase-eye"
        },
        "briefcase-view-outline": {
            parent: "briefcase-eye-outline"
        },
        "brightness-half": {
            parent: "circle-half"
        },
        "brightness-high": {
            parent: "brightness-7"
        },
        "brightness-low": {
            parent: "brightness-5"
        },
        "brightness-medium": {
            parent: "brightness-6"
        },
        "broken-image": {
            parent: "image-broken-variant"
        },
        "bubble-chart": {
            parent: "chart-bubble"
        },
        "bucket-minus": {
            parent: "pail-minus"
        },
        "bucket-minus-outline": {
            parent: "pail-minus-outline"
        },
        "bucket-off": {
            parent: "pail-off"
        },
        "bucket-off-outline": {
            parent: "pail-off-outline"
        },
        "bucket-plus": {
            parent: "pail-plus"
        },
        "bucket-plus-outline": {
            parent: "pail-plus-outline"
        },
        "bucket-remove": {
            parent: "pail-remove"
        },
        "bucket-remove-outline": {
            parent: "pail-remove-outline"
        },
        buddhism: {
            parent: "dharmachakra"
        },
        "bug-report": {
            parent: "bug"
        },
        "bug-start": {
            parent: "bug-play"
        },
        "bug-tick": {
            parent: "bug-check"
        },
        "bug-tick-outline": {
            parent: "bug-check-outline"
        },
        bugfood: {
            parent: "ladybug"
        },
        buggy: {
            parent: "baby-carriage"
        },
        "buggy-off": {
            parent: "baby-carriage-off"
        },
        build: {
            parent: "wrench"
        },
        "build-outline": {
            parent: "wrench-outline"
        },
        building: {
            parent: "domain"
        },
        bulb: {
            parent: "lightbulb"
        },
        "bulb-cfl": {
            parent: "lightbulb-cfl"
        },
        "bulb-cfl-off": {
            parent: "lightbulb-cfl-off"
        },
        "bulb-cfl-spiral": {
            parent: "lightbulb-cfl-spiral"
        },
        "bulb-cfl-spiral-off": {
            parent: "lightbulb-cfl-spiral-off"
        },
        "bulb-group": {
            parent: "lightbulb-group"
        },
        "bulb-group-off": {
            parent: "lightbulb-group-off"
        },
        "bulb-group-off-outline": {
            parent: "lightbulb-group-off-outline"
        },
        "bulb-group-outline": {
            parent: "lightbulb-group-outline"
        },
        "bulb-multiple": {
            parent: "lightbulb-multiple"
        },
        "bulb-multiple-off": {
            parent: "lightbulb-multiple-off"
        },
        "bulb-multiple-off-outline": {
            parent: "lightbulb-multiple-off-outline"
        },
        "bulb-multiple-outline": {
            parent: "lightbulb-multiple-outline"
        },
        "bulb-off": {
            parent: "lightbulb-off"
        },
        "bulb-off-outline": {
            parent: "lightbulb-off-outline"
        },
        "bulb-on": {
            parent: "lightbulb-on"
        },
        "bulb-on-outline": {
            parent: "lightbulb-on-outline"
        },
        "bulb-outline": {
            parent: "lightbulb-outline"
        },
        bulbs: {
            parent: "lightbulb-multiple"
        },
        "bulbs-multiple-off-outline": {
            parent: "lightbulb-multiple-off-outline"
        },
        "bulbs-off": {
            parent: "lightbulb-multiple-off"
        },
        "bulbs-off-outline": {
            parent: "lightbulb-multiple-off-outline"
        },
        "bulbs-outline": {
            parent: "lightbulb-multiple-outline"
        },
        bullets: {
            parent: "ammunition"
        },
        bunny: {
            parent: "rabbit"
        },
        "bunny-outline": {
            parent: "rabbit-variant-outline"
        },
        burger: {
            parent: "food"
        },
        "burger-add": {
            parent: "hamburger-plus"
        },
        "burger-check": {
            parent: "hamburger-check"
        },
        "burger-minus": {
            parent: "hamburger-minus"
        },
        "burger-off": {
            parent: "food-off"
        },
        "burger-plus": {
            parent: "hamburger-plus"
        },
        "burger-remove": {
            parent: "hamburger-remove"
        },
        "burst-mode": {
            parent: "camera-burst"
        },
        "bus-location": {
            parent: "bus-marker"
        },
        "bus-warning": {
            parent: "bus-alert"
        },
        business: {
            parent: "domain"
        },
        "business-card": {
            parent: "card-account-details"
        },
        "business-card-outline": {
            parent: "card-account-details-outline"
        },
        "business-outline": {
            parent: "handshake-outline"
        },
        "business-woman": {
            parent: "account-tie-woman"
        },
        button: {
            parent: "card"
        },
        "button-outline": {
            parent: "card-outline"
        },
        cab: {
            parent: "taxi"
        },
        "cable-car": {
            parent: "gondola"
        },
        "calendar-add": {
            parent: "calendar-plus"
        },
        "calendar-day": {
            parent: "calendar-today"
        },
        "calendar-day-outline": {
            parent: "calendar-today-outline"
        },
        "calendar-favorite": {
            parent: "calendar-star"
        },
        "calendar-help": {
            parent: "calendar-question"
        },
        "calendar-help-outline": {
            parent: "calendar-question-outline"
        },
        "calendar-multiple-tick": {
            parent: "calendar-multiple-check"
        },
        "calendar-repeat": {
            parent: "calendar-refresh"
        },
        "calendar-repeat-outline": {
            parent: "calendar-refresh-outline"
        },
        "calendar-rsvp": {
            parent: "calendar-question"
        },
        "calendar-task": {
            parent: "calendar-check"
        },
        "calendar-task-outline": {
            parent: "calendar-check-outline"
        },
        "calendar-tick": {
            parent: "calendar-check"
        },
        "calendar-tick-outline": {
            parent: "calendar-check-outline"
        },
        "calendar-time": {
            parent: "calendar-clock"
        },
        "calendar-user": {
            parent: "calendar-account"
        },
        "calendar-user-outline": {
            parent: "calendar-account-outline"
        },
        "calendar-warning": {
            parent: "calendar-alert"
        },
        calendars: {
            parent: "calendar-multiple"
        },
        "calendars-check": {
            parent: "calendar-multiple-check"
        },
        "calendars-tick": {
            parent: "calendar-multiple-check"
        },
        call: {
            parent: "phone"
        },
        "call-end": {
            parent: "phone-hangup"
        },
        "call-outline": {
            parent: "phone-outline"
        },
        "call-to-action": {
            parent: "gesture-tap-button"
        },
        "camcorder-box": {
            parent: "video-box"
        },
        "camcorder-box-off": {
            parent: "video-box-off"
        },
        "camera-alt": {
            parent: "camera"
        },
        "camera-location": {
            parent: "camera-marker"
        },
        "camera-location-outline": {
            parent: "camera-marker-outline"
        },
        "camera-metering-centre": {
            parent: "camera-metering-center"
        },
        "camera-refresh": {
            parent: "camera-flip"
        },
        "camera-refresh-outline": {
            parent: "camera-flip-outline"
        },
        "camera-roll": {
            parent: "film"
        },
        "camera-sync": {
            parent: "camera-flip"
        },
        "camera-sync-outline": {
            parent: "camera-flip-outline"
        },
        "camera-user": {
            parent: "camera-account"
        },
        campervan: {
            parent: "rv-truck"
        },
        camping: {
            parent: "tent"
        },
        "can-light": {
            parent: "light-recessed"
        },
        "cancel-bold": {
            parent: "close-thick"
        },
        "cancel-box": {
            parent: "close-box"
        },
        "cancel-box-multiple": {
            parent: "close-box-multiple"
        },
        "cancel-box-outline": {
            parent: "close-box-outline"
        },
        "cancel-circle": {
            parent: "close-circle"
        },
        "cancel-circle-multiple-outline": {
            parent: "close-circle-multiple-outline"
        },
        "cancel-circle-outline": {
            parent: "close-circle-outline"
        },
        "cancel-network": {
            parent: "close-network"
        },
        "cancel-network-outline": {
            parent: "close-network-outline"
        },
        "cancel-octagon": {
            parent: "close-octagon"
        },
        "cancel-octagon-outline": {
            parent: "close-octagon-outline"
        },
        "cancel-outline": {
            parent: "close-outline"
        },
        "cancel-thick": {
            parent: "close-thick"
        },
        "candelabra-flame": {
            parent: "candelabra-fire"
        },
        "candelabra-lamp": {
            parent: "chandelier"
        },
        candelabrum: {
            parent: "candelabra"
        },
        "candelabrum-fire": {
            parent: "candelabra-fire"
        },
        "candelabrum-flame": {
            parent: "candelabra-fire"
        },
        "candle-fire": {
            parent: "candelabra-fire"
        },
        "candle-flame": {
            parent: "candelabra-fire"
        },
        canine: {
            parent: "dog-service"
        },
        capsule: {
            parent: "pill"
        },
        "capsule-off": {
            parent: "pill-off"
        },
        "car-autonomous": {
            parent: "car-wireless"
        },
        "car-brake-warning": {
            parent: "car-brake-alert"
        },
        "car-emergency-brake": {
            parent: "car-brake-alert"
        },
        "car-engine-start": {
            parent: "reload"
        },
        "car-find": {
            parent: "car-search"
        },
        "car-find-outline": {
            parent: "car-search-outline"
        },
        "car-front-glass": {
            parent: "car-windshield"
        },
        "car-front-glass-outline": {
            parent: "car-windshield-outline"
        },
        "car-hand-brake": {
            parent: "car-brake-alert"
        },
        "car-handbrake": {
            parent: "car-brake-alert"
        },
        "car-horn": {
            parent: "bugle"
        },
        "car-insurance": {
            parent: "shield-car"
        },
        "car-location": {
            parent: "car-select"
        },
        "car-manual-transmission": {
            parent: "car-shift-pattern"
        },
        "car-park": {
            parent: "parking"
        },
        "car-parking-brake": {
            parent: "car-brake-alert"
        },
        "car-police": {
            parent: "car-emergency"
        },
        "car-rental": {
            parent: "car-key"
        },
        "car-repair": {
            parent: "car-wrench"
        },
        "car-saloon": {
            parent: "car-side"
        },
        "car-security": {
            parent: "shield-car"
        },
        "car-self-driving": {
            parent: "car-wireless"
        },
        "car-smart": {
            parent: "car-wireless"
        },
        "car-sports-utility-vehicle": {
            parent: "car-estate"
        },
        "car-suv": {
            parent: "car-estate"
        },
        "car-tire-warning": {
            parent: "car-tire-alert"
        },
        "car-transmission": {
            parent: "car-shift-pattern"
        },
        "car-tyre-alert": {
            parent: "car-tire-alert"
        },
        "car-tyre-warning": {
            parent: "car-tire-alert"
        },
        "carbon-monoxide": {
            parent: "molecule-co"
        },
        "card-account-details-favorite": {
            parent: "card-account-details-star"
        },
        "card-account-details-favorite-outline": {
            parent: "card-account-details-star-outline"
        },
        "card-giftcard": {
            parent: "wallet-giftcard"
        },
        "card-membership": {
            parent: "wallet-membership"
        },
        "card-travel": {
            parent: "wallet-travel"
        },
        cardholder: {
            parent: "account-credit-card"
        },
        "cardholder-outline": {
            parent: "account-credit-card-outline"
        },
        caret: {
            parent: "chevron-up"
        },
        "caret-down": {
            parent: "menu-down"
        },
        "caret-down-outline": {
            parent: "menu-down-outline"
        },
        "caret-up": {
            parent: "menu-up"
        },
        "caret-up-outline": {
            parent: "menu-up-outline"
        },
        "cargo-ship": {
            parent: "ferry"
        },
        carpentry: {
            parent: "ruler-square"
        },
        carpet: {
            parent: "rug"
        },
        "carpool-lane": {
            parent: "car-2-plus"
        },
        "carpool-lane-outline": {
            parent: "cards-diamond-outline"
        },
        carriage: {
            parent: "baby-buggy"
        },
        "carriage-lamp": {
            parent: "coach-lamp"
        },
        "carriage-light": {
            parent: "coach-lamp"
        },
        "carry-on-bag-check": {
            parent: "bag-carry-on-check"
        },
        "carry-on-bag-tick": {
            parent: "bag-carry-on-check"
        },
        "carry-on-luggage": {
            parent: "bag-carry-on"
        },
        "carry-on-luggage-off": {
            parent: "bag-carry-on-off"
        },
        "cart-add": {
            parent: "cart-plus"
        },
        "cart-discount": {
            parent: "cart-percent"
        },
        "cart-favorite": {
            parent: "cart-heart"
        },
        "cart-sale": {
            parent: "cart-percent"
        },
        "cash-chargeback": {
            parent: "cash-refund"
        },
        "cash-cycle": {
            parent: "cash-sync"
        },
        "cash-location": {
            parent: "cash-marker"
        },
        "cash-on-delivery": {
            parent: "cash-marker"
        },
        "cash-return": {
            parent: "cash-refund"
        },
        "cash-schedule": {
            parent: "cash-clock"
        },
        casino: {
            parent: "slot-machine"
        },
        "casino-chip": {
            parent: "poker-chip"
        },
        "casino-outline": {
            parent: "slot-machine-outline"
        },
        "cast-school": {
            parent: "cast-education"
        },
        "cast-speaker": {
            parent: "cast-audio"
        },
        "cast-tutorial": {
            parent: "cast-education"
        },
        category: {
            parent: "shape"
        },
        "category-outline": {
            parent: "shape-outline"
        },
        cc: {
            parent: "closed-caption"
        },
        "cc-outline": {
            parent: "closed-caption-outline"
        },
        "cd-rom": {
            parent: "disc"
        },
        "ceiling-fan-on": {
            parent: "ceiling-fan-light"
        },
        "ceiling-lamp": {
            parent: "ceiling-light"
        },
        "ceiling-lamp-multiple": {
            parent: "ceiling-light-multiple"
        },
        "ceiling-lamp-multiple-outline": {
            parent: "ceiling-light-multiple-outline"
        },
        "ceiling-light-flat": {
            parent: "wall-sconce-flat"
        },
        celebration: {
            parent: "party-popper"
        },
        "cellphone-download": {
            parent: "cellphone-arrow-down-variant"
        },
        "cellphone-erase": {
            parent: "cellphone-remove"
        },
        "cellphone-gps": {
            parent: "cellphone-marker"
        },
        "cellphone-location": {
            parent: "cellphone-marker"
        },
        "cellphone-map": {
            parent: "cellphone-marker"
        },
        "cellphone-settings-variant": {
            parent: "cellphone-cog"
        },
        "cellphone-system-update": {
            parent: "cellphone-arrow-down"
        },
        "celtic-cross": {
            parent: "cross-celtic"
        },
        cemetery: {
            parent: "grave-stone"
        },
        chair: {
            parent: "seat"
        },
        "chair-accent": {
            parent: "seat"
        },
        "chair-accent-outline": {
            parent: "seat-outline"
        },
        "chair-outline": {
            parent: "seat-outline"
        },
        "change-history": {
            parent: "delta"
        },
        charcoal: {
            parent: "grill"
        },
        "charcoal-outline": {
            parent: "grill-outline"
        },
        "charging-station": {
            parent: "ev-station"
        },
        "charity-outline": {
            parent: "hand-coin-outline"
        },
        "chart-doughnut": {
            parent: "chart-donut"
        },
        "chart-doughnut-variant": {
            parent: "chart-donut-variant"
        },
        "chart-finance": {
            parent: "finance"
        },
        "chart-home": {
            parent: "home-analytics"
        },
        "chart-production-possibility-frontier": {
            parent: "chart-ppf"
        },
        "chart-scatterplot-hexbin": {
            parent: "chart-scatter-plot-hexbin"
        },
        "chart-snakey": {
            parent: "chart-sankey"
        },
        "chart-snakey-variant": {
            parent: "chart-sankey-variant"
        },
        "chat-add": {
            parent: "forum-plus"
        },
        "chat-add-outline": {
            parent: "forum-plus-outline"
        },
        "chat-bubble": {
            parent: "message"
        },
        "chat-bubble-outline": {
            parent: "message-outline"
        },
        "chat-delete": {
            parent: "forum-remove"
        },
        "chat-delete-outline": {
            parent: "forum-remove-outline"
        },
        "chat-help": {
            parent: "chat-question"
        },
        "chat-help-outline": {
            parent: "chat-question-outline"
        },
        "chat-subtract": {
            parent: "forum-minus"
        },
        "chat-subtract-outline": {
            parent: "forum-minus-outline"
        },
        "chat-typing": {
            parent: "chat-processing"
        },
        "chat-typing-outline": {
            parent: "chat-processing-outline"
        },
        "chat-warning": {
            parent: "chat-alert"
        },
        "check-box": {
            parent: "checkbox-marked"
        },
        "check-box-multiple-outline": {
            parent: "checkbox-multiple-outline"
        },
        "check-box-outline": {
            parent: "checkbox-outline"
        },
        "check-box-outline-blank": {
            parent: "checkbox-blank-outline"
        },
        "check-boxes-outline": {
            parent: "checkbox-multiple-outline"
        },
        "check-multiple": {
            parent: "check-all"
        },
        "check-thick": {
            parent: "check-bold"
        },
        "checkbox-blank-notification": {
            parent: "checkbox-blank-badge"
        },
        "checkbox-blank-notification-outline": {
            parent: "checkbox-blank-badge-outline"
        },
        "checkbox-indeterminate-outline": {
            parent: "minus-box-outline"
        },
        "checkboxes-blank": {
            parent: "checkbox-multiple-blank"
        },
        "checkboxes-blank-circle": {
            parent: "checkbox-multiple-blank-circle"
        },
        "checkboxes-blank-circle-outline": {
            parent: "checkbox-multiple-blank-circle-outline"
        },
        "checkboxes-blank-outline": {
            parent: "checkbox-multiple-blank-outline"
        },
        "checkboxes-marked": {
            parent: "checkbox-multiple-marked"
        },
        "checkboxes-marked-circle": {
            parent: "checkbox-multiple-marked-circle"
        },
        "checkboxes-marked-circle-outline": {
            parent: "checkbox-multiple-marked-circle-outline"
        },
        "checkboxes-marked-outline": {
            parent: "checkbox-multiple-marked-outline"
        },
        "checkboxes-multiple-marked": {
            parent: "checkbox-multiple-marked"
        },
        checkers: {
            parent: "crown-circle"
        },
        "checkers-outline": {
            parent: "crown-circle-outline"
        },
        checks: {
            parent: "check-all"
        },
        chemist: {
            parent: "mortar-pestle-plus"
        },
        "cheque-book": {
            parent: "checkbook"
        },
        chequebook: {
            parent: "checkbook"
        },
        "chess-castle": {
            parent: "chess-rook"
        },
        "chess-horse": {
            parent: "chess-knight"
        },
        "chess-tower": {
            parent: "chess-rook"
        },
        "chevron-down-up": {
            parent: "unfold-less-horizontal"
        },
        "chevron-left-first": {
            parent: "page-first"
        },
        "chevron-left-right": {
            parent: "unfold-more-vertical"
        },
        "chevron-right-last": {
            parent: "page-last"
        },
        "chevron-right-left": {
            parent: "unfold-less-vertical"
        },
        "chevron-up-down": {
            parent: "unfold-more-horizontal"
        },
        "chicken-leg": {
            parent: "food-drumstick"
        },
        "chicken-leg-off": {
            parent: "food-drumstick-off"
        },
        "chicken-leg-off-outline": {
            parent: "food-drumstick-off-outline"
        },
        "chicken-leg-outline": {
            parent: "food-drumstick-outline"
        },
        "child-friendly": {
            parent: "baby-carriage"
        },
        "child-friendly-off": {
            parent: "baby-carriage-off"
        },
        "child-toy": {
            parent: "teddy-bear"
        },
        "children-toy": {
            parent: "teddy-bear"
        },
        "childrens-room": {
            parent: "teddy-bear"
        },
        "chilli-hot": {
            parent: "chili-hot"
        },
        "chilli-medium": {
            parent: "chili-medium"
        },
        "chilli-mild": {
            parent: "chili-mild"
        },
        "chilli-off": {
            parent: "chili-off"
        },
        "chip-32-bit": {
            parent: "cpu-32-bit"
        },
        "chip-64-bit": {
            parent: "cpu-64-bit"
        },
        chips: {
            parent: "french-fries"
        },
        chocolate: {
            parent: "candy"
        },
        "chocolate-off": {
            parent: "candy-off"
        },
        "chocolate-off-outline": {
            parent: "candy-off-outline"
        },
        "chocolate-outline": {
            parent: "candy-outline"
        },
        christianity: {
            parent: "cross"
        },
        "christianity-outline": {
            parent: "cross-outline"
        },
        "christmas-lights": {
            parent: "string-lights"
        },
        "christmas-lights-off": {
            parent: "string-lights-off"
        },
        "christmas-star": {
            parent: "hexagram"
        },
        "christmas-star-outline": {
            parent: "hexagram-outline"
        },
        "chrome-reader-mode": {
            parent: "book-open"
        },
        chromecast: {
            parent: "google-chrome"
        },
        cigarette: {
            parent: "smoking"
        },
        "cigarette-off": {
            parent: "smoking-off"
        },
        cinema: {
            parent: "theater"
        },
        "circle-arrows": {
            parent: "autorenew"
        },
        "circle-arrows-off": {
            parent: "autorenew-off"
        },
        "circle-diameter": {
            parent: "diameter"
        },
        "circle-diameter-outline": {
            parent: "diameter-outline"
        },
        "circle-diameter-variant": {
            parent: "diameter-variant"
        },
        "circle-plus-outline": {
            parent: "loupe"
        },
        "circle-radius": {
            parent: "radius"
        },
        "circle-radius-outline": {
            parent: "radius-outline"
        },
        "circle-transparent": {
            parent: "circle-opacity"
        },
        "circles-add": {
            parent: "plus-circle-outline"
        },
        "circular-arrows": {
            parent: "autorenew"
        },
        "circular-arrows-off": {
            parent: "autorenew-off"
        },
        clapperboard: {
            parent: "movie"
        },
        "clapperboard-check": {
            parent: "movie-check"
        },
        "clapperboard-check-outline": {
            parent: "movie-check-outline"
        },
        "clapperboard-cog": {
            parent: "movie-cog"
        },
        "clapperboard-cog-outline": {
            parent: "movie-cog-outline"
        },
        "clapperboard-edit": {
            parent: "movie-edit"
        },
        "clapperboard-edit-outline": {
            parent: "movie-edit-outline"
        },
        "clapperboard-minus": {
            parent: "movie-minus"
        },
        "clapperboard-minus-outline": {
            parent: "movie-minus-outline"
        },
        "clapperboard-off": {
            parent: "movie-off"
        },
        "clapperboard-off-outline": {
            parent: "movie-off-outline"
        },
        "clapperboard-open": {
            parent: "movie-open"
        },
        "clapperboard-open-check": {
            parent: "movie-open-check"
        },
        "clapperboard-open-check-outline": {
            parent: "movie-open-check-outline"
        },
        "clapperboard-open-cog": {
            parent: "movie-open-cog"
        },
        "clapperboard-open-cog-outline": {
            parent: "movie-open-cog-outline"
        },
        "clapperboard-open-edit": {
            parent: "movie-open-edit"
        },
        "clapperboard-open-edit-outline": {
            parent: "movie-open-edit-outline"
        },
        "clapperboard-open-minus": {
            parent: "movie-open-minus"
        },
        "clapperboard-open-minus-outline": {
            parent: "movie-open-minus-outline"
        },
        "clapperboard-open-off": {
            parent: "movie-open-off"
        },
        "clapperboard-open-off-outline": {
            parent: "movie-open-off-outline"
        },
        "clapperboard-open-outline": {
            parent: "movie-open-outline"
        },
        "clapperboard-open-play": {
            parent: "movie-open-play"
        },
        "clapperboard-open-play-outline": {
            parent: "movie-open-play-outline"
        },
        "clapperboard-open-plus": {
            parent: "movie-open-plus"
        },
        "clapperboard-open-plus-outline": {
            parent: "movie-open-plus-outline"
        },
        "clapperboard-open-remove": {
            parent: "movie-open-remove"
        },
        "clapperboard-open-remove-outline": {
            parent: "movie-open-remove-outline"
        },
        "clapperboard-open-settings": {
            parent: "movie-open-settings"
        },
        "clapperboard-open-settings-outline": {
            parent: "movie-open-settings-outline"
        },
        "clapperboard-open-star": {
            parent: "movie-open-star"
        },
        "clapperboard-open-star-outline": {
            parent: "movie-open-star-outline"
        },
        "clapperboard-outline": {
            parent: "movie-outline"
        },
        "clapperboard-play": {
            parent: "movie-play"
        },
        "clapperboard-play-outline": {
            parent: "movie-play-outline"
        },
        "clapperboard-plus": {
            parent: "movie-plus"
        },
        "clapperboard-plus-outline": {
            parent: "movie-plus-outline"
        },
        "clapperboard-remove": {
            parent: "movie-remove"
        },
        "clapperboard-remove-outline": {
            parent: "movie-remove-outline"
        },
        "clapperboard-settings": {
            parent: "movie-settings"
        },
        "clapperboard-settings-outline": {
            parent: "movie-settings-outline"
        },
        "clapperboard-star": {
            parent: "movie-star"
        },
        "clapperboard-star-outline": {
            parent: "movie-star-outline"
        },
        class: {
            parent: "book-variant"
        },
        cleaning: {
            parent: "spray-bottle"
        },
        clear: {
            parent: "backspace"
        },
        "clear-bold": {
            parent: "close-thick"
        },
        "clear-box": {
            parent: "close-box"
        },
        "clear-box-outline": {
            parent: "close-box-outline"
        },
        "clear-circle": {
            parent: "close-circle"
        },
        "clear-circle-multiple": {
            parent: "close-circle-multiple"
        },
        "clear-circle-multiple-outline": {
            parent: "close-circle-multiple-outline"
        },
        "clear-circle-outline": {
            parent: "close-circle-outline"
        },
        "clear-network": {
            parent: "close-network"
        },
        "clear-network-outline": {
            parent: "close-network-outline"
        },
        "clear-octagon": {
            parent: "close-octagon"
        },
        "clear-octagon-outline": {
            parent: "close-octagon-outline"
        },
        "clear-outline": {
            parent: "backspace-outline"
        },
        "clear-reverse": {
            parent: "backspace-reverse"
        },
        "clear-reverse-outline": {
            parent: "backspace-reverse-outline"
        },
        "clear-thick": {
            parent: "close-thick"
        },
        "climate-change": {
            parent: "waves-arrow-up"
        },
        clip: {
            parent: "content-cut"
        },
        "clipboard-add": {
            parent: "clipboard-plus"
        },
        "clipboard-arrow-bottom": {
            parent: "clipboard-arrow-down"
        },
        "clipboard-arrow-bottom-outline": {
            parent: "clipboard-arrow-down-outline"
        },
        "clipboard-arrow-top": {
            parent: "clipboard-arrow-up"
        },
        "clipboard-arrow-top-outline": {
            parent: "clipboard-arrow-up-outline"
        },
        "clipboard-person": {
            parent: "clipboard-account"
        },
        "clipboard-person-outline": {
            parent: "clipboard-account-outline"
        },
        "clipboard-text-date": {
            parent: "clipboard-text-clock"
        },
        "clipboard-text-date-outline": {
            parent: "clipboard-text-clock-outline"
        },
        "clipboard-text-history": {
            parent: "clipboard-text-clock"
        },
        "clipboard-text-history-outline": {
            parent: "clipboard-text-clock-outline"
        },
        "clipboard-text-time": {
            parent: "clipboard-text-clock"
        },
        "clipboard-text-time-outline": {
            parent: "clipboard-text-clock-outline"
        },
        "clipboard-tick": {
            parent: "clipboard-check"
        },
        "clipboard-tick-outline": {
            parent: "clipboard-check-outline"
        },
        "clipboard-user": {
            parent: "clipboard-account"
        },
        "clipboard-user-outline": {
            parent: "clipboard-account-outline"
        },
        "clipboard-vitals": {
            parent: "clipboard-pulse"
        },
        "clipboard-vitals-outline": {
            parent: "clipboard-pulse-outline"
        },
        "clipboard-warning": {
            parent: "clipboard-alert"
        },
        "clipboard-warning-outline": {
            parent: "clipboard-alert-outline"
        },
        "clock-arrow": {
            parent: "history"
        },
        "clock-warning": {
            parent: "clock-alert"
        },
        clockwise: {
            parent: "update"
        },
        "clockwise-arrows": {
            parent: "autorenew"
        },
        "clockwise-arrows-off": {
            parent: "autorenew-off"
        },
        "close-bold": {
            parent: "close-thick"
        },
        "close-boxes": {
            parent: "close-box-multiple"
        },
        "close-boxes-outline": {
            parent: "close-box-multiple-outline"
        },
        "closed-circuit-television": {
            parent: "cctv"
        },
        "closed-circuit-television-off": {
            parent: "cctv-off"
        },
        closet: {
            parent: "hanger"
        },
        "closet-outline": {
            parent: "wardrobe-outline"
        },
        cloth: {
            parent: "receipt"
        },
        "cloth-outline": {
            parent: "receipt-outline"
        },
        "clothes-hanger": {
            parent: "hanger"
        },
        "cloud-discount": {
            parent: "cloud-percent"
        },
        "cloud-discount-outline": {
            parent: "cloud-percent-outline"
        },
        "cloud-done": {
            parent: "cloud-check"
        },
        "cloud-json": {
            parent: "cloud-braces"
        },
        "cloud-queue": {
            parent: "cloud-outline"
        },
        "cloud-tick": {
            parent: "cloud-check"
        },
        "cloud-warning": {
            parent: "cloud-alert"
        },
        "cloud-xml": {
            parent: "cloud-tags"
        },
        clyde: {
            parent: "ghost"
        },
        "coach-light": {
            parent: "coach-lamp"
        },
        "coat-hanger": {
            parent: "hanger"
        },
        cobweb: {
            parent: "spider-web"
        },
        cocktail: {
            parent: "glass-cocktail"
        },
        cod: {
            parent: "cash-marker"
        },
        code: {
            parent: "xml"
        },
        "code-or": {
            parent: "math-norm"
        },
        "code-or-box": {
            parent: "math-norm-box"
        },
        "code-tags-tick": {
            parent: "code-tags-check"
        },
        "coffee-machine": {
            parent: "coffee-maker"
        },
        "coffee-maker-complete": {
            parent: "coffee-maker-check"
        },
        "coffee-maker-complete-outline": {
            parent: "coffee-maker-check-outline"
        },
        "coffee-maker-done": {
            parent: "coffee-maker-check"
        },
        "coffee-maker-done-outline": {
            parent: "coffee-maker-check-outline"
        },
        coin: {
            parent: "currency-usd-circle"
        },
        "coin-outline": {
            parent: "currency-usd-circle-outline"
        },
        coins: {
            parent: "circle-multiple"
        },
        "coins-close": {
            parent: "close-circle-multiple"
        },
        "coins-close-outline": {
            parent: "close-circle-multiple-outline"
        },
        "coins-minus": {
            parent: "minus-circle-multiple"
        },
        "coins-minus-outline": {
            parent: "minus-circle-multiple-outline"
        },
        "coins-outline": {
            parent: "circle-multiple-outline"
        },
        "coins-plus": {
            parent: "plus-circle-multiple"
        },
        "coins-plus-outline": {
            parent: "plus-circle-multiple-outline"
        },
        "coins-remove": {
            parent: "close-circle-multiple"
        },
        "coins-remove-outline": {
            parent: "close-circle-multiple-outline"
        },
        "cold-alert": {
            parent: "snowflake-alert"
        },
        "collapse-horizontal": {
            parent: "unfold-less-horizontal"
        },
        "collapse-vertical": {
            parent: "unfold-less-vertical"
        },
        collection: {
            parent: "rhombus-split"
        },
        collections: {
            parent: "image-multiple"
        },
        "collections-bookmark": {
            parent: "bookmark-box-multiple"
        },
        "collections-bookmark-outline": {
            parent: "bookmark-box-multiple-outline"
        },
        college: {
            parent: "human-male-board"
        },
        "college-outline": {
            parent: "school-outline"
        },
        color: {
            parent: "palette"
        },
        "color-lens": {
            parent: "palette"
        },
        colorize: {
            parent: "eyedropper-variant"
        },
        "colour-helper": {
            parent: "color-helper"
        },
        "colour-lens": {
            parent: "palette"
        },
        colourise: {
            parent: "eyedropper-variant"
        },
        column: {
            parent: "pillar"
        },
        comedy: {
            parent: "drama-masks"
        },
        "comic-bubble": {
            parent: "thought-bubble"
        },
        "comic-thought-bubble-outline": {
            parent: "thought-bubble-outline"
        },
        "comment-add": {
            parent: "comment-plus"
        },
        "comment-add-outline": {
            parent: "comment-plus-outline"
        },
        "comment-help": {
            parent: "comment-question"
        },
        "comment-help-outline": {
            parent: "comment-question-outline"
        },
        "comment-next": {
            parent: "comment-arrow-right"
        },
        "comment-next-outline": {
            parent: "comment-arrow-right-outline"
        },
        "comment-person": {
            parent: "comment-account"
        },
        "comment-person-outline": {
            parent: "comment-account-outline"
        },
        "comment-previous": {
            parent: "comment-arrow-left"
        },
        "comment-previous-outline": {
            parent: "comment-arrow-left-outline"
        },
        "comment-quick": {
            parent: "comment-flash"
        },
        "comment-quick-outline": {
            parent: "comment-flash-outline"
        },
        "comment-tick": {
            parent: "comment-check"
        },
        "comment-tick-outline": {
            parent: "comment-check-outline"
        },
        "comment-user": {
            parent: "comment-account"
        },
        "comment-user-outline": {
            parent: "comment-account-outline"
        },
        "comment-warning": {
            parent: "comment-alert"
        },
        "comment-warning-outline": {
            parent: "comment-alert-outline"
        },
        comments: {
            parent: "comment-multiple"
        },
        "comments-outline": {
            parent: "comment-multiple-outline"
        },
        "comments-text": {
            parent: "comment-text-multiple"
        },
        "comments-text-outline": {
            parent: "comment-text-multiple-outline"
        },
        communism: {
            parent: "hammer-sickle"
        },
        commute: {
            parent: "train-car"
        },
        company: {
            parent: "domain"
        },
        compress: {
            parent: "arrow-collapse-vertical"
        },
        "compressed-file": {
            parent: "zip-box"
        },
        "compressed-file-outline": {
            parent: "zip-box-outline"
        },
        "compressed-folder": {
            parent: "folder-zip"
        },
        "compressed-folder-outline": {
            parent: "folder-zip-outline"
        },
        computer: {
            parent: "laptop"
        },
        "computer-classic": {
            parent: "desktop-classic"
        },
        "confidential-mode": {
            parent: "lock-clock"
        },
        "confirmation-number": {
            parent: "ticket-confirmation"
        },
        "confirmation-number-outline": {
            parent: "ticket-confirmation-outline"
        },
        "connect-without-contact": {
            parent: "human-greeting-proximity"
        },
        construction: {
            parent: "account-hard-hat"
        },
        "construction-outline": {
            parent: "account-hard-hat-outline"
        },
        contact: {
            parent: "account-box"
        },
        "contact-mail": {
            parent: "card-account-mail"
        },
        "contact-mail-outline": {
            parent: "card-account-mail-outline"
        },
        "contact-outline": {
            parent: "account-box-outline"
        },
        "contact-phone": {
            parent: "card-account-phone"
        },
        "contact-phone-outline": {
            parent: "card-account-phone-outline"
        },
        "content-save-add": {
            parent: "content-save-plus"
        },
        "content-save-add-outline": {
            parent: "content-save-plus-outline"
        },
        contract: {
            parent: "file-document-edit"
        },
        "contract-outline": {
            parent: "file-document-edit-outline"
        },
        "contract-sign": {
            parent: "file-sign"
        },
        "control-point": {
            parent: "plus-circle-outline"
        },
        "control-point-duplicate": {
            parent: "plus-circle-multiple-outline"
        },
        "controlled-burn": {
            parent: "pine-tree-fire"
        },
        "controller-circle": {
            parent: "gamepad-circle"
        },
        "controller-circle-down": {
            parent: "gamepad-circle-down"
        },
        "controller-circle-left": {
            parent: "gamepad-circle-left"
        },
        "controller-circle-outline": {
            parent: "gamepad-circle-outline"
        },
        "controller-circle-right": {
            parent: "gamepad-circle-right"
        },
        "controller-circle-up": {
            parent: "gamepad-circle-up"
        },
        "controller-down": {
            parent: "gamepad-down"
        },
        "controller-left": {
            parent: "gamepad-left"
        },
        "controller-outline": {
            parent: "gamepad-outline"
        },
        "controller-right": {
            parent: "gamepad-right"
        },
        "controller-round": {
            parent: "gamepad-round"
        },
        "controller-round-down": {
            parent: "gamepad-round-down"
        },
        "controller-round-left": {
            parent: "gamepad-round-left"
        },
        "controller-round-outline": {
            parent: "gamepad-round-outline"
        },
        "controller-round-right": {
            parent: "gamepad-round-right"
        },
        "controller-round-up": {
            parent: "gamepad-round-up"
        },
        "controller-square": {
            parent: "gamepad-square"
        },
        "controller-square-outline": {
            parent: "gamepad-square-outline"
        },
        "controller-up": {
            parent: "gamepad-up"
        },
        "controller-variant": {
            parent: "gamepad-variant"
        },
        "controller-variant-outline": {
            parent: "gamepad-variant-outline"
        },
        cook: {
            parent: "chef-hat"
        },
        cooker: {
            parent: "stove"
        },
        "cookie-crumbs": {
            parent: "cookie-settings"
        },
        "cookie-crumbs-outline": {
            parent: "cookie-settings-outline"
        },
        "cooktop-burner": {
            parent: "gas-burner"
        },
        couch: {
            parent: "sofa"
        },
        "couch-outline": {
            parent: "sofa-outline"
        },
        counterclockwise: {
            parent: "history"
        },
        "counterclockwise-arrows": {
            parent: "cached"
        },
        "counting-1": {
            parent: "tally-mark-1"
        },
        "counting-2": {
            parent: "tally-mark-2"
        },
        "counting-3": {
            parent: "tally-mark-3"
        },
        "counting-4": {
            parent: "tally-mark-4"
        },
        "counting-5": {
            parent: "tally-mark-5"
        },
        coupon: {
            parent: "ticket-percent"
        },
        "coupon-outline": {
            parent: "ticket-percent-outline"
        },
        courier: {
            parent: "truck"
        },
        "courier-check": {
            parent: "truck-check"
        },
        "courier-fast": {
            parent: "truck-fast"
        },
        "court-hammer": {
            parent: "gavel"
        },
        "covid-test": {
            parent: "medical-cotton-swab"
        },
        cowboy: {
            parent: "account-cowboy-hat"
        },
        create: {
            parent: "pencil"
        },
        "create-new-folder": {
            parent: "folder-plus"
        },
        "create-new-folder-outline": {
            parent: "folder-plus-outline"
        },
        "create-outline": {
            parent: "pencil-outline"
        },
        "credit-card-add": {
            parent: "credit-card-plus-outline"
        },
        "credit-card-contactless": {
            parent: "credit-card-wireless-outline"
        },
        "credit-card-icc-chip": {
            parent: "credit-card-chip"
        },
        "credit-card-icc-chip-outline": {
            parent: "credit-card-chip-outline"
        },
        "credit-card-location": {
            parent: "credit-card-marker"
        },
        "credit-card-location-outline": {
            parent: "credit-card-marker-outline"
        },
        "credit-card-swipe": {
            parent: "credit-card-fast"
        },
        "credit-card-swipe-outline": {
            parent: "credit-card-fast-outline"
        },
        "credit-cards": {
            parent: "credit-card-multiple-outline"
        },
        crib: {
            parent: "cradle"
        },
        "cricket-bat": {
            parent: "cricket"
        },
        "crop-5-4": {
            parent: "crop-landscape"
        },
        crossfit: {
            parent: "weight-lifter"
        },
        "crosshairs-account": {
            parent: "target-account"
        },
        "crosshairs-unknown": {
            parent: "crosshairs-question"
        },
        "crowd-source": {
            parent: "crowd"
        },
        crowdsource: {
            parent: "crowd"
        },
        "cruelty-free": {
            parent: "rabbit-variant"
        },
        "cruelty-free-outline": {
            parent: "rabbit-variant-outline"
        },
        cta: {
            parent: "gesture-tap-button"
        },
        "cup-full": {
            parent: "beer"
        },
        "cup-full-outline": {
            parent: "beer-outline"
        },
        "cup-ice": {
            parent: "delete-variant"
        },
        "cup-liquid": {
            parent: "cup-water"
        },
        "cup-to-go": {
            parent: "coffee-to-go"
        },
        "cup-to-go-outline": {
            parent: "coffee-to-go-outline"
        },
        "currency-hryvnia": {
            parent: "currency-uah"
        },
        "currency-irr": {
            parent: "currency-rial"
        },
        "currency-lkr": {
            parent: "currency-rupee"
        },
        "currency-mongolian-tugrug": {
            parent: "currency-mnt"
        },
        "currency-npr": {
            parent: "currency-rupee"
        },
        "currency-omr": {
            parent: "currency-rial"
        },
        "currency-pkr": {
            parent: "currency-rupee"
        },
        "currency-riyal": {
            parent: "currency-rial"
        },
        "currency-sar": {
            parent: "currency-rial"
        },
        "currency-scarab": {
            parent: "currency-sign"
        },
        "currency-ukraine": {
            parent: "currency-uah"
        },
        "currency-yer": {
            parent: "currency-rial"
        },
        "cursor-hand": {
            parent: "cursor-pointer"
        },
        "customer-service": {
            parent: "face-agent"
        },
        cutlery: {
            parent: "silverware"
        },
        "cutlery-clean": {
            parent: "silverware-clean"
        },
        "cutlery-fork": {
            parent: "silverware-fork"
        },
        "cutlery-fork-knife": {
            parent: "silverware-fork-knife"
        },
        "cutlery-knife": {
            parent: "knife"
        },
        "cutlery-spoon": {
            parent: "silverware-spoon"
        },
        "cutlery-variant": {
            parent: "silverware-variant"
        },
        cycling: {
            parent: "bicycle"
        },
        cyclone: {
            parent: "weather-hurricane"
        },
        dad: {
            parent: "human-male-boy"
        },
        dagger: {
            parent: "knife-military"
        },
        "dairy-free": {
            parent: "cow-off"
        },
        "dairy-off": {
            parent: "cow-off"
        },
        dais: {
            parent: "lectern"
        },
        dangerous: {
            parent: "close-octagon"
        },
        "data-settings": {
            parent: "network-strength-4-cog"
        },
        "data-usage": {
            parent: "chart-donut"
        },
        "database-add": {
            parent: "database-plus"
        },
        "database-location": {
            parent: "database-marker"
        },
        "database-location-outline": {
            parent: "database-marker-outline"
        },
        "database-tick": {
            parent: "database-check"
        },
        "database-view": {
            parent: "database-eye"
        },
        "database-view-off": {
            parent: "database-eye-off"
        },
        "database-view-off-outline": {
            parent: "database-eye-off-outline"
        },
        "database-view-outline": {
            parent: "database-eye-outline"
        },
        "date-range": {
            parent: "calendar-range"
        },
        "day-temperature": {
            parent: "sun-thermometer"
        },
        dead: {
            parent: "coffin"
        },
        deal: {
            parent: "handshake"
        },
        "deal-outline": {
            parent: "handshake-outline"
        },
        death: {
            parent: "coffin"
        },
        "decagram-check": {
            parent: "check-decagram"
        },
        decrement: {
            parent: "numeric-negative-1"
        },
        decrypted: {
            parent: "lock-open"
        },
        "decrypted-add": {
            parent: "lock-open-plus"
        },
        "decrypted-add-outline": {
            parent: "lock-open-plus-outline"
        },
        "decrypted-alert": {
            parent: "lock-open-alert"
        },
        "decrypted-alert-outline": {
            parent: "lock-open-alert-outline"
        },
        "decrypted-check": {
            parent: "lock-open-check"
        },
        "decrypted-check-outline": {
            parent: "lock-open-check-outline"
        },
        "decrypted-minus": {
            parent: "lock-open-minus"
        },
        "decrypted-minus-outline": {
            parent: "lock-open-minus-outline"
        },
        "decrypted-outline": {
            parent: "lock-open-outline"
        },
        "decrypted-plus": {
            parent: "lock-open-plus"
        },
        "decrypted-plus-outline": {
            parent: "lock-open-plus-outline"
        },
        "decrypted-remove": {
            parent: "lock-open-remove"
        },
        "decrypted-remove-outline": {
            parent: "lock-open-remove-outline"
        },
        "decrypted-variant": {
            parent: "lock-open-variant"
        },
        "decrypted-variant-outline": {
            parent: "lock-open-variant-outline"
        },
        "decrypted-warning": {
            parent: "lock-open-alert"
        },
        "decrypted-warning-outline": {
            parent: "lock-open-alert-outline"
        },
        defibrillator: {
            parent: "heart-flash"
        },
        defrost: {
            parent: "snowflake-melt"
        },
        "delivery-dining": {
            parent: "moped"
        },
        "delivery-dining-electric": {
            parent: "moped-electric"
        },
        "delivery-dining-electric-outline": {
            parent: "moped-electric-outline"
        },
        "delivery-dining-outline": {
            parent: "moped-outline"
        },
        denied: {
            parent: "cancel"
        },
        dentist: {
            parent: "tooth"
        },
        "departure-board": {
            parent: "bus-clock"
        },
        dependencies: {
            parent: "graph"
        },
        dependency: {
            parent: "graph"
        },
        design: {
            parent: "pencil-ruler"
        },
        "desktop-windows": {
            parent: "monitor"
        },
        "dew-point": {
            parent: "thermometer-water"
        },
        "dew-point-outline": {
            parent: "water-thermometer-outline"
        },
        "dharma-wheel": {
            parent: "dharmachakra"
        },
        dial: {
            parent: "knob"
        },
        diary: {
            parent: "notebook"
        },
        "dice-five": {
            parent: "dice-5"
        },
        "dice-four": {
            parent: "dice-4"
        },
        "dice-one": {
            parent: "dice-1"
        },
        "dice-six": {
            parent: "dice-6"
        },
        "dice-three": {
            parent: "dice-3"
        },
        "dice-two": {
            parent: "dice-2"
        },
        dictionary: {
            parent: "book-alphabet"
        },
        "die-1": {
            parent: "dice-1"
        },
        "die-2": {
            parent: "dice-2"
        },
        "die-3": {
            parent: "dice-3"
        },
        "die-4": {
            parent: "dice-4"
        },
        "die-5": {
            parent: "dice-5"
        },
        "die-6": {
            parent: "dice-6"
        },
        "die-d10": {
            parent: "dice-d10-outline"
        },
        "die-d20": {
            parent: "dice-d20-outline"
        },
        "die-d4": {
            parent: "dice-d4-outline"
        },
        "die-d6": {
            parent: "dice-d6-outline"
        },
        "die-d8": {
            parent: "dice-d8-outline"
        },
        "die-multiple": {
            parent: "dice-multiple"
        },
        "dietary-restriction": {
            parent: "food-halal"
        },
        "difference-left": {
            parent: "set-left"
        },
        "difference-right": {
            parent: "set-right"
        },
        dining: {
            parent: "table-chair"
        },
        "dining-room": {
            parent: "table-chair"
        },
        dinner: {
            parent: "food-turkey"
        },
        "dinner-bell": {
            parent: "instrument-triangle"
        },
        "dinosaur-pixel": {
            parent: "google-downasaur"
        },
        diploma: {
            parent: "certificate"
        },
        "diploma-outline": {
            parent: "certificate-outline"
        },
        "direct-current": {
            parent: "current-dc"
        },
        "directions-bike": {
            parent: "bike"
        },
        "directions-boat": {
            parent: "ferry"
        },
        "directions-bus": {
            parent: "bus"
        },
        "directions-car": {
            parent: "car"
        },
        "directions-ferry": {
            parent: "ferry"
        },
        "directions-railway": {
            parent: "train"
        },
        "directions-run": {
            parent: "run"
        },
        "directions-subway": {
            parent: "subway-variant"
        },
        "directions-transit": {
            parent: "subway-variant"
        },
        "directions-walk": {
            parent: "walk"
        },
        dirty: {
            parent: "liquid-spot"
        },
        "disc-full": {
            parent: "disc-alert"
        },
        "disc-warning": {
            parent: "disc-alert"
        },
        discount: {
            parent: "brightness-percent"
        },
        "discount-box": {
            parent: "percent-box"
        },
        "discount-box-outline": {
            parent: "percent-box-outline"
        },
        "discount-circle": {
            parent: "percent-circle"
        },
        "discount-circle-outline": {
            parent: "percent-circle-outline"
        },
        "discount-outline": {
            parent: "percent-outline"
        },
        dislike: {
            parent: "thumb-down"
        },
        "dislike-outline": {
            parent: "thumb-down-outline"
        },
        dispensary: {
            parent: "hospital"
        },
        "dispensary-box": {
            parent: "hospital-box"
        },
        "dispensary-box-outline": {
            parent: "hospital-box-outline"
        },
        divide: {
            parent: "slash-forward"
        },
        "divide-box": {
            parent: "slash-forward-box"
        },
        "do-not-disturb-alt": {
            parent: "cancel"
        },
        "do-not-disturb-off": {
            parent: "minus-circle-off"
        },
        "do-not-disturb-off-outline": {
            parent: "minus-circle-off-outline"
        },
        "do-not-disturb-on": {
            parent: "minus-circle"
        },
        "do-not-disturb-outline": {
            parent: "minus-circle-outline"
        },
        "do-not-enter": {
            parent: "minus-circle"
        },
        "do-not-enter-off": {
            parent: "minus-circle-off"
        },
        "do-not-enter-off-outline": {
            parent: "minus-circle-off-outline"
        },
        "do-not-enter-outline": {
            parent: "minus-circle-outline"
        },
        "document-sign": {
            parent: "file-sign"
        },
        dollar: {
            parent: "currency-usd"
        },
        "dollar-off": {
            parent: "currency-usd-off"
        },
        donate: {
            parent: "gift"
        },
        "donate-off": {
            parent: "gift-off"
        },
        "donate-off-outline": {
            parent: "gift-off-outline"
        },
        "donate-outline": {
            parent: "gift-outline"
        },
        donation: {
            parent: "hand-coin"
        },
        "donation-outline": {
            parent: "hand-coin-outline"
        },
        done: {
            parent: "check"
        },
        "done-all": {
            parent: "check-all"
        },
        "done-outline": {
            parent: "check-outline"
        },
        dot: {
            parent: "circle-small"
        },
        downlight: {
            parent: "light-recessed"
        },
        downloads: {
            parent: "download-multiple"
        },
        draft: {
            parent: "file"
        },
        drafts: {
            parent: "email-open"
        },
        drapes: {
            parent: "curtains"
        },
        "drapes-closed": {
            parent: "curtains-closed"
        },
        drink: {
            parent: "beer"
        },
        "drink-ice": {
            parent: "delete-variant"
        },
        "drink-off": {
            parent: "coffee-off"
        },
        "drink-off-outline": {
            parent: "coffee-off-outline"
        },
        "drink-outline": {
            parent: "beer-outline"
        },
        "drink-to-go": {
            parent: "coffee-to-go"
        },
        "drink-to-go-outline": {
            parent: "coffee-to-go-outline"
        },
        "drink-water": {
            parent: "cup-water"
        },
        drive: {
            parent: "alpha-d"
        },
        "drive-document": {
            parent: "text-box"
        },
        "drive-eta": {
            parent: "car"
        },
        "drivers-license": {
            parent: "card-account-details"
        },
        "drivers-license-outline": {
            parent: "card-account-details-outline"
        },
        drop: {
            parent: "water"
        },
        "drop-alert": {
            parent: "water-alert"
        },
        "drop-alert-outline": {
            parent: "water-alert-outline"
        },
        "drop-check": {
            parent: "water-check"
        },
        "drop-check-outline": {
            parent: "water-check-outline"
        },
        "drop-circle": {
            parent: "water-circle"
        },
        "drop-minus": {
            parent: "water-minus"
        },
        "drop-minus-outline": {
            parent: "water-minus-outline"
        },
        "drop-off-outline": {
            parent: "water-off-outline"
        },
        "drop-outline": {
            parent: "water-outline"
        },
        "drop-plus": {
            parent: "water-plus"
        },
        "drop-plus-outline": {
            parent: "water-plus-outline"
        },
        "drop-remove": {
            parent: "water-remove"
        },
        "drop-remove-outline": {
            parent: "water-remove-outline"
        },
        "drop-saver": {
            parent: "water-opacity"
        },
        "drop-transparent": {
            parent: "water-opacity"
        },
        drug: {
            parent: "needle"
        },
        "drug-off": {
            parent: "needle-off"
        },
        drugs: {
            parent: "pill-multiple"
        },
        "dust-storm": {
            parent: "weather-dust"
        },
        dvd: {
            parent: "disc"
        },
        easter: {
            parent: "rabbit-variant"
        },
        "easter-outline": {
            parent: "rabbit-variant-outline"
        },
        edge: {
            parent: "microsoft-edge"
        },
        "edge-legacy": {
            parent: "microsoft-edge-legacy"
        },
        edit: {
            parent: "pencil"
        },
        "edit-box": {
            parent: "pencil-box"
        },
        "edit-box-outline": {
            parent: "pencil-box-outline"
        },
        "edit-circle": {
            parent: "pencil-circle"
        },
        "edit-circle-outline": {
            parent: "pencil-circle-outline"
        },
        "edit-off": {
            parent: "pencil-off"
        },
        "edit-off-outline": {
            parent: "pencil-off-outline"
        },
        "edit-outline": {
            parent: "pencil-outline"
        },
        education: {
            parent: "bus-school"
        },
        "education-outline": {
            parent: "school-outline"
        },
        "eight-ball": {
            parent: "billiards"
        },
        elderly: {
            parent: "human-cane"
        },
        "electric-charger": {
            parent: "ev-station"
        },
        "electric-vehicle-charger": {
            parent: "ev-station"
        },
        "electric-water-boiler": {
            parent: "water-boiler"
        },
        "electric-water-heater": {
            parent: "water-boiler"
        },
        "electrical-resistance": {
            parent: "omega"
        },
        electricity: {
            parent: "flash"
        },
        "electricity-circle": {
            parent: "lightning-bolt-circle"
        },
        "electricity-from-grid": {
            parent: "transmission-tower-export"
        },
        "electricity-outline": {
            parent: "lightning-bolt-outline"
        },
        "electricity-to-grid": {
            parent: "transmission-tower-import"
        },
        "electronic-stability-program": {
            parent: "car-esp"
        },
        "ellipsis-horizontal": {
            parent: "dots-horizontal"
        },
        "ellipsis-horizontal-circle": {
            parent: "dots-horizontal-circle"
        },
        "ellipsis-horizontal-circle-outline": {
            parent: "dots-horizontal-circle-outline"
        },
        "ellipsis-vertical": {
            parent: "dots-vertical"
        },
        "ellipsis-vertical-circle": {
            parent: "dots-vertical-circle"
        },
        "ellipsis-vertical-circle-outline": {
            parent: "dots-vertical-circle-outline"
        },
        "email-add": {
            parent: "email-plus"
        },
        "email-add-outline": {
            parent: "email-plus-outline"
        },
        "email-certified": {
            parent: "email-seal"
        },
        "email-certified-outline": {
            parent: "email-seal-outline"
        },
        "email-quick": {
            parent: "email-fast"
        },
        "email-quick-outline": {
            parent: "email-fast-outline"
        },
        "email-receive": {
            parent: "email-arrow-left"
        },
        "email-receive-outline": {
            parent: "email-arrow-left-outline"
        },
        "email-refresh": {
            parent: "email-sync"
        },
        "email-refresh-outline": {
            parent: "email-sync-outline"
        },
        "email-resend": {
            parent: "email-sync"
        },
        "email-resend-outline": {
            parent: "email-sync-outline"
        },
        "email-secure": {
            parent: "email-lock"
        },
        "email-secure-outline": {
            parent: "email-lock-outline"
        },
        "email-send": {
            parent: "email-arrow-right"
        },
        "email-send-outline": {
            parent: "email-fast-outline"
        },
        "email-sent": {
            parent: "email-fast"
        },
        "email-sent-outline": {
            parent: "email-fast-outline"
        },
        "email-tick": {
            parent: "email-check"
        },
        "email-tick-outline": {
            parent: "email-check-outline"
        },
        "email-verified": {
            parent: "email-seal"
        },
        "email-verified-outline": {
            parent: "email-seal-outline"
        },
        "email-warning": {
            parent: "email-alert"
        },
        "emergency-exit": {
            parent: "exit-run"
        },
        emoji: {
            parent: "emoticon"
        },
        "emoji-agent": {
            parent: "face-agent"
        },
        "emoji-angry": {
            parent: "emoticon-angry"
        },
        "emoji-angry-outline": {
            parent: "emoticon-angry-outline"
        },
        "emoji-baby": {
            parent: "baby-face"
        },
        "emoji-baby-outline": {
            parent: "baby-face-outline"
        },
        "emoji-cat": {
            parent: "cat"
        },
        "emoji-confused": {
            parent: "emoticon-confused"
        },
        "emoji-confused-outline": {
            parent: "emoticon-confused-outline"
        },
        "emoji-cool": {
            parent: "emoticon-cool"
        },
        "emoji-cool-outline": {
            parent: "emoticon-cool-outline"
        },
        "emoji-cow": {
            parent: "cow"
        },
        "emoji-cry": {
            parent: "emoticon-cry"
        },
        "emoji-cry-outline": {
            parent: "emoticon-cry-outline"
        },
        "emoji-dead": {
            parent: "emoticon-dead"
        },
        "emoji-dead-outline": {
            parent: "emoticon-dead-outline"
        },
        "emoji-devil": {
            parent: "emoticon-devil"
        },
        "emoji-devil-outline": {
            parent: "emoticon-devil-outline"
        },
        "emoji-dog": {
            parent: "dog"
        },
        "emoji-excited": {
            parent: "emoticon-excited"
        },
        "emoji-excited-outline": {
            parent: "emoticon-excited-outline"
        },
        "emoji-frown": {
            parent: "emoticon-frown"
        },
        "emoji-frown-outline": {
            parent: "emoticon-frown-outline"
        },
        "emoji-halloween": {
            parent: "halloween"
        },
        "emoji-happy": {
            parent: "emoticon-happy"
        },
        "emoji-happy-outline": {
            parent: "emoticon-happy-outline"
        },
        "emoji-kiss": {
            parent: "emoticon-kiss"
        },
        "emoji-kiss-outline": {
            parent: "emoticon-kiss-outline"
        },
        "emoji-koala": {
            parent: "koala"
        },
        "emoji-lol": {
            parent: "emoticon-lol"
        },
        "emoji-lol-outline": {
            parent: "emoticon-lol-outline"
        },
        "emoji-man": {
            parent: "face-man"
        },
        "emoji-man-outline": {
            parent: "face-man-outline"
        },
        "emoji-man-profile": {
            parent: "face-man-profile"
        },
        "emoji-man-shimmer": {
            parent: "face-man-shimmer"
        },
        "emoji-man-shimmer-outline": {
            parent: "face-man-shimmer-outline"
        },
        "emoji-neutral": {
            parent: "emoticon-neutral"
        },
        "emoji-neutral-outline": {
            parent: "emoticon-neutral-outline"
        },
        "emoji-outline": {
            parent: "emoticon-outline"
        },
        "emoji-panda": {
            parent: "panda"
        },
        "emoji-penguin": {
            parent: "penguin"
        },
        "emoji-pig": {
            parent: "pig"
        },
        "emoji-poop": {
            parent: "emoticon-poop"
        },
        "emoji-poop-outline": {
            parent: "emoticon-poop-outline"
        },
        "emoji-robot": {
            parent: "robot"
        },
        "emoji-robot-angry": {
            parent: "robot-angry"
        },
        "emoji-robot-angry-outline": {
            parent: "robot-angry-outline"
        },
        "emoji-robot-confused": {
            parent: "robot-confused"
        },
        "emoji-robot-confused-outline": {
            parent: "robot-confused-outline"
        },
        "emoji-robot-dead": {
            parent: "robot-dead"
        },
        "emoji-robot-dead-outline": {
            parent: "robot-dead-outline"
        },
        "emoji-robot-excited": {
            parent: "robot-excited"
        },
        "emoji-robot-excited-outline": {
            parent: "robot-excited-outline"
        },
        "emoji-robot-happy": {
            parent: "robot-happy"
        },
        "emoji-robot-happy-outline": {
            parent: "robot-happy-outline"
        },
        "emoji-robot-love": {
            parent: "robot-love"
        },
        "emoji-robot-off": {
            parent: "robot-off"
        },
        "emoji-robot-outline": {
            parent: "robot-outline"
        },
        "emoji-sad": {
            parent: "emoticon-sad"
        },
        "emoji-sad-outline": {
            parent: "emoticon-sad-outline"
        },
        "emoji-sheep": {
            parent: "sheep"
        },
        "emoji-sick": {
            parent: "emoticon-sick"
        },
        "emoji-sick-outline": {
            parent: "emoticon-sick-outline"
        },
        "emoji-star": {
            parent: "star-face"
        },
        "emoji-tongue": {
            parent: "emoticon-tongue"
        },
        "emoji-tongue-outline": {
            parent: "emoticon-tongue-outline"
        },
        "emoji-wink": {
            parent: "emoticon-wink"
        },
        "emoji-wink-outline": {
            parent: "emoticon-wink-outline"
        },
        "emoji-woman": {
            parent: "face-woman"
        },
        "emoji-woman-outline": {
            parent: "face-woman-outline"
        },
        "emoji-woman-profile": {
            parent: "face-woman-profile"
        },
        "emoji-woman-shimmer": {
            parent: "face-woman-shimmer"
        },
        "emoji-woman-shimmer-outline": {
            parent: "face-woman-shimmer-outline"
        },
        "emoticon-agent": {
            parent: "face-agent"
        },
        "emoticon-baby": {
            parent: "baby-face"
        },
        "emoticon-baby-outline": {
            parent: "baby-face-outline"
        },
        "emoticon-cat": {
            parent: "cat"
        },
        "emoticon-cow": {
            parent: "cow"
        },
        "emoticon-dog": {
            parent: "dog"
        },
        "emoticon-halloween": {
            parent: "halloween"
        },
        "emoticon-koala": {
            parent: "koala"
        },
        "emoticon-man": {
            parent: "face-man"
        },
        "emoticon-man-outline": {
            parent: "face-man-outline"
        },
        "emoticon-man-profile": {
            parent: "face-man-profile"
        },
        "emoticon-man-shimmer": {
            parent: "face-man-shimmer"
        },
        "emoticon-man-shimmer-outline": {
            parent: "face-man-shimmer-outline"
        },
        "emoticon-panda": {
            parent: "panda"
        },
        "emoticon-penguin": {
            parent: "penguin"
        },
        "emoticon-pig": {
            parent: "pig"
        },
        "emoticon-robot": {
            parent: "robot"
        },
        "emoticon-robot-angry": {
            parent: "robot-angry"
        },
        "emoticon-robot-angry-outline": {
            parent: "robot-angry-outline"
        },
        "emoticon-robot-confused": {
            parent: "robot-confused"
        },
        "emoticon-robot-confused-outline": {
            parent: "robot-confused-outline"
        },
        "emoticon-robot-dead": {
            parent: "robot-dead"
        },
        "emoticon-robot-dead-outline": {
            parent: "robot-dead-outline"
        },
        "emoticon-robot-excited": {
            parent: "robot-excited"
        },
        "emoticon-robot-excited-outline": {
            parent: "robot-excited-outline"
        },
        "emoticon-robot-happy": {
            parent: "robot-happy"
        },
        "emoticon-robot-happy-outline": {
            parent: "robot-happy-outline"
        },
        "emoticon-robot-love": {
            parent: "robot-love"
        },
        "emoticon-robot-off": {
            parent: "robot-off"
        },
        "emoticon-robot-outline": {
            parent: "robot-outline"
        },
        "emoticon-sheep": {
            parent: "sheep"
        },
        "emoticon-star": {
            parent: "star-face"
        },
        "emoticon-woman": {
            parent: "face-woman"
        },
        "emoticon-woman-outline": {
            parent: "face-woman-outline"
        },
        "emoticon-woman-profile": {
            parent: "face-woman-profile"
        },
        "emoticon-woman-shimmer": {
            parent: "face-woman-shimmer"
        },
        "emoticon-woman-shimmer-outline": {
            parent: "face-woman-shimmer-outline"
        },
        encryption: {
            parent: "lock"
        },
        "encryption-add": {
            parent: "lock-plus"
        },
        "encryption-add-outline": {
            parent: "lock-plus-outline"
        },
        "encryption-alert": {
            parent: "lock-alert"
        },
        "encryption-alert-outline": {
            parent: "lock-alert-outline"
        },
        "encryption-check": {
            parent: "lock-check"
        },
        "encryption-check-outline": {
            parent: "lock-check-outline"
        },
        "encryption-expiration": {
            parent: "lock-clock"
        },
        "encryption-minus": {
            parent: "lock-minus"
        },
        "encryption-off": {
            parent: "lock-off"
        },
        "encryption-off-outline": {
            parent: "lock-off-outline"
        },
        "encryption-outline": {
            parent: "lock-outline"
        },
        "encryption-plus": {
            parent: "lock-plus"
        },
        "encryption-plus-outline": {
            parent: "lock-plus-outline"
        },
        "encryption-question": {
            parent: "lock-question"
        },
        "encryption-remove": {
            parent: "lock-remove"
        },
        "encryption-remove-outline": {
            parent: "lock-remove-outline"
        },
        "encryption-reset": {
            parent: "lock-reset"
        },
        "encryption-secure": {
            parent: "lock-check"
        },
        "encryption-secure-outline": {
            parent: "lock-check-outline"
        },
        "encryption-verified": {
            parent: "lock-check"
        },
        "encryption-verified-outline": {
            parent: "lock-check-outline"
        },
        "encryption-warning": {
            parent: "lock-alert"
        },
        "encryption-warning-outline": {
            parent: "lock-alert-outline"
        },
        encyclopedia: {
            parent: "book-information-variant"
        },
        energy: {
            parent: "barrel"
        },
        "energy-circle": {
            parent: "lightning-bolt-circle"
        },
        "energy-from-grid": {
            parent: "transmission-tower-export"
        },
        "energy-outline": {
            parent: "barrel-outline"
        },
        "energy-to-grid": {
            parent: "transmission-tower-import"
        },
        "enhanced-encryption": {
            parent: "lock-plus"
        },
        "entry-room": {
            parent: "coat-rack"
        },
        envelope: {
            parent: "email"
        },
        "envelope-add": {
            parent: "email-plus"
        },
        "envelope-add-outline": {
            parent: "email-plus-outline"
        },
        "envelope-alert": {
            parent: "email-alert"
        },
        "envelope-box": {
            parent: "email-box"
        },
        "envelope-fast": {
            parent: "email-fast"
        },
        "envelope-fast-outline": {
            parent: "email-fast-outline"
        },
        "envelope-lock": {
            parent: "email-lock"
        },
        "envelope-open": {
            parent: "email-open"
        },
        "envelope-open-outline": {
            parent: "email-open-outline"
        },
        "envelope-outline": {
            parent: "email-outline"
        },
        "envelope-plus": {
            parent: "email-plus"
        },
        "envelope-plus-outline": {
            parent: "email-plus-outline"
        },
        "envelope-secure": {
            parent: "email-lock"
        },
        "envelope-variant": {
            parent: "email-variant"
        },
        "envelope-warning": {
            parent: "email-alert"
        },
        equaliser: {
            parent: "tune"
        },
        "equaliser-vertical": {
            parent: "tune-vertical"
        },
        "equalizer-vertical": {
            parent: "tune-vertical-variant"
        },
        equestrian: {
            parent: "horse"
        },
        "equestrian-variant": {
            parent: "horse-variant"
        },
        erase: {
            parent: "backspace"
        },
        "erase-outline": {
            parent: "backspace-outline"
        },
        "erase-reverse": {
            parent: "backspace-reverse"
        },
        "erase-reverse-outline": {
            parent: "backspace-reverse-outline"
        },
        error: {
            parent: "alert-circle"
        },
        "error-outline": {
            parent: "alert-circle-outline"
        },
        eruption: {
            parent: "volcano"
        },
        "eruption-outline": {
            parent: "volcano-outline"
        },
        "espresso-machine": {
            parent: "coffee-maker"
        },
        "espresso-maker": {
            parent: "coffee-maker"
        },
        estate: {
            parent: "home-group"
        },
        euro: {
            parent: "currency-eur"
        },
        "euro-symbol": {
            parent: "currency-eur"
        },
        "ev-charger": {
            parent: "ev-station"
        },
        "ev-charger-ccs1": {
            parent: "ev-plug-ccs1"
        },
        "ev-charger-ccs2": {
            parent: "ev-plug-ccs2"
        },
        "ev-charger-chademo": {
            parent: "ev-plug-chademo"
        },
        "ev-charger-tesla": {
            parent: "ev-plug-tesla"
        },
        "ev-charger-type1": {
            parent: "ev-plug-type1"
        },
        "ev-charger-type2": {
            parent: "ev-plug-type2"
        },
        "ev-plug-ccs-combo-1": {
            parent: "ev-plug-ccs1"
        },
        "ev-plug-ccs-combo-2": {
            parent: "ev-plug-ccs2"
        },
        "ev-plug-j1772": {
            parent: "ev-plug-type1"
        },
        "ev-plug-mennekes": {
            parent: "ev-plug-type2"
        },
        event: {
            parent: "calendar"
        },
        "event-add": {
            parent: "calendar-plus"
        },
        "event-alert": {
            parent: "calendar-alert"
        },
        "event-available": {
            parent: "calendar-check"
        },
        "event-available-outline": {
            parent: "calendar-check-outline"
        },
        "event-blank-outline": {
            parent: "calendar-blank-outline"
        },
        "event-busy": {
            parent: "calendar-remove"
        },
        "event-busy-outline": {
            parent: "calendar-remove-outline"
        },
        "event-check": {
            parent: "calendar-check"
        },
        "event-check-outline": {
            parent: "calendar-check-outline"
        },
        "event-clock": {
            parent: "calendar-clock"
        },
        "event-edit": {
            parent: "calendar-edit"
        },
        "event-heart": {
            parent: "calendar-heart"
        },
        "event-minus": {
            parent: "calendar-minus"
        },
        "event-multiple": {
            parent: "calendar-multiple"
        },
        "event-multiple-check": {
            parent: "calendar-multiple-check"
        },
        "event-multiple-tick": {
            parent: "calendar-multiple-check"
        },
        "event-note": {
            parent: "calendar-text"
        },
        "event-note-outline": {
            parent: "calendar-text-outline"
        },
        "event-outline": {
            parent: "calendar-outline"
        },
        "event-plus": {
            parent: "calendar-plus"
        },
        "event-question": {
            parent: "calendar-question"
        },
        "event-range": {
            parent: "calendar-range"
        },
        "event-range-outline": {
            parent: "calendar-range-outline"
        },
        "event-remove": {
            parent: "calendar-remove"
        },
        "event-remove-outline": {
            parent: "calendar-remove-outline"
        },
        "event-search": {
            parent: "calendar-search"
        },
        "event-seat": {
            parent: "seat"
        },
        "event-seat-outline": {
            parent: "seat-outline"
        },
        "event-star": {
            parent: "calendar-star"
        },
        "event-text": {
            parent: "calendar-text"
        },
        "event-text-outline": {
            parent: "calendar-text-outline"
        },
        "event-tick": {
            parent: "calendar-check"
        },
        "event-tick-outline": {
            parent: "calendar-check-outline"
        },
        "event-time": {
            parent: "calendar-clock"
        },
        "event-week": {
            parent: "calendar-week"
        },
        "event-week-begin": {
            parent: "calendar-week-begin"
        },
        "event-week-begin-outline": {
            parent: "calendar-week-begin-outline"
        },
        "event-week-end": {
            parent: "calendar-week-end"
        },
        "event-week-end-outline": {
            parent: "calendar-filter-outline"
        },
        "event-week-outline": {
            parent: "calendar-week-outline"
        },
        events: {
            parent: "calendar-multiple"
        },
        "events-check": {
            parent: "calendar-multiple-check"
        },
        "events-tick": {
            parent: "calendar-multiple-check"
        },
        evse: {
            parent: "ev-station"
        },
        exchange: {
            parent: "swap-horizontal"
        },
        "exclamation-bold": {
            parent: "exclamation-thick"
        },
        exclusion: {
            parent: "set-left-right"
        },
        "expand-horizontal": {
            parent: "unfold-more-horizontal"
        },
        "expand-less": {
            parent: "chevron-up"
        },
        "expand-more": {
            parent: "chevron-down"
        },
        "expand-vertical": {
            parent: "unfold-more-vertical"
        },
        explore: {
            parent: "compass"
        },
        "explore-nearby": {
            parent: "map-marker-circle"
        },
        extension: {
            parent: "puzzle"
        },
        "extension-outline": {
            parent: "puzzle-outline"
        },
        "external-link": {
            parent: "open-in-new"
        },
        "external-temperature": {
            parent: "sun-thermometer"
        },
        "extra-life": {
            parent: "one-up"
        },
        "eye-add": {
            parent: "eye-plus"
        },
        "eye-add-outline": {
            parent: "eye-plus-outline"
        },
        "eye-tick": {
            parent: "eye-check"
        },
        "eye-tick-outline": {
            parent: "eye-check-outline"
        },
        fabric: {
            parent: "receipt"
        },
        "fabric-outline": {
            parent: "receipt-outline"
        },
        face: {
            parent: "emoticon"
        },
        "face-angry": {
            parent: "emoticon-angry"
        },
        "face-angry-outline": {
            parent: "emoticon-angry-outline"
        },
        "face-confused": {
            parent: "emoticon-confused"
        },
        "face-confused-outline": {
            parent: "emoticon-confused-outline"
        },
        "face-cool": {
            parent: "emoticon-cool"
        },
        "face-cool-outline": {
            parent: "emoticon-cool-outline"
        },
        "face-cry": {
            parent: "emoticon-cry"
        },
        "face-cry-outline": {
            parent: "emoticon-cry-outline"
        },
        "face-dead": {
            parent: "emoticon-dead"
        },
        "face-dead-outline": {
            parent: "emoticon-dead-outline"
        },
        "face-devil": {
            parent: "emoticon-devil"
        },
        "face-devil-outline": {
            parent: "emoticon-devil-outline"
        },
        "face-excited": {
            parent: "emoticon-excited"
        },
        "face-excited-outline": {
            parent: "emoticon-excited-outline"
        },
        "face-female": {
            parent: "face-woman"
        },
        "face-female-outline": {
            parent: "face-woman-outline"
        },
        "face-female-profile": {
            parent: "face-woman-profile"
        },
        "face-female-shimmer": {
            parent: "face-woman-shimmer"
        },
        "face-female-shimmer-outline": {
            parent: "face-woman-shimmer-outline"
        },
        "face-frown": {
            parent: "emoticon-frown"
        },
        "face-frown-outline": {
            parent: "emoticon-frown-outline"
        },
        "face-happy": {
            parent: "emoticon-happy"
        },
        "face-happy-outline": {
            parent: "emoticon-happy-outline"
        },
        "face-kiss": {
            parent: "emoticon-kiss"
        },
        "face-kiss-outline": {
            parent: "emoticon-kiss-outline"
        },
        "face-lol": {
            parent: "emoticon-lol"
        },
        "face-lol-outline": {
            parent: "emoticon-lol-outline"
        },
        "face-male": {
            parent: "face-man"
        },
        "face-male-outline": {
            parent: "face-man-outline"
        },
        "face-male-profile": {
            parent: "face-man-profile"
        },
        "face-male-shimmer": {
            parent: "face-man-shimmer"
        },
        "face-male-shimmer-outline": {
            parent: "face-man-shimmer-outline"
        },
        "face-neutral": {
            parent: "emoticon-neutral"
        },
        "face-neutral-outline": {
            parent: "emoticon-neutral-outline"
        },
        "face-outline": {
            parent: "emoticon-outline"
        },
        "face-poop": {
            parent: "emoticon-poop"
        },
        "face-poop-outline": {
            parent: "emoticon-poop-outline"
        },
        "face-profile": {
            parent: "face-man-profile"
        },
        "face-profile-woman": {
            parent: "face-woman-profile"
        },
        "face-retouching-natural": {
            parent: "face-man-shimmer"
        },
        "face-retouching-natural-outline": {
            parent: "face-man-shimmer-outline"
        },
        "face-retouching-natural-woman": {
            parent: "face-woman-shimmer"
        },
        "face-retouching-natural-woman-outline": {
            parent: "face-woman-shimmer-outline"
        },
        "face-sad": {
            parent: "emoticon-sad"
        },
        "face-sad-outline": {
            parent: "emoticon-sad-outline"
        },
        "face-shimmer": {
            parent: "face-man-shimmer"
        },
        "face-shimmer-outline": {
            parent: "face-man-shimmer-outline"
        },
        "face-sick": {
            parent: "emoticon-sick"
        },
        "face-sick-outline": {
            parent: "emoticon-sick-outline"
        },
        "face-sunglasses": {
            parent: "emoticon-cool"
        },
        "face-sunglasses-outline": {
            parent: "emoticon-cool-outline"
        },
        "face-tongue": {
            parent: "emoticon-tongue"
        },
        "face-tongue-outline": {
            parent: "emoticon-tongue-outline"
        },
        "face-wink": {
            parent: "emoticon-wink"
        },
        "face-wink-outline": {
            parent: "emoticon-wink-outline"
        },
        "facial-recognition": {
            parent: "face-recognition"
        },
        factorial: {
            parent: "exclamation"
        },
        fairy: {
            parent: "candy-outline"
        },
        "fairy-lights": {
            parent: "string-lights"
        },
        "fairy-lights-off": {
            parent: "string-lights-off"
        },
        family: {
            parent: "crowd"
        },
        "family-room": {
            parent: "sofa"
        },
        "family-room-outline": {
            parent: "sofa-outline"
        },
        "fan-schedule": {
            parent: "fan-clock"
        },
        "fan-speed-down": {
            parent: "fan-chevron-down"
        },
        "fan-speed-high": {
            parent: "fan-speed-3"
        },
        "fan-speed-low": {
            parent: "fan-speed-1"
        },
        "fan-speed-medium": {
            parent: "fan-speed-2"
        },
        "fan-speed-up": {
            parent: "fan-chevron-up"
        },
        "fan-timer": {
            parent: "fan-clock"
        },
        fantasy: {
            parent: "unicorn"
        },
        "fantasy-variant": {
            parent: "unicorn-variant"
        },
        faq: {
            parent: "frequently-asked-questions"
        },
        farewell: {
            parent: "hand-wave"
        },
        "farewell-outline": {
            parent: "hand-wave-outline"
        },
        farm: {
            parent: "barn"
        },
        "farm-home": {
            parent: "home-silo"
        },
        "farm-home-outline": {
            parent: "home-silo-outline"
        },
        "farm-house": {
            parent: "home-silo"
        },
        "farm-house-outline": {
            parent: "home-silo-outline"
        },
        "farm-outline": {
            parent: "silo-outline"
        },
        "fast-food": {
            parent: "food"
        },
        "fast-food-off": {
            parent: "food-off"
        },
        "fast-rewind": {
            parent: "rewind"
        },
        father: {
            parent: "human-male-boy"
        },
        "faucet-off": {
            parent: "water-pump-off"
        },
        favorite: {
            parent: "heart"
        },
        "favorite-add": {
            parent: "star-plus"
        },
        "favorite-add-outline": {
            parent: "star-plus-outline"
        },
        "favorite-border": {
            parent: "heart-outline"
        },
        "favorite-box": {
            parent: "star-box"
        },
        "favorite-box-multiple": {
            parent: "star-box-multiple"
        },
        "favorite-box-multiple-outline": {
            parent: "star-box-multiple-outline"
        },
        "favorite-box-outline": {
            parent: "star-box-outline"
        },
        "favorite-check": {
            parent: "star-check"
        },
        "favorite-check-outline": {
            parent: "star-check-outline"
        },
        "favorite-circle": {
            parent: "star-circle"
        },
        "favorite-circle-outline": {
            parent: "star-circle-outline"
        },
        "favorite-cog": {
            parent: "star-cog"
        },
        "favorite-cog-outline": {
            parent: "star-cog-outline"
        },
        "favorite-face": {
            parent: "star-face"
        },
        "favorite-half": {
            parent: "star-half"
        },
        "favorite-half-full": {
            parent: "star-half-full"
        },
        "favorite-minus": {
            parent: "star-minus"
        },
        "favorite-minus-outline": {
            parent: "star-minus-outline"
        },
        "favorite-off": {
            parent: "star-off"
        },
        "favorite-off-outline": {
            parent: "star-off-outline"
        },
        "favorite-outline": {
            parent: "heart-outline"
        },
        "favorite-plus": {
            parent: "star-plus"
        },
        "favorite-plus-outline": {
            parent: "star-plus-outline"
        },
        "favorite-remove": {
            parent: "star-remove"
        },
        "favorite-remove-outline": {
            parent: "star-remove-outline"
        },
        "favorite-settings": {
            parent: "star-settings"
        },
        "favorite-settings-outline": {
            parent: "star-settings-outline"
        },
        "favorite-shooting": {
            parent: "star-shooting"
        },
        "favorite-shooting-outline": {
            parent: "star-shooting-outline"
        },
        favourite: {
            parent: "heart"
        },
        "favourite-border": {
            parent: "heart-outline"
        },
        "favourite-outline": {
            parent: "heart-outline"
        },
        "feature-highlight": {
            parent: "star-circle-outline"
        },
        feedback: {
            parent: "comment-quote"
        },
        "feedback-outline": {
            parent: "comment-quote-outline"
        },
        fever: {
            parent: "emoticon-sick"
        },
        "fever-outline": {
            parent: "emoticon-sick-outline"
        },
        "fiber-manual-record": {
            parent: "record"
        },
        "fiber-new": {
            parent: "new-box"
        },
        "file-acrobat": {
            parent: "file-pdf"
        },
        "file-acrobat-box": {
            parent: "file-pdf-box"
        },
        "file-acrobat-box-outline": {
            parent: "file-pdf-box-outline"
        },
        "file-acrobat-outline": {
            parent: "file-pdf-outline"
        },
        "file-csv": {
            parent: "file-delimited"
        },
        "file-csv-outline": {
            parent: "file-delimited-outline"
        },
        "file-discard": {
            parent: "file-undo"
        },
        "file-document-add": {
            parent: "file-document-plus"
        },
        "file-document-add-outline": {
            parent: "file-document-plus-outline"
        },
        "file-document-box": {
            parent: "text-box"
        },
        "file-document-box-check": {
            parent: "text-box-check"
        },
        "file-document-box-check-outline": {
            parent: "text-box-check-outline"
        },
        "file-document-box-minus": {
            parent: "text-box-minus"
        },
        "file-document-box-minus-outline": {
            parent: "text-box-minus-outline"
        },
        "file-document-box-multiple": {
            parent: "text-box-multiple"
        },
        "file-document-box-multiple-outline": {
            parent: "text-box-multiple-outline"
        },
        "file-document-box-outline": {
            parent: "text-box-outline"
        },
        "file-document-box-plus": {
            parent: "text-box-plus"
        },
        "file-document-box-plus-outline": {
            parent: "text-box-plus-outline"
        },
        "file-document-box-remove": {
            parent: "text-box-remove"
        },
        "file-document-box-remove-outline": {
            parent: "text-box-remove-outline"
        },
        "file-document-box-search": {
            parent: "text-box-search"
        },
        "file-document-box-search-outline": {
            parent: "text-box-search-outline"
        },
        "file-document-box-tick": {
            parent: "text-box-check"
        },
        "file-document-box-tick-outline": {
            parent: "text-box-check-outline"
        },
        "file-document-boxes": {
            parent: "text-box-multiple"
        },
        "file-document-boxes-outline": {
            parent: "text-box-multiple-outline"
        },
        "file-document-delete": {
            parent: "file-document-remove"
        },
        "file-document-delete-outline": {
            parent: "file-document-remove-outline"
        },
        "file-document-error": {
            parent: "file-document-alert"
        },
        "file-document-error-outline": {
            parent: "file-document-alert-outline"
        },
        "file-document-tick": {
            parent: "file-document-check"
        },
        "file-document-tick-outline": {
            parent: "file-document-check-outline"
        },
        "file-exchange": {
            parent: "file-arrow-left-right"
        },
        "file-exchange-outline": {
            parent: "file-arrow-left-right-outline"
        },
        "file-favorite": {
            parent: "file-star"
        },
        "file-favorite-outline": {
            parent: "file-star-outline"
        },
        "file-graph": {
            parent: "file-chart"
        },
        "file-graph-outline": {
            parent: "file-chart-outline"
        },
        "file-image-add": {
            parent: "file-image-plus"
        },
        "file-image-add-outline": {
            parent: "file-image-plus-outline"
        },
        "file-image-location": {
            parent: "file-image-marker"
        },
        "file-image-location-outline": {
            parent: "file-image-marker-outline"
        },
        "file-jpeg-box": {
            parent: "file-jpg-box"
        },
        "file-location": {
            parent: "file-marker"
        },
        "file-location-outline": {
            parent: "file-marker-outline"
        },
        "file-report": {
            parent: "file-chart"
        },
        "file-report-outline": {
            parent: "file-chart-outline"
        },
        "file-revert": {
            parent: "file-undo"
        },
        "file-rotate-ccw": {
            parent: "file-rotate-left"
        },
        "file-rotate-ccw-outline": {
            parent: "file-rotate-left-outline"
        },
        "file-rotate-clockwise": {
            parent: "file-rotate-right"
        },
        "file-rotate-counter-clockwise": {
            parent: "file-rotate-left"
        },
        "file-rotate-counter-clockwise-outline": {
            parent: "file-rotate-left-outline"
        },
        "file-settings-cog": {
            parent: "file-cog"
        },
        "file-settings-cog-outline": {
            parent: "file-cog-outline"
        },
        "file-settings-variant": {
            parent: "file-cog"
        },
        "file-settings-variant-outline": {
            parent: "file-cog-outline"
        },
        "file-tick": {
            parent: "file-check"
        },
        "file-transfer": {
            parent: "file-arrow-left-right"
        },
        "file-transfer-outline": {
            parent: "file-arrow-left-right-outline"
        },
        "file-upload-download": {
            parent: "file-arrow-up-down"
        },
        "file-upload-download-outline": {
            parent: "file-arrow-up-down-outline"
        },
        "file-user": {
            parent: "file-account"
        },
        "file-warning": {
            parent: "file-alert"
        },
        "file-warning-outline": {
            parent: "file-alert-outline"
        },
        files: {
            parent: "file-multiple"
        },
        "filing-cabinet": {
            parent: "file-cabinet"
        },
        "film-check": {
            parent: "movie-check"
        },
        "film-check-outline": {
            parent: "movie-check-outline"
        },
        "film-cog": {
            parent: "movie-cog"
        },
        "film-cog-outline": {
            parent: "movie-cog-outline"
        },
        "film-edit": {
            parent: "movie-edit"
        },
        "film-edit-outline": {
            parent: "movie-edit-outline"
        },
        "film-minus": {
            parent: "movie-minus"
        },
        "film-minus-outline": {
            parent: "movie-minus-outline"
        },
        "film-off": {
            parent: "movie-off"
        },
        "film-off-outline": {
            parent: "movie-off-outline"
        },
        "film-open": {
            parent: "movie-open"
        },
        "film-open-check": {
            parent: "movie-open-check"
        },
        "film-open-check-outline": {
            parent: "movie-open-check-outline"
        },
        "film-open-cog": {
            parent: "movie-open-cog"
        },
        "film-open-cog-outline": {
            parent: "movie-open-cog-outline"
        },
        "film-open-edit": {
            parent: "movie-open-edit"
        },
        "film-open-edit-outline": {
            parent: "movie-open-edit-outline"
        },
        "film-open-minus": {
            parent: "movie-open-minus"
        },
        "film-open-minus-outline": {
            parent: "movie-open-minus-outline"
        },
        "film-open-off": {
            parent: "movie-open-off"
        },
        "film-open-off-outline": {
            parent: "movie-open-off-outline"
        },
        "film-open-outline": {
            parent: "movie-open-outline"
        },
        "film-open-play": {
            parent: "movie-open-play"
        },
        "film-open-play-outline": {
            parent: "movie-open-play-outline"
        },
        "film-open-plus-outline": {
            parent: "movie-open-plus-outline"
        },
        "film-open-remove": {
            parent: "movie-open-remove"
        },
        "film-open-remove-outline": {
            parent: "movie-open-remove-outline"
        },
        "film-open-settings": {
            parent: "movie-open-settings"
        },
        "film-open-settings-outline": {
            parent: "movie-open-settings-outline"
        },
        "film-open-star": {
            parent: "movie-open-star"
        },
        "film-open-star-outline": {
            parent: "movie-open-star-outline"
        },
        "film-outline": {
            parent: "movie-outline"
        },
        "film-play": {
            parent: "movie-play"
        },
        "film-play-outline": {
            parent: "movie-play-outline"
        },
        "film-plus": {
            parent: "movie-plus"
        },
        "film-plus-outline": {
            parent: "movie-plus-outline"
        },
        "film-reel": {
            parent: "movie-roll"
        },
        "film-remove": {
            parent: "movie-remove"
        },
        "film-remove-outline": {
            parent: "movie-remove-outline"
        },
        "film-settings": {
            parent: "movie-settings"
        },
        "film-settings-outline": {
            parent: "movie-settings-outline"
        },
        "film-star": {
            parent: "movie-star"
        },
        "film-star-outline": {
            parent: "movie-star-outline"
        },
        "filter-1": {
            parent: "numeric-1-box-multiple-outline"
        },
        "filter-2": {
            parent: "numeric-2-box-multiple-outline"
        },
        "filter-3": {
            parent: "numeric-3-box-multiple-outline"
        },
        "filter-4": {
            parent: "numeric-4-box-multiple-outline"
        },
        "filter-5": {
            parent: "numeric-5-box-multiple-outline"
        },
        "filter-6": {
            parent: "numeric-6-box-multiple-outline"
        },
        "filter-7": {
            parent: "numeric-7-box-multiple-outline"
        },
        "filter-8": {
            parent: "numeric-8-box-multiple-outline"
        },
        "filter-9": {
            parent: "numeric-9-box-multiple-outline"
        },
        "filter-9-plus": {
            parent: "numeric-9-plus-box-multiple-outline"
        },
        "filter-b-and-w": {
            parent: "image-filter-black-white"
        },
        "filter-gear": {
            parent: "filter-cog"
        },
        "filter-gear-outline": {
            parent: "filter-cog-outline"
        },
        "filter-list": {
            parent: "filter-variant"
        },
        "find-in-page": {
            parent: "file-find"
        },
        "find-my-phone": {
            parent: "cellphone-marker"
        },
        "finger-chips": {
            parent: "french-fries"
        },
        "fire-engine": {
            parent: "fire-truck"
        },
        firewall: {
            parent: "wall-fire"
        },
        "first-aid-kit": {
            parent: "medical-bag"
        },
        "first-page": {
            parent: "page-first"
        },
        "fish-food": {
            parent: "shaker"
        },
        "fish-food-outline": {
            parent: "shaker-outline"
        },
        fishing: {
            parent: "spear"
        },
        "fitness-center": {
            parent: "dumbbell"
        },
        five: {
            parent: "tally-mark-5"
        },
        "flag-add": {
            parent: "flag-plus"
        },
        flame: {
            parent: "fire"
        },
        "flame-alert": {
            parent: "fire-alert"
        },
        "flame-circle": {
            parent: "fire-circle"
        },
        "flame-off": {
            parent: "fire-off"
        },
        "flash-circle": {
            parent: "lightning-bolt-circle"
        },
        "flash-on": {
            parent: "flash"
        },
        flatiron: {
            parent: "iron"
        },
        "flatiron-outline": {
            parent: "iron-outline"
        },
        fleet: {
            parent: "bus-multiple"
        },
        flight: {
            parent: "airplane"
        },
        "flight-land": {
            parent: "airplane-landing"
        },
        "flight-mode": {
            parent: "airplane"
        },
        "flight-mode-off": {
            parent: "airplane-off"
        },
        "flight-takeoff": {
            parent: "airplane-takeoff"
        },
        "flim-open-plus": {
            parent: "movie-open-plus"
        },
        flood: {
            parent: "waves"
        },
        "floodlight-down": {
            parent: "light-flood-down"
        },
        "floodlight-up": {
            parent: "light-flood-up"
        },
        "floor-lamp-variant": {
            parent: "floor-lamp-torchiere-variant"
        },
        "floor-light": {
            parent: "floor-lamp"
        },
        "floor-light-dual": {
            parent: "floor-lamp-dual"
        },
        "floor-light-dual-outline": {
            parent: "floor-lamp-dual-outline"
        },
        "floor-light-outline": {
            parent: "floor-lamp-outline"
        },
        "floor-light-torchiere": {
            parent: "floor-lamp-torchiere"
        },
        "floor-light-torchiere-variant": {
            parent: "floor-lamp-torchiere-variant"
        },
        "floor-light-torchiere-variant-outline": {
            parent: "floor-lamp-torchiere-variant-outline"
        },
        "floor-light-variant": {
            parent: "floor-lamp-torchiere-variant"
        },
        "floppy-disc": {
            parent: "content-save"
        },
        "floppy-disc-alert": {
            parent: "content-save-alert"
        },
        "floppy-disc-alert-outline": {
            parent: "content-save-alert-outline"
        },
        "floppy-disc-cog": {
            parent: "content-save-cog"
        },
        "floppy-disc-cog-outline": {
            parent: "content-save-cog-outline"
        },
        "floppy-disc-edit": {
            parent: "content-save-edit"
        },
        "floppy-disc-edit-outline": {
            parent: "content-save-edit-outline"
        },
        "floppy-disc-move": {
            parent: "content-save-move"
        },
        "floppy-disc-move-outline": {
            parent: "content-save-move-outline"
        },
        "floppy-disc-multiple": {
            parent: "content-save-all"
        },
        "floppy-disc-multiple-outline": {
            parent: "content-save-all-outline"
        },
        "floppy-disc-settings": {
            parent: "content-save-settings"
        },
        "floppy-disc-settings-outline": {
            parent: "content-save-settings-outline"
        },
        "floppy-disk": {
            parent: "content-save"
        },
        flowchart: {
            parent: "sitemap"
        },
        "flowchart-outline": {
            parent: "sitemap-outline"
        },
        "flower-lotus": {
            parent: "spa"
        },
        "flower-lotus-outline": {
            parent: "spa-outline"
        },
        flurries: {
            parent: "weather-snowy-heavy"
        },
        fly: {
            parent: "bee"
        },
        "fly-flower": {
            parent: "bee-flower"
        },
        "folder-add": {
            parent: "folder-plus"
        },
        "folder-add-outline": {
            parent: "folder-plus-outline"
        },
        "folder-favorite": {
            parent: "folder-star"
        },
        "folder-favorite-multiple": {
            parent: "folder-star-multiple"
        },
        "folder-favorite-multiple-outline": {
            parent: "folder-star-multiple-outline"
        },
        "folder-favorite-outline": {
            parent: "folder-star-outline"
        },
        "folder-hash": {
            parent: "folder-pound"
        },
        "folder-hash-outline": {
            parent: "folder-pound-outline"
        },
        "folder-help": {
            parent: "folder-question"
        },
        "folder-help-outline": {
            parent: "folder-question-outline"
        },
        "folder-house": {
            parent: "folder-home"
        },
        "folder-house-outline": {
            parent: "folder-home-outline"
        },
        "folder-location": {
            parent: "folder-marker"
        },
        "folder-location-outline": {
            parent: "folder-marker-outline"
        },
        "folder-media": {
            parent: "folder-play"
        },
        "folder-media-outline": {
            parent: "folder-play-outline"
        },
        "folder-mydrive": {
            parent: "folder-google-drive"
        },
        "folder-settings-variant": {
            parent: "folder-cog"
        },
        "folder-settings-variant-outline": {
            parent: "folder-cog-outline"
        },
        "folder-shared": {
            parent: "folder-account"
        },
        "folder-shared-outline": {
            parent: "folder-account-outline"
        },
        "folder-special": {
            parent: "folder-star"
        },
        "folder-special-outline": {
            parent: "folder-star-outline"
        },
        "folder-transfer": {
            parent: "folder-arrow-up-down"
        },
        "folder-transfer-outline": {
            parent: "folder-arrow-up-down-outline"
        },
        "folder-user": {
            parent: "folder-account"
        },
        "folder-user-outline": {
            parent: "folder-account-outline"
        },
        "folder-video": {
            parent: "folder-play"
        },
        "folder-video-outline": {
            parent: "folder-play-outline"
        },
        "folder-warning": {
            parent: "folder-alert"
        },
        "folder-warning-outline": {
            parent: "folder-alert-outline"
        },
        folders: {
            parent: "folder-multiple"
        },
        "folders-image": {
            parent: "folder-multiple-image"
        },
        "folders-outline": {
            parent: "folder-multiple-outline"
        },
        "font-size": {
            parent: "format-size"
        },
        "food-allergy": {
            parent: "peanut"
        },
        "food-allergy-off": {
            parent: "peanut-off"
        },
        "food-allergy-off-outline": {
            parent: "peanut-off-outline"
        },
        "food-allergy-outline": {
            parent: "peanut-outline"
        },
        "food-fork-cup": {
            parent: "food-fork-drink"
        },
        "food-frankfurter": {
            parent: "food-hot-dog"
        },
        "food-italian": {
            parent: "pasta"
        },
        "food-jewish": {
            parent: "food-kosher"
        },
        "food-muslim": {
            parent: "food-halal"
        },
        "food-processor": {
            parent: "blender"
        },
        "food-processor-outline": {
            parent: "blender-outline"
        },
        "food-ramen": {
            parent: "noodles"
        },
        "food-weiner": {
            parent: "food-hot-dog"
        },
        "football-american": {
            parent: "football"
        },
        "football-pitch": {
            parent: "soccer-field"
        },
        "football-play": {
            parent: "strategy"
        },
        footprints: {
            parent: "shoe-print"
        },
        forbid: {
            parent: "cancel"
        },
        "foreign-key": {
            parent: "key-link"
        },
        forestry: {
            parent: "forest"
        },
        forever: {
            parent: "all-inclusive"
        },
        "forever-box": {
            parent: "all-inclusive-box"
        },
        "forever-box-outline": {
            parent: "all-inclusive-box-outline"
        },
        "forgot-password": {
            parent: "lock-question"
        },
        form: {
            parent: "list-box"
        },
        "form-outline": {
            parent: "list-box-outline"
        },
        "format-align-centre": {
            parent: "format-align-center"
        },
        "format-annotation-add": {
            parent: "format-annotation-plus"
        },
        "format-color-redact": {
            parent: "format-color-marker-cancel"
        },
        "format-color-reset": {
            parent: "water-off"
        },
        "format-colour-fill": {
            parent: "format-color-fill"
        },
        "format-colour-highlight": {
            parent: "format-color-highlight"
        },
        "format-colour-text": {
            parent: "format-color-text"
        },
        "format-float-centre": {
            parent: "format-float-center"
        },
        "format-header-hash": {
            parent: "format-header-pound"
        },
        "format-heading-1": {
            parent: "format-header-1"
        },
        "format-heading-2": {
            parent: "format-header-2"
        },
        "format-heading-3": {
            parent: "format-header-3"
        },
        "format-heading-4": {
            parent: "format-header-4"
        },
        "format-heading-5": {
            parent: "format-header-5"
        },
        "format-heading-6": {
            parent: "format-header-6"
        },
        "format-heading-decease": {
            parent: "format-header-decrease"
        },
        "format-heading-equal": {
            parent: "format-header-equal"
        },
        "format-heading-hash": {
            parent: "format-header-pound"
        },
        "format-heading-increase": {
            parent: "format-header-increase"
        },
        "format-heading-markdown": {
            parent: "format-header-pound"
        },
        "format-heading-pound": {
            parent: "format-header-pound"
        },
        "format-horizontal-align-centre": {
            parent: "format-horizontal-align-center"
        },
        "format-kerning": {
            parent: "format-letter-spacing"
        },
        "format-list-group-add": {
            parent: "format-list-group-plus"
        },
        "format-list-numbered-right-to-left": {
            parent: "format-list-numbered-rtl"
        },
        "format-list-numbers": {
            parent: "format-list-numbered"
        },
        "format-lowercase": {
            parent: "format-letter-case-lower"
        },
        "format-rotate-ninety": {
            parent: "format-rotate-90"
        },
        "format-textdirection-l-to-r": {
            parent: "format-pilcrow-arrow-right"
        },
        "format-textdirection-r-to-l": {
            parent: "format-pilcrow-arrow-left"
        },
        "format-underlined": {
            parent: "format-underline"
        },
        "format-uppercase": {
            parent: "format-letter-case-upper"
        },
        "format-vertical-align-centre": {
            parent: "format-vertical-align-center"
        },
        fortnite: {
            parent: "silverware-fork-knife"
        },
        "forum-add": {
            parent: "forum-plus"
        },
        "forum-add-outline": {
            parent: "forum-plus-outline"
        },
        "forum-delete": {
            parent: "forum-remove"
        },
        "forum-delete-outline": {
            parent: "forum-remove-outline"
        },
        "forum-subtract": {
            parent: "forum-minus"
        },
        "forum-subtract-outline": {
            parent: "forum-minus-outline"
        },
        "forward-off": {
            parent: "share-off"
        },
        "forward-off-outline": {
            parent: "share-off-outline"
        },
        "forward-outline": {
            parent: "share-outline"
        },
        "fossil-fuel": {
            parent: "barrel"
        },
        "fossil-fuel-outline": {
            parent: "barrel-outline"
        },
        four: {
            parent: "tally-mark-4"
        },
        foyer: {
            parent: "coat-rack"
        },
        fragrance: {
            parent: "scent"
        },
        "fragrance-off": {
            parent: "scent-off"
        },
        "frame-backward": {
            parent: "step-backward-2"
        },
        "frame-forward": {
            parent: "step-forward-2"
        },
        franc: {
            parent: "currency-chf"
        },
        france: {
            parent: "eiffel-tower"
        },
        "free-breakfast": {
            parent: "coffee"
        },
        "free-breakfast-off": {
            parent: "coffee-off"
        },
        "free-breakfast-off-outline": {
            parent: "coffee-off-outline"
        },
        "free-breakfast-outline": {
            parent: "coffee-outline"
        },
        "free-breakfast-to-go": {
            parent: "coffee-to-go"
        },
        "free-breakfast-to-go-outline": {
            parent: "coffee-to-go-outline"
        },
        "freehand-line": {
            parent: "gesture"
        },
        freemasonry: {
            parent: "ruler-square-compass"
        },
        "freeze-advisory": {
            parent: "snowflake-alert"
        },
        "freezing-point": {
            parent: "snowflake-thermometer"
        },
        "french-baguette": {
            parent: "baguette"
        },
        "french-door": {
            parent: "door-sliding"
        },
        "french-door-lock": {
            parent: "door-sliding-lock"
        },
        "french-door-open": {
            parent: "door-sliding-open"
        },
        "french-fry": {
            parent: "french-fries"
        },
        frequency: {
            parent: "cosine-wave"
        },
        "fridge-filled": {
            parent: "fridge"
        },
        "fridge-filled-bottom": {
            parent: "fridge-top"
        },
        "fridge-filled-top": {
            parent: "fridge-bottom"
        },
        "fried-potatoes": {
            parent: "french-fries"
        },
        fries: {
            parent: "french-fries"
        },
        frites: {
            parent: "french-fries"
        },
        "frost-point": {
            parent: "snowflake-thermometer"
        },
        "fruit-ananas": {
            parent: "fruit-pineapple"
        },
        "fruit-lemon": {
            parent: "fruit-citrus"
        },
        "fruit-lime": {
            parent: "fruit-citrus"
        },
        "fuel-pump": {
            parent: "gas-station"
        },
        "fuel-pump-outline": {
            parent: "gas-station-outline"
        },
        "fuel-station": {
            parent: "gas-station"
        },
        "fuel-station-outline": {
            parent: "gas-station-outline"
        },
        "fuel-truck": {
            parent: "tanker-truck"
        },
        "full-outer-join": {
            parent: "set-all"
        },
        fungus: {
            parent: "mushroom"
        },
        "fungus-outline": {
            parent: "mushroom-outline"
        },
        funnel: {
            parent: "filter"
        },
        "funnel-check": {
            parent: "filter-check"
        },
        "funnel-check-outline": {
            parent: "filter-check-outline"
        },
        "funnel-cog": {
            parent: "filter-cog"
        },
        "funnel-cog-outline": {
            parent: "filter-cog-outline"
        },
        "funnel-gear": {
            parent: "filter-cog"
        },
        "funnel-gear-outline": {
            parent: "filter-cog-outline"
        },
        "funnel-minus": {
            parent: "filter-minus"
        },
        "funnel-minus-outline": {
            parent: "filter-minus-outline"
        },
        "funnel-multiple": {
            parent: "filter-multiple"
        },
        "funnel-multiple-outline": {
            parent: "filter-multiple-outline"
        },
        "funnel-outline": {
            parent: "filter-outline"
        },
        "funnel-plus": {
            parent: "filter-plus"
        },
        "funnel-plus-outline": {
            parent: "filter-plus-outline"
        },
        "funnel-remove": {
            parent: "filter-remove"
        },
        "funnel-remove-outline": {
            parent: "filter-remove-outline"
        },
        "funnel-settings": {
            parent: "filter-cog"
        },
        "funnel-settings-outline": {
            parent: "filter-cog-outline"
        },
        "g-translate": {
            parent: "google-translate"
        },
        gambling: {
            parent: "slot-machine"
        },
        "gambling-chip": {
            parent: "poker-chip"
        },
        "gambling-outline": {
            parent: "slot-machine-outline"
        },
        "gamepad-classic": {
            parent: "controller-classic"
        },
        "gamepad-classic-outline": {
            parent: "controller-classic-outline"
        },
        "gamepad-off": {
            parent: "controller-off"
        },
        games: {
            parent: "gamepad"
        },
        "games-outline": {
            parent: "gamepad-outline"
        },
        "garage-warning": {
            parent: "garage-alert"
        },
        garbage: {
            parent: "delete"
        },
        "garbage-can": {
            parent: "delete"
        },
        "garbage-can-circle": {
            parent: "delete-circle"
        },
        "garbage-can-circle-outline": {
            parent: "delete-circle-outline"
        },
        "garbage-can-empty": {
            parent: "delete-empty"
        },
        "garbage-can-outline": {
            parent: "delete-outline"
        },
        "garbage-circle": {
            parent: "delete-circle"
        },
        "garbage-circle-outline": {
            parent: "delete-circle-outline"
        },
        "garbage-empty": {
            parent: "delete-empty"
        },
        "garbage-outline": {
            parent: "delete-outline"
        },
        gardening: {
            parent: "shovel"
        },
        gas: {
            parent: "fire"
        },
        "gas-circle": {
            parent: "fire-circle"
        },
        "gas-co": {
            parent: "molecule-co"
        },
        "gas-co2": {
            parent: "molecule-co2"
        },
        "gas-pump": {
            parent: "gas-station"
        },
        "gas-pump-outline": {
            parent: "gas-station-outline"
        },
        "gas-tank": {
            parent: "storage-tank"
        },
        "gas-tank-outline": {
            parent: "storage-tank-outline"
        },
        "gas-water-boiler": {
            parent: "water-boiler"
        },
        "gas-water-heater": {
            parent: "water-boiler"
        },
        gasoline: {
            parent: "fuel"
        },
        gastropod: {
            parent: "snail"
        },
        gear: {
            parent: "cog"
        },
        "gear-box": {
            parent: "cog-box"
        },
        "gear-outline": {
            parent: "cog-outline"
        },
        "gear-pause": {
            parent: "cog-pause"
        },
        "gear-pause-outline": {
            parent: "cog-pause-outline"
        },
        "gear-play": {
            parent: "cog-play"
        },
        "gear-play-outline": {
            parent: "cog-play-outline"
        },
        "gear-stop": {
            parent: "cog-stop"
        },
        "gear-stop-outline": {
            parent: "cog-stop-outline"
        },
        "gender-enby": {
            parent: "gender-non-binary"
        },
        "genie-lamp": {
            parent: "oil-lamp"
        },
        germ: {
            parent: "allergy"
        },
        "gesture-touch": {
            parent: "gesture-tap"
        },
        "gesture-touch-box": {
            parent: "gesture-tap-box"
        },
        "gesture-touch-button": {
            parent: "gesture-tap-button"
        },
        "gesture-touch-hold": {
            parent: "gesture-tap-hold"
        },
        "get-app": {
            parent: "download"
        },
        girandole: {
            parent: "chandelier"
        },
        "git-issue": {
            parent: "alert-circle-outline"
        },
        "git-repository": {
            parent: "book"
        },
        "github-circle": {
            parent: "github"
        },
        "give-way": {
            parent: "sign-yield"
        },
        glass: {
            parent: "cup"
        },
        "glass-broken": {
            parent: "glass-fragile"
        },
        "glass-liquid": {
            parent: "cup-water"
        },
        "glass-off": {
            parent: "cup-off"
        },
        "glass-off-outline": {
            parent: "cup-off-outline"
        },
        "glass-outline": {
            parent: "cup-outline"
        },
        "glass-water": {
            parent: "cup-water"
        },
        glasshouse: {
            parent: "greenhouse"
        },
        "global-search": {
            parent: "search-web"
        },
        globe: {
            parent: "earth"
        },
        "globe-arrow-right": {
            parent: "earth-arrow-right"
        },
        "globe-box": {
            parent: "earth-box"
        },
        "globe-box-minus": {
            parent: "earth-box-minus"
        },
        "globe-box-off": {
            parent: "earth-box-off"
        },
        "globe-box-plus": {
            parent: "earth-box-plus"
        },
        "globe-box-remove": {
            parent: "earth-box-remove"
        },
        "globe-minus": {
            parent: "earth-minus"
        },
        "globe-off": {
            parent: "earth-off"
        },
        "globe-plus": {
            parent: "earth-plus"
        },
        "globe-remove": {
            parent: "earth-remove"
        },
        glove: {
            parent: "mixed-martial-arts"
        },
        gluten: {
            parent: "barley"
        },
        "gluten-free": {
            parent: "barley-off"
        },
        goal: {
            parent: "flag-checkered"
        },
        "gog-com": {
            parent: "gog"
        },
        "golf-course": {
            parent: "golf"
        },
        "google-adwords": {
            parent: "google-ads"
        },
        "google-controller": {
            parent: "controller"
        },
        "google-controller-off": {
            parent: "controller-off"
        },
        "google-gamepad": {
            parent: "controller"
        },
        "google-gamepad-off": {
            parent: "controller-off"
        },
        "gps-fixed": {
            parent: "crosshairs-gps"
        },
        "gps-not-fixed": {
            parent: "crosshairs"
        },
        "gps-unknown": {
            parent: "crosshairs-question"
        },
        gpu: {
            parent: "expansion-card"
        },
        grade: {
            parent: "star"
        },
        gradient: {
            parent: "gradient-vertical"
        },
        "graduation-cap": {
            parent: "school"
        },
        "graduation-cap-outline": {
            parent: "school-outline"
        },
        "grain-off": {
            parent: "barley-off"
        },
        "graph-areaspline": {
            parent: "chart-areaspline"
        },
        "graph-areaspline-variant": {
            parent: "chart-areaspline-variant"
        },
        "graph-bar": {
            parent: "chart-bar"
        },
        "graph-bar-stacked": {
            parent: "chart-bar-stacked"
        },
        "graph-bell-curve": {
            parent: "chart-bell-curve"
        },
        "graph-bell-curve-cumulative": {
            parent: "chart-bell-curve-cumulative"
        },
        "graph-box": {
            parent: "chart-box"
        },
        "graph-box-outline": {
            parent: "chart-box-outline"
        },
        "graph-box-plus-outline": {
            parent: "chart-box-plus-outline"
        },
        "graph-histogram": {
            parent: "chart-histogram"
        },
        "graph-line": {
            parent: "chart-line"
        },
        "graph-line-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "graph-line-stacked": {
            parent: "chart-line-stacked"
        },
        "graph-line-variant": {
            parent: "chart-line-variant"
        },
        "graph-multiline": {
            parent: "chart-multiline"
        },
        "graph-multiple": {
            parent: "chart-multiple"
        },
        "graph-pie": {
            parent: "chart-pie"
        },
        "graph-ppf": {
            parent: "chart-ppf"
        },
        "graph-sankey": {
            parent: "chart-sankey"
        },
        "graph-sankey-variant": {
            parent: "chart-sankey-variant"
        },
        "graph-scatter-plot": {
            parent: "chart-scatter-plot"
        },
        "graph-scatter-plot-hexbin": {
            parent: "chart-scatter-plot-hexbin"
        },
        "graph-timeline": {
            parent: "chart-timeline"
        },
        "graph-timeline-variant": {
            parent: "chart-timeline-variant"
        },
        "graph-timeline-variant-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "graphics-processing-unit": {
            parent: "expansion-card"
        },
        graveyard: {
            parent: "grave-stone"
        },
        "green-circle": {
            parent: "leaf-circle"
        },
        "green-circle-outline": {
            parent: "leaf-circle-outline"
        },
        "green-house": {
            parent: "hoop-house"
        },
        greeting: {
            parent: "hand-wave"
        },
        "greeting-outline": {
            parent: "hand-wave-outline"
        },
        "grid-on": {
            parent: "grid"
        },
        "group-add": {
            parent: "account-multiple-plus"
        },
        "group-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        guardian: {
            parent: "account-child"
        },
        "guardian-circle": {
            parent: "account-child-circle"
        },
        "guest-room": {
            parent: "bed"
        },
        "guest-room-outline": {
            parent: "bed-outline"
        },
        "guide-dog": {
            parent: "dog-service"
        },
        gun: {
            parent: "pistol"
        },
        gym: {
            parent: "dumbbell"
        },
        gyro: {
            parent: "axis-arrow"
        },
        hackernews: {
            parent: "y-combinator"
        },
        "hail-cab": {
            parent: "hail"
        },
        "hail-taxi": {
            parent: "hail"
        },
        hallway: {
            parent: "coat-rack"
        },
        "hamburger-menu": {
            parent: "menu"
        },
        "hamburger-menu-back": {
            parent: "backburger"
        },
        hand: {
            parent: "allergy"
        },
        "hand-bike": {
            parent: "hand-cycle"
        },
        "hand-blood": {
            parent: "diabetes"
        },
        "hand-double-tap": {
            parent: "gesture-double-tap"
        },
        "hand-open": {
            parent: "hand-extended"
        },
        "hand-open-outline": {
            parent: "hand-extended-outline"
        },
        "hand-palm": {
            parent: "hand-extended"
        },
        "hand-palm-outline": {
            parent: "hand-extended-outline"
        },
        "hand-reading": {
            parent: "braille"
        },
        "hand-sanitizer": {
            parent: "lotion-plus"
        },
        "hand-sanitizer-outline": {
            parent: "lotion-plus-outline"
        },
        "hand-tap": {
            parent: "gesture-tap"
        },
        "hand-truck": {
            parent: "dolly"
        },
        hare: {
            parent: "rabbit"
        },
        "hare-outline": {
            parent: "rabbit-variant-outline"
        },
        "harry-potter": {
            parent: "deathly-hallows"
        },
        hashtag: {
            parent: "pound"
        },
        "hashtag-box": {
            parent: "pound-box"
        },
        "hashtag-box-outline": {
            parent: "pound-box-outline"
        },
        hd: {
            parent: "high-definition"
        },
        "hd-box": {
            parent: "high-definition-box"
        },
        hdd: {
            parent: "harddisk"
        },
        "hdd-plus": {
            parent: "harddisk-plus"
        },
        "hdd-remove": {
            parent: "harddisk-remove"
        },
        "head-ache": {
            parent: "head-flash"
        },
        "head-ache-outline": {
            parent: "head-flash-outline"
        },
        "head-bulb": {
            parent: "head-lightbulb"
        },
        "head-bulb-outline": {
            parent: "head-lightbulb-outline"
        },
        "head-freeze": {
            parent: "head-snowflake"
        },
        "head-freeze-outline": {
            parent: "head-snowflake-outline"
        },
        "head-idea": {
            parent: "head-lightbulb"
        },
        "head-idea-outline": {
            parent: "head-lightbulb-outline"
        },
        "head-light-dimmed": {
            parent: "car-light-dimmed"
        },
        "head-light-fog": {
            parent: "car-light-fog"
        },
        "head-light-high": {
            parent: "car-light-high"
        },
        "head-love": {
            parent: "head-heart"
        },
        "head-love-outline": {
            parent: "head-heart-outline"
        },
        "head-refresh": {
            parent: "head-sync"
        },
        "head-refresh-outline": {
            parent: "head-sync-outline"
        },
        "head-reload": {
            parent: "head-sync"
        },
        "head-reload-outline": {
            parent: "head-sync-outline"
        },
        "head-thinking": {
            parent: "head-dots-horizontal"
        },
        "head-thinking-outline": {
            parent: "head-dots-horizontal-outline"
        },
        "headphones-off-outline": {
            parent: "earbuds-off-outline"
        },
        "headphones-outline": {
            parent: "earbuds-outline"
        },
        "headset-mic": {
            parent: "headset"
        },
        headstone: {
            parent: "grave-stone"
        },
        "health-potion": {
            parent: "bottle-tonic-plus"
        },
        "health-potion-outline": {
            parent: "bottle-tonic-plus-outline"
        },
        "hearing-impaired": {
            parent: "ear-hearing-off"
        },
        "heart-vitals": {
            parent: "heart-pulse"
        },
        hearts: {
            parent: "heart-multiple"
        },
        "hearts-outline": {
            parent: "heart-multiple-outline"
        },
        "heat-advisory": {
            parent: "weather-sunny-alert"
        },
        "heat-alert": {
            parent: "weather-sunny-alert"
        },
        "heat-cool": {
            parent: "sun-snowflake"
        },
        "heat-index": {
            parent: "sun-thermometer"
        },
        "heated-floor": {
            parent: "heating-coil"
        },
        heater: {
            parent: "radiator"
        },
        "heater-disabled": {
            parent: "radiator-disabled"
        },
        "heater-off": {
            parent: "radiator-off"
        },
        heating: {
            parent: "hvac"
        },
        "heating-off": {
            parent: "hvac-off"
        },
        helipad: {
            parent: "alpha-h-circle-outline"
        },
        helix: {
            parent: "dna"
        },
        helm: {
            parent: "ship-wheel"
        },
        helmet: {
            parent: "hard-hat"
        },
        "help-outline": {
            parent: "handshake-outline"
        },
        hexagons: {
            parent: "hexagon-multiple"
        },
        "hey-listen": {
            parent: "candy-outline"
        },
        "hi-hat-light": {
            parent: "light-recessed"
        },
        hide: {
            parent: "eye-off"
        },
        "hide-outline": {
            parent: "eye-off-outline"
        },
        "high-beam": {
            parent: "car-light-high"
        },
        "high-hat-light": {
            parent: "light-recessed"
        },
        "high-occupancy-vehicle-lane": {
            parent: "car-2-plus"
        },
        "high-occupancy-vehicle-lane-outline": {
            parent: "cards-diamond-outline"
        },
        "high-quality": {
            parent: "quality-high"
        },
        "high-voltage": {
            parent: "flash-triangle"
        },
        "high-voltage-outline": {
            parent: "flash-triangle-outline"
        },
        "highlight-off": {
            parent: "close-circle-outline"
        },
        highlighter: {
            parent: "marker"
        },
        hinduism: {
            parent: "om"
        },
        historic: {
            parent: "pillar"
        },
        "home-add": {
            parent: "home-plus"
        },
        "home-attic": {
            parent: "home-roof"
        },
        "home-bulb": {
            parent: "home-lightbulb"
        },
        "home-bulb-outline": {
            parent: "home-lightbulb-outline"
        },
        "home-chart": {
            parent: "home-analytics"
        },
        "home-chimney": {
            parent: "home-roof"
        },
        "home-climate": {
            parent: "home-thermometer"
        },
        "home-climate-outline": {
            parent: "home-thermometer-outline"
        },
        "home-electricity": {
            parent: "home-battery"
        },
        "home-electricity-outline": {
            parent: "home-battery-outline"
        },
        "home-energy": {
            parent: "home-battery"
        },
        "home-energy-outline": {
            parent: "home-battery-outline"
        },
        "home-find": {
            parent: "home-search"
        },
        "home-find-outline": {
            parent: "home-search-outline"
        },
        "home-flash": {
            parent: "home-lightning-bolt"
        },
        "home-floor-attic": {
            parent: "home-floor-a"
        },
        "home-floor-basement": {
            parent: "home-floor-b"
        },
        "home-floor-first": {
            parent: "home-floor-1"
        },
        "home-floor-ground": {
            parent: "home-floor-g"
        },
        "home-floor-loft": {
            parent: "home-floor-l"
        },
        "home-floor-lower": {
            parent: "home-floor-l"
        },
        "home-floor-minus-1": {
            parent: "home-floor-negative-1"
        },
        "home-floor-minus-one": {
            parent: "home-floor-negative-1"
        },
        "home-floor-negative-one": {
            parent: "home-floor-negative-1"
        },
        "home-floor-one": {
            parent: "home-floor-1"
        },
        "home-floor-second": {
            parent: "home-floor-2"
        },
        "home-floor-third": {
            parent: "home-floor-3"
        },
        "home-floor-three": {
            parent: "home-floor-3"
        },
        "home-floor-two": {
            parent: "home-floor-2"
        },
        "home-floor-zero": {
            parent: "home-floor-0"
        },
        "home-group-add": {
            parent: "home-group-plus"
        },
        "home-location": {
            parent: "home-map-marker"
        },
        "home-power": {
            parent: "home-battery"
        },
        "home-power-outline": {
            parent: "home-battery-outline"
        },
        "home-report": {
            parent: "home-analytics"
        },
        "home-schedule": {
            parent: "home-clock"
        },
        "home-schedule-outline": {
            parent: "home-clock-outline"
        },
        "home-secure": {
            parent: "home-lock"
        },
        "home-swap": {
            parent: "home-switch"
        },
        "home-swap-outline": {
            parent: "home-switch-outline"
        },
        "home-temperature": {
            parent: "home-thermometer"
        },
        "home-temperature-outline": {
            parent: "home-thermometer-outline"
        },
        "home-theater": {
            parent: "seat"
        },
        "home-theatre": {
            parent: "seat"
        },
        "home-time": {
            parent: "home-clock"
        },
        "home-time-outline": {
            parent: "home-clock-outline"
        },
        "home-user": {
            parent: "home-account"
        },
        "home-warning": {
            parent: "home-alert"
        },
        "home-warning-outline": {
            parent: "home-alert-outline"
        },
        "home-wireless": {
            parent: "home-automation"
        },
        "honey-farmer": {
            parent: "beekeeper"
        },
        "honey-outline": {
            parent: "beehive-outline"
        },
        hope: {
            parent: "hand-heart"
        },
        "horizontal-line": {
            parent: "minus"
        },
        "horoscope-aquarius": {
            parent: "zodiac-aquarius"
        },
        "horoscope-aries": {
            parent: "zodiac-aries"
        },
        "horoscope-cancer": {
            parent: "zodiac-cancer"
        },
        "horoscope-capricorn": {
            parent: "zodiac-capricorn"
        },
        "horoscope-gemini": {
            parent: "zodiac-gemini"
        },
        "horoscope-leo": {
            parent: "zodiac-leo"
        },
        "horoscope-libra": {
            parent: "zodiac-libra"
        },
        "horoscope-pisces": {
            parent: "zodiac-pisces"
        },
        "horoscope-sagittarius": {
            parent: "zodiac-sagittarius"
        },
        "horoscope-scorpio": {
            parent: "zodiac-scorpio"
        },
        "horoscope-taurus": {
            parent: "zodiac-taurus"
        },
        "horoscope-virgo": {
            parent: "zodiac-virgo"
        },
        "horse-riding": {
            parent: "horse-human"
        },
        "horseback-riding": {
            parent: "horse-human"
        },
        "hospital-location": {
            parent: "hospital-marker"
        },
        hot: {
            parent: "fire"
        },
        "hot-air-balloon": {
            parent: "airballoon"
        },
        "hot-air-balloon-outline": {
            parent: "airballoon-outline"
        },
        "hot-circle": {
            parent: "fire-circle"
        },
        "hot-cold": {
            parent: "sun-snowflake"
        },
        hotel: {
            parent: "bed"
        },
        "hotel-outline": {
            parent: "bed-outline"
        },
        hothouse: {
            parent: "greenhouse"
        },
        hourglass: {
            parent: "timer-sand"
        },
        "hourglass-complete": {
            parent: "timer-sand-complete"
        },
        "hourglass-empty": {
            parent: "timer-sand-empty"
        },
        "hourglass-full": {
            parent: "timer-sand-full"
        },
        "hourglass-paused": {
            parent: "timer-sand-paused"
        },
        house: {
            parent: "home"
        },
        "house-account": {
            parent: "home-account"
        },
        "house-add": {
            parent: "home-plus"
        },
        "house-add-outline": {
            parent: "home-plus-outline"
        },
        "house-alert": {
            parent: "home-alert"
        },
        "house-alert-outline": {
            parent: "home-alert-outline"
        },
        "house-analytics": {
            parent: "home-analytics"
        },
        "house-attic": {
            parent: "home-roof"
        },
        "house-automation": {
            parent: "home-automation"
        },
        "house-battery": {
            parent: "home-battery"
        },
        "house-battery-outline": {
            parent: "home-battery-outline"
        },
        "house-bulb": {
            parent: "home-lightbulb"
        },
        "house-bulb-outline": {
            parent: "home-lightbulb-outline"
        },
        "house-chart": {
            parent: "home-analytics"
        },
        "house-chimney": {
            parent: "home-roof"
        },
        "house-circle": {
            parent: "home-circle"
        },
        "house-circle-outline": {
            parent: "home-circle-outline"
        },
        "house-city": {
            parent: "home-city"
        },
        "house-city-outline": {
            parent: "home-city-outline"
        },
        "house-climate": {
            parent: "home-thermometer"
        },
        "house-climate-outline": {
            parent: "home-thermometer-outline"
        },
        "house-clock": {
            parent: "home-clock"
        },
        "house-clock-outline": {
            parent: "home-clock-outline"
        },
        "house-edit": {
            parent: "home-edit"
        },
        "house-edit-outline": {
            parent: "home-edit-outline"
        },
        "house-energy": {
            parent: "home-battery"
        },
        "house-energy-outline": {
            parent: "home-battery-outline"
        },
        "house-export-outline": {
            parent: "home-export-outline"
        },
        "house-find": {
            parent: "home-search"
        },
        "house-find-outline": {
            parent: "home-search-outline"
        },
        "house-flash": {
            parent: "home-lightning-bolt"
        },
        "house-flash-outline": {
            parent: "home-lightning-bolt-outline"
        },
        "house-flood": {
            parent: "home-flood"
        },
        "house-floor-0": {
            parent: "home-floor-0"
        },
        "house-floor-1": {
            parent: "home-floor-1"
        },
        "house-floor-2": {
            parent: "home-floor-2"
        },
        "house-floor-3": {
            parent: "home-floor-3"
        },
        "house-floor-a": {
            parent: "home-floor-a"
        },
        "house-floor-attic": {
            parent: "home-floor-a"
        },
        "house-floor-b": {
            parent: "home-floor-b"
        },
        "house-floor-basement": {
            parent: "home-floor-b"
        },
        "house-floor-first": {
            parent: "home-floor-1"
        },
        "house-floor-g": {
            parent: "home-floor-g"
        },
        "house-floor-ground": {
            parent: "home-floor-g"
        },
        "house-floor-l": {
            parent: "home-floor-l"
        },
        "house-floor-loft": {
            parent: "home-floor-l"
        },
        "house-floor-lower": {
            parent: "home-floor-l"
        },
        "house-floor-minus-1": {
            parent: "home-floor-negative-1"
        },
        "house-floor-minus-one": {
            parent: "home-floor-negative-1"
        },
        "house-floor-negative-1": {
            parent: "home-floor-negative-1"
        },
        "house-floor-negative-one": {
            parent: "home-floor-negative-1"
        },
        "house-floor-one": {
            parent: "home-floor-1"
        },
        "house-floor-second": {
            parent: "home-floor-2"
        },
        "house-floor-third": {
            parent: "home-floor-3"
        },
        "house-floor-three": {
            parent: "home-floor-3"
        },
        "house-floor-two": {
            parent: "home-floor-2"
        },
        "house-floor-zero": {
            parent: "home-floor-0"
        },
        "house-group": {
            parent: "home-group"
        },
        "house-group-add": {
            parent: "home-group-plus"
        },
        "house-group-minus": {
            parent: "home-group-minus"
        },
        "house-group-plus": {
            parent: "home-group-plus"
        },
        "house-group-remove": {
            parent: "home-group-remove"
        },
        "house-heart": {
            parent: "home-heart"
        },
        "house-import-outline": {
            parent: "home-import-outline"
        },
        "house-lightbulb": {
            parent: "home-lightbulb"
        },
        "house-lightbulb-outline": {
            parent: "home-lightbulb-outline"
        },
        "house-lightning-bolt": {
            parent: "home-lightning-bolt"
        },
        "house-lightning-bolt-outline": {
            parent: "home-lightning-bolt-outline"
        },
        "house-lock": {
            parent: "home-lock"
        },
        "house-lock-open": {
            parent: "home-lock-open"
        },
        "house-map-marker": {
            parent: "home-map-marker"
        },
        "house-minus": {
            parent: "home-minus"
        },
        "house-minus-outline": {
            parent: "home-minus-outline"
        },
        "house-modern": {
            parent: "home-modern"
        },
        "house-off": {
            parent: "home-off"
        },
        "house-off-outline": {
            parent: "home-off-outline"
        },
        "house-outline": {
            parent: "home-outline"
        },
        "house-plus": {
            parent: "home-plus"
        },
        "house-plus-outline": {
            parent: "home-plus-outline"
        },
        "house-power": {
            parent: "home-battery"
        },
        "house-power-outline": {
            parent: "home-battery-outline"
        },
        "house-remove": {
            parent: "home-remove"
        },
        "house-remove-outline": {
            parent: "home-remove-outline"
        },
        "house-roof": {
            parent: "home-roof"
        },
        "house-schedule": {
            parent: "home-clock"
        },
        "house-schedule-outline": {
            parent: "home-clock-outline"
        },
        "house-search": {
            parent: "home-search"
        },
        "house-search-outline": {
            parent: "home-search-outline"
        },
        "house-secure": {
            parent: "home-lock"
        },
        "house-swap": {
            parent: "home-switch"
        },
        "house-swap-outline": {
            parent: "home-switch-outline"
        },
        "house-switch": {
            parent: "home-switch"
        },
        "house-switch-outline": {
            parent: "home-switch-outline"
        },
        "house-temperature": {
            parent: "home-thermometer"
        },
        "house-temperature-outline": {
            parent: "home-thermometer-outline"
        },
        "house-thermometer": {
            parent: "home-thermometer"
        },
        "house-thermometer-outline": {
            parent: "home-thermometer-outline"
        },
        "house-time": {
            parent: "home-clock"
        },
        "house-time-outline": {
            parent: "home-clock-outline"
        },
        "house-user": {
            parent: "home-account"
        },
        "house-variant": {
            parent: "home-variant"
        },
        "house-variant-outline": {
            parent: "home-variant-outline"
        },
        "house-warning": {
            parent: "home-alert"
        },
        "house-warning-outline": {
            parent: "home-alert-outline"
        },
        "house-wireless": {
            parent: "home-automation"
        },
        "housing-estate": {
            parent: "home-group"
        },
        "hov-lane": {
            parent: "car-2-plus"
        },
        "hov-lane-outline": {
            parent: "cards-diamond-outline"
        },
        "how-to-reg": {
            parent: "account-check"
        },
        "how-to-reg-outline": {
            parent: "account-check-outline"
        },
        "how-to-vote": {
            parent: "vote"
        },
        "how-to-vote-outline": {
            parent: "vote-outline"
        },
        hq: {
            parent: "quality-high"
        },
        https: {
            parent: "lock"
        },
        "https-outline": {
            parent: "lock-outline"
        },
        "human-accessible": {
            parent: "human-wheelchair"
        },
        "human-barbell": {
            parent: "weight-lifter"
        },
        "human-biathlon": {
            parent: "biathlon"
        },
        "human-blind": {
            parent: "human-white-cane"
        },
        "human-capacity-reduce": {
            parent: "human-capacity-decrease"
        },
        "human-dance-ballroom": {
            parent: "dance-ballroom"
        },
        "human-dance-pole": {
            parent: "dance-pole"
        },
        "human-diving": {
            parent: "diving"
        },
        "human-genderless": {
            parent: "human-non-binary"
        },
        "human-hand-truck": {
            parent: "human-dolly"
        },
        "human-handball": {
            parent: "handball"
        },
        "human-hello": {
            parent: "human-greeting"
        },
        "human-hello-variant": {
            parent: "human-greeting-variant"
        },
        "human-hiking": {
            parent: "hiking"
        },
        "human-kabaddi": {
            parent: "kabaddi"
        },
        "human-karate": {
            parent: "karate"
        },
        "human-kayaking": {
            parent: "kayaking"
        },
        "human-line": {
            parent: "human-queue"
        },
        "human-man-board": {
            parent: "human-male-board"
        },
        "human-meditation": {
            parent: "meditation"
        },
        "human-rowing": {
            parent: "rowing"
        },
        "human-run": {
            parent: "run"
        },
        "human-run-fast": {
            parent: "run-fast"
        },
        "human-skateboarding": {
            parent: "skateboarding"
        },
        "human-ski": {
            parent: "ski"
        },
        "human-ski-cross-country": {
            parent: "ski-cross-country"
        },
        "human-ski-water": {
            parent: "ski-water"
        },
        "human-sledding": {
            parent: "sledding"
        },
        "human-snowboard": {
            parent: "snowboard"
        },
        "human-transgender": {
            parent: "human-non-binary"
        },
        "human-trolley": {
            parent: "human-dolly"
        },
        "human-walk": {
            parent: "walk"
        },
        "human-welcome": {
            parent: "human-greeting"
        },
        humidity: {
            parent: "cloud-percent"
        },
        "humidity-alert": {
            parent: "water-percent-alert"
        },
        "humidity-outline": {
            parent: "cloud-percent-outline"
        },
        "hydraulic-turbine": {
            parent: "hydro-power"
        },
        icc: {
            parent: "integrated-circuit-chip"
        },
        "ice-skate": {
            parent: "skate"
        },
        "id-card-outline": {
            parent: "card-account-details-outline"
        },
        idea: {
            parent: "lightbulb"
        },
        "identification-card": {
            parent: "card-account-details"
        },
        "identification-card-outline": {
            parent: "card-account-details-outline"
        },
        "ideogram-chinese-japanese-korean": {
            parent: "ideogram-cjk"
        },
        "ideogram-chinese-japanese-korean-variant": {
            parent: "ideogram-cjk-variant"
        },
        iframe: {
            parent: "application"
        },
        "iframe-array": {
            parent: "application-array"
        },
        "iframe-array-outline": {
            parent: "application-array-outline"
        },
        "iframe-braces": {
            parent: "application-braces"
        },
        "iframe-braces-outline": {
            parent: "application-braces-outline"
        },
        "iframe-brackets": {
            parent: "application-brackets"
        },
        "iframe-brackets-outline": {
            parent: "application-brackets-outline"
        },
        "iframe-cog": {
            parent: "application-cog"
        },
        "iframe-cog-outline": {
            parent: "application-cog-outline"
        },
        "iframe-edit": {
            parent: "application-edit"
        },
        "iframe-edit-outline": {
            parent: "application-edit-outline"
        },
        "iframe-export-outline": {
            parent: "application-export"
        },
        "iframe-import-outline": {
            parent: "application-import"
        },
        "iframe-outline": {
            parent: "application-outline"
        },
        "iframe-parentheses": {
            parent: "application-parentheses"
        },
        "iframe-parentheses-outline": {
            parent: "application-parentheses-outline"
        },
        "iframe-settings": {
            parent: "application-settings"
        },
        "iframe-settings-outline": {
            parent: "application-settings-outline"
        },
        "iframe-variable": {
            parent: "application-variable"
        },
        "iframe-variable-outline": {
            parent: "application-variable-outline"
        },
        ignition: {
            parent: "induction"
        },
        illuminance: {
            parent: "sun-wireless"
        },
        "illuminance-outline": {
            parent: "sun-wireless-outline"
        },
        "image-360": {
            parent: "panorama-variant"
        },
        "image-360-outline": {
            parent: "panorama-variant-outline"
        },
        "image-add": {
            parent: "image-plus"
        },
        "image-add-outline": {
            parent: "image-plus-outline"
        },
        "image-aspect-ratio": {
            parent: "relative-scale"
        },
        "image-description": {
            parent: "image-text"
        },
        "image-filter": {
            parent: "image-auto-adjust"
        },
        "image-filter-centre-focus": {
            parent: "image-filter-center-focus"
        },
        "image-filter-centre-focus-weak": {
            parent: "image-filter-center-focus-weak"
        },
        "image-jpeg-box": {
            parent: "file-jpg-box"
        },
        "image-jpg-box": {
            parent: "file-jpg-box"
        },
        "image-location": {
            parent: "image-marker"
        },
        "image-location-outline": {
            parent: "image-marker-outline"
        },
        "image-secure": {
            parent: "image-lock"
        },
        "image-secure-outline": {
            parent: "image-lock-outline"
        },
        "image-vr": {
            parent: "panorama-variant"
        },
        "image-vr-outline": {
            parent: "panorama-variant-outline"
        },
        images: {
            parent: "image-multiple"
        },
        "images-outline": {
            parent: "image-multiple-outline"
        },
        immunization: {
            parent: "needle"
        },
        "immunization-off": {
            parent: "needle-off"
        },
        "import-contacts": {
            parent: "book-open-blank-variant"
        },
        "import-export": {
            parent: "swap-vertical"
        },
        "import-export-bold": {
            parent: "swap-vertical-bold"
        },
        "important-devices": {
            parent: "monitor-cellphone-star"
        },
        inboxes: {
            parent: "inbox-multiple"
        },
        "inboxes-outline": {
            parent: "inbox-multiple-outline"
        },
        increment: {
            parent: "numeric-positive-1"
        },
        "indeterminate-check-box": {
            parent: "minus-box"
        },
        industrial: {
            parent: "factory"
        },
        "infinity-box": {
            parent: "all-inclusive-box"
        },
        "infinity-box-outline": {
            parent: "all-inclusive-box-outline"
        },
        "info-circle": {
            parent: "information"
        },
        "info-circle-outline": {
            parent: "information-outline"
        },
        "info-outline": {
            parent: "information-outline"
        },
        "info-variant": {
            parent: "information-variant"
        },
        "information-circle": {
            parent: "information"
        },
        "information-circle-outline": {
            parent: "information-outline"
        },
        injection: {
            parent: "needle"
        },
        "injection-off": {
            parent: "needle-off"
        },
        ink: {
            parent: "water"
        },
        "ink-alert": {
            parent: "water-alert"
        },
        "ink-alert-outline": {
            parent: "water-alert-outline"
        },
        "ink-check": {
            parent: "water-check"
        },
        "ink-check-outline": {
            parent: "water-check-outline"
        },
        "ink-circle": {
            parent: "water-circle"
        },
        "ink-color": {
            parent: "format-color-fill"
        },
        "ink-colour": {
            parent: "format-color-fill"
        },
        "ink-minus": {
            parent: "water-minus"
        },
        "ink-minus-outline": {
            parent: "water-minus-outline"
        },
        "ink-off": {
            parent: "water-off"
        },
        "ink-off-outline": {
            parent: "water-off-outline"
        },
        "ink-outline": {
            parent: "water-outline"
        },
        "ink-percent": {
            parent: "water-percent"
        },
        "ink-percent-alert": {
            parent: "water-percent-alert"
        },
        "ink-plus": {
            parent: "water-plus"
        },
        "ink-plus-outline": {
            parent: "water-plus-outline"
        },
        "ink-remove": {
            parent: "water-remove"
        },
        "ink-remove-outline": {
            parent: "water-remove-outline"
        },
        "ink-spot": {
            parent: "liquid-spot"
        },
        inky: {
            parent: "ghost"
        },
        "inner-join": {
            parent: "set-center"
        },
        input: {
            parent: "import"
        },
        insect: {
            parent: "bee"
        },
        "insert-comment": {
            parent: "message-reply-text"
        },
        "insert-drive-file": {
            parent: "file"
        },
        "insert-emoticon": {
            parent: "emoticon-outline"
        },
        "insert-invitation": {
            parent: "calendar"
        },
        "insert-link": {
            parent: "link"
        },
        "insert-photo": {
            parent: "image"
        },
        "instant-cash": {
            parent: "cash-fast"
        },
        "instant-deposit": {
            parent: "cash-fast"
        },
        "instant-mix": {
            parent: "tune-vertical"
        },
        "instant-transfer": {
            parent: "cash-fast"
        },
        "integrated-circuit": {
            parent: "chip"
        },
        "interaction-double-tap": {
            parent: "gesture-double-tap"
        },
        "interaction-tap": {
            parent: "gesture-tap"
        },
        "international-symbol-of-access": {
            parent: "wheelchair"
        },
        internet: {
            parent: "web"
        },
        "internet-box": {
            parent: "web-box"
        },
        "internet-explorer": {
            parent: "microsoft-internet-explorer"
        },
        "internet-protocol": {
            parent: "ip"
        },
        "internet-protocol-outline": {
            parent: "ip-outline"
        },
        "internet-search": {
            parent: "search-web"
        },
        "invert-colours": {
            parent: "invert-colors"
        },
        "invert-colours-off": {
            parent: "invert-colors-off"
        },
        invite: {
            parent: "account-multiple-plus"
        },
        invoice: {
            parent: "receipt-text"
        },
        "invoice-add": {
            parent: "receipt-text-plus"
        },
        "invoice-check": {
            parent: "receipt-text-check"
        },
        "invoice-check-outline": {
            parent: "receipt-text-check-outline"
        },
        "invoice-minus": {
            parent: "receipt-text-minus"
        },
        "invoice-minus-outline": {
            parent: "receipt-text-minus-outline"
        },
        "invoice-outline": {
            parent: "receipt-text-outline"
        },
        "invoice-plus": {
            parent: "receipt-text-plus"
        },
        "invoice-remove": {
            parent: "receipt-text-remove"
        },
        "invoice-remove-outline": {
            parent: "receipt-text-remove-outline"
        },
        "ios-share": {
            parent: "export-variant"
        },
        irrigation: {
            parent: "sprinkler"
        },
        isa: {
            parent: "wheelchair"
        },
        islam: {
            parent: "mosque"
        },
        "italian-lights": {
            parent: "string-lights"
        },
        "italian-lights-off": {
            parent: "string-lights-off"
        },
        "jack-o-lantern": {
            parent: "halloween"
        },
        jaws: {
            parent: "shark"
        },
        "jaws-off": {
            parent: "shark-off"
        },
        "jet-engine": {
            parent: "turbine"
        },
        jewel: {
            parent: "diamond-stone"
        },
        jewish: {
            parent: "star-david"
        },
        "jewish-outline": {
            parent: "synagogue-outline"
        },
        jigsaw: {
            parent: "puzzle"
        },
        "jigsaw-outline": {
            parent: "puzzle-outline"
        },
        "jolly-roger": {
            parent: "skull-crossbones"
        },
        "jolly-roger-outline": {
            parent: "skull-crossbones-outline"
        },
        journal: {
            parent: "notebook"
        },
        "journal-multiple": {
            parent: "notebook-multiple"
        },
        "journal-outline": {
            parent: "notebook-outline"
        },
        json: {
            parent: "code-json"
        },
        judaism: {
            parent: "star-david"
        },
        jump: {
            parent: "debug-step-over"
        },
        justice: {
            parent: "scale-balance"
        },
        k9: {
            parent: "dog-service"
        },
        karabiner: {
            parent: "carabiner"
        },
        "kazakhstani-tenge": {
            parent: "currency-kzt"
        },
        keep: {
            parent: "pin"
        },
        "keep-off": {
            parent: "pin-off"
        },
        "keep-off-outline": {
            parent: "pin-off-outline"
        },
        "keep-outline": {
            parent: "pin-outline"
        },
        "keep-warm": {
            parent: "heat-wave"
        },
        "kettle-empty": {
            parent: "kettle-outline"
        },
        "kettle-empty-alert": {
            parent: "kettle-alert-outline"
        },
        "kettle-empty-off": {
            parent: "kettle-off-outline"
        },
        "kettle-empty-steam": {
            parent: "kettle-steam-outline"
        },
        "kettle-full": {
            parent: "kettle"
        },
        "kettle-full-alert": {
            parent: "kettle-alert"
        },
        "kettle-full-off": {
            parent: "kettle-off"
        },
        "kettle-full-steam": {
            parent: "kettle-steam"
        },
        "key-add": {
            parent: "key-plus"
        },
        "key-favorite": {
            parent: "key-star"
        },
        "keyboard-arrow-down": {
            parent: "chevron-down"
        },
        "keyboard-arrow-left": {
            parent: "chevron-left"
        },
        "keyboard-arrow-right": {
            parent: "chevron-right"
        },
        "keyboard-arrow-up": {
            parent: "chevron-up"
        },
        "keyboard-capslock": {
            parent: "keyboard-caps"
        },
        "keyboard-clear": {
            parent: "keyboard-backspace"
        },
        "keyboard-erase": {
            parent: "keyboard-backspace"
        },
        "keyboard-hide": {
            parent: "keyboard-close"
        },
        "keyboard-voice": {
            parent: "microphone"
        },
        keypad: {
            parent: "dialpad"
        },
        "kho-kho": {
            parent: "dance-pole"
        },
        kickboxing: {
            parent: "karate"
        },
        "kids-room": {
            parent: "teddy-bear"
        },
        kitchen: {
            parent: "fridge"
        },
        "kitchen-counter": {
            parent: "countertop"
        },
        "kitchen-counter-outline": {
            parent: "countertop-outline"
        },
        "kitchen-roll": {
            parent: "paper-roll"
        },
        "kitchen-roll-outline": {
            parent: "paper-roll-outline"
        },
        "kitchen-tap": {
            parent: "faucet"
        },
        "kitchen-tap-off": {
            parent: "water-pump-off"
        },
        kotlin: {
            parent: "language-kotlin"
        },
        lacrosse: {
            parent: "racquetball"
        },
        "lacto-vegetarian": {
            parent: "square-circle"
        },
        ladybird: {
            parent: "ladybug"
        },
        lake: {
            parent: "waves"
        },
        landscape: {
            parent: "image-filter-hdr"
        },
        language: {
            parent: "translate"
        },
        "language-box": {
            parent: "web-box"
        },
        "last-page": {
            parent: "page-last"
        },
        latest: {
            parent: "history"
        },
        laundrette: {
            parent: "washing-machine"
        },
        "laundry-room": {
            parent: "tumble-dryer"
        },
        "laundry-room-alert": {
            parent: "tumble-dryer-alert"
        },
        "laundry-room-off": {
            parent: "tumble-dryer-off"
        },
        lavatory: {
            parent: "toilet"
        },
        "lavatory-roll": {
            parent: "paper-roll"
        },
        "lavatory-roll-outline": {
            parent: "paper-roll-outline"
        },
        lawn: {
            parent: "grass"
        },
        "lawn-mower": {
            parent: "robot-mower"
        },
        "lawn-mower-outline": {
            parent: "robot-mower-outline"
        },
        "layers-clear": {
            parent: "layers-off"
        },
        leads: {
            parent: "account-filter"
        },
        "leads-outline": {
            parent: "account-filter-outline"
        },
        learn: {
            parent: "chair-school"
        },
        "learn-outline": {
            parent: "school-outline"
        },
        lecture: {
            parent: "human-male-board"
        },
        lecturn: {
            parent: "lectern"
        },
        "left-to-right": {
            parent: "format-pilcrow-arrow-right"
        },
        legal: {
            parent: "scale-balance"
        },
        lego: {
            parent: "toy-brick"
        },
        "lego-location": {
            parent: "toy-brick-marker"
        },
        "lego-location-outline": {
            parent: "toy-brick-marker-outline"
        },
        "lego-outline": {
            parent: "toy-brick-marker-outline"
        },
        lens: {
            parent: "circle"
        },
        "letter-a": {
            parent: "alpha-a"
        },
        "letter-a-box": {
            parent: "alpha-a-box"
        },
        "letter-a-box-outline": {
            parent: "alpha-a-box-outline"
        },
        "letter-a-circle": {
            parent: "alpha-a-circle"
        },
        "letter-a-circle-outline": {
            parent: "alpha-a-circle-outline"
        },
        "letter-b": {
            parent: "alpha-b"
        },
        "letter-b-box": {
            parent: "alpha-b-box"
        },
        "letter-b-box-outline": {
            parent: "alpha-b-box-outline"
        },
        "letter-b-circle": {
            parent: "alpha-b-circle"
        },
        "letter-b-circle-outline": {
            parent: "alpha-b-circle-outline"
        },
        "letter-c": {
            parent: "alpha-c"
        },
        "letter-c-box": {
            parent: "alpha-c-box"
        },
        "letter-c-box-outline": {
            parent: "alpha-c-box-outline"
        },
        "letter-c-circle": {
            parent: "alpha-c-circle"
        },
        "letter-c-circle-outline": {
            parent: "alpha-c-circle-outline"
        },
        "letter-d": {
            parent: "alpha-d"
        },
        "letter-d-box": {
            parent: "alpha-d-box"
        },
        "letter-d-box-outline": {
            parent: "alpha-d-box-outline"
        },
        "letter-d-circle": {
            parent: "alpha-d-circle"
        },
        "letter-d-circle-outline": {
            parent: "alpha-d-circle-outline"
        },
        "letter-e": {
            parent: "alpha-e"
        },
        "letter-e-box": {
            parent: "alpha-e-box"
        },
        "letter-e-box-outline": {
            parent: "alpha-e-box-outline"
        },
        "letter-e-circle": {
            parent: "alpha-e-circle"
        },
        "letter-e-circle-outline": {
            parent: "alpha-e-circle-outline"
        },
        "letter-f": {
            parent: "alpha-f"
        },
        "letter-f-box": {
            parent: "alpha-f-box"
        },
        "letter-f-box-outline": {
            parent: "alpha-f-box-outline"
        },
        "letter-f-circle": {
            parent: "alpha-f-circle"
        },
        "letter-f-circle-outline": {
            parent: "alpha-f-circle-outline"
        },
        "letter-g": {
            parent: "alpha-g"
        },
        "letter-g-box": {
            parent: "alpha-g-box"
        },
        "letter-g-box-outline": {
            parent: "alpha-g-box-outline"
        },
        "letter-g-circle": {
            parent: "alpha-g-circle"
        },
        "letter-g-circle-outline": {
            parent: "alpha-g-circle-outline"
        },
        "letter-h": {
            parent: "alpha-h"
        },
        "letter-h-box": {
            parent: "alpha-h-box"
        },
        "letter-h-box-outline": {
            parent: "alpha-h-box-outline"
        },
        "letter-h-circle": {
            parent: "alpha-h-circle"
        },
        "letter-h-circle-outline": {
            parent: "alpha-h-circle-outline"
        },
        "letter-i": {
            parent: "alpha-i"
        },
        "letter-i-box": {
            parent: "alpha-i-box"
        },
        "letter-i-box-outline": {
            parent: "alpha-i-box-outline"
        },
        "letter-i-circle": {
            parent: "alpha-i-circle"
        },
        "letter-i-circle-outline": {
            parent: "alpha-i-circle-outline"
        },
        "letter-j": {
            parent: "alpha-j"
        },
        "letter-j-box": {
            parent: "alpha-j-box"
        },
        "letter-j-box-outline": {
            parent: "alpha-j-box-outline"
        },
        "letter-j-circle": {
            parent: "alpha-j-circle"
        },
        "letter-j-circle-outline": {
            parent: "alpha-j-circle-outline"
        },
        "letter-k": {
            parent: "alpha-k"
        },
        "letter-k-box": {
            parent: "alpha-k-box"
        },
        "letter-k-box-outline": {
            parent: "alpha-k-box-outline"
        },
        "letter-k-circle": {
            parent: "alpha-k-circle"
        },
        "letter-k-circle-outline": {
            parent: "alpha-k-circle-outline"
        },
        "letter-l": {
            parent: "alpha-l"
        },
        "letter-l-box": {
            parent: "alpha-l-box"
        },
        "letter-l-box-outline": {
            parent: "alpha-l-box-outline"
        },
        "letter-l-circle": {
            parent: "alpha-l-circle"
        },
        "letter-l-circle-outline": {
            parent: "alpha-l-circle-outline"
        },
        "letter-m": {
            parent: "alpha-m"
        },
        "letter-m-box": {
            parent: "alpha-m-box"
        },
        "letter-m-box-outline": {
            parent: "alpha-m-box-outline"
        },
        "letter-m-circle": {
            parent: "alpha-m-circle"
        },
        "letter-m-circle-outline": {
            parent: "alpha-m-circle-outline"
        },
        "letter-n": {
            parent: "alpha-n"
        },
        "letter-n-box": {
            parent: "alpha-n-box"
        },
        "letter-n-box-outline": {
            parent: "alpha-n-box-outline"
        },
        "letter-n-circle": {
            parent: "alpha-n-circle"
        },
        "letter-n-circle-outline": {
            parent: "alpha-n-circle-outline"
        },
        "letter-o": {
            parent: "alpha-o"
        },
        "letter-o-box": {
            parent: "alpha-o-box"
        },
        "letter-o-box-outline": {
            parent: "alpha-o-box-outline"
        },
        "letter-o-circle": {
            parent: "alpha-o-circle"
        },
        "letter-o-circle-outline": {
            parent: "alpha-o-circle-outline"
        },
        "letter-p": {
            parent: "alpha-p"
        },
        "letter-p-box": {
            parent: "alpha-p-box"
        },
        "letter-p-box-outline": {
            parent: "alpha-p-box-outline"
        },
        "letter-p-circle": {
            parent: "alpha-p-circle"
        },
        "letter-p-circle-outline": {
            parent: "alpha-p-circle-outline"
        },
        "letter-q": {
            parent: "alpha-q"
        },
        "letter-q-box": {
            parent: "alpha-q-box"
        },
        "letter-q-box-outline": {
            parent: "alpha-q-box-outline"
        },
        "letter-q-circle": {
            parent: "alpha-q-circle"
        },
        "letter-q-circle-outline": {
            parent: "alpha-q-circle-outline"
        },
        "letter-r": {
            parent: "alpha-r"
        },
        "letter-r-box": {
            parent: "alpha-r-box"
        },
        "letter-r-box-outline": {
            parent: "alpha-r-box-outline"
        },
        "letter-r-circle": {
            parent: "alpha-r-circle"
        },
        "letter-r-circle-outline": {
            parent: "alpha-r-circle-outline"
        },
        "letter-s": {
            parent: "alpha-s"
        },
        "letter-s-box": {
            parent: "alpha-s-box"
        },
        "letter-s-box-outline": {
            parent: "alpha-s-box-outline"
        },
        "letter-s-circle": {
            parent: "alpha-s-circle"
        },
        "letter-s-circle-outline": {
            parent: "alpha-s-circle-outline"
        },
        "letter-t": {
            parent: "alpha-t"
        },
        "letter-t-box": {
            parent: "alpha-t-box"
        },
        "letter-t-box-outline": {
            parent: "alpha-t-box-outline"
        },
        "letter-t-circle": {
            parent: "alpha-t-circle"
        },
        "letter-t-circle-outline": {
            parent: "alpha-t-circle-outline"
        },
        "letter-u": {
            parent: "alpha-u"
        },
        "letter-u-box": {
            parent: "alpha-u-box"
        },
        "letter-u-box-outline": {
            parent: "alpha-u-box-outline"
        },
        "letter-u-circle": {
            parent: "alpha-u-circle"
        },
        "letter-u-circle-outline": {
            parent: "alpha-u-circle-outline"
        },
        "letter-v": {
            parent: "alpha-v"
        },
        "letter-v-box": {
            parent: "alpha-v-box"
        },
        "letter-v-box-outline": {
            parent: "alpha-v-box-outline"
        },
        "letter-v-circle": {
            parent: "alpha-v-circle"
        },
        "letter-v-circle-outline": {
            parent: "alpha-v-circle-outline"
        },
        "letter-w": {
            parent: "alpha-w"
        },
        "letter-w-box": {
            parent: "alpha-w-box"
        },
        "letter-w-box-outline": {
            parent: "alpha-w-box-outline"
        },
        "letter-w-circle": {
            parent: "alpha-w-circle"
        },
        "letter-w-circle-outline": {
            parent: "alpha-w-circle-outline"
        },
        "letter-x": {
            parent: "alpha-x"
        },
        "letter-x-box": {
            parent: "alpha-x-box"
        },
        "letter-x-box-outline": {
            parent: "alpha-x-box-outline"
        },
        "letter-x-circle": {
            parent: "alpha-x-circle"
        },
        "letter-x-circle-outline": {
            parent: "alpha-x-circle-outline"
        },
        "letter-y": {
            parent: "alpha-y"
        },
        "letter-y-box": {
            parent: "alpha-y-box"
        },
        "letter-y-box-outline": {
            parent: "alpha-y-box-outline"
        },
        "letter-y-circle": {
            parent: "alpha-y-circle"
        },
        "letter-y-circle-outline": {
            parent: "alpha-y-circle-outline"
        },
        "letter-z": {
            parent: "alpha-z"
        },
        "letter-z-box": {
            parent: "alpha-z-box"
        },
        "letter-z-box-outline": {
            parent: "alpha-z-box-outline"
        },
        "letter-z-circle": {
            parent: "alpha-z-circle"
        },
        "letter-z-circle-outline": {
            parent: "alpha-z-circle-outline"
        },
        letters: {
            parent: "alphabetical"
        },
        "letters-off": {
            parent: "alphabetical-off"
        },
        "level-crossing-signals": {
            parent: "railroad-light"
        },
        "library-add": {
            parent: "plus-box-multiple"
        },
        "library-bookmark": {
            parent: "bookmark-box-multiple"
        },
        "library-bookmark-outline": {
            parent: "bookmark-box-multiple-outline"
        },
        "library-close": {
            parent: "close-box-multiple"
        },
        "library-close-outline": {
            parent: "close-box-multiple-outline"
        },
        "library-edit": {
            parent: "pencil-box-multiple"
        },
        "library-edit-outline": {
            parent: "pencil-box-multiple-outline"
        },
        "library-minus": {
            parent: "minus-box-multiple"
        },
        "library-minus-outline": {
            parent: "minus-box-multiple-outline"
        },
        "library-movie": {
            parent: "filmstrip-box-multiple"
        },
        "library-music": {
            parent: "music-box-multiple"
        },
        "library-music-outline": {
            parent: "music-box-multiple-outline"
        },
        "library-plus": {
            parent: "plus-box-multiple"
        },
        "library-remove": {
            parent: "close-box-multiple"
        },
        "library-remove-outline": {
            parent: "close-box-multiple-outline"
        },
        "library-video": {
            parent: "play-box-multiple"
        },
        "life-preserver": {
            parent: "lifebuoy"
        },
        "light-strip": {
            parent: "led-strip"
        },
        "light-strip-variant": {
            parent: "led-strip-variant"
        },
        "light-strip-variant-off": {
            parent: "led-strip-variant-off"
        },
        "light-switch-on": {
            parent: "toggle-switch-variant"
        },
        "lightbulb-automatic": {
            parent: "lightbulb-auto"
        },
        "lightbulb-automatic-outline": {
            parent: "lightbulb-auto-outline"
        },
        "lightbulb-dimmer-10": {
            parent: "lightbulb-on-10"
        },
        "lightbulb-dimmer-100": {
            parent: "lightbulb-on"
        },
        "lightbulb-dimmer-20": {
            parent: "lightbulb-on-20"
        },
        "lightbulb-dimmer-30": {
            parent: "lightbulb-on-30"
        },
        "lightbulb-dimmer-40": {
            parent: "lightbulb-on-40"
        },
        "lightbulb-dimmer-50": {
            parent: "lightbulb-on-50"
        },
        "lightbulb-dimmer-60": {
            parent: "lightbulb-on-60"
        },
        "lightbulb-dimmer-70": {
            parent: "lightbulb-on-70"
        },
        "lightbulb-dimmer-80": {
            parent: "lightbulb-on-80"
        },
        "lightbulb-dimmer-90": {
            parent: "lightbulb-on-90"
        },
        "lightbulb-edison": {
            parent: "lightbulb-variant"
        },
        "lightbulb-edison-outline": {
            parent: "lightbulb-variant-outline"
        },
        "lightbulb-error": {
            parent: "lightbulb-alert"
        },
        "lightbulb-error-outline": {
            parent: "lightbulb-alert-outline"
        },
        "lightbulb-filament": {
            parent: "lightbulb-variant"
        },
        "lightbulb-filament-outline": {
            parent: "lightbulb-variant-outline"
        },
        "lightbulb-gu10": {
            parent: "lightbulb-spot"
        },
        "lightbulb-gu10-off": {
            parent: "lightbulb-spot-off"
        },
        "lightbulb-halogen": {
            parent: "lightbulb-spot"
        },
        "lightbulb-halogen-off": {
            parent: "lightbulb-spot-off"
        },
        "lightbulb-help": {
            parent: "lightbulb-question"
        },
        "lightbulb-help-outline": {
            parent: "lightbulb-question-outline"
        },
        "lightbulb-moon-star": {
            parent: "lightbulb-night"
        },
        "lightbulb-moon-star-outline": {
            parent: "lightbulb-night-outline"
        },
        "lightbulb-motion": {
            parent: "lightbulb-auto"
        },
        "lightbulb-motion-outline": {
            parent: "lightbulb-auto-outline"
        },
        lightbulbs: {
            parent: "lightbulb-multiple"
        },
        "lightbulbs-off": {
            parent: "lightbulb-multiple-off"
        },
        "lightbulbs-off-outline": {
            parent: "lightbulb-multiple-off-outline"
        },
        "lightbulbs-outline": {
            parent: "lightbulb-multiple-outline"
        },
        "lightning-alert": {
            parent: "flash-alert"
        },
        "lightning-alert-outline": {
            parent: "flash-alert-outline"
        },
        lights: {
            parent: "lamps"
        },
        "lights-outline": {
            parent: "lamps-outline"
        },
        like: {
            parent: "thumb-up"
        },
        "like-dislike": {
            parent: "thumbs-up-down"
        },
        "like-dislike-outline": {
            parent: "thumbs-up-down-outline"
        },
        "like-outline": {
            parent: "thumb-up-outline"
        },
        "link-add": {
            parent: "link-plus"
        },
        "linkedin-box": {
            parent: "linkedin"
        },
        lira: {
            parent: "currency-try"
        },
        "living-room": {
            parent: "sofa"
        },
        "living-room-outline": {
            parent: "sofa-outline"
        },
        loaf: {
            parent: "baguette"
        },
        "local-activity": {
            parent: "ticket"
        },
        "local-airport": {
            parent: "airplane"
        },
        "local-area-network": {
            parent: "lan"
        },
        "local-area-network-connect": {
            parent: "lan-connect"
        },
        "local-area-network-disconnect": {
            parent: "lan-disconnect"
        },
        "local-area-network-pending": {
            parent: "lan-pending"
        },
        "local-atm": {
            parent: "cash-usd"
        },
        "local-attraction": {
            parent: "ticket"
        },
        "local-bar": {
            parent: "glass-cocktail"
        },
        "local-cafe": {
            parent: "coffee"
        },
        "local-cafe-off": {
            parent: "coffee-off"
        },
        "local-cafe-off-outline": {
            parent: "coffee-off-outline"
        },
        "local-cafe-outline": {
            parent: "coffee-outline"
        },
        "local-cafe-to-go": {
            parent: "coffee-to-go"
        },
        "local-cafe-to-go-outline": {
            parent: "coffee-to-go-outline"
        },
        "local-car-wash": {
            parent: "car-wash"
        },
        "local-convenience-store": {
            parent: "store-24-hour"
        },
        "local-dining": {
            parent: "silverware"
        },
        "local-drink": {
            parent: "cup-water"
        },
        "local-florist": {
            parent: "flower"
        },
        "local-florist-outline": {
            parent: "flower-outline"
        },
        "local-gas-station": {
            parent: "gas-station"
        },
        "local-grocery-store": {
            parent: "cart"
        },
        "local-hospital": {
            parent: "hospital-box"
        },
        "local-laundry-service": {
            parent: "washing-machine"
        },
        "local-library": {
            parent: "library"
        },
        "local-library-outline": {
            parent: "library-outline"
        },
        "local-mall": {
            parent: "shopping"
        },
        "local-mall-outline": {
            parent: "shopping-outline"
        },
        "local-movies": {
            parent: "filmstrip"
        },
        "local-offer": {
            parent: "tag"
        },
        "local-parking": {
            parent: "parking"
        },
        "local-pharmacy": {
            parent: "mortar-pestle-plus"
        },
        "local-phone": {
            parent: "phone"
        },
        "local-pizza": {
            parent: "pizza"
        },
        "local-play": {
            parent: "ticket"
        },
        "local-post-office": {
            parent: "email"
        },
        "local-print-shop": {
            parent: "printer"
        },
        "local-printshop": {
            parent: "printer"
        },
        "local-restaurant": {
            parent: "silverware"
        },
        "local-see": {
            parent: "camera"
        },
        "local-shipping": {
            parent: "truck"
        },
        "local-taxi": {
            parent: "taxi"
        },
        location: {
            parent: "map-marker"
        },
        "location-add": {
            parent: "map-marker-plus"
        },
        "location-add-outline": {
            parent: "map-marker-plus-outline"
        },
        "location-alert": {
            parent: "map-marker-alert"
        },
        "location-alert-outline": {
            parent: "map-marker-alert-outline"
        },
        "location-check": {
            parent: "map-marker-check"
        },
        "location-check-outline": {
            parent: "map-marker-check-outline"
        },
        "location-circle": {
            parent: "map-marker-circle"
        },
        "location-city": {
            parent: "city"
        },
        "location-distance": {
            parent: "map-marker-distance"
        },
        "location-down": {
            parent: "map-marker-down"
        },
        "location-favorite": {
            parent: "map-marker-star"
        },
        "location-favorite-outline": {
            parent: "map-marker-star-outline"
        },
        "location-left": {
            parent: "map-marker-left"
        },
        "location-left-outline": {
            parent: "map-marker-left-outline"
        },
        "location-minus": {
            parent: "map-marker-minus"
        },
        "location-minus-outline": {
            parent: "map-marker-minus-outline"
        },
        "location-multiple": {
            parent: "map-marker-multiple"
        },
        "location-multiple-outline": {
            parent: "map-marker-multiple-outline"
        },
        "location-off": {
            parent: "map-marker-off"
        },
        "location-off-outline": {
            parent: "map-marker-off-outline"
        },
        "location-on": {
            parent: "map-marker"
        },
        "location-on-outline": {
            parent: "map-marker-outline"
        },
        "location-outline": {
            parent: "map-marker-outline"
        },
        "location-path": {
            parent: "map-marker-path"
        },
        "location-plus": {
            parent: "map-marker-plus"
        },
        "location-plus-outline": {
            parent: "map-marker-plus-outline"
        },
        "location-question": {
            parent: "map-marker-question"
        },
        "location-question-outline": {
            parent: "map-marker-question-outline"
        },
        "location-radius": {
            parent: "map-marker-radius"
        },
        "location-radius-outline": {
            parent: "map-marker-radius-outline"
        },
        "location-remove": {
            parent: "map-marker-remove"
        },
        "location-remove-outline": {
            parent: "map-marker-remove-outline"
        },
        "location-remove-variant-outline": {
            parent: "map-marker-remove-variant"
        },
        "location-right": {
            parent: "map-marker-right"
        },
        "location-right-outline": {
            parent: "map-marker-right-outline"
        },
        "location-searching": {
            parent: "crosshairs"
        },
        "location-star": {
            parent: "map-marker-star"
        },
        "location-star-outline": {
            parent: "map-marker-star-outline"
        },
        "location-up": {
            parent: "map-marker-up"
        },
        "location-warning": {
            parent: "map-marker-alert"
        },
        "location-warning-outline": {
            parent: "map-marker-alert-outline"
        },
        locations: {
            parent: "map-marker-multiple"
        },
        "locations-outline": {
            parent: "map-marker-multiple-outline"
        },
        "lock-add": {
            parent: "lock-plus"
        },
        "lock-add-outline": {
            parent: "lock-plus-outline"
        },
        "lock-open-add": {
            parent: "lock-open-plus"
        },
        "lock-open-add-outline": {
            parent: "lock-open-plus-outline"
        },
        "lock-open-warning": {
            parent: "lock-open-alert"
        },
        "lock-open-warning-outline": {
            parent: "lock-open-alert-outline"
        },
        "lock-warning": {
            parent: "lock-alert"
        },
        "lock-warning-outline": {
            parent: "lock-alert-outline"
        },
        lockers: {
            parent: "locker-multiple"
        },
        locomotive: {
            parent: "train"
        },
        "locomotive-variant": {
            parent: "train-variant"
        },
        "log-in": {
            parent: "login"
        },
        "log-in-variant": {
            parent: "login-variant"
        },
        "log-out": {
            parent: "logout"
        },
        "log-out-variant": {
            parent: "logout-variant"
        },
        "logic-gate-and": {
            parent: "gate-and"
        },
        "logic-gate-nand": {
            parent: "gate-nand"
        },
        "logic-gate-nor": {
            parent: "gate-nor"
        },
        "logic-gate-not": {
            parent: "gate-not"
        },
        "logic-gate-or": {
            parent: "gate-or"
        },
        "logic-gate-xnor": {
            parent: "gate-xnor"
        },
        "logic-gate-xor": {
            parent: "gate-xor"
        },
        "looks-3": {
            parent: "numeric-3-box"
        },
        "looks-4": {
            parent: "numeric-4-box"
        },
        "looks-5": {
            parent: "numeric-5-box"
        },
        "looks-6": {
            parent: "numeric-6-box"
        },
        "looks-one": {
            parent: "numeric-1-box"
        },
        "looks-two": {
            parent: "numeric-2-box"
        },
        loop: {
            parent: "refresh"
        },
        lorry: {
            parent: "truck"
        },
        "lorry-check": {
            parent: "truck-check"
        },
        "lorry-delivery": {
            parent: "truck-delivery"
        },
        "lorry-fast": {
            parent: "truck-fast"
        },
        loudspeaker: {
            parent: "bullhorn"
        },
        "loudspeaker-outline": {
            parent: "bullhorn-outline"
        },
        love: {
            parent: "hand-heart"
        },
        "love-seat": {
            parent: "sofa-single"
        },
        "love-seat-outline": {
            parent: "sofa-single-outline"
        },
        loveseat: {
            parent: "sofa-single"
        },
        "loveseat-outline": {
            parent: "sofa-single-outline"
        },
        "low-beam": {
            parent: "car-light-dimmed"
        },
        "low-priority": {
            parent: "priority-low"
        },
        "low-quality": {
            parent: "quality-low"
        },
        loyalty: {
            parent: "tag-heart"
        },
        lq: {
            parent: "quality-low"
        },
        ltr: {
            parent: "format-pilcrow-arrow-right"
        },
        luck: {
            parent: "clover"
        },
        luggage: {
            parent: "bag-checked"
        },
        "magen-david": {
            parent: "star-david"
        },
        magic: {
            parent: "auto-fix"
        },
        "magic-wand": {
            parent: "magic-staff"
        },
        "magnify-add": {
            parent: "magnify-plus"
        },
        "magnify-add-cursor": {
            parent: "magnify-plus-cursor"
        },
        "magnify-add-outline": {
            parent: "magnify-plus-outline"
        },
        "magnify-outline": {
            parent: "magnify"
        },
        "mail-certified": {
            parent: "email-seal"
        },
        "mail-certified-outline": {
            parent: "email-seal-outline"
        },
        "mail-outline": {
            parent: "email-outline"
        },
        "mail-seal": {
            parent: "email-seal"
        },
        "mail-seal-outline": {
            parent: "email-seal-outline"
        },
        "mail-verified": {
            parent: "email-seal"
        },
        "mail-verified-outline": {
            parent: "email-seal-outline"
        },
        man: {
            parent: "human-male"
        },
        "man-child": {
            parent: "human-male-boy"
        },
        "man-man": {
            parent: "human-male-male"
        },
        "man-woman": {
            parent: "human-male-female"
        },
        manufacturing: {
            parent: "cogs"
        },
        "map-add": {
            parent: "map-plus"
        },
        "map-marker-add": {
            parent: "map-marker-plus"
        },
        "map-marker-add-outline": {
            parent: "map-marker-plus-outline"
        },
        "map-marker-favorite": {
            parent: "map-marker-star"
        },
        "map-marker-favorite-outline": {
            parent: "map-marker-star-outline"
        },
        "map-marker-tick": {
            parent: "map-marker-check"
        },
        "map-markers": {
            parent: "map-marker-multiple"
        },
        "map-markers-outline": {
            parent: "map-marker-multiple-outline"
        },
        "map-tick": {
            parent: "map-check"
        },
        "map-tick-outline": {
            parent: "map-check-outline"
        },
        marble: {
            parent: "google-earth"
        },
        marijuana: {
            parent: "cannabis"
        },
        markdown: {
            parent: "language-markdown"
        },
        "markdown-outline": {
            parent: "language-markdown-outline"
        },
        "marker-tick": {
            parent: "marker-check"
        },
        marketplace: {
            parent: "shopping"
        },
        "marketplace-outline": {
            parent: "shopping-outline"
        },
        markunread: {
            parent: "email"
        },
        "markunread-mailbox": {
            parent: "mailbox"
        },
        marquise: {
            parent: "awning"
        },
        "marquise-outline": {
            parent: "awning-outline"
        },
        mars: {
            parent: "gender-male"
        },
        marsupial: {
            parent: "kangaroo"
        },
        "martial-arts": {
            parent: "karate"
        },
        martini: {
            parent: "glass-cocktail"
        },
        "masked-transitions": {
            parent: "transition-masked"
        },
        mason: {
            parent: "ruler-square-compass"
        },
        masonic: {
            parent: "ruler-square-compass"
        },
        material: {
            parent: "palette-swatch"
        },
        "math-compass-variant": {
            parent: "android-studio"
        },
        "math-cosine": {
            parent: "math-cos"
        },
        "math-sine": {
            parent: "math-sin"
        },
        "math-tangent": {
            parent: "math-tan"
        },
        "maths-compass": {
            parent: "math-compass"
        },
        "maths-cos": {
            parent: "math-cos"
        },
        "maths-sin": {
            parent: "math-sin"
        },
        "maths-tan": {
            parent: "math-tan"
        },
        maximize: {
            parent: "checkbox-blank-outline"
        },
        mdi: {
            parent: "vector-square"
        },
        "measuring-tape": {
            parent: "tape-measure"
        },
        meat: {
            parent: "food-drumstick"
        },
        "meat-off": {
            parent: "food-drumstick-off"
        },
        "meat-off-outline": {
            parent: "food-drumstick-off-outline"
        },
        "meat-outline": {
            parent: "food-drumstick-outline"
        },
        mechanic: {
            parent: "car-wrench"
        },
        "media-network": {
            parent: "play-network"
        },
        "media-network-outline": {
            parent: "play-network-outline"
        },
        medicine: {
            parent: "medical-bag"
        },
        "medicine-bottle": {
            parent: "medication"
        },
        "medicine-bottle-outline": {
            parent: "medication-outline"
        },
        "medicine-off": {
            parent: "needle-off"
        },
        "medicine-outline": {
            parent: "minus-circle-outline"
        },
        "medium-quality": {
            parent: "quality-medium"
        },
        megaphone: {
            parent: "bullhorn"
        },
        "megaphone-outline": {
            parent: "bullhorn-outline"
        },
        men: {
            parent: "human-male-male"
        },
        "menorah-flame": {
            parent: "menorah-fire"
        },
        mercury: {
            parent: "gender-male-female-variant"
        },
        "merge-type": {
            parent: "call-merge"
        },
        "message-add": {
            parent: "message-plus"
        },
        "message-group": {
            parent: "forum"
        },
        "message-notification": {
            parent: "message-badge"
        },
        "message-notification-outline": {
            parent: "message-badge-outline"
        },
        "message-quick": {
            parent: "message-flash"
        },
        "message-quick-outline": {
            parent: "message-flash-outline"
        },
        "message-secure": {
            parent: "message-lock"
        },
        "message-settings-variant": {
            parent: "message-cog"
        },
        "message-settings-variant-outline": {
            parent: "message-cog-outline"
        },
        "message-text-secure": {
            parent: "message-text-lock"
        },
        "message-unread": {
            parent: "message-badge"
        },
        "message-unread-outline": {
            parent: "message-badge-outline"
        },
        "message-warning": {
            parent: "message-alert"
        },
        "message-warning-outline": {
            parent: "message-alert-outline"
        },
        metro: {
            parent: "subway"
        },
        "metro-variant": {
            parent: "subway-variant"
        },
        "mic-none": {
            parent: "microphone-outline"
        },
        "mic-off": {
            parent: "microphone-off"
        },
        "microphone-add": {
            parent: "microphone-plus"
        },
        "microphone-help": {
            parent: "microphone-question"
        },
        "microphone-help-outline": {
            parent: "microphone-question-outline"
        },
        "microphone-remove": {
            parent: "microphone-minus"
        },
        "microsoft-dot-net": {
            parent: "dot-net"
        },
        "microsoft-dynamics": {
            parent: "microsoft-dynamics-365"
        },
        "microsoft-github": {
            parent: "github"
        },
        "microsoft-minecraft": {
            parent: "minecraft"
        },
        "microsoft-mixer": {
            parent: "mixer"
        },
        "microsoft-skype": {
            parent: "skype"
        },
        "microsoft-xamarin": {
            parent: "xamarin"
        },
        "microsoft-xamarin-outline": {
            parent: "xamarin-outline"
        },
        "microsoft-xaml": {
            parent: "language-xaml"
        },
        "microsoft-xbox-gamepad": {
            parent: "microsoft-xbox-controller"
        },
        "microsoft-xbox-gamepad-battery-alert": {
            parent: "microsoft-xbox-controller-battery-alert"
        },
        "microsoft-xbox-gamepad-battery-charging": {
            parent: "microsoft-xbox-controller-battery-charging"
        },
        "microsoft-xbox-gamepad-battery-empty": {
            parent: "microsoft-xbox-controller-battery-empty"
        },
        "microsoft-xbox-gamepad-battery-full": {
            parent: "microsoft-xbox-controller-battery-full"
        },
        "microsoft-xbox-gamepad-battery-low": {
            parent: "microsoft-xbox-controller-battery-low"
        },
        "microsoft-xbox-gamepad-battery-medium": {
            parent: "microsoft-xbox-controller-battery-medium"
        },
        "microsoft-xbox-gamepad-battery-unknown": {
            parent: "microsoft-xbox-controller-battery-unknown"
        },
        "microsoft-xbox-gamepad-off": {
            parent: "microsoft-xbox-controller-off"
        },
        "microwave-oven": {
            parent: "microwave"
        },
        milestone: {
            parent: "flag-triangle"
        },
        "milestone-add": {
            parent: "sign-direction-plus"
        },
        "milestone-minus": {
            parent: "sign-direction-minus"
        },
        "milestone-plus": {
            parent: "sign-direction-plus"
        },
        "milestone-remove": {
            parent: "sign-direction-remove"
        },
        "mini-blinds": {
            parent: "blinds-horizontal"
        },
        minimize: {
            parent: "minus"
        },
        "minus-one": {
            parent: "numeric-negative-1"
        },
        mister: {
            parent: "sprinkler-fire"
        },
        "mixer-settings": {
            parent: "tune"
        },
        "mixer-settings-vertical": {
            parent: "tune-vertical"
        },
        "mixing-bowl": {
            parent: "bowl-mix"
        },
        "mixing-bowl-outline": {
            parent: "bowl-mix-outline"
        },
        mma: {
            parent: "mixed-martial-arts"
        },
        mms: {
            parent: "message-image"
        },
        "mobile-devices": {
            parent: "tablet-cellphone"
        },
        "mobile-off": {
            parent: "cellphone-off"
        },
        "mobile-phone": {
            parent: "cellphone"
        },
        "mobile-phone-android": {
            parent: "cellphone-android"
        },
        "mobile-phone-arrow-down": {
            parent: "cellphone-arrow-down"
        },
        "mobile-phone-basic": {
            parent: "cellphone-basic"
        },
        "mobile-phone-dock": {
            parent: "cellphone-dock"
        },
        "mobile-phone-erase": {
            parent: "cellphone-remove"
        },
        "mobile-phone-information": {
            parent: "cellphone-information"
        },
        "mobile-phone-iphone": {
            parent: "cellphone-iphone"
        },
        "mobile-phone-key": {
            parent: "cellphone-key"
        },
        "mobile-phone-link": {
            parent: "cellphone-link"
        },
        "mobile-phone-link-off": {
            parent: "cellphone-link-off"
        },
        "mobile-phone-lock": {
            parent: "cellphone-lock"
        },
        "mobile-phone-message": {
            parent: "cellphone-message"
        },
        "mobile-phone-off": {
            parent: "cellphone-off"
        },
        "mobile-phone-settings": {
            parent: "cellphone-settings"
        },
        "mobile-phone-settings-variant": {
            parent: "cellphone-cog"
        },
        "mobile-phone-sound": {
            parent: "cellphone-sound"
        },
        "mobile-phone-text": {
            parent: "cellphone-text"
        },
        "mobile-phone-wireless": {
            parent: "cellphone-wireless"
        },
        "mode-comment": {
            parent: "message-reply"
        },
        "mode-edit": {
            parent: "pencil"
        },
        "mode-edit-outline": {
            parent: "pencil-outline"
        },
        moderator: {
            parent: "shield-sword"
        },
        "moderator-outline": {
            parent: "shield-sword-outline"
        },
        mom: {
            parent: "human-female-boy"
        },
        "mom-dad-child": {
            parent: "human-male-female-child"
        },
        money: {
            parent: "cash"
        },
        "money-100": {
            parent: "cash-100"
        },
        "money-off": {
            parent: "currency-usd-off"
        },
        "money-usd": {
            parent: "cash-usd"
        },
        "monitor-cellphone-favorite": {
            parent: "monitor-cellphone-star"
        },
        "monitor-clean": {
            parent: "monitor-shimmer"
        },
        "monitor-crt": {
            parent: "monitor-small"
        },
        "monitor-download": {
            parent: "monitor-arrow-down"
        },
        "monitor-favorite": {
            parent: "monitor-star"
        },
        "monitor-mobile-phone": {
            parent: "monitor-cellphone"
        },
        "monitor-mobile-phone-star": {
            parent: "monitor-cellphone-star"
        },
        "monitor-smartphone": {
            parent: "monitor-cellphone"
        },
        "monitor-smartphone-star": {
            parent: "monitor-cellphone-star"
        },
        monitors: {
            parent: "monitor-multiple"
        },
        "monkey-wrench": {
            parent: "pipe-wrench"
        },
        mood: {
            parent: "emoticon-outline"
        },
        "moon-and-stars": {
            parent: "weather-night"
        },
        moonshine: {
            parent: "bottle-tonic-skull"
        },
        "moonshine-outline": {
            parent: "bottle-tonic-skull-outline"
        },
        "more-circle": {
            parent: "dots-horizontal-circle"
        },
        "more-circle-outline": {
            parent: "dots-horizontal-circle-outline"
        },
        "more-horiz": {
            parent: "dots-horizontal"
        },
        "more-vert": {
            parent: "dots-vertical"
        },
        mother: {
            parent: "human-female-boy"
        },
        "motion-detector": {
            parent: "motion-sensor"
        },
        motor: {
            parent: "engine"
        },
        "motor-off": {
            parent: "engine-off"
        },
        "motor-off-outline": {
            parent: "engine-off-outline"
        },
        "motor-outline": {
            parent: "engine-outline"
        },
        motorcycle: {
            parent: "motorbike"
        },
        "motorcycle-electric": {
            parent: "motorbike-electric"
        },
        "motorcycle-off": {
            parent: "motorbike-off"
        },
        motorway: {
            parent: "highway"
        },
        mountain: {
            parent: "image-filter-hdr"
        },
        "move-from-inbox": {
            parent: "inbox-arrow-up"
        },
        "move-to-inbox": {
            parent: "inbox-arrow-down"
        },
        "movie-creation": {
            parent: "movie"
        },
        "movie-favorite": {
            parent: "movie-star"
        },
        "movie-favorite-outline": {
            parent: "movie-star-outline"
        },
        "movie-open-favorite": {
            parent: "movie-open-star"
        },
        "movie-open-favorite-outline": {
            parent: "movie-open-star-outline"
        },
        "mozilla-firefox": {
            parent: "firefox"
        },
        mq: {
            parent: "quality-medium"
        },
        mudslide: {
            parent: "landslide"
        },
        "mudslide-outline": {
            parent: "landslide-outline"
        },
        multiplex: {
            parent: "multicast"
        },
        multiply: {
            parent: "close"
        },
        "multiply-bold": {
            parent: "close-thick"
        },
        "multiply-box": {
            parent: "close-box"
        },
        "multiply-box-multiple": {
            parent: "close-box-multiple"
        },
        "multiply-box-multiple-outline": {
            parent: "close-box-multiple-outline"
        },
        "multiply-box-outline": {
            parent: "close-box-outline"
        },
        "multiply-boxes": {
            parent: "close-box-multiple"
        },
        "multiply-boxes-outline": {
            parent: "close-box-multiple-outline"
        },
        "multiply-circle": {
            parent: "close-circle"
        },
        "multiply-circle-multiple": {
            parent: "close-circle-multiple"
        },
        "multiply-circle-multiple-outline": {
            parent: "close-circle-multiple-outline"
        },
        "multiply-circle-outline": {
            parent: "close-circle-outline"
        },
        "multiply-network": {
            parent: "close-network"
        },
        "multiply-network-outline": {
            parent: "close-network-outline"
        },
        "multiply-octagon": {
            parent: "close-octagon"
        },
        "multiply-octagon-outline": {
            parent: "close-octagon-outline"
        },
        "multiply-outline": {
            parent: "close-outline"
        },
        "multiply-thick": {
            parent: "close-thick"
        },
        mum: {
            parent: "human-female-boy"
        },
        museum: {
            parent: "bank"
        },
        "museum-outline": {
            parent: "bank-outline"
        },
        "music-c-clef": {
            parent: "music-clef-alto"
        },
        "music-clef-baritone": {
            parent: "music-clef-alto"
        },
        "music-clef-soprano": {
            parent: "music-clef-alto"
        },
        "music-clef-tenor": {
            parent: "music-clef-alto"
        },
        "music-f-clef": {
            parent: "music-clef-bass"
        },
        "music-g-clef": {
            parent: "music-clef-treble"
        },
        "music-note-add": {
            parent: "music-note-plus"
        },
        muslim: {
            parent: "mosque"
        },
        mute: {
            parent: "volume-off"
        },
        "my-location": {
            parent: "crosshairs-gps"
        },
        naira: {
            parent: "currency-ngn"
        },
        "natural-gas": {
            parent: "fire"
        },
        "natural-gas-circle": {
            parent: "fire-circle"
        },
        "natural-gas-outline": {
            parent: "meter-gas-outline"
        },
        navi: {
            parent: "candy-outline"
        },
        "navi-off": {
            parent: "candy-off-outline"
        },
        "navigate-before": {
            parent: "chevron-left"
        },
        "navigate-next": {
            parent: "chevron-right"
        },
        "near-field-communication": {
            parent: "nfc"
        },
        "near-field-communication-off": {
            parent: "nfc-variant-off"
        },
        "near-field-communication-tap": {
            parent: "nfc-tap"
        },
        "near-field-communication-variant": {
            parent: "nfc-variant"
        },
        neato: {
            parent: "robot-vacuum-variant"
        },
        neighbourhood: {
            parent: "home-group"
        },
        nest: {
            parent: "thermostat"
        },
        "nest-protect": {
            parent: "smoke-detector"
        },
        "network-attached-storage": {
            parent: "nas"
        },
        "network-cash-box": {
            parent: "network-pos"
        },
        "network-favorite": {
            parent: "wifi-star"
        },
        "network-favourite": {
            parent: "wifi-star"
        },
        "network-interface-card": {
            parent: "expansion-card"
        },
        "network-point-of-sale": {
            parent: "network-pos"
        },
        "network-router": {
            parent: "router-network"
        },
        "network-strength-0": {
            parent: "network-strength-outline"
        },
        "network-strength-1-warning": {
            parent: "network-strength-1-alert"
        },
        "network-strength-2-warning": {
            parent: "network-strength-2-alert"
        },
        "network-strength-3-warning": {
            parent: "network-strength-3-alert"
        },
        "network-strength-4-settings": {
            parent: "network-strength-4-cog"
        },
        "network-strength-4-warning": {
            parent: "network-strength-4-alert"
        },
        neutral: {
            parent: "alpha-n"
        },
        "new-releases": {
            parent: "alert-decagram"
        },
        "new-taiwan-dollar": {
            parent: "currency-twd"
        },
        "next-title": {
            parent: "skip-forward"
        },
        nic: {
            parent: "expansion-card"
        },
        nice: {
            parent: "expansion-card-variant"
        },
        "night-light": {
            parent: "lightbulb-night"
        },
        "night-light-outline": {
            parent: "lightbulb-night-outline"
        },
        "night-sky": {
            parent: "weather-night"
        },
        "nintendo-switch-online": {
            parent: "nintendo-switch"
        },
        "nite-light": {
            parent: "lightbulb-night"
        },
        "nite-light-outline": {
            parent: "lightbulb-night-outline"
        },
        no: {
            parent: "cancel"
        },
        "no-entry": {
            parent: "do-not-disturb"
        },
        "no-smoking": {
            parent: "smoking-off"
        },
        "nordic-walking": {
            parent: "ski-cross-country"
        },
        "northern-lights": {
            parent: "aurora"
        },
        "not-protected": {
            parent: "lock-off"
        },
        "not-protected-outline": {
            parent: "lock-off-outline"
        },
        "note-add": {
            parent: "file-plus"
        },
        "note-add-outline": {
            parent: "note-plus-outline"
        },
        "note-circle": {
            parent: "music-circle"
        },
        "note-circle-outline": {
            parent: "music-circle-outline"
        },
        "notebook-favorite": {
            parent: "notebook-heart"
        },
        "notebook-favorite-outline": {
            parent: "notebook-heart-outline"
        },
        "notebook-love": {
            parent: "notebook-heart"
        },
        "notebook-love-outline": {
            parent: "notebook-heart-outline"
        },
        notes: {
            parent: "note-multiple"
        },
        "notes-outline": {
            parent: "note-multiple-outline"
        },
        "notes-search": {
            parent: "text-search"
        },
        "notes-search-variant": {
            parent: "text-search-variant"
        },
        "notice-board": {
            parent: "bulletin-board"
        },
        "notification-settings": {
            parent: "bell-cog"
        },
        "notification-settings-outline": {
            parent: "bell-cog-outline"
        },
        notifications: {
            parent: "bell"
        },
        "notifications-active": {
            parent: "bell-ring"
        },
        "notifications-none": {
            parent: "bell-outline"
        },
        "notifications-off": {
            parent: "bell-off"
        },
        "notifications-paused": {
            parent: "bell-sleep"
        },
        nuclear: {
            parent: "nuke"
        },
        "null-off": {
            parent: "circle-off-outline"
        },
        "number-0": {
            parent: "numeric-0"
        },
        "number-0-box": {
            parent: "numeric-0-box"
        },
        "number-0-box-multiple-outline": {
            parent: "numeric-0-box-multiple-outline"
        },
        "number-0-box-outline": {
            parent: "numeric-0-box-outline"
        },
        "number-0-circle": {
            parent: "numeric-0-circle"
        },
        "number-0-circle-outline": {
            parent: "numeric-0-circle-outline"
        },
        "number-1": {
            parent: "numeric-1"
        },
        "number-1-box": {
            parent: "numeric-1-box"
        },
        "number-1-box-multiple-outline": {
            parent: "numeric-1-box-multiple-outline"
        },
        "number-1-box-outline": {
            parent: "numeric-1-box-outline"
        },
        "number-1-circle": {
            parent: "numeric-1-circle"
        },
        "number-1-circle-outline": {
            parent: "numeric-1-circle-outline"
        },
        "number-2": {
            parent: "numeric-2"
        },
        "number-2-box": {
            parent: "numeric-2-box"
        },
        "number-2-box-multiple-outline": {
            parent: "numeric-2-box-multiple-outline"
        },
        "number-2-box-outline": {
            parent: "numeric-2-box-outline"
        },
        "number-2-circle": {
            parent: "numeric-2-circle"
        },
        "number-2-circle-outline": {
            parent: "numeric-2-circle-outline"
        },
        "number-3": {
            parent: "numeric-3"
        },
        "number-3-box": {
            parent: "numeric-3-box"
        },
        "number-3-box-multiple-outline": {
            parent: "numeric-3-box-multiple-outline"
        },
        "number-3-box-outline": {
            parent: "numeric-3-box-outline"
        },
        "number-3-circle": {
            parent: "numeric-3-circle"
        },
        "number-3-circle-outline": {
            parent: "numeric-3-circle-outline"
        },
        "number-4": {
            parent: "numeric-4"
        },
        "number-4-box": {
            parent: "numeric-4-box"
        },
        "number-4-box-multiple-outline": {
            parent: "numeric-4-box-multiple-outline"
        },
        "number-4-box-outline": {
            parent: "numeric-4-box-outline"
        },
        "number-4-circle": {
            parent: "numeric-4-circle"
        },
        "number-4-circle-outline": {
            parent: "numeric-4-circle-outline"
        },
        "number-5": {
            parent: "numeric-5"
        },
        "number-5-box": {
            parent: "numeric-5-box"
        },
        "number-5-box-multiple-outline": {
            parent: "numeric-5-box-multiple-outline"
        },
        "number-5-box-outline": {
            parent: "numeric-5-box-outline"
        },
        "number-5-circle": {
            parent: "numeric-5-circle"
        },
        "number-5-circle-outline": {
            parent: "numeric-5-circle-outline"
        },
        "number-6": {
            parent: "numeric-6"
        },
        "number-6-box": {
            parent: "numeric-6-box"
        },
        "number-6-box-multiple-outline": {
            parent: "numeric-6-box-multiple-outline"
        },
        "number-6-box-outline": {
            parent: "numeric-6-box-outline"
        },
        "number-6-circle": {
            parent: "numeric-6-circle"
        },
        "number-6-circle-outline": {
            parent: "numeric-6-circle-outline"
        },
        "number-7": {
            parent: "numeric-7"
        },
        "number-7-box": {
            parent: "numeric-7-box"
        },
        "number-7-box-multiple-outline": {
            parent: "numeric-7-box-multiple-outline"
        },
        "number-7-box-outline": {
            parent: "numeric-7-box-outline"
        },
        "number-7-circle": {
            parent: "numeric-7-circle"
        },
        "number-7-circle-outline": {
            parent: "numeric-7-circle-outline"
        },
        "number-8": {
            parent: "numeric-8"
        },
        "number-8-box": {
            parent: "numeric-8-box"
        },
        "number-8-box-multiple-outline": {
            parent: "numeric-8-box-multiple-outline"
        },
        "number-8-box-outline": {
            parent: "numeric-8-box-outline"
        },
        "number-8-circle": {
            parent: "numeric-8-circle"
        },
        "number-8-circle-outline": {
            parent: "numeric-8-circle-outline"
        },
        "number-9": {
            parent: "numeric-9"
        },
        "number-9-box": {
            parent: "numeric-9-box"
        },
        "number-9-box-multiple-outline": {
            parent: "numeric-9-box-multiple-outline"
        },
        "number-9-box-outline": {
            parent: "numeric-9-box-outline"
        },
        "number-9-circle": {
            parent: "numeric-9-circle"
        },
        "number-9-circle-outline": {
            parent: "numeric-9-circle-outline"
        },
        "number-9-plus-box": {
            parent: "numeric-9-plus-box"
        },
        "number-9-plus-box-multiple-outline": {
            parent: "numeric-9-plus-box-multiple-outline"
        },
        "number-9-plus-box-outline": {
            parent: "numeric-9-plus-box-outline"
        },
        "number-9-plus-circle": {
            parent: "numeric-9-plus-circle"
        },
        "number-9-plus-circle-outline": {
            parent: "numeric-9-plus-circle-outline"
        },
        "number-eight-circle": {
            parent: "numeric-8-circle"
        },
        "number-eight-circle-outline": {
            parent: "numeric-8-circle-outline"
        },
        "number-five-circle": {
            parent: "numeric-5-circle"
        },
        "number-five-circle-outline": {
            parent: "numeric-5-circle-outline"
        },
        "number-four-circle": {
            parent: "numeric-4-circle"
        },
        "number-four-circle-outline": {
            parent: "numeric-4-circle-outline"
        },
        "number-nine-circle": {
            parent: "numeric-9-circle"
        },
        "number-nine-circle-outline": {
            parent: "numeric-9-circle-outline"
        },
        "number-nine-plus-circle": {
            parent: "numeric-9-plus-circle"
        },
        "number-nine-plus-circle-outline": {
            parent: "numeric-9-plus-circle-outline"
        },
        "number-one-circle": {
            parent: "numeric-1-circle"
        },
        "number-one-circle-outline": {
            parent: "numeric-1-circle-outline"
        },
        "number-seven-circle": {
            parent: "numeric-7-circle"
        },
        "number-seven-circle-outline": {
            parent: "numeric-7-circle-outline"
        },
        "number-six-circle": {
            parent: "numeric-6-circle"
        },
        "number-six-circle-outline": {
            parent: "numeric-6-circle-outline"
        },
        "number-three-circle": {
            parent: "numeric-3-circle"
        },
        "number-three-circle-outline": {
            parent: "numeric-3-circle-outline"
        },
        "number-two-circle": {
            parent: "numeric-2-circle"
        },
        "number-two-circle-outline": {
            parent: "numeric-2-circle-outline"
        },
        "number-zero-circle": {
            parent: "numeric-0-circle"
        },
        "number-zero-circle-outline": {
            parent: "numeric-0-circle-outline"
        },
        numbers: {
            parent: "counter"
        },
        "numbers-off": {
            parent: "numeric-off"
        },
        "numeric-0-boxes-outline": {
            parent: "numeric-0-box-multiple-outline"
        },
        "numeric-1-boxes-outline": {
            parent: "numeric-1-box-multiple-outline"
        },
        "numeric-2-boxes-outline": {
            parent: "numeric-2-box-multiple-outline"
        },
        "numeric-3-boxes-outline": {
            parent: "numeric-3-box-multiple-outline"
        },
        "numeric-4-boxes-outline": {
            parent: "numeric-4-box-multiple-outline"
        },
        "numeric-5-boxes-outline": {
            parent: "numeric-5-box-multiple-outline"
        },
        "numeric-6-boxes-outline": {
            parent: "numeric-6-box-multiple-outline"
        },
        "numeric-7-boxes-outline": {
            parent: "numeric-7-box-multiple-outline"
        },
        "numeric-8-boxes-outline": {
            parent: "numeric-8-box-multiple-outline"
        },
        "numeric-9-boxes-outline": {
            parent: "numeric-9-box-multiple-outline"
        },
        "numeric-9-plus-boxes-outline": {
            parent: "numeric-9-plus-box-multiple-outline"
        },
        "numeric-eight": {
            parent: "numeric-8"
        },
        "numeric-eight-box": {
            parent: "numeric-8-box"
        },
        "numeric-eight-box-multiple-outline": {
            parent: "numeric-8-box-multiple-outline"
        },
        "numeric-eight-box-outline": {
            parent: "numeric-8-box-outline"
        },
        "numeric-eight-circle": {
            parent: "numeric-8-circle"
        },
        "numeric-eight-circle-outline": {
            parent: "numeric-8-circle-outline"
        },
        "numeric-five": {
            parent: "numeric-5"
        },
        "numeric-five-box": {
            parent: "numeric-5-box"
        },
        "numeric-five-box-multiple-outline": {
            parent: "numeric-5-box-multiple-outline"
        },
        "numeric-five-box-outline": {
            parent: "numeric-5-box-outline"
        },
        "numeric-five-circle": {
            parent: "numeric-5-circle"
        },
        "numeric-five-circle-outline": {
            parent: "numeric-5-circle-outline"
        },
        "numeric-four": {
            parent: "numeric-4"
        },
        "numeric-four-box": {
            parent: "numeric-4-box"
        },
        "numeric-four-box-multiple-outline": {
            parent: "numeric-4-box-multiple-outline"
        },
        "numeric-four-box-outline": {
            parent: "numeric-4-box-outline"
        },
        "numeric-four-circle": {
            parent: "numeric-4-circle"
        },
        "numeric-four-circle-outline": {
            parent: "numeric-4-circle-outline"
        },
        "numeric-nine": {
            parent: "numeric-9"
        },
        "numeric-nine-box": {
            parent: "numeric-9-box"
        },
        "numeric-nine-box-multiple-outline": {
            parent: "numeric-9-box-multiple-outline"
        },
        "numeric-nine-box-outline": {
            parent: "numeric-9-box-outline"
        },
        "numeric-nine-circle": {
            parent: "numeric-9-circle"
        },
        "numeric-nine-circle-outline": {
            parent: "numeric-9-circle-outline"
        },
        "numeric-nine-plus-box": {
            parent: "numeric-9-plus-box"
        },
        "numeric-nine-plus-box-multiple-outline": {
            parent: "numeric-9-plus-box-multiple-outline"
        },
        "numeric-nine-plus-box-outline": {
            parent: "numeric-9-plus-box-outline"
        },
        "numeric-nine-plus-circle": {
            parent: "numeric-9-plus-circle"
        },
        "numeric-nine-plus-circle-outline": {
            parent: "numeric-9-plus-circle-outline"
        },
        "numeric-one": {
            parent: "numeric-1"
        },
        "numeric-one-box": {
            parent: "numeric-1-box"
        },
        "numeric-one-box-multiple-outline": {
            parent: "numeric-1-box-multiple-outline"
        },
        "numeric-one-box-outline": {
            parent: "numeric-1-box-outline"
        },
        "numeric-one-circle": {
            parent: "numeric-1-circle"
        },
        "numeric-one-circle-outline": {
            parent: "numeric-1-circle-outline"
        },
        "numeric-seven": {
            parent: "numeric-7"
        },
        "numeric-seven-box": {
            parent: "numeric-7-box"
        },
        "numeric-seven-box-multiple-outline": {
            parent: "numeric-7-box-multiple-outline"
        },
        "numeric-seven-box-outline": {
            parent: "numeric-7-box-outline"
        },
        "numeric-seven-circle": {
            parent: "numeric-7-circle"
        },
        "numeric-seven-circle-outline": {
            parent: "numeric-7-circle-outline"
        },
        "numeric-six": {
            parent: "numeric-6"
        },
        "numeric-six-box": {
            parent: "numeric-6-box"
        },
        "numeric-six-box-multiple-outline": {
            parent: "numeric-6-box-multiple-outline"
        },
        "numeric-six-box-outline": {
            parent: "numeric-6-box-outline"
        },
        "numeric-six-circle": {
            parent: "numeric-6-circle"
        },
        "numeric-six-circle-outline": {
            parent: "numeric-6-circle-outline"
        },
        "numeric-three": {
            parent: "numeric-3"
        },
        "numeric-three-box": {
            parent: "numeric-3-box"
        },
        "numeric-three-box-multiple-outline": {
            parent: "numeric-3-box-multiple-outline"
        },
        "numeric-three-box-outline": {
            parent: "numeric-3-box-outline"
        },
        "numeric-three-circle": {
            parent: "numeric-3-circle"
        },
        "numeric-three-circle-outline": {
            parent: "numeric-3-circle-outline"
        },
        "numeric-two": {
            parent: "numeric-2"
        },
        "numeric-two-box": {
            parent: "numeric-2-box"
        },
        "numeric-two-box-multiple-outline": {
            parent: "numeric-2-box-multiple-outline"
        },
        "numeric-two-box-outline": {
            parent: "numeric-2-box-outline"
        },
        "numeric-two-circle": {
            parent: "numeric-2-circle"
        },
        "numeric-two-circle-outline": {
            parent: "numeric-2-circle-outline"
        },
        "numeric-zero": {
            parent: "numeric-0"
        },
        "numeric-zero-box": {
            parent: "numeric-0-box"
        },
        "numeric-zero-box-multiple-outline": {
            parent: "numeric-0-box-multiple-outline"
        },
        "numeric-zero-box-outline": {
            parent: "numeric-0-box-outline"
        },
        "numeric-zero-circle": {
            parent: "numeric-0-circle"
        },
        "numeric-zero-circle-outline": {
            parent: "numeric-0-circle-outline"
        },
        nursery: {
            parent: "cradle"
        },
        "nursery-outline": {
            parent: "cradle-outline"
        },
        obelus: {
            parent: "division"
        },
        ocean: {
            parent: "waves"
        },
        "ocean-level-rise": {
            parent: "waves-arrow-up"
        },
        odometer: {
            parent: "counter"
        },
        odor: {
            parent: "scent"
        },
        "odor-off": {
            parent: "scent-off"
        },
        office: {
            parent: "microsoft-office"
        },
        "office-building-location": {
            parent: "office-building-marker"
        },
        "office-building-location-outline": {
            parent: "office-building-marker-outline"
        },
        "office-building-settings": {
            parent: "office-building-cog"
        },
        "office-building-settings-outline": {
            parent: "office-building-cog-outline"
        },
        "office-chair": {
            parent: "chair-rolling"
        },
        "offline-bolt": {
            parent: "lightning-bolt-circle"
        },
        ohm: {
            parent: "omega"
        },
        "oil-barrel": {
            parent: "barrel"
        },
        "oil-barrel-outline": {
            parent: "barrel-outline"
        },
        "oil-saver": {
            parent: "water-opacity"
        },
        "oil-transparent": {
            parent: "water-opacity"
        },
        "oil-truck": {
            parent: "tanker-truck"
        },
        "ok-ru": {
            parent: "odnoklassniki"
        },
        olympics: {
            parent: "torch"
        },
        one: {
            parent: "tally-mark-1"
        },
        "one-two-three": {
            parent: "numeric"
        },
        "one-two-three-off": {
            parent: "numeric-off"
        },
        "open-container-initiative": {
            parent: "oci"
        },
        "open-in-browser": {
            parent: "open-in-app"
        },
        "optical-audio": {
            parent: "toslink"
        },
        "optical-character-recognition": {
            parent: "ocr"
        },
        "oral-hygiene": {
            parent: "toothbrush"
        },
        "order-checkbox-ascending": {
            parent: "order-bool-ascending-variant"
        },
        "order-checkbox-descending": {
            parent: "order-bool-descending"
        },
        organic: {
            parent: "leaf-circle"
        },
        "organic-outline": {
            parent: "leaf-circle-outline"
        },
        "outdoor-light": {
            parent: "outdoor-lamp"
        },
        "outdoor-temperature": {
            parent: "sun-thermometer"
        },
        "outer-join-left": {
            parent: "set-left-center"
        },
        "outer-join-right": {
            parent: "set-center-right"
        },
        output: {
            parent: "export"
        },
        "outside-temperature": {
            parent: "sun-thermometer-outline"
        },
        oven: {
            parent: "stove"
        },
        overboard: {
            parent: "lifebuoy"
        },
        "overhead-projector": {
            parent: "camera-document"
        },
        "overhead-projector-off": {
            parent: "camera-document-off"
        },
        "oxygen-tank": {
            parent: "gas-cylinder"
        },
        "package-delivered": {
            parent: "package-check"
        },
        "package-off": {
            parent: "gift-off"
        },
        "package-off-outline": {
            parent: "gift-off-outline"
        },
        "package-open": {
            parent: "gift-open"
        },
        "package-open-outline": {
            parent: "gift-open-outline"
        },
        "package-outline": {
            parent: "gift-outline"
        },
        "package-variant-add": {
            parent: "package-variant-plus"
        },
        "package-variant-closed-add": {
            parent: "package-variant-closed-plus"
        },
        "package-variant-closed-delivered": {
            parent: "package-variant-closed-check"
        },
        "package-variant-closed-subtract": {
            parent: "package-variant-closed-minus"
        },
        "package-variant-subtract": {
            parent: "package-variant-minus"
        },
        "page-layout-marginals": {
            parent: "page-layout-header-footer"
        },
        pageview: {
            parent: "card-search"
        },
        "pageview-outline": {
            parent: "card-search-outline"
        },
        paint: {
            parent: "format-color-fill"
        },
        "paint-bucket": {
            parent: "format-color-fill"
        },
        "paint-outline": {
            parent: "palette-outline"
        },
        paintbrush: {
            parent: "brush"
        },
        "paintbrush-outline": {
            parent: "brush-outline"
        },
        "pan-down-left": {
            parent: "pan-bottom-left"
        },
        "pan-down-right": {
            parent: "pan-bottom-right"
        },
        "pan-up-left": {
            parent: "pan-top-left"
        },
        "pan-up-right": {
            parent: "pan-top-right"
        },
        "panorama-360": {
            parent: "panorama-sphere"
        },
        "panorama-360-outline": {
            parent: "panorama-sphere-outline"
        },
        "panorama-fish-eye": {
            parent: "panorama-fisheye"
        },
        "panorama-vr": {
            parent: "panorama-variant"
        },
        "panorama-vr-outline": {
            parent: "panorama-variant-outline"
        },
        panties: {
            parent: "lingerie"
        },
        paper: {
            parent: "file"
        },
        "paper-add": {
            parent: "note-plus"
        },
        "paper-add-outline": {
            parent: "note-plus-outline"
        },
        "paper-airplane": {
            parent: "send"
        },
        "paper-airplane-outline": {
            parent: "send-outline"
        },
        "paper-alert": {
            parent: "note-alert"
        },
        "paper-alert-outline": {
            parent: "note-alert-outline"
        },
        "paper-check": {
            parent: "note-check"
        },
        "paper-check-outline": {
            parent: "note-check-outline"
        },
        "paper-edit": {
            parent: "note-edit"
        },
        "paper-edit-outline": {
            parent: "note-edit-outline"
        },
        "paper-jam": {
            parent: "printer-alert"
        },
        "paper-minus": {
            parent: "note-minus"
        },
        "paper-minus-outline": {
            parent: "note-minus-outline"
        },
        "paper-off": {
            parent: "note-off"
        },
        "paper-off-outline": {
            parent: "note-off-outline"
        },
        "paper-outline": {
            parent: "file-outline"
        },
        "paper-plane": {
            parent: "send"
        },
        "paper-plane-outline": {
            parent: "send-outline"
        },
        "paper-plus": {
            parent: "note-plus"
        },
        "paper-plus-outline": {
            parent: "note-plus-outline"
        },
        "paper-remove": {
            parent: "note-remove"
        },
        "paper-search": {
            parent: "note-search"
        },
        "paper-search-outline": {
            parent: "note-search-outline"
        },
        "paper-text": {
            parent: "note-text"
        },
        "paper-text-outline": {
            parent: "note-text-outline"
        },
        "paper-towels": {
            parent: "paper-roll"
        },
        "paper-towels-outline": {
            parent: "paper-roll-outline"
        },
        "paperclip-add": {
            parent: "attachment-plus"
        },
        "paperclip-horizontal": {
            parent: "attachment"
        },
        "paperclip-subtract": {
            parent: "attachment-minus"
        },
        "paperclip-tick": {
            parent: "attachment-check"
        },
        papers: {
            parent: "note-multiple"
        },
        "papers-outline": {
            parent: "note-multiple-outline"
        },
        paraglide: {
            parent: "paragliding"
        },
        parallel: {
            parent: "math-norm"
        },
        "parallel-box": {
            parent: "math-norm-box"
        },
        parasail: {
            parent: "paragliding"
        },
        parasol: {
            parent: "beach"
        },
        paris: {
            parent: "eiffel-tower"
        },
        park: {
            parent: "alpha-p"
        },
        partnership: {
            parent: "handshake"
        },
        "partnership-outline": {
            parent: "handshake-outline"
        },
        "party-balloon": {
            parent: "balloon"
        },
        "passport-electronic": {
            parent: "passport-biometric"
        },
        password: {
            parent: "lock"
        },
        "password-add": {
            parent: "lock-plus"
        },
        "password-add-outline": {
            parent: "lock-plus-outline"
        },
        "password-alert": {
            parent: "lock-alert"
        },
        "password-alert-outline": {
            parent: "lock-alert-outline"
        },
        "password-check": {
            parent: "lock-check"
        },
        "password-check-outline": {
            parent: "lock-check-outline"
        },
        "password-clock": {
            parent: "lock-clock"
        },
        "password-expiration": {
            parent: "lock-clock"
        },
        "password-minus": {
            parent: "lock-minus"
        },
        "password-minus-outline": {
            parent: "lock-minus-outline"
        },
        "password-off": {
            parent: "lock-off"
        },
        "password-off-outline": {
            parent: "lock-off-outline"
        },
        "password-outline": {
            parent: "lock-outline"
        },
        "password-plus": {
            parent: "lock-plus"
        },
        "password-plus-outline": {
            parent: "lock-plus-outline"
        },
        "password-question": {
            parent: "lock-question"
        },
        "password-remove": {
            parent: "lock-remove"
        },
        "password-remove-outline": {
            parent: "lock-remove-outline"
        },
        "password-reset": {
            parent: "lock-reset"
        },
        "password-secure": {
            parent: "lock-check"
        },
        "password-secure-outline": {
            parent: "lock-check-outline"
        },
        "password-verified": {
            parent: "lock-check"
        },
        "password-verified-outline": {
            parent: "lock-check-outline"
        },
        "password-warning": {
            parent: "lock-alert"
        },
        "password-warning-outline": {
            parent: "lock-alert-outline"
        },
        patient: {
            parent: "account-injury"
        },
        "patient-outline": {
            parent: "account-injury-outline"
        },
        patio: {
            parent: "balcony"
        },
        "patio-door": {
            parent: "door-sliding"
        },
        "patio-door-lock": {
            parent: "door-sliding-lock"
        },
        "patio-door-open": {
            parent: "door-sliding-open"
        },
        "pause-circle-filled": {
            parent: "pause-circle"
        },
        payment: {
            parent: "credit-card-outline"
        },
        "payment-clock": {
            parent: "cash-clock"
        },
        "payment-on-delivery": {
            parent: "credit-card-marker"
        },
        "payment-on-delivery-outline": {
            parent: "credit-card-marker-outline"
        },
        "payment-schedule": {
            parent: "cash-clock"
        },
        "payment-settings": {
            parent: "credit-card-settings-outline"
        },
        "pdf-box": {
            parent: "file-pdf-box"
        },
        peak: {
            parent: "summit"
        },
        pegman: {
            parent: "google-street-view"
        },
        "pen-add": {
            parent: "pen-plus"
        },
        "pencil-add": {
            parent: "pencil-plus"
        },
        "pencil-add-outline": {
            parent: "pencil-plus-outline"
        },
        people: {
            parent: "account-multiple"
        },
        "people-add": {
            parent: "account-multiple-plus"
        },
        "people-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "people-check": {
            parent: "account-multiple-check"
        },
        "people-check-outline": {
            parent: "account-multiple-check-outline"
        },
        "people-group": {
            parent: "account-group"
        },
        "people-group-outline": {
            parent: "account-group-outline"
        },
        "people-minus": {
            parent: "account-multiple-minus"
        },
        "people-minus-outline": {
            parent: "account-multiple-minus-outline"
        },
        "people-outline": {
            parent: "account-multiple-outline"
        },
        "people-plus": {
            parent: "account-multiple-plus"
        },
        "people-plus-outline": {
            parent: "account-multiple-plus-outline"
        },
        "people-switch": {
            parent: "account-switch"
        },
        "people-tick": {
            parent: "account-multiple-check"
        },
        "people-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        pepper: {
            parent: "chili-hot"
        },
        "pepper-off": {
            parent: "chili-off"
        },
        performance: {
            parent: "poll"
        },
        perimeter: {
            parent: "dots-circle"
        },
        "periodic-table-carbon-dioxide": {
            parent: "molecule-co2"
        },
        "periodic-table-co": {
            parent: "molecule-co"
        },
        "periodic-table-co2": {
            parent: "molecule-co2"
        },
        "perm-identity": {
            parent: "account-outline"
        },
        "perm-media": {
            parent: "folder-multiple-image"
        },
        person: {
            parent: "account"
        },
        "person-add": {
            parent: "account-plus"
        },
        "person-add-outline": {
            parent: "account-plus-outline"
        },
        "person-alert": {
            parent: "account-alert"
        },
        "person-alert-outline": {
            parent: "account-alert-outline"
        },
        "person-arrow-left": {
            parent: "account-arrow-left"
        },
        "person-arrow-left-outline": {
            parent: "account-arrow-left-outline"
        },
        "person-arrow-right": {
            parent: "account-arrow-right"
        },
        "person-arrow-right-outline": {
            parent: "account-arrow-right-outline"
        },
        "person-badge": {
            parent: "badge-account"
        },
        "person-badge-alert": {
            parent: "badge-account-alert"
        },
        "person-badge-alert-outline": {
            parent: "badge-account-alert-outline"
        },
        "person-badge-outline": {
            parent: "badge-account-outline"
        },
        "person-badge-warning": {
            parent: "badge-account-alert"
        },
        "person-badge-warning-outline": {
            parent: "badge-account-alert-outline"
        },
        "person-block": {
            parent: "account-cancel"
        },
        "person-block-outline": {
            parent: "account-cancel-outline"
        },
        "person-box": {
            parent: "account-box"
        },
        "person-box-multiple": {
            parent: "account-box-multiple"
        },
        "person-box-outline": {
            parent: "account-box-outline"
        },
        "person-boxes": {
            parent: "account-box-multiple"
        },
        "person-cancel": {
            parent: "account-cancel"
        },
        "person-cancel-outline": {
            parent: "account-cancel-outline"
        },
        "person-card-details": {
            parent: "card-account-details"
        },
        "person-card-details-outline": {
            parent: "card-account-details-outline"
        },
        "person-check": {
            parent: "account-check"
        },
        "person-check-outline": {
            parent: "account-check-outline"
        },
        "person-child": {
            parent: "account-child"
        },
        "person-child-circle": {
            parent: "account-child-circle"
        },
        "person-circle": {
            parent: "account-circle"
        },
        "person-circle-outline": {
            parent: "account-circle-outline"
        },
        "person-clock": {
            parent: "account-clock"
        },
        "person-clock-outline": {
            parent: "account-clock-outline"
        },
        "person-convert": {
            parent: "account-convert"
        },
        "person-details": {
            parent: "account-details"
        },
        "person-details-outline": {
            parent: "account-details-outline"
        },
        "person-edit": {
            parent: "account-edit"
        },
        "person-group": {
            parent: "account-group"
        },
        "person-group-outline": {
            parent: "account-group-outline"
        },
        "person-heart": {
            parent: "account-heart"
        },
        "person-heart-outline": {
            parent: "account-heart-outline"
        },
        "person-help": {
            parent: "account-question"
        },
        "person-help-outline": {
            parent: "account-question-outline"
        },
        "person-key": {
            parent: "account-key"
        },
        "person-key-outline": {
            parent: "account-key-outline"
        },
        "person-lock": {
            parent: "account-lock"
        },
        "person-lock-outline": {
            parent: "account-lock-outline"
        },
        "person-minus": {
            parent: "account-minus"
        },
        "person-minus-outline": {
            parent: "account-minus-outline"
        },
        "person-multiple": {
            parent: "account-multiple"
        },
        "person-multiple-add": {
            parent: "account-multiple-plus"
        },
        "person-multiple-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "person-multiple-check": {
            parent: "account-multiple-check"
        },
        "person-multiple-check-outline": {
            parent: "account-multiple-check-outline"
        },
        "person-multiple-minus": {
            parent: "account-multiple-minus"
        },
        "person-multiple-minus-outline": {
            parent: "account-multiple-minus-outline"
        },
        "person-multiple-plus": {
            parent: "account-multiple-plus"
        },
        "person-multiple-plus-outline": {
            parent: "account-multiple-plus-outline"
        },
        "person-multiple-remove": {
            parent: "account-multiple-remove"
        },
        "person-multiple-remove-outline": {
            parent: "account-multiple-remove-outline"
        },
        "person-multiple-tick": {
            parent: "account-multiple-check"
        },
        "person-multiple-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        "person-network": {
            parent: "account-network"
        },
        "person-network-outline": {
            parent: "account-network-outline"
        },
        "person-off": {
            parent: "account-off"
        },
        "person-off-outline": {
            parent: "account-off-outline"
        },
        "person-outline": {
            parent: "account-outline"
        },
        "person-plus": {
            parent: "account-plus"
        },
        "person-plus-outline": {
            parent: "account-plus-outline"
        },
        "person-question": {
            parent: "account-question"
        },
        "person-question-outline": {
            parent: "account-question-outline"
        },
        "person-remove": {
            parent: "account-remove"
        },
        "person-remove-outline": {
            parent: "account-remove-outline"
        },
        "person-search": {
            parent: "account-search"
        },
        "person-search-outline": {
            parent: "account-search-outline"
        },
        "person-settings": {
            parent: "account-settings"
        },
        "person-star": {
            parent: "account-star"
        },
        "person-star-outline": {
            parent: "account-star-outline"
        },
        "person-supervisor": {
            parent: "account-supervisor"
        },
        "person-supervisor-circle": {
            parent: "account-supervisor-circle"
        },
        "person-switch": {
            parent: "account-switch"
        },
        "person-tick": {
            parent: "account-check"
        },
        "person-tick-outline": {
            parent: "account-check-outline"
        },
        "person-tie": {
            parent: "account-tie"
        },
        "person-warning": {
            parent: "account-alert"
        },
        "person-warning-outline": {
            parent: "account-alert-outline"
        },
        "perspective-decrease": {
            parent: "perspective-less"
        },
        "perspective-increase": {
            parent: "perspective-more"
        },
        petrol: {
            parent: "fuel"
        },
        "petrol-pump": {
            parent: "gas-station"
        },
        "petrol-pump-outline": {
            parent: "gas-station-outline"
        },
        "petrol-station": {
            parent: "gas-station"
        },
        "petrol-station-outline": {
            parent: "gas-station-outline"
        },
        pets: {
            parent: "paw"
        },
        pharmaceutical: {
            parent: "minus-circle"
        },
        "pharmaceutical-off": {
            parent: "needle-off"
        },
        pharmacy: {
            parent: "mortar-pestle-plus"
        },
        "philippine-peso": {
            parent: "currency-php"
        },
        "phone-block": {
            parent: "phone-cancel"
        },
        "phone-bluetooth-speaker": {
            parent: "phone-bluetooth"
        },
        "phone-forwarded": {
            parent: "phone-forward"
        },
        "phone-keypad": {
            parent: "phone-dial"
        },
        "phone-keypad-outline": {
            parent: "phone-dial-outline"
        },
        "phone-locked": {
            parent: "phone-lock"
        },
        "phone-redial": {
            parent: "phone-refresh"
        },
        "phone-redial-outline": {
            parent: "phone-refresh-outline"
        },
        "phone-schedule": {
            parent: "phone-clock"
        },
        "phone-time": {
            parent: "phone-clock"
        },
        "phonelink-erase": {
            parent: "cellphone-remove"
        },
        "phonelink-lock": {
            parent: "cellphone-lock"
        },
        "phonelink-off": {
            parent: "cellphone-link-off"
        },
        "phonelink-ring": {
            parent: "cellphone-sound"
        },
        "phonelink-setup": {
            parent: "cellphone-cog"
        },
        "photo-album": {
            parent: "image-album"
        },
        "photo-camera": {
            parent: "camera"
        },
        "photo-library": {
            parent: "image-multiple"
        },
        photography: {
            parent: "camera"
        },
        picture: {
            parent: "multimedia"
        },
        "picture-360": {
            parent: "panorama-variant"
        },
        "picture-360-outline": {
            parent: "panorama-variant-outline"
        },
        "picture-vr": {
            parent: "panorama-variant"
        },
        "picture-vr-outline": {
            parent: "panorama-variant-outline"
        },
        "pill-bottle": {
            parent: "medication"
        },
        "pill-bottle-outline": {
            parent: "medication-outline"
        },
        "pill-tablet": {
            parent: "minus-circle"
        },
        "pill-tablet-outline": {
            parent: "minus-circle-outline"
        },
        "pine-tree-multiple": {
            parent: "forest"
        },
        "ping-pong": {
            parent: "table-tennis"
        },
        pinky: {
            parent: "ghost"
        },
        pint: {
            parent: "beer"
        },
        "pint-outline": {
            parent: "beer-outline"
        },
        pipette: {
            parent: "eyedropper"
        },
        "pipette-variant": {
            parent: "eyedropper-variant"
        },
        pizzeria: {
            parent: "pizza"
        },
        place: {
            parent: "map-marker"
        },
        "place-outline": {
            parent: "map-marker-outline"
        },
        "place-setting": {
            parent: "silverware-fork-knife"
        },
        plane: {
            parent: "airplane"
        },
        "plane-landing": {
            parent: "airplane-landing"
        },
        "plane-off": {
            parent: "airplane-off"
        },
        "plane-shield": {
            parent: "shield-airplane"
        },
        "plane-takeoff": {
            parent: "airplane-takeoff"
        },
        planet: {
            parent: "earth"
        },
        "planet-arrow-right": {
            parent: "earth-arrow-right"
        },
        "planet-box": {
            parent: "earth-box"
        },
        "planet-box-minus": {
            parent: "earth-box-minus"
        },
        "planet-box-off": {
            parent: "earth-box-off"
        },
        "planet-box-plus": {
            parent: "earth-box-plus"
        },
        "planet-box-remove": {
            parent: "earth-box-remove"
        },
        "planet-minus": {
            parent: "earth-minus"
        },
        "planet-off": {
            parent: "earth-off"
        },
        "planet-plus": {
            parent: "earth-plus"
        },
        "planet-remove": {
            parent: "earth-remove"
        },
        planner: {
            parent: "notebook"
        },
        "planner-multiple": {
            parent: "notebook-multiple"
        },
        "planner-outline": {
            parent: "notebook-outline"
        },
        plant: {
            parent: "flower"
        },
        "plant-outline": {
            parent: "sprout-outline"
        },
        plaster: {
            parent: "bandage"
        },
        "play-arrow": {
            parent: "play"
        },
        "play-circle-filled": {
            parent: "play-circle"
        },
        "play-room": {
            parent: "teddy-bear"
        },
        "playground-seesaw": {
            parent: "seesaw"
        },
        "playground-slide": {
            parent: "slide"
        },
        "playlist-add": {
            parent: "playlist-plus"
        },
        "playlist-add-check": {
            parent: "playlist-check"
        },
        "playlist-favorite": {
            parent: "playlist-star"
        },
        "playlist-note": {
            parent: "playlist-music"
        },
        "playlist-note-outline": {
            parent: "playlist-music-outline"
        },
        "playlist-tick": {
            parent: "playlist-check"
        },
        playstation: {
            parent: "sony-playstation"
        },
        "playstation-network": {
            parent: "sony-playstation"
        },
        plug: {
            parent: "connection"
        },
        "plug-socket": {
            parent: "power-socket"
        },
        "plug-socket-au": {
            parent: "power-socket-au"
        },
        "plug-socket-ch": {
            parent: "power-socket-ch"
        },
        "plug-socket-eu": {
            parent: "power-socket-eu"
        },
        "plug-socket-switzerland": {
            parent: "power-socket-ch"
        },
        "plug-socket-type-j": {
            parent: "power-socket-ch"
        },
        "plug-socket-uk": {
            parent: "power-socket-uk"
        },
        "plug-socket-us": {
            parent: "power-socket-us"
        },
        plugin: {
            parent: "toy-brick"
        },
        "plugin-outline": {
            parent: "toy-brick-marker-outline"
        },
        "plus-bold": {
            parent: "plus-thick"
        },
        "plus-circles-outline": {
            parent: "plus-circle-multiple-outline"
        },
        "plus-one": {
            parent: "numeric-positive-1"
        },
        "plus-secure": {
            parent: "plus-lock"
        },
        "podium-first": {
            parent: "podium-gold"
        },
        "podium-second": {
            parent: "podium-silver"
        },
        "podium-third": {
            parent: "podium-bronze"
        },
        poison: {
            parent: "bottle-tonic-skull"
        },
        "poison-outline": {
            parent: "bottle-tonic-skull-outline"
        },
        "poker-club": {
            parent: "cards-club"
        },
        "poker-diamond": {
            parent: "cards-diamond"
        },
        "poker-diamond-outline": {
            parent: "cards-diamond-outline"
        },
        "poker-heart": {
            parent: "cards-heart"
        },
        "poker-spade": {
            parent: "cards-spade"
        },
        "polar-lights": {
            parent: "aurora"
        },
        "poll-box": {
            parent: "chart-box"
        },
        "poll-box-outline": {
            parent: "chart-box-outline"
        },
        "pool-rack": {
            parent: "billiards-rack"
        },
        "pool-table": {
            parent: "billiards-rack"
        },
        "pool-temperature": {
            parent: "pool-thermometer"
        },
        "pool-triangle": {
            parent: "billiards-rack"
        },
        popsicle: {
            parent: "ice-pop"
        },
        porpoise: {
            parent: "dolphin"
        },
        portrait: {
            parent: "account-box-outline"
        },
        "post-it-note": {
            parent: "note"
        },
        "post-it-note-add": {
            parent: "note-plus"
        },
        "post-it-note-add-outline": {
            parent: "note-plus-outline"
        },
        "post-it-note-alert": {
            parent: "note-alert"
        },
        "post-it-note-alert-outline": {
            parent: "note-alert-outline"
        },
        "post-it-note-check": {
            parent: "note-check"
        },
        "post-it-note-check-outline": {
            parent: "note-check-outline"
        },
        "post-it-note-edit": {
            parent: "note-edit"
        },
        "post-it-note-edit-outline": {
            parent: "note-edit-outline"
        },
        "post-it-note-minus": {
            parent: "note-minus"
        },
        "post-it-note-minus-outline": {
            parent: "note-minus-outline"
        },
        "post-it-note-off": {
            parent: "note-off"
        },
        "post-it-note-off-outline": {
            parent: "note-off-outline"
        },
        "post-it-note-outline": {
            parent: "note-outline"
        },
        "post-it-note-plus": {
            parent: "note-plus"
        },
        "post-it-note-plus-outline": {
            parent: "note-plus-outline"
        },
        "post-it-note-remove": {
            parent: "note-remove"
        },
        "post-it-note-search": {
            parent: "note-search"
        },
        "post-it-note-search-outline": {
            parent: "note-search-outline"
        },
        "post-it-note-text": {
            parent: "note-text"
        },
        "post-it-note-text-outline": {
            parent: "note-text-outline"
        },
        "post-it-notes": {
            parent: "note-multiple"
        },
        "post-it-notes-outline": {
            parent: "note-multiple-outline"
        },
        "post-light": {
            parent: "post-lamp"
        },
        "pot-light": {
            parent: "light-recessed"
        },
        "pot-light-flat": {
            parent: "wall-sconce-flat"
        },
        "pot-light-flat-variant": {
            parent: "wall-sconce-flat-variant"
        },
        "pot-light-round": {
            parent: "wall-sconce-round"
        },
        "pot-light-round-variant": {
            parent: "wall-sconce-round-variant"
        },
        "potential-of-hydrogen": {
            parent: "ph"
        },
        "power-box": {
            parent: "exponent-box"
        },
        "power-from-grid": {
            parent: "transmission-tower-export"
        },
        "power-meter": {
            parent: "meter-electric"
        },
        "power-meter-outline": {
            parent: "meter-electric-outline"
        },
        "power-of-hydrogen": {
            parent: "ph"
        },
        "power-settings-new": {
            parent: "power"
        },
        "power-socket-ar": {
            parent: "power-socket-au"
        },
        "power-socket-argentina": {
            parent: "power-socket-au"
        },
        "power-socket-australia": {
            parent: "power-socket-au"
        },
        "power-socket-ca": {
            parent: "power-socket-us"
        },
        "power-socket-canada": {
            parent: "power-socket-us"
        },
        "power-socket-china": {
            parent: "power-socket-au"
        },
        "power-socket-cn": {
            parent: "power-socket-au"
        },
        "power-socket-cy": {
            parent: "power-socket-uk"
        },
        "power-socket-cyprus": {
            parent: "power-socket-uk"
        },
        "power-socket-europe": {
            parent: "power-socket-eu"
        },
        "power-socket-hk": {
            parent: "power-socket-uk"
        },
        "power-socket-hong-kong": {
            parent: "power-socket-uk"
        },
        "power-socket-ie": {
            parent: "power-socket-uk"
        },
        "power-socket-ireland": {
            parent: "power-socket-uk"
        },
        "power-socket-japan": {
            parent: "power-socket-us"
        },
        "power-socket-malaysia": {
            parent: "power-socket-uk"
        },
        "power-socket-malta": {
            parent: "power-socket-uk"
        },
        "power-socket-mexico": {
            parent: "power-socket-us"
        },
        "power-socket-mt": {
            parent: "power-socket-uk"
        },
        "power-socket-mx": {
            parent: "power-socket-us"
        },
        "power-socket-my": {
            parent: "power-socket-uk"
        },
        "power-socket-new-zealand": {
            parent: "power-socket-au"
        },
        "power-socket-nz": {
            parent: "power-socket-au"
        },
        "power-socket-papua-new-guinea": {
            parent: "power-socket-au"
        },
        "power-socket-pg": {
            parent: "power-socket-au"
        },
        "power-socket-sg": {
            parent: "power-socket-uk"
        },
        "power-socket-singapore": {
            parent: "power-socket-uk"
        },
        "power-socket-switzerland": {
            parent: "power-socket-ch"
        },
        "power-socket-type-b": {
            parent: "power-socket-us"
        },
        "power-socket-type-g": {
            parent: "power-socket-uk"
        },
        "power-socket-type-i": {
            parent: "power-socket-au"
        },
        "power-socket-type-j": {
            parent: "power-socket-ch"
        },
        "power-socket-united-kingdom": {
            parent: "power-socket-uk"
        },
        "power-socket-united-states": {
            parent: "power-socket-us"
        },
        "power-to-grid": {
            parent: "transmission-tower-import"
        },
        powerline: {
            parent: "transmission-tower"
        },
        "powerline-off": {
            parent: "transmission-tower-off"
        },
        pram: {
            parent: "baby-buggy"
        },
        "pram-off": {
            parent: "baby-carriage-off"
        },
        "pregnant-woman": {
            parent: "human-pregnant"
        },
        "presence-enter": {
            parent: "location-enter"
        },
        "presence-exit": {
            parent: "location-exit"
        },
        present: {
            parent: "gift"
        },
        "present-off": {
            parent: "gift-off"
        },
        "present-off-outline": {
            parent: "gift-off-outline"
        },
        "present-open": {
            parent: "gift-open"
        },
        "present-open-outline": {
            parent: "gift-open-outline"
        },
        "present-outline": {
            parent: "gift-outline"
        },
        "previous-title": {
            parent: "skip-backward"
        },
        "primary-key": {
            parent: "key-star"
        },
        "print-preview": {
            parent: "file-find"
        },
        "printer-magnify": {
            parent: "printer-search"
        },
        "printer-point-of-sale": {
            parent: "printer-pos"
        },
        "printer-preview": {
            parent: "printer-eye"
        },
        "printer-view": {
            parent: "printer-eye"
        },
        "printer-warning": {
            parent: "printer-alert"
        },
        prize: {
            parent: "license"
        },
        "progress-spanner": {
            parent: "progress-wrench"
        },
        "progress-tick": {
            parent: "progress-check"
        },
        "progress-warning": {
            parent: "progress-alert"
        },
        prohibited: {
            parent: "cancel"
        },
        "property-tag": {
            parent: "bag-personal-tag"
        },
        "property-tag-outline": {
            parent: "bag-personal-tag-outline"
        },
        protected: {
            parent: "lock"
        },
        "protected-outline": {
            parent: "lock-outline"
        },
        "proximity-sensor": {
            parent: "leak"
        },
        "proximity-sensor-off": {
            parent: "leak-off"
        },
        proxy: {
            parent: "arrow-decision"
        },
        "proxy-auto": {
            parent: "arrow-decision-auto"
        },
        "proxy-auto-outline": {
            parent: "arrow-decision-auto-outline"
        },
        "proxy-outline": {
            parent: "arrow-decision-outline"
        },
        psychology: {
            parent: "head-cog"
        },
        "psychology-outline": {
            parent: "head-cog-outline"
        },
        pub: {
            parent: "beer"
        },
        "pub-outline": {
            parent: "beer-outline"
        },
        public: {
            parent: "earth"
        },
        "publish-disabled": {
            parent: "publish-off"
        },
        puddle: {
            parent: "liquid-spot"
        },
        "pumpkin-carved": {
            parent: "halloween"
        },
        "pumpkin-face": {
            parent: "halloween"
        },
        "push-notification": {
            parent: "square-rounded-badge"
        },
        "push-notification-outline": {
            parent: "square-rounded-badge-outline"
        },
        "puzzle-favorite": {
            parent: "puzzle-star"
        },
        "puzzle-favorite-outline": {
            parent: "puzzle-star-outline"
        },
        pylon: {
            parent: "transmission-tower"
        },
        "pylon-off": {
            parent: "transmission-tower-off"
        },
        quad: {
            parent: "atv"
        },
        "query-builder": {
            parent: "clock-outline"
        },
        "question-answer": {
            parent: "forum"
        },
        "question-mark": {
            parent: "help"
        },
        "question-mark-box": {
            parent: "help-box"
        },
        "question-mark-circle": {
            parent: "help-circle"
        },
        "question-mark-circle-outline": {
            parent: "help-circle-outline"
        },
        "question-mark-rhombus": {
            parent: "help-rhombus"
        },
        "question-mark-rhombus-outline": {
            parent: "help-rhombus-outline"
        },
        "question-network": {
            parent: "help-network"
        },
        "question-network-outline": {
            parent: "help-network-outline"
        },
        queue: {
            parent: "plus-box-multiple"
        },
        "queue-music": {
            parent: "playlist-music"
        },
        "queue-music-outline": {
            parent: "playlist-music-outline"
        },
        quill: {
            parent: "feather"
        },
        radiation: {
            parent: "radioactive"
        },
        "radiation-circle": {
            parent: "radioactive-circle"
        },
        "radiation-circle-outline": {
            parent: "radioactive-circle-outline"
        },
        "radiation-off": {
            parent: "radioactive-off"
        },
        "radiator-coil": {
            parent: "heating-coil"
        },
        "radio-button-checked": {
            parent: "radiobox-marked"
        },
        "radio-button-unchecked": {
            parent: "radiobox-blank"
        },
        radiology: {
            parent: "skull-scan"
        },
        "radiology-outline": {
            parent: "skull-scan-outline"
        },
        railroad: {
            parent: "train"
        },
        "railroad-crossing-light": {
            parent: "railroad-light"
        },
        "railroad-variant": {
            parent: "train-variant"
        },
        railway: {
            parent: "fence"
        },
        "railway-electric": {
            parent: "fence-electric"
        },
        "rain-chance": {
            parent: "cloud-percent"
        },
        "rain-chance-outline": {
            parent: "cloud-percent-outline"
        },
        rainbow: {
            parent: "looks"
        },
        rancher: {
            parent: "account-cowboy-hat"
        },
        "rancher-outline": {
            parent: "account-cowboy-hat-outline"
        },
        rank: {
            parent: "chevron-triple-up"
        },
        rash: {
            parent: "allergy"
        },
        raspberrypi: {
            parent: "raspberry-pi"
        },
        raster: {
            parent: "checkerboard"
        },
        "raster-minus": {
            parent: "checkerboard-minus"
        },
        "raster-plus": {
            parent: "checkerboard-plus"
        },
        "raster-remove": {
            parent: "checkerboard-remove"
        },
        rat: {
            parent: "rodent"
        },
        "rate-review": {
            parent: "message-draw"
        },
        rca: {
            parent: "video-input-component"
        },
        rdf: {
            parent: "semantic-web"
        },
        "read-more": {
            parent: "page-next"
        },
        "read-more-outline": {
            parent: "page-next-outline"
        },
        "receipt-roll": {
            parent: "paper-roll"
        },
        "receipt-roll-outline": {
            parent: "paper-roll-outline"
        },
        "receipt-text-add": {
            parent: "receipt-text-plus"
        },
        recent: {
            parent: "history"
        },
        "record-voice-over": {
            parent: "account-voice"
        },
        "recreational-vehicle": {
            parent: "rv-truck"
        },
        "recurring-payment": {
            parent: "cash-sync"
        },
        redeem: {
            parent: "wallet-giftcard"
        },
        "refresh-automatic": {
            parent: "refresh-auto"
        },
        refrigerator: {
            parent: "fridge"
        },
        "refrigerator-bottom": {
            parent: "fridge-bottom"
        },
        "refrigerator-filled": {
            parent: "fridge"
        },
        "refrigerator-filled-bottom": {
            parent: "fridge-top"
        },
        "refrigerator-filled-top": {
            parent: "fridge-bottom"
        },
        "refrigerator-outline": {
            parent: "fridge-outline"
        },
        "refrigerator-top": {
            parent: "fridge-top"
        },
        regeneration: {
            parent: "compost"
        },
        "regenerative-agriculture": {
            parent: "compost"
        },
        register: {
            parent: "account-plus"
        },
        "register-outline": {
            parent: "account-plus-outline"
        },
        "registration-mark": {
            parent: "target"
        },
        "regular-expression": {
            parent: "regex"
        },
        "religion-buddhist": {
            parent: "dharmachakra"
        },
        "religion-christian": {
            parent: "cross"
        },
        "religion-christian-outline": {
            parent: "cross-outline"
        },
        "religion-hindu": {
            parent: "om"
        },
        "religion-islamic": {
            parent: "star-crescent"
        },
        "religion-judaic": {
            parent: "star-david"
        },
        "religion-muslim": {
            parent: "star-crescent"
        },
        remove: {
            parent: "close"
        },
        "remove-bold": {
            parent: "close-thick"
        },
        "remove-box": {
            parent: "close-box"
        },
        "remove-box-multiple": {
            parent: "close-box-multiple"
        },
        "remove-box-outline": {
            parent: "close-box-outline"
        },
        "remove-circle": {
            parent: "close-circle"
        },
        "remove-circle-multiple": {
            parent: "close-circle-multiple"
        },
        "remove-circle-multiple-outline": {
            parent: "close-circle-multiple-outline"
        },
        "remove-circle-off": {
            parent: "minus-circle-off"
        },
        "remove-circle-off-outline": {
            parent: "minus-circle-off-outline"
        },
        "remove-circle-outline": {
            parent: "close-circle-outline"
        },
        "remove-network": {
            parent: "close-network"
        },
        "remove-network-outline": {
            parent: "close-network-outline"
        },
        "remove-octagon": {
            parent: "close-octagon"
        },
        "remove-octagon-outline": {
            parent: "close-octagon-outline"
        },
        "remove-outline": {
            parent: "close-outline"
        },
        "remove-red-eye": {
            parent: "eye"
        },
        "remove-shopping-cart": {
            parent: "cart-off"
        },
        "remove-thick": {
            parent: "close-thick"
        },
        rename: {
            parent: "form-textbox"
        },
        renminbi: {
            parent: "currency-cny"
        },
        "rent-a-car": {
            parent: "car-key"
        },
        "repeat-one": {
            parent: "repeat-once"
        },
        report: {
            parent: "alert-octagon"
        },
        "report-arc": {
            parent: "chart-arc"
        },
        "report-areaspline": {
            parent: "chart-areaspline"
        },
        "report-areaspline-variant": {
            parent: "chart-areaspline-variant"
        },
        "report-bar": {
            parent: "chart-bar"
        },
        "report-bar-stacked": {
            parent: "chart-bar-stacked"
        },
        "report-bell-curve": {
            parent: "chart-bell-curve"
        },
        "report-bell-curve-cumulative": {
            parent: "chart-bell-curve-cumulative"
        },
        "report-box": {
            parent: "chart-box"
        },
        "report-box-outline": {
            parent: "chart-box-outline"
        },
        "report-box-plus-outline": {
            parent: "chart-box-plus-outline"
        },
        "report-bubble": {
            parent: "chart-bubble"
        },
        "report-donut": {
            parent: "chart-donut"
        },
        "report-donut-variant": {
            parent: "chart-donut-variant"
        },
        "report-finance": {
            parent: "finance"
        },
        "report-gantt": {
            parent: "chart-gantt"
        },
        "report-histogram": {
            parent: "chart-histogram"
        },
        "report-line": {
            parent: "chart-line"
        },
        "report-line-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "report-line-stacked": {
            parent: "chart-line-stacked"
        },
        "report-line-variant": {
            parent: "chart-line-variant"
        },
        "report-multiline": {
            parent: "chart-multiline"
        },
        "report-multiple": {
            parent: "chart-multiple"
        },
        "report-pie": {
            parent: "chart-pie"
        },
        "report-ppf": {
            parent: "chart-ppf"
        },
        "report-problem": {
            parent: "alert"
        },
        "report-sankey": {
            parent: "chart-sankey"
        },
        "report-sankey-variant": {
            parent: "chart-sankey-variant"
        },
        "report-scatter-plot": {
            parent: "chart-scatter-plot"
        },
        "report-scatter-plot-hexbin": {
            parent: "chart-scatter-plot-hexbin"
        },
        "report-timeline": {
            parent: "chart-timeline"
        },
        "report-timeline-variant": {
            parent: "chart-timeline-variant"
        },
        "report-timeline-variant-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "report-tree": {
            parent: "chart-tree"
        },
        repost: {
            parent: "repeat"
        },
        reptile: {
            parent: "snake"
        },
        required: {
            parent: "asterisk"
        },
        "required-circle": {
            parent: "asterisk-circle-outline"
        },
        reschedule: {
            parent: "calendar-arrow-left"
        },
        "resize-horizontal": {
            parent: "arrow-split-vertical"
        },
        "resize-vertical": {
            parent: "arrow-split-horizontal"
        },
        "resource-description-framework": {
            parent: "semantic-web"
        },
        restaurant: {
            parent: "silverware-fork-knife"
        },
        "restaurant-menu": {
            parent: "silverware"
        },
        "restore-clock": {
            parent: "history"
        },
        "restore-from-trash": {
            parent: "delete-restore"
        },
        "restore-page": {
            parent: "file-restore"
        },
        resume: {
            parent: "file-account"
        },
        "return-to-grid": {
            parent: "transmission-tower-import"
        },
        reverse: {
            parent: "alpha-r"
        },
        "right-to-left": {
            parent: "format-pilcrow-arrow-left"
        },
        roadmap: {
            parent: "chart-gantt"
        },
        "robber-mask": {
            parent: "domino-mask"
        },
        "robot-vacuum-error": {
            parent: "robot-vacuum-alert"
        },
        "robot-vacuum-variant-error": {
            parent: "robot-vacuum-variant-alert"
        },
        "rock-climbing": {
            parent: "carabiner"
        },
        "rocker-switch": {
            parent: "light-switch"
        },
        "rocker-switch-off": {
            parent: "light-switch-off"
        },
        "roller-shade-open": {
            parent: "blinds-open"
        },
        "rollup-js": {
            parent: "rollupjs"
        },
        room: {
            parent: "map-marker"
        },
        roomba: {
            parent: "robot-vacuum"
        },
        rostrum: {
            parent: "lectern"
        },
        "rotate-90-degrees-ccw": {
            parent: "format-rotate-90"
        },
        "rotate-clockwise": {
            parent: "reload"
        },
        "rotate-counter-clockwise": {
            parent: "restore"
        },
        royalty: {
            parent: "chess-king"
        },
        "rss-feed": {
            parent: "rss"
        },
        "rss-feed-box": {
            parent: "rss-box"
        },
        rtl: {
            parent: "format-pilcrow-arrow-left"
        },
        rubbish: {
            parent: "delete"
        },
        "rubbish-bin": {
            parent: "delete"
        },
        "rubbish-bin-circle": {
            parent: "delete-circle"
        },
        "rubbish-bin-circle-outline": {
            parent: "delete-circle-outline"
        },
        "rubbish-bin-empty": {
            parent: "delete-empty"
        },
        "rubbish-bin-outline": {
            parent: "delete-outline"
        },
        "rubbish-circle": {
            parent: "delete-circle"
        },
        "rubbish-circle-outline": {
            parent: "delete-circle-outline"
        },
        "rubbish-empty": {
            parent: "delete-empty"
        },
        "rubbish-outline": {
            parent: "delete-outline"
        },
        ruble: {
            parent: "currency-rub"
        },
        ruby: {
            parent: "language-ruby"
        },
        "ruby-horizontal": {
            parent: "furigana-horizontal"
        },
        "ruby-vertical": {
            parent: "furigana-vertical"
        },
        "rugby-ball": {
            parent: "rugby"
        },
        rum: {
            parent: "liquor"
        },
        rupee: {
            parent: "currency-inr"
        },
        "safety-belt": {
            parent: "seatbelt"
        },
        "safety-glasses": {
            parent: "safety-goggles"
        },
        "sail-boat-crash": {
            parent: "sail-boat-sink"
        },
        "sail-boat-wreck": {
            parent: "sail-boat-sink"
        },
        sailing: {
            parent: "sail-boat"
        },
        "sale-box": {
            parent: "percent-box"
        },
        "sale-box-outline": {
            parent: "percent-box-outline"
        },
        "sale-circle": {
            parent: "percent-circle"
        },
        "sale-circle-outline": {
            parent: "percent-circle-outline"
        },
        salt: {
            parent: "shaker-outline"
        },
        scan: {
            parent: "face-recognition"
        },
        schedule: {
            parent: "clock-outline"
        },
        "scheduled-maintenance": {
            parent: "wrench-clock"
        },
        "scheduled-payment": {
            parent: "cash-sync"
        },
        "school-online": {
            parent: "cast-education"
        },
        scissors: {
            parent: "content-cut"
        },
        "scooter-electric-outline": {
            parent: "moped-electric-outline"
        },
        "scooter-outline": {
            parent: "moped-outline"
        },
        score: {
            parent: "counter"
        },
        "screen-lock-rotation": {
            parent: "screen-rotation-lock"
        },
        scroll: {
            parent: "script"
        },
        "scroll-horizontal-lock": {
            parent: "arrow-horizontal-lock"
        },
        "scroll-outline": {
            parent: "script-outline"
        },
        "scroll-text": {
            parent: "script-text"
        },
        "scroll-text-outline": {
            parent: "script-text-outline"
        },
        "scroll-vertical-lock": {
            parent: "arrow-vertical-lock"
        },
        "sd-card": {
            parent: "sd"
        },
        "sd-storage": {
            parent: "sd"
        },
        "sea-level-rise": {
            parent: "waves-arrow-up"
        },
        "seal-outline": {
            parent: "certificate-outline"
        },
        search: {
            parent: "magnify"
        },
        "search-add": {
            parent: "magnify-plus"
        },
        "search-add-outline": {
            parent: "magnify-plus-outline"
        },
        "search-expand": {
            parent: "magnify-expand"
        },
        "search-globe": {
            parent: "search-web"
        },
        "search-hands-free": {
            parent: "steering"
        },
        "search-hands-free-off": {
            parent: "steering-off"
        },
        "search-minus": {
            parent: "magnify-minus"
        },
        "search-minus-outline": {
            parent: "magnify-minus-outline"
        },
        "search-plus": {
            parent: "magnify-plus"
        },
        "search-plus-outline": {
            parent: "magnify-plus-outline"
        },
        "seat-belt": {
            parent: "seatbelt"
        },
        secure: {
            parent: "lock"
        },
        "secure-outline": {
            parent: "lock-outline"
        },
        "security-account": {
            parent: "shield-account"
        },
        "security-account-outline": {
            parent: "shield-account-outline"
        },
        "security-camera": {
            parent: "cctv"
        },
        "security-camera-off": {
            parent: "cctv-off"
        },
        "security-home": {
            parent: "shield-home"
        },
        "security-lock": {
            parent: "shield-lock"
        },
        "security-lock-outline": {
            parent: "shield-lock-outline"
        },
        "security-off": {
            parent: "shield-off"
        },
        "seed-add": {
            parent: "seed-plus"
        },
        "seed-add-outline": {
            parent: "seed-plus-outline"
        },
        seedling: {
            parent: "sprout"
        },
        "seedling-outline": {
            parent: "sprout-outline"
        },
        "select-colour": {
            parent: "select-color"
        },
        "select-location": {
            parent: "select-marker"
        },
        "select-multiple-location": {
            parent: "select-multiple-marker"
        },
        "selection-invert": {
            parent: "select-inverse"
        },
        "selection-location": {
            parent: "selection-marker"
        },
        "selection-multiple-location": {
            parent: "selection-multiple-marker"
        },
        "selection-mutliple": {
            parent: "selection-multiple"
        },
        selfie: {
            parent: "account-box"
        },
        "selfie-outline": {
            parent: "account-box-outline"
        },
        "send-secure": {
            parent: "send-lock"
        },
        "sentiment-very-satisfied": {
            parent: "emoticon-outline"
        },
        "server-add": {
            parent: "server-plus"
        },
        "service-toolbox": {
            parent: "toolbox-outline"
        },
        set: {
            parent: "code-braces"
        },
        "set-and": {
            parent: "set-center"
        },
        "set-centre": {
            parent: "set-center"
        },
        "set-centre-right": {
            parent: "set-center-right"
        },
        "set-intersection": {
            parent: "set-center"
        },
        "set-left-centre": {
            parent: "set-left-center"
        },
        "set-not": {
            parent: "set-none"
        },
        "set-null": {
            parent: "set-none"
        },
        "set-or": {
            parent: "set-all"
        },
        "set-union": {
            parent: "set-all"
        },
        "set-xor": {
            parent: "set-left-right"
        },
        settings: {
            parent: "cog"
        },
        "settings-applications": {
            parent: "cog-box"
        },
        "settings-backup-restore": {
            parent: "backup-restore"
        },
        "settings-bluetooth": {
            parent: "bluetooth-settings"
        },
        "settings-box": {
            parent: "cog-box"
        },
        "settings-cell": {
            parent: "cellphone-settings"
        },
        "settings-input-antenna": {
            parent: "video-input-antenna"
        },
        "settings-input-component": {
            parent: "video-input-component"
        },
        "settings-input-composite": {
            parent: "video-input-component"
        },
        "settings-input-hdmi": {
            parent: "video-input-hdmi"
        },
        "settings-input-svideo": {
            parent: "video-input-svideo"
        },
        "settings-off": {
            parent: "cog-off"
        },
        "settings-off-outline": {
            parent: "cog-off-outline"
        },
        "settings-outline": {
            parent: "cog-outline"
        },
        "settings-pause": {
            parent: "cog-pause"
        },
        "settings-pause-outline": {
            parent: "cog-pause-outline"
        },
        "settings-phone": {
            parent: "phone-settings"
        },
        "settings-play": {
            parent: "cog-play"
        },
        "settings-play-outline": {
            parent: "cog-play-outline"
        },
        "settings-power": {
            parent: "power-settings"
        },
        "settings-refresh": {
            parent: "cog-refresh"
        },
        "settings-refresh-outline": {
            parent: "cog-refresh-outline"
        },
        "settings-remote": {
            parent: "remote"
        },
        "settings-stop": {
            parent: "cog-stop"
        },
        "settings-stop-outline": {
            parent: "cog-stop-outline"
        },
        "settings-sync": {
            parent: "cog-sync"
        },
        "settings-sync-outline": {
            parent: "cog-sync-outline"
        },
        "settings-transfer": {
            parent: "cog-transfer"
        },
        "settings-transfer-outline": {
            parent: "cog-transfer-outline"
        },
        "settings-vertical": {
            parent: "tune-vertical"
        },
        "settings-voice": {
            parent: "microphone-settings"
        },
        "shape-add": {
            parent: "shape-plus"
        },
        "shape-circle-add": {
            parent: "shape-circle-plus"
        },
        "shape-polygon-add": {
            parent: "shape-polygon-plus"
        },
        "shape-rectangle-add": {
            parent: "shape-rectangle-plus"
        },
        "shape-square-add": {
            parent: "shape-square-plus"
        },
        shed: {
            parent: "greenhouse"
        },
        "shield-add": {
            parent: "shield-plus"
        },
        "shield-add-outline": {
            parent: "shield-plus-outline"
        },
        "shield-aeroplane": {
            parent: "shield-airplane"
        },
        "shield-aeroplane-outline": {
            parent: "shield-airplane-outline"
        },
        "shield-christianity": {
            parent: "shield-cross"
        },
        "shield-christianity-outline": {
            parent: "shield-cross-outline"
        },
        "shield-favorite": {
            parent: "shield-star"
        },
        "shield-favorite-outline": {
            parent: "shield-star-outline"
        },
        "shield-house": {
            parent: "shield-home"
        },
        "shield-house-outline": {
            parent: "shield-home-outline"
        },
        "shield-person": {
            parent: "shield-account"
        },
        "shield-person-outline": {
            parent: "shield-account-outline"
        },
        "shield-plane": {
            parent: "shield-airplane"
        },
        "shield-plane-outline": {
            parent: "shield-airplane-outline"
        },
        "shield-templar": {
            parent: "shield-cross"
        },
        "shield-templar-outline": {
            parent: "shield-cross-outline"
        },
        "shield-tick": {
            parent: "shield-check"
        },
        "shield-tick-outline": {
            parent: "shield-check-outline"
        },
        "shield-unlocked": {
            parent: "shield-lock-open"
        },
        "shield-unlocked-outline": {
            parent: "shield-lock-open-outline"
        },
        "shield-user": {
            parent: "shield-account"
        },
        "shield-user-outline": {
            parent: "shield-account-outline"
        },
        "shield-warning": {
            parent: "shield-alert"
        },
        "shield-warning-outline": {
            parent: "shield-alert-outline"
        },
        ship: {
            parent: "ferry"
        },
        "shoe-running": {
            parent: "shoe-sneaker"
        },
        shop: {
            parent: "store"
        },
        "shop-24-hour": {
            parent: "store-24-hour"
        },
        "shop-alert": {
            parent: "store-alert"
        },
        "shop-alert-outline": {
            parent: "store-alert-outline"
        },
        "shop-check": {
            parent: "store-check"
        },
        "shop-check-outline": {
            parent: "store-check-outline"
        },
        "shop-clock": {
            parent: "store-clock"
        },
        "shop-clock-outline": {
            parent: "store-clock-outline"
        },
        "shop-cog-outline": {
            parent: "store-cog-outline"
        },
        "shop-complete": {
            parent: "store-check"
        },
        "shop-delete": {
            parent: "store-remove"
        },
        "shop-delete-outline": {
            parent: "store-remove-outline"
        },
        "shop-edit": {
            parent: "store-edit"
        },
        "shop-edit-outline": {
            parent: "store-edit-outline"
        },
        "shop-find": {
            parent: "store-search"
        },
        "shop-find-outline": {
            parent: "store-search-outline"
        },
        "shop-hours": {
            parent: "store-clock"
        },
        "shop-hours-outline": {
            parent: "store-clock-outline"
        },
        "shop-location": {
            parent: "store-marker"
        },
        "shop-location-outline": {
            parent: "store-marker-outline"
        },
        "shop-locator": {
            parent: "store-search"
        },
        "shop-locator-outline": {
            parent: "store-search-outline"
        },
        "shop-look-up": {
            parent: "store-search"
        },
        "shop-look-up-outline": {
            parent: "store-search-outline"
        },
        "shop-marker": {
            parent: "store-marker"
        },
        "shop-marker-outline": {
            parent: "store-marker-outline"
        },
        "shop-minus": {
            parent: "store-minus"
        },
        "shop-minus-outline": {
            parent: "store-minus-outline"
        },
        "shop-off": {
            parent: "store-off"
        },
        "shop-off-outline": {
            parent: "store-off-outline"
        },
        "shop-outline": {
            parent: "store-outline"
        },
        "shop-plus": {
            parent: "store-plus"
        },
        "shop-plus-outline": {
            parent: "store-plus-outline"
        },
        "shop-remove": {
            parent: "store-remove"
        },
        "shop-remove-outline": {
            parent: "store-remove-outline"
        },
        "shop-schedule": {
            parent: "store-clock"
        },
        "shop-schedule-outline": {
            parent: "store-clock-outline"
        },
        "shop-search": {
            parent: "store-search"
        },
        "shop-search-outline": {
            parent: "store-search-outline"
        },
        "shop-settings": {
            parent: "store-cog"
        },
        "shop-settings-outline": {
            parent: "store-cog-outline"
        },
        "shop-time": {
            parent: "store-clock"
        },
        "shop-time-outline": {
            parent: "store-clock-outline"
        },
        "shopping-basket": {
            parent: "basket"
        },
        "shopping-basket-minus": {
            parent: "basket-minus"
        },
        "shopping-basket-minus-outline": {
            parent: "basket-minus-outline"
        },
        "shopping-basket-off": {
            parent: "basket-off"
        },
        "shopping-basket-off-outline": {
            parent: "basket-off-outline"
        },
        "shopping-basket-outline": {
            parent: "basket-outline"
        },
        "shopping-basket-plus": {
            parent: "basket-plus"
        },
        "shopping-basket-plus-outline": {
            parent: "basket-plus-outline"
        },
        "shopping-basket-remove": {
            parent: "basket-remove"
        },
        "shopping-basket-remove-outline": {
            parent: "basket-remove-outline"
        },
        "shopping-cart": {
            parent: "cart"
        },
        "shopping-cart-add": {
            parent: "cart-plus"
        },
        "shopping-cart-arrow-down": {
            parent: "cart-arrow-down"
        },
        "shopping-cart-arrow-right": {
            parent: "cart-arrow-right"
        },
        "shopping-cart-arrow-up": {
            parent: "cart-arrow-up"
        },
        "shopping-cart-minus": {
            parent: "cart-minus"
        },
        "shopping-cart-off": {
            parent: "cart-off"
        },
        "shopping-cart-outline": {
            parent: "cart-outline"
        },
        "shopping-cart-plus": {
            parent: "cart-plus"
        },
        "shopping-cart-remove": {
            parent: "cart-remove"
        },
        "shopping-favorite": {
            parent: "cart-heart"
        },
        shot: {
            parent: "needle"
        },
        "shot-off": {
            parent: "needle-off"
        },
        show: {
            parent: "eye"
        },
        "show-chart": {
            parent: "chart-line-variant"
        },
        "show-outline": {
            parent: "eye-outline"
        },
        shul: {
            parent: "synagogue"
        },
        "shul-outline": {
            parent: "synagogue-outline"
        },
        shutdown: {
            parent: "power"
        },
        shuttlecock: {
            parent: "badminton"
        },
        sideboard: {
            parent: "buffet"
        },
        sign: {
            parent: "draw"
        },
        "sign-direction-add": {
            parent: "sign-direction-plus"
        },
        "sign-in": {
            parent: "login"
        },
        "sign-in-variant": {
            parent: "login-variant"
        },
        "sign-out": {
            parent: "logout"
        },
        "sign-out-variant": {
            parent: "logout-variant"
        },
        "sign-routes": {
            parent: "routes"
        },
        "signal-cellular-0": {
            parent: "signal-cellular-outline"
        },
        "signal-cellular-no-sim": {
            parent: "sim-off"
        },
        sikh: {
            parent: "khanda"
        },
        "silverware-knife": {
            parent: "knife"
        },
        "silverware-shimmer": {
            parent: "silverware-clean"
        },
        "sim-card": {
            parent: "sim"
        },
        "sim-card-alert": {
            parent: "sim-alert"
        },
        "sim-card-outline": {
            parent: "sim-outline"
        },
        "sim-warning": {
            parent: "sim-alert"
        },
        sink: {
            parent: "countertop"
        },
        "sink-outline": {
            parent: "countertop-outline"
        },
        "size-extra-extra-large": {
            parent: "size-xxl"
        },
        "size-extra-extra-small": {
            parent: "size-xxs"
        },
        "size-extra-large": {
            parent: "size-xl"
        },
        "size-extra-small": {
            parent: "size-xs"
        },
        "size-large": {
            parent: "size-l"
        },
        "size-medium": {
            parent: "size-m"
        },
        "size-small": {
            parent: "size-s"
        },
        "skew-decrease": {
            parent: "skew-less"
        },
        "skew-increase": {
            parent: "skew-more"
        },
        skip: {
            parent: "basket"
        },
        "skip-fill": {
            parent: "basket-fill"
        },
        "skip-minus": {
            parent: "basket-minus"
        },
        "skip-minus-outline": {
            parent: "basket-minus-outline"
        },
        "skip-off": {
            parent: "basket-off"
        },
        "skip-off-outline": {
            parent: "basket-off-outline"
        },
        "skip-outline": {
            parent: "basket-outline"
        },
        "skip-plus": {
            parent: "basket-plus"
        },
        "skip-plus-outline": {
            parent: "basket-plus-outline"
        },
        "skip-remove": {
            parent: "basket-remove"
        },
        "skip-remove-outline": {
            parent: "basket-remove-outline"
        },
        slate: {
            parent: "movie"
        },
        "slate-check": {
            parent: "movie-check"
        },
        "slate-check-outline": {
            parent: "movie-check-outline"
        },
        "slate-cog": {
            parent: "movie-cog"
        },
        "slate-cog-outline": {
            parent: "movie-cog-outline"
        },
        "slate-edit": {
            parent: "movie-edit"
        },
        "slate-edit-outline": {
            parent: "movie-edit-outline"
        },
        "slate-minus": {
            parent: "movie-minus"
        },
        "slate-minus-outline": {
            parent: "movie-minus-outline"
        },
        "slate-off": {
            parent: "movie-off"
        },
        "slate-off-outline": {
            parent: "movie-off-outline"
        },
        "slate-open": {
            parent: "movie-open"
        },
        "slate-open-check": {
            parent: "movie-open-check"
        },
        "slate-open-check-outline": {
            parent: "movie-open-check-outline"
        },
        "slate-open-cog": {
            parent: "movie-open-cog"
        },
        "slate-open-cog-outline": {
            parent: "movie-open-cog-outline"
        },
        "slate-open-edit": {
            parent: "movie-open-edit"
        },
        "slate-open-edit-outline": {
            parent: "movie-open-edit-outline"
        },
        "slate-open-minus": {
            parent: "movie-open-minus"
        },
        "slate-open-minus-outline": {
            parent: "movie-open-minus-outline"
        },
        "slate-open-off": {
            parent: "movie-open-off"
        },
        "slate-open-off-outline": {
            parent: "movie-open-off-outline"
        },
        "slate-open-outline": {
            parent: "movie-open-outline"
        },
        "slate-open-play": {
            parent: "movie-open-play"
        },
        "slate-open-play-outline": {
            parent: "movie-open-play-outline"
        },
        "slate-open-plus": {
            parent: "movie-open-plus"
        },
        "slate-open-plus-outline": {
            parent: "movie-open-plus-outline"
        },
        "slate-open-remove": {
            parent: "movie-open-remove"
        },
        "slate-open-remove-outline": {
            parent: "movie-open-remove-outline"
        },
        "slate-open-settings": {
            parent: "movie-open-settings"
        },
        "slate-open-settings-outline": {
            parent: "movie-open-settings-outline"
        },
        "slate-open-star": {
            parent: "movie-open-star"
        },
        "slate-open-star-outline": {
            parent: "movie-open-star-outline"
        },
        "slate-outline": {
            parent: "movie-outline"
        },
        "slate-play": {
            parent: "movie-play"
        },
        "slate-play-outline": {
            parent: "movie-play-outline"
        },
        "slate-plus": {
            parent: "movie-plus"
        },
        "slate-plus-outline": {
            parent: "movie-plus-outline"
        },
        "slate-remove": {
            parent: "movie-remove"
        },
        "slate-remove-outline": {
            parent: "movie-remove-outline"
        },
        "slate-settings": {
            parent: "movie-settings"
        },
        "slate-settings-outline": {
            parent: "movie-settings-outline"
        },
        "slate-star": {
            parent: "movie-star"
        },
        "slate-star-outline": {
            parent: "movie-star-outline"
        },
        "sleep-schedule": {
            parent: "bed-clock"
        },
        "sleep-time": {
            parent: "bed-clock"
        },
        slideshow: {
            parent: "play-box-outline"
        },
        "slippers-ballet": {
            parent: "shoe-ballet"
        },
        smartphone: {
            parent: "cellphone"
        },
        "smartphone-android": {
            parent: "cellphone-android"
        },
        "smartphone-arrow-down": {
            parent: "cellphone-arrow-down"
        },
        "smartphone-dock": {
            parent: "cellphone-dock"
        },
        "smartphone-erase": {
            parent: "cellphone-remove"
        },
        "smartphone-information": {
            parent: "cellphone-information"
        },
        "smartphone-iphone": {
            parent: "cellphone-iphone"
        },
        "smartphone-key": {
            parent: "cellphone-key"
        },
        "smartphone-link": {
            parent: "cellphone-link"
        },
        "smartphone-link-off": {
            parent: "cellphone-link-off"
        },
        "smartphone-lock": {
            parent: "cellphone-lock"
        },
        "smartphone-message": {
            parent: "cellphone-message"
        },
        "smartphone-off": {
            parent: "cellphone-off"
        },
        "smartphone-settings": {
            parent: "cellphone-settings"
        },
        "smartphone-settings-variant": {
            parent: "cellphone-cog"
        },
        "smartphone-sound": {
            parent: "cellphone-sound"
        },
        "smartphone-text": {
            parent: "cellphone-text"
        },
        "smartphone-wireless": {
            parent: "cellphone-wireless"
        },
        smartwatch: {
            parent: "devices"
        },
        smell: {
            parent: "scent"
        },
        "smell-off": {
            parent: "scent-off"
        },
        smiley: {
            parent: "emoticon"
        },
        "smiley-angry": {
            parent: "emoticon-angry"
        },
        "smiley-angry-outline": {
            parent: "emoticon-angry-outline"
        },
        "smiley-cool": {
            parent: "emoticon-cool"
        },
        "smiley-cool-outline": {
            parent: "emoticon-cool-outline"
        },
        "smiley-cry": {
            parent: "emoticon-cry"
        },
        "smiley-cry-outline": {
            parent: "emoticon-cry-outline"
        },
        "smiley-dead": {
            parent: "emoticon-dead"
        },
        "smiley-dead-outline": {
            parent: "emoticon-dead-outline"
        },
        "smiley-devil": {
            parent: "emoticon-devil"
        },
        "smiley-devil-outline": {
            parent: "emoticon-devil-outline"
        },
        "smiley-excited": {
            parent: "emoticon-excited"
        },
        "smiley-excited-outline": {
            parent: "emoticon-excited-outline"
        },
        "smiley-happy": {
            parent: "emoticon-happy"
        },
        "smiley-happy-outline": {
            parent: "emoticon-happy-outline"
        },
        "smiley-kiss": {
            parent: "emoticon-kiss"
        },
        "smiley-kiss-outline": {
            parent: "emoticon-kiss-outline"
        },
        "smiley-neutral": {
            parent: "emoticon-neutral"
        },
        "smiley-neutral-outline": {
            parent: "emoticon-neutral-outline"
        },
        "smiley-outline": {
            parent: "emoticon-outline"
        },
        "smiley-poop": {
            parent: "emoticon-poop"
        },
        "smiley-sad": {
            parent: "emoticon-sad"
        },
        "smiley-sad-outline": {
            parent: "emoticon-sad-outline"
        },
        "smiley-tongue": {
            parent: "emoticon-tongue"
        },
        "smiley-tongue-outline": {
            parent: "emoticon-tongue-outline"
        },
        "smiley-wink": {
            parent: "emoticon-wink"
        },
        "smiley-wink-outline": {
            parent: "emoticon-wink-outline"
        },
        "smoke-free": {
            parent: "smoking-off"
        },
        "smoking-area": {
            parent: "smoking"
        },
        "smoking-rooms": {
            parent: "smoking"
        },
        "smoothing-iron": {
            parent: "iron"
        },
        "smoothing-iron-outline": {
            parent: "iron-outline"
        },
        sms: {
            parent: "message-processing"
        },
        "sms-failed": {
            parent: "message-alert"
        },
        "sms-failed-outline": {
            parent: "message-alert-outline"
        },
        "snooker-rack": {
            parent: "billiards-rack"
        },
        "snooker-triangle": {
            parent: "billiards-rack"
        },
        "snow-advisory": {
            parent: "snowflake-alert"
        },
        "snowflake-approve": {
            parent: "snowflake-check"
        },
        "snowflake-temperature": {
            parent: "snowflake-thermometer"
        },
        "solar-angle": {
            parent: "sun-angle"
        },
        "solar-angle-outline": {
            parent: "sun-angle-outline"
        },
        "solar-asimuth": {
            parent: "sun-compass"
        },
        "solar-compass": {
            parent: "sun-compass"
        },
        "solar-electricity": {
            parent: "solar-panel"
        },
        "solar-electricity-outline": {
            parent: "solar-power-variant-outline"
        },
        "solar-energy": {
            parent: "solar-panel"
        },
        "solar-energy-outline": {
            parent: "solar-power-variant-outline"
        },
        "solar-panel-electricity": {
            parent: "solar-panel-large"
        },
        "solar-panel-energy": {
            parent: "solar-panel-large"
        },
        "sort-alphabetical": {
            parent: "sort-alphabetical-variant"
        },
        "sort-alphabetically": {
            parent: "sort-alphabetical-variant"
        },
        "sort-by-alpha": {
            parent: "sort-alphabetical-variant"
        },
        "sort-checkbox-ascending": {
            parent: "sort-bool-ascending-variant"
        },
        "sort-checkbox-descending": {
            parent: "sort-bool-descending-variant"
        },
        "sort-date-ascending": {
            parent: "sort-calendar-ascending"
        },
        "sort-date-descending": {
            parent: "sort-calendar-descending"
        },
        "sort-numeric": {
            parent: "sort-numeric-variant"
        },
        "sort-numerically": {
            parent: "sort-numeric-variant"
        },
        "sort-time-ascending": {
            parent: "sort-clock-ascending"
        },
        "sort-time-ascending-outline": {
            parent: "sort-clock-ascending-outline"
        },
        "sort-time-descending": {
            parent: "sort-clock-descending"
        },
        "sort-time-descending-outline": {
            parent: "sort-clock-descending-outline"
        },
        "source-repositories": {
            parent: "source-repository-multiple"
        },
        "southern-lights": {
            parent: "aurora"
        },
        "soya-sauce": {
            parent: "soy-sauce"
        },
        spaghetti: {
            parent: "pasta"
        },
        spanner: {
            parent: "wrench"
        },
        "spanner-outline": {
            parent: "wrench-outline"
        },
        sparkles: {
            parent: "shimmer"
        },
        speak: {
            parent: "account-voice"
        },
        "speaker-bar": {
            parent: "soundbar"
        },
        "speaker-notes": {
            parent: "message-bulleted"
        },
        "speaker-notes-off": {
            parent: "message-bulleted-off"
        },
        speakerphone: {
            parent: "volume-high"
        },
        "speakerphone-off": {
            parent: "volume-off"
        },
        speakers: {
            parent: "speaker-multiple"
        },
        speaking: {
            parent: "account-voice"
        },
        "sphere-diameter": {
            parent: "diameter"
        },
        "sphere-diameter-outline": {
            parent: "diameter-outline"
        },
        "sphere-diameter-variant": {
            parent: "diameter-variant"
        },
        "sphere-radius": {
            parent: "radius"
        },
        "sphere-radius-outline": {
            parent: "radius-outline"
        },
        spicy: {
            parent: "chili-hot"
        },
        "spicy-off": {
            parent: "chili-off"
        },
        spill: {
            parent: "liquid-spot"
        },
        spirits: {
            parent: "liquor"
        },
        "spoken-language": {
            parent: "translate-variant"
        },
        "sprinkler-head": {
            parent: "sprinkler-fire"
        },
        "sprinkler-mist": {
            parent: "sprinkler-fire"
        },
        spy: {
            parent: "incognito"
        },
        "spy-circle": {
            parent: "incognito-circle"
        },
        "spy-circle-off": {
            parent: "incognito-circle-off"
        },
        "spy-off": {
            parent: "incognito-off"
        },
        "sql-foreign-key": {
            parent: "key-link"
        },
        "sql-full-outer-join": {
            parent: "set-all"
        },
        "sql-inner-join": {
            parent: "set-center"
        },
        "sql-left-outer-join": {
            parent: "set-left-center"
        },
        "sql-primary-key": {
            parent: "key-star"
        },
        "sql-query": {
            parent: "database-search"
        },
        "sql-right-outer-join": {
            parent: "set-center-right"
        },
        "square-brackets": {
            parent: "code-brackets"
        },
        "square-transparent": {
            parent: "square-opacity"
        },
        squash: {
            parent: "racquetball"
        },
        stackexchange: {
            parent: "stack-exchange"
        },
        stackoverflow: {
            parent: "stack-overflow"
        },
        staff: {
            parent: "spear"
        },
        "staff-shimmer": {
            parent: "magic-staff"
        },
        "stanley-knife": {
            parent: "box-cutter"
        },
        "star-add": {
            parent: "star-plus"
        },
        "star-add-outline": {
            parent: "star-plus-outline"
        },
        "star-border": {
            parent: "star-outline"
        },
        "star-rate": {
            parent: "star"
        },
        starburst: {
            parent: "decagram"
        },
        "starburst-outline": {
            parent: "decagram-outline"
        },
        stars: {
            parent: "star-circle"
        },
        "stay-current-portrait": {
            parent: "cellphone"
        },
        "stay-primary-portrait": {
            parent: "cellphone"
        },
        stereo: {
            parent: "surround-sound-2-0"
        },
        sterling: {
            parent: "currency-gbp"
        },
        "sticky-note": {
            parent: "note"
        },
        "sticky-note-add": {
            parent: "note-plus"
        },
        "sticky-note-add-outline": {
            parent: "note-plus-outline"
        },
        "sticky-note-alert": {
            parent: "note-alert"
        },
        "sticky-note-alert-outline": {
            parent: "note-alert-outline"
        },
        "sticky-note-check": {
            parent: "note-check"
        },
        "sticky-note-check-outline": {
            parent: "note-check-outline"
        },
        "sticky-note-edit": {
            parent: "note-edit"
        },
        "sticky-note-edit-outline": {
            parent: "note-edit-outline"
        },
        "sticky-note-minus": {
            parent: "note-minus"
        },
        "sticky-note-minus-outline": {
            parent: "note-minus-outline"
        },
        "sticky-note-off": {
            parent: "note-off"
        },
        "sticky-note-off-outline": {
            parent: "note-off-outline"
        },
        "sticky-note-outline": {
            parent: "note-outline"
        },
        "sticky-note-plus": {
            parent: "note-plus"
        },
        "sticky-note-plus-outline": {
            parent: "note-plus-outline"
        },
        "sticky-note-remove": {
            parent: "note-remove"
        },
        "sticky-note-search": {
            parent: "note-search"
        },
        "sticky-note-search-outline": {
            parent: "note-search-outline"
        },
        "sticky-note-text": {
            parent: "note-text"
        },
        "sticky-note-text-outline": {
            parent: "note-text-outline"
        },
        "sticky-notes": {
            parent: "note-multiple"
        },
        "sticky-notes-outline": {
            parent: "note-multiple-outline"
        },
        "stop-alert": {
            parent: "alert-octagon"
        },
        "stop-alert-outline": {
            parent: "alert-octagon-outline"
        },
        "stop-light": {
            parent: "traffic-light"
        },
        "stop-light-outline": {
            parent: "traffic-light-outline"
        },
        "stop-outline": {
            parent: "octagon-outline"
        },
        "stop-pause": {
            parent: "pause-octagon"
        },
        "stop-pause-outline": {
            parent: "pause-octagon-outline"
        },
        "stop-remove": {
            parent: "close-octagon"
        },
        "stop-remove-outline": {
            parent: "close-octagon-outline"
        },
        stopwatch: {
            parent: "timer"
        },
        "stopwatch-add": {
            parent: "timer-plus"
        },
        "stopwatch-add-outline": {
            parent: "timer-plus-outline"
        },
        "stopwatch-alert": {
            parent: "timer-alert"
        },
        "stopwatch-alert-outline": {
            parent: "timer-alert-outline"
        },
        "stopwatch-cancel": {
            parent: "timer-cancel"
        },
        "stopwatch-cancel-outline": {
            parent: "timer-cancel-outline"
        },
        "stopwatch-check": {
            parent: "timer-check"
        },
        "stopwatch-check-outline": {
            parent: "timer-check-outline"
        },
        "stopwatch-edit": {
            parent: "timer-edit"
        },
        "stopwatch-edit-outline": {
            parent: "timer-edit-outline"
        },
        "stopwatch-favorite": {
            parent: "timer-star"
        },
        "stopwatch-favorite-outline": {
            parent: "timer-star-outline"
        },
        "stopwatch-location": {
            parent: "timer-marker"
        },
        "stopwatch-location-outline": {
            parent: "timer-marker-outline"
        },
        "stopwatch-lock": {
            parent: "timer-lock"
        },
        "stopwatch-lock-open": {
            parent: "timer-lock-open"
        },
        "stopwatch-lock-open-outline": {
            parent: "timer-lock-open-outline"
        },
        "stopwatch-lock-outline": {
            parent: "timer-lock-outline"
        },
        "stopwatch-marker": {
            parent: "timer-marker"
        },
        "stopwatch-marker-outline": {
            parent: "timer-marker-outline"
        },
        "stopwatch-minus": {
            parent: "timer-minus"
        },
        "stopwatch-minus-outline": {
            parent: "timer-minus-outline"
        },
        "stopwatch-music": {
            parent: "timer-music"
        },
        "stopwatch-music-outline": {
            parent: "timer-music-outline"
        },
        "stopwatch-off": {
            parent: "timer-off"
        },
        "stopwatch-off-outline": {
            parent: "timer-off-outline"
        },
        "stopwatch-outline": {
            parent: "timer-outline"
        },
        "stopwatch-pause": {
            parent: "timer-pause"
        },
        "stopwatch-pause-outline": {
            parent: "timer-pause-outline"
        },
        "stopwatch-play": {
            parent: "timer-play"
        },
        "stopwatch-play-outline": {
            parent: "timer-play-outline"
        },
        "stopwatch-plus": {
            parent: "timer-plus"
        },
        "stopwatch-plus-outline": {
            parent: "timer-plus-outline"
        },
        "stopwatch-refresh": {
            parent: "timer-refresh"
        },
        "stopwatch-refresh-outline": {
            parent: "timer-refresh-outline"
        },
        "stopwatch-remove": {
            parent: "timer-remove"
        },
        "stopwatch-remove-outline": {
            parent: "timer-remove-outline"
        },
        "stopwatch-secure": {
            parent: "timer-lock"
        },
        "stopwatch-secure-outline": {
            parent: "timer-lock-outline"
        },
        "stopwatch-star": {
            parent: "timer-star"
        },
        "stopwatch-star-outline": {
            parent: "timer-star-outline"
        },
        "stopwatch-start": {
            parent: "timer-play"
        },
        "stopwatch-start-outline": {
            parent: "timer-play-outline"
        },
        "stopwatch-stop": {
            parent: "timer-stop"
        },
        "stopwatch-stop-outline": {
            parent: "timer-stop-outline"
        },
        "stopwatch-subtract": {
            parent: "timer-minus"
        },
        "stopwatch-subtract-outline": {
            parent: "timer-minus-outline"
        },
        "stopwatch-sync": {
            parent: "timer-sync"
        },
        "stopwatch-sync-outline": {
            parent: "timer-sync-outline"
        },
        "stopwatch-tick": {
            parent: "timer-check"
        },
        "stopwatch-tick-outline": {
            parent: "timer-check-outline"
        },
        storage: {
            parent: "database"
        },
        "store-complete": {
            parent: "store-check"
        },
        "store-complete-outline": {
            parent: "store-check-outline"
        },
        "store-delete": {
            parent: "store-remove"
        },
        "store-delete-outline": {
            parent: "store-remove-outline"
        },
        "store-find": {
            parent: "store-search"
        },
        "store-find-outline": {
            parent: "store-search-outline"
        },
        "store-hours": {
            parent: "store-clock"
        },
        "store-hours-outline": {
            parent: "store-clock-outline"
        },
        "store-location": {
            parent: "store-marker"
        },
        "store-location-outline": {
            parent: "store-marker-outline"
        },
        "store-locator": {
            parent: "store-search"
        },
        "store-locator-outline": {
            parent: "store-search-outline"
        },
        "store-look-up": {
            parent: "store-search"
        },
        "store-look-up-outline": {
            parent: "store-search-outline"
        },
        "store-mall-directory": {
            parent: "store"
        },
        "store-mall-directory-outline": {
            parent: "store-outline"
        },
        "store-schedule": {
            parent: "store-clock"
        },
        "store-schedule-outline": {
            parent: "store-clock-outline"
        },
        "store-time": {
            parent: "store-clock"
        },
        "store-time-outline": {
            parent: "store-clock-outline"
        },
        storm: {
            parent: "lightning-bolt"
        },
        "storm-advisory": {
            parent: "flash-alert"
        },
        "storm-advisory-outline": {
            parent: "flash-alert-outline"
        },
        "storm-circle": {
            parent: "lightning-bolt-circle"
        },
        "storm-outline": {
            parent: "lightning-bolt-outline"
        },
        "stove-burner": {
            parent: "gas-burner"
        },
        "strikethrough-s": {
            parent: "format-strikethrough-variant"
        },
        stroller: {
            parent: "baby-buggy"
        },
        "stroller-off": {
            parent: "baby-carriage-off"
        },
        "study-chair": {
            parent: "chair-rolling"
        },
        style: {
            parent: "palette-swatch"
        },
        "style-outline": {
            parent: "palette-swatch-outline"
        },
        "subscriber-identification-module": {
            parent: "sim"
        },
        "subscriber-identification-module-outline": {
            parent: "sim-outline"
        },
        "subscriber-identity-module": {
            parent: "sim"
        },
        "subscriber-identity-module-outline": {
            parent: "sim-outline"
        },
        subscriptions: {
            parent: "playlist-check"
        },
        subtasks: {
            parent: "file-tree"
        },
        "subway-warning-variant": {
            parent: "subway-alert-variant"
        },
        subwoofer: {
            parent: "smoke-detector"
        },
        sugar: {
            parent: "cube-outline"
        },
        "sugar-cube": {
            parent: "cube-outline"
        },
        "sugar-cube-off": {
            parent: "cube-off-outline"
        },
        "sugar-free": {
            parent: "cube-off-outline"
        },
        "sugar-off": {
            parent: "cube-off-outline"
        },
        "suit-clubs": {
            parent: "cards-club"
        },
        "suit-diamonds": {
            parent: "cards-diamond"
        },
        "suit-hearts": {
            parent: "cards-heart"
        },
        "suit-spades": {
            parent: "cards-spade"
        },
        summation: {
            parent: "sigma"
        },
        "sun-advisory": {
            parent: "weather-sunny-alert"
        },
        "sun-azimuth": {
            parent: "sun-compass"
        },
        "sun-moon-stars": {
            parent: "theme-light-dark"
        },
        "sun-protection": {
            parent: "shield-sun"
        },
        "sun-protection-outline": {
            parent: "shield-sun-outline"
        },
        "sun-schedule": {
            parent: "sun-clock"
        },
        "sun-schedule-outline": {
            parent: "sun-clock-outline"
        },
        "sun-shade": {
            parent: "awning"
        },
        "sun-shade-outline": {
            parent: "awning-outline"
        },
        "sun-temperature": {
            parent: "sun-thermometer"
        },
        "sun-time": {
            parent: "sun-clock"
        },
        "sun-time-outline": {
            parent: "sun-clock-outline"
        },
        sunrise: {
            parent: "weather-sunset-up"
        },
        "super-chat-for-good": {
            parent: "charity"
        },
        support: {
            parent: "face-agent"
        },
        "surface-area": {
            parent: "texture-box"
        },
        "suspended-light": {
            parent: "chandelier"
        },
        "swap-calls": {
            parent: "swap-vertical-variant"
        },
        "swap-driving-apps-wheel": {
            parent: "gauge"
        },
        swatch: {
            parent: "receipt"
        },
        "swatch-outline": {
            parent: "receipt-outline"
        },
        "swim-dive": {
            parent: "diving"
        },
        "swimming-pool": {
            parent: "pool"
        },
        "swiss-cheese": {
            parent: "cheese"
        },
        "swiss-cross": {
            parent: "hospital"
        },
        "swiss-cross-box": {
            parent: "hospital-box"
        },
        "swiss-cross-box-outline": {
            parent: "hospital-box-outline"
        },
        "switch-account": {
            parent: "account-box-multiple"
        },
        "switch-camera": {
            parent: "camera-switch"
        },
        "switch-video": {
            parent: "video-switch"
        },
        "sword-fight": {
            parent: "fencing"
        },
        "syllabary-katakana-half-width": {
            parent: "syllabary-katakana-halfwidth"
        },
        "sync-disabled": {
            parent: "sync-off"
        },
        "sync-problem": {
            parent: "sync-alert"
        },
        "sync-warning": {
            parent: "sync-alert"
        },
        syringe: {
            parent: "needle"
        },
        "syringe-off": {
            parent: "needle-off"
        },
        "t-rex": {
            parent: "google-downasaur"
        },
        "t-shirt-crew": {
            parent: "tshirt-crew"
        },
        "t-shirt-crew-outline": {
            parent: "tshirt-crew-outline"
        },
        "t-shirt-v": {
            parent: "tshirt-v"
        },
        "t-shirt-v-outline": {
            parent: "tshirt-v-outline"
        },
        "tab-add": {
            parent: "tab-plus"
        },
        "tab-find": {
            parent: "tab-search"
        },
        "table-add": {
            parent: "table-plus"
        },
        "table-column-add-after": {
            parent: "table-column-plus-after"
        },
        "table-column-add-before": {
            parent: "table-column-plus-before"
        },
        "table-download": {
            parent: "table-arrow-down"
        },
        "table-export": {
            parent: "table-arrow-right"
        },
        "table-favorite": {
            parent: "table-heart"
        },
        "table-help": {
            parent: "table-question"
        },
        "table-import": {
            parent: "table-arrow-left"
        },
        "table-large-add": {
            parent: "table-large-plus"
        },
        "table-row-add-after": {
            parent: "table-row-plus-after"
        },
        "table-row-add-before": {
            parent: "table-row-plus-before"
        },
        "table-share": {
            parent: "table-arrow-right"
        },
        "table-upload": {
            parent: "table-arrow-up"
        },
        "table-user": {
            parent: "table-account"
        },
        "tablet-mac": {
            parent: "tablet-ipad"
        },
        "tablet-mobile-phone": {
            parent: "tablet-cellphone"
        },
        "tablet-smartphone": {
            parent: "tablet-cellphone"
        },
        "tag-add": {
            parent: "tag-plus"
        },
        "tag-approve": {
            parent: "tag-check"
        },
        "tag-approve-outline": {
            parent: "tag-check-outline"
        },
        "tag-emoji": {
            parent: "tag-faces"
        },
        "tag-emoticon": {
            parent: "tag-faces"
        },
        "tag-find": {
            parent: "tag-search"
        },
        "tag-find-outline": {
            parent: "tag-search-outline"
        },
        tags: {
            parent: "tag-multiple"
        },
        taka: {
            parent: "currency-bdt"
        },
        talk: {
            parent: "account-voice"
        },
        talking: {
            parent: "account-voice"
        },
        tanker: {
            parent: "tanker-truck"
        },
        taoism: {
            parent: "yin-yang"
        },
        tap: {
            parent: "water-pump"
        },
        "tap-off": {
            parent: "water-pump-off"
        },
        tape: {
            parent: "cassette"
        },
        "target-arrow": {
            parent: "bullseye-arrow"
        },
        "target-user": {
            parent: "target-account"
        },
        "task-add": {
            parent: "checkbox-marked-circle-plus-outline"
        },
        "task-plus": {
            parent: "checkbox-marked-circle-plus-outline"
        },
        "tea-kettle": {
            parent: "kettle"
        },
        "tea-kettle-alert": {
            parent: "kettle-alert"
        },
        "tea-kettle-alert-outline": {
            parent: "kettle-alert-outline"
        },
        "tea-kettle-empty": {
            parent: "kettle-outline"
        },
        "tea-kettle-empty-alert": {
            parent: "kettle-alert-outline"
        },
        "tea-kettle-empty-off": {
            parent: "kettle-off-outline"
        },
        "tea-kettle-empty-steam": {
            parent: "kettle-steam-outline"
        },
        "tea-kettle-full": {
            parent: "kettle"
        },
        "tea-kettle-full-alert": {
            parent: "kettle-alert"
        },
        "tea-kettle-full-off": {
            parent: "kettle-off"
        },
        "tea-kettle-full-steam": {
            parent: "kettle-steam"
        },
        "tea-kettle-off": {
            parent: "kettle-off"
        },
        "tea-kettle-off-outline": {
            parent: "kettle-off-outline"
        },
        "tea-kettle-outline": {
            parent: "kettle-outline"
        },
        "tea-kettle-steam": {
            parent: "kettle-steam"
        },
        "tea-kettle-steam-outline": {
            parent: "kettle-steam-outline"
        },
        "tea-off": {
            parent: "coffee-off"
        },
        "tea-off-outline": {
            parent: "coffee-off-outline"
        },
        "tea-to-go": {
            parent: "coffee-to-go"
        },
        "tea-to-go-outline": {
            parent: "coffee-to-go-outline"
        },
        teach: {
            parent: "human-male-board"
        },
        "teach-poll": {
            parent: "human-male-board-poll"
        },
        teacher: {
            parent: "human-male-board"
        },
        teaching: {
            parent: "human-male-board"
        },
        telecoil: {
            parent: "ear-hearing-loop"
        },
        teleconference: {
            parent: "laptop-account"
        },
        telephone: {
            parent: "phone"
        },
        "telephone-bluetooth": {
            parent: "phone-bluetooth"
        },
        "telephone-forward": {
            parent: "phone-forward"
        },
        "telephone-hangup": {
            parent: "phone-hangup"
        },
        "telephone-in-talk": {
            parent: "phone-in-talk"
        },
        "telephone-in-talk-outline": {
            parent: "phone-in-talk-outline"
        },
        "telephone-incoming": {
            parent: "phone-incoming"
        },
        "telephone-lock": {
            parent: "phone-lock"
        },
        "telephone-locked": {
            parent: "phone-lock"
        },
        "telephone-outline": {
            parent: "phone-outline"
        },
        "television-clean": {
            parent: "television-shimmer"
        },
        temperature: {
            parent: "thermometer"
        },
        "temperature-add": {
            parent: "thermometer-plus"
        },
        "temperature-alert": {
            parent: "thermometer-alert"
        },
        "temperature-approve": {
            parent: "thermometer-check"
        },
        "temperature-auto": {
            parent: "thermometer-auto"
        },
        "temperature-bluetooth": {
            parent: "thermometer-bluetooth"
        },
        "temperature-centigrade": {
            parent: "temperature-celsius"
        },
        "temperature-check": {
            parent: "thermometer-check"
        },
        "temperature-chevron-down": {
            parent: "thermometer-chevron-down"
        },
        "temperature-chevron-up": {
            parent: "thermometer-chevron-up"
        },
        "temperature-decrease": {
            parent: "thermometer-chevron-down"
        },
        "temperature-high": {
            parent: "thermometer-high"
        },
        "temperature-increase": {
            parent: "thermometer-chevron-up"
        },
        "temperature-lines": {
            parent: "thermometer-lines"
        },
        "temperature-low": {
            parent: "thermometer-low"
        },
        "temperature-minus": {
            parent: "thermometer-minus"
        },
        "temperature-off": {
            parent: "thermometer-off"
        },
        "temperature-plus": {
            parent: "thermometer-plus"
        },
        "temperature-warning": {
            parent: "thermometer-alert"
        },
        temple: {
            parent: "synagogue"
        },
        "temple-outline": {
            parent: "synagogue-outline"
        },
        tempo: {
            parent: "metronome"
        },
        "tempo-tick": {
            parent: "metronome-tick"
        },
        "tennis-racket": {
            parent: "tennis"
        },
        "tennis-racquet": {
            parent: "tennis"
        },
        tequila: {
            parent: "liquor"
        },
        terminal: {
            parent: "console"
        },
        "terminal-line": {
            parent: "console-line"
        },
        "terminal-network": {
            parent: "console-network"
        },
        "terminal-network-outline": {
            parent: "console-network-outline"
        },
        terrace: {
            parent: "balcony"
        },
        "text-subject": {
            parent: "text-long"
        },
        "text-to-speech": {
            parent: "microphone-message"
        },
        "text-to-speech-off": {
            parent: "microphone-message-off"
        },
        "text-user": {
            parent: "text-account"
        },
        textarea: {
            parent: "form-textarea"
        },
        textbox: {
            parent: "form-textbox"
        },
        "textbox-lock": {
            parent: "form-textbox-lock"
        },
        "textbox-password": {
            parent: "form-textbox-password"
        },
        textsms: {
            parent: "message-processing"
        },
        thanksgiving: {
            parent: "food-turkey"
        },
        "thanksgiving-dinner": {
            parent: "food-turkey"
        },
        theaters: {
            parent: "filmstrip"
        },
        theatre: {
            parent: "drama-masks"
        },
        theme: {
            parent: "shape"
        },
        "theme-outline": {
            parent: "shape-outline"
        },
        "thermometer-add": {
            parent: "thermometer-plus"
        },
        "thermometer-approve": {
            parent: "thermometer-check"
        },
        "thermometer-decrease": {
            parent: "thermometer-chevron-down"
        },
        "thermometer-increase": {
            parent: "thermometer-chevron-up"
        },
        "thermometer-warning": {
            parent: "thermometer-alert"
        },
        "think-outline": {
            parent: "thought-bubble-outline"
        },
        thinking: {
            parent: "thought-bubble"
        },
        "thinking-outline": {
            parent: "thought-bubble-outline"
        },
        "this-side-down": {
            parent: "archive-arrow-down"
        },
        "this-side-down-outline": {
            parent: "archive-arrow-down-outline"
        },
        "this-side-up": {
            parent: "archive-arrow-up"
        },
        "this-side-up-outline": {
            parent: "archive-arrow-up-outline"
        },
        three: {
            parent: "tally-mark-3"
        },
        "thumbs-down": {
            parent: "thumb-down"
        },
        "thumbs-down-outline": {
            parent: "thumb-down-outline"
        },
        "thumbs-up": {
            parent: "thumb-up"
        },
        "thumbs-up-outline": {
            parent: "thumb-up-outline"
        },
        thunder: {
            parent: "lightning-bolt"
        },
        "thunder-circle": {
            parent: "lightning-bolt-circle"
        },
        "thunder-outline": {
            parent: "lightning-bolt-outline"
        },
        tick: {
            parent: "check"
        },
        "tick-all": {
            parent: "check-all"
        },
        "tick-box-multiple-outline": {
            parent: "checkbox-multiple-outline"
        },
        "tick-circle": {
            parent: "check-circle"
        },
        "tick-circle-outline": {
            parent: "check-circle-outline"
        },
        "tick-decagram": {
            parent: "check-decagram"
        },
        "tick-network": {
            parent: "check-network"
        },
        "tick-network-outline": {
            parent: "check-network-outline"
        },
        "tick-outline": {
            parent: "check-outline"
        },
        "ticket-user": {
            parent: "ticket-account"
        },
        ticks: {
            parent: "check-all"
        },
        "tide-in": {
            parent: "waves-arrow-left"
        },
        "tide-out": {
            parent: "waves-arrow-right"
        },
        till: {
            parent: "cash-register"
        },
        "time-of-day": {
            parent: "sun-clock"
        },
        "time-of-day-outline": {
            parent: "sun-clock-outline"
        },
        "time-to-leave": {
            parent: "car"
        },
        "timeline-help": {
            parent: "timeline-question"
        },
        "timeline-help-outline": {
            parent: "timeline-question-outline"
        },
        "timer-add": {
            parent: "timer-plus"
        },
        "timer-add-outline": {
            parent: "timer-plus-outline"
        },
        "timer-favorite": {
            parent: "timer-star"
        },
        "timer-favorite-outline": {
            parent: "timer-star-outline"
        },
        "timer-location": {
            parent: "timer-marker"
        },
        "timer-location-outline": {
            parent: "timer-marker-outline"
        },
        "timer-secure": {
            parent: "timer-lock"
        },
        "timer-secure-outline": {
            parent: "timer-lock-outline"
        },
        "timer-start": {
            parent: "timer-play"
        },
        "timer-start-outline": {
            parent: "timer-play-outline"
        },
        "timer-subtract": {
            parent: "timer-minus"
        },
        "timer-subtract-outline": {
            parent: "timer-minus-outline"
        },
        "timer-ten": {
            parent: "timer-10"
        },
        "timer-three": {
            parent: "timer-3"
        },
        "timer-tick": {
            parent: "timer-check"
        },
        "timer-tick-outline": {
            parent: "timer-check-outline"
        },
        timezone: {
            parent: "map-clock"
        },
        "timezone-outline": {
            parent: "map-clock-outline"
        },
        "tipper-lorry": {
            parent: "dump-truck"
        },
        "title-backward": {
            parent: "skip-backward"
        },
        "title-forward": {
            parent: "skip-forward"
        },
        tm: {
            parent: "trademark"
        },
        "to-do": {
            parent: "format-list-checks"
        },
        toc: {
            parent: "table-of-contents"
        },
        "todo-add": {
            parent: "checkbox-marked-circle-plus-outline"
        },
        "todo-plus": {
            parent: "checkbox-marked-circle-plus-outline"
        },
        "toilet-paper": {
            parent: "paper-roll"
        },
        "toilet-paper-outline": {
            parent: "paper-roll-outline"
        },
        toll: {
            parent: "circle-multiple-outline"
        },
        tombstone: {
            parent: "grave-stone"
        },
        "tool-clock": {
            parent: "wrench-clock"
        },
        "tool-time": {
            parent: "wrench-clock"
        },
        "tooltip-add": {
            parent: "tooltip-plus"
        },
        "tooltip-add-outline": {
            parent: "tooltip-plus-outline"
        },
        "tooltip-help": {
            parent: "tooltip-question"
        },
        "tooltip-help-outline": {
            parent: "tooltip-question-outline"
        },
        "tooltip-outline-plus": {
            parent: "tooltip-plus-outline"
        },
        "tooltip-person": {
            parent: "tooltip-account"
        },
        "tooltip-user": {
            parent: "tooltip-account"
        },
        toque: {
            parent: "chef-hat"
        },
        "torch-off": {
            parent: "flashlight-off"
        },
        "touch-reading": {
            parent: "braille"
        },
        towing: {
            parent: "tow-truck"
        },
        "toy-brick-location": {
            parent: "toy-brick-marker"
        },
        "toy-brick-location-outline": {
            parent: "toy-brick-marker-outline"
        },
        toys: {
            parent: "pinwheel"
        },
        "toys-outline": {
            parent: "pinwheel-outline"
        },
        "track-changes": {
            parent: "radar"
        },
        "traffic-signal": {
            parent: "traffic-light"
        },
        "traffic-signal-outline": {
            parent: "traffic-light-outline"
        },
        tragedy: {
            parent: "drama-masks"
        },
        "train-crossing-light": {
            parent: "railroad-light"
        },
        "train-track": {
            parent: "fence"
        },
        "train-track-electric": {
            parent: "fence-electric"
        },
        "trans-fat": {
            parent: "water"
        },
        "trans-fat-off": {
            parent: "water-off"
        },
        "trans-fat-off-outline": {
            parent: "water-off-outline"
        },
        "transfer-within-a-station": {
            parent: "transit-transfer"
        },
        transportation: {
            parent: "train-car"
        },
        trash: {
            parent: "delete"
        },
        "trash-can-circle": {
            parent: "delete-circle"
        },
        "trash-can-circle-outline": {
            parent: "delete-circle-outline"
        },
        "trash-can-empty": {
            parent: "delete-empty"
        },
        "trash-circle": {
            parent: "delete-circle"
        },
        "trash-circle-outline": {
            parent: "delete-circle-outline"
        },
        "trash-empty": {
            parent: "delete-empty"
        },
        "trash-outline": {
            parent: "delete-outline"
        },
        "trash-restore": {
            parent: "delete-restore"
        },
        "trash-variant": {
            parent: "delete-variant"
        },
        trashcan: {
            parent: "trash-can"
        },
        "trashcan-outline": {
            parent: "trash-can-outline"
        },
        travel: {
            parent: "train-car"
        },
        "tray-download": {
            parent: "tray-arrow-down"
        },
        "tray-upload": {
            parent: "tray-arrow-up"
        },
        treat: {
            parent: "candy"
        },
        "treat-off": {
            parent: "candy-off"
        },
        "treat-off-outline": {
            parent: "candy-off-outline"
        },
        "treat-outline": {
            parent: "candy-outline"
        },
        "trending-down-variant": {
            parent: "triangle-small-down"
        },
        "trending-flat": {
            parent: "trending-neutral"
        },
        "trending-up-variant": {
            parent: "triangle-small-up"
        },
        trike: {
            parent: "atv"
        },
        trolley: {
            parent: "cart"
        },
        "trolley-add": {
            parent: "cart-plus"
        },
        "trolley-arrow-down": {
            parent: "cart-arrow-down"
        },
        "trolley-arrow-right": {
            parent: "cart-arrow-right"
        },
        "trolley-arrow-up": {
            parent: "cart-arrow-up"
        },
        "trolley-minus": {
            parent: "cart-minus"
        },
        "trolley-off": {
            parent: "cart-off"
        },
        "trolley-outline": {
            parent: "cart-outline"
        },
        "trolley-percent": {
            parent: "cart-percent"
        },
        "trolley-plus": {
            parent: "cart-plus"
        },
        "trolley-remove": {
            parent: "cart-remove"
        },
        "truck-add": {
            parent: "truck-plus"
        },
        "truck-add-outline": {
            parent: "truck-plus-outline"
        },
        "truck-error": {
            parent: "truck-alert"
        },
        "truck-error-outline": {
            parent: "truck-alert-outline"
        },
        "truck-flatbed-tow": {
            parent: "truck-flatbed"
        },
        "truck-freezer": {
            parent: "truck-snowflake"
        },
        "truck-refrigerator": {
            parent: "truck-snowflake"
        },
        "truck-shipping": {
            parent: "truck-cargo-container"
        },
        "truck-subtract": {
            parent: "truck-minus"
        },
        "truck-subtract-outline": {
            parent: "truck-minus-outline"
        },
        "truck-tick": {
            parent: "truck-check"
        },
        tts: {
            parent: "microphone-message"
        },
        "tts-off": {
            parent: "microphone-message-off"
        },
        tube: {
            parent: "subway"
        },
        "tube-variant": {
            parent: "subway-variant"
        },
        tuner: {
            parent: "knob"
        },
        "turkey-leg": {
            parent: "food-drumstick"
        },
        "turkey-leg-off": {
            parent: "food-drumstick-off"
        },
        "turkey-leg-off-outline": {
            parent: "food-drumstick-off-outline"
        },
        "turkey-leg-outline": {
            parent: "food-drumstick-outline"
        },
        "turn-left": {
            parent: "arrow-left-top"
        },
        "turn-left-bold": {
            parent: "arrow-left-top-bold"
        },
        "turn-right": {
            parent: "arrow-right-top"
        },
        "turn-right-bold": {
            parent: "arrow-right-top-bold"
        },
        "turned-in": {
            parent: "bookmark"
        },
        "turned-in-not": {
            parent: "bookmark-outline"
        },
        tux: {
            parent: "linux"
        },
        tv: {
            parent: "television"
        },
        "tv-box": {
            parent: "television-box"
        },
        "tv-classic": {
            parent: "television-classic"
        },
        "tv-classic-off": {
            parent: "television-classic-off"
        },
        "tv-guide": {
            parent: "television-box"
        },
        "tv-off": {
            parent: "television-off"
        },
        "twitter-retweet": {
            parent: "repeat-variant"
        },
        two: {
            parent: "tally-mark-2"
        },
        "two-wheeler": {
            parent: "atv"
        },
        "tyrannosaurus-rex": {
            parent: "google-downasaur"
        },
        tyre: {
            parent: "tire"
        },
        "u-turn-left": {
            parent: "arrow-u-down-left"
        },
        "u-turn-left-bold": {
            parent: "arrow-u-down-left-bold"
        },
        "u-turn-right": {
            parent: "arrow-u-down-right"
        },
        "u-turn-right-bold": {
            parent: "arrow-u-down-right-bold"
        },
        uhd: {
            parent: "ultra-high-definition"
        },
        ultraviolet: {
            parent: "sun-wireless"
        },
        "ultraviolet-outline": {
            parent: "sun-wireless-outline"
        },
        unarchive: {
            parent: "package-up"
        },
        underground: {
            parent: "subway"
        },
        "underground-variant": {
            parent: "subway-variant"
        },
        underwear: {
            parent: "lingerie"
        },
        "unidentified-flying-object": {
            parent: "ufo"
        },
        "unidentified-flying-object-outline": {
            parent: "ufo-outline"
        },
        university: {
            parent: "school"
        },
        "university-outline": {
            parent: "school-outline"
        },
        unlocked: {
            parent: "lock-open"
        },
        "unlocked-add": {
            parent: "lock-open-plus"
        },
        "unlocked-add-outline": {
            parent: "lock-open-plus-outline"
        },
        "unlocked-alert": {
            parent: "lock-open-alert"
        },
        "unlocked-alert-outline": {
            parent: "lock-open-alert-outline"
        },
        "unlocked-check": {
            parent: "lock-open-check"
        },
        "unlocked-check-outline": {
            parent: "lock-open-check-outline"
        },
        "unlocked-minus": {
            parent: "lock-open-minus"
        },
        "unlocked-minus-outline": {
            parent: "lock-open-minus-outline"
        },
        "unlocked-outline": {
            parent: "lock-open-outline"
        },
        "unlocked-plus": {
            parent: "lock-open-plus"
        },
        "unlocked-plus-outline": {
            parent: "lock-open-plus-outline"
        },
        "unlocked-remove": {
            parent: "lock-open-remove"
        },
        "unlocked-remove-outline": {
            parent: "lock-open-remove-outline"
        },
        "unlocked-variant": {
            parent: "lock-open-variant"
        },
        "unlocked-variant-outline": {
            parent: "lock-open-variant-outline"
        },
        "unlocked-warning": {
            parent: "lock-open-alert"
        },
        "unlocked-warning-outline": {
            parent: "lock-open-alert-outline"
        },
        "unreal-engine": {
            parent: "unreal"
        },
        unsecure: {
            parent: "lock-off"
        },
        "unsecure-outline": {
            parent: "lock-off-outline"
        },
        unwrap: {
            parent: "wrap-disabled"
        },
        uplay: {
            parent: "ubisoft"
        },
        uploads: {
            parent: "upload-multiple"
        },
        user: {
            parent: "account"
        },
        "user-add": {
            parent: "account-plus"
        },
        "user-add-outline": {
            parent: "account-plus-outline"
        },
        "user-alert": {
            parent: "account-alert"
        },
        "user-alert-outline": {
            parent: "account-alert-outline"
        },
        "user-arrow-left": {
            parent: "account-arrow-left"
        },
        "user-arrow-left-outline": {
            parent: "account-arrow-left-outline"
        },
        "user-arrow-right": {
            parent: "account-arrow-right"
        },
        "user-arrow-right-outline": {
            parent: "account-arrow-right-outline"
        },
        "user-badge": {
            parent: "badge-account"
        },
        "user-badge-alert": {
            parent: "badge-account-alert"
        },
        "user-badge-alert-outline": {
            parent: "badge-account-alert-outline"
        },
        "user-badge-outline": {
            parent: "badge-account-outline"
        },
        "user-badge-warning": {
            parent: "badge-account-alert"
        },
        "user-badge-warning-outline": {
            parent: "badge-account-alert-outline"
        },
        "user-block": {
            parent: "account-cancel"
        },
        "user-block-outline": {
            parent: "account-cancel-outline"
        },
        "user-box": {
            parent: "account-box"
        },
        "user-box-multiple": {
            parent: "account-box-multiple"
        },
        "user-box-outline": {
            parent: "account-box-outline"
        },
        "user-boxes": {
            parent: "account-box-multiple"
        },
        "user-cancel": {
            parent: "account-cancel"
        },
        "user-cancel-outline": {
            parent: "account-cancel-outline"
        },
        "user-card-details": {
            parent: "card-account-details"
        },
        "user-card-details-outline": {
            parent: "card-account-details-outline"
        },
        "user-check": {
            parent: "account-check"
        },
        "user-check-outline": {
            parent: "account-check-outline"
        },
        "user-child": {
            parent: "account-child"
        },
        "user-child-circle": {
            parent: "account-child-circle"
        },
        "user-circle": {
            parent: "account-circle"
        },
        "user-circle-outline": {
            parent: "account-circle-outline"
        },
        "user-clock": {
            parent: "account-clock"
        },
        "user-clock-outline": {
            parent: "account-clock-outline"
        },
        "user-convert": {
            parent: "account-convert"
        },
        "user-details": {
            parent: "account-details"
        },
        "user-details-outline": {
            parent: "account-details-outline"
        },
        "user-edit": {
            parent: "account-edit"
        },
        "user-group": {
            parent: "account-group"
        },
        "user-group-outline": {
            parent: "account-group-outline"
        },
        "user-heart": {
            parent: "account-heart"
        },
        "user-heart-outline": {
            parent: "account-heart-outline"
        },
        "user-help": {
            parent: "account-question"
        },
        "user-help-outline": {
            parent: "account-question-outline"
        },
        "user-key": {
            parent: "account-key"
        },
        "user-key-outline": {
            parent: "account-key-outline"
        },
        "user-lock": {
            parent: "account-lock"
        },
        "user-lock-open": {
            parent: "account-lock-open"
        },
        "user-lock-open-outline": {
            parent: "account-lock-open-outline"
        },
        "user-lock-outline": {
            parent: "account-lock-outline"
        },
        "user-minus": {
            parent: "account-minus"
        },
        "user-minus-outline": {
            parent: "account-minus-outline"
        },
        "user-multiple": {
            parent: "account-multiple"
        },
        "user-multiple-add": {
            parent: "account-multiple-plus"
        },
        "user-multiple-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "user-multiple-check": {
            parent: "account-multiple-check"
        },
        "user-multiple-check-outline": {
            parent: "account-multiple-check-outline"
        },
        "user-multiple-minus": {
            parent: "account-multiple-minus"
        },
        "user-multiple-minus-outline": {
            parent: "account-multiple-minus-outline"
        },
        "user-multiple-outline": {
            parent: "account-multiple-outline"
        },
        "user-multiple-plus": {
            parent: "account-multiple-plus"
        },
        "user-multiple-plus-outline": {
            parent: "account-multiple-plus-outline"
        },
        "user-multiple-remove": {
            parent: "account-multiple-remove"
        },
        "user-multiple-remove-outline": {
            parent: "account-multiple-remove-outline"
        },
        "user-multiple-tick": {
            parent: "account-multiple-check"
        },
        "user-multiple-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        "user-network": {
            parent: "account-network"
        },
        "user-network-outline": {
            parent: "account-network-outline"
        },
        "user-off": {
            parent: "account-off"
        },
        "user-off-outline": {
            parent: "account-off-outline"
        },
        "user-online": {
            parent: "account-badge"
        },
        "user-online-outline": {
            parent: "account-badge-outline"
        },
        "user-outline": {
            parent: "account-outline"
        },
        "user-plus": {
            parent: "account-plus"
        },
        "user-plus-outline": {
            parent: "account-plus-outline"
        },
        "user-question": {
            parent: "account-question"
        },
        "user-question-outline": {
            parent: "account-question-outline"
        },
        "user-remove": {
            parent: "account-remove"
        },
        "user-remove-outline": {
            parent: "account-remove-outline"
        },
        "user-search": {
            parent: "account-search"
        },
        "user-search-outline": {
            parent: "account-search-outline"
        },
        "user-settings": {
            parent: "account-settings"
        },
        "user-settings-variant": {
            parent: "account-details"
        },
        "user-star": {
            parent: "account-star"
        },
        "user-star-outline": {
            parent: "account-star-outline"
        },
        "user-supervisor": {
            parent: "account-supervisor"
        },
        "user-supervisor-circle": {
            parent: "account-supervisor-circle"
        },
        "user-switch": {
            parent: "account-switch"
        },
        "user-tick": {
            parent: "account-check"
        },
        "user-tick-outline": {
            parent: "account-check-outline"
        },
        "user-tie": {
            parent: "account-tie"
        },
        "user-unlocked": {
            parent: "account-lock-open"
        },
        "user-unlocked-outline": {
            parent: "account-lock-open-outline"
        },
        "user-warning": {
            parent: "account-alert"
        },
        "user-warning-outline": {
            parent: "account-alert-outline"
        },
        users: {
            parent: "account-multiple"
        },
        "users-add": {
            parent: "account-multiple-plus"
        },
        "users-add-outline": {
            parent: "account-multiple-plus-outline"
        },
        "users-check": {
            parent: "account-multiple-check"
        },
        "users-check-outline": {
            parent: "account-multiple-check-outline"
        },
        "users-group": {
            parent: "account-group"
        },
        "users-group-outline": {
            parent: "account-group-outline"
        },
        "users-minus": {
            parent: "account-multiple-minus"
        },
        "users-minus-outline": {
            parent: "account-multiple-minus-outline"
        },
        "users-outline": {
            parent: "account-multiple-outline"
        },
        "users-plus": {
            parent: "account-multiple-plus"
        },
        "users-plus-outline": {
            parent: "account-multiple-plus-outline"
        },
        "users-switch": {
            parent: "account-switch"
        },
        "users-tick": {
            parent: "account-multiple-check"
        },
        "users-tick-outline": {
            parent: "account-multiple-check-outline"
        },
        "uv-ray": {
            parent: "sun-wireless"
        },
        "uv-ray-outline": {
            parent: "sun-wireless-outline"
        },
        "vacuum-cleaner": {
            parent: "vacuum"
        },
        "vacuum-cleaner-outline": {
            parent: "vacuum-outline"
        },
        "van-candy": {
            parent: "van-utility"
        },
        "vector-point-add": {
            parent: "vector-point-plus"
        },
        "vector-square-add": {
            parent: "vector-square-plus"
        },
        "vector-square-delete": {
            parent: "vector-square-remove"
        },
        "vector-square-subtract": {
            parent: "vector-square-minus"
        },
        vegetarian: {
            parent: "square-circle"
        },
        velocity: {
            parent: "bike-fast"
        },
        "venn-diagram": {
            parent: "set-none"
        },
        ventilation: {
            parent: "hvac"
        },
        "ventilation-off": {
            parent: "hvac-off"
        },
        venus: {
            parent: "gender-female"
        },
        veranda: {
            parent: "balcony"
        },
        verified: {
            parent: "check-decagram"
        },
        "verified-user": {
            parent: "shield-check"
        },
        "vertical-rotate-clockwise": {
            parent: "axis-z-rotate-clockwise"
        },
        "vertical-rotate-counterclockwise": {
            parent: "axis-z-rotate-counterclockwise"
        },
        vespa: {
            parent: "moped"
        },
        "vespa-electric": {
            parent: "moped-electric"
        },
        "vespa-electric-outline": {
            parent: "moped-electric-outline"
        },
        "vespa-outline": {
            parent: "moped-outline"
        },
        vga: {
            parent: "serial-port"
        },
        "vhs-cassette": {
            parent: "vhs"
        },
        "vhs-tape": {
            parent: "vhs"
        },
        vibration: {
            parent: "vibrate"
        },
        "video-add": {
            parent: "video-plus"
        },
        "video-call": {
            parent: "video-plus"
        },
        "video-chat": {
            parent: "laptop-account"
        },
        "video-classic": {
            parent: "video-vintage"
        },
        "video-film": {
            parent: "video-vintage"
        },
        "video-home-system": {
            parent: "vhs"
        },
        "video-input-composite": {
            parent: "video-input-component"
        },
        "video-input-ypbpr": {
            parent: "video-input-component"
        },
        "video-location": {
            parent: "video-marker"
        },
        "video-location-outline": {
            parent: "video-marker-outline"
        },
        "video-remove": {
            parent: "video-minus"
        },
        "video-stabilisation": {
            parent: "video-stabilization"
        },
        "video-user": {
            parent: "video-account"
        },
        "video-youtube": {
            parent: "youtube"
        },
        videocam: {
            parent: "video"
        },
        "videocam-off": {
            parent: "video-off"
        },
        "videocam-off-outline": {
            parent: "video-off-outline"
        },
        "videocam-outline": {
            parent: "video-outline"
        },
        "view-arrow-left": {
            parent: "eye-arrow-left"
        },
        "view-arrow-left-outline": {
            parent: "eye-arrow-left-outline"
        },
        "view-arrow-right": {
            parent: "eye-arrow-right"
        },
        "view-arrow-right-outline": {
            parent: "eye-arrow-right-outline"
        },
        "view-grid-add": {
            parent: "view-grid-plus"
        },
        "view-in-ar": {
            parent: "cube-scan"
        },
        "view-in-augmented-reality": {
            parent: "cube-scan"
        },
        "view-refresh": {
            parent: "eye-refresh"
        },
        "view-refresh-outline": {
            parent: "eye-refresh-outline"
        },
        vinyl: {
            parent: "album"
        },
        "virtual-meeting": {
            parent: "laptop-account"
        },
        "virtual-private-network": {
            parent: "vpn"
        },
        visibility: {
            parent: "eye"
        },
        "visibility-off": {
            parent: "eye-off"
        },
        "visibility-off-outline": {
            parent: "eye-off-outline"
        },
        "visibility-outline": {
            parent: "eye-outline"
        },
        "visual-studio": {
            parent: "microsoft-visual-studio"
        },
        "visual-studio-code": {
            parent: "microsoft-visual-studio-code"
        },
        visualstudio: {
            parent: "microsoft-visual-studio"
        },
        vitals: {
            parent: "pulse"
        },
        vkontakte: {
            parent: "vk"
        },
        "vkontakte-box": {
            parent: "vk-box"
        },
        "vkontakte-circle": {
            parent: "vk-circle"
        },
        voice: {
            parent: "account-voice"
        },
        "voice-chat": {
            parent: "message-video"
        },
        "voice-off": {
            parent: "account-voice-off"
        },
        "volume-control": {
            parent: "knob"
        },
        "volume-decrease": {
            parent: "volume-minus"
        },
        "volume-increase": {
            parent: "volume-plus"
        },
        "volume-knob": {
            parent: "knob"
        },
        volunteer: {
            parent: "hand-heart"
        },
        "vote-recount": {
            parent: "ballot-recount"
        },
        "vote-recount-outline": {
            parent: "ballot-recount-outline"
        },
        voucher: {
            parent: "ticket-percent"
        },
        "voucher-outline": {
            parent: "ticket-percent-outline"
        },
        voyager: {
            parent: "ship-wheel"
        },
        "vpn-key": {
            parent: "key"
        },
        vr: {
            parent: "virtual-reality"
        },
        "vs-code": {
            parent: "microsoft-visual-studio-code"
        },
        "vue-js": {
            parent: "vuejs"
        },
        w3c: {
            parent: "semantic-web"
        },
        walker: {
            parent: "walk"
        },
        walking: {
            parent: "walk"
        },
        "wall-charger": {
            parent: "ev-station"
        },
        wallbox: {
            parent: "ev-station"
        },
        "wallet-add": {
            parent: "wallet-plus"
        },
        "wallet-add-outline": {
            parent: "wallet-plus-outline"
        },
        "wallet-product": {
            parent: "google-wallet"
        },
        wand: {
            parent: "auto-fix"
        },
        warmth: {
            parent: "heat-wave"
        },
        warning: {
            parent: "alert"
        },
        "warning-box": {
            parent: "alert-box"
        },
        "warning-box-outline": {
            parent: "alert-box-outline"
        },
        "warning-circle": {
            parent: "alert-circle"
        },
        "warning-circle-outline": {
            parent: "alert-circle-outline"
        },
        "warning-decagram": {
            parent: "alert-decagram"
        },
        "warning-decagram-outline": {
            parent: "alert-decagram-outline"
        },
        "warning-lights": {
            parent: "hazard-lights"
        },
        "warning-octagon": {
            parent: "alert-octagon"
        },
        "warning-octagon-outline": {
            parent: "alert-octagon-outline"
        },
        "warning-octagram": {
            parent: "alert-octagram"
        },
        "warning-octagram-outline": {
            parent: "alert-octagram-outline"
        },
        "warning-outline": {
            parent: "alert-outline"
        },
        "washer-fluid": {
            parent: "wiper-wash"
        },
        "washer-fluid-alert": {
            parent: "wiper-wash-alert"
        },
        "washer-fluid-low": {
            parent: "wiper-wash-alert"
        },
        "watch-later": {
            parent: "clock"
        },
        "water-boiler-error": {
            parent: "water-boiler-alert"
        },
        "water-drop": {
            parent: "water"
        },
        "water-drop-outline": {
            parent: "water-outline"
        },
        "water-evaporation": {
            parent: "waves-arrow-up"
        },
        "water-filter": {
            parent: "air-filter"
        },
        "water-flow": {
            parent: "waves-arrow-left"
        },
        "water-heater": {
            parent: "water-boiler"
        },
        "water-heater-alert": {
            parent: "water-boiler-alert"
        },
        "water-heater-auto": {
            parent: "water-boiler-auto"
        },
        "water-heater-error": {
            parent: "water-boiler-alert"
        },
        "water-heater-off": {
            parent: "water-boiler-off"
        },
        "water-recycle": {
            parent: "water-sync"
        },
        "water-reuse": {
            parent: "water-sync"
        },
        "water-saver": {
            parent: "water-opacity"
        },
        "water-temperature": {
            parent: "thermometer-water"
        },
        "water-temperature-outline": {
            parent: "water-thermometer-outline"
        },
        "water-transparent": {
            parent: "water-opacity"
        },
        "water-truck": {
            parent: "tanker-truck"
        },
        "water-turbine": {
            parent: "hydro-power"
        },
        "watering-pot": {
            parent: "watering-can"
        },
        "watering-pot-outline": {
            parent: "watering-can-outline"
        },
        watermill: {
            parent: "hydro-power"
        },
        "wb-auto": {
            parent: "white-balance-auto"
        },
        "wb-cloudy": {
            parent: "cloud"
        },
        "wb-incandescent": {
            parent: "white-balance-incandescent"
        },
        "wb-iridescent": {
            parent: "white-balance-iridescent"
        },
        "wb-sunny": {
            parent: "white-balance-sunny"
        },
        wc: {
            parent: "human-male-female"
        },
        "weather-date": {
            parent: "weather-cloudy-clock"
        },
        "weather-drizzle": {
            parent: "weather-rainy"
        },
        "weather-flash": {
            parent: "weather-lightning"
        },
        "weather-heavy-rain": {
            parent: "weather-pouring"
        },
        "weather-history": {
            parent: "weather-cloudy-clock"
        },
        "weather-mist": {
            parent: "weather-fog"
        },
        "weather-partlycloudy": {
            parent: "weather-partly-cloudy"
        },
        "weather-sleet": {
            parent: "weather-snowy-rainy"
        },
        "weather-spitting": {
            parent: "weather-rainy"
        },
        "weather-storm": {
            parent: "weather-lightning"
        },
        "weather-sun-wireless": {
            parent: "sun-wireless"
        },
        "weather-sun-wireless-outline": {
            parent: "sun-wireless-outline"
        },
        "weather-thunder": {
            parent: "weather-lightning"
        },
        "weather-thunder-rainy": {
            parent: "weather-lightning-rainy"
        },
        "weather-time": {
            parent: "weather-cloudy-clock"
        },
        "web-asset": {
            parent: "application-outline"
        },
        "web-camera": {
            parent: "webcam"
        },
        "web-ontology-language": {
            parent: "semantic-web"
        },
        weed: {
            parent: "cannabis"
        },
        "weight-kg": {
            parent: "weight-kilogram"
        },
        "weight-lb": {
            parent: "weight-pound"
        },
        weights: {
            parent: "dumbbell"
        },
        whatshot: {
            parent: "fire"
        },
        wheat: {
            parent: "barley"
        },
        "wheat-off": {
            parent: "barley-off"
        },
        wheel: {
            parent: "tire"
        },
        "where-to-vote": {
            parent: "map-marker-check"
        },
        "where-to-vote-outline": {
            parent: "map-marker-check-outline"
        },
        "whiff-whaff": {
            parent: "table-tennis"
        },
        whiskey: {
            parent: "liquor"
        },
        whiteboard: {
            parent: "human-male-board"
        },
        "wide-area-network": {
            parent: "wan"
        },
        "widget-arc": {
            parent: "chart-arc"
        },
        "widget-areaspline": {
            parent: "chart-areaspline"
        },
        "widget-areaspline-variant": {
            parent: "chart-areaspline-variant"
        },
        "widget-bar": {
            parent: "chart-bar"
        },
        "widget-bar-stacked": {
            parent: "chart-bar-stacked"
        },
        "widget-bell-curve": {
            parent: "chart-bell-curve"
        },
        "widget-bell-curve-cumulative": {
            parent: "chart-bell-curve-cumulative"
        },
        "widget-box": {
            parent: "chart-box"
        },
        "widget-box-outline": {
            parent: "chart-box-outline"
        },
        "widget-box-plus-outline": {
            parent: "chart-box-plus-outline"
        },
        "widget-bubble": {
            parent: "chart-bubble"
        },
        "widget-donut": {
            parent: "chart-donut"
        },
        "widget-donut-variant": {
            parent: "chart-donut-variant"
        },
        "widget-gantt": {
            parent: "chart-gantt"
        },
        "widget-histogram": {
            parent: "chart-histogram"
        },
        "widget-line": {
            parent: "chart-line"
        },
        "widget-line-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "widget-line-stacked": {
            parent: "chart-line-stacked"
        },
        "widget-line-variant": {
            parent: "chart-line-variant"
        },
        "widget-multiline": {
            parent: "chart-multiline"
        },
        "widget-multiple": {
            parent: "chart-multiple"
        },
        "widget-pie": {
            parent: "chart-pie"
        },
        "widget-ppf": {
            parent: "chart-ppf"
        },
        "widget-sankey": {
            parent: "chart-sankey"
        },
        "widget-sankey-variant": {
            parent: "chart-sankey-variant"
        },
        "widget-scatter-plot": {
            parent: "chart-scatter-plot"
        },
        "widget-scatter-plot-hexbin": {
            parent: "chart-scatter-plot-hexbin"
        },
        "widget-timeline": {
            parent: "chart-timeline"
        },
        "widget-timeline-variant": {
            parent: "chart-timeline-variant"
        },
        "widget-timeline-variant-shimmer": {
            parent: "chart-timeline-variant-shimmer"
        },
        "widget-tree": {
            parent: "chart-tree"
        },
        "wifi-favorite": {
            parent: "wifi-star"
        },
        "wifi-favourite": {
            parent: "wifi-star"
        },
        "wifi-location": {
            parent: "wifi-marker"
        },
        "wifi-strength-0": {
            parent: "wifi-strength-outline"
        },
        "wifi-strength-0-alert": {
            parent: "wifi-strength-alert-outline"
        },
        "wifi-strength-0-lock": {
            parent: "wifi-strength-lock-outline"
        },
        "wifi-strength-0-warning": {
            parent: "wifi-strength-alert-outline"
        },
        "wifi-strength-1-warning": {
            parent: "wifi-strength-1-alert"
        },
        "wifi-strength-2-warning": {
            parent: "wifi-strength-2-alert"
        },
        "wifi-strength-3-warning": {
            parent: "wifi-strength-3-alert"
        },
        "wifi-strength-4-warning": {
            parent: "wifi-strength-4-alert"
        },
        "wifi-strength-warning-outline": {
            parent: "wifi-strength-alert-outline"
        },
        wii: {
            parent: "nintendo-wii"
        },
        wiiu: {
            parent: "nintendo-wiiu"
        },
        wildfire: {
            parent: "pine-tree-fire"
        },
        "wind-electricity": {
            parent: "wind-power"
        },
        "wind-electricity-outline": {
            parent: "wind-power-outline"
        },
        "wind-energy": {
            parent: "wind-power"
        },
        "wind-energy-outline": {
            parent: "wind-power-outline"
        },
        "wind-power-alert": {
            parent: "wind-turbine-alert"
        },
        "wind-power-check": {
            parent: "wind-turbine-check"
        },
        "wind-power-success": {
            parent: "wind-turbine-check"
        },
        "wind-turbine-success": {
            parent: "wind-turbine-check"
        },
        "wind-turbine-warning": {
            parent: "wind-turbine-alert"
        },
        window: {
            parent: "blinds-vertical"
        },
        windows: {
            parent: "microsoft-windows"
        },
        "windows-classic": {
            parent: "microsoft-windows-classic"
        },
        windy: {
            parent: "weather-dust"
        },
        wine: {
            parent: "liquor"
        },
        "wiper-fluid": {
            parent: "wiper-wash"
        },
        "wiper-fluid-alert": {
            parent: "wiper-wash-alert"
        },
        "wiper-fluid-low": {
            parent: "wiper-wash-alert"
        },
        wireless: {
            parent: "access-point"
        },
        wish: {
            parent: "oil-lamp"
        },
        woman: {
            parent: "human-female"
        },
        "woman-child": {
            parent: "human-female-boy"
        },
        "woman-woman": {
            parent: "human-female-female"
        },
        women: {
            parent: "human-female-female"
        },
        won: {
            parent: "currency-krw"
        },
        work: {
            parent: "briefcase"
        },
        "work-outline": {
            parent: "briefcase-outline"
        },
        worker: {
            parent: "account-hard-hat"
        },
        "worker-outline": {
            parent: "account-hard-hat-outline"
        },
        workflow: {
            parent: "sitemap"
        },
        "workflow-outline": {
            parent: "sitemap-outline"
        },
        world: {
            parent: "earth"
        },
        "world-arrow-right": {
            parent: "earth-arrow-right"
        },
        "world-box": {
            parent: "earth-box"
        },
        "world-box-minus": {
            parent: "earth-box-minus"
        },
        "world-box-off": {
            parent: "earth-box-off"
        },
        "world-box-plus": {
            parent: "earth-box-plus"
        },
        "world-box-remove": {
            parent: "earth-box-remove"
        },
        "world-minus": {
            parent: "earth-minus"
        },
        "world-off": {
            parent: "earth-off"
        },
        "world-plus": {
            parent: "earth-plus"
        },
        "world-remove": {
            parent: "earth-remove"
        },
        "world-wide-web": {
            parent: "web"
        },
        "wrench-settings": {
            parent: "wrench-cog"
        },
        "wrench-settings-outline": {
            parent: "wrench-cog-outline"
        },
        "wrench-time": {
            parent: "wrench-clock"
        },
        wrestling: {
            parent: "kabaddi"
        },
        "writing-system-arabic": {
            parent: "abjad-arabic"
        },
        "writing-system-aurebesh": {
            parent: "alphabet-aurebesh"
        },
        "writing-system-cjk": {
            parent: "ideogram-cjk"
        },
        "writing-system-cjk-variant": {
            parent: "ideogram-cjk-variant"
        },
        "writing-system-cyrillic": {
            parent: "alphabet-cyrillic"
        },
        "writing-system-devanagari": {
            parent: "abugida-devanagari"
        },
        "writing-system-greek": {
            parent: "alphabet-greek"
        },
        "writing-system-hangul": {
            parent: "syllabary-hangul"
        },
        "writing-system-hebrew": {
            parent: "abjad-hebrew"
        },
        "writing-system-hiragana": {
            parent: "syllabary-hiragana"
        },
        "writing-system-katakana": {
            parent: "syllabary-katakana"
        },
        "writing-system-katakana-half-width": {
            parent: "syllabary-katakana-halfwidth"
        },
        "writing-system-latin": {
            parent: "alphabet-latin"
        },
        "writing-system-piqad": {
            parent: "alphabet-piqad"
        },
        "writing-system-tengwar": {
            parent: "alphabet-tengwar"
        },
        "writing-system-thai": {
            parent: "abugida-thai"
        },
        "x-ray": {
            parent: "skull-scan"
        },
        "x-ray-box": {
            parent: "radiology-box"
        },
        "x-ray-box-outline": {
            parent: "radiology-box-outline"
        },
        "x-ray-outline": {
            parent: "skull-scan-outline"
        },
        xaml: {
            parent: "language-xaml"
        },
        xbox: {
            parent: "microsoft-xbox"
        },
        "xbox-controller": {
            parent: "microsoft-xbox-controller"
        },
        "xbox-controller-battery-alert": {
            parent: "microsoft-xbox-controller-battery-alert"
        },
        "xbox-controller-battery-charging": {
            parent: "microsoft-xbox-controller-battery-charging"
        },
        "xbox-controller-battery-empty": {
            parent: "microsoft-xbox-controller-battery-empty"
        },
        "xbox-controller-battery-full": {
            parent: "microsoft-xbox-controller-battery-full"
        },
        "xbox-controller-battery-low": {
            parent: "microsoft-xbox-controller-battery-low"
        },
        "xbox-controller-battery-medium": {
            parent: "microsoft-xbox-controller-battery-medium"
        },
        "xbox-controller-battery-unknown": {
            parent: "microsoft-xbox-controller-battery-unknown"
        },
        "xbox-controller-battery-warning": {
            parent: "microsoft-xbox-controller-battery-alert"
        },
        "xbox-controller-menu": {
            parent: "microsoft-xbox-controller-menu"
        },
        "xbox-controller-off": {
            parent: "microsoft-xbox-controller-off"
        },
        "xbox-controller-view": {
            parent: "microsoft-xbox-controller-view"
        },
        "xbox-live": {
            parent: "microsoft-xbox"
        },
        xi: {
            parent: "currency-eth"
        },
        "xing-box": {
            parent: "xing"
        },
        yen: {
            parent: "currency-jpy"
        },
        "youtube-creator-studio": {
            parent: "youtube-studio"
        },
        "youtube-play": {
            parent: "youtube"
        },
        "youtube-sports": {
            parent: "basketball"
        },
        yuan: {
            parent: "currency-cny"
        },
        zelda: {
            parent: "triforce"
        },
        zhuyin: {
            parent: "furigana-vertical"
        },
        "zoom-in": {
            parent: "magnify-plus"
        },
        "zoom-in-cursor": {
            parent: "magnify-plus-cursor"
        },
        "zoom-in-outline": {
            parent: "magnify-plus-outline"
        },
        "zoom-out": {
            parent: "magnify-minus"
        },
        "zoom-out-cursor": {
            parent: "magnify-minus-cursor"
        },
        "zoom-out-outline": {
            parent: "magnify-minus-outline"
        },
        "zoom-plus": {
            parent: "loupe"
        },
        "zorro-mask": {
            parent: "domino-mask"
        },
        zwave: {
            parent: "z-wave"
        }
    },
    width: 24,
    height: 24
});
(0,iconify/* addCollection */.Hc)({
    prefix: "line-md",
    icons: {
        "home-twotone-alt": {
            body: '<rect width="4" height="8" x="10" y="13" fill="currentColor" fill-opacity="0"><animate fill="freeze" attributeName="fill-opacity" begin="0.9s" dur="0.15s" values="0;0.3"/></rect><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path stroke-dasharray="15" stroke-dashoffset="15" d="M4.5 21.5h15"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.2s" values="15;0"/></path><path stroke-dasharray="15" stroke-dashoffset="15" d="M4.5 21.5V8M19.5 21.5V8"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.2s" dur="0.2s" values="15;0"/></path><path stroke-dasharray="24" stroke-dashoffset="24" d="M9.5 21.5V12.5H14.5V21.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.4s" dur="0.4s" values="24;0"/></path><path stroke-dasharray="30" stroke-dashoffset="30" stroke-width="2" d="M2 10L12 2L22 10"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.4s" values="30;0"/></path></g>'
        },
        github: {
            body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="30" stroke-dashoffset="30" d="M12 4C13.6683 4 14.6122 4.39991 15 4.5C15.5255 4.07463 16.9375 3 18.5 3C18.8438 4 18.7863 5.21921 18.5 6C19.25 7 19.5 8 19.5 9.5C19.5 11.6875 19.017 13.0822 18 14C16.983 14.9178 15.8887 15.3749 14.5 15.5C15.1506 16.038 15 17.3743 15 18C15 18.7256 15 21 15 21M12 4C10.3317 4 9.38784 4.39991 9 4.5C8.47455 4.07463 7.0625 3 5.5 3C5.15625 4 5.21371 5.21921 5.5 6C4.75 7 4.5 8 4.5 9.5C4.5 11.6875 4.98301 13.0822 6 14C7.01699 14.9178 8.1113 15.3749 9.5 15.5C8.84944 16.038 9 17.3743 9 18C9 18.7256 9 21 9 21"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="30;0"/></path><path stroke-dasharray="10" stroke-dashoffset="10" d="M9 19C7.59375 19 6.15625 18.4375 5.3125 17.8125C4.46875 17.1875 4.21875 16.1562 3 15.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="10;0"/></path></g>'
        },
        "document-list": {
            body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><g stroke-width="2"><path stroke-dasharray="64" stroke-dashoffset="64" d="M13 3L19 9V21H5V3H13"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/></path><path stroke-dasharray="6" stroke-dashoffset="6" d="M9 13H13"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1s" dur="0.2s" values="6;0"/></path><path stroke-dasharray="8" stroke-dashoffset="8" d="M9 16H15"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1.2s" dur="0.2s" values="8;0"/></path></g><path stroke-dasharray="14" stroke-dashoffset="14" d="M12.5 3V8.5H19"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="14;0"/></path></g>'
        },
        "document-code": {
            body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path stroke-dasharray="64" stroke-dashoffset="64" stroke-width="2" d="M13 3L19 9V21H5V3H13"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M12.5 3V8.5H19"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="14;0"/></path><g stroke-dasharray="8" stroke-dashoffset="8" stroke-width="2"><path d="M10 13L8 15L10 17"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1s" dur="0.2s" values="8;0"/></path><path d="M14 13L16 15L14 17"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1.2s" dur="0.2s" values="8;0"/></path></g></g>'
        },
        "image-twotone": {
            body: '<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path fill="none" stroke-dasharray="66" stroke-dashoffset="66" stroke-width="2" d="M3 14V5H21V19H3V14"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="66;0"/></path><path fill="currentColor" fill-opacity="0" stroke-dasharray="52" stroke-dashoffset="52" d="M3 16L7 13L10 15L16 10L21 14V19H3Z"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.6s" dur="0.8s" values="52;0"/><animate fill="freeze" attributeName="fill-opacity" begin="1s" dur="0.15s" values="0;0.3"/></path></g><circle cx="7.5" cy="9.5" r="1.5" fill="currentColor" fill-opacity="0"><animate fill="freeze" attributeName="fill-opacity" begin="1s" dur="0.4s" values="0;1"/></circle>'
        }
    },
    width: 24,
    height: 24
});
(0,iconify/* addCollection */.Hc)({
    prefix: "bx",
    icons: {
        basket: {
            body: '<path fill="currentColor" d="M21 9h-1.42l-3.712-6.496l-1.736.992L17.277 9H6.723l3.146-5.504l-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1v-1H6.764L4.31 11h15.38l-2.454 9z"/><path fill="currentColor" d="M9 13h2v5H9zm4 0h2v5h-2z"/>'
        }
    },
    width: 24,
    height: 24
});
(0,iconify/* addCollection */.Hc)({
    prefix: "bi",
    icons: {
        "airplane-engines": {
            body: '<path fill="currentColor" d="M8 0c-.787 0-1.292.592-1.572 1.151A4.347 4.347 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272l.313.937a.5.5 0 0 0 .948 0l.405-1.214l2.21-.369l.375 2.253l-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318l.375-2.253l2.21.369l.405 1.214a.5.5 0 0 0 .948 0l.313-.937l1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0ZM7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1c.213 0 .458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7V3Z"/>'
        }
    }
});
(0,iconify/* addCollection */.Hc)({
    prefix: "tabler",
    icons: {
        anchor: {
            body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 9v12m-8-8a8 8 0 0 0 16 0m1 0h-2M5 13H3"/><circle cx="12" cy="6" r="3"/></g>'
        }
    },
    width: 24,
    height: 24
});
(0,iconify/* addCollection */.Hc)({
    prefix: "uit",
    icons: {
        "adobe-alt": {
            body: '<path fill="currentColor" d="M9.917 2.224A.5.5 0 0 0 9.5 2h-8a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .96.194l8-19a.504.504 0 0 0-.043-.47zM2 19.024V3h6.747L2 19.024zM22.5 2h-8a.5.5 0 0 0-.46.694l8 19A.5.5 0 0 0 23 21.5v-19a.5.5 0 0 0-.5-.5zM22 19.024L15.253 3H22v16.024zm-9.532-9.7A.498.498 0 0 0 12.003 9H12a.5.5 0 0 0-.466.318l-3.5 9A.5.5 0 0 0 8.5 19h3.191l1.362 2.724A.5.5 0 0 0 13.5 22h3a.5.5 0 0 0 .468-.676l-4.5-12zM13.808 21l-1.36-2.724A.501.501 0 0 0 12 18H9.23l2.761-7.099L15.778 21h-1.97z"/>'
        }
    },
    width: 24,
    height: 24
});
(0,iconify/* addCollection */.Hc)({
    prefix: "fa6-regular",
    icons: {
        comment: {
            body: '<path fill="currentColor" d="M256 32C114.6 32 .027 125.1.027 240c0 47.63 19.91 91.25 52.91 126.2c-14.88 39.5-45.87 72.88-46.37 73.25c-6.625 7-8.375 17.25-4.625 26C5.818 474.2 14.38 480 24 480c61.5 0 109.1-25.75 139.1-46.25c28 9.05 60.2 14.25 92.9 14.25c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32zm.1 368c-26.75 0-53.12-4.125-78.38-12.12l-22.75-7.125l-19.5 13.75c-14.25 10.12-33.88 21.38-57.5 29c7.375-12.12 14.37-25.75 19.88-40.25l10.62-28l-20.62-21.87C69.82 314.1 48.07 282.2 48.07 240c0-88.25 93.25-160 208-160s208 71.75 208 160S370.8 400 256.1 400z"/>'
        }
    },
    width: 512,
    height: 512
});
(0,iconify/* addCollection */.Hc)({
    prefix: "twemoji",
    icons: {
        "auto-rickshaw": {
            body: '<path fill="#99AAB5" d="M19 9h2v11h-2z"/><path fill="#55ACEE" d="M10 9c-2 2-4 5-4 7c0 4 5 1 5 1V9h-1z"/><circle cx="5" cy="32" r="4" fill="#292F33"/><circle cx="5" cy="32" r="2" fill="#99AAB5"/><path fill="#1E5200" d="M29 23h-2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm-10 0h-2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2z"/><path fill="#5C913B" d="M2 28.377c-1.387.225-2.581-1.152-1-2.435c2-1.623 7-2.435 9-1.623S12 33 11 33s-4-5.435-9-4.623z"/><path fill="#3E721D" d="M11 33h13c1 0 2 0 2-2c0-1 1-4 3-4s5 3 5 4s0 2 1 2s1-1 1-2V19h-8c0 3-1 8-1 8s-1-1-1 1c0 .606-1 2-2 2h-1c-1 0-2-.666-2-1.672V19c0-1-2-1-2 0v9.328C19 29.334 18.262 30 17.341 30h-3.33C13 30 12 29 12 28v-9H5c0 6 5 14 6 14z"/><path fill="#5C913B" d="M34 32c0 1 1 0 1-2c0-3-.833-5-5-5s-5 3-5 5c0 1 1 3 1 2s.667-2 4-2s4 1 4 2z"/><path fill="#FFAC33" d="M12 19H5c0-1 1-3 1-3h4a1 1 0 0 0 1-1v-4s-2 0-2-2c0-.326.106-.652.25-.944C9.573 7.4 10.258 7 10.99 7H33c2 0 3 5 3 12h-8s0-8-3-8H12v8z"/><circle cx="30" cy="32" r="4" fill="#292F33"/><circle cx="30" cy="32" r="2" fill="#99AAB5"/><path fill="#F4900C" d="M9 18.5v-1a.5.5 0 0 0-.5-.5H5.552C5.286 17.648 5 18.464 5 19h3.5a.5.5 0 0 0 .5-.5z"/>'
        }
    },
    width: 36,
    height: 36
});
(0,iconify/* addCollection */.Hc)({
    prefix: "custom",
    icons: {
        logo: {
            body: '<g fill="none"><path fill="currentColor" d="M30 20.392a2 2 0 01-3.027 1.716l-3.258-1.95a2 2 0 01-.973-1.716l-.001-6.7L15 16.178l-7.742-4.434v6.7a2 2 0 01-.973 1.715l-3.258 1.95A2 2 0 010 20.392V2.585l.005-.15L0 2.572A2 2 0 013.045.866L15 8.194 26.955.866A2 2 0 0130 2.572Z"/><path fill="#000" d="m0 7.589 7.258 4.162v4.08z" opacity=".078"/><path fill="#000" d="m0 7.589 7.258 4.056v2.492zm30 0-7.258 4.153v4.212z" opacity=".078"/><path fill="#000" d="m30 7.589-7.258 4.052v2.619z" opacity=".078"/><path fill="#FFF" fill-opacity=".15" d="M3.045.866 15 8.194v7.983L0 7.587V2.571A2 2 0 013.045.865Z"/><path fill="#FFF" fill-opacity=".35" d="M26.955.866 15 8.194v7.983l15-8.59V2.571A2 2 0 0026.955.865Z"/></g>',
            width: 30,
            height: 23
        }
    }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/layouts/MetadataHeaders.tsx
// ** Next Imports



// ** Modules Imports

// ** Config Imports

const MetadataHeaders = ()=>{
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const originHost = "https://".concat("gosilk.ru");
    const router = (0,next_router.useRouter)();
    const _pathSliceLength = Math.min.apply(Math, [
        router.asPath.indexOf("?") > 0 ? router.asPath.indexOf("?") : router.asPath.length,
        router.asPath.indexOf("#") > 0 ? router.asPath.indexOf("#") : router.asPath.length
    ]);
    const canonicalURL = originHost + router.asPath.substring(0, _pathSliceLength);
    const metaTitle = formatMessage({
        id: "metadata-title-default"
    }, {
        name: themeConfig/* default.templateName */.Z.templateName
    });
    const metaDescription = formatMessage({
        id: "metadata-description-default"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "name",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "image",
                content: "".concat(originHost, "/images/og-icon-300x300.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: originHost
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "gosilk.ru"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "".concat(originHost, "/images/og-image.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(originHost, "/images/og-image.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:width",
                content: "968"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:height",
                content: "504"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:type",
                content: "image/jpg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(originHost, "/images/og-icon-500x500.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: "".concat(themeConfig/* default.templateName */.Z.templateName, ", Publishing Platform, Admin, Platform")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1, width=device-width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "60x60",
                href: "".concat(originHost, "/images/apple-touch-icon-60x60.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "72x72",
                href: "".concat(originHost, "/images/apple-touch-icon-72x72.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: "".concat(originHost, "/images/apple-touch-icon-120x120.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: "".concat(originHost, "/images/apple-touch-icon-152x152.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "".concat(originHost, "/images/apple-touch-icon-180x180.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/images/favicon.png",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "".concat(originHost, "/images/favicon.svg"),
                type: "image/svg+xml"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalURL
            })
        ]
    });
};
/* harmony default export */ var layouts_MetadataHeaders = (MetadataHeaders);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(5084);
;// CONCATENATED MODULE: ./src/views/pages/technical-break/index.tsx
// ** Next Imports


// ** MUI Imports

// ** Modules Imports

// ** Source code Imports

const TechnicalBreakPage = ()=>{
    // ** Hooks
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const { reload  } = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_page/* default */.Z, {
        title: formatMessage({
            id: "technical-break-title"
        }),
        description: "".concat(formatMessage({
            id: "technical-break-description"
        }), "."),
        renderButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: "contained",
            onClick: reload,
            children: formatMessage({
                id: "refresh-page"
            })
        })
    });
};
/* harmony default export */ var technical_break = (TechnicalBreakPage);

// EXTERNAL MODULE: ./src/layouts/default-layout/index.tsx + 36 modules
var default_layout = __webpack_require__(5113);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(8016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(8346);
;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.4 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ./src/layouts/components/cookie-policy/index.tsx
//** React Imports


// ** MUI Imports

// ** Effector Imports

// ** Modules Imports



const CookiesPolicy = ()=>{
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const [isCookieConfirm, setCookieConfirm] = (0,react.useState)(true);
    const onButtonHandler = ()=>{
        api.set("coockieConfirmed", "true", {
            expires: 365
        });
        setCookieConfirm(true);
    };
    (0,react.useEffect)(()=>{
        const cookieConfirm = api.get("coockieConfirmed");
        setCookieConfirm(!!cookieConfirm);
    }, []);
    if (isCookieConfirm || language === "en") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            background: "#3A3E5B",
            width: "100%",
            padding: "15px 0",
            position: "fixed",
            bottom: 0,
            zIndex: 9999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "&.MuiContainer-root": {
                    maxWidth: "1200px",
                    padding: "0 0.75rem"
                },
                "@media (max-width:768px)": {
                    flexDirection: "column",
                    alignItems: "inintial"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        maxWidth: "850px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#fff",
                        "@media (max-width:1024px)": {
                            maxWidth: "720px"
                        },
                        "@media (max-width:768px)": {
                            fontSize: "12px",
                            mb: "16px"
                        }
                    },
                    children: [
                        formatMessage({
                            id: "cookie-text-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/cookie-policy",
                            target: "_blank",
                            children: formatMessage({
                                id: "cookie-link"
                            })
                        }),
                        formatMessage({
                            id: "cookie-text-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: onButtonHandler,
                    sx: {
                        width: "fit-content",
                        height: "fit-content",
                        background: "#9000FF",
                        padding: "8px 26px",
                        fontSize: "15px",
                        fontWeight: "500",
                        color: "#fff",
                        textTransform: "capitalize",
                        "@media (max-width:768px)": {
                            margin: "auto"
                        }
                    },
                    children: formatMessage({
                        id: "accept"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var cookie_policy = (CookiesPolicy);

// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(6774);
// EXTERNAL MODULE: ./src/assets/style.css
var style = __webpack_require__(7835);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
// ** React Imports


// ** Next Imports


// ** Loader Import

// ** Emotion Imports

// ** Config Imports


// ** Third Party Import




// ** Effector Imports

// ** Contexts





// ** Modules Imports




// ** Styled Components

// ** Utils Imports

// ** Prismjs Styles




// ** React Perfect Scrollbar Style


// ** Source code Imports




// ** Global css styles


const clientSideEmotionCache = createEmotionCache();
// ** Pace Loader
if (themeConfig/* default.routingLoader */.Z.routingLoader) {
    next_router.Router.events.on("routeChangeStart", ()=>{
        nprogress_default().start();
    });
    next_router.Router.events.on("routeChangeError", ()=>{
        nprogress_default().done();
    });
    next_router.Router.events.on("routeChangeComplete", ()=>{
        nprogress_default().done();
    });
}
const Guard = (param)=>{
    let { children  } = param;
    const { pathname  } = (0,next_router.useRouter)();
    const isTechnicalBreak = (0,unleash_react/* useFlag */.P5)("is_closed_for_technical_break");
    const isLandingNewsAvailable = (0,unleash_react/* useFlag */.P5)("is_landing_news_available");
    const { formatMessage  } = (0,useIntl/* default */.Z)();
    const { language  } = (0,effector_react/* useStore */.oR)(global/* default.locale */.ZP.locale);
    const isCloseLandingNews = (!isLandingNewsAvailable || language === "en") && (pathname === "/news/[id]" || pathname === "/news");
    const isCloseCookiePolicy = language === "en" && pathname === "/cookie-policy";
    const isClosePrivacyPolicy = language === "en" && pathname === "/privacy-policy";
    if (isCloseLandingNews || isCloseCookiePolicy || isClosePrivacyPolicy) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_page/* default */.Z, {
            code: 404,
            title: formatMessage({
                id: "page-not-found"
            }),
            description: formatMessage({
                id: "page-not-found-description"
            })
        });
    }
    if (isTechnicalBreak) return /*#__PURE__*/ (0,jsx_runtime.jsx)(technical_break, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    });
};
// ** Configure JSS & ClassName
const App = (props)=>{
    const { Component , emotionCache =clientSideEmotionCache , pageProps  } = props;
    var _getLayout;
    // Variables
    const getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(default_layout/* default */.Z, {
            children: page
        });
    var _setConfig;
    const setConfig = (_setConfig = Component.setConfig) !== null && _setConfig !== void 0 ? _setConfig : undefined;
    (0,react.useEffect)(()=>{
        if (window) window.ResizeObserver = ResizeObserver_es;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_element_6a883da9_browser_esm.C, {
        value: emotionCache,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* YandexMetricaProvider */.BJ, {
            tagID: 94806853,
            initParameters: {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unleash_react/* FlagProvider */.Cm, {
                    config: feature_flag,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationContext_LocalizationProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryContext/* HistoryProvider */.f, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(settingsContext/* SettingsProvider */.mu, {
                                ...setConfig ? {
                                    pageSettings: setConfig()
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(settingsContext/* SettingsConsumer */.ix, {
                                    children: (param)=>{
                                        let { settings  } = param;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_ThemeComponent, {
                                            settings: settings,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_MetadataHeaders, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(window_wrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Guard, {
                                                        children: getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                                            ...pageProps
                                                        }))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ie, {
                                                        position: settings.toastPosition,
                                                        toastOptions: {
                                                            className: "react-hot-toast"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_policy, {})
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(google.GoogleTagManager, {
                    gtmId: "GTM-MT7T97JR"
                })
            ]
        })
    });
};
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 5789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HI": function() { return /* reexport */ changeModalRegistrationStatus; },
  "aA": function() { return /* reexport */ closeModalRegistrationClosed; },
  "ZP": function() { return /* binding */ global; }
});

// EXTERNAL MODULE: ./node_modules/effector/effector.mjs
var effector = __webpack_require__(8116);
;// CONCATENATED MODULE: ./src/configs/locale.ts
/* harmony default export */ var locale = ({
    language: "ru" || 0
});

;// CONCATENATED MODULE: ./src/state-manager/global/locale.ts


const locale_locale = (0,effector/* createStore */.MT)({
    language: locale.language
});
/* harmony default export */ var global_locale = (locale_locale);

;// CONCATENATED MODULE: ./src/state-manager/global/modal-registration-closed.ts

const changeModalRegistrationStatus = (0,effector/* createEffect */.GW)((payload)=>payload);
const closeModalRegistrationClosed = (0,effector/* createEvent */.yM)();
const modalRegistrationClosed = (0,effector/* createStore */.MT)({
    open: false
}).on(closeModalRegistrationClosed, (state)=>{
    return {
        ...state,
        open: false
    };
}).on(changeModalRegistrationStatus.doneData, (state, payload)=>{
    return {
        ...state,
        open: payload
    };
});

/* harmony default export */ var modal_registration_closed = (modalRegistrationClosed);

;// CONCATENATED MODULE: ./src/state-manager/global/index.ts



/* harmony default export */ var global = ({
    locale: global_locale,
    modalRegistrationClosed: modal_registration_closed
});


/***/ }),

/***/ 3209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5084);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9630);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(120);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1719);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
// ** React Imports

// ** Next Imports

// ** MUI Imports




// ** Modules Imports

const Image = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("img")({});
const ErrorPage = (param)=>{
    let { code , title , description , renderButton  } = param;
    const { formatMessage  } = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            width: 1,
            height: "100vh",
            minHeight: 900
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            sx: {
                maxWidth: 1480,
                maxHeight: 900,
                m: "0 auto",
                width: 1,
                height: 1,
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        p: 0,
                        m: 0,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: 1,
                        height: 1,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                            sx: (theme)=>({
                                    position: "absolute",
                                    width: theme.spacing(260),
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    [theme.breakpoints.down("md")]: {
                                        width: theme.spacing(200)
                                    }
                                }),
                            src: "/images/not-found/ellipse.png",
                            alt: "ellipse"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            sx: (theme)=>({
                                    position: "absolute",
                                    width: theme.spacing(105.75),
                                    top: "52.5%",
                                    left: "37.5%",
                                    transform: "translate(-100%, -100%)",
                                    [theme.breakpoints.down("md")]: {
                                        top: "38.5%",
                                        left: "42.5%",
                                        transform: "translate(-80%, -100%)"
                                    }
                                }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                                sx: {
                                    width: "100%",
                                    height: "auto",
                                    animation: "headphonesAnim 2.5s linear infinite",
                                    "@keyframes headphonesAnim": {
                                        "0%": {
                                            transform: "translateY(0px)"
                                        },
                                        "50%": {
                                            transform: "translateY(20px)"
                                        },
                                        "100%": {
                                            transform: "translateY(0px)"
                                        }
                                    }
                                },
                                src: "/images/not-found/headphone-dynamic-gradient.png",
                                alt: "ellipse"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            sx: (theme)=>({
                                    position: "absolute",
                                    height: "auto",
                                    top: "37.5%",
                                    right: "40%",
                                    transform: "translate(100%, -100%)",
                                    [theme.breakpoints.down("md")]: {
                                        top: "35.5%",
                                        right: "40%"
                                    }
                                }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                                sx: (theme)=>({
                                        width: theme.spacing(77),
                                        [theme.breakpoints.down("md")]: {
                                            width: theme.spacing(50)
                                        },
                                        animation: "notesAnim 4.5s linear infinite",
                                        "@keyframes notesAnim": {
                                            "0%": {
                                                transform: "translateY(0px)"
                                            },
                                            "50%": {
                                                transform: "translateY(30px)"
                                            },
                                            "100%": {
                                                transform: "translateY(0px)"
                                            }
                                        }
                                    }),
                                src: "/images/not-found/music-dynamic-gradient.png",
                                alt: "music"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            sx: (theme)=>({
                                    position: "absolute",
                                    height: "auto",
                                    top: "78.5%",
                                    left: "45%",
                                    transform: "translate(-50%, 0)",
                                    [theme.breakpoints.down("md")]: {
                                        top: "78%",
                                        left: "27.5%",
                                        transform: "translate(-50%, 0)"
                                    }
                                }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                                sx: (theme)=>({
                                        width: theme.spacing(33),
                                        [theme.breakpoints.down("md")]: {
                                            width: theme.spacing(23)
                                        },
                                        animation: "pointerAnim 3.5s linear infinite",
                                        "@keyframes pointerAnim": {
                                            "0%": {
                                                transform: "translate(0px)"
                                            },
                                            "50%": {
                                                transform: "translate(30px, -30px)"
                                            },
                                            "100%": {
                                                transform: "translate(0px)"
                                            }
                                        }
                                    }),
                                src: "/images/not-found/location-dynamic-gradient.png",
                                alt: "location"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -45%)",
                        width: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            sx: {
                                width: 1,
                                maxWidth: 420,
                                p: 1
                            },
                            children: [
                                code && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    sx: (theme)=>({
                                            fontSize: theme.spacing(32),
                                            fontWeight: 500,
                                            color: theme.palette.common.white,
                                            lineHeight: 1,
                                            mb: 2
                                        }),
                                    children: code
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    sx: (theme)=>({
                                            fontSize: theme.spacing(6),
                                            fontWeight: 500,
                                            color: theme.palette.common.white,
                                            mb: 4
                                        }),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    sx: (theme)=>({
                                            mb: 20,
                                            color: theme.palette.common.white
                                        }),
                                    children: description
                                })
                            ]
                        }),
                        !!renderButton ? renderButton : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            href: "/",
                            component: (next_link__WEBPACK_IMPORTED_MODULE_1___default()),
                            variant: "contained",
                            sx: (theme)=>({
                                    p: theme.spacing(4, 12),
                                    borderRadius: 0
                                }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                sx: (theme)=>({
                                        fontSize: theme.spacing(4.25),
                                        fontWeight: 500,
                                        color: theme.palette.common.white
                                    }),
                                children: formatMessage({
                                    id: "back-to-home"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorPage);


/***/ }),

/***/ 8386:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7187:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7835:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6774:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1551)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(3573)


/***/ }),

/***/ 4865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 2356:
/***/ (function() {

(function (Prism) {

	var javascript = Prism.util.clone(Prism.languages.javascript);

	var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
	var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
	var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;

	/**
	 * @param {string} source
	 * @param {string} [flags]
	 */
	function re(source, flags) {
		source = source
			.replace(/<S>/g, function () { return space; })
			.replace(/<BRACES>/g, function () { return braces; })
			.replace(/<SPREAD>/g, function () { return spread; });
		return RegExp(source, flags);
	}

	spread = re(spread).source;


	Prism.languages.jsx = Prism.languages.extend('markup', javascript);
	Prism.languages.jsx.tag.pattern = re(
		/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
	);

	Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
	Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
	Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
	Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];

	Prism.languages.insertBefore('inside', 'attr-name', {
		'spread': {
			pattern: re(/<SPREAD>/.source),
			inside: Prism.languages.jsx
		}
	}, Prism.languages.jsx.tag);

	Prism.languages.insertBefore('inside', 'special-attr', {
		'script': {
			// Allow for two levels of nesting
			pattern: re(/=<BRACES>/.source),
			alias: 'language-javascript',
			inside: {
				'script-punctuation': {
					pattern: /^=(?=\{)/,
					alias: 'punctuation'
				},
				rest: Prism.languages.jsx
			},
		}
	}, Prism.languages.jsx.tag);

	// The following will handle plain text inside tags
	var stringifyToken = function (token) {
		if (!token) {
			return '';
		}
		if (typeof token === 'string') {
			return token;
		}
		if (typeof token.content === 'string') {
			return token.content;
		}
		return token.content.map(stringifyToken).join('');
	};

	var walkTokens = function (tokens) {
		var openedTags = [];
		for (var i = 0; i < tokens.length; i++) {
			var token = tokens[i];
			var notTagNorBrace = false;

			if (typeof token !== 'string') {
				if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
					// We found a tag, now find its kind

					if (token.content[0].content[0].content === '</') {
						// Closing tag
						if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) {
							// Pop matching opening tag
							openedTags.pop();
						}
					} else {
						if (token.content[token.content.length - 1].content === '/>') {
							// Autoclosed tag, ignore
						} else {
							// Opening tag
							openedTags.push({
								tagName: stringifyToken(token.content[0].content[1]),
								openedBraces: 0
							});
						}
					}
				} else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') {

					// Here we might have entered a JSX context inside a tag
					openedTags[openedTags.length - 1].openedBraces++;

				} else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') {

					// Here we might have left a JSX context inside a tag
					openedTags[openedTags.length - 1].openedBraces--;

				} else {
					notTagNorBrace = true;
				}
			}
			if (notTagNorBrace || typeof token === 'string') {
				if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
					// Here we are inside a tag, and not inside a JSX context.
					// That's plain text: drop any tokens matched.
					var plainText = stringifyToken(token);

					// And merge text with adjacent text
					if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
						plainText += stringifyToken(tokens[i + 1]);
						tokens.splice(i + 1, 1);
					}
					if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
						plainText = stringifyToken(tokens[i - 1]) + plainText;
						tokens.splice(i - 1, 1);
						i--;
					}

					tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
				}
			}

			if (token.content && typeof token.content !== 'string') {
				walkTokens(token.content);
			}
		}
	};

	Prism.hooks.add('after-tokenize', function (env) {
		if (env.language !== 'jsx' && env.language !== 'tsx') {
			return;
		}
		walkTokens(env.tokens);
	});

}(Prism));


/***/ }),

/***/ 1029:
/***/ (function() {

(function (Prism) {
	var typescript = Prism.util.clone(Prism.languages.typescript);
	Prism.languages.tsx = Prism.languages.extend('jsx', typescript);

	// doesn't work with TS because TS is too complex
	delete Prism.languages.tsx['parameter'];
	delete Prism.languages.tsx['literal-property'];

	// This will prevent collisions between TSX tags and TS generic types.
	// Idea by https://github.com/karlhorky
	// Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
	var tag = Prism.languages.tsx.tag;
	tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
	tag.lookbehind = true;
}(Prism));


/***/ }),

/***/ 5660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if ( true && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof __webpack_require__.g !== 'undefined') {
	__webpack_require__.g.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						{
							pattern: /^(\s*)["']|["']$/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());


/***/ }),

/***/ 4806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ }),

/***/ 680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5719);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5687);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2644);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 5719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 6257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = exports.GoogleMapsEmbed = exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var google_analytics_1 = __webpack_require__(3494);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return google_analytics_1.GoogleAnalytics; } }));
var google_maps_embed_1 = __webpack_require__(4248);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return google_maps_embed_1.GoogleMapsEmbed; } }));
var youtube_embed_1 = __webpack_require__(2239);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return youtube_embed_1.YouTubeEmbed; } }));


/***/ }),

/***/ 3494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(9426));
const utils_1 = __webpack_require__(7058);
const GoogleAnalytics = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleAnalytics = GoogleAnalytics;


/***/ }),

/***/ 4248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleMapsEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(7395));
const utils_1 = __webpack_require__(7058);
const GoogleMapsEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleMapsEmbed = GoogleMapsEmbed;


/***/ }),

/***/ 2239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(8420));
const utils_1 = __webpack_require__(7058);
const YouTubeEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.YouTubeEmbed = YouTubeEmbed;


/***/ }),

/***/ 7058:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatData = exports.createHtml = exports.formatUrl = void 0;
function filterArgs(args, selectedArgs, inverse = false) {
    if (!selectedArgs)
        return {};
    return Object.keys(args)
        .filter((key) => inverse ? !selectedArgs.includes(key) : selectedArgs.includes(key))
        .reduce((obj, key) => {
        obj[key] = args[key];
        return obj;
    }, {});
}
// Add all required search params with user inputs as values
function formatUrl(url, params, args, slug) {
    const newUrl = slug && Object.keys(slug).length > 0
        ? new URL(Object.values(slug)[0], url) // If there's a user inputted param for the URL slug, replace the default existing slug or include it
        : new URL(url);
    if (params && args) {
        params.forEach((param) => {
            if (args[param])
                newUrl.searchParams.set(param, args[param]);
        });
    }
    return newUrl.toString();
}
exports.formatUrl = formatUrl;
// Construct HTML element and include all default attributes and user-inputted attributes
function createHtml(element, attributes, htmlAttrArgs, urlQueryParamArgs, slugParamArg) {
    var _a;
    if (!attributes)
        return `<${element}></${element}>`;
    const formattedAttributes = ((_a = attributes.src) === null || _a === void 0 ? void 0 : _a.url)
        ? Object.assign(Object.assign({}, attributes), { src: formatUrl(attributes.src.url, attributes.src.params, urlQueryParamArgs, slugParamArg) }) : attributes;
    const htmlAttributes = Object.keys(Object.assign(Object.assign({}, formattedAttributes), htmlAttrArgs)).reduce((acc, name) => {
        const userVal = htmlAttrArgs === null || htmlAttrArgs === void 0 ? void 0 : htmlAttrArgs[name];
        const defaultVal = formattedAttributes[name];
        const finalVal = userVal !== null && userVal !== void 0 ? userVal : defaultVal; // overwrite
        const attrString = finalVal === true ? name : `${name}="${finalVal}"`;
        return finalVal ? acc + ` ${attrString}` : acc;
    }, '');
    return `<${element}${htmlAttributes}></${element}>`;
}
exports.createHtml = createHtml;
// Format JSON by including all default and user-required parameters
function formatData(data, args) {
    var _a, _b, _c, _d, _e;
    const allScriptParams = (_a = data.scripts) === null || _a === void 0 ? void 0 : _a.reduce((acc, script) => [
        ...acc,
        ...(Array.isArray(script.params) ? script.params : []),
    ], []);
    // First, find all input arguments that map to parameters passed to script URLs
    const scriptUrlParamInputs = filterArgs(args, allScriptParams);
    // Second, find all input arguments that map to parameters passed to the HTML src attribute
    const htmlUrlParamInputs = filterArgs(args, (_c = (_b = data.html) === null || _b === void 0 ? void 0 : _b.attributes.src) === null || _c === void 0 ? void 0 : _c.params);
    // Third, find the input argument that maps to the slug parameter passed to the HTML src attribute if present
    const htmlSlugParamInput = filterArgs(args, [
        (_e = (_d = data.html) === null || _d === void 0 ? void 0 : _d.attributes.src) === null || _e === void 0 ? void 0 : _e.slugParam,
    ]);
    // Lastly, all remaining arguments are forwarded as separate HTML attributes
    const htmlAttrInputs = filterArgs(args, [
        ...Object.keys(scriptUrlParamInputs),
        ...Object.keys(htmlUrlParamInputs),
        ...Object.keys(htmlSlugParamInput),
    ], true);
    return Object.assign(Object.assign({}, data), { 
        // Pass any custom attributes to HTML content
        html: data.html
            ? createHtml(data.html.element, data.html.attributes, htmlAttrInputs, htmlUrlParamInputs, htmlSlugParamInput)
            : null, 
        // Pass any required query params with user values for relevant scripts
        scripts: data.scripts
            ? data.scripts.map((script) => (Object.assign(Object.assign({}, script), { url: formatUrl(script.url, script.params, scriptUrlParamInputs) })))
            : null });
}
exports.formatData = formatData;


/***/ }),

/***/ 4836:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 5068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 1954:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ addCollection; },
/* harmony export */   "JO": function() { return /* binding */ Icon; }
/* harmony export */ });
/* unused harmony exports InlineIcon, _api, addAPIProvider, addIcon, buildIcon, calculateSize, disableCache, enableCache, getIcon, iconExists, listIcons, loadIcon, loadIcons, replaceIDs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


const matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const stringToIcon = (value, validate, allowSimpleName, provider = "") => {
  const colonSeparated = value.split(":");
  if (value.slice(0, 1) === "@") {
    if (colonSeparated.length < 2 || colonSeparated.length > 3) {
      return null;
    }
    provider = colonSeparated.shift().slice(1);
  }
  if (colonSeparated.length > 3 || !colonSeparated.length) {
    return null;
  }
  if (colonSeparated.length > 1) {
    const name2 = colonSeparated.pop();
    const prefix = colonSeparated.pop();
    const result = {
      provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
      prefix,
      name: name2
    };
    return validate && !validateIconName(result) ? null : result;
  }
  const name = colonSeparated[0];
  const dashSeparated = name.split("-");
  if (dashSeparated.length > 1) {
    const result = {
      provider,
      prefix: dashSeparated.shift(),
      name: dashSeparated.join("-")
    };
    return validate && !validateIconName(result) ? null : result;
  }
  if (allowSimpleName && provider === "") {
    const result = {
      provider,
      prefix: "",
      name
    };
    return validate && !validateIconName(result, allowSimpleName) ? null : result;
  }
  return null;
};
const validateIconName = (icon, allowSimpleName) => {
  if (!icon) {
    return false;
  }
  return !!((icon.provider === "" || icon.provider.match(matchIconName)) && (allowSimpleName && icon.prefix === "" || icon.prefix.match(matchIconName)) && icon.name.match(matchIconName));
};

const defaultIconDimensions = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
);
const defaultIconTransformations = Object.freeze({
  rotate: 0,
  vFlip: false,
  hFlip: false
});
const defaultIconProps = Object.freeze({
  ...defaultIconDimensions,
  ...defaultIconTransformations
});
const defaultExtendedIconProps = Object.freeze({
  ...defaultIconProps,
  body: "",
  hidden: false
});

function mergeIconTransformations(obj1, obj2) {
  const result = {};
  if (!obj1.hFlip !== !obj2.hFlip) {
    result.hFlip = true;
  }
  if (!obj1.vFlip !== !obj2.vFlip) {
    result.vFlip = true;
  }
  const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
  if (rotate) {
    result.rotate = rotate;
  }
  return result;
}

function mergeIconData(parent, child) {
  const result = mergeIconTransformations(parent, child);
  for (const key in defaultExtendedIconProps) {
    if (key in defaultIconTransformations) {
      if (key in parent && !(key in result)) {
        result[key] = defaultIconTransformations[key];
      }
    } else if (key in child) {
      result[key] = child[key];
    } else if (key in parent) {
      result[key] = parent[key];
    }
  }
  return result;
}

function getIconsTree(data, names) {
  const icons = data.icons;
  const aliases = data.aliases || {};
  const resolved = /* @__PURE__ */ Object.create(null);
  function resolve(name) {
    if (icons[name]) {
      return resolved[name] = [];
    }
    if (!(name in resolved)) {
      resolved[name] = null;
      const parent = aliases[name] && aliases[name].parent;
      const value = parent && resolve(parent);
      if (value) {
        resolved[name] = [parent].concat(value);
      }
    }
    return resolved[name];
  }
  (names || Object.keys(icons).concat(Object.keys(aliases))).forEach(resolve);
  return resolved;
}

function internalGetIconData(data, name, tree) {
  const icons = data.icons;
  const aliases = data.aliases || {};
  let currentProps = {};
  function parse(name2) {
    currentProps = mergeIconData(
      icons[name2] || aliases[name2],
      currentProps
    );
  }
  parse(name);
  tree.forEach(parse);
  return mergeIconData(data, currentProps);
}

function parseIconSet(data, callback) {
  const names = [];
  if (typeof data !== "object" || typeof data.icons !== "object") {
    return names;
  }
  if (data.not_found instanceof Array) {
    data.not_found.forEach((name) => {
      callback(name, null);
      names.push(name);
    });
  }
  const tree = getIconsTree(data);
  for (const name in tree) {
    const item = tree[name];
    if (item) {
      callback(name, internalGetIconData(data, name, item));
      names.push(name);
    }
  }
  return names;
}

const optionalPropertyDefaults = {
  provider: "",
  aliases: {},
  not_found: {},
  ...defaultIconDimensions
};
function checkOptionalProps(item, defaults) {
  for (const prop in defaults) {
    if (prop in item && typeof item[prop] !== typeof defaults[prop]) {
      return false;
    }
  }
  return true;
}
function quicklyValidateIconSet(obj) {
  if (typeof obj !== "object" || obj === null) {
    return null;
  }
  const data = obj;
  if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") {
    return null;
  }
  if (!checkOptionalProps(obj, optionalPropertyDefaults)) {
    return null;
  }
  const icons = data.icons;
  for (const name in icons) {
    const icon = icons[name];
    if (!name.match(matchIconName) || typeof icon.body !== "string" || !checkOptionalProps(
      icon,
      defaultExtendedIconProps
    )) {
      return null;
    }
  }
  const aliases = data.aliases || {};
  for (const name in aliases) {
    const icon = aliases[name];
    const parent = icon.parent;
    if (!name.match(matchIconName) || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !checkOptionalProps(
      icon,
      defaultExtendedIconProps
    )) {
      return null;
    }
  }
  return data;
}

const dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(provider, prefix) {
  return {
    provider,
    prefix,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function getStorage(provider, prefix) {
  const providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */ Object.create(null));
  return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}
function addIconSet(storage, data) {
  if (!quicklyValidateIconSet(data)) {
    return [];
  }
  return parseIconSet(data, (name, icon) => {
    if (icon) {
      storage.icons[name] = icon;
    } else {
      storage.missing.add(name);
    }
  });
}
function addIconToStorage(storage, name, icon) {
  try {
    if (typeof icon.body === "string") {
      storage.icons[name] = { ...icon };
      return true;
    }
  } catch (err) {
  }
  return false;
}
function listIcons(provider, prefix) {
  let allIcons = [];
  const providers = typeof provider === "string" ? [provider] : Object.keys(dataStorage);
  providers.forEach((provider2) => {
    const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [prefix] : Object.keys(dataStorage[provider2] || {});
    prefixes.forEach((prefix2) => {
      const storage = getStorage(provider2, prefix2);
      allIcons = allIcons.concat(
        Object.keys(storage.icons).map(
          (name) => (provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name
        )
      );
    });
  });
  return allIcons;
}

let simpleNames = false;
function allowSimpleNames(allow) {
  if (typeof allow === "boolean") {
    simpleNames = allow;
  }
  return simpleNames;
}
function getIconData(name) {
  const icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
  if (icon) {
    const storage = getStorage(icon.provider, icon.prefix);
    const iconName = icon.name;
    return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
  }
}
function addIcon(name, data) {
  const icon = stringToIcon(name, true, simpleNames);
  if (!icon) {
    return false;
  }
  const storage = getStorage(icon.provider, icon.prefix);
  return addIconToStorage(storage, icon.name, data);
}
function addCollection(data, provider) {
  if (typeof data !== "object") {
    return false;
  }
  if (typeof provider !== "string") {
    provider = data.provider || "";
  }
  if (simpleNames && !provider && !data.prefix) {
    let added = false;
    if (quicklyValidateIconSet(data)) {
      data.prefix = "";
      parseIconSet(data, (name, icon) => {
        if (icon && addIcon(name, icon)) {
          added = true;
        }
      });
    }
    return added;
  }
  const prefix = data.prefix;
  if (!validateIconName({
    provider,
    prefix,
    name: "a"
  })) {
    return false;
  }
  const storage = getStorage(provider, prefix);
  return !!addIconSet(storage, data);
}
function iconExists(name) {
  return !!getIconData(name);
}
function getIcon(name) {
  const result = getIconData(name);
  return result ? {
    ...defaultIconProps,
    ...result
  } : null;
}

const defaultIconSizeCustomisations = Object.freeze({
  width: null,
  height: null
});
const defaultIconCustomisations = Object.freeze({
  ...defaultIconSizeCustomisations,
  ...defaultIconTransformations
});

const unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(size, ratio, precision) {
  if (ratio === 1) {
    return size;
  }
  precision = precision || 100;
  if (typeof size === "number") {
    return Math.ceil(size * ratio * precision) / precision;
  }
  if (typeof size !== "string") {
    return size;
  }
  const oldParts = size.split(unitsSplit);
  if (oldParts === null || !oldParts.length) {
    return size;
  }
  const newParts = [];
  let code = oldParts.shift();
  let isNumber = unitsTest.test(code);
  while (true) {
    if (isNumber) {
      const num = parseFloat(code);
      if (isNaN(num)) {
        newParts.push(code);
      } else {
        newParts.push(Math.ceil(num * ratio * precision) / precision);
      }
    } else {
      newParts.push(code);
    }
    code = oldParts.shift();
    if (code === void 0) {
      return newParts.join("");
    }
    isNumber = !isNumber;
  }
}

function iconToSVG(icon, customisations) {
  const fullIcon = {
    ...defaultIconProps,
    ...icon
  };
  const fullCustomisations = {
    ...defaultIconCustomisations,
    ...customisations
  };
  const box = {
    left: fullIcon.left,
    top: fullIcon.top,
    width: fullIcon.width,
    height: fullIcon.height
  };
  let body = fullIcon.body;
  [fullIcon, fullCustomisations].forEach((props) => {
    const transformations = [];
    const hFlip = props.hFlip;
    const vFlip = props.vFlip;
    let rotation = props.rotate;
    if (hFlip) {
      if (vFlip) {
        rotation += 2;
      } else {
        transformations.push(
          "translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")"
        );
        transformations.push("scale(-1 1)");
        box.top = box.left = 0;
      }
    } else if (vFlip) {
      transformations.push(
        "translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")"
      );
      transformations.push("scale(1 -1)");
      box.top = box.left = 0;
    }
    let tempValue;
    if (rotation < 0) {
      rotation -= Math.floor(rotation / 4) * 4;
    }
    rotation = rotation % 4;
    switch (rotation) {
      case 1:
        tempValue = box.height / 2 + box.top;
        transformations.unshift(
          "rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")"
        );
        break;
      case 2:
        transformations.unshift(
          "rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")"
        );
        break;
      case 3:
        tempValue = box.width / 2 + box.left;
        transformations.unshift(
          "rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")"
        );
        break;
    }
    if (rotation % 2 === 1) {
      if (box.left !== box.top) {
        tempValue = box.left;
        box.left = box.top;
        box.top = tempValue;
      }
      if (box.width !== box.height) {
        tempValue = box.width;
        box.width = box.height;
        box.height = tempValue;
      }
    }
    if (transformations.length) {
      body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    }
  });
  const customisationsWidth = fullCustomisations.width;
  const customisationsHeight = fullCustomisations.height;
  const boxWidth = box.width;
  const boxHeight = box.height;
  let width;
  let height;
  if (customisationsWidth === null) {
    height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    width = calculateSize(height, boxWidth / boxHeight);
  } else {
    width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
    height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
  }
  const result = {
    attributes: {
      width: width.toString(),
      height: height.toString(),
      viewBox: box.left.toString() + " " + box.top.toString() + " " + boxWidth.toString() + " " + boxHeight.toString()
    },
    body
  };
  return result;
}

const regex = /\sid="(\S+)"/g;
const randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let counter = 0;
function replaceIDs(body, prefix = randomPrefix) {
  const ids = [];
  let match;
  while (match = regex.exec(body)) {
    ids.push(match[1]);
  }
  if (!ids.length) {
    return body;
  }
  ids.forEach((id) => {
    const newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
    const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(
      new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"),
      "$1" + newID + "$3"
    );
  });
  return body;
}

const storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(provider, item) {
  storage[provider] = item;
}
function getAPIModule(provider) {
  return storage[provider] || storage[""];
}

function createAPIConfig(source) {
  let resources;
  if (typeof source.resources === "string") {
    resources = [source.resources];
  } else {
    resources = source.resources;
    if (!(resources instanceof Array) || !resources.length) {
      return null;
    }
  }
  const result = {
    resources,
    path: source.path || "/",
    maxURL: source.maxURL || 500,
    rotate: source.rotate || 750,
    timeout: source.timeout || 5e3,
    random: source.random === true,
    index: source.index || 0,
    dataAfterTimeout: source.dataAfterTimeout !== false
  };
  return result;
}
const configStorage = /* @__PURE__ */ Object.create(null);
const fallBackAPISources = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
];
const fallBackAPI = [];
while (fallBackAPISources.length > 0) {
  if (fallBackAPISources.length === 1) {
    fallBackAPI.push(fallBackAPISources.shift());
  } else {
    if (Math.random() > 0.5) {
      fallBackAPI.push(fallBackAPISources.shift());
    } else {
      fallBackAPI.push(fallBackAPISources.pop());
    }
  }
}
configStorage[""] = createAPIConfig({
  resources: ["https://api.iconify.design"].concat(fallBackAPI)
});
function addAPIProvider(provider, customConfig) {
  const config = createAPIConfig(customConfig);
  if (config === null) {
    return false;
  }
  configStorage[provider] = config;
  return true;
}
function getAPIConfig(provider) {
  return configStorage[provider];
}
function listAPIProviders() {
  return Object.keys(configStorage);
}

const detectFetch = () => {
  let callback;
  try {
    callback = fetch;
    if (typeof callback === "function") {
      return callback;
    }
  } catch (err) {
  }
};
let fetchModule = detectFetch();
function setFetch(fetch2) {
  fetchModule = fetch2;
}
function getFetch() {
  return fetchModule;
}
function calculateMaxLength(provider, prefix) {
  const config = getAPIConfig(provider);
  if (!config) {
    return 0;
  }
  let result;
  if (!config.maxURL) {
    result = 0;
  } else {
    let maxHostLength = 0;
    config.resources.forEach((item) => {
      const host = item;
      maxHostLength = Math.max(maxHostLength, host.length);
    });
    const url = prefix + ".json?icons=";
    result = config.maxURL - maxHostLength - config.path.length - url.length;
  }
  return result;
}
function shouldAbort(status) {
  return status === 404;
}
const prepare = (provider, prefix, icons) => {
  const results = [];
  const maxLength = calculateMaxLength(provider, prefix);
  const type = "icons";
  let item = {
    type,
    provider,
    prefix,
    icons: []
  };
  let length = 0;
  icons.forEach((name, index) => {
    length += name.length + 1;
    if (length >= maxLength && index > 0) {
      results.push(item);
      item = {
        type,
        provider,
        prefix,
        icons: []
      };
      length = name.length;
    }
    item.icons.push(name);
  });
  results.push(item);
  return results;
};
function getPath(provider) {
  if (typeof provider === "string") {
    const config = getAPIConfig(provider);
    if (config) {
      return config.path;
    }
  }
  return "/";
}
const send = (host, params, callback) => {
  if (!fetchModule) {
    callback("abort", 424);
    return;
  }
  let path = getPath(params.provider);
  switch (params.type) {
    case "icons": {
      const prefix = params.prefix;
      const icons = params.icons;
      const iconsList = icons.join(",");
      const urlParams = new URLSearchParams({
        icons: iconsList
      });
      path += prefix + ".json?" + urlParams.toString();
      break;
    }
    case "custom": {
      const uri = params.uri;
      path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
      break;
    }
    default:
      callback("abort", 400);
      return;
  }
  let defaultError = 503;
  fetchModule(host + path).then((response) => {
    const status = response.status;
    if (status !== 200) {
      setTimeout(() => {
        callback(shouldAbort(status) ? "abort" : "next", status);
      });
      return;
    }
    defaultError = 501;
    return response.json();
  }).then((data) => {
    if (typeof data !== "object" || data === null) {
      setTimeout(() => {
        callback("next", defaultError);
      });
      return;
    }
    setTimeout(() => {
      callback("success", data);
    });
  }).catch(() => {
    callback("next", defaultError);
  });
};
const fetchAPIModule = {
  prepare,
  send
};

function sortIcons(icons) {
  const result = {
    loaded: [],
    missing: [],
    pending: []
  };
  const storage = /* @__PURE__ */ Object.create(null);
  icons.sort((a, b) => {
    if (a.provider !== b.provider) {
      return a.provider.localeCompare(b.provider);
    }
    if (a.prefix !== b.prefix) {
      return a.prefix.localeCompare(b.prefix);
    }
    return a.name.localeCompare(b.name);
  });
  let lastIcon = {
    provider: "",
    prefix: "",
    name: ""
  };
  icons.forEach((icon) => {
    if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) {
      return;
    }
    lastIcon = icon;
    const provider = icon.provider;
    const prefix = icon.prefix;
    const name = icon.name;
    const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
    const localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
    let list;
    if (name in localStorage.icons) {
      list = result.loaded;
    } else if (prefix === "" || localStorage.missing.has(name)) {
      list = result.missing;
    } else {
      list = result.pending;
    }
    const item = {
      provider,
      prefix,
      name
    };
    list.push(item);
  });
  return result;
}

function removeCallback(storages, id) {
  storages.forEach((storage) => {
    const items = storage.loaderCallbacks;
    if (items) {
      storage.loaderCallbacks = items.filter((row) => row.id !== id);
    }
  });
}
function updateCallbacks(storage) {
  if (!storage.pendingCallbacksFlag) {
    storage.pendingCallbacksFlag = true;
    setTimeout(() => {
      storage.pendingCallbacksFlag = false;
      const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
      if (!items.length) {
        return;
      }
      let hasPending = false;
      const provider = storage.provider;
      const prefix = storage.prefix;
      items.forEach((item) => {
        const icons = item.icons;
        const oldLength = icons.pending.length;
        icons.pending = icons.pending.filter((icon) => {
          if (icon.prefix !== prefix) {
            return true;
          }
          const name = icon.name;
          if (storage.icons[name]) {
            icons.loaded.push({
              provider,
              prefix,
              name
            });
          } else if (storage.missing.has(name)) {
            icons.missing.push({
              provider,
              prefix,
              name
            });
          } else {
            hasPending = true;
            return true;
          }
          return false;
        });
        if (icons.pending.length !== oldLength) {
          if (!hasPending) {
            removeCallback([storage], item.id);
          }
          item.callback(
            icons.loaded.slice(0),
            icons.missing.slice(0),
            icons.pending.slice(0),
            item.abort
          );
        }
      });
    });
  }
}
let idCounter = 0;
function storeCallback(callback, icons, pendingSources) {
  const id = idCounter++;
  const abort = removeCallback.bind(null, pendingSources, id);
  if (!icons.pending.length) {
    return abort;
  }
  const item = {
    id,
    icons,
    callback,
    abort
  };
  pendingSources.forEach((storage) => {
    (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
  });
  return abort;
}

function listToIcons(list, validate = true, simpleNames = false) {
  const result = [];
  list.forEach((item) => {
    const icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames) : item;
    if (icon) {
      result.push(icon);
    }
  });
  return result;
}

// src/config.ts
var defaultConfig = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: false,
  dataAfterTimeout: false
};

// src/query.ts
function sendQuery(config, payload, query, done) {
  const resourcesCount = config.resources.length;
  const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
  let resources;
  if (config.random) {
    let list = config.resources.slice(0);
    resources = [];
    while (list.length > 1) {
      const nextIndex = Math.floor(Math.random() * list.length);
      resources.push(list[nextIndex]);
      list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
    }
    resources = resources.concat(list);
  } else {
    resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
  }
  const startTime = Date.now();
  let status = "pending";
  let queriesSent = 0;
  let lastError;
  let timer = null;
  let queue = [];
  let doneCallbacks = [];
  if (typeof done === "function") {
    doneCallbacks.push(done);
  }
  function resetTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function abort() {
    if (status === "pending") {
      status = "aborted";
    }
    resetTimer();
    queue.forEach((item) => {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }
  function subscribe(callback, overwrite) {
    if (overwrite) {
      doneCallbacks = [];
    }
    if (typeof callback === "function") {
      doneCallbacks.push(callback);
    }
  }
  function getQueryStatus() {
    return {
      startTime,
      payload,
      status,
      queriesSent,
      queriesPending: queue.length,
      subscribe,
      abort
    };
  }
  function failQuery() {
    status = "failed";
    doneCallbacks.forEach((callback) => {
      callback(void 0, lastError);
    });
  }
  function clearQueue() {
    queue.forEach((item) => {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }
  function moduleResponse(item, response, data) {
    const isError = response !== "success";
    queue = queue.filter((queued) => queued !== item);
    switch (status) {
      case "pending":
        break;
      case "failed":
        if (isError || !config.dataAfterTimeout) {
          return;
        }
        break;
      default:
        return;
    }
    if (response === "abort") {
      lastError = data;
      failQuery();
      return;
    }
    if (isError) {
      lastError = data;
      if (!queue.length) {
        if (!resources.length) {
          failQuery();
        } else {
          execNext();
        }
      }
      return;
    }
    resetTimer();
    clearQueue();
    if (!config.random) {
      const index = config.resources.indexOf(item.resource);
      if (index !== -1 && index !== config.index) {
        config.index = index;
      }
    }
    status = "completed";
    doneCallbacks.forEach((callback) => {
      callback(data);
    });
  }
  function execNext() {
    if (status !== "pending") {
      return;
    }
    resetTimer();
    const resource = resources.shift();
    if (resource === void 0) {
      if (queue.length) {
        timer = setTimeout(() => {
          resetTimer();
          if (status === "pending") {
            clearQueue();
            failQuery();
          }
        }, config.timeout);
        return;
      }
      failQuery();
      return;
    }
    const item = {
      status: "pending",
      resource,
      callback: (status2, data) => {
        moduleResponse(item, status2, data);
      }
    };
    queue.push(item);
    queriesSent++;
    timer = setTimeout(execNext, config.rotate);
    query(resource, payload, item.callback);
  }
  setTimeout(execNext);
  return getQueryStatus;
}

// src/index.ts
function initRedundancy(cfg) {
  const config = {
    ...defaultConfig,
    ...cfg
  };
  let queries = [];
  function cleanup() {
    queries = queries.filter((item) => item().status === "pending");
  }
  function query(payload, queryCallback, doneCallback) {
    const query2 = sendQuery(
      config,
      payload,
      queryCallback,
      (data, error) => {
        cleanup();
        if (doneCallback) {
          doneCallback(data, error);
        }
      }
    );
    queries.push(query2);
    return query2;
  }
  function find(callback) {
    return queries.find((value) => {
      return callback(value);
    }) || null;
  }
  const instance = {
    query,
    find,
    setIndex: (index) => {
      config.index = index;
    },
    getIndex: () => config.index,
    cleanup
  };
  return instance;
}

function emptyCallback$1() {
}
const redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(provider) {
  if (!redundancyCache[provider]) {
    const config = getAPIConfig(provider);
    if (!config) {
      return;
    }
    const redundancy = initRedundancy(config);
    const cachedReundancy = {
      config,
      redundancy
    };
    redundancyCache[provider] = cachedReundancy;
  }
  return redundancyCache[provider];
}
function sendAPIQuery(target, query, callback) {
  let redundancy;
  let send;
  if (typeof target === "string") {
    const api = getAPIModule(target);
    if (!api) {
      callback(void 0, 424);
      return emptyCallback$1;
    }
    send = api.send;
    const cached = getRedundancyCache(target);
    if (cached) {
      redundancy = cached.redundancy;
    }
  } else {
    const config = createAPIConfig(target);
    if (config) {
      redundancy = initRedundancy(config);
      const moduleKey = target.resources ? target.resources[0] : "";
      const api = getAPIModule(moduleKey);
      if (api) {
        send = api.send;
      }
    }
  }
  if (!redundancy || !send) {
    callback(void 0, 424);
    return emptyCallback$1;
  }
  return redundancy.query(query, send, callback)().abort;
}

const browserCacheVersion = "iconify2";
const browserCachePrefix = "iconify";
const browserCacheCountKey = browserCachePrefix + "-count";
const browserCacheVersionKey = browserCachePrefix + "-version";
const browserStorageHour = 36e5;
const browserStorageCacheExpiration = 168;

function getStoredItem(func, key) {
  try {
    return func.getItem(key);
  } catch (err) {
  }
}
function setStoredItem(func, key, value) {
  try {
    func.setItem(key, value);
    return true;
  } catch (err) {
  }
}
function removeStoredItem(func, key) {
  try {
    func.removeItem(key);
  } catch (err) {
  }
}

function setBrowserStorageItemsCount(storage, value) {
  return setStoredItem(storage, browserCacheCountKey, value.toString());
}
function getBrowserStorageItemsCount(storage) {
  return parseInt(getStoredItem(storage, browserCacheCountKey)) || 0;
}

const browserStorageConfig = {
  local: true,
  session: true
};
const browserStorageEmptyItems = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let browserStorageStatus = false;
function setBrowserStorageStatus(status) {
  browserStorageStatus = status;
}

let _window = typeof window === "undefined" ? {} : window;
function getBrowserStorage(key) {
  const attr = key + "Storage";
  try {
    if (_window && _window[attr] && typeof _window[attr].length === "number") {
      return _window[attr];
    }
  } catch (err) {
  }
  browserStorageConfig[key] = false;
}

function iterateBrowserStorage(key, callback) {
  const func = getBrowserStorage(key);
  if (!func) {
    return;
  }
  const version = getStoredItem(func, browserCacheVersionKey);
  if (version !== browserCacheVersion) {
    if (version) {
      const total2 = getBrowserStorageItemsCount(func);
      for (let i = 0; i < total2; i++) {
        removeStoredItem(func, browserCachePrefix + i.toString());
      }
    }
    setStoredItem(func, browserCacheVersionKey, browserCacheVersion);
    setBrowserStorageItemsCount(func, 0);
    return;
  }
  const minTime = Math.floor(Date.now() / browserStorageHour) - browserStorageCacheExpiration;
  const parseItem = (index) => {
    const name = browserCachePrefix + index.toString();
    const item = getStoredItem(func, name);
    if (typeof item !== "string") {
      return;
    }
    try {
      const data = JSON.parse(item);
      if (typeof data === "object" && typeof data.cached === "number" && data.cached > minTime && typeof data.provider === "string" && typeof data.data === "object" && typeof data.data.prefix === "string" && callback(data, index)) {
        return true;
      }
    } catch (err) {
    }
    removeStoredItem(func, name);
  };
  let total = getBrowserStorageItemsCount(func);
  for (let i = total - 1; i >= 0; i--) {
    if (!parseItem(i)) {
      if (i === total - 1) {
        total--;
        setBrowserStorageItemsCount(func, total);
      } else {
        browserStorageEmptyItems[key].add(i);
      }
    }
  }
}

function initBrowserStorage() {
  if (browserStorageStatus) {
    return;
  }
  setBrowserStorageStatus(true);
  for (const key in browserStorageConfig) {
    iterateBrowserStorage(key, (item) => {
      const iconSet = item.data;
      const provider = item.provider;
      const prefix = iconSet.prefix;
      const storage = getStorage(
        provider,
        prefix
      );
      if (!addIconSet(storage, iconSet).length) {
        return false;
      }
      const lastModified = iconSet.lastModified || -1;
      storage.lastModifiedCached = storage.lastModifiedCached ? Math.min(storage.lastModifiedCached, lastModified) : lastModified;
      return true;
    });
  }
}

function updateLastModified(storage, lastModified) {
  const lastValue = storage.lastModifiedCached;
  if (lastValue && lastValue >= lastModified) {
    return lastValue === lastModified;
  }
  storage.lastModifiedCached = lastModified;
  if (lastValue) {
    for (const key in browserStorageConfig) {
      iterateBrowserStorage(key, (item) => {
        const iconSet = item.data;
        return item.provider !== storage.provider || iconSet.prefix !== storage.prefix || iconSet.lastModified === lastModified;
      });
    }
  }
  return true;
}
function storeInBrowserStorage(storage, data) {
  if (!browserStorageStatus) {
    initBrowserStorage();
  }
  function store(key) {
    let func;
    if (!browserStorageConfig[key] || !(func = getBrowserStorage(key))) {
      return;
    }
    const set = browserStorageEmptyItems[key];
    let index;
    if (set.size) {
      set.delete(index = Array.from(set).shift());
    } else {
      index = getBrowserStorageItemsCount(func);
      if (!setBrowserStorageItemsCount(func, index + 1)) {
        return;
      }
    }
    const item = {
      cached: Math.floor(Date.now() / browserStorageHour),
      provider: storage.provider,
      data
    };
    return setStoredItem(
      func,
      browserCachePrefix + index.toString(),
      JSON.stringify(item)
    );
  }
  if (data.lastModified && !updateLastModified(storage, data.lastModified)) {
    return;
  }
  if (!Object.keys(data.icons).length) {
    return;
  }
  if (data.not_found) {
    data = Object.assign({}, data);
    delete data.not_found;
  }
  if (!store("local")) {
    store("session");
  }
}

function emptyCallback() {
}
function loadedNewIcons(storage) {
  if (!storage.iconsLoaderFlag) {
    storage.iconsLoaderFlag = true;
    setTimeout(() => {
      storage.iconsLoaderFlag = false;
      updateCallbacks(storage);
    });
  }
}
function loadNewIcons(storage, icons) {
  if (!storage.iconsToLoad) {
    storage.iconsToLoad = icons;
  } else {
    storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
  }
  if (!storage.iconsQueueFlag) {
    storage.iconsQueueFlag = true;
    setTimeout(() => {
      storage.iconsQueueFlag = false;
      const { provider, prefix } = storage;
      const icons2 = storage.iconsToLoad;
      delete storage.iconsToLoad;
      let api;
      if (!icons2 || !(api = getAPIModule(provider))) {
        return;
      }
      const params = api.prepare(provider, prefix, icons2);
      params.forEach((item) => {
        sendAPIQuery(provider, item, (data, error) => {
          if (typeof data !== "object") {
            if (error !== 404) {
              return;
            }
            item.icons.forEach((name) => {
              storage.missing.add(name);
            });
          } else {
            try {
              const parsed = addIconSet(
                storage,
                data
              );
              if (!parsed.length) {
                return;
              }
              const pending = storage.pendingIcons;
              if (pending) {
                parsed.forEach((name) => {
                  pending.delete(name);
                });
              }
              storeInBrowserStorage(storage, data);
            } catch (err) {
              console.error(err);
            }
          }
          loadedNewIcons(storage);
        });
      });
    });
  }
}
const loadIcons = (icons, callback) => {
  const cleanedIcons = listToIcons(icons, true, allowSimpleNames());
  const sortedIcons = sortIcons(cleanedIcons);
  if (!sortedIcons.pending.length) {
    let callCallback = true;
    if (callback) {
      setTimeout(() => {
        if (callCallback) {
          callback(
            sortedIcons.loaded,
            sortedIcons.missing,
            sortedIcons.pending,
            emptyCallback
          );
        }
      });
    }
    return () => {
      callCallback = false;
    };
  }
  const newIcons = /* @__PURE__ */ Object.create(null);
  const sources = [];
  let lastProvider, lastPrefix;
  sortedIcons.pending.forEach((icon) => {
    const { provider, prefix } = icon;
    if (prefix === lastPrefix && provider === lastProvider) {
      return;
    }
    lastProvider = provider;
    lastPrefix = prefix;
    sources.push(getStorage(provider, prefix));
    const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
    if (!providerNewIcons[prefix]) {
      providerNewIcons[prefix] = [];
    }
  });
  sortedIcons.pending.forEach((icon) => {
    const { provider, prefix, name } = icon;
    const storage = getStorage(provider, prefix);
    const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
    if (!pendingQueue.has(name)) {
      pendingQueue.add(name);
      newIcons[provider][prefix].push(name);
    }
  });
  sources.forEach((storage) => {
    const { provider, prefix } = storage;
    if (newIcons[provider][prefix].length) {
      loadNewIcons(storage, newIcons[provider][prefix]);
    }
  });
  return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};
const loadIcon = (icon) => {
  return new Promise((fulfill, reject) => {
    const iconObj = typeof icon === "string" ? stringToIcon(icon) : icon;
    loadIcons([iconObj || icon], (loaded) => {
      if (loaded.length && iconObj) {
        const data = getIconData(iconObj);
        if (data) {
          fulfill({
            ...defaultIconProps,
            ...data
          });
          return;
        }
      }
      reject(icon);
    });
  });
};

function toggleBrowserCache(storage, value) {
  switch (storage) {
    case "local":
    case "session":
      browserStorageConfig[storage] = value;
      break;
    case "all":
      for (const key in browserStorageConfig) {
        browserStorageConfig[key] = value;
      }
      break;
  }
}

function mergeCustomisations(defaults, item) {
  const result = {
    ...defaults
  };
  for (const key in item) {
    const value = item[key];
    const valueType = typeof value;
    if (key in defaultIconSizeCustomisations) {
      if (value === null || value && (valueType === "string" || valueType === "number")) {
        result[key] = value;
      }
    } else if (valueType === typeof result[key]) {
      result[key] = key === "rotate" ? value % 4 : value;
    }
  }
  return result;
}

const separator = /[\s,]+/;
function flipFromString(custom, flip) {
  flip.split(separator).forEach((str) => {
    const value = str.trim();
    switch (value) {
      case "horizontal":
        custom.hFlip = true;
        break;
      case "vertical":
        custom.vFlip = true;
        break;
    }
  });
}

function rotateFromString(value, defaultValue = 0) {
  const units = value.replace(/^-?[0-9.]*/, "");
  function cleanup(value2) {
    while (value2 < 0) {
      value2 += 4;
    }
    return value2 % 4;
  }
  if (units === "") {
    const num = parseInt(value);
    return isNaN(num) ? 0 : cleanup(num);
  } else if (units !== value) {
    let split = 0;
    switch (units) {
      case "%":
        split = 25;
        break;
      case "deg":
        split = 90;
    }
    if (split) {
      let num = parseFloat(value.slice(0, value.length - units.length));
      if (isNaN(num)) {
        return 0;
      }
      num = num / split;
      return num % 1 === 0 ? cleanup(num) : 0;
    }
  }
  return defaultValue;
}

function iconToHTML(body, attributes) {
  let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const attr in attributes) {
    renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}

function encodeSVGforURL(svg) {
  return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToURL(svg) {
  return 'url("data:image/svg+xml,' + encodeSVGforURL(svg) + '")';
}

const defaultExtendedIconCustomisations = {
    ...defaultIconCustomisations,
    inline: false,
};

/**
 * Default SVG attributes
 */
const svgDefaults = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlnsXlink': 'http://www.w3.org/1999/xlink',
    'aria-hidden': true,
    'role': 'img',
};
/**
 * Style modes
 */
const commonProps = {
    display: 'inline-block',
};
const monotoneProps = {
    backgroundColor: 'currentColor',
};
const coloredProps = {
    backgroundColor: 'transparent',
};
// Dynamically add common props to variables above
const propsToAdd = {
    Image: 'var(--svg)',
    Repeat: 'no-repeat',
    Size: '100% 100%',
};
const propsToAddTo = {
    webkitMask: monotoneProps,
    mask: monotoneProps,
    background: coloredProps,
};
for (const prefix in propsToAddTo) {
    const list = propsToAddTo[prefix];
    for (const prop in propsToAdd) {
        list[prefix + prop] = propsToAdd[prop];
    }
}
/**
 * Default values for customisations for inline icon
 */
const inlineDefaults = {
    ...defaultExtendedIconCustomisations,
    inline: true,
};
/**
 * Fix size: add 'px' to numbers
 */
function fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */
const render = (
// Icon must be validated before calling this function
icon, 
// Partial properties
props, 
// True if icon should have vertical-align added
inline, 
// Optional reference for SVG/SPAN, extracted by React.forwardRef()
ref) => {
    // Get default properties
    const defaultProps = inline
        ? inlineDefaults
        : defaultExtendedIconCustomisations;
    // Get all customisations
    const customisations = mergeCustomisations(defaultProps, props);
    // Check mode
    const mode = props.mode || 'svg';
    // Create style
    const style = {};
    const customStyle = props.style || {};
    // Create SVG component properties
    const componentProps = {
        ...(mode === 'svg' ? svgDefaults : {}),
        ref,
    };
    // Get element properties
    for (let key in props) {
        const value = props[key];
        if (value === void 0) {
            continue;
        }
        switch (key) {
            // Properties to ignore
            case 'icon':
            case 'style':
            case 'children':
            case 'onLoad':
            case 'mode':
            case '_ref':
            case '_inline':
                break;
            // Boolean attributes
            case 'inline':
            case 'hFlip':
            case 'vFlip':
                customisations[key] =
                    value === true || value === 'true' || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case 'flip':
                if (typeof value === 'string') {
                    flipFromString(customisations, value);
                }
                break;
            // Color: copy to style
            case 'color':
                style.color = value;
                break;
            // Rotation as string
            case 'rotate':
                if (typeof value === 'string') {
                    customisations[key] = rotateFromString(value);
                }
                else if (typeof value === 'number') {
                    customisations[key] = value;
                }
                break;
            // Remove aria-hidden
            case 'ariaHidden':
            case 'aria-hidden':
                if (value !== true && value !== 'true') {
                    delete componentProps['aria-hidden'];
                }
                break;
            // Copy missing property if it does not exist in customisations
            default:
                if (defaultProps[key] === void 0) {
                    componentProps[key] = value;
                }
        }
    }
    // Generate icon
    const item = iconToSVG(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) {
        style.verticalAlign = '-0.125em';
    }
    if (mode === 'svg') {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle,
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === 'string') {
            // Convert '-' to '_' to avoid errors in animations
            id = id.replace(/-/g, '_');
        }
        // Add icon stuff
        componentProps.dangerouslySetInnerHTML = {
            __html: replaceIDs(item.body, id ? () => id + 'ID' + localCounter++ : 'iconifyReact'),
        };
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement('svg', componentProps);
    }
    // Render <span> with style
    const { body, width, height } = icon;
    const useMask = mode === 'mask' ||
        (mode === 'bg' ? false : body.indexOf('currentColor') !== -1);
    // Generate SVG
    const html = iconToHTML(body, {
        ...renderAttribs,
        width: width + '',
        height: height + '',
    });
    // Generate style
    componentProps.style = {
        ...style,
        '--svg': svgToURL(html),
        'width': fixSize(renderAttribs.width),
        'height': fixSize(renderAttribs.height),
        ...commonProps,
        ...(useMask ? monotoneProps : coloredProps),
        ...customStyle,
    };
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement('span', componentProps);
};

/**
 * Enable cache
 */
function enableCache(storage) {
    toggleBrowserCache(storage, true);
}
/**
 * Disable cache
 */
function disableCache(storage) {
    toggleBrowserCache(storage, false);
}
/**
 * Initialise stuff
 */
// Enable short names
allowSimpleNames(true);
// Set API module
setAPIModule('', fetchAPIModule);
/**
 * Browser stuff
 */
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    // Set cache and load existing cache
    initBrowserStorage();
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = 'Invalid IconifyPreload syntax.';
        if (typeof preload === 'object' && preload !== null) {
            (preload instanceof Array ? preload : [preload]).forEach((item) => {
                try {
                    if (
                    // Check if item is an object and not null/array
                    typeof item !== 'object' ||
                        item === null ||
                        item instanceof Array ||
                        // Check for 'icons' and 'prefix'
                        typeof item.icons !== 'object' ||
                        typeof item.prefix !== 'string' ||
                        // Add icon set
                        !addCollection(item)) {
                        console.error(err);
                    }
                }
                catch (e) {
                    console.error(err);
                }
            });
        }
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === 'object' && providers !== null) {
            for (let key in providers) {
                const err = 'IconifyProviders[' + key + '] is invalid.';
                try {
                    const value = providers[key];
                    if (typeof value !== 'object' ||
                        !value ||
                        value.resources === void 0) {
                        continue;
                    }
                    if (!addAPIProvider(key, value)) {
                        console.error(err);
                    }
                }
                catch (e) {
                    console.error(err);
                }
            }
        }
    }
}
class IconComponent extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Render placeholder before component is mounted
            icon: null,
        };
    }
    /**
     * Abort loading icon
     */
    _abortLoading() {
        if (this._loading) {
            this._loading.abort();
            this._loading = null;
        }
    }
    /**
     * Update state
     */
    _setData(icon) {
        if (this.state.icon !== icon) {
            this.setState({
                icon,
            });
        }
    }
    /**
     * Check if icon should be loaded
     */
    _checkIcon(changed) {
        const state = this.state;
        const icon = this.props.icon;
        // Icon is an object
        if (typeof icon === 'object' &&
            icon !== null &&
            typeof icon.body === 'string') {
            // Stop loading
            this._icon = '';
            this._abortLoading();
            if (changed || state.icon === null) {
                // Set data if it was changed
                this._setData({
                    data: icon,
                });
            }
            return;
        }
        // Invalid icon?
        let iconName;
        if (typeof icon !== 'string' ||
            (iconName = stringToIcon(icon, false, true)) === null) {
            this._abortLoading();
            this._setData(null);
            return;
        }
        // Load icon
        const data = getIconData(iconName);
        if (!data) {
            // Icon data is not available
            if (!this._loading || this._loading.name !== icon) {
                // New icon to load
                this._abortLoading();
                this._icon = '';
                this._setData(null);
                if (data !== null) {
                    // Icon was not loaded
                    this._loading = {
                        name: icon,
                        abort: loadIcons([iconName], this._checkIcon.bind(this, false)),
                    };
                }
            }
            return;
        }
        // Icon data is available
        if (this._icon !== icon || state.icon === null) {
            // New icon or icon has been loaded
            this._abortLoading();
            this._icon = icon;
            // Add classes
            const classes = ['iconify'];
            if (iconName.prefix !== '') {
                classes.push('iconify--' + iconName.prefix);
            }
            if (iconName.provider !== '') {
                classes.push('iconify--' + iconName.provider);
            }
            // Set data
            this._setData({
                data,
                classes,
            });
            if (this.props.onLoad) {
                this.props.onLoad(icon);
            }
        }
    }
    /**
     * Component mounted
     */
    componentDidMount() {
        this._checkIcon(false);
    }
    /**
     * Component updated
     */
    componentDidUpdate(oldProps) {
        if (oldProps.icon !== this.props.icon) {
            this._checkIcon(true);
        }
    }
    /**
     * Abort loading
     */
    componentWillUnmount() {
        this._abortLoading();
    }
    /**
     * Render
     */
    render() {
        const props = this.props;
        const icon = this.state.icon;
        if (icon === null) {
            // Render placeholder
            return props.children
                ? props.children
                : react__WEBPACK_IMPORTED_MODULE_0__.createElement('span', {});
        }
        // Add classes
        let newProps = props;
        if (icon.classes) {
            newProps = {
                ...props,
                className: (typeof props.className === 'string'
                    ? props.className + ' '
                    : '') + icon.classes.join(' '),
            };
        }
        // Render icon
        return render({
            ...defaultIconProps,
            ...icon.data,
        }, newProps, props._inline, props._ref);
    }
}
/**
 * Block icon
 *
 * @param props - Component properties
 */
const Icon = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Icon(props, ref) {
    const newProps = {
        ...props,
        _ref: ref,
        _inline: false,
    };
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconComponent, newProps);
});
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */
const InlineIcon = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function InlineIcon(props, ref) {
    const newProps = { ...props, _ref: ref, _inline: true };
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconComponent, newProps);
});
/**
 * Internal API
 */
const _api = {
    getAPIConfig,
    setAPIModule,
    sendAPIQuery,
    setFetch,
    getFetch,
    listAPIProviders,
};




/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 8676:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cm": function() { return /* binding */ O; },
  "P5": function() { return /* binding */ z; }
});

// UNUSED EXPORTS: FlagContext, InMemoryStorageProvider, LocalStorageProvider, UnleashClient, default, useFlags, useFlagsStatus, useUnleashClient, useUnleashContext, useVariant

;// CONCATENATED MODULE: ./node_modules/unleash-proxy-client/build/main.esm.js
var t=function(e,r){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])},t(e,r)};var e=function(){return e=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var o in e=arguments[r])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},e.apply(this,arguments)};function r(t,e,r,n){return new(r||(r=Promise))((function(o,i){function s(t){try{c(n.next(t))}catch(t){i(t)}}function a(t){try{c(n.throw(t))}catch(t){i(t)}}function c(t){var e;t.done?o(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(s,a)}c((n=n.apply(t,e||[])).next())}))}function n(t,e){var r,n,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(a){return function(c){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;i&&(i=0,a[0]&&(s=0)),s;)try{if(r=1,n&&(o=2&a[0]?n.return:a[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,a[1])).done)return o;switch(n=0,o&&(a=[2&a[0],o.value]),a[0]){case 0:case 1:o=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,n=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!(o=s.trys,(o=o.length>0&&o[o.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!o||a[1]>o[0]&&a[1]<o[3])){s.label=a[1];break}if(6===a[0]&&s.label<o[1]){s.label=o[1],o=a;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(a);break}o[2]&&s.ops.pop(),s.trys.pop();continue}a=e.call(t,s)}catch(t){a=[6,t],n=0}finally{r=o=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,c])}}}"function"==typeof SuppressedError&&SuppressedError;var o={exports:{}};function i(){}i.prototype={on:function(t,e,r){var n=this.e||(this.e={});return(n[t]||(n[t]=[])).push({fn:e,ctx:r}),this},once:function(t,e,r){var n=this;function o(){n.off(t,o),e.apply(r,arguments)}return o._=e,this.on(t,o,r)},emit:function(t){for(var e=[].slice.call(arguments,1),r=((this.e||(this.e={}))[t]||[]).slice(),n=0,o=r.length;n<o;n++)r[n].fn.apply(r[n].ctx,e);return this},off:function(t,e){var r=this.e||(this.e={}),n=r[t],o=[];if(n&&e)for(var i=0,s=n.length;i<s;i++)n[i].fn!==e&&n[i].fn._!==e&&o.push(n[i]);return o.length?r[t]=o:delete r[t],this}},o.exports=i;var s=o.exports.TinyEmitter=i,a=function(t){var e=t[1];return null!=e},c=function(){},u=function(){function t(t){var e=t.onError,r=t.onSent,n=t.appName,o=t.metricsInterval,i=t.disableMetrics,s=void 0!==i&&i,a=t.url,u=t.clientKey,h=t.fetch,l=t.headerName,p=t.customHeaders,f=void 0===p?{}:p,d=t.metricsIntervalInitial;this.onError=e,this.onSent=r||c,this.disabled=s,this.metricsInterval=1e3*o,this.metricsIntervalInitial=1e3*d,this.appName=n,this.url=a instanceof URL?a:new URL(a),this.clientKey=u,this.bucket=this.createEmptyBucket(),this.fetch=h,this.headerName=l,this.customHeaders=f}return t.prototype.start=function(){var t=this;if(this.disabled)return!1;"number"==typeof this.metricsInterval&&this.metricsInterval>0&&(this.metricsIntervalInitial>0?setTimeout((function(){t.startTimer(),t.sendMetrics()}),this.metricsIntervalInitial):this.startTimer())},t.prototype.stop=function(){this.timer&&(clearTimeout(this.timer),delete this.timer)},t.prototype.createEmptyBucket=function(){return{start:new Date,stop:null,toggles:{}}},t.prototype.getHeaders=function(){var t,e=((t={})[this.headerName]=this.clientKey,t.Accept="application/json",t["Content-Type"]="application/json",t);return Object.entries(this.customHeaders).filter(a).forEach((function(t){var r=t[0],n=t[1];return e[r]=n})),e},t.prototype.sendMetrics=function(){return r(this,void 0,void 0,(function(){var t,e,r;return n(this,(function(n){switch(n.label){case 0:if(t="".concat(this.url,"/client/metrics"),e=this.getPayload(),this.bucketIsEmpty(e))return[2];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,this.fetch(t,{cache:"no-cache",method:"POST",headers:this.getHeaders(),body:JSON.stringify(e)})];case 2:return n.sent(),this.onSent(e),[3,4];case 3:return r=n.sent(),console.error("Unleash: unable to send feature metrics",r),this.onError(r),[3,4];case 4:return[2]}}))}))},t.prototype.count=function(t,e){return!(this.disabled||!this.bucket)&&(this.assertBucket(t),this.bucket.toggles[t][e?"yes":"no"]++,!0)},t.prototype.countVariant=function(t,e){return!(this.disabled||!this.bucket)&&(this.assertBucket(t),this.bucket.toggles[t].variants[e]?this.bucket.toggles[t].variants[e]+=1:this.bucket.toggles[t].variants[e]=1,!0)},t.prototype.assertBucket=function(t){if(this.disabled||!this.bucket)return!1;this.bucket.toggles[t]||(this.bucket.toggles[t]={yes:0,no:0,variants:{}})},t.prototype.startTimer=function(){var t=this;this.timer=setInterval((function(){t.sendMetrics()}),this.metricsInterval)},t.prototype.bucketIsEmpty=function(t){return 0===Object.keys(t.bucket.toggles).length},t.prototype.getPayload=function(){var t=e(e({},this.bucket),{stop:new Date});return this.bucket=this.createEmptyBucket(),{bucket:t,appName:this.appName,instanceId:"browser"}},t}(),h=function(){function t(){this.store=new Map}return t.prototype.save=function(t,e){return r(this,void 0,void 0,(function(){return n(this,(function(r){return this.store.set(t,e),[2]}))}))},t.prototype.get=function(t){return r(this,void 0,void 0,(function(){return n(this,(function(e){return[2,this.store.get(t)]}))}))},t}(),l=function(){function t(){this.prefix="unleash:repository"}return t.prototype.save=function(t,e){return r(this,void 0,void 0,(function(){var r,o;return n(this,(function(n){r=JSON.stringify(e),o="".concat(this.prefix,":").concat(t);try{window.localStorage.setItem(o,r)}catch(t){console.error(t)}return[2]}))}))},t.prototype.get=function(t){try{var e="".concat(this.prefix,":").concat(t),r=window.localStorage.getItem(e);return r?JSON.parse(r):void 0}catch(t){console.error(t)}},t}();let main_esm_p;const f=new Uint8Array(16);function d(){if(!main_esm_p&&(main_esm_p="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!main_esm_p))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return main_esm_p(f)}const v=[];for(let t=0;t<256;++t)v.push((t+256).toString(16).slice(1));var m={randomUUID:"undefined"!=typeof crypto&&crypto.randomUUID&&crypto.randomUUID.bind(crypto)};function main_esm_y(t,e,r){if(m.randomUUID&&!e&&!t)return m.randomUUID();const n=(t=t||{}).random||(t.rng||d)();if(n[6]=15&n[6]|64,n[8]=63&n[8]|128,e){r=r||0;for(let t=0;t<16;++t)e[r+t]=n[t];return e}return function(t,e=0){return v[t[e+0]]+v[t[e+1]]+v[t[e+2]]+v[t[e+3]]+"-"+v[t[e+4]]+v[t[e+5]]+"-"+v[t[e+6]]+v[t[e+7]]+"-"+v[t[e+8]]+v[t[e+9]]+"-"+v[t[e+10]]+v[t[e+11]]+v[t[e+12]]+v[t[e+13]]+v[t[e+14]]+v[t[e+15]]}(n)}var g=function(){function t(){}return t.prototype.generateEventId=function(){return main_esm_y()},t.prototype.createImpressionEvent=function(t,r,n,o,i,s){var a=this.createBaseEvent(t,r,n,o,i);return s?e(e({},a),{variant:s}):a},t.prototype.createBaseEvent=function(t,e,r,n,o){return{eventType:n,eventId:this.generateEventId(),context:t,enabled:e,featureName:r,impressionData:o}},t}(),main_esm_b=["userId","sessionId","remoteAddress","currentTime"],E=function(t){return main_esm_b.includes(t)},w={INIT:"initialized",ERROR:"error",READY:"ready",UPDATE:"update",IMPRESSION:"impression",SENT:"sent",RECOVERED:"recovered"},I="isEnabled",S="getVariant",x={name:"disabled",enabled:!1,feature_enabled:!1},T="repo",R=function(){try{if("undefined"!=typeof window&&"fetch"in window)return fetch.bind(window);if("fetch"in globalThis)return fetch.bind(globalThis)}catch(t){console.error('Unleash failed to resolve "fetch"',t)}},k=function(o){function i(t){var r=t.storageProvider,n=t.url,i=t.clientKey,s=t.disableRefresh,a=void 0!==s&&s,c=t.refreshInterval,p=void 0===c?30:c,f=t.metricsInterval,d=void 0===f?30:f,v=t.metricsIntervalInitial,m=void 0===v?2:v,y=t.disableMetrics,b=void 0!==y&&y,E=t.appName,I=t.environment,S=void 0===I?"default":I,x=t.context,T=t.fetch,k=void 0===T?R():T,O=t.createAbortController,N=void 0===O?function(){try{if("undefined"!=typeof window&&"AbortController"in window)return function(){return new window.AbortController};if("fetch"in globalThis)return function(){return new globalThis.AbortController}}catch(t){console.error('Unleash failed to resolve "AbortController" factory',t)}}():O,A=t.bootstrap,D=t.bootstrapOverride,U=void 0===D||D,C=t.headerName,P=void 0===C?"Authorization":C,j=t.customHeaders,H=void 0===j?{}:j,M=t.impressionDataAll,_=void 0!==M&&M,K=t.usePOSTrequests,V=void 0!==K&&K,q=o.call(this)||this;if(q.toggles=[],q.etag="",q.readyEventEmitted=!1,q.fetchedFromServer=!1,q.usePOSTrequests=!1,q.started=!1,!n)throw new Error("url is required");if(!i)throw new Error("clientKey is required");if(!E)throw new Error("appName is required.");return q.eventsHandler=new g,q.impressionDataAll=_,q.toggles=A&&A.length>0?A:[],q.url=n instanceof URL?n:new URL(n),q.clientKey=i,q.headerName=P,q.customHeaders=H,q.storage=r||("undefined"!=typeof window?new l:new h),q.refreshInterval=a?0:1e3*p,q.context=e({appName:E,environment:S},x),q.usePOSTrequests=V,q.sdkState="initializing",q.ready=new Promise((function(t){q.init().then(t).catch((function(e){console.error(e),q.sdkState="error",q.emit(w.ERROR,e),q.lastError=e,t()}))})),k||console.error('Unleash: You must either provide your own "fetch" implementation or run in an environment where "fetch" is available.'),N||console.error('Unleash: You must either provide your own "AbortController" implementation or run in an environment where "AbortController" is available.'),q.fetch=k,q.createAbortController=N,q.bootstrap=A&&A.length>0?A:void 0,q.bootstrapOverride=U,q.metrics=new u({onError:q.emit.bind(q,w.ERROR),onSent:q.emit.bind(q,w.SENT),appName:E,metricsInterval:d,disableMetrics:b,url:q.url,clientKey:i,fetch:k,headerName:P,customHeaders:H,metricsIntervalInitial:m}),q}return function(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Class extends value "+String(r)+" is not a constructor or null");function n(){this.constructor=e}t(e,r),e.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}(i,o),i.prototype.getAllToggles=function(){return function(t,e,r){if(r||2===arguments.length)for(var n,o=0,i=e.length;o<i;o++)!n&&o in e||(n||(n=Array.prototype.slice.call(e,0,o)),n[o]=e[o]);return t.concat(n||Array.prototype.slice.call(e))}([],this.toggles,!0)},i.prototype.isEnabled=function(t){var e,r=this.toggles.find((function(e){return e.name===t})),n=!!r&&r.enabled;if(this.metrics.count(t,n),(null==r?void 0:r.impressionData)||this.impressionDataAll){var o=this.eventsHandler.createImpressionEvent(this.context,n,t,I,null!==(e=null==r?void 0:r.impressionData)&&void 0!==e?e:void 0);this.emit(w.IMPRESSION,o)}return n},i.prototype.getVariant=function(t){var r,n=this.toggles.find((function(e){return e.name===t})),o=(null==n?void 0:n.enabled)||!1,i=n?n.variant:x;if(i.name&&this.metrics.countVariant(t,i.name),this.metrics.count(t,o),(null==n?void 0:n.impressionData)||this.impressionDataAll){var s=this.eventsHandler.createImpressionEvent(this.context,o,t,S,null!==(r=null==n?void 0:n.impressionData)&&void 0!==r?r:void 0,i.name);this.emit(w.IMPRESSION,s)}return e(e({},i),{feature_enabled:o})},i.prototype.updateToggles=function(){return r(this,void 0,void 0,(function(){var t=this;return n(this,(function(e){switch(e.label){case 0:return this.timerRef||this.fetchedFromServer?[4,this.fetchToggles()]:[3,2];case 1:return e.sent(),[3,4];case 2:return this.started?[4,new Promise((function(e){var r=function(){t.fetchToggles().then((function(){t.off(w.READY,r),e()}))};t.once(w.READY,r)}))]:[3,4];case 3:e.sent(),e.label=4;case 4:return[2]}}))}))},i.prototype.updateContext=function(t){return r(this,void 0,void 0,(function(){var r;return n(this,(function(n){switch(n.label){case 0:return(t.appName||t.environment)&&console.warn("appName and environment are static. They can't be updated with updateContext."),r={environment:this.context.environment,appName:this.context.appName,sessionId:this.context.sessionId},this.context=e(e({},r),t),[4,this.updateToggles()];case 1:return n.sent(),[2]}}))}))},i.prototype.getContext=function(){return e({},this.context)},i.prototype.setContextField=function(t,r){var n,o;if(E(t))this.context=e(e({},this.context),((n={})[t]=r,n));else{var i=e(e({},this.context.properties),((o={})[t]=r,o));this.context=e(e({},this.context),{properties:i})}this.updateToggles()},i.prototype.removeContextField=function(t){var r;E(t)?this.context=e(e({},this.context),((r={})[t]=void 0,r)):"object"==typeof this.context.properties&&delete this.context.properties[t],this.updateToggles()},i.prototype.init=function(){return r(this,void 0,void 0,(function(){var t,r;return n(this,(function(n){switch(n.label){case 0:return[4,this.resolveSessionId()];case 1:return t=n.sent(),this.context=e({sessionId:t},this.context),r=this,[4,this.storage.get(T)];case 2:return r.toggles=n.sent()||[],!this.bootstrap||!this.bootstrapOverride&&0!==this.toggles.length?[3,4]:[4,this.storage.save(T,this.bootstrap)];case 3:n.sent(),this.toggles=this.bootstrap,this.sdkState="healthy",this.readyEventEmitted=!0,this.emit(w.READY),n.label=4;case 4:return this.sdkState="healthy",this.emit(w.INIT),[2]}}))}))},i.prototype.start=function(){return r(this,void 0,void 0,(function(){var t,e=this;return n(this,(function(r){switch(r.label){case 0:return this.started=!0,this.timerRef?(console.error("Unleash SDK has already started, if you want to restart the SDK you should call client.stop() before starting again."),[2]):[4,this.ready];case 1:return r.sent(),this.metrics.start(),t=this.refreshInterval,[4,this.fetchToggles()];case 2:return r.sent(),t>0&&(this.timerRef=setInterval((function(){return e.fetchToggles()}),t)),[2]}}))}))},i.prototype.stop=function(){this.timerRef&&(clearInterval(this.timerRef),this.timerRef=void 0),this.metrics.stop()},i.prototype.isReady=function(){return this.readyEventEmitted},i.prototype.getError=function(){return"error"===this.sdkState?this.lastError:void 0},i.prototype.resolveSessionId=function(){return r(this,void 0,void 0,(function(){var t;return n(this,(function(e){switch(e.label){case 0:return this.context.sessionId?[2,this.context.sessionId]:[4,this.storage.get("sessionId")];case 1:return(t=e.sent())?[3,3]:(t=Math.floor(1e9*Math.random()),[4,this.storage.save("sessionId",t)]);case 2:e.sent(),e.label=3;case 3:return[2,t]}}))}))},i.prototype.getHeaders=function(){var t,e=this.usePOSTrequests,r=((t={})[this.headerName]=this.clientKey,t.Accept="application/json",t);return e&&(r["Content-Type"]="application/json"),this.etag&&(r["If-None-Match"]=this.etag),Object.entries(this.customHeaders).filter(a).forEach((function(t){var e=t[0],n=t[1];return r[e]=n})),r},i.prototype.storeToggles=function(t){return r(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return this.toggles=t,this.emit(w.UPDATE),[4,this.storage.save(T,t)];case 1:return e.sent(),[2]}}))}))},i.prototype.fetchToggles=function(){var t;return r(this,void 0,void 0,(function(){var e,r,o,i,s,c,u,h;return n(this,(function(n){switch(n.label){case 0:if(!this.fetch)return[3,9];this.abortController&&this.abortController.abort(),this.abortController=null===(t=this.createAbortController)||void 0===t?void 0:t.call(this),e=this.abortController?this.abortController.signal:void 0,n.label=1;case 1:return n.trys.push([1,7,8,9]),r=this.usePOSTrequests,o=r?this.url:function(t,e){var r=new URL(t.toString());return Object.entries(e).filter(a).forEach((function(t){var e=t[0],n=t[1];"properties"===e&&n?Object.entries(n).filter(a).forEach((function(t){var e=t[0],n=t[1];return r.searchParams.append("properties[".concat(e,"]"),n)})):r.searchParams.append(e,n)})),r}(this.url,this.context),i=r?"POST":"GET",s=r?JSON.stringify({context:this.context}):void 0,[4,this.fetch(o.toString(),{method:i,cache:"no-cache",headers:this.getHeaders(),body:s,signal:e})];case 2:return c=n.sent(),"error"===this.sdkState&&c.status<400&&(this.sdkState="healthy",this.emit(w.RECOVERED)),c.ok&&304!==c.status?(this.etag=c.headers.get("ETag")||"",[4,c.json()]):[3,5];case 3:return u=n.sent(),[4,this.storeToggles(u.toggles)];case 4:return n.sent(),"healthy"!==this.sdkState&&(this.sdkState="healthy"),this.fetchedFromServer||(this.fetchedFromServer=!0,this.readyEventEmitted=!0,this.emit(w.READY)),[3,6];case 5:c.ok||304===c.status||(console.error("Unleash: Fetching feature toggles did not have an ok response"),this.sdkState="error",this.emit(w.ERROR,{type:"HttpError",code:c.status}),this.lastError={type:"HttpError",code:c.status}),n.label=6;case 6:return[3,9];case 7:return(h=n.sent())instanceof DOMException&&"AbortError"===h.name||(console.error("Unleash: unable to fetch feature toggles",h),this.sdkState="error",this.emit(w.ERROR,h),this.lastError=h),[3,9];case 8:return this.abortController=null,[7];case 9:return[2]}}))}))},i}(s);
//# sourceMappingURL=main.esm.js.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@unleash/proxy-client-react/dist/unleash-react.js



const unleash_react_d = react.createContext(null), P = {
  bootstrap: [],
  disableRefresh: !0,
  disableMetrics: !0,
  url: "http://localhost",
  appName: "offline",
  clientKey: "not-used"
}, M = "startTransition", unleash_react_x = react[M] || ((e) => e()), O = ({
  config: e,
  children: t,
  unleashClient: o,
  startClient: c = !0,
  stopClient: l = !0
}) => {
  var F, h, T;
  const s = e || P, r = react.useRef(
    o || new k(s)
  ), [u, n] = react.useState(
    !!(o ? e != null && e.bootstrap && (e == null ? void 0 : e.bootstrapOverride) !== !1 || (F = o.isReady) != null && F.call(o) : s.bootstrap && s.bootstrapOverride !== !1)
  ), [R, v] = (0,react.useState)(((T = (h = r.current).getError) == null ? void 0 : T.call(h)) || null);
  (0,react.useEffect)(() => {
    !s && !o && console.error(
      `You must provide either a config or an unleash client to the flag provider.
        If you are initializing the client in useEffect, you can avoid this warning
        by checking if the client exists before rendering.`
    );
    const a = (E) => {
      unleash_react_x(() => {
        v((U) => U || E);
      });
    }, f = (E) => {
      unleash_react_x(() => {
        v(null);
      });
    };
    let i = null;
    const m = () => {
      i = setTimeout(() => {
        unleash_react_x(() => {
          n(!0);
        });
      }, 0);
    };
    return r.current.on("ready", m), r.current.on("error", a), r.current.on("recovered", f), c && (r.current.stop(), r.current.start()), function() {
      r.current && (r.current.off("error", a), r.current.off("ready", m), r.current.off("recovered", f), l && r.current.stop()), i && clearTimeout(i);
    };
  }, []);
  const S = (0,react.useMemo)(
    () => ({
      on: (a, f, i) => r.current.on(a, f, i),
      off: (a, f) => r.current.off(a, f),
      updateContext: async (a) => await r.current.updateContext(a),
      isEnabled: (a) => r.current.isEnabled(a),
      getVariant: (a) => r.current.getVariant(a),
      client: r.current,
      flagsReady: u,
      flagsError: R,
      setFlagsReady: n,
      setFlagsError: v
    }),
    [u, R]
  );
  return /* @__PURE__ */ react.createElement(unleash_react_d.Provider, { value: S }, t);
}, z = (e) => {
  const { isEnabled: t, client: o } = (0,react.useContext)(unleash_react_d), [c, l] = (0,react.useState)(!!t(e)), s = (0,react.useRef)();
  return s.current = c, (0,react.useEffect)(() => {
    if (!o)
      return;
    const r = () => {
      const n = t(e);
      n !== s.current && (s.current = n, l(!!n));
    }, u = () => {
      const n = t(e);
      s.current = n, l(n);
    };
    return o.on("update", r), o.on("ready", u), () => {
      o.off("update", r), o.off("ready", u);
    };
  }, [o]), c;
}, B = () => {
  const { client: e } = p(unleash_react_d), [t, o] = b(e.getAllToggles());
  return y(() => {
    const c = () => {
      o(e.getAllToggles());
    };
    return e.on("update", c), () => {
      e.off("update", c);
    };
  }, []), t;
}, K = () => {
  const { flagsReady: e, flagsError: t } = p(unleash_react_d);
  return { flagsReady: e, flagsError: t };
}, _ = (e, t) => {
  var c, l, s, r;
  return !(e.name === (t == null ? void 0 : t.name) && e.enabled === (t == null ? void 0 : t.enabled) && e.feature_enabled === (t == null ? void 0 : t.feature_enabled) && ((c = e.payload) == null ? void 0 : c.type) === ((l = t == null ? void 0 : t.payload) == null ? void 0 : l.type) && ((s = e.payload) == null ? void 0 : s.value) === ((r = t == null ? void 0 : t.payload) == null ? void 0 : r.value));
}, L = (e) => {
  const { getVariant: t, client: o } = p(unleash_react_d), [c, l] = b(t(e)), s = H({
    name: c.name,
    enabled: c.enabled
  });
  return s.current = c, y(() => {
    if (!o)
      return;
    const r = () => {
      const n = t(e);
      _(s.current, n) && (l(n), s.current = n);
    }, u = () => {
      const n = t(e);
      s.current.name = n == null ? void 0 : n.name, s.current.enabled = n == null ? void 0 : n.enabled, l(n);
    };
    return o.on("update", r), o.on("ready", u), () => {
      o.off("update", r), o.off("ready", u);
    };
  }, [o]), c || {};
}, Y = () => {
  const { updateContext: e } = p(unleash_react_d);
  return e;
}, j = () => {
  const { client: e } = p(unleash_react_d);
  return e;
};

//# sourceMappingURL=unleash-react.js.map


/***/ }),

/***/ 4190:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oR": function() { return /* binding */ s; }
/* harmony export */ });
/* unused harmony exports Provider, connect, createComponent, createContextComponent, createGate, createReactState, createStoreConsumer, useEvent, useGate, useList, useStoreMap, useUnit */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8116);
/* harmony import */ var use_sync_external_store_shim_with_selector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3233);
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6199);
function e(e,t,r,n){let o=[effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__/* .step.run */ .Nb.run({fn:e=>t(e)})];if(n&&o.unshift(n),r){let t=(0,effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createNode */ .dS)({node:o}),n=e.graphite.id,u=r.additionalLinks,s=u[n]||[];return u[n]=s,s.push(t),()=>{let e=s.indexOf(t);-1!==e&&s.splice(e,1),(0,effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__/* .clearNode */ .PO)(t)}}{let t=(0,effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createNode */ .dS)({node:o,parent:[e],family:{owners:e}});return()=>{(0,effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__/* .clearNode */ .PO)(t)}}}function t(e,t){return t.displayName=e,t}function r(t,r){effector_effector_mjs__WEBPACK_IMPORTED_MODULE_0__.is.store(t)||E('expect useStore argument to be a store');let n=react__WEBPACK_IMPORTED_MODULE_1__.useCallback((n=>e(t,n,r)),[t,r]),o=react__WEBPACK_IMPORTED_MODULE_1__.useCallback((()=>M(t,r)),[t,r]);return N(n,o,o)}function n([t,r],n){let o,u,s,l,a=O;r?(o=r,s=t,l=[]):({fn:o,store:s,keys:l,defaultValue:u,updateFilter:a=O}=t),k.store(s)||E('useStoreMap expects a store'),Array.isArray(l)||E('useStoreMap expects an array as keys'),'function'!=typeof o&&E('useStoreMap expects a function');let i=b.useCallback((t=>e(s,t,n)),[s,n]),c=b.useCallback((()=>M(s,n)),[s,n]),f=b.useRef(),d=b.useRef(),p=b.useRef(l);return R(i,c,c,(e=>{if(f.current!==e||!((e,t)=>{if(!e||!t||e.length!==t.length)return 0;let r=1;for(let n=0;n<e.length;n++)if(e[n]!==t[n]){r=0;break}return r})(p.current,l)){let t=o(e,l);void 0===t&&void 0!==u&&(t=u),f.current=e,p.current=l,void 0!==t&&(d.current=t)}return d.current}),((e,t)=>!a(t,e)))}function o(e){let t=react__WEBPACK_IMPORTED_MODULE_1__.useContext(L);return e&&!t&&E('No scope found, consider adding <Provider> to app root'),t}function u(e,t){return((e,t)=>{if(!t)return e;let r=k.unit(e)||'object'!=typeof e?{event:e}:e;return b.useMemo((()=>{if(k.unit(e))return S(e,{scope:t});let r=Array.isArray(e)?[]:{};for(let n in e)r[n]=S(e[n],{scope:t});return r}),[t,...Object.keys(r),...Object.values(r)])})(e,o(null==t?void 0:t.forceScope))}function s(e,t){return r(e,o(null==t?void 0:t.forceScope))}function l(t,r){return((t,r)=>{let n=k.unit(t),o=n?{unit:t}:t,u=Array.isArray(o),s=b.useRef({stale:1,justSubscribed:0,scope:r}),[l,a,i]=b.useMemo((()=>{s.current.stale=1;let e=Array.isArray(o)?[]:{},t=[],n=[];for(let u in o){let s=o[u];k.unit(s)||E('expect useUnit argument to be a unit'),k.event(s)||k.effect(s)?e[u]=r?S(s,{scope:r}):s:(e[u]=null,t.push(u),n.push(s))}return[e,t,n]}),[s,r,...Object.keys(o),...Object.values(o)]),c=b.useRef({value:l,storeKeys:a}),f=b.useCallback((t=>{let n=s.current;n.justSubscribed=1;let o=()=>{n.stale||(n.stale=1,t())},u=h.compute({priority:'sampler',batch:1}),l=i.map((t=>e(t,o,r,u)));return()=>{l.forEach((e=>e()))}}),[i,r,c,s]),d=b.useCallback((()=>{let e,t=c.current,o=s.current,f=0,d=t.value,p=t.storeKeys,m=r!==o.scope;if((a.length>0||p.length>0)&&(o.stale||o.justSubscribed||m)){f=!o.justSubscribed||m,e=u?[...l]:{...l},p.length!==a.length&&(f=1);for(let t=0;t<a.length;t++){let n=M(i[t],r),o=a[t];f||(f=p.includes(o)?d[o]!==n:1),e[o]=n}}return f&&(t.value=e),t.storeKeys=a,o.stale=0,o.justSubscribed=!f,o.scope=r,n?t.value.unit:t.value}),[f,i,r,c,s]);return N(f,d,d)})(t,o(null==r?void 0:r.forceScope))}function a(e,t){return n([e,t],o(null==e?void 0:e.forceScope))}function i(e,u,s){return((e,o,u)=>{let s,l,a,i=[];'object'==typeof o&&null!==o?(o.keys&&(i=o.keys),({fn:s,getKey:l,placeholder:a}=o)):s=o,k.store(e)||E('expect useList first argument to be a store'),'function'!=typeof s&&E("expect useList's renderItem to be a function"),Array.isArray(i)||E("expect useList's keys to be an array");let c=b.useMemo((()=>{let r=t(`${e.shortName||'Unknown'}.Item`,(t=>{let{index:r,keys:o,keyVal:s,value:l}=t;if(f.current[1])return f.current[0](l,s);let a=n([{store:e,keys:[r,...o],fn:(e,t)=>e[t[0]]}],u);return f.current[0](a,r)}));return b.memo(r)}),[e,u,!!l]),f=b.useRef([s,l]);f.current=[s,l];let d=b.useMemo((()=>i),i);if(l){let t=r(e,u);return 0===t.length&&a?a:t.map((e=>{let t=f.current[1](e);return b.createElement(c,{keyVal:t,key:t,keys:d,value:e})}))}{let t=n([{store:e,keys:[e],fn:e=>e.length}],u);return 0===t&&a?a:Array.from({length:t},((e,t)=>b.createElement(c,{index:t,key:t,keys:d})))}})(e,u,o(null==s?void 0:s.forceScope))}function c(e,r){function n(e){let t=b.useRef(e),n=s(o);K((()=>(l({props:t.current,state:o.getState()}),()=>{a({props:t.current,state:o.getState()})})),[]);let u=r(e,n);return t.current=e,u}let o;k.store(e)?o=e:'object'==typeof e&&null!==e?o=x(e):E('shape should be a store or object with stores');let u='Unknown';o&&o.shortName&&(u=o.shortName);let l=j(),a=j();return n.mounted=l,n.unmounted=a,t(`${u}.View`,n)}function f(e){return c(e,(({children:e},t)=>e(t)))}function d(e,t){let r=t?e:e[0];var n;(e=>{if(!e)throw Error('expect first argument be an object')})(z(n=r)||(e=>'function'==typeof e)(n));let o=r.or,u=r.and;if(u){let r=t?u:u[0];if(z(r)&&'and'in r){let r=d(u,t);e=r[0],o={...o,...r[1]}}else e=u}return[e,o]}function p(e,t={}){let r=b.useRef({value:null,count:0});K((()=>(e.open(r.current.value),()=>e.close(r.current.value))),[e]),((e,t)=>{if(e===t)return 1;if('object'==typeof e&&null!==e&&'object'==typeof t&&null!==t){let r=Object.keys(e),n=Object.keys(t);if(r.length!==n.length)return 0;for(let n=0;n<r.length;n++){let o=r[n];if(e[o]!==t[o])return 0}return 1}return 0})(r.current.value,t)||(r.current.value=t,r.current.count+=1),K((()=>{e.set(r.current.value)}),[r.current.count])}function m(e,t){let r=t&&z(n=t[0])&&(n.and||n.or)?t:[{and:t}];var n;let o,[[u,s],l]=d(r),a={},i={},c=l;var f;return'string'==typeof u?(i={name:u},z(f=s)&&'sid'in f||(a=s||{})):(e=>z(e)&&('domain'in e||'defaultState'in e||'name'in e))(u)&&(i=u,a=u.defaultState||{},o=u.domain),{hook:e,domain:o,defaultState:a,mainConfig:i,maybeConfig:c}}function y(...e){return(({domain:e,defaultState:r,hook:n,mainConfig:o,maybeConfig:u})=>{function s(e){return n(s,e),null}let l=F({or:u,and:o}),a=`${e?`${e.compositeName.fullName}/`:''}${l.name||'gate'}`,i=j({name:`${a}.set`,sid:l.sid?`${l.sid}|set`:void 0}),c=j({name:`${a}.open`,sid:l.sid?`${l.sid}|open`:void 0}),f=j({name:`${a}.close`,sid:l.sid?`${l.sid}|close`:void 0}),d=C(Boolean(0),{name:`${a}.status`,serialize:'ignore'}).on(c,(()=>Boolean(1))).on(f,(()=>Boolean(0))),p=C(r,{name:`${a}.state`,sid:l.sid}).on(i,((e,t)=>t)).on(c,((e,t)=>t)).reset(f);if(e){let{hooks:t}=e;$({target:[t.store,t.store,t.event,t.event,t.event],params:[d,p,c,f,i]})}return s.open=c,s.close=f,s.status=d,s.state=p,s.set=i,t(`Gate:${a}`,s)})(m(p,e))}let E=e=>{throw Error(e)};const{useSyncExternalStore:N}=use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_3__,{useSyncExternalStoreWithSelector:R}=use_sync_external_store_shim_with_selector_js__WEBPACK_IMPORTED_MODULE_2__,M=(e,t)=>t?t.getState(e):e.getState(),O=(e,t)=>e!==t,L=react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);let{Provider:U}=L,K='undefined'!=typeof window?react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect:react__WEBPACK_IMPORTED_MODULE_1__.useEffect,V=e=>console.error(`${e} is deprecated`),B=(e,r,n)=>(V('createContextComponent'),t(`${e.shortName||'Unknown'}.ContextComponent`,(t=>{let o=b.useContext(r),u=s(e);return n(t,u,o)}))),I=e=>r=>{let n=e;return'function'!=typeof e&&(n=r,r=e),t(`Connect(${n.displayName||n.name||'Unknown'})`,(e=>b.createElement(n,{...e,...s(r)})))},P=(e,t)=>(V('createReactState'),I(t)(e)),z=e=>'object'==typeof e&&null!==e,F=(e,t={})=>(z(e)&&(F(e.or,t),(e=>{for(let o in e)n=o,(e=>void 0===e)(r=e[o])||'or'===n||'and'===n||(t[n]=r);var r,n})(e),F(e.and,t)),t);
//# sourceMappingURL=effector-react.mjs.map


/***/ }),

/***/ 8116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": function() { return /* binding */ h; },
/* harmony export */   "MT": function() { return /* binding */ c; },
/* harmony export */   "Nb": function() { return /* binding */ Ee; },
/* harmony export */   "PO": function() { return /* binding */ ct; },
/* harmony export */   "dS": function() { return /* binding */ a; },
/* harmony export */   "is": function() { return /* binding */ ne; },
/* harmony export */   "yM": function() { return /* binding */ d; }
/* harmony export */ });
/* unused harmony exports allSettled, attach, combine, createApi, createDomain, createStoreObject, createWatch, fork, forward, fromObservable, guard, hydrate, launch, merge, restore, sample, scopeBind, serialize, setStoreName, split, version, withFactory, withRegion */
function e(e,t){for(let r in e)t(e[r],r)}function t(e,t){e.forEach(t)}function r(e,t){if(!e)throw Error(t)}function n(e,t){ce={parent:ce,value:e,template:G(e,'template')||pe(),sidRoot:G(e,'sidRoot')||ce&&ce.sidRoot};try{return t()}finally{ce=H(ce)}}function a({node:e=[],from:r,source:n,parent:a=r||n,to:i,target:o,child:l=i||o,scope:s={},meta:f={},family:u={type:'regular'},regional:d}={}){let c=ye(a),p=ye(u.links),m=ye(u.owners),g=[];t(e,(e=>e&&oe(g,e)));let h={id:de(),seq:g,next:ye(l),meta:f,scope:s,family:{type:u.type||"crosslink",links:p,owners:m}};return t(p,(e=>oe(V(e),h))),t(m,(e=>oe(L(e),h))),t(c,(e=>oe(e.next,h))),d&&ce&&he(B(ce),[h]),h}function i(e,r,n){let a=Ze,i=null,o=Ke;if(e.target&&(r=e.params,n=e.defer,a='page'in e?e.page:a,e.stack&&(i=e.stack),o=U(e)||o,e=e.target),o&&Ke&&o!==Ke&&(Ke=null),Array.isArray(e))for(let t=0;t<e.length;t++)He('pure',a,_(e[t]),i,r[t],o);else He('pure',a,_(e),i,r,o);if(n&&!Qe)return;let l,s,f,u,d,c,p={isRoot:Qe,currentPage:Ze,scope:Ke,isWatch:Xe,isPure:Ye};Qe=0;e:for(;u=We();){let{idx:e,stack:r,type:n}=u;f=r.node,Ze=d=r.page,Ke=U(r),d?c=d.reg:Ke&&(c=Ke.reg);let a=!!d,i=!!Ke,o={fail:0,scope:f.scope};l=s=0;for(let t=e;t<f.seq.length&&!l;t++){let u=f.seq[t];if(u.order){let{priority:a,barrierID:i}=u.order,o=i?d?`${d.fullID}_${i}`:i:0;if(t!==e||n!==a){i?Je.has(o)||(Je.add(o),Ue(t,r,a,i)):Ue(t,r,a);continue e}i&&Je.delete(o)}switch(u.type){case'mov':{let e,t=u.data;switch(t.from){case P:e=B(r);break;case"a":case'b':e=r[t.from];break;case"value":e=t.store;break;case"store":if(c&&!c[t.store.id])if(a){let e=rt(d,t.store.id);r.page=d=e,e?c=e.reg:i?(ot(Ke,t.store,0,1,t.softRead),c=Ke.reg):c=void 0}else i&&ot(Ke,t.store,0,1,t.softRead);e=Pe(c&&c[t.store.id]||t.store)}switch(t.to){case P:r.value=e;break;case"a":case'b':r[t.to]=e;break;case"store":nt(d,Ke,f,t.target).current=e}break}case'compute':let e=u.data;if(e.fn){Xe='watch'===G(f,'op'),Ye=e.pure;let t=e.safe?(0,e.fn)(B(r),o.scope,r):lt(o,e.fn,r);e.filter?s=!t:r.value=t,Xe=p.isWatch,Ye=p.isPure}}l=o.fail||s}if(!l){let e=B(r),n=U(r);if(t(f.next,(t=>{He('child',d,t,r,e,n)})),n){G(f,'needFxCounter')&&He('child',d,n.fxCount,r,e,n),G(f,'storeChange')&&He('child',d,n.storeChange,r,e,n),G(f,'warnSerialize')&&He('child',d,n.warnSerializeNode,r,e,n);let a=n.additionalLinks[f.id];a&&t(a,(t=>{He('child',d,t,r,e,n)}))}}}Qe=p.isRoot,Ze=p.currentPage,Ke=U(p)}function o(t,r="combine"){let n=r+'(',a='',i=0;return e(t,(e=>{i<25&&(null!=e&&(n+=a,n+=Q(e)?K(e).fullName:e.toString()),i+=1,a=', ')})),n+')'}function l(e,t){e.shortName=t,Object.assign(K(e),s(t,H(e)))}function s(e,t){let r,n,a=e;if(t){let a=K(t);0===e.length?(r=a.path,n=a.fullName):(r=a.path.concat([e]),n=0===a.fullName.length?e:a.fullName+'/'+e)}else r=0===e.length?[]:[e],n=e;return{shortName:a,fullName:n,path:r}}function f(e,t){let r=t?e:e[0];we(r);let n=r.or,a=r.and;if(a){let r=t?a:a[0];if(be(r)&&'and'in r){let r=f(a,t);e=r[0],n={...n,...r[1]}}else e=a}return[e,n]}function u(e,...t){let r=pe();if(r){let n=r.handlers[e];if(n)return n(r,...t)}}function d(e,t){let r=st({or:t,and:'string'==typeof e?{name:e}:e}),n=(e,...t)=>(le(!G(n,'derived'),'call of derived event','createEvent'),le(!Ye,'unit call from pure function','operators like sample'),Ze?((e,t,r,n)=>{let a=Ze,i=null;if(t)for(i=Ze;i&&i.template!==t;)i=H(i);tt(i);let o=e.create(r,n);return tt(a),o})(n,o,e,t):n.create(e,t)),o=pe(),l=Object.assign(n,{graphite:a({meta:bt("event",n,r),regional:1}),create:e=>(i({target:n,params:e,scope:Ke}),e),watch:e=>ht(n,e),map:e=>vt(n,R,e,[De()]),filter:e=>vt(n,"filter",e.fn?e:e.fn,[De(Ce,1)]),filterMap:e=>vt(n,'filterMap',e,[De(),Oe((e=>!ke(e)),1)]),prepend(e){let t=d('* \u2192 '+n.shortName,{parent:H(n)});return u('eventPrepend',_(t)),mt(t,n,[De()],'prepend',e),yt(n,t),t}});return null!=r&&r.domain&&r.domain.hooks.event(l),l}function c(e,n){let o=st(n),l=Re(e),s=d({named:'updates',derived:1});u('storeBase',l);let f=l.id,p={subscribers:new Map,updates:s,defaultState:e,stateRef:l,getState(){let e,t=l;if(Ze){let t=Ze;for(;t&&!t.reg[f];)t=H(t);t&&(e=t)}return!e&&Ke&&(ot(Ke,l,1),e=Ke),e&&(t=e.reg[f]),Pe(t)},setState:e=>i({target:p,params:e,defer:1,scope:Ke}),reset:(...e)=>(t(e,(e=>p.on(e,(()=>p.defaultState)))),p),on:(e,n)=>(xe(e,'.on','first argument'),r(ve(n),'second argument should be a function'),le(!G(p,'derived'),'.on in derived store','createStore'),t(Array.isArray(e)?e:[e],(e=>{p.off(e),W(p).set(e,pt(kt(e,p,'on',je,n)))})),p),off(e){let t=W(p).get(e);return t&&(t(),W(p).delete(e)),p},map(e,t){let r,n;be(e)&&(r=e,e=e.fn),le(ke(t),'second argument of store.map','updateFilter');let a=p.getState();pe()?n=null:ke(a)||(n=e(a,t));let i=c(n,{name:`${p.shortName} \u2192 *`,derived:1,and:r}),o=kt(p,i,R,Me,e);return _e(T(i),{type:R,fn:e,from:l}),T(i).noInit=1,u('storeMap',l,o),i},watch(e,t){if(!t||!Q(e)){let t=ht(p,e);return u('storeWatch',l,e)||e(p.getState()),t}return r(ve(t),'second argument should be a function'),e.watch((e=>t(p.getState(),e)))}},m=bt("store",p,o),g=p.defaultConfig.updateFilter;p.graphite=a({scope:{state:l,fn:g},node:[Oe(((e,t,r)=>(r.scope&&!r.scope.reg[l.id]&&(r.b=1),e))),Fe(l),Oe(((e,t,{a:r,b:n})=>!ke(e)&&(e!==r||n)),1),g&&De(Me,1),Ie({from:P,target:l})],child:s,meta:m,regional:1});let h=G(p,'serialize'),y=G(p,'derived'),b='ignore'===h,v=!h||b?0:h,k=G(p,'sid');return k&&(b||J(p,'storeChange',1),l.sid=k,v&&(l.meta={...null==l?void 0:l.meta,serialize:v})),k||b||y||J(p,'warnSerialize',1),r(y||!ke(e),"current state can't be undefined, use null instead"),he(p,[s]),null!=o&&o.domain&&o.domain.hooks.store(p),y||(p.reinit=d(),p.reset(p.reinit)),p}function p(...e){let t,n,a;[e,a]=f(e);let i,o,l,s=e[e.length-1];if(ve(s)?(n=e.slice(0,-1),t=s):n=e,1===n.length){let e=n[0];Y(e)||(i=e,o=1)}if(!o&&(i=n,t)){l=1;let e=t;t=t=>e(...t)}return r(be(i),'shape should be an object'),wt(Array.isArray(i),!l,i,a,t)}function m(...e){return le(0,'createStoreObject','combine'),p(...e)}function g(){let e={};return e.req=new Promise(((t,r)=>{e.rs=t,e.rj=r})),e.req.catch((()=>{})),e}function h(e,t){let n=st(ve(e)?{handler:e}:e,t),o=d(ve(e)?{handler:e}:e,t),l=_(o);J(l,'op',o.kind="effect"),o.use=e=>(r(ve(e),'.use argument should be a function'),h.scope.handler=e,o),o.use.getCurrent=()=>h.scope.handler;let s=o.finally=d({named:'finally',derived:1}),f=o.done=s.filterMap({named:'done',fn({status:e,params:t,result:r}){if('done'===e)return{params:t,result:r}}}),u=o.fail=s.filterMap({named:'fail',fn({status:e,params:t,error:r}){if('fail'===e)return{params:t,error:r}}}),p=o.doneData=f.map({named:'doneData',fn:({result:e})=>e}),m=o.failData=u.map({named:'failData',fn:({error:e})=>e}),h=a({scope:{handlerId:G(l,'sid'),handler:o.defaultConfig.handler||(()=>r(0,`no handler used in ${o.getType()}`))},node:[Oe(((e,t,r)=>{let n=t,a=n.handler;if(U(r)){let e=U(r).handlers[n.handlerId];e&&(a=e)}return e.handler=a,e}),0,1),Oe((({params:e,req:t,handler:r,args:n=[e]},a,i)=>{let o=xt(i),l=zt(e,t,1,s,i,o),f=zt(e,t,0,s,i,o),[u,d]=St(r,f,n);u&&(be(d)&&ve(d.then)?d.then(l,f):l(d))}),0,1)],meta:{op:'fx',fx:'runner'}});l.scope.runner=h,oe(l.seq,Oe(((e,{runner:t},r)=>{let n=H(r)?{params:e,req:{rs(e){},rj(e){}}}:e;return i({target:t,params:n,defer:1,scope:U(r)}),n.params}),0,1)),o.create=e=>{let t=g(),r={params:e,req:t};if(Ke){if(!Xe){let e=Ke;t.req.finally((()=>{et(e)})).catch((()=>{}))}i({target:o,params:r,scope:Ke})}else i(o,r);return t.req};let y=o.inFlight=c(0,{serialize:'ignore'}).on(o,(e=>e+1)).on(s,(e=>e-1)).map({fn:e=>e,named:'inFlight'});J(s,'needFxCounter','dec'),J(o,'needFxCounter',1);let b=o.pending=y.map({fn:e=>e>0,named:'pending'});return he(o,[s,f,u,p,m,b,y]),null!=n&&n.domain&&n.domain.hooks.effect(o),o}function y(e){let t;[e,t]=f(e,1);let{source:r,effect:n,mapParams:a}=e,o=h(e,t);J(o,'attached',1);let l,{runner:u}=_(o).scope,d=Oe(((e,t,n)=>{let l,{params:s,req:f,handler:u}=e,d=o.finally,c=xt(n),p=zt(s,f,0,d,n,c),m=n.a,g=ee(u),h=1;if(a?[h,l]=St(a,p,[s,m]):l=r&&g?m:s,h){if(!g)return e.args=[m,l],1;i({target:u,params:{params:l,req:{rs:zt(s,f,1,d,n,c),rj:p}},page:n.page,defer:1})}}),1,1);if(r){let e;Y(r)?(e=r,he(e,[o])):(e=p(r),he(o,[e])),l=[Fe(T(e)),d]}else l=[d];u.seq.splice(1,0,...l),o.use(n);let c=H(n);return c&&(Object.assign(K(o),s(o.shortName,c)),o.defaultConfig.parent=c),yt(n,o,"effect"),o}function b(...t){let[[r,n],a]=f(t),i={};return e(n,((e,t)=>{let n=i[t]=d(t,{parent:H(r),config:a});r.on(n,e),yt(r,n)})),i}function v(r,n){let o=st({or:n,and:'string'==typeof r?{name:r}:r}),l=a({family:{type:"domain"},regional:1,parent:(null==o?void 0:o.domain)||(null==o?void 0:o.parent)}),s={history:{},graphite:l,hooks:{}};l.meta=bt("domain",s,{parent:(null==o?void 0:o.domain)||(null==o?void 0:o.parent),or:o}),e({Event:d,Effect:h,Store:c,Domain:v},((e,r)=>{let n=r.toLowerCase(),a=d({named:`on${r}`});s.hooks[n]=a;let o=new Set;s.history[`${n}s`]=o,a.create=e=>(i(a,e),e),oe(_(a).seq,Oe(((e,t,r)=>(r.scope=null,e)))),a.watch((e=>{he(s,[e]),o.add(e),e.ownerSet||(e.ownerSet=o),H(e)||(e.parent=s)})),he(s,[a]),s[`onCreate${r}`]=e=>(t(o,e),a.watch(e)),s[`create${r}`]=s[n]=(t,r)=>{let n=st({and:r,or:t});return null!=n&&n.domain?e(t,r):a(e(t,{parent:s,or:n}))}}));let f=H(s);return f&&e(s.hooks,((e,t)=>mt(e,f.hooks[t]))),null!=o&&o.domain&&o.domain.hooks.domain(s),s}function k(e){we(e);let t=E in e?e[E]():e;r(t.subscribe,'expect observable to have .subscribe');let n=d(),a=pt(n);return t.subscribe({next:n,error:a,complete:a}),n}function w(e,t){xe(e,'merge','first argument');let r=d({name:o(e,'merge'),derived:1,and:t});return mt(e,r,[],'merge'),r}function S(e,n){let a=0;return t(jt,(t=>{t in e&&(r(null!=e[t],Ct(n,t)),a=1)})),a}function x(...e){let t,r,n,a,[[i,o,l],s]=f(e),u=1;return ke(o)&&be(i)&&S(i,"sample")&&(o=i.clock,l=i.fn,u=!i.greedy,a=i.filter,t=i.target,r=i.name,n=i.sid,i=i.source),$t("sample",o,i,a,t,l,r,s,u,1,0,n)}function z(...e){let[[t,r],n]=f(e);return r||(r=t,t=r.source),S(r,'guard'),$t('guard',r.clock,t,r.filter,r.target,null,r.name,n,!r.greedy,0,1)}function M(t,r,n){if(Y(t))return le(0,'restore($store)'),t;if(Z(t)||ee(t)){let e=H(t),a=c(r,{parent:e,name:t.shortName,and:n});return mt(ee(t)?t.doneData:t,a),e&&e.hooks.store(a),a}let a=Array.isArray(t)?[]:{};return e(t,((e,t)=>a[t]=Y(e)?e:c(e,{name:t}))),a}function j(...t){let n,i,o='split',[[l,s],c]=f(t),p=!s;p&&(n=l.cases,s=l.match,i=l.clock,l=l.source);let m=Y(s),g=!Q(s)&&ve(s),h=!m&&!g&&be(s);n||(n={}),p?e(n,((e,t)=>ze(o,e,`cases.${t}`))):(r(h,'match should be an object'),e(s,((e,t)=>n[t]=d({derived:1,and:c}))),n.__=d({derived:1,and:c}));let y,b=new Set([].concat(l,i||[],Object.values(n))),v=Object.keys(m||g?n:s);if(m||g)m&&b.add(s),y=[m&&Fe(T(s),0,1),qe({safe:m,filter:1,pure:!m,fn(e,t,r){let n=String(m?r.a:s(e));qt(t,ae(v,n)?n:'__',e,r)}})];else if(h){let t=Re({});t.type='shape';let r,n=[];e(s,((e,a)=>{if(Q(e)){r=1,oe(n,a),b.add(e);let i=mt(e,[],[Fe(t),Oe(((e,t,{a:r})=>r[a]=e))]);if(Y(e)){t.current[a]=e.getState();let r=T(e);_e(t,{from:r,field:a,type:'field'}),u('splitMatchStore',r,i)}}})),r&&u('splitBase',t),y=[r&&Fe(t,0,1),De(((e,t,r)=>{for(let a=0;a<v.length;a++){let i=v[a];if(ae(n,i)?r.a[i]:s[i](e))return void qt(t,i,e,r)}qt(t,'__',e,r)}),1)]}else r(0,'expect match to be unit, function or object');let k=a({meta:{op:o},parent:i?[]:l,scope:n,node:y,family:{owners:Array.from(b)},regional:1});if(i&&$t(o,i,l,null,k,null,o,c,0,0,0),!p)return n}function C(e,{scope:t,params:r}){if(!Q(e))return Promise.reject(new Error('first argument should be unit'));if(!ee(e)&&!Z(e)&&!Y(e))return Promise.reject(new Error('first argument accepts only effects, events and stores'));let n=g();n.parentFork=Ke;let{fxCount:a}=t;oe(a.scope.defers,n);let o=[e],l=[];return oe(l,ee(e)?{params:r,req:{rs(e){n.value={status:'done',value:e}},rj(e){n.value={status:'fail',value:e}}}}:r),oe(o,a),oe(l,null),i({target:o,params:l,scope:t}),n.req}function $(e,r){let n=[];(function e(a){ae(n,a)||(oe(n,a),"store"===G(a,'op')&&G(a,'sid')&&r(a,G(a,'sid')),t(a.next,e),t(V(a),e),t(L(a),e))})(e)}function A(e,n){let a=Array.isArray(e)?new Map(e):e;if(a instanceof Map){let e={};return t(a,((t,a)=>{r(Q(a),'Map key should be a unit'),n&&n(a,t),r(a.sid,'unit should have a sid'),r(!(a.sid in e),'duplicate sid found'),e[a.sid]=t})),e}return a}function I(e,n){let i,o=e;te(e)&&(i=e,o=n);let l=(e=>{let r=a({scope:{defers:[],inFlight:0,fxID:0},node:[Oe(((e,t,r)=>{H(r)?'dec'===G(H(r).node,'needFxCounter')?t.inFlight-=1:(t.inFlight+=1,t.fxID+=1):t.fxID+=1})),qe({priority:"sampler",batch:1}),Oe(((e,r)=>{let{defers:n,fxID:a}=r;r.inFlight>0||0===n.length||Promise.resolve().then((()=>{r.fxID===a&&t(n.splice(0,n.length),(e=>{et(e.parentFork),e.rs(e.value)}))}))}),0,1)]}),n=a({node:[Oe(((e,t,r)=>{let n=H(r);if(n){let t=n.node;if(!G(t,'isCombine')||H(n)&&'combine'!==G(H(n).node,'op')){let n=U(r),a=t.scope.state.id,i=G(t,'sid');n.sidIdMap[i]=a,n.sidValuesMap[i]=e;let o=G(t,'serialize');o&&'ignore'!==o&&(n.sidSerializeMap[i]=o.write)}}}))]}),i=a({node:[Oe(((e,t,r)=>{let n=U(r);if(n){let e=H(r);e&&(!G(e.node,'isCombine')||H(e)&&'combine'!==G(H(e).node,'op'))&&(n.warnSerialize=1)}}))]}),o={cloneOf:e,reg:{},sidValuesMap:{},sidIdMap:{},sidSerializeMap:{},getState(e){if('current'in e)return nt(Ze,o,null,e).current;let t=_(e);return nt(Ze,o,t,t.scope.state,1).current},kind:"scope",graphite:a({family:{type:"domain",links:[r,n,i]},meta:{unit:'fork'},scope:{forkInFlightCounter:r}}),additionalLinks:{},handlers:{},fxCount:r,storeChange:n,warnSerializeNode:i,activeEffects:[]};return o})(i);if(o){let e=o.scope;if(e){let r=e.activeEffects;e.activeEffects=[],l.activeEffects=r,t(r,(e=>e.ref=l))}if(o.values){let e=A(o.values,(e=>r(Y(e),'Values map can contain only stores as keys')));Object.assign(l.sidValuesMap,e),l.fromSerialize=!(Array.isArray(o.values)||o.values instanceof Map)}o.handlers&&(l.handlers=A(o.handlers,(e=>r(ee(e),"Handlers map can contain only effects as keys"))))}return l}function q(e,{values:t}){r(be(t),'values property should be an object');let n,a,o,l=A(t),s=Object.getOwnPropertyNames(l),f=[],u=[];re(e)?(n=e,o=1,r(n.cloneOf,'scope should be created from domain'),a=_(n.cloneOf)):te(e)?a=_(e):r(0,'first argument of hydrate should be domain or scope'),$(a,((e,t)=>{if(ae(s,t)){oe(f,e);let r=G(e,'serialize');r&&'ignore'!==r&&(l[t]=r.read(l[t])),oe(u,l[t])}})),i({target:f,params:u,scope:n}),o&&Object.assign(n.sidValuesMap,l)}function N(e,{scope:t,safe:n}={}){r(t||Ke||n,'scopeBind cannot be called outside of forked .watch');let a=t||Ke;return ee(e)?t=>{let r=g();return i({target:e,params:{params:t,req:r},scope:a}),r.req}:t=>(i({target:e,params:t,scope:a}),t)}function O(t,n={}){t.warnSerialize&&console.error('There is a store without sid in this scope, its value is omitted');let a=n.ignore?n.ignore.map((({sid:e})=>e)):[],i={};return e(t.sidValuesMap,((e,r)=>{if(ae(a,r))return;let n=t.sidIdMap[r];i[r]=(t.sidSerializeMap[r]||Ot)(n&&n in t.reg?t.reg[n].current:e)})),'onlyChanges'in n&&!n.onlyChanges&&(r(t.cloneOf,'scope should be created from domain'),$(_(t.cloneOf),((e,r)=>{r in i||ae(a,r)||G(e,'isCombine')||'ignore'===G(e,'serialize')||(i[r]=t.getState(e))}))),i}function F({unit:e,fn:t,scope:r}){let n=[Ee.run({fn:e=>t(e)})];if(r){let t=a({node:n}),i=e.graphite.id,o=r.additionalLinks,l=o[i]||[];return o[i]=l,l.push(t),D((()=>{let e=l.indexOf(t);-1!==e&&l.splice(e,1),ct(t)}))}{let t=a({node:n,parent:[e],family:{owners:e}});return D((()=>{ct(t)}))}}function D(e){let t=()=>e();return t.unsubscribe=()=>e(),t}let E='undefined'!=typeof Symbol&&Symbol.observable||'@@observable',R='map',P='stack',_=e=>e.graphite||e,V=e=>e.family.owners,L=e=>e.family.links,T=e=>e.stateRef,B=e=>e.value,W=e=>e.subscribers,H=e=>e.parent,U=e=>e.scope,G=(e,t)=>_(e).meta[t],J=(e,t,r)=>_(e).meta[t]=r,K=e=>e.compositeName,Q=e=>(ve(e)||be(e))&&'kind'in e;const X=e=>t=>Q(t)&&t.kind===e;let Y=X("store"),Z=X("event"),ee=X("effect"),te=X("domain"),re=X("scope");var ne={__proto__:null,unit:Q,store:Y,event:Z,effect:ee,domain:te,scope:re,attached:e=>ee(e)&&1==G(e,'attached')};let ae=(e,t)=>e.includes(t),ie=(e,t)=>{let r=e.indexOf(t);-1!==r&&e.splice(r,1)},oe=(e,t)=>e.push(t),le=(e,t,r)=>!e&&console.error(`${t} is deprecated${r?`, use ${r} instead`:''}`);const se=()=>{let e=0;return()=>""+ ++e};let fe=se(),ue=se(),de=se(),ce=null,pe=()=>ce&&ce.template,me=e=>(e&&ce&&ce.sidRoot&&(e=`${ce.sidRoot}|${e}`),e),ge=({sid:e,name:t,loc:r,method:i,fn:o})=>n(a({meta:{sidRoot:me(e),name:t,loc:r,method:i}}),o),he=(e,r)=>{let n=_(e);t(r,(e=>{let t=_(e);"domain"!==n.family.type&&(t.family.type="crosslink"),oe(V(t),n),oe(L(n),t)}))},ye=(e=[])=>(Array.isArray(e)?e:[e]).flat().map(_),be=e=>'object'==typeof e&&null!==e,ve=e=>'function'==typeof e,ke=e=>void 0===e,we=e=>r(be(e)||ve(e),'expect first argument be an object');const Se=(e,t,n,a)=>r(!(!be(e)&&!ve(e)||!('family'in e)&&!('graphite'in e)),`${t}: expect ${n} to be a unit (store, event or effect)${a}`);let xe=(e,r,n)=>{Array.isArray(e)?t(e,((e,t)=>Se(e,r,`${t} item of ${n}`,''))):Se(e,r,n,' or array of units')},ze=(e,r,n="target")=>t(ye(r),(t=>le(!G(t,'derived'),`${e}: derived unit in "${n}"`,"createEvent/createStore"))),Me=(e,{fn:t},{a:r})=>t(e,r),je=(e,{fn:t},{a:r})=>t(r,e),Ce=(e,{fn:t})=>t(e);const $e=(e,t,r,n)=>{let a={id:ue(),type:e,data:t};return r&&(a.order={priority:r},n&&(a.order.barrierID=++Ae)),a};let Ae=0,Ie=({from:e="store",store:t,target:r,to:n=(r?"store":P),batch:a,priority:i})=>$e('mov',{from:e,store:t,to:n,target:r},i,a),qe=({fn:e,batch:t,priority:r,safe:n=0,filter:a=0,pure:i=0})=>$e('compute',{fn:e,safe:n,filter:a,pure:i},r,t),Ne=({fn:e})=>qe({fn:e,priority:"effect"}),Oe=(e,t,r)=>qe({fn:e,safe:1,filter:t,priority:r&&"effect"}),Fe=(e,t,r)=>Ie({store:e,to:t?P:"a",priority:r&&"sampler",batch:1}),De=(e=Ce,t)=>qe({fn:e,pure:1,filter:t}),Ee={mov:Ie,compute:qe,filter:({fn:e,pure:t})=>qe({fn:e,filter:1,pure:t}),run:Ne},Re=e=>({id:ue(),current:e}),Pe=({current:e})=>e,_e=(e,t)=>{e.before||(e.before=[]),oe(e.before,t)},Ve=null;const Le=(e,t)=>{if(!e)return t;if(!t)return e;let r;return(e.v.type===t.v.type&&e.v.id>t.v.id||Ge(e.v.type)>Ge(t.v.type))&&(r=e,e=t,t=r),r=Le(e.r,t),e.r=e.l,e.l=r,e},Te=[];let Be=0;for(;Be<6;)oe(Te,{first:null,last:null,size:0}),Be+=1;const We=()=>{for(let e=0;e<6;e++){let t=Te[e];if(t.size>0){if(3===e||4===e){t.size-=1;let e=Ve.v;return Ve=Le(Ve.l,Ve.r),e}1===t.size&&(t.last=null);let r=t.first;return t.first=r.r,t.size-=1,r.v}}},He=(e,t,r,n,a,i)=>Ue(0,{a:null,b:null,node:r,parent:n,value:a,page:t,scope:i},e),Ue=(e,t,r,n=0)=>{let a=Ge(r),i=Te[a],o={v:{idx:e,stack:t,type:r,id:n},l:null,r:null};3===a||4===a?Ve=Le(Ve,o):(0===i.size?i.first=o:i.last.r=o,i.last=o),i.size+=1},Ge=e=>{switch(e){case'child':return 0;case'pure':return 1;case'read':return 2;case"barrier":return 3;case"sampler":return 4;case"effect":return 5;default:return-1}},Je=new Set;let Ke,Qe=1,Xe=0,Ye=0,Ze=null,et=e=>{Ke=e},tt=e=>{Ze=e};const rt=(e,t)=>{if(e){for(;e&&!e.reg[t];)e=H(e);if(e)return e}return null};let nt=(e,t,r,n,a)=>{let i=rt(e,n.id);return i?i.reg[n.id]:t?(ot(t,n,a),t.reg[n.id]):n};const at=e=>e;let ot=(e,r,n,a,i)=>{var o;let l=e.reg,s=r.sid,f=null==r||null===(o=r.meta)||void 0===o?void 0:o.serialize;if(l[r.id])return;let u={id:r.id,current:r.current,meta:r.meta};if(s&&s in e.sidValuesMap&&!(s in e.sidIdMap))u.current=(e.fromSerialize&&'ignore'!==f&&(null==f?void 0:f.read)||at)(e.sidValuesMap[s]);else if(r.before&&!i){let i=0,o=n||!r.noInit||a;t(r.before,(t=>{switch(t.type){case R:{let r=t.from;if(r||t.fn){r&&ot(e,r,n,a);let i=r&&l[r.id].current;o&&(u.current=t.fn?t.fn(i):i)}break}case'field':i||(i=1,u.current=Array.isArray(u.current)?[...u.current]:{...u.current}),ot(e,t.from,n,a),o&&(u.current[t.field]=l[l[t.from.id].id].current)}}))}s&&(e.sidIdMap[s]=r.id),l[r.id]=u};const lt=(e,t,r)=>{try{return t(B(r),e.scope,r)}catch(t){console.error(t),e.fail=1}};let st=(t,r={})=>(be(t)&&(st(t.or,r),e(t,((e,t)=>{ke(e)||'or'===t||'and'===t||(r[t]=e)})),st(t.and,r)),r);const ft=(e,t)=>{ie(e.next,t),ie(V(e),t),ie(L(e),t)},ut=(e,t,r)=>{let n;e.next.length=0,e.seq.length=0,e.scope=null;let a=L(e);for(;n=a.pop();)ft(n,e),(t||r&&'sample'!==G(e,'op')||"crosslink"===n.family.type)&&ut(n,t,'on'!==G(n,'op')&&r);for(a=V(e);n=a.pop();)ft(n,e),r&&"crosslink"===n.family.type&&ut(n,t,'on'!==G(n,'op')&&r)},dt=e=>e.clear();let ct=(e,{deep:t}={})=>{let r=0;if(e.ownerSet&&e.ownerSet.delete(e),Y(e))dt(W(e));else if(te(e)){r=1;let t=e.history;dt(t.events),dt(t.effects),dt(t.stores),dt(t.domains)}ut(_(e),!!t,r)},pt=e=>{let t=()=>ct(e);return t.unsubscribe=t,t},mt=(e,t,r,n,i)=>a({node:r,parent:e,child:t,scope:{fn:i},meta:{op:n},family:{owners:[e,t],links:t},regional:1}),gt=e=>{let t='forward',[{from:r,to:n},i]=f(e,1);return xe(r,t,'"from"'),xe(n,t,'"to"'),ze(t,n,'to'),pt(a({parent:r,child:n,meta:{op:t,config:i},family:{},regional:1}))},ht=(e,t)=>(r(ve(t),'.watch argument should be a function'),pt(a({scope:{fn:t},node:[Ne({fn:Ce})],parent:e,meta:{op:'watch'},family:{owners:e},regional:1}))),yt=(e,t,r="event")=>{H(e)&&H(e).hooks[r](t)},bt=(e,t,r)=>{let n=st(r),a="domain"===e,i=fe(),{sid:o=null,named:l=null,domain:f=null,parent:u=f}=n,d=l||n.name||(a?'':i),c=s(d,u),p={op:t.kind=e,name:t.shortName=d,sid:t.sid=me(o),named:l,unitId:t.id=i,serialize:n.serialize,derived:n.derived,config:n};if(t.parent=u,t.compositeName=c,t.defaultConfig=n,t.thru=e=>(le(0,'thru','js pipe'),e(t)),t.getType=()=>c.fullName,!a){t.subscribe=e=>(we(e),t.watch(ve(e)?e:t=>e.next&&e.next(t))),t[E]=()=>t;let e=pe();e&&(p.nativeTemplate=e)}return p};const vt=(e,t,r,n)=>{let a;be(r)&&(a=r,r=r.fn);let i=d({name:`${e.shortName} \u2192 *`,derived:1,and:a});return mt(e,i,n,t,r),i},kt=(e,t,r,n,a)=>{let i=T(t),o=Ie({store:i,to:"a",priority:'read'});r===R&&(o.data.softRead=1);let l=[o,De(n)];return u('storeOnMap',i,l,Y(e)&&T(e)),mt(e,t,l,r,a)},wt=(t,n,a,i,l)=>{let s=t?e=>[...e]:e=>({...e}),f=t?[]:{},d=s(f),p=Re(d),m=Re(1);p.type=t?'list':'shape',p.noInit=1,u('combineBase',p,m);let g=c(d,{name:o(a),derived:1,and:i}),h=T(g);h.noInit=1,J(g,'isCombine',1);let y=Fe(p);y.order={priority:'barrier'};let b=[Oe(((e,t,r)=>(r.scope&&!r.scope.reg[p.id]&&(r.c=1),e))),y,Ie({store:m,to:'b'}),Oe(((e,{key:t},r)=>{if(r.c||e!==r.a[t])return n&&r.b&&(r.a=s(r.a)),r.a[t]=e,1}),1),Ie({from:"a",target:p}),Ie({from:"value",store:0,target:m}),Ie({from:"value",store:1,target:m,priority:"barrier",batch:1}),Fe(p,1),l&&De()];return e(a,((e,t)=>{if(!Y(e))return r(!Q(e)&&!ke(e),`combine expects a store in a field ${t}`),void(d[t]=f[t]=e);f[t]=e.defaultState,d[t]=e.getState();let n=mt(e,g,b,'combine',l);n.scope.key=t;let a=T(e);_e(p,{type:'field',field:t,from:a}),u('combineField',a,n)})),g.defaultShape=a,_e(h,{type:R,from:p,fn:l}),pe()||(g.defaultState=l?h.current=l(d):f),g};let St=(e,t,r)=>{try{return[1,e(...r)]}catch(e){return t(e),[0,null]}},xt=e=>{let t=U(e),r={ref:t};return t&&oe(t.activeEffects,r),r},zt=(e,t,r,n,a,o)=>l=>{o.ref&&ie(o.ref.activeEffects,o),i({target:[n,Mt],params:[r?{status:'done',params:e,result:l}:{status:'fail',params:e,error:l},{value:l,fn:r?t.rs:t.rj}],defer:1,page:a.page,scope:o.ref})};const Mt=a({node:[Ne({fn:({fn:e,value:t})=>e(t)})],meta:{op:'fx',fx:'sidechain'}}),jt=(/* unused pure expression or super */ null && (['source','clock','target'])),Ct=(e,t)=>e+`: ${t} should be defined`;let $t=(e,t,n,a,i,o,l,s,f,m,g,h)=>{let y=!!i;r(!ke(n)||!ke(t),Ct(e,'either source or clock'));let b=0;ke(n)?b=1:Q(n)||(n=p(n)),ke(t)?t=n:(xe(t,e,'clock'),Array.isArray(t)&&(t=w(t))),b&&(n=t),s||l||(l=n.shortName);let v='none';(g||a)&&(Q(a)?v='unit':(r(ve(a),'`filter` should be function or unit'),v='fn')),i?(xe(i,e,'target'),ze(e,i)):'none'===v&&m&&Y(n)&&Y(t)?i=c(o?o(Pe(T(n)),Pe(T(t))):Pe(T(n)),{name:l,sid:h,or:s}):(i=d({name:l,derived:1,or:s}),u('sampleTarget',_(i)));let k=Re(),S=[];if('unit'===v){let[r,n]=It(a,i,t,k,e);S=[...At(n),...At(r)]}let[x,z]=It(n,i,t,k,e),M=mt(t,i,[u('sampleSourceLoader'),Ie({from:P,target:k}),...At(z),Fe(x,1,f),...S,Fe(k),'fn'===v&&De(((e,t,{a:r})=>a(e,r)),1),o&&De(Me),u('sampleSourceUpward',y)],e,o);return he(n,[M]),Object.assign(M.meta,s,{joint:1}),i};const At=e=>[Fe(e),Oe(((e,t,{a:r})=>r),1)],It=(e,t,r,n,i)=>{let o=Y(e),l=o?T(e):Re(),s=Re(o);return o||a({parent:e,node:[Ie({from:P,target:l}),Ie({from:"value",store:1,target:s})],family:{owners:[e,t,r],links:t},meta:{op:i},regional:1}),u('sampleSource',s,l,n),[l,s]},qt=(e,t,r,n)=>{let a=e[t];a&&i({target:a,params:Array.isArray(a)?a.map((()=>r)):r,defer:1,stack:n})},Nt="22.4.0",Ot=e=>e;
//# sourceMappingURL=effector.mjs.map


/***/ }),

/***/ 9426:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-analytics","description":"Install a Google Analytics tag on your website","website":"https://analytics.google.com/analytics/web/","scripts":[{"url":"https://www.googletagmanager.com/gtag/js","params":["id"],"strategy":"worker","location":"head","action":"append"},{"code":"window.dataLayer=window.dataLayer||[];window.gtag=function gtag(){window.dataLayer.push(arguments);};gtag(\'js\',new Date());gtag(\'config\',\'${args.id}\')","strategy":"worker","location":"head","action":"append"}]}');

/***/ }),

/***/ 7395:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-maps-embed","description":"Embed a Google Maps embed on your webpage","website":"https://developers.google.com/maps/documentation/embed/get-started","html":{"element":"iframe","attributes":{"loading":"lazy","src":{"url":"https://www.google.com/maps/embed/v1/place","slugParam":"mode","params":["key","q","center","zoom","maptype","language","region"]},"referrerpolicy":"no-referrer-when-downgrade","frameborder":"0","style":"border:0","allowfullscreen":true,"width":null,"height":null}}}');

/***/ }),

/***/ 8420:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"youtube-embed","description":"Embed a YouTube embed on your webpage.","website":"https://github.com/paulirish/lite-youtube-embed","html":{"element":"lite-youtube","attributes":{"videoid":null,"playlabel":null}},"stylesheets":["https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.css"],"scripts":[{"url":"https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.js","strategy":"idle","location":"head","action":"append"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(1246), __webpack_exec__(6840), __webpack_exec__(880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);